/* "use strict"; */
angular.module('ngModules', [
  'ngCookies',
  'ngSanitize',
  'ngMessages',
  'ngResource',
  'ngAnimate',
]);
angular.module('ui.bootstap.fam', ['ui.bootstrap', 'ui.bootstrap.position']);
angular.module('minovate', [
  'ngTouch',
  'picardy.fontawesome',
  'angular-loading-bar',
  'angular-momentjs',
  'FBAngular',
  'angularBootstrapNavTree',
  'oc.lazyLoad',
  'ui.select',
  'ui.tree',
  'ui.tree-filter',
  'ui.highlight',
  /* "textAngular", */
  'colorpicker.module',
  'angularFileUpload',
  'ngImgCrop',
  /*   "datatables",
  "datatables.bootstrap",
  "datatables.colreorder",
  "datatables.colvis",
  "datatables.tabletools",
  "datatables.scroller",
  "datatables.columnfilter", */
  'ui.grid',
  'ui.grid.resizeColumns',
  'ui.grid.edit',
  'ui.grid.moveColumns',
  /* "ngTable", */
  /* "smart-table", */
  'angular-flot',
  /* "angular-rickshaw", */
  'easypiechart',
  /*   "uiGmapgoogle-maps", */
  'ui.calendar',
  'ngTagsInput',
  'ngMaterial',
  'localytics.directives',
  'leaflet-directive',
  /*   "wu.masonry", */
  'ipsum',
  'angular-intro',
  'dragularModule',
  'ngDraggable',

  'formly',
  'formlyBootstrap',
  'chart.js',
  'treeGrid',
  //"ui.bootstrap.contextMenu"
]);
angular.module('utils', [
  'ui.router',
  'ui.router.state.events',
  'toastr',
  'pascalprecht.translate',
  'ui.utils',
]);

var webapp = angular.module('salevis4-web', [
  'ngModules',
  'ui.bootstap.fam',
  'minovate',
  'utils',
  'AuthServices',
  'as.sortable',
  'fa.directive.borderLayout',
]);

webapp
  .run([
    '$rootScope',
    '$state',
    '$stateParams',
    '$window',
    '$translate',
    '$http',
    '$transitions',
    'Auth',
    '$filter',
    '$window',
    'GLOBAL_CONSTANT',
    'postApi',
    function (
      $rootScope,
      $state,
      $stateParams,
      $window,
      $translate,
      $http,
      $transitions,
      Auth,
      $filter,
      $window,
      CONSTANT,
      postApi
    ) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.safeApply = safeApply;

      if (!$window.sessionStorage.getItem('layoutBoard')) {
        $window.sessionStorage.setItem('layoutBoard', 'N'); // Layout 기본을 N에서 H로 변경
      }

      if (!$window.sessionStorage.getItem('layoutBoardSize')) {
        $window.sessionStorage.setItem('layoutBoardSize', '40% + 2px');
      }

      $rootScope.gVariable = {
        totalItemChatComm: 0,
        totalItemTaskComm: 0,
        totalItemNotiComm: 0,
        totalItemComm: 0,
        alertMessage: '',
        UserId: $window.sessionStorage.getItem('loginUserIdx'),
        UserName: $window.sessionStorage.getItem('loginUserName'),
        TenantId: $window.sessionStorage.getItem('loginTenantId'),
        DeptId: $window.sessionStorage.getItem('loginUserDeptId'),
        DeptNm: $window.sessionStorage.getItem('loginUserDeptNm'),
        SysAdminYN: $window.sessionStorage.getItem('loginSysAdminYN'),
        TenantName: $window.sessionStorage.getItem('loginTenantName'),
        TenantDir: $window.sessionStorage.getItem('loginTenantDir'),
        Email: $window.sessionStorage.getItem('loginEmail'),
        Mobile: $window.sessionStorage.getItem('loginMobile'),
        TelNo: $window.sessionStorage.getItem('loginTelNo'),
        userType: $window.sessionStorage.getItem('loginUserType'),
        userKey:
          $window.sessionStorage.getItem('userkey') +
          '-' +
          $window.sessionStorage.getItem('loginTenantId'),
        autoUpdate: false,
        selectedShop: null,
        srchTenantId: $window.sessionStorage.getItem('srchTenantId'),
        srchTenantName: $window.sessionStorage.getItem('srchTenantName'),
        srchBranchId: $window.sessionStorage.getItem('srchBranchId'),
        srchBranchNm: $window.sessionStorage.getItem('srchBranchNm'),
        layoutBoard: $window.sessionStorage.getItem('layoutBoard'),
        layoutBoardSize: $window.sessionStorage.getItem('layoutBoardSize'),
        dataGroupId: $window.sessionStorage.getItem('dataGroupId'),
        dataGroupNm: $window.sessionStorage.getItem('dataGroupNm'),
        dataActionId: $window.sessionStorage.getItem('dataActionId'),
        dataActionNm: $window.sessionStorage.getItem('dataActionNm'),
        noHeader: $window.sessionStorage.getItem('noHeader'),
        mainPage: $window.sessionStorage.getItem('mainPage'),
        listKeyId: null,
      };

      $rootScope.getSelectShopDescription = function () {
        if ($rootScope.gVariable.selectedShop) {
          return (
            $rootScope.gVariable.selectedShop.DatagroupNm +
            ':' +
            $filter('utcToLocal')(
              $rootScope.gVariable.selectedShop.BeginDate,
              'yyyy-MM-dd h:mm a'
            ) +
            '~' +
            $filter('utcToLocal')(
              $rootScope.gVariable.selectedShop.EndDate,
              'yyyy-MM-dd h:mm a'
            )
          );
        }

        return '';
      };

      $rootScope.dataloader = false;

      $rootScope.$on(
        '$viewContentLoaded',
        function (event, viewName, viewContent) {
          angular.element('html, body, #content').animate(
            {
              scrollTop: 0,
            },
            200
          );

          setTimeout(function () {
            angular.element('#wrap').css('visibility', 'visible');

            if (!angular.element('.dropdown').hasClass('open')) {
              angular.element('.dropdown').find('>ul').slideUp();
            }
          }, 200);
        }
      );

      $transitions.onSuccess({}, function (event, toState) {
        $http.defaults.headers.common['Content-Type'] =
          'application/json; charset=utf-8';
        $http.defaults.headers.common['Accept'] = 'application/json, text/html';
      });

      $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        // 메뉴별 방문 카운트
        setTimeout(function() {
          // 이전 URL을 불러오는 경우가 발생하여 지연호출
          var hashPath = window.location.hash.split('#/app/')[1];
          var params = hashPath.split('/').filter(Boolean);

          if(CONSTANT.MENU[params[0]] && CONSTANT.MENU[params[0]][params[1]]) {
            var data = {
              mapcode: 'VisitCountLog.setVisitMenu',
              code1: CONSTANT.MENU[params[0]].CODE1,
              code2: CONSTANT.MENU[params[0]][params[1]].CODE2,
              name1: CONSTANT.MENU[params[0]].NAME,
              name2: CONSTANT.MENU[params[0]][params[1]].NAME,
              url1: params[0],
              url2: params[1],
              path: hashPath,
            }

            if(data.url2 == 'h0101-list') {
              data.code2 = CONSTANT.MENU[params[0]][params[1]][params[2]].CODE2;
              data.name2 = CONSTANT.MENU[params[0]][params[1]][params[2]].NAME;
            }
            postApi.update(data, function(res) {}, function(error) {});
          }
        }, 50);
      });

      $rootScope.$on('$locationChangeStart', function (event, next) {
        //console.log('$locationChangeStart next=', next);
      });

      $rootScope.$on('$stateChangeStart', function (event, next, current) {
        //console.log('$stateChangeStart next=', next);
        // 모바일 중간보고를 위한 임시 처리
        // 모바일 경우 세션이 없을 경우에도 페이지를 열어야하기 때문에
        // 방법을 모색해야함
        /* if(!checkMobile()) {
          var URL = location.href.toString();
          if(URL.indexOf("#/m/") == -1 && URL.indexOf("#/apps/") == -1) {
            if (!Auth.checkPermissionForView(next)){
              event.preventDefault();
              //alert('cannot access : ' + next.name);
              alert('접근 권한이 없습니다');
              if(!$window.sessionStorage['loginUserId']) {
                $state.go("login", {} , {reload: "login"});
              } else {
                $window.history.back();
              }
            }
          }
        } */
      });

      $rootScope.$on('broadcastSetChangeTenantID', function (event, data) {
        console.log('broadcastSetChangeTenantID');
        $state.go('app.dashboard', {}, { reload: true });
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.$on('broadcastSetChangeBranchID', function (event, data) {
        console.log('broadcastSetChangeBranchID');
        $state.go('app.dashboard', {}, { reload: true });
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.changeLanguage = function (langKey) {
        $translate.use(langKey);
        $rootScope.currentLanguage = langKey;
        $window.sessionStorage.setItem('currentLanguage', langKey);
      };
      $rootScope.currentLanguage =
        $translate.proposedLanguage() ||
        $translate.use() ||
        $window.sessionStorage.getItem('currentLanguage');

      if (
        $rootScope.currentLanguage == null ||
        $rootScope.currentLanguage == ''
      ) {
        $rootScope.changeLanguage('ko');
      }

      $rootScope.changeLayout = function (layout) {
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;
        $window.sessionStorage.setItem('layoutBoardSize', '40% + 2px');
        $rootScope.gVariable.layoutBoardSize = '40% + 2px';
      };

      $rootScope.setGVariable = function (key, value) {
        $window.sessionStorage.setItem(key, value);
        $rootScope.gVariable[key] = value;
      };

      function safeApply(fn) {
        var phase = this.$root.$$phase;
        if (phase !== '$digest' && phase !== '$apply') {
          this.$apply(fn);
          return;
        }
        if (fn && typeof fn === 'function') fn();
      }

      $rootScope.getImageUrl = function (fileName, tenantId, filePath) {
        if (!fileName) return '';

        return (
          API_HTTP_PROTOCOL +
          '//' +
          API_SERVER_DOMAIN +
          ':' +
          API_SERVER_PORT +
          '/openapi/attach/' +
          tenantId +
          '/' +
          filePath +
          '/' +
          fileName +
          '/image.do'
        );
      };

      // 엑셀 설정
      // 다중 시트 기능 추가 2020-01-20 hansol
      $rootScope.excelDown = function (exportData, fileName, sheetNames) {
        function datenum(v, date1904) {
          if (date1904) v += 1462;
          var epoch = Date.parse(v);
          var gmt = 0.375;

          return (
            (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000) +
            gmt
          );
        }

        function getSheet(data, opts) {
          var ws = {};
          var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
          for (var R = 0; R != data.length; ++R) {
            for (var C = 0; C != data[R].length; ++C) {
              if (range.s.r > R) range.s.r = R;
              if (range.s.c > C) range.s.c = C;
              if (range.e.r < R) range.e.r = R;
              if (range.e.c < C) range.e.c = C;
              var cell = { v: data[R][C] };
              if (cell.v == null) continue;
              var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

              if (typeof cell.v === 'number') cell.t = 'n';
              else if (typeof cell.v === 'boolean') cell.t = 'b';
              else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
              } else cell.t = 's';

              ws[cell_ref] = cell;
            }
          }
          if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
          return ws;
        }

        function Workbook() {
          if (!(this instanceof Workbook)) return new Workbook();
          this.SheetNames = [];
          this.Sheets = [];
        }

        var wb = new Workbook();
        var ws;

        /* add worksheet to workbook */

        // 시트가 여러개인 경우
        if (
          exportData.length > 1 &&
          sheetNames != null &&
          sheetNames.length > 1
        ) {
          wb.SheetNames = sheetNames;
          exportData.forEach(function (d, i) {
            ws = getSheet(d);
            wb.Sheets[sheetNames[i]] = ws;
          });
        }
        // 시트가 하나인 경우
        else {
          wb.SheetNames.push(fileName);
          ws = getSheet(exportData);
          wb.Sheets[fileName] = ws;
        }

        var wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'binary',
        });

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }

        saveAs(
          new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
          fileName + '.xlsx'
        );
      };
    },
  ])

  .config([
    'uiSelectConfig',
    function (uiSelectConfig) {
      uiSelectConfig.theme = 'bootstrap';
    },
  ])

  .config([
    '$mdThemingProvider',
    function ($mdThemingProvider) {
      var agent = navigator.userAgent.toLowerCase();
      if (
        (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) ||
        agent.indexOf('msie') != -1
      ) {
        $mdThemingProvider.alwaysWatchTheme(false); // ie일 경우
        $mdThemingProvider.disableTheming(true);
      }
    },
  ])

  .config(function inputDirectiveConfig($provide) {
    //키 입력 이벤트는 compostionstart->compostionupdate->compositonend로 진행된다.
    $provide.decorator('inputDirective', function ($delegate, $log) {
      var directive = $delegate[0];
      angular.extend(directive.link, {
        post: function (scope, element, attr, ctrls) {
          element.on('compositionupdate', function (event) {
            //                  $log.debug('composition update 이벤트 발생, 강제 종료');
            element.triggerHandler('compositionend');
          });
        },
      });
      return $delegate;
    });
  })

  //angular-language
  .config([
    '$translateProvider',
    function ($translateProvider) {
      $translateProvider.useStaticFilesLoader({
        prefix: 'languages/',
        suffix: '.data',
      });
      $translateProvider.useLocalStorage();
      $translateProvider.preferredLanguage('ko');
      $translateProvider.useSanitizeValueStrategy(null);
    },
  ]);

webapp.directive('krInput', [
  '$parse',
  function ($parse) {
    return {
      priority: 2,
      restrict: 'A',
      compile: function (element) {
        element.on('compositionstart', function (e) {
          e.stopImmediatePropagation();
        });
      },
    };
  },
]);

/**
 * 숫자와 하이픈(-)만 입력 가능하도록 처리 (e.g. 전화번호)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자와 하이픈 값만 추출하여 반환
 */
webapp.directive('numbersHyphen', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9_-]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    },
  };
});

/**
 * 숫자만 입력 가능하도록 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값만 추출하여 반환
 */
webapp.directive('numbersOnly', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    },
  };
});

/**
 * 숫자 입력시 3자리 마다 콤마 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 콤마처리 하여 반환
 */
webapp
  .directive('comma', function ($filter) {
    'use strict';
    return {
      scope: {
        ngModel: '=',
        ngBind: '=',
      },
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        function checkValidate(P) {
          var splitSize = P.split('.').length;
          if (splitSize > 2) return false;

          var diff = P.replaceAll('.', '').replaceAll(',', '');
          var transformedInput = P.replace(/[^0-9]/g, '');

          if (transformedInput !== diff) return false;
          else return true;
        }

        function nf(T) {
          T = T.replace(/[^0-9]/g, '').toString();
          //T = Number(T)
          return T.toString();
        }

        function setComma(T) {
          return T.replace(/[^\d]+/g, '')
            .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
            .toString();
        }

        ctrl.$formatters.unshift(function (viewValue) {
          if (viewValue) {
            var checkMinus = false;
            if (viewValue.toString().charAt(0) == '-') checkMinus = true;

            var result, parts;
            parts = viewValue.split('.');
            result = nf(parts[0]);
            result = setComma(result);
            if (parts.length > 1) {
              result += '.' + nf(parts[1]).substring(0, 2);
              //result +=  "." + parts[1].substring(0,2);
            }

            if (checkMinus) result = '-' + result;

            var b = result;
            elem.val(b);
            return result;
          }
        });

        ctrl.$parsers.unshift(function (viewValue) {
          var temp,
            result = '',
            parts;
          parts = viewValue.split('.');
          temp = nf(parts[0]);
          temp = setComma(temp);
          if (parts.length > 1) temp += '.' + nf(parts[1]).substring(0, 2);
          for (var i = 0; i < temp.length; i++) {
            var atChar = temp.charAt(i);
            if (atChar == ',' || atChar == '.' || !isNaN(atChar)) {
              result += '' + atChar;
            }
          }

          var b = result;
          elem.val(b);
          return result.replaceAll(',', '');
        });
      },
    };
  })
  .directive('comma3', function ($filter) {
    'use strict';
    return {
      scope: {
        ngModel: '=',
        ngBind: '=',
      },
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        function checkValidate(P) {
          var splitSize = P.split('.').length;
          if (splitSize > 2) return false;

          var diff = P.replaceAll('.', '').replaceAll(',', '');
          var transformedInput = P.replace(/[^0-9]/g, '');

          if (transformedInput !== diff) return false;
          else return true;
        }

        function nf(T) {
          T = T.replace(/[^0-9]/g, '').toString();
          //T = Number(T)
          return T.toString();
        }

        function setComma(T) {
          return T.replace(/[^\d]+/g, '')
            .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
            .toString();
        }

        ctrl.$formatters.unshift(function (viewValue) {
          if (viewValue) {
            var result, parts;
            parts = viewValue.split('.');
            result = nf(parts[0]);
            result = setComma(result);
            if (parts.length > 1) {
              result += '.' + nf(parts[1]).substring(0, 3);
              //result +=  "." + parts[1].substring(0,2);
            }

            var b = result;
            elem.val(b);
            return result;
          }
        });

        ctrl.$parsers.unshift(function (viewValue) {
          var temp,
            result = '',
            parts;
          parts = viewValue.split('.');
          temp = nf(parts[0]);
          temp = setComma(temp);
          if (parts.length > 1) temp += '.' + nf(parts[1]).substring(0, 2);
          for (var i = 0; i < temp.length; i++) {
            var atChar = temp.charAt(i);
            if (atChar == ',' || atChar == '.' || !isNaN(atChar)) {
              result += '' + atChar;
            }
          }

          var b = result;
          elem.val(b);
          return result.replaceAll(',', '');
        });
      },
    };
  })
  .directive('commaBind', function () {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        ngBind: '=',
      },
      link: function (scope, elem) {
        function checkValidate(P) {
          var splitSize = P.split('.').length;
          if (splitSize > 2) return false;

          var diff = P.replaceAll('.', '').replaceAll(',', '');
          var transformedInput = P.replace(/[^0-9]/g, '');

          if (transformedInput !== diff) return false;
          else return true;
        }

        function nf(T) {
          return T.replace(/[^0-9]/g, '').toString();
        }

        function setComma(T) {
          return T.replace(/[^\d]+/g, '')
            .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
            .toString();
        }

        scope.$watch('ngBind', function (newVal) {
          if (newVal !== undefined && newVal !== null) {
            var checkMinus = false;
            if (newVal.toString().charAt(0) == '-') checkMinus = true;
            var parts;
            parts = newVal.toString().split('.');
            var temp = parts[0]
              .toString()
              .replace(/[^\d]+/g, '')
              .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
            if (parts.length > 1) temp += '.' + nf(parts[1]).substring(0, 2);
            if (checkMinus) temp = '-' + temp;
            if ($(elem).is('input')) angular.element(elem).val(temp);
            else angular.element(elem).html(temp);
          }
        });
      },
    };
  });

/**
 * 자동 하이픈 처리 (e.g. 휴대번호 / 전화번호 - 02 예외처리)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 하이픈처리 하여 반환
 */
webapp
  .directive('autoHyphenTel', function ($filter) {
    'use strict';
    return {
      scope: {
        ngModel: '=',
        ngBind: '=',
      },
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        function checkValidate(P) {
          var splitSize = P.length;
          if (splitSize > 14) return false;

          var diff = P.replaceAll('-', '');
          var transformedInput = P.replace(/[^0-9]/g, '');

          if (transformedInput !== diff) return false;
          else return true;
        }

        function nf(str) {
          str = str.replace(/[^0-9]/g, '').toString();
          return str.toString();
        }

        ctrl.$formatters.unshift(function (viewValue) {
          if (viewValue) {
            var result;
            result = nf(viewValue);
            result = autoHypenTel(result);

            var b = result;
            elem.val(b);

            $(elem).attr('maxlength', 20);

            return result;
          }
        });

        ctrl.$parsers.unshift(function (viewValue) {
          var temp,
            result = '';
          temp = nf(viewValue);
          temp = autoHypenTel(temp);
          for (var i = 0; i < temp.length; i++) {
            var atChar = temp.charAt(i);
            if (atChar == '-' || !isNaN(atChar)) {
              result += '' + atChar;
            }
          }

          var b = result;
          elem.val(b);
          return result.replaceAll('-', '');
        });
      },
    };
  })

  .directive('autoHyphenTelBind', function () {
    'use strict';
    return {
      restrict: 'A',
      scope: {
        ngBind: '=',
      },
      link: function (scope, elem) {
        function nf(T) {
          return T.replace(/[^0-9]/g, '').toString();
        }

        scope.$watch('ngBind', function (newVal) {
          if (newVal !== undefined && newVal !== null) {
            var parts;
            parts = autoHypenTel(newVal);
            var temp = parts;
            if ($(elem).is('input')) angular.element(elem).val(temp);
            else angular.element(elem).html(temp);
          }
        });
      },
    };
  })

  .filter('toHyphenContact', Filter);

function Filter($filter) {
  return function (contact) {
    if (typeof contact == 'string' && contact != '') {
      contact = autoHypenTel(contact);
    }
    return contact;
  };
}

function autoHypenTel(str) {
  str = str.replace(/[^0-9]/g, '');
  var tmp = '';

  if (str.substring(0, 1) == '1') {
    if (str.length < 5) {
      return str;
    } else {
      tmp += str.substr(0, 4);
      tmp += '-';
      tmp += str.substr(4, 4);
      return tmp;
    }
  } else if (str.substring(0, 2) == '02') {
    if (str.length < 3) {
      return str;
    } else if (str.length < 6) {
      tmp += str.substr(0, 2);
      tmp += '-';
      tmp += str.substr(2);
      return tmp;
    } else if (str.length < 10) {
      tmp += str.substr(0, 2);
      tmp += '-';
      tmp += str.substr(2, 3);
      tmp += '-';
      tmp += str.substr(5);
      return tmp;
    } else {
      tmp += str.substr(0, 2);
      tmp += '-';
      tmp += str.substr(2, 4);
      tmp += '-';
      tmp += str.substr(6, 4);
      return tmp;
    }
  } else if (str.substring(0, 4) == '0505') {
    if (str.length < 5) {
      return str;
    } else if (str.length < 9) {
      tmp += str.substr(0, 4);
      tmp += '-';
      tmp += str.substr(4, 4);
      return tmp;
    } else {
      tmp += str.substr(0, 4);
      tmp += '-';
      tmp += str.substr(4, 4);
      tmp += '-';
      tmp += str.substr(8);
      return tmp;
    }
  } else {
    if (str.length < 4) {
      return str;
    } else if (str.length < 7) {
      tmp += str.substr(0, 3);
      tmp += '-';
      tmp += str.substr(3);
      return tmp;
    } else if (str.length < 11) {
      tmp += str.substr(0, 3);
      tmp += '-';
      tmp += str.substr(3, 3);
      tmp += '-';
      tmp += str.substr(6, 4);
      return tmp;
    } else if (str.length < 12) {
      tmp += str.substr(0, 3);
      tmp += '-';
      tmp += str.substr(3, 4);
      tmp += '-';
      tmp += str.substr(7);
      return tmp;
    } else {
      return str;
    }
  }
}

webapp.run(function (
  $rootScope,
  $window,
  $resource,
  StaticVariable,
  GLOBAL_CONSTANT,
  $mdToast,
  $filter
) {
  $rootScope.windowOpen = function (url, name, w, h) {
    //TODO : your custom code here.
    if (angular.isUndefined(w)) w = 1000;
    if (angular.isUndefined(h)) h = 800;

    var dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop =
      window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    if (left < 0) left = 0;
    if (top < 0) top = 0;

    // console.log('$window.open(', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ')');
    $window.open(
      url,
      name,
      'scrollbars=yes, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left
    );
  };

  //yyyy-mm-dd > new Date 형태로 변환
  $rootScope.getDateFormat = function (dateStr) {
    var dateArr;

    if (typeof dateStr == 'undefined') {
      return null;
    } else {
      dateArr = dateStr.split('-');
    }

    if (dateArr.length == 3) {
      return new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2]);
    } else {
      return null;
    }
  };

  $rootScope.getDate = function (date) {
    if (!date) return null;

    return new Date(date);
  };

  $rootScope.setUserSession = function (data) {
    var today = new Date();
    $window.sessionStorage['isLoggedIn'] = 'Y';
    $window.sessionStorage['loginUserIdx'] = data.userId;
    $window.sessionStorage['loginUserId'] = data.loginId;
    $window.sessionStorage['loginUserName'] = data.userName;
    $window.sessionStorage['loginSysAdminYN'] = data.sysAdminYN;
    $window.sessionStorage['loginUserType'] = data.userType;
    $window.sessionStorage['loginArmyZone1YN'] = data.armyZone1YN;
    $window.sessionStorage['loginArmyZone2YN'] = data.armyZone2YN;
    $window.sessionStorage['loginArmyZone3YN'] = data.armyZone3YN;
    $window.sessionStorage['loginArmyZone4YN'] = data.armyZone4YN;
    $window.sessionStorage['loginArmyZone5YN'] = data.armyZone5YN;
    $window.sessionStorage['loginArmyInfoDep1YN'] = data.armyInfoDep1YN;
    $window.sessionStorage['loginArmyInfoDep2YN'] = data.armyInfoDep2YN;
    $window.sessionStorage['loginArmyInfoDep3YN'] = data.armyInfoDep3YN;
    $window.sessionStorage['loginTenantId'] =
      data.TenantId == null ? 0 : data.TenantId;
    $window.sessionStorage['loginTenantName'] = data.TenantName;
    $window.sessionStorage['loginBranchId'] = data.TenantCode;
    $window.sessionStorage['loginBranchName'] = data.TenantCodeNm;
    $window.sessionStorage['loginTenantDir'] = data.TenantDir;
    $window.sessionStorage['loginUserEmail'] = data.email;
    $window.sessionStorage['loginUserMobile'] = data.mobile;
    $window.sessionStorage['loginUserSessionMinute'] =
      data.SessionMinute == null ? 3600 : data.SessionMinute;
    $window.sessionStorage['userkey'] = data.userkey;
    $window.sessionStorage['loginGroupUId'] = data.groupId;

    $rootScope.gVariable.UserId = $window.sessionStorage['loginUserIdx'];
    $rootScope.gVariable.TenantId = $window.sessionStorage['loginTenantId'];
    $rootScope.gVariable.TenantName = $window.sessionStorage['loginTenantName'];
    $rootScope.gVariable.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];
    $rootScope.gVariable.TenantDir = $window.sessionStorage['loginTenantDir'];
    $rootScope.gVariable.userType = $window.sessionStorage['loginUserType'];
    $rootScope.gVariable.sessioncountdown =
      $window.sessionStorage['loginUserSessionMinute'];
    $rootScope.gVariable.userkey = $window.sessionStorage['userkey'];

    if (data.userkey) {
      $window.sessionStorage['userkey'] = data.userkey;
      $rootScope.gVariable.userKey =
        $window.sessionStorage['userkey'] +
        '-' +
        $window.sessionStorage['loginTenantId'];
    }
    //console.log($window.sessionStorage);
  };

  $rootScope.setDefaultSelectedShop = function () {
    var srch = { viewSize: 1, page: 1, UseYN: 'Y' };

    var prms = $resource(
      StaticVariable.getUrl('/select/MaDatagroup.getDatagroupList/action.json'),
      { userkey: $rootScope.gVariable.userKey },
      StaticVariable.getRequestActions.defaultAction()
    ).post(srch).$promise;

    prms.then(
      function (data) {
        if (data.responseVO.header.status == GLOBAL_CONSTANT.HttpStatus.OK) {
          // select한 datatable 바인딩
          $rootScope.gVariable.selectedShop = data.responseVO.body.docs[0];
        }
      },
      function (error) {
        //console.error('fail', status, data);
        console.log("error");
        // console.error('Error> setDefaultSelectedShop()');
        // console.table(error);
      }
    );
  };

  $rootScope.showSimpleToast = function (msg, p1, p2) {
    var position = '';
    var delay = 1200;
    if (p1 == undefined) {
      var classTx = 'header-toast';
      $mdToast.show(
        $mdToast.simple({
          template:
            '<md-toast class="md-toast ' +
            classTx +
            '">' +
            '<div class="md-toast-content">' +
            msg +
            '</div></md-toast>',
          position: 'top left',
          hideDelay: delay,
        })
      );
    } else if (p1.indexOf('#') > -1) {
      if (p2 != undefined) p2 = position;
      else p2 = 'top left';
      $mdToast.show(
        $mdToast
          .simple()
          .parent(angular.element(document.querySelector(p1)))
          .content(msg)
          .position(p2)
          .hideDelay(delay)
      );
    } else {
      var classTx = '';
      if (p1 == undefined) {
        classTx = 'header';
      } else if (p1.toLowerCase() == 'header' || p1.toLowerCase() == 'footer') {
        classTx = p1 + '-toast';
      } else {
        position = p1;
      }

      if (classTx == '') {
        $mdToast.show(
          $mdToast.simple().content(msg).position(position).hideDelay(delay)
        );
      } else {
        var position = '';
        if (p1.toLowerCase() == 'footer') position = 'bottom left';
        else position = 'top left';
        $mdToast.show(
          $mdToast.simple({
            template:
              '<md-toast class="md-toast ' +
              classTx +
              '">' +
              '<div class="md-toast-content">' +
              msg +
              '</div></md-toast>',
            position: position,
            hideDelay: delay,
          })
        );
      }
    }
  };

  $rootScope.listColumFilter = function (liCol) {
    if (liCol.ListColumnShowLevel == 'showlevel0') {
      return false;
    }

    return true;
  };

  $rootScope.listColumnCount = function (listColumns) {
    var l = 0;
    angular.forEach(listColumns, function (item) {
      if (item.ListColumnShowLevel != 'showlevel0') {
        l++;
      }
    });

    return l;
  };

  $rootScope.getCodeValue = function (CodeList, CodeValue) {
    if (CodeList == null || CodeValue == null) {
      return '';
    }

    for (var i = 0; i < CodeList.length; i++) {
      if (CodeList[i].Code == CodeValue) {
        return CodeList[i].CodeValue;
      }
    }

    return CodeValue;
  };
});

(function () {
  'use strict';

  angular
    .module('salevis4-web')
    .config(toastrConfig)
    .config(translateConfig)
    .config(formlyConfig);

  /** @ngInject */
  function toastrConfig($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  /** @ngInject */
  function translateConfig($translateProvider) {
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    $translateProvider.useStaticFilesLoader({
      prefix: '/assets/i18n/lang-',
      suffix: '.data'
    });
    $translateProvider.preferredLanguage('ko');
  }
   /** @ngInject */
  function formlyConfig(formlyConfigProvider) {
    // Replace formlyBootstrap bootstrapLabel wrapper to implement horizontal forms
    formlyConfigProvider.removeWrapperByName('bootstrapLabel');
    formlyConfigProvider.setWrapper({
      name : 'bootstrapLabel',
      templateUrl : 'label-wrapper.html'
    });

    // Replace formlyBootstrap input field type to implement read-only forms
    formlyConfigProvider.setType({
      name : 'readOnly',
      templateUrl : 'input-template.html',
      wrapper : [ 'bootstrapLabel', 'bootstrapHasError' ],
      overwriteOk : true
    });
  }

})();

(function() {
  "use strict";

  webapp.constant("MAIN", {
    APP_NAME: "Salevis4-web Manager"
  });
})();

(function () {
  'use strict';

  //var checkdTarget = window.location.href.split('//')[1].split("/")[1].replace("#","");
  var checkdTarget;
  var checkMobile = false;

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig(
    $stateProvider,
    $urlRouterProvider,
    $windowProvider,
    $locationProvider
  ) {
    var $window = $windowProvider.$get();
    if (location.href.indexOf('/apps/') == -1) {
      if (
        !angular.isUndefined($window.sessionStorage['isLoggedIn']) &&
        $window.sessionStorage['isLoggedIn'] === 'Y'
      ) {
        var mainPage = $window.sessionStorage.getItem('mainPage');
        $urlRouterProvider.otherwise(function ($injector, $location) {
          /* 2025.06.25 정보노출 취약점 조치 */
          //$injector.get('$state').go(mainPage);
          console.log("error");
          $injector.get('$state').go('error');
        });
      } else {
        if (M.app.check()) {
          $urlRouterProvider.otherwise('/login');
        } else {
          //$urlRouterProvider.otherwise('/intro');
          $urlRouterProvider.otherwise('/login');
        }
      }
    } else {
      var targetApp = location.href.split('#/apps/')[1];
      $window.sessionStorage['USE_APPTYPE'] = targetApp;
    }

    $stateProvider
      .state('app', { url: '/app', component: 'app' })
      .state('pop', { url: '/pop', component: 'pop' })
      .state('popup', { url: '/popup', component: 'popup' })
      .state('m', { url: '/m', component: 'mApp' })
      .state('intro', { url: '/intro', component: 'intro' })
      .state('login', { url: '/login', component: 'login' })
      .state('logout', { url: '/logout', component: 'logout' })
      .state('updatepass', { url: '/updatepass', component: 'updatepass' })
      .state('signup', { url: '/signup', component: 'signupStepOne' })
      .state('signup2', { url: '/signup/:srch', component: 'signupStepTwo' })
      .state('reserve', { url: '/reserve', component: 'reserve' })
      .state('apps', { url: '/apps/:targetApp', component: 'branchApps' })
      .state('forgotpass', { url: '/forgotpass', component: 'forgotpass' })
      //.state("signupTenant",    { url: "/signupTenant", component: "signupTenant" })
      .state('signupFirst', { url: '/signupFirst', component: 'signupFirst' })
      .state('signupSecond', {
        url: '/signupSecond',
        component: 'signupSecond',
      })
      .state('login.notice', { url: '/notice', component: 'notice' })
      .state('login.faq', { url: '/faq', component: 'faq' })
      .state('login.qna', { url: '/qna', component: 'qna' })
      .state('login.agreement', { url: '/agreement', component: 'agreement' })
      .state('login.policy', { url: '/policy', component: 'policy' })
      /* 2025.06.25 정보노출 취약점 조치 */
      .state('error', {url: "/error", templateUrl: "error.html" })
      ;
  }

  webapp.config([
    '$provide',
    function ($provide) {
      $provide.decorator('$controller', [
        '$delegate',
        function ($delegate) {
          return function (constructor, locals) {
            if (typeof constructor == 'string') {
              locals.$scope.controllerName = constructor;
            }

            return $delegate.apply(this, [].slice.call(arguments));
          };
        },
      ]);
    },
  ]);
})();

(function() {
  "use strict";

  webapp.run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $translate, $transitions, $http, $timeout) {
    // $http.defaults.withCredentials = true;
    $http.defaults.headers.common["Content-Type"] = "application/json; charset=utf-8";
    $http.defaults.headers.common.Accept = "application/json, text/html";

    $transitions.onStart({}, onStart);
    $transitions.onSuccess({}, onSuccess);

    /** @ngInject */
    function onStart(trans) {
      var $state = trans.router.stateService;
      //$log.info("[onStart name]::", $state.current.name);
      $rootScope.dataloader = true;
      //console.log('onStart');
    }

    /** @ngInject */
    function onSuccess(trans) {
      var $state = trans.router.stateService;
      $state.getCurrentPath().forEach(function(element) {
       // $log.info("[onSuccess name]::", element.state.name);
      });

      if(appConfigData.projectNm != undefined) {
        $("html").addClass(appConfigData.projectNm);
      }

      if(appConfigData.menuPoisition == undefined) {
        $("html").addClass("sidebar-default");
      } else {
        if(appConfigData.menuPoisition == "default") {
          $("html").addClass("sidebar-default");
        } else if(appConfigData.menuPoisition == "top1") {
          $("html").addClass("sidebar-on-top1");
        } else if(appConfigData.menuPoisition == "top2") {
          $("html").addClass("sidebar-on-top2");
        }
      }


      if($("body").attr("nav-state") == undefined) {
        if( !$("html").hasClass("isOnlyDevice") )
        initPageNavState();
      }

      $timeout(function(){
        initViewLoadedInputBoxStyle();
        initPageContentMinHeight();
        //initLabelTitle();
        // initSzRequired();
      });

      setTimeout(function() {
        $rootScope.dataloader = false;
        $rootScope.title = $translate.instant('PRODUCT.TITLE');
      }, 200);

      //console.log('onStop');
    }
  }

  function initPageNavState() {
    var winWidth = $(window).width();
    if (winWidth < 560) $("body").attr("nav-state", "xs-off");
    else if (winWidth < 768) $("body").attr("nav-state", "sm-off");
    else if (winWidth > 767 ) {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");

      if(navState == null || navState == "null" || navState == undefined || navState == "on" || navState == "off") {
        navState = "rm";
        localStorage.setItem('navMenuMdSizeState', navState);
      }
      $("body").attr("nav-state", "md-" + navState);
    }
    //setToggleImage();
  }
})();
// ui-router login example
// $transitions.onStart( { to: 'auth.**' }, function(trans) {
//     var $state = trans.router.stateService;
//     var MyAuthService = trans.injector().get('MyAuthService');
//     // If the user is not authenticated
//     if (!MyAuthService.isAuthenticated()) {
//       // Then return a promise for a successful login.
//       // The transition will wait for this promise to settle
//       return MyAuthService.authenticate().catch(function() {
//         // If the authenticate() method failed for whatever reason,
//         // redirect to a 'guest' state which doesn't require auth.
//         return $state.target("guest");
//       });
//     }
//   });

"use strict";angular.module("g1b.scroll-events",[]).directive("scrollUp",function(){return{restrict:"A",compile:function(){return{pre:function(){},post:function(e,n,t){n.bind("mousewheel wheel",function(n){n=n.originalEvent||n;var l=n.wheelDelta||n.deltaY*-1||0;l>0&&(e.$apply(function(){e.$eval(t.scrollUp)}),n.preventDefault())})}}}}}).directive("scrollDown",function(){return{restrict:"A",compile:function(){return{pre:function(){},post:function(e,n,t){n.bind("mousewheel wheel",function(n){n=n.originalEvent||n;var l=n.wheelDelta||n.deltaY*-1||0;l<0&&(e.$apply(function(){e.$eval(t.scrollDown)}),n.preventDefault())})}}}}});
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) { // AMD
      define(['jquery'], factory);
  }
  else if (typeof exports == "object" && typeof module == "object") { // CommonJS
      module.exports = factory(require('jquery'));
  }
  else { // Browser
      factory(jQuery);
  }
})(function($, undefined) {
  "use strict";

  var defaultOpts = {

      // Callbacks
      beforeShow: noop,
      move: noop,
      change: noop,
      show: noop,
      hide: noop,

      // Options
      color: false,
      flat: false, // Deprecated - use type instead
      type: '', // text, color, component or flat
      showInput: false,
      allowEmpty: true,
      showButtons: true,
      clickoutFiresChange: true,
      showInitial: false,
      showPalette: true,
      showPaletteOnly: false,
      hideAfterPaletteSelect: false,
      togglePaletteOnly: false,
      showSelectionPalette: true,
      localStorageKey: false,
      appendTo: "body",
      maxSelectionSize: 8,
      locale: "en",
      cancelText: "cancel",
      chooseText: "choose",
      togglePaletteMoreText: "more",
      togglePaletteLessText: "less",
      clearText: "Clear Color Selection",
      noColorSelectedText: "No Color Selected",
      preferredFormat: "name",
      className: "", // Deprecated - use containerClassName and replacerClassName instead.
      containerClassName: "",
      replacerClassName: "",
      showAlpha: true,
      theme: "sp-light",
      palette: [
          ["#000000","#444444","#5b5b5b","#999999","#bcbcbc","#eeeeee","#f3f6f4","#ffffff"],
          ["#f44336","#744700","#ce7e00","#8fce00","#2986cc","#16537e","#6a329f","#c90076"],
          ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
          ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
          ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
          ["#cc0000","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
          ["#990000","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
          ["#660000","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
      ],
      selectionPalette: [],
      disabled: false,
      offset: null
  },
  spectrums = [],
  IE = !!/msie/i.exec( window.navigator.userAgent ),
  rgbaSupport = (function() {
      function contains( str, substr ) {
          return !!~('' + str).indexOf(substr);
      }

      var elem = document.createElement('div');
      var style = elem.style;
      style.cssText = 'background-color:rgba(0,0,0,.5)';
      return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
  })(),
  replaceInput = [
      "<div class='sp-replacer'>",
          "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
          "<div class='sp-dd'>&#9660;</div>",
      "</div>"
  ].join(''),
  markup = (function () {

      // IE does not support gradients with multiple stops, so we need to simulate
      //  that for the rainbow slider with 8 divs that each have a single gradient
      var gradientFix = "";
      if (IE) {
          for (var i = 1; i <= 6; i++) {
              gradientFix += "<div class='sp-" + i + "'></div>";
          }
      }

      return [
          "<div class='sp-container sp-hidden'>",
              "<div class='sp-palette-container'>",
                  "<div class='sp-palette sp-thumb sp-cf'></div>",
                  "<div class='sp-palette-button-container sp-cf'>",
                      "<button type='button' class='sp-palette-toggle'></button>",
                  "</div>",
              "</div>",
              "<div class='sp-picker-container'>",
                  "<div class='sp-top sp-cf'>",
                      "<div class='sp-fill'></div>",
                      "<div class='sp-top-inner'>",
                          "<div class='sp-color'>",
                              "<div class='sp-sat'>",
                                  "<div class='sp-val'>",
                                      "<div class='sp-dragger'></div>",
                                  "</div>",
                              "</div>",
                          "</div>",
                          "<div class='sp-clear sp-clear-display'>",
                          "</div>",
                          "<div class='sp-hue'>",
                              "<div class='sp-slider'></div>",
                              gradientFix,
                          "</div>",
                      "</div>",
                      "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                  "</div>",
                  "<div class='sp-input-container sp-cf'>",
                      "<input class='sp-input' type='text' spellcheck='false'  />",
                  "</div>",
                  "<div class='sp-initial sp-thumb sp-cf'></div>",
                  "<div class='sp-button-container sp-cf'>",
                      "<button class='sp-cancel' href='#'></button>",
                      "<button type='button' class='sp-choose'></button>",
                  "</div>",
              "</div>",
          "</div>"
      ].join("");
  })();

  function paletteTemplate (p, color, className, opts) {
      var html = [];
      for (var i = 0; i < p.length; i++) {
          var current = p[i];
          if(current) {
              var tiny = tinycolor(current);
              var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
              c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
              var formattedString = tiny.toString(opts.preferredFormat || "rgb");
              var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
              html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';"></span></span>');
          } else {
              html.push('<span class="sp-thumb-el sp-clear-display" ><span class="sp-clear-palette-only" style="background-color: transparent;"></span></span>');
          }
      }
      return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
  }

  function hideAll() {
      for (var i = 0; i < spectrums.length; i++) {
          if (spectrums[i]) {
              spectrums[i].hide();
          }
      }
  }

  function instanceOptions(o, callbackContext) {
      o.locale = o.locale || window.navigator.language;
      if (o.locale) o.locale = o.locale.split('-')[0].toLowerCase(); // handle locale like "fr-FR"
      if (o.locale != 'en' && $.spectrum.localization[o.locale]) {
          o = $.extend({}, $.spectrum.localization[o.locale], o);
      }
      var opts = $.extend({}, defaultOpts, o);

      opts.callbacks = {
          'move': bind(opts.move, callbackContext),
          'change': bind(opts.change, callbackContext),
          'show': bind(opts.show, callbackContext),
          'hide': bind(opts.hide, callbackContext),
          'beforeShow': bind(opts.beforeShow, callbackContext)
      };

      return opts;
  }

  function spectrum(element, o) {

      var opts = instanceOptions(o, element),
          type = opts.type,
          flat = (type == 'flat'),
          showSelectionPalette = opts.showSelectionPalette,
          localStorageKey = opts.localStorageKey,
          theme = opts.theme,
          callbacks = opts.callbacks,
          resize = throttle(reflow, 10),
          visible = false,
          isDragging = false,
          dragWidth = 0,
          dragHeight = 0,
          dragHelperHeight = 0,
          slideHeight = 0,
          slideWidth = 0,
          alphaWidth = 0,
          alphaSlideHelperWidth = 0,
          slideHelperHeight = 0,
          currentHue = 0,
          currentSaturation = 0,
          currentValue = 0,
          currentAlpha = 1,
          palette = [],
          paletteArray = [],
          paletteLookup = {},
          selectionPalette = opts.selectionPalette.slice(0),
          maxSelectionSize = opts.maxSelectionSize,
          draggingClass = "sp-dragging",
          abortNextInputChange = false,
          shiftMovementDirection = null;

      var doc = element.ownerDocument,
          body = doc.body,
          boundElement = $(element),
          disabled = false,
          container = $(markup, doc).addClass(theme),
          pickerContainer = container.find(".sp-picker-container"),
          dragger = container.find(".sp-color"),
          dragHelper = container.find(".sp-dragger"),
          slider = container.find(".sp-hue"),
          slideHelper = container.find(".sp-slider"),
          alphaSliderInner = container.find(".sp-alpha-inner"),
          alphaSlider = container.find(".sp-alpha"),
          alphaSlideHelper = container.find(".sp-alpha-handle"),
          textInput = container.find(".sp-input"),
          paletteContainer = container.find(".sp-palette"),
          initialColorContainer = container.find(".sp-initial"),
          cancelButton = container.find(".sp-cancel"),
          clearButton = container.find(".sp-clear"),
          chooseButton = container.find(".sp-choose"),
          toggleButton = container.find(".sp-palette-toggle"),
          isInput = boundElement.is("input"),
          isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
          shouldReplace = isInput && type == 'color',
          replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
          offsetElement = (shouldReplace) ? replacer : boundElement,
          previewElement = replacer.find(".sp-preview-inner"),
          initialColor = opts.color || (isInput && boundElement.val()),
          colorOnShow = false,
          currentPreferredFormat = opts.preferredFormat,
          clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
          isEmpty = !initialColor,
          allowEmpty = opts.allowEmpty;

      // Element to be updated with the input color. Populated in initialize method
      var originalInputContainer = null,
          colorizeElement = null,
          colorizeElementInitialColor = null,
          colorizeElementInitialBackground = null;

      //If there is a label for this element, when clicked on, show the colour picker
      var thisId = boundElement.attr('id');
      if(thisId !== undefined && thisId.length > 0) {
          var label = $('label[for="'+thisId+'"]');
          if(label.length) {
              label.on('click', function(e){
                  e.preventDefault();
                  boundElement.spectrum('show');
                  return false;
              });
          }
      }
      
      function applyOptions() {

          if (opts.showPaletteOnly) {
              opts.showPalette = true;
          }

          toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

          if (opts.palette) {
              palette = opts.palette.slice(0);
              paletteArray = $.isArray(palette[0]) ? palette : [palette];
              paletteLookup = {};
              for (var i = 0; i < paletteArray.length; i++) {
                  for (var j = 0; j < paletteArray[i].length; j++) {
                      var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                      paletteLookup[rgb] = true;
                  }
              }

              // if showPaletteOnly and didn't set initialcolor
              // set initialcolor to first palette
              if (opts.showPaletteOnly && !initialColor) {
                  initialColor = (palette[0][0] === '') ? palette[0][0] : Object.keys(paletteLookup)[0];
              }
          }

          container.toggleClass("sp-flat", flat);
          container.toggleClass("sp-input-disabled", !opts.showInput);
          container.toggleClass("sp-alpha-enabled", opts.showAlpha);
          container.toggleClass("sp-clear-enabled", allowEmpty);
          container.toggleClass("sp-buttons-disabled", !opts.showButtons);
          container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
          container.toggleClass("sp-palette-disabled", !opts.showPalette);
          container.toggleClass("sp-palette-only", opts.showPaletteOnly);
          container.toggleClass("sp-initial-disabled", !opts.showInitial);
          container.addClass(opts.className).addClass(opts.containerClassName);

          reflow();
      }

      function initialize() {

          if (IE) {
              container.find("*:not(input)").attr("unselectable", "on");
          }

          applyOptions();

          originalInputContainer = $('<span class="sp-original-input-container"></span>');
          ['margin'].forEach(function(cssProp) {
              originalInputContainer.css(cssProp, boundElement.css(cssProp));
          });
          // inline-flex by default, switching to flex if needed
          if (boundElement.css('display') == 'block') originalInputContainer.css('display', 'flex');

          if (shouldReplace) {
              boundElement.after(replacer).hide();
          } else if (type == 'text') {
              originalInputContainer.addClass('sp-colorize-container');
              boundElement.addClass('spectrum sp-colorize').wrap(originalInputContainer);
          } else if (type == 'component') {
              boundElement.addClass('spectrum').wrap(originalInputContainer);
              var addOn = $(["<div class='sp-colorize-container sp-add-on'>",
                  "<div class='sp-colorize'></div> ",
              "</div>"].join(''));
              addOn.width(boundElement.outerHeight() + 'px')
                   .css('border-radius', boundElement.css('border-radius'))
                   .css('border', boundElement.css('border'));
              boundElement.addClass('with-add-on').before(addOn);
          }

          colorizeElement = boundElement.parent().find('.sp-colorize');
          colorizeElementInitialColor = colorizeElement.css('color');
          colorizeElementInitialBackground = colorizeElement.css('background-color');

          if (!allowEmpty) {
              clearButton.hide();
          }

          if (flat) {
              boundElement.after(container).hide();
          }
          else {

              var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
              if (appendTo.length !== 1) {
                  appendTo = $("body");
              }

              appendTo.append(container);
          }

          updateSelectionPaletteFromStorage();

          offsetElement.on("click.spectrum touchstart.spectrum", function (e) {
              if (!disabled) {
                  show();
              }

              e.stopPropagation();

              if (!$(e.target).is("input")) {
                  e.preventDefault();
              }
          });

          if(boundElement.is(":disabled") || (opts.disabled === true)) {
              disable();
          }

          // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
          container.click(stopPropagation);

          // Handle user typed input
          [textInput, boundElement].forEach(function(input) {
              input.change(function() { setFromTextInput(input.val()); });
              input.on("paste", function () {
                  setTimeout(function() { setFromTextInput(input.val()); }, 1);
              });
              input.keydown(function (e) { if (e.keyCode == 13) {
                  setFromTextInput($(input).val());
                  if (input == boundElement) hide();
              } });
          });

          cancelButton.text(opts.cancelText);
          cancelButton.on("click.spectrum", function (e) {
              e.stopPropagation();
              e.preventDefault();
              revert();
              hide();
          });

          clearButton.attr("title", opts.clearText);
          clearButton.on("click.spectrum", function (e) {
              e.stopPropagation();
              e.preventDefault();
              isEmpty = true;
              move();

              if(flat) {
                  //for the flat style, this is a change event
                  updateOriginalInput(true);
              }
          });

          chooseButton.text(opts.chooseText);
          chooseButton.on("click.spectrum", function (e) {
              e.stopPropagation();
              e.preventDefault();

              if (IE && textInput.is(":focus")) {
                  textInput.trigger('change');
              }

              if (isValid()) {
                  updateOriginalInput(true);
                  hide();
              }
          });

          toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
          toggleButton.on("click.spectrum", function (e) {
              e.stopPropagation();
              e.preventDefault();

              opts.showPaletteOnly = !opts.showPaletteOnly;

              // To make sure the Picker area is drawn on the right, next to the
              // Palette area (and not below the palette), first move the Palette
              // to the left to make space for the picker, plus 5px extra.
              // The 'applyOptions' function puts the whole container back into place
              // and takes care of the button-text and the sp-palette-only CSS class.
              if (!opts.showPaletteOnly && !flat) {
                  container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
              }
              applyOptions();
          });

          draggable(alphaSlider, function (dragX, dragY, e) {
              currentAlpha = (dragX / alphaWidth);
              isEmpty = false;
              if (e.shiftKey) {
                  currentAlpha = Math.round(currentAlpha * 10) / 10;
              }

              move();
          }, dragStart, dragStop);

          draggable(slider, function (dragX, dragY) {
              currentHue = parseFloat(dragY / slideHeight);
              isEmpty = false;
              if (!opts.showAlpha) {
                  currentAlpha = 1;
              }
              move();
          }, dragStart, dragStop);

          draggable(dragger, function (dragX, dragY, e) {

              // shift+drag should snap the movement to either the x or y axis.
              if (!e.shiftKey) {
                  shiftMovementDirection = null;
              }
              else if (!shiftMovementDirection) {
                  var oldDragX = currentSaturation * dragWidth;
                  var oldDragY = dragHeight - (currentValue * dragHeight);
                  var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                  shiftMovementDirection = furtherFromX ? "x" : "y";
              }

              var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
              var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

              if (setSaturation) {
                  currentSaturation = parseFloat(dragX / dragWidth);
              }
              if (setValue) {
                  currentValue = parseFloat((dragHeight - dragY) / dragHeight);
              }

              isEmpty = false;
              if (!opts.showAlpha) {
                  currentAlpha = 1;
              }

              move();

          }, dragStart, dragStop);

          if (!!initialColor) {
              set(initialColor);

              // In case color was black - update the preview UI and set the format
              // since the set function will not run (default color is black).
              updateUI();
              currentPreferredFormat = tinycolor(initialColor).format || opts.preferredFormat;
              addColorToSelectionPalette(initialColor);
          } else if (initialColor === '') {
              set(initialColor);
              updateUI();
          } else {
              updateUI();
          }

          if (flat) {
              show();
          }

          function paletteElementClick(e) {
              if (e.data && e.data.ignore) {
                  set($(e.target).closest(".sp-thumb-el").data("color"));
                  move();
              }
              else {
                  set($(e.target).closest(".sp-thumb-el").data("color"));
                  move();

                  // If the picker is going to close immediately, a palette selection
                  // is a change.  Otherwise, it's a move only.
                  if (opts.hideAfterPaletteSelect) {
                      updateOriginalInput(true);
                      hide();
                  } else {
                      updateOriginalInput();
                  }
              }

              return false;
          }

          var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
          paletteContainer.on(paletteEvent, ".sp-thumb-el", paletteElementClick);
          initialColorContainer.on(paletteEvent, ".sp-thumb-el:nth-child(1)", { ignore: true }, paletteElementClick);
      }

      function updateSelectionPaletteFromStorage() {

          if (localStorageKey) {
              // Migrate old palettes over to new format.  May want to remove this eventually.
              try {
                  var localStorage = window.localStorage;
                  var oldPalette = localStorage[localStorageKey].split(",#");
                  if (oldPalette.length > 1) {
                      delete localStorage[localStorageKey];
                      $.each(oldPalette, function(i, c) {
                           addColorToSelectionPalette(c);
                      });
                  }
              }
              catch(e) {
                console.log('Error:', e);
               }

              try {
                  selectionPalette = window.localStorage[localStorageKey].split(";");
              }
              catch (e) { 
                console.log('Error:', e);
              }
              
          }
      }

      function addColorToSelectionPalette(color) {
          if (showSelectionPalette) {
              var rgb = tinycolor(color).toRgbString();
              if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                  selectionPalette.push(rgb);
                  while(selectionPalette.length > maxSelectionSize) {
                      selectionPalette.shift();
                  }
              }

              if (localStorageKey) {
                  try {
                      window.localStorage[localStorageKey] = selectionPalette.join(";");
                  }
                  catch(e) { 
                    console.log('Error:', e);
                  }
              }
          }
      }

      function getUniqueSelectionPalette() {
          var unique = [];
          if (opts.showPalette) {
              for (var i = 0; i < selectionPalette.length; i++) {
                  var rgb = tinycolor(selectionPalette[i]).toRgbString();

                  if (!paletteLookup[rgb]) {
                      unique.push(selectionPalette[i]);
                  }
              }
          }

          return unique.reverse().slice(0, opts.maxSelectionSize);
      }

      function drawPalette() {

          var currentColor = get();

          var html = $.map(paletteArray, function (palette, i) {
              return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
          });

          updateSelectionPaletteFromStorage();

          if (selectionPalette) {
              html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
          }

          paletteContainer.html(html.join(""));
      }

      function drawInitial() {
          if (opts.showInitial) {
              var initial = colorOnShow;
              var current = get();
              initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
          }
      }

      function dragStart() {
          if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
              reflow();
          }
          isDragging = true;
          container.addClass(draggingClass);
          shiftMovementDirection = null;
          boundElement.trigger('dragstart.spectrum', [ get() ]);
      }

      function dragStop() {
          isDragging = false;
          container.removeClass(draggingClass);
          boundElement.trigger('dragstop.spectrum', [ get() ]);
      }

      function setFromTextInput(value) {
          if (abortNextInputChange) { abortNextInputChange = false; return; }
          if ((value === null || value === "") && allowEmpty) {
              set(null);
              move();
              updateOriginalInput();
          }
          else {
              var tiny = tinycolor(value);
              if (tiny.isValid()) {
                  set(tiny);
                  move();
                  updateOriginalInput();
              }
              else {
                  textInput.addClass("sp-validation-error");
              }
          }
      }

      function toggle() {
          if (visible) {
              hide();
          }
          else {
              show();
          }
      }

      function show() {
          // debugger;
          var event = $.Event('beforeShow.spectrum');

          if (visible) {
              reflow();
              return;
          }

          boundElement.trigger(event, [ get() ]);

          if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
              return;
          }

          hideAll();
          visible = true;

          $(doc).on("keydown.spectrum", onkeydown);
          $(doc).on("click.spectrum", clickout);
          $(window).on("resize.spectrum", resize);
          replacer.addClass("sp-active");
          container.removeClass("sp-hidden");

          reflow();
          updateUI();

          colorOnShow = get();

          drawInitial();
          callbacks.show(colorOnShow);
          boundElement.trigger('show.spectrum', [ colorOnShow ]);
      }

      function onkeydown(e) {
          // Close on ESC
          if (e.keyCode === 27) {
              hide();
          }
      }

      function clickout(e) {
          // Return on right click.
          if (e.button == 2) { return; }

          // If a drag event was happening during the mouseup, don't hide
          // on click.
          if (isDragging) { return; }

          if (clickoutFiresChange) {
              updateOriginalInput(true);
          }
          else {
              revert();
          }
          hide();
      }

      function hide() {
          // Return if hiding is unnecessary
          if (!visible || flat) { return; }
          visible = false;

          $(doc).off("keydown.spectrum", onkeydown);
          $(doc).off("click.spectrum", clickout);
          $(window).off("resize.spectrum", resize);

          replacer.removeClass("sp-active");
          container.addClass("sp-hidden");

          callbacks.hide(get());
          boundElement.trigger('hide.spectrum', [ get() ]);
      }

      function revert() {
          set(colorOnShow, true);
          updateOriginalInput(true);
      }

      function set(color, ignoreFormatChange) {
          if (tinycolor.equals(color, get())) {
              // Update UI just in case a validation error needs
              // to be cleared.
              updateUI();
              return;
          }

          var newColor, newHsv;
          if ((!color || color === undefined) && allowEmpty) {
              isEmpty = true;
          } else {
              isEmpty = false;
              newColor = tinycolor(color);
              newHsv = newColor.toHsv();

              currentHue = (newHsv.h % 360) / 360;
              currentSaturation = newHsv.s;
              currentValue = newHsv.v;
              currentAlpha = newHsv.a;
          }
          updateUI();

          if (newColor && newColor.isValid() && !ignoreFormatChange) {
              currentPreferredFormat = opts.preferredFormat || newColor.getFormat();
          }
      }

      function get(opts) {
          opts = opts || { };

          if (allowEmpty && isEmpty) {
              return null;
          }

          return tinycolor.fromRatio({
              h: currentHue,
              s: currentSaturation,
              v: currentValue,
              a: Math.round(currentAlpha * 1000) / 1000
          }, { format: opts.format || currentPreferredFormat });
      }

      function isValid() {
          return !textInput.hasClass("sp-validation-error");
      }

      function move() {
          updateUI();

          callbacks.move(get());
          boundElement.trigger('move.spectrum', [ get() ]);
      }

      function updateUI() {

          textInput.removeClass("sp-validation-error");

          updateHelperLocations();

          // Update dragger background color (gradients take care of saturation and value).
          var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
          dragger.css("background-color", flatColor.toHexString());

          // Get a format that alpha will be included in (hex and names ignore alpha)
          var format = currentPreferredFormat;
          if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
              if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                  format = "rgb";
              }
          }

          var realColor = get({ format: format }),
              displayColor = '';

           //reset background info for preview element
          previewElement.removeClass("sp-clear-display");
          previewElement.css('background-color', 'transparent');

          if (!realColor && allowEmpty) {
              // Update the replaced elements background with icon indicating no color selection
              previewElement.addClass("sp-clear-display");
          }
          else {
              var realHex = realColor.toHexString(),
                  realRgb = realColor.toRgbString();

              // Update the replaced elements background color (with actual selected color)
              if (rgbaSupport || realColor.alpha === 1) {
                  previewElement.css("background-color", realRgb);
              }
              else {
                  previewElement.css("background-color", "transparent");
                  previewElement.css("filter", realColor.toFilter());
              }

              if (opts.showAlpha) {
                  var rgb = realColor.toRgb();
                  rgb.a = 0;
                  var realAlpha = tinycolor(rgb).toRgbString();
                  var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                  if (IE) {
                      alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                  }
                  else {
                      alphaSliderInner.css("background", "-webkit-" + gradient);
                      alphaSliderInner.css("background", "-moz-" + gradient);
                      alphaSliderInner.css("background", "-ms-" + gradient);
                      // Use current syntax gradient on unprefixed property.
                      alphaSliderInner.css("background",
                          "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                  }
              }

              displayColor = realColor.toString(format);
          }

          // Update the text entry input as it changes happen
          if (opts.showInput) {
              textInput.val(displayColor);
          }
          boundElement.val(displayColor);
          if (opts.type == "text" || opts.type == "component") {
              var color = realColor;
              if (color && colorizeElement) {
                  var textColor = (color.isLight() || color.getAlpha() < 0.4) ? 'black' : 'white';
                  colorizeElement.css('background-color', color.toRgbString()).css('color', textColor);
              } else {
                  colorizeElement.css('background-color', colorizeElementInitialBackground)
                                 .css('color', colorizeElementInitialColor);
              }
          }

          if (opts.showPalette) {
              drawPalette();
          }

          drawInitial();
      }

      function updateHelperLocations() {
          var s = currentSaturation;
          var v = currentValue;

          if(allowEmpty && isEmpty) {
              //if selected color is empty, hide the helpers
              alphaSlideHelper.hide();
              slideHelper.hide();
              dragHelper.hide();
          }
          else {
              //make sure helpers are visible
              alphaSlideHelper.show();
              slideHelper.show();
              dragHelper.show();

              // Where to show the little circle in that displays your current selected color
              var dragX = s * dragWidth;
              var dragY = dragHeight - (v * dragHeight);
              dragX = Math.max(
                  -dragHelperHeight,
                  Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
              );
              dragY = Math.max(
                  -dragHelperHeight,
                  Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
              );
              dragHelper.css({
                  "top": dragY + "px",
                  "left": dragX + "px"
              });

              var alphaX = currentAlpha * alphaWidth;
              alphaSlideHelper.css({
                  "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
              });

              // Where to show the bar that displays your current selected hue
              var slideY = (currentHue) * slideHeight;
              slideHelper.css({
                  "top": (slideY - slideHelperHeight) + "px"
              });
          }
      }

      function updateOriginalInput(fireCallback) {
          var color = get(),
              displayColor = '',
              hasChanged = !tinycolor.equals(color, colorOnShow);

          if (color) {
              displayColor = color.toString(currentPreferredFormat);
              // Update the selection palette with the current color
              addColorToSelectionPalette(color);
          }

          if (fireCallback && hasChanged) {
              callbacks.change(color);
              // we trigger the change event or input, but the input change event is also binded
              // to some spectrum processing, that we do no need
              abortNextInputChange = true;
              boundElement.trigger('change', [ color ]);
          }
      }

      function reflow() {
          if (!visible) {
              return; // Calculations would be useless and wouldn't be reliable anyways
          }
          dragWidth = dragger.width();
          dragHeight = dragger.height();
          dragHelperHeight = dragHelper.height();
          slideWidth = slider.width();
          slideHeight = slider.height();
          slideHelperHeight = slideHelper.height();
          alphaWidth = alphaSlider.width();
          alphaSlideHelperWidth = alphaSlideHelper.width();

          if (!flat) {
              container.css("position", "absolute");
              if (opts.offset) {
                  container.offset(opts.offset);
              } else {
                  container.offset(getOffset(container, offsetElement));
              }
          }

          updateHelperLocations();

          if (opts.showPalette) {
              drawPalette();
          }

          boundElement.trigger('reflow.spectrum');
      }

      function destroy() {
          boundElement.show().removeClass('spectrum with-add-on sp-colorize');
          offsetElement.off("click.spectrum touchstart.spectrum");
          container.remove();
          replacer.remove();
          if (colorizeElement) {
              colorizeElement.css('background-color', colorizeElementInitialBackground)
                             .css('color', colorizeElementInitialColor);
          }
          var originalInputContainer = boundElement.closest('.sp-original-input-container');
          if (originalInputContainer.length > 0) {
              originalInputContainer.after(boundElement).remove();
          }
          spectrums[spect.id] = null;
      }

      function option(optionName, optionValue) {
          if (optionName === undefined) {
              return $.extend({}, opts);
          }
          if (optionValue === undefined) {
              return opts[optionName];
          }

          opts[optionName] = optionValue;

          if (optionName === "preferredFormat") {
              currentPreferredFormat = opts.preferredFormat;
          }
          applyOptions();
      }

      function enable() {
          disabled = false;
          boundElement.attr("disabled", false);
          offsetElement.removeClass("sp-disabled");
      }

      function disable() {
          hide();
          disabled = true;
          boundElement.attr("disabled", true);
          offsetElement.addClass("sp-disabled");
      }

      function setOffset(coord) {
          opts.offset = coord;
          reflow();
      }

      initialize();

      var spect = {
          show: show,
          hide: hide,
          toggle: toggle,
          reflow: reflow,
          option: option,
          enable: enable,
          disable: disable,
          offset: setOffset,
          set: function (c) {
              set(c);
              updateOriginalInput();
          },
          get: get,
          destroy: destroy,
          container: container
      };

      spect.id = spectrums.push(spect) - 1;

      return spect;
  }

  /**
  * checkOffset - get the offset below/above and left/right element depending on screen position
  * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
  */
  function getOffset(picker, input) {
      var extraY = 0;
      var dpWidth = picker.outerWidth();
      var dpHeight = picker.outerHeight();
      var inputHeight = input.outerHeight();
      var doc = picker[0].ownerDocument;
      var docElem = doc.documentElement;
      var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
      var viewHeight = docElem.clientHeight + $(doc).scrollTop();
      var offset = input.offset();
      var offsetLeft = offset.left;
      var offsetTop = offset.top;

      offsetTop += inputHeight;

      offsetLeft -=
          Math.min(offsetLeft, (offsetLeft + dpWidth > viewWidth && viewWidth > dpWidth) ?
          Math.abs(offsetLeft + dpWidth - viewWidth) : 0);

      offsetTop -=
          Math.min(offsetTop, ((offsetTop + dpHeight > viewHeight && viewHeight > dpHeight) ?
          Math.abs(dpHeight + inputHeight - extraY) : extraY));

      return {
          top: offsetTop,
          bottom: offset.bottom,
          left: offsetLeft,
          right: offset.right,
          width: offset.width,
          height: offset.height
      };
  }

  /**
  * noop - do nothing
  */
  function noop() {

  }

  /**
  * stopPropagation - makes the code only doing this a little easier to read in line
  */
  function stopPropagation(e) {
      e.stopPropagation();
  }

  /**
  * Create a function bound to a given object
  * Thanks to underscore.js
  */
  function bind(func, obj) {
      var slice = Array.prototype.slice;
      var args = slice.call(arguments, 2);
      return function () {
          return func.apply(obj, args.concat(slice.call(arguments)));
      };
  }

  /**
  * Lightweight drag helper.  Handles containment within the element, so that
  * when dragging, the x is within [0,element.width] and y is within [0,element.height]
  */
  function draggable(element, onmove, onstart, onstop) {
      onmove = onmove || function () { };
      onstart = onstart || function () { };
      onstop = onstop || function () { };
      var doc = document;
      var dragging = false;
      var offset = {};
      var maxHeight = 0;
      var maxWidth = 0;
      var hasTouch = ('ontouchstart' in window);

      var duringDragEvents = {};
      duringDragEvents["selectstart"] = prevent;
      duringDragEvents["dragstart"] = prevent;
      duringDragEvents["touchmove mousemove"] = move;
      duringDragEvents["touchend mouseup"] = stop;

      function prevent(e) {
          if (e.stopPropagation) {
              e.stopPropagation();
          }
          if (e.preventDefault) {
              e.preventDefault();
          }
          e.returnValue = false;
      }

      function move(e) {
          if (dragging) {
              // Mouseup happened outside of window
              if (IE && doc.documentMode < 9 && !e.button) {
                  return stop();
              }

              var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
              var pageX = t0 && t0.pageX || e.pageX;
              var pageY = t0 && t0.pageY || e.pageY;

              var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
              var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

              if (hasTouch) {
                  // Stop scrolling in iOS
                  prevent(e);
              }

              onmove.apply(element, [dragX, dragY, e]);
          }
      }

      function start(e) {
          var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

          if (!rightclick && !dragging) {
              if (onstart.apply(element, arguments) !== false) {
                  dragging = true;
                  maxHeight = $(element).height();
                  maxWidth = $(element).width();
                  offset = $(element).offset();

                  $(doc).on(duringDragEvents);
                  $(doc.body).addClass("sp-dragging");

                  move(e);

                  prevent(e);
              }
          }
      }

      function stop() {
          if (dragging) {
              $(doc).off(duringDragEvents);
              $(doc.body).removeClass("sp-dragging");

              // Wait a tick before notifying observers to allow the click event
              // to fire in Chrome.
              setTimeout(function() {
                  onstop.apply(element, arguments);
              }, 0);
          }
          dragging = false;
      }

      $(element).on("touchstart mousedown", start);
  }

  function throttle(func, wait, debounce) {
      var timeout;
      return function () {
          var context = this, args = arguments;
          var throttler = function () {
              timeout = null;
              func.apply(context, args);
          };
          if (debounce) clearTimeout(timeout);
          if (debounce || !timeout) timeout = setTimeout(throttler, wait);
      };
  }

  function inputTypeColorSupport() {
      return $.fn.spectrum.inputTypeColorSupport();
  }

  /**
  * Define a jQuery plugin
  */
  var dataID = "spectrum.id";
  $.fn.spectrum = function (opts, extra) {

      if (typeof opts == "string") {

          var returnValue = this;
          var args = Array.prototype.slice.call( arguments, 1 );

          this.each(function () {
              var spect = spectrums[$(this).data(dataID)];
              if (spect) {
                  var method = spect[opts];
                  if (!method) {
                      throw new Error( "Spectrum: no such method: '" + opts + "'" );
                  }

                  if (opts == "get") {
                      returnValue = spect.get();
                  }
                  else if (opts == "container") {
                      returnValue = spect.container;
                  }
                  else if (opts == "option") {
                      returnValue = spect.option.apply(spect, args);
                  }
                  else if (opts == "destroy") {
                      spect.destroy();
                      $(this).removeData(dataID);
                  }
                  else {
                      method.apply(spect, args);
                  }
              }
          });

          return returnValue;
      }

      // Initializing a new instance of spectrum
      return this.spectrum("destroy").each(function () {
          var options = $.extend({}, $(this).data(), opts);
          // Infer default type from input params and deprecated options
          if (!$(this).is('input')) options.type = 'noInput';
          else if (options.flat || options.type == "flat") options.type = 'flat';
          else if ($(this).attr('type') == 'color') options.type = 'color';
          else options.type = options.type || 'component';

          var spect = spectrum(this, options);
          $(this).data(dataID, spect.id);
      });
  };

  $.fn.spectrum.load = true;
  $.fn.spectrum.loadOpts = {};
  $.fn.spectrum.draggable = draggable;
  $.fn.spectrum.defaults = defaultOpts;
  $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
      if (typeof inputTypeColorSupport._cachedResult === "undefined") {
          var colorInput = $("<input type='color'/>")[0]; // if color element is supported, value will default to not null
          inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "";
      }
      return inputTypeColorSupport._cachedResult;
  };

  $.spectrum = { };
  $.spectrum.localization = { };
  $.spectrum.palettes = { };

  $.fn.spectrum.processNativeColorInputs = function () {
      var colorInputs = $("input[type=color]");
      if (colorInputs.length && !inputTypeColorSupport()) {
          colorInputs.spectrum({
              preferredFormat: "hex6"
          });
      }
  };

  // TinyColor v1.1.2
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  (function() {

  var trimLeft = /^[\s,#]+/,
      trimRight = /\s+$/,
      tinyCounter = 0,
      math = Math,
      mathRound = math.round,
      mathMin = math.min,
      mathMax = math.max,
      mathRandom = math.random;

  var tinycolor = function(color, opts) {

      color = (color) ? color : '';
      opts = opts || { };

      // If input is already a tinycolor, return itself
      if (color instanceof tinycolor) {
         return color;
      }
      // If we are called as a function, call using new instead
      if (!(this instanceof tinycolor)) {
          return new tinycolor(color, opts);
      }

      var rgb = inputToRGB(color);
      this._originalInput = color;
      this._r = rgb.r;
      this._g = rgb.g;
      this._b = rgb.b;
      this._a = rgb.a;
      this._roundA = mathRound(1000 * this._a) / 1000;
      this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType;

      // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`
      if (this._r < 1) { this._r = mathRound(this._r); }
      if (this._g < 1) { this._g = mathRound(this._g); }
      if (this._b < 1) { this._b = mathRound(this._b); }

      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
  };

  tinycolor.prototype = {
      isDark: function() {
          return this.getBrightness() < 128;
      },
      isLight: function() {
          return !this.isDark();
      },
      isValid: function() {
          return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
          return this._format;
      },
      getAlpha: function() {
          return this._a;
      },
      getBrightness: function() {
          var rgb = this.toRgb();
          return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      setAlpha: function(value) {
          this._a = boundAlpha(value);
          this._roundA = mathRound(1000 * this._a) / 1000;
          return this;
      },
      toHsv: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
      },
      toHsvString: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
          return (this._a == 1) ?
            "hsv("  + h + ", " + s + "%, " + v + "%)" :
            "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
      },
      toHsl: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
      },
      toHslString: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
          return (this._a == 1) ?
            "hsl("  + h + ", " + s + "%, " + l + "%)" :
            "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
      },
      toHex: function(allow3Char) {
          return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function(allow3Char) {
          return '#' + this.toHex(allow3Char);
      },
      toHex8: function() {
          return rgbaToHex(this._r, this._g, this._b, this._a);
      },
      toHex8String: function() {
          return '#' + this.toHex8();
      },
      toRgb: function() {
          return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
      },
      toRgbString: function() {
          return (this._a == 1) ?
            "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
            "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
          return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
          return (this._a == 1) ?
            "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
            "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
          if (this._a === 0) {
              return "transparent";
          }

          if (this._a < 1) {
              return false;
          }

          return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function(secondColor) {
          var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
          var secondHex8String = hex8String;
          var gradientType = this._gradientType ? "GradientType = 1, " : "";

          if (secondColor) {
              var s = tinycolor(secondColor);
              secondHex8String = s.toHex8String();
          }

          return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
      },
      toString: function(format) {
          var formatSet = !!format;
          format = format || this._format;

          var formattedString = false;
          var hasAlpha = this._a < 1 && this._a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

          if (needsAlphaFormat) {
              // Special case for "transparent", all other non-alpha formats
              // will return rgba when there is transparency.
              if (format === "name" && this._a === 0) {
                  return this.toName();
              }
              return this.toRgbString();
          }
          if (format === "rgb") {
              formattedString = this.toRgbString();
          }
          if (format === "prgb") {
              formattedString = this.toPercentageRgbString();
          }
          if (format === "hex" || format === "hex6") {
              formattedString = this.toHexString();
          }
          if (format === "hex3") {
              formattedString = this.toHexString(true);
          }
          if (format === "hex8") {
              formattedString = this.toHex8String();
          }
          if (format === "name") {
              formattedString = this.toName();
          }
          if (format === "hsl") {
              formattedString = this.toHslString();
          }
          if (format === "hsv") {
              formattedString = this.toHsvString();
          }

          return formattedString || this.toHexString();
      },

      _applyModification: function(fn, args) {
          var color = fn.apply(null, [this].concat([].slice.call(args)));
          this._r = color._r;
          this._g = color._g;
          this._b = color._b;
          this.setAlpha(color._a);
          return this;
      },
      lighten: function() {
          return this._applyModification(lighten, arguments);
      },
      brighten: function() {
          return this._applyModification(brighten, arguments);
      },
      darken: function() {
          return this._applyModification(darken, arguments);
      },
      desaturate: function() {
          return this._applyModification(desaturate, arguments);
      },
      saturate: function() {
          return this._applyModification(saturate, arguments);
      },
      greyscale: function() {
          return this._applyModification(greyscale, arguments);
      },
      spin: function() {
          return this._applyModification(spin, arguments);
      },

      _applyCombination: function(fn, args) {
          return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function() {
          return this._applyCombination(analogous, arguments);
      },
      complement: function() {
          return this._applyCombination(complement, arguments);
      },
      monochromatic: function() {
          return this._applyCombination(monochromatic, arguments);
      },
      splitcomplement: function() {
          return this._applyCombination(splitcomplement, arguments);
      },
      triad: function() {
          return this._applyCombination(triad, arguments);
      },
      tetrad: function() {
          return this._applyCombination(tetrad, arguments);
      }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function(color, opts) {
      if (typeof color == "object") {
          var newColor = {};
          for (var i in color) {
              if (color.hasOwnProperty(i)) {
                  if (i === "a") {
                      newColor[i] = color[i];
                  }
                  else {
                      newColor[i] = convertToPercentage(color[i]);
                  }
              }
          }
          color = newColor;
      }

      return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {

      var rgb = { r: 0, g: 0, b: 0 };
      var a = 1;
      var ok = false;
      var format = false;

      if (typeof color == "string") {
          color = stringInputToObject(color);
      }

      if (typeof color == "object") {
          if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
              rgb = rgbToRgb(color.r, color.g, color.b);
              ok = true;
              format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
          }
          else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
              color.s = convertToPercentage(color.s);
              color.v = convertToPercentage(color.v);
              rgb = hsvToRgb(color.h, color.s, color.v);
              ok = true;
              format = "hsv";
          }
          else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
              color.s = convertToPercentage(color.s);
              color.l = convertToPercentage(color.l);
              rgb = hslToRgb(color.h, color.s, color.l);
              ok = true;
              format = "hsl";
          }

          if (color.hasOwnProperty("a")) {
              a = color.a;
          }
      }

      a = boundAlpha(a);

      return {
          ok: ok,
          format: color.format || format,
          r: mathMin(255, mathMax(rgb.r, 0)),
          g: mathMin(255, mathMax(rgb.g, 0)),
          b: mathMin(255, mathMax(rgb.b, 0)),
          a: a
      };
  }


  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b){
      return {
          r: bound01(r, 255) * 255,
          g: bound01(g, 255) * 255,
          b: bound01(b, 255) * 255
      };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {

      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);

      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, l = (max + min) / 2;

      if(max == min) {
          h = s = 0; // achromatic
      }
      else {
          var d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
          switch(max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
          }

          h /= 6;
      }

      return { h: h, s: s, l: l };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
      var r, g, b;

      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);

      function hue2rgb(p, q, t) {
          if(t < 0) t += 1;
          if(t > 1) t -= 1;
          if(t < 1/6) return p + (q - p) * 6 * t;
          if(t < 1/2) return q;
          if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
          return p;
      }

      if(s === 0) {
          r = g = b = l; // achromatic
      }
      else {
          var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
          var p = 2 * l - q;
          r = hue2rgb(p, q, h + 1/3);
          g = hue2rgb(p, q, h);
          b = hue2rgb(p, q, h - 1/3);
      }

      return { r: r * 255, g: g * 255, b: b * 255 };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {

      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);

      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, v = max;

      var d = max - min;
      s = max === 0 ? 0 : d / max;

      if(max == min) {
          h = 0; // achromatic
      }
      else {
          switch(max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
          }
          h /= 6;
      }
      return { h: h, s: s, v: v };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
   function hsvToRgb(h, s, v) {

      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);

      var i = math.floor(h),
          f = h - i,
          p = v * (1 - s),
          q = v * (1 - f * s),
          t = v * (1 - (1 - f) * s),
          mod = i % 6,
          r = [v, q, p, p, t, v][mod],
          g = [t, v, v, q, p, p][mod],
          b = [p, p, t, v, v, q][mod];

      return { r: r * 255, g: g * 255, b: b * 255 };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {

      var hex = [
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
      ];

      // Return a 3 character hex if possible
      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
          return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }

      return hex.join("");
  }
      // `rgbaToHex`
      // Converts an RGBA color plus alpha transparency to hex
      // Assumes r, g, b and a are contained in the set [0, 255]
      // Returns an 8 character hex
      function rgbaToHex(r, g, b, a) {

          var hex = [
              pad2(convertDecimalToHex(a)),
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
      ];

      return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) { return false; }
      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function() {
      return tinycolor.fromRatio({
          r: mathRandom(),
          g: mathRandom(),
          b: mathRandom()
      });
  };


  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function desaturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
  }

  function saturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
  }

  function greyscale(color) {
      return tinycolor(color).desaturate(100);
  }

  function lighten (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
  }

  function brighten(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
      return tinycolor(rgb);
  }

  function darken (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (mathRound(hsl.h) + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
  }

  function triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
      ];
  }

  function tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
      ];
  }

  function splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
          tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
      ];
  }

  function analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;

      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];

      for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
          hsl.h = (hsl.h + part) % 360;
          ret.push(tinycolor(hsl));
      }
      return ret;
  }

  function monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h, s = hsv.s, v = hsv.v;
      var ret = [];
      var modification = 1 / results;

      while (results--) {
          ret.push(tinycolor({ h: h, s: s, v: v}));
          v = (v + modification) % 1;
      }

      return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function(color1, color2, amount) {
      amount = (amount === 0) ? 0 : (amount || 50);

      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();

      var p = amount / 100;
      var w = p * 2 - 1;
      var a = rgb2.a - rgb1.a;

      var w1;

      if (w * a == -1) {
          w1 = w;
      } else {
          w1 = (w + a) / (1 + w * a);
      }

      w1 = (w1 + 1) / 2;

      var w2 = 1 - w1;

      var rgba = {
          r: rgb2.r * w1 + rgb1.r * w2,
          g: rgb2.g * w1 + rgb1.g * w2,
          b: rgb2.b * w1 + rgb1.b * w2,
          a: rgb2.a * p  + rgb1.a * (1 - p)
      };

      return tinycolor(rgba);
  };


  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/AERT#color-contrast>

  // `readability`
  // Analyze the 2 colors and returns an object with the following properties:
  //    `brightness`: difference in brightness between the two colors
  //    `color`: difference in color/hue between the two colors
  tinycolor.readability = function(color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      var rgb1 = c1.toRgb();
      var rgb2 = c2.toRgb();
      var brightnessA = c1.getBrightness();
      var brightnessB = c2.getBrightness();
      var colorDiff = (
          Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
          Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
          Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
      );

      return {
          brightness: Math.abs(brightnessA - brightnessB),
          color: colorDiff
      };
  };

  // `readable`
  // http://www.w3.org/TR/AERT#color-contrast
  // Ensure that foreground and background color combinations provide sufficient contrast.
  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  tinycolor.isReadable = function(color1, color2) {
      var readability = tinycolor.readability(color1, color2);
      return readability.brightness > 125 && readability.color > 500;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // *Example*
  //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
  tinycolor.mostReadable = function(baseColor, colorList) {
      var bestColor = null;
      var bestScore = 0;
      var bestIsReadable = false;
      for (var i=0; i < colorList.length; i++) {

          // We normalize both around the "acceptable" breaking point,
          // but rank brightness constrast higher than hue.

          var readability = tinycolor.readability(baseColor, colorList[i]);
          var readable = readability.brightness > 125 && readability.color > 500;
          var score = 3 * (readability.brightness / 125) + (readability.color / 500);

          if ((readable && ! bestIsReadable) ||
              (readable && bestIsReadable && score > bestScore) ||
              ((! readable) && (! bestIsReadable) && score > bestScore)) {
              bestIsReadable = readable;
              bestScore = score;
              bestColor = tinycolor(colorList[i]);
          }
      }
      return bestColor;
  };


  // Big List of Colors
  // ------------------
  // <http://www.w3.org/TR/css3-color/#svg-color>
  var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);


  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
      var flipped = { };
      for (var i in o) {
          if (o.hasOwnProperty(i)) {
              flipped[o[i]] = i;
          }
      }
      return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
      a = parseFloat(a);

      if (isNaN(a) || a < 0 || a > 1) {
          a = 1;
      }

      return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
      if (isOnePointZero(n)) { n = "100%"; }

      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n)));

      // Automatically convert percentage into number
      if (processPercent) {
          n = parseInt(n * max, 10) / 100;
      }

      // Handle floating point rounding errors
      if ((math.abs(n - max) < 0.000001)) {
          return 1;
      }

      // Convert into [0, 1] range if it isn't already
      return (n % max) / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
      return mathMin(1, mathMax(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
      return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
      if (n <= 1) {
          n = (n * 100) + "%";
      }

      return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
      return (parseIntFromHex(h) / 255);
  }

  var matchers = (function() {

      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?";

      // <http://www.w3.org/TR/css3-values/#number-value>
      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

      // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

      // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren
      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

      return {
          rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
          rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
          hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
          hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
          hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
          hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
          hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
  })();

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {

      color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
      var named = false;
      if (names[color]) {
          color = names[color];
          named = true;
      }
      else if (color == 'transparent') {
          return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      }

      // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.
      var match;
      if ((match = matchers.rgb.exec(color))) {
          return { r: match[1], g: match[2], b: match[3] };
      }
      if ((match = matchers.rgba.exec(color))) {
          return { r: match[1], g: match[2], b: match[3], a: match[4] };
      }
      if ((match = matchers.hsl.exec(color))) {
          return { h: match[1], s: match[2], l: match[3] };
      }
      if ((match = matchers.hsla.exec(color))) {
          return { h: match[1], s: match[2], l: match[3], a: match[4] };
      }
      if ((match = matchers.hsv.exec(color))) {
          return { h: match[1], s: match[2], v: match[3] };
      }
      if ((match = matchers.hsva.exec(color))) {
          return { h: match[1], s: match[2], v: match[3], a: match[4] };
      }
      if ((match = matchers.hex8.exec(color))) {
          return {
              a: convertHexToDecimal(match[1]),
              r: parseIntFromHex(match[2]),
              g: parseIntFromHex(match[3]),
              b: parseIntFromHex(match[4]),
              format: named ? "name" : "hex8"
          };
      }
      if ((match = matchers.hex6.exec(color))) {
          return {
              r: parseIntFromHex(match[1]),
              g: parseIntFromHex(match[2]),
              b: parseIntFromHex(match[3]),
              format: named ? "name" : "hex"
          };
      }
      if ((match = matchers.hex3.exec(color))) {
          return {
              r: parseIntFromHex(match[1] + '' + match[1]),
              g: parseIntFromHex(match[2] + '' + match[2]),
              b: parseIntFromHex(match[3] + '' + match[3]),
              format: named ? "name" : "hex"
          };
      }

      return false;
  }

  window.tinycolor = tinycolor;
  })();

  $(function () {
      if ($.fn.spectrum.load) {
          $.fn.spectrum.processNativeColorInputs();
      }
  });

});

// Spectrum Colorpicker
// Arabic (ar) localization
// https://github.com/seballot/spectrum
(function ( $ ) {

var localization = $.spectrum.localization["ar"] = {
    cancelText: "إلغاء",
    chooseText: "إختار",
    clearText: "إرجاع الألوان على ما كانت",
    noColorSelectedText: "لم تختار أي لون",
    togglePaletteMoreText: "أكثر",
    togglePaletteLessText: "أقل"
};

})( jQuery );

// Spectrum Colorpicker
// Catalan (ca) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ca"] = {
      cancelText: "Cancel·lar",
      chooseText: "Escollir",
      clearText: "Esborrar color seleccionat",
      noColorSelectedText: "Cap color seleccionat",
      togglePaletteMoreText: "Més",
      togglePaletteLessText: "Menys"
  };

})( jQuery );

// Spectrum Colorpicker
// Czech (cs) localization
// https://github.com/seballot/spectrum
// author localization cs Pavel Laupe Dvorak pavel@pavel-dvorak.cz

(function ( $ ) {

  var localization = $.spectrum.localization["cs"] = {
      cancelText: "zrušit",
      chooseText: "vybrat",
      clearText: "Resetovat výběr barev",
      noColorSelectedText: "Žádná barva nebyla vybrána",
      togglePaletteMoreText: "více",
      togglePaletteLessText: "méně"
  };

})( jQuery );

// Spectrum Colorpicker
// German (de) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["de"] = {
      cancelText: "Abbrechen",
      chooseText: "Wählen",
      clearText: "Farbauswahl zurücksetzen",
      noColorSelectedText: "Keine Farbe ausgewählt",
      togglePaletteMoreText: "Mehr",
      togglePaletteLessText: "Weniger"
  };

})( jQuery );

// Spectrum Colorpicker
// Danish (dk) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["dk"] = {
  cancelText: "annuller",
  chooseText: "Vælg"
  };

})( jQuery );

// Spectrum Colorpicker
// Spanish (es) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["es"] = {
      cancelText: "Cancelar",
      chooseText: "Elegir",
      clearText: "Borrar color seleccionado",
      noColorSelectedText: "Ningún color seleccionado",
      togglePaletteMoreText: "Más",
      togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Estonian (et) localization
// https://github.com/bgrins/spectrum

(function ( $ ) {

   var localization = $.spectrum.localization["et"] = {
      cancelText: "Katkesta",
      chooseText: "Vali",
      clearText: "Tühista värvivalik",
      noColorSelectedText: "Ühtki värvi pole valitud",
      togglePaletteMoreText: "Rohkem",
      togglePaletteLessText: "Vähem"
  };

})( jQuery );

// Spectrum Colorpicker
// Persian (fa) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fa"] = {
      cancelText: "لغو",
      chooseText: "انتخاب",
      clearText: "تنظیم مجدد رنگ",
      noColorSelectedText: "هیچ رنگی انتخاب نشده است!",
      togglePaletteMoreText: "بیشتر",
      togglePaletteLessText: "کمتر"
  };

})( jQuery );

// Spectrum Colorpicker
// Finnish (fi) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fi"] = {
      cancelText: "Kumoa",
      chooseText: "Valitse"
  };

})( jQuery );

// Spectrum Colorpicker
// French (fr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fr"] = {
      cancelText: "Annuler",
      chooseText: "Valider",
      clearText: "Effacer couleur sélectionnée",
      noColorSelectedText: "Aucune couleur sélectionnée",
      togglePaletteMoreText: "Plus",
      togglePaletteLessText: "Moins"
  };

})( jQuery );

// Spectrum Colorpicker
// Greek (gr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["gr"] = {
      cancelText: "Ακύρωση",
      chooseText: "Επιλογή",
      clearText: "Καθαρισμός επιλεγμένου χρώματος",
      noColorSelectedText: "Δεν έχει επιλεχθεί κάποιο χρώμα",
      togglePaletteMoreText: "Περισσότερα",
      togglePaletteLessText: "Λιγότερα"
  };

})( jQuery );

// Spectrum Colorpicker
// Hebrew (he) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["he"] = {
      cancelText: "בטל בחירה",
      chooseText: "בחר צבע",
      clearText: "אפס בחירה",
      noColorSelectedText: "לא נבחר צבע",
      togglePaletteMoreText: "עוד צבעים",
      togglePaletteLessText: "פחות צבעים"
  };

})( jQuery );

// Spectrum Colorpicker
// Croatian (hr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["hr"] = {
      cancelText: "Odustani",
      chooseText: "Odaberi",
      clearText: "Poništi odabir",
      noColorSelectedText: "Niti jedna boja nije odabrana",
      togglePaletteMoreText: "Više",
      togglePaletteLessText: "Manje"
  };

})( jQuery );

// Spectrum Colorpicker
// Hungarian (hu) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

var localization = $.spectrum.localization["hu"] = {
    cancelText: "Mégsem",
    chooseText: "Mentés",
    clearText: "A színválasztás visszaállítása",
    noColorSelectedText: "Nincs szín kijelölve",
    togglePaletteMoreText: "Több",
    togglePaletteLessText: "Kevesebb"
};

})( jQuery );

// Spectrum Colorpicker
// Indonesia/Bahasa Indonesia (id) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["id"] = {
      cancelText: "Batal",
      chooseText: "Pilih",
      clearText: "Hapus Pilihan Warna",
      noColorSelectedText: "Warna Tidak Dipilih",
      togglePaletteMoreText: "tambah",
      togglePaletteLessText: "kurangi"
  };

})( jQuery );

// Spectrum Colorpicker
// Italian (it) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["it"] = {
  cancelText: "annulla",
  chooseText: "scegli",
  clearText: "Annulla selezione colore",
  noColorSelectedText: "Nessun colore selezionato"
};

})( jQuery );

// Spectrum Colorpicker
// Japanese (ja) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ja"] = {
      cancelText: "中止",
      chooseText: "選択"
  };

})( jQuery );

// Spectrum Colorpicker
// Korean (ko) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ko"] = {
      cancelText: "취소",
      chooseText: "선택",
      clearText: "선택 초기화",
      noColorSelectedText: "선택된 색상 없음",
      togglePaletteMoreText: "더보기",
      togglePaletteLessText: "줄이기"
  };

})( jQuery );

// Spectrum Colorpicker
// Lithuanian (lt) localization
// https://github.com/liesislukas

(function ( $ ) {

  var localization = $.spectrum.localization["lt"] = {
      cancelText: "Atšaukti",
      chooseText: "Pasirinkti",
      clearText: "Išvalyti pasirinkimą",
      noColorSelectedText: "Spalva nepasirinkta",
      togglePaletteMoreText: "Daugiau",
      togglePaletteLessText: "Mažiau"
  };

})( jQuery );

// Spectrum Colorpicker
// Norwegian, Bokmål (nb-no) localization
// https://github.com/greendimka

(function ( $ ) {

  var localization = $.spectrum.localization["nb-no"] = {
      cancelText: "Avbryte",
      chooseText: "Velg",
      clearText: "Tilbakestill",
      noColorSelectedText: "Farge er ikke valgt",
      togglePaletteMoreText: "Mer",
      togglePaletteLessText: "Mindre"
  };

})( jQuery );

// Spectrum Colorpicker
// Dutch (nl-nl) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["nl-nl"] = {
      cancelText: "Annuleer",
      chooseText: "Kies",
      clearText: "Wis kleur selectie",
      togglePaletteMoreText: 'Meer',
      togglePaletteLessText: 'Minder'
  };

})( jQuery );

// Spectrum Colorpicker
// Polish (pl) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["pl"] = {
      cancelText: "Anuluj",
      chooseText: "Wybierz",
      clearText: "Usuń wybór koloru",
      noColorSelectedText: "Nie wybrano koloru",
      togglePaletteMoreText: "Więcej",
      togglePaletteLessText: "Mniej"
  };

})( jQuery );

// Spectrum Colorpicker
// Brazilian (pt-br) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["pt-br"] = {
      cancelText: "Cancelar",
      chooseText: "Escolher",
      clearText: "Limpar cor selecionada",
      noColorSelectedText: "Nenhuma cor selecionada",
      togglePaletteMoreText: "Mais",
      togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Portuguese (pt-pt) localization
// https://github.com/bgrins/spectrum

(function ( $ ) {

   var localization = $.spectrum.localization["pt-pt"] = {
      cancelText: "Cancelar",
      chooseText: "Escolher",
      clearText: "Limpar cor seleccionada",
      noColorSelectedText: "Nenhuma cor seleccionada",
      togglePaletteMoreText: "Mais",
      togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Russian (ru) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ru"] = {
      cancelText: "Отмена",
      chooseText: "Выбрать",
      clearText: "Сбросить",
      noColorSelectedText: "Цвет не выбран",
      togglePaletteMoreText: "Ещё",
      togglePaletteLessText: "Скрыть"
  };

})( jQuery );

// Spectrum Colorpicker
// Swedish (sv) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["sv"] = {
      cancelText: "Avbryt",
      chooseText: "Välj"
  };

})( jQuery );

// Spectrum Colorpicker
// Turkish (tr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["tr"] = {
  cancelText: "iptal",
  chooseText: "tamam"
};

})( jQuery );

// Spectrum Colorpicker
// Simplified Chinese (zh-cn) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["zh-cn"] = {
      cancelText: "取消",
      chooseText: "选择",
      clearText: "清除",
      togglePaletteMoreText: "更多选项",
      togglePaletteLessText: "隐藏",
      noColorSelectedText: "尚未选择任何颜色"
  };

})( jQuery );

// Spectrum Colorpicker
// Traditional Chinese (zh-tw) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["zh-tw"] = {
      cancelText: "取消",
      chooseText: "選擇",
      clearText: "清除",
      togglePaletteMoreText: "更多選項",
      togglePaletteLessText: "隱藏",
      noColorSelectedText: "尚未選擇任何顏色"
  };

})( jQuery );
/* 'use strict'; */

var szNavCustomType = "LEFT";
var szNavStyle;

//var SHOP_DOMAIN_ADDRESSS = 'http://m.civasatr4473.godomall.com';
var SHOP_DOMAIN_ADDRESSS = 'https://m.mall.pharmesthetic.com';

(function ($) {

  /*   szNavStyle = {
  
      init : function(){
      }
    };
    szNavStyle.init(); */

})(jQuery);

(function ($) {

  if (typeof $.prototype.setCursorPosition !== "function") {
    $.fn.setCursorPosition = function (pos) {
      console.log(pos)
      this.each(function (index, elem) {
        if (elem.setSelectionRange) {
          elem.setSelectionRange(pos, pos);
        } else if (elem.createTextRange) {
          var range = elem.createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          range.select();
        }
      });
    }
  }

  if (typeof String.prototype.replaceAll !== "function") {
    String.prototype.replaceAll = function (target, replacement) {
      return this.split(target).join(replacement);
    };
  }

  if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
      return this.replace(/(^\s*)|(\s*$)/gi, "");
    };
  }

  if (typeof String.prototype.comma !== "function") {
    String.prototype.comma = function () {
      return this.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof Number.prototype.comma !== "function") {
    Number.prototype.comma = function () {

      return this.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof String.prototype.fillStr !== "function") {
    String.prototype.fillStr = function (str, len) {
      var orgStr = this.toString();
      while (orgStr.toString().length < len) {
        orgStr = str + orgStr;
      }
      return orgStr;
    };
  }

  if (typeof String.prototype.left !== "function") {
    String.prototype.left = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(0, len);
    };
  }

  if (typeof String.prototype.right !== "function") {
    String.prototype.right = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(orgStr.length - len, orgStr.length);
    };
  }

  if (typeof String.prototype.isNull !== "function") {

    String.prototype.isNull = function () {
      try {
        var orgStr = this.toString();
        if (orgStr == undefined || orgStr == "undefined" || orgStr == null || orgStr == "null" || orgStr.length == 0 || orgStr == " ") return true;
        else return false;
      } catch (e) {
        return true;
      }
    };
  }

  if (typeof $.prototype.hasAttr !== "function") {
    $.prototype.hasAttr = function (name) {
      try {
        var attr = $(this).attr(name);
        if (typeof attr !== typeof undefined && attr !== false) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    };
  }

  var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
          this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
      }
      return output;
    },
    decode: function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9+/=]/g, "");
      while (i < input.length) {
        enc1 = this._keyStr.indexOf(input.charAt(i++));
        enc2 = this._keyStr.indexOf(input.charAt(i++));
        enc3 = this._keyStr.indexOf(input.charAt(i++));
        enc4 = this._keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      return output;
    }
  };

})(jQuery);


// 시큐어코딩으로 주석 후 수정 (2023-07-06 )
// function makeDateUUID() {

//   // ex : 14 61 20 90 04 27 72 7; : length = 15
//   // [년, 월, 일](4) + 요일(1) + 시간(2) + 분(2) + 초(2) + 밀리세컨드(2) + 랜덤숫자(2);
//   var date = new Date();
//   var year = date.getFullYear();
//   var month = String(date.getMonth() + 1);
//   var day = String(date.getDate());
//   var gday = String(date.getDay());
//   var hh = String(date.getHours()).fillStr(0, 2);
//   var mm = String(date.getMinutes()).fillStr(0, 2);
//   var dd = String(date.getMinutes()).fillStr(0, 2);
//   var ss = String(date.getSeconds()).fillStr(0, 2);
//   var ms = String(date.getMilliseconds()).fillStr(0, 2).left(2);
//   var seed = new Date().getTime();
//   seed = (seed*9301 + 49297) % 233280;

//   var rand = String(Math.floor(Math.random() * 100)).fillStr(0, 2);

//   var uuid = year + Number(month) + Number(day) + gday + hh + dd + ss + ms + rand;
//   if (uuid.length != 15) {
//     var size = 15 - uuid.length;

//     uuid += String(Math.floor(Math.random() * 10000000) + 1111111).left(size);

//   }
//   return uuid;
// }

// function makeDateUUID() {

//   // ex : 14 61 20 90 04 27 72 7; : length = 15
//   // [년, 월, 일](4) + 요일(1) + 시간(2) + 분(2) + 초(2) + 밀리세컨드(2) + 랜덤숫자(2);
//   var date = new Date();
//   var year = date.getFullYear();
//   var month = String(date.getMonth() + 1);
//   var day = String(date.getDate());
//   var gday = String(date.getDay());
//   var hh = String(date.getHours()).padStart(2, 0);
//   var mm = String(date.getMinutes()).padStart(2, 0);
//   var dd = String(date.getMinutes()).padStart(2, 0);
//   var ss = String(date.getSeconds()).padStart(2, 0);
//   var ms = String(date.getMilliseconds()).padStart(2, 0).substring(0, 2);
//   var seed = new Date().getTime();
//   seed = (seed*9301 + 49297) % 233280;

//   var rand = String(Math.floor(seed/233280.0 * 100)).padStart(2, 0);

//   var uuid = year + Number(month) + Number(day) + gday + hh + dd + ss + ms + rand;
//   if (uuid.length != 15) {
//     var size = 15 - uuid.length;

//     uuid += String(Math.floor(seed/233280.0 * 10000000) + 1111111).substring(0, size);

//   }
//   return uuid;
// }


function replacer(key, value) {
  if (!value)
    return undefined;

  return value;
}

function checkMobile() {

  // 모바일 전용
  //if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){

  // 모바일(태블릿 포함)
  if (navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
    return true;
  }

  return false;
}

function enableUploadComponent() {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  var result = false;
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") word = "msie ";
  // IE 11
  else if (agent.search("trident") > -1) word = "trident/.*rv:";
  // Microsoft Edge
  else if (agent.search("edge/") > -1) word = "edge/";
  // 그외, IE가 아니라면 ( If it's not IE or Edge )
  else return true;

  var reg = new RegExp(word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})");
  if (reg.exec(agent) != null) {
    if (parseFloat(RegExp.$1 + RegExp.$2) > 10) return true;
    else return false;
  }
  return true;
}

function initPageContentMinHeight() {
  var headerHeight = 0;
  if ($(".navbar-header").height() == null) headerHeight = 55;
  else headerHeight = $(".navbar-header").height();

  var checkPageInterval = setInterval(function () {
    var offset = $(".page ").eq(0).offset();
    if (offset != undefined) {
      $(".page ").eq(0).css("min-height", $(window).height() - offset.top);
      clearInterval(checkPageInterval);
    }

  }, 300);

}

function initViewLoadedInputBoxStyle() {

  var timerCount = 0;
  var timer = setInterval(function () {
    var input = $(".form-inner-label input");

    if ($(input).length == 0) {
      timerCount++;
      if (timerCount == 5) clearInterval(timer);
    } else {
      clearInterval(timer);
      for (var i = 0; i < input.length; i++) {
        var id = $(input).eq(i).attr("id");
        var convId = '';
        if (id == null) id = $(input).eq(i).attr("ng-model");
        if (id == null) continue;
        id = id.split(".");
        for (var j = 0; j < id.length; j++)
          convId += id[j].charAt(0).toUpperCase() + id[j].substring(1, id[j].length);
        convId = convId + "_" + i;
        if ($(input).eq(i).attr("id") != "" && $(input).eq(i).attr("id") != undefined) {
          convId = $(input).eq(i).attr("id");
        }
        var placeholder = "";
        if ($(input).eq(i).next().length > 0 && $(input).eq(i).next().get(0).tagName.toLowerCase() == "label") {
          $(input).eq(i).next().attr("for", convId);
          $(input).eq(i).attr("id", convId);
          $(input).eq(i).attr("placeholder", " ");
          continue;
        } else if ($(input).eq(i).attr("placeholder") != "" && $(input).eq(i).attr("placeholder") != undefined) {
          placeholder = $(input).eq(i).attr("placeholder");
        } else if ($(input).eq(i).prev().get(0) && $(input).eq(i).prev().get(0).tagName.toLowerCase() == "label") {
          placeholder = $(input).eq(i).prev().get(0).textContent;
          $(input).eq(i).prev().detach();
        }
        $(input).eq(i).attr("id", convId);
        $(input).eq(i).attr("placeholder", " ");
        var label = $("<label>" + placeholder + "</label>", { for: convId, class: "ng-binding", "uib-tooltip": placeholder });
        $(input).eq(i).after(label.clone());
        $(input).eq(i).next().attr("for", convId);
      }
    }
  }, 500);
}

function initLabelTitle() {
  setTimeout(function () {
    var label = $(".pagecontent label");
    for (var i = 0; i < label.length; i++) {
      if (!$(label).eq(i).attr("title") && $(label).eq(i).attr("title") != '') {
        $(label).eq(i).attr("uib-tooltip", $(label).eq(i).text());
        $(label).eq(i).removeAttr("title", $(label).eq(i).text());
      }
    }
  }, 500);
}

// function initSzRequired() {
//   var timerCount = 0;
//   var timer = setInterval(function(){
//     var label = $("[sz-required]");
//     if( $(label).length == 0 ) {
//       timerCount++;
//       if(timerCount == 5) clearInterval(timer);
//     } else {
//       clearInterval(timer);
//       for(var i = 0; i < label.length; i++) {
//         var $label = $(label).eq(i);
//         var tx = $label.text();
//         if(tx.charAt(0) != "*") {
//           $label.text("*" + tx);
//         }
//       }
//     }
//   }, 800);
// }

function chekValidData() {
  var label = $("[sz-required]");
  var errorMsg = "";
  for (var i = 0; i < label.length; i++) {
    var $at = $(label).eq(i).closest("div");
    var labelNm = $(label).eq(i).text().trim();
    var $input = $at.find("input");
    var $select = $at.find("select");
    var $textarea = $at.find("textarea");
    var type = $input.attr("type");
    if ($input.length > 0) {
      if (type == "radio") {
        var name = $input.attr("name");
        var val = $(':radio[name="' + name + '"]:checked').val();
        if (isNullOrEmpty(val)) {
          errorMsg += labelNm + "을 선택하여주세요.</br>";
        }
      } else if (type == "checkbox") {


      } else if (type == "text") {
        var val = $input.val();
        if (isNullOrEmpty(val)) {
          if ($input.hasAttr("uib-datepicker-popup")) {
            errorMsg += labelNm + "를 선택해주세요.</br>";
          } else {
            errorMsg += labelNm + "을 작성하여주세요.</br>";
          }
        }
      }
    } else if ($select.length > 0) {
      var val = $at.find("select option:selected").val();
      if (isNullOrEmpty(val)) {
        errorMsg += labelNm + "를 선택해주세요.</br>";
      }
    } else if ($textarea.length > 0) {
      var val = $textarea.val();
      if (isNullOrEmpty(val)) {
        errorMsg += labelNm + "을 작성하여주세요.</br>";
      }
    }
  }

  if (errorMsg == "") {
    var p = {
      result: true
    }
    return p;
  } else {
    var p = {
      result: false,
      errorMsg: errorMsg
    }
    return p;
  }

  return false;
}

function uploadVaultFile(vault) {
  if (vault != null) {
    vault.uploader.send();
    //    vault.data.upload();
  }
}

function initVaultComponent(id, callback, bOpenApi, exts) {
  var korean = {
    add: "파일추가",
    browse: "파일찾기",
    cancel: "취소",
    clear: "초기화",
    clearAll: "전체 초기화",
    download: "다운로드",
    dragAndDrop: "",
    filesOrFoldersHere: "여러 개의 첨부 파일을 마우스로 끌어놓으세요.",
    or: "",
    upload: ""
  };
  var sessionStorage = window.sessionStorage;
  var userkey = sessionStorage.getItem("userkey") + '-' + sessionStorage.getItem("loginTenantId");
  var iCheck = 0;

  var checkVaultInterval = setInterval(function () {
    if (iCheck > 10) {
      clearInterval(checkVaultInterval);
      return;
    }
    iCheck++;
    if ($('#' + id).length > 0) {
      clearInterval(checkVaultInterval);
      var vault = new dhx.Vault(id, {
        mode: "list",
        uploader: {
          target: API_HTTP_PROTOCOL + "//" + API_SERVER_DOMAIN + ":" + API_SERVER_PORT + (bOpenApi ? "/openapi" : "") + "/attach/temp/upload.do?userkey=" + userkey,
          autosend: false,
          multiple: true,
          accept: ".*"
        }
      });

      var activeCheck = "mp3, mp4, doc, docx, xls, xlsx, ppt, pptx, hwp, pdf, txt, gul, jpg, gif, png, bmp, dib, tif, tiff, zip, alz, rar, 7z, mm, dwg, dxf";//확장자 제한
      if (exts) {
        activeCheck = exts;
      }
      var sizeLimit = 104857600; // 100mb 제한
      var filesCountValue = document.getElementById("files-count-value");
      var filesSizeValue = document.getElementById("files-size-value");
      var filesSizeText = document.getElementById("files-size-text");
      var maxUploadFileCnt = 20;
      var isErrMaxUploadFileCnt = false;
      vault.events.on("beforeAdd", function (item) {
        if (vault.data.getLength() >= maxUploadFileCnt) {
          if (!isErrMaxUploadFileCnt) {
            alert("파일 첨부는 최대 20개 까지만 가능합니다.");
            isErrMaxUploadFileCnt = true;
          }
          return false;
        }
        var extension = item.file.name.split(".").pop();
        var size = item.file.size;
        var predicate = activeCheck.indexOf(extension.toLowerCase()) > -1 && size < sizeLimit;
        if (!predicate) {
          alert(activeCheck + " 파일만 가능합니다.");
          var $obj = $(".dhx-dropable-area.drop-files-here");
          $obj.closest(".layout_y").removeClass('dhx-dragin');
        }
        return predicate;
      });
      vault.events.on("AfterAdd", function (item) {
        vault.toolbar.hide("upload");
      });

      vault.events.on("UploadFile", function (file) {
        // console.log(file);
        //alert(file.fileDuplication);
        //alert(file.file.name);
      });
      vault.events.on("uploadComplete", function (data) {
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].responseVO != null) {
              var result = {};
              result.header = data[i].responseVO.header;
              result.body = data[i].responseVO.body;

              callback.onFileUploaded(id, result);
            }
          }
        }

        callback.onFileUploadComplete(id);
        vault.data.removeAll(); // 초기화
      });
      dhx.i18n.setLocale('vault', korean);

      if (callback)
        callback.onLoaded(id, vault);
    }
  }, 100);
}

function initVaultComponentForMMSImg(id, callback, bOpenApi) {
  var korean = {
    add: "파일추가",
    browse: "파일찾기",
    cancel: "취소",
    clear: "초기화",
    clearAll: "전체 초기화",
    download: "다운로드",
    dragAndDrop: "",
    filesOrFoldersHere: "jpg 파일을 마우스로 끌어놓으세요.",
    or: "",
    upload: ""
  };
  var sessionStorage = window.sessionStorage;
  var userkey = sessionStorage.getItem("userkey") + '-' + sessionStorage.getItem("loginTenantId");
  var iCheck = 0;

  var checkVaultInterval = setInterval(function () {
    if (iCheck > 10) {
      clearInterval(checkVaultInterval);
      return;
    }
    iCheck++;
    if ($('#' + id).length > 0) {
      clearInterval(checkVaultInterval);
      var vault = new dhx.Vault(id, {
        mode: "list",
        uploader: {
          target: API_HTTP_PROTOCOL + "//" + API_SERVER_DOMAIN + ":" + API_SERVER_PORT + (bOpenApi ? "/openapi" : "") + "/attach/temp/upload.do?userkey=" + userkey,
          autosend: false,
          multiple: false,
          accept: ".jpg"
        }
      });

      var activeCheck = "jpg";//확장자 제한
      var sizeLimit = 300000; // 300kb 제한
      var filesCountValue = document.getElementById("files-count-value");
      var filesSizeValue = document.getElementById("files-size-value");
      var filesSizeText = document.getElementById("files-size-text");
      var maxUploadFileCnt = 1;
      var isErrMaxUploadFileCnt = false;
      vault.events.on("beforeAdd", function (item) {
        if (vault.data.getLength() >= maxUploadFileCnt) {
          if (!isErrMaxUploadFileCnt) {
            alert("하나의 파일만 첨부할 수 있습니다.");
            isErrMaxUploadFileCnt = true;
          }
          return false;
        }
        var extension = item.file.name.split(".").pop();
        var size = item.file.size;
        var predicate = activeCheck.indexOf(extension.toLowerCase()) > -1 && size < sizeLimit;
        if (!predicate) {
          alert(activeCheck + " 파일만 가능합니다.");
          var $obj = $(".dhx-dropable-area.drop-files-here");
          $obj.closest(".layout_y").removeClass('dhx-dragin');
        }
        return predicate;
      });
      vault.events.on("AfterAdd", function (item) {
        vault.toolbar.hide("upload");
      });

      vault.events.on("UploadFile", function (file) {
        // console.log(file);
        //alert(file.fileDuplication);
        //alert(file.file.name);
      });
      vault.events.on("uploadComplete", function (data) {
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].responseVO != null) {
              var result = {};
              result.header = data[i].responseVO.header;
              result.body = data[i].responseVO.body;

              callback.onFileUploaded(id, result);
            }
          }
        }

        callback.onFileUploadComplete(id);
        vault.data.removeAll(); // 초기화
      });
      dhx.i18n.setLocale('vault', korean);

      if (callback)
        callback.onLoaded(id, vault);
    }
  }, 100);
}

function setBreakPoint(obj) {
  var size = ['xs', 'sm', 'md', 'lg', 'xl'];
  for (var i = 0; i < size.length; i++) {
    if (obj != "" && size[i] == obj) {
      obj = "";
      for (var j = 0; j < i; j++) obj += size[j] + " ";
    }
  }
  return obj;
}


function initFootableEvent(vm, ft, callback) {
  var $el = ft.$el;
  var key = ft.o.key;
  var row = ft.o.rows;
  var $tr = $el.find("tbody tr");
  var link = ft.o.link;
  var srch = ft.o.srch;
  var FreeBoardId = ft.o.FreeBoardId;
  $tr.find("td").css("cursor", "pointer");
  for (var i = 0; i < $tr.length; i++) {
    $tr.eq(i).attr("data-key", row[i][key]);
    $tr.eq(i).attr("data-idx", i);
  }

  $tr.bind("click", function () {
    if ($(this).find(".footable-toggle").length == 0) {
      srch[key] = $(this).attr("data-key");
      var localStorage = window.localStorage;
      var dockMode = localStorage.getItem("dockMode");

      var type = { v: "vertical", h: "horizon", d: "default" };
      if (dockMode == null || dockMode == type.d) {
        //        console.log(location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId);
        location.hash = "app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId;
        //        ft.o.ctrState.go(link, {srch : encodeURIComponent(JSON.stringify(srch, replacer)), FreeBoardId:FreeBoardId });
      } else {

        /*  var e ={}
         e.ft = ft;
         e.dockMode = dockMode;
         e.eventState = "click";
         callback(e); */
        var url = location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/" + FreeBoardId;
        if (dockMode == type.v) {

          $("#dockTop iframe").attr("src", url);
        } else {
          //console.log("clci");
          $("#dockbottom iframe").attr("src", url);
        }
      }
    }
  });
}

function setDockView($compile, $scope, mode, callback) {
  // mode 대신 필요한 정보를 object 형식으로 받을 수 있도록 수정 필요
  var setDocViewInterval = setInterval(function () {


    var $docWrap = $("#dockWrap");

    if ($docWrap.length > 0) {

      var $docBackup = $("#dockBackupWrap");

      clearInterval(setDocViewInterval);
      var type = { v: "vertical", h: "horizon", d: "default" };
      var localStorage = window.localStorage;
      if (mode.type == null) localStorage.setItem("dockMode", "default");
      else localStorage.setItem("dockMode", mode.type);

      if ($docBackup.length == 0) {
        $docWrap.after("<div id='dockBackupWrap'></div>");
        $docBackup = $("#dockBackupWrap");
        $docBackup.append($docWrap.children().clone(true, true, true));
      }
      var $docWrapChild = $docBackup.children().clone(true, true, true);
      $("#dockWrap").empty().html('');
      if (mode.type == null || mode.type == type.d) {
        //$("#dockWrap").append("<div id='dockLeft' dock=\"'left'\"><div class='dock-content'></div></div>");
      } else if (mode.type == type.v) {
        $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-ref=\"\" dock-resizable ><div class='dock-content'></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\" ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");


      } else {
        // $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-resizable><div class='dock-content'></div></div>");

        $("#dockWrap").append("<div id='dockbottom' dock=\"'bottom'\" dock-resizable ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\"     ><div class='dock-content'></div></div>");

      }

      var $view = { l: $("#dockLeft"), t: $("#dockTop"), b: $("#dockbottom") };
      var offset = $docWrap.offset();
      var viewHeight = $(window).height() - (offset.top + 5);
      if (mode.type == null || mode.type == type.d) {

      } else {

        //console.log(offset.top, $(window).height())

        $docWrap.css("height", viewHeight);
      }
      $docWrap.attr("dock-ref", "");

      if (mode.type == null || mode.type == type.d) {
        /*  $view.l.css("width","100%");
         $view.l.css("height","100%"); */
      } else if (mode.type == type.v) {
        $view.l.css("width", "50%");
        $view.t.css("height", "100%");
      } else {
        $("#dockbottom").css("height", viewHeight / 2);
      }

      $compile($docWrap)($scope);

      if (mode.type == null || mode.type == type.d) {
        //$("#dockLeft .dock-content").append($docWrapChild);
        $("#dockWrap").empty().html($docWrapChild);
      } else if (mode.type == type.v) {
        $("#dockLeft .dock-content").append($docWrapChild);
      } else {
        $("#dockTop .dock-content").append($docWrapChild);
      }

      callback();

    }
  }, 500);

}


/**
 * Null or Empty 검사
 * !value 하면 생기는 논리적 오류를 제거하기 위해 명시적으로 value == 사용 [], {} 도 빈값으로 처리
 * @param value - 검사할 값
 * @return true or false
 */
function isNullOrEmpty(value) {
  return value === "" || value === " " || value === '0.00' || value === null || value === undefined || value === "NULL" || (value != null && typeof value === "object" && !Object.keys(value).length);
}

/**
 * Email 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidEmail(value) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(value);
}

/**
 * 날짜 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidDate(value) {
  return value instanceof Date && !isNaN(value) && value != undefined;
}

function fnOpenLayer(width) {
  //console.log($(".search-detail-wrap"));
  var srchBg = $("<div />", { class: "list-srch-bg-wrap", onClick: "fnCloseLayer()" });
  var position = $(".search-detail-wrap").css('position');

  var pos = position == 'absolute' ? $(".search_layer").position() : $(".search_layer").offset();
  var h = $(".search_layer").height();

  setTimeout(function () {
    $(".search-detail-wrap").css("left", (pos.left) + 10);
    $(".search-detail-wrap").css("top", (pos.top) + 31);
    if (width) {
      $(".search-detail-wrap").css("width", width);
    }

    if ($(".search-detail-wrap").is(":visible")) {
      $(".search-detail-wrap").hide();
      $(".list-srch-bg-wrap").detach();
    } else {
      $(".search-detail-wrap").show();
      $("body").append(srchBg.clone());
    }
  }, 1);

  return false;
}

function fnCloseLayer() {
  $(".search-detail-wrap").hide();
  $(".list-srch-bg-wrap").detach();
  return false;
}

function date2str(x, y) {
  var z = {
    M: x.getMonth() + 1,
    d: x.getDate(),
    h: x.getHours(),
    m: x.getMinutes(),
    s: x.getSeconds()
  };
  y = y.replace(/(M+|d+|h+|m+|s+)/g, function (v) {

    // 시큐어코딩으로 주석 후 수정 (2023-07-06 )
    // return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-2);
    return ((v.length > 1 ? "0" : "") + z[v.slice(-1)]).slice(-2);

  });

  return y.replace(/(y+)/g, function (v) {
    return x.getFullYear().toString().slice(-v.length);
  });
}

function getSearchConditionStr(count, columnMap, srch) {

  // count가 object형으로 전달되는 경우 값 변환 처리 
  var countStr = 0;

  if (Array.isArray(count)) {
    countStr = count;
  } else {
    if (typeof count == "object" || typeof count == "array") {
      countStr = count.totalItems;
    } else {
      countStr = count;
    }
  }

  var searchConditionStr = '<b>검색결과 <font color=red>' + Number(countStr).toLocaleString('en') + '</font>건</b> ';

  if (!columnMap) return;

  var str = [];
  for (var key in srch) {
    if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
      continue;

    var name = key;
    var value = srch[key];

    if (columnMap[key] && srch[key]) {
      name = columnMap[key].ColumnLogicalNm;

      if (columnMap[key].ColumnLogicalDataType == "50" || columnMap[key].ColumnLogicalDataType == "select") {
        if (columnMap[key].CodeList) {
          columnMap[key].CodeList.forEach(function (v) {
            if (v.Code == value) {
              value = v.CodeValue;
              return;
            }
          });
        }
      }

      str.push(name + ':' + value);
    }
  }

  searchConditionStr += str.join(',');

  return searchConditionStr;
}

function getCodeValue(CodeList, CodeValue) {

  if (CodeList == null) {
    if (isNullOrEmpty(CodeValue)) {
      return ""
    } else {
      return CodeValue;
    }
  }
  if (CodeList == null || CodeValue == null) {
    return "";
  }

  for (var i = 0; i < CodeList.length; i++) {
    if (CodeList[i].Code == CodeValue) {
      return CodeList[i].CodeValue;
    }
  }

  if (isNullOrEmpty(CodeValue)) {
    return ""
  } else {
    return CodeValue;
  }
}

var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);

    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;

      if (isNaN(r)) {
        u = a = 64;
      }
      else if (isNaN(i)) {
        a = 64;
      }

      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
    }

    return t;
  },
  decode: function (e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");

    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);

      if (u != 64) {
        t = t + String.fromCharCode(r);
      }

      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }

    t = Base64._utf8_decode(t);

    return t;
  },
  _utf8_encode: function (e) {
    e = e.replace(/rn/g, "n");
    var t = "";

    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);

      if (r < 128) {
        t += String.fromCharCode(r);
      }
      else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      }
      else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }

    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;

    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      }
      else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      }
      else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

function binary2text(encodedString) {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") {
    console.log("Microsoft Internet Explorer (IE 10 or Lower)");
    word = "msie ";
    return Base64.decode(encodedString);
  } else if (agent.search("trident") > -1) {
    word = "trident/.*rv:";
    // Microsoft Edge
  } else if (agent.search("edge/") > -1) {
    word = "edge/";
    // 그외, IE가 아니라면 ( If it's not IE or Edge )
  } else {
  }

  //  return atob(encodedString);

  return Base64.decode(encodedString);
}

function drawWordCloud(data, divId) {
  var weight = 3,   // change me
    width = $("#" + divId).width(),
    height = 300;

  //  var data = [{text:'word', size:100},{text:'cloud', size:50},{text:'워드', size:50}];

  var fill = d3.scale.category20();
  d3.layout.cloud().size([width, height]).words(data)
    //.rotate(function() { return ~~(Math.random() * 2) * 90; })
    .rotate(0)
    .font("Impact")
    .fontSize(function (d) { return d.size; })
    .on("end", draw)
    .start();

  function draw(words) {
    d3.select("svg").selectAll("text")
      .style("font-size", function (d, i) { });

    d3.select("#" + divId)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
      .selectAll("text")
      .data(words)
      .enter().append("text")
      .style("font-size", function (d) { return d.size + "px"; })
      .style("font-family", "Impact")
      .style("fill", function (d, i) { return fill(i); })
      .attr("text-anchor", "middle")
      .attr("transform", function (d) {
        return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
      })
      .text(function (d) { return d.text; });
  }
}

function sendFcmPush(token, title, msg) {
  var data = {
    "to": token,
    //"cMLEkZLoa8A:APA91bEBFw_czN996Uw1-AbBt1TZJhWqCxuqztqUXpy6EMv5bvRWQ4aVs0T6FqmskOfnTIQx4jrbqBsmuLJ4MNIZLWHfLVbIDlVk6aaru4_60XDx96NJYApqC4kooBGWjWwn65DAt1bY",
    // "notification" : {
    //     "title" : title,
    //     "body" : msg
    // },
    "data": {
      "title": title,
      "body": msg
    }
  };
  var xhr = new XMLHttpRequest();
  xhr.open("POST", "https://fcm.googleapis.com/fcm/send", true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader('Authorization', "key=AAAAgytJrAI:APA91bEeI8izlKCisv3HjqnALEOdGsoLf4OfkRlTB86CJYlIfBzHU7iMqzfnVisk9iDmHXJ5ZrBJSV0yp-e06luFmVqFavQRx5GeePS4JhZKmR3QT0fscdFd4btwEKDaGb6IWqeQ91hq");
  xhr.send(JSON.stringify(data));
}


function sendFcmData(token, title, msg) {
  var data = {
    "to": token,
    "data": {
      "title": title,
      "body": msg
    }
  };
  var xhr = new XMLHttpRequest();
  xhr.open("POST", "https://fcm.googleapis.com/fcm/send", true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader('Authorization', "key=AAAAgytJrAI:APA91bEeI8izlKCisv3HjqnALEOdGsoLf4OfkRlTB86CJYlIfBzHU7iMqzfnVisk9iDmHXJ5ZrBJSV0yp-e06luFmVqFavQRx5GeePS4JhZKmR3QT0fscdFd4btwEKDaGb6IWqeQ91hq");
  xhr.send(JSON.stringify(data));
}

/**
 * 이메일 형식 체크
 * 
 * @param 데이터
 */
function emailCheck(email) {
  var exptext = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;

  if (exptext.test(email) == false) {
    // 이메일 형식이 알파벳+숫자@알파벳+숫자.알파벳+숫자 형식이 아닐경우
    //alert("이메일형식이 올바르지 않습니다.");
    return false;
  }

  return true;
}

/**
 * 특수문자 여부 체크
 * 
 * @param 데이터
 */
function checkSpecial(str) {
  var special_pattern = /[`~!@#$%^&*|\\\'\";:\/?]/gi;
  if (special_pattern.test(str) == true) {
    return 0;
  } else {
    return -1;
  }
}

/**
 * 전화번호 포맷으로 변환
 * 
 * @param 데이터
 */
function formatPhone(phoneNum) {
  if (!isMobile(phoneNum)) {
    var rtnNum;
    var regExp = /(02)([0-9]{3,4})([0-9]{4})$/;
    var myArray;
    if (regExp.test(phoneNum)) {
      myArray = regExp.exec(phoneNum);
      rtnNum = myArray[1] + '-' + myArray[2] + '-' + myArray[3];
      return rtnNum;
    } else {
      regExp = /(0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
      if (regExp.test(phoneNum)) {
        myArray = regExp.exec(phoneNum);
        rtnNum = myArray[1] + '-' + myArray[2] + '-' + myArray[3];
        return rtnNum;
      } else {
        return phoneNum;
      }
    }
  } else {
    return phoneNum;
  }
}

/**
 * 핸드폰번호 포맷으로 변환
 * 
 * @param 데이터
 */
function formatMobile(phoneNum) {
  if (isMobile(phoneNum)) {
    var rtnNum;
    var regExp = /(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/;
    var myArray;
    if (regExp.test(phoneNum)) {
      myArray = regExp.exec(phoneNum);
      rtnNum = myArray[1] + '-' + myArray[2] + '-' + myArray[3];
      return rtnNum;
    } else {
      return phoneNum;
    }
  } else {
    return phoneNum;
  }
}

/**
 * 전화번호 형식 체크
 * 
 * @param 데이터
 */
function isTel(phoneNum) {
  //var regExp =/(02|0[3-9]{1}[0-9]{1})[1-9]{1}[0-9]{2,3}[0-9]{4}$/;
  var regExp = /(02)([0-9]{3,4})([0-9]{4})$/;
  var myArray;
  if (regExp.test(phoneNum)) {
    myArray = regExp.exec(phoneNum);
    //   console.log(myArray[1]);
    //   console.log(myArray[2]);
    //   console.log(myArray[3]);
    return true;
  } else {
    regExp = /(0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
    if (regExp.test(phoneNum)) {
      myArray = regExp.exec(phoneNum);
      //    console.log(myArray[1]);
      //    console.log(myArray[2]);
      //    console.log(myArray[3]);
      return true;
    } else {
      return false;
    }
  }
}

/**
 * 핸드폰번호 형식 체크
 * 
 * @param 데이터
 */
function isMobile(phoneNum) {
  var regExp = /(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/;
  var myArray;
  if (regExp.test(phoneNum)) {
    myArray = regExp.exec(phoneNum);
    //   console.log(myArray[1]);
    //   console.log(myArray[2]);
    //   console.log(myArray[3]);
    return true;
  } else {
    return false;
  }
}

/* 	Native Api 정의
───────────────────────────────────────────────────────────────*/
// Native 연결
var _jsConNative = {setWebViewLoadingBar : function(progressNum){alert(progressNum)}}

// Native Recive Value
var reciveNativeData = -1;
var reciveNativeDataIntervalID;

function _jsResetND(){reciveNativeData = -1;}
function _jsSetND(param){reciveNativeData = param;}
function _jsGetND(){return reciveNativeData;}
function _jsCheckND(){var temp;}
function _jsCheckNDInterval(){
	if(_jsGetND() != -1){
		var temp = _jsGetND();
		_jsResetND();
		return temp;
	}else return -1;
}

Native = {};

Native.app = window.app;
Native.device = window.device;
Native.res = window.res;
Native.http = window.http;
Native.album = window.album;
Native.contact = window.contact;
Native.media = window.media;
Native.beacon = window.beacon;
Native.parser = window.parser;
Native.data = window.data;
Native.admob = window.admob;
Native.account = window.account;
Native.permission = window.permission;
Native.qrcode = window.qrcode;
Native.gmail = window.gmail;
Native.page = window.page;
Native.websocket = window.websocket;
Native.fcm = window.fcm;

/* 	Native와의 통신
───────────────────────────────────────────────────────────────*/

var M = {
	onCreate : function(){try{ appOnCreate();} catch(ex) {
		console.log('Error:', ex);
	}},
	onStart : function(){try{ appOnStart();} catch(ex) {
		console.log('Error:', ex);
	}},
	onResume : function(){try{ appOnResume();} catch(ex) {
		console.log('Error:', ex);
	}},
	onPause : function(){try{ appOnPause();} catch(ex) {
		console.log('Error:', ex);
	}},
	onStop : function(){try{ appOnStop();} catch(ex) {
		console.log('Error:', ex);
	}},
	onDestroy : function(){try{ appOnDestroy();} catch(ex) {
		console.log('Error:', ex);
	}},
	onBack :function(){try{ appOnBack(); } catch(ex) { history.back(); }}
};



/*──────────────────────────────────────────*/

M.page = {};
M.page.newPage = function(data) {
	Native.page.newPage(data);
}
M.page.closeTopPage = function() {
	Native.page.closeTopPage();
}

M.permission = {};

M.permission.checkPermission = function(data){

	//account, 
	return Native.permission.checkPermission(data);
}

M.permission.phoneState = function(data) {
	Native.permission.phoneState();
	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
        data.onSuccess(stemp);
			}
		}
	}, 1000);
}

M.permission.storage = function(data) {
	Native.permission.storage();
	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
        data.onSuccess(stemp);
			}
		}
	}, 1000);
}


M.permission.callLog = function(data) {
	Native.permission.callLog();
	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
		         data.onSuccess(stemp);
			}
		}
	}, 1000);
}

M.permission.account = function(data) {
	Native.permission.account();
	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
		         data.onSuccess(stemp);
			}
		}
	}, 1000);
}

M.permission.camera = function(data) {
	 Native.permission.camera()

	 reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
		         data.onSuccess(stemp);
			}
		}
	}, 1000);
}

M.permission.overlay = function(data) {
	Native.permission.overlay();
	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			if(typeof data.onSuccess === 'function') {
		         data.onSuccess(stemp);
			}
		}
	}, 1000);
}

M.account = {}
M.account.getAccounts = function(data) {

	// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
	// var jsonObj = eval("(" + Native.account.getAccounts() +")");
	var jsonObj = JSON.parse(Native.account.getAccounts());
	return Native.account.getAccounts();
}

M.app = {}
M.app.check = function() 
{
	var checkApplication = false;
	try
	{
		checkApplication = Native.app.check();
	} catch(ex) {
		checkApplication = false;
	}

	return checkApplication;
}

M.app.splashDetach = function() {

	if(M.app.check()) Native.app.splashDetach();
}

M.app.info = function(data) {

	// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
	// var jsonObj = eval("(" + Native.app.getApp("NULL") +")");
	var jsonObj = JSON.parse(Native.app.getApp("NULL"));
	return jsonObj;
}

M.app.getAppVersion = function() {
	try {
		var ver = Number(Native.app.getAppVersion());
		return ver;
	} catch(e) {
		return 1;
	}
}

M.app.getAppAuthKey = function(data) {
	mAppAuthKey = Native.app.getAppAuthKey("NULL");
}

M.app.update = function(url) {
	Native.app.update(url);
}

M.fcm = {};
M.fcm.getFcmKey = function() {
  return Native.fcm.getFcmKey();
}

/*──────────────────────────────────────────*/

// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
// M.device = {};
// M.device.getInfo = function() {
// 	var jsonObj = eval("(" + Native.device.getInfo() +")");
// 	return jsonObj;
// }
M.device = {};
M.device.getInfo = function() {
    var jsonObj = JSON.parse(Native.device.getInfo());
    return jsonObj;
}

// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
// M.device.info = function(data) {
// 	var jsonObj = eval("(" + Native.app.getApp("NULL") +")");
// 	return jsonObj;
// 	//Native.app.getDevice("NULL");
// }
M.device.info = function(data) {
    var jsonObj = JSON.parse(Native.app.getApp("NULL"));
    return jsonObj;
}



M.device.memory = function (data) {

}

/*──────────────────────────────────────────*/
M.res = function(data) {
	var minData = JSON.stringify(data);
	Native.res(minData);
};

/*M.http = function(data) {
	var minData = JSON.stringify(data);
	Native.http.send(minData);
};*/
/*──────────────────────────────────────────*/
M.http = {};
M.http.send = function (data)
{
	var minData = JSON.stringify(data);
	Native.http.send(minData);
}
/*──────────────────────────────────────────*/
M.data = {};
M.data.setLocal = function(key, value){Native.data.setLocal(key, value);}
M.data.setSession = function(key, value){Native.data.setSession(key, value);}
M.data.setStorage = function(key, value){Native.data.setStorage(key, value);}
//---------------
M.data.getLocal = function(key){return Native.data.getLocal(key);}
M.data.getSession = function(key){return Native.data.getSession(key);}
M.data.getStorage = function(key){return Native.data.getStorage(key);}
//---------------
M.data.removeLocal = function(key, value){Native.data.removeLocal(key);}
M.data.removeSession = function(key, value){Native.data.removeSession(key);}
M.data.removeStorage = function(key, value){Native.data.removeStorage(key);}
//---------------
M.data.removeAllLocal = function(){Native.data.removeLocal();}
M.data.removeAllSession = function(){Native.data.removeSession();}
M.data.removeAllStorage = function(){Native.data.removeStorage();}

M.data.fncKey = function(){return Native.data.fncKey()}
M.data.getUuid = function(){return Native.data.getUuid()}
/*──────────────────────────────────────────*/
M.parser = {};
M.parser.getPage = function(data)
{
	var minData = JSON.stringify(data);
	var reciveData = Native.parser.getPage(minData);

	// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
	// var jsonObj = eval("(" + reciveData +")");
	var jsonObj = JSON.parse(reciveData);
	data.onSuccess(jsonObj);
}
/*──────────────────────────────────────────*/
// Media
M.media = {}
M.media.getData = function(data)
{
	var minData = JSON.stringify(data);
	
	Native.media.getData(minData);

	reciveNativeDataIntervalID = setInterval(function(){
		var stemp = _jsCheckNDInterval();
		if(stemp != -1)
		{
			clearInterval(reciveNativeDataIntervalID);
			stemp = stemp.replaceAll("\n","//n")

			// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
			// var jsonObj = eval("(" + stemp +")");
			var jsonObj = JSON.parse(stemp);

			if(typeof data.onSuccess === 'function') {
		       data.onSuccess(jsonObj);
			}
		}
	}, 1000);

}

M.websocket = {};
M.websocket.initWebSocket = function() {
  Native.websocket.initWebSocket();
}

M.album = {};
M.album.getPhoto = function(data)
{
	var minData = JSON.stringify(data);
	Native.album.getPhoto(minData);	
}
/*──────────────────────────────────────────*/
M.contact = {};
M.contact.getContact = function(data)
{
	if(data == undefined) 
	{
		// 시큐어코딩으로 주석 후 수정 (2023-07-05 )
		// var jsonObj = eval("(" + Native.contact.getContact() +")");
		var jsonObj = JSON.parse(Native.contact.getContact());
		
		/*alert(jsonObj.list[0].name);
		alert(jsonObj.list.length);*/
		return Native.contact.getContact();
	}
	else Native.contact.getContact(minData);
}


/*
@license

dhtmlxVault v.3.0.0 Professional

This software is covered by DHTMLX Enterprise License.
Usage without proper license is prohibited.

(c) Dinamenta, UAB.

*/
if (window.dhx){ window.dhx_legacy = dhx; delete window.dhx; }(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dhx"] = factory();
	else
		root["dhx"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/codebase/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom = __webpack_require__(43);
exports.el = dom.defineElement;
exports.sv = dom.defineSvgElement;
exports.view = dom.defineView;
exports.create = dom.createView;
exports.inject = dom.injectView;
function disableHelp() {
    dom.DEVMODE.mutations = false;
    dom.DEVMODE.warnings = false;
    dom.DEVMODE.verbose = false;
    dom.DEVMODE.UNKEYED_INPUT = false;
}
exports.disableHelp = disableHelp;
function resizer(handler) {
    return exports.el("iframe", {
        _hooks: {
            didInsert: function (node) {
                var activeHandler = function () {
                    var height = node.el.offsetHeight;
                    var width = node.el.offsetWidth;
                    handler(width, height);
                };
                node.el.contentWindow.onresize = activeHandler;
                activeHandler();
            }
        },
        style: "position:absolute;left:0;top:-100%;width:100%;height:100%;margin:1px 0 0;border:none;opacity:0;visibility:hidden;pointer-events:none;",
    });
}
exports.resizer = resizer;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(37);
function toNode(node) {
    if (typeof node === "string") {
        node = (document.getElementById(node) || document.querySelector(node));
    }
    return node || document.body;
}
exports.toNode = toNode;
function eventHandler(prepare, hash) {
    var keys = Object.keys(hash);
    return function (ev) {
        var data = prepare(ev);
        var node = ev.target;
        while (node) {
            var cssstring = node.getAttribute ? (node.getAttribute("class") || "") : "";
            if (cssstring.length) {
                var css = cssstring.split(" ");
                for (var j = 0; j < keys.length; j++) {
                    if (css.indexOf(keys[j]) > -1) {
                        return hash[keys[j]](ev, data);
                    }
                }
            }
            node = node.parentNode;
        }
        return true;
    };
}
exports.eventHandler = eventHandler;
function locate(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    var node = locateNode(target, attr);
    return node ? node.getAttribute(attr) : "";
}
exports.locate = locate;
function locateNode(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        if (target.getAttribute(attr)) {
            return target;
        }
        target = target.parentNode;
    }
}
exports.locateNode = locateNode;
function getBox(elem) {
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var top = box.top + scrollTop;
    var left = box.left + scrollLeft;
    var right = body.offsetWidth - box.right;
    var bottom = body.offsetHeight - box.bottom;
    var width = box.right - box.left;
    var height = box.bottom - box.top;
    return { top: top, left: left, right: right, bottom: bottom, width: width, height: height };
}
exports.getBox = getBox;
var scrollWidth = -1;
function getScrollbarWidth() {
    if (scrollWidth > -1) {
        return scrollWidth;
    }
    var scrollDiv = document.createElement("div");
    document.body.appendChild(scrollDiv);
    scrollDiv.style.cssText = "position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;";
    scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollWidth;
}
exports.getScrollbarWidth = getScrollbarWidth;
function fitPosition(target, mode, width, height) {
    var right = target.left + target.width;
    var bottom = target.top + target.height;
    if (mode === "bottom") {
        var left = window.innerWidth < target.left + width ? right - width : target.left;
        var top_1 = bottom + height > window.innerHeight ? target.top - height + window.scrollY : bottom + window.scrollY;
        return {
            position: "absolute",
            left: left,
            top: top_1,
            minWidth: width
        };
    }
    else {
        var overflow = void 0;
        var top_2 = target.top + window.scrollY;
        var left = window.innerWidth < right + width ? target.left - width : right;
        if (bottom + height > window.innerHeight) {
            if (bottom - height > 0) {
                top_2 = bottom - height + window.scrollY;
            }
            else {
                overflow = "scroll";
                height = (window.innerHeight - target.top) * 0.8;
            }
        }
        return {
            position: "absolute",
            left: left,
            top: top_2,
            minWidth: width,
            overflow: overflow,
            height: height
        };
    }
}
exports.fitPosition = fitPosition;
function isIE() {
    var ua = window.navigator.userAgent;
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
}
exports.isIE = isIE;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
function getCss(item) {
    var className = "";
    if (item.type !== types_1.ItemType.button && item.size) {
        className += " " + item.size;
    }
    if (item.active) {
        className += " active";
    }
    if (item.$disabled) {
        className += " disabled";
    }
    if (item.css) {
        className += " " + item.css;
    }
    return className;
}
exports.getCss = getCss;
function getButtonCss(item) {
    var className = " ";
    className += item.name === "link" ? "dhx_btn--link" : "dhx_btn--flat";
    className += item.size === "large" ? " dhx_btn--large" : " dhx_btn--small";
    switch (item.usage) {
        case "danger":
            className += " dhx_btn--danger";
            break;
        case "secondary":
            className += " dhx_btn--secondary";
            break;
        case "success":
            className += " dhx_btn--success";
            break;
        case "primary":
        default:
            break;
    }
    return className;
}
exports.getButtonCss = getButtonCss;
function counter(item) {
    if (item.count) {
        return dom_1.el(".counter", item.count);
    }
}
exports.counter = counter;
function icon(iconName) {
    if (iconName === void 0) { iconName = ""; }
    var className = "dhx-icon-block ";
    if (iconName.slice(0, 3) === "dxi") {
        className += "dxi ";
    }
    return dom_1.el("div", {
        class: className + iconName
    });
}
exports.icon = icon;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var counter = (new Date()).valueOf();
function uid() {
    return "u" + (counter++);
}
exports.uid = uid;
function extend(target, source, deep) {
    if (deep === void 0) { deep = true; }
    if (source) {
        for (var key in source) {
            var sobj = source[key];
            var tobj = target[key];
            if (deep && typeof tobj === "object" && !(tobj instanceof Date) && !(tobj instanceof Array)) {
                extend(tobj, sobj);
            }
            else {
                target[key] = sobj;
            }
        }
    }
    return target;
}
exports.extend = extend;
function copy(source) {
    var result = {};
    for (var key in source) {
        result[key] = source[key];
    }
    return result;
}
exports.copy = copy;
function naturalSort(arr) {
    return arr.sort(function (a, b) {
        var nn = typeof a === "string" ? a.localeCompare(b) : a - b;
        return nn;
    });
}
exports.naturalSort = naturalSort;
function findIndex(arr, predicate) {
    var len = arr.length;
    for (var i = 0; i < len; i++) {
        if (predicate(arr[i])) {
            return i;
        }
    }
    return -1;
}
exports.findIndex = findIndex;
function isEqualString(from, to) {
    if (from.length > to.length) {
        return false;
    }
    for (var i = 0; i < from.length; i++) {
        if (from[i].toLowerCase() !== to[i].toLowerCase()) {
            return false;
        }
    }
    return true;
}
exports.isEqualString = isEqualString;
function singleOuterClick(fn) {
    var click = function (e) {
        if (fn(e)) {
            document.removeEventListener("click", click);
        }
    };
    document.addEventListener("click", click);
}
exports.singleOuterClick = singleOuterClick;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
var ItemType;
(function (ItemType) {
    ItemType["button"] = "button";
    ItemType["input"] = "input";
    ItemType["separator"] = "separator";
    ItemType["text"] = "text";
    ItemType["iconButton"] = "iconButton";
    ItemType["imageButton"] = "imageButton";
    ItemType["spacer"] = "spacer";
    ItemType["menuItem"] = "menuItem";
    ItemType["imageButtonText"] = "imageButtonText";
    ItemType["block"] = "block";
    ItemType["customHTMLButton"] = "customButton";
    ItemType["selectButton"] = "selectButton";
    ItemType["dhxButton"] = "dhx-button";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var ToolbarEvents;
(function (ToolbarEvents) {
    ToolbarEvents["inputCreated"] = "inputcreated";
    ToolbarEvents["click"] = "click";
})(ToolbarEvents = exports.ToolbarEvents || (exports.ToolbarEvents = {}));
var NavigationType;
(function (NavigationType) {
    NavigationType["pointer"] = "pointer";
    NavigationType["click"] = "click";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataEvents;
(function (DataEvents) {
    DataEvents["afterAdd"] = "afteradd";
    DataEvents["beforeAdd"] = "beforeadd";
    DataEvents["removeAll"] = "removeall";
    DataEvents["beforeRemove"] = "beforeremove";
    DataEvents["afterRemove"] = "afterremove";
    DataEvents["change"] = "change";
    DataEvents["load"] = "load";
})(DataEvents = exports.DataEvents || (exports.DataEvents = {}));
var DragEvents;
(function (DragEvents) {
    DragEvents["beforeDrag"] = "beforedrag";
    DragEvents["beforeDrop"] = "beforeDrop";
    DragEvents["dragStart"] = "dragstart";
    DragEvents["dragEnd"] = "dragend";
    DragEvents["canDrop"] = "candrop";
    DragEvents["cancelDrop"] = "canceldrop";
    DragEvents["dropComplete"] = "dropcomplete";
    DragEvents["dragOut"] = "dragOut";
    DragEvents["dragIn"] = "dragIn";
})(DragEvents = exports.DragEvents || (exports.DragEvents = {}));
var DragMode;
(function (DragMode) {
    DragMode["target"] = "target";
    DragMode["both"] = "both";
    DragMode["source"] = "source";
})(DragMode = exports.DragMode || (exports.DragMode = {}));
var DragBehaviour;
(function (DragBehaviour) {
    DragBehaviour["child"] = "child";
    DragBehaviour["sibling"] = "sibling";
    DragBehaviour["complex"] = "complex";
})(DragBehaviour = exports.DragBehaviour || (exports.DragBehaviour = {}));
var SelectionEvents;
(function (SelectionEvents) {
    SelectionEvents["beforeUnSelect"] = "beforeunselect";
    SelectionEvents["afterUnSelect"] = "afterunselect";
    SelectionEvents["beforeSelect"] = "beforeselect";
    SelectionEvents["afterSelect"] = "afterselect";
})(SelectionEvents = exports.SelectionEvents || (exports.SelectionEvents = {}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
exports.DragBehaviour = types_1.DragBehaviour;
exports.DragMode = types_1.DragMode;
var TreeFilterType;
(function (TreeFilterType) {
    TreeFilterType[TreeFilterType["all"] = 1] = "all";
    TreeFilterType[TreeFilterType["specific"] = 2] = "specific";
    TreeFilterType[TreeFilterType["leafs"] = 3] = "leafs";
})(TreeFilterType = exports.TreeFilterType || (exports.TreeFilterType = {}));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dataproxy_1 = __webpack_require__(11);
var CsvDriver_1 = __webpack_require__(21);
var JsonDriver_1 = __webpack_require__(22);
function isEqualObj(a, b) {
    for (var key in a) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
exports.isEqualObj = isEqualObj;
function naturalCompare(a, b) {
    var ax = [];
    var bx = [];
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]); });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]); });
    while (ax.length && bx.length) {
        var an = ax.shift();
        var bn = bx.shift();
        var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
        if (nn) {
            return nn;
        }
    }
    return ax.length - bx.length;
}
exports.naturalCompare = naturalCompare;
function findByConf(item, conf) {
    if (typeof conf === "function") {
        if (conf.call(this, item)) {
            return item;
        }
    }
    else if (conf.by && conf.match) {
        if (item[conf.by] === conf.match) {
            return item;
        }
    }
}
exports.findByConf = findByConf;
function isDebug() {
    var dhx = window.dhx;
    if (typeof dhx !== "undefined") {
        return typeof (dhx.debug) !== "undefined" && dhx.debug;
    }
    // return typeof DHX_DEBUG_MODE !== "undefined" && DHX_DEBUG_MODE;
}
exports.isDebug = isDebug;
function dhxWarning(msg) {
    // tslint:disable-next-line:no-console
    console.warn(msg);
}
exports.dhxWarning = dhxWarning;
function dhxError(msg) {
    throw new Error(msg);
}
exports.dhxError = dhxError;
function toProxy(proxy) {
    var type = typeof proxy;
    if (type === "string") {
        return new dataproxy_1.DataProxy(proxy);
    }
    else if (type === "object") {
        return proxy;
    }
}
exports.toProxy = toProxy;
function toDataDriver(driver) {
    var type = typeof driver;
    if (type === "string") {
        switch (driver) {
            case "csv":
                return new CsvDriver_1.CsvDriver();
            case "json":
                return new JsonDriver_1.JsonDriver();
            default:
                // tslint:disable-next-line:no-console
                console.warn("incorrect driver type", driver);
                break;
        }
    }
    else if (typeof driver === "object") {
        return driver;
    }
}
exports.toDataDriver = toDataDriver;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(6));
__export(__webpack_require__(19));
__export(__webpack_require__(23));
__export(__webpack_require__(36));
__export(__webpack_require__(11));
__export(__webpack_require__(7));
__export(__webpack_require__(21));
__export(__webpack_require__(22));
__export(__webpack_require__(39));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EventSystem = /** @class */ (function () {
    function EventSystem(context) {
        this.events = {};
        this.context = context || this;
    }
    EventSystem.prototype.on = function (name, callback, context) {
        var event = name.toLowerCase();
        this.events[event] = this.events[event] || [];
        this.events[event].push({ callback: callback, context: context || this.context });
    };
    EventSystem.prototype.detach = function (name, context) {
        var event = name.toLowerCase();
        var eStack = this.events[event];
        if (context) {
            for (var i = eStack.length - 1; i >= 0; i--) {
                if (eStack[i].context === context) {
                    eStack.splice(i, 1);
                }
            }
        }
        else {
            this.events[event] = [];
        }
    };
    EventSystem.prototype.fire = function (name, args) {
        if (typeof args === "undefined") {
            args = [];
        }
        var event = name.toLowerCase();
        if (this.events[event]) {
            var res = this.events[event].map(function (e) { return e.callback.apply(e.context, args); });
            return res.indexOf(false) < 0;
        }
        return true;
    };
    return EventSystem;
}());
exports.EventSystem = EventSystem;
function EventsMixin(obj) {
    obj = obj || {};
    var eventSystem = new EventSystem(obj);
    obj.detachEvent = eventSystem.detach.bind(eventSystem);
    obj.attachEvent = eventSystem.on.bind(eventSystem);
    obj.callEvent = eventSystem.fire.bind(eventSystem);
}
exports.EventsMixin = EventsMixin;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {(function () {
  global = this

  var queueId = 1
  var queue = {}
  var isRunningTask = false

  if (!global.setImmediate)
    global.addEventListener('message', function (e) {
      if (e.source == global){
        if (isRunningTask)
          nextTick(queue[e.data])
        else {
          isRunningTask = true
          try {
            queue[e.data]()
          } catch (e) {}

          delete queue[e.data]
          isRunningTask = false
        }
      }
    })

  function nextTick(fn) {
    if (global.setImmediate) setImmediate(fn)
    // if inside of web worker
    else if (global.importScripts) setTimeout(fn)
    else {
      queueId++
      queue[queueId] = fn
      global.postMessage(queueId, '*')
    }
  }

  Deferred.resolve = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    if (value instanceof Deferred)
      return value

    return new Deferred(function (resolve) {
        resolve(value)
    })
  }

  Deferred.reject = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    return new Deferred(function (resolve, reject) {
        reject(value)
    })
  }

  Deferred.all = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            arr[i] = r
            done()
            return r
          }, done)
      })
    }

    done()

    return d
  }

  Deferred.race = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    if (arr.length == 0)
      return new Deferred()

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            done(null, r)
          }, done)
      })
    }

    done()

    return d
  }

  Deferred._d = 1


  /**
   * @constructor
   */
  function Deferred(resolver) {
    'use strict'
    if (typeof resolver != 'function' && resolver != undefined)
      throw TypeError()

    if (typeof this != 'object' || (this && this.then))
      throw TypeError()

    // states
    // 0: pending
    // 1: resolving
    // 2: rejecting
    // 3: resolved
    // 4: rejected
    var self = this,
      state = 0,
      val = 0,
      next = [],
      fn, er;

    self['promise'] = self

    self['resolve'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 1

        nextTick(fire)
      }
      return self
    }

    self['reject'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 2

        nextTick(fire)

      }
      return self
    }

    self['_d'] = 1

    self['then'] = function (_fn, _er) {
      if (!(this._d == 1))
        throw TypeError()

      var d = new Deferred()

      d.fn = _fn
      d.er = _er
      if (state == 3) {
        d.resolve(val)
      }
      else if (state == 4) {
        d.reject(val)
      }
      else {
        next.push(d)
      }

      return d
    }

    self['catch'] = function (_er) {
      return self['then'](null, _er)
    }

    var finish = function (type) {
      state = type || 4
      next.map(function (p) {
        state == 3 && p.resolve(val) || p.reject(val)
      })
    }

    try {
      if (typeof resolver == 'function')
        resolver(self['resolve'], self['reject'])
    } catch (e) {
      self['reject'](e)
    }

    return self

    // ref : reference to 'then' function
    // cb, ec, cn : successCallback, failureCallback, notThennableCallback
    function thennable (ref, cb, ec, cn) {
      // Promises can be rejected with other promises, which should pass through
      if (state == 2) {
        return cn()
      }
      if ((typeof val == 'object' || typeof val == 'function') && typeof ref == 'function') {
        try {

          // cnt protects against abuse calls from spec checker
          var cnt = 0
          ref.call(val, function (v) {
            if (cnt++) return
            val = v
            cb()
          }, function (v) {
            if (cnt++) return
            val = v
            ec()
          })
        } catch (e) {
          val = e
          ec()
        }
      } else {
        cn()
      }
    };

    function fire() {

      // check if it's a thenable
      var ref;
      try {
        ref = val && val.then
      } catch (e) {
        val = e
        state = 2
        return fire()
      }

      thennable(ref, function () {
        state = 1
        fire()
      }, function () {
        state = 2
        fire()
      }, function () {
        try {
          if (state == 1 && typeof fn == 'function') {
            val = fn(val)
          }

          else if (state == 2 && typeof er == 'function') {
            val = er(val)
            state = 1
          }
        } catch (e) {
          val = e
          return finish()
        }

        if (val == self) {
          val = TypeError()
          finish()
        } else thennable(ref, function () {
            finish(3)
          }, finish, function () {
            finish(state == 1 && 3)
          })

      })
    }


  }

  // Export our library object, either for node.js or as a globally scoped variable
  if (true) {
    module['exports'] = Deferred
  } else {}
})()

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(32).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var DataProxy = /** @class */ (function () {
    function DataProxy(url) {
        this.url = url;
    }
    DataProxy.prototype.load = function () {
        return this._ajax(this.url);
    };
    DataProxy.prototype.save = function (data, mode) {
        var modes = {
            insert: "POST",
            delete: "DELETE",
            update: "POST"
        };
        return this._ajax(this.url, data, modes[mode] || "POST");
    };
    DataProxy.prototype._ajax = function (url, data, method) {
        if (method === void 0) { method = "GET"; }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response || xhr.responseText);
                }
                else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", "application/json");
            switch (method) {
                case "POST":
                case "DELETE":
                case "PUT":
                    xhr.send(JSON.stringify(data));
                    break;
                case "GET":
                    xhr.send();
                    break;
                default:
                    xhr.send();
                    break;
            }
        });
    };
    return DataProxy;
}());
exports.DataProxy = DataProxy;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var View = /** @class */ (function () {
    function View(_container, config) {
        this._uid = core_1.uid();
        this.config = config || {};
    }
    View.prototype.mount = function (container, vnode) {
        if (vnode) {
            this._view = vnode;
        }
        if (container && this._view && this._view.mount) {
            // init view inside of HTML container
            this._container = html_1.toNode(container);
            if (this._container.tagName) {
                this._view.mount(this._container);
            }
            else if (this._container.attach) {
                this._container.attach(this);
            }
        }
    };
    View.prototype.getRootView = function () {
        return this._view;
    };
    View.prototype.paint = function () {
        if (this._view && ( // was mounted
        this._view.node || // already rendered node
            this._container || // not rendered, but has container
            !this._view.mount)) { // fake cell node
            this._doNotRepaint = false;
            this._view.redraw();
        }
    };
    return View;
}());
exports.View = View;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getRealPosition(node) {
    var rects = node.getBoundingClientRect();
    return {
        left: rects.left + window.pageXOffset,
        right: rects.right + window.pageXOffset,
        top: rects.top + window.pageYOffset,
        bottom: rects.bottom + window.pageYOffset
    };
}
exports.getRealPosition = getRealPosition;
function calculatePosition(pos, config) {
    var rightBorder = window.pageXOffset + window.innerWidth;
    var bottomBorder = window.pageYOffset + window.innerHeight;
    var style = {
        left: null,
        top: null,
        minWidth: config.width + "px",
        position: "absolute"
    };
    if (config.mode === "bottom") {
        if (pos.left + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.left + "px";
        }
        if (pos.bottom + config.height > bottomBorder) {
            style.top = pos.top - config.height + "px";
        }
        else {
            style.top = pos.bottom + "px";
        }
    }
    else {
        if (pos.right + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.right + "px";
        }
        if (pos.top + config.height > bottomBorder) {
            style.top = pos.bottom - config.height + "px";
        }
        else {
            style.top = pos.top + "px";
        }
    }
    return style;
}
exports.calculatePosition = calculatePosition;
function addInGroups(groups, item) {
    if (groups[item.group]) {
        if (item.active) {
            groups[item.group].active = item.id;
        }
        groups[item.group].elements.push(item.id);
    }
    else {
        groups[item.group] = {
            active: item.active ? item.id : null,
            elements: [item.id]
        };
    }
}
exports.addInGroups = addInGroups;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var locale = {
    dragAndDrop: "Drag & drop",
    or: "or",
    browse: "Browse files",
    filesOrFoldersHere: "files or folders here",
    cancel: "Cancel",
    clearAll: "Clear all",
    clear: "Clear",
    add: "Add",
    upload: "Upload",
    download: "Download",
    error: "error",
    byte: "B",
    kilobyte: "KB",
    megabyte: "MB",
    gigabyte: "GB"
};
exports["default"] = locale;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(5);
exports.DataEvents = types_2.DataEvents;
var FileStatus;
(function (FileStatus) {
    FileStatus["queue"] = "queue";
    FileStatus["uploaded"] = "uploaded";
    FileStatus["failed"] = "failed";
    FileStatus["inprogress"] = "inprogress";
})(FileStatus = exports.FileStatus || (exports.FileStatus = {}));
var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["uploadBegin"] = "uploadbegin";
    UploaderEvents["beforeUploadFile"] = "beforeuploadfile";
    UploaderEvents["uploadFile"] = "uploadfile";
    UploaderEvents["uploadFail"] = "uploadfail";
    UploaderEvents["uploadComplete"] = "uploadcomplete";
    UploaderEvents["uploadProgress"] = "uploadprogress";
})(UploaderEvents = exports.UploaderEvents || (exports.UploaderEvents = {}));
var ProgressBarEvents;
(function (ProgressBarEvents) {
    ProgressBarEvents["cancel"] = "cancel";
})(ProgressBarEvents = exports.ProgressBarEvents || (exports.ProgressBarEvents = {}));
var VaultMode;
(function (VaultMode) {
    VaultMode["grid"] = "grid";
    VaultMode["list"] = "list";
})(VaultMode = exports.VaultMode || (exports.VaultMode = {}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(24));
__export(__webpack_require__(40));
__export(__webpack_require__(25));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = __webpack_require__(49);
var customHTMLButton_1 = __webpack_require__(50);
var dhx_button_1 = __webpack_require__(51);
var iconButton_1 = __webpack_require__(52);
var imageButton_1 = __webpack_require__(53);
var imageButtonText_1 = __webpack_require__(54);
var input_1 = __webpack_require__(55);
var menuItem_1 = __webpack_require__(56);
var separator_1 = __webpack_require__(57);
var spacer_1 = __webpack_require__(58);
var text_1 = __webpack_require__(59);
var types_1 = __webpack_require__(4);
function itemfactory(item, events) {
    if (item.$hidden) {
        return null;
    }
    switch (item.type) {
        case types_1.ItemType.button:
            return button_1.button(item);
        case types_1.ItemType.text:
            return text_1.text(item);
        case types_1.ItemType.separator:
            return separator_1.separator(item);
        case types_1.ItemType.spacer:
            return spacer_1.spacer(item);
        case types_1.ItemType.input:
            return input_1.input(item, events);
        case types_1.ItemType.imageButton:
            return imageButton_1.imageButton(item);
        case types_1.ItemType.iconButton:
            return iconButton_1.iconButton(item);
        case types_1.ItemType.selectButton:
        case types_1.ItemType.menuItem:
            return menuItem_1.menuItem(item);
        case types_1.ItemType.imageButtonText:
            return imageButtonText_1.imageButtonText(item);
        case types_1.ItemType.customHTMLButton:
            return customHTMLButton_1.customHTMLButton(item);
        case types_1.ItemType.dhxButton:
            return dhx_button_1.dhx_button(item);
        case types_1.ItemType.block:
        default:
            throw new Error("unknown item type");
    }
}
exports.itemfactory = itemfactory;
function createFactory(defaultType, forbiddenTypes) {
    if (forbiddenTypes === void 0) { forbiddenTypes = []; }
    var forbidden = {};
    forbiddenTypes.forEach(function (type) { return forbidden[type] = true; });
    return function (item, events) {
        item.type = item.type || defaultType;
        if (forbidden[item.type]) {
            item.type = defaultType;
        }
        return itemfactory(item, events);
    };
}
exports.createFactory = createFactory;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var hotkeys_1 = __webpack_require__(60);
var html_1 = __webpack_require__(1);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var types_1 = __webpack_require__(4);
var MenuBase = /** @class */ (function (_super) {
    __extends(MenuBase, _super);
    function MenuBase(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            popupWidth: 175
        }, config)) || this;
        _this._isContextMenu = false;
        _this._documentHaveListener = false;
        _this.events = new events_1.EventSystem();
        _this.data = new ts_data_1.TreeCollection({}, _this.events);
        _this._documentClick = function (e) {
            if (html_1.locate(e, "dhx_widget_id") !== _this._uid && _this._documentHaveListener) {
                document.removeEventListener("click", _this._documentClick);
                _this._documentHaveListener = false;
                _this._close();
            }
        };
        _this._currentRoot = _this.data.getRoot();
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.menuItem);
        _this._init();
        _this._initHandlers();
        _this._initEvents();
        return _this;
    }
    MenuBase.prototype.paint = function () {
        _super.prototype.paint.call(this);
        this._vpopups.redraw();
    };
    MenuBase.prototype.disable = function (ids) {
        this._setProp(ids, "$disabled", true);
    };
    MenuBase.prototype.enable = function (ids) {
        this._setProp(ids, "$disabled", false);
    };
    MenuBase.prototype.show = function (ids) {
        this._setProp(ids, "$hidden", false);
    };
    MenuBase.prototype.hide = function (ids) {
        this._setProp(ids, "$hidden", true);
    };
    MenuBase.prototype.destructor = function () {
        hotkeys_1.keyManager.removeHotKey(null, this);
    };
    MenuBase.prototype._close = function () {
        if (this.config.navigationType === types_1.NavigationType.click) {
            this._isActive = false;
        }
        clearTimeout(this._currentTimeout);
        this._activeMenu = null;
        this.paint();
    };
    MenuBase.prototype._init = function () {
        var _this = this;
        var render = function () { return dom_1.el("div", __assign({ dhx_widget_id: _this._uid, class: "menu-popups" + (_this._isContextMenu ? " context-menu" : "") }, _this._handlers), _this._drawPopups()); };
        this._vpopups = dom_1.create({
            render: render
        });
        this._vpopups.mount(document.body);
    };
    MenuBase.prototype._initHandlers = function () {
        var _this = this;
        /*
            for navigation type click:
            first click open menu, _isActive = true
            after navigation use mousemove
            can be closed after outer click or menu leaf item click
        */
        this._isActive = this.config.navigationType !== types_1.NavigationType.click;
        this._handlers = {
            onmousemove: function (e) {
                if (!_this._isActive) {
                    return;
                }
                var elem = html_1.locateNode(e);
                if (!elem) {
                    _this._activeItemChange(null);
                    return;
                }
                var id = elem.getAttribute("dhx_id");
                if (_this._activeMenu !== id) {
                    _this._activeMenu = id;
                    if (_this.data.haveChilds(id)) {
                        var position = helper_1.getRealPosition(elem);
                        _this.data.update(id, { $position: position }, false);
                    }
                    _this._activeItemChange(id);
                }
            },
            onmouseleave: function () {
                if (_this.config.navigationType !== types_1.NavigationType.click) { // maybe all time when mouse leave close menu
                    _this._activeItemChange(null);
                }
            },
            onclick: function (e) {
                var element = html_1.locateNode(e);
                if (!element) {
                    return;
                }
                var id = element.getAttribute("dhx_id");
                var item = _this.data.getItem(id);
                switch (item.type) {
                    case types_1.ItemType.selectButton:
                    case types_1.ItemType.menuItem:
                        if (id === _this._currentRoot) {
                            _this._close();
                            return;
                        }
                        if (!_this._isActive) {
                            _this._isActive = true;
                        }
                        _this._setRoot(id);
                        _this._activeMenu = id;
                        if (_this.data.haveChilds(id)) {
                            var position = helper_1.getRealPosition(element);
                            _this.data.update(id, { $position: position }, false);
                            _this._activeItemChange(id);
                        }
                        else {
                            _this._onMenuItemClick(id, e);
                        }
                        break;
                    case types_1.ItemType.dhxButton:
                    case types_1.ItemType.imageButtonText:
                    case types_1.ItemType.iconButton:
                    case types_1.ItemType.imageButton:
                    case types_1.ItemType.button:
                    case types_1.ItemType.customHTMLButton:
                        if (item.twoState) {
                            _this.data.update(item.id, { active: !item.active });
                        }
                        _this.events.fire(types_1.ToolbarEvents.click, [id, e]);
                    case types_1.ItemType.separator:
                    case types_1.ItemType.input:
                    case types_1.ItemType.text:
                    case types_1.ItemType.spacer:
                        _this._close();
                    default:
                        return;
                }
            }
        };
    };
    MenuBase.prototype._initEvents = function () {
        var _this = this;
        var timeout = null;
        this.data.events.on(types_1.DataEvents.change, function () {
            _this.paint();
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this._normalizeData();
                _this._resetHotkeys();
                timeout = null;
                _this.paint();
            }, 100);
        });
        this.events.on(types_1.ToolbarEvents.click, function (id) {
            var item = _this.data.getItem(id);
            var parent = _this.data.getItem(item.parent);
            if (parent && parent.type === types_1.ItemType.selectButton) {
                _this.data.update(item.parent, { value: item.value, icon: item.icon });
            }
            if (item.group) {
                var group = _this._groups[item.group];
                if (group.active) {
                    _this.data.update(group.active, { active: false });
                }
                group.active = item.id;
                _this.data.update(item.id, { active: true });
            }
        });
    };
    MenuBase.prototype._drawPopups = function () {
        var _this = this;
        var id = this._activeMenu;
        if (!this._isContextMenu && !id) {
            return null;
        }
        var root = this._currentRoot;
        if (this._isContextMenu && !this._activePosition) {
            return null;
        }
        var parentIds = this._getParents(id, root);
        return parentIds.map(function (itemId) {
            if (!_this.data.haveChilds(itemId)) {
                return null;
            }
            var item = _this.data.getItem(itemId) || {}; // for root item
            var count = 0;
            var separators = 0;
            _this.data.eachChild(itemId, function (child) {
                if (child.$hidden) {
                    return;
                }
                if (child.type === "separator" || child.separator) {
                    separators++;
                }
                else {
                    count++;
                }
            }, false);
            var width = item.width || _this.config.popupWidth;
            var position = (_this._isContextMenu && _this._activePosition && itemId === root) ? _this._activePosition : item.$position;
            var mode = _this._getMode(item, root, position === _this._activePosition);
            var height = (position.bottom - position.top) * count + separators * 5; // separator 5px
            return dom_1.el("div", {
                class: "dhx_widget menu-popup",
                style: helper_1.calculatePosition(position, { mode: mode, width: width, height: height })
            }, _this._drawMenuItems(itemId));
        }).reverse();
    };
    MenuBase.prototype._onMenuItemClick = function (id, e) {
        var item = this.data.getItem(id);
        if (item.$disabled) {
            return;
        }
        this.events.fire(types_1.ToolbarEvents.click, [id, e]);
        this._close();
    };
    MenuBase.prototype._activeItemChange = function (id) {
        var _this = this;
        if (id && !this._documentHaveListener) {
            this._listenOuterClick();
        }
        if (id && this.data.haveChilds(id)) {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this.paint();
        }
        else {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this._currentTimeout = setTimeout(function () { return _this.paint(); }, 400);
        }
    };
    MenuBase.prototype._resetHotkeys = function () {
        var _this = this;
        hotkeys_1.keyManager.removeHotKey(null, this);
        this.data.map(function (item) {
            if (item.hotkey) {
                hotkeys_1.keyManager.addHotKey(item.hotkey, function () { return _this._onMenuItemClick(item.id, null); }, _this);
            }
        });
    };
    MenuBase.prototype._listenOuterClick = function () {
        document.addEventListener("click", this._documentClick);
        this._documentHaveListener = true;
    };
    MenuBase.prototype._getMode = function (item, root, _active) {
        if (_active === void 0) { _active = false; }
        return item.parent === root ? "bottom" : "right";
    };
    MenuBase.prototype._drawMenuItems = function (id) {
        var _this = this;
        return this.data.map(function (item) { return _this._factory(item, _this.events); }, id, false);
    };
    MenuBase.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id) && item.parent !== _this.data.getRoot()) {
                item.$openIcon = "right";
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    MenuBase.prototype._setRoot = function (_id) {
        return; // need only for toolbar
    };
    MenuBase.prototype._getParents = function (id, root) {
        var parentIds = [];
        var afterRoot = false;
        var currentItem = this.data.getItem(id);
        var disabled = currentItem && currentItem.$disabled;
        this.data.eachParent(id, function (item) {
            if (item.id === root) {
                parentIds.push(item.id);
                afterRoot = true;
            }
            else if (!afterRoot) {
                parentIds.push(item.id);
            }
        }, !disabled);
        if (this._isContextMenu && this._activePosition) {
            parentIds.push(root);
        }
        return parentIds;
    };
    MenuBase.prototype._setProp = function (id, key, value) {
        var _this = this;
        var _a;
        if (Array.isArray(id)) {
            id.forEach(function (itemId) {
                var _a;
                return _this.data.update(itemId, (_a = {}, _a[key] = value, _a));
            });
        }
        else {
            this.data.update(id, (_a = {}, _a[key] = value, _a));
        }
    };
    return MenuBase;
}(view_1.View));
exports.MenuBase = MenuBase;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var loader_1 = __webpack_require__(31);
var sort_1 = __webpack_require__(35);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
var core_1 = __webpack_require__(3);
var DataCollection = /** @class */ (function () {
    function DataCollection(config, events) {
        this._order = [];
        this._pull = {};
        this._changes = {
            order: []
        };
        this._initOrder = null;
        this.config = config || {};
        this._sort = new sort_1.Sort();
        this._loader = new loader_1.Loader(this, this._changes);
        this.events = events || new events_1.EventSystem(this);
    }
    DataCollection.prototype.add = function (obj, index) {
        if (!this.events.fire(types_1.DataEvents.beforeAdd, [obj])) {
            return;
        }
        this._addCore(obj, index);
        this._onChange("add", obj.id, obj);
        this.events.fire(types_1.DataEvents.afterAdd, [obj]);
    };
    DataCollection.prototype.remove = function (id) {
        var obj = this._pull[id];
        if (obj) {
            if (!this.events.fire(types_1.DataEvents.beforeRemove, [obj])) {
                return;
            }
            this._removeCore(obj.id);
            this._onChange("remove", id, obj);
        }
        this.events.fire(types_1.DataEvents.afterRemove, [obj]);
    };
    DataCollection.prototype.removeAll = function () {
        this._removeAll();
        this.events.fire(types_1.DataEvents.removeAll);
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.exists = function (id) {
        return !!this._pull[id];
    };
    DataCollection.prototype.getNearId = function (id) {
        var item = this._pull[id];
        if (!item) {
            return this._order[0].id || "";
        }
    };
    DataCollection.prototype.getItem = function (id) {
        return this._pull[id];
    };
    DataCollection.prototype.update = function (id, obj, silent) {
        var item = this.getItem(id);
        if (item) {
            if (helpers_1.isEqualObj(obj, item)) {
                return;
            }
            if (obj.id && id !== obj.id) {
                helpers_1.dhxWarning("this method doesn't allow change id");
                if (helpers_1.isDebug()) {
                    // tslint:disable-next-line:no-debugger
                    debugger;
                }
            }
            else {
                core_1.extend(this._pull[id], obj, false);
                if (this.config.update) {
                    this.config.update(this._pull[id]);
                }
                if (!silent) {
                    this._onChange("update", id, this._pull[id]);
                }
            }
        }
        else {
            helpers_1.dhxWarning("item not found");
        }
    };
    DataCollection.prototype.getIndex = function (id) {
        var res = core_1.findIndex(this._order, function (item) { return item.id === id; });
        if (this._pull[id] && res >= 0) {
            return res;
        }
        return -1;
    };
    DataCollection.prototype.getId = function (index) {
        if (!this._order[index]) {
            return;
        }
        return this._order[index].id;
    };
    DataCollection.prototype.getLength = function () {
        return this._order.length;
    };
    DataCollection.prototype.filter = function (rule, config) {
        var _this = this;
        config = core_1.extend({
            add: false,
            multiple: true
        }, config);
        if (!config.add) {
            this._order = this._initOrder || this._order;
            this._initOrder = null;
        }
        this._filters = this._filters || {};
        if (!config.multiple || !rule) {
            this._filters = {};
        }
        if (rule) {
            if (typeof rule === "function") {
                var f = "_";
                this._filters[f] = {
                    match: f,
                    compare: rule
                };
            }
            else {
                if (!rule.match) {
                    delete this._filters[rule.by];
                }
                else {
                    rule.compare = rule.compare || (function (val, match) { return val === match; });
                    this._filters[rule.by] = rule;
                }
            }
            var fOrder = this._order.filter(function (item) {
                return Object.keys(_this._filters).every(function (key) {
                    return item[key] ?
                        _this._filters[key].compare(item[key], _this._filters[key].match, item)
                        : _this._filters[key].compare(item);
                });
            });
            if (!this._initOrder) {
                this._initOrder = this._order;
                this._order = fOrder;
            }
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.find = function (conf) {
        for (var key in this._pull) {
            var res = helpers_1.findByConf(this._pull[key], conf);
            if (res) {
                return res;
            }
        }
        return null;
    };
    DataCollection.prototype.findAll = function (conf) {
        var res = [];
        for (var key in this._pull) {
            var item = helpers_1.findByConf(this._pull[key], conf);
            if (item) {
                res.push(item);
            }
        }
        return res;
    };
    DataCollection.prototype.sort = function (by) {
        this._sort.sort(this._order, by);
        if (this._initOrder && this._initOrder.length) {
            this._sort.sort(this._initOrder, by);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.copy = function (id, index, target, targetId) {
        if (!this.exists(id)) {
            return null;
        }
        var newid = core_1.uid();
        if (target) {
            if (targetId) {
                target.add(__assign({}, this.getItem(id)), index, targetId);
                return;
            }
            if (target.exists(id)) {
                target.add(__assign({}, this.getItem(id), { id: newid }), index);
                return newid;
            }
            else {
                target.add(this.getItem(id), index);
                return id;
            }
        }
        this.add(__assign({}, this.getItem(id), { id: newid }), index);
        return newid;
    };
    DataCollection.prototype.move = function (id, index, target, targetId) {
        if (target && target !== this && this.exists(id)) {
            var item = this.getItem(id);
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            if (targetId) {
                item.parent = targetId;
            }
            target.add(item, index);
            // remove data from original collection
            this.remove(item.id);
            return item.id;
        }
        if (this.getIndex(id) === index) {
            return null;
        }
        // move other elements
        var spliced = this._order.splice(this.getIndex(id), 1)[0];
        if (index === -1) {
            index = this._order.length;
        }
        this._order.splice(index, 0, spliced);
        this.events.fire(types_1.DataEvents.change); // if target not this, it trigger add and remove
        return id;
    };
    DataCollection.prototype.load = function (url, driver) {
        if (typeof url === "string") {
            url = new dataproxy_1.DataProxy(url);
        }
        return this._loader.load(url, driver);
    };
    DataCollection.prototype.parse = function (data, driver) {
        this._removeAll();
        return this._loader.parse(data, driver);
    };
    DataCollection.prototype.$parse = function (data) {
        var apx = this.config.approximate;
        if (apx) {
            data = this._approximate(data, apx.value, apx.maxNum);
        }
        this._parse_data(data);
        this.events.fire(types_1.DataEvents.change);
        this.events.fire(types_1.DataEvents.load);
    };
    DataCollection.prototype.save = function (url) {
        this._loader.save(url);
    };
    // todo: loop through the array and check saved statuses
    DataCollection.prototype.isSaved = function () {
        return !this._changes.order.length; // todo: bad solution, errors and holded elments are missed...
    };
    DataCollection.prototype.map = function (cb) {
        var result = [];
        for (var i = 0; i < this._order.length; i++) {
            result.push(cb.call(this, this._order[i], i));
        }
        return result;
    };
    DataCollection.prototype.reduce = function (cb, acc) {
        for (var i = 0; i < this._order.length; i++) {
            acc = cb.call(this, acc, this._order[i], i);
        }
        return acc;
    };
    DataCollection.prototype.serialize = function () {
        return this.map(function (item) {
            var newItem = __assign({}, item);
            Object.keys(newItem).forEach(function (key) {
                if (key[0] === "$") {
                    delete newItem[key];
                }
            });
            return newItem;
        });
    };
    DataCollection.prototype.getInitialData = function () {
        return this._initOrder;
    };
    DataCollection.prototype._removeAll = function () {
        this._pull = {};
        this._order = [];
        this._changes.order = [];
        this._initOrder = null;
    };
    DataCollection.prototype._addCore = function (obj, index) {
        if (this.config.init) {
            obj = this.config.init(obj);
        }
        obj.id = obj.id ? obj.id.toString() : core_1.uid();
        if (this._pull[obj.id]) {
            helpers_1.dhxError("Item already exist");
        }
        // todo: not ideal solution
        if (this._initOrder && this._initOrder.length) {
            this._addToOrder(this._initOrder, obj, index);
        }
        this._addToOrder(this._order, obj, index);
    };
    DataCollection.prototype._removeCore = function (id) {
        if (this.getIndex(id) >= 0) {
            this._order = this._order.filter(function (el) { return el.id !== id; });
            delete this._pull[id];
        }
        if (this._initOrder && this._initOrder.length) {
            this._initOrder = this._initOrder.filter(function (el) { return el.id !== id; });
        }
    };
    DataCollection.prototype._parse_data = function (data) {
        var index = this._order.length;
        if (this.config.prep) {
            data = this.config.prep(data);
        }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            obj.id = obj.id || core_1.uid();
            this._pull[obj.id] = obj;
            this._order[index++] = obj;
        }
    };
    DataCollection.prototype._approximate = function (data, values, maxNum) {
        var len = data.length;
        var vlen = values.length;
        var rlen = Math.floor(len / maxNum);
        var newData = Array(Math.ceil(len / rlen));
        var index = 0;
        for (var i = 0; i < len; i += rlen) {
            var newItem = core_1.copy(data[i]);
            var end = Math.min(len, i + rlen);
            for (var j = 0; j < vlen; j++) {
                var sum = 0;
                for (var z = i; z < end; z++) {
                    sum += data[z][values[j]];
                }
                newItem[values[j]] = sum / (end - i);
            }
            newData[index++] = newItem;
        }
        return newData;
    };
    DataCollection.prototype._onChange = function (status, id, obj) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var item = _a[_i];
            // update pending item if previous state is "saving" or if item not saved yet
            if (item.id === id && !item.saving) {
                // update item
                if (item.error) {
                    item.error = false;
                }
                item = __assign({}, item, { obj: obj, status: status });
                this.events.fire(types_1.DataEvents.change, [id, status, obj]);
                return;
            }
        }
        this._changes.order.push({ id: id, status: status, obj: __assign({}, obj), saving: false });
        this.events.fire(types_1.DataEvents.change, [id, status, obj]);
    };
    DataCollection.prototype._addToOrder = function (array, obj, index) {
        if (index >= 0 && array[index]) {
            this._pull[obj.id] = obj;
            array.splice(index, 0, obj);
        }
        else {
            this._pull[obj.id] = obj;
            array.push(obj);
        }
    };
    return DataCollection;
}());
exports.DataCollection = DataCollection;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CsvDriver = /** @class */ (function () {
    function CsvDriver(config) {
        if (config === void 0) { config = {}; }
        var initConfig = {
            skipHeader: 0,
            nameByHeader: false,
            row: "\n",
            column: ",",
        };
        this.config = __assign({}, initConfig, config);
        if (this.config.nameByHeader) {
            this.config.skipHeader = 1;
        }
    }
    CsvDriver.prototype.getFields = function (row, headers) {
        var parts = row.trim().split(this.config.column);
        var obj = {};
        for (var i = 0; i < parts.length; i++) {
            obj[headers ? headers[i] : i + 1] = parts[i];
        }
        return obj;
    };
    CsvDriver.prototype.getRows = function (data) {
        return data.trim().split(this.config.row);
    };
    CsvDriver.prototype.toJsonArray = function (data) {
        var _this = this;
        var rows = this.getRows(data);
        var names = this.config.names;
        if (this.config.skipHeader) {
            var top_1 = rows.splice(0, this.config.skipHeader);
            if (this.config.nameByHeader) {
                names = top_1[0].trim().split(this.config.column);
            }
        }
        return rows.map(function (row) { return _this.getFields(row, names); });
    };
    return CsvDriver;
}());
exports.CsvDriver = CsvDriver;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var JsonDriver = /** @class */ (function () {
    function JsonDriver() {
    }
    JsonDriver.prototype.toJsonArray = function (data) {
        return this.getRows(data);
    };
    JsonDriver.prototype.getFields = function (row) {
        return row;
    };
    JsonDriver.prototype.getRows = function (data) {
        return typeof data === "string" ? JSON.parse(data) : data;
    };
    return JsonDriver;
}());
exports.JsonDriver = JsonDriver;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var datacollection_1 = __webpack_require__(19);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
function addToOrder(store, obj, parent, index) {
    if (index !== undefined && index !== -1 && store[parent] && store[parent][index]) {
        store[parent].splice(index, 0, obj);
    }
    else {
        if (!store[parent]) {
            store[parent] = [];
        }
        store[parent].push(obj);
    }
}
var TreeCollection = /** @class */ (function (_super) {
    __extends(TreeCollection, _super);
    function TreeCollection(config, events) {
        var _a;
        var _this = _super.call(this, config, events) || this;
        var root = _this._root = "_ROOT_" + core_1.uid();
        _this._childs = (_a = {}, _a[root] = [], _a);
        _this._initChilds = null;
        return _this;
    }
    TreeCollection.prototype.add = function (obj, index, parent) {
        if (index === void 0) { index = -1; }
        if (parent === void 0) { parent = this._root; }
        if (typeof obj !== "object") {
            obj = {
                value: obj
            };
        }
        obj.parent = obj.parent ? obj.parent.toString() : parent;
        _super.prototype.add.call(this, obj, index);
    };
    TreeCollection.prototype.getRoot = function () {
        return this._root;
    };
    TreeCollection.prototype.getParent = function (id, asObj) {
        if (asObj === void 0) { asObj = false; }
        if (!this._pull[id]) {
            return null;
        }
        var parent = this._pull[id].parent;
        return asObj ? this._pull[parent] : parent;
    };
    TreeCollection.prototype.getChilds = function (id) {
        if (this._childs && this._childs[id]) {
            return this._childs[id];
        }
        return [];
    };
    TreeCollection.prototype.getLength = function (id) {
        if (id === void 0) { id = this._root; }
        if (!this._childs[id]) {
            return null;
        }
        return this._childs[id].length;
    };
    TreeCollection.prototype.removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_1 = childs; _i < childs_1.length; _i++) {
                var child = childs_1[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype.removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype.getIndex = function (id) {
        var parent = this.getParent(id);
        if (!parent || !this._childs[parent]) {
            return -1;
        }
        return core_1.findIndex(this._childs[parent], function (item) { return item.id === id; });
    };
    TreeCollection.prototype.sort = function (conf) {
        var childs = this._childs;
        for (var key in childs) {
            this._sort.sort(childs[key], conf);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.map = function (cb, parent, direct) {
        if (parent === void 0) { parent = this._root; }
        if (direct === void 0) { direct = true; }
        var result = [];
        if (!this.haveChilds(parent)) {
            return result;
        }
        for (var i = 0; i < this._childs[parent].length; i++) {
            result.push(cb.call(this, this._childs[parent][i], i));
            if (direct) {
                var childResult = this.map(cb, this._childs[parent][i].id, direct);
                result = result.concat(childResult);
            }
        }
        return result;
    };
    TreeCollection.prototype.filter = function (conf) {
        if (!conf) {
            this.restoreOrder();
            return;
        }
        if (!this._initChilds) {
            this._initChilds = this._childs;
        }
        conf.type = conf.type || types_1.TreeFilterType.all;
        var newChilds = {};
        this._recursiveFilter(conf, this._root, 0, newChilds);
        this._childs = newChilds;
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.restoreOrder = function () {
        if (this._initChilds) {
            this._childs = this._initChilds;
            this._initChilds = null;
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.copy = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        var childs = __assign({}, this._childs);
        var currentChilds = childs[id];
        if (target === this && !this.canCopy(id, targetId)) {
            return null;
        }
        if (!(target instanceof TreeCollection)) { // copy to datacollection
            target.add(this._pull[id]);
            return;
        }
        if (this.exists(id)) {
            var item = __assign({}, this.getItem(id));
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            else {
                item.id = id;
            }
            item.parent = targetId;
            target.add(item, index);
            id = item.id;
        }
        if (currentChilds) {
            for (var _i = 0, currentChilds_1 = currentChilds; _i < currentChilds_1.length; _i++) {
                var child = currentChilds_1[_i];
                var childId = child.id;
                var childIndex = this.getIndex(childId);
                this.copy(childId, childIndex, target, id);
            }
        }
        return id;
    };
    TreeCollection.prototype.move = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        if (target !== this) {
            if (!(target instanceof TreeCollection)) { // move to datacollection
                target.add(this._pull[id]);
                this.remove(id);
                return;
            }
            var returnId = this.copy(id, index, target, targetId);
            this.remove(id);
            return returnId;
        }
        // move inside
        if (!this.canCopy(id, targetId)) {
            return null;
        }
        var parent = this.getParent(id);
        var parentIndex = this.getIndex(id);
        // get item from parent array and move to target array
        var spliced = this._childs[parent].splice(parentIndex, 1)[0];
        spliced.parent = targetId; // need for next moving, ... not best solution, may be full method for get item
        if (!this._childs[parent].length) {
            delete this._childs[parent];
        }
        if (!this.haveChilds(targetId)) {
            this._childs[targetId] = [];
        }
        if (index === -1) {
            index = this._childs[targetId].push(spliced);
        }
        else {
            this._childs[targetId].splice(index, 0, spliced);
        }
        this.events.fire(types_1.DataEvents.change);
        return id;
    };
    TreeCollection.prototype.eachChild = function (id, cb, direct) {
        if (direct === void 0) { direct = true; }
        if (!this.haveChilds(id)) {
            return;
        }
        for (var i = 0; i < this._childs[id].length; i++) {
            cb.call(this, this._childs[id][i], i);
            if (direct && this.getItem(this._childs[id][i].id).$opened !== false) {
                this.eachChild(this._childs[id][i].id, cb, direct);
            }
        }
    };
    TreeCollection.prototype.getNearId = function (id) {
        return id; // for selection
    };
    TreeCollection.prototype.loadChilds = function (id, driver) {
        var _this = this;
        if (driver === void 0) { driver = "json"; }
        var url = this.config.autoload + "?id=" + id;
        var proxy = new dataproxy_1.DataProxy(url);
        proxy.load().then(function (data) {
            driver = helpers_1.toDataDriver(driver);
            data = driver.toJsonArray(data);
            _this._parse_data(data, id);
            _this.events.fire(types_1.DataEvents.change);
        });
    };
    TreeCollection.prototype.refreshChilds = function (id, driver) {
        if (driver === void 0) { driver = "json"; }
        this.removeAll(id);
        this.loadChilds(id, driver);
    };
    TreeCollection.prototype.eachParent = function (id, cb, self) {
        if (self === void 0) { self = false; }
        var item = this.getItem(id);
        if (!item) {
            return;
        }
        if (self) {
            cb.call(this, item);
        }
        if (item.parent === this._root) {
            return;
        }
        var parent = this.getItem(item.parent);
        cb.call(this, parent);
        this.eachParent(item.parent, cb);
    };
    TreeCollection.prototype.haveChilds = function (id) {
        return id in this._childs;
    };
    TreeCollection.prototype.canCopy = function (id, target) {
        if (id === target) {
            return false;
        }
        var canCopy = true;
        this.eachParent(target, function (item) { return item.id === id ? canCopy = false : null; }); // locate return string
        return canCopy;
    };
    TreeCollection.prototype.serialize = function (fn) {
        return this._serialize(this._root, fn);
    };
    TreeCollection.prototype.getId = function (index, parent) {
        if (parent === void 0) { parent = this._root; }
        if (!this._childs[parent] || !this._childs[parent][index]) {
            return;
        }
        return this._childs[parent][index].id;
    };
    TreeCollection.prototype._removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_2 = childs; _i < childs_2.length; _i++) {
                var child = childs_2[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype._removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype._removeCore = function (id) {
        if (this._pull[id]) {
            var parent_1 = this.getParent(id);
            this._childs[parent_1] = this._childs[parent_1].filter(function (item) { return item.id !== id; });
            if (parent_1 !== this._root && !this._childs[parent_1].length) {
                delete this._childs[parent_1];
            }
            if (this._initChilds && this._initChilds[parent_1]) {
                this._initChilds[parent_1] = this._initChilds[parent_1].filter(function (item) { return item.id !== id; });
                if (parent_1 !== this._root && !this._initChilds[parent_1].length) {
                    delete this._initChilds[parent_1];
                }
            }
            this._fastDeleteChilds(this._childs, id);
            if (this._initChilds) {
                this._fastDeleteChilds(this._initChilds, id);
            }
        }
    };
    TreeCollection.prototype._addToOrder = function (_order, obj, index) {
        var childs = this._childs;
        var initChilds = this._initChilds;
        var parent = obj.parent;
        this._pull[obj.id] = obj;
        addToOrder(childs, obj, parent, index);
        if (initChilds) {
            addToOrder(initChilds, obj, parent, index);
        }
    };
    TreeCollection.prototype._parse_data = function (data, parent) {
        if (parent === void 0) { parent = this._root; }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            if (typeof obj !== "object") {
                obj = {
                    value: obj
                };
            }
            obj.id = obj.id ? obj.id.toString() : core_1.uid();
            obj.parent = obj.parent ? obj.parent.toString() : parent;
            this._pull[obj.id] = obj;
            if (!this._childs[obj.parent]) {
                this._childs[obj.parent] = [];
            }
            this._childs[obj.parent].push(obj);
            if (obj.childs && obj.childs instanceof Object) {
                this._parse_data(obj.childs, obj.id);
            }
        }
    };
    TreeCollection.prototype._fastDeleteChilds = function (target, id) {
        if (this._pull[id]) {
            delete this._pull[id];
        }
        if (!target[id]) {
            return;
        }
        for (var i = 0; i < target[id].length; i++) {
            this._fastDeleteChilds(target, target[id][i].id);
        }
        delete target[id];
    };
    TreeCollection.prototype._recursiveFilter = function (conf, current, level, newChilds) {
        var _this = this;
        var childs = this._childs[current];
        if (!childs) {
            return;
        }
        var condition = function (item) {
            switch (conf.type) {
                case types_1.TreeFilterType.all: {
                    return true;
                }
                case types_1.TreeFilterType.specific: {
                    return level === conf.specific;
                }
                case types_1.TreeFilterType.leafs: {
                    return !_this.haveChilds(item.id);
                }
            }
        };
        if (conf.by && conf.match) {
            var customRule = function (item) { return !condition(item) || item[conf.by].toString().toLowerCase().indexOf(conf.match.toString().toLowerCase()) !== -1; };
            newChilds[current] = childs.filter(customRule);
        }
        else if (conf.rule && typeof conf.rule === "function") {
            var customRule = function (item) { return !condition(item) || conf.rule(item); };
            var filtered = childs.filter(customRule);
            if (filtered.length) {
                newChilds[current] = filtered;
            }
        }
        for (var _i = 0, childs_3 = childs; _i < childs_3.length; _i++) {
            var child = childs_3[_i];
            this._recursiveFilter(conf, child.id, level + 1, newChilds);
        }
    };
    TreeCollection.prototype._serialize = function (parent, fn) {
        var _this = this;
        if (parent === void 0) { parent = this._root; }
        return this.map(function (item) {
            var itemCopy = {};
            for (var key in item) {
                if (key === "parent" || key === "childs") {
                    continue;
                }
                itemCopy[key] = item[key];
            }
            if (fn) {
                itemCopy = fn(itemCopy);
            }
            if (_this.haveChilds(item.id)) {
                itemCopy.childs = _this._serialize(item.id, fn);
            }
            return itemCopy;
        }, parent, false);
    };
    return TreeCollection;
}(datacollection_1.DataCollection));
exports.TreeCollection = TreeCollection;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var tooltip_1 = __webpack_require__(25);
var Position;
(function (Position) {
    Position["right"] = "right";
    Position["bottom"] = "bottom";
    Position["center"] = "center";
})(Position = exports.Position || (exports.Position = {}));
var nodeTimeout = new WeakMap();
var messageStack = [];
var messageContainer = document.createElement("div");
messageContainer.className = "dhx-message-container";
function onExpire(node, fromClick) {
    if (fromClick) {
        clearTimeout(nodeTimeout.get(node));
    }
    var index = messageStack.indexOf(node);
    if (index < 0) { // node in body
        document.body.removeChild(node);
        return;
    }
    messageContainer.removeChild(node);
    messageStack.splice(index, 1);
    if (messageStack.length === 0) {
        document.body.removeChild(messageContainer);
    }
}
function message(props) {
    if (typeof props === "string") {
        props = { text: props };
    }
    var messageBox = document.createElement("div");
    messageBox.className = "dhx-message " + (props.css || "");
    messageBox.innerHTML = "<span class=\"message-text\">" + props.text + "</span> <div class=\"dxi " + props.icon + "\"></div>";
    if (props.at) {
        messageBox.style.position = "absolute";
        var _a = props.at, node = _a.node, position = _a.position;
        var elem = html_1.toNode(node);
        var rects = elem.getBoundingClientRect();
        document.body.appendChild(messageBox); // for calc bounings
        var _b = messageBox.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = tooltip_1.findPosition(rects, position, width, height), left = _c.left, top_1 = _c.top, pos = _c.pos;
        messageBox.className += " " + pos;
        messageBox.style.left = left + "px";
        messageBox.style.top = top_1 + "px";
    }
    else {
        if (messageStack.length === 0) {
            document.body.appendChild(messageContainer);
        }
        messageStack.push(messageBox);
        messageContainer.appendChild(messageBox);
    }
    if (props.expire) {
        var timeout = setTimeout(function () { return onExpire(messageBox); }, props.expire);
        nodeTimeout.set(messageBox, timeout);
    }
    messageBox.onclick = function () { return onExpire(messageBox, true); };
}
exports.message = message;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var message_1 = __webpack_require__(24);
var RealPosition;
(function (RealPosition) {
    RealPosition["left"] = "left";
    RealPosition["right"] = "right";
    RealPosition["top"] = "top";
    RealPosition["bottom"] = "bottom";
    RealPosition["center"] = "center";
})(RealPosition = exports.RealPosition || (exports.RealPosition = {}));
function findPosition(targetRect, position, width, height) {
    var margin = 8; // margin top/bot, left/right
    var pos;
    var left;
    var top;
    switch (position) {
        case message_1.Position.center:
            left = targetRect.left + window.pageXOffset + (targetRect.width - width) / 2;
            if (left + margin < window.pageXOffset) {
                left = targetRect.left + window.pageXOffset;
            }
            top = targetRect.top + window.pageYOffset + (targetRect.height - height) / 2;
            pos = RealPosition.center;
            return { left: left, top: top, pos: pos };
        case message_1.Position.right:
            pos = RealPosition.right;
            left = targetRect.right + window.pageXOffset;
            if (left + width + margin > window.innerWidth + window.pageXOffset) { // set left
                left = window.pageXOffset + targetRect.left - width;
                pos = RealPosition.left;
            }
            top = window.pageYOffset + targetRect.top + (targetRect.height - height) / 2;
            return { left: left, top: top, pos: pos };
        case message_1.Position.bottom:
            left = window.pageXOffset + targetRect.left + (targetRect.width - width) / 2;
            if (left < window.pageXOffset) {
                left = window.pageXOffset + targetRect.left;
            }
            pos = RealPosition.bottom;
            top = window.pageYOffset + targetRect.bottom;
            if (top + height + margin > window.innerHeight + window.pageYOffset) { // set top
                top = window.pageYOffset + targetRect.top - height;
                pos = RealPosition.top;
            }
            return { left: left, top: top, pos: pos };
    }
}
exports.findPosition = findPosition;
// tooltip init
var tooltipBox = document.createElement("div");
var tooltipText = document.createElement("span");
tooltipText.className = "tooltip-text";
tooltipBox.appendChild(tooltipText);
tooltipBox.style.position = "absolute";
var timeoutId = null;
var lastNode = null;
var isActive = false;
var hideTimeout = null;
function showTooltip(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var rects = node.getBoundingClientRect();
    tooltipText.textContent = text;
    document.body.appendChild(tooltipBox);
    tooltipBox.className = "dhx-tooltip" + (force ? " forced" : "");
    var _a = tooltipBox.getBoundingClientRect(), width = _a.width, height = _a.height;
    var _b = findPosition(rects, position, width, height), left = _b.left, top = _b.top, pos = _b.pos;
    switch (pos) {
        case RealPosition.bottom:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.top:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.left:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.right:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.center:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
    }
    tooltipBox.className += " " + pos + " " + (css || "");
    isActive = true;
    if (!force) {
        setTimeout(function () {
            tooltipBox.className += " animate-tooltip";
        });
    }
}
function hideTooltip() {
    if (lastNode) {
        hideTimeout = setTimeout(function () {
            document.body.removeChild(tooltipBox);
            isActive = false;
            hideTimeout = null;
        }, 200);
    }
}
function addListners(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var mousemove = function () {
        if (isActive) {
            return;
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(function () {
            showTooltip(node, text, position, css);
        }, 750);
    };
    var mouseout = function () {
        if (isActive) {
            hideTooltip();
        }
        clearTimeout(timeoutId);
        if (!force) {
            document.removeEventListener("mousemove", mousemove);
        }
        document.removeEventListener("mouseout", mouseout);
        document.removeEventListener("click", mouseout);
        lastNode = null;
    };
    if (force) {
        showTooltip(node, text, position, css, force);
    }
    else {
        document.addEventListener("mousemove", mousemove);
    }
    document.addEventListener("mouseout", mouseout);
    document.addEventListener("click", mouseout);
}
// default
function tooltip(text, at) {
    var node = html_1.toNode(at.node);
    if (node === lastNode) {
        return;
    }
    lastNode = node;
    if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
        addListners(node, text, at.position, at.css, true);
    }
    else {
        addListners(node, text, at.position || message_1.Position.bottom, at.css);
    }
}
exports.tooltip = tooltip;
function enableTooltip() {
    document.addEventListener("mousemove", _mousemove);
}
exports.enableTooltip = enableTooltip;
function disableTooltip() {
    document.removeEventListener("mousemove", _mousemove);
}
exports.disableTooltip = disableTooltip;
function _mousemove(e) {
    var node = html_1.locateNode(e, "dhx_tooltip_text");
    if (!node) {
        return;
    }
    tooltip(node.getAttribute("dhx_tooltip_text"), {
        position: node.getAttribute("dhx_tooltip_position") || message_1.Position.bottom,
        node: node
    });
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ts_message_1 = __webpack_require__(16);
var types_1 = __webpack_require__(4);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var MenuBase_1 = __webpack_require__(18);
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            navigationType: "click"
        }, config)) || this;
        _this._currentRoot = null;
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.button);
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Toolbar.prototype.getValues = function () {
        var state = {};
        this.data.eachChild(this.data.getRoot(), function (item) {
            if (item.twoState) {
                state[item.id] = item.active;
            }
            else if (item.type === types_1.ItemType.input) {
                state[item.id] = item.value;
            }
        }, false);
        for (var key in this._groups) {
            if (this._groups[key].active) {
                state[key] = this._groups[key].active;
            }
        }
        return state;
    };
    Toolbar.prototype.setValues = function (state) {
        for (var key in state) {
            if (this._groups[key]) {
                if (this._groups[key].active) {
                    this.data.update(this._groups[key].active, { active: false });
                    this._groups[key].active = state[key];
                    this.data.update(state[key], { active: true });
                }
            }
            else {
                var item = this.data.getItem(key);
                if (item.type === types_1.ItemType.input) {
                    this.data.update(key, { value: state[key] });
                }
                else {
                    this.data.update(key, { active: state[key] });
                }
            }
        }
    };
    Toolbar.prototype._initHandlers = function () {
        var _this = this;
        _super.prototype._initHandlers.call(this);
        this._onInput = function (e) {
            var id = html_1.locate(e);
            _this.data.update(id, { value: e.target.value });
        };
        this._showTooltip = function (e) {
            var elem = html_1.locateNode(e);
            if (!elem) {
                return;
            }
            var id = elem.getAttribute("dhx_id");
            var item = _this.data.getItem(id);
            if (item.tooltip) {
                ts_message_1.tooltip(item.tooltip, {
                    node: elem,
                    position: ts_message_1.Position.bottom
                });
            }
        };
    };
    Toolbar.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".toolbar.dhx_widget" + (this.config.css ? "." + this.config.css : ""), {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick,
            oninput: this._onInput,
            onmouseover: this._showTooltip
        }, this.data.map(function (item) { return _this._factory(item, _this.events); }, this.data.getRoot(), false));
    };
    Toolbar.prototype._getMode = function (item, root) {
        return item.id === root ? "bottom" : "right";
    };
    Toolbar.prototype._close = function () {
        this._activeMenu = null;
        this._activePosition = null;
        this._currentRoot = null;
        this.paint();
    };
    Toolbar.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem || item.type === types_1.ItemType.selectButton) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    if (item.parent !== root) {
                        item.$openIcon = "right";
                    }
                    else {
                        item.$openIcon = "bot";
                    }
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Toolbar.prototype._setRoot = function (id) {
        if (this.data.getParent(id) === this.data.getRoot()) { // if we clicked on item which not belong root, we cant set it as root item
            this._currentRoot = id;
        }
    };
    return Toolbar;
}(MenuBase_1.MenuBase));
exports.Toolbar = Toolbar;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var ts_data_1 = __webpack_require__(8);
exports.DataCollection = ts_data_1.DataCollection;
var ts_message_1 = __webpack_require__(16);
exports.message = ts_message_1.message;
__export(__webpack_require__(42));
__export(__webpack_require__(15));
var en_1 = __webpack_require__(14);
exports.i18n = {};
exports.i18n.setLocale = function (component, value) {
    var target = exports.i18n[component];
    for (var key in value) {
        target[key] = value[key];
    }
};
exports.i18n.vault = exports.i18n.vault || en_1.default;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Loader = /** @class */ (function () {
    function Loader(parent, changes) {
        this._parent = parent;
        this._changes = changes; // todo: [dirty] mutation
    }
    Loader.prototype.load = function (url, driver) {
        var _this = this;
        return this._parent.loadData = url.load().then(function (data) {
            _this._parent.removeAll();
            _this.parse(data, driver);
        });
    };
    Loader.prototype.parse = function (data, driver) {
        if (driver === void 0) { driver = "json"; }
        driver = helpers_1.toDataDriver(driver);
        data = driver.toJsonArray(data);
        this._parent.$parse(data);
    };
    Loader.prototype.save = function (url) {
        var _this = this;
        var _loop_1 = function (el) {
            if (el.saving || el.pending) {
                helpers_1.dhxWarning("item is saving");
            }
            else {
                var prevEl_1 = this_1._findPrevState(el.id);
                if (prevEl_1 && prevEl_1.saving) {
                    var pending = new Promise(function (res, rej) {
                        prevEl_1.promise.then(function () {
                            el.pending = false;
                            res(_this._setPromise(el, url));
                        }).catch(function (err) {
                            _this._removeFromOrder(prevEl_1);
                            _this._setPromise(el, url);
                            helpers_1.dhxWarning(err);
                            rej(err);
                        });
                    });
                    this_1._addToChain(pending);
                    el.pending = true;
                }
                else {
                    this_1._setPromise(el, url);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            _loop_1(el);
        }
        this._parent.saveData.then(function () {
            _this._saving = false;
        });
    };
    Loader.prototype._setPromise = function (el, url) {
        var _this = this;
        el.promise = url.save(el.obj, el.status);
        el.promise.then(function () {
            _this._removeFromOrder(el);
        }).catch(function (err) {
            el.saving = false;
            el.error = true;
            helpers_1.dhxError(err);
        });
        el.saving = true;
        this._saving = true;
        this._addToChain(el.promise);
        return el.promise;
    };
    Loader.prototype._addToChain = function (promise) {
        // tslint:disable-next-line:prefer-conditional-expression
        if (this._parent.saveData && this._saving) {
            this._parent.saveData = this._parent.saveData.then(function () { return promise; });
        }
        else {
            this._parent.saveData = promise;
        }
    };
    Loader.prototype._findPrevState = function (id) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            if (el.id === id) {
                return el;
            }
        }
        return null;
    };
    Loader.prototype._removeFromOrder = function (el) {
        this._changes.order = this._changes.order.filter(function (item) { return !helpers_1.isEqualObj(item, el); });
    };
    return Loader;
}());
exports.Loader = Loader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(33);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(34)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Sort = /** @class */ (function () {
    function Sort() {
    }
    Sort.prototype.sort = function (array, by) {
        var _this = this;
        if (by.rule && typeof by.rule === "function") {
            this._sort(array, by);
        }
        else if (by.by) {
            by.rule = function (a, b) {
                var aa = _this._checkVal(by.as, a[by.by]);
                var bb = _this._checkVal(by.as, b[by.by]);
                return helpers_1.naturalCompare(aa.toString(), bb.toString()); // didnt work with numbers
            };
            this._sort(array, by);
        }
    };
    Sort.prototype._checkVal = function (method, val) {
        return method ? method.call(this, val) : val;
    };
    Sort.prototype._sort = function (arr, conf) {
        var _this = this;
        var dir = {
            asc: 1,
            desc: -1
        };
        return arr.sort(function (a, b) {
            return conf.rule.call(_this, a, b) * (dir[conf.dir] || dir.asc);
        });
    };
    return Sort;
}());
exports.Sort = Sort;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var types_1 = __webpack_require__(5);
var CollectionStore_1 = __webpack_require__(38);
var treecollection_1 = __webpack_require__(23);
var types_2 = __webpack_require__(6);
var DropPosition;
(function (DropPosition) {
    DropPosition[DropPosition["top"] = 0] = "top";
    DropPosition[DropPosition["bot"] = 1] = "bot";
    DropPosition[DropPosition["in"] = 2] = "in";
})(DropPosition || (DropPosition = {}));
function getParentElement(target) {
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        var id = target.getAttribute("dhx_id");
        if (id) {
            return target;
        }
        target = target.parentNode;
    }
}
function getPosition(ev) {
    var y = ev.y;
    var element = getParentElement(ev); // may be use domvm refs
    if (!element) {
        return null;
    }
    var treeLine = element.childNodes[0];
    var _a = treeLine.getBoundingClientRect(), top = _a.top, height = _a.height;
    return (y - top) / height;
}
function dragEventContent(item) {
    var ghost = document.createElement("div");
    ghost.textContent = item.value || item.text;
    ghost.className = "drag-ghost"; // need pointer-events: none
    return ghost;
}
var DragManager = /** @class */ (function () {
    function DragManager() {
        var _this = this;
        this._transferData = {};
        this._canMove = true;
        this._ghostTopPadding = -17;
        this._onMouseMove = function (e) {
            if (!_this._transferData.id) {
                return;
            }
            var pageX = e.pageX, pageY = e.pageY;
            if (!_this._transferData.ghost) {
                if (Math.abs(_this._transferData.x - pageX) < 3 && Math.abs(_this._transferData.y - pageY) < 3) {
                    return;
                }
                else {
                    var ghost = _this._onDragStart(_this._transferData.id, _this._transferData.targetId);
                    if (!ghost) {
                        _this._endDrop();
                        return;
                    }
                    else {
                        _this._transferData.ghost = ghost;
                        document.body.appendChild(_this._transferData.ghost);
                    }
                }
            }
            _this._moveGhost(pageX, pageY);
            _this._onDrag(e);
        };
        this._onMouseUp = function () {
            if (!_this._transferData.x) {
                return;
            }
            if (_this._transferData.ghost) {
                _this._removeGhost();
                _this._onDrop();
            }
            else {
                _this._endDrop();
            }
            document.removeEventListener("mousemove", _this._onMouseMove);
            document.removeEventListener("mouseup", _this._onMouseUp);
        };
    }
    DragManager.prototype.setItem = function (id, item, config) {
        // const collection = document.querySelector(`[dhx_collection_id=${id}]`); // use it for add onmousedown here
        CollectionStore_1.collectionStore.setItem(id, item, config);
    };
    DragManager.prototype.onMouseDown = function (e) {
        if (e.which !== 1) {
            return;
        }
        document.addEventListener("mousemove", this._onMouseMove);
        document.addEventListener("mouseup", this._onMouseUp);
        var id = html_1.locate(e, "dhx_id");
        var targetId = html_1.locate(e, "dhx_collection_id");
        if (id && targetId) {
            this._transferData.x = e.x;
            this._transferData.y = e.y;
            this._transferData.targetId = targetId;
            this._transferData.id = id;
        }
    };
    DragManager.prototype._moveGhost = function (x, y) {
        if (this._transferData.ghost) {
            var width = this._transferData.ghost.offsetWidth / 2;
            this._transferData.ghost.style.left = x - width + "px";
            this._transferData.ghost.style.top = y + this._ghostTopPadding + "px";
        }
    };
    DragManager.prototype._removeGhost = function () {
        document.body.removeChild(this._transferData.ghost);
    };
    DragManager.prototype._onDrop = function () {
        if (!this._canMove) {
            this._endDrop();
            return;
        }
        var target = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        var config = CollectionStore_1.collectionStore.getItemConfig(this._lastCollectionId);
        if (!target || config.mode === types_2.DragMode.source) {
            this._endDrop();
            return;
        }
        var to = {
            id: this._lastId,
            target: target
        };
        var from = {
            id: this._transferData.id,
            target: this._transferData.target
        };
        if (from.target.events.fire(types_1.DragEvents.beforeDrop, [from, to])) {
            this._move(from, to);
            to.target.events.fire(types_1.DragEvents.dropComplete, [to.id, this._transferData.dropPosition]);
        }
        this._endDrop();
    };
    DragManager.prototype._onDragStart = function (id, targetId) {
        var target = CollectionStore_1.collectionStore.getItem(targetId);
        var config = CollectionStore_1.collectionStore.getItemConfig(targetId);
        if (config.dragMode === types_2.DragMode.target) {
            return null;
        }
        var item = target.data.getItem(id);
        target.events.fire(types_1.DragEvents.dragStart); // we need it for cancel selection
        var ghost = dragEventContent(item);
        var ans = target.events.fire(types_1.DragEvents.beforeDrag, [item, ghost]);
        if (!ans || !id) {
            return null;
        }
        this._toggleTextSelection(true);
        this._transferData.target = target;
        this._transferData.dragConfig = config;
        return ghost;
    };
    DragManager.prototype._onDrag = function (e) {
        var x = e.x, y = e.y;
        var element = document.elementFromPoint(x, y);
        var id = html_1.locate(element, "dhx_id");
        if (!id) {
            this._cancelCanDrop();
            return;
        }
        var collectionId = html_1.locate(element, "dhx_collection_id");
        if (this._transferData.dragConfig.behaviour === types_2.DragBehaviour.complex) {
            var pos = getPosition(e);
            if (pos <= 0.25) {
                this._transferData.dropPosition = DropPosition.top;
            }
            else if (pos >= 0.75) {
                this._transferData.dropPosition = DropPosition.bot;
            }
            else {
                this._transferData.dropPosition = DropPosition.in;
            }
        }
        else if (this._lastId === id && this._lastCollectionId === collectionId) {
            return;
        }
        var eventArgs;
        var from;
        var targetTo;
        if ((!id || !collectionId) && this._canMove) {
            this._cancelCanDrop();
            return;
        }
        else {
            from = {
                id: this._transferData.id,
                target: this._transferData.target
            };
            targetTo = CollectionStore_1.collectionStore.getItem(collectionId);
            eventArgs = [from, {
                    id: id,
                    target: targetTo
                }];
            from.target.events.fire(types_1.DragEvents.dragOut, eventArgs);
        }
        if (collectionId !== this._transferData.targetId || !(from.target.data instanceof treecollection_1.TreeCollection) ||
            (from.target.data instanceof treecollection_1.TreeCollection && from.target.data.canCopy(from.id, id))) {
            // handle cursor or something, can drop
            this._cancelCanDrop(); // clear last
            this._lastId = id;
            this._lastCollectionId = collectionId;
            eventArgs.push(this._transferData.dropPosition);
            var canMove = from.target.events.fire(types_1.DragEvents.dragIn, eventArgs);
            if (canMove) {
                this._canDrop();
            }
        }
        else {
            this._cancelCanDrop();
        }
    };
    DragManager.prototype._move = function (from, to) {
        var fromData = from.target.data;
        var toData = to.target.data;
        var index = 0;
        var targetId = to.id;
        var behaviour = this._transferData.dragConfig.behaviour;
        switch (behaviour) {
            case types_2.DragBehaviour.child:
                break;
            case types_2.DragBehaviour.sibling:
                targetId = toData.getParent(targetId);
                index = toData.getIndex(to.id) + 1;
                break;
            case types_2.DragBehaviour.complex:
                var dropPosition = this._transferData.dropPosition;
                if (dropPosition === DropPosition.top) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id);
                }
                else if (dropPosition === DropPosition.bot) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id) + 1;
                }
                break;
        }
        if (this._transferData.dragConfig.copy) {
            fromData.copy(from.id, index, toData, targetId);
        }
        else {
            fromData.move(from.id, index, toData, targetId);
        }
    };
    DragManager.prototype._endDrop = function () {
        this._toggleTextSelection(false);
        if (this._transferData.target) {
            this._transferData.target.events.fire(types_1.DragEvents.dragEnd);
        }
        this._cancelCanDrop();
        this._canMove = true;
        this._transferData = {};
        this._lastId = null;
        this._lastCollectionId = null;
    };
    DragManager.prototype._cancelCanDrop = function () {
        this._canMove = false;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.cancelDrop, [this._lastId]);
        }
    };
    DragManager.prototype._canDrop = function () {
        this._canMove = true;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.canDrop, [this._lastId, this._transferData.dropPosition]);
        }
    };
    DragManager.prototype._toggleTextSelection = function (add) {
        if (add) {
            document.body.classList.add("dhx-no-select");
        }
        else {
            document.body.classList.remove("dhx-no-select");
        }
    };
    return DragManager;
}());
exports.dragManager = new DragManager();


/***/ }),
/* 37 */
/***/ (function(module, exports) {

if (Element && !Element.prototype.matches) {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector ||
        proto.mozMatchesSelector || proto.msMatchesSelector ||
        proto.oMatchesSelector || proto.webkitMatchesSelector;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CollectionStore = /** @class */ (function () {
    function CollectionStore() {
        this._store = {};
    }
    CollectionStore.prototype.setItem = function (id, target, config) {
        this._store[id] = {
            target: target,
            config: config
        };
    };
    CollectionStore.prototype.getItem = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].target;
    };
    CollectionStore.prototype.getItemConfig = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].config;
    };
    return CollectionStore;
}());
exports.collectionStore = new CollectionStore();


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(6);
var Selection = /** @class */ (function () {
    function Selection(_config, data, events) {
        var _this = this;
        this.events = events || (new events_1.EventSystem());
        this._data = data;
        this._data.events.on(types_2.DataEvents.removeAll, function () {
            _this._selected = null;
        });
        this._data.events.on(types_2.DataEvents.change, function () {
            if (_this._selected) {
                var near = _this._data.getNearId(_this._selected);
                if (near !== _this._selected) {
                    _this._selected = null;
                    if (near) {
                        _this.add(near);
                    }
                }
            }
        });
    }
    Selection.prototype.getId = function () {
        return this._selected;
    };
    Selection.prototype.getItem = function () {
        if (this._selected) {
            return this._data.getItem(this._selected);
        }
        return null;
    };
    Selection.prototype.remove = function (id) {
        id = id || this._selected;
        if (!id) {
            return true;
        }
        if (this.events.fire(types_1.SelectionEvents.beforeUnSelect, [id])) {
            this._data.update(id, { $selected: false });
            this._selected = null;
            this.events.fire(types_1.SelectionEvents.afterUnSelect, [id]);
            return true;
        }
        return false;
    };
    Selection.prototype.add = function (id) {
        if (this._selected === id) {
            return;
        }
        this.remove();
        if (this.events.fire(types_1.SelectionEvents.beforeSelect, [id])) {
            this._selected = id;
            this._data.update(id, { $selected: true });
            this.events.fire(types_1.SelectionEvents.afterSelect, [id]);
        }
    };
    return Selection;
}());
exports.Selection = Selection;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(41);
function blockKeys(e) {
    var active = document.activeElement;
    if (!active.classList.contains("apply-button") && !active.classList.contains("reject-button")) {
        e.preventDefault();
    }
}
function blockScreen(css) {
    var blocker = document.createElement("div");
    blocker.className = "dhx-blocker " + (css || "");
    document.body.appendChild(blocker);
    document.addEventListener("keydown", blockKeys);
    return function () {
        document.body.removeChild(blocker);
        document.removeEventListener("keydown", blockKeys);
    };
}
exports.blockScreen = blockScreen;
function alert(props) {
    var apply = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.apply;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var alertBox = document.createElement("div");
        alertBox.className = "dhx-alert " + (props.css || "");
        alertBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"alert-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"apply-button alert-btn dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(alertBox);
        alertBox.querySelector(".apply-button").focus();
        alertBox.querySelector("button").addEventListener("click", function () {
            unblock();
            document.body.removeChild(alertBox);
            res(true);
        });
    });
}
exports.alert = alert;
function confirm(props) {
    var apply = props.buttons && props.buttons[1] ? props.buttons[1] : en_1.default.apply;
    var reject = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.reject;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var answer = function (val) {
            unblock();
            confirmBox.removeEventListener("click", clickHandler);
            document.body.removeChild(confirmBox);
            res(val);
        };
        var confirmBox = document.createElement("div");
        confirmBox.className = "dhx-confirm " + (props.css || "");
        confirmBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"confirm-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"reject-button dhx_btn dhx_btn--link\">" + reject + "</button>\n\t\t\t\t<button class=\"apply-button dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(confirmBox);
        confirmBox.querySelector(".reject-button").focus();
        var clickHandler = function (e) {
            if (e.target.tagName === "BUTTON") {
                answer(e.target.classList.contains("apply-button"));
            }
        };
        confirmBox.addEventListener("click", clickHandler);
    });
}
exports.confirm = confirm;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    apply: "apply",
    reject: "reject"
};
exports.default = locale;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var html_1 = __webpack_require__(1);
var scrollView_1 = __webpack_require__(44);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var ts_layout_1 = __webpack_require__(45);
var ts_message_1 = __webpack_require__(16);
var ts_toolbar_1 = __webpack_require__(48);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var Uploader_1 = __webpack_require__(64);
var configs_1 = __webpack_require__(65);
var helper_1 = __webpack_require__(66);
var ProgressBar_1 = __webpack_require__(67);
var ReadStackPreview_1 = __webpack_require__(68);
var Vault = /** @class */ (function (_super) {
    __extends(Vault, _super);
    function Vault(container, config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, null, core_1.extend({
            mode: types_1.VaultMode.list,
            toolbar: true,
            updateFromResponse: true,
            scaleFactor: 4,
            customScroll: true,
            uploader: {},
            progressBar: {}
        }, config)) || this;
        if (!_this.config.toolbar) {
            _this.config.uploader.autosend = true;
        }
        if (config.data) {
            _this.data = config.data;
            _this.events = config.data.events;
            _this.events.context = _this;
        }
        else {
            _this.events = new events_1.EventSystem(_this);
            _this.data = new ts_data_1.DataCollection({}, _this.events);
        }
        _this.data.config.init = function (obj) {
            obj.status = obj.status || types_1.FileStatus.uploaded;
            if (obj.file) {
                obj.size = obj.file.size;
                obj.name = obj.file.name;
            }
            else {
                obj.size = obj.size || 0;
                obj.name = obj.name || "";
            }
            if (_this.config.mode === types_1.VaultMode.grid && obj.file && helper_1.isImage(obj)) {
                _this._readStack.add(obj, _this.uploader.config.autosend);
            }
            return obj;
        };
        _this._readStack = new ReadStackPreview_1.ReadStackPreview(_this.data);
        _this.uploader = new Uploader_1.Uploader(_this.config.uploader, _this.data, _this.events);
        _this._scrollView = new scrollView_1.ScrollView(function () { return _this.getRootView(); });
        _this._progressBar = new ProgressBar_1.ProgressBar(_this.events, _this.config.progressBar);
        _this.events.on(types_1.UploaderEvents.uploadProgress, function (progress, current, total) { return _this._progressBar.setState(progress, { current: current, total: total }); });
        _this._initHandlers();
        _this._initUI(container);
        _this._initEvents();
        return _this;
    }
    Vault.prototype.destructor = function () {
        this.toolbar.destructor();
        this._readStack.stop();
        this.uploader.unlinkDropArea();
        this.uploader.abort();
    };
    Vault.prototype._initUI = function (container) {
        var _this = this;
        var cfg = this.config.toolbar ? configs_1.layoutConfig : configs_1.layoutConfigWithoutTopbar;
        cfg.on = this._getDragEvents();
        var layout = this._layout = new ts_layout_1.Layout(container, cfg);
        var toolbar = this.toolbar = new ts_toolbar_1.Toolbar(null, { css: "vault-toolbar" });
        var defaultButtons = [
            {
                id: "add",
                tooltip: en_1.default.add,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-plus"
            },
            {
                id: "upload",
                tooltip: en_1.default.upload,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi icon-upload" // Custom Web Font Icon
            },
            {
                type: "spacer"
            },
            {
                id: "remove-all",
                tooltip: en_1.default.clearAll,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-delete-forever"
            }
        ];
        this.toolbar.data.parse(defaultButtons);
        this._hideUploadAndDeleteButtons();
        var render = function () { return _this._draw(); };
        this.mount(null, dom_1.create({ render: render }));
        if (this.config.toolbar) {
            layout.cell("topbar").attach(toolbar);
        }
        layout.cell("vault").attach(this);
    };
    Vault.prototype._initHandlers = function () {
        var _this = this;
        this._handlers = {
            onclick: {
                ".action-add": function () { return _this.uploader.selectFile(); },
                ".action-remove-file": function (e) {
                    var id = html_1.locate(e);
                    if (!id) {
                        return;
                    }
                    _this.data.update(id, { $toRemove: true });
                    setTimeout(function () {
                        _this.data.update(id, { $toRemove: false }, true);
                        _this.data.remove(id);
                    }, 200);
                }
            },
            onmouseover: {
                ".action-download": function (e) {
                    ts_message_1.tooltip(en_1.default.download, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".action-remove-file": function (e) {
                    ts_message_1.tooltip(en_1.default.clear, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".title-content, .dhx-file-name": function (e) {
                    var id = html_1.locate(e);
                    var item = _this.data.getItem(id);
                    ts_message_1.tooltip(item.name, {
                        node: e.target,
                        position: ts_message_1.Position.bottom,
                        css: "tooltip-light"
                    });
                }
            }
        };
    };
    Vault.prototype._getDragEvents = function () {
        var _this = this;
        var rect = {
            left: null,
            top: null,
            width: null,
            height: null
        };
        return {
            dragleave: function (e) {
                if (!_this._canDrop) {
                    return;
                }
                if (e.pageX > rect.left + rect.width - 1 || e.pageX < rect.left || e.pageY > rect.top + rect.height - 1 || e.pageY < rect.top) {
                    _this._canDrop = false;
                    if (_this.config.toolbar) {
                        _this._layout.cell("topbar").show();
                    }
                    _this._layout.config.css = "vault-layout";
                    _this._layout.paint();
                }
            },
            dragenter: function (e) {
                e.preventDefault();
                if (_this.uploader.isActive || _this._canDrop) {
                    return;
                }
                var types = e.dataTransfer.types;
                for (var _i = 0, types_2 = types; _i < types_2.length; _i++) {
                    var type = types_2[_i];
                    if (type !== "Files" && type !== "application/x-moz-file") {
                        _this._canDrop = false;
                        return;
                    }
                }
                _this._canDrop = true;
                var clientRect = _this._layout.getRootView().node.el.getBoundingClientRect();
                rect.left = clientRect.left + window.pageXOffset;
                rect.top = clientRect.top + window.pageYOffset;
                rect.width = clientRect.width;
                rect.height = clientRect.height;
                _this._canDrop = true;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").hide();
                }
                _this._layout.config.css = "vault-layout dhx-dragin";
                _this._layout.paint();
            },
            dragover: function (e) {
                e.preventDefault();
            },
            drop: function (e) {
                e.preventDefault();
                if (!_this._canDrop) {
                    return;
                }
                var dataTransfer = e.dataTransfer;
                _this.uploader.parseFiles(dataTransfer);
                _this._canDrop = false;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").show();
                }
                _this._layout.config.css = "vault-layout";
                _this._layout.paint();
            }
        };
    };
    Vault.prototype._hideUploadAndDeleteButtons = function () {
        this.toolbar.hide(["upload", "remove-all"]);
    };
    Vault.prototype._showUploadAndDeleteButtons = function () {
        if (this.uploader.config.autosend) {
            this.toolbar.show("remove-all");
        }
        else {
            //this.toolbar.show(["upload", "remove-all"]);
            this.toolbar.show(["remove-all"]);
        }
    };
    Vault.prototype._initEvents = function () {
        var _this = this;
        this.data.events.on(types_1.DataEvents.change, function () {
            if (!_this.data.getLength()) {
                _this._hideUploadAndDeleteButtons();
            }
            else {
                _this._showUploadAndDeleteButtons();
            }
            _this.paint();
        });
        this.events.on(types_1.UploaderEvents.uploadBegin, function () {
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this._progressBar);
            }
        });
        this.events.on(types_1.UploaderEvents.uploadComplete, function () {
            if (_this.config.mode === types_1.VaultMode.grid && _this.uploader.config.autosend) {
                _this._readStack.read();
            }
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this.toolbar);
            }
        });
        this.toolbar.events.on(ts_toolbar_1.ToolbarEvents.click, function (id) {
            switch (id) {
                case "add":
                    _this.uploader.selectFile();
                    break;
                case "remove-all":
                    _this.data.removeAll();
                    break;
                case "upload":
                    _this.uploader.send();
                    break;
            }
        });
        this.events.on(types_1.ProgressBarEvents.cancel, function () {
            _this.uploader.abort();
            _this.paint();
        });
    };
    Vault.prototype._draw = function () {
        var isEmpty = !this.data.getLength();
        var files = this.config.mode === types_1.VaultMode.grid ? this._drawGrid() : this._drawList();
        return dom_1.el("div", __assign({ class: "vault dhx_widget" + (this._canDrop ? " drop-here" : "") }, this._handlers, { dhx_widget_id: this._uid }), [
            this._canDrop || isEmpty ? this._drawDropableArea() :
                this.config.customScroll ? this._scrollView.render(files) : files
        ]);
    };
    Vault.prototype._getFileActions = function (file) {
        var defaultActions = [];
        var hoverActions = [];
        var actions = [
            dom_1.el(".dhx-default-actions", defaultActions),
            dom_1.el(".dhx-hover-actions", hoverActions)
        ];
        if (file.status === types_1.FileStatus.inprogress) {
            return actions;
        }
        if (file.status !== types_1.FileStatus.failed && file.link) {
            var link = (this.config.downloadURL || "") + file.link;
            var downloadName = link.split("/").pop().split("?")[0];
            var download = dom_1.el("a", {
                download: downloadName,
                class: "download-link",
                href: link
            }, [
                dom_1.el(".icon-btn.dxi.dxi-download.action-download")
            ]);
            hoverActions.push(download);
        }
        var remove = dom_1.el(".icon-btn.dxi.dxi-delete-forever.action-remove-file");
        hoverActions.push(remove);
        if (file.status === types_1.FileStatus.failed) {
            var warn = dom_1.el(".dxi.dxi-alert-circle.warning-status");
            defaultActions.push(warn);
        }
        if (file.status === types_1.FileStatus.uploaded) {
            var uploadComplete = dom_1.el(".dxi.dxi-checkbox-marked-circle.uploaded-status");
            defaultActions.push(uploadComplete);
        }
        return actions;
    };
    Vault.prototype._drawList = function () {
        var _this = this;
        return dom_1.el(".dhx-files-block.dhx-webkit-scroll", this.data.map(function (item) {
            var isError = item.status === types_1.FileStatus.failed && item.request;
            var inProgress = item.status === types_1.FileStatus.inprogress;
            var inQueue = item.status === types_1.FileStatus.queue;
            var notUploaded = item.status !== types_1.FileStatus.uploaded;
            return dom_1.el("div", {
                class: "dhx-file-item" + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : ""),
                dhx_id: item.id,
                _key: item.id
            }, [
                dom_1.el(".dhx-file-icon", [
                    dom_1.el("div", {
                        class: "dhx-file-type " + helper_1.getFileClassName(item) + (notUploaded ? " not-loaded" : "")
                    })
                ]),
                dom_1.el(".dhx-file-title", [
                    dom_1.el(".dhx-title-content", item.name),
                    dom_1.el(".dhx-file-info", [
                        isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                        inProgress ? dom_1.el(".progress-value", (item.progress * 100).toFixed(1) + "%")
                            : dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                    ])
                ]),
                inProgress && dom_1.el(".dhx-download-progress", {
                    style: {
                        width: (item.progress * 100).toFixed(1) + "%"
                    }
                }),
                !inProgress && dom_1.el(".dhx-file-action", _this._getFileActions(item))
            ]);
        }));
    };
    Vault.prototype._drawDropableArea = function () {
        return dom_1.el(".dhx-dropable-area.drop-files-here", [
            dom_1.el(".dhx-big-icon-block", [
                dom_1.el(".dxi.icon-upload") // Custom Web Font Icon
            ]),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.dragAndDrop),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.filesOrFoldersHere),
            !this._canDrop && dom_1.el(".drop-area-light-text", en_1.default.or),
            !this._canDrop && dom_1.el("button.dhx_btn.dhx_btn--flat.dhx_btn--small.action-add", en_1.default.browse)
        ]);
    };
    Vault.prototype._drawGrid = function () {
        var _this = this;
        return dom_1.el("div", {
            class: "dhx-files-grid dhx-webkit-scroll"
        }, [
            dom_1.el(".dhx-grid-content", this.data.map(function (item) {
                var inProgress = item.status === types_1.FileStatus.inprogress;
                var inQueue = item.status === types_1.FileStatus.queue;
                var isError = item.status === types_1.FileStatus.failed;
                return dom_1.el("div", {
                    class: "dhx-file-grid-item" + (inProgress ? " in-progress" : "")
                        + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : "") + (isError ? " failed" : ""),
                    dhx_id: item.id,
                    _key: item.id
                }, [
                    dom_1.el(".dhx-preview-wrapper", [
                        item.preview ? dom_1.el(".dhx-server-file-preview", [
                            dom_1.el("img", { src: item.preview })
                        ]) :
                            item.image ? dom_1.el("canvas", {
                                width: 98 * _this.config.scaleFactor,
                                height: 98 * _this.config.scaleFactor,
                                _hooks: {
                                    didInsert: function (node) {
                                        var _a = helper_1.calculateCover(item.image), dx = _a.dx, dy = _a.dy, sx = _a.sx, sy = _a.sy, sHeight = _a.sHeight, sWidth = _a.sWidth;
                                        var ctx = node.el.getContext("2d");
                                        ctx.drawImage(item.image, sx, sy, sWidth, sHeight, dx, dy, 98 * _this.config.scaleFactor, 98 * _this.config.scaleFactor);
                                    }
                                }
                            }) : dom_1.el("div", {
                                class: "dhx-file-preview dhx-file-type " + helper_1.getFileClassName(item)
                            }),
                        inProgress && _this._drawCircle(item.progress)
                    ].concat(_this._getFileActions(item), [
                        dom_1.el(".dhx-file-info", [
                            isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                            !inProgress && dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                        ])
                    ])),
                    dom_1.el(".dhx-file-name", helper_1.truncateWord(item.name))
                ]);
            }))
        ]);
    };
    Vault.prototype._drawCircle = function (progress) {
        return dom_1.el(".progress-layout", [
            dom_1.el(".progress-amount", (progress * 100).toFixed(1) + "%"),
            dom_1.sv("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "progress-circle",
                viewBox: "0 0 60 60",
            }, [
                dom_1.sv("circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "class": "progress-bar-background",
                }),
                dom_1.sv("circle.active-circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "stroke-dasharray": "175.9 175.9",
                    "stroke-dashoffset": (1 - progress) * 175.9,
                    "class": "progress-bar-active",
                }),
            ])
        ]);
    };
    return Vault;
}(view_1.View));
exports.Vault = Vault;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/**
* Copyright (c) 2017, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* domvm.js (DOM ViewModel)
* A thin, fast, dependency-free vdom view layer
* @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
*/

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

// NOTE: if adding a new *VNode* type, make it < COMMENT and renumber rest.
// There are some places that test <= COMMENT to assert if node is a VNode

// VNode types
var ELEMENT	= 1;
var TEXT		= 2;
var COMMENT	= 3;

// placeholder types
var VVIEW		= 4;
var VMODEL		= 5;

var ENV_DOM = typeof window !== "undefined";
var win = ENV_DOM ? window : {};
var rAF = win.requestAnimationFrame;

var emptyObj = {};

function noop() {}

var isArr = Array.isArray;

function isSet(val) {
	return val != null;
}

function isPlainObj(val) {
	return val != null && val.constructor === Object;		//  && typeof val === "object"
}

function insertArr(targ, arr, pos, rem) {
	targ.splice.apply(targ, [pos, rem].concat(arr));
}

function isVal(val) {
	var t = typeof val;
	return t === "string" || t === "number";
}

function isFunc(val) {
	return typeof val === "function";
}

function isProm(val) {
	return typeof val === "object" && isFunc(val.then);
}



function assignObj(targ) {
	var args = arguments;

	for (var i = 1; i < args.length; i++)
		{ for (var k in args[i])
			{ targ[k] = args[i][k]; } }

	return targ;
}

// export const defProp = Object.defineProperty;

function deepSet(targ, path, val) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			{ targ[seg] = val; }
		else
			{ targ[seg] = targ = targ[seg] || {}; }
	}
}

/*
export function deepUnset(targ, path) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			targ[seg] = val;
		else
			targ[seg] = targ = targ[seg] || {};
	}
}
*/

function sliceArgs(args, offs) {
	var arr = [];
	for (var i = offs; i < args.length; i++)
		{ arr.push(args[i]); }
	return arr;
}

function cmpObj(a, b) {
	for (var i in a)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

function cmpArr(a, b) {
	var alen = a.length;

	if (b.length !== alen)
		{ return false; }

	for (var i = 0; i < alen; i++)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

// https://github.com/darsain/raft
// rAF throttler, aggregates multiple repeated redraw calls within single animframe
function raft(fn) {
	if (!rAF)
		{ return fn; }

	var id, ctx, args;

	function call() {
		id = 0;
		fn.apply(ctx, args);
	}

	return function() {
		ctx = this;
		args = arguments;
		if (!id) { id = rAF(call); }
	};
}

function curry(fn, args, ctx) {
	return function() {
		return fn.apply(ctx, args);
	};
}

/*
export function prop(val, cb, ctx, args) {
	return function(newVal, execCb) {
		if (newVal !== undefined && newVal !== val) {
			val = newVal;
			execCb !== false && isFunc(cb) && cb.apply(ctx, args);
		}

		return val;
	};
}
*/

/*
// adapted from https://github.com/Olical/binary-search
export function binaryKeySearch(list, item) {
    var min = 0;
    var max = list.length - 1;
    var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

    return -1;
}
*/

// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
// impl borrowed from https://github.com/ivijs/ivi
function longestIncreasingSubsequence(a) {
	var p = a.slice();
	var result = [];
	result.push(0);
	var u;
	var v;

	for (var i = 0, il = a.length; i < il; ++i) {
		var j = result[result.length - 1];
		if (a[j] < a[i]) {
			p[i] = j;
			result.push(i);
			continue;
		}

		u = 0;
		v = result.length - 1;

		while (u < v) {
			var c = ((u + v) / 2) | 0;
			if (a[result[c]] < a[i]) {
				u = c + 1;
			} else {
				v = c;
			}
		}

		if (a[i] < a[result[u]]) {
			if (u > 0) {
				p[i] = result[u - 1];
			}
			result[u] = i;
		}
	}

	u = result.length;
	v = result[u - 1];

	while (u-- > 0) {
		result[u] = v;
		v = p[v];
	}

	return result;
}

// based on https://github.com/Olical/binary-search
function binaryFindLarger(item, list) {
	var min = 0;
	var max = list.length - 1;
	var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

	return (min == list.length) ? null : min;

//	return -1;
}

function isEvProp(name) {
	return name[0] === "o" && name[1] === "n";
}

function isSplProp(name) {
	return name[0] === "_";
}

function isStyleProp(name) {
	return name === "style";
}

function repaint(node) {
	node && node.el && node.el.offsetHeight;
}

function isHydrated(vm) {
	return vm.node != null && vm.node.el != null;
}

// tests interactive props where real val should be compared
function isDynProp(tag, attr) {
//	switch (tag) {
//		case "input":
//		case "textarea":
//		case "select":
//		case "option":
			switch (attr) {
				case "value":
				case "checked":
				case "selected":
//				case "selectedIndex":
					return true;
			}
//	}

	return false;
}

function getVm(n) {
	n = n || emptyObj;
	while (n.vm == null && n.parent)
		{ n = n.parent; }
	return n.vm;
}

function VNode() {}

var VNodeProto = VNode.prototype = {
	constructor: VNode,

	type:	null,

	vm:		null,

	// all this stuff can just live in attrs (as defined) just have getters here for it
	key:	null,
	ref:	null,
	data:	null,
	hooks:	null,
	ns:		null,

	el:		null,

	tag:	null,
	attrs:	null,
	body:	null,

	flags:	0,

	_class:	null,
	_diff:	null,

	// pending removal on promise resolution
	_dead:	false,
	// part of longest increasing subsequence?
	_lis:	false,

	idx:	null,
	parent:	null,

	/*
	// break out into optional fluent module
	key:	function(val) { this.key	= val; return this; },
	ref:	function(val) { this.ref	= val; return this; },		// deep refs
	data:	function(val) { this.data	= val; return this; },
	hooks:	function(val) { this.hooks	= val; return this; },		// h("div").hooks()
	html:	function(val) { this.html	= true; return this.body(val); },

	body:	function(val) { this.body	= val; return this; },
	*/
};

function defineText(body) {
	var node = new VNode;
	node.type = TEXT;
	node.body = body;
	return node;
}

// creates a one-shot self-ending stream that redraws target vm
// TODO: if it's already registered by any parent vm, then ignore to avoid simultaneous parent & child refresh

var tagCache = {};

var RE_ATTRS = /\[(\w+)(?:=(\w+))?\]/g;

function cssTag(raw) {
	{
		var cached = tagCache[raw];

		if (cached == null) {
			var tag, id, cls, attr;

			tagCache[raw] = cached = {
				tag:	(tag	= raw.match( /^[-\w]+/))		?	tag[0]						: "div",
				id:		(id		= raw.match( /#([-\w]+)/))		? 	id[1]						: null,
				class:	(cls	= raw.match(/\.([-\w.]+)/))		?	cls[1].replace(/\./g, " ")	: null,
				attrs:	null,
			};

			while (attr = RE_ATTRS.exec(raw)) {
				if (cached.attrs == null)
					{ cached.attrs = {}; }
				cached.attrs[attr[1]] = attr[2] || "";
			}
		}

		return cached;
	}
}

// (de)optimization flags

// forces slow bottom-up removeChild to fire deep willRemove/willUnmount hooks,
var DEEP_REMOVE = 1;
// prevents inserting/removing/reordering of children
var FIXED_BODY = 2;
// enables fast keyed lookup of children via binary search, expects homogeneous keyed body
var KEYED_LIST = 4;
// indicates an vnode match/diff/recycler function for body
var LAZY_LIST = 8;

function initElementNode(tag, attrs, body, flags) {
	var node = new VNode;

	node.type = ELEMENT;

	if (isSet(flags))
		{ node.flags = flags; }

	node.attrs = attrs;

	var parsed = cssTag(tag);

	node.tag = parsed.tag;

	// meh, weak assertion, will fail for id=0, etc.
	if (parsed.id || parsed.class || parsed.attrs) {
		var p = node.attrs || {};

		if (parsed.id && !isSet(p.id))
			{ p.id = parsed.id; }

		if (parsed.class) {
			node._class = parsed.class;		// static class
			p.class = parsed.class + (isSet(p.class) ? (" " + p.class) : "");
		}
		if (parsed.attrs) {
			for (var key in parsed.attrs)
				{ if (!isSet(p[key]))
					{ p[key] = parsed.attrs[key]; } }
		}

//		if (node.attrs !== p)
			node.attrs = p;
	}

	var mergedAttrs = node.attrs;

	if (isSet(mergedAttrs)) {
		if (isSet(mergedAttrs._key))
			{ node.key = mergedAttrs._key; }

		if (isSet(mergedAttrs._ref))
			{ node.ref = mergedAttrs._ref; }

		if (isSet(mergedAttrs._hooks))
			{ node.hooks = mergedAttrs._hooks; }

		if (isSet(mergedAttrs._data))
			{ node.data = mergedAttrs._data; }

		if (isSet(mergedAttrs._flags))
			{ node.flags = mergedAttrs._flags; }

		if (!isSet(node.key)) {
			if (isSet(node.ref))
				{ node.key = node.ref; }
			else if (isSet(mergedAttrs.id))
				{ node.key = mergedAttrs.id; }
			else if (isSet(mergedAttrs.name))
				{ node.key = mergedAttrs.name + (mergedAttrs.type === "radio" || mergedAttrs.type === "checkbox" ? mergedAttrs.value : ""); }
		}
	}

	if (body != null)
		{ node.body = body; }

	return node;
}

function setRef(vm, name, node) {
	var path = ["refs"].concat(name.split("."));
	deepSet(vm, path, node);
}

function setDeepRemove(node) {
	while (node = node.parent)
		{ node.flags |= DEEP_REMOVE; }
}

// vnew, vold
function preProc(vnew, parent, idx, ownVm) {
	if (vnew.type === VMODEL || vnew.type === VVIEW)
		{ return; }

	vnew.parent = parent;
	vnew.idx = idx;
	vnew.vm = ownVm;

	if (vnew.ref != null)
		{ setRef(getVm(vnew), vnew.ref, vnew); }

	var nh = vnew.hooks,
		vh = ownVm && ownVm.hooks;

	if (nh && (nh.willRemove || nh.didRemove) ||
		vh && (vh.willUnmount || vh.didUnmount))
		{ setDeepRemove(vnew); }

	if (isArr(vnew.body))
		{ preProcBody(vnew); }
	else {}
}

function preProcBody(vnew) {
	var body = vnew.body;

	for (var i = 0; i < body.length; i++) {
		var node2 = body[i];

		// remove false/null/undefined
		if (node2 === false || node2 == null)
			{ body.splice(i--, 1); }
		// flatten arrays
		else if (isArr(node2)) {
			insertArr(body, node2, i--, 1);
		}
		else {
			if (node2.type == null)
				{ body[i] = node2 = defineText(""+node2); }

			if (node2.type === TEXT) {
				// remove empty text nodes
				if (node2.body == null || node2.body === "")
					{ body.splice(i--, 1); }
				// merge with previous text node
				else if (i > 0 && body[i-1].type === TEXT) {
					body[i-1].body += node2.body;
					body.splice(i--, 1);
				}
				else
					{ preProc(node2, vnew, i, null); }
			}
			else
				{ preProc(node2, vnew, i, null); }
		}
	}
}

var unitlessProps = {
	animationIterationCount: true,
	boxFlex: true,
	boxFlexGroup: true,
	boxOrdinalGroup: true,
	columnCount: true,
	flex: true,
	flexGrow: true,
	flexPositive: true,
	flexShrink: true,
	flexNegative: true,
	flexOrder: true,
	gridRow: true,
	gridColumn: true,
	order: true,
	lineClamp: true,

	borderImageOutset: true,
	borderImageSlice: true,
	borderImageWidth: true,
	fontWeight: true,
	lineHeight: true,
	opacity: true,
	orphans: true,
	tabSize: true,
	widows: true,
	zIndex: true,
	zoom: true,

	fillOpacity: true,
	floodOpacity: true,
	stopOpacity: true,
	strokeDasharray: true,
	strokeDashoffset: true,
	strokeMiterlimit: true,
	strokeOpacity: true,
	strokeWidth: true
};

function autoPx(name, val) {
	{
		// typeof val === 'number' is faster but fails for numeric strings
		return !isNaN(val) && !unitlessProps[name] ? (val + "px") : val;
	}
}

// assumes if styles exist both are objects or both are strings
function patchStyle(n, o) {
	var ns =     (n.attrs || emptyObj).style;
	var os = o ? (o.attrs || emptyObj).style : null;

	// replace or remove in full
	if (ns == null || isVal(ns))
		{ n.el.style.cssText = ns; }
	else {
		for (var nn in ns) {
			var nv = ns[nn];

			if (os == null || nv != null && nv !== os[nn])
				{ n.el.style[nn] = autoPx(nn, nv); }
		}

		// clean old
		if (os) {
			for (var on in os) {
				if (ns[on] == null)
					{ n.el.style[on] = ""; }
			}
		}
	}
}

var didQueue = [];

function fireHook(hooks, name, o, n, immediate) {
	if (hooks != null) {
		var fn = o.hooks[name];

		if (fn) {
			if (name[0] === "d" && name[1] === "i" && name[2] === "d") {	// did*
				//	console.log(name + " should queue till repaint", o, n);
				immediate ? repaint(o.parent) && fn(o, n) : didQueue.push([fn, o, n]);
			}
			else {		// will*
				//	console.log(name + " may delay by promise", o, n);
				return fn(o, n);		// or pass  done() resolver
			}
		}
	}
}

function drainDidHooks(vm) {
	if (didQueue.length) {
		repaint(vm.node);

		var item;
		while (item = didQueue.shift())
			{ item[0](item[1], item[2]); }
	}
}

var doc = ENV_DOM ? document : null;

function closestVNode(el) {
	while (el._node == null)
		{ el = el.parentNode; }
	return el._node;
}

function createElement(tag, ns) {
	if (ns != null)
		{ return doc.createElementNS(ns, tag); }
	return doc.createElement(tag);
}

function createTextNode(body) {
	return doc.createTextNode(body);
}

function createComment(body) {
	return doc.createComment(body);
}

// ? removes if !recycled
function nextSib(sib) {
	return sib.nextSibling;
}

// ? removes if !recycled
function prevSib(sib) {
	return sib.previousSibling;
}

// TODO: this should collect all deep proms from all hooks and return Promise.all()
function deepNotifyRemove(node) {
	var vm = node.vm;

	var wuRes = vm != null && fireHook(vm.hooks, "willUnmount", vm, vm.data);

	var wrRes = fireHook(node.hooks, "willRemove", node);

	if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE && isArr(node.body)) {
		for (var i = 0; i < node.body.length; i++)
			{ deepNotifyRemove(node.body[i]); }
	}

	return wuRes || wrRes;
}

function _removeChild(parEl, el, immediate) {
	var node = el._node, vm = node.vm;

	if (isArr(node.body)) {
		if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE) {
			for (var i = 0; i < node.body.length; i++)
				{ _removeChild(el, node.body[i].el); }
		}
		else
			{ deepUnref(node); }
	}

	delete el._node;

	parEl.removeChild(el);

	fireHook(node.hooks, "didRemove", node, null, immediate);

	if (vm != null) {
		fireHook(vm.hooks, "didUnmount", vm, vm.data, immediate);
		vm.node = null;
	}
}

// todo: should delay parent unmount() by returning res prom?
function removeChild(parEl, el) {
	var node = el._node;

	// already marked for removal
	if (node._dead) { return; }

	var res = deepNotifyRemove(node);

	if (res != null && isProm(res)) {
		node._dead = true;
		res.then(curry(_removeChild, [parEl, el, true]));
	}
	else
		{ _removeChild(parEl, el); }
}

function deepUnref(node) {
	var obody = node.body;

	for (var i = 0; i < obody.length; i++) {
		var o2 = obody[i];
		delete o2.el._node;

		if (o2.vm != null)
			{ o2.vm.node = null; }

		if (isArr(o2.body))
			{ deepUnref(o2); }
	}
}

function clearChildren(parent) {
	var parEl = parent.el;

	if ((parent.flags & DEEP_REMOVE) === 0) {
		isArr(parent.body) && deepUnref(parent);
		parEl.textContent = null;
	}
	else {
		var el = parEl.firstChild;

		do {
			var next = nextSib(el);
			removeChild(parEl, el);
		} while (el = next);
	}
}

// todo: hooks
function insertBefore(parEl, el, refEl) {
	var node = el._node, inDom = el.parentNode != null;

	// el === refEl is asserted as a no-op insert called to fire hooks
	var vm = (el === refEl || !inDom) ? node.vm : null;

	if (vm != null)
		{ fireHook(vm.hooks, "willMount", vm, vm.data); }

	fireHook(node.hooks, inDom ? "willReinsert" : "willInsert", node);
	parEl.insertBefore(el, refEl);
	fireHook(node.hooks, inDom ? "didReinsert" : "didInsert", node);

	if (vm != null)
		{ fireHook(vm.hooks, "didMount", vm, vm.data); }
}

function insertAfter(parEl, el, refEl) {
	insertBefore(parEl, el, refEl ? nextSib(refEl) : null);
}

var onemit = {};

function emitCfg(cfg) {
	assignObj(onemit, cfg);
}

function emit(evName) {
	var targ = this,
		src = targ;

	var args = sliceArgs(arguments, 1).concat(src, src.data);

	do {
		var evs = targ.onemit;
		var fn = evs ? evs[evName] : null;

		if (fn) {
			fn.apply(targ, args);
			break;
		}
	} while (targ = targ.parent());

	if (onemit[evName])
		{ onemit[evName].apply(targ, args); }
}

var onevent = noop;

function config(newCfg) {
	onevent = newCfg.onevent || onevent;

	{
		if (newCfg.onemit)
			{ emitCfg(newCfg.onemit); }
	}


}

function bindEv(el, type, fn) {
	el[type] = fn;
}

function exec(fn, args, e, node, vm) {
	var out = fn.apply(vm, args.concat([e, node, vm, vm.data]));

	// should these respect out === false?
	vm.onevent(e, node, vm, vm.data, args);
	onevent.call(null, e, node, vm, vm.data, args);

	if (out === false) {
		e.preventDefault();
		e.stopPropagation();
	}
}

function handle(e) {
	var node = closestVNode(e.target);
	var vm = getVm(node);

	var evDef = e.currentTarget._node.attrs["on" + e.type], fn, args;

	if (isArr(evDef)) {
		fn = evDef[0];
		args = evDef.slice(1);
		exec(fn, args, e, node, vm);
	}
	else {
		for (var sel in evDef) {
			if (e.target.matches(sel)) {
				var evDef2 = evDef[sel];

				if (isArr(evDef2)) {
					fn = evDef2[0];
					args = evDef2.slice(1);
				}
				else {
					fn = evDef2;
					args = [];
				}

				exec(fn, args, e, node, vm);
			}
		}
	}
}

function patchEvent(node, name, nval, oval) {
	if (nval === oval)
		{ return; }

	var el = node.el;

	if (nval == null || isFunc(nval))
		{ bindEv(el, name, nval); }
	else if (oval == null)
		{ bindEv(el, name, handle); }
}

function remAttr(node, name, asProp) {
	if (name[0] === ".") {
		name = name.substr(1);
		asProp = true;
	}

	if (asProp)
		{ node.el[name] = ""; }
	else
		{ node.el.removeAttribute(name); }
}

// setAttr
// diff, ".", "on*", bool vals, skip _*, value/checked/selected selectedIndex
function setAttr(node, name, val, asProp, initial) {
	var el = node.el;

	if (val == null)
		{ !initial && remAttr(node, name, false); }		// will also removeAttr of style: null
	else if (node.ns != null)
		{ el.setAttribute(name, val); }
	else if (name === "class")
		{ el.className = val; }
	else if (name === "id" || typeof val === "boolean" || asProp)
		{ el[name] = val; }
	else if (name[0] === ".")
		{ el[name.substr(1)] = val; }
	else
		{ el.setAttribute(name, val); }
}

function patchAttrs(vnode, donor, initial) {
	var nattrs = vnode.attrs || emptyObj;
	var oattrs = donor.attrs || emptyObj;

	if (nattrs === oattrs) {

	}
	else {
		for (var key in nattrs) {
			var nval = nattrs[key];
			var isDyn = isDynProp(vnode.tag, key);
			var oval = isDyn ? vnode.el[key] : oattrs[key];

			if (nval === oval) {}
			else if (isStyleProp(key))
				{ patchStyle(vnode, donor); }
			else if (isSplProp(key)) {}
			else if (isEvProp(key))
				{ patchEvent(vnode, key, nval, oval); }
			else
				{ setAttr(vnode, key, nval, isDyn, initial); }
		}

		// TODO: bench style.cssText = "" vs removeAttribute("style")
		for (var key in oattrs) {
			!(key in nattrs) &&
			!isSplProp(key) &&
			remAttr(vnode, key, isDynProp(vnode.tag, key) || isEvProp(key));
		}
	}
}

function createView(view, data, key, opts) {
	if (view.type === VVIEW) {
		data	= view.data;
		key		= view.key;
		opts	= view.opts;
		view	= view.view;
	}

	return new ViewModel(view, data, key, opts);
}

//import { XML_NS, XLINK_NS } from './defineSvgElement';
function hydrateBody(vnode) {
	for (var i = 0; i < vnode.body.length; i++) {
		var vnode2 = vnode.body[i];
		var type2 = vnode2.type;

		// ELEMENT,TEXT,COMMENT
		if (type2 <= COMMENT)
			{ insertBefore(vnode.el, hydrate(vnode2)); }		// vnode.el.appendChild(hydrate(vnode2))
		else if (type2 === VVIEW) {
			var vm = createView(vnode2.view, vnode2.data, vnode2.key, vnode2.opts)._redraw(vnode, i, false);		// todo: handle new data updates
			type2 = vm.node.type;
			insertBefore(vnode.el, hydrate(vm.node));
		}
		else if (type2 === VMODEL) {
			var vm = vnode2.vm;
			vm._redraw(vnode, i);					// , false
			type2 = vm.node.type;
			insertBefore(vnode.el, vm.node.el);		// , hydrate(vm.node)
		}
	}
}

//  TODO: DRY this out. reusing normal patch here negatively affects V8's JIT
function hydrate(vnode, withEl) {
	if (vnode.el == null) {
		if (vnode.type === ELEMENT) {
			vnode.el = withEl || createElement(vnode.tag, vnode.ns);

		//	if (vnode.tag === "svg")
		//		vnode.el.setAttributeNS(XML_NS, 'xmlns:xlink', XLINK_NS);

			if (vnode.attrs != null)
				{ patchAttrs(vnode, emptyObj, true); }

			if ((vnode.flags & LAZY_LIST) === LAZY_LIST)	// vnode.body instanceof LazyList
				{ vnode.body.body(vnode); }

			if (isArr(vnode.body))
				{ hydrateBody(vnode); }
			else if (vnode.body != null && vnode.body !== "")
				{ vnode.el.textContent = vnode.body; }
		}
		else if (vnode.type === TEXT)
			{ vnode.el = withEl || createTextNode(vnode.body); }
		else if (vnode.type === COMMENT)
			{ vnode.el = withEl || createComment(vnode.body); }
	}

	vnode.el._node = vnode;

	return vnode.el;
}

// prevent GCC from inlining some large funcs (which negatively affects Chrome's JIT)
//window.syncChildren = syncChildren;
window.lisMove = lisMove;

function nextNode(node, body) {
	return body[node.idx + 1];
}

function prevNode(node, body) {
	return body[node.idx - 1];
}

function parentNode(node) {
	return node.parent;
}

var BREAK = 1;
var BREAK_ALL = 2;

function syncDir(advSib, advNode, insert, sibName, nodeName, invSibName, invNodeName, invInsert) {
	return function(node, parEl, body, state, convTest, lis) {
		var sibNode, tmpSib;

		if (state[sibName] != null) {
			// skip dom elements not created by domvm
			if ((sibNode = state[sibName]._node) == null) {
				state[sibName] = advSib(state[sibName]);
				return;
			}

			if (parentNode(sibNode) !== node) {
				tmpSib = advSib(state[sibName]);
				sibNode.vm != null ? sibNode.vm.unmount(true) : removeChild(parEl, state[sibName]);
				state[sibName] = tmpSib;
				return;
			}
		}

		if (state[nodeName] == convTest)
			{ return BREAK_ALL; }
		else if (state[nodeName].el == null) {
			insert(parEl, hydrate(state[nodeName]), state[sibName]);	// should lis be updated here?
			state[nodeName] = advNode(state[nodeName], body);		// also need to advance sib?
		}
		else if (state[nodeName].el === state[sibName]) {
			state[nodeName] = advNode(state[nodeName], body);
			state[sibName] = advSib(state[sibName]);
		}
		// head->tail or tail->head
		else if (!lis && sibNode === state[invNodeName]) {
			tmpSib = state[sibName];
			state[sibName] = advSib(tmpSib);
			invInsert(parEl, tmpSib, state[invSibName]);
			state[invSibName] = tmpSib;
		}
		else {
			if (lis && state[sibName] != null)
				{ return lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state); }

			return BREAK;
		}
	};
}

function lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state) {
	if (sibNode._lis) {
		insert(parEl, state[nodeName].el, state[sibName]);
		state[nodeName] = advNode(state[nodeName], body);
	}
	else {
		// find closest tomb
		var t = binaryFindLarger(sibNode.idx, state.tombs);
		sibNode._lis = true;
		var tmpSib = advSib(state[sibName]);
		insert(parEl, state[sibName], t != null ? body[state.tombs[t]].el : t);

		if (t == null)
			{ state.tombs.push(sibNode.idx); }
		else
			{ state.tombs.splice(t, 0, sibNode.idx); }

		state[sibName] = tmpSib;
	}
}

var syncLft = syncDir(nextSib, nextNode, insertBefore, "lftSib", "lftNode", "rgtSib", "rgtNode", insertAfter);
var syncRgt = syncDir(prevSib, prevNode, insertAfter, "rgtSib", "rgtNode", "lftSib", "lftNode", insertBefore);

function syncChildren(node, donor) {
	var obody	= donor.body,
		parEl	= node.el,
		body	= node.body,
		state = {
			lftNode:	body[0],
			rgtNode:	body[body.length - 1],
			lftSib:		((obody)[0] || emptyObj).el,
			rgtSib:		(obody[obody.length - 1] || emptyObj).el,
		};

	converge:
	while (1) {
//		from_left:
		while (1) {
			var l = syncLft(node, parEl, body, state, null, false);
			if (l === BREAK) { break; }
			if (l === BREAK_ALL) { break converge; }
		}

//		from_right:
		while (1) {
			var r = syncRgt(node, parEl, body, state, state.lftNode, false);
			if (r === BREAK) { break; }
			if (r === BREAK_ALL) { break converge; }
		}

		sortDOM(node, parEl, body, state);
		break;
	}
}

// TODO: also use the state.rgtSib and state.rgtNode bounds, plus reduce LIS range
function sortDOM(node, parEl, body, state) {
	var kids = Array.prototype.slice.call(parEl.childNodes);
	var domIdxs = [];

	for (var k = 0; k < kids.length; k++) {
		var n = kids[k]._node;

		if (n.parent === node)
			{ domIdxs.push(n.idx); }
	}

	// list of non-movable vnode indices (already in correct order in old dom)
	var tombs = longestIncreasingSubsequence(domIdxs).map(function (i) { return domIdxs[i]; });

	for (var i = 0; i < tombs.length; i++)
		{ body[tombs[i]]._lis = true; }

	state.tombs = tombs;

	while (1) {
		var r = syncLft(node, parEl, body, state, null, true);
		if (r === BREAK_ALL) { break; }
	}
}

function alreadyAdopted(vnode) {
	return vnode.el._node.parent !== vnode.parent;
}

function takeSeqIndex(n, obody, fromIdx) {
	return obody[fromIdx];
}

function findSeqThorough(n, obody, fromIdx) {		// pre-tested isView?
	for (; fromIdx < obody.length; fromIdx++) {
		var o = obody[fromIdx];

		if (o.vm != null) {
			// match by key & viewFn || vm
			if (n.type === VVIEW && o.vm.view === n.view && o.vm.key === n.key || n.type === VMODEL && o.vm === n.vm)
				{ return o; }
		}
		else if (!alreadyAdopted(o) && n.tag === o.tag && n.type === o.type && n.key === o.key && (n.flags & ~DEEP_REMOVE) === (o.flags & ~DEEP_REMOVE))
			{ return o; }
	}

	return null;
}

function findHashKeyed(n, obody, fromIdx) {
	return obody[obody._keys[n.key]];
}

/*
// list must be a sorted list of vnodes by key
function findBinKeyed(n, list) {
	var idx = binaryKeySearch(list, n.key);
	return idx > -1 ? list[idx] : null;
}
*/

// have it handle initial hydrate? !donor?
// types (and tags if ELEM) are assumed the same, and donor exists
function patch(vnode, donor) {
	fireHook(donor.hooks, "willRecycle", donor, vnode);

	var el = vnode.el = donor.el;

	var obody = donor.body;
	var nbody = vnode.body;

	el._node = vnode;

	// "" => ""
	if (vnode.type === TEXT && nbody !== obody) {
		el.nodeValue = nbody;
		return;
	}

	if (vnode.attrs != null || donor.attrs != null)
		{ patchAttrs(vnode, donor, false); }

	// patch events

	var oldIsArr = isArr(obody);
	var newIsArr = isArr(nbody);
	var lazyList = (vnode.flags & LAZY_LIST) === LAZY_LIST;

//	var nonEqNewBody = nbody != null && nbody !== obody;

	if (oldIsArr) {
		// [] => []
		if (newIsArr || lazyList)
			{ patchChildren(vnode, donor); }
		// [] => "" | null
		else if (nbody !== obody) {
			if (nbody != null)
				{ el.textContent = nbody; }
			else
				{ clearChildren(donor); }
		}
	}
	else {
		// "" | null => []
		if (newIsArr) {
			clearChildren(donor);
			hydrateBody(vnode);
		}
		// "" | null => "" | null
		else if (nbody !== obody) {
			if (el.firstChild)
				{ el.firstChild.nodeValue = nbody; }
			else
				{ el.textContent = nbody; }
		}
	}

	fireHook(donor.hooks, "didRecycle", donor, vnode);
}

// larger qtys of KEYED_LIST children will use binary search
//const SEQ_FAILS_MAX = 100;

// TODO: modify vtree matcher to work similar to dom reconciler for keyed from left -> from right -> head/tail -> binary
// fall back to binary if after failing nri - nli > SEQ_FAILS_MAX
// while-advance non-keyed fromIdx
// [] => []
function patchChildren(vnode, donor) {
	var nbody		= vnode.body,
		nlen		= nbody.length,
		obody		= donor.body,
		olen		= obody.length,
		isLazy		= (vnode.flags & LAZY_LIST) === LAZY_LIST,
		isFixed		= (vnode.flags & FIXED_BODY) === FIXED_BODY,
		isKeyed		= (vnode.flags & KEYED_LIST) === KEYED_LIST,
		domSync		= !isFixed && vnode.type === ELEMENT,
		doFind		= true,
		find		= (
			isKeyed ? findHashKeyed :				// keyed lists/lazyLists
			isFixed || isLazy ? takeSeqIndex :		// unkeyed lazyLists and FIXED_BODY
			findSeqThorough							// more complex stuff
		);

	if (isKeyed) {
		var keys = {};
		for (var i = 0; i < obody.length; i++)
			{ keys[obody[i].key] = i; }
		obody._keys = keys;
	}

	if (domSync && nlen === 0) {
		clearChildren(donor);
		if (isLazy)
			{ vnode.body = []; }	// nbody.tpl(all);
		return;
	}

	var donor2,
		node2,
		foundIdx,
		patched = 0,
		everNonseq = false,
		fromIdx = 0;		// first unrecycled node (search head)

	if (isLazy) {
		var fnode2 = {key: null};
		var nbodyNew = Array(nlen);
	}

	for (var i = 0; i < nlen; i++) {
		if (isLazy) {
			var remake = false;
			var diffRes = null;

			if (doFind) {
				if (isKeyed)
					{ fnode2.key = nbody.key(i); }

				donor2 = find(fnode2, obody, fromIdx);
			}

			if (donor2 != null) {
                foundIdx = donor2.idx;
				diffRes = nbody.diff(i, donor2);

				// diff returns same, so cheaply adopt vnode without patching
				if (diffRes === true) {
					node2 = donor2;
					node2.parent = vnode;
					node2.idx = i;
					node2._lis = false;
				}
				// diff returns new diffVals, so generate new vnode & patch
				else
					{ remake = true; }
			}
			else
				{ remake = true; }

			if (remake) {
				node2 = nbody.tpl(i);			// what if this is a VVIEW, VMODEL, injected element?
				preProc(node2, vnode, i);

				node2._diff = diffRes != null ? diffRes : nbody.diff(i);

				if (donor2 != null)
					{ patch(node2, donor2); }
			}
			else {
				// TODO: flag tmp FIXED_BODY on unchanged nodes?

				// domSync = true;		if any idx changes or new nodes added/removed
			}

			nbodyNew[i] = node2;
		}
		else {
			var node2 = nbody[i];
			var type2 = node2.type;

			// ELEMENT,TEXT,COMMENT
			if (type2 <= COMMENT) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {
					patch(node2, donor2);
					foundIdx = donor2.idx;
				}
			}
			else if (type2 === VVIEW) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {		// update/moveTo
					foundIdx = donor2.idx;
					var vm = donor2.vm._update(node2.data, vnode, i);		// withDOM
				}
				else
					{ var vm = createView(node2.view, node2.data, node2.key, node2.opts)._redraw(vnode, i, false); }	// createView, no dom (will be handled by sync below)

				type2 = vm.node.type;
			}
			else if (type2 === VMODEL) {
				// if the injected vm has never been rendered, this vm._update() serves as the
				// initial vtree creator, but must avoid hydrating (creating .el) because syncChildren()
				// which is responsible for mounting below (and optionally hydrating), tests .el presence
				// to determine if hydration & mounting are needed
				var withDOM = isHydrated(node2.vm);

				var vm = node2.vm._update(node2.data, vnode, i, withDOM);
				type2 = vm.node.type;
			}
		}

		// found donor & during a sequential search ...at search head
		if (!isKeyed && donor2 != null) {
			if (foundIdx === fromIdx) {
				// advance head
				fromIdx++;
				// if all old vnodes adopted and more exist, stop searching
				if (fromIdx === olen && nlen > olen) {
					// short-circuit find, allow loop just create/init rest
					donor2 = null;
					doFind = false;
				}
			}
			else
				{ everNonseq = true; }

			if (olen > 100 && everNonseq && ++patched % 10 === 0)
				{ while (fromIdx < olen && alreadyAdopted(obody[fromIdx]))
					{ fromIdx++; } }
		}
	}

	// replace List w/ new body
	if (isLazy)
		{ vnode.body = nbodyNew; }

	domSync && syncChildren(vnode, donor);
}

// view + key serve as the vm's unique identity
function ViewModel(view, data, key, opts) {
	var vm = this;

	vm.view = view;
	vm.data = data;
	vm.key = key;

	if (opts) {
		vm.opts = opts;
		vm.config(opts);
	}

	var out = isPlainObj(view) ? view : view.call(vm, vm, data, key, opts);

	if (isFunc(out))
		{ vm.render = out; }
	else {
		vm.render = out.render;
		vm.config(out);
	}

	// these must be wrapped here since they're debounced per view
	vm._redrawAsync = raft(function (_) { return vm.redraw(true); });
	vm._updateAsync = raft(function (newData) { return vm.update(newData, true); });

	vm.init && vm.init.call(vm, vm, vm.data, vm.key, opts);
}

var ViewModelProto = ViewModel.prototype = {
	constructor: ViewModel,

	_diff:	null,	// diff cache

	init:	null,
	view:	null,
	key:	null,
	data:	null,
	state:	null,
	api:	null,
	opts:	null,
	node:	null,
	hooks:	null,
	onevent: noop,
	refs:	null,
	render:	null,

	mount: mount,
	unmount: unmount,
	config: function(opts) {
		var t = this;

		if (opts.init)
			{ t.init = opts.init; }
		if (opts.diff)
			{ t.diff = opts.diff; }
		if (opts.onevent)
			{ t.onevent = opts.onevent; }

		// maybe invert assignment order?
		if (opts.hooks)
			{ t.hooks = assignObj(t.hooks || {}, opts.hooks); }

		{
			if (opts.onemit)
				{ t.onemit = assignObj(t.onemit || {}, opts.onemit); }
		}
	},
	parent: function() {
		return getVm(this.node.parent);
	},
	root: function() {
		var p = this.node;

		while (p.parent)
			{ p = p.parent; }

		return p.vm;
	},
	redraw: function(sync) {
		var vm = this;
		sync ? vm._redraw(null, null, isHydrated(vm)) : vm._redrawAsync();
		return vm;
	},
	update: function(newData, sync) {
		var vm = this;
		sync ? vm._update(newData, null, null, isHydrated(vm)) : vm._updateAsync(newData);
		return vm;
	},

	_update: updateSync,
	_redraw: redrawSync,
	_redrawAsync: null,
	_updateAsync: null,
};

function mount(el, isRoot) {
	var vm = this;

	if (isRoot) {
		clearChildren({el: el, flags: 0});

		vm._redraw(null, null, false);

		// if placeholder node doesnt match root tag
		if (el.nodeName.toLowerCase() !== vm.node.tag) {
			hydrate(vm.node);
			insertBefore(el.parentNode, vm.node.el, el);
			el.parentNode.removeChild(el);
		}
		else
			{ insertBefore(el.parentNode, hydrate(vm.node, el), el); }
	}
	else {
		vm._redraw(null, null);

		if (el)
			{ insertBefore(el, vm.node.el); }
	}

	if (el)
		{ drainDidHooks(vm); }

	return vm;
}

// asSub means this was called from a sub-routine, so don't drain did* hook queue
function unmount(asSub) {
	var vm = this;

	var node = vm.node;
	var parEl = node.el.parentNode;

	// edge bug: this could also be willRemove promise-delayed; should .then() or something to make sure hooks fire in order
	removeChild(parEl, node.el);

	if (!asSub)
		{ drainDidHooks(vm); }
}

function reParent(vm, vold, newParent, newIdx) {
	if (newParent != null) {
		newParent.body[newIdx] = vold;
		vold.idx = newIdx;
		vold.parent = newParent;
		vold._lis = false;
	}
	return vm;
}

function redrawSync(newParent, newIdx, withDOM) {
	var isRedrawRoot = newParent == null;
	var vm = this;
	var isMounted = vm.node && vm.node.el && vm.node.el.parentNode;

	var vold = vm.node, oldDiff, newDiff;

	if (vm.diff != null) {
		oldDiff = vm._diff;
		vm._diff = newDiff = vm.diff(vm, vm.data);

		if (vold != null) {
			var cmpFn = isArr(oldDiff) ? cmpArr : cmpObj;
			var isSame = oldDiff === newDiff || cmpFn(oldDiff, newDiff);

			if (isSame)
				{ return reParent(vm, vold, newParent, newIdx); }
		}
	}

	isMounted && fireHook(vm.hooks, "willRedraw", vm, vm.data);

	var vnew = vm.render.call(vm, vm, vm.data, oldDiff, newDiff);

	if (vnew === vold)
		{ return reParent(vm, vold, newParent, newIdx); }

	// todo: test result of willRedraw hooks before clearing refs
	vm.refs = null;

	// always assign vm key to root vnode (this is a de-opt)
	if (vm.key != null && vnew.key !== vm.key)
		{ vnew.key = vm.key; }

	vm.node = vnew;

	if (newParent) {
		preProc(vnew, newParent, newIdx, vm);
		newParent.body[newIdx] = vnew;
	}
	else if (vold && vold.parent) {
		preProc(vnew, vold.parent, vold.idx, vm);
		vold.parent.body[vold.idx] = vnew;
	}
	else
		{ preProc(vnew, null, null, vm); }

	if (withDOM !== false) {
		if (vold) {
			// root node replacement
			if (vold.tag !== vnew.tag || vold.key !== vnew.key) {
				// hack to prevent the replacement from triggering mount/unmount
				vold.vm = vnew.vm = null;

				var parEl = vold.el.parentNode;
				var refEl = nextSib(vold.el);
				removeChild(parEl, vold.el);
				insertBefore(parEl, hydrate(vnew), refEl);

				// another hack that allows any higher-level syncChildren to set
				// reconciliation bounds using a live node
				vold.el = vnew.el;

				// restore
				vnew.vm = vm;
			}
			else
				{ patch(vnew, vold); }
		}
		else
			{ hydrate(vnew); }
	}

	isMounted && fireHook(vm.hooks, "didRedraw", vm, vm.data);

	if (isRedrawRoot && isMounted)
		{ drainDidHooks(vm); }

	return vm;
}

// this also doubles as moveTo
// TODO? @withRedraw (prevent redraw from firing)
function updateSync(newData, newParent, newIdx, withDOM) {
	var vm = this;

	if (newData != null) {
		if (vm.data !== newData) {
			fireHook(vm.hooks, "willUpdate", vm, newData);
			vm.data = newData;


		}
	}

	return vm._redraw(newParent, newIdx, withDOM);
}

function defineElement(tag, arg1, arg2, flags) {
	var attrs, body;

	if (arg2 == null) {
		if (isPlainObj(arg1))
			{ attrs = arg1; }
		else
			{ body = arg1; }
	}
	else {
		attrs = arg1;
		body = arg2;
	}

	return initElementNode(tag, attrs, body, flags);
}

//export const XML_NS = "http://www.w3.org/2000/xmlns/";
var SVG_NS = "http://www.w3.org/2000/svg";

function defineSvgElement(tag, arg1, arg2, flags) {
	var n = defineElement(tag, arg1, arg2, flags);
	n.ns = SVG_NS;
	return n;
}

function defineComment(body) {
	var node = new VNode;
	node.type = COMMENT;
	node.body = body;
	return node;
}

// placeholder for declared views
function VView(view, data, key, opts) {
	this.view = view;
	this.data = data;
	this.key = key;
	this.opts = opts;
}

VView.prototype = {
	constructor: VView,

	type: VVIEW,
	view: null,
	data: null,
	key: null,
	opts: null,
};

function defineView(view, data, key, opts) {
	return new VView(view, data, key, opts);
}

// placeholder for injected ViewModels
function VModel(vm) {
	this.vm = vm;
}

VModel.prototype = {
	constructor: VModel,

	type: VMODEL,
	vm: null,
};

function injectView(vm) {
//	if (vm.node == null)
//		vm._redraw(null, null, false);

//	return vm.node;

	return new VModel(vm);
}

function injectElement(el) {
	var node = new VNode;
	node.type = ELEMENT;
	node.el = node.key = el;
	return node;
}

function lazyList(items, cfg) {
	var len = items.length;

	var self = {
		items: items,
		length: len,
		// defaults to returning item identity (or position?)
		key: function(i) {
			return cfg.key(items[i], i);
		},
		// default returns 0?
		diff: function(i, donor) {
			var newVals = cfg.diff(items[i], i);
			if (donor == null)
				{ return newVals; }
			var oldVals = donor._diff;
			var same = newVals === oldVals || isArr(oldVals) ? cmpArr(newVals, oldVals) : cmpObj(newVals, oldVals);
			return same || newVals;
		},
		tpl: function(i) {
			return cfg.tpl(items[i], i);
		},
		map: function(tpl) {
			cfg.tpl = tpl;
			return self;
		},
		body: function(vnode) {
			var nbody = Array(len);

			for (var i = 0; i < len; i++) {
				var vnode2 = self.tpl(i);

			//	if ((vnode.flags & KEYED_LIST) === KEYED_LIST && self. != null)
			//		vnode2.key = getKey(item);

				vnode2._diff = self.diff(i);			// holds oldVals for cmp

				nbody[i] = vnode2;

				// run preproc pass (should this be just preProc in above loop?) bench
				preProc(vnode2, vnode, i);
			}

			// replace List with generated body
			vnode.body = nbody;
		}
	};

	return self;
}

var nano = {
	config: config,

	ViewModel: ViewModel,
	VNode: VNode,

	createView: createView,

	defineElement: defineElement,
	defineSvgElement: defineSvgElement,
	defineText: defineText,
	defineComment: defineComment,
	defineView: defineView,

	injectView: injectView,
	injectElement: injectElement,

	lazyList: lazyList,

	FIXED_BODY: FIXED_BODY,
	DEEP_REMOVE: DEEP_REMOVE,
	KEYED_LIST: KEYED_LIST,
	LAZY_LIST: LAZY_LIST,
};

function protoPatch(n, doRepaint) {
	patch$1(this, n, doRepaint);
}

// newNode can be either {class: style: } or full new VNode
// will/didPatch hooks?
function patch$1(o, n, doRepaint) {
	if (n.type != null) {
		// no full patching of view roots, just use redraw!
		if (o.vm != null)
			{ return; }

		preProc(n, o.parent, o.idx, null);
		o.parent.body[o.idx] = n;
		patch(n, o);
		doRepaint && repaint(n);
		drainDidHooks(getVm(n));
	}
	else {
		// TODO: re-establish refs

		// shallow-clone target
		var donor = Object.create(o);
		// fixate orig attrs
		donor.attrs = assignObj({}, o.attrs);
		// assign new attrs into live targ node
		var oattrs = assignObj(o.attrs, n);
		// prepend any fixed shorthand class
		if (o._class != null) {
			var aclass = oattrs.class;
			oattrs.class = aclass != null && aclass !== "" ? o._class + " " + aclass : o._class;
		}

		patchAttrs(o, donor);

		doRepaint && repaint(o);
	}
}

VNodeProto.patch = protoPatch;

function nextSubVms(n, accum) {
	var body = n.body;

	if (isArr(body)) {
		for (var i = 0; i < body.length; i++) {
			var n2 = body[i];

			if (n2.vm != null)
				{ accum.push(n2.vm); }
			else
				{ nextSubVms(n2, accum); }
		}
	}

	return accum;
}

function defineElementSpread(tag) {
	var args = arguments;
	var len = args.length;
	var body, attrs;

	if (len > 1) {
		var bodyIdx = 1;

		if (isPlainObj(args[1])) {
			attrs = args[1];
			bodyIdx = 2;
		}

		if (len === bodyIdx + 1 && (isVal(args[bodyIdx]) || isArr(args[bodyIdx]) || attrs && (attrs._flags & LAZY_LIST) === LAZY_LIST))
			{ body = args[bodyIdx]; }
		else
			{ body = sliceArgs(args, bodyIdx); }
	}

	return initElementNode(tag, attrs, body);
}

function defineSvgElementSpread() {
	var n = defineElementSpread.apply(null, arguments);
	n.ns = SVG_NS;
	return n;
}

ViewModelProto.emit = emit;
ViewModelProto.onemit = null;

ViewModelProto.body = function() {
	return nextSubVms(this.node, []);
};

nano.defineElementSpread = defineElementSpread;
nano.defineSvgElementSpread = defineSvgElementSpread;

return nano;

})));
//# sourceMappingURL=domvm.micro.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ScrollView = /** @class */ (function () {
    function ScrollView(getRootView, config) {
        var _a;
        if (config === void 0) { config = {}; }
        var _this = this;
        this.config = core_1.extend({
            speed: 20
        }, config);
        this._wheelName = html_1.isIE() ? "onmousewheel" : "onwheel";
        this._getRootView = getRootView;
        this._scrollTop = 0;
        this._runnerTop = 0;
        this._runnerHeight = 0;
        this._visibleArea = 1;
        this._scrollWidth = html_1.getScrollbarWidth();
        this._handlers = (_a = {
                onscroll: function () {
                    _this._update();
                }
            },
            _a[this._wheelName] = function (e) {
                e.preventDefault();
                var sign = (e.deltaY || -e.wheelDelta) > 0 ? 1 : -1;
                var delta = sign * _this.config.speed;
                var area = _this._getRefs().area;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var newScrollTop = _this._scrollTop + delta;
                if (newScrollTop < 0) {
                    area.scrollTop = 0;
                }
                else if (newScrollTop > maxBottom) {
                    area.scrollTop = maxBottom;
                }
                else {
                    area.scrollTop = newScrollTop;
                }
                _this._update();
            },
            _a.onmousedownRunner = function (mouseDownEv) {
                mouseDownEv.preventDefault();
                var _a = _this._getRefs(), area = _a.area, runner = _a.runner;
                var rect = area.getBoundingClientRect();
                var top = rect.top + window.pageYOffset;
                var bottom = rect.bottom + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var delta = mouseDownEv.pageY - runner.getBoundingClientRect().top - window.pageYOffset;
                var mouseMove = function (e) {
                    var y = e.pageY - delta;
                    if (y <= top) {
                        area.scrollTop = 0;
                    }
                    else if (y > bottom) {
                        area.scrollTop = maxBottom;
                    }
                    else {
                        area.scrollTop = (y - top) / _this._visibleArea;
                    }
                    _this._update();
                };
                var mouseUp = function () {
                    document.removeEventListener("mousemove", mouseMove);
                    document.removeEventListener("mouseup", mouseUp);
                    document.body.classList.remove("dhx-no-select");
                };
                document.body.classList.add("dhx-no-select");
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseup", mouseUp);
            },
            _a.onmousedownTrack = function (e) {
                if (e.target.classList.contains("scroll-runner")) {
                    return;
                }
                e.preventDefault();
                var mouseUp = function () {
                    document.removeEventListener("mouseup", mouseUp);
                    window.clearInterval(mousePressed); // typescript bug
                };
                var area = _this._getRefs().area;
                var top = e.target.getBoundingClientRect().top + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var y = e.pageY;
                var updateScroll = function () {
                    var scrollTop;
                    if (y < top + _this._runnerTop) {
                        scrollTop = _this._scrollTop - area.clientHeight;
                        if (scrollTop < 0) {
                            scrollTop = 0;
                        }
                    }
                    else if (y > top + _this._runnerTop + _this._runnerHeight) {
                        scrollTop = _this._scrollTop + area.clientHeight;
                        if (scrollTop > maxBottom) {
                            scrollTop = maxBottom;
                        }
                    }
                    else {
                        return;
                    }
                    area.scrollTop = scrollTop;
                    _this._update();
                };
                updateScroll();
                var mousePressed = setInterval(updateScroll, 100);
                document.addEventListener("mouseup", mouseUp);
            },
            _a);
    }
    ScrollView.prototype.render = function (element) {
        var _this = this;
        var _a;
        if (this._scrollWidth === 0) {
            return element;
        }
        return dom_1.el(".scroll-view-wrapper", {
            style: {
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative"
            }
        }, [
            dom_1.el(".scroll-view", {
                onscroll: this._handlers.onscroll,
                _ref: "scroll-view",
                _hooks: {
                    didInsert: function () {
                        _this._update();
                    },
                    didRecycle: function () {
                        _this._update();
                    }
                },
                style: {
                    "height": "100%",
                    "width": "calc(100% + " + this._scrollWidth + "px)",
                    "overflowY": "scroll",
                    "-ms-overflow-style": "scrollbar"
                },
            }, [element]),
            dom_1.el(".y-scroll", (_a = {
                    onmousedown: this._handlers.onmousedownTrack
                },
                _a[this._wheelName] = this._handlers[this._wheelName],
                _a.style = {
                    width: "10px",
                    height: "100%",
                    right: 0,
                    top: 0,
                    position: "absolute"
                },
                _a), [
                dom_1.el(".scroll-runner", {
                    _ref: "scroll-runner",
                    onmousedown: this._handlers.onmousedownRunner,
                    style: {
                        height: this._runnerHeight + "px",
                        right: "2px",
                        top: this._runnerTop,
                        width: "6px",
                        position: "absolute"
                    }
                })
            ])
        ]);
    };
    ScrollView.prototype._update = function () {
        var refs = this._getRefs();
        if (!refs) {
            return;
        }
        var area = refs.area, runner = refs.runner;
        this._visibleArea = area.clientHeight / area.scrollHeight;
        this._scrollTop = area.scrollTop;
        this._runnerTop = this._scrollTop * this._visibleArea;
        if (this._visibleArea < 1) {
            this._runnerHeight = area.clientHeight * this._visibleArea;
        }
        else {
            this._runnerHeight = 0;
        }
        // update dom
        runner.style.top = this._runnerTop + "px";
        runner.style.height = this._runnerHeight + "px";
    };
    ScrollView.prototype._getRefs = function () {
        var rootView = this._getRootView();
        if (rootView.refs && rootView.refs["scroll-view"] && rootView.refs["scroll-runner"]) {
            return {
                area: rootView.refs["scroll-view"].el,
                runner: rootView.refs["scroll-runner"].el
            };
        }
    };
    return ScrollView;
}());
exports.ScrollView = ScrollView;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Cell_1 = __webpack_require__(47);
var dom_1 = __webpack_require__(0);
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        if (_this.config.views) {
            _this.config.activeView = _this.config.activeView || 0;
            _this._isViewLayout = true;
        }
        _this._all = {};
        _this._parseConfig();
        _this._css += _this._xLayout ? "layout_x" : "layout_y";
        if (!(parent instanceof Layout)) {
            var view = dom_1.create({ render: function () { return _this.toVDOM(); } }, _this);
            _this.mount(parent, view);
        }
        return _this;
    }
    Layout.prototype.cell = function (id) {
        return this._all[id];
    };
    Layout.prototype.updateActiveView = function (id) {
        for (var i = 0; i < this._cells.length; i++) {
            if (this._cells[i].id === id) {
                if (this.config.activeView !== i) {
                    this.config.activeView = i;
                    this.paint();
                }
                return;
            }
        }
    };
    Layout.prototype.getActiveView = function () {
        return this._cells[this.config.activeView];
    };
    Layout.prototype.toVDOM = function () {
        if (this._isViewLayout) {
            return _super.prototype.toVDOM.call(this, [this.getActiveView().toVDOM()]);
        }
        var nodes = [];
        this._cells.forEach(function (cell) {
            var node = cell.toVDOM();
            if (Array.isArray(node)) {
                nodes.push.apply(nodes, node);
            }
            else {
                nodes.push(node);
            }
        });
        return _super.prototype.toVDOM.call(this, nodes, this._isTopParent);
    };
    Layout.prototype.removeCell = function (id) {
        var topParent = this.getTopParent();
        if (topParent._all[id]) {
            var parent_1 = topParent._all[id].getParent();
            delete topParent._all[id];
            var cells = parent_1._cells;
            var deleteIndex = -1;
            for (var i = 0; i < cells.length; i++) {
                if (cells[i].id === id) {
                    deleteIndex = i;
                    break;
                }
            }
            if (deleteIndex !== -1) {
                cells.splice(deleteIndex, 1);
            }
            this.paint();
        }
    };
    Layout.prototype.addCell = function (config, index) {
        if (index === void 0) { index = -1; }
        var topParent = this.getTopParent();
        var view = this._parseView(config, topParent);
        if (index < 0) {
            index = this._cells.length + index + 1;
        }
        this._cells.splice(index, 0, view);
        this.paint();
    };
    Layout.prototype.getId = function (index) {
        if (index < 0) {
            index = this._cells.length + index;
        }
        return this._cells[index] ? this._cells[index].id : undefined;
    };
    Layout.prototype._parseConfig = function () {
        var _this = this;
        var config = this.config;
        var topParent = this.getTopParent();
        var cells = config.rows || config.cols || config.views;
        this._xLayout = !config.rows;
        this._cells = cells.map(function (a) { return _this._parseView(a, topParent); });
    };
    Layout.prototype._createUi = function (cell) {
        if (cell.rows || cell.cols || cell.views) {
            return new Layout(this, cell);
        }
        else {
            return new Cell_1.Cell(this, cell);
        }
    };
    Layout.prototype._parseView = function (raw, topParent) {
        var view = this._createUi(raw);
        if (raw.id) {
            topParent._all[raw.id] = view;
        }
        return view;
    };
    return Layout;
}(Cell_1.Cell));
exports.Layout = Layout;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var resizeMode;
(function (resizeMode) {
    resizeMode[resizeMode["unknown"] = 0] = "unknown";
    resizeMode[resizeMode["percents"] = 1] = "percents";
    resizeMode[resizeMode["pixels"] = 2] = "pixels";
    resizeMode[resizeMode["mixedpx1"] = 3] = "mixedpx1";
    resizeMode[resizeMode["mixedpx2"] = 4] = "mixedpx2";
    resizeMode[resizeMode["mixedperc1"] = 5] = "mixedperc1";
    resizeMode[resizeMode["mixedperc2"] = 6] = "mixedperc2";
})(resizeMode || (resizeMode = {}));
function getResizeMode(dir, conf1, conf2) {
    var field = dir ? "width" : "height";
    var is1perc = conf1[field] && conf1[field].indexOf("%") !== -1;
    var is2perc = conf2[field] && conf2[field].indexOf("%") !== -1;
    var is1px = conf1[field] && conf1[field].indexOf("px") !== -1;
    var is2px = conf2[field] && conf2[field].indexOf("px") !== -1;
    if (is1perc && is2perc) {
        return resizeMode.percents;
    }
    if (is1px && is2px) {
        return resizeMode.pixels;
    }
    if (is1px && !is2px) {
        return resizeMode.mixedpx1;
    }
    if (is2px && !is1px) {
        return resizeMode.mixedpx2;
    }
    if (is1perc) {
        return resizeMode.mixedperc1;
    }
    if (is2perc) {
        return resizeMode.mixedperc2;
    }
    return resizeMode.unknown;
}
function getBlockRange(block1, block2, isXLayout) {
    if (isXLayout === void 0) { isXLayout = true; }
    if (isXLayout) {
        return {
            min: block1.left + window.pageXOffset,
            max: block2.right + window.pageXOffset
        };
    }
    return {
        min: block1.top + window.pageYOffset,
        max: block2.bottom + window.pageYOffset
    };
}
var Cell = /** @class */ (function (_super) {
    __extends(Cell, _super);
    function Cell(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        _this._parent = parent;
        _this._isTopParent = !(parent instanceof Cell);
        _this._initHandlers();
        _this.mount(parent, { redraw: function () {
                parent.paint();
            } });
        _this.id = _this.config.id;
        _this._css = "";
        return _this;
    }
    Cell.prototype.isVisible = function () {
        return !this.config.hidden;
    };
    Cell.prototype.isView = function () {
        return !!this._parent.config.views;
    };
    Cell.prototype.hide = function () {
        this.config.hidden = true;
        this.paint();
    };
    Cell.prototype.show = function (_forced) {
        if (this.isView()) {
            this._parent.updateActiveView(this.id);
            return;
        }
        if (this._parent && !this._parent.isVisible()) {
            this._parent.show();
        }
        this.config.hidden = false;
        this.paint();
    };
    Cell.prototype.getParent = function () {
        return this._parent;
    };
    Cell.prototype.getTopParent = function () {
        if (this._isTopParent) {
            return this;
        }
        var parent = this.getParent();
        while (parent) {
            if (parent._isTopParent) {
                return parent;
            }
            parent = parent.getParent();
        }
    };
    Cell.prototype.destructor = function () {
        this.config = null;
    };
    Cell.prototype.getWidget = function () {
        return this._ui;
    };
    Cell.prototype.attach = function (name, config) {
        if (typeof name === "object") {
            this._ui = name;
        }
        else if (typeof name === "string") {
            this._ui = new window.dhx[name](null, config);
        }
        else if (typeof name === "function") {
            if (name.prototype instanceof view_1.View) {
                this._ui = new name(null, config);
            }
            else {
                this._ui = {
                    getRootView: function () {
                        return name(config);
                    }
                };
            }
        }
        this.paint();
        return this._ui;
    };
    Cell.prototype.toVDOM = function (nodes, isTopParent) {
        if (isTopParent === void 0) { isTopParent = false; }
        var conf = this.config;
        if (conf.hidden) {
            return;
        }
        var css = this._css + " " + (this.config.css || "") + (isTopParent ? " dhx_widget" : "");
        var style = this._calculateStyle();
        var kids;
        if (this.config.html) {
            kids = [dom_1.el("div", { ".innerHTML": this.config.html })];
        }
        else if (this._ui) {
            var view = this._ui.getRootView();
            if (view.render) {
                view = dom_1.inject(view);
            }
            kids = [view];
        }
        else {
            kids = nodes || null;
        }
        var resizer = this.config.canResize && !this._isLastCell() ?
            dom_1.el(".resizer." + (this._isXDirection() ? "x" : "y"), __assign({}, this._resizerHandlers, { _ref: "resizer_" + this._uid }), [dom_1.el("div", {
                    class: "dxi " + (this._isXDirection() ? "dxi-dots-vertical" : "dxi-dots-horizontal")
                })]) : null;
        var handlers = {};
        if (this.config.on) {
            for (var key in this.config.on) {
                handlers["on" + key] = this.config.on[key];
            }
        }
        var cell = dom_1.el("div", __assign({ _key: this._uid, style: style, _ref: this._uid }, handlers, { class: "dhx_cell " + css + (this.config.collapsed ? " collapsed" : "") }), [
            this.config.header ? dom_1.el("div", {
                class: "dhx_cell_header",
                onclick: this._handlers.collapse
            }, [
                dom_1.el(".header-text", this.config.header),
                dom_1.el(".header-action-icon", [
                    dom_1.el("div", {
                        class: "dxi " + this.config.headerIcon
                    })
                ])
            ]) : null,
            !this.config.collapsed ? dom_1.el("div", {
                class: "dhx_cell_content"
            }, kids) : null,
            this.config.footer ? dom_1.el("div", {
                class: "dhx_cell_footer",
            }, this.config.footer) : null
        ]);
        return resizer ? [
            cell,
            resizer
        ] : cell;
    };
    Cell.prototype._initHandlers = function () {
        var _this = this;
        var blockOpts = {
            left: null,
            top: null,
            isActive: false,
            range: null,
            xLayout: null,
            nextCell: null,
            size: null,
            resizerLength: null,
            mode: null,
            percentsum: null
        };
        var mouseUp = function () {
            blockOpts.isActive = false;
            document.body.classList.remove("dhx-no-select");
            document.removeEventListener("mouseup", mouseUp);
            document.removeEventListener("mousemove", mouseMove);
        };
        var mouseMove = function (e) {
            if (!blockOpts.isActive || blockOpts.mode === resizeMode.unknown) {
                return;
            }
            var newValue = blockOpts.xLayout ? e.x - blockOpts.range.min - window.pageXOffset :
                e.y - blockOpts.range.min - window.pageYOffset;
            var prop = blockOpts.xLayout ? "width" : "height";
            if (newValue < 0) {
                newValue = blockOpts.resizerLength / 2;
            }
            else if (newValue > blockOpts.size) {
                newValue = blockOpts.size - blockOpts.resizerLength;
            }
            switch (blockOpts.mode) {
                case resizeMode.pixels:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx1:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx2:
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.percents:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc1:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc2:
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
            }
            _this.paint();
        };
        this._handlers = {
            collapse: function () {
                if (!_this.config.canCollapse) {
                    return;
                }
                _this.config.collapsed = !_this.config.collapsed;
                _this.paint();
            }
        };
        this._resizerHandlers = {
            onmousedown: function (e) {
                if (e.which === 3) {
                    return;
                }
                if (blockOpts.isActive) {
                    mouseUp();
                }
                document.body.classList.add("dhx-no-select");
                var block = _this._getCellView();
                var nextCell = _this._getNextCell();
                var nextBlock = nextCell._getCellView();
                var resizerBlock = _this._getResizerView();
                var blockOffsets = block.el.getBoundingClientRect();
                var resizerOffsets = resizerBlock.el.getBoundingClientRect();
                var nextBlockOffsets = nextBlock.el.getBoundingClientRect();
                blockOpts.xLayout = _this._isXDirection();
                blockOpts.left = blockOffsets.left + window.pageXOffset;
                blockOpts.top = blockOffsets.top + window.pageYOffset;
                blockOpts.range = getBlockRange(blockOffsets, nextBlockOffsets, blockOpts.xLayout);
                blockOpts.size = blockOpts.range.max - blockOpts.range.min;
                blockOpts.isActive = true;
                blockOpts.nextCell = nextCell;
                blockOpts.resizerLength = blockOpts.xLayout ? resizerOffsets.width : resizerOffsets.height;
                blockOpts.mode = getResizeMode(blockOpts.xLayout, _this.config, nextCell.config);
                if (blockOpts.mode === resizeMode.percents) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = parseFloat(_this.config[field]) + parseFloat(nextCell.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc1) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (blockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(_this.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc2) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (nextBlockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(nextCell.config[field]);
                }
                document.addEventListener("mouseup", mouseUp);
                document.addEventListener("mousemove", mouseMove);
            },
            ondragstart: function (e) { return e.preventDefault(); }
        };
    };
    Cell.prototype._isLastCell = function () {
        var parent = this._parent;
        return parent && parent._cells.indexOf(this) === parent._cells.length - 1;
    };
    Cell.prototype._getNextCell = function () {
        var parent = this._parent;
        var index = parent._cells.indexOf(this);
        return parent._cells[index + 1];
    };
    Cell.prototype._getCellView = function () {
        return this.getTopParent().getRootView().refs[this._uid];
    };
    Cell.prototype._getResizerView = function () {
        return this.getTopParent().getRootView().refs["resizer_" + this._uid];
    };
    Cell.prototype._isXDirection = function () {
        return this._parent && this._parent._xLayout;
    };
    Cell.prototype._calculateStyle = function () {
        var conf = this.config;
        var style = {};
        if (this._isXDirection()) {
            if (this.config.width !== undefined) {
                style.flex = "0 0 " + conf.width;
            }
            if (conf.height !== undefined) {
                style.height = conf.height;
            }
        }
        else {
            if (this.config.height !== undefined) {
                style.flex = "0 0 " + conf.height;
            }
            if (conf.width !== undefined) {
                style.width = conf.width;
            }
        }
        return style;
    };
    return Cell;
}(view_1.View));
exports.Cell = Cell;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(26));
__export(__webpack_require__(61));
__export(__webpack_require__(62));
__export(__webpack_require__(63));
__export(__webpack_require__(17));
var types_1 = __webpack_require__(4);
exports.ToolbarEvents = types_1.ToolbarEvents;
exports.ItemType = types_1.ItemType;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function button(item) {
    return dom_1.el("div", {
        class: "button-container main-btn element" + helpers_1.getCss(item) + (item.value ? "" : " no-text"),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.button = button;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function customHTMLButton(item) {
    return dom_1.el("div", {
        class: "button-container custom-html-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".html-content", {
            ".innerHTML": item.html
        }),
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.customHTMLButton = customHTMLButton;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function dhx_button(item) {
    return dom_1.el("button", {
        class: "dhx_btn" + helpers_1.getCss(item) + helpers_1.getButtonCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".item-value", item.value) : null
    ]);
}
exports.dhx_button = dhx_button;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function iconButton(item) {
    return dom_1.el("div", {
        class: "icon-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        helpers_1.icon(item.icon),
        item.css && item.css.indexOf("ripple") !== -1 ? dom_1.el(".ripple-container-outside") : null
    ]);
}
exports.iconButton = iconButton;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButton(item) {
    return dom_1.el("div", {
        class: "button-container img-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".img-button-wrapper", [
            dom_1.el("img.img-button", {
                src: item.src
            })
        ])
    ]);
}
exports.imageButton = imageButton;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButtonText(item) {
    return dom_1.el("div", {
        class: "button-container img-text-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el("img.img-button", {
            src: item.src
        }),
        dom_1.el(".button-text", item.value)
    ]);
}
exports.imageButtonText = imageButtonText;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
var helpers_1 = __webpack_require__(2);
function input(item, events) {
    return dom_1.el("div", {
        dhx_id: item.id,
        class: "input-container element" + helpers_1.getCss(item)
    }, [
        dom_1.el(".input-wrapper", [
            dom_1.el("input.text-input", {
                placeholder: item.placeholder,
                value: item.value,
                style: {
                    width: item.width ? item.width : null
                },
                _hooks: {
                    didInsert: function (node) {
                        if (events) {
                            events.fire(types_1.ToolbarEvents.inputCreated, [item.id, node.el]);
                        }
                    }
                },
                _key: item.id
            }),
            dom_1.el(".input-animation")
        ]),
        item.icon ? helpers_1.icon(item.icon) : null
    ]);
}
exports.input = input;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function menuItem(item) {
    return dom_1.el("div", {
        class: "menu-item element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el("span.menu-item-content", item.value) : null,
        item.$openIcon ? dom_1.el(".dhx-icon.sub-menu-opener", [
            dom_1.el(".dxi." + (item.$openIcon === "right" ? ".dxi-menu-right" : ".dxi-menu-down"))
        ]) : null,
        item.hotkey ? dom_1.el(".hotkey", item.hotkey) : null
    ]);
}
exports.menuItem = menuItem;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function separator(_item) {
    return dom_1.el(".separator");
}
exports.separator = separator;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function spacer(_item) {
    return dom_1.el(".spacer");
}
exports.spacer = spacer;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function text(item) {
    return dom_1.el("div", {
        class: "text element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, item.value);
}
exports.text = text;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getHotKeyCode(code) {
    var matches = code.toLowerCase().match(/\w+/g);
    var comp = 0;
    var key = "";
    for (var i = 0; i < matches.length; i++) {
        var check = matches[i];
        if (check === "ctrl") {
            comp += 4;
        }
        else if (check === "shift") {
            comp += 2;
        }
        else if (check === "alt") {
            comp += 1;
        }
        else {
            key = check;
        }
    }
    return comp + key;
}
var KeyManager = /** @class */ (function () {
    function KeyManager() {
        var _this = this;
        this._keysStorage = {};
        document.addEventListener("keydown", function (e) {
            var comp = (e.ctrlKey ? 4 : 0) + (e.shiftKey ? 2 : 0) + (e.altKey ? 1 : 0);
            if(e.key != null && e.key != undefined && e.key !="") {
              var code = comp + e.key.toLowerCase();
              var action = _this._keysStorage[code];
              if (action) {
                  action.handler(e);
              }
            }
        });
    }
    KeyManager.prototype.addHotKey = function (key, handler, scope) {
        var code = getHotKeyCode(key);
        this._keysStorage[code] = {
            handler: handler,
            scope: scope
        };
    };
    KeyManager.prototype.removeHotKey = function (key, scope) {
        var keyStorage = this._keysStorage;
        if (key) {
            var code = getHotKeyCode(key);
            delete keyStorage[code];
        }
        if (scope) {
            for (var code in keyStorage) {
                if (keyStorage[code].scope === scope) {
                    delete keyStorage[code];
                }
            }
        }
    };
    KeyManager.prototype.exist = function (key) {
        var code = getHotKeyCode(key);
        return !!this._keysStorage[code];
    };
    return KeyManager;
}());
exports.keyManager = new KeyManager();


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var helper_1 = __webpack_require__(13);
var MenuBase_1 = __webpack_require__(18);
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isContextMenu = true;
        return _this;
    }
    ContextMenu.prototype.showAt = function (elem, showAt) {
        if (showAt === void 0) { showAt = "bottom"; }
        if (elem instanceof MouseEvent) {
            this._changeActivePosition({
                left: window.pageXOffset + elem.x + 1,
                right: window.pageXOffset + elem.x + 1,
                top: window.pageYOffset + elem.y,
                bottom: window.pageYOffset + elem.y
            }, showAt);
        }
        else {
            var node = html_1.toNode(elem);
            this._changeActivePosition(helper_1.getRealPosition(node), showAt);
        }
    };
    ContextMenu.prototype._close = function () {
        this._activeMenu = null;
        this._changeActivePosition(null, null);
    };
    ContextMenu.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id)) {
                item.$openIcon = "right";
            }
        }, true);
    };
    ContextMenu.prototype._getMode = function (_item, _root, active) {
        return active ? this._mode : "right";
    };
    ContextMenu.prototype._changeActivePosition = function (position, mode) {
        this._activePosition = position;
        this._mode = mode;
        this._listenOuterClick();
        this.paint();
    };
    return ContextMenu;
}(MenuBase_1.MenuBase));
exports.ContextMenu = ContextMenu;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var MenuBase_1 = __webpack_require__(18);
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(element, config) {
        var _this = _super.call(this, element, config) || this;
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Menu.prototype._draw = function () {
        return dom_1.el("div", __assign({ dhx_widget_id: this._uid, class: "main-menu" }, this._handlers), this._drawMenuItems(this.data.getRoot()));
    };
    return Menu;
}(MenuBase_1.MenuBase));
exports.Menu = Menu;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helper_1 = __webpack_require__(13);
var Toolbar_1 = __webpack_require__(26);
var types_1 = __webpack_require__(4);
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ribbon.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".ribbon.dhx_widget", {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick
        }, this.data.map(function (block) { return _this._drawBlock(block.id); }, this.data.getRoot(), false));
    };
    Ribbon.prototype._setRoot = function (id) {
        var parentId = this.data.getParent(id);
        if (this.data.getItem(parentId).type === types_1.ItemType.block) {
            this._currentRoot = id;
        }
    };
    Ribbon.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    var parentId = _this.data.getParent(item.id);
                    var parent_1 = _this.data.getItem(parentId);
                    item.$openIcon = parent_1.type === types_1.ItemType.block ? "bot" : "right";
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Ribbon.prototype._drawBlock = function (id) {
        var _this = this;
        var block = this.data.getItem(id);
        if (!block) {
            return null;
        }
        var direction = block.direction === "row" ? " ribbon-row" : " ribbon-cols";
        var childs = this.data.map(function (child) {
            if (child.type === types_1.ItemType.block) {
                return _this._drawBlock(child.id);
            }
            return _this._factory(child);
        }, id, false);
        return dom_1.el("div", {
            class: "ribbon-item-block" + direction
        }, [
            dom_1.el(".block-content", childs),
            block.label ? dom_1.el(".block-label", [dom_1.el("span", block.label)]) : null
        ]);
    };
    return Ribbon;
}(Toolbar_1.Toolbar));
exports.Ribbon = Ribbon;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var ts_data_1 = __webpack_require__(8);
var types_1 = __webpack_require__(15);
var Uploader = /** @class */ (function () {
    function Uploader(config, data, events) {
        if (config === void 0) { config = {}; }
        this.config = core_1.extend({
            autosend: true,
            updateFromResponse: true,
            fieldName: "file"
        }, config);
        this.data = data || new ts_data_1.DataCollection();
        this.events = events || this.data.events;
        this.isActive = false;
        this._fileInput = document.createElement("input");
        this._fileInput.type = "file";
        this._fileInput.multiple = config.multiple;
        this._fileInput.accept = config.accept;
        this._initEvents();
        this._dropAreas = new Map();
    }
    Uploader.prototype.selectFile = function () {
        this._fileInput.click();
    };
    Uploader.prototype.linkDropArea = function (element) {
        var _this = this;
        var node = html_1.toNode(element);
        var mouseover = function () { return node.style.cursor = "pointer"; };
        var dragover = function (e) { return e.preventDefault(); };
        var drop = function (e) {
            e.preventDefault();
            _this.parseFiles(e.dataTransfer);
        };
        node.addEventListener("mouseover", mouseover);
        node.addEventListener("dragover", dragover);
        node.addEventListener("drop", drop);
        this._dropAreas.set(node, {
            mouseover: mouseover,
            dragover: dragover,
            drop: drop
        });
    };
    Uploader.prototype.unlinkDropArea = function (element) {
        var _this = this;
        if (!element) {
            this._dropAreas.forEach(function (_, node) {
                _this._unlinkDropArea(node);
            });
            this._dropAreas.clear();
        }
        else {
            var node = html_1.toNode(element);
            this._unlinkDropArea(node);
            this._dropAreas.delete(node);
        }
    };
    Uploader.prototype.parseFiles = function (dataTransfer) {
        if (!dataTransfer.items || !dataTransfer.items[0] || !dataTransfer.items[0].webkitGetAsEntry) {
            var files = dataTransfer.files;
            for (var i = 0; i < files.length; i++) {
                this._addFile(files[i]);
            }
            if (this.config.autosend) {
                this.send();
            }
        }
        else {
            this._parseAsWebkitEntry(dataTransfer.items);
        }
    };
    Uploader.prototype.send = function (params) {
        var _this = this;
        if (this._uploadInfo && this.isActive) {
            // cancel two active sends
            return;
        }
        var all = this.data.findAll(function (item) { return item.status === types_1.FileStatus.queue || item.status === types_1.FileStatus.failed; });
        var files = all.filter(function (file) { return _this.events.fire(types_1.UploaderEvents.beforeUploadFile, [file]); });
        if (!files.length) {
            return;
        }
        this.isActive = true;
        this._uploadInfo = {
            files: files,
            count: files.length,
            size: files.reduce(function (s, f) { return s + f.file.size; }, 0)
        };
        this.events.fire(types_1.UploaderEvents.uploadBegin, [files]);
        this.events.fire(types_1.UploaderEvents.uploadProgress, [0, 0, this._uploadInfo.size]);
        if (this.config.singleRequest) {
            this._xhrSend(files, params);
        }
        else {
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var fileWrapper = files_1[_i];
                this._xhrSend([fileWrapper], params);
            }
        }
    };
    Uploader.prototype.abort = function (id) {
        if (!id) {
            if (!this._uploadInfo || !this._uploadInfo.files) {
                return;
            }
            for (var _i = 0, _a = this._uploadInfo.files; _i < _a.length; _i++) {
                var fileWrapper = _a[_i];
                this.abort(fileWrapper.id);
            }
            return;
        }
        else {
            var item = this.data.getItem(id);
            if (!item || !item.request || item.request.readyState === 4) {
                return;
            }
            item.request.abort();
        }
    };
    Uploader.prototype._unlinkDropArea = function (node) {
        var handlers = this._dropAreas.get(node);
        if (!handlers) {
            return;
        }
        var mouseover = handlers.mouseover, dragover = handlers.dragover, drop = handlers.drop;
        node.removeEventListener("mouseover", mouseover);
        node.removeEventListener("dragover", dragover);
        node.removeEventListener("drop", drop);
    };
    Uploader.prototype._initEvents = function () {
        var _this = this;
        this._fileInput.addEventListener("change", function () {
            var files = _this._fileInput.files;
            for (var i = 0; i < files.length; i++) {
                _this._addFile(files[i]);
            }
            if (_this.config.autosend) {
                _this.send();
            }
            _this._fileInput.value = null; // clear file input after get info about files
        });
    };
    Uploader.prototype._xhrSend = function (fileWrappers, params) {
        var _this = this;
        var formData = this._createFormData(fileWrappers, params);
        var request = new XMLHttpRequest();
        for (var _i = 0, fileWrappers_1 = fileWrappers; _i < fileWrappers_1.length; _i++) {
            var fileWrapper = fileWrappers_1[_i];
            this.data.update(fileWrapper.id, {
                request: request,
                status: types_1.FileStatus.inprogress,
                progress: 0
            });
        }
        request.open("POST", this.config.target);
        request.upload.onprogress = function (ev) {
            for (var _i = 0, fileWrappers_2 = fileWrappers; _i < fileWrappers_2.length; _i++) {
                var fileWrapper = fileWrappers_2[_i];
                _this.data.update(fileWrapper.id, {
                    progress: ev.loaded / ev.total,
                    status: types_1.FileStatus.inprogress
                });
            }
            var current = _this._uploadInfo.files.reduce(function (tot, file) { return tot + file.size * file.progress; }, 0) || 0;
            var total = _this._uploadInfo.size;
            var progress = current / _this._uploadInfo.size * 100 || 0;
            _this.events.fire(types_1.UploaderEvents.uploadProgress, [progress, current, total]);
        };
        request.onloadend = function () {
            _this._uploadInfo.count = _this.config.singleRequest ? 0 : _this._uploadInfo.count - 1;
            var status = request.status === 200 ? types_1.FileStatus.uploaded : types_1.FileStatus.failed;
            var extra = request.status === 200 && request.response ? JSON.parse(request.response) : null;
            for (var _i = 0, fileWrappers_3 = fileWrappers; _i < fileWrappers_3.length; _i++) {
                var fileWrapper = fileWrappers_3[_i];
                _this.data.update(fileWrapper.id, { status: status });
                if (status === types_1.FileStatus.uploaded) {
                    if (_this.config.updateFromResponse && extra) {
                        if (_this.config.singleRequest && extra[fileWrapper.id]) {
                            _this.data.update(fileWrapper.id, extra[fileWrapper.id]);
                        }
                        else if (!_this.config.singleRequest) {
                            _this.data.update(fileWrapper.id, extra);
                        }
                    }
                    _this.events.fire(types_1.UploaderEvents.uploadFile, [fileWrapper, extra]);
                }
                else {
                    _this.events.fire(types_1.UploaderEvents.uploadFail, [fileWrapper]);
                }
            }
            if (_this._uploadInfo.count === 0) {
                _this.isActive = false;
                _this.events.fire(types_1.UploaderEvents.uploadComplete, [_this._uploadInfo.files]);
            }
        };
        request.send(formData);
    };
    Uploader.prototype._parseAsWebkitEntry = function (items) {
        var _this = this;
        var reads = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i].webkitGetAsEntry();
            reads.push(this._traverseFileTree(item));
        }
        Promise.all(reads).then(function () {
            if (_this.config.autosend) {
                _this.send();
            }
        });
    };
    Uploader.prototype._createFormData = function (fileWrappers, params) {
        var fieldName = this.config.fieldName;
        var formData = new FormData();
        var extraParams = this.config.params;
        if (params) {
            for (var key in params) {
                formData.append(key, params[key]);
            }
        }
        if (extraParams) {
            for (var key in extraParams) {
                formData.append(key, extraParams[key]);
            }
        }
        var brackets = fileWrappers.length > 1 ? "[]" : "";
        for (var _i = 0, fileWrappers_4 = fileWrappers; _i < fileWrappers_4.length; _i++) {
            var fileWrapper = fileWrappers_4[_i];
            formData.append(fieldName + brackets, fileWrapper.file, fileWrapper.file.name);
            formData.append(fieldName + "_fullname" + brackets, fileWrapper.path + fileWrapper.file.name);
            formData.append(fieldName + "_id" + brackets, fileWrapper.id);
        }
        return formData;
    };
    Uploader.prototype._addFile = function (file, path) {
        if (path === void 0) { path = ""; }
        var fileWrapper = {
            id: core_1.uid(),
            file: file,
            progress: 0,
            status: types_1.FileStatus.queue,
            src: null,
            path: path
        };
        this.data.add(fileWrapper);
    };
    Uploader.prototype._traverseFileTree = function (item) {
        var _this = this;
        return new Promise(function (res) {
            var count = 0;
            var readEntry = function (entry, path) {
                if (entry.isFile) {
                    count++;
                    entry.file(function (file) {
                        count--;
                        _this._addFile(file, path);
                        if (count === 0) {
                            res();
                        }
                    });
                }
                else if (entry.isDirectory) {
                    var reader = entry.createReader();
                    readDirectory(reader, path + entry.name + "/");
                }
            };
            var readDirectory = function (reader, path) {
                count++;
                reader.readEntries(function (entries) {
                    count--;
                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        var entry = entries_1[_i];
                        readEntry(entry, path);
                    }
                    if (count === 0) {
                        res();
                    }
                });
            };
            readEntry(item, "");
        });
    };
    return Uploader;
}());
exports.Uploader = Uploader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutConfig = {
    css: "vault-layout",
    rows: [
        {
            id: "topbar",
            css: "vault-topbar"
        },
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};
exports.layoutConfigWithoutTopbar = {
    css: "vault-layout",
    rows: [
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(14);
var basis = [
    "byte",
    "kilobyte",
    "megabyte",
    "gigabyte"
];
function getBasis(size, current) {
    if (size === void 0) { size = 0; }
    if (current === void 0) { current = 0; }
    return size < 1024 ? size + " " + en_1.default[basis[current]] : this.getBasis(Math.round(size / 1024), current + 1);
}
exports.getBasis = getBasis;
var MAX_WORD_LENGTH = 13;
function truncateWord(word, len) {
    if (len === void 0) { len = MAX_WORD_LENGTH; }
    var start;
    var end;
    if (word.length <= len) {
        return word;
    }
    var dotIndex = word.lastIndexOf(".");
    if (dotIndex === -1) {
        end = word.substr(word.length - 4);
        start = word.substr(0, len - 7);
    }
    else {
        var endStartFrom = dotIndex - 3;
        end = word.substr(endStartFrom);
        start = word.substr(0, len - (word.length - endStartFrom));
    }
    return start + "..." + end;
}
exports.truncateWord = truncateWord;
function calculateCover(image) {
    var width = image.width, height = image.height;
    var imageAspectRatio = width / height;
    var sHeight;
    var sWidth;
    var sx;
    var sy;
    if (imageAspectRatio > 1) {
        // width > height
        sWidth = height;
        sHeight = height;
        sx = (width - sWidth) / 2;
        sy = 0;
    }
    else if (imageAspectRatio < 1) {
        // width < height
        sWidth = width;
        sHeight = width;
        sx = 0;
        sy = (height - sHeight) / 2;
    }
    else {
        // width == height
        sHeight = width;
        sWidth = width;
        sx = 0;
        sy = 0;
    }
    return {
        sx: sx,
        sy: sy,
        sWidth: sWidth,
        sHeight: sHeight,
        dx: 0,
        dy: 0
    };
}
exports.calculateCover = calculateCover;
var FileType;
(function (FileType) {
    FileType["image"] = "image";
    FileType["video"] = "video";
    FileType["archive"] = "archive";
    FileType["table"] = "table";
    FileType["document"] = "document";
    FileType["presentation"] = "presentation";
    FileType["application"] = "application";
    FileType["web"] = "web";
    FileType["apple"] = "apple";
    FileType["pdf"] = "pdf";
    FileType["psd"] = "psd";
    FileType["audio"] = "audio";
    FileType["other"] = "other";
    FileType["text"] = "text";
})(FileType = exports.FileType || (exports.FileType = {}));
function getMimeAndExtension(fileWrapper) {
    var extension = fileWrapper.name.split(".").pop() || "none";
    var mime = fileWrapper.file ? fileWrapper.file.type : "";
    return {
        extension: extension,
        mime: mime
    };
}
function getFileType(extension, mime) {
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "gif":
        case "png":
        case "bmp":
        case "tiff":
        case "pcx":
        case "svg":
        case "ico":
            return FileType.image;
        case "avi":
        case "mpg":
        case "mpeg":
        case "rm":
        case "move":
        case "mov":
        case "mkv":
        case "flv":
        case "f4v":
        case "mp4":
        case "3gp":
        case "wmv":
        case "webm":
        case "vob":
            return FileType.video;
        case "rar":
        case "zip":
        case "tar":
        case "tgz":
        case "arj":
        case "gzip":
        case "bzip2":
        case "7z":
        case "ace":
        case "apk":
        case "deb":
        case "zipx":
        case "cab":
        case "tar-gz":
        case "rpm":
        case "xar":
            return FileType.archive;
        case "xlr":
        case "xls":
        case "xlsm":
        case "xlsx":
        case "ods":
        case "csv":
        case "tsv":
            return FileType.table;
        case "doc":
        case "docx":
        case "docm":
        case "dot":
        case "dotx":
        case "odt":
        case "wpd":
        case "wps":
        case "pages":
            return FileType.document;
        case "wav":
        case "aiff":
        case "au":
        case "mp3":
        case "aac":
        case "wma":
        case "ogg":
        case "flac":
        case "ape":
        case "wv":
        case "m4a":
        case "mid":
        case "midi":
            return FileType.audio;
        case "pot":
        case "potm":
        case "potx":
        case "pps":
        case "ppsm":
        case "ppsx":
        case "ppt":
        case "pptx":
        case "pptm":
        case "odp":
            return FileType.presentation;
        case "html":
        case "htm":
        case "eml":
            return FileType.web;
        case "exe":
            return FileType.application;
        case "dmg":
            return FileType.apple;
        case "pdf":
        case "ps":
        case "eps":
            return FileType.pdf;
        case "psd":
            return FileType.psd;
        case "txt":
        case "djvu":
        case "nfo":
        case "xml":
            return FileType.text;
        default:
            var type = mime.split("/")[0];
            switch (type) {
                case "image":
                    return FileType.image;
                case "audio":
                    return FileType.audio;
                case "video":
                    return FileType.video;
                default:
                    return FileType.other;
            }
    }
}
exports.getFileType = getFileType;
function getFileClassName(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    return getFileType(extension, mime) + " extension-" + extension;
}
exports.getFileClassName = getFileClassName;
function isImage(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    var fileType = getFileType(extension, mime);
    return fileType === FileType.image;
}
exports.isImage = isImage;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar(events, config) {
        var _this = _super.call(this, null, config) || this;
        _this.events = events;
        _this._progress = 0;
        var render = function () { return _this._draw(); };
        _this.mount(null, dom_1.create({
            render: render
        }));
        _this._abortUpload = function () {
            _this.events.fire(types_1.ProgressBarEvents.cancel);
        };
        return _this;
    }
    ProgressBar.prototype.setState = function (progress, extra) {
        this._progress = progress;
        if (this.config.template) {
            this._progressText = this.config.template(progress, extra);
        }
        else {
            this._progressText = this._progress.toFixed(1) + "%";
        }
        this.paint();
    };
    ProgressBar.prototype._draw = function () {
        return dom_1.el(".progress-bar", {
            _key: this._uid
        }, [
            dom_1.el(".progress-indicator", {
                style: {
                    width: this._progress + "%"
                }
            }),
            dom_1.el(".progress-text", {
                ".innerHTML": this._progressText
            }),
            dom_1.el("button", {
                class: "dhx_btn dhx_btn--flat dhx_btn_small action-abort-all",
                onclick: this._abortUpload
            }, en_1.default.cancel)
        ]);
    };
    return ProgressBar;
}(view_1.View));
exports.ProgressBar = ProgressBar;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReadStackPreview = /** @class */ (function () {
    function ReadStackPreview(data) {
        this._readerStack = [];
        this._isActive = false;
        this._data = data;
    }
    ReadStackPreview.prototype.add = function (fileWrapper, wait) {
        if (wait === void 0) { wait = false; }
        this._readerStack.push(fileWrapper);
        if (!wait) {
            this.read();
        }
    };
    ReadStackPreview.prototype.read = function () {
        var _this = this;
        if (!this._readerStack.length || this._isActive) {
            return;
        }
        var fileWrapper = this._readerStack.shift();
        this._isActive = true;
        var reader = new FileReader();
        reader.readAsDataURL(fileWrapper.file);
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                if (_this._data.exists(fileWrapper.id)) {
                    _this._data.update(fileWrapper.id, { image: image });
                }
                _this._isActive = false;
                _this.read();
            };
        };
        reader.onerror = function () {
            _this._isActive = false;
            _this.read();
        };
    };
    ReadStackPreview.prototype.stop = function () {
        this._readerStack = [];
    };
    return ReadStackPreview;
}());
exports.ReadStackPreview = ReadStackPreview;


/***/ })
/******/ ]);
});if (window.dhx_legacy) { if (window.dhx){ for (var key in dhx) dhx_legacy[key] = dhx[key]; } window.dhx = dhx_legacy; delete window.dhx_legacy; }

//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
angular.element(function() {
  angular.element(window).bind("load resize", function() {
    var topOffset = 50;
    var width =
      this.window.innerWidth > 0 ? this.window.innerWidth : this.screen.width;
    if (width < 768) {
      angular.element("div.navbar-collapse").addClass("collapse");
      topOffset = 100; // 2-row-menu
    } else {
      angular.element("div.navbar-collapse").removeClass("collapse");
    }

    var height = (this.window.innerHeight > 0 ? this.window.innerHeight : this.screen.height) - 1;
    height = height - topOffset;

    if (height < 1) height = 1;

    if (height > topOffset) {

      if(height < 600) {
        angular.element("#page-wrapper").css("min-height", "600px");
      } else {
        angular.element("#page-wrapper").css("min-height", (height + 50) + "px");
      }
    }
  });

  try {
    var url = angular.element(window).location;
    var element = angular
      .element("ul.nav a")
      .filter(function() {
        return this.href == url || (url.href && url.href.indexOf(this.href) == 0);
      })
      .addClass("active")
      .parent()
      .parent()
      .addClass("in")
      .parent();
    if (element.is("li")) {
      element.addClass("active");
    }
  } catch(e) {
    //console.log(e)
  }
});

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */

  /** @ngInject */
  var AppController = function ($scope, $log, $window) {
    var vm = this;
    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1532423437610;
    //$log.log(vm.creationDate);

    if ($window.sessionStorage.getItem('noHeader') == 'true') {
      $('html').addClass('noheader');
    }
  };

  var app = {
    templateUrl: 'app/app.html',
    controller: AppController,
  };

  webapp.component('app', app);
})();

// (function() {
//   "use strict";

  var appConfigData = {
    projectNm : 'SalevisCare',
    menuPoisition : 'default' // default, top1, top2;
  };

// })();
(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    // $urlRouterProvider.otherwise('/');
    $stateProvider
      .state("app.panelsWells", {
        url: "/panels-wells",
        component: "panelsWells"
      })
      .state("app.buttons", {
        url: "/buttons",
        component: "buttons"
      })
      .state("app.chart", {
        url: "/chart",
        templateUrl: "app/chart/chart.html"
      });
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name minovateApp.controller:MainCtrl
   * @description
   * # MainCtrl
   * Controller of the minovateApp
   */
  webapp.controller('MainCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$window',
    function ($scope, $http, $translate, $window) {
      $scope.main = {
        title: 'Salevis',
        settings: {
          navbarHeaderColor: 'scheme-default',
          sidebarColor: 'scheme-default',
          brandingColor: 'scheme-default',
          activeColor: 'default-scheme-color',
          headerFixed: true,
          asideFixed: true,
          rightbarShow: false,
          tenantDir: 'salevis',
        },
      };

      $scope.ajaxFaker = function () {
        $scope.data = [];
        var url =
          'http://www.filltext.com/?rows=10&fname={firstName}&lname={lastName}&delay=5&callback=JSON_CALLBACK';

        $http.jsonp(url).success(function (data) {
          $scope.data = data;
          angular.element('.tile.refreshing').removeClass('refreshing');
        });
      };

      $translate.use('ko');
      $window.sessionStorage['currentLanguage'] = 'ko';
    },
  ]);
})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPos
   * @description
   * # adminPosHeader
   */

  /** @ngInject */
  var PopController = function ($log, $window) {
    var vm = this;
    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1532423437610;
    //$log.log(vm.creationDate);

    if ($window.sessionStorage.getItem('noHeader') == 'true') {
      $('html').addClass('noheader');
    }
  };

  var pop = {
    templateUrl: 'app/pop.html',
    controller: PopController,
  };

  webapp.component('pop', pop);
})();

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost.bbs-master-detail-ctrl
 * @description # 게시판관리 상세보기 Controller
 */

webapp.controller('BbsMasterDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module *
 */

  function BbsMasterDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {

    // View Model
    var vm = this;
    vm.dataloader = false;
    vm.RoleList = [];

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId  : '',
        TenantId : vm.TenantId,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbsmaster',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId != '') {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : $stateParams.BbsMasterId,
      TenantId : vm.TenantId,
      tableNm : 'bbsmaster',
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getData() {
      vm.dataloader = true;
      var data = vm.srchDetail;

      data.mapCode = 'BbsMaster.getBbsMasterDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

            // #region 권한 체크박스 표시
            var RoleIds = [];
            if (vm.data.RoleIds != null) {
              RoleIds = vm.data.RoleIds.split(",");
            }

            vm.RoleList.forEach(function(item) {
              RoleIds.filter(function(e){
                if(e == item.RoleId){
                  item.checked = true;
                }
              });
            });
            // #endregion 권한 체크박스 표시
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.log("error");
        // console.error('Error> role-edit-ctrl> getData()', error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      var data = vm.data;
      data.mapCode = 'BbsMaster.deleteBbsMasterDetailBatch';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.bbs-master-list', {
                srch:srch
              }, {reload:'app.bbspost.bbs-master-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> role-detail-ctrl> deleteDataAction()', error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      }
    }

    function getRoleList() {
      var data = {};
      data.mapCode = 'Role.getRoleList';
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          angular.forEach(result.body.docs, function (item) {
            var obj = { RoleId : item.RoleId, RoleNm : item.RoleNm};
            vm.RoleList.push(obj);
          });
          getData();
        }
      }, function (error) {
        // 오류 발생
        console.log("error");
        // console.error("Error> getRoleList()");
        // console.table(error);
      });
    }

    // 함수 선언
    vm.getData = getData;
    vm.deleteDetail = deleteDetail;
    vm.goList = goList;
    vm.goEdit = goEdit;
    vm.getRoleList = getRoleList;

    // 데이터 조회
    getRoleList();
    
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-edit-ctrl
 * @description
 * # 게시판관리 등록/수정
 * Controller of the 게시판관리
 */
webapp.controller('BbsMasterEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */

  function BbsMasterEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;
    vm.RoleList = [];

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'TB_BBSMASTER',
        TenantId : vm.TenantId,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : vm.srch.BbsMasterId != null ? $stateParams.BbsMasterId : '',
      TenantId : vm.TenantId,
      tableNm : vm.srch.tableNm,
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author rohbi
    */
    function getData() {
      vm.dataloader = true;
      if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srchDetail;
      data.mapCode = 'BbsMaster.getBbsMasterDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

            // #region 권한 체크박스 표시
            var RoleIds = [];
            if (vm.data.RoleIds != null) {
              RoleIds = vm.data.RoleIds.split(",");
            }

            vm.RoleList.forEach(function(item) {
              RoleIds.filter(function(e){
                if(e == item.RoleId){
                  item.checked = true;
                }
                
              });
            });
            // #endregion 권한 체크박스 표시

            vm.dataloader = false;
            return;
          }
        } else {
          vm.dataloader = false;
        }
        console.table(result);
      }, function(error) {
        console.table(error);
        vm.dataloader = false;

      });
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
    */
    function setData() {

      // if($scope.theForm.Title.$invalid){
      //   gAlert("","제목을 입력해주세요.");
      //   return false;
      // }

      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.BbsMasterId;
      vm.data.MetatableNm = "TB_BBSPOST";
      vm.data.RoleList = [];

      angular.forEach(vm.RoleList, function (item) {
        if(item.checked == true) {
          vm.data.RoleList.push(item.RoleId);
        }
      });
  
      var data = vm.data;

      if (vm.data.BbsMasterId == null || vm.data.BbsMasterId == '') {
        // 등록
        data.mapcode = "BbsMaster.insertBbsMasterDetailBatch";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      } else {
        // 수정
        data.mapCode = "BbsMaster.updateBbsMasterDetailBatch";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (result.body.docs[0].BbsMasterId !== null || result.body.docs[0].TableId !== null) {
          // KeyId 조회
          vm.data.BbsMasterId = result.body.docs[0].BbsMasterId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              // 메뉴 새로고침
              $rootScope.$broadcast('broadcastSetChangeMenuList', {});

              if (vm.layout == 'N') {
                if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
                  $state.go("app.bbspost.bbs-master-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.bbspost.bbs-master-detail", {
                    srch: srch,
                    BbsMasterId: vm.data.BbsMasterId
                  });
                }
              } else {
                vm.srch.BbsMasterId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.bbspost.bbs-master-list.detail", { srch: srch, BbsMasterId:vm.data.BbsMasterId });
                
              }
            }
            
          });
          return;
        }
      }
      console.table(result);
    }

    function goList() {
      vm.srch.BbsMasterId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.bbspost.bbs-master-list", { srch: srch });
    }

    function getRoleList() {
      var data = {};
      data.mapCode = 'Role.getRoleList';
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          angular.forEach(result.body.docs, function (item) {
            var obj = { RoleId : item.RoleId, RoleNm : item.RoleNm};
            vm.RoleList.push(obj);
          });
          getData();
        }
      }, function (error) {
        // 오류 발생
        console.log("error");
        // console.error("Error> getRoleList()");
        // console.table(error);
      });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 조회
    getRoleList();
    },
  ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-list-ctrl
 * @description
 * # 게시판관리 목록
 * Controller of the 게시판관리 목록
 */

webapp.controller('BbsMasterListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
/**
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function BbsMasterListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'TB_BBSMASTER',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CustType : '',
        UseYN : '',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'TB_BBSMASTER';
      if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsMasterId;
    vm.listSize = [ 10, 25, 50, 100 ];


    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function resetSearch() {
      $state.go('app.bbspost.bbs-master-list', {srch : ''}, {reload:'app.bbspost.bbs-master-list'});
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getList() {
      vm.dataloader = true;
      vm.srch.page = vm.currentPage;

      getListCount();

      var data = angular.copy(vm.srch);
      data.selectType = 'List';
      data.mapCode = 'BbsMaster.getBbsMasterList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'BbsMaster.getBbsMasterListCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
      });
    }

    function goDetail(BbsMasterId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsMasterId;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch,
          BbsMasterId : ''
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch,
          BbsMasterId : ''
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {srch : srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();

webapp.config([
  '$stateProvider',
  '$urlRouterProvider',
  function ($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.bbspost', {
        url: '/bbspost',
        template: '<div ui-view></div>',
      })
      .state('app.bbspost.h0101-list', {
        url: '/h0101-list/:BoardId',
        templateUrl: 'app/board/h0101-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.bbspost.h0101-detail', {
        url: '/h0101-detail/:BoardId/:FreeBoardId',
        templateUrl: 'app/board/h0101-detail.html',
      })
      .state('app.bbspost.h0101-edit', {
        url: '/h0101-edit/:BoardId/:FreeBoardId',
        templateUrl: 'app/board/h0101-edit.html',
      })
      .state('app.bbspost.h0102-list', {
        url: '/h0102-list/:TableNm/:BbsMasterId/:srch',
        templateUrl: 'app/board/h0102-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.bbspost.h0102-edit', {
        url: '/h0102-edit/:TableNm/:BbsMasterId/:BbsPostId',
        templateUrl: 'app/board/h0102-edit.html',
      })
      .state('app.bbspost.h0102-detail', {
        url: '/h0102-detail/:TableNm/:BbsMasterId/:BbsPostId',
        templateUrl: 'app/board/h0102-detail.html',
      })
      .state('app.bbspost.recom-list', {
        url: '/recom-list',
        templateUrl: 'app/board/recom-list.html',
      })
      .state('app.bbspost.recom-detail', {
        url: '/recom-detail/:p_seq',
        templateUrl: 'app/board/recom-detail.html',
      });
  },
]);

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.board', {
        url: '/board',
        template: '<div ui-view></div>',
      })
      .state('app.board.company-board', {
        url: '/company-board',
        templateUrl: 'app/board/company-board.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.consultant-board', {
        url: '/consultant-board',
        templateUrl: 'app/board/consultant-board.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.recommend-board', {
        url: '/recommend-board',
        templateUrl: 'app/board/recommend-board.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.individual-board', {
        url: '/individual-board',
        templateUrl: 'app/board/individual-board.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.notice-list', {
        url: '/notice-list',
        templateUrl: 'app/board/notice-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.notice-add', {
        url: '/notice-add',
        templateUrl: 'app/board/notice-add.html',
      })
      .state('app.board.notice-detail', {
        url: '/notice-detail/:noticeId',
        templateUrl: 'app/board/notice-detail.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.board.alarm_list', {
        url: '/alarm_list',
        templateUrl: 'app/board/alarm_list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      });
  }
})();

'use strict';

webapp.controller('H0101DetailCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'postApi',
  'gAlert',
  'gConfirm',
  'fileUploadService',
  '$rootScope',
  function H0101DetailCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    postApi,
    gAlert,
    gConfirm,
    fileUploadService,
    $rootScope
  ) {
    var vm = this;
    vm.gVariable = $rootScope.gVariable;
    vm.page = $stateParams.page;
    vm.srch = {
      FreeBoardId: $stateParams.FreeBoardId,
      IdName: 'FreeBoardId',
      TableNm: 'FreeBoard',
      BoardId: $stateParams.BoardId,
      uploadFileList: [],
    };

    vm.BoardNm = getBBSNm($stateParams.BoardId); // 게시판명 추출
    vm.srchFileList = {
      FreeBoardId: $stateParams.FreeBoardId,
      TableId: $stateParams.FreeBoardId,
      TableNm: 'FreeBoard',
      BoardId: $stateParams.BoardId,
    };

    vm.comment = {};

    vm.srchComment = {
      FreeBoardId: $stateParams.FreeBoardId,
      TableNm: 'FreeBoardComm',
      viewSize: 100,
      LastId: '',
      BoardId: $stateParams.BoardId,
    };

    vm.items = [
      {
        name: 'Share',
        icon: 'zmdi zmdi-share',
      },
      {
        name: 'Upload',
        icon: 'zmdi zmdi-upload',
      },
      {
        name: 'Copy',
        icon: 'zmdi zmdi-copy',
      },
      {
        name: 'Print this page',
        icon: 'zmdi zmdi-print',
      },
    ];

    var id = 0;

    vm.uploadFileList = [];
    vm.uploadFileListComment = [];

    vm.getDetail = getDetail;
    vm.updateReadCnt = updateReadCnt;
    vm.getFileList = getFileList;
    vm.getComment = getComment;
    vm.deleteDetail = deleteDetail;
    vm.deleteDetailAction = deleteDetailAction;
    vm.saveComment = saveComment;
    vm.deleteComment = deleteComment;
    vm.deleteCommentAction = deleteCommentAction;
    vm.editComment = editComment;
    vm.editCommentAction = editCommentAction;
    vm.editCommentCancel = editCommentCancel;

    function getDetail() {
      vm.srch.mapCode = 'FreeBoard.getBoardDetail';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = data.body.docs[0];

            var uploadFileList = [];
            angular.forEach(vm.data.uploadFileList, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.PhysicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm +
                    '&userkey=' +
                    $rootScope.gVariable.userkey
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
              };
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.data.uploadFileList);
            return;
          }

          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        }
      );
      updateReadCnt();
      //        getFileList();
    }

    function updateReadCnt() {
      vm.srch.mapCode = 'FreeBoard.updateBoardReadCnt';
      postApi.update(vm.srch, function (data) {});
    }

    function getFileList() {
      vm.srchFileList.mapCode = 'FileAttach.getFileList';
      postApi.select(
        vm.srchFileList,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];
            angular.forEach(data.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.PhysicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
              };
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        }
      );
    }

    vm.openMenu = openMenu;
    var originatorEv;
    function openMenu($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    }
    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }
      var uploadFileList = [];
      angular.forEach(vm.uploadFileList, function (item) {
        var obj = {
          id: item.id,
          fileName: item.fileName,
          size: item.size,
          fileKey: item.fileKey,
          typeId: 'file',
          path: item.path,
          delState: 'delete',
        };
        uploadFileList.push(obj);
      });
      vm.data['uploadFileList'] = uploadFileList;

      vm.data.mapCode = 'FreeBoard.deleteBoardDetail';
      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.go('app.bbspost.h0101-list', {
                  BoardId: vm.srch.BoardId,
                });
              },
            });
            return;
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    Array.prototype.append = function (array) {
      this.push.apply(this, array);
    };

    function getComment() {
      vm.srchComment.mapCode = 'FreeBoard.getBoardComment';
      postApi.select(
        vm.srchComment,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              if (vm.comment.lists == null) vm.comment.lists = data.body.docs;
              else vm.comment.lists.append(data.body.docs);

              vm.srchComment.LastId =
                data.body.docs[data.body.docs.length - 1].FreeBoardCommId;
              return;
            }
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        }
      );
    }

    function saveComment() {
      if (vm.srchComment.Contents == null || vm.srchComment.Contents == '') {
        gAlert('', 'Menu.NOCONTENTS');
        return;
      }

      vm.srchComment.IdName = 'FreeBoardCommId';
      vm.srchComment['uploadFileList'] = vm.uploadFileListComment;

      vm.srchComment.mapCode = 'FreeBoard.insertBoardComment';
      postApi.insert(
        vm.srchComment,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.srchComment.Contents = '';
              vm.srchComment.uploadFileList = [];
              vm.uploadFileListComment = [];

              getComment();

              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    vm.setDeleteFileToggle = setDeleteFileToggle;
    function setDeleteFileToggle(commentObj) {
      var idx = -1;
      angular.forEach(vm.comment.lists, function (val, key) {
        if (val == commentObj) {
          idx = key;
          return;
        }
      });
      if (vm.comment.lists[idx].delState == '') {
        vm.comment.lists[idx].delState = 'delete';
      } else {
        vm.comment.lists[idx].delState = '';
      }
    }

    function deleteComment(commentObj) {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteCommentAction(commentObj);
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteCommentAction(commentObj) {
      var srch = {
        FreeBoardCommId: commentObj.FreeBoardCommId,
        TableNm: 'FreeBoardComm',
        TableId: commentObj.FreeBoardCommId,
      };

      if (commentObj.AttachmentId != null) {
        var uploadFileList = [];

        var obj = {
          id: commentObj.AttachmentId,
          isLoaded: true,
          link: StaticVariable.getUrl(
            '/attach/file/' +
              commentObj.PhysicalFileNm +
              '/download.do?path=' +
              commentObj.PhysicalFolderNm +
              '&fileName=' +
              commentObj.LogicalFileNm
          ),
          fileName: commentObj.LogicalFileNm,
          size: commentObj.FileSize,
          fileKey: commentObj.PhysicalFileNm,
          path: commentObj.PhysicalFolderNm,
          downloadCnt: commentObj.DownloadCnt,
          delState: 'delete',
          typeId: 'file',
        };
        uploadFileList.push(obj);

        srch['uploadFileList'] = uploadFileList;
      }
      srch.mapCode = 'FreeBoard.deleteBoardComment';
      postApi.update(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.FreeBoardCommId == commentObj.FreeBoardCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function editComment(FreeBoardCommId) {
      vm.comment.editid = FreeBoardCommId;

      vm.comment.lists.forEach(function (item, index, object) {
        if (item.FreeBoardCommId == FreeBoardCommId) {
          vm.comment.editContents = item.Contents;
        }
      });
    }

    function editCommentAction(commentObj) {
      var srch = {
        FreeBoardCommId: commentObj.FreeBoardCommId,
        Contents: vm.comment.editContents,
        TableNm: 'FreeBoardComm',
        TableId: commentObj.FreeBoardCommId,
      };

      if (commentObj.AttachmentId != null) {
        var uploadFileList = [];

        var obj = {
          id: commentObj.AttachmentId,
          isLoaded: true,
          link: StaticVariable.getUrl(
            '/attach/file/' +
              commentObj.PhysicalFileNm +
              '/download.do?path=' +
              commentObj.PhysicalFolderNm +
              '&fileName=' +
              commentObj.LogicalFileNm
          ),
          fileName: commentObj.LogicalFileNm,
          size: commentObj.FileSize,
          fileKey: commentObj.PhysicalFileNm,
          path: commentObj.PhysicalFolderNm,
          downloadCnt: commentObj.DownloadCnt,
          delState: commentObj.delState,
          typeId: 'file',
        };
        uploadFileList.push(obj);

        srch['uploadFileList'] = uploadFileList;
      }

      srch.mapCode = 'FreeBoard.updateBoardComment';
      postApi.update(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.FreeBoardCommId == commentObj.FreeBoardCommId) {
                  item.Contents = data.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState == 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });

              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }
    function editCommentCancel() {
      vm.comment.editid = null;
      vm.comment.editContents = null;
    }

    vm.openDilalog = openDilalog;
    function openDilalog() {
      angular.element('#file-5').trigger('click');
    }

    var fileElement = angular.element('#file-5');
    fileElement.bind('change', function () {
      uploadFiles(fileElement[0].files);
    });

    vm.uploadFiles = uploadFiles;

    function uploadFiles(files) {
      var tempIds = [];
      // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
      $scope.$root.safeApply(function () {
        var hasZeroByteFile = false;
        angular.forEach(files, function (value) {
          if (value.size == 0) {
            hasZeroByteFile = true;
          } else {
            var obj = {
              isLoaded: false,
              fileName: value.name,
              size: value.size,
              id: id,
              delState: '',
            };
            tempIds.push(obj);
            if (vm.uploadFileListComment == null)
              vm.uploadFileListComment = new Array();
            vm.uploadFileListComment.push(angular.copy(obj));
            id++;
          }
        });
        if (hasZeroByteFile) {
          alert('빈 파일이 있습니다.');
          return;
        }

        var request = fileUploadService.post(files, null, function (percent) {
          // -- 진행율 표시
          angular.forEach(tempIds, function (obj) {
            $('#filectl' + ' .progress .progress-bar').css(
              'width',
              percent + '%'
            );
          });
          if (percent == 100) {
            vm.showLoading = true;
          }
        });

        try {
          request.to(StaticVariable.getUrl('/attach/temp/upload.do')).then(
            function (value) {
              angular.forEach(value.data.responseVO.body.docs, function (item) {
                angular.forEach(vm.uploadFileListComment, function (obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.fileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl(
                      '/attach/temp/' +
                        item.tmpFileKey +
                        '/download.do?fileName=' +
                        item.encFileName
                    );
                    obj.delState = '';
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);


              vm.showLoading = false;
            },
            function (reason) {
              console.log(reason);
            }
          );
        } catch (err) {
          console.log(err);
        }
      });
    }
    vm.onDelete = onDelete;
    function onDelete(obj) {
      var idx = -1;
      angular.forEach(vm.uploadFileListComment, function (val, key) {
        if (val == obj) {
          idx = key;
          return;
        }
      });

      alert('2');
      if (idx != -1) {
        if (vm.uploadFileListComment[idx].typeId == 'temp') {
          var prms = fileUploadService.attachFileDelete().get({
            attachId: vm.uploadFileListComment[idx].fileKey,
          }).$promise;

          prms.then(
            function (data) {
            },
            function (error) {
              console.log("error");
              // console.error('fail', error);
            }
          );
          vm.uploadFileListComment.splice(idx, 1);
        } else if (vm.callback) {
          vm.uploadFileListComment[idx].delState = 'delete';
        }
      }
      alert('3');
    }
    vm.onDeleteCancel = onDeleteCancel;
    function onDeleteCancel(obj) {
      var idx = -1;
      angular.forEach(vm.uploadFileListComment, function (val, key) {
        if (val == obj) {
          idx = key;
          return;
        }
      });

      if (idx != -1) {
        vm.uploadFileListComment[idx].delState = '';
      }
    }
    getDetail();
    getComment();
  },
]);

webapp.controller('H0101EditCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'postApi',
  'gAlert',
  function H0101EditCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert) {
    // 접근 권한 체크 (2022-04-14 추가)
    if (!isPageAccess('h0101-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    var vm = this;
    vm.page = $stateParams.page;

    vm.BoardNm = getBBSNm($stateParams.BoardId); // 게시판명 추출
    vm.uploadFileList = [];
    vm.srch = {
      FreeBoardId: $stateParams.FreeBoardId,
      IdName: 'FreeBoardId',
      TableNm: 'FreeBoard',
      viewSize: CONSTANT.PAGINATION.VIEWSIZE,
      BoardId: $stateParams.BoardId,
      uploadFileList: [],
    };

    vm.data = {
      BoardId: vm.srch.BoardId,
    };

    vm.getDetail = getDetail;
    //      vm.getFileList = getFileList;
    vm.saveDetail = saveDetail;

    vm.onFileCallback = {
      onFileUploadComplete: function () {
      },
      onFileDelete: function (item) {
        var param = {
          fileId: item.id,
        };
        postApi.attach('file/delete', param, function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED');
          }
        });
      },
    };

    function getDetail() {
      if (vm.srch.FreeBoardId == null || vm.srch.FreeBoardId == 0) {
        return;
      }

      //        if (vm.srch.RegUser != $window.sessionStorage['loginId']) {
      //        	return;
      //        }

      vm.srch.mapCode = 'FreeBoard.getBoardDetail';
      postApi.select(
        vm.srch,
        function (data) {
          // console.log("세션아이디 : " + $window.sessionStorage['loginUserIdx']);
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardId != null) {
              if (data.body.docs[0].RegUser == $window.sessionStorage['loginUserIdx']) {
                vm.data = data.body.docs[0];
              } else {
                vm.data = [];

                alert('조회권한이 없습니다.');
                $state.go('app.dashboard');
              }
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    '/attach/file/' +
                      item.physicalFileNm +
                      '/download.do?path=' +
                      item.PhysicalPath +
                      '&fileName=' +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: '',
                };
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 사용하지 않음
    /*  function getFileList() {
      vm.srch.tableNm = 'FreeBoard';
      if (vm.srch.FreeBoardId == null || vm.srch.FreeBoardId == 0) {
        return;
      }
      vm.srch.mapCode = 'FileAttach.getFileList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];
            angular.forEach(data.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.physicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: '',
              };
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.uploadFileList);
            console.log('after load', vm.uploadFileList);
            return;
          }
        },

        function (data) {
          console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    } */

    function saveDetail() {
      oEditors.getById['strHtml'].exec('UPDATE_CONTENTS_FIELD', []);
      vm.data.Contents = $('#strHtml').val();
      vm.data.TableNm = 'FreeBoard';
      vm.data.TableId = vm.data.FreeBoardId;
      vm.data.IdName = 'FreeBoardId';
      vm.data.XssFilter = "Y";

      /* 2025.06.11 악성 콘텐츠 취약점 조치 */
      vm.data.Contents = DOMPurify.sanitize(vm.data.Contents, {
        FORBID_TAGS : ['script', 'iframe', 'object', 'embed', 'form', 'link', 'style', 'applet'],
        FORBID_ATTR : ['onerror', 'onClick', 'onload', 'onmouseover', 'onfocus', 'srcset']
      });

      var successCallback = function (data) {
        if (data.header.status == CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].FreeBoardId != null || data.body.docs[0].TableId != null) {
            // insert
            // 시
            // TableId
            // 만
            // 넘어옴
            vm.data.keyId = data.body.docs[0].FreeBoardId;

            $state.go('app.bbspost.h0101-detail', {
              BoardId: $stateParams.BoardId,
              FreeBoardId: vm.data.keyId,
            });
          }
        }

        gAlert('', data.body.docs[0].errMessage);
      };

      var errorCallback = function (error) {
        console.log("error");
        // console.error('fail', status, data);
        gAlert('', data.body.docs[0].errMessage);
      };

      if (vm.data.FreeBoardId == null) {
        vm.data.mapCode = 'FreeBoard.insertBoardDetail';
        postApi.insert(vm.data, successCallback, errorCallback);
      } else {
        vm.data.mapCode = 'FreeBoard.updateBoardDetail';
        postApi.update(vm.data, successCallback, errorCallback);
      }
    }

    getDetail();
  },
]);

webapp.controller('H0101ListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'postApi',
  function H0101ListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi
  ) {
    var vm = this;
    vm.dataloader = false;

    if ($stateParams.page == undefined || $stateParams.page == '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.BoardNm = getBBSNm($stateParams.BoardId); // 게시판명 추출

    vm.srch = {
      remark: '',
    };

    vm.listSize = [10, 25, 50, 100];

    vm.excel = {
      downFileName: 'FreeBoard',
      subject: '자유게시판 리스트',
      header: [
        {
          field: 'FreeBoardId',
          title: '번호',
          width: '5',
          format: 'number',
        },
        {
          field: 'Title',
          title: '제목',
          width: '20',
          format: 'string',
        },
        {
          field: 'RegUserNm',
          title: '등록자',
          width: '10',
          format: 'string',
        },
        {
          field: 'RegDate',
          title: '등록일자',
          width: '10',
          format: 'date',
        },
        {
          field: 'ReadCnt',
          title: '조회수',
          width: '5',
          format: 'string',
        },
      ],
    };

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.BoardId = $stateParams.BoardId;
    vm.srch.viewSize = vm.viewSize;

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    /*if ($window.sessionStorage.getItem('h0101-list-ctrl') != null) {
      console.log('H0101ListCtrl previousPage:', $rootScope.previousPage, '===', '/app/bbspost/h0101-list/' + $stateParams.BoardId);
      if ($rootScope.previousPage != null
          && ($rootScope.previousPage.indexOf('/app/bbspost/h0101-edit/' + $stateParams.BoardId) !== -1
              || $rootScope.previousPage.indexOf('/app/bbspost/h0101-detail/' + $stateParams.BoardId) !== -1 || $rootScope.previousPage.indexOf('/app/bbspost/h0101-list/'
              + $stateParams.BoardId) !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0101-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }*/

    $scope.showDetail = function (li) {
      $location.url('/' + li.ntcIdx);
    };

    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.getListCnt = getListCnt;
    vm.getExcel = getExcel;
    vm.changeViewSize = changeViewSize;

    function pageChanged() {
      // $state.go("app.bbspost.h0101-list", {BoardId:vm.srch.BoardId,
      // page:vm.currentPage});
      vm.srch.page = vm.currentPage;
      getList();
      // $location.path('/app/h0101/list/' + vm.srch.BoardId + "/" +
      // vm.currentPage, false);
    }

    function getListCnt() {
      vm.srch.mapCode = 'FreeBoard.getBoardCount';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = data.body.docs[0];
          }
        },

        function (error) {
          console.log("error");
          // console.error('fail', status, data);
        }
      );
    }

    function getList() {
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      $window.sessionStorage.setItem(
        'h0101-list-ctrl',
        angular.toJson(vm.srch)
      );

      vm.dataloader = true;

      vm.srch.mapCode = 'FreeBoard.getBoardList';

      postApi.select(
        vm.srch,
        function (data) {
          vm.dataloader = false;
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = data.body.docs;
            //					vm.numPages = Math.ceil(vm.totalItems / vm.viewSize);
          }
        },

        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        }
      );
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function getExcel() {
      vm.excel.param = vm.srch;
      vm.excel.mapCode = 'FreeBoard.getExcelBoardList';

      postApi.excel(
        vm.excel,
        function (data) {},

        function (error) {
          console.log("error");
          // console.error('fail', status, data);
        }
      );
    }

    getList();
  },
]);

webapp.service('H0102APISrv', ['$resource', 'StaticVariable', '$rootScope',
  function H0102APISrv($resource, StaticVariable, $rootScope) {
    var bbspostApi = {
      doSelectListColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectListColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostListCnt/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doExcel: function() {
        return $resource(StaticVariable.getUrl('/excel/BbsPost.getExcelBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSelectEditColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectEditColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcInsert.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcUpdate.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcDelete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doReply: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveReply: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return bbspostApi;
  },
]);

(function () {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
  webapp.controller('H0102DetailCtrl', ['$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope', 'modalFactory',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object} 
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function H0102DetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope, modalFactory) {
      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.ShowContents = false;
      vm.ShowPwd = false;

      vm.srch = {};
      if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      //vm.srch.tableNm = $stateParams.srch && !angular.isUndefined($stateParams.srch) ? $stateParams.srch.tableNm : 'board.notice';
      vm.srch.tableNm = 'TB_BBSPOST';
      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      } else {
        vm.srch.BbsMasterId = '6Y024Q3ILI';
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];
      vm.srchDetail.IdName = 'BbsPostId';
      vm.srchDetail.selectType = "Edit";
      vm.srchDetail.CodeType = "HdcBoardType";

      // 조회 데이터
      vm.data = {
        TableNm: vm.srchDetail.TableNm,
        BbsPostId: vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId: vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm: 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId: vm.srch.BbsPostId,
        TableId: vm.srch.BbsPostId,
        IdName: 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize: 100,
        LastId: 0,
      };
      // 옵션
      vm.items = [{
        name: '공유',
        icon: 'zmdi zmdi-share'
      }, {
        name: '업로드',
        icon: 'zmdi zmdi-upload'
      }, {
        name: '복사',
        icon: 'zmdi zmdi-copy'
      }, {
        name: '현재 페이지 인쇄',
        icon: 'zmdi zmdi-print'
      },];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function H0102DetailCtrl() {

      })();

      // 조회수 증가 호출하고 그다음 데이터 조회
      function updateBbsPostReadCnt() {
        var data = {};
        data = angular.copy(vm.srch);
        data.mapCode = "BbsPost.updateBbsPostReadCntBatch";

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            getData();
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            deleteDataAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                var srch = $stateParams.srch != null ? $stateParams.srch : '';
                $state.go('app.bbspost.h0102-list', {
                  srch: srch,
                  BbsMasterId: vm.srch.BbsMasterId
                }, { reload: 'app.bbspost.h0102-list' });
              }
            });
            return;
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function (array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              var srch = $stateParams.srch != null ? $stateParams.srch : '';
              $state.go('app.bbspost.h0102-list', {
                srch: srch
              });
            }
          });
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if ((angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') && vm.uploadFileListReply.length == 0) {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          // console.error('Error> h0102-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function (val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            deleteCommentAction(replyObj);
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId: replyObj.BbsPostCommId,
          tableNm: "BbsPostComm",
          TableId: replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id: replyObj.AttachmentId,
            isLoaded: true,
            link: StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName: replyObj.LogicalFileNm,
            size: replyObj.FileSize,
            fileKey: replyObj.PhysicalFileNm,
            path: replyObj.PhysicalFolderNm,
            downloadCnt: replyObj.DownloadCnt,
            delState: 'delete',
            typeId: 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function (item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId: replyObj.BbsPostCommId,
          Contents: vm.comment.editContents,
          TableNm: "BbsPostComm",
          TableId: replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id: replyObj.AttachmentId,
            isLoaded: true,
            link: StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName: replyObj.LogicalFileNm,
            size: replyObj.FileSize,
            fileKey: replyObj.PhysicalFileNm,
            path: replyObj.PhysicalFolderNm,
            downloadCnt: replyObj.DownloadCnt,
            delState: replyObj.delState,
            typeId: "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function () {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function () {
          var hasZeroByteFile = false;

          angular.forEach(files, function (value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded: false,
                fileName: value.name,
                size: value.size,
                id: fileUploadId,
                delState: ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function (percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function (obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey=' + $rootScope.gVariable.userKey)).then(function (value) {
              angular.forEach(value.data.responseVO.body.docs, function (item) {
                angular.forEach(vm.uploadFileListReply, function (obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function (error) {
              console.log("error");
              // console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.log("error");
            // console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function (val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId: vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function (data) {
              // console.log('Success> h0102-detail-ctrl> onDelete()', data);
            }, function (error) {
              // console.error('Error> h0102-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function (val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go('app.bbspost.h0102-list', {
          srch: srch,
          BbsMasterId: vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        if (vm.layout == 'N') {
          $state.go('app.bbspost.h0102-edit', {
            srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId: vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.bbspost.h0102-list.edit', {
            srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId: vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      function getBbsNm() {
        if (vm.layout != 'N') {
          return;
        }
        var data = { BbsMasterId: vm.srch.BbsMasterId };
        data.mapCode = "BbsMaster.getBbsMasterDetail";
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.BbsNm = result.body.docs[0].BbsNm;
              }
            }
          },
          function (error) {
            console.log("error");
            // console.error("Error> h0102-list-ctrl> getList()", status, error);
          }
        );
      }

      function getPublicYN() {
        postApi.select('BbsPost.getBbsPostPublicYN', { BbsPostId: vm.srch.BbsPostId },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].PublicYN == 'Y') {
                vm.ShowContents = true;
                vm.ShowPwd = false;
                updateBbsPostReadCnt();
                getComment();
              } else {
                vm.ShowContents = false;
                vm.ShowPwd = true;
              }
            } else {
              gAlert('', "오류가 발생하였습니다. </br>관리자에게 문의해주세요.");
              goList();
            }
          },
          function (error) {
            vm.dataloader = false;
            console.table(error);
          });
      }

      // 비밀번호 입력
      function chkPwd() {
        if (isNullOrEmpty(vm.PostPwd))
        {
          gAlert('', "비밀번호를 입력해주세요.");
        }
        else 
        {
          // 비밀번호 체크
          postApi.select('BbsPost.chkBbsPostPwd', { BbsPostId: vm.srch.BbsPostId , PostPwd: vm.PostPwd },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if(result.body.docs[0] > 0) {
                  vm.ShowContents = true;
                  vm.ShowPwd = false;
                  updateBbsPostReadCnt();
                  getComment();
                } else {
                  gAlert('', "비밀번호를 확인해주세요.");
                  return false;
                }
              } else {
                gAlert('', "오류가 발생하였습니다. </br>관리자에게 문의해주세요.");
                  return false;
              }
            },
            function (error) {
              vm.dataloader = false;
              console.table(error);
            });
        }
      }

      // 함수 선언
      vm.getData = getData;
      vm.updateBbsPostReadCnt = updateBbsPostReadCnt;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;
      vm.getPublicYN = getPublicYN;
      vm.chkPwd = chkPwd;

      // 데이터 조회
      getBbsNm();
      getPublicYN();
    }]);
})();
/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102EditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function H0102EditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.h0102-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.h0102-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.h0102-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    //vm.srch.tableNm = $stateParams.srch && !angular.isUndefined($stateParams.srch) ? $stateParams.srch.tableNm : 'board.notice';
    vm.srch.tableNm = 'TB_BBSPOST';

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = '6Y024Q3ILI';
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];
    vm.srchDetail.IdName = 'BbsPostId';
    vm.srchDetail.selectType = "Edit";

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function H0102EditCtrl() {
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        var param = {
          fileId: item.id
        };
        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
   
      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              try {
                oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.Contents]);
              } catch (e) {
              }
            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs.length > 0 && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if(valid()){
        // 내용
        vm.dataloader = true;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        vm.data.BbsMasterId = vm.srch.BbsMasterId;
        vm.data.Contents = $("#strHtml").val();
        vm.data.tableNm = vm.srch.tableNm;
        vm.data.RelateDataId = vm.data.BbsPostId;
        vm.data.IdName = "BbsPostId";
        vm.data.uploadFileList = vm.uploadFileList;
        vm.data.userkey = vm.srch.userkey;

        var data = vm.data;
        if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
          // 등록
          data.mapCode = "BbsPost.insertBbsPostBatch";
          postApi.insert(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        } else {
          // 수정
          data.mapCode = "BbsPost.updateBbsPost";
          postApi.update(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        }
    }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : vm.srch.BbsMasterId
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId});
      }
    }

    function valid(){
      if($scope.theForm.Title.$invalid){
        gAlert("","제목을 입력해주세요.");
        return false;
      }else if(isNullOrEmpty(vm.data.PublicYN)){
        gAlert("","공개여부를 선택해주세요.");
        return false;
      }else if(isNullOrEmpty(vm.data.NoticeYN)){
        gAlert("","공지여부를 선택해주세요.");
        return false;
      }else {
        return true;
      }
    }

    function getBbsNm() {
      if (vm.layout != 'N') {
        return;
      }      
      var data = { BbsMasterId: vm.srch.BbsMasterId };
      data.mapCode = "BbsMaster.getBbsMasterDetail";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.BbsNm = result.body.docs[0].BbsNm;
            }
          }
        },
        function (error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getList()", status, error);
        }
      );
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getBbsNm();
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102ListCtrl", ["$window","$scope","$location","$state","$stateParams","$rootScope","GLOBAL_CONSTANT","postApi","$compile","modalFactory","$translate","$filter","Auth",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function H0102ListCtrl($window,$scope,$location,$state,$stateParams,$rootScope,CONSTANT,postApi,$compile,modalFactory,$translate,$filter,Auth) {
    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: "board.notice", // For CustomColumn and FileAttachment
        sortDirect: "",
        sortColumn: "",
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = "board.notice"; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    if (vm.srch.viewSize == null) {
      vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    if ($stateParams.BbsMasterId) {
      vm.srch.tableNm = "";
    }
    vm.srch.CodeType = "HdcBoardType";
    vm.BbsNm = "";

    //    $compile($('#pane'))($scope);

    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    (function H0102ListCtrl() {
      // console.log("H0102ListCtrl:");
    })();

    // 회원사 변경 설정
    $scope.$on("broadcastSetChangeTenantID", function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant("MSG.LISTUPDATED"));
    });

    // 엑셀
    vm.excel = {
      downFileName: "BbsPost",
      subject: "자유게시판 리스트",
      header: [
        {
          field: "BbsPostId",
          title: "번호",
          width: "5",
          format: "number",
        },
        {
          field: "Title",
          title: "제목",
          width: "20",
          format: "string",
        },
        {
          field: "RegUserNm",
          title: "등록자",
          width: "10",
          format: "string",
        },
        {
          field: "RegDate",
          title: "등록일자",
          width: "10",
          format: "date",
        },
        {
          field: "ReadCnt",
          title: "조회수",
          width: "5",
          format: "string",
        },
        {
          field: "Reviewer",
          title: "평가자",
          width: "5",
          format: "string",
        },
      ],
    };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo() {
      new daum.Postcode({
        oncomplete: function (data) {
          vm.zipCode = data.zonecode;
          vm.addr1 =
            data.buildingName != ""
              ? data.address + " " + data.buildingName
              : data.address;
          $("#zipCode").val(vm.zipCode);
          $("#addr1").val(vm.addr1);
        },
      }).open();
    }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = "UserModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/users/user-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.UserNm = res.UserNm;
          vm.srch.UserId = res.UserId;
        },
        function (cancelData) { }
      );
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = "";
      vm.srch.UserId = "";
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = "ProductModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/product/product-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;
        },
        function (cancelData) { }
      );
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = "";
      vm.srch.ProductNm = "";
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      if (!$scope.selectedRow) {
        vm.dataloader = true;
      }
      vm.viewSize = vm.srch.viewSize;

      getListCnt();
      getUnreadCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.mapCode = "BbsPost.getBbsPostList";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
        /* console.log("type C", result.header);
      console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      },
        function (error) {
          console.log("error");$
          // console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function getUnreadCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "BbsPost.getBbsPostUnreadCnt";
      postApi.select(data, function (result) {
        /* console.log("type C", result.header);
      console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalUnreadItems = result.body.docs[0];
          } else {
            vm.totalUnreadItems = 0;
          }
        }
      },
        function (error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list",
        { srch: srch },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    /**
     * 엑셀파일 다운로드
     * @param
     * @return
     * @author 최원영
     */
    function getExcel() {
      vm.excel.param = vm.srch;
      var data = vm.excel;

      data.mapCode = "BbsPost.getExcelBbsPostList";
      postApi.excel(
        data,
        function (result) {
          // console.log("type C", result.header);
          // console.log("type c", result.body);
        },
        function (error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getExcel()", status, error);
        }
      );
      /*
      vm.excel.param = vm.srch;

      var prms = h0102Api.doExcel().post(vm.excel).$promise;

      prms.then(function(data) {
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getExcel()', status, error);
      }); */
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list",
        { srch: srch },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function resetSearch() {
      $state.go(
        "app.bbspost.h0102-list",
        { srch: "" },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        angular.forEach(vm.lists, function (item) {
          if (item.BbsPostId == BbsPostId) {
            if (item.UserReadImg == 'fa-envelope') {
              item.UserReadImg = 'fa-envelope-open-o';
              vm.totalUnreadItems = vm.totalUnreadItems > 0 ? vm.totalUnreadItems - 1 : 0;
            }
            return;
          }
        });

        $state.go("app.bbspost.h0102-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.bbspost.h0102-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      $state.go(
        "app.bbspost.h0102-list",
        {
          srch: srch,
        },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function getBbsNm() {
      var data = { BbsMasterId: vm.srch.BbsMasterId };
      data.mapCode = "BbsMaster.getBbsMasterDetail";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.BbsNm = result.body.docs[0].BbsNm;
            }
          }
          vm.dataloader = false;
        },
        function (error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function goUnreadList() {
      var srch = { Unread: 'Y' };
      $state.go(
        "app.bbspost.h0102-list",
        {
          srch: encodeURIComponent(JSON.stringify(srch, replacer))
        },
        { reload: "app.bbspost.h0102-list" }
      );
    }
    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.getExcel = getExcel;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;
    vm.goUnreadList = goUnreadList;

    // 데이터 조회
    getBbsNm();
    getList();
  },
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', '$compile', 'modalFactory', '$translate', '$filter',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function NoticeBoardCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi, $compile, modalFactory, $translate, $filter) {

          // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'BbsPost.getExcelBbsPostList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.bbspost.notice-board';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.company-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.company-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.company-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = '공지사항 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의





    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'bbspost', // For CustomColumn and FileAttachment
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbspost'; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    vm.BbsNm = '위너스 홈페이지 공지사항';

//    $compile($('#pane'))($scope);

    vm.listSize = [ 10, 25, 50, 100 ];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // // 엑셀
    // vm.excel = {
    //   downFileName : 'BbsPost',
    //   subject : '공지사항 리스트',
    //   header : [ {
    //     field : 'BbsPostId',
    //     title : '번호',
    //     width : '5',
    //     format : 'number'
    //   }, {
    //     field : 'Title',
    //     title : '제목',
    //     width : '20',
    //     format : 'string'
    //   }, {
    //     field : 'RegUserNm',
    //     title : '등록자',
    //     width : '10',
    //     format : 'string'
    //   }, {
    //     field : 'RegDate',
    //     title : '등록일자',
    //     width : '10',
    //     format : 'date'
    //   }, {
    //     field : 'ReadCnt',
    //     title : '조회수',
    //     width : '5',
    //     format : 'string'
    //   }, {
    //     field : 'Reviewer',
    //     title : '평가자',
    //     width : '5',
    //     format : 'string'
    //   } ],
    // };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function(li) {
      $location.url('/' + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();
   }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }


    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      getListCnt();
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.selectType = 'List'; // For CustomColumn
      data.mapCode = 'BbsPost.getBbsPostList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.lists = {};
          }
        }
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error> h0102-list-ctrl> getList()', status, error);
        vm.dataloader = false;
      });

    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.mapCode = 'BbsPost.getBbsPostListCnt';
      postApi.select(data, function(result){
        /* console.log("type C", result.header);
        console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> h0102-list-ctrl> getListCnt()', status, error);
      });
    }

    function setResponsive(dockMode) {
      var rows =  vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function(item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if(o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if(item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString="YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }


    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
    }

    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      getSearch();
    }

    function getSearch() {
//      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.notice-board', {srch:srch}, {reload:'app.bbspost.notice-board'});
    }

    function resetSearch() {
      $state.go('app.bbspost.notice-board', {srch : ''}, {reload:'app.bbspost.notice-board'});
    }

    vm.test = test;
    function test(id) {
      return "/app/bbspost/h0102-list/bbspost//"+id;
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = '';
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      } else {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      }
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.notice-board', {
        srch : srch
      }, {reload: 'app.bbspost.notice-board'});
    }

    function getBbsNm() {
      var data = {BbsMasterId:vm.srch.BbsMasterId};
      data.mapCode = 'BbsMaster.getBbsMasterDetail';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.BbsNm = result.body.docs[0].BbsNm;
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error> notice-board-ctrl> getList()', status, error);
        vm.dataloader = false;
      });
    }

/**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }

    // 함수 선언
    vm.getList = getList;
    vm.getExcelFile = getExcelFile;
    vm.setChangeViewSize = setChangeViewSize;
    vm.setPageChanged = setPageChanged;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;

    // 데이터 조회
    getBbsNm();
    getList();

  }
]);


(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function NoticeBoardDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      } else {
        vm.srch.BbsMasterId = 1;
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        IdName : 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function NoticeBoardDetailCtrl() {
        // console.log('NoticeBoardDetailCtrl:');
      })();

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        },function(error) {
          console.log("error");
          // console.error('Error> Notice-Board-detail-ctrl> getFileList()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> Notice-Board-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.bbspost.notice-board', {
                  srch:srch
                }, {reload:'app.bbspost.notice-board'});
              }
            });
            return;
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> notice-board-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> notice-board-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.notice-board', {
                srch : srch
              });
            }
          });
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if (angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          // console.error('Error> notice-board-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.log("error");
          // console.error('Error> notice-board-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        },  function(error) {
          console.log("error");
          // console.error('Error> notice-board-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.log("error");
          // console.error('Error> notice-board-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.log("error");
              // console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.log("error");
            // console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function(data) {
              // console.log('Success> notice-board-detail-ctrl> onDelete()', data);
            }, function(error) {
              console.log("error");
              // console.error('Error> notice-board-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.bbspost.notice-board', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        } else {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("NoticeBoardEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function NoticeBoardEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.notice-board';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.notice-board.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.notice-board.detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;
    vm.boardTypes = ["공지사항", "NewsLetter", "위너스 소식"];


    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function H0102EditCtrl() {
      // console.log('notice-board.Ctrl:');
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {
      // 내용
      vm.dataloader = true;
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

      vm.data.BbsMasterId = vm.srch.BbsMasterId;
      vm.data.Contents = $("#strHtml").val();
      vm.data.tableNm = 'bbspost';
      vm.data.RelateDataId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;

      var data = vm.data;
      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : 1
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : 1});
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:popup-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('PopupListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile', 'modalFactory',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function PopupListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi,DTOptionsBuilder, DTColumnBuilder, $compile, modalFactory) {

    var vm = this;
    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    vm.srch = {
      ZipCode : "",
      Addr1 : ""
    }

    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();

    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /* 관리권 검색 */
    vm.srch = {
      CareTktNm : '',
      CareTktId : ''
    }
    function openModalCareTkt() {
      var ctrl = 'CareTktModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {

        vm.srch.CareTktNm = res.CareTktNm;
        vm.srch.CareTktId = res.KeyId;

      }, function(cancelData) {
      });
    }
    /* 관리권검색- 지우기 */
    function clearCareTkt() {
      vm.srch.CareTktNm = '';
      vm.srch.CareTktId = '';
    }


    /* 고객검색 */
    function openModalCustomer() {
      var ctrl = 'CustomerModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/customer/customer-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.CustNm = res.CustNm;
        vm.srch.CustId = res.CustId;
      }, function(cancelData) {
      });
    }
    /* 고객검색- 지우기 */
    function clearCustomer() {
      vm.srch.CustNm = '';
      vm.srch.CustId = '';
    }

    // 함수 선언

    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;
    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;
    vm.getAddressInfo = getAddressInfo;
    vm.openModalCareTkt = openModalCareTkt;
    vm.clearCareTkt = clearCareTkt;
    vm.clearCustomer = clearCustomer;
    vm.openModalCustomer = openModalCustomer;
  },
]);
})();

'use strict';

webapp.controller('RecomDetailCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'postApi',
  'gAlert',
  'gConfirm',
  'fileUploadService',
  '$http',
  function RecomDetailCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    postApi,
    gAlert,
    gConfirm,
    fileUploadService,
    $http
  ) {
    var vm = this;
    vm.page = $stateParams.page;
    vm.srch = {
      p_seq: $stateParams.p_seq,
      FreeBoardId: $stateParams.FreeBoardId,
      IdName: 'FreeBoardId',
      TableNm: 'FreeBoard',
      BoardId: $stateParams.BoardId,
      uploadFileList: [],
    };

    vm.BoardNm = getBBSNm($stateParams.BoardId); // 게시판명 추출
    vm.srchFileList = {
      FreeBoardId: $stateParams.FreeBoardId,
      TableId: $stateParams.FreeBoardId,
      TableNm: 'FreeBoard',
      BoardId: $stateParams.BoardId,
    };

    vm.comment = {};

    vm.srchComment = {
      FreeBoardId: $stateParams.FreeBoardId,
      TableNm: 'FreeBoardComm',
      viewSize: 100,
      LastId: '',
      BoardId: $stateParams.BoardId,
    };

    vm.items = [
      {
        name: 'Share',
        icon: 'zmdi zmdi-share',
      },
      {
        name: 'Upload',
        icon: 'zmdi zmdi-upload',
      },
      {
        name: 'Copy',
        icon: 'zmdi zmdi-copy',
      },
      {
        name: 'Print this page',
        icon: 'zmdi zmdi-print',
      },
    ];

    var id = 0;

    vm.uploadFileList = [];
    vm.uploadFileListComment = [];

    vm.getDetail = getDetail;
    vm.updateReadCnt = updateReadCnt;
    vm.getFileList = getFileList;
    vm.getComment = getComment;
    vm.deleteDetail = deleteDetail;
    vm.deleteDetailAction = deleteDetailAction;
    vm.saveComment = saveComment;
    vm.deleteComment = deleteComment;
    vm.deleteCommentAction = deleteCommentAction;
    vm.editComment = editComment;
    vm.editCommentAction = editCommentAction;
    vm.editCommentCancel = editCommentCancel;
    vm.fncFileDown = fncFileDown;

    function getDetail() {
      /*       var url =
          'https://moti.or.kr/system/employ/employ5/GoojikApiGetRecomDetail.jsp?p_seq=' +
          vm.srch.p_seq;
  */

      postApi.api(
        'extSelect/Linkage.getRecomDetail/action',
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              gAlert('', '조회된 정보가 없습니다.');
            } else {
              vm.data = data.body.docs[0];
              vm.data.CONTENT = vm.data.JR_CONTENTS;
              vm.data.CONTENT_URL = 'https://moti.or.kr/job/recruit/instList/instDetail?KeyId=' + vm.data.JR_AB_SEQ;
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );
      /* window.GoojikApiGetRecomDetail = function (data) {
        console.log('GoojikApiGetRecomDetail = ', data);
        if (data == null || data == '') {
          gAlert('', '조회된 정보가 없습니다.');
        }
        vm.data = data;

        vm.data.CONTENT =
          data.JR_CONTENT1 +
          data.JR_CONTENT2 +
          data.JR_CONTENT3 +
          data.JR_CONTENT4 +
          data.JR_CONTENT5 +
          data.JR_CONTENT6 +
          data.JR_CONTENT7 +
          data.JR_CONTENT8 +
          data.JR_CONTENT9 +
          data.JR_CONTENT10 +
          data.JR_CONTENT11;
        vm.data.CONTENT_URL =
          'https://moti.or.kr/jsp/recruit/recom/Detail0717.jsp?p_seq=' +
          data.JR_AB_SEQ;
      };

      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiGetRecomDetail' }); */
    }

    function updateReadCnt() {
      vm.srch.mapCode = 'FreeBoard.updateBoardReadCnt';
      postApi.update(vm.srch, function (data) {});
    }

    function getFileList() {
      vm.srchFileList.mapCode = 'FileAttach.getFileList';
      postApi.select(
        vm.srchFileList,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];
            angular.forEach(data.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.PhysicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
              };
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        }
      );
    }

    vm.openMenu = openMenu;
    var originatorEv;
    function openMenu($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    }
    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }
      var uploadFileList = [];
      angular.forEach(vm.uploadFileList, function (item) {
        var obj = {
          id: item.id,
          fileName: item.fileName,
          size: item.size,
          fileKey: item.fileKey,
          typeId: 'file',
          path: item.path,
          delState: 'delete',
        };
        uploadFileList.push(obj);
      });
      vm.data['uploadFileList'] = uploadFileList;

      vm.data.mapCode = 'FreeBoard.deleteBoardDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.go('app.bbspost.h0101-list', {
                  BoardId: vm.srch.BoardId,
                });
              },
            });
            return;
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    Array.prototype.append = function (array) {
      this.push.apply(this, array);
    };

    function getComment() {
      vm.srchComment.mapCode = 'FreeBoard.getBoardComment';
      postApi.select(
        vm.srchComment,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              if (vm.comment.lists == null) vm.comment.lists = data.body.docs;
              else vm.comment.lists.append(data.body.docs);

              vm.srchComment.LastId = data.body.docs[data.body.docs.length - 1].FreeBoardCommId;
              return;
            }
          }
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            btn: '',
            fn: function () {
              $state.go('app.bbspost.h0101-list', {
                BoardId: vm.srch.BoardId,
              });
            },
          });
        }
      );
    }

    function saveComment() {
      if (vm.srchComment.Contents == null || vm.srchComment.Contents == '') {
        gAlert('', 'Menu.NOCONTENTS');
        return;
      }

      vm.srchComment.IdName = 'FreeBoardCommId';
      vm.srchComment['uploadFileList'] = vm.uploadFileListComment;

      vm.srchComment.mapCode = 'FreeBoard.insertBoardComment';

      postApi.insert(
        vm.srchComment,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.srchComment.Contents = '';
              vm.srchComment.uploadFileList = [];
              vm.uploadFileListComment = [];

              getComment();

              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    vm.setDeleteFileToggle = setDeleteFileToggle;
    function setDeleteFileToggle(commentObj) {
      var idx = -1;
      angular.forEach(vm.comment.lists, function (val, key) {
        if (val == commentObj) {
          idx = key;
          return;
        }
      });
      if (vm.comment.lists[idx].delState == '') {
        vm.comment.lists[idx].delState = 'delete';
      } else {
        vm.comment.lists[idx].delState = '';
      }
    }

    function deleteComment(commentObj) {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteCommentAction(commentObj);
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteCommentAction(commentObj) {
      var srch = {
        FreeBoardCommId: commentObj.FreeBoardCommId,
        TableNm: 'FreeBoardComm',
        TableId: commentObj.FreeBoardCommId,
      };

      if (commentObj.AttachmentId != null) {
        var uploadFileList = [];

        var obj = {
          id: commentObj.AttachmentId,
          isLoaded: true,
          link: StaticVariable.getUrl(
            '/attach/file/' +
              commentObj.PhysicalFileNm +
              '/download.do?path=' +
              commentObj.PhysicalFolderNm +
              '&fileName=' +
              commentObj.LogicalFileNm
          ),
          fileName: commentObj.LogicalFileNm,
          size: commentObj.FileSize,
          fileKey: commentObj.PhysicalFileNm,
          path: commentObj.PhysicalFolderNm,
          downloadCnt: commentObj.DownloadCnt,
          delState: 'delete',
          typeId: 'file',
        };
        uploadFileList.push(obj);

        srch['uploadFileList'] = uploadFileList;
      }

      srch.mapCode = 'FreeBoard.deleteBoardComment';
      postApi.update(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.FreeBoardCommId == commentObj.FreeBoardCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function editComment(FreeBoardCommId) {
      vm.comment.editid = FreeBoardCommId;

      vm.comment.lists.forEach(function (item, index, object) {
        if (item.FreeBoardCommId == FreeBoardCommId) {
          vm.comment.editContents = item.Contents;
        }
      });
    }

    function editCommentAction(commentObj) {
      var srch = {
        FreeBoardCommId: commentObj.FreeBoardCommId,
        Contents: vm.comment.editContents,
        TableNm: 'FreeBoardComm',
        TableId: commentObj.FreeBoardCommId,
      };

      if (commentObj.AttachmentId != null) {
        var uploadFileList = [];

        var obj = {
          id: commentObj.AttachmentId,
          isLoaded: true,
          link: StaticVariable.getUrl(
            '/attach/file/' +
              commentObj.PhysicalFileNm +
              '/download.do?path=' +
              commentObj.PhysicalFolderNm +
              '&fileName=' +
              commentObj.LogicalFileNm
          ),
          fileName: commentObj.LogicalFileNm,
          size: commentObj.FileSize,
          fileKey: commentObj.PhysicalFileNm,
          path: commentObj.PhysicalFolderNm,
          downloadCnt: commentObj.DownloadCnt,
          delState: commentObj.delState,
          typeId: 'file',
        };
        uploadFileList.push(obj);

        console.log('editComment File', uploadFileList);
        srch['uploadFileList'] = uploadFileList;
      }

      console.log('edit comment', srch);
      srch.mapCode = 'FreeBoard.updateBoardComment';
      postApi.update(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].FreeBoardCommId != 0) {
              vm.comment.lists.forEach(function (item, index, object) {
                if (item.FreeBoardCommId == commentObj.FreeBoardCommId) {
                  item.Contents = data.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState == 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });

              return;
            }
          }

          gAlert('', data.body.docs[0].errMessage);
        },

        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }
    function editCommentCancel() {
      vm.comment.editid = null;
      vm.comment.editContents = null;
    }

    vm.openDilalog = openDilalog;
    function openDilalog() {
      angular.element('#file-5').trigger('click');
    }

    var fileElement = angular.element('#file-5');
    fileElement.bind('change', function () {
      uploadFiles(fileElement[0].files);
    });

    vm.uploadFiles = uploadFiles;

    function uploadFiles(files) {
      var tempIds = [];
      // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
      $scope.$root.safeApply(function () {
        var hasZeroByteFile = false;
        angular.forEach(files, function (value) {
          if (value.size == 0) {
            hasZeroByteFile = true;
          } else {
            var obj = {
              isLoaded: false,
              fileName: value.name,
              size: value.size,
              id: id,
              delState: '',
            };
            tempIds.push(obj);
            if (vm.uploadFileListComment == null) vm.uploadFileListComment = new Array();
            vm.uploadFileListComment.push(angular.copy(obj));
            id++;
          }
        });
        if (hasZeroByteFile) {
          alert('빈 파일이 있습니다.');
          return;
        }

        var request = fileUploadService.post(files, null, function (percent) {
          // -- 진행율 표시
          angular.forEach(tempIds, function (obj) {
            $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
          });
          if (percent == 100) {
            vm.showLoading = true;
          }
        });

        try {
          request.to(StaticVariable.getUrl('/attach/temp/upload.do')).then(
            function (value) {
              angular.forEach(value.data.body.docs, function (item) {
                angular.forEach(vm.uploadFileListComment, function (obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.fileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl(
                      '/attach/temp/' + item.tmpFileKey + '/download.do?fileName=' + item.encFileName
                    );
                    obj.delState = '';
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            },
            function (reason) {
            }
          );
        } catch (err) {
          console.log(err);
        }
      });
    }
    vm.onDelete = onDelete;
    function onDelete(obj) {
      var idx = -1;
      angular.forEach(vm.uploadFileListComment, function (val, key) {
        if (val == obj) {
          idx = key;
          return;
        }
      });

      alert('2');
      if (idx != -1) {
        if (vm.uploadFileListComment[idx].typeId == 'temp') {
          var prms = fileUploadService.attachFileDelete().get({
            attachId: vm.uploadFileListComment[idx].fileKey,
          }).$promise;

          prms.then(
            function (data) {
              // console.log('success', data);
            },
            function (error) {
              console.log("error");
              // console.error('fail', error);
            }
          );
          vm.uploadFileListComment.splice(idx, 1);
        } else if (vm.callback) {
          vm.uploadFileListComment[idx].delState = 'delete';
        }
      }
      alert('3');
    }
    vm.onDeleteCancel = onDeleteCancel;
    function onDeleteCancel(obj) {
      var idx = -1;
      angular.forEach(vm.uploadFileListComment, function (val, key) {
        if (val == obj) {
          idx = key;
          return;
        }
      });

      if (idx != -1) {
        vm.uploadFileListComment[idx].delState = '';
      }
    }
    function fncFileDown(a, b) {
      document.frm_filedown.fileurl.value = a;
      document.frm_filedown.filename.value = escape(encodeURIComponent(b));
      document.frm_filedown.action = 'https://moti.or.kr/system/employ/employ5/download.jsp';

      document.frm_filedown.submit();
    }

    getDetail();
    //getComment();
  },
]);

/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('RecomListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  '$http',
  'postApi',
  '$timeout',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function RecomListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    $http,
    postApi,
    $timeout
  ) {
    // View Model
    var vm = this;

    vm.dataloader = false;

    if ($stateParams.srch == undefined || $stateParams.srch == '') {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId: $stateParams.BbsMasterId != '' ? $stateParams.BbsMasterId : 1,
        TableNm: $stateParams.TableNm != '' ? $stateParams.TableNm : 'bbspost',
        //        Title : '',
        //        Contents : '',
        //        RegDateFrom : '',
        //        RegDateTo : '',
        //        RegUser_ : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.currentPage = vm.srch.page;
    }

    vm.listSize = [20];

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = {};

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.listSize[0];

    $scope.showDetail = function (li) {
      $location.url('/' + li.BbsPostId);
    };

    var date = new Date();
    date.setDate(date.getDate() - 3);
    var year = date.getFullYear();
    var month = new String(date.getMonth() + 1);
    var day = new String(date.getDate());

    // 한자리수일 경우 0을 채워준다.
    if (month.length == 1) {
      month = '0' + month;
    }
    if (day.length == 1) {
      day = '0' + day;
    }

    vm.srch.beforeDay3 = year + '' + month + '' + day;

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('recom-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/recom-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/bbspost/recom-list') !== -1)
      ) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('recom-list-ctrl'));

        $("li[id^='liTab']").prop('class', '');

        switch (vm.srch.Orderby) {
          case 'closeday':
            $('#liTab2').prop('class', 'active');
            break;
          case 'overday':
            $('#liTab3').prop('class', 'active');
            break;
          default:
            $('#liTab1').prop('class', 'active');
            break;
        }

        vm.currentPage = vm.srch.page;
      }
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.dataloader = true;
      vm.srch.p_Schfield = vm.srch.Schfield === undefined ? 'JR_SUBJECT' : vm.srch.Schfield;

      postApi.api('extSelect/Linkage.getRecomListCnt/action', vm.srch, function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            vm.totalItems = data.body.docs[0];
            $timeout(function () {
              vm.dataloader = false;
            }, 1000);
          } else {
            vm.totalItems = 0;
            vm.lists = {};
            $timeout(function () {
              vm.dataloader = false;
            }, 1000);
          }
        }
      });

      vm.srch.page = vm.currentPage;
      $window.sessionStorage.setItem('recom-list-ctrl', angular.toJson(vm.srch));

      postApi.api('extSelect/Linkage.getRecomList/action', vm.srch, function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt === 0) {
            vm.lists = [];
          } else {
            var resultData = postApi.makeResultData(data);
            // vm.lists = data.body.docs;
            vm.lists = resultData.body.docs;
          }
        }
      });

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiGetRecomList.jsp?p_pagenum=' +
        vm.srch.page;
      url = url + '&p_orderby=' + vm.srch.Orderby;
      url = url + '&p_schfield=' + vm.srch.Schfield;
      url = url + '&p_schword=' + escape(encodeURIComponent(vm.srch.Schword));

      window.GoojikApiGetRecomList = function (data) {
        console.log('GoojikApiGetRecomList = ', data);
        if (data == null || data == '') {
          //gAlert('', '조회된 정보가 없습니다.');
          vm.lists = [];
        }
        vm.lists = data;
        vm.totalItems = data[0].TotCount;
      };

      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiGetRecomList' }); */
    }


    

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      //var srch = encodeURIComponent(JSON.stringify(vm.srch));
      //console.log('srch=', srch);
      //$state.go('app.bbspost.recom-list', {srch:srch});
      vm.srch.page = 1;
      getList();
    }

    function fncFileDown(a, b) {
      /* if(b != null && b != ''){

        var link = document.createElement('a');
        document.body.appendChild(link);

        var downObj = {
          fileDir: a,
          fileName: b,
          userkey: $rootScope.gVariable.userKey,
          host: document.location.host,
        };

        $http({
          url: StaticVariable.getUrl(
            '/api/extRecomDownload.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: downObj, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var blob = new Blob([data], {type:'application/octet-stream'});
            if (window.navigator && window.navigator.msSaveBlob) {
              window.navigator.msSaveOrOpenBlob(blob, downObj.fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              link.href = objectUrl;
              link.download = downObj.fileName;
              link.click();
              document.body.removeChild(link);
              delete link;
            }
          })
          .error(function (data, status, headers, config) {});
      }else{
        gAlert('', '파일이 존재하지 않습니다.');
      } */
      document.frm_filedown.fileurl.value = a;
      document.frm_filedown.filename.value = escape(encodeURIComponent(b));
      document.frm_filedown.action = 'https://moti.or.kr/system/employ/employ5/download.jsp';

      document.frm_filedown.submit();
    }

    // 탭클릭
    $scope.setTab = function (data) {
      vm.srch.Orderby = data;

      $("li[id^='liTab']").prop('class', '');

      switch (data) {
        case 'closeday':
          $('#liTab2').prop('class', 'active');
          break;
        case 'overday':
          $('#liTab3').prop('class', 'active');
          break;
        default:
          $('#liTab1').prop('class', 'active');
          break;
      }

      vm.srch.page = 1;
      getList();
    };

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.fncFileDown = fncFileDown;

    // 데이터 조회
    getList();
  },
]);

webapp.service('BoardMngAPISrv', [
  '$resource',
  'StaticVariable',
  '$rootScope',
  function BoardMngAPISrv($resource, staticVariable, $rootScope) {
    return {
      getBoardMngApi: function () {
        return $resource(
          staticVariable.getUrl('/api/boardmng/metatables/:tableNm') + '.json',
          {
            tableNm: '@tableNm',
            userkey: $rootScope.gVariable.userKey,
          },
          staticVariable.getRequestActions.defaultAction()
        );
      },
      getUsingMetaTableNm: function () {
        return $resource(
          staticVariable.getUrl('/api/boardmng/metatables/:tableNm/info') +
            '.json',
          {
            tableNm: '@tableNm',
            userkey: $rootScope.gVariable.userKey,
          },
          staticVariable.getRequestActions.defaultAction()
        );
      },
      doModuleTypeList: function () {
        return $resource(
          staticVariable.getUrl(
            '/select/CommonCode.getCommonCodeValue/action.json'
          ),
          { userkey: $rootScope.gVariable.userKey },
          staticVariable.getRequestActions.defaultAction()
        );
      },
    };
  },
]);

webapp.controller('BoardMngDetailCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate',
    function BoardMngDetailCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope,$location,$window,gConfirm,$translate) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      $scope.srchTenantId = $window.sessionStorage['srchTenantId'];
      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';

      (function BoardMngDetailCtrl() {
        vm.currentActionView = $stateParams.currentActionView;
        if (angular.isDefined($stateParams.tableNm)) {
          getMetaTableDetail();
        } else {
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }

      })();

      function getMetaTableDetail() {
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $window.sessionStorage['srchTenantId']
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          vm.metaTable.metaColumns.forEach(function(elm, idx) {
            elm.columnValid = true;
            elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
          });

          if(json.responseVO.body.docs[0].metaColumns.length > 0)
            vm.metaColumnYN = 'Y';
        });
      }

      function addColumn() {
        var newLine = {
          metaColumnId : '',
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '20%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          customColumnYN : 'Y',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        if(vm.metaColumnYN == 'N'){
          vm.currentActionView = 'add';
        }
        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
        if (selectedColumn.dirty == vm.COLUMN_EDIT_STATE_PENDING || selectedColumn.dirty == vm.COLUMN_EDIT_STATE_MODIFY) {
          selectedColumn.dirty = vm.COLUMN_EDIT_STATE_DELETE;
        } else {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
        }
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            return true;
          }
        });
        return false;
      }

      function getTableColumns() {
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.currentActionView = 'add';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.metaTable.metaColumns = result.body.docs;
                }
              }, function(error) {
                console.log("error");
                // console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.metaTable.metaColumns = result.body.docs;
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        $state.go('app.boardmng.modify', {
          tableNm : $stateParams.tableNm
        });
      }
    }, ]);

webapp.controller('BoardMngEditCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT',
    function BoardMngEditCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope, $location, $window, gConfirm, $translate, systemCodeAPISrv, CONST) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.ChangeCustomColumn = ChangeCustomColumn;
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      vm.makeSrch = makeSrch;

      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';
      vm.dataloader = false;
      vm.changeColumn = 'N';
      vm.srchTenantId = $rootScope.gVariable.srchTenantId;

      vm.sbCtrl;
      vm.viewType = "D";

      (function getMetaTableEdit() {
        getModuleTypeList();
        if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
          vm.currentActionView = 'modify';
          //getMetaTableDetail();
        } else {
          vm.currentActionView = 'add';
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }
      })();

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      //console.log(vm.layout);

      vm.onSelectCallback = function(data) {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.metaColumnId == data.CallbackTarget) {
            item.columnPhysicalNm = data.Code;
            return;
          }
        });
      };

      function makeSrch(){
        return encodeURIComponent(JSON.stringify(vm.srch, replacer));
      }
      function getMetaTableDetail(dataType) {
        vm.dataloader = true;
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $rootScope.gVariable.srchTenantId,
          userkey : $rootScope.gVariable.userKey
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];

          vm.sbCtrl.drawList(vm.metaTable, dataType);
          vm.checkColumnSection = "Y";
          vm.checkEditColumnRowCount = "Y";
          if (vm.metaTable) {
            vm.metaTable.metaColumns.forEach(function(elm, idx) {

              if(!isNullOrEmpty(elm.columnSection)) {
                vm.checkColumnSection = "N";
              }

              if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                vm.checkEditColumnRowCount = "N";
              }

              if (elm.editColumnRowCount != null) {
                elm.editColumnRowCount = elm.editColumnRowCount.toString();
              }
              if (elm.searchColumnRowCount != null) {
                elm.searchColumnRowCount = elm.searchColumnRowCount.toString();
              }

              elm.columnValid = true;
              elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
              if (elm.customColumnYN == 'Y') {
                elm.type = 'add';
                elm.commoncodeDATA = {
                  CallbackTarget : elm.metaColumnId,
                  CodeType : 'METACOLUMN',
                  Code : elm.columnPhysicalNm,
                  ReloadSeq : 1
                }
              } else if (elm.customColumnYN == 'N') {
                elm.type = 'old';
              }
            });

            if(vm.metaTable.metaColumns.length > 0)
              vm.metaColumnYN = 'Y';
          }

          vm.dataloader = false;
        });
      }

      function addColumn(type) {
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

        var newLine = {
          metaColumnId : newnum.toString(36),
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : 'auto',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'N',
          listColumnShowLevel : 'showlevel3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'N',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          codeType : '',
          customColumnYN : type == 'add' ? 'Y' : 'N',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
          commoncodeDATA : {
            CallbackTarget : newnum.toString(36),
            CodeType : 'METACOLUMN',
            ReloadSeq : 1
          },
          type : type
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        data.deleteColumns = vm.deleteColumns;

        postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.log("error");
          // console.error('Error> h0102-list-ctrl> getList()', status, error);
        });

    /*         if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        } */
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
          vm.deleteColumns.push(selectedColumn);
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        var res = false;
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            res = true;
          }
        });
        return res;
      }

      function validateCheck(){
        if(vm.currentActionView == 'add'){
          if(vm.usingTableNm.length != 0){
            gAlert('','Menu.EM710VA03');
            vm.dataloader = false;
            return false;
          }
        }

        return true;
      }

      function getTableColumns() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){

              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  var newnum = 0;
                  result.body.docs.forEach(function(elm,indx){

                    newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                    elm.metaColumnId = newnum.toString(36);
                    if (elm.customColumnYN == "N") {
                      elm.columnSection = "";

                      if (elm.dataType == "varchar") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else if (elm.dataType == "datetime" || elm.dataType == "date") {
                        elm.columnPhysicalDataType = "40";
                        elm.columnLogicalDataType = "40";
                      } else if (elm.dataType == "int") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "bigint") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "char") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      }
                      elm.columnPhysicalDataSize = "";
                      elm.listColumnWidth = "20%";
                      elm.listColumnTextAlign = "text-center";
                      elm.listColumnShowYN = "Y";
                      elm.listColumnShowLevel = "showlevel3";
                      elm.editColumnWidth = "col-lg-4 col-md-6";
                      elm.editColumnShowYN = "Y";
                      elm.editColumnHeight = "";
                      elm.columnDesc = "";
                      elm.columnCodeValue = "";
                      elm.codeType = "";
                      elm.dirty = "";
                    }

                    if (elm.customColumnYN == 'Y') {
                      elm.commoncodeDATA = {
                        CallbackTarget : elm.metaColumnId,
                        CodeType : 'METACOLUMN',
                        Code : elm.columnPhysicalNm,
                        ReloadSeq : 1
                      };
                    }
                  });
                  vm.metaTable.metaColumns = result.body.docs;
                  vm.sbCtrl.drawList(vm.metaTable);
                }
                vm.dataloader = false;
              }, function(error) {
                vm.dataloader = false;
                console.log("error");
                // console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              vm.checkColumnSection = "Y";
              vm.checkEditColumnRowCount = "Y";

              result.body.docs.forEach(function(elm,indx){
                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);

                if(!isNullOrEmpty(elm.columnSection)) {
                  vm.checkColumnSection = "N";
                }

                if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                  vm.checkEditColumnRowCount = "N";
                }

                if(elm.customColumnYN == 'N'){
                  elm.columnSection = '';
                  elm.editColumnSort = indx;
                  if(elm.dataType =="varchar"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else if(elm.dataType =="date"){

                    elm.columnPhysicalDataType = '40';
                    elm.columnLogicalDataType = '40';

                  }else if(elm.dataType =="datetime"){

                    elm.columnPhysicalDataType = '90';
                    elm.columnLogicalDataType = '90';

                  }else if(elm.dataType =="int"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="bigint"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="char"){

                    elm.columnPhysicalDataType = '110';
                    elm.columnLogicalDataType = '110';

                  }else{
                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';
                  }
                  elm.columnPhysicalDataSize = '';
                  elm.listColumnWidth = 'auto';
                  elm.listColumnTextAlign = 'text-center';
                  elm.listColumnShowYN = 'Y';
                  elm.listColumnShowLevel = 'showlevel3';
                  elm.editColumnWidth = 'col-lg-4 col-md-6';
                  elm.editColumnShowYN = 'Y';
                  elm.editColumnHeight = '';
                  elm.columnDesc = '';
                  elm.columnCodeValue = '';
                  elm.codeType = '';
                  elm.keyColumnYN = 'Y';
                }
                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
              vm.metaTable.metaColumns = result.body.docs;
              vm.sbCtrl.drawList(vm.metaTable)
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        vm.srchTenantId = $rootScope.gVariable.srchTenantId;
        vm.metaColumnYN = 'N';
        vm.changeColumn = 'N';
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          // 삭제시 -> 목록 화면 이동
//        $state.go("app.boardmng.list", { srch: srch, tableNm: ''}, {reload:"app.boardmng.list"});
        } else {
          // 조회 화면 이동
          $state.go("app.boardmng.list.modify", {srch: srch, tableNm: vm.metaTable.tableNm}, {reload:"app.boardmng.list"});
        }        
      }

      function ChangeCustomColumn() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y' || vm.changeColumn == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              if (vm.changeColumn =='N') vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.changeColumn = 'N';
              vm.metaTable.metaColumns = [];
              vm.dataloader = false;
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          vm.changeColumn = 'Y';
          postApi.select('BoardMng.getChangeTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              vm.metaTable.metaColumns = result.body.docs;
              vm.metaTable.metaColumns.forEach(function(elm, idx) {

                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);
                elm.tenantId = null;

                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function getModuleTypeList () {
        var res = boardMngApi.doModuleTypeList().post({
          CodeType : 'MODULETYPE',
          srchTenantId : $rootScope.gVariable.srchTenantId,
          userkey : $rootScope.gVariable.userKey
        }).$promise;
        res.then(function(json) {
          vm.moduleTypeList = json.responseVO.body.docs;
        });
      }

      vm.succSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
        .then(function(json){
          if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
            getMetaTableDetail(json.responseVO.body.docs);
          } else {
            vm.sbCtrl.drawList(vm.metaTable, json.responseVO.body.docs)
          }
        });

        ctrl.openPop = function(data, callback) {

        };

        ctrl.deleteColumn = function(data, callback) {
          vm.deleteColumn(data);
        };

        ctrl.openAttrSetup = function(data, callback) {
          vm.openAttrSetup(data);
        };

        ctrl.onSelectCallback  = function(data, callback) {
          vm.onSelectCallback(data);
        };
      };

      
    }, ]);

webapp.controller('BoardMngListCtrl', [ '$window', '$filter', 'GLOBAL_CONSTANT', 'BoardMngAPISrv','$stateParams','$scope','$state','$rootScope', 'postApi', 'gAlert',
  function BoardListCtrl($window, $filter, CONSTANT, boardMngApi, $stateParams, $scope, $state, $rootScope, postApi, gAlert) {
    var vm = this;// View Model

    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.getSearch = getSearch;
    vm.makeSrch = makeSrch;
    vm.resetSearch = resetSearch;
    vm.pageChanged = pageChanged;

    var KEY_TABLE_NM = 'metatable';

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: ''          // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
    }

    $scope.selectedRow = $stateParams.tableNm;
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    setLayout(vm.layout); // 화면분할 모드 설정

    //pagination
    vm.totalCount = 0;
    vm.viewSizePerPage = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.viewSizePerPageList = CONSTANT.PAGINATION.OPTION_VIEWSIZE;
    vm.dataloader = false;
    // 검색 선택 옵션
    vm.searchFieldTypeList = [ {
      optionId : 'all',
      optionName : '전체'
    }, {
      optionId : 'table',
      optionName: '물리 테이블명'
    }, {
      optionId : 'column',
      optionName: '물리 컬럼명'
    }, ];

    vm.changeViewSize = changeViewSize;
    vm.getMetaTableList = getMetaTableList;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;

    (function BoardListCtrl() {
      // 페이징
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      getMetaTableList();
    })();

    function changeViewSize() {
      vm.srch.page = 1;
      vm.srch.viewSize = vm.viewSize;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getMetaTableList();
    });

    /**
     * 화면 분할 모드 설정
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setLayout(layout) {

      // 분할 모드 지정
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          // 수평
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          // 수직
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          // 기본
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    /**
     * 화면 분할 모드 변경
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function changeLayout(layout) {
      // 분할 모드 설정값 저장
      $rootScope.changeLayout(layout);

      var srch = $stateParams.srch; // 검색 옵션

      $state.go('app.boardmng.list', {
        srch: makeSrch(),
        tableNm: ''
      }, {reload: 'app.boardmng.list'});
    }

    function getMetaTableList() {
      vm.srch.page = vm.currentPage;
      vm.dataloader = true;
      var data = vm.srch;
      data.mapCode = "boardmng/metatables";
      postApi.api(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.boardList = result.body.docs;
              vm.currentPage = vm.boardList[0].page;
              vm.totalCount = vm.boardList[0].totalCount;
              vm.boardList.splice(0, 1);
              vm.dataloader = false;
            } else {
              vm.dataloader = false;
              var errMsg = result.body.docs.errMessage;
              gAlert("Menu.ERROR", errMsg);
              console.log("error");
              // console.error("ErrorCode : ", result.body.docs.errCode, "ErrorMsg : ", result.body.docs.errMessage);
            }
          }
          vm.columnMap = '';
          vm.SearchConditionStr = getSearchConditionStr(vm.totalCount, vm.columnMap, vm.srch);
          vm.dataloader = false;
        },
        function(error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
        vm.sortDirect = vm.srch.sortDirect ;
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.sortDirect = vm.srch.sortDirect ;
      }

      vm.srch.sortColumn = sortkey;
      vm.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.boardmng.list', {srch:srch}, {reload:'app.boardmng.list'});
    }
    function makeSrch(){
      return encodeURIComponent(JSON.stringify(vm.srch, replacer));
    }

    function resetSearch() {
      $state.go('app.boardmng.list', {
        srch : ''
      }, {reload: 'app.boardmng.list'});
    }

    function goDetail(tableNm) {
      var srch = $stateParams.srch; // 검색 옵션
      $scope.selectedRow = tableNm;

      if (vm.layout == 'N') {
        // 조회 화면 이동
        $state.go('app.boardmng.modify', {
          srch: srch,
          tableNm: tableNm
        });
      } else {
        // 목록 조회 화면 이동
        $state.go('app.boardmng.list.modify', {
          srch: srch,
          tableNm: tableNm
        });
      }
    }

    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }
}, ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.boardmng', {
      url: '/boardmng',
      template: '<div ui-view></div>',
    }).state('app.boardmng.list', {
      url: '/list/:srch',
      templateUrl: 'app/boardmng/boardmng-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.add', {
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.modify', {
      url: '/modify/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.add', {
      url: '/add/:srch',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.modify', {
      url: '/modify/:srch/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    });
  }
})();

webapp.controller('ColumnAttrReorderCtrl', [ '$scope', '$uibModalInstance', '$filter', 'sortArrayFactory', 'toModalData',
    function ObjectTypeReorderController($scope, $uibModalInstance, $filter, sorts, toModalData) {
      var vm = this;
      var COLUMN_EDIT_STATE_MODIFY = 'M';
      var COLUMN_EDIT_STATE_PENDING = '';
      vm.selectedIdx = 0;
      vm.objModel = [];

      vm.onSelect = onSelect;
      vm.moveUp = moveUp;
      vm.moveDown = moveDown;
      vm.moveTop = moveTop;
      vm.moveBottom = moveBottom;
      vm.move = move;
      vm.onSave = onSave;
      vm.onClose = onClose;
      vm.title = '사용자 속성 정렬';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      angular.copy(sorts.sortArrayObject(toModalData, toModalData.ListColumnSort), vm.objModel);
      vm.objModelLen = vm.objModel.length;

      function onSelect(idx) {
        vm.selectedIdx = idx;
      }

      function moveUp() {
        var destIdx = vm.selectedIdx - 1;
        if (destIdx == -1) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveDown() {
        var destIdx = vm.selectedIdx + 1;
        if (destIdx == vm.objModelLen) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveTop() { // 맨위
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.unshift(temp);
        vm.selectedIdx = 0;
      }

      function moveBottom() { // 맨아래
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.push(temp);
        vm.selectedIdx = vm.objModelLen - 1;
      }

      function move(orgIdx, destIdx) {
        var temp = vm.objModel[destIdx];
        vm.objModel[destIdx] = vm.objModel[orgIdx];
        vm.objModel[orgIdx] = temp;
      }

      // 순서 변경 저장
      function onSave() {
        var reorderList = [];
        angular.forEach(vm.objModel, function(node, idx) {
          node.listColumnSort = idx;
          if (node.dirty == COLUMN_EDIT_STATE_PENDING) {
            node.dirty = COLUMN_EDIT_STATE_MODIFY;
          }
        });
        $uibModalInstance.close(vm.objModel);
      }

      // 취소|닫기 버튼
      function onClose() {
        $uibModalInstance.dismiss('cancel');
      }
    } ]);

webapp.controller('ColumnAttrSetupCtrl', ['$scope', '$uibModalInstance', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT', 'toModalData',
  function ColumnAttrSetupCtrl($scope, $uibModalInstance, systemCodeAPISrv, CONST, toModalData) {
    var vm = this;
    var backupColumn = {};
    vm.isSizableData = isSizableData;
    vm.onCancelClick = onCancelClick;
    vm.onAddClick = onAddClick;

    (function ColumnAttrSetupCtrl(){
      getSystemCodeList();
      vm.column = toModalData;
      angular.copy(toModalData, backupColumn);
      vm.selectedPhysicalDataType = {
          code: vm.column.columnPhysicalDataType
      };
      vm.selectedLogicalDataType = {
          code: vm.column.columnLogicalDataType
      };
      vm.title = vm.column.columnLogicalNm + "(" + vm.column.columnPhysicalNm + ")";
    })();

    function onCancelClick(){
      angular.copy(backupColumn, vm.column);
        $uibModalInstance.dismiss('cancel');
    }

    function onAddClick(){
      vm.column.columnPhysicalDataType = vm.selectedPhysicalDataType.code;
      vm.column.columnLogicalDataType = vm.selectedLogicalDataType.code;

      $uibModalInstance.close(vm.column);
    }

    function getSystemCodeList(){
      systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
      .then(function(json){
        vm.codeList = json.responseVO.body.docs;
      });
    }

    function isSizableData(){
      return ['40', '50'].indexOf(vm.selectedPhysicalDataType.code) < 0;
    }
  }]);

(function () {
  "use strict";
  webapp.controller('BusinessDrListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
      function BusinessDrListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

        var vm = this;          // View Model
        vm.showDetailSearch = false;

        // 영업일지 등록 팝업창
        vm.busiWriteModal = function (keyId, copyYN) {
          if (isNullOrEmpty(copyYN) || copyYN == undefined) { copyYN = 'N'; }
          var ctrl = 'BusinessDrModalCtrl as vc';
          var paramData = { KeyId: keyId, CopyYN: copyYN };

          var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            var KeyId = 0;
            var CopyYN = 'N';
            // 새로등록
            if (!isNullOrEmpty(okData)) {
              KeyId = okData.KeyId;
              CopyYN = okData.CopyYN;
            }
            vm.busiWriteModal(KeyId, CopyYN);
          }, function (cancelData) {
            getDRList();
            av.search();
          });
        };

        // 회의뷰 등록 팝업창
        vm.meetViewWriteModal = function () {
          vm.MeetViewList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow)
            {
              vm.MeetViewList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.MeetViewList == null || vm.MeetViewList.length == 0)
          {
            av.alert('회의View를 생성할</br>영업일지를 선택해주세요.', function () {return false;});
          } 
          else 
          {
            var ctrl = 'BusinessMeetingViewModalCtrl as vc';
            var paramData = { BusinessDRList: vm.MeetViewList };

            var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-meeting-view/business-meeting-view-modal.html', ctrl, paramData);
            modalInstance.result.then(function (okData) {
              vm.meetViewWriteModal();
            }, function (cancelData) {
              getDRList();
              av.search();
            });
          }
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_BUSINESSDR",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "BusinessDR.getBusinessDRListCnt", param: null },
            initSelect: { mapCode: "BusinessDR.getBusinessDRList", param: null, excelFileName: "영업일지목록"},
          },

          // List
          listCheckboxEnable: true,

          addSrchStack: false,

          src: {
            detail: "",
            splitDetail: ""
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent,

          customCodes: {
            //Channel: "codeCmpgnChannel"
          }

        };

        //#region 목록 삭제
        function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'BusinessDR.deleteBusinessDRBatch', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ getDRList(); av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelList()");
              // console.table(error);
            });
          }, function () {

          });
        }
        //#endregion 목록 삭제

        function clickevent(clickData) {
          vm.busiWriteModal(clickData.KeyId, 'N');
        }

        function getDRList() {
          // 활동유형 건수
          postApi.select({ mapCode: 'BusinessDR.getBusinessDRTypeCnt' },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.DRTypeLists = result.body.docs;
              }
            });
        }

        function onReadyAutoView() {
          //console.log(vm);
          getDRList();

        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.setDelList = setDelList;
        vm.getDRList = getDRList;
        vm.clickevent = clickevent;

        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessMeetingViewListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
      function BusinessMeetingViewListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

        var vm = this;  // View Model
        vm.headerTitle = "회의View 목록";
        vm.showDetailSearch = false;

        // 회의뷰 조회 팝업창
        vm.meetViewModal = function (keyId) {
          var ctrl = 'BusinessMeetingViewModalCtrl as vc';
          var paramData = { KeyId: keyId };

          var modalInstance = modalFactory.open('mf-65', 'app/business/modal/business-meeting-view/business-meeting-view-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            var KeyId = 0;
            // 새로등록
            if (!isNullOrEmpty(okData)) {
              KeyId = okData;
            }
            // 수정하는 경우
            else {
              KeyId = okData.KeyId;
            }
            vm.meetViewModal(KeyId);
          }, function (cancelData) {
            av.search();
          });
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_MEETINGVIEW",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "MeetingView.getMeetingViewListCnt", param: null },
            initSelect: { mapCode: "MeetingView.getMeetingViewList", param: null },
          },

          addSrchStack: false,

          // List
          listCheckboxEnable: true,

          src: {
            detail: "",
            splitDetail: ""
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent
        };


        //#region 목록 삭제
        function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'MeetingView.deleteMeetingViewBatch', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelList()");
              // console.table(error);
            });
          }, function () {

          });
        }
        //#endregion 목록 삭제


        function clickevent(clickData) {
          vm.meetViewModal(clickData.KeyId);
        }

        function onReadyAutoView() {

        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.clickevent = clickevent;
        vm.setDelList = setDelList;

        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessOpDetailCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window', 'modalFactory', '$timeout', 'gAlert',
    function BusinessOpDetailCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window, modalFactory, $timeout, gAlert) {

      var vm = this;
      $scope.events = [];

      vm.BusinessProductList = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];

      vm.headerTitle = "사업기회 정보";

      var VIEW_PAGE_URL = 'app.business.business-op-detail';

      // 변경이력
      var oldParam = {};
      var newParam = {};

      // 싱글뷰 사용
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 싱글뷰 영역
      vm.view = {
        VIEW_PAGE_DR : 'app/business/tab/business-op-tab-dr.html', 
        VIEW_PAGE_CUSTOMER : 'app/business/tab/business-op-tab-customer.html', 
        VIEW_PAGE_HIST : 'app/business/tab/business-op-tab-hist.html', 
        VIEW_PAGE_FILES : 'app/business/tab/business-op-tab-files.html', 
        VIEW_PAGE_COMM : 'app/business/tab/business-op-tab-comm.html', 
      };

      // vm.pages = vm.view.VIEW_PAGE_DR;
      vm.tabIndex = 0;

      postApi.select({mapCode : 'KSATab.getTabListBusinessOP'}, 
        function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tabList = {};
              vm.tabList = result.body.docs;
              vm.pages = vm.view[vm.tabList[0].Page];
            } else {
              vm.tabList = [
                {Index : 0, Page : "VIEW_PAGE_DR", Text : "영업일지"}
                , {Index : 1, Page : "VIEW_PAGE_CUSTOMER", Text : "고객"}
                , {Index : 2, Page : "VIEW_PAGE_HIST", Text : "변경이력"}
                , {Index : 3, Page : "VIEW_PAGE_FILES", Text : "관련파일"}
                , {Index : 4, Page : "VIEW_PAGE_COMM", Text : "의견공유"}
              ];
              vm.pages = vm.view[vm.tabList[0].Page];
            }
          }
        });

      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          return true;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeTabPosition(source);
        },
      };

      function setChangeTabPosition(source) {
        var TabList = [];
        for (var i = 0;  i < source.length; i ++) {
          source[i].Index = i;
          if (isNullOrEmpty(source[i].KeyId)) {
            source[i].KeyId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
          }

          TabList.push(source[i]);
        }

        var data = {};
        data.TabList = TabList;
        data.mapCode = 'KSATab.updateTabListBusinessOP';

        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> setChangeTabPosition()', error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      }
      
      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
       function setLayout(layout) {
        //alert(layout);
        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } 
        else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "651px";
            break;
            // 기본 "N"을 "V"와 같게 맞춰줌 
          case "N":
            vm.anchor = "west";
            vm.paneMin = "651px";
            break;
        }
        
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {
        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.changeLayout(layout);

        var srch = '';

        $state.go(VIEW_PAGE_URL, {
          srch: srch
        }, {reload: VIEW_PAGE_URL});
      }

      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,

        /* 공통 */
        viewType: mViewType.Edit, // List OR Edit
        tableNm: "TB_BUSINESSOP_DETAIL",
        keyIdNm: "KeyId",
        alias: "vc",
        dataModelNm: "data", // ex : vc.data = {}
        apis: {

          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect: { mapCode: "BusinessOP.getBusinessOPDetail", param:  {KeyId: $stateParams.KeyId} },

          // vieType is edit
          update: "BusinessOP.updateBusinessOPBatch",
        },

        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType: mElemTx.layout.inline,
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow: [],
  
        // vc의 ng-if
        ngIf: {
          //ItemType: "!vc.data.KeyId || vc.data.Status == '10' || vc.data.Status == '20'",
        },
  
        // 비활성화 시킬 컬럼의 조건
        disabled: {
          ClientNm : true,
        },

        // MataColum 외 추가 적으로 넣어야할 폼
        addForm: {
        },

        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
        },

        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
        },

        // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
        //noLable : ["OpenType"],

        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
          //ItemType: "codeItemType",
        },

        // 필수 항목 컬럼 
        //required: [],

        autocomplete: {
          CustNm: { keyNm: "CustId", callback: "setCustCode", codeList: "codeCustList", addTopRow: "신규등록", addTopRowCallback: "addCust", ngChange: "onChangeCustNm" },
          ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", addTopRow: "", addTopRowCallback: "", ngChange: "onChangeManagerNm" },
        }
      };

      /* START 고객 자동완성 */
      vm.ACCustNm = "__undefined__";
      vm.ACCustNmTimerId = null;

      vm.onChangeCustNm = function (item) {
        if (vm.ACCustNmTimerId != null) {
          clearTimeout(vm.ACCustNmTimerId);
        }

        vm.ACCustNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACCustNm != item && !check.test(item)) {
            // 고객리스트
            postApi.select({ mapCode: 'AutoComplete.getCustList', EncryptNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.EncryptNm;
                });
                vm.codeCustList = result.body.docs;
              }

              vm.ACCustNm = item;
            });
          }
        }, 100);
      };

      function setCustCode(data) {
        var tmpCnt = 0;

        if (data) {
          if (vm.data.CustList.length != 0) {
            for (var i in vm.data.CustList) {
              if (vm.data.CustList[i].CustId == data.CustId) {
                tmpCnt += 1;
                $timeout(function(){
                  vm.data.CustNm = "";
                }, 1);
                
                av.alert("중복된 고객은 선택할 수 없습니다.");
              }
            }
          }
          
          if (tmpCnt == 0){
            vm.data.CustList.push({ 'CustId': data.CustId, 'CustNm': data.CodeValue });
            
            $timeout(function(){
              vm.data.CustNm = "";
            }, 1);
          }
        }
      }

      function addCust(){
        var ctrl = 'KSACustEditModalCtrl as vc';
        var paramData = {popup : 'Y'};
        var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
          // var data = angular.copy(okData);
        }, function (cancelData) {
          // cancel버튼
        });
      }

      function setCust() {
        var CustIds = [];
        var CustNms = [];
        if (vm.data.CustIds != null) {
          CustIds = vm.data.CustIds.split(",");
        }
        if (vm.data.EncryptNms != null) {
          CustNms = vm.data.EncryptNms.split(",");
        }
        angular.forEach(CustIds, function (item, key) {
          var result = {CustId: item, CustNm: CustNms[key]};
          vm.data.CustList.push(result);
        });
      }

      function delCust(item) {
        if (item) {
          for (var i in vm.data.CustList) {
            if (vm.data.CustList[i].CustId == item.CustId) {
              vm.data.CustList.splice(i, 1);
            }
          }
        }
      }
      /* END 고객 자동완성 */

      /* START 영업담당자 자동완성 */
      vm.ACManagerNm = "__undefined__";
      vm.ACManagerNmTimerId = null;

      vm.onChangeManagerNm = function (item) {
        if (vm.ACManagerNmTimerId != null) {
          clearTimeout(vm.ACManagerNmTimerId);
        }

        vm.ACManagerNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACManagerNm != item && !check.test(item)) {
            // 영업담당자리스트
            postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.UserNm;
                });
                vm.codeManagerList = result.body.docs;
              }

              vm.ACManagerNm = item;
            });
          }
        }, 100);
      };

      function setManagerCode(data) {
        var tmpCnt = 0;

        if (data) {
          if (vm.data.ManagerList.length != 0) {
            for (var i in vm.data.ManagerList) {
              if (vm.data.ManagerList[i].ManagerId == data.UserId) {
                tmpCnt += 1;
                $timeout(function(){
                  vm.data.ManagerNm = "";
                }, 1);
                
                av.alert("중복된 영업담당자는 선택할 수 없습니다.");
              }
            }
          }
          
          if (tmpCnt == 0){
            vm.data.ManagerList.push({ 'ManagerId': data.UserId, 'ManagerNm': data.CodeValue });
            
            $timeout(function(){
              vm.data.ManagerNm = "";
            }, 1);
          }
        }
      }

      function setManager() {
        var ManagerIds = [];
        var ManagerNms = [];
        if (vm.data.ManagerIds != null) {
          ManagerIds = vm.data.ManagerIds.split(",");
        }
        if (vm.data.ManagerNms != null) {
          ManagerNms = vm.data.ManagerNms.split(",");
        }
        angular.forEach(ManagerIds, function (item, key) {
          var result = {ManagerId: item, ManagerNm: ManagerNms[key]};
          vm.data.ManagerList.push(result);
        });
      }

      function delManager(item) {
        if (item) {
          for (var i in vm.data.ManagerList) {
            if (vm.data.ManagerList[i].ManagerId == item.ManagerId) {
              vm.data.ManagerList.splice(i, 1);
            }
          }
        }
      }
      /* END 영업담당자 자동완성 */

      //#region 사업 자동완성 목록
      vm.ACBusinessNm = "__undefined__";
      vm.ACBusinessNmTimerId = null;

      vm.onChangeBusinessNm = function (item) {
        if (vm.ACBusinessNmTimerId != null) {
          clearTimeout(vm.ACBusinessNmTimerId);
        }

        vm.ACBusinessNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACBusinessNm != item && !check.test(item)) {
            // 사업리스트
            postApi.select({ mapCode: 'AutoComplete.getBusinessCodeList', BusinessNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.BusinessNm;
                });
                vm.codeBusinessList = result.body.docs;
              }

              vm.ACBusinessNm = item;
            });
          }
        }, 100);
      };

      function setBusinessCode(data) {
        vm.BusinessProductList[data.index].BusinessId = data.BusinessId;
        vm.BusinessProductList[data.index].BusinessStartDate = data.BusinessStartDate;
        vm.BusinessProductList[data.index].BusinessEndDate = data.BusinessEndDate;
        vm.BusinessProductList[data.index].BusinessExSales = data.BusinessExSales;
      }
      //#endregion 사업 자동완성 목록

      function setRemindAlarm() {
        var RemindIds = [];
        var RemindNms = [];
        var RemindStartDates = [];
        var RemindEndDates = [];
        var RemindDoneYns = [];

        if (vm.data.RemindIds != null) {
          RemindIds = vm.data.RemindIds.split(",");
        }
        if (vm.data.RemindNms != null) {
          RemindNms = vm.data.RemindNms.split(",");
        }
        if (vm.data.RemindStartDates != null) {
          RemindStartDates = vm.data.RemindStartDates.split(",");
        }
        if (vm.data.RemindEndDates != null) {
          RemindEndDates = vm.data.RemindEndDates.split(",");
        }
        if (vm.data.RemindDoneYns != null) {
          RemindDoneYns = vm.data.RemindDoneYns.split(",");
        }
        angular.forEach(RemindIds, function (item, key) {
          var result = {RemindId: item, RemindNm: RemindNms[key], RemindStartDate: RemindStartDates[key], RemindEndDate: RemindEndDates[key], DoneYn: RemindDoneYns[key]};
          vm.data.RemindAlarmList.push(result);
        });
      }

      function setBusinessProduct() {
        return new Promise(function(resovle, reject) {
          vm.BusinessProductList = [];

          postApi.select({ mapCode: 'BusinessOP.getBusinessProductList', KeyId: vm.data.KeyId },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              angular.forEach(result.body.docs, function(item){
                vm.BusinessProductList.push(item);
              });
              if (vm.BusinessProductList.length == 0) {
                vm.BusinessProductList[0] = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];
              }
            }
            resovle(setTotalSales());
          });
        });
      }

      function addRow() {
        var item = {};

        item.BusinessId = vm.BusinessProductList.BusinessId;
        item.BusinessNm = vm.BusinessProductList.BusinessNm;
        item.BusinessStartDate = vm.BusinessProductList.BusinessStartDate;
        item.BusinessEndDate = vm.BusinessProductList.BusinessEndDate;
        item.BusinessExSales = vm.BusinessProductList.BusinessExSales;

        vm.BusinessProductList.push(item);
      }

      function delRow(item, p2) {
        vm.totalSales = 0;
        var number = 0;

        if(vm.BusinessProductList.length > 1) {
          vm.BusinessProductList.splice(p2, 1);
          for (var i in vm.BusinessProductList) {
            if (!isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
              number = parseInt(vm.BusinessProductList[i].BusinessExSales);
            }
            vm.totalSales = vm.totalSales + number;
          }
        } else {
          vm.BusinessProductList[0] = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];
        }
      }

      function setTotalSales() {
        vm.totalSales = 0;
        var number = 0;

        for (var i in vm.BusinessProductList) {
          if (!isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
            number = parseInt(vm.BusinessProductList[i].BusinessExSales);
          }
          vm.totalSales = vm.totalSales + number;
        }
      }

      // 리마인드 알림설정 (맞춤설정)
      vm.addRemindAlarm = function () {
        var ctrl = 'BusinessRemindAlarmModalCtrl as vc';

        var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl);
        modalInstance.result.then(function (okData) {
          // ok버튼
          var data = angular.copy(okData);
          vm.data.RemindAlarmList.push(data);
        }, function (cancelData) {
          // cancel버튼
        });
      };

      function editItem(item) {
        var ctrl = 'BusinessRemindAlarmModalCtrl as vc';
        var paramData = angular.copy(item);
        var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
          vm.data.RemindAlarmList.splice(vm.data.RemindAlarmList.indexOf(item), 1, okData);
        }, function (cancelData) {
          // cancel버튼
        });
      }

      function deleteItem(item) {
        if (item) {
          for (var i in vm.data.RemindAlarmList) {
            if (vm.data.RemindAlarmList[i].RemindId == item.RemindId) {
              vm.data.RemindAlarmList.splice(i, 1);
            }
          }
        }
      }

      function goList() {
        $state.go('app.business.business-op-list', {srch: $stateParams.srch, KeyId: ''}, {reload:'app.business.business-op-list'});
      }

      function setData() {
        if (getIsValidData()) {
          // 리마인드 알림설정
          if (vm.data.RemindAlarmList.length > 0) {
            angular.forEach(vm.data.RemindAlarmList, function (element, index) {
              element.RemindStartDate = moment(element.RemindStartDate).format("YYYY-MM-DD");
              element.RemindEndDate = moment(element.RemindEndDate).format("YYYY-MM-DD");
              vm.data.RemindAlarmList.splice(index, 1, element);
            });
          }

          vm.data.BusinessProductList = vm.BusinessProductList;
          if (vm.data.BusinessProductList.length > 0) {
            angular.forEach(vm.data.BusinessProductList, function (element, index) {
              element.StartDate = moment(element.BusinessStartDate).format('YYYY-MM-DD');
              element.EndDate = moment(element.BusinessEndDate).format('YYYY-MM-DD');
              if (isNullOrEmpty(element.BPId)) {
                element.BPId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
              }
              vm.data.BusinessProductList.splice(index, 1, element);
            });
          }

          newParam = angular.copy(vm.data);
          
          av.confirm("Menu.UPDATECONFIRM", function(){
            av.commit(function(result){
              
              compareMaps(oldParam, newParam);
              
              av.alert('Menu.UPDATED', function(){
                $state.go('app.business.business-op-list', {}, {reload: 'app.business.business-op-list'});
              });
            });
          });
        }
      }

      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';

        if (isNullOrEmpty(vm.data.ClientId)) {
          errMsg = errMsg + '- 고객사를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.BusinessOPNm)) {
          errMsg = errMsg + '- 사업기회명를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.ProgressStep)) {
          errMsg = errMsg + '- 진행단계를 선택해 주세요.<br/>';
        }
        
        // 계약구분(성공)일 경우 실제종료일 필수
        if (vm.data.ContractType == '20'  && isNullOrEmpty(vm.data.RealEndDate)) {
          errMsg = errMsg + '- 실제종료일을 입력해 주세요.<br/>';
        }

        for (var i = 0; i < vm.BusinessProductList.length;  i++) {
          if (isNullOrEmpty(vm.BusinessProductList[i].BusinessId)) {
            errMsg = errMsg + '- 사업을 선택해 주세요.<br/>';
            break;
          }
          if (isNullOrEmpty(vm.BusinessProductList[i].BusinessStartDate)) {
            errMsg = errMsg + '- 사업 시작일을 확인해 주세요.<br/>';
            break;
          }
          if (isNullOrEmpty(vm.BusinessProductList[i].BusinessEndDate) || vm.BusinessProductList[i].BusinessStartDate > vm.BusinessProductList[i].BusinessEndDate) {
            errMsg = errMsg + '- 사업 종료일을 확인해 주세요.<br/>';
            break;
          }
          if (isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
            errMsg = errMsg + '- 사업 예상매출을 확인해 주세요.<br/>';
            break;
          }
        }
        
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn =  false;
        }

        return bRtn;
      }

      // 변경이력 저장
      function compareMaps(oldParam, newParam) {
        var histData = {};

        var keys = Object.keys(newParam);

        var list = [];

        for (var i = 0; i < keys.length; i++) {
          if (oldParam[keys[i]] != vm.data[keys[i]]) {
            var item = {};
            if (keys[i] == 'RegDate' || keys[i] == "ExEndDate" || keys[i] == "RealEndDate" || keys[i] == "ContractStartDate" || keys[i] == "ContractEndDate") {
              var beforeDate = oldParam[keys[i]];
              beforeDate = isNullOrEmpty(beforeDate) ? '추가' : moment(beforeDate).format("YYYY-MM-DD");
              var afterDate = moment(vm.data[keys[i]].format("YYYY-MM-DD"))._i;

              item.BeforeVal = beforeDate;
              item.AfterVal = afterDate;
              item.ColNm = keys[i];

              list.push(item);
            } else if (keys[i] == 'CustList') {
              var oldIdList = [];
              var oldNameList = [];
              var newIdList = [];
              var newNameList = [];
              
              angular.forEach(oldParam[keys[i]], function (item) {
                oldIdList.push(item.CustId);
                oldNameList.push(item.CustNm);
              });
              angular.forEach(vm.data[keys[i]], function (item) {
                newIdList.push(item.CustId);
                newNameList.push(item.CustNm);
              });

              var diff1 = $(oldIdList).not(newIdList).get();
              var diff2 = $(newIdList).not(oldIdList).get();
              var sum = diff1.concat(diff2);

              if (sum.length > 0) {
                item.BeforeVal = oldNameList.join(', ');
                item.AfterVal = newNameList.join(', ');
                item.ColNm = keys[i];

                list.push(item);
              }
            } else if (keys[i] == 'ManagerList') {
              var oldIdList = [];
              var oldNameList = [];
              var newIdList = [];
              var newNameList = [];

              angular.forEach(oldParam[keys[i]], function (item) {
                oldIdList.push(item.ManagerId);
                oldNameList.push(item.ManagerNm);
              });
              angular.forEach(vm.data[keys[i]], function (item) {
                newIdList.push(item.ManagerId);
                newNameList.push(item.ManagerNm);
              });

              var diff1 = $(oldIdList).not(newIdList).get();
              var diff2 = $(newIdList).not(oldIdList).get();
              var sum = diff1.concat(diff2)

              if (sum.length > 0) {
                item.BeforeVal = oldNameList.join(', ');
                item.AfterVal = newNameList.join(', ');
                item.ColNm = keys[i];

                list.push(item);
              }
            } else if (keys[i] == 'RemindAlarmList') {
            } else if (keys[i] == 'BusinessProductList') {
            } else {
              if (keys[i] != "CustNm" || keys[i] != "ManagerNm") {
                item.BeforeVal = isNullOrEmpty(oldParam[keys[i]]) ? '추가' : oldParam[keys[i]];
                item.AfterVal = vm.data[keys[i]];
                item.ColNm = keys[i];

                list.push(item);
              }
            }
          }
        }        
        
        histData.newList = list; 
        histData.KeyId = vm.data.KeyId;
        histData.mapcode = "BusinessOP.insertBusinessOPUpdateHist";
        
        if (histData.newList.length > 0) {
          postApi.insert(histData, function(result) {
          },function(error) {
            console.table(error);
          }); 
        }
      }

      function copyData() {
        av.confirm("기존 내용 미 저장 시 기존 사업기회 내용이 복제됩니다.</br>복제하시겠습니까?</br>(단, 리마인드알림설정은 복제되지 않습니다.)",
          function () {
            var ctrl = 'BusinessOpModalCtrl as vc';
            var paramData = { KeyId: vm.data.KeyId, CopyYN: 'Y' };
            var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData)

            
            modalInstance.result.then(
              function (res) {
                $state.go('app.business.business-op-detail', {KeyId : res.KeyId});
              },
              function (cancelData) { }
            );
          }, function () {
          }
        );
      }
      
      function onReadyAutoView() {
        // 초기 데이터 설정
        vm.data.CustList =[];
        vm.data.ManagerList =[];
        vm.data.RemindAlarmList = [];

        setLayout(vm.layout); // 화면분할 모드 설정
        setCust(); // 고객
        setManager(); // 영업담당자
        setRemindAlarm(); // 리마인드알림
        setBusinessProduct(); // 사업정보

        vm.data.exProgressStep = vm.data.ProgressStep;

        // 진행단계
        postApi.select({mapCode : 'BusinessOP.getProgressStep'}, 
        function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.progressStep = result.body.docs;

            setStepWidthSize($(window).width());
            $(window).resize(function(){
              vm.contentSize = angular.element("#form").width();
              setStepWidthSize($(this).width());
            });
          }
        });


        // 변경이력 사용함으로 인한 초기값 저장
        oldParam = angular.copy(vm.data);
        
        if (vm.data.TBDCnt > 0) {
          for(var i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_DR') {
              vm.tabList[i].Text = "영업일지(" + vm.data.TBDCnt + ')';
            }
          }
        }
        if (vm.data.TBCCnt > 0) {
          for(var i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_CUSTOMER') {
              vm.tabList[i].Text = "고객(" + vm.data.TBCCnt + ')';
            }
          }
        }
        if (vm.data.THFCnt > 0) {
          for(var i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_HIST') {
              vm.tabList[i].Text = "변경이력(" + vm.data.THFCnt + ')';
            }
          }
        }
        if (vm.data.TACnt > 0) {
          for(var i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_FILES') {
              vm.tabList[i].Text = "관련파일(" + vm.data.TACnt + ')';
            }
          }
        }
        if (vm.data.TBCMCnt > 0) {
          for(var i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_COMM') {
              vm.tabList[i].Text = "의견공유(" + vm.data.TBCMCnt + ')';
            }
          }
        }
      }

      // 진행단계 size설정
      function setStepWidthSize(_w) {
        var cw, swmwr, len = vm.progressStep.length;
        cw = "99%";        // 기본 진행단계별 사이즈
        swmwr = "100%";

        vm.stepWidthRatio = cw;

        $timeout(function(){
          cw = 100 / len;
          cw = cw + '%';

          vm.stepWidthRatio  = cw ;
        });
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      vm.setData = setData;
      vm.copyData = copyData;
      vm.goList = goList;

      vm.setCustCode = setCustCode;
      vm.addCust = addCust;
      vm.delCust = delCust;
      vm.setManagerCode = setManagerCode;
      vm.delManager = delManager;

      vm.setBusinessCode = setBusinessCode;
      vm.setTotalSales = setTotalSales;
      vm.addRow = addRow;
      vm.delRow = delRow;

      vm.editItem = editItem;
      vm.deleteItem = deleteItem;

      vm.setChangeTab = setChangeTab;
      vm.setChangeTabPosition = setChangeTabPosition;
      vm.setLayout = setLayout;
      vm.setChangeLayout = setChangeLayout;
          
      var av = new autoView();
      av.init(autoViewOption);
    }]);
})();

(function () {
  "use strict";

  webapp.controller('BusinessOpFlowCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window', 'modalFactory', '$timeout', 'gConfirm', 'gAlert',
    function BusinessOpFlowCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window, modalFactory, $timeout, gConfirm, gAlert) {

      var vm = this;

      vm.stepDataTree = {}; // Step 별 데이터 저장 공간
      vm.stepStateData = {}; // Step 별 데이터 저장 공간
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.stepWidthRatio = "25%";         // 스텝별 가로 사이즈
      vm.stepWidthMinRadio  = "25%";     // 스텝별 가로 최소 사이즈
      vm.stepWrapMinWidthRatio = "100%"; // 스텝 Wrap의 최소 사이즈
      vm.contentSize = angular.element("#form").width();

      vm.view = {
        VIEW_PAGE_LIST : 'app.business.business-op-list', // 목록형
        VIEW_PAGE_FLOW : 'app.business.business-op-flow', // 플로우형
      };
      
      function setChangeTab(view) {
        vm.page = vm.view[view];
        $state.go(vm.page, {
          srch : ''
        });
      }
      vm.headerTitle = "사업기회 목록 - 플로우형";
      vm.listOptions = {
        addColumn : {
        },
        html : {
        },

        addColumnClass : {
        },

        addRowClass : {
        },

        ngIf : {
        }
      };

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_BUSINESSOP",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          // initSelectCnt : { mapCode : "BusinessOP.getBusinessOPListCnt"},
          initSelect : { mapCode : "BusinessOP.getBusinessOPListByFlow", param : null },
        },

        addSrchStack : true,

        // List
        listCheckboxEnable : false,
        
        src : {
          // detail : "app.business.business-op-detail",
        },

        addForm : {
        },
        
        addFormGroup : {
        },
  
        customCodes : {
        },

        srchDateType : {
        }
      };

      
      // 사업기회 등록 팝업창
      vm.busiWriteModal = function () {
        var ctrl = 'BusinessOpModalCtrl as vc';
        var paramData = {};
  
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
        }, function (cancelData) {
          // cancel버튼
        });
      };

      //#region Soterble
      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          // console.log(sourceItemHandleScope, destSortableScope, destItemScope)
          angular.element(".progress-step-bottom").css("display","block");
          return true;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          // console.log('source', source)

          // console.log("일반 :", vm.stepDataTree);
          // console.log("보류 :", vm.stepStateData['postpone']);
          // console.log("성공 :", vm.stepStateData['success']);
          // console.log("실패 :", vm.stepStateData['fail']);
          
          if (vm.stepStateData['postpone'].length > 0 || vm.stepStateData['success'].length > 0 || vm.stepStateData['fail'].length > 0) {
            if (vm.stepStateData['postpone'].length > 0) {
              vm.stepStateData.postpone = [];
              vm.stepStateData.success = [];
              vm.stepStateData.fail = [];
              setStatePosition(eventObj.source.itemScope.modelValue.KeyId, '10');
              return;
            } else if (vm.stepStateData['success'].length > 0) {
              vm.stepStateData.postpone = [];
              vm.stepStateData.success = [];
              vm.stepStateData.fail = [];
              setStatePosition(eventObj.source.itemScope.modelValue.KeyId, '20');
              return;
            } else if (vm.stepStateData['fail'].length > 0) {
              vm.stepStateData.postpone = [];
              vm.stepStateData.success = [];
              vm.stepStateData.fail = [];
              setStatePosition(eventObj.source.itemScope.modelValue.KeyId, '30');
              return;
            }
          }
          angular.element(".progress-step-bottom").css("display","none");
          setTabPosition(eventObj.source.itemScope.modelValue.KeyId, eventObj.dest.sortableScope.$parent.stepKey);
        },
      };

      /** @description Step, List를 통한 데이터 변한 기능**/
      function makeSortableData() {

        // Data 구조
        // stepDataTree = {
        //   step10 : [
        //     {} ...
        //   ],
        //   step20 : [
        //     {} ...
        //   ],
        // }

        // console.log(vm.progressStep)

        vm.progressStep.forEach(function(item) {
          vm.stepDataTree["step" + item.Code] = [];
        });

        // AutoView에서 작업한 List 데이터
        vm.lists.forEach(function(item){
          
          // if(item.ProgressStep == "사전문의") item.ProgressStep = 10;
          // else if(item.ProgressStep == "미팅진행") item.ProgressStep = 20;
          // else if(item.ProgressStep == "입찰/제안") item.ProgressStep = 30;
          // else if(item.ProgressStep == "협상") item.ProgressStep = 40;
          // else if(item.ProgressStep == "계약완료") item.ProgressStep = 50;
          // else if(item.ProgressStep == "테스트") item.ProgressStep = 60;

          if (vm.stepDataTree["step" + item.ProgressStep]) {
            vm.stepDataTree["step" + item.ProgressStep].push(item);
          }
        });
        
        vm.stepDataTreeKeys = Object.keys(vm.stepDataTree);

        vm.stepStateData.postpone = [];
        vm.stepStateData.success = [];
        vm.stepStateData.fail = [];
      }
      //#endregion Sortble

      function setTabPosition(d1, d2) {
        var data = {};
        data.KeyId = d1;
        data.ProgressStep = d2.replace('step', '');

        data.mapCode = "BusinessOP.updateProgressStep";
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {}
        });
      }

      function setStatePosition(d1, d2) {
        var data = {};
        data.KeyId = d1;
        data.ContractType = d2;

        var ctrl = 'ChgContractTypeModalCtrl as vc';

        if (data.ContractType == '20') {
          var modalInstance = modalFactory.open('mf-15', 'app/business/modal/business-op/chg-contract-type-modal.html', ctrl, data);
          modalInstance.result.then(function (okData) {
            // ok버튼
            var srch = '';
            $state.go('app.business.business-op-flow', {srch:srch}, {reload:'app.business.business-op-flow'});
          }, function (cancelData) {
            // cancel버튼
          });
        } else {
          gConfirm('', '계약구분을 수정하시겠습니까?', {
            btn : '',
            fn : function() {
                data.mapCode = "BusinessOP.updateProgressStep";
                postApi.update(data, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    gAlert('', "수정되었습니다.", {
                      btn : '',
                      fn : function() {
                        var srch = '';
                        $state.go('app.business.business-op-flow', {srch:srch}, {reload:'app.business.business-op-flow'});
                      }
                    });
                  }
                });
              }
          },{
              btn : '',
              fn : function() {
            }
          });
        }
      }

      function goDetail(p) {
        $state.go('app.business.business-op-detail', {
          srch : '',
          KeyId : p,
        });
      }

      function setBtnCtrl(data, e) {
        e.stopPropagation();
        var ctrl = 'BusinessDrModalCtrl as vc';
        var paramData = { BusinessOPId: data.KeyId, BusinessOP: 'BusinessOP' };
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          $state.go('app.business.business-op-list', {srch:srch}, {reload:'app.business.business-op-list'});
        }, function (cancelData) {});
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      vm.setChangeTab = setChangeTab;
      vm.makeSortableData = makeSortableData;
      
      vm.goDetail = goDetail;
      vm.setBtnCtrl = setBtnCtrl;

      function onReadyAutoView() {
        vm.contentSize = angular.element("#form").width();
        vm.makeSortableData();
      }

      /** @description 화면 별 스탭 가로 사이즈 설정**/
      function setStepWidthSize(_w) {
        var cw, cmw, swmwr, len = vm.progressStep.length;
        cw = "400px";        // 스텝별 가로 사이즈
        cmw  = "400px";    // 스텝별 가로 최소 사이즈
        swmwr = "100%";

        // if (_w < 700) {
        //   cw = "400px";
        // } else {
        //   if (len == 1) {
        //     cw = "400px";
        //   } else if (len == 2 || len == 3 || len == 4) {
        //     cw = "25%";
        //   } else {
        //     cw = "400px";
        //   }
        // }
        
        vm.stepWidthRatio = cw;
        vm.stepWidthMinRadio  = cmw;
        $timeout(function(){
          if (cw.indexOf("px") > -1) {
            cw = parseInt(cw.replace("px","")) * len + 20;
            vm.stepWrapMinWidthRatio  = cw + "px";
          } else {
            cw = parseInt(cw.replace("%","")) / 100;
            vm.stepWrapMinWidthRatio  = ($("#form").width() * cw * len) + "px";
          }
        });
      }

      // 진행단계
      postApi.select({mapCode : 'BusinessOP.getProgressStep'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.progressStep = result.body.docs;

          setStepWidthSize($(window).width());
          $(window).resize(function(){
            vm.contentSize = angular.element("#form").width();
            setStepWidthSize($(this).width());
          });
          
          // 진행단계에 맞춰 작업하기 위해 AutoView를 이후에 작업
          var av = new autoView();
          av.init(autoViewOption);
        }
      });
    }]);
})();


(function () {
  "use strict";

  webapp.controller('BusinessOpListCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window', 'modalFactory', '$timeout',
    function BusinessOpListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window, modalFactory, $timeout) {

      var vm = this;

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.view = {
        VIEW_PAGE_LIST : 'app.business.business-op-list', // 목록형
        VIEW_PAGE_FLOW : 'app.business.business-op-flow', // 플로우형
      };

      function setChangeTab(view) {
        vm.page = vm.view[view];
        $state.go(vm.page, { 
          srch: ''
        });
      }
      
      vm.headerTitle = "사업기회 목록 - 목록형";
      var tempSpan = '<span class="list-progress-step" ng-style="{\'background\':li.ProgressStepColor}" ng-click="vc.chgProgressStep(li.KeyId, $event)">{{li.ProgressStep}}<span>';
      var tempBtn = '<button class="btn btn-default" ng-click="vc.setBtnCtrl(li, $event)"><i class="fa fa-briefcase"></i></button>';
      vm.listOptions = {
        addColumn : {
          ProgressStep : {
            title : "진행단계",
            after : "CustNms",
            template : tempSpan,
            size : "120px",
            textAlign : "center",
          },
          Action : {
            title : "영업일지",
            after : "ManagerNms",
            template : tempBtn,
            size : "120px",
            textAlign : "center",
          }
        },
        html : {
          // ProgressStep : {
          //   template : '<span class="list-progress-step">{{value}}<span>'
          // },
        },

        addColumnClass : {
        },

        addRowClass : {
        },

        ngIf : {
        }
      };

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_BUSINESSOP",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "BusinessOP.getBusinessOPListCnt", param : null },
          initSelect : { mapCode : "BusinessOP.getBusinessOPList", param : null, excelFileName: "사업기회목록"},
        },

        addSrchStack : true,

        // List
        listCheckboxEnable : true,
        
        src : {
          detail : "app.business.business-op-detail",
        },

        addForm : {
        },
        
        addFormGroup : {
        },

        customCodes : {
        },

        srchDateType : {
        }

      };

      function onReadyAutoView() {
      }

      // 진행단계 size설정
      function setStepWidthSize(_w) {
        var cw, swmwr, len = vm.progressStep.length;
        cw = "99%";        // 기본 진행단계별 사이즈
        swmwr = "100%";

        vm.stepWidthRatio = cw;

        $timeout(function(){
          cw = 100 / len;
          cw = cw + '%';

          vm.stepWidthRatio  = cw ;
        });
      }

      function setProgressStep(param) {
        vm.srch.ProgressStep = param;

        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('app.business.business-op-list', {srch:srch}, {reload:'app.business.business-op-list'});
      }

      // 사업기회 등록 팝업창
      vm.busiWriteModal = function () {
        var ctrl = 'BusinessOpModalCtrl as vc';
        var paramData = {};
  
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
        }, function (cancelData) {
          // cancel버튼
        });
      };

      vm.chgProgressStep = function(data, e) {
        e.stopPropagation();
        
        var ctrl = 'ChgProgressStepModalCtrl as vc';

        var modalInstance = modalFactory.open('mf-15', 'app/business/modal/business-op/chg-progress-step-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {
          // ok버튼
          var av = new autoView();
          av.init(autoViewOption);
        }, function (cancelData) {
          // cancel버튼
        });
      };

      //#region 목록 삭제
      function setDelList() {
        vm.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
          av.alert('Menu.DELETENODATA', function(){ });
          return false;
        }

        av.confirm("Menu.DELETECONFIRM", function () {
          var data = { mapCode: 'BusinessOP.deleteBusinessOPBatch', KeyIdList: vm.KeyIdList };
          postApi.update(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert('Menu.DELETED');
              var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
              $state.go('app.business.business-op-list', {srch:srch}, {reload:'app.business.business-op-list'})
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.log("error");
            // console.error("Error> setDelList()");
            // console.table(error);
          });
        }, function () {

        });
      }
      //#endregion 목록 삭제

      function setBtnCtrl(data, e) {
        e.stopPropagation();
        var ctrl = 'BusinessDrModalCtrl as vc';
        var paramData = { BusinessOPId: data.KeyId, BusinessOP: 'BusinessOP' };
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          $state.go('app.business.business-op-list', {srch:srch}, {reload:'app.business.business-op-list'});
        }, function (cancelData) {});
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      vm.setChangeTab = setChangeTab;
      vm.setProgressStep = setProgressStep;

      vm.setDelList = setDelList;
      vm.setBtnCtrl = setBtnCtrl;

      // 진행단계
      postApi.select({mapCode : 'BusinessOP.getProgressStep'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.progressStep = result.body.docs;

          setStepWidthSize($(window).width());
          $(window).resize(function(){
            vm.contentSize = angular.element("#form").width();
            setStepWidthSize($(this).width());
          });
          
          // 진행단계에 맞춰 작업하기 위해 AutoView를 이후에 작업
          var av = new autoView();
          av.init(autoViewOption);
        }
      });
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    $stateProvider.state('app.business', {
      url: '/business',
      template: '<div ui-view></div>',
    })
    // 사업기회 리스트(목록형)
    .state('app.business.business-op-list', {
      url: '/business-op-list?:srch',
      templateUrl: 'app/business/business-op-list.html',
      requiresAuthentication: true,
    })
    // 사업기회 리스트(플로우형))
    .state('app.business.business-op-flow', {
      url: '/business-op-flow?:srch',
      templateUrl: 'app/business/business-op-flow.html',
      requiresAuthentication: true,
    })
    // 사업기회 리스트(타임라인형)
    .state('app.business.business-op-line', {
      url: '/business-op-line?:srch',
      templateUrl: 'app/business/business-op-line.html',
      requiresAuthentication: true,
    })
    // 사업기회 상세
    .state('app.business.business-op-detail', {
      url: '/business-op-detail?srch/:KeyId',
      templateUrl: 'app/business/business-op-detail.html',
      requiresAuthentication: true,
    })
    // 사업기회 상세 - 싱글뷰영역
    // .state('app.business.business-op-tab-view', {
    //   url: '/business-op-tab-view?:srch/:KeyId',
    //   // url: '/business-op-tab-view?:srch',
    //   templateUrl: 'app/business/business-op-tab-view.html',
    //   requiresAuthentication: true,
    // })

    // 영업일지 리스트
    .state('app.business.business-dr-list', {
      url: '/business-dr-list?:srch',
      templateUrl: 'app/business/business-dr-list.html',
      requiresAuthentication: true,
    })

    // 회의View 리스트
    .state('app.business.business-meeting-view-list', {
      url: '/business-meeting-view-list?:srch',
      templateUrl: 'app/business/business-meeting-view-list.html',
      requiresAuthentication: true,
    })
    ;
  }
})();

(function() {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.calendar', {
      url : '/calendar',
      template : '<div ui-view></div>',
    })
    .state('app.calendar.mng-calendar', {
      url: '/mng-calendar',
      templateUrl: 'app/calendar/mng-calendar.html',
    })
    ;
  }
})();

/**
 * @ngdoc function
 * @name app.basic:mng-calendar-ctrl
 * @description # 캘린더 설정
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 */
 webapp.controller('MngCalendarCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
    function MngCalendarCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
     // View Model
      var vm = this;
      
      if ($stateParams.srch == null || $stateParams.srch == '') {
        vm.srch = {
          TargetYear : String((new Date()).getFullYear()),
          TargetMonth : (new Date()).getMonth() + 1 < 10 ? '0' + String((new Date()).getMonth() + 1) : String((new Date()).getMonth() + 1),
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.data = {};
      vm.getList = getList;
      vm.saveData = saveData;
      vm.getYearsList = getYearsList;
      vm.totalMonth = 12;
      vm.targetMonth = String((new Date()).getMonth() + 1);
      $scope.TargetMonth = vm.srch.TargetMonth;
      
      $scope.$watch('TargetMonth', function(current) {
        vm.srch.TargetMonth = current;
        getList();
      });
      
      function getList() {
        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        data.mapCode = 'Calendar.getCalendarList';
  
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data.lists = result.body.docs;
              vm.lists2 = [];
            
              var weeklyItem = {};
              var i = 0;
              angular.forEach(vm.data.lists, function(item) {
                switch (item.Day) {
                case '1':
                  weeklyItem = {};
                  weeklyItem.Sun = parseInt(item.Date);
                  weeklyItem.SunIndex = i;
                  break;
                case '2':
                  weeklyItem.Mon = parseInt(item.Date);
                  weeklyItem.MonIndex = i;
                  break;
                case '3':
                  weeklyItem.Tue = parseInt(item.Date);
                  weeklyItem.TueIndex = i;
                  break;
                case '4':
                  weeklyItem.Wed = parseInt(item.Date);
                  weeklyItem.WedIndex = i;
                  break;
                case '5':
                  weeklyItem.Thu = parseInt(item.Date);
                  weeklyItem.ThuIndex = i;
                  break;
                case '6':
                  weeklyItem.Fri = parseInt(item.Date);
                  weeklyItem.FriIndex = i;
                  break;
                case '7':
                  weeklyItem.Sat = parseInt(item.Date);
                  weeklyItem.SatIndex = i;
                  vm.lists2.push(weeklyItem);
                  weeklyItem = null;
                  break;
                }
                i++;   
              });
              if (weeklyItem != null)
                vm.lists2.push(weeklyItem);
              
              vm.data.TargetYear = vm.srch.TargetYear;
            } else {
              vm.totalItems = 0;
              vm.lists2 = [];
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', error);
          vm.dataloader = false;
        });     
      }
      
      function getYearsList() {
        vm.dataLoader = true;

        var data = {};
        data.mapCode = 'Calendar.getYearsList';

        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.yearsList = result.body.docs;

              if (parseInt(vm.yearsList[vm.yearsList.length - 1].TargetYear) < (new Date()).getFullYear() + 1) {
                vm.yearsList.push({TargetYear:(new Date()).getFullYear() + 1});
              }              
            } else {
              vm.yearsList = [{TargetYear:(new Date()).getFullYear()}, {TargetYear:(new Date()).getFullYear() + 1}];
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }
      
      function saveData() {
        vm.dataLoader = true;

        var data = angular.copy(vm.data);
        data.mapCode = 'Calendar.insertCalendarBatch';
  
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '저장되었습니다', {
              btn : '',
              fn : function() {
              }
            });
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }

      getList();
      getYearsList();
    }, ]);

(function () {
  "use strict";
  webapp.controller('CampaignListCtrl', ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', 'modalFactory',
    function CampaignListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $state, modalFactory) {
      var vm = this;    
      vm.dataloader = true;
      
      // 담당자 목록 
      postApi.select({ mapCode: 'Campaign.getUserListCodes' }, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
        }
      }, function (error) {
        console.table(error);
      });  

      // 타이틀
      vm.headerTitle = "켐패인 목록";

      // 오토뷰 설정
      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn: true,

        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "TB_CAMPAIGNIMPL",
        keyIdNm: "keyId",
        alias: "vc",
        dataModelNm: "lists", // ex : vc.data = {}
        srchModelNm: "srch",
        srchTarget: "searchWrap",
        apis: {
          initSelectCnt: { mapCode: "Campaign.getCampaignListCnt", param: null },
          initSelect: { mapCode: "Campaign.getCampaignList", param: null },
        },

        addSrchStack: true,

        // List
        listCheckboxEnable: false,

        src: {
          detail: "app.campaign.campaign-edit",
          splitDetail: "app.campaign.campaign-list.edit"
        },

        addFormGroup: {
          SrchStartDate : { after : "Status", type : mElemTx.date,  bindKey : ["StartDateFrom", "StartDateTo"], label : "실행일시", addDivision : true, colSize : 2},
        },

        srchDateType : {
          StartDateFrom : "from",
          StartDateTo : "to"
        },

        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes: {
          ManagerId : "codeManager"
        }

      };

      // 오토뷰 콜백
      function onReadyAutoView() {
        vm.dataloader = false;
      }

      // 등록버튼 클릭이벤트
      vm.goAdd = function(type) {
        var ctrl = 'CampaignEditModalCtrl as vc';
        var paramData = {
          keyId: 0
        };

        modalFactory.open('mf-80', 'app/campaign/modal/campaign-edit-modal.html', ctrl, paramData);
      };
      
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);
    }]);      
})();
(function () {
    "use strict";
  
    webapp.config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider.state('app.campaign', {
        url: '/campaign',
        template: '<div ui-view></div>'
      })
      .state('app.campaign.campaign-list', {
        url: '/campaign-list/:srch',
        templateUrl: 'app/campaign/campaign-list.html',
        requiresAuthentication: true,
        resolve : {
          plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          } ],
        }
      })
      .state('app.campaign.cert-sms-list', {
        url: '/cert-sms-list/:srch',
        templateUrl: 'app/campaign/cert-sms-list.html',
        requiresAuthentication: true,
        resolve : {
          plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          } ],
        }
      })
      .state('app.campaign.cert-email-list', {
        url: '/cert-email-list/:srch',
        templateUrl: 'app/campaign/cert-email-list.html',
        requiresAuthentication: true,
        resolve : {
          plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          } ],
        }
      })
      ;
    }
  })();
  
(function () {
  "use strict";
  webapp.controller('CertEmailListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'autoView',
    function CertEmailListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, autoView) {
      var vm = this;
      var KEY_TABLE_NM = 'SendVerify.Email'; // 작업 테이블명

      // SQL Mapper Id 정의
      var LIST_SQL  = "SendVerify.getSendVerifyList";
      var LIST_CNT_SQL  = "SendVerify.getSendVerifyListCnt";
      
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          tableNm: KEY_TABLE_NM, // For CustomColumn and FileAttachment
          sortDirect: "",
          sortColumn: "",
          Type : 'E',
          selectType : "List"
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = KEY_TABLE_NM; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.srchList.searchColumns = {};
      vm.listSize = [10, 25, 50, 100];

      function getListCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          console.table(error);
        });  
      }

      function getList() {
        getListCnt();
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_SQL;
        vm.viewSize = vm.srch.viewSize;
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.table(error);
        });  
      }

      function setResponsive(dockMode) {
        var rows = vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];
  
        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if (item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 번호 변경시 데이터 조회 함수 호출
       * @param
       * @return
       * @author 이기훈
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.message.email-certifi-list",
          { srch: srch },
          { reload: "app.message.email-certifi-list" }
        );
      }

      function changeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch.viewSize;
        getSearch();
      }

      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.message.email-certifi-list",
          { srch: srch },
          { reload: "app.message.email-certifi-list" }
        );
      }
  
      function resetSearch() {
        $state.go(
          "app.message.email-certifi-list",
          { srch: "" },
          { reload: "app.message.email-certifi-list" }
        );
      }
      
      // 목록 삭제 확인
      function setDelData(li) {
        gConfirm('', '삭제하시겠습니까?', {
          btn : '',
          fn : function() {
            setDelDataAction(li);
          }
        }, {
          btn : '',
          fn : ''
        });
      }

      // 목록 삭제
      function setDelDataAction(li) {
        var data = angular.copy(li);
        data.mapCode = 'aws/deleteVerifyEmail';
        
        postApi.api(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '삭제되었습니다.', {
              btn : '',
              fn : getList()
            });
          } else {
            gAlert('', result.body.docs[0].errMessage);
            return;
          }
        }, function (error) {
          console.table(error);
        });  
      }

      // 이메일 인증 팝업
      function openEmailCertifiModal() {
        var ctrl = 'CertEmailModalCtrl as vc';
        var paramData = { };

        var modalInstance = modalFactory.open('md', 'app/campaign/modal/cert-email-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          getList();
        }, function (cancelData) {
        });
      }

      // 정렬 컬럼 설정
      function setSortColumn(sortColumn, isSortable) {
        if (isSortable == 'N') return;

        if (vm.srch.sortColumn != sortColumn) vm.srch.sortDirect = "ASC";
        else vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        getSearch();
      }

      // 정렬 컬럼 설정에 따른 Grid header Icon 표시
      function setSortDirect(sortColumn) {
        var rtnval = '';

        if (sortColumn != vm.srch.sortColumn) return 'fa fa-sort';      

        if (vm.srch.sortDirect == 'ASC') rtnval = 'fa fa-caret-down';
        else rtnval = 'fa fa-caret-up';

        return rtnval;
      }

      // 함수 연결
      vm.openEmailCertifiModal = openEmailCertifiModal;
      vm.pageChanged = pageChanged;
      vm.changeViewSize = changeViewSize;
      vm.getSearch = getSearch;
      vm.resetSearch = resetSearch;
      vm.setDelData = setDelData;

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      getList();

    }]);
})();

(function () {
  "use strict";
  webapp.controller('CertSmsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'autoView',
    function CertSmsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, autoView) {
      var vm = this;
      var KEY_TABLE_NM = 'SendVerify.Mobile'; // 작업 테이블명

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.data = {
        CertType : 'MOBILE',
        tableNm : KEY_TABLE_NM
      };

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendVerify.insertSendVerify';     // 등록 SQL
      var DELETE_LIST_SQL = 'SendVerify.deleteSendVerify'; // 목록에서 삭제

      // 함수 연결
      vm.setVerifyData = setVerifyData;
      vm.setDelList = setDelList;
      vm.dupChk = dupChk;

      // 오토뷰 설정
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : KEY_TABLE_NM,
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "SendVerify.getSendVerifyListCnt", param : {Type : 'M'} },
          initSelect : { mapCode : "SendVerify.getSendVerifyList", param : {Type : 'M'} },
        },

        // List
        listCheckboxEnable : true,
        
        src : {
        },
        
        addFormGroup : {
        },
  
        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes : {
          Manager : "codeManager"
          , RecommendItem : "codeRecommendItem"
        }
      };
    
      // 오토뷰 콜백
      function onReadyAutoView() {
      }

      // 중복 체크
      function dupChk() {
        var data = angular.copy(vm.data);
        data.mapCode = 'SendVerify.getSendDuplicateCnt';
  
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs > 0) {
              gAlert('','이미 등록된 번호 입니다.');
              return;
            } else {
              setVerifyData();
            }
          }
        });
      }
      
      // 숫자 2자리 채우기
      function setZero(val){
        return val > 10 ?  '' + val : '0' + val ;
      }      
      
      // 요청ID 생성      
      function setMerchantUID() {
        var d = new Date();
        var rndNum = Math.floor(10 + Math.random() * d.getTime());
        return "CID_" + (d.getFullYear() + "").substring(2, 4) + "" + setZero(d.getMonth() + 1) + "" + setZero(d.getDate()) + "" + setZero(d.getHours()) + "" + setZero(d.getMinutes()) + "_" + rndNum;;
      }      
      
      // 저장
      function setVerifyData() {
        
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendInfo)) {
          errMsg = errMsg + '-발송번호를 입력해 주세요.';
        }
        
        if(vm.data.CertType != 'MOBILE' ){
          if (isNullOrEmpty(vm.uploadFileList)) {
            errMsg = errMsg + '<br/>-첨부파일을 업로드 해주세요.';
          }
        }
        
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        if (vm.data.CertType =='MOBILE') {
          /*
           * 본인인증은 SSCRM용을 사용한다.
           */
          IMP.init("imp86263784"); 
          IMP.certification({ 
            merchant_uid: setMerchantUID()
            ,phone: vm.data.SendInfo         
          }, function (certifyResult) {
            console.table(certifyResult);
            
            if (certifyResult.success) {
              postApi.api('personalCertify', certifyResult, function (result) {
                setPaymentCertify(result);
              }, function (error) {
                console.log("error");
                // console.error("Error : personalCertify");
                // console.table(error);
              });
            } else {
              alert("본인인증에 실패하였습니다.(" + certifyResult.error_msg + ")");
            }
          });
          
        } else {
          var data = angular.copy(vm.data); // 검색 옵션 설정
          data.Type = 'M';
          data.mapCode = INSERT_SQL;
          
          data.uploadFileList = [];
          angular.forEach(vm.uploadFileList, function(item) {
            data.uploadFileList.push(item);
          });
          
          postApi.insert(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if ( result.body.docs[0].RelateDataId !== null ) {
                gAlert("", "Menu.SAVED", {
                  btn: "",
                  fn: function () {
                    vm.data = {
                      CertType : 'MOBILE',
                      tableNm : KEY_TABLE_NM
                    };
                    vm.showUploader = false;
                    vm.uploadFileList = [];
                    av.init(autoViewOption);
                  }
                });
                return;
              }
            }else{
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function (error) {
            console.log("error");
            // console.error("Error : personalCertify");
            // console.table(error);
          });
        }
      }
     
      // 저장 후처리
      function setPaymentCertify(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if ( result.body.docs[0].status ) {
            gAlert("발신번호가 인증되었습니다.");
            vm.data.SendInfo = '';
            av.init(autoViewOption);
          }else{
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              gAlert("발신번호가 중복되었습니다.");
            }else{
              gAlert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            return false;
          }
        }
      }

      // 목록 삭제 확인
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      // 목록 삭제
      function setDelListAction() {
        var data = {};
        data.mapCode = DELETE_LIST_SQL;
        data.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            data.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (data.KeyIdList == null || data.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                av.init(autoViewOption);
              }
            });
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }
      
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);
    }]);
})();
(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.chatting', {
      url : '/chatting',
      template : '<div ui-view></div>',
    }).state('app.chatting.h0201-roomlist', {
			url : '/h0201-roomlist?srch/:ChatUserId/:WorkerId',
			templateUrl : 'app/chatting/h0201-roomlist.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }]
      },
      cache: false,
		}).state('app.chatting.h0201-roomdetail', {
			url : '/h0201-roomdetail?srch/:FreeChatId',
			templateUrl : 'app/chatting/h0201-roomdetail.html',
			cache: false,
		}).state('app.chatting.h0201-roomedit', {
			url : '/h0201-roomedit?srch/:FreeChatId',
			templateUrl : 'app/chatting/h0201-roomedit.html',
		}).state('app.chatting.h0201-chat', {
			url : '/h0201-chat/:UserId',
			templateUrl : 'app/chatting/h0201-roomdetail.html',
		}).state('app.chatting.h0201-chatlist', {
			url : '/h0201-chatlist',
			templateUrl : 'app/chatting/h0201-chatlist.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }]
      }
		}).state('app.chatting.h0201-roomlist.edit', {
      url : '/edit/:FreeChatId',
      templateUrl : 'app/chatting/h0201-roomedit.html',
    }).state('app.chatting.h0201-roomlist.detail', {
      url : '/detail/:FreeChatId',
      templateUrl : 'app/chatting/h0201-roomdetail.html',
    });
  }
})();

(function() {
  'use strict';
webapp.service('H0201APISrv', [ '$resource', 'StaticVariable', '$rootScope', function H0201APISrv($resource, StaticVariable, $rootScope) {
    var h0201Api = {
      doListCnt : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChatCount.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doExcel : function() {
        return $resource(StaticVariable.getUrl('/excel/FreeChat.getExcelChatList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReadCnt : function() {
        return $resource(StaticVariable.getUrl('/update/FreeChat.updateChatReadCnt/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doFileList : function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doComment : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail : function() {
        return $resource(StaticVariable.getUrl('/insert/FreeChat.insertChatDetail/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile : function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doSaveComment : function() {
        return $resource(StaticVariable.getUrl('/insert/FreeChat.insertChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteComment : function() {
        return $resource(StaticVariable.getUrl('/update/FreeChat.deleteChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateComment : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateChatComment.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete : function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doCreateDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/createChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doViewDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/viewChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doList : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      updateReadFreeChatCommId : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateReadFreeChatCommId.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doDelete : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/leaveChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatListCnt : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getAllChatCommCount/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatList : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getAllChatCommList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatTaskCount : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChatTaskCount.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
    };
    return h0201Api;
  } ]);
})();

(function() {
  'use strict';

webapp.controller('H0201ChatListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    '$translate',
    'GLOBAL_CONSTANT',
    'H0201APISrv',
    function H0201ChatListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, h0201Api) {
      var vm = this;
      vm.dataloader = false;

      if ($stateParams.page == undefined || $stateParams.page == "") {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }

      vm.srch = {
        remark : '',
      };

      vm.listSize = [ 10, 25, 50, 100 ];

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.ChatId = '1';
      vm.srch.viewSize = vm.viewSize;
      vm.srch.AllMsg = 'Y';

      /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
      if ($window.sessionStorage.getItem('h0201-chatlist-ctrl') != null) {
        // console.log('H0201ListCtrl previousPage:', $rootScope.previousPage, '===', '/app/chatting/h0201-chatlist');
        if ($rootScope.previousPage != null
            && ($rootScope.previousPage.indexOf('/app/chatting/h0201-roomedit') !== -1 || $rootScope.previousPage.indexOf('/app/chatting/h0201-roomdetail') !== -1 || $rootScope.previousPage
                .indexOf('/app/chatting/h0201-chatlist') !== -1)) {
          vm.srch = JSON.parse($window.sessionStorage.getItem('h0201-chatlist-ctrl'));
          vm.currentPage = vm.srch.page;
        }
      }

      $scope.showDetail = function(li) {
        $location.url('/' + li.ntcIdx);
      };

      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.getListCnt = getListCnt;
      vm.changeViewSize = changeViewSize;
      vm.getExcel = getExcel;

      function pageChanged() {
        // console.log('vm.currentPage=', vm.currentPage, ',vm.srch.page=', vm.srch.page);
        // $state.go("app.h0201.roomlist");
        vm.srch.page = vm.currentPage;
        getList();
        // $location.path('/app/chatting/h0201-roomlist/' +
        // vm.srch.ChatId + "/" + vm.currentPage, false);
      }

      function getListCnt() {

        var prms = h0201Api.doChatListCnt().post(vm.srch).$promise;

        prms.then(

        function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = data.responseVO.body.docs[0];
          }
        },

        function(error) {
          console.log("error");
          // console.error('fail', status, data);
        });
      }

      function getList() {
        vm.viewSize = vm.srch.viewSize;

        getListCnt();

        $window.sessionStorage.setItem("h0201-chatlist-ctrl", angular.toJson(vm.srch));

        vm.dataloader = true;
        var prms = h0201Api.doChatList().post(vm.srch).$promise;

        prms.then(

        function(data) {
          vm.dataloader = false;
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = getContentsData(data.responseVO.body.docs);
          }
        },

        function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        });
      }

      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            veg.Contents = json.UserNm + ' ' + $translate.instant(json.Message);
          }

          return veg;
        });
      }

      function getExcel() {

        vm.excel.param = vm.srch;

        var prms = h0201Api.doExcel().post(vm.excel).$promise;

        prms.then(

        function(data) {
        },

        function(error) {
          console.log("error");
          // console.error('fail', status, data);
        });

      }

      getList();
    } ]);
})();

(function() {
  'use strict';

webapp.directive('enterSubmit', function () {
  return {
    restrict: 'A',
    link: function (scope, elem, attrs) {

      elem.bind('keydown', function(event) {
        var code = event.keyCode || event.which;

        if (code === 13) {
          if (!event.shiftKey) {
            event.preventDefault();
            scope.$apply(attrs.enterSubmit);
          }
        }
      });
    }
  };
});

webapp.controller('H0201RoomDetailCtrl', ['$window', '$scope', '$rootScope', '$location', '$state', '$stateParams', '$translate', '$timeout', '$anchorScroll', 'GLOBAL_CONSTANT', 'StaticVariable',
    'postApi', 'gAlert', 'gConfirm', 'fileUploadService',
    function H0201DetailCtrl($window, $scope, $rootScope, $location, $state, $stateParams, $translate, $timeout, $anchorScroll, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, fileUploadService) {
      var vm = this;
      vm.dataloader = false;

      vm.page = $stateParams.page;
      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.srch = {
        UserId : $stateParams.UserId,
        FreeChatId : $stateParams.FreeChatId,
        IdName : 'FreeChatId',
        tableNm : 'freechat',
        ChatId : '1',
        uploadFileList : [],
      };
      //console.log("detail load vm.srch", vm.srch);
      vm.comment = {};

      vm.srchComment = {
        FreeChatId : $stateParams.FreeChatId,
        tableNm : "freechatcomm",
        viewSize : 10,
        ChatId : '1',
      };

      vm.items = [ {
        name : 'Share',
        icon : 'zmdi zmdi-share'
      }, {
        name : 'Upload',
        icon : 'zmdi zmdi-upload'
      }, {
        name : 'Copy',
        icon : 'zmdi zmdi-copy'
      }, {
        name : 'Print this page',
        icon : 'zmdi zmdi-print'
      } ];

      var id = 0;

      vm.data = {};
      vm.uploadFileList = [];
      vm.uploadFileListComment = [];

      vm.saveDetail = saveDetail;
      vm.getDetail = getDetail;
      vm.updateReadCnt = updateReadCnt;
      vm.getFileList = getFileList;
      vm.getPrevComment = getPrevComment;
      vm.getNextComment = getNextComment;
      vm.getComment = getComment;
      vm.editDetail = editDetail;
      vm.deleteDetail = deleteDetail;
      vm.deleteDetailAction = deleteDetailAction;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.deleteCommentAction = deleteCommentAction;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.ngRepeatFinished = ngRepeatFinished;
      vm.goList = goList;

      if (vm.srch.FreeChatId != null) {
        // console.log('vm.srch.FreeChatId=', vm.srch.FreeChatId);
        getDetail();
        getComment(true);
        getCommentCnt(true);
      } else if (vm.srch.UserId != null) {
        // console.log('vm.srch.UserId=', vm.srch.UserId);
        saveDetail();
        return;
      }

      function saveDetail() {
        vm.data = {};
        vm.data.ChatId = 1;
        vm.data.Title = '대화';
        vm.data.Participants = ':' + $window.sessionStorage['loginUserIdx'] + '::' + vm.srch.UserId + ':';
        vm.data.tableNm = 'freechat';
        vm.data.IdName = 'FreeChatId';
        if ($window.sessionStorage['loginUserIdx'] != vm.srch.UserId) {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx']
          }, {
            UserId : vm.srch.UserId
          } ];
        } else {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx']
          } ];
        }

        //console.log("vm.uploadFileList", vm.uploadFileList);
        vm.dataloader = true;

        postApi.sendPostApi('api/freechat', 'createChat', vm.data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docCnt > 0) {
                if (data.responseVO.body.docCnt == 1) {
                  vm.srch.FreeChatId = result.body.docs[0].FreeChatId;
                  vm.srchComment.FreeChatId = vm.srch.FreeChatId;

                  getDetail();
                  getComment(true);
                  return;
                } else {
                  $state.go('app.chatting.h0201-roomlist', {
                    ChatUserId : vm.srch.UserId
                  });
                }
              }
            }

            gAlert('', data.responseVO.body.docs[0].errMessage);
          },
          function(error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('fail', error);
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        );
      }

      function getDetail() {
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx'],
            LoginId : $window.sessionStorage['loginUserId'],
            UserNm : $window.sessionStorage['loginUserName']
          } ];
          return;
        }

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        postApi.sendPostApi('api/freechat', 'viewChat', data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatId != null) {
                vm.data = result.body.docs[0];

                var uploadFileList = [];
                angular.forEach(vm.data.uploadFileList, function(item) {
                  var obj = {
                    id : item.fileId,
                    isLoaded : true,
                    link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                    fileName : item.LogicalFileNm,
                    size : item.FileSize,
                    fileKey : item.PhysicalFileNm,
                    typeId : 'file',
                    path : item.PhysicalPath,
                    downloadCnt : item.DownloadCnt,
                    delState : '',
                  };
                  uploadFileList.push(obj);
                });
                angular.copy(uploadFileList, vm.data.uploadFileList);

                //console.log('uploadFileList', vm.data.uploadFileList);

                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      function updateReadCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = 'FreeChat.updateChatReadCnt';
        postApi.update(data, function(result) {}, function(error) {});
      }

      // 사용하지 않음
      function getFileList() {

        vm.srch.tableNm = 'freechat';
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          return;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {

              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }
          },
          function(result) {
            console.log("error");
            // console.error('fail', status, result);
            gAlert('알림', result.body.docs[0].errMessage);
          }
        );
      }

      vm.openMenu = openMenu;
      var originatorEv;
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      function editDetail() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.chatting.h0201-roomedit', {
            srch : srch, FreeChatId : vm.srch.FreeChatId
          });
        } else {
          $state.go('app.chatting.h0201-roomlist.edit', {
            srch : srch, FreeChatId : vm.srch.FreeChatId
          });
        }
      }

      function deleteDetail() {
        gConfirm('', 'Menu.WANTTOLEAVETHEROOM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTLEAVETHEROOM');
          return;
        }
        var uploadFileList = [];
        angular.forEach(vm.data.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);

        });
        vm.data.uploadFileList = uploadFileList;

        postApi.sendPostApi('api/freechat', 'leaveChat', vm.data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.LEFTTHEROOM', {
                btn : '',
                fn : function() {
                  $state.go('app.chatting.h0201-roomlist', {
                    ChatUserId : 0
                  });
                }
              });
              return;
            }
          },
          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      };

      function getPrevComment() {
        vm.srchComment.FirstId = vm.FirstId;
        vm.srchComment.LastId = null;
        vm.srchComment.viewSize = 10;
        //console.log('getPrevComment() ===');
        getComment(true);
      }

      function getNextComment(showLoading) {
        vm.srchComment.FirstId = null;
        vm.srchComment.LastId = vm.LastId;
        vm.srchComment.viewSize = 100;
        //console.log('getNextComment() ===');
        getComment(showLoading);
      }

      function getComment(showLoading) {
        //console.log("getComment(ShowLoading) ===");

        vm.dataloader = showLoading & true;

        var data = angular.copy(vm.srchComment);
        data.mapCode = 'FreeChat.getChatComment';

        postApi.select(data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                if (vm.comment.lists == null)
                  vm.comment.lists = getContentsData(result.body.docs);
                else {
                  if (vm.srchComment.FirstId) {
                    angular.forEach(getContentsData(result.body.docs), function(item) {
                      vm.comment.lists.unshift(item);
                    });
                  } else {
                    vm.comment.lists.append(getContentsData(result.body.docs));
                  }
                }

                if (vm.srchComment.FirstId == null) {
                  $timeout(function() {
                    var old = $location.hash();
                    $location.hash('bottom');
                    $anchorScroll();
                    $location.hash(old);
                  }, 0);
                }

                if (vm.srchComment.FirstId == null) {
                  if (vm.FirstId == null) {
                    vm.FirstId = result.body.docs[0].FreeChatCommId;
                  }
                  vm.LastId = result.body.docs[result.body.docs.length - 1].FreeChatCommId;
                } else {
                  vm.FirstId = result.body.docs[result.body.docs.length - 1].FreeChatCommId;
                }

                vm.srchComment.FirstId = vm.FirstId;
                vm.srchComment.LastId = vm.LastId;

                postApi.sendPostApi('api/freechat', 'updateReadFreeChatCommId', vm.srchComment,
                  function(result) {
                    if (result.header.status == CONSTANT.HttpStatus.OK) {
                      $rootScope.gVariable.totalItemChatComm = result.body.docs[0].ChatCount;
                      $rootScope.gVariable.totalItemTaskComm = result.body.docs[0].TaskCount;
                      $rootScope.gVariable.totalItemNotiComm = result.body.docs[0].NotiCount;
                      $rootScope.gVariable.totalItemComm = parseInt($rootScope.gVariable.totalItemChatComm) + parseInt($rootScope.gVariable.totalItemTaskComm);
                    }
                  },
                  function(error) {
                    vm.dataloader = false;
                    console.log("error");
                    // console.error('fail', error);
                  }
                );
              }
            }
          },
          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage, {
              btn : '',
              fn : function() {
                $state.go('app.chatting.h0201-roomlist', {
                  ChatUserId : 0
                });
              }
            });
          }
        );
      }

      function getCommentCnt(showLoading) {
        var data = angular.copy(vm.srchComment);
        data.mapCode = 'FreeChat.getChatCommentCnt';

        postApi.select(data,
          function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.totalItems = result.body.docs[0];
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
            //console.log('vm.totalItems', vm.totalItems);
          },
          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage, {
              btn : '',
              fn : function() {
                $state.go('app.chatting.h0201-roomlist', {
                  ChatUserId : 0
                });
              }
            });
          }
        );
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            if (json.UserNm != '')
              veg.Contents = json.UserNm + ' ' + getMessageData(json.Message);
            else
              veg.Contents = getMessageData(json.Message);
          }

          return veg;
        });
      }

      function getMessageData(message) {
        var arg = message.split('|');
        var result = '';

        angular.forEach(arg, function(item) {
          result = result + $translate.instant(item) + " ";
        });

        return result;
      }

      function getWorkerNm(WorkerId) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            veg.Contents = json.UserNm + ' ' + $translate.instant(json.Message);
          }

          return veg;
        });
      }

      function saveComment() {
        //var msg = $("#emoji").data("emojioneArea").getText();
        var data = angular.copy(vm.srchComment);
        data.Contents = $("#emoji").data("emojioneArea").getText().trim();
        if ((data.Contents == null || data.Contents == '') && vm.uploadFileListComment.length == 0) {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        data.FreeChatType = 'M';
        data.IdName = "FreeChatCommId";
        data.uploadFileList = vm.uploadFileListComment;
        data.mapCode = 'FreeChat.insertChatCommentBatch';

        postApi.insert(data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.srchComment.WorkerId = '';
                vm.srchComment.Contents = '';
                vm.srchComment.uploadFileList = [];
                vm.uploadFileListComment = [];

                vm.send();

                getNextComment(false);

                // data.FreeChatCommId = result.body.docs[0].FreeChatCommId;
                // postApi.sendPostApi('api/freechat', 'updateReadFreeChatCommId', data,
                //   function(result) {
                //     if (result.header.status == CONSTANT.HttpStatus.OK) {
                //       $rootScope.gVariable.totalItemChatComm = result.body.docs[0].ChatCount;
                //       $rootScope.gVariable.totalItemTaskComm = result.body.docs[0].TaskCount;
                //       $rootScope.gVariable.totalItemNotiComm = result.body.docs[0].NotiCount;
                //       $rootScope.gVariable.totalItemComm = parseInt($rootScope.gVariable.totalItemChatComm) + parseInt($rootScope.gVariable.totalItemTaskComm);
                //     }
                //   },
                //   function(error) {
                //     vm.dataloader = false;
                //     console.error('fail', error);
                //   }
                // );
                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
        $("#emoji").data("emojioneArea").setText('');
      }

      vm.setDeleteFileToggle = setDeleteFileToggle;
      function setDeleteFileToggle(commentObj) {
        //console.log("deleteComment File");

        var idx = -1;
        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == commentObj) {
            idx = key;
            return;
          }
        });
        if (vm.comment.lists[idx].delState == '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      function deleteComment(commentObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(commentObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteCommentAction(commentObj) {

        var srch = {
          FreeChatCommId : commentObj.FreeChatCommId,
          TableNm : "FreeChatComm",
          IdName : "FreeChatCommId",
        };

        if (commentObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : commentObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable
                .getUrl('/attach/file/' + commentObj.PhysicalFileNm + '/download.do?path=' + commentObj.PhysicalFolderNm + '&fileName=' + commentObj.LogicalFileNm),
            fileName : commentObj.LogicalFileNm,
            size : commentObj.FileSize,
            fileKey : commentObj.PhysicalFileNm,
            path : commentObj.PhysicalFolderNm,
            downloadCnt : commentObj.DownloadCnt,
            delState : "delete",
            typeId : "file",
          };
          uploadFileList.push(obj);

          // console.log("deleteComment File", uploadFileList);
          srch['uploadFileList'] = uploadFileList;
        }

        srch.mapCode = 'FreeChat.deleteChatComment';
        postApi.update(srch,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.comment.lists.forEach(function(item, index, object) {
                  if (item.FreeChatCommId == commentObj.FreeChatCommId) {
                    item.Contents = "MSG.DELETEDCONTENT";
                    item.LogicalFileNm = "";
                    item.PhysicalFileNm = "";
                    item.DelYN = "Y";
                  }
                });
                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.log("error");
            // console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      function editComment(FreeChatCommId) {
        // console.log("editComment");

        vm.comment.editid = FreeChatCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.FreeChatCommId == FreeChatCommId) {
            vm.comment.WorkerId = item.WorkerId;
            vm.comment.editContents = item.Contents;
          }
        });
      }

      function editCommentAction(commentObj) {

        var srch = {
          FreeChatCommId : commentObj.FreeChatCommId,
          FreeChatId : vm.srchComment.FreeChatId,
          WorkerId : vm.comment.WorkerId,
          Contents : vm.comment.editContents,
          TableNm : "FreeChatComm",
          IdName : "FreeChatCommId",
        };

        if (commentObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : commentObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable
                .getUrl('/attach/file/' + commentObj.PhysicalFileNm + '/download.do?path=' + commentObj.PhysicalFolderNm + '&fileName=' + commentObj.LogicalFileNm),
            fileName : commentObj.LogicalFileNm,
            size : commentObj.FileSize,
            fileKey : commentObj.PhysicalFileNm,
            path : commentObj.PhysicalFolderNm,
            downloadCnt : commentObj.DownloadCnt,
            delState : commentObj.delState,
            typeId : "file",
          };
          uploadFileList.push(obj);

          // console.log("editComment File", uploadFileList);
          srch['uploadFileList'] = uploadFileList;
        }

        // console.log("edit comment", srch);
        postApi.sendPostApi('api/freechat', 'updateChatComment', srch,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.comment.lists.forEach(function(item, index, object) {
                  if (item.FreeChatCommId == commentObj.FreeChatCommId) {
                    item.WorkerId = result.body.docs[0].WorkerId;
                    item.WorkerNm = result.body.docs[0].WorkerNm;
                    item.Contents = result.body.docs[0].Contents;
                    vm.comment.editid = null;

                    if (item.delState == "delete") {
                      item.AttachmentId = '';
                      item.PhysicalFileNm = '';
                      item.PhysicalFolderNm = '';
                      item.LogicalFileNm = '';
                      item.FileSize = '';
                      item.DownloadCnt = '';
                      item.delState = '';
                      item.WorkerId = '';
                      item.WorkerNm = '';
                    }
                  }
                });

                return;
              }
            }

            gAlert('', data.responseVO.body.docs[0].errMessage);
          },

          function(data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        );
      }

      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      function goList() {
        $state.go('app.chatting.h0201-roomlist', {srch: $stateParams.srch, ChatUserId: '', WorkerId: ''}, {reload:'app.chatting.h0201-roomlist'});
      }

      vm.openDilalog = openDilalog;
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      function uploadFiles(files) {
        // console.log('uploadFiles', vm.uploadFileListComment);
        var tempIds = [];
        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;
          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : id,
                delState : ''
              };
              tempIds.push(obj);
              vm.uploadFileListComment.push(angular.copy(obj));
              id++;
            }
          });
          // console.log("fu", vm.uploadFileListComment);
          if (hasZeroByteFile) {
            alert('빈 파일이 있습니다.');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              // console.log('progress percent::', percent);
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });
            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListComment, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.fileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                    // console.log("obj.link", obj.link);
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              // console.log('file items::', vm.uploadFileListComment);

              vm.showLoading = false;
            }, function(reason) {
            });
          } catch (err) {
          }
        });
      }

      function ngRepeatFinished() {
        // console.log('ngRepeatFinished');
      }

      vm.onDelete = onDelete;
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListComment, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListComment[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete({
              attachId : vm.uploadFileListComment[idx].fileKey
            }, function(data) {
              vm.uploadFileListComment.splice(idx, 1);
            }, function(error) {
              console.log("error");
              // console.error('fail', error);
            });
          } else if (vm.callback) {
            vm.uploadFileListComment[idx].delState = 'delete';
          }
        }
      }

      vm.onDeleteCancel = onDeleteCancel;
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListComment, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListComment[idx].delState = '';
        }
      }

      vm.openAttachment = function (li) {
        if (!li.PhysicalFileNm) return;

        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      };

      vm.serveraddr = CONSTANT.URL.API_SERVER_DOMAIN;

      var socket = null;
      var isopened = false;

//      document.addEventListener("DOMContentLoaded", function() {

      function start(serveraddr){
        if (window.WebSocket) {
            socket = new WebSocket("ws://" + serveraddr + ":19998/chat");
            socket.onmessage = function (event) {
              getNextComment(false);
              // $('#Content').after('<p>' + event.data + '</p>');
              // var json = JSON.parse(event.data);
              // console.log('json=', json);
            };
            socket.onopen = function (event) {
              isopened = true;
              var message = "{\"command\":\"freechat\",\"freechatid\":\"" + $stateParams.FreeChatId + "\"}";
              socket.send(message);
              $('#Content').after('<p>Web Socket opened!!!!!!</p>');
            };
            socket.onclose = function (event) {
              if (isopened == true) {
                $('#Content').after('<p>Web Socket closed!!!!!!</p>');
                setInterval(check, 3000);
              }

              isopened = false;
            };
        } else {
          $('#Content').after('Your browser does not support Websockets. (Use Chrome)');
        }
      }

      function check(){
        if(!socket || socket.readyState == 3) start(vm.serveraddr);
      }

      setTimeout(check, 1000);

//      });

      vm.reconnect = function () {
        socket.close();
      };

      vm.send = function () {
        if (!window.WebSocket) {
            return;
        }
        if (socket.readyState == WebSocket.OPEN) {
            socket.send(vm.message);
        } else {
          $('#Content').after('The socket is not open.');
        }
      };

      $scope.$on("$destroy", function() {
        socket.close();
      });

      /* $(document).ready(function() {
        $("#emoji").emojioneArea({
          shortcuts: false,
          events:
          {
            keypress: function(editor, event) {
              if (event.which === 13) {
                saveComment();
                event.preventDefault();
              }
            }
          }
        });
      }); */

      /* $(document).ready(function() {
        $("#emoji").emojioneArea({
            pickerPosition: "top",
            events: {
              keyup: function (editor, event) {
                if(event.which == 13){
                  if(event.shiftKey) {
                    // With shift
                  } else {
                    event.preventDefault();
                    saveComment();
                  }
                }
              }
            }
        });
      }); */
      $scope.$watch('$viewContentLoaded',
        function() {
          $timeout(function() {
            $("#emoji").emojioneArea({
              pickerPosition: "top",
              events: {
                keyup: function (editor, event) {
                  if(event.which == 13){
                    if(event.shiftKey) {
                      // With shift
                    } else {
                      event.preventDefault();
                      saveComment();
                    }
                  }
                }
              }
          });
        } ,0);
      });

    } ]);
})();

(function() {
  'use strict';
webapp.controller('H0201RoomEditCtrl', [ '$window', '$scope', '$rootScope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert',
    function H0201RoomEditCtrl($window, $scope, $rootScope, $location, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert) {
      var vm = this;

      vm.page = $stateParams.page;

      vm.srch = {
        FreeChatId : $stateParams.FreeChatId,
        IdName : 'FreeChatId',
        tableNm : 'freechat',
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        ChatId : '1',
        uploadFileList : [],
      };

      vm.data = {
        ChatId : vm.srch.ChatId,
      };

      vm.dataloader = false;
      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.newFreeChatUser = [];

      vm.getDetail = getDetail;
      vm.getFileList = getFileList;
      vm.saveDetail = saveDetail;
      vm.addUser = addUser;
      vm.goList = goList;

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          // console.log('file items::', vm.data.uploadFileList);
        },
        onFileDelete : function(item) {
          // console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0201Api.attachFileDelete().post(param).$promise;
          prms.then(function(data) {
            // console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.querySearch = querySearch;
      vm.loadContacts = loadContacts;
      // vm.allContacts = loadContacts();
      // vm.contacts = [ vm.allContacts[0] ];
      vm.filterSelected = true;
      vm.IsContact = IsContact;
      vm.onRemoveChip = onRemoveChip;
      vm.goBack = goBack;

      function IsContact(contact) {
        if (vm.newFreeChatUser != null) {
          for (var i = 0; i < vm.newFreeChatUser.length; i++) {
            if (contact.UserId == vm.newFreeChatUser[i].UserId)
              return true;
          }
        }

        if (vm.data.freeChatUser != null) {
          for (var j = 0; j < vm.data.freeChatUser.length; j++) {
            if (contact.UserId == vm.data.freeChatUser[j].UserId)
              return true;
          }
        }

        return false;
      }

      /**
       * Search for contacts.
       */
      function querySearch(query) {
        var results = query ? vm.listUsers.filter(createFilterFor(query)) : [];
        return results;
      }
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        return function filterFn(contact) {
          return (contact.UserNm.indexOf(query) != -1);
        };
      }

      function onRemoveChip(item) {
        // console.log('item=', item);
      }

      function loadContacts() {
        var data = angular.copy(vm.srch);
        data.mapCode = 'FreeChat.getContacts';
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.listUsers = result.body.docs;
              }
              var page = 1;
              var viewSize = 20;
              var totalSize = vm.listUsers.length;
              vm.contactSize = function() {
                return page * viewSize;
              };
              vm.totalContact = function() {
                return page < (totalSize / viewSize);
              };
              vm.getMoreContact = function() {
                page = page + 1;
              };
            }
            vm.dataloader = false;
          },
          function (error) {
            console.log("error");
            // console.error("Error> h0102-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getDetail() {
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          vm.newFreeChatUser = [ {
            UserId : $rootScope.gVariable.UserId,
            UserNm : $rootScope.gVariable.UserName,
            ContactNm : $rootScope.gVariable.TenantName.substring(0, 4) + '-' + $rootScope.gVariable.UserName
          } ];
          return;
        }

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        postApi.sendPostApi('api/freechat', 'viewChat', data, function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].FreeChatId != null) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                };
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              // console.log('$rootScope.gVariable.UserId', $rootScope.gVariable.UserId);
              // console.log(vm.data.RegUser );

              if (vm.data.RegUser == $rootScope.gVariable.UserId) {
                vm.newFreeChatUser = angular.copy(vm.data.FreeChatUser);
              }

              return;
            }
          }

          gAlert('', result.body.docs[0].errMessage);
        },

        function(error) {
          console.log("error");
          // console.error('fail', error);
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      function getFileList() {
        vm.srch.tableNm = 'FreeChat';
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          return;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            var uploadFileList = [];
            angular.forEach(result.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.data.uploadFileList);
            return;
          }
        },

        function(result) {
          console.log("error");
          // console.error('fail', status, result);
          gAlert('알림', result.body.docs[0].errMessage);
        });
      }

      function saveDetail() {
        var data = angular.copy(vm.data);
        data.Participants = ':' + $window.sessionStorage['loginUserIdx'] + ':';
        data.tableNm = "freechat";
        data.IdName = "FreeChatId";
        data.TableId = vm.data.FreeChatId;
        if (vm.data.RegUser == $rootScope.gVariable.UserId || data.FreeChatUser == null) {
          data.FreeChatUser = [];
        }
        angular.forEach(vm.newFreeChatUser, function(item) {
          data.FreeChatUser.push(item);
        });

        if (vm.data.FreeChatId == null) {
          postApi.sendPostApi('api/freechat', 'createChat', data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              vm.dataloader = false;
              console.table(error);
            }
          );

          vm.data.forceCreate = true;
        } else {
          postApi.sendPostApi('api/freechat', 'updateChat', data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              vm.dataloader = false;
              console.table(error);
            }
          );
        }
      }

      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = result.body.docs[0];
          var srch = $stateParams.srch; // 검색 옵션

          if (vm.layout == 'N') {
            $state.go('app.chatting.h0201-roomdetail', {srch : srch, FreeChatId : vm.data.FreeChatId}, {reload:'app.chatting.h0201-roomdetail'});
          } else {
            vm.srch.FreeChatId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            // 조회 화면 이동
            $state.go('app.chatting.h0201-roomlist.detail', {srch: srch, FreeChatId : vm.data.FreeChatId});
          }
        }

        vm.dataloader = false;

        if (result.body.docs != null && result.body.docs[0].errMessage != null)
          console.table(result);
      }

      function goBack() {
        $window.history.back();
      }

      function addUser(UserId) {
        for (var i = 0; i < vm.listUsers.length; i++) {
          if (vm.listUsers[i].UserId == UserId) {
            vm.newFreeChatUser.push(vm.listUsers[i]);
            break;
          }
        }
      }

      function goList() {
        $state.go('app.chatting.h0201-roomlist', {srch: $stateParams.srch, ChatUserId: '', WorkerId: ''}, {reload:'app.chatting.h0201-roomlist'});
      }

      getDetail();
      loadContacts();
    } ]);
})();

(function() {
  'use strict';
webapp.controller('H0201RoomListCtrl', ['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory',
    function H0201RoomListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory) {
      var vm = this;

      vm.dataloader = false;

      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.anchor = "";
      setLayout(vm.layout);

      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          tableNm: "freechat", // For CustomColumn and FileAttachment
          sortDirect: "",
          sortColumn: "",
          ChatId: "1"
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = "freechat"; // For CustomColumn and FileAttachment
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        if (vm.srch.page == null) {
          vm.srch.page = 1;
        }
        vm.srch.ChatId = "1";
      }

      $scope.selectedRow = $stateParams.FreeChatId;

      vm.listSize = [ 10, 25, 50, 100 ];
      vm.columnMap = {};
      vm.currentPage = vm.srch.page;
      vm.WorkerId = "";
      vm.WorkerNm = "";
      vm.ChatUserId = "";
      vm.ChatUserNm = "";

      if ($stateParams.WorkerId != null && $stateParams.WorkerId != "" && $stateParams.WorkerId != "0") {
        vm.WorkerId = $stateParams.WorkerId;
        var data1 = {UserId:vm.WorkerId};
        data1.mapCode = 'FreeChat.getUserInfo';

        postApi.select(data1, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.WorkerNm = result.body.docs[0].UserNm;
              return;
            }
          }
        }, function(error) {
          console.table(error);
        });
      } else if ($stateParams.ChatUserId != null && $stateParams.ChatUserId != "" && $stateParams.ChatUserId != "0") {
        vm.ChatUserId = $stateParams.ChatUserId;
        var data2 = {UserId:vm.ChatUserId};
        data2.mapCode = 'FreeChat.getUserInfo';

        postApi.select(data2, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.ChatUserNm = result.body.docs[0].UserNm;
              return;
            }
          }
        }, function(error) {
          console.table(error);
        });
      }

      $scope.showDetail = function(li) {
        $location.url('/' + li.ntcIdx);
      };

      vm.setLayout = setLayout;
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.getListCnt = getListCnt;
      vm.changeViewSize = changeViewSize;
      vm.getExcel = getExcel;
      vm.setResponsive = setResponsive;
      vm.changeLayout = changeLayout;
      vm.goEdit = goEdit;
      vm.goDetail = goDetail;

      function setLayout(layout) {
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            vm.anchor = "west";
            vm.paneMin = "480px";
            break;
          case "N":
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      function pageChanged() {
        // console.log('vm.currentPage=', vm.currentPage, ',vm.srch.page=', vm.srch.page);
        // $state.go("app.h0201.roomlist");
        vm.srch.page = vm.currentPage;
        getList();
        // $location.path('/app/request/h0201-list/' + vm.srch.ChatId + "/" +
        // vm.currentPage, false);
      }

      function getListCnt() {

        var data = angular.copy(vm.srch);
        data.WorkerId = vm.WorkerId;
        data.ChatUserId = vm.ChatUserId;
        data.selectType = "List"; // For CustomColumn
        postApi.sendPostApi('api/freechat', 'selectChatCount', data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.totalItems = result.body.docCnt;
              } else {
                vm.totalItems = 0;
              }
            }

            vm.SearchConditionStr = '<b>검색결과 <font color=red>' + Number(vm.totalItems).toLocaleString('en') + '</font>건</b> ';
            vm.dataloader = false;
          },
          function (error) {
            console.log("error");
            // console.error("Error> request-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getList() {
        vm.viewSize = vm.srch.viewSize;

        getListCnt();
        getChatTaskCount();

        $window.sessionStorage.setItem('h0201-roomlist-ctrl', angular.toJson(vm.srch));

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        data.WorkerId = vm.WorkerId;
        data.ChatUserId = vm.ChatUserId;
        data.selectType = "List"; // For CustomColumn
        postApi.sendPostApi('api/freechat', 'selectChat', data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.desc.length > 0) {
                vm.listColumns = result.body.desc;
                angular.forEach(vm.listColumns, function (item) {
                  vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                vm.lists = getContentsData(result.body.docs);
                setResponsive();
              } else {
                vm.lists = {};
              }
            }

            vm.dataloader = false;
          },
          function (error) {
            console.log("error");
            // console.error("Error> request-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            if (json.UserNm != '')
              veg.Contents = json.UserNm + ' ' + getMessageData(json.Message);
            else
              veg.Contents = getMessageData(json.Message);
          }

          return veg;
        });
      }

      function getMessageData(message) {
        var arg = message.split('|');
        var result = '';

        angular.forEach(arg, function(item) {
          result = result + $translate.instant(item) + " ";
        });

        return result;
      }

      function getExcel() {

        vm.excel.param = vm.srch;

        var prms = h0201Api.doExcel().post(vm.excel).$promise;

        prms.then(

        function(data) {
        },

        function(error) {
          console.log("error");
          // console.error('fail', status, data);
        });

      }

      function getChatTaskCount() {
        //commonFn.getChatTaskCount();
      }

      function setResponsive(dockMode) {
        var rows = vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if (item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }

      function goDetail(FreeChatId) {
        //vm.srch.BbsPostId = BbsPostId;
        angular.forEach(vm.lists, function(item) {
          if (item.FreeChatId == FreeChatId) {
            item.UnReadCnt = 0;
            return;
          }
        });

        var srch = $stateParams.srch;
        $scope.selectedRow = FreeChatId;
        if (vm.layout == "N") {
          $state.go("app.chatting.h0201-roomdetail", {
            srch: srch,
            FreeChatId: FreeChatId
          });
        } else {
          $state.go("app.chatting.h0201-roomlist.detail", {
            srch: srch,
            FreeChatId: FreeChatId
          });
        }
      }

      function goEdit() {
        var srch = $stateParams.srch;
        vm.keyId = "";
        if (vm.layout == "N") {
          $state.go("app.chatting.h0201-roomedit", {
            srch: srch,
            FreeChatId: ""
          });
        } else {
          $state.go("app.chatting.h0201-roomlist.edit", {
            srch: srch,
            FreeChatId: ""
          });
        }
      }

      function changeLayout(layout) {
        $window.sessionStorage.setItem("layoutBoard", layout);
        $rootScope.gVariable.layoutBoard = layout;
        var srch = $stateParams.srch;
        $state.go(
          "app.chatting.h0201-roomlist",
          {
            ChatUserId:'', WorkerId:''
          },
          { reload: "app.chatting.h0201-roomlist" }
        );
      }

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchWorkerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, ContactsYN: true};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.WorkerNm = okData.UserNm;
          vm.WorkerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseWorker = function () {
        vm.WorkerNm = "";
        vm.WorkerId = "";
      };

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, ContactsYN: true};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.ChatUserNm = okData.UserNm;
          vm.ChatUserId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.ChatUserNm = "";
        vm.ChatUserId = "";
      };

      vm.getSearch = function () {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.chatting.h0201-roomlist",
          {
            srch:srch, ChatUserId:vm.ChatUserId, WorkerId:vm.WorkerId
          },
          { reload: "app.chatting.h0201-roomlist" }
        );
      };

      vm.resetSearch = function () {
        vm.WorkerNm = "";
        vm.WorkerId = "";
        vm.ChatUserNm = "";
        vm.ChatUserId = "";
        vm.srch.RegDateFrom = "";
        vm.srch.RegDateTo = "";
        vm.RegDateFrom = "";
        vm.RegDateTo = "";
        getList();
      };

      getList();
    } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.clientcompany:client-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객사 조회 디테일 목록
   * @history
   * 
   */
  webapp.controller('ClientDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', 'autoView',

    function ClientDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, autoView) {
      
      
      var LIST_PAGE_URL = 'app.client.client-detail';


      var LIST_SQL = 'Client.getClientDetail';    // 목록 조회 SQL

      var KEY_TABLE_NM = 'TB_COMPANY'; // 작업 테이블명
      var svc = ''; //이력변경시 저장될 출처 (고객사는 [0]를 출처로)
      var oldParam = {};
      var newParam = {};
      var paramData = [];
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.CompanyId = $stateParams.CompanyId;
      vm.srch = {};
      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      var LoginId = $window.sessionStorage['loginUserId'];

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.srch.KeyId = $stateParams.KeyId;
      //세션에 컴패니아이디를 저장시켜서 싱글뷰에서 키값으로 사용한다
      var KeyId = $stateParams.KeyId;
      //$window.sessionStorage.setItem("currentClientId", KeyId);
      /* // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          KeyId: !isNullOrEmpty($stateParams.KeyId) ? $stateParams.KeyId : '',
          TenantId : vm.TenantId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.KeyId = $stateParams.KeyId;
        vm.srch.TenantId = vm.TenantId;
      } */

      vm.url = $state.current.url;
      vm.view = {
        VIEW_PAGE_DEFAULTINFO : 'app/client/tab/client-defaultinfo.html', // 기본정보 화면
        VIEW_PAGE_RELATEBUSINESS : 'app/client/tab/client-relate.html', // 연관사업정보 화면
        VIEW_PAGE_CUSTOMER : 'app/client/tab/client-customer.html', // 고객 화면
        VIEW_PAGE_BUSINESSPLAN : 'app/client/tab/client-business.html', // 사업기회 화면
        VIEW_PAGE_SALESPLAN : 'app/client/tab/client-sales.html', // 영업일지 화면
        VIEW_PAGE_KS : 'app/client/tab/client-ks.html', // KS 화면
        VIEW_PAGE_ISO : 'app/client/tab/client-iso.html', // ISO 화면
        VIEW_PAGE_ENERGY: 'app/client/tab/client-energy.html', // 에너지 화면
        VIEW_PAGE_EDUCATION: 'app/client/tab/client-education.html', // 교육 화면
        VIEW_PAGE_NETWORK: 'app/client/tab/client-network.html', // 표준정보망 화면
        VIEW_PAGE_MEMBERS: 'app/client/tab/client-members.html', // 회원사 화면
        VIEW_PAGE_QUALITYCONTROL: 'app/client/tab/client-quality.html', // 분임조 화면
        VIEW_PAGE_BREAKFAST: 'app/client/tab/client-breakfast.html', // 조찬 화면
        VIEW_PAGE_HISTORY: 'app/client/tab/client-history.html', // 변경이력 화면
        VIEW_PAGE_ALARM: 'app/client/tab/client-alarm.html', // 조기경보 화면
        VIEW_PAGE_SUPPORT: 'app/client/tab/client-support.html', // 지원사업 화면
      };

      //vm.pages = vm.view.VIEW_PAGE_DEFAULTINFO;
      vm.tabIndex = 0;

      


      postApi.select({mapCode : 'KSATab.getTabListClient'}, 
        function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tabList = {};
              vm.tabList = result.body.docs;
              vm.pages = vm.view[vm.tabList[0].Page];
            } else {
              vm.tabList = [
                {Index : 0, Page : "VIEW_PAGE_DEFAULTINFO", Text : "기본정보"}
                , {Index : 1, Page : "VIEW_PAGE_RELATEBUSINESS", Text : "연관사업정보"}
                , {Index : 2, Page : "VIEW_PAGE_CUSTOMER", Text : "고객"}
                , {Index : 3, Page : "VIEW_PAGE_BUSINESSPLAN", Text : "사업기회"}
                , {Index : 4, Page : "VIEW_PAGE_SALESPLAN", Text : "영업일지"}
                , {Index : 5, Page : "VIEW_PAGE_KS", Text : "KS"}
                , {Index : 6, Page : "VIEW_PAGE_ISO", Text : "ISO"}
                , {Index : 7, Page : "VIEW_PAGE_ENERGY", Text : "에너지"}
                , {Index : 8, Page : "VIEW_PAGE_EDUCATION", Text : "교육"}
                , {Index : 9, Page : "VIEW_PAGE_NETWORK", Text : "표준정보망"}
                , {Index : 10, Page : "VIEW_PAGE_MEMBERS", Text : "회원사"}
                , {Index : 11, Page : "VIEW_PAGE_QUALITYCONTROL", Text : "분임조"}
                , {Index : 12, Page : "VIEW_PAGE_BREAKFAST", Text : "조찬"}
                , {Index : 13, Page : "VIEW_PAGE_SUPPORT", Text : "지원사업"}
                , {Index : 14, Page : "VIEW_PAGE_ALARM", Text : "조기경보"}
                , {Index : 15, Page : "VIEW_PAGE_HISTORY", Text : "변경이력"}
              ];
              vm.pages = vm.view[vm.tabList[0].Page];

              
            }
          }
        });

      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          return true;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeTabPosition(source);
        },
      };

      

      function setChangeTabPosition(source) {
        var TabList = [];
        for (var i = 0;  i < source.length; i ++) {
          source[i].Index = i;
          if (isNullOrEmpty(source[i].KeyId)) {
            source[i].KeyId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
          }

          TabList.push(source[i]);
        }

        var data = {};
        data.TabList = TabList;
        data.mapCode = 'KSATab.updateTabListClient';

        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> setChangeTabPosition()', error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 탭메뉴 변경
      function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      }






      /**
       *
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
       function setLayout(layout) {
        //alert(layout);
        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } 
        else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
            // 기본 "N"을 "V"와 같게 맞춰줌 
          case "N":
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
        }
        
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {
        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.changeLayout(layout);

        var srch = '';

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.Edit, // List OR Edit
        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "TB_COMPANY",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data", // ex : vc.data = {}
        apis : {
          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect : { mapCode : "Client.getClientDetail", param : null },
          // vieType is edit
          insert : "Client.insertClientBatch",
          update : "Client.updateClient",        
        },
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow : [],
  
        // vc의 ng-if
        /* ngIf : {
          CustType : "false",
        }, */
        
        // 비활성화 시킬 컬럼의 조건
        disabled : {
          Sales3Y : true,
          SalesCredit : true,
          CompanyId : true,
          RegInfo : true,
          EditInfo : true,
          DeptCodes : true,
          ManagerNms : true,
          
        },
  
        // MataColum 외 추가 적으로 넣어야할 폼
        addForm : {
          // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
          Address : { after : "Homepage", type : mElemTx.address,  bindKey : ["ZipCode", "Address1", "Address2"], label : "주소"},
          empytyBox1 : { after : "ManagerId"},
        },
        
        customColSize : {
          Address : "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          empytyBox1 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
        },
  
        // 필수 항목 컬럼 
        required : ["CompName", "Telephone", "SVCSystem"]
        
      };

      //고객사 등록/수정 저장버튼 클릭
      function setData() {



        busiInfoEtcText = $('#busiInfoEtc').val();
        var BusiInfo = "";
        //기타 선택했는지 확인 
        if (busiInfoEtcText != null && busiInfoEtcText != "") {
          BusiInfo = busiInfoEtcText;
        }
        // 체크박스 
        var checkboxes = document.getElementsByName('busiInfo');
        var selected = [];
        

        for (var i=0; i<checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                selected.push(checkboxes[i].value);
            }
        }
        // 선택된 체크박스가 하나면 그대로 두개이상이면 ,로 구분
        
        for (i = 0; i < selected.length; i ++) {
          if (i == 0 && BusiInfo != "") {
            BusiInfo += ", " + selected[i];
          }
          else if (i == 0 && BusiInfo == "") {
            BusiInfo += selected[i] + ""; 
          }
          else  {
            BusiInfo += "," + selected[i];
          }
        }
        
        
        // 아무것도 체크가 안되어 있으면 기본값은 CRM으로 자동입력 (<- 고객만 고객사는 출처x)
        if (BusiInfo == null || BusiInfo == ""){
          vm.data.SVCSystem = "";
        } else {
          vm.data.SVCSystem = BusiInfo;
        }

        vm.data.LoginId = LoginId;

        newParam = vm.data;
        //console.log(newParam);
        //변경이력용 출처저장
        svc = selected[0];
        if (getIsValidData()) {
          av.confirm("Menu.SAVECONFIRM2", function(){
            //console.log(vm.data);
            av.commit(function(result){
              compareMaps(oldParam, newParam);
              //console.log(result);

              av.alert('Menu.SAVED', function(){
                var url = "app.client.client-detail";
                var param = {};
                param.srch = '';
                //param.KeyId = result.body.docs[0].RelateDataId;
                param = JSON.stringify(param);
                $state.go(url, JSON.parse(param) , {reload: url});
              });
            });
          });
        }

      }
      
      /* 변경이력 저장 */
      function compareMaps(map1, map2) {
        //var testVal;
        vm.dataloader = true;
        var histData = {};

        var oldParamKey = Object.keys(map1);
        var newParamKey = Object.keys(map2);
        var oldParamVal = Object.values(map1);
        var newParamVal = Object.values(map2);
        //console.log(oldParamKey);
        //console.log(newParamKey);
        //console.log(oldParamVal);
        //console.log(newParamVal);
        var beforeVal = [];
        var afterVal = [];
        var ColNm = [];
        //var chkItem = {};
        //console.log(oldParamVal[10]);
        
        var list = [];
        
        for(var i = 0; i < oldParamKey.length; i++) {
          
          if (oldParamVal[i] != newParamVal[i]) {
            var mapData = {};
            mapData.beforeVal = oldParamVal[i];
            mapData.ColNm = oldParamKey[i];
            mapData.afterVal = newParamVal[i];
            
            list.push(mapData);
          }

        }


        histData.alist = list; 
        
        
        histData.SVCSystem = svc;
        histData.KeyId = vm.data.KeyId;
        histData.mapcode = "Client.insertClientUpdateHist";
        //console.log(histData);
        
        postApi.insert(histData, function(result) {
          vm.dataloader = false;

        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        vm.dataloader = false;
      }
      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        //var srch = $stateParams.srch; // 검색 옵션
        var srch = '';
        $state.go('app.client.client-list', {
          srch: srch
        });
      }



      var busiInfoEtcText = "";
      // 체크박스 기타 체크시 인풋 열어주기
      $scope.clickCheckBoxEtc = function(event) {
        var checkBox = document.getElementById("inlineCheckbox12");
        if (checkBox.checked) {
          $('#busiInfoEtc').attr('readonly', false);
        } else {
          $('#busiInfoEtc').attr('readonly', true);
        }
        
      };




      

      function onReadyAutoView() {
        // 초기 설정
        var svcValue = vm.data.SVCSystem;
       
        var svcArray = svcValue.split(",");

        for(var i = 0; i < svcArray.length; i++) {
          if (svcArray[i] == 'K') {
            document.getElementById("inlineCheckbox1").checked = true;
          }
          if (svcArray[i] == 'I') {
            document.getElementById("inlineCheckbox2").checked = true;
          }
          if (svcArray[i] == 'E') {
            document.getElementById("inlineCheckbox3").checked = true;
          }
          if (svcArray[i] == 'L') {
            document.getElementById("inlineCheckbox4").checked = true;
          }
          if (svcArray[i] == 'M') {
            document.getElementById("inlineCheckbox5").checked = true;
          }
          if (svcArray[i] == 'Q') {
            document.getElementById("inlineCheckbox6").checked = true;
          }
          if (svcArray[i] == 'B') {
            document.getElementById("inlineCheckbox7").checked = true;
          }
          if (svcArray[i] == 'N') {
            document.getElementById("inlineCheckbox8").checked = true;
          }
          if (svcArray[i] == 'C') {
            document.getElementById("inlineCheckbox12").checked = true;
            $('#busiInfoEtc').val('CRM');
          }
          if (svcArray[i].length > 1) {
            document.getElementById("inlineCheckbox12").checked = true;
            $('#busiInfoEtc').val(svcArray[i]);
          }
          
        }
        var data = {};
        data = vm.data;
        if (data.CustCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_CUSTOMER') {
              vm.tabList[i].Text = "고객(" + data.CustCnt + ')';
            }
          }
        }
        if (data.TBDCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_SALESPLAN') {
              vm.tabList[i].Text = '영업일지(' + data.TBDCnt + ')';
            }
          }
        }
        if (data.TBOCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_BUSINESSPLAN') {
              vm.tabList[i].Text = '사업기회(' + data.TBOCnt + ')';
            }
          }
        } 
        if (data.KSCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_KS') {
              vm.tabList[i].Text = 'KS(' + data.KSCnt + ')';
            }
          }
        } 
        if (data.ISOCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_ISO') {
              vm.tabList[i].Text = 'ISO(' + data.ISOCnt + ')';
            }
          }
        } 
        if (data.ECCCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_ENERGY') {
              vm.tabList[i].Text = '에너지(' + data.ECCCnt + ')';
            }
          }
        } 
        if (data.LMSCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_EDUCATION') {
              vm.tabList[i].Text = '교육(' + data.LMSCnt + ')';
            }
          }
        } 
        if (data.KSSNCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_NETWORK') {
              vm.tabList[i].Text = '표준정보망(' + data.KSSNCnt + ')';
            }
          }
        } 
        if (data.MBRCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_MEMBERS') {
              vm.tabList[i].Text = '회원사(' + data.MBRCnt + ')';
            }
          }
        } 
        if (data.QCCCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_QUALITYCONTROL') {
              vm.tabList[i].Text = '분임조(' + data.QCCCnt + ')';
            }
          }
        } 
        if (data.BKMCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_BREAKFAST') {
              vm.tabList[i].Text = '조찬(' + data.BKMCnt + ')';
            }
          }
        }
        if (data.BSTCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_SUPPORT') {
              vm.tabList[i].Text = '지원사업(' + data.BSTCnt + ')';
            }
          }
        }
        if (data.AlertCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_ALARM') {
              vm.tabList[i].Text = '조기경보(' + data.AlertCnt + ')';
            }
          }
        }
        if (data.THFCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_HISTORY') {
              vm.tabList[i].Text = '변경이력(' + data.THFCnt + ')';
            }
          }
        }
        if (data.ERPCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_RELATEBUSINESS') {
              vm.tabList[i].Text = '연관사업정보(' + data.ERPCnt + ')';
            }
          }
        }

        //초기값 저장
        oldParam = angular.copy(vm.data);
        //console.log(oldParam);
      }


      //#region 필수항목 체크
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';

        if (isNullOrEmpty(vm.data.ClientNm)) {
          errMsg = errMsg + '- 고객사를 입력하세요.<br/>';
        }
        
        if (isNullOrEmpty(vm.data.Telephone)) {
          errMsg = errMsg + '- 회사전화를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ClientBSN1)) {
          errMsg = errMsg + '- 사업자등록번호를 입력하세요.<br/>';
        }
       
        if (isNullOrEmpty(vm.data.SVCSystem)) {
          errMsg = errMsg + '- 출처를 선택하세요.<br/>';
        }
        if (!isNullOrEmpty(vm.data.ClientBSN1) && vm.data.ClientBSN1.length > 10) {
          errMsg = errMsg + '- 값이 너무 큽니다. 사업자등록번호를 확인해 주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn = false;
        }
        return bRtn;
      }
      //#endregion 필수항목 체크



      //나이스 정보조회 
      vm.getNiceName = function() {
        //console.log('nice');
        //var paramData = vm.data.ClientNm;
        var data =  {};
        var prefix = "(주)";
        
        
        data.ClientNm = vm.data.ClientNm;
        data.ClientNm = data.ClientNm.replace(prefix, '');
        data.Key = 'Name';
        openNiceModal(data);

      };

      vm.getNiceBSN = function() {
        //console.log('nice');
        var data =  {};
        data.ClientBSN1 = vm.data.ClientBSN1;
        data.Key = 'BSN';
        openNiceModal(data);

      };

      function openNiceModal(paramData) {
        //e.stopPropagation();
        var ctrl = 'ClientNiceDNBModalCtrl as vc';
        modalFactory.open('mf-80', 'app/client/modal/client-nicednb-modal.html', ctrl, paramData);
       /*  modalInstance.result.then(function (okData) {
          // ok버튼
          av.init(autoViewOption);
        }, function (cancelData) {
          // cancel버튼
        }); */
      }





      vm.onReadyAutoView = onReadyAutoView;


      // 함수 정의
      vm.openNiceModal = openNiceModal;
      vm.setChangeTabPosition = setChangeTabPosition;
      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;             // 탭 이동 설정
      vm.setData = setData; 
      
      var av = new autoView();
      av.init(autoViewOption);
    }]);
})();
(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.company:company-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객사 조회
   */
  webapp.controller('ClientListCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window', 'modalFactory',
    function ClientListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window, modalFactory) {
      
      var vm = this;
      vm.dataloader = false;
      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];   
      
      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Client.getClientListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Client.getClientList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.client.client-list';       // 조회 화면
      var LIST_DETAIL_PAGE_URL = 'app.client.client-detail';  // 목록 조회  화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'TB_COMPANY'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // COMPANYID



      //vm.headerTitle = "고객사리스트";
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          //ClientId: !isNullOrEmpty($stateParams.ClientId) ? $stateParams.ClientId : '',
          TenantId : vm.TenantId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        //vm.srch.ClientId = $stateParams.ClientId;
        vm.srch.TenantId = vm.TenantId;
      } 

      vm.SelectBox = [
        {id : "", name : "- 조회기준 -"},
        {id: "All", name :"전체"}, 
        {id: "Dept", name :"부서"},
        {id: "Person", name :"개인"}
      ];

      vm.SortBox = [
        {id: "", name : " - 정렬기준 -"},
        {id: "CreatedDate", name: '최근등록'},
        {id: "UpdatedDate", name: '최근수정'},
        {id: "ClientScore", name: '고객사등급'}
      ];


      $scope.selectedRow = $stateParams.KeyId;

      //vm.listSize = [ 10, 25, 50, 100 ]; // 목록당 표시건수

      if (vm.srch.SortBy != '' && vm.srch.SortBy != null) {
        for(var i = 0; i < vm.SortBox.length; i++) {
          if ( vm.srch.SortBy == vm.SortBox[i].id) {
            vm.SortBy = vm.SortBox[i];
          }
        }
      } else {
        vm.SortBy = vm.SortBox[0];
      }

      if (vm.srch.SelectBy != '' && vm.srch.SelectBy != null) {
        for(var j = 0; j < vm.SelectBox.length; j ++) {
          if (vm.srch.SelectBy == vm.SelectBox[j].id) {
            vm.SelectBy = vm.SelectBox[j];
          }
        }
      } else {
        vm.SelectBy = vm.SelectBox[0];
      }
      vm.thisSort = vm.SortBy;
      vm.thisSelect = vm.SelectBy;
      

      //담당지역본부 값 불러와서 셀렉트박스에 설정
      var codeval = [];
      postApi.select({ mapCode: 'KSACust.getDeptCode'}, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.CodeValue = result.body.docs;
            angular.forEach(vm.CodeValue, function(item) {
              var code = {Code : item.Code, CodeValue : item.CodeValue};
              codeval.push(code);
            });
          }
          
        }
      }); 

      vm.DeptBox = codeval;
      
      if (vm.srch.DeptBy != '' && vm.srch.DeptBy != null) {
        for(var k = 0; k < vm.DeptBox.length; k ++) {
          if (vm.srch.DeptBy == vm.DeptBox[k].CodeValue) {
            vm.DeptBy = vm.DeptBox[k];
          }
        }
      } else {
        vm.DeptBy = vm.DeptBox[0];
      }
      vm.thisDept = vm.DeptBy;
      



   

      vm.listOptions = {
        addColumn : {

        },

        html : {

        },
        addColumnClass : {

        },

        addRowClass : {
          //if : "li.CustReadyYN == 'Y'",  class : "row-highlight"
        },
        ngIf: {

        },

      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_COMPANY",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientListCnt", param : null},
          initSelect : { mapCode : "Client.getClientList", param : null },
        },


        addSrchStack : true,
        // List
        listCheckboxEnable : true,

        src : {
          detail : "app.client.client-detail",
        },

        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },

        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
          //SVCSystem : "setSVCSystem"
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {

        },
        addForm : {
          BusiInfo : { after : 'Address1', type : mElemTx.input, colSize: 4, label : "사업정보"},
        },
        customColSize : {
          BusiInfo : "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3",
        },
        // 필수 항목 컬럼 
        required: [],

        autocomplete: {}
      };




      function onReadyAutoView() {
        setSVCSystem();
      }

      
      vm.companyRegisterModal = function() {
        var ctrl = 'ClientEditModalCtrl as vc';
        modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl);
      };

      

      /* 출처 정의.... */
      function setSVCSystem() {
        //vm.dataloader = true;
        var data = {};
        //console.log(vm.lists);
        data = vm.lists;
        //console.log(data);
        var svcValue = "";
        var svcArray = [];
        if (data.length > 0) {
          for(var o = 0; o < data.length; o++) {
            svcValue = data[o].SVCSystem;
            var busiCnt = "";
            
            svcArray = svcValue.split(",");
            for(var i = 0; i < svcArray.length; i++) {
              if(svcArray[i] == 'K') {
                svcArray[i] = 'KS';
                if (data[o].KSCnt >= 0) {
                  busiCnt += "KS(" + data[o].KSCnt + ")";
                }
              }
              if(svcArray[i] == 'I') {
                svcArray[i] = 'ISO';
                if (data[o].ISOCnt >= 0) {
                  busiCnt += " ISO(" + data[o].ISOCnt + ")";
                }
              }
              if(svcArray[i] == 'E') {
                svcArray[i] = '에너지';
                if (data[o].ECCCnt >= 0) {
                  busiCnt += " 에너지(" + data[o].ECCCnt + ")";
                }
              }
              if(svcArray[i] == 'L') {
                svcArray[i] = '교육';
                if (data[o].LMSCnt >= 0) {
                  busiCnt += " 교육(" + data[o].LMSCnt + ")";
                }
              }
              if(svcArray[i] == 'M') {
                svcArray[i] = '회원사';
                if (data[o].MBRCnt >= 0) {
                  busiCnt += " 회원사(" + data[o].MBRCnt + ")";
                }
              }
              if(svcArray[i] == 'Q') {
                svcArray[i] = '분임조';
                if (data[o].QCCCnt >= 0) {
                  busiCnt += " 분임조(" + data[o].QCCCnt + ")";
                }
              }
              if(svcArray[i] == 'B') {
                svcArray[i] = '조찬회';
                if (data[o].BKMCnt >= 0) {
                  busiCnt += " 조찬회(" + data[o].BKMCnt + ")";
                }
              }
              if(svcArray[i] == 'N') {
                svcArray[i] = '표준정보망';
                if (data[o].KSSNCnt >= 0) {
                  busiCnt += " 표준정보망(" + data[o].KSSNCnt + ")";
                }
              }
              if(svcArray[i] == 'A') {
                svcArray[i] = 'ERP';
              }
              
            }
            
            
            busiCnt.replace(' ',',');
            // 바꾸어준 출처 정보를 기입
            data[o].SVCSystem = svcArray;
            data[o].BusiInfoCnt = busiCnt;
          }
        }
        
        //vm.dataloader = false;
      }

      


      //정렬 셀렉트박스와 조회기준 셀렉트 박스 설정값 저장
      function setSortSelect() {
        vm.srch.SortBy = vm.thisSort.id;
        vm.srch.SelectBy = vm.thisSelect.id;
        //console.log(vm.srch);
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      //담당지역본부 선택시.. 담당지역본부값 설정
      function setDeptSelect() {
        vm.srch.DeptBy = vm.thisDept.CodeValue;
        //setManagerId();
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }



      //나이스 정보조회 
      vm.getNiceName = function() {
        //console.log('nice');
        //var paramData = vm.data.ClientNm;
        
        
        var data =  {};
        var KeyIdList = [];
        var prefix = "(주)";
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            data.ClientNm = vm.lists[i].ClientNm;
            data.ClientBSN1 = vm.lists[i].ClientBSN1;
            //data.ClientNm = vm.data.ClientNm;
            data.ClientNm = data.ClientNm.replace(prefix, '');
            data.Key = 'Both';
            KeyIdList.push(vm.lists[i].KeyId);
          }
        }
        if (KeyIdList.length > 1) {
          av.alert('나이스정보조회를 위해 한곳의 고객사만 선택해주세요', function(){ });
          return false;
        }
        
        openNiceModal(data);

      };

      

      function openNiceModal(paramData) {
        //e.stopPropagation();
        var ctrl = 'ClientNiceDNBModalCtrl as vc';
        modalFactory.open('mf-80', 'app/client/modal/client-nicednb-modal.html', ctrl, paramData);
        /*  modalInstance.result.then(function (okData) {
          // ok버튼
          av.init(autoViewOption);
        }, function (cancelData) {
          // cancel버튼
        }); */
      }



      // 함수 정의
      vm.setDeptSelect = setDeptSelect;
      //vm.goDetail = goDetail;
      vm.setSVCSystem = setSVCSystem;
      //vm.getSearch = getSearch;
      vm.setSortSelect = setSortSelect;
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);


    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    $stateProvider.state('app.client', {
      url: '/client',
      template: '<div ui-view></div>',
    })
    // 고객사 목록 client-list
    .state('app.client.client-list', {
      url: '/client-list/:srch/',
      templateUrl: 'app/client/client-list.html',
      requiresAuthentication: true,
    })
    // 고객사 조회 페이지 client-detail
    .state('app.client.client-detail', {
      url: '/client-detail/:KeyId/',
      templateUrl: 'app/client/client-detail.html',
      requiresAuthentication: true,
    })
    //고객 목록
    .state('app.client.ksacust-list', {
      url: '/ksacust-list/:srch/',
      templateUrl: 'app/client/ksacust-list.html',
      requiresAuthentication: true,
    })
    //고객 조회 페이지 ksacust-detail
    .state('app.client.ksacust-detail', {
      url: '/ksacust-detail/:KeyId/',
      templateUrl: 'app/client/ksacust-detail.html',
      requiresAuthentication: true,
    })
    //리멤버 팀명함 조회 페이지 remember-list
    .state('app.client.remember-list', {
      url: '/remember-list/:srch/',
      templateUrl: 'app/client/remember-list.html',
      requiresAuthentication: true,
    })
    //중복고객통합 조회 페이지 ksacust-merge
    .state('app.client.ksacust-merge-list', {
      url: '/ksacust-merge-list/:srch/',
      templateUrl: 'app/client/ksacust-merge-list.html',
      requiresAuthentication: true,
    })
    
    ;
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.client:ksacust-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객사 조회 디테일 목록
   * @history
   * 
   */
  webapp.controller('KSACustDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', 'autoView', '$http', '$filter',

    function KSACustDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, 
      autoView, $http, $filter) {
      
      
      var LIST_PAGE_URL = 'app.client.ksacust-detail';


      var LIST_SQL = 'KSACust.getKSACustDetail';    // 목록 조회 SQL

      var KEY_TABLE_NM = 'TB_MEMBER'; // 작업 테이블명



      var oldParam = {}; //onReadyAutoView에서 저장되어지는 최초 값
      var newParam = {}; //setData에서 저장되어지는 수정된 값




      //var paramData = [];
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.CompanyId = $stateParams.CompanyId;
      vm.srch = {};
      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      var LoginId = $window.sessionStorage['loginUserId'];
      
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.srch.KeyId = $stateParams.KeyId;
      //세션에 컴패니아이디를 저장시켜서 싱글뷰에서 키값으로 사용한다
      var KeyId = $stateParams.KeyId;
      $window.sessionStorage.setItem("currentCustId", KeyId);
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          KeyId: !isNullOrEmpty($stateParams.KeyId) ? $stateParams.KeyId : '',
          TenantId : vm.TenantId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.KeyId = $stateParams.KeyId;
        vm.srch.TenantId = vm.TenantId;
      }

      vm.url = $state.current.url;
       vm.view = {
        VIEW_PAGE_BUSINESSPLAN : 'app/client/cust-tab/ksacust-business.html', // 사업기회 화면
        VIEW_PAGE_SALESPLAN : 'app/client/cust-tab/ksacust-sales.html', // 영업일지 화면
        VIEW_PAGE_CAMPAIGN : 'app/client/cust-tab/ksacust-campaign.html', // 캠패인 화면
        VIEW_PAGE_KS : 'app/client/cust-tab/ksacust-ks.html', // KS 화면
        VIEW_PAGE_ISO : 'app/client/cust-tab/ksacust-iso.html', // ISO 화면
        VIEW_PAGE_ENERGY: 'app/client/cust-tab/ksacust-energy.html', // 에너지 화면
        VIEW_PAGE_EDUCATION: 'app/client/cust-tab/ksacust-education.html', // 교육 화면
        VIEW_PAGE_NETWORK: 'app/client/cust-tab/ksacust-network.html', // 표준정보망 화면
        VIEW_PAGE_MEMBERS: 'app/client/cust-tab/ksacust-members.html', // 회원사 화면
        VIEW_PAGE_QUALITYCONTROL: 'app/client/cust-tab/ksacust-quality.html', // 분임조 화면
        VIEW_PAGE_BREAKFAST: 'app/client/cust-tab/ksacust-breakfast.html', // 조찬 화면
        VIEW_PAGE_HISTORY: 'app/client/cust-tab/ksacust-history.html', // 변경이력 화면
        VIEW_PAGE_COMP: 'app/client/cust-tab/ksacust-comp.html', // 직장이력 화면
        VIEW_PAGE_ERP: 'app/client/cust-tab/ksacust-relate.html', // 연관사업정보 화면
      };

/*       vm.pages = vm.view.VIEW_PAGE_ERP;
      vm.tabIndex = 13;  */


        postApi.select({mapCode : 'KSATab.getTabListKSACust'}, 
        function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tabList = {};
              vm.tabList = result.body.docs;
              vm.pages = vm.view[vm.tabList[0].Page];
            } else {
              vm.tabList = [
                {Index : 0, Page : "VIEW_PAGE_ERP", Text : "연관사업정보"}
                , {Index : 1, Page : "VIEW_PAGE_BUSINESSPLAN", Text : "사업기회"}
                , {Index : 2, Page : "VIEW_PAGE_SALESPLAN", Text : "영업일지"}
                , {Index : 3, Page : "VIEW_PAGE_CAMPAIGN", Text : "캠패인"}
                , {Index : 4, Page : "VIEW_PAGE_KS", Text : "KS"}
                , {Index : 5, Page : "VIEW_PAGE_ISO", Text : "ISO"}
                , {Index : 6, Page : "VIEW_PAGE_ENERGY", Text : "에너지"}
                , {Index : 7, Page : "VIEW_PAGE_EDUCATION", Text : "교육"}
                , {Index : 8, Page : "VIEW_PAGE_NETWORK", Text : "표준정보망"}
                , {Index : 9, Page : "VIEW_PAGE_MEMBERS", Text : "회원사"}
                , {Index : 10, Page : "VIEW_PAGE_QUALITYCONTROL", Text : "분임조"}
                , {Index : 11, Page : "VIEW_PAGE_BREAKFAST", Text : "조찬"}
                , {Index : 12, Page : "VIEW_PAGE_COMP", Text : "직장이력"}
                , {Index : 13, Page : "VIEW_PAGE_HISTORY", Text : "변경이력"}
              ];
              vm.pages = vm.view[vm.tabList[0].Page];
            }
          }
        });
      
      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          return true;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeTabPosition(source);
        },
      };

      function setChangeTabPosition(source) {
        var TabList = [];
        for (var i = 0;  i < source.length; i ++) {
          source[i].Index = i;
          if (isNullOrEmpty(source[i].KeyId)) {
            source[i].KeyId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
          }

          TabList.push(source[i]);
        }

        var data = {};
        data.TabList = TabList;
        data.mapCode = 'KSATab.updateTabListKSACust';

        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> setChangeTabPosition()', error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 탭메뉴 변경
      function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      }



      //담당지역본부 값 불러와서 셀렉트박스에 설정
      var codeval = [];
      postApi.select({ mapCode: 'KSACust.getDeptCode'}, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.CodeValue = result.body.docs;
            angular.forEach(vm.CodeValue, function(item) {
              var code = {Code : item.Code, CodeValue : item.CodeValue};
              codeval.push(code);
            });
          }
          
        }
      }); 
      
      $scope.DeptBox = codeval;
      //console.log(codeval);
      

      //담당지역본부 선택시.. 담당지역본부값 설정
      function setDeptSelect(selectedDept) {
        vm.data.DeptCode = selectedDept;
        //console.log(vm.data.DeptCode);
        //setManagerId();
      }
      
      


      // 탭메뉴 변경
/*       function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      } */
/*       var checkTab = $window.sessionStorage.getItem("goToClientCustAtTab");
      if(!isNullOrEmpty(checkTab)) {
        checkTab = JSON.parse(checkTab);
        $window.sessionStorage.setItem("goToClientCustAtTab", "");
        setChangeTab(checkTab.idx, checkTab.tab);
      } else {
        $window.sessionStorage.setItem("goToClientCustAtTab", "");
      } */
      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
       function setLayout(layout) {
        //alert(layout);
        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } 
        else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
            // 기본 "N"을 "V"와 같게 맞춰줌 
          case "N":
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
        }
        
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {
        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.changeLayout(layout);

        var srch = '';

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.Edit, // List OR Edit
        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "TB_MEMBER",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data", // ex : vc.data = {}
        apis : {
          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect : { mapCode : "KSACust.getKSACustDetail", param : null },
          // vieType is edit
          insert : "KSACust.insertKSACustBatch",
          update : "KSACust.updateKSACustBatch",        
        },
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow : [],
  
        // vc의 ng-if
        /* ngIf : {
          CustType : "false",
        }, */
        
        // 비활성화 시킬 컬럼의 조건
        disabled : {
          SVCSystem : true,
          RegInfo : true,
          EditInfo : true,
          ClientNm : true,
          CompTel : true,
          Fax : true,
          ZipCode : true,
          Address1 : true,
          Address2 : true,
        },
  
        // MataColum 외 추가 적으로 넣어야할 폼
        addForm : {
          // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
          Address : { after : "Working", type : mElemTx.address,  bindKey : ["ZipCode", "Address1", "Address2"], label : "주소"},
          /* empytyBox1 : { after : "KeyMan"}, */
          //empytyBox2 : { after : "empytyBox1"},
        },
  
        
  
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes : {
          //BusiInfoBox : "codeBusiInfo",
        },
        
        customColSize : {
          Address : "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          /* empytyBox1 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4", */
          //empytyBox2 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
        },
  
        // 필수 항목 컬럼 
        required : ["CustNm", "Mobile", "Email", "AgreeSMS", "AgreeEmail", "ClientNm", ],

        autocomplete: {
          //ClientNm: { keyNm: "ClientId", callback: "getSetClient", codeList: "codeClientList", addTopRow: "신규등록", addTopRowCallback: "addClient", ngChange: "onChangeClientNm" },
          //CustNm: { keyNm: "CustId", callback: "getSetCust", codeList: "codeCustList", /* addTopRow: "신규등록", addTopRowCallback: "addCust", */ ngChange: "onChangeCustNm" },
          //ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", addTopRow: "", addTopRowCallback: "", ngChange: "onChangeManagerNm" },
        }  
      };

      /* START 고객사 자동완성 */
      vm.ACClientNm = "__undefined__";
      vm.ACClientNmTimerId = null;

      vm.onChangeClientNm = function(item) {
        if (vm.ACClientTimerId != null) {
          clearTimeout(vm.ACClientNmTimerId);
        }

        vm.ACClientNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACClientNm != item && !check.test(item)) {
            // 고객사리스트
            postApi.select({mapCode: 'AutoComplete.getClientList', ClientNm: item}, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function(item){
                  item.CodeValue = item.ClientNm;
                });
                vm.codeClientList = result.body.docs;
              }

              vm.ACClientNm = item;
            });
          }
        }, 100);
      };

      function addClient(){
        var ctrl = 'ClientEditModalCtrl as vc';
        var paramData = {popup : 'Y'};
        var modalInstance = modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
          var data = angular.copy(okData);
          getSetClient(data);
        }, function (cancelData) {
        });
      }
      /* END 고객사 자동완성 */

      /* START 고객 자동완성 */
      vm.ACCustNm = "__undefined__";
      vm.ACCustNmTimerId = null;

      vm.onChangeCustNm = function (item) {
        if (vm.ACCustNmTimerId != null) {
          clearTimeout(vm.ACCustNmTimerId);
        }

        vm.ACCustNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACCustNm != item && !check.test(item)) {
            // 영업담당자사리스트
            postApi.select({ mapCode: 'AutoComplete.getCustList', CustNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.CustNm;
                });
                vm.codeCustList = result.body.docs;
              }

              vm.ACCustNm = item;
            });
          }
        }, 100);
      };

      



      
      /* END 고객 자동완성 */
      
      /* START 영업담당자 자동완성 */
      vm.ACManagerNm = "__undefined__";
      vm.ACManagerNmTimerId = null;

      vm.onChangeManagerNm = function (item) {
        if (vm.ACManagerNmTimerId != null) {
          clearTimeout(vm.ACManagerNmTimerId);
        }

        vm.ACManagerNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACManagerNm != item && !check.test(item)) {
            // 영업담당자사리스트
            postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.UserNm;
                });
                vm.codeManagerList = result.body.docs;
              }

              vm.ACManagerNm = item;
            });
          }
        }, 100);
      };

      function setManagerCode(data) {
        //console.log(data.UserId);
        vm.data.ManagerId = data.UserId;
      }
      


      /* END 영업담당자 자동완성 */

      

      //#endregion 고객사 자동완성 목록
      //고객사 등록/수정 저장버튼 클릭
      function setData() {
        if (getIsValidData()) {

          busiInfoEtcText = $('#busiInfoEtc').val();
          var BusiInfo = "";
          
          //기타 선택했는지 확인 
          if (busiInfoEtcText != null && busiInfoEtcText != "") {
            BusiInfo = busiInfoEtcText;
            //기타담당사업
            vm.data.ETCRole = busiInfoEtcText;
          }
          // 체크박스 
          var checkboxes = document.getElementsByName('busiInfo');
          var selected = [];
          
          for (var i = 0; i < checkboxes.length; i++) {
              if (checkboxes[i].checked) {
                  selected.push(checkboxes[i].value);
              }
          }
          // 선택된 체크박스가 하나면 그대로 두개이상이면 ,로 구분
          var svcRoleList = [];
          for (i = 0; i < selected.length; i ++) {
            var svcRoleMap = {};
            if (i == 0 && BusiInfo != "") {
              BusiInfo += ", " + selected[i];
            }
            else if (i == 0 && BusiInfo == "") {
              BusiInfo += selected[i] + ""; 
            }
            else  {
              BusiInfo += "," + selected[i];
              
            }
            svcRoleMap.SVCRole = selected[i];
            svcRoleList.push(svcRoleMap);
            
          }
          //Mainrole 관련사업(KIESLGMQB) == KEYMAN Y용으로 관련사업 수 만큼 TB_COMP_MEMBER에 INSERT한다.
          svcRoleList.sort();
          vm.data.SVCRole = svcRoleList;
          // 아무것도 체크가 안되어 있으면 기본값은 없음
          if (BusiInfo == null || BusiInfo == "") {
            vm.data.CustRole = "";
          } else {
            var custArray = BusiInfo.split(",");
            custArray = custArray.sort();
            custArray = custArray.join(",");
            vm.data.CustRole = custArray;
          }

          //SVC 출처 미선택시 기본값 CRM
          if (vm.data.SVCSystem == null || vm.data.SVCSystem == "" || vm.data.SVCSystem == "CRM")  {
            vm.data.SVCSystem = "C";
          }

          var tele = vm.data.EncryptMobile;
          //전화번호 뒤자리 4자리 저장 
          vm.data.Mobile4 = tele.slice(tele.length - 4);

          //working 미선택시 재직을 기본값으로
          if (vm.data.Working == null || vm.data.Working == "") {
            vm.data.Working = 'Y';
          }
          /* vm.data.Department = $('#custDept').val();
          vm.data.Title = $('#custTitle').val(); */
          vm.data.LoginId = LoginId;
          //console.log(vm.data);
          newParam = vm.data;

          if (oldParam.AgreeSMS != newParam.AgreeSMS) {
            if (newParam.AgreeSMS == 'Y' ) {
              newParam.AgreeSMSDT = moment.utc(vm.data.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              newParam.DenialSMSDT = null;
            }
            if (newParam.AgreeSMS == 'N') {
              newParam.AgreeSMSDT = null;
              newParam.DenialSMSDT = moment.utc(vm.data.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
          } 

          if (oldParam.AgreeEmail != newParam.AgreeEmail) {
            if (newParam.AgreeEmail == 'Y') {
              newParam.AgreeEmailDT = moment.utc(vm.data.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일동의일시
              newParam.DenialEmailDT = null;
            }
            if (newParam.AgreeEmail == 'N') {
              newParam.AgreeEmailDT = null;
              newParam.DenialEmailDT = moment.utc(vm.data.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일거부일시
            }
          }


          if (oldParam.AgreeSMS == newParam.AgreeSMS) {
            if (newParam.AgreeSMS == 'Y' ) {
              newParam.AgreeSMSDT = moment.utc(vm.data.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              newParam.DenialSMSDT = null;
            }
            if (newParam.AgreeSMS == 'N') {
              newParam.AgreeSMSDT = null;
              newParam.DenialSMSDT = moment.utc(vm.data.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
          }
          if (oldParam.AgreeEmail == newParam.AgreeEmail) {
            if (newParam.AgreeEmail == 'Y') {
              newParam.AgreeEmailDT = moment.utc(vm.data.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일동의일시
              newParam.DenialEmailDT = null;
            }
            if (newParam.AgreeEmail == 'N') {
              newParam.AgreeEmailDT = null;
              newParam.DenialEmailDT = moment.utc(vm.data.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일거부일시
            }
          }
          
          //직장 재직여부 변경 
          if(oldParam.Working == 'Y' && newParam.Working == 'N' && oldParam.ClientId == newParamClientId) {
            setOldClient();
          }
          /* //직장변경시! 또는 새로운 직장 추가시
          if (oldParam.ClientId != newParam.ClientId ) {
            //과거직장정보 재직상태 변경
            console.log('setOldClient' + newParam);
            //setOldClient();

            //새로운직장정보 추가
            console.log('setNewClient' + newParam);
            //setNewClient();
          } */
          
          // 고객 기본정보 수정 및 사업정보 해제시 
          else {

            // 수정사항 저장 및 선택 해제된 사업정보 Working 'N' 처리
            updateKSACustBatch();

            // 추가된 사업정보 만큼 고객 소속 생성
            if (oldParam.CustRole != newParam.CustRole && newParam.CustRole != null && newParam.CustRole != '') {
              insertSVCRole();
            }
            

            // 변경 이력 저장 
            //변경이력 비교시 날짜시간비교를 위해 oldParam의 값들도 변경해준다. 

            if (oldParam.AgreeSMS == 'Y' ) {
              oldParam.AgreeSMSDT = moment.utc(oldParam.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              oldParam.DenialSMSDT = null;
            }
            if (oldParam.AgreeSMS == 'N') {
              oldParam.AgreeSMSDT = null;
              oldParam.DenialSMSDT = moment.utc(oldParam.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
            if (oldParam.AgreeEmail == 'Y' ) {
              oldParam.AgreeEmailDT = moment.utc(oldParam.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              oldParam.DenialEmailDT = null;
            }
            if (oldParam.AgreeSMS == 'N') {
              oldParam.AgreeEmailDT = null;
              oldParam.DenialEmailDT = moment.utc(oldParam.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
            compareMaps(oldParam, newParam);
            
            
            var url = "app.client.ksacust-detail";
            var param = {};
            param.srch = '';
            param = JSON.stringify(param);
            $state.go(url, JSON.parse(param) , {reload: url});

            /* av.confirm("Menu.SAVECONFIRM2", function(){
              console.log(vm.data);
              av.commit(function(result){

                av.alert('Menu.SAVED', function(){
                  var url = "app.client.ksacust-detail";
                  var param = {};
                  param.srch = '';
                  
                  param = JSON.stringify(param);
                  $state.go(url, JSON.parse(param) , {reload: url});
                });
              });
            });  */
            //compareMaps(oldParam, newParam);
          }

        }
        
        
      }

      /* 고객사가 변경되는 경우 기존의 고객소속에서 재직상태 변경 */
      function setOldClient() {
        vm.dataloader = true;
        var newData = {};
        newData = oldParam;
        //newData.LoginId = LoginId;
        newData.mapCode = "KSACust.updateOldClientInfo";

        postApi.update(newData, function(result) {
          vm.dataloader = false;
          
        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        
      }
      /* 고객사가 변경된경우 고객사정보와 고객소속을 변경 */
      function setNewClient() {
        vm.dataloader = true;
        var newData = {};
        newData = newParam;
        newData.LoginId = LoginId;
        newData.mapCode = "KSACust.insertNewClientInfoBatch";
        postApi.insert(newData, function(result) {
          vm.dataloader = false;

        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        
      }

      function updateKSACustBatch() {
        vm.dataloader = true;
        var newData = {};
        newData = newParam;
        newData.LoginId = LoginId;
        newData.mapCode = "KSACust.updateKSACustBatch";
        postApi.insert(newData, function(result) {
          vm.dataloader = false;

        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
      }

      function insertSVCRole() {
        vm.dataloader = true;
        var newData = {};
        //원래의 사업정보에서 추가된 사업정보만 추려 해당 사업정보를 새로 insert한다.
        var a = oldParam.CustRole;
        var b = newParam.CustRole;
        var clist = [];
        for (var i = 0; i < b.length; i++) {
          var setMap = {};
          if (a.indexOf(b[i]) == -1 && b[i] != ',') {
            setMap.newRole = b[i];
            clist.push(setMap);
          }
        }
        newData = newParam;
        newData.LoginId = LoginId;
        newData.NewCustRole = clist;
        newData.mapCode = "KSACust.insertSVCRole";
        postApi.insert(newData, function(result) {
          vm.dataloader = false;
        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
      }

      function compareMaps(map1, map2) {
        //var testVal;
        vm.dataloader = true;
        var histData = {};

        var oldParamKey = Object.keys(map1);
        var newParamKey = Object.keys(map2);
        var oldParamVal = Object.values(map1);
        var newParamVal = Object.values(map2);

        var list = [];
        
        for(var i = 0; i < oldParamKey.length; i++) {
          
          if (oldParamVal[i] != newParamVal[i] && oldParamKey[i] != 'SVCRole') {
            var mapData = {};
            mapData.beforeVal = oldParamVal[i];
            mapData.ColNm = oldParamKey[i];
            mapData.afterVal = newParamVal[i];
            
            list.push(mapData);
          }

        }

        histData.alist = list; 
        
        //고객의 경우 출처가 하나
        histData.SVCSystem = vm.data.SVCSystem;
        histData.KeyId = vm.data.KeyId;
        histData.mapcode = "KSACust.insertKSACustUpdateHist";
        //console.log(histData);
        
        postApi.insert(histData, function(result) {
          vm.dataloader = false;

        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        vm.dataloader = false;
      }



      


      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        //var srch = $stateParams.srch; // 검색 옵션
        var srch = '';
        $state.go('app.client.ksacust-list', {
          srch: srch
        });
      }

      var busiInfoEtcText = "";
      // 체크박스 기타 체크시 인풋 열어주기
      $scope.clickCheckBoxEtc = function(event) {
        var checkBox = document.getElementById("inlineCheckbox12");
        if (checkBox.checked) {
          $('#busiInfoEtc').attr('readonly', false);
        } else {
          $('#busiInfoEtc').attr('readonly', true);
        }
        
      };

      var cidArr = [], ctelArr = [], cfaxArr = [], cnmArr = [], czipArr = [], cManNmArr = [],
      caddr1Arr = [], caddr2Arr = [], cSVCRole = [], cWorkingArr = [], cKeyManArr = [], 
      cDeptArr = [], cManIdArr = []; 
      vm.toggle = 0;
      vm.toggleY = false;

      //직장정보변경 버튼
      //직장정보가 2개 이상인 경우 버튼클릭시 직장정보를 변경하여 보여준다. 
      //변경될때마다 oldParam의 값을 변경하여 저장한다. 
      function toggleClientInfo() {
        
        if (vm.toggle < cidArr.length) {
          vm.data.ClientId = cidArr[vm.toggle];
          vm.data.ClientNm = cnmArr[vm.toggle];
          vm.data.CompTel = ctelArr[vm.toggle];
          vm.data.Fax = cfaxArr[vm.toggle];
          vm.data.ZipCode = czipArr[vm.toggle];
          vm.data.Address1 = caddr1Arr[vm.toggle];
          vm.data.Address2 = caddr2Arr[vm.toggle];
          vm.data.Working = cWorkingArr[vm.toggle];
          vm.data.KeyMan = cKeyManArr[vm.toggle];
          vm.data.DeptCode = cDeptArr[vm.toggle];
          //담당본부 설정
          setDeptCodes();
          vm.data.ManagerId = cManIdArr[vm.toggle];
          vm.data.ManagerNm = cManNmArr[vm.toggle];
          //영업담당자 설정
          setManagerNms(cManNmArr[vm.toggle]);
          //직장정보에 따른 사업정보 변경
          //console.log(cSVCRole[vm.toggle]);
          setCustRole(cSVCRole[vm.toggle]);
          
          vm.toggle += 1;
        }
        else {
          vm.toggle = 0;
          vm.data.ClientId = cidArr[vm.toggle];
          vm.data.ClientNm = cnmArr[vm.toggle];
          vm.data.CompTel = ctelArr[vm.toggle];
          vm.data.Fax = cfaxArr[vm.toggle];
          vm.data.ZipCode = czipArr[vm.toggle];
          vm.data.Address1 = caddr1Arr[vm.toggle];
          vm.data.Address2 = caddr2Arr[vm.toggle];
          vm.data.Working = cWorkingArr[vm.toggle];
          vm.data.KeyMan = cKeyManArr[vm.toggle];
          vm.data.DeptCode = cDeptArr[vm.toggle];
          //담당본부 설정
          setDeptCodes();
          vm.data.ManagerId = cManIdArr[vm.toggle];
          vm.data.ManagerNm = cManNmArr[vm.toggle];
          //영업담당자 설정
          setManagerNms(cManNmArr[vm.toggle]);
          //직장정보에 따른 사업정보 변경
          //console.log(cSVCRole[vm.toggle]);
          setCustRole(cSVCRole[vm.toggle]);
          vm.toggle += 1;
        }
        //고객사 정보가 변경될때마다 oldParam정보 저장 변경
        oldParam = angular.copy(vm.data);
        oldParam.ClientId = vm.data.ClientId;
        oldParam.ClientNm = vm.data.ClientNm;
        oldParam.CompTel = vm.data.CompTel;
        oldParam.Fax = vm.data.Fax;
        oldParam.ZipCode = vm.data.ZipCode;
        oldParam.Address1 = vm.data.Address1;
        oldParam.Address2 = vm.data.Address2;
        oldParam.Working = vm.data.Working;
        oldParam.KeyMan = vm.data.KeyMan;
        oldParam.DeptCode = vm.data.DeptCode;
        oldParam.ManagerId = vm.data.ManagerId;
        oldParam.ManagerNm = vm.data.ManagerNm;
        oldParam.CustRole = vm.data.CustRole;
      }

      // 고객의 담당지역본부 설정.. 직장정보마다 바껴야함.. 
      function setDeptCodes() {
        
        /* if (vm.data.DeptCode != '' && vm.data.DeptCode != null) {
          for (var i = 0; i < $scope.DeptBox.length; i++) {
            if ( vm.data.DeptCode == $scope.DeptBox[i].Code) {
              $scope.thisDept = $scope.DeptBox[i];
            }
          }
        } */
        $scope.selectedDept = vm.data.DeptCode;
      }

      


      function setCustRole(cRole) {
        //var svcArray = vm.data.CustRole.split(",");
        vm.data.CustRole = cRole;
        var chk = document.getElementsByName('busiInfo');
        var isAllCheck = false;
        for(var a = 0; a < chk.length; a++){
          chk[a].checked = isAllCheck;
        }   
        for(var i = 0; i < cRole.length; i++) {
          if (cRole[i] == 'K') {
            document.getElementById("inlineCheckbox1").checked = true;
          }
          if (cRole[i] == 'I') {
            document.getElementById("inlineCheckbox2").checked = true;
          }
          if (cRole[i] == 'E') {
            document.getElementById("inlineCheckbox3").checked = true;
          }
          if (cRole[i] == 'L') {
            document.getElementById("inlineCheckbox4").checked = true;
          }
          if (cRole[i] == 'M') {
            document.getElementById("inlineCheckbox5").checked = true;
          }
          if (cRole[i] == 'Q') {
            document.getElementById("inlineCheckbox6").checked = true;
          }
          if (cRole[i] == 'B') {
            document.getElementById("inlineCheckbox7").checked = true;
          }
          if (cRole[i] == 'N') {
            document.getElementById("inlineCheckbox8").checked = true;
          }
          if (cRole[i].length > 1) {
            document.getElementById("inlineCheckbox12").checked = true;
            $('#busiInfoEtc').val(cRole[i]);
          }
        }
      }
      
      /* 
      온레디오토뷰 초기 정보세팅.
      
      */
      function onReadyAutoView() {
        
        // 초기 설정
        // 사업정보 
        // CustRole은 TB_MEMBER의 CustRole이 아닌 고객소속 TB_COMP_MEMBER의 SVCROLE을 
        // ,로 구분하여 합쳐진 값을 CUSTROLE로 받아온다. 
        // 이후 받아온 CUSTROLE의 각 값을 조사하여 체크박스로 표시한다. 
        
        
        var i = 0;
        var data = {};
        data = vm.data;
        
        if (data.TBDCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_SALESPLAN') {
              vm.tabList[i].Text = '영업일지(' + data.TBDCnt + ')';
            }
          }

        }
        if (data.TBOCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_BUSINESSPLAN') {
              vm.tabList[i].Text = '사업기회(' + data.TBOCnt + ')';
            }
          }

        } 
        if (data.KSCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_KS') {
              vm.tabList[i].Text = 'KS(' + data.KSCnt + ')';
            }
          }

        } 
        if (data.ISOCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_ISO') {
              vm.tabList[i].Text = 'ISO(' + data.ISOCnt + ')';
            }
          }

        } 
        if (data.ECCCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_ENERGY') {
              vm.tabList[i].Text = '에너지(' + data.ECCCnt + ')';
            }
          }

        } 
        if (data.LMSCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_EDUCATION') {
              vm.tabList[i].Text = '교육(' + data.LMSCnt + ')';
            }
          }

        } 
        if (data.KSSNCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_NETWORK') {
              vm.tabList[i].Text = '표준정보망(' + data.KSSNCnt + ')';
            }
          }

        } 
        if (data.MBRCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_MEMBERS') {
              vm.tabList[i].Text = '회원사(' + data.MBRCnt + ')';
            }
          }

        } 
        if (data.QCCCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_QUALITYCONTROL') {
              vm.tabList[i].Text = '분임조(' + data.QCCCnt + ')';
            }
          }

        } 
        if (data.BKMCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_BREAKFAST') {
              vm.tabList[i].Text = '조찬(' + data.BKMCnt + ')';
            }
          }

        }
        /* if (data.SupportCnt > 0) {
          var tab13 = '지원사업(' + data.SupportCnt + ')';
          $("#SupportCnt").text(tab13);
        }
        if (data.AlertCnt > 0) {
          var tab14 = '조기경보(' + data.AlertCnt + ')';
          $("#AlertCnt").text(tab14);
        } */
        if (data.THFCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_HISTORY') {
              vm.tabList[i].Text = '변경이력(' + data.THFCnt + ')';
            }
          }

        } 
        if (data.CompCnt > 0) {
          for(i = 0; i < vm.tabList.length; i++) {
            if (vm.tabList[i].Page == 'VIEW_PAGE_COMP') {
              vm.tabList[i].Text = '직장이력(' + data.CompCnt + ')';
            }
          }

        } 
        
        //초기값 저장
        //현 고객의 고객사가 2곳이상이라면 클라이언트 아이디가 ,로 구분되어 넘어온다. 
        //이때 컴마를 조사하여 고객사가 여러곳인지 아닌지 확인
        if (!isNullOrEmpty(vm.data.ClientId)) {
          if (vm.data.ClientId.indexOf(",") != -1) {
            vm.toggleY = true;
            //고객사가 여러곳이라면 toggleY를 true로 설정 
            //고객사 정보를 모두 ,로 나누어 어레이에 담는다.
            cidArr = vm.data.ClientId.split(",");
            cnmArr = vm.data.ClientNm.split(",");
            //cSVCRole = vm.data.SVCRole.split("/");
            if (vm.data.CompTel.split(",").length > 1) {
              ctelArr = vm.data.CompTel.split(",");
            }
            if (vm.data.Fax.split(",").length > 1) {
              cfaxArr = vm.data.Fax.split(",");
            }
            if (vm.data.ZipCode.split(",").length > 1) {
              czipArr = vm.data.ZipCode.split(",");
            }
            if (vm.data.Address1.split(",").length > 1) {
              caddr1Arr = vm.data.Address1.split(",");
            }
            if (vm.data.Address2.split(",").length > 1) {
              caddr2Arr = vm.data.Address2.split(",");
            }
            //고객의 사업정보는 고객사별로 / 로 나뉘고 사업정보별로 , 나뉜다.
            if (vm.data.CustRole.split("/").length > 1) {
              cSVCRole = vm.data.CustRole.split("/");
            }
            if (vm.data.ManagerId.split(",").length > 1) {
              cManIdArr = vm.data.ManagerId.split(",");
            }
            if (vm.data.DeptCode.split(",").length > 1) {
              cDeptArr = vm.data.DeptCode.split(",");
            }
            if (vm.data.Working.split(",").length > 1) {
              cWorkingArr = vm.data.Working.split(",");
            }
            if (vm.data.KeyMan.split(",").length > 1) {
              cKeyManArr = vm.data.KeyMan.split(",");
            }
            if (vm.data.ManagerNms.split(",").length > 1) {
              cManNmArr = vm.data.ManagerNms.split(",");
            }
            //직장정보 전환을 위한 함수 실행
            toggleClientInfo();
          } else {
            //직장정보가 하나 임으로 사업정보만 split가능한경우.. (",")으로 스플릿

            var cRole = vm.data.CustRole.split(",");
            cRole.sort();
            setDeptCodes();
            setCustRole(cRole);
            if (vm.data.ManagerNms != null && vm.data.ManagerNms != '') {
              cManNmArr = vm.data.ManagerNms.split(",");
              vm.data.ManagerNm = cManNmArr[0];
            }
            vm.toggleY = false;
            if (vm.data.AgreeSMS == 'Y' ) {
              vm.data.AgreeSMSDT = moment.utc(vm.data.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              vm.data.DenialSMSDT = "";
            } 
            if (vm.data.AgreeEmail == 'Y') {
              vm.data.AgreeEmailDT = moment.utc(vm.data.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일동의일시
              vm.data.DenialEmailDT = "";
            }
            if (vm.data.AgreeSMS == 'N') {
              vm.data.AgreeSMSDT = "";
              vm.data.DenialSMSDT = moment.utc(vm.data.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
            if (vm.data.AgreeEmail == 'N') {
              vm.data.AgreeEmailDT = "";
              vm.data.DenialEmailDT = moment.utc(vm.data.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일거부일시
            }
            
            oldParam = angular.copy(vm.data);
          }
        } else {
          //직장정보가 없는 경우 영업담당자 / 담당지역본부 정보가 없다. 
          vm.data.ManagerNm = "";
          if (vm.data.AgreeSMS == 'Y' ) {
            vm.data.AgreeSMSDT = moment.utc(vm.data.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
            vm.data.DenialSMSDT = "";
          } 
          if (vm.data.AgreeEmail == 'Y') {
            vm.data.AgreeEmailDT = moment.utc(vm.data.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일동의일시
            vm.data.DenialEmailDT = "";
          }
          if (vm.data.AgreeSMS == 'N') {
            vm.data.AgreeSMSDT = "";
            vm.data.DenialSMSDT = moment.utc(vm.data.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
          } 
          if (vm.data.AgreeEmail == 'N') {
            vm.data.AgreeEmailDT = "";
            vm.data.DenialEmailDT = moment.utc(vm.data.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일거부일시
          }
          
          oldParam = angular.copy(vm.data);
          
          oldParam.CustRole = curole;
        }
        //console.log(vm.data.DeptCode);
        
      }
      
      function setManagerNms(ManNm) {
        //console.log(ManNm);
        vm.data.ManagerNm = ManNm;
      }

      //고객사 정보입력
      function getSetClient() {
        
        var data = vm.data;
        //data.ClientId = client.ClientId;
        data.mapCode = 'KSACust.setCompanyData';
        
        /* 고객명 클릭시 해당 고객사 정보 불러와서 입력 */
        postApi.select(data, function(result) {
          //mapCode: 'KSACust.setCompanyData'
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            var cdata = result.body.docs[0];
            vm.data.CompTel = cdata.CompTel;
            vm.data.Fax = cdata.Fax;
            vm.data.ZipCode = cdata.ZipCode;
            vm.data.Address1 = cdata.Address1;
            vm.data.Address2 = cdata.Address2;
            vm.data.ClientId = cdata.ClientId;
            
            //detailOpen();
          }
        },function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        
      }
      //detailOpen();


      
    
      
      

      //#region 필수항목 체크
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';

        if (isNullOrEmpty(vm.data.ClientNm)) {
          errMsg = errMsg + '- 고객사를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.EncryptNm)) {
          errMsg = errMsg + '- 고객 이름을 입력하세요.<br/>';
        }
        
        /* if (isNullOrEmpty(vm.data.CompTel)) {
          errMsg = errMsg + '- 직장 전화번호를 입력하세요.<br/>';
        } */
        if (isNullOrEmpty(vm.data.EncryptMobile)) {
          errMsg = errMsg + '- 휴대전화를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.EncryptEmail)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }
        /* if (isNullOrEmpty(vm.data.AgreeEmail)) {
          errMsg = errMsg + '- 이메일 마케팅 수신여부를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.AgreeSMS)) {
          errMsg = errMsg + '- SMS 마케팅 수신여부를 입력하세요.<br/>';
        } */

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn = false;
        }
        return bRtn;
      }
      //#endregion 필수항목 체크




      // 함수 정의
      vm.onReadyAutoView = onReadyAutoView;
      vm.setManagerCode = setManagerCode;
      vm.setChangeTabPosition = setChangeTabPosition;
      vm.setDeptSelect = setDeptSelect;
      vm.toggleClientInfo = toggleClientInfo;
      vm.addClient = addClient;
      vm.getSetClient = getSetClient; //고객사 정보입력
      //vm.setClientCode = setClientCode;
      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;             // 탭 이동 설정
      vm.setData = setData; 
      
      var av = new autoView();
      av.init(autoViewOption);
    }]);
})();
  (function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.client:ksacust-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객 조회
   */
  webapp.controller('KSACustListCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window', 'modalFactory',
    function KSACustListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window, modalFactory) {

      var vm = this;
      vm.dataloader = false;
      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'KSACust.getKSACustListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'KSACust.getKSACustList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.client.ksacust-list';       // 조회 화면
      var LIST_DETAIL_PAGE_URL = 'app.client.ksacust-detail';  // 목록 조회  화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'TB_MEMBER'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // TB_MEMBER PK

      //vm.headerTitle = "고객리스트";
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          //ClientId: !isNullOrEmpty($stateParams.ClientId) ? $stateParams.ClientId : '',
          TenantId : vm.TenantId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        //vm.srch.ClientId = $stateParams.ClientId;
        vm.srch.TenantId = vm.TenantId;
      }
      //휴대전화 4자리 limit
      $scope.limitKeypress = function ($event, value, maxLength) {
        if (value != undefined && value.toString().length >= maxLength) {
          $event.preventDefault();
        }
      };

      vm.SelectBox = [
        {id : "", name : "- 조회기준 -"},
        {id: "All", name :"전체"}, 
        {id: "Dept", name :"부서"},
        {id: "Person", name :"개인"}
      ];

      vm.SortBox = [
        {id: "", name : " - 정렬기준 -"},
        {id: "CreatedDate", name: '최근등록'},
        {id: "UpdatedDate", name: '최근수정'},
        //{id: "ClientScore", name: '고객사등급'}
      ];

      $scope.selectedRow = $stateParams.KeyId;

/*       vm.metadataChanged = function() {
        var srch = '';
        if (vm.srch != '') {
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
      }; */

      if (vm.srch.SortBy != '' && vm.srch.SortBy != null) {
        for(var i = 0; i < vm.SortBox.length; i++) {
          if ( vm.srch.SortBy == vm.SortBox[i].id) {
            vm.SortBy = vm.SortBox[i];
          }
        }
      } else {
        vm.SortBy = vm.SortBox[0];
      }

      if (vm.srch.SelectBy != '' && vm.srch.SelectBy != null) {
        for(var j = 0; j < vm.SelectBox.length; j ++) {
          if (vm.srch.SelectBy == vm.SelectBox[j].id) {
            vm.SelectBy = vm.SelectBox[j];
          }
        }
      } else {
        vm.SelectBy = vm.SelectBox[0];
      }
      vm.thisSort = vm.SortBy;
      vm.thisSelect = vm.SelectBy;

  
          
      vm.listOptions = {
        addColumn : {
          AddClientInfo : {
            title : "직장추가",
            after : "DeptCode",
            template : '<button class="btn btn-default ng-binding" ng-click="vc.addCustClient(li.KeyId, $event)"><i class="fa fa-building-o"></i>직장추가</button>',
            size : "100px",
            textAlign : "center",
          }
        },

        html : {
          //AddClient : {
          //  template: '<button class="btn btn-danger"><i class="fa fa-trash-o"></i>직장추가</button>'  
          // },
        },
      };
      
     
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_MEMBER",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustListCnt", param : null},
          initSelect : { mapCode : "KSACust.getKSACustList", param : null },
        },


        addSrchStack : true,
        // List
        listCheckboxEnable : false,

        src : {
          detail : "app.client.ksacust-detail",
        },
      };

      vm.ksacustEditModal = function() {
        var ctrl = 'KSACustEditModalCtrl as vc';
        modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl);
      };


      //정렬 셀렉트박스와 조회기준 셀렉트 박스 설정값 저장
      function setSortSelect() {
        vm.srch.SortBy = vm.thisSort.id;
        vm.srch.SelectBy = vm.thisSelect.id;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      vm.addCustClient = function(KeyId, e) {
        e.stopPropagation();
        var ctrl = 'KSACustEditModalCtrl as vc';
        var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, KeyId);
        modalInstance.result.then(function (okData) {
          // ok버튼
          av.init(autoViewOption);
        }, function (cancelData) {
          // cancel버튼
        });
      };

      function onReadyAutoView() {
        setSVCSystem();
      }

      /* 출처(사업정보/사업실적) 정의.... */
      function setSVCSystem() {
        //vm.dataloader = true;
        var data = {};
        //console.log(vm.lists);
        data = vm.lists;
        //console.log(data);
        var svcValue = "";
        var svcArray = [];
        if (data.length > 0) {
          for(var o = 0; o < data.length; o++) {
            svcValue = data[o].CustRole;
            var busiCnt = "";
            if ( data[o].CustRole != null || data[o].CustRole != ''){
              svcArray = data[o].CustRole.split(",");
              for(var i = 0; i < svcArray.length; i++) {
                if(svcArray[i] == 'K') {
                  svcArray[i] = 'KS';
                  if (data[o].KSCnt >= 0) {
                    busiCnt += "KS(" + data[o].KSCnt + ") ";
                  }
                }
                if(svcArray[i] == 'I') {
                  svcArray[i] = 'ISO';
                  if (data[o].ISOCnt >= 0) {
                    busiCnt += "ISO(" + data[o].ISOCnt + ") ";
                  }
                }
                if(svcArray[i] == 'E') {
                  svcArray[i] = '에너지';
                  if (data[o].ECCCnt >= 0) {
                    busiCnt += "에너지(" + data[o].ECCCnt + ") ";
                  }
                }
                if(svcArray[i] == 'L') {
                  svcArray[i] = '교육';
                  if (data[o].LMSCnt >= 0) {
                    busiCnt += "교육(" + data[o].LMSCnt + ") ";
                  }
                }
                if(svcArray[i] == 'M') {
                  svcArray[i] = '회원사';
                  if (data[o].MBRCnt >= 0) {
                    busiCnt += "회원사(" + data[o].MBRCnt + ") ";
                  }
                }
                if(svcArray[i] == 'Q') {
                  svcArray[i] = '분임조';
                  if (data[o].QCCCnt >= 0) {
                    busiCnt += "분임조(" + data[o].QCCCnt + ") ";
                  }
                }
                if(svcArray[i] == 'B') {
                  svcArray[i] = '조찬회';
                  if (data[o].BKMCnt >= 0) {
                    busiCnt += "조찬회(" + data[o].BKMCnt + ") ";
                  }
                }
                if(svcArray[i] == 'N') {
                  svcArray[i] = '표준정보망';
                  if (data[o].KSSNCnt >= 0) {
                    busiCnt += "표준정보망(" + data[o].KSSNCnt + ") ";
                  }
                }
                if (svcArray[i] == 'S') {
                  svcArray[i] = 'ETL';
                }
  
              }
              busiCnt.replace(' ',',');
              // 바꾸어준 사업 정보를 기입
              data[o].CustRole = svcArray;
              data[o].BusiInfoCnt = busiCnt;
            }
            
            
            
            
          }
        }
        
        //vm.dataloader = false;
      }

      //중복고객통합 모달
      vm.openCustMergeModal = function() {
        console.log('openCustMergeModal');
        var KeyIds = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            var KeyId = vm.lists[i].KeyId;
            KeyIds.push(KeyId);
          }
        }
        if (vm.KeyIdList == null || vm.KeyIdList.length < 2) {
          av.alert('두명이상의 중복 고객을 선택해 주세요.', function(){ });
          return false;
        }

        if (vm.KeyIdList != null || vm.KeyIdList.length >= 2) {
          var ctrl = 'KSACustMergeModalCtrl as vc';
          modalFactory.open('mf-80', 'app/client/modal/ksacust-merge-modal.html', ctrl, KeyIds);
        }
        

      };
      






      // 함수 정의
      //vm.goDetail = goDetail;
      vm.setSortSelect = setSortSelect;
      vm.setSVCSystem = setSVCSystem;
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);

      





    }]);
  })();
webapp.controller('KSACustMergeListCtrl', [ '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert', 'gConfirm',
    function KSACustMergeListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert, gConfirm) {
      var vm = this;
      vm.dataloader = false;
      var LoginId = $window.sessionStorage['loginUserId'];
      vm.headerTitle = "중복고객 통합";
      var LIST_PAGE_URL = 'app.client.ksacust-merge-list';       // 조회 화면
      vm.setSortSelect = setSortSelect;
      var KEY_TABLE_NM = 'TB_MEMBER'; // 작업 테이블명

      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          //ClientId: !isNullOrEmpty($stateParams.ClientId) ? $stateParams.ClientId : '',
          TenantId : vm.TenantId,
          //Key : "Y"
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        //vm.srch.ClientId = $stateParams.ClientId;
        vm.srch.TenantId = vm.TenantId;
        //vm.srch.Key = "N";
      }
      //휴대전화 4자리 limit
      $scope.limitKeypress = function ($event, value, maxLength) {
        if (value != undefined && value.toString().length >= maxLength) {
          $event.preventDefault();
        }
      };


      //console.log(data);

      vm.MergeBox = [
        {id : "", name : "- 중복유형 -"},
        {id: "Name", name :"고객명"}, 
        {id: "Mobile", name :"휴대전화"},
        {id: "Email", name :"이메일"},
        {id: "CustTel", name :"전화번호"}
      ];
      if (vm.srch.MergeBy != '' && vm.srch.MergeBy != null) {
        for(var j = 0; j < vm.MergeBox.length; j ++) {
          if (vm.srch.MergeBy == vm.MergeBox[j].id) {
            vm.MergeBy = vm.MergeBox[j];
          }
        }
      } else {
        vm.MergeBy = vm.MergeBox[0];
      }
      vm.thisMerge = vm.MergeBy;
      //정렬 셀렉트박스와 조회기준 셀렉트 박스 설정값 저장
      function setSortSelect() {
        vm.srch.MergeBy = vm.thisMerge.id;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }
      


      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_MERGEMEMBER",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustMergeListCnt", param : null},
          initSelect : { mapCode : "KSACust.getKSACustMergeList", param : null },
        },
        src : {
          detail : "app.client.ksacust-detail",
        },

        addSrchStack : true,
        // List
        listCheckboxEnable : true,

        
      };

      function onReadyAutoView() {
        var data = vm.lists;
        
        /* if (data.length > 0) {
          for (i = 0; i < data.length; i++) {
            var param = Object.values(data[i]);
            var key = Object.keys(data[0]);
            for (j = 0; j < param.length; j++) {
              if ( param[j] == 'null') {
                param[j] = '';
              }
            }
            
          }
        } */
      }

      vm.openMergeModal = function() {
        var KeyIdList = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            KeyIdList.push(vm.lists[i]);
          }
        }
        if (KeyIdList.length < 2) {
          av.alert('통합대상 고객을 선택해 주세요 ', function(){ });
          return false;
        } else {
          var ctrl = 'KSACustMergeModalCtrl as vc';
          modalFactory.open('mf-70', 'app/client/modal/ksacust-merge-modal.html', ctrl, KeyIdList);
        }
      };


      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);
     

    } ]);

(function () {
  "use strict";
  webapp.controller('RememberListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$window', '$state',
      function RememberListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $window, $state) {

        var vm = this;  // View Model
        vm.headerTitle = "리멤버 팀명함 목록";
        vm.showDetailSearch = false;
        var KEY_TABLE_NM = 'TB_MEMBER_REMEMBER'; // 작업 테이블명
        vm.TenantId = $window.sessionStorage['loginTenantId'];

        // 검색값 설정
        if (!$stateParams.srch) {
          vm.srch = {
            tableNm : KEY_TABLE_NM,
            //ClientId: !isNullOrEmpty($stateParams.ClientId) ? $stateParams.ClientId : '',
            TenantId : vm.TenantId,
          };
        } else {
          vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
          //vm.srch.ClientId = $stateParams.ClientId;
          vm.srch.TenantId = vm.TenantId;
        }
        //휴대전화 4자리 limit
        $scope.limitKeypress = function ($event, value, maxLength) {
          if (value != undefined && value.toString().length >= maxLength) {
            $event.preventDefault();
          }
        };
        
        
        vm.SelectBox = [
          {id : "", name : "- 조회기준 -"},
          {id: "All", name :"전체"}, 
          {id: "Dept", name :"부서"},
          {id: "Person", name :"개인"}
        ];

        vm.SortBox = [
          {id: "", name : " - 정렬기준 -"},
          {id: "RegDate", name: '최근명함등록'},
          {id: "EdtDate", name: '최근고객등록'},
        ];

        vm.RegYNBox = [
          {id: "", name : " - CRM등록여부 - "},
          {id: "All", name : " 전체 "},
          {id: "Y", name : "등록완료"},
          {id: "N", name : "미등록"},
        ];


        if (vm.srch.SortBy != '' && vm.srch.SortBy != null) {
          for(var i = 0; i < vm.SortBox.length; i++) {
            if ( vm.srch.SortBy == vm.SortBox[i].id) {
              vm.SortBy = vm.SortBox[i];
            }
          }
        } else {
          vm.SortBy = vm.SortBox[0];
        }
  
        if (vm.srch.SelectBy != '' && vm.srch.SelectBy != null) {
          for(var j = 0; j < vm.SelectBox.length; j ++) {
            if (vm.srch.SelectBy == vm.SelectBox[j].id) {
              vm.SelectBy = vm.SelectBox[j];
            }
          }
        } else {
          vm.SelectBy = vm.SelectBox[0];
        }

        if (vm.srch.RegYNBy != '' && vm.srch.RegYNBy != null) {
          for(var k = 0; k < vm.RegYNBox.length; k++) {
            if (vm.srch.RegYNBy == vm.RegYNBox[k].id) {
              vm.RegYNBy = vm.RegYNBox[k];
            }
          }
        } else {
          vm.RegYNBy = vm.RegYNBox[0];
        }
        vm.thisSort = vm.SortBy;
        vm.thisSelect = vm.SelectBy;
        vm.thisRegYN = vm.RegYNBy;
        

        //정렬 셀렉트박스와 조회기준 셀렉트 박스 설정값 저장
        function setSortSelect() {
          //console.log(vm.thisSort);
          vm.srch.SortBy = vm.thisSort.id;
          vm.srch.SelectBy = vm.thisSelect.id;
          vm.srch.RegYNBy = vm.thisRegYN.id;
          //console.log(vm.srch);
          var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          $state.go('app.client.remember-list', {srch: srch}, {reload: 'app.client.remember-list'});
          //console.log(vm.srch);
        }
        $scope.selectedRow = $stateParams.KeyId;

        var tempSpan = '<span class="list-RegYN">{{li.RegYN}}<span><br><span ng-if="li.ClientNm != null || li.ClientNm != \'\' && li.RegYN == \'미등록\'">  {{li.BSN1}}{{li.ClientNm}}  </span><button class="btn btn-default" ng-if="li.RegYN == \'미등록\'" ng-click="vc.setRememberCustomer(li, $event)"><i class="fa fa-building-o"></i>등록</button>';
        vm.listOptions = {
          addColumn : {
            AddClientInfo : {
              title : "CRM등록여부",
              after : "CreatedDate",
              template : tempSpan,
              size : "200px",
              textAlign : "center",
            }
          },
  
          html : {
            //AddClient : {
            //  template: '<button class="btn btn-danger"><i class="fa fa-trash-o"></i>직장추가</button>'  
            // },
          },
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_MEMBER_REMEMBER",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "Remember.getRememberListCnt", param: null },
            initSelect: { mapCode: "Remember.getRememberList", param: null },
          },

          addSrchStack: true,

          // List
          listCheckboxEnable: true,

          src: {
            detail: "",
            splitDetail: ""
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent
        };

        vm.setRememberCustomer = function(li, e) {
          e.stopPropagation();
          var paramData = li;
          var ctrl = 'KSACustEditModalCtrl as vc';
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            av.init(autoViewOption);
          }, function (cancelData) {
            // cancel버튼
          });
        };

        //동기화 
        vm.getSynchronize = function() {
          var data = {};
//          data.mapCode = 'getRememberApiList';
          postApi.api('getRememberApiList', data, function(result){
            if(result.header.status === CONSTANT.HttpStatus.OK) {
              $state.go('app.client.remember-list', {srch:''}, {reload:'app.client.remember-list'});
            }
          });
            
          
        };

        //#region 목록 삭제
        /* function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'MeetingView.deleteMeetingViewBatch', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.error("Error> setDelList()");
              console.table(error);
            });
          }, function () {

          });
        } */
        //#endregion 목록 삭제


        function clickevent(clickData) {
          //vm.meetViewModal(clickData.KeyId);
        }

        function onReadyAutoView() {
        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.clickevent = clickevent;
        vm.setDelList = setDelList;
        vm.setSortSelect = setSortSelect;
        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function () {
  'use strict';

  webapp.config([
    '$stateProvider',
    '$urlRouterProvider',
    function ($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('app.counsel', {
          url: '/counsel',
          template: '<div ui-view></div>',
        })
        .state('app.counsel.schedule-list', {
          url: '/schedule-list/',
          templateUrl: 'app/counsel/schedule-list.html',
        })
        .state('app.counsel.counselrecord-list', {
          url: '/counselrecord-list',
          templateUrl: 'app/counsel/counselrecord-list.html',
          resolve: {
            plugins: [
              '$ocLazyLoad',
              function ($ocLazyLoad) {
                return $ocLazyLoad.load([
                  'assets/app/vendor/footable/js/footable.js',
                  'assets/app/vendor/footable/css/footable.core.min.css',
                ]);
              },
            ],
          },
        })
        .state('app.counsel.counselrecord-edit', {
          url: '/counselrecord-edit/:CounselRecordId/:CustArmyId',
          templateUrl: 'app/counsel/counselrecord-edit.html',
          params: {
            CounselRecordId: '',
            CustArmyId: '',
          },
        })
        .state('app.counsel.counselrecord-detail', {
          url: '/counselrecord-detail/:CounselRecordId',
          templateUrl: 'app/counsel/counselrecord-detail.html',
        });
    },
  ]);
})();

webapp.controller('CounselrecordDetailCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  'modalFactory',
  function CounselrecordDetailCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalWindow,
    postApi,
    gAlert,
    gConfirm,
    modalFactory
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('counselrecord-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnEdit = isPageAccess('counselrecord-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnDel = true;

    // 함수 연결
    vm.deleteDetail = deleteDetail;
    vm.showModalCounselRecordList = showModalCounselRecordList;
    $scope.HopeDutyListShow = false;
    $scope.HopeDutyEtcShow = false;
    $scope.HopeLocListShow = false;
    $scope.HopeDutyListShow2 = false;
    $scope.HopeDutyEtcShow2 = false;
    $scope.HopeLocListShow2 = false;

    // 검색 데이터
    vm.srch = {
      CounselRecordId: $stateParams.CounselRecordId,
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'counselrecord',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터
    vm.data = {};

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getData() {
      if (vm.srch.CounselRecordId === null || vm.srch.CounselRecordId === '') {
        return;
      }

      vm.srch.mapCode = 'CounselRecord.getCounselRecordDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].CounselRecordId !== null) {
              vm.data = data.body.docs[0];
              if (typeof vm.data.HopeLoc != 'undefined' && vm.data.HopeLoc != '') {
                $scope.HopeLocListShow = true;
              }

              if (typeof vm.data.HopeDuty != 'undefined' && vm.data.HopeDuty != '') {
                $scope.HopeDutyListShow = true;
              }

              if (typeof vm.data.HopeDutyEtc != 'undefined' && vm.data.HopeDutyEtc != '') {
                $scope.HopeDutyEtcShow = true;
              }

              if (typeof vm.data.HopeLoc2 != 'undefined' && vm.data.HopeLoc2 != '') {
                $scope.HopeLocListShow2 = true;
              }

              if (typeof vm.data.HopeDuty2 != 'undefined' && vm.data.HopeDuty2 != '') {
                $scope.HopeDutyListShow2 = true;
              }

              if (typeof vm.data.HopeDutyEtc2 != 'undefined' && vm.data.HopeDutyEtc2 != '') {
                $scope.HopeDutyEtcShow2 = true;
              }

              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          // console.error('fail', status, data);
          console.log('Error> counselrecordDetailCtrl> getData> ', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.srch.CounselRecordId === null || vm.srch.CounselRecordId === '') {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      vm.data.mapCode = 'CounselRecord.deleteCounselRecordDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                deleteWorkData();
                $state.go('app.counsel.counselrecord-list');
              },
            });
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteWorkData() {

      vm.linkObj = {
        p_JC_COUNSEL_RECORD_ID: vm.srch.CounselRecordId,
      };

      postApi.api(
        'extDelete/Linkage.deleteConsultRecord/action',
        vm.linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
              fn: function () {
                vm.dataloader = false;
              },
            });
            console.log('Error-setWorkData' + data.body.docs[0].errMessage);
          }
        },
        function (data) {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
            fn: function () {
              vm.dataloader = false;
            },
          });
          console.log('Error-setWorkData' + data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (이전상담내역)
    function showModalCounselRecordList() {
      if (typeof vm.data.CustArmyId == 'undefined' || vm.data.CustArmyId == '') {
        gAlert('', '성명을 입력해주세요');
        return false;
      }

      $window.open(
        '/#/popup/counsel-record-modal/' + vm.data.CustArmyId,
        'counsel-record-modal:' + vm.data.CustArmyId,
        'scrollbars=yes, width=800, height=500, top=0, left=0'
      );

      /*var ctrl = 'CounselRecordModalCtrl as modalCtrl';
        var paramData = {CustArmyId:vm.data.CustArmyId};
    
        var modalInstance = modalFactory.open('lg', 'views/modal/counsel-record-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
          //vm.data.ArmyId = okData.MM_ID;
          //serchArmyId();
        }, function(cancelData) {
        });*/
    }

    // 데이터 조회
    getData();
  },
]);

webapp.controller('CounselrecordEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$http',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$timeout',
  function CounselrecordEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    $http,
    CONSTANT,
    StaticVariable,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $timeout
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('counselrecord-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 함수연결
    vm.showModalCustInfo = showModalCustInfo;
    vm.clearModalCustInfo = clearModalCustInfo;
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.getData = getData;
    vm.setData = setData;
    vm.setWorkData = setWorkData;
    vm.showModalCounselRecordList = showModalCounselRecordList;
    vm.dataloader = false;
    vm.disabledArea = false;
    /*vm.refreshHopeLocList1 = 0;*/
    $scope.HopeDutyListShow = false;
    $scope.HopeDutyListShow2 = false;
    $scope.HopeLocListShow1 = false;
    $scope.HopeLocListShow2 = false;
    $scope.HopeLocListShow3 = false;
    $scope.HopeLocListShow4 = false;
    $scope.HopeDutyEtcShow = false;
    $scope.HopeDutyEtcShow2 = false;

    (function CounselrecordEditCtrl() {
      if ($stateParams.CustArmyId) {
        var srchCustArmy = {
          CustArmyId: $stateParams.CustArmyId,
          TableNm: 'customerarmy',
          userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        };

        srchCustArmy.mapCode = 'Customerarmy.getCustomerarmyDetail';

        postApi.select(
          srchCustArmy,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt !== 0 && data.body.docs[0].CustArmyId !== null) {
                var okData = data.body.docs[0];

                vm.data.CustNm = okData.CustNm;

                setArmyCustData(okData);
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            // console.log('Error> counselrecordEditCtrl> getData> ', data.body.docs[0].errMessage);
          }
        );
      }
    })();

    if ($window.sessionStorage['loginUserType'] == '030') {
      vm.ArmyClassReadOnly = true;
    } else {
      vm.ArmyClassReadOnly = false;
    }

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselRoundList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1110',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselTimeFromHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselTimeFromMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselTimeToHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselTimeToMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselDateHopeNextHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselDateHopeNextMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField3List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList1 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList3 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList4 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.LastEduList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1220',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.SpecList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1230',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    /* 2025.11.17. 상담방법 변경
    vm.CounselMethodList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1270',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    */
    vm.CounselMethodValueList = [
      '', '전화', '대면', '이메일', '화상', '온라인 메신저'
    ];

    vm.CounselTopicList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1440',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.data.ArmyClass = data.Code;
      } else if (data.CodeType == '1010') {
        vm.data.ArmyType = data.Code;
      } else if (data.CodeType == '1110') {
        //vm.data.CounselRound = data.Code;
      } else if (data.CodeType == '1120') {
        vm.data.CounselDateHopeNextHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.CounselDateHopeNextMin = data.Code;
      } else if (data.CodeType == '1250') {
        vm.data.HopeDuty = data.Code;

        if (data.Code == '151') {
          $scope.HopeDutyEtcShow = true;
        } else {
          $scope.HopeDutyEtcShow = false;
          vm.data.HopeDutyEtc = '';
        }
      } else if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.data.HopeLoc = data.Code;
      } else if (data.CodeType == '1220') {
        vm.data.LastEdu = data.Code;
      } else if (data.CodeType == '1230') {
        vm.data.Spec = data.Code;
      // } else if (data.CodeType == '1270') {
      //   vm.data.CounselMethod = data.Code;
      //   vm.data.CounselMethodValue = data.CodeValue;
      } else if (data.CodeType == '1440') {
        vm.data.CounselTopic = data.Code;
        vm.data.CounselTopicValue = data.CodeValue;
      }
    };

    vm.onSelectCallback2 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.CounselTimeFromHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.CounselTimeFromMin = data.Code;
      }
    };

    vm.onSelectCallback3 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.CounselTimeToHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.CounselTimeToMin = data.Code;
      }
    };

    vm.onSelectCallback4 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1250') {
        vm.data.HopeDuty2 = data.Code;

        if (data.Code == '151') {
          $scope.HopeDutyEtcShow2 = true;
        } else {
          $scope.HopeDutyEtcShow2 = false;
          vm.data.HopeDutyEtc2 = '';
        }
      } else if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.data.HopeLoc2 = data.Code;
      }
    };

    vm.onArmyAreaListSelected = function () {
      var data = vm.data.ArmyAreaObj;

      if (data == null) {
        vm.data.ArmyArea = '';
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }

      vm.data.ArmyArea = data.Code;
      vm.ArmyTypeList.ArmyArea = data.Code;
      vm.PermStat1List.ArmyArea = data.Code;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {

      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.ArmyType = '';
        return;
      }

      vm.data.ArmyType = data.Code;
      vm.data.ArmyAreaType = data.Code;
      //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
      vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.PermStat1 = '';
        return;
      }

      vm.data.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onPermStat2ListSelected = function (data) {

      if (data == null) {
        vm.data.PermStat2 = '';
        return;
      }

      vm.data.PermStat2 = data.Code;
    };

    vm.CounselField2List = {};

    vm.onCounselField1ListSelected = function (data) {
      vm.CounselField2List.CodeType = '';
      vm.CounselField2List.ParentCommonCodeId = '';
      /*vm.refreshHopeLocList1++;*/

      if (data == null) {
        vm.data.CounselField1 = '';
        return;
      }

      vm.data.CounselField1 = data.Code;
      vm.data.CounselField1Value = data.CodeValue;
      vm.CounselField2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField2ListSelected = function (data) {
      if (data == null) {
        vm.data.CounselField2 = '';

        vm.data.HopeDuty = '';
        vm.data.HopeDutyEtc = '';
        vm.data.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
        return;
      }

      vm.data.CounselField2 = data.Code;
      vm.data.CounselField2Value = data.CodeValue;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow = true;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = vm.data.HopeDuty == '151';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = true;
        $scope.HopeDutyEtcShow = false;
      } else {
        vm.data.HopeDuty = '';
        vm.data.HopeDutyEtc = '';
        vm.data.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      }
    };

    vm.CounselField4List = {};

    vm.onCounselField3ListSelected = function (data) {
      vm.CounselField4List.CodeType = '';
      vm.CounselField4List.ParentCommonCodeId = '';
      /*vm.refreshHopeLocList1++;*/

      if (data == null) {
        vm.data.CounselField3 = '';
        return;
      }

      vm.data.CounselField3 = data.Code;
      vm.data.CounselField3Value = data.CodeValue;
      vm.CounselField4List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField4ListSelected = function (data) {
      if (data == null) {
        vm.data.CounselField4 = '';

        vm.data.HopeDuty2 = '';
        vm.data.HopeDutyEtc2 = '';
        vm.data.HopeLoc2 = '';
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
        return;
      }

      vm.data.CounselField4 = data.Code;
      vm.data.CounselField4Value = data.CodeValue;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow2 = true;
        $scope.HopeLocListShow3 = true;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = vm.data.HopeDuty2 == '151';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = true;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = true;
        $scope.HopeDutyEtcShow2 = false;
      } else {
        vm.data.HopeDuty2 = '';
        vm.data.HopeDutyEtc2 = '';
        vm.data.HopeLoc2 = '';
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
      }
    };

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.HopeField1 = '';
        return;
      }

      vm.data.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      /*if (vm.data.HopeField1 == "0") {
          vm.HopeField2ListShow = true;
        }
        else {
          vm.HopeField2ListShow = false;
          vm.data.HopeField2 = "";
        }*/
    };

    vm.onHopeField2ListSelected = function (data) {
      if (vm.data.HopeField1 != '0') {
        vm.data.HopeField2 = '';
        vm.HopeField2ListShow = false;
        //return;
      } else {
        vm.data.HopeField2 = data.Code;
        vm.HopeField2ListShow = true;
      }
    };

    // 검색 데이터
    vm.srch = {
      CounselRecordId: $stateParams.CounselRecordId === undefined ? '' : $stateParams.CounselRecordId,
      UserId: $window.sessionStorage['loginUserIdx'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'counselrecord',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터
    vm.data = {};

    // 기본값
    if (vm.srch.CounselRecordId == 0) {
      vm.data.CounselUser = $window.sessionStorage['loginUserIdx'];
      vm.data.CounselUser_ = $window.sessionStorage['loginUserName'];
      $scope.dtCounselDate = setNewDate(getToday());
      vm.data.CounselDate = getToday();
    }

    // 소속데이터권한 목록
    function getArmyInfoList() {
      vm.srch.mapCode = 'User.getUserarmyinfoList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyInfoList = data.body.docs;
              angular.forEach(vm.ArmyInfoList, function (item) {
                if (item.ArmyArea == '050' || $window.sessionStorage['loginArmyZone5YN'] == 'Y') {
                  vm.ArmyArea5YN = 'Y';
                }
              });
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 유효성검사
    function chkValid() {
      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        gAlert('', '성명을 선택해주세요', {
          fn: function () {
            vm.showModalCustInfo();
          },
        });
        angular.element('input[ng-value="vc.data.CustNm"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        gAlert('', '계급을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyClassList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.ArmyArea == 'undefined' || vm.data.ArmyArea == '') {
        gAlert('', '권역을 선택해주세요');
        angular.element('select[ng-model="vc.data.ArmyAreaObj"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
        gAlert('', '군별을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyTypeList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        gAlert('', '소속부대를 선택해주세요');
        angular.element('common-code[param-data="vc.PermStat1List"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
        gAlert('', '소속부대를 입력해주세요');
        angular.element('input[ng-model="vc.data.PermStat2"]').focus();
        return false;
      }

      if (typeof vm.data.HopeField1 == 'undefined' || vm.data.HopeField1 == '') {
        gAlert('', '상담희망분야를 선택해주세요');
        angular.element('common-code[param-data="vc.HopeField1List"]').children('select').focus();
        return false;
      }

      if (vm.data.HopeField1 == '040') {
        if (typeof vm.data.HopeField2 == 'undefined' || vm.data.HopeField2 == '') {
          gAlert('', '상담희망분야를 선택해주세요');
          angular.element('common-code[param-data="vc.HopeField2List"]').children('select').focus();
          return false;
        }
      } else {
        vm.data.HopeField2 = '';
      }

      if (typeof vm.data.Spec == 'undefined' || vm.data.Spec == '') {
        gAlert('', '병과를 선택해주세요');
        angular.element('common-code[param-data="vc.SpecList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == null || vm.data.InArmyDate == '') {
        gAlert('', '임관일 또는 입대일을 선택해주세요');
        angular.element('input[ng-model="dtInArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == null || vm.data.OutArmyDate == '') {
        gAlert('', '전역일을 입력해주세요');
        angular.element('input[ng-model="dtOutArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == '') {
        gAlert('', '생년월일를 입력해주세요');
        angular.element('input[ng-model="vc.data.ResRegNo"]').focus();
        return false;
      }

      if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        gAlert('', '휴대폰 번호를 입력해주세요');
        angular.element('input[ng-model="vc.data.Mobile"]').focus();
        return false;
      }

      if (typeof vm.data.Email == 'undefined' || vm.data.Email == '') {
        gAlert('', '이메일을 입력해주세요');
        angular.element('input[ng-model="vc.data.Email"]').focus();
        return false;
      }

      /*    if (vm.data.HopeField1 != "040") {
          if (typeof(vm.data.CounselLoc) == "undefined" || vm.data.CounselLoc == "") {
            gAlert('', '희망지역을 선택해주세요');
            return false;
          }
        }*/

      /* if (vm.data.HopeField1 != "020" && vm.data.HopeField1 != "030" && vm.data.HopeField1 != "040") {
          if (typeof(vm.data.HopeJobType) == "undefined" || vm.data.HopeJobType == "") {
            gAlert('', '희망직종을 선택해주세요');
            return false;
          }
        }*/

      /*if (vm.data.HopeJobType == "110") {
          if (typeof(vm.data.HopeJobTypeEtc) == "undefined" || vm.data.HopeJobTypeEtc == "") {
            gAlert('', '희망직종의 기타내용을 입력해주세요.');
            return false;
          }
        }*/

      /*  if (typeof(vm.data.LastEdu) == "undefined" || vm.data.LastEdu == "") {
          gAlert('', '학력을 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAbleTel) == "undefined" || vm.data.CounselAbleTel == "") {
          gAlert('', '상담가능연락처를 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.HopeAmt) == "undefined" || vm.data.HopeAmt == "") {
          gAlert('', '희망급여(만원)을 입력해주세요');
          return false;
        }*/

      /* if (typeof(vm.data.FirstHopeDate) == "undefined" || vm.data.FirstHopeDate == "") {          
          gAlert('', '1차상담희망일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAppliRegUser) == "undefined" || vm.data.CounselAppliRegUser == "") {          
          gAlert('', '상담신천등록자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAppliRegDate) == "undefined" || vm.data.CounselAppliRegDate == "") {          
          gAlert('', '상담신청등록일을 입력해주세요');
          return false;
        }

        if (typeof(vm.data.CustArmyRegUser) == "undefined" || vm.data.CustArmyRegUser == "") {          
          gAlert('', '등록자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CustArmyRegDate) == "undefined" || vm.data.CustArmyRegDate == "") {          
          gAlert('', '등록일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecDate) == "undefined" || vm.data.FirstDecDate == "") {          
          gAlert('', '1차상담확정일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecHour) == "undefined") {
          gAlert('', '1차상담확정일시(시)를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecMin) == "undefined") {
          gAlert('', '1차상담확정일시(분)를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.ApprDate) == "undefined" || vm.data.ApprDate == "") {          
          gAlert('', '상담승인일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.ApprUser) == "undefined" || vm.data.ApprUser == "") {          
          gAlert('', '상담승인자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselUser) == "undefined" || vm.data.CounselUser == "") {          
          gAlert('', '상담사를 선택해주세요');
          return false;
        }*/

      /*if (vm.data.oldFirstDecDate == "") { // 신규
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (vm.data.oldFirstDecDate != vm.data.FirstDecDate && getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      if (typeof vm.data.CounselRound == 'undefined' || vm.data.CounselRound == '') {
        gAlert('', '상담회차를 선택해주세요');
        angular.element('common-code[param-data="vc.CounselRoundList"]').children('select').focus();
        return false;
      }

      // if (typeof vm.data.CounselMethod == 'undefined' || vm.data.CounselMethod == '') {
      if (vm.data.CounselMethod == '0' && (typeof vm.data.RemoteMethod == 'undefined' || vm.data.RemoteMethod == '' || vm.data.RemoteMethod == '0')) {
        gAlert('', '상담방법을 선택해주세요');
        // angular.element('common-code[param-data="vc.CounselMethodList"]').children('select').focus();
        angular.element('select[id="remote_method"]').focus();
        return false;
      }

      if (typeof vm.data.CounselUser == 'undefined' || vm.data.CounselUser == '') {
        gAlert('', '상담사를 선택해주세요', {
          fn: function () {
            vm.showModalCounselUser();
          },
        });
        angular.element('input[ng-value="vc.data.CounselUser_"]').focus();
        return false;
      }

      if (typeof vm.data.CounselField1 == 'undefined' || vm.data.CounselField1 == '') {
        gAlert('', '상담분야를 선택해주세요');
        angular.element('common-code[param-data="vc.CounselField1List"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CounselField2 == 'undefined' || vm.data.CounselField2 == '') {
        gAlert('', '상담분야를 선택해주세요');
        angular.element('common-code[param-data="vc.CounselField2List"]').children('select').focus();
        return false;
      }

      if (vm.data.CounselField2 == '010' || vm.data.CounselField2 == '020') {
        if (typeof vm.data.HopeDuty == 'undefined' || vm.data.HopeDuty == '') {
          gAlert('', '희망직무를 선택해주세요');
          angular.element('common-code[param-data="vc.HopeDutyList"]').children('select').focus();
          return false;
        }

        if (vm.data.HopeDuty == '151') {
          if (typeof vm.data.HopeDutyEtc == 'undefined' || vm.data.HopeDutyEtc == '') {
            gAlert('', '희망직무기타를 입력해주세요');
            angular.element('input[ng-model="vc.data.HopeDutyEtc"]').focus();
            return false;
          }
        }

        if (typeof vm.data.HopeLoc == 'undefined' || vm.data.HopeLoc == '') {
          gAlert('', '희망지역을 선택해주세요');
          angular.element('common-code[param-data="vc.HopeLocList1"]').children('select').focus();
          return false;
        }
      }

      if (vm.data.CounselField2 == '050') {
        if (typeof vm.data.HopeLoc == 'undefined' || vm.data.HopeLoc == '') {
          gAlert('', '희망지역을 선택해주세요');
          angular.element('common-code[param-data="vc.HopeLocList1"]').children('select').focus();
          return false;
        }
      }

      if (typeof vm.data.CounselDate == 'undefined' || vm.data.CounselDate == '') {
        gAlert('', '상담일자를 선택해주세요');
        angular.element('input[ng-model="dtCounselDate"]').focus();
        return false;
      }

/*      if (typeof vm.data.CounselTimeFromHour == 'undefined' || vm.data.CounselTimeFromHour == '') {
        gAlert('', '상담시간 시작시를 선택해주세요');
        angular.element('common-code[param-data="vc.CounselTimeFromHourList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CounselTimeFromMin == 'undefined' || vm.data.CounselTimeFromMin == '') {
        gAlert('', '상담시간 시작분을 선택해주세요');
        angular.element('common-code[param-data="vc.CounselTimeFromMinList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CounselTimeToHour == 'undefined' || vm.data.CounselTimeToHour == '') {
        gAlert('', '상담시간 종료시를 선택해주세요');
        angular.element('common-code[param-data="vc.CounselTimeToHourList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CounselTimeToMin == 'undefined' || vm.data.CounselTimeToMin == '') {
        gAlert('', '상담시간 종료분을 선택해주세요');
        angular.element('common-code[param-data="vc.CounselTimeToMinList"]').children('select').focus();
        return false;
      }*/

      if (typeof vm.data.CounselDateHopeNext != 'undefined' && vm.data.CounselDateHopeNext != '') {
        if (typeof vm.data.CounselDateHopeNextHour == 'undefined' || vm.data.CounselDateHopeNextHour == '') {
          gAlert('', '다음상담희망일을 입력한 경우 희망 시간을 선택해야합니다.');
          angular.element('common-code[param-data="vc.CounselDateHopeNextHourList"]').children('select').focus();
          return false;
        }
        if (typeof vm.data.CounselDateHopeNextMin == 'undefined' || vm.data.CounselDateHopeNextMin == '') {
          gAlert('', '다음상담희망일을 입력한 경우 희망 분을 선택해야합니다.');
          angular.element('common-code[param-data="vc.CounselDateHopeNextMinList"]').children('select').focus();
          return false;
        }
      }

/**
 * 2025.12.11. 유지보수 12-6.
 * 제목에서 상담주제로 변경.
 * 기존 제목값은 세부주제에 넣고 상담주제를 기타로 설정.
 * 상담주제 신규 컬럼 추가. 세부주제는 기존 제목 컬럼을 활용.
 */
/*
      if (typeof vm.data.Title == 'undefined' || vm.data.Title == '') {
        gAlert('', '제목을 입력해주세요.');
        angular.element('input[ng-model="vc.data.Title"]').focus();
        return false;
      }
*/
      if(typeof vm.data.CounselTopic == 'undefined' || vm.data.CounselTopic == '') {
        gAlert('', '상담주제를 선택해 주세요.');
        angular.element('common-code[param-data="vc.CounselTopicList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.Content == 'undefined' || vm.data.Content == '') {
        gAlert('', '내용을 입력해주세요.');
        angular.element('input[ng-model="vc.data.Content"]').focus();
        return false;
      }

      return true;
    }

    // 조회
    function getData() {
      // 상담방법 초기값 설정
      if (typeof vm.data.CounselMethod == 'undefined' || vm.data.CounselMethod == '') {
        // vm.data.CounselMethod = '2';
        // vm.CounselMethodList.Code = '2';
        vm.data.CounselMethod = '0';
      }

      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var list = data.body.docs[0].TenantArea.split(',');
              vm.ArmyAreaList = list.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.data.ArmyAreaObj = vm.ArmyAreaList[0];
                vm.data.ArmyArea = vm.data.ArmyAreaObj.Code;
              }
            } else {
              vm.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList' + data.body.docs[0].errMessage);
        }
      );

      if (vm.srch.CounselRecordId == null || vm.srch.CounselRecordId == '') {
        return;
      }

      vm.dataloader = true;

      vm.srch.mapCode = 'CounselRecord.getCounselRecordDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0 && data.body.docs[0].CounselRecordId !== null) {
              vm.data = data.body.docs[0];

              // 수동 메핑 항목 설정
              vm.ArmyClassList.Code = vm.data.ArmyClass;
              vm.ArmyTypeList.Code = vm.data.ArmyType;
              /* vm.ArmyAreaList.Code = vm.data.ArmyArea; */
              vm.data.ArmyAreaObj = {
                Code: vm.data.ArmyArea,
                CodeValue: vm.data.ArmyArea,
              };
              vm.PermStat1List.Code = vm.data.PermStat1;
              vm.PermStat2List.Code = vm.data.PermStat2;
              vm.HopeField1List.Code = vm.data.HopeField1;
              vm.HopeField2List.Code = vm.data.HopeField2;
              vm.LastEduList.Code = vm.data.LastEdu;
              vm.SpecList.Code = vm.data.Spec;
              vm.CounselTopicList.Code = vm.data.CounselTopic;
              /*vm.CounselTimeFromHourList.Code = vm.data.CounselTimeFromHour;
              vm.CounselTimeFromMinList.Code = vm.data.CounselTimeFromMin;
              vm.CounselTimeToHourList.Code = vm.data.CounselTimeToHour;
              vm.CounselTimeToMinList.Code = vm.data.CounselTimeToMin;*/
              vm.CounselRoundList.Code = vm.data.CounselRound;
              vm.CounselField1List.Code = vm.data.CounselField1;
              vm.CounselField2List.Code = vm.data.CounselField2;
              vm.CounselDateHopeNextHourList.Code = vm.data.CounselDateHopeNextHour;
              vm.CounselDateHopeNextMinList.Code = vm.data.CounselDateHopeNextMin;
              vm.HopeDutyList.Code = vm.data.HopeDuty;
              // vm.CounselMethodList.Code = vm.data.CounselMethod;
              if(vm.data.CounselMethod != '2') {
                vm.data.RemoteMethod = data.body.docs[0].CounselMethod;
                vm.data.CounselMethod = '0';
              }

              if (typeof vm.data.HopeLoc != 'undefined' || vm.data.HopeLoc != '') {
                if (parseInt(vm.data.HopeLoc) < 1000) {
                  vm.HopeLocList1.Code = vm.data.HopeLoc;
                } else {
                  vm.HopeLocList2.Code = vm.data.HopeLoc;
                }
              }

              vm.CounselField3List.Code = vm.data.CounselField3;
              vm.CounselField4List.Code = vm.data.CounselField4;
              vm.HopeDutyList2.Code = vm.data.HopeDuty2;

              if (typeof vm.data.HopeLoc2 != 'undefined' || vm.data.HopeLoc2 != '') {
                if (parseInt(vm.data.HopeLoc2) < 1000) {
                  vm.HopeLocList3.Code = vm.data.HopeLoc2;
                } else {
                  vm.HopeLocList4.Code = vm.data.HopeLoc2;
                }
              }

              $scope.dtInArmyDate = setNewDate(vm.data.InArmyDate);
              $scope.dtOutArmyDate = setNewDate(vm.data.OutArmyDate);
              $scope.dtCounselDate = setNewDate(vm.data.CounselDate);
              $scope.dtCounselDateHopeNext = setNewDate(vm.data.CounselDateHopeNext);

              $timeout(function () {
                vm.dataloader = false;
              }, 500);
              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          console.log('Error> counselrecordEditCtrl> getData> ', data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (고객정보)
    function showModalCustInfo() {
      var ctrl = 'CustarmyModalCtrl as modalCtrl';
      var paramData = { type: 'counsel' };

      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/customerarmy/custarmy-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          if (!isNullOrEmpty(okData.RetDate)) {
            var pYear = okData.RetDate.substring(0, 4);
            var pMonth = okData.RetDate.substring(5, 6);
            var pDay = okData.RetDate.substring(7, 8);

            gAlert('', '해당 장병은 ' + pYear + '년 ' + pMonth + '월 ' + pDay + '일 홈페이지 탈퇴한 회원입니다.');
            return;
          }
          vm.data.CustNm = okData.CustNm;
          setArmyCustData(okData);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 호출 (이전상담내역)
    function showModalCounselRecordList() {
      if (typeof vm.data.CustArmyId == 'undefined' || vm.data.CustArmyId == '') {
        gAlert('', '성명을 입력해주세요');
        return false;
      }

      $window.open(
        '/#/popup/counsel-record-modal/' + vm.data.CustArmyId,
        'counsel-record-modal:' + vm.data.CustArmyId,
        'scrollbars=yes, width=800, height=500, top=0, left=0'
      );

      /*var ctrl = 'CounselRecordModalCtrl as modalCtrl';
        var paramData = {CustArmyId:vm.data.CustArmyId};
    
        var modalInstance = modalFactory.open('lg', 'views/modal/counsel-record-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
          //vm.data.ArmyId = okData.MM_ID;
          //serchArmyId();
        }, function(cancelData) {
        });*/
    }

    function setArmyCustData(okData) {
      if (okData.NextCounselRound <= okData.ConsultNum) {
        vm.CounselRoundList.Code = okData.NextCounselRound;
        vm.data.CounselRound = okData.NextCounselRound;
      } else {
        gAlert('', okData.ConsultNum + '회차 상담까지 모두 입력이 완료되었습니다.');
        return;
      }
      /* if (vm.ArmyArea5YN != 'Y') {
        if (okData.NextCounselRound <= vm.data.ConsultNum) {
          vm.CounselRoundList.Code = okData.NextCounselRound;
          vm.data.CounselRound = okData.NextCounselRound;
        } else {
          gAlert('', vm.data.ConsultNum + '회차 상담까지 모두 입력이 완료되었습니다.');
          return;
        }
      } else if (vm.ArmyArea5YN == 'Y') {
        if (okData.NextCounselRound <= 9) {
          vm.CounselRoundList.Code = okData.NextCounselRound;
          vm.data.CounselRound = okData.NextCounselRound;
        } else {
          gAlert('', '9회차 상담까지 모두 입력이 완료되었습니다.');
          return;
        }
      } */
      vm.data.ArmyArea = okData.ArmyArea;

      vm.data.CustArmyId = okData.CustArmyId;
      vm.data.ArmyNo = okData.ArmyNo;
      vm.ArmyClassList.Code = okData.ArmyClass;
      vm.ArmyTypeList.Code = okData.ArmyType;
      /* vm.ArmyAreaList.Code = okData.ArmyArea; */
      vm.data.ArmyAreaObj = {
        Code: vm.data.ArmyArea,
        CodeValue: vm.data.ArmyArea,
      };
      vm.PermStat1List.Code = okData.PermStat1;
      //vm.PermStat2List.Code = okData.PermStat2;
      vm.data.PermStat2 = okData.PermStat2;
      vm.LastEduList.Code = okData.LastEdu;
      vm.HopeField1List.Code = okData.HopeField1;
      vm.HopeField2List.Code = okData.HopeField2;
      //vm.data.Spec = okData.Spec;

      $scope.dtInArmyDate = setNewDate(okData.InArmyDate);
      $scope.dtOutArmyDate = setNewDate(okData.OutArmyDate);
      vm.data.InArmyDate = okData.InArmyDate;
      vm.data.OutArmyDate = okData.OutArmyDate;

      vm.data.ResRegNo = okData.ResRegNo;
      vm.data.Mobile = okData.Mobile;
      vm.data.OutArmyTel = okData.OutArmyTel;
      vm.data.Email = okData.Email;
      vm.data.CounselMemo = okData.CounselMemo;
      vm.data.AddMemo = okData.AddMemo;

      vm.CounselField1List.Code = okData.CounselField1;
      vm.CounselField2List.Code = okData.CounselField2;
      vm.HopeDutyList.Code = okData.HopeDuty;
      vm.data.HopeDutyEtc = okData.HopeDutyEtc;

      vm.data.ArmyId = okData.ArmyId;
      vm.data.MM_NO = okData.MM_NO;
      vm.SpecList.Code = okData.Spec;
      vm.data.PermStat = okData.PermStat;

      if (typeof okData.HopeLoc != 'undefined' || okData.HopeLoc != '') {
        if (parseInt(okData.HopeLoc) < 1000) {
          vm.HopeLocList1.Code = okData.HopeLoc;
        } else {
          vm.HopeLocList2.Code = okData.HopeLoc;
        }
      }

      vm.CounselField3List.Code = okData.CounselField3;
      vm.CounselField4List.Code = okData.CounselField4;
      vm.HopeDutyList2.Code = okData.HopeDuty2;
      vm.data.HopeDutyEtc2 = okData.HopeDutyEtc2;

      if (typeof okData.HopeLoc2 != 'undefined' || okData.HopeLoc2 != '') {
        if (parseInt(okData.HopeLoc2) < 1000) {
          vm.HopeLocList3.Code = okData.HopeLoc2;
        } else {
          vm.HopeLocList4.Code = okData.HopeLoc2;
        }
      }
    }

    // 모달팝업 데이터 삭제 (고객정보)
    function clearModalCustInfo() {
      vm.data.MM_NO = '';
      vm.data.ArmyId = '';
      vm.data.PermStat = '';

      vm.data.CustNm = '';
      vm.data.CustArmyId = '';
      vm.data.ArmyNo = '';
      vm.ArmyClassList.Code = '';
      vm.ArmyTypeList.Code = '';
      vm.data.ArmyAreaObj = null;
      /* vm.ArmyAreaList.Code = ''; */
      vm.HopeField1List.Code = '';
      vm.LastEduList.Code = '';
      vm.data.Spec = '';

      $scope.dtInArmyDate = '';
      $scope.dtOutArmyDate = '';
      vm.data.InArmyDate = '';
      vm.data.OutArmyDate = '';

      vm.data.ResRegNo = '';
      vm.data.Mobile = '';
      vm.data.OutArmyTel = '';
      vm.data.Email = '';
      vm.data.CounselMemo = '';
      vm.data.AddMemo = '';

      vm.CounselField1List.Code = '';
      vm.CounselField2List.Code = '';
      vm.data.CounselField1 = '';
      vm.data.CounselField2 = '';
      vm.data.CounselField3 = '';
      vm.data.CounselField4 = '';
      vm.HopeDutyList.Code = '';
      vm.data.HopeDuty = '';
      vm.data.HopeDutyEtc = '';
      vm.HopeDutyList2.Code = '';
      vm.data.HopeDuty2 = '';
      vm.data.HopeDutyEtc2 = '';
      vm.HopeLocList1.Code = '';
      vm.HopeLocList2.Code = '';
      vm.HopeLocList3.Code = '';
      vm.HopeLocList4.Code = '';
      vm.data.HopeLoc1 = '';
      vm.data.HopeLoc2 = '';
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.CounselUser_ = okData.UserNm;
          vm.data.CounselUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.data.CounselUser_ = '';
      vm.data.CounselUser = '';
    }

    /*      function setSchedule(){
    	  
    	  var prms = null;   
    	  
    	  prms = api.doInsertSchedule().post(vm.data).$promise;
    	  
      }*/

    // 저장버튼 더블클릭 방지용 변수 선언 2020-02-19 김준권
    vm.saveButtonDisable = false;
    // 저장
    function setData() {
      if (!chkValid()) return false;

      vm.dataloader = true;

      var successCallback = function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].CounselRecordId !== null) {
            // KeyId 조회
            vm.srch.CounselRecordId = data.body.docs[0].CounselRecordId;

            // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
            if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
              setWorkData(); // 업무 시스템 연동
            } else {
              vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';
              postApi.update(vm.srch, function (json) {
                if (json.header.status === CONSTANT.HttpStatus.OK) {
                  gAlert('', 'Menu.SAVED', {
                    btn: '',
                    fn: function () {
                      if (vm.srch.CounselRecordId == 0) {
                        $state.go('app.counsel.counselrecord-list');
                      } else {
                        $state.go('app.counsel.counselrecord-detail', {
                          CounselRecordId: vm.srch.CounselRecordId,
                        });
                      }
                    },
                  });
                } else {
                  gAlert('', '상담일지 저장에 실패했습니다.');
                  vm.dataloader = false;
                }
              });
              return;
            }
          }
        } else {
          gAlert('', data.body.docs[0].errMessage);
        }
      };

      var errorCallback = function (error) {
        console.log("error");
        // console.error('Error-setData', status, data);
        vm.dataloader = false;
      };

      console.log(vm.data);

      var data = angular.copy(vm.data);
      if(data.CounselMethod == '0') {
        data.CounselMethod = data.RemoteMethod;
      }

      if (vm.srch.CounselRecordId == 0) {
        // 등록
        data.mapCode = 'CounselRecord.insertCounselRecordDetailBatch';
        postApi.insert(data, successCallback, errorCallback);
      } else {
        // 수정
        data.mapCode = 'CounselRecord.updateCounselRecordDetailBatch';
        postApi.update(data, successCallback, errorCallback);
      }
    }

    function setConsultContents(len, cnt, type) {
      if (!type) type = 'default';
      if (len > 0) {
        vm.linkObj.p_JC_CONTENT2 = vm.data.Content.substring(500 * cnt, 500 * (cnt + 1));
        postApi.api(
          'extUpdate/Linkage.updateConsultRecordContents/action',
          vm.linkObj,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              len = len - 500;
              cnt++;
              setConsultContents(len, cnt, type);
            } else {
              gAlert('', '업무시스템과의 연동에 실패 했습니다.');
              console.log('Error-setWorkData' + data.body.docs[0].errMessage);
            }
          },
          function (data) {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.');
            console.log('Error-setWorkData' + data.body.docs[0].errMessage);
          }
        );
      } else {
        console.log('partitioning End');
        vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';

        postApi.update(
          vm.srch,
          function (json) {
            if (json.header.status === CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if (type === 'auto') {
                    vm.dataloader = false;
                  } else {
                    if (vm.srch.CounselRecordId == 0) {
                      $state.go('app.counsel.counselrecord-list');
                    } else {
                      $state.go('app.counsel.counselrecord-detail', {
                        CounselRecordId: vm.srch.CounselRecordId,
                      });
                    }
                  }
                },
              });
            } else {
              gAlert('', '상담일지 등록에 실패했습니다.', {
                fn: function () {
                  vm.dataloader = false;
                },
              });
            }
          },
          function (json) {
            console.log("error");
            // console.error('Error> CounselrecordEditCtrl> setConsultContents>' + json.body.docs[0].errMessage);
          }
        );
        return;
      }
    }

    function setWorkData() {
      vm.data.RegUser = vm.data.ArmyArea;

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiSetCounselRecord.jsp?p_JC_COUNSEL_RECORD_ID=' +
        vm.srch.CounselRecordId;
      url =
        url +
        '&p_JC_NO=' +
        vm.data.MM_NO +
        '&p_JC_ID=' +
        vm.data.ArmyId +
        '&p_JC_NAME=' +
        escape(encodeURIComponent(vm.data.CustNm));
      url =
        url +
        '&p_JC_COUNSEL_USER=' +
        escape(encodeURIComponent(vm.data.RegUser));
      url =
        url +
        '&p_JC_COUNSEL_FIELD1=' +
        escape(encodeURIComponent(vm.data.CounselField1Value));
      url =
        url +
        '&p_JC_COUNSEL_FIELD2=' +
        escape(encodeURIComponent(vm.data.CounselField2Value));
      url =
        url +
        '&p_JC_COUNSEL_FIELD3=' +
        escape(encodeURIComponent(vm.data.CounselField3Value));
      if (typeof vm.data.CounselField4Value != 'undefined') {
        url =
          url +
          '&p_JC_COUNSEL_FIELD4=' +
          escape(encodeURIComponent(vm.data.CounselField4Value));
      }
      url =
        url +
        '&p_JC_COUNSEL_DATE=' +
        vm.data.CounselDate +
        '&p_JC_COUNSEL_TIME_FROM_HOUR=' +
        vm.data.CounselTimeFromHour +
        '&p_JC_COUNSEL_TIME_FROM_MIN=' +
        vm.data.CounselTimeFromMin;
      url =
        url +
        '&p_JC_COUNSEL_TIME_TO_HOUR=' +
        vm.data.CounselTimeToHour +
        '&p_JC_COUNSEL_TIME_TO_MIN=' +
        vm.data.CounselTimeToMin;
      if (typeof vm.data.CounselDateHopeNext != 'undefined') {
        url =
          url + '&p_JC_COUNSEL_DATE_HOPE_NEXT=' + vm.data.CounselDateHopeNext;
      }
      url =
        url +
        '&p_JC_COUNSEL_TIME_HOPE_NEXT_HOUR=' +
        vm.data.CounselDateHopeNextHour;
      url =
        url +
        '&p_JC_COUNSEL_TIME_HOPE_NEXT_MIN=' +
        vm.data.CounselDateHopeNextMin;
      url = url + '&p_JC_TITLE=' + escape(encodeURIComponent(vm.data.Title));
      url =
        url +
        '&p_JC_CONTENT=' +
        escape(encodeURIComponent(vm.data.Content.substring(0, 500)));
      url = url + '&p_JC_COUNSEL_ROUND=' + vm.data.CounselRound;
      url =
        url +
        '&p_JC_REG_USER=' +
        escape(encodeURIComponent($window.sessionStorage['loginUserName']));
      url =
        url +
        '&p_JC_EDT_USER=' +
        escape(encodeURIComponent($window.sessionStorage['loginUserName']));
      url =
        url +
        '&p_JC_COUNSEL_METHOD=' +
        escape(encodeURIComponent(vm.data.CounselMethodValue)); */

      vm.linkObj = {
        p_JC_COUNSEL_RECORD_ID: vm.srch.CounselRecordId,
        p_JC_NO: vm.data.MM_NO,
        p_JC_ID: vm.data.ArmyId,
        p_JC_NAME: vm.data.CustNm,
        p_JC_COUNSEL_USER: vm.data.RegUser,
        p_JC_COUNSEL_FIELD1: vm.data.CounselField1Value,
        p_JC_COUNSEL_FIELD2: vm.data.CounselField2Value,
        p_JC_COUNSEL_FIELD3: vm.data.CounselField3Value,
        p_JC_COUNSEL_FIELD4: vm.data.CounselField4Value,
        p_JC_COUNSEL_DATE: vm.data.CounselDate,
        /*p_JC_COUNSEL_TIME_FROM_HOUR: vm.data.CounselTimeFromHour,
        p_JC_COUNSEL_TIME_FROM_MIN: vm.data.CounselTimeFromMin,
        p_JC_COUNSEL_TIME_TO_HOUR: vm.data.CounselTimeToHour,
        p_JC_COUNSEL_TIME_TO_MIN: vm.data.CounselTimeToMin,*/
        p_JC_COUNSEL_DATE_HOPE_NEXT: vm.data.CounselDateHopeNext === undefined ? '' : vm.data.CounselDateHopeNext,
        p_JC_COUNSEL_TIME_HOPE_NEXT_HOUR: vm.data.CounselDateHopeNextHour,
        p_JC_COUNSEL_TIME_HOPE_NEXT_MIN: vm.data.CounselDateHopeNextMin,
        // p_JC_TITLE: vm.data.Title,
        p_JC_TITLE: vm.data.CounselTopicValue,
        p_JC_CONTENT: vm.data.Content,
        p_JC_COUNSEL_ROUND: vm.data.CounselRound,
        p_JC_REG_USER: $window.sessionStorage['loginUserName'],
        p_JC_EDT_USER: $window.sessionStorage['loginUserName'],
        // p_JC_COUNSEL_METHOD: vm.data.CounselMethodValue,
        p_JC_COUNSEL_METHOD: vm.data.CounselMethod == '2' ? vm.CounselMethodValueList[vm.data.CounselMethod]
                                                          : vm.CounselMethodValueList[vm.data.RemoteMethod],
      };

      postApi.api(
        'extUpdate/Linkage.updateConsultRecord/action',
        vm.linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            /* 큐브리드 전환하면서 500자씩 끊어서 저장 취소
            var leftLength = vm.data.Content.length - 500;
            var cnt = 1;
            setConsultContents(leftLength, cnt);
            */
           gAlert('', '업무시스템과의 연동에 성공 했습니다.', {
             fn: function () {
               vm.dataloader = false;
               if (vm.srch.CounselRecordId == 0) {
                 $state.go('app.counsel.counselrecord-list');
               } else {
                 $state.go('app.counsel.counselrecord-detail', {
                   CounselRecordId: vm.srch.CounselRecordId,
                 });
               }
             },
           });
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
              fn: function () {
                vm.dataloader = false;
              },
            });
            console.log('Error-setWorkData' + data.body.docs[0].errMessage);
          }
        },
        function (data) {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
            fn: function () {
              vm.dataloader = false;
            },
          });
          console.log('Error-setWorkData' + data.body.docs[0].errMessage);
        }
      );

      //console.log(url);
      //console.log(escape(encodeURIComponent(vm.data.Content)));

      // 업무관리 시스템 연동시 상담 내용 500자씩 끊어서 저장 2019-0318 김준권
      /* window.GoojikApiSetCounselRecord = function (data) {
        console.log('GoojikApiSetCounselRecord = ', data);
        if (data.Result == null || data.Result == '' || data.Result == 'FAIL') {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.');
          return;
        } else {
          console.log('vm.data.Content.length=', vm.data.Content.length);

          if (vm.data.Content.length > 500) {
            var url2 =
              'https://moti.or.kr/system/employ/employ5/GoojikApiSetCounselRecordContent.jsp?p_JC_COUNSEL_RECORD_ID=' +
              vm.srch.CounselRecordId;
            url2 =
              url2 +
              '&p_JC_CONTENT2=' +
              escape(encodeURIComponent(vm.data.Content.substring(500, 1000)));

            //console.log(url2);

            window.GoojikApiSetCounselRecordContents = function (data) {
              console.log('GoojikApiSetCounselRecordContents = ', data);
              if (
                data.Result == null ||
                data.Result == '' ||
                data.Result == 'FAIL'
              ) {
                gAlert('', '업무시스템과의 연동에 실패 했습니다.');
                return;
              } else {
                if (vm.data.Content.length > 1000) {
                  var url3 =
                    'https://moti.or.kr/system/employ/employ5/GoojikApiSetCounselRecordContent.jsp?p_JC_COUNSEL_RECORD_ID=' +
                    vm.srch.CounselRecordId;
                  url3 =
                    url3 +
                    '&p_JC_CONTENT2=' +
                    escape(
                      encodeURIComponent(vm.data.Content.substring(1000, 1500))
                    );

                  //console.log(url3);

                  window.GoojikApiSetCounselRecordContents = function (data) {
                    console.log('GoojikApiSetCounselRecordContents = ', data);
                    if (
                      data.Result == null ||
                      data.Result == '' ||
                      data.Result == 'FAIL'
                    ) {
                      gAlert('', '업무시스템과의 연동에 실패 했습니다.');
                      return;
                    } else {
                      if (vm.data.Content.length > 1500) {
                        var url4 =
                          'https://moti.or.kr/system/employ/employ5/GoojikApiSetCounselRecordContent.jsp?p_JC_COUNSEL_RECORD_ID=' +
                          vm.srch.CounselRecordId;
                        url4 =
                          url4 +
                          '&p_JC_CONTENT2=' +
                          escape(
                            encodeURIComponent(
                              vm.data.Content.substring(1500, 2000)
                            )
                          );

                        //console.log(url4);

                        window.GoojikApiSetCounselRecordContents = function (
                          data
                        ) {
                          console.log(
                            'GoojikApiSetCounselRecordContents = ',
                            data
                          );
                          if (
                            data.Result == null ||
                            data.Result == '' ||
                            data.Result == 'FAIL'
                          ) {
                            gAlert('', '업무시스템과의 연동에 실패 했습니다.');
                            return;
                          } else {
                            vm.srch.mapCode =
                              'CounselRecord.updateCounselRecordLinkage';
                            postApi.update(vm.srch, function (json) {
                              if (
                                json.header.status === CONSTANT.HttpStatus.OK
                              ) {
                                gAlert('', 'Menu.SAVED', {
                                  btn: '',
                                  fn: function () {
                                    if (vm.srch.CounselRecordId == 0) {
                                      $state.go(
                                        'app.counsel.counselrecord-list'
                                      );
                                    } else {
                                      $state.go(
                                        'app.counsel.counselrecord-detail',
                                        {
                                          CounselRecordId:
                                            vm.srch.CounselRecordId,
                                        }
                                      );
                                    }
                                  },
                                });
                              }
                            });
                            return;
                          }
                        };

                        $http.jsonp(url4, {
                          jsonpCallbackParam:
                            'GoojikApiSetCounselRecordContents',
                        });
                      } else {
                        vm.srch.mapCode =
                          'CounselRecord.updateCounselRecordLinkage';

                        postApi.update(vm.srch, function (json) {
                          if (json.header.status === CONSTANT.HttpStatus.OK) {
                            gAlert('', 'Menu.SAVED', {
                              btn: '',
                              fn: function () {
                                if (vm.srch.CounselRecordId == 0) {
                                  $state.go('app.counsel.counselrecord-list');
                                } else {
                                  $state.go(
                                    'app.counsel.counselrecord-detail',
                                    {
                                      CounselRecordId: vm.srch.CounselRecordId,
                                    }
                                  );
                                }
                              },
                            });
                          }
                        });
                        return;
                      }
                    }
                  };

                  $http.jsonp(url3, {
                    jsonpCallbackParam: 'GoojikApiSetCounselRecordContents',
                  });
                } else {
                  vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';

                  postApi.update(vm.srch, function (json) {
                    if (json.header.status === CONSTANT.HttpStatus.OK) {
                      gAlert('', 'Menu.SAVED', {
                        btn: '',
                        fn: function () {
                          if (vm.srch.CounselRecordId == 0) {
                            $state.go('app.counsel.counselrecord-list');
                          } else {
                            $state.go('app.counsel.counselrecord-detail', {
                              CounselRecordId: vm.srch.CounselRecordId,
                            });
                          }
                        },
                      });
                    }
                  });
                  return;
                }
              }
            };

            $http.jsonp(url2, {
              jsonpCallbackParam: 'GoojikApiSetCounselRecordContents',
            });
          } else {
            vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';
            postApi.update(vm.srch, function (json) {
              if (json.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.SAVED', {
                  btn: '',
                  fn: function () {
                    if (vm.srch.CounselRecordId == 0) {
                      $state.go('app.counsel.counselrecord-list');
                    } else {
                      $state.go('app.counsel.counselrecord-detail', {
                        CounselRecordId: vm.srch.CounselRecordId,
                      });
                    }
                  },
                });
              }
            });
            return;
          }
        }
      };

      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiSetCounselRecord' }); */
    }

    function setWorkDataAuto() {
      vm.data.RegUser = vm.data.ArmyArea;

      /* console.log(vm.data);

      var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiSetCounselRecord.jsp?p_JC_COUNSEL_RECORD_ID=' +
        vm.srch.CounselRecordId;
      url =
        url +
        '&p_JC_NO=' +
        vm.data.MM_NO +
        '&p_JC_ID=' +
        vm.data.ArmyId +
        '&p_JC_NAME=' +
        escape(encodeURIComponent(vm.data.CustNm));
      url =
        url +
        '&p_JC_COUNSEL_USER=' +
        escape(encodeURIComponent(vm.data.RegUser));
      url =
        url +
        '&p_JC_COUNSEL_FIELD1=' +
        escape(encodeURIComponent(vm.data.CounselField1Value));
      url =
        url +
        '&p_JC_COUNSEL_FIELD2=' +
        escape(encodeURIComponent(vm.data.CounselField2Value));
      url =
        url +
        '&p_JC_COUNSEL_FIELD3=' +
        escape(encodeURIComponent(vm.data.CounselField3Value));
      if (typeof vm.data.CounselField4Value != 'undefined') {
        url =
          url +
          '&p_JC_COUNSEL_FIELD4=' +
          escape(encodeURIComponent(vm.data.CounselField4Value));
      }
      url =
        url +
        '&p_JC_COUNSEL_DATE=' +
        vm.data.CounselDate +
        '&p_JC_COUNSEL_TIME_FROM_HOUR=' +
        vm.data.CounselTimeFromHour +
        '&p_JC_COUNSEL_TIME_FROM_MIN=' +
        vm.data.CounselTimeFromMin;
      url =
        url +
        '&p_JC_COUNSEL_TIME_TO_HOUR=' +
        vm.data.CounselTimeToHour +
        '&p_JC_COUNSEL_TIME_TO_MIN=' +
        vm.data.CounselTimeToMin;
      if (typeof vm.data.CounselDateHopeNext != 'undefined') {
        url =
          url + '&p_JC_COUNSEL_DATE_HOPE_NEXT=' + vm.data.CounselDateHopeNext;
      }
      url =
        url +
        '&p_JC_COUNSEL_TIME_HOPE_NEXT_HOUR=' +
        vm.data.CounselDateHopeNextHour;
      url =
        url +
        '&p_JC_COUNSEL_TIME_HOPE_NEXT_MIN=' +
        vm.data.CounselDateHopeNextMin;
      url = url + '&p_JC_TITLE=' + escape(encodeURIComponent(vm.data.Title));
      url =
        url +
        '&p_JC_CONTENT=' +
        escape(encodeURIComponent(vm.data.Content.substring(0, 500)));
      url = url + '&p_JC_COUNSEL_ROUND=' + vm.data.CounselRound;
      url =
        url +
        '&p_JC_REG_USER=' +
        escape(encodeURIComponent($window.sessionStorage['loginUserName']));
      url =
        url +
        '&p_JC_EDT_USER=' +
        escape(encodeURIComponent($window.sessionStorage['loginUserName']));
      url =
        url +
        '&p_JC_COUNSEL_METHOD=' +
        escape(encodeURIComponent(vm.data.CounselMethodValue)); */

      vm.linkObj = {
        p_JC_COUNSEL_RECORD_ID: vm.srch.CounselRecordId,
        p_JC_NO: vm.data.MM_NO,
        p_JC_ID: vm.data.ArmyId,
        p_JC_NAME: vm.data.CustNm,
        p_JC_COUNSEL_USER: vm.data.RegUser,
        p_JC_COUNSEL_FIELD1: vm.data.CounselField1Value,
        p_JC_COUNSEL_FIELD2: vm.data.CounselField2Value,
        p_JC_COUNSEL_FIELD3: vm.data.CounselField3Value,
        p_JC_COUNSEL_FIELD4: vm.data.CounselField4Value,
        p_JC_COUNSEL_DATE: vm.data.CounselDate,
        /*p_JC_COUNSEL_TIME_FROM_HOUR: vm.data.CounselTimeFromHour,
        p_JC_COUNSEL_TIME_FROM_MIN: vm.data.CounselTimeFromMin,
        p_JC_COUNSEL_TIME_TO_HOUR: vm.data.CounselTimeToHour,
        p_JC_COUNSEL_TIME_TO_MIN: vm.data.CounselTimeToMin,*/
        p_JC_COUNSEL_DATE_HOPE_NEXT: vm.data.CounselDateHopeNext === undefined ? '' : vm.data.CounselDateHopeNext,
        p_JC_COUNSEL_TIME_HOPE_NEXT_HOUR: vm.data.CounselDateHopeNextHour,
        p_JC_COUNSEL_TIME_HOPE_NEXT_MIN: vm.data.CounselDateHopeNextMin,
        // p_JC_TITLE: vm.data.Title,
        p_JC_TITLE: vm.data.CounselTopicValue,
        p_JC_CONTENT: vm.data.Content.substring(0, 500),
        p_JC_COUNSEL_ROUND: vm.data.CounselRound,
        p_JC_REG_USER: $window.sessionStorage['loginUserName'],
        p_JC_EDT_USER: $window.sessionStorage['loginUserName'],
        // p_JC_COUNSEL_METHOD: vm.data.CounselMethodValue,
        p_JC_COUNSEL_METHOD: vm.data.CounselMethod == '2' ? vm.CounselMethodValueList[vm.data.CounselMethod]
                                                          : vm.CounselMethodValueList[vm.data.RemoteMethod],
      };

      postApi.api(
        'extUpdate/Linkage.updateConsultRecord/action',
        vm.linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            /* 큐브리드 전환으로 500자씩 끊어서 저장 삭제
            var leftLength = vm.data.Content.length - 500;
            var cnt = 1;
            setConsultContents(leftLength, cnt, 'auto');
            */
            gAlert('', '업무시스템과의 연동에 성공 했습니다.', {
              fn: function () {
                vm.dataloader = false;
                if (vm.srch.CounselRecordId == 0) {
                  $state.go('app.counsel.counselrecord-list');
                } else {
                  $state.go('app.counsel.counselrecord-detail', {
                    CounselRecordId: vm.srch.CounselRecordId,
                  });
                }
              },
            });
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
              fn: function () {
                vm.dataloader = false;
              },
            });
            console.log('Error-setWorkData' + data.body.docs[0].errMessage);
          }
        },
        function (data) {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
            fn: function () {
              vm.dataloader = false;
            },
          });
          console.log('Error-setWorkData' + data.body.docs[0].errMessage);
        }
      );
    }

    // 등록/수정 컬럼 조회
    // 데이터 조회
    getData();

    // 유효성검사
    function chkValidAuto() {
      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        //gAlert('', '성명을 선택해주세요');
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        //gAlert('', '군번을 입력해주세요');
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        //gAlert('', '계급을 선택해주세요');
        return false;
      }

      if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
        //gAlert('', '군별을 선택해주세요');
        return false;
      }

      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        //gAlert('', '소속부대를 선택해주세요');
        return false;
      }

      if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
        //gAlert('', '소속부대를 입력해주세요');
        return false;
      }

      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        //gAlert('', '소속부대를 선택해주세요');
        return false;
      }

      if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
        //gAlert('', '소속부대를 선택해주세요');
        return false;
      }

      if (typeof vm.data.HopeField1 == 'undefined' || vm.data.HopeField1 == '') {
        //gAlert('', '상담희망분야를 선택해주세요');
        return false;
      }

      if (vm.data.HopeField1 == '040') {
        if (typeof vm.data.HopeField2 == 'undefined' || vm.data.HopeField2 == '') {
          //gAlert('', '상담희망분야를 선택해주세요');
          return false;
        }
      }

      if (typeof vm.data.Spec == 'undefined' || vm.data.Spec == '') {
        //gAlert('', '병과를 선택해주세요');
        return false;
      }

      if (typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == null || vm.data.InArmyDate == '') {
        //gAlert('', '임관일 또는 입대일을 선택해주세요');
        return false;
      }

      if (typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == null || vm.data.OutArmyDate == '') {
        //gAlert('', '전역일을 입력해주세요');
        return false;
      }

      if (typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == '') {
        //gAlert('', '생년월일를 입력해주세요');
        return false;
      }

      if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        //gAlert('', '휴대폰을 입력해주세요');
        return false;
      }

      if (typeof vm.data.Email == 'undefined' || vm.data.Email == '') {
        //gAlert('', '이메일을 입력해주세요');
        return false;
      }

      /*    if (vm.data.HopeField1 != "040") {
          if (typeof(vm.data.CounselLoc) == "undefined" || vm.data.CounselLoc == "") {
            gAlert('', '희망지역을 선택해주세요');
            return false;
          }
        }*/

      /* if (vm.data.HopeField1 != "020" && vm.data.HopeField1 != "030" && vm.data.HopeField1 != "040") {
          if (typeof(vm.data.HopeJobType) == "undefined" || vm.data.HopeJobType == "") {
            gAlert('', '희망직종을 선택해주세요');
            return false;
          }
        }*/

      /*if (vm.data.HopeJobType == "110") {
          if (typeof(vm.data.HopeJobTypeEtc) == "undefined" || vm.data.HopeJobTypeEtc == "") {
            gAlert('', '희망직종의 기타내용을 입력해주세요.');
            return false;
          }
        }*/

      /*  if (typeof(vm.data.LastEdu) == "undefined" || vm.data.LastEdu == "") {
          gAlert('', '학력을 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAbleTel) == "undefined" || vm.data.CounselAbleTel == "") {
          gAlert('', '상담가능연락처를 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.HopeAmt) == "undefined" || vm.data.HopeAmt == "") {
          gAlert('', '희망급여(만원)을 입력해주세요');
          return false;
        }*/

      /* if (typeof(vm.data.FirstHopeDate) == "undefined" || vm.data.FirstHopeDate == "") {          
          gAlert('', '1차상담희망일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAppliRegUser) == "undefined" || vm.data.CounselAppliRegUser == "") {          
          gAlert('', '상담신천등록자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselAppliRegDate) == "undefined" || vm.data.CounselAppliRegDate == "") {          
          gAlert('', '상담신청등록일을 입력해주세요');
          return false;
        }

        if (typeof(vm.data.CustArmyRegUser) == "undefined" || vm.data.CustArmyRegUser == "") {          
          gAlert('', '등록자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CustArmyRegDate) == "undefined" || vm.data.CustArmyRegDate == "") {          
          gAlert('', '등록일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecDate) == "undefined" || vm.data.FirstDecDate == "") {          
          gAlert('', '1차상담확정일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecHour) == "undefined") {
          gAlert('', '1차상담확정일시(시)를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.FirstDecMin) == "undefined") {
          gAlert('', '1차상담확정일시(분)를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.ApprDate) == "undefined" || vm.data.ApprDate == "") {          
          gAlert('', '상담승인일을 입력해주세요');
          return false;
        }
        
        if (typeof(vm.data.ApprUser) == "undefined" || vm.data.ApprUser == "") {          
          gAlert('', '상담승인자를 선택해주세요');
          return false;
        }
        
        if (typeof(vm.data.CounselUser) == "undefined" || vm.data.CounselUser == "") {          
          gAlert('', '상담사를 선택해주세요');
          return false;
        }*/

      /*if (vm.data.oldFirstDecDate == "") { // 신규
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (vm.data.oldFirstDecDate != vm.data.FirstDecDate && getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      if (typeof vm.data.CounselRound == 'undefined' || vm.data.CounselRound == '') {
        //gAlert('', '상담회차를 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselField1 == 'undefined' || vm.data.CounselField1 == '') {
        //gAlert('', '상담분야를 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselField2 == 'undefined' || vm.data.CounselField2 == '') {
        //gAlert('', '상담분야를 선택해주세요');
        return false;
      }

      if (vm.data.CounselField2 == '010' || vm.data.CounselField2 == '020') {
        if (typeof vm.data.HopeDuty == 'undefined' || vm.data.HopeDuty == '') {
          //gAlert('', '희망직무를 선택해주세요');
          return false;
        }

        if (vm.data.HopeDuty == '151') {
          if (typeof vm.data.HopeDutyEtc == 'undefined' || vm.data.HopeDutyEtc == '') {
            //gAlert('', '희망직무기타를 입력해주세요');
            return false;
          }
        }

        if (typeof vm.data.HopeLoc == 'undefined' || vm.data.HopeLoc == '') {
          //gAlert('', '희망지역을 선택해주세요');
          return false;
        }
      }

      if (vm.data.CounselField2 == '050') {
        if (typeof vm.data.HopeLoc == 'undefined' || vm.data.HopeLoc == '') {
          //gAlert('', '희망지역을 선택해주세요');
          return false;
        }
      }

      if (typeof vm.data.CounselUser == 'undefined' || vm.data.CounselUser == '') {
        //gAlert('', '상담사를 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselDate == 'undefined' || vm.data.CounselDate == '') {
        //gAlert('', '상담일자를 선택해주세요');
        return false;
      }

      /*if (typeof vm.data.CounselTimeFromHour == 'undefined' || vm.data.CounselTimeFromHour == '') {
        //gAlert('', '상담시간 시작시를 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselTimeFromMin == 'undefined' || vm.data.CounselTimeFromMin == '') {
        //gAlert('', '상담시간 시작분을 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselTimeToHour == 'undefined' || vm.data.CounselTimeToHour == '') {
        //gAlert('', '상담시간 종료시를 선택해주세요');
        return false;
      }

      if (typeof vm.data.CounselTimeToMin == 'undefined' || vm.data.CounselTimeToMin == '') {
        //gAlert('', '상담시간 종료분을 선택해주세요');
        return false;
      }*/

      if (typeof vm.data.CounselDateHopeNext != 'undefined' && vm.data.CounselDateHopeNext != '') {
        if (typeof vm.data.CounselDateHopeNextHour == 'undefined' || vm.data.CounselDateHopeNextHour == '') {
          //gAlert('', '다음상담희망일을 입력한 경우 희망 시간을 선택해야합니다.');
          return false;
        }
        if (typeof vm.data.CounselDateHopeNextMin == 'undefined' || vm.data.CounselDateHopeNextMin == '') {
          //gAlert('', '다음상담희망일을 입력한 경우 희망 분을 선택해야합니다.');
          return false;
        }
      }

      // if (typeof vm.data.Title == 'undefined' || vm.data.Title == '') {
      if (typeof vm.data.CounselTopic == 'undefined' || vm.data.CounselTopic == '') {
        //gAlert('', '제목을 입력해주세요.');
        return false;
      }

      if (typeof vm.data.Content == 'undefined' || vm.data.Content == '') {
        //gAlert('', '내용을 입력해주세요.');
        return false;
      }

      return true;
    }

    // 저장
    function setDataAuto() {
      if ($window.sessionStorage['isLoggedIn'] != 'Y') {
        return;
      }

      if (!chkValidAuto()) {
        startTimer();
        return false;
      }

      if (vm.srch.CounselRecordId == 0) {
        // 등록
        gConfirm(
          '',
          '자동저장 하시겠습니까?',
          {
            btn: '',
            fn: function () {
              vm.data.mapCode = 'CounselRecord.insertCounselRecordDetailBatch';

              postApi.insert(
                vm.data,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docs[0].CounselRecordId !== null) {
                      // KeyId 조회
                      vm.srch.CounselRecordId = data.body.docs[0].CounselRecordId;
                      vm.data.CounselRecordId = data.body.docs[0].CounselRecordId;

                      // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
                      if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                        setWorkDataAuto(); // 업무 시스템 연동
                      } else {
                        vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';

                        postApi.update(vm.srch, function (json) {
                          if (json.header.status === CONSTANT.HttpStatus.OK) {
                            /*
                        gAlert('', 'Menu.SAVED', {
                          btn : '',
                          fn : function() {
                            if (vm.srch.CounselRecordId == 0) {
                              $state.go("app.counsel.counselrecord-list");
                            } else {
                              $state.go("app.counsel.counselrecord-detail", {
                                  CounselRecordId : vm.srch.CounselRecordId
                              });
                            }
                          }
                        });
                      */
                          }
                        });
                        startTimer();
                        return;
                      }
                    }
                  } else {
                    gAlert('', data.body.docs[0].errMessage);
                  }
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            },
          },
          {
            btn: '',
            fn: function () {
              startTimer();
              return;
            },
          }
        );
        return;
      } else {
        // 수정
        vm.data.mapCode = 'CounselRecord.updateCounselRecordDetailBatch';

        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].CounselRecordId !== null) {
                // KeyId 조회
                vm.srch.CounselRecordId = data.body.docs[0].CounselRecordId;
                vm.data.CounselRecordId = data.body.docs[0].CounselRecordId;

                // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
                if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                  setWorkDataAuto(); // 업무 시스템 연동
                } else {
                  vm.srch.mapCode = 'CounselRecord.updateCounselRecordLinkage';

                  postApi.update(vm.srch, function (json) {
                    if (json.header.status === CONSTANT.HttpStatus.OK) {
                      /*
                gAlert('', 'Menu.SAVED', {
                  btn : '',
                  fn : function() {
                    if (vm.srch.CounselRecordId == 0) {
                      $state.go("app.counsel.counselrecord-list");
                    } else {
                      $state.go("app.counsel.counselrecord-detail", {
                          CounselRecordId : vm.srch.CounselRecordId
                      });
                    }
                  }
                });
              */
                    }
                  });
                  startTimer();
                  return;
                }
              }
            } else {
              gAlert('', data.body.docs[0].errMessage);
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
    }

    var timer = null;

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
    });

    function startTimer() {
      // timer = $timeout(setDataAuto, 300000); // 타이머 : 5문 = 5 * 60 * 1000
      timer = $timeout(setDataAuto, 1500000); // 타이머 : 25분 = 25 * 60 * 1000
      // 타이머 25분으로 변경 : 김정규 책임 요청 2024.06.05
      // 30분으로 요청하였으나 로그인 세션 유지시간이 30분임을 감안하여 25분으로 변경
    }

    startTimer();
    getArmyInfoList();
  },
]);

webapp.controller('CounselrecordListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function CounselrecordListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;
    var EXCEL_SQL = 'CounselRecord.getExcelCounselRecordList';
    var EXCEL_TITLE = '상담일지목록';

    // 접근 권한 체크
    if (!isPageAccess('counselrecord-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    $scope.showBtnDel = true;
    $scope.showBtnLinkageYN = true;
    $scope.showBtnAdd = isPageAccess('counselrecord-edit', $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.deleteList = deleteList;
    vm.getExcel = getExcel;
    vm.getExcelForWork = getExcelForWork;
    vm.updateLinkageYNList = updateLinkageYNList;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
    vm.disabledArea = false;

    $scope.HopeDutyListShow = false;
    $scope.HopeDutyListEtcShow = false;
    $scope.HopeLocListShow1 = false;
    $scope.HopeLocListShow2 = false;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 데이터
    vm.data = {};

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];

    /*     if (vm.srch.ArmyArea == undefined || vm.srch.ArmyArea == '') {
      vm.srch.ArmyArea = [];
      if ($window.sessionStorage['loginArmyZone1YN'] == 'Y') {
        vm.srch.ArmyArea.push('010');
      }
      if ($window.sessionStorage['loginArmyZone2YN'] == 'Y') {
        vm.srch.ArmyArea.push('020');
      }
      if ($window.sessionStorage['loginArmyZone3YN'] == 'Y') {
        vm.srch.ArmyArea.push('030');
      }
      if ($window.sessionStorage['loginArmyZone4YN'] == 'Y') {
        vm.srch.ArmyArea.push('040');
      }
      if ($window.sessionStorage['loginArmyZone5YN'] == 'Y') {
        vm.srch.ArmyArea.push('050');
      }
    } */

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    /* vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselRoundList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1110',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1200',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList1 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.LastEduList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1220',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.LinkageYNList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1280',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.CounselMethodList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1270',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselTopicList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1440',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.srch.ArmyClass = data.Code;
      } else if (data.CodeType == '1010') {
        vm.srch.ArmyType = data.Code;
        /*} else if (data.CodeType == '1020') {
          vm.srch.HopeField = data.Code;*/
      } else if (data.CodeType == '1110') {
        vm.srch.CounselRound = data.Code;
      } else if (data.CodeType == '1200') {
        vm.srch.HopeDuty = data.Code;

        if (data.Code == '110') {
          $scope.HopeDutyEtcShow = true;
        } else {
          $scope.HopeDutyEtcShow = false;
          vm.srch.HopeDutyEtc = '';
        }
      } else if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.srch.HopeLoc = data.Code;
      } else if (data.CodeType == '1220') {
        vm.srch.LastEdu = data.Code;
      } else if (data.CodeType == '1280') {
        vm.srch.LinkageYN = data.Code;
      } else if (data.CodeType == '1270') {
        vm.srch.CounselMethod = data.Code;
      } else if (data.CodeType == '1440') {
        vm.srch.CounselTopic = data.Code;
        vm.srch.CounselTopicValue = data.CodeValue;
      }
    };

    vm.onArmyAreaListSelected = function () {
      var data = vm.srch.ArmyAreaObj;
      if (data == null) {
        vm.srch.ArmyArea = '';
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }
      vm.srch.ArmyArea = data.Code;
      vm.ArmyTypeList.ArmyArea = data.Code;
      vm.PermStat1List.ArmyArea = data.Code;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;

      vm.PermStat1List.ParentCommonCodeId = data.Code;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onPermStat2ListSelected = function (data) {
      if (data == null) {
        vm.srch.PermStat2 = '';
        return;
      }

      vm.srch.PermStat2 = data.Code;
    };

    vm.CounselField2List = {};

    vm.onCounselField1ListSelected = function (data) {
      vm.CounselField2List.CodeType = '';
      vm.CounselField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.CounselField1 = '';
        return;
      }

      vm.srch.CounselField1 = data.Code;
      vm.CounselField2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField2ListSelected = function (data) {
      if (data == null) {
        vm.srch.CounselField2 = '';

        vm.srch.HopeDuty = '';
        vm.srch.HopeDutyEtc = '';
        vm.srch.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
        return;
      }

      vm.srch.CounselField2 = data.Code;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow = true;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = vm.srch.HopeDuty == '110';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = true;
        $scope.HopeDutyEtcShow = false;
      } else {
        vm.srch.HopeDuty = '';
        vm.srch.HopeDutyEtc = '';
        vm.srch.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      }
    };

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.HopeField1 = '';
        return;
      }

      vm.srch.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      if (vm.srch.HopeField1 == '040') {
        vm.HopeField2ListShow = true;
      } else {
        vm.HopeField2ListShow = false;
        vm.srch.HopeField2 = '';
      }
    };

    vm.onHopeField2ListSelected = function (data) {
      if (data == null) {
        vm.srch.HopeField2 = '';
        return;
      }

      vm.srch.HopeField2 = data.Code;
    };

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('counselrecord-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/counsel/counselrecord-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/counsel/counselrecord-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/counsel/counselrecord-list') !== -1)
      ) {
        vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('counselrecord-list-ctrl')));

        vm.ArmyClassList.Code = vm.srch.ArmyClass;
        vm.ArmyTypeList.Code = vm.srch.ArmyType;
        vm.PermStat1List.Code = vm.srch.PermStat1;
        vm.PermStat2List.Code = vm.srch.PermStat2;
        vm.HopeField1List.Code = vm.srch.HopeField1;
        vm.HopeField2List.Code = vm.srch.HopeField2;
        vm.CounselRoundList.Code = vm.srch.CounselRound;
        vm.CounselField1List.Code = vm.srch.CounselField1;
        vm.CounselField2List.Code = vm.srch.CounselField2;
        vm.HopeDutyList.Code = vm.srch.HopeDuty;
        vm.HopeLocList1.Code = vm.srch.HopeLoc;
        vm.HopeLocList2.Code = vm.srch.HopeLoc;
        vm.LastEduList.Code = vm.srch.LastEdu;
        vm.LinkageYNList.Code = vm.srch.LinkageYN;
        vm.CounselMethodList.Code = vm.srch.CounselMethod;

        $scope.dtCounselDateFrom = setNewDate(vm.srch.CounselDateFrom);
        $scope.dtCounselDateTo = setNewDate(vm.srch.CounselDateTo);

        vm.currentPage = vm.srch.page;
      }
    }

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateFrom != '' &&
        vm.srch.CounselDateTo != null &&
        vm.srch.CounselDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.CounselDateFrom) > getDateToNumber(vm.srch.CounselDateTo)) {
          gAlert('', '상담일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      return true;
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      if (!chkValid()) return false;
      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          var resultData = postApi.makeResultData(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            // if (data.body.docs[0] != null) {
            if (resultData.body.docs[0] != null) {

              var areaList = resultData.body.docs[0].TenantArea.split(',');
              vm.ArmyAreaList = areaList.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.srch.ArmyAreaObj = vm.ArmyAreaList[0];
                vm.srch.ArmyArea = vm.srch.ArmyAreaObj.Code;
              }
            } else {
              vm.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList' + data.body.docs[0].errMessage);
        }
      );

      getListCount();
      vm.srch.page = vm.currentPage;
      $window.sessionStorage.setItem('counselrecord-list-ctrl', angular.toJson(vm.srch));

      vm.srch.mapCode = 'CounselRecord.getCounselRecordList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {

              var resultData = postApi.makeResultData(data);

              vm.lists = resultData.body.docs;

              // vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'CounselRecord.getCounselRecordListCount';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = [];
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 모달팝업 호출 (등록자)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CounselUser_ = okData.UserNm;
          vm.srch.CounselUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (등록자)
    function clearModalCounselUser() {
      vm.srch.CounselUser_ = '';
      vm.srch.CounselUser = '';
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.CounselRecordIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.CounselRecordIds.push(vm.lists[i].CounselRecordId);
        }
      }

      /*var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);
        });
        
        vm.data['uploadFileList'] = uploadFileList;*/

      if (vm.data.CounselRecordIds == null || vm.data.CounselRecordIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'CounselRecord.deleteCounselRecordDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                deleteWorkData()
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteWorkData() {
      
      vm.data.p_JC_COUNSEL_RECORD_IDs = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.p_JC_COUNSEL_RECORD_IDs.push(vm.lists[i].CounselRecordId);
        }
      };

      postApi.api(
        'extDelete/Linkage.deleteConsultRecord/action',
        //vm.linkObj,
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
              fn: function () {
                vm.dataloader = false;
              },
            });
            console.log('Error-setWorkData' + data.body.docs[0].errMessage);
          }
        },
        function (data) {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
            fn: function () {
              vm.dataloader = false;
            },
          });
          console.log('Error-setWorkData' + data.body.docs[0].errMessage);
        }
      );
    }
    // 목록 삭제
    function updateLinkageYNList() {
      gConfirm(
        '',
        '연동완료처리 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            LinkageYNListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function LinkageYNListAction() {
      vm.data.CounselRecordIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.CounselRecordIds.push(vm.lists[i].CounselRecordId);
        }
      }

      if (vm.data.CounselRecordIds == null || vm.data.CounselRecordIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'CounselRecord.updateCounselRecordLinkage';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '연동완료처리 되었습니다.', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '상담일지목록';
      log.ScreenUrl = 'app/counsel/counselrecord-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {

              var resultData = postApi.makeResultData(data);

              // vm.DownloadCheckYn = data.body.docs;
              vm.DownloadCheckYn = resultData.body.docs;

              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    /**
     * Excel 파일 다운로드
     * @param
     * @return
     */
    /* function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', 'Menu.데이터가 없습니다.');
        return;
      }

      var a = document.createElement('a');
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      var excelHeader = [
        ['일련번호', 'MM_NO'],
        ['아이디', 'ArmyId'],
        ['권역', 'ArmyArea'],
        ['소속부대', 'PermStat'],
        ['성명', 'CustNm'],
        ['군번', 'ArmyNo'],
        ['계급', 'ArmyClass'],
        ['군별', 'ArmyType'],
        ['소속부대_사단', 'PermStat1'],
        ['소속부대_연대', 'PermStat2'],
        ['상담희망분야_1차', 'HopeField1'],
        ['상담희망분야_2차', 'HopeField2'],
        ['병과및특기', 'Spec'],
        ['임관/입대일', 'InArmyDate'],
        ['전역일', 'OutArmyDate'],
        ['휴대폰', 'Mobile'],
        ['전역후연락가능번호', 'OutArmyTel'],
        ['학력', 'LastEdu'],
        ['상담메모', 'CounselMemo'],
        ['추가메모정보', 'AddMemo'],
        ['상담회차', 'CounselRound'],
        ['상담분야_대분류', 'CounselField1'],
        ['상담분야_중분류', 'CounselField2'],
        ['희망직무', 'HopeDuty'],
        ['취업희망지역', 'HopeLoc'],
        ['상담분야_대분류', 'CounselField3'],
        ['상담분야_중분류', 'CounselField4'],
        ['희망직무', 'HopeDuty2'],
        ['취업희망지역', 'HopeLoc2'],
        ['상담사', 'CounselUser'],
        ['상담일자', 'CounselDate'],
        ['상담시작시간', 'CounselTimeFrom'],
        ['상담종료시간', 'CounselTimeTo'],
        ['다음상담희망일', 'CounselDateHopeNext'],
        ['다음상담희망시', 'CounselDateHopeNextHour'],
        ['상담방법', 'CounselMethod'],
        ['제목', 'Title'],
        ['상담내용', 'Content'],
      ];

      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];
            var columnHeader = [];
            var columnData;

            angular.forEach(excelHeader, function (head) {
              columnHeader.push(head[0]);
            });
            obj.push(columnHeader);
            angular.forEach($scope.jsonToExport, function (data) {
              columnData = [];
              angular.forEach(excelHeader, function (head) {
                if (!isNullOrEmpty(data[head[1]])) {
                  columnData.push(data[head[1]]);
                } else {
                  columnData.push('');
                }
              });
              obj.push(columnData);
            });

            $scope.exportData = obj;

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        },
        function (error) {
          // 조회 중 오류 발생
          console.error('Error> getExcelFile()');
          console.table(error);
        }
      );
    } */

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '일련번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MM_NO';
      header.push(obj);

      obj = {};
      obj.title = '아이디';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyId';
      header.push(obj);

      obj = {};
      obj.title = '권역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyArea';
      header.push(obj);

      obj = {};
      obj.title = '소속부대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat';
      header.push(obj);

      obj = {};
      obj.title = '성명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CustNm';
      header.push(obj);

      obj = {};
      obj.title = '군번';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyNo';
      header.push(obj);

      obj = {};
      obj.title = '계급';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyClass';
      header.push(obj);

      obj = {};
      obj.title = '군별';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyType';
      header.push(obj);

      obj = {};
      obj.title = '소속부대_사단';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat1';
      header.push(obj);

      obj = {};
      obj.title = '소속부대_연대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat2';
      header.push(obj);

      obj = {};
      obj.title = '상담희망분야_1차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeField1';
      header.push(obj);

      obj = {};
      obj.title = '상담희망분야_2차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeField2';
      header.push(obj);

      obj = {};
      obj.title = '병과및특기';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Spec';
      header.push(obj);

      obj = {};
      obj.title = '임관/입대일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'InArmyDate';
      header.push(obj);

      obj = {};
      obj.title = '전역일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'OutArmyDate';
      header.push(obj);

      obj = {};
      obj.title = '휴대폰';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Mobile';
      header.push(obj);

      obj = {};
      obj.title = '전역후연락가능번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'OutArmyTel';
      header.push(obj);

      obj = {};
      obj.title = '학력';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'LastEdu';
      header.push(obj);

      obj = {};
      obj.title = '상담메모';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselMemo';
      header.push(obj);

      obj = {};
      obj.title = '추가메모정보';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'AddMemo';
      header.push(obj);

      obj = {};
      obj.title = '상담회차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselRound';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_대분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField1';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_중분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField2';
      header.push(obj);

      obj = {};
      obj.title = '희망직무';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeDuty';
      header.push(obj);

      obj = {};
      obj.title = '취업희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeLoc';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_대분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField3';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_중분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField4';
      header.push(obj);

      obj = {};
      obj.title = '희망직무';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeDuty2';
      header.push(obj);

      obj = {};
      obj.title = '취업희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeLoc2';
      header.push(obj);

      obj = {};
      obj.title = '상담사';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselUser';
      header.push(obj);

      obj = {};
      obj.title = '상담일자';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDate';
      header.push(obj);

      obj = {};
      obj.title = '상담시작시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeFrom';
      header.push(obj);

      obj = {};
      obj.title = '상담종료시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeTo';
      header.push(obj);

      obj = {};
      obj.title = '다음상담희망일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDateHopeNext';
      header.push(obj);

      obj = {};
      obj.title = '다음상담희망시';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDateHopeNextHour';
      header.push(obj);

      obj = {};
      obj.title = '상담방법';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselMethod';
      header.push(obj);

/*      obj = {};
      obj.title = '제목';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Title';
      header.push(obj);*/

      obj = {};
      obj.title = '상담주제';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTopic';
      header.push(obj);

      obj = {};
      obj.title = '상담내용';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Content';
      header.push(obj);
      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '상담일지목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;
      $http({
        url: StaticVariable.getUrl(
          '/excel/CounselRecord.getExcelCounselRecordList/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    // 엑셀 다운로드
    function getExcelForWork() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '상담관리일련번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselRecordID';
      header.push(obj);

      obj = {};
      obj.title = '회원일련번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MM_NO';
      header.push(obj);

      obj = {};
      obj.title = '아이디';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyId';
      header.push(obj);

      obj = {};
      obj.title = '성명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CustNm';
      header.push(obj);

      obj = {};
      obj.title = '상담회차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselRound';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_대분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField1';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_중분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField2';
      header.push(obj);

      obj = {};
      obj.title = '희망직무';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeDuty';
      header.push(obj);

      obj = {};
      obj.title = '취업희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeLoc';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_대분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField3';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_중분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField4';
      header.push(obj);

      obj = {};
      obj.title = '희망직무';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeDuty2';
      header.push(obj);

      obj = {};
      obj.title = '취업희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeLoc2';
      header.push(obj);

      obj = {};
      obj.title = '상담사';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselUser';
      header.push(obj);

      obj = {};
      obj.title = '상담일자';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDate';
      header.push(obj);

      obj = {};
      obj.title = '상담시작시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeFromHour';
      header.push(obj);

      obj = {};
      obj.title = '상담시작분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeFromMin';
      header.push(obj);

      obj = {};
      obj.title = '상담종료시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeToHour';
      header.push(obj);

      obj = {};
      obj.title = '상담종료분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselTimeToMin';
      header.push(obj);

      obj = {};
      obj.title = '다음상담희망일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDateHopeNext';
      header.push(obj);

      obj = {};
      obj.title = '다음상담희망시';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDateHopeNextHour';
      header.push(obj);

      obj = {};
      obj.title = '다음상담희망분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselDateHopeNextMin';
      header.push(obj);

      obj = {};
      obj.title = '제목';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Title';
      header.push(obj);

      obj = {};
      obj.title = '상담내용';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Content';
      header.push(obj);

      obj = {};
      obj.title = '상담방법';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselMethod';
      header.push(obj);
      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '업무시스템용상담일지목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl(
          '/excel/CounselRecord.getExcelCounselRecordListForWork/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    vm.setSortColumn = function (sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = 'ASC';
      } else {
        //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getList();
    };

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    vm.setSortDirect = function (sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    };

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    // 데이터 조회
    getList();
  },
]);

/**
 * @ngdoc function
 * @name app.counsel:schedule-list-ctrl
 * @description
 * # 일정조회
 * Controller of the 일정조회
 */
webapp.controller('ScheduleListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'postApi',
  'uiCalendarConfig',
  'gAlert',
  'gConfirm',
  '$compile',
  'modalFactory',
  /**
   * 일정조회 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} ScheduleAPISvr - ScheduleAPISvr Module
   */
  function ScheduleListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    uiCalendarConfig,
    gAlert,
    gConfirm,
    $compile,
    modalFactory
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('schedule-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 검색 조건
    vm.srch = {
      baseDate: new moment().format('YYYY-MM-DD'),
      CustNm: '',
      CustArmyId: '',
      PermStat: '',
      /*SchUserId   : $window.sessionStorage['loginUserIdx'],
     SchUserId_  : $window.sessionStorage['loginUserName'],*/
      SchUserId: '',
      SchUserId_: '',
      Title: '',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 공통코드 정의
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: vm.srch.userPermList,
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1010') {
        vm.srch.ArmyType = data.Code;
      }
    };

    vm.PermStat1List = {
      userPermList: vm.srch.userPermList,
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;
      vm.PermStat1List.ParentCommonCodeId = data.Code;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onPermStat2ListSelected = function (data) {
      if (data == null) {
        vm.srch.PermStat2 = '';
        return;
      }

      vm.srch.PermStat2 = data.Code;
    };

    // 변수 선언
    $scope.SelectedEvent = null;
    var isFirstTime = true;

    $scope.events = [];
    $scope.eventSources = [$scope.events];
    $scope.NewEvent = {};

    // 전역상수 선언

    /**
     * 고객 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalCustInfo() {
      var ctrl = 'CustarmyModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/customerarmy/custarmy-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.srch.CustNm = okData.CustNm;
          vm.srch.CustArmyId = okData.CustArmyId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 고객 초기화
     *
     * @param
     * @return
     */
    function clearModalCustInfo() {
      vm.srch.CustNm = '';
      vm.srch.CustArmyId = '';
    }

    /**
     * 상담사 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.SchUserId_ = okData.UserNm;
          vm.srch.SchUserId = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 상담사 초기화
     *
     * @param
     * @return
     */
    function clearModalUser() {
      vm.srch.SchUserId_ = '';
      vm.srch.SchUserId = '';
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */

    function getList() {
      $window.sessionStorage.setItem('Schedule-list-ctrl', angular.toJson(vm.srch));

      vm.srch.mapCode = 'Schedule.getScheduleList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              // 검색결과 저장
              vm.lists = data.body.docs;
            } else {
              // 검색된 결과 없음
              vm.lists = {};

              /*gAlert('알림', '데이터가 존재하지 않습니다.', {
           btn : '',
           fn : function() {}
         });*/
            }

            // 달력에 일정 표시
            setDataInCalendar();
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error> Schedule-list-ctrl> getList()', status, error);
        }
      );
    }

    /**
     * 달력에 일정 표시
     * @param
     * @return
     * @author 최원영
     */
    function setDataInCalendar() {
      try {
        // 달력 초기화
        if (uiCalendarConfig.calendars.myCalendar != null) {
          uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
          uiCalendarConfig.calendars.myCalendar.fullCalendar('unselect');
        }

        // event 초기화
        $scope.events.slice(0, $scope.events.length);

        if (vm.lists.length > 0) {
          /*angular.forEach(vm.lists, function (item) {
            $scope.events.push({
               id: item.SchId,
               title: item.CustNm + '(' + item.PermStat_ + '), ' + item.SchUserId_,
               description: " ",
               start: new moment(item.StartDate).toDate(),
               end: new moment(item.EndDate).toDate(),
               allDay: false,
               stick: true,
               startEditable: false,
               durationEditable: false
             });
         });*/

          var addEvent = uiCalendarConfig.calendars.myCalendar.fullCalendar('addEventSource', vm.lists);

          if (typeof addEvent != 'undefined') {
            location.reload();
          }
        }
      } catch (ex) {
        console.log("error");
        // console.error('Error> Schedule-list-ctrl> setDataInCalendar()> ' + ex.message);
      }
    }

    /**
     * 일정정보
     * @param
     * @return
     * @author 최원영
     */
    function showScheduleModalPopup(schId) {
      try {
        // Modal Popup Controller 정의
        var ctrl = 'ScheduleModalCtrl as modalCtrl';

        // Modal Popup에 전달할 Parameter 정의
        var paramData = { BaseDate: vm.srch.baseDate, SchId: schId };

        // Modal Popup 호출
        var modalInstance = modalFactory.open('modal', 'app/counsel/modal/schedule-modal.html', ctrl, paramData);

        modalInstance.result.then(
          function (okData) {
            // 데이터 조회
            getList();
          },
          function (cancelData) {
            // Cancel 처리
          }
        );
      } catch (ex) {
        console.log("error");
        // console.error('Error> Schedule-list-ctrl> showScheduleModalPopup()> ' + ex.message);
      }
    }

    /**
     * 달력 초기화
     * @param
     * @return
     * @author 최원영
     */
    $scope.uiConfig = {
      calendar: {
        height: 1500,
        editable: true,
        eventLimit: 11,
        displayEventTime: true,
        header: {
          left: '',
          center: 'title',
          right: 'prev,next today month,agendaWeek,agendaDay',
        },
        views: {
          basic: {
            titleFormat: 'YYYY.MM.DD',
          },
          month: {
            titleFormat: 'YYYY.MM',
          },
          agenda: {
            titleFormat: 'YYYY.MM.DD',
          },
          week: {
            titleFormat: 'YYYY.MM.DD',
          },
          day: {
            titleFormat: 'YYYY.MM.DD',
          },
        },
        timeFormat: 'H(:mm)',
        monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        dayNames: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
        buttonText: {
          today: '오늘',
          month: '월간',
          week: '주간',
          day: '일간',
        },
        selectable: false,
        selectHelper: true,
        navLinks: true,
        navLinkDayClick: function (date, jsEvent) {
          vm.srch.baseDate = moment(date).format('YYYY-MM-DD');
          uiCalendarConfig.calendars.myCalendar.fullCalendar('gotoDate', date);
          uiCalendarConfig.calendars.myCalendar.fullCalendar('changeView', 'agendaDay');
        },
        select: function (start, end) {
          vm.srch.baseDate = moment(start).format('YYYY-MM-DD');
        },
        eventClick: function (event) {
          vm.srch.baseDate = moment(event.start).format('YYYY-MM-DD');

          // 일정수정
          showScheduleModalPopup(event.id);
        },
        dayClick: function (date, jsEvent, view) {
          vm.srch.baseDate = moment(date).format('YYYY-MM-DD');

          // 일정등록
          showScheduleModalPopup('');
        },
        eventAfterAllRender: function () {},
        viewRender: function (view, element) {},
        dayRender: function (date, cell) {},
        eventRender: function (event, element, view) {
          vm.srch.baseDate = '';
          vm.lists = [];

          element.attr({
            tooltip: event.title,
            'tooltip-append-to-body': true,
          });
          $compile(element)($scope);
        },
      },
    };

    // 함수 선언
    vm.getList = getList;
    vm.showModalCustInfo = showModalCustInfo;
    vm.clearModalCustInfo = clearModalCustInfo;
    vm.showModalUser = showModalUser;
    vm.clearModalUser = clearModalUser;

    // 데이터 조회
    getList();
  },
]);

(function () {
  "use strict";
  webapp.controller('CtiListCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', 'gConfirm', '$window', '$state', 'gAlert',
  function CtiListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, gConfirm, $window, $state, gAlert) {

    var vm = this;

    // 담당자
    postApi.select({mapCode : 'ScUser.getUserListCodes'}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeManager = result.body.docs;
      }
    });

    vm.codeExceptYN = [
      {Code : "N", CodeValue : "N"},
      {Code : "Y", CodeValue : "Y"}
    ]

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "ctihist",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",

      apis : {
        initSelectCnt : { mapCode : "CtiHist.getCtihistListCnt"},
        initSelect : { mapCode : "CtiHist.getCtihistList", param : {ExceptYN : "N"} },
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : true,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      addFormGroup : {
        srchTime : { after : "Manager", type : mElemTx.datetime,  bindKey : ["TimeFrom", "TimeTo"], label : "통화시작시간", addDivision : true, colSize : 1}
      },

      srchDateType : {
        TimeFrom : "from",
        TimeTo : "to",
      },

      customCodes : {
        Manager : "codeManager"
        , ExceptYN : "codeExceptYN"
      },

      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      //listClickCallback : clickevent

    };

    var btnTemp = '<button class="btn btn-primary" ng-if="!li.CustId && li.ExceptYN ==\'N\' && li.ExceptYNExt==\'N\'" ng-click="vc.setBtnCtrl(li, \'R\')">등록</button><button class="btn btn-remove" ng-if="li.ExceptYN ==\'N\' && li.ExceptYNExt==\'N\'" ng-click="vc.setBtnCtrl(li, \'D\')">제외</button>'
    btnTemp += '<button class="btn btn-default" ng-if="li.ExceptYN ==\'Y\'" ng-click="vc.setBtnCtrl(li, \'C\')">제외취소</button>';
    vm.listOptions = {

      html : {
        SRC : {
          template : '<span class="cust-list-call-btn" ng-click="vc.callToMobile(li, $event)"><i class="fa fa-phone" style=" color:#00da6c" ></i> {{value}}</span>'
        },
      },

      addColumn : {
        Action : {
          title : "동작",
          after : "KINDNM",
          template : btnTemp,
          size : "120px",
          textAlign : "center",
        }
      }
    }
    function clickevent(clickData){
      vm.custCounselAddModal(clickData.KeyId, clickData.VisitId, clickData.SurgicalId);
    }

    vm.pages = 'app/customer/customer-detail.html';
    function onReadyAutoView() {

    }

    function callToMobile(data, e) {
      e.stopPropagation();
      postApi.select({mapCode : "ScUser.getUserToken", LoginId : $window.sessionStorage["loginUserId"]}, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(result.body.docs.length > 0) {
            if(isNullOrEmpty(data.SRCTitle)) {
            } else {
              av.confirm("전화를 거시겠습니까?", function(){
                sendFcmData(result.body.docs[0].PushToken, "SALEVISCTICALL", data.SRCTitle.toString().replaceAll("-",""));
              })              
            }
          } else {
            gAlert('', '연결 가능한 장치가 없습니다.');
          }
        }
      })
    }

    vm.setBtnCtrl = function(data, action) {
      if(action == "R") {
        var data = {
          CtiCallHistoryId : data.KeyId,
          SRC : data.SRCTitle.replaceAll("-","")
        }
        gConfirm("", "고객 등록페이지로 이동하시겠습니까?",{
          btn : '',
          fn : function() {
            $window.sessionStorage.setItem("goToCustomerAtTab", JSON.stringify(data));
            $state.go('app.customer.customer-edit', {}, { reload: true });
          }
        }, {
          btn : '',
          fn : function() {
          
          }
        });

      } else if(action == "D") {

        gConfirm("", "제외한 번호는 CTI리스트에 생성되지 않습니다. 제외하시겠습니까?",{
          btn : '',
          fn : function() {
            data.CtiCallHistoryId = data.KeyId;
            data.ExceptYN = "Y"
            data.mapCode = "CtiHist.seExceptYN"
            postApi.update(data, function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', "CTI리스트에서 제외되었습니다.", {
                  btn : '',
                  fn : function() {
                    av.search();
                  }
                });
              }
            })

          }
        }, {
          btn : '',
          fn : function() {
          
          }
        });

      } else if(action == "C") {
        gConfirm("", "제외취소한 번호는 CTI리스트에 생성됩니다. 제외 취소 하시겠습니까?",{
          btn : '',
          fn : function() {
            data.CtiCallHistoryId = data.KeyId;
            data.ExceptYN = "N"
            data.mapCode = "CtiHist.seExceptYN"
            postApi.update(data, function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', "CTI리스트에서 제외되었습니다.", {
                  btn : '',
                  fn : function() {
                    av.search();
                  }
                });
              }
            })

          }
        }, {
          btn : '',
          fn : function() {
          
          }
        });
      }
    }

    vm.custCounselAddModal = function (keyId, visitId, surgicalId) {
      var ctrl = 'CustCounselModalCtrl as vc';
      var paramData = {
        CustId: $stateParams.KeyId,
        KeyId: keyId, 
        ReserveViewType: "L", 
        VisitId: visitId, 
        SurgicalId: surgicalId
      };

      var modalInstance = modalFactory.open('lg', 'app/customer/modal/custCounsel/custCounsel-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        var KeyId = 0; var VisitId = 0; var SurgicalId = 0;

        // 새로 등록하는 경우
        if(!isNullOrEmpty(okData.CustCounselId)){ 
          KeyId = okData.CustCounselId;

          if (okData.ReserveType == "10"){ VisitId = okData.ReserveId; SurgicalId = 0; }
          else if (okData.ReserveType == "20"){ VisitId = 0; SurgicalId = okData.ReserveId; }
          else { VisitId = 0; SurgicalId = 0; }
        }
        // 수정하는 경우
        else {  
          KeyId = okData.KeyId;
          VisitId = isNullOrEmpty(okData.VisitId) ? okData.NewVisitId : okData.VisitId;
          SurgicalId = isNullOrEmpty(okData.SurgicalId) ? okData.NewSurgicalId : okData.SurgicalId;
        }

        vm.custCounselAddModal(KeyId, VisitId, SurgicalId);
      }, function (cancelData) {
        av.search();
      });
    };

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.callToMobile = callToMobile;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('CustomerCampaignCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function CustomerCampaignCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "sccustcampaign",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        initSelectCnt : { mapCode : "ScCustomer.getScCustCampaignListCnt", param : null },
        initSelect : { mapCode : "ScCustomer.getScCustCampaignList", param : null },
        
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
    };

    vm.pages = 'app/customer/customer-detail.html';
    function onReadyAutoView() {

      // 발송자, 수신자 폰번호일 경우 포멧변경
      vm.lists.forEach(function(item){
        if(!isNullOrEmpty(item.FromInfo) && item.FromInfo.indexOf("@") == -1) {
          item.FromInfo = autoHypenTel(item.FromInfo);
        }

        if(!isNullOrEmpty(item.ToInfo) && item.ToInfo.indexOf("@") == -1) {
          item.ToInfo = autoHypenTel(item.ToInfo);
        }
      });
      
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('CustomerCounselCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', 'gConfirm', 'gSelect', 'gAlert',
  function CustomerCounselCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, gConfirm, gSelect, gAlert) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "screserve",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        initSelectCnt : { mapCode : "ScCustomerReserve.getCustCounselListCnt", param : null },
        initSelect : { mapCode : "ScCustomerReserve.getCustCounselList", param : null },
        
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback : clickevent

    };

    var btnTemp = '<button class="btn btn-remove" ng-click="vc.setBtnCtrl(li, $event)">삭제</button>';
    vm.listOptions = {

      html : {
      },

      addColumn : {
        Action : {
          title : "",
          after : "RegDate",
          template : btnTemp,
          size : "120px",
          textAlign : "center",
        }
      }
    };

    vm.setBtnCtrl = function(data, e) {
      e.stopPropagation();
      if (data.RepeatId != undefined) {
        var options = [{label:'이 일정만', value:0}, {label:'이 일정 및 향후 일정', value:1}, {label:'모든 일정', value:2}];

        gSelect('', '반복 일정 삭제', {
          btn: '',
          fn: function (mode) {
            gConfirm("", "삭제한 내역은 복구 불가능합니다. 삭제하시겠습니까?",{
              btn : '',
              fn : function() {
                setDelDataAction(mode, data);
              }
            }, {
              btn : '',
              fn : function() {
              
              }
            });
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        }, options, 0);
      } else {
        gConfirm("", "삭제한 내역은 복구 불가능합니다. 삭제하시겠습니까?",{
          btn : '',
          fn : function() {
            setDelDataAction(0, data);
          }
        }, {
          btn : '',
          fn : function() {
          
          }
        });
      }
    };

    function setDelDataAction(mode, param) {
      var data = {};
      data.ReserveType = param.StatusCode;
      data.OldRepeatId = param.RepeatId;
      data.KeyId = param.KeyId;
      data.mode = mode;
      data.mapCode = 'ScCustomerReserve.deleteSccustReserveBatch';

      postApi.update(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK || result.header.status != CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn: '',
            fn: function () {
              // 삭제 성공
              av.init(autoViewOption);
            }
          });

        }
      }, function (error) {
        // 삭제 중 오류 발생
        console.log("error");
        // console.error("Error> setDelDataAction()");
        // console.table(error);
      });
    }

    function clickevent(clickData){
      vm.custCounselAddModal(clickData.KeyId, clickData.VisitId, clickData.SurgicalId);
    }

    vm.pages = 'app/customer/customer-detail.html';
    function onReadyAutoView() {

    }

    vm.custCounselAddModal = function (keyId, visitId, surgicalId) {
      var ctrl = 'CustCounselModalCtrl as vc';
      var paramData = {
        CustId: $stateParams.KeyId,
        KeyId: keyId, 
        ReserveViewType: "L", 
        VisitId: visitId, 
        SurgicalId: surgicalId
      };

      var modalInstance = modalFactory.open('lg', 'app/customer/modal/custCounsel/custCounsel-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        var KeyId = 0; var VisitId = 0; var SurgicalId = 0;

        // 새로 등록하는 경우
        if(!isNullOrEmpty(okData.CustCounselId)){ 
          KeyId = okData.CustCounselId;

          if (okData.ReserveType == "10"){ VisitId = okData.ReserveId; SurgicalId = 0; }
          else if (okData.ReserveType == "20"){ VisitId = 0; SurgicalId = okData.ReserveId; }
          else { VisitId = 0; SurgicalId = 0; }
        }
        // 수정하는 경우
        else {  
          KeyId = okData.KeyId;
          VisitId = isNullOrEmpty(okData.VisitId) ? okData.NewVisitId : okData.VisitId;
          SurgicalId = isNullOrEmpty(okData.SurgicalId) ? okData.NewSurgicalId : okData.SurgicalId;
        }

        vm.custCounselAddModal(KeyId, VisitId, SurgicalId);
      }, function (cancelData) {
        av.search();
      });
    };

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.clickevent = clickevent;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  
  /**
   * @name 고객/상담 탭 관리 Controller
   * @description 
   */
  webapp.controller('CustomerDetailCtrl', 
    ['$rootScope', '$scope', '$stateParams', '$translate', '$state', '$window',
    function CustomerDetailCtrl($rootScope, $scope, $stateParams, $translate, $state, $window) {

      var vm = this;
      vm.layout = $state.current.name.indexOf('customer-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard;
  
      vm.url = $state.current.url;
      vm.keyId = $stateParams.keyId;
      vm.view = {
        VIEW_PAGE_DETAIL : 'app/customer/customer-edit.html', // 상세 화면
        VIEW_PAGE_COUNSEL : 'app/customer/customer-counsel.html', // 히스토리 화면
        VIEW_PAGE_PAYMENT : 'app/customer/customer-payment.html', // 결제 화면
        VIEW_PAGE_PENCHART : 'app/customer/customer-penchart.html', // 펜차트 화면
        VIEW_PAGE_CAMPAIN : 'app/customer/customer-campaign.html', // 캠페인 화면
        VIEW_PAGE_HISTORY : 'app/customer/customer-history.html', // 이력관리 화면
      };
      vm.pages = vm.view.VIEW_PAGE_DETAIL;
      vm.tabIndex = 0;

      function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      }

      var checkTab = $window.sessionStorage.getItem("goToCustomerAtTab");
      if(!isNullOrEmpty(checkTab)) {
        checkTab = JSON.parse(checkTab);
        $window.sessionStorage.setItem("goToCustomerAtTab", "");
        setChangeTab(checkTab.idx, checkTab.tab);
      } else {
        $window.sessionStorage.setItem("goToCustomerAtTab", "");
      }

      // var checkReloadPenchart = $window.sessionStorage.getItem("scheduleToPenChart");
      // if(eval(checkReloadPenchart)) {
      //   $window.sessionStorage.setItem("scheduleToPenChart", false)
      //   setChangeTab(3, "VIEW_PAGE_PENCHART")
      // }

      //setChangeTab(3, "VIEW_PAGE_PENCHART")
      // 함수 정의
      vm.setChangeTab = setChangeTab;

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });
      
    }]);
})();

(function () {
  "use strict";
  webapp.controller('CustomerEditCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function CustomerEditCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {

    var vm = this;

    // CustCodes 정의
    vm.codeChartCreateType = [
      {Code : 'Y', CodeValue : '자동'},
      {Code : 'N', CodeValue : '수동'},
    ];

    // 결혼여부
    vm.codeMarriageYn = [
      {Code : 'N', CodeValue : '미혼'},
      {Code : 'Y', CodeValue : '기혼'},
    ];

    vm.codeLnrSlrType = mCommonCodeTable.lnrSlrType; // 음력양력
    vm.codeAgree = mCommonCodeTable.codeAgree; // 수신동의
    vm.codeKakao = [{Code : 'Y', CodeValue : '가능'}]
    vm.codeGender = mCommonCodeTable.gender;   // 성별
    vm.CtiCallHistoryId = "";

    // 지점코드
    postApi.select({mapCode : 'organizationMng.getOrganizationCodes', Depth : 1}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeBranchCode = result.body.docs;
      }
    });

    // 담당자
    postApi.select({mapCode : 'ScUser.getUserListCodes'}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeManager = result.body.docs;
      }
    });

    // 당당부서
    vm.codeDepts = [];
    
    // 이력관리 비교 데이터
    vm.copyCustInfo = {};

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.Edit, // List OR Edit
      /* 상세페이지 */
      // 엘리먼트 퍼블리싱 타입
      formType : mElemTx.layout.inline,
      tableNm : "Customer",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "data", // ex : vc.data = {}
      apis : {
        /** common mapper **/
        // initSelect : 기본 데이터를 가져오는 코드 
        initSelect : { mapCode : "ScCustomer.getCustomerDetail", param : null },
        // vieType is edit
        insert : "ScCustomer.insertCustomer",
        update : "ScCustomer.updateCustomer",        
      },

      // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
      addRow : [],

      // vc의 ng-if
      ngIf : {
        CustType : "false",
      },
      
      // 비활성화 시킬 컬럼의 조건
      disabled : {
        // 차트번호가 자동일 경우 disable 처리
        ChartNo : "vc.data.ChartNoAutoYN == 'Y'",
        BranchNm : false,
        MarriageDate : "vc.data.MarriageYN == 'N'",
        Age : true,
        // CustNm : "vc.data.KeyId",
        CustRegDt : "vc.data.KeyId",
        InquiryDate : true,
        LastVisitDate : true,
      },

      // MataColum 외 추가 적으로 넣어야할 폼
      addForm : {
        Age : { after : 'BirthDay', type : mElemTx.input, colSize: 4, label : "나이"},
        // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
        Address : { after : "CustGrade", type : mElemTx.address,  bindKey : ["ZipCode", "Addr1", "Addr2"], label : "주소"}
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange : {
        BirthDay : "setChangeBirthDay",
        InquiryDate : "setChangeBirthDay"
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback : {
        CustNm : "setChangeDefaultCustInfo",
        Mobile : "setChangeDefaultCustInfo",
      },

      timeOption : {
        InquiryDate : {
          minuteStep : 30, initActiveCalendar : true
        }
      },

      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes : {
        ChartNoAutoYN : "codeChartCreateType",
        SmsYN : "codeAgree",
        EmailYN : "codeAgree",
        BranchCodeId : "codeBranchCode",
        DeptCodeId : "codeDepts",
        LnrSlrType : "codeLnrSlrType",
        Manager : "codeManager"
      },
      
      customColSize : {
        Age : "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
        Address : "col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8",
        SpcNote : "col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8",
      },

      // 필수 항목 컬럼 
      required : ["CustNm", "Mobile", "Manager"]
      
    };
    
    /** 
     * @description 각 필드가 지점인지 아닌지 체크하는 로직
    **/
    function checkBranchHist(key) {
      var branchInfos = [
        "ChartNo", "ChartNoAutoYN", "CustGubun", "CustGrade", "VisitPath",
        "Manager", "SmsYN", "EmailYN", "KakaoYN", "SpcNote"
      ];
      var result = false;
      for(var i = 0; i < branchInfos.length; i++) {
        if(branchInfos[i] == key) {
          result = true;
          break;
        }
      }
      return result;
    }

    /** 
     * @description 이력 값 채우는 함수
    **/
    function concatHist (key, before, after) {

      try {
        var colNm = vm._columnMaps[key].ColumnLogicalNm;

        if(checkBranchHist(key)) {
          if(!isNullOrEmpty(before)) {
            vm.data.BranchHist += colNm + " : " + before + " > " + after + "</br>";
          } else {
            vm.data.BranchHist += colNm + " : " + after + "</br>";
          }
        } else {
          if(!isNullOrEmpty(before)) {
            vm.data.TenantHist += colNm + " : " + before + " > " + after + "</br>";
          } else {
            vm.data.TenantHist += colNm + " : " + after + "</br>";
          }
        }
      } catch (e) {
        if(!isNullOrEmpty(before)) {
          vm.data.TenantHist += key + " : " + before + " > " + after + "</br>";
        } else {
          vm.data.TenantHist += key + " : " + after + "</br>";
        }
      }
    }

    // 저장 버튼 클릭 시
    function setData() {
     
      vm.data.BranchHist = "";
      vm.data.TenantHist = "";
      var addressFrom = "";
      var addressTo = "";
      var keys = Object.keys(vm.data);
      if(vm.data.KeyId) {
        for(var i = 0; i < keys.length; i++) {

          if(keys[i] == "Age") {
            continue;
          }

          if(vm.copyCustInfo[keys[i]] != vm.data[keys[i]]) {
            if(vm._columnMaps[keys[i]]) {
              if(checkBranchHist(keys[i])) {
                if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "CustGubun") {
                  var beforeNm = "", afterNm = "";
                  for(var j = 0; j < vm._columnMaps['CustGubun'].CodeList.length; j++) {
                    var at = vm._columnMaps['CustGubun'].CodeList[j];
                    if(at.Code == vm.copyCustInfo[keys[i]]) beforeNm = at.CodeValue;
                    if(at.Code == vm.data[keys[i]]) afterNm = at.CodeValue;
                    if(beforeNm != "" && afterNm != "") break;
                  }              
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "CustGrade") {
                    var beforeNm = "", afterNm = "";
                    for(var j = 0; j < vm._columnMaps['CustGrade'].CodeList.length; j++) {
                      var at = vm._columnMaps['CustGrade'].CodeList[j];
                      if(at.Code == vm.copyCustInfo[keys[i]]) beforeNm = at.CodeValue;
                      if(at.Code == vm.data[keys[i]]) afterNm = at.CodeValue;
                      if(beforeNm != "" && afterNm != "") break;
                    }
                    concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "Manager") {
                  var beforeNm = "", afterNm = "";
                  for(var j = 0; j < vm.codeManager.length; j++) {
                    var at = vm.codeManager[j];
                    if(at.Code == vm.copyCustInfo[keys[i]]) beforeNm = at.CodeValue;
                    if(at.Code == vm.data[keys[i]]) afterNm = at.CodeValue;
                    if(beforeNm != "" && afterNm != "") break;
                  }
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "VisitPath") {
                  var beforeNm = "", afterNm = "";
                  for(var j = 0; j < vm._columnMaps['VisitPath'].CodeList.length; j++) {
                    var at = vm._columnMaps['VisitPath'].CodeList[j];
                    if(at.Code == vm.copyCustInfo[keys[i]]) beforeNm = at.CodeValue;
                    if(at.Code == vm.data[keys[i]]) afterNm = at.CodeValue;
                    if(beforeNm != "" && afterNm != "") break;
                  }
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "ChartNoAutoYN") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "Y") ? "자동" : "수동";
                  afterNm = (vm.data[keys[i]] == "Y") ? "자동" : "수동";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "EmailYN") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "Y") ? "동의" : "거절";
                  afterNm = (vm.data[keys[i]] == "Y") ? "동의" : "거절";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "SmsYN") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "Y") ? "동의" : "거절";
                  afterNm = (vm.data[keys[i]] == "Y") ? "동의" : "거절";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "KakaoYN") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "Y") ? "동의" : "거절";
                  afterNm = (vm.data[keys[i]] == "Y") ? "동의" : "거절";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                }  else {
                  concatHist(keys[i], vm.copyCustInfo[keys[i]], vm.data[keys[i]])
                }

              } else {
                if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "MarriageYN") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "Y") ? "기혼" : "미혼";
                  afterNm = (vm.data[keys[i]] == "Y") ? "기혼" : "미혼";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "BirthDay" || vm._columnMaps[keys[i]].ColumnPhysicalNm == "MarriageDate") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = moment.utc(vm.copyCustInfo[keys[i]]).format("YYYY-MM-DD") 
                  afterNm = moment.utc(vm.data[keys[i]]).format("YYYY-MM-DD") 
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "Gender") {
                  var beforeNm = "", afterNm = "";
                  beforeNm = (vm.copyCustInfo[keys[i]] == "M") ? "남성" : "여성";
                  afterNm = (vm.data[keys[i]] == "M") ? "남성" : "여성";
                  
                  concatHist(keys[i], beforeNm, afterNm);
                } else if(vm._columnMaps[keys[i]].ColumnPhysicalNm == "Mobile") {
                    var beforeNm = "", afterNm = "";
                    beforeNm = autoHypenTel(vm.copyCustInfo[keys[i]]);
                    afterNm = autoHypenTel(vm.data[keys[i]]);
                    
                    concatHist(keys[i], beforeNm, afterNm);
                } else {
                  concatHist(keys[i], vm.copyCustInfo[keys[i]], vm.data[keys[i]])
                }
              
              }
            } 
          }
        }

        var addressFrom = "[" + vm.copyCustInfo['ZipCode'] + "] " + vm.copyCustInfo['Addr1'] + ' ' + vm.copyCustInfo['Addr2'];
        var addressTo = "[" + vm.data['ZipCode'] + "] " + vm.data['Addr1'] + ' ' + vm.data['Addr2'];

        if(addressFrom != addressTo) {
          if(isNullOrEmpty(vm.copyCustInfo['ZipCode'])){
            addressFrom = "";
          }
          concatHist("주소", addressFrom, addressTo);
        }
      }

      if( !isNullOrEmpty(vm.CtiCallHistoryId)) {
        vm.data.CtiCallHistoryId = vm.CtiCallHistoryId;
      }

      av.confirm("Menu.SAVECONFIRM2", function(){
        av.commit(function(result){
          if(vm.data.KeyId) {
            vm.data.CustBranchId = result.body.docs[0].BranchNewId;
            vm.copyCustInfo = angular.copy(vm.data);
          } else {
            vm.data.KeyId = result.body.docs[0].RelateDataId;
            vm.data.CustBranchId = result.body.docs[0].BranchNewId;
            vm.copyCustInfo = angular.copy(vm.data);
          }
          av.alert('Menu.SAVED', function(){
            var url = (vm.layout == 'N') ? "app.customer.customer-detail" : "app.customer.customer-list.detail";
            var param = {};
            param.srch = '';
            param.KeyId = result.body.docs[0].RelateDataId;
            param = JSON.stringify(param);
            $state.go(url, JSON.parse(param) , {reload: url});
          });
        });
      });
    }

    vm.delData = function() {
      av.confirm("Menu.DELETECONFIRM", function() {
        var p = angular.copy(vm.data);
        p.mapCode = "ScCustomer.deleteCustomer";
        postApi.update(p, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            av.alert('Menu.DELETED', function() {
              goNextPage();
            });
            return;
          } else {
            av.alert('Menu.CANNOTDELETE');
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
          av.alert(error.body.docs[0].errMessage);
        });
      });
    };

    function goNextPage() {
      $state.go("app.customer.customer-list", {srch:$stateParams.srch}, {reload:"app.customer.customer-list"});
    }

    function onReadyAutoView() {
      // 초기 설정
      if(!vm.data.KeyId) {
        vm.data.ChartNoAutoYN = "N";
        vm.data.MarriageYN = "N"
        vm.data.SmsYN = "Y"
        vm.data.EmailYN = "Y"
        vm.data.CustRegDt = moment(new Date()).local('YYYY-MM-DD');
        vm.data.Manager = $window.sessionStorage['loginUserIdx'];

        var checkTab = $window.sessionStorage.getItem("goToCustomerAtTab");
        if(!isNullOrEmpty(checkTab)) {
          checkTab = JSON.parse(checkTab);
          vm.data.Mobile = checkTab.SRC;
          vm.CtiCallHistoryId = checkTab.CtiCallHistoryId;
          $window.sessionStorage.setItem("goToCustomerAtTab", "");
        } else {
          $window.sessionStorage.setItem("goToCustomerAtTab", "");
        }

      } else {  
        vm.copyCustInfo = angular.copy(vm.data);
        if(vm.data.BirthDay) {
          vm.calcAge(moment(vm.data.BirthDay));
        }
      }

      vm.layout = $state.current.name.indexOf('customer-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard;
      if ($state.current.name.indexOf('customer-detail') > -1) {
        vm.layout = '';
      }
    }

    /** 
     * @description 생년월일 변경 시 나이를 셋팅 해준다.
    **/
    function setChangeBirthDay(key, date) {
      vm.calcAge(date);
    }

    vm.calcAge = function(birth) {
      
      var date = new Date();
      var year = date.getFullYear();
      var month = (date.getMonth() + 1);
      var day = date.getDate();       
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      var monthDay = month + day;

      var year2 = birth.year();
      var month2 = (1 + birth.month());
      month2 = month2 >= 10 ? month2 : '0' + month2;
      var day2 = birth.day();
      day2 = day2 >= 10 ? day2 : '0' + day2;
      birth =  year2 + "" +month2 + '' + day2;
      var birthdayy = birth.substr(0, 4);
      var birthdaymd = birth.substr(4, 4);

      vm.data.Age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;
    } 

    function setChangeDefaultCustInfo() {

      var p = angular.copy(vm.data);
      p.findUser = "Y";
      p.mapCode = "ScCustomer.getCustomerDetail"
      postApi.select(p, function(result){
        if(result.body.docs.length > 0) {
          if(result.body.docs[0].CheckCustBranch == "Y") {
            var url = (vm.layout == 'N') ? "app.customer.customer-detail" : "app.customer.customer-list.detail";
            var param = {};
            param.srch = '';
            param.KeyId = result.body.docs[0].KeyId;
            param = JSON.stringify(param);

            if(!vm.data.KeyId && !isNullOrEmpty(vm.data.CustNm) && !isNullOrEmpty(vm.data.Mobile)) {
              
              $state.go(url, JSON.parse(param) , {reload: url});
            } else {

              if(vm.copyCustInfo.CustNm != vm.data.CustNm || vm.copyCustInfo.Mobile != vm.data.Mobile) {
                av.alert("이미 등록된 고객이 있습니다. 해당 페이지로 이동합니다.", function(){
                  $state.go(url, JSON.parse(param));
                })
              }
            }

          } else{
            vm.data = result.body.docs[0];
            if(vm.data.BirthDay) {
              vm.calcAge(moment(vm.data.BirthDay));
            }
          }
          
        }
      });
    }

    function goList() {
      $window.history.back();
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.setChangeDefaultCustInfo = setChangeDefaultCustInfo;
    vm.setData = setData;
    
    vm.setChangeBirthDay = setChangeBirthDay;
    vm.goList = goList;

    vm.custMigrationModal = function () {
      var ctrl = 'CustMigrationModalCtrl as vc';
      var paramData = {};

      var modalInstance = modalFactory.open('md', 'app/customer/modal/custMigration/custMigration-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        // ok버튼
      }, function (cancelData) {
        // cancel버튼
      });
    };

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();

(function () {
  "use strict";
  webapp.controller('CustomerHistoryCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function CustomerHistoryCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "Sccusthist",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        initSelectCnt : { mapCode : "ScCustomer.getSccusthistListCnt", param : null },
        initSelect : { mapCode : "ScCustomer.getSccusthistList", param : null },
        
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
    };

    vm.pages = 'app/customer/customer-detail.html';
    function onReadyAutoView() {

    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객조회
   */
  webapp.controller('CustomerListCtrl', 
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window',
    function CustomerListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state, $window) {

      var vm = this;

      // 담당자
      postApi.select({mapCode : 'ScUser.getUserListCodes'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
        }
      });

      // 추천상품
      postApi.select({mapCode : 'ScItemType.getScitemtypeCodes'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
         // vm.codeRecommendItem = result.body.docs;
        }
      });

      postApi.select({ mapCode: 'ScItemType.getScitemtypeCodes',ItemType:'I' },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeItemType = result.body.docs;
          vm.codeRecommendItem = result.body.docs;
        }
      });
  
      vm.layout = $rootScope.gVariable.layoutBoard;
      
      vm.headerTitle = "고객관리";

  
      vm.listOptions = {
        addColumn : {
          
        },

        html : {
          CustNm : {
            template : '<span class="noti-new" ng-if="li.CustReadyYN ==\'Y\'">신규문의</span> {{value}}'
          },
          Mobile : {
            template : '<span class="cust-list-call-btn" ng-click="vc.callToMobile(li, $event)"><i class="fa fa-phone" style=" color:#00da6c" ></i> {{value}}</span>'
          },
        },

        addColumnClass : {

        },

        addRowClass : {
          if : "li.CustReadyYN == 'Y'",  class : "row-highlight"
        },

        ngIf : {

        }
      };

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "Customer",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "ScCustomer.getCustomerListCnt"},
          initSelect : { mapCode : "ScCustomer.getCustomerList", param : null },
        },

        addSrchStack : true,

        // List
        listCheckboxEnable : false,
        
        src : {
          detail : "app.customer.customer-detail",
          splitDetail : "app.customer.customer-list.detail"
        },

        addForm : {
          SrchMobile : { after : 'CustNm', type : mElemTx.input, colSize: 3, label : "연락처"},
          CounselManager : { after : 'Manager', type : mElemTx.select, colSize: 3, label : "전화담당자"},
          VisitManager : { after : 'CounselManager', type : mElemTx.select, colSize: 3, label : "방문담당자"},
          SurgicalManager : { after : 'VisitManager', type : mElemTx.select, colSize: 3, label : "시술담당자"},
          
        },
        
        addFormGroup : {
          Inquiry : { after : "RecommendItem", type : mElemTx.date,  bindKey : ["InquiryDateFrom", "InquiryDateTo"], label : "문의일", addDivision : true, colSize : 2}
          , BirthDay : { after : "Inquiry", type : mElemTx.date,  bindKey : ["BirthDayFrom", "BirthDayTo"], label : "생년월일", addDivision : true, colSize : 2}
          , TotalSales : { after : "BirthDay", type : mElemTx.number,  bindKey : ["TotalSalesCostFrom", "TotalSalesCostTo"], label : "총매출", addDivision : true, colSize : 2}
          , SalesCount : { after : "TotalSales", type : mElemTx.number,  bindKey : ["TotalSalesCountFrom", "TotalSalesCountTo"], label : "판매횟수", addDivision : true, colSize : 2}
        },
  
        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes : {
          Manager : "codeManager"
          , CounselManager : "codeManager"
          , VisitManager : "codeManager"
          , SurgicalManager : "codeManager"
          , RecommendItem : "codeRecommendItem"
          , ItemType : "codeItemType"
        },

        srchDateType : {
          InquiryDateFrom : "from",
          InquiryDateTo : "to",
          BirthDayFrom : "from",
          BirthDayTo : "to",
        }

      };

      function callToMobile(data, e) {
        e.stopPropagation();
        postApi.select({mapCode : "ScUser.getUserToken", LoginId : $window.sessionStorage["loginUserId"]}, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if(result.body.docs.length > 0) {
              if(isNullOrEmpty(data.MobileTitle)) {

              } else {
                av.confirm("전화를 거시겠습니까?", function(){
                  sendFcmData(result.body.docs[0].PushToken, "SALEVISCTICALL", data.MobileTitle.toString().replaceAll("-",""));
                });
              }
            } else {
              gAlert('', '연결 가능한 장치가 없습니다.');
            }
          }
        })
      }

      function goAdd() {
        if (vm.layout == 'N' || vm.layout == '') {
          $state.go("app.customer.customer-edit", {srch:$stateParams.srch}, {reload:"app.customer.customer-edit"});
        } else {
          $state.go("app.customer.customer-list.edit", {srch:$stateParams.srch, KeyId:''}, {reload:"app.customer.customer-list.edit"});
        }
      }

      vm.pages = 'app/customer/customer-detail.html';
      
      function onReadyAutoView() {
        
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
      vm.goAdd = goAdd;
      vm.callToMobile = callToMobile;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

(function () {
  "use strict";
  webapp.controller('CustomerPaymentCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory','$window', 'gAlert','gConfirm',
  function CustomerPaymentCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $window, gAlert, gConfirm) {

    // View Model 
    var vm = this;

    // 결제내역 
    vm.data = {PaymentSummaryList : {}};

    //#region 상수 선언 
    //#endregion 상수 선언 

    //#region 변수 선언
    
    // 조회 페이지 설정 
    vm.pages = 'app/customer/customer-detail.html';
    //#endregion 변수 선언 

    //#region Auto View Option 설정 
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "sccustpaymaster",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        initSelectCnt : { mapCode : "ScCustomerPayment.getCustPaymentListCnt", param : null },
        initSelect : { mapCode : "ScCustomerPayment.getCustPaymentList", param : null },
        
      },

      // List
      listCheckboxEnable : false,
     
      // 페이지 이동시 해당 탭에서만 적용 
      addSrchStack : false,

      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback : clickevent

    };

    // 삭제 버튼 추가 (시스템관리자, 본점관리자만 삭제 가능)
    var btnDelete = '';      
    if ($window.sessionStorage['loginSysAdminYN'] == 'Y' || $window.sessionStorage['loginTenantAdminYn'] == 'Y') 
      btnDelete = '<button class="btn btn-danger" ng-click="vc.setDelData(li, $event)"><i class="fa fa-trash-o"></i>삭제</button>';

    vm.listOptions = {
        html : {
         DelYN  : {
           template: btnDelete           
          },
        },

        addColumn : {
        }
    }

    //#endregion Auto View Option 설정 

    //#region 함수 구현

    /**
     * 결제 팝업 호출 
     * @param {*} clickData 
     */
    function clickevent(clickData){
      vm.custPaymentAddModal(clickData.KeyId);
    }


    /**
     * AutoView Callback
     */
    function onReadyAutoView() {
    }

    /**
     * 결제 팝업 표시 
     * @param {*} keyId 
     */
    vm.custPaymentAddModal = function (keyId) {
      var ctrl = 'CustPaymentModalCtrl as vc';
      var paramData = {
        CustId: $stateParams.KeyId,
        KeyId: keyId,
        ReserveType: '',
        ReserveId: ''
      };

      var modalInstance = modalFactory.open('lg', 'app/customer/modal/custPayment/custPayment-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        
        // 목록 갱신 
        av.search();
        
        // 결제내역 조회 
        getPaymentSummaryList();
      }, function (cancelData) {
      
        // 닫기 
      });
    };

    /**
     * 정액권, 횟수권 충전 팝업 표시 
    */
    vm.custPaymentPassTicketAddModal = function() {

        var ctrl = 'CustPaymentPassTicketModalCtrl as vc';
        var paramData = {
          CustId: $stateParams.KeyId,
        };

        var modalInstance = modalFactory.open('md', 'app/customer/modal/custPayment/custPaymentPassTicket-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
       
          // 목록 갱신 
          av.search();
          
          // 결제내역 조회 
          getPaymentSummaryList();
        }, function (cancelData) {
        
          // 닫기 
        });
      };

     /**
      * 결제내역 조회 
     */
    function getPaymentSummaryList() {
           postApi.select({
                mapCode: 'ScCustomerPayment.getCustPaymentSummaryList',
                KeyId: $stateParams.KeyId
              },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.data.PaymentSummaryList = result.body.docs;
                }
              });
    }
 
    /** 
     * 결제내역 삭제 
    */
    function setDelData(row, e) {
     e.stopPropagation();

      gConfirm('', '선택한 결제 내역을 삭제 하시겠습니까?<br/>삭제한 내역은 복구 불가능합니다.', {
        btn: '',
        fn: function () {
          if (row) {
            // 삭제 
            postApi.update({
              mapCode: 'ScCustomerPayment.deletePaymentHistory',
              KeyId: row.KeyId
            },
            function (result) {
              if (result.header.status == CONSTANT.HttpStatus.OK || result.header.status != CONSTANT.HttpStatus.OK) {
                  // 목록 갱신 
                  av.search();
        
                  // 결제내역 조회 
                  getPaymentSummaryList();

                  gAlert('삭제를 성공했습니다.');
              }
              else { 
                  gAlert('삭제를 실패했습니다.');
              }
            });
            
          
          }
        }
      }, {
        btn: '',
        fn: function () {
          // 취소 
        }
      });


    }

    //#endregion 함수 구현 

    //#region 함수 설정 
    // AutoView Callback 
    vm.onReadyAutoView = onReadyAutoView;

    // AutoView 초기화 
    var av = new autoView();
    av.init(autoViewOption);

    vm.setDelData = setDelData;
    
    //#endregion 함수 설정 

    // 결제내역 조회 
    getPaymentSummaryList();

  }]);
})();

(function () {
  "use strict";
  webapp.controller('CustomerPenChartCtrl', 
    ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
    function CustomerPenChartCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

      var vm = this;

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.currentPage = 1;

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "penchartmaster",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        addSrchStack : false,
        apis : {
          initSelectCnt : { mapCode : "PenchartMng.getCustomerPenchartListCnt", param : {CustId: $stateParams.KeyId} },
          initSelect : { mapCode : "PenchartMng.getCustomerPenchartList", param : {CustId: $stateParams.KeyId} },
        },
      };

      function custPenchartAddModal() {
        var ctrl = 'CustPenchartModalCtrl as vc';
        var paramData = {
          CustId: $stateParams.KeyId,
        };
  
        var modalInstance = modalFactory.open('lg', 'app/customer/modal/penchart/cust-penchart-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          av.search();
        }, function (cancelData) {
          av.search();
          // 닫기 
        });
      }

      function custPenchartDetailModal(item) {
        var ctrl = 'CustPenchartViewModalCtrl as vc';
        var paramData = {
          CustId : $stateParams.KeyId,
          KeyId :  item.KeyId
        };
  
        var modalInstance = modalFactory.open('lg', 'app/customer/modal/penchart/cust-penchart-view-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
        }, function (cancelData) {
          // 닫기 
        });
      }

      function onReadyAutoView() {

      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
      vm.custPenchartAddModal = custPenchartAddModal;
      vm.custPenchartDetailModal = custPenchartDetailModal;

      var av = new autoView();
      av.init(autoViewOption);

    }]);

})();

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.customer', {
        url: '/customer',
        template: '<div ui-view></div>',
      })
      /*  // 고객정보 리스트
      .state('app.customer.customer-list', {
        url: '/customer-list?:srch',
        templateUrl: 'app/customer/customer-list.html',
        requiresAuthentication: true,
      })
      .state('app.customer.customer-list.detail', {
        url: '/detail/:KeyId',
        templateUrl: 'app/customer/customer-detail.html',
        requiresAuthentication: true,
      })
      .state('app.customer.customer-list.edit', {
        url: '/edit',
        templateUrl: 'app/customer/customer-edit.html',
        requiresAuthentication: true,
      })

      //고객등록
      .state('app.customer.customer-edit', {
        url: '/customer-edit',
        templateUrl: 'app/customer/customer-edit.html',
        requiresAuthentication: true,
      })

      // 고객 상세 Root
      .state('app.customer.customer-detail', {
        url: '/customer-detail?:srch/:KeyId',
        templateUrl: 'app/customer/customer-detail.html',
        requiresAuthentication: true,
      })

      // CTI
      .state('app.customer.cti-list', {
        url: '/cti-list/:srch',
        templateUrl: 'app/customer/cti-list.html',
        requiresAuthentication: true,
      }) */

      .state('app.customer.customerarmy-list', {
        url: '/customerarmy-list',
        templateUrl: 'app/customer/customerarmy-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                'assets/app/vendor/footable/js/footable.js',
                'assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })

      .state('app.customer.customerarmy-detail', {
        url: '/customerarmy-detail/:CustArmyId',
        templateUrl: 'app/customer/customerarmy-detail.html',
      })

      .state('app.customer.customerarmy-edit', {
        url: '/customerarmy-edit/:CustArmyId',
        templateUrl: 'app/customer/customerarmy-edit.html',
        params: {
          CustArmyId: '',
        },
      })

      .state('app.customer.jobinfoarmy-list', {
        url: '/jobinfoarmy-list',
        templateUrl: 'app/customer/jobinfoarmy-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                'assets/app/vendor/footable/js/footable.js',
                'assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })

      .state('app.customer.jobinfoarmy-detail', {
        url: '/jobinfoarmy-detail/:JobInfoId',
        templateUrl: 'app/customer/jobinfoarmy-detail.html',
      })

      .state('app.customer.jobinfoarmy-edit', {
        url: '/jobinfoarmy-edit/:JobInfoId',
        templateUrl: 'app/customer/jobinfoarmy-edit.html',
        params: {
          JobInfoId: '',
        },
      });
    // // 고객 펜차트
    // .state('app.customer.customer-penchart', {
    //   url: '/customer-detail/:KeyId',
    //   templateUrl: 'app/customer/customer-penchart.html',
    //   requiresAuthentication: true,
    // })

    // // 이력관리
    // .state('app.customer.customer-hist', {
    //   url: '/customer-hist/:KeyId',
    //   templateUrl: 'app/customer/customer-hist.html',
    //   requiresAuthentication: true,
    // })
  }
})();

webapp.controller('CustomerarmyDetailCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'gAlert',
  'gConfirm',
  'postApi',
  '$timeout',
  function CustomerarmyDetailCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    gAlert,
    gConfirm,
    postApi,
    $timeout
  ) {
    var vm = this;

    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('customerarmy-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnEdit = isPageAccess('customerarmy-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnEmail = true;
    $scope.showBtnDel = true;

    // 함수 연결
    //vm.getData = getData;
    //vm.getFileList = getFileList;
    //vm.setData = setData;
    vm.deleteDetail = deleteDetail;
    vm.showModalAppr = showModalAppr;
    vm.showModalEmail = showModalEmail;
    $scope.HopeDutyListShow = false;
    $scope.HopeLocListShow = false;
    $scope.HopeDutyEtcShow = false;
    $scope.HopeDutyListShow2 = false;
    $scope.HopeLocListShow2 = false;
    $scope.HopeDutyEtcShow2 = false;
    $scope.showListEmpty = false;

    // 업로드 파일 목록
    vm.uploadFileList = [];

    vm.onFileCallback = {
      onFileUploadComplete: function () {
      },
      onFileDelete: function (item) {
        var param = {
          fileId: item.id,
        };
        /* var prms = api.attachFileDelete().post(param).$promise;
        prms.then(function (data) {
          console.log(data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED');
          }
        }); */
      },
    };

    // 검색 데이터
    vm.srch = {
      CustArmyId: $stateParams.CustArmyId,
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'customerarmy',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 탭 페이징
    if ($stateParams.pageEmail === undefined || $stateParams.pageEmail === '') {
      vm.currentPageEmail = 1;
    } else {
      vm.currentPageEmail = $stateParams.pageEmail;
    }

    vm.listSizeEmail = [10, 25, 50, 100];
    vm.viewSizeEmail = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSizeEmail = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSizeEmail = vm.viewSizeEmail;
    vm.pageChangedEmail = pageChangedEmail;
    vm.changeViewSizeEmail = changeViewSizeEmail;

    // 조회 데이터 (휘발성 데이터)
    vm.data = {};
    vm.jobinfo = {};

    // 조회
    function getData() {
      vm.dataloader = true;
      if (vm.srch.CustArmyId === null || vm.srch.CustArmyId === '') {
        return;
      }

      vm.srch.mapCode = 'Customerarmy.getCustomerarmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].CustArmyId !== null) {
              vm.data = data.body.docs[0];

              if (typeof vm.data.HopeLoc != 'undefined' && vm.data.HopeLoc != '') {
                $scope.HopeLocListShow = true;
              }

              if (typeof vm.data.HopeDuty != 'undefined' && vm.data.HopeDuty != '') {
                $scope.HopeDutyListShow = true;
              }

              if (typeof vm.data.HopeDutyEtc != 'undefined' && vm.data.HopeDutyEtc != '') {
                $scope.HopeDutyEtcShow = true;
              }

              if (typeof vm.data.HopeLoc2 != 'undefined' && vm.data.HopeLoc2 != '') {
                $scope.HopeLocListShow2 = true;
              }

              if (typeof vm.data.HopeDuty2 != 'undefined' && vm.data.HopeDuty2 != '') {
                $scope.HopeDutyListShow2 = true;
              }

              if (typeof vm.data.HopeDutyEtc2 != 'undefined' && vm.data.HopeDutyEtc2 != '') {
                $scope.HopeDutyEtcShow2 = true;
              }

              getFileList(); // 첨부파일 목록 조회
              getLicenseList(); // 자격증 목록 조회
              getEduList(); // 학력 목록 조회
              getCareerList(); // 경력 목록 조회
              getJobinfoList(); // 취업 목록 조회

              getCounselrecordList(); // 상담일지 목록 조회
              getEmailList(); // 이메일 목록 조회
              $timeout(function () {
                vm.dataloader = false;
              }, 1000);

              return;
            }
          } else {
            gAlert('', '회원정보를 불러오는데 실패하였습니다.', {
              fn: function () {
                $timeout(function () {
                  vm.dataloader = false;
                }, 500);
              },
            });
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 취업목록
    function getJobinfoList() {
      vm.data.mapCode = 'Jobinfoarmy.getJobinfoarmyDetail';

      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.jobinfo = data.body.docs[0];

              $scope.dtRegDate = setNewDate(vm.jobinfo.RegDate);
              $scope.dtCompanyJoinDate = setNewDate(vm.jobinfo.CompanyJoinDate);
              $scope.dtCompanyRegDate = setNewDate(vm.jobinfo.CompanyRegDate);
            }

            return;
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('Error-getJobinfoList', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 첨부파일 목록
    function getFileList() {
      vm.data.TableId = vm.srch.CustArmyId;
      vm.data.TableNm = vm.srch.TableNm;

      if (vm.data.TableId === null || vm.data.TableId === '0') {
        return;
      }

      vm.data.mapCode = 'FileAttach.getFileList';
      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.PhysicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm +
                    '&userkey=' +
                    $rootScope.gVariable.userKey
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: '',
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getFileList', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.srch.CustArmyId === null || vm.srch.CustArmyId === '') {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }
      var uploadFileList = [];
      angular.forEach(vm.uploadFileList, function (item) {
        var obj = {
          id: item.id,
          fileName: item.fileName,
          size: item.size,
          fileKey: item.fileKey,
          typeId: 'file',
          path: item.path,
          delState: 'delete',
        };
        uploadFileList.push(obj);
      });
      vm.data['uploadFileList'] = uploadFileList;

      vm.data.mapCode = 'Customerarmy.deleteCustomerarmyDetailBatch';
      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.go('app.customer.customerarmy-list');
              },
            });
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (승인)
    function showModalAppr() {
      var ctrl = 'ApprModalCtrl as modalCtrl';
      var paramData = {};
      paramData.CustArmyId = vm.srch.CustArmyId;

      var modalInstance = modalFactory.open('modal', 'app/modal/appr-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          alert('ok');
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 호출 (이메일)
    function showModalEmail() {
      var ctrl = 'EmailModalCtrl as modalCtrl';
      var paramData = {};
      paramData.CustArmyId = vm.srch.CustArmyId;

      var modalInstance = modalFactory.open('lg', 'app/modal/email-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          //console.log('okData');
          gAlert('', '선택된 고객에게 이메일이 발송되었습니다. \n\r(이메일이 입력된 고객만 발송됩니다.)');
          $state.reload();
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 자격증 목록
    function getLicenseList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmylicenseList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.LicenseJSON = data.body.docs;
            } else {
              /*$scope.LicenseJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 학력 목록
    function getEduList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmyeduList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.EduJSON = data.body.docs;
            } else {
              /*$scope.EduJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 경력 목록
    function getCareerList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmycareerList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.CareerJSON = data.body.docs;
            } else {
              /*$scope.CareerJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 상담일지 목록 조회
    /*      function getCounselrecordList() {
        getCounselrecordListCount();
        
        vm.srch.page = vm.currentPage;
        console.log("vm.srch", vm.srch);
        //$window.sessionStorage.setItem("counselrecord-list-ctrl", angular.toJson(vm.srch));

        var prms = api.doCounselrecordList().post(vm.srch).$promise;

        prms.then(function(data) {          
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {           
            if (data.responseVO.body.docs.length > 0) {
              vm.lists = data.responseVO.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            console.info("vm.lists -", vm.lists);
          } else {
            console.info("else ");
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }*/

    function getCounselrecordList() {
      vm.srch.mapCode = 'Customerarmy.getCounselrecordList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
              $scope.showListEmpty = false;
            } else {
              $scope.showListEmpty = true;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 상담일지 목록카운트 조회
    /*  function getCounselrecordListCount() {
        var prms = api.doCounselrecordListCount().post(vm.srch).$promise;

        prms.then(function(data) {          
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt > 0) {
              vm.totalItems = data.responseVO.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info("else ");
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }           */

    // 이메일 목록 조회
    function getEmailList() {
      getEmailListCount();

      vm.srch.pageEmail = vm.currentPageEmail;

      vm.srch.mapCode = 'Emaillog.getEmaillogListForCustArmy';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listsEmail = data.body.docs;
            } else {
              vm.totalItemsEmail = 0;
              vm.listsEmail = {};
            }
          } else {
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getEmailList', status, data);
        }
      );
    }

    // 이메일 목록 카운트 조회
    function getEmailListCount() {
      vm.srch.mapCode = 'Emaillog.getEmaillogCountForCustArmy';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItemsEmail = data.body.docs;
            } else {
              vm.totalItemsEmail = 0;
              vm.listsEmail = {};
            }
          } else {
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getEmailListCount', status, data);
        }
      );
    }

    // 페이징 관련
    function pageChangedEmail() {
      getListEmail();
    }
    function changeViewSizeEmail() {
      vm.currentPageEmail = 1;
      getListEmail();
    }

    getData();
  },
]);

webapp.controller('CustomerarmyEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'gAlert',
  'gConfirm',
  '$http',
  '$sce',
  '$timeout',
  'postApi',
  function CustomerarmyEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    gAlert,
    gConfirm,
    $http,
    $sce,
    $timeout,
    postApi
  ) {
    var vm = this;
    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('customerarmy-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 함수 연결
    vm.showModalCounselAppliRegUser = showModalCounselAppliRegUser;
    vm.clearModalCounselAppliRegUser = clearModalCounselAppliRegUser;
    vm.showModalCustArmyRegUser = showModalCustArmyRegUser;
    vm.clearModalCustArmyRegUser = clearModalCustArmyRegUser;
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.showModalApprUser = showModalApprUser;
    vm.clearModalApprUser = clearModalApprUser;
    vm.chkDupArmyNo = chkDupArmyNo;
    vm.chkDupArmyNoClear = chkDupArmyNoClear;
    vm.serchArmyId = serchArmyId;
    /* vm.serchNameGunbun = serchNameGunbun; */
    vm.setDataMemberHistory = setDataMemberHistory;
    vm.chkMemberHistoryValid = chkMemberHistoryValid;
    vm.chkDupMM_NO = chkDupMM_NO;
    vm.showModalCustNameInfo = showModalCustNameInfo;
    vm.showModalCustGunbunInfo = showModalCustGunbunInfo;

    vm.getFileList = getFileList;
    vm.getData = getData;
    vm.setData = setData;
    vm.disabled = false;
    vm.disabledArea = false;

    $scope.HopeJobTypeListShow = true;
    $scope.HopeJobTypeEtcShow = false;
    $scope.HopeJobTypeListShow2 = true;
    $scope.HopeJobTypeEtcShow2 = false;
    $scope.HopeDutyListShow = false;
    $scope.HopeDutyListShow2 = false;
    $scope.HopeLocListShow1 = false;
    $scope.HopeLocListShow2 = false;
    $scope.HopeLocListShow3 = false;
    $scope.HopeLocListShow4 = false;
    $scope.HopeDutyEtcShow = false;
    $scope.HopeDutyEtcShow2 = false;
    $scope.CompanyRegDateReadOnly = false;

    // 페이징
    //vm.page = $stateParams.page;

    if ($window.sessionStorage['loginUserType'] == '030') {
      vm.ArmyClassReadOnly = true;
    } else {
      vm.ArmyClassReadOnly = false;
    }

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    /* vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.JoinCntList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1360',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField3List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselLocList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselLocList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.OutArmyCounselLocList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.FirstDecHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.FirstDecMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeJobTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeJobTypeList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1200',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList1 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1200',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList3 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList4 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.LastEduList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1220',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.SpecList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1230',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyWorkTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1240',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.CompanyEmployList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1260',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.PermStatAddrList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1430',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.data.ArmyClass = data.Code;
      } else if (data.CodeType == '1030') {
        vm.data.OutArmyCounselLoc = data.Code;
      } else if (data.CodeType == '1120') {
        vm.data.FirstDecHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.FirstDecMin = data.Code;
      } else if (data.CodeType == '1190') {
        vm.data.HopeJobType = data.Code;

        if (data.Code == '110') {
          // 기타 선택시
          $scope.HopeJobTypeEtcShow = true;
        } else {
          $scope.HopeJobTypeEtcShow = false;
          vm.data.HopeJobTypeEtc = '';
        }
      } else if (data.CodeType == '1200') {
        vm.data.HopeDuty = data.Code;

        if (data.Code == '110') {
          $scope.HopeDutyEtcShow = true;
        } else {
          $scope.HopeDutyEtcShow = false;
          vm.data.HopeDutyEtc = '';
        }
      } else if (data.CodeType == '1220') {
        vm.data.LastEdu = data.Code;
      } else if (data.CodeType == '1230') {
        vm.data.Spec = data.Code;
      } else if (data.CodeType == '1240') {
        vm.data.CompanyWorkType = data.Code;
      } else if (data.CodeType == '1250') {
        vm.data.CompanyType = data.Code;
        vm.data.CompanyTypeValue = data.CodeValue;
      } else if (data.CodeType == '1260') {
        vm.data.CompanyEmploy = data.Code;
      } else if (data.CodeType == '1360') {
        vm.data.JoinCnt = data.Code;
      } else if (data.CodeType == '1430') {
        vm.data.PermStatAddr = data.Code;
      }
    };

    vm.onSelectCallback2 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1030') {
        vm.data.CounselLoc = data.Code;
      }
    };

    vm.onSelectCallback3 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.data.HopeLoc = data.Code;
      }
    };

    vm.onSelectCallback4 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1030') {
        vm.data.CounselLoc2 = data.Code;
      } else if (data.CodeType == '1250') {
        vm.data.HopeJobType2 = data.Code;

        if (data.Code == '151') {
          // 기타 선택시
          $scope.HopeJobTypeEtcShow2 = true;
        } else {
          $scope.HopeJobTypeEtcShow2 = false;
          vm.data.HopeJobTypeEtc2 = '';
        }
      }
    };

    vm.onSelectCallback5 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1200') {
        vm.data.HopeDuty2 = data.Code;

        if (data.Code == '110') {
          $scope.HopeDutyEtcShow2 = true;
        } else {
          $scope.HopeDutyEtcShow2 = false;
          vm.data.HopeDutyEtc2 = '';
        }
      }
    };

    vm.onSelectCallback6 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.data.HopeLoc2 = data.Code;
      }
    };

    vm.onSelectCallback7 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1250') {
        vm.data.HopeJobType = data.Code;

        if (data.Code == '151') {
          // 기타 선택시
          $scope.HopeJobTypeEtcShow = true;
        } else {
          $scope.HopeJobTypeEtcShow = false;
          vm.data.HopeJobTypeEtc = '';
        }
      }
    };

    vm.onArmyAreaListSelected = function () {
      var data = vm.data.ArmyAreaObj;

      if (vm.data.ArmyAreaObj == null) {
        vm.data.ArmyArea = '';
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }

      if (data.Code == null || data.Code == '') {
        vm.disabledArea = false;
      }

      vm.data.ArmyArea = vm.data.ArmyAreaObj.Code;
      vm.ArmyTypeList.ArmyArea = vm.data.ArmyArea;
      vm.PermStat1List.ArmyArea = vm.data.ArmyArea;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.ArmyType = '';
        return;
      }

      vm.data.ArmyType = data.Code;

      vm.data.ArmyAreaType = data.Code;

      //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
      vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      // console.log('onPermStat1ListSelected=', data);

      /*  vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = ''; */

      if (data.Code == null) {
        vm.data.PermStat1 = '';
        return;
      }

      vm.data.PermStat1 = data.Code;
      /* vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId; */
    };

    /*vm.onPermStat2ListSelected = function(data) {
        console.log("onPermStat2ListSelected=", data);
        
        if (data == null) {
          vm.data.PermStat2 = '';
          return;
        }
        
        vm.data.PermStat2 = data.Code;
      }*/

    /*vm.onPermStat2ListSelected = function(data) {
        console.log("onPermStat2ListSelected=", data);
        
        if (data == null) {
          vm.data.PermStat2 = '';
          return;
        }
        
        vm.data.PermStat2 = data.Code;
      }*/

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.HopeField1 = '';
        return;
      }

      vm.data.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      /*if (vm.data.HopeField1 == "0") {
          vm.HopeField2ListShow = true;
        }
        else {
          vm.HopeField2ListShow = false;
          vm.data.HopeField2 = "";
        }*/

      if (vm.data.HopeField1 == '2' || vm.data.HopeField1 == '3' || vm.data.HopeField1 == '0') {
        $scope.HopeJobTypeListShow = false;
        $scope.HopeJobTypeListShow2 = false;
        $scope.HopeJobTypeEtcShow = false;
        $scope.HopeJobTypeEtcShow2 = false;
        vm.data.HopeJobType = '';
        vm.data.HopeJobTypeEtc = '';
        vm.data.HopeJobType2 = '';
        vm.data.HopeJobTypeEtc2 = '';
      } else {
        if (vm.data.HopeJobType == '110') {
          $scope.HopeJobTypeEtcShow = true;
        }
        if (vm.data.HopeJobType2 == '110') {
          $scope.HopeJobTypeEtcShow2 = true;
        }
        $scope.HopeJobTypeListShow = true;
        $scope.HopeJobTypeListShow2 = true;
      }
      if (vm.data.HopeField1 == '0') {
        $scope.HopeAmtShow = false;
      } else {
        $scope.HopeAmtShow = true;
      }
    };

    vm.onHopeField2ListSelected = function (data) {
      if (vm.data.HopeField1 != '0') {
        vm.data.HopeField2 = '';
        vm.HopeField2ListShow = false;
        //return;
      } else {
        vm.data.HopeField2 = data.Code;
        vm.HopeField2ListShow = true;
      }
    };

    vm.CounselField2List = {};

    vm.onCounselField1ListSelected = function (data) {
      vm.CounselField2List.CodeType = '';
      vm.CounselField2List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.CounselField1 = '';
        return;
      }

      vm.data.CounselField1 = data.Code;
      vm.CounselField2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField2ListSelected = function (data) {
      if (data.Code == null) {
        vm.data.CounselField2 = '';

        vm.data.HopeDuty = '';
        vm.data.HopeDutyEtc = '';
        vm.data.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
        return;
      }

      vm.data.CounselField2 = data.Code;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow = true;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = vm.data.HopeDuty == '110';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = true;
        $scope.HopeDutyEtcShow = false;
      } else {
        vm.data.HopeDuty = '';
        vm.data.HopeDutyEtc = '';
        vm.data.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      }
    };

    vm.CounselField4List = {};

    vm.onCounselField3ListSelected = function (data) {
      vm.CounselField4List.CodeType = '';
      vm.CounselField4List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.CounselField3 = '';
        return;
      }

      vm.data.CounselField3 = data.Code;
      vm.CounselField4List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField4ListSelected = function (data) {
      if (data.Code == null) {
        vm.data.CounselField4 = '';

        vm.data.HopeDuty2 = '';
        vm.data.HopeDutyEtc2 = '';
        vm.data.HopeLoc2 = '';
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
        return;
      }

      vm.data.CounselField4 = data.Code;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow2 = true;
        $scope.HopeLocListShow3 = true;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = vm.data.HopeDuty2 == '110';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = true;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = true;
        $scope.HopeDutyEtcShow2 = false;
      } else {
        vm.data.HopeDuty2 = '';
        vm.data.HopeDutyEtc2 = '';
        vm.data.HopeLoc2 = '';
        $scope.HopeDutyListShow2 = false;
        $scope.HopeLocListShow3 = false;
        $scope.HopeLocListShow4 = false;
        $scope.HopeDutyEtcShow2 = false;
      }
    };

    /* if ($window.sessionStorage['loginArmyZone5YN'] == 'Y') {
      vm.ArmyAreaList.Code = '050';
    }*/

    // 업로드 파일 목록
    vm.uploadFileList = [];

    vm.onFileCallback = {
      onFileUploadComplete: function () {
      },
      onFileDelete: function (item) {
        var param = {
          fileId: item.id,
        };

        postApi.attach(
          'file/delete',
          param,
          function (data) {
            if (data.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          },
          function (error) {
            // 삭제 실패
            console.log("error");
            // console.error('Error> onFileDelete()');
            // console.table(error);
          }
        );

        /* var prms = h0101Api.attachFileDelete().post(param).$promise;
        prms.then(function (data) {
          console.log(data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED');
          }
        }); */
      },
    };

    // 검색 데이터
    vm.srch = {
      CustArmyId: $stateParams.CustArmyId,
      BranchId: $window.sessionStorage['loginBranchId'],
      BranchNm: $window.sessionStorage['loginBranchName'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'customerarmy',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터 (휘발성 데이터)
    vm.data = {
      TenantNm: $window.sessionStorage['loginTenantName'],
    };
    vm.data.oldFirstDecDate = '';

    // 기본값
    if (vm.srch.CustArmyId == 0 || vm.srch.CustArmyId == '' || typeof vm.srch.CustArmyId == 'undefined') {
      vm.data.CounselAppliRegUser = $window.sessionStorage['loginUserIdx'];
      vm.data.CounselAppliRegUser_ = $window.sessionStorage['loginUserName'];
      vm.data.CustArmyRegUser = $window.sessionStorage['loginUserIdx'];
      vm.data.CustArmyRegUser_ = $window.sessionStorage['loginUserName'];

      $scope.dtCounselAppliRegDate = setNewDate(getToday());
      vm.data.CounselAppliRegDate = getToday();
      $scope.dtCustArmyRegDate = setNewDate(getToday());
      vm.data.CustArmyRegDate = getToday();

      $scope.dtFirstDecDate = setNewDate(getToday());
      vm.data.FirstDecDate = getToday();
      vm.FirstDecHourList.Code = '00';
      vm.FirstDecMinList.Code = '00';
      $scope.dtApprDate = setNewDate(getToday());
      vm.data.ApprDate = getToday();
      vm.data.ApprUser = $window.sessionStorage['loginUserIdx'];
      vm.data.ApprUser_ = $window.sessionStorage['loginUserName'];
      vm.data.CounselUser = $window.sessionStorage['loginUserIdx'];
      vm.data.CounselUser_ = $window.sessionStorage['loginUserName'];

      // vm.data.CustArmyId = $window.sessionStorage['CustArmyId'];
    }

    // 행추가 삭제 테이블 (자격증)
    $scope.LicenseJSON = [{ CustArmyLicenseId: '', LicenseNm: '', GetDate: '', GetAgency: '' }];

    $scope.removeRowLicense = function (index) {
      var removeJSON = $scope.LicenseJSON.splice(index, 1);

      if (removeJSON[0].CustArmyLicenseId != '') {
        deleteLicense(removeJSON[0].CustArmyLicenseId);
      }

      if ($scope.LicenseJSON.length === 0) {
        $scope.LicenseJSON = [];
      }
    };

    $scope.addRowLicense = function () {
      $scope.LicenseJSON.push({
        CustArmyLicenseId: '',
        LicenseNm: '',
        GetDate: '',
        GetAgency: '',
      });
    };

    // 행추가 삭제 테이블 (학력)
    $scope.EduJSON = [
      {
        CustArmyEduId: '',
        EduLev: '',
        SchNm: '',
        OutSchDate: '',
        MajorType: '',
        MajorSeries: '',
        Loc: '',
        OutSchYN: '',
        MajorName: '',
        EduLevName: '',
      },
    ];

    $scope.removeRowEdu = function (index) {
      var removeJSON = $scope.EduJSON.splice(index, 1);

      if (removeJSON[0].CustArmyEduId != '') {
        deleteEdu(removeJSON[0].CustArmyEduId);
      }

      if ($scope.EduJSON.length === 0) {
        $scope.EduJSON = [];
      }
    };

    $scope.addRowEdu = function () {
      $scope.EduJSON.push({
        CustArmyEduId: '',
        EduLev: '',
        SchNm: '',
        OutSchDate: '',
        MajorType: '',
        MajorSeries: '',
        Loc: '',
        OutSchYN: '',
        MajorName: '',
        EduLevName: '',
      });
    };

    // 행추가 삭제 테이블 (경력)
    $scope.CareerJSON = [
      {
        CustArmyCareerId: '',
        WorkDateFrom: '',
        WorkDateTo: '',
        CompNm: '',
        Position: '',
        Work: '',
      },
    ];

    $scope.removeRowCareer = function (index) {
      var removeJSON = $scope.CareerJSON.splice(index, 1);

      if (removeJSON[0].CustArmyCareerId != '') {
        deleteCareer(removeJSON[0].CustArmyCareerId);
      }

      if ($scope.CareerJSON.length === 0) {
        $scope.CareerJSON = [];
      }
    };

    $scope.addRowCareer = function () {
      $scope.CareerJSON.push({
        CustArmyCareerId: '',
        WorkDateFrom: '',
        WorkDateTo: '',
        CompNm: '',
        Position: '',
        Work: '',
      });
    };

    // 유효성검사
    function chkValid() {
      //alert(angular.element(document.getElementById('txtZipcode')).scope().vm.data.Zipcode);

      if (typeof vm.data.MM_NO == 'undefined' || vm.data.MM_NO == '') {
        gAlert('', '고객정보를 검색해 주세요');
        angular.element('input[ng-model="vc.data.CustNm"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyId == 'undefined' || vm.data.ArmyId == '') {
        gAlert('', '아이디를 입력해주세요');
        angular.element('input[ng-model="vc.data.ArmyId"]').focus();
        return false;
      }

      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        gAlert('', '성명을 입력해주세요');
        angular.element('input[ng-model="vc.data.CustNm"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        gAlert('', '계급을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyClassList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.ArmyArea == 'undefined' || vm.data.ArmyArea == '') {
        gAlert('', '권역을 선택해주세요');
        angular.element('select[ng-model="vc.data.ArmyAreaObj"]').focus();
        return false;
      }

/*      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        gAlert('', '소속부대를 선택해주세요');
        angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
        return false;
      }

      if (vm.data.PermStat1 < 1000) {
        gAlert('', '소속부대를 선택해주세요');
        angular.element('common-code[param-data="vc.PermStat1List"]').children('select').focus();
        return false;
      }*/

      if (vm.data.ArmyArea != null && vm.data.ArmyArea != '050') {
        if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
          gAlert('', '군별을 선택해주세요');
          angular.element('common-code[param-data="vc.ArmyTypeList"]').children('select').focus();
          return false;
        }

/*        if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
          gAlert('', '소속부대2를 입력해주세요');
          angular.element('input[ng-model="vc.data.PermStat2"]').focus();
          return false;
        }*/
      }

      if (typeof vm.data.HopeField1 == 'undefined' || vm.data.HopeField1 == '') {
        gAlert('', '상담희망분야를 선택해주세요');
        angular.element('common-code[param-data="vc.HopeField1List"]').children('select').focus();
        return false;
      }

      if (vm.data.HopeField1 == '040') {
        if (typeof vm.data.HopeField2 == 'undefined' || vm.data.HopeField2 == '') {
          gAlert('', '상담희망분야를 선택해주세요');
          angular.element('common-code[param-data="vc.HopeField2List"]').children('select').focus();
          return false;
        }
      }

      if (typeof vm.data.LastEdu == 'undefined' || vm.data.LastEdu == '') {
        gAlert('', '학력을 선택해주세요');
        angular.element('common-code[param-data="vc.LastEduList"]').children('select').focus();
        return false;
      }

      if (vm.data.HopeField1 != '040') {
        if (typeof vm.data.CounselLoc == 'undefined' || vm.data.CounselLoc == '') {
          gAlert('', '희망지역을 선택해주세요');
          angular.element('common-code[param-data="vc.CounselLocList"]').children('select').focus();
          return false;
        }
      } else {
        vm.data.HopeField2 = '';
      }

      if (vm.data.HopeField1 != '2' && vm.data.HopeField1 != '3' && vm.data.HopeField1 != '0') {
        if (typeof vm.data.HopeJobType == 'undefined' || vm.data.HopeJobType == '') {
          gAlert('', '희망직종(1지망)을 선택해주세요');
          angular.element('common-code[param-data="vc.HopeJobTypeList"]').children('select').focus();
          return false;
        }
        if (vm.data.HopeJobType2 == ' ') {
          gAlert('', '희망직종(2지망)을 선택해주세요');
          angular.element('common-code[param-data="vc.HopeJobTypeList2"]').children('select').focus();
          return false;
        }
      }

      /* if (vm.data.HopeJobType == '151') {
        if (typeof vm.data.HopeJobTypeEtc == 'undefined' || vm.data.HopeJobTypeEtc == '') {
          gAlert('', '희망직종의 기타내용을 입력해주세요.');
          angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
          return false;
        }
      } */

      if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        gAlert('', '휴대폰 번호를 입력해주세요');
        angular.element('input[ng-model="vc.data.Mobile"]').focus();
        return false;
      }

/*      if (vm.data.HopeField1 != '0') {
        if (typeof vm.data.HopeAmt == 'undefined' || vm.data.HopeAmt == '') {
          gAlert('', '희망급여(만원)을 입력해주세요');
          angular.element('input[ng-model="vc.data.HopeAmt"]').focus();
          return false;
        }
      }

      if (typeof vm.data.FirstHopeDate == 'undefined' || vm.data.FirstHopeDate == '') {
        gAlert('', '1차상담희망일을 입력해주세요');
        angular.element('input[ng-model="dtFirstHopeDate"]').focus();
        return false;
      }*/

      /*if (typeof(vm.data.isDupArmyNo) == "undefined" || vm.data.isDupArmyNo == "Y") {          
          gAlert('', '군번 중복확인버튼을 클릭해주세요.');
          return false;
        } */

      /*if (typeof(vm.data.PermStat) == "undefined" || vm.data.PermStat == "") {          
          gAlert('', '소속부대를 입력해주세요');
          return false;
        }*/

      /*if (typeof(vm.data.PermStat2) == "undefined" || vm.data.PermStat2 == "") {          
          gAlert('', '소속부대를 선택해주세요');
          return false;
        }*/

      /* var date1 = new Date(vm.data.InArmyDate);
      var date2 = new Date(vm.data.OutArmyDate);
      var interval = date2 - date1;
      var day = 1000 * 60 * 60 * 24;
      var month = day * 30;
      var year = month * 12; */

      /* if (interval / year >= 5) {
        gAlert('', '장기간부의 경우 등록이 불가능합니다.');
        return false;
      } */

      /*if (typeof vm.data.FirstDecDate == 'undefined' || vm.data.FirstDecDate == '') {
        gAlert('', '1차상담확정일을 입력해주세요');
        angular.element('input[ng-model="dtFirstDecDate"]').focus();
        return false;
      }*/

      if (typeof vm.data.FirstDecHour == 'undefined') {
        gAlert('', '1차상담확정일시(시)를 선택해주세요');
        angular.element('common-code[param-data="vc.FirstDecHourList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.FirstDecMin == 'undefined') {
        gAlert('', '1차상담확정일시(분)를 선택해주세요');
        angular.element('common-code[param-data="vc.FirstDecMinList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CounselUser == 'undefined' || vm.data.CounselUser == '') {
        gAlert('', '상담사를 선택해주세요', {
          fn: function () {
            vm.showModalCounselUser();
          },
        });
        angular.element('input[ng-model="vc.data.CounselUser_"]').focus();
        return false;
      }

      if (typeof vm.data.Spec == 'undefined' || vm.data.Spec == '') {
        gAlert('', '병과를 입력해주세요');
        angular.element('common-code[param-data="vc.SpecList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == '') {
        gAlert('', '임관일 또는 입대일를 입력해주세요');
        angular.element('input[ng-model="dtInArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == '') {
        gAlert('', '전역일을 입력해주세요');
        angular.element('input[ng-model="dtOutArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == '') {
        gAlert('', '생년월일을 입력해주세요');
        angular.element('input[ng-model="vc.data.ResRegNo"]').focus();
        return false;
      }

      if (typeof vm.data.Email == 'undefined' || vm.data.Email == '') {
        gAlert('', '이메일을 입력해주세요');
        angular.element('input[ng-model="vc.data.Email"]').focus();
        return false;
      }

      /* if (
        typeof vm.data.CounselAbleTel == 'undefined' ||
        vm.data.CounselAbleTel == ''
      ) {
        gAlert('', '상담가능연락처를 입력해주세요');
        return false;
      } */

      /* if (
        typeof vm.data.CounselAppliRegUser == 'undefined' ||
        vm.data.CounselAppliRegUser == ''
      ) {
        gAlert('', '상담신천등록자를 선택해주세요');
        return false;
      }

      if (
        typeof vm.data.CounselAppliRegDate == 'undefined' ||
        vm.data.CounselAppliRegDate == ''
      ) {
        gAlert('', '상담신청등록일을 입력해주세요');
        return false;
      } */

      /* if (
        typeof vm.data.CustArmyRegUser == 'undefined' ||
        vm.data.CustArmyRegUser == ''
      ) {
        gAlert('', '등록자를 선택해주세요');
        return false;
      }

      if (
        typeof vm.data.CustArmyRegDate == 'undefined' ||
        vm.data.CustArmyRegDate == ''
      ) {
        gAlert('', '등록일을 입력해주세요');
        return false;
      } */

      /* if (typeof vm.data.ApprDate == 'undefined' || vm.data.ApprDate == '') {
        gAlert('', '상담승인일을 입력해주세요');
        return false;
      }

      if (typeof vm.data.ApprUser == 'undefined' || vm.data.ApprUser == '') {
        gAlert('', '상담승인자를 선택해주세요');
        return false;
      } */

      /*if (vm.data.oldFirstDecDate == "") { // 신규
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (vm.data.oldFirstDecDate != vm.data.FirstDecDate && getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      return true;
    }

    // 조회
    function getData() {
      if (vm.srch.TenantId === undefined || vm.srch.TenantId === null || vm.srch.TenantId === '') {
        return;
      }

      vm.srch.mapCode = 'Business.getTenantArea';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var listStr = data.body.docs[0].TenantArea;
              vm.ArmyAreaList = listStr.split(',').reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.data.ArmyAreaObj = vm.ArmyAreaList[0];
                vm.data.ArmyArea = vm.data.ArmyAreaObj.Code;
              }
            } else {
              vm.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );

      if (vm.srch.CustArmyId === undefined || vm.srch.CustArmyId === null || vm.srch.CustArmyId === '') {
        return;
      }

      vm.srch.mapCode = 'Customerarmy.getCustomerarmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].CustArmyId !== null) {
              vm.data = data.body.docs[0];
              // 수동 메핑 항목 설정
              vm.SpecList.Code = vm.data.Spec;
              vm.ArmyClassList.Code = vm.data.ArmyClass;
              vm.ArmyTypeList.Code = vm.data.ArmyType;
              vm.data.ArmyAreaObj = {
                Code: vm.data.ArmyArea,
                CodeValue: vm.data.ArmyArea,
              };
              vm.PermStat1List.Code = vm.data.PermStat1;
              vm.PermStat2List.Code = vm.data.PermStat2;
              vm.HopeField1List.Code = vm.data.HopeField1;
              vm.HopeField2List.Code = vm.data.HopeField2;
              vm.CounselLocList.Code = vm.data.CounselLoc;
              vm.HopeJobTypeList.Code = vm.data.HopeJobType;
              vm.CounselLocList2.Code = vm.data.CounselLoc2;
              vm.HopeJobTypeList2.Code = vm.data.HopeJobType2;
              vm.OutArmyCounselLocList.Code = vm.data.OutArmyCounselLoc;
              vm.FirstDecHourList.Code = vm.data.FirstDecHour;
              vm.FirstDecMinList.Code = vm.data.FirstDecMin;
              vm.CounselField1List.Code = vm.data.CounselField1;
              vm.CounselField2List.Code = vm.data.CounselField2;
              vm.HopeDutyList.Code = vm.data.HopeDuty;
              vm.LastEduList.Code = vm.data.LastEdu;
              vm.CompanyTypeList.Code = vm.data.CompanyType;
              vm.CompanyWorkTypeList.Code = vm.data.CompanyWorkType;
              vm.CompanyEmployList.Code = vm.data.CompanyEmploy;
              vm.JoinCntList.Code = vm.data.JoinCnt;

              vm.data.oldFirstDecDate = vm.data.FirstDecDate;
              vm.data.CompanyJoinDate = vm.data.CompanyJoinDate;
              vm.data.CompanyRegDate = vm.data.CompanyRegDate;

              // 취업확인일 교육원 권한 가진 사용자만 수정가능하도록 수정 2019-06-11 김준권
              if (
                typeof vm.data.CompanyRegDate == 'undefined' ||
                vm.data.CompanyRegDate == '' ||
                $window.sessionStorage['loginUserType'] == '000'
              ) {
                $scope.CompanyRegDateReadOnly = false;
              } else {
                $scope.CompanyRegDateReadOnly = true;
              }

              if (typeof vm.data.HopeLoc != 'undefined' || vm.data.HopeLoc != '') {
                if (parseInt(vm.data.HopeLoc) < 1000) {
                  vm.HopeLocList1.Code = vm.data.HopeLoc;
                } else {
                  vm.HopeLocList2.Code = vm.data.HopeLoc;
                }
              }

              vm.CounselField3List.Code = vm.data.CounselField3;
              vm.CounselField4List.Code = vm.data.CounselField4;
              vm.HopeDutyList2.Code = vm.data.HopeDuty2;

              if (typeof vm.data.HopeLoc2 != 'undefined' || vm.data.HopeLoc2 != '') {
                if (parseInt(vm.data.HopeLoc2) < 1000) {
                  vm.HopeLocList3.Code = vm.data.HopeLoc2;
                } else {
                  vm.HopeLocList4.Code = vm.data.HopeLoc2;
                }
              }

              vm.data.OldArmyNo = vm.data.ArmyNo;
              vm.data.isDupArmyNo = 'N';

              $scope.dtFirstHopeDate = setNewDate(vm.data.FirstHopeDate);
              $scope.dtCounselAppliRegDate = setNewDate(vm.data.CounselAppliRegDate);
              $scope.dtInArmyDate = setNewDate(vm.data.InArmyDate);
              $scope.dtOutArmyDate = setNewDate(vm.data.OutArmyDate);
              $scope.dtCustArmyRegDate = setNewDate(vm.data.CustArmyRegDate);
              $scope.dtFirstDecDate = setNewDate(vm.data.FirstDecDate);
              $scope.dtApprDate = setNewDate(vm.data.ApprDate);
              $scope.dtCompanyJoinDate = setNewDate(vm.data.CompanyJoinDate);
              $scope.dtCompanyRegDate = setNewDate(vm.data.CompanyRegDate);

              angular.element(document.getElementById('txtZipcode')).val(vm.data.Zipcode);
              angular.element(document.getElementById('txtAddr1')).val(vm.data.Addr1);

              getFileList(); // 첨부파일 목록 조회
              getLicenseList(); // 자격증 목록 조회
              getEduList(); // 학력 목록 조회
              getCareerList(); // 경력 목록 조회

              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 첨부파일 목록
    function getFileList() {
      vm.data.TableId = vm.srch.CustArmyId;
      vm.data.TableNm = vm.srch.TableNm;

      if (vm.data.TableId === null || vm.data.TableId === '0') {
        return;
      }

      vm.data.mapCode = 'FileAttach.getFileList';

      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl(
                  '/attach/file/' +
                    item.PhysicalFileNm +
                    '/download.do?path=' +
                    item.PhysicalPath +
                    '&fileName=' +
                    item.LogicalFileNm
                ),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: '',
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getFileList', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 저장버튼 더블클릭 방지용 변수 선언 2020-02-19 김준권
    vm.saveButtonDisable = false;
    // 저장
    function setData() {
      // 주소 값 저장
      vm.data.Zipcode = angular.element(document.getElementById('txtZipcode')).val();
      vm.data.Addr1 = angular.element(document.getElementById('txtAddr1')).val();
      //vm.data.Addr2 = angular.element(document.getElementById('txtAddr2')).val();

      if (!chkValid()) return false;

      if (vm.data.CompanyNm !== undefined && vm.data.CompanyNm != '') {
        if (!chkMemberHistoryValid()) return false;
      }

      vm.dataloader = true;

      angular.element(document.getElementById('txtZipcode')).val();

      vm.saveButtonDisable = true;

      vm.data.TableId = vm.srch.CustArmyId;
      vm.data.TableNm = vm.srch.TableNm;
      vm.data['uploadFileList'] = vm.uploadFileList;

      var updateCallback = function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].CustArmyId !== null) {
            vm.srch.CustArmyId = data.body.docs[0].CustArmyId;

            setDataLicense(); // 자격증 정보 저장
            setDataEdu(); // 학력 정보 저장
            setDataCareer(); // 경력 정보 저장

            if (typeof vm.data.CompanyNm != 'undefined' && vm.data.CompanyNm != '') {
              // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
              if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                setDataMemberHistory(); // 업무 시스템 연동
              }
            }

            $timeout(function () {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if ($stateParams.CustArmyId == 0) {
                    $state.go('app.customer.customerarmy-list');
                  } else {
                    $state.go('app.customer.customerarmy-detail', {
                      CustArmyId: vm.srch.CustArmyId,
                    });
                  }
                },
              });
            }, 500);

            return;
          }
        }
        gAlert('', data.body.docs[0].errMessage);
      };

      if (vm.srch.CustArmyId == 0 || vm.srch.CustArmyId === undefined) {
        // 등록
        vm.data.mapCode = 'Customerarmy.insertCustomerarmyDetailBatch';
        postApi.insert(vm.data, updateCallback, function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
        });
      } else {
        // 수정
        vm.data.mapCode = 'Customerarmy.updateCustomerarmyDetailBatch';
        postApi.update(vm.data, updateCallback, function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
        });
      }
    }

    // 유효성검사
    function chkDupMM_NO() {
      vm.data.mapCode = 'Customerarmy.getChkDupMM_NO';

      postApi.select(
        vm.data,
        function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (parseInt(data.body.docs[0].MM_NODupCnt) == 0) {
              //vm.data.isDupArmyNo = "N";
              //gAlert('', '등록이 가능한 고객입니다.');
              return true;
            } else {
              //vm.data.isDupArmyNo = "Y";
              gAlert('', '이미 등록된 고객입니다.');
              return false;
              //returnval = false;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }
    // 유효성검사
    function chkMemberHistoryValid() {
      //alert(angular.element(document.getElementById('txtZipcode')).scope().vm.data.Zipcode);

      if (typeof vm.data.CompanyDept == 'undefined' || vm.data.CompanyDept == '') {
        gAlert('', '부서를 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyWorkType == 'undefined' || vm.data.CompanyWorkType == '') {
        gAlert('', '취업형태를 선택해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyClass == 'undefined' || vm.data.CompanyClass == '') {
        gAlert('', '직급을 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyJobTitle == 'undefined' || vm.data.CompanyJobTitle == '') {
        gAlert('', '직책을 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyRegDate == 'undefined' || vm.data.CompanyRegDate == '') {
        gAlert('', '취업등록일을 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyType == 'undefined' || vm.data.CompanyType == '' || vm.data.CompanyType == ' ') {
        gAlert('', '취업직종을 선택해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyAmt == 'undefined' || vm.data.CompanyAmt == '') {
        gAlert('', '연봉을 입력해 주세요');
        return false;
      }

      var regexp = /^[0-9]*$/;
      if (!regexp.test(vm.data.CompanyAmt)) {
        gAlert('', '연봉은 숫자만 입력가능합니다');
        return false;
      }

      if (vm.data.CompanyAmt.length < 3 || vm.data.CompanyAmt.length > 5) {
        gAlert('', '연봉을 3~5자리로 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyJoinDate == 'undefined' || vm.data.CompanyJoinDate == '') {
        gAlert('', '입사일을 입력해 주세요');
        return false;
      }

      if (typeof vm.data.CompanyEmploy == 'undefined' || vm.data.CompanyEmploy == '') {
        gAlert('', '고용형태를 입력해 주세요');
        return false;
      }

      return true;
    }
    // 취업현황 업무 연동
    function setDataMemberHistory() {
      if (vm.data.ArmyArea == '010') {
        vm.data.RegUser = '1권역';
      } else if (vm.data.ArmyArea == '020') {
        vm.data.RegUser = '2권역';
      } else if (vm.data.ArmyArea == '030') {
        vm.data.RegUser = '3권역';
      } else if (vm.data.ArmyArea == '040') {
        vm.data.RegUser = '4권역';
      }

      var linkObj = {
        p_MH_CUST_ARMY_ID: vm.srch.CustArmyId,
        p_MH_NO: vm.data.MM_NO,
        p_MH_KNM: vm.data.CustNm,
        p_MH_COMPANY: vm.data.CompanyNm,
        p_MH_DEPT: vm.data.CompanyDept,
        p_MH_JIK_CD: vm.data.CompanyClass,
        p_MH_TITLE_CD: vm.data.CompanyJobTitle,
        p_MH_PAY: vm.data.CompanyAmt,
        p_MH_WORK: vm.data.CompanyTypeValue,
        p_MH_WORK_CD: vm.data.CompanyType,
        p_MH_ENT_YMD: vm.data.CompanyJoinDate,
        p_MH_WORK_TYPE: vm.data.CompanyWorkType,
        p_MH_EMPLOY: vm.data.CompanyEmploy,
        p_REG_DATE: vm.data.CompanyRegDate,
        p_REG_USER: $window.sessionStorage['loginUserName'],
      };

      postApi.api(
        'ext/MemberHistoryData',
        linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.mapCode = 'Customerarmy.updateCustomerarmyLinkage';

            postApi.update(
              vm.data,
              function (json) {
                if (json.header.status === CONSTANT.HttpStatus.OK) {
                }
              },
              function (json) {}
            );
            return;
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.', {
              fn: function () {
                vm.dataloader = false;
              },
            });
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-setDataMemberHistory' + data.body.docs[0].errMessage);
        }
      );

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiSetMemberHistory.jsp?p_MH_CUST_ARMY_ID=' +
        vm.srch.CustArmyId;
      url = url + '&p_MH_NO=' + vm.data.MM_NO;
      url = url + '&p_MH_KNM=' + escape(encodeURIComponent(vm.data.CustNm));
      url =
        url + '&p_MH_COMPANY=' + escape(encodeURIComponent(vm.data.CompanyNm));
      url =
        url + '&p_MH_DEPT=' + escape(encodeURIComponent(vm.data.CompanyDept));
      url =
        url +
        '&p_MH_JIK_CD=' +
        escape(encodeURIComponent(vm.data.CompanyClass));
      url =
        url +
        '&p_MH_TITLE_CD=' +
        escape(encodeURIComponent(vm.data.CompanyJobTitle));
      url = url + '&p_MH_PAY=' + escape(encodeURIComponent(vm.data.CompanyAmt));
      url =
        url +
        '&p_MH_WORK=' +
        escape(encodeURIComponent(vm.data.CompanyTypeValue));
      url = url + '&p_MH_WORK_CD=' + vm.data.CompanyType;
      url = url + '&p_MH_ENT_YMD=' + vm.data.CompanyJoinDate;
      url = url + '&p_MH_WORK_TYPE=' + vm.data.CompanyWorkType;
      url = url + '&p_REG_DATE=' + vm.data.CompanyRegDate;
      url = url + '&p_MH_EMPLOY=' + vm.data.CompanyEmploy;
      url = url + '&p_REG_USER=' + escape(encodeURIComponent(vm.data.RegUser));

      window.GoojikApiSetMemberHistory = function (data) {
        console.log('GoojikApiSetMemberHistory = ', data);
        if (data.Result == null || data.Result == '' || data.Result == 'FAIL') {
          gAlert('', '업무시스템과의 연동에 실패 했습니다.');
          return;
        } else {
          
        }
      };

      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiSetMemberHistory' }); */
    }

    // 모달팝업 호출 (상담신청등록자)
    function showModalCounselAppliRegUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.CounselAppliRegUser_ = okData.UserNm;
          vm.data.CounselAppliRegUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담신청등록자)
    function clearModalCounselAppliRegUser() {
      vm.data.CounselAppliRegUser_ = '';
      vm.data.CounselAppliRegUser = '';
    }

    // 모달팝업 호출 (등록자)
    function showModalCustArmyRegUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.CustArmyRegUser_ = okData.UserNm;
          vm.data.CustArmyRegUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (등록자)
    function clearModalCustArmyRegUser() {
      vm.data.CustArmyRegUser_ = '';
      vm.data.CustArmyRegUser = '';
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.CounselUser_ = okData.UserNm;
          vm.data.CounselUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.data.CounselUser_ = '';
      vm.data.CounselUser = '';
    }

    // 모달팝업 호출 (상담사)
    function showModalApprUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.ApprUser_ = okData.UserNm;
          vm.data.ApprUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalApprUser() {
      vm.data.ApprUser_ = '';
      vm.data.ApprUser = '';
    }

    // 아이디로 검색
    function serchArmyId() {
      if (typeof vm.data.ArmyId == 'undefined' || vm.data.ArmyId == '') {
        gAlert('', '아이디을 입력해주세요');
        return false;
      }
      /*var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiById_20.jsp?p_MM_ID=' +
        vm.data.ArmyId */
      vm.data.BranchId = vm.srch.BranchId;

      postApi.api(
        'extSelect/Linkage.getCustomerInfoByID/action',
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              gAlert('', '등록정보가 없습니다.');
              return;
            } else {
              vm.data.MM_NO = data.body.docs[0].MM_NO;
              /*if (!chkDupMM_NO()) {
                    //vm.data.MM_NO = '';
                    return false;
                }*/

              vm.data.mapCode = 'Customerarmy.getChkDupMM_NO';
              postApi.select(
                vm.data,
                function (json) {
                  //console.log(data);
                  if (json.header.status === CONSTANT.HttpStatus.OK) {
                    if (parseInt(json.body.docs[0].MM_NODupCnt) == 0) {
                      gAlert('', '등록된 정보를 불러옵니다.');
                      vm.data.MM_NO = data.body.docs[0].MM_NO;
                      vm.data.CustNm = data.body.docs[0].MM_KNM;
                      vm.data.ArmyNo = data.body.docs[0].MM_ARMY_GUNBUN;
                      if ((data.body.docs[0].MM_BIRTH.length = 8)) {
                        vm.data.ResRegNo = data.body.docs[0].MM_BIRTH.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                      }
                      vm.data.Mobile = data.body.docs[0].MM_TEL_HP.replace(/\s|-/g, '').replace(
                        /(\d{3})(\d{3,4})(\d{4})/,
                        '$1-$2-$3'
                      );
                      vm.data.Email = data.body.docs[0].MM_EMAIL;
                      if ((data.body.docs[0].MM_ARMY_ENTYMD.length = 8)) {
                        document.getElementById('dtInArmyDate').value = data.body.docs[0].MM_ARMY_ENTYMD.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                        vm.data.InArmyDate = data.body.docs[0].MM_ARMY_ENTYMD.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                      }
                      if ((data.body.docs[0].MM_ARMY_RETYMD.length = 8)) {
                        document.getElementById('dtOutArmyDate').value = data.body.docs[0].MM_ARMY_RETYMD.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                        vm.data.OutArmyDate = data.body.docs[0].MM_ARMY_RETYMD.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                      }
                      vm.ArmyClassList.Code = data.body.docs[0].MM_ARMY_RANKS;
                      vm.ArmyTypeList.Code = data.body.docs[0].MM_ARMY_GUNBUL;
                      vm.SpecList.Code = data.body.docs[0].MM_ARMY_BRANCH;
                      vm.data.Spec = data.body.docs[0].MM_ARMY_BRANCH;
                      vm.data.PermStat = data.body.docs[0].MM_UNIT;
                      vm.data.PermStatAddr = data.body.docs[0].MM_UNIT_ADDR;
                      vm.PermStatAddrList.Code = data.body.docs[0].MM_UNIT_ADDR;
                      document.getElementById('txtZipcode').value = data.body.docs[0].MM_ZIP;
                      document.getElementById('txtAddr1').value = data.body.docs[0].MM_ADDR;
                      vm.data.Addr2 = data.body.docs[0].MM_ADDR_NO;
                      vm.HopeField1List.Code = data.body.docs[0].MM_JOB_CHK;
                      vm.CounselLocList.Code = data.body.docs[0].MD_WORK_PLACE1;
                      vm.CounselLocList2.Code = data.body.docs[0].MD_WORK_PLACE2;
                      vm.HopeJobTypeList.Code = data.body.docs[0].MD_TYPE1;
                      vm.HopeJobTypeList2.Code = data.body.docs[0].MD_TYPE2;

                      getCustSchoolList();
                      getCustLicenseList();
                      getCustomerarmyHistoryList();
                      vm.disabled = true;
                      return true;
                    } else {
                      //vm.data.isDupArmyNo = "Y";
                      gAlert('', '이미 등록된 고객입니다.');
                      vm.data.ArmyId = '';
                      vm.data.MM_NO = '';
                      vm.data.CustNm = '';
                      vm.data.ArmyNo = '';
                      vm.data.ResRegNo = '';
                      vm.data.Mobile = '';
                      vm.data.Email = '';
                      document.getElementById('dtInArmyDate').value = '';
                      vm.data.InArmyDate = '';
                      document.getElementById('dtOutArmyDate').value = '';
                      vm.data.OutArmyDate = '';
                      vm.ArmyClassList.Code = '';
                      vm.ArmyTypeList.Code = '';
                      vm.SpecList.Code = '';
                      vm.data.Spec = '';
                      vm.data.PermStat = '';
                      vm.data.PermStatAddr = '';
                      document.getElementById('txtZipcode').value = '';
                      document.getElementById('txtAddr1').value = '';
                      vm.data.Addr2 = '';
                      vm.HopeField1List.Code = '';
                      vm.CounselLocList.Code = '';
                      vm.CounselLocList2.Code = '';
                      vm.HopeJobTypeList.Code = '';
                      vm.HopeJobTypeList2.Code = '';
                      return true;
                    }
                  }
                  gAlert('', json.body.docs[0].errMessage);
                },
                function (json) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', json.body.docs[0].errMessage);
                }
              );
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-serchArmyId' + data.body.docs[0].errMessage);
        }
      );
    }

    function getCustSchoolList() {
      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiGetSchoolInfoByMS_NO.jsp?p_MS_NO=' +
        vm.data.MM_NO; */

      postApi.api(
        'extSelect/Linkage.getCustomerarmySchoolList/action',
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0) {
              var jsonList = data.body.docs;

              jsonList = jsonList.reduce(function (acc, cur) {
                cur.OutSchDate = cur.MS_RET_YMD.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                if (cur.MS_CODE.length === 2) {
                  cur.EduLev = cur.MS_CODE.substring(0, 1);
                  cur.OutSchYN = cur.MS_CODE.substring(1, 2);
                }
                acc.push(cur);
                return acc;
              }, []);

              if (jsonList == null || jsonList == '') {
                //gAlert('', '조회된 정보가 없습니다.');
              }
              $scope.EduJSON = jsonList;

              var cnt = data.body.docCnt - 1;

              if (cnt > -1) {
                if (jsonList[cnt].EduLev == '4') {
                  // 고등학교면
                  if (jsonList[cnt].OutSchYN == '1') {
                    // 졸업이면 -> 고졸
                    vm.data.LastEdu = '010';
                    vm.LastEduList.Code = '010';
                  }
                } else {
                  // 고등학교가 아니면
                  if (jsonList[cnt].OutSchYN == '1') {
                    // 졸업이면 -> 대졸
                    vm.data.LastEdu = '030';
                    vm.LastEduList.Code = '030';
                  } else {
                    // 졸업이 아니면 -> 대재
                    vm.data.LastEdu = '020';
                    vm.LastEduList.Code = '020';
                  }
                }
              }
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustSchoolList' + data.body.docs[0].errMessage);
        }
      );
    }

    function getCustLicenseList() {
      postApi.api(
        'extSelect/Linkage.getCustomerarmyLicenseList/action',
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0) {
              var jsonList = data.body.docs;

              jsonList = jsonList.reduce(function (acc, cur) {
                cur.GetDate = cur.GetDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                acc.push(cur);
                return acc;
              }, []);

              if (jsonList == null || jsonList == '') {
                //gAlert('', '조회된 정보가 없습니다.');
              }
              $scope.LicenseJSON = jsonList;
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustSchoolList' + data.body.docs[0].errMessage);
        }
      );
    }

    function getCustomerarmyHistoryList() {
      postApi.api(
        'extSelect/Linkage.getCustomerarmyHistoryList/action',
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0) {
              var jsonList = data.body.docs;

              jsonList = jsonList.reduce(function (acc, cur) {
                cur.WorkDateFrom = cur.WorkDateFrom.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                cur.WorkDateTo = cur.WorkDateTo.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                acc.push(cur);
                return acc;
              }, []);

              if (jsonList == null || jsonList == '') {
                //gAlert('', '조회된 정보가 없습니다.');
              }
              $scope.CareerJSON = jsonList;
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustSchoolList' + data.body.docs[0].errMessage);
        }
      );
    }

    var modalCustarmyInstance = null;

    // 모달팝업 호출 (고객정보)
    function showModalCustNameInfo() {
      if (modalCustarmyInstance != null) {
        return;
      }
      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        gAlert('', '성명을 입력해주세요');
        return false;
      }

      var ctrl = 'CustarmyNameModalCtrl as modalCtrl';
      var paramData = { CustNm: vm.data.CustNm };

      modalCustarmyInstance = modalFactory.open(
        'lg',
        'app/customer/modal/customerarmy/custarmy-name-modal.html',
        ctrl,
        paramData
      );
      modalCustarmyInstance.result.then(
        function (okData) {
          vm.data.ArmyId = okData.MM_ID;
          serchArmyId();
          modalCustarmyInstance = null;
        },
        function (cancelData) {
          modalCustarmyInstance = null;
        }
      );
    }

    // 모달팝업 호출 (고객정보)
    function showModalCustGunbunInfo() {
      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        return false;
      }

      var ctrl = 'CustarmyGunbunModalCtrl as modalCtrl';
      var paramData = { ArmyNo: vm.data.ArmyNo };

      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/customerarmy/custarmy-gunbun-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.ArmyId = okData.MM_ID;
          serchArmyId();
        },
        function (cancelData) {}
      );
    }

    // 성명, 군번으로 검색
    /* function serchNameGunbun() {
      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        gAlert('', '성명을 입력해주세요');
        return false;
      }
      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        return false;
      }

      var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiByNameGunbun_06.jsp?p_MM_KNM=' +
        escape(encodeURIComponent(vm.data.CustNm)) +
        '&p_MM_ARMY_GUNBUN=' +
        vm.data.ArmyNo;

      window.GoojikApiByNameGunbun = function (data) {
        console.log('GoojikApiByNameGunbun = ', data);
        if (data.MM_NO == null || data.MM_NO == '') {
          gAlert('', '등록정보가 없습니다.');
          return;
        } else {
          vm.data.MM_NO = data.MM_NO;
          if (!chkDupMM_NO()) {
            //vm.data.MM_NO = '';
            return false;
          }
          gAlert('', '등록정보된 정보를 불러옵니다.');
        }
        vm.data.MM_NO = data.MM_NO;
        vm.data.ArmyId = data.MM_ID;
        if ((data.MM_BIRTH.length = 8)) {
          vm.data.ResRegNo = vm.data.ResRegNo = data.MM_BIRTH.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3'
          );
        }
        vm.data.Mobile = data.MM_TEL_HP;
        vm.data.Email = data.MM_EMAIL;
        if ((data.MM_ARMY_ENTYMD.length = 8)) {
          document.getElementById('dtInArmyDate').value = vm.data.ResRegNo =
            data.MM_ARMY_ENTYMD.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
          vm.data.InArmyDate = vm.data.ResRegNo = data.MM_ARMY_ENTYMD.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3'
          );
        }
        if ((data.MM_ARMY_RETYMD.length = 8)) {
          document.getElementById('dtOutArmyDate').value = vm.data.ResRegNo =
            data.MM_ARMY_RETYMD.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
          vm.data.OutArmyDate = vm.data.ResRegNo = data.MM_ARMY_RETYMD.replace(
            /(\d{4})(\d{2})(\d{2})/,
            '$1-$2-$3'
          );
        }
        vm.ArmyClassList.Code = data.MM_ARMY_RANKS;
        vm.ArmyTypeList.Code = data.MM_ARMY_GUNBUL;
        vm.SpecList.Code = data.MM_ARMY_BRANCH;
        vm.data.Spec = data.MM_ARMY_BRANCH;
        vm.data.PermStat = data.MM_UNIT;
        document.getElementById('txtZipcode').value = data.MM_ZIP;
        document.getElementById('txtAddr1').value = data.MM_ADDR;
        vm.data.Addr2 = data.MM_ADDR_NO;
        vm.HopeField1List.Code = data.MM_JOB_CHK;
        vm.CounselLocList.Code = data.MD_WORK_PLACE1;
        vm.CounselLocList2.Code = data.MD_WORK_PLACE2;
        vm.HopeJobTypeList.Code = data.MD_TYPE1;
        vm.HopeJobTypeList2.Code = data.MD_TYPE2;
      };

      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiByNameGunbun' });
    } */

    // 군번 중복체크
    function chkDupArmyNo() {
      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        return false;
      }

      // 수정모드일때
      if (vm.srch.CustArmyId != 0 && vm.data.OldArmyNo == vm.data.ArmyNo) {
        gAlert('', '군번이 변경되지 않았습니다.');
        vm.data.isDupArmyNo = 'N';
        return false;
      }

      vm.data.mapCode = 'Counselappli.getChkDupArmyNo';

      postApi.select(
        vm.data,
        function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (
              parseInt(data.body.docs[0].CounselAppliDupCnt) == 0 &&
              parseInt(data.body.docs[0].CustArmyDupCnt) == 0
            ) {
              vm.data.isDupArmyNo = 'N';
              gAlert('', '등록이 가능한 군번입니다.');
            } else {
              vm.data.isDupArmyNo = 'Y';
              gAlert('', '이미 상담신청정보 또는 고객정보에 등록된 군번입니다.');
            }

            return;
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 군번 중복체크 초기화
    function chkDupArmyNoClear() {
      vm.data.isDupArmyNo = 'Y';
    }

    // 자격증 목록
    function getLicenseList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmylicenseList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.LicenseJSON = data.body.docs;
            } else {
              /*$scope.LicenseJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 자격증 정보 저장
    function setDataLicense() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataLicense', status, data);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};

      data.paramList = $scope.LicenseJSON.reduce(function (acc, cur) {
        if (typeof cur.LicenseNm != 'undefined' && cur.LicenseNm != '') {
          cur.CustArmyId = vm.srch.CustArmyId;
          acc.push(cur);
        }
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'Customerarmy.updateCustomerarmylicense';
        postApi.update(data, successCallback, errorCallback);
      }

      /*  $scope.LicenseJSON.forEach(function (data) {
        data.CustArmyId = vm.srch.CustArmyId;

        if (typeof data.LicenseNm == 'undefined' || data.LicenseNm == '') return true;

        if (data.CustArmyLicenseId == 0 || data.CustArmyLicenseId === undefined) {
          data.mapCode = 'Customerarmy.insertCustomerarmylicense';
          postApi.insert(data, successCallback, errorCallback);
        } else {
          data.mapCode = 'Customerarmy.updateCustomerarmylicense';
          postApi.update(data, successCallback, errorCallback);
        }
      }); */
    }

    // 자격증 정보 삭제
    function deleteLicense(idx) {
      var data = {
        CustArmyLicenseId: idx,
      };

      data.mapCode = 'Customerarmy.deleteCustomerarmylicense';
      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 학력 목록
    function getEduList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmyeduList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.EduJSON = data.body.docs;
            } else {
              /*$scope.EduJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 학력 정보 저장
    function setDataEdu() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataEdu', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};
      data.paramList = $scope.EduJSON.reduce(function (acc, cur) {
        if (cur.EduLev) {
          cur.CustArmyId = vm.srch.CustArmyId;
          acc.push(cur);
        }
        //신규 생성
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'Customerarmy.updateCustomerarmyedu';
        postApi.update(data, successCallback, errorCallback);
      }

      /* angular.forEach($scope.EduJSON, function (item) {
        item.CustArmyId = vm.srch.CustArmyId;

        if (!item.EduLev) return true;

        if (typeof item.CustArmyEduId === 'undefined' || item.CustArmyEduId === '0') {
          item.mapCode = 'Customerarmy.insertCustomerarmyedu';
          postApi.insert(item, successCallback, errorCallback);
        } else {
          item.mapCode = 'Customerarmy.updateCustomerarmyedu';
          postApi.update(item, successCallback, errorCallback);
        }
      }); */
    }

    // 학력 정보 삭제
    function deleteEdu(idx) {
      var data = {
        CustArmyEduId: idx,
      };

      data.mapCode = 'Customerarmy.deleteCustomerarmyedu';

      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 경력 목록
    function getCareerList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmycareerList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.CareerJSON = data.body.docs;
            } else {
              /*$scope.CareerJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 경력 정보 저장
    function setDataCareer() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataCareer', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};

      data.paramList = $scope.CareerJSON.reduce(function (acc, cur) {
        if (typeof cur.WorkDateFrom != 'undefined' && cur.WorkDateFrom != '') {
          cur.CustArmyId = vm.srch.CustArmyId;
          acc.push(cur);
        }
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'Customerarmy.updateCustomerarmycareer';
        postApi.update(data, successCallback, errorCallback);
      }

      /*  $scope.CareerJSON.forEach(function (data) {
        data.CustArmyId = vm.srch.CustArmyId;

        if (typeof data.WorkDateFrom == 'undefined' || data.WorkDateFrom == '') return true;

        if (data.CustArmyCareerId == 0 || data.CustArmyCareerId === undefined) {
          data.mapCode = 'Customerarmy.insertCustomerarmycareer';
          postApi.insert(data, successCallback, errorCallback);
        } else {
          data.mapCode = 'Customerarmy.updateCustomerarmycareer';
          postApi.update(data, successCallback, errorCallback);
        }
      }); */
    }

    // 경력 정보 삭제
    function deleteCareer(idx) {
      var data = {
        CustArmyCareerId: idx,
      };

      data.mapCode = 'Customerarmy.deleteCustomerarmycareer';

      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 데이터 조회
    getData();

    // 자동 저장 유효성검사
    function chkValidAuto() {
      //alert(angular.element(document.getElementById('txtZipcode')).scope().vm.data.Zipcode);

      if (typeof vm.data.MM_NO == 'undefined' || vm.data.MM_NO == '') {
        //gAlert('', '고객정보를 검색해 주세요');
        return false;
      }

      if (typeof vm.data.ArmyId == 'undefined' || vm.data.ArmyId == '') {
        //gAlert('', '아이디를 입력해주세요');
        return false;
      }

      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        //gAlert('', '성명을 입력해주세요');
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        //gAlert('', '군번을 입력해주세요');
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        //gAlert('', '계급을 선택해주세요');
        return false;
      }

      if (typeof vm.data.ArmyArea == 'undefined' || vm.data.ArmyArea == '') {
        //gAlert('', '권역을 선택해주세요');
        return false;
      }

      if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
        //gAlert('', '군별을 선택해주세요');
        return false;
      }

/*      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        //gAlert('', '소속부대를 선택해주세요');
        return false;
      }

      if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
        //gAlert('', '소속부대2를 입력해주세요');
        return false;
      }*/

      /*if (typeof(vm.data.isDupArmyNo) == "undefined" || vm.data.isDupArmyNo == "Y") {          
          gAlert('', '군번 중복확인버튼을 클릭해주세요.');
          return false;
        } */

      /*if (typeof(vm.data.PermStat) == "undefined" || vm.data.PermStat == "") {          
          gAlert('', '소속부대를 입력해주세요');
          return false;
        }*/

      /*if (typeof(vm.data.PermStat2) == "undefined" || vm.data.PermStat2 == "") {          
          gAlert('', '소속부대를 선택해주세요');
          return false;
        }*/

      if (typeof vm.data.Spec == 'undefined' || vm.data.Spec == '') {
        //gAlert('', '병과를 입력해주세요');
        return false;
      }

      if (typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == '') {
        //gAlert('', '임관일 또는 입대일를 입력해주세요');
        return false;
      }

      if (typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == '') {
        //gAlert('', '전역일을 입력해주세요');
        return false;
      }

      var date1 = new Date(vm.data.InArmyDate);
      var date2 = new Date(vm.data.OutArmyDate);
      var interval = date2 - date1;
      var day = 1000 * 60 * 60 * 24;
      var month = day * 30;
      var year = month * 12;

      if (interval / year >= 5) {
        //gAlert('', '장기간부의 경우 등록이 불가능합니다.');
        return false;
      }

      if (typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == '') {
        //gAlert('', '생년월일를 입력해주세요');
        return false;
      }

      if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        //gAlert('', '휴대폰을 입력해주세요');
        return false;
      }

      if (typeof vm.data.Email == 'undefined' || vm.data.Email == '') {
        //gAlert('', '이메일을 입력해주세요');
        return false;
      }

      if (typeof vm.data.HopeField1 == 'undefined' || vm.data.HopeField1 == '') {
        //gAlert('', '상담희망분야를 선택해주세요');
        return false;
      }

      if (vm.data.HopeField1 == '040') {
        if (typeof vm.data.HopeField2 == 'undefined' || vm.data.HopeField2 == '') {
          //gAlert('', '상담희망분야를 선택해주세요');
          return false;
        }
      }

      if (vm.data.HopeField1 != '040') {
        if (typeof vm.data.CounselLoc == 'undefined' || vm.data.CounselLoc == '') {
          //gAlert('', '희망지역을 선택해주세요');
          return false;
        }
      }

      if (vm.data.HopeField1 != '2' && vm.data.HopeField1 != '3' && vm.data.HopeField1 != '0') {
        if (typeof vm.data.HopeJobType == 'undefined' || vm.data.HopeJobType == '') {
          //gAlert('', '희망직종(1지망)을 선택해주세요');
          return false;
        }
      }

      if (vm.data.HopeJobType2 == ' ') {
        //gAlert('', '희망직종(2지망)을 선택해주세요');
        return false;
      }

      if (vm.data.HopeJobType == '151') {
        if (typeof vm.data.HopeJobTypeEtc == 'undefined' || vm.data.HopeJobTypeEtc == '') {
          //gAlert('', '희망직종의 기타내용을 입력해주세요.');
          return false;
        }
      }

      if (typeof vm.data.LastEdu == 'undefined' || vm.data.LastEdu == '') {
        //gAlert('', '학력을 선택해주세요');
        return false;
      }

      /* if (
        typeof vm.data.CounselAbleTel == 'undefined' ||
        vm.data.CounselAbleTel == ''
      ) {
        //gAlert('', '상담가능연락처를 입력해주세요');
        return false;
      } */

      /*if (vm.data.HopeField1 != '0') {
        if (typeof vm.data.HopeAmt == 'undefined' || vm.data.HopeAmt == '') {
          //gAlert('', '희망급여(만원)을 입력해주세요');
          return false;
        }
      }

      if (typeof vm.data.FirstHopeDate == 'undefined' || vm.data.FirstHopeDate == '') {
        //gAlert('', '1차상담희망일을 입력해주세요');
        return false;
      }*/

      /* if (
        typeof vm.data.CounselAppliRegUser == 'undefined' ||
        vm.data.CounselAppliRegUser == ''
      ) {
        //gAlert('', '상담신천등록자를 선택해주세요');
        return false;
      } */

      /* if (
        typeof vm.data.CounselAppliRegDate == 'undefined' ||
        vm.data.CounselAppliRegDate == ''
      ) {
        //gAlert('', '상담신청등록일을 입력해주세요');
        return false;
      } */

      /* if (
        typeof vm.data.CustArmyRegUser == 'undefined' ||
        vm.data.CustArmyRegUser == ''
      ) {
        //gAlert('', '등록자를 선택해주세요');
        return false;
      } */

      /* if (
        typeof vm.data.CustArmyRegDate == 'undefined' ||
        vm.data.CustArmyRegDate == ''
      ) {
        //gAlert('', '등록일을 입력해주세요');
        return false;
      } */

      if (typeof vm.data.FirstDecDate == 'undefined' || vm.data.FirstDecDate == '') {
        //gAlert('', '1차상담확정일을 입력해주세요');
        return false;
      }

      if (typeof vm.data.FirstDecHour == 'undefined') {
        //gAlert('', '1차상담확정일시(시)를 선택해주세요');
        return false;
      }

      if (typeof vm.data.FirstDecMin == 'undefined') {
        //gAlert('', '1차상담확정일시(분)를 선택해주세요');
        return false;
      }

      /*  if (typeof vm.data.ApprDate == 'undefined' || vm.data.ApprDate == '') {
        //gAlert('', '상담승인일을 입력해주세요');
        return false;
      } */

      /* if (typeof vm.data.ApprUser == 'undefined' || vm.data.ApprUser == '') {
        //gAlert('', '상담승인자를 선택해주세요');
        return false;
      } */

      if (typeof vm.data.CounselUser == 'undefined' || vm.data.CounselUser == '') {
        //gAlert('', '상담사를 선택해주세요');
        return false;
      }

      /*if (vm.data.oldFirstDecDate == "") { // 신규
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.FirstDecDate) != "undefined" && vm.data.FirstDecDate != "") {
            if (vm.data.oldFirstDecDate != vm.data.FirstDecDate && getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
              alert('1차상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      return true;
    }

    // 자동 저장
    function setDataAuto() {
      if ($window.sessionStorage['isLoggedIn'] != 'Y') {
        return;
      }

      // 주소 값 저장
      vm.data.Zipcode = angular.element(document.getElementById('txtZipcode')).val();
      vm.data.Addr1 = angular.element(document.getElementById('txtAddr1')).val();
      //vm.data.Addr2 = angular.element(document.getElementById('txtAddr2')).val();

      if (!chkValidAuto()) {
        startTimer();
        return false;
      }

      if (typeof vm.data.CompanyNm != 'undefined' && vm.data.CompanyNm != '') {
        if (!chkMemberHistoryValid()) return false;
      }

      angular.element(document.getElementById('txtZipcode')).val();

      vm.data.TableId = vm.srch.CustArmyId;
      vm.data.TableNm = vm.srch.TableNm;
      vm.data['uploadFileList'] = vm.uploadFileList;

      if (vm.srch.CustArmyId == 0) {
        // 등록
        gConfirm(
          '',
          '자동저장 하시겠습니까?',
          {
            btn: '',
            fn: function () {
              vm.data.mapCode = 'Customerarmy.insertCustomerarmyDetailBatch';

              postApi.insert(
                vm.data,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docs[0].CustArmyId !== null) {
                      vm.srch.CustArmyId = data.body.docs[0].CustArmyId;
                      vm.data.CustArmyId = data.body.docs[0].CustArmyId;

                      setDataLicense(); // 자격증 정보 저장
                      setDataEdu(); // 학력 정보 저장
                      setDataCareer(); // 경력 정보 저장

                      if (typeof vm.data.CompanyNm != 'undefined' && vm.data.CompanyNm != '') {
                        // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
                        if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                          setDataMemberHistory(); // 업무 시스템 연동
                        }
                      }
                      startTimer();
                      return;
                    }
                  }
                  gAlert('', data.body.docs[0].errMessage);
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            },
          },
          {
            btn: '',
            fn: function () {
              startTimer();
              return;
            },
          }
        );
        return;
      } else {
        // 수정
        vm.data.mapCode = 'Customerarmy.updateCustomerarmyDetailBatch';

        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].CustArmyId !== null) {
                vm.srch.CustArmyId = data.body.docs[0].CustArmyId;
                vm.data.CustArmyId = data.body.docs[0].CustArmyId;

                setDataLicense(); // 자격증 정보 저장
                setDataEdu(); // 학력 정보 저장
                setDataCareer(); // 경력 정보 저장

                if (typeof vm.data.CompanyNm != 'undefined' && vm.data.CompanyNm != '') {
                  // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
                  if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                    setDataMemberHistory(); // 업무 시스템 연동
                  }
                }
                startTimer();
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
    }

    var timer = null;

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
    });

    function startTimer() {
      timer = $timeout(setDataAuto, 300000); // 타이머 : 5문 = 5 * 60 * 1000
    }

    startTimer();
  },
]);

webapp.controller('CustomerarmyListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'StaticVariable',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  '$timeout',
  function CustomerarmyListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    StaticVariable,
    postApi,
    gAlert,
    gConfirm,
    $http,
    $timeout
  ) {
    var vm = this;
    var EXCEL_SQL = 'Customerarmy.getExcelCustomerarmyList';
    var EXCEL_TITLE = '고객 목록';

    // 접근 권한 체크
    if (!isPageAccess('customerarmy-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    $scope.showBtnEmail = true;
    $scope.showBtnDel = true;
    $scope.showBtnLinkageYN = true;
    $scope.showBtnAdd = isPageAccess('customerarmy-edit', $window.sessionStorage['loginUserType'], false);
    vm.dataloader = false;
    vm.disabledArea = false;

    // 함수연결
    vm.showModalCounselAppliRegUser = showModalCounselAppliRegUser;
    vm.clearModalCounselAppliRegUser = clearModalCounselAppliRegUser;
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.showModalCustArmyRegUser = showModalCustArmyRegUser;
    vm.clearModalCustArmyRegUser = clearModalCustArmyRegUser;
    vm.deleteList = deleteList;
    vm.getExcel = getExcel;
    vm.showModalEmail = showModalEmail;
    vm.getExcelForWork = getExcelForWork;
    vm.updateLinkageYNList = updateLinkageYNList;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      TenantNm: $window.sessionStorage['loginTenantName'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 데이터
    vm.data = {};

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    /*  vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CounselField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeDutyList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1200',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList1 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1030',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.HopeLocList2 = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1210',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.LinkageYNList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1280',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    /*vm.ApprYNList = {
        CommonCodeId:'',
        ParentCommonCodeId:'',
        CodeType:'1080',
        Code:'',
        CodeValue:'',
        TenantId:$window.sessionStorage['loginTenantId'],      
      }  */

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.srch.ArmyClass = data.Code;
      } else if (data.CodeType == '1200') {
        /*} else if (data.CodeType == '1080') {
          vm.srch.ApprYN = data.Code;              
        }*/
        vm.srch.HopeDuty = data.Code;

        if (data.Code == '110') {
          $scope.HopeDutyEtcShow = true;
        } else {
          $scope.HopeDutyEtcShow = false;
          vm.srch.HopeDutyEtc = '';
        }
      } else if (data.CodeType == '1030' || data.CodeType == '1210') {
        vm.srch.HopeLoc = data.Code;
      } else if (data.CodeType == '1280') {
        vm.srch.LinkageYN = data.Code;
      }
    };

    vm.onArmyAreaListSelected = function () {
      var data = vm.srch.ArmyAreaObj;
      if (data == null) {
        vm.srch.ArmyArea = '';
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }
      vm.srch.ArmyArea = data.Code;

      vm.PermStat1List.ArmyArea = data.Code;
      vm.ArmyTypeList.ArmyArea = data.Code;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;

      vm.srch.ArmyAreaType = data.Code;

      //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
      vm.PermStat1List.ParentCommonCodeId = vm.srch.ArmyAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onPermStat2ListSelected = function (data) {
      if (data == null) {
        vm.srch.PermStat2 = '';
        return;
      }

      vm.srch.PermStat2 = data.Code;
    };

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.HopeField1 = '';
        return;
      }

      vm.srch.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      if (vm.srch.HopeField1 == '040') {
        vm.HopeField2ListShow = true;
      } else {
        vm.HopeField2ListShow = false;
        vm.srch.HopeField2 = '';
      }
    };

    vm.onHopeField2ListSelected = function (data) {
      if (data == null) {
        vm.srch.HopeField2 = '';
        return;
      }

      vm.srch.HopeField2 = data.Code;
    };

    vm.CounselField2List = {};

    vm.onCounselField1ListSelected = function (data) {
      vm.CounselField2List.CodeType = '';
      vm.CounselField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.CounselField1 = '';
        return;
      }

      vm.srch.CounselField1 = data.Code;
      vm.CounselField2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onCounselField2ListSelected = function (data) {
      if (data == null) {
        vm.srch.CounselField2 = '';

        vm.srch.HopeDuty = '';
        vm.srch.HopeDutyEtc = '';
        vm.srch.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
        return;
      }

      vm.srch.CounselField2 = data.Code;

      if (data.Code == '010' || data.Code == '020') {
        $scope.HopeDutyListShow = true;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = vm.srch.HopeDuty == '110';
      } else if (data.Code == '080' || data.Code == '090' || data.Code == '091') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = true;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      } else if (data.Code == '050') {
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = true;
        $scope.HopeDutyEtcShow = false;
      } else {
        vm.srch.HopeDuty = '';
        vm.srch.HopeDutyEtc = '';
        vm.srch.HopeLoc = '';
        $scope.HopeDutyListShow = false;
        $scope.HopeLocListShow1 = false;
        $scope.HopeLocListShow2 = false;
        $scope.HopeDutyEtcShow = false;
      }
    };

    

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('customerarmy-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/customer/customerarmy-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/customer/customerarmy-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/customer/customerarmy-list') !== -1)
      ) {
        vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('customerarmy-list-ctrl')));

        vm.data.ArmyAreaObj = {
          Code: vm.srch.ArmyArea,
          CodeValue: vm.srch.ArmyArea,
        };
        vm.ArmyClassList.Code = vm.srch.ArmyClass;
        vm.ArmyTypeList.Code = vm.srch.ArmyType;
        vm.PermStat1List.Code = vm.srch.PermStat1;
        vm.PermStat2List.Code = vm.srch.PermStat2;
        vm.HopeField1List.Code = vm.srch.HopeField1;
        vm.HopeField2List.Code = vm.srch.HopeField2;
        vm.CounselField1List.Code = vm.srch.CounselField1;
        vm.CounselField2List.Code = vm.srch.CounselField2;
        vm.HopeDutyList.Code = vm.srch.HopeDuty;
        vm.HopeLocList1.Code = vm.srch.HopeLoc;
        vm.HopeLocList2.Code = vm.srch.HopeLoc;
        vm.LinkageYNList.Code = vm.srch.LinkageYN;

        $scope.dtFirstHopeDateFrom = setNewDate(vm.srch.FirstHopeDateFrom);
        $scope.dtFirstHopeDateTo = setNewDate(vm.srch.FirstHopeDateTo);
        $scope.dtCounselAppliRegDateFrom = setNewDate(vm.srch.CounselAppliRegDateFrom);
        $scope.dtCounselAppliRegDateTo = setNewDate(vm.srch.CounselAppliRegDateTo);
        $scope.dtFirstDecDateFrom = setNewDate(vm.srch.FirstDecDateFrom);
        $scope.dtFirstDecDateTo = setNewDate(vm.srch.FirstDecDateTo);
        $scope.dtCustArmyRegDateFrom = setNewDate(vm.srch.CustArmyRegDateFrom);
        $scope.dtCustArmyRegDateTo = setNewDate(vm.srch.CustArmyRegDateTo);

        vm.currentPage = vm.srch.page;
      }
    }

    // 엑셀 정보
    vm.excel = {
      downFileName: 'customerarmy',
      subject: '상담신청 목록',
      /*header : [ {
          field : 'FreeBoardId',
          title : '번호',
          width : '5',
          format : 'number'
        }, {          
          field : 'ReadCnt',
          title : '조회수',
          width : '5',
          format : 'string'
        } ],*/
    };

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      if (
        vm.srch.FirstHopeDateFrom != null &&
        vm.srch.FirstHopeDateFrom != '' &&
        vm.srch.FirstHopeDateTo != null &&
        vm.srch.FirstHopeDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.FirstHopeDateFrom) > getDateToNumber(vm.srch.FirstHopeDateTo)) {
          gAlert('', '1차상담희망일의 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      if (
        vm.srch.CounselAppliRegDateFrom != null &&
        vm.srch.CounselAppliRegDateFrom != '' &&
        vm.srch.CounselAppliRegDateTo != null &&
        vm.srch.CounselAppliRegDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.CounselAppliRegDateFrom) > getDateToNumber(vm.srch.CounselAppliRegDateTo)) {
          gAlert('', '상담신청등록일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      if (
        vm.srch.FirstDecDateFrom != null &&
        vm.srch.FirstDecDateFrom != '' &&
        vm.srch.FirstDecDateTo != null &&
        vm.srch.FirstDecDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.FirstDecDateFrom) > getDateToNumber(vm.srch.FirstDecDateTo)) {
          gAlert('', '1차상담확정일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      if (
        vm.srch.CustArmyRegDateFrom != null &&
        vm.srch.CustArmyRegDateFrom != '' &&
        vm.srch.CustArmyRegDateTo != null &&
        vm.srch.CustArmyRegDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.CustArmyRegDateFrom) > getDateToNumber(vm.srch.CustArmyRegDateTo)) {
          gAlert('', '등록일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      return true;
    }

    function getTenantAreaList() {
      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          var resultData = postApi.makeResultData(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (resultData.body.docs[0] != null) {
              var areaList = resultData.body.docs[0].TenantArea.split(',');
              vm.ArmyAreaList = areaList.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.srch.ArmyAreaObj = vm.ArmyAreaList[0];
                vm.srch.ArmyArea = vm.srch.ArmyAreaObj.Code;
              }
            } else {
              vm.srch.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-setData' + data.body.docs[0].errMessage);
        }
      );
    }

    // 목록 조회
    function getList() {
      if (!chkValid()) return false;

      getTenantAreaList();

      vm.srch.page = vm.currentPage;

      /* if (vm.srch.ArmyArea == undefined || vm.srch.ArmyArea == '') {
        vm.srch.ArmyArea = [];
        if ($window.sessionStorage['loginArmyZone1YN'] == 'Y') {
          vm.srch.ArmyArea.push('010');
        }
        if ($window.sessionStorage['loginArmyZone2YN'] == 'Y') {
          vm.srch.ArmyArea.push('020');
        }
        if ($window.sessionStorage['loginArmyZone3YN'] == 'Y') {
          vm.srch.ArmyArea.push('030');
        }
        if ($window.sessionStorage['loginArmyZone4YN'] == 'Y') {
          vm.srch.ArmyArea.push('040');
        }
        if ($window.sessionStorage['loginArmyZone5YN'] == 'Y') {
          vm.srch.ArmyArea.push('050');
        }
      }
      console.log('vm.srch', vm.srch); */

      getListCount();

      $window.sessionStorage.setItem('customerarmy-list-ctrl', angular.toJson(vm.srch));

      vm.dataloader = true;
      vm.srch.mapCode = 'Customerarmy.getCustomerarmyList';

      postApi.select(
        vm.srch,
        function (data) {
          vm.dataloader = false;
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {

              var resultData = postApi.makeResultData(data);
              vm.lists = resultData.body.docs;

             // vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );

      /*   var prms = api.doList().post(vm.srch).$promise;

        prms.then(function(data) {
          vm.dataloader = false;
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {           
            if (data.responseVO.body.docs.length > 0) {
              vm.lists = data.responseVO.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            console.info("vm.lists -", vm.lists);
          } else {
            console.info("else ");
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('Error-getList', status, data);
        }); */
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmyListCount';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log('customerarmy', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs[0];
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            //console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );

      /* var prms = api.doListCount().post(vm.srch).$promise;

      prms.then(
        function (data) {
          console.log('customerarmy', data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt > 0) {
              vm.totalItems = data.responseVO.body.docs[0];
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.error('Error-getList', status, data);
        }
      ); */
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.CustArmyIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.CustArmyIds.push(vm.lists[i].CustArmyId);
        }
      }

      /*var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);
        });
        
        vm.data['uploadFileList'] = uploadFileList;*/
      vm.dataloader = true;

      if (vm.data.CustArmyIds == null || vm.data.CustArmyIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'Customerarmy.deleteCustomerarmyDetailBatch';

      postApi.update(
        vm.data,
        function (data) {
          vm.dataloader = false;
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );

      /* var prms = api.doDelete().post(vm.data).$promise;

      prms.then(
        function (data) {
          vm.dataloader = false;
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },

        function (data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }
      ); */
    }

    // 목록 삭제
    function updateLinkageYNList() {
      gConfirm(
        '',
        '연동완료처리 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            LinkageYNListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function LinkageYNListAction() {
      vm.data.CustArmyIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.CustArmyIds.push(vm.lists[i].CustArmyId);
        }
      }

      if (vm.data.CustArmyIds == null || vm.data.CustArmyIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.dataloader = true;
      vm.data.mapCode = 'Customerarmy.updateCustomerarmyLinkage';

      postApi.update(
        vm.data,
        function (data) {
          vm.dataloader = false;

          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '연동완료처리 되었습니다.', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );

      /* var prms = api.doUpdateLinkage().post(vm.data).$promise;

      prms.then(
        function (data) {
          vm.dataloader = false;

          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '연동완료처리 되었습니다.', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },

        function (data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }
      ); */
    }

    // 모달팝업 호출 (상담신청등록자)
    function showModalCounselAppliRegUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CounselAppliRegUser_ = okData.UserNm;
          vm.srch.CounselAppliRegUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담신청등록자)
    function clearModalCounselAppliRegUser() {
      vm.srch.CounselAppliRegUser_ = '';
      vm.srch.CounselAppliRegUser = '';
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CounselUser_ = okData.UserNm;
          vm.srch.CounselUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.srch.CounselUser_ = '';
      vm.srch.CounselUser = '';
    }

    // 모달팝업 호출 (등록자)
    function showModalCustArmyRegUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CustArmyRegUser_ = okData.UserNm;
          vm.srch.CustArmyRegUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCustArmyRegUser() {
      vm.srch.CustArmyRegUser_ = '';
      vm.srch.CustArmyRegUser = '';
    }

    // 모달팝업 호출 (이메일)
    function showModalEmail() {
      var ctrl = 'EmailModalCtrl as modalCtrl';
      var paramData = {};
      paramData.CustArmyIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          paramData.CustArmyIds.push(vm.lists[i].CustArmyId);
        }
      }

      if (paramData.CustArmyIds == null || paramData.CustArmyIds.length == 0) {
        gAlert('', '선택된 고객이 없습니다.');
        return false;
      }

      var modalInstance = modalFactory.open('modal', 'app/modal/email-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          //console.log('okData');
          gAlert('', '선택된 고객에게 이메일이 발송되었습니다. \n\r(이메일이 입력된 고객만 발송됩니다.)');
          $state.reload();
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 페이징 관련
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '고객목록';
      log.ScreenUrl = 'app/customer/customerarmy-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        //console.log(data);
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );

      /*  var prms = api.doDownloadCheckYn().post(vm.srch).$promise;

      prms.then(
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt > 0) {
              vm.DownloadCheckYn = data.responseVO.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.error('Error-getDownloadCheckYn', status, data);
        }
      ); */
    }

    /**
     * Excel 파일 다운로드
     * @param
     * @return
     */
    /* function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', 'Menu.데이터가 없습니다.');
        return;
      }

      var a = document.createElement('a');
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      var excelHeader = [
        ['일련번호', 'MM_NO'],
        ['아이디', 'ArmyId'],
        ['소속부대', 'PermStat'],
        ['성명', 'CustNm'],
        ['군번', 'ArmyNo'],
        ['계급', 'ArmyClass'],
        ['군별', 'ArmyType'],
        ['소속부대_사단', 'PermStat1'],
        ['소속부대_연대', 'PermStat2'],
        ['상담희망분야_1차', 'HopeField1'],
        ['상담희망분야_2차', 'HopeField2'],
        ['희망지역', 'CounselLoc'],
        ['희망직종', 'HopeJobType'],
        ['희망지역', 'CounselLoc2'],
        ['희망직종', 'HopeJobType2'],
        ['상담가능연락처(부대실무자)', 'CounselAbleTel'],
        ['희망급여(만원)', 'HopeAmt'],
        ['1차상담희망일', 'FirstHopeDate'],
        ['상담신청등록자', 'CounselAppliRegUser'],
        ['상담신청등록일', 'CounselAppliRegDate'],
        ['1차상담확정일', 'FirstDecDate'],
        ['1차상담확정시', 'FirstDecHour'],
        ['상담사', 'CounselUser'],
        ['상담승인일', 'ApprDate'],
        ['상담승인자', 'ApprUser'],
        ['상담분야_대분류', 'CounselField1'],
        ['상담분야_중분류', 'CounselField2'],
        ['전역후상담희망지역', 'OutArmyCounselLoc'],
        ['상담메모', 'CounselMemo'],
        ['병과및특기', 'Spec'],
        ['임관/입대일', 'InArmyDate'],
        ['전역일', 'OutArmyDate'],
        ['휴대폰', 'Mobile'],
        ['전역후연락가능번호', 'OutArmyTel'],
        ['이메일', 'Email'],
        ['우편번호', 'Zipcode'],
        ['주소', 'Addr1'],
        ['상세주소', 'Addr2'],
        ['추가메모정보', 'AddMemo'],
        ['학력', 'LastEdu'],
      ];

      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];
            var columnHeader = [];
            var columnData;

            angular.forEach(excelHeader, function (head) {
              columnHeader.push(head[0]);
            });
            obj.push(columnHeader);
            angular.forEach($scope.jsonToExport, function (data) {
              columnData = [];
              angular.forEach(excelHeader, function (head) {
                if (!isNullOrEmpty(data[head[1]])) {
                  columnData.push(data[head[1]]);
                } else {
                  columnData.push('');
                }
              });
              obj.push(columnData);
            });

            $scope.exportData = obj;

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        },
        function (error) {
          // 조회 중 오류 발생
          console.error('Error> getExcelFile()');
          console.table(error);
        }
      );
    } */

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '일련번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MM_NO';
      header.push(obj);

      obj = {};
      obj.title = '아이디';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyId';
      header.push(obj);

      obj = {};
      obj.title = '소속부대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat';
      header.push(obj);

      obj = {};
      obj.title = '성명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CustNm';
      header.push(obj);

      obj = {};
      obj.title = '군번';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyNo';
      header.push(obj);

      obj = {};
      obj.title = '계급';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyClass';
      header.push(obj);

      obj = {};
      obj.title = '군별';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyType';
      header.push(obj);

      obj = {};
      obj.title = '소속부대_사단';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat1';
      header.push(obj);

      obj = {};
      obj.title = '소속부대_연대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat2';
      header.push(obj);

      obj = {};
      obj.title = '상담희망분야_1차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeField1';
      header.push(obj);

      obj = {};
      obj.title = '상담희망분야_2차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeField2';
      header.push(obj);

      obj = {};
      obj.title = '희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselLoc';
      header.push(obj);

      obj = {};
      obj.title = '희망직종';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeJobType';
      header.push(obj);

      obj = {};
      obj.title = '희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselLoc2';
      header.push(obj);

      obj = {};
      obj.title = '희망직종';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeJobType2';
      header.push(obj);

      obj = {};
      obj.title = '상담가능연락처(부대실무자)';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselAbleTel';
      header.push(obj);

      obj = {};
      obj.title = '희망급여(만원)';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'HopeAmt';
      header.push(obj);

      obj = {};
      obj.title = '1차상담희망일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'FirstHopeDate';
      header.push(obj);

      obj = {};
      obj.title = '상담신청등록자';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselAppliRegUser';
      header.push(obj);

      obj = {};
      obj.title = '상담신청등록일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselAppliRegDate';
      header.push(obj);

      obj = {};
      obj.title = '1차상담확정일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'FirstDecDate';
      header.push(obj);

      obj = {};
      obj.title = '1차상담확정시';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'FirstDecHour';
      header.push(obj);

      obj = {};
      obj.title = '상담사';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselUser';
      header.push(obj);

      obj = {};
      obj.title = '상담승인일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ApprDate';
      header.push(obj);

      obj = {};
      obj.title = '상담승인자';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ApprUser';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_대분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField1';
      header.push(obj);

      obj = {};
      obj.title = '상담분야_중분류';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField2';
      header.push(obj);

      obj = {};
      obj.title = '전역후상담희망지역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'OutArmyCounselLoc';
      header.push(obj);

      obj = {};
      obj.title = '상담메모';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselMemo';
      header.push(obj);

      obj = {};
      obj.title = '병과및특기';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Spec';
      header.push(obj);

      obj = {};
      obj.title = '임관/입대일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'InArmyDate';
      header.push(obj);

      obj = {};
      obj.title = '전역일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'OutArmyDate';
      header.push(obj);

      obj = {};
      obj.title = '휴대폰';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Mobile';
      header.push(obj);

      obj = {};
      obj.title = '전역후연락가능번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'OutArmyTel';
      header.push(obj);

      obj = {};
      obj.title = '이메일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Email';
      header.push(obj);

      obj = {};
      obj.title = '우편번호';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Zipcode';
      header.push(obj);

      obj = {};
      obj.title = '주소';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Addr1';
      header.push(obj);

      obj = {};
      obj.title = '상세주소';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Addr2';
      header.push(obj);

      obj = {};
      obj.title = '추가메모정보';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'AddMemo';
      header.push(obj);

      obj = {};
      obj.title = '학력';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'LastEdu';
      header.push(obj);

      obj = {};
      obj.title = '신청취소일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'AplyRtrcnYmd';
      header.push(obj);
      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '고객 목록';

      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl(
          '/excel/Customerarmy.getExcelCustomerarmyList/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    // 엑셀 다운로드
    function getExcelForWork() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '*성명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CustNm';
      header.push(obj);

      obj = {};
      obj.title = '*생년월일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ResRegNo';
      header.push(obj);

      obj = {};
      obj.title = '군번';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyNo';
      header.push(obj);

      obj = {};
      obj.title = '*회사명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyNm';
      header.push(obj);

      obj = {};
      obj.title = '*부서명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyDept';
      header.push(obj);

      obj = {};
      obj.title = '*취업형태';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyWorkType';
      header.push(obj);

      obj = {};
      obj.title = '*직급';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyClass';
      header.push(obj);

      obj = {};
      obj.title = '*직책';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyJobTitle';
      header.push(obj);

      obj = {};
      obj.title = '취업확인일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyRegDate';
      header.push(obj);

      obj = {};
      obj.title = '*취업직종';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyType';
      header.push(obj);

      obj = {};
      obj.title = '*입사일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyJoinDate';
      header.push(obj);

      obj = {};
      obj.title = '*급여(만원)';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyAmt';
      header.push(obj);

      obj = {};
      obj.title = '취업세부직종';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyTypeValue';
      header.push(obj);

      obj = {};
      obj.title = '*고용형태';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyEmploy';
      header.push(obj);

      obj = {};
      obj.title = '행사참여';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'test_01';
      header.push(obj);

      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '취업정보목록';

      $http({
        url: 'excel/Customerarmy.getExcelCustomerarmyListForWork/action.json',
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    vm.setSortColumn = function (sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = 'ASC';
      } else {
        //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getList();
    };

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    vm.setSortDirect = function (sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    };

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getList();
  },
]);

webapp.controller('JobinfoarmyDetailCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  function JobinfoarmyDetailCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    postApi,
    gAlert,
    gConfirm
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('jobinfoarmy-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnEdit = isPageAccess('jobinfoarmy-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnEmail = true;
    $scope.showBtnDel = true;

    // 함수 연결
    vm.deleteDetail = deleteDetail;

    // 검색 데이터
    vm.srch = {
      JobInfoId: $stateParams.JobInfoId,
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'jobinfoarmy',
    };

    // 조회 데이터 (휘발성 데이터)
    vm.data = {};

    // 조회
    function getData() {
      if (vm.srch.JobInfoId === null || vm.srch.JobInfoId === '') {
        return;
      }

      vm.srch.mapCode = 'Jobinfoarmy.getJobinfoarmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].CustArmyId !== null) {
              vm.data = data.body.docs[0];
              $scope.dtRegDate = setNewDate(vm.data.RegDate);
              $scope.dtCompanyJoinDate = setNewDate(vm.data.CompanyJoinDate);
              $scope.dtCompanyRegDate = setNewDate(vm.data.CompanyRegDate);

              vm.CompanyWorkTypeList = [];
              //코드 가져오기
              postApi.api('extSelect/Linkage.getEventCodeList/action', vm.srch, function (data) {
                if (data.header.status === CONSTANT.HttpStatus.OK) {
                  if (data.body.docCnt > 0) {
                    vm.CompanyWorkTypeList = data.body.docs;
                    vm.data.CompanyWorkType_ = vm.CompanyWorkTypeList.reduce(function (acc, cur) {
                      if (cur.Code === vm.data.CompanyWorkType) return acc + cur.CodeValue;
                      return acc + '';
                    }, '');
                  }
                }
              });

              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.srch.JobInfoId === null || vm.srch.JobInfoId === '') {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      vm.data.mapCode = 'Jobinfoarmy.deleteJobinfoarmyDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.go('app.customer.jobinfoarmy-list');
              },
            });
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    getData();
  },
]);

webapp.controller('JobinfoarmyEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  '$sce',
  '$timeout',
  function JobinfoarmyEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    $sce,
    $timeout
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('jobinfoarmy-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 함수 연결
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    /* vm.serchArmyId = serchArmyId; */
    vm.chkJobDupMM_NO = chkJobDupMM_NO;
    vm.showModalCustInfo = showModalCustInfo;
    vm.clearModalCustInfo = clearModalCustInfo;
    vm.setDataMemberHistory = setDataMemberHistory;

    vm.getData = getData;
    vm.setData = setData;
    vm.disabledArea = false;
    $scope.HopeJobTypeListShow = true;
    $scope.HopeJobTypeEtcShow = false;
    $scope.HopeJobTypeListShow2 = true;
    $scope.HopeJobTypeEtcShow2 = false;
    $scope.HopeDutyListShow = false;
    $scope.HopeDutyListShow2 = false;
    $scope.HopeLocListShow1 = false;
    $scope.HopeLocListShow2 = false;
    $scope.HopeLocListShow3 = false;
    $scope.HopeLocListShow4 = false;
    $scope.HopeDutyEtcShow = false;
    $scope.HopeDutyEtcShow2 = false;
    $scope.CompanyRegDateReadOnly = false;

    // 페이징
    //vm.page = $stateParams.page;

    /* 2026-04-01 유지보수 4-2 가.위촉상담사 취업권한 부여
    if ($window.sessionStorage['loginUserType'] == '030') {
      gAlert('', '취업등록 권한이 없습니다.', {
        btn: '',
        fn: function () {
          window.history.back();
        },
      });
    }
    */

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    /*  vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyWorkTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1240',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1250',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyEmployList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1260',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    // 기업구분
    vm.CompanyGuBunList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1340',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    // 고용형태구분
    vm.CompanyEmployGuBunList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1350',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.data.ArmyClass = data.Code;
      } else if (data.CodeType == '1240') {
        vm.data.CompanyWorkType = data.Code;
      } else if (data.CodeType == '1250') {
        vm.data.CompanyType = data.Code;
        vm.data.CompanyTypeValue = data.CodeValue;
      } else if (data.CodeType == '1260') {
        vm.data.CompanyEmploy = data.Code;
      } else if (data.CodeType == '1340') {
        vm.data.CompanyGuBun = data.Code;
      } else if (data.CodeType == '1350') {
        vm.data.CompanyEmployGuBun = data.Code;
      }
    };

    vm.onArmyAreaListSelected = function () {
      if (vm.data.ArmyArea == '') {
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }
      vm.PermStat1List.ArmyArea = vm.data.ArmyArea;
      vm.ArmyTypeList.ArmyArea = vm.data.ArmyArea;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {

      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.ArmyType = '';
        return;
      }

      vm.data.ArmyType = data.Code;

      //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
      vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      // console.log('onPermStat1ListSelected=', data);

      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.PermStat1 = '';
        return;
      }

      vm.data.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.data.HopeField1 = '';
        return;
      }

      vm.data.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      if (vm.data.HopeField1 == '2' || vm.data.HopeField1 == '3' || vm.data.HopeField1 == '0') {
        $scope.HopeJobTypeListShow = false;
        $scope.HopeJobTypeListShow2 = false;
        $scope.HopeJobTypeEtcShow = false;
        $scope.HopeJobTypeEtcShow2 = false;
        vm.data.HopeJobType = '';
        vm.data.HopeJobTypeEtc = '';
        vm.data.HopeJobType2 = '';
        vm.data.HopeJobTypeEtc2 = '';
      } else {
        if (vm.data.HopeJobType == '110') {
          $scope.HopeJobTypeEtcShow = true;
        }
        if (vm.data.HopeJobType2 == '110') {
          $scope.HopeJobTypeEtcShow2 = true;
        }
        $scope.HopeJobTypeListShow = true;
        $scope.HopeJobTypeListShow2 = true;
      }
      if (vm.data.HopeField1 == '0') {
        $scope.HopeAmtShow = false;
      } else {
        $scope.HopeAmtShow = true;
      }
    };

    vm.onHopeField2ListSelected = function (data) {
      if (vm.data.HopeField1 != '0') {
        vm.data.HopeField2 = '';
        vm.HopeField2ListShow = false;
        //return;
      } else {
        vm.data.HopeField2 = data.Code;
        vm.HopeField2ListShow = true;
      }
    };

    // 검색 데이터
    vm.srch = {
      JobInfoId: $stateParams.JobInfoId === undefined ? 0 : $stateParams.JobInfoId,
      TenantId: $window.sessionStorage['loginTenantId'],
      BranchId: $window.sessionStorage['loginBranchId'],
      BranchNm: $window.sessionStorage['loginBranchName'],
      TableNm: 'jobinfo',
    };

    vm.CompanyWorkTypeList = [];

    postApi.api('extSelect/Linkage.getEventCodeList/action', vm.srch, function (data) {
      if (data.header.status === CONSTANT.HttpStatus.OK) {
        if (data.body.docCnt > 0) {
          vm.CompanyWorkTypeList = data.body.docs;
        }
      }
    });

    // 조회 데이터 (휘발성 데이터)
    vm.data = {};
    vm.data.oldFirstDecDate = '';

    // 기본값
    if (vm.srch.JobInfoId == 0 || vm.srch.JobInfoId == '' || typeof vm.srch.JobInfoId == 'undefined') {
      $scope.dtRegDate = setNewDate(getToday());
      vm.data.CounselUser = $window.sessionStorage['loginUserIdx'];
      vm.data.CounselUser_ = $window.sessionStorage['loginUserName'];
    }

    // 유효성검사
    function chkValid() {
      if (typeof vm.data.MM_NO == 'undefined' || vm.data.MM_NO == '') {
        gAlert('', '고객정보를 검색해 주세요', {
          fn: function () {
            vm.showModalCustInfo();
          },
        });
        angular.element('input[ng-model="vc.data.ArmyId"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyId == 'undefined' || vm.data.ArmyId == '') {
        gAlert('', '아이디를 입력해주세요');
        angular.element('input[ng-model="vc.data.ArmyId"]').focus();
        return false;
      }

      if (typeof vm.data.CustNm == 'undefined' || vm.data.CustNm == '') {
        gAlert('', '성명을 입력해주세요');
        angular.element('input[ng-model="vc.data.CustNm"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요', {
          fn: function () {
            vm.showModalCustInfo('ArmyNo');
          },
        });
        angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        gAlert('', '계급을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyClassList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.ArmyArea == 'undefined' || vm.data.ArmyArea == '') {
        gAlert('', '권역을 선택해주세요');
        angular.element('select[ng-model="vc.data.ArmyArea"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
        gAlert('', '군별을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyTypeList"]').children('select').focus();
        return false;
      }

      /*
      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
        gAlert('', '소속부대를 선택해주세요');
        angular.element('common-code[param-data="vc.PermStat1List"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
        gAlert('', '소속부대2를 입력해주세요');
        angular.element('input[ng-model="vc.data.PermStat2"]').focus();
        return false;
      }
        */

      if (typeof vm.data.HopeField1 == 'undefined' || vm.data.HopeField1 == '') {
        gAlert('', '상담희망분야를 선택해주세요');
        angular.element('common-code[param-data="vc.HopeField1List"]').children('select').focus();
        return false;
      }

      if (vm.data.HopeField1 == '040') {
        if (typeof vm.data.HopeField2 == 'undefined' || vm.data.HopeField2 == '') {
          gAlert('', '상담희망분야를 선택해주세요');
          angular.element('common-code[param-data="vc.HopeField2List"]').children('select').focus();
          return false;
        }
      }

      if (typeof vm.data.CounselUser == 'undefined' || vm.data.CounselUser == '') {
        gAlert('', '상담사를 선택해주세요', {
          fn: function () {
            vm.showModalCounselUser();
          },
        });
        angular.element('input[ng-model="vc.data.CounselUser_"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyNm == 'undefined' || vm.data.CompanyNm == '') {
        gAlert('', '회사명을 입력해주세요');
        angular.element('input[ng-model="vc.data.CompanyNm"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyDept == 'undefined' || vm.data.CompanyDept == '') {
        gAlert('', '부서를 입력해 주세요');
        angular.element('input[ng-model="vc.data.CompanyDept"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyGuBun == 'undefined' || vm.data.CompanyGuBun == '') {
        gAlert('', '기업구분을 선택해 주세요');
        angular.element('common-code[param-data="vc.CompanyGuBunList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CompanyWorkType == 'undefined' || vm.data.CompanyWorkType == '') {
        gAlert('', '취업형태를 선택해 주세요');
        angular.element('common-code[param-data="vc.CompanyWorkTypeList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CompanyClass == 'undefined' || vm.data.CompanyClass == '') {
        gAlert('', '직급을 입력해 주세요');
        angular.element('input[ng-model="vc.data.CompanyClass"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyJobTitle == 'undefined' || vm.data.CompanyJobTitle == '') {
        gAlert('', '직책을 입력해 주세요');
        angular.element('input[ng-model="vc.data.CompanyJobTitle"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyRegDate == 'undefined' || vm.data.CompanyRegDate == '') {
        gAlert('', '취업확인일을 입력해 주세요');
        angular.element('input[ng-model="dtCompanyRegDate"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyType == 'undefined' || vm.data.CompanyType == '' || vm.data.CompanyType == ' ') {
        gAlert('', '취업직종을 선택해 주세요');
        angular.element('common-code[param-data="vc.CompanyTypeList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CompanyAmt == 'undefined' || vm.data.CompanyAmt == '') {
        gAlert('', '연봉을 입력해 주세요');
        angular.element('input[ng-model="vc.data.CompanyAmt"]').focus();
        return false;
      }

      var regexp = /^[0-9]*$/;
      if (!regexp.test(vm.data.CompanyAmt)) {
        gAlert('', '연봉은 숫자만 입력가능합니다');
        angular.element('input[ng-model="vc.data.CompanyAmt"]').focus();
        return false;
      }

      if (vm.data.CompanyAmt.length < 3 || vm.data.CompanyAmt.length > 5) {
        gAlert('', '연봉을 3~5자리로 입력해 주세요');
        angular.element('input[ng-model="vc.data.CompanyAmt"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyJoinDate == 'undefined' || vm.data.CompanyJoinDate == '') {
        gAlert('', '입사일을 입력해 주세요');
        angular.element('input[ng-model="dtCompanyJoinDate"]').focus();
        return false;
      }

      if (typeof vm.data.CompanyEmploy == 'undefined' || vm.data.CompanyEmploy == '') {
        gAlert('', '고용형태를 선택해 주세요');
        angular.element('common-code[param-data="vc.CompanyTypeList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.CompanyEmployGuBun == 'undefined' || vm.data.CompanyEmployGuBun == '') {
        gAlert('', '고용형태구분을 선택해 주세요');
        angular.element('common-code[param-data="vc.CompanyEmployGuBunList"]').children('select').focus();
        return false;
      }

      return true;
    }

    function getTenantArea() {
      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var list = data.body.docs[0].TenantArea.split(',');
              vm.ArmyAreaList = list.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.data.ArmyArea = vm.ArmyAreaList[0].Code;
              }
            } else {
              vm.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );
    }

    // 조회
    function getData() {
      if (vm.srch.JobinfoId === null || vm.srch.JobinfoId === '' || vm.srch.JobInfoId === undefined) {
        return;
      }

      vm.dataloader = true;

      vm.srch.mapCode = 'Jobinfoarmy.getJobinfoarmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].JobInfoId !== null) {
              vm.data = data.body.docs[0];

              vm.data.p_MH_COMPANY_ORG = vm.data.CompanyNm;
              if ($rootScope.gVariable.TenantId == 1) {
                vm.data.CompanyWorkType = '12';
              }

              // 수동 메핑 항목 설정
              vm.ArmyClassList.Code = vm.data.ArmyClass;
              vm.ArmyTypeList.Code = vm.data.ArmyType;
              vm.PermStat1List.Code = vm.data.PermStat1;
              vm.HopeField1List.Code = vm.data.HopeField1;
              vm.HopeField2List.Code = vm.data.HopeField2;
              vm.CompanyTypeList.Code = vm.data.CompanyType;
              vm.CompanyWorkTypeList.Code = vm.data.CompanyWorkType;
              vm.CompanyEmployList.Code = vm.data.CompanyEmploy;
              vm.CompanyGuBunList.Code = vm.data.CompanyGuBun;
              vm.CompanyEmployGuBunList.Code = vm.data.CompanyEmployGuBun;
              vm.data.CompanyWorkType_ = vm.CompanyWorkTypeList.reduce(function (acc, cur) {
                if (cur.Code === vm.data.CompanyWorkType) return acc + cur.CodeValue;
                return acc + '';
              }, '');

              // 취업확인일 교육원 권한 가진 사용자만 수정가능하도록 수정 2019-06-11 김준권
              if (
                typeof vm.data.CompanyRegDate == 'undefined' ||
                vm.data.CompanyRegDate == '' ||
                $window.sessionStorage['loginUserType'] == '020'
              ) {
                $scope.CompanyRegDateReadOnly = false;
              } else {
                $scope.CompanyRegDateReadOnly = true;
              }

              vm.data.isDupArmyNo = 'N';

              $scope.dtRegDate = setNewDate(vm.data.RegDate);
              $scope.dtCompanyJoinDate = setNewDate(vm.data.CompanyJoinDate);
              $scope.dtCompanyRegDate = setNewDate(vm.data.CompanyRegDate);
              $timeout(function () {
                vm.dataloader = false;
              }, 500);
              return;
            }
          } else {
            gAlert('', '회원정보를 불러오는데 실패하였습니다.', {
              fn: function () {
                $timeout(function () {
                  vm.dataloader = false;
                }, 500);
              },
            });
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          $timeout(function () {
            vm.dataloader = false;
          }, 500);
        }
      );
    }

    // 저장버튼 더블클릭 방지용 변수 선언 2020-02-19 김준권
    vm.saveButtonDisable = false;
    // 저장
    function setData() {
      if (!chkValid()) return false;

      vm.data.mapCode = 'Jobinfoarmy.chkDupleData';

      postApi.select(vm.data, function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].isDuple == 1 && vm.data.p_MH_COMPANY_ORG != vm.data.CompanyNm) {
            gAlert('', '해당 장병은 동일년도, 동일사업장에 취업등록된 이력이 있습니다.<br/>등록된 이력을 확인하세요.', {
              fn: function () {
                showModalEmployHistory(vm.data.MM_NO);
              },
            });
          } else {
            vm.saveButtonDisable = true;

            vm.data.JobInfoId = vm.srch.JobInfoId;
            vm.data.TableNm = vm.srch.TableNm;

            var successCallback = function (data) {

              if (data.header.status === CONSTANT.HttpStatus.OK) {
                /* 2026-04-01 유지보수 4-2 나. 운영업무시스템 연동 변경(연동->미연동)
                * 취업컨설팅 사업 관련 요청이었으나 신규시스템 개발 예정으로 인하여 모든 사업 및 모든 권한에서 미연동
                if (typeof vm.data.CompanyNm != 'undefined' && vm.data.CompanyNm != '') {
                  // 로컬 테스트가 아닌 경우에만 업무시스템과 연동 2019-03-20 김준권
                  if (document.location.host != 'localhost:8080' && document.location.host != 'localhost:3000') {
                    setDataMemberHistory(); // 업무 시스템 연동
                  }
                }
                */
                gAlert('', 'Menu.SAVED', {
                  btn: '',
                  fn: function () {
                    $state.go('app.customer.jobinfoarmy-list');
                  },
                });
                return;
              }
              gAlert('', data.body.docs[0].errMessage);
            };

            var errorCallback = function (data) {
              console.log("error");
              // console.error('Error-setData', status, data);
              gAlert('', data.body.docs[0].errMessage);
            };

            if (vm.srch.JobInfoId == 0) {
              // 등록
              vm.data.mapCode = 'Jobinfoarmy.insertJobinfoarmyDetail';
              postApi.insert(vm.data, successCallback, errorCallback);
            } else {
              // 수정
              vm.data.mapCode = 'Jobinfoarmy.updateJobinfoarmyDetail';
              postApi.update(vm.data, successCallback, errorCallback);
            }
          }
        }
      });
    }

    // 취업현황 업무 연동
    function setDataMemberHistory() {
      vm.data.RegUser = vm.data.ArmyArea;

      var linkObj = {
        p_MH_CUST_ARMY_ID: vm.data.CustArmyId,
        p_MH_NO: vm.data.MM_NO,
        p_MH_KNM: vm.data.CustNm,
        p_MH_COMPANY: vm.data.CompanyNm,
        p_MH_DEPT: vm.data.CompanyDept,
        p_MH_JIK_CD: vm.data.CompanyClass,
        p_MH_TITLE_CD: vm.data.CompanyJobTitle,
        p_MH_PAY: vm.data.CompanyAmt,
        p_MH_WORK: vm.data.CompanyTypeValue,
        p_MH_WORK_CD: vm.data.CompanyType,
        p_MH_ENT_YMD: vm.data.CompanyJoinDate,
        p_MH_WORK_TYPE: vm.data.CompanyWorkType,
        p_MH_EMPLOY: vm.data.CompanyEmploy,
        p_MH_EMPLOY_GUBUN: vm.data.CompanyEmployGuBun == '4' ? '002' : '001', // 2024-10-18 유지보수 10-1. 창업인 경우 창업, 그외 취업
        p_REG_DATE: vm.data.CompanyRegDate,
        p_REG_USER: vm.data.RegUser,
        p_MH_COMPANY_TYPE: vm.data.CompanyGuBun,
      };

      if (vm.data.p_MH_COMPANY_ORG) linkObj.p_MH_COMPANY_ORG = vm.data.p_MH_COMPANY_ORG;

      postApi.api(
        'ext/MemberHistoryData',
        linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.mapCode = 'Customerarmy.updateCustomerarmyLinkage';

            postApi.update(
              vm.data,
              function (json) {
                if (json.header.status === CONSTANT.HttpStatus.OK) {
                }
              },
              function (json) {}
            );
            return;
          } else {
            gAlert('', '업무시스템과의 연동에 실패 했습니다.');
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-setDataMemberHistory' + data.body.docs[0].errMessage);
        }
      );
    }

    // 유효성검사
    function chkJobDupMM_NO() {
      vm.data.mapCode = 'Jobinfoarmy.getChkJobDupMM_NO';
      postApi.select(
        vm.data,
        function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (parseInt(data.body.docs[0].MM_NODupCnt) == 0) {
              gAlert('', '이미 등록된 고객입니다.');
              return false;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('lg', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.CounselUser_ = okData.UserNm;
          vm.data.CounselUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.data.CounselUser_ = '';
      vm.data.CounselUser = '';
    }

    // 아이디로 검색
    /* function serchArmyId() {
      postApi.api(
        'extSelect/Linkage.getCustomerInfoByID/action',
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            console.log('GoojikApiById = ', data.body.docs[0]);
            if (data.body.docCnt === 0) {
              gAlert('', '등록정보가 없습니다.');
              return;
            } else {
              vm.data.MM_NO = data.body.docs[0].MM_NO;
              vm.data.ArmyNo = data.body.docs[0].MM_ARMY_GUNBUN;

              vm.data.mapCode = 'Jobinfoarmy.getChkJobDupMM_NO';

              postApi.select(
                vm.data,
                function (json) {
                  if (json.header.status === CONSTANT.HttpStatus.OK) {
                    if (parseInt(json.body.docs[0].JobDupCnt) != 0) {
                      gAlert('', '취업등록된 이력이 있습니다. 등록된 이력을 확인하세요.', {
                        fn: function () {
                          showModalEmployHistory(vm.data.MM_NO);
                        },
                      });
                      vm.data.MM_NO = '';
                      vm.data.CustNm = '';
                      vm.data.ArmyId = '';
                      vm.data.ArmyNo = '';
                      vm.data.ResRegNo = '';
                      vm.data.Mobile = '';
                      vm.data.Email = '';
                      document.getElementById('dtInArmyDate').value = '';
                      vm.data.InArmyDate = '';
                      document.getElementById('dtOutArmyDate').value = '';
                      vm.data.OutArmyDate = '';
                      vm.ArmyClassList.Code = '';
                      vm.ArmyTypeList.Code = '';
                      vm.SpecList.Code = '';
                      vm.data.Spec = '';
                      vm.data.PermStat = '';
                      document.getElementById('txtZipcode').value = '';
                      document.getElementById('txtAddr1').value = '';
                      vm.data.Addr2 = '';
                      vm.HopeField1List.Code = '';
                      vm.CounselLocList.Code = '';
                      vm.CounselLocList2.Code = '';
                      vm.HopeJobTypeList.Code = '';
                      vm.HopeJobTypeList2.Code = '';
                      return true;
                    } else if (parseInt(json.body.docs[0].JobDupCnt) == 0) {
                      gAlert('', '등록된 정보를 불러옵니다.');
                      vm.data.TenantId = data.body.docs[0].TenantId;
                      vm.data.MM_NO = data.body.docs[0].MM_NO;
                      vm.data.CustNm = data.body.docs[0].MM_KNM;
                      vm.data.ArmyNo = data.body.docs[0].MM_ARMY_GUNBUN;
                      vm.ArmyClassList.Code = data.body.docs[0].MM_ARMY_RANKS;
                      vm.ArmyTypeList.Code = data.body.docs[0].MM_ARMY_GUNBUL;
                      vm.HopeField1List.Code = data.body.docs[0].MM_JOB_CHK;
                      vm.PermStat1List.Code = data.body.docs[0].PermStat1;
                      vm.data.ArmyArea = data.body.docs[0].ArmyArea;
                      vm.data.PermStat2 = data.body.docs[0].PermStat2;
                      vm.data.PermStat = data.body.docs[0].MM_UNIT;
                      return true;
                    }
                  }
                  gAlert('', json.body.docs[0].errMessage);
                },
                function (json) {
                  console.error('Error-setData', status, data);
                  gAlert('', json.body.docs[0].errMessage);
                }
              );
            }
          }
        },
        function (data) {
          console.error('Error-serchArmyId' + data.body.docs[0].errMessage);
        }
      );
    }*/

    //사용자 취업 이력 목록 팝업
    function showModalEmployHistory(data) {
      var ctrl = 'EmployHistoryModalCtrl as modalCtrl';
      var paramData = { p_MM_NO: data };

      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/jobinfoarmy/employhistory-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {},
        function (cancelData) {}
      );
    }

    // 모달팝업 호출 (고객정보)
    function showModalCustInfo(type) {
      var ctrl = 'CustarmyModalCtrl as modalCtrl';
      var paramData = { location: 'jobinfo' };
      if (type && type === 'ArmyNo') paramData.searchFieldType = type;
      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/customerarmy/custarmy-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.CustArmyId = okData.CustArmyId;
          vm.data.TenantId = okData.TenantId;
          vm.data.CustNm = okData.CustNm;
          vm.data.ArmyId = okData.ArmyId;

          if (okData.RetDate != null && okData.RetDate != '') {
            var pYear = okData.RetDate.substring(0, 4);
            var pMonth = okData.RetDate.substring(5, 6);
            var pDay = okData.RetDate.substring(7, 8);

            gAlert('', '해당 장병은 ' + pYear + '년 ' + pMonth + '월 ' + pDay + '일 홈페이지 탈퇴한 회원입니다.');
          } else {
            setArmyCustData(okData);
          }
        },
        function (cancelData) {}
      );
    }

    function setArmyCustData(okData) {
      vm.data.MM_NO = okData.MM_NO;
      vm.data.ArmyNo = okData.ArmyNo;
      vm.data.ArmyArea = okData.ArmyArea;
      vm.data.CustArmyId = okData.CustArmyId;

      vm.data.mapCode = 'Jobinfoarmy.getChkJobDupMM_NO';

      postApi.select(
        vm.data,
        function (json) {
          if (json.header.status === CONSTANT.HttpStatus.OK) {
            //올해에 취업등록이력 있어도 등록할 수 있도록 변경
            if (parseInt(json.body.docs[0].JobDupCnt) != 0) {
              gAlert('', '해당 장병은 올해 취업등록된 이력이 있습니다. 등록된 이력을 확인하세요.', {
                fn: function () {
                  showModalEmployHistory(okData.MM_NO);
                },
              });
              /* vm.data.MM_NO = '';
              vm.data.CustNm = '';
              vm.data.ArmyId = '';
              vm.data.ArmyNo = '';
              vm.data.ResRegNo = '';
              vm.data.Mobile = '';
              vm.data.Email = '';
              if (document.getElementById('dtInArmyDate').value != null)
                document.getElementById('dtInArmyDate').value = '';
              if (document.getElementById('dtOutArmyDate').value != null)
                document.getElementById('dtOutArmyDate').value = '';
              vm.data.OutArmyDate = '';
              vm.ArmyClassList.Code = '';
              vm.ArmyTypeList.Code = '';
              vm.SpecList.Code = '';
              vm.data.Spec = '';
              vm.data.PermStat = '';
              if (document.getElementById('txtZipcode').value != null) document.getElementById('txtZipcode').value = '';
              if (document.getElementById('txtAddr1').value != null) document.getElementById('txtAddr1').value = '';
              vm.data.Addr2 = '';
              vm.HopeField1List.Code = '';
              vm.CounselLocList.Code = '';
              vm.CounselLocList2.Code = '';
              vm.HopeJobTypeList.Code = '';
              vm.HopeJobTypeList2.Code = ''; */
              setCustData(okData);
              return true;
            } else if (parseInt(json.body.docs[0].JobDupCnt) == 0) {
              gAlert('', '등록된 정보를 불러옵니다.');
              setCustData(okData);
              return true;
            }
          }
          gAlert('', json.body.docs[0].errMessage);
        },
        function (json) {
          console.log("error");
          // console.error('Error-setData', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    function setCustData(okData) {
      var tmpArea = '';
      var tmpType = '';
      var tmpStat = '';
      angular.forEach(vm.ArmyAreaList, function (item) {
        if (item.Code === okData.ArmyArea) tmpArea = okData.ArmyArea;
      });

      var ArmyTypeOptionList = document.querySelector('common-code[param-data="vc.ArmyTypeList"]').children[0].children;
      angular.forEach(ArmyTypeOptionList, function (item) {
        if (item.value === okData.ArmyType) tmpType = okData.ArmyType;
      });

      var PermStatOptionList = document.querySelector('common-code[param-data="vc.PermStat1List"]').children[0]
        .children;
      angular.forEach(PermStatOptionList, function (item) {
        if (item.value === okData.PermStat1) tmpStat = okData.PermStat1;
      });

      vm.data.ArmyArea = tmpArea;
      vm.ArmyTypeList.Code = tmpType;
      vm.PermStat1List.Code = tmpStat;

      //vm.data.MM_NO = okData.MM_NO;
      vm.data.CustNm = okData.CustNm;
      //vm.data.ArmyNo = okData.MM_ARMY_GUNBUN;
      vm.ArmyClassList.Code = okData.ArmyClass;

      vm.HopeField1List.Code = okData.HopeField1;
      vm.data.PermStat2 = okData.PermStat2;
    }

    // 모달팝업 데이터 삭제 (고객정보)
    function clearModalCustInfo() {
      vm.data.MM_NO = '';
      vm.data.ArmyId = '';
      vm.data.CustNm = '';
      vm.data.ArmyNo = '';
      vm.ArmyClassList.Code = '';
      vm.ArmyAreaList.Code = '';
      vm.ArmyTypeList.Code = '';
      vm.PermStat1List.Code = '';
      vm.data.PermStat2 = '';
      vm.HopeField1List.Code = '';
      vm.HopeField2List.Code = '';
    }

    // 데이터 조회
    getTenantArea();
    if (vm.srch.JobInfoId != 0) {
      getData();
    } else {
      vm.data.JobInfoId = 0;
      if ($rootScope.gVariable.TenantId == 1) {
        vm.data.CompanyWorkType = '12';
      }
    }
  },
]);

webapp.controller('JobinfoarmyListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'gAlert',
  'gConfirm',
  '$http',
  'postApi',
  'StaticVariable',
  function JobinfoarmyListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    gAlert,
    gConfirm,
    $http,
    postApi,
    StaticVariable
  ) {
    var vm = this;
    var EXCEL_SQL = 'Jobinfoarmy.getExcelJobinfoarmyList';
    var EXCEL_TITLE = '취업 목록';

    // 접근 권한 체크
    if (!isPageAccess('jobinfoarmy-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    $scope.showBtnDel = true;
    $scope.showBtnLinkageYN = true;
    $scope.showBtnAdd = isPageAccess('jobinfoarmy-edit', $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.deleteList = deleteList;
    vm.getExcel = getExcel;
    vm.updateLinkageYNList = updateLinkageYNList;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
    vm.goAdd = goAdd;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    vm.srch.CompanyWorkTypeList = [];

    postApi.api('extSelect/Linkage.getEventCodeList/action', vm.srch, function (data) {
      if (data.header.status === CONSTANT.HttpStatus.OK) {
        vm.srch.CompanyWorkTypeList = data.body.docs;
      }
    });

    // 데이터
    vm.data = {};

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;
    vm.disabledArea = false;

    // 공통코드 정의
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    /* vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.HopeField1List = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1160',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.CompanyEmployList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1260',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.srch.ArmyClass = data.Code;
      } else if (data.CodeType == '1260') {
        vm.data.CompanyEmploy = data.Code;
      }
    };

    vm.onArmyAreaListSelected = function () {
      var data = vm.srch.ArmyAreaObj;
      if (data == null) {
        vm.srch.ArmyArea = '';
        vm.PermStat1List.ArmyArea = '';
        vm.ArmyTypeList.ArmyArea = '';
        return;
      }

      vm.srch.ArmyArea = data.Code;
      vm.PermStat1List.ArmyArea = data.Code;
      vm.ArmyTypeList.ArmyArea = data.Code;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;

      vm.srch.ArmyAreaType = data.Code;

      //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
      vm.PermStat1List.ParentCommonCodeId = vm.srch.ArmyAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.HopeField2List = {};

    vm.onHopeField1ListSelected = function (data) {
      vm.HopeField2List.CodeType = '';
      vm.HopeField2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.HopeField1 = '';
        return;
      }

      vm.srch.HopeField1 = data.Code;
      vm.HopeField2List.ParentCommonCodeId = data.CommonCodeId;

      if (vm.srch.HopeField1 == '040') {
        vm.HopeField2ListShow = true;
      } else {
        vm.HopeField2ListShow = false;
        vm.srch.HopeField2 = '';
      }
    };

    vm.onHopeField2ListSelected = function (data) {
      if (data == null) {
        vm.srch.HopeField2 = '';
        return;
      }

      vm.srch.HopeField2 = data.Code;
    };

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('jobinfoarmy-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/customer/jobinfoarmy-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/customer/jobinfoarmy-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/customer/jobinfoarmy-list') !== -1)
      ) {
        vm.srch =JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('jobinfoarmy-list-ctrl')));
        // vm.srch = JSON.parse($window.sessionStorage.getItem('jobinfoarmy-list-ctrl'));

        vm.srch.ArmyAreaObj = {
          Code: vm.srch.ArmyArea,
          CodeValue: vm.srch.ArmyArea,
        };
        vm.ArmyClassList.Code = vm.srch.ArmyClass;
        vm.ArmyTypeList.Code = vm.srch.ArmyType;
        vm.PermStat1List.Code = vm.srch.PermStat1;
        vm.PermStat2List.Code = vm.srch.PermStat2;
        vm.HopeField1List.Code = vm.srch.HopeField1;
        vm.HopeField2List.Code = vm.srch.HopeField2;

        if (vm.srch.RegDateFrom != null && vm.srch.RegDateFrom != '') {
          $scope.dtRegDateFrom = setNewDate(vm.srch.RegDateFrom);
        }
        if (vm.srch.RegDateTo != null && vm.srch.RegDateTo != '') {
          $scope.dtRegDateTo = setNewDate(vm.srch.RegDateTo);
        }
        if (vm.srch.CompanyRegDateFrom != null && vm.srch.CompanyRegDateFrom != '') {
          $scope.dtCompanyRegDateFrom = setNewDate(vm.srch.CompanyRegDateFrom);
        }
        if (vm.srch.CompanyRegDateTo != null && vm.srch.CompanyRegDateTo != '') {
          $scope.dtCompanyRegDateTo = setNewDate(vm.srch.CompanyRegDateTo);
        }
        if (vm.srch.CompanyJoinDateFrom != null && vm.srch.CompanyJoinDateFrom != '') {
          $scope.dtCompanyJoinDateFrom = setNewDate(vm.srch.CompanyJoinDateFrom);
        }
        if (vm.srch.CompanyJoinDateTo != null && vm.srch.CompanyJoinDateTo != '') {
          $scope.dtCompanyJoinDateTo = setNewDate(vm.srch.CompanyJoinDateTo);
        }
        vm.currentPage = vm.srch.page;
      }
    }

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      if (
        vm.srch.RegDateFrom != null &&
        vm.srch.RegDateFrom != '' &&
        vm.srch.RegDateTo != null &&
        vm.srch.RegDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.RegDateFrom) > getDateToNumber(vm.srch.RegDateTo)) {
          gAlert('', '등록일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }
      if (
        vm.srch.CompanyRegDateFrom != null &&
        vm.srch.CompanyRegDateFrom != '' &&
        vm.srch.CompanyRegDateTo != null &&
        vm.srch.CompanyRegDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.CompanyRegDateFrom) > getDateToNumber(vm.srch.CompanyRegDateTo)) {
          gAlert('', '취업확인일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }
      if (
        vm.srch.CompanyJoinDateFrom != null &&
        vm.srch.CompanyJoinDateFrom != '' &&
        vm.srch.CompanyJoinDateTo != null &&
        vm.srch.CompanyJoinDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.CompanyJoinDateFrom) > getDateToNumber(vm.srch.CompanyJoinDateTo)) {
          gAlert('', '입사일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }
      return true;
    }

    // 목록 조회
    function getList() {
      if (!chkValid()) return false;

      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          var resultData = postApi.makeResultData(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (resultData.body.docs[0] != null) {
              var areaList = resultData.body.docs[0].TenantArea.split(',');
              vm.ArmyAreaList = areaList.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };

                acc.push(obj);
                return acc;
              }, []);
              if (vm.ArmyAreaList.length === 1) {
                vm.srch.ArmyAreaObj = vm.ArmyAreaList[0];
                vm.srch.ArmyArea = vm.srch.ArmyAreaObj.Code;
              }
            } else {
              vm.ArmyAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList' + data.body.docs[0].errMessage);
        }
      );

      getListCount();

      vm.srch.page = vm.currentPage;
      $window.sessionStorage.setItem('jobinfoarmy-list-ctrl', angular.toJson(vm.srch));

      vm.srch.mapCode = 'Jobinfoarmy.getJobinfoarmyList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'Jobinfoarmy.getJobinfoarmyListCount';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs[0];
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.JobInfoIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.JobInfoIds.push(vm.lists[i].JobInfoId);
        }
      }

      if (vm.data.JobInfoIds == null || vm.data.JobInfoIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'Jobinfoarmy.deleteJobinfoarmyDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 목록 삭제
    function updateLinkageYNList() {
      gConfirm(
        '',
        '연동완료처리 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            LinkageYNListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function goAdd() {
      if ($window.sessionStorage['loginUserType'] == '030') {
        gAlert('', '취업등록 권한이 없습니다.');
        return;
      } else {
        $state.go('app.customer.jobinfoarmy-edit', { JobInfoId: '' });
      }
    }

    function LinkageYNListAction() {
      vm.data.CustArmyIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.CustArmyIds.push(vm.lists[i].CustArmyId);
        }
      }

      if (vm.data.CustArmyIds == null || vm.data.CustArmyIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'Customerarmy.updateCustomerarmyLinkage';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '연동완료처리 되었습니다.', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                $state.reload();
              },
            });
            //return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CounselUser_ = okData.UserNm;
          vm.srch.CounselUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.srch.CounselUser_ = '';
      vm.srch.CounselUser = '';
    }

    // 페이징 관련
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '취업목록';
      log.ScreenUrl = 'app/customer/jobinfoarmy-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    /**
     * Excel 파일 다운로드
     * @param
     * @return
     */
    /* function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', 'Menu.데이터가 없습니다.');
        return;
      }

      var a = document.createElement('a');
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      var excelHeader = [
        ['일련번호', 'rowNum'],
        ['성명', 'CustNm'],
        ['군번', 'ArmyNo'],
        ['생년월일', 'ResRegNo'],
        ['권역', 'ArmyArea_'],
        ['군별', 'ArmyType_'],
        ['계급', 'ArmyClass_'],
        ['소속부대1', 'PermStat1_'],
        ['소속부대2', 'PermStat2'],
        ['병과', 'Spec_'],
        ['상담분야1', 'CounselField1_'],
        ['상담분야2', 'CounselField2_'],
        ['상담사', 'CounselUser_'],
        ['등록일', 'RegDate'],
        ['취업처', 'CompanyNm'],
        ['부서', 'CompanyDept'],
        ['기업구분', 'CompanyGuBun_'],
        ['취업형태', 'CompanyWorkType_'],
        ['직급', 'CompanyClass'],
        ['직책', 'CompanyJobTitle'],
        ['취업확인일', 'CompanyRegDate'],
        ['취업직종', 'CompanyType_'],
        ['급여/연봉(만원)', 'CompanyAmt'],
        ['입사일', 'CompanyJoinDate'],
        ['고용형태', 'CompanyEmploy_'],
        ['고용형태구분', 'CompanyEmployGuBun_'],
        ['비고', 'CompanyRemark'],
      ];

      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];
            var columnHeader = [];
            var columnData;

            angular.forEach(excelHeader, function (head) {
              columnHeader.push(head[0]);
            });
            obj.push(columnHeader);
            angular.forEach($scope.jsonToExport, function (data) {
              columnData = [];
              angular.forEach(excelHeader, function (head) {
                if (!isNullOrEmpty(data[head[1]])) {
                  columnData.push(data[head[1]]);
                } else {
                  columnData.push('');
                }
              });
              obj.push(columnData);
            });

            $scope.exportData = obj;

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        },
        function (error) {
          // 조회 중 오류 발생
          console.error('Error> getExcelFile()');
          console.table(error);
        }
      );
    } */

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '일련번호';
      obj.format = numFormat;
      obj.width = numWidth;
      obj.field = 'rowNum';
      header.push(obj);

      obj = {};
      obj.title = '성명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CustNm';
      header.push(obj);

      obj = {};
      obj.title = '군번';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyNo';
      header.push(obj);

      obj = {};
      obj.title = '생년월일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ResRegNo';
      header.push(obj);

      obj = {};
      obj.title = '권역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyArea_';
      header.push(obj);

      obj = {};
      obj.title = '군별';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyType_';
      header.push(obj);

      obj = {};
      obj.title = '계급';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyClass_';
      header.push(obj);

      obj = {};
      obj.title = '소속부대1';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat1_';
      header.push(obj);

      obj = {};
      obj.title = '소속부대2';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat2';
      header.push(obj);

      obj = {};
      obj.title = '병과';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Spec_';
      header.push(obj);

      obj = {};
      obj.title = '상담분야1';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField1_';
      header.push(obj);

      obj = {};
      obj.title = '상담분야2';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselField2_';
      header.push(obj);

      obj = {};
      obj.title = '상담사';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CounselUser_';
      header.push(obj);

      obj = {};
      obj.title = '등록일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'RegDate';
      header.push(obj);

      obj = {};
      obj.title = '취업처';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyNm';
      header.push(obj);

      obj = {};
      obj.title = '부서';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyDept';
      header.push(obj);

      obj = {};
      obj.title = '기업구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyGuBun_';
      header.push(obj);

      obj = {};
      obj.title = '취업형태';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyWorkType_';
      header.push(obj);

      obj = {};
      obj.title = '직급';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyClass';
      header.push(obj);

      obj = {};
      obj.title = '직책';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyJobTitle';
      header.push(obj);

      obj = {};
      obj.title = '취업확인일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyRegDate';
      header.push(obj);

      obj = {};
      obj.title = '취업직종';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyType_';
      header.push(obj);

      obj = {};
      obj.title = '급여/연봉(만원)';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyAmt';
      header.push(obj);

      obj = {};
      obj.title = '입사일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyJoinDate';
      header.push(obj);

      obj = {};
      obj.title = '고용형태';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyEmploy_';
      header.push(obj);

      obj = {};
      obj.title = '고용형태구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyEmployGuBun_';
      header.push(obj);

      obj = {};
      obj.title = '비고';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyRemark';
      header.push(obj);

      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '취업 목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl(
          '/excel/Jobinfoarmy.getExcelJobinfoarmyList/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    vm.setSortColumn = function (sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = 'ASC';
      } else {
        //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getList();
    };

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    vm.setSortDirect = function (sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    };

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getList();
  },
]);

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.dashboard:dashboard-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @description Controller of the Dashboard
   */
  webapp.controller('DashboardCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$timeout',
    '$filter',
    '$translate',
    'modalFactory',
    '$q',
    function DashboardCtrl(
      $window,
      $rootScope,
      $scope,
      $state,
      $stateParams,
      CONSTANT,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $timeout,
      $filter,
      $translate,
      modalFactory,
      $q
    ) {
      var vm = this;

      // 함수연결
      vm.showScheduleModalPopup = showScheduleModalPopup;

      vm.srchTopCnt = {
        TenantId: vm.TenantId,
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      };

      vm.LoginUserType = $window.sessionStorage['loginUserType'];

      vm.srchTopCnt.UserArmyZone = '';

      vm.srchCal = {
        baseDate: new moment().format('YYYY-MM-DD'),
        CustNm: '',
        CustArmyId: '',
        PermStat: '',
        /*SchUserId   : $window.sessionStorage['loginUserIdx'],
          SchUserId_  : $window.sessionStorage['loginUserName'],*/
        SchUserId: '',
        SchUserId_: '',
        Title: '',
      };

      $scope.SelectedEvent = null;
      var isFirstTime = true;

      vm.dataTopCnt = [];
      vm.dataCal = [];

      $scope.events = [];
      $scope.eventSources = [$scope.events];
      $scope.NewEvent = {};
      vm.ArmyZoneList = [];

      var modalMailSecGuideInstance = null;
      function showModalMailSecGuide() {
        modalMailSecGuideInstance = modalFactory.open(
          'lg',
          'app/dashboard/modal/dashboard-img-modal.html',
          'DashboardImgModalCtrl as modalCtrl',
          { src:'/assets/mailSecGuide.png' }
        );

        // modalMailSecGuideInstance.result.then(
        //   function(ok){},
        //   function(cancel){}
        // );
        modalMailSecGuideInstance = null;
      }

      var modalInstance = null;
      function showModal() {
        modalInstance = modalFactory.open(
          'md',
          'app/dashboard/modal/dashboard-img-modal.html',
          'DashboardImgModalCtrl as modalCtrl',
          { src:'/assets/20160613.png' }
        );
        modalInstance = null;
      }

      // 사용자 권한  조회
      function getUserArmyZone() {
        vm.srchTopCnt.mapCode = 'Dashboard.getUserArmyZone';
        postApi.select(
          vm.srchTopCnt,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              /*  if (
                data.body.docs[0] != null &&
                data.body.docs[0].UserArmyZone != ''
              ) {
                vm.srchTopCnt.UserArmyZone = data.body.docs[0].UserArmyZone;
              } */
              vm.ArmyZoneList = data.body.docs;

              getTopCnt();
              return;
            }
            // console.error('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('Error > dashboard-ctrl> getUserArmyZone>', data.body.docs[0].errMessage);
          }
        );
      }

      // 상단카운트 조회
      function getTopCnt() {
        vm.srchTopCnt.mapCode = 'Dashboard.getTopCnt';
        vm.srchTopCnt.armyZonelist = vm.ArmyZoneList;
        postApi.select(
          vm.srchTopCnt,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              vm.dataTopCnt = data.body.docs[0];
              return;
            }
            // console.error('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('Error > dashboard-ctrl> getTopCnt>', data.body.docs[0].errMessage);
          }
        );
      }

      // 달력 조회
      function getDataCal() {
        //$window.sessionStorage.setItem("Schedule-list-ctrl", angular.toJson(vm.srchCal));
        vm.srchCal.mapCode = 'Schedule.getScheduleList';

        postApi.select(
          vm.srchCal,
          function (data) {
            if (data.body.docs.length > 0) {
              // 검색결과 저장
              vm.dataCal = data.body.docs;
            } else {
              // 검색된 결과 없음
              vm.dataCal = {};
            }

            // 달력에 일정 표시
            setDataInCalendar();
          },
          function (error) {
            console.log("error");
            // console.error('Error> Schedule-list-ctrl> getList()', status, error);
          }
        );

        var prms = dashboardApi.doCalData().post(vm.srchCal).$promise;
      }

      // 달력에 일정표시
      function setDataInCalendar() {
        try {
          // 달력 초기화
          if (uiCalendarConfig.calendars.myCalendar != null) {
            uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
            uiCalendarConfig.calendars.myCalendar.fullCalendar('unselect');
          }

          // event 초기화
          $scope.events.slice(0, $scope.events.length);

          if (vm.dataCal.length > 0) {
            /*  angular.forEach(vm.dataCal, function (item) {
               $scope.events.push({
                  id: item.SchId,
                  title: item.CustNm + '(' + item.PermStat_ + '), ' + item.SchUserId_,
                  description: " ",
                  start: new moment(item.StartDate).toDate(),
                  end: new moment(item.EndDate).toDate(),
                  allDay: false,
                  stick: true,
                  startEditable: false,
                  durationEditable: false
                });
            });*/

            var addEvent = uiCalendarConfig.calendars.myCalendar.fullCalendar('addEventSource', vm.dataCal);

            if (typeof addEvent != 'undefined') {
              //$scope.events.push.apply($scope.events, vm.dataCal);
              location.reload();
            }
          }
        } catch (ex) {
          console.log("error");
          // console.error('Error> Schedule-list-ctrl> setDataInCalendar()> ' + ex.message);
        }
      }

      // 달력 초기화
      $scope.uiConfig = {
        calendar: {
          height: 1500,
          editable: true,
          eventLimit: 11,
          displayEventTime: true,
          header: {
            left: '',
            center: 'title',
            right: 'prev,next today month,agendaWeek,agendaDay',
          },
          views: {
            basic: {
              titleFormat: 'YYYY.MM.DD',
            },
            month: {
              titleFormat: 'YYYY.MM',
            },
            agenda: {
              titleFormat: 'YYYY.MM.DD',
            },
            week: {
              titleFormat: 'YYYY.MM.DD',
            },
            day: {
              titleFormat: 'YYYY.MM.DD',
            },
          },
          timeFormat: 'H(:mm)',
          monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
          dayNames: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
          dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
          buttonText: {
            today: '오늘',
            month: '월간',
            week: '주간',
            day: '일간',
          },
          selectable: false,
          selectHelper: true,
          navLinks: true,
          navLinkDayClick: function (date, jsEvent) {
            vm.srchCal.baseDate = moment(date).format('YYYY-MM-DD');
            uiCalendarConfig.calendars.myCalendar.fullCalendar('gotoDate', date);
            uiCalendarConfig.calendars.myCalendar.fullCalendar('changeView', 'agendaDay');
          },
          select: function (start, end) {
            vm.srchCal.baseDate = moment(start).format('YYYY-MM-DD');
          },
          eventClick: function (event) {
            vm.srchCal.baseDate = moment(event.start).format('YYYY-MM-DD');

            // 일정수정
            showScheduleModalPopup(event.id);
          },
          dayClick: function (date, jsEvent, view) {
            vm.srchCal.baseDate = moment(date).format('YYYY-MM-DD');

            // 일정등록
            showScheduleModalPopup('');
          },
          eventAfterAllRender: function () {},
          viewRender: function (view, element) {},
          dayRender: function (date, cell) {},
          eventRender: function (event, element, view) {
            vm.srchCal.baseDate = '';
            vm.dataCal = [];

            element.attr({
              tooltip: event.title,
              'tooltip-append-to-body': true,
            });
            $compile(element)($scope);
          },
        },
      };

      // 달력클릭
      function showScheduleModalPopup(schId) {
        $state.go('app.counsel.schedule-list');
        /*try {

          // Modal Popup Controller 정의
          var ctrl = 'ScheduleModalCtrl as modalCtrl';

          // Modal Popup에 전달할 Parameter 정의
          var paramData = {BaseDate:vm.srch.baseDate, SchId: schId};

          // Modal Popup 호출
          var modalInstance = modalFactory.open('modal', 'views/modal/schedule-modal.html', ctrl, paramData);

          modalInstance.result.then(function(okData) {
              // 데이터 조회
              getList();

            }, function(cancelData) {
              // Cancel 처리
          });

        }
        catch (ex)
        {
          console.error('Error> Schedule-list-ctrl> showScheduleModalPopup()> ' + ex.message);
        }*/
      }

      // 모달팝업 호출 (부대별상담현황)
      /* function showUnitCounselModalPopup() {
        var ctrl = 'UnitCounselModalCtrl as modalCtrl';
        var paramData = {};

        var modalInstance = modalFactory.open(
          'lg',
          'app/dashboard/modal/unit-counsel-modal.html',
          ctrl,
          paramData
        );
        modalInstance.result.then(
          function (okData) {},
          function (cancelData) {}
        );
      }

      // 오늘 그만보기
      function getCloseToday() {
        vm.srchTopCnt.mapCode = 'Dashboard.getCloseToday';

        postApi.select(
          vm.srchTopCnt,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (
                data.body.docs.length > 0 &&
                data.body.docs[0].CloseToday != 1
              ) {
                vm.closeToday = data.body.docs[0].CloseToday;
                showUnitCounselModalPopup();
              } else {
              }
            }
          },
          function (error) {
            console.error('Error > getCloseToday()', status, error);
          }
        );
      } */

      //getCloseToday();
      showModalMailSecGuide();
      // showModal();
      getUserArmyZone();
      //getDataCal();
    },
  ]);
})();

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/dashboard/dashboard.html',
        requiresAuthentication: true,
        resolve: {
          /* plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ], */
        },
      })

      .state('pop.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/dashboard/dashboard.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/dist/footable.all.min.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      });
  }
})();

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.mentoring', {
        url: '/mentoring',
        template: '<div ui-view></div>',
      })
      .state('app.mentoring.mentoringapply-list', {
        url: '/apply-list',
        templateUrl: 'app/mentoring/mentoringapply-list.html',
      })
      .state('app.mentoring.mentoringclub-list', {
        url: '/club-list',
        templateUrl: 'app/mentoring/mentoringclub-list.html',
      })
      .state('app.mentoring.mentoringclub-detail', {
        url: '/club-detail/:ClubId',
        templateUrl: 'app/mentoring/mentoringclub-detail.html',
      })
      .state('app.mentoring.mentoringclub-edit', {
        url: '/club-edit/:ClubId',
        templateUrl: 'app/mentoring/mentoringclub-edit.html',
        params: {
          ClubId: '',
        },
      })
      .state('app.mentoring.mentoringprtcp-list', {
        url: '/prtcp-list',
        templateUrl: 'app/mentoring/mentoringprtcp-list.html',
      })
      .state('app.mentoring.mentoringprtcp-detail', {
        url: '/prtcp-detail/:PrtcpId',
        templateUrl: 'app/mentoring/mentoringprtcp-detail.html',
      })
      .state('app.mentoring.mentoringprtcp-edit', {
        url: '/prtcp-edit/:PrtcpId',
        templateUrl: 'app/mentoring/mentoringprtcp-edit.html',
        params: {
          PrtcpId: '',
        },
      })
      .state('app.mentoring.mentoringrecord-list', {
        url: '/record-list',
        templateUrl: 'app/mentoring/mentoringrecord-list.html',
      })
      .state('app.mentoring.mentoringrecord-edit', {
        url: '/record-edit/:RecordId',
        templateUrl: 'app/mentoring/mentoringrecord-edit.html',
        params: {
          mentoringRecordId: '',
          ClubId: '',
        },
      })
      .state('app.mentoring.mentoringrecord-detail', {
        url: '/record-detail/:RecordId',
        templateUrl: 'app/mentoring/mentoringrecord-detail.html',
      })
      .state('app.mentoring.mentoringschedule-list', {
        url: '/schedule-list',
        templateUrl: 'app/mentoring/mentoringschedule-list.html',
      });
    }
})();
webapp.controller('MentoringApplyListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$http',
    '$timeout',
    function MentoringApplyListCtrl(
      $window,
      $scope,
      $location,
      $state,
      $stateParams,
      $rootScope,
      CONSTANT,
      modalFactory,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $http,
      $timeout
    ) {
      var vm = this;
      var EXCEL_SQL = 'Mentoring.getExcelMentoringApplyList';
      var EXCEL_TITLE = '창업멘토링 신청자';
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringapply-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');
      // console.log('loginUserType === ', $window.sessionStorage['loginUserType']);
      // 버튼 권한 체크
      $scope.showBtnExcel = true;
      $scope.showBtnDel = true;
      $scope.showBtnAdd = isPageAccess('mentoringapply-edit', $window.sessionStorage['loginUserType'], false);
      vm.dataloader = false;
      vm.disabledArea = false;
  
      // 함수연결
      vm.getExcel = getExcel;
      vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
      var today = new Date();
      var year = today.getFullYear().toString();
  
      // 검색 조건
      vm.srch = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        TenantNm: $window.sessionStorage['loginTenantName'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        year:year,
        isMasking:'Y'
      };
  
      // 데이터
      vm.data = {};
  
      // 페이징
      if ($stateParams.page === undefined || $stateParams.page === '') {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }
  
      vm.listSize = [10, 25, 50, 100];
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.viewSize = vm.viewSize;
  
      /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
      if ($window.sessionStorage.getItem('mentoringapply-list-ctrl') != null) {
        if (
          $rootScope.previousPage != null &&
          ($rootScope.previousPage.indexOf('/app/mentoring/apply-edit') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/apply-detail') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/apply-list') !== -1)
        ) {
          vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('mentoringapply-list-ctrl')));
  
          vm.data.ArmyAreaObj = {
            Code: vm.srch.ArmyArea,
            CodeValue: vm.srch.ArmyArea,
          };
          $scope.dtApplyDateFrom = setNewDate(vm.srch.ApplyDateFrom);
          $scope.dtApplyDateTo = setNewDate(vm.srch.ApplyDateTo);
  
          vm.currentPage = vm.srch.page;
        }
      }
  
      // 엑셀 정보
      vm.excel = {
        downFileName: 'mentoringapply',
        subject: '창업멘토링 신청자 목록',
      };
  
      // 유효성검사
      function chkValid() {
  
        if (
          vm.srch.ApplyDateFrom != null &&
          vm.srch.ApplyDateFrom != '' &&
          vm.srch.ApplyDateTo != null &&
          vm.srch.ApplyDateTo != ''
        ) {
          if (getDateToNumber(vm.srch.ApplyDateFrom) > getDateToNumber(vm.srch.ApplyDateTo)) {
            gAlert('', '신청일 날짜범위가 잘못되었습니다.');
            return false;
          }
        }
  
        return true;
      }
  
      function getTenantAreaList() {
        vm.srch.mapCode = 'Business.getTenantArea';
        postApi.select(
          vm.srch,
          function (data) {
            var resultData = postApi.makeResultData(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (resultData.body.docs[0] != null) {
                var areaList = resultData.body.docs[0].TenantArea.split(',');
                vm.ArmyAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                if (vm.ArmyAreaList.length === 1) {
                  vm.srch.ArmyAreaObj = vm.ArmyAreaList[0];
                  vm.srch.ArmyArea = vm.srch.ArmyAreaObj.Code;
                }
              } else {
                vm.srch.ArmyAreaList = [];
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData' + data.body.docs[0].errMessage);
          }
        );
      }
  
      // 목록 조회
      function getList() {
        if (!chkValid()) return false;
  
        getTenantAreaList();
  
        vm.srch.page = vm.currentPage;
  
        vm.dataloader = true;
        getListCount();

        $window.sessionStorage.setItem('mentoringapply-list-ctrl', angular.toJson(vm.srch));

        vm.srch.mapCode = 'MentoringApplyArmy.getMentoringApplyList';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.lists = resultData.body.docs;

              // vm.lists = data.body.docs;
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
  
      }
  
      // 목록카운트 조회
      function getListCount() {
        vm.srch.mapCode = 'MentoringApplyArmy.getMentoringApplyListCount';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.totalItems = data.body.docs[0];
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }
  
      // 페이징 관련
      function pageChanged() {
        getList();
      }
  
      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }
  
      function setDownloadHistory(DownloadReason) {
        var log = {};
  
        log.DownloadIP = $window.sessionStorage['loginIP'];
        log.DownloadReason = DownloadReason;
        log.ScreenNm = '멘토링신청자목록';
        log.ScreenUrl = 'app/mentoring/mentoringapply-list';
  
        log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
        postApi.insert(log, function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              getExcel();
            }
          }
        });
      }
  
      // 모달팝업 호출 (다운로드사유)
      function showModalDownloadReason() {
        var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            setDownloadHistory(okData);
          },
          function (cancelData) {}
        );
      }
  
      // 엑셀 다운로드 체크여부 조회
      function getExcelDownloadCheckYn() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
  
        postApi.select(
          vm.srch,
          function (data) {
            //console.log("DownloadCheckYn", data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.DownloadCheckYn = data.body.docs;
                if (vm.DownloadCheckYn == 'Y') {
                  showModalDownloadReason();
                } else {
                  setDownloadHistory('');
                }
              } else {
                console.info('else ');
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getDownloadCheckYn', status, data);
          }
        );
      }
    
      // 엑셀 다운로드
      function getExcel() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        var header = [];
        var a = document.createElement('a');
        document.body.appendChild(a);
        var strFormat = 'string';
        var strWidth = '20';
        var numFormat = 'number2';
        var numWidth = '20';
  
        //헤더 설정..공통사용 불가
        obj = {};
        obj.title = '성명';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MemberNm';
        header.push(obj);

        obj = {};
        obj.title = '군번';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyNo';
        header.push(obj);

        obj = {};
        obj.title = '군별';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyType';
        header.push(obj);

        obj = {};
        obj.title = '계급';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyClass';
        header.push(obj);

        obj = {};
        obj.title = '소속(사,여단급)';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'PermStat';
        header.push(obj);

        obj = {};
        obj.title = '복무구분';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Term';
        header.push(obj);

        obj = {};
        obj.title = '동아리팀';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubNm';
        header.push(obj);

        obj = {};
        obj.title = '팀정보';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubRole';
        header.push(obj);

        obj = {};
        obj.title = '휴대폰';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Phone';
        header.push(obj);

        obj = {};
        obj.title = '신청일시';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ApplyDate';
        header.push(obj);
        // 헤더설정 End
  
        vm.srch.header = header;
        vm.srch.downFileName = '창업멘토링 신청자 목록';
  
        vm.srch.userkey = $rootScope.gVariable.userKey;
  
        $http({
          url: StaticVariable.getUrl(
            '/excel/MentoringApplyArmy.getExcelMentoringApplyList/action.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: vm.srch, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var fileName = vm.srch.downFileName;
            var blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
            });
            if (window.navigator && window.navigator.msSaveBlob) {
              fileName = fileName + '.xlsx';
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              a.href = objectUrl;
              a.download = fileName;
              a.click();
            }
          })
          .error(function (data, status, headers, config) {
            //download failed
          });
      }
  
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      vm.setSortColumn = function (sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;
  
        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = 'ASC';
        } else {
          //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
          vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
        }
  
        vm.srch.sortColumn = sortColumn;
  
        // 조회
        getList();
      };
  
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      vm.setSortDirect = function (sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }
  
        var rtnval = '';
  
        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      };
  
      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
  
      // 데이터 조회
      getList();
    },
  ]);
  
webapp.controller('MentoringClubDetailCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'modalFactory',
    'gAlert',
    'gConfirm',
    'postApi',
    '$timeout',
    function MentoringClubDetailCtrl(
      $window,
      $rootScope,
      $scope,
      $location,
      $state,
      $stateParams,
      CONSTANT,
      StaticVariable,
      modalFactory,
      gAlert,
      gConfirm,
      postApi,
      $timeout
    ) {
      var vm = this;
  
      vm.dataloader = false;
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringclub-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');
  
      // 버튼 권한 체크~
      $scope.showBtnEdit = isPageAccess('mentoringclub-edit', $window.sessionStorage['loginUserType'], false);
      $scope.showBtnDel = true;
  
      // 함수 연결
      //vm.getData = getData;
      // vm.deleteDetail = deleteDetail;
      $scope.showListEmpty = false;

      // 검색 데이터
      vm.srch = {
        ClubId: $stateParams.ClubId,
        TenantId: $window.sessionStorage['loginTenantId'],
        TableNm: 'mentoringclub',
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      // 조회 데이터 (휘발성 데이터)
      vm.data = {};

      // 조회
      function getData() {
        vm.dataloader = true;
        if (vm.srch.ClubId === null || vm.srch.ClubId === '') {
          return;
        }

        vm.srch.mapCode = 'MentoringClub.getMentoringClubDetail';

        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].ClubId !== null) {
                vm.data = data.body.docs[0];

                getContestList(); // 창업경진대회 목록 조회
                getClubMemberList(); // 구성원 목록 조회
                getMentoringrecordList(); // 멘토링보고서 목록 조회

                $timeout(function () {
                  vm.dataloader = false;
                }, 1000);
  
                return;
              }
            } else {
              gAlert('', '동아리팀 정보를 불러오는데 실패하였습니다.', {
                fn: function () {
                  $timeout(function () {
                    vm.dataloader = false;
                  }, 500);
                },
              });
            }
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }

      /*
      // 동아리팀 삭제
      function deleteDetail() {
        gConfirm(
          '',
          'Menu.DELETECONFIRM',
          {
            btn: '',
            fn: function () {
              deleteDetailAction();
            },
          },
          {
            btn: '',
            fn: function () {},
          }
        );
      }

      function deleteDetailAction() {
        if (vm.srch.CustArmyId === null || vm.srch.CustArmyId === '') {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        console.log('before delete', vm.data);
  
        vm.data.mapCode = 'MentoringClub.deleteMentoringClubBatch';
        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  $state.go('app.mentoring.mentoringclub-list');
                },
              });
              return;
            }
          },
          function (data) {
            console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
      */

      // 창업경진대회 목록
      function getContestList() {
        vm.srch.mapCode = 'MentoringClub.getMentoringContestList';
  
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                $scope.ContestJSON = data.body.docs;
              } else {
                /*$scope.ContestJSON = [];*/
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 구성원 목록
      function getClubMemberList() {
        vm.srch.mapCode = 'MentoringClub.getClubMemberList';

        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                $scope.MemberJSON = data.body.docs;
              } else {
                /*$scope.MemberJSON = [];*/
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 멘토링보고서 목록
      function getMentoringrecordList() {
        vm.srch.mapCode = 'MentoringClub.getMentoringrecordList';
        vm.srch.TableNm = 'MentoringRecord';
        vm.srch.IdName = 'RecordId';
        vm.srch.uploadFileList = [];
  
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                vm.lists = data.body.docs;
                $scope.showListEmpty = false;

                angular.forEach(vm.lists, function(li) {
                  var uploadFileList = [];
                  angular.forEach(li.uploadFileList, function (item) {
                    var obj = {
                      id: item.fileId,
                      isLoaded: true,
                      link: StaticVariable.getUrl(
                        '/attach/file/' +
                          item.PhysicalFileNm +
                          '/download.do?path=' +
                          item.PhysicalPath +
                          '&fileName=' +
                          item.LogicalFileNm +
                          '&userkey=' +
                          $rootScope.gVariable.userkey
                      ),
                      fileName: item.LogicalFileNm,
                      size: item.FileSize,
                      fileKey: item.PhysicalFileNm,
                      path: item.PhysicalPath,
                      downloadCnt: item.DownloadCnt,
                    };
                    uploadFileList.push(obj);
                  });
                  angular.copy(uploadFileList, li.uploadFileList);
                });
              } else {
                $scope.showListEmpty = true;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      getData();
    },
  ]);
  
webapp.controller('MentoringClubEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'gAlert',
  'gConfirm',
  '$http',
  '$sce',
  '$timeout',
  'postApi',
  function MentoringClubEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    gAlert,
    gConfirm,
    $http,
    $sce,
    $timeout,
    postApi
  ) {
    var vm = this;
    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('mentoringclub-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 함수 연결
    vm.showModalMentoUser = showModalMentoUser;
    vm.clearModalMentoUser = clearModalMentoUser;

    vm.getData = getData;
    vm.setData = setData;
    vm.disabledArea = false;

    // 공통코드 정의
    vm.MentoringAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      MentoringArea: '',
    };
    vm.ItemFieldList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1390',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    // vm.ProgressList = {
    //   CommonCodeId: '',
    //   ParentCommonCodeId: '',
    //   CodeType: '1400',
    //   Code: '',
    //   CodeValue: '',
    //   TenantId: $window.sessionStorage['loginTenantId'],
    // };
    vm.ArmyTypeList = { // 군별
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      MentoringArea: '',
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1390') {
        vm.data.ItemField = data.Code;
      // } else if (data.CodeType == '1400') {
      //   vm.data.Progress = data.Code;
      }
    };

    vm.onMentoringAreaListSelected = function () {
      var data = vm.data.MentoringAreaObj;
      if (vm.data.MentoringAreaObj == null) {
        vm.data.MentoringArea = '';
        vm.PermStat1List.MentoringArea = '';
        vm.ArmyTypeList.MentoringArea = '';
        return;
      }

      if (data.Code == null || data.Code == '') {
        vm.disabledArea = false;
      }

      vm.data.MentoringArea = vm.data.MentoringAreaObj.Code;
      vm.ArmyTypeList.MentoringArea = vm.data.MentoringArea;
      vm.PermStat1List.MentoringArea = vm.data.MentoringArea;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = {};

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.ArmyType = '';
        return;
      }

      vm.data.ArmyType = data.Code;
      vm.data.MentoringAreaType = data.Code;
      vm.PermStat1List.ParentCommonCodeId = vm.data.MentoringAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      if (data.Code == null) {
        vm.data.PermStat1 = '';
        return;
      }

      vm.data.PermStat1 = data.Code;
    };

    // 검색 데이터
    vm.srch = {
      ClubId: $stateParams.ClubId,
      BranchId: $window.sessionStorage['loginBranchId'],
      BranchNm: $window.sessionStorage['loginBranchName'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'mentoringclub',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터 (휘발성 데이터)
    vm.data = {
      TenantNm: $window.sessionStorage['loginTenantName'],
      Progress_: '신청',
    };

    // 기본값
    if (vm.srch.ClubId == 0 || vm.srch.ClubId == '' || typeof vm.srch.ClubId == 'undefined') {
      vm.data.MentoUser = $window.sessionStorage['loginUserIdx'];
      vm.data.MentoUser_ = $window.sessionStorage['loginUserName'];
    }

    vm.ClubNmORG = '';

    // 행추가 삭제 테이블 (창업경진대회)
    $scope.ContestJSON = [{ ContestId: '', ContestCode: '', ContestResult: '', ClubId: '' }];

    $scope.removeRowContest = function (index) {
      var removeJSON = $scope.ContestJSON.splice(index, 1);

      if (removeJSON[0].ContestId != '') {
        deleteContest(removeJSON[0].ContestId);
      }

      if ($scope.ContestJSON.length === 0) {
        $scope.ContestJSON = [];
      }
    };

    $scope.addRowContest = function () {
      $scope.ContestJSON.push({
        ContestId: '',
        ContestCode: '',
        ContestResult: '',
        ClubId: '',
      });
    };


    // 유효성검사
    function chkValid() {

      if (typeof vm.data.ClubNm == 'undefined' || vm.data.ClubNm == '') {
        gAlert('', '팀명을 입력해주세요');
        angular.element('input[ng-model="vc.data.ClubNm"]').focus();
        return false;
      }

      // if (typeof vm.data.MentoringArea == 'undefined' || vm.data.MentoringArea == '') {
      //   gAlert('', '권역을 선택해주세요');
      //   angular.element('select[ng-model="vc.data.MentoringAreaObj"]').focus();
      //   return false;
      // }

      // if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '') {
      //   gAlert('', '소속부대를 선택해주세요');
      //   angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
      //   return false;
      // }

      // if (vm.data.PermStat1 < 1000) {
      //   gAlert('', '소속부대를 선택해주세요');
      //   angular.element('common-code[param-data="vc.PermStat1List"]').children('select').focus();
      //   return false;
      // }

      // if (vm.data.MentoringArea != null && vm.data.MentoringArea != '050') {
      //   if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
      //     gAlert('', '군별을 선택해주세요');
      //     angular.element('common-code[param-data="vc.ArmyTypeList"]').children('select').focus();
      //     return false;
      //   }

      //   if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
      //     gAlert('', '소속부대2를 입력해주세요');
      //     angular.element('input[ng-model="vc.data.PermStat2"]').focus();
      //     return false;
      //   }
      // }

      // if (typeof vm.data.MentoUser == 'undefined' || vm.data.MentoUser == '') {
      //   gAlert('', '멘토를 선택해주세요', {
      //     fn: function () {
      //       vm.showModalMentoUser();
      //     },
      //   });
      //   angular.element('input[ng-model="vc.data.MentoUser_"]').focus();
      //   return false;
      // }

      return true;
    }

    // 조회
    function getData() {
      if (vm.srch.TenantId === undefined || vm.srch.TenantId === null || vm.srch.TenantId === '') {
        return;
      }

      vm.srch.mapCode = 'Business.getTenantArea';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var listStr = data.body.docs[0].TenantArea;
              vm.MentoringAreaList = listStr.split(',').reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.MentoringAreaList.length === 1) {
                vm.data.MentoringAreaObj = vm.MentoringAreaList[0];
                vm.data.MentoringArea = vm.data.MentoringAreaObj.Code;
              }
            } else {
              vm.MentoringAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );

      if (vm.srch.ClubId === undefined || vm.srch.ClubId === null || vm.srch.ClubId === '') {
        return;
      }

      vm.srch.mapCode = 'MentoringClub.getMentoringClubDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].ClubId !== null) {
              vm.data = data.body.docs[0];
              vm.ClubNmORG = vm.data.ClubNm;
              // 수동 메핑 항목 설정
              vm.data.MentoringAreaObj = {
                Code: vm.data.MentoringArea,
                CodeValue: vm.data.MentoringArea,
              };
              vm.ItemFieldList.Code = vm.data.ItemField;
              // vm.ProgressList.Code = vm.data.Progress;
              vm.ArmyTypeList.Code = vm.data.ArmyType;
              vm.PermStat1List.Code = vm.data.PermStat1;

              getContestList(); // 창업경진대회 목록 조회

              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 저장버튼 더블클릭 방지용 변수 선언 2020-02-19 김준권
    vm.saveButtonDisable = false;
    // 저장
    function setData() {

      if (!chkValid()) return false;

      vm.dataloader = true;
      vm.saveButtonDisable = true;

      var updateCallback = function (data) {

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].ClubId !== null) {
            vm.srch.ClubId = data.body.docs[0].ClubId;

            setDataContest(); // 창업경진대회 저장
            setDataSystemEventDetail().then(function(isSuccess) {
              if(!isSuccess) {
                gAlert('','운영업무시스템 연동에 실패하였습니다.');
              }
            });
            $timeout(function () {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if ($stateParams.ClubId == 0) {
                    $state.go('app.mentoring.mentoringclub-list');
                  } else {
                    $state.go('app.mentoring.mentoringclub-detail', {
                      ClubId: vm.srch.ClubId,
                    });
                  }
                },
              });
            }, 500);

            return;
          }
        }
        gAlert('', data.body.docs[0].errMessage);
      };

      if (vm.srch.ClubId == 0 || vm.srch.ClubId === undefined) {
        gAlert('', '동아리팀 신규 등록은 현재 이용이 불가능합니다.');
        vm.dataloader = false;
        $state.go('app.mentoring.mentoringclub-list');
        return;
        // 등록
        /* 신규 등록 비활성화
        vm.data.mapCode = 'MentoringClub.insertMentoringClubBatch';
        postApi.insert(vm.data, updateCallback, function (data) {
          console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
        });
        */
      } else {
        // 수정
        vm.data.mapCode = 'MentoringClub.updateMentoringClubBatch';
        postApi.update(vm.data, updateCallback, function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
        });
      }
    }

    // 모달팝업 호출 (상담사)
    function showModalMentoUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.MentoUser_ = okData.UserNm;
          vm.data.MentoUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalMentoUser() {
      vm.data.MentoUser_ = '';
      vm.data.MentoUser = '';
    }

    // 창업경진대회 목록
    function getContestList() {
      vm.srch.mapCode = 'MentoringClub.getMentoringContestList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.ContestJSON = data.body.docs;
            } else {
              /*$scope.ContestJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 동아리팀명 변경 반영
    function setDataSystemEventDetail() {
      return new Promise(function (resolve, reject) {
        if (vm.data.ClubNm == vm.ClubNmORG) {
          resolve(true);
        }
  
        var param = {
          LeaderNo: vm.data.LeaderNo,
          ClubNm: vm.data.ClubNm,
          ClubNmORG: vm.ClubNmORG,
        }
        postApi.api(
          'extUpdate/Linkage.updateMentoringClubNmBatch/action',
          param,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              resolve(true);
            }
          },
          function (data) {
            gAlert('', data.body.docs[0].errMessage);
            console.log("error");
            // console.error('Error-updateClubNm' + data.body.docs[0].errMessage);
            reject(false);
          }
        );
      });
    }

    // 창업경진대회 저장
    function setDataContest() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataContest', status, data);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};

      data.paramList = $scope.ContestJSON.reduce(function (acc, cur) {
        if (typeof cur.ContestCode != 'undefined' && cur.ContestCode != '') {
          cur.ClubId = vm.srch.ClubId;
          acc.push(cur);
        }
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'MentoringClub.updateMentoringContest';
        postApi.update(data, successCallback, errorCallback);
      }
    }

    // 창업경진대회 삭제
    function deleteContest(idx) {
      var data = {
        ContestId: idx,
      };

      data.mapCode = 'MentoringClub.deleteMentoringContest';
      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 데이터 조회
    getData();

    // 자동 저장 유효성검사
    function chkValidAuto() {
      if (typeof vm.data.ClubNm == 'undefined' || vm.data.ClubNm == '') {
        return false;
      }

      // if (typeof vm.data.MentoringArea == 'undefined' || vm.data.MentoringArea == ''
      // || typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == ''
      // || typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == ''
      // || typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == ''
      // || typeof vm.data.MentoUser == 'undefined' || vm.data.MentoUser == '') {
      //   return false;
      // }

      return true;
    }

    // 자동 저장
    function setDataAuto() {
      if ($window.sessionStorage['isLoggedIn'] != 'Y') {
        return;
      }

      if (!chkValidAuto()) {
        startTimer();
        return false;
      }

      if (vm.srch.ClubId == 0) {
        // 등록
        gConfirm(
          '',
          '자동저장 하시겠습니까?',
          {
            btn: '',
            fn: function () {
              vm.data.mapCode = 'MentoringClub.insertMentoringClubBatch';

              postApi.insert(
                vm.data,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docs[0].ClubId !== null) {
                      vm.srch.ClubId = data.body.docs[0].ClubId;
                      vm.data.ClubId = data.body.docs[0].ClubId;

                      setDataContest(); // 창업경진대회 저장
                      setDataSystemEventDetail();
                      startTimer();
                      return;
                    }
                  }
                  gAlert('', data.body.docs[0].errMessage);
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            },
          },
          {
            btn: '',
            fn: function () {
              startTimer();
              return;
            },
          }
        );
        return;
      } else {
        // 수정
        vm.data.mapCode = 'MentoringClub.updateMentoringClubBatch';

        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].ClubId !== null) {
                vm.srch.ClubId = data.body.docs[0].ClubId;
                vm.data.ClubId = data.body.docs[0].ClubId;

                setDataContest(); // 창업경진대회 저장
                setDataSystemEventDetail();
                startTimer();
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
    }

    var timer = null;

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
    });

    function startTimer() {
      timer = $timeout(setDataAuto, 300000); // 타이머 : 5문 = 5 * 60 * 1000
    }

    startTimer();
  },
]);

webapp.controller('MentoringClubListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$http',
    '$timeout',
    function MentoringClubListCtrl(
      $window,
      $scope,
      $location,
      $state,
      $stateParams,
      $rootScope,
      CONSTANT,
      modalFactory,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $http,
      $timeout
    ) {
      var vm = this;
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringclub-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');
      // console.log('loginUserType === ', $window.sessionStorage['loginUserType']);
      // 버튼 권한 체크
      $scope.showBtnExcel = true;
      $scope.showBtnDel = true;
      $scope.showBtnAdd = isPageAccess('mentoringclub-edit', $window.sessionStorage['loginUserType'], false);
      vm.dataloader = false;
      vm.disabledArea = false;
  
      // 함수연결
      vm.showModalMentoUser = showModalMentoUser;
      vm.clearModalMentoUser = clearModalMentoUser;
      // vm.deleteList = deleteList;
      vm.getExcel = getExcel;
      vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
  
      // 검색 조건
      vm.srch = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        TenantNm: $window.sessionStorage['loginTenantName'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        isMasking: 'Y',
      };
  
      // 데이터
      vm.data = {};
  
      // 페이징
      if ($stateParams.page === undefined || $stateParams.page === '') {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }
  
      vm.listSize = [10, 25, 50, 100];
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.viewSize = vm.viewSize;

      // 공통코드 정의
      vm.ArmyTypeList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1010',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        MentoringArea: '',
      };
      vm.ItemFieldList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1390',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ProgressList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1400',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ContestList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1410',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
  
      vm.onSelectCallback = function (data) {
        if (data.Code == null) data.Code = '';
  
        if (data.CodeType == '1390') {
          vm.srch.ItemField = data.Code;
        } else if (data.CodeType == '1400') {
          vm.srch.Progress = data.Code;
        } else if (data.CodeType == '1410') {
          vm.srch.Contest = data.Code;
        }
      };
  
      vm.PermStat1List = {
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      vm.onMentoringAreaListSelected = function () {
        var data = vm.srch.MentoringAreaObj;
  
        if (data == null) {
          vm.srch.MentoringArea = '';
          vm.PermStat1List.MentoringArea = '';
          vm.ArmyTypeList.MentoringArea = '';
          return;
        }
        vm.srch.MentoringArea = data.Code;
  
        vm.PermStat1List.MentoringArea = data.Code;
        vm.ArmyTypeList.MentoringArea = data.Code;
      };
  
      vm.onArmyTypeListSelected = function (data) {
  
        vm.PermStat1List.CodeType = '1380';
        vm.PermStat1List.ParentCommonCodeId = '';
  
        if (data == null) {
          vm.srch.ArmyType = '';
          return;
        }

        vm.srch.ArmyType = data.Code;
        vm.srch.MentoringAreaType = data.Code;
        vm.PermStat1List.ParentCommonCodeId = vm.srch.MentoringAreaType;
  
        if (data.Code == null) data.Code = '';
      };
  
      vm.onPermStat1ListSelected = function (data) {
  
        if (data == null) {
          vm.srch.PermStat1 = '';
          return;
        }
  
        vm.srch.PermStat1 = data.Code;
        vm.srch.PermStat2 = '';
      };
    
      /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
      if ($window.sessionStorage.getItem('mentoringclub-list-ctrl') != null) {
        if (
          $rootScope.previousPage != null &&
          ($rootScope.previousPage.indexOf('/app/mentoring/club-edit') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/club-detail') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/club-list') !== -1)
        ) {
          vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('mentoringclub-list-ctrl')));
  
          vm.data.MentoringAreaObj = {
            Code: vm.srch.MentoringArea,
            CodeValue: vm.srch.MentoringArea,
          };
          vm.ArmyTypeList.Code = vm.srch.ArmyType;
          vm.PermStat1List.Code = vm.srch.PermStat1;
  
          vm.currentPage = vm.srch.page;
        }
      }
  
      // 엑셀 정보
      vm.excel = {
        downFileName: 'mentoringclub',
        subject: '멘토링 동아리팀 목록',
        /*header : [ {
            field : 'FreeBoardId',
            title : '번호',
            width : '5',
            format : 'number'
          }, {          
            field : 'ReadCnt',
            title : '조회수',
            width : '5',
            format : 'string'
          } ],*/
      };
  
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
  
        vm.chkHead = true;
      };
  
      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };

      function getTenantAreaList() {
        vm.srch.mapCode = 'Business.getTenantArea';
        postApi.select(
          vm.srch,
          function (data) {
            var resultData = postApi.makeResultData(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (resultData.body.docs[0] != null) {
                var areaList = resultData.body.docs[0].TenantArea.split(',');
                vm.MentoringAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                if (vm.MentoringAreaList.length === 1) {
                  vm.srch.MentoringAreaObj = vm.MentoringAreaList[0];
                  vm.srch.MentoringArea = vm.srch.MentoringAreaObj.Code;
                }
              } else {
                vm.srch.MentoringAreaList = [];
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData' + data.body.docs[0].errMessage);
          }
        );
      }
  
      // 목록 조회
      function getList() {

        vm.dataloader = true;
        vm.srch.page = vm.currentPage;
        getTenantAreaList();
        getListCount();

        $window.sessionStorage.setItem('mentoringclub-list-ctrl', angular.toJson(vm.srch));
        vm.srch.mapCode = 'MentoringClub.getMentoringClubList';

        postApi.select(
            vm.srch,
            function (data) {
              if (data.header.status === CONSTANT.HttpStatus.OK) {
                if (data.body.docCnt === 0) {
                  vm.lists = null;
                  gAlert('', '조회된 정보가 없습니다.');
                } else {
                  var resultData = postApi.makeResultData(data);
                  vm.lists = resultData.body.docs;
                }
              }
            },
            function (data) {
              console.log("error");
              // console.error('Error-getData' + data.body.docs[0].errMessage);
            }
        );
        vm.dataloader = false;
      }
  
      // 목록카운트 조회
      function getListCount() {
        vm.srch.mapCode = 'MentoringClub.getMentoringClubListCnt';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.totalItems = data.body.docs[0];
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getData' + data.body.docs[0].errMessage);
          }
        );
      }
  
      /*
      // 목록 삭제
      function deleteList() {
        gConfirm(
          '',
          'Menu.DELETECONFIRM',
          {
            btn: '',
            fn: function () {
              deleteListAction();
            },
          },
          {
            btn: '',
            fn: function () {},
          }
        );
      }
  
      function deleteListAction() {
        vm.data.ClubIds = [];
  
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.data.ClubIds.push(vm.lists[i].ClubId);
          }
        }
        
        vm.dataloader = true;
  
        if (vm.data.ClubIds == null || vm.data.ClubIds.length == 0) {
          gAlert('', '선택된 게시물이 없습니다.');
          return false;
        }
  
        vm.data.mapCode = 'MentoringClub.deleteMentoringClubBatch';
  
        postApi.update(
          vm.data,
          function (data) {
            vm.dataloader = false;
            if (data.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  $state.reload();
                },
              });
            }
          },
          function (data) {
            vm.dataloader = false;
            console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
      */
  
      // 모달팝업 호출 (상담사)
      function showModalMentoUser() {
        var ctrl = 'User2ModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            vm.srch.MentoUser_ = okData.UserNm;
            vm.srch.MentoUser = okData.UserId;
            //console.log('vm.srch:', vm.srch);
          },
          function (cancelData) {}
        );
      }
  
      // 모달팝업 데이터 삭제 (상담사)
      function clearModalMentoUser() {
        vm.srch.MentoUser_ = '';
        vm.srch.MentoUser = '';
      }
  
      // 페이징 관련
      function pageChanged() {
        getList();
      }
  
      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }
  
      function setDownloadHistory(DownloadReason) {
        var log = {};
  
        log.DownloadIP = $window.sessionStorage['loginIP'];
        log.DownloadReason = DownloadReason;
        log.ScreenNm = '멘토링동아리팀목록';
        log.ScreenUrl = 'app/mentoring/club-list';
  
        log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
        postApi.insert(log, function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              getExcel();
            }
          }
        });
      }
  
      // 모달팝업 호출 (다운로드사유)
      function showModalDownloadReason() {
        var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            setDownloadHistory(okData);
          },
          function (cancelData) {}
        );
      }
  
      // 엑셀 다운로드 체크여부 조회
      function getExcelDownloadCheckYn() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
  
        postApi.select(
          vm.srch,
          function (data) {
            //console.log("DownloadCheckYn", data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.DownloadCheckYn = data.body.docs;
                if (vm.DownloadCheckYn == 'Y') {
                  showModalDownloadReason();
                } else {
                  setDownloadHistory('');
                }
              } else {
                console.info('else ');
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getDownloadCheckYn', status, data);
          }
        );
      }
    
      // 엑셀 다운로드
      function getExcel() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        var header = [];
        var a = document.createElement('a');
        document.body.appendChild(a);
        var strFormat = 'string';
        var strWidth = '20';
        var numFormat = 'number2';
        var numWidth = '20';
  
        //헤더 설정..공통사용 불가
        obj = {};
        obj.title = '동아리팀';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubNm';
        header.push(obj);

        obj = {};
        obj.title = '팀장';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'LeaderNm';
        header.push(obj);

        obj = {};
        obj.title = '팀원';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MemberNm';
        header.push(obj);

        obj = {};
        obj.title = '군별';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyType_';
        header.push(obj);

        obj = {};
        obj.title = '소속부대';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'PermStat';
        header.push(obj);

        obj = {};
        obj.title = '멘토';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoUser_';
        header.push(obj);

        obj = {};
        obj.title = '권역';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoringArea';
        header.push(obj);

        obj = {};
        obj.title = '등록일';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'RegDate';
        header.push(obj);
        header.push(obj);

        obj = {};
        obj.title = '진행상태';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Progress_';
        header.push(obj);
        // 헤더설정 End
  
        vm.srch.header = header;
        vm.srch.downFileName = '멘토링 동아리 목록';
        vm.srch.ext = 'motisystem';
  
        vm.srch.userkey = $rootScope.gVariable.userKey;
  
        $http({
          url: StaticVariable.getUrl(
            '/excel/MentoringClub.getExcelMentoringClubList/action.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: vm.srch, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var fileName = vm.srch.downFileName;
            var blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
            });
            if (window.navigator && window.navigator.msSaveBlob) {
              fileName = fileName + '.xlsx';
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              a.href = objectUrl;
              a.download = fileName;
              a.click();
            }
          })
          .error(function (data, status, headers, config) {
            //download failed
          });
      }
  
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      vm.setSortColumn = function (sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;
  
        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = 'ASC';
        } else {
          //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
          vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
        }
  
        vm.srch.sortColumn = sortColumn;
  
        // 조회
        getList();
      };
  
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      vm.setSortDirect = function (sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }
  
        var rtnval = '';
  
        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      };
  
      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
  
      // 데이터 조회
      getList();
    },
  ]);
  
webapp.controller('MentoringPrtcpDetailCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'gAlert',
  'gConfirm',
  'postApi',
  '$timeout',
  function MentoringPrtcpDetailCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    gAlert,
    gConfirm,
    postApi,
    $timeout
  ) {
    var vm = this;

    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('mentoringprtcp-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnEdit = isPageAccess('mentoringprtcp-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnEmail = true;
    $scope.showBtnDel = true;

    // 함수 연결
    vm.deleteDetail = deleteDetail;
    $scope.showListEmpty = false;

    // 검색 데이터
    vm.srch = {
      PrtcpId: $stateParams.PrtcpId,
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'mentoringprtcparmy',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터 (휘발성 데이터)
    vm.data = {};
    vm.jobinfo = {};

    // 조회
    function getData() {
      vm.dataloader = true;
      if (vm.srch.PrtcpId === null || vm.srch.PrtcpId === '') {
        return;
      }

      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].PrtcpId !== null) {
              vm.data = data.body.docs[0];

              if ((vm.data.ResRegNo.length = 8)) {
                vm.data.ResRegNo = vm.data.ResRegNo.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
              }
              vm.data.Mobile = vm.data.Mobile.replace(/\s|-/g, '').replace(
                /(\d{3})(\d{3,4})(\d{4})/,
                '$1-$2-$3'
              );

              // getLicenseList(); // 자격증 목록 조회
              // getCareerList(); // 경력 목록 조회
              getEduList(); // 학력 목록 조회
              getMentoringrecordList(); // 멘토링보고서 목록 조회
              $timeout(function () {
                vm.dataloader = false;
              }, 1000);

              return;
            }
          } else {
            gAlert('', '회원정보를 불러오는데 실패하였습니다.', {
              fn: function () {
                $timeout(function () {
                  vm.dataloader = false;
                }, 500);
              },
            });
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.srch.PrtcpId === null || vm.srch.PrtcpId === '') {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      postApi.api(
        'extUpdate/Linkage.deleteMentoringPrtcpArmyBatch/action',
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.mapCode = 'MentoringPrtcpArmy.deleteMentoringPrtcpArmyBatch';
            postApi.update(
              vm.data,
              function (data) {
                if (data.header.status == CONSTANT.HttpStatus.OK) {
                  gAlert('', 'Menu.DELETED', {
                    btn: '',
                    fn: function () {
                      $state.go('app.mentoring.mentoringprtcp-list');
                    },
                  });
                  return;
                }
              },
              function (data) {
                console.log("error");
                // console.error('fail', status, data);
                gAlert('', data.body.docs[0].errMessage);
              }
            );
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-updatePrtcpId' + data.body.docs[0].errMessage);
          gAlert('', data.body.docs[0].errMessage);
        }
      );

    }

    // 학력 목록
    function getEduList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyEduList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.EduJSON = data.body.docs;
            } else {
              /*$scope.EduJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /*
    // 자격증 목록
    function getLicenseList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyLicenseList';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('mentoringprtcparmylicense', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.LicenseJSON = data.body.docs;
            } else {
              //$scope.LicenseJSON = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.error('Error-getList', status, data);
        }
      );
    }

    // 경력 목록
    function getCareerList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyCareerList';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('mentoringprtcparmycareer', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.CareerJSON = data.body.docs;
            } else {
              $scope.CareerJSON = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.error('Error-getList', status, data);
        }
      );
    }
    */

    // 멘토링보고서 목록
    function getMentoringrecordList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringrecordList';
      vm.srch.TableNm = 'MentoringRecord';
      vm.srch.IdName = 'RecordId';
      vm.srch.uploadFileList = [];

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
              $scope.showListEmpty = false;

              angular.forEach(vm.lists, function(li) {
                var uploadFileList = [];
                angular.forEach(li.uploadFileList, function (item) {
                  var obj = {
                    id: item.fileId,
                    isLoaded: true,
                    link: StaticVariable.getUrl(
                      '/attach/file/' +
                        item.PhysicalFileNm +
                        '/download.do?path=' +
                        item.PhysicalPath +
                        '&fileName=' +
                        item.LogicalFileNm +
                        '&userkey=' +
                        $rootScope.gVariable.userkey
                    ),
                    fileName: item.LogicalFileNm,
                    size: item.FileSize,
                    fileKey: item.PhysicalFileNm,
                    path: item.PhysicalPath,
                    downloadCnt: item.DownloadCnt,
                  };
                  uploadFileList.push(obj);
                });
                angular.copy(uploadFileList, li.uploadFileList);
              });
            } else {
              $scope.showListEmpty = true;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    getData();
  },
]);

webapp.controller('MentoringPrtcpEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'gAlert',
  'gConfirm',
  '$http',
  '$sce',
  '$timeout',
  'postApi',
  function MentoringPrtcpEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    gAlert,
    gConfirm,
    $http,
    $sce,
    $timeout,
    postApi
  ) {
    var vm = this;
    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('mentoringprtcp-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 함수 연결
    // vm.showModalClubNameInfo = showModalClubNameInfo;
    vm.showModalArmyInfo = showModalArmyInfo;
    vm.showModalMentoUser = showModalMentoUser;
    vm.clearModalMentoUser = clearModalMentoUser;

    vm.getData = getData;
    vm.setData = setData;
    vm.disabledArea = false;

    // 공통코드 정의
    vm.ArmyTypeList = { // 군별
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      MentoringArea: '',
    };
    vm.ArmyClassList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1000',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.SpecList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1230',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    // vm.ClubRoleList = {
    //   CommonCodeId: '',
    //   ParentCommonCodeId: '',
    //   CodeType: '1420',
    //   Code: '',
    //   CodeValue: '',
    //   TenantId: $window.sessionStorage['loginTenantId'],
    // }

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1000') {
        vm.data.ArmyClass = data.Code;
      } else if (data.CodeType == '1230') {
        vm.data.Spec = data.Code;
      // } else if (data.CodeType == '1420') {
      //   vm.data.ClubRole = data.Code;
      }
    };

    vm.onMentoringAreaListSelected = function () {
      var data = vm.data.MentoringAreaObj;
      if (vm.data.MentoringAreaObj == null) {
        vm.data.MentoringArea = '';
        vm.PermStat1List.MentoringArea = '';
        vm.ArmyTypeList.MentoringArea = '';
        return;
      }

      if (data.Code == null || data.Code == '') {
        vm.disabledArea = false;
      }

      vm.data.MentoringArea = vm.data.MentoringAreaObj.Code;
      vm.ArmyTypeList.MentoringArea = vm.data.MentoringArea;
      vm.PermStat1List.MentoringArea = vm.data.MentoringArea;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data.Code == null) {
        vm.data.ArmyType = '';
        return;
      }

      vm.data.ArmyType = data.Code;
      vm.data.MentoringAreaType = data.Code;
      vm.PermStat1List.ParentCommonCodeId = vm.data.MentoringAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      if (data.Code == null) {
        vm.data.PermStat1 = '';
        return;
      }

      vm.data.PermStat1 = data.Code;
    };

    // 검색 데이터
    vm.srch = {
      PrtcpId: $stateParams.PrtcpId,
      BranchId: $window.sessionStorage['loginBranchId'],
      BranchNm: $window.sessionStorage['loginBranchName'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'mentoringprtcp',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터 (휘발성 데이터)
    vm.data = {
      TenantNm: $window.sessionStorage['loginTenantName'],
    };

    // 기본값
    if (vm.srch.PrtcpId == 0 || vm.srch.PrtcpId == '' || typeof vm.srch.PrtcpId == 'undefined') {
      vm.data.RegUser = $window.sessionStorage['loginUserIdx'];
      vm.data.RegUser_ = $window.sessionStorage['loginUserName'];
      vm.data.MentoUser = $window.sessionStorage['loginUserIdx'];
      vm.data.MentoUser_ = $window.sessionStorage['loginUserName'];
    }

    // 행추가 삭제 테이블 (자격증)
    /*
    $scope.LicenseJSON = [{ LicenseId: '', LicenseNm: '', GetDate: '', GetAgency: '' }];
    $scope.removeRowLicense = function (index) {
      var removeJSON = $scope.LicenseJSON.splice(index, 1);

      if (removeJSON[0].LicenseId != '') {
        deleteLicense(removeJSON[0].LicenseId);
      }

      if ($scope.LicenseJSON.length === 0) {
        $scope.LicenseJSON = [];
      }
    };

    $scope.addRowLicense = function () {
      $scope.LicenseJSON.push({
        LicenseId: '',
        LicenseNm: '',
        GetDate: '',
        GetAgency: '',
      });
    };
    */

    // 행추가 삭제 테이블 (학력)
    $scope.EduJSON = [
      {
        PrtcpEduId: '',
        EduLev: '',
        SchNm: '',
        OutSchDate: '',
        MajorType: '',
        MajorSeries: '',
        Loc: '',
        OutSchYN: '',
        MajorName: '',
        EduLevName: '',
      },
    ];

    $scope.removeRowEdu = function (index) {
      var removeJSON = $scope.EduJSON.splice(index, 1);

      if (removeJSON[0].PrtcpEduId != '') {
        deleteEdu(removeJSON[0].PrtcpEduId);
      }

      if ($scope.EduJSON.length === 0) {
        $scope.EduJSON = [];
      }
    };

    $scope.addRowEdu = function () {
      $scope.EduJSON.push({
        PrtcpEduId: '',
        EduLev: '',
        SchNm: '',
        OutSchDate: '',
        MajorType: '',
        MajorSeries: '',
        Loc: '',
        OutSchYN: '',
        MajorName: '',
        EduLevName: '',
      });
    };

    // 행추가 삭제 테이블 (경력)
    /*
    $scope.CareerJSON = [
      {
        CareerId: '',
        WorkDateFrom: '',
        WorkDateTo: '',
        CompNm: '',
        Position: '',
        Work: '',
      },
    ];

    $scope.removeRowCareer = function (index) {
      var removeJSON = $scope.CareerJSON.splice(index, 1);

      if (removeJSON[0].CareerId != '') {
        deleteCareer(removeJSON[0].CareerId);
      }

      if ($scope.CareerJSON.length === 0) {
        $scope.CareerJSON = [];
      }
    };

    $scope.addRowCareer = function () {
      $scope.CareerJSON.push({
        CareerId: '',
        WorkDateFrom: '',
        WorkDateTo: '',
        CompNm: '',
        Position: '',
        Work: '',
      });
    };
    */

    // 유효성검사
    function chkValid() {

      if (typeof vm.data.ApplyId == 'undefined' || vm.data.ApplyId == '') {
        gAlert('', '회원정보를 검색해 주세요');
        angular.element('input[ng-model="vc.data.MemberNm"]').focus();
        return false;
      }

      if (typeof vm.data.MemberNm == 'undefined' || vm.data.MemberNm == '') {
        gAlert('', '성명을 입력해주세요');
        angular.element('input[ng-model="vc.data.MemberNm"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
        gAlert('', '군번을 입력해주세요');
        angular.element('input[ng-model="vc.data.ArmyNo"]').focus();
        return false;
      }

      if (typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == '') {
        gAlert('', '계급을 선택해주세요');
        angular.element('common-code[param-data="vc.ArmyClassList"]').children('select').focus();
        return false;
      }

      if (vm.data.ClubRole != '0' && (typeof vm.data.MentoringArea == 'undefined' || vm.data.MentoringArea == '')) {
        gAlert('', '권역을 선택해주세요');
        angular.element('select[ng-model="vc.data.MentoringAreaObj"]').focus();
        return false;
      }

      if (typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '' || vm.data.PermStat1 < 1000) {
        gAlert('', '소속부대를 선택해주세요');
        angular.element('common-code[param-data="vc.PermStat1List"]').children('select').focus();
        return false;
      }

      if (vm.data.MentoringArea != null && vm.data.MentoringArea != '050') {
        if (typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '') {
          gAlert('', '군별을 선택해주세요');
          angular.element('common-code[param-data="vc.ArmyTypeList"]').children('select').focus();
          return false;
        }

        if (typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '') {
          gAlert('', '소속부대2를 입력해주세요');
          angular.element('input[ng-model="vc.data.PermStat2"]').focus();
          return false;
        }
      }

      if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        gAlert('', '휴대폰 번호를 입력해주세요');
        angular.element('input[ng-model="vc.data.Mobile"]').focus();
        return false;
      }

      if (typeof vm.data.Spec == 'undefined' || vm.data.Spec == '') {
        gAlert('', '병과를 입력해주세요');
        angular.element('common-code[param-data="vc.SpecList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == '') {
        gAlert('', '임관일 또는 입대일를 입력해주세요');
        angular.element('input[ng-model="dtInArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == '') {
        gAlert('', '전역일을 입력해주세요');
        angular.element('input[ng-model="dtOutArmyDate"]').focus();
        return false;
      }

      if (typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == '') {
        gAlert('', '생년월일을 입력해주세요');
        angular.element('input[ng-model="vc.data.ResRegNo"]').focus();
        return false;
      }

      return true;
    }

    // 조회
    function getData() {
      if (vm.srch.TenantId === undefined || vm.srch.TenantId === null || vm.srch.TenantId === '') {
        // console.log('$rootScope.gVariable', $rootScope.gVariable);
        return;
      }

      vm.srch.mapCode = 'Business.getTenantArea';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var listStr = data.body.docs[0].TenantArea;
              vm.MentoringAreaList = listStr.split(',').reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.MentoringAreaList.length === 1) {
                vm.data.MentoringAreaObj = vm.MentoringAreaList[0];
                vm.data.MentoringArea = vm.data.MentoringAreaObj.Code;
              }
            } else {
              vm.MentoringAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );

      if (vm.srch.PrtcpId === undefined || vm.srch.PrtcpId === null || vm.srch.PrtcpId === '') {
        return;
      }

      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].PrtcpId !== null) {
              vm.data = data.body.docs[0];
              // 수동 메핑 항목 설정
              vm.SpecList.Code = vm.data.Spec;
              vm.ArmyClassList.Code = vm.data.ArmyClass;
              vm.ArmyTypeList.Code = vm.data.ArmyType;
              vm.PermStat1List.Code = vm.data.PermStat1;
              // vm.ClubRoleList.Code = vm.data.ClubRole;
              vm.data.MentoringAreaObj = {
                Code: vm.data.MentoringArea,
                CodeValue: vm.data.MentoringArea,
              };

              if ((vm.data.ResRegNo.length = 8)) {
                vm.data.ResRegNo = vm.data.ResRegNo.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
              }
              vm.data.Mobile = vm.data.Mobile.replace(/\s|-/g, '').replace(
                /(\d{3})(\d{3,4})(\d{4})/,
                '$1-$2-$3'
              );

              $scope.dtInArmyDate = setNewDate(vm.data.InArmyDate);
              $scope.dtOutArmyDate = setNewDate(vm.data.OutArmyDate);

              angular.element(document.getElementById('txtZipcode')).val(vm.data.ZipCode);
              angular.element(document.getElementById('txtAddr1')).val(vm.data.Address);

              getEduList(); // 학력 목록 조회
              // getLicenseList(); // 자격증 목록 조회
              // getCareerList(); // 경력 목록 조회

              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    // 저장버튼 더블클릭 방지용 변수
    vm.saveButtonDisable = false;
    // 저장
    function setData() {

      if (vm.saveButtonDisable || !chkValid()) return false;

      vm.dataloader = true;
      vm.saveButtonDisable = true;

      // 주소 값 저장
      vm.data.ZipCode = angular.element(document.getElementById('txtZipcode')).val();
      vm.data.Address = angular.element(document.getElementById('txtAddr1')).val();

      var updateCallback = function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docs[0].PrtcpId !== null) {
            vm.srch.PrtcpId = data.body.docs[0].PrtcpId;

            setDataMentoringApplyArmy();
            setDataEdu();
            if (vm.data.ClubRole == '1') {
              setDataMentoringClub();
              setDataPrtcpMember();
            }
            var param = {
              ApplyId: vm.data.ApplyId,
              PrtcpId: data.body.docs[0].PrtcpId,
            }
            if ($stateParams.PrtcpId == 0) {
              setDataSystemEventDetail(param).then(function(isSuccess) {
                if(!isSuccess) {
                  gAlert('','운영업무시스템 연동에 실패하였습니다.');
                }
              });
            }
            // setDataCareer();
            // setDataLicense();
            $timeout(function () {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if ($stateParams.PrtcpId == 0) {
                    $state.go('app.mentoring.mentoringprtcp-list');
                  } else {
                    $state.go('app.mentoring.mentoringprtcp-detail', {
                      PrtcpId: vm.srch.PrtcpId,
                    });
                  }
                },
              });
            }, 500);

            return;
          }
        }
        gAlert('', data.body.docs[0].errMessage);
      };

      if (vm.srch.PrtcpId == 0 || vm.srch.PrtcpId === undefined) {
        // 등록
        vm.data.mapCode = 'MentoringPrtcpArmy.insertMentoringPrtcpArmyBatch';
        postApi.insert(vm.data, updateCallback, function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
          return;
        });
      } else {
        // 수정
        vm.data.mapCode = 'MentoringPrtcpArmy.updateMentoringPrtcpArmyBatch';
        postApi.update(vm.data, updateCallback, function (data) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage, {
            fn: function () {
              vm.dataloader = false;
            },
          });
        });
      }
    }

    // 운영업무시스템 DB에 창업멘토링 참여기록 저장
    function setDataSystemEventDetail(param) {
      return new Promise(function (resolve, reject) {
        postApi.api(
          'extUpdate/Linkage.updateMentoringPrtcpArmyBatch/action',
          param,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              resolve(true);
            }
          },
          function (data) {
            gAlert('', data.body.docs[0].errMessage);
            console.log("error");
            // console.error('Error-updatePrtcpId' + data.body.docs[0].errMessage);
            reject(false);
          }
        );
      });
    }

    // 회원카드번호로 정보불러오기
    function searchMember(okData) {
      vm.data.ApplyId = okData.MemberId;
      var param1 = {
        ApplyId: okData.MemberId,
        mapCode: 'MentoringPrtcpArmy.getChkDupApplyId',
      };
      postApi.select(
        param1,
        function (json) {
          if (json.header.status === CONSTANT.HttpStatus.OK) {
            if (json.body.docs[0] == 0) {
              gAlert('', '등록된 정보를 불러옵니다.');
              var param2 = {MemberNo: okData.MemberNo};
              postApi.api(
                'extSelect/Linkage.getMentoringApplyArmyByMemberNo/action',
                param2,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docCnt === 0) {
                      gAlert('', '등록정보가 없습니다.');
                      return false;
                    } else {
                      vm.data.MemberNo = data.body.docs[0].MemberNo;
                      vm.data.MemberNm = data.body.docs[0].MemberNm;
                      vm.data.ArmyNo = data.body.docs[0].ArmyNo;
                      if ((data.body.docs[0].Birth.length = 8)) {
                        vm.data.ResRegNo = data.body.docs[0].Birth.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                      }
                      vm.data.Mobile = data.body.docs[0].Mobile.replace(/\s|-/g, '').replace(
                        /(\d{3})(\d{3,4})(\d{4})/,
                        '$1-$2-$3'
                      );
                      vm.data.Email = data.body.docs[0].Email;
                      if ((data.body.docs[0].InArmyDate.length = 8)) {
                        document.getElementById('dtInArmyDate').value = data.body.docs[0].InArmyDate.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                        vm.data.InArmyDate = data.body.docs[0].InArmyDate.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                      }
                      if ((data.body.docs[0].OutArmyDate.length = 8)) {
                        document.getElementById('dtOutArmyDate').value = data.body.docs[0].OutArmyDate.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                        vm.data.OutArmyDate = data.body.docs[0].OutArmyDate.replace(
                          /(\d{4})(\d{2})(\d{2})/,
                          '$1-$2-$3'
                        );
                      }
                      vm.ArmyClassList.Code = data.body.docs[0].ArmyClass;
                      vm.ArmyTypeList.Code = data.body.docs[0].ArmyType;
                      vm.SpecList.Code = data.body.docs[0].Spec;
                      vm.data.Spec = data.body.docs[0].Spec;
                      vm.data.PermStat = data.body.docs[0].PermStat;
                      document.getElementById('txtZipcode').value = data.body.docs[0].ZipCode;
                      document.getElementById('txtAddr1').value = data.body.docs[0].Address;
                      vm.data.AddressDetail = data.body.docs[0].AddressDetail;
                      vm.data.ClubId = okData.ClubId;
                      vm.data.ClubNm = okData.ClubNm;
                      vm.data.ClubRole = okData.ClubRole;
                      vm.data.ClubRole_ = okData.ClubRole_;
                      vm.data.TenantId = okData.LeaderTenantId;
                      vm.data.MentoUser = okData.LeaderMentoUser;
                      vm.data.MentoUser_ = okData.LeaderMentoUser_;
                      if (vm.data.ClubRole == '0') vm.data.MentoringArea = okData.MentoringArea;
                      getPrtcpSchoolList();
                      vm.disabled = true;
                      return true;
                    }
                  }
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-serchApplyId' + data.body.docs[0].errMessage);
                  return false;
                }
              );
            } else {
              gAlert('', '이미 등록된 회원입니다.');
              return false;
            }
          }
        },
        function (json) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', json.body.docs[0].errMessage);
          return false;
        }
      );
      return false;
    }

    function getPrtcpSchoolList() {
      var param = {
        MemberNo: vm.data.MemberNo,
      };
      postApi.api(
        'extSelect/Linkage.getMentoringPrtcpArmySchoolList/action',
        param,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0) {
              var jsonList = data.body.docs;

              jsonList = jsonList.reduce(function (acc, cur) {
                cur.OutSchDate = cur.MS_RET_YMD.replace(/(\d{4})(\d{2})/, '$1-$2');
                if (cur.MS_CODE.length === 2) {
                  cur.EduLev = cur.MS_CODE.substring(0, 1);
                  cur.OutSchYn = cur.MS_CODE.substring(1, 2);
                }
                acc.push(cur);
                return acc;
              }, []);

              if (jsonList == null || jsonList == '') {
                //gAlert('', '조회된 정보가 없습니다.');
              }
              $scope.EduJSON = jsonList;
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustSchoolList' + data.body.docs[0].errMessage);
        }
      );
    }

    var modalApplyarmyInstance = null;
    // var modalClubInstance = null;

    // 모달팝업 호출 (동아리팀)
    /*
    function showModalClubNameInfo() {
      if (modalClubInstance != null) {
        return;
      }
      
      if (typeof vm.data.ClubNm == 'undefined' || vm.data.ClubNm == '') {
        gAlert('','동아리팀을 입력해주세요');
        return false;
      }

      var paramData = {
        searchValue: vm.data.ClubNm,
        searchFrom: 'prtcp-edit',
      };

      modalClubInstance = modalFactory.open(
        'lg',
        'app/mentoring/modal/club-name-modal.html',
        'ClubNameModalCtrl as modalCtrl',
        paramData
      );

      modalClubInstance.result.then(
        function (okData) {
          if (!isNullOrEmpty(okData.ClubId) && okData.ClubId != '') {
            vm.data.ClubId = okData.ClubId;
          }
          if (!isNullOrEmpty(okData.ClubNm) && okData.ClubNm != '') {
            vm.data.ClubNm = okData.ClubNm;
          }
        },
        function (cancelData) {
        }
      );

      modalClubInstance = null;
    }
    */

    // 모달팝업 호출 (참여자)
    function showModalArmyInfo(type) {
      if (modalApplyarmyInstance != null || isNullOrEmpty(type)) {
        return;
      }

      var paramData = {
        searchValue: '',
        searchType: type,
      };

      if (type === 'MemberNm' ) {
        if (typeof vm.data.MemberNm == 'undefined' || vm.data.MemberNm == '') {
          gAlert('', '성명을 입력해주세요');
          return false;
        }
        paramData.searchValue = vm.data.MemberNm
      } else if (type === 'ArmyNo') {
        if (typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == '') {
          gAlert('', '군번을 입력해주세요');
          return false;
        }
        paramData.searchValue = vm.data.ArmyNo
      }

      var ctrl = 'ApplyTypeModalCtrl as modalCtrl';

      modalApplyarmyInstance = modalFactory.open(
        'lg',
        'app/mentoring/modal/apply-type-modal.html',
        ctrl,
        paramData
      );

      modalApplyarmyInstance.result.then(
        function (okData) {
          searchMember(okData);
        },
        function (cancelData) {
        }
      );
      modalApplyarmyInstance = null;
    }

    // 모달팝업 호출 (멘토)
    function showModalMentoUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.MentoUser_ = okData.UserNm;
          vm.data.MentoUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalMentoUser() {
      vm.data.MentoUser_ = '';
      vm.data.MentoUser = '';
    }


    // 학력 목록
    function getEduList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyEduList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.EduJSON = data.body.docs;
            } else {
              /*$scope.EduJSON = [];*/
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 학력 정보 저장
    function setDataEdu() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataEdu', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};
      data.paramList = $scope.EduJSON.reduce(function (acc, cur) {
        if (cur.EduLev) {
          cur.PrtcpId = vm.srch.PrtcpId;
          acc.push(cur);
        }
        //신규 생성
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'MentoringPrtcpArmy.updateMentoringPrtcpArmyEdu';
        postApi.update(data, successCallback, errorCallback);
      }
    }

    // 학력 정보 삭제
    function deleteEdu(idx) {
      var data = {
        PrtcpEduId: idx,
      };

      data.mapCode = 'MentoringPrtcpArmy.deleteMentoringPrtcpArmyEdu';

      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 자격증 목록
    /*
    function getLicenseList() {
      vm.srch.mapCode = 'Customerarmy.getCustomerarmylicenseList';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('prtcparmylicense', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.LicenseJSON = data.body.docs;
            } else {
              //$scope.LicenseJSON = [];
            }
            console.info('vm.lists -', vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.error('Error-getList', status, data);
        }
      );
    }

    // 자격증 정보 저장
    function setDataLicense() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.error('Error-setDataLicense', status, data);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};

      data.paramList = $scope.LicenseJSON.reduce(function (acc, cur) {
        if (typeof cur.LicenseNm != 'undefined' && cur.LicenseNm != '') {
          cur.PrtcpId = vm.srch.PrtcpId;
          acc.push(cur);
        }
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'MentoringPrtcpArmy.updateMentoringPrtcpArmyLicense';
        postApi.update(data, successCallback, errorCallback);
      }
    }

    // 자격증 정보 삭제
    function deleteLicense(idx) {
      var data = {
        CustArmyLicenseId: idx,
      };

      data.mapCode = 'MentoringPrtcpArmy.deleteMentoringPrtcpArmyLicense';
      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }

    // 경력 목록
    function getCareerList() {
      vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyCareerList';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('mentoringprtcparmycareer', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              $scope.CareerJSON = data.body.docs;
            } else {
              //$scope.CareerJSON = [];
            }
            console.info('vm.lists -', vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.error('Error-getList', status, data);
        }
      );
    }

    // 경력 정보 저장
    function setDataCareer() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.error('Error-setDataCareer', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {};

      data.paramList = $scope.CareerJSON.reduce(function (acc, cur) {
        if (typeof cur.WorkDateFrom != 'undefined' && cur.WorkDateFrom != '') {
          cur.PrtcpId = vm.srch.PrtcpId;
          acc.push(cur);
        }
        return acc;
      }, []);

      if (data.paramList.length > 0) {
        data.mapCode = 'MentoringPrtcpArmy.updateMentoringPrtcpArmyCareer';
        postApi.update(data, successCallback, errorCallback);
      }
    }

    // 경력 정보 삭제
    function deleteCareer(idx) {
      var data = {
        PrtcpCareerId: idx,
      };

      data.mapCode = 'MentoringPrtcpArmy.deleteMentoringPrtcpArmyCareer';

      postApi.update(
        data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            return;
          }
        },
        function (json) {
          console.error('fail', status, json);
          gAlert('', json.body.docs[0].errMessage);
        }
      );
    }
    */

    // 신청자 정보 저장
    function setDataMentoringApplyArmy() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataCareer', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {
        mapCode: 'MentoringApplyArmy.updateMentoringApplyArmyBatch',
        ApplyId: vm.data.ApplyId,
        ArmyClass: vm.data.ArmyClass,
        ArmyType: vm.data.ArmyType,
        PermStat: vm.data.PermStat,
        Spec: vm.data.Spec,
        InArmyDate: vm.data.InArmyDate,
        OutArmyDate: vm.data.OutArmyDate,
        // 동아리팀 및 역할 수정 불가
        // ClubId: vm.srch.ClubId,
        // ClubRole: vm.data.ClubRole,
        ResRegNo: vm.data.ResRegNo,
        Mobile: vm.data.Mobile,
        Email: vm.data.Email,
      };

      postApi.update(data, successCallback, errorCallback);
    }

    // 팀장 등록/수정 시 동아리정보 저장
    function setDataMentoringClub() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataCareer', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {
        mapCode: 'MentoringClub.updateMentoringClubBatch',
        ClubId: vm.data.ClubId,
        MentoringArea: vm.data.MentoringArea,
        ArmyType: vm.data.ArmyType,
        PermStat1: vm.data.PermStat1,
        PermStat2: vm.data.PermStat2,
        MentoUser: vm.data.MentoUser
      };

      postApi.update(data, successCallback, errorCallback);
    }

    // 동아리팀 팀원 정보 저장
    function setDataPrtcpMember() {
      var successCallback = function (json) {
        if (json.header.status === CONSTANT.HttpStatus.OK) {
          return true;
        }
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var errorCallback = function (json) {
        console.log("error");
        // console.error('Error-setDataCareer', status, json);
        gAlert('', json.body.docs[0].errMessage);
        return false;
      };

      var data = {
        mapCode: 'MentoringPrtcpArmy.updateMentoringPrtcpMemberBatch',
        ApplyId: vm.data.ApplyId,
        MentoringArea: vm.data.MentoringArea,
        MentoUser: vm.data.MentoUser,
      };

      postApi.update(data, successCallback, errorCallback);
    }

    // 데이터 조회
    getData();

    // 자동 저장 유효성검사
    function chkValidAuto() {
      if (typeof vm.data.PrtcpId == 'undefined' || vm.data.PrtcpId == ''
       || typeof vm.data.ApplyId == 'undefined' || vm.data.ApplyId == ''
       || typeof vm.data.MemberNm == 'undefined' || vm.data.MemberNm == ''
       || typeof vm.data.ArmyNo == 'undefined' || vm.data.ArmyNo == ''
       || typeof vm.data.ArmyClass == 'undefined' || vm.data.ArmyClass == ''
       || typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == ''
       || (vm.data.ClubRole != '0' && (typeof vm.data.MentoringArea == 'undefined' || vm.data.MentoringArea == ''))
       || typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == ''
       || typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == ''
       || typeof vm.data.Spec == 'undefined' || vm.data.Spec == ''
       || typeof vm.data.InArmyDate == 'undefined' || vm.data.InArmyDate == ''
       || typeof vm.data.OutArmyDate == 'undefined' || vm.data.OutArmyDate == ''
       || typeof vm.data.ResRegNo == 'undefined' || vm.data.ResRegNo == ''
       || typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
        return false;
      }
      return true;
    }

    // 자동 저장
    function setDataAuto() {
      if ($window.sessionStorage['isLoggedIn'] != 'Y') {
        return;
      }

      // 주소 값 저장
      vm.data.ZipCode = angular.element(document.getElementById('txtZipcode')).val();
      vm.data.Addr1 = angular.element(document.getElementById('txtAddr1')).val();

      if (!chkValidAuto()) {
        startTimer();
        return false;
      }

      angular.element(document.getElementById('txtZipcode')).val();

      if (vm.srch.PrtcpId == 0) {
        // 등록
        gConfirm(
          '',
          '자동저장 하시겠습니까?',
          {
            btn: '',
            fn: function () {
              vm.data.mapCode = 'MentoringPrtcpArmy.insertMentoringPrtcpArmyBatch';

              postApi.insert(
                vm.data,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docs[0].PrtcpId !== null) {
                      vm.srch.PrtcpId = data.body.docs[0].PrtcpId;
                      vm.data.PrtcpId = data.body.docs[0].PrtcpId;

                      setDataMentoringApplyArmy();
                      if (vm.data.ClubRole == '1') {
                        setDataMentoringClub();
                        setDataPrtcpMember();
                      }
                      setDataEdu(); // 학력 정보 저장
                      // setDataLicense(); // 자격증 정보 저장
                      // setDataCareer(); // 경력 정보 저장

                      startTimer();
                      return;
                    }
                  }
                  gAlert('', data.body.docs[0].errMessage);
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            },
          },
          {
            btn: '',
            fn: function () {
              startTimer();
              return;
            },
          }
        );
        return;
      } else {
        // 수정
        vm.data.mapCode = 'MentoringPrtcpArmy.updateMentoringPrtcpArmyBatch';

        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].PrtcpId !== null) {
                vm.srch.PrtcpId = data.body.docs[0].PrtcpId;
                vm.data.PrtcpId = data.body.docs[0].PrtcpId;

                setDataMentoringApplyArmy();
                if (vm.data.ClubRole == '1') {
                  setDataMentoringClub();
                  setDataPrtcpMember();
                }
                setDataEdu(); // 학력 정보 저장
                // setDataLicense(); // 자격증 정보 저장
                // setDataCareer(); // 경력 정보 저장

                startTimer();
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
    }

    var timer = null;

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
    });

    function startTimer() {
      timer = $timeout(setDataAuto, 300000); // 타이머 : 5문 = 5 * 60 * 1000
    }

    startTimer();
  },
]);

webapp.controller('MentoringPrtcpListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$http',
    '$timeout',
    function MentoringPrtcpListCtrl(
      $window,
      $scope,
      $location,
      $state,
      $stateParams,
      $rootScope,
      CONSTANT,
      modalFactory,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $http,
      $timeout
    ) {
      var vm = this;
      var EXCEL_SQL = 'Mentoring.getExcelMentoringPrtcpList';
      var EXCEL_TITLE = '창업멘토링 참여자';
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringprtcp-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      // 버튼 권한 체크
      $scope.showBtnExcel = true;
      $scope.showBtnDel = true;
      $scope.showBtnAdd = isPageAccess('mentoringprtcp-list', $window.sessionStorage['loginUserType'], false);
      vm.dataloader = false;
      vm.disabledArea = false;
  
      // 함수연결
      vm.showModalMentoUser = showModalMentoUser;
      vm.clearModalMentoUser = clearModalMentoUser;
      vm.deleteList = deleteList;
      vm.getExcel = getExcel;
      vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
  
      // 검색 조건
      vm.srch = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        TenantNm: $window.sessionStorage['loginTenantName'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        isMasking: 'Y',
      };

      // 데이터
      vm.data = {};

      // 페이징
      if ($stateParams.page === undefined || $stateParams.page === '') {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }
  
      vm.listSize = [10, 25, 50, 100];
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.viewSize = vm.viewSize;
  
      // 공통코드 정의
      vm.ArmyClassList = { // 계급
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1000',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ArmyTypeList = { // 군별
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1010',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        MentoringArea: '',
      };
      // vm.CounselField1List = {
      //   CommonCodeId: '',
      //   ParentCommonCodeId: '',
      //   CodeType: '1160',
      //   Code: '',
      //   CodeValue: '',
      //   TenantId: $window.sessionStorage['loginTenantId'],
      // };
      // vm.HopeDutyList = {
      //   CommonCodeId: '',
      //   ParentCommonCodeId: '',
      //   CodeType: '1200',
      //   Code: '',
      //   CodeValue: '',
      //   TenantId: $window.sessionStorage['loginTenantId'],
      // };
      // vm.HopeLocList1 = {
      //   CommonCodeId: '',
      //   ParentCommonCodeId: '',
      //   CodeType: '1030',
      //   Code: '',
      //   CodeValue: '',
      //   TenantId: $window.sessionStorage['loginTenantId'],
      // };
      // vm.HopeLocList2 = {
      //   CommonCodeId: '',
      //   ParentCommonCodeId: '',
      //   CodeType: '1210',
      //   Code: '',
      //   CodeValue: '',
      //   TenantId: $window.sessionStorage['loginTenantId'],
      // };
      // vm.LinkageYNList = {
      //   CommonCodeId: '',
      //   ParentCommonCodeId: '',
      //   CodeType: '1280',
      //   Code: '',
      //   CodeValue: '',
      //   TenantId: $window.sessionStorage['loginTenantId'],
      // };
  
      /*vm.ApprYNList = {
          CommonCodeId:'',
          ParentCommonCodeId:'',
          CodeType:'1080',
          Code:'',
          CodeValue:'',
          TenantId:$window.sessionStorage['loginTenantId'],      
        }  */

      vm.PermStat1List = {
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      vm.onSelectCallback = function (data) {
        if (data.Code == null) data.Code = '';
  
        if (data.CodeType == '1000') {
          vm.srch.ArmyClass = data.Code;
        // } else if (data.CodeType == '1200') {
        //   /*} else if (data.CodeType == '1080') {
        //     vm.srch.ApprYN = data.Code;              
        //   }*/
        //   vm.srch.HopeDuty = data.Code;
  
        //   if (data.Code == '110') {
        //     $scope.HopeDutyEtcShow = true;
        //   } else {
        //     $scope.HopeDutyEtcShow = false;
        //     vm.srch.HopeDutyEtc = '';
        //   }
        // } else if (data.CodeType == '1030' || data.CodeType == '1210') {
        //   vm.srch.HopeLoc = data.Code;
        // } else if (data.CodeType == '1280') {
        //   vm.srch.LinkageYN = data.Code;
        }
      };

      vm.onMentoringAreaListSelected = function () {
        var data = vm.srch.MentoringAreaObj;
        if (data == null) {
          vm.srch.MentoringArea = '';
          vm.PermStat1List.MentoringArea = '';
          vm.ArmyTypeList.MentoringArea = '';
          return;
        }

        vm.srch.MentoringArea = data.Code;

        vm.PermStat1List.MentoringArea = data.Code;
        vm.ArmyTypeList.MentoringArea = data.Code;
      };

      vm.onArmyTypeListSelected = function (data) {
        vm.PermStat1List.CodeType = '1380';
        vm.PermStat1List.ParentCommonCodeId = '';
  
        if (data.Code == null) {
          vm.srch.ArmyType = '';
          return;
        }
  
        vm.srch.ArmyType = data.Code;
        vm.data.MentoringAreaType = data.Code;
        vm.PermStat1List.ParentCommonCodeId = vm.data.MentoringAreaType;
  
        if (data.Code == null) data.Code = '';
      };
  
      vm.onPermStat1ListSelected = function (data) {
        if (data.Code == null) {
          vm.srch.PermStat1 = '';
          return;
        }
  
        vm.srch.PermStat1 = data.Code;
        vm.srch.PermStat2 = '';
      };

      /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
      if ($window.sessionStorage.getItem('mentoringprtcp-list-ctrl') != null) {
        if (
          $rootScope.previousPage != null &&
          ($rootScope.previousPage.indexOf('/app/mentoring/prtcp-edit') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/prtcp-detail') !== -1 ||
            $rootScope.previousPage.indexOf('/app/mentoring/prtcp-list') !== -1)
        ) {
          vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('mentoringprtcp-list-ctrl')));
  
          vm.data.MentoringAreaObj = {
            Code: vm.srch.MentoringArea,
            CodeValue: vm.srch.MentoringArea,
          };
          // vm.ArmyClassList.Code = vm.srch.ArmyClass;
          // vm.ArmyTypeList.Code = vm.srch.ArmyType;
          // vm.PermStat1List.Code = vm.srch.PermStat1;
          // vm.PermStat2List.Code = vm.srch.PermStat2;

          $scope.dtPrtcpDateFrom = setNewDate(vm.srch.PrtcpDateFrom);
          $scope.dtPrtcpDateTo = setNewDate(vm.srch.PrtcpDateTo);
  
          vm.currentPage = vm.srch.page;
        }
      }
  
      // 엑셀 정보
      vm.excel = {
        downFileName: 'mentoringprtcp',
        subject: '창업멘토링 참여자 목록',
        /*header : [ {
            field : 'FreeBoardId',
            title : '번호',
            width : '5',
            format : 'number'
          }, {          
            field : 'ReadCnt',
            title : '조회수',
            width : '5',
            format : 'string'
          } ],*/
      };
  
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
  
        vm.chkHead = true;
      };
  
      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };
  
      // 유효성검사
      function chkValid() {

        if (
          vm.srch.PrtcpDateFrom != null &&
          vm.srch.PrtcpDateFrom != '' &&
          vm.srch.PrtcpDateTo != null &&
          vm.srch.PrtcpDateTo != ''
        ) {
          if (getDateToNumber(vm.srch.PrtcpDateFrom) > getDateToNumber(vm.srch.PrtcpDateTo)) {
            gAlert('', '등록일 날짜범위가 잘못되었습니다.');
            return false;
          }
        }
  
        return true;
      }

      function getTenantAreaList() {
        vm.srch.mapCode = 'Business.getTenantArea';
        postApi.select(
          vm.srch,
          function (data) {
            var resultData = postApi.makeResultData(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (resultData.body.docs[0] != null) {
                var areaList = resultData.body.docs[0].TenantArea.split(',');
                vm.MentoringAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                if (vm.MentoringAreaList.length === 1) {
                  vm.srch.MentoringAreaObj = vm.MentoringAreaList[0];
                  vm.srch.MentoringArea = vm.srch.MentoringAreaObj.Code;
                }
              } else {
                vm.srch.MentoringAreaList = [];
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData' + data.body.docs[0].errMessage);
          }
        );
      }
  
      // 목록 조회
      function getList() {
        if (!chkValid()) return false;
  
        getTenantAreaList();
  
        vm.srch.page = vm.currentPage;
  
        /* if (vm.srch.ArmyArea == undefined || vm.srch.ArmyArea == '') {
          vm.srch.ArmyArea = [];
          if ($window.sessionStorage['loginArmyZone1YN'] == 'Y') {
            vm.srch.ArmyArea.push('010');
          }
          if ($window.sessionStorage['loginArmyZone2YN'] == 'Y') {
            vm.srch.ArmyArea.push('020');
          }
          if ($window.sessionStorage['loginArmyZone3YN'] == 'Y') {
            vm.srch.ArmyArea.push('030');
          }
          if ($window.sessionStorage['loginArmyZone4YN'] == 'Y') {
            vm.srch.ArmyArea.push('040');
          }
          if ($window.sessionStorage['loginArmyZone5YN'] == 'Y') {
            vm.srch.ArmyArea.push('050');
          }
        }
        console.log('vm.srch', vm.srch); */
  
        vm.dataloader = true;
        getListCount();

        $window.sessionStorage.setItem('mentoringprtcp-list-ctrl', angular.toJson(vm.srch));

        vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyList';
        console.log(vm.srch);
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.lists = resultData.body.docs;

              // vm.lists = data.body.docs;
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
  
        /*   var prms = api.doList().post(vm.srch).$promise;
  
          prms.then(function(data) {
            vm.dataloader = false;
            if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {           
              if (data.responseVO.body.docs.length > 0) {
                vm.lists = data.responseVO.body.docs;
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
              console.info("vm.lists -", vm.lists);
            } else {
              console.info("else ");
            }
          }, function(error) {
            vm.dataloader = false;
            console.error('Error-getList', status, data);
          }); */
      }
  
      // 목록카운트 조회
      function getListCount() {
        vm.srch.mapCode = 'MentoringPrtcpArmy.getMentoringPrtcpArmyListCnt';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.totalItems = data.body.docs[0];
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }
  
      // 목록 삭제
      function deleteList() {
        gConfirm(
          '',
          'Menu.DELETECONFIRM',
          {
            btn: '',
            fn: function () {
              deleteListAction();
            },
          },
          {
            btn: '',
            fn: function () {},
          }
        );
      }
  
      function deleteListAction() {
        vm.data.PrtcpIds = [];
  
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.data.PrtcpIds.push(vm.lists[i].PrtcpId);
          }
        }
        vm.dataloader = true;
  
        if (vm.data.PrtcpIds == null || vm.data.PrtcpIds.length == 0) {
          gAlert('', '선택된 참여자가 없습니다.');
          return false;
        }

        postApi.api(
          'extUpdate/Linkage.deleteMentoringPrtcpArmyBatch/action',
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              vm.data.mapCode = 'MentoringPrtcpArmy.deleteMentoringPrtcpArmyBatch';
              postApi.update(
                vm.data,
                function (data) {
                  vm.dataloader = false;
                  if (data.header.status == CONSTANT.HttpStatus.OK) {
                    gAlert('', 'Menu.DELETED', {
                      btn: '',
                      fn: function () {
                        $state.reload();
                      },
                    });
                  }
                },
                function (data) {
                  vm.dataloader = false;
                  console.log("error");
                  // console.error('fail', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            }
          },
          function (data) {
            gAlert('', data.body.docs[0].errMessage);
            console.log("error");
            // console.error('Error-updatePrtcpId' + data.body.docs[0].errMessage);
          }
        );
      }
  
      // 모달팝업 호출 (상담사)
      function showModalMentoUser() {
        var ctrl = 'User2ModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            vm.srch.MentoUser_ = okData.UserNm;
            vm.srch.MentoUser = okData.UserId;
            //console.log('vm.srch:', vm.srch);
          },
          function (cancelData) {}
        );
      }
  
      // 모달팝업 데이터 삭제 (상담사)
      function clearModalMentoUser() {
        vm.srch.MentoUser_ = '';
        vm.srch.MentoUser = '';
      }
  
      // 페이징 관련
      function pageChanged() {
        getList();
      }
  
      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }
  
      function setDownloadHistory(DownloadReason) {
        var log = {};
  
        log.DownloadIP = $window.sessionStorage['loginIP'];
        log.DownloadReason = DownloadReason;
        log.ScreenNm = '멘토링신청자목록';
        log.ScreenUrl = 'app/mentoring/mentoringprtcp-list';
  
        log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
        postApi.insert(log, function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              getExcel();
            }
          }
        });
      }
  
      // 모달팝업 호출 (다운로드사유)
      function showModalDownloadReason() {
        var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            setDownloadHistory(okData);
          },
          function (cancelData) {}
        );
      }
  
      // 엑셀 다운로드 체크여부 조회
      function getExcelDownloadCheckYn() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
  
        postApi.select(
          vm.srch,
          function (data) {
            //console.log("DownloadCheckYn", data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.DownloadCheckYn = data.body.docs;
                if (vm.DownloadCheckYn == 'Y') {
                  showModalDownloadReason();
                } else {
                  setDownloadHistory('');
                }
              } else {
                console.info('else ');
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getDownloadCheckYn', status, data);
          }
        );
      }
    
      // 엑셀 다운로드
      function getExcel() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        var header = [];
        var a = document.createElement('a');
        document.body.appendChild(a);
        var strFormat = 'string';
        var strWidth = '20';
        var numFormat = 'number2';
        var numWidth = '20';
  
        //헤더 설정..공통사용 불가
        obj = {};
        obj.title = '성명';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MemberNm';
        header.push(obj);

        obj = {};
        obj.title = '군번';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyNo';
        header.push(obj);

        obj = {};
        obj.title = '군별';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyType';
        header.push(obj);

        obj = {};
        obj.title = '계급';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyClass';
        header.push(obj);

        obj = {};
        obj.title = '소속부대';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'PermStat';
        header.push(obj);

        obj = {};
        obj.title = '복무구분';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Term';
        header.push(obj);

        obj = {};
        obj.title = '학교소재지';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Loc_';
        header.push(obj);

        obj = {};
        obj.title = '동아리팀';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubNm';
        header.push(obj);

        obj = {};
        obj.title = '팀정보';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubRole';
        header.push(obj);

        obj = {};
        obj.title = '멘토';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoUser_';
        header.push(obj);

        obj = {};
        obj.title = '등록일';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'PrtcpDate';
        header.push(obj);
        // 헤더설정 End
  
        vm.srch.header = header;
        vm.srch.downFileName = '창업멘토링 참여자 목록';
  
        vm.srch.userkey = $rootScope.gVariable.userKey;
  
        $http({
          url: StaticVariable.getUrl(
            '/excel/MentoringPrtcpArmy.getExcelMentoringPrtcpList/action.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: vm.srch, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var fileName = vm.srch.downFileName;
            var blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
            });
            if (window.navigator && window.navigator.msSaveBlob) {
              fileName = fileName + '.xlsx';
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              a.href = objectUrl;
              a.download = fileName;
              a.click();
            }
          })
          .error(function (data, status, headers, config) {
            //download failed
          });
      }
  
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      vm.setSortColumn = function (sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;
  
        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = 'ASC';
        } else {
          //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
          vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
        }
  
        vm.srch.sortColumn = sortColumn;
  
        // 조회
        getList();
      };
  
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      vm.setSortDirect = function (sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }
  
        var rtnval = '';
  
        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      };
  
      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
  
      // 데이터 조회
      getList();
    },
  ]);
  
webapp.controller('MentoringrecordDetailCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  'modalFactory',
  function MentoringrecordDetailCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalWindow,
    postApi,
    gAlert,
    gConfirm,
    modalFactory
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringrecord-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnEdit = isPageAccess('mentoringrecord-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnDel = true;

    // 함수 연결
    vm.deleteDetail = deleteDetail;
    vm.openPrintModal = openPrintModal;

    // 검색 데이터
    vm.srch = {
      RecordId: $stateParams.RecordId,
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'MentoringRecord',
      IdName: 'RecordId',
      uploadFileList: [],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 조회 데이터
    vm.data = {};
    vm.uploadFileList = [];

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getData() {
      if (vm.srch.RecordId === null || vm.srch.RecordId === '') {
        return;
      }

      vm.srch.mapCode = 'MentoringRecord.getMentoringRecordDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].RecordId !== null) {
              vm.data = data.body.docs[0];
              
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    '/attach/file/' + item.PhysicalFileNm +
                    '/download.do?path=' + item.PhysicalPath +
                    '&fileName=' + item.LogicalFileNm +
                    '&userkey=' + $rootScope.gVariable.userkey
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          console.log('Error> mentoringrecordDetailCtrl> getData> ', data.body.docs[0].errMessage);
        }
      );
    }

    function deleteDetail() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteDetailAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteDetailAction() {
      if (vm.srch.RecordId === null || vm.srch.RecordId === '') {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      vm.data.mapCode = 'MentoringRecord.deleteMentoringRecordDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.go('app.mentoring.mentoringrecord-list');
              },
            });
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function openPrintModal() {
      $rootScope.windowOpen(
        '/#/popup/mentoringrecord-print-modal/' + vm.srch.RecordId,
        'mentoringrecord-print-modal'
      );
    }

    // 데이터 조회
    getData();
  },
]);

webapp.controller('MentoringrecordEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$http',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$timeout',
  function MentoringrecordEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    $http,
    CONSTANT,
    StaticVariable,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $timeout
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringrecord-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 조회 데이터
    vm.data = {};

    // 함수연결
    vm.showModalClubInfo = showModalClubInfo;
    vm.clearModalClubInfo = clearModalClubInfo;
    vm.showModalMentoUser = showModalMentoUser;
    vm.clearModalMentoUser = clearModalMentoUser;
    vm.beforeSetData = beforeSetData;
    vm.getData = getData;
    vm.setData = setData;
    vm.dataloader = false;
    vm.disabledArea = false;
    vm.isMento = $window.sessionStorage['loginUserType'] == '030' ? true : false;
    vm.uploadFileList = [];
    $scope.uploadLocation = 'MentoringRecordEdit';
    $scope.MaxFileSize = 3145728;
    $scope.nowFileCnt = 0;
    $scope.MaxFileCnt = 4;
    $scope.FileType = ['image/jpeg','image/gif','image/png'];

    (function MentoringrecordEditCtrl() {
      if ($stateParams.ClubId) {
        var srchClub = {
          ClubId: $stateParams.ClubId,
          TableNm: 'mentoringclub',
          userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        };

        srchClub.mapCode = 'MentoringClub.getMentoringClubDetail';

        postApi.select(
          srchClub,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt !== 0 && data.body.docs[0].ClubId !== null) {
                var okData = data.body.docs[0];

                vm.data.ClubNm = okData.ClubNm;

                setClubData(okData);
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            console.log('Error> mentoringrecordEditCtrl> getData> ', data.body.docs[0].errMessage);
          }
        );
      }
    })();

    // 공통코드 정의
    vm.ProgressList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1400',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringRoundList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1110',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringTimeFromHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringTimeFromMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringTimeToHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringTimeToMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringDateHopeNextHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringDateHopeNextMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.MentoringMethodList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1270',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.MentoringDateHopeNextHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.MentoringDateHopeNextMin = data.Code;
      } else if (data.CodeType == '1270') {
        vm.data.MentoringMethod = data.Code;
        vm.data.MentoringMethodValue = data.CodeValue;
      } else if (data.CodeType == '1400') {
        vm.data.Progress = data.Code;
      }
    };

    vm.onSelectCallback2 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.MentoringTimeFromHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.MentoringTimeFromMin = data.Code;
      }
    };

    vm.onSelectCallback3 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.MentoringTimeToHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.MentoringTimeToMin = data.Code;
      }
    };

    vm.onFileCallback = {
      onFileUploadComplete: function () {
      },
      onFileDelete: function (item) {
        var param = {
          fileId: item.id,
        };
        postApi.attach('file/delete', param, function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED');
          }
        });
      },
    };

    // 검색 데이터
    vm.srch = {
      RecordId: $stateParams.RecordId === undefined ? '' : $stateParams.RecordId,
      UserId: $window.sessionStorage['loginUserIdx'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TableNm: 'MentoringRecord',
      IdName: 'RecordId',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      uploadFileList: [],
    };

    // 기본값
    if (vm.srch.RecordId == 0) {
      if (vm.isMento) {
        vm.data.MentoUser_ = $window.sessionStorage['loginUserName'];
        vm.data.MentoUser = $window.sessionStorage['loginUserIdx'];
      }
      $scope.dtMentoringDate = setNewDate(getToday());
      vm.data.MentoringDate = getToday();
    }

    // 소속데이터권한 목록
    function getArmyInfoList() {
      vm.srch.mapCode = 'User.getUserarmyinfoList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyInfoList = data.body.docs;
              angular.forEach(vm.ArmyInfoList, function (item) {
                if (item.ArmyArea == '050' || $window.sessionStorage['loginArmyZone5YN'] == 'Y') {
                  vm.ArmyArea5YN = 'Y';
                }
              });
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 유효성검사
    function chkValid() {
      if (typeof vm.data.ClubNm == 'undefined' || vm.data.ClubNm == '') {
        gAlert('', '동아리팀을 선택해주세요', {
          fn: function () {
            vm.showModalClubInfo();
          },
        });
        angular.element('input[ng-value="vc.data.ClubNm"]').focus();
        return false;
      }

      if (typeof vm.data.MentoringRound == 'undefined' || vm.data.MentoringRound == '') {
        gAlert('', '상담회차를 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringRoundList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringMethod == 'undefined' || vm.data.MentoringMethod == '') {
        gAlert('', '상담방법을 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringMethodList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoUser == 'undefined' || vm.data.MentoUser == '') {
        gAlert('', '멘토를 선택해주세요', {
          fn: function () {
            vm.showModalMentoUser();
          },
        });
        angular.element('input[ng-value="vc.data.MentoUser_"]').focus();
        return false;
      }

      if (typeof vm.data.Progress == 'undefined' || vm.data.Progress == '') {
        gAlert('', '진행상태를 선택해주세요');
        angular.element('common-code[param-data="vc.ProgressList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringDate == 'undefined' || vm.data.MentoringDate == '') {
        gAlert('', '상담일자를 선택해주세요');
        angular.element('input[ng-model="dtMentoringDate"]').focus();
        return false;
      }

      if (typeof vm.data.MentoringTimeFromHour == 'undefined' || vm.data.MentoringTimeFromHour == '') {
        gAlert('', '상담시간 시작시를 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringTimeFromHourList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringTimeFromMin == 'undefined' || vm.data.MentoringTimeFromMin == '') {
        gAlert('', '상담시간 시작분을 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringTimeFromMinList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringTimeToHour == 'undefined' || vm.data.MentoringTimeToHour == '') {
        gAlert('', '상담시간 종료시를 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringTimeToHourList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringTimeToMin == 'undefined' || vm.data.MentoringTimeToMin == '') {
        gAlert('', '상담시간 종료분을 선택해주세요');
        angular.element('common-code[param-data="vc.MentoringTimeToMinList"]').children('select').focus();
        return false;
      }

      if (typeof vm.data.MentoringDateHopeNext != 'undefined' && vm.data.MentoringDateHopeNext != '') {
        if (typeof vm.data.MentoringDateHopeNextHour == 'undefined' || vm.data.MentoringDateHopeNextHour == '') {
          gAlert('', '다음상담희망일을 입력한 경우 희망 시간을 선택해야합니다.');
          angular.element('common-code[param-data="vc.MentoringDateHopeNextHourList"]').children('select').focus();
          return false;
        }
        if (typeof vm.data.MentoringDateHopeNextMin == 'undefined' || vm.data.MentoringDateHopeNextMin == '') {
          gAlert('', '다음상담희망일을 입력한 경우 희망 분을 선택해야합니다.');
          angular.element('common-code[param-data="vc.MentoringDateHopeNextMinList"]').children('select').focus();
          return false;
        }
      }

      if (typeof vm.data.Title == 'undefined' || vm.data.Title == '') {
        gAlert('', '제목을 입력해주세요.');
        angular.element('input[ng-model="vc.data.Title"]').focus();
        return false;
      }

      if (typeof vm.data.Content == 'undefined' || vm.data.Content == '') {
        gAlert('', '내용을 입력해주세요.');
        angular.element('input[ng-model="vc.data.Content"]').focus();
        return false;
      }

      return true;
    }

    // 조회
    function getData() {
      // 상담방법 초기값 설정
      if (typeof vm.data.MentoringMethod == 'undefined' || vm.data.MentoringMethod == '') {
        vm.data.MentoringMethod = '2';
        vm.MentoringMethodList.Code = '2';
      }

      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0]) {
              var list = data.body.docs[0].TenantArea.split(',');
              vm.MentoringAreaList = list.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.MentoringAreaList.length === 1) {
                vm.data.MentoringAreaObj = vm.MentoringAreaList[0];
                vm.data.MentoringArea = vm.data.MentoringAreaObj.Code;
              }
            } else {
              vm.MentoringAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList' + data.body.docs[0].errMessage);
        }
      );

      if (vm.srch.RecordId == null || vm.srch.RecordId == '') {
        return;
      }

      vm.dataloader = true;

      vm.srch.mapCode = 'MentoringRecord.getMentoringRecordDetail';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0 && data.body.docs[0].RecordId !== null) {
              vm.data = data.body.docs[0];

              // 수동 메핑 항목 설정/
              vm.data.MentoringAreaObj = {
                Code: vm.data.MentoringArea,
                CodeValue: vm.data.MentoringArea,
              };
              vm.MentoringTimeFromHourList.Code = vm.data.MentoringTimeFromHour;
              vm.MentoringTimeFromMinList.Code = vm.data.MentoringTimeFromMin;
              vm.MentoringTimeToHourList.Code = vm.data.MentoringTimeToHour;
              vm.MentoringTimeToMinList.Code = vm.data.MentoringTimeToMin;
              vm.MentoringRoundList.Code = vm.data.MentoringRound;
              vm.MentoringDateHopeNextHourList.Code = vm.data.MentoringDateHopeNextHour;
              vm.MentoringDateHopeNextMinList.Code = vm.data.MentoringDateHopeNextMin;
              vm.MentoringMethodList.Code = vm.data.MentoringMethod;
              vm.ProgressList.Code = vm.data.Progress;

              $scope.dtMentoringDate = setNewDate(vm.data.MentoringDate);
              $scope.dtMentoringDateHopeNext = setNewDate(vm.data.MentoringDateHopeNext);

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    '/attach/file/' + item.PhysicalFileNm +
                    '/download.do?path=' + item.PhysicalPath +
                    '&fileName=' + item.LogicalFileNm +
                    '&userkey=' + $rootScope.gVariable.userKey
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: '',
                };
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.uploadFileList);
              $scope.nowFileCnt += vm.uploadFileList.length;

              $timeout(function () {
                vm.dataloader = false;
              }, 500);
              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          console.log('Error> mentoringrecordEditCtrl> getData> ', data.body.docs[0].errMessage);
        }
      );
    }

    // 모달팝업 호출 (동아리팀)
    function showModalClubInfo() {
      var paramData = {
        searchValue: vm.data.ClubNm,
        searchFrom: 'record-edit',
      };

      var modalInstance = modalFactory.open(
        'modal',
        'app/mentoring/modal/club-name-modal.html',
        'ClubNameModalCtrl as modalCtrl',
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          if (!isNullOrEmpty(okData.ClubId) && okData.ClubId != '') {
            vm.data.ClubId = okData.ClubId;
          }
          if (!isNullOrEmpty(okData.ClubNm) && okData.ClubNm != '') {
            vm.data.ClubNm = okData.ClubNm;
          }
          if (!isNullOrEmpty(okData.Progress) && okData.Progress != '') {
            vm.data.Progress = okData.Progress;
            vm.ProgressList.Code = vm.data.Progress;
          }
          setClubData(okData);
        },
        function (cancelData) {}
      );
    }

    function setClubData(okData) {
      if (okData.MentoringCnt < okData.MentoringNum) {
        vm.MentoringRoundList.Code = okData.MentoringCnt + 1;
        vm.data.MentoringRound = okData.MentoringCnt + 1;
      } else {
        gAlert('', okData.MentoringNum + '회차 상담까지 모두 입력이 완료되었습니다.');
        return;
      }
      vm.data.MentoringArea = okData.MentoringArea;

      vm.data.ClubId = okData.ClubId;
      vm.data.MentoringAreaObj = {
        Code: vm.data.MentoringArea,
        CodeValue: vm.data.MentoringArea,
      };
    }

    // 모달팝업 데이터 삭제 (동아리팀)
    function clearModalClubInfo() {
      vm.data.ClubNm = '';
      vm.data.ClubId = '';
      vm.data.MentoringAreaObj = null;
    }

    // 모달팝업 호출 (멘토)
    function showModalMentoUser() {
      if (vm.isMento) {
        gAlert('','해당 기능에 대한 권한이 없습니다.');
        return;
      }
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.data.MentoUser_ = okData.UserNm;
          vm.data.MentoUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalMentoUser() {
      if (vm.isMento) {
        gAlert('','해당 기능에 대한 권한이 없습니다.');
        return;
      }
      vm.data.MentoUser_ = '';
      vm.data.MentoUser = '';
    }

    function beforeSetData() {
      if (!isNullOrEmpty(vm.data.MentoringDateHopeNext)) {
        gConfirm('', '멘토링 일정에 다음상담일시가 자동등록됩니다.', {
          btn: '확인', fn: function() {
            setData();
            setDataNextMentoringSchedule();
          }
        }, {
          btn: '취소', fn: function() {
            console.log('cancel save');
          }
        });
      } else {
        setData();
      }
    }

    // 저장버튼 더블클릭 방지용 변수 선언 2020-02-19 김준권
    vm.saveButtonDisable = false;
    // 저장
    function setData() {
      if (!chkValid()) return false;

      vm.dataloader = true;
      if(!isNullOrEmpty(vm.uploadFileList)) vm.data.uploadFileList = vm.uploadFileList;

      var successCallback = function (data) {
        console.log('MentoringRecord save');
        vm.dataloader = false;
        $state.go('app.mentoring.mentoringrecord-list');
      };

      var errorCallback = function (error) {
        console.log("error");
        // console.error('Error-setData', status, data);
        vm.dataloader = false;
      };
      if (vm.srch.RecordId == 0) {
        // 등록
        vm.data.mapCode = 'MentoringRecord.insertMentoringRecordDetailBatch';
        postApi.insert(vm.data, successCallback, errorCallback);
      } else {
        // 수정
        vm.data.mapCode = 'MentoringRecord.updateMentoringRecordDetailBatch';
        postApi.update(vm.data, successCallback, errorCallback);
      }
    }

    // 멘토링일정 등록
    function setDataNextMentoringSchedule() {

    }
    // 등록/수정 컬럼 조회
    // 데이터 조회
    getData();

    // 유효성검사
    function chkValidAuto() {
      if (typeof vm.data.ClubNm == 'undefined' || vm.data.ClubNm == ''
       || typeof vm.data.MentoringRound == 'undefined' || vm.data.MentoringRound == ''
       || typeof vm.data.MentoUser == 'undefined' || vm.data.MentoUser == ''
       || typeof vm.data.MentoringDate == 'undefined' || vm.data.MentoringDate == ''
       || typeof vm.data.MentoringTimeFromHour == 'undefined' || vm.data.MentoringTimeFromHour == ''
       || typeof vm.data.MentoringTimeFromMin == 'undefined' || vm.data.MentoringTimeFromMin == ''
       || typeof vm.data.MentoringTimeToHour == 'undefined' || vm.data.MentoringTimeToHour == ''
       || typeof vm.data.MentoringTimeToMin == 'undefined' || vm.data.MentoringTimeToMin == ''
       || typeof vm.data.Title == 'undefined' || vm.data.Title == ''
       || typeof vm.data.Content == 'undefined' || vm.data.Content == '') {
        return false;
      }

      if (typeof vm.data.MentoringDateHopeNext != 'undefined' && vm.data.MentoringDateHopeNext != '') {
        if (typeof vm.data.MentoringDateHopeNextHour == 'undefined' || vm.data.MentoringDateHopeNextHour == '') {
          return false;
        }
        if (typeof vm.data.MentoringDateHopeNextMin == 'undefined' || vm.data.MentoringDateHopeNextMin == '') {
          return false;
        }
      }

      return true;
    }

    // 저장
    function setDataAuto() {
      if ($window.sessionStorage['isLoggedIn'] != 'Y') {
        return;
      }

      if (!chkValidAuto()) {
        startTimer();
        return false;
      }

      if (vm.srch.RecordId == 0) {
        // 등록
        gConfirm(
          '',
          '자동저장 하시겠습니까?',
          {
            btn: '',
            fn: function () {
              vm.data.mapCode = 'MentoringRecord.insertMentoringRecordDetailBatch';

              postApi.insert(
                vm.data,
                function (data) {
                  if (data.header.status === CONSTANT.HttpStatus.OK) {
                    if (data.body.docs[0].RecordId !== null) {
                      // KeyId 조회
                      vm.srch.RecordId = data.body.docs[0].RecordId;
                      vm.data.RecordId = data.body.docs[0].RecordId;
                      startTimer();
                      return;
                    }
                  } else {
                    gAlert('', data.body.docs[0].errMessage);
                  }
                },
                function (data) {
                  console.log("error");
                  // console.error('Error-setData', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            },
          },
          {
            btn: '',
            fn: function () {
              startTimer();
              return;
            },
          }
        );
        return;
      } else {
        // 수정
        vm.data.mapCode = 'MentoringRecord.updateMentoringRecordDetailBatch';

        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].RecordId !== null) {
                // KeyId 조회
                vm.srch.RecordId = data.body.docs[0].RecordId;
                vm.data.RecordId = data.body.docs[0].RecordId;
                startTimer();
                return;
              }
            } else {
              gAlert('', data.body.docs[0].errMessage);
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }
    }

    var timer = null;

    $scope.$on('$destroy', function () {
      $timeout.cancel(timer);
    });

    function startTimer() {
      timer = $timeout(setDataAuto, 300000); // 타이머 : 5문 = 5 * 60 * 1000
    }

    startTimer();
    getArmyInfoList();
  },
]);

webapp.controller('MentoringrecordListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function MentoringrecordListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringrecord-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    $scope.showBtnDel = true;
    $scope.showBtnLinkageYN = true;
    $scope.showBtnAdd = isPageAccess('mentoringrecord-edit', $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.showModalMentoUser = showModalMentoUser;
    vm.clearModalMentoUser = clearModalMentoUser;
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.deleteList = deleteList;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
    vm.disabledArea = false;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 데이터
    vm.data = {};

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];
    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 공통코드 정의
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    vm.MentoringRoundList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1110',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1010') {
        vm.srch.ArmyType = data.Code;
      } else if (data.CodeType == '1110') {
        vm.srch.MentoringRound = data.Code;
      }
    };

    vm.onMentoringAreaListSelected = function () {
      var data = vm.srch.MentoringAreaObj;
      if (data == null) {
        vm.srch.MentoringArea = '';
        vm.PermStat1List.MentoringArea = '';
        vm.ArmyTypeList.MentoringArea = '';
        return;
      }
      vm.srch.MentoringArea = data.Code;
      vm.ArmyTypeList.MentoringArea = data.Code;
      vm.PermStat1List.MentoringArea = data.Code;
    };

    vm.PermStat1List = {
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };
    vm.PermStat2List = '';

    vm.onArmyTypeListSelected = function (data) {
      // console.log('onArmyTypeListSelected=', data);

      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;

      vm.PermStat1List.ParentCommonCodeId = data.Code;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      // console.log('onPermStat1ListSelected=', data);

      vm.PermStat2List.CodeType = '';
      vm.PermStat2List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
      vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
    };

    vm.onPermStat2ListSelected = function (data) {
      if (data == null) {
        vm.srch.PermStat2 = '';
        return;
      }

      vm.srch.PermStat2 = data.Code;
    };

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('mentoringrecord-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/mentoring/record-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/mentoring/record-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/mentoring/record-list') !== -1)
      ) {
        vm.srch = JSON.parse(postApi.makeResultData($window.sessionStorage.getItem('mentoringrecord-list-ctrl')));

        vm.ArmyTypeList.Code = vm.srch.ArmyType;
        vm.PermStat1List.Code = vm.srch.PermStat1;
        vm.MentoringRoundList.Code = vm.srch.MentoringRound;

        $scope.dtMentoringDateFrom = setNewDate(vm.srch.MentoringDateFrom);
        $scope.dtMentoringDateTo = setNewDate(vm.srch.MentoringDateTo);

        vm.currentPage = vm.srch.page;
      }
    }

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      if (
        vm.srch.MentoringDateFrom != null &&
        vm.srch.MentoringDateFrom != '' &&
        vm.srch.MentoringDateTo != null &&
        vm.srch.MentoringDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.MentoringDateFrom) > getDateToNumber(vm.srch.MentoringDateTo)) {
          gAlert('', '상담일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      return true;
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      if (!chkValid()) return false;
      vm.srch.mapCode = 'Business.getTenantArea';
      postApi.select(
        vm.srch,
        function (data) {
          var resultData = postApi.makeResultData(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            // if (data.body.docs[0] != null) {
            if (resultData.body.docs[0] != null) {

              var areaList = resultData.body.docs[0].TenantArea.split(',');
              vm.MentoringAreaList = areaList.reduce(function (acc, cur) {
                var obj = { Code: cur, CodeValue: cur };
                acc.push(obj);
                return acc;
              }, []);
              if (vm.MentoringAreaList.length === 1) {
                vm.srch.MentoringAreaObj = vm.MentoringAreaList[0];
                vm.srch.MentoringArea = vm.srch.MentoringAreaObj.Code;
              }
            } else {
              vm.MentoringAreaList = [];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList' + data.body.docs[0].errMessage);
        }
      );

      // getListCount();
      vm.srch.page = vm.currentPage;
      // console.log('vm.srch', vm.srch);
      $window.sessionStorage.setItem('mentoringrecord-list-ctrl', angular.toJson(vm.srch));

      vm.srch.mapCode = 'MentoringRecord.getMentoringRecordList';

      postApi.select(
        vm.srch,
        function (data) {
          // console.log('mentoringrecord', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              var resultData = postApi.makeResultData(data);
              vm.lists = resultData.body.docs;
              vm.totalItems = resultData.body.docs[0].TOTAL;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'MentoringRecord.getMentoringRecordListCount';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = [];
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 모달팝업 호출 (등록자)
    function showModalMentoUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.MentoUser_ = okData.UserNm;
          vm.srch.MentoUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (등록자)
    function clearModalMentoUser() {
      vm.srch.MentoUser_ = '';
      vm.srch.MentoUser = '';
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.RecordIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.RecordIds.push(vm.lists[i].RecordId);
        }
      }

      if (vm.data.RecordIds == null || vm.data.RecordIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'MentoringRecord.deleteMentoringRecordDetail';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.reload();
              },
            });
          }
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '멘토링보고서 목록';
      log.ScreenUrl = 'app/mentoring/record-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {

              var resultData = postApi.makeResultData(data);

              // vm.DownloadCheckYn = data.body.docs;
              vm.DownloadCheckYn = resultData.body.docs;

              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '동아리팀';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ClubNm';
      header.push(obj);

      obj = {};
      obj.title = '상담제목';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Title';
      header.push(obj);

      obj = {};
      obj.title = '상담회차';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoringRound_';
      header.push(obj);

      obj = {};
      obj.title = '멘토';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoUser_';
      header.push(obj);

      obj = {};
      obj.title = '상담일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoringDate';
      header.push(obj);

      obj = {};
      obj.title = '상담시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoringTime';
      header.push(obj);

      obj = {};
      obj.title = '권역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoringArea';
      header.push(obj);

      obj = {};
      obj.title = '군별';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyType_';
      header.push(obj);

      obj = {};
      obj.title = '소속부대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat';
      header.push(obj);
      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '멘토링보고서 목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;
      $http({
        url: StaticVariable.getUrl(
          '/excel/MentoringRecord.getExcelMentoringRecordList/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    vm.setSortColumn = function (sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = 'ASC';
      } else {
        //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getList();
    };

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    vm.setSortDirect = function (sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    };

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    // 데이터 조회
    getList();
  },
]);

/**
 * @ngdoc function
 * @name app.mentoring:mentoringschedule-list-ctrl
 * @description
 * # 일정조회
 * Controller of the 일정조회
 */
webapp.controller('MentoringScheduleListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'postApi',
  'uiCalendarConfig',
  'gAlert',
  'gConfirm',
  '$compile',
  '$http',
  'StaticVariable',
  'modalFactory',
  /**
   * 일정조회 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} ScheduleAPISvr - ScheduleAPISvr Module
   */
  function MentoringScheduleListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    uiCalendarConfig,
    gAlert,
    gConfirm,
    $compile,
    $http,
    StaticVariable,
    modalFactory
  ) {
    var vm = this;
    vm.data = {};
    vm.listType = 'calendar';
    vm.listTypeBtn = '목록형';

    // 접근 권한 체크
    if (!isPageAccess('mentoringschedule-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');
    // 버튼 권한 체크
    $scope.showBtnExcel = false;
    $scope.showBtnDel = false;

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건
    vm.srch = {
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      TenantId: $window.sessionStorage['loginTenantId'],
      TenantNm: $window.sessionStorage['loginTenantName'],
      baseDate: new moment().format('YYYY-MM-DD'),
      ClubNm: '',
      ClubId: '',
      MentoUser: '',
      MentoUser_: '',
      ArmyType: '',
      PermStat1: '',
      PermStat2: '',
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];
    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 공통코드 정의
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: vm.srch.userPermList,
      MentoringArea: '',
    };

    vm.PermStat1List = {
      userPermList: vm.srch.userPermList,
    };

    vm.onMentoringAreaListSelected = function () {
      var data = vm.srch.MentoringAreaObj;
      if (data == null) {
        vm.srch.MentoringArea = '';
        vm.PermStat1List.MentoringArea = '';
        vm.ArmyTypeList.MentoringArea = '';
        return;
      }
      vm.srch.MentoringArea = data.Code;
      vm.ArmyTypeList.MentoringArea = data.Code;
      vm.PermStat1List.MentoringArea = data.Code;
    };

    vm.onArmyTypeListSelected = function (data) {
      vm.PermStat1List.CodeType = '1380';
      vm.PermStat1List.ParentCommonCodeId = '';

      if (data == null) {
        vm.srch.ArmyType = '';
        return;
      }

      vm.srch.ArmyType = data.Code;
      vm.srch.ArmyAreaType = data.Code;
      // vm.PermStat1List.ParentCommonCodeId = data.Code;
      vm.PermStat1List.ParentCommonCodeId = vm.srch.ArmyAreaType;

      if (data.Code == null) data.Code = '';
    };

    vm.onPermStat1ListSelected = function (data) {
      vm.PermStat2 = '';

      if (data == null) {
        vm.srch.PermStat1 = '';
        return;
      }

      vm.srch.PermStat1 = data.Code;
    };

    // 변수 선언
    $scope.SelectedEvent = null;
    var isFirstTime = true;

    $scope.events = [];
    $scope.eventSources = [$scope.events];
    $scope.NewEvent = {};

    // 전역상수 선언

    /**
     * 모달팝업 호출 (동아리팀)
     *
     * @param
     * @return
     */
    function showModalClubInfo() {

      var modalInstance = modalFactory.open(
        'modal',
        'app/mentoring/modal/club-name-modal.html',
        'ClubNameModalCtrl as modalCtrl',
        {}
      );
      modalInstance.result.then(
        function (okData) {
          vm.srch.ClubId = okData.ClubId;
          vm.srch.ClubNm = okData.ClubNm;
        },
        function (cancelData) {}
      );
    }

    /**
     * 고객 초기화
     *
     * @param
     * @return
     */
    function clearModalClubInfo() {
      vm.srch.ClubNm = '';
      vm.srch.ClubId = '';
    }

    /**
     * 멘토 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.MentoUser_ = okData.UserNm;
          vm.srch.MentoUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 멘토 초기화
     *
     * @param
     * @return
     */
    function clearModalUser() {
      vm.srch.MentoUser_ = '';
      vm.srch.MentoUser = '';
    }

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      if (
        vm.srch.MentoringDateFrom != null &&
        vm.srch.MentoringDateFrom != '' &&
        vm.srch.MentoringDateTo != null &&
        vm.srch.MentoringDateTo != ''
      ) {
        if (getDateToNumber(vm.srch.MentoringDateFrom) > getDateToNumber(vm.srch.MentoringDateTo)) {
          gAlert('', '상담일 날짜범위가 잘못되었습니다.');
          return false;
        }
      }

      return true;
    }
    
    function getTenantAreaList() {
      return new Promise(function(resolve, reject) {
        vm.srch.mapCode = 'Business.getTenantArea';
        postApi.select(
          vm.srch,
          function (data) {
            var resultData = postApi.makeResultData(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (resultData.body.docs[0] != null) {
                var areaList = resultData.body.docs[0].TenantArea.split(',');
                vm.MentoringAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                if (vm.MentoringAreaList.length === 1) {
                  vm.srch.MentoringAreaObj = vm.MentoringAreaList[0];
                  vm.srch.MentoringArea = vm.srch.MentoringAreaObj.Code;
                }
                resolve(true);
              } else {
                vm.srch.MentoringAreaList = [];
                reject(false);
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData' + data.body.docs[0].errMessage);
          }
        );
      });
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'MentoringSchedule.getScheduleListCnt';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      $window.sessionStorage.setItem('MentoringSchedule-list-ctrl', angular.toJson(vm.srch));
      if(!chkValid()) return;

      getTenantAreaList().then(function() {
        vm.srch.page = vm.currentPage;
        getListCount();
  
        if (vm.listType === 'calendar') {
          vm.srch.mapCode = 'MentoringSchedule.getScheduleCalendar';
        } else if (vm.listType === 'list') {
          vm.srch.mapCode = 'MentoringSchedule.getScheduleList';
        }
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                // 검색결과 저장
                vm.lists = data.body.docs;
              } else {
                // 검색된 결과 없음
                vm.lists = {};
              }
  
              // 달력에 일정 표시
              if (vm.listType === 'calendar')
              setDataInCalendar();
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error> MentoringSchedule-list-ctrl> getList()', status, error);
          }
        );
      });
    }

    /**
     * 달력에 일정 표시
     * @param
     * @return
     * @author 최원영
     */
    function setDataInCalendar() {
      try {
        // 달력 초기화
        if (uiCalendarConfig.calendars.myCalendar != null) {
          uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
          uiCalendarConfig.calendars.myCalendar.fullCalendar('unselect');
        }

        // event 초기화
        $scope.events.slice(0, $scope.events.length);

        if (vm.lists.length > 0) {
          var addEvent = uiCalendarConfig.calendars.myCalendar.fullCalendar('addEventSource', vm.lists);

          if (typeof addEvent != 'undefined') {
            location.reload();
          }
        }
      } catch (ex) {
        console.log("error");
        // console.error('Error> MentoringSchedule-list-ctrl> setDataInCalendar()> ' + ex.message);
      }
    }

    /**
     * 일정정보
     * @param
     * @return
     * @author 최원영
     */
    function showScheduleModalPopup(schId) {
      try {
        // Modal Popup Controller 정의
        var ctrl = 'MentoringScheduleModalCtrl as modalCtrl';

        // Modal Popup에 전달할 Parameter 정의
        var paramData = { BaseDate: vm.srch.baseDate, SchId: schId };

        // Modal Popup 호출
        var modalInstance = modalFactory.open('modal', 'app/mentoring/modal/mentoringschedule-modal.html', ctrl, paramData);

        modalInstance.result.then(
          function (okData) {
            // 데이터 조회
            getList();
          },
          function (cancelData) {
            // Cancel 처리
          }
        );
      } catch (ex) {
        console.log("error");
        // console.error('Error> MentoringSchedule-list-ctrl> showMentoringScheduleModalPopup()> ' + ex.message);
      }
    }

    /**
     * 달력 초기화
     * @param
     * @return
     * @author 최원영
     */
    $scope.uiConfig = {
      calendar: {
        height: 1500,
        editable: true,
        eventLimit: 11,
        displayEventTime: false,
        header: {
          left: '',
          center: 'title',
          right: 'prev,next today month,agendaWeek,agendaDay',
        },
        views: {
          basic: {
            titleFormat: 'YYYY.MM.DD',
          },
          month: {
            titleFormat: 'YYYY.MM',
          },
          agenda: {
            titleFormat: 'YYYY.MM.DD',
          },
          week: {
            titleFormat: 'YYYY.MM.DD',
          },
          day: {
            titleFormat: 'YYYY.MM.DD',
          },
        },
        timeFormat: 'H(:mm)',
        monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        dayNames: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
        buttonText: {
          today: '오늘',
          month: '월간',
          week: '주간',
          day: '일간',
        },
        selectable: false,
        selectHelper: true,
        navLinks: true,
        navLinkDayClick: function (date, jsEvent) {
          vm.srch.baseDate = moment(date).format('YYYY-MM-DD');
          uiCalendarConfig.calendars.myCalendar.fullCalendar('gotoDate', date);
          uiCalendarConfig.calendars.myCalendar.fullCalendar('changeView', 'agendaDay');
        },
        select: function (start, end) {
          vm.srch.baseDate = moment(start).format('YYYY-MM-DD');
        },
        eventClick: function (event) {
          vm.srch.baseDate = moment(event.start).format('YYYY-MM-DD');

          // 일정수정
          showScheduleModalPopup(event.id);
        },
        dayClick: function (date, jsEvent, view) {
          vm.srch.baseDate = moment(date).format('YYYY-MM-DD');

          // 일정등록
          showScheduleModalPopup('');
        },
        eventAfterAllRender: function () {},
        viewRender: function (view, element) {},
        dayRender: function (date, cell) {},
        eventRender: function (event, element, view) {
          vm.srch.baseDate = '';
          vm.lists = [];

          element.attr({
            tooltip: event.title,
            'tooltip-append-to-body': true,
          });
          $compile(element)($scope);
        },
      },
    };

    function print() {
      window.print();
    }

    function listTypeChg() {
      // TODO: vm.listType 값이 변환 list <-> calendar
      if(vm.listType === 'list') {
        vm.listType = 'calendar';
        vm.listTypeBtn = '목록형';
        $scope.showBtnExcel = false;
        $scope.showBtnDel = false;
      } else if(vm.listType === 'calendar') {
        vm.listType = 'list';
        vm.listTypeBtn = '달력형';
        $scope.showBtnExcel = true;
        $scope.showBtnDel = true;
      }
      getList();
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '멘토링일정 목록';
      log.ScreenUrl = 'app/mentoring/schedule-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {

              var resultData = postApi.makeResultData(data);

              // vm.DownloadCheckYn = data.body.docs;
              vm.DownloadCheckYn = resultData.body.docs;

              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '동아리팀';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ClubNm';
      header.push(obj);

      obj = {};
      obj.title = '멘토';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoUser_';
      header.push(obj);

      obj = {};
      obj.title = '상담일';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'StartYMD';
      header.push(obj);

      obj = {};
      obj.title = '상담시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'StartTime';
      header.push(obj);

      obj = {};
      obj.title = '권역';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'MentoringArea';
      header.push(obj);

      obj = {};
      obj.title = '군별';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'ArmyType_';
      header.push(obj);

      obj = {};
      obj.title = '소속부대';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'PermStat';
      header.push(obj);
      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '멘토링일정 목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;
      $http({
        url: StaticVariable.getUrl(
          '/excel/MentoringSchedule.getExcelScheduleList/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.SchIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.SchIds.push(vm.lists[i].SchId);
        }
      }

      if (vm.data.SchIds == null || vm.data.SchIds.length == 0) {
        gAlert('', '선택된 일정이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'MentoringSchedule.deleteSchedule';

      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                $state.reload();
              },
            });
          }
        },
        function (data) {
          console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    vm.setSortColumn = function (sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = 'ASC';
      } else {
        //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getList();
    };

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    vm.setSortDirect = function (sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    };

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    // 함수 선언
    vm.getList = getList;
    vm.showModalClubInfo = showModalClubInfo;
    vm.clearModalClubInfo = clearModalClubInfo;
    vm.showModalUser = showModalUser;
    vm.clearModalUser = clearModalUser;
    vm.print = print;
    vm.listTypeChg = listTypeChg;
    vm.showScheduleModalPopup = showScheduleModalPopup;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
    vm.deleteList = deleteList;
    vm.pageChanged = pageChanged;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getList();
  },
]);

webapp.controller('ApprModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  function ApprModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    postApi
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'counselappli-appr-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    // 함수 연결
    vm.cancel = cancel;
    vm.ok = ok;
    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    // 데이터선언
    vm.data = {};
    //vm.setData = setData;

    // 공통코드 정의
    vm.FirstDecHourList = {
      CodeType: '1120',
      TenantId: $window.sessionStorage['loginTenantId'],
      Value: '',
    };
    vm.FirstDecMinList = {
      CodeType: '1130',
      TenantId: $window.sessionStorage['loginTenantId'],
      Value: '',
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.FirstDecHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.FirstDecMin = data.Code;
      }
    };

    // 기본값
    vm.data.CounselUser = $window.sessionStorage['loginUserIdx'];
    vm.data.CounselUser_ = $window.sessionStorage['loginUserName'];
    vm.FirstDecHourList.Code = '00';
    vm.FirstDecMinList.Code = '00';
    /*vm.data.FirstDecHour = "00";
      vm.data.FirstDecMin = "00";*/

    (function ApprModalCtrl() {
      //vm.getRequestParams = getRequestParams;
    })();

    // 유효성검사
    function chkValid() {
      // gAlert 사용시 레이어가 닫힘

      if (
        typeof vm.data.FirstDecDate == 'undefined' ||
        vm.data.FirstDecDate == ''
      ) {
        alert('상담확정일을 입력해주세요');
        return false;
      }

      /*if (getDateToNumber(vm.data.FirstDecDate) <  getDateToNumber(getTodayAddDay(3))) {
          alert('상담확정일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
          return false;
        }
        */

      if (
        typeof vm.data.FirstDecDate == 'undefined' ||
        vm.data.FirstDecDate == ''
      ) {
        alert('상담확정일을 입력해주세요');
        return false;
      }

      if (typeof vm.data.FirstDecHour == 'undefined') {
        alert('상담확정일시(시)를 선택해주세요');
        return false;
      }

      if (typeof vm.data.FirstDecMin == 'undefined') {
        alert('상담확정일시(분)를 선택해주세요');
        return false;
      }

      if (
        typeof vm.data.CounselUser == 'undefined' ||
        vm.data.CounselUser == ''
      ) {
        alert('상담사를 선택해주세요');
        return false;
      }

      return true;
    }

    // 저장
    function setData() {
      if (!chkValid()) return false;

      var arr = [];

      if (
        toModalData.CounselAppliIds != null &&
        toModalData.CounselAppliIds != ''
      ) {
        vm.data.CounselAppliIds = toModalData.CounselAppliIds;
      } else {
        vm.data.CounselAppliId = toModalData.CounselAppliId;
      }

      vm.data.mapCode = 'Counselappli.updateAppr';

      postApi.update(
        vm.data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            //$uibModalInstance.close();
          }

          $uibModalInstance.close();
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          return false;
        }
      );
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/user2-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.CounselUser_ = okData.UserNm;
          vm.data.CounselUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.data.CounselUser_ = '';
      vm.data.CounselUser = '';
    }

    // 취소버튼 클릭
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 확인버튼 클릭
    function ok() {
      setData();
    }
  },
]);

webapp.controller('DownloadReasonModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'gAlert',
  function DownloadReasonModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    gAlert
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    //vm.getUserList = getUserList;

    (function DownloadReasonModalCtrl() {
      // search
      vm.DownloadReason = '';
    })();

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok() {
      if (
        typeof vm.DownloadReason == 'undefined' ||
        vm.DownloadReason == '' ||
        vm.DownloadReason.length < 5
      ) {
        gAlert('', '다운로드 사유를 5자 이상 입력하세요.');
        return false;
      }

      $uibModalInstance.close(vm.DownloadReason);
    }
  },
]);

webapp.controller('EmailModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  function EmailModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    postApi
  ) {
    var vm = this;
    // 접근 권한 체크
    /*   if (!isPageAccess("email-modal", $window.sessionStorage['loginUserType'])) {
        cancel();
        vm.cancel = cancel;
        return false;
      }*/

    // 함수 연결
    vm.cancel = cancel;
    vm.ok = ok;
    /*vm.showModalCounselUser = showModalCounselUser;
      vm.clearModalCounselUser = clearModalCounselUser;*/
    // 데이터선언
    vm.data = {};
    //vm.setData = setData;

    // 공통코드 정의
    /*vm.FirstDecHourList = {
        CodeType : '1120',
        TenantId : $window.sessionStorage['loginTenantId'],
        Value : ''
      }         */

    /*      vm.onSelectCallback = function(data) {
        if (data.Code == null) data.Code = "";

        if (data.CodeType == '1120') {          
          vm.data.FirstDecHour = data.Code;
        }
      }*/

    // 업로드 파일 목록
    vm.uploadFileList = [];

    vm.onFileCallback = {
      onFileUploadComplete: function () {
        //console.log('file items::', vm.uploadFileList);
      },
      onFileDelete: function (item) {
        //console.log('delete item::', item);
        var param = {
          fileId: item.id,
        };

        postApi.attach('file/delete', param, function (data) {
          console.log(data);
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED');
          }
        });
      },
    };

    // 기본값
    vm.data.FromEmail = $window.sessionStorage['loginUserEmail'];
    //vm.data.FromEmail = "support@softzion.com"; // mail.softzion.com 메일서버를 사용하기때문에 메일도메인이 softzion.com 이여야만 발송됨

    (function EmailModalCtrl() {})();

    // 유효성검사
    function chkValid() {
      // gAlert 사용시 레이어가 닫힘

      if (typeof vm.data.FromEmail == 'undefined' || vm.data.FromEmail == '') {
        alert('발신자 이메일주소를 입력해주세요');
        return false;
      }

      if (typeof vm.data.Title == 'undefined' || vm.data.Title == '') {
        alert('제목을 입력해주세요');
        return false;
      }

      oEditors.getById['strHtml'].exec('UPDATE_CONTENTS_FIELD', []);
      vm.data.SendMessage = $('#strHtml').val();

      if (
        typeof vm.data.SendMessage == 'undefined' ||
        vm.data.SendMessage == ''
      ) {
        alert('내용을 입력해주세요');
        return false;
      }

      return true;
    }

    // 저장
    function setData() {
      if (!chkValid()) return false;

      vm.data.TableId = 0;
      vm.data.TableNm = 'singleemaillog';
      vm.data['uploadFileList'] = vm.uploadFileList;
      vm.data.TimeCode = getDateTime('CODE'); // 발송 그룹 코드

      if (toModalData.CustArmyIds != null && toModalData.CustArmyIds != '') {
        vm.data.CustArmyIds = [];
        vm.data.CustArmyIds = toModalData.CustArmyIds;
      } else {
        vm.data.CustArmyId = toModalData.CustArmyId;
      }

      vm.data.mapCode = 'Emaillog.insertEmaillogForCustArmy';

      postApi.update(
        vm.data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            //$uibModalInstance.close();
            //console.log("----------------", json.body.docs[0]);

            vm.data.TableId = json.body.docs[0].TableId;

            setDataAttach();
          }

          $uibModalInstance.close();
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          return false;
        }
      );
    }

    // 첨부파일 정보 업데이트
    function setDataAttach() {
      vm.data.mapCode = 'Emaillog.updateEmaillogAttachForCustArmy';

      postApi.update(
        vm.data,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            //$uibModalInstance.close();
            //console.log("----------------", json.body.docs[0]);
          }

          $uibModalInstance.close();
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
          return false;
        }
      );
    }

    // 취소버튼 클릭
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 확인버튼 클릭
    function ok() {
      setData();
    }
  },
]);

webapp.controller('ImageModalCtrl', [
  '$window',
  '$scope',
  '$state',
  '$cookies',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'ModalAPISrv',
  'gAlert',
  'postApi',
  function ImageModalCtrl(
    $window,
    $scope,
    $state,
    $cookies,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    api,
    gAlert,
    postApi
  ) {
    var vm = this;

    // 함수 연결
    vm.close = close;

    (function ImageModalCtrl() {
      vm.src = toModalData.src;
    })();
    
    function close() {
      $uibModalInstance.close();
    }
  },
]);

webapp.controller('SessionCountdownModalCtrl', [
  '$window',
  '$scope',
  '$rootScope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$interval',
  function SessionCountdownModalCtrl(
    $window,
    $scope,
    $rootScope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $interval
  ) {
    var vm = this;

    vm.cancel = cancel;
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    vm.ok = ok;
    function ok() {
      if ($rootScope.gVariable.sessioncountdown < 1) {
        $uibModalInstance.close('expired');
      } else {
        $uibModalInstance.close();
      }
    }

    function twoDigits(n) {
      return n <= 9 ? '0' + n : n;
    }

    function updateTimer() {
      if ($rootScope.gVariable.sessioncountdown < 1) {
        vm.countdown = '만료되었습니다.';
      } else {
        vm.countdown =
          twoDigits(parseInt($rootScope.gVariable.sessioncountdown / 60)) +
          ':' +
          twoDigits($rootScope.gVariable.sessioncountdown % 60);
      }
    }

    vm.minute = $window.sessionStorage['loginUserSessionMinute'] / 60;

    var interval = $interval(updateTimer, 1000);

    $scope.$on('$destroy', function () {
      $interval.cancel(interval);
    });

    updateTimer();
  },
]);


webapp.controller('User2ModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  function User2ModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getUserList = getUserList;

    (function User2ModalCtrl() {
      // search
      vm.searchValue = '';
      vm.selectPeriod = 'all';
      vm.startDate = '';
      vm.endDate = '';
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'UserNm',
          optionName: '이름',
        },
      ];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;

      vm.UserList = [];
      getUserList();
    })();
    function changeViewSize() {
      getUserList();
    }
    function getRequestParams() {
      var req = {
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchFieldType: vm.searchFieldType,
        UserNm: vm.searchValue,
        selectPeriod: vm.selectPeriod,
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };
      vm.filter = req;
      return req;
    }

    function getUserList() {
      getUserListCnt();

      vm.req = vm.getRequestParams();
      vm.req.mapCode = 'User.getUserMgrList';

      postApi.select(
        vm.req,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.UserList = json.body.docs;
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
        }
      );
    }

    function getUserListCnt() {
      vm.req = vm.getRequestParams();
      vm.req.mapCode = 'User.getUserMgrListCnt';

      postApi.select(
        vm.req,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalCount = json.body.docs[0];
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(User) {
      $uibModalInstance.close(User);
    }
  },
]);

(function () {
  "use strict";
  webapp.controller('ScheduleCtrl', ['$window', '$rootScope', '$scope', 'uiCalendarConfig', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi', '$filter',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', 'modalPopup', '$interval', 'gChoice', '$compile', 'autoView', "$http", "$mdDialog", 'gSelect',
    function ScheduleCtrl($window, $rootScope, $scope, uiCalendarConfig, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, $filter, gAlert, gConfirm, udcApi, $translate, $timeout, modalPopup, $interval, gChoice, $compile, autoView, $http, $mdDialog, gSelect) {

      // 관련 화면 정의

      // #endregion 상수 정의
      var LIST_SQL = 'KSASchedule.getScheduleList';

      // View Model
      var vm = this;
      vm.data = {};
      vm.data.deptList = [];

      vm.title = '영업캘린더';
      vm.dataloader = false;

      vm.addEvent = false;
      
      $scope.events = [];
      $scope.curEvent = '';
      $rootScope.isOpened = false;
      
      var TenantId = $window.sessionStorage['loginTenantId'];
      vm.editUser = TenantId == 0 ? true : false;
      
      var resources = [];
      var resourceList = [];
      var row = {};
      vm.cellMap = [];

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {};
        vm.defaultDate = moment(moment().startOf('month')).format('YYYY-MM-DD');
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }
      
      vm.defaultDate = moment(moment().startOf('month')).format('YYYY-MM-DD');

      /**
       * 데이터 조회
       * @param
       * @return
       */
      var interval;
      $scope.$on('$destroy', function () {
        $interval.cancel(interval);
      });

      function getHolidayList(view, mode) {
        var srch = {};
        var start = moment(view.start).format('YYYY-MM-DD');
        var end = moment(view.end).format('YYYY-MM-DD');
        srch.startDate = $filter('localToUtc')(start, 'from');
        srch.endDate = $filter('localToUtc')(end, 'to');
        srch.mapCode = 'Calendar.getCalendarList';
        var classname = (mode == "main" ? ".calendarWrap" : ".calendar_lnb");
  
        postApi.select(srch, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // angular.forEach(result.body.docs, function (item) {
              //   if (item.Description != undefined && vm.cellMap[item.CalDt]) {
              //     vm.cellMap[item.CalDt].append("<div style='text-align:left;color:#f33;padding:10px;'>" + item.Description + "</div>");
              //   }
              // });
              var holidayFirst = null;
              if (start == result.body.docs[0].CalDt) {
                holidayFirst = result.body.docs[0];
              }

              var holiday = result.body.docs.reduce(function(map, obj) {
                map[obj.CalDt] = obj;
                return map;
              }, {});

              $(classname).find(".fc-month-view").find(".fc-content-skeleton").find(".fc-day-top").each(function(index) {
                if (holiday[$(this).attr('data-date')] && holiday[$(this).attr('data-date')].HolidayYn == 'Y') {
                  $(this).find(".fc-mon").removeClass("fc-mon");
                  $(this).find(".fc-tue").removeClass("fc-tue");
                  $(this).find(".fc-wed").removeClass("fc-wed");
                  $(this).find(".fc-thu").removeClass("fc-thu");
                  $(this).find(".fc-fri").removeClass("fc-fri");
                  $(this).find(".fc-sat").removeClass("fc-sat");
                  $(this).addClass("fc-sun");
                }
              });

              $(classname).find(".fc-agendaWeek-view").find(".fc-day-header").each(function(index) {
                if (holiday[$(this).attr('data-date')] && holiday[$(this).attr('data-date')].HolidayYn == 'Y') {
                  $(this).find(".fc-mon").removeClass("fc-mon");
                  $(this).find(".fc-tue").removeClass("fc-tue");
                  $(this).find(".fc-wed").removeClass("fc-wed");
                  $(this).find(".fc-thu").removeClass("fc-thu");
                  $(this).find(".fc-fri").removeClass("fc-fri");
                  $(this).find(".fc-sat").removeClass("fc-sat");
                  $(this).addClass("fc-sun");
                }
                if (holiday[$(this).attr('data-date')] && holiday[$(this).attr('data-date')].Description) {
                  $(this).append("<div style='text-align:center;color:#f33;'>" + holiday[$(this).attr('data-date')].Description + "</div>");
                }
              });

              $(classname).find(".fc-agendaDay-view").find(".fc-head-container").find(".table-bordered").find("td").each(function(index) {
                if (holidayFirst != null && holidayFirst.Description) {
                  $(this).html("<div style='text-align:center;color:#f33;'>" + holidayFirst.Description + "</div>");
                }
              });

              if (mode == "main") {
                $(classname).find(".fc-month-view").find(".fc-bg").find(".fc-day").each(function(index) {
                  if (holiday[$(this).attr('data-date')] && holiday[$(this).attr('data-date')].Description) {
                    $(this).append("<div style='text-align:left;color:#f33;padding:10px;'>" + holiday[$(this).attr('data-date')].Description + "</div>");
                  }
                });
              }
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getHolidayList', error);
          vm.dataloader = false;
        });
      }

      function getData(view) {
        $scope.events = [];
        $scope.eventSources = [];
        vm.lists = [];

        var start = moment(view.start).format('YYYY-MM-DD');
        var end = moment(view.end).format('YYYY-MM-DD');
        vm.srch.startDate = $filter('localToUtc')(start, 'from');
        vm.srch.endDate = $filter('localToUtc')(end, 'to');

        var data = angular.copy(vm.srch);
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              var lists = result.body.docs;
              isCalLoading = true;
              $timeout(function () {
                for (var j = 0; j < lists.length; j++) {
                  var item = lists[j];
                  row = {};
                  
                  row.id = item.KeyId;
                  row.start = moment.utc(item.StartDate);
                  row.end = moment.utc(item.EndDate);
                  row.clientNm = item.ClientNm;
                  row.title = item.DRTitle + ' [' + item.ManagerNm + ']';
                  row.drTitle = item.DRTitle;
                  row.businessOPNm = item.BusinessOPNm;
                  // row.deptId = item.DeptId;
                  // row.deptNm = item.DeptNm;
                  row.drType = item.DRType;
                  row.drTypeNm = item.DRTypeNm;
                  row.drStatus = item.DRStatus;
                  row.drStatusNm = item.DRStatusNm;
                  row.encryptNms = item.EncryptNms;
                  row.managerNm = isNullOrEmpty(item.CompanionNms) ? item.ManagerNm : item.ManagerNm + ',' + item.CompanionNms;
                  // row.resourceId = item.DeptId;
                  switch (item.DRStatus) {
                    case '10':
                      row.color = '#ffe16b';
                      row.textColor = '#333';
                      break;
                    case '20':
                      row.color = '#cf0bf0';
                      row.textColor = '#fff';
                      break;
                    case '30':
                      row.color = '#749ef8';
                      row.textColor = '#fff';
                      break;
                    case '40':
                      row.color = '#55dd9f';
                      row.textColor = '#fff';
                      break;
                  }
                  row.dow = '';

                  $scope.events.push(row);
                }

                uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
                vm.isLoading = false;
              }, 0);
            }
            vm.isLoading = false;
          } else {
            vm.isLoading = false;
            console.log("error");
            // console.error("Error> getData()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      var isCalLoading = false;
      var lastViewType = '';
      var lastCalTitle = '';

      vm.isLoading = true;

      var localStorage = window.localStorage;
      var defaultView = (localStorage.getItem("fcDefaultView") !== null ? localStorage.getItem("fcDefaultView") : "agendaDay");

      function setCalendar(result) {
        /* config object */
        $('.calendarWrap').css('opacity', 1);
        $scope.uiConfig = {
          calendar: {
            header: {
              left: 'today',
              center: 'prev, title, next',
              right: 'month, agendaWeek, agendaDay, listMonth'
            },
            views: {
              month: { columnFormat: 'dddd' },
              agendaWeek: { columnFormat: 'ddd M/D' },
            },
            customButtons: {
              prev: {
                text: 'prev',
                click: function () {
                  $('#calendar').fullCalendar('prev');
                }
              },
              next: {
                text: 'next',
                click: function () {
                  $('#calendar').fullCalendar('next');
                }
              }
            },
            schedulerLicenseKey: '0663320046-fcs-1605662091',
            locale: 'ko',
            timezone: 'local',
            editable: true,
            draggable: true,
            eventDurationEditable: false,
            defaultDate: moment().format("YYYY-MM-DD"),
            defaultView: defaultView, // agendaDay, agendaWeek, month           
            themeSystem: 'bootstrap3',
            timeFormat: 'HH:mm',
            weekends: true,
            nowIndicator: false,
            displayEventTime: true,
            displayEventEnd: false,
            slotLabelFormat: "H:mm",
            allDaySlot: false,
            eventLimit: 6,
            minTime: '06:00:00',
            maxTime: '18:00:00',
            height: "auto",
            refetchResourcesOnNavigate: true,
            // resources: resources,
            viewRender: function (view, element) {
              // var localStorage = window.localStorage;
              localStorage.setItem("fcDefaultView", view.name);
              $('#calendar').fullCalendar('removeEvents');
              if (lastViewType != view.type) {
                isCalLoading = false;
                lastViewType = view.type;
              }

              if (lastCalTitle != view.calendar.view.title) {
                isCalLoading = false;
                lastCalTitle = view.calendar.view.title;
              }

              if (!isCalLoading) {
                vm.isLoading = true;
                getHolidayList(view, "main");
                getData(view);
                isCalLoading = true;
              }
            },
            eventDrop: function (event, delta, revertFunc) {
              eventDrop(event, revertFunc);
            },
            eventResize: $scope.alertOnResize,
            eventMouseover: function (event, jsEvent, view) {
              if ($rootScope.isOpened == false) {
                $scope.curEvent = { id: event.id, keyId: event.keyId, drStatus: event.drStatus, start: event.start, end: event.end};
              }
            },
            eventMouseout: function (event, jsEvent, view) {
            },
            eventRender: function (event, element, view) {
              // getMenu(event);
              element.attr("context-menu", "menuOptions");
              element.attr("model", "event");
              $compile(element)($scope);
              element.popover({
                content: $('<div />', {
                  class: 'popoverInfoCalendar'
                }).append('<p><strong>일정명 :</strong> ' + event.drTitle + '</p>')
                  .append(event.drTypeNm == undefined || event.drTypeNm == '' ? '' : '<p><strong>활동유형 :</strong> ' + event.drTypeNm + '</p>')
                  .append(event.businessOPNm == undefined || event.businessOPNm == '' ? '' : '<p><strong>사업기회 :</strong> ' + event.businessOPNm + '</p>')
                  .append(event.clientNm == undefined || event.clientNm == '' ? '' : '<p><strong>고객사 :</strong> ' + event.clientNm + '</p>')
                  .append(event.encryptNms == undefined || event.encryptNms == '' ? '' : '<p><strong>고객 :</strong> ' + event.encryptNms + '</p>')
                  .append(event.managerNm == undefined || event.managerNm == '' ? '' : '<p><strong>영업담당자 :</strong> ' + event.managerNm + '</p>'),
                delay: {
                  show: "800",
                  hide: "50"
                },
                trigger: 'hover',
                placement: 'left',
                html: true,
                container: 'body'
              });

              var show_client = false;

              if (vm.data.srchClientNm != undefined || vm.data.srchClientNm == '') {
                show_client = ['', event.clientNm].indexOf(vm.data.srchClientNm) > -1;
              } else {
                show_client = true;
              }
              
              return show_client;
            },
            dayClick: function (date, jsEvent, view, resourceObj) {
              dayClick(date, resourceObj, view.type);
            },
            eventClick: function (calEvent) {
              eventClick(calEvent);
            },
            dayRender: function (date, cell) {
              cell.append("<span class='hoverEffect'></span>");
              cell.mouseenter(function () {
                cell.find(".hoverEffect").show();
                cell.css("background", "rgba(0,0,0,.1)");
              }).mouseleave(function () {
                $(".hoverEffect").hide();
                cell.removeAttr('style');
              });
              //vm.cellMap[date.format('YYYY-MM-DD')] = cell;
            },
            eventRightclick: function (event, jsEvent, view) {}
          }
        };
      }

      // 고객명 필터링
      $('#srch_filter').on('change', function () {
        $('#calendar').fullCalendar('rerenderEvents');
      });

      // 부서선택 필터링
      $('#type_filter').on('change', function () {
        $('#calendar').fullCalendar('rerenderEvents');
      });

      function eventDrop(event, revertFunc) {
        var savedEvent = {};
        gConfirm('', 'Menu.UPDATECONFIRM', {
          btn: '',
          fn: function () {
            var data = {
              KeyId: event.id,
              StartDate: moment.utc(event.start).format('YYYY-MM-DD HH:mm'),
              EndDate: moment.utc(event.end).format('YYYY-MM-DD HH:mm')
            };
            
            data.mapCode = 'KSASchedule.updateSchedule';
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.UPDATED', {
                  btn: '',
                  fn: function () {
                    $scope.events.forEach(function (data) {
                      if (event.id == data.id) {
                        savedEvent = data;
                        savedEvent.resourceId = event.resourceId;
                        savedEvent.start = event.start;
                        savedEvent.end = event.end;

                        $scope.events.splice($scope.events.indexOf(data), 1);
                      }
                    });
                    
                      $scope.events.push(savedEvent);
                      uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
                      uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
                    }
                  });
                }
              }, function (error) {
                // 조회 중 오류 발생
                console.log("error");
                // console.error("Error> setDelListAction()");
                // console.table(error);
              });
            }
          }, {
          btn: '',
          fn: function () {
            revertFunc();
          }
        });
        // ESC 눌렀을 경우 (오류 나중에 수정)
        $(document).keyup(function (e) {
          if (e.keyCode == 27) {
            revertFunc();
          }
        });
      }

      function dayClick(adddate, resourceObj, viewType) {
        var paramData = { addYn: true, addDate: adddate, calendar: 'calendar', viewType: viewType };
        var ctrl = 'BusinessDrModalCtrl as vc';
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);

        modalInstance.result.then(function (res) {
          row = {};

          row.id = res.KeyId;
          row.keyId = res.KeyId;
          row.start = moment.utc(res.StartDate);
          row.end = moment.utc(res.EndDate);
          row.clientNm = res.ClientNm;
          row.title = res.DRTitle + ' [' + res.ManagerNm + ']';
          row.drTitle = res.DRTitle;
          row.businessOPNm = res.BusinessOPNm;
          // row.deptId = res.DeptId;
          // row.deptNm = res.DeptNm;
          row.drType = res.DRType;
          row.drTypeNm = res.DRTypeNm;
          row.drStatus = res.DRStatus;
          row.drStatusNm = res.DRStatusNm;
          row.encryptNms = res.CustNms;
          row.managerNm = isNullOrEmpty(res.CompanionNms) ? res.ManagerNm : res.ManagerNm + ',' + res.CompanionNms;
          // row.resourceId = res.DeptId;
          switch (res.DRStatus) {
            case '10':
              row.color = '#ffe16b';
              row.textColor = '#333';
              break;
            case '20':
              row.color = '#cf0bf0';
              row.textColor = '#fff';
              break;
            case '30':
              row.color = '#749ef8';
              row.textColor = '#fff';
              break;
            case '40':
              row.color = '#55dd9f';
              row.textColor = '#fff';
              break;
          }
          row.dow = '';

          $scope.events.push(row);
          $scope.eventSources = [$scope.events];
          uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
          uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
        }, function (cancelData) {});
      }

      function eventClick(event) {
        var paramData = { addYn: false, KeyId: event.id, calendar: 'calendar' };
        var ctrl = 'BusinessDrModalCtrl as vc';

        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
        
        modalInstance.result.then(function (res) {
          // if (res.res == 'E') {
            var index = 0;
            angular.forEach($scope.events, function(item) {
              if (item.id == event.id) {
                index = $scope.events.indexOf(item);
              }
            });
            $scope.events.splice(index, 1);

            row = {};

            row.id = res.KeyId;
            row.keyId = res.KeyId;
            row.start = moment.utc(res.StartDate);
            row.end = moment.utc(res.EndDate);
            row.clientNm = res.ClientNm;
            row.title = res.DRTitle + ' [' + res.ManagerNm + ']';
            row.drTitle = res.DRTitle;
            row.businessOPNm = res.BusinessOPNm;
            // row.deptId = res.DeptId;
            // row.deptNm = res.DeptNm;
            row.drType = res.DRType;
            row.drTypeNm = res.DRTypeNm;
            row.drStatus = res.DRStatus;
            row.drStatusNm = res.DRStatusNm;
            row.encryptNms = res.CustNms;
            row.managerNm = isNullOrEmpty(res.CompanionNms) ? res.ManagerNm : res.ManagerNm + ',' + res.CompanionNms;
            // row.resourceId = res.DeptId;
            switch (res.DRStatus) {
              case '10':
                row.color = '#ffe16b';
                row.textColor = '#333';
                break;
              case '20':
                row.color = '#cf0bf0';
                row.textColor = '#fff';
                break;
              case '30':
                row.color = '#749ef8';
                row.textColor = '#fff';
                break;
              case '40':
                row.color = '#55dd9f';
                row.textColor = '#fff';
                break;
            }
            row.dow = '';

            $scope.events.push(row);
            $scope.eventSources = [$scope.events];
            uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
            uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
          // } 
          // else if (res.res == 'D') {
          //   var index = 0;
            
          //   $scope.events.splice(index, 1);
          //   $scope.eventSources = [$scope.events];
          //   uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
          //   uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
          // } 
        }, function () {
        });
      }

      function setMiniCalendar() {
        /* config object */
        $scope.uiConfig2 = {
          calendar: {
            header: {
              left: '',
              center: 'prev, title, next',
              right: ''
            },
            views: {
            },
            schedulerLicenseKey: '0663320046-fcs-1605662091',
            locale: 'ko',
            timezone: 'local',
            editable: false,
            defaultDate: moment().format("YYYY-MM-DD"),
            defaultView: 'month', // agendaDay, agendaWeek, month           
            themeSystem: 'bootstrap4',
            timeFormat: 'HH:mm',
            titleFormat: 'YYYY.MM',
            bootstrapFontAwesome: {
              prev: 'fa-angle-left',
              next: 'fa-angle-right'
            },
            eventDisplay: 'none',
            displayEventTime: false,
            displayEventEnd: false,
            viewRender: function (view, element) {
              getHolidayList(view, "mini");
              if (moment().isAfter(view.intervalStart, 'day')) {
                $('.fc-prev-button').addClass('fc-state-disabled');
              } else {
                $('.fc-prev-button').removeClass('fc-state-disabled');
              }
            },
            eventDrop: $scope.alertOnDrop,
            eventResize: $scope.alertOnResize,
            dayClick: function (date, jsEvent, view, resourceObj) {
              vm.srch.miniDate = moment(date).format('YYYY-MM-DD');
              miniDayClick(date);
              $(".day-highlight").removeClass("day-highlight");
              $(this).addClass("day-highlight");
            },
            eventClick: function (calEvent) {},
            dayRender: function (date, cell) {
              vm.srch.miniDate = moment($.fullCalendar.moment()).format('YYYY-MM-DD');
              var today = $.fullCalendar.moment();
              if (date.isSame(today, 'day')) {
                cell.css("background", "#e8e8e8");
              }
            }
          },
        };
      }

      function miniDayClick(adddate) {
        $('#calendar').fullCalendar('gotoDate', adddate);
      }

      $scope.menuOptions = [
        {
          text: '상태변경',
          children: [
            ['예정', function ($itemScope, $event) {
              setUpdateMenu($scope.curEvent, '10', $event.target);
            }],
            ['보류', function ($itemScope, $event) {
              setUpdateMenu($scope.curEvent, '20', $event.target);
            }],
            ['완료', function ($itemScope, $event) {
              setUpdateMenu($scope.curEvent, '30', $event.target);
            }],
            ['취소', function ($itemScope, $event) {
              setUpdateMenu($scope.curEvent, '40', $event.target);
            }]
          ]
        },
        // ['지도보기', function ($itemScope) {
        // }],
        // ['개별발송', function ($itemScope) {
        //   // 메시지 발송
        //   setInsCampaignCust();
        // }],
        // ['복사', function ($itemScope) {
        // }],
        ['삭제', function ($itemScope) {
          // 삭제
          delData($scope.curEvent);
        }],
      ];

      function setUpdateMenu(curEvent, status, targetEl) {
        var savedEvent = {};
        var row = {};
        gConfirm('', 'Menu.UPDATECONFIRM', {
          btn: '',
          fn: function () {
            var data = {
              KeyId: curEvent.id,
              DRStatus : status
            };
            
            data.mapCode = 'KSASchedule.updateSchedule';
            switch (status) {
              case '10':
                row.color = '#ffe16b';
                row.textColor = '#333';
                break;
              case '20':
                row.color = '#cf0bf0';
                row.textColor = '#fff';
                break;
              case '30':
                row.color = '#749ef8';
                row.textColor = '#fff';
                break;
              case '40':
                row.color = '#55dd9f';
                row.textColor = '#fff';
                break;
            }

            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.UPDATED', {
                  btn: '',
                  fn: function () {
                    $scope.events.forEach(function (event) {
                      if (curEvent.id == event.id) {
                        savedEvent = event;
                        savedEvent.status = status;
                        savedEvent.color = row.color;
                        savedEvent.textColor = row.textColor;

                        $scope.events.splice($scope.events.indexOf(event), 1);
                      }
                    });

                    $scope.events.push(savedEvent);
                    uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
                    uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
                  }
                });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelListAction()");
              // console.table(error);
            });
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      function delData(curEvent) {
        if (curEvent.id != undefined) {
          gConfirm("", "삭제한 내역은 복구 불가능합니다. 삭제하시겠습니까?",{
            btn : '',
            fn : function() {
              var list = [];
              list.push(curEvent.id);

              var data = {
                KeyIdList: list
              };

              data.mapCode = 'BusinessDR.deleteBusinessDRBatch';
              postApi.update(data, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  gAlert('', 'Menu.DELETED', {
                    btn: '',
                    fn: function () {
                      // 삭제 성공
                      var index = 0;
                      angular.forEach($scope.events, function(item) {
                        if (item.id == curEvent.id) {
                          index = $scope.events.indexOf(item);
                        }
                      });

                      $scope.events.splice(index, 1);
                      $scope.eventSources = [$scope.events];
                      uiCalendarConfig.calendars.ksaCalendar.fullCalendar('removeEvents');
                      uiCalendarConfig.calendars.ksaCalendar.fullCalendar('addEventSource', $scope.events);
                    }
                  });
                }
              }, function (error) {
                // 삭제 중 오류 발생
                console.log("error");
                // console.error("Error> setDelDataAction()");
                // console.table(error);
              });
            }
          }, {
            btn : '',
            fn : function() {
            }
          });
        }
      }


      function getDeptList() {
        var data = {};
        data.Dept = '3';
        data.mapCode = 'organizationMng.getOrganizationCodes';
        resources = [];
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.deptLists = result.body.docs;
              angular.forEach(vm.deptLists, function (item) {
                row = {};
                row.id = item.Code;
                row.title = item.CodeValue;

                resources.push(row);
                resourceList.push(row);
              });
            }
          } else {
            console.log("error");
            // console.error("Error> getDeptList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getDeptList()");
          // console.table(error);
        });
      }

      // 고객사 자동완성 클릭시 호출함수 시작
      vm.ACClientNm = "__undefined__";
      vm.ACClientNmTimerId = null;      

      function changeClientNm(data) {
        if (data == "") {
          $timeout(function () {
            $('#calendar').fullCalendar('rerenderEvents');
          }, 0);
        }

        if (vm.ACClientNmTimerId != null) {
          clearTimeout(vm.ACCustNmTimerId);
        }

        vm.ACClientNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACClientNm != data && !check.test(data)) {
            // 고객리스트
            postApi.select({mapCode: 'AutoComplete.getClientList', ClientNm: data}, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function(item){
                  item.CodeValue = item.ClientNm;
                });
                vm.codeClientList = result.body.docs;
              }

              vm.ACClientNm = data;
            });
          }
        }, 100);
      }

      function changeClientCode(data) {
        if (data.CodeValue == "") {
          vm.data.srchClientNm = "";
        }
        $timeout(function () {
          $('#calendar').fullCalendar('rerenderEvents');
        }, 0);
      }
      // 고객사 자동완성 클릭시 호출함수 끝


      var firstClick = false;

      // 부서 클릭시 호출함수
      function setDeptType(data) {
        if (!firstClick) {
          resources.splice(0);
          firstClick = true;
        }
        var tmpCnt = 0;
        if (data) {
          if (vm.data.deptList.length != 0) {
            for (var i in vm.data.deptList) {
              if (vm.data.deptList[i].deptCode == data.Code) {
                tmpCnt += 1;
                gAlert('중복된 부서는 선택할 수 없습니다.');
                break;
              }
            }
          }
        }

        if (tmpCnt == 0) {
          vm.data.deptList.push({ 'deptCode': data.Code, 'deptCodeValue': data.CodeValue });
          vm.act_ItemTypeFocus = 'N';
          vm.data.ItemType = "";
          resources.push({ 'id': data.Code, 'title': data.CodeValue });
          $('#calendar').fullCalendar('refetchResources');
          $timeout(function () {
            angular.element(".ItemType-col-wrap .form-group > input").focus();
            vm.act_ItemTypeFocus = 'Y';
            $('#calendar').fullCalendar('rerenderEvents');
          }, 100);
        }
        $("select[name=selectDeptList]").val('').prop("selected", true);
      }

      function setDept() {
        var deptCodeList = [];
        var deptCodeValueList = [];
        if (vm.data.deptCodeList != null) {
          deptCodeList = vm.data.deptCodeList.split(",");
        }
        if (vm.data.deptCodeValueList != null) {
          deptCodeValueList = vm.data.deptCodeValueList.split(",");
        }
        angular.forEach(deptCodeList, function (item, key) {
          var result = { deptCode: item, deptCodeValue: deptCodeValueList[key] };
          vm.data.deptList.push(result);
        });
      }

      function deleteDept(item) {
        if (item) {
          for (var j in resources) {
            if (resources[j].id == item.deptCode) {
              resources.splice(j, 1);
              $('#calendar').fullCalendar('refetchResources');
            }
          }
          for (var i in vm.data.deptList) {
            if (vm.data.deptList[i].deptCode == item.deptCode) {
              vm.data.deptList.splice(i, 1);
              $('#calendar').fullCalendar('rerenderEvents');
            }
          }
        }

        if (resources.length == 0) {
          resources.splice(0);
          firstClick = false;
          angular.forEach(resourceList, function (item) {
            row = {};
            row.id = item.id;
            row.title = item.title;

            resources.push(row);
          });
          $('#calendar').fullCalendar('refetchResources');
        }
      }
      
      function init() {
        setCalendar();
        setMiniCalendar();
        $('#ksa_calendar_select').select2({
          theme: "classic",
          placeholder: '부서를 선택해주세요.',
          allowClear: true,
          width: 'resolve',
        });
        $('#ksa_calendar_select').on('select2:opening select2:closing', function( event ) {
          var $searchfield = $(this).parent().find('.select2-search__field');
          $searchfield.prop('disabled', true);
        });
      }

      function chgSelect() {
        if ($('#ksa_calendar_select').val() == $('#ksa_calendar_opt_person').val()) {
          $('#ksa_calendar_opt_dept').prop('disabled', true);
        } else {
          $('#ksa_calendar_opt_dept').prop('disabled', false);
        } 
        if ($('#ksa_calendar_select').val() != $('#ksa_calendar_opt_person').val()) {
          $('#ksa_calendar_opt_person').prop('disabled', true);
        } 
        if (isNullOrEmpty($('#ksa_calendar_select').val())) {
          $('#ksa_calendar_opt_person').prop('disabled', false);
        }
      }

      // 함수 정의
      vm.dayClick = dayClick;
      vm.eventClick = eventClick;
      vm.getData = getData;
      vm.changeClientNm = changeClientNm;
      vm.changeClientCode = changeClientCode;
      vm.setDeptType = setDeptType;
      vm.getDeptList = getDeptList;
      vm.deleteDept = deleteDept;

      vm.chgSelect = chgSelect;

      vm.init = init;

      $scope.eventSources = [];
      $scope.eventSources = [$scope.events];

      init();

      // getDeptList();
      // setDept();
    }]);
})();


(function() {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.schedule', {
        url: '/schedule',
        templateUrl: 'app/schedule/schedule.html',
        requiresAuthentication: true,
      })
      // .state('app.schedule.week', {
      //   url: '/today/:srch',
      //   templateUrl: 'app/schedule/schedule-week.html',
      //   requiresAuthentication: true,
      // })
      // .state('app.schedule.teacher', {
      //   url: '/teacher/:srch',
      //   templateUrl: 'app/schedule/schedule-teacher.html',
      //   requiresAuthentication: true,
      // })

      // .state('app.schedule.month', {
      //   url: '/month/:srch',
      //   templateUrl: 'app/schedule/schedule-month.html',
      //   requiresAuthentication: true,
      // })

      // .state('app.schedule.tenant-list', {
      //   url: '/tenant-list/:srch?searchDate',
      //   templateUrl: 'app/schedule/tenant-schedule-list.html',
      //   requiresAuthentication: true,
      // }).state('app.schedule.tenant-week-detail', {
      //   url: '/tenant-week-detail/:srch/:keyId/:searchDate',
      //   templateUrl: 'app/schedule/schedule-week.html'
      // }).state('app.schedule.tenant-teacher-detail', {
      //   url: '/tenant-teacher-detail/:srch/:keyId/:searchDate',
      //   templateUrl: 'app/schedule/schedule-teacher.html'
      // })
      ;
  }
})();

webapp.controller('ColumnAttrReorderCtrl', [ '$scope', '$uibModalInstance', '$filter', 'sortArrayFactory', 'toModalData',
    function ObjectTypeReorderController($scope, $uibModalInstance, $filter, sorts, toModalData) {
      var vm = this;
      var COLUMN_EDIT_STATE_MODIFY = 'M';
      var COLUMN_EDIT_STATE_PENDING = '';
      vm.selectedIdx = 0;
      vm.objModel = [];

      vm.onSelect = onSelect;
      vm.moveUp = moveUp;
      vm.moveDown = moveDown;
      vm.moveTop = moveTop;
      vm.moveBottom = moveBottom;
      vm.move = move;
      vm.onSave = onSave;
      vm.onClose = onClose;
      vm.title = '사용자 속성 정렬';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      angular.copy(sorts.sortArrayObject(toModalData, toModalData.ListColumnSort), vm.objModel);
      vm.objModelLen = vm.objModel.length;

      function onSelect(idx) {
        vm.selectedIdx = idx;
      }

      function moveUp() {
        var destIdx = vm.selectedIdx - 1;
        if (destIdx == -1) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveDown() {
        var destIdx = vm.selectedIdx + 1;
        if (destIdx == vm.objModelLen) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveTop() { // 맨위
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.unshift(temp);
        vm.selectedIdx = 0;
      }

      function moveBottom() { // 맨아래
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.push(temp);
        vm.selectedIdx = vm.objModelLen - 1;
      }

      function move(orgIdx, destIdx) {
        var temp = vm.objModel[destIdx];
        vm.objModel[destIdx] = vm.objModel[orgIdx];
        vm.objModel[orgIdx] = temp;
      }

      // 순서 변경 저장
      function onSave() {
        var reorderList = [];
        angular.forEach(vm.objModel, function(node, idx) {
          node.listColumnSort = idx;
          if (node.dirty == COLUMN_EDIT_STATE_PENDING) {
            node.dirty = COLUMN_EDIT_STATE_MODIFY;
          }
        });
        $uibModalInstance.close(vm.objModel);
      }

      // 취소|닫기 버튼
      function onClose() {
        $uibModalInstance.dismiss('cancel');
      }
    } ]);

webapp.controller('ColumnAttrSetupCtrl', ['$scope', '$uibModalInstance', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT', 'toModalData',
  function ColumnAttrSetupCtrl($scope, $uibModalInstance, systemCodeAPISrv, CONST, toModalData) {
    var vm = this;
    var backupColumn = {};
    vm.isSizableData = isSizableData;
    vm.onCancelClick = onCancelClick;
    vm.onAddClick = onAddClick;

    (function ColumnAttrSetupCtrl(){
      getSystemCodeList();
      vm.column = toModalData;
      angular.copy(toModalData, backupColumn);
      vm.selectedPhysicalDataType = {
          code: vm.column.columnPhysicalDataType
      };
      vm.selectedLogicalDataType = {
          code: vm.column.columnLogicalDataType
      };
      vm.title = vm.column.columnLogicalNm + "(" + vm.column.columnPhysicalNm + ")";
    })();

    function onCancelClick(){
      angular.copy(backupColumn, vm.column);
        $uibModalInstance.dismiss('cancel');
    }

    function onAddClick(){
      vm.column.columnPhysicalDataType = vm.selectedPhysicalDataType.code;
      vm.column.columnLogicalDataType = vm.selectedLogicalDataType.code;

      $uibModalInstance.close(vm.column);
    }

    function getSystemCodeList(){
      systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
      .then(function(json){
        vm.codeList = json.responseVO.body.docs;
      });
    }

    function isSizableData(){
      return ['40', '50'].indexOf(vm.selectedPhysicalDataType.code) < 0;
    }
  }]);

webapp.service('MetadataAPISrv', [ '$resource', 'StaticVariable','$rootScope', function MetadataAPISrv($resource, staticVariable, $rootScope) {
  return {

    getMetadataApi : function() {
      return $resource(staticVariable.getUrl('/api/metadata/metatables/:tableNm') + '.json', {
        tableNm : '@tableNm',userkey:$rootScope.gVariable.userKey
      }, staticVariable.getRequestActions.defaultAction());
    },
    getUsingMetaTableNm : function() {
      return $resource(staticVariable.getUrl('/api/metadata/metatables/:tableNm/info') + '.json', {
        tableNm : '@tableNm',userkey:$rootScope.gVariable.userKey
      }, staticVariable.getRequestActions.defaultAction());
    },
    doModuleTypeList: function() {
      return $resource(staticVariable.getUrl('/select/CommonCode.getCommonCodeValue/action.json'), {userkey:$rootScope.gVariable.userKey},
        staticVariable.getRequestActions.defaultAction());
    },

  };
}, ]);

webapp.controller('MetadataDetailCtrl', [ '$scope', '$state', '$stateParams', 'MetadataAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate',
    function MetadataDetailCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope,$location,$window,gConfirm,$translate) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      $scope.srchTenantId = $window.sessionStorage['srchTenantId'];
      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';

      (function MetadataDetailCtrl() {
        console.info('currentActionView:', $stateParams.currentActionView);
        vm.currentActionView = $stateParams.currentActionView;
        if (angular.isDefined($stateParams.tableNm)) {
          getMetaTableDetail();
        } else {
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }

      })();

      function getMetaTableDetail() {
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $window.sessionStorage['srchTenantId']
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          vm.metaTable.metaColumns.forEach(function(elm, idx) {
            elm.columnValid = true;
            elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
          });

          if(json.responseVO.body.docs[0].metaColumns.length > 0)
            vm.metaColumnYN = 'Y';
        });
      }

      function addColumn() {
        var newLine = {
          metaColumnId : '',
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '20%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          customColumnYN : 'Y',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        if(vm.metaColumnYN == 'N'){
          vm.currentActionView = 'add';
        }
        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              console.log('result.header.status');
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
        if (selectedColumn.dirty == vm.COLUMN_EDIT_STATE_PENDING || selectedColumn.dirty == vm.COLUMN_EDIT_STATE_MODIFY) {
          selectedColumn.dirty = vm.COLUMN_EDIT_STATE_DELETE;
        } else {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
        }
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            return true;
          }
        });
        return false;
      }

      function getTableColumns() {
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.currentActionView = 'add';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.metaTable.metaColumns = result.body.docs;
                }
              }, function(error) {
                console.log("error");
                // console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.metaTable.metaColumns = result.body.docs;
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        $state.go('app.boardmng.modify', {
          tableNm : $stateParams.tableNm
        });
      }
    }, ]);

webapp.controller('MetadataEditCtrl', [ '$scope', '$state', '$stateParams', 'MetadataAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT',
    function MetadataEditCtrl($scope, $state, $stateParams, metadataApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope, $location, $window, gConfirm, $translate, systemCodeAPISrv, CONST) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.ChangeCustomColumn = ChangeCustomColumn;
      vm.modMetaTable = modMetaTable;
      vm.delMetaTable = delMetaTable;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      vm.makeSrch = makeSrch;

      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';
      vm.dataloader = false;
      vm.changeColumn = 'N';
      vm.srchTenantId = $rootScope.gVariable.srchTenantId;

      vm.sbCtrl = null;
      vm.viewType = "D";

      (function getMetaTableEdit() {
        getModuleTypeList();
        if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
          vm.currentActionView = 'modify';
          //getMetaTableDetail();
        } else {
          vm.currentActionView = 'add';
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }
      })();

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      //console.log(vm.layout);

      vm.onSelectCallback = function(data) {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.metaColumnId == data.CallbackTarget) {
            item.columnPhysicalNm = data.Code;
            return;
          }
        });
      };

      function makeSrch(){
        return encodeURIComponent(JSON.stringify(vm.srch, replacer));
      }
      function getMetaTableDetail(dataType) {
        vm.dataloader = true;
        var data = {};
        postApi.sendPostApi('api/metadata/metatables', $stateParams.tableNm, data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.metaTable = result.body.docs[0];
              vm.sbCtrl.drawList(vm.metaTable, dataType);
              vm.checkColumnSection = "Y";
              vm.checkEditColumnRowCount = "Y";
              if (vm.metaTable) {
                vm.metaTable.metaColumns.forEach(function(elm, idx) {

                  if(!isNullOrEmpty(elm.columnSection)) {
                    vm.checkColumnSection = "N";
                  }

                  if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                    vm.checkEditColumnRowCount = "N";
                  }

                  if (elm.editColumnRowCount != null) {
                    elm.editColumnRowCount = elm.editColumnRowCount.toString();
                  }
                  if (elm.searchColumnRowCount != null) {
                    elm.searchColumnRowCount = elm.searchColumnRowCount.toString();
                  }

                  elm.columnValid = true;
                  elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
                  if (elm.customColumnYN == 'Y') {
                    elm.type = 'add';
                    elm.commoncodeDATA = {
                      CallbackTarget : elm.metaColumnId,
                      CodeType : 'METACOLUMN',
                      Code : elm.columnPhysicalNm,
                      ReloadSeq : 1
                    };
                  } else if (elm.customColumnYN == 'N') {
                    elm.type = 'old';
                  }
                });

                if(vm.metaTable.metaColumns.length > 0)
                  vm.metaColumnYN = 'Y';
              }
            } else {
              $rootScope.showSimpleToast('failed to load');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to load');
          console.log("error");
          // console.error('Error> metadata-list> getList()', status, error);
        });              
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = metadataApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function modMetaTable() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        data.deleteColumns = vm.deleteColumns;

        postApi.sendPostApi('api/metadata/mod', vm.metaTable.tableNm, data, function(result){

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.log("error");
          // console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }

      function delMetaTable() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = {};

        postApi.sendPostApi('api/metadata/del', vm.metaTable.tableNm, data, function(result){

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.UPDATED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.log("error");
          // console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }      

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/metadata/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/metadata/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/metadata/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/metadata/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        var res = false;
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            res = true;
          }
        });
        return res;
      }

      function validateCheck(){
        if(vm.currentActionView == 'add'){
          if(vm.usingTableNm.length != 0){
            gAlert('','Menu.EM710VA03');
            vm.dataloader = false;
            return false;
          }
        }

        return true;
      }

      function getTableColumns() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){

              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  var newnum = 0;
                  result.body.docs.forEach(function(elm,indx){

                    newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                    elm.metaColumnId = newnum.toString(36);
                    if (elm.customColumnYN == "N") {
                      elm.columnSection = "";

                      if (elm.dataType == "varchar") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else if (elm.dataType == "datetime" || elm.dataType == "date") {
                        elm.columnPhysicalDataType = "40";
                        elm.columnLogicalDataType = "40";
                      } else if (elm.dataType == "int") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "bigint") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "char") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      }
                      elm.columnPhysicalDataSize = "";
                      elm.listColumnWidth = "20%";
                      elm.listColumnTextAlign = "text-center";
                      elm.listColumnShowYN = "Y";
                      elm.listColumnShowLevel = "showlevel3";
                      elm.editColumnWidth = "col-lg-4 col-md-6";
                      elm.editColumnShowYN = "Y";
                      elm.editColumnHeight = "";
                      elm.columnDesc = "";
                      elm.columnCodeValue = "";
                      elm.codeType = "";
                      elm.dirty = "";
                    }

                    if (elm.customColumnYN == 'Y') {
                      elm.commoncodeDATA = {
                        CallbackTarget : elm.metaColumnId,
                        CodeType : 'METACOLUMN',
                        Code : elm.columnPhysicalNm,
                        ReloadSeq : 1
                      };
                    }
                  });
                  vm.metaTable.metaColumns = result.body.docs;
                  vm.sbCtrl.drawList(vm.metaTable);
                }
                vm.dataloader = false;
              }, function(error) {
                vm.dataloader = false;
                console.log("error");
                // console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              vm.checkColumnSection = "Y";
              vm.checkEditColumnRowCount = "Y";

              result.body.docs.forEach(function(elm,indx){
                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);

                if(!isNullOrEmpty(elm.columnSection)) {
                  vm.checkColumnSection = "N";
                }

                if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                  vm.checkEditColumnRowCount = "N";
                }

                if(elm.customColumnYN == 'N'){
                  elm.columnSection = '';
                  elm.editColumnSort = indx;
                  if(elm.dataType =="varchar"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else if(elm.dataType =="date"){

                    elm.columnPhysicalDataType = '40';
                    elm.columnLogicalDataType = '40';

                  }else if(elm.dataType =="datetime"){

                    elm.columnPhysicalDataType = '90';
                    elm.columnLogicalDataType = '90';

                  }else if(elm.dataType =="int"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="bigint"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="char"){

                    elm.columnPhysicalDataType = '110';
                    elm.columnLogicalDataType = '110';

                  }else{
                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';
                  }
                  elm.columnPhysicalDataSize = '';
                  elm.listColumnWidth = 'auto';
                  elm.listColumnTextAlign = 'text-center';
                  elm.listColumnShowYN = 'Y';
                  elm.listColumnShowLevel = 'showlevel3';
                  elm.editColumnWidth = 'col-lg-4 col-md-6';
                  elm.editColumnShowYN = 'Y';
                  elm.editColumnHeight = '';
                  elm.columnDesc = '';
                  elm.columnCodeValue = '';
                  elm.codeType = '';
                  elm.keyColumnYN = 'Y';
                }
                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
              vm.metaTable.metaColumns = result.body.docs;
              vm.sbCtrl.drawList(vm.metaTable)
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        vm.srchTenantId = $rootScope.gVariable.srchTenantId;
        vm.metaColumnYN = 'N';
        vm.changeColumn = 'N';
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          // 삭제시 -> 목록 화면 이동
          //$state.go("app.metadata.list", { srch: srch, tableNm: ''}, {reload:"app.metadata.list"});
        } else {
          // 조회 화면 이동
          $state.go("app.metadata.list.modify", {srch: srch, tableNm: vm.metaTable.tableNm}, {reload:"app.metadata.list"});
        }        
      }

      function ChangeCustomColumn() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y' || vm.changeColumn == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              if (vm.changeColumn =='N') vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.changeColumn = 'N';
              vm.metaTable.metaColumns = [];
              vm.dataloader = false;
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          vm.changeColumn = 'Y';
          postApi.select('BoardMng.getChangeTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              vm.metaTable.metaColumns = result.body.docs;
              vm.metaTable.metaColumns.forEach(function(elm, idx) {

                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);
                elm.tenantId = null;

                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function getModuleTypeList () {
        var res = metadataApi.doModuleTypeList().post({
          CodeType : 'MODULETYPE',
          srchTenantId : $rootScope.gVariable.srchTenantId,
          userkey : $rootScope.gVariable.userKey
        }).$promise;
        res.then(function(json) {
          vm.moduleTypeList = json.responseVO.body.docs;
        });
      }

      vm.succSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
        .then(function(json){
          if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
            getMetaTableDetail(json.responseVO.body.docs);
          } else {
            vm.sbCtrl.drawList(vm.metaTable, json.responseVO.body.docs)
          }
        });

        ctrl.openPop = function(data, callback) {

        };

        ctrl.deleteColumn = function(data, callback) {
          vm.deleteColumn(data);
        };

        ctrl.openAttrSetup = function(data, callback) {
          vm.openAttrSetup(data)
        };

        ctrl.onSelectCallback  = function(data, callback) {
          vm.onSelectCallback(data)
        };
      };

      
    }, ]);

webapp.controller('MetadataListCtrl', [ '$window', '$filter', 'GLOBAL_CONSTANT', 'MetadataAPISrv','$stateParams','$scope','$state','$rootScope', 'postApi', 'gAlert',
  function MetadataListCtrl($window, $filter, CONSTANT, metadataApi, $stateParams, $scope, $state, $rootScope, postApi, gAlert) {
    var vm = this;// View Model

    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.getSearch = getSearch;
    vm.makeSrch = makeSrch;
    vm.resetSearch = resetSearch;
    vm.pageChanged = pageChanged;

    var KEY_TABLE_NM = 'metatable';

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: ''          // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
    }

    $scope.selectedRow = $stateParams.tableNm;
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    setLayout(vm.layout); // 화면분할 모드 설정

    //pagination
    vm.totalCount = 0;
    vm.viewSizePerPage = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.viewSizePerPageList = CONSTANT.PAGINATION.OPTION_VIEWSIZE;
    vm.dataloader = false;
    // 검색 선택 옵션
    vm.searchFieldTypeList = [ {
      optionId : 'all',
      optionName : '전체'
    }, {
      optionId : 'table',
      optionName: '물리 테이블명'
    }, {
      optionId : 'column',
      optionName: '물리 컬럼명'
    }, ];

    vm.changeViewSize = changeViewSize;
    vm.getMetaTableList = getMetaTableList;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;

    (function BoardListCtrl() {
      // 페이징
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      getMetaTableList();
    })();

    function changeViewSize() {
      vm.srch.page = 1;
      vm.srch.viewSize = vm.viewSize;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getMetaTableList();
    });

    /**
     * 화면 분할 모드 설정
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setLayout(layout) {

      // 분할 모드 지정
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          // 수평
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          // 수직
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          // 기본
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    /**
     * 화면 분할 모드 변경
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function changeLayout(layout) {
      // 분할 모드 설정값 저장
      $rootScope.changeLayout(layout);

      var srch = $stateParams.srch; // 검색 옵션

      $state.go('app.metadata.list', {
        srch: makeSrch(),
        tableNm: ''
      }, {reload: 'app.metadata.list'});
    }

    function getMetaTableList() {
      vm.srch.page = vm.currentPage;
      vm.dataloader = true;
      var data = vm.srch;
      data.mapCode = "metadata/metatables";
      postApi.api(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.boardList = result.body.docs;
              vm.currentPage = vm.boardList[0].page;
              vm.totalCount = vm.boardList[0].totalCount;
              vm.boardList.splice(0, 1);
              vm.dataloader = false;
            } else {
              vm.dataloader = false;
              var errMsg = result.body.docs.errMessage;
              gAlert("Menu.ERROR", errMsg);
              console.log("error");
              // console.error("ErrorCode : ", result.body.docs.errCode, "ErrorMsg : ", result.body.docs.errMessage);
            }
          }
          vm.columnMap = '';
          vm.SearchConditionStr = getSearchConditionStr(vm.totalCount, vm.columnMap, vm.srch);
          vm.dataloader = false;
        },
        function(error) {
          console.log("error");
          // console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
        vm.sortDirect = vm.srch.sortDirect ;
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.sortDirect = vm.srch.sortDirect ;
      }

      vm.srch.sortColumn = sortkey;
      vm.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.metadata.list', {srch:srch}, {reload:'app.metadata.list'});
    }
    function makeSrch(){
      return encodeURIComponent(JSON.stringify(vm.srch, replacer));
    }

    function resetSearch() {
      $state.go('app.metadata.list', {
        srch : ''
      }, {reload: 'app.metadata.list'});
    }

    function goDetail(tableNm) {
      var srch = $stateParams.srch; // 검색 옵션
      $scope.selectedRow = tableNm;

      if (vm.layout == 'N') {
        // 조회 화면 이동
        $state.go('app.metadata.modify', {
          srch: srch,
          tableNm: tableNm
        });
      } else {
        // 목록 조회 화면 이동
        $state.go('app.metadata.list.modify', {
          srch: srch,
          tableNm: tableNm
        });
      }
    }

    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }
}, ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.metadata', {
      url: '/metadata',
      template: '<div ui-view></div>',
    }).state('app.metadata.list', {
      url: '/list/:srch',
      templateUrl: 'app/metadata/metadata-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.metadata.list.add', {
      templateUrl: 'app/metadata/metadata-edit.html',
      controller: 'MetadataEditCtrl as vc',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.metadata.list.modify', {
      url: '/modify/:tableNm',
      templateUrl: 'app/metadata/metadata-edit.html',
      controller: 'MetadataEditCtrl as vc',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.metadata.add', {
      url: '/add/:srch',
      templateUrl: 'app/boardmng/metadata-edit.html',
      controller: 'MetadataEditCtrl as vc',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.metadata.modify', {
      url: '/modify/:srch/:tableNm',
      templateUrl: 'app/metadata/metadata-edit.html',
      controller: 'MetadataEditCtrl as vc',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    });
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignAutoListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CampaignAutoListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplCustomerListCnt2'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplCustomerList2';    // 목록 조회 SQL
      var STATS_SQL = 'Campaign2.getGroupSmsStatsList';
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteCampaignList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.campaign-customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.campaign-customer-list.edit';    // 목록 등록/수정 화면
      var LIST_EDIT_AUTO_PAGE_URL = 'app.message.campaign-customer-list.auto-edit';    // 목록 등록/수정 화면

      var VIEW_PAGE_URL = 'app.message.campaign-customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.campaign-customer-edit';         // 등록/수정 화면
      var EDIT_AUTO_PAGE_URL = 'app.message.campaign-auto-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImplCustomer2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      var toDate = new Date();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          //CmpgnChannel : 'SMS',
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          RegDateFrom : new Date(toDate.getFullYear(), toDate.getMonth(), 1),
          RegDateTo : new Date(toDate.getFullYear(), toDate.getMonth()+1, 0)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId == null ? '':$stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        console.log('rootScope $viewContentLoaded th count=', $(".table-custom thead th").length);
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.ManagerId = "";
      };
      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        
        getListCnt(); // 목록 건수 조회
        getStatsList();
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        if(vm.RegDateFrom == undefined && vm.RegDateTo == undefined) {
          vm.RegDateFrom = vm.srch.RegDateFrom;
          vm.RegDateTo = vm.srch.RegDateTo; 
        }
        vm.srch.RegDateFrom = moment(data.RegDateFrom).format('YYYY-MM-DD');
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        vm.srch.RegDateTo = moment(data.RegDateTo).format('YYYY-MM-DD');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      function getStatsList() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = STATS_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.FailSms = result.body.docs[0].FailSms;
              vm.SuccessSms = result.body.docs[0].SuccessSms;
              vm.SumCost = result.body.docs[0].SumCost;
            } else {
              // 조회 실패
              vm.FailSms = 0;
              vm.SuccessSms = 0;
              vm.SumCost = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;
        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(cmpgnType) {
        vm.keyId = '';
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          formType: '',
          cmpgnType : cmpgnType,
          keyId: ''
        });
      }
      
      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, cmpgnType) {
        var bAuto = false;
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';
        
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          cmpgnType: cmpgnType,
          keyId: paramKeyId
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getStatsList = getStatsList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CampaignCustomerDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CampaignCustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertCampaignBatch';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateCampaign';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getCampaignDetail3';   // 조회 SQL
      var DEL_SQL = 'Campaign2.deleteCampaign';  // 삭제 SQL
      var GET_GRUOP_CUST_CNT_SQL = 'Campaign2.getGroupCustomerList2';                  // 수신그룹 대상고객 조회
      var GET_GROUP_CUST_SQL = 'Campaign2.getCampaignCustomers';
      var GET_CUST_CNT_SQL = 'Campaign2.getCampaignCustCnt';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-customer-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.message.campaign-customer-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.message.campaign-customer-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.info2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // View Model
      var vm = this;          // View Model
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.goList = goList;

      (function CampaignCustomerDetailCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;

        vm.CmpgnImplCustId = $stateParams.keyId;
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect';
        
        vm.sendNumberVerifyList = [];
        
        getCustInfo();
      })();

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = {};
        data.selectType = 'Detail';
        data.CmpgnImplCustId = vm.CmpgnImplCustId;
        data.mapCode = 'Campaign2.getCampaignDetail3';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data = result.body.docs[0];
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          item.SendTitle = data.SendTitle;
          item.SendMessage = data.SendMessage;
          item.SendMessage2 = data.SendMessage2;
        });
        
        postApi.insert(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      function chkSendMessage() {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS';
        vm.messageMaxLength = vm.data.CmpgnChannel == 'SMS' ? '90' : '2000';
        vm.messageLength = bytes;
      }
      
      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignCustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CampaignCustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplCustomerListCnt2'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplCustomerList2';    // 목록 조회 SQL
      var STATS_SQL = 'Campaign2.getGroupSmsStatsList';
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteCampaignList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.campaign-customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.campaign-customer-list.edit';    // 목록 등록/수정 화면
      var LIST_EDIT_AUTO_PAGE_URL = 'app.message.campaign-customer-list.auto-edit';    // 목록 등록/수정 화면

      var VIEW_PAGE_URL = 'app.message.campaign-customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.campaign-customer-edit';         // 등록/수정 화면
      var EDIT_AUTO_PAGE_URL = 'app.message.campaign-auto-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImplCustomer2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      var toDate = new Date();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          //CmpgnChannel : 'SMS',
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          RegDateFrom : new Date(toDate.getFullYear(), toDate.getMonth(), 1),
          RegDateTo : new Date(toDate.getFullYear(), toDate.getMonth()+1, 0)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId == null ? '':$stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        console.log('rootScope $viewContentLoaded th count=', $(".table-custom thead th").length);
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.ManagerId = "";
      };
      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        
        getListCnt(); // 목록 건수 조회
        getStatsList();
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        if(vm.RegDateFrom == undefined && vm.RegDateTo == undefined) {
          vm.RegDateFrom = vm.srch.RegDateFrom;
          vm.RegDateTo = vm.srch.RegDateTo; 
        }
        vm.srch.RegDateFrom = moment(data.RegDateFrom).format('YYYY-MM-DD');
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        vm.srch.RegDateTo = moment(data.RegDateTo).format('YYYY-MM-DD');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      function getStatsList() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = STATS_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.FailSms = result.body.docs[0].FailSms;
              vm.SuccessSms = result.body.docs[0].SuccessSms;
              vm.SumCost = result.body.docs[0].SumCost;
            } else {
              // 조회 실패
              vm.FailSms = 0;
              vm.SuccessSms = 0;
              vm.SumCost = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;
        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(cmpgnType) {
        vm.keyId = '';
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          formType: '',
          cmpgnType : cmpgnType,
          keyId: ''
        });
      }
      
      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, cmpgnType) {
        var bAuto = false;
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';
        
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          cmpgnType: cmpgnType,
          keyId: paramKeyId
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getStatsList = getStatsList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignImplListCtrl', ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state',

    function CampaignListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $state) {
      var vm = this;          // View Model
      vm.dataloader = true;
      
      // 담당자 목록
      postApi.select({ mapCode: 'ScUser.getUserListCodes' },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
        }
      });

      vm.headerTitle = "메세지 발송 목록";

      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn: true,

        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "campaignimpl",
        keyIdNm: "keyId",
        alias: "vc",
        dataModelNm: "lists", // ex : vc.data = {}
        srchModelNm: "srch",
        srchTarget: "searchWrap",
        apis: {
          initSelectCnt: { mapCode: "CampaignImpl.getCampaignImplCareListCnt", param: null },
          initSelect: { mapCode: "CampaignImpl.getCampaignImplCareList", param: null },
        },

        addSrchStack: true,

        // List
        listCheckboxEnable: false,

        src: {
          detail: "app.message.sms-send-edit",
          splitDetail: "app.message.campaign-list.edit"
        },

        addFormGroup: {
          SrchStartDate : { after : "Status", type : mElemTx.date,  bindKey : ["StartDateFrom", "StartDateTo"], label : "실행일시", addDivision : true, colSize : 2},
        },

        srchDateType : {
          StartDateFrom : "from",
          StartDateTo : "to"
        },

        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes: {
          ManagerId : "codeManager"
        }

      };

      function onReadyAutoView() {
        vm.dataloader = false;
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

(function () {
  "use strict";
  webapp.controller('CampaignResultDetailCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$filter', '$window', '$state', '$rootScope',
  function CampaignResultDetailCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $filter, $window, $state, $rootScope) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.Edit, // List OR Edit
      /* 상세페이지 */
      // 엘리먼트 퍼블리싱 타입
      formType : mElemTx.layout.inline,
      tableNm : "sccampaigncustimpl",
      keyIdNm : "keyId",
      alias : "vc",
      dataModelNm : "data", // ex : vc.data = {}
      apis : {
        /** common mapper **/
        // initSelect : 기본 데이터를 가져오는 코드 
        initSelect : { mapCode : "CampaignImpl.getCampaignCustImplDetail", param : null },
        // vieType is edit
        insert : "",
        update : "",        
      },

      // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
      addRow : [],

      // vc의 ng-if
      ngIf : {
      },
      
      // 비활성화 시킬 컬럼의 조건
      disabled : {
        BranchNm: true,
        SendType: true,
        CmpgnChannel: true,
        FromInfo: true,
        ToInfo: true,
        CustNm: true,
        ResultDate: true,
        SendStatus: true,
        UserNm: true,
        SejongErrCode: true,
        SendMessage: true
      },

      // MataColum 외 추가 적으로 넣어야할 폼
      addForm : {
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange : {
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback : {
      },

      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes : {
      },

      // textArea 사이즈 옵션
      textAreaOption: {
        SendMessage: { rows: 16 }
      },

      // 필수 항목 컬럼 
      required : [""]
      
    };

    function onReadyAutoView() {
      // 초기 설정
      if(vm.data.keyId) {
        // 발송자, 수신자 폰번호일 경우 포멧변경
          if(!isNullOrEmpty(vm.data.FromInfo) && vm.data.FromInfo.indexOf("@") == -1) {
            vm.data.FromInfo = autoHypenTel(vm.data.FromInfo);
          }

          if(!isNullOrEmpty(vm.data.ToInfo) && vm.data.ToInfo.indexOf("@") == -1) {
            vm.data.ToInfo = autoHypenTel(vm.data.ToInfo);
          }
      }

      vm.layout = $state.current.name.indexOf('campaign-result-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard;
      if ($state.current.name.indexOf('campaign-result-detail') > -1) {
        vm.layout = '';
      }
    }

    function goList() {
      $window.history.back();
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
  
    vm.goList = goList;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignResultListCtrl', ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state',

    function CampaignResultListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state) {
      var vm = this;          // View Model

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.headerTitle = "개별 메세지 결과";

      vm.codeCmpgnChannel = [
        {Code : 'SMS', CodeValue : 'SMS'},
        {Code : 'EMAIL', CodeValue : 'EMAIL'},
      ];
      
      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn: true,

        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "sccampaigncustimpl",
        keyIdNm: "keyId",
        alias: "vc",
        dataModelNm: "lists", // ex : vc.data = {}
        srchModelNm: "srch",
        srchTarget: "searchWrap",
        apis: {
          initSelectCnt: { mapCode: "CampaignImpl.getCampaignCustImplListCnt", param: null },
          initSelect: { mapCode: "CampaignImpl.getCampaignCustImplList", param: null },
        },

        addSrchStack: true,

        // List
        listCheckboxEnable: true,

        src : {
          detail : "app.message.campaign-result-detail",
          splitDetail : "app.message.campaign-result-list.detail"
        },

        addForm : {
          SendType : { before : "CmpgnChannel", type : mElemTx.select, label : "발송유형", colSize: 2},
          Channel : { after : "SendType", type : mElemTx.select, label : "SMS/EMAIL", colSize: 2},
          SendStatus : { after : "SrchResultDate", type : mElemTx.select, label : "발송상태", colSize: 2}
        },

        addFormGroup : {
          SrchResultDate : { after : "CustNm", type : mElemTx.date,  bindKey : ["ResultDateFrom", "ResultDateTo"], label : "수신일", addDivision : true, colSize : 2},
        },

        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes: {
          Channel: "codeCmpgnChannel"
        }

      };

      function onReadyAutoView() {

        // 발송자, 수신자 폰번호일 경우 포멧변경
        vm.lists.forEach(function(item){
          if(!isNullOrEmpty(item.FromInfo) && item.FromInfo.indexOf("@") == -1) {
            item.FromInfo = autoHypenTel(item.FromInfo);
          }

          if(!isNullOrEmpty(item.ToInfo) && item.ToInfo.indexOf("@") == -1) {
            item.ToInfo = autoHypenTel(item.ToInfo);
          }
        });

      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('EmailCertifiListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'autoView',

    function EmailCertifiListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, autoView) {
      var vm = this;
      var KEY_TABLE_NM = 'SendVerify.Email'; // 작업 테이블명

      // SQL Mapper Id 정의
      var LIST_SQL  = "SendVerify.getSendVerifyList";
      var LIST_CNT_SQL  = "SendVerify.getSendVerifyListCnt";
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제
      
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          tableNm: KEY_TABLE_NM, // For CustomColumn and FileAttachment
          sortDirect: "",
          sortColumn: "",
          Type : 'E',
          selectType : "List"
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = KEY_TABLE_NM; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.srchList.searchColumns = {};
      vm.listSize = [10, 25, 50, 100];

      function getListCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.log("error");
          // console.error("Error> email-certifi-list-ctrl> getListCnt()", status, error);
        });
      }

      function getList() {
        getListCnt();
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_SQL;
        vm.viewSize = vm.srch.viewSize;
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.log("error");
          // console.error("Error> email-certifi-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        });
      }

      function setResponsive(dockMode) {
        var rows = vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];
  
        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if (item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 번호 변경시 데이터 조회 함수 호출
       * @param
       * @return
       * @author 이기훈
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.message.email-certifi-list",
          { srch: srch },
          { reload: "app.message.email-certifi-list" }
        );
      }

      function changeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch.viewSize;
        getSearch();
      }

      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.message.email-certifi-list",
          { srch: srch },
          { reload: "app.message.email-certifi-list" }
        );
      }
  
      function resetSearch() {
        $state.go(
          "app.message.email-certifi-list",
          { srch: "" },
          { reload: "app.message.email-certifi-list" }
        );
      }

      // #region 상수 정의

      function setDelData(li) {
        gConfirm('', '삭제하시겠습니까?', {
          btn : '',
          fn : function() {
            setDelDataAction(li);
          }
        }, {
          btn : '',
          fn : ''
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelDataAction(li) {
        var data = angular.copy(li);
        data.mapCode = 'aws/deleteVerifyEmail';
        
        postApi.api(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '삭제되었습니다.', {
              btn : '',
              fn : getList()
            });
          } else {
            gAlert('', result.body.docs[0].errMessage);
            return;
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelDataAction()");
          // console.table(error);
        });
      }

      function openEmailCertifiModal() {
        var ctrl = 'EmailCertifiModalCtrl as vc';
        var paramData = { };

        var modalInstance = modalFactory.open('md', 'app/message/modal/email-certifi-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          getList();
        }, function (cancelData) {
        });
      }

      //#region 정렬 컬럼 설정

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
       function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정에 따른 Grid header Icon 표시

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      //#endregion


      // 함수 정의
      vm.openEmailCertifiModal = openEmailCertifiModal;
      vm.pageChanged = pageChanged;
      vm.changeViewSize = changeViewSize;
      vm.getSearch = getSearch;
      vm.resetSearch = resetSearch;
      vm.setDelData = setDelData;

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      getList();

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('FormEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function FormEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertForm';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateForm';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getFormDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'Campaign2.deleteFormDetail';  // 삭제 SQL
      var UPDATE_AGREE_MSG_SQL = 'Campaign2.updateAgreeMsg'; //수신동의메세지 update

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.form-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.message.form-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.message.form-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;
      
      vm.formType = $stateParams.formType; // SMS, KAKAO, EMAIL
      vm.Contents = "0";
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                                     // 작업 테이블명
        CmpgnChannel : 'SMS', //SMS : 90byte, LMS : 2000byte
      };

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }
      
      vm.addADTxtYN = 'N';

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        
        vm.data.FormType = $stateParams.formType;
        vm.data.TenantId = $rootScope.gVariable.srchTenantId;
        vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
        
        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
          vm.isMine = true;
          return false;
        }
        
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              
              if ($rootScope.gVariable.srchTenantId == vm.data.TenantId) vm.isMine = true;
              else vm.isMine = false; 
              
              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();
              vm.chkSendMessage();
            }

            if(vm.formType == "EMAIL") {
              try {
                oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.Contents]);
              } catch (e) {
                console.log(e);
              }
            }
          } else {
            console.log("error");
            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }
        //LMS. MMS 일경우 필수
        if (vm.data.FormType == 'LMS'  && isNullOrEmpty(vm.data.Title)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if (vm.data.FormType == 'SMS' && isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        if(vm.formType == "EMAIL") {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.data.Contents = $("#strHtml").val();
        }

        var data = vm.data; // 사용자 입력 데이터

        if (getIsValidData() == false) {
          return;
        }

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            // console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              formType: vm.formType,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch,formType:vm.formType, keyId: vm.data.KeyId});
        }
      }

       /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 2000;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.Contents)) {
          msg = vm.data.Contents;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            gAlert('', '메시지는 최대 2000 bytes까지 가능합니다.', {
              btn : '',
              fn : function () {
                vm.data.Contents = fnCutMsg(msg, 2000);
                bytes = 2000;
                vm.messageLength = bytes; 
              }
            });
          } else {
            vm.messageLength = bytes; 
          }
        } else {
          vm.messageLength = 0;
          vm.addADTxtYN = 'N';
        }
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      /**
       * 광고문구 추가
       */
      vm.chkADTxt = function() {
        if(vm.data.Title == undefined){
          vm.data.Title = '';
        }
        
        if(vm.data.Contents == undefined){
          vm.data.Contents = '';
        }
        
        if(vm.addADTxtYN == 'Y'){
          vm.data.Title = vm.addADTxt + vm.data.Title;
          vm.data.Contents = vm.addADTxt + vm.data.Contents;
        }else{
          vm.data.Title = vm.data.Title.replaceAll(vm.addADTxt, '');
          vm.data.Contents = vm.data.Contents.replaceAll(vm.addADTxt, '');
        }
        
        vm.chkSendMessage();
      };

      vm.chkDenyTxt = function() {
        if(vm.data.Contents == undefined){
          vm.data.Contents = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.Contents = vm.data.Contents + vm.addDenyTxt;
        }else{
          vm.data.Contents = vm.data.Contents.replaceAll(vm.addDenyTxt, '');
        }
        
        vm.chkSendMessage();
      };

      vm.tabId = 'tab1';
      vm.setChangeTab = function(_id){
        vm.tabId = _id;
        $('.tab-pane.active').addClass('fade').removeClass('active');
        $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
      };

      /**
       * 회원수신동의 문구 저장
       * @param
       * @return
       */
      function setFromAgreeMsg() {
        var data = angular.copy(vm.data);
        data.mapCode = UPDATE_AGREE_MSG_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "회원수신동의 문구가 저장되었습니다.");
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.contentsModal = function () {
        var ctrl = 'ContentsModalCtrl as modalCtrl';
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        var Contents = $("#strHtml").val();
        var paramData = {
          Contents:Contents,
          AgreeYN : vm.data.AgreeYN,
          TelNo : vm.branchData.TelNo
        };

        var modalInstance = modalFactory.open("lg","components/modal/contents/contents-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      function getBranchDetail() {
        var data = {};
        data.mapCode = 'organizationMng.getBranchDetail';

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.branchData = result.body.docs[0];
              vm.branchData.TenantNm = $window.sessionStorage['loginTenantName'];
              vm.branchData.loginMobile = $window.sessionStorage['loginMobile'];
              vm.data.ServPoint = vm.branchData.ServPoint;
              vm.branchData.loginMobile = autoHypenTel(vm.branchData.loginMobile);
              vm.addADTxt = '(광고) 무료수신거부 ' + autoHypenTel(result.body.docs[0].TelNo);
            } else {
              vm.branchData = {};
            }
          }
        });
      }

      //#region innerTextArea 현재 커서 위치에 텍스트 대체하기
      /**
        * 메세지 글 자르기
        * @param areaId - textArea Id 값
        * @param type - type
        * @return
        */
      function innerTextArea(areaId, type) {
        var text = '';
        if (type == 'C') {
          text = '{CustNm}';
        } else if (type == 'T') {
          text = vm.branchData.TenantNm;
        } else if (type == 'B') {
          text = vm.branchData.GroupNm;
        } else if (type == 'M') {
          text = vm.branchData.loginMobile;
        } else if (type == 'A' && !isNullOrEmpty(vm.branchData.ZipCode)) {
          text = '(우)' + vm.branchData.ZipCode + ' ' + vm.branchData.Addr1;
          if (!isNullOrEmpty(vm.branchData.Addr2)) {
            text = text + ' ' + vm.branchData.Addr2;
          }
        } else if (type == 'BA' && !isNullOrEmpty(vm.branchData.Bank) && !isNullOrEmpty(vm.branchData.AccountNum)) {
          text = '[' + vm.branchData.Bank + '] ' + vm.branchData.AccountNum;
        }

        var txtarea = document.getElementById(areaId);
        var scrollPos = txtarea.scrollTop;
        var strPos = 0;
        var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
          "ff" : (document.selection ? "ie" : false));
        if (br == "ie") {
          txtarea.focus();
          var range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          strPos = range.text.length;
        }
        else if (br == "ff") strPos = txtarea.selectionStart;

        var front = (txtarea.value).substring(0, strPos);
        var back = (txtarea.value).substring(strPos, txtarea.value.length);
        txtarea.value = front + text + back;
        vm.data.Contents = txtarea.value;
        strPos = strPos + text.length;
        if (br == "ie") {
          txtarea.focus();
          var range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          range.moveStart('character', strPos);
          range.moveEnd('character', 0);
          range.select();
        }
        else if (br == "ff") {
          txtarea.selectionStart = strPos;
          txtarea.selectionEnd = strPos;
          txtarea.focus();
        }
        txtarea.scrollTop = scrollPos;

        var tcount = 0;
        if (text == "{CLICKURL}") {
          alert('장문으로 전환됩니다.');

          $("#ContentPage_FLD_SENDCLSS").val("20");
          fnChgSendClss();

          $("#ContentPage_lblByte").html(tcount + " / 2000 bytes");
        }

        vm.chkSendMessage();
      }
      //#endregion innerTextArea 현재 커서 위치에 텍스트 대체하기
     
      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장
      vm.goList = goList;                       // 목록 화면 이동
      vm.innerTextArea = innerTextArea;

      // 데이터 조회
      getData();
      getBranchDetail();
      
    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:form-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('FormListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function FormListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getFormListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getFormList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteFormList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.form-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.form-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.form-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.form-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.form-edit';         // 등록/수정 화면
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }
      vm.srchTenantId = $rootScope.gVariable.srchTenantId; 

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'RegDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            if (vm.lists[i].TenantId != $rootScope.gVariable.srchTenantId) {
              gAlert('', '관리자 게시물 삭제 불가');
              return;
            }
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.message', {
      url: '/message',
      template: '<div ui-view></div>'
    })
    // 단순발송
    .state('app.message.sms-send-edit', {
      url: '/sms-send-edit/:keyId',
      templateUrl: 'app/message/sms-send-edit.html',
      requiresAuthentication: true,
    })
    // Email 발신 인증
    .state('app.message.email-certifi-list', {
      url: '/email-certifi-list/:srch',
      templateUrl: 'app/message/email-certifi-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    // SMS발송번호 인증
    .state('app.message.sms-send-number-save', {
      url: '/sms-send-number-save/:srch',
      templateUrl: 'app/message/sms-send-number-save.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    // SMS발송번호인증 관리
    .state('app.message.sms-send-number-list', {
      url: '/sms-send-number-list/:srch',
      templateUrl: 'app/message/sms-send-number-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.sms-send-number-edit', {
      url: '/sms-send-number-edit/:srch/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    }).state('app.message.sms-send-number-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    })
    // 서식관리
    .state('app.message.form-list', {
      url: '/form-list/:srch',
      templateUrl: 'app/message/form-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.form-edit', {
      url: '/form-edit/:srch/:formType/:keyId',
      templateUrl: 'app/message/form-edit.html',
    }).state('app.message.form-list.edit', {
      url: '/edit/:formType/:keyId',
      templateUrl: 'app/message/form-edit.html',
    })
    // 알림발송관리
    .state('app.message.campaign-auto-list', {
      url: '/campaign-auto-list/:srch',
      templateUrl: 'app/message/campaign-auto-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    // 발송목록
    .state('app.message.campaign-list', {
      url: '/campaign-list/:srch',
      templateUrl: 'app/message/campaign-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    .state('app.message.campaign-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/sms-send-edit.html',
    })
    // 발송현황
    .state('app.message.campaign-result-list', {
      url: '/campaign-result-list?:srch',
      templateUrl: 'app/message/campaign-result-list.html',
      requiresAuthentication: true,
    })
    // 발송현황상세페이지
    .state('app.message.campaign-result-detail', {
      url: '/campaign-result-detail?:srch/:keyId',
      templateUrl: 'app/message/campaign-result-detail.html',
      requiresAuthentication: true,
    })
    .state('app.message.campaign-result-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/message/campaign-result-detail.html',
      requiresAuthentication: true,
    })
    //SMS 자동발송문구 관리
    .state('app.message.sms-auto-list-tenant', {
      url: '/sms-auto-list-tenant/:srch',
      templateUrl: 'app/message/sms-auto-list-tenant.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.sms-auto-edit-tenant', {
      url: '/sms-auto-edit-tenant/:srch/:keyId',
      templateUrl: 'app/message/sms-auto-edit-tenant.html',
    }).state('app.message.sms-auto-list-tenant.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/sms-auto-edit-tenant.html',
    })

    ;
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:sms-auto-edit-tenant
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SmsAutoEditTenantCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SmsAutoEditTenantCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SmsSituationAutoTenant.insertSmsSituationAutoTenant';     // 등록 SQL
      var UPDATE_SQL = "SmsSituationAutoTenant.updateSmsSituationAutoTenant";   // 인증 승인
      var VIEW_SQL = 'SmsSituationAutoTenant.getSmsSituationAutoDetailTenant'; // 조회 SQL
      var DEL_SQL = 'SmsSituationAutoTenant.deleteSmsSituationAutoTenant';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-auto-list-tenant';             // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-auto-list-tenant.edit';  // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.message.sms-auto-edit-tenant';           // 수정 화면

      var KEY_TABLE_NM = 'campaign.smssituationautotenant'; // 작업 테이블명


      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.showUploader = true;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.tableNm = KEY_TABLE_NM;
      vm.srchDetail.uploadFileList = [];
      vm.srchDetail.IdName = "SmsSituationAutoTenantId";
      vm.lmsYN = 'N';

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        CmpgnChannel : 'KAKAO', //SMS : 90byte, LMS : 2000byte
      };

      $scope.isSMSType = function(CodeList) {
        return CodeList.Code == "SMS" || CodeList.Code == "LMS" || CodeList.Code == "MMS";
      };      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (!isNullOrEmpty(vm.srch.keyId)) {
              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                vm.data = result.body.docs[0];
                vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
                if (vm.data.CmpgnChannel == 'EMAIL') {
                  vm.messageMaxLength = '0000';
                }

                var uploadFileList = [];

                angular.forEach(vm.data.uploadFileList, function(item) {
                  var obj = {
                    id : item.fileId,
                    isLoaded : true,
                    link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                    fileName : item.LogicalFileNm,
                    size : item.FileSize,
                    fileKey : item.PhysicalFileNm,
                    path : item.PhysicalPath,
                    downloadCnt : item.DownloadCnt,
                  };
                  uploadFileList.push(obj);
                });
  
                angular.copy(uploadFileList, vm.uploadFileList);
              } else {
                vm.data.TenantId = $rootScope.gVariable.srchTenantId;
                vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
              }

              if (vm.data.CmpgnChannel == 'LMS')  {
                vm.lmsYN = 'Y';
              }
            }

            vm.chkSendMessage();
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }
      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

     /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;

        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 발송 내용을 확인하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn =  false;
        }

        return bRtn;
      }

     /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData()) {
          // 내용
          var data = angular.copy(vm.data); // 사용자 입력 데이터

          data.uploadFileList = vm.uploadFileList;
          data.tableNm = KEY_TABLE_NM;
          data.mapCode = INSERT_SQL;
          data.IdName = "SmsSituationAutoTenantId";
          data.SmsSituationAutoId = data.keyId;
          if (data.DayBeforeYN == 'N') {
            data.DayBefore = null;
          }

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

     /**
       * 데이터 삭제
       *
       * @param
       * @return
       */      
      function deleteData() {
        gConfirm('', 'Menu.DELETENDEFAULTCONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }


      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null || vm.data.SmsSituationAutoTenantId == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        var data = vm.srchDetail;
        data.mapCode = 'SmsSituationAutoTenant.deleteSmsSituationAutoTenant';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                goList();
              }
            });
            return;
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                goList();
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(LIST_PAGE_URL, {
            srch: srch
          }, {reload: LIST_PAGE_URL});
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: $stateParams.keyId
          }, {reload: LIST_PAGE_URL});
        }        
      }

       /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (vm.data.CmpgnChannel == 'SMS' && bytes > 90) {
            $rootScope.showSimpleToast($translate.instant('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.'));
            vm.messageMaxLength = 2000;
            vm.data.CmpgnChannel = 'LMS';
            vm.lmsYN = 'Y';
          }

          if ((vm.data.CmpgnChannel == 'LMS' || vm.data.CmpgnChannel == 'MMS') && bytes > 2000) {
            $rootScope.showSimpleToast($translate.instant('메세지는 최대 2000 bytes까지 가능합니다.'));
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }

          if (vm.lmsYN == 'Y' && bytes < 91) {
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          }

          vm.messageLength = bytes;
        } else {
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          bytes = 0;
          vm.messageLength = bytes;
        }
        vm.messageLength = bytes;
      };

      vm.setCmpgnChannel = function() {
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.messageMaxLength = '90';
        } else if (vm.data.CmpgnChannel == 'LMS') {
          vm.messageMaxLength = '2000';
        } else if (vm.data.CmpgnChannel == 'MMS') {
          vm.messageMaxLength = '2000';
          initVaultComponentForMMSImg('vault', vm.onFileCallback);
        } else if (vm.data.CmpgnChannel == 'EMAIL') {
          vm.messageMaxLength = '0000';
        }
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      function innerTextArea(areaId, type) {
        var text = type;

        var txtarea = document.getElementById(areaId);
        var scrollPos = txtarea.scrollTop;
        var strPos = 0;
        var range = '';
        var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
          "ff" : (document.selection ? "ie" : false));
        if (br == "ie") {
          txtarea.focus();
          range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          strPos = range.text.length;
        }
        else if (br == "ff") strPos = txtarea.selectionStart;

        var front = (txtarea.value).substring(0, strPos);
        var back = (txtarea.value).substring(strPos, txtarea.value.length);
        txtarea.value = front + text + back;
        vm.data.SendMessage = txtarea.value;
        strPos = strPos + text.length;
        if (br == "ie") {
          txtarea.focus();
          range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          range.moveStart('character', strPos);
          range.moveEnd('character', 0);
          range.select();
        }
        else if (br == "ff") {
          txtarea.selectionStart = strPos;
          txtarea.selectionEnd = strPos;
          txtarea.focus();
        }
        txtarea.scrollTop = scrollPos;

        var tcount = 0;
        if (text == "{CLICKURL}") {
          alert('장문으로 전환됩니다.');

          $("#ContentPage_FLD_SENDCLSS").val("20");
          fnChgSendClss();

          $("#ContentPage_lblByte").html(tcount + " / 2000 bytes");
        }
      }      

      vm.tabId = 'tab1';
      vm.setChangeTab = function(_id){
        vm.tabId = _id;
        $('.tab-pane.active').addClass('fade').removeClass('active');
        $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
      };

      //#region 업로드 파일 목록
      vm.uploadFileList = [];
      //#endregion 업로드 파일 목록

      //#region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드 완료
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          var param = {
            fileId: item.id
          };

          var prms = h0102Api.attachFileDelete().post(param).$promise;
          prms.then(function (data) {
            if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
              gAlert("", "Menu.DELETED");
            }
          });
        },
        onLoaded: function (id, vault) {
          vm[id] = vault;
        }
      };

      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          uploadVaultFile(vm.vault);
        } else {
          setData();
        }
      };

      vm.srchFromTelNoModal = function () {
        var ctrl = 'FromTelNoModalCtrl as vc';
        var paramData = {
          SendInfo: vm.data.FromTelNo,
          Type: vm.data.CmpgnChannel == 'EMAIL' ? 'E' : 'M'
        };

        var modalInstance = modalFactory.open('md', 'app/message/modal/from-tel-no-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.FromTelNo = okData.SendInfo;
        }, function (cancelData) {
        });
      };

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      vm.deleteData = deleteData;

      vm.innerTextArea = innerTextArea;

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:sms-auto-list-tenant
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the sms자동발송
   */
  webapp.controller('SmsAutoListTenantCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsAutoListTenantCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'SmsSituationAutoTenant.getSmsSituationAutoListTenantCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SmsSituationAutoTenant.getSmsSituationAutoListTenant';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-auto-list-tenant';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-auto-list-tenant.edit';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.sms-auto-list-tenant.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-auto-edit-tenant';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.sms-auto-edit-tenant';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.smssituationautotenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      $scope.selectedRow = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);

          if (vm.srch.Contents) {
            var str = '';
            if (vm.SearchConditionStr) {
              str = vm.SearchConditionStr + ',';
            }
            
            vm.SearchConditionStr = str + $translate.instant(vm.columnMap['SendTitle'].ColumnLogicalNm) + '/' + $translate.instant(vm.columnMap['SendMessage'].ColumnLogicalNm) + ":" + vm.srch.Contents;
          }
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == "N") return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      function sortClass(sortkey) {
        if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

        var rtnval = "";

        if (vm.srch.sortDirect == "ASC") {
          rtnval = "fa fa-caret-down";
        } else {
          rtnval = "fa fa-caret-up";
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.sortClass = sortClass;      

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();
    }]);
})();

(function () {
  "use strict";
  webapp.controller('SmsSendEditCtrl',
    ['$scope', '$state', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', 'modalFactory', 'gConfirm', '$window', 'StaticVariable', '$rootScope', '$timeout',
      function SmsSendEditCtrl($scope, $state, $stateParams, autoView, postApi, CONSTANT, gAlert, modalFactory, gConfirm, $window, StaticVariable, $rootScope, $timeout) {

        //#region 변수 선언
        var vm = this;
        var editCnt = 0;
        var oEditors = [];
        vm.data = {};
        vm.messageMaxLength = '90';
        vm.bytes = '0';
        //#endregion 변수선언

        //#region 함수 선언
        vm.setData = setData;
        vm.setTestData = setTestData;                         // 테스트발송
        vm.setChangeCmpgnImpChannel = setChangeCmpgnImpChannel;     // 발송채널 Callback
        vm.resetCmpgnCustomerList = resetCmpgnCustomerList;   // 대상고객 초기화
        vm.resetAll = resetAll;                               // 전체초기화
        vm.showPreView = showPreView;                         // 미리보기 
        vm.setCustAll = setCustAll;                           // 전체고객투입
        vm.chkSmsByte = chkSmsByte;                           // SMS Byte 체크
        vm.innerTextArea = innerTextArea;                     // textarea 삽입
        vm.dataloader = true;
        vm.lmsYN = 'N';
        vm.deleteModalData = deleteModalData;
        //#endregion  함수 선언

        //#region 코드 설정
        // 발송채널
        vm.codeChannel = [
          {Code : 'SMS', CodeValue : 'SMS(단문)'},
          {Code : 'LMS', CodeValue : 'LMS(장문)'},
          {Code : 'MMS', CodeValue : 'MMS(이미지)'},
          /* {Code : 'KAKAO', CodeValue : '알림톡'}, */
          {Code : 'EMAIL', CodeValue : '이메일'},
        ];

        // 담당자 목록
        postApi.select({ mapCode: 'ScUser.getUserListCodes' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeManager = result.body.docs;
            }
          });
        //#endregion 코드 설정

        //#region getgetSendVerifySimpleList 발송번호/이메일 목록
        /**
        *  발송번호/이메일 목록
        * 
        * @param type -> M : 휴대폰번호 E : 이메일
        * @return
        * @author 이기훈
        */
         function getgetSendVerifySimpleList(type) {
          
          postApi.select({ mapCode: 'SendVerify.getSendVerifySimpleList', Type : type },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.codeSendNumber = result.body.docs;
                vm.data.FromInfo = result.body.docs[0].Code;
              }
            }
          );
        }
        //#endregion getgetSendVerifySimpleList 발송번호/이메일 목록

        //#region Auto View Option 설정
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,
          tableNm: "campaignimpl",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {
            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "CampaignImpl.getCareCampaignImplDetail", param: { keyId: $stateParams.keyId, uploadFileList : [], IdName : 'keyId'} },
          },
          /* 목록페이지 */

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
            StartDate: "vc.data.SendType == '20'",
            SendMessage: "vc.data.CmpgnImpChannel != 'EMAIL'"
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            TargetCnt: true,
            CmpgnImpChannel : "vc.data.keyId != null && vc.data.keyId != ''",
            SendType : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
            FromInfo : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
            ManagerId : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
            SendTitle : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
            ServPoint : true
          },

          // MataColum 외 추가 적으로 넣어야할 폼
          addForm: {
          },

          // vc의 ng -click 
          ngClick: {
            Form: "FormModal"
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
            CmpgnImpChannel: "setChangeCmpgnImpChannel"
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          // 달력 시간 옵션
          timeOption: {
            StartDate: {
              minuteStep: 30, initActiveCalendar: true
            }
          },

          autocomplete: {
          },
          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["ChartNoAutoYN"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            ManagerId: "codeManager",
            FromInfo: "codeSendNumber",
            CmpgnImpChannel : "codeChannel"
          },

          // textArea 사이즈 옵션
          textAreaOption: {
            SendMessage: { rows: 12 }
          },

          // 필수 항목 컬럼 
          required: []

        };
        //#endregion Auto View Option 설정

        //#region vm.initEditor 네이버Eidtor init 
        vm.initEditor = function () {
          if (editCnt == 0) {
            var sLang = "ko_KR"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR

            // 추가 글꼴 목록
            //var aAdditionalFontSet = [["MS UI Gothic", "MS UI Gothic"], ["Comic Sans MS", "Comic Sans MS"],["TEST","TEST"]];
            nhn.husky.EZCreator.createInIFrame({
              oAppRef: oEditors,
              elPlaceHolder: "strHtml",
              sSkinURI: "assets/app/SE2.9/SmartEditor2Skin.html",
              htParams: {
                bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)
                bUseVerticalResizer: true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)
                bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)
                //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)
                //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록
                fOnBeforeUnload: function () {
                  //alert("완료!");
                },
                I18N_LOCALE: sLang
              }, //boolean
              fOnAppLoad: function () {
                if (!isNullOrEmpty(vm.data.SendMessage)) {
                  oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.SendMessage]);
                }
                //예제 코드
                //oEditors.getById["strHtml"].exec("PASTE_HTML", []);
              },
              fCreator: "createSEditor2"
            });
            editCnt = editCnt + 1;
          } else {
            oEditors.getById["strHtml"].exec("SET_IR", ['']);
            return;
          }
        };
        //#endregion vm.initEditor 네이버Eidtor init 

        //#region vm.FormModal 서식 목록 모달창
        vm.FormModal = function () {
          var FormType = '';

          if (isNullOrEmpty(vm.data.CmpgnImpChannel)) {
            gAlert('', '발송채널을 먼저 선택해주시기 바랍니다.');
            return;
          }

          if (vm.data.CmpgnImpChannel == 'SMS' || vm.data.CmpgnImpChannel == 'LMS' || vm.data.CmpgnImpChannel == 'MMS') {
            FormType = 'SMS';
          } else if (vm.data.CmpgnImpChannel == 'KAKAO') {
            FormType = vm.data.CmpgnImpChannel;
          } else {
            FormType = 'EMAIL';
          }

          var ctrl = 'FormListModalCtrl as vc';
          var paramData = {
            FormType: FormType
          };

          var modalInstance = modalFactory.open('md', 'app/message/modal/form-list-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            vm.data.FormNm = okData.FormNm;
            vm.data.FormId = okData.KeyId;
            vm.data.SendMessage = okData.Contents;
            if (!isNullOrEmpty(okData.KakaoTemplateKey)) {
              vm.data.KakaoTemplateKey = okData.KakaoTemplateKey;
            }
            chkSmsByte();
          }, function (cancelData) {
          });
        };
        //#endregion vm.FormModal 서식 목록 모달창

        //#region vm.ReceiveNumberModal 직접입력 모달창 호출
        vm.ReceiveNumberModal = function () {
          var ctrl = 'ReceiveNumberModalCtrl as vc';
          var paramData = {
            keyId: $stateParams.keyId
          };

          var modalInstance = modalFactory.open('sm', 'app/message/modal/receive-number-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            getCampaignCustomerList('R');
          }, function (cancelData) {
          });
        };
        //#endregion vm.ReceiveNumberModal 직접입력 모달창 호출

        //#region vm.srchInputModal 조건검색투입 모달창 호출
        vm.srchInputModal = function() {
          var ctrl = 'SrchInputModalCtrl as vc';
          var paramData = {
            keyId: $stateParams.keyId,
            CmpgnImpChannel : vm.data.CmpgnImpChannel
          };

          var modalInstance = modalFactory.open('lg', 'app/message/modal/srch-input-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            getCampaignCustomerList('R');
          }, function (cancelData) {
          });
        };
        //#endregion vm.srchInputModal 조건검색투입 모달창 호출

        //#region vm.campaignCustomerModal 투입고객 목록 모달창 호출
        vm.campaignCustomerModal = function(type) {
          var title = '';
          var errYN = '';
          if (type == 'A') {
            title = '투입';
            errYN = '';
          } else if (type == 'T') {
            title = '대상';
            errYN = 'N';
          } else if (type == 'E') {
            title = '제외';
            errYN = 'Y';
          }

          var ctrl = 'CampaignCustomerModalCtrl as vc';
          var paramData = {
            keyId: $stateParams.keyId,
            errYN : errYN,
            CmpgnImpChannel : vm.data.CmpgnImpChannel,
            title : title
          };

          var modalInstance = modalFactory.open('md', 'app/message/modal/campaign-customer-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
          }, function (cancelData) {
            getCampaignCustomerList('R');
          });
        };
        //#endregion vm.campaignCustomerModal 투입고객 목록 모달창 호출

        //#region vm.setChangeTab 안내이미지 변경
        vm.setChangeTab = function (_id) {
          vm.tabId = _id;
          $('.tab-pane.active').addClass('fade').removeClass('active');
          $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
        };
        //#endregion vm.setChangeTab 안내이미지 변경

        //#region 업로드 파일 목록
        vm.uploadFileList = [];
        vm.showUploader = false;
        //#endregion 업로드 파일 목록

        //#region 첨부파일 Callback
        vm.onFileCallback = {
          onFileUploaded: function (id, result) {
            // 첨부파일 업로드 완료
            $scope.$apply(function () {
              angular.forEach(result.body.docs, function (item) {
                var obj = item;
                obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
                vm.uploadFileList.push(obj);
              });
            });
          },
          onFileUploadComplete: function (id) {
            // 첨부파일 업로드 이후 저장을 호출해야 함
            if (id == 'vault') {
              $timeout(setData, 1);
            }
          },
          onFileDelete: function (item) {
            var param = {
              fileId: item.id
            };

            var prms = h0102Api.attachFileDelete().post(param).$promise;
            prms.then(function (data) {
              if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            });
          },
          onLoaded: function (id, vault) {
            vm[id] = vault;
          }
        };

        vm.uploadFile = function (type) {
          vm.type = type;
          if (vm.vault != null && vm.vault.data.getLength() > 0) {
            uploadVaultFile(vm.vault);
          } else {
            setData();
          }
        };
        //#endregion 첨부파일 Callback

        //#region getBranchDetail 지점정보 조회
        /**
          * 지점정보 조회
          *
          * @param
          * @return
        */
        function getBranchDetail() {
          var data = { mapCode: 'organizationMng.getBranchDetail' };

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.branchData = result.body.docs[0];
                vm.branchData.TenantNm = $window.sessionStorage['loginTenantName'];
                vm.branchData.loginMobile = $window.sessionStorage['loginMobile'];
                vm.data.ServPoint = vm.branchData.ServPoint;
                vm.branchData.loginMobile = autoHypenTel(vm.branchData.loginMobile);
                vm.branchData.TelNo = autoHypenTel(vm.branchData.TelNo);
                vm.addADTxt = '(광고) 무료수신거부 ' + autoHypenTel(vm.branchData.TelNo);
              } else {
                vm.branchData = {};
              }
            }
          });
        }
        //#endregion getBranchDetail 지점정보 조회


        //#region SmsPreviewModal SMS 미리보기 모달
        /**
          * SMS 미리보기 모달
          *
          * @param
          * @return
        */
        function SmsPreviewModal() {
          if (vm.data.CmpgnImpChannel == 'EMAIL') {
            vm.data.SendMessage = $('#strHtml').val();
          }

          var ctrl = 'SmsPreviewModalCtrl as vc';
          var paramData = {
            SendTitle: vm.data.SendTitle,
            SendMessage: vm.data.SendMessage
          };

          var modalInstance = modalFactory.open('sm', 'app/message/modal/sms-preview-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {

          }, function (cancelData) {
          });
        }
        //#endregion 함수 구현

        //#region EmailPreviewModal Email 미리보기 모달
        /**
         *  Email 미리보기 모달창 호출
         *
         * @param
         * @return
        */
        function EmailPreviewModal() {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

          var ctrl = 'ContentsModalCtrl as modalCtrl';
          var paramData = {
            Title: 'Email 미리보기',
            Contents: $('#strHtml').val(),
            AgreeYN : vm.data.AgreeYN,
            TelNo : vm.branchData.TelNo
          };

          var modalInstance = modalFactory.open("lg", "components/modal/contents/contents-modal.html", ctrl, paramData);
          modalInstance.result.then(function (okData) {
          }, function (cancelData) {
          });
        }
        //#endregion EmailPreviewModal Email 미리보기 모달

        //#region onReadyAutoView 초기 설정
        /**
         *  초기 설정
         * 
         * @param
         * @return
         */
        function onReadyAutoView() {
          vm.tabId = 'tab1';
          vm.dataloader = false;

          if (!vm.data.keyId) {
            vm.data.CmpgnImpChannel = "SMS";
            vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
            vm.data.SendType = "10";
            vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];

            var checkReloadSms = $window.sessionStorage.getItem("scheduleToSms");

            // 시큐어코딩으로 주석 후 수정 (2023-07-06 )
            // if (eval(checkReloadSms)) {
            if (checkReloadSms === "true") {
              $window.sessionStorage.setItem("scheduleToSms", false);
              getCampaignCustomerList('R');
            } else {
              getCampaignCustomerList('F');
            }
          } else {
            vm.data.FromInfoOrg = angular.copy(vm.data.FromInfo);
            vm.data.SendTitleOrg = angular.copy(vm.data.SendTitle);
            vm.data.SendMessageOrg = angular.copy(vm.data.SendMessage);
            vm.data.AgreeYNOrg = angular.copy(vm.data.AgreeYN);
            vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
            if (vm.data.CmpgnImpChannel == 'LMS') {
              vm.lmsYN = 'Y';
            }
            getCampaignCustomerList('R');
          }

          vm.layout = $state.current.name.indexOf('sms-send-list') == -1 && $state.current.name.indexOf('campaign-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard;

          getgetSendVerifySimpleList('M');
          getBranchDetail();          
          chkSmsByte();

          var uploadFileList = [];

          angular.forEach(vm.data.uploadFileList, function(item) {
            var obj = {
              id : item.fileId,
              isLoaded : true,
              link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
              fileName : item.LogicalFileNm,
              size : item.FileSize,
              fileKey : item.PhysicalFileNm,
              path : item.PhysicalPath,
              downloadCnt : item.DownloadCnt,
            };
            uploadFileList.push(obj);
          });

          angular.copy(uploadFileList, vm.uploadFileList);
        }
        //#endregion onReadyAutoView 초기 설정

        //#region showPreView 미리보기 호출
        /**
         *  미리보기 호출
         * 
         * @param
         * @return
         */
        function showPreView() {
          if (isNullOrEmpty(vm.data.CmpgnImpChannel)) {
            gAlert('', '발송채널을 선택해주시기 바랍니다.');
            return;
          } else {
            if (vm.data.CmpgnImpChannel == 'EMAIL') {
              EmailPreviewModal();
            } else {
              SmsPreviewModal();
            }
          }
        }
        //#endregion showPreView 미리보기 호출

        //#region  getCampaignCustomerList 투입/대상/제외 고객수 조회
        /**
         * 투입/대상/제외 고객수 조회
         * 
         * @param type F : 처음 화면 호출 시, R : 목록 재호출 시
         * @return
         */
        function getCampaignCustomerList(type) {
          var data = {};
          data.mapCode = 'CampaignImpl.getCareCampaignImplCustomerCnt';

          if (!isNullOrEmpty($stateParams.keyId)) {
            data.keyId = $stateParams.keyId;
          }

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.data.EnterCnt = result.body.docs[0].EnterCnt;
                vm.data.TargetCnt = result.body.docs[0].TargetCnt;
                vm.data.ExceptCnt = result.body.docs[0].ExceptCnt;

                if (type == 'F') {
                  if (vm.data.EnterCnt > 0) {
                    gConfirm('', '이전에 투입된 고객 데이터가 있습니다. 초기화하시겠습니까?', {
                      btn: '',
                      fn: function () {
                        deleteCmpgnCustomerAction('', '', 'C');
                      }
                    }, {
                      btn: '',
                      fn: function () {

                      }
                    });
                  }
                }
              }
            }
          });
        }
        //#endregion getCampaignCustomerList 투입/대상/제외 고객수 조회

        //#region setChangeCmpgnImpChannel 발송채널 Callback
        /**
         * 발송채널 Callback
         * 
         * @param
         * @return
         */
        function setChangeCmpgnImpChannel() {
          if (vm.data.CmpgnImpChannel != 'EMAIL') {
            if (vm.data.CmpgnImpChannelBefore == 'EMAIL') {
              if (isNullOrEmpty(vm.data.FromInfoOrg)) {
                vm.data.FromInfo = '';
              }
              if (isNullOrEmpty(vm.data.AgreeYNOrg)) {
                vm.data.AgreeYN = '';
              }

              getgetSendVerifySimpleList('M');

              if (vm.data.EnterCnt > 0) {
                deleteCmpgnCustomerAction('', '', 'C');
              }
            }
            

            if (vm.data.CmpgnImpChannel == 'SMS') {
              vm.showUploader = false;
              if (vm.bytes > 90) {
                gAlert('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.');
                vm.data.CmpgnImpChannel = 'LMS';
                return;
              }
              vm.messageMaxLength = '90';
            } else if (vm.data.CmpgnImpChannel == 'LMS') {
              if (vm.bytes == 0) {
                vm.data.CmpgnImpChannel = 'SMS';
                return;
              }
              vm.messageMaxLength = '2000';
            } else if (vm.data.CmpgnImpChannel == 'MMS') {
              vm.messageMaxLength = '2000';
              if (vm.data.CmpgnImpChannel == 'MMS') {
                if (vm.data.keyId != null && vm.data.Status != 'TEMP' && vm.data.Status != 'STANDBY') {
                  vm.showUploader = false;
                } else {
                  vm.showUploader = true;
                  initVaultComponentForMMSImg('vault', vm.onFileCallback);
                }
              } else {
                vm.showUploader = false;
              }
            } else if (vm.data.CmpgnImpChannel == 'KAKAO') {
              gAlert('알림톡은 직접 입력이 불가하며 사전에 승인된 알림톡 서식으로만 사용가능합니다. 알림톡 서식을 선택하여 사용해주시기 바랍니다.');
              vm.data.SendMessage = '';
              vm.showUploader = false;
            }
          } else if (vm.data.CmpgnImpChannel == 'EMAIL') {
            if (isNullOrEmpty(vm.data.FromInfoOrg)) {
              vm.data.FromInfo = '';
            }
            if (isNullOrEmpty(vm.data.AgreeYNOrg)) {
              vm.data.AgreeYN = '';
            }

            getgetSendVerifySimpleList('E');
            
            vm.initEditor();
            vm.showUploader = false;
            if (vm.data.EnterCnt > 0) {
              deleteCmpgnCustomerAction('', '', 'C');
            }
          }

          vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
        }
        //#endregion setChangeCmpgnImpChannel 발송채널 Callback

        //#region deleteCmpgnCustomerAction 대상고객 삭제 액션
        /**
         * 발송채널 Callback
         * 
         * @param {*} msgSuccess => 성공메시지
         * @param {*} msgFail => 실패메시지
         * @param {*} type => 'A' 전체초기화 / 'C' 대상고객초기화
         * @return
         */
        function deleteCmpgnCustomerAction(msgSuccess, msgFail, type) {
          var data = { keyId: $stateParams.keyId, mapCode: 'CampaignImpl.deleteCareCampaignImplCustomer' };

          postApi.update(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (!isNullOrEmpty(msgSuccess)) {
                gAlert('', msgSuccess);
              }

              getCampaignCustomerList('R');

              if (type == 'A') {
                resetData();
              }
            } else {
              if (!isNullOrEmpty(msgFail)) {
                gAlert('', msgFail);
              }
              return;
            }
          });
        }

        //#region resetCmpgnCustomerList 대상고객초기화
        /**
         * 대상고객초기화
         * 
         * @param
         * @return
         */
        function resetCmpgnCustomerList() {
          gConfirm('', '초기화 하시겠습니까?', {
            btn: '',
            fn: function () {
              if (vm.data.EnterCnt > 0) {
                deleteCmpgnCustomerAction('초기화 되었습니다.', '초기화 되지 않았습니다.', 'C');
              } else {
                gAlert('', '초기화할 대상고객이 없습니다.');
              }
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        }
        //#endregion resetCmpgnCustomerList 대상고객초기화

        //#region resetAll 전체 초기화
        /**
         * 전체 초기화
         * 
         * @param
         * @return
         */
        function resetAll() {
          gConfirm('', '전체 초기화 하시겠습니까?', {
            btn: '',
            fn: function () {
              if (vm.data.EnterCnt > 0) {
                deleteCmpgnCustomerAction('초기화 되었습니다.', '초기화 되지 않았습니다.', 'A');
              } else {
                gAlert('', '초기화 되었습니다.', {
                  btn: '',
                  fn: function () {
                    resetData();
                  }
                });
              }
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        }
        //#endregion resetAll 전체 초기화

        //#region resetData vm.data 초기화
        /**
         * vm.data 초기화
         * 
         * @param
         * @return
         */
        function resetData() {
          vm.data = {
            CmpgnImpChannel: "SMS",
            SendType: "10"
          };

          vm.bytes = 0;

          if (!isNullOrEmpty($stateParams.keyId)) {
            vm.data.keyId = $stateParams.keyId;
          }
        }
        //#endregion resetData vm.data 초기화

        function getIsValidData(data) {
          var errMsg = '';

          if (data.type == 'S' && data.TargetCnt == '0') {
            errMsg = errMsg + '- 대상고객수를 확인해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.FromInfo)) {
            errMsg = errMsg + '- 발송번호를 선택해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.ManagerId)) {
            errMsg = errMsg + '- 담당자를 선택해주시기 바랍니다.<br>';
          }
          if (data.CmpgnImpChannel != 'SMS' && isNullOrEmpty(data.SendTitle)) {
            errMsg = errMsg + '- 제목을 입력해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.SendMessage)) {
            errMsg = errMsg + '- 발송메시지를 입력해주시기 바랍니다.';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            return false;
          } else {
            return true;
          }
        }

        //#region setData 발송
        /**
         * 발송
         * 
         * @param
         * @return
         */
        function setData() {
          var successMsg = '';
          var failMsg = '';

          if (vm.type == 'T') {
            successMsg = '임시저장 되었습니다.';
            failMsg = '임시저장 되지 않았습니다.';
          } else {
            successMsg = '발송되었습니다.';
            failMsg = '발송되지 않았습니다.';

            if (!chkServPoint('S')) {
              return false;
            }
          }

          var data = angular.copy(vm.data);
          data.uploadFileList = vm.uploadFileList;
          data.type = vm.type;
          data.tableNm = 'campaignimpl';
          data.TelNo = vm.branchData.TelNo;
          data.IdName = 'keyId';

          if (!isNullOrEmpty(vm.unitPriceTotal)) {
            data.UnitPriceTotal = vm.unitPriceTotal;
          }

          if (!isNullOrEmpty(data.StartDate)) {
            data.StartDate = moment.utc(data.StartDate).format('YYYY-MM-DD HH:mm');
          }

          if (!isNullOrEmpty(data.keyId)) {
            data.mapCode = 'CampaignImpl.updateCareCampaignImpl';
          } else {
            data.mapCode = 'CampaignImpl.insertCareCampaignImpl';
          }

          if (data.CmpgnImpChannel == 'EMAIL') {
            oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
            data.SendMessage = $('#strHtml').val();
          }

          if (getIsValidData(data)) {
            postApi.insert(data, function (result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
                  vm.keyId = result.body.docs[0].RelateDataId;
                } else {
                  vm.keyId = result.body.docs[0].keyId;
                }

                gAlert('', successMsg, {
                  btn: '',
                  fn: function () {
                    if (vm.type == 'S') {
                      $state.go('app.message.sms-send-edit', { srch: '', keyId: '' }, { reload: 'app.message.sms-send-edit' });
                    } else {
                      $state.go('app.message.sms-send-edit', { srch: '', keyId: vm.keyId }, { reload: 'app.message.sms-send-edit' });
                    }
                  }
                });
              } else {
                gAlert('', failMsg);
                return;
              }
            });
          }
        }
        //#endregion setData 발송

        function chkServPoint(type) {
          vm.data.UnitPrice = 0;
          vm.unitPriceTotal = 0;
          var servPointTotal = 0;          
          var message = '';

          if (isNullOrEmpty(vm.data.ServPoint)) {
            gAlert('', '남은 잔여포인트가 없습니다.');
            return false;
          }

          if (vm.data.CmpgnImpChannel == 'SMS') {
            if (isNullOrEmpty(vm.branchData.CostSMS)) {
              gAlert('', '정해진 SMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
              return false;
            } else {
              vm.data.UnitPrice = vm.branchData.CostSMS;
            }
          } else if (vm.data.CmpgnImpChannel == 'LMS') {
            if (isNullOrEmpty(vm.branchData.CostLMS)) {
              gAlert('', '정해진 LMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
              return false;
            } else {
              vm.data.UnitPrice = vm.branchData.CostLMS;
            }
          } else if (vm.data.CmpgnImpChannel == 'MMS') {
            if (isNullOrEmpty(vm.branchData.CostMMS)) {
              gAlert('', '정해진 MMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
              return false;
            } else {
              vm.data.UnitPrice = vm.branchData.CostMMS;
            }
          } else if (vm.data.CmpgnImpChannel == 'KAKAO') {
            if (isNullOrEmpty(vm.branchData.CostKAKAO)) {
              gAlert('', '정해진 KAKAO단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
              return false;
            } else {
              vm.data.UnitPrice = vm.branchData.CostKAKAO;
            }
          } else if (vm.data.CmpgnImpChannel == 'EMAIL') {
            if (isNullOrEmpty(vm.branchData.CostEMAIL)) {
              gAlert('', '정해진 EMAIL단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
              return false;
            } else {
              vm.data.UnitPrice = vm.branchData.CostEMAIL;
            }
          }

          if (type == 'S') {
            vm.unitPriceTotal = Number(vm.data.TargetCnt) * Number( vm.data.UnitPrice);  
          } else {
            vm.unitPriceTotal = Number( vm.data.UnitPrice);
          }

          servPointTotal = Number(vm.data.ServPoint) - vm.unitPriceTotal; 

          if (servPointTotal <= 0) {
            message = '발송 가능 포인트를 초과합니다.<br>' + '남은 발송가능 포인트는' + vm.data.ServPoint + '원 입니다.';
            gAlert('', message);
            return false;
          }

          return true;

        }

        //#region setTestData 테스트 발송 
        /**
         * 테스트 발송 
         * 
         * @param
         * @return
         */
        function setTestData() {
          var errMsg = '';
          var chkData = { mapCode: 'CampaignImpl.getCareCampaignImplCustomerTestChk' };
          var data = angular.copy(vm.data);
          if (data.CmpgnImpChannel == 'EMAIL') {
            oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
            data.SendMessage = $('#strHtml').val();
          }

          if (isNullOrEmpty(data.FromInfo)) {
            errMsg = errMsg + '- 발송번호를 선택해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.ManagerId)) {
            errMsg = errMsg + '- 담당자를 선택해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.SendTitle)) {
            errMsg = errMsg + '- 제목을 입력해주시기 바랍니다.<br>';
          }
          if (isNullOrEmpty(data.SendMessage)) {
            errMsg = errMsg + '- 발송메시지를 입력해주시기 바랍니다.';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            return;
          } else {
            postApi.select(chkData, function (result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {

                  if (data.CmpgnImpChannel == 'EMAIL') {
                    if (result.body.docs[0].EmailErrYN == 'N') {
                      setTestDataAction(data);
                    } else {
                      gAlert('', '내정보 - Email 확인바랍니다.');
                      return;
                    }
                  }
                  if (data.CmpgnImpChannel != 'EMAIL') {
                    if (result.body.docs[0].MobileErrYN == 'N') {
                      setTestDataAction(data);
                    } else {
                      gAlert('', '내정보 - 휴대폰번호 확인바랍니다.');
                      return;
                    }
                  }
                }
              }
            });
          }
        }
        //#endregion setTestData 테스트 발송 

        //#region setTestDataAction 테스트발송 액션
        /**
         * 테스트발송 액션
         * 
         * @param
         * @return
         */
        function setTestDataAction(data) {
          data.mapCode = 'CampaignImpl.insertCareCampaignImplCustomerTest';
          chkServPoint('T');

          if (!isNullOrEmpty(vm.unitPriceTotal)) {
            data.UnitPriceTotal = vm.unitPriceTotal;
          }

          data.TelNo = vm.branchData.TelNo;

          postApi.insert(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', '테스트 발송하였습니다.', {
                btn : '',
                fn : function() {
                  getBranchDetail();
                }
              });
            } else {
              gAlert('', '테스트 발송에 실패하였습니다.');
            }
          });
        }
        //#endregion setTestDataAction 테스트발송 액션


        //#region setCustAll 전체고객투입
        /**
         * 전체고객투입
         * 
         * @param
         * @return
         */
        function setCustAll() {
          gConfirm('', '기존에 투입한 고객들이 초기화 되며,<br> 대상고객 수에 따라 수분 이상 소요될 수 있습니다. 계속 진행하시겠습니까?', {
            btn: '',
            fn: function () {
              setCustAllAction();
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        }
        //#endregion setCustAll 전체고객투입

        function setCustAllAction() {
          var data = { keyId: $stateParams.keyId, CmpgnImpChannel: vm.data.CmpgnImpChannel, EnterCnt : vm.data.EnterCnt, mapCode: 'CampaignImpl.insertCareCampaignImplCustomerAll' };

          postApi.insert(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('전체 고객 투입이 되었습니다.');
              getCampaignCustomerList('R');
            }
          });
        }

        //#region chkSmsByte SMS Byte 체크
        /**
         * SMS Byte 체크
         * 
         * @param
         * @return
         */
        function chkSmsByte() {
          var msg = "";

          if (!isNullOrEmpty(vm.data.SendMessage)) {
            msg = vm.data.SendMessage;
            vm.bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
            
            if (vm.data.CmpgnImpChannel == 'SMS' && vm.bytes > 90) {
              gAlert('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.', {
                btn: '',
                fn: function () {
                  vm.data.CmpgnImpChannel = 'LMS';
                  vm.messageMaxLength = '2000';
                  vm.lmsYN = 'Y';
                }
              });
            }

            if ((vm.data.CmpgnImpChannel == 'LMS' || vm.data.CmpgnImpChannel == 'MMS') && vm.bytes > 1999) {
              gAlert('', '메세지는 최대 2000 bytes까지 가능합니다.', {
                btn: '',
                fn: function () {
                  vm.data.SendMessage = fnCutMsg(msg, 1999);
                }
              });
            }

            if (vm.lmsYN == 'Y' && vm.bytes < 91) {
              vm.data.CmpgnImpChannel = 'SMS';
              vm.messageMaxLength = '90';
            }

          } else {
            vm.bytes = 0;
            vm.addADTxtYN = 'N';
            if (vm.lmsYN == 'Y') {
              vm.data.CmpgnImpChannel = 'SMS';
              vm.messageMaxLength = '90';
            }
          }
        }
        //#endregion chkSmsByte SMS Byte 체크

        //#region chkADTxt 광고문구 추가
        /**
          * 광고문구 추가
          * @param areaId - textArea Id값
          * @return
          */
        vm.chkADTxt = function (areaId) {
          var txtarea = document.getElementById(areaId);

          if (vm.addADTxtYN == 'Y') {
            if (!isNullOrEmpty(vm.data.SendMessage)) {
              txtarea.value = vm.addADTxt + vm.data.SendMessage;
            } else {
              txtarea.value = vm.addADTxt;
            }
            
            vm.data.SendMessage = txtarea.value;
          } else {
            vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
            txtarea.value =  vm.data.SendMessage;
          }

          vm.chkSmsByte();
        };
        //#endregion chkADTxt 광고문구 추가

        //#region fnCutMsg 메세지 글 자르기
        /**
          * 메세지 글 자르기
          * @param str - 메시지
          * @param length - Max 길이
          * @return
          */
        function fnCutMsg(str, length) {
          var ret = '';
          var i;
          var msglen = 0;

          for (i = 0; i < str.length; i++) {
            var ch = str.charAt(i);

            if (escape(ch).length > 4) {
              msglen += 2;
            } else {
              msglen++;
            }
            if (msglen > length) break;
            ret += ch;
          }
          return ret;
        }
        //#endregion fnCutMsg 메세지 글 자르기

        //#region innerTextArea 현재 커서 위치에 텍스트 대체하기
        /**
          * 현재 커서 위치에 텍스트 대체하기
          * @param areaId - textArea Id 값
          * @param type - type
          * @return
          */
        function innerTextArea(areaId, type) {
          var text = '';
          if (type == 'C') {
            text = '{CustNm}';
          } else if (type == 'T') {
            text = vm.branchData.TenantNm;
          } else if (type == 'B') {
            text = vm.branchData.GroupNm;
          } else if (type == 'M') {
            text = vm.branchData.loginMobile;
          } else if (type == 'A' && !isNullOrEmpty(vm.branchData.ZipCode)) {
            text = '(우)' + vm.branchData.ZipCode + ' ' + vm.branchData.Addr1;
            if (!isNullOrEmpty(vm.branchData.Addr2)) {
              text = text + ' ' + vm.branchData.Addr2;
            }
          } else if (type == 'BA' && !isNullOrEmpty(vm.branchData.Bank) && !isNullOrEmpty(vm.branchData.AccountNum)) {
            text = '[' + vm.branchData.Bank + '] ' + vm.branchData.AccountNum;
          }

          var txtarea = document.getElementById(areaId);
          var scrollPos = txtarea.scrollTop;
          var strPos = 0;
          var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
            "ff" : (document.selection ? "ie" : false));
          if (br == "ie") {
            txtarea.focus();
            var range = document.selection.createRange();
            range.moveStart('character', -txtarea.value.length);
            strPos = range.text.length;
          }
          else if (br == "ff") strPos = txtarea.selectionStart;

          var front = (txtarea.value).substring(0, strPos);
          var back = (txtarea.value).substring(strPos, txtarea.value.length);
          txtarea.value = front + text + back;
          vm.data.SendMessage = txtarea.value;
          strPos = strPos + text.length;
          if (br == "ie") {
            txtarea.focus();
            var range = document.selection.createRange();
            range.moveStart('character', -txtarea.value.length);
            range.moveStart('character', strPos);
            range.moveEnd('character', 0);
            range.select();
          }
          else if (br == "ff") {
            txtarea.selectionStart = strPos;
            txtarea.selectionEnd = strPos;
            txtarea.focus();
          }
          txtarea.scrollTop = scrollPos;

          var tcount = 0;
          if (text == "{CLICKURL}") {
            alert('장문으로 전환됩니다.');

            $("#ContentPage_FLD_SENDCLSS").val("20");
            fnChgSendClss();

            $("#ContentPage_lblByte").html(tcount + " / 2000 bytes");
          }

          chkSmsByte();
        }
        //#endregion innerTextArea 현재 커서 위치에 텍스트 대체하기

        //#region 서식 삭제
        /**
          * 서식명 및 발송메시지 삭제
          * @param type - type
          * @return
          */
        function deleteModalData(type) {
          if (type == 'Form') {
            vm.data.FormNm = '';
            vm.data.SendMessage = '';
            chkSmsByte();
          }
        }
        //#endregion 서식 삭제

        //#region Auto View init Callback
        vm.onReadyAutoView = onReadyAutoView;
        //#endregion Auto View init Callback

        //#region Auto View init
        var av = new autoView();
        av.init(autoViewOption);
        //#endregion Auto View init

      }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberSaveCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'autoView',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, autoView) {
      
      //#region 상수 정의
      var vm = this;
      var KEY_TABLE_NM = 'SendVerify.Mobile'; // 작업 테이블명

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.data = {
        CertType : 'MOBILE',
        tableNm : KEY_TABLE_NM
      };
      //#endregion 상수 정의

      //#region SQL Mapper Id 정의
      var INSERT_SQL = 'SendVerify.insertSendVerify';     // 등록 SQL
      var DELETE_LIST_SQL = 'SendVerify.deleteSendVerify'; // 목록에서 삭제
      //#endregion SQL Mapper Id 정의

      //#region 함수 선언
      vm.setVerifyData = setVerifyData;
      vm.setDelList = setDelList;
      vm.dupChk = dupChk;
      //#endregion 함수 선언

      //#region Auto View Option 설정
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : KEY_TABLE_NM,
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "SendVerify.getSendVerifyListCnt", param : {Type : 'M'} },
          initSelect : { mapCode : "SendVerify.getSendVerifyList", param : {Type : 'M'} },
        },

        // List
        listCheckboxEnable : true,
        
        src : {
        },
        
        addFormGroup : {
        },
  
        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        // listClickCallback : clickevent
        customCodes : {
          Manager : "codeManager"
          , RecommendItem : "codeRecommendItem"
        }

      };
      //#endregion Auto View Option 설정
    
      //#region onReadyAutoView 초기 설정
      /**
        *  초기 설정
        * 
        * @param
        * @return
        * @author 이기훈
        */
      function onReadyAutoView() {
      }
      //#endregion onReadyAutoView 초기 설정

      //#region dupChk 중복체크
      /**
        *  중복체크
        * 
        * @param
        * @return
        * @author 이기훈
        */
      function dupChk() {
        var data = angular.copy(vm.data);
        data.mapCode = 'SendVerify.getSendDuplicateCnt';
  
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs > 0) {
              gAlert('','이미 등록된 번호 입니다.');
              return;
            } else {
              setVerifyData();
            }
          }
        });
      }
      //#endregion dupChk 중복체크
      
      //#region setZero 2자리로 만들기
      /**
        *  2자리로 만들기
        * 
        * @param val -> 날짜 데이터
        * @return
        * @author 이기훈
        */
      function setZero(val){
        return val > 10 ?  '' + val : '0' + val ;
      }
      //#endregion setZero 2자리로 만들기
      
      //#region setMerchantUID 요청ID생성
      /**
        *  요청ID생성
        * 
        * @param 
        * @return
        * @author 이기훈
        */
      function setMerchantUID() {
        // var d = new Date();
        // var rndNum = Math.floor(10 + Math.random() * d.getTime());

        var array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        var d = new Date();
        var scale = d.getTime() - 10;
        var rndNum = Math.floor(array[0] / Math.pow(2, 32) * scale + 10);

        return "CID_" + (d.getFullYear() + "").substring(2, 4) + "" + setZero(d.getMonth() + 1) + "" + setZero(d.getDate()) + "" + setZero(d.getHours()) + "" + setZero(d.getMinutes()) + "_" + rndNum;;
      }
      //#endregion setMerchantUID 요청ID생성
      
      //#region setVerifyData 저장
      /**
        *  저장
        * 
        * @param 
        * @return
        * @author 이기훈
        */
      function setVerifyData() {
        
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendInfo)) {
          errMsg = errMsg + '-발송번호를 입력해 주세요.';
        }
        
        if(vm.data.CertType != 'MOBILE' ){
          if (isNullOrEmpty(vm.uploadFileList)) {
            errMsg = errMsg + '<br/>-첨부파일을 업로드 해주세요.';
          }
        }
        
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        if (vm.data.CertType =='MOBILE') {
          /*
           * 본인인증은 SSCRM용을 사용한다.
           */
          IMP.init("imp86263784"); 
          IMP.certification({ 
            merchant_uid: setMerchantUID()
            ,phone: vm.data.SendInfo         
          }, function (certifyResult) {
            console.table(certifyResult);
            
            if (certifyResult.success) {
              postApi.api('personalCertify', certifyResult, function (result) {
                setPaymentCertify(result);
              }, function (error) {
                console.log("error");
                // console.error("Error : personalCertify");
                // console.table(error);
              });
            } else {
              alert("본인인증에 실패하였습니다.(" + certifyResult.error_msg + ")");
            }
          });
          
        } else {
          var data = angular.copy(vm.data); // 검색 옵션 설정
          data.Type = 'M';
          data.mapCode = INSERT_SQL;
          
          data.uploadFileList = [];
          angular.forEach(vm.uploadFileList, function(item) {
            data.uploadFileList.push(item);
          });
          
          postApi.insert(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if ( result.body.docs[0].RelateDataId !== null ) {
                gAlert("", "Menu.SAVED", {
                  btn: "",
                  fn: function () {
                    vm.data = {
                      CertType : 'MOBILE',
                      tableNm : KEY_TABLE_NM
                    };
                    vm.showUploader = false;
                    vm.uploadFileList = [];
                    av.init(autoViewOption);
                  }
                });
                return;
              }
            }else{
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function (error) {
            console.log("error");
            // console.error("Error : personalCertify");
            // console.table(error);
          });
        }
      }
      //#endregion setVerifyData 저장

      //#region setPaymentCertify 결제 처리후 process
      /**
        *  결제 처리후 process
        * 
        * @param result -> 휴대폰본인인증 프로세스 진행 후 결과값
        * @return
        * @author 이기훈
        */
      function setPaymentCertify(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if ( result.body.docs[0].status ) {
            gAlert("발신번호가 인증되었습니다.");
            vm.data.SendInfo = '';
            av.init(autoViewOption);
          }else{
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              gAlert("발신번호가 중복되었습니다.");
            }else{
              gAlert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            return false;
          }
        }
      }
      //#endregion setPaymentCertify 목록 삭제 확인

      //#region setDelList 목록 삭제 확인
      /**
        *  목록 삭제 확인
        * 
        * @param
        * @return
        * @author 이기훈
        */
       function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }
      //#endregion setDelList 목록 삭제 확인

      //#region setDelListAction 목록 삭제
      /**
        *  목록 삭제
        * 
        * @param
        * @return
        * @author 이기훈
        */
      function setDelListAction() {
        var data = {};
        data.mapCode = DELETE_LIST_SQL;
        data.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            data.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (data.KeyIdList == null || data.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                av.init(autoViewOption);
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }
      //#endregion setDelListAction 목록 삭제
      
      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
 
      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      // 유형관리
      .state('app.system.itemtype-list', {
        url: '/itemtype-list',
        templateUrl: 'app/scsystem/itemtype/itemtype-list-view.html',
        requiresAuthentication: true,
      })

      .state('app.system.penchart-mng-list', {
        url: '/penchart-mng-list',
        templateUrl: 'app/scsystem/penchart-mng/penchart-mng-list.html',
        requiresAuthentication: true,
      });
   }
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.sysinfo', {
      url : '/sysinfo',
      template : '<div ui-view></div>',
    })

    .state('app.sysinfo.organization', {
      url: '/organization-list',
      templateUrl: 'app/system/organization/organization-list-view.html',
    })

    // 사용자관리
    .state('app.sysinfo.user-list', {
      url: '/user-list/:srch',
      templateUrl: 'app/system/user/user-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.sysinfo.user-detail', {
      url: '/user-detail/:srch/:keyId',
      templateUrl: 'app/system/user/user-detail.html',
      requiresAuthentication: true,
    }).state('app.sysinfo.user-edit', {
      url: '/user-edit/:srch/:keyId',
      templateUrl: 'app/system/user/user-edit.html',
    }).state('app.sysinfo.user-edit.tab1', {
      url: '/user-edit/:srch/:keyId/tab1',
      templateUrl: 'app/system/user/user-edit-tab1.html',
    }).state('app.sysinfo.user-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/system/user/user-detail.html',
      requiresAuthentication: true,
    }).state('app.sysinfo.user-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/user/user-edit.html',
    }).state('app.sysinfo.user-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/system/user/user-edit-tab1.html',
    }).state('app.sysinfo.user-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/system/user/user-edit-tab2.html',
    }).state('app.sysinfo.user-list.edit.tab3', {
      url: '/tab3',
      templateUrl: 'app/system/user/user-edit-tab3.html',
    })

    // 가입경로회원사목록
    .state('app.sysinfo.recommender-list', {
      url: '/recommender-list/:srch',
      templateUrl: 'app/system/company/recommender-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.sysinfo.recommender-detail', {
      url: '/recommender-detail/:srch/:keyId',
      templateUrl: 'app/system/company/recommender-detail.html',
      requiresAuthentication: true,
    }).state('app.sysinfo.recommender-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/system/company/recommender-detail.html',
      requiresAuthentication: true,
    })

    .state('app.sysinfo.role-list', {
      url: '/role-list/:srch',
      templateUrl: 'app/system/role/role-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    })

    // 유형관리
    .state('app.sysinfo.itemtype-list', {
      url: '/itemtype-list',
      templateUrl: 'app/scsystem/itemtype/itemtype-list-view.html',
      requiresAuthentication: true,
    })

    .state('app.sysinfo.penchart-mng-list', {
      url: '/penchart-mng-list',
      templateUrl: 'app/scsystem/penchart-mng/penchart-mng-list.html',
      requiresAuthentication: true,
    })

    .state('app.sysinfo.additional-service-list', {
      url: '/additional-service-list/:srch',
      templateUrl: 'app/scsystem/additional-service/additional-service-list.html',
      requiresAuthentication: true,
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    })

    // 영업차량관리
    .state('app.sysinfo.rental-car-list', {
      url: '/rental-car-list/:srch',
      templateUrl: 'app/system/rental-car/rental-car-list.html',
    })
    // 지원사업
    .state('app.sysinfo.support-business-list', {
      url: '/support-business-list/:srch',
      templateUrl: 'app/system/support-business/support-business-list.html',
    })
    // 사업관리
    .state('app.sysinfo.business-management-list', {
      url: '/business-management-list/:srch',
      templateUrl: 'app/system/business-management/business-management-list.html',
    })
    ;

  }
})();
webapp.service('SystemCodeAPISrv', ['$resource', 'StaticVariable', '$rootScope',
	  function SystemCodeAPISrv($resource, staticVariable, $rootScope) {
	    return {
	    	getSystemCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/system/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    	getCommonCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/common/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    };
  },
]);

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.system', {
        url: '/system',
        template: '<div ui-view></div>',
      })

      // 회원사관리
      .state('app.system.company-list', {
        url: '/company-list/:srch',
        templateUrl: 'app/system/company/company-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.company-detail', {
        url: '/company-detail/:srch/:keyId',
        templateUrl: 'app/system/company/company-detail.html',
      })
      .state('app.system.company-edit', {
        url: '/company-edit/:srch/:keyId',
        templateUrl: 'app/system/company/company-edit.html',
      })
      .state('app.system.company-list.detail', {
        url: '/detail/:keyId',
        templateUrl: 'app/system/company-detail.html',
      })
      .state('app.system.company-list.edit', {
        url: '/edit/:keyId',
        templateUrl: 'app/system/company/company-edit.html',
      })
      .state('app.system.company-edit.tab1', {
        url: '/tab1',
        templateUrl: 'app/system/company/company-edit-tab1.html',
      })
      .state('app.system.company-edit.tab2', {
        url: '/tab2',
        templateUrl: 'app/system/company/company-edit-tab2.html',
      })
      .state('app.system.company-list.edit.tab1', {
        url: '/tab1',
        templateUrl: 'app/system/company/company-edit-tab1.html',
      })
      .state('app.system.company-list.edit.tab2', {
        url: '/tab2',
        templateUrl: 'app/system/company/company-edit-tab2.html',
      })

      // 회원사에서 보는 회원사관리
      .state('app.system.organization', {
        url: '/organization-list',
        templateUrl: 'app/system/organization/organization-list-view.html',
      })

      // 조직관리
      .state('app.system.company-info', {
        url: '/company-info',
        templateUrl: 'app/system/company/company-edit.html',
      })
      .state('app.system.company-info.tab1', {
        url: '/tab1/:srch/:keyId',
        templateUrl: 'app/system/company/company-edit-tab1.html',
      })

      // 공통코드관리
      .state('app.system.commoncode-list', {
        url: '/commoncode-list/:CodeType',
        templateUrl: 'app/system/common-code/commoncode-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })

      // 부서관리
      .state('app.system.department-list', {
        url: '/department-list',
        templateUrl: 'app/system/department/department-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.department-detail', {
        url: '/department-detail/:DeptId',
        templateUrl: 'app/system/department/department-detail.html',
      })
      .state('app.system.department-edit', {
        url: '/department-edit/:DeptId',
        templateUrl: 'app/system/department/department-edit.html',
      })

      // 쿼리생성기
      .state('app.system.makequery-list', {
        url: '/makequery-list',
        templateUrl: 'app/system/make-query/makequery-list.html',
        requiresAuthentication: true,
      })

      // 메뉴관리
      .state('app.system.menumanage-list', {
        url: '/menumanage-list',
        templateUrl: 'app/system/menu/menu-manage-list.html',
        requiresAuthentication: true,
      })
      .state('app.system.menumanage-mobilelist', {
        url: '/menumanage-mobilelist',
        templateUrl: 'app/system/menu/menu-manage-list.html',
        requiresAuthentication: true,
      })

      // 역할관리
      .state('app.system.role-list', {
        url: '/role-list/:srch',
        templateUrl: 'app/system/role/role-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.role-detail', {
        url: '/role-detail/:srch/:RoleId',
        templateUrl: 'app/system/role/role-detail.html',
      })
      .state('app.system.role-edit', {
        url: '/role-edit/:srch/:RoleId',
        templateUrl: 'app/system/role/role-edit.html',
      })
      .state('app.system.role-list.detail', {
        url: '/detail/:RoleId',
        templateUrl: 'app/system/role/role-detail.html',
      })
      .state('app.system.role-list.edit', {
        url: '/edit/:RoleId',
        templateUrl: 'app/system/role/role-edit.html',
      })

      // 역활별 화면 권한
      .state('app.system.screen-list.detail', {
        url: '/detail/:ScreenId',
        templateUrl: 'app/system/role-screen/screen-detail.html',
      })
      .state('app.system.screen-list.edit', {
        url: '/edit/:ScreenId',
        templateUrl: 'app/system/role-screen/screen-edit.html',
      })
      .state('app.system.rolescreen-list', {
        url: '/rolescreen-list/:srch',
        templateUrl: 'app/system/role-screen/rolescreen-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.rolescreen-detail', {
        url: '/rolescreen-detail/:RolescreenId',
        templateUrl: 'app/system/role-screen/rolescreen-detail.html',
      })
      .state('app.system.rolescreen-edit', {
        url: '/rolescreen-edit/:RolescreenId',
        templateUrl: 'app/system/role-screen/rolescreen-edit.html',
      })

      // 화면관리
      .state('app.system.screen-list', {
        url: '/screen-list/:srch',
        templateUrl: 'app/system/screen/screen-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.screen-detail', {
        url: '/screen-detail/:ScreenId',
        templateUrl: 'app/system/screen/screen-detail.html',
      })
      .state('app.system.screen-edit', {
        url: '/screen-edit/:ScreenId',
        templateUrl: 'app/system/screen/screen-edit.html',
      })

      // 프로젝트 관리
      .state('app.system.project-manage-list', {
        url: '/project-manage-list/:srch',
        templateUrl: 'app/system/project-manage/project-manage-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.project-manage-list.edit', {
        url: '/edit/:keyId',
        templateUrl: 'app/system/project-manage/project-edit.html',
      })
      .state('app.system.project-manage-edit', {
        url: '/project-edit/:srch/:keyId',
        templateUrl: 'app/system/project-manage/project-edit.html',
      })

      // 공지사항 등록
      .state('app.system.notice-list', {
        url: '/notice-list/:srch',
        templateUrl: 'app/system/notice/sys-notice-list-view.html',
        requiresAuthentication: true,
      })
      .state('app.system.notice-edit', {
        url: '/notice-edit/:keyId',
        templateUrl: 'app/system/notice/sys-notice-edit-view.html',
      })
      .state('app.system.notice-list.edit', {
        url: '/notice-edit/:keyId',
        templateUrl: 'app/system/notice/sys-notice-edit-view.html',
      })

      // 바로가기 관리
      .state('app.system.bookmark-manage', {
        url: '/bookmark-manage/',
        templateUrl: 'app/system/bookmark/bookmark-manage.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })

      // 마이그레이션
      .state('app.system.migration-list', {
        url: '/migration-list',
        templateUrl: 'app/system/migration/migration-list-view.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })

      // 서비스문의
      .state('app.system.inquery-list', {
        url: '/inquery-list',
        templateUrl: 'app/system/inquery/inquery-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.inquery-edit', {
        url: '/inquery-edit/:KeyId',
        templateUrl: 'app/system/inquery/inquery-edit.html',
      })
      .state('app.system.inquery-list.edit', {
        url: '/inquery-edit/:KeyId',
        templateUrl: 'app/system/inquery/inquery-edit.html',
      })

      // 사용자관리
      .state('app.system.user-list', {
        url: '/user-list',
        templateUrl: 'app/system/user/user-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.user-detail', {
        url: '/user-detail/:UserId',
        templateUrl: 'app/system/user/user-detail.html',
        requiresAuthentication: true,
      })
      .state('app.system.user-edit', {
        url: '/user-edit/:UserId?:TenantId',
        templateUrl: 'app/system/user/user-edit.html',
        params: {
          UserId: '',
        },
      })
      .state('app.system.user-edit.tab1', {
        url: '/user-edit/:srch/:keyId/tab1',
        templateUrl: 'app/system/user/user-edit-tab1.html',
      })
      .state('app.system.user-list.detail', {
        url: '/detail/:keyId',
        templateUrl: 'app/system/user/user-detail.html',
        requiresAuthentication: true,
      })
      .state('app.system.user-list.edit', {
        url: '/edit/:keyId',
        templateUrl: 'app/system/user/user-edit.html',
      })
      .state('app.system.user-list.edit.tab1', {
        url: '/tab1',
        templateUrl: 'app/system/user/user-edit-tab1.html',
      })
      .state('app.system.user-list.edit.tab2', {
        url: '/tab2',
        templateUrl: 'app/system/user/user-edit-tab2.html',
      })
      .state('app.system.user-list.edit.tab3', {
        url: '/tab3',
        templateUrl: 'app/system/user/user-edit-tab3.html',
      })

      //SMS 자동발송문구 관리
      .state('app.system.sms-auto-list', {
        url: '/sms-auto-list/:srch',
        templateUrl: 'app/system/sms/sms-auto-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.sms-auto-edit', {
        url: '/sms-auto-edit/:srch/:keyId',
        templateUrl: 'app/system/sms/sms-auto-edit.html',
      })
      .state('app.system.sms-auto-list.edit', {
        url: '/edit/:keyId',
        templateUrl: 'app/system/sms/sms-auto-edit.html',
      })

      // SMS발송번호인증 관리
      .state('app.system.sms-send-number-list', {
        url: '/sms-send-number-list/:srch',
        templateUrl: 'app/system/sms/sms-send-number-list.html',
        requiresAuthentication: true,
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.sms-send-number-edit', {
        url: '/sms-send-number-edit/:srch/:keyId',
        templateUrl: 'app/system/sms/sms-send-number-edit.html',
      })
      .state('app.system.sms-send-number-list.edit', {
        url: '/edit/:keyId',
        templateUrl: 'app/system/sms/sms-send-number-edit.html',
      })
      .state('app.system.personalInfo-list', {
        url: '/personalInfo-list',
        templateUrl: 'app/system/personal/personalinfo-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.personalInfo-edit', {
        url: '/personalInfo-edit/',
        templateUrl: 'app/system/personal/personalinfo-edit.html',
      })
      .state('app.system.personalSms-list', {
        url: '/personalSms-list',
        templateUrl: 'app/system/personal/personalSms-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.accountLock-list', {
        url: '/accountLock-list?:srch',
        templateUrl: 'app/system/personal/accountLock-list.html',
      })
      .state('app.system.visitLog-list', {
        url: '/visitLog-list?:srch',
        templateUrl: 'app/system/personal/visitLog-list.html',
      })
      .state('app.system.visitMenu-list', {
        url: '/visitMenu-list?:srch',
        templateUrl: 'app/system/personal/visitMenu-list.html',
      })
      .state('app.system.permissionInfo-list', {
        url: '/permissionInfo-list?:srch',
        templateUrl: 'app/system/personal/permissionInfo-list.html',
      })
      .state('app.system.business-list', {
        url: '/business-list',
        templateUrl: 'app/system/business/business-list.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.system.business-detail', {
        url: '/business-detail/:TenantId',
        templateUrl: 'app/system/business/business-detail.html',
      })
      .state('app.system.business-edit', {
        url: '/business-edit/:TenantId',
        templateUrl: 'app/system/business/business-edit.html',
        params: {
          TenantId: '',
        },
      })
      .state('app.system.business-detail-edit', {
        url: '/business-detail-edit/:TenantId',
        templateUrl: 'app/system/business/business-detail-edit.html',
      });
  }
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.systenant', {
      url : '/sys',
      template : '<div ui-view></div>',
    })
    .state('app.systenant.company-info', {
      url: '/company-info',
      templateUrl: 'app/system/company/company-edit.html',
    })
    .state('app.systenant.company-info.tab1', {
      url: '/tab1/:srch/:keyId',
      templateUrl: 'app/system/company/company-edit-tab1.html',
    })
    ;

    // $stateProvider.state('app.systinfo', {
    //   url : '/system',
    //   template : '<div ui-view></div>',
    // })

  }
})();
webapp.controller('AreacounselCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function AreacounselCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess('Areacounsel-list', $window.sessionStorage['loginUserType'])
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Areacounsel-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getExcel = getExcel;
    vm.getSearch = getSearch;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CustArmyRegDateFrom: null,
      CustArmyRegDateTo: null,
    };

    vm.ArmyZone = [];
    vm.CounselList = [];

    function getUserArmyZone() {
      vm.srch.mapCode = 'Areacounsel.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              console.log('vm.ArmyZone',vm.ArmyZone);
              getArmyList();
              getClassList();
              getEduList();
              getMonthList();
              getArmyClassList();
              getUnitList();
            } else {
              vm.ArmyZone = [];
              getArmyList();
              getClassList();
              getEduList();
              getMonthList();
              getArmyClassList();
              getUnitList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }

    // 군별 등록현황 조회
    function getArmyList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getArmyList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listArmy = data.body.docs;
            } else {
              vm.listArmy = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-ArmyList', status, data);
        }
      );
    }

    // 계급별 등록현황 조회
    function getClassList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getClassList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listClass = data.body.docs;
            } else {
              vm.listClass = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-ClassList', status, data);
        }
      );
    }

    // 학력별 등록현황 조회
    function getEduList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getEduList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listEdu = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listEdu.length; i++) {
                vm.listEdu[i].Gubun1_rowspan = 1;
                vm.listEdu[i].Gubun1_colspan = 1;
                vm.listEdu[i].Gubun1_show = true;
                vm.listEdu[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listEdu.length; i++) {
                if (i == 0) {
                  vm.listEdu[i].Gubun1_colspan = 2;
                  vm.listEdu[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listEdu.length; j++) {
                  if (vm.listEdu[i].Gubun1 == vm.listEdu[j].Gubun1) {
                    vm.listEdu[i].Gubun1_rowspan += 1;
                    vm.listEdu[j].Gubun1_show = false;

                    if (j == vm.listEdu.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listEdu = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-EduList', status, data);
        }
      );
    }

    // 월별 등록현황 조회
    function getMonthList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getMonthList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listMonth = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listMonth.length; i++) {
                vm.listMonth[i].Gubun1_rowspan = 1;
                vm.listMonth[i].Gubun1_colspan = 1;
                vm.listMonth[i].Gubun1_show = true;
                vm.listMonth[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listMonth.length; i++) {
                if (i == 0) {
                  vm.listMonth[i].Gubun1_colspan = 2;
                  vm.listMonth[i].Gubun2_show = false;
                }

                if (i == 1) {
                  vm.listMonth[i].Gubun1_colspan = 2;
                  vm.listMonth[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listMonth.length; j++) {
                  if (vm.listMonth[i].Gubun1 == vm.listMonth[j].Gubun1) {
                    vm.listMonth[i].Gubun1_rowspan += 1;
                    vm.listMonth[j].Gubun1_show = false;

                    if (j == vm.listMonth.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listMonth = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-MonthList', status, data);
        }
      );
    }

    // 군별/신분별 등록현황 조회
    function getArmyClassList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getArmyClassList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listArmyClass = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listArmyClass.length; i++) {
                vm.listArmyClass[i].Gubun1_rowspan = 1;
                vm.listArmyClass[i].Gubun1_colspan = 1;
                vm.listArmyClass[i].Gubun1_show = true;
                vm.listArmyClass[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listArmyClass.length; i++) {
                if (i == 0) {
                  vm.listArmyClass[i].Gubun1_colspan = 2;
                  vm.listArmyClass[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listArmyClass.length; j++) {
                  if (
                    vm.listArmyClass[i].Gubun1 == vm.listArmyClass[j].Gubun1
                  ) {
                    vm.listArmyClass[i].Gubun1_rowspan += 1;
                    vm.listArmyClass[j].Gubun1_show = false;

                    if (j == vm.listArmyClass.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listArmyClass = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-ArmyClassList', status, data);
        }
      );
    }

    // 부대별 등록현황 조회
    function getUnitList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Areacounsel.getUnitList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listUnit = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listUnit.length; i++) {
                vm.listUnit[i].Gubun1_rowspan = 1;
                vm.listUnit[i].Gubun1_colspan = 1;
                vm.listUnit[i].Gubun1_show = true;
                vm.listUnit[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listUnit.length; i++) {
                if (i == 0) {
                  vm.listUnit[i].Gubun1_colspan = 2;
                  vm.listUnit[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listUnit.length; j++) {
                  if (vm.listUnit[i].Gubun1 == vm.listUnit[j].Gubun1) {
                    vm.listUnit[i].Gubun1_rowspan += 1;
                    vm.listUnit[j].Gubun1_show = false;

                    if (j == vm.listUnit.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listUnit = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-UnitList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '지역별/부대별 등록현황';
      log.ScreenUrl = 'app/state/areacounsel';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/
      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '지역별 부대별 등록현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl('/etcExcel/areacounsel/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    function getSearch() {
      // 고객등록일 입력 후 검색 시
      if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo != null
      ) {
        return false;
      } else if (
        vm.srch.CustArmyRegDateFrom != null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
        getArmyList();
        getClassList();
        getEduList();
        getMonthList();
        getArmyClassList();
        getUnitList();
      } else {
        if (
          getDateToNumber(vm.srch.CustArmyRegDateFrom) >
          getDateToNumber(vm.srch.CustArmyRegDateTo)
        ) {
          gAlert('', '고객등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getArmyList();
          getClassList();
          getEduList();
          getMonthList();
          getArmyClassList();
          getUnitList();
        }
      }
    }

    // 데이터 조회
    getUserArmyZone();
  },
]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignReportListCtrl', ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state',

    function CampaignReportListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $state) {
      var vm = this;          // View Model

      var toDate = new Date();
      toDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
      var fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()-6);

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.listOptions = {
        ngIf : {
          FromInfo : "vc.srch.GroupType == 'From'", 
          ToInfo  : "vc.srch.GroupType == 'To'"
        }
      };

      vm.codeCmpgnChannel = [
        {Code : 'SMS', CodeValue : 'SMS'},
        {Code : 'EMAIL', CodeValue : 'EMAIL'},
      ];

      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn: true,

        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "sccampaigncustimplreport",
        keyIdNm: "keyId",
        alias: "vc",
        dataModelNm: "lists", // ex : vc.data = {}
        srchModelNm: "srch",
        srchTarget: "searchWrap",
        apis: {
          initSelectCnt: { mapCode: "CampaignImpl.getCampaignCustImplReportListCnt", param: {ResultDateFrom: moment(fromDate).format('YYYY-MM-DD'), ResultDateTo: moment(toDate).format('YYYY-MM-DD')} },
          initSelect: { mapCode: "CampaignImpl.getCampaignCustImplReportList", param: {ResultDateFrom: moment(fromDate).format('YYYY-MM-DD'), ResultDateTo: moment(toDate).format('YYYY-MM-DD')} },
        },

        addSrchStack: true,

        // List
        listCheckboxEnable: false,

        src : {
          detail : "app.message.campaign-result-list",
          splitDetail : ""
        },

        addForm : {
          // SendType : { before : "CmpgnChannel", type : mElemTx.select, label : "발송유형", colSize: 2},
          // SendStatus : { after : "SendMessage", type : mElemTx.select, label : "발송상태", colSize: 2}
        },

        addFormGroup : {
          SrchResultDate : { after : "Channel", type : mElemTx.date,  bindKey : ["ResultDateFrom", "ResultDateTo"], label : "수신일", addDivision : true, colSize : 2},
        },

        // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
        listClickCallback : clickevent,

        customCodes: {
          Channel: "codeCmpgnChannel"
        }

      };

      function clickevent(clickData) {
        if (vm.srch.GroupType == 'From') {
          vm.srch.FromInfo = clickData.EMAILCount == "0" ? clickData.FromInfoTitle.replaceAll("-", "") : clickData.FromInfoTitle;
        }
        else {
          vm.srch.ToInfo = clickData.EMAILCount == "0" ? clickData.ToInfoTitle.replaceAll("-", "") : clickData.ToInfoTitle;
        }

        if (clickData.EMAILCount == "0") {
          vm.srch.Channel = "SMS";
        }
        else {
          vm.srch.Channel = "EMAIL";
        }

        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('app.message.campaign-result-list', {srch: srch}, {reload:'app.message.campaign-result-list'});
      }

      function chgRadioButton(groupType) {
        vm.srch.GroupType = groupType;
        av.search();
      }

      function onReadyAutoView() {
        vm.srch.ResultDateFrom = isNullOrEmpty(vm.srch.ResultDateFrom)? moment(fromDate).format('YYYY-MM-DD') : vm.srch.ResultDateFrom;
        vm.srch.ResultDateTo = isNullOrEmpty(vm.srch.ResultDateTo)? moment(toDate).format('YYYY-MM-DD') : vm.srch.ResultDateTo;
        
        vm.headerTitle = moment(vm.srch.ResultDateFrom).format('YYYY-MM-DD') + " ~ " + moment(vm.srch.ResultDateTo).format('YYYY-MM-DD');

        if (isNullOrEmpty(vm.srch.GroupType)) {
          chgRadioButton('From');
        }

        // 발송자, 수신자 폰번호일 경우 포멧변경
        vm.lists.forEach(function(item){
          if(!isNullOrEmpty(item.FromInfo) && item.FromInfo.indexOf("@") == -1) {
            item.FromInfo = autoHypenTel(item.FromInfo);
          }

          if(!isNullOrEmpty(item.ToInfo) && item.ToInfo.indexOf("@") == -1) {
            item.ToInfo = autoHypenTel(item.ToInfo);
          }
        });

      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
      vm.chgRadioButton = chgRadioButton;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

webapp.controller('CareeremployCtrl', [
  '$http',
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  'StaticVariable',
  function CareeremployCtrl(
    $http,
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'Careeremploy-list',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Careeremploy-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CustArmyRegDateFrom: null,
      CustArmyRegDateTo: null,
      CounselDateFrom: null,
      CounselDateTo: null,
      CounselRound: null,
    };

    vm.CounselRoundList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1110',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    //vm.CounselRoundList.Code = '3';

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1110') {
        vm.srch.CounselRound = data.Code;
      }
    };

    vm.ArmyZone = [];
    vm.ConsultNumList = [];

    function getUserArmyZone() {
      vm.srch.mapCode = 'Careeremploy.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              getAllCareerList();
              getCareerList();
              getAllCounselList();
              getCounselList();
              getAllCompanyList();
              getCompanyList();
              getAreaList();
              getArmyList();
              getNavyList();
              getAirForceList();
              getROKMList();
            } else {
              vm.ArmyZone = [];
              getAllCareerList();
              getCareerList();
              getAllCounselList();
              getCounselList();
              getAllCompanyList();
              getCompanyList();
              getAreaList();
              getArmyList();
              getNavyList();
              getAirForceList();
              getROKMList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }

    // 진로목표별 현황(신청 기준)
    function getAllCareerList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getAllCareerList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCareerAll = data.body.docs;
              // 셀병합 관련
              for (var i = 0; i < vm.listCareerAll.length; i++) {
                vm.listCareerAll[i].Gubun1_rowspan = 1;
                vm.listCareerAll[i].Gubun1_colspan = 1;
                vm.listCareerAll[i].Gubun1_show = true;
                vm.listCareerAll[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCareerAll.length; i++) {
                if (i == 0) {
                  vm.listCareerAll[i].Gubun1_colspan = 2;
                  vm.listCareerAll[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCareerAll.length; j++) {
                  if (
                    vm.listCareerAll[i].Gubun1 == vm.listCareerAll[j].Gubun1
                  ) {
                    vm.listCareerAll[i].Gubun1_rowspan += 1;
                    vm.listCareerAll[j].Gubun1_show = false;

                    if (j == vm.listCareerAll.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCareerAll = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('AllError-CareerList', status, data);
        }
      );
    }

    // 부대별/진로목표별 현황(신청 기준) 조회
    function getCareerList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getCareerList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCareer = data.body.docs;
              // 셀병합 관련
              for (var i = 0; i < vm.listCareer.length; i++) {
                vm.listCareer[i].Gubun1_rowspan = 1;
                vm.listCareer[i].Gubun1_colspan = 1;
                vm.listCareer[i].Gubun1_show = true;
                vm.listCareer[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCareer.length; i++) {
                if (i == 0) {
                  vm.listCareer[i].Gubun1_colspan = 2;
                  vm.listCareer[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCareer.length; j++) {
                  if (vm.listCareer[i].Gubun1 == vm.listCareer[j].Gubun1) {
                    vm.listCareer[i].Gubun1_rowspan += 1;
                    vm.listCareer[j].Gubun1_show = false;

                    if (j == vm.listCareer.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCareer = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-CareerList', status, data);
        }
      );
    }

    // 상담분야별 현황(상담 기준)
    function getAllCounselList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getAllCounselList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCounselAll = data.body.docs;
              // 셀병합 관련
              for (var i = 0; i < vm.listCounselAll.length; i++) {
                vm.listCounselAll[i].Gubun1_rowspan = 1;
                vm.listCounselAll[i].Gubun1_colspan = 1;
                vm.listCounselAll[i].Gubun1_show = true;
                vm.listCounselAll[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCounselAll.length; i++) {
                if (i == 0) {
                  vm.listCounselAll[i].Gubun1_colspan = 2;
                  vm.listCounselAll[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCounselAll.length; j++) {
                  if (
                    vm.listCounselAll[i].Gubun1 == vm.listCounselAll[j].Gubun1
                  ) {
                    vm.listCounselAll[i].Gubun1_rowspan += 1;
                    vm.listCounselAll[j].Gubun1_show = false;

                    if (j == vm.listCounselAll.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCounselAll = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-AllCounselList', status, data);
        }
      );
    }

    // 부대별/상담분야별 현황(상담 기준)
    function getCounselList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getCounselList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCounsel = data.body.docs;
              // 셀병합 관련
              for (var i = 0; i < vm.listCounsel.length; i++) {
                vm.listCounsel[i].Gubun1_rowspan = 1;
                vm.listCounsel[i].Gubun1_colspan = 1;
                vm.listCounsel[i].Gubun1_show = true;
                vm.listCounsel[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCounsel.length; i++) {
                if (i == 0) {
                  vm.listCounsel[i].Gubun1_colspan = 2;
                  vm.listCounsel[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCounsel.length; j++) {
                  if (vm.listCounsel[i].Gubun1 == vm.listCounsel[j].Gubun1) {
                    vm.listCounsel[i].Gubun1_rowspan += 1;
                    vm.listCounsel[j].Gubun1_show = false;

                    if (j == vm.listCounsel.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCounsel = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-CounselList', status, data);
        }
      );
    }

    // 희망기업별 현황 (상담 기준)
    function getAllCompanyList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getAllCompanyList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCompanyAll = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listCompanyAll.length; i++) {
                vm.listCompanyAll[i].Gubun1_rowspan = 1;
                vm.listCompanyAll[i].Gubun1_colspan = 1;
                vm.listCompanyAll[i].Gubun1_show = true;
                vm.listCompanyAll[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCompanyAll.length; i++) {
                if (i == 0) {
                  vm.listCompanyAll[i].Gubun1_colspan = 2;
                  vm.listCompanyAll[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCompanyAll.length; j++) {
                  if (
                    vm.listCompanyAll[i].Gubun1 == vm.listCompanyAll[j].Gubun1
                  ) {
                    vm.listCompanyAll[i].Gubun1_rowspan += 1;
                    vm.listCompanyAll[j].Gubun1_show = false;

                    if (j == vm.listCompanyAll.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCompanyAll = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-AllCompanyList', status, data);
        }
      );
    }

    // 부대별/희망기업별 현황(상담 기준)
    function getCompanyList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getCompanyList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCompany = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listCompany.length; i++) {
                vm.listCompany[i].Gubun1_rowspan = 1;
                vm.listCompany[i].Gubun1_colspan = 1;
                vm.listCompany[i].Gubun1_show = true;
                vm.listCompany[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCompany.length; i++) {
                if (i == 0) {
                  vm.listCompany[i].Gubun1_colspan = 2;
                  vm.listCompany[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCompany.length; j++) {
                  if (vm.listCompany[i].Gubun1 == vm.listCompany[j].Gubun1) {
                    vm.listCompany[i].Gubun1_rowspan += 1;
                    vm.listCompany[j].Gubun1_show = false;

                    if (j == vm.listCompany.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCompany = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-CompanyList', status, data);
        }
      );
    }

    // 직무별/희망근무지역별 현황 조회
    function getAreaList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getAreaList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listArea = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listArea.length; i++) {
                vm.listArea[i].Gubun1_rowspan = 1;
                vm.listArea[i].Gubun1_colspan = 1;
                vm.listArea[i].Gubun1_show = true;
                vm.listArea[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listArea.length; i++) {
                if (i == 0) {
                  vm.listArea[i].Gubun1_colspan = 2;
                  vm.listArea[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listArea.length; j++) {
                  if (vm.listArea[i].Gubun1 == vm.listArea[j].Gubun1) {
                    vm.listArea[i].Gubun1_rowspan += 1;
                    vm.listArea[j].Gubun1_show = false;

                    if (j == vm.listArea.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listArea = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-AreaList', status, data);
        }
      );
    }

    // 군별 현황 (육군) 조회
    function getArmyList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getArmyList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listArmy = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listArmy.length; i++) {
                vm.listArmy[i].Gubun1_rowspan = 1;
                vm.listArmy[i].Gubun1_colspan = 1;
                vm.listArmy[i].Gubun1_show = true;
                vm.listArmy[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listArmy.length; i++) {
                if (i == 0) {
                  vm.listArmy[i].Gubun1_colspan = 2;
                  vm.listArmy[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listArmy.length; j++) {
                  if (vm.listArmy[i].Gubun1 == vm.listArmy[j].Gubun1) {
                    vm.listArmy[i].Gubun1_rowspan += 1;
                    vm.listArmy[j].Gubun1_show = false;

                    if (j == vm.listArmy.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listArmy = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-ArmyList', status, data);
        }
      );
    }

    // 군별 현황 (해군) 조회
    function getNavyList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getNavyList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listNavy = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listNavy.length; i++) {
                vm.listNavy[i].Gubun1_rowspan = 1;
                vm.listNavy[i].Gubun1_colspan = 1;
                vm.listNavy[i].Gubun1_show = true;
                vm.listNavy[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listNavy.length; i++) {
                if (i == 0) {
                  vm.listNavy[i].Gubun1_colspan = 2;
                  vm.listNavy[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listNavy.length; j++) {
                  if (vm.listNavy[i].Gubun1 == vm.listNavy[j].Gubun1) {
                    vm.listNavy[i].Gubun1_rowspan += 1;
                    vm.listNavy[j].Gubun1_show = false;

                    if (j == vm.listNavy.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listNavy = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-NavyList', status, data);
        }
      );
    }

    // 군별 현황 (공군) 조회
    function getAirForceList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getAirForceList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listAirForce = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listAirForce.length; i++) {
                vm.listAirForce[i].Gubun1_rowspan = 1;
                vm.listAirForce[i].Gubun1_colspan = 1;
                vm.listAirForce[i].Gubun1_show = true;
                vm.listAirForce[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listAirForce.length; i++) {
                if (i == 0) {
                  vm.listAirForce[i].Gubun1_colspan = 2;
                  vm.listAirForce[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listAirForce.length; j++) {
                  if (vm.listAirForce[i].Gubun1 == vm.listAirForce[j].Gubun1) {
                    vm.listAirForce[i].Gubun1_rowspan += 1;
                    vm.listAirForce[j].Gubun1_show = false;

                    if (j == vm.listAirForce.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listAirForce = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-AirForceList', status, data);
        }
      );
    }

    // 군별 현황 (해병대) 조회
    function getROKMList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Careeremploy.getROKMList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listROKM = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listROKM.length; i++) {
                vm.listROKM[i].Gubun1_rowspan = 1;
                vm.listROKM[i].Gubun1_colspan = 1;
                vm.listROKM[i].Gubun1_show = true;
                vm.listROKM[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listROKM.length; i++) {
                if (i == 0) {
                  vm.listROKM[i].Gubun1_colspan = 2;
                  vm.listROKM[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listROKM.length; j++) {
                  if (vm.listROKM[i].Gubun1 == vm.listROKM[j].Gubun1) {
                    vm.listROKM[i].Gubun1_rowspan += 1;
                    vm.listROKM[j].Gubun1_show = false;

                    if (j == vm.listROKM.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listROKM = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-ROKMList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '진로/취업목표별 진행현황';
      log.ScreenUrl = 'app/state/careeremploy';
      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      /*console.log('vm.listCareer', vm.listCareer);
        console.log('vm.listCompany : ' ,vm.listCompany);
        console.log('vm.listArea : ' ,vm.listArea);*/

      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
              
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/

      var header1 = [];
      var header2 = [];
      var header3 = [];
      var header4 = [];
      var header5 = [];
      var header6 = [];
      var header7 = [];
      var header8 = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun1';
      header1.push(obj);

      var obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header1.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header1.push(obj);

      obj = {};
      obj.title = '취업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header1.push(obj);

      obj = {};
      obj.title = '창업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header1.push(obj);

      obj = {};
      obj.title = '귀농귀촌';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header1.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header1.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun1';
      header2.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header2.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header2.push(obj);

      obj = {};
      obj.title = '중소기업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header2.push(obj);

      obj = {};
      obj.title = '대기업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header2.push(obj);

      obj = {};
      obj.title = '공공기관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header2.push(obj);

      obj = {};
      obj.title = '공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header2.push(obj);

      obj = {};
      obj.title = '해외취업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header2.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun';
      header3.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header3.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header3.push(obj);

      obj = {};
      obj.title = '군교관요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '군무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '군전임교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기타 군관련직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '민간대학교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '복지시설';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = '';
      header3.push(obj);

      obj = {};
      obj.title = '비상계획관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type7Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '산하기관/업체';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type8Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '예비군지휘관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type9Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '행정관서';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type10Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '교육·교사·교수·강사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type11Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '방송·미디어·문화';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type12Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '번역·통역';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type13Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '법무·특허';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type14Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '보험';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type15Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '부동산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type16Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '은행·증권·투신';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type17Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '편집·자료관리·출판·인쇄';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type18Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '경비·경호요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type19Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '시설관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type20Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type21Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '창고관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type22Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '폭발물 처리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type23Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '경리·회계·세무·재무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type24Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '경영·컨설팅·연구';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type25Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '경찰공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type26Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기능직 공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type27Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기획 전략';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type28Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '무역·수출입관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type29Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '물류·유통·구매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type30Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '비서·인포메이션';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type31Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '사무직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type32Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '사회복지·봉사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type33Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '상담';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type34Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '소방공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type35Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '인사·노무·인재개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type36Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '일반공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type37Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '일반사무·총무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type38Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '배송·운전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type39Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '사진';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type40Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '생활체육';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type41Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '서비스';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type42Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '식품·조리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type43Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '여행·숙박·레저';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type44Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '인포메이션·이벤트';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type45Cnt';
      header3.push(obj);

      obj = {};
      obj.title = 'CAD·CAM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type46Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '건축·토목·조경·설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type47Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '금속·재료·요업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type48Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기계·기계설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type49Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '농수축산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type50Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '도시·교통';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type51Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '생명공학·식품공학';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type52Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '생산직·기능직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type53Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '섬유·패션·의류';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type54Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '연구개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type55Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '의약·의료·제약·보건';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type56Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '전기·전자·제어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type57Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '품질관리·품질보증·생산관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type58Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '화학·화공·에너지';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type59Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '환경·안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type60Cnt';
      header3.push(obj);

      obj = {};
      obj.title = 'TM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Typ61Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '광고·홍보·PR';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type62Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기술영업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type63Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type64Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '마케팅';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type65Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '매장관리·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type66Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '상품기획·개발·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type67Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '영업·영업관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type68Cnt';
      header3.push(obj);

      obj = {};
      obj.title = 'IT기술영업·기술지원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type69Cnt';
      header3.push(obj);

      obj = {};
      obj.title = 'IT디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type70Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '멀티미디어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type71Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '모바일';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type72Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '서버·네트워크관리·DB관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type73Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '웹기획·웹마케팅·컨텐츠';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type74Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '통신기술';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type75Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '프로그래머';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type76Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '고정익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type77Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '관제';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type78Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기상';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type79Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '우주항공';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type80Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '조선';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type81Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '항공정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type82Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '항해';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type83Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '해양정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type84Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '회전익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type85Cnt';
      header3.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type86Cnt';
      header3.push(obj);

      var obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun1';
      header4.push(obj);

      var obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header4.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header4.push(obj);

      obj = {};
      obj.title = '취업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header4.push(obj);

      obj = {};
      obj.title = '창업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header4.push(obj);

      obj = {};
      obj.title = '귀농귀촌';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header4.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header4.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun';
      header5.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header5.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header5.push(obj);

      obj = {};
      obj.title = '군교관요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '군무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '군전임교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기타 군관련직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '민간대학교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '복지시설';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = '';
      header5.push(obj);

      obj = {};
      obj.title = '비상계획관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type7Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '산하기관/업체';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type8Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '예비군지휘관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type9Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '행정관서';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type10Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '교육·교사·교수·강사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type11Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '방송·미디어·문화';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type12Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '번역·통역';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type13Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '법무·특허';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type14Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '보험';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type15Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '부동산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type16Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '은행·증권·투신';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type17Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '편집·자료관리·출판·인쇄';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type18Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '경비·경호요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type19Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '시설관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type20Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type21Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '창고관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type22Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '폭발물 처리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type23Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '경리·회계·세무·재무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type24Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '경영·컨설팅·연구';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type25Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '경찰공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type26Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기능직 공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type27Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기획 전략';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type28Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '무역·수출입관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type29Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '물류·유통·구매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type30Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '비서·인포메이션';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type31Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '사무직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type32Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '사회복지·봉사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type33Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '상담';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type34Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '소방공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type35Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '인사·노무·인재개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type36Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '일반공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type37Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '일반사무·총무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type38Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '배송·운전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type39Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '사진';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type40Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '생활체육';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type41Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '서비스';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type42Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '식품·조리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type43Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '여행·숙박·레저';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type44Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '인포메이션·이벤트';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type45Cnt';
      header5.push(obj);

      obj = {};
      obj.title = 'CAD·CAM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type46Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '건축·토목·조경·설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type47Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '금속·재료·요업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type48Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기계·기계설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type49Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '농수축산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type50Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '도시·교통';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type51Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '생명공학·식품공학';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type52Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '생산직·기능직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type53Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '섬유·패션·의류';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type54Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '연구개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type55Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '의약·의료·제약·보건';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type56Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '전기·전자·제어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type57Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '품질관리·품질보증·생산관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type58Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '화학·화공·에너지';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type59Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '환경·안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type60Cnt';
      header5.push(obj);

      obj = {};
      obj.title = 'TM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Typ61Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '광고·홍보·PR';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type62Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기술영업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type63Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type64Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '마케팅';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type65Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '매장관리·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type66Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '상품기획·개발·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type67Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '영업·영업관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type68Cnt';
      header5.push(obj);

      obj = {};
      obj.title = 'IT기술영업·기술지원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type69Cnt';
      header5.push(obj);

      obj = {};
      obj.title = 'IT디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type70Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '멀티미디어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type71Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '모바일';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type72Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '서버·네트워크관리·DB관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type73Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '웹기획·웹마케팅·컨텐츠';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type74Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '통신기술';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type75Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '프로그래머';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type76Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '고정익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type77Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '관제';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type78Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기상';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type79Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '우주항공';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type80Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '조선';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type81Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '항공정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type82Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '항해';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type83Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '해양정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type84Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '회전익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type85Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type86Cnt';
      header5.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun';
      header6.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header6.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header6.push(obj);

      obj = {};
      obj.title = '군교관요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '군무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '군전임교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기타 군관련직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '민간대학교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '복지시설';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = '';
      header6.push(obj);

      obj = {};
      obj.title = '비상계획관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type7Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '산하기관/업체';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type8Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '예비군지휘관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type9Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '행정관서';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type10Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '교육·교사·교수·강사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type11Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '방송·미디어·문화';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type12Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '번역·통역';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type13Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '법무·특허';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type14Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '보험';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type15Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '부동산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type16Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '은행·증권·투신';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type17Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '편집·자료관리·출판·인쇄';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type18Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '경비·경호요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type19Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '시설관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type20Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type21Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '창고관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type22Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '폭발물 처리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type23Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '경리·회계·세무·재무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type24Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '경영·컨설팅·연구';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type25Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '경찰공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type26Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기능직 공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type27Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기획 전략';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type28Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '무역·수출입관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type29Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '물류·유통·구매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type30Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '비서·인포메이션';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type31Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '사무직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type32Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '사회복지·봉사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type33Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '상담';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type34Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '소방공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type35Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '인사·노무·인재개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type36Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '일반공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type37Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '일반사무·총무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type38Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '배송·운전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type39Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '사진';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type40Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '생활체육';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type41Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '서비스';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type42Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '식품·조리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type43Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '여행·숙박·레저';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type44Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '인포메이션·이벤트';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type45Cnt';
      header6.push(obj);

      obj = {};
      obj.title = 'CAD·CAM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type46Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '건축·토목·조경·설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type47Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '금속·재료·요업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type48Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기계·기계설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type49Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '농수축산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type50Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '도시·교통';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type51Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '생명공학·식품공학';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type52Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '생산직·기능직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type53Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '섬유·패션·의류';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type54Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '연구개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type55Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '의약·의료·제약·보건';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type56Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '전기·전자·제어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type57Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '품질관리·품질보증·생산관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type58Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '화학·화공·에너지';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type59Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '환경·안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type60Cnt';
      header6.push(obj);

      obj = {};
      obj.title = 'TM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Typ61Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '광고·홍보·PR';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type62Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기술영업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type63Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type64Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '마케팅';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type65Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '매장관리·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type66Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '상품기획·개발·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type67Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '영업·영업관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type68Cnt';
      header6.push(obj);

      obj = {};
      obj.title = 'IT기술영업·기술지원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type69Cnt';
      header6.push(obj);

      obj = {};
      obj.title = 'IT디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type70Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '멀티미디어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type71Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '모바일';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type72Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '서버·네트워크관리·DB관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type73Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '웹기획·웹마케팅·컨텐츠';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type74Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '통신기술';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type75Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '프로그래머';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type76Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '고정익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type77Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '관제';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type78Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기상';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type79Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '우주항공';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type80Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '조선';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type81Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '항공정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type82Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '항해';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type83Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '해양정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type84Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '회전익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type85Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type86Cnt';
      header6.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun';
      header7.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header7.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header7.push(obj);

      obj = {};
      obj.title = '군교관요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '군무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '군전임교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기타 군관련직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '민간대학교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '복지시설';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = '';
      header7.push(obj);

      obj = {};
      obj.title = '비상계획관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type7Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '산하기관/업체';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type8Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '예비군지휘관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type9Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '행정관서';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type10Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '교육·교사·교수·강사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type11Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '방송·미디어·문화';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type12Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '번역·통역';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type13Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '법무·특허';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type14Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '보험';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type15Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '부동산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type16Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '은행·증권·투신';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type17Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '편집·자료관리·출판·인쇄';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type18Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '경비·경호요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type19Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '시설관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type20Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type21Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '창고관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type22Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '폭발물 처리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type23Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '경리·회계·세무·재무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type24Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '경영·컨설팅·연구';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type25Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '경찰공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type26Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기능직 공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type27Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기획 전략';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type28Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '무역·수출입관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type29Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '물류·유통·구매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type30Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '비서·인포메이션';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type31Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '사무직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type32Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '사회복지·봉사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type33Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '상담';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type34Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '소방공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type35Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '인사·노무·인재개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type36Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '일반공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type37Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '일반사무·총무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type38Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '배송·운전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type39Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '사진';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type40Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '생활체육';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type41Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '서비스';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type42Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '식품·조리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type43Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '여행·숙박·레저';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type44Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '인포메이션·이벤트';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type45Cnt';
      header7.push(obj);

      obj = {};
      obj.title = 'CAD·CAM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type46Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '건축·토목·조경·설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type47Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '금속·재료·요업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type48Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기계·기계설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type49Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '농수축산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type50Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '도시·교통';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type51Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '생명공학·식품공학';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type52Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '생산직·기능직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type53Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '섬유·패션·의류';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type54Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '연구개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type55Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '의약·의료·제약·보건';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type56Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '전기·전자·제어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type57Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '품질관리·품질보증·생산관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type58Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '화학·화공·에너지';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type59Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '환경·안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type60Cnt';
      header7.push(obj);

      obj = {};
      obj.title = 'TM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Typ61Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '광고·홍보·PR';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type62Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기술영업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type63Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type64Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '마케팅';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type65Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '매장관리·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type66Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '상품기획·개발·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type67Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '영업·영업관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type68Cnt';
      header7.push(obj);

      obj = {};
      obj.title = 'IT기술영업·기술지원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type69Cnt';
      header7.push(obj);

      obj = {};
      obj.title = 'IT디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type70Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '멀티미디어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type71Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '모바일';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type72Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '서버·네트워크관리·DB관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type73Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '웹기획·웹마케팅·컨텐츠';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type74Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '통신기술';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type75Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '프로그래머';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type76Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '고정익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type77Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '관제';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type78Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기상';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type79Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '우주항공';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type80Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '조선';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type81Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '항공정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type82Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '항해';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type83Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '해양정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type84Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '회전익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type85Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type86Cnt';
      header7.push(obj);

      obj = {};
      obj.title = '구분';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun';
      header8.push(obj);

      obj = {};
      obj.title = '';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'Gubun2';
      header8.push(obj);

      obj = {};
      obj.title = '계';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'TotCnt';
      header8.push(obj);

      obj = {};
      obj.title = '군교관요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type1Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '군무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type2Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '군전임교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type3Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기타 군관련직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type4Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '민간대학교수';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type5Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '복지시설';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = '';
      header8.push(obj);

      obj = {};
      obj.title = '비상계획관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type7Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '산하기관/업체';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type8Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '예비군지휘관';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type9Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '행정관서';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type10Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '교육·교사·교수·강사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type11Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '방송·미디어·문화';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type12Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '번역·통역';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type13Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '법무·특허';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type14Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '보험';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type15Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '부동산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type16Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '은행·증권·투신';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type17Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '편집·자료관리·출판·인쇄';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type18Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '경비·경호요원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type19Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '시설관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type20Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type21Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '창고관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type22Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '폭발물 처리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type23Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '경리·회계·세무·재무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type24Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '경영·컨설팅·연구';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type25Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '경찰공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type26Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기능직 공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type27Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기획 전략';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type28Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '무역·수출입관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type29Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '물류·유통·구매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type30Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '비서·인포메이션';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type31Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '사무직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type32Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '사회복지·봉사';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type33Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '상담';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type34Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '소방공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type35Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '인사·노무·인재개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type36Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '일반공무원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type37Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '일반사무·총무';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type38Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '배송·운전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type39Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '사진';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type40Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '생활체육';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type41Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '서비스';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type42Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '식품·조리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type43Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '여행·숙박·레저';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type44Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '인포메이션·이벤트';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type45Cnt';
      header8.push(obj);

      obj = {};
      obj.title = 'CAD·CAM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type46Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '건축·토목·조경·설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type47Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '금속·재료·요업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type48Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기계·기계설비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type49Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '농수축산';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type50Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '도시·교통';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type51Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '생명공학·식품공학';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type52Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '생산직·기능직';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type53Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '섬유·패션·의류';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type54Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '연구개발';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type55Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '의약·의료·제약·보건';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type56Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '전기·전자·제어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type57Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '품질관리·품질보증·생산관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type58Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '화학·화공·에너지';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type59Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '환경·안전';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type60Cnt';
      header8.push(obj);

      obj = {};
      obj.title = 'TM';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Typ61Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '광고·홍보·PR';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type62Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기술영업';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type63Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type64Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '마케팅';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type65Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '매장관리·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type66Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '상품기획·개발·판매';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type67Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '영업·영업관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type68Cnt';
      header8.push(obj);

      obj = {};
      obj.title = 'IT기술영업·기술지원';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type69Cnt';
      header8.push(obj);

      obj = {};
      obj.title = 'IT디자인';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type70Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '멀티미디어';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type71Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '모바일';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type72Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '서버·네트워크관리·DB관리';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type73Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '웹기획·웹마케팅·컨텐츠';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type74Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '통신기술';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type75Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '프로그래머';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type76Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '고정익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type77Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '관제';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type78Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기상';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type79Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '우주항공';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type80Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '조선';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type81Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '항공정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type82Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '항해';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type83Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '해양정비';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type84Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '회전익조종';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type85Cnt';
      header8.push(obj);

      obj = {};
      obj.title = '기타';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'Type86Cnt';
      header8.push(obj);

      // 헤더설정 End

      vm.srch.header1 = header1;
      vm.srch.header4 = header4;
      vm.srch.header2 = header2;
      vm.srch.header3 = header3;

      vm.srch.header5 = header5;
      vm.srch.header6 = header6;
      vm.srch.header7 = header7;
      vm.srch.header8 = header8;

      vm.srch.downFileName = '진로취업목표별진행현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;
      console.log('vm.srch ', vm.srch);

      $http({
        url: StaticVariable.getUrl('/etcExcel/careeremploy/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    function getSearch() {
      // 고객등록일 입력 후 검색 시
      if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo != null
      ) {
      } else if (
        vm.srch.CustArmyRegDateFrom != null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
      } else if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
        getAllCareerList();
        getCareerList();
      } else {
        if (
          getDateToNumber(vm.srch.CustArmyRegDateFrom) >
          getDateToNumber(vm.srch.CustArmyRegDateTo)
        ) {
          gAlert('', '고객등록일의 날짜범위가 잘못되었습니다.');
        } else {
          getAllCareerList();
          getCareerList();
        }
      }

      // 상담등록일 입력 후 검색 시
      if (vm.srch.CounselDateFrom == null && vm.srch.CounselDateTo != null) {
        return false;
      } else if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CounselDateFrom == null &&
        vm.srch.CounselDateTo == null
      ) {
        getAllCounselList();
        getCounselList();
        getAllCompanyList();
        getCompanyList();
        getAreaList();
        getArmyList();
        getNavyList();
        getAirForceList();
        getROKMList();
      } else {
        if (
          getDateToNumber(vm.srch.CounselDateFrom) >
          getDateToNumber(vm.srch.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getAllCounselList();
          getCounselList();
          getAllCompanyList();
          getCompanyList();
          getAreaList();
          getArmyList();
          getNavyList();
          getAirForceList();
          getROKMList();
        }
      }
    }

    // 데이터 조회
    getUserArmyZone();
  },
]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} modalFactory - modalFactory
   * @description Controller of the 고객조회
   */
  webapp.controller('CustomerReportCtrl', 
    ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', 'autoView',
    function CustomerReportCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, autoView) {

      var vm = this;
      vm.headerTitle = "고객 통계";
      vm.dataloader = false;
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      //setLayout(vm.layout); // 화면분할 모드 설정
      var LIST_PAGE_URL = 'app.statistics.client-report';
      var KEY_TABLE_NM = 'TB_MEMBER';
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm : KEY_TABLE_NM,
          //ClientId: !isNullOrEmpty($stateParams.ClientId) ? $stateParams.ClientId : '',
          TenantId : vm.TenantId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        //vm.srch.ClientId = $stateParams.ClientId;
        vm.srch.TenantId = vm.TenantId;
      } 

      vm.SelectBox = [
        {id : "", name : "- 조회기준 -"},
        {id: "All", name :"전체"}, 
        {id: "Dept", name :"부서"},
        {id: "Person", name :"개인"}
      ];

      vm.LengthBox = [
        {id: "", name : " - 기간설정 -"},
        {id: "Recent7Days", name: '최근 1주일'},
        {id: "LastWeek", name: '지난주'},
        {id: "ThisWeek", name: '이번주'},
        {id: "Recent30Days", name: '최근한달'},
        {id: "ThisMonth", name: '이번달'},
        {id: "LastMonth", name: '지난달'},
        {id: "ThisYear", name: '올해'},
      ];

      vm.GroupBox = [
        {id: "", name : " - 그룹설정 -"},
        {id: "ByWeek", name: '주별'},
        {id: "ByMonth", name: '월별'},
        {id: "ByQuarter", name: '분기별'},
        {id: "ByYear", name: '연도별'},
      ];


      $scope.selectedRow = $stateParams.KeyId;

      if (vm.srch.LengthBy != '' && vm.srch.LengthBy != null) {
        for(var i = 0; i < vm.LengthBox.length; i++) {
          if ( vm.srch.LengthBy == vm.LengthBox[i].id) {
            vm.LengthBy = vm.LengthBox[i];
          }
        }
      } else {
        vm.LengthBy = vm.LengthBox[0];
      }

      if (vm.srch.SelectBy != '' && vm.srch.SelectBy != null) {
        for(var j = 0; j < vm.SelectBox.length; j ++) {
          if (vm.srch.SelectBy == vm.SelectBox[j].id) {
            vm.SelectBy = vm.SelectBox[j];
          }
        }
      } else {
        vm.SelectBy = vm.SelectBox[0];
      }

      if (vm.srch.GroupBy != '' && vm.srch.GroupBy != null) {
        for(var k = 0; k < vm.GroupBox.length; k++) {
          if ( vm.srch.GroupBy == vm.GroupBox[k].id) {
            vm.GroupBy = vm.GroupBox[k];
          }
        }
      } else {
        vm.GroupBy = vm.GroupBox[0];
      }
      vm.thisLength = vm.LengthBy;
      vm.thisSelect = vm.SelectBy;
      vm.thisGroup = vm.GroupBy;

      //정렬 셀렉트박스와 조회기준 셀렉트 박스 설정값 저장
      function setSortSelect() {
        vm.srch.LengthBy = vm.thisLength.id;
        vm.srch.SelectBy = vm.thisSelect.id;
        vm.srch.GroupBy = vm.thisGroup.id;
        //console.log(vm.srch);
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('app.statistics.client-report', {srch: srch}, {reload: 'app.statistics.client-report'});
      }



      vm.url = $state.current.url;
      vm.view = {
        VIEW_PAGE_BYMONTH : 'app/statistics/tab/customer-tab/customer-month.html', // 월별
        VIEW_PAGE_BYDAY : 'app/statistics/tab/customer-tab/customer-month.html', // 일별
        VIEW_PAGE_BYSYSTEM : 'app/statistics/tab/customer-tab/customer-month.html', // 출처별
        VIEW_PAGE_BYMANAGER : 'app/statistics/tab/customer-tab/customer-month.html', // 영업담당자별
        VIEW_PAGE_BYDEPT : 'app/statistics/tab/customer-tab/customer-month.html', // 지역본부별
        VIEW_PAGE_BYDEPT2 : 'app/statistics/tab/customer-tab/customer-month.html', // 부서별
        VIEW_PAGE_BYNONCONTACT : 'app/statistics/tab/customer-tab/customer-month.html', // 비접촉
        VIEW_PAGE_BYREGION : 'app/statistics/tab/customer-tab/customer-month.html', // 지역별
      };

      //vm.pages = vm.view.VIEW_PAGE_DEFAULTINFO;
      vm.tabIndex = 0;


      
      vm.tabList = [
        {Index : 0, Page : "VIEW_PAGE_BYMONTH", Text : "월별"}
        , {Index : 1, Page : "VIEW_PAGE_BYDAY", Text : "일별"}
        , {Index : 2, Page : "VIEW_PAGE_BYSYSTEM", Text : "출처별"}
        , {Index : 3, Page : "VIEW_PAGE_BYMANAGER", Text : "영업담당자별"}
        , {Index : 4, Page : "VIEW_PAGE_BYDEPT", Text : "지역본부별"}
        , {Index : 5, Page : "VIEW_PAGE_BYDEPT2", Text : "부서별"}
        , {Index : 6, Page : "VIEW_PAGE_BYNONCONTACT", Text : "비접촉"}
        , {Index : 7, Page : "VIEW_PAGE_BYREGION", Text : "지역별"}
       
      ];
      vm.pages = vm.view[vm.tabList[0].Page];


      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          return true;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeTabPosition(source);
        },
      };

      function setChangeTabPosition(source) {
        var TabList = [];
        for (var i = 0;  i < source.length; i ++) {
          source[i].Index = i;
          if (isNullOrEmpty(source[i].KeyId)) {
            source[i].KeyId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
          }

          TabList.push(source[i]);
        }

        var data = {};
        data.TabList = TabList;
        data.mapCode = 'KSATab.updateTabListBusinessOP';

        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> setChangeTabPosition()', error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      function setChangeTab(idx, view) {
        vm.tabIndex = idx;
        vm.pages = vm.view[view];
      }


      /**
       *
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {
        //alert(layout);
        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } 
        else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
            // 기본 "N"을 "V"와 같게 맞춰줌 
          case "N":
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
        }
        
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {
        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.changeLayout(layout);

        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn : true,
        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "TB_MEMBER",
        keyIdNm: "KeyId",
        alias: "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustListCnt", param : null},
          initSelect : { mapCode : "KSACust.getKSACustList", param : null },
        },
        addSrchStack : true,
        // List
        listCheckboxEnable : false,
        src: {
          detail: "app.client.ksacust-detail",
          splitDetail: ""
        },
      };

      function onReadyAutoView() {
        //var x = "V";
        //setLayout(x); // 화면분할 모드 설정
        //vm.data.totalItems = 0
      }
      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
      vm.setChangeTab = setChangeTab;
      vm.setChangeTabPosition = setChangeTabPosition;
      vm.setLayout = setLayout;
      vm.setChangeLayout = setChangeLayout;
      vm.setSortSelect = setSortSelect;
      
      var av = new autoView();
      av.init(autoViewOption);
    }]);
})();

webapp.controller('EmploystartupCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function EmploystartupCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'Employstartup-list',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Employstartup-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CounselDateFrom: null,
      CounselDateTo: null,
    };

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 중소기업 추천 리스트 조회
    function getRecommList() {
      getRecommListCount();

      vm.srch.page = vm.currentPage;

      vm.srch.mapCode = 'Employstartup.getRecommList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listRecomm = data.body.docs;
            } else {
              vm.listRecomm = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-RecommList', status, data);
        }
      );
    }

    // 중소기업 추천 리스트 카운트 조회
    function getRecommListCount() {
      vm.srch.mapCode = 'Employstartup.getRecommListCount';
      postApi.select(
        vm.srch,
        function (data) {
          console.log('counselappli', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '중소기업 희망 현황';
      log.ScreenUrl = 'app/state/employstartup';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '중소기업희망현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      var oriViewSize = vm.viewSize;
      vm.viewSize = 999999;
      vm.srch.viewSize = 999999;

      $http({
        url: StaticVariable.getUrl('/etcExcel/employstartup/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }

          vm.viewSize = oriViewSize;
          vm.srch.viewSize = oriViewSize;
        })
        .error(function (data, status, headers, config) {
          //download failed

          vm.viewSize = oriViewSize;
          vm.srch.viewSize = oriViewSize;
        });
    }

    // 페이징 관련
    function pageChanged() {
      getRecommList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getRecommList();
    }

    function getSearch() {
      if (vm.srch.CounselDateFrom == null && vm.srch.CounselDateTo != null) {
        return false;
      } else if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CounselDateFrom == null &&
        vm.srch.CounselDateTo == null
      ) {
        getRecommList();
      } else {
        if (
          getDateToNumber(vm.srch.CounselDateFrom) >
          getDateToNumber(vm.srch.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getRecommList();
        }
      }
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getRecommList();
  },
]);

webapp.controller('EmploystateCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function EmploystateCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('Employstate-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Employstartup-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
    vm.onTenentCodeSelected = onTenentCodeSelected;
    vm.onArmyAreaListSelected = onArmyAreaListSelected;
    vm.onArmyTypeListSelected = onArmyTypeListSelected;
    vm.onPermStat1ListSelected = onPermStat1ListSelected;

    vm.TCode = {};
    // 검색 조건
    vm.srch = {
      CounselDateFrom: null,
      CounselDateTo: null,
    };

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.listSize = [2, 10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    vm.srch.PermStat1 = '';

    /* vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      ArmyArea: '',
    };
    vm.CompanyEmployList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1260',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1260') {
        vm.srch.CompanyEmploy = data.Code;
      }
    };

    // 페이징 관련
    function pageChanged() {
      getEmployStateList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getEmployStateList();
    }

    vm.ArmyZone = [];
    vm.CounselList = [];

    function getUserArmyZone() {
      
      if($rootScope.gVariable.userType !='000') {
        vm.TCode.TenantId = $rootScope.gVariable.TenantId;
        vm.TCode.TenantNm = $rootScope.gVariable.TenantName;
        onTenentCodeSelected();
      }
      
      vm.srch.mapCode = 'Employstate.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              getEmployStateList();
            } else {
              vm.ArmyZone = [];
              getEmployStateList();
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }

    
    function getTenantList() {
      vm.TCode.mapCode = 'User.getTenantList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0] != null) {
              vm.tenantList = data.body.docs;
            } else {
              vm.tenantList = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getTenantList', status, data);
        }
      );
    }

    function onTenentCodeSelected () {
      //vm.listBtnDisable = true;
      if (vm.TCode == null) {
        vm.TCode = {
          TenantId: '',
          TenantNm: '',
        };
        vm.listBtnDisable = false;
        vm.AreaList = [];
      } else {
        vm.AreaList = [];
        vm.TypeList = [];
        vm.Stat1List = [];
        vm.TCode.TenantId = vm.TCode.TenantId;
        vm.TCode.TenantNm = vm.TCode.TenantNm;
        //vm.data.TenantId = vm.TCode.TenantId;
        vm.TCode.mapCode = 'User.getTenantCodeList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].TenantId != '0') {
                vm.AreaList = data.body.docs[0].TenantArea.split(',');
              } else {
                vm.AreaList = [];
              }
              vm.listBtnDisable = false;
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }
    }

    function onArmyAreaListSelected() {
      if (vm.ArmyAreaList == null) {
        vm.TCode.ArmyArea2 = '';
        vm.TypeList = [];
        vm.Stat1List = [];
      } else {
        vm.TCode.ArmyArea2 = vm.ArmyAreaList;
      }

      vm.TCode.mapCode = 'User.getArmyTypeList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs != null) {
              vm.TypeList = data.body.docs;
            } else {
              vm.TypeList = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function onArmyTypeListSelected() {
      if (vm.ArmyTypeList == null) {
        vm.TCode.ArmyType = '';
        vm.TCode.ArmyType_ = '';
      } else {
        vm.TCode.ArmyType = vm.ArmyTypeList.ArmyType;
        vm.TCode.ArmyType_ = vm.ArmyTypeList.ArmyType_;
      }

      vm.TCode.mapCode = 'User.getArmyAreaList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs != null) {
              vm.Stat1List = data.body.docs;
              // console.info("vm.lists -", vm.lists);
            } else {
              vm.Stat1List = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function onPermStat1ListSelected() {
      if (vm.PermStat1List == null) {
        vm.TCode.PermStat1 = '';
        vm.TCode.PermStat1_ = '';
      } else {
        vm.TCode.PermStat1 = vm.PermStat1List.PermStat1;
        vm.TCode.PermStat1_ = vm.PermStat1List.PermStat1_;
      }
    }


    // 취업자 리스트 조회
    function getEmployStateList() {
      
      vm.srch.page = vm.currentPage;
      
      if (vm.TCode != null) {
        if (vm.TCode.TenantId != undefined) {
          vm.srch.TenantId = vm.TCode.TenantId;
          vm.srch.TenantNm = vm.TCode.TenantNm;
        }
        if (vm.TCode.ArmyArea2 != undefined) {
          vm.srch.ArmyArea = vm.TCode.ArmyArea2;
        }
        if (vm.TCode.ArmyType != undefined) {
          vm.srch.ArmyType = vm.TCode.ArmyType;
          vm.srch.ArmyType_ = vm.TCode.ArmyType_;
        }
        if (vm.TCode.PermStat1 != undefined) {
          vm.srch.PermStat1 = vm.TCode.PermStat1;
          vm.srch.PermStat1_ = vm.TCode.PermStat1_;
        }
      }
      getEmployStateListCount();
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Employstate.getEmployStateList2';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              for(var i = 0; i < data.body.docs.length; i++) {
                data.body.docs[i].CompanyType = data.body.docs[i].CompanyType.replaceAll("&middot;","·");
              }
              
              vm.listEmployState = data.body.docs;
            } else {
              vm.listEmployState = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-EmployStateList', status, data);
        }
      );
    }

    // 취업자 리스트 카운트 조회
    function getEmployStateListCount() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Employstate.getEmployStateListCount';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('employstate', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '취업자 현황';
      log.ScreenUrl = 'app/state/employstate';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/
      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '취업자현황 리스트';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl('/etcExcel/employstate/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    function getSearch() {
      vm.currentPage = 1;
      console.log(vm.TCode);
      getEmployStateList();

      /*if(vm.srch.CustArmyRegDateFrom == null && vm.srch.CustArmyRegDateTo != null){
          return false;
        }
        else if(vm.srch.CustArmyRegDateFrom != null && vm.srch.CustArmyRegDateTo == null){
          return false;
        }
        else if(vm.srch.CompanyRegDateFrom == null && vm.srch.CompanyRegDateTo != null){
            return false;
        }
        else if(vm.srch.CompanyRegDateFrom != null && vm.srch.CompanyRegDateTo == null){
            return false;
        }
        else if(vm.srch.CompanyJoinDateFrom == null && vm.srch.CompanyJoinDateTo != null){
            return false;
        }
        else if(vm.srch.CompanyJoinDateFrom != null && vm.srch.CompanyJoinDateTo == null){
            return false;
        }
        else if(vm.srch.CustArmyRegDateFrom == null && vm.srch.CustArmyRegDateTo == null && vm.srch.CompanyRegDateFrom == null && vm.srch.CompanyRegDateTo == null && vm.srch.CompanyJoinDateFrom == null && vm.srch.CompanyJoinDateTo == null){
            getEmployStateList();
        }
        else {          
          if (getDateToNumber(vm.srch.CustArmyRegDateFrom) > getDateToNumber(vm.srch.CustArmyRegDateTo)) {
            gAlert('', '고객등록일의 날짜범위가 잘못되었습니다.');
          } 
          else if (getDateToNumber(vm.srch.CompanyRegDateFrom) > getDateToNumber(vm.srch.CompanyRegDateTo)) {
              gAlert('', '취업확인일의 날짜범위가 잘못되었습니다.');
          }
          else if (getDateToNumber(vm.srch.CompanyJoinDateFrom) > getDateToNumber(vm.srch.CompanyJoinDateTo)) {
              gAlert('', '입사일의 날짜범위가 잘못되었습니다.');
            }  
          else {
            getEmployStateList();
          }
        } */
    }

    // 모달팝업 호출 (상담사)
    function showModalCounselUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('lg', 'app/modal/user2-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          vm.srch.CounselUser_ = okData.UserNm;
          vm.srch.CounselUser = okData.UserId;
          //console.log('vm.srch:', vm.srch);
        },
        function (cancelData) {}
      );
    }

    // 모달팝업 데이터 삭제 (상담사)
    function clearModalCounselUser() {
      vm.srch.CounselUser_ = '';
      vm.srch.CounselUser = '';
    }

    vm.showModalCounselUser = showModalCounselUser;
    vm.clearModalCounselUser = clearModalCounselUser;
    vm.pageChanged = pageChanged;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getTenantList();
    getUserArmyZone();
  },
]);

(function () {
    "use strict";
    webapp.controller('ItemTypeReportCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function ItemTypeReportCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

  
      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'StatisticsPayment.getStatisticsByItemTypeCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'StatisticsPayment.getStatisticsByItemType';    // 목록 조회 SQL
      var EXCEL_SQL = 'StatisticsPayment.getStatisticsByItemType';
      var GROUP_LIST_SQL = 'StatisticsPayment.getGroupList';
      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.statistics.itemtype-report';         // 목록 화면
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'itemtype-report'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.daily = {};


      //#region 코드설정
     
      // 담당자
      postApi.select({
        mapCode: 'ScUser.getUserListCodes'
      },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
       }
      });
      
      //#endregion 코드설정 

      // #region 검색 옵션 설정
      
      var toDate = new Date();
      toDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
      var fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()-6);
      
      if (!$stateParams.srch) {
        //vm.PayDateFrom = new Date(moment().startOf('month'));
        //vm.PayDateTo = new Date(moment());
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          //PayDateFrom : vm.PayDateFrom,
          //PayDateTo : vm.PayDateTo
          PayDateFrom : moment(fromDate).format('YYYY-MM-DD'),
          PayDateTo : moment(toDate).format('YYYY-MM-DD'),
          GroupId : $window.sessionStorage['loginBranchId']
        };
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
        vm.currentPage = vm.srch.page;
        
      }

      //#endregion

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }
      vm.srchTenantId = $rootScope.gVariable.srchTenantId; 
      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.srchList = {};
      vm.columnMap = {};
      vm.groupList = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      vm.itemTypeItem = {};
      vm.totalCCount = 0;
      vm.totalPCount = 0;
      vm.totalPSum = 0;
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.text = {
        PayDateFrom : '',
        PayDateTo : ''
      };

      setLayout(vm.layout); // 화면분할 모드 설정

      // #region 데이터 조회 getSearch
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      // #region 검색값 초기화

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      // #region 지점 리스트 조회
      
      /**
       * 지점 리스트 조회
       *
       * @param
       * @return
       */
       function getGroupList() {
        var data = {}; // 검색 옵션 설정
        data.mapCode = GROUP_LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.groupList = result.body.docs;
            } 
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getGroupList()");
          // console.table(error);
        });
      }
      
      //#endregion

      // #region 목록 건수 조회

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }
      
      //#endregion
      
      // #region 목록 조회

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.PayDateFrom = moment(vm.srch.PayDateFrom).format('YYYY-MM-DD');
        vm.srch.PayDateTo = moment(vm.srch.PayDateTo).format('YYYY-MM-DD');
        vm.totalPCount = 0;
        vm.totalVCount = 0;
        vm.totalPSum = 0;
        
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정 
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        vm.text.PayDateFrom = data.PayDateFrom;
        vm.text.PayDateTo = data.PayDateTo;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              getItemTypeItemChart(vm.lists);
              setResponsive();

              for (var i = 0; i < vm.lists.length; i++) {
                vm.totalCCount += Number(vm.lists[i].C_COUNT);
                vm.totalPCount += Number(vm.lists[i].P_COUNT);
                vm.totalPSum += Number(vm.lists[i].P_SUM);
                vm.lists[i].P_SUM = AddComma(vm.lists[i].P_SUM);
              }
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      //#endregion

      // #region 목록 화면 구성

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }
      //#endregion
      
      // #region 페이지 변경시 데이터 조회

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }
      
      //#endregion

      // #region 목록 당 조회 건수 변경

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      //#endregion

      // #region 정렬 컬럼 설정

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      //#endregion
 
      // #region 정렬 컬럼 설정에 따른 Grid header Icon 표시
      
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }
      
      //#endregion

      // #region 화면 분할 모드 설정

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      //#endregion

      // #region 화면 분할 모드 변경

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      //#endregion

      // #region 초기 데이터 설정

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      //#endregion

      // #region 엑셀 다운로드

      /**
       * 엑셀 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            var today = new Date();
            $scope.fileName = "유형별매출통계_"+ today.getFullYear()+today.getMonth()+today.getDate();
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'PayDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }
      
      //#endregion

      // #region 차트 정보 설정 

      /**
       * 차트 정보 설정
       * @param data
       * @return
       */
      function getItemTypeItemChart(data) {
        vm.itemTypeItem.colors = ['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'];
        vm.itemTypeItem.datasetOverride = [
          {
            backgroundColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderWidth: 1,
            type: 'pie'
          }
        ];
        
        vm.itemTypeItem.options = {
          legend: {
            display : true,
            position : 'right'
          },
          responsive: true,
          tooltips: {
            displayColors : false,
            callbacks: {
              label: function(tooltipItem, _data) {
                var dataset = _data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1));
                currentValue = currentValue.toString();
                currentValue = currentValue.split(/(?=(?:...)*$)/);
                currentValue = currentValue.join(',');
                var tooltipPsum = '매출 ' + ': ' + currentValue + '원 (' + percentage + '%)';
                var tooltipVCnt = '고객 수 ' + ': ' + data[tooltipItem.index].C_COUNT + '건';
                var tooltipPCnt = '결제 수 ' + ': ' + data[tooltipItem.index].P_COUNT + '건';
                
                return [tooltipPsum, tooltipVCnt, tooltipPCnt];
              },
              title: function(tooltipItem, data) {
                return data.labels[tooltipItem[0].index];
              }
            }
          }
        };
        vm.itemTypeItem.labels = [];
        vm.itemTypeItem.data = [];
        angular.forEach(data, function(item) {
          vm.itemTypeItem.labels.push(item.ItemName);
          vm.itemTypeItem.data.push(item.P_SUM);
        });
      }

      //#endregion
      
      // #region AddComma 

      /**
       * 금액 콤마 표기
       * @param num
       * @return
       */
      function AddComma(num)
      {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
      }

      //#endregion

      // #region 함수 정의
      
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getExcelFile = getExcelFile;
      vm.getGroupList = getGroupList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      //#endregion

      // #region 함수 호출
      
      getGroupList();
      getList();
      setInitData();

      //#endregion

    }]);
  })();
  
webapp.controller('MethodcounselCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function MethodcounselCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'Methodcounsel-list',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Unitclass-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CounselDateFrom: null,
      CounselDateTo: null,
    };


    vm.ArmyZone = [];
    vm.CounselList = [];

    function getUserArmyZone() {
      vm.srch.mapCode = 'Methodcounsel.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              getCounselMethodList();
              getClassCounselMethodList();
            } else {
              vm.ArmyZone = [];
              getCounselMethodList();
              getClassCounselMethodList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }


    // 상담방법(총괄) 조회
    function getCounselMethodList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Methodcounsel.getCounselMethodList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listAll = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listAll.length; i++) {
                vm.listAll[i].Gubun1_rowspan = 1;
                vm.listAll[i].Gubun1_colspan = 1;
                vm.listAll[i].Gubun1_show = true;
                vm.listAll[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listAll.length; i++) {
                if (i == 0) {
                  vm.listAll[i].Gubun1_colspan = 2;
                  vm.listAll[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listAll.length; j++) {
                  if (vm.listAll[i].Gubun1 == vm.listAll[j].Gubun1) {
                    vm.listAll[i].Gubun1_rowspan += 1;
                    vm.listAll[j].Gubun1_show = false;

                    if (j == vm.listAll.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listAll = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getCounselMethodList', status, data);
        }
      );
    }

    function getClassCounselMethodList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Methodcounsel.getClassCounselMethodList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listClass = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listClass.length; i++) {
                vm.listClass[i].Gubun1_rowspan = 1;
                vm.listClass[i].Gubun1_acolspan = 1;
                vm.listClass[i].Gubun2_rowspan = 1;
                vm.listClass[i].Gubun1_show = true;
                vm.listClass[i].Gubun2_show = true;
                vm.listClass[i].Gubun3_show = true;
              }

              for (var i = 0; i < vm.listClass.length; i++) {
                if (i == 0) {
                  vm.listClass[i].Gubun1_colspan = 3;
                  vm.listClass[i].Gubun2_show = false;
                  vm.listClass[i].Gubun3_show = false;
                }

                for (var k = i + 1; k < vm.listClass.length; k++) {
                  if (vm.listClass[i].Gubun2 == vm.listClass[k].Gubun2) {
                    vm.listClass[i].Gubun2_rowspan += 1;
                    vm.listClass[k].Gubun2_show = false;
                  } else {
                    break;
                  }
                }
              }

              for (var i = 0; i < vm.listClass.length; i++) {
                for (var j = i + 1; j < vm.listClass.length; j++) {
                  if (vm.listClass[i].Gubun1 == vm.listClass[j].Gubun1) {
                    vm.listClass[i].Gubun1_rowspan += 1;
                    vm.listClass[j].Gubun1_show = false;
                    if (j == vm.listClass.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listClass = {};
            }
          }
          console.log(data);
        },
        function (error) {
          console.log("error");
          // console.error('Error-getCounselMethodList', status, data);
        }
      );
    }

    function getSearch() {
      // 상담등록일 입력 후 검색 시
      if (vm.srch.CounselDateFrom == null && vm.srch.CounselDateTo != null) {
        return false;
      } else if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CounselDateFrom == null &&
        vm.srch.CounselDateTo == null
      ) {
        getCounselMethodList();
        getClassCounselMethodList();
      } else {
        if (
          getDateToNumber(vm.srch.CounselDateFrom) >
          getDateToNumber(vm.srch.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getCounselMethodList();
          getClassCounselMethodList();
        }
      }
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '상담방법별 상담현황';
      log.ScreenUrl = 'app/state/methodcounsel';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '상담방법별 상담현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl('/etcExcel/methodcounsel/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    // 데이터 조회
    getUserArmyZone();
  },
]);

(function () {
    "use strict";
    /**
     * @ngdoc function
     * @name app.customer:customer-list-ctrl
     * @param {object} $window - window object
     * @param {object} $rootScope - rootScope object
     * @param {object} $scope - scope object
     * @param {object} $location - location object
     * @param {object} $state - state object
     * @param {object} $stateParams - state Parameter object
     * @param {object} GLOBAL_CONSTANT - Global Constant
     * @param {object} StaticVariable - StaticVariable Constant
     * @param {object} modalFactory - Modal Popup object
     * @param {object} postApi - postApi Module
     * @param {object} gAlert - gAlert Module
     * @param {object} gConfirm - gConfirm Module
     * @param {object} customFieldApi - customFieldApi Module
     * @param {object} $translate - translate object
     * @param {object} modalFactory - modalFactory
     * @description Controller of the 고객조회
     */
    webapp.controller('OutAmtReportCtrl', 
      ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$window','modalFactory',
      function OutAmtReportCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $window, modalFactory) {
  
        var vm = this;
        vm.headerTitle = "미수금 관리";
        vm.dataloader = true;

        
      //#region 코드설정
     
      // 담당자
      postApi.select({
        mapCode: 'ScUser.getUserListCodes'
      },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
       }
      });
      
      //#endregion 코드설정 

        //#region AutoView Options

        var autoViewOption = {
          vm : vm,
          stateParams : $stateParams,
          scope : $scope,
          printColumn : true,
  
          /* 공통 */
          viewType : mViewType.List, // List OR Edit
          tableNm : "outamt-report",
          keyIdNm : "KeyId",
          alias : "vc",
          dataModelNm : "lists", // ex : vc.data = {}
          srchModelNm : "srch",
          srchTarget : "searchWrap",
          apis : {
            initSelectCnt : { mapCode : "StatisticsPayment.getOutAmtListCnt", param : {GroupId : $window.sessionStorage['loginBranchId']} },
            initSelect : { mapCode : "StatisticsPayment.getOutAmtList", param : {GroupId : $window.sessionStorage['loginBranchId']} },
          },
  
          //addSrchStack : true,
  
          // List
          listCheckboxEnable : false,
          
          src : {
            detail : "",
            splitDetail : ""
          },
          
          addFormGroup : {
            PayDate : { after : "OutAmt", type : mElemTx.date,  bindKey : ["PayDateFrom", "PayDateTo"], label : "결제일시", addDivision : true, colSize : 2}
          },
    
          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          // listClickCallback : clickevent
          customCodes : {
            SurgicalManager: "codeManager",
          },
          
            // 비활성화 시킬 컬럼의 조건
          ngIf : {
          },
          listClickCallback : clickevent

        };
  
        //#endregion

        //#region 결제팝업 호출

        /**
         * 결제 팝업 호출 
         * @param {*} clickData 
         */
        function clickevent(clickData){
          vm.custPaymentAddModal(clickData.KeyId);
        }

        //#endregion

        //#region 결제 팝업 표시

        /**
         * 결제 팝업 표시 
         * @param {*} keyId 
         */
        vm.custPaymentAddModal = function (keyId) {
          var ctrl = 'CustPaymentModalCtrl as vc';
          var paramData = {
            CustId: $stateParams.KeyId,
            KeyId: keyId,
            ReserveType: '',
            ReserveId: ''
          };

          var modalInstance = modalFactory.open('lg', 'app/customer/modal/custPayment/custPayment-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {

          }, function (cancelData) {
            // 리스트업데이트
          });
        };

        //#endregion

        //#region onReadyAutoView

        function onReadyAutoView() {
          vm.dataloader = false;
        }


        //#endregion

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        
        var av = new autoView();
        av.init(autoViewOption);
        
        // 레이아웃 변경 미사용으로 레이아웃 변경 버튼 안보이게 설정
        $(".dock-header-tx").css("display", "none");
      }]);
  })();
  
(function () {
    "use strict";
    webapp.controller('PeriodReportCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function PeriodReportCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

  
     // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'StatisticsPayment.getStatisticsByPeriodCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'StatisticsPayment.getStatisticsByPeriod';    // 목록 조회 SQL
      var EXCEL_SQL = 'StatisticsPayment.getStatisticsByPeriod';
      var GROUP_LIST_SQL = 'StatisticsPayment.getGroupList';
      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.statistics.period-report';         // 목록 화면
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'period-report'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.daily = {};
      var toDate = new Date().getTime();
      var fromDate = new Date(moment().subtract(6, 'days')).getTime();

      //#region 코드설정
     
      // 담당자
      postApi.select({
        mapCode: 'ScUser.getUserListCodes'
      },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
       }
      });
      
      //#endregion 코드설정 
      
      //#region 검색 옵션 설정 

      if (!$stateParams.srch) {
        //vm.PayDateFrom = new Date(moment().startOf('month'));
        //vm.PayDateTo = new Date(moment());
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PayDateFrom : moment(fromDate).format('YYYY-MM-DD'),
          PayDateTo : moment(toDate).format('YYYY-MM-DD'),
          GroupId : $window.sessionStorage['loginBranchId']
        };
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
        vm.currentPage = vm.srch.page;
        
      }

      //#endregion

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }

      vm.srchTenantId = $rootScope.gVariable.srchTenantId; 
      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.totalPCount = 0;
      vm.totalPDCount = 0;
      vm.totalPSum = 0;
      vm.srchList = {};
      vm.columnMap = {};
      vm.groupList = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      setLayout(vm.layout); // 화면분할 모드 설정

      //#region 데이터 조회 getSearch
      /**
       * 데이터 조회 
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 검색값 초기화

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      //#endregion
      
      //#region 지점 리스트 조회

      /**
       * 지점 리스트 조회
       *
       * @param
       * @return
       */
      function getGroupList() {
        var data = {}; // 검색 옵션 설정
        data.mapCode = GROUP_LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.groupList = result.body.docs;
            } 
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getGroupList()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 목록 건수 조회

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 목록 조회

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.PayDateFrom = moment(vm.srch.PayDateFrom).format('YYYY-MM-DD');
        vm.srch.PayDateTo = moment(vm.srch.PayDateTo).format('YYYY-MM-DD');
        vm.totalPCount = 0;
        vm.totalVCount = 0;
        vm.totalPSum = 0;
        
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              
              // 목록 화면 구성
              setResponsive();
              setChartData(vm.lists);
              
              for (var i = 0; i < vm.lists.length; i++) {
                vm.totalPCount += Number(vm.lists[i].P_COUNT);
                vm.totalPDCount += Number(vm.lists[i].PD_COUNT);
                vm.totalPSum += Number(vm.lists[i].P_SUM);
                vm.lists[i].P_SUM = AddComma(vm.lists[i].P_SUM);
              }
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      //#endregion

      //#region 목록 화면 구성
    
      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      //#endregion

      //#region 페이지 변경시 데이터 조회

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 목록 당 조회 건수 변경

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정에 따른 Grid header Icon 표시

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      //#endregion

      //#region  화면 분할 모드 설정

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      //#endregion

      //#region 화면 분할 모드 변경

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 초기 데이터 설정

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      //#endregion

      //#region 엑셀 다운로드

      /**
       * 엑셀 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            var today = new Date();
            $scope.fileName = "기간별매출통계_"+ today.getFullYear()+today.getMonth()+today.getDate();
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'PayDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }

      //#endregion

      //#region setChartData

      /**
       * 차트 정보 설정
       * @param
       * @return
       */
      function setChartData(data) {
        vm.daily.colors = ['#428bca'];
        vm.daily.datasetOverride = [
          {
            label: '기간별 매출',
            backgroundColor: '#47a4f1',
            borderColor: '#47a4f1',
            borderWidth: 2,
            type: 'bar',
            yAxisID: 'y-axis-1',
          }
        ];
  
        vm.daily.options = {
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                  beginAtZero: true,
                  ShowGridLines : true,
                  userCallback: function(value, index, values) {
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
                    value = value.join(',');
                    return value;
                  }
                }
              }
            ],
            xAxes: [
              {
                id: 'x-axis-1',
                ticks: {
                  multiline: false,
                  autoSkip: false
                }
              }
            ]
          },
          tooltips: {
            displayColors : false,
            callbacks : {
              label : function(tooltipItem, data_) {
                var tooltipSum, tooltipPcnt, tooltipPDCnt = '';
                tooltipItem.yLabel = tooltipItem.yLabel.toString();
                tooltipItem.yLabel = tooltipItem.yLabel.split(/(?=(?:...)*$)/);
                tooltipItem.yLabel = tooltipItem.yLabel.join(',');
                tooltipSum = '매출 ' + ': ' + tooltipItem.yLabel+'원';
                tooltipPcnt = '유형 건 수 ' + ': ' + data[data.length-1-tooltipItem.index].PD_COUNT + '건';
                tooltipPDCnt = '결제 건 수 ' + ': ' + data[data.length-1-tooltipItem.index].P_COUNT + '건';
                return [tooltipSum, tooltipPcnt, tooltipPDCnt];
              }
            }
          }
        };
        vm.daily.labels = [];
        vm.daily.data = [];
        angular.forEach(data, function (item) {
            vm.daily.labels.push(moment(item.PayDate).format('M월 D일')); 
            vm.daily.data.push(item.P_SUM); 
        });      
        vm.daily.labels.reverse();
        vm.daily.data.reverse();
      }

      //#endregion

      //#region AddComma
    
      /**
       *  금액 콤마 표시
       * @param num
       * @return
       */
      function AddComma(num)
      {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
      }

      //#endregion

      //#region 함수 정의

      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getExcelFile = getExcelFile;
      vm.getGroupList = getGroupList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      //#endregion

      //#region 함수 호출
      
      getGroupList();
      getList();
      setInitData();

      //#endregion
      
    }]);
  })();
  
(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.state', {
        url: '/state',
        template: '<div ui-view></div>',
      })
      .state('app.state.totalprog', {
        url: '/totalprog',
        templateUrl: 'app/state/totalprog.html',
      })
      .state('app.state.unitclass', {
        url: '/unitclass',
        templateUrl: 'app/state/unitclass.html',
      })
      .state('app.state.areacounsel', {
        url: '/areacounsel',
        templateUrl: 'app/state/areacounsel.html',
      })
      .state('app.state.careeremploy', {
        url: '/careeremploy',
        templateUrl: 'app/state/careeremploy.html',
      })
      .state('app.state.employstartup', {
        url: '/employstartup',
        templateUrl: 'app/state/employstartup.html',
      })
      .state('app.state.survey', {
        url: '/survey',
        templateUrl: 'app/state/survey.html',
      })
      .state('app.state.survey2', {
        url: '/survey2',
        templateUrl: 'app/state/survey2.html',
      })
      .state('app.state.employstate', {
        url: '/employstate',
        templateUrl: 'app/state/employstate.html',
        resolve: {
          plugins: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
              ]);
            },
          ],
        },
      })
      .state('app.state.methodcounsel', {
        url: '/methodcounsel',
        templateUrl: 'app/state/methodcounsel.html',
      });
  }
})();

(function () {
    "use strict";
    webapp.controller('SurgicalManagerReportCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SurgicalManagerReportCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

  
     // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'StatisticsPayment.getStatisticsBySurgicalManagerCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'StatisticsPayment.getStatisticsBySurgicalManager';    // 목록 조회 SQL
      var EXCEL_SQL = 'StatisticsPayment.getStatisticsBySurgicalManager';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.statistics.surgicalmanager-report';         // 목록 화면
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'surgicalmanager-report'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.daily = {};
      var toDate = new Date();
      toDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
      var fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()-6);

      
      //#region 코드설정
     
      // 담당자
      postApi.select({
        mapCode: 'ScUser.getUserListCodes'
      },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
       }
      });
      
      //#endregion 코드설정 
      
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        //vm.PayDateFrom = new Date(moment().startOf('month'));
        //vm.PayDateTo = new Date(moment());
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          //PayDateFrom : vm.PayDateFrom,
          //PayDateTo : vm.PayDateTo
          PayDateFrom : moment(fromDate).format('YYYY-MM-DD'),
          PayDateTo : moment(toDate).format('YYYY-MM-DD'),
          GroupId : $window.sessionStorage['loginBranchId']
        };
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
        vm.currentPage = vm.srch.page;
        
      }

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }
      vm.srchTenantId = $rootScope.gVariable.srchTenantId; 
      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.groupList = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      vm.surgicalManagerItem = {};
      vm.totalCCount = 0;
      vm.totalPCount = 0;
      vm.totalPSum = 0;
      vm.text = {
        PayDateFrom : '',
        PayDateTo : ''
      };
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      setLayout(vm.layout); // 화면분할 모드 설정

      //#region 데이터 조회  getSearch
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 검색값 초기화

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 목록 건 수 조회

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 목록 조회

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.PayDateFrom = moment(vm.srch.PayDateFrom).format('YYYY-MM-DD');
        vm.srch.PayDateTo = moment(vm.srch.PayDateTo).format('YYYY-MM-DD');
        vm.totalPCount = 0;
        vm.totalVCount = 0;
        vm.totalPSum = 0;

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        vm.text.PayDateFrom = data.PayDateFrom;
        vm.text.PayDateTo = data.PayDateTo;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              getSurgicalManagerItemChart(vm.lists);
              setResponsive();

              for (var i = 0; i < vm.lists.length; i++) {
                vm.totalCCount += Number(vm.lists[i].C_COUNT);
                vm.totalPCount += Number(vm.lists[i].P_COUNT);
                vm.totalPSum += Number(vm.lists[i].P_SUM);
                vm.lists[i].P_SUM = AddComma(vm.lists[i].P_SUM);
              }
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      //#endregion

      //#region 목록 화면 구성

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      //#endregion

      //#region 페이지 변경시 데이터 조회

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 목록 당 조회 건수 변경

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정에 따른 Grid header Icon 표시

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      //#endregion

      //#region 화면 분할 모드 설정

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      //#endregion

      //#region 화면 분할 모드 변경

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 초기 데이터 설정

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      //#endregion

      //#region 엑셀 다운로드

      /**
       * 엑셀 다운로드
       * @param 
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            var today = new Date();
            $scope.fileName = "담당자별매출통계_"+ today.getFullYear()+today.getMonth()+today.getDate();
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'PayDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 담당자 차트 설정 

      function getSurgicalManagerItemChart(data) {
        vm.surgicalManagerItem.colors = ['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'];
        vm.surgicalManagerItem.datasetOverride = [
          {
            backgroundColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderWidth: 1,
            type: 'pie'
          }
        ];
        
        vm.surgicalManagerItem.options = {
          legend: {
            display : true,
            position : 'right'
          },
          responsive: true,
          tooltips: {
            displayColors : false,
            callbacks: {
              label: function(tooltipItem, _data) {
                var dataset = _data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1));
                currentValue = currentValue.toString();
                currentValue = currentValue.split(/(?=(?:...)*$)/);
                currentValue = currentValue.join(',');
                var tooltipPsum = '매출 ' + ': ' + currentValue + '원 (' + percentage + '%)';
                var tooltipVCnt = '고객 수 ' + ': ' + data[tooltipItem.index].C_COUNT + '건';
                var tooltipPCnt = '결제 수 ' + ': ' + data[tooltipItem.index].P_COUNT + '건';
                
                return [tooltipPsum, tooltipVCnt, tooltipPCnt];
              },
              title: function(tooltipItem, data) {
                return data.labels[tooltipItem[0].index];
              }
            }
          }
        };
        vm.surgicalManagerItem.labels = [];
        vm.surgicalManagerItem.data = [];
        angular.forEach(data, function(item) {
          vm.surgicalManagerItem.labels.push(item.UserNm);
          vm.surgicalManagerItem.data.push(item.P_SUM);
        });
      }

      //#endregion

      //#region 금액 콤마 추가 AddComma 

      function AddComma(num)
      {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
      }

      //#endregion
      
      //#region 함수 정의

      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getExcelFile = getExcelFile;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      //#endregion

      //#region 함수 호출

      getList();
      setInitData();

      //#endregion

    }]);
  })();
  
webapp.controller('TotalprogCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function TotalprogCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess('Totalprog-list', $window.sessionStorage['loginUserType'])
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Totalprog-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CustArmyRegDateFrom: null,
      CustArmyRegDateTo: null,
      CounselDateFrom: null,
      CounselDateTo: null,
    }; 
    vm.ArmyZone = [];
    vm.CounselList = [];

    function getUserArmyZone() {
      vm.srch.mapCode = 'Totalprog.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              getRegList();
              getCounselRound();
            } else {
              vm.ArmyZone = [];
              getRegList();
              getCounselRound();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }

    function getCounselRound() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Totalprog.getCounselRound';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.CounselList = data.body.docs;
              getCounselList();
            } else {
              vm.CounselList = [];
              getCounselList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }
    
    // 등록현황 조회
    function getRegList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Totalprog.getRegList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listReg = data.body.docs;
            } else {
              vm.listReg = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-RegList', status, data);
        }
      );
    }

    // 상담현황 조회
    function getCounselList() {
      vm.srch.CounselList = vm.CounselList;
      vm.srch.mapCode = 'Totalprog.getCounselList';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCounsel = data.body.docs;
            } else {
              vm.listCounsel = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-CounselList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '총괄진행현황/진도율';
      log.ScreenUrl = 'app/state/totalprog';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '총괄진행현황 진도율';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl('/etcExcel/totalprog/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    function getSearch() {
      // 고객등록일 입력 후 검색 시
      if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo != null
      ) {
      } else if (
        vm.srch.CustArmyRegDateFrom != null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
      } else if (
        vm.srch.CustArmyRegDateFrom == null &&
        vm.srch.CustArmyRegDateTo == null
      ) {
        getRegList();
      } else {
        if (
          getDateToNumber(vm.srch.CustArmyRegDateFrom) >
          getDateToNumber(vm.srch.CustArmyRegDateTo)
        ) {
          gAlert('', '고객등록일의 날짜범위가 잘못되었습니다.');
        } else {
          getRegList();
        }
      }

      // 상담등록일 입력 후 검색 시
      if (vm.srch.CounselDateFrom == null && vm.srch.CounselDateTo != null) {
        return false;
      } else if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CounselDateFrom == null &&
        vm.srch.CounselDateTo == null
      ) {
        getCounselList();
      } else {
        if (
          getDateToNumber(vm.srch.CounselDateFrom) >
          getDateToNumber(vm.srch.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getCounselList();
        }
      }
    }

    // 데이터 조회
    getUserArmyZone();
  },
]);

webapp.controller('UnitclassCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  'StaticVariable',
  function UnitclassCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    $http,
    StaticVariable
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess('Unitclass-list', $window.sessionStorage['loginUserType'])
    )
      $state.go('app.dashboard');

    // 버튼 권한 체크
    //$scope.showBtnAppr = isPageAccess("Unitclass-appr-modal", $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.getSearch = getSearch;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      CounselDateFrom: null,
      CounselDateTo: null,
    };
    vm.ArmyZone = [];
    vm.CounselList = [];
    vm.CounselList2 = [];
    
    function getUserArmyZone() {
      vm.srch.mapCode = 'Unitclass.getUserArmyZone';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.ArmyZone = data.body.docs;
              getCounselRound();
              getCounselRound2();
            } else {
              vm.ArmyZone = [];
              getCounselRound();
              getCounselRound2();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }
    
    function getCounselRound() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Unitclass.getCounselRound';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.CounselList = data.body.docs;
              getAllList();
            } else {
              vm.CounselList = [];
              getAllList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }
    
    function getCounselRound2() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.mapCode = 'Unitclass.getCounselRound2';

      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.CounselList2 = data.body.docs;
              getUnitList();
              getCounselList();
            } else {
              vm.CounselList2 = [];
              getUnitList();
              getCounselList();
            }
            
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getUserArmyZone', status, data);
        }
      );
    }

    // 상담현황(총괄) 조회
    function getAllList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.CounselList = vm.CounselList;
      vm.srch.mapCode = 'Unitclass.getAllList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listAll = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listAll.length; i++) {
                vm.listAll[i].Gubun1_rowspan = 1;
                vm.listAll[i].Gubun1_colspan = 1;
                vm.listAll[i].Gubun1_show = true;
                vm.listAll[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listAll.length; i++) {
                if (i == 0) {
                  vm.listAll[i].Gubun1_colspan = 2;
                  vm.listAll[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listAll.length; j++) {
                  if (vm.listAll[i].Gubun1 == vm.listAll[j].Gubun1) {
                    vm.listAll[i].Gubun1_rowspan += 1;
                    vm.listAll[j].Gubun1_show = false;

                    if (j == vm.listAll.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listAll = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-UnitList', status, data);
        }
      );
    }

    // 부대별 상담현황 조회
    function getUnitList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.CounselList2 = vm.CounselList2;
      vm.srch.mapCode = 'Unitclass.getUnitList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listUnit = data.body.docs;
              console.log('vm.listUnit === ', vm.listUnit);
              // 셀병합 관련
              for (var i = 0; i < vm.listUnit.length; i++) {
                vm.listUnit[i].Gubun1_rowspan = 1;
                vm.listUnit[i].Gubun1_colspan = 1;
                vm.listUnit[i].Gubun1_show = true;
                vm.listUnit[i].Gubun2_show = true;
                vm.listUnit[i].Goal_rowspan = 1;
                vm.listUnit[i].Goal_show = true;
                vm.listUnit[i].ProgressRate_rowspan = 1;
                vm.listUnit[i].ProgressRate_show = true;
              }

              for (var i = 0; i < vm.listUnit.length; i++) {
                if (i == 0) {
                  vm.listUnit[i].Gubun1_colspan = 2;
                  vm.listUnit[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listUnit.length; j++) {
                  if (vm.listUnit[i].Gubun1 == vm.listUnit[j].Gubun1) {
                    vm.listUnit[i].Gubun1_rowspan += 1;
                    vm.listUnit[j].Gubun1_show = false;

                    if (j == vm.listUnit.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listUnit = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-UnitList', status, data);
        }
      );
    }

    // 컨설턴트별 상담현황 조회
    function getCounselList() {
      vm.srch.userAreaList = vm.ArmyZone;
      vm.srch.CounselList2 = vm.CounselList2;
      vm.srch.mapCode = 'Unitclass.getCounselList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listCounsel = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listCounsel.length; i++) {
                vm.listCounsel[i].Gubun1_rowspan = 1;
                vm.listCounsel[i].Gubun1_colspan = 1;
                vm.listCounsel[i].Gubun1_show = true;
                vm.listCounsel[i].Gubun2_show = true;
              }

              for (var i = 0; i < vm.listCounsel.length; i++) {
                if (i == 0) {
                  vm.listCounsel[i].Gubun1_colspan = 2;
                  vm.listCounsel[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listCounsel.length; j++) {
                  if (vm.listCounsel[i].Gubun1 == vm.listCounsel[j].Gubun1) {
                    vm.listCounsel[i].Gubun1_rowspan += 1;
                    vm.listCounsel[j].Gubun1_show = false;

                    if (j == vm.listCounsel.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listCounsel = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-CounselList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '부대별/컨설턴트별 상담현황';
      log.ScreenUrl = 'app/state/unitclass';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      /*if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
          
        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }*/

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '부대별 컨설턴트별 상담현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        url: StaticVariable.getUrl('/etcExcel/unitclass/action.json?userkey=' + $rootScope.gVariable.userKey),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    function getSearch() {
      // 상담등록일 입력 후 검색 시
      if (vm.srch.CounselDateFrom == null && vm.srch.CounselDateTo != null) {
        return false;
      } else if (
        vm.srch.CounselDateFrom != null &&
        vm.srch.CounselDateTo == null
      ) {
        return false;
      } else if (
        vm.srch.CounselDateFrom == null &&
        vm.srch.CounselDateTo == null
      ) {
        getAllList();
        getUnitList();
        getCounselList();
      } else {
        if (
          getDateToNumber(vm.srch.CounselDateFrom) >
          getDateToNumber(vm.srch.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getAllList();
          getUnitList();
          getCounselList();
        }
      }
    }

    // 데이터 조회
    getUserArmyZone();
  },
]);

(function () {
    "use strict";
    webapp.controller('VisitPathReportCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function VisitPathReportCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

  
     // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'StatisticsPayment.getStatisticsByVisitPathCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'StatisticsPayment.getStatisticsByVisitPath';    // 목록 조회 SQL
      var EXCEL_SQL = 'StatisticsPayment.getStatisticsByVisitPath';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.statistics.visitpath-report';         // 목록 화면
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'visitpath-report'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.daily = {};
      var toDate = new Date();
      toDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
      var fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()-6);

      
      //#region 코드설정
     
      // 담당자
      postApi.select({
        mapCode: 'ScUser.getUserListCodes'
      },
      function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
       }
      });
      
      //#endregion 코드설정 
      
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        //vm.PayDateFrom = new Date(moment().startOf('month'));
        //vm.PayDateTo = new Date(moment());
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PayDateFrom : moment(fromDate).format('YYYY-MM-DD'),
          PayDateTo : moment(toDate).format('YYYY-MM-DD'),
          GroupId : $window.sessionStorage['loginBranchId']
        };
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PayDateFrom = $rootScope.getDateFormat(vm.srch.PayDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = $rootScope.getDateFormat(vm.srch.PayDateTo);
        vm.currentPage = vm.srch.page;
        
      }

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }
      vm.srchTenantId = $rootScope.gVariable.srchTenantId; 
      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.groupList = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      vm.visitPathItem = {};
      vm.totalPCount = 0;
      vm.totalVCount = 0;
      vm.totalPSum = 0;
      vm.text = {
        PayDateFrom : '',
        PayDateTo : ''
      };
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      setLayout(vm.layout); // 화면분할 모드 설정

      //#region 데이터 조회 getSearch
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 검색값 초기화

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 목록 건수 조회

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 목록 조회

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.PayDateFrom = moment(vm.srch.PayDateFrom).format('YYYY-MM-DD');
        vm.srch.PayDateTo = moment(vm.srch.PayDateTo).format('YYYY-MM-DD');
        vm.totalPCount = 0;
        vm.totalVCount = 0;
        vm.totalPSum = 0;
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        vm.text.PayDateFrom = data.PayDateFrom;
        vm.text.PayDateTo = data.PayDateTo;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              getVisitPathItemChart(vm.lists);
              setResponsive();

              for (var i = 0; i < vm.lists.length; i++) {
                vm.totalPCount += Number(vm.lists[i].P_COUNT);
                vm.totalVCount += Number(vm.lists[i].V_COUNT);
                vm.totalPSum += Number(vm.lists[i].P_SUM);
                vm.lists[i].P_SUM = AddComma(vm.lists[i].P_SUM);
              }
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      //#endregion

      //#region 목록 화면 구성

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      //#endregion

      //#region 페이지 변경시 데이터 조회

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 목록 당 조회 건수 변경

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      //#endregion

      //#region 정렬 컬럼 설정에 따른 Grid header Icon 표시

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      //#endregion

      //#region 화면 분할 모드 설정

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }
      
      //#endregion

      //#region 화면 분할 모드 변경

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      //#endregion

      //#region 초기 데이터 설정

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      //#endregion

      //#region 엑셀 다운로드 

      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            var today = new Date();
            $scope.fileName = "방문경로별매출통계_"+ today.getFullYear()+today.getMonth()+today.getDate();
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'PayDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }

      //#endregion

      //#region 방문경로별 차트 설정

      function getVisitPathItemChart(data) {
        vm.visitPathItem.colors = ['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'];
        vm.visitPathItem.datasetOverride = [
          {
            backgroundColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
            borderWidth: 1,
            type: 'pie'
          }
        ];
        
        vm.visitPathItem.options = {
          legend: {
            display : true,
            position : 'bottom'
          },
          responsive: true,
          tooltips: {
            displayColors : false,
            callbacks: {
              label: function(tooltipItem, _data) {
                var dataset = _data.datasets[tooltipItem.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1));
                currentValue = currentValue.toString();
                currentValue = currentValue.split(/(?=(?:...)*$)/);
                currentValue = currentValue.join(',');
                var tooltipPsum = '매출 ' + ': ' + currentValue + '원 (' + percentage + '%)';
                var tooltipVCnt = '고객 수 ' + ': ' + data[tooltipItem.index].V_COUNT + '건';
                var tooltipPCnt = '결제 수 ' + ': ' + data[tooltipItem.index].P_COUNT + '건';
                
                return [tooltipPsum, tooltipVCnt, tooltipPCnt];
              },
              title: function(tooltipItem, data) {
                return data.labels[tooltipItem[0].index];
              }
            }
          }
        };
        vm.visitPathItem.labels = [];
        vm.visitPathItem.data = [];
        angular.forEach(data, function(item) {
          vm.visitPathItem.labels.push(item.VisitPathNm);
          vm.visitPathItem.data.push(item.P_SUM);
        });
      }

      //#endregion

      //#region 금액 콤마 추가 

      function AddComma(num)
      {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
      }

      //#endregion

      //#region 함수 정의
      
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getExcelFile = getExcelFile;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      //#endregion

      //#region 함수 호출
      
      getList();
      setInitData();

      //#endregion
      
    }]);
  })();
  
(function() {
  "use strict";
  AgreementController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function AgreementController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
  }

  webapp.component("agreement", {
    transclude: true,
    bindings: {},
    controller: AgreementController,
    controllerAs: "agreement",
    templateUrl: "components/agreement/agreement.html"
  });
})();

(function() {
  "use strict";
  FaqController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function FaqController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    //console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.onChangeHandler = onChangeHandler;

    function onChangeHandler() {
      //console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

//      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function getBoardList() {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9'};

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.boardlist = result.body.docs;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    }

    vm.showDetail = function(BbsPostId) {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9', BbsPostId:BbsPostId, selectType:'Detail'};

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    };

    getBoardList();
  }

  webapp.component("faq", {
    transclude: true,
    bindings: {},
    controller: FaqController,
    controllerAs: "faq",
    templateUrl: "components/faq/faq.html"
  });
})();

(function() {
  "use strict";
  IntroController.$inject = 
  ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', 'modalFactory', 'Auth', 'autoPage', '$stateParams', '$scope', 'postApi', '$window', '$timeout'];

  /** @ngInject */
  function IntroController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, modalFactory, Auth, autoPage,  $stateParams, $scope, postApi, $window, $timeout) {
    var vm = this;
    
    vm.goLogin = function() {
      $state.go('login');
    };

    vm.download = function() {
      //indow.location.href = "/assets/salevisCare.apk";
      var ctrl = 'DownLoadApk as modalCtrl';
      var paramData = {
       
      };

      var modalInstance = modalFactory.open('md', 'components/modal/apk/download-apk-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        
      }, function (cancelData) {
      
        // 닫기 
      });
    };

    vm.goInqueryScroll = function() {
      var offset = $("#inquiry").offset();
      $(window).scrollTop(offset.top);
    };

    vm.submit = function() {

      var error = "";
      if(isNullOrEmpty(vm.CompanyNm)) {
        if(error != "") error += "</br>"
        error +=  "- 회사명을 입력하여주세요.";
      }

      if(isNullOrEmpty(vm.Manager)) {
        if(error != "") error += "</br>"
        error +=  "- 담당자를 입력하여주세요.";
      }

      if(isNullOrEmpty(vm.Tel)) {
        if(error != "") error += "</br>"
        error +=  "- 연락처를 입력하여주세요.";
      }

      if(isNullOrEmpty(vm.Email)) {
        if(error != "") error += "</br>"
        error +=  "- 이메일을 입력하여주세요.";
      }

      if (!isNullOrEmpty(vm.Email) && !isValidEmail(vm.Email)) {
        if(error != "") error += "</br>"
        error +=  "- 이메일 형식을 확인해주세요.";
      }

      if(isNullOrEmpty(vm.Contents)) {
        if(error != "") error += "</br>"
        error +=  "- 문의내용을 입력하여주세요.";
      }

      if(error != "") {
        gAlert("", error);
        return;
      }

      var data = {
        CompanyNm : vm.CompanyNm,
        Manager : vm.Manager,
        Tel : vm.Tel,
        Email : vm.Email,
        Contents : vm.Contents,
        Status : 100,
        mapCode : "insertInquery"
      };

      postApi.login(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('','문의를 등록하였습니다.<br>확인 후 연락드리겠습니다.', {
            btn : '',
            fn : function() {
              vm.CompanyNm = "";
              vm.Manager = "";
              vm.Tel = "";
              vm.Email = "";
              vm.Contents = "";
            }
          });
        }
      }, function(error) {
        console.log("error");
        // console.error('fail', status, data);
      });

    };

  }

  webapp.component("intro", {
    transclude: true,
    bindings: {},
    controller: IntroController,
    controllerAs: "intro",
    templateUrl: "components/intro/intro.html"
  });

  

})();

webapp.service('LoginAPISrv', [
  '$resource',
  '$rootScope',
  'StaticVariable',
  function LoginAPISrv($resource, $rootScope, StaticVariable) {
    var loginApi = {
      doLogin: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/login.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doLogout: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/logout.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCheckSession: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/checkSession.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doPersonal_IdSrch: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/personal_IdSrch.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCompany_IdSrch: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/company_IdSrch.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doPersonal_PwSrch: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/personal_PwSrch.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCompany_PwSrch: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/company_PwSrch.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doResetPassword: function () {
        return $resource(
          StaticVariable.getUrl('/login/resetPassword.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doSaveResetPwAutoMail: function () {
        return $resource(
          StaticVariable.getUrl('/login/insertAutoMail.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCreateUser: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/signupUser.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCheckLoginId: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/checkLoginId.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doGetTenant: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/getTenant.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doGetTenantList: function (obj) {
        return $resource(
          StaticVariable.getUrl('/login/getTenantList.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },

      doCheckUserInfo: function () {
        return $resource(
          StaticVariable.getUrl('/login/checkUserInfo.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      /* 2024-01-25 보안취약점 개선으로 API 제거
      doUpdateUserPass: function () {
        return $resource(
          StaticVariable.getUrl('/login/updateUserPass.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      */

      doCheckUserInfoForUpdatePass: function () {
        return $resource(
          StaticVariable.getUrl(
            '/select/Login.checkUserInfoForUpdatePass/action.json'
          ),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doUpdateUserPassForUpdatePass: function () {
        return $resource(
          StaticVariable.getUrl(
            '/update/Login.updateUserPassForUpdatePass/action.json'
          ),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },

      doInsertSecondAuthentication: function () {
        return $resource(
          StaticVariable.getUrl('/login/insertSecondAuthentication.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doCheckSecondAuthenticationNumber: function () {
        return $resource(
          StaticVariable.getUrl('/login/checkSecondAuthenticationNumber.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
    };
    return loginApi;
  },
]);

(function () {
    'use strict';
    LoginFooterController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory', '$scope'];
  
    /** @ngInject */
    function LoginFooterController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory, $scope) {
      var vm = this;
    }

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */
    var loginFooter = {
      transclude: true,
      controller: LoginFooterController,
      bindings: {},
      controllerAs: "loginFooter",
      templateUrl: 'components/login/login-footer.html'
    };
  
    webapp.component("loginFooter", loginFooter);
  })();
  
  
(function () {
    'use strict';
    LoginHeaderController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory', '$scope'];
  
    /** @ngInject */
    function LoginHeaderController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory, $scope) {
      var vm = this;
      vm.title = $window.sessionStorage['loginTitle'];
      vm.url = $window.sessionStorage['loginUrl'];

      vm.stateName = $state.current.name;

      $rootScope.$on("$stateChangeSuccess", function(event, toState) {
        vm.stateName = toState.name;
      });
    }

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */
    var loginHeader = {
      transclude: true,
      controller: LoginHeaderController,
      bindings: {},
      controllerAs: "loginHeader",
      templateUrl: 'components/login/login-header.html'
    };
  
    webapp.component("loginHeader", loginHeader);
  })();
  
  
(function () {
  'use strict';
  LoginController.$inject = [
    '$log',
    '$state',
    '$filter',
    '$cookies',
    '$rootScope',
    'MAIN',
    'LoginAPISrv',
    'GLOBAL_CONSTANT',
    'gAlert',
    'gConfirm',
    'modalFactory',
    'Auth',
    'autoPage',
    '$stateParams',
    '$scope',
    'postApi',
    '$window',
    '$timeout',
    '$translate',
    'pay',
  ];

  /** @ngInject */
  function LoginController(
    $log,
    $state,
    $filter,
    $cookies,
    $rootScope,
    MAIN,
    loginApi,
    CONSTANT,
    gAlert,
    gConfirm,
    modalFactory,
    Auth,
    autoPage,
    $stateParams,
    $scope,
    postApi,
    $window,
    $timeout,
    $translate,
    pay
  ) {
    var vm = this;

    vm.user = {};
    vm.data = {};

    // var date = new Date();
    // if(date.getFullYear() <= 2026 && date.getMonth()+1 <= 1 && date.getDate() <= 20) {
    //   gAlert('','서버 작업으로 인해 2026. 1. 20(화) 19:00 ~ 20:00 동안 이용이 제한됩니다.');
    // }
    if(new Date('2026-06-16 01:00:00') - new Date > 0) {
      showInfoImageModal('assets/images/img20260615.png');
    }

    var saveId = $cookies.get('mySavedId');

    if (saveId != undefined && saveId != '') {
      vm.user = {
        loginId: saveId,
        saveId: '1',
      };
    }

    $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function (json) {
      $window.sessionStorage['loginIP'] = json.ip;
    });

    function checkCookie() {
      CONSTANT.isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));

      var log = document.cookie.split(';').filter(function(a) {
        var a2 = a.replaceAll(' ', '').split('=');
        return a2[0] == 'visitor' && a2[1] == 'done'
      });
      
      if(log.length === 0) {
        setVisitorCookie();
      }
    }
    
    function setVisitorCookie() {
      var today = new Date();
      today.setDate(today.getDate() + 1);
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(1);
  
      var cookie = [
        'visitor=done',
        ';path=/; expires=',
        today.toString()
      ].join('');
  
      document.cookie = cookie;
      setVisitorIp();
    }

    function setVisitorIp() {
      var ua = navigator.userAgent;
      var browser = '알 수 없음';
      var isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));
      
      if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edge') === -1 && ua.indexOf('OPR') === -1) {
        browser = 'Chrome';
      } else if (ua.indexOf('Firefox') > -1) {
        browser = 'Firefox';
      } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
        browser = 'Safari';
      } else if (ua.indexOf('Edge') > -1) {
        browser = 'Edge';
      } else if (ua.indexOf('Trident') > -1 || ua.indexOf('MSIE') > -1) {
        browser = 'Internet Explorer';
      } else if (ua.indexOf('OPR') > -1 || ua.indexOf('Opera') > -1) {
        browser = 'Opera';
      }

      var param = {
        mapcode: 'setTodayVisitor',
        device: isMobile ? 'M' : 'P',
        browser: browser,
        ip: $window.sessionStorage['loginIP'],
      };
      postApi.home(param, function(res) {}, function(error) {});
    }

    checkCookie();

    vm.user.userGbn = 'C';
    vm.user.Tenant = 'logo_salevis';

    vm.doLogin = doLogin;
    vm.keyUp = keyUp;
    vm.searchUserInfo = searchUserInfo;
    vm.getTenant = getTenant;
    vm.chkUserInfo = chkUserInfo;
    vm.fnGetCookie = fnGetCookie;
    vm.fnSetCookie = fnSetCookie;
    vm.popupEliminate = popupEliminate;
    vm.onTenentCodeSelected = onTenentCodeSelected;

    // Add Mobile
    vm.doLogin_m = doLogin_m;

    function doLogin(forceLogin) {
      /*
       * if(vm.user.loginId == undefined || vm.user.loginId == "" ){
       * gAlert('', '아이디를 입력하세요.'); return; } if(vm.user.loginPw == undefined ||
       * vm.user.loginPw == "" ){ gAlert('', '비밀번호를 입력하세요.'); return; }
       */

      if (
        vm.user.loginId == undefined ||
        vm.user.loginId == '' ||
        vm.user.loginPw == undefined ||
        vm.user.loginPw == ''
      )
        return false;

      //console.log(vm.user);
      vm.user.forceLogin = forceLogin;

      vm.user.loginIP = $window.sessionStorage['loginIP'];

      var prms = loginApi.doLogin().post(vm.user).$promise;

      prms.then(
        function (data) {
          if (data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt > 0) {
              if (data.responseVO.body.docs[0].message == 'LOGIN.MSG.DUPLICATEACCESS') {
                gConfirm(
                  '',
                  $translate.instant('LOGIN.MSG.DUPLICATEACCESS'),
                  {
                    btn: '',
                    fn: function () {
                      vm.dataloader = false;
                      doLogin(true);
                    },
                  },
                  {
                    btn: '',
                    fn: function () {
                      vm.dataloader = false;
                    },
                  }
                );

                return;
              }
              // 사용자 구분이 교육원이 아닌 경우(userType != '020') 2차인증 모달 open
              // 허용 IP 수가 0인 경우 2차인증 모달 open
              // 로컬 테스트가 아닌 경우 2차인증 모달 open -> 주석처리
              if (
                data.responseVO.body.docs[0].userType != '020' &&
                data.responseVO.body.docs[0].userType != '000' &&
                data.responseVO.body.docs[0].loginId !== 'user1'
                //&& data.responseVO.body.docs[0].allowIpCount == '0'
              ) {
                // && document.location.host != 'localhost:8082') {
                showModalSecondAuthentication(data);
                return;
              }

              setUserSession(vm, data.responseVO.body.docs[0]);

              if (
                data.responseVO.body.docs[0].userType != '020' &&
                data.responseVO.body.docs[0].userType != '000' &&
                !checkPasswordUpdateDate(data.responseVO.body.docs[0].lastPWUpdateDate)
              ) {
                $state.go('updatepass');
              } else {
                $state.go('app.dashboard');
              }

              // 이메일, 전화번호 추가
              // $window.sessionStorage['loginUserEmail'] =
              // json.responseVO.body.docs[0].email;

              // $window.location.replace('/app/dashboard');
              // $state.reload("home");
              //$window.location.replace('/');
              // $state.go("app.dashboard");
            } else {
              gAlert('', 'Menu.INVALIEDIDPASSWORD');
            }
          } else {
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        },
        function (error) {
          gAlert('', error);
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    function showInfoImageModal(src) {
      var ctrl = 'ImageModalCtrl as modalCtrl';
      var paramData = {
        src : src,
      };

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/image-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {},
        function (cancelData) {}
      );
    }

    // 모달팝업 호출 (2차인증)
    function showModalSecondAuthentication(User) {
      var ctrl = 'SecondAuthenticationModalCtrl as modalCtrl';
      var paramData = User;

      var modalInstance = modalFactory.open(
        'modal',
        'components/login/modal/SecondAuthentication-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {},
        function (cancelData) {}
      );
    }

    function checkPasswordUpdateDate(lastPWUpdateDate) {
      var da1 = new Date(lastPWUpdateDate);
      var da2 = new Date();

      // alert(lastPWUpdateDate + ' | ' + da1 + " | " + da2 );

      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30; // 월 만듬
      var cYear = cMonth * 12; // 년 만듬

      // alert(dif/cMonth);

      if (dif / cMonth > 3) {
        return false;
      }

      return true;
    }
    /*
     * 2017.09.27 jhHan DR Description : Add mobile Function
     */
    function doLogin_m() {
      var prms = loginApi.doLogin().post(vm.user).$promise;

      prms.then(
        function (json) {
          if (json.responseVO.body.docCnt > 0) {
            setUserSession(vm, data.responseVO.body.docs[0]);
            $state.go('app.dashboard');
          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    function setUserSession(vm, json) {
      if (vm.user.saveId != undefined && vm.user.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
        $cookies.put('mySavedId', vm.user.loginId, { expires: cookieExp });
      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json);
    }

    function keyUp(event) {
      // console.log(event.keyCode);
      if (evenet.keyCode == 13) {
        alert('13');
        vm.doLogin();
      }
    }

    function searchUserInfo() {
      var ctrl = 'SrchUserModalCtrl as suc';
      var paramData = {};

      var modalInstance = modalWindow.open('modal', 'view/modal/srch-user-modal.html', ctrl, paramData);

      modalInstance.result.then(
        function (okData) {
          vm.rsvlists = okData.data;
        },
        function (cancelData) {}
      );
    }

    function getTenant() {
      var prms = loginApi.doGetTenant().post().$promise;

      prms.then(
        function (json) {
          if (json.responseVO && json.responseVO.body.docCnt > 0 && json.responseVO.body.docs != null) {
            vm.user.Tenant = json.responseVO.body.docs[0].TenantId;
            // console.log('TenantId=' + vm.user.Tenant);
          } else {
            vm.user.Tenant = 'logo_salevis';
          }
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    // 아이디/비밀번호 찾기 > 유효성검사
    function chkValid() {
      if (typeof vm.user.UserNm == 'undefined' || vm.data.UserNm == '') {
        gAlert('', '사용자명을 입력해주세요');
        return false;
      }
      if (typeof vm.user.Mobile == 'undefined' || vm.data.Mobile == '') {
        gAlert('', '휴대전화 번호를 입력해주세요');
        return false;
      }
      if (typeof vm.user.TenantId == 'undefined' || vm.data.Mobile == '') {
        gAlert('', '사업정보를 선택해주세요');
        return false;
      }

      return true;
    }

    // 아이디/비밀번호 찾기 > 사용자정보 체크
    function chkUserInfo() {
      if (!chkValid()) return false;

      var prms = loginApi.doCheckUserInfo().post(vm.user).$promise;

      prms.then(
        function (data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', data.responseVO.body.docs[0].message);
            /*
            if (data.responseVO.body.docs.length > 0) {
              if (data.responseVO.body.docs.length == 1 && data.responseVO.body.docs[0].UserId !== null) {
                vm.user.UserId = data.responseVO.body.docs[0].UserId;
                vm.user.LoginId = data.responseVO.body.docs[0].LoginId;
                setUserPass();
              } else {
                gAlert('', '일치하는 사용자가 2명 이상입니다.');
              }
            } else {
              gAlert('', '일치하는 사용자가 없습니다.');
            }*/
          } else {
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-chkUser', status, data);
        }
      );
    }

    /* 2024-01-25 보안취약점 개선 > 서버에서 바로 문자발송
    // 아이디/비밀번호 찾기 > 임시 비밀번호 저장 및 이메일 발송
    function setUserPass() {
      var prms = null;

      // vm.user.Password = generateRandom(10000, 99999) + '!Qa';
      // vm.user.FromEmail = 'support@softzion.com';
      vm.user.ToEmail = vm.user.Email;
      // vm.user.Title = '[국방전직교육원]아이디와 임시비밀번호가 발급되었습니다.';
      // vm.user.SendMessage =
      //   '[국방전직교육원]아이디와 임시비밀번호가 발급되었습니다.\n\r\n\r아이디: ' +
      //   vm.user.LoginId +
      //   '\n\r비밀번호: ' +
      //   vm.user.Password;
      vm.user.ToMobile = vm.user.Mobile;

      prms = loginApi.doUpdateUserPass().post(vm.user).$promise;
      prms.then(
        function (data) {
          console.log("data : ", data)
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            //setEmailLog();
            gAlert('', '입력한 휴대전화 번호로 아이디 및 임시비밀번호가 발송되었습니다.');
            $state.go('main.login');
          } else {
            //실패
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-setUserPass', status, data);
        }
      );
    }
    }*/

    // 이메일 로그에 저장
    /* function setEmailLog() {
        var prms = null;
        
        vm.data.FromEmail = "support@softzion.com";
        vm.data.ToEmail = vm.user.Email;
        vm.data.Title = "[국방전직교육원]아이디와 임시비밀번호가 발급되었습니다."
        vm.data.SendMessage = "[국방전직교육원]아이디와 임시비밀번호가 발급되었습니다.\n\r\n\r아이디: " + vm.user.LoginId + "\n\r비밀번호: " + vm.user.Password;
        
        prms = api.doUpdateUserPass().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '입력한 이메일주소로 아이디 및 임시비밀번호가 발송되었습니다.');
          }
        }, function(error) {
          console.error('Error-setEmailLog', status, data);
        });
      }*/

    getTenant();

    function getTenantList() {
      // gAlert('','6.14일부로 모든 패스워드가 초기화 되었습니다. 반드시 아이디/비밀번호 찾기를 통해 임시패스워드를 부여 받으시기 바랍니다.');
      var prms = loginApi.doGetTenantList().post().$promise;

      prms.then(
        function (json) {
          if (json.responseVO && json.responseVO.body.docCnt > 0 && json.responseVO.body.docs != null) {
            vm.tenantList = json.responseVO.body.docs;
            // console.log('tenantList=' + vm.tenantList);
          } else {
            vm.tenantList = [];
          }
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }
    getTenantList();

    function onTenentCodeSelected() {
      vm.user.TenantId = vm.user.TCode.TenantId;
    }

    function fnGetCookie(name) {
      var cookieNm = name + '=';
      var x = 0;
      while (x <= document.cookie.length) {
        var y = x + nameOfCookie.length;
        if (document.cookie.substring(x, y) == nameOfCookie) {
          if ((endOfCookie = document.cookie.indexOf(';', y)) == -1) endOfCookie = document.cookie.length;
          return unescape(document.cookie.substring(y, endOfCookie));
        }
        x = document.cookie.indexOf(' ', x) + 1;
        if (x == 0) break;
      }
      return '';
    }
  }

  function fnSetCookie(name, value, expire) {
    var today = new Date();
    today.setDate(today.getDate() + expire);
    document.cookie = name + '=' + escape(value) + '; path=/; expires=' + today.toUTCString() + ';';
  }

  function popupEliminate() {
    if ($("input:checkbox[id='chkNoMore']").is(':checked')) {
      setCookie('Anounce_2020-12-17_01', 'NOMORE', 1);
    }
    $('#anounceModal').hide();
  }

  webapp.component('login', {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: 'login',
    templateUrl: 'components/login/login.html',
  });

  webapp.component('forgotpass', {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: 'login',
    templateUrl: 'components/login/forgotpass.html',
  });

})();

(function() {
  "use strict";
  LogoutController.$inject = ['$window', '$state', 'StaticVariable', 'LoginAPISrv', 'gAlert'];

  /** @ngInject */
  function LogoutController($window, $state, StaticVariable, loginApi, gAlert) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    vm.doLogout = doLogout;

    function doLogout() {
      StaticVariable.sessionExpire();
      var prms = loginApi.doLogout().post().$promise;
      prms.then(function(json) {
        var temp = {};
        temp.layoutBoard = "N";
        $window.sessionStorage.clear();
        $window.localStorage.clear();
        $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
        gAlert('', 'Menu.SIGNEDOUT', {
          btn : '',
          fn : function() {
            //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
            //$state.reload('main.login');
            if(M.app.check()) {
              $window.localStorage['userAuthKey'] = "";
              M.data.setStorage("loginUser", "");
              M.data.setStorage("userkey", "");
            }
            $state.go('login');
          }
        });
      }, function(error) {
        console.log("error");
        // console.error('fail', status);
      });
    }

    doLogout();

  }

  webapp.component("logout", {
    transclude: true,
    bindings: {},
    controller: LogoutController,
  });
})();

(function() {
    "use strict";
    SignupFirstController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm', '$window', '$translate', '$stateParams', 'customFieldApi','postApi', 'fileUploadService', '$timeout'];
  
    /** @ngInject */
    function SignupFirstController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, StaticVariable, gAlert, gConfirm, $window, $translate, $stateParams, customFieldApi, postApi, fileUploadService, $timeout) {
      var vm = this;
      vm.data = {};

      vm.signUp = function (data) { 
          if (data =='N') {
            if(vm.data.agreeYN == 'Y') {
              $state.go("signupSecond");
            } else {
              alert("회원가입을 위해 약관에 동의해주세요.");
            }
          } else if (data =='C'){
            $state.go("login");
          }
      };

    }
    

    webapp.component("signupFirst", {
      transclude: true,
      bindings: {},
      controller: SignupFirstController,
      controllerAs: "vc",
      templateUrl: "components/login/signup-first-step.html"
    });
  })();
  
(function() {
  "use strict";
  SignupSecondController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm', '$window', '$translate', '$stateParams', 'customFieldApi','postApi', 'fileUploadService', '$timeout'];

  /** @ngInject */
  function SignupSecondController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, StaticVariable, gAlert, gConfirm, $window, $translate, $stateParams, customFieldApi, postApi, fileUploadService, $timeout) {
    var vm = this;
    vm.data = {};
    vm.srch = decodeURIComponent($stateParams.srch);
    vm.TenantType = vm.srch;
    vm.loginIdDisYN = 'N';
    vm.etcList = [];
    vm.interestList = [];
    vm.industCodeList = [];
    vm.recommenderCodeList = [];

    //#region 첨부파일
    //첨부파일 확장성을 위해 그대로 가져옴
    vm.attach = {
      BizReg:{label:'사업자등록증', grpId: 1, id:'BizReg', size:0, delState:''},
      // OperationPlan:{label:'운영계획서', grpId: 2, id:'OperationPlan', size:0, delState:''},
      // CorporateOrg:{label:'법인(단체)현황및조직도', grpId: 3, id:'CorporateOrg', size:0, delState:''},
      // BizReg:{label:'사업자등록증', grpId: 4, id:'BizReg', size:0, delState:''},
    };

    // 파일 업로드창 
    vm.openAttachDilalog = function(target) {
      var elementNm = "#" + target;
      var fileElement = angular.element(elementNm);
      fileElement.trigger("click");
      
      fileElement.bind('change', function(){
        var reader = new FileReader();
        reader.onload = function (e) { vm.data[target] = e.target.result; };
        vm.data[target] = $(fileElement).val();
        vm.onChangeHandler(fileElement[0].files, target);
      });
    };

    // 파일 삭제
    vm.onDelete = function(target) {
      gConfirm('w', '삭제하시겠습니까?', {
        btn : '',
        fn : function() {
          if (!vm.attach[target].tmpFileKey) {
            var data = angular.copy(vm.srch);
            data.path = vm.attach[target].path;
            data.fileKey = vm.attach[target].fileKey;
            data.mapCode = 'deleteTenantAttachment';
            postApi.login(data, function(result){
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                gAlert('','삭제되었습니다.', {
                  btn : '',
                  fn : function() {
                    resetAttachment(target);          
                  }
                });
              } else {
                gAlert('','삭제되지 않았습니다.');
              }
            }, function(error) {
              console.log("error");
              // console.error('fail', status, data);
            });
    
            return;
          }
          resetAttachment(target);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    };

    function resetAttachment(target) {
      vm.attach[target].fileName = '';
      vm.attach[target].isLoaded = false;
      vm.attach[target].size = 0;
      vm.attach[target].link = '';
      vm.attach[target].tmpFileKey = null;
      vm.attach[target].delState = '';
      $('#filectl_' + target + ' .progress .progress-bar').css('width', '0%');
    }

    /**
     * 첨부파일 업로드
     *
     * @param {object}
     *          files - 첨부 파일
     * @return
     */
    vm.onChangeHandler = function(files, target) {
      var tempIds = [];

      // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
      $scope.$root.safeApply(function() {
        resetAttachment(target);
        vm.attach[target].fileName = files[0].name;
        vm.attach[target].size = files[0].size;
        var request = fileUploadService.post(files, null, function(percent) {
          // -- 진행율 표시
          $('#filectl_' + target + ' .progress .progress-bar').css('width', percent + '%');

          if (percent == 100) {
            vm.showLoading = true;
          }
        });

        try {
          request.to(StaticVariable.getUrl('/openapi/attach/temp/upload.do')).then(function(value) {
            angular.forEach(value.data.responseVO.body.docs, function(item) {
              if (item.fileName == vm.attach[target].fileName && item.size == vm.attach[target].size) {
                vm.attach[target].isLoaded = true;
                vm.attach[target].tmpFileKey = item.tmpFileKey;
                vm.attach[target].typeId = item.typeId;
                vm.attach[target].path = item.path;
                vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/temp/" + item.tmpFileKey + "/download.do?&fileName=" + item.encFileName);
                vm.attach[target].delState = '';
              }
            });

            // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
            angular.element('#' + target).val(null);

            vm.showLoading = false;
          }, function(error) {
            console.log("error");
            // console.error('Error> signup-second-step-ctrl> uploadFiles()', status, error);
          });
        } catch (error) {
          console.log("error");
          // console.error('Error> signup-second-step-ctrl> uploadFiles()', status, error);
        }
      });
    };
    //#endregion

    //#region srchZipCodeModal 우편번호 검색 팝업 호출
    /**
    * 우편번호 검색 팝업 호출
    *
    * @param {string}
    * @return {boolean}
    */
    vm.srchZipCodeModal = function() {
      new daum.Postcode({
        oncomplete: function(data) {
          $timeout(function(){
            vm.data.ZipCode = data.zonecode;
            var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
            vm.data.Addr1 = addr1;
          }, 0);
        },
      }).open();
    };
    //#endregion

    //#region signUpTenant 가입신청 및 취소 버튼 클릭
    /**
     *  가입신청 및 취소 버튼 클릭
     *
     * @param 
     * @return
     */
     vm.signUpTenant = function (data) { 
      if(data == 'C') {
        $state.go("login");
      } else {
        getIsValidData();
      }
    };
    //#endregion

    //#region chkLoginIdDup 아이디중복 체크
    /**
     * 아이디 중복체크
     *
     * @param
     * @return
     */
    function chkLoginIdDup() {
      var data = angular.copy(vm.data);
      data.mapCode = 'getLoginIdDup';

      $("#loginid").css("display", "block");
      if(isNullOrEmpty(vm.data.LoginId)) {
        $("#loginid").css("display", "none");
        return false;
      } else if (!chkPassId('ID')) {
        $("#loginid").removeClass("pass");
        $("#loginid").addClass("not_pass");
        $("#loginid i").removeClass("glyphicon-ok");
        $("#loginid i").addClass("glyphicon-remove");
        $("#loginidTx").text("사용할 수 없는 아이디입니다.");
        return false;
      } else {
        postApi.login(data, function(result){
          if(result.body.docs[0].DupCnt > 0) {
            $("#loginid").removeClass("pass");
            $("#loginid").addClass("not_pass");
            $("#loginid i").removeClass("glyphicon-ok");
            $("#loginid i").addClass("glyphicon-remove");    
            $("#loginidTx").text("이미 사용중인 아이디입니다.");
            return false;
          } else {
            $("#loginidTx").text("사용 가능한 아이디입니다.");
            $("#loginid").removeClass("not_pass");
            $("#loginid").addClass("pass");
            $("#loginid i").removeClass("glyphicon-remove");
            $("#loginid i").addClass("glyphicon-ok");
            vm.loginIdDisYN = 'Y';
          }
        });
      }
    }
    //#endregion
    
    //#region chkPassId 아이디/비밀번호 체크
    /**
     * 아이디/비밀번호 체크
     *
     * @param str 'ID' or 'PWD'
     * @return
     */
     function chkPassId(str) {
      if(str == 'PWD') {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;
      
      } else if (str == 'ID') {      
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
        
        // var reg1 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
        
        // if(reg1.test(vm.data.LoginId)) return false;
        // if(vm.data.LoginId.length < 4) return false;
        
        // return true;
      }
    }
    //#endregion chkPassId 아이디/비밀번호 체크

    //#region getIndustCodeList 업종 목록 조회
    /**
     * 업종 목록 조회
     *
     * @param 
     * @return
     */
    function getIndustCodeList() {
      vm.industCodeList = [];
      var data = {};
      data.mapCode = 'getIndustCodeList';
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.industCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.industCodeList = {};
        }
      });
    }
    //#endregion

    //#region getIndustCodeList 업종 목록 조회
    /**
     * 가입경로 목록 조회
     *
     * @param 
     * @return
     */
     function recommenderCodeList() {
      vm.recommenderCodeList = [];
      var data = {};
      data.mapCode = 'getRecommenderCodeList';
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.recommenderCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.industCrecommenderCodeListodeList = {};
        }
      });
     }

    //#region SetData 데이터 저장
    /**
     *  데이터 저장
     *
     * @param 
     * @return
     */
    function saveData() {
      var data = angular.copy(vm.data);
      
      data.mapCode = 'insertTenant';
      data.tableNm = 'tenant';
      
      data.TenantStatus = 'R';
      data.MenuTypeList = [{codeValue : '기본메뉴', code: 'DEFAULTMENU'},{codeValue : '회원사메뉴', code: 'TENANTMENU'}];
      data.MainPage = 'app.dashboard';

      data.CorpNm = data.TenantNm;

      data.uploadFileList = [];
      angular.forEach(vm.attach, function(item) {
        if (item.isLoaded) {
          data.uploadFileList.push(item);
        }
      });

      if (data.uploadFileList.length == 0){
        gAlert('', '- 사업자등록증을 첨부해주세요.');
        return false;
      }
      
      postApi.login(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('','승인요청되었습니다. <br>관리자 승인 후에 이용 가능합니다.', {
            btn : '',
            fn : function() {
              $state.go('login');
            }
          });
        }
      }, function(error) {
        console.log("error");
        // console.error('fail', status, data);
      });
    }
    //#endregion

    //#region Validation Check
    /**
     *  Validation Check
     *
     * @param 
     * @return
     */
    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = '';
      
      // 로그인 정보 Validation Check
      if(isNullOrEmpty(data.LoginId)) {
        errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
      }
      if(vm.loginIdDisYN == 'N') {
        errMsg = errMsg + '- 아이디 중복확인을 해주세요.<br/>';
      }
      if(isNullOrEmpty(data.Password)) {
        errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
      }
      if(data.Password != data.Password2) {
        errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
      }
      if (!isNullOrEmpty(data.Password)){
        if (!chkPassId('PWD'))
        errMsg = errMsg + '- 비밀번호 형식을 확인해주세요.<br/>';
      }
      if(isNullOrEmpty(data.UserNm)) {
        errMsg = errMsg + '- 사용자명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.UserMobile)) {
        errMsg = errMsg + '- 휴대폰번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.UserEmail)) {
        errMsg = errMsg + '- 사용자 이메일을 입력하세요.<br/>';
      } else if (!isValidEmail(data.UserEmail)) {
        errMsg = errMsg + '- 사용자 이메일을 확인하세요.<br/>';
      }

      // 회원사 정보 Validation Check
      if(isNullOrEmpty(data.TenantNm)) {
        errMsg = errMsg + '- 볍인명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.BizRegNo)) {
        errMsg = errMsg + '- 사업자번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Ceo)) {
        errMsg = errMsg + '- 대표자명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Contact)) {
        errMsg = errMsg + '- 담당자명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.TenantEmail)) {
        errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
      } else if (!isValidEmail(data.TenantEmail)) {
        errMsg = errMsg + '- 대표 이메일을 확인하세요.<br/>';
      }
      if(isNullOrEmpty(data.TelNo)) {
        errMsg = errMsg + '- 대표 전화번호를 입력하세요.<br/>';
      }
      if (isNullOrEmpty(data.indust_code)) {
        errMsg = errMsg + '- 업종을 입력하십시오.<br/>';     
      } else {
        vm.data.IndustCode = vm.data.indust_code;
      }
      if(isNullOrEmpty(data.BizCondCode)) {
        errMsg = errMsg + '- 업태를 입력하세요.<br/>';
      }

      if(isNullOrEmpty(data.ZipCode) || isNullOrEmpty(data.Addr1) || isNullOrEmpty(data.Addr2)) {
        errMsg = errMsg + '- 주소를 입력하세요.<br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      saveData();
      
    }
    //#endregion

    getIndustCodeList();
    recommenderCodeList();
    vm.chkLoginIdDup = chkLoginIdDup;
  }

  webapp.component("signupSecond", {
    transclude: true,
    bindings: {},
    controller: SignupSecondController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-second-step.html"
  });
  
})();



(function() {
  "use strict";
  SignupStepOneController.$inject = ['$state', 'gAlert', 'postApi'];

  /** @ngInject */
  function SignupStepOneController($state, gAlert, postApi) {
    var vm = this;
    
    vm.data = {};
    vm.goCancel = goCancel;    
    vm.saveData = saveData;    

    function goCancel() {
      $state.go("login");
    }

    // 필수값 체크
    function getIsValidData(type) {
      var data = vm.data;
      data.type = type;

      if(isNullOrEmpty(data.TenantNm)) {
        gAlert('','센터명을 입력해주세요.');
        return false;
      } else {
        data.TenantNm = data.TenantNm.replace(/(\s*)/g, "");
      }

      if(isNullOrEmpty(data.BizRegNo)) {
        gAlert('','사업자번호를 입력해주세요.');
        return false;
      } else{
        // 사업자번호 유효성 체크
        // bizID는 숫자만 10자리로 해서 문자열로 넘긴다. 
        var bizID = data.BizRegNo;
        var checkID = new Array(1, 3, 7, 1, 3, 7, 1, 3, 5, 1); 
        var i, iResult=0, c2;
        
        bizID = bizID.replace(/-/gi,''); 
      
        for (i=0; i<=8; i++) {
          iResult += checkID[i] * bizID.charAt(i); 
        } 

        c2 = (checkID[8] * bizID.charAt(8)) %10; 
        iResult = iResult + (checkID[8] * bizID.charAt(8) - c2) /10;
        iResult = iResult % 10;
        iResult = 10 - iResult;
        
        if (iResult == 10) {
          iResult = 0;
        }

        if (Math.floor(bizID.charAt(9)) != iResult) {
          gAlert('', '사업자등록번호를 정확히 입력해주세요.');
          return false ; 
        } else {
          chkBizDup();
        }
      }
      return true;
    }

    function chkBizDup() {
      // 사업자번호 중복체크
      var data = angular.copy(vm.data);
      postApi.openApi('getTenantBizRegNoDupChk', data, function(result){
        if (result.body.docs.length > 0) {
          var bizData = result.body.docs[0];
          if (data.type != null && data.type == 'R') {
            gAlert('', '이미 등록된 사업자번호 입니다.');
            return false ; 
          } else if (bizData.TenantStatus == 'Y') {
            gAlert('', '이미 승인된 사업자번호 입니다.');
            return false ; 
          } else {
            data.TenantId = bizData.TenantId;
            $state.go("signup2", {srch:encodeURIComponent(JSON.stringify(data, replacer))});
          }
        } else {
          if (data.type != null && data.type == 'E') {
            gAlert('', '조회결과가 없습니다.<br>정확한 기관명과 사업자번호를 입력해주세요.');
            return false ; 
          } else {
            $state.go("signup2", {srch:encodeURIComponent(JSON.stringify(data, replacer))});
          }
        }
      });
    }

    function saveData(type) {
      getIsValidData(type)
    }
  }

  webapp.component("signupStepOne", {
    transclude: true,
    bindings: {},
    controller: SignupStepOneController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-step-one.html"
  });
})();

(function() {
  "use strict";
  SignupStepTwoController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm', '$window', '$translate', '$stateParams', 'customFieldApi','postApi', 'fileUploadService', '$timeout'];

  /** @ngInject */
  function SignupStepTwoController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, StaticVariable, gAlert, gConfirm, $window, $translate, $stateParams, customFieldApi, postApi, fileUploadService, $timeout) {
    var vm = this;
    vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

    // 이메일 목록
    vm.EmailList = [{TypeNm : '네이버', TypeId : 'naver.com'}, {TypeNm : '다음', TypeId : 'daum.net'}, {TypeNm : '직접입력', TypeId : ''}];

    vm.data = {}

    // 첨부파일 항목
    vm.attach = {
      ApplicationForm:{label:'지원신청서', grpId: 1, id:'ApplicationForm', size:0, delState:''},
      OperationPlan:{label:'운영계획서', grpId: 2, id:'OperationPlan', size:0, delState:''},
      CorporateOrg:{label:'법인(단체)현황및조직도', grpId: 3, id:'CorporateOrg', size:0, delState:''},
      BizReg:{label:'사업자등록증', grpId: 4, id:'BizReg', size:0, delState:''},
      EduCert:{label:'교육이수증1', grpId: 5, id:'EduCert', size:0, delState:''},
      EduCert2:{label:'교육이수증2', grpId: 6, id:'EduCert2', size:0, delState:''},
      Contract:{label:'약정서', grpId: 7, id:'Contract', size:0, delState:''},
      PerformanceBond:{label:'이행보증보험', grpId: 8, id:'PerformanceBond', size:0, delState:''},    
      OtherDoc:{label:'기타서류', grpId: 9, id:'OtherDoc', size:0, delState:''}};

    // 지역 코드
    vm.LocationData = {
      CallbackTarget : '0000',
      CodeType : 'LOCATION',
      Code : vm.data.Location,
      ReloadSeq : 1
    };
  

    // 사업명 코드
    vm.yearList = {
      CallbackTarget : '1000',
      CodeType : 'SEARCH_YEAR',
      Code : vm.data.BusinessYear,
      ReloadSeq : 2
    };
  

    // 운영형태 코드
    vm.OperFormData = {
      CallbackTarget : '2000',
      CodeType : 'OPER_FROM',
      Code : vm.data.OperationForm,
      ReloadSeq : 3
    };

    // 운영규모 코드
    vm.OperScaleData = {
      CallbackTarget : '3000',
      CodeType : 'OPERSCALE',
      Code : vm.data.OperationScale,
      ReloadSeq : 4
    };

    vm.onSelectCallback = function (data) {
      if (data.CallbackTarget == '0000') {
        vm.data.Location = data.Code;
      }
      if (data.CallbackTarget == '1000') {
        vm.data.BusinessYear = data.Code;
        getProjectList();
      }
      if (data.CallbackTarget == '2000') {
        vm.data.OperationForm = data.Code;
      }
      if (data.CallbackTarget == '3000') {
        vm.data.OperationScale = data.Code;
      }
    };

    // 함수 정의
    vm.getIsValidData = getIsValidData;
    vm.chkLoginIdDup = chkLoginIdDup;
    vm.loginIdDisYN = 'N';
    vm.goBack = goBack;

    function getProjectList() {
      var data = angular.copy(vm.data);
      data.PrmYear = vm.data.BusinessYear;
      data.PrmType = '200';
      data.mapCode = 'getProjectManageCodeList';

      postApi.login(data, function(result) {
        if(result.body.docs.length > 0) {
          vm.projectList = result.body.docs;
        }
      });
    }

    /**
      * 우편번호 검색 팝업 호출
      *
      * @param {string}
      * @return {boolean}
    */
    vm.srchZipCodeModal = function() {
      new daum.Postcode({
        oncomplete: function(data) {
          $timeout(function(){
            vm.data.ZipCode = data.zonecode;
            var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
            vm.data.Addr1 = addr1;
          }, 0);
        },
      }).open();
    };

    // 파일 업로드창 
    vm.openAttachDilalog = function(target) {
      var elementNm = "#" + target;
      var fileElement = angular.element(elementNm);
      fileElement.trigger("click");
      
      fileElement.bind('change', function(){
        var reader = new FileReader();
        reader.onload = function (e) { vm.data[target] = e.target.result; };
        vm.data[target] = $(fileElement).val();
        vm.onChangeHandler(fileElement[0].files, target);
      });
    };

    // 파일 삭제
    vm.onDelete = function(target) {
      gConfirm('w', '삭제하시겠습니까?', {
        btn : '',
        fn : function() {
          if (!vm.attach[target].tmpFileKey) {
            var data = angular.copy(vm.srch);
            data.path = vm.attach[target].path;
            data.fileKey = vm.attach[target].fileKey;
            data.mapCode = 'deleteTenantAttachment';
            postApi.login(data, function(result){
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                gAlert('','삭제되었습니다.', {
                  btn : '',
                  fn : function() {
                    resetAttachment(target);          
                  }
                });
              } else {
                gAlert('','삭제되지 않았습니다.');
              }
            }, function(error) {
              console.log("error");
              // console.error('fail', status, data);
            });
    
            return;
          }
          resetAttachment(target);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    };

    function resetAttachment(target) {
      vm.attach[target].fileName = '';
      vm.attach[target].isLoaded = false;
      vm.attach[target].size = 0;
      vm.attach[target].link = '';
      vm.attach[target].tmpFileKey = null;
      vm.attach[target].delState = '';
      $('#filectl_' + target + ' .progress .progress-bar').css('width', '0%');
    }

    /**
     * 첨부파일 업로드
     *
     * @param {object}
     *          files - 첨부 파일
     * @return
     */
    vm.onChangeHandler = function(files, target) {
      var tempIds = [];

      // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
      $scope.$root.safeApply(function() {
        resetAttachment(target);
        vm.attach[target].fileName = files[0].name;
        vm.attach[target].size = files[0].size;
        var request = fileUploadService.post(files, null, function(percent) {
          // -- 진행율 표시
          $('#filectl_' + target + ' .progress .progress-bar').css('width', percent + '%');

          if (percent == 100) {
            vm.showLoading = true;
          }
        });

        try {
          request.to(StaticVariable.getUrl('/openapi/attach/temp/upload.do')).then(function(value) {
            angular.forEach(value.data.responseVO.body.docs, function(item) {
              if (item.fileName == vm.attach[target].fileName && item.size == vm.attach[target].size) {
                vm.attach[target].isLoaded = true;
                vm.attach[target].tmpFileKey = item.tmpFileKey;
                vm.attach[target].typeId = item.typeId;
                vm.attach[target].path = item.path;
                vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/temp/" + item.tmpFileKey + "/download.do?&fileName=" + item.encFileName);
                vm.attach[target].delState = '';
              }
            });

            // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
            angular.element('#' + target).val(null);

            vm.showLoading = false;
          }, function(error) {
            console.log("error");
            // console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
          });
        } catch (error) {
          console.log("error");
          // console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
        }
      });
    };


    // 데이터 조회
    function getData() {
      var data = angular.copy(vm.srch);
      data.mapCode = 'getSignupTenant';
      data.tableNm = 'tenant';
      data.IdName = 'KeyId';
      data.TenantId = vm.srch.TenantId;
      data.uploadFileList = [];
      postApi.login(data, function(result) {
        if (result.body.docs.length > 0) {
          vm.data = result.body.docs[0];
          getProjectList();
          vm.data.Email1 = vm.data.Email.split('@')[0];
          vm.data.Email2 = vm.data.Email.split('@')[1];
          vm.LocationData.Code = vm.data.Location;
          vm.yearList.Code = vm.data.BusinessYear;
          vm.OperFormData.Code = vm.data.OperationForm;
          vm.OperScaleData.Code = vm.data.OperationScale;
          vm.ConsignDate = moment(vm.data.ConsignDate).toDate();
          if (vm.data.uploadFileList) {
            angular.forEach(vm.data.uploadFileList, function(item) {
              var target = Object.keys(vm.attach)[item.GrpId - 1];
              vm.attach[target].isLoaded = true;
              vm.attach[target].fileName = item.LogicalFileNm;
              vm.attach[target].size = item.FileSize;
              vm.attach[target].path = item.PhysicalPath;
              vm.attach[target].fileKey = item.PhysicalFileNm;
              vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
              vm.attach[target].delState = '';
            });
          }
        } else {
          vm.data = {
            type : vm.srch.type,
            TenantNm : vm.srch.TenantNm,
            BizRegNo : vm.srch.BizRegNo
          };
        }
      });

    }

    // 아이디 중복 체크
    function chkLoginIdDup() {
      var data = angular.copy(vm.data);
      data.mapCode = 'getLoginIdDup';

      postApi.login(data, function(result){
        if(result.body.docs[0].DupCnt > 0) {
          gAlert('','이미 사용중인 아이디입니다.');
          return false;
        } else {
          gAlert('','사용 가능한 아이디입니다.');
          vm.loginIdDisYN = 'Y';
        }
      });
    }

    vm.downloadTemp = function(target) {
      if(!isNullOrEmpty(vm.attach[target].link)) {
        window.open(vm.attach[target].link);
      }
    };


    // 데이터 저장
    function saveData() {
      var data = angular.copy(vm.data);
      data.ConsignDate = $filter('localToUtc')(vm.data.ConsignDate);
      data.uploadFileList = [];
      data.ReqURL = 'app.company.company-detail';
      
      angular.forEach(vm.attach, function(item) {
        if (item.isLoaded) {
          data.uploadFileList.push(item);
        }
      });
      data.tableNm = 'tenant';
      data.MenuTypeList = [{codeValue : '기관', code: 'TENANTMENU'}];
      data.TenantStatus = 'R';
      data.RelateDataId = data.KeyId;
      data.MainPage = 'app.dashboard';

      if(data.KeyId != null && data.KeyId != "") {
        data.mapCode = 'updateSignupTenant';
      } else {
        data.mapCode = 'insertTenant';
      }

      postApi.login(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('','승인요청되었습니다. <br>회원가입 -> 정보 입력 -> 조회 버튼으로 내용 확인 가능합니다.', {
            btn : '',
            fn : function() {
              $state.go('login');
            }
          });
        }
      }, function(error) {
        console.log("error");
        // console.error('fail', status, data);
      });
    }
    
    // 필수값 체크
    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = '';
      
      if(isNullOrEmpty(data.TenantNm)) {
        errMsg = errMsg + '- 센터명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Ceo)) {
        errMsg = errMsg + '- 대표자를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.BizRegNo)) {
        errMsg = errMsg + '- 사업자번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.TelNo)) {
        errMsg = errMsg + '- 대표번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.ZipCode) || isNullOrEmpty(data.Addr1) || isNullOrEmpty(data.Addr2)) {
        errMsg = errMsg + '- 주소를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Location)) {
        errMsg = errMsg + '- 지역을 선택하세요.<br/>';
      }
      if(isNullOrEmpty(data.Email1) || isNullOrEmpty(data.Email2)) {
        errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
      } else {
        vm.data.Email = data.Email1 + '@' + data.Email2;
      }
      if(isNullOrEmpty(data.LoginId)) {
        errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
      }
      if(vm.loginIdDisYN == 'N') {
        errMsg = errMsg + '- 아이디 중복확인을 해주세요.<br/>';
      }
      if(isNullOrEmpty(data.Password)) {
        errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
      }
      if(data.Password != data.Password2) {
        errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
      }
      if(isNullOrEmpty(data.BusinessYear)) {
        errMsg = errMsg + '- 사업명을 선택하세요.<br/>';
      }
      if(isNullOrEmpty(data.PrmId)) {
        errMsg = errMsg + '- 사업명을 선택하세요.<br/>';
      }
      if(isNullOrEmpty(data.OperationForm)) {
        errMsg = errMsg + '- 운영형태를 선택하세요.<br/>';
      }
      if(isNullOrEmpty(data.OperationScale)) {
        errMsg = errMsg + '- 운영규모를 선택하세요.<br/>';
      }
      if(isNullOrEmpty(data.ConsignDate)) {
        errMsg = errMsg + '- 위탁일을 입력하세요.<br/>';
      } else{
        vm.data.ConsignDate = moment(data.ConsignDate).format('YYYY-MM-DD');
      }
      if(isNullOrEmpty(data.ContactTelNo)) {
        errMsg = errMsg + '- 담당자 전화번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Contact)) {
        errMsg = errMsg + '- 담당자를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.ContactMobile)) {
        errMsg = errMsg + '- 담당자 휴대전화를 입력하세요.<br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      chkFileList();
    }

    function chkFileList() {
      var chkMsg = '';
      angular.forEach(vm.attach, function(item) {
        if(item.size == 0) {
          chkMsg = chkMsg + item.label + ' 서류가 등록되지 않았습니다.<br/> '
        }
      });

      if(!isNullOrEmpty(chkMsg)) {
        chkMsg = chkMsg + '이대로 진행하시겠습니까?';
        gConfirm('',chkMsg, {
          btn : '',
          fn : function() {
            saveData();
          }
        }, {
          btn: '',
          fn: function () {
            return false;
          }
        })
      } else {
        saveData();
      }
    }

    // 뒤로가기
    function goBack() {
      $state.go('signup');
    }

    getData();
  }

  webapp.component("signupStepTwo", {
    transclude: true,
    bindings: {},
    controller: SignupStepTwoController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-step-two.html"
  });

})();

(function() {
    "use strict";
    SignupController.$inject = ['$state', '$rootScope', '$window'];
  
    /** @ngInject */
    function SignupController($state, $rootScope, $window) {
      var vm = this;
      vm.data = {};
      
      vm.signUpTenant = function (data) {
        $state.go("signupFirst", {srch:encodeURIComponent(data)});
      };

      // 로그인 헤더 버튼 설정
      $window.sessionStorage['loginTitle'] = '로그인';
      $window.sessionStorage['loginUrl'] = 'login';
    }

    webapp.component("signupTenant", {
      transclude: true,
      bindings: {},
      controller: SignupController,
      controllerAs: "vc",
      templateUrl: "components/login/signup.html"
    });
  })();
  
(function () {
  'use strict';
  updatePassCtrl.$inject = [
    '$window',
    '$rootScope',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'modalFactory',
    'LoginAPISrv',
    'gAlert',
    'gConfirm',
    'postApi',
  ];

  function updatePassCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalWindow,
    loginApi,
    gAlert,
    gConfirm,
    postApi
  ) {
    var vm = this;

    // 접근 권한 체크
    //if (!isPageAccess("user-edit", $window.sessionStorage['loginUserType'])) $state.go("app.dashboard");

    // 함수 선언

    vm.doCheckSession = doCheckSession;
    vm.chkUserInfo = chkUserInfo;

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post().$promise;

      prms.then(
        function (json) {
          if (
            json.responseVO.header.status == CONSTANT.HttpStatus.OK &&
            json.responseVO.body.docs != null &&
            json.responseVO.body.docs != ''
          ) {
            console.log('Login user');
            $rootScope.setUserSession(json.responseVO.body.docs[0]);
          } else {
            StaticVariable.sessionExpire();
          }
          // gAlert("로그아웃 되었습니다.");
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    doCheckSession();

    // 비밀번호 변경 > 유효성검사
    function chkValid() {
      if (typeof vm.user.oldPass == 'undefined' || vm.user.oldPass == '') {
        gAlert('', '현재 비밀번호을 입력해주세요');
        return false;
      }
      if (typeof vm.user.newPass == 'undefined' || vm.user.newPass == '') {
        gAlert('', '변경 비밀번호를 입력해주세요');
        return false;
      }
      if (vm.user.newPass.length < 8) {
        gAlert('', '비밀번호는 최소 8자리 이상으로 입력해주세요.');
        return false;
      }
      if (vm.user.newPass == vm.user.oldPass) {
        gAlert('', '변경비밀번호가 현재비밀번호와 일치 합니다.');
        return false;
      }
      if (
        $window.sessionStorage['loginUserType'] != '020' &&
        !checkPassword(vm.user.newPass, $window.sessionStorage['loginUserId'])
      ) {
        //gAlert('', '비밀번호가 일치하지 않습니다.');
        return false;
      }
      if (typeof vm.user.newPass2 == 'undefined' || vm.user.newPass2 == '') {
        gAlert('', '변경 비밀번호 확인을 입력해주세요');
        return false;
      }
      if (vm.user.newPass != vm.user.newPass2) {
        gAlert('', '비밀번호가 일치하지 않습니다.');
        return false;
      }

      return true;
    }

    function checkPassword(password, id) {
      if (
        !/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/.test(password)
      ) {
        gAlert(
          '',
          '숫자+영문자+특수문자 조합으로 8자리 이상 16자리 이하로 사용해야 합니다.'
        );
        return false;
      }
      var checkNumber = password.search(/[0-9]/g);
      var checkEnglish = password.search(/[a-z]/gi);
      if (checkNumber < 0 || checkEnglish < 0) {
        gAlert('', '숫자와 영문자를 혼용하여야 합니다.');
        return false;
      }
      if (/(\w)\1\1/.test(password)) {
        gAlert('', '같은 문자를 3번 이상 사용하실 수 없습니다.');
        return false;
      }
      /*
          if(password.search(id) > -1){
              alert("비밀번호에 아이디가 포함되었습니다.");
              //$('#password').val('').focus();
              return false;
          }*/
      return true;
    }

    // 비밀번호 변경 > 사용자정보 체크
    function chkUserInfo() {
      if (!chkValid()) return false;

      vm.user.LoginId = $window.sessionStorage['loginUserId'];

      postApi.login(
        'regularUpdateUserPass',
        vm.user,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '비밀번호가 변경되었습니다.', {
              fn: function () {
                $state.go('app.dashboard');
              },
            });
          } else {
            gAlert('', data.body.docs[0].errMessage);
            return;
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-chkUserInfo' + data.body.docs[0].errMessage);
        }
      );

      /* var prms = loginApi.doCheckUserInfoForUpdatePass().post(vm.user).$promise;

      prms.then(
        function (data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs.length > 0) {
              if (
                data.responseVO.body.docs.length == 1 &&
                data.responseVO.body.docs[0].UserId !== null
              ) {
                vm.user.UserId = data.responseVO.body.docs[0].UserId;
                vm.user.LoginId = data.responseVO.body.docs[0].LoginId;
                setUserPass();
              } else {
                gAlert('', '일치하는 사용자가 2명 이상입니다.');
              }
            } else {
              gAlert('', '일치하는 사용자가 없습니다.');
            }
          } else {
            gAlert('', '일치하는 사용자가 없습니다.');
          }
        },
        function (error) {
          console.error('Error-chkUser', status, data);
        }
      ); */
    }

    // 비밀번호 변경 > 비밀번호 저장
    /* function setUserPass() {
      var prms = loginApi
        .doUpdateUserPassForUpdatePass()
        .post(vm.user).$promise;
      prms.then(
        function (data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            //setEmailLog();
            gAlert('', '비밀번호가 변경 되었습니다.', {
              fn: function () {
                $state.go('app.dashboard');
              },
            });
          } else {
            //실패
          }
        },
        function (data) {
          console.error(
            'Error-setUserPass',
            status,
            data.body.docs[0].errMessage
          );
        }
      );
    } */
  }

  webapp.component('updatepass', {
    transclude: true,
    bindings: {},
    controller: updatePassCtrl,
    controllerAs: 'updatepass',
    templateUrl: 'components/login/updatepass.html',
  });
})();

(function() {
  "use strict";
  NoticeController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function NoticeController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    //console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.onChangeHandler = onChangeHandler;

    function onChangeHandler() {
      //console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

//      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function getBoardList() {
      var data = {BbsMasterId:'7X3HP8Q9F4', TenantId:'7TLIMMJEL9'};

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.boardlist = result.body.docs;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    }

    vm.showDetail = function(BbsPostId) {
      var data = {BbsMasterId:'7X3HP8Q9F4', TenantId:'7TLIMMJEL9', BbsPostId:BbsPostId, selectType:'Detail'};

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    };

    getBoardList();
  }

  webapp.component("notice", {
    transclude: true,
    bindings: {},
    controller: NoticeController,
    controllerAs: "notice",
    templateUrl: "components/notice/notice.html"
  });
})();

webapp.service('ModalAPISrv', ['$rootScope', '$resource', 'StaticVariable',
  function ModalAPISrv($rootScope, $resource, staticVariable) {
    var modalApi = {
      getClientApi: function(){
        return $resource(staticVariable.getUrl('/api/org/clients.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDeptUserApi: function(){
        return $resource(staticVariable.getUrl('/api/org/department/:deptId/users.json?userkey=' + $rootScope.gVariable.userKey), {
          deptId: '@deptId'
        }, staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDepartmentApi: function(){
        return $resource(staticVariable.getUrl('/api/org/departement/tree.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      doDeptList: function() {
        return $resource(staticVariable.getUrl('/select/Department.getDepartmentTree/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doTenantList: function() {
        alert('doTenantList');
        return $resource(staticVariable.getUrl('/select/Tenant.getTenantSrch/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doLocationList: function() {
        return $resource(staticVariable.getUrl('/select/Location.getLocationTreeList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserCntApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getShopApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getShopCntApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopCount/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleCntApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doUpdateDefaultActionDetail : function() {
        return $resource(staticVariable.getUrl('/update/DataAnalysis.updateDefaultActionDetail/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
    };
    return modalApi;
  },
]);

(function() {
  "use strict";
  PolicyController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function PolicyController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
  }

  webapp.component("policy", {
    transclude: true,
    bindings: {},
    controller: PolicyController,
    controllerAs: "policy",
    templateUrl: "components/policy/policy.html"
  });
})();

(function() {
  "use strict";
  QnaController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function QnaController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    //console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.onChangeHandler = onChangeHandler;

    function onChangeHandler() {
      //console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

//      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function getBoardList() {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9'};

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.boardlist = result.body.docs;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    }

    vm.showDetail = function(BbsPostId) {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9', BbsPostId:BbsPostId, selectType:'Detail'};

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.log("error");
        // console.error('fail', status);
      });
    };

    getBoardList();
  }

  webapp.component("qna", {
    transclude: true,
    bindings: {},
    controller: QnaController,
    controllerAs: "qna",
    templateUrl: "components/qna/qna.html"
  });
})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */

  /** @ngInject */
  var PopupController = function ($scope, $log, $window) {
    var vm = this;
    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1532423437610;
    //$log.log(vm.creationDate);

    if ($window.sessionStorage.getItem('noHeader') == 'true') {
      $('html').addClass('noheader');
    }
  };

  var popup = {
    templateUrl: 'components/popup/popup.html',
    controller: PopupController,
  };

  webapp.component('popup', popup);
})();

webapp.config([
  '$stateProvider',
  '$urlRouterProvider',
  function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state('popup.counsel-record-modal', {
      url: '/counsel-record-modal/:CustArmyId',
      templateUrl: 'app/counsel/modal/counsel-record-modal.html',
    }),
    $stateProvider.state('popup.mentoringrecord-print-modal', {
      url: '/mentoringrecord-print-modal/:RecordId',
      templateUrl: 'app/mentoring/modal/mentoringrecord-print-modal.html',
    });
  },
]);

function checkBizID(bizID) {
  //사업자등록번호 체크
  // bizID는 숫자만 10자리로 해서 문자열로 넘긴다.
  var checkID = new Array(1, 3, 7, 1, 3, 7, 1, 3, 5, 1);
  var tmpBizID,
    i,
    iResult = 0,
    c2;
  var remander;
  bizID = bizID.replace(/-/gi, '');

  for (i = 0; i <= 8; i++) iResult += checkID[i] * bizID.charAt(i);
  c2 = (checkID[8] * bizID.charAt(8)) % 10;
  iResult = iResult + (checkID[8] * bizID.charAt(8) - c2) / 10;
  iResult = iResult % 10;
  iResult = 10 - iResult;
  if (iResult == 10) iResult = 0;
  if (Math.floor(bizID.charAt(9)) == iResult) return true;
  return false;
}

function fnNumberOnly() {
  var agent = navigator.userAgent.toLowerCase();

  if ((event.keyCode < 48 || event.keyCode > 57) && event.keyCode != 189 && event.keyCode != 8 && event.keyCode != 46) {
    // keyCode 아스키코드 값을 리턴해주느 함수
    if (agent.indexOf('chrome') != -1) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      return false;
    } else {
      event.preventDefault(); // IE(이벤트를 무효화시킴)
    }
  }
  return true;
}

/*
Function Name 	: fnOpenPopup()
Author 			: 최원영
Usage			: fnOpenPopup('kcp_pay', '/jsp/kcp_pay/jsp/kcp_pay_order.jsp' + param, '800', '600');
*/
function fnOpenPopup(id, url, width, height) {
  var left = screen.width / 2 - width / 2;
  var top = screen.height / 2 - height / 2;
  var options =
    'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, ';
  options = options + 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left;

  // 팝업 창 표시
  var popUpWindow = window.open(url, id, options);

  popUpWindow.focus();

  return false;
}

function parseHeaderFilename(headers) {
  var header = headers('content-disposition');
  var result = header.split(';')[1].trim().split('=')[1];
  return result.replace(/"/g, '');
}

function downloadFile(data, filename) {
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && !!window.chrome.webstore;
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isBlink = (isChrome || isOpera) && !!window.CSS;

  if (isFirefox || isIE || isChrome) {
    if (isChrome) {
      console.log('Manage Google Chrome download');
      var url = window.URL || window.webkitURL;
      var fileURL = url.createObjectURL(data);
      var downloadLink = angular.element('<a></a>'); //create a new  <a> tag element
      downloadLink.attr('href', fileURL);
      downloadLink.attr('download', filename);
      downloadLink.attr('target', '_self');
      downloadLink[0].click(); //call click function
      url.revokeObjectURL(fileURL); //revoke the object from URL
    }
    if (isIE) {
      console.log('Manage IE download>10');
      window.navigator.msSaveOrOpenBlob(data, filename);
    }
    if (isFirefox) {
      console.log('Manage Mozilla Firefox download');
      var url = window.URL || window.webkitURL;
      var fileURL = url.createObjectURL(data);
      var a = elem[0]; //recover the <a> tag from directive
      a.href = fileURL;
      a.download = filename;
      a.target = '_self';
      a.click(); //we call click function
    }
  } else {
    alert('SORRY YOUR BROWSER IS NOT COMPATIBLE');
  }
}

function fnCheckTel(value) {
  var regTel = /^(01[016789]{1}|070|02|0[3-9]{1}[0-9]{1})-[0-9]{3,4}-[0-9]{4}$/;

  if (!regTel.test(value)) {
    alert('입력한 전화(휴대폰) 번호를 확인하십시오.');
    return false;
  }
  return true;
}

/**
 * 숫자만 입력 가능
 * @param obj
 * @param value
 */
function fnCheckNum(obj, value) {
  var regExp = /[^0-9]+/g;

  if (regExp.test(value)) {
    alert("'숫자' 만 입력 가능합니다.");

    var returnStr = '';

    for (i = 0; i < value.length; i++) {
      if (value.charAt(i) >= '0' && value.charAt(i) <= '9') {
        returnStr += value.charAt(i);
      }
    }

    obj.value = returnStr;
    obj.focus();
  }
}

/**
 * 숫자만 입력 가능
 * @param obj
 * @param value
 */
function fnCheckNumDash(obj, value) {
  var regExp = /[^0-9-]+/g;

  if (regExp.test(value)) {
    alert("'숫자' 만 입력 가능합니다.");

    var returnStr = '';

    for (i = 0; i < value.length; i++) {
      if ((value.charAt(i) >= '0' && value.charAt(i) <= '9') || value.charAt(i) == '-') {
        returnStr += value.charAt(i);
      }
    }

    obj.value = returnStr;
    obj.focus();
  }
}

/**
 * Length Check
 * @param el
 * @param limitLength
 * @param subLength
 */
function fnLengthChk(el, limitLength, subLength) {
  var ls_str = el.value; // 이벤트가 일어난 컨트롤의 value 값
  var li_str_len = ls_str.length; // 전체길이

  // 변수초기화
  var li_max = limitLength; // 제한할 글자수 크기
  var i = 0; // for문에 사용
  var li_byte = 0; // 한글일경우는 2 그밗에는 1을 더함

  var li_len = 0; // substring하기 위해서 사용
  if (subLength != '' && subLength > 0) {
    li_len = subLength;
  }

  var ls_one_char = ''; // 한글자씩 검사한다
  var ls_str2 = ''; // 글자수를 초과하면 제한할수 글자전까지만 보여준다.

  for (i = 0; i < li_str_len; i++) {
    // 한글자추출
    ls_one_char = ls_str.charAt(i);

    if (escape(ls_one_char).length > 4) {
      // 한글이면 2를 더한다.
      li_byte = li_byte + 2;
    } else {
      li_byte++;
    }

    // 전체 크기가 li_max를 넘지않으면
    if (li_byte <= li_max) {
      li_len = i + 1;
    }
  }

  // 전체길이를 초과하면
  if (li_byte > li_max) {
    alert(li_max + ' 자를 초과하여 입력하실 수 없습니다.');
    ls_str2 = ls_str.substr(0, li_len);
    el.value = ls_str2;
  }

  el.focus();
}

/**
 * 한글 바이트 체크
 * @param el
 * @param limitLength
 * @param subLength
 */
function fnLengthKoChk(el, limitLength, koLimitLength) {
  var ls_str = el.value; // 이벤트가 일어난 컨트롤의 value 값
  var li_str_len = ls_str.length; // 전체길이

  // 변수초기화
  var li_max = limitLength; // 제한할 글자수 크기
  var i = 0; // for문에 사용
  var li_byte = 0; // 한글일경우는 2 그밗에는 1을 더함

  var li_len = 0; // substring하기 위해서 사용

  var ls_one_char = ''; // 한글자씩 검사한다
  var ls_str2 = ''; // 글자수를 초과하면 제한할수 글자전까지만 보여준다.

  for (i = 0; i < li_str_len; i++) {
    // 한글자추출
    ls_one_char = ls_str.charAt(i);

    if (escape(ls_one_char).length > 4) {
      // 한글이면 2를 더한다.
      li_byte = li_byte + 2;
    } else {
      li_byte++;
    }

    // 전체 크기가 li_max를 넘지않으면
    if (li_byte <= li_max) {
      li_len = i + 1;
    }
  }

  // 전체길이를 초과하면
  if (li_byte > li_max) {
    alert('한글은 ' + koLimitLength + ' 자, 영문자는 ' + limitLength + '자를 초과하여 입력하실 수 없습니다.');

    ls_str2 = ls_str.substr(0, li_len);
    el.value = ls_str2;
  }

  el.focus();
}

//오늘날짜 얻기 (YYYY-MM-DD)
function getToday() {
  var date = new Date();
  var year = date.getFullYear();
  var month = new String(date.getMonth() + 1);
  var day = new String(date.getDate());

  if (month.length == 1) month = '0' + month;
  if (day.length == 1) day = '0' + day;

  return year + '-' + month + '-' + day;
}

//오늘날짜 얻기 (YYYY-MM)
function getTodayMonth() {
  var date = new Date();
  var year = date.getFullYear();
  var month = new String(date.getMonth() + 1);

  if (month.length == 1) month = '0' + month;

  return year + '-' + month;
}

//오늘날짜에서 Day 더하기
function getTodayAddDay(addNumber) {
  var date = new Date();
  date.setDate(date.getDate() + addNumber);

  var year = date.getFullYear();
  var month = new String(date.getMonth() + 1);
  var day = new String(date.getDate());

  if (month.length == 1) month = '0' + month;
  if (day.length == 1) day = '0' + day;

  return year + '-' + month + '-' + day;
}

//YYYY-MM-DD 숫자로 변환
function getDateToNumber(date) {
  var dateNum = parseInt(date.replace(/-/g, ''));

  return dateNum;
}

//오늘시간 얻기
function getTodayTime(type) {
  var date = new Date();
  var h = date.getHours();
  var m = date.getMinutes();

  if (h.length == 1) h = '0' + h;
  if (m.length == 1) m = '0' + m;

  return type == 'H' ? h : m;
}

//오늘시간 얻기
function getDateTime(type) {
  var date = new Date();
  var year = date.getFullYear();
  var month = new String(date.getMonth() + 1);
  var day = new String(date.getDate());
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  var msecond = date.getMilliseconds();
  var rtn;

  if (month.length == 1) month = '0' + month;
  if (day.length == 1) day = '0' + day;
  if (hour.length == 1) hour = '0' + hour;
  if (minute.length == 1) minute = '0' + minute;
  if (second.length == 1) second = '0' + second;

  if (msecond.length == 1) msecond = '00' + msecond;
  else if (msecond.length == 2) msecond = '0' + msecond;

  if (type == 'CODE') {
    rtn = year + month + day + hour + minute + second + msecond;
  } else {
    rtn = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
  }

  return rtn;
}

//시간 유효성 체크
function chkHour(obj) {
  var h = obj.value;

  alert(h);

  if (h == '') h = '00';
  if (parseInt(h) > 24) h = '24';

  if (h.length == 1) h = '0' + h;

  obj.value = h;
}

//분 유효성 체크
function chkMin(obj) {
  var m = obj.value;

  if (m == '') m = '00';
  if (parseInt(m) > 60) m = '60';

  if (m.length == 1) m = '0' + m;

  obj.value = m;
}

//yyyy-mm-dd > new Date 형태로 변환
function setNewDate(dateStr) {
  var dateArr;

  if (typeof dateStr == 'undefined') {
    return null;
  } else {
    dateArr = dateStr.split('-');
  }

  if (dateArr.length == 3) {
    return new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2]);
  } else {
    return null;
  }
}

// 숫자 콤마 삽입
function setNumberFormat(num) {
  if (this == '0') return '0';
  var reg = /(^[+-]?\d+)(\d{3})/;
  var n = num + '';
  while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');

  return n;
}

// DAUM 주소 API 팝업 호출
function SearchZipcode(zipcodeId, addrId) {
  daum.postcode.load(function () {
    new daum.Postcode({
      oncomplete: function (data) {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        var fullAddr = ''; // 최종 주소 변수
        var extraAddr = ''; // 조합형 주소 변수

        // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') {
          // 사용자가 도로명 주소를 선택했을 경우
          fullAddr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          fullAddr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 조합한다.
        if (data.userSelectedType === 'R') {
          //법정동명이 있을 경우 추가한다.
          if (data.bname !== '') {
            extraAddr += data.bname;
          }
          // 건물명이 있을 경우 추가한다.
          if (data.buildingName !== '') {
            extraAddr += extraAddr !== '' ? ', ' + data.buildingName : data.buildingName;
          }
          // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
          //fullAddr += (extraAddr !== '' ? ' (' + extraAddr + ')' : '');
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        document.getElementById(zipcodeId).value = data.zonecode;
        document.getElementById(addrId).value = fullAddr;
      },
    }).open();
  });

  //return rtnArr;
}

// 페이지별 접근 권한 체크
function isPageAccess(path, userType, isAlert) {
  var rtn = false;

  if (typeof isAlert == 'undefined') isAlert = true;

  /* userType
  '000', 'superadmin'
  '010', 'PM'
  '020', '교육원'
  '030', '상담사'
  '040', '연대급실무자'
  */
  switch (path) {
    case 'counselappli-list': // 상담신청관리 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'counselappli-detail': // 상담신청관리 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'counselappli-edit': // 상담신청관리 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'counselappli-appr-modal': // 상담신청 승인  팝업
      switch (userType) {
        case '000':
          rtn = false;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = false;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'unit-counsel-modal': // 부대별 상담현황 팝업
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'customerarmy-list': // 고객 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'customerarmy-detail': // 고객 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'customerarmy-edit': // 고객 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'customerarmy-list-modal': // 고객 선택 팝업
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'employhistory-list-modal':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'customerarmy-large': // 대량고객등록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'counselrecord-list': // 상담일지 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'counselrecord-detail': // 상담일지 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'counselrecord-edit': // 상담일지 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'schedule-list': // 상담일정 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'schedule-edit-modal': // 상담일정 등록 팝업
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'beforesurvey-list': // 사전설문조사 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'beforesurvey-detail': // 사전설문조사 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'beforesurvey-edit': // 사전설문조사 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'aftersurvey-list': // 사후설문조사 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'aftersurvey-detail': // 사후설문조사 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'aftersurvey-edit': // 사후설문조사 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'user-list': // 사용자 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'user-detail': // 사용자 상세조회
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'user-edit': // 사용자 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'Totalprog-list': // 총괄진행현황/진도율
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'Areacounsel-list': // 지역별/부대별 등록현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'Unitclass-list': // 부대별/컨설턴트별 상담현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'Methodcounsel-list': // 부대별/컨설턴트별 상담현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'Careeremploy-list': // 진로/취업목표별 진행현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'Employstartup-list': // 중소기업 희망 현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'Survey-list': // 설문서종합결과
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'Employstate-list': // 취업자 현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

    case 'personalInfo-list': // 개인정보 다운로드 이력
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'personalInfo-edit': // 개인정보 시스템 설정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'personalSms-list': // 로그인 SMS 인증번호 발송 현황
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'jobinfoarmy-edit': // 취업 등록/수정
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'jobinfoarmy-detail': // 취업 상세
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'jobinfoarmy-list': // 취업 목록
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'business-list':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'business-detail':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'business-edit':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'business-detail-edit':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'h0101-edit':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'accountLock-list':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;
    case 'visitLog-list':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;
    case 'visitMenu-list':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'permissionInfo-list':
      switch (userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = false;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'mentoringapply-list': // 창업멘토링 신청자목록
      switch(userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = false;
          break;
        case '040':
          rtn = false;
          break;
        default:
          break;
      }
      break;

    case 'mentoringclub-list': // 창업멘토링 동아리팀 목록
      switch(userType) {
        case '000':
          rtn = true;
          break;
        case '010':
          rtn = true;
          break;
        case '020':
          rtn = true;
          break;
        case '030':
          rtn = true;
          break;
        case '040':
          rtn = true;
          break;
        default:
          break;
      }
      break;

      case 'mentoringclub-detail': // 창업멘토링 동아리팀 상세조회
        switch(userType) {
          case '000':
            rtn = true;
            break;
          case '010':
            rtn = true;
            break;
          case '020':
            rtn = true;
            break;
          case '030':
            rtn = true;
            break;
          case '040':
            rtn = true;
            break;
          default:
            break;
        }
        break;

        case 'mentoringclub-edit': // 창업멘토링 동아리팀 등록수정
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = false;
              break;
            case '040':
              rtn = false;
              break;
            default:
              break;
          }
          break;

        case 'mentoringprtcp-list': // 창업멘토링 참여자 목록
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringprtcp-detail': // 창업멘토링 참여자 상세정보
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringprtcp-edit': // 창업멘토링 참여자 등록/수정
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = false;
              break;
            case '040':
              rtn = false;
              break;
            default:
              break;
          }
          break;

        case 'mentoringapply-list-modal': // 멘토링 신청자 팝업
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringclub-list-modal': // 멘토링 동아리팀 팝업
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringrecord-list': // 멘토링보고서 목록
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringrecord-detail': // 멘토링보고서 조회
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringrecord-edit': // 멘토링보고서 등록/수정
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringschedule-list': // 멘토링일정
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringschedule-edit-modal': // 멘토링일정 등록/수정
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = true;
              break;
            case '040':
              rtn = true;
              break;
            default:
              break;
          }
          break;

        case 'mentoringstate-summary': // 창업멘토링 통계 현황판
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = false;
              break;
            case '040':
              rtn = false;
              break;
            default:
              break;
          }
          break;

        case 'mentoringstate-total': // 창업멘토링 통계 종합현황
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = false;
              break;
            case '040':
              rtn = false;
              break;
            default:
              break;
          }
          break;

        case 'mentoringstate-list': // 창업멘토링 통계 참여자현황
          switch(userType) {
            case '000':
              rtn = true;
              break;
            case '010':
              rtn = true;
              break;
            case '020':
              rtn = true;
              break;
            case '030':
              rtn = false;
              break;
            case '040':
              rtn = false;
              break;
            default:
              break;
          }
          break;
  }

  if (!rtn && isAlert) {
    alert('조회권한이 없습니다.');
  }

  return rtn;
}

// 게시판명 (임시)
function getBBSNm(code) {
  var rtn = '';

  switch (code) {
    case '60Y9C18S4M':
      rtn = '공지사항';
      break;
    case '7GLIAQRSY0':
      rtn = '자료실';
      break;
    default:
      break;
  }

  return rtn;
}

// function getRandomKeyString() {
//   var seed = new Date().getTime();
//   seed = (seed*9301 + 49297) % 233280;
//   return Math.floor(seed/233280.0 * 899999999999999 + 100000000000000).toString(36).toUpperCase();
// }

function getRandomKeyString() {
  var array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return Math.floor(array[0] / (Math.pow(2, 32) - 1) * 899999999999999 + 100000000000000);

}

// function makeDateUUID() =>> function getRandomKey() 변경해서 사용함 (2023-07-07)
function getRandomKey() {
  var array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return Math.floor(array[0] / (Math.pow(2, 32) - 1) * 899999999999999 + 100000000000000);
}


/*! jQuery v1.9.1 | (c) 2005, 2012 jQuery Foundation, Inc. | jquery.org/license
//@ sourceMappingURL=jquery.min.map
*/(function(e,t){var n,r,i=typeof t,o=e.document,a=e.location,s=e.jQuery,u=e.$,l={},c=[],p="1.9.1",f=c.concat,d=c.push,h=c.slice,g=c.indexOf,m=l.toString,y=l.hasOwnProperty,v=p.trim,b=function(e,t){return new b.fn.init(e,t,r)},x=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,w=/\S+/g,T=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,N=/^(?:(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,k=/^[\],:{}\s]*$/,E=/(?:^|:|,)(?:\s*\[)+/g,S=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,A=/"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,j=/^-ms-/,D=/-([\da-z])/gi,L=function(e,t){return t.toUpperCase()},H=function(e){(o.addEventListener||"load"===e.type||"complete"===o.readyState)&&(q(),b.ready())},q=function(){o.addEventListener?(o.removeEventListener("DOMContentLoaded",H,!1),e.removeEventListener("load",H,!1)):(o.detachEvent("onreadystatechange",H),e.detachEvent("onload",H))};b.fn=b.prototype={jquery:p,constructor:b,init:function(e,n,r){var i,a;if(!e)return this;if("string"==typeof e){if(i="<"===e.charAt(0)&&">"===e.charAt(e.length-1)&&e.length>=3?[null,e,null]:N.exec(e),!i||!i[1]&&n)return!n||n.jquery?(n||r).find(e):this.constructor(n).find(e);if(i[1]){if(n=n instanceof b?n[0]:n,b.merge(this,b.parseHTML(i[1],n&&n.nodeType?n.ownerDocument||n:o,!0)),C.test(i[1])&&b.isPlainObject(n))for(i in n)b.isFunction(this[i])?this[i](n[i]):this.attr(i,n[i]);return this}if(a=o.getElementById(i[2]),a&&a.parentNode){if(a.id!==i[2])return r.find(e);this.length=1,this[0]=a}return this.context=o,this.selector=e,this}return e.nodeType?(this.context=this[0]=e,this.length=1,this):b.isFunction(e)?r.ready(e):(e.selector!==t&&(this.selector=e.selector,this.context=e.context),b.makeArray(e,this))},selector:"",length:0,size:function(){return this.length},toArray:function(){return h.call(this)},get:function(e){return null==e?this.toArray():0>e?this[this.length+e]:this[e]},pushStack:function(e){var t=b.merge(this.constructor(),e);return t.prevObject=this,t.context=this.context,t},each:function(e,t){return b.each(this,e,t)},ready:function(e){return b.ready.promise().done(e),this},slice:function(){return this.pushStack(h.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(0>e?t:0);return this.pushStack(n>=0&&t>n?[this[n]]:[])},map:function(e){return this.pushStack(b.map(this,function(t,n){return e.call(t,n,t)}))},end:function(){return this.prevObject||this.constructor(null)},push:d,sort:[].sort,splice:[].splice},b.fn.init.prototype=b.fn,b.extend=b.fn.extend=function(){var e,n,r,i,o,a,s=arguments[0]||{},u=1,l=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[1]||{},u=2),"object"==typeof s||b.isFunction(s)||(s={}),l===u&&(s=this,--u);l>u;u++)if(null!=(o=arguments[u]))for(i in o)e=s[i],r=o[i],s!==r&&(c&&r&&(b.isPlainObject(r)||(n=b.isArray(r)))?(n?(n=!1,a=e&&b.isArray(e)?e:[]):a=e&&b.isPlainObject(e)?e:{},s[i]=b.extend(c,a,r)):r!==t&&(s[i]=r));return s},b.extend({noConflict:function(t){return e.$===b&&(e.$=u),t&&e.jQuery===b&&(e.jQuery=s),b},isReady:!1,readyWait:1,holdReady:function(e){e?b.readyWait++:b.ready(!0)},ready:function(e){if(e===!0?!--b.readyWait:!b.isReady){if(!o.body)return setTimeout(b.ready);b.isReady=!0,e!==!0&&--b.readyWait>0||(n.resolveWith(o,[b]),b.fn.trigger&&b(o).trigger("ready").off("ready"))}},isFunction:function(e){return"function"===b.type(e)},isArray:Array.isArray||function(e){return"array"===b.type(e)},isWindow:function(e){return null!=e&&e==e.window},isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},type:function(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?l[m.call(e)]||"object":typeof e},isPlainObject:function(e){if(!e||"object"!==b.type(e)||e.nodeType||b.isWindow(e))return!1;try{if(e.constructor&&!y.call(e,"constructor")&&!y.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(n){return!1}var r;for(r in e);return r===t||y.call(e,r)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},error:function(e){throw Error(e)},parseHTML:function(e,t,n){if(!e||"string"!=typeof e)return null;"boolean"==typeof t&&(n=t,t=!1),t=t||o;var r=C.exec(e),i=!n&&[];return r?[t.createElement(r[1])]:(r=b.buildFragment([e],t,i),i&&b(i).remove(),b.merge([],r.childNodes))},parseJSON:function(n){return e.JSON&&e.JSON.parse?e.JSON.parse(n):null===n?n:"string"==typeof n&&(n=b.trim(n),n&&k.test(n.replace(S,"@").replace(A,"]").replace(E,"")))?Function("return "+n)():(b.error("Invalid JSON: "+n),t)},parseXML:function(n){var r,i;if(!n||"string"!=typeof n)return null;try{e.DOMParser?(i=new DOMParser,r=i.parseFromString(n,"text/xml")):(r=new ActiveXObject("Microsoft.XMLDOM"),r.async="false",r.loadXML(n))}catch(o){r=t}return r&&r.documentElement&&!r.getElementsByTagName("parsererror").length||b.error("Invalid XML: "+n),r},noop:function(){},globalEval:function(t){t&&b.trim(t)&&(e.execScript||function(t){e.eval.call(e,t)})(t)},camelCase:function(e){return e.replace(j,"ms-").replace(D,L)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,t,n){var r,i=0,o=e.length,a=M(e);if(n){if(a){for(;o>i;i++)if(r=t.apply(e[i],n),r===!1)break}else for(i in e)if(r=t.apply(e[i],n),r===!1)break}else if(a){for(;o>i;i++)if(r=t.call(e[i],i,e[i]),r===!1)break}else for(i in e)if(r=t.call(e[i],i,e[i]),r===!1)break;return e},trim:v&&!v.call("\ufeff\u00a0")?function(e){return null==e?"":v.call(e)}:function(e){return null==e?"":(e+"").replace(T,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(M(Object(e))?b.merge(n,"string"==typeof e?[e]:e):d.call(n,e)),n},inArray:function(e,t,n){var r;if(t){if(g)return g.call(t,e,n);for(r=t.length,n=n?0>n?Math.max(0,r+n):n:0;r>n;n++)if(n in t&&t[n]===e)return n}return-1},merge:function(e,n){var r=n.length,i=e.length,o=0;if("number"==typeof r)for(;r>o;o++)e[i++]=n[o];else while(n[o]!==t)e[i++]=n[o++];return e.length=i,e},grep:function(e,t,n){var r,i=[],o=0,a=e.length;for(n=!!n;a>o;o++)r=!!t(e[o],o),n!==r&&i.push(e[o]);return i},map:function(e,t,n){var r,i=0,o=e.length,a=M(e),s=[];if(a)for(;o>i;i++)r=t(e[i],i,n),null!=r&&(s[s.length]=r);else for(i in e)r=t(e[i],i,n),null!=r&&(s[s.length]=r);return f.apply([],s)},guid:1,proxy:function(e,n){var r,i,o;return"string"==typeof n&&(o=e[n],n=e,e=o),b.isFunction(e)?(r=h.call(arguments,2),i=function(){return e.apply(n||this,r.concat(h.call(arguments)))},i.guid=e.guid=e.guid||b.guid++,i):t},access:function(e,n,r,i,o,a,s){var u=0,l=e.length,c=null==r;if("object"===b.type(r)){o=!0;for(u in r)b.access(e,n,u,r[u],!0,a,s)}else if(i!==t&&(o=!0,b.isFunction(i)||(s=!0),c&&(s?(n.call(e,i),n=null):(c=n,n=function(e,t,n){return c.call(b(e),n)})),n))for(;l>u;u++)n(e[u],r,s?i:i.call(e[u],u,n(e[u],r)));return o?e:c?n.call(e):l?n(e[0],r):a},now:function(){return(new Date).getTime()}}),b.ready.promise=function(t){if(!n)if(n=b.Deferred(),"complete"===o.readyState)setTimeout(b.ready);else if(o.addEventListener)o.addEventListener("DOMContentLoaded",H,!1),e.addEventListener("load",H,!1);else{o.attachEvent("onreadystatechange",H),e.attachEvent("onload",H);var r=!1;try{r=null==e.frameElement&&o.documentElement}catch(i){}r&&r.doScroll&&function a(){if(!b.isReady){try{r.doScroll("left")}catch(e){return setTimeout(a,50)}q(),b.ready()}}()}return n.promise(t)},b.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(e,t){l["[object "+t+"]"]=t.toLowerCase()});function M(e){var t=e.length,n=b.type(e);return b.isWindow(e)?!1:1===e.nodeType&&t?!0:"array"===n||"function"!==n&&(0===t||"number"==typeof t&&t>0&&t-1 in e)}r=b(o);var _={};function F(e){var t=_[e]={};return b.each(e.match(w)||[],function(e,n){t[n]=!0}),t}b.Callbacks=function(e){e="string"==typeof e?_[e]||F(e):b.extend({},e);var n,r,i,o,a,s,u=[],l=!e.once&&[],c=function(t){for(r=e.memory&&t,i=!0,a=s||0,s=0,o=u.length,n=!0;u&&o>a;a++)if(u[a].apply(t[0],t[1])===!1&&e.stopOnFalse){r=!1;break}n=!1,u&&(l?l.length&&c(l.shift()):r?u=[]:p.disable())},p={add:function(){if(u){var t=u.length;(function i(t){b.each(t,function(t,n){var r=b.type(n);"function"===r?e.unique&&p.has(n)||u.push(n):n&&n.length&&"string"!==r&&i(n)})})(arguments),n?o=u.length:r&&(s=t,c(r))}return this},remove:function(){return u&&b.each(arguments,function(e,t){var r;while((r=b.inArray(t,u,r))>-1)u.splice(r,1),n&&(o>=r&&o--,a>=r&&a--)}),this},has:function(e){return e?b.inArray(e,u)>-1:!(!u||!u.length)},empty:function(){return u=[],this},disable:function(){return u=l=r=t,this},disabled:function(){return!u},lock:function(){return l=t,r||p.disable(),this},locked:function(){return!l},fireWith:function(e,t){return t=t||[],t=[e,t.slice?t.slice():t],!u||i&&!l||(n?l.push(t):c(t)),this},fire:function(){return p.fireWith(this,arguments),this},fired:function(){return!!i}};return p},b.extend({Deferred:function(e){var t=[["resolve","done",b.Callbacks("once memory"),"resolved"],["reject","fail",b.Callbacks("once memory"),"rejected"],["notify","progress",b.Callbacks("memory")]],n="pending",r={state:function(){return n},always:function(){return i.done(arguments).fail(arguments),this},then:function(){var e=arguments;return b.Deferred(function(n){b.each(t,function(t,o){var a=o[0],s=b.isFunction(e[t])&&e[t];i[o[1]](function(){var e=s&&s.apply(this,arguments);e&&b.isFunction(e.promise)?e.promise().done(n.resolve).fail(n.reject).progress(n.notify):n[a+"With"](this===r?n.promise():this,s?[e]:arguments)})}),e=null}).promise()},promise:function(e){return null!=e?b.extend(e,r):r}},i={};return r.pipe=r.then,b.each(t,function(e,o){var a=o[2],s=o[3];r[o[1]]=a.add,s&&a.add(function(){n=s},t[1^e][2].disable,t[2][2].lock),i[o[0]]=function(){return i[o[0]+"With"](this===i?r:this,arguments),this},i[o[0]+"With"]=a.fireWith}),r.promise(i),e&&e.call(i,i),i},when:function(e){var t=0,n=h.call(arguments),r=n.length,i=1!==r||e&&b.isFunction(e.promise)?r:0,o=1===i?e:b.Deferred(),a=function(e,t,n){return function(r){t[e]=this,n[e]=arguments.length>1?h.call(arguments):r,n===s?o.notifyWith(t,n):--i||o.resolveWith(t,n)}},s,u,l;if(r>1)for(s=Array(r),u=Array(r),l=Array(r);r>t;t++)n[t]&&b.isFunction(n[t].promise)?n[t].promise().done(a(t,l,n)).fail(o.reject).progress(a(t,u,s)):--i;return i||o.resolveWith(l,n),o.promise()}}),b.support=function(){var t,n,r,a,s,u,l,c,p,f,d=o.createElement("div");if(d.setAttribute("className","t"),d.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",n=d.getElementsByTagName("*"),r=d.getElementsByTagName("a")[0],!n||!r||!n.length)return{};s=o.createElement("select"),l=s.appendChild(o.createElement("option")),a=d.getElementsByTagName("input")[0],r.style.cssText="top:1px;float:left;opacity:.5",t={getSetAttribute:"t"!==d.className,leadingWhitespace:3===d.firstChild.nodeType,tbody:!d.getElementsByTagName("tbody").length,htmlSerialize:!!d.getElementsByTagName("link").length,style:/top/.test(r.getAttribute("style")),hrefNormalized:"/a"===r.getAttribute("href"),opacity:/^0.5/.test(r.style.opacity),cssFloat:!!r.style.cssFloat,checkOn:!!a.value,optSelected:l.selected,enctype:!!o.createElement("form").enctype,html5Clone:"<:nav></:nav>"!==o.createElement("nav").cloneNode(!0).outerHTML,boxModel:"CSS1Compat"===o.compatMode,deleteExpando:!0,noCloneEvent:!0,inlineBlockNeedsLayout:!1,shrinkWrapBlocks:!1,reliableMarginRight:!0,boxSizingReliable:!0,pixelPosition:!1},a.checked=!0,t.noCloneChecked=a.cloneNode(!0).checked,s.disabled=!0,t.optDisabled=!l.disabled;try{delete d.test}catch(h){t.deleteExpando=!1}a=o.createElement("input"),a.setAttribute("value",""),t.input=""===a.getAttribute("value"),a.value="t",a.setAttribute("type","radio"),t.radioValue="t"===a.value,a.setAttribute("checked","t"),a.setAttribute("name","t"),u=o.createDocumentFragment(),u.appendChild(a),t.appendChecked=a.checked,t.checkClone=u.cloneNode(!0).cloneNode(!0).lastChild.checked,d.attachEvent&&(d.attachEvent("onclick",function(){t.noCloneEvent=!1}),d.cloneNode(!0).click());for(f in{submit:!0,change:!0,focusin:!0})d.setAttribute(c="on"+f,"t"),t[f+"Bubbles"]=c in e||d.attributes[c].expando===!1;return d.style.backgroundClip="content-box",d.cloneNode(!0).style.backgroundClip="",t.clearCloneStyle="content-box"===d.style.backgroundClip,b(function(){var n,r,a,s="padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",u=o.getElementsByTagName("body")[0];u&&(n=o.createElement("div"),n.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",u.appendChild(n).appendChild(d),d.innerHTML="<table><tr><td></td><td>t</td></tr></table>",a=d.getElementsByTagName("td"),a[0].style.cssText="padding:0;margin:0;border:0;display:none",p=0===a[0].offsetHeight,a[0].style.display="",a[1].style.display="none",t.reliableHiddenOffsets=p&&0===a[0].offsetHeight,d.innerHTML="",d.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;",t.boxSizing=4===d.offsetWidth,t.doesNotIncludeMarginInBodyOffset=1!==u.offsetTop,e.getComputedStyle&&(t.pixelPosition="1%"!==(e.getComputedStyle(d,null)||{}).top,t.boxSizingReliable="4px"===(e.getComputedStyle(d,null)||{width:"4px"}).width,r=d.appendChild(o.createElement("div")),r.style.cssText=d.style.cssText=s,r.style.marginRight=r.style.width="0",d.style.width="1px",t.reliableMarginRight=!parseFloat((e.getComputedStyle(r,null)||{}).marginRight)),typeof d.style.zoom!==i&&(d.innerHTML="",d.style.cssText=s+"width:1px;padding:1px;display:inline;zoom:1",t.inlineBlockNeedsLayout=3===d.offsetWidth,d.style.display="block",d.innerHTML="<div></div>",d.firstChild.style.width="5px",t.shrinkWrapBlocks=3!==d.offsetWidth,t.inlineBlockNeedsLayout&&(u.style.zoom=1)),u.removeChild(n),n=d=a=r=null)}),n=s=u=l=r=a=null,t}();var O=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,B=/([A-Z])/g;function P(e,n,r,i){if(b.acceptData(e)){var o,a,s=b.expando,u="string"==typeof n,l=e.nodeType,p=l?b.cache:e,f=l?e[s]:e[s]&&s;if(f&&p[f]&&(i||p[f].data)||!u||r!==t)return f||(l?e[s]=f=c.pop()||b.guid++:f=s),p[f]||(p[f]={},l||(p[f].toJSON=b.noop)),("object"==typeof n||"function"==typeof n)&&(i?p[f]=b.extend(p[f],n):p[f].data=b.extend(p[f].data,n)),o=p[f],i||(o.data||(o.data={}),o=o.data),r!==t&&(o[b.camelCase(n)]=r),u?(a=o[n],null==a&&(a=o[b.camelCase(n)])):a=o,a}}function R(e,t,n){if(b.acceptData(e)){var r,i,o,a=e.nodeType,s=a?b.cache:e,u=a?e[b.expando]:b.expando;if(s[u]){if(t&&(o=n?s[u]:s[u].data)){b.isArray(t)?t=t.concat(b.map(t,b.camelCase)):t in o?t=[t]:(t=b.camelCase(t),t=t in o?[t]:t.split(" "));for(r=0,i=t.length;i>r;r++)delete o[t[r]];if(!(n?$:b.isEmptyObject)(o))return}(n||(delete s[u].data,$(s[u])))&&(a?b.cleanData([e],!0):b.support.deleteExpando||s!=s.window?delete s[u]:s[u]=null)}}}b.extend({cache:{},expando:"jQuery"+(p+Math.random()).replace(/\D/g,""),noData:{embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",applet:!0},hasData:function(e){return e=e.nodeType?b.cache[e[b.expando]]:e[b.expando],!!e&&!$(e)},data:function(e,t,n){return P(e,t,n)},removeData:function(e,t){return R(e,t)},_data:function(e,t,n){return P(e,t,n,!0)},_removeData:function(e,t){return R(e,t,!0)},acceptData:function(e){if(e.nodeType&&1!==e.nodeType&&9!==e.nodeType)return!1;var t=e.nodeName&&b.noData[e.nodeName.toLowerCase()];return!t||t!==!0&&e.getAttribute("classid")===t}}),b.fn.extend({data:function(e,n){var r,i,o=this[0],a=0,s=null;if(e===t){if(this.length&&(s=b.data(o),1===o.nodeType&&!b._data(o,"parsedAttrs"))){for(r=o.attributes;r.length>a;a++)i=r[a].name,i.indexOf("data-")||(i=b.camelCase(i.slice(5)),W(o,i,s[i]));b._data(o,"parsedAttrs",!0)}return s}return"object"==typeof e?this.each(function(){b.data(this,e)}):b.access(this,function(n){return n===t?o?W(o,e,b.data(o,e)):null:(this.each(function(){b.data(this,e,n)}),t)},null,n,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){b.removeData(this,e)})}});function W(e,n,r){if(r===t&&1===e.nodeType){var i="data-"+n.replace(B,"-$1").toLowerCase();if(r=e.getAttribute(i),"string"==typeof r){try{r="true"===r?!0:"false"===r?!1:"null"===r?null:+r+""===r?+r:O.test(r)?b.parseJSON(r):r}catch(o){}b.data(e,n,r)}else r=t}return r}function $(e){var t;for(t in e)if(("data"!==t||!b.isEmptyObject(e[t]))&&"toJSON"!==t)return!1;return!0}b.extend({queue:function(e,n,r){var i;return e?(n=(n||"fx")+"queue",i=b._data(e,n),r&&(!i||b.isArray(r)?i=b._data(e,n,b.makeArray(r)):i.push(r)),i||[]):t},dequeue:function(e,t){t=t||"fx";var n=b.queue(e,t),r=n.length,i=n.shift(),o=b._queueHooks(e,t),a=function(){b.dequeue(e,t)};"inprogress"===i&&(i=n.shift(),r--),o.cur=i,i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return b._data(e,n)||b._data(e,n,{empty:b.Callbacks("once memory").add(function(){b._removeData(e,t+"queue"),b._removeData(e,n)})})}}),b.fn.extend({queue:function(e,n){var r=2;return"string"!=typeof e&&(n=e,e="fx",r--),r>arguments.length?b.queue(this[0],e):n===t?this:this.each(function(){var t=b.queue(this,e,n);b._queueHooks(this,e),"fx"===e&&"inprogress"!==t[0]&&b.dequeue(this,e)})},dequeue:function(e){return this.each(function(){b.dequeue(this,e)})},delay:function(e,t){return e=b.fx?b.fx.speeds[e]||e:e,t=t||"fx",this.queue(t,function(t,n){var r=setTimeout(t,e);n.stop=function(){clearTimeout(r)}})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,n){var r,i=1,o=b.Deferred(),a=this,s=this.length,u=function(){--i||o.resolveWith(a,[a])};"string"!=typeof e&&(n=e,e=t),e=e||"fx";while(s--)r=b._data(a[s],e+"queueHooks"),r&&r.empty&&(i++,r.empty.add(u));return u(),o.promise(n)}});var I,z,X=/[\t\r\n]/g,U=/\r/g,V=/^(?:input|select|textarea|button|object)$/i,Y=/^(?:a|area)$/i,J=/^(?:checked|selected|autofocus|autoplay|async|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped)$/i,G=/^(?:checked|selected)$/i,Q=b.support.getSetAttribute,K=b.support.input;b.fn.extend({attr:function(e,t){return b.access(this,b.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){b.removeAttr(this,e)})},prop:function(e,t){return b.access(this,b.prop,e,t,arguments.length>1)},removeProp:function(e){return e=b.propFix[e]||e,this.each(function(){try{this[e]=t,delete this[e]}catch(n){}})},addClass:function(e){var t,n,r,i,o,a=0,s=this.length,u="string"==typeof e&&e;if(b.isFunction(e))return this.each(function(t){b(this).addClass(e.call(this,t,this.className))});if(u)for(t=(e||"").match(w)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(X," "):" ")){o=0;while(i=t[o++])0>r.indexOf(" "+i+" ")&&(r+=i+" ");n.className=b.trim(r)}return this},removeClass:function(e){var t,n,r,i,o,a=0,s=this.length,u=0===arguments.length||"string"==typeof e&&e;if(b.isFunction(e))return this.each(function(t){b(this).removeClass(e.call(this,t,this.className))});if(u)for(t=(e||"").match(w)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(X," "):"")){o=0;while(i=t[o++])while(r.indexOf(" "+i+" ")>=0)r=r.replace(" "+i+" "," ");n.className=e?b.trim(r):""}return this},toggleClass:function(e,t){var n=typeof e,r="boolean"==typeof t;return b.isFunction(e)?this.each(function(n){b(this).toggleClass(e.call(this,n,this.className,t),t)}):this.each(function(){if("string"===n){var o,a=0,s=b(this),u=t,l=e.match(w)||[];while(o=l[a++])u=r?u:!s.hasClass(o),s[u?"addClass":"removeClass"](o)}else(n===i||"boolean"===n)&&(this.className&&b._data(this,"__className__",this.className),this.className=this.className||e===!1?"":b._data(this,"__className__")||"")})},hasClass:function(e){var t=" "+e+" ",n=0,r=this.length;for(;r>n;n++)if(1===this[n].nodeType&&(" "+this[n].className+" ").replace(X," ").indexOf(t)>=0)return!0;return!1},val:function(e){var n,r,i,o=this[0];{if(arguments.length)return i=b.isFunction(e),this.each(function(n){var o,a=b(this);1===this.nodeType&&(o=i?e.call(this,n,a.val()):e,null==o?o="":"number"==typeof o?o+="":b.isArray(o)&&(o=b.map(o,function(e){return null==e?"":e+""})),r=b.valHooks[this.type]||b.valHooks[this.nodeName.toLowerCase()],r&&"set"in r&&r.set(this,o,"value")!==t||(this.value=o))});if(o)return r=b.valHooks[o.type]||b.valHooks[o.nodeName.toLowerCase()],r&&"get"in r&&(n=r.get(o,"value"))!==t?n:(n=o.value,"string"==typeof n?n.replace(U,""):null==n?"":n)}}}),b.extend({valHooks:{option:{get:function(e){var t=e.attributes.value;return!t||t.specified?e.value:e.text}},select:{get:function(e){var t,n,r=e.options,i=e.selectedIndex,o="select-one"===e.type||0>i,a=o?null:[],s=o?i+1:r.length,u=0>i?s:o?i:0;for(;s>u;u++)if(n=r[u],!(!n.selected&&u!==i||(b.support.optDisabled?n.disabled:null!==n.getAttribute("disabled"))||n.parentNode.disabled&&b.nodeName(n.parentNode,"optgroup"))){if(t=b(n).val(),o)return t;a.push(t)}return a},set:function(e,t){var n=b.makeArray(t);return b(e).find("option").each(function(){this.selected=b.inArray(b(this).val(),n)>=0}),n.length||(e.selectedIndex=-1),n}}},attr:function(e,n,r){var o,a,s,u=e.nodeType;if(e&&3!==u&&8!==u&&2!==u)return typeof e.getAttribute===i?b.prop(e,n,r):(a=1!==u||!b.isXMLDoc(e),a&&(n=n.toLowerCase(),o=b.attrHooks[n]||(J.test(n)?z:I)),r===t?o&&a&&"get"in o&&null!==(s=o.get(e,n))?s:(typeof e.getAttribute!==i&&(s=e.getAttribute(n)),null==s?t:s):null!==r?o&&a&&"set"in o&&(s=o.set(e,r,n))!==t?s:(e.setAttribute(n,r+""),r):(b.removeAttr(e,n),t))},removeAttr:function(e,t){var n,r,i=0,o=t&&t.match(w);if(o&&1===e.nodeType)while(n=o[i++])r=b.propFix[n]||n,J.test(n)?!Q&&G.test(n)?e[b.camelCase("default-"+n)]=e[r]=!1:e[r]=!1:b.attr(e,n,""),e.removeAttribute(Q?n:r)},attrHooks:{type:{set:function(e,t){if(!b.support.radioValue&&"radio"===t&&b.nodeName(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},propFix:{tabindex:"tabIndex",readonly:"readOnly","for":"htmlFor","class":"className",maxlength:"maxLength",cellspacing:"cellSpacing",cellpadding:"cellPadding",rowspan:"rowSpan",colspan:"colSpan",usemap:"useMap",frameborder:"frameBorder",contenteditable:"contentEditable"},prop:function(e,n,r){var i,o,a,s=e.nodeType;if(e&&3!==s&&8!==s&&2!==s)return a=1!==s||!b.isXMLDoc(e),a&&(n=b.propFix[n]||n,o=b.propHooks[n]),r!==t?o&&"set"in o&&(i=o.set(e,r,n))!==t?i:e[n]=r:o&&"get"in o&&null!==(i=o.get(e,n))?i:e[n]},propHooks:{tabIndex:{get:function(e){var n=e.getAttributeNode("tabindex");return n&&n.specified?parseInt(n.value,10):V.test(e.nodeName)||Y.test(e.nodeName)&&e.href?0:t}}}}),z={get:function(e,n){var r=b.prop(e,n),i="boolean"==typeof r&&e.getAttribute(n),o="boolean"==typeof r?K&&Q?null!=i:G.test(n)?e[b.camelCase("default-"+n)]:!!i:e.getAttributeNode(n);return o&&o.value!==!1?n.toLowerCase():t},set:function(e,t,n){return t===!1?b.removeAttr(e,n):K&&Q||!G.test(n)?e.setAttribute(!Q&&b.propFix[n]||n,n):e[b.camelCase("default-"+n)]=e[n]=!0,n}},K&&Q||(b.attrHooks.value={get:function(e,n){var r=e.getAttributeNode(n);return b.nodeName(e,"input")?e.defaultValue:r&&r.specified?r.value:t},set:function(e,n,r){return b.nodeName(e,"input")?(e.defaultValue=n,t):I&&I.set(e,n,r)}}),Q||(I=b.valHooks.button={get:function(e,n){var r=e.getAttributeNode(n);return r&&("id"===n||"name"===n||"coords"===n?""!==r.value:r.specified)?r.value:t},set:function(e,n,r){var i=e.getAttributeNode(r);return i||e.setAttributeNode(i=e.ownerDocument.createAttribute(r)),i.value=n+="","value"===r||n===e.getAttribute(r)?n:t}},b.attrHooks.contenteditable={get:I.get,set:function(e,t,n){I.set(e,""===t?!1:t,n)}},b.each(["width","height"],function(e,n){b.attrHooks[n]=b.extend(b.attrHooks[n],{set:function(e,r){return""===r?(e.setAttribute(n,"auto"),r):t}})})),b.support.hrefNormalized||(b.each(["href","src","width","height"],function(e,n){b.attrHooks[n]=b.extend(b.attrHooks[n],{get:function(e){var r=e.getAttribute(n,2);return null==r?t:r}})}),b.each(["href","src"],function(e,t){b.propHooks[t]={get:function(e){return e.getAttribute(t,4)}}})),b.support.style||(b.attrHooks.style={get:function(e){return e.style.cssText||t},set:function(e,t){return e.style.cssText=t+""}}),b.support.optSelected||(b.propHooks.selected=b.extend(b.propHooks.selected,{get:function(e){var t=e.parentNode;return t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex),null}})),b.support.enctype||(b.propFix.enctype="encoding"),b.support.checkOn||b.each(["radio","checkbox"],function(){b.valHooks[this]={get:function(e){return null===e.getAttribute("value")?"on":e.value}}}),b.each(["radio","checkbox"],function(){b.valHooks[this]=b.extend(b.valHooks[this],{set:function(e,n){return b.isArray(n)?e.checked=b.inArray(b(e).val(),n)>=0:t}})});var Z=/^(?:input|select|textarea)$/i,et=/^key/,tt=/^(?:mouse|contextmenu)|click/,nt=/^(?:focusinfocus|focusoutblur)$/,rt=/^([^.]*)(?:\.(.+)|)$/;function it(){return!0}function ot(){return!1}b.event={global:{},add:function(e,n,r,o,a){var s,u,l,c,p,f,d,h,g,m,y,v=b._data(e);if(v){r.handler&&(c=r,r=c.handler,a=c.selector),r.guid||(r.guid=b.guid++),(u=v.events)||(u=v.events={}),(f=v.handle)||(f=v.handle=function(e){return typeof b===i||e&&b.event.triggered===e.type?t:b.event.dispatch.apply(f.elem,arguments)},f.elem=e),n=(n||"").match(w)||[""],l=n.length;while(l--)s=rt.exec(n[l])||[],g=y=s[1],m=(s[2]||"").split(".").sort(),p=b.event.special[g]||{},g=(a?p.delegateType:p.bindType)||g,p=b.event.special[g]||{},d=b.extend({type:g,origType:y,data:o,handler:r,guid:r.guid,selector:a,needsContext:a&&b.expr.match.needsContext.test(a),namespace:m.join(".")},c),(h=u[g])||(h=u[g]=[],h.delegateCount=0,p.setup&&p.setup.call(e,o,m,f)!==!1||(e.addEventListener?e.addEventListener(g,f,!1):e.attachEvent&&e.attachEvent("on"+g,f))),p.add&&(p.add.call(e,d),d.handler.guid||(d.handler.guid=r.guid)),a?h.splice(h.delegateCount++,0,d):h.push(d),b.event.global[g]=!0;e=null}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,p,f,d,h,g,m=b.hasData(e)&&b._data(e);if(m&&(c=m.events)){t=(t||"").match(w)||[""],l=t.length;while(l--)if(s=rt.exec(t[l])||[],d=g=s[1],h=(s[2]||"").split(".").sort(),d){p=b.event.special[d]||{},d=(r?p.delegateType:p.bindType)||d,f=c[d]||[],s=s[2]&&RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),u=o=f.length;while(o--)a=f[o],!i&&g!==a.origType||n&&n.guid!==a.guid||s&&!s.test(a.namespace)||r&&r!==a.selector&&("**"!==r||!a.selector)||(f.splice(o,1),a.selector&&f.delegateCount--,p.remove&&p.remove.call(e,a));u&&!f.length&&(p.teardown&&p.teardown.call(e,h,m.handle)!==!1||b.removeEvent(e,d,m.handle),delete c[d])}else for(d in c)b.event.remove(e,d+t[l],n,r,!0);b.isEmptyObject(c)&&(delete m.handle,b._removeData(e,"events"))}},trigger:function(n,r,i,a){var s,u,l,c,p,f,d,h=[i||o],g=y.call(n,"type")?n.type:n,m=y.call(n,"namespace")?n.namespace.split("."):[];if(l=f=i=i||o,3!==i.nodeType&&8!==i.nodeType&&!nt.test(g+b.event.triggered)&&(g.indexOf(".")>=0&&(m=g.split("."),g=m.shift(),m.sort()),u=0>g.indexOf(":")&&"on"+g,n=n[b.expando]?n:new b.Event(g,"object"==typeof n&&n),n.isTrigger=!0,n.namespace=m.join("."),n.namespace_re=n.namespace?RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,n.result=t,n.target||(n.target=i),r=null==r?[n]:b.makeArray(r,[n]),p=b.event.special[g]||{},a||!p.trigger||p.trigger.apply(i,r)!==!1)){if(!a&&!p.noBubble&&!b.isWindow(i)){for(c=p.delegateType||g,nt.test(c+g)||(l=l.parentNode);l;l=l.parentNode)h.push(l),f=l;f===(i.ownerDocument||o)&&h.push(f.defaultView||f.parentWindow||e)}d=0;while((l=h[d++])&&!n.isPropagationStopped())n.type=d>1?c:p.bindType||g,s=(b._data(l,"events")||{})[n.type]&&b._data(l,"handle"),s&&s.apply(l,r),s=u&&l[u],s&&b.acceptData(l)&&s.apply&&s.apply(l,r)===!1&&n.preventDefault();if(n.type=g,!(a||n.isDefaultPrevented()||p._default&&p._default.apply(i.ownerDocument,r)!==!1||"click"===g&&b.nodeName(i,"a")||!b.acceptData(i)||!u||!i[g]||b.isWindow(i))){f=i[u],f&&(i[u]=null),b.event.triggered=g;try{i[g]()}catch(v){}b.event.triggered=t,f&&(i[u]=f)}return n.result}},dispatch:function(e){e=b.event.fix(e);var n,r,i,o,a,s=[],u=h.call(arguments),l=(b._data(this,"events")||{})[e.type]||[],c=b.event.special[e.type]||{};if(u[0]=e,e.delegateTarget=this,!c.preDispatch||c.preDispatch.call(this,e)!==!1){s=b.event.handlers.call(this,e,l),n=0;while((o=s[n++])&&!e.isPropagationStopped()){e.currentTarget=o.elem,a=0;while((i=o.handlers[a++])&&!e.isImmediatePropagationStopped())(!e.namespace_re||e.namespace_re.test(i.namespace))&&(e.handleObj=i,e.data=i.data,r=((b.event.special[i.origType]||{}).handle||i.handler).apply(o.elem,u),r!==t&&(e.result=r)===!1&&(e.preventDefault(),e.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,e),e.result}},handlers:function(e,n){var r,i,o,a,s=[],u=n.delegateCount,l=e.target;if(u&&l.nodeType&&(!e.button||"click"!==e.type))for(;l!=this;l=l.parentNode||this)if(1===l.nodeType&&(l.disabled!==!0||"click"!==e.type)){for(o=[],a=0;u>a;a++)i=n[a],r=i.selector+" ",o[r]===t&&(o[r]=i.needsContext?b(r,this).index(l)>=0:b.find(r,this,null,[l]).length),o[r]&&o.push(i);o.length&&s.push({elem:l,handlers:o})}return n.length>u&&s.push({elem:this,handlers:n.slice(u)}),s},fix:function(e){if(e[b.expando])return e;var t,n,r,i=e.type,a=e,s=this.fixHooks[i];s||(this.fixHooks[i]=s=tt.test(i)?this.mouseHooks:et.test(i)?this.keyHooks:{}),r=s.props?this.props.concat(s.props):this.props,e=new b.Event(a),t=r.length;while(t--)n=r[t],e[n]=a[n];return e.target||(e.target=a.srcElement||o),3===e.target.nodeType&&(e.target=e.target.parentNode),e.metaKey=!!e.metaKey,s.filter?s.filter(e,a):e},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(e,t){return null==e.which&&(e.which=null!=t.charCode?t.charCode:t.keyCode),e}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(e,n){var r,i,a,s=n.button,u=n.fromElement;return null==e.pageX&&null!=n.clientX&&(i=e.target.ownerDocument||o,a=i.documentElement,r=i.body,e.pageX=n.clientX+(a&&a.scrollLeft||r&&r.scrollLeft||0)-(a&&a.clientLeft||r&&r.clientLeft||0),e.pageY=n.clientY+(a&&a.scrollTop||r&&r.scrollTop||0)-(a&&a.clientTop||r&&r.clientTop||0)),!e.relatedTarget&&u&&(e.relatedTarget=u===e.target?n.toElement:u),e.which||s===t||(e.which=1&s?1:2&s?3:4&s?2:0),e}},special:{load:{noBubble:!0},click:{trigger:function(){return b.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):t}},focus:{trigger:function(){if(this!==o.activeElement&&this.focus)try{return this.focus(),!1}catch(e){}},delegateType:"focusin"},blur:{trigger:function(){return this===o.activeElement&&this.blur?(this.blur(),!1):t},delegateType:"focusout"},beforeunload:{postDispatch:function(e){e.result!==t&&(e.originalEvent.returnValue=e.result)}}},simulate:function(e,t,n,r){var i=b.extend(new b.Event,n,{type:e,isSimulated:!0,originalEvent:{}});r?b.event.trigger(i,null,t):b.event.dispatch.call(t,i),i.isDefaultPrevented()&&n.preventDefault()}},b.removeEvent=o.removeEventListener?function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n,!1)}:function(e,t,n){var r="on"+t;e.detachEvent&&(typeof e[r]===i&&(e[r]=null),e.detachEvent(r,n))},b.Event=function(e,n){return this instanceof b.Event?(e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||e.returnValue===!1||e.getPreventDefault&&e.getPreventDefault()?it:ot):this.type=e,n&&b.extend(this,n),this.timeStamp=e&&e.timeStamp||b.now(),this[b.expando]=!0,t):new b.Event(e,n)},b.Event.prototype={isDefaultPrevented:ot,isPropagationStopped:ot,isImmediatePropagationStopped:ot,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=it,e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=it,e&&(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=it,this.stopPropagation()}},b.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(e,t){b.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;
return(!i||i!==r&&!b.contains(r,i))&&(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),b.support.submitBubbles||(b.event.special.submit={setup:function(){return b.nodeName(this,"form")?!1:(b.event.add(this,"click._submit keypress._submit",function(e){var n=e.target,r=b.nodeName(n,"input")||b.nodeName(n,"button")?n.form:t;r&&!b._data(r,"submitBubbles")&&(b.event.add(r,"submit._submit",function(e){e._submit_bubble=!0}),b._data(r,"submitBubbles",!0))}),t)},postDispatch:function(e){e._submit_bubble&&(delete e._submit_bubble,this.parentNode&&!e.isTrigger&&b.event.simulate("submit",this.parentNode,e,!0))},teardown:function(){return b.nodeName(this,"form")?!1:(b.event.remove(this,"._submit"),t)}}),b.support.changeBubbles||(b.event.special.change={setup:function(){return Z.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(b.event.add(this,"propertychange._change",function(e){"checked"===e.originalEvent.propertyName&&(this._just_changed=!0)}),b.event.add(this,"click._change",function(e){this._just_changed&&!e.isTrigger&&(this._just_changed=!1),b.event.simulate("change",this,e,!0)})),!1):(b.event.add(this,"beforeactivate._change",function(e){var t=e.target;Z.test(t.nodeName)&&!b._data(t,"changeBubbles")&&(b.event.add(t,"change._change",function(e){!this.parentNode||e.isSimulated||e.isTrigger||b.event.simulate("change",this.parentNode,e,!0)}),b._data(t,"changeBubbles",!0))}),t)},handle:function(e){var n=e.target;return this!==n||e.isSimulated||e.isTrigger||"radio"!==n.type&&"checkbox"!==n.type?e.handleObj.handler.apply(this,arguments):t},teardown:function(){return b.event.remove(this,"._change"),!Z.test(this.nodeName)}}),b.support.focusinBubbles||b.each({focus:"focusin",blur:"focusout"},function(e,t){var n=0,r=function(e){b.event.simulate(t,e.target,b.event.fix(e),!0)};b.event.special[t]={setup:function(){0===n++&&o.addEventListener(e,r,!0)},teardown:function(){0===--n&&o.removeEventListener(e,r,!0)}}}),b.fn.extend({on:function(e,n,r,i,o){var a,s;if("object"==typeof e){"string"!=typeof n&&(r=r||n,n=t);for(a in e)this.on(a,n,r,e[a],o);return this}if(null==r&&null==i?(i=n,r=n=t):null==i&&("string"==typeof n?(i=r,r=t):(i=r,r=n,n=t)),i===!1)i=ot;else if(!i)return this;return 1===o&&(s=i,i=function(e){return b().off(e),s.apply(this,arguments)},i.guid=s.guid||(s.guid=b.guid++)),this.each(function(){b.event.add(this,e,i,r,n)})},one:function(e,t,n,r){return this.on(e,t,n,r,1)},off:function(e,n,r){var i,o;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,b(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(o in e)this.off(o,n,e[o]);return this}return(n===!1||"function"==typeof n)&&(r=n,n=t),r===!1&&(r=ot),this.each(function(){b.event.remove(this,e,r,n)})},bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},trigger:function(e,t){return this.each(function(){b.event.trigger(e,t,this)})},triggerHandler:function(e,n){var r=this[0];return r?b.event.trigger(e,n,r,!0):t}}),function(e,t){var n,r,i,o,a,s,u,l,c,p,f,d,h,g,m,y,v,x="sizzle"+-new Date,w=e.document,T={},N=0,C=0,k=it(),E=it(),S=it(),A=typeof t,j=1<<31,D=[],L=D.pop,H=D.push,q=D.slice,M=D.indexOf||function(e){var t=0,n=this.length;for(;n>t;t++)if(this[t]===e)return t;return-1},_="[\\x20\\t\\r\\n\\f]",F="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",O=F.replace("w","w#"),B="([*^$|!~]?=)",P="\\["+_+"*("+F+")"+_+"*(?:"+B+_+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+O+")|)|)"+_+"*\\]",R=":("+F+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+P.replace(3,8)+")*)|.*)\\)|)",W=RegExp("^"+_+"+|((?:^|[^\\\\])(?:\\\\.)*)"+_+"+$","g"),$=RegExp("^"+_+"*,"+_+"*"),I=RegExp("^"+_+"*([\\x20\\t\\r\\n\\f>+~])"+_+"*"),z=RegExp(R),X=RegExp("^"+O+"$"),U={ID:RegExp("^#("+F+")"),CLASS:RegExp("^\\.("+F+")"),NAME:RegExp("^\\[name=['\"]?("+F+")['\"]?\\]"),TAG:RegExp("^("+F.replace("w","w*")+")"),ATTR:RegExp("^"+P),PSEUDO:RegExp("^"+R),CHILD:RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+_+"*(even|odd|(([+-]|)(\\d*)n|)"+_+"*(?:([+-]|)"+_+"*(\\d+)|))"+_+"*\\)|)","i"),needsContext:RegExp("^"+_+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+_+"*((?:-\\d)?\\d*)"+_+"*\\)|)(?=[^-]|$)","i")},V=/[\x20\t\r\n\f]*[+~]/,Y=/^[^{]+\{\s*\[native code/,J=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,G=/^(?:input|select|textarea|button)$/i,Q=/^h\d$/i,K=/'|\\/g,Z=/\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,et=/\\([\da-fA-F]{1,6}[\x20\t\r\n\f]?|.)/g,tt=function(e,t){var n="0x"+t-65536;return n!==n?t:0>n?String.fromCharCode(n+65536):String.fromCharCode(55296|n>>10,56320|1023&n)};try{q.call(w.documentElement.childNodes,0)[0].nodeType}catch(nt){q=function(e){var t,n=[];while(t=this[e++])n.push(t);return n}}function rt(e){return Y.test(e+"")}function it(){var e,t=[];return e=function(n,r){return t.push(n+=" ")>i.cacheLength&&delete e[t.shift()],e[n]=r}}function ot(e){return e[x]=!0,e}function at(e){var t=p.createElement("div");try{return e(t)}catch(n){return!1}finally{t=null}}function st(e,t,n,r){var i,o,a,s,u,l,f,g,m,v;if((t?t.ownerDocument||t:w)!==p&&c(t),t=t||p,n=n||[],!e||"string"!=typeof e)return n;if(1!==(s=t.nodeType)&&9!==s)return[];if(!d&&!r){if(i=J.exec(e))if(a=i[1]){if(9===s){if(o=t.getElementById(a),!o||!o.parentNode)return n;if(o.id===a)return n.push(o),n}else if(t.ownerDocument&&(o=t.ownerDocument.getElementById(a))&&y(t,o)&&o.id===a)return n.push(o),n}else{if(i[2])return H.apply(n,q.call(t.getElementsByTagName(e),0)),n;if((a=i[3])&&T.getByClassName&&t.getElementsByClassName)return H.apply(n,q.call(t.getElementsByClassName(a),0)),n}if(T.qsa&&!h.test(e)){if(f=!0,g=x,m=t,v=9===s&&e,1===s&&"object"!==t.nodeName.toLowerCase()){l=ft(e),(f=t.getAttribute("id"))?g=f.replace(K,"\\$&"):t.setAttribute("id",g),g="[id='"+g+"'] ",u=l.length;while(u--)l[u]=g+dt(l[u]);m=V.test(e)&&t.parentNode||t,v=l.join(",")}if(v)try{return H.apply(n,q.call(m.querySelectorAll(v),0)),n}catch(b){}finally{f||t.removeAttribute("id")}}}return wt(e.replace(W,"$1"),t,n,r)}a=st.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return t?"HTML"!==t.nodeName:!1},c=st.setDocument=function(e){var n=e?e.ownerDocument||e:w;return n!==p&&9===n.nodeType&&n.documentElement?(p=n,f=n.documentElement,d=a(n),T.tagNameNoComments=at(function(e){return e.appendChild(n.createComment("")),!e.getElementsByTagName("*").length}),T.attributes=at(function(e){e.innerHTML="<select></select>";var t=typeof e.lastChild.getAttribute("multiple");return"boolean"!==t&&"string"!==t}),T.getByClassName=at(function(e){return e.innerHTML="<div class='hidden e'></div><div class='hidden'></div>",e.getElementsByClassName&&e.getElementsByClassName("e").length?(e.lastChild.className="e",2===e.getElementsByClassName("e").length):!1}),T.getByName=at(function(e){e.id=x+0,e.innerHTML="<a name='"+x+"'></a><div name='"+x+"'></div>",f.insertBefore(e,f.firstChild);var t=n.getElementsByName&&n.getElementsByName(x).length===2+n.getElementsByName(x+0).length;return T.getIdNotName=!n.getElementById(x),f.removeChild(e),t}),i.attrHandle=at(function(e){return e.innerHTML="<a href='#'></a>",e.firstChild&&typeof e.firstChild.getAttribute!==A&&"#"===e.firstChild.getAttribute("href")})?{}:{href:function(e){return e.getAttribute("href",2)},type:function(e){return e.getAttribute("type")}},T.getIdNotName?(i.find.ID=function(e,t){if(typeof t.getElementById!==A&&!d){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}},i.filter.ID=function(e){var t=e.replace(et,tt);return function(e){return e.getAttribute("id")===t}}):(i.find.ID=function(e,n){if(typeof n.getElementById!==A&&!d){var r=n.getElementById(e);return r?r.id===e||typeof r.getAttributeNode!==A&&r.getAttributeNode("id").value===e?[r]:t:[]}},i.filter.ID=function(e){var t=e.replace(et,tt);return function(e){var n=typeof e.getAttributeNode!==A&&e.getAttributeNode("id");return n&&n.value===t}}),i.find.TAG=T.tagNameNoComments?function(e,n){return typeof n.getElementsByTagName!==A?n.getElementsByTagName(e):t}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},i.find.NAME=T.getByName&&function(e,n){return typeof n.getElementsByName!==A?n.getElementsByName(name):t},i.find.CLASS=T.getByClassName&&function(e,n){return typeof n.getElementsByClassName===A||d?t:n.getElementsByClassName(e)},g=[],h=[":focus"],(T.qsa=rt(n.querySelectorAll))&&(at(function(e){e.innerHTML="<select><option selected=''></option></select>",e.querySelectorAll("[selected]").length||h.push("\\["+_+"*(?:checked|disabled|ismap|multiple|readonly|selected|value)"),e.querySelectorAll(":checked").length||h.push(":checked")}),at(function(e){e.innerHTML="<input type='hidden' i=''/>",e.querySelectorAll("[i^='']").length&&h.push("[*^$]="+_+"*(?:\"\"|'')"),e.querySelectorAll(":enabled").length||h.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),h.push(",.*:")})),(T.matchesSelector=rt(m=f.matchesSelector||f.mozMatchesSelector||f.webkitMatchesSelector||f.oMatchesSelector||f.msMatchesSelector))&&at(function(e){T.disconnectedMatch=m.call(e,"div"),m.call(e,"[s!='']:x"),g.push("!=",R)}),h=RegExp(h.join("|")),g=RegExp(g.join("|")),y=rt(f.contains)||f.compareDocumentPosition?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},v=f.compareDocumentPosition?function(e,t){var r;return e===t?(u=!0,0):(r=t.compareDocumentPosition&&e.compareDocumentPosition&&e.compareDocumentPosition(t))?1&r||e.parentNode&&11===e.parentNode.nodeType?e===n||y(w,e)?-1:t===n||y(w,t)?1:0:4&r?-1:1:e.compareDocumentPosition?-1:1}:function(e,t){var r,i=0,o=e.parentNode,a=t.parentNode,s=[e],l=[t];if(e===t)return u=!0,0;if(!o||!a)return e===n?-1:t===n?1:o?-1:a?1:0;if(o===a)return ut(e,t);r=e;while(r=r.parentNode)s.unshift(r);r=t;while(r=r.parentNode)l.unshift(r);while(s[i]===l[i])i++;return i?ut(s[i],l[i]):s[i]===w?-1:l[i]===w?1:0},u=!1,[0,0].sort(v),T.detectDuplicates=u,p):p},st.matches=function(e,t){return st(e,null,null,t)},st.matchesSelector=function(e,t){if((e.ownerDocument||e)!==p&&c(e),t=t.replace(Z,"='$1']"),!(!T.matchesSelector||d||g&&g.test(t)||h.test(t)))try{var n=m.call(e,t);if(n||T.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(r){}return st(t,p,null,[e]).length>0},st.contains=function(e,t){return(e.ownerDocument||e)!==p&&c(e),y(e,t)},st.attr=function(e,t){var n;return(e.ownerDocument||e)!==p&&c(e),d||(t=t.toLowerCase()),(n=i.attrHandle[t])?n(e):d||T.attributes?e.getAttribute(t):((n=e.getAttributeNode(t))||e.getAttribute(t))&&e[t]===!0?t:n&&n.specified?n.value:null},st.error=function(e){throw Error("Syntax error, unrecognized expression: "+e)},st.uniqueSort=function(e){var t,n=[],r=1,i=0;if(u=!T.detectDuplicates,e.sort(v),u){for(;t=e[r];r++)t===e[r-1]&&(i=n.push(r));while(i--)e.splice(n[i],1)}return e};function ut(e,t){var n=t&&e,r=n&&(~t.sourceIndex||j)-(~e.sourceIndex||j);if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function lt(e){return function(t){var n=t.nodeName.toLowerCase();return"input"===n&&t.type===e}}function ct(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function pt(e){return ot(function(t){return t=+t,ot(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}o=st.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r];r++)n+=o(t);return n},i=st.selectors={cacheLength:50,createPseudo:ot,match:U,find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(et,tt),e[3]=(e[4]||e[5]||"").replace(et,tt),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||st.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&st.error(e[0]),e},PSEUDO:function(e){var t,n=!e[5]&&e[2];return U.CHILD.test(e[0])?null:(e[4]?e[2]=e[4]:n&&z.test(n)&&(t=ft(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){return"*"===e?function(){return!0}:(e=e.replace(et,tt).toLowerCase(),function(t){return t.nodeName&&t.nodeName.toLowerCase()===e})},CLASS:function(e){var t=k[e+" "];return t||(t=RegExp("(^|"+_+")"+e+"("+_+"|$)"))&&k(e,function(e){return t.test(e.className||typeof e.getAttribute!==A&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=st.attr(r,e);return null==i?"!="===t:t?(i+="","="===t?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i+" ").indexOf(n)>-1:"|="===t?i===n||i.slice(0,n.length+1)===n+"-":!1):!0}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,p,f,d,h,g=o!==a?"nextSibling":"previousSibling",m=t.parentNode,y=s&&t.nodeName.toLowerCase(),v=!u&&!s;if(m){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===y:1===p.nodeType)return!1;h=g="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?m.firstChild:m.lastChild],a&&v){c=m[x]||(m[x]={}),l=c[e]||[],d=l[0]===N&&l[1],f=l[0]===N&&l[2],p=d&&m.childNodes[d];while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if(1===p.nodeType&&++f&&p===t){c[e]=[N,d,f];break}}else if(v&&(l=(t[x]||(t[x]={}))[e])&&l[0]===N)f=l[1];else while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===y:1===p.nodeType)&&++f&&(v&&((p[x]||(p[x]={}))[e]=[N,f]),p===t))break;return f-=i,f===r||0===f%r&&f/r>=0}}},PSEUDO:function(e,t){var n,r=i.pseudos[e]||i.setFilters[e.toLowerCase()]||st.error("unsupported pseudo: "+e);return r[x]?r(t):r.length>1?(n=[e,e,"",t],i.setFilters.hasOwnProperty(e.toLowerCase())?ot(function(e,n){var i,o=r(e,t),a=o.length;while(a--)i=M.call(e,o[a]),e[i]=!(n[i]=o[a])}):function(e){return r(e,0,n)}):r}},pseudos:{not:ot(function(e){var t=[],n=[],r=s(e.replace(W,"$1"));return r[x]?ot(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),!n.pop()}}),has:ot(function(e){return function(t){return st(e,t).length>0}}),contains:ot(function(e){return function(t){return(t.textContent||t.innerText||o(t)).indexOf(e)>-1}}),lang:ot(function(e){return X.test(e||"")||st.error("unsupported lang: "+e),e=e.replace(et,tt).toLowerCase(),function(t){var n;do if(n=d?t.getAttribute("xml:lang")||t.getAttribute("lang"):t.lang)return n=n.toLowerCase(),n===e||0===n.indexOf(e+"-");while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===f},focus:function(e){return e===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:function(e){return e.disabled===!1},disabled:function(e){return e.disabled===!0},checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,e.selected===!0},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeName>"@"||3===e.nodeType||4===e.nodeType)return!1;return!0},parent:function(e){return!i.pseudos.empty(e)},header:function(e){return Q.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||t.toLowerCase()===e.type)},first:pt(function(){return[0]}),last:pt(function(e,t){return[t-1]}),eq:pt(function(e,t,n){return[0>n?n+t:n]}),even:pt(function(e,t){var n=0;for(;t>n;n+=2)e.push(n);return e}),odd:pt(function(e,t){var n=1;for(;t>n;n+=2)e.push(n);return e}),lt:pt(function(e,t,n){var r=0>n?n+t:n;for(;--r>=0;)e.push(r);return e}),gt:pt(function(e,t,n){var r=0>n?n+t:n;for(;t>++r;)e.push(r);return e})}};for(n in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})i.pseudos[n]=lt(n);for(n in{submit:!0,reset:!0})i.pseudos[n]=ct(n);function ft(e,t){var n,r,o,a,s,u,l,c=E[e+" "];if(c)return t?0:c.slice(0);s=e,u=[],l=i.preFilter;while(s){(!n||(r=$.exec(s)))&&(r&&(s=s.slice(r[0].length)||s),u.push(o=[])),n=!1,(r=I.exec(s))&&(n=r.shift(),o.push({value:n,type:r[0].replace(W," ")}),s=s.slice(n.length));for(a in i.filter)!(r=U[a].exec(s))||l[a]&&!(r=l[a](r))||(n=r.shift(),o.push({value:n,type:a,matches:r}),s=s.slice(n.length));if(!n)break}return t?s.length:s?st.error(e):E(e,u).slice(0)}function dt(e){var t=0,n=e.length,r="";for(;n>t;t++)r+=e[t].value;return r}function ht(e,t,n){var i=t.dir,o=n&&"parentNode"===i,a=C++;return t.first?function(t,n,r){while(t=t[i])if(1===t.nodeType||o)return e(t,n,r)}:function(t,n,s){var u,l,c,p=N+" "+a;if(s){while(t=t[i])if((1===t.nodeType||o)&&e(t,n,s))return!0}else while(t=t[i])if(1===t.nodeType||o)if(c=t[x]||(t[x]={}),(l=c[i])&&l[0]===p){if((u=l[1])===!0||u===r)return u===!0}else if(l=c[i]=[p],l[1]=e(t,n,s)||r,l[1]===!0)return!0}}function gt(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function mt(e,t,n,r,i){var o,a=[],s=0,u=e.length,l=null!=t;for(;u>s;s++)(o=e[s])&&(!n||n(o,r,i))&&(a.push(o),l&&t.push(s));return a}function yt(e,t,n,r,i,o){return r&&!r[x]&&(r=yt(r)),i&&!i[x]&&(i=yt(i,o)),ot(function(o,a,s,u){var l,c,p,f=[],d=[],h=a.length,g=o||xt(t||"*",s.nodeType?[s]:s,[]),m=!e||!o&&t?g:mt(g,f,e,s,u),y=n?i||(o?e:h||r)?[]:a:m;if(n&&n(m,y,s,u),r){l=mt(y,d),r(l,[],s,u),c=l.length;while(c--)(p=l[c])&&(y[d[c]]=!(m[d[c]]=p))}if(o){if(i||e){if(i){l=[],c=y.length;while(c--)(p=y[c])&&l.push(m[c]=p);i(null,y=[],l,u)}c=y.length;while(c--)(p=y[c])&&(l=i?M.call(o,p):f[c])>-1&&(o[l]=!(a[l]=p))}}else y=mt(y===a?y.splice(h,y.length):y),i?i(null,a,y,u):H.apply(a,y)})}function vt(e){var t,n,r,o=e.length,a=i.relative[e[0].type],s=a||i.relative[" "],u=a?1:0,c=ht(function(e){return e===t},s,!0),p=ht(function(e){return M.call(t,e)>-1},s,!0),f=[function(e,n,r){return!a&&(r||n!==l)||((t=n).nodeType?c(e,n,r):p(e,n,r))}];for(;o>u;u++)if(n=i.relative[e[u].type])f=[ht(gt(f),n)];else{if(n=i.filter[e[u].type].apply(null,e[u].matches),n[x]){for(r=++u;o>r;r++)if(i.relative[e[r].type])break;return yt(u>1&&gt(f),u>1&&dt(e.slice(0,u-1)).replace(W,"$1"),n,r>u&&vt(e.slice(u,r)),o>r&&vt(e=e.slice(r)),o>r&&dt(e))}f.push(n)}return gt(f)}function bt(e,t){var n=0,o=t.length>0,a=e.length>0,s=function(s,u,c,f,d){var h,g,m,y=[],v=0,b="0",x=s&&[],w=null!=d,T=l,C=s||a&&i.find.TAG("*",d&&u.parentNode||u),k=N+=null==T?1:Math.random()||.1;for(w&&(l=u!==p&&u,r=n);null!=(h=C[b]);b++){if(a&&h){g=0;while(m=e[g++])if(m(h,u,c)){f.push(h);break}w&&(N=k,r=++n)}o&&((h=!m&&h)&&v--,s&&x.push(h))}if(v+=b,o&&b!==v){g=0;while(m=t[g++])m(x,y,u,c);if(s){if(v>0)while(b--)x[b]||y[b]||(y[b]=L.call(f));y=mt(y)}H.apply(f,y),w&&!s&&y.length>0&&v+t.length>1&&st.uniqueSort(f)}return w&&(N=k,l=T),x};return o?ot(s):s}s=st.compile=function(e,t){var n,r=[],i=[],o=S[e+" "];if(!o){t||(t=ft(e)),n=t.length;while(n--)o=vt(t[n]),o[x]?r.push(o):i.push(o);o=S(e,bt(i,r))}return o};function xt(e,t,n){var r=0,i=t.length;for(;i>r;r++)st(e,t[r],n);return n}function wt(e,t,n,r){var o,a,u,l,c,p=ft(e);if(!r&&1===p.length){if(a=p[0]=p[0].slice(0),a.length>2&&"ID"===(u=a[0]).type&&9===t.nodeType&&!d&&i.relative[a[1].type]){if(t=i.find.ID(u.matches[0].replace(et,tt),t)[0],!t)return n;e=e.slice(a.shift().value.length)}o=U.needsContext.test(e)?0:a.length;while(o--){if(u=a[o],i.relative[l=u.type])break;if((c=i.find[l])&&(r=c(u.matches[0].replace(et,tt),V.test(a[0].type)&&t.parentNode||t))){if(a.splice(o,1),e=r.length&&dt(a),!e)return H.apply(n,q.call(r,0)),n;break}}}return s(e,p)(r,t,d,n,V.test(e)),n}i.pseudos.nth=i.pseudos.eq;function Tt(){}i.filters=Tt.prototype=i.pseudos,i.setFilters=new Tt,c(),st.attr=b.attr,b.find=st,b.expr=st.selectors,b.expr[":"]=b.expr.pseudos,b.unique=st.uniqueSort,b.text=st.getText,b.isXMLDoc=st.isXML,b.contains=st.contains}(e);var at=/Until$/,st=/^(?:parents|prev(?:Until|All))/,ut=/^.[^:#\[\.,]*$/,lt=b.expr.match.needsContext,ct={children:!0,contents:!0,next:!0,prev:!0};b.fn.extend({find:function(e){var t,n,r,i=this.length;if("string"!=typeof e)return r=this,this.pushStack(b(e).filter(function(){for(t=0;i>t;t++)if(b.contains(r[t],this))return!0}));for(n=[],t=0;i>t;t++)b.find(e,this[t],n);return n=this.pushStack(i>1?b.unique(n):n),n.selector=(this.selector?this.selector+" ":"")+e,n},has:function(e){var t,n=b(e,this),r=n.length;return this.filter(function(){for(t=0;r>t;t++)if(b.contains(this,n[t]))return!0})},not:function(e){return this.pushStack(ft(this,e,!1))},filter:function(e){return this.pushStack(ft(this,e,!0))},is:function(e){return!!e&&("string"==typeof e?lt.test(e)?b(e,this.context).index(this[0])>=0:b.filter(e,this).length>0:this.filter(e).length>0)},closest:function(e,t){var n,r=0,i=this.length,o=[],a=lt.test(e)||"string"!=typeof e?b(e,t||this.context):0;for(;i>r;r++){n=this[r];while(n&&n.ownerDocument&&n!==t&&11!==n.nodeType){if(a?a.index(n)>-1:b.find.matchesSelector(n,e)){o.push(n);break}n=n.parentNode}}return this.pushStack(o.length>1?b.unique(o):o)},index:function(e){return e?"string"==typeof e?b.inArray(this[0],b(e)):b.inArray(e.jquery?e[0]:e,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){var n="string"==typeof e?b(e,t):b.makeArray(e&&e.nodeType?[e]:e),r=b.merge(this.get(),n);return this.pushStack(b.unique(r))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),b.fn.andSelf=b.fn.addBack;function pt(e,t){do e=e[t];while(e&&1!==e.nodeType);return e}b.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return b.dir(e,"parentNode")},parentsUntil:function(e,t,n){return b.dir(e,"parentNode",n)},next:function(e){return pt(e,"nextSibling")},prev:function(e){return pt(e,"previousSibling")},nextAll:function(e){return b.dir(e,"nextSibling")},prevAll:function(e){return b.dir(e,"previousSibling")},nextUntil:function(e,t,n){return b.dir(e,"nextSibling",n)},prevUntil:function(e,t,n){return b.dir(e,"previousSibling",n)},siblings:function(e){return b.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return b.sibling(e.firstChild)},contents:function(e){return b.nodeName(e,"iframe")?e.contentDocument||e.contentWindow.document:b.merge([],e.childNodes)}},function(e,t){b.fn[e]=function(n,r){var i=b.map(this,t,n);return at.test(e)||(r=n),r&&"string"==typeof r&&(i=b.filter(r,i)),i=this.length>1&&!ct[e]?b.unique(i):i,this.length>1&&st.test(e)&&(i=i.reverse()),this.pushStack(i)}}),b.extend({filter:function(e,t,n){return n&&(e=":not("+e+")"),1===t.length?b.find.matchesSelector(t[0],e)?[t[0]]:[]:b.find.matches(e,t)},dir:function(e,n,r){var i=[],o=e[n];while(o&&9!==o.nodeType&&(r===t||1!==o.nodeType||!b(o).is(r)))1===o.nodeType&&i.push(o),o=o[n];return i},sibling:function(e,t){var n=[];for(;e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}});function ft(e,t,n){if(t=t||0,b.isFunction(t))return b.grep(e,function(e,r){var i=!!t.call(e,r,e);return i===n});if(t.nodeType)return b.grep(e,function(e){return e===t===n});if("string"==typeof t){var r=b.grep(e,function(e){return 1===e.nodeType});if(ut.test(t))return b.filter(t,r,!n);t=b.filter(t,r)}return b.grep(e,function(e){return b.inArray(e,t)>=0===n})}function dt(e){var t=ht.split("|"),n=e.createDocumentFragment();if(n.createElement)while(t.length)n.createElement(t.pop());return n}var ht="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",gt=/ jQuery\d+="(?:null|\d+)"/g,mt=RegExp("<(?:"+ht+")[\\s/>]","i"),yt=/^\s+/,vt=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,bt=/<([\w:]+)/,xt=/<tbody/i,wt=/<|&#?\w+;/,Tt=/<(?:script|style|link)/i,Nt=/^(?:checkbox|radio)$/i,Ct=/checked\s*(?:[^=]|=\s*.checked.)/i,kt=/^$|\/(?:java|ecma)script/i,Et=/^true\/(.*)/,St=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,At={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:b.support.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},jt=dt(o),Dt=jt.appendChild(o.createElement("div"));At.optgroup=At.option,At.tbody=At.tfoot=At.colgroup=At.caption=At.thead,At.th=At.td,b.fn.extend({text:function(e){return b.access(this,function(e){return e===t?b.text(this):this.empty().append((this[0]&&this[0].ownerDocument||o).createTextNode(e))},null,e,arguments.length)},wrapAll:function(e){if(b.isFunction(e))return this.each(function(t){b(this).wrapAll(e.call(this,t))});if(this[0]){var t=b(e,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstChild&&1===e.firstChild.nodeType)e=e.firstChild;return e}).append(this)}return this},wrapInner:function(e){return b.isFunction(e)?this.each(function(t){b(this).wrapInner(e.call(this,t))}):this.each(function(){var t=b(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=b.isFunction(e);return this.each(function(n){b(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(){return this.parent().each(function(){b.nodeName(this,"body")||b(this).replaceWith(this.childNodes)}).end()},append:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&this.appendChild(e)})},prepend:function(){return this.domManip(arguments,!0,function(e){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&this.insertBefore(e,this.firstChild)})},before:function(){return this.domManip(arguments,!1,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return this.domManip(arguments,!1,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},remove:function(e,t){var n,r=0;for(;null!=(n=this[r]);r++)(!e||b.filter(e,[n]).length>0)&&(t||1!==n.nodeType||b.cleanData(Ot(n)),n.parentNode&&(t&&b.contains(n.ownerDocument,n)&&Mt(Ot(n,"script")),n.parentNode.removeChild(n)));return this},empty:function(){var e,t=0;for(;null!=(e=this[t]);t++){1===e.nodeType&&b.cleanData(Ot(e,!1));while(e.firstChild)e.removeChild(e.firstChild);e.options&&b.nodeName(e,"select")&&(e.options.length=0)}return this},clone:function(e,t){return e=null==e?!1:e,t=null==t?e:t,this.map(function(){return b.clone(this,e,t)})},html:function(e){return b.access(this,function(e){var n=this[0]||{},r=0,i=this.length;if(e===t)return 1===n.nodeType?n.innerHTML.replace(gt,""):t;if(!("string"!=typeof e||Tt.test(e)||!b.support.htmlSerialize&&mt.test(e)||!b.support.leadingWhitespace&&yt.test(e)||At[(bt.exec(e)||["",""])[1].toLowerCase()])){e=e.replace(vt,"<$1></$2>");try{for(;i>r;r++)n=this[r]||{},1===n.nodeType&&(b.cleanData(Ot(n,!1)),n.innerHTML=e);n=0}catch(o){}}n&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(e){var t=b.isFunction(e);return t||"string"==typeof e||(e=b(e).not(this).detach()),this.domManip([e],!0,function(e){var t=this.nextSibling,n=this.parentNode;n&&(b(this).remove(),n.insertBefore(e,t))})},detach:function(e){return this.remove(e,!0)},domManip:function(e,n,r){e=f.apply([],e);var i,o,a,s,u,l,c=0,p=this.length,d=this,h=p-1,g=e[0],m=b.isFunction(g);if(m||!(1>=p||"string"!=typeof g||b.support.checkClone)&&Ct.test(g))return this.each(function(i){var o=d.eq(i);m&&(e[0]=g.call(this,i,n?o.html():t)),o.domManip(e,n,r)});if(p&&(l=b.buildFragment(e,this[0].ownerDocument,!1,this),i=l.firstChild,1===l.childNodes.length&&(l=i),i)){for(n=n&&b.nodeName(i,"tr"),s=b.map(Ot(l,"script"),Ht),a=s.length;p>c;c++)o=l,c!==h&&(o=b.clone(o,!0,!0),a&&b.merge(s,Ot(o,"script"))),r.call(n&&b.nodeName(this[c],"table")?Lt(this[c],"tbody"):this[c],o,c);if(a)for(u=s[s.length-1].ownerDocument,b.map(s,qt),c=0;a>c;c++)o=s[c],kt.test(o.type||"")&&!b._data(o,"globalEval")&&b.contains(u,o)&&(o.src?b.ajax({url:o.src,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0}):b.globalEval((o.text||o.textContent||o.innerHTML||"").replace(St,"")));l=i=null}return this}});function Lt(e,t){return e.getElementsByTagName(t)[0]||e.appendChild(e.ownerDocument.createElement(t))}function Ht(e){var t=e.getAttributeNode("type");return e.type=(t&&t.specified)+"/"+e.type,e}function qt(e){var t=Et.exec(e.type);return t?e.type=t[1]:e.removeAttribute("type"),e}function Mt(e,t){var n,r=0;for(;null!=(n=e[r]);r++)b._data(n,"globalEval",!t||b._data(t[r],"globalEval"))}function _t(e,t){if(1===t.nodeType&&b.hasData(e)){var n,r,i,o=b._data(e),a=b._data(t,o),s=o.events;if(s){delete a.handle,a.events={};for(n in s)for(r=0,i=s[n].length;i>r;r++)b.event.add(t,n,s[n][r])}a.data&&(a.data=b.extend({},a.data))}}function Ft(e,t){var n,r,i;if(1===t.nodeType){if(n=t.nodeName.toLowerCase(),!b.support.noCloneEvent&&t[b.expando]){i=b._data(t);for(r in i.events)b.removeEvent(t,r,i.handle);t.removeAttribute(b.expando)}"script"===n&&t.text!==e.text?(Ht(t).text=e.text,qt(t)):"object"===n?(t.parentNode&&(t.outerHTML=e.outerHTML),b.support.html5Clone&&e.innerHTML&&!b.trim(t.innerHTML)&&(t.innerHTML=e.innerHTML)):"input"===n&&Nt.test(e.type)?(t.defaultChecked=t.checked=e.checked,t.value!==e.value&&(t.value=e.value)):"option"===n?t.defaultSelected=t.selected=e.defaultSelected:("input"===n||"textarea"===n)&&(t.defaultValue=e.defaultValue)}}b.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){b.fn[e]=function(e){var n,r=0,i=[],o=b(e),a=o.length-1;for(;a>=r;r++)n=r===a?this:this.clone(!0),b(o[r])[t](n),d.apply(i,n.get());return this.pushStack(i)}});function Ot(e,n){var r,o,a=0,s=typeof e.getElementsByTagName!==i?e.getElementsByTagName(n||"*"):typeof e.querySelectorAll!==i?e.querySelectorAll(n||"*"):t;if(!s)for(s=[],r=e.childNodes||e;null!=(o=r[a]);a++)!n||b.nodeName(o,n)?s.push(o):b.merge(s,Ot(o,n));return n===t||n&&b.nodeName(e,n)?b.merge([e],s):s}function Bt(e){Nt.test(e.type)&&(e.defaultChecked=e.checked)}b.extend({clone:function(e,t,n){var r,i,o,a,s,u=b.contains(e.ownerDocument,e);if(b.support.html5Clone||b.isXMLDoc(e)||!mt.test("<"+e.nodeName+">")?o=e.cloneNode(!0):(Dt.innerHTML=e.outerHTML,Dt.removeChild(o=Dt.firstChild)),!(b.support.noCloneEvent&&b.support.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||b.isXMLDoc(e)))for(r=Ot(o),s=Ot(e),a=0;null!=(i=s[a]);++a)r[a]&&Ft(i,r[a]);if(t)if(n)for(s=s||Ot(e),r=r||Ot(o),a=0;null!=(i=s[a]);a++)_t(i,r[a]);else _t(e,o);return r=Ot(o,"script"),r.length>0&&Mt(r,!u&&Ot(e,"script")),r=s=i=null,o},buildFragment:function(e,t,n,r){var i,o,a,s,u,l,c,p=e.length,f=dt(t),d=[],h=0;for(;p>h;h++)if(o=e[h],o||0===o)if("object"===b.type(o))b.merge(d,o.nodeType?[o]:o);else if(wt.test(o)){s=s||f.appendChild(t.createElement("div")),u=(bt.exec(o)||["",""])[1].toLowerCase(),c=At[u]||At._default,s.innerHTML=c[1]+o.replace(vt,"<$1></$2>")+c[2],i=c[0];while(i--)s=s.lastChild;if(!b.support.leadingWhitespace&&yt.test(o)&&d.push(t.createTextNode(yt.exec(o)[0])),!b.support.tbody){o="table"!==u||xt.test(o)?"<table>"!==c[1]||xt.test(o)?0:s:s.firstChild,i=o&&o.childNodes.length;while(i--)b.nodeName(l=o.childNodes[i],"tbody")&&!l.childNodes.length&&o.removeChild(l)
}b.merge(d,s.childNodes),s.textContent="";while(s.firstChild)s.removeChild(s.firstChild);s=f.lastChild}else d.push(t.createTextNode(o));s&&f.removeChild(s),b.support.appendChecked||b.grep(Ot(d,"input"),Bt),h=0;while(o=d[h++])if((!r||-1===b.inArray(o,r))&&(a=b.contains(o.ownerDocument,o),s=Ot(f.appendChild(o),"script"),a&&Mt(s),n)){i=0;while(o=s[i++])kt.test(o.type||"")&&n.push(o)}return s=null,f},cleanData:function(e,t){var n,r,o,a,s=0,u=b.expando,l=b.cache,p=b.support.deleteExpando,f=b.event.special;for(;null!=(n=e[s]);s++)if((t||b.acceptData(n))&&(o=n[u],a=o&&l[o])){if(a.events)for(r in a.events)f[r]?b.event.remove(n,r):b.removeEvent(n,r,a.handle);l[o]&&(delete l[o],p?delete n[u]:typeof n.removeAttribute!==i?n.removeAttribute(u):n[u]=null,c.push(o))}}});var Pt,Rt,Wt,$t=/alpha\([^)]*\)/i,It=/opacity\s*=\s*([^)]*)/,zt=/^(top|right|bottom|left)$/,Xt=/^(none|table(?!-c[ea]).+)/,Ut=/^margin/,Vt=RegExp("^("+x+")(.*)$","i"),Yt=RegExp("^("+x+")(?!px)[a-z%]+$","i"),Jt=RegExp("^([+-])=("+x+")","i"),Gt={BODY:"block"},Qt={position:"absolute",visibility:"hidden",display:"block"},Kt={letterSpacing:0,fontWeight:400},Zt=["Top","Right","Bottom","Left"],en=["Webkit","O","Moz","ms"];function tn(e,t){if(t in e)return t;var n=t.charAt(0).toUpperCase()+t.slice(1),r=t,i=en.length;while(i--)if(t=en[i]+n,t in e)return t;return r}function nn(e,t){return e=t||e,"none"===b.css(e,"display")||!b.contains(e.ownerDocument,e)}function rn(e,t){var n,r,i,o=[],a=0,s=e.length;for(;s>a;a++)r=e[a],r.style&&(o[a]=b._data(r,"olddisplay"),n=r.style.display,t?(o[a]||"none"!==n||(r.style.display=""),""===r.style.display&&nn(r)&&(o[a]=b._data(r,"olddisplay",un(r.nodeName)))):o[a]||(i=nn(r),(n&&"none"!==n||!i)&&b._data(r,"olddisplay",i?n:b.css(r,"display"))));for(a=0;s>a;a++)r=e[a],r.style&&(t&&"none"!==r.style.display&&""!==r.style.display||(r.style.display=t?o[a]||"":"none"));return e}b.fn.extend({css:function(e,n){return b.access(this,function(e,n,r){var i,o,a={},s=0;if(b.isArray(n)){for(o=Rt(e),i=n.length;i>s;s++)a[n[s]]=b.css(e,n[s],!1,o);return a}return r!==t?b.style(e,n,r):b.css(e,n)},e,n,arguments.length>1)},show:function(){return rn(this,!0)},hide:function(){return rn(this)},toggle:function(e){var t="boolean"==typeof e;return this.each(function(){(t?e:nn(this))?b(this).show():b(this).hide()})}}),b.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Wt(e,"opacity");return""===n?"1":n}}}},cssNumber:{columnCount:!0,fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":b.support.cssFloat?"cssFloat":"styleFloat"},style:function(e,n,r,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var o,a,s,u=b.camelCase(n),l=e.style;if(n=b.cssProps[u]||(b.cssProps[u]=tn(l,u)),s=b.cssHooks[n]||b.cssHooks[u],r===t)return s&&"get"in s&&(o=s.get(e,!1,i))!==t?o:l[n];if(a=typeof r,"string"===a&&(o=Jt.exec(r))&&(r=(o[1]+1)*o[2]+parseFloat(b.css(e,n)),a="number"),!(null==r||"number"===a&&isNaN(r)||("number"!==a||b.cssNumber[u]||(r+="px"),b.support.clearCloneStyle||""!==r||0!==n.indexOf("background")||(l[n]="inherit"),s&&"set"in s&&(r=s.set(e,r,i))===t)))try{l[n]=r}catch(c){}}},css:function(e,n,r,i){var o,a,s,u=b.camelCase(n);return n=b.cssProps[u]||(b.cssProps[u]=tn(e.style,u)),s=b.cssHooks[n]||b.cssHooks[u],s&&"get"in s&&(a=s.get(e,!0,r)),a===t&&(a=Wt(e,n,i)),"normal"===a&&n in Kt&&(a=Kt[n]),""===r||r?(o=parseFloat(a),r===!0||b.isNumeric(o)?o||0:a):a},swap:function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i}}),e.getComputedStyle?(Rt=function(t){return e.getComputedStyle(t,null)},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),u=s?s.getPropertyValue(n)||s[n]:t,l=e.style;return s&&(""!==u||b.contains(e.ownerDocument,e)||(u=b.style(e,n)),Yt.test(u)&&Ut.test(n)&&(i=l.width,o=l.minWidth,a=l.maxWidth,l.minWidth=l.maxWidth=l.width=u,u=s.width,l.width=i,l.minWidth=o,l.maxWidth=a)),u}):o.documentElement.currentStyle&&(Rt=function(e){return e.currentStyle},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),u=s?s[n]:t,l=e.style;return null==u&&l&&l[n]&&(u=l[n]),Yt.test(u)&&!zt.test(n)&&(i=l.left,o=e.runtimeStyle,a=o&&o.left,a&&(o.left=e.currentStyle.left),l.left="fontSize"===n?"1em":u,u=l.pixelLeft+"px",l.left=i,a&&(o.left=a)),""===u?"auto":u});function on(e,t,n){var r=Vt.exec(t);return r?Math.max(0,r[1]-(n||0))+(r[2]||"px"):t}function an(e,t,n,r,i){var o=n===(r?"border":"content")?4:"width"===t?1:0,a=0;for(;4>o;o+=2)"margin"===n&&(a+=b.css(e,n+Zt[o],!0,i)),r?("content"===n&&(a-=b.css(e,"padding"+Zt[o],!0,i)),"margin"!==n&&(a-=b.css(e,"border"+Zt[o]+"Width",!0,i))):(a+=b.css(e,"padding"+Zt[o],!0,i),"padding"!==n&&(a+=b.css(e,"border"+Zt[o]+"Width",!0,i)));return a}function sn(e,t,n){var r=!0,i="width"===t?e.offsetWidth:e.offsetHeight,o=Rt(e),a=b.support.boxSizing&&"border-box"===b.css(e,"boxSizing",!1,o);if(0>=i||null==i){if(i=Wt(e,t,o),(0>i||null==i)&&(i=e.style[t]),Yt.test(i))return i;r=a&&(b.support.boxSizingReliable||i===e.style[t]),i=parseFloat(i)||0}return i+an(e,t,n||(a?"border":"content"),r,o)+"px"}function un(e){var t=o,n=Gt[e];return n||(n=ln(e,t),"none"!==n&&n||(Pt=(Pt||b("<iframe frameborder='0' width='0' height='0'/>").css("cssText","display:block !important")).appendTo(t.documentElement),t=(Pt[0].contentWindow||Pt[0].contentDocument).document,t.write("<!doctype html><html><body>"),t.close(),n=ln(e,t),Pt.detach()),Gt[e]=n),n}function ln(e,t){var n=b(t.createElement(e)).appendTo(t.body),r=b.css(n[0],"display");return n.remove(),r}b.each(["height","width"],function(e,n){b.cssHooks[n]={get:function(e,r,i){return r?0===e.offsetWidth&&Xt.test(b.css(e,"display"))?b.swap(e,Qt,function(){return sn(e,n,i)}):sn(e,n,i):t},set:function(e,t,r){var i=r&&Rt(e);return on(e,t,r?an(e,n,r,b.support.boxSizing&&"border-box"===b.css(e,"boxSizing",!1,i),i):0)}}}),b.support.opacity||(b.cssHooks.opacity={get:function(e,t){return It.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":t?"1":""},set:function(e,t){var n=e.style,r=e.currentStyle,i=b.isNumeric(t)?"alpha(opacity="+100*t+")":"",o=r&&r.filter||n.filter||"";n.zoom=1,(t>=1||""===t)&&""===b.trim(o.replace($t,""))&&n.removeAttribute&&(n.removeAttribute("filter"),""===t||r&&!r.filter)||(n.filter=$t.test(o)?o.replace($t,i):o+" "+i)}}),b(function(){b.support.reliableMarginRight||(b.cssHooks.marginRight={get:function(e,n){return n?b.swap(e,{display:"inline-block"},Wt,[e,"marginRight"]):t}}),!b.support.pixelPosition&&b.fn.position&&b.each(["top","left"],function(e,n){b.cssHooks[n]={get:function(e,r){return r?(r=Wt(e,n),Yt.test(r)?b(e).position()[n]+"px":r):t}}})}),b.expr&&b.expr.filters&&(b.expr.filters.hidden=function(e){return 0>=e.offsetWidth&&0>=e.offsetHeight||!b.support.reliableHiddenOffsets&&"none"===(e.style&&e.style.display||b.css(e,"display"))},b.expr.filters.visible=function(e){return!b.expr.filters.hidden(e)}),b.each({margin:"",padding:"",border:"Width"},function(e,t){b.cssHooks[e+t]={expand:function(n){var r=0,i={},o="string"==typeof n?n.split(" "):[n];for(;4>r;r++)i[e+Zt[r]+t]=o[r]||o[r-2]||o[0];return i}},Ut.test(e)||(b.cssHooks[e+t].set=on)});var cn=/%20/g,pn=/\[\]$/,fn=/\r?\n/g,dn=/^(?:submit|button|image|reset|file)$/i,hn=/^(?:input|select|textarea|keygen)/i;b.fn.extend({serialize:function(){return b.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=b.prop(this,"elements");return e?b.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!b(this).is(":disabled")&&hn.test(this.nodeName)&&!dn.test(e)&&(this.checked||!Nt.test(e))}).map(function(e,t){var n=b(this).val();return null==n?null:b.isArray(n)?b.map(n,function(e){return{name:t.name,value:e.replace(fn,"\r\n")}}):{name:t.name,value:n.replace(fn,"\r\n")}}).get()}}),b.param=function(e,n){var r,i=[],o=function(e,t){t=b.isFunction(t)?t():null==t?"":t,i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(t)};if(n===t&&(n=b.ajaxSettings&&b.ajaxSettings.traditional),b.isArray(e)||e.jquery&&!b.isPlainObject(e))b.each(e,function(){o(this.name,this.value)});else for(r in e)gn(r,e[r],n,o);return i.join("&").replace(cn,"+")};function gn(e,t,n,r){var i;if(b.isArray(t))b.each(t,function(t,i){n||pn.test(e)?r(e,i):gn(e+"["+("object"==typeof i?t:"")+"]",i,n,r)});else if(n||"object"!==b.type(t))r(e,t);else for(i in t)gn(e+"["+i+"]",t[i],n,r)}b.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(e,t){b.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),b.fn.hover=function(e,t){return this.mouseenter(e).mouseleave(t||e)};var mn,yn,vn=b.now(),bn=/\?/,xn=/#.*$/,wn=/([?&])_=[^&]*/,Tn=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Nn=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Cn=/^(?:GET|HEAD)$/,kn=/^\/\//,En=/^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,Sn=b.fn.load,An={},jn={},Dn="*/".concat("*");try{yn=a.href}catch(Ln){yn=o.createElement("a"),yn.href="",yn=yn.href}mn=En.exec(yn.toLowerCase())||[];function Hn(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(w)||[];if(b.isFunction(n))while(r=o[i++])"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function qn(e,n,r,i){var o={},a=e===jn;function s(u){var l;return o[u]=!0,b.each(e[u]||[],function(e,u){var c=u(n,r,i);return"string"!=typeof c||a||o[c]?a?!(l=c):t:(n.dataTypes.unshift(c),s(c),!1)}),l}return s(n.dataTypes[0])||!o["*"]&&s("*")}function Mn(e,n){var r,i,o=b.ajaxSettings.flatOptions||{};for(i in n)n[i]!==t&&((o[i]?e:r||(r={}))[i]=n[i]);return r&&b.extend(!0,e,r),e}b.fn.load=function(e,n,r){if("string"!=typeof e&&Sn)return Sn.apply(this,arguments);var i,o,a,s=this,u=e.indexOf(" ");return u>=0&&(i=e.slice(u,e.length),e=e.slice(0,u)),b.isFunction(n)?(r=n,n=t):n&&"object"==typeof n&&(a="POST"),s.length>0&&b.ajax({url:e,type:a,dataType:"html",data:n}).done(function(e){o=arguments,s.html(i?b("<div>").append(b.parseHTML(e)).find(i):e)}).complete(r&&function(e,t){s.each(r,o||[e.responseText,t,e])}),this},b.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){b.fn[t]=function(e){return this.on(t,e)}}),b.each(["get","post"],function(e,n){b[n]=function(e,r,i,o){return b.isFunction(r)&&(o=o||i,i=r,r=t),b.ajax({url:e,type:n,dataType:o,data:r,success:i})}}),b.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:yn,type:"GET",isLocal:Nn.test(mn[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Dn,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText"},converters:{"* text":e.String,"text html":!0,"text json":b.parseJSON,"text xml":b.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Mn(Mn(e,b.ajaxSettings),t):Mn(b.ajaxSettings,e)},ajaxPrefilter:Hn(An),ajaxTransport:Hn(jn),ajax:function(e,n){"object"==typeof e&&(n=e,e=t),n=n||{};var r,i,o,a,s,u,l,c,p=b.ajaxSetup({},n),f=p.context||p,d=p.context&&(f.nodeType||f.jquery)?b(f):b.event,h=b.Deferred(),g=b.Callbacks("once memory"),m=p.statusCode||{},y={},v={},x=0,T="canceled",N={readyState:0,getResponseHeader:function(e){var t;if(2===x){if(!c){c={};while(t=Tn.exec(a))c[t[1].toLowerCase()]=t[2]}t=c[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return 2===x?a:null},setRequestHeader:function(e,t){var n=e.toLowerCase();return x||(e=v[n]=v[n]||e,y[e]=t),this},overrideMimeType:function(e){return x||(p.mimeType=e),this},statusCode:function(e){var t;if(e)if(2>x)for(t in e)m[t]=[m[t],e[t]];else N.always(e[N.status]);return this},abort:function(e){var t=e||T;return l&&l.abort(t),k(0,t),this}};if(h.promise(N).complete=g.add,N.success=N.done,N.error=N.fail,p.url=((e||p.url||yn)+"").replace(xn,"").replace(kn,mn[1]+"//"),p.type=n.method||n.type||p.method||p.type,p.dataTypes=b.trim(p.dataType||"*").toLowerCase().match(w)||[""],null==p.crossDomain&&(r=En.exec(p.url.toLowerCase()),p.crossDomain=!(!r||r[1]===mn[1]&&r[2]===mn[2]&&(r[3]||("http:"===r[1]?80:443))==(mn[3]||("http:"===mn[1]?80:443)))),p.data&&p.processData&&"string"!=typeof p.data&&(p.data=b.param(p.data,p.traditional)),qn(An,p,n,N),2===x)return N;u=p.global,u&&0===b.active++&&b.event.trigger("ajaxStart"),p.type=p.type.toUpperCase(),p.hasContent=!Cn.test(p.type),o=p.url,p.hasContent||(p.data&&(o=p.url+=(bn.test(o)?"&":"?")+p.data,delete p.data),p.cache===!1&&(p.url=wn.test(o)?o.replace(wn,"$1_="+vn++):o+(bn.test(o)?"&":"?")+"_="+vn++)),p.ifModified&&(b.lastModified[o]&&N.setRequestHeader("If-Modified-Since",b.lastModified[o]),b.etag[o]&&N.setRequestHeader("If-None-Match",b.etag[o])),(p.data&&p.hasContent&&p.contentType!==!1||n.contentType)&&N.setRequestHeader("Content-Type",p.contentType),N.setRequestHeader("Accept",p.dataTypes[0]&&p.accepts[p.dataTypes[0]]?p.accepts[p.dataTypes[0]]+("*"!==p.dataTypes[0]?", "+Dn+"; q=0.01":""):p.accepts["*"]);for(i in p.headers)N.setRequestHeader(i,p.headers[i]);if(p.beforeSend&&(p.beforeSend.call(f,N,p)===!1||2===x))return N.abort();T="abort";for(i in{success:1,error:1,complete:1})N[i](p[i]);if(l=qn(jn,p,n,N)){N.readyState=1,u&&d.trigger("ajaxSend",[N,p]),p.async&&p.timeout>0&&(s=setTimeout(function(){N.abort("timeout")},p.timeout));try{x=1,l.send(y,k)}catch(C){if(!(2>x))throw C;k(-1,C)}}else k(-1,"No Transport");function k(e,n,r,i){var c,y,v,w,T,C=n;2!==x&&(x=2,s&&clearTimeout(s),l=t,a=i||"",N.readyState=e>0?4:0,r&&(w=_n(p,N,r)),e>=200&&300>e||304===e?(p.ifModified&&(T=N.getResponseHeader("Last-Modified"),T&&(b.lastModified[o]=T),T=N.getResponseHeader("etag"),T&&(b.etag[o]=T)),204===e?(c=!0,C="nocontent"):304===e?(c=!0,C="notmodified"):(c=Fn(p,w),C=c.state,y=c.data,v=c.error,c=!v)):(v=C,(e||!C)&&(C="error",0>e&&(e=0))),N.status=e,N.statusText=(n||C)+"",c?h.resolveWith(f,[y,C,N]):h.rejectWith(f,[N,C,v]),N.statusCode(m),m=t,u&&d.trigger(c?"ajaxSuccess":"ajaxError",[N,p,c?y:v]),g.fireWith(f,[N,C]),u&&(d.trigger("ajaxComplete",[N,p]),--b.active||b.event.trigger("ajaxStop")))}return N},getScript:function(e,n){return b.get(e,t,n,"script")},getJSON:function(e,t,n){return b.get(e,t,n,"json")}});function _n(e,n,r){var i,o,a,s,u=e.contents,l=e.dataTypes,c=e.responseFields;for(s in c)s in r&&(n[c[s]]=r[s]);while("*"===l[0])l.shift(),o===t&&(o=e.mimeType||n.getResponseHeader("Content-Type"));if(o)for(s in u)if(u[s]&&u[s].test(o)){l.unshift(s);break}if(l[0]in r)a=l[0];else{for(s in r){if(!l[0]||e.converters[s+" "+l[0]]){a=s;break}i||(i=s)}a=a||i}return a?(a!==l[0]&&l.unshift(a),r[a]):t}function Fn(e,t){var n,r,i,o,a={},s=0,u=e.dataTypes.slice(),l=u[0];if(e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u[1])for(i in e.converters)a[i.toLowerCase()]=e.converters[i];for(;r=u[++s];)if("*"!==r){if("*"!==l&&l!==r){if(i=a[l+" "+r]||a["* "+r],!i)for(n in a)if(o=n.split(" "),o[1]===r&&(i=a[l+" "+o[0]]||a["* "+o[0]])){i===!0?i=a[n]:a[n]!==!0&&(r=o[0],u.splice(s--,0,r));break}if(i!==!0)if(i&&e["throws"])t=i(t);else try{t=i(t)}catch(c){return{state:"parsererror",error:i?c:"No conversion from "+l+" to "+r}}}l=r}return{state:"success",data:t}}b.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(e){return b.globalEval(e),e}}}),b.ajaxPrefilter("script",function(e){e.cache===t&&(e.cache=!1),e.crossDomain&&(e.type="GET",e.global=!1)}),b.ajaxTransport("script",function(e){if(e.crossDomain){var n,r=o.head||b("head")[0]||o.documentElement;return{send:function(t,i){n=o.createElement("script"),n.async=!0,e.scriptCharset&&(n.charset=e.scriptCharset),n.src=e.url,n.onload=n.onreadystatechange=function(e,t){(t||!n.readyState||/loaded|complete/.test(n.readyState))&&(n.onload=n.onreadystatechange=null,n.parentNode&&n.parentNode.removeChild(n),n=null,t||i(200,"success"))},r.insertBefore(n,r.firstChild)},abort:function(){n&&n.onload(t,!0)}}}});var On=[],Bn=/(=)\?(?=&|$)|\?\?/;b.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=On.pop()||b.expando+"_"+vn++;return this[e]=!0,e}}),b.ajaxPrefilter("json jsonp",function(n,r,i){var o,a,s,u=n.jsonp!==!1&&(Bn.test(n.url)?"url":"string"==typeof n.data&&!(n.contentType||"").indexOf("application/x-www-form-urlencoded")&&Bn.test(n.data)&&"data");return u||"jsonp"===n.dataTypes[0]?(o=n.jsonpCallback=b.isFunction(n.jsonpCallback)?n.jsonpCallback():n.jsonpCallback,u?n[u]=n[u].replace(Bn,"$1"+o):n.jsonp!==!1&&(n.url+=(bn.test(n.url)?"&":"?")+n.jsonp+"="+o),n.converters["script json"]=function(){return s||b.error(o+" was not called"),s[0]},n.dataTypes[0]="json",a=e[o],e[o]=function(){s=arguments},i.always(function(){e[o]=a,n[o]&&(n.jsonpCallback=r.jsonpCallback,On.push(o)),s&&b.isFunction(a)&&a(s[0]),s=a=t}),"script"):t});var Pn,Rn,Wn=0,$n=e.ActiveXObject&&function(){var e;for(e in Pn)Pn[e](t,!0)};function In(){try{return new e.XMLHttpRequest}catch(t){}}function zn(){try{return new e.ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}b.ajaxSettings.xhr=e.ActiveXObject?function(){return!this.isLocal&&In()||zn()}:In,Rn=b.ajaxSettings.xhr(),b.support.cors=!!Rn&&"withCredentials"in Rn,Rn=b.support.ajax=!!Rn,Rn&&b.ajaxTransport(function(n){if(!n.crossDomain||b.support.cors){var r;return{send:function(i,o){var a,s,u=n.xhr();if(n.username?u.open(n.type,n.url,n.async,n.username,n.password):u.open(n.type,n.url,n.async),n.xhrFields)for(s in n.xhrFields)u[s]=n.xhrFields[s];n.mimeType&&u.overrideMimeType&&u.overrideMimeType(n.mimeType),n.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest");try{for(s in i)u.setRequestHeader(s,i[s])}catch(l){}u.send(n.hasContent&&n.data||null),r=function(e,i){var s,l,c,p;try{if(r&&(i||4===u.readyState))if(r=t,a&&(u.onreadystatechange=b.noop,$n&&delete Pn[a]),i)4!==u.readyState&&u.abort();else{p={},s=u.status,l=u.getAllResponseHeaders(),"string"==typeof u.responseText&&(p.text=u.responseText);try{c=u.statusText}catch(f){c=""}s||!n.isLocal||n.crossDomain?1223===s&&(s=204):s=p.text?200:404}}catch(d){i||o(-1,d)}p&&o(s,c,p,l)},n.async?4===u.readyState?setTimeout(r):(a=++Wn,$n&&(Pn||(Pn={},b(e).unload($n)),Pn[a]=r),u.onreadystatechange=r):r()},abort:function(){r&&r(t,!0)}}}});var Xn,Un,Vn=/^(?:toggle|show|hide)$/,Yn=RegExp("^(?:([+-])=|)("+x+")([a-z%]*)$","i"),Jn=/queueHooks$/,Gn=[nr],Qn={"*":[function(e,t){var n,r,i=this.createTween(e,t),o=Yn.exec(t),a=i.cur(),s=+a||0,u=1,l=20;if(o){if(n=+o[2],r=o[3]||(b.cssNumber[e]?"":"px"),"px"!==r&&s){s=b.css(i.elem,e,!0)||n||1;do u=u||".5",s/=u,b.style(i.elem,e,s+r);while(u!==(u=i.cur()/a)&&1!==u&&--l)}i.unit=r,i.start=s,i.end=o[1]?s+(o[1]+1)*n:n}return i}]};function Kn(){return setTimeout(function(){Xn=t}),Xn=b.now()}function Zn(e,t){b.each(t,function(t,n){var r=(Qn[t]||[]).concat(Qn["*"]),i=0,o=r.length;for(;o>i;i++)if(r[i].call(e,t,n))return})}function er(e,t,n){var r,i,o=0,a=Gn.length,s=b.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;var t=Xn||Kn(),n=Math.max(0,l.startTime+l.duration-t),r=n/l.duration||0,o=1-r,a=0,u=l.tweens.length;for(;u>a;a++)l.tweens[a].run(o);return s.notifyWith(e,[l,o,n]),1>o&&u?n:(s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:b.extend({},t),opts:b.extend(!0,{specialEasing:{}},n),originalProperties:t,originalOptions:n,startTime:Xn||Kn(),duration:n.duration,tweens:[],createTween:function(t,n){var r=b.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;r>n;n++)l.tweens[n].run(1);return t?s.resolveWith(e,[l,t]):s.rejectWith(e,[l,t]),this}}),c=l.props;for(tr(c,l.opts.specialEasing);a>o;o++)if(r=Gn[o].call(l,e,c,l.opts))return r;return Zn(l,c),b.isFunction(l.opts.start)&&l.opts.start.call(e,l),b.fx.timer(b.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always)}function tr(e,t){var n,r,i,o,a;for(i in e)if(r=b.camelCase(i),o=t[r],n=e[i],b.isArray(n)&&(o=n[1],n=e[i]=n[0]),i!==r&&(e[r]=n,delete e[i]),a=b.cssHooks[r],a&&"expand"in a){n=a.expand(n),delete e[r];for(i in n)i in e||(e[i]=n[i],t[i]=o)}else t[r]=o}b.Animation=b.extend(er,{tweener:function(e,t){b.isFunction(e)?(t=e,e=["*"]):e=e.split(" ");var n,r=0,i=e.length;for(;i>r;r++)n=e[r],Qn[n]=Qn[n]||[],Qn[n].unshift(t)},prefilter:function(e,t){t?Gn.unshift(e):Gn.push(e)}});function nr(e,t,n){var r,i,o,a,s,u,l,c,p,f=this,d=e.style,h={},g=[],m=e.nodeType&&nn(e);n.queue||(c=b._queueHooks(e,"fx"),null==c.unqueued&&(c.unqueued=0,p=c.empty.fire,c.empty.fire=function(){c.unqueued||p()}),c.unqueued++,f.always(function(){f.always(function(){c.unqueued--,b.queue(e,"fx").length||c.empty.fire()})})),1===e.nodeType&&("height"in t||"width"in t)&&(n.overflow=[d.overflow,d.overflowX,d.overflowY],"inline"===b.css(e,"display")&&"none"===b.css(e,"float")&&(b.support.inlineBlockNeedsLayout&&"inline"!==un(e.nodeName)?d.zoom=1:d.display="inline-block")),n.overflow&&(d.overflow="hidden",b.support.shrinkWrapBlocks||f.always(function(){d.overflow=n.overflow[0],d.overflowX=n.overflow[1],d.overflowY=n.overflow[2]}));for(i in t)if(a=t[i],Vn.exec(a)){if(delete t[i],u=u||"toggle"===a,a===(m?"hide":"show"))continue;g.push(i)}if(o=g.length){s=b._data(e,"fxshow")||b._data(e,"fxshow",{}),"hidden"in s&&(m=s.hidden),u&&(s.hidden=!m),m?b(e).show():f.done(function(){b(e).hide()}),f.done(function(){var t;b._removeData(e,"fxshow");for(t in h)b.style(e,t,h[t])});for(i=0;o>i;i++)r=g[i],l=f.createTween(r,m?s[r]:0),h[r]=s[r]||b.style(e,r),r in s||(s[r]=l.start,m&&(l.end=l.start,l.start="width"===r||"height"===r?1:0))}}function rr(e,t,n,r,i){return new rr.prototype.init(e,t,n,r,i)}b.Tween=rr,rr.prototype={constructor:rr,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||"swing",this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(b.cssNumber[n]?"":"px")},cur:function(){var e=rr.propHooks[this.prop];return e&&e.get?e.get(this):rr.propHooks._default.get(this)},run:function(e){var t,n=rr.propHooks[this.prop];return this.pos=t=this.options.duration?b.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):rr.propHooks._default.set(this),this}},rr.prototype.init.prototype=rr.prototype,rr.propHooks={_default:{get:function(e){var t;return null==e.elem[e.prop]||e.elem.style&&null!=e.elem.style[e.prop]?(t=b.css(e.elem,e.prop,""),t&&"auto"!==t?t:0):e.elem[e.prop]},set:function(e){b.fx.step[e.prop]?b.fx.step[e.prop](e):e.elem.style&&(null!=e.elem.style[b.cssProps[e.prop]]||b.cssHooks[e.prop])?b.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},rr.propHooks.scrollTop=rr.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},b.each(["toggle","show","hide"],function(e,t){var n=b.fn[t];b.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(ir(t,!0),e,r,i)}}),b.fn.extend({fadeTo:function(e,t,n,r){return this.filter(nn).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=b.isEmptyObject(e),o=b.speed(t,n,r),a=function(){var t=er(this,b.extend({},e),o);a.finish=function(){t.stop(!0)},(i||b._data(this,"finish"))&&t.stop(!0)};return a.finish=a,i||o.queue===!1?this.each(a):this.queue(o.queue,a)},stop:function(e,n,r){var i=function(e){var t=e.stop;delete e.stop,t(r)};return"string"!=typeof e&&(r=n,n=e,e=t),n&&e!==!1&&this.queue(e||"fx",[]),this.each(function(){var t=!0,n=null!=e&&e+"queueHooks",o=b.timers,a=b._data(this);if(n)a[n]&&a[n].stop&&i(a[n]);else for(n in a)a[n]&&a[n].stop&&Jn.test(n)&&i(a[n]);for(n=o.length;n--;)o[n].elem!==this||null!=e&&o[n].queue!==e||(o[n].anim.stop(r),t=!1,o.splice(n,1));(t||!r)&&b.dequeue(this,e)})},finish:function(e){return e!==!1&&(e=e||"fx"),this.each(function(){var t,n=b._data(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=b.timers,a=r?r.length:0;for(n.finish=!0,b.queue(this,e,[]),i&&i.cur&&i.cur.finish&&i.cur.finish.call(this),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;a>t;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}});function ir(e,t){var n,r={height:e},i=0;for(t=t?1:0;4>i;i+=2-t)n=Zt[i],r["margin"+n]=r["padding"+n]=e;return t&&(r.opacity=r.width=e),r}b.each({slideDown:ir("show"),slideUp:ir("hide"),slideToggle:ir("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){b.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),b.speed=function(e,t,n){var r=e&&"object"==typeof e?b.extend({},e):{complete:n||!n&&t||b.isFunction(e)&&e,duration:e,easing:n&&t||t&&!b.isFunction(t)&&t};return r.duration=b.fx.off?0:"number"==typeof r.duration?r.duration:r.duration in b.fx.speeds?b.fx.speeds[r.duration]:b.fx.speeds._default,(null==r.queue||r.queue===!0)&&(r.queue="fx"),r.old=r.complete,r.complete=function(){b.isFunction(r.old)&&r.old.call(this),r.queue&&b.dequeue(this,r.queue)},r},b.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}},b.timers=[],b.fx=rr.prototype.init,b.fx.tick=function(){var e,n=b.timers,r=0;for(Xn=b.now();n.length>r;r++)e=n[r],e()||n[r]!==e||n.splice(r--,1);n.length||b.fx.stop(),Xn=t},b.fx.timer=function(e){e()&&b.timers.push(e)&&b.fx.start()},b.fx.interval=13,b.fx.start=function(){Un||(Un=setInterval(b.fx.tick,b.fx.interval))},b.fx.stop=function(){clearInterval(Un),Un=null},b.fx.speeds={slow:600,fast:200,_default:400},b.fx.step={},b.expr&&b.expr.filters&&(b.expr.filters.animated=function(e){return b.grep(b.timers,function(t){return e===t.elem}).length}),b.fn.offset=function(e){if(arguments.length)return e===t?this:this.each(function(t){b.offset.setOffset(this,e,t)});var n,r,o={top:0,left:0},a=this[0],s=a&&a.ownerDocument;if(s)return n=s.documentElement,b.contains(n,a)?(typeof a.getBoundingClientRect!==i&&(o=a.getBoundingClientRect()),r=or(s),{top:o.top+(r.pageYOffset||n.scrollTop)-(n.clientTop||0),left:o.left+(r.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}):o},b.offset={setOffset:function(e,t,n){var r=b.css(e,"position");"static"===r&&(e.style.position="relative");var i=b(e),o=i.offset(),a=b.css(e,"top"),s=b.css(e,"left"),u=("absolute"===r||"fixed"===r)&&b.inArray("auto",[a,s])>-1,l={},c={},p,f;u?(c=i.position(),p=c.top,f=c.left):(p=parseFloat(a)||0,f=parseFloat(s)||0),b.isFunction(t)&&(t=t.call(e,n,o)),null!=t.top&&(l.top=t.top-o.top+p),null!=t.left&&(l.left=t.left-o.left+f),"using"in t?t.using.call(e,l):i.css(l)}},b.fn.extend({position:function(){if(this[0]){var e,t,n={top:0,left:0},r=this[0];return"fixed"===b.css(r,"position")?t=r.getBoundingClientRect():(e=this.offsetParent(),t=this.offset(),b.nodeName(e[0],"html")||(n=e.offset()),n.top+=b.css(e[0],"borderTopWidth",!0),n.left+=b.css(e[0],"borderLeftWidth",!0)),{top:t.top-n.top-b.css(r,"marginTop",!0),left:t.left-n.left-b.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent||o.documentElement;while(e&&!b.nodeName(e,"html")&&"static"===b.css(e,"position"))e=e.offsetParent;return e||o.documentElement})}}),b.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,n){var r=/Y/.test(n);b.fn[e]=function(i){return b.access(this,function(e,i,o){var a=or(e);return o===t?a?n in a?a[n]:a.document.documentElement[i]:e[i]:(a?a.scrollTo(r?b(a).scrollLeft():o,r?o:b(a).scrollTop()):e[i]=o,t)},e,i,arguments.length,null)}});function or(e){return b.isWindow(e)?e:9===e.nodeType?e.defaultView||e.parentWindow:!1}b.each({Height:"height",Width:"width"},function(e,n){b.each({padding:"inner"+e,content:n,"":"outer"+e},function(r,i){b.fn[i]=function(i,o){var a=arguments.length&&(r||"boolean"!=typeof i),s=r||(i===!0||o===!0?"margin":"border");return b.access(this,function(n,r,i){var o;return b.isWindow(n)?n.document.documentElement["client"+e]:9===n.nodeType?(o=n.documentElement,Math.max(n.body["scroll"+e],o["scroll"+e],n.body["offset"+e],o["offset"+e],o["client"+e])):i===t?b.css(n,r,s):b.style(n,r,i,s)},n,a?i:t,a,null)}})}),e.jQuery=e.$=b,"function"==typeof define&&define.amd&&define.amd.jQuery&&define("jquery",[],function(){return b})})(window);
/**
 * BxSlider v4.1.2 - Fully loaded, responsive content slider
 * http://bxslider.com
 *
 * Copyright 2014, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
 * Written while drinking Belgian ales and listening to jazz
 *
 * Released under the MIT license - http://opensource.org/licenses/MIT
 */
!function(t){var e={},s={mode:"horizontal",slideSelector:"",infiniteLoop:!0,hideControlOnEnd:!1,speed:500,easing:null,slideMargin:0,startSlide:0,randomStart:!1,captions:!1,ticker:!1,tickerHover:!1,adaptiveHeight:!1,adaptiveHeightSpeed:500,video:!1,useCSS:!0,preloadImages:"visible",responsive:!0,slideZIndex:50,touchEnabled:!0,swipeThreshold:50,oneToOneTouch:!0,preventDefaultSwipeX:!0,preventDefaultSwipeY:!1,pager:!0,pagerType:"full",pagerShortSeparator:" / ",pagerSelector:null,buildPager:null,pagerCustom:null,controls:!0,nextText:"Next",prevText:"Prev",nextSelector:null,prevSelector:null,autoControls:!1,startText:"Start",stopText:"Stop",autoControlsCombine:!1,autoControlsSelector:null,auto:!1,pause:4e3,autoStart:!0,autoDirection:"next",autoHover:!1,autoDelay:0,minSlides:1,maxSlides:1,moveSlides:0,slideWidth:0,onSliderLoad:function(){},onSlideBefore:function(){},onSlideAfter:function(){},onSlideNext:function(){},onSlidePrev:function(){},onSliderResize:function(){}};t.fn.bxSlider=function(n){if(0==this.length)return this;if(this.length>1)return this.each(function(){t(this).bxSlider(n)}),this;var o={},r=this;e.el=this;var a=t(window).width(),l=t(window).height(),d=function(){o.settings=t.extend({},s,n),o.settings.slideWidth=parseInt(o.settings.slideWidth),o.children=r.children(o.settings.slideSelector),o.children.length<o.settings.minSlides&&(o.settings.minSlides=o.children.length),o.children.length<o.settings.maxSlides&&(o.settings.maxSlides=o.children.length),o.settings.randomStart&&(o.settings.startSlide=Math.floor(Math.random()*o.children.length)),o.active={index:o.settings.startSlide},o.carousel=o.settings.minSlides>1||o.settings.maxSlides>1,o.carousel&&(o.settings.preloadImages="all"),o.minThreshold=o.settings.minSlides*o.settings.slideWidth+(o.settings.minSlides-1)*o.settings.slideMargin,o.maxThreshold=o.settings.maxSlides*o.settings.slideWidth+(o.settings.maxSlides-1)*o.settings.slideMargin,o.working=!1,o.controls={},o.interval=null,o.animProp="vertical"==o.settings.mode?"top":"left",o.usingCSS=o.settings.useCSS&&"fade"!=o.settings.mode&&function(){var t=document.createElement("div"),e=["WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var i in e)if(void 0!==t.style[e[i]])return o.cssPrefix=e[i].replace("Perspective","").toLowerCase(),o.animProp="-"+o.cssPrefix+"-transform",!0;return!1}(),"vertical"==o.settings.mode&&(o.settings.maxSlides=o.settings.minSlides),r.data("origStyle",r.attr("style")),r.children(o.settings.slideSelector).each(function(){t(this).data("origStyle",t(this).attr("style"))}),c()},c=function(){r.wrap('<div class="bx-wrapper"><div class="bx-viewport"></div></div>'),o.viewport=r.parent(),o.loader=t('<div class="bx-loading" />'),o.viewport.prepend(o.loader),r.css({width:"horizontal"==o.settings.mode?100*o.children.length+215+"%":"auto",position:"relative"}),o.usingCSS&&o.settings.easing?r.css("-"+o.cssPrefix+"-transition-timing-function",o.settings.easing):o.settings.easing||(o.settings.easing="swing"),f(),o.viewport.css({width:"100%",overflow:"hidden",position:"relative"}),o.viewport.parent().css({maxWidth:p()}),o.settings.pager||o.viewport.parent().css({margin:"0 auto 0px"}),o.children.css({"float":"horizontal"==o.settings.mode?"left":"none",listStyle:"none",position:"relative"}),o.children.css("width",u()),"horizontal"==o.settings.mode&&o.settings.slideMargin>0&&o.children.css("marginRight",o.settings.slideMargin),"vertical"==o.settings.mode&&o.settings.slideMargin>0&&o.children.css("marginBottom",o.settings.slideMargin),"fade"==o.settings.mode&&(o.children.css({position:"absolute",zIndex:0,display:"none"}),o.children.eq(o.settings.startSlide).css({zIndex:o.settings.slideZIndex,display:"block"})),o.controls.el=t('<div class="bx-controls" />'),o.settings.captions&&P(),o.active.last=o.settings.startSlide==x()-1,o.settings.video&&r.fitVids();var e=o.children.eq(o.settings.startSlide);"all"==o.settings.preloadImages&&(e=o.children),o.settings.ticker?o.settings.pager=!1:(o.settings.pager&&T(),o.settings.controls&&C(),o.settings.auto&&o.settings.autoControls&&E(),(o.settings.controls||o.settings.autoControls||o.settings.pager)&&o.viewport.after(o.controls.el)),g(e,h)},g=function(e,i){var s=e.find("img, iframe").length;if(0==s)return i(),void 0;var n=0;e.find("img, iframe").each(function(){t(this).one("load",function(){++n==s&&i()}).each(function(){this.complete&&t(this).load()})})},h=function(){if(o.settings.infiniteLoop&&"fade"!=o.settings.mode&&!o.settings.ticker){var e="vertical"==o.settings.mode?o.settings.minSlides:o.settings.maxSlides,i=o.children.slice(0,e).clone().addClass("bx-clone"),s=o.children.slice(-e).clone().addClass("bx-clone");r.append(i).prepend(s)}o.loader.remove(),S(),"vertical"==o.settings.mode&&(o.settings.adaptiveHeight=!0),o.viewport.height(v()),r.redrawSlider(),o.settings.onSliderLoad(o.active.index),o.initialized=!0,o.settings.responsive&&t(window).bind("resize",Z),o.settings.auto&&o.settings.autoStart&&H(),o.settings.ticker&&L(),o.settings.pager&&q(o.settings.startSlide),o.settings.controls&&W(),o.settings.touchEnabled&&!o.settings.ticker&&O()},v=function(){var e=0,s=t();if("vertical"==o.settings.mode||o.settings.adaptiveHeight)if(o.carousel){var n=1==o.settings.moveSlides?o.active.index:o.active.index*m();for(s=o.children.eq(n),i=1;i<=o.settings.maxSlides-1;i++)s=n+i>=o.children.length?s.add(o.children.eq(i-1)):s.add(o.children.eq(n+i))}else s=o.children.eq(o.active.index);else s=o.children;return"vertical"==o.settings.mode?(s.each(function(){e+=t(this).outerHeight()}),o.settings.slideMargin>0&&(e+=o.settings.slideMargin*(o.settings.minSlides-1))):e=Math.max.apply(Math,s.map(function(){return t(this).outerHeight(!1)}).get()),e},p=function(){var t="100%";return o.settings.slideWidth>0&&(t="horizontal"==o.settings.mode?o.settings.maxSlides*o.settings.slideWidth+(o.settings.maxSlides-1)*o.settings.slideMargin:o.settings.slideWidth),t},u=function(){var t=o.settings.slideWidth,e=o.viewport.width();return 0==o.settings.slideWidth||o.settings.slideWidth>e&&!o.carousel||"vertical"==o.settings.mode?t=e:o.settings.maxSlides>1&&"horizontal"==o.settings.mode&&(e>o.maxThreshold||e<o.minThreshold&&(t=(e-o.settings.slideMargin*(o.settings.minSlides-1))/o.settings.minSlides)),t},f=function(){var t=1;if("horizontal"==o.settings.mode&&o.settings.slideWidth>0)if(o.viewport.width()<o.minThreshold)t=o.settings.minSlides;else if(o.viewport.width()>o.maxThreshold)t=o.settings.maxSlides;else{var e=o.children.first().width();t=Math.floor(o.viewport.width()/e)}else"vertical"==o.settings.mode&&(t=o.settings.minSlides);return t},x=function(){var t=0;if(o.settings.moveSlides>0)if(o.settings.infiniteLoop)t=o.children.length/m();else for(var e=0,i=0;e<o.children.length;)++t,e=i+f(),i+=o.settings.moveSlides<=f()?o.settings.moveSlides:f();else t=Math.ceil(o.children.length/f());return t},m=function(){return o.settings.moveSlides>0&&o.settings.moveSlides<=f()?o.settings.moveSlides:f()},S=function(){if(o.children.length>o.settings.maxSlides&&o.active.last&&!o.settings.infiniteLoop){if("horizontal"==o.settings.mode){var t=o.children.last(),e=t.position();b(-(e.left-(o.viewport.width()-t.width())),"reset",0)}else if("vertical"==o.settings.mode){var i=o.children.length-o.settings.minSlides,e=o.children.eq(i).position();b(-e.top,"reset",0)}}else{var e=o.children.eq(o.active.index*m()).position();o.active.index==x()-1&&(o.active.last=!0),void 0!=e&&("horizontal"==o.settings.mode?b(-e.left,"reset",0):"vertical"==o.settings.mode&&b(-e.top,"reset",0))}},b=function(t,e,i,s){if(o.usingCSS){var n="vertical"==o.settings.mode?"translate3d(0, "+t+"px, 0)":"translate3d("+t+"px, 0, 0)";r.css("-"+o.cssPrefix+"-transition-duration",i/1e3+"s"),"slide"==e?(r.css(o.animProp,n),r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(){r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),D()})):"reset"==e?r.css(o.animProp,n):"ticker"==e&&(r.css("-"+o.cssPrefix+"-transition-timing-function","linear"),r.css(o.animProp,n),r.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(){r.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),b(s.resetValue,"reset",0),N()}))}else{var a={};a[o.animProp]=t,"slide"==e?r.animate(a,i,o.settings.easing,function(){D()}):"reset"==e?r.css(o.animProp,t):"ticker"==e&&r.animate(a,speed,"linear",function(){b(s.resetValue,"reset",0),N()})}},w=function(){for(var e="",i=x(),s=0;i>s;s++){var n="";o.settings.buildPager&&t.isFunction(o.settings.buildPager)?(n=o.settings.buildPager(s),o.pagerEl.addClass("bx-custom-pager")):(n=s+1,o.pagerEl.addClass("bx-default-pager")),e+='<div class="bx-pager-item"><a href="" data-slide-index="'+s+'" class="bx-pager-link">'+n+"</a></div>"}o.pagerEl.html(e)},T=function(){o.settings.pagerCustom?o.pagerEl=t(o.settings.pagerCustom):(o.pagerEl=t('<div class="bx-pager" />'),o.settings.pagerSelector?t(o.settings.pagerSelector).html(o.pagerEl):o.controls.el.addClass("bx-has-pager").append(o.pagerEl),w()),o.pagerEl.on("click","a",I)},C=function(){o.controls.next=t('<a class="bx-next" href="">'+o.settings.nextText+"</a>"),o.controls.prev=t('<a class="bx-prev" href="">'+o.settings.prevText+"</a>"),o.controls.next.bind("click",y),o.controls.prev.bind("click",z),o.settings.nextSelector&&t(o.settings.nextSelector).append(o.controls.next),o.settings.prevSelector&&t(o.settings.prevSelector).append(o.controls.prev),o.settings.nextSelector||o.settings.prevSelector||(o.controls.directionEl=t('<div class="bx-controls-direction" />'),o.controls.directionEl.append(o.controls.prev).append(o.controls.next),o.controls.el.addClass("bx-has-controls-direction").append(o.controls.directionEl))},E=function(){o.controls.start=t('<div class="bx-controls-auto-item"><a class="bx-start" href="">'+o.settings.startText+"</a></div>"),o.controls.stop=t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">'+o.settings.stopText+"</a></div>"),o.controls.autoEl=t('<div class="bx-controls-auto" />'),o.controls.autoEl.on("click",".bx-start",k),o.controls.autoEl.on("click",".bx-stop",M),o.settings.autoControlsCombine?o.controls.autoEl.append(o.controls.start):o.controls.autoEl.append(o.controls.start).append(o.controls.stop),o.settings.autoControlsSelector?t(o.settings.autoControlsSelector).html(o.controls.autoEl):o.controls.el.addClass("bx-has-controls-auto").append(o.controls.autoEl),A(o.settings.autoStart?"stop":"start")},P=function(){o.children.each(function(){var e=t(this).find("img:first").attr("title");void 0!=e&&(""+e).length&&t(this).append('<div class="bx-caption"><span>'+e+"</span></div>")})},y=function(t){o.settings.auto&&r.stopAuto(),r.goToNextSlide(),t.preventDefault()},z=function(t){o.settings.auto&&r.stopAuto(),r.goToPrevSlide(),t.preventDefault()},k=function(t){r.startAuto(),t.preventDefault()},M=function(t){r.stopAuto(),t.preventDefault()},I=function(e){o.settings.auto&&r.stopAuto();var i=t(e.currentTarget),s=parseInt(i.attr("data-slide-index"));s!=o.active.index&&r.goToSlide(s),e.preventDefault()},q=function(e){var i=o.children.length;return"short"==o.settings.pagerType?(o.settings.maxSlides>1&&(i=Math.ceil(o.children.length/o.settings.maxSlides)),o.pagerEl.html(e+1+o.settings.pagerShortSeparator+i),void 0):(o.pagerEl.find("a").removeClass("active"),o.pagerEl.each(function(i,s){t(s).find("a").eq(e).addClass("active")}),void 0)},D=function(){if(o.settings.infiniteLoop){var t="";0==o.active.index?t=o.children.eq(0).position():o.active.index==x()-1&&o.carousel?t=o.children.eq((x()-1)*m()).position():o.active.index==o.children.length-1&&(t=o.children.eq(o.children.length-1).position()),t&&("horizontal"==o.settings.mode?b(-t.left,"reset",0):"vertical"==o.settings.mode&&b(-t.top,"reset",0))}o.working=!1,o.settings.onSlideAfter(o.children.eq(o.active.index),o.oldIndex,o.active.index)},A=function(t){o.settings.autoControlsCombine?o.controls.autoEl.html(o.controls[t]):(o.controls.autoEl.find("a").removeClass("active"),o.controls.autoEl.find("a:not(.bx-"+t+")").addClass("active"))},W=function(){1==x()?(o.controls.prev.addClass("disabled"),o.controls.next.addClass("disabled")):!o.settings.infiniteLoop&&o.settings.hideControlOnEnd&&(0==o.active.index?(o.controls.prev.addClass("disabled"),o.controls.next.removeClass("disabled")):o.active.index==x()-1?(o.controls.next.addClass("disabled"),o.controls.prev.removeClass("disabled")):(o.controls.prev.removeClass("disabled"),o.controls.next.removeClass("disabled")))},H=function(){o.settings.autoDelay>0?setTimeout(r.startAuto,o.settings.autoDelay):r.startAuto(),o.settings.autoHover&&r.hover(function(){o.interval&&(r.stopAuto(!0),o.autoPaused=!0)},function(){o.autoPaused&&(r.startAuto(!0),o.autoPaused=null)})},L=function(){var e=0;if("next"==o.settings.autoDirection)r.append(o.children.clone().addClass("bx-clone"));else{r.prepend(o.children.clone().addClass("bx-clone"));var i=o.children.first().position();e="horizontal"==o.settings.mode?-i.left:-i.top}b(e,"reset",0),o.settings.pager=!1,o.settings.controls=!1,o.settings.autoControls=!1,o.settings.tickerHover&&!o.usingCSS&&o.viewport.hover(function(){r.stop()},function(){var e=0;o.children.each(function(){e+="horizontal"==o.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)});var i=o.settings.speed/e,s="horizontal"==o.settings.mode?"left":"top",n=i*(e-Math.abs(parseInt(r.css(s))));N(n)}),N()},N=function(t){speed=t?t:o.settings.speed;var e={left:0,top:0},i={left:0,top:0};"next"==o.settings.autoDirection?e=r.find(".bx-clone").first().position():i=o.children.first().position();var s="horizontal"==o.settings.mode?-e.left:-e.top,n="horizontal"==o.settings.mode?-i.left:-i.top,a={resetValue:n};b(s,"ticker",speed,a)},O=function(){o.touch={start:{x:0,y:0},end:{x:0,y:0}},o.viewport.bind("touchstart",X)},X=function(t){if(o.working)t.preventDefault();else{o.touch.originalPos=r.position();var e=t.originalEvent;o.touch.start.x=e.changedTouches[0].pageX,o.touch.start.y=e.changedTouches[0].pageY,o.viewport.bind("touchmove",Y),o.viewport.bind("touchend",V)}},Y=function(t){var e=t.originalEvent,i=Math.abs(e.changedTouches[0].pageX-o.touch.start.x),s=Math.abs(e.changedTouches[0].pageY-o.touch.start.y);if(3*i>s&&o.settings.preventDefaultSwipeX?t.preventDefault():3*s>i&&o.settings.preventDefaultSwipeY&&t.preventDefault(),"fade"!=o.settings.mode&&o.settings.oneToOneTouch){var n=0;if("horizontal"==o.settings.mode){var r=e.changedTouches[0].pageX-o.touch.start.x;n=o.touch.originalPos.left+r}else{var r=e.changedTouches[0].pageY-o.touch.start.y;n=o.touch.originalPos.top+r}b(n,"reset",0)}},V=function(t){o.viewport.unbind("touchmove",Y);var e=t.originalEvent,i=0;if(o.touch.end.x=e.changedTouches[0].pageX,o.touch.end.y=e.changedTouches[0].pageY,"fade"==o.settings.mode){var s=Math.abs(o.touch.start.x-o.touch.end.x);s>=o.settings.swipeThreshold&&(o.touch.start.x>o.touch.end.x?r.goToNextSlide():r.goToPrevSlide(),r.stopAuto())}else{var s=0;"horizontal"==o.settings.mode?(s=o.touch.end.x-o.touch.start.x,i=o.touch.originalPos.left):(s=o.touch.end.y-o.touch.start.y,i=o.touch.originalPos.top),!o.settings.infiniteLoop&&(0==o.active.index&&s>0||o.active.last&&0>s)?b(i,"reset",200):Math.abs(s)>=o.settings.swipeThreshold?(0>s?r.goToNextSlide():r.goToPrevSlide(),r.stopAuto()):b(i,"reset",200)}o.viewport.unbind("touchend",V)},Z=function(){var e=t(window).width(),i=t(window).height();(a!=e||l!=i)&&(a=e,l=i,r.redrawSlider(),o.settings.onSliderResize.call(r,o.active.index))};return r.goToSlide=function(e,i){if(!o.working&&o.active.index!=e)if(o.working=!0,o.oldIndex=o.active.index,o.active.index=0>e?x()-1:e>=x()?0:e,o.settings.onSlideBefore(o.children.eq(o.active.index),o.oldIndex,o.active.index),"next"==i?o.settings.onSlideNext(o.children.eq(o.active.index),o.oldIndex,o.active.index):"prev"==i&&o.settings.onSlidePrev(o.children.eq(o.active.index),o.oldIndex,o.active.index),o.active.last=o.active.index>=x()-1,o.settings.pager&&q(o.active.index),o.settings.controls&&W(),"fade"==o.settings.mode)o.settings.adaptiveHeight&&o.viewport.height()!=v()&&o.viewport.animate({height:v()},o.settings.adaptiveHeightSpeed),o.children.filter(":visible").fadeOut(o.settings.speed).css({zIndex:0}),o.children.eq(o.active.index).css("zIndex",o.settings.slideZIndex+1).fadeIn(o.settings.speed,function(){t(this).css("zIndex",o.settings.slideZIndex),D()});else{o.settings.adaptiveHeight&&o.viewport.height()!=v()&&o.viewport.animate({height:v()},o.settings.adaptiveHeightSpeed);var s=0,n={left:0,top:0};if(!o.settings.infiniteLoop&&o.carousel&&o.active.last)if("horizontal"==o.settings.mode){var a=o.children.eq(o.children.length-1);n=a.position(),s=o.viewport.width()-a.outerWidth()}else{var l=o.children.length-o.settings.minSlides;n=o.children.eq(l).position()}else if(o.carousel&&o.active.last&&"prev"==i){var d=1==o.settings.moveSlides?o.settings.maxSlides-m():(x()-1)*m()-(o.children.length-o.settings.maxSlides),a=r.children(".bx-clone").eq(d);n=a.position()}else if("next"==i&&0==o.active.index)n=r.find("> .bx-clone").eq(o.settings.maxSlides).position(),o.active.last=!1;else if(e>=0){var c=e*m();n=o.children.eq(c).position()}if("undefined"!=typeof n){var g="horizontal"==o.settings.mode?-(n.left-s):-n.top;b(g,"slide",o.settings.speed)}}},r.goToNextSlide=function(){if(o.settings.infiniteLoop||!o.active.last){var t=parseInt(o.active.index)+1;r.goToSlide(t,"next")}},r.goToPrevSlide=function(){if(o.settings.infiniteLoop||0!=o.active.index){var t=parseInt(o.active.index)-1;r.goToSlide(t,"prev")}},r.startAuto=function(t){o.interval||(o.interval=setInterval(function(){"next"==o.settings.autoDirection?r.goToNextSlide():r.goToPrevSlide()},o.settings.pause),o.settings.autoControls&&1!=t&&A("stop"))},r.stopAuto=function(t){o.interval&&(clearInterval(o.interval),o.interval=null,o.settings.autoControls&&1!=t&&A("start"))},r.getCurrentSlide=function(){return o.active.index},r.getCurrentSlideElement=function(){return o.children.eq(o.active.index)},r.getSlideCount=function(){return o.children.length},r.redrawSlider=function(){o.children.add(r.find(".bx-clone")).outerWidth(u()),o.viewport.css("height",v()),o.settings.ticker||S(),o.active.last&&(o.active.index=x()-1),o.active.index>=x()&&(o.active.last=!0),o.settings.pager&&!o.settings.pagerCustom&&(w(),q(o.active.index))},r.destroySlider=function(){o.initialized&&(o.initialized=!1,t(".bx-clone",this).remove(),o.children.each(function(){void 0!=t(this).data("origStyle")?t(this).attr("style",t(this).data("origStyle")):t(this).removeAttr("style")}),void 0!=t(this).data("origStyle")?this.attr("style",t(this).data("origStyle")):t(this).removeAttr("style"),t(this).unwrap().unwrap(),o.controls.el&&o.controls.el.remove(),o.controls.next&&o.controls.next.remove(),o.controls.prev&&o.controls.prev.remove(),o.pagerEl&&o.settings.controls&&o.pagerEl.remove(),t(".bx-caption",this).remove(),o.controls.autoEl&&o.controls.autoEl.remove(),clearInterval(o.interval),o.settings.responsive&&t(window).unbind("resize",Z))},r.reloadSlider=function(t){void 0!=t&&(n=t),r.destroySlider(),d()},d(),this}}(jQuery);
/* idTabs ~ Sean Catchpole - Version 2.2 - MIT/GPL */
(function(){var dep={"jQuery":"http://code.jquery.com/jquery-latest.min.js"};var init=function(){(function($){$.fn.idTabs=function(){var s={};for(var i=0;i<arguments.length;++i){var a=arguments[i];switch(a.constructor){case Object:$.extend(s,a);break;case Boolean:s.change=a;break;case Number:s.start=a;break;case Function:s.click=a;break;case String:if(a.charAt(0)=='.')s.selected=a;else if(a.charAt(0)=='!')s.event=a;else s.start=a;break;}}
if(typeof s['return']=="function")
s.change=s['return'];return this.each(function(){$.idTabs(this,s);});}
$.idTabs=function(tabs,options){var meta=($.metadata)?$(tabs).metadata():{};var s=$.extend({},$.idTabs.settings,meta,options);if(s.selected.charAt(0)=='.')s.selected=s.selected.substr(1);if(s.event.charAt(0)=='!')s.event=s.event.substr(1);if(s.start==null)s.start=-1;var showId=function(){if($(this).is('.'+s.selected))
return s.change;var id="#"+this.href.split('#')[1];var aList=[];var idList=[];$("a",tabs).each(function(){if(this.href.match(/#/)){aList.push(this);idList.push("#"+this.href.split('#')[1]);}});if(s.click&&!s.click.apply(this,[id,idList,tabs,s]))return s.change;for(i in aList)$(aList[i]).removeClass(s.selected);for(i in idList)$(idList[i]).hide();$(this).addClass(s.selected);$(id).show();return s.change;}
var list=$("a[href*='#']",tabs).unbind(s.event,showId).bind(s.event,showId);list.each(function(){$("#"+this.href.split('#')[1]).hide();});var test=false;if((test=list.filter('.'+s.selected)).length);else if(typeof s.start=="number"&&(test=list.eq(s.start)).length);else if(typeof s.start=="string"&&(test=list.filter("[href*='#"+s.start+"']")).length);if(test){test.removeClass(s.selected);test.trigger(s.event);}
return s;}
$.idTabs.settings={start:0,change:false,click:null,selected:".selected",event:"!click"};$.idTabs.version="2.2";$(function(){$(".idTabs").idTabs();});})(jQuery);}
var check=function(o,s){s=s.split('.');while(o&&s.length)o=o[s.shift()];return o;}
var head=document.getElementsByTagName("head")[0];var add=function(url){var s=document.createElement("script");s.type="text/javascript";s.src=url;head.appendChild(s);}
var s=document.getElementsByTagName('script');var src=s[s.length-1].src;var ok=true;for(d in dep){if(check(this,d))continue;ok=false;add(dep[d]);}if(ok)return init();add(src);})();
$(function(){

	//gnb
	
	var gnbMouse = false, menu_etc = false, gnb_focus = false;

	$('#gnb > ul > li').mouseenter(	
		function() {			
			gnbMouse = true;		
			var $dep2Obj = $(".dep2");
			if($dep2Obj.length > 0){
				$('#gnb > ul > li').removeClass('active');
				$(this).addClass('active');
				$('#header').css('overflow','visible')
				$('.dep2Bg').fadeIn(200);
				$('#gnb .dep2').fadeIn(200);
			} 
			else {
				$('.dep2Bg').fadeOut(200);
				$('#gnb .dep2').fadeOut(200);
			}
		}
	);

	$('#gnb').mouseleave(	
		function() {	
			gnbMouse = false;				
			$('#gnb > ul > li').removeClass('active');
			$('#header').css('overflow','hidden')
			$('.dep2Bg').fadeOut(200);
			$('#gnb .dep2').fadeOut(200);	
		}
	);

	$('.dep2Bg').on({
		mouseleave : function() {
			gnbMouse = false;
			if (gnbMouse) return;
			gnbAnimated = true;
			$('.dep2Bg').fadeOut(100);		
			$('#gnb .dep2').fadeOut(100);
		},
		mouseenter : function() {
			gnbMouse = true;
		}
	});

	$('#gnb > ul > li > a').focus(function() {
		$('.dep2Bg').fadeIn(200);
		$('#gnb .dep2').fadeIn(200);
	});

	$('#gnb a').on({
		"focus" : function(){
			gnb_focus = true;
		},
		"blur" : function() {
			gnb_focus = false;
			setTimeout(function(){
				if(!gnb_focus) {
					$('.dep2Bg').fadeOut(100);		
					$('#gnb .dep2').fadeOut(100);
				}
			},100)
		}
	});
	

	//gnb,lnb current page	
//	function gnb(a){
//		if(a != 0 ){
//			var thisAct = $("#gnb > ul > li").eq(a-1).find("a").eq(0);
//		}else{
//			var thisAct = $("#gnb");
//		}	
//		thisAct.addClass("active");	
//	}
//	if(dep1 != null){
//		gnb(dep1);
//	}

	//lnb
	/*
	$(".lnb a").click(function(){
		var ulObj = $(this).parent("li").find(" > .dep2");
		if(ulObj.length > 0){
			$(".lnb > ul > li > .dep2").hide();
			//`$(".lnb > ul > li a").removeClass("active");
			ulObj.show();
			return false;
		}else{
			location.href = $(this).attr("href");
		}
	});
	*/


//	function lnb(d1,d2,d3){
//
//		if(dep1 != null){
//			if(dep2 != null){
//				var d2Ul = $(".lnb > ul > li").eq(d2-1);
//				d2Ul.find(" > a").addClass("active");
//				if(dep3 != null){
//					var d3Ul = d2Ul.find(" .dep2 > ul > li").eq(d3-1);
//					d2Ul.find(" > .dep2").show();
//					d3Ul.find(" > a").addClass("active");
//				}
//			}
//		}
//	}
//
//	lnb(dep1,dep2,dep3);

	

	//lnb dep2 show/hide
	// $('.lnb > ul > li > a').click(function(){
	// 	$(this).toggleClass('on');
	// 	return false;
	// });


	// select design
	$(document).ready(function(){
		var selectTarget = $('.dg_sel select');

		selectTarget.on('blur', function(){
			$(this).parent().removeClass('focus');
		});

		selectTarget.change(function(){			
			var select_name = $(this).children('option:selected').text();
			$(this).siblings('label').text(select_name);
		});
	});

	// 메인공지 닫기
	$(".noti_x").click(function(){
		
		// 인풋박스 체크 확인 추가
		// if($("#oneday").is(":checked")){
		// 	$.cookie('notice', 'close',{expires:1});
		// };		
		$("#noti").stop().animate({height : 0}, 500 );
	});
	

	//bxslider
	$('.swipe_ban').bxSlider({			//lnb 하단 배너
			pager:true,
			controls: false,
			hideControlOnEnd: false,
			auto : true
	});
	$('.swipe_foot_ban').bxSlider({		//footer 배너
			controls: true,
			pager:false,
			slideWidth : 130,
			maxSlides : 7,
			slideMargin : 11,
			auto : true,
			moveSlides : 1
	});

	// main 홈 탭
	$('.m_news_tab .lft .tit').click(function(){
		$('.m_news_cont > div').hide();
		$('.m_news_cont > div.cont1').show();
		$('.m_news_tab .tit').removeClass('active');
		$(this).addClass('active');
		return false;
	})
	$('.m_news_tab .rgt .tit').click(function(){
		$('.m_news_cont > div').hide();
		$('.m_news_cont > div.cont2').show();
		$('.m_news_tab .tit').removeClass('active');
		$(this).addClass('active');
		return false;
	})

	// main 진행중사업
	$('.m_busi_tab .lft .tit').click(function(){
		$('.m_busi_cont > div').hide();
		$('.m_busi_cont > div.m_busi_ing').show();
		$('.m_busi_tab .tit').removeClass('active');
		$(this).addClass('active');
		return false;
	})
	$('.m_busi_tab .rgt .tit').click(function(){
		$('.m_busi_cont > div').hide();
		$('.m_busi_cont > div.m_busi_link').show();
		$('.m_busi_tab .tit').removeClass('active');
		$(this).addClass('active');
		return false;
	})

});

window.commomJS = {}
commonJS = {
	tab : function(selector) {
		if ($("ul.cm_tabm > li > a", selector).length) {
			var $btns = $("ul.cm_tabm > li > a", selector);
		} else {
			var $btns = $(".cm_tabm > ul > li > a", selector);
		} 
		var $cont = $(".cm_tabc", selector).children();
		$btns.on({
			"click" : function() {
				var thisIndex = $(this).parent().index();
				$cont.each(function(i) {
					if ( i == thisIndex ) {
						$(this).show();
						$btns.eq(i).addClass('active');
					} else {
						$(this).hide();
						$btns.eq(i).removeClass('active');
					}
				});
				return false;
			}
		});
	}
}



/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var DO_NOT_EXPORT_CODEPAGE=true;var DO_NOT_EXPORT_JSZIP=true;(function(e){if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();else if("function"==typeof define&&define.amd&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();define([],e)}else{var r;"undefined"!=typeof window?r=window:"undefined"!=typeof global?r=global:"undefined"!=typeof $&&$.global?r=$.global:"undefined"!=typeof self&&(r=self),r.JSZipSync=e()}})(function(){var e,r,t;return function a(e,r,t){function n(s,f){if(!r[s]){if(!e[s]){var o=typeof require=="function"&&require;if(!f&&o)return o(s,!0);if(i)return i(s,!0);throw new Error("Cannot find module '"+s+"'")}var l=r[s]={exports:{}};e[s][0].call(l.exports,function(r){var t=e[s][1][r];return n(t?t:r)},l,l.exports,a,e,r,t)}return r[s].exports}var i=typeof require=="function"&&require;for(var s=0;s<t.length;s++)n(t[s]);return n}({1:[function(e,r,t){"use strict";var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.encode=function(e,r){var t="";var n,i,s,f,o,l,c;var h=0;while(h<e.length){n=e.charCodeAt(h++);i=e.charCodeAt(h++);s=e.charCodeAt(h++);f=n>>2;o=(n&3)<<4|i>>4;l=(i&15)<<2|s>>6;c=s&63;if(isNaN(i)){l=c=64}else if(isNaN(s)){c=64}t=t+a.charAt(f)+a.charAt(o)+a.charAt(l)+a.charAt(c)}return t};t.decode=function(e,r){var t="";var n,i,s;var f,o,l,c;var h=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(h<e.length){f=a.indexOf(e.charAt(h++));o=a.indexOf(e.charAt(h++));l=a.indexOf(e.charAt(h++));c=a.indexOf(e.charAt(h++));n=f<<2|o>>4;i=(o&15)<<4|l>>2;s=(l&3)<<6|c;t=t+String.fromCharCode(n);if(l!=64){t=t+String.fromCharCode(i)}if(c!=64){t=t+String.fromCharCode(s)}}return t}},{}],2:[function(e,r,t){"use strict";function a(){this.compressedSize=0;this.uncompressedSize=0;this.crc32=0;this.compressionMethod=null;this.compressedContent=null}a.prototype={getContent:function(){return null},getCompressedContent:function(){return null}};r.exports=a},{}],3:[function(e,r,t){"use strict";t.STORE={magic:"\0\0",compress:function(e){return e},uncompress:function(e){return e},compressInputType:null,uncompressInputType:null};t.DEFLATE=e("./flate")},{"./flate":8}],4:[function(e,r,t){"use strict";var a=e("./utils");var n=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117];r.exports=function i(e,r){if(typeof e==="undefined"||!e.length){return 0}var t=a.getTypeOf(e)!=="string";if(typeof r=="undefined"){r=0}var i=0;var s=0;var f=0;r=r^-1;for(var o=0,l=e.length;o<l;o++){f=t?e[o]:e.charCodeAt(o);s=(r^f)&255;i=n[s];r=r>>>8^i}return r^-1}},{"./utils":21}],5:[function(e,r,t){"use strict";var a=e("./utils");function n(e){this.data=null;this.length=0;this.index=0}n.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<e||e<0){throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")}},setIndex:function(e){this.checkIndex(e);this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(e){},readInt:function(e){var r=0,t;this.checkOffset(e);for(t=this.index+e-1;t>=this.index;t--){r=(r<<8)+this.byteAt(t)}this.index+=e;return r},readString:function(e){return a.transformTo("string",this.readData(e))},readData:function(e){},lastIndexOfSignature:function(e){},readDate:function(){var e=this.readInt(4);return new Date((e>>25&127)+1980,(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(e&31)<<1)}};r.exports=n},{"./utils":21}],6:[function(e,r,t){"use strict";t.base64=false;t.binary=false;t.dir=false;t.createFolders=false;t.date=null;t.compression=null;t.comment=null},{}],7:[function(e,r,t){"use strict";var a=e("./utils");t.string2binary=function(e){return a.string2binary(e)};t.string2Uint8Array=function(e){return a.transformTo("uint8array",e)};t.uint8Array2String=function(e){return a.transformTo("string",e)};t.string2Blob=function(e){var r=a.transformTo("arraybuffer",e);return a.arrayBuffer2Blob(r)};t.arrayBuffer2Blob=function(e){return a.arrayBuffer2Blob(e)};t.transformTo=function(e,r){return a.transformTo(e,r)};t.getTypeOf=function(e){return a.getTypeOf(e)};t.checkSupport=function(e){return a.checkSupport(e)};t.MAX_VALUE_16BITS=a.MAX_VALUE_16BITS;t.MAX_VALUE_32BITS=a.MAX_VALUE_32BITS;t.pretty=function(e){return a.pretty(e)};t.findCompression=function(e){return a.findCompression(e)};t.isRegExp=function(e){return a.isRegExp(e)}},{"./utils":21}],8:[function(e,r,t){"use strict";var a=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Uint32Array!=="undefined";var n=e("pako");t.uncompressInputType=a?"uint8array":"array";t.compressInputType=a?"uint8array":"array";t.magic="\b\0";t.compress=function(e){return n.deflateRaw(e)};t.uncompress=function(e){return n.inflateRaw(e)}},{pako:24}],9:[function(e,r,t){"use strict";var a=e("./base64");function n(e,r){if(!(this instanceof n))return new n(e,r);this.files={};this.comment=null;this.root="";if(e){this.load(e,r)}this.clone=function(){var e=new n;for(var r in this){if(typeof this[r]!=="function"){e[r]=this[r]}}return e}}n.prototype=e("./object");n.prototype.load=e("./load");n.support=e("./support");n.defaults=e("./defaults");n.utils=e("./deprecatedPublicUtils");n.base64={encode:function(e){return a.encode(e)},decode:function(e){return a.decode(e)}};n.compressions=e("./compressions");r.exports=n},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(e,r,t){"use strict";var a=e("./base64");var n=e("./zipEntries");r.exports=function(e,r){var t,i,s,f;r=r||{};if(r.base64){e=a.decode(e)}i=new n(e,r);t=i.files;for(s=0;s<t.length;s++){f=t[s];this.file(f.fileName,f.decompressed,{binary:true,optimizedBinaryString:true,date:f.date,dir:f.dir,comment:f.fileComment.length?f.fileComment:null,createFolders:r.createFolders})}if(i.zipComment.length){this.comment=i.zipComment}return this}},{"./base64":1,"./zipEntries":22}],11:[function(e,r,t){(function(e){"use strict";var t=function(){};if(typeof e!=="undefined"){var a=!e.from;if(!a)try{e.from("foo","utf8")}catch(n){a=true}t=a?function(r,t){return t?new e(r,t):new e(r)}:e.from.bind(e);if(!e.alloc)e.alloc=function(r){return new e(r)}}r.exports=function(r,a){return typeof r=="number"?e.alloc(r):t(r,a)};r.exports.test=function(r){return e.isBuffer(r)}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],12:[function(e,r,t){"use strict";var a=e("./uint8ArrayReader");function n(e){this.data=e;this.length=this.data.length;this.index=0}n.prototype=new a;n.prototype.readData=function(e){this.checkOffset(e);var r=this.data.slice(this.index,this.index+e);this.index+=e;return r};r.exports=n},{"./uint8ArrayReader":18}],13:[function(e,r,t){"use strict";var a=e("./support");var n=e("./utils");var i=e("./crc32");var s=e("./signature");var f=e("./defaults");var o=e("./base64");var l=e("./compressions");var c=e("./compressedObject");var h=e("./nodeBuffer");var u=e("./utf8");var d=e("./stringWriter");var p=e("./uint8ArrayWriter");var v=function(e){if(e._data instanceof c){e._data=e._data.getContent();e.options.binary=true;e.options.base64=false;if(n.getTypeOf(e._data)==="uint8array"){var r=e._data;e._data=new Uint8Array(r.length);if(r.length!==0){e._data.set(r,0)}}}return e._data};var g=function(e){var r=v(e),t=n.getTypeOf(r);if(t==="string"){if(!e.options.binary){if(a.nodebuffer){return h(r,"utf-8")}}return e.asBinary()}return r};var m=function(e){var r=v(this);if(r===null||typeof r==="undefined"){return""}if(this.options.base64){r=o.decode(r)}if(e&&this.options.binary){r=T.utf8decode(r)}else{r=n.transformTo("string",r)}if(!e&&!this.options.binary){r=n.transformTo("string",T.utf8encode(r))}return r};var b=function(e,r,t){this.name=e;this.dir=t.dir;this.date=t.date;this.comment=t.comment;this._data=r;this.options=t;this._initialMetadata={dir:t.dir,date:t.date}};b.prototype={asText:function(){return m.call(this,true)},asBinary:function(){return m.call(this,false)},asNodeBuffer:function(){var e=g(this);return n.transformTo("nodebuffer",e)},asUint8Array:function(){var e=g(this);return n.transformTo("uint8array",e)},asArrayBuffer:function(){return this.asUint8Array().buffer}};var w=function(e,r){var t="",a;for(a=0;a<r;a++){t+=String.fromCharCode(e&255);e=e>>>8}return t};var C=function(){var e={},r,t;for(r=0;r<arguments.length;r++){for(t in arguments[r]){if(arguments[r].hasOwnProperty(t)&&typeof e[t]==="undefined"){e[t]=arguments[r][t]}}}return e};var E=function(e){e=e||{};if(e.base64===true&&(e.binary===null||e.binary===undefined)){e.binary=true}e=C(e,f);e.date=e.date||new Date;if(e.compression!==null)e.compression=e.compression.toUpperCase();return e};var k=function(e,r,t){var a=n.getTypeOf(r),i;t=E(t);if(t.createFolders&&(i=S(e))){A.call(this,i,true)}if(t.dir||r===null||typeof r==="undefined"){t.base64=false;t.binary=false;r=null}else if(a==="string"){if(t.binary&&!t.base64){if(t.optimizedBinaryString!==true){r=n.string2binary(r)}}}else{t.base64=false;t.binary=true;if(!a&&!(r instanceof c)){throw new Error("The data of '"+e+"' is in an unsupported format !")}if(a==="arraybuffer"){r=n.transformTo("uint8array",r)}}var s=new b(e,r,t);this.files[e]=s;return s};var S=function(e){if(e.slice(-1)=="/"){e=e.substring(0,e.length-1)}var r=e.lastIndexOf("/");return r>0?e.substring(0,r):""};var A=function(e,r){if(e.slice(-1)!="/"){e+="/"}r=typeof r!=="undefined"?r:false;if(!this.files[e]){k.call(this,e,null,{dir:true,createFolders:r})}return this.files[e]};var _=function(e,r){var t=new c,a;if(e._data instanceof c){t.uncompressedSize=e._data.uncompressedSize;t.crc32=e._data.crc32;if(t.uncompressedSize===0||e.dir){r=l["STORE"];t.compressedContent="";t.crc32=0}else if(e._data.compressionMethod===r.magic){t.compressedContent=e._data.getCompressedContent()}else{a=e._data.getContent();t.compressedContent=r.compress(n.transformTo(r.compressInputType,a))}}else{a=g(e);if(!a||a.length===0||e.dir){r=l["STORE"];a=""}t.uncompressedSize=a.length;t.crc32=i(a);t.compressedContent=r.compress(n.transformTo(r.compressInputType,a))}t.compressedSize=t.compressedContent.length;t.compressionMethod=r.magic;return t};var B=function(e,r,t,a){var f=t.compressedContent,o=n.transformTo("string",u.utf8encode(r.name)),l=r.comment||"",c=n.transformTo("string",u.utf8encode(l)),h=o.length!==r.name.length,d=c.length!==l.length,p=r.options,v,g,m="",b="",C="",E,k;if(r._initialMetadata.dir!==r.dir){E=r.dir}else{E=p.dir}if(r._initialMetadata.date!==r.date){k=r.date}else{k=p.date}v=k.getHours();v=v<<6;v=v|k.getMinutes();v=v<<5;v=v|k.getSeconds()/2;g=k.getFullYear()-1980;g=g<<4;g=g|k.getMonth()+1;g=g<<5;g=g|k.getDate();if(h){b=w(1,1)+w(i(o),4)+o;m+="up"+w(b.length,2)+b}if(d){C=w(1,1)+w(this.crc32(c),4)+c;m+="uc"+w(C.length,2)+C}var S="";S+="\n\0";S+=h||d?"\0\b":"\0\0";S+=t.compressionMethod;S+=w(v,2);S+=w(g,2);S+=w(t.crc32,4);S+=w(t.compressedSize,4);S+=w(t.uncompressedSize,4);S+=w(o.length,2);S+=w(m.length,2);var A=s.LOCAL_FILE_HEADER+S+o+m;var _=s.CENTRAL_FILE_HEADER+"\0"+S+w(c.length,2)+"\0\0"+"\0\0"+(E===true?"\0\0\0":"\0\0\0\0")+w(a,4)+o+m+c;return{fileRecord:A,dirRecord:_,compressedObject:t}};var T={load:function(e,r){throw new Error("Load method is not defined. Is the file jszip-load.js included ?")},filter:function(e){var r=[],t,a,n,i;for(t in this.files){if(!this.files.hasOwnProperty(t)){continue}n=this.files[t];i=new b(n.name,n._data,C(n.options));a=t.slice(this.root.length,t.length);if(t.slice(0,this.root.length)===this.root&&e(a,i)){r.push(i)}}return r},file:function(e,r,t){if(arguments.length===1){if(n.isRegExp(e)){var a=e;return this.filter(function(e,r){return!r.dir&&a.test(e)})}else{return this.filter(function(r,t){return!t.dir&&r===e})[0]||null}}else{e=this.root+e;k.call(this,e,r,t)}return this},folder:function(e){if(!e){return this}if(n.isRegExp(e)){return this.filter(function(r,t){return t.dir&&e.test(r)})}var r=this.root+e;var t=A.call(this,r);var a=this.clone();a.root=t.name;return a},remove:function(e){e=this.root+e;var r=this.files[e];if(!r){if(e.slice(-1)!="/"){e+="/"}r=this.files[e]}if(r&&!r.dir){delete this.files[e]}else{var t=this.filter(function(r,t){return t.name.slice(0,e.length)===e});for(var a=0;a<t.length;a++){delete this.files[t[a].name]}}return this},generate:function(e){e=C(e||{},{base64:true,compression:"STORE",type:"base64",comment:null});n.checkSupport(e.type);var r=[],t=0,a=0,i,f,c=n.transformTo("string",this.utf8encode(e.comment||this.comment||""));for(var h in this.files){if(!this.files.hasOwnProperty(h)){continue}var u=this.files[h];var v=u.options.compression||e.compression.toUpperCase();var g=l[v];if(!g){throw new Error(v+" is not a valid compression method !")}var m=_.call(this,u,g);var b=B.call(this,h,u,m,t);t+=b.fileRecord.length+m.compressedSize;a+=b.dirRecord.length;r.push(b)}var E="";E=s.CENTRAL_DIRECTORY_END+"\0\0"+"\0\0"+w(r.length,2)+w(r.length,2)+w(a,4)+w(t,4)+w(c.length,2)+c;var k=e.type.toLowerCase();if(k==="uint8array"||k==="arraybuffer"||k==="blob"||k==="nodebuffer"){i=new p(t+a+E.length)}else{i=new d(t+a+E.length)}for(f=0;f<r.length;f++){i.append(r[f].fileRecord);i.append(r[f].compressedObject.compressedContent)}for(f=0;f<r.length;f++){i.append(r[f].dirRecord)}i.append(E);var S=i.finalize();switch(e.type.toLowerCase()){case"uint8array":;case"arraybuffer":;case"nodebuffer":return n.transformTo(e.type.toLowerCase(),S);case"blob":return n.arrayBuffer2Blob(n.transformTo("arraybuffer",S));case"base64":return e.base64?o.encode(S):S;default:return S;}},crc32:function(e,r){return i(e,r)},utf8encode:function(e){return n.transformTo("string",u.utf8encode(e))},utf8decode:function(e){return u.utf8decode(e)}};r.exports=T},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(e,r,t){"use strict";t.LOCAL_FILE_HEADER="PK";t.CENTRAL_FILE_HEADER="PK";t.CENTRAL_DIRECTORY_END="PK";t.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK";t.ZIP64_CENTRAL_DIRECTORY_END="PK";t.DATA_DESCRIPTOR="PK\b"},{}],15:[function(e,r,t){"use strict";var a=e("./dataReader");var n=e("./utils");function i(e,r){this.data=e;if(!r){this.data=n.string2binary(this.data)}this.length=this.data.length;this.index=0}i.prototype=new a;i.prototype.byteAt=function(e){return this.data.charCodeAt(e)};i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)};i.prototype.readData=function(e){this.checkOffset(e);var r=this.data.slice(this.index,this.index+e);this.index+=e;return r};r.exports=i},{"./dataReader":5,"./utils":21}],16:[function(e,r,t){"use strict";var a=e("./utils");var n=function(){this.data=[]};n.prototype={append:function(e){e=a.transformTo("string",e);this.data.push(e)},finalize:function(){return this.data.join("")}};r.exports=n},{"./utils":21}],17:[function(e,r,t){(function(e){"use strict";t.base64=true;t.array=true;t.string=true;t.arraybuffer=typeof ArrayBuffer!=="undefined"&&typeof Uint8Array!=="undefined";t.nodebuffer=typeof e!=="undefined";t.uint8array=typeof Uint8Array!=="undefined";if(typeof ArrayBuffer==="undefined"){t.blob=false}else{var r=new ArrayBuffer(0);try{t.blob=new Blob([r],{type:"application/zip"}).size===0}catch(a){try{var n=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var i=new n;i.append(r);t.blob=i.getBlob("application/zip").size===0}catch(a){t.blob=false}}}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],18:[function(e,r,t){"use strict";var a=e("./dataReader");function n(e){if(e){this.data=e;this.length=this.data.length;this.index=0}}n.prototype=new a;n.prototype.byteAt=function(e){return this.data[e]};n.prototype.lastIndexOfSignature=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1),a=e.charCodeAt(2),n=e.charCodeAt(3);for(var i=this.length-4;i>=0;--i){if(this.data[i]===r&&this.data[i+1]===t&&this.data[i+2]===a&&this.data[i+3]===n){return i}}return-1};n.prototype.readData=function(e){this.checkOffset(e);if(e===0){return new Uint8Array(0)}var r=this.data.subarray(this.index,this.index+e);this.index+=e;return r};r.exports=n},{"./dataReader":5}],19:[function(e,r,t){"use strict";var a=e("./utils");var n=function(e){this.data=new Uint8Array(e);this.index=0};n.prototype={append:function(e){if(e.length!==0){e=a.transformTo("uint8array",e);this.data.set(e,this.index);this.index+=e.length}},finalize:function(){return this.data}};r.exports=n},{"./utils":21}],20:[function(e,r,t){"use strict";var a=e("./utils");var n=e("./support");var i=e("./nodeBuffer");var s=new Array(256);for(var f=0;f<256;f++){s[f]=f>=252?6:f>=248?5:f>=240?4:f>=224?3:f>=192?2:1}s[254]=s[254]=1;var o=function(e){var r,t,a,i,s,f=e.length,o=0;for(i=0;i<f;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){a=e.charCodeAt(i+1);if((a&64512)===56320){t=65536+(t-55296<<10)+(a-56320);i++}}o+=t<128?1:t<2048?2:t<65536?3:4}if(n.uint8array){r=new Uint8Array(o)}else{r=new Array(o)}for(s=0,i=0;s<o;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){a=e.charCodeAt(i+1);if((a&64512)===56320){t=65536+(t-55296<<10)+(a-56320);i++}}if(t<128){r[s++]=t}else if(t<2048){r[s++]=192|t>>>6;r[s++]=128|t&63}else if(t<65536){r[s++]=224|t>>>12;r[s++]=128|t>>>6&63;r[s++]=128|t&63}else{r[s++]=240|t>>>18;r[s++]=128|t>>>12&63;r[s++]=128|t>>>6&63;r[s++]=128|t&63}}return r};var l=function(e,r){var t;r=r||e.length;if(r>e.length){r=e.length}t=r-1;while(t>=0&&(e[t]&192)===128){t--}if(t<0){return r}if(t===0){return r}return t+s[e[t]]>r?t:r};var c=function(e){var r,t,n,i,f;var o=e.length;var l=new Array(o*2);for(n=0,t=0;t<o;){i=e[t++];if(i<128){l[n++]=i;continue}f=s[i];if(f>4){l[n++]=65533;t+=f-1;continue}i&=f===2?31:f===3?15:7;while(f>1&&t<o){i=i<<6|e[t++]&63;f--}if(f>1){l[n++]=65533;continue}if(i<65536){l[n++]=i}else{i-=65536;l[n++]=55296|i>>10&1023;l[n++]=56320|i&1023}}if(l.length!==n){if(l.subarray){l=l.subarray(0,n)}else{l.length=n}}return a.applyFromCharCode(l)};t.utf8encode=function h(e){if(n.nodebuffer){return i(e,"utf-8")}return o(e)};t.utf8decode=function u(e){if(n.nodebuffer){return a.transformTo("nodebuffer",e).toString("utf-8")}e=a.transformTo(n.uint8array?"uint8array":"array",e);var r=[],t=0,i=e.length,s=65536;while(t<i){var f=l(e,Math.min(t+s,i));if(n.uint8array){r.push(c(e.subarray(t,f)))}else{r.push(c(e.slice(t,f)))}t=f}return r.join("")}},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(e,r,t){"use strict";var a=e("./support");var n=e("./compressions");var i=e("./nodeBuffer");t.string2binary=function(e){var r="";for(var t=0;t<e.length;t++){r+=String.fromCharCode(e.charCodeAt(t)&255)}return r};t.arrayBuffer2Blob=function(e){t.checkSupport("blob");try{return new Blob([e],{type:"application/zip"})}catch(r){try{var a=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var n=new a;n.append(e);return n.getBlob("application/zip")}catch(r){throw new Error("Bug : can't construct the Blob.")}}};function s(e){return e}function f(e,r){for(var t=0;t<e.length;++t){r[t]=e.charCodeAt(t)&255}return r}function o(e){var r=65536;var a=[],n=e.length,s=t.getTypeOf(e),f=0,o=true;try{switch(s){case"uint8array":String.fromCharCode.apply(null,new Uint8Array(0));break;case"nodebuffer":String.fromCharCode.apply(null,i(0));break;}}catch(l){o=false}if(!o){var c="";for(var h=0;h<e.length;h++){c+=String.fromCharCode(e[h])}return c}while(f<n&&r>1){try{if(s==="array"||s==="nodebuffer"){a.push(String.fromCharCode.apply(null,e.slice(f,Math.min(f+r,n))))}else{a.push(String.fromCharCode.apply(null,e.subarray(f,Math.min(f+r,n))))}f+=r}catch(l){r=Math.floor(r/2)}}return a.join("")}t.applyFromCharCode=o;function l(e,r){for(var t=0;t<e.length;t++){r[t]=e[t]}return r}var c={};c["string"]={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c["string"]["uint8array"](e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:function(e){return f(e,i(e.length))}};c["array"]={string:o,array:s,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return i(e)}};c["arraybuffer"]={string:function(e){return o(new Uint8Array(e))},array:function(e){return l(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:s,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return i(new Uint8Array(e))}};c["uint8array"]={string:o,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:s,nodebuffer:function(e){return i(e)}};c["nodebuffer"]={string:o,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c["nodebuffer"]["uint8array"](e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:s};t.transformTo=function(e,r){if(!r){r=""}if(!e){return r}t.checkSupport(e);var a=t.getTypeOf(r);var n=c[a][e](r);return n};t.getTypeOf=function(e){if(typeof e==="string"){return"string"}if(Object.prototype.toString.call(e)==="[object Array]"){return"array"}if(a.nodebuffer&&i.test(e)){return"nodebuffer"}if(a.uint8array&&e instanceof Uint8Array){return"uint8array"}if(a.arraybuffer&&e instanceof ArrayBuffer){return"arraybuffer"}};t.checkSupport=function(e){var r=a[e.toLowerCase()];if(!r){throw new Error(e+" is not supported by this browser")}};t.MAX_VALUE_16BITS=65535;t.MAX_VALUE_32BITS=-1;t.pretty=function(e){var r="",t,a;for(a=0;a<(e||"").length;a++){t=e.charCodeAt(a);r+="\\x"+(t<16?"0":"")+t.toString(16).toUpperCase()}return r};t.findCompression=function(e){for(var r in n){if(!n.hasOwnProperty(r)){continue}if(n[r].magic===e){return n[r]}}return null};t.isRegExp=function(e){return Object.prototype.toString.call(e)==="[object RegExp]"}},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(e,r,t){"use strict";var a=e("./stringReader");var n=e("./nodeBufferReader");var i=e("./uint8ArrayReader");var s=e("./utils");var f=e("./signature");var o=e("./zipEntry");var l=e("./support");var c=e("./object");function h(e,r){this.files=[];this.loadOptions=r;if(e){this.load(e)}}h.prototype={checkSignature:function(e){var r=this.reader.readString(4);if(r!==e){throw new Error("Corrupted zip or bug : unexpected signature "+"("+s.pretty(r)+", expected "+s.pretty(e)+")")}},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2);this.diskWithCentralDirStart=this.reader.readInt(2);this.centralDirRecordsOnThisDisk=this.reader.readInt(2);this.centralDirRecords=this.reader.readInt(2);this.centralDirSize=this.reader.readInt(4);this.centralDirOffset=this.reader.readInt(4);this.zipCommentLength=this.reader.readInt(2);this.zipComment=this.reader.readString(this.zipCommentLength);this.zipComment=c.utf8decode(this.zipComment)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8);this.versionMadeBy=this.reader.readString(2);this.versionNeeded=this.reader.readInt(2);this.diskNumber=this.reader.readInt(4);this.diskWithCentralDirStart=this.reader.readInt(4);this.centralDirRecordsOnThisDisk=this.reader.readInt(8);this.centralDirRecords=this.reader.readInt(8);this.centralDirSize=this.reader.readInt(8);this.centralDirOffset=this.reader.readInt(8);this.zip64ExtensibleData={};var e=this.zip64EndOfCentralSize-44,r=0,t,a,n;while(r<e){t=this.reader.readInt(2);a=this.reader.readInt(4);n=this.reader.readString(a);this.zip64ExtensibleData[t]={id:t,length:a,value:n}}},readBlockZip64EndOfCentralLocator:function(){this.diskWithZip64CentralDirStart=this.reader.readInt(4);this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8);this.disksCount=this.reader.readInt(4);if(this.disksCount>1){throw new Error("Multi-volumes zip are not supported")}},readLocalFiles:function(){var e,r;for(e=0;e<this.files.length;e++){r=this.files[e];this.reader.setIndex(r.localHeaderOffset);this.checkSignature(f.LOCAL_FILE_HEADER);r.readLocalPart(this.reader);r.handleUTF8()}},readCentralDir:function(){var e;this.reader.setIndex(this.centralDirOffset);while(this.reader.readString(4)===f.CENTRAL_FILE_HEADER){e=new o({zip64:this.zip64},this.loadOptions);e.readCentralPart(this.reader);this.files.push(e)}},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);if(e===-1){throw new Error("Corrupted zip : can't find end of central directory")}this.reader.setIndex(e);this.checkSignature(f.CENTRAL_DIRECTORY_END);this.readBlockEndOfCentral();if(this.diskNumber===s.MAX_VALUE_16BITS||this.diskWithCentralDirStart===s.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===s.MAX_VALUE_16BITS||this.centralDirRecords===s.MAX_VALUE_16BITS||this.centralDirSize===s.MAX_VALUE_32BITS||this.centralDirOffset===s.MAX_VALUE_32BITS){this.zip64=true;e=this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);if(e===-1){throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator")}this.reader.setIndex(e);this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR);this.readBlockZip64EndOfCentralLocator();this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END);this.readBlockZip64EndOfCentral()}},prepareReader:function(e){var r=s.getTypeOf(e);if(r==="string"&&!l.uint8array){this.reader=new a(e,this.loadOptions.optimizedBinaryString)}else if(r==="nodebuffer"){this.reader=new n(e)}else{this.reader=new i(s.transformTo("uint8array",e))}},load:function(e){this.prepareReader(e);this.readEndOfCentral();this.readCentralDir();this.readLocalFiles()}};r.exports=h},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(e,r,t){"use strict";var a=e("./stringReader");var n=e("./utils");var i=e("./compressedObject");var s=e("./object");function f(e,r){this.options=e;this.loadOptions=r}f.prototype={isEncrypted:function(){return(this.bitFlag&1)===1},useUTF8:function(){return(this.bitFlag&2048)===2048},prepareCompressedContent:function(e,r,t){return function(){var a=e.index;e.setIndex(r);var n=e.readData(t);e.setIndex(a);return n}},prepareContent:function(e,r,t,a,i){return function(){var e=n.transformTo(a.uncompressInputType,this.getCompressedContent());var r=a.uncompress(e);if(r.length!==i){throw new Error("Bug : uncompressed data size mismatch")}return r}},readLocalPart:function(e){var r,t;e.skip(22);this.fileNameLength=e.readInt(2);t=e.readInt(2);this.fileName=e.readString(this.fileNameLength);e.skip(t);if(this.compressedSize==-1||this.uncompressedSize==-1){throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory "+"(compressedSize == -1 || uncompressedSize == -1)")}r=n.findCompression(this.compressionMethod);if(r===null){throw new Error("Corrupted zip : compression "+n.pretty(this.compressionMethod)+" unknown (inner file : "+this.fileName+")")}this.decompressed=new i;this.decompressed.compressedSize=this.compressedSize;this.decompressed.uncompressedSize=this.uncompressedSize;this.decompressed.crc32=this.crc32;this.decompressed.compressionMethod=this.compressionMethod;this.decompressed.getCompressedContent=this.prepareCompressedContent(e,e.index,this.compressedSize,r);this.decompressed.getContent=this.prepareContent(e,e.index,this.compressedSize,r,this.uncompressedSize);if(this.loadOptions.checkCRC32){this.decompressed=n.transformTo("string",this.decompressed.getContent());if(s.crc32(this.decompressed)!==this.crc32){throw new Error("Corrupted zip : CRC32 mismatch")}}},readCentralPart:function(e){this.versionMadeBy=e.readString(2);this.versionNeeded=e.readInt(2);this.bitFlag=e.readInt(2);this.compressionMethod=e.readString(2);this.date=e.readDate();this.crc32=e.readInt(4);this.compressedSize=e.readInt(4);this.uncompressedSize=e.readInt(4);this.fileNameLength=e.readInt(2);this.extraFieldsLength=e.readInt(2);this.fileCommentLength=e.readInt(2);this.diskNumberStart=e.readInt(2);this.internalFileAttributes=e.readInt(2);this.externalFileAttributes=e.readInt(4);this.localHeaderOffset=e.readInt(4);if(this.isEncrypted()){throw new Error("Encrypted zip are not supported")}this.fileName=e.readString(this.fileNameLength);this.readExtraFields(e);this.parseZIP64ExtraField(e);this.fileComment=e.readString(this.fileCommentLength);this.dir=this.externalFileAttributes&16?true:false},parseZIP64ExtraField:function(e){if(!this.extraFields[1]){return}var r=new a(this.extraFields[1].value);if(this.uncompressedSize===n.MAX_VALUE_32BITS){this.uncompressedSize=r.readInt(8)}if(this.compressedSize===n.MAX_VALUE_32BITS){this.compressedSize=r.readInt(8)}if(this.localHeaderOffset===n.MAX_VALUE_32BITS){this.localHeaderOffset=r.readInt(8)}if(this.diskNumberStart===n.MAX_VALUE_32BITS){this.diskNumberStart=r.readInt(4)}},readExtraFields:function(e){var r=e.index,t,a,n;this.extraFields=this.extraFields||{};while(e.index<r+this.extraFieldsLength){t=e.readInt(2);a=e.readInt(2);n=e.readString(a);this.extraFields[t]={id:t,length:a,value:n}}},handleUTF8:function(){if(this.useUTF8()){this.fileName=s.utf8decode(this.fileName);this.fileComment=s.utf8decode(this.fileComment)}else{var e=this.findExtraFieldUnicodePath();if(e!==null){this.fileName=e}var r=this.findExtraFieldUnicodeComment();if(r!==null){this.fileComment=r}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var r=new a(e.value);if(r.readInt(1)!==1){return null}if(s.crc32(this.fileName)!==r.readInt(4)){
return null}return s.utf8decode(r.readString(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var r=new a(e.value);if(r.readInt(1)!==1){return null}if(s.crc32(this.fileComment)!==r.readInt(4)){return null}return s.utf8decode(r.readString(e.length-5))}return null}};r.exports=f},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(e,r,t){"use strict";var a=e("./lib/utils/common").assign;var n=e("./lib/deflate");var i=e("./lib/inflate");var s=e("./lib/zlib/constants");var f={};a(f,n,i,s);r.exports=f},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(e,r,t){"use strict";var a=e("./zlib/deflate.js");var n=e("./utils/common");var i=e("./utils/strings");var s=e("./zlib/messages");var f=e("./zlib/zstream");var o=0;var l=4;var c=0;var h=1;var u=-1;var d=0;var p=8;var v=function(e){this.options=n.assign({level:u,method:p,chunkSize:16384,windowBits:15,memLevel:8,strategy:d,to:""},e||{});var r=this.options;if(r.raw&&r.windowBits>0){r.windowBits=-r.windowBits}else if(r.gzip&&r.windowBits>0&&r.windowBits<16){r.windowBits+=16}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new f;this.strm.avail_out=0;var t=a.deflateInit2(this.strm,r.level,r.method,r.windowBits,r.memLevel,r.strategy);if(t!==c){throw new Error(s[t])}if(r.header){a.deflateSetHeader(this.strm,r.header)}};v.prototype.push=function(e,r){var t=this.strm;var s=this.options.chunkSize;var f,u;if(this.ended){return false}u=r===~~r?r:r===true?l:o;if(typeof e==="string"){t.input=i.string2buf(e)}else{t.input=e}t.next_in=0;t.avail_in=t.input.length;do{if(t.avail_out===0){t.output=new n.Buf8(s);t.next_out=0;t.avail_out=s}f=a.deflate(t,u);if(f!==h&&f!==c){this.onEnd(f);this.ended=true;return false}if(t.avail_out===0||t.avail_in===0&&u===l){if(this.options.to==="string"){this.onData(i.buf2binstring(n.shrinkBuf(t.output,t.next_out)))}else{this.onData(n.shrinkBuf(t.output,t.next_out))}}}while((t.avail_in>0||t.avail_out===0)&&f!==h);if(u===l){f=a.deflateEnd(this.strm);this.onEnd(f);this.ended=true;return f===c}return true};v.prototype.onData=function(e){this.chunks.push(e)};v.prototype.onEnd=function(e){if(e===c){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=n.flattenChunks(this.chunks)}}this.chunks=[];this.err=e;this.msg=this.strm.msg};function g(e,r){var t=new v(r);t.push(e,true);if(t.err){throw t.msg}return t.result}function m(e,r){r=r||{};r.raw=true;return g(e,r)}function b(e,r){r=r||{};r.gzip=true;return g(e,r)}t.Deflate=v;t.deflate=g;t.deflateRaw=m;t.gzip=b},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(e,r,t){"use strict";var a=e("./zlib/inflate.js");var n=e("./utils/common");var i=e("./utils/strings");var s=e("./zlib/constants");var f=e("./zlib/messages");var o=e("./zlib/zstream");var l=e("./zlib/gzheader");var c=function(e){this.options=n.assign({chunkSize:16384,windowBits:0,to:""},e||{});var r=this.options;if(r.raw&&r.windowBits>=0&&r.windowBits<16){r.windowBits=-r.windowBits;if(r.windowBits===0){r.windowBits=-15}}if(r.windowBits>=0&&r.windowBits<16&&!(e&&e.windowBits)){r.windowBits+=32}if(r.windowBits>15&&r.windowBits<48){if((r.windowBits&15)===0){r.windowBits|=15}}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new o;this.strm.avail_out=0;var t=a.inflateInit2(this.strm,r.windowBits);if(t!==s.Z_OK){throw new Error(f[t])}this.header=new l;a.inflateGetHeader(this.strm,this.header)};c.prototype.push=function(e,r){var t=this.strm;var f=this.options.chunkSize;var o,l;var c,h,u;if(this.ended){return false}l=r===~~r?r:r===true?s.Z_FINISH:s.Z_NO_FLUSH;if(typeof e==="string"){t.input=i.binstring2buf(e)}else{t.input=e}t.next_in=0;t.avail_in=t.input.length;do{if(t.avail_out===0){t.output=new n.Buf8(f);t.next_out=0;t.avail_out=f}o=a.inflate(t,s.Z_NO_FLUSH);if(o!==s.Z_STREAM_END&&o!==s.Z_OK){this.onEnd(o);this.ended=true;return false}if(t.next_out){if(t.avail_out===0||o===s.Z_STREAM_END||t.avail_in===0&&l===s.Z_FINISH){if(this.options.to==="string"){c=i.utf8border(t.output,t.next_out);h=t.next_out-c;u=i.buf2string(t.output,c);t.next_out=h;t.avail_out=f-h;if(h){n.arraySet(t.output,t.output,c,h,0)}this.onData(u)}else{this.onData(n.shrinkBuf(t.output,t.next_out))}}}}while(t.avail_in>0&&o!==s.Z_STREAM_END);if(o===s.Z_STREAM_END){l=s.Z_FINISH}if(l===s.Z_FINISH){o=a.inflateEnd(this.strm);this.onEnd(o);this.ended=true;return o===s.Z_OK}return true};c.prototype.onData=function(e){this.chunks.push(e)};c.prototype.onEnd=function(e){if(e===s.Z_OK){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=n.flattenChunks(this.chunks)}}this.chunks=[];this.err=e;this.msg=this.strm.msg};function h(e,r){var t=new c(r);t.push(e,true);if(t.err){throw t.msg}return t.result}function u(e,r){r=r||{};r.raw=true;return h(e,r)}t.Inflate=c;t.inflate=h;t.inflateRaw=u;t.ungzip=h},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(e,r,t){"use strict";var a=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";t.assign=function(e){var r=Array.prototype.slice.call(arguments,1);while(r.length){var t=r.shift();if(!t){continue}if(typeof t!=="object"){throw new TypeError(t+"must be non-object")}for(var a in t){if(t.hasOwnProperty(a)){e[a]=t[a]}}}return e};t.shrinkBuf=function(e,r){if(e.length===r){return e}if(e.subarray){return e.subarray(0,r)}e.length=r;return e};var n={arraySet:function(e,r,t,a,n){if(r.subarray&&e.subarray){e.set(r.subarray(t,t+a),n);return}for(var i=0;i<a;i++){e[n+i]=r[t+i]}},flattenChunks:function(e){var r,t,a,n,i,s;a=0;for(r=0,t=e.length;r<t;r++){a+=e[r].length}s=new Uint8Array(a);n=0;for(r=0,t=e.length;r<t;r++){i=e[r];s.set(i,n);n+=i.length}return s}};var i={arraySet:function(e,r,t,a,n){for(var i=0;i<a;i++){e[n+i]=r[t+i]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,n)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,i)}};t.setTyped(a)},{}],28:[function(e,r,t){"use strict";var a=e("./common");var n=true;var i=true;try{String.fromCharCode.apply(null,[0])}catch(s){n=false}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(s){i=false}var f=new a.Buf8(256);for(var o=0;o<256;o++){f[o]=o>=252?6:o>=248?5:o>=240?4:o>=224?3:o>=192?2:1}f[254]=f[254]=1;t.string2buf=function(e){var r,t,n,i,s,f=e.length,o=0;for(i=0;i<f;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){n=e.charCodeAt(i+1);if((n&64512)===56320){t=65536+(t-55296<<10)+(n-56320);i++}}o+=t<128?1:t<2048?2:t<65536?3:4}r=new a.Buf8(o);for(s=0,i=0;s<o;i++){t=e.charCodeAt(i);if((t&64512)===55296&&i+1<f){n=e.charCodeAt(i+1);if((n&64512)===56320){t=65536+(t-55296<<10)+(n-56320);i++}}if(t<128){r[s++]=t}else if(t<2048){r[s++]=192|t>>>6;r[s++]=128|t&63}else if(t<65536){r[s++]=224|t>>>12;r[s++]=128|t>>>6&63;r[s++]=128|t&63}else{r[s++]=240|t>>>18;r[s++]=128|t>>>12&63;r[s++]=128|t>>>6&63;r[s++]=128|t&63}}return r};function l(e,r){if(r<65537){if(e.subarray&&i||!e.subarray&&n){return String.fromCharCode.apply(null,a.shrinkBuf(e,r))}}var t="";for(var s=0;s<r;s++){t+=String.fromCharCode(e[s])}return t}t.buf2binstring=function(e){return l(e,e.length)};t.binstring2buf=function(e){var r=new a.Buf8(e.length);for(var t=0,n=r.length;t<n;t++){r[t]=e.charCodeAt(t)}return r};t.buf2string=function(e,r){var t,a,n,i;var s=r||e.length;var o=new Array(s*2);for(a=0,t=0;t<s;){n=e[t++];if(n<128){o[a++]=n;continue}i=f[n];if(i>4){o[a++]=65533;t+=i-1;continue}n&=i===2?31:i===3?15:7;while(i>1&&t<s){n=n<<6|e[t++]&63;i--}if(i>1){o[a++]=65533;continue}if(n<65536){o[a++]=n}else{n-=65536;o[a++]=55296|n>>10&1023;o[a++]=56320|n&1023}}return l(o,a)};t.utf8border=function(e,r){var t;r=r||e.length;if(r>e.length){r=e.length}t=r-1;while(t>=0&&(e[t]&192)===128){t--}if(t<0){return r}if(t===0){return r}return t+f[e[t]]>r?t:r}},{"./common":27}],29:[function(e,r,t){"use strict";function a(e,r,t,a){var n=e&65535|0,i=e>>>16&65535|0,s=0;while(t!==0){s=t>2e3?2e3:t;t-=s;do{n=n+r[a++]|0;i=i+n|0}while(--s);n%=65521;i%=65521}return n|i<<16|0}r.exports=a},{}],30:[function(e,r,t){r.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],31:[function(e,r,t){"use strict";function a(){var e,r=[];for(var t=0;t<256;t++){e=t;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}r[t]=e}return r}var n=a();function i(e,r,t,a){var i=n,s=a+t;e=e^-1;for(var f=a;f<s;f++){e=e>>>8^i[(e^r[f])&255]}return e^-1}r.exports=i},{}],32:[function(e,r,t){"use strict";var a=e("../utils/common");var n=e("./trees");var i=e("./adler32");var s=e("./crc32");var f=e("./messages");var o=0;var l=1;var c=3;var h=4;var u=5;var d=0;var p=1;var v=-2;var g=-3;var m=-5;var b=-1;var w=1;var C=2;var E=3;var k=4;var S=0;var A=2;var _=8;var B=9;var T=15;var y=8;var x=29;var I=256;var R=I+1+x;var D=30;var F=19;var O=2*R+1;var P=15;var N=3;var L=258;var M=L+N+1;var U=32;var H=42;var W=69;var V=73;var z=91;var X=103;var G=113;var j=666;var K=1;var Y=2;var $=3;var Z=4;var Q=3;function J(e,r){e.msg=f[r];return r}function q(e){return(e<<1)-(e>4?9:0)}function ee(e){var r=e.length;while(--r>=0){e[r]=0}}function re(e){var r=e.state;var t=r.pending;if(t>e.avail_out){t=e.avail_out}if(t===0){return}a.arraySet(e.output,r.pending_buf,r.pending_out,t,e.next_out);e.next_out+=t;r.pending_out+=t;e.total_out+=t;e.avail_out-=t;r.pending-=t;if(r.pending===0){r.pending_out=0}}function te(e,r){n._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,r);e.block_start=e.strstart;re(e.strm)}function ae(e,r){e.pending_buf[e.pending++]=r}function ne(e,r){e.pending_buf[e.pending++]=r>>>8&255;e.pending_buf[e.pending++]=r&255}function ie(e,r,t,n){var f=e.avail_in;if(f>n){f=n}if(f===0){return 0}e.avail_in-=f;a.arraySet(r,e.input,e.next_in,f,t);if(e.state.wrap===1){e.adler=i(e.adler,r,f,t)}else if(e.state.wrap===2){e.adler=s(e.adler,r,f,t)}e.next_in+=f;e.total_in+=f;return f}function se(e,r){var t=e.max_chain_length;var a=e.strstart;var n;var i;var s=e.prev_length;var f=e.nice_match;var o=e.strstart>e.w_size-M?e.strstart-(e.w_size-M):0;var l=e.window;var c=e.w_mask;var h=e.prev;var u=e.strstart+L;var d=l[a+s-1];var p=l[a+s];if(e.prev_length>=e.good_match){t>>=2}if(f>e.lookahead){f=e.lookahead}do{n=r;if(l[n+s]!==p||l[n+s-1]!==d||l[n]!==l[a]||l[++n]!==l[a+1]){continue}a+=2;n++;do{}while(l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&l[++a]===l[++n]&&a<u);i=L-(u-a);a=u-L;if(i>s){e.match_start=r;s=i;if(i>=f){break}d=l[a+s-1];p=l[a+s]}}while((r=h[r&c])>o&&--t!==0);if(s<=e.lookahead){return s}return e.lookahead}function fe(e){var r=e.w_size;var t,n,i,s,f;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=r+(r-M)){a.arraySet(e.window,e.window,r,r,0);e.match_start-=r;e.strstart-=r;e.block_start-=r;n=e.hash_size;t=n;do{i=e.head[--t];e.head[t]=i>=r?i-r:0}while(--n);n=r;t=n;do{i=e.prev[--t];e.prev[t]=i>=r?i-r:0}while(--n);s+=r}if(e.strm.avail_in===0){break}n=ie(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=n;if(e.lookahead+e.insert>=N){f=e.strstart-e.insert;e.ins_h=e.window[f];e.ins_h=(e.ins_h<<e.hash_shift^e.window[f+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[f+N-1])&e.hash_mask;e.prev[f&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=f;f++;e.insert--;if(e.lookahead+e.insert<N){break}}}}while(e.lookahead<M&&e.strm.avail_in!==0)}function oe(e,r){var t=65535;if(t>e.pending_buf_size-5){t=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fe(e);if(e.lookahead===0&&r===o){return K}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+t;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;te(e,false);if(e.strm.avail_out===0){return K}}if(e.strstart-e.block_start>=e.w_size-M){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.strstart>e.block_start){te(e,false);if(e.strm.avail_out===0){return K}}return K}function le(e,r){var t;var a;for(;;){if(e.lookahead<M){fe(e);if(e.lookahead<M&&r===o){return K}if(e.lookahead===0){break}}t=0;if(e.lookahead>=N){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(t!==0&&e.strstart-t<=e.w_size-M){e.match_length=se(e,t)}if(e.match_length>=N){a=n._tr_tally(e,e.strstart-e.match_start,e.match_length-N);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=N){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=e.strstart<N-1?e.strstart:N-1;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function ce(e,r){var t;var a;var i;for(;;){if(e.lookahead<M){fe(e);if(e.lookahead<M&&r===o){return K}if(e.lookahead===0){break}}t=0;if(e.lookahead>=N){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=N-1;if(t!==0&&e.prev_length<e.max_lazy_match&&e.strstart-t<=e.w_size-M){e.match_length=se(e,t);if(e.match_length<=5&&(e.strategy===w||e.match_length===N&&e.strstart-e.match_start>4096)){e.match_length=N-1}}if(e.prev_length>=N&&e.match_length<=e.prev_length){i=e.strstart+e.lookahead-N;a=n._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-N);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=i){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+N-1])&e.hash_mask;t=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=N-1;e.strstart++;if(a){te(e,false);if(e.strm.avail_out===0){return K}}}else if(e.match_available){a=n._tr_tally(e,0,e.window[e.strstart-1]);if(a){te(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return K}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=n._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<N-1?e.strstart:N-1;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function he(e,r){var t;var a;var i,s;var f=e.window;for(;;){if(e.lookahead<=L){fe(e);if(e.lookahead<=L&&r===o){return K}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=N&&e.strstart>0){i=e.strstart-1;a=f[i];if(a===f[++i]&&a===f[++i]&&a===f[++i]){s=e.strstart+L;do{}while(a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&a===f[++i]&&i<s);e.match_length=L-(s-i);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=N){t=n._tr_tally(e,1,e.match_length-N);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{t=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(t){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}function ue(e,r){var t;for(;;){if(e.lookahead===0){fe(e);if(e.lookahead===0){if(r===o){return K}break}}e.match_length=0;t=n._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(t){te(e,false);if(e.strm.avail_out===0){return K}}}e.insert=0;if(r===h){te(e,true);if(e.strm.avail_out===0){return $}return Z}if(e.last_lit){te(e,false);if(e.strm.avail_out===0){return K}}return Y}var de=function(e,r,t,a,n){this.good_length=e;this.max_lazy=r;this.nice_length=t;this.max_chain=a;this.func=n};var pe;pe=[new de(0,0,0,0,oe),new de(4,4,8,4,le),new de(4,5,16,8,le),new de(4,6,32,32,le),new de(4,4,16,16,ce),new de(8,16,32,32,ce),new de(8,16,128,128,ce),new de(8,32,128,256,ce),new de(32,128,258,1024,ce),new de(32,258,258,4096,ce)];function ve(e){e.window_size=2*e.w_size;ee(e.head);e.max_lazy_match=pe[e.level].max_lazy;e.good_match=pe[e.level].good_length;e.nice_match=pe[e.level].nice_length;e.max_chain_length=pe[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=N-1;e.match_available=0;e.ins_h=0}function ge(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=_;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(O*2);this.dyn_dtree=new a.Buf16((2*D+1)*2);this.bl_tree=new a.Buf16((2*F+1)*2);ee(this.dyn_ltree);ee(this.dyn_dtree);ee(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(P+1);this.heap=new a.Buf16(2*R+1);ee(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*R+1);ee(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function me(e){var r;if(!e||!e.state){return J(e,v)}e.total_in=e.total_out=0;e.data_type=A;r=e.state;r.pending=0;r.pending_out=0;if(r.wrap<0){r.wrap=-r.wrap}r.status=r.wrap?H:G;e.adler=r.wrap===2?0:1;r.last_flush=o;n._tr_init(r);return d}function be(e){var r=me(e);if(r===d){ve(e.state)}return r}function we(e,r){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=r;return d}function Ce(e,r,t,n,i,s){if(!e){return v}var f=1;if(r===b){r=6}if(n<0){f=0;n=-n}else if(n>15){f=2;n-=16}if(i<1||i>B||t!==_||n<8||n>15||r<0||r>9||s<0||s>k){return J(e,v)}if(n===8){n=9}var o=new ge;e.state=o;o.strm=e;o.wrap=f;o.gzhead=null;o.w_bits=n;o.w_size=1<<o.w_bits;o.w_mask=o.w_size-1;o.hash_bits=i+7;o.hash_size=1<<o.hash_bits;o.hash_mask=o.hash_size-1;o.hash_shift=~~((o.hash_bits+N-1)/N);o.window=new a.Buf8(o.w_size*2);o.head=new a.Buf16(o.hash_size);o.prev=new a.Buf16(o.w_size);o.lit_bufsize=1<<i+6;o.pending_buf_size=o.lit_bufsize*4;o.pending_buf=new a.Buf8(o.pending_buf_size);o.d_buf=o.lit_bufsize>>1;o.l_buf=(1+2)*o.lit_bufsize;o.level=r;o.strategy=s;o.method=t;return be(e)}function Ee(e,r){return Ce(e,r,_,T,y,S)}function ke(e,r){var t,a;var i,f;if(!e||!e.state||r>u||r<0){return e?J(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===j&&r!==h){return J(e,e.avail_out===0?m:v)}a.strm=e;t=a.last_flush;a.last_flush=r;if(a.status===H){if(a.wrap===2){e.adler=0;ae(a,31);ae(a,139);ae(a,8);if(!a.gzhead){ae(a,0);ae(a,0);ae(a,0);ae(a,0);ae(a,0);ae(a,a.level===9?2:a.strategy>=C||a.level<2?4:0);ae(a,Q);a.status=G}else{ae(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));ae(a,a.gzhead.time&255);ae(a,a.gzhead.time>>8&255);ae(a,a.gzhead.time>>16&255);ae(a,a.gzhead.time>>24&255);ae(a,a.level===9?2:a.strategy>=C||a.level<2?4:0);ae(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){ae(a,a.gzhead.extra.length&255);ae(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=W}}else{var g=_+(a.w_bits-8<<4)<<8;var b=-1;if(a.strategy>=C||a.level<2){b=0}else if(a.level<6){b=1}else if(a.level===6){b=2}else{b=3}g|=b<<6;if(a.strstart!==0){g|=U}g+=31-g%31;a.status=G;ne(a,g);if(a.strstart!==0){ne(a,e.adler>>>16);ne(a,e.adler&65535)}e.adler=1}}if(a.status===W){if(a.gzhead.extra){i=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){break}}ae(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=V}}else{a.status=V}}if(a.status===V){if(a.gzhead.name){i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){f=1;break}}if(a.gzindex<a.gzhead.name.length){f=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{f=0}ae(a,f)}while(f!==0);if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(f===0){a.gzindex=0;a.status=z}}else{a.status=z}}if(a.status===z){if(a.gzhead.comment){i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}re(e);i=a.pending;if(a.pending===a.pending_buf_size){f=1;break}}if(a.gzindex<a.gzhead.comment.length){f=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{f=0}ae(a,f)}while(f!==0);if(a.gzhead.hcrc&&a.pending>i){e.adler=s(e.adler,a.pending_buf,a.pending-i,i)}if(f===0){a.status=X}}else{a.status=X}}if(a.status===X){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){re(e)}if(a.pending+2<=a.pending_buf_size){ae(a,e.adler&255);ae(a,e.adler>>8&255);e.adler=0;a.status=G}}else{a.status=G}}if(a.pending!==0){re(e);if(e.avail_out===0){a.last_flush=-1;return d}}else if(e.avail_in===0&&q(r)<=q(t)&&r!==h){return J(e,m)}if(a.status===j&&e.avail_in!==0){return J(e,m)}if(e.avail_in!==0||a.lookahead!==0||r!==o&&a.status!==j){var w=a.strategy===C?ue(a,r):a.strategy===E?he(a,r):pe[a.level].func(a,r);if(w===$||w===Z){a.status=j}if(w===K||w===$){if(e.avail_out===0){a.last_flush=-1}return d}if(w===Y){if(r===l){n._tr_align(a)}else if(r!==u){n._tr_stored_block(a,0,0,false);if(r===c){ee(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}re(e);if(e.avail_out===0){a.last_flush=-1;return d}}}if(r!==h){return d}if(a.wrap<=0){return p}if(a.wrap===2){ae(a,e.adler&255);ae(a,e.adler>>8&255);ae(a,e.adler>>16&255);ae(a,e.adler>>24&255);ae(a,e.total_in&255);ae(a,e.total_in>>8&255);ae(a,e.total_in>>16&255);ae(a,e.total_in>>24&255)}else{ne(a,e.adler>>>16);ne(a,e.adler&65535)}re(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?d:p}function Se(e){var r;if(!e||!e.state){return v}r=e.state.status;if(r!==H&&r!==W&&r!==V&&r!==z&&r!==X&&r!==G&&r!==j){return J(e,v)}e.state=null;return r===G?J(e,g):d}t.deflateInit=Ee;t.deflateInit2=Ce;t.deflateReset=be;t.deflateResetKeep=me;t.deflateSetHeader=we;t.deflate=ke;t.deflateEnd=Se;t.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(e,r,t){"use strict";function a(){this.text=0;this.time=0;this.xflags=0;this.os=0;this.extra=null;this.extra_len=0;this.name="";this.comment="";this.hcrc=0;this.done=false}r.exports=a},{}],34:[function(e,r,t){"use strict";var a=30;var n=12;r.exports=function i(e,r){var t;var i;var s;var f;var o;var l;var c;var h;var u;var d;var p;var v;var g;var m;var b;var w;var C;var E;var k;var S;var A;var _;var B;var T,y;t=e.state;i=e.next_in;T=e.input;s=i+(e.avail_in-5);f=e.next_out;y=e.output;o=f-(r-e.avail_out);l=f+(e.avail_out-257);c=t.dmax;h=t.wsize;u=t.whave;d=t.wnext;p=t.window;v=t.hold;g=t.bits;m=t.lencode;b=t.distcode;w=(1<<t.lenbits)-1;C=(1<<t.distbits)-1;e:do{if(g<15){v+=T[i++]<<g;g+=8;v+=T[i++]<<g;g+=8}E=m[v&w];r:for(;;){k=E>>>24;v>>>=k;g-=k;k=E>>>16&255;if(k===0){y[f++]=E&65535}else if(k&16){S=E&65535;k&=15;if(k){if(g<k){v+=T[i++]<<g;g+=8}S+=v&(1<<k)-1;v>>>=k;g-=k}if(g<15){v+=T[i++]<<g;g+=8;v+=T[i++]<<g;g+=8}E=b[v&C];t:for(;;){k=E>>>24;v>>>=k;g-=k;k=E>>>16&255;if(k&16){A=E&65535;k&=15;if(g<k){v+=T[i++]<<g;g+=8;if(g<k){v+=T[i++]<<g;g+=8}}A+=v&(1<<k)-1;if(A>c){e.msg="invalid distance too far back";t.mode=a;break e}v>>>=k;g-=k;k=f-o;if(A>k){k=A-k;if(k>u){if(t.sane){e.msg="invalid distance too far back";t.mode=a;break e}}_=0;B=p;if(d===0){_+=h-k;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}else if(d<k){_+=h+d-k;k-=d;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=0;if(d<S){k=d;S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}}else{_+=d-k;if(k<S){S-=k;do{y[f++]=p[_++]}while(--k);_=f-A;B=y}}while(S>2){y[f++]=B[_++];y[f++]=B[_++];y[f++]=B[_++];S-=3}if(S){y[f++]=B[_++];if(S>1){y[f++]=B[_++]}}}else{_=f-A;do{y[f++]=y[_++];y[f++]=y[_++];y[f++]=y[_++];S-=3}while(S>2);if(S){y[f++]=y[_++];if(S>1){y[f++]=y[_++]}}}}else if((k&64)===0){E=b[(E&65535)+(v&(1<<k)-1)];continue t}else{e.msg="invalid distance code";t.mode=a;break e}break}}else if((k&64)===0){E=m[(E&65535)+(v&(1<<k)-1)];continue r}else if(k&32){t.mode=n;break e}else{e.msg="invalid literal/length code";t.mode=a;break e}break}}while(i<s&&f<l);S=g>>3;i-=S;g-=S<<3;v&=(1<<g)-1;e.next_in=i;e.next_out=f;e.avail_in=i<s?5+(s-i):5-(i-s);e.avail_out=f<l?257+(l-f):257-(f-l);t.hold=v;t.bits=g;return}},{}],35:[function(e,r,t){"use strict";var a=e("../utils/common");var n=e("./adler32");var i=e("./crc32");var s=e("./inffast");var f=e("./inftrees");var o=0;var l=1;var c=2;var h=4;var u=5;var d=6;var p=0;var v=1;var g=2;var m=-2;var b=-3;var w=-4;var C=-5;var E=8;var k=1;var S=2;var A=3;var _=4;var B=5;var T=6;var y=7;var x=8;var I=9;var R=10;var D=11;var F=12;var O=13;var P=14;var N=15;var L=16;var M=17;var U=18;var H=19;var W=20;var V=21;var z=22;var X=23;var G=24;var j=25;var K=26;var Y=27;var $=28;var Z=29;var Q=30;var J=31;var q=32;var ee=852;var re=592;var te=15;var ae=te;function ne(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function ie(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function se(e){var r;if(!e||!e.state){return m}r=e.state;e.total_in=e.total_out=r.total=0;e.msg="";if(r.wrap){e.adler=r.wrap&1}r.mode=k;r.last=0;r.havedict=0;r.dmax=32768;r.head=null;r.hold=0;r.bits=0;r.lencode=r.lendyn=new a.Buf32(ee);r.distcode=r.distdyn=new a.Buf32(re);r.sane=1;r.back=-1;return p}function fe(e){var r;if(!e||!e.state){return m}r=e.state;r.wsize=0;r.whave=0;r.wnext=0;return se(e)}function oe(e,r){var t;var a;if(!e||!e.state){return m}a=e.state;if(r<0){t=0;r=-r}else{t=(r>>4)+1;if(r<48){r&=15}}if(r&&(r<8||r>15)){return m}if(a.window!==null&&a.wbits!==r){a.window=null}a.wrap=t;a.wbits=r;return fe(e)}function le(e,r){var t;var a;if(!e){return m}a=new ie;e.state=a;a.window=null;t=oe(e,r);if(t!==p){e.state=null}return t}function ce(e){return le(e,ae)}var he=true;var ue,de;function pe(e){if(he){var r;ue=new a.Buf32(512);de=new a.Buf32(32);r=0;while(r<144){e.lens[r++]=8}while(r<256){e.lens[r++]=9}while(r<280){e.lens[r++]=7}while(r<288){e.lens[r++]=8}f(l,e.lens,0,288,ue,0,e.work,{bits:9});r=0;while(r<32){e.lens[r++]=5}f(c,e.lens,0,32,de,0,e.work,{bits:5});he=false}e.lencode=ue;e.lenbits=9;e.distcode=de;e.distbits=5}function ve(e,r,t,n){var i;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(n>=s.wsize){a.arraySet(s.window,r,t-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{i=s.wsize-s.wnext;if(i>n){i=n}a.arraySet(s.window,r,t-n,i,s.wnext);n-=i;if(n){a.arraySet(s.window,r,t-n,n,0);s.wnext=n;s.whave=s.wsize}else{s.wnext+=i;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=i}}}return 0}function ge(e,r){var t;var ee,re;var te;var ae;var ie,se;var fe;var oe;var le,ce;var he;var ue;var de;var ge=0;var me,be,we;var Ce,Ee,ke;var Se;var Ae;var _e=new a.Buf8(4);var Be;var Te;var ye=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return m}t=e.state;if(t.mode===F){t.mode=O}ae=e.next_out;re=e.output;se=e.avail_out;te=e.next_in;ee=e.input;ie=e.avail_in;fe=t.hold;oe=t.bits;le=ie;ce=se;Ae=p;e:for(;;){switch(t.mode){case k:if(t.wrap===0){t.mode=O;break}while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.wrap&2&&fe===35615){t.check=0;_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0);fe=0;oe=0;t.mode=S;break}t.flags=0;if(t.head){t.head.done=false}if(!(t.wrap&1)||(((fe&255)<<8)+(fe>>8))%31){e.msg="incorrect header check";t.mode=Q;break}if((fe&15)!==E){e.msg="unknown compression method";t.mode=Q;break}fe>>>=4;oe-=4;Se=(fe&15)+8;if(t.wbits===0){t.wbits=Se}else if(Se>t.wbits){e.msg="invalid window size";t.mode=Q;break}t.dmax=1<<Se;e.adler=t.check=1;t.mode=fe&512?R:F;fe=0;oe=0;break;case S:while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.flags=fe;if((t.flags&255)!==E){e.msg="unknown compression method";t.mode=Q;break}if(t.flags&57344){e.msg="unknown header flags set";t.mode=Q;break}if(t.head){t.head.text=fe>>8&1}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0;t.mode=A;case A:while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.head){t.head.time=fe}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;_e[2]=fe>>>16&255;_e[3]=fe>>>24&255;t.check=i(t.check,_e,4,0)}fe=0;oe=0;t.mode=_;case _:while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(t.head){t.head.xflags=fe&255;t.head.os=fe>>8}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0;t.mode=B;case B:if(t.flags&1024){while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.length=fe;if(t.head){t.head.extra_len=fe}if(t.flags&512){_e[0]=fe&255;_e[1]=fe>>>8&255;t.check=i(t.check,_e,2,0)}fe=0;oe=0}else if(t.head){t.head.extra=null}t.mode=T;case T:if(t.flags&1024){he=t.length;if(he>ie){he=ie}if(he){if(t.head){Se=t.head.extra_len-t.length;if(!t.head.extra){t.head.extra=new Array(t.head.extra_len)}a.arraySet(t.head.extra,ee,te,he,Se)}if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;t.length-=he}if(t.length){break e}}t.length=0;t.mode=y;case y:if(t.flags&2048){if(ie===0){break e}he=0;do{Se=ee[te+he++];if(t.head&&Se&&t.length<65536){t.head.name+=String.fromCharCode(Se)}}while(Se&&he<ie);if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;if(Se){break e}}else if(t.head){t.head.name=null}t.length=0;t.mode=x;case x:if(t.flags&4096){if(ie===0){break e}he=0;do{Se=ee[te+he++];if(t.head&&Se&&t.length<65536){t.head.comment+=String.fromCharCode(Se)}}while(Se&&he<ie);if(t.flags&512){t.check=i(t.check,ee,he,te)}ie-=he;te+=he;if(Se){break e}}else if(t.head){t.head.comment=null}t.mode=I;case I:if(t.flags&512){while(oe<16){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(fe!==(t.check&65535)){e.msg="header crc mismatch";t.mode=Q;break}fe=0;oe=0}if(t.head){t.head.hcrc=t.flags>>9&1;t.head.done=true}e.adler=t.check=0;t.mode=F;break;case R:while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}e.adler=t.check=ne(fe);fe=0;oe=0;t.mode=D;case D:if(t.havedict===0){e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;return g}e.adler=t.check=1;t.mode=F;case F:if(r===u||r===d){break e};case O:if(t.last){fe>>>=oe&7;
oe-=oe&7;t.mode=Y;break}while(oe<3){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.last=fe&1;fe>>>=1;oe-=1;switch(fe&3){case 0:t.mode=P;break;case 1:pe(t);t.mode=W;if(r===d){fe>>>=2;oe-=2;break e}break;case 2:t.mode=M;break;case 3:e.msg="invalid block type";t.mode=Q;}fe>>>=2;oe-=2;break;case P:fe>>>=oe&7;oe-=oe&7;while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if((fe&65535)!==(fe>>>16^65535)){e.msg="invalid stored block lengths";t.mode=Q;break}t.length=fe&65535;fe=0;oe=0;t.mode=N;if(r===d){break e};case N:t.mode=L;case L:he=t.length;if(he){if(he>ie){he=ie}if(he>se){he=se}if(he===0){break e}a.arraySet(re,ee,te,he,ae);ie-=he;te+=he;se-=he;ae+=he;t.length-=he;break}t.mode=F;break;case M:while(oe<14){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.nlen=(fe&31)+257;fe>>>=5;oe-=5;t.ndist=(fe&31)+1;fe>>>=5;oe-=5;t.ncode=(fe&15)+4;fe>>>=4;oe-=4;if(t.nlen>286||t.ndist>30){e.msg="too many length or distance symbols";t.mode=Q;break}t.have=0;t.mode=U;case U:while(t.have<t.ncode){while(oe<3){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.lens[ye[t.have++]]=fe&7;fe>>>=3;oe-=3}while(t.have<19){t.lens[ye[t.have++]]=0}t.lencode=t.lendyn;t.lenbits=7;Be={bits:t.lenbits};Ae=f(o,t.lens,0,19,t.lencode,0,t.work,Be);t.lenbits=Be.bits;if(Ae){e.msg="invalid code lengths set";t.mode=Q;break}t.have=0;t.mode=H;case H:while(t.have<t.nlen+t.ndist){for(;;){ge=t.lencode[fe&(1<<t.lenbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(we<16){fe>>>=me;oe-=me;t.lens[t.have++]=we}else{if(we===16){Te=me+2;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;if(t.have===0){e.msg="invalid bit length repeat";t.mode=Q;break}Se=t.lens[t.have-1];he=3+(fe&3);fe>>>=2;oe-=2}else if(we===17){Te=me+3;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;Se=0;he=3+(fe&7);fe>>>=3;oe-=3}else{Te=me+7;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=me;oe-=me;Se=0;he=11+(fe&127);fe>>>=7;oe-=7}if(t.have+he>t.nlen+t.ndist){e.msg="invalid bit length repeat";t.mode=Q;break}while(he--){t.lens[t.have++]=Se}}}if(t.mode===Q){break}if(t.lens[256]===0){e.msg="invalid code -- missing end-of-block";t.mode=Q;break}t.lenbits=9;Be={bits:t.lenbits};Ae=f(l,t.lens,0,t.nlen,t.lencode,0,t.work,Be);t.lenbits=Be.bits;if(Ae){e.msg="invalid literal/lengths set";t.mode=Q;break}t.distbits=6;t.distcode=t.distdyn;Be={bits:t.distbits};Ae=f(c,t.lens,t.nlen,t.ndist,t.distcode,0,t.work,Be);t.distbits=Be.bits;if(Ae){e.msg="invalid distances set";t.mode=Q;break}t.mode=W;if(r===d){break e};case W:t.mode=V;case V:if(ie>=6&&se>=258){e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;s(e,ce);ae=e.next_out;re=e.output;se=e.avail_out;te=e.next_in;ee=e.input;ie=e.avail_in;fe=t.hold;oe=t.bits;if(t.mode===F){t.back=-1}break}t.back=0;for(;;){ge=t.lencode[fe&(1<<t.lenbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(be&&(be&240)===0){Ce=me;Ee=be;ke=we;for(;;){ge=t.lencode[ke+((fe&(1<<Ce+Ee)-1)>>Ce)];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(Ce+me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=Ce;oe-=Ce;t.back+=Ce}fe>>>=me;oe-=me;t.back+=me;t.length=we;if(be===0){t.mode=K;break}if(be&32){t.back=-1;t.mode=F;break}if(be&64){e.msg="invalid literal/length code";t.mode=Q;break}t.extra=be&15;t.mode=z;case z:if(t.extra){Te=t.extra;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.length+=fe&(1<<t.extra)-1;fe>>>=t.extra;oe-=t.extra;t.back+=t.extra}t.was=t.length;t.mode=X;case X:for(;;){ge=t.distcode[fe&(1<<t.distbits)-1];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if((be&240)===0){Ce=me;Ee=be;ke=we;for(;;){ge=t.distcode[ke+((fe&(1<<Ce+Ee)-1)>>Ce)];me=ge>>>24;be=ge>>>16&255;we=ge&65535;if(Ce+me<=oe){break}if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}fe>>>=Ce;oe-=Ce;t.back+=Ce}fe>>>=me;oe-=me;t.back+=me;if(be&64){e.msg="invalid distance code";t.mode=Q;break}t.offset=we;t.extra=be&15;t.mode=G;case G:if(t.extra){Te=t.extra;while(oe<Te){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}t.offset+=fe&(1<<t.extra)-1;fe>>>=t.extra;oe-=t.extra;t.back+=t.extra}if(t.offset>t.dmax){e.msg="invalid distance too far back";t.mode=Q;break}t.mode=j;case j:if(se===0){break e}he=ce-se;if(t.offset>he){he=t.offset-he;if(he>t.whave){if(t.sane){e.msg="invalid distance too far back";t.mode=Q;break}}if(he>t.wnext){he-=t.wnext;ue=t.wsize-he}else{ue=t.wnext-he}if(he>t.length){he=t.length}de=t.window}else{de=re;ue=ae-t.offset;he=t.length}if(he>se){he=se}se-=he;t.length-=he;do{re[ae++]=de[ue++]}while(--he);if(t.length===0){t.mode=V}break;case K:if(se===0){break e}re[ae++]=t.length;se--;t.mode=V;break;case Y:if(t.wrap){while(oe<32){if(ie===0){break e}ie--;fe|=ee[te++]<<oe;oe+=8}ce-=se;e.total_out+=ce;t.total+=ce;if(ce){e.adler=t.check=t.flags?i(t.check,re,ce,ae-ce):n(t.check,re,ce,ae-ce)}ce=se;if((t.flags?fe:ne(fe))!==t.check){e.msg="incorrect data check";t.mode=Q;break}fe=0;oe=0}t.mode=$;case $:if(t.wrap&&t.flags){while(oe<32){if(ie===0){break e}ie--;fe+=ee[te++]<<oe;oe+=8}if(fe!==(t.total&4294967295)){e.msg="incorrect length check";t.mode=Q;break}fe=0;oe=0}t.mode=Z;case Z:Ae=v;break e;case Q:Ae=b;break e;case J:return w;case q:;default:return m;}}e.next_out=ae;e.avail_out=se;e.next_in=te;e.avail_in=ie;t.hold=fe;t.bits=oe;if(t.wsize||ce!==e.avail_out&&t.mode<Q&&(t.mode<Y||r!==h)){if(ve(e,e.output,e.next_out,ce-e.avail_out)){t.mode=J;return w}}le-=e.avail_in;ce-=e.avail_out;e.total_in+=le;e.total_out+=ce;t.total+=ce;if(t.wrap&&ce){e.adler=t.check=t.flags?i(t.check,re,ce,e.next_out-ce):n(t.check,re,ce,e.next_out-ce)}e.data_type=t.bits+(t.last?64:0)+(t.mode===F?128:0)+(t.mode===W||t.mode===N?256:0);if((le===0&&ce===0||r===h)&&Ae===p){Ae=C}return Ae}function me(e){if(!e||!e.state){return m}var r=e.state;if(r.window){r.window=null}e.state=null;return p}function be(e,r){var t;if(!e||!e.state){return m}t=e.state;if((t.wrap&2)===0){return m}t.head=r;r.done=false;return p}t.inflateReset=fe;t.inflateReset2=oe;t.inflateResetKeep=se;t.inflateInit=ce;t.inflateInit2=le;t.inflate=ge;t.inflateEnd=me;t.inflateGetHeader=be;t.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(e,r,t){"use strict";var a=e("../utils/common");var n=15;var i=852;var s=592;var f=0;var o=1;var l=2;var c=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var h=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var u=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var d=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];r.exports=function p(e,r,t,v,g,m,b,w){var C=w.bits;var E=0;var k=0;var S=0,A=0;var _=0;var B=0;var T=0;var y=0;var x=0;var I=0;var R;var D;var F;var O;var P;var N=null;var L=0;var M;var U=new a.Buf16(n+1);var H=new a.Buf16(n+1);var W=null;var V=0;var z,X,G;for(E=0;E<=n;E++){U[E]=0}for(k=0;k<v;k++){U[r[t+k]]++}_=C;for(A=n;A>=1;A--){if(U[A]!==0){break}}if(_>A){_=A}if(A===0){g[m++]=1<<24|64<<16|0;g[m++]=1<<24|64<<16|0;w.bits=1;return 0}for(S=1;S<A;S++){if(U[S]!==0){break}}if(_<S){_=S}y=1;for(E=1;E<=n;E++){y<<=1;y-=U[E];if(y<0){return-1}}if(y>0&&(e===f||A!==1)){return-1}H[1]=0;for(E=1;E<n;E++){H[E+1]=H[E]+U[E]}for(k=0;k<v;k++){if(r[t+k]!==0){b[H[r[t+k]]++]=k}}if(e===f){N=W=b;M=19}else if(e===o){N=c;L-=257;W=h;V-=257;M=256}else{N=u;W=d;M=-1}I=0;k=0;E=S;P=m;B=_;T=0;F=-1;x=1<<_;O=x-1;if(e===o&&x>i||e===l&&x>s){return 1}var j=0;for(;;){j++;z=E-T;if(b[k]<M){X=0;G=b[k]}else if(b[k]>M){X=W[V+b[k]];G=N[L+b[k]]}else{X=32+64;G=0}R=1<<E-T;D=1<<B;S=D;do{D-=R;g[P+(I>>T)+D]=z<<24|X<<16|G|0}while(D!==0);R=1<<E-1;while(I&R){R>>=1}if(R!==0){I&=R-1;I+=R}else{I=0}k++;if(--U[E]===0){if(E===A){break}E=r[t+b[k]]}if(E>_&&(I&O)!==F){if(T===0){T=_}P+=S;B=E-T;y=1<<B;while(B+T<A){y-=U[B+T];if(y<=0){break}B++;y<<=1}x+=1<<B;if(e===o&&x>i||e===l&&x>s){return 1}F=I&O;g[F]=_<<24|B<<16|P-m|0}}if(I!==0){g[P+I]=E-T<<24|64<<16|0}w.bits=_;return 0}},{"../utils/common":27}],37:[function(e,r,t){"use strict";r.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],38:[function(e,r,t){"use strict";var a=e("../utils/common");var n=4;var i=0;var s=1;var f=2;function o(e){var r=e.length;while(--r>=0){e[r]=0}}var l=0;var c=1;var h=2;var u=3;var d=258;var p=29;var v=256;var g=v+1+p;var m=30;var b=19;var w=2*g+1;var C=15;var E=16;var k=7;var S=256;var A=16;var _=17;var B=18;var T=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var y=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var I=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var R=512;var D=new Array((g+2)*2);o(D);var F=new Array(m*2);o(F);var O=new Array(R);o(O);var P=new Array(d-u+1);o(P);var N=new Array(p);o(N);var L=new Array(m);o(L);var M=function(e,r,t,a,n){this.static_tree=e;this.extra_bits=r;this.extra_base=t;this.elems=a;this.max_length=n;this.has_stree=e&&e.length};var U;var H;var W;var V=function(e,r){this.dyn_tree=e;this.max_code=0;this.stat_desc=r};function z(e){return e<256?O[e]:O[256+(e>>>7)]}function X(e,r){e.pending_buf[e.pending++]=r&255;e.pending_buf[e.pending++]=r>>>8&255}function G(e,r,t){if(e.bi_valid>E-t){e.bi_buf|=r<<e.bi_valid&65535;X(e,e.bi_buf);e.bi_buf=r>>E-e.bi_valid;e.bi_valid+=t-E}else{e.bi_buf|=r<<e.bi_valid&65535;e.bi_valid+=t}}function j(e,r,t){G(e,t[r*2],t[r*2+1])}function K(e,r){var t=0;do{t|=e&1;e>>>=1;t<<=1}while(--r>0);return t>>>1}function Y(e){if(e.bi_valid===16){X(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function $(e,r){var t=r.dyn_tree;var a=r.max_code;var n=r.stat_desc.static_tree;var i=r.stat_desc.has_stree;var s=r.stat_desc.extra_bits;var f=r.stat_desc.extra_base;var o=r.stat_desc.max_length;var l;var c,h;var u;var d;var p;var v=0;for(u=0;u<=C;u++){e.bl_count[u]=0}t[e.heap[e.heap_max]*2+1]=0;for(l=e.heap_max+1;l<w;l++){c=e.heap[l];u=t[t[c*2+1]*2+1]+1;if(u>o){u=o;v++}t[c*2+1]=u;if(c>a){continue}e.bl_count[u]++;d=0;if(c>=f){d=s[c-f]}p=t[c*2];e.opt_len+=p*(u+d);if(i){e.static_len+=p*(n[c*2+1]+d)}}if(v===0){return}do{u=o-1;while(e.bl_count[u]===0){u--}e.bl_count[u]--;e.bl_count[u+1]+=2;e.bl_count[o]--;v-=2}while(v>0);for(u=o;u!==0;u--){c=e.bl_count[u];while(c!==0){h=e.heap[--l];if(h>a){continue}if(t[h*2+1]!==u){e.opt_len+=(u-t[h*2+1])*t[h*2];t[h*2+1]=u}c--}}}function Z(e,r,t){var a=new Array(C+1);var n=0;var i;var s;for(i=1;i<=C;i++){a[i]=n=n+t[i-1]<<1}for(s=0;s<=r;s++){var f=e[s*2+1];if(f===0){continue}e[s*2]=K(a[f]++,f)}}function Q(){var e;var r;var t;var a;var n;var i=new Array(C+1);t=0;for(a=0;a<p-1;a++){N[a]=t;for(e=0;e<1<<T[a];e++){P[t++]=a}}P[t-1]=a;n=0;for(a=0;a<16;a++){L[a]=n;for(e=0;e<1<<y[a];e++){O[n++]=a}}n>>=7;for(;a<m;a++){L[a]=n<<7;for(e=0;e<1<<y[a]-7;e++){O[256+n++]=a}}for(r=0;r<=C;r++){i[r]=0}e=0;while(e<=143){D[e*2+1]=8;e++;i[8]++}while(e<=255){D[e*2+1]=9;e++;i[9]++}while(e<=279){D[e*2+1]=7;e++;i[7]++}while(e<=287){D[e*2+1]=8;e++;i[8]++}Z(D,g+1,i);for(e=0;e<m;e++){F[e*2+1]=5;F[e*2]=K(e,5)}U=new M(D,T,v+1,g,C);H=new M(F,y,0,m,C);W=new M(new Array(0),x,0,b,k)}function J(e){var r;for(r=0;r<g;r++){e.dyn_ltree[r*2]=0}for(r=0;r<m;r++){e.dyn_dtree[r*2]=0}for(r=0;r<b;r++){e.bl_tree[r*2]=0}e.dyn_ltree[S*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function q(e){if(e.bi_valid>8){X(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function ee(e,r,t,n){q(e);if(n){X(e,t);X(e,~t)}a.arraySet(e.pending_buf,e.window,r,t,e.pending);e.pending+=t}function re(e,r,t,a){var n=r*2;var i=t*2;return e[n]<e[i]||e[n]===e[i]&&a[r]<=a[t]}function te(e,r,t){var a=e.heap[t];var n=t<<1;while(n<=e.heap_len){if(n<e.heap_len&&re(r,e.heap[n+1],e.heap[n],e.depth)){n++}if(re(r,a,e.heap[n],e.depth)){break}e.heap[t]=e.heap[n];t=n;n<<=1}e.heap[t]=a}function ae(e,r,t){var a;var n;var i=0;var s;var f;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+i*2]<<8|e.pending_buf[e.d_buf+i*2+1];n=e.pending_buf[e.l_buf+i];i++;if(a===0){j(e,n,r)}else{s=P[n];j(e,s+v+1,r);f=T[s];if(f!==0){n-=N[s];G(e,n,f)}a--;s=z(a);j(e,s,t);f=y[s];if(f!==0){a-=L[s];G(e,a,f)}}}while(i<e.last_lit)}j(e,S,r)}function ne(e,r){var t=r.dyn_tree;var a=r.stat_desc.static_tree;var n=r.stat_desc.has_stree;var i=r.stat_desc.elems;var s,f;var o=-1;var l;e.heap_len=0;e.heap_max=w;for(s=0;s<i;s++){if(t[s*2]!==0){e.heap[++e.heap_len]=o=s;e.depth[s]=0}else{t[s*2+1]=0}}while(e.heap_len<2){l=e.heap[++e.heap_len]=o<2?++o:0;t[l*2]=1;e.depth[l]=0;e.opt_len--;if(n){e.static_len-=a[l*2+1]}}r.max_code=o;for(s=e.heap_len>>1;s>=1;s--){te(e,t,s)}l=i;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];te(e,t,1);f=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=f;t[l*2]=t[s*2]+t[f*2];e.depth[l]=(e.depth[s]>=e.depth[f]?e.depth[s]:e.depth[f])+1;t[s*2+1]=t[f*2+1]=l;e.heap[1]=l++;te(e,t,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];$(e,r);Z(t,o,e.bl_count)}function ie(e,r,t){var a;var n=-1;var i;var s=r[0*2+1];var f=0;var o=7;var l=4;if(s===0){o=138;l=3}r[(t+1)*2+1]=65535;for(a=0;a<=t;a++){i=s;s=r[(a+1)*2+1];if(++f<o&&i===s){continue}else if(f<l){e.bl_tree[i*2]+=f}else if(i!==0){if(i!==n){e.bl_tree[i*2]++}e.bl_tree[A*2]++}else if(f<=10){e.bl_tree[_*2]++}else{e.bl_tree[B*2]++}f=0;n=i;if(s===0){o=138;l=3}else if(i===s){o=6;l=3}else{o=7;l=4}}}function se(e,r,t){var a;var n=-1;var i;var s=r[0*2+1];var f=0;var o=7;var l=4;if(s===0){o=138;l=3}for(a=0;a<=t;a++){i=s;s=r[(a+1)*2+1];if(++f<o&&i===s){continue}else if(f<l){do{j(e,i,e.bl_tree)}while(--f!==0)}else if(i!==0){if(i!==n){j(e,i,e.bl_tree);f--}j(e,A,e.bl_tree);G(e,f-3,2)}else if(f<=10){j(e,_,e.bl_tree);G(e,f-3,3)}else{j(e,B,e.bl_tree);G(e,f-11,7)}f=0;n=i;if(s===0){o=138;l=3}else if(i===s){o=6;l=3}else{o=7;l=4}}}function fe(e){var r;ie(e,e.dyn_ltree,e.l_desc.max_code);ie(e,e.dyn_dtree,e.d_desc.max_code);ne(e,e.bl_desc);for(r=b-1;r>=3;r--){if(e.bl_tree[I[r]*2+1]!==0){break}}e.opt_len+=3*(r+1)+5+5+4;return r}function oe(e,r,t,a){var n;G(e,r-257,5);G(e,t-1,5);G(e,a-4,4);for(n=0;n<a;n++){G(e,e.bl_tree[I[n]*2+1],3)}se(e,e.dyn_ltree,r-1);se(e,e.dyn_dtree,t-1)}function le(e){var r=4093624447;var t;for(t=0;t<=31;t++,r>>>=1){if(r&1&&e.dyn_ltree[t*2]!==0){return i}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(t=32;t<v;t++){if(e.dyn_ltree[t*2]!==0){return s}}return i}var ce=false;function he(e){if(!ce){Q();ce=true}e.l_desc=new V(e.dyn_ltree,U);e.d_desc=new V(e.dyn_dtree,H);e.bl_desc=new V(e.bl_tree,W);e.bi_buf=0;e.bi_valid=0;J(e)}function ue(e,r,t,a){G(e,(l<<1)+(a?1:0),3);ee(e,r,t,true)}function de(e){G(e,c<<1,3);j(e,S,D);Y(e)}function pe(e,r,t,a){var i,s;var o=0;if(e.level>0){if(e.strm.data_type===f){e.strm.data_type=le(e)}ne(e,e.l_desc);ne(e,e.d_desc);o=fe(e);i=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=i){i=s}}else{i=s=t+5}if(t+4<=i&&r!==-1){ue(e,r,t,a)}else if(e.strategy===n||s===i){G(e,(c<<1)+(a?1:0),3);ae(e,D,F)}else{G(e,(h<<1)+(a?1:0),3);oe(e,e.l_desc.max_code+1,e.d_desc.max_code+1,o+1);ae(e,e.dyn_ltree,e.dyn_dtree)}J(e);if(a){q(e)}}function ve(e,r,t){e.pending_buf[e.d_buf+e.last_lit*2]=r>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=r&255;e.pending_buf[e.l_buf+e.last_lit]=t&255;e.last_lit++;if(r===0){e.dyn_ltree[t*2]++}else{e.matches++;r--;e.dyn_ltree[(P[t]+v+1)*2]++;e.dyn_dtree[z(r)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=he;t._tr_stored_block=ue;t._tr_flush_block=pe;t._tr_tally=ve;t._tr_align=de},{"../utils/common":27}],39:[function(e,r,t){"use strict";function a(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}r.exports=a},{}]},{},[9])(9)});var cptable={version:"1.14.0"};cptable[437]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[620]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[737]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[850]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[852]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[857]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[861]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[865]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[866]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[874]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[895]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[932]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[135]="����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[224]="����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[237]="����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[250]="����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}return{enc:r,dec:e}}();cptable[936]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[133]="����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");for(a=0;a!=t[133].length;++a)if(t[133][a].charCodeAt(0)!==65533){r[t[133][a]]=34048+a;e[34048+a]=t[133][a]}t[134]="����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");for(a=0;a!=t[134].length;++a)if(t[134][a].charCodeAt(0)!==65533){r[t[134][a]]=34304+a;e[34304+a]=t[134][a]}t[135]="����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[160]="����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");for(a=0;a!=t[160].length;++a)if(t[160][a].charCodeAt(0)!==65533){r[t[160][a]]=40960+a;e[40960+a]=t[160][a]}t[161]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[201]="����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}t[250]="����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}t[253]="����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[253].length;++a)if(t[253][a].charCodeAt(0)!==65533){r[t[253][a]]=64768+a;e[64768+a]=t[253][a]}t[254]="����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[254].length;++a)if(t[254][a].charCodeAt(0)!==65533){r[t[254][a]]=65024+a;e[65024+a]=t[254][a]}return{enc:r,dec:e}}();cptable[949]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[129]="�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");for(a=0;a!=t[129].length;++a)if(t[129][a].charCodeAt(0)!==65533){r[t[129][a]]=33024+a;e[33024+a]=t[129][a]}t[130]="�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");for(a=0;a!=t[130].length;++a)if(t[130][a].charCodeAt(0)!==65533){r[t[130][a]]=33280+a;e[33280+a]=t[130][a]}t[131]="�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");for(a=0;a!=t[131].length;++a)if(t[131][a].charCodeAt(0)!==65533){r[t[131][a]]=33536+a;e[33536+a]=t[131][a]}t[132]="�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");for(a=0;a!=t[132].length;++a)if(t[132][a].charCodeAt(0)!==65533){r[t[132][a]]=33792+a;e[33792+a]=t[132][a]}t[133]="�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");for(a=0;a!=t[133].length;++a)if(t[133][a].charCodeAt(0)!==65533){r[t[133][a]]=34048+a;e[34048+a]=t[133][a]}t[134]="�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");for(a=0;a!=t[134].length;++a)if(t[134][a].charCodeAt(0)!==65533){r[t[134][a]]=34304+a;e[34304+a]=t[134][a]}t[135]="�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");for(a=0;a!=t[135].length;++a)if(t[135][a].charCodeAt(0)!==65533){r[t[135][a]]=34560+a;e[34560+a]=t[135][a]}t[136]="�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");for(a=0;a!=t[136].length;++a)if(t[136][a].charCodeAt(0)!==65533){r[t[136][a]]=34816+a;e[34816+a]=t[136][a]}t[137]="�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");for(a=0;a!=t[137].length;++a)if(t[137][a].charCodeAt(0)!==65533){r[t[137][a]]=35072+a;e[35072+a]=t[137][a]}t[138]="�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");for(a=0;a!=t[138].length;++a)if(t[138][a].charCodeAt(0)!==65533){r[t[138][a]]=35328+a;e[35328+a]=t[138][a]}t[139]="�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");for(a=0;a!=t[139].length;++a)if(t[139][a].charCodeAt(0)!==65533){r[t[139][a]]=35584+a;e[35584+a]=t[139][a]}t[140]="�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");for(a=0;a!=t[140].length;++a)if(t[140][a].charCodeAt(0)!==65533){r[t[140][a]]=35840+a;e[35840+a]=t[140][a]}t[141]="�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");for(a=0;a!=t[141].length;++a)if(t[141][a].charCodeAt(0)!==65533){r[t[141][a]]=36096+a;e[36096+a]=t[141][a]}t[142]="�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");for(a=0;a!=t[142].length;++a)if(t[142][a].charCodeAt(0)!==65533){r[t[142][a]]=36352+a;e[36352+a]=t[142][a]}t[143]="�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");for(a=0;a!=t[143].length;++a)if(t[143][a].charCodeAt(0)!==65533){r[t[143][a]]=36608+a;e[36608+a]=t[143][a]}t[144]="�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");for(a=0;a!=t[144].length;++a)if(t[144][a].charCodeAt(0)!==65533){r[t[144][a]]=36864+a;e[36864+a]=t[144][a]}t[145]="�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");for(a=0;a!=t[145].length;++a)if(t[145][a].charCodeAt(0)!==65533){r[t[145][a]]=37120+a;e[37120+a]=t[145][a]}t[146]="�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");for(a=0;a!=t[146].length;++a)if(t[146][a].charCodeAt(0)!==65533){r[t[146][a]]=37376+a;e[37376+a]=t[146][a]}t[147]="�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");for(a=0;a!=t[147].length;++a)if(t[147][a].charCodeAt(0)!==65533){r[t[147][a]]=37632+a;e[37632+a]=t[147][a]}t[148]="�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");for(a=0;a!=t[148].length;++a)if(t[148][a].charCodeAt(0)!==65533){r[t[148][a]]=37888+a;e[37888+a]=t[148][a]}t[149]="�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");for(a=0;a!=t[149].length;++a)if(t[149][a].charCodeAt(0)!==65533){r[t[149][a]]=38144+a;e[38144+a]=t[149][a]}t[150]="�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");for(a=0;a!=t[150].length;++a)if(t[150][a].charCodeAt(0)!==65533){r[t[150][a]]=38400+a;e[38400+a]=t[150][a]}t[151]="�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");for(a=0;a!=t[151].length;++a)if(t[151][a].charCodeAt(0)!==65533){r[t[151][a]]=38656+a;e[38656+a]=t[151][a]}t[152]="�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(a=0;a!=t[152].length;++a)if(t[152][a].charCodeAt(0)!==65533){r[t[152][a]]=38912+a;e[38912+a]=t[152][a]}t[153]="�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");for(a=0;a!=t[153].length;++a)if(t[153][a].charCodeAt(0)!==65533){r[t[153][a]]=39168+a;e[39168+a]=t[153][a]}t[154]="�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");for(a=0;a!=t[154].length;++a)if(t[154][a].charCodeAt(0)!==65533){r[t[154][a]]=39424+a;e[39424+a]=t[154][a]}t[155]="�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");for(a=0;a!=t[155].length;++a)if(t[155][a].charCodeAt(0)!==65533){r[t[155][a]]=39680+a;e[39680+a]=t[155][a]}t[156]="�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");for(a=0;a!=t[156].length;++a)if(t[156][a].charCodeAt(0)!==65533){r[t[156][a]]=39936+a;e[39936+a]=t[156][a]}t[157]="�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");for(a=0;a!=t[157].length;++a)if(t[157][a].charCodeAt(0)!==65533){r[t[157][a]]=40192+a;e[40192+a]=t[157][a]}t[158]="�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");for(a=0;a!=t[158].length;++a)if(t[158][a].charCodeAt(0)!==65533){r[t[158][a]]=40448+a;e[40448+a]=t[158][a]}t[159]="�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");for(a=0;a!=t[159].length;++a)if(t[159][a].charCodeAt(0)!==65533){r[t[159][a]]=40704+a;e[40704+a]=t[159][a]}t[160]="�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");for(a=0;a!=t[160].length;++a)if(t[160][a].charCodeAt(0)!==65533){r[t[160][a]]=40960+a;e[40960+a]=t[160][a]}t[161]="�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[202]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}t[250]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");for(a=0;a!=t[250].length;++a)if(t[250][a].charCodeAt(0)!==65533){r[t[250][a]]=64e3+a;e[64e3+a]=t[250][a]}t[251]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");for(a=0;a!=t[251].length;++a)if(t[251][a].charCodeAt(0)!==65533){r[t[251][a]]=64256+a;e[64256+a]=t[251][a]}t[252]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");for(a=0;a!=t[252].length;++a)if(t[252][a].charCodeAt(0)!==65533){r[t[252][a]]=64512+a;e[64512+a]=t[252][a]}t[253]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");for(a=0;a!=t[253].length;++a)if(t[253][a].charCodeAt(0)!==65533){r[t[253][a]]=64768+a;e[64768+a]=t[253][a]}return{enc:r,dec:e}}();cptable[950]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[161]="����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[170]="����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");for(a=0;a!=t[170].length;++a)if(t[170][a].charCodeAt(0)!==65533){r[t[170][a]]=43520+a;e[43520+a]=t[170][a]}t[171]="����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");for(a=0;a!=t[171].length;++a)if(t[171][a].charCodeAt(0)!==65533){r[t[171][a]]=43776+a;e[43776+a]=t[171][a]}t[172]="����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");for(a=0;a!=t[172].length;++a)if(t[172][a].charCodeAt(0)!==65533){r[t[172][a]]=44032+a;e[44032+a]=t[172][a]}t[173]="����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");for(a=0;a!=t[173].length;++a)if(t[173][a].charCodeAt(0)!==65533){r[t[173][a]]=44288+a;e[44288+a]=t[173][a]}t[174]="����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");for(a=0;a!=t[174].length;++a)if(t[174][a].charCodeAt(0)!==65533){r[t[174][a]]=44544+a;e[44544+a]=t[174][a]}t[175]="����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");for(a=0;a!=t[175].length;++a)if(t[175][a].charCodeAt(0)!==65533){r[t[175][a]]=44800+a;e[44800+a]=t[175][a]}t[176]="����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[201]="����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}t[248]="����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");for(a=0;a!=t[248].length;++a)if(t[248][a].charCodeAt(0)!==65533){r[t[248][a]]=63488+a;e[63488+a]=t[248][a]}t[249]="����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");for(a=0;a!=t[249].length;++a)if(t[249][a].charCodeAt(0)!==65533){r[t[249][a]]=63744+a;e[63744+a]=t[249][a]}return{enc:r,dec:e}}();cptable[1250]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1251]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1252]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1253]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1254]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1255]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1256]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1257]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1258]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[1e4]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10006]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10007]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10008]=function(){var e=[],r={},t=[],a;t[0]="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");for(a=0;a!=t[0].length;++a)if(t[0][a].charCodeAt(0)!==65533){r[t[0][a]]=0+a;e[0+a]=t[0][a]}t[161]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");for(a=0;a!=t[161].length;++a)if(t[161][a].charCodeAt(0)!==65533){r[t[161][a]]=41216+a;e[41216+a]=t[161][a]}t[162]="���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");for(a=0;a!=t[162].length;++a)if(t[162][a].charCodeAt(0)!==65533){r[t[162][a]]=41472+a;e[41472+a]=t[162][a]}t[163]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");for(a=0;a!=t[163].length;++a)if(t[163][a].charCodeAt(0)!==65533){r[t[163][a]]=41728+a;e[41728+a]=t[163][a]}t[164]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");for(a=0;a!=t[164].length;++a)if(t[164][a].charCodeAt(0)!==65533){r[t[164][a]]=41984+a;e[41984+a]=t[164][a]}t[165]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");for(a=0;a!=t[165].length;++a)if(t[165][a].charCodeAt(0)!==65533){r[t[165][a]]=42240+a;e[42240+a]=t[165][a]}t[166]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");for(a=0;a!=t[166].length;++a)if(t[166][a].charCodeAt(0)!==65533){r[t[166][a]]=42496+a;e[42496+a]=t[166][a]}t[167]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");for(a=0;a!=t[167].length;++a)if(t[167][a].charCodeAt(0)!==65533){r[t[167][a]]=42752+a;e[42752+a]=t[167][a]}t[168]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");for(a=0;a!=t[168].length;++a)if(t[168][a].charCodeAt(0)!==65533){r[t[168][a]]=43008+a;e[43008+a]=t[168][a]}t[169]="��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");for(a=0;a!=t[169].length;++a)if(t[169][a].charCodeAt(0)!==65533){r[t[169][a]]=43264+a;e[43264+a]=t[169][a]}t[176]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");for(a=0;a!=t[176].length;++a)if(t[176][a].charCodeAt(0)!==65533){r[t[176][a]]=45056+a;e[45056+a]=t[176][a]}t[177]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");for(a=0;a!=t[177].length;++a)if(t[177][a].charCodeAt(0)!==65533){r[t[177][a]]=45312+a;e[45312+a]=t[177][a]}t[178]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");for(a=0;a!=t[178].length;++a)if(t[178][a].charCodeAt(0)!==65533){r[t[178][a]]=45568+a;e[45568+a]=t[178][a]}t[179]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");for(a=0;a!=t[179].length;++a)if(t[179][a].charCodeAt(0)!==65533){r[t[179][a]]=45824+a;e[45824+a]=t[179][a]}t[180]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");for(a=0;a!=t[180].length;++a)if(t[180][a].charCodeAt(0)!==65533){r[t[180][a]]=46080+a;e[46080+a]=t[180][a]}t[181]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");for(a=0;a!=t[181].length;++a)if(t[181][a].charCodeAt(0)!==65533){r[t[181][a]]=46336+a;e[46336+a]=t[181][a]}t[182]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");for(a=0;a!=t[182].length;++a)if(t[182][a].charCodeAt(0)!==65533){r[t[182][a]]=46592+a;e[46592+a]=t[182][a]}t[183]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");for(a=0;a!=t[183].length;++a)if(t[183][a].charCodeAt(0)!==65533){r[t[183][a]]=46848+a;e[46848+a]=t[183][a]}t[184]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");for(a=0;a!=t[184].length;++a)if(t[184][a].charCodeAt(0)!==65533){r[t[184][a]]=47104+a;e[47104+a]=t[184][a]}t[185]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");for(a=0;a!=t[185].length;++a)if(t[185][a].charCodeAt(0)!==65533){r[t[185][a]]=47360+a;e[47360+a]=t[185][a]}t[186]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");for(a=0;a!=t[186].length;++a)if(t[186][a].charCodeAt(0)!==65533){r[t[186][a]]=47616+a;e[47616+a]=t[186][a]}t[187]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");for(a=0;a!=t[187].length;++a)if(t[187][a].charCodeAt(0)!==65533){r[t[187][a]]=47872+a;e[47872+a]=t[187][a]}t[188]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");for(a=0;a!=t[188].length;++a)if(t[188][a].charCodeAt(0)!==65533){r[t[188][a]]=48128+a;e[48128+a]=t[188][a]}t[189]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");for(a=0;a!=t[189].length;++a)if(t[189][a].charCodeAt(0)!==65533){r[t[189][a]]=48384+a;e[48384+a]=t[189][a]}t[190]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");for(a=0;a!=t[190].length;++a)if(t[190][a].charCodeAt(0)!==65533){r[t[190][a]]=48640+a;e[48640+a]=t[190][a]}t[191]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");for(a=0;a!=t[191].length;++a)if(t[191][a].charCodeAt(0)!==65533){r[t[191][a]]=48896+a;e[48896+a]=t[191][a]}t[192]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");for(a=0;a!=t[192].length;++a)if(t[192][a].charCodeAt(0)!==65533){r[t[192][a]]=49152+a;e[49152+a]=t[192][a]}t[193]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");for(a=0;a!=t[193].length;++a)if(t[193][a].charCodeAt(0)!==65533){r[t[193][a]]=49408+a;e[49408+a]=t[193][a]}t[194]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");for(a=0;a!=t[194].length;++a)if(t[194][a].charCodeAt(0)!==65533){r[t[194][a]]=49664+a;e[49664+a]=t[194][a]}t[195]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");for(a=0;a!=t[195].length;++a)if(t[195][a].charCodeAt(0)!==65533){r[t[195][a]]=49920+a;e[49920+a]=t[195][a]}t[196]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");for(a=0;a!=t[196].length;++a)if(t[196][a].charCodeAt(0)!==65533){r[t[196][a]]=50176+a;e[50176+a]=t[196][a]}t[197]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");for(a=0;a!=t[197].length;++a)if(t[197][a].charCodeAt(0)!==65533){r[t[197][a]]=50432+a;e[50432+a]=t[197][a]}t[198]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");for(a=0;a!=t[198].length;++a)if(t[198][a].charCodeAt(0)!==65533){r[t[198][a]]=50688+a;e[50688+a]=t[198][a]}t[199]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");for(a=0;a!=t[199].length;++a)if(t[199][a].charCodeAt(0)!==65533){r[t[199][a]]=50944+a;e[50944+a]=t[199][a]}t[200]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");for(a=0;a!=t[200].length;++a)if(t[200][a].charCodeAt(0)!==65533){r[t[200][a]]=51200+a;e[51200+a]=t[200][a]}t[201]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");for(a=0;a!=t[201].length;++a)if(t[201][a].charCodeAt(0)!==65533){r[t[201][a]]=51456+a;e[51456+a]=t[201][a]}t[202]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");for(a=0;a!=t[202].length;++a)if(t[202][a].charCodeAt(0)!==65533){r[t[202][a]]=51712+a;e[51712+a]=t[202][a]}t[203]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");for(a=0;a!=t[203].length;++a)if(t[203][a].charCodeAt(0)!==65533){r[t[203][a]]=51968+a;e[51968+a]=t[203][a]}t[204]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");for(a=0;a!=t[204].length;++a)if(t[204][a].charCodeAt(0)!==65533){r[t[204][a]]=52224+a;e[52224+a]=t[204][a]}t[205]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");for(a=0;a!=t[205].length;++a)if(t[205][a].charCodeAt(0)!==65533){r[t[205][a]]=52480+a;e[52480+a]=t[205][a]}t[206]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");for(a=0;a!=t[206].length;++a)if(t[206][a].charCodeAt(0)!==65533){r[t[206][a]]=52736+a;e[52736+a]=t[206][a]}t[207]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");for(a=0;a!=t[207].length;++a)if(t[207][a].charCodeAt(0)!==65533){r[t[207][a]]=52992+a;e[52992+a]=t[207][a]}t[208]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");for(a=0;a!=t[208].length;++a)if(t[208][a].charCodeAt(0)!==65533){r[t[208][a]]=53248+a;e[53248+a]=t[208][a]}t[209]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");for(a=0;a!=t[209].length;++a)if(t[209][a].charCodeAt(0)!==65533){r[t[209][a]]=53504+a;e[53504+a]=t[209][a]}t[210]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");for(a=0;a!=t[210].length;++a)if(t[210][a].charCodeAt(0)!==65533){r[t[210][a]]=53760+a;e[53760+a]=t[210][a]}t[211]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");for(a=0;a!=t[211].length;++a)if(t[211][a].charCodeAt(0)!==65533){r[t[211][a]]=54016+a;e[54016+a]=t[211][a]}t[212]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");for(a=0;a!=t[212].length;++a)if(t[212][a].charCodeAt(0)!==65533){r[t[212][a]]=54272+a;e[54272+a]=t[212][a]}t[213]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");for(a=0;a!=t[213].length;++a)if(t[213][a].charCodeAt(0)!==65533){r[t[213][a]]=54528+a;e[54528+a]=t[213][a]}t[214]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");for(a=0;a!=t[214].length;++a)if(t[214][a].charCodeAt(0)!==65533){r[t[214][a]]=54784+a;e[54784+a]=t[214][a]}t[215]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");for(a=0;a!=t[215].length;++a)if(t[215][a].charCodeAt(0)!==65533){
r[t[215][a]]=55040+a;e[55040+a]=t[215][a]}t[216]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");for(a=0;a!=t[216].length;++a)if(t[216][a].charCodeAt(0)!==65533){r[t[216][a]]=55296+a;e[55296+a]=t[216][a]}t[217]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");for(a=0;a!=t[217].length;++a)if(t[217][a].charCodeAt(0)!==65533){r[t[217][a]]=55552+a;e[55552+a]=t[217][a]}t[218]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");for(a=0;a!=t[218].length;++a)if(t[218][a].charCodeAt(0)!==65533){r[t[218][a]]=55808+a;e[55808+a]=t[218][a]}t[219]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");for(a=0;a!=t[219].length;++a)if(t[219][a].charCodeAt(0)!==65533){r[t[219][a]]=56064+a;e[56064+a]=t[219][a]}t[220]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");for(a=0;a!=t[220].length;++a)if(t[220][a].charCodeAt(0)!==65533){r[t[220][a]]=56320+a;e[56320+a]=t[220][a]}t[221]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");for(a=0;a!=t[221].length;++a)if(t[221][a].charCodeAt(0)!==65533){r[t[221][a]]=56576+a;e[56576+a]=t[221][a]}t[222]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");for(a=0;a!=t[222].length;++a)if(t[222][a].charCodeAt(0)!==65533){r[t[222][a]]=56832+a;e[56832+a]=t[222][a]}t[223]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");for(a=0;a!=t[223].length;++a)if(t[223][a].charCodeAt(0)!==65533){r[t[223][a]]=57088+a;e[57088+a]=t[223][a]}t[224]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");for(a=0;a!=t[224].length;++a)if(t[224][a].charCodeAt(0)!==65533){r[t[224][a]]=57344+a;e[57344+a]=t[224][a]}t[225]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");for(a=0;a!=t[225].length;++a)if(t[225][a].charCodeAt(0)!==65533){r[t[225][a]]=57600+a;e[57600+a]=t[225][a]}t[226]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");for(a=0;a!=t[226].length;++a)if(t[226][a].charCodeAt(0)!==65533){r[t[226][a]]=57856+a;e[57856+a]=t[226][a]}t[227]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");for(a=0;a!=t[227].length;++a)if(t[227][a].charCodeAt(0)!==65533){r[t[227][a]]=58112+a;e[58112+a]=t[227][a]}t[228]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");for(a=0;a!=t[228].length;++a)if(t[228][a].charCodeAt(0)!==65533){r[t[228][a]]=58368+a;e[58368+a]=t[228][a]}t[229]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");for(a=0;a!=t[229].length;++a)if(t[229][a].charCodeAt(0)!==65533){r[t[229][a]]=58624+a;e[58624+a]=t[229][a]}t[230]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");for(a=0;a!=t[230].length;++a)if(t[230][a].charCodeAt(0)!==65533){r[t[230][a]]=58880+a;e[58880+a]=t[230][a]}t[231]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");for(a=0;a!=t[231].length;++a)if(t[231][a].charCodeAt(0)!==65533){r[t[231][a]]=59136+a;e[59136+a]=t[231][a]}t[232]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");for(a=0;a!=t[232].length;++a)if(t[232][a].charCodeAt(0)!==65533){r[t[232][a]]=59392+a;e[59392+a]=t[232][a]}t[233]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");for(a=0;a!=t[233].length;++a)if(t[233][a].charCodeAt(0)!==65533){r[t[233][a]]=59648+a;e[59648+a]=t[233][a]}t[234]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");for(a=0;a!=t[234].length;++a)if(t[234][a].charCodeAt(0)!==65533){r[t[234][a]]=59904+a;e[59904+a]=t[234][a]}t[235]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");for(a=0;a!=t[235].length;++a)if(t[235][a].charCodeAt(0)!==65533){r[t[235][a]]=60160+a;e[60160+a]=t[235][a]}t[236]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");for(a=0;a!=t[236].length;++a)if(t[236][a].charCodeAt(0)!==65533){r[t[236][a]]=60416+a;e[60416+a]=t[236][a]}t[237]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");for(a=0;a!=t[237].length;++a)if(t[237][a].charCodeAt(0)!==65533){r[t[237][a]]=60672+a;e[60672+a]=t[237][a]}t[238]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");for(a=0;a!=t[238].length;++a)if(t[238][a].charCodeAt(0)!==65533){r[t[238][a]]=60928+a;e[60928+a]=t[238][a]}t[239]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");for(a=0;a!=t[239].length;++a)if(t[239][a].charCodeAt(0)!==65533){r[t[239][a]]=61184+a;e[61184+a]=t[239][a]}t[240]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");for(a=0;a!=t[240].length;++a)if(t[240][a].charCodeAt(0)!==65533){r[t[240][a]]=61440+a;e[61440+a]=t[240][a]}t[241]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");for(a=0;a!=t[241].length;++a)if(t[241][a].charCodeAt(0)!==65533){r[t[241][a]]=61696+a;e[61696+a]=t[241][a]}t[242]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");for(a=0;a!=t[242].length;++a)if(t[242][a].charCodeAt(0)!==65533){r[t[242][a]]=61952+a;e[61952+a]=t[242][a]}t[243]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");for(a=0;a!=t[243].length;++a)if(t[243][a].charCodeAt(0)!==65533){r[t[243][a]]=62208+a;e[62208+a]=t[243][a]}t[244]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");for(a=0;a!=t[244].length;++a)if(t[244][a].charCodeAt(0)!==65533){r[t[244][a]]=62464+a;e[62464+a]=t[244][a]}t[245]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");for(a=0;a!=t[245].length;++a)if(t[245][a].charCodeAt(0)!==65533){r[t[245][a]]=62720+a;e[62720+a]=t[245][a]}t[246]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");for(a=0;a!=t[246].length;++a)if(t[246][a].charCodeAt(0)!==65533){r[t[246][a]]=62976+a;e[62976+a]=t[246][a]}t[247]="�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");for(a=0;a!=t[247].length;++a)if(t[247][a].charCodeAt(0)!==65533){r[t[247][a]]=63232+a;e[63232+a]=t[247][a]}return{enc:r,dec:e}}();cptable[10029]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10079]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();cptable[10081]=function(){var e="\0\b\t\n\x0B\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ",r=[],t={};for(var a=0;a!=e.length;++a){if(e.charCodeAt(a)!==65533)t[e.charAt(a)]=a;r[a]=e.charAt(a)}return{enc:t,dec:r}}();if(typeof module!=="undefined"&&module.exports&&typeof DO_NOT_EXPORT_CODEPAGE==="undefined")module.exports=cptable;(function(e,r){"use strict";if(typeof cptable==="undefined"){if(typeof require!=="undefined"){var t=cptable;if(typeof module!=="undefined"&&module.exports&&typeof DO_NOT_EXPORT_CODEPAGE==="undefined")module.exports=r(t);else e.cptable=r(t)}else throw new Error("cptable not found")}else cptable=r(cptable)})(this,function(e){"use strict";var r={1200:"utf16le",1201:"utf16be",12000:"utf32le",12001:"utf32be",16969:"utf64le",20127:"ascii",65000:"utf7",65001:"utf8"};var t=[874,1250,1251,1252,1253,1254,1255,1256,1e4];var a=[932,936,949,950];var n=[65001];var i={};var s={};var f={};var o={};var l=function O(e){return String.fromCharCode(e)};var c=function P(e){return e.charCodeAt(0)};var h=typeof Buffer!=="undefined";var u=function(){};if(h){var d=!Buffer.from;if(!d)try{Buffer.from("foo","utf8")}catch(p){d=true}u=d?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)};var v=1024,g=Buffer.allocUnsafe(v);var m=function N(e){var r=Buffer.allocUnsafe(65536);for(var t=0;t<65536;++t)r[t]=0;var a=Object.keys(e),n=a.length;for(var i=0,s=a[i];i<n;++i){if(!(s=a[i]))continue;r[s.charCodeAt(0)]=e[s]}return r};var b=function L(r){var t=m(e[r].enc);return function a(e,r){var a=e.length;var n,i=0,s=0,f=0,o=0;if(typeof e==="string"){n=Buffer.allocUnsafe(a);for(i=0;i<a;++i)n[i]=t[e.charCodeAt(i)]}else if(Buffer.isBuffer(e)){n=Buffer.allocUnsafe(2*a);s=0;for(i=0;i<a;++i){f=e[i];if(f<128)n[s++]=t[f];else if(f<224){n[s++]=t[((f&31)<<6)+(e[i+1]&63)];++i}else if(f<240){n[s++]=t[((f&15)<<12)+((e[i+1]&63)<<6)+(e[i+2]&63)];i+=2}else{o=((f&7)<<18)+((e[i+1]&63)<<12)+((e[i+2]&63)<<6)+(e[i+3]&63);i+=3;if(o<65536)n[s++]=t[o];else{o-=65536;n[s++]=t[55296+(o>>10&1023)];n[s++]=t[56320+(o&1023)]}}}n=n.slice(0,s)}else{n=Buffer.allocUnsafe(a);for(i=0;i<a;++i)n[i]=t[e[i].charCodeAt(0)]}if(!r||r==="buf")return n;if(r!=="arr")return n.toString("binary");return[].slice.call(n)}};var w=function M(r){var t=e[r].dec;var a=Buffer.allocUnsafe(131072),n=0,i="";for(n=0;n<t.length;++n){if(!(i=t[n]))continue;var s=i.charCodeAt(0);a[2*n]=s&255;a[2*n+1]=s>>8}return function f(e){var r=e.length,t=0,n=0;if(2*r>v){v=2*r;g=Buffer.allocUnsafe(v)}if(Buffer.isBuffer(e)){for(t=0;t<r;t++){n=2*e[t];g[2*t]=a[n];g[2*t+1]=a[n+1]}}else if(typeof e==="string"){for(t=0;t<r;t++){n=2*e.charCodeAt(t);g[2*t]=a[n];g[2*t+1]=a[n+1]}}else{for(t=0;t<r;t++){n=2*e[t];g[2*t]=a[n];g[2*t+1]=a[n+1]}}return g.slice(0,2*r).toString("ucs2")}};var C=function U(r){var t=e[r].enc;var a=Buffer.allocUnsafe(131072);for(var n=0;n<131072;++n)a[n]=0;var i=Object.keys(t);for(var s=0,f=i[s];s<i.length;++s){if(!(f=i[s]))continue;var o=f.charCodeAt(0);a[2*o]=t[f]&255;a[2*o+1]=t[f]>>8}return function l(e,r){var t=e.length,n=Buffer.allocUnsafe(2*t),i=0,s=0,f=0,o=0,l=0;if(typeof e==="string"){for(i=o=0;i<t;++i){s=e.charCodeAt(i)*2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}n=n.slice(0,o)}else if(Buffer.isBuffer(e)){for(i=o=0;i<t;++i){l=e[i];if(l<128)s=l;else if(l<224){s=((l&31)<<6)+(e[i+1]&63);++i}else if(l<240){s=((l&15)<<12)+((e[i+1]&63)<<6)+(e[i+2]&63);i+=2}else{s=((l&7)<<18)+((e[i+1]&63)<<12)+((e[i+2]&63)<<6)+(e[i+3]&63);i+=3}if(s<65536){s*=2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}else{f=s-65536;s=2*(55296+(f>>10&1023));n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s];s=2*(56320+(f&1023));n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}}n=n.slice(0,o)}else{for(i=o=0;i<t;i++){s=e[i].charCodeAt(0)*2;n[o++]=a[s+1]||a[s];if(a[s+1]>0)n[o++]=a[s]}}if(!r||r==="buf")return n;if(r!=="arr")return n.toString("binary");return[].slice.call(n)}};var E=function H(r){var t=e[r].dec;var a=Buffer.allocUnsafe(131072),n=0,i,s=0,f=0,o=0;for(o=0;o<65536;++o){a[2*o]=255;a[2*o+1]=253}for(n=0;n<t.length;++n){if(!(i=t[n]))continue;s=i.charCodeAt(0);f=2*n;a[f]=s&255;a[f+1]=s>>8}return function l(e){var r=e.length,t=Buffer.allocUnsafe(2*r),n=0,i=0,s=0;if(Buffer.isBuffer(e)){for(n=0;n<r;n++){i=2*e[n];if(a[i]===255&&a[i+1]===253){i=2*((e[n]<<8)+e[n+1]);++n}t[s++]=a[i];t[s++]=a[i+1]}}else if(typeof e==="string"){for(n=0;n<r;n++){i=2*e.charCodeAt(n);if(a[i]===255&&a[i+1]===253){i=2*((e.charCodeAt(n)<<8)+e.charCodeAt(n+1));++n}t[s++]=a[i];t[s++]=a[i+1]}}else{for(n=0;n<r;n++){i=2*e[n];if(a[i]===255&&a[i+1]===253){i=2*((e[n]<<8)+e[n+1]);++n}t[s++]=a[i];t[s++]=a[i+1]}}return t.slice(0,s).toString("ucs2")}};i[65001]=function W(e){if(typeof e==="string")return W(e.split("").map(c));var r=e.length,t=0,a=0;if(4*r>v){v=4*r;g=Buffer.allocUnsafe(v)}var n=0;if(r>=3&&e[0]==239)if(e[1]==187&&e[2]==191)n=3;for(var i=1,s=0,f=0;n<r;n+=i){i=1;f=e[n];if(f<128)t=f;else if(f<224){t=(f&31)*64+(e[n+1]&63);i=2}else if(f<240){t=((f&15)<<12)+(e[n+1]&63)*64+(e[n+2]&63);i=3}else{t=(f&7)*262144+((e[n+1]&63)<<12)+(e[n+2]&63)*64+(e[n+3]&63);i=4}if(t<65536){g[s++]=t&255;g[s++]=t>>8}else{t-=65536;a=55296+(t>>10&1023);t=56320+(t&1023);g[s++]=a&255;g[s++]=a>>>8;g[s++]=t&255;g[s++]=t>>>8&255}}return g.slice(0,s).toString("ucs2")};s[65001]=function V(e,r){if(h&&Buffer.isBuffer(e)){if(!r||r==="buf")return e;if(r!=="arr")return e.toString("binary");return[].slice.call(e)}var t=e.length,a=0,n=0,i=0;var s=typeof e==="string";if(4*t>v){v=4*t;g=Buffer.allocUnsafe(v)}for(var f=0;f<t;++f){a=s?e.charCodeAt(f):e[f].charCodeAt(0);if(a<=127)g[i++]=a;else if(a<=2047){g[i++]=192+(a>>6);g[i++]=128+(a&63)}else if(a>=55296&&a<=57343){a-=55296;++f;n=(s?e.charCodeAt(f):e[f].charCodeAt(0))-56320+(a<<10);g[i++]=240+(n>>>18&7);g[i++]=144+(n>>>12&63);g[i++]=128+(n>>>6&63);g[i++]=128+(n&63)}else{g[i++]=224+(a>>12);g[i++]=128+(a>>6&63);g[i++]=128+(a&63)}}if(!r||r==="buf")return g.slice(0,i);if(r!=="arr")return g.slice(0,i).toString("binary");return[].slice.call(g,0,i)}}var k=function z(){if(h){if(f[t[0]])return;var r=0,l=0;for(r=0;r<t.length;++r){l=t[r];if(e[l]){f[l]=w(l);o[l]=b(l)}}for(r=0;r<a.length;++r){l=a[r];if(e[l]){f[l]=E(l);o[l]=C(l)}}for(r=0;r<n.length;++r){l=n[r];if(i[l])f[l]=i[l];if(s[l])o[l]=s[l]}}};var S=function(e,r){void r;return""};var A=function X(e){delete f[e];delete o[e]};var _=function G(){if(h){if(!f[t[0]])return;t.forEach(A);a.forEach(A);n.forEach(A)}x=S;I=0};var B={encache:k,decache:_,sbcs:t,dbcs:a};k();var T="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var y="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";var x=S,I=0;var R=function j(t,a,n){if(t===I&&x){return x(a,n)}if(o[t]){x=o[I=t];return x(a,n)}if(h&&Buffer.isBuffer(a))a=a.toString("utf8");var i=a.length;var s=h?Buffer.allocUnsafe(4*i):[],f=0,c=0,d=0,p=0;var v=e[t],g,m="";var b=typeof a==="string";if(v&&(g=v.enc))for(c=0;c<i;++c,++d){f=g[b?a.charAt(c):a[c]];if(f>255){s[d]=f>>8;s[++d]=f&255}else s[d]=f&255}else if(m=r[t])switch(m){case"utf8":if(h&&b){s=u(a,m);d=s.length;break}for(c=0;c<i;++c,++d){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f<=127)s[d]=f;else if(f<=2047){s[d]=192+(f>>6);s[++d]=128+(f&63)}else if(f>=55296&&f<=57343){f-=55296;p=(b?a.charCodeAt(++c):a[++c].charCodeAt(0))-56320+(f<<10);s[d]=240+(p>>>18&7);s[++d]=144+(p>>>12&63);s[++d]=128+(p>>>6&63);s[++d]=128+(p&63)}else{s[d]=224+(f>>12);s[++d]=128+(f>>6&63);s[++d]=128+(f&63)}}break;case"ascii":if(h&&typeof a==="string"){s=u(a,m);d=s.length;break}for(c=0;c<i;++c,++d){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f<=127)s[d]=f;else throw new Error("bad ascii "+f)}break;case"utf16le":if(h&&typeof a==="string"){s=u(a,m);d=s.length;break}for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);s[d++]=f&255;s[d++]=f>>8}break;case"utf16be":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);s[d++]=f>>8;s[d++]=f&255}break;case"utf32le":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f>=55296&&f<=57343)f=65536+(f-55296<<10)+(a[++c].charCodeAt(0)-56320);s[d++]=f&255;f>>=8;s[d++]=f&255;f>>=8;s[d++]=f&255;f>>=8;s[d++]=f&255}break;case"utf32be":for(c=0;c<i;++c){f=b?a.charCodeAt(c):a[c].charCodeAt(0);if(f>=55296&&f<=57343)f=65536+(f-55296<<10)+(a[++c].charCodeAt(0)-56320);s[d+3]=f&255;f>>=8;s[d+2]=f&255;f>>=8;s[d+1]=f&255;f>>=8;s[d]=f&255;d+=4}break;case"utf7":for(c=0;c<i;c++){var w=b?a.charAt(c):a[c].charAt(0);if(w==="+"){s[d++]=43;s[d++]=45;continue}if(y.indexOf(w)>-1){s[d++]=w.charCodeAt(0);continue}var C=j(1201,w);s[d++]=43;s[d++]=T.charCodeAt(C[0]>>2);s[d++]=T.charCodeAt(((C[0]&3)<<4)+((C[1]||0)>>4));s[d++]=T.charCodeAt(((C[1]&15)<<2)+((C[2]||0)>>6));s[d++]=45}break;default:throw new Error("Unsupported magic: "+t+" "+r[t]);}else throw new Error("Unrecognized CP: "+t);s=s.slice(0,d);if(!h)return n=="str"?s.map(l).join(""):s;if(!n||n==="buf")return s;if(n!=="arr")return s.toString("binary");return[].slice.call(s)};var D=function K(t,a){var n;if(n=f[t])return n(a);if(typeof a==="string")return K(t,a.split("").map(c));var i=a.length,s=new Array(i),o="",l=0,u=0,d=1,p=0,v=0;var g=e[t],m,b="";if(g&&(m=g.dec)){for(u=0;u<i;u+=d){d=2;o=m[(a[u]<<8)+a[u+1]];if(!o){d=1;o=m[a[u]]}if(!o)throw new Error("Unrecognized code: "+a[u]+" "+a[u+d-1]+" "+u+" "+d+" "+m[a[u]]);s[p++]=o}}else if(b=r[t])switch(b){case"utf8":if(i>=3&&a[0]==239)if(a[1]==187&&a[2]==191)u=3;for(;u<i;u+=d){d=1;if(a[u]<128)l=a[u];else if(a[u]<224){l=(a[u]&31)*64+(a[u+1]&63);d=2}else if(a[u]<240){l=((a[u]&15)<<12)+(a[u+1]&63)*64+(a[u+2]&63);d=3}else{l=(a[u]&7)*262144+((a[u+1]&63)<<12)+(a[u+2]&63)*64+(a[u+3]&63);d=4}if(l<65536){s[p++]=String.fromCharCode(l)}else{l-=65536;v=55296+(l>>10&1023);l=56320+(l&1023);s[p++]=String.fromCharCode(v);s[p++]=String.fromCharCode(l)}}break;case"ascii":if(h&&Buffer.isBuffer(a))return a.toString(b);for(u=0;u<i;u++)s[u]=String.fromCharCode(a[u]);p=i;break;case"utf16le":if(i>=2&&a[0]==255)if(a[1]==254)u=2;if(h&&Buffer.isBuffer(a))return a.toString(b);d=2;for(;u+1<i;u+=d){s[p++]=String.fromCharCode((a[u+1]<<8)+a[u])}break;case"utf16be":if(i>=2&&a[0]==254)if(a[1]==255)u=2;d=2;for(;u+1<i;u+=d){s[p++]=String.fromCharCode((a[u]<<8)+a[u+1])}break;case"utf32le":if(i>=4&&a[0]==255)if(a[1]==254&&a[2]===0&&a[3]===0)u=4;d=4;for(;u<i;u+=d){l=(a[u+3]<<24)+(a[u+2]<<16)+(a[u+1]<<8)+a[u];if(l>65535){l-=65536;s[p++]=String.fromCharCode(55296+(l>>10&1023));s[p++]=String.fromCharCode(56320+(l&1023))}else s[p++]=String.fromCharCode(l)}break;case"utf32be":if(i>=4&&a[3]==255)if(a[2]==254&&a[1]===0&&a[0]===0)u=4;d=4;for(;u<i;u+=d){l=(a[u]<<24)+(a[u+1]<<16)+(a[u+2]<<8)+a[u+3];if(l>65535){l-=65536;s[p++]=String.fromCharCode(55296+(l>>10&1023));s[p++]=String.fromCharCode(56320+(l&1023))}else s[p++]=String.fromCharCode(l)}break;case"utf7":if(i>=4&&a[0]==43&&a[1]==47&&a[2]==118){if(i>=5&&a[3]==56&&a[4]==45)u=5;else if(a[3]==56||a[3]==57||a[3]==43||a[3]==47)u=4}for(;u<i;u+=d){if(a[u]!==43){d=1;s[p++]=String.fromCharCode(a[u]);continue}d=1;if(a[u+1]===45){d=2;s[p++]="+";continue}while(String.fromCharCode(a[u+d]).match(/[A-Za-z0-9+\/]/))d++;var w=0;if(a[u+d]===45){++d;w=1}var C=[];var E="";var k=0,S=0,A=0;var _=0,B=0,y=0,x=0;for(var I=1;I<d-w;){_=T.indexOf(String.fromCharCode(a[u+I++]));B=T.indexOf(String.fromCharCode(a[u+I++]));k=_<<2|B>>4;C.push(k);y=T.indexOf(String.fromCharCode(a[u+I++]));if(y===-1)break;S=(B&15)<<4|y>>2;C.push(S);x=T.indexOf(String.fromCharCode(a[u+I++]));if(x===-1)break;A=(y&3)<<6|x;if(x<64)C.push(A)}E=K(1201,C);for(I=0;I<E.length;++I)s[p++]=E.charAt(I)}break;default:throw new Error("Unsupported magic: "+t+" "+r[t]);}else throw new Error("Unrecognized CP: "+t);return s.slice(0,p).join("")};var F=function Y(t){return!!(e[t]||r[t])};e.utils={decode:D,encode:R,hascp:F,magic:r,cache:B};return e});var XLSX={};function make_xlsx_lib(e){e.version="0.14.3";var r=1200,t=1252;if(typeof module!=="undefined"&&typeof require!=="undefined"){if(typeof cptable==="undefined"){if(typeof global!=="undefined")global.cptable=undefined;else if(typeof window!=="undefined")window.cptable=undefined}}var a=[874,932,936,949,950];for(var n=0;n<=8;++n)a.push(1250+n);var i={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var s=function(e){if(a.indexOf(e)==-1)return;t=i[0]=e};function f(){s(1252)}var o=function(e){r=e;s(e)};function l(){o(1200);f()}function c(e){var r=[];for(var t=0,a=e.length;t<a;++t)r[t]=e.charCodeAt(t);return r}function h(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t)+(e.charCodeAt(2*t+1)<<8));return r.join("")}function u(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t+1)+(e.charCodeAt(2*t)<<8));return r.join("")}var d=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1);if(r==255&&t==254)return h(e.slice(2));if(r==254&&t==255)return u(e.slice(2));if(r==65279)return e.slice(1);return e};var p=function Hg(e){return String.fromCharCode(e)};if(typeof cptable!=="undefined"){o=function(e){r=e};d=function(e){if(e.charCodeAt(0)===255&&e.charCodeAt(1)===254){return cptable.utils.decode(1200,c(e.slice(2)))}return e};p=function Wg(e){if(r===1200)return String.fromCharCode(e);return cptable.utils.decode(r,[e&255,e>>8])[0]}}var v=null;var g=true;var m=function Vg(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(r){var t="";var a=0,n=0,i=0,s=0,f=0,o=0,l=0;for(var c=0;c<r.length;){a=r.charCodeAt(c++);s=a>>2;n=r.charCodeAt(c++);f=(a&3)<<4|n>>4;i=r.charCodeAt(c++);o=(n&15)<<2|i>>6;l=i&63;if(isNaN(n)){o=l=64}else if(isNaN(i)){l=64}t+=e.charAt(s)+e.charAt(f)+e.charAt(o)+e.charAt(l)}return t},decode:function r(t){var a="";var n=0,i=0,s=0,f=0,o=0,l=0,c=0;t=t.replace(/[^\w\+\/\=]/g,"");for(var h=0;h<t.length;){f=e.indexOf(t.charAt(h++));o=e.indexOf(t.charAt(h++));n=f<<2|o>>4;a+=String.fromCharCode(n);l=e.indexOf(t.charAt(h++));i=(o&15)<<4|l>>2;if(l!==64){a+=String.fromCharCode(i)}c=e.indexOf(t.charAt(h++));s=(l&3)<<6|c;if(c!==64){a+=String.fromCharCode(s)}}return a}}}();var b=typeof Buffer!=="undefined"&&typeof process!=="undefined"&&typeof process.versions!=="undefined"&&!!process.versions.node;var w=function(){};if(typeof Buffer!=="undefined"){var C=!Buffer.from;if(!C)try{Buffer.from("foo","utf8")}catch(E){C=true}w=C?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.alloc)Buffer.alloc=function(e){return new Buffer(e)};if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)}}function k(e){return b?Buffer.alloc(e):new Array(e)}function S(e){return b?Buffer.allocUnsafe(e):new Array(e)}var A=function zg(e){if(b)return w(e,"binary");return e.split("").map(function(e){return e.charCodeAt(0)&255})};function _(e){if(typeof ArrayBuffer==="undefined")return A(e);var r=new ArrayBuffer(e.length),t=new Uint8Array(r);for(var a=0;a!=e.length;++a)t[a]=e.charCodeAt(a)&255;return r}function B(e){if(Array.isArray(e))return e.map(xp).join("");var r=[];for(var t=0;t<e.length;++t)r[t]=xp(e[t]);return r.join("")}function T(e){if(typeof Uint8Array==="undefined")throw new Error("Unsupported");return new Uint8Array(e)}function y(e){if(typeof ArrayBuffer=="undefined")throw new Error("Unsupported");if(e instanceof ArrayBuffer)return y(new Uint8Array(e));var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=e[t];return r}var x=function(e){return[].concat.apply([],e)};var I=/\u0000/g,R=/[\u0001-\u0006]/g;var D={};var F=function Xg(e){e.version="0.10.2";function r(e){var r="",t=e.length-1;while(t>=0)r+=e.charAt(t--);return r}function t(e,r){var t="";while(t.length<r)t+=e;return t}function a(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}function n(e,r){var a=""+e;return a.length>=r?a:t(" ",r-a.length)+a}function i(e,r){var a=""+e;return a.length>=r?a:a+t(" ",r-a.length)}function s(e,r){var a=""+Math.round(e);return a.length>=r?a:t("0",r-a.length)+a}function f(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}var o=Math.pow(2,32);function l(e,r){if(e>o||e<-o)return s(e,r);var t=Math.round(e);return f(t,r)}function c(e,r){r=r||0;return e.length>=7+r&&(e.charCodeAt(r)|32)===103&&(e.charCodeAt(r+1)|32)===101&&(e.charCodeAt(r+2)|32)===110&&(e.charCodeAt(r+3)|32)===101&&(e.charCodeAt(r+4)|32)===114&&(e.charCodeAt(r+5)|32)===97&&(e.charCodeAt(r+6)|32)===108}var h=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var u=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function d(e){e[0]="General";e[1]="0";e[2]="0.00";e[3]="#,##0";e[4]="#,##0.00";e[9]="0%";e[10]="0.00%";e[11]="0.00E+00";e[12]="# ?/?";e[13]="# ??/??";e[14]="m/d/yy";e[15]="d-mmm-yy";e[16]="d-mmm";e[17]="mmm-yy";e[18]="h:mm AM/PM";e[19]="h:mm:ss AM/PM";e[20]="h:mm";e[21]="h:mm:ss";e[22]="m/d/yy h:mm";e[37]="#,##0 ;(#,##0)";e[38]="#,##0 ;[Red](#,##0)";e[39]="#,##0.00;(#,##0.00)";e[40]="#,##0.00;[Red](#,##0.00)";e[45]="mm:ss";e[46]="[h]:mm:ss";e[47]="mmss.0";e[48]="##0.0E+0";e[49]="@";e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';e[65535]="General"}var p={};d(p);function v(e,r,t){var a=e<0?-1:1;var n=e*a;var i=0,s=1,f=0;var o=1,l=0,c=0;var h=Math.floor(n);while(l<r){h=Math.floor(n);f=h*s+i;c=h*l+o;if(n-h<5e-8)break;n=1/(n-h);i=s;s=f;o=l;l=c}if(c>r){if(l>r){c=o;f=i}else{c=l;f=s}}if(!t)return[0,a*f,c];var u=Math.floor(a*f/c);return[u,a*f-u*c,c]}function g(e,r,t){if(e>2958465||e<0)return null;var a=e|0,n=Math.floor(86400*(e-a)),i=0;var s=[];var f={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(f.u)<1e-6)f.u=0;if(r&&r.date1904)a+=1462;if(f.u>.9999){f.u=0;if(++n==86400){f.T=n=0;++a;++f.D}}if(a===60){s=t?[1317,10,29]:[1900,2,29];i=3}else if(a===0){s=t?[1317,8,29]:[1900,1,0];i=6}else{if(a>60)--a;var o=new Date(1900,0,1);o.setDate(o.getDate()+a-1);s=[o.getFullYear(),o.getMonth()+1,o.getDate()];i=o.getDay();if(a<60)i=(i+6)%7;if(t)i=A(o,s)}f.y=s[0];f.m=s[1];f.d=s[2];f.S=n%60;n=Math.floor(n/60);f.M=n%60;n=Math.floor(n/60);f.H=n;f.q=i;return f}e.parse_date_code=g;var m=new Date(1899,11,31,0,0,0);var b=m.getTime();var w=new Date(1900,2,1,0,0,0);function C(e,r){var t=e.getTime();if(r)t-=1461*24*60*60*1e3;else if(e>=w)t+=24*60*60*1e3;return(t-(b+(e.getTimezoneOffset()-m.getTimezoneOffset())*6e4))/(24*60*60*1e3)}function E(e){return e.toString(10)}e._general_int=E;var k=function M(){var e=/\.(\d*[1-9])0+$/,r=/\.0*$/,t=/\.(\d*[1-9])0+/,a=/\.0*[Ee]/,n=/(E[+-])(\d)$/;function i(e){var r=e<0?12:11;var t=o(e.toFixed(12));
if(t.length<=r)return t;t=e.toPrecision(10);if(t.length<=r)return t;return e.toExponential(5)}function s(r){var t=r.toFixed(11).replace(e,".$1");if(t.length>(r<0?12:11))t=r.toPrecision(6);return t}function f(e){for(var r=0;r!=e.length;++r)if((e.charCodeAt(r)|32)===101)return e.replace(t,".$1").replace(a,"E").replace("e","E").replace(n,"$10$2");return e}function o(t){return t.indexOf(".")>-1?t.replace(r,"").replace(e,".$1"):t}return function l(e){var r=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),t;if(r>=-4&&r<=-1)t=e.toPrecision(10+r);else if(Math.abs(r)<=9)t=i(e);else if(r===10)t=e.toFixed(10).substr(0,12);else t=s(e);return o(f(t))}}();e._general_num=k;function S(e,r){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(e|0)===e?E(e):k(e);case"undefined":return"";case"object":if(e==null)return"";if(e instanceof Date)return N(14,C(e,r&&r.date1904),r);}throw new Error("unsupported value in General format: "+e)}e._general=S;function A(){return 0}function _(e,r,t,n){var i="",s=0,f=0,o=t.y,l,c=0;switch(e){case 98:o=t.y+543;case 121:switch(r.length){case 1:;case 2:l=o%100;c=2;break;default:l=o%1e4;c=4;break;}break;case 109:switch(r.length){case 1:;case 2:l=t.m;c=r.length;break;case 3:return u[t.m-1][1];case 5:return u[t.m-1][0];default:return u[t.m-1][2];}break;case 100:switch(r.length){case 1:;case 2:l=t.d;c=r.length;break;case 3:return h[t.q][0];default:return h[t.q][1];}break;case 104:switch(r.length){case 1:;case 2:l=1+(t.H+11)%12;c=r.length;break;default:throw"bad hour format: "+r;}break;case 72:switch(r.length){case 1:;case 2:l=t.H;c=r.length;break;default:throw"bad hour format: "+r;}break;case 77:switch(r.length){case 1:;case 2:l=t.M;c=r.length;break;default:throw"bad minute format: "+r;}break;case 115:if(r!="s"&&r!="ss"&&r!=".0"&&r!=".00"&&r!=".000")throw"bad second format: "+r;if(t.u===0&&(r=="s"||r=="ss"))return a(t.S,r.length);if(n>=2)f=n===3?1e3:100;else f=n===1?10:1;s=Math.round(f*(t.S+t.u));if(s>=60*f)s=0;if(r==="s")return s===0?"0":""+s/f;i=a(s,2+n);if(r==="ss")return i.substr(0,2);return"."+i.substr(2,r.length-1);case 90:switch(r){case"[h]":;case"[hh]":l=t.D*24+t.H;break;case"[m]":;case"[mm]":l=(t.D*24+t.H)*60+t.M;break;case"[s]":;case"[ss]":l=((t.D*24+t.H)*60+t.M)*60+Math.round(t.S+t.u);break;default:throw"bad abstime format: "+r;}c=r.length===3?1:2;break;case 101:l=o;c=1;}if(c>0)return a(l,c);else return""}function B(e){var r=3;if(e.length<=r)return e;var t=e.length%r,a=e.substr(0,t);for(;t!=e.length;t+=r)a+=(a.length>0?",":"")+e.substr(t,r);return a}var T=function U(){var e=/%/g;function s(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return T(r,i,n*Math.pow(10,2*s))+t("%",s)}function f(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return T(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function o(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+o(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(t.indexOf("e")===-1){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);while(t.substr(0,2)==="0."){t=t.charAt(0)+t.substr(2,n)+"."+t.substr(2+n);t=t.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.")}t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}var c=/# (\?+)( ?)\/( ?)(\d+)/;function h(e,r,i){var s=parseInt(e[4],10),f=Math.round(r*s),o=Math.floor(f/s);var l=f-o*s,c=s;return i+(o===0?"":""+o)+" "+(l===0?t(" ",e[1].length+1+e[4].length):n(l,e[1].length)+e[2]+"/"+e[3]+a(c,e[4].length))}function u(e,r,a){return a+(r===0?"":""+r)+t(" ",e[1].length+2+e[4].length)}var d=/^#*0*\.([0#]+)/;var p=/\).*[0#]/;var g=/\(###\) ###\\?-####/;function m(e){var r="",t;for(var a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t);}return r}function b(e,r){var t=Math.pow(10,r);return""+Math.round(e*t)/t}function w(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 0}return Math.round((e-Math.floor(e))*Math.pow(10,r))}function C(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 1}return 0}function E(e){if(e<2147483647&&e>-2147483648)return""+(e>=0?e|0:e-1|0);return""+Math.floor(e)}function k(e,u,S){if(e.charCodeAt(0)===40&&!u.match(p)){var A=u.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(S>=0)return k("n",A,S);return"("+k("n",A,-S)+")"}if(u.charCodeAt(u.length-1)===44)return f(e,u,S);if(u.indexOf("%")!==-1)return s(e,u,S);if(u.indexOf("E")!==-1)return o(u,S);if(u.charCodeAt(0)===36)return"$"+k(e,u.substr(u.charAt(1)==" "?2:1),S);var _;var y,x,I,R=Math.abs(S),D=S<0?"-":"";if(u.match(/^00+$/))return D+l(R,u.length);if(u.match(/^[#?]+$/)){_=l(S,0);if(_==="0")_="";return _.length>u.length?_:m(u.substr(0,u.length-_.length))+_}if(y=u.match(c))return h(y,R,D);if(u.match(/^#+0+$/))return D+l(R,u.length-u.indexOf("0"));if(y=u.match(d)){_=b(S,y[1].length).replace(/^([^\.]+)$/,"$1."+m(y[1])).replace(/\.$/,"."+m(y[1])).replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",m(y[1]).length-r.length)});return u.indexOf("0.")!==-1?_:_.replace(/^0\./,".")}u=u.replace(/^#+([0.])/,"$1");if(y=u.match(/^(0*)\.(#*)$/)){return D+b(R,y[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,y[1].length?"0.":".")}if(y=u.match(/^#{1,3},##0(\.?)$/))return D+B(l(R,0));if(y=u.match(/^#,##0\.([#0]*0)$/)){return S<0?"-"+k(e,u,-S):B(""+(Math.floor(S)+C(S,y[1].length)))+"."+a(w(S,y[1].length),y[1].length)}if(y=u.match(/^#,#*,#0/))return k(e,u.replace(/^#,#*,/,""),S);if(y=u.match(/^([0#]+)(\\?-([0#]+))+$/)){_=r(k(e,u.replace(/[\\-]/g,""),S));x=0;return r(r(u.replace(/\\/g,"")).replace(/[0#]/g,function(e){return x<_.length?_.charAt(x++):e==="0"?"0":""}))}if(u.match(g)){_=k(e,"##########",S);return"("+_.substr(0,3)+") "+_.substr(3,3)+"-"+_.substr(6)}var F="";if(y=u.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(y[4].length,7);I=v(R,Math.pow(10,x)-1,false);_=""+D;F=T("n",y[1],I[1]);if(F.charAt(F.length-1)==" ")F=F.substr(0,F.length-1)+"0";_+=F+y[2]+"/"+y[3];F=i(I[2],x);if(F.length<y[4].length)F=m(y[4].substr(y[4].length-F.length))+F;_+=F;return _}if(y=u.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(Math.max(y[1].length,y[4].length),7);I=v(R,Math.pow(10,x)-1,true);return D+(I[0]||(I[1]?"":"0"))+" "+(I[1]?n(I[1],x)+y[2]+"/"+y[3]+i(I[2],x):t(" ",2*x+1+y[2].length+y[3].length))}if(y=u.match(/^[#0?]+$/)){_=l(S,0);if(u.length<=_.length)return _;return m(u.substr(0,u.length-_.length))+_}if(y=u.match(/^([#0?]+)\.([#0]+)$/)){_=""+S.toFixed(Math.min(y[2].length,10)).replace(/([^0])0+$/,"$1");x=_.indexOf(".");var O=u.indexOf(".")-x,P=u.length-_.length-O;return m(u.substr(0,O)+_+u.substr(u.length-P))}if(y=u.match(/^00,000\.([#0]*0)$/)){x=w(S,y[1].length);return S<0?"-"+k(e,u,-S):B(E(S)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(x,y[1].length)}switch(u){case"###,##0.00":return k(e,"#,##0.00",S);case"###,###":;case"##,###":;case"#,###":var N=B(l(R,0));return N!=="0"?D+N:"";case"###,###.00":return k(e,"###,##0.00",S).replace(/^0\./,".");case"#,###.00":return k(e,"#,##0.00",S).replace(/^0\./,".");default:;}throw new Error("unsupported format |"+u+"|")}function S(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return T(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function A(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return T(r,i,n*Math.pow(10,2*s))+t("%",s)}function _(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+_(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(!t.match(/[Ee]/)){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}function y(e,s,f){if(e.charCodeAt(0)===40&&!s.match(p)){var o=s.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(f>=0)return y("n",o,f);return"("+y("n",o,-f)+")"}if(s.charCodeAt(s.length-1)===44)return S(e,s,f);if(s.indexOf("%")!==-1)return A(e,s,f);if(s.indexOf("E")!==-1)return _(s,f);if(s.charCodeAt(0)===36)return"$"+y(e,s.substr(s.charAt(1)==" "?2:1),f);var l;var h,b,w,C=Math.abs(f),E=f<0?"-":"";if(s.match(/^00+$/))return E+a(C,s.length);if(s.match(/^[#?]+$/)){l=""+f;if(f===0)l="";return l.length>s.length?l:m(s.substr(0,s.length-l.length))+l}if(h=s.match(c))return u(h,C,E);if(s.match(/^#+0+$/))return E+a(C,s.length-s.indexOf("0"));if(h=s.match(d)){l=(""+f).replace(/^([^\.]+)$/,"$1."+m(h[1])).replace(/\.$/,"."+m(h[1]));l=l.replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",m(h[1]).length-r.length)});return s.indexOf("0.")!==-1?l:l.replace(/^0\./,".")}s=s.replace(/^#+([0.])/,"$1");if(h=s.match(/^(0*)\.(#*)$/)){return E+(""+C).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,h[1].length?"0.":".")}if(h=s.match(/^#{1,3},##0(\.?)$/))return E+B(""+C);if(h=s.match(/^#,##0\.([#0]*0)$/)){return f<0?"-"+y(e,s,-f):B(""+f)+"."+t("0",h[1].length)}if(h=s.match(/^#,#*,#0/))return y(e,s.replace(/^#,#*,/,""),f);if(h=s.match(/^([0#]+)(\\?-([0#]+))+$/)){l=r(y(e,s.replace(/[\\-]/g,""),f));b=0;return r(r(s.replace(/\\/g,"")).replace(/[0#]/g,function(e){return b<l.length?l.charAt(b++):e==="0"?"0":""}))}if(s.match(g)){l=y(e,"##########",f);return"("+l.substr(0,3)+") "+l.substr(3,3)+"-"+l.substr(6)}var k="";if(h=s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){b=Math.min(h[4].length,7);w=v(C,Math.pow(10,b)-1,false);l=""+E;k=T("n",h[1],w[1]);if(k.charAt(k.length-1)==" ")k=k.substr(0,k.length-1)+"0";l+=k+h[2]+"/"+h[3];k=i(w[2],b);if(k.length<h[4].length)k=m(h[4].substr(h[4].length-k.length))+k;l+=k;return l}if(h=s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){b=Math.min(Math.max(h[1].length,h[4].length),7);w=v(C,Math.pow(10,b)-1,true);return E+(w[0]||(w[1]?"":"0"))+" "+(w[1]?n(w[1],b)+h[2]+"/"+h[3]+i(w[2],b):t(" ",2*b+1+h[2].length+h[3].length))}if(h=s.match(/^[#0?]+$/)){l=""+f;if(s.length<=l.length)return l;return m(s.substr(0,s.length-l.length))+l}if(h=s.match(/^([#0]+)\.([#0]+)$/)){l=""+f.toFixed(Math.min(h[2].length,10)).replace(/([^0])0+$/,"$1");b=l.indexOf(".");var x=s.indexOf(".")-b,I=s.length-l.length-x;return m(s.substr(0,x)+l+s.substr(s.length-I))}if(h=s.match(/^00,000\.([#0]*0)$/)){return f<0?"-"+y(e,s,-f):B(""+f).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(0,h[1].length)}switch(s){case"###,###":;case"##,###":;case"#,###":var R=B(""+C);return R!=="0"?E+R:"";default:if(s.match(/\.[0#?]*$/))return y(e,s.slice(0,s.lastIndexOf(".")),f)+m(s.slice(s.lastIndexOf(".")));}throw new Error("unsupported format |"+s+"|")}return function x(e,r,t){return(t|0)===t?y(e,r,t):k(e,r,t)}}();function y(e){var r=[];var t=false;for(var a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:t=!t;break;case 95:;case 42:;case 92:++a;break;case 59:r[r.length]=e.substr(n,a-n);n=a+1;}r[r.length]=e.substr(n);if(t===true)throw new Error("Format |"+e+"| unterminated string ");return r}e._split=y;var x=/\[[HhMmSs]*\]/;function I(e){var r=0,t="",a="";while(r<e.length){switch(t=e.charAt(r)){case"G":if(c(e,r))r+=6;r++;break;case'"':for(;e.charCodeAt(++r)!==34&&r<e.length;)++r;++r;break;case"\\":r+=2;break;case"_":r+=2;break;case"@":++r;break;case"B":;case"b":if(e.charAt(r+1)==="1"||e.charAt(r+1)==="2")return true;case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":;case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":return true;case"A":;case"a":if(e.substr(r,3).toUpperCase()==="A/P")return true;if(e.substr(r,5).toUpperCase()==="AM/PM")return true;++r;break;case"[":a=t;while(e.charAt(r++)!=="]"&&r<e.length)a+=e.charAt(r);if(a.match(x))return true;break;case".":;case"0":;case"#":while(r<e.length&&("0#?.,E+-%".indexOf(t=e.charAt(++r))>-1||t=="\\"&&e.charAt(r+1)=="-"&&"0#".indexOf(e.charAt(r+2))>-1)){}break;case"?":while(e.charAt(++r)===t){}break;case"*":++r;if(e.charAt(r)==" "||e.charAt(r)=="*")++r;break;case"(":;case")":++r;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":while(r<e.length&&"0123456789".indexOf(e.charAt(++r))>-1){}break;case" ":++r;break;default:++r;break;}}return false}e.is_date=I;function R(e,r,t,a){var n=[],i="",s=0,f="",o="t",l,h,u;var d="H";while(s<e.length){switch(f=e.charAt(s)){case"G":if(!c(e,s))throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"G",v:"General"};s+=7;break;case'"':for(i="";(u=e.charCodeAt(++s))!==34&&s<e.length;)i+=String.fromCharCode(u);n[n.length]={t:"t",v:i};++s;break;case"\\":var p=e.charAt(++s),v=p==="("||p===")"?p:"t";n[n.length]={t:v,v:p};++s;break;case"_":n[n.length]={t:"t",v:" "};s+=2;break;case"@":n[n.length]={t:"T",v:r};++s;break;case"B":;case"b":if(e.charAt(s+1)==="1"||e.charAt(s+1)==="2"){if(l==null){l=g(r,t,e.charAt(s+1)==="2");if(l==null)return""}n[n.length]={t:"X",v:e.substr(s,2)};o=f;s+=2;break};case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":f=f.toLowerCase();case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":if(r<0)return"";if(l==null){l=g(r,t);if(l==null)return""}i=f;while(++s<e.length&&e.charAt(s).toLowerCase()===f)i+=f;if(f==="m"&&o.toLowerCase()==="h")f="M";if(f==="h")f=d;n[n.length]={t:f,v:i};o=f;break;case"A":;case"a":var m={t:f,v:f};if(l==null)l=g(r,t);if(e.substr(s,3).toUpperCase()==="A/P"){if(l!=null)m.v=l.H>=12?"P":"A";m.t="T";d="h";s+=3}else if(e.substr(s,5).toUpperCase()==="AM/PM"){if(l!=null)m.v=l.H>=12?"PM":"AM";m.t="T";s+=5;d="h"}else{m.t="t";++s}if(l==null&&m.t==="T")return"";n[n.length]=m;o=f;break;case"[":i=f;while(e.charAt(s++)!=="]"&&s<e.length)i+=e.charAt(s);if(i.slice(-1)!=="]")throw'unterminated "[" block: |'+i+"|";if(i.match(x)){if(l==null){l=g(r,t);if(l==null)return""}n[n.length]={t:"Z",v:i.toLowerCase()};o=i.charAt(1)}else if(i.indexOf("$")>-1){i=(i.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!I(e))n[n.length]={t:"t",v:i}}break;case".":if(l!=null){i=f;while(++s<e.length&&(f=e.charAt(s))==="0")i+=f;n[n.length]={t:"s",v:i};break};case"0":;case"#":i=f;while(++s<e.length&&"0#?.,E+-%".indexOf(f=e.charAt(s))>-1||f=="\\"&&e.charAt(s+1)=="-"&&s<e.length-2&&"0#".indexOf(e.charAt(s+2))>-1)i+=f;n[n.length]={t:"n",v:i};break;case"?":i=f;while(e.charAt(++s)===f)i+=f;n[n.length]={t:f,v:i};o=f;break;case"*":++s;if(e.charAt(s)==" "||e.charAt(s)=="*")++s;break;case"(":;case")":n[n.length]={t:a===1?"t":f,v:f};++s;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":i=f;while(s<e.length&&"0123456789".indexOf(e.charAt(++s))>-1)i+=e.charAt(s);n[n.length]={t:"D",v:i};break;case" ":n[n.length]={t:f,v:f};++s;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f)===-1)throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"t",v:f};++s;break;}}var b=0,w=0,C;for(s=n.length-1,o="t";s>=0;--s){switch(n[s].t){case"h":;case"H":n[s].t=d;o="h";if(b<1)b=1;break;case"s":if(C=n[s].v.match(/\.0+$/))w=Math.max(w,C[0].length-1);if(b<3)b=3;case"d":;case"y":;case"M":;case"e":o=n[s].t;break;case"m":if(o==="s"){n[s].t="M";if(b<2)b=2}break;case"X":break;case"Z":if(b<1&&n[s].v.match(/[Hh]/))b=1;if(b<2&&n[s].v.match(/[Mm]/))b=2;if(b<3&&n[s].v.match(/[Ss]/))b=3;}}switch(b){case 0:break;case 1:if(l.u>=.5){l.u=0;++l.S}if(l.S>=60){l.S=0;++l.M}if(l.M>=60){l.M=0;++l.H}break;case 2:if(l.u>=.5){l.u=0;++l.S}if(l.S>=60){l.S=0;++l.M}break;}var E="",k;for(s=0;s<n.length;++s){switch(n[s].t){case"t":;case"T":;case" ":;case"D":break;case"X":n[s].v="";n[s].t=";";break;case"d":;case"m":;case"y":;case"h":;case"H":;case"M":;case"s":;case"e":;case"b":;case"Z":n[s].v=_(n[s].t.charCodeAt(0),n[s].v,l,w);n[s].t="t";break;case"n":;case"(":;case"?":k=s+1;while(n[k]!=null&&((f=n[k].t)==="?"||f==="D"||(f===" "||f==="t")&&n[k+1]!=null&&(n[k+1].t==="?"||n[k+1].t==="t"&&n[k+1].v==="/")||n[s].t==="("&&(f===" "||f==="n"||f===")")||f==="t"&&(n[k].v==="/"||n[k].v===" "&&n[k+1]!=null&&n[k+1].t=="?"))){n[s].v+=n[k].v;n[k]={v:"",t:";"};++k}E+=n[s].v;s=k-1;break;case"G":n[s].t="t";n[s].v=S(r,t);break;}}var A="",B,y;if(E.length>0){if(E.charCodeAt(0)==40){B=r<0&&E.charCodeAt(0)===45?-r:r;y=T("(",E,B)}else{B=r<0&&a>1?-r:r;y=T("n",E,B);if(B<0&&n[0]&&n[0].t=="t"){y=y.substr(1);n[0].v="-"+n[0].v}}k=y.length-1;var R=n.length;for(s=0;s<n.length;++s)if(n[s]!=null&&n[s].t!="t"&&n[s].v.indexOf(".")>-1){R=s;break}var D=n.length;if(R===n.length&&y.indexOf("E")===-1){for(s=n.length-1;s>=0;--s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1)continue;if(k>=n[s].v.length-1){k-=n[s].v.length;n[s].v=y.substr(k+1,n[s].v.length)}else if(k<0)n[s].v="";else{n[s].v=y.substr(0,k+1);k=-1}n[s].t="t";D=s}if(k>=0&&D<n.length)n[D].v=y.substr(0,k+1)+n[D].v}else if(R!==n.length&&y.indexOf("E")===-1){k=y.indexOf(".")-1;for(s=R;s>=0;--s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1)continue;h=n[s].v.indexOf(".")>-1&&s===R?n[s].v.indexOf(".")-1:n[s].v.length-1;A=n[s].v.substr(h+1);for(;h>=0;--h){if(k>=0&&(n[s].v.charAt(h)==="0"||n[s].v.charAt(h)==="#"))A=y.charAt(k--)+A}n[s].v=A;n[s].t="t";D=s}if(k>=0&&D<n.length)n[D].v=y.substr(0,k+1)+n[D].v;k=y.indexOf(".")+1;for(s=R;s<n.length;++s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1&&s!==R)continue;h=n[s].v.indexOf(".")>-1&&s===R?n[s].v.indexOf(".")+1:0;A=n[s].v.substr(0,h);for(;h<n[s].v.length;++h){if(k<y.length)A+=y.charAt(k++)}n[s].v=A;n[s].t="t";D=s}}}for(s=0;s<n.length;++s)if(n[s]!=null&&"n(?".indexOf(n[s].t)>-1){B=a>1&&r<0&&s>0&&n[s-1].v==="-"?-r:r;n[s].v=T(n[s].t,n[s].v,B);n[s].t="t"}var F="";for(s=0;s!==n.length;++s)if(n[s]!=null)F+=n[s].v;return F}e._eval=R;var D=/\[[=<>]/;var F=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function O(e,r){if(r==null)return false;var t=parseFloat(r[2]);switch(r[1]){case"=":if(e==t)return true;break;case">":if(e>t)return true;break;case"<":if(e<t)return true;break;case"<>":if(e!=t)return true;break;case">=":if(e>=t)return true;break;case"<=":if(e<=t)return true;break;}return false}function P(e,r){var t=y(e);var a=t.length,n=t[a-1].indexOf("@");if(a<4&&n>-1)--a;if(t.length>4)throw new Error("cannot find right format for |"+t.join("|")+"|");if(typeof r!=="number")return[4,t.length===4||n>-1?t[t.length-1]:"@"];switch(t.length){case 1:t=n>-1?["General","General","General",t[0]]:[t[0],t[0],t[0],"@"];break;case 2:t=n>-1?[t[0],t[0],t[0],t[1]]:[t[0],t[1],t[0],"@"];break;case 3:t=n>-1?[t[0],t[1],t[0],t[2]]:[t[0],t[1],t[2],"@"];break;case 4:break;}var i=r>0?t[0]:r<0?t[1]:t[2];if(t[0].indexOf("[")===-1&&t[1].indexOf("[")===-1)return[a,i];if(t[0].match(D)!=null||t[1].match(D)!=null){var s=t[0].match(F);var f=t[1].match(F);return O(r,s)?[a,t[0]]:O(r,f)?[a,t[1]]:[a,t[s!=null&&f!=null?2:1]]}return[a,i]}function N(e,r,t){if(t==null)t={};var a="";switch(typeof e){case"string":if(e=="m/d/yy"&&t.dateNF)a=t.dateNF;else a=e;break;case"number":if(e==14&&t.dateNF)a=t.dateNF;else a=(t.table!=null?t.table:p)[e];break;}if(c(a,0))return S(r,t);if(r instanceof Date)r=C(r,t.date1904);var n=P(a,r);if(c(n[1]))return S(r,t);if(r===true)r="TRUE";else if(r===false)r="FALSE";else if(r===""||r==null)return"";return R(n[1],r,t,n[0])}function L(e,r){if(typeof r!="number"){r=+r||-1;for(var t=0;t<392;++t){if(p[t]==undefined){if(r<0)r=t;continue}if(p[t]==e){r=t;break}}if(r<0)r=391}p[r]=e;return r}e.load=L;e._table=p;e.get_table=function H(){return p};e.load_table=function W(e){for(var r=0;r!=392;++r)if(e[r]!==undefined)L(e[r],r)};e.init_table=d;e.format=N};F(D);var O={"General Number":"General","General Date":D._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":D._table[15],"Short Date":D._table[14],"Long Time":D._table[19],"Medium Time":D._table[18],"Short Time":D._table[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:D._table[2],Standard:D._table[4],Percent:D._table[10],Scientific:D._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var P={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"};var N=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function L(e){var r=typeof e=="number"?D._table[e]:e;r=r.replace(N,"(\\d+)");return new RegExp("^"+r+"$")}function M(e,r,t){var a=-1,n=-1,i=-1,s=-1,f=-1,o=-1;(r.match(N)||[]).forEach(function(e,r){var l=parseInt(t[r+1],10);switch(e.toLowerCase().charAt(0)){case"y":a=l;break;case"d":i=l;break;case"h":s=l;break;case"s":o=l;break;case"m":if(s>=0)f=l;else n=l;break;}});if(o>=0&&f==-1&&n>=0){f=n;n=-1}var l=(""+(a>=0?a:(new Date).getFullYear())).slice(-4)+"-"+("00"+(n>=1?n:1)).slice(-2)+"-"+("00"+(i>=1?i:1)).slice(-2);if(l.length==7)l="0"+l;if(l.length==8)l="20"+l;var c=("00"+(s>=0?s:0)).slice(-2)+":"+("00"+(f>=0?f:0)).slice(-2)+":"+("00"+(o>=0?o:0)).slice(-2);if(s==-1&&f==-1&&o==-1)return l;if(a==-1&&n==-1&&i==-1)return c;return l+"T"+c}var U=true;var H;(function(e){e(H={})})(function(e){e.version="1.2.0";function r(){var e=0,r=new Array(256);for(var t=0;t!=256;++t){e=t;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;r[t]=e}return typeof Int32Array!=="undefined"?new Int32Array(r):r}var t=r();function a(e,r){var a=r^-1,n=e.length-1;for(var i=0;i<n;){a=a>>>8^t[(a^e.charCodeAt(i++))&255];a=a>>>8^t[(a^e.charCodeAt(i++))&255]}if(i===n)a=a>>>8^t[(a^e.charCodeAt(i))&255];return a^-1}function n(e,r){if(e.length>1e4)return i(e,r);var a=r^-1,n=e.length-3;for(var s=0;s<n;){a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255]}while(s<n+3)a=a>>>8^t[(a^e[s++])&255];return a^-1}function i(e,r){var a=r^-1,n=e.length-7;for(var i=0;i<n;){a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255]}while(i<n+7)a=a>>>8^t[(a^e[i++])&255];return a^-1}function s(e,r){var a=r^-1;for(var n=0,i=e.length,s,f;n<i;){s=e.charCodeAt(n++);if(s<128){a=a>>>8^t[(a^s)&255]}else if(s<2048){a=a>>>8^t[(a^(192|s>>6&31))&255];a=a>>>8^t[(a^(128|s&63))&255]}else if(s>=55296&&s<57344){s=(s&1023)+64;f=e.charCodeAt(n++)&1023;a=a>>>8^t[(a^(240|s>>8&7))&255];a=a>>>8^t[(a^(128|s>>2&63))&255];a=a>>>8^t[(a^(128|f>>6&15|(s&3)<<4))&255];a=a>>>8^t[(a^(128|f&63))&255]}else{a=a>>>8^t[(a^(224|s>>12&15))&255];a=a>>>8^t[(a^(128|s>>6&63))&255];a=a>>>8^t[(a^(128|s&63))&255]}}return a^-1}e.table=t;e.bstr=a;e.buf=n;e.str=s});var W=function Gg(){var e={};e.version="1.1.0";function r(e,r){var t=e.split("/"),a=r.split("/");for(var n=0,i=0,s=Math.min(t.length,a.length);n<s;++n){if(i=t[n].length-a[n].length)return i;if(t[n]!=a[n])return t[n]<a[n]?-1:1}return t.length-a.length}function t(e){if(e.charAt(e.length-1)=="/")return e.slice(0,-1).indexOf("/")===-1?e:t(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(0,r+1)}function a(e){if(e.charAt(e.length-1)=="/")return a(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(r+1)}function n(e,r){if(typeof r==="string")r=new Date(r);var t=r.getHours();t=t<<6|r.getMinutes();t=t<<5|r.getSeconds()>>>1;e._W(2,t);var a=r.getFullYear()-1980;a=a<<4|r.getMonth()+1;a=a<<5|r.getDate();e._W(2,a)}function i(e){var r=e._R(2)&65535;var t=e._R(2)&65535;var a=new Date;var n=t&31;t>>>=5;var i=t&15;t>>>=4;a.setMilliseconds(0);a.setFullYear(t+1980);a.setMonth(i-1);a.setDate(n);var s=r&31;r>>>=5;var f=r&63;r>>>=6;a.setHours(r);a.setMinutes(f);a.setSeconds(s<<1);return a}function s(e){zr(e,0);var r={};var t=0;while(e.l<=e.length-4){var a=e._R(2);var n=e._R(2),i=e.l+n;var s={};switch(a){case 21589:{t=e._R(1);if(t&1)s.mtime=e._R(4);if(n>5){if(t&2)s.atime=e._R(4);if(t&4)s.ctime=e._R(4)}if(s.mtime)s.mt=new Date(s.mtime*1e3)}break;}e.l=i;r[a]=s}return r}var f;function o(){return f||(f=require("fs"))}function l(e,r){if(e[0]==80&&e[1]==75)return Be(e,r);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var t=3;var a=512;var n=0;var i=0;var s=0;var f=0;var o=0;var l=[];var p=e.slice(0,512);zr(p,0);var g=c(p);t=g[0];switch(t){case 3:a=512;break;case 4:a=4096;break;case 0:if(g[1]==0)return Be(e,r);default:throw new Error("Major Version: Expected 3 or 4 saw "+t);}if(a!==512){p=e.slice(0,a);zr(p,28)}var m=e.slice(0,a);h(p,t);var b=p._R(4,"i");if(t===3&&b!==0)throw new Error("# Directory Sectors: Expected 0 saw "+b);p.l+=4;s=p._R(4,"i");p.l+=4;p.chk("00100000","Mini Stream Cutoff Size: ");f=p._R(4,"i");n=p._R(4,"i");o=p._R(4,"i");i=p._R(4,"i");for(var E=-1,k=0;k<109;++k){E=p._R(4,"i");if(E<0)break;l[k]=E}var S=u(e,a);v(o,i,S,a,l);var A=w(S,s,l,a);A[s].name="!Directory";if(n>0&&f!==N)A[f].name="!MiniFAT";A[l[0]].name="!FAT";A.fat_addrs=l;A.ssz=a;var _={},B=[],T=[],y=[];C(s,A,S,B,n,_,T,f);d(T,y,B);B.shift();var x={FileIndex:T,FullPaths:y};if(r&&r.raw)x.raw={header:m,sectors:S};return x}function c(e){if(e[e.l]==80&&e[e.l+1]==75)return[0,0];e.chk(L,"Header Signature: ");e.chk(U,"CLSID: ");var r=e._R(2,"u");return[e._R(2,"u"),r]}function h(e,r){var t=9;e.l+=2;switch(t=e._R(2)){case 9:if(r!=3)throw new Error("Sector Shift: Expected 9 saw "+t);break;case 12:if(r!=4)throw new Error("Sector Shift: Expected 12 saw "+t);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+t);}e.chk("0600","Mini Sector Shift: ");e.chk("000000000000","Reserved: ")}function u(e,r){var t=Math.ceil(e.length/r)-1;var a=[];for(var n=1;n<t;++n)a[n-1]=e.slice(n*r,(n+1)*r);a[t-1]=e.slice(t*r);return a}function d(e,r,t){var a=0,n=0,i=0,s=0,f=0,o=t.length;var l=[],c=[];for(;a<o;++a){l[a]=c[a]=a;r[a]=t[a]}for(;f<c.length;++f){a=c[f];n=e[a].L;i=e[a].R;s=e[a].C;if(l[a]===a){if(n!==-1&&l[n]!==n)l[a]=l[n];if(i!==-1&&l[i]!==i)l[a]=l[i]}if(s!==-1)l[s]=a;if(n!==-1){l[n]=l[a];if(c.lastIndexOf(n)<f)c.push(n)}if(i!==-1){l[i]=l[a];if(c.lastIndexOf(i)<f)c.push(i)}}for(a=1;a<o;++a)if(l[a]===a){if(i!==-1&&l[i]!==i)l[a]=l[i];else if(n!==-1&&l[n]!==n)l[a]=l[n]}for(a=1;a<o;++a){if(e[a].type===0)continue;f=l[a];if(f===0)r[a]=r[0]+"/"+r[a];else while(f!==0&&f!==l[f]){r[a]=r[f]+"/"+r[a];f=l[f]}l[a]=0}r[0]+="/";for(a=1;a<o;++a){if(e[a].type!==2)r[a]+="/"}}function p(e,r,t){var a=e.start,n=e.size;var i=[];var s=a;while(t&&n>0&&s>=0){i.push(r.slice(s*P,s*P+P));n-=P;s=Pr(t,s*4)}if(i.length===0)return Gr(0);return x(i).slice(0,e.size)}function v(e,r,t,a,n){var i=N;if(e===N){if(r!==0)throw new Error("DIFAT chain shorter than expected")}else if(e!==-1){var s=t[e],f=(a>>>2)-1;if(!s)return;for(var o=0;o<f;++o){if((i=Pr(s,o*4))===N)break;n.push(i)}v(Pr(s,a-4),r-1,t,a,n)}}function g(e,r,t,a,n){var i=[],s=[];if(!n)n=[];var f=a-1,o=0,l=0;for(o=r;o>=0;){n[o]=true;i[i.length]=o;s.push(e[o]);var c=t[Math.floor(o*4/a)];l=o*4&f;if(a<4+l)throw new Error("FAT boundary crossed: "+o+" 4 "+a);if(!e[c])break;o=Pr(e[c],l)}return{nodes:i,data:cr([s])}}function w(e,r,t,a){var n=e.length,i=[];var s=[],f=[],o=[];var l=a-1,c=0,h=0,u=0,d=0;for(c=0;c<n;++c){f=[];u=c+r;if(u>=n)u-=n;if(s[u])continue;o=[];for(h=u;h>=0;){s[h]=true;f[f.length]=h;o.push(e[h]);var p=t[Math.floor(h*4/a)];d=h*4&l;if(a<4+d)throw new Error("FAT boundary crossed: "+h+" 4 "+a);if(!e[p])break;h=Pr(e[p],d)}i[u]={nodes:f,data:cr([o])}}return i}function C(e,r,t,a,n,i,s,f){var o=0,l=a.length?2:0;var c=r[e].data;var h=0,u=0,d;for(;h<c.length;h+=128){var v=c.slice(h,h+128);zr(v,64);u=v._R(2);d=ur(v,0,u-l);a.push(d);var m={name:d,type:v._R(1),color:v._R(1),L:v._R(4,"i"),R:v._R(4,"i"),C:v._R(4,"i"),clsid:v._R(16),state:v._R(4,"i"),start:0,size:0};var b=v._R(2)+v._R(2)+v._R(2)+v._R(2);if(b!==0)m.ct=E(v,v.l-8);var w=v._R(2)+v._R(2)+v._R(2)+v._R(2);if(w!==0)m.mt=E(v,v.l-8);m.start=v._R(4,"i");m.size=v._R(4,"i");if(m.size<0&&m.start<0){m.size=m.type=0;m.start=N;m.name=""}if(m.type===5){o=m.start;if(n>0&&o!==N)r[o].name="!StreamData"}else if(m.size>=4096){m.storage="fat";if(r[m.start]===undefined)r[m.start]=g(t,m.start,r.fat_addrs,r.ssz);r[m.start].name=m.name;m.content=r[m.start].data.slice(0,m.size)}else{m.storage="minifat";if(m.size<0)m.size=0;else if(o!==N&&m.start!==N&&r[o]){m.content=p(m,r[o].data,(r[f]||{}).data)}}if(m.content)zr(m.content,0);i[d]=m;s.push(m)}}function E(e,r){return new Date((Or(e,r+4)/1e7*Math.pow(2,32)+Or(e,r)/1e7-11644473600)*1e3)}function _(e,r){o();return l(f.readFileSync(e),r)}function B(e,r){switch(r&&r.type||"base64"){case"file":return _(e,r);case"base64":return l(A(m.decode(e)),r);case"binary":return l(A(e),r);}return l(e,r)}function T(e,r){var t=r||{},a=t.root||"Root Entry";if(!e.FullPaths)e.FullPaths=[];if(!e.FileIndex)e.FileIndex=[];if(e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");if(e.FullPaths.length===0){e.FullPaths[0]=a+"/";e.FileIndex[0]={name:a,type:5}}if(t.CLSID)e.FileIndex[0].clsid=t.CLSID;y(e)}function y(e){var r="Sh33tJ5";if(W.find(e,"/"+r))return;var t=Gr(4);t[0]=55;t[1]=t[3]=50;t[2]=54;e.FileIndex.push({name:r,type:2,content:t,size:4,L:69,R:69,C:69});e.FullPaths.push(e.FullPaths[0]+r);D(e)}function D(e,n){T(e);var i=false,s=false;for(var f=e.FullPaths.length-1;f>=0;--f){var o=e.FileIndex[f];switch(o.type){case 0:if(s)i=true;else{e.FileIndex.pop();e.FullPaths.pop()}break;case 1:;case 2:;case 5:s=true;if(isNaN(o.R*o.L*o.C))i=true;if(o.R>-1&&o.L>-1&&o.R==o.L)i=true;break;default:i=true;break;}}if(!i&&!n)return;var l=new Date(1987,1,19),c=0;var h=[];for(f=0;f<e.FullPaths.length;++f){if(e.FileIndex[f].type===0)continue;h.push([e.FullPaths[f],e.FileIndex[f]])}for(f=0;f<h.length;++f){var u=t(h[f][0]);s=false;for(c=0;c<h.length;++c)if(h[c][0]===u)s=true;if(!s)h.push([u,{name:a(u).replace("/",""),type:1,clsid:U,ct:l,mt:l,content:null}])}h.sort(function(e,t){return r(e[0],t[0])});e.FullPaths=[];e.FileIndex=[];for(f=0;f<h.length;++f){e.FullPaths[f]=h[f][0];e.FileIndex[f]=h[f][1]}for(f=0;f<h.length;++f){var d=e.FileIndex[f];var p=e.FullPaths[f];d.name=a(p).replace("/","");d.L=d.R=d.C=-(d.color=1);d.size=d.content?d.content.length:0;d.start=0;d.clsid=d.clsid||U;if(f===0){d.C=h.length>1?1:-1;d.size=0;d.type=5}else if(p.slice(-1)=="/"){for(c=f+1;c<h.length;++c)if(t(e.FullPaths[c])==p)break;d.C=c>=h.length?-1:c;for(c=f+1;c<h.length;++c)if(t(e.FullPaths[c])==t(p))break;
d.R=c>=h.length?-1:c;d.type=1}else{if(t(e.FullPaths[f+1]||"")==t(p))d.R=f+1;d.type=2}}}function F(e,r){var t=r||{};D(e);if(t.fileType=="zip")return ye(e,t);var a=function(e){var r=0,t=0;for(var a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];if(!n.content)continue;var i=n.content.length;if(i>0){if(i<4096)r+=i+63>>6;else t+=i+511>>9}}var s=e.FullPaths.length+3>>2;var f=r+7>>3;var o=r+127>>7;var l=f+t+s+o;var c=l+127>>7;var h=c<=109?0:Math.ceil((c-109)/127);while(l+c+h+127>>7>c)h=++c<=109?0:Math.ceil((c-109)/127);var u=[1,h,c,o,s,t,r,0];e.FileIndex[0].size=r<<6;u[7]=(e.FileIndex[0].start=u[0]+u[1]+u[2]+u[3]+u[4]+u[5])+(u[6]+7>>3);return u}(e);var n=Gr(a[7]<<9);var i=0,s=0;{for(i=0;i<8;++i)n._W(1,M[i]);for(i=0;i<8;++i)n._W(2,0);n._W(2,62);n._W(2,3);n._W(2,65534);n._W(2,9);n._W(2,6);for(i=0;i<3;++i)n._W(2,0);n._W(4,0);n._W(4,a[2]);n._W(4,a[0]+a[1]+a[2]+a[3]-1);n._W(4,0);n._W(4,1<<12);n._W(4,a[3]?a[0]+a[1]+a[2]-1:N);n._W(4,a[3]);n._W(-4,a[1]?a[0]-1:N);n._W(4,a[1]);for(i=0;i<109;++i)n._W(-4,i<a[2]?a[1]+i:-1)}if(a[1]){for(s=0;s<a[1];++s){for(;i<236+s*127;++i)n._W(-4,i<a[2]?a[1]+i:-1);n._W(-4,s===a[1]-1?N:s+1)}}var f=function(e){for(s+=e;i<s-1;++i)n._W(-4,i+1);if(e){++i;n._W(-4,N)}};s=i=0;for(s+=a[1];i<s;++i)n._W(-4,V.DIFSECT);for(s+=a[2];i<s;++i)n._W(-4,V.FATSECT);f(a[3]);f(a[4]);var o=0,l=0;var c=e.FileIndex[0];for(;o<e.FileIndex.length;++o){c=e.FileIndex[o];if(!c.content)continue;l=c.content.length;if(l<4096)continue;c.start=s;f(l+511>>9)}f(a[6]+7>>3);while(n.l&511)n._W(-4,V.ENDOFCHAIN);s=i=0;for(o=0;o<e.FileIndex.length;++o){c=e.FileIndex[o];if(!c.content)continue;l=c.content.length;if(!l||l>=4096)continue;c.start=s;f(l+63>>6)}while(n.l&511)n._W(-4,V.ENDOFCHAIN);for(i=0;i<a[4]<<2;++i){var h=e.FullPaths[i];if(!h||h.length===0){for(o=0;o<17;++o)n._W(4,0);for(o=0;o<3;++o)n._W(4,-1);for(o=0;o<12;++o)n._W(4,0);continue}c=e.FileIndex[i];if(i===0)c.start=c.size?c.start-1:N;var u=i===0&&t.root||c.name;l=2*(u.length+1);n._W(64,u,"utf16le");n._W(2,l);n._W(1,c.type);n._W(1,c.color);n._W(-4,c.L);n._W(-4,c.R);n._W(-4,c.C);if(!c.clsid)for(o=0;o<4;++o)n._W(4,0);else n._W(16,c.clsid,"hex");n._W(4,c.state||0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,c.start);n._W(4,c.size);n._W(4,0)}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>=4096){n.l=c.start+1<<9;for(o=0;o<c.size;++o)n._W(1,c.content[o]);for(;o&511;++o)n._W(1,0)}}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>0&&c.size<4096){for(o=0;o<c.size;++o)n._W(1,c.content[o]);for(;o&63;++o)n._W(1,0)}}while(n.l<n.length)n._W(1,0);return n}function O(e,r){var t=e.FullPaths.map(function(e){return e.toUpperCase()});var a=t.map(function(e){var r=e.split("/");return r[r.length-(e.slice(-1)=="/"?2:1)]});var n=false;if(r.charCodeAt(0)===47){n=true;r=t[0].slice(0,-1)+r}else n=r.indexOf("/")!==-1;var i=r.toUpperCase();var s=n===true?t.indexOf(i):a.indexOf(i);if(s!==-1)return e.FileIndex[s];var f=!i.match(R);i=i.replace(I,"");if(f)i=i.replace(R,"!");for(s=0;s<t.length;++s){if((f?t[s].replace(R,"!"):t[s]).replace(I,"")==i)return e.FileIndex[s];if((f?a[s].replace(R,"!"):a[s]).replace(I,"")==i)return e.FileIndex[s]}return null}var P=64;var N=-2;var L="d0cf11e0a1b11ae1";var M=[208,207,17,224,161,177,26,225];var U="00000000000000000000000000000000";var V={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:N,FREESECT:-1,HEADER_SIGNATURE:L,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:U,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function z(e,r,t){o();var a=F(e,t);f.writeFileSync(r,a)}function X(e){var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function G(e,r){var t=F(e,r);switch(r&&r.type){case"file":o();f.writeFileSync(r.filename,t);return t;case"binary":return X(t);case"base64":return m.encode(X(t));}return t}var j;function K(e){try{var r=e.InflateRaw;var t=new r;t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag);if(t.bytesRead)j=e;else throw new Error("zlib does not expose bytesRead")}catch(a){console.error("cannot use native zlib: "+(a.message||a))}}function Y(e,r){if(!j)return Ae(e,r);var t=j.InflateRaw;var a=new t;var n=a._processChunk(e.slice(e.l),a._finishFlushFlag);e.l+=a.bytesRead;return n}function $(e){return j?j.deflateRawSync(e):ue(e)}var Z=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var Q=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];var J=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function q(e){var r=(e<<1|e<<11)&139536|(e<<5|e<<15)&558144;return(r>>16|r>>8|r)&255}var ee=typeof Uint8Array!=="undefined";var re=ee?new Uint8Array(1<<8):[];for(var te=0;te<1<<8;++te)re[te]=q(te);function ae(e,r){var t=re[e&255];if(r<=8)return t>>>8-r;t=t<<8|re[e>>8&255];if(r<=16)return t>>>16-r;t=t<<8|re[e>>16&255];return t>>>24-r}function ne(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=6?0:e[a+1]<<8))>>>t&3}function ie(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=5?0:e[a+1]<<8))>>>t&7}function se(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=4?0:e[a+1]<<8))>>>t&15}function fe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=3?0:e[a+1]<<8))>>>t&31}function oe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=1?0:e[a+1]<<8))>>>t&127}function le(e,r,t){var a=r&7,n=r>>>3,i=(1<<t)-1;var s=e[n]>>>a;if(t<8-a)return s&i;s|=e[n+1]<<8-a;if(t<16-a)return s&i;s|=e[n+2]<<16-a;if(t<24-a)return s&i;s|=e[n+3]<<24-a;return s&i}function ce(e,r){var t=e.length,a=2*t>r?2*t:r+5,n=0;if(t>=r)return e;if(b){var i=S(a);if(e.copy)e.copy(i);else for(;n<e.length;++n)i[n]=e[n];return i}else if(ee){var s=new Uint8Array(a);if(s.set)s.set(e);else for(;n<e.length;++n)s[n]=e[n];return s}e.length=a;return e}function he(e){var r=new Array(e);for(var t=0;t<e;++t)r[t]=0;return r}var ue=function(){var e=function(){return function e(r,t){var a=0;while(a<r.length){var n=Math.min(65535,r.length-a);var i=a+n==r.length;t._W(1,+i);t._W(2,n);t._W(2,~n&65535);while(n-- >0)t[t.l++]=r[a++]}return t.l}}();return function(r){var t=Gr(50+Math.floor(r.length*1.1));var a=e(r,t);return t.slice(0,a)}}();function de(e,r,t){var a=1,n=0,i=0,s=0,f=0,o=e.length;var l=ee?new Uint16Array(32):he(32);for(i=0;i<32;++i)l[i]=0;for(i=o;i<t;++i)e[i]=0;o=e.length;var c=ee?new Uint16Array(o):he(o);for(i=0;i<o;++i){l[n=e[i]]++;if(a<n)a=n;c[i]=0}l[0]=0;for(i=1;i<=a;++i)l[i+16]=f=f+l[i-1]<<1;for(i=0;i<o;++i){f=e[i];if(f!=0)c[i]=l[f+16]++}var h=0;for(i=0;i<o;++i){h=e[i];if(h!=0){f=ae(c[i],a)>>a-h;for(s=(1<<a+4-h)-1;s>=0;--s)r[f|s<<h]=h&15|i<<4}}return a}var pe=ee?new Uint16Array(512):he(512);var ve=ee?new Uint16Array(32):he(32);if(!ee){for(var ge=0;ge<512;++ge)pe[ge]=0;for(ge=0;ge<32;++ge)ve[ge]=0}(function(){var e=[];var r=0;for(;r<32;r++)e.push(5);de(e,ve,32);var t=[];r=0;for(;r<=143;r++)t.push(8);for(;r<=255;r++)t.push(9);for(;r<=279;r++)t.push(7);for(;r<=287;r++)t.push(8);de(t,pe,288)})();var me=ee?new Uint16Array(32768):he(32768);var be=ee?new Uint16Array(32768):he(32768);var we=ee?new Uint16Array(128):he(128);var Ce=1,Ee=1;function ke(e,r){var t=fe(e,r)+257;r+=5;var a=fe(e,r)+1;r+=5;var n=se(e,r)+4;r+=4;var i=0;var s=ee?new Uint8Array(19):he(19);var f=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var o=1;var l=ee?new Uint8Array(8):he(8);var c=ee?new Uint8Array(8):he(8);var h=s.length;for(var u=0;u<n;++u){s[Z[u]]=i=ie(e,r);if(o<i)o=i;l[i]++;r+=3}var d=0;l[0]=0;for(u=1;u<=o;++u)c[u]=d=d+l[u-1]<<1;for(u=0;u<h;++u)if((d=s[u])!=0)f[u]=c[d]++;var p=0;for(u=0;u<h;++u){p=s[u];if(p!=0){d=re[f[u]]>>8-p;for(var v=(1<<7-p)-1;v>=0;--v)we[d|v<<p]=p&7|u<<3}}var g=[];o=1;for(;g.length<t+a;){d=we[oe(e,r)];r+=d&7;switch(d>>>=3){case 16:i=3+ne(e,r);r+=2;d=g[g.length-1];while(i-- >0)g.push(d);break;case 17:i=3+ie(e,r);r+=3;while(i-- >0)g.push(0);break;case 18:i=11+oe(e,r);r+=7;while(i-- >0)g.push(0);break;default:g.push(d);if(o<d)o=d;break;}}var m=g.slice(0,t),b=g.slice(t);for(u=t;u<286;++u)m[u]=0;for(u=a;u<30;++u)b[u]=0;Ce=de(m,me,286);Ee=de(b,be,30);return r}function Se(e,r){if(e[0]==3&&!(e[1]&3)){return[k(r),2]}var t=0;var a=0;var n=S(r?r:1<<18);var i=0;var s=n.length>>>0;var f=0,o=0;while((a&1)==0){a=ie(e,t);t+=3;if(a>>>1==0){if(t&7)t+=8-(t&7);var l=e[t>>>3]|e[(t>>>3)+1]<<8;t+=32;if(!r&&s<i+l){n=ce(n,i+l);s=n.length}if(typeof e.copy==="function"){e.copy(n,i,t>>>3,(t>>>3)+l);i+=l;t+=8*l}else while(l-- >0){n[i++]=e[t>>>3];t+=8}continue}else if(a>>>1==1){f=9;o=5}else{t=ke(e,t);f=Ce;o=Ee}if(!r&&s<i+32767){n=ce(n,i+32767);s=n.length}for(;;){var c=le(e,t,f);var h=a>>>1==1?pe[c]:me[c];t+=h&15;h>>>=4;if((h>>>8&255)===0)n[i++]=h;else if(h==256)break;else{h-=257;var u=h<8?0:h-4>>2;if(u>5)u=0;var d=i+Q[h];if(u>0){d+=le(e,t,u);t+=u}c=le(e,t,o);h=a>>>1==1?ve[c]:be[c];t+=h&15;h>>>=4;var p=h<4?0:h-2>>1;var v=J[h];if(p>0){v+=le(e,t,p);t+=p}if(!r&&s<d){n=ce(n,d);s=n.length}while(i<d){n[i]=n[i-v];++i}}}}return[r?n:n.slice(0,i),t+7>>>3]}function Ae(e,r){var t=e.slice(e.l||0);var a=Se(t,r);e.l+=a[1];return a[0]}function _e(e,r){if(e){if(typeof console!=="undefined")console.error(r)}else throw new Error(r)}function Be(e,r){var t=e;zr(t,0);var a=[],n=[];var i={FileIndex:a,FullPaths:n};T(i,{root:r.root});var f=t.length-4;while((t[f]!=80||t[f+1]!=75||t[f+2]!=5||t[f+3]!=6)&&f>=0)--f;t.l=f+4;t.l+=4;var o=t._R(2);t.l+=6;var l=t._R(4);t.l=l;for(f=0;f<o;++f){t.l+=20;var c=t._R(4);var h=t._R(4);var u=t._R(2);var d=t._R(2);var p=t._R(2);t.l+=8;var v=t._R(4);var g=s(t.slice(t.l+u,t.l+u+d));t.l+=u+d+p;var m=t.l;t.l=v+4;Te(t,c,h,i,g);t.l=m}return i}function Te(e,r,t,a,n){e.l+=2;var f=e._R(2);var o=e._R(2);var l=i(e);if(f&8257)throw new Error("Unsupported ZIP encryption");var c=e._R(4);var h=e._R(4);var u=e._R(4);var d=e._R(2);var p=e._R(2);var v="";for(var g=0;g<d;++g)v+=String.fromCharCode(e[e.l++]);if(p){var m=s(e.slice(e.l,e.l+p));if((m[21589]||{}).mt)l=m[21589].mt;if(((n||{})[21589]||{}).mt)l=n[21589].mt}e.l+=p;var b=e.slice(e.l,e.l+h);switch(o){case 8:b=Y(e,u);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+o);}var w=false;if(f&8){c=e._R(4);if(c==134695760){c=e._R(4);w=true}h=e._R(4);u=e._R(4)}if(h!=r)_e(w,"Bad compressed size: "+r+" != "+h);if(u!=t)_e(w,"Bad uncompressed size: "+t+" != "+u);var C=H.buf(b,0);if(c!=C)_e(w,"Bad CRC32 checksum: "+c+" != "+C);Ie(a,v,b,{unsafe:true,mt:l})}function ye(e,r){var t=r||{};var a=[],i=[];var s=Gr(1);var f=t.compression?8:0,o=0;var l=false;if(l)o|=8;var c=0,h=0;var u=0,d=0;var p=e.FullPaths[0],v=p,g=e.FileIndex[0];var m=[];var b=0;for(c=1;c<e.FullPaths.length;++c){v=e.FullPaths[c].slice(p.length);g=e.FileIndex[c];if(!g.size||!g.content||v=="Sh33tJ5")continue;var w=u;var C=Gr(v.length);for(h=0;h<v.length;++h)C._W(1,v.charCodeAt(h)&127);C=C.slice(0,C.l);m[d]=H.buf(g.content,0);var E=g.content;if(f==8)E=$(E);s=Gr(30);s._W(4,67324752);s._W(2,20);s._W(2,o);s._W(2,f);if(g.mt)n(s,g.mt);else s._W(4,0);s._W(-4,o&8?0:m[d]);s._W(4,o&8?0:E.length);s._W(4,o&8?0:g.content.length);s._W(2,C.length);s._W(2,0);u+=s.length;a.push(s);u+=C.length;a.push(C);u+=E.length;a.push(E);if(o&8){s=Gr(12);s._W(-4,m[d]);s._W(4,E.length);s._W(4,g.content.length);u+=s.l;a.push(s)}s=Gr(46);s._W(4,33639248);s._W(2,0);s._W(2,20);s._W(2,o);s._W(2,f);s._W(4,0);s._W(-4,m[d]);s._W(4,E.length);s._W(4,g.content.length);s._W(2,C.length);s._W(2,0);s._W(2,0);s._W(2,0);s._W(2,0);s._W(4,0);s._W(4,w);b+=s.l;i.push(s);b+=C.length;i.push(C);++d}s=Gr(22);s._W(4,101010256);s._W(2,0);s._W(2,0);s._W(2,d);s._W(2,d);s._W(4,b);s._W(4,u);s._W(2,0);return x([x(a),x(i),s])}function xe(e){var r={};T(r,e);return r}function Ie(e,r,t,n){var i=n&&n.unsafe;if(!i)T(e);var s=!i&&W.find(e,r);if(!s){var f=e.FullPaths[0];if(r.slice(0,f.length)==f)f=r;else{if(f.slice(-1)!="/")f+="/";f=(f+r).replace("//","/")}s={name:a(r),type:2};e.FileIndex.push(s);e.FullPaths.push(f);if(!i)W.utils.cfb_gc(e)}s.content=t;s.size=t?t.length:0;if(n){if(n.CLSID)s.clsid=n.CLSID;if(n.mt)s.mt=n.mt;if(n.ct)s.ct=n.ct}return s}function Re(e,r){T(e);var t=W.find(e,r);if(t)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==t){e.FileIndex.splice(a,1);e.FullPaths.splice(a,1);return true}return false}function De(e,r,t){T(e);var n=W.find(e,r);if(n)for(var i=0;i<e.FileIndex.length;++i)if(e.FileIndex[i]==n){e.FileIndex[i].name=a(t);e.FullPaths[i]=t;return true}return false}function Fe(e){D(e,true)}e.find=O;e.read=B;e.parse=l;e.write=G;e.writeFile=z;e.utils={cfb_new:xe,cfb_add:Ie,cfb_del:Re,cfb_mov:De,cfb_gc:Fe,ReadShift:Lr,CheckField:Vr,prep_blob:zr,bconcat:x,use_zlib:K,_deflateRaw:ue,_inflateRaw:Ae,consts:V};return e}();if(typeof require!=="undefined"&&typeof module!=="undefined"&&typeof U==="undefined"){module.exports=W}var V;if(typeof require!=="undefined")try{V=require("fs")}catch(E){}function z(e){if(typeof e==="string")return _(e);if(Array.isArray(e))return T(e);return e}function X(e,r,t){if(typeof V!=="undefined"&&V.writeFileSync)return t?V.writeFileSync(e,r,t):V.writeFileSync(e,r);var a=t=="utf8"?Xe(r):r;if(typeof IE_SaveFile!=="undefined")return IE_SaveFile(a,e);if(typeof Blob!=="undefined"){var n=new Blob([z(a)],{type:"application/octet-stream"});if(typeof navigator!=="undefined"&&navigator.msSaveBlob)return navigator.msSaveBlob(n,e);if(typeof saveAs!=="undefined")return saveAs(n,e);if(typeof URL!=="undefined"&&typeof document!=="undefined"&&document.createElement&&URL.createObjectURL){var i=URL.createObjectURL(n);if(typeof chrome==="object"&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return chrome.downloads.download({url:i,filename:e,saveAs:true})}var s=document.createElement("a");if(s.download!=null){s.download=e;s.href=i;document.body.appendChild(s);s.click();document.body.removeChild(s);if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return i}}}if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var f=File(e);f.open("w");f.encoding="binary";if(Array.isArray(r))r=B(r);f.write(r);f.close();return r}catch(o){if(!o.message||!o.message.match(/onstruct/))throw o}throw new Error("cannot save file "+e)}function G(e){if(typeof V!=="undefined")return V.readFileSync(e);if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var r=File(e);r.open("r");r.encoding="binary";var t=r.read();r.close();return t}catch(a){if(!a.message||!a.message.match(/onstruct/))throw a}throw new Error("Cannot access file "+e)}function j(e){var r=Object.keys(e),t=[];for(var a=0;a<r.length;++a)if(e.hasOwnProperty(r[a]))t.push(r[a]);return t}function K(e,r){var t=[],a=j(e);for(var n=0;n!==a.length;++n)if(t[e[a[n]][r]]==null)t[e[a[n]][r]]=a[n];return t}function Y(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=t[a];return r}function Z(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=parseInt(t[a],10);return r}function Q(e){var r=[],t=j(e);for(var a=0;a!==t.length;++a){if(r[e[t[a]]]==null)r[e[t[a]]]=[];r[e[t[a]]].push(t[a])}return r}var J=new Date(1899,11,30,0,0,0);var q=J.getTime()+((new Date).getTimezoneOffset()-J.getTimezoneOffset())*6e4;function ee(e,r){var t=e.getTime();if(r)t-=1462*24*60*60*1e3;return(t-q)/(24*60*60*1e3)}function re(e){var r=new Date;r.setTime(e*24*60*60*1e3+q);return r}function te(e){var r=0,t=0,a=false;var n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var i=1;i!=n.length;++i){if(!n[i])continue;t=1;if(i>3)a=true;switch(n[i].slice(n[i].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[i].slice(n[i].length-1));case"D":t*=24;case"H":t*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");else t*=60;case"S":break;}r+=t*parseInt(n[i],10)}return r}var ae=new Date("2017-02-19T19:06:09.000Z");if(isNaN(ae.getFullYear()))ae=new Date("2/19/17");var ne=ae.getFullYear()==2017;function ie(e,r){var t=new Date(e);if(ne){if(r>0)t.setTime(t.getTime()+t.getTimezoneOffset()*60*1e3);else if(r<0)t.setTime(t.getTime()-t.getTimezoneOffset()*60*1e3);return t}if(e instanceof Date)return e;if(ae.getFullYear()==1917&&!isNaN(t.getFullYear())){var a=t.getFullYear();if(e.indexOf(""+a)>-1)return t;t.setFullYear(t.getFullYear()+100);return t}var n=e.match(/\d+/g)||["2017","2","19","0","0","0"];var i=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(e.indexOf("Z")>-1)i=new Date(i.getTime()-i.getTimezoneOffset()*60*1e3);return i}function se(e){var r="";for(var t=0;t!=e.length;++t)r+=String.fromCharCode(e[t]);return r}function fe(e){if(typeof JSON!="undefined"&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if(typeof e!="object"||e==null)return e;if(e instanceof Date)return new Date(e.getTime());var r={};for(var t in e)if(e.hasOwnProperty(t))r[t]=fe(e[t]);return r}function oe(e,r){var t="";while(t.length<r)t+=e;return t}function le(e){var r=Number(e);if(!isNaN(r))return r;var t=1;var a=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){t*=100;return""});if(!isNaN(r=Number(a)))return r/t;a=a.replace(/[(](.*)[)]/,function(e,r){t=-t;return r});if(!isNaN(r=Number(a)))return r/t;return r}function ce(e){var r=new Date(e),t=new Date(NaN);var a=r.getYear(),n=r.getMonth(),i=r.getDate();if(isNaN(i))return t;if(a<0||a>8099)return t;if((n>0||i>1)&&a!=101)return r;if(e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return r;if(e.match(/[^-0-9:,\/\\]/))return t;return r}var he="abacaba".split(/(:?b)/i).length==5;function ue(e,r,t){if(he||typeof r=="string")return e.split(r);var a=e.split(r),n=[a[0]];for(var i=1;i<a.length;++i){n.push(t);n.push(a[i])}return n}function de(e){if(!e)return null;if(e.data)return d(e.data);if(e.asNodeBuffer&&b)return d(e.asNodeBuffer().toString("binary"));if(e.asBinary)return d(e.asBinary());if(e._data&&e._data.getContent)return d(se(Array.prototype.slice.call(e._data.getContent(),0)));return null}function pe(e){if(!e)return null;if(e.data)return c(e.data);if(e.asNodeBuffer&&b)return e.asNodeBuffer();if(e._data&&e._data.getContent){var r=e._data.getContent();if(typeof r=="string")return c(r);return Array.prototype.slice.call(r)}return null}function ve(e){return e&&e.name.slice(-4)===".bin"?pe(e):de(e)}function ge(e,r){var t=j(e.files);var a=r.toLowerCase(),n=a.replace(/\//g,"\\");for(var i=0;i<t.length;++i){var s=t[i].toLowerCase();if(a==s||n==s)return e.files[t[i]]}return null}function me(e,r){var t=ge(e,r);if(t==null)throw new Error("Cannot find file "+r+" in zip");return t}function be(e,r,t){if(!t)return ve(me(e,r));if(!r)return null;try{return be(e,r)}catch(a){return null}}function we(e,r,t){if(!t)return de(me(e,r));if(!r)return null;try{return we(e,r)}catch(a){return null}}function Ce(e){var r=j(e.files),t=[];for(var a=0;a<r.length;++a)if(r[a].slice(-1)!="/")t.push(r[a]);return t.sort()}var Ee;if(typeof JSZipSync!=="undefined")Ee=JSZipSync;if(typeof exports!=="undefined"){if(typeof module!=="undefined"&&module.exports){if(typeof Ee==="undefined")Ee=undefined}}function ke(e,r){var t=r.split("/");if(r.slice(-1)!="/")t.pop();var a=e.split("/");while(a.length!==0){var n=a.shift();if(n==="..")t.pop();else if(n!==".")t.push(n)}return t.join("/")}var Se='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var Ae=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var _e=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;if(!Se.match(_e))_e=/<[^>]*>/g;var Be=/<\w*:/,Te=/<(\/?)\w+:/;function ye(e,r){var t={};var a=0,n=0;for(;a!==e.length;++a)if((n=e.charCodeAt(a))===32||n===10||n===13)break;if(!r)t[0]=e.slice(0,a);if(a===e.length)return t;var i=e.match(Ae),s=0,f="",o=0,l="",c="",h=1;if(i)for(o=0;o!=i.length;++o){c=i[o];for(n=0;n!=c.length;++n)if(c.charCodeAt(n)===61)break;l=c.slice(0,n).trim();while(c.charCodeAt(n+1)==32)++n;h=(a=c.charCodeAt(n+1))==34||a==39?1:0;f=c.slice(n+1+h,c.length-h);for(s=0;s!=l.length;++s)if(l.charCodeAt(s)===58)break;if(s===l.length){if(l.indexOf("_")>0)l=l.slice(0,l.indexOf("_"));t[l]=f;t[l.toLowerCase()]=f}else{var u=(s===5&&l.slice(0,5)==="xmlns"?"xmlns":"")+l.slice(s+1);if(t[u]&&l.slice(s-3,s)=="ext")continue;t[u]=f;t[u.toLowerCase()]=f}}return t}function xe(e){return e.replace(Te,"<$1")}var Ie={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"};var Re=Y(Ie);var De=function(){var e=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g,r=/_x([\da-fA-F]{4})_/g;return function t(a){var n=a+"",i=n.indexOf("<![CDATA[");if(i==-1)return n.replace(e,function(e,r){return Ie[e]||String.fromCharCode(parseInt(r,e.indexOf("x")>-1?16:10))||e}).replace(r,function(e,r){return String.fromCharCode(parseInt(r,16))});var s=n.indexOf("]]>");return t(n.slice(0,i))+n.slice(i+9,s)+t(n.slice(s+3))}}();var Fe=/[&<>'"]/g,Oe=/[\u0000-\u0008\u000b-\u001f]/g;function Pe(e){var r=e+"";return r.replace(Fe,function(e){return Re[e]}).replace(Oe,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function Ne(e){return Pe(e).replace(/ /g,"_x0020_")}var Le=/[\u0000-\u001f]/g;function Me(e){var r=e+"";return r.replace(Fe,function(e){return Re[e]}).replace(/\n/g,"<br/>").replace(Le,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}function Ue(e){var r=e+"";return r.replace(Fe,function(e){return Re[e]}).replace(Le,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}var He=function(){var e=/&#(\d+);/g;function r(e,r){return String.fromCharCode(parseInt(r,10))}return function t(a){return a.replace(e,r)}}();var We=function(){return function e(r){return r.replace(/(\r\n|[\r\n])/g,"&#10;")}}();function Ve(e){switch(e){case 1:;case true:;case"1":;case"true":;case"TRUE":return true;default:return false;}}var ze=function jg(e){var r="",t=0,a=0,n=0,i=0,s=0,f=0;while(t<e.length){a=e.charCodeAt(t++);if(a<128){r+=String.fromCharCode(a);continue}n=e.charCodeAt(t++);if(a>191&&a<224){s=(a&31)<<6;s|=n&63;r+=String.fromCharCode(s);continue}i=e.charCodeAt(t++);if(a<240){r+=String.fromCharCode((a&15)<<12|(n&63)<<6|i&63);continue}s=e.charCodeAt(t++);f=((a&7)<<18|(n&63)<<12|(i&63)<<6|s&63)-65536;r+=String.fromCharCode(55296+(f>>>10&1023));r+=String.fromCharCode(56320+(f&1023))}return r};var Xe=function(e){var r=[],t=0,a=0,n=0;while(t<e.length){a=e.charCodeAt(t++);switch(true){case a<128:r.push(String.fromCharCode(a));break;case a<2048:r.push(String.fromCharCode(192+(a>>6)));r.push(String.fromCharCode(128+(a&63)));break;case a>=55296&&a<57344:a-=55296;n=e.charCodeAt(t++)-56320+(a<<10);r.push(String.fromCharCode(240+(n>>18&7)));r.push(String.fromCharCode(144+(n>>12&63)));r.push(String.fromCharCode(128+(n>>6&63)));r.push(String.fromCharCode(128+(n&63)));break;default:r.push(String.fromCharCode(224+(a>>12)));r.push(String.fromCharCode(128+(a>>6&63)));r.push(String.fromCharCode(128+(a&63)));}}return r.join("")};if(b){var Ge=function Kg(e){var r=Buffer.alloc(2*e.length),t,a,n=1,i=0,s=0,f;for(a=0;a<e.length;a+=n){n=1;if((f=e.charCodeAt(a))<128)t=f;else if(f<224){t=(f&31)*64+(e.charCodeAt(a+1)&63);n=2}else if(f<240){t=(f&15)*4096+(e.charCodeAt(a+1)&63)*64+(e.charCodeAt(a+2)&63);n=3}else{n=4;t=(f&7)*262144+(e.charCodeAt(a+1)&63)*4096+(e.charCodeAt(a+2)&63)*64+(e.charCodeAt(a+3)&63);t-=65536;s=55296+(t>>>10&1023);t=56320+(t&1023)}if(s!==0){r[i++]=s&255;r[i++]=s>>>8;s=0}r[i++]=t%256;r[i++]=t>>>8}return r.slice(0,i).toString("ucs2")};var je="foo bar bazâð£";if(ze(je)==Ge(je))ze=Ge;var Ke=function Yg(e){return w(e,"binary").toString("utf8")};if(ze(je)==Ke(je))ze=Ke;Xe=function(e){return w(e,"utf8").toString("binary")}}var Ye=function(){var e={};return function r(t,a){var n=t+"|"+(a||"");if(e[n])return e[n];return e[n]=new RegExp("<(?:\\w+:)?"+t+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+t+">",a||"")}}();var $e=function(){var e=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","g"),e[1]]});return function r(t){var a=t.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");for(var n=0;n<e.length;++n)a=a.replace(e[n][0],e[n][1]);return a}}();var Ze=function(){var e={};return function r(t){if(e[t]!==undefined)return e[t];return e[t]=new RegExp("<(?:vt:)?"+t+">([\\s\\S]*?)</(?:vt:)?"+t+">","g")}}();var Qe=/<\/?(?:vt:)?variant>/g,Je=/<(?:vt:)([^>]*)>([\s\S]*)</;function qe(e,r){var t=ye(e);var a=e.match(Ze(t.baseType))||[];var n=[];if(a.length!=t.size){if(r.WTF)throw new Error("unexpected vector length "+a.length+" != "+t.size);return n}a.forEach(function(e){var r=e.replace(Qe,"").match(Je);if(r)n.push({v:ze(r[2]),t:r[1]})});return n}var er=/(^\s|\s$|\n)/;function rr(e,r){return"<"+e+(r.match(er)?' xml:space="preserve"':"")+">"+r+"</"+e+">"}function tr(e){return j(e).map(function(r){return" "+r+'="'+e[r]+'"'}).join("")}function ar(e,r,t){return"<"+e+(t!=null?tr(t):"")+(r!=null?(r.match(er)?' xml:space="preserve"':"")+">"+r+"</"+e:"/")+">"}function nr(e,r){try{return e.toISOString().replace(/\.\d*/,"")}catch(t){if(r)throw t}return""}function ir(e){switch(typeof e){case"string":return ar("vt:lpwstr",e);case"number":return ar((e|0)==e?"vt:i4":"vt:r8",String(e));case"boolean":return ar("vt:bool",e?"true":"false");}if(e instanceof Date)return ar("vt:filetime",nr(e));throw new Error("Unable to serialize "+e)}var sr={dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"};sr.main=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"];var fr={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function or(e,r){var t=1-2*(e[r+7]>>>7);var a=((e[r+7]&127)<<4)+(e[r+6]>>>4&15);var n=e[r+6]&15;for(var i=5;i>=0;--i)n=n*256+e[r+i];if(a==2047)return n==0?t*Infinity:NaN;if(a==0)a=-1022;else{a-=1023;n+=Math.pow(2,52)}return t*Math.pow(2,a-52)*n}function lr(e,r,t){var a=(r<0||1/r==-Infinity?1:0)<<7,n=0,i=0;var s=a?-r:r;if(!isFinite(s)){n=2047;i=isNaN(r)?26985:0}else if(s==0)n=i=0;else{n=Math.floor(Math.log(s)/Math.LN2);i=s*Math.pow(2,52-n);if(n<=-1023&&(!isFinite(i)||i<Math.pow(2,52))){n=-1022}else{i-=Math.pow(2,52);n+=1023}}for(var f=0;f<=5;++f,i/=256)e[t+f]=i&255;e[t+6]=(n&15)<<4|i&15;e[t+7]=n>>4|a}var cr=function(e){var r=[],t=10240;for(var a=0;a<e[0].length;++a)if(e[0][a])for(var n=0,i=e[0][a].length;n<i;n+=t)r.push.apply(r,e[0][a].slice(n,n+t));return r};var hr=cr;var ur=function(e,r,t){var a=[];for(var n=r;n<t;n+=2)a.push(String.fromCharCode(Dr(e,n)));return a.join("").replace(I,"")};var dr=ur;var pr=function(e,r,t){var a=[];for(var n=r;n<r+t;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")};var vr=pr;var gr=function(e,r,t){var a=[];for(var n=r;n<t;n++)a.push(String.fromCharCode(Rr(e,n)));return a.join("")};var mr=gr;var br=function(e,r){var t=Or(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var wr=br;var Cr=function(e,r){var t=Or(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var Er=Cr;var kr=function(e,r){var t=2*Or(e,r);return t>0?gr(e,r+4,r+4+t-1):""};var Sr=kr;var Ar,_r;Ar=_r=function $g(e,r){var t=Or(e,r);return t>0?ur(e,r+4,r+4+t):""};var Br=function(e,r){var t=Or(e,r);return t>0?gr(e,r+4,r+4+t):""};var Tr=Br;var yr,xr;yr=xr=function(e,r){return or(e,r)};var Ir=function Zg(e){return Array.isArray(e)};if(b){ur=function(e,r,t){if(!Buffer.isBuffer(e))return dr(e,r,t);return e.toString("utf16le",r,t).replace(I,"")};pr=function(e,r,t){return Buffer.isBuffer(e)?e.toString("hex",r,r+t):vr(e,r,t)};br=function Qg(e,r){if(!Buffer.isBuffer(e))return wr(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};Cr=function Jg(e,r){if(!Buffer.isBuffer(e))return Er(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};kr=function qg(e,r){if(!Buffer.isBuffer(e))return Sr(e,r);var t=2*e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t-1)};Ar=function em(e,r){if(!Buffer.isBuffer(e))return _r(e,r);var t=e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t)};Br=function rm(e,r){if(!Buffer.isBuffer(e))return Tr(e,r);var t=e.readUInt32LE(r);return e.toString("utf8",r+4,r+4+t)};gr=function tm(e,r,t){return Buffer.isBuffer(e)?e.toString("utf8",r,t):mr(e,r,t)};cr=function(e){return e[0].length>0&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0]):hr(e)};x=function(e){return Buffer.isBuffer(e[0])?Buffer.concat(e):[].concat.apply([],e)};yr=function am(e,r){if(Buffer.isBuffer(e))return e.readDoubleLE(r);return xr(e,r)};Ir=function nm(e){return Buffer.isBuffer(e)||Array.isArray(e)}}if(typeof cptable!=="undefined"){ur=function(e,r,t){return cptable.utils.decode(1200,e.slice(r,t)).replace(I,"")};gr=function(e,r,t){return cptable.utils.decode(65001,e.slice(r,t))};br=function(e,r){var a=Or(e,r);return a>0?cptable.utils.decode(t,e.slice(r+4,r+4+a-1)):""};Cr=function(e,t){var a=Or(e,t);return a>0?cptable.utils.decode(r,e.slice(t+4,t+4+a-1)):""};kr=function(e,r){var t=2*Or(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t-1)):""};Ar=function(e,r){var t=Or(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t)):""};Br=function(e,r){var t=Or(e,r);return t>0?cptable.utils.decode(65001,e.slice(r+4,r+4+t)):""}}var Rr=function(e,r){return e[r]};var Dr=function(e,r){return e[r+1]*(1<<8)+e[r]};var Fr=function(e,r){var t=e[r+1]*(1<<8)+e[r];return t<32768?t:(65535-t+1)*-1};var Or=function(e,r){return e[r+3]*(1<<24)+(e[r+2]<<16)+(e[r+1]<<8)+e[r]};var Pr=function(e,r){return e[r+3]<<24|e[r+2]<<16|e[r+1]<<8|e[r]};var Nr=function(e,r){return e[r]<<24|e[r+1]<<16|e[r+2]<<8|e[r+3]};function Lr(e,t){var a="",n,i,s=[],f,o,l,c;switch(t){case"dbcs":c=this.l;if(b&&Buffer.isBuffer(this))a=this.slice(this.l,this.l+2*e).toString("utf16le");else for(l=0;l<e;++l){a+=String.fromCharCode(Dr(this,c));c+=2}e*=2;break;case"utf8":a=gr(this,this.l,this.l+e);break;case"utf16le":e*=2;a=ur(this,this.l,this.l+e);break;case"wstr":if(typeof cptable!=="undefined")a=cptable.utils.decode(r,this.slice(this.l,this.l+2*e));else return Lr.call(this,e,"dbcs");e=2*e;break;case"lpstr-ansi":a=br(this,this.l);e=4+Or(this,this.l);break;case"lpstr-cp":a=Cr(this,this.l);e=4+Or(this,this.l);break;case"lpwstr":a=kr(this,this.l);e=4+2*Or(this,this.l);break;case"lpp4":e=4+Or(this,this.l);a=Ar(this,this.l);if(e&2)e+=2;break;case"8lpp4":e=4+Or(this,this.l);a=Br(this,this.l);if(e&3)e+=4-(e&3);break;case"cstr":e=0;a="";while((f=Rr(this,this.l+e++))!==0)s.push(p(f));a=s.join("");
break;case"_wstr":e=0;a="";while((f=Dr(this,this.l+e))!==0){s.push(p(f));e+=2}e+=2;a=s.join("");break;case"dbcs-cont":a="";c=this.l;for(l=0;l<e;++l){if(this.lens&&this.lens.indexOf(c)!==-1){f=Rr(this,c);this.l=c+1;o=Lr.call(this,e-l,f?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Dr(this,c)));c+=2}a=s.join("");e*=2;break;case"cpstr":if(typeof cptable!=="undefined"){a=cptable.utils.decode(r,this.slice(this.l,this.l+e));break};case"sbcs-cont":a="";c=this.l;for(l=0;l!=e;++l){if(this.lens&&this.lens.indexOf(c)!==-1){f=Rr(this,c);this.l=c+1;o=Lr.call(this,e-l,f?"dbcs-cont":"sbcs-cont");return s.join("")+o}s.push(p(Rr(this,c)));c+=1}a=s.join("");break;default:switch(e){case 1:n=Rr(this,this.l);this.l++;return n;case 2:n=(t==="i"?Fr:Dr)(this,this.l);this.l+=2;return n;case 4:;case-4:if(t==="i"||(this[this.l+3]&128)===0){n=(e>0?Pr:Nr)(this,this.l);this.l+=4;return n}else{i=Or(this,this.l);this.l+=4}return i;case 8:;case-8:if(t==="f"){if(e==8)i=yr(this,this.l);else i=yr([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return i}else e=8;case 16:a=pr(this,this.l,e);break;};}this.l+=e;return a}var Mr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255;e[t+2]=r>>>16&255;e[t+3]=r>>>24&255};var Ur=function(e,r,t){e[t]=r&255;e[t+1]=r>>8&255;e[t+2]=r>>16&255;e[t+3]=r>>24&255};var Hr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255};function Wr(e,r,t){var a=0,n=0;if(t==="dbcs"){for(n=0;n!=r.length;++n)Hr(this,r.charCodeAt(n),this.l+2*n);a=2*r.length}else if(t==="sbcs"){r=r.replace(/[^\x00-\x7F]/g,"_");for(n=0;n!=r.length;++n)this[this.l+n]=r.charCodeAt(n)&255;a=r.length}else if(t==="hex"){for(;n<e;++n){this[this.l++]=parseInt(r.slice(2*n,2*n+2),16)||0}return this}else if(t==="utf16le"){var i=Math.min(this.l+e,this.length);for(n=0;n<Math.min(r.length,e);++n){var s=r.charCodeAt(n);this[this.l++]=s&255;this[this.l++]=s>>8}while(this.l<i)this[this.l++]=0;return this}else switch(e){case 1:a=1;this[this.l]=r&255;break;case 2:a=2;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;break;case 3:a=3;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;r>>>=8;this[this.l+2]=r&255;break;case 4:a=4;Mr(this,r,this.l);break;case 8:a=8;if(t==="f"){lr(this,r,this.l);break};case 16:break;case-4:a=4;Ur(this,r,this.l);break;}this.l+=a;return this}function Vr(e,r){var t=pr(this,this.l,e.length>>1);if(t!==e)throw new Error(r+"Expected "+e+" saw "+t);this.l+=e.length>>1}function zr(e,r){e.l=r;e._R=Lr;e.chk=Vr;e._W=Wr}function Xr(e,r){e.l+=r}function Gr(e){var r=k(e);zr(r,0);return r}function jr(e,r,t){if(!e)return;var a,n,i;zr(e,e.l||0);var s=e.length,f=0,o=0;while(e.l<s){f=e._R(1);if(f&128)f=(f&127)+((e._R(1)&127)<<7);var l=hv[f]||hv[65535];a=e._R(1);i=a&127;for(n=1;n<4&&a&128;++n)i+=((a=e._R(1))&127)<<7*n;o=e.l+i;var c=(l.f||Xr)(e,i,t);e.l=o;if(r(c,l.n,f))return}}function Kr(){var e=[],r=b?256:2048;var t=function o(e){var r=Gr(e);zr(r,0);return r};var a=t(r);var n=function l(){if(!a)return;if(a.length>a.l){a=a.slice(0,a.l);a.l=a.length}if(a.length>0)e.push(a);a=null};var i=function c(e){if(a&&e<a.length-a.l)return a;n();return a=t(Math.max(e+1,r))};var s=function h(){n();return cr([e])};var f=function u(e){n();a=e;if(a.l==null)a.l=a.length;i(r)};return{next:i,push:f,end:s,_bufs:e}}function Yr(e,r,t,a){var n=+uv[r],i;if(isNaN(n))return;if(!a)a=hv[n].p||(t||[]).length||0;i=1+(n>=128?1:0)+1;if(a>=128)++i;if(a>=16384)++i;if(a>=2097152)++i;var s=e.next(i);if(n<=127)s._W(1,n);else{s._W(1,(n&127)+128);s._W(1,n>>7)}for(var f=0;f!=4;++f){if(a>=128){s._W(1,(a&127)+128);a>>=7}else{s._W(1,a);break}}if(a>0&&Ir(t))e.push(t)}function $r(e,r,t){var a=fe(e);if(r.s){if(a.cRel)a.c+=r.s.c;if(a.rRel)a.r+=r.s.r}else{if(a.cRel)a.c+=r.c;if(a.rRel)a.r+=r.r}if(!t||t.biff<12){while(a.c>=256)a.c-=256;while(a.r>=65536)a.r-=65536}return a}function Zr(e,r,t){var a=fe(e);a.s=$r(a.s,r.s,t);a.e=$r(a.e,r.s,t);return a}function Qr(e,r){if(e.cRel&&e.c<0){e=fe(e);e.c+=r>8?16384:256}if(e.rRel&&e.r<0){e=fe(e);e.r+=r>8?1048576:r>5?65536:16384}var t=ht(e);if(e.cRel===0)t=ft(t);if(e.rRel===0)t=at(t);return t}function Jr(e,r){if(e.s.r==0&&!e.s.rRel){if(e.e.r==(r.biff>=12?1048575:r.biff>=8?65536:16384)&&!e.e.rRel){return(e.s.cRel?"":"$")+st(e.s.c)+":"+(e.e.cRel?"":"$")+st(e.e.c)}}if(e.s.c==0&&!e.s.cRel){if(e.e.c==(r.biff>=12?65535:255)&&!e.e.cRel){return(e.s.rRel?"":"$")+tt(e.s.r)+":"+(e.e.rRel?"":"$")+tt(e.e.r)}}return Qr(e.s,r.biff)+":"+Qr(e.e,r.biff)}var qr={};var et=function(e,r){var t;if(typeof r!=="undefined")t=r;else if(typeof require!=="undefined"){try{t=undefined}catch(a){t=null}}e.rc4=function(e,r){var t=new Array(256);var a=0,n=0,i=0,s=0;for(n=0;n!=256;++n)t[n]=n;for(n=0;n!=256;++n){i=i+t[n]+e[n%e.length].charCodeAt(0)&255;s=t[n];t[n]=t[i];t[i]=s}n=i=0;var f=Buffer(r.length);for(a=0;a!=r.length;++a){n=n+1&255;i=(i+t[n])%256;s=t[n];t[n]=t[i];t[i]=s;f[a]=r[a]^t[t[n]+t[i]&255]}return f};e.md5=function(e){if(!t)throw new Error("Unsupported crypto");return t.createHash("md5").update(e).digest("hex")}};et(qr,typeof crypto!=="undefined"?crypto:undefined);function rt(e){return parseInt(nt(e),10)-1}function tt(e){return""+(e+1)}function at(e){return e.replace(/([A-Z]|^)(\d+)$/,"$1$$$2")}function nt(e){return e.replace(/\$(\d+)$/,"$1")}function it(e){var r=ot(e),t=0,a=0;for(;a!==r.length;++a)t=26*t+r.charCodeAt(a)-64;return t-1}function st(e){var r="";for(++e;e;e=Math.floor((e-1)/26))r=String.fromCharCode((e-1)%26+65)+r;return r}function ft(e){return e.replace(/^([A-Z])/,"$$$1")}function ot(e){return e.replace(/^\$([A-Z])/,"$1")}function lt(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")}function ct(e){var r=lt(e);return{c:it(r[0]),r:rt(r[1])}}function ht(e){return st(e.c)+tt(e.r)}function ut(e){var r=e.split(":").map(ct);return{s:r[0],e:r[r.length-1]}}function dt(e,r){if(typeof r==="undefined"||typeof r==="number"){return dt(e.s,e.e)}if(typeof e!=="string")e=ht(e);if(typeof r!=="string")r=ht(r);return e==r?e:e+":"+r}function pt(e){var r={s:{c:0,r:0},e:{c:0,r:0}};var t=0,a=0,n=0;var i=e.length;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.s.c=--t;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.s.r=--t;if(a===i||e.charCodeAt(++a)===58){r.e.c=r.s.c;r.e.r=r.s.r;return r}for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.e.c=--t;for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.e.r=--t;return r}function vt(e,r){var t=e.t=="d"&&r instanceof Date;if(e.z!=null)try{return e.w=D.format(e.z,t?ee(r):r)}catch(a){}try{return e.w=D.format((e.XF||{}).numFmtId||(t?14:0),t?ee(r):r)}catch(a){return""+r}}function gt(e,r,t){if(e==null||e.t==null||e.t=="z")return"";if(e.w!==undefined)return e.w;if(e.t=="d"&&!e.z&&t&&t.dateNF)e.z=t.dateNF;if(r==undefined)return vt(e,e.v);return vt(e,r)}function mt(e,r){var t=r&&r.sheet?r.sheet:"Sheet1";var a={};a[t]=e;return{SheetNames:[t],Sheets:a}}function bt(e,r,t){var a=t||{};var n=e?Array.isArray(e):a.dense;if(v!=null&&n==null)n=v;var i=e||(n?[]:{});var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?ct(a.origin):a.origin;s=o.r;f=o.c}}var l={s:{c:1e7,r:1e7},e:{c:0,r:0}};if(i["!ref"]){var c=pt(i["!ref"]);l.s.c=c.s.c;l.s.r=c.s.r;l.e.c=Math.max(l.e.c,c.e.c);l.e.r=Math.max(l.e.r,c.e.r);if(s==-1)l.e.r=s=c.e.r+1}for(var h=0;h!=r.length;++h){if(!r[h])continue;if(!Array.isArray(r[h]))throw new Error("aoa_to_sheet expects an array of arrays");for(var u=0;u!=r[h].length;++u){if(typeof r[h][u]==="undefined")continue;var d={v:r[h][u]};var p=s+h,g=f+u;if(l.s.r>p)l.s.r=p;if(l.s.c>g)l.s.c=g;if(l.e.r<p)l.e.r=p;if(l.e.c<g)l.e.c=g;if(r[h][u]&&typeof r[h][u]==="object"&&!Array.isArray(r[h][u])&&!(r[h][u]instanceof Date))d=r[h][u];else{if(Array.isArray(d.v)){d.f=r[h][u][1];d.v=d.v[0]}if(d.v===null){if(d.f)d.t="n";else if(!a.sheetStubs)continue;else d.t="z"}else if(typeof d.v==="number")d.t="n";else if(typeof d.v==="boolean")d.t="b";else if(d.v instanceof Date){d.z=a.dateNF||D._table[14];if(a.cellDates){d.t="d";d.w=D.format(d.z,ee(d.v))}else{d.t="n";d.v=ee(d.v);d.w=D.format(d.z,d.v)}}else d.t="s"}if(n){if(!i[p])i[p]=[];i[p][g]=d}else{var m=ht({c:g,r:p});i[m]=d}}}if(l.s.c<1e7)i["!ref"]=dt(l);return i}function wt(e,r){return bt(null,e,r)}function Ct(e,r){if(!r)r=Gr(4);r._W(4,e);return r}function Et(e){var r=e._R(4);return r===0?"":e._R(r,"dbcs")}function kt(e,r){var t=false;if(r==null){t=true;r=Gr(4+2*e.length)}r._W(4,e.length);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}function St(e){return{ich:e._R(2),ifnt:e._R(2)}}function At(e,r){if(!r)r=Gr(4);r._W(2,e.ich||0);r._W(2,e.ifnt||0);return r}function _t(e,r){var t=e.l;var a=e._R(1);var n=Et(e);var i=[];var s={t:n,h:n};if((a&1)!==0){var f=e._R(4);for(var o=0;o!=f;++o)i.push(St(e));s.r=i}else s.r=[{ich:0,ifnt:0}];e.l=t+r;return s}function Bt(e,r){var t=false;if(r==null){t=true;r=Gr(15+4*e.t.length)}r._W(1,0);kt(e.t,r);return t?r.slice(0,r.l):r}var Tt=_t;function yt(e,r){var t=false;if(r==null){t=true;r=Gr(23+4*e.t.length)}r._W(1,1);kt(e.t,r);r._W(4,1);At({ich:0,ifnt:0},r);return t?r.slice(0,r.l):r}function xt(e){var r=e._R(4);var t=e._R(2);t+=e._R(1)<<16;e.l++;return{c:r,iStyleRef:t}}function It(e,r){if(r==null)r=Gr(8);r._W(-4,e.c);r._W(3,e.iStyleRef||e.s);r._W(1,0);return r}var Rt=Et;var Dt=kt;function Ft(e){var r=e._R(4);return r===0||r===4294967295?"":e._R(r,"dbcs")}function Ot(e,r){var t=false;if(r==null){t=true;r=Gr(127)}r._W(4,e.length>0?e.length:4294967295);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}var Pt=Et;var Nt=Ft;var Lt=Ot;function Mt(e){var r=e.slice(e.l,e.l+4);var t=r[0]&1,a=r[0]&2;e.l+=4;r[0]&=252;var n=a===0?yr([0,0,0,0,r[0],r[1],r[2],r[3]],0):Pr(r,0)>>2;return t?n/100:n}function Ut(e,r){if(r==null)r=Gr(4);var t=0,a=0,n=e*100;if(e==(e|0)&&e>=-(1<<29)&&e<1<<29){a=1}else if(n==(n|0)&&n>=-(1<<29)&&n<1<<29){a=1;t=1}if(a)r._W(-4,((t?n:e)<<2)+(t+2));else throw new Error("unsupported RkNumber "+e)}function Ht(e){var r={s:{},e:{}};r.s.r=e._R(4);r.e.r=e._R(4);r.s.c=e._R(4);r.e.c=e._R(4);return r}function Wt(e,r){if(!r)r=Gr(16);r._W(4,e.s.r);r._W(4,e.e.r);r._W(4,e.s.c);r._W(4,e.e.c);return r}var Vt=Ht;var zt=Wt;function Xt(e){return e._R(8,"f")}function Gt(e,r){return(r||Gr(8))._W(8,e,"f")}var jt={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"};var Kt=Z(jt);function Yt(e){var r={};var t=e._R(1);var a=t>>>1;var n=e._R(1);var i=e._R(2,"i");var s=e._R(1);var f=e._R(1);var o=e._R(1);e.l++;switch(a){case 0:r.auto=1;break;case 1:r.index=n;var l=ka[n];if(l)r.rgb=Yf(l);break;case 2:r.rgb=Yf([s,f,o]);break;case 3:r.theme=n;break;}if(i!=0)r.tint=i>0?i/32767:i/32768;return r}function $t(e,r){if(!r)r=Gr(8);if(!e||e.auto){r._W(4,0);r._W(4,0);return r}if(e.index){r._W(1,2);r._W(1,e.index)}else if(e.theme){r._W(1,6);r._W(1,e.theme)}else{r._W(1,5);r._W(1,0)}var t=e.tint||0;if(t>0)t*=32767;else if(t<0)t*=32768;r._W(2,t);if(!e.rgb){r._W(2,0);r._W(1,0);r._W(1,0)}else{var a=e.rgb||"FFFFFF";r._W(1,parseInt(a.slice(0,2),16));r._W(1,parseInt(a.slice(2,4),16));r._W(1,parseInt(a.slice(4,6),16));r._W(1,255)}return r}function Zt(e){var r=e._R(1);e.l++;var t={fItalic:r&2,fStrikeout:r&8,fOutline:r&16,fShadow:r&32,fCondense:r&64,fExtend:r&128};return t}function Qt(e,r){if(!r)r=Gr(2);var t=(e.italic?2:0)|(e.strike?8:0)|(e.outline?16:0)|(e.shadow?32:0)|(e.condense?64:0)|(e.extend?128:0);r._W(1,t);r._W(1,0);return r}function Jt(e,r){var t={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var a=e._R(4);switch(a){case 0:return"";case 4294967295:;case 4294967294:return t[e._R(4)]||"";}if(a>400)throw new Error("Unsupported Clipboard: "+a.toString(16));e.l-=4;return e._R(0,r==1?"lpstr":"lpwstr")}function qt(e){return Jt(e,1)}function ea(e){return Jt(e,2)}var ra=2;var ta=3;var aa=11;var na=12;var ia=19;var sa=30;var fa=64;var oa=65;var la=71;var ca=4096;var ha=80;var ua=81;var da=[ha,ua];var pa={1:{n:"CodePage",t:ra},2:{n:"Category",t:ha},3:{n:"PresentationFormat",t:ha},4:{n:"ByteCount",t:ta},5:{n:"LineCount",t:ta},6:{n:"ParagraphCount",t:ta},7:{n:"SlideCount",t:ta},8:{n:"NoteCount",t:ta},9:{n:"HiddenCount",t:ta},10:{n:"MultimediaClipCount",t:ta},11:{n:"ScaleCrop",t:aa},12:{n:"HeadingPairs",t:ca|na},13:{n:"TitlesOfParts",t:ca|sa},14:{n:"Manager",t:ha},15:{n:"Company",t:ha},16:{n:"LinksUpToDate",t:aa},17:{n:"CharacterCount",t:ta},19:{n:"SharedDoc",t:aa},22:{n:"HyperlinksChanged",t:aa},23:{n:"AppVersion",t:ta,p:"version"},24:{n:"DigSig",t:oa},26:{n:"ContentType",t:ha},27:{n:"ContentStatus",t:ha},28:{n:"Language",t:ha},29:{n:"Version",t:ha},255:{}};var va={1:{n:"CodePage",t:ra},2:{n:"Title",t:ha},3:{n:"Subject",t:ha},4:{n:"Author",t:ha},5:{n:"Keywords",t:ha},6:{n:"Comments",t:ha},7:{n:"Template",t:ha},8:{n:"LastAuthor",t:ha},9:{n:"RevNumber",t:ha},10:{n:"EditTime",t:fa},11:{n:"LastPrinted",t:fa},12:{n:"CreatedDate",t:fa},13:{n:"ModifiedDate",t:fa},14:{n:"PageCount",t:ta},15:{n:"WordCount",t:ta},16:{n:"CharCount",t:ta},17:{n:"Thumbnail",t:la},18:{n:"Application",t:ha},19:{n:"DocSecurity",t:ta},255:{}};var ga={2147483648:{n:"Locale",t:ia},2147483651:{n:"Behavior",t:ia},1919054434:{}};(function(){for(var e in ga)if(ga.hasOwnProperty(e))pa[e]=va[e]=ga[e]})();var ma=K(pa,"n");var ba=K(va,"n");var wa={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"};var Ca=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];function Ea(e){return e.map(function(e){return[e>>16&255,e>>8&255,e&255]})}var ka=Ea([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);var Sa={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"};var Aa=function(){var e={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};j(e).forEach(function(r){["xlsm","xlam"].forEach(function(t){if(!e[r][t])e[r][t]=e[r].xlsx})});j(e).forEach(function(r){j(e[r]).forEach(function(t){Sa[e[r][t]]=r})});return e}();var _a=Q(Sa);sr.CT="http://schemas.openxmlformats.org/package/2006/content-types";function Ba(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""}}function Ta(e){var r=Ba();if(!e||!e.match)return r;var t={};(e.match(_e)||[]).forEach(function(e){var a=ye(e);switch(a[0].replace(Be,"<")){case"<?xml":break;case"<Types":r.xmlns=a["xmlns"+(a[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":t[a.Extension]=a.ContentType;break;case"<Override":if(r[Sa[a.ContentType]]!==undefined)r[Sa[a.ContentType]].push(a.PartName);break;}});if(r.xmlns!==sr.CT)throw new Error("Unknown Namespace: "+r.xmlns);r.calcchain=r.calcchains.length>0?r.calcchains[0]:"";r.sst=r.strs.length>0?r.strs[0]:"";r.style=r.styles.length>0?r.styles[0]:"";r.defaults=t;delete r.calcchains;return r}var ya=ar("Types",null,{xmlns:sr.CT,"xmlns:xsd":sr.xsd,"xmlns:xsi":sr.xsi});var xa=[["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels",_a.rels[0]]].map(function(e){return ar("Default",null,{Extension:e[0],ContentType:e[1]})});function Ia(e,r){var t=[],a;t[t.length]=Se;t[t.length]=ya;t=t.concat(xa);var n=function(n){if(e[n]&&e[n].length>0){a=e[n][0];t[t.length]=ar("Override",null,{PartName:(a[0]=="/"?"":"/")+a,ContentType:Aa[n][r.bookType||"xlsx"]})}};var i=function(a){(e[a]||[]).forEach(function(e){t[t.length]=ar("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:Aa[a][r.bookType||"xlsx"]})})};var s=function(r){(e[r]||[]).forEach(function(e){t[t.length]=ar("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:_a[r][0]})})};n("workbooks");i("sheets");i("charts");s("themes");["strs","styles"].forEach(n);["coreprops","extprops","custprops"].forEach(s);s("vba");s("comments");s("drawings");if(t.length>2){t[t.length]="</Types>";t[1]=t[1].replace("/>",">")}return t.join("")}var Ra={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function Da(e){var r=e.lastIndexOf("/");return e.slice(0,r+1)+"_rels/"+e.slice(r+1)+".rels"}function Fa(e,r){if(!e)return e;if(r.charAt(0)!=="/"){r="/"+r}var t={};var a={};(e.match(_e)||[]).forEach(function(e){var n=ye(e);if(n[0]==="<Relationship"){var i={};i.Type=n.Type;i.Target=n.Target;i.Id=n.Id;i.TargetMode=n.TargetMode;var s=n.TargetMode==="External"?n.Target:ke(n.Target,r);t[s]=i;a[n.Id]=i}});t["!id"]=a;return t}sr.RELS="http://schemas.openxmlformats.org/package/2006/relationships";var Oa=ar("Relationships",null,{xmlns:sr.RELS});function Pa(e){var r=[Se,Oa];j(e["!id"]).forEach(function(t){r[r.length]=ar("Relationship",null,e["!id"][t])});if(r.length>2){r[r.length]="</Relationships>";r[1]=r[1].replace("/>",">")}return r.join("")}function Na(e,r,t,a,n){if(!n)n={};if(!e["!id"])e["!id"]={};if(r<0)for(r=1;e["!id"]["rId"+r];++r){}n.Id="rId"+r;n.Type=a;n.Target=t;if(n.Type==Ra.HLINK)n.TargetMode="External";if(e["!id"][n.Id])throw new Error("Cannot rewrite rId "+r);e["!id"][n.Id]=n;e[("/"+n.Target).replace("//","/")]=n;return r}var La="application/vnd.oasis.opendocument.spreadsheet";function Ma(e,r){var t=Mp(e);var a;var n;while(a=Up.exec(t))switch(a[3]){case"manifest":break;case"file-entry":n=ye(a[0],false);if(n.path=="/"&&n.type!==La)throw new Error("This OpenDocument is not a spreadsheet");break;case"encryption-data":;case"algorithm":;case"start-key-generation":;case"key-derivation":throw new Error("Unsupported ODS Encryption");default:if(r&&r.WTF)throw a;}}function Ua(e){var r=[Se];r.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');r.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var t=0;t<e.length;++t)r.push('  <manifest:file-entry manifest:full-path="'+e[t][0]+'" manifest:media-type="'+e[t][1]+'"/>\n');r.push("</manifest:manifest>");return r.join("")}function Ha(e,r,t){return['  <rdf:Description rdf:about="'+e+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(t||"odf")+"#"+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Wa(e,r){return['  <rdf:Description rdf:about="'+e+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Va(e){var r=[Se];r.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var t=0;t!=e.length;++t){r.push(Ha(e[t][0],e[t][1]));r.push(Wa("",e[t][0]))}r.push(Ha("","Document","pkg"));r.push("</rdf:RDF>");return r.join("")}var za=function(){var r='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+"JS "+e.version+"</meta:generator></office:meta></office:document-meta>";return function t(){return r}}();var Xa=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]];sr.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";Ra.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";var Ga=function(){var e=new Array(Xa.length);for(var r=0;r<Xa.length;++r){var t=Xa[r];var a="(?:"+t[0].slice(0,t[0].indexOf(":"))+":)"+t[0].slice(t[0].indexOf(":")+1);e[r]=new RegExp("<"+a+"[^>]*>([\\s\\S]*?)</"+a+">")}return e}();function ja(e){var r={};e=ze(e);for(var t=0;t<Xa.length;++t){var a=Xa[t],n=e.match(Ga[t]);if(n!=null&&n.length>0)r[a[1]]=n[1];if(a[2]==="date"&&r[a[1]])r[a[1]]=ie(r[a[1]])}return r}var Ka=ar("cp:coreProperties",null,{"xmlns:cp":sr.CORE_PROPS,"xmlns:dc":sr.dc,"xmlns:dcterms":sr.dcterms,"xmlns:dcmitype":sr.dcmitype,"xmlns:xsi":sr.xsi});function Ya(e,r,t,a,n){if(n[e]!=null||r==null||r==="")return;n[e]=r;a[a.length]=t?ar(e,r,t):rr(e,r)}function $a(e,r){var t=r||{};var a=[Se,Ka],n={};if(!e&&!t.Props)return a.join("");if(e){if(e.CreatedDate!=null)Ya("dcterms:created",typeof e.CreatedDate==="string"?e.CreatedDate:nr(e.CreatedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n);if(e.ModifiedDate!=null)Ya("dcterms:modified",typeof e.ModifiedDate==="string"?e.ModifiedDate:nr(e.ModifiedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n)}for(var i=0;i!=Xa.length;++i){var s=Xa[i];var f=t.Props&&t.Props[s[1]]!=null?t.Props[s[1]]:e?e[s[1]]:null;if(f===true)f="1";else if(f===false)f="0";else if(typeof f=="number")f=String(f);if(f!=null)Ya(s[0],f,null,a,n)}if(a.length>2){a[a.length]="</cp:coreProperties>";a[1]=a[1].replace("/>",">")}return a.join("")}var Za=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];sr.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";Ra.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";var Qa=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function Ja(e,r,t,a){var n=[];if(typeof e=="string")n=qe(e,a);else for(var i=0;i<e.length;++i)n=n.concat(e[i].map(function(e){return{v:e}}));var s=typeof r=="string"?qe(r,a).map(function(e){return e.v}):r;var f=0,o=0;if(s.length>0)for(var l=0;l!==n.length;l+=2){o=+n[l+1].v;switch(n[l].v){case"Worksheets":;case"工作表":;case"Листы":;case"أوراق العمل":;case"ワークシート":;case"גליונות עבודה":;case"Arbeitsblätter":;case"Çalışma Sayfaları":;case"Feuilles de calcul":;case"Fogli di lavoro":;case"Folhas de cálculo":;case"Planilhas":;case"Regneark":;case"Werkbladen":t.Worksheets=o;t.SheetNames=s.slice(f,f+o);break;case"Named Ranges":;case"名前付き一覧":;case"Benannte Bereiche":;case"Navngivne områder":t.NamedRanges=o;t.DefinedNames=s.slice(f,f+o);break;case"Charts":;case"Diagramme":t.Chartsheets=o;t.ChartNames=s.slice(f,f+o);break;}f+=o}}function qa(e,r,t){var a={};if(!r)r={};e=ze(e);Za.forEach(function(t){switch(t[2]){case"string":r[t[1]]=(e.match(Ye(t[0]))||[])[1];break;case"bool":r[t[1]]=(e.match(Ye(t[0]))||[])[1]==="true";break;case"raw":var n=e.match(new RegExp("<"+t[0]+"[^>]*>([\\s\\S]*?)</"+t[0]+">"));if(n&&n.length>0)a[t[1]]=n[1];break;}});if(a.HeadingPairs&&a.TitlesOfParts)Ja(a.HeadingPairs,a.TitlesOfParts,r,t);return r}var en=ar("Properties",null,{xmlns:sr.EXT_PROPS,"xmlns:vt":sr.vt});function rn(e){var r=[],t=ar;if(!e)e={};e.Application="SheetJS";r[r.length]=Se;r[r.length]=en;Za.forEach(function(a){if(e[a[1]]===undefined)return;var n;switch(a[2]){case"string":n=String(e[a[1]]);break;case"bool":n=e[a[1]]?"true":"false";break;}if(n!==undefined)r[r.length]=t(a[0],n)});r[r.length]=t("HeadingPairs",t("vt:vector",t("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+t("vt:variant",t("vt:i4",String(e.Worksheets))),{size:2,baseType:"variant"}));r[r.length]=t("TitlesOfParts",t("vt:vector",e.SheetNames.map(function(e){return"<vt:lpstr>"+Pe(e)+"</vt:lpstr>"}).join(""),{size:e.Worksheets,baseType:"lpstr"}));if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}sr.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";Ra.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";var tn=/<[^>]+>[^<]*/g;function an(e,r){var t={},a="";var n=e.match(tn);if(n)for(var i=0;i!=n.length;++i){var s=n[i],f=ye(s);switch(f[0]){case"<?xml":break;case"<Properties":break;case"<property":a=f.name;break;case"</property>":a=null;break;default:if(s.indexOf("<vt:")===0){var o=s.split(">");var l=o[0].slice(4),c=o[1];switch(l){case"lpstr":;case"bstr":;case"lpwstr":
t[a]=De(c);break;case"bool":t[a]=Ve(c);break;case"i1":;case"i2":;case"i4":;case"i8":;case"int":;case"uint":t[a]=parseInt(c,10);break;case"r4":;case"r8":;case"decimal":t[a]=parseFloat(c);break;case"filetime":;case"date":t[a]=ie(c);break;case"cy":;case"error":t[a]=De(c);break;default:if(l.slice(-1)=="/")break;if(r.WTF&&typeof console!=="undefined")console.warn("Unexpected",s,l,o);}}else if(s.slice(0,2)==="</"){}else if(r.WTF)throw new Error(s);}}return t}var nn=ar("Properties",null,{xmlns:sr.CUST_PROPS,"xmlns:vt":sr.vt});function sn(e){var r=[Se,nn];if(!e)return r.join("");var t=1;j(e).forEach(function a(n){++t;r[r.length]=ar("property",ir(e[n]),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:t,name:n})});if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}var fn={Title:"Title",Subject:"Subject",Author:"Author",Keywords:"Keywords",Comments:"Description",LastAuthor:"LastAuthor",RevNumber:"Revision",Application:"AppName",LastPrinted:"LastPrinted",CreatedDate:"Created",ModifiedDate:"LastSaved",Category:"Category",Manager:"Manager",Company:"Company",AppVersion:"Version",ContentStatus:"ContentStatus",Identifier:"Identifier",Language:"Language"};var on=Y(fn);function ln(e,r,t){r=on[r]||r;e[r]=t}function cn(e,r){var t=[];j(fn).map(function(e){for(var r=0;r<Xa.length;++r)if(Xa[r][1]==e)return Xa[r];for(r=0;r<Za.length;++r)if(Za[r][1]==e)return Za[r];throw e}).forEach(function(a){if(e[a[1]]==null)return;var n=r&&r.Props&&r.Props[a[1]]!=null?r.Props[a[1]]:e[a[1]];switch(a[2]){case"date":n=new Date(n).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof n=="number")n=String(n);else if(n===true||n===false){n=n?"1":"0"}else if(n instanceof Date)n=new Date(n).toISOString().replace(/\.\d*Z/,"");t.push(rr(fn[a[1]]||a[1],n))});return ar("DocumentProperties",t.join(""),{xmlns:fr.o})}function hn(e,r){var t=["Worksheets","SheetNames"];var a="CustomDocumentProperties";var n=[];if(e)j(e).forEach(function(r){if(!e.hasOwnProperty(r))return;for(var a=0;a<Xa.length;++a)if(r==Xa[a][1])return;for(a=0;a<Za.length;++a)if(r==Za[a][1])return;for(a=0;a<t.length;++a)if(r==t[a])return;var i=e[r];var s="string";if(typeof i=="number"){s="float";i=String(i)}else if(i===true||i===false){s="boolean";i=i?"1":"0"}else i=String(i);n.push(ar(Ne(r),i,{"dt:dt":s}))});if(r)j(r).forEach(function(t){if(!r.hasOwnProperty(t))return;if(e&&e.hasOwnProperty(t))return;var a=r[t];var i="string";if(typeof a=="number"){i="float";a=String(a)}else if(a===true||a===false){i="boolean";a=a?"1":"0"}else if(a instanceof Date){i="dateTime.tz";a=a.toISOString()}else a=String(a);n.push(ar(Ne(t),a,{"dt:dt":i}))});return"<"+a+' xmlns="'+fr.o+'">'+n.join("")+"</"+a+">"}function un(e){var r=e._R(4),t=e._R(4);return new Date((t/1e7*Math.pow(2,32)+r/1e7-11644473600)*1e3).toISOString().replace(/\.000/,"")}function dn(e){var r=typeof e=="string"?new Date(Date.parse(e)):e;var t=r.getTime()/1e3+11644473600;var a=t%Math.pow(2,32),n=(t-a)/Math.pow(2,32);a*=1e7;n*=1e7;var i=a/Math.pow(2,32)|0;if(i>0){a=a%Math.pow(2,32);n+=i}var s=Gr(8);s._W(4,a);s._W(4,n);return s}function pn(e,r,t){var a=e.l;var n=e._R(0,"lpstr-cp");if(t)while(e.l-a&3)++e.l;return n}function vn(e,r,t){var a=e._R(0,"lpwstr");if(t)e.l+=4-(a.length+1&3)&3;return a}function gn(e,r,t){if(r===31)return vn(e);return pn(e,r,t)}function mn(e,r,t){return gn(e,r,t===false?0:4)}function bn(e,r){if(!r)throw new Error("VtUnalignedString must have positive length");return gn(e,r,0)}function wn(e){var r=e._R(4);var t=[];for(var a=0;a!=r;++a)t[a]=e._R(0,"lpstr-cp").replace(I,"");return t}function Cn(e){return wn(e)}function En(e){var r=Tn(e,ua);var t=Tn(e,ta);return[r,t]}function kn(e){var r=e._R(4);var t=[];for(var a=0;a!=r/2;++a)t.push(En(e));return t}function Sn(e){return kn(e)}function An(e,r){var t=e._R(4);var a={};for(var n=0;n!=t;++n){var i=e._R(4);var s=e._R(4);a[i]=e._R(s,r===1200?"utf16le":"utf8").replace(I,"").replace(R,"!");if(r===1200&&s%2)e.l+=2}if(e.l&3)e.l=e.l>>2+1<<2;return a}function _n(e){var r=e._R(4);var t=e.slice(e.l,e.l+r);e.l+=r;if((r&3)>0)e.l+=4-(r&3)&3;return t}function Bn(e){var r={};r.Size=e._R(4);e.l+=r.Size+3-(r.Size-1)%4;return r}function Tn(e,r,t){var a=e._R(2),n,i=t||{};e.l+=2;if(r!==na)if(a!==r&&da.indexOf(r)===-1)throw new Error("Expected type "+r+" saw "+a);switch(r===na?a:r){case 2:n=e._R(2,"i");if(!i.raw)e.l+=2;return n;case 3:n=e._R(4,"i");return n;case 11:return e._R(4)!==0;case 19:n=e._R(4);return n;case 30:return pn(e,a,4).replace(I,"");case 31:return vn(e);case 64:return un(e);case 65:return _n(e);case 71:return Bn(e);case 80:return mn(e,a,!i.raw).replace(I,"");case 81:return bn(e,a).replace(I,"");case 4108:return Sn(e);case 4126:return Cn(e);default:throw new Error("TypedPropertyValue unrecognized type "+r+" "+a);}}function yn(e,r){var t=Gr(4),a=Gr(4);t._W(4,e==80?31:e);switch(e){case 3:a._W(-4,r);break;case 5:a=Gr(8);a._W(8,r,"f");break;case 11:a._W(4,r?1:0);break;case 64:a=dn(r);break;case 31:;case 80:a=Gr(4+2*(r.length+1)+(r.length%2?0:2));a._W(4,r.length+1);a._W(0,r,"dbcs");while(a.l!=a.length)a._W(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+e+" "+r);}return x([t,a])}function xn(e,r){var t=e.l;var a=e._R(4);var n=e._R(4);var i=[],s=0;var f=0;var l=-1,c={};for(s=0;s!=n;++s){var h=e._R(4);var u=e._R(4);i[s]=[h,u+t]}i.sort(function(e,r){return e[1]-r[1]});var d={};for(s=0;s!=n;++s){if(e.l!==i[s][1]){var p=true;if(s>0&&r)switch(r[i[s-1][0]].t){case 2:if(e.l+2===i[s][1]){e.l+=2;p=false}break;case 80:if(e.l<=i[s][1]){e.l=i[s][1];p=false}break;case 4108:if(e.l<=i[s][1]){e.l=i[s][1];p=false}break;}if((!r||s==0)&&e.l<=i[s][1]){p=false;e.l=i[s][1]}if(p)throw new Error("Read Error: Expected address "+i[s][1]+" at "+e.l+" :"+s)}if(r){var v=r[i[s][0]];d[v.n]=Tn(e,v.t,{raw:true});if(v.p==="version")d[v.n]=String(d[v.n]>>16)+"."+("0000"+String(d[v.n]&65535)).slice(-4);if(v.n=="CodePage")switch(d[v.n]){case 0:d[v.n]=1252;case 874:;case 932:;case 936:;case 949:;case 950:;case 1250:;case 1251:;case 1253:;case 1254:;case 1255:;case 1256:;case 1257:;case 1258:;case 1e4:;case 1200:;case 1201:;case 1252:;case 65e3:;case-536:;case 65001:;case-535:o(f=d[v.n]>>>0&65535);break;default:throw new Error("Unsupported CodePage: "+d[v.n]);}}else{if(i[s][0]===1){f=d.CodePage=Tn(e,ra);o(f);if(l!==-1){var g=e.l;e.l=i[l][1];c=An(e,f);e.l=g}}else if(i[s][0]===0){if(f===0){l=s;e.l=i[s+1][1];continue}c=An(e,f)}else{var m=c[i[s][0]];var b;switch(e[e.l]){case 65:e.l+=4;b=_n(e);break;case 30:e.l+=4;b=mn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 31:e.l+=4;b=mn(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 3:e.l+=4;b=e._R(4,"i");break;case 19:e.l+=4;b=e._R(4);break;case 5:e.l+=4;b=e._R(8,"f");break;case 11:e.l+=4;b=Mn(e,4);break;case 64:e.l+=4;b=ie(un(e));break;default:throw new Error("unparsed value: "+e[e.l]);}d[m]=b}}}e.l=t+a;return d}var In=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"].concat(Qa);function Rn(e){switch(typeof e){case"boolean":return 11;case"number":return(e|0)==e?3:5;case"string":return 31;case"object":if(e instanceof Date)return 64;break;}return-1}function Dn(e,r,t){var a=Gr(8),n=[],i=[];var s=8,f=0;var o=Gr(8),l=Gr(8);o._W(4,2);o._W(4,1200);l._W(4,1);i.push(o);n.push(l);s+=8+o.length;if(!r){l=Gr(8);l._W(4,0);n.unshift(l);var c=[Gr(4)];c[0]._W(4,e.length);for(f=0;f<e.length;++f){var h=e[f][0];o=Gr(4+4+2*(h.length+1)+(h.length%2?0:2));o._W(4,f+2);o._W(4,h.length+1);o._W(0,h,"dbcs");while(o.l!=o.length)o._W(1,0);c.push(o)}o=x(c);i.unshift(o);s+=8+o.length}for(f=0;f<e.length;++f){if(r&&!r[e[f][0]])continue;if(In.indexOf(e[f][0])>-1)continue;if(e[f][1]==null)continue;var u=e[f][1],d=0;if(r){d=+r[e[f][0]];var p=t[d];if(p.p=="version"&&typeof u=="string"){var v=u.split(".");u=(+v[0]<<16)+(+v[1]||0)}o=yn(p.t,u)}else{var g=Rn(u);if(g==-1){g=31;u=String(u)}o=yn(g,u)}i.push(o);l=Gr(8);l._W(4,!r?2+f:d);n.push(l);s+=8+o.length}var m=8*(i.length+1);for(f=0;f<i.length;++f){n[f]._W(4,m);m+=i[f].length}a._W(4,s);a._W(4,i.length);return x([a].concat(n).concat(i))}function Fn(e,r,t){var a=e.content;if(!a)return{};zr(a,0);var n,i,s,f,o=0;a.chk("feff","Byte Order: ");a._R(2);var l=a._R(4);var c=a._R(16);if(c!==W.utils.consts.HEADER_CLSID&&c!==t)throw new Error("Bad PropertySet CLSID "+c);n=a._R(4);if(n!==1&&n!==2)throw new Error("Unrecognized #Sets: "+n);i=a._R(16);f=a._R(4);if(n===1&&f!==a.l)throw new Error("Length mismatch: "+f+" !== "+a.l);else if(n===2){s=a._R(16);o=a._R(4)}var h=xn(a,r);var u={SystemIdentifier:l};for(var d in h)u[d]=h[d];u.FMTID=i;if(n===1)return u;if(o-a.l==2)a.l+=2;if(a.l!==o)throw new Error("Length mismatch 2: "+a.l+" !== "+o);var p;try{p=xn(a,null)}catch(v){}for(d in p)u[d]=p[d];u.FMTID=[i,s];return u}function On(e,r,t,a,n,i){var s=Gr(n?68:48);var f=[s];s._W(2,65534);s._W(2,0);s._W(4,842412599);s._W(16,W.utils.consts.HEADER_CLSID,"hex");s._W(4,n?2:1);s._W(16,r,"hex");s._W(4,n?68:48);var o=Dn(e,t,a);f.push(o);if(n){var l=Dn(n,null,null);s._W(16,i,"hex");s._W(4,68+o.length);f.push(l)}return x(f)}function Pn(e,r){e._R(r);return null}function Nn(e,r){if(!r)r=Gr(e);for(var t=0;t<e;++t)r._W(1,0);return r}function Ln(e,r,t){var a=[],n=e.l+r;while(e.l<n)a.push(t(e,n-e.l));if(n!==e.l)throw new Error("Slurp error");return a}function Mn(e,r){return e._R(r)===1}function Un(e,r){if(!r)r=Gr(2);r._W(2,+!!e);return r}function Hn(e){return e._R(2,"u")}function Wn(e,r){if(!r)r=Gr(2);r._W(2,e);return r}function Vn(e,r){return Ln(e,r,Hn)}function zn(e){var r=e._R(1),t=e._R(1);return t===1?r:r===1}function Xn(e,r,t){if(!t)t=Gr(2);t._W(1,+e);t._W(1,r=="e"?1:0);return t}function Gn(e,t,a){var n=e._R(a&&a.biff>=12?2:1);var i="sbcs-cont";var s=r;if(a&&a.biff>=8)r=1200;if(!a||a.biff==8){var f=e._R(1);if(f){i="dbcs-cont"}}else if(a.biff==12){i="wstr"}if(a.biff>=2&&a.biff<=5)i="cpstr";var o=n?e._R(n,i):"";r=s;return o}function jn(e){var t=r;r=1200;var a=e._R(2),n=e._R(1);var i=n&4,s=n&8;var f=1+(n&1);var o=0,l;var c={};if(s)o=e._R(2);if(i)l=e._R(4);var h=f==2?"dbcs-cont":"sbcs-cont";var u=a===0?"":e._R(a,h);if(s)e.l+=4*o;if(i)e.l+=l;c.t=u;if(!s){c.raw="<t>"+c.t+"</t>";c.r=c.t}r=t;return c}function Kn(e,r,t){var a;if(t){if(t.biff>=2&&t.biff<=5)return e._R(r,"cpstr");if(t.biff>=12)return e._R(r,"dbcs-cont")}var n=e._R(1);if(n===0){a=e._R(r,"sbcs-cont")}else{a=e._R(r,"dbcs-cont")}return a}function Yn(e,r,t){var a=e._R(t&&t.biff==2?1:2);if(a===0){e.l++;return""}return Kn(e,a,t)}function $n(e,r,t){if(t.biff>5)return Yn(e,r,t);var a=e._R(1);if(a===0){e.l++;return""}return e._R(a,t.biff<=4||!e.lens?"cpstr":"sbcs-cont")}function Zn(e,r,t){if(!t)t=Gr(3+2*e.length);t._W(2,e.length);t._W(1,1);t._W(31,e,"utf16le");return t}function Qn(e){var r=e._R(1);e.l++;var t=e._R(2);e.l+=2;return[r,t]}function Jn(e){var r=e._R(4),t=e.l;var a=false;if(r>24){e.l+=r-24;if(e._R(16)==="795881f43b1d7f48af2c825dc4852763")a=true;e.l=t}var n=e._R((a?r-24:r)>>1,"utf16le").replace(I,"");if(a)e.l+=24;return n}function qn(e){e.l+=2;var r=e._R(0,"lpstr-ansi");e.l+=2;if(e._R(2)!=57005)throw new Error("Bad FileMoniker");var t=e._R(4);if(t===0)return r.replace(/\\/g,"/");var a=e._R(4);if(e._R(2)!=3)throw new Error("Bad FileMoniker");var n=e._R(a>>1,"utf16le").replace(I,"");return n}function ei(e,r){var t=e._R(16);r-=16;switch(t){case"e0c9ea79f9bace118c8200aa004ba90b":return Jn(e,r);case"0303000000000000c000000000000046":return qn(e,r);default:throw new Error("Unsupported Moniker "+t);}}function ri(e){var r=e._R(4);var t=r>0?e._R(r,"utf16le").replace(I,""):"";return t}function ti(e,r){var t=e.l+r;var a=e._R(4);if(a!==2)throw new Error("Unrecognized streamVersion: "+a);var n=e._R(2);e.l+=2;var i,s,f,o,l="",c,h;if(n&16)i=ri(e,t-e.l);if(n&128)s=ri(e,t-e.l);if((n&257)===257)f=ri(e,t-e.l);if((n&257)===1)o=ei(e,t-e.l);if(n&8)l=ri(e,t-e.l);if(n&32)c=e._R(16);if(n&64)h=un(e);e.l=t;var u=s||f||o||"";if(u&&l)u+="#"+l;if(!u)u="#"+l;var d={Target:u};if(c)d.guid=c;if(h)d.time=h;if(i)d.Tooltip=i;return d}function ai(e){var r=Gr(512),t=0;var a=e.Target;var n=a.indexOf("#")>-1?31:23;switch(a.charAt(0)){case"#":n=28;break;case".":n&=~2;break;}r._W(4,2);r._W(4,n);var i=[8,6815827,6619237,4849780,83];for(t=0;t<i.length;++t)r._W(4,i[t]);if(n==28){a=a.slice(1);r._W(4,a.length+1);for(t=0;t<a.length;++t)r._W(2,a.charCodeAt(t));r._W(2,0)}else if(n&2){i="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(t=0;t<i.length;++t)r._W(1,parseInt(i[t],16));r._W(4,2*(a.length+1));for(t=0;t<a.length;++t)r._W(2,a.charCodeAt(t));r._W(2,0)}else{i="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(t=0;t<i.length;++t)r._W(1,parseInt(i[t],16));var s=0;while(a.slice(s*3,s*3+3)=="../"||a.slice(s*3,s*3+3)=="..\\")++s;r._W(2,s);r._W(4,a.length+1);for(t=0;t<a.length;++t)r._W(1,a.charCodeAt(t)&255);r._W(1,0);r._W(2,65535);r._W(2,57005);for(t=0;t<6;++t)r._W(4,0)}return r.slice(0,r.l)}function ni(e){var r=e._R(1),t=e._R(1),a=e._R(1),n=e._R(1);return[r,t,a,n]}function ii(e,r){var t=ni(e,r);t[3]=0;return t}function si(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);return{r:r,c:t,ixfe:a}}function fi(e,r,t,a){if(!a)a=Gr(6);a._W(2,e);a._W(2,r);a._W(2,t||0);return a}function oi(e){var r=e._R(2);var t=e._R(2);e.l+=8;return{type:r,flags:t}}function li(e,r,t){return r===0?"":$n(e,r,t)}function ci(e,r,t){var a=t.biff>8?4:2;var n=e._R(a),i=e._R(a,"i"),s=e._R(a,"i");return[n,i,s]}function hi(e){var r=e._R(2);var t=Mt(e);return[r,t]}function ui(e,r,t){e.l+=4;r-=4;var a=e.l+r;var n=Gn(e,r,t);var i=e._R(2);a-=e.l;if(i!==a)throw new Error("Malformed AddinUdf: padding = "+a+" != "+i);e.l+=i;return n}function di(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);var n=e._R(2);return{s:{c:a,r:r},e:{c:n,r:t}}}function pi(e,r){if(!r)r=Gr(8);r._W(2,e.s.r);r._W(2,e.e.r);r._W(2,e.s.c);r._W(2,e.e.c);return r}function vi(e){var r=e._R(2);var t=e._R(2);var a=e._R(1);var n=e._R(1);return{s:{c:a,r:r},e:{c:n,r:t}}}var gi=vi;function mi(e){e.l+=4;var r=e._R(2);var t=e._R(2);var a=e._R(2);e.l+=12;return[t,r,a]}function bi(e){var r={};e.l+=4;e.l+=16;r.fSharedNote=e._R(2);e.l+=4;return r}function wi(e){var r={};e.l+=4;e.cf=e._R(2);return r}function Ci(e){e.l+=2;e.l+=e._R(2)}var Ei={0:Ci,4:Ci,5:Ci,6:Ci,7:wi,8:Ci,9:Ci,10:Ci,11:Ci,12:Ci,13:bi,14:Ci,15:Ci,16:Ci,17:Ci,18:Ci,19:Ci,20:Ci,21:mi};function ki(e,r){var t=e.l+r;var a=[];while(e.l<t){var n=e._R(2);e.l-=2;try{a.push(Ei[n](e,t-e.l))}catch(i){e.l=t;return a}}if(e.l!=t)e.l=t;return a}function Si(e,r){var t={BIFFVer:0,dt:0};t.BIFFVer=e._R(2);r-=2;if(r>=2){t.dt=e._R(2);e.l-=2}switch(t.BIFFVer){case 1536:;case 1280:;case 1024:;case 768:;case 512:;case 2:;case 7:break;default:if(r>6)throw new Error("Unexpected BIFF Ver "+t.BIFFVer);}e._R(r);return t}function Ai(e,r,t){var a=1536,n=16;switch(t.bookType){case"biff8":break;case"biff5":a=1280;n=8;break;case"biff4":a=4;n=6;break;case"biff3":a=3;n=6;break;case"biff2":a=2;n=4;break;case"xla":break;default:throw new Error("unsupported BIFF version");}var i=Gr(n);i._W(2,a);i._W(2,r);if(n>4)i._W(2,29282);if(n>6)i._W(2,1997);if(n>8){i._W(2,49161);i._W(2,1);i._W(2,1798);i._W(2,0)}return i}function _i(e,r){if(r===0)return 1200;if(e._R(2)!==1200){}return 1200}function Bi(e,r,t){if(t.enc){e.l+=r;return""}var a=e.l;var n=$n(e,0,t);e._R(r+a-e.l);return n}function Ti(e,r){var t=!r||r.biff==8;var a=Gr(t?112:54);a._W(r.biff==8?2:1,7);if(t)a._W(1,0);a._W(4,859007059);a._W(4,5458548|(t?0:536870912));while(a.l<a.length)a._W(1,t?0:32);return a}function yi(e,r,t){var a=t&&t.biff==8||r==2?e._R(2):(e.l+=r,0);return{fDialog:a&16}}function xi(e,r,t){var a=e._R(4);var n=e._R(1)&3;var i=e._R(1);switch(i){case 0:i="Worksheet";break;case 1:i="Macrosheet";break;case 2:i="Chartsheet";break;case 6:i="VBAModule";break;}var s=Gn(e,0,t);if(s.length===0)s="Sheet1";return{pos:a,hs:n,dt:i,name:s}}function Ii(e,r){var t=!r||r.biff>=8?2:1;var a=Gr(8+t*e.name.length);a._W(4,e.pos);a._W(1,e.hs||0);a._W(1,e.dt);a._W(1,e.name.length);if(r.biff>=8)a._W(1,1);a._W(t*e.name.length,e.name,r.biff<8?"sbcs":"utf16le");var n=a.slice(0,a.l);n.l=a.l;return n}function Ri(e,r){var t=e.l+r;var a=e._R(4);var n=e._R(4);var i=[];for(var s=0;s!=n&&e.l<t;++s){i.push(jn(e))}i.Count=a;i.Unique=n;return i}function Di(e,r){var t={};t.dsst=e._R(2);e.l+=r-2;return t}function Fi(e){var r={};r.r=e._R(2);r.c=e._R(2);r.cnt=e._R(2)-r.c;var t=e._R(2);e.l+=4;var a=e._R(1);e.l+=3;if(a&7)r.level=a&7;if(a&32)r.hidden=true;if(a&64)r.hpt=t/20;return r}function Oi(e){var r=oi(e);if(r.type!=2211)throw new Error("Invalid Future Record "+r.type);var t=e._R(4);return t!==0}function Pi(e){e._R(2);return e._R(4)}function Ni(e,r,t){var a=0;if(!(t&&t.biff==2)){a=e._R(2)}var n=e._R(2);if(t&&t.biff==2){a=1-(n>>15);n&=32767}var i={Unsynced:a&1,DyZero:(a&2)>>1,ExAsc:(a&4)>>2,ExDsc:(a&8)>>3};return[i,n]}function Li(e){var r=e._R(2),t=e._R(2),a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2),f=e._R(2);var o=e._R(2),l=e._R(2);return{Pos:[r,t],Dim:[a,n],Flags:i,CurTab:s,FirstTab:f,Selected:o,TabRatio:l}}function Mi(){var e=Gr(18);e._W(2,0);e._W(2,0);e._W(2,29280);e._W(2,17600);e._W(2,56);e._W(2,0);e._W(2,0);e._W(2,1);e._W(2,500);return e}function Ui(e,r,t){if(t&&t.biff>=2&&t.biff<8)return{};var a=e._R(2);return{RTL:a&64}}function Hi(e){var r=Gr(18),t=1718;if(e&&e.RTL)t|=64;r._W(2,t);r._W(4,0);r._W(4,64);r._W(4,0);r._W(4,0);return r}function Wi(e,r,t){var a={dyHeight:e._R(2),fl:e._R(2)};switch(t&&t.biff||8){case 2:break;case 3:;case 4:e.l+=2;break;default:e.l+=10;break;}a.name=Gn(e,0,t);return a}function Vi(e,r){var t=e.name||"Arial";var a=r&&r.biff==5,n=a?15+t.length:16+2*t.length;var i=Gr(n);i._W(2,(e.sz||12)*20);i._W(4,0);i._W(2,400);i._W(4,0);i._W(2,0);i._W(1,t.length);if(!a)i._W(1,1);i._W((a?1:2)*t.length,t,a?"sbcs":"utf16le");return i}function zi(e){var r=si(e);r.isst=e._R(4);return r}function Xi(e,r,t){var a=e.l+r;var n=si(e,6);if(t.biff==2)e.l++;var i=Yn(e,a-e.l,t);n.val=i;return n}function Gi(e,r,t,a,n){var i=!n||n.biff==8;var s=Gr(6+2+ +i+(1+i)*t.length);fi(e,r,a,s);s._W(2,t.length);if(i)s._W(1,1);s._W((1+i)*t.length,t,i?"utf16le":"sbcs");return s}function ji(e,r,t){var a=e._R(2);var n=$n(e,0,t);return[a,n]}function Ki(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Gr(n?3+r.length:5+2*r.length);a._W(2,e);a._W(n?1:2,r.length);if(!n)a._W(1,1);a._W((n?1:2)*r.length,r,n?"sbcs":"utf16le");var i=a.length>a.l?a.slice(0,a.l):a;if(i.l==null)i.l=i.length;return i}var Yi=$n;function $i(e,r,t){var a=e.l+r;var n=t.biff==8||!t.biff?4:2;var i=e._R(n),s=e._R(n);var f=e._R(2),o=e._R(2);e.l=a;return{s:{r:i,c:f},e:{r:s,c:o}}}function Zi(e,r){var t=r.biff==8||!r.biff?4:2;var a=Gr(2*t+6);a._W(t,e.s.r);a._W(t,e.e.r+1);a._W(2,e.s.c);a._W(2,e.e.c+1);a._W(2,0);return a}function Qi(e){var r=e._R(2),t=e._R(2);var a=hi(e);return{r:r,c:t,ixfe:a[0],rknum:a[1]}}function Ji(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(hi(e));if(e.l!==t)throw new Error("MulRK read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulRK length mismatch");return{r:a,c:n,C:s,rkrec:i}}function qi(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(e._R(2));if(e.l!==t)throw new Error("MulBlank read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulBlank length mismatch");return{r:a,c:n,C:s,ixfe:i}}function es(e,r,t,a){var n={};var i=e._R(4),s=e._R(4);var f=e._R(4),o=e._R(2);n.patternType=Ca[f>>26];if(!a.cellStyles)return n;n.alc=i&7;n.fWrap=i>>3&1;n.alcV=i>>4&7;n.fJustLast=i>>7&1;n.trot=i>>8&255;n.cIndent=i>>16&15;n.fShrinkToFit=i>>20&1;n.iReadOrder=i>>22&2;n.fAtrNum=i>>26&1;n.fAtrFnt=i>>27&1;n.fAtrAlc=i>>28&1;n.fAtrBdr=i>>29&1;n.fAtrPat=i>>30&1;n.fAtrProt=i>>31&1;n.dgLeft=s&15;n.dgRight=s>>4&15;n.dgTop=s>>8&15;n.dgBottom=s>>12&15;n.icvLeft=s>>16&127;n.icvRight=s>>23&127;n.grbitDiag=s>>30&3;n.icvTop=f&127;n.icvBottom=f>>7&127;n.icvDiag=f>>14&127;n.dgDiag=f>>21&15;n.icvFore=o&127;n.icvBack=o>>7&127;n.fsxButton=o>>14&1;return n}function rs(e,r,t){var a={};a.ifnt=e._R(2);a.numFmtId=e._R(2);a.flags=e._R(2);a.fStyle=a.flags>>2&1;r-=6;a.data=es(e,r,a.fStyle,t);return a}function ts(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Gr(n?16:20);a._W(2,0);if(e.style){a._W(2,e.numFmtId||0);a._W(2,65524)}else{a._W(2,e.numFmtId||0);a._W(2,r<<4)}a._W(4,0);a._W(4,0);if(!n)a._W(4,0);a._W(2,0);return a}function as(e){e.l+=4;var r=[e._R(2),e._R(2)];if(r[0]!==0)r[0]--;if(r[1]!==0)r[1]--;if(r[0]>7||r[1]>7)throw new Error("Bad Gutters: "+r.join("|"));return r}function ns(e){var r=Gr(8);r._W(4,0);r._W(2,e[0]?e[0]+1:0);r._W(2,e[1]?e[1]+1:0);return r}function is(e,r,t){var a=si(e,6);if(t.biff==2)++e.l;var n=zn(e,2);a.val=n;a.t=n===true||n===false?"b":"e";return a}function ss(e,r,t,a,n,i){var s=Gr(8);fi(e,r,a,s);Xn(t,i,s);return s}function fs(e){var r=si(e,6);var t=Xt(e,8);r.val=t;return r}function os(e,r,t,a){var n=Gr(14);fi(e,r,a,n);Gt(t,n);return n}var ls=li;function cs(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(2);t.sbcch=i;if(i==1025||i==14849)return[i,n];if(i<1||i>255)throw new Error("Unexpected SupBook type: "+i);var s=Kn(e,i);var f=[];while(a>e.l)f.push(Yn(e));return[i,n,s,f]}function hs(e,r,t){var a=e._R(2);var n;var i={fBuiltIn:a&1,fWantAdvise:a>>>1&1,fWantPict:a>>>2&1,fOle:a>>>3&1,fOleLink:a>>>4&1,cf:a>>>5&1023,fIcon:a>>>15&1};if(t.sbcch===14849)n=ui(e,r-2,t);i.body=n||e._R(r-2);if(typeof n==="string")i.Name=n;return i}var us=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function ds(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(1);var s=e._R(1);var f=e._R(t&&t.biff==2?1:2);var o=0;if(!t||t.biff>=5){if(t.biff!=5)e.l+=2;o=e._R(2);if(t.biff==5)e.l+=2;e.l+=4}var l=Kn(e,s,t);if(n&32)l=us[l.charCodeAt(0)];var c=a-e.l;if(t&&t.biff==2)--c;var h=a==e.l||f===0?[]:yh(e,c,t,f);return{chKey:i,Name:l,itab:o,rgce:h}}function ps(e,r,t){if(t.biff<8)return vs(e,r,t);var a=[],n=e.l+r,i=e._R(t.biff>8?4:2);while(i--!==0)a.push(ci(e,t.biff>8?12:6,t));if(e.l!=n)throw new Error("Bad ExternSheet: "+e.l+" != "+n);return a}function vs(e,r,t){if(e[e.l+1]==3)e[e.l]++;var a=Gn(e,r,t);return a.charCodeAt(0)==3?a.slice(1):a}function gs(e,r,t){if(t.biff<8){e.l+=r;return}var a=e._R(2);var n=e._R(2);var i=Kn(e,a,t);var s=Kn(e,n,t);return[i,s]}function ms(e,r,t){var a=vi(e,6);e.l++;var n=e._R(1);r-=8;return[xh(e,r,t),n,a]}function bs(e,r,t){var a=gi(e,6);switch(t.biff){case 2:e.l++;r-=7;break;case 3:;case 4:e.l+=2;r-=8;break;default:e.l+=6;r-=12;}return[a,Bh(e,r,t,a)]}function ws(e){var r=e._R(4)!==0;var t=e._R(4)!==0;var a=e._R(4);return[r,t,a]}function Cs(e,r,t){if(t.biff<8)return;var a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2);var f=$n(e,0,t);if(t.biff<8)e._R(1);return[{r:a,c:n},f,s,i]}function Es(e,r,t){return Cs(e,r,t)}function ks(e,r){var t=[];var a=e._R(2);while(a--)t.push(di(e,r));return t}function Ss(e){var r=Gr(2+e.length*8);r._W(2,e.length);for(var t=0;t<e.length;++t)pi(e[t],r);return r}function As(e,r,t){if(t&&t.biff<8)return Bs(e,r,t);var a=mi(e,22);var n=ki(e,r-22,a[1]);return{cmo:a,ft:n}}var _s=[];_s[8]=function(e,r){var t=e.l+r;e.l+=10;var a=e._R(2);e.l+=4;e.l+=2;e.l+=2;e.l+=2;e.l+=4;var n=e._R(1);e.l+=n;e.l=t;return{fmt:a}};function Bs(e,r,t){e.l+=4;var a=e._R(2);var n=e._R(2);var i=e._R(2);e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=6;r-=36;var s=[];s.push((_s[a]||Xr)(e,r,t));return{cmo:[n,a,i],ft:s}}function Ts(e,r,t){var a=e.l;var n="";try{e.l+=4;var i=(t.lastobj||{cmo:[0,0]}).cmo[1];var s;if([0,5,7,11,12,14].indexOf(i)==-1)e.l+=6;else s=Qn(e,6,t);var f=e._R(2);e._R(2);Hn(e,2);var o=e._R(2);e.l+=o;for(var l=1;l<e.lens.length-1;++l){if(e.l-a!=e.lens[l])throw new Error("TxO: bad continue record");var c=e[e.l];var h=Kn(e,e.lens[l+1]-e.lens[l]-1);n+=h;if(n.length>=(c?f:2*f))break}if(n.length!==f&&n.length!==f*2){throw new Error("cchText: "+f+" != "+n.length)}e.l=a+r;return{t:n}}catch(u){e.l=a+r;return{t:n}}}function ys(e,r){var t=di(e,8);e.l+=16;var a=ti(e,r-24);return[t,a]}function xs(e){var r=Gr(24);var t=ct(e[0]);r._W(2,t.r);r._W(2,t.r);r._W(2,t.c);r._W(2,t.c);var a="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var n=0;n<16;++n)r._W(1,parseInt(a[n],16));return x([r,ai(e[1])])}function Is(e,r){e._R(2);var t=di(e,8);var a=e._R((r-10)/2,"dbcs-cont");a=a.replace(I,"");return[t,a]}function Rs(e){var r=e[1].Tooltip;var t=Gr(10+2*(r.length+1));t._W(2,2048);var a=ct(e[0]);t._W(2,a.r);t._W(2,a.r);t._W(2,a.c);t._W(2,a.c);for(var n=0;n<r.length;++n)t._W(2,r.charCodeAt(n));t._W(2,0);return t}function Ds(e){var r=[0,0],t;t=e._R(2);r[0]=wa[t]||t;t=e._R(2);r[1]=wa[t]||t;return r}function Fs(e){if(!e)e=Gr(4);e._W(2,1);e._W(2,1);return e}function Os(e){var r=e._R(2);var t=[];while(r-- >0)t.push(ii(e,8));return t}function Ps(e){var r=e._R(2);var t=[];while(r-- >0)t.push(ii(e,8));return t}function Ns(e){e.l+=2;var r={cxfs:0,crc:0};r.cxfs=e._R(2);r.crc=e._R(4);return r}function Ls(e,r,t){if(!t.cellStyles)return Xr(e,r);var a=t&&t.biff>=12?4:2;var n=e._R(a);var i=e._R(a);var s=e._R(a);var f=e._R(a);var o=e._R(2);if(a==2)e.l+=2;return{s:n,e:i,w:s,ixfe:f,flags:o}}function Ms(e,r){var t={};if(r<32)return t;e.l+=16;t.header=Xt(e,8);t.footer=Xt(e,8);e.l+=2;return t}function Us(e,r,t){var a={area:false};if(t.biff!=5){e.l+=r;return a}var n=e._R(1);e.l+=3;if(n&16)a.area=true;return a}function Hs(e){var r=Gr(2*e);for(var t=0;t<e;++t)r._W(2,t+1);return r}var Ws=si;var Vs=Vn;var zs=Yn;function Xs(e){var r=e._R(2);var t=e._R(2);var a=e._R(4);var n={fmt:r,env:t,len:a,data:e.slice(e.l,e.l+a)};e.l+=a;return n}function Gs(e,r,t){var a=si(e,6);++e.l;var n=$n(e,r-7,t);a.t="str";a.val=n;return a}function js(e){var r=si(e,6);++e.l;var t=Xt(e,8);r.t="n";r.val=t;return r}function Ks(e,r,t){var a=Gr(15);gv(a,e,r);a._W(8,t,"f");return a}function Ys(e){var r=si(e,6);++e.l;var t=e._R(2);r.t="n";r.val=t;return r}function $s(e,r,t){var a=Gr(9);gv(a,e,r);a._W(2,t);return a}function Zs(e){var r=e._R(1);if(r===0){e.l++;return""}return e._R(r,"sbcs-cont")}function Qs(e,r){e.l+=6;e.l+=2;e.l+=1;e.l+=3;e.l+=1;e.l+=r-13}function Js(e,r,t){var a=e.l+r;var n=si(e,6);var i=e._R(2);var s=Kn(e,i,t);e.l=a;n.t="str";n.val=s;return n}var qs=function(){var e={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,255:16969};function r(r,t){var a=[];var n=k(1);switch(t.type){case"base64":n=A(m.decode(r));break;case"binary":n=A(r);break;case"buffer":;case"array":n=r;break;}zr(n,0);var i=n._R(1);var s=false;var f=false,o=false;switch(i){case 2:;case 3:break;case 48:f=true;s=true;break;case 49:f=true;break;case 131:s=true;break;case 139:s=true;break;case 140:s=true;o=true;break;case 245:s=true;break;default:throw new Error("DBF Unsupported Version: "+i.toString(16));}var l=0,c=0;if(i==2)l=n._R(2);n.l+=3;if(i!=2)l=n._R(4);if(i!=2)c=n._R(2);var h=n._R(2);var u=1252;if(i!=2){n.l+=16;n._R(1);if(n[n.l]!==0)u=e[n[n.l]];n.l+=1;n.l+=2}if(o)n.l+=36;var d=[],p={};var v=c-10-(f?264:0),g=o?32:11;while(i==2?n.l<n.length&&n[n.l]!=13:n.l<v){p={};p.name=cptable.utils.decode(u,n.slice(n.l,n.l+g)).replace(/[\u0000\r\n].*$/g,"");n.l+=g;p.type=String.fromCharCode(n._R(1));if(i!=2&&!o)p.offset=n._R(4);p.len=n._R(1);if(i==2)p.offset=n._R(2);p.dec=n._R(1);if(p.name.length)d.push(p);if(i!=2)n.l+=o?13:14;switch(p.type){case"B":if((!f||p.len!=8)&&t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"G":;case"P":if(t.WTF)console.log("Skipping "+p.name+":"+p.type);break;case"C":;case"D":;case"F":;case"I":;case"L":;case"M":;case"N":;case"O":;case"T":;case"Y":;case"0":;case"@":;case"+":break;default:throw new Error("Unknown Field Type: "+p.type);}}if(n[n.l]!==13)n.l=c-1;else if(i==2)n.l=521;if(i!=2){if(n._R(1)!==13)throw new Error("DBF Terminator not found "+n.l+" "+n[n.l]);n.l=c}var b=0,w=0;a[0]=[];for(w=0;w!=d.length;++w)a[0][w]=d[w].name;while(l-- >0){if(n[n.l]===42){n.l+=h;continue}++n.l;a[++b]=[];w=0;for(w=0;w!=d.length;++w){var C=n.slice(n.l,n.l+d[w].len);n.l+=d[w].len;zr(C,0);var E=cptable.utils.decode(u,C);switch(d[w].type){case"C":a[b][w]=cptable.utils.decode(u,C);a[b][w]=a[b][w].trim();break;case"D":if(E.length===8)a[b][w]=new Date(+E.slice(0,4),+E.slice(4,6)-1,+E.slice(6,8));else a[b][w]=E;break;case"F":a[b][w]=parseFloat(E.trim());break;case"+":;case"I":a[b][w]=o?C._R(-4,"i")^2147483648:C._R(4,"i");break;case"L":switch(E.toUpperCase()){case"Y":;case"T":a[b][w]=true;break;case"N":;case"F":a[b][w]=false;break;case" ":;case"?":a[b][w]=false;break;default:throw new Error("DBF Unrecognized L:|"+E+"|");}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+i.toString(16));a[b][w]="##MEMO##"+(o?parseInt(E.trim(),10):C._R(4));break;case"N":a[b][w]=+E.replace(/\u0000/g,"").trim();break;case"@":
a[b][w]=new Date(C._R(-8,"f")-621356832e5);break;case"T":a[b][w]=new Date((C._R(4)-2440588)*864e5+C._R(4));break;case"Y":a[b][w]=C._R(4,"i")/1e4;break;case"O":a[b][w]=-C._R(-8,"f");break;case"B":if(f&&d[w].len==8){a[b][w]=C._R(8,"f");break};case"G":;case"P":C.l+=d[w].len;break;case"0":if(d[w].name==="_NullFlags")break;default:throw new Error("DBF Unsupported data type "+d[w].type);}}}if(i!=2)if(n.l<n.length&&n[n.l++]!=26)throw new Error("DBF EOF Marker missing "+(n.l-1)+" of "+n.length+" "+n[n.l-1].toString(16));if(t&&t.sheetRows)a=a.slice(0,t.sheetRows);return a}function t(e,t){var a=t||{};if(!a.dateNF)a.dateNF="yyyymmdd";return wt(r(e,a),a)}function a(e,r){try{return mt(t(e,r),r)}catch(a){if(r&&r.WTF)throw a}return{SheetNames:[],Sheets:{}}}var n={B:8,C:250,L:1,D:8,"?":0,"":0};function i(e,r){var t=r||{};if(t.type=="string")throw new Error("Cannot write DBF to JS string");var a=Kr();var i=Rg(e,{header:1,cellDates:true});var s=i[0],f=i.slice(1);var o=0,l=0,c=0,h=1;for(o=0;o<s.length;++o){if(o==null)continue;++c;if(typeof s[o]==="number")s[o]=s[o].toString(10);if(typeof s[o]!=="string")throw new Error("DBF Invalid column name "+s[o]+" |"+typeof s[o]+"|");if(s.indexOf(s[o])!==o)for(l=0;l<1024;++l)if(s.indexOf(s[o]+"_"+l)==-1){s[o]+="_"+l;break}}var u=pt(e["!ref"]);var d=[];for(o=0;o<=u.e.c-u.s.c;++o){var p=[];for(l=0;l<f.length;++l){if(f[l][o]!=null)p.push(f[l][o])}if(p.length==0||s[o]==null){d[o]="?";continue}var v="",g="";for(l=0;l<p.length;++l){switch(typeof p[l]){case"number":g="B";break;case"string":g="C";break;case"boolean":g="L";break;case"object":g=p[l]instanceof Date?"D":"C";break;default:g="C";}v=v&&v!=g?"C":g;if(v=="C")break}h+=n[v]||0;d[o]=v}var m=a.next(32);m._W(4,318902576);m._W(4,f.length);m._W(2,296+32*c);m._W(2,h);for(o=0;o<4;++o)m._W(4,0);m._W(4,768);for(o=0,l=0;o<s.length;++o){if(s[o]==null)continue;var b=a.next(32);var w=(s[o].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11);b._W(1,w,"sbcs");b._W(1,d[o]=="?"?"C":d[o],"sbcs");b._W(4,l);b._W(1,n[d[o]]||0);b._W(1,0);b._W(1,2);b._W(4,0);b._W(1,0);b._W(4,0);b._W(4,0);l+=n[d[o]]||0}var C=a.next(264);C._W(4,13);for(o=0;o<65;++o)C._W(4,0);for(o=0;o<f.length;++o){var E=a.next(h);E._W(1,0);for(l=0;l<s.length;++l){if(s[l]==null)continue;switch(d[l]){case"L":E._W(1,f[o][l]==null?63:f[o][l]?84:70);break;case"B":E._W(8,f[o][l]||0,"f");break;case"D":if(!f[o][l])E._W(8,"00000000","sbcs");else{E._W(4,("0000"+f[o][l].getFullYear()).slice(-4),"sbcs");E._W(2,("00"+(f[o][l].getMonth()+1)).slice(-2),"sbcs");E._W(2,("00"+f[o][l].getDate()).slice(-2),"sbcs")}break;case"C":var k=String(f[o][l]||"");E._W(1,k,"sbcs");for(c=0;c<250-k.length;++c)E._W(1,32);break;}}}a.next(1)._W(1,26);return a.end()}return{to_workbook:a,to_sheet:t,from_sheet:i}}();var ef=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split(/[\n\r]+/),a=-1,n=-1,i=0,s=0,f=[];var o=[];var l=null;var c={},h=[],u=[],d=[];var p=0,v;for(;i!==t.length;++i){p=0;var g=t[i].trim();var m=g.replace(/;;/g,"").split(";").map(function(e){return e.replace(/\u0001/g,";")});var b=m[0],w;if(g.length>0)switch(b){case"ID":break;case"E":break;case"B":break;case"O":break;case"P":if(m[1].charAt(0)=="P")o.push(g.slice(3).replace(/;;/g,";"));break;case"C":var C=false,E=false;for(s=1;s<m.length;++s)switch(m[s].charAt(0)){case"X":n=parseInt(m[s].slice(1))-1;E=true;break;case"Y":a=parseInt(m[s].slice(1))-1;if(!E)n=0;for(v=f.length;v<=a;++v)f[v]=[];break;case"K":w=m[s].slice(1);if(w.charAt(0)==='"')w=w.slice(1,w.length-1);else if(w==="TRUE")w=true;else if(w==="FALSE")w=false;else if(!isNaN(le(w))){w=le(w);if(l!==null&&D.is_date(l))w=re(w)}else if(!isNaN(ce(w).getDate())){w=ie(w)}if(typeof cptable!=="undefined"&&typeof w=="string"&&(r||{}).type!="string"&&(r||{}).codepage)w=cptable.utils.decode(r.codepage,w);C=true;break;case"E":var k=Xl(m[s].slice(1),{r:a,c:n});f[a][n]=[f[a][n],k];break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}if(C){f[a][n]=w;l=null}break;case"F":var S=0;for(s=1;s<m.length;++s)switch(m[s].charAt(0)){case"X":n=parseInt(m[s].slice(1))-1;++S;break;case"Y":a=parseInt(m[s].slice(1))-1;for(v=f.length;v<=a;++v)f[v]=[];break;case"M":p=parseInt(m[s].slice(1))/20;break;case"F":break;case"G":break;case"P":l=o[parseInt(m[s].slice(1))];break;case"S":break;case"D":break;case"N":break;case"W":d=m[s].slice(1).split(" ");for(v=parseInt(d[0],10);v<=parseInt(d[1],10);++v){p=parseInt(d[2],10);u[v-1]=p===0?{hidden:true}:{wch:p};fo(u[v-1])}break;case"C":n=parseInt(m[s].slice(1))-1;if(!u[n])u[n]={};break;case"R":a=parseInt(m[s].slice(1))-1;if(!h[a])h[a]={};if(p>0){h[a].hpt=p;h[a].hpx=ho(p)}else if(p===0)h[a].hidden=true;break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}if(S<1)l=null;break;default:if(r&&r.WTF)throw new Error("SYLK bad record "+g);}}if(h.length>0)c["!rows"]=h;if(u.length>0)c["!cols"]=u;if(r&&r.sheetRows)f=f.slice(0,r.sheetRows);return[f,c]}function t(r,t){var a=e(r,t);var n=a[0],i=a[1];var s=wt(n,t);j(i).forEach(function(e){s[e]=i[e]});return s}function a(e,r){return mt(t(e,r),r)}function n(e,r,t,a){var n="C;Y"+(t+1)+";X"+(a+1)+";K";switch(e.t){case"n":n+=e.v||0;if(e.f&&!e.F)n+=";E"+jl(e.f,{r:t,c:a});break;case"b":n+=e.v?"TRUE":"FALSE";break;case"e":n+=e.w||e.v;break;case"d":n+='"'+(e.w||e.v)+'"';break;case"s":n+='"'+e.v.replace(/"/g,"")+'"';break;}return n}function i(e,r){r.forEach(function(r,t){var a="F;W"+(t+1)+" "+(t+1)+" ";if(r.hidden)a+="0";else{if(typeof r.width=="number")r.wpx=to(r.width);if(typeof r.wpx=="number")r.wch=ao(r.wpx);if(typeof r.wch=="number")a+=Math.round(r.wch)}if(a.charAt(a.length-1)!=" ")e.push(a)})}function s(e,r){r.forEach(function(r,t){var a="F;";if(r.hidden)a+="M0;";else if(r.hpt)a+="M"+20*r.hpt+";";else if(r.hpx)a+="M"+20*co(r.hpx)+";";if(a.length>2)e.push(a+"R"+(t+1))})}function f(e,r){var t=["ID;PWXL;N;E"],a=[];var f=pt(e["!ref"]),o;var l=Array.isArray(e);var c="\r\n";t.push("P;PGeneral");t.push("F;P0;DG0G8;M255");if(e["!cols"])i(t,e["!cols"]);if(e["!rows"])s(t,e["!rows"]);t.push("B;Y"+(f.e.r-f.s.r+1)+";X"+(f.e.c-f.s.c+1)+";D"+[f.s.c,f.s.r,f.e.c,f.e.r].join(" "));for(var h=f.s.r;h<=f.e.r;++h){for(var u=f.s.c;u<=f.e.c;++u){var d=ht({r:h,c:u});o=l?(e[h]||[])[u]:e[d];if(!o||o.v==null&&(!o.f||o.F))continue;a.push(n(o,e,h,u,r))}}return t.join(c)+c+a.join(c)+c+"E"+c}return{to_workbook:a,to_sheet:t,from_sheet:f}}();var rf=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split("\n"),a=-1,n=-1,i=0,s=[];for(;i!==t.length;++i){if(t[i].trim()==="BOT"){s[++a]=[];n=0;continue}if(a<0)continue;var f=t[i].trim().split(",");var o=f[0],l=f[1];++i;var c=t[i].trim();switch(+o){case-1:if(c==="BOT"){s[++a]=[];n=0;continue}else if(c!=="EOD")throw new Error("Unrecognized DIF special command "+c);break;case 0:if(c==="TRUE")s[a][n]=true;else if(c==="FALSE")s[a][n]=false;else if(!isNaN(le(l)))s[a][n]=le(l);else if(!isNaN(ce(l).getDate()))s[a][n]=ie(l);else s[a][n]=l;++n;break;case 1:c=c.slice(1,c.length-1);s[a][n++]=c!==""?c:null;break;}if(c==="EOD")break}if(r&&r.sheetRows)s=s.slice(0,r.sheetRows);return s}function t(r,t){return wt(e(r,t),t)}function a(e,r){return mt(t(e,r),r)}var n=function(){var e=function t(e,r,a,n,i){e.push(r);e.push(a+","+n);e.push('"'+i.replace(/"/g,'""')+'"')};var r=function a(e,r,t,n){e.push(r+","+t);e.push(r==1?'"'+n.replace(/"/g,'""')+'"':n)};return function n(t){var a=[];var n=pt(t["!ref"]),i;var s=Array.isArray(t);e(a,"TABLE",0,1,"sheetjs");e(a,"VECTORS",0,n.e.r-n.s.r+1,"");e(a,"TUPLES",0,n.e.c-n.s.c+1,"");e(a,"DATA",0,0,"");for(var f=n.s.r;f<=n.e.r;++f){r(a,-1,0,"BOT");for(var o=n.s.c;o<=n.e.c;++o){var l=ht({r:f,c:o});i=s?(t[f]||[])[o]:t[l];if(!i){r(a,1,0,"");continue}switch(i.t){case"n":var c=g?i.w:i.v;if(!c&&i.v!=null)c=i.v;if(c==null){if(g&&i.f&&!i.F)r(a,1,0,"="+i.f);else r(a,1,0,"")}else r(a,0,c,"V");break;case"b":r(a,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":r(a,1,0,!g||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":if(!i.w)i.w=D.format(i.z||D._table[14],ee(ie(i.v)));if(g)r(a,0,i.w,"V");else r(a,1,0,i.w);break;default:r(a,1,0,"");}}}r(a,-1,0,"EOD");var h="\r\n";var u=a.join(h);return u}}();return{to_workbook:a,to_sheet:t,from_sheet:n}}();var tf=function(){function e(e){return e.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n")}function r(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function t(r,t){var a=r.split("\n"),n=-1,i=-1,s=0,f=[];for(;s!==a.length;++s){var o=a[s].trim().split(":");if(o[0]!=="cell")continue;var l=ct(o[1]);if(f.length<=l.r)for(n=f.length;n<=l.r;++n)if(!f[n])f[n]=[];n=l.r;i=l.c;switch(o[2]){case"t":f[n][i]=e(o[3]);break;case"v":f[n][i]=+o[3];break;case"vtf":var c=o[o.length-1];case"vtc":switch(o[3]){case"nl":f[n][i]=+o[4]?true:false;break;default:f[n][i]=+o[4];break;}if(o[2]=="vtf")f[n][i]=[f[n][i],c];}}if(t&&t.sheetRows)f=f.slice(0,t.sheetRows);return f}function a(e,r){return wt(t(e,r),r)}function n(e,r){return mt(a(e,r),r)}var i=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var s=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";var f=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var o="--SocialCalcSpreadsheetControlSave--";function l(e){if(!e||!e["!ref"])return"";var t=[],a=[],n,i="";var s=ut(e["!ref"]);var f=Array.isArray(e);for(var o=s.s.r;o<=s.e.r;++o){for(var l=s.s.c;l<=s.e.c;++l){i=ht({r:o,c:l});n=f?(e[o]||[])[l]:e[i];if(!n||n.v==null||n.t==="z")continue;a=["cell",i,"t"];switch(n.t){case"s":;case"str":a.push(r(n.v));break;case"n":if(!n.f){a[2]="v";a[3]=n.v}else{a[2]="vtf";a[3]="n";a[4]=n.v;a[5]=r(n.f)}break;case"b":a[2]="vt"+(n.f?"f":"c");a[3]="nl";a[4]=n.v?"1":"0";a[5]=r(n.f||(n.v?"TRUE":"FALSE"));break;case"d":var c=ee(ie(n.v));a[2]="vtc";a[3]="nd";a[4]=""+c;a[5]=n.w||D.format(n.z||D._table[14],c);break;case"e":continue;}t.push(a.join(":"))}}t.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1");t.push("valueformat:1:text-wiki");return t.join("\n")}function c(e){return[i,s,f,s,l(e),o].join("\n")}return{to_workbook:n,to_sheet:a,from_sheet:c}}();var af=function(){function e(e,r,t,a,n){if(n.raw)r[t][a]=e;else if(e==="TRUE")r[t][a]=true;else if(e==="FALSE")r[t][a]=false;else if(e===""){}else if(!isNaN(le(e)))r[t][a]=le(e);else if(!isNaN(ce(e).getDate()))r[t][a]=ie(e);else r[t][a]=e}function r(r,t){var a=t||{};var n=[];if(!r||r.length===0)return n;var i=r.split(/[\r\n]/);var s=i.length-1;while(s>=0&&i[s].length===0)--s;var f=10,o=0;var l=0;for(;l<=s;++l){o=i[l].indexOf(" ");if(o==-1)o=i[l].length;else o++;f=Math.max(f,o)}for(l=0;l<=s;++l){n[l]=[];var c=0;e(i[l].slice(0,f).trim(),n,l,c,a);for(c=1;c<=(i[l].length-f)/10+1;++c)e(i[l].slice(f+(c-1)*10,f+c*10).trim(),n,l,c,a)}if(a.sheetRows)n=n.slice(0,a.sheetRows);return n}var t={44:",",9:"\t",59:";"};var a={44:3,9:2,59:1};function n(e){var r={},n=false,i=0,s=0;for(;i<e.length;++i){if((s=e.charCodeAt(i))==34)n=!n;else if(!n&&s in t)r[s]=(r[s]||0)+1}s=[];for(i in r)if(r.hasOwnProperty(i)){s.push([r[i],i])}if(!s.length){r=a;for(i in r)if(r.hasOwnProperty(i)){s.push([r[i],i])}}s.sort(function(e,r){return e[0]-r[0]||a[e[1]]-a[r[1]]});return t[s.pop()[1]]}function i(e,r){var t=r||{};var a="";if(v!=null&&t.dense==null)t.dense=v;var i=t.dense?[]:{};var s={s:{c:0,r:0},e:{c:0,r:0}};if(e.slice(0,4)=="sep="&&e.charCodeAt(5)==10){a=e.charAt(4);e=e.slice(6)}else a=n(e.slice(0,1024));var f=0,o=0,l=0;var c=0,h=0,u=a.charCodeAt(0),d=false,p=0;e=e.replace(/\r\n/gm,"\n");var g=t.dateNF!=null?L(t.dateNF):null;function m(){var r=e.slice(c,h);var a={};if(r.charAt(0)=='"'&&r.charAt(r.length-1)=='"')r=r.slice(1,-1).replace(/""/g,'"');if(r.length===0)a.t="z";else if(t.raw){a.t="s";a.v=r}else if(r.trim().length===0){a.t="s";a.v=r}else if(r.charCodeAt(0)==61){if(r.charCodeAt(1)==34&&r.charCodeAt(r.length-1)==34){a.t="s";a.v=r.slice(2,-1).replace(/""/g,'"')}else if($l(r)){a.t="n";a.f=r.slice(1)}else{a.t="s";a.v=r}}else if(r=="TRUE"){a.t="b";a.v=true}else if(r=="FALSE"){a.t="b";a.v=false}else if(!isNaN(l=le(r))){a.t="n";if(t.cellText!==false)a.w=r;a.v=l}else if(!isNaN(ce(r).getDate())||g&&r.match(g)){a.z=t.dateNF||D._table[14];var n=0;if(g&&r.match(g)){r=M(r,t.dateNF,r.match(g)||[]);n=1}if(t.cellDates){a.t="d";a.v=ie(r,n)}else{a.t="n";a.v=ee(ie(r,n))}if(t.cellText!==false)a.w=D.format(a.z,a.v instanceof Date?ee(a.v):a.v);if(!t.cellNF)delete a.z}else{a.t="s";a.v=r}if(a.t=="z"){}else if(t.dense){if(!i[f])i[f]=[];i[f][o]=a}else i[ht({c:o,r:f})]=a;c=h+1;if(s.e.c<o)s.e.c=o;if(s.e.r<f)s.e.r=f;if(p==u)++o;else{o=0;++f;if(t.sheetRows&&t.sheetRows<=f)return true}}e:for(;h<e.length;++h)switch(p=e.charCodeAt(h)){case 34:d=!d;break;case u:;case 10:;case 13:if(!d&&m())break e;break;default:break;}if(h-c>0)m();i["!ref"]=dt(s);return i}function s(e,t){if(e.slice(0,4)=="sep=")return i(e,t);if(e.indexOf("\t")>=0||e.indexOf(",")>=0||e.indexOf(";")>=0)return i(e,t);return wt(r(e,t),t)}function f(e,r){var t="",a=r.type=="string"?[0,0,0,0]:cg(e,r);switch(r.type){case"base64":t=m.decode(e);break;case"binary":t=e;break;case"buffer":if(r.codepage==65001)t=e.toString("utf8");else if(r.codepage&&typeof cptable!=="undefined")t=cptable.utils.decode(r.codepage,e);else t=e.toString("binary");break;case"array":t=se(e);break;case"string":t=e;break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=ze(t.slice(3));else if(r.type=="binary"&&typeof cptable!=="undefined"&&r.codepage)t=cptable.utils.decode(r.codepage,cptable.utils.encode(1252,t));if(t.slice(0,19)=="socialcalc:version:")return tf.to_sheet(r.type=="string"?t:ze(t),r);return s(t,r)}function o(e,r){return mt(f(e,r),r)}function l(e){var r=[];var t=pt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){var s=[];for(var f=t.s.c;f<=t.e.c;++f){var o=ht({r:i,c:f});a=n?(e[i]||[])[f]:e[o];if(!a||a.v==null){s.push("          ");continue}var l=(a.w||(gt(a),a.w)||"").slice(0,10);while(l.length<10)l+=" ";s.push(l+(f===0?" ":""))}r.push(s.join(""))}return r.join("\n")}return{to_workbook:o,to_sheet:f,from_sheet:l}}();function nf(e,r){var t=r||{},a=!!t.WTF;t.WTF=true;try{var n=ef.to_workbook(e,t);t.WTF=a;return n}catch(i){t.WTF=a;if(!i.message.match(/SYLK bad record ID/)&&a)throw i;return af.to_workbook(e,r)}}var sf=function(){function e(e,r,t){if(!e)return;zr(e,e.l||0);var a=t.Enum||w;while(e.l<e.length){var n=e._R(2);var i=a[n]||a[255];var s=e._R(2);var f=e.l+s;var o=(i.f||Xr)(e,s,t);e.l=f;if(r(o,i.n,n))return}}function r(e,r){switch(r.type){case"base64":return t(A(m.decode(e)),r);case"binary":return t(A(e),r);case"buffer":;case"array":return t(e,r);}throw"Unsupported type "+r.type}function t(r,t){if(!r)return r;var a=t||{};if(v!=null&&a.dense==null)a.dense=v;var n=a.dense?[]:{},i="Sheet1",s=0;var f={},o=[i];var l={s:{r:0,c:0},e:{r:0,c:0}};var c=a.sheetRows||0;if(r[2]==2)a.Enum=w;else if(r[2]==26)a.Enum=C;else if(r[2]==14){a.Enum=C;a.qpro=true;r.l=0}else throw new Error("Unrecognized LOTUS BOF "+r[2]);e(r,function(e,t,h){if(r[2]==2)switch(h){case 0:a.vers=e;if(e>=4096)a.qpro=true;break;case 6:l=e;break;case 15:if(!a.qpro)e[1].v=e[1].v.slice(1);case 13:;case 14:;case 16:;case 51:if(h==14&&(e[2]&112)==112&&(e[2]&15)>1&&(e[2]&15)<15){e[1].z=a.dateNF||D._table[14];if(a.cellDates){e[1].t="d";e[1].v=re(e[1].v)}}if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[ht(e[0])]=e[1];break;}else switch(h){case 22:e[1].v=e[1].v.slice(1);case 23:;case 24:;case 25:;case 37:;case 39:;case 40:if(e[3]>s){n["!ref"]=dt(l);f[i]=n;n=a.dense?[]:{};l={s:{r:0,c:0},e:{r:0,c:0}};s=e[3];i="Sheet"+(s+1);o.push(i)}if(c>0&&e[0].r>=c)break;if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[ht(e[0])]=e[1];if(l.e.c<e[0].c)l.e.c=e[0].c;if(l.e.r<e[0].r)l.e.r=e[0].r;break;default:break;}},a);n["!ref"]=dt(l);f[i]=n;return{SheetNames:o,Sheets:f}}function a(e){var r={s:{c:0,r:0},e:{c:0,r:0}};r.s.c=e._R(2);r.s.r=e._R(2);r.e.c=e._R(2);r.e.r=e._R(2);if(r.s.c==65535)r.s.c=r.e.c=r.s.r=r.e.r=0;return r}function n(e,r,t){var a=[{c:0,r:0},{t:"n",v:0},0];if(t.qpro&&t.vers!=20768){a[0].c=e._R(1);e.l++;a[0].r=e._R(2);e.l+=2}else{a[2]=e._R(1);a[0].c=e._R(2);a[0].r=e._R(2)}return a}function i(e,r,t){var a=e.l+r;var i=n(e,r,t);i[1].t="s";if(t.vers==20768){e.l++;var s=e._R(1);i[1].v=e._R(s,"utf8");return i}if(t.qpro)e.l++;i[1].v=e._R(a-e.l,"cstr");return i}function s(e,r,t){var a=n(e,r,t);a[1].v=e._R(2,"i");return a}function f(e,r,t){var a=n(e,r,t);a[1].v=e._R(8,"f");return a}function o(e,r,t){var a=e.l+r;var i=n(e,r,t);i[1].v=e._R(8,"f");if(t.qpro)e.l=a;else{var s=e._R(2);e.l+=s}return i}function l(e){var r=[{c:0,r:0},{t:"n",v:0},0];r[0].r=e._R(2);r[3]=e[e.l++];r[0].c=e[e.l++];return r}function c(e,r){var t=l(e,r);t[1].t="s";t[1].v=e._R(r-4,"cstr");return t}function h(e,r){var t=l(e,r);t[1].v=e._R(2);var a=t[1].v>>1;if(t[1].v&1){switch(a&7){case 1:a=(a>>3)*500;break;case 2:a=(a>>3)/20;break;case 4:a=(a>>3)/2e3;break;case 6:a=(a>>3)/16;break;case 7:a=(a>>3)/64;break;default:throw"unknown NUMBER_18 encoding "+(a&7);}}t[1].v=a;return t}function u(e,r){var t=l(e,r);var a=e._R(4);var n=e._R(4);var i=e._R(2);if(i==65535){t[1].v=0;return t}var s=i&32768;i=(i&32767)-16446;t[1].v=(s*2-1)*((i>0?n<<i:n>>>-i)+(i>-32?a<<i+32:a>>>-(i+32)));return t}function d(e,r){var t=u(e,14);e.l+=r-14;return t}function p(e,r){var t=l(e,r);var a=e._R(4);t[1].v=a>>6;return t}function g(e,r){var t=l(e,r);var a=e._R(8,"f");t[1].v=a;return t}function b(e,r){var t=g(e,14);e.l+=r-10;return t}var w={0:{n:"BOF",f:Hn},1:{n:"EOF"},2:{n:"CALCMODE"},3:{n:"CALCORDER"},4:{n:"SPLIT"},5:{n:"SYNC"},6:{n:"RANGE",f:a},7:{n:"WINDOW1"},8:{n:"COLW1"},9:{n:"WINTWO"},10:{n:"COLW2"},11:{n:"NAME"},12:{n:"BLANK"},13:{n:"INTEGER",f:s},14:{n:"NUMBER",f:f},15:{n:"LABEL",f:i},16:{n:"FORMULA",f:o},24:{n:"TABLE"},25:{n:"ORANGE"},26:{n:"PRANGE"},27:{n:"SRANGE"},28:{n:"FRANGE"},29:{n:"KRANGE1"},32:{n:"HRANGE"},35:{n:"KRANGE2"},36:{n:"PROTEC"},37:{n:"FOOTER"},38:{n:"HEADER"},39:{n:"SETUP"},40:{n:"MARGINS"},41:{n:"LABELFMT"},42:{n:"TITLES"},43:{n:"SHEETJS"},45:{n:"GRAPH"},46:{n:"NGRAPH"},47:{n:"CALCCOUNT"},48:{n:"UNFORMATTED"},49:{n:"CURSORW12"},50:{n:"WINDOW"},51:{n:"STRING",f:i},55:{n:"PASSWORD"},56:{n:"LOCKED"},60:{n:"QUERY"},61:{n:"QUERYNAME"},62:{n:"PRINT"},63:{n:"PRINTNAME"},64:{n:"GRAPH2"},65:{n:"GRAPHNAME"},66:{n:"ZOOM"},67:{n:"SYMSPLIT"},68:{n:"NSROWS"},69:{n:"NSCOLS"},70:{n:"RULER"},71:{n:"NNAME"},72:{n:"ACOMM"},73:{n:"AMACRO"},74:{n:"PARSE"},255:{n:"",f:Xr}};var C={0:{n:"BOF"},1:{n:"EOF"},3:{n:"??"},4:{n:"??"},5:{n:"??"},6:{n:"??"},7:{n:"??"},9:{n:"??"},10:{n:"??"},11:{n:"??"},12:{n:"??"},14:{n:"??"},15:{n:"??"},16:{n:"??"},17:{n:"??"},18:{n:"??"},19:{n:"??"},21:{n:"??"},22:{n:"LABEL16",f:c},23:{n:"NUMBER17",f:u},24:{n:"NUMBER18",f:h},25:{n:"FORMULA19",f:d},26:{n:"??"},27:{n:"??"},28:{n:"??"},29:{n:"??"},30:{n:"??"},31:{n:"??"},33:{n:"??"},37:{n:"NUMBER25",f:p},39:{n:"NUMBER27",f:g},40:{n:"FORMULA28",f:b},255:{n:"",f:Xr}};return{to_workbook:r}}();var ff=function im(){var e=Ye("t"),r=Ye("rPr"),t=/<(?:\w+:)?r>/g,a=/<\/(?:\w+:)?r>/,n=/\r\n/g;var s=function o(e,r,t){var a={},n=65001,s="";var f=false;var o=e.match(_e),l=0;if(o)for(;l!=o.length;++l){var c=ye(o[l]);switch(c[0].replace(/\w*:/g,"")){case"<condense":break;case"<extend":break;case"<shadow":if(!c.val)break;case"<shadow>":;case"<shadow/>":a.shadow=1;break;case"</shadow>":break;case"<charset":if(c.val=="1")break;n=i[parseInt(c.val,10)];break;case"<outline":if(!c.val)break;case"<outline>":;case"<outline/>":a.outline=1;break;case"</outline>":break;case"<rFont":a.name=c.val;break;case"<sz":a.sz=c.val;break;case"<strike":if(!c.val)break;case"<strike>":;case"<strike/>":a.strike=1;break;case"</strike>":break;case"<u":if(!c.val)break;switch(c.val){case"double":a.uval="double";break;case"singleAccounting":a.uval="single-accounting";break;case"doubleAccounting":a.uval="double-accounting";break;};case"<u>":;case"<u/>":a.u=1;break;case"</u>":break;case"<b":if(c.val=="0")break;case"<b>":;case"<b/>":a.b=1;break;case"</b>":break;case"<i":if(c.val=="0")break;case"<i>":;case"<i/>":a.i=1;break;case"</i>":break;case"<color":if(c.rgb)a.color=c.rgb.slice(2,8);break;case"<family":a.family=c.val;break;case"<vertAlign":s=c.val;break;case"<scheme":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":f=true;break;case"</ext>":f=false;break;default:if(c[0].charCodeAt(1)!==47&&!f)throw new Error("Unrecognized rich format "+c[0]);}}var h=[];if(a.u)h.push("text-decoration: underline;");if(a.uval)h.push("text-underline-style:"+a.uval+";");if(a.sz)h.push("font-size:"+a.sz+"pt;");if(a.outline)h.push("text-effect: outline;");if(a.shadow)h.push("text-shadow: auto;");r.push('<span style="'+h.join("")+'">');if(a.b){r.push("<b>");t.push("</b>")}if(a.i){r.push("<i>");t.push("</i>")}if(a.strike){r.push("<s>");t.push("</s>")}if(s=="superscript")s="sup";else if(s=="subscript")s="sub";if(s!=""){r.push("<"+s+">");t.push("</"+s+">")}t.push("</span>");return n};function f(t){var a=[[],"",[]];var i=t.match(e);if(!i)return"";a[1]=i[1];var f=t.match(r);if(f)s(f[1],a[0],a[2]);return a[0].join("")+a[1].replace(n,"<br/>")+a[2].join("")}return function l(e){return e.replace(t,"").split(a).map(f).join("")}}();var of=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,lf=/<(?:\w+:)?r>/;var cf=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function hf(e,r){var t=r?r.cellHTML:true;var a={};if(!e)return null;if(e.match(/^\s*<(?:\w+:)?t[^>]*>/)){a.t=De(ze(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));a.r=ze(e);if(t)a.h=Me(a.t)}else if(e.match(lf)){a.r=ze(e);a.t=De(ze((e.replace(cf,"").match(of)||[]).join("").replace(_e,"")));if(t)a.h=ff(a.r)}return a}var uf=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var df=/<(?:\w+:)?(?:si|sstItem)>/g;var pf=/<\/(?:\w+:)?(?:si|sstItem)>/;function vf(e,r){var t=[],a="";if(!e)return t;var n=e.match(uf);if(n){a=n[2].replace(df,"").split(pf);for(var i=0;i!=a.length;++i){var s=hf(a[i].trim(),r);if(s!=null)t[t.length]=s}n=ye(n[1]);t.Count=n.count;t.Unique=n.uniqueCount}return t}Ra.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var gf=/^\s|\s$|[\t\n\r]/;function mf(e,r){if(!r.bookSST)return"";var t=[Se];t[t.length]=ar("sst",null,{xmlns:sr.main[0],count:e.Count,uniqueCount:e.Unique});for(var a=0;a!=e.length;++a){if(e[a]==null)continue;var n=e[a];var i="<si>";if(n.r)i+=n.r;else{i+="<t";if(!n.t)n.t="";if(n.t.match(gf))i+=' xml:space="preserve"';i+=">"+Pe(n.t)+"</t>"}i+="</si>";t[t.length]=i}if(t.length>2){t[t.length]="</sst>";t[1]=t[1].replace("/>",">")}return t.join("")}function bf(e){return[e._R(4),e._R(4)]}function wf(e,r){var t=[];var a=false;jr(e,function n(e,i,s){switch(s){case 159:t.Count=e[0];t.Unique=e[1];break;case 19:t.push(e);break;case 160:return true;case 35:a=true;break;case 36:a=false;break;default:if(i.indexOf("Begin")>0){}else if(i.indexOf("End")>0){}if(!a||r.WTF)throw new Error("Unexpected record "+s+" "+i);}});return t}function Cf(e,r){if(!r)r=Gr(8);r._W(4,e.Count);r._W(4,e.Unique);return r}var Ef=Bt;function kf(e){var r=Kr();Yr(r,"BrtBeginSst",Cf(e));for(var t=0;t<e.length;++t)Yr(r,"BrtSSTItem",Ef(e[t]));Yr(r,"BrtEndSst");return r.end()}function Sf(e){if(typeof cptable!=="undefined")return cptable.utils.encode(t,e);var r=[],a=e.split("");for(var n=0;n<a.length;++n)r[n]=a[n].charCodeAt(0);return r}function Af(e,r){var t={};t.Major=e._R(2);t.Minor=e._R(2);if(r>=4)e.l+=r-4;return t}function _f(e){var r={};r.id=e._R(0,"lpp4");r.R=Af(e,4);r.U=Af(e,4);r.W=Af(e,4);return r}function Bf(e){var r=e._R(4);var t=e.l+r-4;var a={};var n=e._R(4);var i=[];while(n-- >0)i.push({t:e._R(4),v:e._R(0,"lpp4")});a.name=e._R(0,"lpp4");a.comps=i;if(e.l!=t)throw new Error("Bad DataSpaceMapEntry: "+e.l+" != "+t);return a}function Tf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(Bf(e));return r}function yf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(e._R(0,"lpp4"));return r}function xf(e){var r={};e._R(4);e.l+=4;r.id=e._R(0,"lpp4");r.name=e._R(0,"lpp4");r.R=Af(e,4);r.U=Af(e,4);r.W=Af(e,4);return r}function If(e){var r=xf(e);r.ename=e._R(0,"8lpp4");r.blksz=e._R(4);r.cmode=e._R(4);if(e._R(4)!=4)throw new Error("Bad !Primary record");return r}function Rf(e,r){var t=e.l+r;var a={};a.Flags=e._R(4)&63;e.l+=4;a.AlgID=e._R(4);var n=false;switch(a.AlgID){case 26126:;case 26127:;case 26128:n=a.Flags==36;break;case 26625:n=a.Flags==4;break;case 0:n=a.Flags==16||a.Flags==4||a.Flags==36;break;default:throw"Unrecognized encryption algorithm: "+a.AlgID;}if(!n)throw new Error("Encryption Flags/AlgID mismatch");a.AlgIDHash=e._R(4);a.KeySize=e._R(4);a.ProviderType=e._R(4);e.l+=8;a.CSPName=e._R(t-e.l>>1,"utf16le");e.l=t;return a}function Df(e,r){var t={},a=e.l+r;e.l+=4;t.Salt=e.slice(e.l,e.l+16);e.l+=16;t.Verifier=e.slice(e.l,e.l+16);e.l+=16;e._R(4);t.VerifierHash=e.slice(e.l,a);e.l=a;return t}function Ff(e){var r=Af(e);switch(r.Minor){case 2:return[r.Minor,Of(e,r)];case 3:return[r.Minor,Pf(e,r)];case 4:return[r.Minor,Nf(e,r)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+r.Minor)}function Of(e){var r=e._R(4);if((r&63)!=36)throw new Error("EncryptionInfo mismatch");var t=e._R(4);var a=Rf(e,t);var n=Df(e,e.length-e.l);return{t:"Std",h:a,v:n}}function Pf(){throw new Error("File is password-protected: ECMA-376 Extensible")}function Nf(e){var r=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];e.l+=4;var t=e._R(e.length-e.l,"utf8");var a={};t.replace(_e,function n(e){var t=ye(e);switch(xe(t[0])){case"<?xml":break;case"<encryption":;case"</encryption>":break;case"<keyData":r.forEach(function(e){a[e]=t[e]});break;case"<dataIntegrity":a.encryptedHmacKey=t.encryptedHmacKey;a.encryptedHmacValue=t.encryptedHmacValue;break;case"<keyEncryptors>":;case"<keyEncryptors":a.encs=[];break;case"</keyEncryptors>":break;case"<keyEncryptor":a.uri=t.uri;break;case"</keyEncryptor>":break;case"<encryptedKey":a.encs.push(t);break;default:throw t[0];}});return a}function Lf(e,r){var t={};var a=t.EncryptionVersionInfo=Af(e,4);r-=4;if(a.Minor!=2)throw new Error("unrecognized minor version code: "+a.Minor);if(a.Major>4||a.Major<2)throw new Error("unrecognized major version code: "+a.Major);t.Flags=e._R(4);r-=4;var n=e._R(4);r-=4;t.EncryptionHeader=Rf(e,n);r-=n;t.EncryptionVerifier=Df(e,r);return t}function Mf(e){var r={};var t=r.EncryptionVersionInfo=Af(e,4);if(t.Major!=1||t.Minor!=1)throw"unrecognized version code "+t.Major+" : "+t.Minor;r.Salt=e._R(16);r.EncryptedVerifier=e._R(16);r.EncryptedVerifierHash=e._R(16);return r}function Uf(e){var r=0,t;var a=Sf(e);var n=a.length+1,i,s;var f,o,l;t=k(n);t[0]=a.length;for(i=1;i!=n;++i)t[i]=a[i-1];for(i=n-1;i>=0;--i){s=t[i];f=(r&16384)===0?0:1;o=r<<1&32767;l=f|o;r=l^s}return r^52811}var Hf=function(){var e=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0];var r=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163];var t=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628];var a=function(e){return(e/2|e*128)&255};var n=function(e,r){return a(e^r)};var i=function(e){var a=r[e.length-1];var n=104;for(var i=e.length-1;i>=0;--i){var s=e[i];for(var f=0;f!=7;++f){if(s&64)a^=t[n];s*=2;--n}}return a};return function(r){var t=Sf(r);var a=i(t);var s=t.length;var f=k(16);for(var o=0;o!=16;++o)f[o]=0;var l,c,h;if((s&1)===1){l=a>>8;f[s]=n(e[0],l);--s;l=a&255;c=t[t.length-1];f[s]=n(c,l)}while(s>0){--s;l=a>>8;f[s]=n(t[s],l);--s;l=a&255;f[s]=n(t[s],l)}s=15;h=15-t.length;while(h>0){l=a>>8;f[s]=n(e[h],l);--s;--h;l=a&255;f[s]=n(t[s],l);--s;--h}return f}}();var Wf=function(e,r,t,a,n){if(!n)n=r;if(!a)a=Hf(e);var i,s;for(i=0;i!=r.length;++i){s=r[i];s^=a[t];s=(s>>5|s<<3)&255;n[i]=s;++t}return[n,t,a]};var Vf=function(e){var r=0,t=Hf(e);return function(e){var a=Wf("",e,r,t);r=a[1];return a[0]}};function zf(e,r,t,a){var n={key:Hn(e),verificationBytes:Hn(e)};if(t.password)n.verifier=Uf(t.password);a.valid=n.verificationBytes===n.verifier;if(a.valid)a.insitu=Vf(t.password);return n}function Xf(e,r,t){var a=t||{};a.Info=e._R(2);e.l-=2;if(a.Info===1)a.Data=Mf(e,r);else a.Data=Lf(e,r);return a}function Gf(e,r,t){var a={Type:t.biff>=8?e._R(2):0};if(a.Type)Xf(e,r-2,a);else zf(e,t.biff>=8?r:r-2,t,a);return a}var jf=function(){function e(e,t){switch(t.type){case"base64":return r(m.decode(e),t);case"binary":return r(e,t);case"buffer":return r(e.toString("binary"),t);case"array":return r(se(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=r||{};var a=t.dense?[]:{};var n={s:{c:0,r:0},e:{c:0,r:0}};if(!e.match(/\\trowd/))throw new Error("RTF missing table");a["!ref"]=dt(n);return a}function t(r,t){return mt(e(r,t),t)}function a(e){var r=["{\\rtf1\\ansi"];var t=pt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){r.push("\\trowd\\trautofit1");for(var s=t.s.c;s<=t.e.c;++s)r.push("\\cellx"+(s+1));r.push("\\pard\\intbl");for(s=t.s.c;s<=t.e.c;++s){var f=ht({r:i,c:s});a=n?(e[i]||[])[s]:e[f];if(!a||a.v==null&&(!a.f||a.F))continue;r.push(" "+(a.w||(gt(a),a.w)));r.push("\\cell")}r.push("\\pard\\intbl\\row")}return r.join("")+"}"}return{to_workbook:t,to_sheet:e,from_sheet:a}}();function Kf(e){var r=e.slice(e[0]==="#"?1:0).slice(0,6);return[parseInt(r.slice(0,2),16),parseInt(r.slice(2,4),16),parseInt(r.slice(4,6),16)]}function Yf(e){for(var r=0,t=1;r!=3;++r)t=t*256+(e[r]>255?255:e[r]<0?0:e[r]);return t.toString(16).toUpperCase().slice(1)}function $f(e){var r=e[0]/255,t=e[1]/255,a=e[2]/255;var n=Math.max(r,t,a),i=Math.min(r,t,a),s=n-i;if(s===0)return[0,0,r];var f=0,o=0,l=n+i;o=s/(l>1?2-l:l);switch(n){case r:f=((t-a)/s+6)%6;break;case t:f=(a-r)/s+2;break;case a:f=(r-t)/s+4;break;}return[f/6,o,l/2]}function Zf(e){var r=e[0],t=e[1],a=e[2];var n=t*2*(a<.5?a:1-a),i=a-n/2;var s=[i,i,i],f=6*r;var o;if(t!==0)switch(f|0){case 0:;case 6:o=n*f;s[0]+=n;s[1]+=o;break;case 1:o=n*(2-f);s[0]+=o;s[1]+=n;break;case 2:o=n*(f-2);s[1]+=n;s[2]+=o;break;case 3:o=n*(4-f);s[1]+=o;s[2]+=n;break;case 4:o=n*(f-4);s[2]+=n;s[0]+=o;break;case 5:o=n*(6-f);s[2]+=o;s[0]+=n;break;}for(var l=0;l!=3;++l)s[l]=Math.round(s[l]*255);return s}function Qf(e,r){if(r===0)return e;var t=$f(Kf(e));if(r<0)t[2]=t[2]*(1+r);else t[2]=1-(1-t[2])*(1-r);return Yf(Zf(t))}var Jf=6,qf=15,eo=1,ro=Jf;function to(e){return Math.floor((e+Math.round(128/ro)/256)*ro)}function ao(e){return Math.floor((e-5)/ro*100+.5)/100}function no(e){return Math.round((e*ro+5)/ro*256)/256}function io(e){return no(ao(to(e)))}function so(e){
var r=Math.abs(e-io(e)),t=ro;if(r>.005)for(ro=eo;ro<qf;++ro)if(Math.abs(e-io(e))<=r){r=Math.abs(e-io(e));t=ro}ro=t}function fo(e){if(e.width){e.wpx=to(e.width);e.wch=ao(e.wpx);e.MDW=ro}else if(e.wpx){e.wch=ao(e.wpx);e.width=no(e.wch);e.MDW=ro}else if(typeof e.wch=="number"){e.width=no(e.wch);e.wpx=to(e.width);e.MDW=ro}if(e.customWidth)delete e.customWidth}var oo=96,lo=oo;function co(e){return e*96/lo}function ho(e){return e*lo/96}var uo={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};function po(e,r,t,a){r.Borders=[];var n={};var i=false;e[0].match(_e).forEach(function(e){var t=ye(e);switch(xe(t[0])){case"<borders":;case"<borders>":;case"</borders>":break;case"<border":;case"<border>":;case"<border/>":n={};if(t.diagonalUp){n.diagonalUp=t.diagonalUp}if(t.diagonalDown){n.diagonalDown=t.diagonalDown}r.Borders.push(n);break;case"</border>":break;case"<left/>":break;case"<left":;case"<left>":break;case"</left>":break;case"<right/>":break;case"<right":;case"<right>":break;case"</right>":break;case"<top/>":break;case"<top":;case"<top>":break;case"</top>":break;case"<bottom/>":break;case"<bottom":;case"<bottom>":break;case"</bottom>":break;case"<diagonal":;case"<diagonal>":;case"<diagonal/>":break;case"</diagonal>":break;case"<horizontal":;case"<horizontal>":;case"<horizontal/>":break;case"</horizontal>":break;case"<vertical":;case"<vertical>":;case"<vertical/>":break;case"</vertical>":break;case"<start":;case"<start>":;case"<start/>":break;case"</start>":break;case"<end":;case"<end>":;case"<end/>":break;case"</end>":break;case"<color":;case"<color>":break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in borders")};}})}function vo(e,r,t,a){r.Fills=[];var n={};var i=false;e[0].match(_e).forEach(function(e){var t=ye(e);switch(xe(t[0])){case"<fills":;case"<fills>":;case"</fills>":break;case"<fill>":;case"<fill":;case"<fill/>":n={};r.Fills.push(n);break;case"</fill>":break;case"<gradientFill>":break;case"<gradientFill":;case"</gradientFill>":r.Fills.push(n);n={};break;case"<patternFill":;case"<patternFill>":if(t.patternType)n.patternType=t.patternType;break;case"<patternFill/>":;case"</patternFill>":break;case"<bgColor":if(!n.bgColor)n.bgColor={};if(t.indexed)n.bgColor.indexed=parseInt(t.indexed,10);if(t.theme)n.bgColor.theme=parseInt(t.theme,10);if(t.tint)n.bgColor.tint=parseFloat(t.tint);if(t.rgb)n.bgColor.rgb=t.rgb.slice(-6);break;case"<bgColor/>":;case"</bgColor>":break;case"<fgColor":if(!n.fgColor)n.fgColor={};if(t.theme)n.fgColor.theme=parseInt(t.theme,10);if(t.tint)n.fgColor.tint=parseFloat(t.tint);if(t.rgb)n.fgColor.rgb=t.rgb.slice(-6);break;case"<fgColor/>":;case"</fgColor>":break;case"<stop":;case"<stop/>":break;case"</stop>":break;case"<color":;case"<color/>":break;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in fills")};}})}function go(e,r,t,a){r.Fonts=[];var n={};var s=false;e[0].match(_e).forEach(function(e){var f=ye(e);switch(xe(f[0])){case"<fonts":;case"<fonts>":;case"</fonts>":break;case"<font":;case"<font>":break;case"</font>":;case"<font/>":r.Fonts.push(n);n={};break;case"<name":if(f.val)n.name=f.val;break;case"<name/>":;case"</name>":break;case"<b":n.bold=f.val?Ve(f.val):1;break;case"<b/>":n.bold=1;break;case"<i":n.italic=f.val?Ve(f.val):1;break;case"<i/>":n.italic=1;break;case"<u":switch(f.val){case"none":n.underline=0;break;case"single":n.underline=1;break;case"double":n.underline=2;break;case"singleAccounting":n.underline=33;break;case"doubleAccounting":n.underline=34;break;}break;case"<u/>":n.underline=1;break;case"<strike":n.strike=f.val?Ve(f.val):1;break;case"<strike/>":n.strike=1;break;case"<outline":n.outline=f.val?Ve(f.val):1;break;case"<outline/>":n.outline=1;break;case"<shadow":n.shadow=f.val?Ve(f.val):1;break;case"<shadow/>":n.shadow=1;break;case"<condense":n.condense=f.val?Ve(f.val):1;break;case"<condense/>":n.condense=1;break;case"<extend":n.extend=f.val?Ve(f.val):1;break;case"<extend/>":n.extend=1;break;case"<sz":if(f.val)n.sz=+f.val;break;case"<sz/>":;case"</sz>":break;case"<vertAlign":if(f.val)n.vertAlign=f.val;break;case"<vertAlign/>":;case"</vertAlign>":break;case"<family":if(f.val)n.family=parseInt(f.val,10);break;case"<family/>":;case"</family>":break;case"<scheme":if(f.val)n.scheme=f.val;break;case"<scheme/>":;case"</scheme>":break;case"<charset":if(f.val=="1")break;f.codepage=i[parseInt(f.val,10)];break;case"<color":if(!n.color)n.color={};if(f.auto)n.color.auto=Ve(f.auto);if(f.rgb)n.color.rgb=f.rgb.slice(-6);else if(f.indexed){n.color.index=parseInt(f.indexed,10);var o=ka[n.color.index];if(n.color.index==81)o=ka[1];if(!o)throw new Error(e);n.color.rgb=o[0].toString(16)+o[1].toString(16)+o[2].toString(16)}else if(f.theme){n.color.theme=parseInt(f.theme,10);if(f.tint)n.color.tint=parseFloat(f.tint);if(f.theme&&t.themeElements&&t.themeElements.clrScheme){n.color.rgb=Qf(t.themeElements.clrScheme[n.color.theme].rgb,n.color.tint||0)}}break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":s=true;break;case"</ext>":s=false;break;default:if(a&&a.WTF){if(!s)throw new Error("unrecognized "+f[0]+" in fonts")};}})}function mo(e,r,t){r.NumberFmt=[];var a=j(D._table);for(var n=0;n<a.length;++n)r.NumberFmt[a[n]]=D._table[a[n]];var i=e[0].match(_e);if(!i)return;for(n=0;n<i.length;++n){var s=ye(i[n]);switch(xe(s[0])){case"<numFmts":;case"</numFmts>":;case"<numFmts/>":;case"<numFmts>":break;case"<numFmt":{var f=De(ze(s.formatCode)),o=parseInt(s.numFmtId,10);r.NumberFmt[o]=f;if(o>0){if(o>392){for(o=392;o>60;--o)if(r.NumberFmt[o]==null)break;r.NumberFmt[o]=f}D.load(f,o)}}break;case"</numFmt>":break;default:if(t.WTF)throw new Error("unrecognized "+s[0]+" in numFmts");}}}function bo(e){var r=["<numFmts>"];[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(e[a]!=null)r[r.length]=ar("numFmt",null,{numFmtId:a,formatCode:Pe(e[a])})});if(r.length===1)return"";r[r.length]="</numFmts>";r[0]=ar("numFmts",null,{count:r.length-2}).replace("/>",">");return r.join("")}var wo=["numFmtId","fillId","fontId","borderId","xfId"];var Co=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function Eo(e,r,t){r.CellXf=[];var a;var n=false;e[0].match(_e).forEach(function(e){var i=ye(e),s=0;switch(xe(i[0])){case"<cellXfs":;case"<cellXfs>":;case"<cellXfs/>":;case"</cellXfs>":break;case"<xf":;case"<xf/>":a=i;delete a[0];for(s=0;s<wo.length;++s)if(a[wo[s]])a[wo[s]]=parseInt(a[wo[s]],10);for(s=0;s<Co.length;++s)if(a[Co[s]])a[Co[s]]=Ve(a[Co[s]]);if(a.numFmtId>392){for(s=392;s>60;--s)if(r.NumberFmt[a.numFmtId]==r.NumberFmt[s]){a.numFmtId=s;break}}r.CellXf.push(a);break;case"</xf>":break;case"<alignment":;case"<alignment/>":var f={};if(i.vertical)f.vertical=i.vertical;if(i.horizontal)f.horizontal=i.horizontal;if(i.textRotation!=null)f.textRotation=i.textRotation;if(i.indent)f.indent=i.indent;if(i.wrapText)f.wrapText=i.wrapText;a.alignment=f;break;case"</alignment>":break;case"<protection":;case"</protection>":;case"<protection/>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(t&&t.WTF){if(!n)throw new Error("unrecognized "+i[0]+" in cellXfs")};}})}function ko(e){var r=[];r[r.length]=ar("cellXfs",null);e.forEach(function(e){r[r.length]=ar("xf",null,e)});r[r.length]="</cellXfs>";if(r.length===2)return"";r[0]=ar("cellXfs",null,{count:r.length-2}).replace("/>",">");return r.join("")}var So=function sm(){var e=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var r=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var t=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var a=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var n=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function i(s,f,o){var l={};if(!s)return l;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");var c;if(c=s.match(e))mo(c,l,o);if(c=s.match(a))go(c,l,f,o);if(c=s.match(t))vo(c,l,f,o);if(c=s.match(n))po(c,l,f,o);if(c=s.match(r))Eo(c,l,o);return l}}();var Ao=ar("styleSheet",null,{xmlns:sr.main[0],"xmlns:vt":sr.vt});Ra.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function _o(e,r){var t=[Se,Ao],a;if(e.SSF&&(a=bo(e.SSF))!=null)t[t.length]=a;t[t.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';t[t.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';t[t.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';t[t.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(a=ko(r.cellXfs))t[t.length]=a;t[t.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';t[t.length]='<dxfs count="0"/>';t[t.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(t.length>2){t[t.length]="</styleSheet>";t[1]=t[1].replace("/>",">")}return t.join("")}function Bo(e,r){var t=e._R(2);var a=Et(e,r-2);return[t,a]}function To(e,r,t){if(!t)t=Gr(6+4*r.length);t._W(2,e);kt(r,t);var a=t.length>t.l?t.slice(0,t.l):t;if(t.l==null)t.l=t.length;return a}function yo(e,r,t){var a={};a.sz=e._R(2)/20;var n=Zt(e,2,t);if(n.fCondense)a.condense=1;if(n.fExtend)a.extend=1;if(n.fShadow)a.shadow=1;if(n.fOutline)a.outline=1;if(n.fStrikeout)a.strike=1;if(n.fItalic)a.italic=1;var i=e._R(2);if(i===700)a.bold=1;switch(e._R(2)){case 1:a.vertAlign="superscript";break;case 2:a.vertAlign="subscript";break;}var s=e._R(1);if(s!=0)a.underline=s;var f=e._R(1);if(f>0)a.family=f;var o=e._R(1);if(o>0)a.charset=o;e.l++;a.color=Yt(e,8);switch(e._R(1)){case 1:a.scheme="major";break;case 2:a.scheme="minor";break;}a.name=Et(e,r-21);return a}function xo(e,r){if(!r)r=Gr(25+4*32);r._W(2,e.sz*20);Qt(e,r);r._W(2,e.bold?700:400);var t=0;if(e.vertAlign=="superscript")t=1;else if(e.vertAlign=="subscript")t=2;r._W(2,t);r._W(1,e.underline||0);r._W(1,e.family||0);r._W(1,e.charset||0);r._W(1,0);$t(e.color,r);var a=0;if(e.scheme=="major")a=1;if(e.scheme=="minor")a=2;r._W(1,a);kt(e.name,r);return r.length>r.l?r.slice(0,r.l):r}var Io=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var Ro=Y(Io);var Do=Xr;function Fo(e,r){if(!r)r=Gr(4*3+8*7+16*1);var t=Ro[e.patternType];if(t==null)t=40;r._W(4,t);var a=0;if(t!=40){$t({auto:1},r);$t({auto:1},r);for(;a<12;++a)r._W(4,0)}else{for(;a<4;++a)r._W(4,0);for(;a<12;++a)r._W(4,0)}return r.length>r.l?r.slice(0,r.l):r}function Oo(e,r){var t=e.l+r;var a=e._R(2);var n=e._R(2);e.l=t;return{ixfe:a,numFmtId:n}}function Po(e,r,t){if(!t)t=Gr(16);t._W(2,r||0);t._W(2,e.numFmtId||0);t._W(2,0);t._W(2,0);t._W(2,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);t._W(1,0);return t}function No(e,r){if(!r)r=Gr(10);r._W(1,0);r._W(1,0);r._W(4,0);r._W(4,0);return r}var Lo=Xr;function Mo(e,r){if(!r)r=Gr(51);r._W(1,0);No(null,r);No(null,r);No(null,r);No(null,r);No(null,r);return r.length>r.l?r.slice(0,r.l):r}function Uo(e,r){if(!r)r=Gr(12+4*10);r._W(4,e.xfId);r._W(2,1);r._W(1,+e.builtinId);r._W(1,0);Ot(e.name||"",r);return r.length>r.l?r.slice(0,r.l):r}function Ho(e,r,t){var a=Gr(4+256*2*4);a._W(4,e);Ot(r,a);Ot(t,a);return a.length>a.l?a.slice(0,a.l):a}function Wo(e,r,t){var a={};a.NumberFmt=[];for(var n in D._table)a.NumberFmt[n]=D._table[n];a.CellXf=[];a.Fonts=[];var i=[];var s=false;jr(e,function f(e,n,o){switch(o){case 44:a.NumberFmt[e[0]]=e[1];D.load(e[1],e[0]);break;case 43:a.Fonts.push(e);if(e.color.theme!=null&&r&&r.themeElements&&r.themeElements.clrScheme){e.color.rgb=Qf(r.themeElements.clrScheme[e.color.theme].rgb,e.color.tint||0)}break;case 1025:break;case 45:break;case 46:break;case 47:if(i[i.length-1]=="BrtBeginCellXFs"){a.CellXf.push(e)}break;case 48:;case 507:;case 572:;case 475:break;case 1171:;case 2102:;case 1130:;case 512:;case 2095:;case 3072:break;case 35:s=true;break;case 36:s=false;break;case 37:i.push(n);break;case 38:i.pop();break;default:if((n||"").indexOf("Begin")>0)i.push(n);else if((n||"").indexOf("End")>0)i.pop();else if(!s||t.WTF)throw new Error("Unexpected record "+o+" "+n);}});return a}function Vo(e,r){if(!r)return;var t=0;[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var a=e[0];a<=e[1];++a)if(r[a]!=null)++t});if(t==0)return;Yr(e,"BrtBeginFmts",Ct(t));[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(r[a]!=null)Yr(e,"BrtFmt",To(a,r[a]))});Yr(e,"BrtEndFmts")}function zo(e){var r=1;if(r==0)return;Yr(e,"BrtBeginFonts",Ct(r));Yr(e,"BrtFont",xo({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));Yr(e,"BrtEndFonts")}function Xo(e){var r=2;if(r==0)return;Yr(e,"BrtBeginFills",Ct(r));Yr(e,"BrtFill",Fo({patternType:"none"}));Yr(e,"BrtFill",Fo({patternType:"gray125"}));Yr(e,"BrtEndFills")}function Go(e){var r=1;if(r==0)return;Yr(e,"BrtBeginBorders",Ct(r));Yr(e,"BrtBorder",Mo({}));Yr(e,"BrtEndBorders")}function jo(e){var r=1;Yr(e,"BrtBeginCellStyleXFs",Ct(r));Yr(e,"BrtXF",Po({numFmtId:0,fontId:0,fillId:0,borderId:0},65535));Yr(e,"BrtEndCellStyleXFs")}function Ko(e,r){Yr(e,"BrtBeginCellXFs",Ct(r.length));r.forEach(function(r){Yr(e,"BrtXF",Po(r,0))});Yr(e,"BrtEndCellXFs")}function Yo(e){var r=1;Yr(e,"BrtBeginStyles",Ct(r));Yr(e,"BrtStyle",Uo({xfId:0,builtinId:0,name:"Normal"}));Yr(e,"BrtEndStyles")}function $o(e){var r=0;Yr(e,"BrtBeginDXFs",Ct(r));Yr(e,"BrtEndDXFs")}function Zo(e){var r=0;Yr(e,"BrtBeginTableStyles",Ho(r,"TableStyleMedium9","PivotStyleMedium4"));Yr(e,"BrtEndTableStyles")}function Qo(){return}function Jo(e,r){var t=Kr();Yr(t,"BrtBeginStyleSheet");Vo(t,e.SSF);zo(t,e);Xo(t,e);Go(t,e);jo(t,e);Ko(t,r.cellXfs);Yo(t,e);$o(t,e);Zo(t,e);Qo(t,e);Yr(t,"BrtEndStyleSheet");return t.end()}Ra.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";function qo(e,r,t){r.themeElements.clrScheme=[];var a={};(e[0].match(_e)||[]).forEach(function(e){var n=ye(e);switch(n[0]){case"<a:clrScheme":;case"</a:clrScheme>":break;case"<a:srgbClr":a.rgb=n.val;break;case"<a:sysClr":a.rgb=n.lastClr;break;case"<a:dk1>":;case"</a:dk1>":;case"<a:lt1>":;case"</a:lt1>":;case"<a:dk2>":;case"</a:dk2>":;case"<a:lt2>":;case"</a:lt2>":;case"<a:accent1>":;case"</a:accent1>":;case"<a:accent2>":;case"</a:accent2>":;case"<a:accent3>":;case"</a:accent3>":;case"<a:accent4>":;case"</a:accent4>":;case"<a:accent5>":;case"</a:accent5>":;case"<a:accent6>":;case"</a:accent6>":;case"<a:hlink>":;case"</a:hlink>":;case"<a:folHlink>":;case"</a:folHlink>":if(n[0].charAt(1)==="/"){r.themeElements.clrScheme.push(a);a={}}else{a.name=n[0].slice(3,n[0].length-1)}break;default:if(t&&t.WTF)throw new Error("Unrecognized "+n[0]+" in clrScheme");}})}function el(){}function rl(){}var tl=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var al=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var nl=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;function il(e,r,t){r.themeElements={};var a;[["clrScheme",tl,qo],["fontScheme",al,el],["fmtScheme",nl,rl]].forEach(function(n){if(!(a=e.match(n[1])))throw new Error(n[0]+" not found in themeElements");n[2](a,r,t)})}var sl=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function fl(e,r){if(!e||e.length===0)return fl(ol());var t;var a={};if(!(t=e.match(sl)))throw new Error("themeElements not found in theme");il(t[0],a,r);return a}function ol(e,r){if(r&&r.themeXLSX)return r.themeXLSX;var t=[Se];t[t.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';t[t.length]="<a:themeElements>";t[t.length]='<a:clrScheme name="Office">';t[t.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';t[t.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';t[t.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';t[t.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';t[t.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';t[t.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';t[t.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';t[t.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';t[t.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';t[t.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';t[t.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';t[t.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';t[t.length]="</a:clrScheme>";t[t.length]='<a:fontScheme name="Office">';t[t.length]="<a:majorFont>";t[t.length]='<a:latin typeface="Cambria"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Times New Roman"/>';t[t.length]='<a:font script="Hebr" typeface="Times New Roman"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="MoolBoran"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Times New Roman"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:majorFont>";t[t.length]="<a:minorFont>";t[t.length]='<a:latin typeface="Calibri"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Arial"/>';t[t.length]='<a:font script="Hebr" typeface="Arial"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="DaunPenh"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Arial"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:minorFont>";t[t.length]="</a:fontScheme>";t[t.length]='<a:fmtScheme name="Office">';t[t.length]="<a:fillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="1"/>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="0"/>';t[t.length]="</a:gradFill>";t[t.length]="</a:fillStyleLst>";t[t.length]="<a:lnStyleLst>";t[t.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]="</a:lnStyleLst>";t[t.length]="<a:effectStyleLst>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';t[t.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';t[t.length]="</a:effectStyle>";t[t.length]="</a:effectStyleLst>";t[t.length]="<a:bgFillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]="</a:bgFillStyleLst>";t[t.length]="</a:fmtScheme>";t[t.length]="</a:themeElements>";t[t.length]="<a:objectDefaults>";t[t.length]="<a:spDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';t[t.length]="</a:spDef>";t[t.length]="<a:lnDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';t[t.length]="</a:lnDef>";t[t.length]="</a:objectDefaults>";t[t.length]="<a:extraClrSchemeLst/>";t[t.length]="</a:theme>";return t.join("")}function ll(e,r,t){var a=e.l+r;var n=e._R(4);if(n===124226)return;if(!t.cellStyles||!Ee){e.l=a;return}var i=e.slice(e.l);e.l=a;var s;try{s=new Ee(i)}catch(f){return}var o=we(s,"theme/theme/theme1.xml",true);if(!o)return;return fl(o,t)}function cl(e){return e._R(4)}function hl(e){var r={};r.xclrType=e._R(2);r.nTintShade=e._R(2);switch(r.xclrType){case 0:e.l+=4;break;case 1:r.xclrValue=ul(e,4);break;case 2:r.xclrValue=ni(e,4);break;case 3:r.xclrValue=cl(e,4);break;case 4:e.l+=4;break;}e.l+=8;return r}function ul(e,r){return Xr(e,r)}function dl(e,r){return Xr(e,r)}function pl(e){var r=e._R(2);var t=e._R(2)-4;var a=[r];switch(r){case 4:;case 5:;case 7:;case 8:;case 9:;case 10:;case 11:;case 13:a[1]=hl(e,t);break;case 6:a[1]=dl(e,t);break;case 14:;case 15:a[1]=e._R(t===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+r+" "+t);}return a}function vl(e,r){var t=e.l+r;e.l+=2;var a=e._R(2);e.l+=2;var n=e._R(2);var i=[];while(n-- >0)i.push(pl(e,t-e.l));return{ixfe:a,ext:i}}function gl(e,r){r.forEach(function(e){switch(e[0]){case 4:break;case 5:break;case 6:break;case 7:break;case 8:break;case 9:break;case 10:break;case 11:break;case 13:break;case 14:break;case 15:break;}})}function ml(e){var r=[];if(!e)return r;var t=1;(e.match(_e)||[]).forEach(function(e){var a=ye(e);switch(a[0]){case"<?xml":break;case"<calcChain":;case"<calcChain>":;case"</calcChain>":break;case"<c":delete a[0];if(a.i)t=a.i;else a.i=t;r.push(a);break;}});return r}function bl(e){var r={};r.i=e._R(4);var t={};t.r=e._R(4);t.c=e._R(4);r.r=ht(t);var a=e._R(1);if(a&2)r.l="1";if(a&8)r.a="1";return r}function wl(e,r,t){var a=[];var n=false;jr(e,function i(e,r,s){switch(s){case 63:a.push(e);break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!n||t.WTF)throw new Error("Unexpected record "+s+" "+r);}});return a}function Cl(){}function El(e,r,t){if(!e)return e;var a=t||{};var n=false,i=false;jr(e,function s(e,r,t){if(i)return;switch(t){case 359:;case 363:;case 364:;case 366:;case 367:;case 368:;case 369:;case 370:;case 371:;case 472:;case 577:;case 578:;case 579:;case 580:;case 581:;case 582:;case 583:;case 584:;case 585:;case 586:;case 587:break;case 35:n=true;break;case 36:n=false;break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!n||a.WTF)throw new Error("Unexpected record "+t.toString(16)+" "+r);}},a)}Ra.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";Ra.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";function kl(e,r){if(!e)return"??";var t=(e.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return r["!id"][t].Target}var Sl=1024;function Al(e,r){var t=[21600,21600];var a=["m0,0l0",t[1],t[0],t[1],t[0],"0xe"].join(",");var n=[ar("xml",null,{"xmlns:v":fr.v,"xmlns:o":fr.o,"xmlns:x":fr.x,"xmlns:mv":fr.mv}).replace(/\/>/,">"),ar("o:shapelayout",ar("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),ar("v:shapetype",[ar("v:stroke",null,{joinstyle:"miter"}),ar("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:t.join(","),path:a})];while(Sl<e*1e3)Sl+=1e3;r.forEach(function(e){var r=ct(e[0]);n=n.concat(["<v:shape"+tr({id:"_x0000_s"+ ++Sl,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",ar("v:fill",ar("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}),{color2:"#BEFF82",angle:"-180",type:"gradient"}),ar("v:shadow",null,{on:"t",obscured:"t"}),ar("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",rr("x:Anchor",[r.c,0,r.r,0,r.c+3,100,r.r+5,100].join(",")),rr("x:AutoFill","False"),rr("x:Row",String(r.r)),rr("x:Column",String(r.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])});n.push("</xml>");return n.join("")}Ra.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function _l(e,r,t,a,n){for(var i=0;i!=r.length;++i){var s=r[i];var f=bp(be(e,s.replace(/^\//,""),true),s,n);if(!f||!f.length)continue;var o=j(t);for(var l=0;l!=o.length;++l){var c=o[l];var h=a[c];if(h){var u=h[s];if(u)Bl(c,t[c],f)}}}}function Bl(e,r,t){var a=Array.isArray(r);var n;t.forEach(function(e){var t=ct(e.ref);if(a){if(!r[t.r])r[t.r]=[];n=r[t.r][t.c]}else n=r[e.ref];if(!n){n={};if(a)r[t.r][t.c]=n;else r[e.ref]=n;var i=pt(r["!ref"]||"BDWGO1000001:A1");if(i.s.r>t.r)i.s.r=t.r;if(i.e.r<t.r)i.e.r=t.r;if(i.s.c>t.c)i.s.c=t.c;if(i.e.c<t.c)i.e.c=t.c;var s=dt(i);if(s!==r["!ref"])r["!ref"]=s}if(!n.c)n.c=[];var f={a:e.author,t:e.t,r:e.r};if(e.h)f.h=e.h;n.c.push(f)})}function Tl(e,r){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var t=[];var a=[];var n=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(n&&n[1])n[1].split(/<\/\w*:?author>/).forEach(function(e){if(e===""||e.trim()==="")return;var r=e.match(/<(?:\w+:)?author[^>]*>(.*)/);if(r)t.push(r[1])});var i=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(i&&i[1])i[1].split(/<\/\w*:?comment>/).forEach(function(e){if(e===""||e.trim()==="")return;var n=e.match(/<(?:\w+:)?comment[^>]*>/);if(!n)return;var i=ye(n[0]);var s={
author:i.authorId&&t[i.authorId]||"sheetjsghost",ref:i.ref,guid:i.guid};var f=ct(i.ref);if(r.sheetRows&&r.sheetRows<=f.r)return;var o=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var l=!!o&&!!o[1]&&hf(o[1])||{r:"",t:"",h:""};s.r=l.r;if(l.r=="<t></t>")l.t=l.h="";s.t=l.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(r.cellHTML)s.h=l.h;a.push(s)});return a}var yl=ar("comments",null,{xmlns:sr.main[0]});function xl(e){var r=[Se,yl];var t=[];r.push("<authors>");e.forEach(function(e){e[1].forEach(function(e){var a=Pe(e.a);if(t.indexOf(a)>-1)return;t.push(a);r.push("<author>"+a+"</author>")})});r.push("</authors>");r.push("<commentList>");e.forEach(function(e){e[1].forEach(function(a){r.push('<comment ref="'+e[0]+'" authorId="'+t.indexOf(Pe(a.a))+'"><text>');r.push(rr("t",a.t==null?"":Pe(a.t)));r.push("</text></comment>")})});r.push("</commentList>");if(r.length>2){r[r.length]="</comments>";r[1]=r[1].replace("/>",">")}return r.join("")}function Il(e){var r={};r.iauthor=e._R(4);var t=Vt(e,16);r.rfx=t.s;r.ref=ht(t.s);e.l+=16;return r}function Rl(e,r){if(r==null)r=Gr(36);r._W(4,e[1].iauthor);zt(e[0],r);r._W(4,0);r._W(4,0);r._W(4,0);r._W(4,0);return r}var Dl=Et;function Fl(e){return kt(e.slice(0,54))}function Ol(e,r){var t=[];var a=[];var n={};var i=false;jr(e,function s(e,f,o){switch(o){case 632:a.push(e);break;case 635:n=e;break;case 637:n.t=e.t;n.h=e.h;n.r=e.r;break;case 636:n.author=a[n.iauthor];delete n.iauthor;if(r.sheetRows&&r.sheetRows<=n.rfx.r)break;if(!n.t)n.t="";delete n.rfx;t.push(n);break;case 3072:break;case 35:i=true;break;case 36:i=false;break;case 37:break;case 38:break;default:if((f||"").indexOf("Begin")>0){}else if((f||"").indexOf("End")>0){}else if(!i||r.WTF)throw new Error("Unexpected record "+o+" "+f);}});return t}function Pl(e){var r=Kr();var t=[];Yr(r,"BrtBeginComments");Yr(r,"BrtBeginCommentAuthors");e.forEach(function(e){e[1].forEach(function(e){if(t.indexOf(e.a)>-1)return;t.push(e.a.slice(0,54));Yr(r,"BrtCommentAuthor",Fl(e.a))})});Yr(r,"BrtEndCommentAuthors");Yr(r,"BrtBeginCommentList");e.forEach(function(e){e[1].forEach(function(a){a.iauthor=t.indexOf(a.a);var n={s:ct(e[0]),e:ct(e[0])};Yr(r,"BrtBeginComment",Rl([n,a]));if(a.t&&a.t.length>0)Yr(r,"BrtCommentText",yt(a));Yr(r,"BrtEndComment");delete a.iauthor})});Yr(r,"BrtEndCommentList");Yr(r,"BrtEndComments");return r.end()}var Nl="application/vnd.ms-office.vbaProject";function Ll(e){var r=W.utils.cfb_new({root:"R"});e.FullPaths.forEach(function(t,a){if(t.slice(-1)==="/"||!t.match(/_VBA_PROJECT_CUR/))return;var n=t.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");W.utils.cfb_add(r,n,e.FileIndex[a].content)});return W.write(r)}function Ml(e,r){r.FullPaths.forEach(function(t,a){if(a==0)return;var n=t.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(n.slice(-1)!=="/")W.utils.cfb_add(e,n,r.FileIndex[a].content)})}var Ul=["xlsb","xlsm","xlam","biff8","xla"];Ra.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";Ra.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";function Hl(){return{"!type":"dialog"}}function Wl(){return{"!type":"dialog"}}function Vl(){return{"!type":"macro"}}function zl(){return{"!type":"macro"}}var Xl=function(){var e=/(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;var r={r:0,c:0};function t(e,t,a,n,i,s){var f=n.length>0?parseInt(n,10)|0:0,o=s.length>0?parseInt(s,10)|0:0;if(o<0&&i.length===0)o=0;var l=false,c=false;if(i.length>0||s.length==0)l=true;if(l)o+=r.c;else--o;if(a.length>0||n.length==0)c=true;if(c)f+=r.r;else--f;return t+(l?"":"$")+st(o)+(c?"":"$")+tt(f)}return function a(n,i){r=i;return n.replace(e,t)}}();var Gl=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;var jl=function(){return function e(r,t){return r.replace(Gl,function(e,r,a,n,i,s){var f=it(n)-(a?0:t.c);var o=rt(s)-(i?0:t.r);var l=o==0?"":!i?"["+o+"]":o+1;var c=f==0?"":!a?"["+f+"]":f+1;return r+"R"+l+"C"+c})}}();function Kl(e,r){return e.replace(Gl,function(e,t,a,n,i,s){return t+(a=="$"?a+n:st(it(n)+r.c))+(i=="$"?i+s:tt(rt(s)+r.r))})}function Yl(e,r,t){var a=ut(r),n=a.s,i=ct(t);var s={r:i.r-n.r,c:i.c-n.c};return Kl(e,s)}function $l(e){if(e.length==1)return false;return true}function Zl(e){return e.replace(/_xlfn\./g,"")}function Ql(e){e.l+=1;return}function Jl(e,r){var t=e._R(r==1?1:2);return[t&16383,t>>14&1,t>>15&1]}function ql(e,r,t){var a=2;if(t){if(t.biff>=2&&t.biff<=5)return ec(e,r,t);else if(t.biff==12)a=4}var n=e._R(a),i=e._R(a);var s=Jl(e,2);var f=Jl(e,2);return{s:{r:n,c:s[0],cRel:s[1],rRel:s[2]},e:{r:i,c:f[0],cRel:f[1],rRel:f[2]}}}function ec(e){var r=Jl(e,2),t=Jl(e,2);var a=e._R(1);var n=e._R(1);return{s:{r:r[0],c:a,cRel:r[1],rRel:r[2]},e:{r:t[0],c:n,cRel:t[1],rRel:t[2]}}}function rc(e,r,t){if(t.biff<8)return ec(e,r,t);var a=e._R(t.biff==12?4:2),n=e._R(t.biff==12?4:2);var i=Jl(e,2);var s=Jl(e,2);return{s:{r:a,c:i[0],cRel:i[1],rRel:i[2]},e:{r:n,c:s[0],cRel:s[1],rRel:s[2]}}}function tc(e,r,t){if(t&&t.biff>=2&&t.biff<=5)return ac(e,r,t);var a=e._R(t&&t.biff==12?4:2);var n=Jl(e,2);return{r:a,c:n[0],cRel:n[1],rRel:n[2]}}function ac(e){var r=Jl(e,2);var t=e._R(1);return{r:r[0],c:t,cRel:r[1],rRel:r[2]}}function nc(e){var r=e._R(2);var t=e._R(2);return{r:r,c:t&255,fQuoted:!!(t&16384),cRel:t>>15,rRel:t>>15}}function ic(e,r,t){var a=t&&t.biff?t.biff:8;if(a>=2&&a<=5)return sc(e,r,t);var n=e._R(a>=12?4:2);var i=e._R(2);var s=(i&16384)>>14,f=(i&32768)>>15;i&=16383;if(f==1)while(n>524287)n-=1048576;if(s==1)while(i>8191)i=i-16384;return{r:n,c:i,cRel:s,rRel:f}}function sc(e){var r=e._R(2);var t=e._R(1);var a=(r&32768)>>15,n=(r&16384)>>14;r&=16383;if(a==1&&r>=8192)r=r-16384;if(n==1&&t>=128)t=t-256;return{r:r,c:t,cRel:n,rRel:a}}function fc(e,r,t){var a=(e[e.l++]&96)>>5;var n=ql(e,t.biff>=2&&t.biff<=5?6:8,t);return[a,n]}function oc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2,"i");var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}var s=ql(e,i,t);return[a,n,s]}function lc(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t&&t.biff>8?12:t.biff<8?6:8;return[a]}function cc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}e.l+=i;return[a,n]}function hc(e,r,t){var a=(e[e.l++]&96)>>5;var n=rc(e,r-1,t);return[a,n]}function uc(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t.biff==2?6:t.biff==12?14:7;return[a]}function dc(e){var r=e[e.l+1]&1;var t=1;e.l+=4;return[r,t]}function pc(e,r,t){e.l+=2;var a=e._R(t&&t.biff==2?1:2);var n=[];for(var i=0;i<=a;++i)n.push(e._R(t&&t.biff==2?1:2));return n}function vc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function gc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function mc(e){var r=e[e.l+1]&255?1:0;e.l+=2;return[r,e._R(2)]}function bc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=t&&t.biff==2?3:4;return[a]}function wc(e){var r=e._R(1),t=e._R(1);return[r,t]}function Cc(e){e._R(2);return wc(e,2)}function Ec(e){e._R(2);return wc(e,2)}function kc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=tc(e,0,t);return[a,n]}function Sc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=ic(e,0,t);return[a,n]}function Ac(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(2);if(t&&t.biff==5)e.l+=12;var i=tc(e,0,t);return[a,n,i]}function _c(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(t&&t.biff<=3?1:2);return[Uh[n],Mh[n],a]}function Bc(e,r,t){var a=e[e.l++];var n=e._R(1),i=t&&t.biff<=3?[a==88?-1:0,e._R(1)]:Tc(e);return[n,(i[0]===0?Mh:Lh)[i[1]]]}function Tc(e){return[e[e.l+1]>>7,e._R(2)&32767]}function yc(e,r,t){e.l+=t&&t.biff==2?3:4;return}function xc(e,r,t){e.l++;if(t&&t.biff==12)return[e._R(4,"i"),0];var a=e._R(2);var n=e._R(t&&t.biff==2?1:2);return[a,n]}function Ic(e){e.l++;return jt[e._R(1)]}function Rc(e){e.l++;return e._R(2)}function Dc(e){e.l++;return e._R(1)!==0}function Fc(e){e.l++;return Xt(e,8)}function Oc(e,r,t){e.l++;return Gn(e,r-1,t)}function Pc(e,r){var t=[e._R(1)];if(r==12)switch(t[0]){case 2:t[0]=4;break;case 4:t[0]=16;break;case 0:t[0]=1;break;case 1:t[0]=2;break;}switch(t[0]){case 4:t[1]=Mn(e,1)?"TRUE":"FALSE";if(r!=12)e.l+=7;break;case 37:;case 16:t[1]=jt[e[e.l]];e.l+=r==12?4:8;break;case 0:e.l+=8;break;case 1:t[1]=Xt(e,8);break;case 2:t[1]=$n(e,0,{biff:r>0&&r<8?2:r});break;default:throw new Error("Bad SerAr: "+t[0]);}return t}function Nc(e,r,t){var a=e._R(t.biff==12?4:2);var n=[];for(var i=0;i!=a;++i)n.push((t.biff==12?Vt:di)(e,8));return n}function Lc(e,r,t){var a=0,n=0;if(t.biff==12){a=e._R(4);n=e._R(4)}else{n=1+e._R(1);a=1+e._R(2)}if(t.biff>=2&&t.biff<8){--a;if(--n==0)n=256}for(var i=0,s=[];i!=a&&(s[i]=[]);++i)for(var f=0;f!=n;++f)s[i][f]=Pc(e,t.biff);return s}function Mc(e,r,t){var a=e._R(1)>>>5&3;var n=!t||t.biff>=8?4:2;var i=e._R(n);switch(t.biff){case 2:e.l+=5;break;case 3:;case 4:e.l+=8;break;case 5:e.l+=12;break;}return[a,0,i]}function Uc(e,r,t){if(t.biff==5)return Hc(e,r,t);var a=e._R(1)>>>5&3;var n=e._R(2);var i=e._R(4);return[a,n,i]}function Hc(e){var r=e._R(1)>>>5&3;var t=e._R(2,"i");e.l+=8;var a=e._R(2);e.l+=12;return[r,t,a]}function Wc(e,r,t){var a=e._R(1)>>>5&3;e.l+=t&&t.biff==2?3:4;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function Vc(e,r,t){var a=e._R(1)>>>5&3;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function zc(e,r,t){var a=e._R(1)>>>5&3;e.l+=4;if(t.biff<8)e.l--;if(t.biff==12)e.l+=2;return[a]}function Xc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=4;if(t)switch(t.biff){case 5:i=15;break;case 12:i=6;break;}e.l+=i;return[a,n]}var Gc=Xr;var jc=Xr;var Kc=Xr;function Yc(e,r,t){e.l+=2;return[nc(e,4,t)]}function $c(e){e.l+=6;return[]}var Zc=Yc;var Qc=$c;var Jc=$c;var qc=Yc;function eh(e){e.l+=2;return[Hn(e),e._R(2)&1]}var rh=Yc;var th=eh;var ah=$c;var nh=Yc;var ih=Yc;var sh=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function fh(e){e.l+=2;var r=e._R(2);var t=e._R(2);var a=e._R(4);var n=e._R(2);var i=e._R(2);var s=sh[t>>2&31];return{ixti:r,coltype:t&3,rt:s,idx:a,c:n,C:i}}function oh(e){e.l+=2;return[e._R(4)]}function lh(e,r,t){e.l+=5;e.l+=2;e.l+=t.biff==2?1:4;return["PTGSHEET"]}function ch(e,r,t){e.l+=t.biff==2?4:5;return["PTGENDSHEET"]}function hh(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function uh(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function dh(e){e.l+=4;return[0,0]}var ph={1:{n:"PtgExp",f:xc},2:{n:"PtgTbl",f:Kc},3:{n:"PtgAdd",f:Ql},4:{n:"PtgSub",f:Ql},5:{n:"PtgMul",f:Ql},6:{n:"PtgDiv",f:Ql},7:{n:"PtgPower",f:Ql},8:{n:"PtgConcat",f:Ql},9:{n:"PtgLt",f:Ql},10:{n:"PtgLe",f:Ql},11:{n:"PtgEq",f:Ql},12:{n:"PtgGe",f:Ql},13:{n:"PtgGt",f:Ql},14:{n:"PtgNe",f:Ql},15:{n:"PtgIsect",f:Ql},16:{n:"PtgUnion",f:Ql},17:{n:"PtgRange",f:Ql},18:{n:"PtgUplus",f:Ql},19:{n:"PtgUminus",f:Ql},20:{n:"PtgPercent",f:Ql},21:{n:"PtgParen",f:Ql},22:{n:"PtgMissArg",f:Ql},23:{n:"PtgStr",f:Oc},26:{n:"PtgSheet",f:lh},27:{n:"PtgEndSheet",f:ch},28:{n:"PtgErr",f:Ic},29:{n:"PtgBool",f:Dc},30:{n:"PtgInt",f:Rc},31:{n:"PtgNum",f:Fc},32:{n:"PtgArray",f:uc},33:{n:"PtgFunc",f:_c},34:{n:"PtgFuncVar",f:Bc},35:{n:"PtgName",f:Mc},36:{n:"PtgRef",f:kc},37:{n:"PtgArea",f:fc},38:{n:"PtgMemArea",f:Wc},39:{n:"PtgMemErr",f:Gc},40:{n:"PtgMemNoMem",f:jc},41:{n:"PtgMemFunc",f:Vc},42:{n:"PtgRefErr",f:zc},43:{n:"PtgAreaErr",f:lc},44:{n:"PtgRefN",f:Sc},45:{n:"PtgAreaN",f:hc},46:{n:"PtgMemAreaN",f:hh},47:{n:"PtgMemNoMemN",f:uh},57:{n:"PtgNameX",f:Uc},58:{n:"PtgRef3d",f:Ac},59:{n:"PtgArea3d",f:oc},60:{n:"PtgRefErr3d",f:Xc},61:{n:"PtgAreaErr3d",f:cc},255:{}};var vh={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,78:46,110:46,79:47,111:47,88:34,120:34,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61};(function(){for(var e in vh)ph[e]=ph[vh[e]]})();var gh={1:{n:"PtgElfLel",f:eh},2:{n:"PtgElfRw",f:nh},3:{n:"PtgElfCol",f:Zc},6:{n:"PtgElfRwV",f:ih},7:{n:"PtgElfColV",f:qc},10:{n:"PtgElfRadical",f:rh},11:{n:"PtgElfRadicalS",f:ah},13:{n:"PtgElfColS",f:Qc},15:{n:"PtgElfColSV",f:Jc},16:{n:"PtgElfRadicalLel",f:th},25:{n:"PtgList",f:fh},29:{n:"PtgSxName",f:oh},255:{}};var mh={0:{n:"PtgAttrNoop",f:dh},1:{n:"PtgAttrSemi",f:bc},2:{n:"PtgAttrIf",f:gc},4:{n:"PtgAttrChoose",f:pc},8:{n:"PtgAttrGoto",f:vc},16:{n:"PtgAttrSum",f:yc},32:{n:"PtgAttrBaxcel",f:dc},64:{n:"PtgAttrSpace",f:Cc},65:{n:"PtgAttrSpaceSemi",f:Ec},128:{n:"PtgAttrIfError",f:mc},255:{}};mh[33]=mh[32];function bh(e,r,t,a){if(a.biff<8)return Xr(e,r);var n=e.l+r;var i=[];for(var s=0;s!==t.length;++s){switch(t[s][0]){case"PtgArray":t[s][1]=Lc(e,0,a);i.push(t[s][1]);break;case"PtgMemArea":t[s][2]=Nc(e,t[s][1],a);i.push(t[s][2]);break;case"PtgExp":if(a&&a.biff==12){t[s][1][1]=e._R(4);i.push(t[s][1])}break;case"PtgList":;case"PtgElfRadicalS":;case"PtgElfColS":;case"PtgElfColSV":throw"Unsupported "+t[s][0];default:break;}}r=n-e.l;if(r!==0)i.push(Xr(e,r));return i}function wh(e,r,t){var a=e.l+r;var n,i,s=[];while(a!=e.l){r=a-e.l;i=e[e.l];n=ph[i];if(i===24||i===25)n=(i===24?gh:mh)[e[e.l+1]];if(!n||!n.f){Xr(e,r)}else{s.push([n.n,n.f(e,r,t)])}}return s}function Ch(e){var r=[];for(var t=0;t<e.length;++t){var a=e[t],n=[];for(var i=0;i<a.length;++i){var s=a[i];if(s)switch(s[0]){case 2:n.push('"'+s[1].replace(/"/g,'""')+'"');break;default:n.push(s[1]);}else n.push("")}r.push(n.join(","))}return r.join(";")}var Eh={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};function kh(e,r){if(!e&&!(r&&r.biff<=5&&r.biff>=2))throw new Error("empty sheet name");if(e.indexOf(" ")>-1)return"'"+e+"'";return e}function Sh(e,r,t){if(!e)return"SH33TJSERR0";if(t.biff>8&&(!e.XTI||!e.XTI[r]))return e.SheetNames[r];if(!e.XTI)return"SH33TJSERR6";var a=e.XTI[r];if(t.biff<8){if(r>1e4)r-=65536;if(r<0)r=-r;return r==0?"":e.XTI[r-1]}if(!a)return"SH33TJSERR1";var n="";if(t.biff>8)switch(e[a[0]][0]){case 357:n=a[1]==-1?"#REF":e.SheetNames[a[1]];return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 358:if(t.SID!=null)return e.SheetNames[t.SID];return"SH33TJSSAME"+e[a[0]][0];case 355:;default:return"SH33TJSSRC"+e[a[0]][0];}switch(e[a[0]][0][0]){case 1025:n=a[1]==-1?"#REF":e.SheetNames[a[1]]||"SH33TJSERR3";return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 14849:return"SH33TJSERR8";default:if(!e[a[0]][0][3])return"SH33TJSERR2";n=a[1]==-1?"#REF":e[a[0]][0][3][a[1]]||"SH33TJSERR4";return a[1]==a[2]?n:n+":"+e[a[0]][0][3][a[2]];}}function Ah(e,r,t){return kh(Sh(e,r,t),t)}function _h(e,r,t,a,n){var i=n&&n.biff||8;var s={s:{c:0,r:0},e:{c:0,r:0}};var f=[],o,l,c,h=0,u=0,d,p="";if(!e[0]||!e[0][0])return"";var v=-1,g="";for(var m=0,b=e[0].length;m<b;++m){var w=e[0][m];switch(w[0]){case"PtgUminus":f.push("-"+f.pop());break;case"PtgUplus":f.push("+"+f.pop());break;case"PtgPercent":f.push(f.pop()+"%");break;case"PtgAdd":;case"PtgConcat":;case"PtgDiv":;case"PtgEq":;case"PtgGe":;case"PtgGt":;case"PtgLe":;case"PtgLt":;case"PtgMul":;case"PtgNe":;case"PtgPower":;case"PtgSub":o=f.pop();l=f.pop();if(v>=0){switch(e[0][v][1][0]){case 0:g=oe(" ",e[0][v][1][1]);break;case 1:g=oe("\r",e[0][v][1][1]);break;default:g="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][v][1][0]);}l=l+g;v=-1}f.push(l+Eh[w[0]]+o);break;case"PtgIsect":o=f.pop();l=f.pop();f.push(l+" "+o);break;case"PtgUnion":o=f.pop();l=f.pop();f.push(l+","+o);break;case"PtgRange":o=f.pop();l=f.pop();f.push(l+":"+o);break;case"PtgAttrChoose":break;case"PtgAttrGoto":break;case"PtgAttrIf":break;case"PtgAttrIfError":break;case"PtgRef":c=$r(w[1][1],s,n);f.push(Qr(c,i));break;case"PtgRefN":c=t?$r(w[1][1],t,n):w[1][1];f.push(Qr(c,i));break;case"PtgRef3d":h=w[1][1];c=$r(w[1][2],s,n);p=Ah(a,h,n);var C=p;f.push(p+"!"+Qr(c,i));break;case"PtgFunc":;case"PtgFuncVar":var E=w[1][0],k=w[1][1];if(!E)E=0;E&=127;var S=E==0?[]:f.slice(-E);f.length-=E;if(k==="User")k=S.shift();f.push(k+"("+S.join(",")+")");break;case"PtgBool":f.push(w[1]?"TRUE":"FALSE");break;case"PtgInt":f.push(w[1]);break;case"PtgNum":f.push(String(w[1]));break;case"PtgStr":f.push('"'+w[1]+'"');break;case"PtgErr":f.push(w[1]);break;case"PtgAreaN":d=Zr(w[1][1],t?{s:t}:s,n);f.push(Jr(d,n));break;case"PtgArea":d=Zr(w[1][1],s,n);f.push(Jr(d,n));break;case"PtgArea3d":h=w[1][1];d=w[1][2];p=Ah(a,h,n);f.push(p+"!"+Jr(d,n));break;case"PtgAttrSum":f.push("SUM("+f.pop()+")");break;case"PtgAttrBaxcel":;case"PtgAttrSemi":break;case"PtgName":u=w[1][2];var A=(a.names||[])[u-1]||(a[0]||[])[u];var _=A?A.Name:"SH33TJSNAME"+String(u);if(_ in Hh)_=Hh[_];f.push(_);break;case"PtgNameX":var B=w[1][1];u=w[1][2];var T;if(n.biff<=5){if(B<0)B=-B;if(a[B])T=a[B][u]}else{var y="";if(((a[B]||[])[0]||[])[0]==14849){}else if(((a[B]||[])[0]||[])[0]==1025){if(a[B][u]&&a[B][u].itab>0){y=a.SheetNames[a[B][u].itab-1]+"!"}}else y=a.SheetNames[u-1]+"!";if(a[B]&&a[B][u])y+=a[B][u].Name;else if(a[0]&&a[0][u])y+=a[0][u].Name;else y+="SH33TJSERRX";f.push(y);break}if(!T)T={Name:"SH33TJSERRY"};f.push(T.Name);break;case"PtgParen":var x="(",I=")";if(v>=0){g="";switch(e[0][v][1][0]){case 2:x=oe(" ",e[0][v][1][1])+x;break;case 3:x=oe("\r",e[0][v][1][1])+x;break;case 4:I=oe(" ",e[0][v][1][1])+I;break;case 5:I=oe("\r",e[0][v][1][1])+I;break;default:if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][v][1][0]);}v=-1}f.push(x+f.pop()+I);break;case"PtgRefErr":f.push("#REF!");break;case"PtgRefErr3d":f.push("#REF!");break;case"PtgExp":c={c:w[1][1],r:w[1][0]};var R={c:t.c,r:t.r};if(a.sharedf[ht(c)]){var D=a.sharedf[ht(c)];f.push(_h(D,s,R,a,n))}else{var F=false;for(o=0;o!=a.arrayf.length;++o){l=a.arrayf[o];if(c.c<l[0].s.c||c.c>l[0].e.c)continue;if(c.r<l[0].s.r||c.r>l[0].e.r)continue;f.push(_h(l[1],s,R,a,n));F=true;break}if(!F)f.push(w[1])}break;case"PtgArray":f.push("{"+Ch(w[1])+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":;case"PtgAttrSpaceSemi":v=m;break;case"PtgTbl":break;case"PtgMemErr":break;case"PtgMissArg":f.push("");break;case"PtgAreaErr":f.push("#REF!");break;case"PtgAreaErr3d":f.push("#REF!");break;case"PtgList":f.push("Table"+w[1].idx+"[#"+w[1].rt+"]");break;case"PtgMemAreaN":;case"PtgMemNoMemN":;case"PtgAttrNoop":;case"PtgSheet":;case"PtgEndSheet":break;case"PtgMemFunc":break;case"PtgMemNoMem":break;case"PtgElfCol":;case"PtgElfColS":;case"PtgElfColSV":;case"PtgElfColV":;case"PtgElfLel":;case"PtgElfRadical":;case"PtgElfRadicalLel":;case"PtgElfRadicalS":;case"PtgElfRw":;case"PtgElfRwV":throw new Error("Unsupported ELFs");case"PtgSxName":throw new Error("Unrecognized Formula Token: "+String(w));default:throw new Error("Unrecognized Formula Token: "+String(w));}var O=["PtgAttrSpace","PtgAttrSpaceSemi","PtgAttrGoto"];if(n.biff!=3)if(v>=0&&O.indexOf(e[0][m][0])==-1){w=e[0][v];var P=true;switch(w[1][0]){case 4:P=false;case 0:g=oe(" ",w[1][1]);break;case 5:P=false;case 1:g=oe("\r",w[1][1]);break;default:g="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+w[1][0]);}f.push((P?g:"")+f.pop()+(P?"":g));v=-1}}if(f.length>1&&n.WTF)throw new Error("bad formula stack");return f[0]}function Bh(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Xr(e,r-2)];var f=wh(e,s,t);if(r!==s+n)i=bh(e,r-s-n,f,t);e.l=a;return[f,i]}function Th(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Xr(e,r-2)];var f=wh(e,s,t);if(r!==s+n)i=bh(e,r-s-n,f,t);e.l=a;return[f,i]}function yh(e,r,t,a){var n=e.l+r;var i=wh(e,a,t);var s;if(n!==e.l)s=bh(e,n-e.l,i,t);return[i,s]}function xh(e,r,t){var a=e.l+r;var n,i=e._R(2);var s=wh(e,i,t);if(i==65535)return[[],Xr(e,r-2)];if(r!==i+2)n=bh(e,a-i-2,s,t);return[s,n]}function Ih(e){var r;if(Dr(e,e.l+6)!==65535)return[Xt(e),"n"];switch(e[e.l]){case 0:e.l+=8;return["String","s"];case 1:r=e[e.l+2]===1;e.l+=8;return[r,"b"];case 2:r=e[e.l+2];e.l+=8;return[r,"e"];case 3:e.l+=8;return["","s"];}return[]}function Rh(e,r,t){var a=e.l+r;var n=si(e,6);if(t.biff==2)++e.l;var i=Ih(e,8);var s=e._R(1);if(t.biff!=2){e._R(1);if(t.biff>=5){e._R(4)}}var f=Th(e,a-e.l,t);return{cell:n,val:i[0],formula:f,shared:s>>3&1,tt:i[1]}}function Dh(e,r,t){var a=e._R(4);var n=wh(e,a,t);var i=e._R(4);var s=i>0?bh(e,i,n,t):null;return[n,s]}var Fh=Dh;var Oh=Dh;var Ph=Dh;var Nh=Dh;var Lh={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var Mh={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",
305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"};var Uh={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};var Hh={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONCAT":"CONCAT","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORECAST.ETS":"FORECAST.ETS","_xlfn.FORECAST.ETS.CONFINT":"FORECAST.ETS.CONFINT","_xlfn.FORECAST.ETS.SEASONALITY":"FORECAST.ETS.SEASONALITY","_xlfn.FORECAST.ETS.STAT":"FORECAST.ETS.STAT","_xlfn.FORECAST.LINEAR":"FORECAST.LINEAR","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFERROR":"IFERROR","_xlfn.IFNA":"IFNA","_xlfn.IFS":"IFS","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MAXIFS":"MAXIFS","_xlfn.MINIFS":"MINIFS","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.SWITCH":"SWITCH","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.TEXTJOIN":"TEXTJOIN","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};function Wh(e){if(e.slice(0,3)=="of:")e=e.slice(3);if(e.charCodeAt(0)==61){e=e.slice(1);if(e.charCodeAt(0)==61)e=e.slice(1)}e=e.replace(/COM\.MICROSOFT\./g,"");e=e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function(e,r){return r.replace(/\./g,"")});e=e.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return e.replace(/[;~]/g,",").replace(/\|/g,";")}function Vh(e){var r="of:="+e.replace(Gl,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");return r.replace(/;/g,"|").replace(/,/g,";")}function zh(e){var r=e.split(":");var t=r[0].split(".")[0];return[t,r[0].split(".")[1]+(r.length>1?":"+(r[1].split(".")[1]||r[1].split(".")[0]):"")]}function Xh(e){return e.replace(/\./,"!")}var Gh={};var jh={};Ra.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];var Kh=typeof Map!=="undefined";function Yh(e,r,t){var a=0,n=e.length;if(t){if(Kh?t.has(r):t.hasOwnProperty(r)){var i=Kh?t.get(r):t[r];for(;a<i.length;++a){if(e[i[a]].t===r){e.Count++;return i[a]}}}}else for(;a<n;++a){if(e[a].t===r){e.Count++;return a}}e[n]={t:r};e.Count++;e.Unique++;if(t){if(Kh){if(!t.has(r))t.set(r,[]);t.get(r).push(n)}else{if(!t.hasOwnProperty(r))t[r]=[];t[r].push(n)}}return n}function $h(e,r){var t={min:e+1,max:e+1};var a=-1;if(r.MDW)ro=r.MDW;if(r.width!=null)t.customWidth=1;else if(r.wpx!=null)a=ao(r.wpx);else if(r.wch!=null)a=r.wch;if(a>-1){t.width=no(a);t.customWidth=1}else if(r.width!=null)t.width=r.width;if(r.hidden)t.hidden=true;return t}function Zh(e,r){if(!e)return;var t=[.7,.7,.75,.75,.3,.3];if(r=="xlml")t=[1,1,1,1,.5,.5];if(e.left==null)e.left=t[0];if(e.right==null)e.right=t[1];if(e.top==null)e.top=t[2];if(e.bottom==null)e.bottom=t[3];if(e.header==null)e.header=t[4];if(e.footer==null)e.footer=t[5]}function Qh(e,r,t){var a=t.revssf[r.z!=null?r.z:"General"];var n=60,i=e.length;if(a==null&&t.ssf){for(;n<392;++n)if(t.ssf[n]==null){D.load(r.z,n);t.ssf[n]=r.z;t.revssf[r.z]=a=n;break}}for(n=0;n!=i;++n)if(e[n].numFmtId===a)return n;e[i]={numFmtId:a,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return i}function Jh(e,r,t,a,n,i){if(e.t==="z")return;if(e.t==="d"&&typeof e.v==="string")e.v=ie(e.v);try{if(a.cellNF)e.z=D._table[r]}catch(s){if(a.WTF)throw s}if(!a||a.cellText!==false)try{if(D._table[r]==null)D.load(P[r]||"General",r);if(e.t==="e")e.w=e.w||jt[e.v];else if(r===0){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else if(e.t==="d"){var f=ee(e.v);if((f|0)===f)e.w=D._general_int(f);else e.w=D._general_num(f)}else if(e.v===undefined)return"";else e.w=D._general(e.v,jh)}else if(e.t==="d")e.w=D.format(r,ee(e.v),jh);else e.w=D.format(r,e.v,jh)}catch(s){if(a.WTF)throw s}if(!a.cellStyles)return;if(t!=null)try{e.s=i.Fills[t];if(e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb){e.s.fgColor.rgb=Qf(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0);if(a.WTF)e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb}if(e.s.bgColor&&e.s.bgColor.theme){e.s.bgColor.rgb=Qf(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0);if(a.WTF)e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb}}catch(s){if(a.WTF&&i.Fills)throw s}}function qh(e,r,t){if(e&&e["!ref"]){var a=pt(e["!ref"]);if(a.e.c<a.s.c||a.e.r<a.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}function eu(e,r){var t=pt(r);if(t.s.r<=t.e.r&&t.s.c<=t.e.c&&t.s.r>=0&&t.s.c>=0)e["!ref"]=dt(t)}var ru=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var tu=/<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;var au=/<(?:\w:)?hyperlink [^>]*>/gm;var nu=/"(\w*:\w*)"/;var iu=/<(?:\w:)?col\b[^>]*[\/]?>/g;var su=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var fu=/<(?:\w:)?pageMargins[^>]*\/>/g;var ou=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var lu=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function cu(e,r,t,a,n,i,s){if(!e)return e;if(v!=null&&r.dense==null)r.dense=v;var f=r.dense?[]:{};var o={s:{r:2e6,c:2e6},e:{r:0,c:0}};var l="",c="";var h=e.match(tu);if(h){l=e.slice(0,h.index);c=e.slice(h.index+h[0].length)}else l=c=e;var u=l.match(ou);if(u)uu(u[0],f,n,t);var d=(l.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(d>0){var p=l.slice(d,d+50).match(nu);if(p)eu(f,p[1])}var g=l.match(lu);if(g&&g[1])ku(g[1],n);var m=[];if(r.cellStyles){var b=l.match(iu);if(b)mu(m,b)}if(h)_u(h[1],f,r,o,i,s);var w=c.match(su);if(w)f["!autofilter"]=wu(w[0]);var C=[];var E=c.match(ru);if(E)for(d=0;d!=E.length;++d)C[d]=pt(E[d].slice(E[d].indexOf('"')+1));var k=c.match(au);if(k)pu(f,k,a);var S=c.match(fu);if(S)f["!margins"]=vu(ye(S[0]));if(!f["!ref"]&&o.e.c>=o.s.c&&o.e.r>=o.s.r)f["!ref"]=dt(o);if(r.sheetRows>0&&f["!ref"]){var A=pt(f["!ref"]);if(r.sheetRows<=+A.e.r){A.e.r=r.sheetRows-1;if(A.e.r>o.e.r)A.e.r=o.e.r;if(A.e.r<A.s.r)A.s.r=A.e.r;if(A.e.c>o.e.c)A.e.c=o.e.c;if(A.e.c<A.s.c)A.s.c=A.e.c;f["!fullref"]=f["!ref"];f["!ref"]=dt(A)}}if(m.length>0)f["!cols"]=m;if(C.length>0)f["!merges"]=C;return f}function hu(e){if(e.length===0)return"";var r='<mergeCells count="'+e.length+'">';for(var t=0;t!=e.length;++t)r+='<mergeCell ref="'+dt(e[t])+'"/>';return r+"</mergeCells>"}function uu(e,r,t,a){var n=ye(e);if(!t.Sheets[a])t.Sheets[a]={};if(n.codeName)t.Sheets[a].CodeName=n.codeName}function du(e){var r={sheet:1};var t=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var a=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];t.forEach(function(t){if(e[t]!=null&&e[t])r[t]="1"});a.forEach(function(t){if(e[t]!=null&&!e[t])r[t]="0"});if(e.password)r.password=Uf(e.password).toString(16).toUpperCase();return ar("sheetProtection",null,r)}function pu(e,r,t){var a=Array.isArray(e);for(var n=0;n!=r.length;++n){var i=ye(ze(r[n]),true);if(!i.ref)return;var s=((t||{})["!id"]||[])[i.id];if(s){i.Target=s.Target;if(i.location)i.Target+="#"+i.location}else{i.Target="#"+i.location;s={Target:i.Target,TargetMode:"Internal"}}i.Rel=s;if(i.tooltip){i.Tooltip=i.tooltip;delete i.tooltip}var f=pt(i.ref);for(var o=f.s.r;o<=f.e.r;++o)for(var l=f.s.c;l<=f.e.c;++l){var c=ht({c:l,r:o});if(a){if(!e[o])e[o]=[];if(!e[o][l])e[o][l]={t:"z",v:undefined};e[o][l].l=i}else{if(!e[c])e[c]={t:"z",v:undefined};e[c].l=i}}}}function vu(e){var r={};["left","right","top","bottom","header","footer"].forEach(function(t){if(e[t])r[t]=parseFloat(e[t])});return r}function gu(e){Zh(e);return ar("pageMargins",null,e)}function mu(e,r){var t=false;for(var a=0;a!=r.length;++a){var n=ye(r[a],true);if(n.hidden)n.hidden=Ve(n.hidden);var i=parseInt(n.min,10)-1,s=parseInt(n.max,10)-1;delete n.min;delete n.max;n.width=+n.width;if(!t&&n.width){t=true;so(n.width)}fo(n);while(i<=s)e[i++]=fe(n)}}function bu(e,r){var t=["<cols>"],a;for(var n=0;n!=r.length;++n){if(!(a=r[n]))continue;t[t.length]=ar("col",null,$h(n,a))}t[t.length]="</cols>";return t.join("")}function wu(e){var r={ref:(e.match(/ref="([^"]*)"/)||[])[1]};return r}function Cu(e,r,t,a){var n=typeof e.ref=="string"?e.ref:dt(e.ref);if(!t.Workbook)t.Workbook={};if(!t.Workbook.Names)t.Workbook.Names=[];var i=t.Workbook.Names;var s=ut(n);if(s.s.r==s.e.r){s.e.r=ut(r["!ref"]).e.r;n=dt(s)}for(var f=0;f<i.length;++f){var o=i[f];if(o.Name!="_xlnm._FilterDatabase")continue;if(o.Sheet!=a)continue;o.Ref="'"+t.SheetNames[a]+"'!"+n;break}if(f==i.length)i.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+t.SheetNames[a]+"'!"+n});return ar("autoFilter",null,{ref:n})}var Eu=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;function ku(e,r){(e.match(Eu)||[]).forEach(function(e){var t=ye(e);if(Ve(t.rightToLeft)){if(!r.Views)r.Views=[{}];if(!r.Views[0])r.Views[0]={};r.Views[0].RTL=true}})}function Su(e,r,t,a){var n={workbookViewId:"0"};if((((a||{}).Workbook||{}).Views||[])[0])n.rightToLeft=a.Workbook.Views[0].RTL?"1":"0";return ar("sheetViews",ar("sheetView",null,n),{})}function Au(e,r,t,a){if(e.v===undefined&&e.f===undefined||e.t==="z")return"";var n="";var i=e.t,s=e.v;switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=jt[e.v];break;case"d":if(a.cellDates)n=ie(e.v,-1).toISOString();else{e=fe(e);e.t="n";n=""+(e.v=ee(ie(e.v)))}if(typeof e.z==="undefined")e.z=D._table[14];break;default:n=e.v;break;}var f=rr("v",Pe(n)),o={r:r};var l=Qh(a.cellXfs,e,a);if(l!==0)o.s=l;switch(e.t){case"n":break;case"d":o.t="d";break;case"b":o.t="b";break;case"e":o.t="e";break;default:if(e.v==null){delete e.t;break}if(a.bookSST){f=rr("v",""+Yh(a.Strings,e.v,a.revStrings));o.t="s";break}o.t="str";break;}if(e.t!=i){e.t=i;e.v=s}if(e.f){var c=e.F&&e.F.slice(0,r.length)==r?{t:"array",ref:e.F}:null;f=ar("f",Pe(e.f),c)+(e.v!=null?f:"")}if(e.l)t["!links"].push([r,e.l]);if(e.c)t["!comments"].push([r,e.c]);return ar("c",f,o)}var _u=function(){var e=/<(?:\w+:)?c[ >]/,r=/<\/(?:\w+:)?row>/;var t=/r=["']([^"']*)["']/,a=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var n=/ref=["']([^"']*)["']/;var i=Ye("v"),s=Ye("f");return function f(o,l,c,h,u,d){var p=0,v="",g=[],m=[],b=0,w=0,C=0,E="",k;var S,A=0,_=0;var B,T;var y=0,x=0;var I=Array.isArray(d.CellXf),R;var F=[];var O=[];var P=Array.isArray(l);var N=[],L={},M=false;for(var U=o.split(r),H=0,W=U.length;H!=W;++H){v=U[H].trim();var V=v.length;if(V===0)continue;for(p=0;p<V;++p)if(v.charCodeAt(p)===62)break;++p;S=ye(v.slice(0,p),true);A=S.r!=null?parseInt(S.r,10):A+1;_=-1;if(c.sheetRows&&c.sheetRows<A)continue;if(h.s.r>A-1)h.s.r=A-1;if(h.e.r<A-1)h.e.r=A-1;if(c&&c.cellStyles){L={};M=false;if(S.ht){M=true;L.hpt=parseFloat(S.ht);L.hpx=ho(L.hpt)}if(S.hidden=="1"){M=true;L.hidden=true}if(S.outlineLevel!=null){M=true;L.level=+S.outlineLevel}if(M)N[A-1]=L}g=v.slice(p).split(e);for(p=0;p!=g.length;++p){v=g[p].trim();if(v.length===0)continue;m=v.match(t);b=p;w=0;C=0;v="<c "+(v.slice(0,1)=="<"?">":"")+v;if(m!=null&&m.length===2){b=0;E=m[1];for(w=0;w!=E.length;++w){if((C=E.charCodeAt(w)-64)<1||C>26)break;b=26*b+C}--b;_=b}else++_;for(w=0;w!=v.length;++w)if(v.charCodeAt(w)===62)break;++w;S=ye(v.slice(0,w),true);if(!S.r)S.r=ht({r:A-1,c:_});E=v.slice(w);k={t:""};if((m=E.match(i))!=null&&m[1]!=="")k.v=De(m[1]);if(c.cellFormula){if((m=E.match(s))!=null&&m[1]!==""){k.f=Zl(De(ze(m[1])));if(m[0].indexOf('t="array"')>-1){k.F=(E.match(n)||[])[1];if(k.F.indexOf(":")>-1)F.push([pt(k.F),k.F])}else if(m[0].indexOf('t="shared"')>-1){T=ye(m[0]);O[parseInt(T.si,10)]=[T,Zl(De(ze(m[1]))),S.r]}}else if(m=E.match(/<f[^>]*\/>/)){T=ye(m[0]);if(O[T.si])k.f=Yl(O[T.si][1],O[T.si][2],S.r)}var z=ct(S.r);for(w=0;w<F.length;++w)if(z.r>=F[w][0].s.r&&z.r<=F[w][0].e.r)if(z.c>=F[w][0].s.c&&z.c<=F[w][0].e.c)k.F=F[w][1]}if(S.t==null&&k.v===undefined){if(k.f||k.F){k.v=0;k.t="n"}else if(!c.sheetStubs)continue;else k.t="z"}else k.t=S.t||"n";if(h.s.c>_)h.s.c=_;if(h.e.c<_)h.e.c=_;switch(k.t){case"n":if(k.v==""||k.v==null){if(!c.sheetStubs)continue;k.t="z"}else k.v=parseFloat(k.v);break;case"s":if(typeof k.v=="undefined"){if(!c.sheetStubs)continue;k.t="z"}else{B=Gh[parseInt(k.v,10)];k.v=B.t;k.r=B.r;if(c.cellHTML)k.h=B.h}break;case"str":k.t="s";k.v=k.v!=null?ze(k.v):"";if(c.cellHTML)k.h=Me(k.v);break;case"inlineStr":m=E.match(a);k.t="s";if(m!=null&&(B=hf(m[1])))k.v=B.t;else k.v="";break;case"b":k.v=Ve(k.v);break;case"d":if(c.cellDates)k.v=ie(k.v,1);else{k.v=ee(ie(k.v,1));k.t="n"}break;case"e":if(!c||c.cellText!==false)k.w=k.v;k.v=Kt[k.v];break;}y=x=0;if(I&&S.s!==undefined){R=d.CellXf[S.s];if(R!=null){if(R.numFmtId!=null)y=R.numFmtId;if(c.cellStyles){if(R.fillId!=null)x=R.fillId}}}Jh(k,y,x,c,u,d);if(c.cellDates&&I&&k.t=="n"&&D.is_date(D._table[y])){k.t="d";k.v=re(k.v)}if(P){var X=ct(S.r);if(!l[X.r])l[X.r]=[];l[X.r][X.c]=k}else l[S.r]=k}}if(N.length>0)l["!rows"]=N}}();function Bu(e,r,t,a){var n=[],i=[],s=pt(e["!ref"]),f="",o,l="",c=[],h=0,u=0,d=e["!rows"];var p=Array.isArray(e);var v={r:l},g,m=-1;for(u=s.s.c;u<=s.e.c;++u)c[u]=st(u);for(h=s.s.r;h<=s.e.r;++h){i=[];l=tt(h);for(u=s.s.c;u<=s.e.c;++u){o=c[u]+l;var b=p?(e[h]||[])[u]:e[o];if(b===undefined)continue;if((f=Au(b,o,e,r,t,a))!=null)i.push(f)}if(i.length>0||d&&d[h]){v={r:l};if(d&&d[h]){g=d[h];if(g.hidden)v.hidden=1;m=-1;if(g.hpx)m=co(g.hpx);else if(g.hpt)m=g.hpt;if(m>-1){v.ht=m;v.customHeight=1}if(g.level){v.outlineLevel=g.level}}n[n.length]=ar("row",i.join(""),v)}}if(d)for(;h<d.length;++h){if(d&&d[h]){v={r:h+1};g=d[h];if(g.hidden)v.hidden=1;m=-1;if(g.hpx)m=co(g.hpx);else if(g.hpt)m=g.hpt;if(m>-1){v.ht=m;v.customHeight=1}if(g.level){v.outlineLevel=g.level}n[n.length]=ar("row","",v)}}return n.join("")}var Tu=ar("worksheet",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function yu(e,r,t,a){var n=[Se,Tu];var i=t.SheetNames[e],s=0,f="";var o=t.Sheets[i];if(o==null)o={};var l=o["!ref"]||"A1";var c=pt(l);if(c.e.c>16383||c.e.r>1048575){if(r.WTF)throw new Error("Range "+l+" exceeds format limit A1:XFD1048576");c.e.c=Math.min(c.e.c,16383);c.e.r=Math.min(c.e.c,1048575);l=dt(c)}if(!a)a={};o["!comments"]=[];o["!drawing"]=[];if(r.bookType!=="xlsx"&&t.vbaraw){var h=t.SheetNames[e];try{if(t.Workbook)h=t.Workbook.Sheets[e].CodeName||h}catch(u){}n[n.length]=ar("sheetPr",null,{codeName:Pe(h)})}n[n.length]=ar("dimension",null,{ref:l});n[n.length]=Su(o,r,e,t);if(r.sheetFormat)n[n.length]=ar("sheetFormatPr",null,{defaultRowHeight:r.sheetFormat.defaultRowHeight||"16",baseColWidth:r.sheetFormat.baseColWidth||"10",outlineLevelRow:r.sheetFormat.outlineLevelRow||"7"});if(o["!cols"]!=null&&o["!cols"].length>0)n[n.length]=bu(o,o["!cols"]);n[s=n.length]="<sheetData/>";o["!links"]=[];if(o["!ref"]!=null){f=Bu(o,r,e,t,a);if(f.length>0)n[n.length]=f}if(n.length>s+1){n[n.length]="</sheetData>";n[s]=n[s].replace("/>",">")}if(o["!protect"]!=null)n[n.length]=du(o["!protect"]);if(o["!autofilter"]!=null)n[n.length]=Cu(o["!autofilter"],o,t,e);if(o["!merges"]!=null&&o["!merges"].length>0)n[n.length]=hu(o["!merges"]);var d=-1,p,v=-1;if(o["!links"].length>0){n[n.length]="<hyperlinks>";o["!links"].forEach(function(e){if(!e[1].Target)return;p={ref:e[0]};if(e[1].Target.charAt(0)!="#"){v=Na(a,-1,Pe(e[1].Target).replace(/#.*$/,""),Ra.HLINK);p["r:id"]="rId"+v}if((d=e[1].Target.indexOf("#"))>-1)p.location=Pe(e[1].Target.slice(d+1));if(e[1].Tooltip)p.tooltip=Pe(e[1].Tooltip);n[n.length]=ar("hyperlink",null,p)});n[n.length]="</hyperlinks>"}delete o["!links"];if(o["!margins"]!=null)n[n.length]=gu(o["!margins"]);n[n.length]="";if(!r||r.ignoreEC||r.ignoreEC==void 0)n[n.length]=rr("ignoredErrors",ar("ignoredError",null,{numberStoredAsText:1,sqref:l}));if(o["!drawing"].length>0){v=Na(a,-1,"../drawings/drawing"+(e+1)+".xml",Ra.DRAW);n[n.length]=ar("drawing",null,{"r:id":"rId"+v})}else delete o["!drawing"];if(o["!comments"].length>0){v=Na(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",Ra.VML);n[n.length]=ar("legacyDrawing",null,{"r:id":"rId"+v});o["!legacy"]=v}if(n.length>2){n[n.length]="</worksheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function xu(e,r){var t={};var a=e.l+r;t.r=e._R(4);e.l+=4;var n=e._R(2);e.l+=1;var i=e._R(1);e.l=a;if(i&7)t.level=i&7;if(i&16)t.hidden=true;if(i&32)t.hpt=n/20;return t}function Iu(e,r,t){var a=Gr(17+8*16);var n=(t["!rows"]||[])[e]||{};a._W(4,e);a._W(4,0);var i=320;if(n.hpx)i=co(n.hpx)*20;else if(n.hpt)i=n.hpt*20;a._W(2,i);a._W(1,0);var s=0;if(n.level)s|=n.level;if(n.hidden)s|=16;if(n.hpx||n.hpt)s|=32;a._W(1,s);a._W(1,0);var f=0,o=a.l;a.l+=4;var l={r:e,c:0};for(var c=0;c<16;++c){if(r.s.c>c+1<<10||r.e.c<c<<10)continue;var h=-1,u=-1;for(var d=c<<10;d<c+1<<10;++d){l.c=d;var p=Array.isArray(t)?(t[l.r]||[])[l.c]:t[ht(l)];if(p){if(h<0)h=d;u=d}}if(h<0)continue;++f;a._W(4,h);a._W(4,u)}var v=a.l;a.l=o;a._W(4,f);a.l=v;return a.length>a.l?a.slice(0,a.l):a}function Ru(e,r,t,a){var n=Iu(a,t,r);if(n.length>17||(r["!rows"]||[])[a])Yr(e,"BrtRowHdr",n)}var Du=Vt;var Fu=zt;function Ou(){}function Pu(e,r){var t={};e.l+=19;t.name=Rt(e,r-19);return t}function Nu(e,r){if(r==null)r=Gr(84+4*e.length);for(var t=0;t<3;++t)r._W(1,0);$t({auto:1},r);r._W(-4,-1);r._W(-4,-1);Dt(e,r);return r.slice(0,r.l)}function Lu(e){var r=xt(e);return[r]}function Mu(e,r,t){if(t==null)t=Gr(8);return It(r,t)}function Uu(e){var r=xt(e);var t=e._R(1);return[r,t,"b"]}function Hu(e,r,t){if(t==null)t=Gr(9);It(r,t);t._W(1,e.v?1:0);return t}function Wu(e){var r=xt(e);var t=e._R(1);return[r,t,"e"]}function Vu(e){var r=xt(e);var t=e._R(4);return[r,t,"s"]}function zu(e,r,t){if(t==null)t=Gr(12);It(r,t);t._W(4,r.v);return t}function Xu(e){var r=xt(e);var t=Xt(e);return[r,t,"n"]}function Gu(e,r,t){if(t==null)t=Gr(16);It(r,t);Gt(e.v,t);return t}function ju(e){var r=xt(e);var t=Mt(e);return[r,t,"n"]}function Ku(e,r,t){if(t==null)t=Gr(12);It(r,t);Ut(e.v,t);return t}function Yu(e){var r=xt(e);var t=Et(e);return[r,t,"str"]}function $u(e,r,t){if(t==null)t=Gr(12+4*e.v.length);It(r,t);kt(e.v,t);return t.length>t.l?t.slice(0,t.l):t}function Zu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"b"];if(t.cellFormula){e.l+=2;var f=Oh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function Qu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"e"];if(t.cellFormula){e.l+=2;var f=Oh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function Ju(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=Xt(e);var s=[n,i,"n"];if(t.cellFormula){e.l+=2;var f=Oh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}function qu(e,r,t){var a=e.l+r;var n=xt(e);n.r=t["!row"];var i=Et(e);var s=[n,i,"str"];if(t.cellFormula){e.l+=2;var f=Oh(e,a-e.l,t);s[3]=_h(f,null,n,t.supbooks,t)}else e.l=a;return s}var ed=Vt;var rd=zt;function td(e,r){if(r==null)r=Gr(4);r._W(4,e);return r}function ad(e,r){var t=e.l+r;var a=Vt(e,16);var n=Ft(e);var i=Et(e);var s=Et(e);var f=Et(e);e.l=t;var o={rfx:a,relId:n,loc:i,display:f};if(s)o.Tooltip=s;return o}function nd(e,r){var t=Gr(50+4*(e[1].Target.length+(e[1].Tooltip||"").length));zt({s:ct(e[0]),e:ct(e[0])},t);Lt("rId"+r,t);var a=e[1].Target.indexOf("#");var n=a==-1?"":e[1].Target.slice(a+1);kt(n||"",t);kt(e[1].Tooltip||"",t);kt("",t);return t.slice(0,t.l)}function id(e,r,t){var a=e.l+r;var n=Ht(e,16);var i=e._R(1);var s=[n];s[2]=i;if(t.cellFormula){var f=Fh(e,a-e.l,t);s[1]=f}else e.l=a;return s}function sd(e,r,t){var a=e.l+r;var n=Vt(e,16);var i=[n];if(t.cellFormula){var s=Nh(e,a-e.l,t);i[1]=s;e.l=a}else e.l=a;return i}function fd(e,r,t){if(t==null)t=Gr(18);var a=$h(e,r);t._W(-4,e);t._W(-4,e);t._W(4,(a.width||10)*256);t._W(4,0);var n=0;if(r.hidden)n|=1;if(typeof a.width=="number")n|=2;t._W(1,n);t._W(1,0);return t}var od=["left","right","top","bottom","header","footer"];function ld(e){var r={};od.forEach(function(t){r[t]=Xt(e,8)});return r}function cd(e,r){if(r==null)r=Gr(6*8);Zh(e);od.forEach(function(t){Gt(e[t],r)});return r}function hd(e){var r=e._R(2);e.l+=28;return{RTL:r&32}}function ud(e,r,t){if(t==null)t=Gr(30);var a=924;if((((r||{}).Views||[])[0]||{}).RTL)a|=32;t._W(2,a);t._W(4,0);t._W(4,0);t._W(4,0);t._W(1,0);t._W(1,0);t._W(2,0);t._W(2,100);t._W(2,0);t._W(2,0);t._W(2,0);t._W(4,0);return t}function dd(e){var r=Gr(24);r._W(4,4);r._W(4,1);zt(e,r);return r}function pd(e,r){if(r==null)r=Gr(16*4+2);r._W(2,e.password?Uf(e.password):0);r._W(4,1);[["objects",false],["scenarios",false],["formatCells",true],["formatColumns",true],["formatRows",true],["insertColumns",true],["insertRows",true],["insertHyperlinks",true],["deleteColumns",true],["deleteRows",true],["selectLockedCells",false],["sort",true],["autoFilter",true],["pivotTables",true],["selectUnlockedCells",false]].forEach(function(t){if(t[1])r._W(4,e[t[0]]!=null&&!e[t[0]]?1:0);else r._W(4,e[t[0]]!=null&&e[t[0]]?0:1)});return r}function vd(e,r,t,a,n,i,s){if(!e)return e;var f=r||{};if(!a)a={"!id":{}};if(v!=null&&f.dense==null)f.dense=v;var o=f.dense?[]:{};var l;var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};var h=false,u=false;var d,p,g,m,b,w,C,E,k;var S=[];f.biff=12;f["!row"]=0;var A=0,_=false;var B=[];var T={};var y=f.supbooks||n.supbooks||[[]];y.sharedf=T;y.arrayf=B;y.SheetNames=n.SheetNames||n.Sheets.map(function(e){return e.name});if(!f.supbooks){f.supbooks=y;if(n.Names)for(var x=0;x<n.Names.length;++x)y[0][x+1]=n.Names[x]}var I=[],R=[];var F=false;jr(e,function P(e,r,v){if(u)return;switch(v){case 148:l=e;break;case 0:d=e;if(f.sheetRows&&f.sheetRows<=d.r)u=true;E=tt(m=d.r);f["!row"]=d.r;if(e.hidden||e.hpt||e.level!=null){if(e.hpt)e.hpx=ho(e.hpt);R[e.r]=e}break;case 2:;case 3:;case 4:;case 5:;case 6:;case 7:;case 8:;case 9:;case 10:;case 11:p={t:e[2]};switch(e[2]){case"n":p.v=e[1];break;case"s":C=Gh[e[1]];p.v=C.t;p.r=C.r;break;case"b":p.v=e[1]?true:false;break;case"e":p.v=e[1];if(f.cellText!==false)p.w=jt[p.v];break;case"str":p.t="s";p.v=e[1];break;}if(g=s.CellXf[e[0].iStyleRef])Jh(p,g.numFmtId,null,f,i,s);b=e[0].c;if(f.dense){if(!o[m])o[m]=[];o[m][b]=p}else o[st(b)+E]=p;if(f.cellFormula){_=false;for(A=0;A<B.length;++A){var x=B[A];if(d.r>=x[0].s.r&&d.r<=x[0].e.r)if(b>=x[0].s.c&&b<=x[0].e.c){p.F=dt(x[0]);_=true}}if(!_&&e.length>3)p.f=e[3]}if(c.s.r>d.r)c.s.r=d.r;if(c.s.c>b)c.s.c=b;if(c.e.r<d.r)c.e.r=d.r;if(c.e.c<b)c.e.c=b;if(f.cellDates&&g&&p.t=="n"&&D.is_date(D._table[g.numFmtId])){var O=D.parse_date_code(p.v);if(O){p.t="d";p.v=new Date(O.y,O.m-1,O.d,O.H,O.M,O.S,O.u)}}break;case 1:if(!f.sheetStubs||h)break;p={t:"z",v:undefined};b=e[0].c;if(f.dense){if(!o[m])o[m]=[];o[m][b]=p}else o[st(b)+E]=p;if(c.s.r>d.r)c.s.r=d.r;if(c.s.c>b)c.s.c=b;if(c.e.r<d.r)c.e.r=d.r;if(c.e.c<b)c.e.c=b;break;case 176:S.push(e);break;case 494:var P=a["!id"][e.relId];if(P){e.Target=P.Target;if(e.loc)e.Target+="#"+e.loc;e.Rel=P}else if(e.relId==""){e.Target="#"+e.loc}for(m=e.rfx.s.r;m<=e.rfx.e.r;++m)for(b=e.rfx.s.c;b<=e.rfx.e.c;++b){if(f.dense){if(!o[m])o[m]=[];if(!o[m][b])o[m][b]={t:"z",v:undefined};o[m][b].l=e}else{w=ht({c:b,r:m});if(!o[w])o[w]={t:"z",v:undefined};o[w].l=e}}break;case 426:if(!f.cellFormula)break;B.push(e);k=f.dense?o[m][b]:o[st(b)+E];k.f=_h(e[1],c,{r:d.r,c:b},y,f);k.F=dt(e[0]);break;case 427:if(!f.cellFormula)break;T[ht(e[0].s)]=e[1];k=f.dense?o[m][b]:o[st(b)+E];k.f=_h(e[1],c,{r:d.r,c:b},y,f);break;case 60:if(!f.cellStyles)break;while(e.e>=e.s){I[e.e--]={width:e.w/256,hidden:!!(e.flags&1)};if(!F){F=true;so(e.w/256)}fo(I[e.e+1])}break;case 161:o["!autofilter"]={ref:dt(e)};break;case 476:o["!margins"]=e;break;case 147:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 137:if(!n.Views)n.Views=[{}];if(!n.Views[0])n.Views[0]={};if(e.RTL)n.Views[0].RTL=true;break;case 485:break;case 175:;case 644:;case 625:;case 562:;case 396:;case 1112:;case 1146:;case 471:;case 1050:;case 649:;case 1105:;case 49:;case 589:;case 607:;case 564:;case 1055:;case 168:;case 174:;case 1180:;case 499:;case 64:;case 1053:;case 550:;case 171:;case 167:;case 1177:;case 169:;case 1181:;case 551:;case 552:;case 661:;case 639:;case 478:;case 151:;case 537:;case 477:;case 536:;case 1103:;case 680:;case 1104:;case 1024:;case 152:;case 663:;case 535:;case 678:;case 504:;case 1043:;case 428:;case 170:;case 3072:;case 50:;case 2070:;case 1045:break;case 35:h=true;break;case 36:h=false;break;case 37:break;case 38:break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!h||f.WTF)throw new Error("Unexpected record "+v+" "+r);}},f);delete f.supbooks;delete f["!row"];if(!o["!ref"]&&(c.s.r<2e6||l&&(l.e.r>0||l.e.c>0||l.s.r>0||l.s.c>0)))o["!ref"]=dt(l||c);if(f.sheetRows&&o["!ref"]){var O=pt(o["!ref"]);if(f.sheetRows<=+O.e.r){O.e.r=f.sheetRows-1;if(O.e.r>c.e.r)O.e.r=c.e.r;if(O.e.r<O.s.r)O.s.r=O.e.r;if(O.e.c>c.e.c)O.e.c=c.e.c;if(O.e.c<O.s.c)O.s.c=O.e.c;o["!fullref"]=o["!ref"];o["!ref"]=dt(O)}}if(S.length>0)o["!merges"]=S;if(I.length>0)o["!cols"]=I;if(R.length>0)o["!rows"]=R;return o}function gd(e,r,t,a,n,i){if(r.v===undefined)return"";var s="";switch(r.t){case"b":s=r.v?"1":"0";break;case"d":r=fe(r);r.z=r.z||D._table[14];r.v=ee(ie(r.v));r.t="n";break;case"n":;case"e":
s=""+r.v;break;default:s=r.v;break;}var f={r:t,c:a};f.s=Qh(n.cellXfs,r,n);if(r.l)i["!links"].push([ht(f),r.l]);if(r.c)i["!comments"].push([ht(f),r.c]);switch(r.t){case"s":;case"str":if(n.bookSST){s=Yh(n.Strings,r.v,n.revStrings);f.t="s";f.v=s;Yr(e,"BrtCellIsst",zu(r,f))}else{f.t="str";Yr(e,"BrtCellSt",$u(r,f))}return;case"n":if(r.v==(r.v|0)&&r.v>-1e3&&r.v<1e3)Yr(e,"BrtCellRk",Ku(r,f));else Yr(e,"BrtCellReal",Gu(r,f));return;case"b":f.t="b";Yr(e,"BrtCellBool",Hu(r,f));return;case"e":f.t="e";break;}Yr(e,"BrtCellBlank",Mu(r,f))}function md(e,r,t,a){var n=pt(r["!ref"]||"A1"),i,s="",f=[];Yr(e,"BrtBeginSheetData");var o=Array.isArray(r);var l=n.e.r;if(r["!rows"])l=Math.max(n.e.r,r["!rows"].length-1);for(var c=n.s.r;c<=l;++c){s=tt(c);Ru(e,r,n,c);if(c<=n.e.r)for(var h=n.s.c;h<=n.e.c;++h){if(c===n.s.r)f[h]=st(h);i=f[h]+s;var u=o?(r[c]||[])[h]:r[i];if(!u)continue;gd(e,u,c,h,a,r)}}Yr(e,"BrtEndSheetData")}function bd(e,r){if(!r||!r["!merges"])return;Yr(e,"BrtBeginMergeCells",td(r["!merges"].length));r["!merges"].forEach(function(r){Yr(e,"BrtMergeCell",rd(r))});Yr(e,"BrtEndMergeCells")}function wd(e,r){if(!r||!r["!cols"])return;Yr(e,"BrtBeginColInfos");r["!cols"].forEach(function(r,t){if(r)Yr(e,"BrtColInfo",fd(t,r))});Yr(e,"BrtEndColInfos")}function Cd(e,r){if(!r||!r["!ref"])return;Yr(e,"BrtBeginCellIgnoreECs");Yr(e,"BrtCellIgnoreEC",dd(pt(r["!ref"])));Yr(e,"BrtEndCellIgnoreECs")}function Ed(e,r,t){r["!links"].forEach(function(r){if(!r[1].Target)return;var a=Na(t,-1,r[1].Target.replace(/#.*$/,""),Ra.HLINK);Yr(e,"BrtHLink",nd(r,a))});delete r["!links"]}function kd(e,r,t,a){if(r["!comments"].length>0){var n=Na(a,-1,"../drawings/vmlDrawing"+(t+1)+".vml",Ra.VML);Yr(e,"BrtLegacyDrawing",Lt("rId"+n));r["!legacy"]=n}}function Sd(e,r){if(!r["!autofilter"])return;Yr(e,"BrtBeginAFilter",zt(pt(r["!autofilter"].ref)));Yr(e,"BrtEndAFilter")}function Ad(e,r,t){Yr(e,"BrtBeginWsViews");{Yr(e,"BrtBeginWsView",ud(r,t));Yr(e,"BrtEndWsView")}Yr(e,"BrtEndWsViews")}function _d(){}function Bd(e,r){if(!r["!protect"])return;Yr(e,"BrtSheetProtection",pd(r["!protect"]))}function Td(e,r,t,a){var n=Kr();var i=t.SheetNames[e],s=t.Sheets[i]||{};var f=i;try{if(t&&t.Workbook)f=t.Workbook.Sheets[e].CodeName||f}catch(o){}var l=pt(s["!ref"]||"A1");if(l.e.c>16383||l.e.r>1048575){if(r.WTF)throw new Error("Range "+(s["!ref"]||"A1")+" exceeds format limit A1:XFD1048576");l.e.c=Math.min(l.e.c,16383);l.e.r=Math.min(l.e.c,1048575)}s["!links"]=[];s["!comments"]=[];Yr(n,"BrtBeginSheet");if(t.vbaraw)Yr(n,"BrtWsProp",Nu(f));Yr(n,"BrtWsDim",Fu(l));Ad(n,s,t.Workbook);_d(n,s);wd(n,s,e,r,t);md(n,s,e,r,t);Bd(n,s);Sd(n,s);bd(n,s);Ed(n,s,a);if(s["!margins"])Yr(n,"BrtMargins",cd(s["!margins"]));if(!r||r.ignoreEC||r.ignoreEC==void 0)Cd(n,s);kd(n,s,e,a);Yr(n,"BrtEndSheet");return n.end()}function yd(e){var r=[];(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){var t=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!t)return;r[+t[1]]=+t[2]});var t=De((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);return[r,t]}function xd(e,r,t,a,n,i){var s=i||{"!type":"chart"};if(!e)return i;var f=0,o=0,l="A";var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=yd(e);c.s.r=c.s.c=0;c.e.c=f;l=st(f);r[0].forEach(function(e,t){s[l+tt(t)]={t:"n",v:e,z:r[1]};o=t});if(c.e.r<o)c.e.r=o;++f});if(f>0)s["!ref"]=dt(c);return s}Ra.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var Id=ar("chartsheet",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function Rd(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!chart":null,"!rel":""};var s;var f=e.match(ou);if(f)uu(f[0],i,n,t);if(s=e.match(/drawing r:id="(.*?)"/))i["!rel"]=s[1];if(a["!id"][i["!rel"]])i["!chart"]=a["!id"][i["!rel"]];return i}function Dd(e,r,t,a){var n=[Se,Id];n[n.length]=ar("drawing",null,{"r:id":"rId1"});Na(a,-1,"../drawings/drawing"+(e+1)+".xml",Ra.DRAW);if(n.length>2){n[n.length]="</chartsheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function Fd(e,r){e.l+=10;var t=Et(e,r-10);return{name:t}}function Od(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!chart":null,"!rel":""};var s=[];var f=false;jr(e,function o(e,a,l){switch(l){case 550:i["!rel"]=e;break;case 651:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 562:;case 652:;case 669:;case 679:;case 551:;case 552:;case 476:;case 3072:break;case 35:f=true;break;case 36:f=false;break;case 37:s.push(a);break;case 38:s.pop();break;default:if((a||"").indexOf("Begin")>0)s.push(a);else if((a||"").indexOf("End")>0)s.pop();else if(!f||r.WTF)throw new Error("Unexpected record "+l+" "+a);}},r);if(a["!id"][i["!rel"]])i["!chart"]=a["!id"][i["!rel"]];return i}function Pd(){var e=Kr();Yr(e,"BrtBeginSheet");Yr(e,"BrtEndSheet");return e.end()}var Nd=[["allowRefreshQuery",false,"bool"],["autoCompressPictures",true,"bool"],["backupFile",false,"bool"],["checkCompatibility",false,"bool"],["CodeName",""],["date1904",false,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",false,"bool"],["hidePivotFieldList",false,"bool"],["promptedSolutions",false,"bool"],["publishItems",false,"bool"],["refreshAllConnections",false,"bool"],["saveExternalLinkValues",true,"bool"],["showBorderUnselectedTables",true,"bool"],["showInkAnnotation",true,"bool"],["showObjects","all"],["showPivotChartFilter",false,"bool"],["updateLinks","userSet"]];var Ld=[["activeTab",0,"int"],["autoFilterDateGrouping",true,"bool"],["firstSheet",0,"int"],["minimized",false,"bool"],["showHorizontalScroll",true,"bool"],["showSheetTabs",true,"bool"],["showVerticalScroll",true,"bool"],["tabRatio",600,"int"],["visibility","visible"]];var Md=[];var Ud=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function Hd(e,r){for(var t=0;t!=e.length;++t){var a=e[t];for(var n=0;n!=r.length;++n){var i=r[n];if(a[i[0]]==null)a[i[0]]=i[1];else switch(i[2]){case"bool":if(typeof a[i[0]]=="string")a[i[0]]=Ve(a[i[0]]);break;case"int":if(typeof a[i[0]]=="string")a[i[0]]=parseInt(a[i[0]],10);break;}}}}function Wd(e,r){for(var t=0;t!=r.length;++t){var a=r[t];if(e[a[0]]==null)e[a[0]]=a[1];else switch(a[2]){case"bool":if(typeof e[a[0]]=="string")e[a[0]]=Ve(e[a[0]]);break;case"int":if(typeof e[a[0]]=="string")e[a[0]]=parseInt(e[a[0]],10);break;}}}function Vd(e){Wd(e.WBProps,Nd);Wd(e.CalcPr,Ud);Hd(e.WBView,Ld);Hd(e.Sheets,Md);jh.date1904=Ve(e.WBProps.date1904)}function zd(e){if(!e.Workbook)return"false";if(!e.Workbook.WBProps)return"false";return Ve(e.Workbook.WBProps.date1904)?"true":"false"}var Xd="][*?/\\".split("");function Gd(e,r){if(e.length>31){if(r)return false;throw new Error("Sheet names cannot exceed 31 chars")}var t=true;Xd.forEach(function(a){if(e.indexOf(a)==-1)return;if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");t=false});return t}function jd(e,r,t){e.forEach(function(a,n){Gd(a);for(var i=0;i<n;++i)if(a==e[i])throw new Error("Duplicate Sheet Name: "+a);if(t){var s=r&&r[n]&&r[n].CodeName||a;if(s.charCodeAt(0)==95&&s.length>22)throw new Error("Bad Code Name: Worksheet"+s)}})}function Kd(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var r=e.Workbook&&e.Workbook.Sheets||[];jd(e.SheetNames,r,!!e.vbaraw);for(var t=0;t<e.SheetNames.length;++t)qh(e.Sheets[e.SheetNames[t]],e.SheetNames[t],t)}var Yd=/<\w+:workbook/;function $d(e,r){if(!e)throw new Error("Could not find file");var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var a=false,n="xmlns";var i={},s=0;e.replace(_e,function f(o,l){var c=ye(o);switch(xe(c[0])){case"<?xml":break;case"<workbook":if(o.match(Yd))n="xmlns"+o.match(/<(\w+):/)[1];t.xmlns=c[n];break;case"</workbook>":break;case"<fileVersion":delete c[0];t.AppVersion=c;break;case"<fileVersion/>":;case"</fileVersion>":break;case"<fileSharing":;case"<fileSharing/>":break;case"<workbookPr":;case"<workbookPr/>":Nd.forEach(function(e){if(c[e[0]]==null)return;switch(e[2]){case"bool":t.WBProps[e[0]]=Ve(c[e[0]]);break;case"int":t.WBProps[e[0]]=parseInt(c[e[0]],10);break;default:t.WBProps[e[0]]=c[e[0]];}});if(c.codeName)t.WBProps.CodeName=c.codeName;break;case"</workbookPr>":break;case"<workbookProtection":break;case"<workbookProtection/>":break;case"<bookViews":;case"<bookViews>":;case"</bookViews>":break;case"<workbookView":;case"<workbookView/>":delete c[0];t.WBView.push(c);break;case"</workbookView>":break;case"<sheets":;case"<sheets>":;case"</sheets>":break;case"<sheet":switch(c.state){case"hidden":c.Hidden=1;break;case"veryHidden":c.Hidden=2;break;default:c.Hidden=0;}delete c.state;c.name=De(ze(c.name));delete c[0];t.Sheets.push(c);break;case"</sheet>":break;case"<functionGroups":;case"<functionGroups/>":break;case"<functionGroup":break;case"<externalReferences":;case"</externalReferences>":;case"<externalReferences>":break;case"<externalReference":break;case"<definedNames/>":break;case"<definedNames>":;case"<definedNames":a=true;break;case"</definedNames>":a=false;break;case"<definedName":{i={};i.Name=ze(c.name);if(c.comment)i.Comment=c.comment;if(c.localSheetId)i.Sheet=+c.localSheetId;if(Ve(c.hidden||"0"))i.Hidden=true;s=l+o.length}break;case"</definedName>":{i.Ref=De(ze(e.slice(s,l)));t.Names.push(i)}break;case"<definedName/>":break;case"<calcPr":delete c[0];t.CalcPr=c;break;case"<calcPr/>":delete c[0];t.CalcPr=c;break;case"</calcPr>":break;case"<oleSize":break;case"<customWorkbookViews>":;case"</customWorkbookViews>":;case"<customWorkbookViews":break;case"<customWorkbookView":;case"</customWorkbookView>":break;case"<pivotCaches>":;case"</pivotCaches>":;case"<pivotCaches":break;case"<pivotCache":break;case"<smartTagPr":;case"<smartTagPr/>":break;case"<smartTagTypes":;case"<smartTagTypes>":;case"</smartTagTypes>":break;case"<smartTagType":break;case"<webPublishing":;case"<webPublishing/>":break;case"<fileRecoveryPr":;case"<fileRecoveryPr/>":break;case"<webPublishObjects>":;case"<webPublishObjects":;case"</webPublishObjects>":break;case"<webPublishObject":break;case"<extLst":;case"<extLst>":;case"</extLst>":;case"<extLst/>":break;case"<ext":a=true;break;case"</ext>":a=false;break;case"<ArchID":break;case"<AlternateContent":;case"<AlternateContent>":a=true;break;case"</AlternateContent>":a=false;break;case"<revisionPtr":break;default:if(!a&&r.WTF)throw new Error("unrecognized "+c[0]+" in workbook");}return o});if(sr.main.indexOf(t.xmlns)===-1)throw new Error("Unknown Namespace: "+t.xmlns);Vd(t);return t}var Zd=ar("workbook",null,{xmlns:sr.main[0],"xmlns:r":sr.r});function Qd(e){var r=[Se];r[r.length]=Zd;var t=e.Workbook&&(e.Workbook.Names||[]).length>0;var a={codeName:"ThisWorkbook"};if(e.Workbook&&e.Workbook.WBProps){Nd.forEach(function(r){if(e.Workbook.WBProps[r[0]]==null)return;if(e.Workbook.WBProps[r[0]]==r[1])return;a[r[0]]=e.Workbook.WBProps[r[0]]});if(e.Workbook.WBProps.CodeName){a.codeName=e.Workbook.WBProps.CodeName;delete a.CodeName}}r[r.length]=ar("workbookPr",null,a);var n=e.Workbook&&e.Workbook.Sheets||[];var i=0;r[r.length]="<sheets>";for(i=0;i!=e.SheetNames.length;++i){var s={name:Pe(e.SheetNames[i].slice(0,31))};s.sheetId=""+(i+1);s["r:id"]="rId"+(i+1);if(n[i])switch(n[i].Hidden){case 1:s.state="hidden";break;case 2:s.state="veryHidden";break;}r[r.length]=ar("sheet",null,s)}r[r.length]="</sheets>";if(t){r[r.length]="<definedNames>";if(e.Workbook&&e.Workbook.Names)e.Workbook.Names.forEach(function(e){var t={name:e.Name};if(e.Comment)t.comment=e.Comment;if(e.Sheet!=null)t.localSheetId=""+e.Sheet;if(e.Hidden)t.hidden="1";if(!e.Ref)return;r[r.length]=ar("definedName",String(e.Ref).replace(/</g,"&lt;").replace(/>/g,"&gt;"),t)});r[r.length]="</definedNames>"}if(r.length>2){r[r.length]="</workbook>";r[1]=r[1].replace("/>",">")}return r.join("")}function Jd(e,r){var t={};t.Hidden=e._R(4);t.iTabID=e._R(4);t.strRelID=Nt(e,r-8);t.name=Et(e);return t}function qd(e,r){if(!r)r=Gr(127);r._W(4,e.Hidden);r._W(4,e.iTabID);Lt(e.strRelID,r);kt(e.name.slice(0,31),r);return r.length>r.l?r.slice(0,r.l):r}function ep(e,r){var t={};var a=e._R(4);t.defaultThemeVersion=e._R(4);var n=r>8?Et(e):"";if(n.length>0)t.CodeName=n;t.autoCompressPictures=!!(a&65536);t.backupFile=!!(a&64);t.checkCompatibility=!!(a&4096);t.date1904=!!(a&1);t.filterPrivacy=!!(a&8);t.hidePivotFieldList=!!(a&1024);t.promptedSolutions=!!(a&16);t.publishItems=!!(a&2048);t.refreshAllConnections=!!(a&262144);t.saveExternalLinkValues=!!(a&128);t.showBorderUnselectedTables=!!(a&4);t.showInkAnnotation=!!(a&32);t.showObjects=["all","placeholders","none"][a>>13&3];t.showPivotChartFilter=!!(a&32768);t.updateLinks=["userSet","never","always"][a>>8&3];return t}function rp(e,r){if(!r)r=Gr(72);var t=0;if(e){if(e.filterPrivacy)t|=8}r._W(4,t);r._W(4,0);Dt(e&&e.CodeName||"ThisWorkbook",r);return r.slice(0,r.l)}function tp(e,r){var t={};e._R(4);t.ArchID=e._R(4);e.l+=r-8;return t}function ap(e,r,t){var a=e.l+r;e.l+=4;e.l+=1;var n=e._R(4);var i=Pt(e);var s=Ph(e,0,t);var f=Ft(e);e.l=a;var o={Name:i,Ptg:s};if(n<268435455)o.Sheet=n;if(f)o.Comment=f;return o}function np(e,r){var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var a=[];var n=false;if(!r)r={};r.biff=12;var i=[];var s=[[]];s.SheetNames=[];s.XTI=[];jr(e,function f(e,o,l){switch(l){case 156:s.SheetNames.push(e.name);t.Sheets.push(e);break;case 153:t.WBProps=e;break;case 39:if(e.Sheet!=null)r.SID=e.Sheet;e.Ref=_h(e.Ptg,null,null,s,r);delete r.SID;delete e.Ptg;i.push(e);break;case 1036:break;case 357:;case 358:;case 355:;case 667:if(!s[0].length)s[0]=[l,e];else s.push([l,e]);s[s.length-1].XTI=[];break;case 362:if(s.length===0){s[0]=[];s[0].XTI=[]}s[s.length-1].XTI=s[s.length-1].XTI.concat(e);s.XTI=s.XTI.concat(e);break;case 361:break;case 3072:;case 3073:;case 2071:;case 534:;case 677:;case 158:;case 157:;case 610:;case 2050:;case 155:;case 548:;case 676:;case 128:;case 665:;case 2128:;case 2125:;case 549:;case 2053:;case 596:;case 2076:;case 2075:;case 2082:;case 397:;case 154:;case 1117:;case 553:;case 2091:break;case 35:a.push(o);n=true;break;case 36:a.pop();n=false;break;case 37:a.push(o);n=true;break;case 38:a.pop();n=false;break;case 16:break;default:if((o||"").indexOf("Begin")>0){}else if((o||"").indexOf("End")>0){}else if(!n||r.WTF&&a[a.length-1]!="BrtACBegin"&&a[a.length-1]!="BrtFRTBegin")throw new Error("Unexpected record "+l+" "+o);}},r);Vd(t);t.Names=i;t.supbooks=s;return t}function ip(e,r){Yr(e,"BrtBeginBundleShs");for(var t=0;t!=r.SheetNames.length;++t){var a=r.Workbook&&r.Workbook.Sheets&&r.Workbook.Sheets[t]&&r.Workbook.Sheets[t].Hidden||0;var n={Hidden:a,iTabID:t+1,strRelID:"rId"+(t+1),name:r.SheetNames[t]};Yr(e,"BrtBundleSh",qd(n))}Yr(e,"BrtEndBundleShs")}function sp(r,t){if(!t)t=Gr(127);for(var a=0;a!=4;++a)t._W(4,0);kt("SheetJS",t);kt(e.version,t);kt(e.version,t);kt("7262",t);t.length=t.l;return t.length>t.l?t.slice(0,t.l):t}function fp(e,r){if(!r)r=Gr(29);r._W(-4,0);r._W(-4,460);r._W(4,28800);r._W(4,17600);r._W(4,500);r._W(4,e);r._W(4,e);var t=120;r._W(1,t);return r.length>r.l?r.slice(0,r.l):r}function op(e,r){if(!r.Workbook||!r.Workbook.Sheets)return;var t=r.Workbook.Sheets;var a=0,n=-1,i=-1;for(;a<t.length;++a){if(!t[a]||!t[a].Hidden&&n==-1)n=a;else if(t[a].Hidden==1&&i==-1)i=a}if(i>n)return;Yr(e,"BrtBeginBookViews");Yr(e,"BrtBookView",fp(n));Yr(e,"BrtEndBookViews")}function lp(e,r){var t=Kr();Yr(t,"BrtBeginBook");Yr(t,"BrtFileVersion",sp());Yr(t,"BrtWbProp",rp(e.Workbook&&e.Workbook.WBProps||null));op(t,e,r);ip(t,e,r);Yr(t,"BrtEndBook");return t.end()}function cp(e,r,t){if(r.slice(-4)===".bin")return np(e,t);return $d(e,t)}function hp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return vd(e,a,t,n,i,s,f);return cu(e,a,t,n,i,s,f)}function up(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Od(e,a,t,n,i,s,f);return Rd(e,a,t,n,i,s,f)}function dp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Vl(e,a,t,n,i,s,f);return zl(e,a,t,n,i,s,f)}function pp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Hl(e,a,t,n,i,s,f);return Wl(e,a,t,n,i,s,f)}function vp(e,r,t,a){if(r.slice(-4)===".bin")return Wo(e,t,a);return So(e,t,a)}function gp(e,r,t){return fl(e,t)}function mp(e,r,t){if(r.slice(-4)===".bin")return wf(e,t);return vf(e,t)}function bp(e,r,t){if(r.slice(-4)===".bin")return Ol(e,t);return Tl(e,t)}function wp(e,r,t){if(r.slice(-4)===".bin")return wl(e,r,t);return ml(e,r,t)}function Cp(e,r,t){if(r.slice(-4)===".bin")return El(e,r,t);return Cl(e,r,t)}function Ep(e,r,t){return(r.slice(-4)===".bin"?lp:Qd)(e,t)}function kp(e,r,t,a,n){return(r.slice(-4)===".bin"?Td:yu)(e,t,a,n)}function Sp(e,r,t,a,n){return(r.slice(-4)===".bin"?Pd:Dd)(e,t,a,n)}function Ap(e,r,t){return(r.slice(-4)===".bin"?Jo:_o)(e,t)}function _p(e,r,t){return(r.slice(-4)===".bin"?kf:mf)(e,t)}function Bp(e,r,t){return(r.slice(-4)===".bin"?Pl:xl)(e,t)}var Tp=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var yp=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;var xp=function(e){return String.fromCharCode(e)};function Ip(e,r){var t=e.split(/\s+/);var a=[];if(!r)a[0]=t[0];if(t.length===1)return a;var n=e.match(Tp),i,s,f,o;if(n)for(o=0;o!=n.length;++o){i=n[o].match(yp);if((s=i[1].indexOf(":"))===-1)a[i[1]]=i[2].slice(1,i[2].length-1);else{if(i[1].slice(0,6)==="xmlns:")f="xmlns"+i[1].slice(6);else f=i[1].slice(s+1);a[f]=i[2].slice(1,i[2].length-1)}}return a}function Rp(e){var r=e.split(/\s+/);var t={};if(r.length===1)return t;var a=e.match(Tp),n,i,s,f;if(a)for(f=0;f!=a.length;++f){n=a[f].match(yp);if((i=n[1].indexOf(":"))===-1)t[n[1]]=n[2].slice(1,n[2].length-1);else{if(n[1].slice(0,6)==="xmlns:")s="xmlns"+n[1].slice(6);else s=n[1].slice(i+1);t[s]=n[2].slice(1,n[2].length-1)}}return t}function Dp(e,r){var t=O[e]||De(e);if(t==="General")return D._general(r);return D.format(t,r)}function Fp(e,r,t,a){var n=a;switch((t[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":n=Ve(a);break;case"i2":;case"int":n=parseInt(a,10);break;case"r4":;case"float":n=parseFloat(a);break;case"date":;case"dateTime.tz":n=ie(a);break;case"i8":;case"string":;case"fixed":;case"uuid":;case"bin.base64":break;default:throw new Error("bad custprop:"+t[0]);}e[De(r)]=n}function Op(e,r,t){if(e.t==="z")return;if(!t||t.cellText!==false)try{if(e.t==="e"){e.w=e.w||jt[e.v]}else if(r==="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=Dp(r||"General",e.v)}catch(a){if(t.WTF)throw a}try{var n=O[r]||r||"General";if(t.cellNF)e.z=n;if(t.cellDates&&e.t=="n"&&D.is_date(n)){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}catch(a){if(t.WTF)throw a}}function Pp(e,r,t){if(t.cellStyles){if(r.Interior){var a=r.Interior;if(a.Pattern)a.patternType=uo[a.Pattern]||a.Pattern}}e[r.ID]=r}function Np(e,r,t,a,n,i,s,f,o,l){var c="General",h=a.StyleID,u={};l=l||{};var d=[];var p=0;if(h===undefined&&f)h=f.StyleID;if(h===undefined&&s)h=s.StyleID;while(i[h]!==undefined){if(i[h].nf)c=i[h].nf;if(i[h].Interior)d.push(i[h].Interior);if(!i[h].Parent)break;h=i[h].Parent}switch(t.Type){case"Boolean":a.t="b";a.v=Ve(e);break;case"String":a.t="s";a.r=He(De(e));a.v=e.indexOf("<")>-1?De(r):a.r;break;case"DateTime":if(e.slice(-1)!="Z")e+="Z";a.v=(ie(e)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1e3);if(a.v!==a.v)a.v=De(e);else if(a.v<60)a.v=a.v-1;if(!c||c=="General")c="yyyy-mm-dd";case"Number":if(a.v===undefined)a.v=+e;if(!a.t)a.t="n";break;case"Error":a.t="e";a.v=Kt[e];if(l.cellText!==false)a.w=e;break;default:a.t="s";a.v=He(r||e);break;}Op(a,c,l);if(l.cellFormula!==false){if(a.Formula){var v=De(a.Formula);if(v.charCodeAt(0)==61)v=v.slice(1);a.f=Xl(v,n);delete a.Formula;if(a.ArrayRange=="RC")a.F=Xl("RC:RC",n);else if(a.ArrayRange){a.F=Xl(a.ArrayRange,n);o.push([pt(a.F),a.F])}}else{for(p=0;p<o.length;++p)if(n.r>=o[p][0].s.r&&n.r<=o[p][0].e.r)if(n.c>=o[p][0].s.c&&n.c<=o[p][0].e.c)a.F=o[p][1]}}if(l.cellStyles){d.forEach(function(e){if(!u.patternType&&e.patternType)u.patternType=e.patternType});a.s=u}if(a.StyleID!==undefined)a.ixfe=a.StyleID}function Lp(e){e.t=e.v||"";e.t=e.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");e.v=e.w=e.ixfe=undefined}function Mp(e){if(b&&Buffer.isBuffer(e))return e.toString("utf8");if(typeof e==="string")return e;if(typeof Uint8Array!=="undefined"&&e instanceof Uint8Array)return ze(B(y(e)));throw new Error("Bad input format: expected Buffer or string")}var Up=/<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/gm;function Hp(e,r){var t=r||{};F(D);var a=d(Mp(e));if(t.type=="binary"||t.type=="array"||t.type=="base64"){if(typeof cptable!=="undefined")a=cptable.utils.decode(65001,c(a));else a=ze(a)}var n=a.slice(0,1024).toLowerCase(),i=false;if(n.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(e){if(n.indexOf("<"+e)>=0)i=true});if(i)return Dv.to_workbook(a,t);var s;var f=[],o;if(v!=null&&t.dense==null)t.dense=v;var l={},h=[],u=t.dense?[]:{},p="";var g={},m={},b={};var w=Ip('<Data ss:Type="String">'),C=0;var E=0,k=0;var S={s:{r:2e6,c:2e6},e:{r:0,c:0}};var A={},_={};var B="",T=0;var y=[];var x={},I={},R=0,P=[];var N=[],L={};var M=[],U,H=false;var W=[];var V=[],z={},X=0,G=0;var j={Sheets:[],WBProps:{date1904:false}},K={};Up.lastIndex=0;a=a.replace(/<!--([\s\S]*?)-->/gm,"");while(s=Up.exec(a))switch(s[3]){case"Data":if(f[f.length-1][1])break;if(s[1]==="/")Np(a.slice(C,s.index),B,w,f[f.length-1][0]=="Comment"?L:m,{c:E,r:k},A,M[E],b,W,t);else{B="";w=Ip(s[0]);C=s.index+s[0].length}break;case"Cell":if(s[1]==="/"){if(N.length>0)m.c=N;if((!t.sheetRows||t.sheetRows>k)&&m.v!==undefined){if(t.dense){if(!u[k])u[k]=[];u[k][E]=m}else u[st(E)+tt(k)]=m}if(m.HRef){m.l={Target:m.HRef};if(m.HRefScreenTip)m.l.Tooltip=m.HRefScreenTip;delete m.HRef;delete m.HRefScreenTip}if(m.MergeAcross||m.MergeDown){X=E+(parseInt(m.MergeAcross,10)|0);G=k+(parseInt(m.MergeDown,10)|0);y.push({s:{c:E,r:k},e:{c:X,r:G}})}if(!t.sheetStubs){if(m.MergeAcross)E=X+1;else++E}else if(m.MergeAcross||m.MergeDown){for(var Y=E;Y<=X;++Y){for(var $=k;$<=G;++$){if(Y>E||$>k){if(t.dense){if(!u[$])u[$]=[];u[$][Y]={t:"z"}}else u[st(Y)+tt($)]={t:"z"}}}}E=X+1}else++E}else{m=Rp(s[0]);if(m.Index)E=+m.Index-1;if(E<S.s.c)S.s.c=E;if(E>S.e.c)S.e.c=E;if(s[0].slice(-2)==="/>")++E;N=[]}break;case"Row":if(s[1]==="/"||s[0].slice(-2)==="/>"){if(k<S.s.r)S.s.r=k;if(k>S.e.r)S.e.r=k;if(s[0].slice(-2)==="/>"){b=Ip(s[0]);if(b.Index)k=+b.Index-1}E=0;++k}else{b=Ip(s[0]);if(b.Index)k=+b.Index-1;z={};if(b.AutoFitHeight=="0"||b.Height){z.hpx=parseInt(b.Height,10);z.hpt=co(z.hpx);V[k]=z}if(b.Hidden=="1"){z.hidden=true;V[k]=z}}break;case"Worksheet":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"));h.push(p);if(S.s.r<=S.e.r&&S.s.c<=S.e.c){u["!ref"]=dt(S);if(t.sheetRows&&t.sheetRows<=S.e.r){u["!fullref"]=u["!ref"];S.e.r=t.sheetRows-1;u["!ref"]=dt(S)}}if(y.length)u["!merges"]=y;if(M.length>0)u["!cols"]=M;if(V.length>0)u["!rows"]=V;l[p]=u}else{S={s:{r:2e6,c:2e6},e:{r:0,c:0}};k=E=0;f.push([s[3],false]);o=Ip(s[0]);p=De(o.Name);u=t.dense?[]:{};y=[];W=[];V=[];K={name:p,Hidden:0};j.Sheets.push(K)}break;case"Table":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].slice(-2)=="/>")break;else{g=Ip(s[0]);f.push([s[3],false]);M=[];H=false}break;case"Style":if(s[1]==="/")Pp(A,_,t);else _=Ip(s[0]);break;case"NumberFormat":_.nf=De(Ip(s[0]).Format||"General");if(O[_.nf])_.nf=O[_.nf];for(var Z=0;Z!=392;++Z)if(D._table[Z]==_.nf)break;if(Z==392)for(Z=57;Z!=392;++Z)if(D._table[Z]==null){D.load(_.nf,Z);break}break;case"Column":if(f[f.length-1][0]!=="Table")break;U=Ip(s[0]);if(U.Hidden){U.hidden=true;delete U.Hidden}if(U.Width)U.wpx=parseInt(U.Width,10);if(!H&&U.wpx>10){H=true;ro=Jf;for(var Q=0;Q<M.length;++Q)if(M[Q])fo(M[Q])}if(H)fo(U);M[U.Index-1||M.length]=U;for(var J=0;J<+U.Span;++J)M[M.length]=fe(U);break;case"NamedRange":if(!j.Names)j.Names=[];var q=ye(s[0]);var ee={Name:q.Name,Ref:Xl(q.RefersTo.slice(1),{r:0,c:0})};if(j.Sheets.length>0)ee.Sheet=j.Sheets.length-1;j.Names.push(ee);break;case"NamedCell":break;case"B":break;case"I":break;case"U":break;case"S":break;case"Sub":break;case"Sup":break;case"Span":break;case"Border":break;case"Alignment":break;case"Borders":break;case"Font":if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")B+=a.slice(T,s.index);else T=s.index+s[0].length;break;case"Interior":if(!t.cellStyles)break;_.Interior=Ip(s[0]);break;case"Protection":break;case"Author":;case"Title":;case"Description":;case"Created":;case"Keywords":;case"Subject":;case"Category":;case"Company":;case"LastAuthor":;case"LastSaved":;case"LastPrinted":;case"Version":;case"Revision":;case"TotalTime":;case"HyperlinkBase":;case"Manager":;case"ContentStatus":;case"Identifier":;case"Language":;case"AppName":if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")ln(x,s[3],a.slice(R,s.index));else R=s.index+s[0].length;break;case"Paragraphs":break;case"Styles":;case"Workbook":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else f.push([s[3],false]);break;case"Comment":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"));Lp(L);N.push(L)}else{f.push([s[3],false]);o=Ip(s[0]);L={a:o.Author}}break;case"AutoFilter":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].charAt(s[0].length-2)!=="/"){var re=Ip(s[0]);u["!autofilter"]={ref:Xl(re.Range).replace(/\$/g,"")};f.push([s[3],true])}break;case"Name":break;case"ComponentOptions":;case"DocumentProperties":;case"CustomDocumentProperties":;case"OfficeDocumentSettings":;case"PivotTable":;case"PivotCache":;case"Names":;case"MapInfo":;case"PageBreaks":;case"QueryTable":;case"DataValidation":;case"Sorting":;case"Schema":;case"data":;case"ConditionalFormatting":;case"SmartTagType":;case"SmartTags":;case"ExcelWorkbook":;case"WorkbookOptions":;case"WorksheetOptions":if(s[1]==="/"){if((o=f.pop())[0]!==s[3])throw new Error("Bad state: "+o.join("|"))}else if(s[0].charAt(s[0].length-2)!=="/")f.push([s[3],true]);break;default:if(f.length==0&&s[3]=="document")return Uv(a,t);if(f.length==0&&s[3]=="UOF")return Uv(a,t);var te=true;switch(f[f.length-1][0]){case"OfficeDocumentSettings":switch(s[3]){case"AllowPNG":break;case"RemovePersonalInformation":break;case"DownloadComponents":break;case"LocationOfComponents":break;case"Colors":break;case"Color":break;case"Index":break;case"RGB":break;case"PixelsPerInch":break;case"TargetScreenSize":break;case"ReadOnlyRecommended":break;default:te=false;}break;case"ComponentOptions":switch(s[3]){case"Toolbar":break;case"HideOfficeLogo":break;case"SpreadsheetAutoFit":break;case"Label":break;case"Caption":break;case"MaxHeight":break;case"MaxWidth":break;case"NextSheetNumber":break;default:te=false;}break;case"ExcelWorkbook":switch(s[3]){case"Date1904":j.WBProps.date1904=true;break;case"WindowHeight":break;case"WindowWidth":break;case"WindowTopX":break;case"WindowTopY":break;case"TabRatio":break;case"ProtectStructure":break;case"ProtectWindows":break;case"ActiveSheet":break;case"DisplayInkNotes":break;case"FirstVisibleSheet":break;case"SupBook":break;case"SheetName":break;case"SheetIndex":break;case"SheetIndexFirst":break;case"SheetIndexLast":break;case"Dll":break;case"AcceptLabelsInFormulas":break;case"DoNotSaveLinkValues":break;case"Iteration":break;case"MaxIterations":break;case"MaxChange":break;case"Path":break;case"Xct":break;case"Count":break;case"SelectedSheets":break;case"Calculation":break;case"Uncalced":break;case"StartupPrompt":break;case"Crn":break;case"ExternName":break;case"Formula":break;case"ColFirst":break;case"ColLast":break;case"WantAdvise":break;case"Boolean":break;case"Error":break;case"Text":break;case"OLE":break;case"NoAutoRecover":break;case"PublishObjects":break;case"DoNotCalculateBeforeSave":break;case"Number":break;case"RefModeR1C1":break;case"EmbedSaveSmartTags":break;default:te=false;}break;case"WorkbookOptions":switch(s[3]){case"OWCVersion":break;case"Height":break;case"Width":break;default:te=false;}break;case"WorksheetOptions":switch(s[3]){case"Visible":if(s[0].slice(-2)==="/>"){}else if(s[1]==="/")switch(a.slice(R,s.index)){case"SheetHidden":K.Hidden=1;break;case"SheetVeryHidden":K.Hidden=2;break;}else R=s.index+s[0].length;break;case"Header":if(!u["!margins"])Zh(u["!margins"]={},"xlml");u["!margins"].header=ye(s[0]).Margin;break;case"Footer":if(!u["!margins"])Zh(u["!margins"]={},"xlml");u["!margins"].footer=ye(s[0]).Margin;break;case"PageMargins":var ae=ye(s[0]);if(!u["!margins"])Zh(u["!margins"]={},"xlml");if(ae.Top)u["!margins"].top=ae.Top;if(ae.Left)u["!margins"].left=ae.Left;if(ae.Right)u["!margins"].right=ae.Right;if(ae.Bottom)u["!margins"].bottom=ae.Bottom;break;case"DisplayRightToLeft":if(!j.Views)j.Views=[];if(!j.Views[0])j.Views[0]={};j.Views[0].RTL=true;break;case"Unsynced":break;case"Print":break;case"Panes":break;case"Scale":break;case"Pane":break;case"Number":break;case"Layout":break;case"PageSetup":break;case"Selected":break;case"ProtectObjects":break;case"EnableSelection":break;case"ProtectScenarios":break;case"ValidPrinterInfo":break;case"HorizontalResolution":break;case"VerticalResolution":break;case"NumberofCopies":break;case"ActiveRow":break;case"ActiveCol":break;case"ActivePane":break;case"TopRowVisible":break;case"TopRowBottomPane":break;case"LeftColumnVisible":break;case"LeftColumnRightPane":break;case"FitToPage":break;case"RangeSelection":break;case"PaperSizeIndex":break;case"PageLayoutZoom":break;case"PageBreakZoom":break;case"FilterOn":break;case"DoNotDisplayGridlines":break;case"SplitHorizontal":break;case"SplitVertical":break;case"FreezePanes":break;case"FrozenNoSplit":break;case"FitWidth":break;case"FitHeight":break;case"CommentsLayout":break;case"Zoom":break;case"LeftToRight":break;case"Gridlines":break;case"AllowSort":break;case"AllowFilter":break;case"AllowInsertRows":break;case"AllowDeleteRows":break;case"AllowInsertCols":break;case"AllowDeleteCols":break;case"AllowInsertHyperlinks":break;case"AllowFormatCells":break;case"AllowSizeCols":break;case"AllowSizeRows":break;case"NoSummaryRowsBelowDetail":break;case"TabColorIndex":break;case"DoNotDisplayHeadings":break;case"ShowPageLayoutZoom":break;case"NoSummaryColumnsRightDetail":break;case"BlackAndWhite":break;case"DoNotDisplayZeros":break;case"DisplayPageBreak":break;case"RowColHeadings":break;case"DoNotDisplayOutline":break;case"NoOrientation":break;case"AllowUsePivotTables":break;case"ZeroHeight":break;case"ViewableRange":break;case"Selection":break;case"ProtectContents":break;default:te=false;}break;case"PivotTable":;case"PivotCache":switch(s[3]){case"ImmediateItemsOnDrop":break;case"ShowPageMultipleItemLabel":break;case"CompactRowIndent":break;case"Location":break;case"PivotField":break;case"Orientation":break;case"LayoutForm":break;case"LayoutSubtotalLocation":break;case"LayoutCompactRow":break;case"Position":break;case"PivotItem":break;case"DataType":break;case"DataField":break;case"SourceName":break;case"ParentField":break;case"PTLineItems":break;case"PTLineItem":break;case"CountOfSameItems":break;case"Item":break;case"ItemType":break;case"PTSource":break;case"CacheIndex":break;case"ConsolidationReference":break;case"FileName":break;case"Reference":break;case"NoColumnGrand":break;case"NoRowGrand":break;case"BlankLineAfterItems":break;case"Hidden":break;case"Subtotal":break;case"BaseField":break;case"MapChildItems":break;case"Function":break;case"RefreshOnFileOpen":break;case"PrintSetTitles":break;case"MergeLabels":break;case"DefaultVersion":break;case"RefreshName":break;case"RefreshDate":break;case"RefreshDateCopy":break;case"VersionLastRefresh":break;case"VersionLastUpdate":break;case"VersionUpdateableMin":break;case"VersionRefreshableMin":break;case"Calculation":break;default:te=false;}break;case"PageBreaks":switch(s[3]){
case"ColBreaks":break;case"ColBreak":break;case"RowBreaks":break;case"RowBreak":break;case"ColStart":break;case"ColEnd":break;case"RowEnd":break;default:te=false;}break;case"AutoFilter":switch(s[3]){case"AutoFilterColumn":break;case"AutoFilterCondition":break;case"AutoFilterAnd":break;case"AutoFilterOr":break;default:te=false;}break;case"QueryTable":switch(s[3]){case"Id":break;case"AutoFormatFont":break;case"AutoFormatPattern":break;case"QuerySource":break;case"QueryType":break;case"EnableRedirections":break;case"RefreshedInXl9":break;case"URLString":break;case"HTMLTables":break;case"Connection":break;case"CommandText":break;case"RefreshInfo":break;case"NoTitles":break;case"NextId":break;case"ColumnInfo":break;case"OverwriteCells":break;case"DoNotPromptForFile":break;case"TextWizardSettings":break;case"Source":break;case"Number":break;case"Decimal":break;case"ThousandSeparator":break;case"TrailingMinusNumbers":break;case"FormatSettings":break;case"FieldType":break;case"Delimiters":break;case"Tab":break;case"Comma":break;case"AutoFormatName":break;case"VersionLastEdit":break;case"VersionLastRefresh":break;default:te=false;}break;case"Sorting":;case"ConditionalFormatting":;case"DataValidation":switch(s[3]){case"Range":break;case"Type":break;case"Min":break;case"Max":break;case"Sort":break;case"Descending":break;case"Order":break;case"CaseSensitive":break;case"Value":break;case"ErrorStyle":break;case"ErrorMessage":break;case"ErrorTitle":break;case"CellRangeList":break;case"InputMessage":break;case"InputTitle":break;case"ComboHide":break;case"InputHide":break;case"Condition":break;case"Qualifier":break;case"UseBlank":break;case"Value1":break;case"Value2":break;case"Format":break;default:te=false;}break;case"MapInfo":;case"Schema":;case"data":switch(s[3]){case"Map":break;case"Entry":break;case"Range":break;case"XPath":break;case"Field":break;case"XSDType":break;case"FilterOn":break;case"Aggregate":break;case"ElementType":break;case"AttributeType":break;case"schema":;case"element":;case"complexType":;case"datatype":;case"all":;case"attribute":;case"extends":break;case"row":break;default:te=false;}break;case"SmartTags":break;default:te=false;break;}if(te)break;if(!f[f.length-1][1])throw"Unrecognized tag: "+s[3]+"|"+f.join("|");if(f[f.length-1][0]==="CustomDocumentProperties"){if(s[0].slice(-2)==="/>")break;else if(s[1]==="/")Fp(I,s[3],P,a.slice(R,s.index));else{P=s;R=s.index+s[0].length}break}if(t.WTF)throw"Unrecognized tag: "+s[3]+"|"+f.join("|");}var ne={};if(!t.bookSheets&&!t.bookProps)ne.Sheets=l;ne.SheetNames=h;ne.Workbook=j;ne.SSF=D.get_table();ne.Props=x;ne.Custprops=I;return ne}function Wp(e,r){rg(r=r||{});switch(r.type||"base64"){case"base64":return Hp(m.decode(e),r);case"binary":;case"buffer":;case"file":return Hp(e,r);case"array":return Hp(B(e),r);}}function Vp(e,r){var t=[];if(e.Props)t.push(cn(e.Props,r));if(e.Custprops)t.push(hn(e.Props,e.Custprops,r));return t.join("")}function zp(){return""}function Xp(e,r){var t=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];r.cellXfs.forEach(function(e,r){var a=[];a.push(ar("NumberFormat",null,{"ss:Format":Pe(D._table[e.numFmtId])}));t.push(ar("Style",a.join(""),{"ss:ID":"s"+(21+r)}))});return ar("Styles",t.join(""))}function Gp(e){return ar("NamedRange",null,{"ss:Name":e.Name,"ss:RefersTo":"="+jl(e.Ref,{r:0,c:0})})}function jp(e){if(!((e||{}).Workbook||{}).Names)return"";var r=e.Workbook.Names;var t=[];for(var a=0;a<r.length;++a){var n=r[a];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;t.push(Gp(n))}return ar("Names",t.join(""))}function Kp(e,r,t,a){if(!e)return"";if(!((a||{}).Workbook||{}).Names)return"";var n=a.Workbook.Names;var i=[];for(var s=0;s<n.length;++s){var f=n[s];if(f.Sheet!=t)continue;if(f.Name.match(/^_xlfn\./))continue;i.push(Gp(f))}return i.join("")}function Yp(e,r,t,a){if(!e)return"";var n=[];if(e["!margins"]){n.push("<PageSetup>");if(e["!margins"].header)n.push(ar("Header",null,{"x:Margin":e["!margins"].header}));if(e["!margins"].footer)n.push(ar("Footer",null,{"x:Margin":e["!margins"].footer}));n.push(ar("PageMargins",null,{"x:Bottom":e["!margins"].bottom||"0.75","x:Left":e["!margins"].left||"0.7","x:Right":e["!margins"].right||"0.7","x:Top":e["!margins"].top||"0.75"}));n.push("</PageSetup>")}if(a&&a.Workbook&&a.Workbook.Sheets&&a.Workbook.Sheets[t]){if(a.Workbook.Sheets[t].Hidden)n.push(ar("Visible",a.Workbook.Sheets[t].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{for(var i=0;i<t;++i)if(a.Workbook.Sheets[i]&&!a.Workbook.Sheets[i].Hidden)break;if(i==t)n.push("<Selected/>")}}if(((((a||{}).Workbook||{}).Views||[])[0]||{}).RTL)n.push("<DisplayRightToLeft/>");if(e["!protect"]){n.push(rr("ProtectContents","True"));if(e["!protect"].objects)n.push(rr("ProtectObjects","True"));if(e["!protect"].scenarios)n.push(rr("ProtectScenarios","True"));if(e["!protect"].selectLockedCells!=null&&!e["!protect"].selectLockedCells)n.push(rr("EnableSelection","NoSelection"));else if(e["!protect"].selectUnlockedCells!=null&&!e["!protect"].selectUnlockedCells)n.push(rr("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(r){if(e["!protect"][r[0]])n.push("<"+r[1]+"/>")})}if(n.length==0)return"";return ar("WorksheetOptions",n.join(""),{xmlns:fr.x})}function $p(e){return e.map(function(e){var r=We(e.t||"");var t=ar("ss:Data",r,{xmlns:"http://www.w3.org/TR/REC-html40"});return ar("Comment",t,{"ss:Author":e.a})}).join("")}function Zp(e,r,t,a,n,i,s){if(!e||e.v==undefined&&e.f==undefined)return"";var f={};if(e.f)f["ss:Formula"]="="+Pe(jl(e.f,s));if(e.F&&e.F.slice(0,r.length)==r){var o=ct(e.F.slice(r.length+1));f["ss:ArrayRange"]="RC:R"+(o.r==s.r?"":"["+(o.r-s.r)+"]")+"C"+(o.c==s.c?"":"["+(o.c-s.c)+"]")}if(e.l&&e.l.Target){f["ss:HRef"]=Pe(e.l.Target);if(e.l.Tooltip)f["x:HRefScreenTip"]=Pe(e.l.Tooltip)}if(t["!merges"]){var l=t["!merges"];for(var c=0;c!=l.length;++c){if(l[c].s.c!=s.c||l[c].s.r!=s.r)continue;if(l[c].e.c>l[c].s.c)f["ss:MergeAcross"]=l[c].e.c-l[c].s.c;if(l[c].e.r>l[c].s.r)f["ss:MergeDown"]=l[c].e.r-l[c].s.r}}var h="",u="";switch(e.t){case"z":return"";case"n":h="Number";u=String(e.v);break;case"b":h="Boolean";u=e.v?"1":"0";break;case"e":h="Error";u=jt[e.v];break;case"d":h="DateTime";u=new Date(e.v).toISOString();if(e.z==null)e.z=e.z||D._table[14];break;case"s":h="String";u=Ue(e.v||"");break;}var d=Qh(a.cellXfs,e,a);f["ss:StyleID"]="s"+(21+d);f["ss:Index"]=s.c+1;var p=e.v!=null?u:"";var v='<Data ss:Type="'+h+'">'+p+"</Data>";if((e.c||[]).length>0)v+=$p(e.c);return ar("Cell",v,f)}function Qp(e,r){var t='<Row ss:Index="'+(e+1)+'"';if(r){if(r.hpt&&!r.hpx)r.hpx=ho(r.hpt);if(r.hpx)t+=' ss:AutoFitHeight="0" ss:Height="'+r.hpx+'"';if(r.hidden)t+=' ss:Hidden="1"'}return t+">"}function Jp(e,r,t,a){if(!e["!ref"])return"";var n=pt(e["!ref"]);var i=e["!merges"]||[],s=0;var f=[];if(e["!cols"])e["!cols"].forEach(function(e,r){fo(e);var t=!!e.width;var a=$h(r,e);var n={"ss:Index":r+1};if(t)n["ss:Width"]=to(a.width);if(e.hidden)n["ss:Hidden"]="1";f.push(ar("Column",null,n))});var o=Array.isArray(e);for(var l=n.s.r;l<=n.e.r;++l){var c=[Qp(l,(e["!rows"]||[])[l])];for(var h=n.s.c;h<=n.e.c;++h){var u=false;for(s=0;s!=i.length;++s){if(i[s].s.c>h)continue;if(i[s].s.r>l)continue;if(i[s].e.c<h)continue;if(i[s].e.r<l)continue;if(i[s].s.c!=h||i[s].s.r!=l)u=true;break}if(u)continue;var d={r:l,c:h};var p=ht(d),v=o?(e[l]||[])[h]:e[p];c.push(Zp(v,p,e,r,t,a,d))}c.push("</Row>");if(c.length>2)f.push(c.join(""))}return f.join("")}function qp(e,r,t){var a=[];var n=t.SheetNames[e];var i=t.Sheets[n];var s=i?Kp(i,r,e,t):"";if(s.length>0)a.push("<Names>"+s+"</Names>");s=i?Jp(i,r,e,t):"";if(s.length>0)a.push("<Table>"+s+"</Table>");a.push(Yp(i,r,e,t));return a.join("")}function ev(e,r){if(!r)r={};if(!e.SSF)e.SSF=D.get_table();if(e.SSF){F(D);D.load_table(e.SSF);r.revssf=Z(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF;r.cellXfs=[];Qh(r.cellXfs,{},{revssf:{General:0}})}var t=[];t.push(Vp(e,r));t.push(zp(e,r));t.push("");t.push("");for(var a=0;a<e.SheetNames.length;++a)t.push(ar("Worksheet",qp(a,r,e),{"ss:Name":Pe(e.SheetNames[a])}));t[2]=Xp(e,r);t[3]=jp(e,r);return Se+ar("Workbook",t.join(""),{xmlns:fr.ss,"xmlns:o":fr.o,"xmlns:x":fr.x,"xmlns:ss":fr.ss,"xmlns:dt":fr.dt,"xmlns:html":fr.html})}function rv(e){var r={};var t=e.content;t.l=28;r.AnsiUserType=t._R(0,"lpstr-ansi");r.AnsiClipboardFormat=qt(t);if(t.length-t.l<=4)return r;var a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved1=t._R(0,"lpstr-ansi");if(t.length-t.l<=4)return r;a=t._R(4);if(a!==1907505652)return r;r.UnicodeClipboardFormat=ea(t);a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved2=t._R(0,"lpwstr")}function tv(e,r,t,a){var n=t;var i=[];var s=r.slice(r.l,r.l+n);if(a&&a.enc&&a.enc.insitu)switch(e.n){case"BOF":;case"FilePass":;case"FileLock":;case"InterfaceHdr":;case"RRDInfo":;case"RRDHead":;case"UsrExcl":break;default:if(s.length===0)break;a.enc.insitu(s);}i.push(s);r.l+=n;var f=dv[Dr(r,r.l)];var o=0;while(f!=null&&f.n.slice(0,8)==="Continue"){n=Dr(r,r.l+2);o=r.l+4;if(f.n=="ContinueFrt")o+=4;else if(f.n.slice(0,11)=="ContinueFrt")o+=12;i.push(r.slice(o,r.l+4+n));r.l+=4+n;f=dv[Dr(r,r.l)]}var l=x(i);zr(l,0);var c=0;l.lens=[];for(var h=0;h<i.length;++h){l.lens.push(c);c+=i[h].length}return e.f(l,l.length,a)}function av(e,r,t){if(e.t==="z")return;if(!e.XF)return;var a=0;try{a=e.z||e.XF.numFmtId||0;if(r.cellNF)e.z=D._table[a]}catch(n){if(r.WTF)throw n}if(!r||r.cellText!==false)try{if(e.t==="e"){e.w=e.w||jt[e.v]}else if(a===0||a=="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=D.format(a,e.v,{date1904:!!t})}catch(n){if(r.WTF)throw n}if(r.cellDates&&a&&e.t=="n"&&D.is_date(D._table[a]||String(a))){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}function nv(e,r,t){return{v:e,ixfe:r,t:t}}function iv(e,r){var t={opts:{}};var a={};if(v!=null&&r.dense==null)r.dense=v;var n=r.dense?[]:{};var i={};var s={};var f=null;var l=[];var c="";var h={};var u,d="",p,g,m,b;var w={};var C=[];var E;var k;var S=true;var A=[];var _=[];var B={Sheets:[],WBProps:{date1904:false},Views:[{}]},T={};var y=function be(e){if(e<8)return ka[e];if(e<64)return _[e-8]||ka[e];return ka[e]};var x=function we(e,r,t){var a=r.XF.data;if(!a||!a.patternType||!t||!t.cellStyles)return;r.s={};r.s.patternType=a.patternType;var n;if(n=Yf(y(a.icvFore))){r.s.fgColor={rgb:n}}if(n=Yf(y(a.icvBack))){r.s.bgColor={rgb:n}}};var I=function Ce(e,r,t){if(z>1)return;if(t.sheetRows&&e.r>=t.sheetRows)S=false;if(!S)return;if(t.cellStyles&&r.XF&&r.XF.data)x(e,r,t);delete r.ixfe;delete r.XF;u=e;d=ht(e);if(!s||!s.s||!s.e)s={s:{r:0,c:0},e:{r:0,c:0}};if(e.r<s.s.r)s.s.r=e.r;if(e.c<s.s.c)s.s.c=e.c;if(e.r+1>s.e.r)s.e.r=e.r+1;if(e.c+1>s.e.c)s.e.c=e.c+1;if(t.cellFormula&&r.f){for(var a=0;a<C.length;++a){if(C[a][0].s.c>e.c||C[a][0].s.r>e.r)continue;if(C[a][0].e.c<e.c||C[a][0].e.r<e.r)continue;r.F=dt(C[a][0]);if(C[a][0].s.c!=e.c||C[a][0].s.r!=e.r)delete r.f;if(r.f)r.f=""+_h(C[a][1],s,e,W,R);break}}{if(t.dense){if(!n[e.r])n[e.r]=[];n[e.r][e.c]=r}else n[d]=r}};var R={enc:false,sbcch:0,snames:[],sharedf:w,arrayf:C,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!r&&!!r.cellStyles,WTF:!!r&&!!r.wtf};if(r.password)R.password=r.password;var F;var O=[];var P=[];var N=[],L=[];var M=0,U=0;var H=false;var W=[];W.SheetNames=R.snames;W.sharedf=R.sharedf;W.arrayf=R.arrayf;W.names=[];W.XTI=[];var V="";var z=0;var X=0,G=[];var K=[];var Y;R.codepage=1200;o(1200);var $=false;while(e.l<e.length-1){var Z=e.l;var Q=e._R(2);if(Q===0&&V==="EOF")break;var J=e.l===e.length?0:e._R(2);var q=dv[Q];if(q&&q.f){if(r.bookSheets){if(V==="BoundSheet8"&&q.n!=="BoundSheet8")break}V=q.n;if(q.r===2||q.r==12){var ee=e._R(2);J-=2;if(!R.enc&&ee!==Q&&((ee&255)<<8|ee>>8)!==Q)throw new Error("rt mismatch: "+ee+"!="+Q);if(q.r==12){e.l+=10;J-=10}}var re;if(q.n==="EOF")re=q.f(e,J,R);else re=tv(q,e,J,R);var te=q.n;if(z==0&&te!="BOF")continue;switch(te){case"Date1904":t.opts.Date1904=B.WBProps.date1904=re;break;case"WriteProtect":t.opts.WriteProtect=true;break;case"FilePass":if(!R.enc)e.l=0;R.enc=re;if(!r.password)throw new Error("File is password-protected");if(re.valid==null)throw new Error("Encryption scheme unsupported");if(!re.valid)throw new Error("Password is incorrect");break;case"WriteAccess":R.lastuser=re;break;case"FileSharing":break;case"CodePage":switch(re){case 21010:re=1200;break;case 32768:re=1e4;break;case 32769:re=1252;break;}o(R.codepage=re);$=true;break;case"RRTabId":R.rrtabid=re;break;case"WinProtect":R.winlocked=re;break;case"Template":break;case"BookBool":break;case"UsesELFs":break;case"MTRSettings":break;case"RefreshAll":;case"CalcCount":;case"CalcDelta":;case"CalcIter":;case"CalcMode":;case"CalcPrecision":;case"CalcSaveRecalc":t.opts[te]=re;break;case"CalcRefMode":R.CalcRefMode=re;break;case"Uncalced":break;case"ForceFullCalculation":t.opts.FullCalc=re;break;case"WsBool":if(re.fDialog)n["!type"]="dialog";break;case"XF":A.push(re);break;case"ExtSST":break;case"BookExt":break;case"RichTextStream":break;case"BkHim":break;case"SupBook":W.push([re]);W[W.length-1].XTI=[];break;case"ExternName":W[W.length-1].push(re);break;case"Index":break;case"Lbl":Y={Name:re.Name,Ref:_h(re.rgce,s,null,W,R)};if(re.itab>0)Y.Sheet=re.itab-1;W.names.push(Y);if(!W[0]){W[0]=[];W[0].XTI=[]}W[W.length-1].push(re);if(re.Name=="_xlnm._FilterDatabase"&&re.itab>0)if(re.rgce&&re.rgce[0]&&re.rgce[0][0]&&re.rgce[0][0][0]=="PtgArea3d")K[re.itab-1]={ref:dt(re.rgce[0][0][1][2])};break;case"ExternCount":R.ExternCount=re;break;case"ExternSheet":if(W.length==0){W[0]=[];W[0].XTI=[]}W[W.length-1].XTI=W[W.length-1].XTI.concat(re);W.XTI=W.XTI.concat(re);break;case"NameCmt":if(R.biff<8)break;if(Y!=null)Y.Comment=re[1];break;case"Protect":n["!protect"]=re;break;case"Password":if(re!==0&&R.WTF)console.error("Password verifier: "+re);break;case"Prot4Rev":;case"Prot4RevPass":break;case"BoundSheet8":{i[re.pos]=re;R.snames.push(re.name)}break;case"EOF":{if(--z)break;if(s.e){if(s.e.r>0&&s.e.c>0){s.e.r--;s.e.c--;n["!ref"]=dt(s);if(r.sheetRows&&r.sheetRows<=s.e.r){var ae=s.e.r;s.e.r=r.sheetRows-1;n["!fullref"]=n["!ref"];n["!ref"]=dt(s);s.e.r=ae}s.e.r++;s.e.c++}if(O.length>0)n["!merges"]=O;if(P.length>0)n["!objects"]=P;if(N.length>0)n["!cols"]=N;if(L.length>0)n["!rows"]=L;B.Sheets.push(T)}if(c==="")h=n;else a[c]=n;n=r.dense?[]:{}}break;case"BOF":{if(R.biff===8)R.biff={9:2,521:3,1033:4}[Q]||{512:2,768:3,1024:4,1280:5,1536:8,2:2,7:2}[re.BIFFVer]||8;if(R.biff==8&&re.BIFFVer==0&&re.dt==16)R.biff=2;if(z++)break;S=true;n=r.dense?[]:{};if(R.biff<8&&!$){$=true;o(R.codepage=r.codepage||1252)}if(R.biff<5){if(c==="")c="Sheet1";s={s:{r:0,c:0},e:{r:0,c:0}};var ne={pos:e.l-J,name:c};i[ne.pos]=ne;R.snames.push(c)}else c=(i[Z]||{name:""}).name;if(re.dt==32)n["!type"]="chart";if(re.dt==64)n["!type"]="macro";O=[];P=[];R.arrayf=C=[];N=[];L=[];M=U=0;H=false;T={Hidden:(i[Z]||{hs:0}).hs,name:c}}break;case"Number":;case"BIFF2NUM":;case"BIFF2INT":{if(n["!type"]=="chart")if(r.dense?(n[re.r]||[])[re.c]:n[ht({c:re.c,r:re.r})])++re.c;E={ixfe:re.ixfe,XF:A[re.ixfe]||{},v:re.val,t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"BoolErr":{E={ixfe:re.ixfe,XF:A[re.ixfe],v:re.val,t:re.t};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"RK":{E={ixfe:re.ixfe,XF:A[re.ixfe],v:re.rknum,t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"MulRk":{for(var ie=re.c;ie<=re.C;++ie){var se=re.rkrec[ie-re.c][0];E={ixfe:se,XF:A[se],v:re.rkrec[ie-re.c][1],t:"n"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:ie,r:re.r},E,r)}}break;case"Formula":{if(re.val=="String"){f=re;break}E=nv(re.val,re.cell.ixfe,re.tt);E.XF=A[E.ixfe];if(r.cellFormula){var fe=re.formula;if(fe&&fe[0]&&fe[0][0]&&fe[0][0][0]=="PtgExp"){var oe=fe[0][0][1][0],le=fe[0][0][1][1];var ce=ht({r:oe,c:le});if(w[ce])E.f=""+_h(re.formula,s,re.cell,W,R);else E.F=((r.dense?(n[oe]||[])[le]:n[ce])||{}).F}else E.f=""+_h(re.formula,s,re.cell,W,R)}if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I(re.cell,E,r);f=re}break;case"String":{if(f){f.val=re;E=nv(re,f.cell.ixfe,"s");E.XF=A[E.ixfe];if(r.cellFormula){E.f=""+_h(f.formula,s,f.cell,W,R)}if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I(f.cell,E,r);f=null}else throw new Error("String record expects Formula")}break;case"Array":{C.push(re);var he=ht(re[0].s);p=r.dense?(n[re[0].s.r]||[])[re[0].s.c]:n[he];if(r.cellFormula&&p){if(!f)break;if(!he||!p)break;p.f=""+_h(re[1],s,re[0],W,R);p.F=dt(re[0])}}break;case"ShrFmla":{if(!S)break;if(!r.cellFormula)break;if(d){if(!f)break;w[ht(f.cell)]=re[0];p=r.dense?(n[f.cell.r]||[])[f.cell.c]:n[ht(f.cell)];(p||{}).f=""+_h(re[0],s,u,W,R)}}break;case"LabelSst":E=nv(l[re.isst].t,re.ixfe,"s");E.XF=A[E.ixfe];if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r);break;case"Blank":if(r.sheetStubs){E={ixfe:re.ixfe,XF:A[re.ixfe],t:"z"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r)}break;case"MulBlank":if(r.sheetStubs){for(var ue=re.c;ue<=re.C;++ue){var de=re.ixfe[ue-re.c];E={ixfe:de,XF:A[de],t:"z"};if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:ue,r:re.r},E,r)}}break;case"RString":;case"Label":;case"BIFF2STR":E=nv(re.val,re.ixfe,"s");E.XF=A[E.ixfe];if(X>0)E.z=G[E.ixfe>>8&31];av(E,r,t.opts.Date1904);I({c:re.c,r:re.r},E,r);break;case"Dimensions":{if(z===1)s=re}break;case"SST":{l=re}break;case"Format":{if(R.biff==4){G[X++]=re[1];for(var pe=0;pe<X+163;++pe)if(D._table[pe]==re[1])break;if(pe>=163)D.load(re[1],X+163)}else D.load(re[1],re[0])}break;case"BIFF2FORMAT":{G[X++]=re;for(var ve=0;ve<X+163;++ve)if(D._table[ve]==re)break;if(ve>=163)D.load(re,X+163)}break;case"MergeCells":O=O.concat(re);break;case"Obj":P[re.cmo[0]]=R.lastobj=re;break;case"TxO":R.lastobj.TxO=re;break;case"ImData":R.lastobj.ImData=re;break;case"HLink":{for(b=re[0].s.r;b<=re[0].e.r;++b)for(m=re[0].s.c;m<=re[0].e.c;++m){p=r.dense?(n[b]||[])[m]:n[ht({c:m,r:b})];if(p)p.l=re[1]}}break;case"HLinkTooltip":{for(b=re[0].s.r;b<=re[0].e.r;++b)for(m=re[0].s.c;m<=re[0].e.c;++m){p=r.dense?(n[b]||[])[m]:n[ht({c:m,r:b})];if(p&&p.l)p.l.Tooltip=re[1]}}break;case"Note":{if(R.biff<=5&&R.biff>=2)break;p=r.dense?(n[re[0].r]||[])[re[0].c]:n[ht(re[0])];var ge=P[re[2]];if(!p)break;if(!p.c)p.c=[];g={a:re[1],t:ge.TxO.t};p.c.push(g)}break;default:switch(q.n){case"ClrtClient":break;case"XFExt":gl(A[re.ixfe],re.ext);break;case"DefColWidth":M=re;break;case"DefaultRowHeight":U=re[1];break;case"ColInfo":{if(!R.cellStyles)break;while(re.e>=re.s){N[re.e--]={width:re.w/256};if(!H){H=true;so(re.w/256)}fo(N[re.e+1])}}break;case"Row":{var me={};if(re.level!=null){L[re.r]=me;me.level=re.level}if(re.hidden){L[re.r]=me;me.hidden=true}if(re.hpt){L[re.r]=me;me.hpt=re.hpt;me.hpx=ho(re.hpt)}}break;case"LeftMargin":;case"RightMargin":;case"TopMargin":;case"BottomMargin":if(!n["!margins"])Zh(n["!margins"]={});n["!margins"][te.slice(0,-6).toLowerCase()]=re;break;case"Setup":if(!n["!margins"])Zh(n["!margins"]={});n["!margins"].header=re.header;n["!margins"].footer=re.footer;break;case"Window2":if(re.RTL)B.Views[0].RTL=true;break;case"Header":break;case"Footer":break;case"HCenter":break;case"VCenter":break;case"Pls":break;case"GCW":break;case"LHRecord":break;case"DBCell":break;case"EntExU2":break;case"SxView":break;case"Sxvd":break;case"SXVI":break;case"SXVDEx":break;case"SxIvd":break;case"SXString":break;case"Sync":break;case"Addin":break;case"SXDI":break;case"SXLI":break;case"SXEx":break;case"QsiSXTag":break;case"Selection":break;case"Feat":break;case"FeatHdr":;case"FeatHdr11":break;case"Feature11":;case"Feature12":;case"List12":break;case"Country":k=re;break;case"RecalcId":break;case"DxGCol":break;case"Fbi":;case"Fbi2":;case"GelFrame":break;case"Font":break;case"XFCRC":break;case"Style":break;case"StyleExt":break;case"Palette":_=re;break;case"Theme":F=re;break;case"ScenarioProtect":break;case"ObjProtect":break;case"CondFmt12":break;case"Table":break;case"TableStyles":break;case"TableStyle":break;case"TableStyleElement":break;case"SXStreamID":break;case"SXVS":break;case"DConRef":break;case"SXAddl":break;case"DConBin":break;case"DConName":break;case"SXPI":break;case"SxFormat":break;case"SxSelect":break;case"SxRule":break;case"SxFilt":break;case"SxItm":break;case"SxDXF":break;case"ScenMan":break;case"DCon":break;case"CellWatch":break;case"PrintRowCol":break;case"PrintGrid":break;case"PrintSize":break;case"XCT":break;case"CRN":break;case"Scl":{}break;case"SheetExt":{}break;case"SheetExtOptional":{}break;case"ObNoMacros":{}break;case"ObProj":{}break;case"CodeName":{if(!c)B.WBProps.CodeName=re||"ThisWorkbook";else T.CodeName=re||T.name}break;case"GUIDTypeLib":{}break;case"WOpt":break;case"PhoneticInfo":break;case"OleObjectSize":break;case"DXF":;case"DXFN":;case"DXFN12":;case"DXFN12List":;case"DXFN12NoCB":break;case"Dv":;case"DVal":break;case"BRAI":;case"Series":;case"SeriesText":break;case"DConn":break;case"DbOrParamQry":break;case"DBQueryExt":break;case"OleDbConn":break;case"ExtString":break;case"IFmtRecord":break;case"CondFmt":;case"CF":;case"CF12":;case"CFEx":break;case"Excel9File":break;case"Units":break;case"InterfaceHdr":;case"Mms":;case"InterfaceEnd":;case"DSF":break;case"BuiltInFnGroupCount":break;case"Window1":;case"HideObj":;case"GridSet":;case"Guts":;case"UserBView":;case"UserSViewBegin":;case"UserSViewEnd":;case"Pane":break;default:switch(q.n){case"Dat":;case"Begin":;case"End":;case"StartBlock":;case"EndBlock":;case"Frame":;case"Area":;case"Axis":;case"AxisLine":;case"Tick":break;case"AxesUsed":;case"CrtLayout12":;case"CrtLayout12A":;case"CrtLink":;case"CrtLine":;case"CrtMlFrt":;case"CrtMlFrtContinue":break;case"LineFormat":;case"AreaFormat":;case"Chart":;case"Chart3d":;case"Chart3DBarShape":;case"ChartFormat":;case"ChartFrtInfo":break;case"PlotArea":;case"PlotGrowth":break;case"SeriesList":;case"SerParent":;case"SerAuxTrend":break;case"DataFormat":;case"SerToCrt":;case"FontX":break;case"CatSerRange":;case"AxcExt":;case"SerFmt":break;case"ShtProps":break;case"DefaultText":;case"Text":;case"CatLab":break;case"DataLabExtContents":break;case"Legend":;case"LegendException":break;case"Pie":;case"Scatter":break;case"PieFormat":;case"MarkerFormat":break;case"StartObject":;case"EndObject":break;case"AlRuns":;case"ObjectLink":break;case"SIIndex":break;case"AttachedLabel":;case"YMult":break;case"Line":;case"Bar":break;case"Surf":break;case"AxisParent":break;case"Pos":break;case"ValueRange":break;case"SXViewEx9":break;case"SXViewLink":break;case"PivotChartBits":break;case"SBaseRef":break;case"TextPropsStream":break;case"LnExt":break;case"MkrExt":break;case"CrtCoopt":break;case"Qsi":;case"Qsif":;case"Qsir":;case"QsiSXTag":break;case"TxtQry":break;case"FilterMode":break;case"AutoFilter":;case"AutoFilterInfo":break;case"AutoFilter12":break;case"DropDownObjIds":break;case"Sort":break;case"SortData":break;case"ShapePropsStream":break;case"MsoDrawing":;case"MsoDrawingGroup":;case"MsoDrawingSelection":break;case"WebPub":;case"AutoWebPub":break;case"HeaderFooter":;case"HFPicture":;case"PLV":;case"HorizontalPageBreaks":;case"VerticalPageBreaks":break;case"Backup":;case"CompressPictures":;case"Compat12":break;case"Continue":;case"ContinueFrt12":break;case"FrtFontList":;case"FrtWrapper":break;default:switch(q.n){case"TabIdConf":;case"Radar":;case"RadarArea":;case"DropBar":;case"Intl":;case"CoordList":;case"SerAuxErrBar":break;case"BIFF2FONTCLR":;case"BIFF2FMTCNT":;case"BIFF2FONTXTRA":break;case"BIFF2XF":;case"BIFF3XF":;case"BIFF4XF":break;case"BIFF4FMTCNT":;case"BIFF2ROW":;case"BIFF2WINDOW2":break;case"SCENARIO":;case"DConBin":;case"PicF":;case"DataLabExt":;case"Lel":;case"BopPop":;case"BopPopCustom":;case"RealTimeData":;case"Name":break;case"LHNGraph":;case"FnGroupName":;case"AddMenu":;case"LPr":break;case"ListObj":;case"ListField":break;case"RRSort":break;case"BigName":break;case"ToolbarHdr":;case"ToolbarEnd":break;case"DDEObjName":break;case"FRTArchId$":break;default:if(r.WTF)throw"Unrecognized Record "+q.n;};};};}}else e.l+=J}t.SheetNames=j(i).sort(function(e,r){return Number(e)-Number(r)}).map(function(e){return i[e].name});if(!r.bookSheets)t.Sheets=a;if(t.Sheets)K.forEach(function(e,r){t.Sheets[t.SheetNames[r]]["!autofilter"]=e});t.Preamble=h;t.Strings=l;t.SSF=D.get_table();if(R.enc)t.Encryption=R.enc;if(F)t.Themes=F;t.Metadata={};if(k!==undefined)t.Metadata.Country=k;if(W.names.length>0)B.Names=W.names;t.Workbook=B;return t}var sv={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function fv(e,r,t){var a=W.find(e,"!DocumentSummaryInformation");if(a&&a.size>0)try{var n=Fn(a,pa,sv.DSI);for(var i in n)r[i]=n[i]}catch(s){if(t.WTF)throw s}var f=W.find(e,"!SummaryInformation");if(f&&f.size>0)try{var o=Fn(f,va,sv.SI);for(var l in o)if(r[l]==null)r[l]=o[l]}catch(s){if(t.WTF)throw s}if(r.HeadingPairs&&r.TitlesOfParts){Ja(r.HeadingPairs,r.TitlesOfParts,r,t);delete r.HeadingPairs;delete r.TitlesOfParts}}function ov(e,r){var t=[],a=[],n=[];var i=0,s;if(e.Props){s=j(e.Props);for(i=0;i<s.length;++i)(ma.hasOwnProperty(s[i])?t:ba.hasOwnProperty(s[i])?a:n).push([s[i],e.Props[s[i]]])}if(e.Custprops){s=j(e.Custprops);for(i=0;i<s.length;++i)if(!(e.Props||{}).hasOwnProperty(s[i]))(ma.hasOwnProperty(s[i])?t:ba.hasOwnProperty(s[i])?a:n).push([s[i],e.Custprops[s[i]]])}var f=[];for(i=0;i<n.length;++i){if(In.indexOf(n[i][0])>-1)continue;if(n[i][1]==null)continue;f.push(n[i])}if(a.length)W.utils.cfb_add(r,"/SummaryInformation",On(a,sv.SI,ba,va));if(t.length||f.length)W.utils.cfb_add(r,"/DocumentSummaryInformation",On(t,sv.DSI,ma,pa,f.length?f:null,sv.UDI))}function lv(e,r){if(!r)r={};rg(r);l();if(r.codepage)s(r.codepage);var t,a;if(e.FullPaths){if(W.find(e,"/encryption"))throw new Error("File is password-protected");t=W.find(e,"!CompObj");a=W.find(e,"/Workbook")||W.find(e,"/Book")}else{switch(r.type){case"base64":e=A(m.decode(e));break;case"binary":e=A(e);break;case"buffer":break;case"array":if(!Array.isArray(e))e=Array.prototype.slice.call(e);break;}zr(e,0);a={content:e}}var n;var i;if(t)rv(t);if(r.bookProps&&!r.bookSheets)n={};else{var f=b?"buffer":"array";if(a&&a.content)n=iv(a.content,r);else if((i=W.find(e,"PerfectOffice_MAIN"))&&i.content)n=sf.to_workbook(i.content,(r.type=f,r));else if((i=W.find(e,"NativeContent_MAIN"))&&i.content)n=sf.to_workbook(i.content,(r.type=f,r));else throw new Error("Cannot find Workbook stream");if(r.bookVBA&&e.FullPaths&&W.find(e,"/_VBA_PROJECT_CUR/VBA/dir"))n.vbaraw=Ll(e)}var o={};if(e.FullPaths)fv(e,o,r);n.Props=n.Custprops=o;if(r.bookFiles)n.cfb=e;return n}function cv(e,r){var t=r||{};var a=W.utils.cfb_new({root:"R"});var n="/Workbook";switch(t.bookType||"xls"){case"xls":t.bookType="biff8";case"xla":if(!t.bookType)t.bookType="xla";case"biff8":n="/Workbook";t.biff=8;break;case"biff5":n="/Book";t.biff=5;break;default:throw new Error("invalid type "+t.bookType+" for XLS CFB");}W.utils.cfb_add(a,n,Rv(e,t));if(t.biff==8&&(e.Props||e.Custprops))ov(e,a);if(t.biff==8&&e.vbaraw)Ml(a,W.read(e.vbaraw,{type:typeof e.vbaraw=="string"?"binary":"buffer"}));return a}var hv={0:{n:"BrtRowHdr",f:xu},1:{n:"BrtCellBlank",f:Lu},2:{n:"BrtCellRk",f:ju},3:{n:"BrtCellError",f:Wu},4:{n:"BrtCellBool",f:Uu},5:{n:"BrtCellReal",f:Xu},6:{n:"BrtCellSt",f:Yu},7:{n:"BrtCellIsst",f:Vu},8:{n:"BrtFmlaString",f:qu},9:{n:"BrtFmlaNum",f:Ju},10:{n:"BrtFmlaBool",f:Zu},11:{n:"BrtFmlaError",f:Qu},16:{n:"BrtFRTArchID$",f:tp},19:{n:"BrtSSTItem",f:_t},20:{n:"BrtPCDIMissing"},21:{n:"BrtPCDINumber"},22:{n:"BrtPCDIBoolean"},23:{n:"BrtPCDIError"},24:{n:"BrtPCDIString"},25:{n:"BrtPCDIDatetime"},26:{n:"BrtPCDIIndex"},27:{n:"BrtPCDIAMissing"},28:{n:"BrtPCDIANumber"},29:{n:"BrtPCDIABoolean"},30:{n:"BrtPCDIAError"},31:{n:"BrtPCDIAString"},32:{n:"BrtPCDIADatetime"},33:{n:"BrtPCRRecord"},34:{n:"BrtPCRRecordDt"},35:{n:"BrtFRTBegin"},36:{n:"BrtFRTEnd"},37:{n:"BrtACBegin"},38:{n:"BrtACEnd"},39:{n:"BrtName",f:ap},40:{n:"BrtIndexRowBlock"},42:{n:"BrtIndexBlock"},43:{n:"BrtFont",f:yo},44:{n:"BrtFmt",f:Bo},45:{n:"BrtFill",f:Do},46:{n:"BrtBorder",f:Lo},47:{n:"BrtXF",f:Oo},48:{n:"BrtStyle"},49:{n:"BrtCellMeta"},50:{n:"BrtValueMeta"},51:{n:"BrtMdb"},52:{n:"BrtBeginFmd"},53:{n:"BrtEndFmd"},54:{n:"BrtBeginMdx"},55:{n:"BrtEndMdx"},56:{n:"BrtBeginMdxTuple"},57:{n:"BrtEndMdxTuple"},58:{n:"BrtMdxMbrIstr"},59:{n:"BrtStr"},60:{n:"BrtColInfo",f:Ls},62:{n:"BrtCellRString"},63:{n:"BrtCalcChainItem$",f:bl},64:{n:"BrtDVal"},65:{n:"BrtSxvcellNum"},66:{n:"BrtSxvcellStr"},67:{n:"BrtSxvcellBool"},68:{n:"BrtSxvcellErr"},69:{n:"BrtSxvcellDate"},70:{n:"BrtSxvcellNil"},128:{n:"BrtFileVersion"},129:{n:"BrtBeginSheet"},130:{n:"BrtEndSheet"},131:{n:"BrtBeginBook",f:Xr,p:0},132:{n:"BrtEndBook"},133:{n:"BrtBeginWsViews"},134:{n:"BrtEndWsViews"},135:{n:"BrtBeginBookViews"},136:{n:"BrtEndBookViews"},137:{n:"BrtBeginWsView",f:hd},138:{n:"BrtEndWsView"},139:{n:"BrtBeginCsViews"},140:{n:"BrtEndCsViews"},141:{n:"BrtBeginCsView"},142:{n:"BrtEndCsView"},143:{n:"BrtBeginBundleShs"},144:{n:"BrtEndBundleShs"},145:{n:"BrtBeginSheetData"},146:{n:"BrtEndSheetData"},147:{n:"BrtWsProp",f:Pu},148:{n:"BrtWsDim",f:Du,p:16},151:{n:"BrtPane"},152:{n:"BrtSel"},153:{n:"BrtWbProp",f:ep},154:{n:"BrtWbFactoid"},155:{n:"BrtFileRecover"},156:{n:"BrtBundleSh",f:Jd},157:{n:"BrtCalcProp"},158:{n:"BrtBookView"},159:{n:"BrtBeginSst",f:bf},160:{n:"BrtEndSst"},161:{n:"BrtBeginAFilter",f:Vt},162:{n:"BrtEndAFilter"},163:{n:"BrtBeginFilterColumn"},164:{n:"BrtEndFilterColumn"},165:{n:"BrtBeginFilters"},166:{n:"BrtEndFilters"},167:{n:"BrtFilter"},168:{n:"BrtColorFilter"},169:{n:"BrtIconFilter"},170:{n:"BrtTop10Filter"},171:{n:"BrtDynamicFilter"},172:{n:"BrtBeginCustomFilters"},173:{n:"BrtEndCustomFilters"},174:{n:"BrtCustomFilter"},175:{n:"BrtAFilterDateGroupItem"},176:{n:"BrtMergeCell",f:ed},177:{n:"BrtBeginMergeCells"},178:{n:"BrtEndMergeCells"},179:{n:"BrtBeginPivotCacheDef"},180:{n:"BrtEndPivotCacheDef"},181:{n:"BrtBeginPCDFields"},182:{n:"BrtEndPCDFields"},183:{n:"BrtBeginPCDField"},184:{n:"BrtEndPCDField"},185:{n:"BrtBeginPCDSource"},186:{n:"BrtEndPCDSource"},187:{n:"BrtBeginPCDSRange"},188:{n:"BrtEndPCDSRange"},189:{n:"BrtBeginPCDFAtbl"},190:{n:"BrtEndPCDFAtbl"},191:{n:"BrtBeginPCDIRun"},192:{n:"BrtEndPCDIRun"},193:{n:"BrtBeginPivotCacheRecords"},194:{n:"BrtEndPivotCacheRecords"},195:{n:"BrtBeginPCDHierarchies"},196:{n:"BrtEndPCDHierarchies"},197:{n:"BrtBeginPCDHierarchy"},198:{n:"BrtEndPCDHierarchy"},199:{n:"BrtBeginPCDHFieldsUsage"},200:{n:"BrtEndPCDHFieldsUsage"},201:{n:"BrtBeginExtConnection"},202:{n:"BrtEndExtConnection"},203:{n:"BrtBeginECDbProps"},204:{n:"BrtEndECDbProps"},205:{n:"BrtBeginECOlapProps"},206:{n:"BrtEndECOlapProps"},207:{n:"BrtBeginPCDSConsol"},208:{n:"BrtEndPCDSConsol"},209:{n:"BrtBeginPCDSCPages"},210:{n:"BrtEndPCDSCPages"},211:{n:"BrtBeginPCDSCPage"},212:{n:"BrtEndPCDSCPage"},213:{n:"BrtBeginPCDSCPItem"},214:{n:"BrtEndPCDSCPItem"},215:{n:"BrtBeginPCDSCSets"},216:{n:"BrtEndPCDSCSets"},217:{n:"BrtBeginPCDSCSet"},218:{n:"BrtEndPCDSCSet"},219:{n:"BrtBeginPCDFGroup"},220:{n:"BrtEndPCDFGroup"},221:{n:"BrtBeginPCDFGItems"},222:{n:"BrtEndPCDFGItems"},223:{n:"BrtBeginPCDFGRange"},224:{n:"BrtEndPCDFGRange"},225:{n:"BrtBeginPCDFGDiscrete"},226:{n:"BrtEndPCDFGDiscrete"},227:{n:"BrtBeginPCDSDTupleCache"},228:{n:"BrtEndPCDSDTupleCache"},229:{n:"BrtBeginPCDSDTCEntries"},230:{n:"BrtEndPCDSDTCEntries"},231:{n:"BrtBeginPCDSDTCEMembers"},232:{n:"BrtEndPCDSDTCEMembers"},233:{n:"BrtBeginPCDSDTCEMember"},234:{n:"BrtEndPCDSDTCEMember"},235:{n:"BrtBeginPCDSDTCQueries"},236:{n:"BrtEndPCDSDTCQueries"},237:{n:"BrtBeginPCDSDTCQuery"},238:{n:"BrtEndPCDSDTCQuery"},239:{n:"BrtBeginPCDSDTCSets"},240:{n:"BrtEndPCDSDTCSets"},241:{n:"BrtBeginPCDSDTCSet"
},242:{n:"BrtEndPCDSDTCSet"},243:{n:"BrtBeginPCDCalcItems"},244:{n:"BrtEndPCDCalcItems"},245:{n:"BrtBeginPCDCalcItem"},246:{n:"BrtEndPCDCalcItem"},247:{n:"BrtBeginPRule"},248:{n:"BrtEndPRule"},249:{n:"BrtBeginPRFilters"},250:{n:"BrtEndPRFilters"},251:{n:"BrtBeginPRFilter"},252:{n:"BrtEndPRFilter"},253:{n:"BrtBeginPNames"},254:{n:"BrtEndPNames"},255:{n:"BrtBeginPName"},256:{n:"BrtEndPName"},257:{n:"BrtBeginPNPairs"},258:{n:"BrtEndPNPairs"},259:{n:"BrtBeginPNPair"},260:{n:"BrtEndPNPair"},261:{n:"BrtBeginECWebProps"},262:{n:"BrtEndECWebProps"},263:{n:"BrtBeginEcWpTables"},264:{n:"BrtEndECWPTables"},265:{n:"BrtBeginECParams"},266:{n:"BrtEndECParams"},267:{n:"BrtBeginECParam"},268:{n:"BrtEndECParam"},269:{n:"BrtBeginPCDKPIs"},270:{n:"BrtEndPCDKPIs"},271:{n:"BrtBeginPCDKPI"},272:{n:"BrtEndPCDKPI"},273:{n:"BrtBeginDims"},274:{n:"BrtEndDims"},275:{n:"BrtBeginDim"},276:{n:"BrtEndDim"},277:{n:"BrtIndexPartEnd"},278:{n:"BrtBeginStyleSheet"},279:{n:"BrtEndStyleSheet"},280:{n:"BrtBeginSXView"},281:{n:"BrtEndSXVI"},282:{n:"BrtBeginSXVI"},283:{n:"BrtBeginSXVIs"},284:{n:"BrtEndSXVIs"},285:{n:"BrtBeginSXVD"},286:{n:"BrtEndSXVD"},287:{n:"BrtBeginSXVDs"},288:{n:"BrtEndSXVDs"},289:{n:"BrtBeginSXPI"},290:{n:"BrtEndSXPI"},291:{n:"BrtBeginSXPIs"},292:{n:"BrtEndSXPIs"},293:{n:"BrtBeginSXDI"},294:{n:"BrtEndSXDI"},295:{n:"BrtBeginSXDIs"},296:{n:"BrtEndSXDIs"},297:{n:"BrtBeginSXLI"},298:{n:"BrtEndSXLI"},299:{n:"BrtBeginSXLIRws"},300:{n:"BrtEndSXLIRws"},301:{n:"BrtBeginSXLICols"},302:{n:"BrtEndSXLICols"},303:{n:"BrtBeginSXFormat"},304:{n:"BrtEndSXFormat"},305:{n:"BrtBeginSXFormats"},306:{n:"BrtEndSxFormats"},307:{n:"BrtBeginSxSelect"},308:{n:"BrtEndSxSelect"},309:{n:"BrtBeginISXVDRws"},310:{n:"BrtEndISXVDRws"},311:{n:"BrtBeginISXVDCols"},312:{n:"BrtEndISXVDCols"},313:{n:"BrtEndSXLocation"},314:{n:"BrtBeginSXLocation"},315:{n:"BrtEndSXView"},316:{n:"BrtBeginSXTHs"},317:{n:"BrtEndSXTHs"},318:{n:"BrtBeginSXTH"},319:{n:"BrtEndSXTH"},320:{n:"BrtBeginISXTHRws"},321:{n:"BrtEndISXTHRws"},322:{n:"BrtBeginISXTHCols"},323:{n:"BrtEndISXTHCols"},324:{n:"BrtBeginSXTDMPS"},325:{n:"BrtEndSXTDMPs"},326:{n:"BrtBeginSXTDMP"},327:{n:"BrtEndSXTDMP"},328:{n:"BrtBeginSXTHItems"},329:{n:"BrtEndSXTHItems"},330:{n:"BrtBeginSXTHItem"},331:{n:"BrtEndSXTHItem"},332:{n:"BrtBeginMetadata"},333:{n:"BrtEndMetadata"},334:{n:"BrtBeginEsmdtinfo"},335:{n:"BrtMdtinfo"},336:{n:"BrtEndEsmdtinfo"},337:{n:"BrtBeginEsmdb"},338:{n:"BrtEndEsmdb"},339:{n:"BrtBeginEsfmd"},340:{n:"BrtEndEsfmd"},341:{n:"BrtBeginSingleCells"},342:{n:"BrtEndSingleCells"},343:{n:"BrtBeginList"},344:{n:"BrtEndList"},345:{n:"BrtBeginListCols"},346:{n:"BrtEndListCols"},347:{n:"BrtBeginListCol"},348:{n:"BrtEndListCol"},349:{n:"BrtBeginListXmlCPr"},350:{n:"BrtEndListXmlCPr"},351:{n:"BrtListCCFmla"},352:{n:"BrtListTrFmla"},353:{n:"BrtBeginExternals"},354:{n:"BrtEndExternals"},355:{n:"BrtSupBookSrc",f:Nt},357:{n:"BrtSupSelf"},358:{n:"BrtSupSame"},359:{n:"BrtSupTabs"},360:{n:"BrtBeginSupBook"},361:{n:"BrtPlaceholderName"},362:{n:"BrtExternSheet",f:ps},363:{n:"BrtExternTableStart"},364:{n:"BrtExternTableEnd"},366:{n:"BrtExternRowHdr"},367:{n:"BrtExternCellBlank"},368:{n:"BrtExternCellReal"},369:{n:"BrtExternCellBool"},370:{n:"BrtExternCellError"},371:{n:"BrtExternCellString"},372:{n:"BrtBeginEsmdx"},373:{n:"BrtEndEsmdx"},374:{n:"BrtBeginMdxSet"},375:{n:"BrtEndMdxSet"},376:{n:"BrtBeginMdxMbrProp"},377:{n:"BrtEndMdxMbrProp"},378:{n:"BrtBeginMdxKPI"},379:{n:"BrtEndMdxKPI"},380:{n:"BrtBeginEsstr"},381:{n:"BrtEndEsstr"},382:{n:"BrtBeginPRFItem"},383:{n:"BrtEndPRFItem"},384:{n:"BrtBeginPivotCacheIDs"},385:{n:"BrtEndPivotCacheIDs"},386:{n:"BrtBeginPivotCacheID"},387:{n:"BrtEndPivotCacheID"},388:{n:"BrtBeginISXVIs"},389:{n:"BrtEndISXVIs"},390:{n:"BrtBeginColInfos"},391:{n:"BrtEndColInfos"},392:{n:"BrtBeginRwBrk"},393:{n:"BrtEndRwBrk"},394:{n:"BrtBeginColBrk"},395:{n:"BrtEndColBrk"},396:{n:"BrtBrk"},397:{n:"BrtUserBookView"},398:{n:"BrtInfo"},399:{n:"BrtCUsr"},400:{n:"BrtUsr"},401:{n:"BrtBeginUsers"},403:{n:"BrtEOF"},404:{n:"BrtUCR"},405:{n:"BrtRRInsDel"},406:{n:"BrtRREndInsDel"},407:{n:"BrtRRMove"},408:{n:"BrtRREndMove"},409:{n:"BrtRRChgCell"},410:{n:"BrtRREndChgCell"},411:{n:"BrtRRHeader"},412:{n:"BrtRRUserView"},413:{n:"BrtRRRenSheet"},414:{n:"BrtRRInsertSh"},415:{n:"BrtRRDefName"},416:{n:"BrtRRNote"},417:{n:"BrtRRConflict"},418:{n:"BrtRRTQSIF"},419:{n:"BrtRRFormat"},420:{n:"BrtRREndFormat"},421:{n:"BrtRRAutoFmt"},422:{n:"BrtBeginUserShViews"},423:{n:"BrtBeginUserShView"},424:{n:"BrtEndUserShView"},425:{n:"BrtEndUserShViews"},426:{n:"BrtArrFmla",f:id},427:{n:"BrtShrFmla",f:sd},428:{n:"BrtTable"},429:{n:"BrtBeginExtConnections"},430:{n:"BrtEndExtConnections"},431:{n:"BrtBeginPCDCalcMems"},432:{n:"BrtEndPCDCalcMems"},433:{n:"BrtBeginPCDCalcMem"},434:{n:"BrtEndPCDCalcMem"},435:{n:"BrtBeginPCDHGLevels"},436:{n:"BrtEndPCDHGLevels"},437:{n:"BrtBeginPCDHGLevel"},438:{n:"BrtEndPCDHGLevel"},439:{n:"BrtBeginPCDHGLGroups"},440:{n:"BrtEndPCDHGLGroups"},441:{n:"BrtBeginPCDHGLGroup"},442:{n:"BrtEndPCDHGLGroup"},443:{n:"BrtBeginPCDHGLGMembers"},444:{n:"BrtEndPCDHGLGMembers"},445:{n:"BrtBeginPCDHGLGMember"},446:{n:"BrtEndPCDHGLGMember"},447:{n:"BrtBeginQSI"},448:{n:"BrtEndQSI"},449:{n:"BrtBeginQSIR"},450:{n:"BrtEndQSIR"},451:{n:"BrtBeginDeletedNames"},452:{n:"BrtEndDeletedNames"},453:{n:"BrtBeginDeletedName"},454:{n:"BrtEndDeletedName"},455:{n:"BrtBeginQSIFs"},456:{n:"BrtEndQSIFs"},457:{n:"BrtBeginQSIF"},458:{n:"BrtEndQSIF"},459:{n:"BrtBeginAutoSortScope"},460:{n:"BrtEndAutoSortScope"},461:{n:"BrtBeginConditionalFormatting"},462:{n:"BrtEndConditionalFormatting"},463:{n:"BrtBeginCFRule"},464:{n:"BrtEndCFRule"},465:{n:"BrtBeginIconSet"},466:{n:"BrtEndIconSet"},467:{n:"BrtBeginDatabar"},468:{n:"BrtEndDatabar"},469:{n:"BrtBeginColorScale"},470:{n:"BrtEndColorScale"},471:{n:"BrtCFVO"},472:{n:"BrtExternValueMeta"},473:{n:"BrtBeginColorPalette"},474:{n:"BrtEndColorPalette"},475:{n:"BrtIndexedColor"},476:{n:"BrtMargins",f:ld},477:{n:"BrtPrintOptions"},478:{n:"BrtPageSetup"},479:{n:"BrtBeginHeaderFooter"},480:{n:"BrtEndHeaderFooter"},481:{n:"BrtBeginSXCrtFormat"},482:{n:"BrtEndSXCrtFormat"},483:{n:"BrtBeginSXCrtFormats"},484:{n:"BrtEndSXCrtFormats"},485:{n:"BrtWsFmtInfo",f:Ou},486:{n:"BrtBeginMgs"},487:{n:"BrtEndMGs"},488:{n:"BrtBeginMGMaps"},489:{n:"BrtEndMGMaps"},490:{n:"BrtBeginMG"},491:{n:"BrtEndMG"},492:{n:"BrtBeginMap"},493:{n:"BrtEndMap"},494:{n:"BrtHLink",f:ad},495:{n:"BrtBeginDCon"},496:{n:"BrtEndDCon"},497:{n:"BrtBeginDRefs"},498:{n:"BrtEndDRefs"},499:{n:"BrtDRef"},500:{n:"BrtBeginScenMan"},501:{n:"BrtEndScenMan"},502:{n:"BrtBeginSct"},503:{n:"BrtEndSct"},504:{n:"BrtSlc"},505:{n:"BrtBeginDXFs"},506:{n:"BrtEndDXFs"},507:{n:"BrtDXF"},508:{n:"BrtBeginTableStyles"},509:{n:"BrtEndTableStyles"},510:{n:"BrtBeginTableStyle"},511:{n:"BrtEndTableStyle"},512:{n:"BrtTableStyleElement"},513:{n:"BrtTableStyleClient"},514:{n:"BrtBeginVolDeps"},515:{n:"BrtEndVolDeps"},516:{n:"BrtBeginVolType"},517:{n:"BrtEndVolType"},518:{n:"BrtBeginVolMain"},519:{n:"BrtEndVolMain"},520:{n:"BrtBeginVolTopic"},521:{n:"BrtEndVolTopic"},522:{n:"BrtVolSubtopic"},523:{n:"BrtVolRef"},524:{n:"BrtVolNum"},525:{n:"BrtVolErr"},526:{n:"BrtVolStr"},527:{n:"BrtVolBool"},528:{n:"BrtBeginCalcChain$"},529:{n:"BrtEndCalcChain$"},530:{n:"BrtBeginSortState"},531:{n:"BrtEndSortState"},532:{n:"BrtBeginSortCond"},533:{n:"BrtEndSortCond"},534:{n:"BrtBookProtection"},535:{n:"BrtSheetProtection"},536:{n:"BrtRangeProtection"},537:{n:"BrtPhoneticInfo"},538:{n:"BrtBeginECTxtWiz"},539:{n:"BrtEndECTxtWiz"},540:{n:"BrtBeginECTWFldInfoLst"},541:{n:"BrtEndECTWFldInfoLst"},542:{n:"BrtBeginECTwFldInfo"},548:{n:"BrtFileSharing"},549:{n:"BrtOleSize"},550:{n:"BrtDrawing",f:Nt},551:{n:"BrtLegacyDrawing"},552:{n:"BrtLegacyDrawingHF"},553:{n:"BrtWebOpt"},554:{n:"BrtBeginWebPubItems"},555:{n:"BrtEndWebPubItems"},556:{n:"BrtBeginWebPubItem"},557:{n:"BrtEndWebPubItem"},558:{n:"BrtBeginSXCondFmt"},559:{n:"BrtEndSXCondFmt"},560:{n:"BrtBeginSXCondFmts"},561:{n:"BrtEndSXCondFmts"},562:{n:"BrtBkHim"},564:{n:"BrtColor"},565:{n:"BrtBeginIndexedColors"},566:{n:"BrtEndIndexedColors"},569:{n:"BrtBeginMRUColors"},570:{n:"BrtEndMRUColors"},572:{n:"BrtMRUColor"},573:{n:"BrtBeginDVals"},574:{n:"BrtEndDVals"},577:{n:"BrtSupNameStart"},578:{n:"BrtSupNameValueStart"},579:{n:"BrtSupNameValueEnd"},580:{n:"BrtSupNameNum"},581:{n:"BrtSupNameErr"},582:{n:"BrtSupNameSt"},583:{n:"BrtSupNameNil"},584:{n:"BrtSupNameBool"},585:{n:"BrtSupNameFmla"},586:{n:"BrtSupNameBits"},587:{n:"BrtSupNameEnd"},588:{n:"BrtEndSupBook"},589:{n:"BrtCellSmartTagProperty"},590:{n:"BrtBeginCellSmartTag"},591:{n:"BrtEndCellSmartTag"},592:{n:"BrtBeginCellSmartTags"},593:{n:"BrtEndCellSmartTags"},594:{n:"BrtBeginSmartTags"},595:{n:"BrtEndSmartTags"},596:{n:"BrtSmartTagType"},597:{n:"BrtBeginSmartTagTypes"},598:{n:"BrtEndSmartTagTypes"},599:{n:"BrtBeginSXFilters"},600:{n:"BrtEndSXFilters"},601:{n:"BrtBeginSXFILTER"},602:{n:"BrtEndSXFilter"},603:{n:"BrtBeginFills"},604:{n:"BrtEndFills"},605:{n:"BrtBeginCellWatches"},606:{n:"BrtEndCellWatches"},607:{n:"BrtCellWatch"},608:{n:"BrtBeginCRErrs"},609:{n:"BrtEndCRErrs"},610:{n:"BrtCrashRecErr"},611:{n:"BrtBeginFonts"},612:{n:"BrtEndFonts"},613:{n:"BrtBeginBorders"},614:{n:"BrtEndBorders"},615:{n:"BrtBeginFmts"},616:{n:"BrtEndFmts"},617:{n:"BrtBeginCellXFs"},618:{n:"BrtEndCellXFs"},619:{n:"BrtBeginStyles"},620:{n:"BrtEndStyles"},625:{n:"BrtBigName"},626:{n:"BrtBeginCellStyleXFs"},627:{n:"BrtEndCellStyleXFs"},628:{n:"BrtBeginComments"},629:{n:"BrtEndComments"},630:{n:"BrtBeginCommentAuthors"},631:{n:"BrtEndCommentAuthors"},632:{n:"BrtCommentAuthor",f:Dl},633:{n:"BrtBeginCommentList"},634:{n:"BrtEndCommentList"},635:{n:"BrtBeginComment",f:Il},636:{n:"BrtEndComment"},637:{n:"BrtCommentText",f:Tt},638:{n:"BrtBeginOleObjects"},639:{n:"BrtOleObject"},640:{n:"BrtEndOleObjects"},641:{n:"BrtBeginSxrules"},642:{n:"BrtEndSxRules"},643:{n:"BrtBeginActiveXControls"},644:{n:"BrtActiveX"},645:{n:"BrtEndActiveXControls"},646:{n:"BrtBeginPCDSDTCEMembersSortBy"},648:{n:"BrtBeginCellIgnoreECs"},649:{n:"BrtCellIgnoreEC"},650:{n:"BrtEndCellIgnoreECs"},651:{n:"BrtCsProp",f:Fd},652:{n:"BrtCsPageSetup"},653:{n:"BrtBeginUserCsViews"},654:{n:"BrtEndUserCsViews"},655:{n:"BrtBeginUserCsView"},656:{n:"BrtEndUserCsView"},657:{n:"BrtBeginPcdSFCIEntries"},658:{n:"BrtEndPCDSFCIEntries"},659:{n:"BrtPCDSFCIEntry"},660:{n:"BrtBeginListParts"},661:{n:"BrtListPart"},662:{n:"BrtEndListParts"},663:{n:"BrtSheetCalcProp"},664:{n:"BrtBeginFnGroup"},665:{n:"BrtFnGroup"},666:{n:"BrtEndFnGroup"},667:{n:"BrtSupAddin"},668:{n:"BrtSXTDMPOrder"},669:{n:"BrtCsProtection"},671:{n:"BrtBeginWsSortMap"},672:{n:"BrtEndWsSortMap"},673:{n:"BrtBeginRRSort"},674:{n:"BrtEndRRSort"},675:{n:"BrtRRSortItem"},676:{n:"BrtFileSharingIso"},677:{n:"BrtBookProtectionIso"},678:{n:"BrtSheetProtectionIso"},679:{n:"BrtCsProtectionIso"},680:{n:"BrtRangeProtectionIso"},1024:{n:"BrtRwDescent"},1025:{n:"BrtKnownFonts"},1026:{n:"BrtBeginSXTupleSet"},1027:{n:"BrtEndSXTupleSet"},1028:{n:"BrtBeginSXTupleSetHeader"},1029:{n:"BrtEndSXTupleSetHeader"},1030:{n:"BrtSXTupleSetHeaderItem"},1031:{n:"BrtBeginSXTupleSetData"},1032:{n:"BrtEndSXTupleSetData"},1033:{n:"BrtBeginSXTupleSetRow"},1034:{n:"BrtEndSXTupleSetRow"},1035:{n:"BrtSXTupleSetRowItem"},1036:{n:"BrtNameExt"},1037:{n:"BrtPCDH14"},1038:{n:"BrtBeginPCDCalcMem14"},1039:{n:"BrtEndPCDCalcMem14"},1040:{n:"BrtSXTH14"},1041:{n:"BrtBeginSparklineGroup"},1042:{n:"BrtEndSparklineGroup"},1043:{n:"BrtSparkline"},1044:{n:"BrtSXDI14"},1045:{n:"BrtWsFmtInfoEx14"},1046:{n:"BrtBeginConditionalFormatting14"},1047:{n:"BrtEndConditionalFormatting14"},1048:{n:"BrtBeginCFRule14"},1049:{n:"BrtEndCFRule14"},1050:{n:"BrtCFVO14"},1051:{n:"BrtBeginDatabar14"},1052:{n:"BrtBeginIconSet14"},1053:{n:"BrtDVal14"},1054:{n:"BrtBeginDVals14"},1055:{n:"BrtColor14"},1056:{n:"BrtBeginSparklines"},1057:{n:"BrtEndSparklines"},1058:{n:"BrtBeginSparklineGroups"},1059:{n:"BrtEndSparklineGroups"},1061:{n:"BrtSXVD14"},1062:{n:"BrtBeginSXView14"},1063:{n:"BrtEndSXView14"},1064:{n:"BrtBeginSXView16"},1065:{n:"BrtEndSXView16"},1066:{n:"BrtBeginPCD14"},1067:{n:"BrtEndPCD14"},1068:{n:"BrtBeginExtConn14"},1069:{n:"BrtEndExtConn14"},1070:{n:"BrtBeginSlicerCacheIDs"},1071:{n:"BrtEndSlicerCacheIDs"},1072:{n:"BrtBeginSlicerCacheID"},1073:{n:"BrtEndSlicerCacheID"},1075:{n:"BrtBeginSlicerCache"},1076:{n:"BrtEndSlicerCache"},1077:{n:"BrtBeginSlicerCacheDef"},1078:{n:"BrtEndSlicerCacheDef"},1079:{n:"BrtBeginSlicersEx"},1080:{n:"BrtEndSlicersEx"},1081:{n:"BrtBeginSlicerEx"},1082:{n:"BrtEndSlicerEx"},1083:{n:"BrtBeginSlicer"},1084:{n:"BrtEndSlicer"},1085:{n:"BrtSlicerCachePivotTables"},1086:{n:"BrtBeginSlicerCacheOlapImpl"},1087:{n:"BrtEndSlicerCacheOlapImpl"},1088:{n:"BrtBeginSlicerCacheLevelsData"},1089:{n:"BrtEndSlicerCacheLevelsData"},1090:{n:"BrtBeginSlicerCacheLevelData"},1091:{n:"BrtEndSlicerCacheLevelData"},1092:{n:"BrtBeginSlicerCacheSiRanges"},1093:{n:"BrtEndSlicerCacheSiRanges"},1094:{n:"BrtBeginSlicerCacheSiRange"},1095:{n:"BrtEndSlicerCacheSiRange"},1096:{n:"BrtSlicerCacheOlapItem"},1097:{n:"BrtBeginSlicerCacheSelections"},1098:{n:"BrtSlicerCacheSelection"},1099:{n:"BrtEndSlicerCacheSelections"},1100:{n:"BrtBeginSlicerCacheNative"},1101:{n:"BrtEndSlicerCacheNative"},1102:{n:"BrtSlicerCacheNativeItem"},1103:{n:"BrtRangeProtection14"},1104:{n:"BrtRangeProtectionIso14"},1105:{n:"BrtCellIgnoreEC14"},1111:{n:"BrtList14"},1112:{n:"BrtCFIcon"},1113:{n:"BrtBeginSlicerCachesPivotCacheIDs"},1114:{n:"BrtEndSlicerCachesPivotCacheIDs"},1115:{n:"BrtBeginSlicers"},1116:{n:"BrtEndSlicers"},1117:{n:"BrtWbProp14"},1118:{n:"BrtBeginSXEdit"},1119:{n:"BrtEndSXEdit"},1120:{n:"BrtBeginSXEdits"},1121:{n:"BrtEndSXEdits"},1122:{n:"BrtBeginSXChange"},1123:{n:"BrtEndSXChange"},1124:{n:"BrtBeginSXChanges"},1125:{n:"BrtEndSXChanges"},1126:{n:"BrtSXTupleItems"},1128:{n:"BrtBeginSlicerStyle"},1129:{n:"BrtEndSlicerStyle"},1130:{n:"BrtSlicerStyleElement"},1131:{n:"BrtBeginStyleSheetExt14"},1132:{n:"BrtEndStyleSheetExt14"},1133:{n:"BrtBeginSlicerCachesPivotCacheID"},1134:{n:"BrtEndSlicerCachesPivotCacheID"},1135:{n:"BrtBeginConditionalFormattings"},1136:{n:"BrtEndConditionalFormattings"},1137:{n:"BrtBeginPCDCalcMemExt"},1138:{n:"BrtEndPCDCalcMemExt"},1139:{n:"BrtBeginPCDCalcMemsExt"},1140:{n:"BrtEndPCDCalcMemsExt"},1141:{n:"BrtPCDField14"},1142:{n:"BrtBeginSlicerStyles"},1143:{n:"BrtEndSlicerStyles"},1144:{n:"BrtBeginSlicerStyleElements"},1145:{n:"BrtEndSlicerStyleElements"},1146:{n:"BrtCFRuleExt"},1147:{n:"BrtBeginSXCondFmt14"},1148:{n:"BrtEndSXCondFmt14"},1149:{n:"BrtBeginSXCondFmts14"},1150:{n:"BrtEndSXCondFmts14"},1152:{n:"BrtBeginSortCond14"},1153:{n:"BrtEndSortCond14"},1154:{n:"BrtEndDVals14"},1155:{n:"BrtEndIconSet14"},1156:{n:"BrtEndDatabar14"},1157:{n:"BrtBeginColorScale14"},1158:{n:"BrtEndColorScale14"},1159:{n:"BrtBeginSxrules14"},1160:{n:"BrtEndSxrules14"},1161:{n:"BrtBeginPRule14"},1162:{n:"BrtEndPRule14"},1163:{n:"BrtBeginPRFilters14"},1164:{n:"BrtEndPRFilters14"},1165:{n:"BrtBeginPRFilter14"},1166:{n:"BrtEndPRFilter14"},1167:{n:"BrtBeginPRFItem14"},1168:{n:"BrtEndPRFItem14"},1169:{n:"BrtBeginCellIgnoreECs14"},1170:{n:"BrtEndCellIgnoreECs14"},1171:{n:"BrtDxf14"},1172:{n:"BrtBeginDxF14s"},1173:{n:"BrtEndDxf14s"},1177:{n:"BrtFilter14"},1178:{n:"BrtBeginCustomFilters14"},1180:{n:"BrtCustomFilter14"},1181:{n:"BrtIconFilter14"},1182:{n:"BrtPivotCacheConnectionName"},2048:{n:"BrtBeginDecoupledPivotCacheIDs"},2049:{n:"BrtEndDecoupledPivotCacheIDs"},2050:{n:"BrtDecoupledPivotCacheID"},2051:{n:"BrtBeginPivotTableRefs"},2052:{n:"BrtEndPivotTableRefs"},2053:{n:"BrtPivotTableRef"},2054:{n:"BrtSlicerCacheBookPivotTables"},2055:{n:"BrtBeginSxvcells"},2056:{n:"BrtEndSxvcells"},2057:{n:"BrtBeginSxRow"},2058:{n:"BrtEndSxRow"},2060:{n:"BrtPcdCalcMem15"},2067:{n:"BrtQsi15"},2068:{n:"BrtBeginWebExtensions"},2069:{n:"BrtEndWebExtensions"},2070:{n:"BrtWebExtension"},2071:{n:"BrtAbsPath15"},2072:{n:"BrtBeginPivotTableUISettings"},2073:{n:"BrtEndPivotTableUISettings"},2075:{n:"BrtTableSlicerCacheIDs"},2076:{n:"BrtTableSlicerCacheID"},2077:{n:"BrtBeginTableSlicerCache"},2078:{n:"BrtEndTableSlicerCache"},2079:{n:"BrtSxFilter15"},2080:{n:"BrtBeginTimelineCachePivotCacheIDs"},2081:{n:"BrtEndTimelineCachePivotCacheIDs"},2082:{n:"BrtTimelineCachePivotCacheID"},2083:{n:"BrtBeginTimelineCacheIDs"},2084:{n:"BrtEndTimelineCacheIDs"},2085:{n:"BrtBeginTimelineCacheID"},2086:{n:"BrtEndTimelineCacheID"},2087:{n:"BrtBeginTimelinesEx"},2088:{n:"BrtEndTimelinesEx"},2089:{n:"BrtBeginTimelineEx"},2090:{n:"BrtEndTimelineEx"},2091:{n:"BrtWorkBookPr15"},2092:{n:"BrtPCDH15"},2093:{n:"BrtBeginTimelineStyle"},2094:{n:"BrtEndTimelineStyle"},2095:{n:"BrtTimelineStyleElement"},2096:{n:"BrtBeginTimelineStylesheetExt15"},2097:{n:"BrtEndTimelineStylesheetExt15"},2098:{n:"BrtBeginTimelineStyles"},2099:{n:"BrtEndTimelineStyles"},2100:{n:"BrtBeginTimelineStyleElements"},2101:{n:"BrtEndTimelineStyleElements"},2102:{n:"BrtDxf15"},2103:{n:"BrtBeginDxfs15"},2104:{n:"brtEndDxfs15"},2105:{n:"BrtSlicerCacheHideItemsWithNoData"},2106:{n:"BrtBeginItemUniqueNames"},2107:{n:"BrtEndItemUniqueNames"},2108:{n:"BrtItemUniqueName"},2109:{n:"BrtBeginExtConn15"},2110:{n:"BrtEndExtConn15"},2111:{n:"BrtBeginOledbPr15"},2112:{n:"BrtEndOledbPr15"},2113:{n:"BrtBeginDataFeedPr15"},2114:{n:"BrtEndDataFeedPr15"},2115:{n:"BrtTextPr15"},2116:{n:"BrtRangePr15"},2117:{n:"BrtDbCommand15"},2118:{n:"BrtBeginDbTables15"},2119:{n:"BrtEndDbTables15"},2120:{n:"BrtDbTable15"},2121:{n:"BrtBeginDataModel"},2122:{n:"BrtEndDataModel"},2123:{n:"BrtBeginModelTables"},2124:{n:"BrtEndModelTables"},2125:{n:"BrtModelTable"},2126:{n:"BrtBeginModelRelationships"},2127:{n:"BrtEndModelRelationships"},2128:{n:"BrtModelRelationship"},2129:{n:"BrtBeginECTxtWiz15"},2130:{n:"BrtEndECTxtWiz15"},2131:{n:"BrtBeginECTWFldInfoLst15"},2132:{n:"BrtEndECTWFldInfoLst15"},2133:{n:"BrtBeginECTWFldInfo15"},2134:{n:"BrtFieldListActiveItem"},2135:{n:"BrtPivotCacheIdVersion"},2136:{n:"BrtSXDI15"},2137:{n:"BrtBeginModelTimeGroupings"},2138:{n:"BrtEndModelTimeGroupings"},2139:{n:"BrtBeginModelTimeGrouping"},2140:{n:"BrtEndModelTimeGrouping"},2141:{n:"BrtModelTimeGroupingCalcCol"},3072:{n:"BrtUid"},3073:{n:"BrtRevisionPtr"},5095:{n:"BrtBeginCalcFeatures"},5096:{n:"BrtEndCalcFeatures"},5097:{n:"BrtCalcFeature"},65535:{n:""}};var uv=K(hv,"n");var dv={3:{n:"BIFF2NUM",f:js},4:{n:"BIFF2STR",f:Gs},6:{n:"Formula",f:Rh},9:{n:"BOF",f:Si},10:{n:"EOF",f:Pn},12:{n:"CalcCount",f:Hn},13:{n:"CalcMode",f:Hn},14:{n:"CalcPrecision",f:Mn},15:{n:"CalcRefMode",f:Mn},16:{n:"CalcDelta",f:Xt},17:{n:"CalcIter",f:Mn},18:{n:"Protect",f:Mn},19:{n:"Password",f:Hn},20:{n:"Header",f:ls},21:{n:"Footer",f:ls},23:{n:"ExternSheet",f:ps},24:{n:"Lbl",f:ds},25:{n:"WinProtect",f:Mn},26:{n:"VerticalPageBreaks"},27:{n:"HorizontalPageBreaks"},28:{n:"Note",f:Es},29:{n:"Selection"},34:{n:"Date1904",f:Mn},35:{n:"ExternName",f:hs},38:{n:"LeftMargin",f:Xt},39:{n:"RightMargin",f:Xt},40:{n:"TopMargin",f:Xt},41:{n:"BottomMargin",f:Xt},42:{n:"PrintRowCol",f:Mn},43:{n:"PrintGrid",f:Mn},47:{n:"FilePass",f:Gf},49:{n:"Font",f:Wi},51:{n:"PrintSize",f:Hn},60:{n:"Continue"},61:{n:"Window1",f:Li},64:{n:"Backup",f:Mn},65:{n:"Pane"},66:{n:"CodePage",f:Hn},77:{n:"Pls"},80:{n:"DCon"},81:{n:"DConRef"},82:{n:"DConName"},85:{n:"DefColWidth",f:Hn},89:{n:"XCT"},90:{n:"CRN"},91:{n:"FileSharing"},92:{n:"WriteAccess",f:Bi},93:{n:"Obj",f:As},94:{n:"Uncalced"},95:{n:"CalcSaveRecalc",f:Mn},96:{n:"Template"},97:{n:"Intl"},99:{n:"ObjProtect",f:Mn},125:{n:"ColInfo",f:Ls},128:{n:"Guts",f:as},129:{n:"WsBool",f:yi},130:{n:"GridSet",f:Hn},131:{n:"HCenter",f:Mn},132:{n:"VCenter",f:Mn},133:{n:"BoundSheet8",f:xi},134:{n:"WriteProtect"},140:{n:"Country",f:Ds},141:{n:"HideObj",f:Hn},144:{n:"Sort"},146:{n:"Palette",f:Ps},151:{n:"Sync"},152:{n:"LPr"},153:{n:"DxGCol"},154:{n:"FnGroupName"},155:{n:"FilterMode"},156:{n:"BuiltInFnGroupCount",f:Hn},157:{n:"AutoFilterInfo"},158:{n:"AutoFilter"},160:{n:"Scl",f:Vs},161:{n:"Setup",f:Ms},174:{n:"ScenMan"},175:{n:"SCENARIO"},176:{n:"SxView"},177:{n:"Sxvd"},178:{n:"SXVI"},180:{n:"SxIvd"},181:{n:"SXLI"},182:{n:"SXPI"},184:{n:"DocRoute"},185:{n:"RecipName"},189:{n:"MulRk",f:Ji},190:{n:"MulBlank",f:qi},193:{n:"Mms",f:Pn},197:{n:"SXDI"},198:{n:"SXDB"},199:{n:"SXFDB"},200:{n:"SXDBB"},201:{n:"SXNum"},202:{n:"SxBool",f:Mn},203:{n:"SxErr"},204:{n:"SXInt"},205:{n:"SXString"},206:{n:"SXDtr"},207:{n:"SxNil"},208:{n:"SXTbl"},209:{n:"SXTBRGIITM"},210:{n:"SxTbpg"},211:{n:"ObProj"},213:{n:"SXStreamID"},215:{n:"DBCell"},216:{n:"SXRng"},217:{n:"SxIsxoper"},218:{n:"BookBool",f:Hn},220:{n:"DbOrParamQry"},221:{n:"ScenarioProtect",f:Mn},222:{n:"OleObjectSize"},224:{n:"XF",f:rs},225:{n:"InterfaceHdr",f:_i},226:{n:"InterfaceEnd",f:Pn},227:{n:"SXVS"},229:{n:"MergeCells",f:ks},233:{n:"BkHim"},235:{n:"MsoDrawingGroup"},236:{n:"MsoDrawing"},237:{n:"MsoDrawingSelection"},239:{n:"PhoneticInfo"},240:{n:"SxRule"},241:{n:"SXEx"},242:{n:"SxFilt"},244:{n:"SxDXF"},245:{n:"SxItm"},246:{n:"SxName"},247:{n:"SxSelect"},248:{n:"SXPair"},249:{n:"SxFmla"},251:{n:"SxFormat"},252:{n:"SST",f:Ri},253:{n:"LabelSst",f:zi},255:{n:"ExtSST",f:Di},256:{n:"SXVDEx"},259:{n:"SXFormula"},290:{n:"SXDBEx"},311:{n:"RRDInsDel"},312:{n:"RRDHead"},315:{n:"RRDChgCell"},317:{n:"RRTabId",f:Vn},318:{n:"RRDRenSheet"},319:{n:"RRSort"},320:{n:"RRDMove"},330:{n:"RRFormat"},331:{n:"RRAutoFmt"},333:{n:"RRInsertSh"},334:{n:"RRDMoveBegin"},335:{n:"RRDMoveEnd"},336:{n:"RRDInsDelBegin"},337:{n:"RRDInsDelEnd"},338:{n:"RRDConflict"},339:{n:"RRDDefName"},340:{n:"RRDRstEtxp"},351:{n:"LRng"},352:{n:"UsesELFs",f:Mn},353:{n:"DSF",f:Pn},401:{n:"CUsr"},402:{n:"CbUsr"},403:{n:"UsrInfo"},404:{n:"UsrExcl"},405:{n:"FileLock"},406:{n:"RRDInfo"},407:{n:"BCUsrs"},408:{n:"UsrChk"},425:{n:"UserBView"},426:{n:"UserSViewBegin"},427:{n:"UserSViewEnd"},428:{n:"RRDUserView"},429:{n:"Qsi"},430:{n:"SupBook",f:cs},431:{n:"Prot4Rev",f:Mn},432:{n:"CondFmt"},433:{n:"CF"},434:{n:"DVal"},437:{n:"DConBin"},438:{n:"TxO",f:Ts},439:{n:"RefreshAll",f:Mn},440:{n:"HLink",f:ys},441:{n:"Lel"},442:{n:"CodeName",f:Yn},443:{n:"SXFDBType"},444:{n:"Prot4RevPass",f:Hn},445:{n:"ObNoMacros"},446:{n:"Dv"},448:{n:"Excel9File",f:Pn},449:{n:"RecalcId",f:Pi,r:2},450:{n:"EntExU2",f:Pn},512:{n:"Dimensions",f:$i},513:{n:"Blank",f:Ws},515:{n:"Number",f:fs},516:{n:"Label",f:Xi},517:{n:"BoolErr",f:is},518:{n:"Formula",f:Rh},519:{n:"String",f:zs},520:{n:"Row",f:Fi},523:{n:"Index"},545:{n:"Array",f:bs},549:{n:"DefaultRowHeight",f:Ni},566:{n:"Table"},574:{n:"Window2",f:Ui},638:{n:"RK",f:Qi},659:{n:"Style"},1030:{n:"Formula",f:Rh},1048:{n:"BigName"},1054:{n:"Format",f:ji},1084:{n:"ContinueBigName"},1212:{n:"ShrFmla",f:ms},2048:{n:"HLinkTooltip",f:Is},2049:{n:"WebPub"},2050:{n:"QsiSXTag"},2051:{n:"DBQueryExt"},2052:{n:"ExtString"},2053:{n:"TxtQry"},2054:{n:"Qsir"},2055:{n:"Qsif"},2056:{n:"RRDTQSIF"},2057:{n:"BOF",f:Si},2058:{n:"OleDbConn"},2059:{n:"WOpt"},2060:{n:"SXViewEx"},2061:{n:"SXTH"},2062:{n:"SXPIEx"},2063:{n:"SXVDTEx"},2064:{n:"SXViewEx9"},2066:{n:"ContinueFrt"},2067:{n:"RealTimeData"},2128:{n:"ChartFrtInfo"},2129:{n:"FrtWrapper"},2130:{n:"StartBlock"},2131:{n:"EndBlock"},2132:{n:"StartObject"},2133:{n:"EndObject"},2134:{n:"CatLab"},2135:{n:"YMult"},2136:{n:"SXViewLink"},2137:{n:"PivotChartBits"},2138:{n:"FrtFontList"},2146:{n:"SheetExt"},2147:{n:"BookExt",r:12},2148:{n:"SXAddl"},2149:{n:"CrErr"},2150:{n:"HFPicture"},2151:{n:"FeatHdr",f:Pn},2152:{n:"Feat"},2154:{n:"DataLabExt"},2155:{n:"DataLabExtContents"},2156:{n:"CellWatch"},2161:{n:"FeatHdr11"},2162:{n:"Feature11"},2164:{n:"DropDownObjIds"},2165:{n:"ContinueFrt11"},2166:{n:"DConn"},2167:{n:"List12"},2168:{n:"Feature12"},2169:{n:"CondFmt12"},2170:{n:"CF12"},2171:{n:"CFEx"},2172:{n:"XFCRC",f:Ns,r:12},2173:{n:"XFExt",f:vl,r:12},2174:{n:"AutoFilter12"},2175:{n:"ContinueFrt12"},2180:{n:"MDTInfo"},2181:{n:"MDXStr"},2182:{n:"MDXTuple"},2183:{n:"MDXSet"},2184:{n:"MDXProp"},2185:{n:"MDXKPI"},2186:{n:"MDB"},2187:{n:"PLV"},2188:{n:"Compat12",f:Mn,r:12},2189:{n:"DXF"},2190:{n:"TableStyles",r:12},2191:{n:"TableStyle"},2192:{n:"TableStyleElement"},2194:{n:"StyleExt"},2195:{n:"NamePublish"},2196:{n:"NameCmt",f:gs,r:12},2197:{n:"SortData"},2198:{n:"Theme",f:ll,r:12},2199:{n:"GUIDTypeLib"},2200:{n:"FnGrp12"},2201:{n:"NameFnGrp12"},2202:{n:"MTRSettings",f:ws,r:12},2203:{n:"CompressPictures",f:Pn},2204:{n:"HeaderFooter"},2205:{n:"CrtLayout12"},2206:{n:"CrtMlFrt"},2207:{n:"CrtMlFrtContinue"},2211:{n:"ForceFullCalculation",f:Oi},2212:{n:"ShapePropsStream"},2213:{n:"TextPropsStream"},2214:{n:"RichTextStream"},2215:{n:"CrtLayout12A"},4097:{n:"Units"},4098:{n:"Chart"},4099:{n:"Series"},4102:{n:"DataFormat"},4103:{n:"LineFormat"},4105:{n:"MarkerFormat"},4106:{n:"AreaFormat"},4107:{n:"PieFormat"},4108:{n:"AttachedLabel"},4109:{n:"SeriesText"},4116:{n:"ChartFormat"},4117:{n:"Legend"},4118:{n:"SeriesList"},4119:{n:"Bar"},4120:{n:"Line"},4121:{n:"Pie"},4122:{n:"Area"},4123:{n:"Scatter"},4124:{n:"CrtLine"},4125:{n:"Axis"},4126:{n:"Tick"},4127:{n:"ValueRange"},4128:{n:"CatSerRange"},4129:{n:"AxisLine"},4130:{n:"CrtLink"},4132:{n:"DefaultText"},4133:{n:"Text"},4134:{n:"FontX",f:Hn},4135:{n:"ObjectLink"},4146:{n:"Frame"},4147:{n:"Begin"},4148:{n:"End"},4149:{n:"PlotArea"},4154:{n:"Chart3d"},4156:{n:"PicF"},4157:{n:"DropBar"},4158:{n:"Radar"},4159:{n:"Surf"},4160:{n:"RadarArea"},4161:{n:"AxisParent"},4163:{n:"LegendException"},4164:{n:"ShtProps",f:Us},4165:{n:"SerToCrt"},4166:{n:"AxesUsed"},4168:{n:"SBaseRef"},4170:{n:"SerParent"},4171:{n:"SerAuxTrend"},4174:{n:"IFmtRecord"},4175:{n:"Pos"},4176:{n:"AlRuns"},4177:{n:"BRAI"},4187:{n:"SerAuxErrBar"},4188:{n:"ClrtClient",f:Os},4189:{n:"SerFmt"},4191:{n:"Chart3DBarShape"},4192:{n:"Fbi"},4193:{n:"BopPop"},4194:{n:"AxcExt"},4195:{n:"Dat"},4196:{n:"PlotGrowth"},4197:{n:"SIIndex"},4198:{n:"GelFrame"},4199:{n:"BopPopCustom"},4200:{n:"Fbi2"},0:{n:"Dimensions",f:$i},2:{n:"BIFF2INT",f:Ys},5:{n:"BoolErr",f:is},7:{n:"String",f:Zs},8:{n:"BIFF2ROW"},11:{n:"Index"},22:{n:"ExternCount",f:Hn},30:{n:"BIFF2FORMAT",f:Yi},31:{n:"BIFF2FMTCNT"},32:{n:"BIFF2COLINFO"},33:{n:"Array",f:bs},37:{n:"DefaultRowHeight",f:Ni},50:{n:"BIFF2FONTXTRA",f:Qs},52:{n:"DDEObjName"},62:{n:"BIFF2WINDOW2"},67:{n:"BIFF2XF"},69:{n:"BIFF2FONTCLR"},86:{n:"BIFF4FMTCNT"},126:{n:"RK"},127:{n:"ImData",f:Xs},135:{n:"Addin"},136:{n:"Edg"},137:{n:"Pub"},145:{n:"Sub"},148:{n:"LHRecord"},149:{n:"LHNGraph"},150:{n:"Sound"},169:{n:"CoordList"},171:{n:"GCW"},188:{n:"ShrFmla"},191:{n:"ToolbarHdr"},192:{n:"ToolbarEnd"},194:{n:"AddMenu"},195:{n:"DelMenu"},214:{n:"RString",f:Js},223:{n:"UDDesc"},234:{n:"TabIdConf"},354:{n:"XL5Modify"},421:{n:"FileSharing2"},521:{n:"BOF",f:Si},536:{n:"Lbl",f:ds},547:{n:"ExternName",f:hs},561:{n:"Font"},579:{n:"BIFF3XF"},1033:{n:"BOF",f:Si},1091:{n:"BIFF4XF"},2157:{n:"FeatInfo"},2163:{n:"FeatInfo11"},2177:{n:"SXAddl12"},2240:{n:"AutoWebPub"},2241:{n:"ListObj"},2242:{n:"ListField"},2243:{n:"ListDV"},2244:{n:"ListCondFmt"},2245:{n:"ListCF"},2246:{n:"FMQry"},2247:{n:"FMSQry"},2248:{n:"PLV"},2249:{n:"LnExt"},2250:{n:"MkrExt"},2251:{n:"CrtCoopt"},2262:{n:"FRTArchId$",r:12},29282:{}};var pv=K(dv,"n");function vv(e,r,t,a){var n=+r||+pv[r];if(isNaN(n))return;var i=a||(t||[]).length||0;var s=e.next(4);s._W(2,n);s._W(2,i);if(i>0&&Ir(t))e.push(t)}function gv(e,r,t){if(!e)e=Gr(7);e._W(2,r);e._W(2,t);e._W(2,0);e._W(1,0);return e}function mv(e,r,t,a){var n=Gr(9);gv(n,e,r);if(a=="e"){n._W(1,t);n._W(1,1)}else{n._W(1,t?1:0);n._W(1,0)}return n}function bv(e,r,t){var a=Gr(8+2*t.length);gv(a,e,r);a._W(1,t.length);a._W(t.length,t,"sbcs");return a.l<a.length?a.slice(0,a.l):a}function wv(e,r,t,a){if(r.v!=null)switch(r.t){case"d":;case"n":var n=r.t=="d"?ee(ie(r.v)):r.v;if(n==(n|0)&&n>=0&&n<65536)vv(e,2,$s(t,a,n));else vv(e,3,Ks(t,a,n));return;case"b":;case"e":vv(e,5,mv(t,a,r.v,r.t));return;case"s":;case"str":vv(e,4,bv(t,a,r.v));return;}vv(e,1,gv(null,t,a))}function Cv(e,r,t,a){var n=Array.isArray(r);var i=pt(r["!ref"]||"A1"),s,f="",o=[];if(i.e.c>255||i.e.r>16383){if(a.WTF)throw new Error("Range "+(r["!ref"]||"A1")+" exceeds format limit A1:IV16384");i.e.c=Math.min(i.e.c,255);i.e.r=Math.min(i.e.c,16383);s=dt(i)}for(var l=i.s.r;l<=i.e.r;++l){f=tt(l);for(var c=i.s.c;c<=i.e.c;++c){if(l===i.s.r)o[c]=st(c);s=o[c]+f;var h=n?(r[l]||[])[c]:r[s];if(!h)continue;wv(e,h,l,c,a)}}}function Ev(e,r){var t=r||{};if(v!=null&&t.dense==null)t.dense=v;var a=Kr();var n=0;for(var i=0;i<e.SheetNames.length;++i)if(e.SheetNames[i]==t.sheet)n=i;if(n==0&&!!t.sheet&&e.SheetNames[0]!=t.sheet)throw new Error("Sheet not found: "+t.sheet);vv(a,9,Ai(e,16,t));Cv(a,e.Sheets[e.SheetNames[n]],n,t,e);vv(a,10);return a.end()}function kv(e,r,t){vv(e,"Font",Vi({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},t))}function Sv(e,r,t){if(!r)return;[[5,8],[23,26],[41,44],[50,392]].forEach(function(a){for(var n=a[0];n<=a[1];++n)if(r[n]!=null)vv(e,"Format",Ki(n,r[n],t))})}function Av(e,r){var t=Gr(19);t._W(4,2151);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,1);t._W(4,0);vv(e,"FeatHdr",t);t=Gr(39);t._W(4,2152);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,0);t._W(4,0);t._W(2,1);t._W(4,4);t._W(2,0);pi(pt(r["!ref"]||"A1"),t);t._W(4,4);vv(e,"Feat",t)}function _v(e,r){for(var t=0;t<16;++t)vv(e,"XF",ts({numFmtId:0,style:true},0,r));r.cellXfs.forEach(function(t){vv(e,"XF",ts(t,0,r))})}function Bv(e,r){for(var t=0;t<r["!links"].length;++t){var a=r["!links"][t];vv(e,"HLink",xs(a));if(a[1].Tooltip)vv(e,"HLinkTooltip",Rs(a))}delete r["!links"]}function Tv(e,r,t,a,n){var i=16+Qh(n.cellXfs,r,n);if(r.v!=null)switch(r.t){case"d":;case"n":var s=r.t=="d"?ee(ie(r.v)):r.v;vv(e,"Number",os(t,a,s,i,n));return;case"b":;case"e":vv(e,517,ss(t,a,r.v,i,n,r.t));return;case"s":;case"str":vv(e,"Label",Gi(t,a,r.v,i,n));return;}vv(e,"Blank",fi(t,a,i))}function yv(e,r,t){var a=Kr();var n=t.SheetNames[e],i=t.Sheets[n]||{};var s=(t||{}).Workbook||{};var f=(s.Sheets||[])[e]||{};var o=Array.isArray(i);var l=r.biff==8;var c,h="",u=[];var d=pt(i["!ref"]||"A1");var p=l?65536:16384;if(d.e.c>255||d.e.r>=p){if(r.WTF)throw new Error("Range "+(i["!ref"]||"A1")+" exceeds format limit A1:IV16384");d.e.c=Math.min(d.e.c,255);d.e.r=Math.min(d.e.c,p-1)}vv(a,2057,Ai(t,16,r));vv(a,"CalcMode",Wn(1));vv(a,"CalcCount",Wn(100));vv(a,"CalcRefMode",Un(true));vv(a,"CalcIter",Un(false));vv(a,"CalcDelta",Gt(.001));vv(a,"CalcSaveRecalc",Un(true));vv(a,"PrintRowCol",Un(false));vv(a,"PrintGrid",Un(false));vv(a,"GridSet",Wn(1));vv(a,"Guts",ns([0,0]));vv(a,"HCenter",Un(false));vv(a,"VCenter",Un(false));vv(a,512,Zi(d,r));if(l)i["!links"]=[];for(var v=d.s.r;v<=d.e.r;++v){h=tt(v);for(var g=d.s.c;g<=d.e.c;++g){if(v===d.s.r)u[g]=st(g);c=u[g]+h;var m=o?(i[v]||[])[g]:i[c];if(!m)continue;Tv(a,m,v,g,r);if(l&&m.l)i["!links"].push([c,m.l])}}var b=f.CodeName||f.name||n;if(l&&s.Views)vv(a,"Window2",Hi(s.Views[0]));if(l&&(i["!merges"]||[]).length)vv(a,"MergeCells",Ss(i["!merges"]));if(l)Bv(a,i);vv(a,"CodeName",Zn(b,r));if(l)Av(a,i);vv(a,"EOF");return a.end()}function xv(e,r,t){var a=Kr();var n=(e||{}).Workbook||{};var i=n.Sheets||[];var s=n.WBProps||{};var f=t.biff==8,o=t.biff==5;vv(a,2057,Ai(e,5,t));if(t.bookType=="xla")vv(a,"Addin");vv(a,"InterfaceHdr",f?Wn(1200):null);vv(a,"Mms",Nn(2));if(o)vv(a,"ToolbarHdr");if(o)vv(a,"ToolbarEnd");vv(a,"InterfaceEnd");vv(a,"WriteAccess",Ti("SheetJS",t));vv(a,"CodePage",Wn(f?1200:1252));if(f)vv(a,"DSF",Wn(0));if(f)vv(a,"Excel9File");vv(a,"RRTabId",Hs(e.SheetNames.length));if(f&&e.vbaraw){vv(a,"ObProj");var l=s.CodeName||"ThisWorkbook";vv(a,"CodeName",Zn(l,t))}vv(a,"BuiltInFnGroupCount",Wn(17));vv(a,"WinProtect",Un(false));vv(a,"Protect",Un(false));vv(a,"Password",Wn(0));if(f)vv(a,"Prot4Rev",Un(false));if(f)vv(a,"Prot4RevPass",Wn(0));vv(a,"Window1",Mi(t));vv(a,"Backup",Un(false));vv(a,"HideObj",Wn(0));vv(a,"Date1904",Un(zd(e)=="true"));vv(a,"CalcPrecision",Un(true));if(f)vv(a,"RefreshAll",Un(false));vv(a,"BookBool",Wn(0));kv(a,e,t);Sv(a,e.SSF,t);_v(a,t);if(f)vv(a,"UsesELFs",Un(false));var c=a.end();var h=Kr();if(f)vv(h,"Country",Fs());vv(h,"EOF");var u=h.end();var d=Kr();var p=0,v=0;for(v=0;v<e.SheetNames.length;++v)p+=(f?12:11)+(f?2:1)*e.SheetNames[v].length;
var g=c.length+p+u.length;for(v=0;v<e.SheetNames.length;++v){var m=i[v]||{};vv(d,"BoundSheet8",Ii({pos:g,hs:m.Hidden||0,dt:0,name:e.SheetNames[v]},t));g+=r[v].length}var b=d.end();if(p!=b.length)throw new Error("BS8 "+p+" != "+b.length);var w=[];if(c.length)w.push(c);if(b.length)w.push(b);if(u.length)w.push(u);return cr([w])}function Iv(e,r){var t=r||{};var a=[];if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){F(D);D.load_table(e.SSF);t.revssf=Z(e.SSF);t.revssf[e.SSF[65535]]=0;t.ssf=e.SSF}t.cellXfs=[];t.Strings=[];t.Strings.Count=0;t.Strings.Unique=0;Qh(t.cellXfs,{},{revssf:{General:0}});for(var n=0;n<e.SheetNames.length;++n)a[a.length]=yv(n,t,e);a.unshift(xv(e,a,t));return cr([a])}function Rv(e,r){var t=r||{};switch(t.biff||2){case 8:;case 5:return Iv(e,r);case 4:;case 3:;case 2:return Ev(e,r);}throw new Error("invalid type "+t.bookType+" for BIFF")}var Dv=function(){function e(e,r){var t=r||{};if(v!=null&&t.dense==null)t.dense=v;var a=t.dense?[]:{};var n=e.match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");var i=e.match(/<\/table/i);var s=n.index,f=i&&i.index||e.length;var o=ue(e.slice(s,f),/(:?<tr[^>]*>)/i,"<tr>");var l=-1,c=0,h=0,u=0;var d={s:{r:1e7,c:1e7},e:{r:0,c:0}};var p=[];for(s=0;s<o.length;++s){var g=o[s].trim();var m=g.slice(0,3).toLowerCase();if(m=="<tr"){++l;if(t.sheetRows&&t.sheetRows<=l){--l;break}c=0;continue}if(m!="<td"&&m!="<th")continue;var b=g.split(/<\/t[dh]>/i);for(f=0;f<b.length;++f){var w=b[f].trim();if(!w.match(/<t[dh]/i))continue;var C=w,E=0;while(C.charAt(0)=="<"&&(E=C.indexOf(">"))>-1)C=C.slice(E+1);var k=ye(w.slice(0,w.indexOf(">")));u=k.colspan?+k.colspan:1;if((h=+k.rowspan)>1||u>1)p.push({s:{r:l,c:c},e:{r:l+(h||1)-1,c:c+u-1}});var S=k.t||"";if(!C.length){c+=u;continue}C=$e(C);if(d.s.r>l)d.s.r=l;if(d.e.r<l)d.e.r=l;if(d.s.c>c)d.s.c=c;if(d.e.c<c)d.e.c=c;if(!C.length)continue;var A={t:"s",v:C};if(t.raw||!C.trim().length||S=="s"){}else if(C==="TRUE")A={t:"b",v:true};else if(C==="FALSE")A={t:"b",v:false};else if(!isNaN(le(C)))A={t:"n",v:le(C)};else if(!isNaN(ce(C).getDate())){A={t:"d",v:ie(C)};if(!t.cellDates)A={t:"n",v:ee(A.v)};A.z=t.dateNF||D._table[14]}if(t.dense){if(!a[l])a[l]=[];a[l][c]=A}else a[ht({r:l,c:c})]=A;c+=u}}a["!ref"]=dt(d);return a}function r(r,t){return mt(e(r,t),t)}function t(e,r,t,a){var n=e["!merges"]||[];var i=[];for(var s=r.s.c;s<=r.e.c;++s){var f=0,o=0;for(var l=0;l<n.length;++l){if(n[l].s.r>t||n[l].s.c>s)continue;if(n[l].e.r<t||n[l].e.c<s)continue;if(n[l].s.r<t||n[l].s.c<s){f=-1;break}f=n[l].e.r-n[l].s.r+1;o=n[l].e.c-n[l].s.c+1;break}if(f<0)continue;var c=ht({r:t,c:s});var h=a.dense?(e[t]||[])[s]:e[c];var u={};if(f>1)u.rowspan=f;if(o>1)u.colspan=o;var d=h&&h.v!=null&&(h.h||Me(h.w||(gt(h),h.w)||""))||"";u.t=h&&h.t||"z";if(a.editable)d='<span contenteditable="true">'+d+"</span>";u.id="sjs-"+c;i.push(ar("td",d,u))}var p="<tr>";return p+i.join("")+"</tr>"}function a(e,r,t){var a=[];return a.join("")+"<table"+(t&&t.id?' id="'+t.id+'"':"")+">"}var n='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var i="</body></html>";function s(e,r){var s=r||{};var f=s.header!=null?s.header:n;var o=s.footer!=null?s.footer:i;var l=[f];var c=ut(e["!ref"]);s.dense=Array.isArray(e);l.push(a(e,c,s));for(var h=c.s.r;h<=c.e.r;++h)l.push(t(e,c,h,s));l.push("</table>"+o);return l.join("")}return{to_workbook:r,to_sheet:e,_row:t,BEGIN:n,END:i,_preamble:a,from_sheet:s}}();function Fv(e,r){var t=r||{};if(v!=null)t.dense=v;var a=t.dense?[]:{};var n=e.getElementsByTagName("tr");var i=t.sheetRows||1e7;var s={s:{r:0,c:0},e:{r:0,c:0}};var f=[],o=0;var l=[];var c=0,h=0,u,d,p,g;for(;c<n.length&&h<i;++c){var m=n[c];if(Pv(m)){if(t.display)continue;l[h]={hidden:true}}var b=m.children;for(u=d=0;u<b.length;++u){var w=b[u];if(t.display&&Pv(w))continue;var C=$e(w.innerHTML);for(o=0;o<f.length;++o){var E=f[o];if(E.s.c==d&&E.s.r<=h&&h<=E.e.r){d=E.e.c+1;o=-1}}g=+w.getAttribute("colspan")||1;if((p=+w.getAttribute("rowspan"))>0||g>1)f.push({s:{r:h,c:d},e:{r:h+(p||1)-1,c:d+g-1}});var k={t:"s",v:C};var S=w.getAttribute("t")||"";if(C!=null){if(C.length==0)k.t=S||"z";else if(t.raw||C.trim().length==0||S=="s"){}else if(C==="TRUE")k={t:"b",v:true};else if(C==="FALSE")k={t:"b",v:false};else if(!isNaN(le(C)))k={t:"n",v:le(C)};else if(!isNaN(ce(C).getDate())){k={t:"d",v:ie(C)};if(!t.cellDates)k={t:"n",v:ee(k.v)};k.z=t.dateNF||D._table[14]}}if(t.dense){if(!a[h])a[h]=[];a[h][d]=k}else a[ht({c:d,r:h})]=k;if(s.e.c<d)s.e.c=d;d+=g}++h}if(f.length)a["!merges"]=f;if(l.length)a["!rows"]=l;s.e.r=h-1;a["!ref"]=dt(s);if(h>=i)a["!fullref"]=dt((s.e.r=n.length-c+h-1,s));return a}function Ov(e,r){return mt(Fv(e,r),r)}function Pv(e){var r="";var t=Nv(e);if(t)r=t(e).getPropertyValue("display");if(!r)r=e.style.display;return r==="none"}function Nv(e){if(e.ownerDocument.defaultView&&typeof e.ownerDocument.defaultView.getComputedStyle==="function")return e.ownerDocument.defaultView.getComputedStyle;if(typeof getComputedStyle==="function")return getComputedStyle;return null}var Lv=function(){var e=function(e){var r=e.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,r){return Array(parseInt(r,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var t=De(r.replace(/<[^>]*>/g,""));return[t]};var r={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};return function t(a,n){var i=n||{};if(v!=null&&i.dense==null)i.dense=v;var s=Mp(a);var f=[],o;var l;var c={name:""},h="",u=0;var d;var p;var g={},m=[];var b=i.dense?[]:{};var w,C;var E={value:""};var k="",S=0,A;var _=[];var B=-1,T=-1,y={s:{r:1e6,c:1e7},e:{r:0,c:0}};var x=0;var I={};var R=[],D={},F=0,O=0;var P=[],N=1,L=1;var M=[];var U={Names:[]};var H={};var W=["",""];var V=[],z={};var X="",G=0;var j=false,K=false;var Y=0;Up.lastIndex=0;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(w=Up.exec(s))switch(w[3]=w[3].replace(/_.*$/,"")){case"table":;case"工作表":if(w[1]==="/"){if(y.e.c>=y.s.c&&y.e.r>=y.s.r)b["!ref"]=dt(y);if(i.sheetRows>0&&i.sheetRows<=y.e.r){b["!fullref"]=b["!ref"];y.e.r=i.sheetRows-1;b["!ref"]=dt(y)}if(R.length)b["!merges"]=R;if(P.length)b["!rows"]=P;d.name=d["名称"]||d.name;if(typeof JSON!=="undefined")JSON.stringify(d);m.push(d.name);g[d.name]=b;K=false}else if(w[0].charAt(w[0].length-2)!=="/"){d=ye(w[0],false);B=T=-1;y.s.r=y.s.c=1e7;y.e.r=y.e.c=0;b=i.dense?[]:{};R=[];P=[];K=true}break;case"table-row-group":if(w[1]==="/")--x;else++x;break;case"table-row":;case"行":if(w[1]==="/"){B+=N;N=1;break}p=ye(w[0],false);if(p["行号"])B=p["行号"]-1;else if(B==-1)B=0;N=+p["number-rows-repeated"]||1;if(N<10)for(Y=0;Y<N;++Y)if(x>0)P[B+Y]={level:x};T=-1;break;case"covered-table-cell":if(w[1]!=="/")++T;if(i.sheetStubs){if(i.dense){if(!b[B])b[B]=[];b[B][T]={t:"z"}}else b[ht({r:B,c:T})]={t:"z"}}k="";_=[];break;case"table-cell":;case"数据":if(w[0].charAt(w[0].length-2)==="/"){++T;E=ye(w[0],false);L=parseInt(E["number-columns-repeated"]||"1",10);C={t:"z",v:null};if(E.formula&&i.cellFormula!=false)C.f=Wh(De(E.formula));if((E["数据类型"]||E["value-type"])=="string"){C.t="s";C.v=De(E["string-value"]||"");if(i.dense){if(!b[B])b[B]=[];b[B][T]=C}else{b[ht({r:B,c:T})]=C}}T+=L-1}else if(w[1]!=="/"){++T;L=1;var $=N?B+N-1:B;if(T>y.e.c)y.e.c=T;if(T<y.s.c)y.s.c=T;if(B<y.s.r)y.s.r=B;if($>y.e.r)y.e.r=$;E=ye(w[0],false);V=[];z={};C={t:E["数据类型"]||E["value-type"],v:null};if(i.cellFormula){if(E.formula)E.formula=De(E.formula);if(E["number-matrix-columns-spanned"]&&E["number-matrix-rows-spanned"]){F=parseInt(E["number-matrix-rows-spanned"],10)||0;O=parseInt(E["number-matrix-columns-spanned"],10)||0;D={s:{r:B,c:T},e:{r:B+F-1,c:T+O-1}};C.F=dt(D);M.push([D,C.F])}if(E.formula)C.f=Wh(E.formula);else for(Y=0;Y<M.length;++Y)if(B>=M[Y][0].s.r&&B<=M[Y][0].e.r)if(T>=M[Y][0].s.c&&T<=M[Y][0].e.c)C.F=M[Y][1]}if(E["number-columns-spanned"]||E["number-rows-spanned"]){F=parseInt(E["number-rows-spanned"],10)||0;O=parseInt(E["number-columns-spanned"],10)||0;D={s:{r:B,c:T},e:{r:B+F-1,c:T+O-1}};R.push(D)}if(E["number-columns-repeated"])L=parseInt(E["number-columns-repeated"],10);switch(C.t){case"boolean":C.t="b";C.v=Ve(E["boolean-value"]);break;case"float":C.t="n";C.v=parseFloat(E.value);break;case"percentage":C.t="n";C.v=parseFloat(E.value);break;case"currency":C.t="n";C.v=parseFloat(E.value);break;case"date":C.t="d";C.v=ie(E["date-value"]);if(!i.cellDates){C.t="n";C.v=ee(C.v)}C.z="m/d/yy";break;case"time":C.t="n";C.v=te(E["time-value"])/86400;break;case"number":C.t="n";C.v=parseFloat(E["数据数值"]);break;default:if(C.t==="string"||C.t==="text"||!C.t){C.t="s";if(E["string-value"]!=null){k=De(E["string-value"]);_=[]}}else throw new Error("Unsupported value type "+C.t);}}else{j=false;if(C.t==="s"){C.v=k||"";if(_.length)C.R=_;j=S==0}if(H.Target)C.l=H;if(V.length>0){C.c=V;V=[]}if(k&&i.cellText!==false)C.w=k;if(!j||i.sheetStubs){if(!(i.sheetRows&&i.sheetRows<=B)){for(var Z=0;Z<N;++Z){L=parseInt(E["number-columns-repeated"]||"1",10);if(i.dense){if(!b[B+Z])b[B+Z]=[];b[B+Z][T]=Z==0?C:fe(C);while(--L>0)b[B+Z][T+L]=fe(C)}else{b[ht({r:B+Z,c:T})]=C;while(--L>0)b[ht({r:B+Z,c:T+L})]=fe(C)}if(y.e.c<=T)y.e.c=T}}}L=parseInt(E["number-columns-repeated"]||"1",10);T+=L-1;L=0;C={};k="";_=[]}H={};break;case"document":;case"document-content":;case"电子表格文档":;case"spreadsheet":;case"主体":;case"scripts":;case"styles":;case"font-face-decls":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")f.push([w[3],true]);break;case"annotation":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o;z.t=k;if(_.length)z.R=_;z.a=X;V.push(z)}else if(w[0].charAt(w[0].length-2)!=="/"){f.push([w[3],false])}X="";G=0;k="";S=0;_=[];break;case"creator":if(w[1]==="/"){X=s.slice(G,w.index)}else G=w.index+w[0].length;break;case"meta":;case"元数据":;case"settings":;case"config-item-set":;case"config-item-map-indexed":;case"config-item-map-entry":;case"config-item-map-named":;case"shapes":;case"frame":;case"text-box":;case"image":;case"data-pilot-tables":;case"list-style":;case"form":;case"dde-links":;case"event-listeners":;case"chart":if(w[1]==="/"){if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/")f.push([w[3],false]);k="";S=0;_=[];break;case"scientific-number":break;case"currency-symbol":break;case"currency-style":break;case"number-style":;case"percentage-style":;case"date-style":;case"time-style":if(w[1]==="/"){I[c.name]=h;if((o=f.pop())[0]!==w[3])throw"Bad state: "+o}else if(w[0].charAt(w[0].length-2)!=="/"){h="";c=ye(w[0],false);f.push([w[3],true])}break;case"script":break;case"libraries":break;case"automatic-styles":break;case"master-styles":break;case"default-style":;case"page-layout":break;case"style":break;case"map":break;case"font-face":break;case"paragraph-properties":break;case"table-properties":break;case"table-column-properties":break;case"table-row-properties":break;case"table-cell-properties":break;case"number":switch(f[f.length-1][0]){case"time-style":;case"date-style":l=ye(w[0],false);h+=r[w[3]][l.style==="long"?1:0];break;}break;case"fraction":break;case"day":;case"month":;case"year":;case"era":;case"day-of-week":;case"week-of-year":;case"quarter":;case"hours":;case"minutes":;case"seconds":;case"am-pm":switch(f[f.length-1][0]){case"time-style":;case"date-style":l=ye(w[0],false);h+=r[w[3]][l.style==="long"?1:0];break;}break;case"boolean-style":break;case"boolean":break;case"text-style":break;case"text":if(w[0].slice(-2)==="/>")break;else if(w[1]==="/")switch(f[f.length-1][0]){case"number-style":;case"date-style":;case"time-style":h+=s.slice(u,w.index);break;}else u=w.index+w[0].length;break;case"named-range":l=ye(w[0],false);W=zh(l["cell-range-address"]);var Q={Name:l.name,Ref:W[0]+"!"+W[1]};if(K)Q.Sheet=m.length;U.Names.push(Q);break;case"text-content":break;case"text-properties":break;case"embedded-text":break;case"body":;case"电子表格":break;case"forms":break;case"table-column":break;case"table-header-rows":break;case"table-rows":break;case"table-column-group":break;case"table-header-columns":break;case"table-columns":break;case"null-date":break;case"graphic-properties":break;case"calculation-settings":break;case"named-expressions":break;case"label-range":break;case"label-ranges":break;case"named-expression":break;case"sort":break;case"sort-by":break;case"sort-groups":break;case"tab":break;case"line-break":break;case"span":break;case"p":;case"文本串":if(w[1]==="/"&&(!E||!E["string-value"])){var J=e(s.slice(S,w.index),A);k=(k.length>0?k+"\n":"")+J[0]}else{A=ye(w[0],false);S=w.index+w[0].length}break;case"s":break;case"database-range":if(w[1]==="/")break;try{W=zh(ye(w[0])["target-range-address"]);g[W[0]]["!autofilter"]={ref:W[1]}}catch(q){}break;case"date":break;case"object":break;case"title":;case"标题":break;case"desc":break;case"binary-data":break;case"table-source":break;case"scenario":break;case"iteration":break;case"content-validations":break;case"content-validation":break;case"help-message":break;case"error-message":break;case"database-ranges":break;case"filter":break;case"filter-and":break;case"filter-or":break;case"filter-condition":break;case"list-level-style-bullet":break;case"list-level-style-number":break;case"list-level-properties":break;case"sender-firstname":;case"sender-lastname":;case"sender-initials":;case"sender-title":;case"sender-position":;case"sender-email":;case"sender-phone-private":;case"sender-fax":;case"sender-company":;case"sender-phone-work":;case"sender-street":;case"sender-city":;case"sender-postal-code":;case"sender-country":;case"sender-state-or-province":;case"author-name":;case"author-initials":;case"chapter":;case"file-name":;case"template-name":;case"sheet-name":break;case"event-listener":break;case"initial-creator":;case"creation-date":;case"print-date":;case"generator":;case"document-statistic":;case"user-defined":;case"editing-duration":;case"editing-cycles":break;case"config-item":break;case"page-number":break;case"page-count":break;case"time":break;case"cell-range-source":break;case"detective":break;case"operation":break;case"highlighted-range":break;case"data-pilot-table":;case"source-cell-range":;case"source-service":;case"data-pilot-field":;case"data-pilot-level":;case"data-pilot-subtotals":;case"data-pilot-subtotal":;case"data-pilot-members":;case"data-pilot-member":;case"data-pilot-display-info":;case"data-pilot-sort-info":;case"data-pilot-layout-info":;case"data-pilot-field-reference":;case"data-pilot-groups":;case"data-pilot-group":;case"data-pilot-group-member":break;case"rect":break;case"dde-connection-decls":;case"dde-connection-decl":;case"dde-link":;case"dde-source":break;case"properties":break;case"property":break;case"a":if(w[1]!=="/"){H=ye(w[0],false);if(!H.href)break;H.Target=H.href;delete H.href;if(H.Target.charAt(0)=="#"&&H.Target.indexOf(".")>-1){W=zh(H.Target.slice(1));H.Target="#"+W[0]+"!"+W[1]}}break;case"table-protection":break;case"data-pilot-grand-total":break;case"office-document-common-attrs":break;default:switch(w[2]){case"dc:":;case"calcext:":;case"loext:":;case"ooo:":;case"chartooo:":;case"draw:":;case"style:":;case"chart:":;case"form:":;case"uof:":;case"表:":;case"字:":break;default:if(i.WTF)throw new Error(w);};}var re={Sheets:g,SheetNames:m,Workbook:U};if(i.bookSheets)delete re.Sheets;return re}}();function Mv(e,r){r=r||{};var t=!!ge(e,"objectdata");if(t)Ma(be(e,"META-INF/manifest.xml"),r);var a=we(e,"content.xml");if(!a)throw new Error("Missing content.xml in "+(t?"ODS":"UOF")+" file");var n=Lv(t?a:ze(a),r);if(ge(e,"meta.xml"))n.Props=ja(be(e,"meta.xml"));return n}function Uv(e,r){return Lv(e,r)}var Hv=function(){var e="<office:document-styles "+tr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+"></office:document-styles>";return function r(){return Se+e}}();var Wv=function(){var e=function(e){return Pe(e).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"<text:line-break/>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>")};var r="          <table:table-cell />\n";var t="          <table:covered-table-cell/>\n";var a=function(a,n,i){var s=[];s.push('      <table:table table:name="'+Pe(n.SheetNames[i])+'">\n');var f=0,o=0,l=ut(a["!ref"]);var c=a["!merges"]||[],h=0;var u=Array.isArray(a);for(f=0;f<l.s.r;++f)s.push("        <table:table-row></table:table-row>\n");for(;f<=l.e.r;++f){s.push("        <table:table-row>\n");for(o=0;o<l.s.c;++o)s.push(r);for(;o<=l.e.c;++o){var d=false,p={},v="";for(h=0;h!=c.length;++h){if(c[h].s.c>o)continue;if(c[h].s.r>f)continue;if(c[h].e.c<o)continue;if(c[h].e.r<f)continue;if(c[h].s.c!=o||c[h].s.r!=f)d=true;p["table:number-columns-spanned"]=c[h].e.c-c[h].s.c+1;p["table:number-rows-spanned"]=c[h].e.r-c[h].s.r+1;break}if(d){s.push(t);continue}var g=ht({r:f,c:o}),m=u?(a[f]||[])[o]:a[g];if(m&&m.f){p["table:formula"]=Pe(Vh(m.f));if(m.F){if(m.F.slice(0,g.length)==g){var b=ut(m.F);p["table:number-matrix-columns-spanned"]=b.e.c-b.s.c+1;p["table:number-matrix-rows-spanned"]=b.e.r-b.s.r+1}}}if(!m){s.push(r);continue}switch(m.t){case"b":v=m.v?"TRUE":"FALSE";p["office:value-type"]="boolean";p["office:boolean-value"]=m.v?"true":"false";break;case"n":v=m.w||String(m.v||0);p["office:value-type"]="float";p["office:value"]=m.v||0;break;case"s":;case"str":v=m.v;p["office:value-type"]="string";break;case"d":v=m.w||ie(m.v).toISOString();p["office:value-type"]="date";p["office:date-value"]=ie(m.v).toISOString();p["table:style-name"]="ce1";break;default:s.push(r);continue;}var w=e(v);if(m.l&&m.l.Target){var C=m.l.Target;C=C.charAt(0)=="#"?"#"+Xh(C.slice(1)):C;w=ar("text:a",w,{"xlink:href":C})}s.push("          "+ar("table:table-cell",ar("text:p",w,{}),p)+"\n")}s.push("        </table:table-row>\n")}s.push("      </table:table>\n");return s.join("")};var n=function(e){e.push(" <office:automatic-styles>\n");e.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');e.push('   <number:month number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push('   <number:day number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push("   <number:year/>\n");e.push("  </number:date-style>\n");e.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');e.push(" </office:automatic-styles>\n")};return function i(e,r){var t=[Se];var i=tr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"});var s=tr({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});if(r.bookType=="fods")t.push("<office:document"+i+s+">\n");else t.push("<office:document-content"+i+">\n");n(t);t.push("  <office:body>\n");t.push("    <office:spreadsheet>\n");for(var f=0;f!=e.SheetNames.length;++f)t.push(a(e.Sheets[e.SheetNames[f]],e,f,r));t.push("    </office:spreadsheet>\n");t.push("  </office:body>\n");if(r.bookType=="fods")t.push("</office:document>");else t.push("</office:document-content>");return t.join("")}}();function Vv(e,r){if(r.bookType=="fods")return Wv(e,r);var t=new Ee;var a="";var n=[];var i=[];a="mimetype";t.file(a,"application/vnd.oasis.opendocument.spreadsheet");a="content.xml";t.file(a,Wv(e,r));n.push([a,"text/xml"]);i.push([a,"ContentFile"]);a="styles.xml";t.file(a,Hv(e,r));n.push([a,"text/xml"]);i.push([a,"StylesFile"]);a="meta.xml";t.file(a,za());n.push([a,"text/xml"]);i.push([a,"MetadataFile"]);a="manifest.rdf";t.file(a,Va(i));n.push([a,"application/rdf+xml"]);a="META-INF/manifest.xml";t.file(a,Ua(n));return t}function zv(e,r){if(!r)return 0;var t=e.SheetNames.indexOf(r);if(t==-1)throw new Error("Sheet not found: "+r);return t}function Xv(e){return function r(t,a){var n=zv(t,a.sheet);return e.from_sheet(t.Sheets[t.SheetNames[n]],a,t)}}var Gv=Xv(Dv);var jv=Xv({from_sheet:Og});var Kv=Xv(ef);var Yv=Xv(rf);var $v=Xv(af);var Zv=Xv(jf);var Qv=Xv({from_sheet:Pg});var Jv=Xv(qs);var qv=Xv(tf);function eg(e){return function r(t){for(var a=0;a!=e.length;++a){var n=e[a];if(t[n[0]]===undefined)t[n[0]]=n[1];if(n[2]==="n")t[n[0]]=Number(t[n[0]])}}}var rg=eg([["cellNF",false],["cellHTML",true],["cellFormula",true],["cellStyles",false],["cellText",true],["cellDates",false],["sheetStubs",false],["sheetRows",0,"n"],["bookDeps",false],["bookSheets",false],["bookProps",false],["bookFiles",false],["bookVBA",false],["password",""],["WTF",false]]);var tg=eg([["cellDates",false],["bookSST",false],["bookType","xlsx"],["compression",false],["WTF",false]]);function ag(e){if(Ra.WS.indexOf(e)>-1)return"sheet";if(Ra.CS&&e==Ra.CS)return"chart";if(Ra.DS&&e==Ra.DS)return"dialog";if(Ra.MS&&e==Ra.MS)return"macro";return e&&e.length?e:"sheet"}function ng(e,r){if(!e)return 0;try{e=r.map(function a(r){if(!r.id)r.id=r.strRelID;return[r.name,e["!id"][r.id].Target,ag(e["!id"][r.id].Type)]})}catch(t){return null}return!e||e.length===0?null:e}function ig(e,r,t,a,n,i,s,f,o,l,c,h){try{i[a]=Fa(we(e,t,true),r);var u=be(e,r);var d;switch(f){case"sheet":d=hp(u,r,n,o,i[a],l,c,h);break;case"chart":d=up(u,r,n,o,i[a],l,c,h);if(!d||!d["!chart"])break;var p=ke(d["!chart"].Target,r);var v=Da(p);var g=kl(we(e,p,true),Fa(we(e,v,true),p));var m=ke(g,p);var b=Da(m);d=xd(we(e,m,true),m,o,Fa(we(e,b,true),m),l,d);break;case"macro":d=dp(u,r,n,o,i[a],l,c,h);break;case"dialog":d=pp(u,r,n,o,i[a],l,c,h);break;}s[a]=d}catch(w){if(o.WTF)throw w}}function sg(e){return e.charAt(0)=="/"?e.slice(1):e}function fg(e,r){F(D);r=r||{};rg(r);if(ge(e,"META-INF/manifest.xml"))return Mv(e,r);if(ge(e,"objectdata.xml"))return Mv(e,r);if(ge(e,"Index/Document.iwa"))throw new Error("Unsupported NUMBERS file");var t=Ce(e);var a=Ta(we(e,"[Content_Types].xml"));var n=false;var i,s;if(a.workbooks.length===0){s="xl/workbook.xml";if(be(e,s,true))a.workbooks.push(s)}if(a.workbooks.length===0){s="xl/workbook.bin";if(!be(e,s,true))throw new Error("Could not find workbook");a.workbooks.push(s);n=true}if(a.workbooks[0].slice(-3)=="bin")n=true;var f={};var o={};if(!r.bookSheets&&!r.bookProps){Gh=[];if(a.sst)try{Gh=mp(be(e,sg(a.sst)),a.sst,r)}catch(l){if(r.WTF)throw l}if(r.cellStyles&&a.themes.length)f=gp(we(e,a.themes[0].replace(/^\//,""),true)||"",a.themes[0],r);if(a.style)o=vp(be(e,sg(a.style)),a.style,f,r)}a.links.map(function(t){return Cp(be(e,sg(t)),t,r)});var c=cp(be(e,sg(a.workbooks[0])),a.workbooks[0],r);var h={},u="";if(a.coreprops.length){u=be(e,sg(a.coreprops[0]),true);if(u)h=ja(u);if(a.extprops.length!==0){u=be(e,sg(a.extprops[0]),true);if(u)qa(u,h,r)}}var d={};if(!r.bookSheets||r.bookProps){if(a.custprops.length!==0){u=we(e,sg(a.custprops[0]),true);if(u)d=an(u,r)}}var p={};if(r.bookSheets||r.bookProps){if(c.Sheets)i=c.Sheets.map(function y(e){return e.name});else if(h.Worksheets&&h.SheetNames.length>0)i=h.SheetNames;if(r.bookProps){p.Props=h;p.Custprops=d}if(r.bookSheets&&typeof i!=="undefined")p.SheetNames=i;if(r.bookSheets?p.SheetNames:r.bookProps)return p}i={};var v={};if(r.bookDeps&&a.calcchain)v=wp(be(e,sg(a.calcchain)),a.calcchain,r);var g=0;var m={};var b,w;{var C=c.Sheets;h.Worksheets=C.length;h.SheetNames=[];for(var E=0;E!=C.length;++E){h.SheetNames[E]=C[E].name}}var k=n?"bin":"xml";var S=a.workbooks[0].lastIndexOf("/");var A=(a.workbooks[0].slice(0,S+1)+"_rels/"+a.workbooks[0].slice(S+1)+".rels").replace(/^\//,"");if(!ge(e,A))A="xl/_rels/workbook."+k+".rels";var _=Fa(we(e,A,true),A);if(_)_=ng(_,c.Sheets);var B=be(e,"xl/worksheets/sheet.xml",true)?1:0;for(g=0;g!=h.Worksheets;++g){var T="sheet";if(_&&_[g]){b="xl/"+_[g][1].replace(/[\/]?xl\//,"");if(!ge(e,b))b=_[g][1];if(!ge(e,b))b=A.replace(/_rels\/.*$/,"")+_[g][1];T=_[g][2]}else{b="xl/worksheets/sheet"+(g+1-B)+"."+k;b=b.replace(/sheet0\./,"sheet.")}w=b.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");ig(e,b,w,h.SheetNames[g],g,m,i,T,r,c,f,o)}if(a.comments)_l(e,a.comments,i,m,r);p={Directory:a,Workbook:c,Props:h,Custprops:d,Deps:v,Sheets:i,SheetNames:h.SheetNames,Strings:Gh,Styles:o,Themes:f,SSF:D.get_table()};if(r.bookFiles){p.keys=t;p.files=e.files}if(r.bookVBA){if(a.vba.length>0)p.vbaraw=be(e,sg(a.vba[0]),true);else if(a.defaults&&a.defaults.bin===Nl)p.vbaraw=be(e,"xl/vbaProject.bin",true)}return p}function og(e,r){var t=r||{};var a="Workbook",n=W.find(e,a);try{a="/!DataSpaces/Version";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);_f(n.content);a="/!DataSpaces/DataSpaceMap";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var i=Tf(n.content);if(i.length!==1||i[0].comps.length!==1||i[0].comps[0].t!==0||i[0].name!=="StrongEncryptionDataSpace"||i[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var s=yf(n.content);if(s.length!=1||s[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);If(n.content)}catch(f){}a="/EncryptionInfo";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var o=Ff(n.content);a="/EncryptedPackage";n=W.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);if(o[0]==4&&typeof decrypt_agile!=="undefined")return decrypt_agile(o[1],n.content,t.password||"",t);if(o[0]==2&&typeof decrypt_std76!=="undefined")return decrypt_std76(o[1],n.content,t.password||"",t);throw new Error("File is password-protected")}function lg(e,r){Sl=1024;if(r.bookType=="ods")return Vv(e,r);if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){F(D);D.load_table(e.SSF);r.revssf=Z(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF}r.rels={};r.wbrels={};r.Strings=[];r.Strings.Count=0;r.Strings.Unique=0;if(Kh)r.revStrings=new Map;else{r.revStrings={};r.revStrings.foo=[];delete r.revStrings.foo}var t=r.bookType=="xlsb"?"bin":"xml";var a=Ul.indexOf(r.bookType)>-1;var n=Ba();tg(r=r||{});var i=new Ee;var s="",f=0;r.cellXfs=[];Qh(r.cellXfs,{},{revssf:{General:0}});if(!e.Props)e.Props={};s="docProps/core.xml";i.file(s,$a(e.Props,r));n.coreprops.push(s);Na(r.rels,2,s,Ra.CORE_PROPS);s="docProps/app.xml";if(e.Props&&e.Props.SheetNames){}else if(!e.Workbook||!e.Workbook.Sheets)e.Props.SheetNames=e.SheetNames;else{var o=[];for(var l=0;l<e.SheetNames.length;++l)if((e.Workbook.Sheets[l]||{}).Hidden!=2)o.push(e.SheetNames[l]);e.Props.SheetNames=o}e.Props.Worksheets=e.Props.SheetNames.length;i.file(s,rn(e.Props,r));n.extprops.push(s);Na(r.rels,3,s,Ra.EXT_PROPS);if(e.Custprops!==e.Props&&j(e.Custprops||{}).length>0){s="docProps/custom.xml";i.file(s,sn(e.Custprops,r));n.custprops.push(s);Na(r.rels,4,s,Ra.CUST_PROPS)}for(f=1;f<=e.SheetNames.length;++f){var c={"!id":{}};var h=e.Sheets[e.SheetNames[f-1]];var u=(h||{})["!type"]||"sheet";switch(u){case"chart":;default:s="xl/worksheets/sheet"+f+"."+t;i.file(s,kp(f-1,s,r,e,c));n.sheets.push(s);Na(r.wbrels,-1,"worksheets/sheet"+f+"."+t,Ra.WS[0]);}if(h){var d=h["!comments"];var p=false;if(d&&d.length>0){var v="xl/comments"+f+"."+t;i.file(v,Bp(d,v,r));n.comments.push(v);Na(c,-1,"../comments"+f+"."+t,Ra.CMNT);p=true}if(h["!legacy"]){if(p)i.file("xl/drawings/vmlDrawing"+f+".vml",Al(f,h["!comments"]))}delete h["!comments"];delete h["!legacy"]}if(c["!id"].rId1)i.file(Da(s),Pa(c))}if(r.Strings!=null&&r.Strings.length>0){s="xl/sharedStrings."+t;i.file(s,_p(r.Strings,s,r));n.strs.push(s);Na(r.wbrels,-1,"sharedStrings."+t,Ra.SST)}s="xl/workbook."+t;i.file(s,Ep(e,s,r));n.workbooks.push(s);Na(r.rels,1,s,Ra.WB);s="xl/theme/theme1.xml";i.file(s,ol(e.Themes,r));n.themes.push(s);Na(r.wbrels,-1,"theme/theme1.xml",Ra.THEME);s="xl/styles."+t;i.file(s,Ap(e,s,r));n.styles.push(s);Na(r.wbrels,-1,"styles."+t,Ra.STY);if(e.vbaraw&&a){s="xl/vbaProject.bin";i.file(s,e.vbaraw);n.vba.push(s);Na(r.wbrels,-1,"vbaProject.bin",Ra.VBA)}i.file("[Content_Types].xml",Ia(n,r));i.file("_rels/.rels",Pa(r.rels));i.file("xl/_rels/workbook."+t+".rels",Pa(r.wbrels));delete r.revssf;delete r.ssf;return i}function cg(e,r){var t="";switch((r||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3]];case"base64":t=m.decode(e.slice(0,24));break;case"binary":t=e;break;case"array":return[e[0],e[1],e[2],e[3]];default:throw new Error("Unrecognized type "+(r&&r.type||"undefined"));}return[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]}function hg(e,r){if(W.find(e,"EncryptedPackage"))return og(e,r);return lv(e,r)}function ug(e,r){var t,a=e;var n=r||{};if(!n.type)n.type=b&&Buffer.isBuffer(e)?"buffer":"base64";switch(n.type){case"base64":t=new Ee(a,{base64:true});break;case"binary":;case"array":t=new Ee(a,{base64:false});break;case"buffer":t=new Ee(a);break;default:throw new Error("Unrecognized type "+n.type);}return fg(t,n)}function dg(e,r){var t=0;e:while(t<e.length)switch(e.charCodeAt(t)){case 10:;case 13:;case 32:++t;break;case 60:return Wp(e.slice(t),r);default:break e;}return af.to_workbook(e,r)}function pg(e,r){var t="",a=cg(e,r);switch(r.type){case"base64":t=m.decode(e);break;case"binary":t=e;break;case"buffer":t=e.toString("binary");
break;case"array":t=se(e);break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=ze(t);return dg(t,r)}function vg(e,r){var t=e;if(r.type=="base64")t=m.decode(t);t=cptable.utils.decode(1200,t.slice(2),"str");r.type="binary";return dg(t,r)}function gg(e){return!e.match(/[^\x00-\x7F]/)?e:Xe(e)}function mg(e,r,t,a){if(a){t.type="string";return af.to_workbook(e,t)}return af.to_workbook(r,t)}function bg(e,r){l();if(typeof ArrayBuffer!=="undefined"&&e instanceof ArrayBuffer)return bg(new Uint8Array(e),r);var t=e,a=[0,0,0,0],n=false;var i=r||{};jh={};if(i.dateNF)jh.dateNF=i.dateNF;if(!i.type)i.type=b&&Buffer.isBuffer(e)?"buffer":"base64";if(i.type=="file"){i.type=b?"buffer":"binary";t=G(e)}if(i.type=="string"){n=true;i.type="binary";i.codepage=65001;t=gg(e)}if(i.type=="array"&&typeof Uint8Array!=="undefined"&&e instanceof Uint8Array&&typeof ArrayBuffer!=="undefined"){var s=new ArrayBuffer(3),f=new Uint8Array(s);f.foo="bar";if(!f.foo){i=fe(i);i.type="array";return bg(y(t),i)}}switch((a=cg(t,i))[0]){case 208:return hg(W.read(t,i),i);case 9:return lv(t,i);case 60:return Wp(t,i);case 73:if(a[1]===68)return nf(t,i);break;case 84:if(a[1]===65&&a[2]===66&&a[3]===76)return rf.to_workbook(t,i);break;case 80:return a[1]===75&&a[2]<9&&a[3]<9?ug(t,i):mg(e,t,i,n);case 239:return a[3]===60?Wp(t,i):mg(e,t,i,n);case 255:if(a[1]===254){return vg(t,i)}break;case 0:if(a[1]===0&&a[2]>=2&&a[3]===0)return sf.to_workbook(t,i);break;case 3:;case 131:;case 139:;case 140:return qs.to_workbook(t,i);case 123:if(a[1]===92&&a[2]===114&&a[3]===116)return jf.to_workbook(t,i);break;case 10:;case 13:;case 32:return pg(t,i);}if(a[2]<=12&&a[3]<=31)return qs.to_workbook(t,i);return mg(e,t,i,n)}function wg(e,r){var t=r||{};t.type="file";return bg(e,t)}function Cg(e,r){switch(r.type){case"base64":;case"binary":break;case"buffer":;case"array":r.type="";break;case"file":return X(r.file,W.write(e,{type:b?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+r.bookType+"' files");default:throw new Error("Unrecognized type "+r.type);}return W.write(e,r)}function Eg(e,r){var t=r||{};var a=lg(e,t);var n={};if(t.compression)n.compression="DEFLATE";if(t.password)n.type=b?"nodebuffer":"string";else switch(t.type){case"base64":n.type="base64";break;case"binary":n.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":;case"file":n.type=b?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+t.type);}var i=a.generate(n);if(t.password&&typeof encrypt_agile!=="undefined")return Cg(encrypt_agile(i,t.password),t);if(t.type==="file")return X(t.file,i);return t.type=="string"?ze(i):i}function kg(e,r){var t=r||{};var a=cv(e,t);return Cg(a,t)}function Sg(e,r,t){if(!t)t="";var a=t+e;switch(r.type){case"base64":return m.encode(Xe(a));case"binary":return Xe(a);case"string":return e;case"file":return X(r.file,a,"utf8");case"buffer":{if(b)return w(a,"utf8");else return Sg(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function Ag(e,r){switch(r.type){case"base64":return m.encode(e);case"binary":return e;case"string":return e;case"file":return X(r.file,e,"binary");case"buffer":{if(b)return w(e,"binary");else return e.split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function _g(e,r){switch(r.type){case"string":;case"base64":;case"binary":var t="";for(var a=0;a<e.length;++a)t+=String.fromCharCode(e[a]);return r.type=="base64"?m.encode(t):r.type=="string"?ze(t):t;case"file":return X(r.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+r.type);}}function Bg(e,r){Kd(e);var t=r||{};if(t.type=="array"){t.type="binary";var a=Bg(e,t);t.type="array";return _(a)}switch(t.bookType||"xlsb"){case"xml":;case"xlml":return Sg(ev(e,t),t);case"slk":;case"sylk":return Sg(Kv(e,t),t);case"htm":;case"html":return Sg(Gv(e,t),t);case"txt":return Ag(Qv(e,t),t);case"csv":return Sg(jv(e,t),t,"\ufeff");case"dif":return Sg(Yv(e,t),t);case"dbf":return _g(Jv(e,t),t);case"prn":return Sg($v(e,t),t);case"rtf":return Sg(Zv(e,t),t);case"eth":return Sg(qv(e,t),t);case"fods":return Sg(Vv(e,t),t);case"biff2":if(!t.biff)t.biff=2;case"biff3":if(!t.biff)t.biff=3;case"biff4":if(!t.biff)t.biff=4;return _g(Rv(e,t),t);case"biff5":if(!t.biff)t.biff=5;case"biff8":;case"xla":;case"xls":if(!t.biff)t.biff=8;return kg(e,t);case"xlsx":;case"xlsm":;case"xlam":;case"xlsb":;case"ods":return Eg(e,t);default:throw new Error("Unrecognized bookType |"+t.bookType+"|");}}function Tg(e){if(e.bookType)return;var r={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"};var t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase();if(t.match(/^\.[a-z]+$/))e.bookType=t.slice(1);e.bookType=r[e.bookType]||e.bookType}function yg(e,r,t){var a=t||{};a.type="file";a.file=r;Tg(a);return Bg(e,a)}function xg(e,r,t,a){var n=t||{};n.type="file";n.file=e;Tg(n);n.type="buffer";var i=a;if(!(i instanceof Function))i=t;return V.writeFile(e,Bg(r,n),i)}function Ig(e,r,t,a,n,i,s,f){var o=tt(t);var l=f.defval,c=f.raw||!f.hasOwnProperty("raw");var h=true;var u=n===1?[]:{};if(n!==1){if(Object.defineProperty)try{Object.defineProperty(u,"__rowNum__",{value:t,enumerable:false})}catch(d){u.__rowNum__=t}else u.__rowNum__=t}if(!s||e[t])for(var p=r.s.c;p<=r.e.c;++p){var v=s?e[t][p]:e[a[p]+o];if(v===undefined||v.t===undefined){if(l===undefined)continue;if(i[p]!=null){u[i[p]]=l}continue}var g=v.v;switch(v.t){case"z":if(g==null)break;continue;case"e":g=void 0;break;case"s":;case"d":;case"b":;case"n":break;default:throw new Error("unrecognized type "+v.t);}if(i[p]!=null){if(g==null){if(l!==undefined)u[i[p]]=l;else if(c&&g===null)u[i[p]]=null;else continue}else{u[i[p]]=c?g:gt(v,g,f)}if(g!=null)h=false}}return{row:u,isempty:h}}function Rg(e,r){if(e==null||e["!ref"]==null)return[];var t={t:"n",v:0},a=0,n=1,i=[],s=0,f="";var o={s:{r:0,c:0},e:{r:0,c:0}};var l=r||{};var c=l.range!=null?l.range:e["!ref"];if(l.header===1)a=1;else if(l.header==="A")a=2;else if(Array.isArray(l.header))a=3;switch(typeof c){case"string":o=pt(c);break;case"number":o=pt(e["!ref"]);o.s.r=c;break;default:o=c;}if(a>0)n=0;var h=tt(o.s.r);var u=[];var d=[];var p=0,v=0;var g=Array.isArray(e);var m=o.s.r,b=0,w=0;if(g&&!e[m])e[m]=[];for(b=o.s.c;b<=o.e.c;++b){u[b]=st(b);t=g?e[m][b]:e[u[b]+h];switch(a){case 1:i[b]=b-o.s.c;break;case 2:i[b]=u[b];break;case 3:i[b]=l.header[b-o.s.c];break;default:if(t==null)t={w:"__EMPTY",t:"s"};f=s=gt(t,null,l);v=0;for(w=0;w<i.length;++w)if(i[w]==f)f=s+"_"+ ++v;i[b]=f;}}for(m=o.s.r+n;m<=o.e.r;++m){var C=Ig(e,o,m,u,a,i,g,l);if(C.isempty===false||(a===1?l.blankrows!==false:!!l.blankrows))d[p++]=C.row}d.length=p;return d}var Dg=/"/g;function Fg(e,r,t,a,n,i,s,f){var o=true;var l=[],c="",h=tt(t);for(var u=r.s.c;u<=r.e.c;++u){if(!a[u])continue;var d=f.dense?(e[t]||[])[u]:e[a[u]+h];if(d==null)c="";else if(d.v!=null){o=false;c=""+gt(d,null,f);for(var p=0,v=0;p!==c.length;++p)if((v=c.charCodeAt(p))===n||v===i||v===34){c='"'+c.replace(Dg,'""')+'"';break}if(c=="ID")c='"ID"'}else if(d.f!=null&&!d.F){o=false;c="="+d.f;if(c.indexOf(",")>=0)c='"'+c.replace(Dg,'""')+'"'}else c="";l.push(c)}if(f.blankrows===false&&o)return null;return l.join(s)}function Og(e,r){var t=[];var a=r==null?{}:r;if(e==null||e["!ref"]==null)return"";var n=pt(e["!ref"]);var i=a.FS!==undefined?a.FS:",",s=i.charCodeAt(0);var f=a.RS!==undefined?a.RS:"\n",o=f.charCodeAt(0);var l=new RegExp((i=="|"?"\\|":i)+"+$");var c="",h=[];a.dense=Array.isArray(e);var u=a.skipHidden&&e["!cols"]||[];var d=a.skipHidden&&e["!rows"]||[];for(var p=n.s.c;p<=n.e.c;++p)if(!(u[p]||{}).hidden)h[p]=st(p);for(var v=n.s.r;v<=n.e.r;++v){if((d[v]||{}).hidden)continue;c=Fg(e,n,v,h,s,o,i,a);if(c==null){continue}if(a.strip)c=c.replace(l,"");t.push(c+f)}delete a.dense;return t.join("")}function Pg(e,r){if(!r)r={};r.FS="\t";r.RS="\n";var t=Og(e,r);if(typeof cptable=="undefined"||r.type=="string")return t;var a=cptable.utils.encode(1200,t,"str");return String.fromCharCode(255)+String.fromCharCode(254)+a}function Ng(e){var r="",t,a="";if(e==null||e["!ref"]==null)return[];var n=pt(e["!ref"]),i="",s=[],f;var o=[];var l=Array.isArray(e);for(f=n.s.c;f<=n.e.c;++f)s[f]=st(f);for(var c=n.s.r;c<=n.e.r;++c){i=tt(c);for(f=n.s.c;f<=n.e.c;++f){r=s[f]+i;t=l?(e[c]||[])[f]:e[r];a="";if(t===undefined)continue;else if(t.F!=null){r=t.F;if(!t.f)continue;a=t.f;if(r.indexOf(":")==-1)r=r+":"+r}if(t.f!=null)a=t.f;else if(t.t=="z")continue;else if(t.t=="n"&&t.v!=null)a=""+t.v;else if(t.t=="b")a=t.v?"TRUE":"FALSE";else if(t.w!==undefined)a="'"+t.w;else if(t.v===undefined)continue;else if(t.t=="s")a="'"+t.v;else a=""+t.v;o[o.length]=r+"="+a}}return o}function Lg(e,r,t){var a=t||{};var n=+!a.skipHeader;var i=e||{};var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var o=typeof a.origin=="string"?ct(a.origin):a.origin;s=o.r;f=o.c}}var l;var c={s:{c:0,r:0},e:{c:f,r:s+r.length-1+n}};if(i["!ref"]){var h=pt(i["!ref"]);c.e.c=Math.max(c.e.c,h.e.c);c.e.r=Math.max(c.e.r,h.e.r);if(s==-1){s=c.e.r+1;c.e.r=s+r.length-1+n}}var u=a.header||[],d=0;r.forEach(function(e,r){j(e).forEach(function(t){if((d=u.indexOf(t))==-1)u[d=u.length]=t;var o=e[t];var c="z";var h="";if(o&&typeof o==="object"&&!(o instanceof Date)){i[ht({c:f+d,r:s+r+n})]=o}else{if(typeof o=="number")c="n";else if(typeof o=="boolean")c="b";else if(typeof o=="string")c="s";else if(o instanceof Date){c="d";if(!a.cellDates){c="n";o=ee(o)}h=a.dateNF||D._table[14]}i[ht({c:f+d,r:s+r+n})]=l={t:c,v:o};if(h)l.z=h}})});c.e.c=Math.max(c.e.c,f+u.length-1);var p=tt(s);if(n)for(d=0;d<u.length;++d)i[st(d+f)+p]={t:"s",v:u[d]};i["!ref"]=dt(c);return i}function Mg(e,r){return Lg(null,e,r)}var Ug={encode_col:st,encode_row:tt,encode_cell:ht,encode_range:dt,decode_col:it,decode_row:rt,split_cell:lt,decode_cell:ct,decode_range:ut,format_cell:gt,get_formulae:Ng,make_csv:Og,make_json:Rg,make_formulae:Ng,sheet_add_aoa:bt,sheet_add_json:Lg,aoa_to_sheet:wt,json_to_sheet:Mg,table_to_sheet:Fv,table_to_book:Ov,sheet_to_csv:Og,sheet_to_txt:Pg,sheet_to_json:Rg,sheet_to_html:Dv.from_sheet,sheet_to_dif:rf.from_sheet,sheet_to_slk:ef.from_sheet,sheet_to_eth:tf.from_sheet,sheet_to_formulae:Ng,sheet_to_row_object_array:Rg};(function(e){e.consts=e.consts||{};function r(r){r.forEach(function(r){e.consts[r[0]]=r[1]})}function t(e,r,t){return e[r]!=null?e[r]:e[r]=t}function a(e,r,t){if(typeof r=="string")return e[r]||(e[r]={t:"z"});if(typeof r!="number")return a(e,ht(r));return a(e,ht({r:r,c:t||0}))}function n(e,r){if(typeof r=="number"){if(r>=0&&e.SheetNames.length>r)return r;throw new Error("Cannot find sheet # "+r)}else if(typeof r=="string"){var t=e.SheetNames.indexOf(r);if(t>-1)return t;throw new Error("Cannot find sheet name |"+r+"|")}else throw new Error("Cannot find sheet |"+r+"|")}e.book_new=function(){return{SheetNames:[],Sheets:{}}};e.book_append_sheet=function(e,r,t){if(!t)for(var a=1;a<=65535;++a)if(e.SheetNames.indexOf(t="Sheet"+a)==-1)break;if(!t)throw new Error("Too many worksheets");Gd(t);if(e.SheetNames.indexOf(t)>=0)throw new Error("Worksheet with name |"+t+"| already exists!");e.SheetNames.push(t);e.Sheets[t]=r};e.book_set_sheet_visibility=function(e,r,a){t(e,"Workbook",{});t(e.Workbook,"Sheets",[]);var i=n(e,r);t(e.Workbook.Sheets,i,{});switch(a){case 0:;case 1:;case 2:break;default:throw new Error("Bad sheet visibility setting "+a);}e.Workbook.Sheets[i].Hidden=a};r([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);e.cell_set_number_format=function(e,r){e.z=r;return e};e.cell_set_hyperlink=function(e,r,t){if(!r){delete e.l}else{e.l={Target:r};if(t)e.l.Tooltip=t}return e};e.cell_set_internal_link=function(r,t,a){return e.cell_set_hyperlink(r,"#"+t,a)};e.cell_add_comment=function(e,r,t){if(!e.c)e.c=[];e.c.push({t:r,a:t||"SheetJS"})};e.sheet_set_array_formula=function(e,r,t){var n=typeof r!="string"?r:pt(r);var i=typeof r=="string"?r:dt(r);for(var s=n.s.r;s<=n.e.r;++s)for(var f=n.s.c;f<=n.e.c;++f){var o=a(e,s,f);o.t="n";o.F=i;delete o.v;if(s==n.s.r&&f==n.s.c)o.f=t}return e};return e})(Ug);if(b&&typeof require!="undefined")(function(){var r={}.Readable;var t=function(e,t){var a=r();var n=t==null?{}:t;if(e==null||e["!ref"]==null){a.push(null);return a}var i=pt(e["!ref"]);var s=n.FS!==undefined?n.FS:",",f=s.charCodeAt(0);var o=n.RS!==undefined?n.RS:"\n",l=o.charCodeAt(0);var c=new RegExp((s=="|"?"\\|":s)+"+$");var h="",u=[];n.dense=Array.isArray(e);var d=n.skipHidden&&e["!cols"]||[];var p=n.skipHidden&&e["!rows"]||[];for(var v=i.s.c;v<=i.e.c;++v)if(!(d[v]||{}).hidden)u[v]=st(v);var g=i.s.r;var m=false;a._read=function(){if(!m){m=true;return a.push("\ufeff")}if(g>i.e.r)return a.push(null);while(g<=i.e.r){++g;if((p[g-1]||{}).hidden)continue;h=Fg(e,i,g-1,u,f,l,s,n);if(h!=null){if(n.strip)h=h.replace(c,"");a.push(h+o);break}}};return a};var a=function(e,t){var a=r();var n=t||{};var i=n.header!=null?n.header:Dv.BEGIN;var s=n.footer!=null?n.footer:Dv.END;a.push(i);var f=ut(e["!ref"]);n.dense=Array.isArray(e);a.push(Dv._preamble(e,f,n));var o=f.s.r;var l=false;a._read=function(){if(o>f.e.r){if(!l){l=true;a.push("</table>"+s)}return a.push(null)}while(o<=f.e.r){a.push(Dv._row(e,f,o,n));++o;break}};return a};var n=function(e,t){var a=r({objectMode:true});if(e==null||e["!ref"]==null){a.push(null);return a}var n={t:"n",v:0},i=0,s=1,f=[],o=0,l="";var c={s:{r:0,c:0},e:{r:0,c:0}};var h=t||{};var u=h.range!=null?h.range:e["!ref"];if(h.header===1)i=1;else if(h.header==="A")i=2;else if(Array.isArray(h.header))i=3;switch(typeof u){case"string":c=pt(u);break;case"number":c=pt(e["!ref"]);c.s.r=u;break;default:c=u;}if(i>0)s=0;var d=tt(c.s.r);var p=[];var v=0;var g=Array.isArray(e);var m=c.s.r,b=0,w=0;if(g&&!e[m])e[m]=[];for(b=c.s.c;b<=c.e.c;++b){p[b]=st(b);n=g?e[m][b]:e[p[b]+d];switch(i){case 1:f[b]=b-c.s.c;break;case 2:f[b]=p[b];break;case 3:f[b]=h.header[b-c.s.c];break;default:if(n==null)n={w:"__EMPTY",t:"s"};l=o=gt(n,null,h);v=0;for(w=0;w<f.length;++w)if(f[w]==l)l=o+"_"+ ++v;f[b]=l;}}m=c.s.r+s;a._read=function(){if(m>c.e.r)return a.push(null);while(m<=c.e.r){var r=Ig(e,c,m,p,i,f,g,h);++m;if(r.isempty===false||(i===1?h.blankrows!==false:!!h.blankrows)){a.push(r.row);break}}};return a};e.stream={to_json:n,to_html:a,to_csv:t}})();e.parse_xlscfb=lv;e.parse_ods=Mv;e.parse_fods=Uv;e.write_ods=Vv;e.parse_zip=fg;e.read=bg;e.readFile=wg;e.readFileSync=wg;e.write=Bg;e.writeFile=yg;e.writeFileSync=yg;e.writeFileAsync=xg;e.utils=Ug;e.SSF=D;e.CFB=W}if(typeof exports!=="undefined")make_xlsx_lib(exports);else if(typeof module!=="undefined"&&module.exports)make_xlsx_lib(module.exports);else if(typeof define==="function"&&define.amd)define("xlsx",function(){if(!XLSX.version)make_xlsx_lib(XLSX);return XLSX});else make_xlsx_lib(XLSX);var XLS=XLSX,ODS=XLSX;

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:activateButton
 * @description
 * # activateButton
 */
webapp.directive('activateButton', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      var activatedClass = 'btn-activated';
      var status = attrs.activateButton;
      var activate = function () {
        element.addClass(activatedClass);
        setTimeout(function () {
          element.removeClass(activatedClass);
        }, 1000);
      };

      element.on('click', function () {
        if (!element.hasClass(activatedClass) && status === 'success') {
          element.addClass('btn-activated-success');
          setTimeout(function () {
            element.removeClass('btn-activated-success');
          }, 1000);
        } else if (!element.hasClass(activatedClass) && status === 'error') {
          element.addClass('btn-activated-error');
          setTimeout(function () {
            element.removeClass('btn-activated-error');
          }, 1000);
        } else if (!element.hasClass(activatedClass)) {
          activate();
        }
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:activeToggle
 * @description
 * # activeToggle
 */
webapp.directive('activeToggle', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element, attr) {
      element.on('click', function () {
        var target = angular.element(attr.target) || Array(element);

        if (element.hasClass('active')) {
          element.removeClass('active');
          target.removeClass('show');
        } else {
          element.addClass('active');
          target.addClass('show');
        }
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:anchorScroll
 * @description
 * # anchorScroll
 */
webapp.directive('anchorScroll', [
  '$location',
  '$anchorScroll',
  function ($location, $anchorScroll) {
    return {
      restrict: 'AC',
      link: function (scope, el, attr) {
        el.on('click', function (e) {
          $location.hash(attr.anchorScroll);
          $anchorScroll();
        });
      },
    };
  },
]);

/*
 ng-sortable v1.3.8
 The MIT License (MIT)

 Copyright (c) 2014 Muhammed Ashik

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';
  angular.module('as.sortable', [])
    .constant('sortableConfig', {
      itemClass: 'as-sortable-item',
      handleClass: 'as-sortable-item-handle',
      placeHolderClass: 'as-sortable-placeholder',
      dragClass: 'as-sortable-drag',
      hiddenClass: 'as-sortable-hidden',
      dragging: 'as-sortable-dragging'
    });
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';

  var mainModule = angular.module('as.sortable');

  /**
   * Helper factory for sortable.
   */
  mainModule.factory('$helper', ['$document', '$window',
    function ($document, $window) {
      return {

        /**
         * Get the height of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Height
         */
        height: function (element) {
          return element[0].getBoundingClientRect().height;
        },

        /**
         * Get the width of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Width
         */
        width: function (element) {
          return element[0].getBoundingClientRect().width;
        },

        /**
         * Get the offset values of an element.
         *
         * @param {Object} element Angular element.
         * @param {Object} [scrollableContainer] Scrollable container object for calculating relative top & left (optional, defaults to Document)
         * @returns {Object} Object with properties width, height, top and left
         */
        offset: function (element, scrollableContainer) {
          var boundingClientRect = element[0].getBoundingClientRect();
          if (!scrollableContainer) {
            scrollableContainer = $document[0].documentElement;
          }

          return {
            width: boundingClientRect.width || element.prop('offsetWidth'),
            height: boundingClientRect.height || element.prop('offsetHeight'),
            top: boundingClientRect.top + ($window.pageYOffset || scrollableContainer.scrollTop - scrollableContainer.offsetTop),
            left: boundingClientRect.left + ($window.pageXOffset || scrollableContainer.scrollLeft - scrollableContainer.offsetLeft)
          };
        },

        /**
         * get the event object for touch.
         *
         * @param  {Object} event the touch event
         * @return {Object} the touch event object.
         */
        eventObj: function (event) {
          var obj = event;
          if (event.targetTouches !== undefined) {
            obj = event.targetTouches.item(0);
          } else if (event.originalEvent !== undefined && event.originalEvent.targetTouches !== undefined) {
            obj = event.originalEvent.targetTouches.item(0);
          }
          return obj;
        },

        /**
         * Checks whether the touch is valid and multiple.
         *
         * @param event the event object.
         * @returns {boolean} true if touch is multiple.
         */
        isTouchInvalid: function (event) {

          var touchInvalid = false;
          if (event.touches !== undefined && event.touches.length > 1) {
            touchInvalid = true;
          } else if (event.originalEvent !== undefined &&
            event.originalEvent.touches !== undefined && event.originalEvent.touches.length > 1) {
            touchInvalid = true;
          }
          return touchInvalid;
        },

        /**
         * Get the start position of the target element according to the provided event properties.
         *
         * @param {Object} event Event
         * @param {Object} target Target element
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         * @returns {Object} Object with properties offsetX, offsetY.
         */
        positionStarted: function (event, target, scrollableContainer) {
          var pos = {};
          pos.offsetX = event.pageX - this.offset(target, scrollableContainer).left;
          pos.offsetY = event.pageY - this.offset(target, scrollableContainer).top;
          pos.startX = pos.lastX = event.pageX;
          pos.startY = pos.lastY = event.pageY;
          pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
          pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
          return pos;
        },

        /**
         * Calculates the event position and sets the direction
         * properties.
         *
         * @param pos the current position of the element.
         * @param event the move event.
         */
        calculatePosition: function (pos, event) {
          // mouse position last events
          pos.lastX = pos.nowX;
          pos.lastY = pos.nowY;

          // mouse position this events
          pos.nowX = event.pageX;
          pos.nowY = event.pageY;

          // distance mouse moved between events
          pos.distX = pos.nowX - pos.lastX;
          pos.distY = pos.nowY - pos.lastY;

          // direction mouse was moving
          pos.lastDirX = pos.dirX;
          pos.lastDirY = pos.dirY;

          // direction mouse is now moving (on both axis)
          pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
          pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

          // axis mouse is now moving on
          var newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

          // calc distance moved on this axis (and direction)
          if (pos.dirAx !== newAx) {
            pos.distAxX = 0;
            pos.distAxY = 0;
          } else {
            pos.distAxX += Math.abs(pos.distX);
            if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
              pos.distAxX = 0;
            }

            pos.distAxY += Math.abs(pos.distY);
            if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
              pos.distAxY = 0;
            }
          }
          pos.dirAx = newAx;
        },

        /**
         * Move the position by applying style.
         *
         * @param event the event object
         * @param element - the dom element
         * @param pos - current position
         * @param container - the bounding container.
         * @param containerPositioning - absolute or relative positioning.
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         */
        movePosition: function (event, element, pos, container, containerPositioning, scrollableContainer) {
          var bounds;
          var useRelative = (containerPositioning === 'relative');

          element.x = event.pageX - pos.offsetX;
          element.y = event.pageY - pos.offsetY;

          if (container) {
            bounds = this.offset(container, scrollableContainer);

            if (useRelative) {
              // reduce positioning by bounds
              element.x -= bounds.left;
              element.y -= bounds.top;

              // reset bounds
              bounds.left = 0;
              bounds.top = 0;
            }

            if (element.x < bounds.left) {
              element.x = bounds.left;
            } else if (element.x >= bounds.width + bounds.left - this.offset(element).width) {
              element.x = bounds.width + bounds.left - this.offset(element).width;
            }
            if (element.y < bounds.top) {
              element.y = bounds.top;
            } else if (element.y >= bounds.height + bounds.top - this.offset(element).height) {
              element.y = bounds.height + bounds.top - this.offset(element).height;
            }
          }

          element.css({
            'left': element.x + 'px',
            'top': element.y + 'px'
          });

          this.calculatePosition(pos, event);
        },

        /**
         * The drag item info and functions.
         * retains the item info before and after move.
         * holds source item and target scope.
         *
         * @param item - the drag item
         * @returns {{index: *, parent: *, source: *,
                 *          sourceInfo: {index: *, itemScope: (*|.dragItem.sourceInfo.itemScope|$scope.itemScope|itemScope), sortableScope: *},
                 *         moveTo: moveTo, isSameParent: isSameParent, isOrderChanged: isOrderChanged, eventArgs: eventArgs, apply: apply}}
         */
        dragItem: function (item) {

          return {
            index: item.index(),
            parent: item.sortableScope,
            source: item,
            targetElement: null,
            targetElementOffset: null,
            sourceInfo: {
              index: item.index(),
              itemScope: item.itemScope,
              sortableScope: item.sortableScope
            },
            canMove: function(itemPosition, targetElement, targetElementOffset) {
              // return true if targetElement has been changed since last call
              if (this.targetElement !== targetElement) {
                this.targetElement = targetElement;
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return true if mouse is moving in the last moving direction of targetElement
              if (itemPosition.dirX * (targetElementOffset.left - this.targetElementOffset.left) > 0 ||
                  itemPosition.dirY * (targetElementOffset.top - this.targetElementOffset.top) > 0) {
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return false otherwise
              return false;
            },
            moveTo: function (parent, index) {
              // move the item to a new position
              this.parent = parent;
              // if the source item is in the same parent, the target index is after the source index and we're not cloning
              if (this.isSameParent() && this.source.index() < index && !this.sourceInfo.sortableScope.cloning) {
                index = index - 1;
              }
              this.index = index;
            },
            isSameParent: function () {
              return this.parent.element === this.sourceInfo.sortableScope.element;
            },
            isOrderChanged: function () {
              return this.index !== this.sourceInfo.index;
            },
            eventArgs: function () {
              return {
                source: this.sourceInfo,
                dest: {
                  index: this.index,
                  sortableScope: this.parent
                }
              };
            },
            apply: function () {
              if (!this.sourceInfo.sortableScope.cloning) {
                // if not cloning, remove the item from the source model.
                this.sourceInfo.sortableScope.removeItem(this.sourceInfo.index);

                // if the dragged item is not already there, insert the item. This avoids ng-repeat dupes error
                if (this.parent.options.allowDuplicates || this.parent.modelValue.indexOf(this.source.modelValue) < 0) {
                  this.parent.insertItem(this.index, this.source.modelValue);
                }
              } else if (!this.parent.options.clone) { // prevent drop inside sortables that specify options.clone = true
                // clone the model value as well
                this.parent.insertItem(this.index, angular.copy(this.source.modelValue));
              }
            }
          };
        },

        /**
         * Check the drag is not allowed for the element.
         *
         * @param element - the element to check
         * @returns {boolean} - true if drag is not allowed.
         */
        noDrag: function (element) {
          return element.attr('no-drag') !== undefined || element.attr('data-no-drag') !== undefined;
        },

        /**
         * Helper function to find the first ancestor with a given selector
         * @param el - angular element to start looking at
         * @param selector - selector to find the parent
         * @returns {Object} - Angular element of the ancestor or body if not found
         * @private
         */
        findAncestor: function (el, selector) {
          el = el[0];
          var matches = Element.matches || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;
          while ((el = el.parentElement) && !matches.call(el, selector)) {
          }
          return el ? angular.element(el) : angular.element(document.body);
        }
      };
    }
  ]);

}());

/*jshint undef: false, unused: false, indent: 2*/
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for Sortable.
   * @param $scope - the sortable scope.
   */
  mainModule.controller('as.sortable.sortableController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.modelValue = null; // sortable list.
    $scope.callbacks = null;
    $scope.type = 'sortable';
    $scope.options = {
      longTouch: false
    };
    $scope.isDisabled = false;

    /**
     * Inserts the item in to the sortable list.
     *
     * @param index - the item index.
     * @param itemData - the item model data.
     */
    $scope.insertItem = function (index, itemData) {
      if ($scope.options.allowDuplicates) {
        $scope.modelValue.splice(index, 0, angular.copy(itemData));
      } else {
        $scope.modelValue.splice(index, 0, itemData);
      }
    };

    /**
     * Removes the item from the sortable list.
     *
     * @param index - index to be removed.
     * @returns {*} - removed item.
     */
    $scope.removeItem = function (index) {
      var removedItem = null;
      if (index > -1) {
        removedItem = $scope.modelValue.splice(index, 1)[0];
      }
      return removedItem;
    };

    /**
     * Checks whether the sortable list is empty.
     *
     * @returns {null|*|$scope.modelValue|boolean}
     */
    $scope.isEmpty = function () {
      return ($scope.modelValue && $scope.modelValue.length === 0);
    };

    /**
     * Wrapper for the accept callback delegates to callback.
     *
     * @param sourceItemHandleScope - drag item handle scope.
     * @param destScope - sortable target scope.
     * @param destItemScope - sortable destination item scope.
     * @returns {*|boolean} - true if drop is allowed for the drag item in drop target.
     */
    $scope.accept = function (sourceItemHandleScope, destScope, destItemScope) {
      return $scope.callbacks.accept(sourceItemHandleScope, destScope, destItemScope);
    };

  }]);

  /**
   * Sortable directive - defines callbacks.
   * Parent directive for draggable and sortable items.
   * Sets modelValue, callbacks, element in scope.
   * sortOptions also includes a longTouch option which activates longTouch when set to true (default is false).
   */
  mainModule.directive('asSortable',
    function () {
      return {
        require: 'ngModel', // get a hold of NgModelController
        restrict: 'A',
        scope: true,
        controller: 'as.sortable.sortableController',
        link: function (scope, element, attrs, ngModelController) {

          var ngModel, callbacks;

          ngModel = ngModelController;

          if (!ngModel) {
            return; // do nothing if no ng-model
          }

          // Set the model value in to scope.
          ngModel.$render = function () {
            scope.modelValue = ngModel.$modelValue;
          };
          //set the element in scope to be accessed by its sub scope.
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)

          callbacks = {accept: null, orderChanged: null, itemMoved: null, dragStart: null, dragMove:null, dragCancel: null, dragEnd: null};

          /**
           * Invoked to decide whether to allow drop.
           *
           * @param sourceItemHandleScope - the drag item handle scope.
           * @param destSortableScope - the drop target sortable scope.
           * @param destItemScope - the drop target item scope.
           * @returns {boolean} - true if allowed for drop.
           */
          callbacks.accept = function (sourceItemHandleScope, destSortableScope, destItemScope) {
            return true;
          };

          /**
           * Invoked when order of a drag item is changed.
           *
           * @param event - the event object.
           */
          callbacks.orderChanged = function (event) {
          };

          /**
           * Invoked when the item is moved to other sortable.
           *
           * @param event - the event object.
           */
          callbacks.itemMoved = function (event) {
          };

          /**
           * Invoked when the drag started successfully.
           *
           * @param event - the event object.
           */
          callbacks.dragStart = function (event) {
          };

          /**
           * Invoked when the drag move.
           *
           * @param itemPosition - the item position.
           * @param containment - the containment element.
           * @param eventObj - the event object.
          */
          callbacks.dragMove = angular.noop;

          /**
           * Invoked when the drag cancelled.
           *
           * @param event - the event object.
           */
          callbacks.dragCancel = function (event) {
          };

          /**
           * Invoked when the drag stopped.
           *
           * @param event - the event object.
           */
          callbacks.dragEnd = function (event) {
          };

          //Set the sortOptions callbacks else set it to default.
          scope.$watch(attrs.asSortable, function (newVal, oldVal) {
            angular.forEach(newVal, function (value, key) {
              if (callbacks[key]) {
                if (typeof value === 'function') {
                  callbacks[key] = value;
                }
              } else {
                scope.options[key] = value;
              }
            });
            scope.callbacks = callbacks;
          }, true);

          // Set isDisabled if attr is set, if undefined isDisabled = false
          if (angular.isDefined(attrs.isDisabled)) {
            scope.$watch(attrs.isDisabled, function (newVal, oldVal) {
              if (!angular.isUndefined(newVal)) {
                scope.isDisabled = newVal;
              }
            }, true);
          }
        }
      };
    });

}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortableItemHandle
   *
   * @param $scope - item handle scope.
   */
  mainModule.controller('as.sortable.sortableItemHandleController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.itemScope = null;
    $scope.type = 'handle';
  }]);

  //Check if a node is parent to another node
  function isParent(possibleParent, elem) {
    if(!elem || elem.nodeName === 'HTML') {
      return false;
    }

    if(elem.parentNode === possibleParent) {
      return true;
    }

    return isParent(possibleParent, elem.parentNode);
  }

  /**
   * Directive for sortable item handle.
   */
  mainModule.directive('asSortableItemHandle', ['sortableConfig', '$helper', '$window', '$document', '$timeout',
    function (sortableConfig, $helper, $window, $document, $timeout) {
      return {
        require: '^asSortableItem',
        scope: true,
        restrict: 'A',
        controller: 'as.sortable.sortableItemHandleController',
        link: function (scope, element, attrs, itemController) {

          var dragElement, //drag item element.
            placeHolder, //place holder class element.
            placeElement,//hidden place element.
            itemPosition, //drag item element position.
            dragItemInfo, //drag item data.
            containment,//the drag container.
            containerPositioning, // absolute or relative positioning.
            dragListen,// drag listen event.
            scrollableContainer, //the scrollable container
            dragStart,// drag start event.
            dragMove,//drag move event.
            dragEnd,//drag end event.
            dragCancel,//drag cancel event.
            isDraggable,//is element draggable.
            placeHolderIndex,//placeholder index in items elements.
            bindDrag,//bind drag events.
            unbindDrag,//unbind drag events.
            bindEvents,//bind the drag events.
            unBindEvents,//unbind the drag events.
            hasTouch,// has touch support.
            isIOS,// is iOS device.
            longTouchStart, // long touch start event
            longTouchCancel, // cancel long touch
            longTouchTimer, // timer promise for the long touch on iOS devices
            dragHandled, //drag handled.
            createPlaceholder,//create place holder.
            isPlaceHolderPresent,//is placeholder present.
            isDisabled = false, // drag enabled
            escapeListen, // escape listen event
            isLongTouch = false; //long touch disabled.

          hasTouch = 'ontouchstart' in $window;
          isIOS = /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream;

          if (sortableConfig.handleClass) {
            element.addClass(sortableConfig.handleClass);
          }

          scope.itemScope = itemController.scope;
          element.data('_scope', scope); // #144, work with angular debugInfoEnabled(false)

          scope.$watchGroup(['sortableScope.isDisabled', 'sortableScope.options.longTouch'], function (newValues) {
            if (isDisabled !== newValues[0]) {
              isDisabled = newValues[0];
              if (isDisabled) {
                unbindDrag();
              } else {
                bindDrag();
              }
            } else if (isLongTouch !== newValues[1]) {
              isLongTouch = newValues[1];
              unbindDrag();
              bindDrag();
            } else {
              bindDrag();
            }
          });

          scope.$on('$destroy', function () {
            angular.element($document[0].body).unbind('keydown', escapeListen);
          });

          createPlaceholder = function (itemScope) {
            if (typeof scope.sortableScope.options.placeholder === 'function') {
              return angular.element(scope.sortableScope.options.placeholder(itemScope));
            } else if (typeof scope.sortableScope.options.placeholder === 'string') {
              return angular.element(scope.sortableScope.options.placeholder);
            } else {
              return angular.element($document[0].createElement(itemScope.element.prop('tagName')));
            }
          };

          /**
           * Listens for a 10px movement before
           * dragStart is called to allow for
           * a click event on the element.
           *
           * @param event - the event object.
           */
          dragListen = function (event) {

            var unbindMoveListen = function () {
              angular.element($document).unbind('mousemove', moveListen);
              angular.element($document).unbind('touchmove', moveListen);
              element.unbind('mouseup', unbindMoveListen);
              element.unbind('touchend', unbindMoveListen);
              element.unbind('touchcancel', unbindMoveListen);
            };

            var startPosition;
            var moveListen = function (e) {
              e.preventDefault();
              var eventObj = $helper.eventObj(e);
              if (!startPosition) {
                startPosition = { clientX: eventObj.clientX, clientY: eventObj.clientY };
              }
              if (Math.abs(eventObj.clientX - startPosition.clientX) + Math.abs(eventObj.clientY - startPosition.clientY) > 10) {
                unbindMoveListen();
                dragStart(event);
              }
            };

            angular.element($document).bind('mousemove', moveListen);
            angular.element($document).bind('touchmove', moveListen);
            element.bind('mouseup', unbindMoveListen);
            element.bind('touchend', unbindMoveListen);
            element.bind('touchcancel', unbindMoveListen);
            event.stopPropagation();
          };

          /**
           * Triggered when drag event starts.
           *
           * @param event the event object.
           */
          dragStart = function (event) {

            var eventObj, tagName;

            if (!hasTouch && (event.button === 2 || event.which === 3)) {
              // disable right click
              return;
            }
            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            if (dragHandled || !isDraggable(event)) {
              // event has already fired in other scope.
              return;
            }
            // Set the flag to prevent other items from inheriting the drag event
            dragHandled = true;
            event.preventDefault();
            eventObj = $helper.eventObj(event);
            scope.sortableScope = scope.sortableScope || scope.itemScope.sortableScope; //isolate directive scope issue.
            scope.callbacks = scope.callbacks || scope.itemScope.callbacks; //isolate directive scope issue.

            if (scope.itemScope.sortableScope.options.clone || (scope.itemScope.sortableScope.options.ctrlClone && event.ctrlKey)) {
                // Clone option is true
                // or Ctrl clone option is true & the ctrl key was pressed when the user innitiated drag
              scope.itemScope.sortableScope.cloning = true;
            } else {
              scope.itemScope.sortableScope.cloning = false;
            }

            // (optional) Scrollable container as reference for top & left offset calculations, defaults to Document
            scrollableContainer = angular.element($document[0].querySelector(scope.sortableScope.options.scrollableContainer)).length > 0 ?
              $document[0].querySelector(scope.sortableScope.options.scrollableContainer) : $document[0].documentElement;

            containment = (scope.sortableScope.options.containment)? $helper.findAncestor(element, scope.sortableScope.options.containment):angular.element($document[0].body);
            //capture mouse move on containment.
            containment.css('cursor', 'move');
            containment.css('cursor', '-webkit-move');
            containment.css('cursor', '-moz-move');
            containment.addClass('as-sortable-un-selectable');

            // container positioning
            containerPositioning = scope.sortableScope.options.containerPositioning || 'absolute';

            dragItemInfo = $helper.dragItem(scope);
            tagName = scope.itemScope.element.prop('tagName');

            dragElement = angular.element($document[0].createElement(scope.sortableScope.element.prop('tagName')))
              .addClass(scope.sortableScope.element.attr('class')).addClass(sortableConfig.dragClass);
            dragElement.css('width', $helper.width(scope.itemScope.element) + 'px');
            dragElement.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeHolder = createPlaceholder(scope.itemScope)
              .addClass(sortableConfig.placeHolderClass).addClass(scope.sortableScope.options.additionalPlaceholderClass);
            placeHolder.css('width', $helper.width(scope.itemScope.element) + 'px');
            placeHolder.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeElement = angular.element($document[0].createElement(tagName));
            if (sortableConfig.hiddenClass) {
              placeElement.addClass(sortableConfig.hiddenClass);
            }

            itemPosition = $helper.positionStarted(eventObj, scope.itemScope.element, scrollableContainer);

            // fill the immediate vacuum.
            if (!scope.itemScope.sortableScope.options.clone) {
              scope.itemScope.element.after(placeHolder);
            }

            if (scope.itemScope.sortableScope.cloning) {
              // clone option is enabled or triggered, so clone the element.
              dragElement.append(scope.itemScope.element.clone());
            }
            else {
              // add hidden placeholder element in original position.
              scope.itemScope.element.after(placeElement);
              // not cloning, so use the original element.
              dragElement.append(scope.itemScope.element);
            }

            containment.append(dragElement);
            $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

            scope.sortableScope.$apply(function () {
              scope.callbacks.dragStart(dragItemInfo.eventArgs());
            });
            bindEvents();
          };

          /**
           * Allow Drag if it is a proper item-handle element.
           *
           * @param event - the event object.
           * @return boolean - true if element is draggable.
           */
          isDraggable = function (event) {

            var elementClicked, sourceScope, isDraggable;

            elementClicked = angular.element(event.target);

            // look for the handle on the current scope or parent scopes
            sourceScope = fetchScope(elementClicked);

            isDraggable = (sourceScope && sourceScope.type === 'handle');

            //If a 'no-drag' element inside item-handle if any.
            while (isDraggable && elementClicked[0] !== element[0]) {
              if ($helper.noDrag(elementClicked)) {
                isDraggable = false;
              }
              elementClicked = elementClicked.parent();
            }
            return isDraggable;
          };

          /**
           * Inserts the placeHolder in to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertBefore(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement[0].parentNode.insertBefore(placeHolder[0], targetElement[0]);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index());
            }
          }

          /**
           * Inserts the placeHolder next to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertAfter(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement.after(placeHolder);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index() + 1);
            }
          }

          /**
           * Triggered when drag is moving.
           *
           * @param event - the event object.
           */
          dragMove = function (event) {

            var eventObj, targetX, targetY, targetScope, targetElement;

            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            if (dragElement) {

              event.preventDefault();

              eventObj = $helper.eventObj(event);

              // checking if dragMove callback exists, to prevent application
              // rerenderings on each mouse move event
              if (scope.callbacks.dragMove !== angular.noop) {
                scope.sortableScope.$apply(function () {
                  scope.callbacks.dragMove(itemPosition, containment, eventObj);
                });
              }

              targetX = eventObj.pageX - $document[0].documentElement.scrollLeft;
              targetY = eventObj.pageY - ($window.pageYOffset || $document[0].documentElement.scrollTop);

              //IE fixes: hide show element, call element from point twice to return pick correct element.
              dragElement.addClass(sortableConfig.hiddenClass);
              targetElement = angular.element($document[0].elementFromPoint(targetX, targetY));
              dragElement.removeClass(sortableConfig.hiddenClass);

              $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

              //Set Class as dragging starts
              dragElement.addClass(sortableConfig.dragging);

              targetScope = fetchScope(targetElement);

              if (!targetScope || !targetScope.type) {
                return;
              }
              if (targetScope.type === 'handle') {
                targetScope = targetScope.itemScope;
              }
              if (targetScope.type !== 'item' && targetScope.type !== 'sortable') {
                return;
              }

              if (targetScope.type === 'item' && targetScope.accept(scope, targetScope.sortableScope, targetScope)) {
                // decide where to insert placeholder based on target element and current placeholder if is present
                targetElement = targetScope.element;

                // Fix #241 Drag and drop have trembling with blocks of different size
                var targetElementOffset = $helper.offset(targetElement, scrollableContainer);
                if (!dragItemInfo.canMove(itemPosition, targetElement, targetElementOffset)) {
                  return;
                }

                var placeholderIndex = placeHolderIndex(targetScope.sortableScope.element);
                if (placeholderIndex < 0) {
                  insertBefore(targetElement, targetScope);
                } else {
                  if (placeholderIndex <= targetScope.index()) {
                    insertAfter(targetElement, targetScope);
                  } else {
                    insertBefore(targetElement, targetScope);
                  }
                }
              }

              if (targetScope.type === 'sortable') {//sortable scope.
                if (targetScope.accept(scope, targetScope) &&
                  !isParent(targetScope.element[0], targetElement[0])) {
                  //moving over sortable bucket. not over item.
                  if (!isPlaceHolderPresent(targetElement) && !targetScope.options.clone) {
                    targetElement[0].appendChild(placeHolder[0]);
                    dragItemInfo.moveTo(targetScope, targetScope.modelValue.length);
                  }
                }
              }
            }
          };


          /**
           * Fetch scope from element or parents
           * @param  {object} element Source element
           * @return {object}         Scope, or null if not found
           */
          function fetchScope(element) {
            var scope;
            while (!scope && element.length) {
              scope = element.data('_scope');
              if (!scope) {
                element = element.parent();
              }
            }
            return scope;
          }


          /**
           * Get position of place holder among item elements in itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} -1 if placeholder is not present, index if yes.
           */
          placeHolderIndex = function (targetElement) {
            var itemElements, i;
            // targetElement is placeHolder itself, return index 0
            if (targetElement.hasClass(sortableConfig.placeHolderClass)){
              return 0;
            }
            // find index in target children
            itemElements = targetElement.children();
            for (i = 0; i < itemElements.length; i += 1) {
              //TODO may not be accurate when elements contain other siblings than item elements
              //solve by adding 1 to model index of previous item element
              if (angular.element(itemElements[i]).hasClass(sortableConfig.placeHolderClass)) {
                return i;
              }
            }
            return -1;
          };


          /**
           * Check there is no place holder placed by itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} true if place holder present.
           */
          isPlaceHolderPresent = function (targetElement) {
            return placeHolderIndex(targetElement) >= 0;
          };

          /**
           * Rollback the drag data changes.
           */

          function rollbackDragChanges() {
            if (!scope.itemScope.sortableScope.cloning) {
              placeElement.replaceWith(scope.itemScope.element);
            }
            placeHolder.remove();
            dragElement.remove();
            dragElement = null;
            dragHandled = false;
            containment.css('cursor', '');
            containment.removeClass('as-sortable-un-selectable');
          }

          /**
           * triggered while drag ends.
           *
           * @param event - the event object.
           */
          dragEnd = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();
            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              // update model data
              dragItemInfo.apply();
              scope.sortableScope.$apply(function () {
                if (dragItemInfo.isSameParent()) {
                  if (dragItemInfo.isOrderChanged()) {
                    scope.callbacks.orderChanged(dragItemInfo.eventArgs());
                  }
                } else {
                  scope.callbacks.itemMoved(dragItemInfo.eventArgs());
                }
              });
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragEnd(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * triggered while drag is cancelled.
           *
           * @param event - the event object.
           */
          dragCancel = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();

            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragCancel(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * Binds the drag start events.
           */
          bindDrag = function () {
            if (hasTouch) {
              if (isLongTouch) {
                if (isIOS) {
                  element.bind('touchstart', longTouchStart);
                  element.bind('touchend', longTouchCancel);
                  element.bind('touchmove', longTouchCancel);
                } else {
                  element.bind('contextmenu', dragListen);
                }
              } else {
                element.bind('touchstart', dragListen);
              }
            }
            element.bind('mousedown', dragListen);
          };

          /**
           * Unbinds the drag start events.
           */
          unbindDrag = function () {
            element.unbind('touchstart', longTouchStart);
            element.unbind('touchend', longTouchCancel);
            element.unbind('touchmove', longTouchCancel);
            element.unbind('contextmenu', dragListen);
            element.unbind('touchstart', dragListen);
            element.unbind('mousedown', dragListen);
          };

          /**
           * starts a timer to detect long touch on iOS devices. If touch held for more than 500ms,
           * it would be considered as long touch.
           *
           * @param event - the event object.
           */
          longTouchStart = function(event) {
            longTouchTimer = $timeout(function() {
              dragListen(event);
            }, 500);
          };

          /**
           * cancel the long touch and its timer.
           */
          longTouchCancel = function() {
            $timeout.cancel(longTouchTimer);
          };

          //bind drag start events.
          //put in a watcher since this method is now depending on the longtouch option from sortable.sortOptions
          //bindDrag();

          //Cancel drag on escape press.
          escapeListen = function (event) {
            if (event.keyCode === 27) {
              dragCancel(event);
            }
          };
          angular.element($document[0].body).bind('keydown', escapeListen);

          /**
           * Binds the events based on the actions.
           */
          bindEvents = function () {
            angular.element($document).bind('touchmove', dragMove);
            angular.element($document).bind('touchend', dragEnd);
            angular.element($document).bind('touchcancel', dragCancel);
            angular.element($document).bind('mousemove', dragMove);
            angular.element($document).bind('mouseup', dragEnd);
          };

          /**
           * Un binds the events for drag support.
           */
          unBindEvents = function () {
            angular.element($document).unbind('touchend', dragEnd);
            angular.element($document).unbind('touchcancel', dragCancel);
            angular.element($document).unbind('touchmove', dragMove);
            angular.element($document).unbind('mouseup', dragEnd);
            angular.element($document).unbind('mousemove', dragMove);
          };
        }
      };
    }]);
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortable item.
   *
   * @param $scope - drag item scope
   */
  mainModule.controller('as.sortable.sortableItemController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.sortableScope = null;
    $scope.modelValue = null; // sortable item.
    $scope.type = 'item';

    /**
     * returns the index of the drag item from the sortable list.
     *
     * @returns {*} - index value.
     */
    $scope.index = function () {
      return $scope.$index;
    };

    /**
     * Returns the item model data.
     *
     * @returns {*} - item model value.
     */
    $scope.itemData = function () {
      return $scope.sortableScope.modelValue[$scope.$index];
    };

  }]);

  /**
   * sortableItem directive.
   */
  mainModule.directive('asSortableItem', ['sortableConfig',
    function (sortableConfig) {
      return {
        require: ['^asSortable', '?ngModel'],
        restrict: 'A',
        controller: 'as.sortable.sortableItemController',
        link: function (scope, element, attrs, ctrl) {
          var sortableController = ctrl[0];
          var ngModelController = ctrl[1];
          if (sortableConfig.itemClass) {
            element.addClass(sortableConfig.itemClass);
          }
          scope.sortableScope = sortableController.scope;
          if (ngModelController) {
            ngModelController.$render = function () {
              scope.modelValue = ngModelController.$modelValue;
            };
          } else {
            scope.modelValue = sortableController.scope.modelValue[scope.$index];
          }
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)
        }
      };
    }]);

}());

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:chartMorris
 * @description
 * # chartMorris
 * https://github.com/jasonshark/ng-morris/blob/master/src/ngMorris.js
 */
webapp
  .directive('morrisLineChart', function () {
    return {
      restrict: 'A',
      scope: {
        lineData: '=',
        lineXkey: '@',
        lineYkeys: '@',
        lineLabels: '@',
        lineColors: '@',
      },
      link: function (scope, elem, attrs) {
        var colors, morris;
        if (scope.lineColors === void 0 || scope.lineColors === '') {
          colors = null;
        } else {
          colors = JSON.parse(scope.lineColors);
        }
        scope.$watch('lineData', function () {
          if (scope.lineData) {
            if (!morris) {
              morris = new Morris.Line({
                element: elem,
                data: scope.lineData,
                xkey: scope.lineXkey,
                ykeys: JSON.parse(scope.lineYkeys),
                labels: JSON.parse(scope.lineLabels),
                lineColors: colors || [
                  '#0b62a4',
                  '#7a92a3',
                  '#4da74d',
                  '#afd8f8',
                  '#edc240',
                  '#cb4b4b',
                  '#9440ed',
                ],
                resize: true,
              });
            } else {
              morris.setData(scope.lineData);
            }
          }
        });
      },
    };
  })

  .directive('morrisAreaChart', function () {
    return {
      restrict: 'A',
      scope: {
        lineData: '=',
        lineXkey: '@',
        lineYkeys: '@',
        lineLabels: '@',
        lineColors: '@',
        lineWidth: '@',
        fillOpacity: '@',
        showGrid: '@',
      },
      link: function (scope, elem, attrs) {
        var colors, morris;
        if (scope.lineColors === void 0 || scope.lineColors === '') {
          colors = null;
        } else {
          colors = JSON.parse(scope.lineColors);
        }
        scope.$watch('lineData', function () {
          if (scope.lineData) {
            if (!morris) {
              morris = new Morris.Area({
                element: elem,
                data: scope.lineData,
                xkey: scope.lineXkey,
                ykeys: JSON.parse(scope.lineYkeys),
                labels: JSON.parse(scope.lineLabels),
                lineColors: colors || [
                  '#0b62a4',
                  '#7a92a3',
                  '#4da74d',
                  '#afd8f8',
                  '#edc240',
                  '#cb4b4b',
                  '#9440ed',
                ],
                lineWidth: scope.lineWidth || '0',
                fillOpacity: scope.fillOpacity || '0.8',
                grid: scope.showGrid || false,
                resize: true,
              });
            } else {
              morris.setData(scope.lineData);
            }
          }
        });
      },
    };
  })

  .directive('morrisBarChart', function () {
    return {
      restrict: 'A',
      scope: {
        barData: '=',
        barXkey: '@',
        barYkeys: '@',
        barLabels: '@',
        barColors: '@',
      },
      link: function (scope, elem, attrs) {
        var colors, morris;
        if (scope.barColors === void 0 || scope.barColors === '') {
          colors = null;
        } else {
          colors = JSON.parse(scope.barColors);
        }

        scope.$watch('barData', function () {
          if (scope.barData) {
            if (!morris) {
              morris = new Morris.Bar({
                element: elem,
                data: scope.barData,
                xkey: scope.barXkey,
                ykeys: JSON.parse(scope.barYkeys),
                labels: JSON.parse(scope.barLabels),
                barColors: colors || [
                  '#0b62a4',
                  '#7a92a3',
                  '#4da74d',
                  '#afd8f8',
                  '#edc240',
                  '#cb4b4b',
                  '#9440ed',
                ],
                xLabelMargin: 2,
                resize: true,
              });
            } else {
              morris.setData(scope.barData);
            }
          }
        });
      },
    };
  })

  .directive('morrisDonutChart', function () {
    return {
      restrict: 'A',
      scope: {
        donutData: '=',
        donutColors: '@',
      },
      link: function (scope, elem, attrs) {
        var colors, morris;
        if (scope.donutColors === void 0 || scope.donutColors === '') {
          colors = null;
        } else {
          colors = JSON.parse(scope.donutColors);
        }

        scope.$watch('donutData', function () {
          if (scope.donutData) {
            if (!morris) {
              morris = new Morris.Donut({
                element: elem,
                data: scope.donutData,
                colors: colors || [
                  '#0B62A4',
                  '#3980B5',
                  '#679DC6',
                  '#95BBD7',
                  '#B0CCE1',
                  '#095791',
                  '#095085',
                  '#083E67',
                  '#052C48',
                  '#042135',
                ],
                resize: true,
              });
            } else {
              morris.setData(scope.donutData);
            }
          }
        });
      },
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:checkToggler
 * @description
 * # checkToggler
 */
webapp.directive('checkToggler', function () {
  return {
    restrict: 'E',
    link: function postLink(scope, element) {
      element.on('click', function () {
        if (element.hasClass('checked')) {
          element.removeClass('checked');
        } else {
          element.addClass('checked');
        }
      });
    },
  };
});

(function () {
  "use strict";
  webapp.directive('clickAndDisable', function() {
    return {
      scope: {
        clickAndDisable: '&'
      },
      link: function(scope, iElement, iAttrs) {
        iElement.bind('click', function() {
          iElement.prop('disabled',true);
          scope.clickAndDisable().finally(function() {
            iElement.prop('disabled',false);
          })
        });
      }
    };
  });
})();

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:clock
 * @description
 * # clock
 */
webapp.directive('clock', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      radius: '@',
      zone: '@?',
      lightFill: '@?',
      darkFill: '@?',
    },
    template:
      '<div class=\'bloc-clock\' ng-style=\'divStyle()\'>\n  <svg xmlns="http://www.w3.org/2000/svg"\n   style="padding: 10px 0"\n    width="100%"\n       height="100%"\n       viewBox="0 0 200 200">\n    <g class=\'face\' style=\'stroke: black; stroke-width: 0px;\'>\n      <g>\n        <circle style="stroke: rgba(255,255,255,.5); fill: rgba(255,255,255,0); stroke-width: 6px;"\n                cx="100"\n                cy="100"\n                r="100"/>\n        <line x1="100"\n              x2="100"\n              y1="10"\n              y2="0"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="187"\n              x2="178"\n              y1="50"\n              y2="55"\n              />\n        <line x1="190"\n              x2="200"\n              y1="100"\n              y2="100"\n              />\n        <line x1="187"\n              x2="178"\n              y1="150"\n              y2="145"\n              />\n        <line x1="150"\n              x2="145"\n              y1="187"\n              y2="178"\n              />\n        <line x1="100"\n              x2="100"\n              y1="190"\n              y2="200"\n              />\n        <line x1="50"\n              x2="55"\n              y1="187"\n              y2="178"\n              />\n        <line x1="13"\n              x2="22"\n              y1="150"\n              y2="145"\n              />\n        <line x1="0"\n              x2="10"\n              y1="100"\n              y2="100"\n              />\n        <line x1="13"\n              x2="22"\n              y1="50"\n              y2="55"\n              />\n        <line x1="50"\n              x2="55"\n              y1="13"\n              y2="22"\n              />\n      </g>\n      <g>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="45"\n                style="stroke-width: 6px"\n                class="hourhand"/>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="15"\n                style="stroke-width: 6px"\n                class="minutehand" />\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="5"\n                style="stroke-width: 3px; stroke: rgba(255,255,255,.5)"\n                class="secondhand"/>\n      <circle cx="100"\n cy="100"\n r="8"\n fill="white"\n />\n   </g>\n    </g>\n  </svg>\n</div>',
    link: function (scope, el, attrs) {
      var drawClock, drawHands, getRad, getX, getY;

      scope.divStyle = function () {
        return {
          width: scope.w(),
          height: scope.w(),
          margin: '0 auto',
        };
      };

      scope.w = function () {
        return scope.radius * 2;
      };

      getX = function (degrees, r, adjust, x) {
        var adj;
        x = x || r;
        adj = adjust || 1;
        return x + r * adj * Math.cos(getRad(degrees));
      };

      getY = function (degrees, r, adjust, y) {
        var adj;
        y = y || r;
        adj = adjust || 1;
        return y + r * adj * Math.sin(getRad(degrees));
      };

      getRad = function (degrees) {
        var adjust;
        adjust = Math.PI / 2;
        return (degrees * Math.PI) / 180 - adjust;
      };

      drawHands = function () {
        var $circle,
          H_HAND_SIZE,
          M_HAND_SIZE,
          S_HAND_SIZE,
          dark,
          drawHand,
          fillColor,
          hour,
          hour24,
          r,
          strokeColor,
          t;
        S_HAND_SIZE = 0.95;
        M_HAND_SIZE = 0.85;
        H_HAND_SIZE = 0.55;
        t = scope.zone ? moment.tz(new Date(), scope.zone) : moment();
        r = 100;
        $circle = el.find('circle');
        hour24 = Number(t.format('H'));
        dark = hour24 >= 18 || hour24 < 6;
        strokeColor = 'rgba(255,255,255,1)';
        el.find('line').not('.secondhand').css('stroke', strokeColor);
        drawHand = function (hand, value, size, degrees) {
          var deg, x2, y2;
          deg = degrees * value;
          x2 = getX(deg, r, size, r);
          y2 = getY(deg, r, size, r);
          hand.attr('x1', r);
          hand.attr('y1', r);
          hand.attr('x2', x2);
          hand.attr('y2', y2);
        };
        hour = t.hour() + t.minute() / 60;
        drawHand(
          angular.element(el).find('.secondhand'),
          t.second(),
          S_HAND_SIZE,
          6
        );
        drawHand(
          angular.element(el).find('.minutehand'),
          t.minute(),
          M_HAND_SIZE,
          6
        );
        drawHand(angular.element(el).find('.hourhand'), hour, H_HAND_SIZE, 30);
      };
      drawHands();
      setInterval(drawHands, 1000);
    },
  };
});

/* 'use strict'; */

/**
 * @ngdoc directive
 * @name minovateApp.directive:collapseSidebarSm
 * @description
 * # collapseSidebarSm
 */
webapp.directive('collapseSidebar', function ($rootScope) {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var app = angular.element('.appWrapper'),
        $window = angular.element(window),
        width = $window.width();

      var removeRipple = function () {
        angular.element('#sidebar').find('.ink').remove();
      };

      var collapse = function () {
        width = $window.width();

        if (width < 992) {
          app.addClass('sidebar-sm');
        } else {
          //app.removeClass('sidebar-sm sidebar-xs');
        }

        if (width < 768) {
          app.removeClass('sidebar-sm').addClass('sidebar-xs');
        } else if (width > 992) {
          //app.removeClass('sidebar-sm sidebar-xs');
        } else {
          //app.removeClass('sidebar-xs').addClass('sidebar-sm');
        }

        if (app.hasClass('sidebar-sm-forced')) {
          app.addClass('sidebar-sm');
        }

        if (app.hasClass('sidebar-xs-forced')) {
          app.addClass('sidebar-xs');
        }
      };

      collapse();

      $window.resize(function () {
        if (width !== $window.width()) {
          var t;
          clearTimeout(t);
          t = setTimeout(collapse, 300);
          removeRipple();
        }
      });

      element.on('click', function (e) {
        if (app.hasClass('sidebar-sm')) {
          app.removeClass('sidebar-sm').addClass('sidebar-xs');
        } else if (app.hasClass('sidebar-xs')) {
          app.removeClass('sidebar-xs');
        } else {
          app.addClass('sidebar-sm');
        }

        app.removeClass('sidebar-sm-forced sidebar-xs-forced');
        app.parent().removeClass('sidebar-sm sidebar-xs');
        removeRipple();
        e.preventDefault();
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:daterangepicker
 * @description
 * # daterangepicker
 */
webapp.directive('daterangepicker', function () {
  return {
    restrict: 'A',
    scope: {
      options: '=daterangepicker',
      start: '=dateBegin',
      end: '=dateEnd',
    },
    link: function (scope, element) {
      element.daterangepicker(scope.options, function (start, end) {
        scope.start = start.format('MMMM D, YYYY');
        scope.end = end.format('MMMM D, YYYY');
        scope.$apply();
      });
    },
  };
});

'use strict';

webapp.directive('numbersOnly', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }
      ngModelCtrl.$parsers.push(fromUser);
    },
  };
});

(function () {
  "use strict";
  webapp.directive('fileDropzone', function() {
  return {
    restrict: 'A',
    scope: {
      file: '=',
      fileName: '='
    },
    link: function(scope, element, attrs) {
      var checkSize,
          isTypeValid,
          processDragOverOrEnter,
          validMimeTypes;

      processDragOverOrEnter = function (event) {
        if (event != null) {
          event.preventDefault();
        }
        if(enableUploadComponent()) {
          var $obj = $(".dhx-dropable-area.drop-files-here");
          if($obj.length == 0) $obj = $(".dhx-files-block.dhx-webkit-scroll");
          if( $obj.length > 0) {
            $obj.closest(".layout_y").addClass('dhx-dragin');
          }
        }
        return false;
      };

      validMimeTypes = attrs.fileDropzone;
      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);
      element.hover(function(){

      }, function(){
        var $obj = $(".dhx-dropable-area.drop-files-here");
        $obj.closest(".layout_y").removeClass('dhx-dragin');
      });
      

      return element.bind('drop', function(event) {
        console.log("drop")

        return false;
      });
    }
  };
});
})();

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:formSubmit
 * @description
 * # formSubmit
 */
webapp.directive('submit', function () {
  return {
    restrict: 'A',
    link: function (scope, formElement, attrs) {
      var form;
      form = scope[attrs.name];
      return formElement.bind('submit', function () {
        angular.forEach(form, function (field, name) {
          if (typeof name === 'string' && !name.match('^[$]')) {
            if (field.$pristine) {
              return field.$setViewValue(field.$value);
            }
          }
        });
        if (form.$valid) {
          return scope.$apply(attrs.submit);
        }
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:gaugeChart
 * @description
 * # gaugeChart
 */

webapp.directive('gaugeChart', [
  function () {
    return {
      restrict: 'A',
      scope: {
        data: '=',
        options: '=',
      },
      link: function ($scope, $el) {
        var data = $scope.data,
          options = $scope.options,
          gauge = new Gauge($el[0]).setOptions(options);

        gauge.maxValue = data.maxValue;
        gauge.animationSpeed = data.animationSpeed;
        gauge.set(data.val);
      },
    };
  },
]);

(function () {
  "use strict";
  webapp.directive('inputEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.inputEnter);
          });
          event.preventDefault();
        }
      });
    }
  });
})();

(function () {
  "use strict";
  webapp.directive('krInput', ['$parse', function($parse) {
    return {
        priority : 2,
        restrict : 'A',
        compile : function(element) {
            element.on('compositionstart', function(e) {
                e.stopImmediatePropagation();
            });
        },
    };
  }]);
})();

/**
 * lazy-model directive
 *
 * AngularJS directive that works like `ng-model` but saves changes
 * only when form is submitted (otherwise changes are canceled)
 */

angular
  .module('lazyModel', [])

  // lazy-model
  .directive('lazyModel', [
    '$compile',
    '$timeout',
    function ($compile, $timeout) {
      'use strict';
      return {
        restrict: 'A',
        priority: 500,
        terminal: true,
        require: ['lazyModel', '^form', '?^lazySubmit'],
        scope: true,
        controller: [
          '$scope',
          '$element',
          '$attrs',
          '$parse',
          function ($scope, $element, $attrs, $parse) {
            if ($attrs.lazyModel === '') {
              throw '`lazy-model` should have a value.';
            }

            // getter and setter for original model
            var ngModelGet = $parse($attrs.lazyModel);
            var ngModelSet = ngModelGet.assign;

            // accept changes
            this.accept = function () {
              ngModelSet($scope.$parent, $scope.buffer);
            };

            // reset changes
            this.reset = function () {
              $scope.buffer = ngModelGet($scope.$parent);
            };

            // watch for original model change (and initialization also)
            $scope.$watch(
              $attrs.lazyModel,
              angular.bind(this, function () {
                this.reset();
              })
            );
          },
        ],
        compile: function compile(elem) {
          // set ng-model to buffer in directive scope (nested)
          elem.attr('ng-model', 'buffer');
          // remove lazy-model attribute to exclude recursion
          elem.removeAttr('lazy-model');
          // store compiled fn
          var compiled = $compile(elem);
          return {
            pre: function (scope) {
              // compile element with ng-model directive poining to `scope.buffer`
              compiled(scope);
            },
            post: function postLink(scope, elem, attr, ctrls) {
              var lazyModelCtrl = ctrls[0];
              var formCtrl = ctrls[1];
              var lazySubmitCtrl = ctrls[2];
              // parentCtrl may be formCtrl or lazySubmitCtrl
              var parentCtrl = lazySubmitCtrl || formCtrl;

              // for the first time attach hooks
              if (parentCtrl.$lazyControls === undefined) {
                parentCtrl.$lazyControls = [];

                // find form element
                var form = elem.parent();
                while (form[0].tagName !== 'FORM') {
                  form = form.parent();
                }

                // bind submit
                form.bind('submit', function () {
                  // this submit handler must be called LAST after all other `submit` handlers
                  // to get final value of formCtrl.$valid. The only way - is to call it in
                  // the next tick via $timeout
                  $timeout(function () {
                    if (formCtrl.$valid) {
                      // form valid - accept new values
                      for (
                        var i = 0;
                        i < parentCtrl.$lazyControls.length;
                        i++
                      ) {
                        parentCtrl.$lazyControls[i].accept();
                      }

                      // call final hook `lazy-submit`
                      if (lazySubmitCtrl) {
                        lazySubmitCtrl.finalSubmit();
                      }
                    }
                  });
                });

                // bind reset
                form.bind('reset', function (e) {
                  e.preventDefault();
                  $timeout(function () {
                    // reset changes
                    for (var i = 0; i < parentCtrl.$lazyControls.length; i++) {
                      parentCtrl.$lazyControls[i].reset();
                    }
                  });
                });
              }

              // add to collection
              parentCtrl.$lazyControls.push(lazyModelCtrl);

              // remove from collection on destroy
              scope.$on('$destroy', function () {
                for (var i = parentCtrl.$lazyControls.length; i--; ) {
                  if (parentCtrl.$lazyControls[i] === lazyModelCtrl) {
                    parentCtrl.$lazyControls.splice(i, 1);
                  }
                }
              });
            },
          };
        },
      };
    },
  ])

  // lazy-submit
  .directive('lazySubmit', function () {
    'use strict';
    return {
      restrict: 'A',
      require: ['lazySubmit', 'form'],
      controller: [
        '$element',
        '$attrs',
        '$scope',
        '$parse',
        function ($element, $attrs, $scope, $parse) {
          var finalHook = $attrs.lazySubmit
            ? $parse($attrs.lazySubmit)
            : angular.noop;
          this.finalSubmit = function () {
            finalHook($scope);
          };
        },
      ],
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:nativeTab
 * @description
 * # nativeTab
 */
webapp.directive('nativeTab', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attributes) {
      var $element = angular.element(element);
      $element.on('click', function (e) {
        e.preventDefault();
        $element.tab('show');
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:navCollapse
 * @description
 * # navCollapse
 * # sidebar navigation dropdown collapse
 */
webapp.directive('navCollapse', function ($timeout) {
  return {
    restrict: 'A',
    link: function ($scope, $el) {
      $timeout(function () {
        var $dropdowns = $el.find('ul').parent('li'),
          $a = $dropdowns.children('a'),
          $notDropdowns = $el.children('li').not($dropdowns),
          $notDropdownsLinks = $notDropdowns.children('a'),
          app = angular.element('.appWrapper'),
          sidebar = angular.element('#sidebar'),
          controls = angular.element('#controls');

        $dropdowns.addClass('dropdown');

        var $submenus = $dropdowns.find('ul >.dropdown');
        $submenus.addClass('submenu');

        //$a.append('<i class="fa fa-plus"></i>');

        $a.on('click', function (event) {
          /*if ($(this).find("span").html() == "내담자관리" || $(this).find("span").html() == "상담관리") {
            //event.preventDefault();
            return false;
          }*/

          if (
            app.hasClass('sidebar-sm') ||
            app.hasClass('sidebar-xs') ||
            app.hasClass('hz-menu')
          ) {
            return false;
          }

          var $this = angular.element(this),
            $parent = $this.parent('li'),
            $openSubmenu = angular.element('.submenu.open');

          if (!$parent.hasClass('submenu')) {
            //$dropdowns.not($parent).removeClass('open').find('ul').slideUp();
          }

          $openSubmenu
            .not($this.parents('.submenu'))
            .removeClass('open')
            .find('ul')
            .slideUp();
          $parent.toggleClass('open').find('>ul').stop().slideToggle();

          event.preventDefault();
        });

        $dropdowns.on('mouseenter', function () {
          if ($dropdowns.css('width') != '250px') {
            $dropdowns.children('ul').hide();
          }
          sidebar.addClass('dropdown-open');
          controls.addClass('dropdown-open');
        });

        $dropdowns.on('mouseleave', function () {
          sidebar.removeClass('dropdown-open');
          controls.removeClass('dropdown-open');
        });

        $notDropdownsLinks.on('click', function () {
          //$dropdowns.removeClass('open').find('ul').slideUp();
        });

        var $activeDropdown = angular.element('.dropdown>ul>.active').parent();

        $activeDropdown.css('display', 'block');
        $('.lmenu_fix').css('display', 'block');
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:offcanvasSidebar
 * @description
 * # offcanvasSidebar
 */
webapp.directive('offcanvasSidebar', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var app = angular.element('.appWrapper'),
        $window = angular.element(window),
        width = $window.width();

      element.on('click', function (e) {
        if (app.hasClass('offcanvas-opened')) {
          app.removeClass('offcanvas-opened');
        } else {
          app.addClass('offcanvas-opened');
        }
        e.preventDefault();
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:onBlurValidation
 * @description
 * # onBlurValidation
 */
webapp.directive('onBlurValidation', function () {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function (scope, elm, attr, ctrl) {
      if (!ctrl) {
        return;
      }

      elm.on('focus', function () {
        elm.addClass('has-focus');

        scope.$apply(function () {
          ctrl.hasFocus = true;
        });
      });

      elm.on('blur', function () {
        elm.removeClass('has-focus');
        elm.addClass('has-visited');

        scope.$apply(function () {
          ctrl.hasFocus = false;
          ctrl.hasVisited = true;
        });
      });

      elm.closest('form').on('submit', function () {
        elm.addClass('has-visited');

        scope.$apply(function () {
          ctrl.hasFocus = false;
          ctrl.hasVisited = true;
        });
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:pageLoader
 * @description
 * # pageLoader
 */
webapp.directive('pageLoader', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'AE',
      template: '<div class="dot1"></div><div class="dot2"></div>',
      link: function (scope, element) {
        element.addClass('hide');
        scope.$on('$stateChangeStart', function () {
          element.toggleClass('hide animate');
        });
        scope.$on('$stateChangeSuccess', function (event) {
          event.targetScope.$watch('$viewContentLoaded', function () {
            $timeout(function () {
              element.toggleClass('hide animate');
            }, 600);
          });
        });
      },
    };
  },
]);

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name minovateApp.directive:activateButton
   * @description
   * # activateButton
   */
  webapp.directive('permission', [ 'Auth', function(Auth) {
    return {
      restrict : 'A',
      scope : {
        permission : '=',
      },

      link : function(scope, elem, attrs) {
        scope.$watch(attrs.ngShow, function() {
          /* console.log('scope.permission=', scope.permission); */
          if (Auth.userHasPermission(scope.permission)) {
            elem.show();
          } else {
            elem.hide();
          }
        });
      }
    };
  }]);
})();
'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:prettyprint
 * @description
 * # prettyprint
 */
/* jshint ignore:start */
webapp.directive('prettyprint', function () {
  return {
    restrict: 'C',
    link: function postLink(scope, element) {
      element.html(prettyPrintOne(element.html(), '', true));
    },
  };
});
/* jshint ignore:end */

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:ripple
 * @description
 * # ripple
 */
webapp.directive('ripple', function () {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var parent, ink, d, x, y;

      angular
        .element(element)
        .find('>li>a')
        .click(function (e) {
          parent = angular.element(this).parent();

          if (parent.find('.ink').length === 0) {
            parent.prepend('<span class="ink"></span>');
          }

          ink = parent.find('.ink');
          //incase of quick double clicks stop the previous animation
          ink.removeClass('animate');

          //set size of .ink
          if (!ink.height() && !ink.width()) {
            //use parent's width or height whichever is larger for the diameter to make a circle which can cover the entire element.
            d = Math.max(parent.outerWidth(), parent.outerHeight());
            ink.css({ height: d, width: d });
          }

          //get click coordinates
          //logic = click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center;
          x = e.pageX - parent.offset().left - ink.width() / 2;
          y = e.pageY - parent.offset().top - ink.height() / 2;

          //set the position and add class .animate
          ink.css({ top: y + 'px', left: x + 'px' }).addClass('animate');

          setTimeout(function () {
            angular.element('.ink').remove();
          }, 600);
        });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:setNgAnimate
 * @description
 * # setNgAnimate
 */
webapp.directive('setNgAnimate', [
  '$animate',
  function ($animate) {
    return {
      link: function ($scope, $element, $attrs) {
        $scope.$watch(
          function () {
            return $scope.$eval($attrs.setNgAnimate, $scope);
          },
          function (valnew) {
            console.log('Directive animation Enabled: ' + valnew);
            $animate.enabled(!!valnew, $element);
          }
        );
      },
    };
  },
]);

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:slimScroll
 * @description
 * # slimScroll
 */
webapp.directive('slimscroll', function () {
  return {
    restrict: 'A',
    link: function ($scope, $elem, $attr) {
      var off = [];
      var option = {};

      var refresh = function () {
        if ($attr.slimscroll) {
          option = $scope.$eval($attr.slimscroll);
        } else if ($attr.slimscrollOption) {
          option = $scope.$eval($attr.slimscrollOption);
        }

        angular.element($elem).slimScroll({ destroy: true });

        angular.element($elem).slimScroll(option);
      };

      var registerWatch = function () {
        if ($attr.slimscroll && !option.noWatch) {
          off.push($scope.$watchCollection($attr.slimscroll, refresh));
        }

        if ($attr.slimscrollWatch) {
          off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
        }

        if ($attr.slimscrolllistento) {
          off.push($scope.$on($attr.slimscrolllistento, refresh));
        }
      };

      var destructor = function () {
        angular.element($elem).slimScroll({ destroy: true });
        off.forEach(function (unbind) {
          unbind();
        });
        off = null;
      };

      off.push($scope.$on('$destroy', destructor));

      registerWatch();
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:sparkline
 * @description
 * # sparkline
 */
webapp.directive('sparkline', [
  function () {
    return {
      restrict: 'A',
      scope: {
        data: '=',
        options: '=',
      },
      link: function ($scope, $el) {
        var data = $scope.data,
          options = $scope.options,
          chartResize,
          chartRedraw = function () {
            return $el.sparkline(data, options);
          };
        angular.element(window).resize(function () {
          clearTimeout(chartResize);
          chartResize = setTimeout(chartRedraw, 200);
        });
        return chartRedraw();
      },
    };
  },
]);

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:submitValidate
 * @description
 * # submitValidate
 */
webapp.directive('submitValidate', function () {
  return {
    require: 'form',
    restrict: 'A',
    link: function (scope, element, attributes) {
      var $element = angular.element(element);
      $element.on('submit', function (e) {
        $element
          .find('.ng-pristine')
          .removeClass('ng-pristine')
          .addClass('ng-dirty');
        var form = scope[attributes.name];
        angular.forEach(
          form,
          function (formElement, fieldName) {
            if (fieldName[0] === '$') {
              return;
            }
            formElement.$pristine = false;
            formElement.$dirty = true;
          },
          this
        );
        form.$setDirty();
        scope.$apply();
      });
    },
  };
});

/**
 * tenantList
 * 
 **/
webapp.directive('tenantList', function(){
    return {
      restrict: 'A',
      scope:{
        ngModel : '=',
        tenant : '='
      },
      template : '<option value="" selected>---- 선택 ----</option><option value="{{li.TenantId}}" ng-repeat="li in vc.lists">{{li.TenantNm}}</option>',
      controller : 'TenantListCtrl as vc',
      link : function(scope, ele, attr, ctrl){
        scope.$watchCollection('ngModel', function(){
            if(ctrl.lists){
                ctrl.lists.forEach(function(item){
                    if(item.TenantId == scope.ngModel){
                        scope.tenant = item.TenantNm;
                    }
                });
            }
        });
      }
    };
});

webapp.controller('TenantListCtrl', ['postApi', 'GLOBAL_CONSTANT', '$scope',
    function TenantListCtrl(postApi, CONSTANT, $scope){
        var vm = this;
        
        var LIST_SQL = 'Tenant.getSrchTenantList';

        var data = {};
        data.mapCode = LIST_SQL;
        postApi.select(data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
                if(result.body.docCnt > 0){
                    vm.lists = result.body.docs;
                }
            }
        });
    }
]);
'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:vectorMap
 * @description
 * # vectorMap
 */
webapp.directive('vectorMap', function () {
  return {
    restrict: 'AE',
    scope: {
      options: '=',
    },
    link: function postLink(scope, element) {
      var options = scope.options;
      element.vectorMap(options);
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:wrapOwlcarousel
 * @description
 * # wrapOwlcarousel
 */
webapp.directive('wrapOwlcarousel', function () {
  return {
    restrict: 'E',
    link: function postLink(scope, element) {
      var options = scope.$eval(angular.element(element).attr('data-options'));

      angular.element(element).owlCarousel(options);
    },
  };
});


function setTmpFileKey(fileKeys) {
	angular.element($(".fileAttachArea")).scope().modalCtrl.fileKeys = fileKeys;
};

webapp.filter('byteCheck', function () {
	return function(text,b,i,c){
		if(angular.isUndefined(text)) return 0;
		for(b=i=0;c=text.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
		return b;
	};
});

/**
 * Usage
 * {{text|byteCheck}} / 2000byte
 * Output
 * "12 / 2000byte"
 *
 */

// add the filter to your application module
webapp.filter('filesize', function ($sce) {
		return function (bytes) {
	        if(bytes < 1024) return bytes + " Bytes";
	        else if(bytes < 1048576) return(bytes / 1024).toFixed(2) + " KB";
	        else if(bytes < 1073741824) return(bytes / 1048576).toFixed(2) + " MB";
	        else return(bytes / 1073741824).toFixed(2) + " GB";
		};
	});
/**
 * Usage
 * var myFile = 5678;
 *
 * {{myText|filesize}}
 *
 * Output
 * "5.54 Kb"
 *
 */


webapp.filter('htmlString', function($sce){
	return function(val){
		if(val) {
			return $sce.trustAsHtml(val);
		}else{
		    return val;
		}
	};
});


(function() {
  "use strict";

  webapp.filter("localToUtc", Filter);

  function Filter($filter) {
    return function(localeDateString, type, timezoneOffset) {
      var localeDate;
      var utcDate;
      var toUtcDate = "";

      if (!localeDateString) {
        return;
      }

      if(type != undefined) {
        if (typeof localeDateString === "string" && localeDateString != "") {
          if(localeDateString.indexOf("T") > -1) {
            localeDateString =  localeDateString.split("T")[0];
          }
        }  
      }

      if (typeof localeDateString === "string" && localeDateString != "") {
        var dateArr = localeDateString.split("-");
        if (dateArr.length == 3) {
          localeDate = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2], 0, 0, 0);
        }
      } else if (typeof localeDateString === "object" && localeDateString instanceof Date) {
        localeDate = localeDateString;
      } else {
        return "";
      }

      if (!timezoneOffset || timezoneOffset == 0) {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000) + 86399000);
        }
      } else {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000) + 86399000);
        }
      }

      toUtcDate = $filter("date")(utcDate, 'yyyy-MM-dd HH:mm:ss');

      return toUtcDate;
    };
  }
})();

/*!
 * nl2br필터는 carriage return 값을 html의 <br/>로 바꿔준다.
 * */
webapp.filter('nl2brString', function($sce){
    return function(val){
        if(angular.isString(val)) {
            return $sce.trustAsHtml(val.replace(/\n/g, '<br/>'));
        }else{
            return val;
        }
    };
});


(function() {
  "use strict";

  webapp.filter("takenTime", ['$filter', function($filter) {
    return function(min) {
      var t = "";
      var translate = $filter('translate');

      if (!min) {
        return;
      }

      if (min < 60) {
        t = min + translate('Menu.MINUTE');
      } else {
        t = parseInt(min / 60) + translate('Menu.HOURS') + ((min % 60) != 0 ? ' ' + (min % 60) + translate('Menu.MINUTE') : '');
      }

      return t;
    };
  }]);
})();

webapp.filter('tel', function ($sce) {
	return function (tel) {

		if(!tel) return tel;

		tel = tel.replace(/[^0-9]/g, '');

    	var tmp = '';
		
		if (tel.length < 4){
			return tel;
    	} else if(tel.length < 7) {
			tmp += tel.substr(0, 3);
			tmp += '-';
			tmp += tel.substr(3);
			return tmp;
    	} else if(tel.length == 8) {
			tmp += tel.substr(0, 4);
			tmp += '-';
			tmp += tel.substr(4);
			return tmp;
    	} else if(tel.length < 10) {
        	if( tel.substr(0, 2) =='02') { //02-123-5678            
            	tmp += tel.substr(0, 2);
            	tmp += '-';
            	tmp += tel.substr(2, 3);
            	tmp += '-';
            	tmp += tel.substr(5);
            	return tmp;
        	} else if (tel.substring(0, 1) == '1') {
				tmp += tel.substr(0, 4);
            	tmp += '-';
            	tmp += tel.substr(4, 4);
            	return tmp;
			}
    	} else if(tel.length < 11) {
        	if(tel.substr(0, 2) =='02') { 	//02-1234-5678            
            	tmp += tel.substr(0, 2);
            	tmp += '-';
				tmp += tel.substr(2, 4);
				tmp += '-';
				tmp += tel.substr(6);
				return tmp;
			} else {                        //010-123-4567            
				tmp += tel.substr(0, 3);
				tmp += '-';
				tmp += tel.substr(3, 3);
				tmp += '-';
				tmp += tel.substr(6);
				return tmp;
			}
		} else if(tel.length < 12) {		//010-1234-5678
			if(tel.substr(0, 4) =='0505') {
				tmp += tel.substr(0, 4);
				tmp += '-';
				tmp += tel.substr(4, 4);
				tmp += '-';
				tmp += tel.substr(8);
				return tmp;
			} else {
				tmp += tel.substr(0, 3);
				tmp += '-';
				tmp += tel.substr(3, 4);
				tmp += '-';
				tmp += tel.substr(7);
				return tmp;
			}
		} else { 
			return tel;
		}
	};
});
/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDate', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {
        var localeDate;
        var toLocalDate = '';
//        $window.localStorage.loginUserLang 변경 필요.
        var format = variables.getDateFormat('ko', false);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }
        return toLocalDate;
    };
}]);

/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDatetime', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {

        var localeDate;
        var toLocalDate = '';
        var format = variables.getDateFormat($window.localStorage.loginUserLang, true);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }

        return toLocalDate;
    };
}]);

webapp.filter('trust', function ($sce) {
	return function (val) {
		return $sce.trustAsHtml(val);
	};
});

(function() {
  "use strict";

  webapp.filter("utcToLocal", Filter);
  function Filter($filter) {
    return function(utcDateString, format) {
      var localeDate;
      var toLocalDate = "";
      if (!utcDateString) {
        return;
      }
      if (typeof utcDateString == "string" && utcDateString != "") {
        localeDate = new Date(parseInt(utcDateString));
      } else if (typeof utcDateString == "number") {
        localeDate = new Date(utcDateString);
      } else {
        return "";
      }

      //localeDate += 'Z';

      if (format != "") {
        toLocalDate = $filter("date")(localeDate, format);
      } else {
        toLocalDate = localeDate.toLocaleDateString();
      }

      return toLocalDate;
    };
  }

  webapp.filter("autoViewUtcToLocal", autoViewListDateTimeFilter);
  function autoViewListDateTimeFilter($filter) {
    return function(utcDateString, format) {
      var localeDate;
      var toLocalDate = "";
      if (!utcDateString) {
        return;
      }
      
      if(utcDateString.dayOfWeek) {
        utcDateString.monthValue = utcDateString.monthValue > 10 ? utcDateString.monthValue : '0'+utcDateString.monthValue;
        utcDateString.dayOfMonth = utcDateString.dayOfMonth > 10 ? utcDateString.dayOfMonth : '0'+utcDateString.dayOfMonth;
        utcDateString.hour = utcDateString.hour > 10 ? utcDateString.hour : '0'+utcDateString.hour;
        utcDateString.minute = utcDateString.minute > 10 ? utcDateString.minute : '0'+utcDateString.minute;
        utcDateString.second = '00';
        var localeDate = utcDateString.year + '-' + (utcDateString.monthValue) + '-' + utcDateString.dayOfMonth + 'T' + utcDateString.hour + ':' + utcDateString.minute + ':' + utcDateString.second;
        var temp = new Date(localeDate).toISOString();
        temp = new Date(new Date(localeDate).toISOString()).getTime();
        localeDate = moment( new Date(temp)).format("YYYY-MM-DD HH:mm:ss");
        toLocalDate = moment.utc(localeDate);
        toLocalDate = moment(toLocalDate).local().toDate();
        
        if(format) {
          toLocalDate = moment(toLocalDate).format(format);
        } else {
          toLocalDate = moment(toLocalDate).format("YYYY-MM-DD HH:mm");
        }
        
      } else {
        localeDate = new Date(utcDateString);
        localeDate = moment.utc(utcDateString).toDate();
        toLocalDate = moment(localeDate).toDate();
        if(format) {
          toLocalDate = moment(toLocalDate).format(format);
        } else {
          toLocalDate = moment(toLocalDate).format('YYYY-MM-DD HH:mm');
        }
      }
      return toLocalDate;
    };
  }
})();



webapp.controller('mtSidenavCtrl', function($scope, $timeout, $mdSidenav, $mdUtil, $log) {

    $scope.page = {
      title: 'Sidenav',
      subtitle: 'Place subtitle here...'
    };

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');
    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn =  $mdUtil.debounce(function(){
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      },200);
      return debounceFn;
    }

  })

  .controller('mtSidenavLeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });
    };
  })
  .controller('mtSidenavRightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });





(function() {
  var module,
    __slice = [].slice;

  module = angular.module("fa.directive.borderLayout", []);

  module.factory("paneManager", function() {
    return {
      panes: {},
      get: function(paneId) {
        return this.panes[paneId];
      },
      set: function(paneId, pane) {
        return this.panes[paneId] = pane;
      },
      remove: function(paneId) {
        return delete this.panes[paneId];
      }
    };
  });

  module.directive("faPane", [
    "$window", "$rootScope", "paneManager", function($window, $rootScope, paneManager) {
      var Region, generateSerialId, getHandleStyle, getOrientation, getScrollerStyle;
      Region = (function() {
        function Region(_at_width, _at_height, _at_top, _at_right, _at_bottom, _at_left) {
          this.width = _at_width != null ? _at_width : 0;
          this.height = _at_height != null ? _at_height : 0;
          this.top = _at_top != null ? _at_top : 0;
          this.right = _at_right != null ? _at_right : 0;
          this.bottom = _at_bottom != null ? _at_bottom : 0;
          this.left = _at_left != null ? _at_left : 0;
        }

        Region.prototype.clone = function() {
          return new Region(this.width, this.height, this.top, this.right, this.bottom, this.left);
        };

        Region.prototype.calculateSize = function(orientation, target) {
          var available, matches, terms, total;
          if (target == null) {
            target = 0;
          }
          total = this.getSize(orientation);
          available = this.getAvailableSize(orientation);
          if (angular.isNumber(target)) {
            if (target >= 1) {
              return Math.round(target);
            }
            if (target >= 0) {
              return Math.round(target * total);
            }
            return 0;
          }
          target = target.replace(/\s+/mg, "");
          if ((terms = target.split("-")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) - this.calculateSize(orientation, terms.join("+"));
          }
          if ((terms = target.split("+")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) + this.calculateSize(orientation, terms.join("+"));
          }
          if (matches = target.match(/^(\d+)px$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+)$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)&$/)) {
            return Math.round(available * parseFloat(matches[1]) / 100);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)%$/)) {
            return Math.round(total * parseFloat(matches[1]) / 100);
          }
          throw new Error("Unsupported size: " + target);
        };

        Region.prototype.consume = function(anchor, size) {
          var style;
          if (size == null) {
            size = 0;
          }

          switch (anchor) {
            case "north":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: "auto",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.top += size;
              break;
            case "east":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: "auto",
                width: size + "px",
                height: "auto"
              };
              this.right += size;
              break;
            case "south":
              style = {
                top: "auto",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.bottom += size;
              break;
            case "west":
              style = {
                top: this.top + "px",
                right: "auto",
                bottom: this.bottom + "px",
                left: this.left + "px",
                width: size + "px",
                height: "auto"
              };
              this.left += size;
          }
          if (size === 0) {
            style.display = "none";
          }
          return style;
        };

        Region.prototype.getInnerRegion = function() {
          return new Region(this.width - this.right - this.left, this.height - this.top - this.bottom);
        };

        Region.prototype.getSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height;
            case "horizontal":
              return this.width;
          }
        };

        Region.prototype.getAvailableSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height - this.top - this.bottom;
            case "horizontal":
              return this.width - this.right - this.left;
          }
        };

        Region.prototype.toString = function() {
          return "{" + this.top + ", " + this.right + ", " + this.bottom + ", " + this.left + "}, {" + this.width + ", " + this.height + "}";
        };

        return Region;

      })();
      getOrientation = function(anchor) {
        switch (anchor) {
          case "north":
          case "south":
            return "vertical";
          case "east":
          case "west":
            return "horizontal";
        }
      };
      getScrollerStyle = function(anchor, size) {
        var style;
        style = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        };
        if (size) {
          switch (anchor) {
            case "north":
              style.bottom = "auto";
              style.height = size + "px";
              break;
            case "east":
              style.left = "auto";
              style.width = size + "px";
              break;
            case "south":
              style.top = "auto";
              style.height = size + "px";
              break;
            case "west":
              style.right = "auto";
              style.width = size + "px";
          }
        }
        return style;
      };
      getHandleStyle = function(anchor, region, handleSize) {
        switch (anchor) {
          case "north":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              bottom: 0
            };
          case "south":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              top: 0
            };
          case "east":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              left: 0
            };
          case "west":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              right: 0
            };
        }
      };
      generateSerialId = (function() {
        var counter, fun;
        counter = 0;
        fun = function() {
          return counter++;
        };
        fun.peek = function() {
          return counter;
        };
        return fun;
      })();
      return {
        restrict: "A",
        replace: true,
        require: "faPane",
        priority: 1,
        transclude: "element",
        scope: {
          anchor: "@paneAnchor",
          paneId: "@faPane",
          size: "@paneSize",
          min: "@paneMin",
          max: "@paneMax",
          handle: "@paneHandle",
          closed: "=paneClosed",
          closable: "@paneNoToggle"
        },
        template: "<div class=\"fa-pane pane-{{$pane.id}}\">\n  <div class=\"fa-pane-overlay\"></div>\n  <div class=\"fa-pane-handle\" fa-pane-resizer>\n    <div ng-if=\"!paneNotoggle\" class=\"fa-pane-toggle\" ng-click=\"$pane.toggle()\"></div>\n  </div>\n</div>",
        controllerAs: "$pane",
        controller: function() {
          var $pane, Pane;
          return $pane = new (Pane = (function() {
            function Pane() {
              this.children = [];
              this.closed = false;
              this.max = Number.MAX_VALUE;
              this.min = 0;
            }

            Pane.prototype.$scheduleReflow = function() {
              if ($pane.parent) {
                return $pane.parent.$scheduleReflow();
              } else if (!$pane.$reflowScheduled) {
                $pane.$reflowScheduled = true;
                return $rootScope.$evalAsync(function() {
                  if ($pane.$reflowScheduled) {
                    $pane.reflow();
                  }
                  return $pane.$reflowScheduled = false;
                });
              }
            };

            Pane.prototype.getOptions = function() {
              return {
                anchor: this.anchor,
                targetSize: this.targetSize,
                size: this.size,
                min: this.min,
                max: this.max,
                handle: {
                  open: this.handleSizeOpen || 0,
                  closed: this.handleSizeClosed || 0
                },
                closed: this.closed
              };
            };

            Pane.prototype.setOptions = function(options) {
              if (options == null) {
                options = {};
              }
              if (options.anchor != null) {
                this.setAnchor(options.anchor);
              }
              if (options.size != null) {
                this.setTargetSize(options.size);
              }
              if (options.min != null) {
                this.setMinSize(options.min);
              }
              if (options.max != null) {
                this.setMaxSize(options.max);
              }
              if (options.handle != null) {
                this.setHandleSize(options.handle);
              }
              if (options.closed != null) {
                return this.toggle(!options.closed);
              }
            };

            Pane.prototype.setAnchor = function(_at_anchor) {
              this.anchor = _at_anchor;
              return this.$scheduleReflow();
            };

            Pane.prototype.setTargetSize = function(_at_targetSize) {
              this.targetSize = _at_targetSize;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMinSize = function(_at_min) {
              this.min = _at_min;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMaxSize = function(_at_max) {
              this.max = _at_max;
              return this.$scheduleReflow();
            };

            Pane.prototype.setHandleSize = function(handleSize) {
              if ((handleSize != null ? handleSize.open : void 0) || (handleSize != null ? handleSize.closed : void 0)) {
                this.handleSizeOpen = handleSize.open || 0;
                this.handleSizeClosed = handleSize.closed || 0;
              } else {
                this.handleSizeOpen = this.handleSizeClosed = parseInt(handleSize, 10);
              }
              return this.$scheduleReflow();
            };

            Pane.prototype.addChild = function(child) {
              child.parent = $pane;
              this.children.push(child);
              if (this.children.length) {
                $pane.$containerEl.addClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.getOrientation = function() {
              return getOrientation($pane.anchor);
            };

            Pane.prototype.onHandleDown = function() {
              return $pane.$containerEl.addClass("active");
            };

            Pane.prototype.onHandleUp = function() {
              $pane.$containerEl.removeClass("active");
              return $pane.$scheduleReflow();
            };

            Pane.prototype.removeChild = function(child) {
              var idx;
              if (!(0 > (idx = this.children.indexOf(child)))) {
                this.children.splice(idx, 1);
              }
              if (!this.children.length) {
                $pane.$containerEl.removeClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.reflow = function(region) {
              var handleSize, height, orientation, size, styleContainer, styleHandle, styleScroller, width, _ref;
              width = $pane.$containerEl[0].offsetWidth;
              height = $pane.$containerEl[0].offsetHeight;
              region || (region = new Region(width, height));
              if ((_ref = $pane.anchor) === "north" || _ref === "east" || _ref === "south" || _ref === "west") {
                $pane.$containerEl.removeClass("fa-pane-orientation-vertical");
                $pane.$containerEl.removeClass("fa-pane-orientation-horizontal");
                orientation = getOrientation($pane.anchor);
                $pane.$containerEl.addClass("fa-pane-orientation-" + orientation);
                handleSize = region.calculateSize(orientation, !$pane.closed && $pane.handleSizeOpen || $pane.handleSizeClosed);
                if ($pane.closed) {
                  size = handleSize;
                } else {
                  size = region.calculateSize(orientation, !$pane.closed && $pane.targetSize || handleSize);
                  size = Math.min(size, region.calculateSize(orientation, $pane.max));
                  size = Math.max(size, region.calculateSize(orientation, $pane.min));
                  size = Math.min(size, region.getAvailableSize(orientation));
                  size = Math.max(size, handleSize);
                }
                this.size = size;
                styleContainer = region.consume($pane.anchor, size);
                styleScroller = getScrollerStyle($pane.anchor, size - handleSize);
                styleHandle = getHandleStyle($pane.anchor, region, handleSize);
                $pane.$containerEl.attr("style", "").css(styleContainer);
                $pane.$overlayEl.attr("style", "").css(styleScroller);
                $pane.$handleEl.attr("style", "").css(styleHandle);
                $pane.$scrollerEl.attr("style", "").css(styleScroller);
                if ($rootScope.gVariable && $rootScope.gVariable.layoutBoardSize) {
                  $rootScope.gVariable.layoutBoardSize = size + "px";
                }
              } else {

                // SZ Custom HJH GJ
                // 방향에 따라 사이즈 조절
                var offset = $pane.$containerEl.offset();
                var tempHeight = ($(window).height() - offset.top) + "px";
                var $parentObj = $pane.$containerEl.closest("[pane-wrap-anchor]")
                var anchor = $parentObj.attr("pane-wrap-anchor");
                var sheight = "auto";
                var swidth = "auto";
                if(!$pane.$containerEl.hasClass("pane-root")) sheight = "auto";
                else {
                  if(anchor != "west" && anchor != "north") {
                    swidth = "100%";
                    sheight = tempHeight;
                    $parentObj.find("[fa-pane]").css("height","auto");
                    $parentObj.find("[fa-pane]").css("width","auto");
                  } else {
                    sheight = tempHeight;
                  }
                }

                $pane.$containerEl.css({
                  top: region.top + "px",
                  right: region.right + "px",
                  bottom: region.bottom + "px",
                  left: region.left + "px",
                  width: swidth,
                  height: sheight
                });
              }

              $pane.$region = region.clone();


              // HJH HJ 19.07.02
              // anchor == west 일경우
              // 자식 엘리먼트의 사이즈 조절을 하기 위해 fapane-size Attribute 속성을 추가
              // 나머지는 CSS에서 작업
              if($pane.anchor == "west") {
                var $rootPane = $pane.parent;
                var $first = $rootPane.children[0];
                var $second = $rootPane.children[1];
                var fw = $rootPane.children[0].size, sw = $rootPane.$region.width - fw;
                if (fw > 992) $first.$containerEl.attr('fapane-size', "lg");
                else if (fw > 768) $first.$containerEl.attr('fapane-size', "md");
                else if (fw > 650) $first.$containerEl.attr('fapane-size', "sm");
                else $first.$containerEl.attr('fapane-size', "xs");
                if (sw > 992) $second.$containerEl.attr('fapane-size', "lg");
                else if (sw > 768) $second.$containerEl.attr('fapane-size', "md");
                else if (sw > 650) $second.$containerEl.attr('fapane-size', "sm");
                else $second.$containerEl.attr('fapane-size', "xs");
              } else {
                if($pane.anchor != undefined) $('[fapane-size]').removeAttr('fapane-size');
              }

              return $pane.reflowChildren(region.getInnerRegion());
            };

            Pane.prototype.reflowChildren = function(region) {
              var child, _i, _len, _ref, _results;
              region || (region = $pane.$region);
              $pane.children.sort(function(a, b) {
                return a.order - b.order;
              });
              _ref = $pane.children;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                child = _ref[_i];
                _results.push(child.reflow(region));
              }
              return _results;
            };

            Pane.prototype.resize = function(size) {
              if (size == null) {
                size = $pane.targetSize;
              }
              $pane.targetSize = size;
              $pane.parent.reflowChildren($pane.parent.$region.getInnerRegion());
              if (size !== $pane.size) {
                return $pane.$containerEl.addClass("fa-pane-constrained");
              } else {
                return $pane.$containerEl.removeClass("fa-pane-constrained");
              }
            };

            Pane.prototype.toggle = function(open) {
              var reflow;
              if (open == null) {
                open = !!$pane.closed;
              }
              $pane.closed = !open;
              reflow = function() {
                if ($pane.parent) {
                  return $pane.parent.$scheduleReflow();
                } else {
                  return $pane.$scheduleReflow();
                }
              };
              if ($pane.closed) {
                $pane.$containerEl.addClass("fa-pane-closed");
              } else {
                $pane.$containerEl.removeClass("fa-pane-closed");
              }
              return reflow();
            };

            return Pane;

          })());
        },
        compile: function($el, $attrs, $transclude) {
          var link, serialId;
          serialId = generateSerialId();
          return link = function($scope, $el, $attrs, $pane) {
            var $directiveScope, $transcludeScope;
            $directiveScope = $scope.$parent.$new();
            $directiveScope.$pane = $scope.$pane = $pane;
            $transcludeScope = $directiveScope.$new();
            if ($pane.order == null) {
              $pane.order = serialId;
            }
            $pane.$isolateScope = $scope;
            $pane.$directiveScope = $directiveScope;
            $pane.$transcludeScope = $transcludeScope;
            return $transclude($transcludeScope, function(clone) {
              clone.addClass("fa-pane-scroller");
              $el.append(clone);
              $pane.$containerEl = $el;
              $pane.$overlayEl = $el.children().eq(0);
              $pane.$handleEl = $el.children().eq(1);
              $pane.$scrollerEl = $el.children().eq(2);
              $scope.$watch("anchor", function(anchor) {
                return $pane.setAnchor(anchor);
              });
              $scope.$watch("size", function(targetSize) {
                return $pane.setTargetSize(targetSize);
              });
              $scope.$watch("closed", function(closed) {
                return $pane.toggle(!closed);
              });
              $scope.$watch("min", function(min) {
                return $pane.setMinSize(min != null ? min : 0);
              });
              $scope.$watch("max", function(max) {
                return $pane.setMaxSize(max != null ? max : Number.MAX_VALUE);
              });
              $scope.$watch("paneId", function(paneId, prevPaneId) {
                if (prevPaneId) {
                  paneManager.remove(prevPaneId);
                }
                paneManager.set(paneId, $pane);
                return $pane.id = paneId;
              });
              $scope.$watch("handle", function(handle) {
                return $pane.setHandleSize(handle);
              });
              $pane.$directiveScope.$on("fa-pane-attach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.addChild(child);
                }
              });
              $pane.$directiveScope.$on("fa-pane-detach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.removeChild(child);
                }
              });
              $window.addEventListener("resize", function(e) {
                e.stopPropagation();
                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$on("$stateChangeSuccess", function() {

                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$emit("fa-pane-attach", $pane);
              return $pane.$directiveScope.$on("$destroy", function() {
                return $pane.$directiveScope.$emit("fa-pane-detach", $pane);
              });
            });
          };
        }
      };
    }
  ]);

  module.directive("faPaneToggle", [
    "paneManager", function(paneManager) {
      return {
        link: function($scope, $el, $attrs) {
          return $attrs.$observe("faPaneToggle", function(paneId) {});
        }
      };
    }
  ]);

  module.directive("faPaneResizer", [
    "$window", function($window) {
      var throttle;
      throttle = function(delay, fn) {
        var throttled;
        throttled = false;
        return function() {
          if (throttled) {
            return;
          }
          throttled = true;
          setTimeout(function() {
            return throttled = false;
          }, delay);
          return fn.call.apply(fn, [this].concat(__slice.call(arguments)));
        };
      };
      return {
        restrict: "A",
        link: function($scope, $element, $attrs, $pane) {
          var clickRadius, clickTime, el;
          $pane || ($pane = $scope.$pane);
          el = $element[0];
          clickRadius = 5;
          clickTime = 300;
          $scope.$watch((function() {
            return $pane.getOrientation();
          }), function(orientation) {
            $element.removeClass("vertical");
            $element.removeClass("horizontal");
            switch (orientation) {
              case "vertical":
                return $element.addClass("vertical");
              case "horizontal":
                return $element.addClass("horizontal");
            }
          });
          return el.addEventListener("mousedown", function(e) {
            var anchor, coord, handleMouseMove, handleMouseMoveThrottled, handleMouseUp, scale, startCoord, startPos, startSize, startTime;
            if (e.button !== 0) {
              return;
            }
            anchor = $pane.anchor;
            if (anchor === "north" || anchor === "south") {
              coord = "screenY";
            } else if (anchor === "west" || anchor === "east") {
              coord = "screenX";
            }
            if (anchor === "north" || anchor === "west") {
              scale = 1;
            } else if (anchor === "south" || anchor === "east") {
              scale = -1;
            }
            startPos = {
              x: e.screenX,
              y: e.screenY
            };
            startCoord = e[coord];
            startSize = $pane.size;
            startTime = Date.now();
            el.unselectable = "on";
            el.onselectstart = function() {
              return false;
            };
            el.style.userSelect = el.style.MozUserSelect = "none";
            e.preventDefault();
            e.defaultPrevented = true;
            e = null;
            handleMouseMove = function(e) {
              $pane.$containerEl.addClass("fa-pane-resizing");

              $scope.$apply(function() {
                var targetSize;
                // by rohbi on 2019.06.17
                targetSize = startSize + scale * (e[coord] - startCoord);
                //targetSize = startSize + scale * (startCoord - e[coord]);
                return $pane.resize(targetSize);
              });
              e.preventDefault();
              e.defaultPrevented = true;
              return e = null;
            };
            handleMouseUp = function(e) {
              var cleanup, displacementSq, timeElapsed;
              displacementSq = Math.pow(e.screenX - startPos.x, 2) + Math.pow(e.screenY - startPos.y, 2);
              timeElapsed = Date.now() - startTime;
              $window.removeEventListener("mousemove", handleMouseMoveThrottled, true);
              $window.removeEventListener("mouseup", handleMouseUp, true);
              cleanup = function() {
                $pane.$containerEl.removeClass("fa-pane-resizing");
                e.preventDefault();
                e.defaultPrevented = true;
                return e = null;
              };
              if (displacementSq <= Math.pow(clickRadius, 2) && timeElapsed <= clickTime) {
                cleanup();
                return;
              }
              handleMouseMove(e);
              return cleanup();
            };
            handleMouseMoveThrottled = throttle(10, handleMouseMove);
            $window.addEventListener("mouseup", handleMouseUp, true);
            return $window.addEventListener("mousemove", handleMouseMoveThrottled, true);
          });
        }
      };
    }
  ]);

}).call(this);


angular.module('ngDock', []).factory('dock', function () {
  var valids = ['left', 'right', 'top', 'bottom', 'fill'];
  return {
    dockRefs: {},
    valids: valids,
    handlesByDock: {
      "top": "s",
      "left": "e",
      "right": "w",
      "bottom": "n"
    },
    Area: (function () {
      function setPosition(r, s, pos) {
        r.position = 'absolute';
        if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
        if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
        if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
        if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
      }
      function decreaseSize($element, pos, s) {
        if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
        if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
        if (pos == "bottom") s.bottom += size;
        if (pos == "left") s.left += size;
        if (pos == "right") s.right += size;
        if (pos == "top") s.top += size;
      }
      function removeClasses($element) {
        var x = valids.length;
        while (x--)
          $element.removeClass("dock-" + valids[x]);
      }
      function update($element, pos, s) {
        var r = {};
        removeClasses($element);
        setPosition(r, s, pos);
        $element.addClass("dock-" + pos);
        $element.css(r);
        decreaseSize($element, pos, s);
      }
      var Area = function ($div, $scope) {
        var s = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
        var childList = [];
        this.addChild = function ($element, $pos) {
          var pos = $scope.$eval($pos);

          if (valids.indexOf(pos) == -1)
            throw {
              message: " : dock position must be one of this: " + valids.join(', ')
            };
          childList.push({
            element: $element,
            pos: $pos,
            order: childList.length
          });

          if($(".ui-resizable-handle").length > 0) {
            if($(".ui-resizable-handle > div").length == 0)
              $(".ui-resizable-handle").append("<div></div>");
          }
          update($element, pos, s);
        };
        this.refresh = function () {
          s.top = 0;
          s.bottom = 0;
          s.left = 0;
          s.right = 0;
          for (var x = 0; x < childList.length; x++) {
            var pos = $scope.$eval(childList[x].pos);
            update(childList[x].element, pos, s);
          }
        };


        var _this = this;
        $(window).resize(function () {
          $(".ui-resizable-handle").addClass("ui-resizable-bar-area");
          _this.refresh();
          clearTimeout($.data(this, 'resizeTimer'));
          $.data(this, 'resizeTimer', setTimeout(function() {
              $(".ui-resizable-handle").removeClass("ui-resizable-bar-area");
          }, 250));
        });
        $scope.$watch(function () {
          _this.refresh();
        });
      };
      return Area;
    })()
  };
})
.directive('dockRef', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
      dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
    },
    scope: true
  };
})
.directive('dock', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      var dp = $element.attr('dock');
      $scope.__dock_id = String(Math.random()).replace(/\./g, "");
      var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
      area.addChild($element, dp);
    },
    scope: true
  };
})
.directive("dockResizable", function (dock) {
  function enableResize($element, dp) {
    $element.resizable({
      handles: dock.handlesByDock[dp]
    });
  }
  return {
    require: 'dock',
    restrict: "A",
    controller: function ($scope, $element) {

      var dp = $scope.$eval($element.attr('dock'));
      if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
      $scope.$watch(function () {
        var newdp = $scope.$eval($element.attr('dock'));
        if (newdp != dp) {
          if (dock.valids.indexOf(newdp) == -1)
            throw {
              message: "> dock position must be one of this: " + valids.join(', ')
            };
          dp = newdp;
          $element.resizable('destroy');
          if (newdp != 'fill') enableResize($element, dp);
        }
      });
    }
  };
});


/*
== malihu jquery custom scrollbar plugin ==
Version: 3.1.5
Plugin URI: http://manos.malihu.gr/jquery-custom-content-scroller
Author: malihu
Author URI: http://manos.malihu.gr
License: MIT License (MIT)
*/

/*
Copyright Manos Malihutsakis (email: manos@malihu.gr)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

/*
The code below is fairly long, fully commented and should be normally used in development.
For production, use either the minified jquery.mCustomScrollbar.min.js script or
the production-ready jquery.mCustomScrollbar.concat.min.js which contains the plugin
and dependencies (minified).
*/

(function(factory){
	if(typeof define==="function" && define.amd){
		define(["jquery"],factory);
	}else if(typeof module!=="undefined" && module.exports){
		module.exports=factory;
	}else{
		factory(jQuery,window,document);
	}
}(function($){
(function(init){
	var _rjs=typeof define==="function" && define.amd, /* RequireJS */
		_njs=typeof module !== "undefined" && module.exports, /* NodeJS */
		_dlp=("https:"==document.location.protocol) ? "https:" : "http:", /* location protocol */
		_url="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";
	if(!_rjs){
		if(_njs){
			require("jquery-mousewheel")($);
		}else{
			/* load jquery-mousewheel plugin (via CDN) if it's not present or not loaded via RequireJS
			(works when mCustomScrollbar fn is called on window load) */
			$.event.special.mousewheel || $("head").append(decodeURI("%3Cscript src="+_dlp+"//"+_url+"%3E%3C/script%3E"));
		}
	}
	init();
}(function(){

	/*
	----------------------------------------
	PLUGIN NAMESPACE, PREFIX, DEFAULT SELECTOR(S)
	----------------------------------------
	*/

	var pluginNS="mCustomScrollbar",
		pluginPfx="mCS",
		defaultSelector=".mCustomScrollbar",





	/*
	----------------------------------------
	DEFAULT OPTIONS
	----------------------------------------
	*/

		defaults={
			/*
			set element/content width/height programmatically
			values: boolean, pixels, percentage
				option						default
				-------------------------------------
				setWidth					false
				setHeight					false
			*/
			/*
			set the initial css top property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setTop:0,
			/*
			set the initial css left property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setLeft:0,
			/*
			scrollbar axis (vertical and/or horizontal scrollbars)
			values (string): "y", "x", "yx"
			*/
			axis:"y",
			/*
			position of scrollbar relative to content
			values (string): "inside", "outside" ("outside" requires elements with position:relative)
			*/
			scrollbarPosition:"inside",
			/*
			scrolling inertia
			values: integer (milliseconds)
			*/
			scrollInertia:950,
			/*
			auto-adjust scrollbar dragger length
			values: boolean
			*/
			autoDraggerLength:true,
			/*
			auto-hide scrollbar when idle
			values: boolean
				option						default
				-------------------------------------
				autoHideScrollbar			false
			*/
			/*
			auto-expands scrollbar on mouse-over and dragging
			values: boolean
				option						default
				-------------------------------------
				autoExpandScrollbar			false
			*/
			/*
			always show scrollbar, even when there's nothing to scroll
			values: integer (0=disable, 1=always show dragger rail and buttons, 2=always show dragger rail, dragger and buttons), boolean
			*/
			alwaysShowScrollbar:0,
			/*
			scrolling always snaps to a multiple of this number in pixels
			values: integer, array ([y,x])
				option						default
				-------------------------------------
				snapAmount					null
			*/
			/*
			when snapping, snap with this number in pixels as an offset
			values: integer
			*/
			snapOffset:0,
			/*
			mouse-wheel scrolling
			*/
			mouseWheel:{
				/*
				enable mouse-wheel scrolling
				values: boolean
				*/
				enable:true,
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto",
				/*
				mouse-wheel scrolling axis
				the default scrolling direction when both vertical and horizontal scrollbars are present
				values (string): "y", "x"
				*/
				axis:"y",
				/*
				prevent the default behaviour which automatically scrolls the parent element(s) when end of scrolling is reached
				values: boolean
					option						default
					-------------------------------------
					preventDefault				null
				*/
				/*
				the reported mouse-wheel delta value. The number of lines (translated to pixels) one wheel notch scrolls.
				values: "auto", integer
				"auto" uses the default OS/browser value
				*/
				deltaFactor:"auto",
				/*
				normalize mouse-wheel delta to -1 or 1 (disables mouse-wheel acceleration)
				values: boolean
					option						default
					-------------------------------------
					normalizeDelta				null
				*/
				/*
				invert mouse-wheel scrolling direction
				values: boolean
					option						default
					-------------------------------------
					invert						null
				*/
				/*
				the tags that disable mouse-wheel when cursor is over them
				*/
				disableOver:["select","option","keygen","datalist","textarea"]
			},
			/*
			scrollbar buttons
			*/
			scrollButtons:{
				/*
				enable scrollbar buttons
				values: boolean
					option						default
					-------------------------------------
					enable						null
				*/
				/*
				scrollbar buttons scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
				/*
				tabindex of the scrollbar buttons
				values: false, integer
					option						default
					-------------------------------------
					tabindex					null
				*/
			},
			/*
			keyboard scrolling
			*/
			keyboard:{
				/*
				enable scrolling via keyboard
				values: boolean
				*/
				enable:true,
				/*
				keyboard scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
			},
			/*
			enable content touch-swipe scrolling
			values: boolean, integer, string (number)
			integer values define the axis-specific minimum amount required for scrolling momentum
			*/
			contentTouchScroll:25,
			/*
			enable/disable document (default) touch-swipe scrolling
			*/
			documentTouchScroll:true,
			/*
			advanced option parameters
			*/
			advanced:{
				/*
				auto-expand content horizontally (for "x" or "yx" axis)
				values: boolean, integer (the value 2 forces the non scrollHeight/scrollWidth method, the value 3 forces the scrollHeight/scrollWidth method)
					option						default
					-------------------------------------
					autoExpandHorizontalScroll	null
				*/
				/*
				auto-scroll to elements with focus
				*/
				autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
				/*
				auto-update scrollbars on content, element or viewport resize
				should be true for fluid layouts/elements, adding/removing content dynamically, hiding/showing elements, content with images etc.
				values: boolean
				*/
				updateOnContentResize:true,
				/*
				auto-update scrollbars each time each image inside the element is fully loaded
				values: "auto", boolean
				*/
				updateOnImageLoad:"auto",
				/*
				auto-update scrollbars based on the amount and size changes of specific selectors
				useful when you need to update the scrollbar(s) automatically, each time a type of element is added, removed or changes its size
				values: boolean, string (e.g. "ul li" will auto-update scrollbars each time list-items inside the element are changed)
				a value of true (boolean) will auto-update scrollbars each time any element is changed
					option						default
					-------------------------------------
					updateOnSelectorChange		null
				*/
				/*
				extra selectors that'll allow scrollbar dragging upon mousemove/up, pointermove/up, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					extraDraggableSelectors		null
				*/
				/*
				extra selectors that'll release scrollbar dragging upon mouseup, pointerup, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					releaseDraggableSelectors	null
				*/
				/*
				auto-update timeout
				values: integer (milliseconds)
				*/
				autoUpdateTimeout:60
			},
			/*
			scrollbar theme
			values: string (see CSS/plugin URI for a list of ready-to-use themes)
			*/
			theme:"light",
			/*
			user defined callback functions
			*/
			callbacks:{
				/*
				Available callbacks:
					callback					default
					-------------------------------------
					onCreate					null
					onInit						null
					onScrollStart				null
					onScroll					null
					onTotalScroll				null
					onTotalScrollBack			null
					whileScrolling				null
					onOverflowY					null
					onOverflowX					null
					onOverflowYNone				null
					onOverflowXNone				null
					onImageLoad					null
					onSelectorChange			null
					onBeforeUpdate				null
					onUpdate					null
				*/
				onTotalScrollOffset:0,
				onTotalScrollBackOffset:0,
				alwaysTriggerOffsets:true
			}
			/*
			add scrollbar(s) on all elements matching the current selector, now and in the future
			values: boolean, string
			string values: "on" (enable), "once" (disable after first invocation), "off" (disable)
			liveSelector values: string (selector)
				option						default
				-------------------------------------
				live						false
				liveSelector				null
			*/
		},





	/*
	----------------------------------------
	VARS, CONSTANTS
	----------------------------------------
	*/

		totalInstances=0, /* plugin instances amount */
		liveTimers={}, /* live option timers */
		oldIE=(window.attachEvent && !window.addEventListener) ? 1 : 0, /* detect IE < 9 */
		touchActive=false,touchable, /* global touch vars (for touch and pointer events) */
		/* general plugin classes */
		classes=[
			"mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar",
			"mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer",
			"mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"
		],





	/*
	----------------------------------------
	METHODS
	----------------------------------------
	*/

		methods={

			/*
			plugin initialization method
			creates the scrollbar(s), plugin data object and options
			----------------------------------------
			*/

			init:function(options){

				var options=$.extend(true,{},defaults,options),
					selector=_selector.call(this); /* validate selector */

				/*
				if live option is enabled, monitor for elements matching the current selector and
				apply scrollbar(s) when found (now and in the future)
				*/
				if(options.live){
					var liveSelector=options.liveSelector || this.selector || defaultSelector, /* live selector(s) */
						$liveSelector=$(liveSelector); /* live selector(s) as jquery object */
					if(options.live==="off"){
						/*
						disable live if requested
						usage: $(selector).mCustomScrollbar({live:"off"});
						*/
						removeLiveTimers(liveSelector);
						return;
					}
					liveTimers[liveSelector]=setTimeout(function(){
						/* call mCustomScrollbar fn on live selector(s) every half-second */
						$liveSelector.mCustomScrollbar(options);
						if(options.live==="once" && $liveSelector.length){
							/* disable live after first invocation */
							removeLiveTimers(liveSelector);
						}
					},500);
				}else{
					removeLiveTimers(liveSelector);
				}

				/* options backward compatibility (for versions < 3.0.0) and normalization */
				options.setWidth=(options.set_width) ? options.set_width : options.setWidth;
				options.setHeight=(options.set_height) ? options.set_height : options.setHeight;
				options.axis=(options.horizontalScroll) ? "x" : _findAxis(options.axis);
				options.scrollInertia=options.scrollInertia>0 && options.scrollInertia<17 ? 17 : options.scrollInertia;
				if(typeof options.mouseWheel!=="object" &&  options.mouseWheel==true){ /* old school mouseWheel option (non-object) */
					options.mouseWheel={enable:true,scrollAmount:"auto",axis:"y",preventDefault:false,deltaFactor:"auto",normalizeDelta:false,invert:false}
				}
				options.mouseWheel.scrollAmount=!options.mouseWheelPixels ? options.mouseWheel.scrollAmount : options.mouseWheelPixels;
				options.mouseWheel.normalizeDelta=!options.advanced.normalizeMouseWheelDelta ? options.mouseWheel.normalizeDelta : options.advanced.normalizeMouseWheelDelta;
				options.scrollButtons.scrollType=_findScrollButtonsType(options.scrollButtons.scrollType);

				_theme(options); /* theme-specific options */

				/* plugin constructor */
				return $(selector).each(function(){

					var $this=$(this);

					if(!$this.data(pluginPfx)){ /* prevent multiple instantiations */

						/* store options and create objects in jquery data */
						$this.data(pluginPfx,{
							idx:++totalInstances, /* instance index */
							opt:options, /* options */
							scrollRatio:{y:null,x:null}, /* scrollbar to content ratio */
							overflowed:null, /* overflowed axis */
							contentReset:{y:null,x:null}, /* object to check when content resets */
							bindEvents:false, /* object to check if events are bound */
							tweenRunning:false, /* object to check if tween is running */
							sequential:{}, /* sequential scrolling object */
							langDir:$this.css("direction"), /* detect/store direction (ltr or rtl) */
							cbOffsets:null, /* object to check whether callback offsets always trigger */
							/*
							object to check how scrolling events where last triggered
							"internal" (default - triggered by this script), "external" (triggered by other scripts, e.g. via scrollTo method)
							usage: object.data("mCS").trigger
							*/
							trigger:null,
							/*
							object to check for changes in elements in order to call the update method automatically
							*/
							poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}
						});

						var d=$this.data(pluginPfx),o=d.opt,
							/* HTML data attributes */
							htmlDataAxis=$this.data("mcs-axis"),htmlDataSbPos=$this.data("mcs-scrollbar-position"),htmlDataTheme=$this.data("mcs-theme");

						if(htmlDataAxis){o.axis=htmlDataAxis;} /* usage example: data-mcs-axis="y" */
						if(htmlDataSbPos){o.scrollbarPosition=htmlDataSbPos;} /* usage example: data-mcs-scrollbar-position="outside" */
						if(htmlDataTheme){ /* usage example: data-mcs-theme="minimal" */
							o.theme=htmlDataTheme;
							_theme(o); /* theme-specific options */
						}

						_pluginMarkup.call(this); /* add plugin markup */

						if(d && o.callbacks.onCreate && typeof o.callbacks.onCreate==="function"){o.callbacks.onCreate.call(this);} /* callbacks: onCreate */

						$("#mCSB_"+d.idx+"_container img:not(."+classes[2]+")").addClass(classes[2]); /* flag loaded images */

						methods.update.call(null,$this); /* call the update method */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin update method
			updates content and scrollbar(s) values, events and status
			----------------------------------------
			usage: $(selector).mCustomScrollbar("update");
			*/

			update:function(el,cb){

				var selector=el || _selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];

						if(!mCSB_container.length){return;}

						if(d.tweenRunning){_stop($this);} /* stop any running tweens while updating */

						if(cb && d && o.callbacks.onBeforeUpdate && typeof o.callbacks.onBeforeUpdate==="function"){o.callbacks.onBeforeUpdate.call(this);} /* callbacks: onBeforeUpdate */

						/* if element was disabled or destroyed, remove class(es) */
						if($this.hasClass(classes[3])){$this.removeClass(classes[3]);}
						if($this.hasClass(classes[4])){$this.removeClass(classes[4]);}

						/* css flexbox fix, detect/set max-height */
						mCustomScrollBox.css("max-height","none");
						if(mCustomScrollBox.height()!==$this.height()){mCustomScrollBox.css("max-height",$this.height());}

						_expandContentHorizontally.call(this); /* expand content horizontally */

						if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
							mCSB_container.css("width",_contentWidth(mCSB_container));
						}

						d.overflowed=_overflowed.call(this); /* determine if scrolling is required */

						_scrollbarVisibility.call(this); /* show/hide scrollbar(s) */

						/* auto-adjust scrollbar dragger length analogous to content */
						if(o.autoDraggerLength){_setDraggerLength.call(this);}

						_scrollRatio.call(this); /* calculate and store scrollbar to content ratio */

						_bindEvents.call(this); /* bind scrollbar events */

						/* reset scrolling position and/or events */
						var to=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)];
						if(o.axis!=="x"){ /* y/yx axis */
							if(!d.overflowed[0]){ /* y scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="y"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[1]){
									_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[0].height()>mCSB_dragger[0].parent().height()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* y scrolling is required */
								_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								d.contentReset.y=null;
							}
						}
						if(o.axis!=="y"){ /* x/yx axis */
							if(!d.overflowed[1]){ /* x scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="x"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[0]){
									_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[1].width()>mCSB_dragger[1].parent().width()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* x scrolling is required */
								_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								d.contentReset.x=null;
							}
						}

						/* callbacks: onImageLoad, onSelectorChange, onUpdate */
						if(cb && d){
							if(cb===2 && o.callbacks.onImageLoad && typeof o.callbacks.onImageLoad==="function"){
								o.callbacks.onImageLoad.call(this);
							}else if(cb===3 && o.callbacks.onSelectorChange && typeof o.callbacks.onSelectorChange==="function"){
								o.callbacks.onSelectorChange.call(this);
							}else if(o.callbacks.onUpdate && typeof o.callbacks.onUpdate==="function"){
								o.callbacks.onUpdate.call(this);
							}
						}

						_autoUpdate.call(this); /* initialize automatic updating (for dynamic content, fluid layouts etc.) */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin scrollTo method
			triggers a scrolling event to a specific value
			----------------------------------------
			usage: $(selector).mCustomScrollbar("scrollTo",value,options);
			*/

			scrollTo:function(val,options){

				/* prevent silly things like $(selector).mCustomScrollbar("scrollTo",undefined); */
				if(typeof val=="undefined" || val==null){return;}

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							/* method default options */
							methodDefaults={
								trigger:"external", /* method is by default triggered externally (e.g. from other scripts) */
								scrollInertia:o.scrollInertia, /* scrolling inertia (animation duration) */
								scrollEasing:"mcsEaseInOut", /* animation easing */
								moveDragger:false, /* move dragger instead of content */
								timeout:60, /* scroll-to delay */
								callbacks:true, /* enable/disable callbacks */
								onStart:true,
								onUpdate:true,
								onComplete:true
							},
							methodOptions=$.extend(true,{},methodDefaults,options),
							to=_arr.call(this,val),dur=methodOptions.scrollInertia>0 && methodOptions.scrollInertia<17 ? 17 : methodOptions.scrollInertia;

						/* translate yx values to actual scroll-to positions */
						to[0]=_to.call(this,to[0],"y");
						to[1]=_to.call(this,to[1],"x");

						/*
						check if scroll-to value moves the dragger instead of content.
						Only pixel values apply on dragger (e.g. 100, "100px", "-=100" etc.)
						*/
						if(methodOptions.moveDragger){
							to[0]*=d.scrollRatio.y;
							to[1]*=d.scrollRatio.x;
						}

						methodOptions.dur=_isTabHidden() ? 0 : dur; //skip animations if browser tab is hidden

						setTimeout(function(){
							/* do the scrolling */
							if(to[0]!==null && typeof to[0]!=="undefined" && o.axis!=="x" && d.overflowed[0]){ /* scroll y */
								methodOptions.dir="y";
								methodOptions.overwrite="all";
								_scrollTo($this,to[0].toString(),methodOptions);
							}
							if(to[1]!==null && typeof to[1]!=="undefined" && o.axis!=="y" && d.overflowed[1]){ /* scroll x */
								methodOptions.dir="x";
								methodOptions.overwrite="none";
								_scrollTo($this,to[1].toString(),methodOptions);
							}
						},methodOptions.timeout);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin stop method
			stops scrolling animation
			----------------------------------------
			usage: $(selector).mCustomScrollbar("stop");
			*/
			stop:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						_stop($this);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin disable method
			temporarily disables the scrollbar(s)
			----------------------------------------
			usage: $(selector).mCustomScrollbar("disable",reset);
			reset (boolean): resets content position to 0
			*/
			disable:function(r){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx);

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						if(r){_resetContentPosition.call(this);} /* reset content position */

						_scrollbarVisibility.call(this,true); /* show/hide scrollbar(s) */

						$this.addClass(classes[3]); /* add disable class */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin destroy method
			completely removes the scrollbar(s) and returns the element to its original state
			----------------------------------------
			usage: $(selector).mCustomScrollbar("destroy");
			*/
			destroy:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							scrollbar=$(".mCSB_"+d.idx+"_scrollbar");

						if(o.live){removeLiveTimers(o.liveSelector || $(selector).selector);} /* remove live timers */

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						_resetContentPosition.call(this); /* reset content position */

						$this.removeData(pluginPfx); /* remove plugin data object */

						_delete(this,"mcs"); /* delete callbacks object */

						/* remove plugin markup */
						scrollbar.remove(); /* remove scrollbar(s) first (those can be either inside or outside plugin's inner wrapper) */
						mCSB_container.find("img."+classes[2]).removeClass(classes[2]); /* remove loaded images flag */
						mCustomScrollBox.replaceWith(mCSB_container.contents()); /* replace plugin's inner wrapper with the original content */
						/* remove plugin classes from the element and add destroy class */
						$this.removeClass(pluginNS+" _"+pluginPfx+"_"+d.idx+" "+classes[6]+" "+classes[7]+" "+classes[5]+" "+classes[3]).addClass(classes[4]);

					}

				});

			}
			/* ---------------------------------------- */

		},





	/*
	----------------------------------------
	FUNCTIONS
	----------------------------------------
	*/

		/* validates selector (if selector is invalid or undefined uses the default one) */
		_selector=function(){
			return (typeof $(this)!=="object" || $(this).length<1) ? defaultSelector : this;
		},
		/* -------------------- */


		/* changes options according to theme */
		_theme=function(obj){
			var fixedSizeScrollbarThemes=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],
				nonExpandedScrollbarThemes=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],
				disabledScrollButtonsThemes=["minimal","minimal-dark"],
				enabledAutoHideScrollbarThemes=["minimal","minimal-dark"],
				scrollbarPositionOutsideThemes=["minimal","minimal-dark"];
			obj.autoDraggerLength=$.inArray(obj.theme,fixedSizeScrollbarThemes) > -1 ? false : obj.autoDraggerLength;
			obj.autoExpandScrollbar=$.inArray(obj.theme,nonExpandedScrollbarThemes) > -1 ? false : obj.autoExpandScrollbar;
			obj.scrollButtons.enable=$.inArray(obj.theme,disabledScrollButtonsThemes) > -1 ? false : obj.scrollButtons.enable;
			obj.autoHideScrollbar=$.inArray(obj.theme,enabledAutoHideScrollbarThemes) > -1 ? true : obj.autoHideScrollbar;
			obj.scrollbarPosition=$.inArray(obj.theme,scrollbarPositionOutsideThemes) > -1 ? "outside" : obj.scrollbarPosition;
		},
		/* -------------------- */


		/* live option timers removal */
		removeLiveTimers=function(selector){
			if(liveTimers[selector]){
				clearTimeout(liveTimers[selector]);
				_delete(liveTimers,selector);
			}
		},
		/* -------------------- */


		/* normalizes axis option to valid values: "y", "x", "yx" */
		_findAxis=function(val){
			return (val==="yx" || val==="xy" || val==="auto") ? "yx" : (val==="x" || val==="horizontal") ? "x" : "y";
		},
		/* -------------------- */


		/* normalizes scrollButtons.scrollType option to valid values: "stepless", "stepped" */
		_findScrollButtonsType=function(val){
			return (val==="stepped" || val==="pixels" || val==="step" || val==="click") ? "stepped" : "stepless";
		},
		/* -------------------- */


		/* generates plugin markup */
		_pluginMarkup=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				expandClass=o.autoExpandScrollbar ? " "+classes[1]+"_expand" : "",
				scrollbar=["<div id='mCSB_"+d.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_vertical"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+d.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_horizontal"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],
				wrapperClass=o.axis==="yx" ? "mCSB_vertical_horizontal" : o.axis==="x" ? "mCSB_horizontal" : "mCSB_vertical",
				scrollbars=o.axis==="yx" ? scrollbar[0]+scrollbar[1] : o.axis==="x" ? scrollbar[1] : scrollbar[0],
				contentWrapper=o.axis==="yx" ? "<div id='mCSB_"+d.idx+"_container_wrapper' class='mCSB_container_wrapper' />" : "",
				autoHideClass=o.autoHideScrollbar ? " "+classes[6] : "",
				scrollbarDirClass=(o.axis!=="x" && d.langDir==="rtl") ? " "+classes[7] : "";
			if(o.setWidth){$this.css("width",o.setWidth);} /* set element width */
			if(o.setHeight){$this.css("height",o.setHeight);} /* set element height */
			o.setLeft=(o.axis!=="y" && d.langDir==="rtl") ? "989999px" : o.setLeft; /* adjust left position for rtl direction */
			$this.addClass(pluginNS+" _"+pluginPfx+"_"+d.idx+autoHideClass+scrollbarDirClass).wrapInner("<div id='mCSB_"+d.idx+"' class='mCustomScrollBox mCS-"+o.theme+" "+wrapperClass+"'><div id='mCSB_"+d.idx+"_container' class='mCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir='"+d.langDir+"' /></div>");
			var mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
				mCSB_container.css("width",_contentWidth(mCSB_container));
			}
			if(o.scrollbarPosition==="outside"){
				if($this.css("position")==="static"){ /* requires elements with non-static position */
					$this.css("position","relative");
				}
				$this.css("overflow","visible");
				mCustomScrollBox.addClass("mCSB_outside").after(scrollbars);
			}else{
				mCustomScrollBox.addClass("mCSB_inside").append(scrollbars);
				mCSB_container.wrap(contentWrapper);
			}
			_scrollButtons.call(this); /* add scrollbar buttons */
			/* minimum dragger length */
			var mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			mCSB_dragger[0].css("min-height",mCSB_dragger[0].height());
			mCSB_dragger[1].css("min-width",mCSB_dragger[1].width());
		},
		/* -------------------- */


		/* calculates content width */
		_contentWidth=function(el){
			var val=[el[0].scrollWidth,Math.max.apply(Math,el.children().map(function(){return $(this).outerWidth(true);}).get())],w=el.parent().width();
			return val[0]>w ? val[0] : val[1]>w ? val[1] : "100%";
		},
		/* -------------------- */


		/* expands content horizontally */
		_expandContentHorizontally=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.autoExpandHorizontalScroll && o.axis!=="y"){
				/* calculate scrollWidth */
				mCSB_container.css({"width":"auto","min-width":0,"overflow-x":"scroll"});
				var w=Math.ceil(mCSB_container[0].scrollWidth);
				if(o.advanced.autoExpandHorizontalScroll===3 || (o.advanced.autoExpandHorizontalScroll!==2 && w>mCSB_container.parent().width())){
					mCSB_container.css({"width":w,"min-width":"100%","overflow-x":"inherit"});
				}else{
					/*
					wrap content with an infinite width div and set its position to absolute and width to auto.
					Setting width to auto before calculating the actual width is important!
					We must let the browser set the width as browser zoom values are impossible to calculate.
					*/
					mCSB_container.css({"overflow-x":"inherit","position":"absolute"})
						.wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />")
						.css({ /* set actual width, original position and un-wrap */
							/*
							get the exact width (with decimals) and then round-up.
							Using jquery outerWidth() will round the width value which will mess up with inner elements that have non-integer width
							*/
							"width":(Math.ceil(mCSB_container[0].getBoundingClientRect().right+0.4)-Math.floor(mCSB_container[0].getBoundingClientRect().left)),
							"min-width":"100%",
							"position":"relative"
						}).unwrap();
				}
			}
		},
		/* -------------------- */


		/* adds scrollbar buttons */
		_scrollButtons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_scrollTools=$(".mCSB_"+d.idx+"_scrollbar:first"),
				tabindex=!_isNumeric(o.scrollButtons.tabindex) ? "" : "tabindex='"+o.scrollButtons.tabindex+"'",
				btnHTML=[
					"<a href='#' class='"+classes[13]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[14]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[15]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[16]+"' "+tabindex+" />"
				],
				btn=[(o.axis==="x" ? btnHTML[2] : btnHTML[0]),(o.axis==="x" ? btnHTML[3] : btnHTML[1]),btnHTML[2],btnHTML[3]];
			if(o.scrollButtons.enable){
				mCSB_scrollTools.prepend(btn[0]).append(btn[1]).next(".mCSB_scrollTools").prepend(btn[2]).append(btn[3]);
			}
		},
		/* -------------------- */


		/* auto-adjusts scrollbar dragger length */
		_setDraggerLength=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				ratio=[mCustomScrollBox.height()/mCSB_container.outerHeight(false),mCustomScrollBox.width()/mCSB_container.outerWidth(false)],
				l=[
					parseInt(mCSB_dragger[0].css("min-height")),Math.round(ratio[0]*mCSB_dragger[0].parent().height()),
					parseInt(mCSB_dragger[1].css("min-width")),Math.round(ratio[1]*mCSB_dragger[1].parent().width())
				],
				h=oldIE && (l[1]<l[0]) ? l[0] : l[1],w=oldIE && (l[3]<l[2]) ? l[2] : l[3];
			mCSB_dragger[0].css({
				"height":h,"max-height":(mCSB_dragger[0].parent().height()-10)
			}).find(".mCSB_dragger_bar").css({"line-height":l[0]+"px"});
			mCSB_dragger[1].css({
				"width":w,"max-width":(mCSB_dragger[1].parent().width()-10)
			});
		},
		/* -------------------- */


		/* calculates scrollbar to content ratio */
		_scrollRatio=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				scrollAmount=[mCSB_container.outerHeight(false)-mCustomScrollBox.height(),mCSB_container.outerWidth(false)-mCustomScrollBox.width()],
				ratio=[
					scrollAmount[0]/(mCSB_dragger[0].parent().height()-mCSB_dragger[0].height()),
					scrollAmount[1]/(mCSB_dragger[1].parent().width()-mCSB_dragger[1].width())
				];
			d.scrollRatio={y:ratio[0],x:ratio[1]};
		},
		/* -------------------- */


		/* toggles scrolling classes */
		_onDragClasses=function(el,action,xpnd){
			var expandClass=xpnd ? classes[0]+"_expanded" : "",
				scrollbar=el.closest(".mCSB_scrollTools");
			if(action==="active"){
				el.toggleClass(classes[0]+" "+expandClass); scrollbar.toggleClass(classes[1]);
				el[0]._draggable=el[0]._draggable ? 0 : 1;
			}else{
				if(!el[0]._draggable){
					if(action==="hide"){
						el.removeClass(classes[0]); scrollbar.removeClass(classes[1]);
					}else{
						el.addClass(classes[0]); scrollbar.addClass(classes[1]);
					}
				}
			}
		},
		/* -------------------- */


		/* checks if content overflows its container to determine if scrolling is required */
		_overflowed=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				contentHeight=d.overflowed==null ? mCSB_container.height() : mCSB_container.outerHeight(false),
				contentWidth=d.overflowed==null ? mCSB_container.width() : mCSB_container.outerWidth(false),
				h=mCSB_container[0].scrollHeight,w=mCSB_container[0].scrollWidth;
			if(h>contentHeight){contentHeight=h;}
			if(w>contentWidth){contentWidth=w;}
			return [contentHeight>mCustomScrollBox.height(),contentWidth>mCustomScrollBox.width()];
		},
		/* -------------------- */


		/* resets content position to 0 */
		_resetContentPosition=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			_stop($this); /* stop any current scrolling before resetting */
			if((o.axis!=="x" && !d.overflowed[0]) || (o.axis==="y" && d.overflowed[0])){ /* reset y */
				mCSB_dragger[0].add(mCSB_container).css("top",0);
				_scrollTo($this,"_resetY");
			}
			if((o.axis!=="y" && !d.overflowed[1]) || (o.axis==="x" && d.overflowed[1])){ /* reset x */
				var cx=dx=0;
				if(d.langDir==="rtl"){ /* adjust left position for rtl direction */
					cx=mCustomScrollBox.width()-mCSB_container.outerWidth(false);
					dx=Math.abs(cx/d.scrollRatio.x);
				}
				mCSB_container.css("left",cx);
				mCSB_dragger[1].css("left",dx);
				_scrollTo($this,"_resetX");
			}
		},
		/* -------------------- */


		/* binds scrollbar events */
		_bindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt;
			if(!d.bindEvents){ /* check if events are already bound */
				_draggable.call(this);
				if(o.contentTouchScroll){_contentDraggable.call(this);}
				_selectable.call(this);
				if(o.mouseWheel.enable){ /* bind mousewheel fn when plugin is available */
					function _mwt(){
						mousewheelTimeout=setTimeout(function(){
							if(!$.event.special.mousewheel){
								_mwt();
							}else{
								clearTimeout(mousewheelTimeout);
								_mousewheel.call($this[0]);
							}
						},100);
					}
					var mousewheelTimeout;
					_mwt();
				}
				_draggerRail.call(this);
				_wrapperScroll.call(this);
				if(o.advanced.autoScrollOnFocus){_focus.call(this);}
				if(o.scrollButtons.enable){_buttons.call(this);}
				if(o.keyboard.enable){_keyboard.call(this);}
				d.bindEvents=true;
			}
		},
		/* -------------------- */


		/* unbinds scrollbar events */
		_unbindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				sb=".mCSB_"+d.idx+"_scrollbar",
				sel=$("#mCSB_"+d.idx+",#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,"+sb+" ."+classes[12]+",#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal,"+sb+">a"),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.releaseDraggableSelectors){sel.add($(o.advanced.releaseDraggableSelectors));}
			if(o.advanced.extraDraggableSelectors){sel.add($(o.advanced.extraDraggableSelectors));}
			if(d.bindEvents){ /* check if events are bound */
				/* unbind namespaced events from document/selectors */
				$(document).add($(!_canAccessIFrame() || top.document)).unbind("."+namespace);
				sel.each(function(){
					$(this).unbind("."+namespace);
				});
				/* clear and delete timeouts/objects */
				clearTimeout($this[0]._focusTimeout); _delete($this[0],"_focusTimeout");
				clearTimeout(d.sequential.step); _delete(d.sequential,"step");
				clearTimeout(mCSB_container[0].onCompleteTimeout); _delete(mCSB_container[0],"onCompleteTimeout");
				d.bindEvents=false;
			}
		},
		/* -------------------- */


		/* toggles scrollbar visibility */
		_scrollbarVisibility=function(disabled){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				contentWrapper=$("#mCSB_"+d.idx+"_container_wrapper"),
				content=contentWrapper.length ? contentWrapper : $("#mCSB_"+d.idx+"_container"),
				scrollbar=[$("#mCSB_"+d.idx+"_scrollbar_vertical"),$("#mCSB_"+d.idx+"_scrollbar_horizontal")],
				mCSB_dragger=[scrollbar[0].find(".mCSB_dragger"),scrollbar[1].find(".mCSB_dragger")];
			if(o.axis!=="x"){
				if(d.overflowed[0] && !disabled){
					scrollbar[0].add(mCSB_dragger[0]).add(scrollbar[0].children("a")).css("display","block");
					content.removeClass(classes[8]+" "+classes[10]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[0].css("display","none");}
						content.removeClass(classes[10]);
					}else{
						scrollbar[0].css("display","none");
						content.addClass(classes[10]);
					}
					content.addClass(classes[8]);
				}
			}
			if(o.axis!=="y"){
				if(d.overflowed[1] && !disabled){
					scrollbar[1].add(mCSB_dragger[1]).add(scrollbar[1].children("a")).css("display","block");
					content.removeClass(classes[9]+" "+classes[11]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[1].css("display","none");}
						content.removeClass(classes[11]);
					}else{
						scrollbar[1].css("display","none");
						content.addClass(classes[11]);
					}
					content.addClass(classes[9]);
				}
			}
			if(!d.overflowed[0] && !d.overflowed[1]){
				$this.addClass(classes[5]);
			}else{
				$this.removeClass(classes[5]);
			}
		},
		/* -------------------- */


		/* returns input coordinates of pointer, touch and mouse events (relative to document) */
		_coordinates=function(e){
			var t=e.type,o=e.target.ownerDocument!==document && frameElement!==null ? [$(frameElement).offset().top,$(frameElement).offset().left] : null,
				io=_canAccessIFrame() && e.target.ownerDocument!==top.document && frameElement!==null ? [$(e.view.frameElement).offset().top,$(e.view.frameElement).offset().left] : [0,0];
			switch(t){
				case "pointerdown": case "MSPointerDown": case "pointermove": case "MSPointerMove": case "pointerup": case "MSPointerUp":
					return o ? [e.originalEvent.pageY-o[0]+io[0],e.originalEvent.pageX-o[1]+io[1],false] : [e.originalEvent.pageY,e.originalEvent.pageX,false];
					break;
				case "touchstart": case "touchmove": case "touchend":
					var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
						touches=e.originalEvent.touches.length || e.originalEvent.changedTouches.length;
					return e.target.ownerDocument!==document ? [touch.screenY,touch.screenX,touches>1] : [touch.pageY,touch.pageX,touches>1];
					break;
				default:
					return o ? [e.pageY-o[0]+io[0],e.pageX-o[1]+io[1],false] : [e.pageY,e.pageX,false];
			}
		},
		/* -------------------- */


		/*
		SCROLLBAR DRAG EVENTS
		scrolls content via scrollbar dragging
		*/
		_draggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				draggerId=["mCSB_"+d.idx+"_dragger_vertical","mCSB_"+d.idx+"_dragger_horizontal"],
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=$("#"+draggerId[0]+",#"+draggerId[1]),
				draggable,dragY,dragX,
				rds=o.advanced.releaseDraggableSelectors ? mCSB_dragger.add($(o.advanced.releaseDraggableSelectors)) : mCSB_dragger,
				eds=o.advanced.extraDraggableSelectors ? $(!_canAccessIFrame() || top.document).add($(o.advanced.extraDraggableSelectors)) : $(!_canAccessIFrame() || top.document);
			mCSB_dragger.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				touchActive=true;
				if(oldIE){document.onselectstart=function(){return false;}} /* disable text selection for IE < 9 */
				_iframe.call(mCSB_container,false); /* enable scrollbar dragging over iframes by disabling their events */
				_stop($this);
				draggable=$(this);
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
					h=draggable.height()+offset.top,w=draggable.width()+offset.left;
				if(y<h && y>0 && x<w && x>0){
					dragY=y;
					dragX=x;
				}
				_onDragClasses(draggable,"active",o.autoExpandScrollbar);
			}).bind("touchmove."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				_drag(dragY,dragX,y,x);
			});
			$(document).add(eds).bind("mousemove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
				if(draggable){
					var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
					if(dragY===y && dragX===x){return;} /* has it really moved? */
					_drag(dragY,dragX,y,x);
				}
			}).add(rds).bind("mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				if(draggable){
					_onDragClasses(draggable,"active",o.autoExpandScrollbar);
					draggable=null;
				}
				touchActive=false;
				if(oldIE){document.onselectstart=null;} /* enable text selection for IE < 9 */
				_iframe.call(mCSB_container,true); /* enable iframes events */
			});
			function _drag(dragY,dragX,y,x){
				mCSB_container[0].idleTimer=o.scrollInertia<233 ? 250 : 0;
				if(draggable.attr("id")===draggerId[1]){
					var dir="x",to=((draggable[0].offsetLeft-dragX)+x)*d.scrollRatio.x;
				}else{
					var dir="y",to=((draggable[0].offsetTop-dragY)+y)*d.scrollRatio.y;
				}
				_scrollTo($this,to.toString(),{dir:dir,drag:true});
			}
		},
		/* -------------------- */


		/*
		TOUCH SWIPE EVENTS
		scrolls content via touch swipe
		Emulates the native touch-swipe scrolling with momentum found in iOS, Android and WP devices
		*/
		_contentDraggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				draggable,dragY,dragX,touchStartY,touchStartX,touchMoveY=[],touchMoveX=[],startTime,runningTime,endTime,distance,speed,amount,
				durA=0,durB,overwrite=o.axis==="yx" ? "none" : "all",touchIntent=[],touchDrag,docDrag,
				iframe=mCSB_container.find("iframe"),
				events=[
					"touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace, //start
					"touchmove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace, //move
					"touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace //end
				],
				touchAction=document.body.style.touchAction!==undefined && document.body.style.touchAction!=="";
			mCSB_container.bind(events[0],function(e){
				_onTouchstart(e);
			}).bind(events[1],function(e){
				_onTouchmove(e);
			});
			mCustomScrollBox.bind(events[0],function(e){
				_onTouchstart2(e);
			}).bind(events[2],function(e){
				_onTouchend(e);
			});
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onTouchstart(e);
								_onTouchstart2(e);
							}).bind(events[1],function(e){
								_onTouchmove(e);
							}).bind(events[2],function(e){
								_onTouchend(e);
							});
						}
					});
				});
			}
			function _onTouchstart(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1; touchDrag=0; docDrag=0; draggable=1;
				$this.removeClass("mCS_touch_action");
				var offset=mCSB_container.offset();
				dragY=_coordinates(e)[0]-offset.top;
				dragX=_coordinates(e)[1]-offset.left;
				touchIntent=[_coordinates(e)[0],_coordinates(e)[1]];
			}
			function _onTouchmove(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				if(!o.documentTouchScroll){e.preventDefault();}
				e.stopImmediatePropagation();
				if(docDrag && !touchDrag){return;}
				if(draggable){
					runningTime=_getTime();
					var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
						easing="mcsLinearOut";
					touchMoveY.push(y);
					touchMoveX.push(x);
					touchIntent[2]=Math.abs(_coordinates(e)[0]-touchIntent[0]); touchIntent[3]=Math.abs(_coordinates(e)[1]-touchIntent[1]);
					if(d.overflowed[0]){
						var limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
							prevent=((dragY-y)>0 && (y-dragY)>-(limit*d.scrollRatio.y) && (touchIntent[3]*2<touchIntent[2] || o.axis==="yx"));
					}
					if(d.overflowed[1]){
						var limitX=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
							preventX=((dragX-x)>0 && (x-dragX)>-(limitX*d.scrollRatio.x) && (touchIntent[2]*2<touchIntent[3] || o.axis==="yx"));
					}
					if(prevent || preventX){ /* prevent native document scrolling */
						if(!touchAction){e.preventDefault();}
						touchDrag=1;
					}else{
						docDrag=1;
						$this.addClass("mCS_touch_action");
					}
					if(touchAction){e.preventDefault();}
					amount=o.axis==="yx" ? [(dragY-y),(dragX-x)] : o.axis==="x" ? [null,(dragX-x)] : [(dragY-y),null];
					mCSB_container[0].idleTimer=250;
					if(d.overflowed[0]){_drag(amount[0],durA,easing,"y","all",true);}
					if(d.overflowed[1]){_drag(amount[1],durA,easing,"x",overwrite,true);}
				}
			}
			function _onTouchstart2(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1;
				e.stopImmediatePropagation();
				_stop($this);
				startTime=_getTime();
				var offset=mCustomScrollBox.offset();
				touchStartY=_coordinates(e)[0]-offset.top;
				touchStartX=_coordinates(e)[1]-offset.left;
				touchMoveY=[]; touchMoveX=[];
			}
			function _onTouchend(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				draggable=0;
				e.stopImmediatePropagation();
				touchDrag=0; docDrag=0;
				endTime=_getTime();
				var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				if((endTime-runningTime)>30){return;}
				speed=1000/(endTime-startTime);
				var easing="mcsEaseOut",slow=speed<2.5,
					diff=slow ? [touchMoveY[touchMoveY.length-2],touchMoveX[touchMoveX.length-2]] : [0,0];
				distance=slow ? [(y-diff[0]),(x-diff[1])] : [y-touchStartY,x-touchStartX];
				var absDistance=[Math.abs(distance[0]),Math.abs(distance[1])];
				speed=slow ? [Math.abs(distance[0]/4),Math.abs(distance[1]/4)] : [speed,speed];
				var a=[
					Math.abs(mCSB_container[0].offsetTop)-(distance[0]*_m((absDistance[0]/speed[0]),speed[0])),
					Math.abs(mCSB_container[0].offsetLeft)-(distance[1]*_m((absDistance[1]/speed[1]),speed[1]))
				];
				amount=o.axis==="yx" ? [a[0],a[1]] : o.axis==="x" ? [null,a[1]] : [a[0],null];
				durB=[(absDistance[0]*4)+o.scrollInertia,(absDistance[1]*4)+o.scrollInertia];
				var md=parseInt(o.contentTouchScroll) || 0; /* absolute minimum distance required */
				amount[0]=absDistance[0]>md ? amount[0] : 0;
				amount[1]=absDistance[1]>md ? amount[1] : 0;
				if(d.overflowed[0]){_drag(amount[0],durB[0],easing,"y",overwrite,false);}
				if(d.overflowed[1]){_drag(amount[1],durB[1],easing,"x",overwrite,false);}
			}
			function _m(ds,s){
				var r=[s*1.5,s*2,s/1.5,s/2];
				if(ds>90){
					return s>4 ? r[0] : r[3];
				}else if(ds>60){
					return s>3 ? r[3] : r[2];
				}else if(ds>30){
					return s>8 ? r[1] : s>6 ? r[0] : s>4 ? s : r[2];
				}else{
					return s>8 ? s : r[3];
				}
			}
			function _drag(amount,dur,easing,dir,overwrite,drag){
				if(!amount){return;}
				_scrollTo($this,amount.toString(),{dur:dur,scrollEasing:easing,dir:dir,overwrite:overwrite,drag:drag});
			}
		},
		/* -------------------- */


		/*
		SELECT TEXT EVENTS
		scrolls content when text is selected
		*/
		_selectable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				action;
			mCSB_container.bind("mousedown."+namespace,function(e){
				if(touchable){return;}
				if(!action){action=1; touchActive=true;}
			}).add(document).bind("mousemove."+namespace,function(e){
				if(!touchable && action && _sel()){
					var offset=mCSB_container.offset(),
						y=_coordinates(e)[0]-offset.top+mCSB_container[0].offsetTop,x=_coordinates(e)[1]-offset.left+mCSB_container[0].offsetLeft;
					if(y>0 && y<wrapper.height() && x>0 && x<wrapper.width()){
						if(seq.step){_seq("off",null,"stepped");}
					}else{
						if(o.axis!=="x" && d.overflowed[0]){
							if(y<0){
								_seq("on",38);
							}else if(y>wrapper.height()){
								_seq("on",40);
							}
						}
						if(o.axis!=="y" && d.overflowed[1]){
							if(x<0){
								_seq("on",37);
							}else if(x>wrapper.width()){
								_seq("on",39);
							}
						}
					}
				}
			}).bind("mouseup."+namespace+" dragend."+namespace,function(e){
				if(touchable){return;}
				if(action){action=0; _seq("off",null);}
				touchActive=false;
			});
			function _sel(){
				return 	window.getSelection ? window.getSelection().toString() :
						document.selection && document.selection.type!="Control" ? document.selection.createRange().text : 0;
			}
			function _seq(a,c,s){
				seq.type=s && action ? "stepped" : "stepless";
				seq.scrollAmount=10;
				_sequentialScroll($this,a,c,"mcsLinearOut",s ? 60 : null);
			}
		},
		/* -------------------- */


		/*
		MOUSE WHEEL EVENT
		scrolls content via mouse-wheel
		via mouse-wheel plugin (https://github.com/brandonaaron/jquery-mousewheel)
		*/
		_mousewheel=function(){
			if(!$(this).data(pluginPfx)){return;} /* Check if the scrollbar is ready to use mousewheel events (issue: #185) */
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				iframe=$("#mCSB_"+d.idx+"_container").find("iframe");
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind("mousewheel."+namespace,function(e,delta){
								_onMousewheel(e,delta);
							});
						}
					});
				});
			}
			mCustomScrollBox.bind("mousewheel."+namespace,function(e,delta){
				_onMousewheel(e,delta);
			});
			function _onMousewheel(e,delta){
				_stop($this);
				if(_disableMousewheel($this,e.target)){return;} /* disables mouse-wheel when hovering specific elements */
				var deltaFactor=o.mouseWheel.deltaFactor!=="auto" ? parseInt(o.mouseWheel.deltaFactor) : (oldIE && e.deltaFactor<100) ? 100 : e.deltaFactor || 100,
					dur=o.scrollInertia;
				if(o.axis==="x" || o.mouseWheel.axis==="x"){
					var dir="x",
						px=[Math.round(deltaFactor*d.scrollRatio.x),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.width() ? mCustomScrollBox.width()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetLeft),
						draggerPos=mCSB_dragger[1][0].offsetLeft,
						limit=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
						dlt=o.mouseWheel.axis==="y" ? (e.deltaY || delta) : e.deltaX;
				}else{
					var dir="y",
						px=[Math.round(deltaFactor*d.scrollRatio.y),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.height() ? mCustomScrollBox.height()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetTop),
						draggerPos=mCSB_dragger[0][0].offsetTop,
						limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
						dlt=e.deltaY || delta;
				}
				if((dir==="y" && !d.overflowed[0]) || (dir==="x" && !d.overflowed[1])){return;}
				if(o.mouseWheel.invert || e.webkitDirectionInvertedFromDevice){dlt=-dlt;}
				if(o.mouseWheel.normalizeDelta){dlt=dlt<0 ? -1 : 1;}
				if((dlt>0 && draggerPos!==0) || (dlt<0 && draggerPos!==limit) || o.mouseWheel.preventDefault){
					e.stopImmediatePropagation();
					e.preventDefault();
				}
				if(e.deltaFactor<5 && !o.mouseWheel.normalizeDelta){
					//very low deltaFactor values mean some kind of delta acceleration (e.g. osx trackpad), so adjusting scrolling accordingly
					amount=e.deltaFactor; dur=17;
				}
				_scrollTo($this,(contentPos-(dlt*amount)).toString(),{dir:dir,dur:dur});
			}
		},
		/* -------------------- */


		/* checks if iframe can be accessed */
		_canAccessIFrameCache=new Object(),
		_canAccessIFrame=function(iframe){
		    var result=false,cacheKey=false,html=null;
		    if(iframe===undefined){
				cacheKey="#empty";
		    }else if($(iframe).attr("id")!==undefined){
				cacheKey=$(iframe).attr("id");
		    }
			if(cacheKey!==false && _canAccessIFrameCache[cacheKey]!==undefined){
				return _canAccessIFrameCache[cacheKey];
			}
			if(!iframe){
				try{
					var doc=top.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}else{
				try{
					var doc=iframe.contentDocument || iframe.contentWindow.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}
			if(cacheKey!==false){_canAccessIFrameCache[cacheKey]=result;}
			return result;
		},
		/* -------------------- */


		/* switches iframe's pointer-events property (drag, mousewheel etc. over cross-domain iframes) */
		_iframe=function(evt){
			var el=this.find("iframe");
			if(!el.length){return;} /* check if content contains iframes */
			var val=!evt ? "none" : "auto";
			el.css("pointer-events",val); /* for IE11, iframe's display property should not be "block" */
		},
		/* -------------------- */


		/* disables mouse-wheel when hovering specific elements like select, datalist etc. */
		_disableMousewheel=function(el,target){
			var tag=target.nodeName.toLowerCase(),
				tags=el.data(pluginPfx).opt.mouseWheel.disableOver,
				/* elements that require focus */
				focusTags=["select","textarea"];
			return $.inArray(tag,tags) > -1 && !($.inArray(tag,focusTags) > -1 && !$(target).is(":focus"));
		},
		/* -------------------- */


		/*
		DRAGGER RAIL CLICK EVENT
		scrolls content via dragger rail
		*/
		_draggerRail=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				mCSB_draggerContainer=$(".mCSB_"+d.idx+"_scrollbar ."+classes[12]),
				clickable;
			mCSB_draggerContainer.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				touchActive=true;
				if(!$(e.target).hasClass("mCSB_dragger")){clickable=1;}
			}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				touchActive=false;
			}).bind("click."+namespace,function(e){
				if(!clickable){return;}
				clickable=0;
				if($(e.target).hasClass(classes[12]) || $(e.target).hasClass("mCSB_draggerRail")){
					_stop($this);
					var el=$(this),mCSB_dragger=el.find(".mCSB_dragger");
					if(el.parent(".mCSB_scrollTools_horizontal").length>0){
						if(!d.overflowed[1]){return;}
						var dir="x",
							clickDir=e.pageX>mCSB_dragger.offset().left ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetLeft)-(clickDir*(wrapper.width()*0.9));
					}else{
						if(!d.overflowed[0]){return;}
						var dir="y",
							clickDir=e.pageY>mCSB_dragger.offset().top ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetTop)-(clickDir*(wrapper.height()*0.9));
					}
					_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
				}
			});
		},
		/* -------------------- */


		/*
		FOCUS EVENT
		scrolls content via element focus (e.g. clicking an input, pressing TAB key etc.)
		*/
		_focus=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent();
			mCSB_container.bind("focusin."+namespace,function(e){
				var el=$(document.activeElement),
					nested=mCSB_container.find(".mCustomScrollBox").length,
					dur=0;
				if(!el.is(o.advanced.autoScrollOnFocus)){return;}
				_stop($this);
				clearTimeout($this[0]._focusTimeout);
				$this[0]._focusTimer=nested ? (dur+17)*nested : 0;
				$this[0]._focusTimeout=setTimeout(function(){
					var	to=[_childPos(el)[0],_childPos(el)[1]],
						contentPos=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft],
						isVisible=[
							(contentPos[0]+to[0]>=0 && contentPos[0]+to[0]<wrapper.height()-el.outerHeight(false)),
							(contentPos[1]+to[1]>=0 && contentPos[0]+to[1]<wrapper.width()-el.outerWidth(false))
						],
						overwrite=(o.axis==="yx" && !isVisible[0] && !isVisible[1]) ? "none" : "all";
					if(o.axis!=="x" && !isVisible[0]){
						_scrollTo($this,to[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
					if(o.axis!=="y" && !isVisible[1]){
						_scrollTo($this,to[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
				},$this[0]._focusTimer);
			});
		},
		/* -------------------- */


		/* sets content wrapper scrollTop/scrollLeft always to 0 */
		_wrapperScroll=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				wrapper=$("#mCSB_"+d.idx+"_container").parent();
			wrapper.bind("scroll."+namespace,function(e){
				if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){
					$(".mCSB_"+d.idx+"_scrollbar").css("visibility","hidden"); /* hide scrollbar(s) */
				}
			});
		},
		/* -------------------- */


		/*
		BUTTONS EVENTS
		scrolls content via up, down, left and right buttons
		*/
		_buttons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				sel=".mCSB_"+d.idx+"_scrollbar",
				btn=$(sel+">a");
			btn.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace+" mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace+" mouseout."+namespace+" pointerout."+namespace+" MSPointerOut."+namespace+" click."+namespace,function(e){
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				var btnClass=$(this).attr("class");
				seq.type=o.scrollButtons.scrollType;
				switch(e.type){
					case "mousedown": case "touchstart": case "pointerdown": case "MSPointerDown":
						if(seq.type==="stepped"){return;}
						touchActive=true;
						d.tweenRunning=false;
						_seq("on",btnClass);
						break;
					case "mouseup": case "touchend": case "pointerup": case "MSPointerUp":
					case "mouseout": case "pointerout": case "MSPointerOut":
						if(seq.type==="stepped"){return;}
						touchActive=false;
						if(seq.dir){_seq("off",btnClass);}
						break;
					case "click":
						if(seq.type!=="stepped" || d.tweenRunning){return;}
						_seq("on",btnClass);
						break;
				}
				function _seq(a,c){
					seq.scrollAmount=o.scrollButtons.scrollAmount;
					_sequentialScroll($this,a,c);
				}
			});
		},
		/* -------------------- */


		/*
		KEYBOARD EVENTS
		scrolls content via keyboard
		Keys: up arrow, down arrow, left arrow, right arrow, PgUp, PgDn, Home, End
		*/
		_keyboard=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				editables="input,textarea,select,datalist,keygen,[contenteditable='true']",
				iframe=mCSB_container.find("iframe"),
				events=["blur."+namespace+" keydown."+namespace+" keyup."+namespace];
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onKeyboard(e);
							});
						}
					});
				});
			}
			mCustomScrollBox.attr("tabindex","0").bind(events[0],function(e){
				_onKeyboard(e);
			});
			function _onKeyboard(e){
				switch(e.type){
					case "blur":
						if(d.tweenRunning && seq.dir){_seq("off",null);}
						break;
					case "keydown": case "keyup":
						var code=e.keyCode ? e.keyCode : e.which,action="on";
						if((o.axis!=="x" && (code===38 || code===40)) || (o.axis!=="y" && (code===37 || code===39))){
							/* up (38), down (40), left (37), right (39) arrows */
							if(((code===38 || code===40) && !d.overflowed[0]) || ((code===37 || code===39) && !d.overflowed[1])){return;}
							if(e.type==="keyup"){action="off";}
							if(!$(document.activeElement).is(editables)){
								e.preventDefault();
								e.stopImmediatePropagation();
								_seq(action,code);
							}
						}else if(code===33 || code===34){
							/* PgUp (33), PgDn (34) */
							if(d.overflowed[0] || d.overflowed[1]){
								e.preventDefault();
								e.stopImmediatePropagation();
							}
							if(e.type==="keyup"){
								_stop($this);
								var keyboardDir=code===34 ? -1 : 1;
								if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
									var dir="x",to=Math.abs(mCSB_container[0].offsetLeft)-(keyboardDir*(wrapper.width()*0.9));
								}else{
									var dir="y",to=Math.abs(mCSB_container[0].offsetTop)-(keyboardDir*(wrapper.height()*0.9));
								}
								_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
							}
						}else if(code===35 || code===36){
							/* End (35), Home (36) */
							if(!$(document.activeElement).is(editables)){
								if(d.overflowed[0] || d.overflowed[1]){
									e.preventDefault();
									e.stopImmediatePropagation();
								}
								if(e.type==="keyup"){
									if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
										var dir="x",to=code===35 ? Math.abs(wrapper.width()-mCSB_container.outerWidth(false)) : 0;
									}else{
										var dir="y",to=code===35 ? Math.abs(wrapper.height()-mCSB_container.outerHeight(false)) : 0;
									}
									_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
								}
							}
						}
						break;
				}
				function _seq(a,c){
					seq.type=o.keyboard.scrollType;
					seq.scrollAmount=o.keyboard.scrollAmount;
					if(seq.type==="stepped" && d.tweenRunning){return;}
					_sequentialScroll($this,a,c);
				}
			}
		},
		/* -------------------- */


		/* scrolls content sequentially (used when scrolling via buttons, keyboard arrows etc.) */
		_sequentialScroll=function(el,action,trigger,e,s){
			var d=el.data(pluginPfx),o=d.opt,seq=d.sequential,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				once=seq.type==="stepped" ? true : false,
				steplessSpeed=o.scrollInertia < 26 ? 26 : o.scrollInertia, /* 26/1.5=17 */
				steppedSpeed=o.scrollInertia < 1 ? 17 : o.scrollInertia;
			switch(action){
				case "on":
					seq.dir=[
						(trigger===classes[16] || trigger===classes[15] || trigger===39 || trigger===37 ? "x" : "y"),
						(trigger===classes[13] || trigger===classes[15] || trigger===38 || trigger===37 ? -1 : 1)
					];
					_stop(el);
					if(_isNumeric(trigger) && seq.type==="stepped"){return;}
					_on(once);
					break;
				case "off":
					_off();
					if(once || (d.tweenRunning && seq.dir)){
						_on(true);
					}
					break;
			}

			/* starts sequence */
			function _on(once){
				if(o.snapAmount){seq.scrollAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : seq.dir[0]==="x" ? o.snapAmount[1] : o.snapAmount[0];} /* scrolling snapping */
				var c=seq.type!=="stepped", /* continuous scrolling */
					t=s ? s : !once ? 1000/60 : c ? steplessSpeed/1.5 : steppedSpeed, /* timer */
					m=!once ? 2.5 : c ? 7.5 : 40, /* multiplier */
					contentPos=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)],
					ratio=[d.scrollRatio.y>10 ? 10 : d.scrollRatio.y,d.scrollRatio.x>10 ? 10 : d.scrollRatio.x],
					amount=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*(ratio[1]*m)) : contentPos[0]+(seq.dir[1]*(ratio[0]*m)),
					px=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*parseInt(seq.scrollAmount)) : contentPos[0]+(seq.dir[1]*parseInt(seq.scrollAmount)),
					to=seq.scrollAmount!=="auto" ? px : amount,
					easing=e ? e : !once ? "mcsLinear" : c ? "mcsLinearOut" : "mcsEaseInOut",
					onComplete=!once ? false : true;
				if(once && t<17){
					to=seq.dir[0]==="x" ? contentPos[1] : contentPos[0];
				}
				_scrollTo(el,to.toString(),{dir:seq.dir[0],scrollEasing:easing,dur:t,onComplete:onComplete});
				if(once){
					seq.dir=false;
					return;
				}
				clearTimeout(seq.step);
				seq.step=setTimeout(function(){
					_on();
				},t);
			}
			/* stops sequence */
			function _off(){
				clearTimeout(seq.step);
				_delete(seq,"step");
				_stop(el);
			}
		},
		/* -------------------- */


		/* returns a yx array from value */
		_arr=function(val){
			var o=$(this).data(pluginPfx).opt,vals=[];
			if(typeof val==="function"){val=val();} /* check if the value is a single anonymous function */
			/* check if value is object or array, its length and create an array with yx values */
			if(!(val instanceof Array)){ /* object value (e.g. {y:"100",x:"100"}, 100 etc.) */
				vals[0]=val.y ? val.y : val.x || o.axis==="x" ? null : val;
				vals[1]=val.x ? val.x : val.y || o.axis==="y" ? null : val;
			}else{ /* array value (e.g. [100,100]) */
				vals=val.length>1 ? [val[0],val[1]] : o.axis==="x" ? [null,val[0]] : [val[0],null];
			}
			/* check if array values are anonymous functions */
			if(typeof vals[0]==="function"){vals[0]=vals[0]();}
			if(typeof vals[1]==="function"){vals[1]=vals[1]();}
			return vals;
		},
		/* -------------------- */


		/* translates values (e.g. "top", 100, "100px", "#id") to actual scroll-to positions */
		_to=function(val,dir){
			if(val==null || typeof val=="undefined"){return;}
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				t=typeof val;
			if(!dir){dir=o.axis==="x" ? "x" : "y";}
			var contentLength=dir==="x" ? mCSB_container.outerWidth(false)-wrapper.width() : mCSB_container.outerHeight(false)-wrapper.height(),
				contentPos=dir==="x" ? mCSB_container[0].offsetLeft : mCSB_container[0].offsetTop,
				cssProp=dir==="x" ? "left" : "top";
			switch(t){
				case "function": /* this currently is not used. Consider removing it */
					return val();
					break;
				case "object": /* js/jquery object */
					var obj=val.jquery ? val : $(val);
					if(!obj.length){return;}
					return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
					break;
				case "string": case "number":
					if(_isNumeric(val)){ /* numeric value */
						return Math.abs(val);
					}else if(val.indexOf("%")!==-1){ /* percentage value */
						return Math.abs(contentLength*parseInt(val)/100);
					}else if(val.indexOf("-=")!==-1){ /* decrease value */
						return Math.abs(contentPos-parseInt(val.split("-=")[1]));
					}else if(val.indexOf("+=")!==-1){ /* inrease value */
						var p=(contentPos+parseInt(val.split("+=")[1]));
						return p>=0 ? 0 : Math.abs(p);
					}else if(val.indexOf("px")!==-1 && _isNumeric(val.split("px")[0])){ /* pixels string value (e.g. "100px") */
						return Math.abs(val.split("px")[0]);
					}else{
						if(val==="top" || val==="left"){ /* special strings */
							return 0;
						}else if(val==="bottom"){
							return Math.abs(wrapper.height()-mCSB_container.outerHeight(false));
						}else if(val==="right"){
							return Math.abs(wrapper.width()-mCSB_container.outerWidth(false));
						}else if(val==="first" || val==="last"){
							var obj=mCSB_container.find(":"+val);
							return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
						}else{
							if($(val).length){ /* jquery selector */
								return dir==="x" ? _childPos($(val))[1] : _childPos($(val))[0];
							}else{ /* other values (e.g. "100em") */
								mCSB_container.css(cssProp,val);
								methods.update.call(null,$this[0]);
								return;
							}
						}
					}
					break;
			}
		},
		/* -------------------- */


		/* calls the update method automatically */
		_autoUpdate=function(rem){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(rem){
				/*
				removes autoUpdate timer
				usage: _autoUpdate.call(this,"remove");
				*/
				clearTimeout(mCSB_container[0].autoUpdate);
				_delete(mCSB_container[0],"autoUpdate");
				return;
			}
			upd();
			function upd(){
				clearTimeout(mCSB_container[0].autoUpdate);
				if($this.parents("html").length===0){
					/* check element in dom tree */
					$this=null;
					return;
				}
				mCSB_container[0].autoUpdate=setTimeout(function(){
					/* update on specific selector(s) length and size change */
					if(o.advanced.updateOnSelectorChange){
						d.poll.change.n=sizesSum();
						if(d.poll.change.n!==d.poll.change.o){
							d.poll.change.o=d.poll.change.n;
							doUpd(3);
							return;
						}
					}
					/* update on main element and scrollbar size changes */
					if(o.advanced.updateOnContentResize){
						d.poll.size.n=$this[0].scrollHeight+$this[0].scrollWidth+mCSB_container[0].offsetHeight+$this[0].offsetHeight+$this[0].offsetWidth;
						if(d.poll.size.n!==d.poll.size.o){
							d.poll.size.o=d.poll.size.n;
							doUpd(1);
							return;
						}
					}
					/* update on image load */
					if(o.advanced.updateOnImageLoad){
						if(!(o.advanced.updateOnImageLoad==="auto" && o.axis==="y")){ //by default, it doesn't run on vertical content
							d.poll.img.n=mCSB_container.find("img").length;
							if(d.poll.img.n!==d.poll.img.o){
								d.poll.img.o=d.poll.img.n;
								mCSB_container.find("img").each(function(){
									imgLoader(this);
								});
								return;
							}
						}
					}
					if(o.advanced.updateOnSelectorChange || o.advanced.updateOnContentResize || o.advanced.updateOnImageLoad){upd();}
				},o.advanced.autoUpdateTimeout);
			}
			/* a tiny image loader */
			function imgLoader(el){
				if($(el).hasClass(classes[2])){doUpd(); return;}
				var img=new Image();
				function createDelegate(contextObject,delegateMethod){
					return function(){return delegateMethod.apply(contextObject,arguments);}
				}
				function imgOnLoad(){
					this.onload=null;
					$(el).addClass(classes[2]);
					doUpd(2);
				}
				img.onload=createDelegate(img,imgOnLoad);
				img.src=el.src;
			}
			/* returns the total height and width sum of all elements matching the selector */
			function sizesSum(){
				if(o.advanced.updateOnSelectorChange===true){o.advanced.updateOnSelectorChange="*";}
				var total=0,sel=mCSB_container.find(o.advanced.updateOnSelectorChange);
				if(o.advanced.updateOnSelectorChange && sel.length>0){sel.each(function(){total+=this.offsetHeight+this.offsetWidth;});}
				return total;
			}
			/* calls the update method */
			function doUpd(cb){
				clearTimeout(mCSB_container[0].autoUpdate);
				methods.update.call(null,$this[0],cb);
			}
		},
		/* -------------------- */


		/* snaps scrolling to a multiple of a pixels number */
		_snapAmount=function(to,amount,offset){
			return (Math.round(to/amount)*amount-offset);
		},
		/* -------------------- */


		/* stops content and scrollbar animations */
		_stop=function(el){
			var d=el.data(pluginPfx),
				sel=$("#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal");
			sel.each(function(){
				_stopTween.call(this);
			});
		},
		/* -------------------- */


		/*
		ANIMATES CONTENT
		This is where the actual scrolling happens
		*/
		_scrollTo=function(el,to,options){
			var d=el.data(pluginPfx),o=d.opt,
				defaults={
					trigger:"internal",
					dir:"y",
					scrollEasing:"mcsEaseOut",
					drag:false,
					dur:o.scrollInertia,
					overwrite:"all",
					callbacks:true,
					onStart:true,
					onUpdate:true,
					onComplete:true
				},
				options=$.extend(defaults,options),
				dur=[options.dur,(options.drag ? 0 : options.dur)],
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				totalScrollOffsets=o.callbacks.onTotalScrollOffset ? _arr.call(el,o.callbacks.onTotalScrollOffset) : [0,0],
				totalScrollBackOffsets=o.callbacks.onTotalScrollBackOffset ? _arr.call(el,o.callbacks.onTotalScrollBackOffset) : [0,0];
			d.trigger=options.trigger;
			if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){ /* always reset scrollTop/Left */
				$(".mCSB_"+d.idx+"_scrollbar").css("visibility","visible");
				wrapper.scrollTop(0).scrollLeft(0);
			}
			if(to==="_resetY" && !d.contentReset.y){
				/* callbacks: onOverflowYNone */
				if(_cb("onOverflowYNone")){o.callbacks.onOverflowYNone.call(el[0]);}
				d.contentReset.y=1;
			}
			if(to==="_resetX" && !d.contentReset.x){
				/* callbacks: onOverflowXNone */
				if(_cb("onOverflowXNone")){o.callbacks.onOverflowXNone.call(el[0]);}
				d.contentReset.x=1;
			}
			if(to==="_resetY" || to==="_resetX"){return;}
			if((d.contentReset.y || !el[0].mcs) && d.overflowed[0]){
				/* callbacks: onOverflowY */
				if(_cb("onOverflowY")){o.callbacks.onOverflowY.call(el[0]);}
				d.contentReset.x=null;
			}
			if((d.contentReset.x || !el[0].mcs) && d.overflowed[1]){
				/* callbacks: onOverflowX */
				if(_cb("onOverflowX")){o.callbacks.onOverflowX.call(el[0]);}
				d.contentReset.x=null;
			}
			if(o.snapAmount){ /* scrolling snapping */
				var snapAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : options.dir==="x" ? o.snapAmount[1] : o.snapAmount[0];
				to=_snapAmount(to,snapAmount,o.snapOffset);
			}
			switch(options.dir){
				case "x":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_horizontal"),
						property="left",
						contentPos=mCSB_container[0].offsetLeft,
						limit=[
							mCustomScrollBox.width()-mCSB_container.outerWidth(false),
							mCSB_dragger.parent().width()-mCSB_dragger.width()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.x)],
						tso=totalScrollOffsets[1],
						tsbo=totalScrollBackOffsets[1],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.x : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.x : 0;
					break;
				case "y":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_vertical"),
						property="top",
						contentPos=mCSB_container[0].offsetTop,
						limit=[
							mCustomScrollBox.height()-mCSB_container.outerHeight(false),
							mCSB_dragger.parent().height()-mCSB_dragger.height()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.y)],
						tso=totalScrollOffsets[0],
						tsbo=totalScrollBackOffsets[0],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.y : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.y : 0;
					break;
			}
			if(scrollTo[1]<0 || (scrollTo[0]===0 && scrollTo[1]===0)){
				scrollTo=[0,0];
			}else if(scrollTo[1]>=limit[1]){
				scrollTo=[limit[0],limit[1]];
			}else{
				scrollTo[0]=-scrollTo[0];
			}
			if(!el[0].mcs){
				_mcs();  /* init mcs object (once) to make it available before callbacks */
				if(_cb("onInit")){o.callbacks.onInit.call(el[0]);} /* callbacks: onInit */
			}
			clearTimeout(mCSB_container[0].onCompleteTimeout);
			_tweenTo(mCSB_dragger[0],property,Math.round(scrollTo[1]),dur[1],options.scrollEasing);
			if(!d.tweenRunning && ((contentPos===0 && scrollTo[0]>=0) || (contentPos===limit[0] && scrollTo[0]<=limit[0]))){return;}
			_tweenTo(mCSB_container[0],property,Math.round(scrollTo[0]),dur[0],options.scrollEasing,options.overwrite,{
				onStart:function(){
					if(options.callbacks && options.onStart && !d.tweenRunning){
						/* callbacks: onScrollStart */
						if(_cb("onScrollStart")){_mcs(); o.callbacks.onScrollStart.call(el[0]);}
						d.tweenRunning=true;
						_onDragClasses(mCSB_dragger);
						d.cbOffsets=_cbOffsets();
					}
				},onUpdate:function(){
					if(options.callbacks && options.onUpdate){
						/* callbacks: whileScrolling */
						if(_cb("whileScrolling")){_mcs(); o.callbacks.whileScrolling.call(el[0]);}
					}
				},onComplete:function(){
					if(options.callbacks && options.onComplete){
						if(o.axis==="yx"){clearTimeout(mCSB_container[0].onCompleteTimeout);}
						var t=mCSB_container[0].idleTimer || 0;
						mCSB_container[0].onCompleteTimeout=setTimeout(function(){
							/* callbacks: onScroll, onTotalScroll, onTotalScrollBack */
							if(_cb("onScroll")){_mcs(); o.callbacks.onScroll.call(el[0]);}
							if(_cb("onTotalScroll") && scrollTo[1]>=limit[1]-totalScrollOffset && d.cbOffsets[0]){_mcs(); o.callbacks.onTotalScroll.call(el[0]);}
							if(_cb("onTotalScrollBack") && scrollTo[1]<=totalScrollBackOffset && d.cbOffsets[1]){_mcs(); o.callbacks.onTotalScrollBack.call(el[0]);}
							d.tweenRunning=false;
							mCSB_container[0].idleTimer=0;
							_onDragClasses(mCSB_dragger,"hide");
						},t);
					}
				}
			});
			/* checks if callback function exists */
			function _cb(cb){
				return d && o.callbacks[cb] && typeof o.callbacks[cb]==="function";
			}
			/* checks whether callback offsets always trigger */
			function _cbOffsets(){
				return [o.callbacks.alwaysTriggerOffsets || contentPos>=limit[0]+tso,o.callbacks.alwaysTriggerOffsets || contentPos<=-tsbo];
			}
			/*
			populates object with useful values for the user
			values:
				content: this.mcs.content
				content top position: this.mcs.top
				content left position: this.mcs.left
				dragger top position: this.mcs.draggerTop
				dragger left position: this.mcs.draggerLeft
				scrolling y percentage: this.mcs.topPct
				scrolling x percentage: this.mcs.leftPct
				scrolling direction: this.mcs.direction
			*/
			function _mcs(){
				var cp=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft], /* content position */
					dp=[mCSB_dragger[0].offsetTop,mCSB_dragger[0].offsetLeft], /* dragger position */
					cl=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false)], /* content length */
					pl=[mCustomScrollBox.height(),mCustomScrollBox.width()]; /* content parent length */
				el[0].mcs={
					content:mCSB_container, /* original content wrapper as jquery object */
					top:cp[0],left:cp[1],draggerTop:dp[0],draggerLeft:dp[1],
					topPct:Math.round((100*Math.abs(cp[0]))/(Math.abs(cl[0])-pl[0])),leftPct:Math.round((100*Math.abs(cp[1]))/(Math.abs(cl[1])-pl[1])),
					direction:options.dir
				};
				/*
				this refers to the original element containing the scrollbar(s)
				usage: this.mcs.top, this.mcs.leftPct etc.
				*/
			}
		},
		/* -------------------- */


		/*
		CUSTOM JAVASCRIPT ANIMATION TWEEN
		Lighter and faster than jquery animate() and css transitions
		Animates top/left properties and includes easings
		*/
		_tweenTo=function(el,prop,to,duration,easing,overwrite,callbacks){
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var callbacks=callbacks || {},
				onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){},
				startTime=_getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style,_request,tobj=el._mTween[prop];
			if(prop==="left"){from=el.offsetLeft;}
			var diff=to-from;
			tobj.stop=0;
			if(overwrite!=="none"){_cancelTween();}
			_startTween();
			function _step(){
				if(tobj.stop){return;}
				if(!progress){onStart.call();}
				progress=_getTime()-startTime;
				_tween();
				if(progress>=tobj.time){
					tobj.time=(progress>tobj.time) ? progress+_delay-(progress-tobj.time) : progress+_delay-1;
					if(tobj.time<progress+1){tobj.time=progress+1;}
				}
				if(tobj.time<duration){tobj.id=_request(_step);}else{onComplete.call();}
			}
			function _tween(){
				if(duration>0){
					tobj.currVal=_ease(tobj.time,from,diff,duration,easing);
					elStyle[prop]=Math.round(tobj.currVal)+"px";
				}else{
					elStyle[prop]=to+"px";
				}
				onUpdate.call();
			}
			function _startTween(){
				_delay=1000/60;
				tobj.time=progress+_delay;
				_request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
				tobj.id=_request(_step);
			}
			function _cancelTween(){
				if(tobj.id==null){return;}
				if(!window.requestAnimationFrame){clearTimeout(tobj.id);
				}else{window.cancelAnimationFrame(tobj.id);}
				tobj.id=null;
			}
			function _ease(t,b,c,d,type){
				switch(type){
					case "linear": case "mcsLinear":
						return c*t/d + b;
						break;
					case "mcsLinearOut":
						t/=d; t--; return c * Math.sqrt(1 - t*t) + b;
						break;
					case "easeInOutSmooth":
						t/=d/2;
						if(t<1) return c/2*t*t + b;
						t--;
						return -c/2 * (t*(t-2) - 1) + b;
						break;
					case "easeInOutStrong":
						t/=d/2;
						if(t<1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
						t--;
						return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
						break;
					case "easeInOut": case "mcsEaseInOut":
						t/=d/2;
						if(t<1) return c/2*t*t*t + b;
						t-=2;
						return c/2*(t*t*t + 2) + b;
						break;
					case "easeOutSmooth":
						t/=d; t--;
						return -c * (t*t*t*t - 1) + b;
						break;
					case "easeOutStrong":
						return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
						break;
					case "easeOut": case "mcsEaseOut": default:
						var ts=(t/=d)*t,tc=ts*t;
						return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
				}
			}
		},
		/* -------------------- */


		/* returns current time */
		_getTime=function(){
			if(window.performance && window.performance.now){
				return window.performance.now();
			}else{
				if(window.performance && window.performance.webkitNow){
					return window.performance.webkitNow();
				}else{
					if(Date.now){return Date.now();}else{return new Date().getTime();}
				}
			}
		},
		/* -------------------- */


		/* stops a tween */
		_stopTween=function(){
			var el=this;
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var props=["top","left"];
			for(var i=0; i<props.length; i++){
				var prop=props[i];
				if(el._mTween[prop].id){
					if(!window.requestAnimationFrame){clearTimeout(el._mTween[prop].id);
					}else{window.cancelAnimationFrame(el._mTween[prop].id);}
					el._mTween[prop].id=null;
					el._mTween[prop].stop=1;
				}
			}
		},
		/* -------------------- */


		/* deletes a property (avoiding the exception thrown by IE) */
		_delete=function(c,m){
			try{delete c[m];}catch(e){c[m]=null;}
		},
		/* -------------------- */


		/* detects left mouse button */
		_mouseBtnLeft=function(e){
			return !(e.which && e.which!==1);
		},
		/* -------------------- */


		/* detects if pointer type event is touch */
		_pointerTouch=function(e){
			var t=e.originalEvent.pointerType;
			return !(t && t!=="touch" && t!==2);
		},
		/* -------------------- */


		/* checks if value is numeric */
		_isNumeric=function(val){
			return !isNaN(parseFloat(val)) && isFinite(val);
		},
		/* -------------------- */


		/* returns element position according to content */
		_childPos=function(el){
			var p=el.parents(".mCSB_container");
			return [el.offset().top-p.offset().top,el.offset().left-p.offset().left];
		},
		/* -------------------- */


		/* checks if browser tab is hidden/inactive via Page Visibility API */
		_isTabHidden=function(){
			var prop=_getHiddenProp();
			if(!prop) return false;
			return document[prop];
			function _getHiddenProp(){
				var pfx=["webkit","moz","ms","o"];
				if("hidden" in document) return "hidden"; //natively supported
				for(var i=0; i<pfx.length; i++){ //prefixed
				    if((pfx[i]+"Hidden") in document)
				        return pfx[i]+"Hidden";
				}
				return null; //not supported
			}
		};
		/* -------------------- */





	/*
	----------------------------------------
	PLUGIN SETUP
	----------------------------------------
	*/

	/* plugin constructor functions */
	$.fn[pluginNS]=function(method){ /* usage: $(selector).mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};
	$[pluginNS]=function(method){ /* usage: $.mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};

	/*
	allow setting plugin default options.
	usage: $.mCustomScrollbar.defaults.scrollInertia=500;
	to apply any changed default options on default selectors (below), use inside document ready fn
	e.g.: $(document).ready(function(){ $.mCustomScrollbar.defaults.scrollInertia=500; });
	*/
	$[pluginNS].defaults=defaults;

	/*
	add window object (window.mCustomScrollbar)
	usage: if(window.mCustomScrollbar){console.log("custom scrollbar plugin loaded");}
	*/
	window[pluginNS]=true;

	$(window).bind("load",function(){

		$(defaultSelector)[pluginNS](); /* add scrollbars automatically on default selector */

		/* extend jQuery expressions */
		$.extend($.expr[":"],{
			/* checks if element is within scrollable viewport */
			mcsInView:$.expr[":"].mcsInView || function(el){
				var $el=$(el),content=$el.parents(".mCSB_container"),wrapper,cPos;
				if(!content.length){return;}
				wrapper=content.parent();
				cPos=[content[0].offsetTop,content[0].offsetLeft];
				return 	cPos[0]+_childPos($el)[0]>=0 && cPos[0]+_childPos($el)[0]<wrapper.height()-$el.outerHeight(false) &&
						cPos[1]+_childPos($el)[1]>=0 && cPos[1]+_childPos($el)[1]<wrapper.width()-$el.outerWidth(false);
			},
			/* checks if element or part of element is in view of scrollable viewport */
			mcsInSight:$.expr[":"].mcsInSight || function(el,i,m){
				var $el=$(el),elD,content=$el.parents(".mCSB_container"),wrapperView,pos,wrapperViewPct,
					pctVals=m[3]==="exact" ? [[1,0],[1,0]] : [[0.9,0.1],[0.6,0.4]];
				if(!content.length){return;}
				elD=[$el.outerHeight(false),$el.outerWidth(false)];
				pos=[content[0].offsetTop+_childPos($el)[0],content[0].offsetLeft+_childPos($el)[1]];
				wrapperView=[content.parent()[0].offsetHeight,content.parent()[0].offsetWidth];
				wrapperViewPct=[elD[0]<wrapperView[0] ? pctVals[0] : pctVals[1],elD[1]<wrapperView[1] ? pctVals[0] : pctVals[1]];
				return 	pos[0]-(wrapperView[0]*wrapperViewPct[0][0])<0 && pos[0]+elD[0]-(wrapperView[0]*wrapperViewPct[0][1])>=0 &&
						pos[1]-(wrapperView[1]*wrapperViewPct[1][0])<0 && pos[1]+elD[1]-(wrapperView[1]*wrapperViewPct[1][1])>=0;
			},
			/* checks if element is overflowed having visible scrollbar(s) */
			mcsOverflow:$.expr[":"].mcsOverflow || function(el){
				var d=$(el).data(pluginPfx);
				if(!d){return;}
				return d.overflowed[0] || d.overflowed[1];
			}
		});

	});

}))}));

angular.module('AuthServices', [ 'ngResource' ]).factory('Auth', function($resource, $rootScope, $window) {

  var auth = {};
  //auth.permissions = {'app.system.user-list':true,'app.system.department-list':false};
  auth.permissions = null;

  auth.init = function(perm) {
    auth.permissions = {};

    angular.forEach(perm, function(item) {
      auth.permissions[item.PageUrl] = item;
    });

    $window.sessionStorage.setItem("authPer", angular.toJson(auth.permissions))
  };

  auth.checkPermissionForView = function(view) {
    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (!view.requiresAuthentication) {
      return true;
    }

    return userHasPermissionForView(view);
  };

  var userHasPermissionForView = function(view) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    return auth.userHasPermission(view.name);
  };

  auth.userHasPermission = function(viewName) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    //console.log('2 permissions=', auth.permissions);
    //console.log('auth.permissions[viewName]=', auth.permissions[viewName]);

    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (auth.permissions == null) {
      return false;
    }

    /* console.log(viewName); */

    if (viewName.indexOf(':') == -1) {
      if (auth.permissions[viewName] == null) {
        //console.log('auth.permissions viewName null');
        //return false;
        return true;
      }

      if (auth.permissions[viewName]['read'] == 'Y') {
        return true;
      }
    } else {
      var view = viewName.split(':')[0];
      var button = viewName.split(':')[1];

      if (auth.permissions[view] == null || auth.permissions[view][button] == null) {
        return false;
      }

      if (auth.permissions[view][button] == 'Y') {
        return true;
      }
    }

    return false;
  };

  auth.currentUser = function() {
    return $window.sessionStorage.user;
  };

  auth.isLoggedIn = function() {
    return $window.sessionStorage.loginUserIdx != null;
  };

  return auth;
});

//"use strict";
/**
 * @ngdoc Service, Directive
 * @since 2020-01-08
 * @description 
 *   데이터를 입력하여 자동으로 화면을 그려주는 서비스
 *   !!!!중요!!!
 *    - fa-pane 을 통해서 화면을 나누었을 시 동일한 이름으로 변수를 지정하면
 *      리스트화면에 autoPage의 데이터를 변경함
 *      그러한 이유로 변수 선언시 리스트는 apL, 상세는 apD로 변수 선언(서로 다르게)
 *      테스트를 해본 건 아니지만 TAB 역시 비슷할 것으로 보임
 * @version 1.0
 * @namespace autoPage
 */

/******************************************************************************** */
// 확장 기능 개발 구간 시작
/******************************************************************************** */
/******************************************************************************** */
// Override 정의 함수
// 지정 함수가 없을 경우  autoPage에서 자동 바인딩
// 함수는 vm에 무조건 연동 
// ex1) vm.getList = function(){};
// ex2) function getList(){}; vm.getList = getList;

// setLayout = fa-pane 기본 구조 설정
// setChangeLayout = fa-pane 레이아웃 변경 버튼 클릭
// getData (getInitData 함수로 통합) = 상세화면 초기 값 호출
// getList (getInitData 함수로 통합) = 리스트화면 데이터 호출
// getListCnt (getInitData 함수로 통합) = 리스트화면 카운트 : MapperId->init->LIST_CNT_SQL 가 있으면 자동제외
// getInitData = 초기 데이터 호출 (MapperId -> init 에서 호출되는 MapperId)
// setSortColumn = 테이블 정렬
// setSortDirect = 정렬 설정에 따른 Grid header Icon 표시 
// setResetSearch = 검색항목 초기화
// setChangeViewSize = 목록 당 조회 건수 변경

// setPageChanged = 페이지 클릭시 호출 함수
// getSearch = 검색 버튼 클릭 시

// goDetail = 상세페이지 이동 (삭제 - 무조건 edit 파일로 가서 disabled, ng-if를 통해 처리하기를 권함) 
// goAdd = 추가페이지 이동

// getExcelFile = 엑셀 다운로드
// setDelList = 리스트 항목 삭제(미구현)


/******************************************************************************** */

/* "use strict"; */
webapp.service('autoPage', 
  ['GLOBAL_CONSTANT', 'StaticVariable', '$rootScope', '$window', '$state', '$stateParams', 'postApi', '$compile', '$interval', '$filter', 'modalFactory', '$timeout', 'gAlert', 'gConfirm', '$translate',
  function autoPage(CONSTANT, StaticVariable, $rootScope, $window, $state, $stateParams, postApi, $compile, $interval, $filter, modalFactory, $timeout, gAlert, gConfirm, $translate) {
    return function(){
      var fns = {
        timeSec : 100,
        datas : {},
        copyVm : {},
        dateInfo : [],
        vaultObj : [],
        tempUploadFile : [],
        uploadFileList : [],
        checkValutUpload : false,
        pageType : { LIST : "LIST", DETAIL : "DETAIL", EDIT : "EDIT", CONTENT : "CONTENT", VIEW : "VIEW",},
        setData : function(DATA) { 
          this.copyVm = angular.copy(DATA.vm);
          this.datas = DATA;
        },
        getData : function() { return this.datas; },
        checkEmptyType : function(type) { return (typeof type == 'undefined') ? true : false; },
        init : function() {
          var D = this.datas;
          var thisObj = this;

          if(D.vm.keyId != undefined) $rootScope.gVariable.listKeyId = D.vm.keyId;

          D.scope.$watch('$viewContentLoaded', function(){
            if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
              D.vm.getInitDataExt();
            }
          });
        },
        initSrchData : function() {
          var D = this.datas;
          if (D.vm.srchMem) {
            angular.copy(D.vm.srchMem, D.vm.srch);
          }
        },
        initView : function() {
          var D = this.datas;
          var thisObj = this;
          if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
            if(D.listStack == undefined || D.listStack == true)
              $rootScope.gVariable.listKeyId = '';
          }
          D.scope.$watch('$viewContentLoaded', function(){
            if (D.FormGroup != undefined && D.FormGroup.length > 0) {
              thisObj.drawFormBox(D);  
            } else {
              D.FormGroup = [];
              thisObj.setModalFn(D);
            }
            
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST && thisObj.checkEmptyType(D.vm.setLayout)) thisObj.setLayout(D);
           
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
              
              if(thisObj.datas.enableListCheck != undefined) {
                thisObj.datas.vm.listCheckboxEnable = thisObj.datas.enableListCheck;
              } else {
                thisObj.datas.vm.listCheckboxEnable = false;
              }
              thisObj.initListTableSortField(D);
              thisObj.initListDefaultVmFnc(D);
              D.vm.listSize = CONSTANT.PAGINATION.NEW_LISTSIZE;
              D.vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
              if (D.vm.headerTitle == '전체 회원 리스트') {
                D.vm.viewSize = 25;
              }
              D.vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
              D.vm.srchList = {};
              D.vm.columnMap = {};
              angular.copy(D.vm.srch, D.vm.srchList);
            } else {
              D.vm.layout = $rootScope.gVariable.layoutBoard;
              $rootScope.gVariable.listKeyId = D.vm.keyId;
              thisObj.initViewDefaultVmFnc(D);
            }

            if(thisObj.checkEmptyType(D.vm.getInitData)) {
              thisObj.initBindingVm(D);
              if(D.pageType.toUpperCase() == thisObj.pageType.VIEW) {
                D.vm.data = {};
              }
              thisObj.getBindInitData(D);
            }
          });
        },
        initViewDefaultVmFnc : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.goList)) {
            D.vm.goList = function() {
              var url = "", param = {};
              if (D.vm.layout == 'N') {
                url = D.PageUrl.LIST_PAGE_URL.url;
              } else {
                url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
              }

              var srch = D.stateParams.srch; // 검색 옵션
              if(url == undefined) {
                if (D.vm.layout == 'N') {
                  url = D.PageUrl.LIST_PAGE_URL;
                } else {
                  url = D.PageUrl.LIST_EDIT_PAGE_URL;
                }
                param = {};
              } else {
                if (D.vm.layout == 'N') {
                  param = D.PageUrl.LIST_PAGE_URL.param;
                } else {
                  param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                }
              }
              if(srch != undefined) param.srch = srch             
              else param.srch = "";
              param = JSON.stringify(param);
              if (D.vm.layout == 'N') {
                if (isNullOrEmpty(D.vm.keyId)) {
                  // 신규등록 -> 목록 화면 이동
                  $state.go(url, JSON.parse(param) , {reload: url});
                } else {
                  $state.go(url, JSON.parse(param) , {reload: url});
                }
              } else {
              }
            };
          }

          if(this.checkEmptyType(D.vm.setDelData)) {
            D.vm.setDelData = function() {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  if (D.vm.data == null) {
                    // 삭제할 데이터 미 존재
                    gAlert('', 'Menu.CANNOTDELETE');
                    return;
                  }

                  var url = "", param = {};
                  url = D.PageUrl.LIST_PAGE_URL.url;
                  var srch = D.stateParams.srch; // 검색 옵션
                  if(url == undefined) {
                    url = D.PageUrl.LIST_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.LIST_PAGE_URL.param;
                  }
                  if(srch != undefined) param.srch = srch
                  else param.srch = "";
                  param = JSON.stringify(param);
                  $state.go(url, JSON.parse(param) , {reload: url});
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            };
          }
        }, 
        initListDefaultVmFnc : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.setResetSearch)) {
            D.vm.setResetSearch = function() {
              D.vm.srch = {};
              D.vm.srch.page = 1;
              D.vm.srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10; // 페이지당 조회건수
              if (D.vm.headerTitle == '전체 회원 리스트') {
                D.vm.srch.viewSize = 25;
              }
              thisObj.getListSearch();
            };
          }
          if(this.checkEmptyType(D.vm.setChangeViewSize)) {
            D.vm.setChangeViewSize = function() {
              if(D.vm.srch) {
                D.vm.srch.page = 1;
              }
              D.vm.currentPage = 1; // 1페이지 부터 조회
              D.vm.viewSize = D.vm.srch.viewSize; // 목록 당 조회 건수
              thisObj.getListSearch();
            };
          }

          if(thisObj.datas.enableListCheck != undefined) {
            if(this.checkEmptyType(D.vm.chkRowChg)) {
              D.vm.chkRowChg = function(data) {
               
              };
            }
            if(this.checkEmptyType(D.vm.chkRowAll)) {
              D.vm.chkRowAll = function() {
                for(var i = 0 ; i < D.vm.lists.length; i++) {
                  D.vm.lists[i].chkRow = D.vm.checkListCheckbox;
                }
              };
            } 
          }

          
          if(this.checkEmptyType(D.vm.getListKeyId)) {
            D.vm.getListKeyId = function() {
              if(D.rootScope != undefined) {
                return D.rootScope.gVariable.listKeyId;
              } else return '';
            };
          }
          

          if(this.checkEmptyType(D.vm.setPageChanged)) {
            D.vm.setPageChanged = function() {
              // D.vm.currentPage = 1; // 1페이지 부터 조회
              // D.vm.viewSize = D.vm.srch.viewSize; // 목록 당 조회 건수
              // thisObj.getListSearch();

              D.vm.srch.page = D.vm.currentPage; // 조회 할 페이지 번호
              D.vm.currentPage = D.vm.currentPage;
              thisObj.getListSearch();
            };
          }

          if(this.checkEmptyType(D.vm.getSearch)) {
            D.vm.getSearch = function() {
              /* var limitedBeforeYear = moment().add(-2, 'years').format("YYYY-MM-DD"); 
              var limitedAfterYear = moment().add(+2, 'years').format("YYYY-MM-DD"); 
              if (D.vm.headerTitle == '전체 회원 리스트') {
                if (D.vm.srch.memberType != 'A') {
                  if (isNullOrEmpty(D.vm.srch.CustNm) && isNullOrEmpty(D.vm.srch.CustCode) && isNullOrEmpty(D.vm.srch.Manager) && isNullOrEmpty(D.vm.srch.RegManage)) {
                    if ((isNullOrEmpty(D.vm.srch.ExpirdDate_Str) || isNullOrEmpty(D.vm.srch.ExpirdDate_End)) && (isNullOrEmpty(D.vm.srch.LockerDate_Str) || isNullOrEmpty(D.vm.srch.LockerDate_End)) && (isNullOrEmpty(D.vm.srch.PayDate_Str) || isNullOrEmpty(D.vm.srch.PayDate_End))) {
                      gAlert('', '입력된 날짜가 없습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if ((D.vm.srch.LockerDate_Str < limitedBeforeYear || D.vm.srch.LockerDate_End > limitedAfterYear)) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if (D.vm.srch.ExpirdDate_Str < limitedBeforeYear || D.vm.srch.ExpirdDate_End > limitedAfterYear) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if (D.vm.srch.PayDate_Str < limitedBeforeYear || D.vm.srch.PayDate_End > limitedAfterYear) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    }
                  }
                }
              } */
              thisObj.getListSearch();
            };
          }

          if(this.checkEmptyType(D.vm.setDelData)) {
            D.vm.setDelData = function() {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn : '',
                fn : function() {
                  var delList = [];
                  angular.forEach(D.vm.lists, function (item) {
                    if(item.chkRow) {
                      delList.push(item.KeyId)
                    }
                  });

                  if (delList.length == 0)
                  {
                    gAlert('', 'Menu.DELETENODATA');
                    return false;
                  }

                  var param = {};
                  param.mapCode = thisObj.datas.MapperId.del;
                  param.KeyIdList = angular.copy(delList);

                  postApi.update(param, function (result) {
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      gAlert('', 'Menu.DELETED', {
                        btn : '',
                        fn : function() {
                          $state.reload();
                        }
                      });
                    }
                  }, function (error) {
                    console.log("error");
                    // console.error("Error> setDelListAction()");
                    // console.table(error);
                  });
                }
              }, {
                btn : '',
                fn : function() {
                }
              });
            };
          }
         
          if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
            
            if(D.MapperId && D.MapperId.excel != undefined) {
              if(this.checkEmptyType(D.vm.getExcelFile)) {
                D.vm.getExcelFile = function() {
                  if(D.vm.lists.length == undefined) {
                    gAlert("","조회 후 엑셀을 다운로드 하십시오.");
                    return;
                  }
                  if(D.vm.lists.length == 0) {
                    gAlert("","Menu.데이터가 없습니다.");
                    return;
                  }
                  var header = [];
                  var a = document.createElement("a");
                  document.body.appendChild(a);
                  var data = angular.copy(D.vm.srch);
                  data.viewSize = 0;
                  data.mapCode = D.MapperId.excel.EXCEL_SQL;

                  if(D.enableListCheck == true) {
                    var ExcelAddList = [];
                    for(var i = 0; i < D.vm.lists.length; i++) {
                      if(D.vm.lists[i].chkRow) {
                        var t = {
                          KeyId : D.vm.lists[i].KeyId
                        }
                        ExcelAddList.push(t);
                      }                      
                    }
                    if(ExcelAddList.length > 0) {
                      data.atList = angular.copy(ExcelAddList);
                    }
                  }

                  postApi.select(data, function (result) {
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      D.scope.jsonToExport = result.body.docs;
                      D.scope.fileName = D.MapperId.excel.EXCEL_TITLE;
                      D.scope.exportData = [];
                      var obj = [];
                      angular.forEach(result.body.desc, function (item) {
                        if(item.ListColumnShowYN == "Y") {
                          obj.push(item.ColumnLogicalNm);
                        }
                      });
                      D.scope.exportData.push(obj);
                      angular.forEach(D.scope.jsonToExport, function(value) {
                        obj = [];
                        angular.forEach(result.body.desc, function(item) {
                          if(item.ColumnLogicalDataType == '40') {
                            if (!isNullOrEmpty(value[item.ColumnPhysicalAsNm])) {
                              obj.push(moment(value[item.ColumnPhysicalAsNm]).toDate());
                            } else {
                              obj.push(value[item.ColumnPhysicalAsNm]);
                            }
                          } else {
                            obj.push(value[item.ColumnPhysicalAsNm]);
                          }
                        });
                        D.scope.exportData.push(obj);
                      });     
                      $rootScope.excelDown(D.scope.exportData,D.MapperId.excel.EXCEL_TITLE);
                    }
                  }, function (error) {
                    // 조회 중 오류 발생
                    console.log("error");
                    // console.error("Error> getExcelFile()");
                    // console.table(error);
                  });
                }
              }
            }
  
            if(this.checkEmptyType(D.vm.goEdit)) {
              D.vm.goEdit = function(p) {
                var srch = D.stateParams.srch; // 검색 옵션
                //D.vm.KeyId = p.KeyId;
  
                try {
                  var url = "", param = {};
                  if (D.vm.layout == 'N') {
                    // 등록/수정 화면 이동
                    url = D.PageUrl.EDIT_PAGE_URL.url; 
                    if(url == undefined) {
                      url = D.PageUrl.EDIT_PAGE_URL;
                      param = {};
                    } else {
                      param = D.PageUrl.EDIT_PAGE_URL.param;
                    }
                  } else {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
                    if(url == undefined) {
                      url = D.PageUrl.LIST_EDIT_PAGE_URL;
                      param = {};
                    } else {
                      param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                    }
                  }
                  
                  if(param == undefined) param = {};
                  if(srch != undefined) param.srch = srch
                  else param.srch = "";
                  if(!isNullOrEmpty(p.KeyId)) {
                    param.KeyId = p.KeyId;
                    param.keyId = p.KeyId;
                  } else {
                    param.KeyId = p.keyId;
                    param.keyId = p.keyId;
                  }
                                    
                  param = JSON.stringify(param);              
                  $state.go(url, JSON.parse(param) , {reload: url});
                } catch (e) {
                  console.log("error");
                  // console.error("PageUrl.EDIT_PAGE_URL 을 추가 하시거나 goEdit 함수를 오버라이드 하세요.");
                }
                
              };
            }
  
            if(this.checkEmptyType(D.vm.goAdd)) {
              D.vm.goAdd = function(keyId) {
                keyId = '';
                var srch = D.stateParams.srch; // 검색 옵션
                D.vm.keyId = keyId;
         
                var url = "", param = {};
                if (D.vm.layout == 'N') {
                  // 등록/수정 화면 이동
                  url = D.PageUrl.EDIT_PAGE_URL.url;
                  if(url == undefined) {
                    url = D.PageUrl.EDIT_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.EDIT_PAGE_URL.param;
                  }
                } else {
                  url = D.PageUrl.LIST_EDIT_PAGE_URL.url; 
                  if(url == undefined) {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                  }
                }
                
                if(param == undefined) param = {};
                if(srch != undefined) param.srch = srch
                else param.srch = "";
                param.keyId = keyId;
                param = JSON.stringify(param);              
                $state.go(url, JSON.parse(param) , {reload: url});
              }
            }
  
            D.vm.listToPage = function(data) {

              D.vm.keyId = data.KeyId;
              try {
                if(D.PageUrl.LIST_DETAIL_PAGE_URL != undefined) {
                  //D.vm.goDetail(keyId);
                  D.vm.goEdit(data);
                } else {
                  D.vm.goEdit(data);
                }
              } catch(e) {
                D.vm.goEdit(data);
              }
              
            }
          }
        },
  
        initListTableSortField : function(D) {
          var thisObj = this;
  
          if(this.checkEmptyType(D.vm.setSortColumn)) {
            D.vm.setSortColumn = function(sortColumn, isSortable, liCol) {
              if (isSortable == 'N') return;
              // 정렬순서(오름차순, 내림차순) 설정
              if (D.vm.srch.sortColumn != sortColumn) {
                D.vm.srch.sortDirect = "ASC";
              } else if (D.vm.srch.sortColumn == sortColumn){ 
                if(D.vm.srch.sortDirect == "ASC") {
                  D.vm.srch.sortDirect = "DESC"
                } else {
                  D.vm.srch.sortDirect = "ASC"
                }
              } else {
                D.vm.srch.sortDirect = (D.vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
              }
              D.vm.srch.sortColumn = sortColumn;
              thisObj.getListSearch();
            }
          }
  
          if(this.checkEmptyType(D.vm.setSortColumn)) {
            D.vm.setSortDirect = function(sortColumn) {
              if (sortColumn != D.vm.srch.sortColumn) {
                return 'fa fa-sort';
              }
              var rtnval = '';
              // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
              (D.vm.srch.sortDirect == 'ASC') ? rtnval = 'fa fa-caret-down' : rtnval = 'fa fa-caret-up';
              
              return rtnval;
            }
          }
        },
        getListSearch : function() {
          var thisObj = this;
          var D = thisObj.datas;
          var srch = D.vm.srch; // 검색 옵션
          var url = null;
          var param = {};
          var listStack = true;
          if(D.listStack != undefined) listStack = D.listStack;

          if(listStack) {
            url = D.PageUrl.LIST_PAGE_URL.url; 
            if(url == undefined) {
              url = D.PageUrl.LIST_PAGE_URL;
              param = {};
            } else {
              param = D.PageUrl.LIST_PAGE_URL.param;
            }    
            if(param == undefined) param = {};
            if(srch != undefined) {
              for(var i = 0; i < this.dateInfo.length; i++) {
                var at = this.dateInfo[i].key.replace("vm.","");
                if(at.indexOf("_Str") != -1) {
                  srch[at] = $filter('localToUtc')(srch[at],'from');
                } 
                if(at.indexOf("_End") != -1) {
                  srch[at] = $filter('localToUtc')(srch[at],'to');
                }
              }
              param.srch =  encodeURIComponent(JSON.stringify(srch));
            } else { 
              param.srch = "";
            }
            param = JSON.stringify(param);          
            $state.go(url, JSON.parse(param) , {reload: url});
          } else {
            this.getBindListDataExt(D, "List");
          }
        },
        select : function(data, callback) {
          postApi.select(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) 
              callback(result.body.docs);
          }, function(error) {
            console.table(error);
          });
        },
        commit : function(data, callback) {
          
          var thisObj = this;
          var D = thisObj.datas;

          if(D.pageType == undefined) {
            var thisObj = this;
            var D = thisObj.datas;
            var count = 0;
            try {
              var interval = $interval(function(){
                if(!thisObj.checkValutUpload) {
                  thisObj.checkValutUpload = true;
                  if(thisObj.vaultObj.length > 0) {
                    if( (count) == thisObj.vaultObj.length) {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    } else {
                      uploadVaultFile(thisObj.vaultObj[count]);
                    }
                    count++;
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }
                } else {
                  thisObj.checkValutUpload = false;
                  $interval.cancel(interval);
                  thisObj.saveContentData(data, callback);
                }          
              },500);
            } catch (e) {
              $interval.cancel(interval);
              console.table(e);
            }
          } else {
            if(D.pageType.toUpperCase() != this.pageType.LIST) {
              var thisObj = this;
              var D = thisObj.datas;
              var count = 0;
              try {
                var interval = $interval(function(){
                  if(!thisObj.checkValutUpload) {
                    thisObj.checkValutUpload = true;
                    if(thisObj.vaultObj.length > 0) {
                      if( (count) == thisObj.vaultObj.length) {
                        thisObj.checkValutUpload = false;
                        $interval.cancel(interval);
                        thisObj.saveContentData(data, callback);
                      } else {
                        uploadVaultFile(thisObj.vaultObj[count]);
                      }
                      count++;
                    } else {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    }
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }          
                },500);
              } catch (e) {
                $interval.cancel(interval);
                console.table(e);
              }
            } else {
              var thisObj = this;
              var D = thisObj.datas;
              var count = 0;
              try {
                var interval = $interval(function(){
                  if(!thisObj.checkValutUpload) {
                    thisObj.checkValutUpload = true;
                    if(thisObj.vaultObj.length > 0) {
                      if( (count) == thisObj.vaultObj.length) {
                        thisObj.checkValutUpload = false;
                        $interval.cancel(interval);
                        thisObj.saveContentData(data, callback);
                      } else {
                        uploadVaultFile(thisObj.vaultObj[count]);
                      }
                      count++;
                    } else {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    }
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }          
                },500);
              } catch (e) {
                $interval.cancel(interval);
                console.table(e);
              }
              }
          }
        },
        saveContentData : function(data, callback) {
          var thisObj = this;
          var D = thisObj.datas;
          data = angular.copy(data);

          // data에 keyId가 넘어왔을 경우에는 vm 이 아닌
          // 넘겨온 데이터를 기준으로 key값을 조회한다.
          var checkUpdate = false;
          if(data != undefined) {
            if(!isNullOrEmpty(data.keyId)) {
              checkUpdate = true;
              data.KeyId = data.KeyId;
            } else if(!isNullOrEmpty(data.KeyId)) {
              checkUpdate = false;
              data.keyId = data.KeyId;
            }

            var uploadFileData = [];          
            for(var i = 0; i < thisObj.uploadFileList.length; i++) {
              var at = thisObj.uploadFileList[i];
              for(var j = 0; j < at.length; j++) {
                if(at[j].tmpLink) {
                  at[j].grpId = i+1;
                  uploadFileData.push(at[j]);
                } else if (at[j].delState == "delete") {
                  uploadFileData.push(at[j]);
                }
              }
            }
            data.uploadFileList = [];
            angular.forEach(uploadFileData, function(item) {
              D.vm.data.uploadFileList.push(item);
            });

            for(var i = 0; i < thisObj.dateInfo.length; i++) {            
              var at = thisObj.dateInfo[i];
              if(at.type == "date") {
                var keyObj =  thisObj.getStrObjectValue(D, at.bindKey);
                data[at.key.replace("vc.","").replace("vm.","")] = keyObj;
              } else {
                var keyObj =  thisObj.getStrObjectValue(D, at.key);
                var utcDate = null;
                if (!at.datetype) {
                  utcDate = $filter('localToUtc')(keyObj);
                  data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                } else {
                  if(Array.isArray(at.datetype)) {
                    for(var k = 0; k < at.datetype.length; k++) {
                      utcDate = $filter('localToUtc')(keyObj, at.datetype[k]);
                      data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                    }
                  } else {
                    utcDate = $filter('localToUtc')(keyObj, at.datetype);
                    data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                  }
                }
              }
            }
            
            if (isNullOrEmpty(data.keyId) && isNullOrEmpty(data.KeyId)) {
              checkUpdate = false;
            } else {
              checkUpdate = true;
              if(isNullOrEmpty(data.KeyId)) {
                data.KeyId = data.keyId;
              }
            }

          } else {

            var uploadFileData = [];          
            for(var i = 0; i < thisObj.uploadFileList.length; i++) {
              var at = thisObj.uploadFileList[i];
              for(var j = 0; j < at.length; j++) {
                if(at[j].tmpLink) {
                  at[j].grpId = i+1;
                  uploadFileData.push(at[j]);
                } else if (at[j].delState == "delete") {
                  uploadFileData.push(at[j]);
                }
              }
            }
            D.vm.data.uploadFileList = [];
            angular.forEach(uploadFileData, function(item) {
              D.vm.data.uploadFileList.push(item);
            });

            for(var i = 0; i < thisObj.dateInfo.length; i++) {            
              var at = thisObj.dateInfo[i];
              if(at.type == "date") {
                var keyObj =  thisObj.getStrObjectValue(D, at.bindKey);
                data[at.key.replace("vc.","").replace("vm.","")] = keyObj;
              } else {
                var keyObj =  thisObj.getStrObjectValue(D, at.key);
                var utcDate = null;
                if (!at.datetype) {
                  utcDate = $filter('localToUtc')(keyObj);
                  data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                } else {
                  if(Array.isArray(at.datetype)) {
                    for(var k = 0; k < at.datetype.length; k++) {
                      utcDate = $filter('localToUtc')(keyObj, at.datetype[k]);
                      data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                    }
                  } else {
                    utcDate = $filter('localToUtc')(keyObj, at.datetype);
                    data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                  }
                }
              }
            }
            
            if (isNullOrEmpty(D.vm.keyId) && isNullOrEmpty(D.vm.KeyId)) {
              checkUpdate = false;
            } else {
              checkUpdate = true;
              if(isNullOrEmpty(D.vm.KeyId)) {
                D.vm.KeyId = D.vm.KeyId;
              }
            }
          }

          var toastMsg = '';
          if(data.toastMsg != undefined) {
            toastMsg = data.toastMsg;
          }

          if (!checkUpdate) {
            // 신규 등록
            var param = {};
            if(data == undefined) {
              param = angular.copy(D.vm.data);
            } else {
              param = angular.copy(data);
            }

            if(data != undefined) {
              // if(!isNullOrEmpty(data.mapCode)) {
              // } else if(!isNullOrEmpty(data.KeyId)) {
              //   param.mapCode = D.MapperId.insert;
              // }
              if(typeof(data.mapCode) != 'string' ) {
                if(data.mapCode.insert == undefined) {
                  var result = {};
                  result.header = {status:405, msg: "This service requires a 'mapCode.insert' key for data."};
                  result.body = {};
                  console.log("error");
                  // console.error(result.header);
                } else {
                  param.mapCode = data.mapCode.insert;    
                }
              } else {
                param.mapCode = data.mapCode;
              }

            } else {
              param.mapCode = D.MapperId.insert;
            }

           
            postApi.insert(param, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                //D.vm.goList();
                //keyId
                //if(data == undefined) {
                  D.vm.keyId = result.body.docs[0].RelateDataId;
                //}
 
                if(toastMsg != "") {
                  $rootScope.showSimpleToast(toastMsg);
                }

                if(callback != undefined) {
                  callback(result);
                  return;
                } else {
                  var url = "", param = {};
                  url = D.PageUrl.LIST_PAGE_URL.url;
                  if (D.vm.layout == 'N') {
                    url = D.PageUrl.EDIT_PAGE_URL.url;
                  } else {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
                  }
                  var srch = D.stateParams.srch; // 검색 옵션
                  
                  if(url == undefined) {
                    if (D.vm.layout == 'N') {
                      url = D.PageUrl.EDIT_PAGE_URL;
                      param = {};
                    } else {
                      url = D.PageUrl.LIST_EDIT_PAGE_URL;
                      param = {};
                    }
                  } else {
                    if (D.vm.layout == 'N') {
                      param = D.PageUrl.EDIT_PAGE_URL.param;
                    } else {
                      param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                    }
                  }
                  
                  param.keyId = D.vm.keyId;
                  param.srch = "";
                  param = JSON.stringify(param);

                  $state.go(url, JSON.parse(param) , {reload: url});
                }

                // 테스트해봐야함
              } else {
                console.log("error");
                // console.error("Error> commit.InsertData()");  
              }
            }, function (error) {
              console.log("error");
              // console.error("Error> setData()");
              // console.table(error);
            });
          } else {
          // 수정
           
            var param = {};
            if(data == undefined) {
              param = angular.copy(D.vm.data);
            } else {
              param = angular.copy(data);
            }

            if(data != undefined) {
              if(typeof(data.mapCode) != 'string' ) {
                if(data.mapCode.update == undefined) {
                  var result = {};
                  result.header = {status:405, msg: "This service requires a 'mapCode.update' key for data."};
                  result.body = {};
                  console.log("error");
                  // console.error(result.header);
                } else {
                  param.mapCode = data.mapCode.update;    
                }
              }
            } else {
              param.mapCode = D.MapperId.update;
            }


            postApi.update(param, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {

                if(toastMsg != "") {
                  $rootScope.showSimpleToast(toastMsg);
                } else {
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                }
                // gAlert("", "Menu.SAVED", {
                //   btn: "",
                //   fn: function () {
                    // 화면 분할 모드에 따른 이동
                    if(callback != undefined) {
                      callback(result);
                      return;
                    } else {
                      $state.reload();
                    }
                //   }
                // });
              }
            }, function (error) {
              console.log("error");
              // console.error("Error> setData()");
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          }
          
        },
        getBindInitData : function(D) {
          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            this.getBindListDataExt(D, "List");
          } else if(D.pageType.toUpperCase() == this.pageType.DETAIL) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.EDIT) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.VIEW) {
            this.getBindListDataExt(D, "Edit");
          } 
        },
        setChangeDateUTC : function(D) {
          var srch = angular.copy(D.vm.srch);
          var srchKeys = Object.keys(srch);

          if(D.FormGroup != undefined) {
            for(var i = 0 ; i < srchKeys.length; i++) {
              for(var j = 0 ; j < D.FormGroup.length; j++) {
                var field = D.FormGroup[j].field;
                if(!field) field = [];
                for(var k = 0 ; k < field.length; k++) {
                  var at = field[k], bindKey = at.bindKey, type = at.type;
                  var utcYn = (at.utcYn != undefined) ? utcYn = at.utcYn : utcYn = false;
                  if(type == "date" && utcYn) {                  
                    if(Array.isArray(bindKey)) {
                      for(var l = 0; l < bindKey.length; l++) {
                        var bindKey2 = bindKey[l].split(".");
                        bindKey2 = bindKey2[bindKey2.length-1];
                        if(srchKeys[i] == bindKey2) {                 
                          if(bindKey2.indexOf("From") != -1) {
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'from');
                          } else if(bindKey2.indexOf("to") != -1) {
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'to');
                          } else{
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]]);
                          }
                        }
                      }
                    } else {
                      bindKey = bindKey.split(".");
                      bindKey = bindKey[bindKey.length-1];
                      if(srchKeys[i] == bindKey) {                       
                        if(bindKey.indexOf("From") != -1) {
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'from');
                        } else if(bindKey.indexOf("to") != -1) {
                          if(srch[srchKeys[i]].indexOf(" ")== -1)
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'to');
                        } else {
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]]);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          return angular.copy(srch);
        },
        getBindListDataExt : function(D, selectType) {
          var thisObj = this, multyParm = [];
          
          D.vm.dataloader = true;
          var dataExtendMqpper = [];
          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            D.vm.srch.selectType = selectType;
            var params = this.setChangeDateUTC(D);
            if(D.listParam) {
              var listParamKeys = Object.keys(D.listParam);
              for(var i = 0; i < listParamKeys.length; i++) {
                params[listParamKeys[i]] = D.listParam[listParamKeys[i]];
              }
            }

            if(D.MapperId) {
              multyParm = [
                {mapCode : D.MapperId.init.LIST_CNT_SQL, param : params},
                {mapCode : D.MapperId.init.LIST_SQL, param : params},
              ];
            } else {
              multyParm = [];
            }
          } else {
            // 상세페이지 전용, 현재 else로 처리 했지만 추가적인 부분일 경우에는 else if로 변경 필요
            D.vm.data = {};
            D.vm.srchDetail = {};
            D.vm.srchDetail.IdName = D.keyColumnNm;
            D.vm.srchDetail.tableNm = D.keyTableNm;
            if(D.MapperId != undefined)
              D.vm.srchDetail.mapCode = D.MapperId.init.VIEW_SQL.mapCode;
            D.vm.srchDetail.keyId = D.keyId;
            D.vm.srchDetail.selectType = selectType;
            D.vm.srchDetail.uploadFileList = [];
            
            if(D.MapperId == undefined) {
              if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                D.vm.getInitDataExt();
              }
              return;
            }
            
            var baseParam = {
              mapCode : D.vm.srchDetail.mapCode,
              param : D.vm.srchDetail
            }
            multyParm.push(baseParam);

            var keys = Object.keys(D.MapperId.init);
            for(var i = 0; i < keys.length; i++) {
              if(keys[i] != 'VIEW_SQL') {
                var data = D.MapperId.init[keys[i]];
                if(data.param == undefined) data.param = {};
                data.MapperId = keys[i];
                dataExtendMqpper.push(data);
              }
            }

            D.vm.showUploader = enableUploadComponent();
            if(this.checkEmptyType(D.vm.onFileCallback)) {

              D.vm.onFileCallback = {
                onFileUploaded: function (id, result) {
                  var bindFile = thisObj.datas.MapperId.init.VIEW_SQL.bindFile;                  
                  angular.forEach(result.body.docs, function (item) {
                    var obj = item;
                    obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
                    
                    for(var i = 0; i < bindFile.length; i++) {
                      if(bindFile[i].vault == id) {
                        thisObj.uploadFileList[i].push(obj);
                      }
                    }
                  });
                },
                onFileUploadComplete: function (id) {
                  thisObj.checkValutUpload = false;

                },
                onFileDelete: function (item) {
                },
                onLoaded: function (id, vault) {
                  D.vm[id] = vault;
                  thisObj.vaultObj.push(D.vm[id]);
                }
              };
            }

            for(var i = 0; i < keys.length; i++) {
              if(typeof(D.MapperId.init[keys[i]]) == "object") {
                var at = D.MapperId.init[keys[i]];
                if(at.bindFile != undefined) {
                  var atKeys = Object.keys(at.bindFile);
                  for(var j = 0; j < atKeys.length; j++){
                    if(at.bindFile[atKeys[j]].vault != undefined) {
                      initVaultComponent(at.bindFile[atKeys[j]].vault.replace("#", "").replace(".", ""), D.vm.onFileCallback);
                    }
                  }
                }
              }
            }
            
          }
          D.vm.columnMap = [];
          
          this.postApi(D, multyParm, function(){
            D.vm.srchMem = angular.copy(D.vm.srch);

            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {

            } else {

              if(dataExtendMqpper.length > 0) {
                thisObj.postApi(D, dataExtendMqpper);
              }
            }

          });
        },
        getData : function(param, callback) {
          var thisObj = this, D = this.datas;

          postApi.select(param, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var columnMap = {};
              if (result.body.desc.length > 0) {
                // MetaColumn 정보를 이용하여 표시할 목록 정보 설정                
                angular.forEach(result.body.desc, function (item) {
                  columnMap[item.ColumnPhysicalAsNm] = item;
                });
                result.columnMap = columnMap;
              } 
              callback(result);
            }
          });
          

        },
        postApi : function(D, multyParm, callback) {
          var thisObj = this;

          postApi.select(multyParm, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
  
              if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
                if(D.MapperId.init.LIST_CNT_SQL == result.mapCode) {
                  //(result.body.docs.length > 0) ? D.vm.totalItems = result.body.docs[0] : D.vm.totalItems = 0;
                  if (result.body.docs.length > 0) {
                    D.vm.totalItems = result.body.docs[0];
                  }
                } else if(D.MapperId.init.LIST_SQL == result.mapCode) {

                  if (D.vm.headerTitle == '전체 회원 리스트') {
                    if(isNullOrEmpty(D.vm.srch.memberType)) {
                      D.vm.srch.memberType = 'A';
                    }
                    if(isNullOrEmpty(D.vm.srch.AttendanceType)) {
                      D.vm.srch.AttendanceType  = '';
                    }
                    if(isNullOrEmpty(D.vm.srch.Gender)) {
                      D.vm.srch.Gender  = '';
                    }
                    if(isNullOrEmpty(D.vm.srch.Age)) {
                      D.vm.srch.Age  = '';
                    }
                  }
                  if (result.body.desc.length > 0) {
                    // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
                    D.vm.listColumns = result.body.desc;
                    angular.forEach(D.vm.listColumns, function (item) {
                      D.vm.columnMap[item.ColumnPhysicalAsNm] = item;
                    });
                  } else {
                    var srch = angular.copy(D.vm.srch);
                    srch.mapCode = result.mapCode;
                    var check = [];
                    if(result.body.desc.length == 0) check.push("desc.length = 0");
                    srch.checkMsg = check;
                  }
                  if (result.body.docs.length > 0 && !isNullOrEmpty(D.vm.listColumns)) {
                    D.vm.lists = result.body.docs;
                   
                    var resList = [];
                    var res = '';
                    if (D.vm.lists != null) {
                      angular.forEach(D.vm.lists, function (item) {
                        resList = [];
                        if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                          res = item.Addr1;
                          resList = res.split(" ");
                          item.Addr = resList[0] + " " + resList[1];
                        }
                      });
                    }
                  } else if (result.body.docs.length > 0 && isNullOrEmpty(D.vm.listColumns)) {
                    D.vm.lists = result.body.docs;
                  } else {
                    D.vm.lists = [];
                  }
                  if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                    D.vm.getInitDataExt(result.body);
                  }
                  $timeout(function(){
                    D.vm.dataloader = false;
                  }, thisObj.timeSec); 
                  //D.vm.dataloader = false;
                }
                D.vm.SearchConditionStr = getSearchConditionStr(D.vm.totalItems);
              } else { // VIEW PAGE
  
                if(D.MapperId.init.VIEW_SQL.mapCode == result.mapCode) {
                  if (result.body.desc.length > 0) {
                    // 사용자정의 컬럼 설정
                    D.vm.allColumns = result.body.desc;
                    
                    angular.forEach(D.vm.allColumns, function (item) {
                      D.vm.columnMap[item.ColumnPhysicalAsNm] = item;
                    });
                  }
  
                  if(result.body.docs.length == 0) {
                    D.vm.data = {};
                    if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                      D.vm.getInitDataExt(result.body);
                    }
                  } else {
                    D.vm.data = result.body.docs[0];  
                  
                    if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                      D.vm.getInitDataExt(result.body);
                    }
                    if(result.body.docs[0].uploadFileList != undefined && result.body.docs[0].uploadFileList.length > 0) {
                      
                      thisObj.changeUtcToLocal(D, D.vm.data, result.mapCode);

                      var bindKey = D.MapperId.init.VIEW_SQL.bindFile[0].bindKey;
                      if(bindKey != undefined && bindKey != "") {
                        bindKey = bindKey.split(".")[1];
                        D.vm[bindKey] = [];
                      }

                      angular.forEach(D.vm.data.uploadFileList, function (item) {
                        var obj = {
                          id: item.fileId,
                          isLoaded: true,
                          link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                          fileName: item.LogicalFileNm,
                          size: item.FileSize,
                          fileKey: item.PhysicalFileNm,
                          grpId : item.GrpId,
                          path: item.PhysicalPath,
                          downloadCnt: item.DownloadCnt,
                        };
                        
                        D.vm[bindKey].push(obj);
                      });

                      thisObj.uploadFileList.push(D.vm[bindKey]);
    
                    }
                  }
                } else {
                  // 기본 mapperID 가 아닌 경우
                  for(var i = 0; i < multyParm.length; i++) {
                    if(multyParm[i].mapCode == result.mapCode) {

                      // 시큐어코딩으로 주석 후 수정 (2023-07-06 )
                      // var fnc =  eval("D."+ multyParm[i].callback);
                      var fnc =  D[multyParm[i].callback];

                      fnc(result.body)
                    }
                  }
                }

                $timeout(function(){
                  D.vm.dataloader = false;
                }, thisObj.timeSec); 
                //D.vm.dataloader = false;
              }
            } else {

              if(D.pageType.toUpperCase() == thisObj.pageType.LIST && D.MapperId.init.LIST_SQL == result.mapCode) {
                if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                  D.vm.getInitDataExt(result);
                }
              };
              if(D.pageType.toUpperCase() == thisObj.pageType.VIEW && D.MapperId.init.VIEW_SQL.mapCode == result.mapCode) {
                if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                  D.vm.getInitDataExt(result);
                }
              }
            }
            if(callback != undefined) callback();

            if (D.MapperId.init.LIST_CNT_SQL != result.mapCode) {
              $timeout(function(){
                D.vm.dataloader = false;
              }, thisObj.timeSec);
            }
            //D.vm.dataloader = false; // Progressbar 숨김

    
          }, function (error) {
            $timeout(function(){
              D.vm.dataloader = false;
            }, thisObj.timeSec); 
            //D.vm.dataloader = false; // Progressbar 숨김
            console.table(error);
          });

        },
        changeUtcToLocal : function(D, data, mapCode) {
          var thisObj = this;
          for(var i = 0; i < thisObj.dateInfo.length; i++) {
            if(mapCode == thisObj.dateInfo[i].mapCode) {
              var at = thisObj.dateInfo[i];
              if(data[at.key] != undefined) {
                thisObj.setStrObjValue(D, "vm." + at.key , moment(data[at.key]).toDate());
              }
            }
          }
        },
        changeLocalToUtc : function(D, data, mapCode) {
          
        },
        convCamelCase : function(str) {
          var id = str;
          var convId = '';
          if( id == null) id = $(input).eq(i).attr("ng-model");
          if(id == null) {}
          id = id.split(".");
          for(var j = 0; j < id.length; j++)
            convId += id[j].charAt(0).toUpperCase() + id[j].substring(1, id[j].length);
          convId = convId+ "_" + i;
          if( $(input).eq(i).attr("id")  != "" && $(input).eq(i).attr("id")  != undefined) {
            convId = $(input).eq(i).attr("id") ;
          }
          return convId;
        },
        initBindingVm : function(D) {
          D.vm.headerTitle = D.headerTitle;

          var srchData = { keyTableNm : D.keyTableNm, keyColumnNm: D.keyColumnNm, srch : D.stateParams.srch };
          D.vm.srch = this.makeSrchData(srchData, D);
          if(D.srch != undefined) {
            var srchKey = Object.keys(D.srch);
            var vmSrchKey = Object.keys(D.vm.srch);
            for(var i= 0; i < srchKey.length; i++) {
              var check = true;
              for(var j = 0; j < vmSrchKey.length; j++) {
                if(srchKey[i] == vmSrchKey[j]) {
                  check = false;
                  break;
                }
              }
              if(check) {
                D.vm.srch[srchKey[i]] = D.srch[srchKey[i]];
              }
            }
          }

          // 2020.03.14 edit에서 검색된 값이 검색에 영향을 미치는 부분이 있음
          // 리스트 서치 박스에서 keyId가 있다면 자동 바인딩이 될 것임으로
          // 구지 등록 할 필요가 없을 것으로 보임
          // if( !isNullOrEmpty(D.vm.keyId)) {
          //   D.vm.srch.KeyId = D.vm.keyId;
          // } else if( !isNullOrEmpty(D.vm.KeyId)) {
          //   D.vm.srch.KeyId = D.vm.KeyId;
          // }

          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            // List 일 경우 기본적으로 srch를 기준으로 작업이 됩
            
          } else if(D.pageType.toUpperCase() == this.pageType.DETAIL) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.EDIT) {
  
          } 
          //$timeout(function(){
          //  D.vm.dataloader = false;
          //}, this.timeSec); 
          //D.vm.dataloader = false;
        },
        makeSrchData : function(srchData, D) {
          var srch = {}
          if (!D.stateParams.srch) {
            var temp = {};
            (!isNullOrEmpty(srchData.keyTableNm)) ? temp.keyTableNm = srchData.keyTableNm : temp.keyTableNm = D.keyTableNm; // 작업테이블명
            (!isNullOrEmpty(srchData.sortDirect)) ? temp.sortDirect = srchData.sortDirect : temp.sortDirect = ""; // 정렬순서 (ASC:오름차순, DESC:내림차순)
            (!isNullOrEmpty(srchData.sortColumn)) ? temp.sortColumn = srchData.sortColumn : temp.sortColumn = ""; // 정렬컬럼명
            (!isNullOrEmpty(srchData.keyColumnNm)) ? temp.keyColumnNm = srchData.keyColumnNm : temp.keyColumnNm = ""; // 정렬컬럼명

            srch.page = 1;
            srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10; // 페이지당 조회건수
            if (D.vm.headerTitle == '전체 회원 리스트') {
              srch.viewSize = 25;
            }
            srch.tableNm = temp.keyTableNm;
            srch.sortDirect = temp.sortDirect;
            srch.sortColumn = temp.sortColumn;
          } else {
            srch = JSON.parse(decodeURIComponent(D.stateParams.srch));
            srch.tableNm = D.keyTableNm;
            var srchKeys = Object.keys(srch);
            
            if(srch.page != undefined) {
              D.vm.currentPage = srch.page;
            }
            
            if(srch.viewSize != undefined) {
              D.vm.viewSize = srch.viewSize;
            }

            if(D.FormGroup != undefined) {
              for(var i = 0 ; i < srchKeys.length; i++) {
                for(var j = 0 ; j < D.FormGroup.length; j++) {
                  var field = D.FormGroup[j].field;
                  if(!field) field = [];
                  for(var k = 0 ; k < field.length; k++) {
                    var at = field[k], bindKey = at.bindKey, type = at.type, key = at.key;
                    var utcYn = (at.utcYn != undefined) ? utcYn = at.utcYn : utcYn = false;
                    if(type == "date" && utcYn) {                    
                      if(Array.isArray(bindKey)) {
                        for(var l = 0; l < bindKey.length; l++) {
                          var bindKey2 = bindKey[l].split(".");
                          bindKey2 = bindKey2[bindKey2.length-1];
                          if(srchKeys[i] == bindKey2) {     
                          D.vm[bindKey2] = moment(srch[srchKeys[i]]).toDate();
                          }
                        }
                      } else {
                        bindKey = bindKey.split(".");
                        bindKey = bindKey[bindKey.length-1];
                        if(srchKeys[i] == bindKey) {         
                          D.vm[bindKey] = moment(srch[srchKeys[i]]).toDate();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var result = angular.copy(srch);
          return result;
        },
  
        setLayout : function(D) {
          if(!D.vm.layout) {
            D.vm.layout = $rootScope.gVariable.layoutBoard;
          }
          this.initChangeLayout(D);
        },
        initChangeLayout : function(D) {
          var thisObj = this;
          var vm = D.vm;
          switch (vm.layout) {
            case "H":
              // 수평
              vm.anchor = "north";
              vm.paneMin = "300px";
              break;
            case "V":
              // 수직
              vm.anchor = "west";
              vm.paneMin = "600px";
              break;
            case "N":
              // 기본
              vm.anchor = "";
              vm.paneMin = "600px";
              break;
          }
  
          vm.setChangeLayout = function(layout, vc) {
            var vm = D.vm;
            $window.sessionStorage.setItem('layoutBoard', layout);
            $rootScope.gVariable.layoutBoard = layout;
            var srch = vc.srch; // 검색 옵션
            var url = null;
            var param = {};
            url = D.PageUrl.LIST_PAGE_URL.url; 
            if(url == undefined) {
              url = D.PageUrl.LIST_PAGE_URL;
              param = {};
            } else {
              param = D.PageUrl.LIST_PAGE_URL.param;
            }    
            if(param == undefined) param = {};
            if(srch != undefined) param.srch =  encodeURIComponent(JSON.stringify(srch));
            else param.srch = "";
            param = JSON.stringify(param);
            $state.go(url, JSON.parse(param) , {reload: url});
          };
        },
        getObjFieldType : function (type, colClass, layout) {
  
          var thisObj = this;
          var formType = "inner";
          var $elemForm = $("<div />", {class : "form-group form-inner-label"});

          if(layout == undefined) {
            if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
              $elemForm = $("<div />", {class : "form-group form-inline"});
              formType = "inline";
            }
          } else {
            if(layout == mElemTx.layout.inline) {
              $elemForm = $("<div />", {class : "form-group form-inline"});
            } 
            formType = layout;
          }

          if(type == "date" || type.toLowerCase() == "datetime") {
  
            var $elemDateGroup = $("<div />", {class : "input-group", "ng-controller":"DatepickerDemoCtrl"});
            var $elemDateInput = $("<input />", {
              class: "form-control", "clear-text" : "취소", "close-text" : "닫기", "current-text" : "오늘", "datepicker-options" : "dateOptions", "is-open" : "opened", "ng-change" : "", "ng-model":"", "ng-required": "false",
              "placeholder":"", "type":"text", "uib-datepicker-popup" : "{{ :: format}}"
            });
            var $elemDateSpan = $("<span />", { class : "input-group-btn" })
            var $elemDateButton = $("<button />", { class : "btn btn-default", "ng-click" : "open($event)", type : "button" });
            var $elemDateIco =  $("<i />", { class : "glyphicon glyphicon-calendar" });

            $elemDateButton.html($elemDateIco.clone());
            $elemDateSpan.html($elemDateButton.clone());
            if(formType == "inner")  {
              $elemDateGroup.html($elemDateInput.clone());
              $elemDateGroup.append($elemDateSpan.clone());
              $elemForm.html($elemDateGroup.clone());
            } else {
              var $label = $("<label />");
              $elemDateGroup.html($elemDateInput.clone());
              $elemDateGroup.append($elemDateSpan.clone());
              $elemForm.append($label.clone())
              $elemForm.append($elemDateGroup.clone())
            }
          } else if (type == "blank") {

          } else if (type == "input") {
            var $input = $("<input />", {class : "form-control form-right", type : "text"});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.html($input.clone());
            }
          } else if (type == "text") {
            var $input = $("<input />", {class : "form-control form-right", type : "text"});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.html($input.clone());
            }
          } else if (type == "textarea") {
            var $input = $("<textarea />", {class : "form-control", row : 5});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.removeClass("form-inner-label");
              $elemForm.html($input.clone());
            }
          } else if (type == "select") {
            var $ccc = $("<common-code-custom />", {});
            var $label = $("<label/>", {});
            $elemForm.html($ccc.clone());
            $elemForm.append($label.clone());
          } else if (type == "radio") {
            $elemForm.attr("class", "form-group form-inline radio-wrap");
            var $label = $("<label />", {});
            var $inputGroup = $("<div />", {class:"input-group input-radio-custom-group"});
            var $repeatDiv = $("<div />", {class:"radio-inline"});
            var $customLabel = $("<label />", {class:"custom-radio-btn"});
            var $span1 = $("<span />", {class:"helping-el"});
            var $span2 = $("<span />", {class:"label-text", text: '{{li.CodeValue}}'});
            var $input = $("<input />", {class : "clr form-right", type : "radio", value: "{{li.Code}}"});

            $customLabel.html($input.clone());
            $customLabel.append($span1.clone());
            $customLabel.append($span2.clone());

            $repeatDiv.html($customLabel.clone());
            $inputGroup.html($repeatDiv.clone());
            $elemForm.html($label.clone());
            $elemForm.append($inputGroup.clone());
          } else if (type == "modal") {
            var $inputGroup = $("<div />", {class:"input-group"});
            var $FormGoup = $("<div />", {class : "form-group form-inner-label"});
            var $input = $("<input />", {class : "form-control form-right", type : "text", readonly:""});
            var $label = $("<label/>", {});
            var $btnGroupSpan = $("<span />", { class : "input-group-btn" });
            var $btnGroupSpanButton = $("<button />", { class : "btn btn-default", type : "button" });
            var $btnGroupSpanIco =  $("<i />", { class : "fa fa-search" });
            $FormGoup.html($input.clone());
            $FormGoup.append($label.clone());
            $btnGroupSpanButton.html($btnGroupSpanIco.clone());
            $btnGroupSpan.html($btnGroupSpanButton.clone());
            $btnGroupSpanIco =  $("<i />", { class : "fa fa-eraser" });
            $btnGroupSpanButton.html($btnGroupSpanIco.clone());
            $btnGroupSpan.append($btnGroupSpanButton.clone());
            $inputGroup.html($FormGoup.clone());
            $inputGroup.append($btnGroupSpan.clone());
            return $inputGroup;
          } else if (type == "address") {
            var $returnRow = $("<div />", {class:"row"});
            var $row = $("<div />", {class:"row"});
            var $wrap = $("<div />", {class: colClass});
            var $formGroup = $("<div />", {class: "form-group form-inline"});
            var $label = $("<label />", {});
            var $inputGroup = $("<div />", {class: "input-group"});
            var $input = $("<input />", {class : "form-control", type : "text", readonly:""});
            var $span = $("<span />", {class: "input-group-btn"});
            var $button = $("<button />", {class: "btn btn-default", type:"button"});
            var $i = $("<i />", {class: "fa fa-search"});

            $button.html( $i.clone());
            $span.html( $button.clone());
            $inputGroup.html($input.clone());
            $inputGroup.append($span.clone());
            $formGroup.html($label.clone());
            $formGroup.append($inputGroup.clone());
            $wrap.html($formGroup.clone());
            $row.html($wrap.clone());
            var $zipcodeWrap = $("<div />", {class:"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"});
            $zipcodeWrap.html($row);
            $returnRow.html($zipcodeWrap.clone());

            var $addr1 = $("<div />", {class:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"});
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr1.html($formGroup.clone());
            $returnRow.append($addr1);

            var $addr2 = $("<div />", {class:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"});
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr2.html($formGroup.clone());
            $returnRow.append($addr2);

            return $returnRow;
          } else if (type == "addressLine") {
            var $returnRow = $("<div />", {class:"row"});
            var $row = $("<div />", {class:"row"});
            var $wrap = $("<div />", {class: colClass});
            var $formGroup = $("<div />", {class: "form-group form-inline"});
            var $label = $("<label />", {});
            var $inputGroup = $("<div />", {class: "input-group"});
            var $input = $("<input />", {class : "form-control", type : "text", readonly:""});
            var $span = $("<span />", {class: "input-group-btn"});
            var $button = $("<button />", {class: "btn btn-default", type:"button"});
            var $i = $("<i />", {class: "fa fa-search"});

            $button.html( $i.clone());
            $span.html( $button.clone());
            $inputGroup.html($input.clone());
            $inputGroup.append($span.clone());
            $formGroup.html($label.clone());
            $formGroup.append($inputGroup.clone());
            $wrap.html($formGroup.clone());
            $wrap.attr("class", "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12")
            $row.html($wrap.clone());
            var $zipcodeWrap = $("<div />", {class:"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"});
            $zipcodeWrap.css("padding-left", "0")
            $zipcodeWrap.html($row);
            $returnRow.html($zipcodeWrap.clone());

            var $addr1 = $("<div />", {class:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"});
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr1.html($formGroup.clone());
            $returnRow.append($addr1);

            var $addr2 = $("<div />", {class:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"});
            $input.attr("placeholder", "상세주소");
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr2.html($formGroup.clone());
            $returnRow.append($addr2);

            return $returnRow;
          } else if (type == "checkbox") {

          }

          return $elemForm;
        },
        setForms : function(forms) {

          var thisObj = this;
          var D = this.datas;
          var elemWidth;
          var checkUseModal = false;
          var checkZipCode = false, checkUseZipCode = false;
          var target = forms.target;
          var $elem = $("html");
          var field = forms.field;
          var arrayObj = [];
          var layout = forms.layout;
          var bindData = forms.bindData;

          if(layout == undefined) layout = mElemTx.layout.inner;
          
          if(typeof(target) == "string") {
            target = target.split(" ");            
            for(var j = 0; j < target.length; j++) {
              if(target[j].indexOf("[") > -1) {
                var splite = target[j].replaceAll(" ","").split("[");
                splite[1] = Number(splite[1].replace("]", ""));
                ($elem != null) ? $elem = $elem.find(splite[0]).eq(splite[1]) : $elem = $(splite[0]).eq(splite[1]);
              } else {
                ($elem != null) ? $elem = $elem.find(target[j]) : $elem = $(target[j]);
              }
            }
          } else {
            $elem = target;
          }

          if(forms.resetForm) {
            $elem.empty().html('');
          }
  
          for(var j = 0; j < field.length; j++) {
            var af = field[j];
            var disabled = af.disabled;
            af.bindKey = forms.bindKey + "." +af.key;
            var col=4, colClass = "";
            if (!isNullOrEmpty(af.col)) col = Number(af.col);
            if(col==4) colClass = "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3";
            else if(col==3) colClass = "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
            else if(col==2) colClass = "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6";
            else if(col==1) colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";

            if(af.layout != undefined) layout = af.layout;

            var $fObj = thisObj.getObjFieldType(af.type, colClass, layout);
            var $copyObj = $fObj.clone();

            // 주소 인라인용
            var $zipWrap_ = $copyObj.find("> div").eq(0);
            var $add1Wrap_ = $copyObj.find("> div").eq(1);
            var $add2Wrap_ = $copyObj.find("> div").eq(2);

            var $mainWrap = $("<div />", {
              class : colClass
            });

            var checkDoubleDate = false;

            if(af.type == "date" || af.type.toLowerCase() == "datetime") {
              
              if(Array.isArray(af.key)) {
                var $rowWrap = $("<div />", {
                  class :  "row"
                });
                var $subWrap = $("<div />", {
                  class :  "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                });

                checkDoubleDate = true;
                if(elemWidth > 500 && col < 3) {
                  $mainWrap.attr("class", "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6");
                }
                var $input = $copyObj.find("input");
                // from
                var dateKey = af.key[0];
                //dateKey = dateKey[dateKey.length-1];
               // D.vm[dateKey] = '';


                if(af.ngChange != undefined) {
                  if(typeof(af.ngChange) == "string") {
                    $input.attr("ng-change", af.ngChange+'()');
                  } else {
                    $input.attr("ng-change", af.ngChange[0]+'()');
                  }
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                  if(typeof(af.callback) == "string") {
                    $input.attr("ng-change", af.callback+'()');
                  } else {
                    $input.attr("ng-change", af.callback[0]+'()');
                  }
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }

                $input.attr("ng-model", "vc." + dateKey);
                
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }

                if(disabled != undefined) $input.attr("ng-disabled", disabled);

                if(thisObj.datas.pageType == undefined) {

                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    if(Array.isArray(af.label)) {
                      $input.attr("placeholder", af.label[0]);
                    } else {
                      $label.text(af.label);
                      $label.attr("title", af.label);
                    }
                  }

                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                  }
                }

                if(af.where != undefined) {
                  if(typeof(af.where) == "string") {
                    $copyObj.attr("ng-if", af.where);
                  } else {
                    $copyObj.attr("ng-if", af.where[0]);
                  }
                }

                $subWrap.html($copyObj.clone());
                $subWrap.attr("data-key", dateKey)
                $rowWrap.html($subWrap.clone());
                //$mainWrap.html($subWrap.clone());
                
                $mainWrap.addClass("doubleDate");
                //arrayObj.push($mainWrap.clone());
                
                thisObj.dateInfo.push({key : "vm." + dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey})
                // to
                
                var dateKey = af.key[1];
                if(af.ngChange != undefined) {
                  if(typeof(af.ngChange) == "string") {
                   
                  } else {
                    $input.attr("ng-change", af.ngChange[1]+'()');
                  }
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                  if(typeof(af.callback) == "string") {
                  } else {
                    if(af.callback[1]) {
                      $input.attr("ng-change", af.callback[1]+'()');
                    } else {
                      $input.removeAttr("ng-change");
                    }
                  }
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }

                $input.attr("ng-model", "vc." + dateKey);
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
                
                if(thisObj.datas.pageType == undefined) {
                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    if(Array.isArray(af.label)) {
                      $input.attr("placeholder", af.label[0]);
                    } else {
                      $label.detach();
                    }
                  }
                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[1]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                    $label.attr("title", af.label[0]);
                  }
                }
                
                $subWrap = $("<div />", {
                  class :  "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                });

                if(af.where != undefined) {
                  if(typeof(af.where) == "string") {
                    $copyObj.attr("ng-if", af.where);
                  } else {
                    $copyObj.attr("ng-if", af.where[0]);
                  }
                }

                $copyObj.removeClass("form-inline");
                $copyObj.css("padding-left", "1%");
                $subWrap.html($copyObj.clone());
                $subWrap.attr("data-key", af.key[1])
                $rowWrap.append($subWrap.clone());
                $mainWrap.html($rowWrap.clone());
                //$mainWrap.attr("data-key", af.key)
                arrayObj.push($mainWrap.clone());

                thisObj.dateInfo.push({key : "vm." + dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey})

              } else {
                var dateKey = af.key;
                var $input = $copyObj.find("input");
                // from
                if(af.ngChange != undefined) {
                  $input.attr("ng-change", af.ngChange+'()');
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }
                $input.attr("ng-model", "vc." + dateKey);
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }

                //var dateKey = af.bindKey.split(".");
                // dateKey = dateKey[dateKey.length-1];
                // D.vm[dateKey] = '';
                //var value = af.bindKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                //$input.attr("ng-change", value);
                //$input.attr("ng-model", "vc." + dateKey);
                if(disabled != undefined) $input.attr("ng-disabled", disabled);

                if(thisObj.datas.pageType == undefined) {

                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.html(af.label);
                    $label.attr("title", af.label);
                  }
                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label);
                    $label.attr("title", af.label);
                  }                  
                }

                var dateInfo = {key : "vm." +  dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey};
                  thisObj.dateInfo.push(dateInfo)
              }
            } else if(af.type == "blank"){

            } else if(af.type == "input"){
              
              var $input = $copyObj.find("input");
              if(af.inputType != undefined) {
                if(af.inputType == "number") {
                  $input.attr('comma','');
                }
              }

              if(af.ngChange != undefined) {
                $input.attr('ng-change',af.ngChange + "("+ af.bindKey+", this)");
              } else if(af.callback != undefined) {
                $input.attr('ng-change',af.callback + "("+ af.bindKey+", this)");
              }


              $input.attr("ng-model", af.bindKey);

              if(thisObj.datas.pageType == undefined) {

                if(layout == mElemTx.layout.inner) {
                  $input.attr("placeholder", af.label);
                } else {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                }

                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              } else {
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              }
            } else if(af.type == "text"){
              var $input = $copyObj.find("input");
              if(af.inputType != undefined) {
                if(af.inputType == "number") {
                  $input.attr('comma','');
                }
                if(af.inputType == "date") {
                  $input.attr('md-date-utc-to-local', af.bindKey);
                }
              }

              if(af.ngChange != undefined) {
                $input.attr('ng-change',af.ngChange + "("+ af.bindKey+", this)");
              } else if(af.callback != undefined) {
                $input.attr('ng-change',af.callback + "("+ af.bindKey+", this)");
              }

              $input.attr("ng-model", af.bindKey);
              if(thisObj.datas.pageType == undefined) {
                if(layout == mElemTx.layout.inner) {
                  $input.attr("placeholder", af.label);
                } else {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              } else {

                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              }
            } else if(af.type == "textarea"){
              var $input = $copyObj.find("textarea");
              if(af.row != undefined) $input.attr("rows", af.row);
              $input.attr("ng-model", af.bindKey);
              if(thisObj.datas.pageType == undefined) {
                var $label = $copyObj.find("label");
                $label.html(af.label);
                $label.attr("title", af.label);
              } else {
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
              }
              
              if(af.readOnly != undefined && af.readOnly == true) $input.attr("readonly", '');
              if(disabled != undefined) $input.attr("ng-disabled", disabled);
            } else if(af.type == "select"){
              var $ccc = $copyObj.find("common-code-custom");
              var $label = $copyObj.find("label");
              if(af.bindData != undefined) {
                $ccc.attr("code-list", af.bindData.replace("vm.","vc."));
              } else {
                $ccc.attr("code-list", "vc.columnMap['" + af.key + "'].CodeList");
              }
              
              if(af.codeExclude != undefined) {
                $ccc.attr("code-exclude", af.codeExclude.replace("vm.","vc."));
              } 

              if(disabled != undefined) $ccc.attr("is-disabled", disabled);
              $ccc.attr("code-model", af.bindKey);
              $label.text(af.label);
              $label.attr("title", af.label);
              if(af.callback != undefined) {
                $ccc.attr("callback", af.callback);
              }
            } else if(af.type == "radio"){
              var $label = $copyObj.find("label");
              var $input = $copyObj.find("input");
              var $radioInline = $copyObj.find(".radio-inline");
              $label.eq(0).text(af.label);
              $label.eq(0).attr("title", af.label);
              if(af.bindData != undefined) {
                $radioInline.attr("ng-repeat", "li in " + af.bindData.replace("vm.","vc."));
                $radioInline.attr("title", "{{li.CodeValue}}");
              } else {
                $radioInline.attr("ng-repeat", "li in vc.columnMap['" + af.key + "'].CodeList");
              }
              $input.attr("ng-model", af.bindKey);
              $input.attr("ng-checked", af.bindKey + " == li.Code");
              if(disabled != undefined) $input.attr("ng-disabled", disabled);
              if(af.callback != undefined) $input.attr("ng-change", af.callback + "(li);");
              //$radioInline.append("{{li.CodeValue}}");
            } else if(af.type == "modal"){
              checkUseModal = true;
              var $label = $copyObj.find("label");
              $label.html(af.label);
              $label.attr("title", af.label);
              var $input = $copyObj.find("input");
              $input.attr("ng-model", af.bindLabel);
              var $searchBtn = $copyObj.find("button").eq(0);
              var $eraserBtn = $copyObj.find("button").eq(1);

              $searchBtn.attr("ng-click", af.clickFn + "();")
              $eraserBtn.attr("ng-click", "vc.eraserModalData('" + af.bindLabel+ "','" + af.bindKey +"');")
            }  else if(af.type == "address"){
              checkZipCode = true, checkUseZipCode = true;
              var $zipWrap = $copyObj.find("> div").eq(0);
              var $add1Wrap = $copyObj.find("> div").eq(1);
              var $add2Wrap = $copyObj.find("> div").eq(2);
              $zipWrap.find("label").text(af.label);
              $zipWrap.find("label").attr("title", af.label);
              
              var bindKey = forms.bindKey;
              var postCode = bindKey + "." + af.key[0];
              var add1 = bindKey + "." + af.key[1];
              var add2 = bindKey + "." + af.key[2];

              $zipWrap.find("input").attr("ng-model", postCode);
              $zipWrap.find("button").attr("ng-click", "vc.setAddressField('"+postCode+"','"+add1+"','"+add2+"')");
              $add1Wrap.find("label").text('주소');
              $add1Wrap.find("label").attr("title", "주소");
              $add1Wrap.find("input").attr("ng-model", add1);
              $add2Wrap.find("label").text('상세주소');
              $add2Wrap.find("label").attr("title", "상세주소");
              $add2Wrap.find("input").attr("ng-model", add2);
              $add2Wrap.find("input").removeAttr("readonly");                
              $zipWrap.attr("data-key", af.key)
              //$zipWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              $add1Wrap.attr("data-key", af.key)
              //$add1Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              $add2Wrap.attr("data-key", af.key)
              //$add2Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              arrayObj.push($zipWrap.clone());
              arrayObj.push($add1Wrap.clone());
              arrayObj.push($add2Wrap.clone());
            }  else if(af.type == "addressLine"){
              
              checkZipCode = false, checkUseZipCode = true;
              $zipWrap_ = $copyObj.find("> div").eq(0);
              $add1Wrap_ = $copyObj.find("> div").eq(1);
              $add2Wrap_ = $copyObj.find("> div").eq(2);
              $zipWrap_.find("label").text(af.label);
              $zipWrap_.find("label").attr("title", af.label);
              
              var bindKey = forms.bindKey;
              var postCode = bindKey + "." + af.key[0];
              var add1 = bindKey + "." + af.key[1];
              var add2 = bindKey + "." + af.key[2];

              $zipWrap_.find("input").attr("ng-model", postCode);
              $zipWrap_.find("button").attr("ng-click", "vc.setAddressField('"+postCode+"','"+add1+"','"+add2+"')");
              $add1Wrap_.find("label").text('주소');
              $add1Wrap_.find("label").detach();
              $add1Wrap_.find("input").css("margin-left", 0);
              $add1Wrap_.find("input").css("width", "100%");
              $add2Wrap_.find("label").detach();
              $add2Wrap_.find("input").attr("ng-model", add2);
              $add2Wrap_.find("input").css("margin-left", 0);
              $add2Wrap_.find("input").css("width", "100%");
              $add2Wrap_.find("input").removeAttr("readonly");                
              $zipWrap_.attr("data-key", af.key)
              $add1Wrap_.attr("data-key", af.key)
              $add2Wrap_.attr("data-key", af.key)
              // arrayObj.push($zipWrap.clone());
              // arrayObj.push($add1Wrap.clone());
              // arrayObj.push($add2Wrap.clone());
            } else if(af.type == "checkbox") {
              // var $mdCheckbox = $("<md-checkbox />", {
              //   "ng-true-value" : 'Y',
              //   "ng-false-value" : 'N',
              //   "role" : 'checkbox',
              //   class : 'md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty',
              // });
              var $mdCheckbox = $("<md-checkbox />", {
              });

              if(af.disabled != undefined) $mdCheckbox.attr("ng-disabled", af.disabled);
              $mdCheckbox.attr("ng-true-value", "'Y'");
              $mdCheckbox.attr("ng-false-value", "'N'");
              $mdCheckbox.attr("role", 'checkbox');
              var $inputGroup = $("<div />", {class:"input-group"});

              if(af.bindData != undefined) {    
                $mdCheckbox.attr("ng-repeat", "li in " + af.bindData.replace("vm.","vc."));
                $mdCheckbox.attr("role", 'checkbox');
                af.bindKey = forms.bindKey + "[li.Code]";
                $mdCheckbox.attr('ng-model', af.bindKey)
                $mdCheckbox.attr('title', '{{li.CodeValue}}')
                $mdCheckbox.text("{{li.CodeValue}}");

                if(af.label != undefined) {
                  var $label = $("<label />", {
                    text : af.label
                  })
                  
                  $inputGroup.html($mdCheckbox.clone());
                  $copyObj.html($label.clone());
                  $copyObj.append($inputGroup);
                  
                } else {
                  $inputGroup.html($mdCheckbox.clone());
                  $copyObj.append($mdCheckbox.clone());
                }
              } else if(Array.isArray(af.key)) {
                //$copyObj.empty().html('');
                for(var k = 0; k < af.label.length; k++) {
                  af.bindKey = forms.bindKey + "." + af.key[k];
                  $mdCheckbox.attr('ng-model', af.bindKey)
                  $mdCheckbox.text(af.label[k])
                  $copyObj.append($mdCheckbox.clone());
                }
              } else {
                af.bindKey = forms.bindKey + "." + af.key;
                $mdCheckbox.attr('ng-model', af.bindKey)
                $mdCheckbox.text(af.label)
                $copyObj.append($mdCheckbox.clone());
              }              
            }

            $mainWrap.css("min-height", "38px");

            if(af.where != undefined) {
              $mainWrap.attr('ng-if', af.where);
            }
            
            if(af.type == "addressLine") {
              $mainWrap.html($zipWrap_.clone())
              $mainWrap.append($add1Wrap_.clone())
              $mainWrap.append($add2Wrap_.clone())
              $mainWrap.attr("data-key", af.key)
              arrayObj.push($mainWrap.clone());
            } else if(!checkDoubleDate && !checkZipCode) {
              $mainWrap.html($copyObj.clone());
              $mainWrap.attr("data-key", af.key)
              arrayObj.push($mainWrap.clone());
            }

            
            checkDoubleDate = false;
            checkZipCode = false;
          }

       

          if(forms.fixOrder == undefined) forms.fixOrder = true
          if(forms.fixOrder == true) {
            for(var k = 0; k < arrayObj.length; k++) 
              $elem.append(arrayObj[k].clone());

              $compile($elem)(D.scope);
              initViewLoadedInputBoxStyle();
              //if(checkUseModal) {
                thisObj.setModalFn(D);
              //}
              if(checkUseZipCode) {
                thisObj.setAddressFn(D);
              }
          } else {
            var intervalCount = 0;
            var interval = $interval(function(){
              try {
                if(!D.vm.columnMap) {
                  intervalCount++;
                  if(intervalCount==5){
                    $interval.cancel(interval);
                  }
                } else {
                  $interval.cancel(interval);
                  var keys = Object.keys(D.vm.columnMap);
                  for(var k = 0; k < keys.length; k++) {
                    for(var l = 0; l < arrayObj.length; l++) {
                      var dataKey = $(arrayObj[l]).attr("data-key");
                      if(dataKey == keys[k]) {
                        $elem.append(arrayObj[l].clone())
                      }
                    }
                  }
                  $compile($elem)(D.scope);
                  initViewLoadedInputBoxStyle();
                  //if(checkUseModal) {
                    thisObj.setModalFn(D);
                  //}
                }
              } catch(e) {
                $interval.cancel(interval);
                console.table(e);
              }
            },500);
          }
        },
        setSrchDateForm : function(){
          var D = this.datas;
          var dateInfo = this.dateInfo;
          for(var i = 0; i < dateInfo.length; i++) {
            var obj = this.getStrObjectValue(D, dateInfo[i].bindKey);
            if(obj == undefined) continue;
            obj = moment(obj).toDate();//format('YYYY-MM-DD');
            var key = dateInfo[i].key;
            key = key.replace("vm.","");
            if(key.indexOf("_Str") > 0) {
              obj = $filter('localToUtc')(obj,'to');
            } else {
              obj = $filter('localToUtc')(obj,'from');
            }
            this.datePicker().setDate(key, obj)
          }
        },
        setStrObjValue : function(D, p, v){
          p = p.replace("vc.", "vm.").split(".");
          var object = D;
          for(var i = 0; i < p.length-1; i++) {
            object = Object.assign(object[p[i]]);
          }
          $timeout(function(){
            object[ p[p.length -1]] = v;
          },0);
          
        },
        getStrObjectValue : function(D, p){

          try {
            var ps = p.replace("vc.", "vm.").split(".");
            var object = D;
            for(var i = 0; i < ps.length-1; i++) {              
              object = Object.assign(object[ps[i]]);
            }
            return object[ ps[ps.length-1]];
          } catch(e) {
            return null;
          }
        },
        getStrObject : function(D, p){

          try {
            var ps = p.replace("vc.", "vm.").split(".");
            var object = D;
            for(var i = 0; i < ps.length; i++) {              
              object = Object.assign(object[ps[i]]);
            }
            return object;
          } catch(e) {
            return null;
          }
        },
        setAddressFn : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.setAddressField)) {
            D.vm.setAddressField = function(p1, p2, p3) {
              new daum.Postcode({
                oncomplete: function(data) {
                  thisObj.setStrObjValue(D, p1, data.zonecode);
                  var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
                  thisObj.setStrObjValue(D, p2, addr1);
                },
              }).open();
            };
          }
        },
        setModalFn : function(D) {

          if(this.checkEmptyType(D.vm.eraserModalData)) {
            D.vm.eraserModalData = function(p1, p2) {
              p1 = p1.replace("vc.", "vm.").split(".");
              p2 = p2.replace("vc.", "vm.").split(".");

              if(p1.length == 1) {
                D[p1[0]] = '';
              } else if(p1.length == 2) {
                D[p1[0]][p1[1]] = '';
              } else if(p1.length == 3) {
                D[p1[0]][p1[1]][p1[2]] = '';
              }

              if(p2.length == 1) {
                D[p2[0]] = '';
              } else if(p2.length == 2) {
                D[p2[0]][p2[1]] = '';
              } else if(p2.length == 3) {
                D[p2[0]][p2[1]][p2[2]] = '';
              }
             
            };
          }

          if(this.checkEmptyType(D.vm.openModal)) {
            D.vm.openModal = function(p, callback, cancelCallback) {
              var modalInstance = modalFactory.open(p.size, p.template, p.ctrl, p.param);
              modalInstance.result.then(function(res) {
                if(callback != undefined) {
                  callback(res);
                }
              }, function(cancelData) {
                if(cancelCallback != undefined) {
                  cancelCallback(cancelData);
                }
              });
            };
          }

        },
        drawFormBox : function(D) {
  
          var thisObj = this;
          if(D.FormGroup.drawSuccess == true) return;
          D.FormGroup.drawSuccess = true;

          for(var i = 0; i < D.FormGroup.length; i++) {
            var afg = D.FormGroup[i];
            var target = afg.target.split(" ");
            var $elem = null;
            var elemWidth;
            var checkUseModal = false;
            var checkZipCode = false, checkUseZipCode = false;
            for(var j = 0; j < target.length; j++) {
              if(target[j].indexOf("[") > -1) {
                var splite = target[j].replaceAll(" ","").split("[");
                splite[1] = Number(splite[1].replace("]", ""));
                ($elem != null) ? $elem = $elem.find(splite[0]).eq(splite[1]) : $elem = $(splite[0]).eq(splite[1]);
              } else {
                ($elem != null) ? $elem = $elem.find(target[j]) : $elem = $(target[j]);
              }
            }

            //var $elem = angular.element(afg.target);
            var arrayObj = [];
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
              if (!isNullOrEmpty(afg.searchboxSize)) {
                $elem.closest(".search-detail-wrap").css("width", afg.searchboxSize);
                elemWidth = Number(afg.searchboxSize.replace("px","").replace("%",""));
              } else {
                elemWidth = $elem.closest(".search-detail-wrap").width();
              }
            }
            //$elem.empty().html('');
            var field = afg.field;
            if(!field) field = [];
            for(var j = 0; j < field.length; j++) {
              var af = field[j];
              var col=4, colClass = "";
              if (!isNullOrEmpty(af.col)) col = Number(af.col);
              if(col==4) colClass = "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3";
              else if(col==3) colClass = "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4";
              else if(col==2) colClass = "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6";
              else if(col==1) colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";
              var $fObj = thisObj.getObjFieldType(af.type, colClass);
              var $copyObj = $fObj.clone();

              var $mainWrap = $("<div />", {
                class : colClass
              });

              var checkDoubleDate = false;
              if(af.type == "date") {

                if(Array.isArray(af.bindKey)) {
                  checkDoubleDate = true;
                  if(elemWidth > 500 && col < 3) {
                    $mainWrap.attr("class", "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6");
                  }
                  var $input = $copyObj.find("input");
                  // from
                  var dateKey = af.bindKey[0].split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey[0] + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                  }

                  $mainWrap.html($copyObj.clone());
                  $mainWrap.attr("data-key", af.key)
                  $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                  arrayObj.push($mainWrap.clone());
                  
                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey[0], datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo)
                  }

                  // to
                  var dateKey = af.bindKey[1].split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey[1] + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[1]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[1]);
                  }
                  
                  $mainWrap.html($copyObj.clone());
                  $mainWrap.attr("data-key", af.key)
                  $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                  arrayObj.push($mainWrap.clone());

                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey[1], datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo)
                  }

                } else {
                  var $input = $copyObj.find("input");
                  // from
                  var dateKey = af.bindKey.split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label);
                  }

                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey, datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo);
                  }
                }
              } else if(af.type == "input"){
                var $input = $copyObj.find("input");
                $input.attr("ng-model", af.bindKey);
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
              } else if(af.type == "select"){
                var $ccc = $copyObj.find("common-code-custom");
                var $label = $copyObj.find("label");
                $ccc.attr("code-list", "vc.columnMap['" + af.key + "'].CodeList");
                $ccc.attr("code-model", af.bindKey);
                $label.text(af.label);
                if(af.callback != undefined) {
                  $ccc.attr("callback", af.callback);
                }
              } else if(af.type == "radio"){
                var $label = $copyObj.find("label");
                var $input = $copyObj.find("input");
                var $radioInline = $copyObj.find(".radio-inline");
                $label.text(af.label);
                $radioInline.attr("ng-repeat", "li in vc.columnMap['" + af.key +"'].CodeList");
                $input.attr("ng-model", af.bindKey);
                $input.attr("ng-checked", af.bindKey + " == li.Code");
                if(af.callback != undefined) $input.attr("ng-change", af.callback + "();");
                $radioInline.append("{{li.CodeValue}}");
              } else if(af.type == "modal"){
                checkUseModal = true;
                var $label = $copyObj.find("label");
                $label.html(af.label);
                var $input = $copyObj.find("input");
                $input.attr("ng-model", af.bindLabel);
                var $searchBtn = $copyObj.find("button").eq(0);
                var $eraserBtn = $copyObj.find("button").eq(1);

                $searchBtn.attr("ng-click", af.clickFn + "();")
                $eraserBtn.attr("ng-click", "vc.eraserModalData('" + af.bindLabel+ "','" + af.bindKey +"');")
              }  else if(af.type == "address"){
                checkZipCode = true, checkUseZipCode = true;
                var $zipWrap = $copyObj.find("> div").eq(0);
                var $add1Wrap = $copyObj.find("> div").eq(1);
                var $add2Wrap = $copyObj.find("> div").eq(2);
                $zipWrap.find("label").text(af.label);
                $zipWrap.find("input").attr("ng-model", af.bindKey[0]);
                $zipWrap.find("button").attr("ng-click", "vc.setAddressField('"+af.bindKey[0]+"','"+af.bindKey[1]+"','"+af.bindKey[2]+"')");
                $add1Wrap.find("label").text('주소');
                $add1Wrap.find("input").attr("ng-model", af.bindKey[1]);
                $add2Wrap.find("label").text('상세주소');
                $add2Wrap.find("input").attr("ng-model", af.bindKey[2]);
                $add2Wrap.find("input").removeAttr("readonly");                
                $zipWrap.attr("data-key", af.key)
                $zipWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                $add1Wrap.attr("data-key", af.key)
                $add1Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                $add2Wrap.attr("data-key", af.key)
                $add2Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                arrayObj.push($zipWrap.clone());
                arrayObj.push($add1Wrap.clone());
                arrayObj.push($add2Wrap.clone());
              }

              if(!checkDoubleDate && !checkZipCode) {
                $mainWrap.html($copyObj.clone());
                $mainWrap.attr("data-key", af.key)
                $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                arrayObj.push($mainWrap.clone());
              }

              checkDoubleDate = false;
              checkZipCode = false;
            }

            if(afg.fixOrder == true) {
              for(var k = 0; k < arrayObj.length; k++) 
                $elem.append(arrayObj[k].clone());
                $compile($elem)(D.scope);
                //if(checkUseModal) {
                  thisObj.setModalFn(D);
                //}
                if(checkUseZipCode) {
                  thisObj.setAddressFn(D);
                }
            } else {
              var intervalCount = 0;
              var interval = $interval(function(){
                try {
                  if(!D.vm.columnMap) {
                    intervalCount++;
                    if(intervalCount==5){
                      $interval.cancel(interval);
                    }
                  } else {
                    $interval.cancel(interval);
                    var keys = Object.keys(D.vm.columnMap);
                    for(var k = 0; k < keys.length; k++) {
                      for(var l = 0; l < arrayObj.length; l++) {
                        var dataKey = $(arrayObj[l]).attr("data-key");
                        if(dataKey == keys[k]) {
                          $elem.append(arrayObj[l].clone())
                        }
                      }
                    }
                    $compile($elem)(D.scope);
                    //if(checkUseModal) {
                      thisObj.setModalFn(D);
                    //}
                  }
                } catch(e) {
                  $interval.cancel(interval);
                  console.table(e);
                }
              },500);
            }
          }
        },

        openModal : function(p, callback, cancelCallback) {
          var modalInstance = modalFactory.open(p.size, p.template, p.ctrl, p.param);
          modalInstance.result.then(function(res) {
            if(callback != undefined) {
              callback(res);
            }
          }, function(cancelData) {
            if(cancelCallback != undefined) {
              cancelCallback(cancelData);
            }
          });
        },
        alert : function(MSG, callback){
          if(callback == undefined)
            gAlert('', MSG);
          else 
            gAlert('',MSG, {
              btn : '',
              fn : function() {
                callback();
              }
            });
        },
        confirm : function(MSG, okCallback, cancelCallback) {
          gConfirm('', MSG, {
            btn : '',
            fn : function() {
              if(okCallback != undefined)
              okCallback();
            }
          }, {
            btn : '',
            fn : function() {
              if(cancelCallback != undefined)
                cancelCallback();
            }
          });

        },
        toast : function(msg) {
          $rootScope.showSimpleToast(msg);
        },

        go : function(p1, p2, p3) {
          if(p3 == undefined)
            $state.go(p1, p2 , {reload: p1});
          else 
            $state.go(p1, p2 , {reload: p3});
        },
        datePicker : function() {
          var vm = this.datas.vm;
          var dates = this.dateInfo;
          var thisObj = this;
          return {
            setDate : function(key, date) {           
              if(key.indexOf("vc.") > -1) {
                key = key.replace("vc.", "vm.")
              } 
              if(key.indexOf("vm.") == - 1) {
                key = "vm." + key;
              }

              for(var i  = 0; i < dates.length; i++) {
                if(key == dates[i].key) {
                  var caldate =  moment(date).format('YYYY-MM-DD');
                  var bindKeyArray = dates[i].bindKey.split(".");
                  if(bindKeyArray.length == 2) {
                    vm[bindKeyArray[1]] = caldate;
                  } else if(bindKeyArray.length == 3) {
                    vm[bindKeyArray[1]][bindKeyArray[2]] = caldate;
                  } else if(bindKeyArray.length == 4) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]] = caldate;
                  } else if(bindKeyArray.length == 5) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]][bindKeyArray[4]] = caldate;
                  } else if(bindKeyArray.length == 6) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]][bindKeyArray[4]][bindKeyArray[5]] = caldate;
                  }

                  var keyArray = dates[i].key.split(".");
                  vm[keyArray[1]] = moment(date).toDate();
                  
                }                
              }
            },

            moment : function(p) {
              if(p == undefined) {
                return moment().toDate();
              } else {
                return moment(p).toDate();
              }
              
            },

            getToday : function() {
              return moment().toDate();
            },

            getTodayStartOf : function() {
              return moment().startOf('day');
            },            

            setCalDays  : function(p, month, option) {
              // option :
              // d = day
              // w = week
              // M = Month
              // y = year
              if(option.toUpperCase == "M") option = "M";
              vm[p] = moment(moment().add(month, option)).toDate();
            },

            setCalMonth  : function(p1, p2, p3, p4, p5) {
              var checkDateP1 = false;
              if(new Date(p1) == "Invalid Date" || new Date(p1).toISOString().split('T')[0] == "1970-01-01") {
                checkDateP1 = false;
              } else {
                checkDateP1 = true;
              }
              var checkNaN_p1 = isNaN(p1);
              var checkNaN_p2 = isNaN(p2);
              var result;
              if(typeof(p1) == 'string' && !checkNaN_p2 && !checkDateP1) {
                p1 = p1.replace('vm.', '').replace('vc.', '');
                if(p2 == 0) {
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'M')).toDate();
                } else {
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'M').subtract(1, 'd')).toDate();
                }                
              } else if(typeof(p1) == 'object' && checkDateP1)  {
                if(p2 == 0) {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'M')).toDate();
                } else {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'M').subtract(1, 'd')).toDate();
                }
              } else if(!checkNaN_p1) {
                if(p1 == 0) {
                  result = moment(moment().add(p1-0, 'd')).toDate();
                } else {
                  result = moment(moment().add(p1-1, 'd')).toDate();
                }
              }

              return result;
            },

            setCalDay  : function(p1, p2, p3, p4, p5) {
              var result;
              if(p3 != undefined) {
                // p1 참고
                // p2 기간
                // p3 타입
                p3 = p3.toLowerCase();
                if(p3 == "m") p3 = "M";
                
                if(p2 == 0) {
                  result = moment(moment(moment(p1).toDate()).add(Number(p2), p3)).toDate();
                } else{
                  result = moment(moment(moment(p1).toDate()).add(Number(p2), p3).subtract(1, 'd')).toDate();
                }
              } else {
                var checkDateP1 = false;
                if(new Date(p1) == "Invalid Date" || new Date(p1).toISOString().split('T')[0] == "1970-01-01") {
                  checkDateP1 = false;
                } else {
                  checkDateP1 = true;
                }
                var checkNaN_p1 = isNaN(p1);
                var checkNaN_p2 = isNaN(p2);
                var result;
                if(typeof(p1) == 'string' && !checkNaN_p2 && !checkDateP1) {
                  p1 = p1.replace('vm.', '').replace('vc.', '');
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'd')).toDate();
                } else if(typeof(p1) == 'object' && checkDateP1)  {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'd')).toDate();
                } else if(!checkNaN_p1) {
                  result = moment(moment().add(p1, 'd')).toDate();
                }
              }

              return result;
            },
          }
        },
        
      }; // End Fns;
      return fns;
    }

    return ins;
  },
])
.directive('pageHeader', 
  [ '$compile', '$parse', function($compile, $parse) {

    var $row = $("<div />", { class: "row" });
    var $wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $pageHeader = $("<div />", { class: "page-header", text: "{{vc.headerTitle}}" });
    var $dockBtnWrap = $("<div />", { class: "pull-right dock-header-tx list-split" });

    var btns = ["vc.setChangeLayout('N', vc)", "vc.setChangeLayout('V', vc)","vc.setChangeLayout('H', vc)"];
    var imgs = ["assets/images/icon-sp-list.png", "assets/images/icon-sp-rl.png", "assets/images/icon-sp-tb.png"];

    for(var i = 0; i < btns.length; i++) {
      var $btn = $("<span />", { "ng-click": btns[i] });
      var $img = $("<img />", { alt: "", src: imgs[i] });
      $btn.html($img.clone());
      $dockBtnWrap.append($btn.clone());
    }

    $pageHeader.append($dockBtnWrap.clone());
    $wrap.html($pageHeader.clone());
    $row.html($wrap.clone());
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      require: false,
      scope : false,
      template : $wrap.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}])
.directive('listTable', 
  [ '$compile', '$parse', 
  function($compile, $parse) {

    var $row = $("<div />", { class: "row" });
    var $wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody = $("<div />", { class: "panel-body collapse in" });
    var $table = $("<table />", {
      class : "table table-striped table-bordered table-hover data_table table-custom",
      "data-filter" : "#filter", ///있긴한데 불필요한 것 같아서 주석처리
      style: "table-layout:fixed"
    });
    var $thead = $("<thead />", {});
    var $tr = $("<tr />", {});
    var $checkHeader = $("<th />", {class: 'text-center', style : 'vertical-align:middle; width: 40px;', 'ng-if':'vc.listCheckboxEnable'});
    var $headerCheckbox = $("<input />", {type:'checkbox', 'ng-click': 'vc.chkRowAll()', 'ng-model' : 'vc.checkListCheckbox'});
    $checkHeader.html($headerCheckbox.clone());
    var $theadTh = $("<th />", {
      class: "text-center none {{liCol.ListColumnShowLevel}}",
      "data-toggle" : "{{liCol.KeyColumnYN == 'Y'? 'true' : 'false'}}",
      "ng-click" : "vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN, liCol)",
      "ng-repeat" : "liCol in vc.listColumns",
      style : "width: {{liCol.ListColumnWidth}}",
      text : "{{ ::liCol.ColumnLogicalNm | translate }}"
    });
    var $theadThSpen = $("<span />", {
      class : "fa fa-sort",
      "ng-show" : "liCol.KeyColumnYN == 'Y'"
    });
    var $tbody = $("<tbody />", {});
    var $checkBodyTd = $("<td />", {class: 'text-center', style : 'vertical-align:middle; width: 40px;', 'ng-if':'vc.listCheckboxEnable'});
    var $checkBodyTdInput = $("<input />", {type:'checkbox', 'ng-model' : 'li.chkRow', 'ng-change': 'vc.chkRowChg(li)'});
    $checkBodyTd.html($checkBodyTdInput.clone())

    var $listTr = $("<tr />", { "ng-repeat": "li in vc.lists", style: "cursor:pointer", "ng-class": "{'bg-lightyellow':vc.getListKeyId() == li.KeyId}"});
    var $listTd = $("<td />", { 
      class: "{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}",
      "ng-click": "vc.listToPage(li)", 
      "ng-repeat" : "liCol in vc.listColumns",
      text : "{{liCol.ColumnLogicalDataType != '40' ? (liCol.ColumnLogicalDataType == '20' ? (li[liCol.ColumnPhysicalAsNm] | number) : li[liCol.ColumnPhysicalAsNm]) : (li[liCol.ColumnPhysicalAsNm] | utcToLocal:'yyyy-MM-dd')}}",     });
    
    var $emptyDiv = $("<div />", { 
      class: "tbnodata", 
      "ng-if" : "vc.totalItems == 0",  
      text : "{{ 'MSG.NO_DATA' | translate }}",
      style : "text-align:center; padding:15px; border:solid 1px #CCC; border-top:none;"
    });

    $tr.html($checkHeader.clone());
    $theadTh.append($theadThSpen.clone());
    $tr.append($theadTh.clone());
    $thead.html($tr.clone());
    $table.html($thead.clone());
    // $emptyTr.html($emptyTd.clone());
    // $tbody.append($emptyTr.clone());

    $listTr.html($checkBodyTd.clone());
    $listTr.append($listTd.clone());
    $tbody.append($listTr.clone());
    $table.append($tbody.clone());
    $panelBody.append($table.clone());
    $panelBody.append($emptyDiv.clone());

    // 페이징까지 처리진행
    var $wrap2 = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody2 = $("<div />", { class: "panel-body collapse in" });
    var $row2 = $("<div />", { class: "row" });
    var $viewSizeWrap = $("<div />", { class: "col-xl-4 col-lg-4 col-md-4 col-sm-2 col-xs-2 col-sm-hidden col-xs-hidden  paging_pad", style:"width:50%" });
    var $formGroup = $("<div />", { class: "form-group form-inline select-size-list"});
    var $label = $("<label />", {text : "{{ :: 'Menu.LIST' | translate }}"});
    var $select = $("<select />", { 
      "aria-controls" : "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
      "ng-change" :"vc.setChangeViewSize()", "ng-model" : "vc.srch.viewSize",
      "ng-options" : "c for c in vc.listSize" });
    var $pagingBarWrap = $("<div />", { class: "col-xl-8 col-lg-8 col-md-8 col-sm-6 col-xs-6 paging_pad", style:"width:50%"});
    var $pullRight =  $("<div />", { class: "paging dataTables_paginate pull-right" });
    var $ul =  $("<ul />", { 
      "uib-pagination" : "",
      "data-ng-if" :"vc.totalItems", "direction-links" :"true", "first-text":"{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
      "name" : "pagination", "next-text" : "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change" : "vc.setPageChanged()", "ng-model":"vc.currentPage",
      "previous-text":"{{'BTN.PAGINATION.PREV'|translate}}", "total-items":"vc.totalItems", "boundary-links":"true",
      "items-per-page":"vc.viewSize", "max-size" : "vc.maxSize", "num-pages":"vc.numPages", "rotate":"false", "template-url" : "components/template/pagination.html"
    });
    var $row3 = $("<div />", { class: "row" });
    $formGroup.append($label.clone());
    $formGroup.append($select.clone());
    $viewSizeWrap.append($formGroup.clone());
    $row2.append($viewSizeWrap.clone());    
    $pullRight.append($ul.clone());
    $pagingBarWrap.append($pullRight.clone());
    $row2.append($pagingBarWrap.clone());
    $panelBody.append($row2.clone());
    $panel.append($panelBody.clone());
    $wrap.append($panel.clone());
    $row.append($wrap.clone());
    var $last = $("<div />");
    $last.html($row.clone());

    return {
      transclude : true,
      replace: false,
      restrict : 'E',
      require: false,
      scope :false,
      template : $last.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}])
.directive('listCustom', 
  [ '$compile', '$parse', 
  function($compile, $parse) {
    return {
      restrict : 'E',
      compile: function compile(element, tAttrs) {
       
        var viewTypeObj = element.find("[view-type]");
        for(var i = 0; i < viewTypeObj.length; i++) {

          var bindObj = viewTypeObj.eq(i).find("[bind-key]");
          for(var j = 0; j < bindObj.length; j++) {
            bindObj.eq(j).attr("ng-bind", bindObj.eq(j).attr("bind-key"))
          }

          var ifObj = viewTypeObj.eq(i).find("[bind-if]");
          for(var j = 0; j < ifObj.length; j++) {
            ifObj.eq(j).attr("ng-if", ifObj.eq(j).attr("bind-if"))
          }

          if(viewTypeObj.eq(i).attr("bind-repeat") != undefined) {
            viewTypeObj.eq(i).attr("ng-repeat", viewTypeObj.eq(i).attr("bind-repeat"));
          }
          var repeatObj = viewTypeObj.eq(i).find("[bind-repeat]");
          for(var j = 0; j < repeatObj.length; j++) {
            repeatObj.eq(j).attr("ng-repeat", repeatObj.eq(j).attr("bind-repeat"))
          }
        }
      }
    };
}])
.directive('listPaging', 
  [ '$compile', '$parse', 
  function($compile, $parse) {

    // 페이징까지 처리진행
    var $wrap2 = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody2 = $("<div />", { class: "panel-body collapse in" });
    var $row2 = $("<div />", { class: "row" });
    var $viewSizeWrap = $("<div />", { class: "col-xl-4 col-lg-4 col-md-4 col-sm-2 col-xs-2 col-sm-hidden col-xs-hidden  paging_pad", style:"width:50%" });
    var $formGroup = $("<div />", { class: "form-group form-inline select-size-list"});
    var $label = $("<label />", {text : "{{ :: 'Menu.LIST' | translate }}"});
    var $select = $("<select />", { 
      "aria-controls" : "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
      "ng-change" :"vc.setChangeViewSize()", "ng-model" : "vc.srch.viewSize",
      "ng-options" : "c for c in vc.listSize" });
    var $pagingBarWrap = $("<div />", { class: "col-xl-8 col-lg-8 col-md-8 col-sm-6 col-xs-6 paging_pad", style:"width:50%"});
    var $pullRight =  $("<div />", { class: "paging dataTables_paginate pull-right" });
    var $ul =  $("<ul />", { 
      "uib-pagination" : "",
      "data-ng-if" :"vc.totalItems", "direction-links" :"true", "first-text":"{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
      "name" : "pagination", "next-text" : "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change" : "vc.setPageChanged()", "ng-model":"vc.currentPage",
      "previous-text":"{{'BTN.PAGINATION.PREV'|translate}}", "total-items":"vc.totalItems", "boundary-links":"true",
      "items-per-page":"vc.viewSize", "max-size" : "vc.maxSize", "num-pages":"vc.numPages", "rotate":"false", "template-url" : "components/template/pagination.html"
    });

    $formGroup.append($select.clone());
    $viewSizeWrap.append($formGroup.clone());
    $row2.append($viewSizeWrap.clone());    
    $pullRight.append($ul.clone());
    $pagingBarWrap.append($pullRight.clone());
    $row2.append($pagingBarWrap.clone());
    // $panelBody.append($row2.clone());
    // $panel.append($panelBody.clone());
    // $wrap.append($row2.clone());
    // $row.append($wrap.clone());
    var $last = $("<div />", {
      class : 'row'
    });
    $last.html($row2.clone());

    return {
      transclude : true,
      replace: false,
      restrict : 'E',
      require: false,
      scope :false,
      template : $last.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}]);
//"use strict";
/**
 * @ngdoc Service, Directive
 * @since 2020-01-08
 * @description 
 *   데이터를 입력하여 자동으로 화면을 그려주는 서비스
 *   !!!!중요!!!
 *    - fa-pane 을 통해서 화면을 나누었을 시 동일한 이름으로 변수를 지정하면
 *      리스트화면에 autoPage의 데이터를 변경함
 *      그러한 이유로 변수 선언시 리스트는 apL, 상세는 apD로 변수 선언(서로 다르게)
 *      테스트를 해본 건 아니지만 TAB 역시 비슷할 것으로 보임
 * @version 1.0
 * @namespace autoView
 */

/******************************************************************************** */
// 확장 기능 개발 구간 시작
/******************************************************************************** */
/******************************************************************************** */

/******************************************************************************** */

/* "use strict"; */
webapp.service('autoView',
  ['GLOBAL_CONSTANT', 'StaticVariable', '$rootScope', '$window', '$state', '$stateParams', 'postApi', '$compile', '$interval', '$filter', 'modalFactory', '$timeout', 'gAlert', 'gConfirm', '$translate',
    function autoView(CONSTANT, StaticVariable, $rootScope, $window, $state, $stateParams, postApi, $compile, $interval, $filter, modalFactory, $timeout, gAlert, gConfirm, $translate) {
      return function () {

        var autoView = {
          _vm: {},
          _scope: null,
          _stateParams: null,
          _apis: null,
          _io: null, // initOptions
          _viewType: null,
          _apis: null,
          _tableName: null,
          _keyIdNm: null,
          _formType: null,
          _disabled: null,
          _ngIf: {},
          _ngChange: {},
          _callback: null,
          _addForm: {},
          _alias: null,
          _dataModelNm: null,
          _customCodes: {},
          _noLable: [],
          _required: [],
          _autocomplete: {},
          _pageUrl: '',
          _listClickCallback: "",
          _listSize: CONSTANT.PAGINATION.LISTSIZE,
          _listCheckboxEnable: false,
          _dateInfo: [], // 날짜 타입의 데이터 정보 저장
          _emailInfo : [], // 이메일 데이터 정보 저장
          _telInfo : [], // 전화번호 데이터 정보 저장
          _detailUrl: "",
          _srchTarget: "",
          _timeOption: {},
          _ngClick: {},
          _addRow: [],
          _src: {},
          _printColumn: true,
          _srchModelNm: '',
          _addSrchStack: true,
          _customColSize: "",
          _ctrlClassNm : "",
          _srchDateType : {},
          init: function (options) {

            // 옵션 재 정의
            var _self = this;
            this._vm = options.vm;
            this._scope = options.scope;
            this._stateParams = options.stateParams;
            this._viewType = options.viewType;
            this._apis = options.apis;
            this._tableName = options.tableNm;
            this._keyIdNm = options.keyIdNm;
            this._vm.keyIdNm = options.keyIdNm;
            this._required = options.required;
            this._alias = options.alias;
            this._dataModelNm = options.dataModelNm;
            this._customCodes = options.customCodes;
            this._formType = options.formType;
            this._disabled = options.disabled;
            this._ngIf = options.ngIf;
            this._ngChange = options.ngChange;
            this._callback = options.callback;
            this._ngClick = options.ngClick;
            this._addForm = options.addForm;
            this._timeOption = options.timeOption;
            this._textAreaOption = options.textAreaOption;

            this._detailUrl = options.detailUrl;
            this._addRow = options.addRow;
            this._noLable = options.noLable;
            this._autocomplete = options.autocomplete;
            this._srchTarget = options.srchTarget;
            this._addFormGroup = options.addFormGroup;
            this._customColSize = options.customColSize;
            this._srchDateType = options.srchDateType;
            this._src = options.src;

            this._srchModelNm = options.srchModelNm;

            if (options.listClickCallback && !isNullOrEmpty(options.listClickCallback)) {
              this._listClickCallback = options.listClickCallback;
            }

            if (options.printColumn) {
              this._printColumn = options.printColumn;
            }

            if (options.addSrchStack != undefined) {
              this._addSrchStack = options.addSrchStack;
            }

            if (options.listCheckboxEnable)
              this._vm._listCheckboxEnable = options.listCheckboxEnable;

            // 리스트 검색 사이즈
            if (options.listSize) _self._listSize = options.listSize;
            _self._vm._listSize = _self._listSize;

            if (options.viewSize) _self._viewSize = options.viewSize;
            else _self._vm._viewSize = 10;

            if (options.maxSize) _self._maxSize = options.maxSize;
            else _self._vm._maxSize = 10;

            // 폼타입이 없을 경우 inline을 기본으로 설정 함
            if (isNullOrEmpty(this._formType)) {
              this._formType = mElemTx.layout.inline;
            }

            this._io = options;

            this._vm[options.dataModelNm] = {};

            if (_self._viewType === mViewType.List) {
              if (!_self._stateParams[_self._srchModelNm]) {
                _self._vm[_self._srchModelNm] = {};
                _self._vm[_self._srchModelNm].page = 1;
                _self._vm[_self._srchModelNm].currentPage = 1;
                _self._vm[_self._srchModelNm].viewSize = CONSTANT.PAGINATION.VIEWSIZE;
                _self._vm[_self._srchModelNm].maxSize = CONSTANT.PAGINATION.MAXSIZE;
                _self._vm.currentPage = 1;
                _self._vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
                _self._vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
              } else {
                _self._vm[_self._srchModelNm] = JSON.parse(decodeURIComponent(_self._stateParams[_self._srchModelNm]));
                if (_self._vm[_self._srchModelNm].currentPage) _self._vm.currentPage = _self._vm[_self._srchModelNm].currentPage;
                if (_self._vm[_self._srchModelNm].viewSize) {
                  _self._vm._viewSize = _self._vm[_self._srchModelNm].viewSize;
                  _self._vm.viewSize = _self._vm[_self._srchModelNm].viewSize;
                  _self._vm.currentPage = _self._vm[_self._srchModelNm].page;
                }
                if (_self._vm[_self._srchModelNm].maxSize) {
                  _self._vm._maxSize = _self._vm[_self._srchModelNm].maxSize;
                  _self._vm.maxSize = _self._vm[_self._srchModelNm].maxSize;
                  _self._vm.currentPage = _self._vm[_self._srchModelNm].page;
                }
              }
            }

            this._scope.$watch('$viewContentLoaded', function () {

              _self._listPageUrl = $state.router.globals.current.name;

              // 리스트일 경우 기본 레이아웃 부터 구성한다.
              if (_self._viewType === mViewType.List) {

                if (_self._src && _self._listPageUrl == _self._src.splitDetail) {
                  _self._listPageUrl = $state.router.globals.$current.parent.name;
                }

                // 검색 조건 값이 없을 경우 기본 값으로 설정한다.
                _self.setLayout(); // view Layout 설정

                if (_self.checkEmptyType(_self._vm.fnOpenLayer)) {
                  _self._vm.fnOpenLayer = function (size) {
                    if (size == undefined) size = 550;
                    return fnOpenLayer(size)
                  };
                }
                if (_self.checkEmptyType(_self._vm.fnCloseLayer)) {
                  _self._vm.fnCloseLayer = function () {
                    return fnCloseLayer()
                  };
                }
                if (_self.checkEmptyType(_self._vm.setResetSearch)) {
                  _self._vm.setResetSearch = function () {
                    _self._vm[_self._srchModelNm] = {};
                    _self._vm[_self._srchModelNm].page = 1;
                    _self._vm[_self._srchModelNm].currentPage = 1;
                    _self._vm[_self._srchModelNm].viewSize = CONSTANT.PAGINATION.VIEWSIZE;
                    _self._vm[_self._srchModelNm].maxSize = CONSTANT.PAGINATION.MAXSIZE;
                    _self._vm.currentPage = 1;
                    _self._vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
                    _self._vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
                    _self.search();
                  };
                }

                if (_self.checkEmptyType(_self._vm.chkRowAll)) {
                  _self._vm.chkRowAll = function () {
                    var obj = $('tbody [ng-if="vc._listCheckboxEnable"]');
                    for (var i = 0; i < _self._vm[_self._dataModelNm].length; i++) {
                      var ck = obj.eq(i).find("input[type=checkbox]");
                      if(ck.attr("disabled") != "disabled")
                        _self._vm[_self._dataModelNm][i].chkRow = _self._vm.checkListCheckbox;
                    }
                  };
                }

                if (_self.checkEmptyType(_self._vm.getSearch)) {
                  _self._vm.getSearch = function (param) {
                    if (_self._addSrchStack || param === true) {
                      var srch = encodeURIComponent(JSON.stringify(_self._vm[_self._srchModelNm], replacer));
                      $state.go(_self._listPageUrl, { srch: srch }, { reload:_self._listPageUrl });
                    } else {
                      fnCloseLayer();
                      var cp = {};
                      if (_self._apis.initSelectCnt.param) { cp = angular.copy(_self._apis.initSelectCnt.param); }
                      if (_self._vm[_self._srchModelNm]) {
                        cp = Object.assign(_self._vm[_self._srchModelNm], cp);
                      }

                      cp.mapCode = _self._apis.initSelectCnt.mapCode;
                      cp = _self.makeDefaultSendData(cp);

                      cp = _self.setSrchDate(cp);
                      
                      _self.getData(cp, function (resultCnt) {
                        _self._vm._totalItems = (resultCnt.body.docs.length > 0) ? resultCnt.body.docs[0] : 0;
                        cp.mapCode = _self._apis.initSelect.mapCode;
                        _self.getData(cp, function (result) {
                          _self._vm[_self._dataModelNm] = result.body.docs;
                        });
                      });
                    }

                    _self._vm.SearchConditionStr = getSearchConditionStr(_self._vm._totalItems, _self._vm._columnMaps, _self._vm.srch);
                  };
                }

                _self._vm.getTest = function(call) {
                  console.log(call);

                  if (call != undefined) {
                    console.log('getTest()');
                  }
                };

                if (_self.checkEmptyType(_self._vm.setPageChanged)) {
                  _self._vm.setPageChanged = function () {
                    _self._vm.srch.page = _self._vm.currentPage; // 조회 할 페이지 번호
                    _self._vm.currentPage = _self._vm.currentPage;
                    _self.search();
                  };
                }

                // 리스트에 보여질 갯수 변경 시
                if (_self.checkEmptyType(_self._vm.setChangeViewSize)) {
                  _self._vm.setChangeViewSize = function () {

                    if (_self._vm[_self._srchModelNm]) {
                      _self._vm[_self._srchModelNm].page = 1;
                      _self._vm[_self._srchModelNm].viewSize = _self._vm._viewSize;
                    }

                    _self._vm.currentPage = 1; // 1페이지 부터 조회
                    _self._vm.viewSize = _self._vm._viewSize; // 목록 당 조회 건수

                    _self.search();
                  };
                }
              } else {
                _self._vm.layout = $rootScope.gVariable.layoutBoard;
              }

              if (_self.checkEmptyType(_self._vm.deleteModalData)) {
                _self._vm.deleteModalData = function (str) {
                  delete _self._vm[_self._dataModelNm][str];
                  delete _self._vm[_self._dataModelNm][str + "Nm"];
                };
              }

              // Srch 기준으로 BaseSelect 데이터 다운로드
              if (_self.checkEmptyType(_self._vm.getExcelFile)) {
                _self._vm.getExcelFile = function () {

                  if (_self._io.apis && _self._io.apis.initSelect) {

                    var p = {};

                    if (_self._apis.initSelect.param) { p = angular.copy(_self._apis.initSelect.param); }

                    if (!_self._stateParams[_self._srchModelNm]) {
                      _self._vm[_self._srchModelNm] = Object.assign(p, _self._vm[_self._srchModelNm]);
                      p = angular.copy(_self._vm[_self._srchModelNm]);
                    }

                    p.isExcel = 'Y';  // 엑셀일 경우 페이징처리를 안타기 위함

                    p.isDescList = 'N';
                    p.mapCode = _self._apis.initSelect.mapCode;
                    p = _self.makeDefaultSendData(p);
                    p = _self.setSrchDate(p);

                    //console.log("cp", p);

                    _self.getData(p, function (result) {
                      if (result.body.docs.length == undefined) {
                        gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
                        return;
                      }
                      if (result.body.docs.length == 0) {
                        gAlert("", "데이터가 없습니다.");
                        return;
                      }

                      _self._scope.jsonToExport = result.body.docs;
                      _self._scope.exportData = [];

                      var today = new Date();
                      if (_self._apis.initSelect.excelFileName) {
                        _self._scope.fileName = _self._apis.initSelect.excelFileName + "_" + today.getFullYear() + today.getMonth() + today.getDate();
                      } else {
                        _self._scope.fileName = "엑셀다운로드_" + today.getFullYear() + today.getMonth() + today.getDate();
                      }

                      var obj = [];
                      angular.forEach(_self._vm._columnMaps, function (item) {
                        if (item.ListColumnShowLevel != "showlevel0") {
                          obj.push(item.ColumnLogicalNm);
                        }
                      });
                      _self._scope.exportData.push(obj);

                      // Data:
                      angular.forEach(_self._scope.jsonToExport, function (value) {
                        obj = [];
                        angular.forEach(_self._vm._columnMaps, function (item) {

                          var dt = item.ColumnLogicalDataType;

                          if (dt == "40" || dt == "41" || dt == "42" || dt == "90") {
                            if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                              if (dt == "90") {
                                obj.push($filter('autoViewUtcToLocal')(value[item.ColumnPhysicalNm]).substr(0, 16));
                              } else {
                                obj.push($filter('autoViewUtcToLocal')(value[item.ColumnPhysicalNm]).substr(0, 10));
                              }
                            } else {
                              obj.push(value[item.ColumnPhysicalNm]);
                            }
                          }
                          else {
                            obj.push(value[item.ColumnPhysicalNm]);
                          }
                        });
                        _self._scope.exportData.push(obj);
                      });

                      $rootScope.excelDown(_self._scope.exportData, _self._scope.fileName);
                      //console.log("result.body.docs",result.body.docs);
                    });
                  }
                };
              }

              // 체크박스 선택한 리스트 다운로드
              if (_self.checkEmptyType(_self._vm.getExcelCheckDataFile)) {
                _self._vm.getExcelCheckDataFile = function () {

                };
              }

              // 리스트 정렬 버튼 클릭 시
              if (_self.checkEmptyType(_self._vm.setSortColumn)) {
                _self._vm.setSortColumn = function (sortColumn, isSortable, liCol) {
                  if (isSortable == 'N') return;
                  // 정렬순서(오름차순, 내림차순) 설정
                  if (_self._vm[_self._srchModelNm].sortColumn != sortColumn) {
                    _self._vm[_self._srchModelNm].sortDirect = "ASC";
                  } else if (_self._vm[_self._srchModelNm].sortColumn == sortColumn) {
                    if (_self._vm[_self._srchModelNm].sortDirect == "ASC") {
                      _self._vm[_self._srchModelNm].sortDirect = "DESC"
                    } else {
                      _self._vm[_self._srchModelNm].sortDirect = "ASC"
                    }
                  } else {
                    _self._vm[_self._srchModelNm].sortDirect = (_self._vm[_self._srchModelNm].sortDirect == "ASC" ? "DESC" : "ASC");
                  }
                  _self._vm[_self._srchModelNm].sortColumn = sortColumn;
                  _self.search();
                };
              }

              // 리스트 정렬 시 아이콘 변경
              if (_self.checkEmptyType(_self._vm.setSortDirect)) {
                _self._vm.setSortDirect = function (sortColumn) {
                  if (sortColumn != _self._vm[_self._srchModelNm].sortColumn) {
                    return 'fa fa-sort';
                  }
                  var rtnval = '';
                  // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
                  (_self._vm[_self._srchModelNm].sortDirect == 'ASC') ? rtnval = 'fa-caret-down' : rtnval = 'fa fa-caret-up';
                  return rtnval;
                };
              }

              var ctrlClassNm = "ctrl-" + _self._scope.controllerName.split(" ")[0].toLowerCase() + "-wrap";
              _self._ctrlClassNm = ctrlClassNm;
              if ($(".modal-dialog").length > 0) {
                $(".modal-dialog").eq($(".modal-dialog").length-1).css("opacity", 0);

                if(!$(".modal-dialog").eq($(".modal-dialog").length-1).hasClass(_self._ctrlClassNm)) {
                  $("[ng-controller='" + _self._scope.controllerName + "']").css("opacity", 0);
                }
              } else {
                $("[ng-controller='" + _self._scope.controllerName + "']").css("opacity", 0);                
              }
              $("[ng-controller='" + _self._scope.controllerName + "']").addClass(ctrlClassNm);

              var metaPatam = _self.makeDefaultSendData({});
              metaPatam.mapCode = "baseDescList";
              var opacitySec = 380;
              _self.getData(metaPatam, function (result) {
                // columnSection 이 없는 폼을 등록하기 위한 임시 Wrapper
                $("[ng-controller='" + _self._scope.controllerName + "'] .pagecontent").append($("<div />", { class: "autoViewWrap" }));
                _self._vm._columnMaps = angular.copy(result.columnMap);

                if (!_self._vm._columnMaps) _self._vm._columnMaps = {};

                if (_self._viewType === mViewType.Edit) { // 상세페이지

                  _self.drawMetaForms(_self._vm._columnMaps, function () {
                    if ($(".modal-dialog").length > 0) {

                      $(".modal-dialog").eq($(".modal-dialog").length-1).animate({
                        opacity: 1
                      }, opacitySec, function () {

                        $(".modal-dialog").eq($(".modal-dialog").length-1).addClass("complate-load-ctrl-view");
                        if(!$(".modal-dialog").eq($(".modal-dialog").length-1).hasClass(_self._ctrlClassNm)) {
                          $("[ng-controller='" + _self._scope.controllerName + "']").animate({
                            opacity: 1
                          }, opacitySec, function () { 
                            $("[ng-controller='" + _self._scope.controllerName + "']").addClass("complate-load-ctrl-view");
                          });
                        }
                       });

                    } else {
                      $("[ng-controller='" + _self._scope.controllerName + "']").animate({
                        opacity: 1
                      }, opacitySec, function () { 
                        $("[ng-controller='" + _self._scope.controllerName + "']").addClass("complate-load-ctrl-view");
                      });
                    }

                    _self.printMataColsInfo();
                  });
                } else {
                  _self._vm._listColumns = angular.copy(result.columnMap);
                  var drawSrchData = [];
                  angular.forEach(_self._vm._listColumns, function (item) {
                    if (item.SearchColumnShowYN == "Y") {
                      if (item.SearchColumnRowCount == 0) item.EditColumnRowCount = 1;
                      else item.EditColumnRowCount = item.SearchColumnRowCount;

                      item.columnSection = _self._srchTarget;
                      drawSrchData.push(item);
                    }
                  });

                  _self.drawMetaForms(drawSrchData, function () {
                    _self._vm.listToPage = function (row) {
                      var key = row[_self._keyIdNm];
                      _self._scope.selectedRow = key;
                      if (!isNullOrEmpty(_self._listClickCallback)) {
                        _self._listClickCallback(row);
                      } else {
                        _self._vm._goListToEdit(row);
                      }
                    };

                    _self._vm._goListToEdit = function (row) {
                      var url = (_self._vm.layout == 'N') ? _self._src.detail : _self._src.splitDetail;
                      var param = {};
                      param[_self._keyIdNm] = row[_self._keyIdNm];
                      var srch = _self._vm.srch;
                      if (srch != undefined) param.srch = encodeURIComponent(JSON.stringify(srch));

                      try {
                        if (!isNullOrEmpty(url)) {
                          $state.go(url, param, { reload: url });
                        }
                      } catch (e) {
                        console.log('Error:', e);
                      }
                    };

                    if ($(".modal-dialog").length > 0) {
                      $(".modal-dialog").eq($(".modal-dialog").length-1).animate({
                        opacity: 1
                      }, opacitySec, function () { 
                        $(".modal-dialog").eq($(".modal-dialog").length-1).addClass("complate-load-ctrl-view");
                        if(!$(".modal-dialog").eq($(".modal-dialog").length-1).hasClass(_self._ctrlClassNm)) {
                          $("[ng-controller='" + _self._scope.controllerName + "']").animate({
                            opacity: 1
                          }, opacitySec, function () { 
                            $("[ng-controller='" + _self._scope.controllerName + "']").addClass("complate-load-ctrl-view");
                          });
                        }
                      });
                      
                    } else {
                      $("[ng-controller='" + _self._scope.controllerName + "']").animate({
                        opacity: 1
                      }, opacitySec, function () { 
                        $("[ng-controller='" + _self._scope.controllerName + "']").addClass("complate-load-ctrl-view");
                      });
                    }

                    _self.printMataColsInfo();
                  });
                }

                //#region InitSelect 함수 호출
                // apis initSelect 값이 존재하면 기본적으로 데이터를 호출한다.
                if (_self._io.apis && _self._io.apis.initSelect) {
                  var p = {};
                  if (_self._apis.initSelect.param) { p = angular.copy(_self._apis.initSelect.param); }
                  p.isDescList = 'N';
                  p.mapCode = _self._apis.initSelect.mapCode;
                  p = _self.makeDefaultSendData(p);

                  if (_self._viewType === mViewType.Edit) { // 상세페이지
                    _self.getData(p, function (result) {
                      if (!_self.checkEmptyType(_self._vm.onReadyAutoView)) {
                        if (result.body.docs.length > 0) {
                          var keys = Object.keys(result.body.docs[0]);
                          var at = result.body.docs[0];
                          for (var i = 0; i < keys.length; i++) {
                            if (isNullOrEmpty(result.body.docs[0][keys[i]])) result.body.docs[0][keys[i]] = "";
                            else {
                              var atData = _self._vm._columnMaps[keys[i]];

                              if (atData != undefined) {
                                if (atData.ColumnLogicalDataType == "40") { // Date

                                } else if (atData.ColumnLogicalDataType == "90") { // DateTime
                                  var temp = angular.copy(at[atData.ColumnPhysicalAsNm]).toString();
                                  var tempDate;

                                  try {
                                    temp = temp.replace(" ", "T");
                                    tempDate = new Date(temp).toISOString();  // IOS환경 Date 처리 
                                  } catch (e) {
                                    console.log('Error:', e);
                                    // toISOString() 오류 발생시 처리 
                                    tempDate = new Date(temp); 
                                  }

                                  if (temp.indexOf("-") > -1) {
                                    var curr = new Date();
                                    // at[atData.ColumnPhysicalAsNm] = new Date(at[atData.ColumnPhysicalAsNm]).getTime() + (curr.getTimezoneOffset() * -1 * 60 * 1000);
                                    at[atData.ColumnPhysicalAsNm] = new Date(tempDate).getTime() + (curr.getTimezoneOffset() * -1 * 60 * 1000);
                                  }
                                }
                              }
                            }
                          }
                          _self._vm[_self._dataModelNm] = result.body.docs[0];
                          _self._vm.onReadyAutoView();
                        } else {
                          _self._vm[_self._dataModelNm] = {};
                          _self._vm.onReadyAutoView();
                        }

                      }
                    });
                  } else {  // 목록 페이지

                    var cp = {};
                    if (_self._apis.initSelect.param) {
                      cp = angular.copy(_self._apis.initSelect.param);
                      if (!_self._stateParams[_self._srchModelNm]) {
                        _self._vm[_self._srchModelNm] = Object.assign(_self._apis.initSelect.param, _self._vm[_self._srchModelNm]);
                        cp = angular.copy(_self._vm[_self._srchModelNm]);
                      }
                    }

                    if (_self._apis.initSelectCnt) {
                      cp.mapCode = _self._apis.initSelectCnt.mapCode;
                      cp = _self.makeDefaultSendData(cp);

                      if (_self._addSrchStack) {
                        var keys = Object.keys(_self._vm[_self._srchModelNm]);
                        for (var i = 0; i < keys.length; i++) {
                          cp[keys[i]] = _self._vm[_self._srchModelNm][keys[i]];
                          p[keys[i]] = _self._vm[_self._srchModelNm][keys[i]]
                        }
                      }

                      cp = _self.setSrchDate(cp);
                      p = _self.setSrchDate(p);

                      _self.getData(cp, function (resultCnt) {
                        _self._vm._totalItems = (resultCnt.body.docs.length > 0) ? resultCnt.body.docs[0] : 0;
                        _self.getData(p, function (result) {
                          _self._vm[_self._dataModelNm] = result.body.docs;

                          if (!_self.checkEmptyType(_self._vm.onReadyAutoView)) {
                            _self._vm.onReadyAutoView();
                          }

                          _self._vm.SearchConditionStr = getSearchConditionStr(_self._vm._totalItems, _self._vm._columnMaps, _self._vm.srch);
                        });
                      });
                    } else {
                      if (_self._addSrchStack) {
                        var keys = Object.keys(_self._vm[_self._srchModelNm]);
                        for (var i = 0; i < keys.length; i++) {
                          cp[keys[i]] = _self._vm[_self._srchModelNm][keys[i]];
                          p[keys[i]] = _self._vm[_self._srchModelNm][keys[i]]
                        }
                      }
                      cp = _self.setSrchDate(cp);
                      p = _self.setSrchDate(p);
                      _self.getData(p, function (result) {
                        _self._vm[_self._dataModelNm] = result.body.docs;

                        if (!_self.checkEmptyType(_self._vm.onReadyAutoView)) {
                          _self._vm.onReadyAutoView();
                        }
                      });
                    }
                    _self._scope.selectedRow = _self._stateParams[_self._keyIdNm];
                  }
                } else {
                  if (!_self.checkEmptyType(_self._vm.onReadyAutoView)) {
                    _self._vm.onReadyAutoView();
                  }
                }
                ////#endregion
              })
            });
          },

          setSrchDate : function(cp) {

            var _self = this;
            for(var i = 0; i < _self._dateInfo.length; i++) {
              var dateKey = _self._dateInfo[i].keyNm;
              var cpDate = cp[dateKey];
              if(cpDate != undefined) {
                if (typeof cpDate === "string" && cpDate != "") {
                  if(cpDate.indexOf("T") > -1) {
                    var temp = cpDate.split("T")[0].split("-");
                    cp[dateKey + "Full"] = cpDate.split("T")[0];
                    cp[dateKey + "Yyyy"] = temp[0];
                    cp[dateKey + "Mm"] = temp[1];
                    cp[dateKey + "Dd"] = temp[2];
                    cp[dateKey + "MmDd"] = temp[1] + "-" +temp[2];
                  }
                } else {
                  var temp = cpDate.year() + "-" + (cpDate.month() + 1) + "-" + cpDate.date();
                  cp[dateKey] = moment(new Date(temp)).format("YYYY-MM-DD");
                  temp = moment(new Date(temp)).format("YYYY-MM-DD");
                  cp[dateKey + "Full"] = temp;
                  temp = temp.split("-");
                  cp[dateKey + "Yyyy"] = temp[0];
                  cp[dateKey + "Mm"] = temp[1];
                  cp[dateKey + "Dd"] = temp[2];
                  cp[dateKey + "MmDd"] = temp[1] + "-" +temp[2];
                }
                if(_self._srchDateType && _self._srchDateType[dateKey]) {
                  cp[dateKey] = _self.setSrchDateType(cp[dateKey], _self._srchDateType[dateKey]);
                }
              }
            }
            return cp;
          },

          setSrchDateType : function(date, type) {
            return $filter('localToUtc')(date, type);
          },

          setLayout: function (D) {
            var _self = this;
            this._vm.layout = $rootScope.gVariable.layoutBoard;
            this.initChangeLayout();
          },

          initChangeLayout: function () {
            var _self = this;

            switch (_self._vm.layout) {
              case "H":
                // 수평
                _self._vm.anchor = "north";
                _self._vm.paneMin = "300px";
                break;
              case "V":
                // 수직
                _self._vm.anchor = "west";
                _self._vm.paneMin = "600px";
                break;
              case "N":
                // 기본
                _self._vm.anchor = "";
                _self._vm.paneMin = "600px";
                break;
            }

            _self._vm.setChangeLayout = function (layout, vc) {

              var vm = _self._vm;
              $window.sessionStorage.setItem('layoutBoard', layout);
              $rootScope.gVariable.layoutBoard = layout;
              var srch = vc.srch; // 검색 옵션
              var url = null;
              var param = {};
              url = _self._listPageUrl;

              if (url != $state.router.globals.current.name) {
                url = $state.router.globals.current.name;
              }

              if (param == undefined) param = {};
              if (srch != undefined) param.srch = encodeURIComponent(JSON.stringify(srch));
              else param.srch = "";
              param = JSON.stringify(param);
              $state.go(url, JSON.parse(param), { reload: true });
            };
          },

          addForm: function (D, callback) {

            if (Array.isArray(D)) {
              var temp = {};
              for (var i = 0; i < D.length; i++) {
                temp[D[i].code] = D[i];
                delete temp[D[i].code].code;
              }
              this.drawMetaForms(temp, function () {
                if (callback != undefined) callback();
              }, true);
            } else {
              this.drawMetaForms(D, function () {
                if (callback != undefined) callback();
              }, true);
            }
          },

          drawMetaForms: function (D, callback, callAddFormFn, callAddFormGroupFn) {
            var _self = this;
            var keys = Object.keys(D);

            var compileSection = [];
            if (callAddFormFn == undefined) {
              for (var i = 0; i < keys.length; i++) {
                if (D[keys[i]].ColumnLogicalDataType == "10") D[keys[i]].dataType = mElemTx.input;
                else if (D[keys[i]].ColumnLogicalDataType == "20") D[keys[i]].dataType = mElemTx.number;
                else if (D[keys[i]].ColumnLogicalDataType == "30") D[keys[i]].dataType = mElemTx.realNumber;
                else if (D[keys[i]].ColumnLogicalDataType == "40") D[keys[i]].dataType = mElemTx.date;
                else if (D[keys[i]].ColumnLogicalDataType == "41") D[keys[i]].dataType = mElemTx.datefrom;
                else if (D[keys[i]].ColumnLogicalDataType == "42") D[keys[i]].dataType = mElemTx.dateto;
                else if (D[keys[i]].ColumnLogicalDataType == "50") D[keys[i]].dataType = mElemTx.select;
                else if (D[keys[i]].ColumnLogicalDataType == "60") D[keys[i]].dataType = mElemTx.image;
                else if (D[keys[i]].ColumnLogicalDataType == "70") D[keys[i]].dataType = mElemTx.tel;
                else if (D[keys[i]].ColumnLogicalDataType == "80") D[keys[i]].dataType = mElemTx.textArea;
                else if (D[keys[i]].ColumnLogicalDataType == "90") D[keys[i]].dataType = mElemTx.dateTime;
                else if (D[keys[i]].ColumnLogicalDataType == "100") D[keys[i]].dataType = mElemTx.radio;
                else if (D[keys[i]].ColumnLogicalDataType == "110") D[keys[i]].dataType = mElemTx.checkbox;
                else if (D[keys[i]].ColumnLogicalDataType == "120") D[keys[i]].dataType = mElemTx.modal;
                else if (D[keys[i]].ColumnLogicalDataType == "121") D[keys[i]].dataType = mElemTx.time;
                else if (D[keys[i]].ColumnLogicalDataType == "122") D[keys[i]].dataType = mElemTx.bindWrap;

                // RowCount 가 없을 경우 1(1/4)로 기본 저장함
                if (!D[keys[i]].EditColumnRowCount || D[keys[i]].EditColumnRowCount == 0) {
                  D[keys[i]].EditColumnRowCount = 4;
                }
                if (!_self.checkOptionCode(D[keys[i]].columnSection, compileSection)) {
                  compileSection.push(D[keys[i]].columnSection)
                }
                _self.setForms(D[keys[i]]);
                if(_self._customCodes && _self._customCodes[ D[keys[i]].ColumnPhysicalAsNm ] ) {
                  if(!_self._vm._columnMaps[D[keys[i]].ColumnPhysicalAsNm]["CodeList"]) {
                    _self._vm._columnMaps[D[keys[i]].ColumnPhysicalAsNm]["CodeList"] = _self._vm[_self._customCodes[D[keys[i]].ColumnPhysicalAsNm]];
                  }
                }
              }
            }

            if (_self._addForm || callAddFormFn) {

              var keys = [];
              var obj = {};
              if (callAddFormFn) {
                keys = Object.keys(D);
                obj = D;
              } else {
                keys = Object.keys(_self._addForm);
                obj = _self._addForm;
              }
              for (var i = 0; i < keys.length; i++) {
                obj[keys[i]].dataType = obj[keys[i]].type;
                obj[keys[i]].ColumnLogicalNm = obj[keys[i]].label;
                obj[keys[i]].EditColumnRowCount = obj[keys[i]].colSize;
                obj[keys[i]].ColumnPhysicalAsNm = keys[i];

                if (!_self._vm._columnMaps[keys[i]]) {
                  _self._vm._columnMaps[keys[i]] = {
                    dataType: obj[keys[i]].type,
                    ColumnLogicalNm: obj[keys[i]].label,
                    ColumnPhysicalAsNm: keys[i],
                    ColumnLogicalDataType : obj[keys[i]].type
                  }

                  if(_self._customCodes && _self._customCodes[keys[i]]) {
                    _self._vm._columnMaps[keys[i]]["CodeList"] = _self._vm[_self._customCodes[keys[i]]];
                  }
                }
                if (isNullOrEmpty(obj[keys[i]].colSize)) obj[keys[i]].EditColumnRowCount = 4;

                if (!_self.checkOptionCode(obj[keys[i]].target, compileSection)) {
                  compileSection.push(obj[keys[i]].target)
                }

                _self.setForms(obj[keys[i]]);
              }
            }

            if (_self._addFormGroup || callAddFormGroupFn) {
              var keys = [];
              var obj = {};
              if (callAddFormFn) {
                keys = Object.keys(D);
                obj = D;
              } else {
                keys = Object.keys(_self._addFormGroup);
                obj = _self._addFormGroup;
              }

              for (var i = 0; i < keys.length; i++) {

                if (obj[keys[i]].bindKey && obj[keys[i]].type != mElemTx.address) {
                  for (var j = 0; j < obj[keys[i]].bindKey.length; j++) {
                    obj[keys[i]].dataType = obj[keys[i]].type;
                    obj[keys[i]].ColumnLogicalNm = obj[keys[i]].label;
                    obj[keys[i]].EditColumnRowCount = obj[keys[i]].colSize;
                    obj[keys[i]].ColumnPhysicalAsNm = obj[keys[i]].bindKey[j];
                    obj[keys[i]].GroupNm = keys[i];
                    if (!obj[keys[i]].addDivision) {
                      obj[keys[i]].addDivision = false;
                    }

                    _self._vm._columnMaps[keys[i]] = {
                      dataType: obj[keys[i]].type,
                      ColumnLogicalNm: obj[keys[i]].label,
                      ColumnPhysicalAsNm: keys[i],
                      ColumnLogicalDataType : obj[keys[i]].type
                    };

                    if(_self._customCodes && _self._customCodes[keys[i]]) {
                      _self._vm._columnMaps[keys[i]]["CodeList"] = _self._vm[_self._customCodes[keys[i]]];
                    }

                    if (isNullOrEmpty(obj[keys[i]].colSize)) obj[keys[i]].EditColumnRowCount = 4;

                    if (!_self.checkOptionCode(obj[keys[i]].target, compileSection)) {
                      compileSection.push(obj[keys[i]].target)
                    }

                    _self.setForms(obj[keys[i]], true);
                  }

                
                }
                else if (obj[keys[i]].bind && obj[keys[i]].type != mElemTx.address) {
                  for (var j = 0; j < obj[keys[i]].bind.length; j++) {
                    var at = obj[keys[i]].bind[j];

                    obj[keys[i]].dataType = at.type;
                    obj[keys[i]].ColumnLogicalNm = obj[keys[i]].label;
                    obj[keys[i]].EditColumnRowCount = obj[keys[i]].colSize;
                    obj[keys[i]].ColumnPhysicalAsNm = at.bindKey;
                    obj[keys[i]].GroupNm = keys[i];

                    if (!obj[keys[i]].addDivision) {
                      obj[keys[i]].addDivision = false;
                    }

                    _self._vm._columnMaps[keys[i]] = {
                      dataType: obj[keys[i]].type,
                      ColumnPhysicalAsNm: obj[keys[i]].label,
                      ColumnLogicalDataType : obj[keys[i]].type
                    };

                    if(_self._customCodes && _self._customCodes[keys[i]]) {
                      _self._vm._columnMaps[keys[i]]["CodeList"] = _self._vm[_self._customCodes[keys[i]]];
                    }


                    if (isNullOrEmpty(obj[keys[i]].colSize)) obj[keys[i]].EditColumnRowCount = 4;

                    if (!_self.checkOptionCode(obj[keys[i]].target, compileSection)) {
                      compileSection.push(obj[keys[i]].target)
                    }

                    _self.setForms(obj[keys[i]], true);

                  }
                }
              }
            }

            for (var i = 0; i < compileSection.length; i++) {
              $compile(angular.element("#" + compileSection[i]))(_self._scope)
            }

            callback();
          },

          setForms: function (item, formGroupYn) {

            var _self = this;
            var _formType = this._formType;
            var bindKey = _self._alias + "." + _self._dataModelNm + "." + item.ColumnPhysicalAsNm;
            if (_self._viewType === mViewType.List) {
              bindKey = _self._alias + "." + _self._srchModelNm + "." + item.ColumnPhysicalAsNm;
            }
            var col = item.EditColumnRowCount, colClass;
            var checkUseZipCode = false;
            var elem = $('html');
            if (isNullOrEmpty(item.columnSection)) {
              // 지정된 Section이 없을 경우
              elem = elem.find(".autoViewWrap");
            } else {
              // id, class 구분이 없을 경우 기본 ID 값으로 지정
              elem = (item.columnSection.indexOf("#") != 0 && item.columnSection.indexOf(".") != 0) ? $("#" + item.columnSection) : $(item.columnSection);
            }

            if (col == 4) colClass = "col-xxs-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
            else if (col == 3) colClass = "col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4";
            else if (col == 2) colClass = "col-xxs-12 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
            else if (col == 1) colClass = "col-xxs-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";

            if (_self._customColSize && _self._customColSize[item.ColumnPhysicalAsNm]) {
              colClass = _self._customColSize[item.ColumnPhysicalAsNm];
            }
            //customColSize

            //inputType 공통을 위한 처리
            var elemType = item.dataType;
            if (elemType == mElemTx.number || elemType == mElemTx.realNumber || elemType == mElemTx.tel) {
              elemType = mElemTx.input;
            }

            var fObj = this.getBaseElem(elemType, colClass, _formType);
            var copyObj = fObj.clone(true);

            var mainWrap = $("<div />", { class: colClass });

            // 공통사용 Element 선언
            var input = copyObj.find("input");
            var bindWrap = copyObj.find(".bind-wrap");
            var select = copyObj.find("common-code-custom");
            var mdCheckbox = $("<md-checkbox />", {});
            var inputGroup = $("<div />", { class: "input-group" });
            var radioInline = copyObj.find(".radio-inline");
            var textarea = copyObj.find("textarea");
            var zipWrap = copyObj.find("> div").eq(0);
            var add1Wrap = copyObj.find("> div").eq(1);
            var add2Wrap = copyObj.find("> div").eq(2);

            var dateForm = copyObj.find("date-input");
            var dateTimeForm = copyObj.find("datetime-picker");
            var timeForm = copyObj.find("time-input");

            // input 텍스트 정의
            // if(item.dataType == mElemTx.input || item.dataType == mElemTx.number || item.dataType == mElemTx.realNumber
            //   || item.dataType == mElemTx.tel){


            if (item.dataType == mElemTx.input) {
              if (_self._autocomplete && _self._autocomplete[item.ColumnPhysicalAsNm]) {

                var sac = $("<sz-auto-complete />");

                // input.attr("ng-init", _self._alias + "." + "act_" + item.ColumnPhysicalAsNm + "Focus = 'N'");
                sac.attr("code-list", _self._alias + "." + _self._autocomplete[item.ColumnPhysicalAsNm].codeList);
                sac.attr("code-model", _self._alias + "." + _self._dataModelNm + "." + item.ColumnPhysicalAsNm);
                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].keyNm)) {
                  sac.attr("code-key", _self._alias + "." + _self._dataModelNm + "." + _self._autocomplete[item.ColumnPhysicalAsNm].keyNm);
                }
                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].callback)) {
                  sac.attr("callback", _self._alias + "." + _self._autocomplete[item.ColumnPhysicalAsNm].callback);
                }
                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].format)) {
                  sac.attr("format", _self._autocomplete[item.ColumnPhysicalAsNm].format);
                }

                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].addTopRow)) {
                  sac.attr("add-top-row", _self._autocomplete[item.ColumnPhysicalAsNm].addTopRow);
                }

                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].addTopRowCallback)) {
                  sac.attr("add-top-row-callback", _self._alias + "." + _self._autocomplete[item.ColumnPhysicalAsNm].addTopRowCallback);
                }

                if (!isNullOrEmpty(_self._autocomplete[item.ColumnPhysicalAsNm].ngChange)) {
                  sac.attr("change-callback", _self._alias + "." + _self._autocomplete[item.ColumnPhysicalAsNm].ngChange);
                }

                // input.attr("ng-focus", _self._alias + "." + "act_" + item.ColumnPhysicalAsNm + "Focus = 'Y'");
                // input.attr("ng-blur", _self._alias + "." + "act_" + item.ColumnPhysicalAsNm + "Focus = 'N'");
                sac.attr("is-focus", _self._alias + "." + "act_" + item.ColumnPhysicalAsNm + "Focus");

                if (_self._disabled && _self._disabled[item.ColumnPhysicalAsNm] != undefined) {
                  sac.attr("ng-disabled", _self._disabled[item.ColumnPhysicalAsNm]);
                }

                sac.attr("init-value", bindKey);

                copyObj.find("input").after(sac.clone());
                copyObj.find("input").detach();
              }

              if(item.ColumnPhysicalAsNm.toLowerCase().indexOf("email") > -1) {
                _self._emailInfo.push(item.ColumnPhysicalAsNm);  
              }
            }

            if (item.dataType == mElemTx.number) {
              input.attr('comma', '');
            }

            if (item.dataType == mElemTx.tel) {
              input.attr('auto-hyphen-tel', '');
              _self._telInfo.push(item.ColumnPhysicalAsNm);
            }

            // 모달형식
            if (item.dataType == mElemTx.modal) {
              var btns = copyObj.find(".input-group-btn button");


              if (_self._ngClick && _self._ngClick[item.ColumnPhysicalAsNm]) {
                btns.eq(0).attr("ng-click", _self._alias + "." + _self._ngClick[item.ColumnPhysicalAsNm] + "()");
              }

              btns.eq(1).attr("ng-click", _self._alias + ".deleteModalData('" + item.ColumnPhysicalAsNm + "');");
            }

            // 날짜 형식
            if (item.dataType == mElemTx.date || item.dataType == mElemTx.datefrom || item.dataType == mElemTx.dateto) {
              var dateKey = "autoView_data_" + item.ColumnPhysicalAsNm;
              //_self._vm[dateKey] = '';
              // Append-to-Body 는 기본 true 로 설정
              // 필요할 경우 추가 개발 필요
              //dateForm.attr("date", );

              var dateInfo = { key: dateKey, datetype: item.dataType, bindKey: dateKey, keyNm : item.ColumnPhysicalAsNm};
              _self._dateInfo.push(dateInfo);
            }

            // 날짜(시간) 형식
            if (item.dataType == mElemTx.dateTime) {
              var dateKey = "autoView_data_" + item.ColumnPhysicalAsNm;

              if (_self._timeOption && _self._timeOption[item.ColumnPhysicalAsNm]) {
                if (_self._timeOption[item.ColumnPhysicalAsNm].minuteStep) {
                  dateTimeForm.attr("minute-step", _self._timeOption[item.ColumnPhysicalAsNm].minuteStep);
                }

                if (_self._timeOption[item.ColumnPhysicalAsNm].maxHour) {
                  dateTimeForm.attr("max-hour", _self._timeOption[item.ColumnPhysicalAsNm].maxHour);
                }

                if (_self._timeOption[item.ColumnPhysicalAsNm].minHour) {
                  dateTimeForm.attr("min-hour", _self._timeOption[item.ColumnPhysicalAsNm].minHour);
                }


                if (_self._timeOption[item.ColumnPhysicalAsNm].initActiveCalendar == undefined
                  || _self._timeOption[item.ColumnPhysicalAsNm].initActiveCalendar
                  || _self._timeOption[item.ColumnPhysicalAsNm].initActiveCalendar == "true") {
                  dateTimeForm.attr("init-active-calendar", "true");
                } else {
                  dateTimeForm.attr("init-active-calendar", "false");
                }
              } else {
                dateTimeForm.attr("init-active-calendar", "true");
              }
              var dateInfo = { key: dateKey, datetype: item.dataType, bindKey: dateKey, keyNm : item.ColumnPhysicalAsNm };
              _self._dateInfo.push(dateInfo);
            }

            if (item.dataType == mElemTx.time) {
              var dateKey = "autoView_data_" + item.ColumnPhysicalAsNm;

              if (_self._timeOption && _self._timeOption[item.ColumnPhysicalAsNm]) {
                if (_self._timeOption[item.ColumnPhysicalAsNm].minuteStep) {
                  timeForm.attr("minute-step", _self._timeOption[item.ColumnPhysicalAsNm].minuteStep);
                }
              }
            }

            // SelectBox 형식
            if (item.dataType == mElemTx.select) {

              if (_self._customCodes && _self._customCodes[item.ColumnPhysicalAsNm]) {
                select.attr("code-list", _self._alias + "." + _self._customCodes[item.ColumnPhysicalAsNm].replace("vm.", "vc."));
              } else if (item.customCodes) {
                select.attr("code-list", _self._alias + "." + item.customCodes.replace("vm.", "vc."));
              } else {
                var key = _self._alias + "._columnMaps['" + item.ColumnPhysicalAsNm + "'].CodeList";
                select.attr("code-list", key);
              }

              // 코드 제외인데 많이 사용하지 않은 것 같아 일단 개발 제외
              // if(af.codeExclude != undefined) {
              //   $ccc.attr("code-exclude", af.codeExclude.replace("vm.","vc."));
              // } 
            }

            // checkBox 형식
            if (item.dataType == mElemTx.checkbox) {

              var label = $("<label />", { text: item.ColumnLogicalNm })
              if (_self._customCodes && _self._customCodes[item.ColumnPhysicalAsNm]) {
                _self._vm[_self._dataModelNm][item.ColumnPhysicalAsNm] = _self._vm[_self._customCodes[item.ColumnPhysicalAsNm].replace("vm.", "vc.")];

                mdCheckbox.attr("ng-repeat", "li in " + _self._alias + "." + _self._dataModelNm + "." + item.ColumnPhysicalAsNm.replace("vm.", "vc."));
                mdCheckbox.attr("ng-model", "li.checked");
                mdCheckbox.attr("title", "{{li.CoodeValue}}");
                mdCheckbox.text("{{li.CoodeValue}}");

              } else {
                mdCheckbox.attr("ng-model", _self._alias + "." + _self._dataModelNm + "." + item.ColumnPhysicalAsNm);
                mdCheckbox.attr("title", "");
                mdCheckbox.text("");
              }

              mdCheckbox.attr("ng-true-value", "'Y'");
              mdCheckbox.attr("ng-false-value", "'N'");
              mdCheckbox.attr("role", 'checkbox');
              mdCheckbox.attr("aria-label", "''");

              if (_self._disabled && _self._disabled[item.ColumnPhysicalAsNm] != undefined) {
                mdCheckbox.attr("ng-disabled", _self._disabled[item.ColumnPhysicalAsNm]);
              }

              if (_self._ngChange && _self._ngChange[item.ColumnPhysicalAsNm]) {
                mdCheckbox.attr('ng-change', _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else if (_self._callback && _self._callback[item.ColumnPhysicalAsNm]) {
                mdCheckbox.attr('ng-change', _self._alias + "." + _self._callback[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              }

              inputGroup.html(mdCheckbox.clone());

              copyObj.html(label.clone());
              copyObj.append(inputGroup.clone());
            }

            // radio 형식
            if (item.dataType == mElemTx.radio) {

              copyObj.find("label").eq(0).text(item.ColumnLogicalNm);

              if (_self._customCodes && _self._customCodes[item.ColumnPhysicalAsNm]) {
                radioInline.attr("ng-repeat", "li in " + _self._alias + "." + _self._customCodes[item.ColumnPhysicalAsNm]);
                radioInline.attr("title", "{{li.CodeValue}}");
              } else {
                var key = _self._alias + "._columnMaps['" + item.ColumnPhysicalAsNm + "'].CodeList";

                radioInline.attr("ng-repeat", "li in " + key);
                radioInline.attr("title", "{{li.CodeValue}}");
              }

              input.attr("ng-checked", bindKey + " == li.Code");
            }

            // TextArea 형식
            if (item.dataType == mElemTx.textArea) {
              if (_self._textAreaOption && _self._textAreaOption[item.ColumnPhysicalAsNm]) {
                if (_self._textAreaOption[item.ColumnPhysicalAsNm].rows) {
                  textarea.attr("rows", _self._textAreaOption[item.ColumnPhysicalAsNm].rows);
                } else {
                  textarea.attr("rows", 5);
                }
              } else {
                textarea.attr("rows", 5);
              }
            }

            if (item.dataType == mElemTx.address) {
              checkUseZipCode = true;
              colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7";
              if (item.colSize && item.colSize == 1) {
                colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";
              }
              if (_self._customColSize && _self._customColSize[item.ColumnPhysicalAsNm]) {
                colClass = _self._customColSize[item.ColumnPhysicalAsNm];
              }

              zipWrap.find("label").text(item.ColumnLogicalNm);
              zipWrap.find("label").attr("title", item.ColumnLogicalNm);

              var bindKey = _self._alias + "." + _self._dataModelNm;
              var postCode = bindKey + "." + item.bindKey[0];
              var add1 = bindKey + "." + item.bindKey[1];
              var add2 = bindKey + "." + item.bindKey[2];

              zipWrap.find("input").attr("ng-model", postCode);
              zipWrap.find("button").attr("ng-click", "vc.setAddressField('" + item.bindKey[0] + "','" + item.bindKey[1] + "','" + item.bindKey[2] + "')");
              add1Wrap.find("label").text('주소');
              add1Wrap.find("label").attr("title", "주소");
              add1Wrap.find("input").attr("ng-model", add1);
              add2Wrap.find("label").text('상세주소');
              add2Wrap.find("label").attr("title", "상세주소");
              add2Wrap.find("input").attr("ng-model", add2);
              add2Wrap.find("input").removeAttr("readonly");
            }

            // ng-model 처리
            if (item.dataType == mElemTx.bindWrap) {
              bindWrap.attr("ng-bind", bindKey);
            }

            if (item.dataType == mElemTx.modal) {
              input.eq(0).attr("ng-model", bindKey);
              input.eq(1).attr("ng-model", bindKey + "Nm");
            }

            if (item.dataType != mElemTx.address && item.dataType != mElemTx.modal) {
              if (input) input.attr("ng-model", bindKey);
              if (select) select.attr("code-model", bindKey);
              if (textarea) textarea.attr("ng-model", bindKey);
            }

            // date 형일 경우 ng-model을 bindKey 가 아닌 dataKey로 설정해야함
            if (item.dataType == mElemTx.date || item.dataType == mElemTx.datefrom || item.dataType == mElemTx.dateto) {
              dateForm.attr("date", bindKey);
            }
            if (item.dataType == mElemTx.dateTime) {
              dateTimeForm.attr("datetime", bindKey);
            }
            if (item.dataType == mElemTx.time) {
              timeForm.attr("time", bindKey);
            }

            /** @description 공통 이벤트 처리 **/
            // Change, Callback 처리

            if (_self._ngClick && _self._ngClick[item.ColumnPhysicalAsNm]) {
              if (elemType == mElemTx.modal) {

              } else if (elemType == mElemTx.input) {
                input.attr("ng-click", _self._alias + "." + _self._ngClick[item.ColumnPhysicalAsNm] + "()");
              } else if (elemType == mElemTx.bindWrap) {
                bindWrap.attr("ng-click", _self._alias + "." + _self._ngClick[item.ColumnPhysicalAsNm] + "()");
              }
            }

            if (_self._ngChange && _self._ngChange[item.ColumnPhysicalAsNm]) {
              if (item.dataType == mElemTx.select) {
                select.attr('callback', _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else if (item.dataType == mElemTx.date || item.dataType == mElemTx.datefrom || item.dataType == mElemTx.dateto) {
                dateForm.attr("on-change", _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else if (item.dataType == mElemTx.dateTime) {
                dateTimeForm.attr("on-change", _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else if (item.dataType == mElemTx.time) {
                timeForm.attr("on-change", _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else {
                input.attr('ng-change', _self._alias + "." + _self._ngChange[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              }
            } else if (_self._callback && _self._callback[item.ColumnPhysicalAsNm]) {
              if (item.dataType == mElemTx.select) {
                select.attr('callback', _self._alias + "." + _self._callback[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else if (item.dataType == mElemTx.text || item.dataType == mElemTx.number || item.dataType == mElemTx.input || item.dataType == mElemTx.tel) {
                input.attr('ng-blur', _self._alias + "." + _self._callback[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              } else {
                input.attr('ng-change', _self._alias + "." + _self._callback[item.ColumnPhysicalAsNm] + "('" + item.ColumnPhysicalAsNm + "'," + bindKey + ", this)");
              }
            }
            // else {
            //   // 데이타타입이 Date 일 경우에만 해당
            //   if(item.dataType == mElemTx.date || item.dataType == mElemTx.dateTime) {
            //     var value = bindKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
            //     input.attr("ng-change", value);
            //   }
            // }

            // Disable 처리
            if (_self._disabled && _self._disabled[item.ColumnPhysicalAsNm] != undefined) {

              // 타입별로 분기처리 필요
              var checkDisable = _self._disabled[item.ColumnPhysicalAsNm];
              if (checkDisable === "true" || checkDisable === true) {
                checkDisable = "true";
              } else if (checkDisable === "false" || checkDisable === false) {
                checkDisable = "false";
              } else {
                checkDisable = _self._disabled[item.ColumnPhysicalAsNm];
              }

              if (item.dataType == mElemTx.checkbox) {
                // checkbodx 위에서 선언
              } else if (item.dataType == mElemTx.textArea) {
                textarea.attr("ng-disabled", checkDisable);
              } else if (item.dataType == mElemTx.dateTime) {
                dateTimeForm.attr("ng-disabled", checkDisable);
              } else if (item.dataType == mElemTx.date || item.dataType == mElemTx.datefrom || item.dataType == mElemTx.dateto) {
                dateForm.attr("ng-disabled", checkDisable);
              } else if (item.dataType == mElemTx.time) {
                timeForm.attr("ng-disabled", checkDisable);
              } else if (item.dataType == mElemTx.select) {
                select.attr("is-disabled", checkDisable)
              } else {
                input.attr("ng-disabled", checkDisable);
              }
              // var dateForm = copyObj.find("date-input");
              // var dateTimeForm = copyObj.find("datetime-input");
              // var timeForm = copyObj.find("time-input");

            }

            // 라벨 정의
            if (item.dataType != mElemTx.radio && item.dataType != mElemTx.checkbox) {
              var label = copyObj.find("label");

              var labelTx = item.ColumnLogicalNm;
              if (isNullOrEmpty(labelTx)) labelTx = "";

              // 필수 항목 체크
              if (_self._required && _self.checkOptionCode(item.ColumnPhysicalAsNm, _self._required)) {
                copyObj.find("label").html('<span style="color:red">* </span>' + labelTx);
                copyObj.addClass("required-wrap");
              } else if (item.required) {
                if ((_self._noLable && _self.checkOptionCode(item.ColumnPhysicalAsNm, _self._noLable)) || item.noLable) {
                  copyObj.find("label").html('<span style="color:red; position:absolute; top: 12px; left: 0;">* </span>' + labelTx);
                  copyObj.addClass("required-wrap");
                } else {
                  copyObj.find("label").html('<span style="color:red">* </span>' + labelTx);
                  copyObj.addClass("required-wrap");
                }
                //mainWrap.find('.form-group')

              } else {
                label.html(item.ColumnLogicalNm);
              }

              label.attr("uib-tooltip", item.ColumnLogicalNm);
            }

            var className = item.ColumnPhysicalAsNm + "-col-wrap form-layout-" + _self._formType;
           
            className = className.replaceAll("[", "").replaceAll("]", "").replaceAll(".", "_");

            if (formGroupYn) {
              className = item.GroupNm + "-col-wrap form-layout-" + _self._formType;
              if (item.addDivision) className += " group-form-division-wrap";
              else className += " group-form-wrap";
            }

            if(item.colSize) {
              className += " wrap-col-size-" + item.colSize;
            } else {
              if(_self._viewType === mViewType.Edit) className += " wrap-col-size-" + item.EditColumnRowCount;
              else className += " wrap-col-size-" + item.SearchColumnRowCount;
            }

            var mainWrap = $("<div />", { class: colClass + " " + className + " type-" + item.dataType + "-col-wrap" });
            if (item.dataType == mElemTx.address) {
              mainWrap.addClass("form-addr");
            }

            if (item.dataType == mElemTx.textArea) {
              mainWrap.addClass("col-xs-12");
              mainWrap.removeClass("col-xs-6");
            }
            var rowWrap = $("<div />", { class: "row" });
            if (formGroupYn) {
              if (_self._ngIf && _self._ngIf[item.GroupNm]) {
                mainWrap.attr("ng-if", _self._ngIf[item.GroupNm]);
              }
            } else {
              if (_self._ngIf && _self._ngIf[item.ColumnPhysicalAsNm]) {
                mainWrap.attr("ng-if", _self._ngIf[item.ColumnPhysicalAsNm]);
              }
            }
            //rowWrap.html(copyObj.clone());
            if (item.dataType == mElemTx.address) {
              mainWrap.html(copyObj.clone());
            } else {
              mainWrap.html(copyObj.clone());
            }

            // if(_self._addRow && _self.checkOptionCode(item.ColumnPhysicalAsNm, _self._addRow)) {
            //   var row = $("<div />", {class:"row", style: "margin-left: 0px; margin-right: 0px"});
            //   row.html(mainWrap.clone());
            //   mainWrap = row.clone();
            // } 

            if ((_self._noLable && _self.checkOptionCode(item.ColumnPhysicalAsNm, _self._noLable)) || item.noLable) {
              mainWrap.find('.form-group').removeClass("form-inline");
            }

            if (item.after) {
              var className = item.after + "-col-wrap";
              className = className.replaceAll("[", "").replaceAll("]", "").replaceAll(".", "_");
              var useClass = item.ColumnPhysicalAsNm + "-col-wrap";
              if (formGroupYn) {
                useClass = item.GroupNm + "-col-wrap";
                if ($("." + _self._ctrlClassNm + " ." + useClass).length > 0) {
                  if (item.addDivision) {
                    $("." + _self._ctrlClassNm + " ." + useClass).append("<span>~</span>");
                  }
                 $("." + _self._ctrlClassNm + " ." + useClass).append(mainWrap.html());
                } else {
                  $("." + _self._ctrlClassNm + " ." + className).after(mainWrap.clone());
                }

              } else {
                $("." + _self._ctrlClassNm + " ." + className).after(mainWrap.clone());
              }

            } else if (item.before) {
              var className = item.before + "-col-wrap";
              className = className.replaceAll("[", "").replaceAll("]", "").replaceAll(".", "_");

              if (formGroupYn) {
                useClass = item.GroupNm + "-col-wrap";
                if ($("." + _self._ctrlClassNm + " ." + useClass).length > 0) {
                  if (item.addDivision) {
                    $("." + _self._ctrlClassNm + " ." + useClass).append("<span>~</span>");
                  }
                  $("." + _self._ctrlClassNm + " ." + useClass).append(mainWrap.html());
                } else {
                  $("." + _self._ctrlClassNm + " ." + className).before(mainWrap.clone());
                }
              } else {
                $("." + _self._ctrlClassNm + " ." + className).before(mainWrap.clone());
              }
            } else if (item.target) {

              if (formGroupYn) {
                useClass = item.GroupNm + "-col-wrap";
                if ($("." + _self._ctrlClassNm + " ." + useClass).length > 0) {
                  if (item.addDivision) {
                    $("." + _self._ctrlClassNm + " ." + useClass).append("<span>~</span>");
                  }
                  $("." + _self._ctrlClassNm + " ." + useClass).append(mainWrap.html());
                } else {
                  $("." + _self._ctrlClassNm + " #" + item.target).append(mainWrap.clone());
                }
              } else {
                if($("." + _self._ctrlClassNm + " #" + item.target).length == 0) {
                  $("#" + item.target).append(mainWrap);
                } else {
                  $("." + _self._ctrlClassNm + " #" + item.target).append(mainWrap);
                }
              }
            } else {
              if (_self._addRow && _self.checkOptionCode(item.ColumnPhysicalAsNm, _self._addRow)) {
                var row = $("<div />", { class: "row col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
                //row.html(mainWrap.clone());
                //elem.append(mainWrap);
                row.html(mainWrap.clone());
                elem.append(row.clone());
              } else {
                elem.append(mainWrap);
              }
            }

            if (checkUseZipCode) {
              _self.setAddressFn();
            }
          },

          getBaseElem: function (type, colClass, layout) {

            var thisObj = this;
            var formType = "inner";
            var elemForm = $("<div />", { class: "form-group form-inner-label" });

            if (layout == undefined) {
              if (thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                elemForm = $("<div />", { class: "form-group form-inline" });
                formType = "inline";
              }
            } else {
              if (layout == mElemTx.layout.inline) {
                elemForm = $("<div />", { class: "form-group form-inline" });
              }
              formType = layout;
            }

            if (type == mElemTx.input) {
              var input = $("<input />", { class: "form-control form-right", type: "text" });
              if (formType == "inline") {
                var label = $("<label/>", {});
                elemForm.html(label.clone());
                elemForm.append(input.clone());
              } else {
                elemForm.html(input.clone());
              }
            } else if (type == mElemTx.bindWrap) {
              var span = $("<span />", { class: "form-control form-right bind-wrap" });
              if (formType == "inline") {
                var label = $("<label/>", {});
                elemForm.html(label.clone());
                elemForm.append(span.clone());
              } else {
                elemForm.html(span.clone());
              }
            } else if (type == mElemTx.date || type == mElemTx.datefrom || type == mElemTx.dateto) {
              var elemDateGroup = $("<div />", { class: "input-group" });
              var elemDateInput = $("<date-input />", {});

              if (formType == "inner") {
                elemDateGroup.html(elemDateInput.clone());
                elemForm.html(elemDateGroup.clone());
              } else {
                var label = $("<label />");
                elemDateGroup.html(elemDateInput.clone());
                elemForm.append(label.clone())
                elemForm.append(elemDateGroup.clone())
              }
            } else if (type == mElemTx.dateTime) {

              var elemDateGroup = $("<div />", { class: "input-group" });
              var elemDateTimeInput = $("<datetime-picker />", {});

              if (formType == "inner") {
                elemDateGroup.html(elemDateTimeInput.clone());
                elemForm.html(elemDateGroup.clone());
              } else {
                var label = $("<label />");
                elemDateGroup.html(elemDateTimeInput.clone());
                elemForm.append(label.clone())
                elemForm.append(elemDateGroup.clone())
              }
            } else if (type == mElemTx.time) {
              var elemDateGroup = $("<div />", { class: "input-group" });
              var elemTimeInput = $("<time-input />", {});
              if (formType == "inner") {
                elemDateGroup.html(elemTimeInput.clone());
                elemDateGroup.append(elemDateSpan.clone());
                elemForm.html(elemDateGroup.clone());
              } else {
                var label = $("<label />");
                elemDateGroup.html(elemTimeInput.clone());
                elemForm.append(label.clone())
                elemForm.append(elemDateGroup.clone())
              }
            } else if (type == "text") {
              var input = $("<input />", { class: "form-control form-right", type: "text" });
              if (formType == "inline") {
                var label = $("<label/>", {});
                elemForm.html(label.clone());
                elemForm.append(input.clone());
              } else {
                elemForm.html(input.clone());
              }
            } else if (type == "textarea") {
              var input = $("<textarea />", { class: "form-control" });
              if (formType == "inline") {
                var label = $("<label/>", {});
                elemForm.html(label.clone());
                elemForm.append(input.clone());
              } else {
                elemForm.removeClass("form-inner-label");
                elemForm.html(input.clone());
              }
            } else if (type == "select") {
              var ccc = $("<common-code-custom />", {});
              var label = $("<label/>", {});
              elemForm.html(label.clone());
              elemForm.append(ccc.clone());

            } else if (type == "radio") {
              elemForm.attr("class", "form-group form-inline radio-wrap");
              var label = $("<label />", {});
              var inputGroup = $("<div />", { class: "input-group input-radio-custom-group" });
              var repeatDiv = $("<div />", { class: "radio-inline" });
              var customLabel = $("<label />", { class: "custom-radio-btn" });
              var span1 = $("<span />", { class: "helping-el" });
              var span2 = $("<span />", { class: "label-text", text: '{{li.CodeValue}}' });
              var input = $("<input />", { class: "clr form-right", type: "radio", value: "{{li.Code}}" });

              customLabel.html(input.clone());
              customLabel.append(span1.clone());
              customLabel.append(span2.clone());

              repeatDiv.html(customLabel.clone());
              inputGroup.html(repeatDiv.clone());
              elemForm.html(label.clone());
              elemForm.append(inputGroup.clone());
            } else if (type == "modal") {
              var inputGroup = $("<div />", { class: "input-group" });
              var FormGoup = $("<div />", { class: "form-group form-inline" });
              var input = $("<input />", { class: "form-control form-right", type: "text", readonly: "" });
              var hidden = $("<input />", { class: "form-control form-right", type: "hidden", readonly: "" });
              var label = $("<label/>", {});
              var btnGroupSpan = $("<span />", { class: "input-group-btn" });
              var btnGroupSpanButton = $("<button />", { class: "btn btn-default", type: "button" });
              var btnGroupSpanIco = $("<i />", { class: "fa fa-search" });
              FormGoup.html(label.clone());
              inputGroup.html(hidden.clone());
              inputGroup.append(input.clone());
              FormGoup.append(inputGroup.clone());

              btnGroupSpanButton.html(btnGroupSpanIco.clone());
              btnGroupSpan.html(btnGroupSpanButton.clone());
              btnGroupSpanIco = $("<i />", { class: "fa fa-eraser" });
              btnGroupSpanButton.html(btnGroupSpanIco.clone());
              btnGroupSpan.append(btnGroupSpanButton.clone());
              FormGoup.append(btnGroupSpan.clone());
              return FormGoup;
            } else if (type == "address") {
              var returnRow = $("<div />", { class: "row" });
              var row = $("<div />", { class: "row" });
              var wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" });
              var formGroup = $("<div />", { class: "form-group form-inline" });
              var label = $("<label />", {});
              var inputGroup = $("<div />", { class: "input-group" });
              var input = $("<input />", { class: "form-control", type: "text", readonly: "" });
              var span = $("<span />", { class: "input-group-btn" });
              var button = $("<button />", { class: "btn btn-default", type: "button" });
              var i = $("<i />", { class: "fa fa-search" });

              button.html(i.clone());
              span.html(button.clone());
              inputGroup.html(input.clone());
              inputGroup.append(span.clone());
              formGroup.html(label.clone());
              formGroup.append(inputGroup.clone());
              wrap.html(formGroup.clone());
              row.html(wrap.clone());
              var zipcodeWrap = $("<div />", { class: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4" });
              zipcodeWrap.html(row);
              returnRow.html(zipcodeWrap.clone());

              var addr1 = $("<div />", { class: "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4" });
              formGroup.html(label.clone());
              formGroup.html(input.clone());
              addr1.html(formGroup.clone());
              returnRow.append(addr1);

              var formGroup = $("<div />", { class: "form-group form-inline" });
              var addr2 = $("<div />", { class: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" });
              input.attr("placeholder", "상세주소")
              formGroup.html(input.clone());
              addr2.html(formGroup.clone());
              returnRow.append(addr2);

              return returnRow;
            } else if (type == mElemTx.checkbox) {

            }

            return elemForm;
          },

          checkOptionCode: function (str, A) {
            var check = false;
            for (var i = 0; i < A.length; i++) {
              if (A[i] == str) {
                check = true;
                break;
              }
            }
            return check;
          },

          //postApi의 select 호출
          getData: function (param, callback) {
            postApi.select(param, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                var columnMap = {};
                if (result.body.desc.length > 0) {
                  angular.forEach(result.body.desc, function (item) {
                    columnMap[item.ColumnPhysicalAsNm] = item;
                  });
                  result.columnMap = columnMap;
                }
                callback(result);
              } else {
                callback(result);
                console.log("error");
                // console.error(result);
              }
            }, function (error) {
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          },

          checkInvalid: function () {

          },

          setAddressFn: function () {
            var _self = this;
            if (_self.checkEmptyType(_self._vm.setAddressField)) {
              _self._vm.setAddressField = function (p1, p2, p3) {
                new daum.Postcode({
                  oncomplete: function (data) {

                    var addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;

                    $timeout(function () {
                      _self._vm[_self._dataModelNm][p1] = data.zonecode;
                      _self._vm[_self._dataModelNm][p2] = addr1;
                    }, 0);
                    //_self._vm[_self._dataModelNm][p2] = addr1;
                  },
                }).open();
              };
            }
          },

          search: function (callback) {
            this._vm.getSearch();
          },

          // insert, update 처리를 하는 구간
          // 키값이 있을 경우 update, 없을 경우 insert, mapcode 가 있을 경우 해당 mapCode를 따라가게 되어있음
          commit: function (callback) {
            var _self = this;
            var check = true;
            var message = "";

            var requireObj = $( "." + _self._ctrlClassNm + " .required-wrap"); //.find("[ng-model]");
            var msg = "";
            for (var i = 0; i < requireObj.length; i++) {
              var data = _self._vm[_self._dataModelNm];
              var model = null;
              var formType = "input";
              if (requireObj.eq(i).parent().hasClass("type-select-col-wrap")) {
                model = requireObj.eq(i).find("[code-model]").attr("code-model");
                formType = "select";
              } else if (requireObj.eq(i).parent().hasClass("type-date-col-wrap")) {
                model = requireObj.eq(i).find("[date]").attr("date");
              } else if (requireObj.eq(i).parent().hasClass("type-dateto-col-wrap")) {
                model = requireObj.eq(i).find("[date]").attr("date");
              } else if (requireObj.eq(i).parent().hasClass("type-datefrom-col-wrap")) {
                model = requireObj.eq(i).find("[date]").attr("date");
              } else if (requireObj.eq(i).parent().hasClass("type-datetime-col-wrap")) {
                model = requireObj.eq(i).find("[datetime]").attr("datetime");
              } else if (requireObj.eq(i).parent().hasClass("type-time-col-wrap")) {
                model = requireObj.eq(i).find("[time]").attr("time");
              } else if (requireObj.eq(i).parent().hasClass("type-span-col-wrap")) {
                model = requireObj.eq(i).find("[ng-bind]").attr("ng-bind");
              } else {
                model = requireObj.eq(i).find("[ng-model]").attr("ng-model");
              }

              model = model.replace(_self._alias + "." + _self._dataModelNm + ".", "");

              if (model.indexOf("[") > -1) {
                model = model.split(".");
                data = data[model[0].split("[")[0]];
                var index = Number(model[0].split("[")[1].replace("]", ''));
                data = data[index];
                model = model[1];
              }

              if(model == "avc.inputValue") {
                model = requireObj.eq(i).find("[code-model]").attr("code-model");
                model = model.split(".");
                model = model[model.length-1];
              }

              if (data[model] != null && isNullOrEmpty(data[model] && _self._vm._columnMaps[model] != null)) {
                if(msg != "") msg += "</br>"
                if(formType == "input") {
                  
                  msg += "- " + _self._vm._columnMaps[model].ColumnLogicalNm + "를 입력하세요.";
                } else {
                  msg += "- " + _self._vm._columnMaps[model].ColumnLogicalNm + "를 선택하세요.";
                }
              }

              // if (isNullOrEmpty(data[model])) {
              //   console.log(data[model])
              //   //message += "- " + requireObj.eq(i).find("label").text() + "을 입력하세요.<br>";
              //   check = false;
              //   var msg = "이 입력란을 작성하세요.";
              //   if (formType == "select") msg = "이 입력란을 선택하세요."
              //   var errNoti = $("<div />", {
              //     html: "<span>*</span> " + msg,
              //     class: "require-err-pop"
              //   })
              //   requireObj.eq(i).append(errNoti.clone());
              //   setTimeout(function () {
              //     $(".require-err-pop").detach();
              //   }, 1800)
              //   break;
              // }
            }

            //if (check) {
              // 전화번호 체크
              for(var i = 0; i < _self._telInfo.length; i++) {
                var at = _self._telInfo[i];
                var num = _self._vm[_self._dataModelNm][at];
                var subCheck = true;
                if(!isNullOrEmpty(num)) {
                  if(num.indexOf("010") == 0 || num.indexOf("011") == 0 || num.indexOf("016") == 0 || num.indexOf("017") == 0 || num.indexOf("018") == 0 || num.indexOf("019") == 0) {
                    subCheck = isMobile(num);
                  } else {
                    subCheck = isTel(num);
                  }

                  if(isNullOrEmpty(num)) {
                    subCheck = true;
                  }

                  if(!subCheck) {
                    if(msg != "") msg += "</br>"
                    msg +=  "- " + _self._vm._columnMaps[at].ColumnLogicalNm + "를 형식을 확인하세요.";
                    // var msg = "전화번호 형식을 확인하세요.";
                    // var errNoti = $("<div />", {
                    //   html: "<span>*</span> " + msg,
                    //   class: "require-err-pop"
                    // })
                    // $("." + at + "-col-wrap").children().append(errNoti.clone());
                    // setTimeout(function () {
                    //   $(".require-err-pop").detach();
                    // }, 1800)
                    // check = false;
                    // break;
                  }
                }
              }
            //}

            // 이메일 체크
            //if (check) {
              for(var i = 0; i < _self._emailInfo.length; i++) {
                var at = _self._emailInfo[i];
                var email = _self._vm[_self._dataModelNm][at];
                var subCheck = emailCheck(email);
                if(isNullOrEmpty(email)) {
                  subCheck = true;
                }
                if(!subCheck) {
                  if(msg != "") msg += "</br>"
                    msg +=  "- " +  _self._vm._columnMaps[at].ColumnLogicalNm + "를 형식을 확인하세요.";
                  // var msg = "이메일 형식을 확인하세요.";
                  // var errNoti = $("<div />", {
                  //   html: "<span>*</span> " + msg,
                  //   class: "require-err-pop"
                  // })
                  // $("." + at + "-col-wrap").children().append(errNoti.clone());
                  // setTimeout(function () {
                  //   $(".require-err-pop").detach();
                  // }, 1800)
                  // check = false;
                  // break;
                }
              }
            //}

            if (msg == "") {
              this.saveContentData(function (result) {
                callback(result)
              })
            } else {
              gAlert('', msg);
            }
          },

          setInsertApi: function (mapCode) {
            this._apis.insert = mapCode;
          },

          setUpdateApi: function (mapCode) {
            this._apis.update = mapCode;
          },

          saveContentData: function (callback) {
            var _self = this;
            var key = _self._vm[_self._dataModelNm][_self._keyIdNm];
            var data = angular.copy(_self._vm[_self._dataModelNm]);
            var checkInst = false;
            if (isNullOrEmpty(key)) { // Update
              checkInst = true;
              data.mapCode = _self._apis.insert;
            } else { // Insert
              data.mapCode = _self._apis.update;
            }

            // TimeZone 설정
            for (var i = 0; i < _self._dateInfo.length; i++) {
              var at = _self._dateInfo[i];
              var dateKey = at.bindKey.split("_")[2];
              if (data[dateKey]) {
                if (at.datetype == "datetime") {
                  data[dateKey] = moment.utc(data[dateKey]).format("YYYY-MM-DD HH:mm:ss");
                } else if (at.datetype == "date") {
                  data[dateKey] = moment.utc(data[dateKey]).format("YYYY-MM-DD");
                } else if (at.datetype == "datefrom") {
                  data[dateKey] = $filter('localToUtc')(moment(data[dateKey]).format('YYYY-MM-DD'), 'from');
                } else if (at.datetype == "dateto") {
                  data[dateKey] = $filter('localToUtc')(moment(data[dateKey]).format('YYYY-MM-DD'), 'to');
                }
              }
            }

            if(checkInst) {
              postApi.insert(data, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  callback(result);
                } else {
                  callback(result);
                }
              }, function (error) {
                console.table(error);
                gAlert('', 'Menu.EXCEPTIONOCCURED');
              });
            } else {
              postApi.update(data, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  callback(result);
                } else {
                  callback(result);
                }
              }, function (error) {
                console.table(error);
                gAlert('', 'Menu.EXCEPTIONOCCURED');
              });
            }

          },

          openModal: function (p, callback, cancelCallback) {
            var modalInstance = modalFactory.open(p.size, p.template, p.ctrl, p.param);
            modalInstance.result.then(function (res) {
              if (callback != undefined) {
                callback(res);
              }
            }, function (cancelData) {
              if (cancelCallback != undefined) {
                cancelCallback(cancelData);
              }
            });
          },
          alert: function (MSG, callback) {
            if (callback == undefined)
              gAlert('', MSG);
            else
              gAlert('', MSG, {
                btn: '',
                fn: function () {
                  callback();
                }
              });
          },
          confirm: function (MSG, okCallback, cancelCallback) {
            gConfirm('', MSG, {
              btn: '',
              fn: function () {
                if (okCallback != undefined)
                  okCallback();
              }
            }, {
              btn: '',
              fn: function () {
                if (cancelCallback != undefined)
                  cancelCallback();
              }
            });
          },
          toast: function (msg) {
            $rootScope.showSimpleToast(msg);
          },

          reload: function (P) {
            if (_self._viewType === mViewType.Edit) { // 상세페이지

              // var metaPatam = _self.makeDefaultSendData({});
              //   metaPatam.mapCode = "baseDescList";
              //   var opacitySec = 380;
              //   _self.getData(metaPatam, function(result){

            } else {

            }

          },

          compileElement: function (target, attr, val) {
            var _self = this;
            var obj = $(target);
            obj.attr(attr, val);
            $compile(obj)(_self._scope)
          },

          //#region 정의 컬럼 정보 출력
          printMataColsInfo: function () {
            var _self = this;
            if (_self._vm._columnMaps && _self._printColumn) {
              _self._vm._columnTables = [];
              var keys = Object.keys(_self._vm._columnMaps);
              for (var i = 0; i < keys.length; i++) {
                var at = _self._vm._columnMaps[keys[i]];
                var colType = at.ColumnLogicalDataType;
                if (at.ColumnLogicalDataType) {
                  if (at.ColumnLogicalDataType == "10") colType += "(input)";
                  else if (at.ColumnLogicalDataType == "20") colType += "(Number)";
                  else if (at.ColumnLogicalDataType == "30") colType += "(RealNumber)";
                  else if (at.ColumnLogicalDataType == "40") colType += "(Date)";
                  else if (at.ColumnLogicalDataType == "41") colType += "(Date)";
                  else if (at.ColumnLogicalDataType == "42") colType += "(Date)";
                  else if (at.ColumnLogicalDataType == "50") colType += "(Select)";
                  else if (at.ColumnLogicalDataType == "60") colType += "(Image)";
                  else if (at.ColumnLogicalDataType == "70") colType += "(Tel)";
                  else if (at.ColumnLogicalDataType == "80") colType += "(Textarea)";
                  else if (at.ColumnLogicalDataType == "90") colType += "(DateTime)";
                  else if (at.ColumnLogicalDataType == "100") colType += "(Radio)";
                  else if (at.ColumnLogicalDataType == "110") colType += "(CheckBox)";
                  else if (at.ColumnLogicalDataType == "120") colType += "(ModalPop)";
                  else if (at.ColumnLogicalDataType == "121") colType += "(Date)";
                  else if (at.ColumnLogicalDataType == "122") colType += "(Span)";
                } else {
                  colType = at.dataType;
                }

                _self._vm._columnTables.push({ Column: at.ColumnPhysicalAsNm, Name: at.ColumnLogicalNm, ColumnType: colType });
              }
              if (location.href.indexOf("localhost") > -1) {
                console.table(_self._vm._columnTables);
              }
            }
          },
          //#endregion 정의 컬럼 정보 출력

          // 공통적으로 보낼 데이터를 추가 하는 함수
          makeDefaultSendData: function (p) {
            var _self = this;
            var cp = angular.copy(p);
            if (_self._viewType) cp.selectType = _self._viewType;
            if (_self._tableName) cp.tableNm = _self._tableName;
            if (!cp.KeyId && _self._keyIdNm) {
              cp[_self._keyIdNm] = (isNullOrEmpty(_self._stateParams[_self._keyIdNm])) ? "" : _self._stateParams[_self._keyIdNm];
            }
            return cp;
          },

          checkEmptyType: function (type) { return (typeof type == 'undefined') ? true : false; }
        }
        return autoView;
      }
    }])
  .directive('autoviewPageHeader',
    ['$compile', '$parse', '$translate',
      function ($compile, $parse, $translate) {
        return {
          transclude: true,
          replace: true,
          restrict: 'E',
          require: false,
          scope: false,
          template: function (scope, iAttrs) {
            var row = $("<div />", { class: "row" });
            var wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
            var pageHeader = $("<div />", { class: "page-header", text: "{{" + iAttrs.alias + ".headerTitle}}" });
            var dockBtnWrap = $("<div />", { class: "pull-right dock-header-tx list-split" });

            var btns = [iAttrs.alias + ".setChangeLayout('N', " + iAttrs.alias + ")", iAttrs.alias + ".setChangeLayout('V', " + iAttrs.alias + ")", iAttrs.alias + ".setChangeLayout('H', " + iAttrs.alias + ")"];
            var imgs = ["assets/images/icon-sp-list.png", "assets/images/icon-sp-rl.png", "assets/images/icon-sp-tb.png"];

            for (var i = 0; i < btns.length; i++) {
              var $btn = $("<span />", { "ng-click": btns[i] });
              var $img = $("<img />", { alt: "", src: imgs[i] });
              $btn.html($img.clone());
              dockBtnWrap.append($btn.clone());
            }

            if (iAttrs.metaconfig) {
              var $dockMetaConfig = $("<metadata-config table-nm=\"" + iAttrs.metaconfig + "\" metadata-changed=\"" + iAttrs.alias + ".getSearch\" />");
              pageHeader.append($dockMetaConfig.clone());
            }

            pageHeader.append(dockBtnWrap.clone());

            wrap.html(pageHeader.clone());
            row.html(wrap.clone());

            return wrap.html();
          },
          compile: function compile(tElement, tAttrs) {
            return {
              post: function ($scope, element, attr) { },
              pre: function ($scope, element, attr) {

              }
            }
          },
        };
      }])
  .directive('autoviewListTable',
    ['$compile', '$parse', '$translate', '$filter', '$sce', '$compile', '$timeout',
      function ($compile, $parse, $translate, $filter, $sce, $compile, $timeout) {

        return {
          transclude: true,
          replace: false,
          restrict: 'E',
          require: false,
          scope: false,
          template: function (scope, iAttrs) {
            var row = $("<div />", { class: "row" });
            var wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
            var panel = $("<div />", { class: "panel panel-default tile" });
            var panelBody = $("<div />", { class: "panel-body collapse in" });
            var table = $("<table />", {
              class: "table table-striped table-bordered table-hover data_table table-custom",
              style: "table-layout:fixed"
            });
            var thead = $("<thead />", {});
            var tr = $("<tr />", {});
            var checkHeader = $("<th />", { class: 'text-center', style: 'vertical-align:middle; width: 40px;', 'ng-if': iAttrs.alias + '._listCheckboxEnable' });
            var headerCheckbox = $("<input />", { type: 'checkbox', 'ng-click': 'vc.chkRowAll()', 'ng-model': 'vc.checkListCheckbox' });
            checkHeader.html(headerCheckbox.clone());

            var tbody = $("<tbody />", {});
            var checkBodyTd = $("<td />", { class: 'text-center', style: 'vertical-align:middle; width: 20px;', 'ng-if': iAttrs.alias + '._listCheckboxEnable' });
            var checkBodyTdInput = $("<input />", { type: 'checkbox', 'ng-model': 'li.chkRow', 'ng-change': 'vc.chkRowChg(li)' });
            checkBodyTd.html(checkBodyTdInput.clone())

            var emptyDiv = $("<div />", {
              class: "tbnodata",
              "ng-if": "_scope_totalItems == 0",
              text: "{{ 'MSG.NO_DATA' | translate }}",
              style: "text-align:center; padding:15px; border:solid 1px #CCC; border-top:none;"
            });

            tr.html(checkHeader.clone());
            thead.html(tr.clone());
            table.html(thead.clone());
            table.append(tbody.clone());
            panelBody.append(table.clone());

            panelBody.append(emptyDiv.clone());

            // 페이징까지 처리진행
            var panel = $("<div />", { class: "panel panel-default tile" });
            var row2 = $("<div />", { class: "row" });
            var viewSizeWrap = $("<div />", { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad", "data-ng-if": iAttrs.alias + "._totalItems" });

            var formGroup = $("<div />", { class: "form-group form-inline select-size-list pull-left col-xs-hidden av-page-size-wrap" });
            var label = $("<label />", { text: "{{ :: 'Menu.LIST' | translate }}" });
            var select = $("<select />", {
              "aria-controls": "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
              "ng-change": "vc.setChangeViewSize()", "ng-model": iAttrs.alias + "._viewSize",
              "ng-options": "c for c in " + iAttrs.alias + "._listSize"
            });
            var pullRight = $("<div />", { class: "paging dataTables_paginate pull-right av-paging-wrap" });
            var ul = $("<ul />", {
              "uib-pagination": "",
              "data-ng-if": iAttrs.alias + "._totalItems", "direction-links": "true", "first-text": "{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
              "name": "pagination", "next-text": "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change": iAttrs.alias + ".setPageChanged()", "ng-model": iAttrs.alias + ".currentPage",
              "previous-text": "{{'BTN.PAGINATION.PREV'|translate}}", "total-items": iAttrs.alias + "._totalItems", "boundary-links": "true",
              "items-per-page": iAttrs.alias + ".viewSize", "max-size": iAttrs.alias + ".maxSize", "num-pages": iAttrs.alias + ".numPages", "rotate": "false", "template-url": "components/template/pagination.html"
            });
            var $row3 = $("<div />", { class: "row" });
            formGroup.append(label.clone());
            formGroup.append(select.clone());

            pullRight.append(ul.clone());
            //pagingBarWrap.append(pullRight.clone());
            viewSizeWrap.append(formGroup.clone());
            viewSizeWrap.append(pullRight.clone());

            row2.append(viewSizeWrap.clone());

            //row2.append(pullRight.clone());
            panelBody.append(row2.clone());
            panel.append(panelBody.clone());
            wrap.append(panel.clone());
            row.append(wrap.clone());
            var last = $("<div />");
            last.html(row.clone());
            return last.html();
          },

          compile: function compile(tElement, tAttrs) {
            return {
              post: function ($scope, elem, attr) {
              },
              pre: function ($scope, elem, attr) {
                $scope.avOptions = null;
                $scope.avltMetaCol = null;
                $scope.avlData = null;
                $scope._scope_totalItems = null;
                var isProcess = false;
                var checkInit = false;

                $scope.$watch(attr.listOptions, function (option) {
                  if (option && attr.listOptions) {
                    $scope.avOptions = option;
                  }
                });

                $scope.$watch(attr.alias + "._columnMaps", function (meta) {
                  if(attr.custColumnMap){
                    return;
                  }
                  if (meta) {
                    $scope.avltMetaCol = meta;
                    isProcess = true;

                    if (!checkInit) setAvListTableData();
                  }
                });

                $scope.$watch(attr.custColumnMap, function (meta) {
                  if (meta) {
                    $scope.avltMetaCol = meta;
                    isProcess = true;

                    if (!checkInit) setAvListTableData();
                  }
                });

                $scope.$watch(attr.alias + "._totalItems", function (count) {
                  if(count != undefined) {
                    if(count.totalItems) {
                      $scope._scope_totalItems = count.totalItems;
                    } else {
                      $scope._scope_totalItems = count;
                    }
                  } 
                });

                $scope.$watch(attr.alias + "." + attr.listData, function (item) {

                  if(item == undefined) {
                    return;
                  }

                  if (item || item.length == 0) {
                    $scope.avlData = item;
                    isProcess = true;

                    angular.forEach($scope.avlData, function (li, idx) {

                      var keys = Object.keys(li);
                      for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        if ($scope.avltMetaCol[keys[i]]) {
                          var dType = $scope.avltMetaCol[key].ColumnLogicalDataType;
                          if (dType == "20") li[key] = $filter("number")(li[key]);
                          if (dType == "40") li[key] = $filter("autoViewUtcToLocal")(li[key], 'YYYY-MM-DD');
                          if (dType == "41") li[key] = $filter("autoViewUtcToLocal")(li[key], 'YYYY-MM-DD');
                          if (dType == "42") li[key] = $filter("autoViewUtcToLocal")(li[key], 'YYYY-MM-DD');
                          if (dType == "50") li[key] = getCodeValue($scope.avltMetaCol[key].CodeList, li[key]);
                          if (dType == "70") li[key] = $filter("toHyphenContact")(li[key]);
                          if (dType == "90") {
                            // if(li[key].dayOfMonth) {
                            //   var _d = li[key].year + '-' + (li[key].monthValue) + '-' + li[key].dayOfMonth + ' ' + li[key].hour + ':' + li[key].minute + ':' + li[key].second;
                            //   _d = moment( new Date(_d)).format("YYYY-MM-DD HH:mm:ss");
                            //   li[key] = moment(_d).local("YYYY-MM-DD HH:mm:ss");
                            // } 
                            li[key] = $filter("autoViewUtcToLocal")(li[key], 'YYYY-MM-DD HH:mm:ss');
                          }
                          if (dType == "100") li[key] = getCodeValue($scope.avltMetaCol[key].CodeList, li[key]);
                          if (dType == "110") li[key] = getCodeValue($scope.avltMetaCol[key].CodeList, li[key]);

                          li[key + "Title"] = li[key];

                          if ($scope.avOptions) {
                            if ($scope.avOptions.html && $scope.avOptions.html[key]) {
                              li[key+"-template"] = $scope.avOptions.html[key].template.replace("{{value}}", li[key]);
                            } else {
                              li[key+"-template"] = li[key];
                            }
                          } else {
                            li[key+"-template"] = li[key];
                          }
                        }
                      }
                    });

                    //console.log($scope.avlData)
                    if (!checkInit) setAvListTableData();
                  }

                  if ($scope.avltMetaCol && $scope.avOptions && $scope.avOptions.addColumn) {
                    var tempMeta = {};
                    //anuglar.copy($scope.avltMetaCol);
                    var metaKeys = Object.keys($scope.avltMetaCol)
                    var keys = Object.keys($scope.avOptions.addColumn);
                    for(var i = 0; i < metaKeys.length; i++) {
                      var metaAt = $scope.avltMetaCol[metaKeys[i]];
                      tempMeta[metaKeys[i]] = metaAt;
                      for(var j = 0; j < keys.length; j++) {
                        var at = $scope.avOptions.addColumn[keys[j]];
                        if( (at.after && at.after == metaKeys[i]) || (at.before && (at.before == metaKeys[i+1] || at.before == metaKeys[0] ))) {
                          if(at.before) {
                            delete tempMeta[metaKeys[i]];
                          }
                          tempMeta[keys[j]] = {
                            ColumnLogicalNm : at.title,
                            ColumnPhysicalAsNm : keys[j],
                            ListColumnShowYN : "Y"
                          }

                          if(at.size) {
                            tempMeta[keys[j]].ListColumnWidth = at.size;
                          }
                          
                          if(at.textAlign && at.textAlign == "left")  {
                            tempMeta[keys[j]]["ListColumnTextAlign"] = "text-left";
                          } else if(at.textAlign && at.textAlign == "center")  {
                            tempMeta[keys[j]]["ListColumnTextAlign"] = "text-center";
                          } else if(at.textAlign && at.textAlign == "right")  {
                            tempMeta[keys[j]]["ListColumnTextAlign"] = "text-right";
                          } else {
                            tempMeta[keys[j]]["ListColumnTextAlign"] = "text-center";
                          }
                        } 
                        if(at.before) {
                          tempMeta[metaKeys[i]] = metaAt;
                        }

                        for(var k = 0; k < $scope.avlData.length; k++) {
                          $scope.avlData[k][keys[j] + "-template" ] = at.template;
                        }
                      }                      
                    }
                    $scope.avltMetaCol = tempMeta;                   
                  }

                  // && attr.listOptions
                });

                function setAvListTableData(resetOption) {
                  
                  if (isProcess) {
                    isProcess = false;

                    var ngRowClass = ""
                    if ($scope.avltMetaCol && Array.isArray($scope.avlData) && $scope.avlData) {
                      checkInit = true;

                      angular.forEach($scope.avltMetaCol, function (item, key) {
                        item.isShow = true;
                        if (item.ListColumnShowYN != "Y") {
                          item.isShow = false;
                          $scope.avlData
                        }
                      })

                      var checkBodyTd = $("<td />", { class: 'text-center', style: 'vertical-align:middle; width: 20px;', 'ng-if': attr.alias + '._listCheckboxEnable' });
                      var checkBodyTdInput = $("<input />", { type: 'checkbox', 'ng-model': 'li.chkRow', 'ng-change': 'vc.chkRowChg(li)' });

                      if ($scope.avOptions && $scope.avOptions.html && $scope.avOptions.html.autoViewCheckBox && $scope.avOptions.html.autoViewCheckBox.template) {
                        checkBodyTd.html($scope.avOptions.html.autoViewCheckBox.template);
                      } else {
                        checkBodyTd.html(checkBodyTdInput.clone())
                      }

                      var theadThSpen = $("<span />", {
                        class: "fa {{" + attr.alias + ".setSortDirect(liCol.ColumnPhysicalNm)}}",
                        "ng-if": "liCol.KeyColumnYN == 'Y'",
                        style: "padding-left: 4px;"
                      });

                      var theadTh = $("<th />", {
                        class: "text-center none {{liCol.ListColumnShowLevel}} cols-{{liCol.ColumnPhysicalAsNm}} cols-head-{{liCol.ColumnPhysicalAsNm}}",
                        "data-toggle": "{{liCol.KeyColumnYN == 'Y'? 'true' : 'false'}}",
                        "ng-click": "vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN, liCol)",
                        "ng-repeat": "liCol in avltMetaCol",
                        "ng-if": "liCol.ListColumnShowYN == 'Y'",
                        style: "width: {{liCol.ListColumnWidth}}",
                        text: "{{ ::liCol.ColumnLogicalNm | translate }}"
                      });

                      theadTh.append(theadThSpen.clone());

                      var listTr = $("<tr />", {
                        "ng-repeat": "li in avlData",
                        style: "cursor:pointer"
                      });

                      var listTd = $("<td />", {
                        class: "{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} cols-{{liCol.ColumnPhysicalAsNm}} cols-body-{{liCol.ColumnPhysicalAsNm}}",
                        "ng-click": attr.alias + ".listToPage(li)",
                        "ng-repeat": "liCol in avltMetaCol",
                        "ng-if": "liCol.ListColumnShowYN == 'Y'",
                        "bind-html-compile": "li[liCol.ColumnPhysicalAsNm +'-template']",
                        "title": "{{li[liCol.ColumnPhysicalAsNm + 'Title']}}"
                      });

                      
                      if(attr.disabledClick != undefined) { 
                        listTr.removeAttr("style");
                        listTd.removeAttr("ng-click");
                      }
                      //console.log(disabled-click)

                      ngRowClass = "{'bg-lightyellow':li[" + attr.alias + ".keyIdNm] && li[" + attr.alias + ".keyIdNm] == selectedRow";

                      if ($scope.avOptions && $scope.avOptions.addRowClass && $scope.avOptions.addRowClass.if) {
                        ngRowClass = ngRowClass + ", '" + $scope.avOptions.addRowClass.class + "':" + $scope.avOptions.addRowClass.if;
                      }

                      ngRowClass = ngRowClass + "}";

                      if ($scope.avOptions && $scope.avOptions.ngIf) {
                        var ngIf = "liCol.ListColumnShowYN == 'Y'";
                        var subkeys = Object.keys($scope.avOptions.ngIf);
                        for (var i = 0; i < subkeys.length; i++) {
                          var subkey = subkeys[i];
                          if (i == 0) ngIf += " && (( liCol.ColumnPhysicalAsNm=='" + subkey + "' ? " + $scope.avOptions.ngIf[subkey] + " ? true : false : true)";
                          else ngIf += " && ( liCol.ColumnPhysicalAsNm=='" + subkey + "' ? " + $scope.avOptions.ngIf[subkey] + " ? true : false : true)";

                          if (i == subkeys.length - 1) ngIf += ")";
                        }

                        theadTh.attr("ng-if", ngIf);
                        listTd.attr("ng-if", ngIf);
                      }

                      listTr.html(checkBodyTd.clone());
                      listTr.append(listTd.clone());
                      if (!isNullOrEmpty(ngRowClass)) {
                        listTr.attr("ng-class", ngRowClass);
                      }

                      elem.find("thead tr").append(theadTh.clone());

                      elem.find("tbody").attr("ng-if", "_scope_totalItems != 0")
                      elem.find("tbody").html(listTr.clone())

                      $compile(elem.find("table"))($scope);
                    }
                  }

                  //$compile(elem)($scope);
                };

                $scope.checkIf = function (type, meta, item) {
                  var result = true;
                  return result
                };

                $scope.getData = function () {

                };
              }
            }
          },
        };
      }])

  .directive('autoviewListPaging',
    ['$compile', '$parse', '$translate',
      function ($compile, $parse, $translate) {
        return {
          transclude: true,
          replace: false,
          restrict: 'E',
          require: false,
          scope: false,
          template: function (scope, iAttrs) {

            var row2 = $("<div />", { class: "row" });
            var viewSizeWrap = $("<div />", { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad" });
            var formGroup = $("<div />", { class: "form-group form-inline select-size-list pull-left col-xs-hidden av-page-size-wrap" });
            var label = $("<label />", { text: "{{ :: 'Menu.LIST' | translate }}" });
            var select = $("<select />", {
              "aria-controls": "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
              "ng-change": "vc.setChangeViewSize()", "ng-model": iAttrs.alias + "._viewSize",
              "ng-options": "c for c in " + iAttrs.alias + "._listSize"
            });
            var pullRight = $("<div />", { class: "paging dataTables_paginate pull-right av-paging-wrap" });
            var ul = $("<ul />", {
              "uib-pagination": "",
              "data-ng-if": iAttrs.alias + "._totalItems", "direction-links": "true", "first-text": "{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
              "name": "pagination", "next-text": "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change": iAttrs.alias + ".setPageChanged()", "ng-model": iAttrs.alias + ".currentPage",
              "previous-text": "{{'BTN.PAGINATION.PREV'|translate}}", "total-items": iAttrs.alias + "._totalItems", "boundary-links": "true",
              "items-per-page": iAttrs.alias + ".viewSize", "max-size": iAttrs.alias + ".maxSize", "num-pages": iAttrs.alias + ".numPages", "rotate": "false", "template-url": "components/template/pagination.html"
            });
            pullRight.append(ul.clone());
            formGroup.append(label.clone());
            formGroup.append(select.clone());
            viewSizeWrap.append(formGroup.clone());
            viewSizeWrap.append(pullRight.clone());
            row2.append(viewSizeWrap.clone());
            var last = $("<div />");
            last.html(row2.clone());

            return last.html();
          },
          compile: function compile(tElement, tAttrs) {
            return {
              post: function ($scope, element, attr) { },
              pre: function ($scope, element, attr) {
              }
            }
          },
        };
      }
    ])
  .directive('bindHtmlCompile',
    ['$compile', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.bindHtmlCompile);
          },
          function (value) {
            element.html(value && value.toString());
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          }
        );
      };
    }])
  ;
/* "use strict"; */
webapp.service('commonFns', 
  ['GLOBAL_CONSTANT', 'StaticVariable', '$rootScope', '$window', '$state', '$stateParams',
  function commonFns(CONSTANT, StaticVariable, $rootScope, $window, $state, $stateParams) {

    var fns = {
      vm : {},
      makeSrchData : function(srchData) {

        var temp = {};
        (!isNullOrEmpty(srchData.keyTableNm)) ? temp.keyTableNm = srchData.keyTableNm : temp.keyTableNm = ""; // 작업테이블명
        (!isNullOrEmpty(srchData.sortDirect)) ? temp.sortDirect = srchData.sortDirect : temp.sortDirect = ""; // 정렬순서 (ASC:오름차순, DESC:내림차순)
        (!isNullOrEmpty(srchData.sortColumn)) ? temp.sortColumn = srchData.sortColumn : temp.sortColumn = ""; // 정렬컬럼명
       
        if (!srchData.srch) {
          this.vm.srch = {};
          this.vm.srch.page = 1;
          this.vm.srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          this.vm.srch.tableNm = temp.keyTableNm;
          this.vm.srch.sortDirect = temp.sortDirect;
          this.vm.srch.sortColumn = temp.sortColumn;
        } else {
          this.vm.srch = JSON.parse(decodeURIComponent(srchData.srch));
          this.vm.srch.tableNm = !isNullOrEmpty(srchData.srch.tableNm) ? srchData.srch.tableNm : temp.keyTableNm;
        }

        var result = angular.copy(this.vm.srch);
        this.vm = {};
        return result;
      },

      setLayout : function(vm) {
        vm.layout = $rootScope.gVariable.layoutBoard;
        this.initChangeLayout(vm);
      },
      initChangeLayout : function(vm) {
        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }

        vm.setChangeLayout = function(layout, vc) {
          $window.sessionStorage.setItem('layoutBoard', layout);
          $rootScope.gVariable.layoutBoard = layout;
          var srch = vc.srch; // 검색 옵션
          var url = vc.PageUrl.LIST_PAGE_URL;
          url = url.substring(0, url.indexOf("/"));
          var urlOption = vc.PageUrl.LIST_PAGE_URL;
          var param = {};
          param.srch = srch;
          if(urlOption.indexOf("({") != -1) {
            urlOption = urlOption.substring( urlOption.indexOf("({"), urlOption.length)
              .replaceAll(" ","").replaceAll("({","").replaceAll("})","").replaceAll('"',"").replaceAll("'","").split(",");
            for(var i = 0; i < urlOption.length; i++) {
              var keyValue = urlOption[i].split(":");
              param[keyValue[0]] = keyValue[1];
            }
          }
          //$state.go(url,{ param }, {reload: url});
        }
      },

    };
    return fns;
  }
]);

/* "use strict"; */
webapp.service('customFieldApi', ['$resource', 'StaticVariable', '$rootScope', '$filter',
  function customFieldApi($resource, StaticVariable, $rootScope, $filter) {
    /**
     * * Noti
     *   - 호출 타입
     *     * customFieldApi 내 type 참고
    **/
    var translate = $filter('translate');

    var customFieldApi = {
      setReadOnlyUdcColumns : function(allColumns) {
        var udcColumns = [];
        // var udcCols = vm.allColumns.filter(x => x.CustomColumnYN == 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN == 'Y';
        });
        // for (var i = 0; i < udcCols.length; i += 4){
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {
          var item = {};

          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth;

            item.type = 'readOnly';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            row.fieldGroup.push(item);
          }
        }

        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
      setEditableUdcColumns : function(allColumns) {
        var udcColumns = [];
        //      var udcCols = vm.allColumns.filter(x => x.CustomColumnYN === 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN === 'Y';
        });

        // row당 4개의 컬럼 표시
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {

          var item = {};
          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth+' form-right';
            item.type = 'input';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            //TODO: 데이터 유형에 따라서 type을 다르게 처리 필요
            // 10-text, 20-number, 30-number(float), 40-date, 50-select
            switch (udcCols[j].ColumnPhysicalDataType) {
            case '20':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '30':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '40':
              item.templateOptions.type = 'text';
              item.templateOptions.placeholder = '{년-월-일}';
              break;
            case '50':
              item.type = 'select';
              item.templateOptions.valueProp = 'abbr';
              item.templateOptions.labelProp = 'name';
              item.templateOptions.options = [];

              var items = [{name:'--'+translate('Menu.CHOOSE')+'--',abbr:''}];

              if (udcCols[j].CodeKey != null && udcCols[j].CodeValue != null) {
                var codeValues = udcCols[j].CodeValue.split(',');
                var codeKeys = udcCols[j].CodeKey.split(',');

                codeValues.forEach(function(codeRow, key) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeKeys[key];
                  items.push(code);
                });
              } else  if (udcCols[j].ColumnCodeValue.length > 0) {
                var codeValues = udcCols[j].ColumnCodeValue.split(',');

                codeValues.forEach(function(codeRow) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeRow;
                  items.push(code);
                });
              }

              item.templateOptions.options = items;

              break;
            default:
              item.templateOptions.type = 'text';
              break;
            }

            row.fieldGroup.push(item);
          }
        }
        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
    };
    return customFieldApi;
  },
]);

/* "use strict"; */
webapp.service("Helper", ["$state","$location",
  function($state, $location) {
    var services = {};

    function objectKeys(object) {
      var result = [];

      angular.forEach(object, function(val, key) {
        result.push(val);
      });
      return result;
    }

    services.stateIs = function(state_name) {
      var names = state_name.split('.');
      var state = '';
      var url = '';

      angular.forEach(names, function(name) {
        state = state == '' ? name : state + '.' + name;
        if ($state.get(state)) {
          url = url + $state.get(state).url;
        }
      });

      return url;
    };

    //#region ColorPicker 확장
    services.getOffset = function(el) {
      return $(el).offset();
    }

    services.closestSlider = function(e) {
      var o = e.matches || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector;
      return o.bind(e)("I") ? e.parentNode : e
    }

    services.getOffset = function(e, o) {
      for (var t = 0, r = 0, n = e.getBoundingClientRect(); e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop); )
          o || "BODY" !== e.tagName ? (t += e.scrollLeft,
          r += e.scrollTop) : (t += document.documentElement.scrollLeft || e.scrollLeft,
          r += document.documentElement.scrollTop || e.scrollTop),
          e = e.offsetParent;
      return {
          top: n.top + window.pageYOffset,
          left: n.left + window.pageXOffset,
          scrollX: t,
          scrollY: r
      }
    }
    //#endregion ColorPicker
    return services;
  }
]);

/* "use strict"; */
webapp.service('ifProxy',
  ['GLOBAL_CONSTANT', '$compile', 'postApi', '$window', 'gAlert', '$rootScope', '$state', 'StaticVariable', 'LoginAPISrv', '$timeout',
  function ifProxy(CONSTANT, $compile, postApi, $window, gAlert, $rootScope, $state, StaticVariable, loginApi, $timeout) {

    var vm = this;
    vm.userType = $window.sessionStorage['USE_APPTYPE'];

     /**
     * @description 멤버스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.membersLogin = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;
      postApi.login('custLogin',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MEMBER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {
          gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
        }
      });
    };
    /**
     * @description 리더스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.Login = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;

      postApi.login('login',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MASTER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {

          if(result.body.docs.length > 0 && result.body.docs[0].checkApproval == "N") {
            gAlert('', result.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      });
    };


    var ifProxy = null;
    var regEvent = true;
    ifProxy = {
      instance : this,
      responselistner : null,
      porthole : null,
      $frame : null,
      $fromRequestKey : null,
      orgTargetRequestKey : null,
      getIfProxyReqKey : null,
      reset : function () {

      },
      init : function(option){
        //$window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
        this.porthole = new Porthole.WindowProxy(SHOP_DOMAIN_ADDRESSS, option.targetId);

        $frame = $("#" + option.targetId);
        $frame.attr("ng-src", option.url);
        var offset = $("#page-wrapper [ui-view]").offset();
        $frame.css("height", $(window).height() - offset.top );
        $frame.css("display", "block");
        $compile($frame)(option.scope);

        var callback = option.callback;

        if(regEvent) {
          this.porthole.addEventListener(this.reqeuest);
          regEvent = false;
        }

        if(callback.completInit != null)
          callback.completInit(this.porthole);

        if(callback.contentChangeSuccess != null)
          ifProxy.porthole.Callback_contentChangeSuccess = callback.contentChangeSuccess;

        if(callback.onMessage != null)
          ifProxy.porthole.Callback_onMessage = callback.onMessage;
      },

      reqeuest :  function(msg) {
        if (SHOP_DOMAIN_ADDRESSS.replace("https","").replace("http","") == msg.origin.replace("https","").replace("http","")) {
          ifProxy.orgTargetRequestKey = msg.data.data.requestKey;
          var action = msg.data.action;
          var sData = msg.data.data;
          if(action == "redirctLoginPage") {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});

                  $state.go("m.member.login");
                }
              });
            }, function(error) {
              console.log("error");
              // console.error('fail', status);
            });
          }

          if(action == "setNavi" && sData.title == "회원로그인" && $window.loginUserIdx != undefined) {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});
                }
              });
            }, function(error) {
              console.log("error");
              // console.error('fail', status);
            });
          }

          if(action == "startLogin") {
            M.fcm.getFcmToken({
              onSucess:function(token){
                msg.data.data.osType = getOs();
                msg.data.data.fcmToken = token;
                if(vm.userType == "members") {
                  vm.membersLogin(msg.data.data);
                } else {
                  vm.Login(msg.data.data);
                }
              }
            });
            return;
          }

          if(action == "findUserId" || action == "findUserPw") {
            var request = sData;
            request.mapCode = 'checkFindUserInfo';
            request.action = action;
            request.userType = vm.userType;
            postApi.openApi(request, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                var req = {};
                if(result.body.docs.length == 0) {
                  req.passYn = false;
                  gAlert('', '해당 정보를 찾을 수 없습니다.', {
                    btn: '확인', fn: function () { }
                  });
                } else {
                  req.passYn = true;
                }
                ifProxy.send(action, req);
              }
            });
            return;
          }

          if(action == "goDashboard") {
            $state.go("m.dashboard");
          }

          if(ifProxy.porthole.Callback_contentChangeSuccess != null && action == 'frameContentChangeSuccess') {
            if($window.sessionStorage["M_LAST_PAGE"] != $state.current.name) {
              ifProxy.porthole.Callback_contentChangeSuccess(sData);
              $window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
            } else {

            }
            return;
          }

          var data = msg.data;
          if(data.useAuth) {

          } else {
            var response = {
              action : action,
              requestKey : data.requestKey,
              data : data.data
            };
            delete response.data.action;
            delete response.data.useAuth;
            ifProxy.porthole.Callback_onMessage(response);
          }
        } else {

        }
      },

      send : function (action, data) {
        if(data == null) data = {};
        if(data != null) {
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action, data : data, useAuth : false});
        } else {
          var data = {};
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action});
        }
      },

      page : function(data) {
        var thisTemp = this;
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "goPages";
            data.useAuth = true;
            data.fromKey = param.requestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;
            //porthole.post({action: action, data : data, useAuth : true});
            //alert(JSON.stringify(data))
            thisTemp.overrideSender(action, data);
          } else {
            console.log("error");
            // console.error(result);
          }
        });
      },

      overrideSender : function(action, data) {
        //$timeout(
          try {

          this.porthole.post({action: action, data : data, useAuth : true})
        } catch (e) {
          console.log(e)
          $window.sessionStorage["M_LAST_PAGE"] = "";
          $state.reload($state.current.name);
        }
          //, 500);
          //this.porthole.post({action: action, data : data, useAuth : true});
        //}, 1000)

      },

      authApi : function(actionKey, data) {
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "authApi";
            data.useAuth = true;
            data.actionKey = actionKey;
            data.fromKey = ifProxy.orgTargetRequestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;

            porthole.post({action: action, data : data, useAuth : true});

          } else {
            console.log("error");
            // console.error(result);
          }
        });
      }
    };
    return ifProxy;
  },
]);

/* "use strict"; */
webapp.service('pay',
  ['GLOBAL_CONSTANT', 'postApi', 'gAlert', '$filter', 'StaticVariable',
    function pay(CONSTANT, postApi, gAlert, $filter, StaticVariable) {
      var vm = this;

      // 계정정보 (아임포트)
      vm.PG_KEY = "imp86263784";
      vm.PG_NOTIURL = "https://care.salevis.co.kr/pay/updatePayEnd/action.json";
      
      // 본인인증정보 (아임포트)
      //vm.CM_KEY = "imp86263784";
      //vm.CM_SECRET = "6tfCHwj9nmU0Wz1uTcZko9rcLER4rLyyfObWlu5IR0JNALiuYiOnrgAcVrhmdPUsE6o0AuIsvsg5eyAc";

      // 세금계산서(바로빌) 인증정보는 WAS의 BaroService.java 확인      

      // 금액 콤마 표시
      vm.setComma = function(num) {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;

        if (isNullOrEmpty(num)) num = "";
        else num = num + "";

        return num.replace(regexp, ',');
      };

      // 숫자콤마제거
      vm.delComma = function(str) {
        if (isNullOrEmpty(str)) str = "0";
        return str.replace(/,/g, "");
      };

      // 숫자 두자리(00) 맞춤
      vm.setZero = function(num) {      
        if (parseInt(num) < 10) {
            num = "0" + num;
        }
    
        return num;
      };

      // 현재일시 반환 (YYYY-MM-DD)
      vm.getNow = function() {      
        var now = new Date();

        return now.getFullYear() + "-" + vm.setZero(now.getMonth() + 1) + "-" + vm.setZero(now.getDate()); 
        //  + ' ' + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
      };

      // 날짜 추가 후 반환 (YYYY-MM-DD)
      vm.addDate = function(dateStr, addDate) {      
        var dateStrArr = dateStr.split("-");
        var date = new Date(dateStrArr[0], dateStrArr[1] - 1, dateStrArr[2]);        
        
        date.setDate(date.getDate() + addDate);

        return date.getFullYear() + "-" + vm.setZero(date.getMonth() + 1) + "-" + vm.setZero(date.getDate()); 
      };

      // 두 날짜간의 일수 차이 반환
      vm.getDiffDay = function(date1, date2) {      
        var date1Arr = date1.split("-");
        var date2Arr = date2.split("-");
        date1 = new Date(date1Arr[0], date1Arr[1] - 1, date1Arr[2]);        
        date2 = new Date(date2Arr[0], date2Arr[1] - 1, date2Arr[2]);        
                
        return (date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24); 
      };
    }
  ]);

/* "use strict"; */
webapp.service('postApi', [
  '$resource',
  'StaticVariable',
  '$rootScope',
  '$window',
  '$timeout',
  '$http',
  function postApi(
    $resource,
    StaticVariable,
    $rootScope,
    $window,
    $timeout,
    $http
  ) {
    /**
     * * Noti
     *   - 사용방법 예시
     *     * postApi.get('namespace.method', data, function(){});
     *     * postApi.get(data, function(){});
     *     * postApi.get(data, callbackFnc);
     *       > function callbackFnc() {}
     *
     *      var data = {mapCode : 'Role.getRoleList'};
     *      postApi.get(data, function(result){
     *        console.log("type B", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, function(result){
     *        console.log("type C", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, callback);
     *      function callback(result) {
     *        console.log("type D", result);
     *      }
     *
     *   - 호출 타입
     *     * postApi 내 type 참고
     **/

    function decodeString(val) {
      if (val === undefined || val === null) return "";
      return val.toString()
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&rarr;/g, '→');
    }

    var postApi = {
      runningCode: {},
      type: {
        select: 'select',
        insert: 'insert',
        update: 'update',
        delete: 'delete',
        action: 'action',
        attach: 'attach',
        excel: 'excel',
        api: 'api',
        openApi: 'openapi',
        login: 'login',
      },
      makeData: function (D) {
        if (
          $window.sessionStorage['loginTenantId'] != '' &&
          $window.sessionStorage['loginTenantId'] != null &&
          $window.sessionStorage['loginTenantId'] != undefined
        ) {
          D.userkey = $rootScope.gVariable.userKey;
        }
        if (
          $window.sessionStorage['loginSysAdminYN'] == 'Y' &&
          !D.srchTenantId
        ) {
          D.srchTenantId = $rootScope.gVariable.srchTenantId;
        }

        if (
          ($window.sessionStorage['loginSysAdminYN'] == 'Y' ||
            $window.sessionStorage['loginTenantAdminYn'] == 'Y') &&
          !D.srchBranchId
        ) {
          D.srchBranchId = $rootScope.gVariable.srchBranchId;
        }

        return D;
      },
      makeErrorMsg: function (errorType) {
        var result = {};
        if (errorType == 'undefinedSqlMap')
          result.header = {
            status: 405,
            msg: "This service requires a 'mapCode' key for data.",
          };
        result.body = {};
        console.log("error");
        // console.error(result.header);
        return result;
      },
      // 시큐어코딩으로 주석 후 수정 2023-07-14
      // makeResultData: function (D) {
      //   var result = { header: { status: 400 }, body: { decs: [], docs: [] } };
      //   if (D == null || D.responseVO == null) return result;
      //   result.header = D.responseVO.header;
      //   result.body = D.responseVO.body;
      //   return result;
      // },
      makeResultData: function (D) {
        var result = {};
        if (D == null) return result;
        if (D.responseVO != null) {
          result.header = D.responseVO.header;
          result.body = D.responseVO.body;
        
          if (result.body) {
            var keys = Object.keys(result.body);
            keys.forEach(function(key) {
              if (key == 'docs' && Array.isArray(D.responseVO.body[key])) {
                D.responseVO.body[key].forEach(function(item) {
                  if (item && item.encElements) {
                    var arr = item.encElements.split(",");
                    arr.forEach(function(ele) {
                      if (item[ele] !== undefined && item[ele] !== null) {
                        item[ele] = decodeString(item[ele]);
                      }
                    });
                  }
                });
              }
              result.body[key] = D.responseVO.body[key];
            });
          }
        } else if (D.header != null) {
          result.header = D.header;
          result.body = D.body;
        
          if (result.body) {
            var keys = Object.keys(result.body);
            keys.forEach(function(key) {
              if (key == 'docs' && Array.isArray(D.body[key])) {
                D.body[key].forEach(function(item) {
                  if (item && item.encElements) {
                    var arr = item.encElements.split(",");
                    arr.forEach(function(ele) {
                      if (item[ele] !== undefined && item[ele] !== null) {
                        item[ele] = decodeString(item[ele]);
                      }
                    });
                  }
                });
              }
              result.body[key] = D.body[key];
            });
          }
        } else {
          result = decodeString(D);
        }
        return result;
      },
      getMapCode: function (D) {
        var obj = { result: false, mapcode: '' };
        for (var key in D)
          if (key.toLowerCase() == 'mapcode') {
            obj.result = true;
            obj.mapcode = D[key];
            obj.data = D;
            delete obj.data.mapCode;
          }
        return obj;
      },
      sendPost: function (p1, p2, p3, callback, callback2) {
        var thisObj = this;

        /**
         * @Date  : 2020. 02. 20
         * @ISSUE : Insert, Update, Delete 중복 클릭시 여러번 호출되는 문제
         * @processing :
         *  SQLID, MapCode를 체크하여 중복클릭인지를 확인
         *  값이 존재하지 않을 경우 정상 프로세스를 태운 후 값을 받고 1초 후에 Map에서 삭제
         *  값이 존재할 경우 1분동안 콜백을 기다리고 1분이 지났을 경우에는 Map에서 삭제
         */
        if (this.runningCode[p2] != undefined) {
          var startTime = new Date(this.runningCode[p2].time);
          var now = new Date().getTime();
          var elapsed = (now - startTime) / 1000;
          if (elapsed > 60) {
            delete thisObj.runningCode[p2];
          } else {
            return;
          }
        } else {
          if (
            p1.toLowerCase() == this.type.insert ||
            p1.toLowerCase() == this.type.update ||
            p1.toLowerCase() == this.type.delete
          ) {
            this.runningCode[p2] = {
              type: p1,
              time: new Date().getTime(),
            };
          }
        }

        try {
          var param = {},
            vm;
          if (p3.ctrl != undefined) {
            vm = p3.ctrl;
            param = angular.copy(p3);
            delete param.ctrl;
          } else {
            param = angular.copy(p3);
          }
          var timeSec = 1000;
          if (vm) vm.dataloader = true;
          $resource(
            StaticVariable.getUrl('/' + p1 + '/' + p2 + '/action.json'),
            { userkey: $rootScope.gVariable.userKey },
            StaticVariable.getRequestActions.defaultAction()
          )
            .post(this.makeData(param))
            .$promise.then(
              function (data) {
                callback(postApi.makeResultData(data), p2);
                if (
                  p1.toLowerCase() == thisObj.type.insert ||
                  p1.toLowerCase() == thisObj.type.update ||
                  p1.toLowerCase() == thisObj.type.delete
                ) {
                  $timeout(function () {
                    delete thisObj.runningCode[p2];
                  }, 1000);
                }
                $timeout(function () {
                  if (vm) vm.dataloader = false;
                }, timeSec);
              },
              function (error) {
                callback2(error, p2);
                if (
                  p1.toLowerCase() == thisObj.type.insert ||
                  p1.toLowerCase() == thisObj.type.update ||
                  p1.toLowerCase() == thisObj.type.delete
                ) {
                  $timeout(function () {
                    delete thisObj.runningCode[p2];
                  }, 1000);
                }
                $timeout(function () {
                  if (vm) vm.dataloader = false;
                }, timeSec);
              }
            );
        } catch (e) {
          console.log("error");
          // console.error(e);
        }
      },
      sendPostOpen: function (p1, p2, p3, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/' + p1 + '/' + p2 + '.json'),
          {},
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(p3))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      sendPostCustom: function (p1, p2, p3, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/' + p1 + '/' + p2 + '/actionCustom.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(p3))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      sendPostApi: function (p1, p2, p3, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/' + p1 + '/' + p2 + '.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(p3))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      login: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPostOpen(
            this.type.login,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPostOpen(
              this.type.login,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      select: function (p1, p2, callback, callback2) {
        if (Array.isArray(p1)) {
          // HJH GJ - 20200103 멀티 Select를 할 수 있는 환경 추가
          // postApi.select(data, function(result) {});
          // data 가 배열일 경우 해당 루트를 타게됨
          // data 구조 = [{mapCode: "map1", param: data},{mapCode: "map1", param: data}];
          // 기존과 다르게 mapCode 명시 - 같은 파라메터를 넘길 수 있음으로 mapCode가 key 값을 가지게 됨
          for (var i = 0; i < p1.length; i++) {
            this.sendPost(
              this.type.select,
              p1[i].mapCode,
              p1[i].param,
              function (data, mapCode) {
                data.mapCode = mapCode;
                p2(data);
              }
            );
          }
        } else {
          if (typeof p1 == 'string') {
            this.sendPost(
              this.type.select,
              p1,
              p2,
              function (data) {
                callback(data);
              },
              function (data) {
                callback2(data);
              }
            );
          } else {
            var code = this.getMapCode(p1);
            if (code.result) {
              this.sendPost(
                this.type.select,
                code.mapcode,
                code.data,
                function (data) {
                  p2(data);
                },
                function (data) {
                  callback(data);
                }
              );
            } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
          }
        }
      },
      callbackSelect: function (p1, p2, tempData, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.select,
            p1,
            p2,
            function (data) {
              callback(data, tempData);
            },
            function (data) {
              callback2(data, tempData);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.select,
              code.mapcode,
              code.data,
              function (data) {
                p2(data, tempData);
              },
              function (data) {
                callback(data, tempData);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      selectCustom: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPostCustom(
            this.type.select,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPostCustom(
              this.type.select,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      insert: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.insert,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.insert,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else callback2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      update: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.update,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.update,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      delete: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.delete,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.delete,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      action: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.action,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.action,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      attach: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.attach,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.attach,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      excel: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPost(
            this.type.excel,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPost(
              this.type.excel,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      excelFile: function (p1, p2, p3, callback, callback2) {
        var url = null;
        var data = {};
        var finleNm;
        var cal1, cal2;
        if (typeof p1 == 'string') {
          url = StaticVariable.getUrl(
            '/' + this.type.excel + '/' + p1 + '.json'
          );

          if (typeof p2 == 'string') {
            if (p2.indexOf('xls') != -1 || p2.indexOf('xlsx') != -1) {
              fileNm = p2;
            } else {
              fileNm = p2 + '.xlsx';
            }
            data = p3;
            cal1 = callback;
            cal2 = callback2;
          } else {
            fileNm = '';
            data = p2;
            cal1 = p3;
            cal2 = callback;
          }
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            url = StaticVariable.getUrl(
              '/' + this.type.excel + '/' + code.mapcode + '.json'
            );
            data = p1;
          } else {
            p2(postApi.makeErrorMsg('undefinedSqlMap'));
            return;
          }

          if (p1.fileNm != undefined) {
            if (
              p1.fileNm.indexOf('xls') != -1 ||
              p1.fileNm.indexOf('xlsx') != -1
            ) {
              fileNm = p1.fileNm;
            } else {
              fileNm = p1.fileNm + '.xlsx';
            }
          } else {
            fileNm = '';
          }

          cal1 = p2;
          cal2 = p3;
        }
        var temp = {};
        temp = this.makeData(temp);
        url += '?userkey=' + temp.userkey;
        $http({
          method: 'POST',
          url: url,
          data: data,
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: 'application/octet-stream' });
              var url = window.URL.createObjectURL(blob);

              if (fileNm == '') {
                var urls = url.split('/');
                fileNm = urls[urls.length - 1] + '.xlsx';
              }
              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', fileNm);
              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
              });
              linkElement.dispatchEvent(clickEvent);
              if (cal1 != undefined) {
                cal1(data);
              }
            } catch (ex) {
              if (cal2 != undefined) {
                cal2(ex);
              }
            }
          })
          .error(function (data) {
            if (cal2 != undefined) {
              cal2(data);
            }
          });
      },
      api: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPostApi(
            this.type.api,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPostApi(
              this.type.api,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      openApi: function (p1, p2, callback, callback2) {
        if (typeof p1 == 'string') {
          this.sendPostOpen(
            this.type.openApi,
            p1,
            p2,
            function (data) {
              callback(data);
            },
            function (data) {
              callback2(data);
            }
          );
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            this.sendPostOpen(
              this.type.openApi,
              code.mapcode,
              code.data,
              function (data) {
                p2(data);
              },
              function (data) {
                callback(data);
              }
            );
          } else p2(postApi.makeErrorMsg('undefinedSqlMap'));
        }
      },
      ajax: {
        get: function (p1, p2, callback) {
          if (typeof p1 == 'string')
            postApi.ajax.sendAjax(postApi.type.select, p1, p2, function (data) {
              callback(data);
            });
          else {
            var code = postApi.getMapCode(p1);
            code.result
              ? postApi.ajax.sendAjax(
                  postApi.type.select,
                  code.mapcode,
                  code.data,
                  function (data) {
                    p2(data);
                  }
                )
              : p2(postApi.makeErrorMsg('undefinedSqlMap'));
          }
        },
        set: function (p1, p2, callback) {
          if (typeof p1 == 'string')
            postApi.ajax.sendAjax(postApi.type.insert, p1, p2, function (data) {
              callback(data);
            });
          else {
            var code = postApi.getMapCode(p1);
            code.result
              ? postApi.ajax.sendAjax(
                  postApi.type.insert,
                  code.mapcode,
                  code.data,
                  function (data) {
                    p2(data);
                  }
                )
              : p2(postApi.makeErrorMsg('undefinedSqlMap'));
          }
        },
        upt: function (p1, p2, callback) {
          if (typeof p1 == 'string')
            postApi.ajax.sendAjax(postApi.type.update, p1, p2, function (data) {
              callback(data);
            });
          else {
            var code = postApi.getMapCode(p1);
            code.result
              ? postApi.ajax.sendAjax(
                  postApi.type.update,
                  code.mapcode,
                  code.data,
                  function (data) {
                    p2(data);
                  }
                )
              : p2(postApi.makeErrorMsg('undefinedSqlMap'));
          }
        },
        del: function (p1, p2, callback) {
          if (typeof p1 == 'string')
            postApi.ajax.sendAjax(postApi.type.delete, p1, p2, function (data) {
              callback(data);
            });
          else {
            var code = postApi.getMapCode(p1);
            code.result
              ? postApi.ajax.sendAjax(
                  postApi.type.delete,
                  code.mapcode,
                  code.data,
                  function (data) {
                    p2(data);
                  }
                )
              : p2(postApi.makeErrorMsg('undefinedSqlMap'));
          }
        },
        sendAjax: function (type, sqlmap, data, callback) {
          if (data == undefined) data = {};
          var url = '/' + type + '/' + sqlmap + '/action.json';
          if (sqlmap.indexOf('.json') > -1) url = '/' + type + '/' + sqlmap;
          data.userkey = $rootScope.gVariable.userKey;
          if (
            $window.sessionStorage['loginSysAdminYN'] == 'Y' &&
            !data.srchTenantId
          ) {
            data.srchTenantId = $window.sessionStorage['srchTenantId'];
          }
          url = StaticVariable.getUrl(url);
          url = url + '?' + $rootScope.gVariable.userKey;
          var reciveJsonData = null;
          $.ajax({
            type: 'POST',
            url: url,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            async: false,
            crossDomain: true,
            beforeSend: function (xhr) {},
            success: function (result) {
              callback(reciveJsonData);
            },
            error: function (jqXHR, textStatus, errorThrown) {},
          });
        },
      },
      insertComplex: function (data, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/rainbow/insertComplex.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(data))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      fileInsert: function (data, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/independent/insertFile.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(data))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      fileSelect: function (data, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/independent/selectFile.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(data))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      fileDelete: function (data, callback, callback2) {
        $resource(
          StaticVariable.getUrl('/independent/deleteFile.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
          .post(this.makeData(data))
          .$promise.then(
            function (data) {
              callback(postApi.makeResultData(data));
            },
            function (error) {
              callback2(error);
            }
          );
      },
      duplicateMobileCheck: function (data, callback, callback2) {
        if (data.UserNm && data.Mobile) {
          $resource(
            StaticVariable.getUrl('/login/duplicateMobileCheck.json'),
            { userkey: $rootScope.gVariable.userKey },
            StaticVariable.getRequestActions.defaultAction()
          )
            .post(this.makeData(data))
            .$promise.then(
              function (data) {
                callback(postApi.makeResultData(data));
              },
              function (error) {
                callback2(error);
              }
            );
        }
      },
      home: function (p1, callback, callback2) {
        var code = this.getMapCode(p1);
        if(!code.result) {
          return {header: {status: 500}};
        }
        return this.sendPostOpen('home', code.mapcode, code.data, callback, callback2);
      },
    };
    return postApi;
  },
]);

(function () {
  "use strict";
  webapp.controller('BusinessOpTabCommCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', 'gAlert',
  function BusinessOpTabCommCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, gAlert) {

    var vm = this;
    vm.srch = {};
    vm.srch.KeyId = $stateParams.KeyId;

    vm.pages = 'app/business/business-op-detail.html';

    function getList() {
      var data = angular.copy(vm.srch);
      data.mapCode = 'BusinessOP.getBusinessCommList';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            getListAction(vm.lists);
          } else {
            vm.lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error> BusinessOpTabCommCtrl> getList()', status, error);
        vm.dataloader = false;
      });
    }

    function getListAction(array) {
      vm.lists = {};

      for (var i = 0; i < array.length; i ++) {
        var obj = {"KeyId" : array[i]['KeyId'], "Contents" : array[i]['Contents'] , "Level" : array[i]['Level'], "RegUser" : array[i]['RegUser'], "RegDate" : array[i]['RegDate'], "BusinessOpId" : array[i]['BusinessOpId']};
        obj.commentList = [];
        vm.lists[obj.KeyId] = obj;
        var parent = array[i]['ParentId'] || '-';

        if (!vm.lists[parent]) { 
          vm.lists[parent] = { commentList: [] };
        }
        vm.lists[parent].commentList.push(obj);
      }
      // return vm.lists['-'].commentList;
      return vm.lists['-'];
    }

    function init() {
      getList();
    }

    function addComment(p1, p2) {
      vm.lists[0].commentList[p2].commDisplayYN = vm.lists[0].commentList[p2].commDisplayYN ? false : true;
      vm.data.Comment[p2] = '';
    }

    function setComment (p1, p2) {
      var data = {};

      if (isNullOrEmpty(p2)) {
        gAlert("","댓글을 입력해주세요.");
        return false;
      }

      data = { BusinessOpId : p1.BusinessOpId, Contents : p2, KeyId : p1.KeyId};  

      if (!isNullOrEmpty(data)) {
        data.mapCode = 'BusinessOP.insertBusinessCommentBatch';
        
        postApi.insert(data, function (result) {
          vm.dataloader = false;
          init();
          return;
        }, function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error("Error> setComment()");
          // console.table(error);
        });
      }
    }

    function setData() {
      var data = {};

      if (isNullOrEmpty(vm.data)) {
        gAlert("","내용을 입력해주세요.");
        return false;
      }

      data = { BusinessOpId : vm.srch.KeyId, Contents : vm.data.opContents};

      if (!isNullOrEmpty(data)) {
        data.mapCode = 'BusinessOP.insertBusinessCommBatch';
        
        postApi.insert(data, function (result) {
          vm.dataloader = false;
          init();
          return;
        }, function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error("Error> setComment()");
          // console.table(error);
        });
      }
    }

    vm.getList = getList;
    vm.init = init;
    vm.addComment = addComment;
    vm.setComment = setComment;

    vm.setData = setData;

    init();
  }]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessOpTabCustomerCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function BusinessOpTabCustomerCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    // 고객 추가 팝업창
    vm.busiWriteModal = function (keyId) {
      var ctrl = 'KSACustListCtrl as vc';
      var paramData = { KeyId: keyId };

      var modalInstance = modalFactory.open('mf-80', 'app/client/ksacust-list.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        var KeyId = 0;
        // 새로등록
        if (!isNullOrEmpty(okData)) {
          KeyId = okData;
        }
        // 수정하는 경우
        else {
          KeyId = okData.KeyId;
        }
        vm.busiWriteModal(KeyId);
      }, function (cancelData) {
      });
    };

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_MEMBER",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        // initSelectCnt : { mapCode : "ScCustomer.getSccusthistListCnt", param : null },
        initSelect : { mapCode : "BusinessOP.getCustList", param : {BusinessOPId: $stateParams.KeyId} },
        
      },

      // List
      // listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
    };

    vm.pages = 'app/business/business-op-detail.html';

    function onReadyAutoView() {

    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessOpTabDrCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function BusinessOpTabDrCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    // 영업일지 등록 팝업창
    vm.busiWriteModal = function () {
      var ctrl = 'BusinessDrModalCtrl as vc';
      var paramData = { BusinessOPId: $stateParams.KeyId, BusinessOP: 'BusinessOP' };
      var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        var KeyId = 0;
        // 새로등록
        if (!isNullOrEmpty(okData)) {
          KeyId = okData;
        }
        vm.busiWriteModal(KeyId);
      }, function (cancelData) {
      });
    };

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_BUSINESSDR",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {
        initSelectCnt: { mapCode: "BusinessDR.getBusinessDRListCnt", param: {BusinessOPId: $stateParams.KeyId} },
        initSelect: { mapCode: "BusinessDR.getBusinessDRList", param: {BusinessOPId: $stateParams.KeyId} }
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback: clickevent,
    };

    vm.pages = 'app/business/business-op-detail.html';

    function onReadyAutoView() {
    }

    function clickevent(clickData) {
      vm.busiWriteModal(clickData.KeyId, 'N');
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.clickevent = clickevent;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  'use strict';
  webapp.controller('BusinessOpTabFilesCtrl', [
    '$scope',
    '$stateParams',
    'autoView',
    'postApi',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    '$rootScope',
    '$timeout',
    'gAlert',
    function BusinessOpTabFilesCtrl(
      $scope,
      $stateParams,
      autoView,
      postApi,
      CONSTANT,
      modalFactory,
      StaticVariable,
      $rootScope,
      $timeout,
      gAlert
    ) {
      var vm = this;
      vm.vault = null;

      vm.pages = 'app/business/business-op-detail.html';

      vm.data = {};

      //#region 업로드 파일 목록
      vm.uploadFileList = [];
      vm.oldUploadFileList = [];
      vm.showUploader = false;
      //#endregion 업로드 파일 목록

      vm.uploadFile = function () {
        vm.oldUploadFileList = vm.oldUploadFileList;
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          uploadVaultFile(vm.vault);
        } else {
          setData();
        }
      };

      //#region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드 완료
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link =
                StaticVariable.getUrl(item.tmpLink) +
                '?fileName=' +
                item.fileName +
                '&userkey=' +
                $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          var param = {
            fileId: item.id,
          };
          postApi.attach(
            param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.DELETED');
              }
            },
            function (error) {
              // 삭제 실패
              console.log("error");
              // console.error('Error> onFileDelete()');
              // console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          vm[id] = vault;
        },
      };
      //#endregion 첨부파일 Callback

      //#region 첨부파일목록
      function getFileList() {
        var uploadFileList = [];
        var data = {};

        data.tableNm = 'TB_BUSINESSOP';
        data.TableId = $stateParams.KeyId;

        postApi.fileSelect(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                angular.forEach(result.body.docs, function (item) {
                  var obj = {
                    id: item.fileId,
                    isLoaded: true,
                    link: StaticVariable.getFileDownloadUrl(
                      item.PhysicalFileNm
                    ),
                    // link: StaticVariable.getUrl(
                    //   "/attach/file/" +
                    //     item.PhysicalFileNm +
                    //     "/download.do?path=" +
                    //     item.PhysicalPath +
                    //     "&fileName=" +
                    //     item.LogicalFileNm
                    // ),
                    fileName: item.LogicalFileNm,
                    size: item.FileSize,
                    fileKey: item.PhysicalFileNm,
                    typeId: 'file',
                    path: item.PhysicalPath,
                    downloadCnt: item.DownloadCnt,
                    regDate: item.RegDate,
                  };
                  uploadFileList.push(obj);
                });
                angular.copy(uploadFileList, vm.uploadFileList);
                angular.copy(uploadFileList, vm.oldUploadFileList);
                vm.lists = vm.uploadFileList;
                // return;
              } else {
                vm.lists = {};
              }
            }
          },
          function (error) {
            console.log("error");
            // console.error(
            //   'Error> business-op-tab-files-ctrl> getFileList()',
            //   status,
            //   error
            // );
            gAlert('', result.body.docs[0].errMessage);
          }
        );
      }
      //#endregion 첨부파일목록

      function setData() {
        var data = {};
        data.tableNm = 'TB_BUSINESSOP';
        data.RelateDataId = $stateParams.KeyId;
        data.uploadFileList = vm.uploadFileList;
        data.oldUploadFileList = vm.oldUploadFileList;
        postApi.fileInsert(data, function (result) {
          if (data.oldUploadFileList.length == data.uploadFileList.length) {
            gAlert('', '파일을 찾을 수 없습니다.');
            return;
          }
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.SAVED', {
              btn: '',
              fn: function () {
                vm.uploadFileList = [];
                getFileList();
              },
            });
          }
        });
      }

      function delData() {
        vm.KeyIdList = [];

        vm.lists.forEach(function (item) {
          if (item.chkRow) {
            item.delState = 'delete';
            item.fileKey = item.fileKey;
            item.id = item.id;
            item.path = item.path;
            vm.KeyIdList.push(item.fileId);
          }
        });

        if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = {};
        data.tableNm = 'TB_BUSINESSOP';
        data.RelateDataId = $stateParams.KeyId;
        data.uploadFileList = vm.lists;

        postApi.fileDelete(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  getFileList();
                },
              });
            }
          },
          function (error) {
            // 조회 중 오류 발생
            console.log("error");
            // console.error('Error> delData()');
            // console.table(error);
          }
        );
      }

      function init() {
        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

        getFileList();
      }

      vm.init = init;
      vm.setData = setData;
      vm.delData = delData;

      init();
    },
  ]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessOpTabHistCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function BusinessOpTabHistCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_BUSINESSP_HIST",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",

      apis : {

        initSelectCnt: { mapCode: "BusinessOP.getHistListCnt", param: {KeyId: $stateParams.KeyId} },
        initSelect: { mapCode: "BusinessOP.getHistList", param: {KeyId: $stateParams.KeyId} },
        
      },

      // List
      // listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },
      
      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
    };

    vm.pages = 'app/business/business-op-detail.html';
    
    function onReadyAutoView() {
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('CampaignCustModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function CampaignCustModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {
    var vm = this;

    // 변수설정
    vm.CmpgnImpChannel = mdata.CmpgnImpChannel;
    vm.title = mdata.title;

    vm.srch = {
      page: 1,
      viewSize: CONSTANT.PAGINATION.VIEWSIZE,
      ErrYN : mdata.errYN, 
      DenyYN : mdata.errYN,
      CmpgnImplCustIdList : [],
      keyId : mdata.keyId
    };
    
    vm.viewSize = vm.srch.viewSize;
    vm.currentPage = vm.srch.page;

    // 페이지번호 변경이벤트
     function pageChanged() {
      vm.srch.page = vm.currentPage;

      getList();
    }

    // 검색
    function getSearch() {
      vm.srch.pag = 1;
      vm.currentPage = vm.srch.page;

      getList();
    }
    
    // 초기설정
    function init() {
      getList();
    }
    
    // 저장 클릭이벤트
    function ok(clickData) {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    // 닫기 클릭이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    // 캠페인 고객 목록 건수
    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign.getCampaignCustomerListCnt";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
      });
    }

    // 캠페인 고객 목록
    function getList() {
      getListCnt();
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign.getCampaignCustomerList";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        } else {
          vm.lists = [];
        }
      });
    }

    // 체크박스 전체 체크
    vm.chkRowAll = function() {
      for(var i = 0 ; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.checkListCheckbox;
      }
    };

    // 목록 삭제 확인
    function setDelList() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          setDelListAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    // 목록 삭제      
    function setDelListAction() {
      vm.srch.KeyIdList = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.srch.CmpgnImplCustIdList.push(vm.lists[i].CmpgnImplCustId);
        }
      }

      if (vm.srch.CmpgnImplCustIdList == null || vm.srch.CmpgnImplCustIdList.length == 0) {
        gAlert('', 'Menu.DELETENODATA');
        return false;
      }

      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign.deleteCampaignCustomerList";

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.log("error");
        // console.error("Error> setDelListAction()");
        // console.table(error);
      });
    }

    // 함수연결
    vm.cancel = cancel;
    vm.pageChanged = pageChanged;
    vm.getSearch = getSearch;
    vm.setDelList = setDelList;

    init();
  }]);
})();
webapp.controller('CampaignEditModalCtrl', [ '$uibModalInstance', 'toModalData', '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert', 'gConfirm', '$timeout',
    function CampaignEditModalCtrl($uibModalInstance, toModalData, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert, gConfirm, $timeout) {
      var vm = this;      
      //var LoginId = $window.sessionStorage['loginUserId'];
      var editCnt = 0;
      var oEditors = [];
            
      vm.data = {};
      vm.messageMaxLength = '90';
      vm.bytes = '0';
      vm.segList = [];

      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.Edit, // List OR Edit

        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "TB_CAMPAIGNIMPL",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data", // ex : vc.data = {}
        apis : {
          /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
          initSelect: { mapCode: "Campaign.getCampaignDetail", param: { keyId: toModalData.keyId, uploadFileList : [], IdName : 'keyId'} },      
        },
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow: [],
  
        // vc의 ng-if
        ngIf: {
          StartDate: "vc.data.SendType == '20'",
          SendMessage: "vc.data.CmpgnImpChannel != 'EMAIL'"
        },
        
        // 비활성화 시킬 컬럼의 조건
        disabled: {
          TargetCnt: true,
          CmpgnImpChannel : "vc.data.keyId != null && vc.data.keyId != ''",
          SendType : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
          FromInfo : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
          ManagerId : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
          SendTitle : "vc.data.keyId != null && vc.data.Status != 'TEMP'",
          ServPoint : true
        },
  
        // MataColum 외 추가 적으로 넣어야할 폼
        addForm: {
        },

        // vc의 ng -click 
        ngClick: {
          Form: "FormModal"
        },

        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          CmpgnImpChannel: "setChangeCmpgnImpChannel"
        },

        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {

        },

        // 달력 시간 옵션
        timeOption: {
          StartDate: {
            minuteStep: 30, initActiveCalendar: true
          }
        },

        autocomplete: {
        },
        // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
        //noLable : ["ChartNoAutoYN"],

        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
          ManagerId: "codeManager",
          FromInfo: "codeSendNumber",
          CmpgnImpChannel : "codeChannel"
        },

        // textArea 사이즈 옵션
        textAreaOption: {
          SendMessage: { rows: 12 }
        },

        // 필수 항목 컬럼 
        required: []        
      };

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }
     
      function onReadyAutoView() {        
        vm.tabId = 'tab1';
        vm.dataloader = false;

        if (!vm.data.keyId) {
          vm.data.CmpgnImpChannel = "SMS";
          vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
          vm.data.SendType = "10";
          vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];

          var checkReloadSms = $window.sessionStorage.getItem("scheduleToSms");
          // if (eval(checkReloadSms)) {
          if (checkReloadSms === "true") {
            $window.sessionStorage.setItem("scheduleToSms", false);
            getCampaignCustomerList('R');
          } else {
            getCampaignCustomerList('F');
          }
        } else {
          vm.data.FromInfoOrg = angular.copy(vm.data.FromInfo);
          vm.data.SendTitleOrg = angular.copy(vm.data.SendTitle);
          vm.data.SendMessageOrg = angular.copy(vm.data.SendMessage);
          vm.data.AgreeYNOrg = angular.copy(vm.data.AgreeYN);
          vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
          if (vm.data.CmpgnImpChannel == 'LMS') {
            vm.lmsYN = 'Y';
          }
          getCampaignCustomerList('R');
        }

        vm.layout = $state.current.name.indexOf('sms-send-list') == -1 && $state.current.name.indexOf('campaign-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard;

        getSendVerifySimpleList('M');
        //getBranchDetail();          
        chkSmsByte();

        var uploadFileList = [];

        angular.forEach(vm.data.uploadFileList, function(item) {
          var obj = {
            id : item.fileId,
            isLoaded : true,
            link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
            fileName : item.LogicalFileNm,
            size : item.FileSize,
            fileKey : item.PhysicalFileNm,
            path : item.PhysicalPath,
            downloadCnt : item.DownloadCnt,
          };
          uploadFileList.push(obj);
        });

        angular.copy(uploadFileList, vm.uploadFileList);
      }
      
      // 발송채널코드 설정
      vm.codeChannel = [
        {Code : 'SMS', CodeValue : 'SMS(단문)'},
        {Code : 'LMS', CodeValue : 'LMS(장문)'},
        {Code : 'MMS', CodeValue : 'MMS(이미지)'},
        /* {Code : 'KAKAO', CodeValue : '알림톡'}, */
        {Code : 'EMAIL', CodeValue : '이메일'},
      ];

      // 담당자코드 설정
      postApi.select({ mapCode: 'Campaign.getUserListCodes' }, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
        }
      }, function (error) {
        console.table(error);
      });  

      // 발송번호/이메일 목록
      function getSendVerifySimpleList(type) {          
        postApi.select({ mapCode: 'SendVerify.getSendVerifySimpleList', Type : type }, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeSendNumber = result.body.docs;
            vm.data.FromInfo = result.body.docs[0].Code;
          }
        }, function (error) {
          console.table(error);
        });  
      }       

      // 스마트에디터 세팅
      vm.initEditor = function () {
        if (editCnt == 0) {
          var sLang = "ko_KR"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR

          // 추가 글꼴 목록
          //var aAdditionalFontSet = [["MS UI Gothic", "MS UI Gothic"], ["Comic Sans MS", "Comic Sans MS"],["TEST","TEST"]];
          nhn.husky.EZCreator.createInIFrame({
            oAppRef: oEditors,
            elPlaceHolder: "strHtml",
            sSkinURI: "assets/app/SE2.9/SmartEditor2Skin.html",
            htParams: {
              bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)
              bUseVerticalResizer: true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)
              bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)
              //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)
              //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록
              fOnBeforeUnload: function () {
                //alert("완료!");
              },
              I18N_LOCALE: sLang
            }, //boolean
            fOnAppLoad: function () {
              if (!isNullOrEmpty(vm.data.SendMessage)) {
                oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.SendMessage]);
              }
              //예제 코드
              //oEditors.getById["strHtml"].exec("PASTE_HTML", []);
            },
            fCreator: "createSEditor2"
          });
          editCnt = editCnt + 1;
        } else {
          oEditors.getById["strHtml"].exec("SET_IR", ['']);
          return;
        }
      };      

      // 서식검색 팝업
      vm.FormModal = function () {
        var FormType = '';

        if (isNullOrEmpty(vm.data.CmpgnImpChannel)) {
          gAlert('', '발송채널을 먼저 선택해주시기 바랍니다.');
          return;
        }

        if (vm.data.CmpgnImpChannel == 'SMS' || vm.data.CmpgnImpChannel == 'LMS' || vm.data.CmpgnImpChannel == 'MMS') {
          FormType = 'SMS';
        } 
        else if (vm.data.CmpgnImpChannel == 'KAKAO') {
          FormType = vm.data.CmpgnImpChannel;
        } 
        else {
          FormType = 'EMAIL';
        }

        var ctrl = 'FormIncModalCtrl as vc';
        var data = {
          FormType: FormType,
        };

        var modalInstance = modalFactory.open('md', 'app/campaign/modal/form-inc-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {
          vm.data.FormNm = okData.FormNm;
          vm.data.FormId = okData.KeyId;
          vm.data.SendMessage = okData.Contents;

          if (!isNullOrEmpty(okData.KakaoTemplateKey)) {
            vm.data.KakaoTemplateKey = okData.KakaoTemplateKey;
          }
          
          chkSmsByte();
        }, function (cancelData) {
        });
      };

      // 직접입력 팝업
      vm.ReceiveNumberModal = function () {
        var ctrl = 'DirectInputModalCtrl as vc';
        var data = {
          keyId: toModalData.keyId
        };

        var modalInstance = modalFactory.open('sm', 'app/campaign/modal/direct-input-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {
          getCampaignCustomerList('R');
        }, function (cancelData) {
        });
      };

      // 조건검색투입 팝업
      vm.extCustModal = function() {
        var ctrl = 'ExtCustModalCtrl as vc';
        var data = {
          keyId: toModalData.keyId,      
          CmpgnImpChannel : vm.data.CmpgnImpChannel,
          segList: angular.copy(vm.segList),
        };

        var modalInstance = modalFactory.open('lg', 'app/campaign/modal/ext-cust-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {
          getCampaignCustomerList('R');
        }, function (cancelData) {
        });
      };

      // 투입고객 목록 팝업
      vm.campaignCustomerModal = function(type) {
        var title = '';
        var errYN = '';
        if (type == 'A') {
          title = '투입';
          errYN = '';
        } else if (type == 'T') {
          title = '대상';
          errYN = 'N';
        } else if (type == 'E') {
          title = '제외';
          errYN = 'Y';
        }

        var ctrl = 'CampaignCustModalCtrl as vc';
        var data = {
          keyId: toModalData.keyId,
          errYN : errYN,
          CmpgnImpChannel : vm.data.CmpgnImpChannel,
          title : title
        };

        var modalInstance = modalFactory.open('md', 'app/campaign/modal/campaign-cust-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {
        }, function (cancelData) {
          getCampaignCustomerList('R');
        });
      };

      // 안내이미지 변경
      vm.setChangeTab = function (_id) {
        vm.tabId = _id;
        $('.tab-pane.active').addClass('fade').removeClass('active');
        $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
      };

      // 업로드 파일 목록
      vm.uploadFileList = [];
      vm.showUploader = false;

      // 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드 완료
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          var param = {
            fileId: item.id
          };

          var prms = h0102Api.attachFileDelete().post(param).$promise;
          prms.then(function (data) {
            if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
              gAlert("", "Menu.DELETED");
            }
          });
        },
        onLoaded: function (id, vault) {
          vm[id] = vault;
        }
      };

      vm.uploadFile = function (type) {
        vm.type = type;
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          uploadVaultFile(vm.vault);
        } else {
          setData();
        }
      };

      // 지점정보 조회        
      /*
      function getBranchDetail() {
        var data = { mapCode: 'organizationMng.getBranchDetail' };

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.branchData = result.body.docs[0];
              vm.branchData.TenantNm = $window.sessionStorage['loginTenantName'];
              vm.branchData.loginMobile = $window.sessionStorage['loginMobile'];
              vm.data.ServPoint = vm.branchData.ServPoint;
              vm.branchData.loginMobile = autoHypenTel(vm.branchData.loginMobile);
              vm.branchData.TelNo = autoHypenTel(vm.branchData.TelNo);
              vm.addADTxt = '(광고) 무료수신거부 ' + autoHypenTel(vm.branchData.TelNo);
            } else {
              vm.branchData = {};
            }
          }
        }, function (error) {        
          console.table(error);
        });  
      }
      */

      // 미리보기 팝업
      function SmsPreviewModal() {
        if (vm.data.CmpgnImpChannel == 'EMAIL') {
          vm.data.SendMessage = $('#strHtml').val();
        }

        var ctrl = 'SmsPreviewModalCtrl as vc';
        var data = {
          SendTitle: vm.data.SendTitle,
          SendMessage: vm.data.SendMessage
        };

        var modalInstance = modalFactory.open('sm', 'app/campaign/modal/sms-preview-modal.html', ctrl, data);
        modalInstance.result.then(function (okData) {

        }, function (cancelData) {
        });
      }

      // 이메일 미리보기 팝업
      function EmailPreviewModal() {
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        var ctrl = 'ContentsModalCtrl as modalCtrl';
        var data = {
          Title: 'Email 미리보기',
          Contents: $('#strHtml').val(),
          AgreeYN : vm.data.AgreeYN,
          TelNo : vm.branchData.TelNo
        };

        var modalInstance = modalFactory.open("lg", "components/modal/contents/contents-modal.html", ctrl, data);
        modalInstance.result.then(function (okData) {
        }, function (cancelData) {
        });
      }      

      // 미리보기 호출
      function showPreView() {
        if (isNullOrEmpty(vm.data.CmpgnImpChannel)) {
          gAlert('', '발송채널을 선택해주시기 바랍니다.');
          return;
        } else {
          if (vm.data.CmpgnImpChannel == 'EMAIL') {
            EmailPreviewModal();
          } else {
            SmsPreviewModal();
          }
        }
      }

      // 투입/대상/제외 고객수 조회
      function getCampaignCustomerList(type) {
        var data = {};
        data.mapCode = 'Campaign.getCampaignCustomerCnt';

        if (!isNullOrEmpty(toModalData.keyId)) {
          data.keyId = toModalData.keyId;
        }

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data.EnterCnt = result.body.docs[0].EnterCnt;
              vm.data.TargetCnt = result.body.docs[0].TargetCnt;
              vm.data.ExceptCnt = result.body.docs[0].ExceptCnt;

              if (type == 'F') {
                if (vm.data.EnterCnt > 0) {
                  gConfirm('', '이전에 투입된 고객 데이터가 있습니다. 초기화하시겠습니까?', {
                    btn: '',
                    fn: function () {
                      deleteCmpgnCustAction('', '', 'C');
                    }
                  }, {
                    btn: '',
                    fn: function () {

                    }
                  });
                }
              }
            }
          }
        }, function (error) {
          console.table(error);
        });  
      }

      // 발송채널 Callback
      function setChangeCmpgnImpChannel() {
        if (vm.data.CmpgnImpChannel != 'EMAIL') {
          if (vm.data.CmpgnImpChannelBefore == 'EMAIL') {
            if (isNullOrEmpty(vm.data.FromInfoOrg)) {
              vm.data.FromInfo = '';
            }
            if (isNullOrEmpty(vm.data.AgreeYNOrg)) {
              vm.data.AgreeYN = '';
            }

            getSendVerifySimpleList('M');

            if (vm.data.EnterCnt > 0) {
              deleteCmpgnCustAction('', '', 'C');
            }
          }
          

          if (vm.data.CmpgnImpChannel == 'SMS') {
            vm.showUploader = false;
            if (vm.bytes > 90) {
              gAlert('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.');
              vm.data.CmpgnImpChannel = 'LMS';
              return;
            }
            vm.messageMaxLength = '90';
          } else if (vm.data.CmpgnImpChannel == 'LMS') {
            if (vm.bytes == 0) {
              vm.data.CmpgnImpChannel = 'SMS';
              return;
            }
            vm.messageMaxLength = '2000';
          } else if (vm.data.CmpgnImpChannel == 'MMS') {
            vm.messageMaxLength = '2000';
            if (vm.data.CmpgnImpChannel == 'MMS') {
              if (vm.data.keyId != null && vm.data.Status != 'TEMP' && vm.data.Status != 'STANDBY') {
                vm.showUploader = false;
              } else {
                vm.showUploader = true;
                initVaultComponentForMMSImg('vault', vm.onFileCallback);
              }
            } else {
              vm.showUploader = false;
            }
          } else if (vm.data.CmpgnImpChannel == 'KAKAO') {
            gAlert('알림톡은 직접 입력이 불가하며 사전에 승인된 알림톡 서식으로만 사용가능합니다. 알림톡 서식을 선택하여 사용해주시기 바랍니다.');
            vm.data.SendMessage = '';
            vm.showUploader = false;
          }
        } else if (vm.data.CmpgnImpChannel == 'EMAIL') {
          if (isNullOrEmpty(vm.data.FromInfoOrg)) {
            vm.data.FromInfo = '';
          }
          if (isNullOrEmpty(vm.data.AgreeYNOrg)) {
            vm.data.AgreeYN = '';
          }

          getSendVerifySimpleList('E');
          
          vm.initEditor();
          vm.showUploader = false;
          if (vm.data.EnterCnt > 0) {
            deleteCmpgnCustAction('', '', 'C');
          }
        }

        vm.data.CmpgnImpChannelBefore = angular.copy(vm.data.CmpgnImpChannel);
      }

      // 발송채널 Callback
      function deleteCmpgnCustAction(msgSuccess, msgFail, type) {
        var data = { keyId: toModalData.keyId, mapCode: 'Campaign.deleteCampaignCustomer' };

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!isNullOrEmpty(msgSuccess)) {
              gAlert('', msgSuccess);
            }

            getCampaignCustomerList('R');

            if (type == 'A') {
              resetData();
            }
          } else {
            if (!isNullOrEmpty(msgFail)) {
              gAlert('', msgFail);
            }
            return;
          }
        }, function (error) {
          console.table(error);
        });  
      }

      // 대상고객초기화
      function resetCmpgnCustList() {
        gConfirm('', '초기화 하시겠습니까?', {
          btn: '',
          fn: function () {
            if (vm.data.EnterCnt > 0) {
              deleteCmpgnCustAction('초기화 되었습니다.', '초기화 되지 않았습니다.', 'C');
            } else {
              gAlert('', '초기화할 대상고객이 없습니다.');
            }
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 초기화 컨펌
      function resetAll() {
        gConfirm('', '전체 초기화 하시겠습니까?', {
          btn: '',
          fn: function () {
            if (vm.data.EnterCnt > 0) {
              deleteCmpgnCustAction('초기화 되었습니다.', '초기화 되지 않았습니다.', 'A');
            } else {
              gAlert('', '초기화 되었습니다.', {
                btn: '',
                fn: function () {
                  resetData();
                }
              });
            }
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 초기화
      function resetData() {
        vm.data = {
          CmpgnImpChannel: "SMS",
          SendType: "10"
        };

        vm.bytes = 0;

        if (!isNullOrEmpty(toModalData.keyId)) {
          vm.data.keyId = toModalData.keyId;
        }
      }

      // 유효성 체크
      function getIsValidData(data) {
        var errMsg = '';

        if (isNullOrEmpty(data.CmpgnNm)) {
          errMsg = errMsg + '- 캠페인명을 입력해주시기 바랍니다.<br>';
        }

        if (isNullOrEmpty(data.AppStatus)) {
          errMsg = errMsg + '- 승인상태를 선택해주시기 바랍니다.<br>';
        }

        if (data.type == 'S' && data.TargetCnt == '0') {
          errMsg = errMsg + '- 대상고객수를 확인해주시기 바랍니다.<br>';
        }

        if (isNullOrEmpty(data.FromInfo)) {
          errMsg = errMsg + '- 발송번호를 선택해주시기 바랍니다.<br>';
        }

        if (isNullOrEmpty(data.ManagerId)) {
          errMsg = errMsg + '- 담당자를 선택해주시기 바랍니다.<br>';
        }

        if (data.CmpgnImpChannel != 'SMS' && isNullOrEmpty(data.SendTitle)) {
          errMsg = errMsg + '- 제목을 입력해주시기 바랍니다.<br>';
        }

        if (isNullOrEmpty(data.SendMessage)) {
          errMsg = errMsg + '- 발송메시지를 입력해주시기 바랍니다.';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        } else {
          return true;
        }
      }

      // 발송
      function setData() {
        var successMsg = '';
        var failMsg = '';

        if (vm.type == 'T') {
          successMsg = '임시저장 되었습니다.';
          failMsg = '임시저장 되지 않았습니다.';
        } else {
          successMsg = '발송되었습니다.';
          failMsg = '발송되지 않았습니다.';

          /*
          if (!chkServPoint('S')) {
            return false;
          }
          */
        }

        var data = angular.copy(vm.data);
        data.uploadFileList = vm.uploadFileList;
        data.type = vm.type;
        data.tableNm = 'campaignimpl';
        //data.TelNo = vm.branchData.TelNo;
        data.IdName = 'keyId';

        if (!isNullOrEmpty(vm.unitPriceTotal)) {
          data.UnitPriceTotal = vm.unitPriceTotal;
        }

        if (!isNullOrEmpty(data.StartDate)) {
          data.StartDate = moment.utc(data.StartDate).format('YYYY-MM-DD HH:mm');
        }

        if (!isNullOrEmpty(data.keyId)) {
          data.mapCode = 'Campaign.updateCampaignBatch';
        } else {
          data.mapCode = 'Campaign.insertCampaignBatch';
        }

        if (data.CmpgnImpChannel == 'EMAIL') {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          data.SendMessage = $('#strHtml').val();
        }

        if (getIsValidData(data)) {
          postApi.insert(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
                vm.keyId = result.body.docs[0].RelateDataId;
              } else {
                vm.keyId = result.body.docs[0].keyId;
              }

              gAlert('', successMsg, {
                btn: '',
                fn: function () {
                  if (vm.type == 'S') {
                    $state.go('app.campaign.campaign-edit-modal', { srch: '', keyId: '' }, { reload: 'app.campaign.campaign-edit-modal' });
                  } else {
                    $state.go('app.campaign.campaign-edit-modal', { srch: '', keyId: vm.keyId }, { reload: 'app.campaign.campaign-edit-modal' });
                  }
                }
              });
            } else {
              gAlert('', failMsg);
              return;
            }
          }, function (error) {
            console.table(error);
          });  
        }
      }

      // 잔여포인트 체크
      /*
      function chkServPoint(type) {
        vm.data.UnitPrice = 0;
        vm.unitPriceTotal = 0;
        var servPointTotal = 0;          
        var message = '';

        if (isNullOrEmpty(vm.data.ServPoint)) {
          gAlert('', '남은 잔여포인트가 없습니다.');
          return false;
        }

        if (vm.data.CmpgnImpChannel == 'SMS') {
          if (isNullOrEmpty(vm.branchData.CostSMS)) {
            gAlert('', '정해진 SMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
            return false;
          } else {
            vm.data.UnitPrice = vm.branchData.CostSMS;
          }
        } else if (vm.data.CmpgnImpChannel == 'LMS') {
          if (isNullOrEmpty(vm.branchData.CostLMS)) {
            gAlert('', '정해진 LMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
            return false;
          } else {
            vm.data.UnitPrice = vm.branchData.CostLMS;
          }
        } else if (vm.data.CmpgnImpChannel == 'MMS') {
          if (isNullOrEmpty(vm.branchData.CostMMS)) {
            gAlert('', '정해진 MMS단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
            return false;
          } else {
            vm.data.UnitPrice = vm.branchData.CostMMS;
          }
        } else if (vm.data.CmpgnImpChannel == 'KAKAO') {
          if (isNullOrEmpty(vm.branchData.CostKAKAO)) {
            gAlert('', '정해진 KAKAO단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
            return false;
          } else {
            vm.data.UnitPrice = vm.branchData.CostKAKAO;
          }
        } else if (vm.data.CmpgnImpChannel == 'EMAIL') {
          if (isNullOrEmpty(vm.branchData.CostEMAIL)) {
            gAlert('', '정해진 EMAIL단가가 없어 사용이 불가능 합니다.<br>시스템관리자에게 문의 부탁드립니다.');
            return false;
          } else {
            vm.data.UnitPrice = vm.branchData.CostEMAIL;
          }
        }

        if (type == 'S') {
          vm.unitPriceTotal = Number(vm.data.TargetCnt) * Number( vm.data.UnitPrice);  
        } else {
          vm.unitPriceTotal = Number( vm.data.UnitPrice);
        }

        servPointTotal = Number(vm.data.ServPoint) - vm.unitPriceTotal; 

        if (servPointTotal <= 0) {
          message = '발송 가능 포인트를 초과합니다.<br>' + '남은 발송가능 포인트는' + vm.data.ServPoint + '원 입니다.';
          gAlert('', message);
          return false;
        }

        return true;

      }
      */

      // 테스트 발송 
      function setTestData() {
        var errMsg = '';
        var chkData = { mapCode: 'Campaign.getCampaignCustomerTestChk' };
        var data = angular.copy(vm.data);
        if (data.CmpgnImpChannel == 'EMAIL') {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          data.SendMessage = $('#strHtml').val();
        }

        if (isNullOrEmpty(data.FromInfo)) {
          errMsg = errMsg + '- 발송번호를 선택해주시기 바랍니다.<br>';
        }
        if (isNullOrEmpty(data.ManagerId)) {
          errMsg = errMsg + '- 담당자를 선택해주시기 바랍니다.<br>';
        }
        if (isNullOrEmpty(data.SendTitle)) {
          errMsg = errMsg + '- 제목을 입력해주시기 바랍니다.<br>';
        }
        if (isNullOrEmpty(data.SendMessage)) {
          errMsg = errMsg + '- 발송메시지를 입력해주시기 바랍니다.';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return;
        } else {
          postApi.select(chkData, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {

                if (data.CmpgnImpChannel == 'EMAIL') {
                  if (result.body.docs[0].EmailErrYN == 'N') {
                    setTestDataAction(data);
                  } else {
                    gAlert('', '내정보 - Email 확인바랍니다.');
                    return;
                  }
                }
                if (data.CmpgnImpChannel != 'EMAIL') {
                  if (result.body.docs[0].MobileErrYN == 'N') {
                    setTestDataAction(data);
                  } else {
                    gAlert('', '내정보 - 휴대폰번호 확인바랍니다.');
                    return;
                  }
                }
              }
            }
          }, function (error) {
            console.table(error);
          });  
        }
      }

      // 테스트발송 액션
      function setTestDataAction(data) {
        data.mapCode = 'Campaign.insertCampaignCustomerTest';
        //chkServPoint('T');

        if (!isNullOrEmpty(vm.unitPriceTotal)) {
          data.UnitPriceTotal = vm.unitPriceTotal;
        }

        data.TelNo = vm.branchData.TelNo;

        postApi.insert(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '테스트 발송하였습니다.', {
              btn : '',
              fn : function() {
                getBranchDetail();
              }
            });
          } else {
            gAlert('', '테스트 발송에 실패하였습니다.');
          }
        }, function (error) {
          console.table(error);
        });  
      }

      // 전체고객투입
      function setCustAll() {
        gConfirm('', '기존에 투입한 고객들이 초기화 되며,<br> 대상고객 수에 따라 수분 이상 소요될 수 있습니다. 계속 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            setCustAllAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      function setCustAllAction() {
        var data = { keyId: toModalData.keyId, CmpgnImpChannel: vm.data.CmpgnImpChannel, EnterCnt : vm.data.EnterCnt, mapCode: 'Campaign.insertCampaignCustomerAllBatch' };

        postApi.insert(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('전체 고객 투입이 되었습니다.');
            getCampaignCustomerList('R');
          }
        }, function (error) {
          console.table(error);
        });  
      }

      // SMS Byte 체크
      function chkSmsByte() {
        var msg = "";

        if (!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          vm.bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnImpChannel == 'SMS' && vm.bytes > 90) {
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.', {
              btn: '',
              fn: function () {
                vm.data.CmpgnImpChannel = 'LMS';
                vm.messageMaxLength = '2000';
                vm.lmsYN = 'Y';
              }
            });
          }

          if ((vm.data.CmpgnImpChannel == 'LMS' || vm.data.CmpgnImpChannel == 'MMS') && vm.bytes > 1999) {
            gAlert('', '메세지는 최대 2000 bytes까지 가능합니다.', {
              btn: '',
              fn: function () {
                vm.data.SendMessage = fnCutMsg(msg, 1999);
              }
            });
          }

          if (vm.lmsYN == 'Y' && vm.bytes < 91) {
            vm.data.CmpgnImpChannel = 'SMS';
            vm.messageMaxLength = '90';
          }

        } else {
          vm.bytes = 0;
          vm.addADTxtYN = 'N';
          if (vm.lmsYN == 'Y') {
            vm.data.CmpgnImpChannel = 'SMS';
            vm.messageMaxLength = '90';
          }
        }
      }

      // 광고문구 추가
      vm.chkADTxt = function (areaId) {
        var txtarea = document.getElementById(areaId);

        if (vm.addADTxtYN == 'Y') {
          if (!isNullOrEmpty(vm.data.SendMessage)) {
            txtarea.value = vm.addADTxt + vm.data.SendMessage;
          } else {
            txtarea.value = vm.addADTxt;
          }
          
          vm.data.SendMessage = txtarea.value;
        } else {
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
          txtarea.value =  vm.data.SendMessage;
        }

        vm.chkSmsByte();
      };

      // 메세지 글 자르기
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      // 현재 커서 위치에 텍스트 대체하기
      function innerTextArea(areaId, type) {
        var text = '';
        if (type == 'C') {
          text = '{CustNm}';
        } else if (type == 'T') {
          text = vm.branchData.TenantNm;
        } else if (type == 'B') {
          text = vm.branchData.GroupNm;
        } else if (type == 'M') {
          text = vm.branchData.loginMobile;
        } else if (type == 'A' && !isNullOrEmpty(vm.branchData.ZipCode)) {
          text = '(우)' + vm.branchData.ZipCode + ' ' + vm.branchData.Addr1;
          if (!isNullOrEmpty(vm.branchData.Addr2)) {
            text = text + ' ' + vm.branchData.Addr2;
          }
        } else if (type == 'BA' && !isNullOrEmpty(vm.branchData.Bank) && !isNullOrEmpty(vm.branchData.AccountNum)) {
          text = '[' + vm.branchData.Bank + '] ' + vm.branchData.AccountNum;
        }

        var txtarea = document.getElementById(areaId);
        var scrollPos = txtarea.scrollTop;
        var strPos = 0;
        var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
          "ff" : (document.selection ? "ie" : false));
        if (br == "ie") {
          txtarea.focus();
          var range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          strPos = range.text.length;
        }
        else if (br == "ff") strPos = txtarea.selectionStart;

        var front = (txtarea.value).substring(0, strPos);
        var back = (txtarea.value).substring(strPos, txtarea.value.length);
        txtarea.value = front + text + back;
        vm.data.SendMessage = txtarea.value;
        strPos = strPos + text.length;
        if (br == "ie") {
          txtarea.focus();
          var range = document.selection.createRange();
          range.moveStart('character', -txtarea.value.length);
          range.moveStart('character', strPos);
          range.moveEnd('character', 0);
          range.select();
        }
        else if (br == "ff") {
          txtarea.selectionStart = strPos;
          txtarea.selectionEnd = strPos;
          txtarea.focus();
        }
        txtarea.scrollTop = scrollPos;

        var tcount = 0;
        if (text == "{CLICKURL}") {
          alert('장문으로 전환됩니다.');

          $("#ContentPage_FLD_SENDCLSS").val("20");
          fnChgSendClss();

          $("#ContentPage_lblByte").html(tcount + " / 2000 bytes");
        }

        chkSmsByte();
      }

      // 서식명 및 발송메시지 삭제
      function deleteModalData(type) {
        if (type == 'Form') {
          vm.data.FormNm = '';
          vm.data.SendMessage = '';
          chkSmsByte();
        }
      }

      // 함수연결
      vm.onReadyAutoView = onReadyAutoView;      
      vm.cancel = cancel;
      vm.ok = ok;
      vm.setData = setData;
      vm.setTestData = setTestData;                         
      vm.setChangeCmpgnImpChannel = setChangeCmpgnImpChannel; 
      vm.resetCmpgnCustomerList = resetCmpgnCustList;  
      vm.resetAll = resetAll;                           
      vm.showPreView = showPreView;                     
      vm.setCustAll = setCustAll;                       
      vm.chkSmsByte = chkSmsByte;                       
      vm.innerTextArea = innerTextArea;                       
      vm.deleteModalData = deleteModalData;

      vm.dataloader = true;
      vm.lmsYN = 'N';

      var av = new autoView();
      av.init(autoViewOption);
    } ]);
(function () {
  "use strict";
  webapp.controller('CertEmailModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function CertEmailModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {
    var vm = this;

    // 변수설정
    vm.data = {};
    vm.showMsg = false;

    // 중복체크
    function dupChk() {
      if (isNullOrEmpty(vm.data.SendInfo)) {        
        gAlert('','이메일을 입력해주세요.');
        return;
      }

      var data = angular.copy(vm.data);
      data.mapCode = 'SendVerify.getSendDuplicateCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs > 0) {
            gAlert('','이미 등록된 이메일 입니다.');
            return;
          } else {
            sendVerifyEmail();
          }
        }
      }, function (error) {
        console.table(error);
      });  
    }

    // 이메일 발송
    function sendVerifyEmail() {
      var data = angular.copy(vm.data);      
      data.mapCode = 'aws/verifyEmailAddress';
      
      postApi.api(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.showMsg = true;
        }
      }, function (error) {
        console.table(error);
      });  
    }

    // 완료
    function sendVerifyEmailChk() {
      var data = angular.copy(vm.data);
      data.Type = 'E';
      data.CertYN = 'Y';
      data.mapCode = 'aws/verifyEmailAddressChk';

      postApi.api(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '등록이 완료되었습니다.', {
            btn : '',
            fn : function () {
              $uibModalInstance.close();
            }
          });
        } else {
          gAlert('', result.body.docs[0].errMessage);
          return;
        }
      }, function (error) {
        console.table(error);
      });  
    }

    // 초기설정
    function init() {
    }

    // 저장 클릭이벤트
    function ok() {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    // 닫기 클릭이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    // 함수연결
    vm.dupChk = dupChk;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.sendVerifyEmailChk = sendVerifyEmailChk;

    init();
  }]);
})();
(function () {
    "use strict";
    webapp.controller('DirectInputModalCtrl', 
    ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
    function DirectInputModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {
      var vm = this;

      // 변수설정
      vm.receiveNumList = [];      
  
      // 저장 클릭이벤트
      function ok() {
        if (vm.receiveNumList.length == 0) {
          gAlert('', '휴대폰 번호를 1개 이상 입력해주세요.');
          return;
        }
  
        var data = {
          keyId : mdata.keyId, 
          orgYN : vm.orgYN, 
          list : angular.copy(vm.receiveNumList), 
          mapCode : 'Campaign.insertCampaignCustomerDirectBatch',
        };
  
        postApi.insert(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "투입되었습니다.", {
              btn: "",
              fn: function () {
                $uibModalInstance.close();
              }
            });
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function (error) {
          console.table(error);
        });
      }

      // 닫기 클릭이벤트
      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }

      // 초기설정
      function init() {
        getCmpgnCustomerList();
      }
  
      // 추가된 휴대폰번호 추가
      function addReceiveNumList() {
        vm.receiveNumData = {
          MbErrYN : 'N',
          MbDenyYN : 'N',
          EmErrYN : 'N',
          EmDenyYN : 'N',
          DirectYN : 'Y',
          CustStatus : "PRE"
        };
  
        var rgEx = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
  
        var chkFlg = rgEx.test(vm.receiveNum);
        if (!chkFlg) {
          gAlert('', '올바른 휴대폰 번호가 아닙니다.');
          return;
        }
  
        vm.receiveNumData.ToInfo = vm.receiveNum;
        
        vm.receiveNumList.push(vm.receiveNumData);
        vm.receiveNum = '';
      }
  
      // 투입 데이터 삭제
      function delReceiveNumList(index) {
        vm.receiveNumList.splice(index, 1);
        vm.receiveNum = '';
      }
  
      // 투입 데이터 목록 조회
      function getCmpgnCustomerList() {
        var data = {
          keyId : mdata.keyId, 
          DirectYN : 'Y', 
          ErrYN : 'N', 
          DenyYN : 'N', 
          mapCode : 'Campaign.getCampaignCustomerList',
        };
        
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.receiveNumList = result.body.docs;
              vm.orgYN = 'Y';
            } else {
              vm.orgYN = 'N';
            }
          }
        }, function (error) {
          console.table(error);
        });
      }
  
      // 투입 데이터 초기화
      function resetReceiveNumList() {
        var data = {
          keyId : mdata.keyId, 
          DirectYN : 'Y', 
          mapCode : 'Campaign.deleteCampaignCustomer',
        };
  
        gConfirm('','직접 투입된 휴대폰번호가 초기화 됩니다. 초기화 하시겠습니까?', {
          btn : '',
          fn : function() {
            postApi.update(data, function(result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.receiveNumList = [];   

                gAlert('', '초기화 되었습니다.', {
                  btn : '',
                  fn : function() {
                    $uibModalInstance.close();
                  }
                });
              }
            }, function (error) {
              console.table(error);
            });
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }      

      init();

      // 함수연결  
      vm.cancel = cancel;
      vm.ok = ok;
      vm.addReceiveNumList = addReceiveNumList;
      vm.delReceiveNumList = delReceiveNumList;
      vm.resetReceiveNumList = resetReceiveNumList;
    }]);
  })();
(function () {
  "use strict";
  webapp.controller('ExtCustDetailModalCtrl', 
  ['$scope','$stateParams', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function ExtCustDetailModalCtrl($scope, $stateParams, postApi, CONSTANT, $uibModalInstance, toModalData, gConfirm, gAlert) {
    var vm = this;

    // 변수설정
    vm.repItem = {};    

    // 유형(상품) 코드 
    /*    
    postApi.select({ mapCode: 'ScItemType.getScitemtypeCodes',ItemType:'I' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeItemType = result.body.docs;
      }
    });

    // 담당자 목록
    postApi.select({ mapCode: 'ScUser.getUserListCodes' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeManager = result.body.docs;
      }
    });

    // 캠페인 목록
    postApi.select({ mapCode: 'CampaignImpl.getCampaignImplCareSimpleList' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeCampaign = result.body.docs;
      }
    });
    */

    // 상세검색 팝업
    /*
    vm.extCustDetailModal = function(id, name) {
      var ctrl = 'ExtCustDetailModalCtrl as vc';
      var data = {
        id: id,
        name : name
      };

      var modalInstance = modalFactory.open('md', 'app/campaign/modal/ext-cust-detail-modal.html', ctrl, data);
      modalInstance.result.then(function (okData) {        
      }, function (cancelData) {
      });
    };
    */

    // 초기설정
    function init() {
      vm.repItem = angular.copy(toModalData.item);            
      
      if (toModalData.type == "modify") { 
        vm.cond = vm.repItem.cond;
        vm.cond2 = vm.repItem.cond2;
        vm.cond3 = vm.repItem.cond3;
        vm.cond4 = vm.repItem.cond4;
      }
    }

    // 저장 클릭이벤트
    function ok() {
      if (!getIsValidData()) return false;

      var cond = vm.cond;
      var cond2 = !isNullOrEmpty(vm.cond2) ? vm.cond2 : '';
      var cond3 = !isNullOrEmpty(vm.cond3) ? vm.cond3 : '';
      var cond4 = !isNullOrEmpty(vm.cond4) ? vm.cond4 : '';

      var param = {
        id: vm.repItem.id,
        name : vm.repItem.name,
        type : vm.repItem.type,
        cond : cond,
        cond2 : cond2,
        cond3 : cond3,
        cond4 : cond4,
      };

      param.cont = cond;
      param.cont += cond2 != '' ? ' / ' + cond2 : '';
      param.cont += cond3 != '' ? ' / ' + cond3 : '';
      param.cont += cond4 != '' ? ' / ' + cond4 : '';

      $uibModalInstance.close(param);

      /*
      vm.data.list = vm.srchList;
      var data = angular.copy(vm.data);
      data.mapCode = 'CampaignImpl.insertCareCampaignImplCustomerSrchInput';

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '투입되었습니다.', {
            btn : '',
            fn : function() {
              $uibModalInstance.close();
            }
          });
        } else {
          gAlert('', '투입되지 않았습니다.');
          return;
        }
      }, function (error) {
          console.table(error);
        });
      */
    }
    
    // 닫기 클릭이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }    
    
    // 유효성 체크
    function getIsValidData() {
      var errMsg = '';

      switch (vm.repItem.type) {
        case "text":          
          if (isNullOrEmpty(vm.cond)) {
            errMsg = errMsg + '- ' + vm.repItem.name + '을(를) 입력해주시기 바랍니다.<br>';
          }          
          break;
        case "number":
          if (isNullOrEmpty(vm.cond)) {
            errMsg = errMsg + '- ' + vm.repItem.name + '을(를) 입력해주시기 바랍니다.<br>';
          }   
          if (isNullOrEmpty(vm.cond2)) {
            errMsg = errMsg + '- ' + vm.repItem.name + '을(를) 입력해주시기 바랍니다.<br>';
          }
          break;

        default: break;
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      } 
      else {
        return true;
      }
    }

    // 함수연결
    vm.ok = ok;
    vm.cancel = cancel;

    init();
  }]);
})();

(function () {
  "use strict";
  webapp.controller('ExtCustModalCtrl', 
  ['$scope','$stateParams', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert', 'modalFactory', '$filter',
  function ExtCustModalCtrl($scope, $stateParams, postApi, CONSTANT, $uibModalInstance, toModalData, gConfirm, gAlert, modalFactory, $filter) {

    var vm = this;
    
    // 변수설정
    vm.data = {};
    vm.selItem = {id: '', name: '', type: ''};
    vm.selItem2 = {id: '', name: '', type: ''};
    vm.segList = [];
    vm.itemList = [];

    // 유형(상품) 코드 
    /*    
    postApi.select({ mapCode: 'ScItemType.getScitemtypeCodes',ItemType:'I' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeItemType = result.body.docs;
      }
    });

    // 담당자 목록
    postApi.select({ mapCode: 'ScUser.getUserListCodes' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeManager = result.body.docs;
      }
    });

    // 캠페인 목록
    postApi.select({ mapCode: 'CampaignImpl.getCampaignImplCareSimpleList' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeCampaign = result.body.docs;
      }
    });
    */

    // 초기설정
    function init() {
      vm.data.EnterCnt = 0;
      vm.data.TargetCnt = 0;
      vm.data.ExceptCnt = 0;

      // 아이템설정
      vm.itemList = [
        {id: '01', name: '고객', type: '', child: [
          {id: '0101', name: '고객명', type: 'search', child: []},
          {id: '0102', name: '휴대폰', type: 'text', child: []},
          {id: '0103', name: '이메일', type: 'text', child: []},
          {id: '0104', name: '재직여부', type: 'select', child: []},
          {id: '0105', name: '고객등록일', type: 'date', child: []},
          {id: '0106', name: '지역본부', type: 'select', child: []},
          {id: '0107', name: '영업담당자', type: 'search', child: []},
          {id: '0108', name: '마케팅활용동의', type: 'select', child: []},
          {id: '0109', name: '마케팅활용동의일', type: 'date', child: []},
          {id: '0110', name: '최초등록일', type: 'date', child: []},
          {id: '0111', name: '담당부서', type: 'search', child: []},
          {id: '0112', name: '고객그룹', type: 'select', child: []},
          {id: '0113', name: '유입채널', type: 'select', child: []},
          {id: '0114', name: '업종', type: 'select', child: []},
        ]},   
        {id: '02', name: '고객사', type: '', child: [
          {id: '0201', name: '고객사명', type: 'search', child: []},
          {id: '0202', name: '고객사등록일', type: 'date', child: []},
          {id: '0203', name: '지역본부', type: 'select', child: []},
          {id: '0204', name: '영업담당자', type: 'search', child: []},
          {id: '0205', name: '최초등록일', type: 'date', child: []},
          {id: '0206', name: '담당부서', type: 'search', child: []},
          {id: '0207', name: '고객사등급', type: 'select', child: []},
          {id: '0208', name: '기업규모', type: 'select', child: []},
          {id: '0209', name: '매출(전체)', type: 'number', child: []},
          {id: '0210', name: '매출(3년)', type: 'number', child: []},        
        ]},
        {id: '03', name: '영업', type: '', child: [
          {id: '0301', name: '사업기회명', type: 'search', child: []},
          {id: '0302', name: '영업담당자', type: 'search', child: []},
          {id: '0303', name: '매출액', type: 'number', child: []},
          {id: '0304', name: '예상매출액', type: 'number', child: []},
          {id: '0305', name: '영업일지수', type: 'number', child: []},
          {id: '0306', name: '사업기회등록일', type: 'date', child: []},
          {id: '0307', name: '영업일지등록일', type: 'date', child: []},
          {id: '0308', name: '실제종료일', type: 'date', child: []},
          {id: '0309', name: '비접촉에이징', type: 'date', child: []},
          {id: '0310', name: '진행단계', type: 'select', child: []}, 
          {id: '0311', name: '계약구분', type: 'select', child: []},
          {id: '0312', name: '계약기간', type: 'date', child: []},
          {id: '0313', name: '계약일', type: 'date', child: []},
          {id: '0314', name: '사업판매완료', type: 'date', child: []},
          {id: '0315', name: '사업판매전', type: 'select', child: []},
          {id: '0316', name: '사업판매회차', type: 'number', child: []},
          {id: '0317', name: '판매금액', type: 'number', child: []},
          {id: '0318', name: '최초등록일', type: 'date', child: []},
          {id: '0319', name: '담당부서', type: 'select', child: []},       
        ]},     
        {id: '04', name: '캠페인반응', type: '', child: [
          {id: '0401', name: '캠페인발송일', type: 'date', child: []},
          {id: '0402', name: '캠페인이력', type: 'search', child: []},
          {id: '0403', name: '담당자', type: 'search', child: []},
          {id: '0404', name: '캠페인반응', type: 'select', child: []},
        ]},     
        {id: '05', name: '사업실적', type: '', child: [
          {id: '0501', name: 'KS', type: '', child: [
            {id: '050101', name: '실적여부', type: 'select', child: []},
            {id: '050102', name: '표준번호', type: 'select', child: []},
            {id: '050103', name: '표준명', type: 'select', child: []},
            {id: '050104', name: '처리상태', type: 'select', child: []},
            {id: '050105', name: '차기심사완료기한', type: 'date', child: []},
            {id: '050106', name: '심사구분', type: 'select', child: []},
            {id: '050107', name: '최종변경일', type: 'date', child: []},          
          ]},
          {id: '0502', name: '표준정보망', type: '', child: [
            {id: '050201', name: '실적여부', type: 'select', child: []},
            {id: '050202', name: '상품명', type: 'select', child: []},
            {id: '050203', name: '표준번호', type: 'text', child: []},
            {id: '050204', name: '판매일', type: 'date', child: []},
          ]},
          {id: '0503', name: '에너지기후', child: [
            {id: '050301', name: '실적여부', type: 'select', child: []},
            {id: '050302', name: '제도', type: 'select', child: []},
            {id: '050303', name: '검증평가', type: 'select', child: []},
            {id: '050304', name: '시작일', type: 'date', child: []},
            {id: '050305', name: '만료일', type: 'date', child: []},
            {id: '050306', name: '검증결과', type: 'select', child: []},
          ]},
          {id: '0504', name: '분임조', child: [
            {id: '050401', name: '실적여부', type: 'select', child: []},
            {id: '050402', name: '분임조등록일', type: 'date', child: []},
            {id: '050403', name: '분임조유효기간', type: 'date', child: []},
            {id: '050404', name: '상태', type: 'select', child: []},
          ]},
          {id: '0505', name: 'ISO', child: [
            {id: '050501', name: '실적여부', type: 'select', child: []},
            {id: '050502', name: '인증코드', type: 'select', child: []},
            {id: '050503', name: '차기심사유형', type: 'select', child: []},
            {id: '050504', name: '차기심사예정월', type: 'date', child: []},
            {id: '050505', name: '임증취소여부', type: 'select', child: []},
            {id: '050506', name: '발행일', type: 'date', child: []},
            {id: '050507', name: '유효일', type: 'date', child: []},
            {id: '050508', name: '심사지부', type: 'select', child: []},
          ]},
          {id: '0506', name: '교육관리', child: [
            {id: '050601', name: '실적여부', type: 'select', child: []},
            {id: '050602', name: '교육유형', type: 'select', child: []},
            {id: '050603', name: '과정명', type: 'select', child: []},
            {id: '050604', name: '학습기간', type: 'date', child: []},
            {id: '050605', name: '수료상태', type: 'select', child: []},
            {id: '050606', name: '수강신청일', type: 'date', child: []},
            {id: '050607', name: '수강신청구분', type: 'select', child: []},
            {id: '050608', name: '납입구분', type: 'select', child: []},
            {id: '050609', name: '교육구분', type: 'select', child: []},
            {id: '050610', name: '훈련구분', type: 'select', child: []},
            {id: '050611', name: '실교육비', type: 'text', child: []},
          ]},
          {id: '0507', name: '회원사', child: [
            {id: '050701', name: '실적여부', type: 'select', child: []},
            {id: '050702', name: '납부일자', type: 'date', child: []},
            {id: '050703', name: '납부금액', type: 'text', child: []},
            {id: '050704', name: '감면금액', type: 'text', child: []},
            {id: '050705', name: '감면유형', type: 'select', child: []},
            {id: '050706', name: '탈퇴일자', type: 'date', child: []},
          ]},
          {id: '0508', name: '조찬회', child: [
            {id: '050801', name: '실적여부', type: 'select', child: []},
            {id: '050802', name: '회원구분', type: 'select', child: []},
            {id: '050803', name: '개최지역', type: 'select', child: []},
            {id: '050804', name: '회원사여부', type: 'select', child: []},
            {id: '050805', name: '유효일자', type: 'date', child: []},
            {id: '050806', name: '회원상태', type: 'select', child: []},
          ]},
        ]},      
      ];
    }

    // 저장 클릭이벤트
    function ok() {
      if (vm.segList.length == 0) {        
        gAlert('', '세그먼트를 추가해주세요.');
        return;
      }

      vm.dataloader = true;

      var data = {
        CmpgnImpChannel: toModalData.CmpgnImpChannel,
        segList: angular.copy(vm.segList),
        mapCode: 'Campaign.insertCampaignCustomerSegmentBatch',
      };                        

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          gAlert('', '투입되었습니다.', {
            btn : '',
            fn : function() {
              $uibModalInstance.close();
            }
          });          
        }
        
        vm.dataloader = false;
      }, function (error) {
        vm.dataloader = false;
        console.table(error);
      });  
    }
    
    // 닫기 클릭이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    // 아이템 클릭이벤트
    vm.chkItem = function(type, item) {
      switch (type) {
        case "1":           
          if (item.id == vm.selItem.id && item.child.length > 0) {            
            vm.selItem = {id: '', name: ''};
            vm.selItem2 = {id: '', name: ''};
          }
          else {            
            vm.selItem.id = item.id;
            vm.selItem.name = item.name;          
          }
          break;
        case "2":           
          if (item.id == vm.selItem2.id && item.child.length > 0) {
            vm.selItem2 = {id: '', name: ''};            
          }
          else {
            vm.selItem2.id = item.id;
            vm.selItem2.name = item.name;
          }
          break;        
        default: break;
      }      

      if (item.child.length == 0) {
        vm.extCustDetailModal("add", item);
      }
    }    

    // 상세검색 팝업
    vm.extCustDetailModal = function(type, item) {            
      var tgtSeg = {};

      if (type == "add") {
        var dupSeg = $filter('filter')(vm.segList, {id: item.id}, true)[0];
        if (!isNullOrEmpty(dupSeg)) {        
          gAlert('', '이미 추가된 세그먼트입니다.');
          return;
        }
      }

      var ctrl = 'ExtCustDetailModalCtrl as vc';
      var data = {
        item : angular.copy(item),   
        type : type,     
      };

      var modalInstance = modalFactory.open('md', 'app/campaign/modal/ext-cust-detail-modal.html', ctrl, data);
      modalInstance.result.then(function (okData) {  
        if (type == "add") {
          vm.segList.push(okData);                
        }
        else {
          tgtSeg = $filter('filter')(vm.segList, {id: okData.id}, true)[0];
          if (!isNullOrEmpty(tgtSeg)) {
            tgtSeg.cont = okData.cont;                        
            tgtSeg.cond = okData.cond;
            tgtSeg.cond2 = okData.cond2;
            tgtSeg.cond3 = okData.cond3;
            tgtSeg.cond4 = okData.cond4;
          }
        }
      }, function (cancelData) {
        // cancel
      });
    };    

    // 세그먼트 삭제
    vm.delSeg = function(seg) {
      var tgtSeg = $filter('filter')(vm.segList, {id: seg.id}, true)[0];
      if (!isNullOrEmpty(tgtSeg)) vm.segList.splice(vm.segList.indexOf(tgtSeg), 1);
    };

    // 추출
    vm.import = function() {
      if (vm.segList.length == 0) {        
        gAlert('', '세그먼트를 추가해주세요.');
        return;
      }

      vm.dataloader = true;

      var data = {
        CmpgnImpChannel: toModalData.CmpgnImpChannel,
        segList: angular.copy(vm.segList),
        mapCode: 'Campaign.getCampaignSegmentImport',
      };

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.extraSearch = true;
          if (result.body.docs.length > 0) {
            //vm.srchList = result.body.docs;
            vm.data.EnterCnt = result.body.docs[0].EnterCnt;
            vm.data.TargetCnt = result.body.docs[0].TargetCnt;
            vm.data.ExceptCnt = result.body.docs[0].ExceptCnt;
          } else {
            vm.data.EnterCnt = 0;
            vm.data.TargetCnt = 0;
            vm.data.ExceptCnt = 0;
          }         
        }
        
        vm.dataloader = false;        
      }, function (error) {
        vm.dataloader = false;
        console.table(error);
      });  
    };

    // 함수연결
    vm.ok = ok;
    vm.cancel = cancel;

    init();
  }]);
})();

(function () {
  "use strict";
  webapp.controller('FormIncModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm',
  function FormIncModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm) {
    var vm = this;

    // 변수설정
    vm.srch = {
      page: 1,
      viewSize: CONSTANT.PAGINATION.VIEWSIZE,
      FormType : mdata.FormType
    };

    vm.viewSize = vm.srch.viewSize;
    vm.currentPage = vm.srch.page;

    // 페이지번호 변경이벤트
     function pageChanged() {
      vm.srch.page = vm.currentPage;

      getList();
    }

    // 검색
    function getSearch() {
      vm.srch.pag = 1;
      vm.currentPage = vm.srch.page;

      getList();
    }
    
    // 초기설정
    function init() {
      getList();
    }

    // 저장 클릭이벤트
    function ok(clickData) {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    // 닫기 클릭이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    // 서식 목록 건수
    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign.getFormListCnt";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function (error) {
        console.table(error);
      });  
    }

    // 서식 목록
    function getList() {
      getListCnt();
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign.getFormList";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        } else {
          vm.lists = [];
        }
      }, function (error) {
        console.table(error);
      });  
    }

    // 함수연결
    vm.pageChanged = pageChanged;
    vm.getSearch = getSearch;
    vm.ok = ok;
    vm.cancel = cancel;

    init();
  }]);
})();
(function () {
  "use strict";
  webapp.controller('KSACustBusinessCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustBusinessCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 사업기회
    KSACust.getKSACustBusinessListCnt
    KSACust.getKSACustBusinessList
    TB_SV_BUSINESSOP
   */
    var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
      var KeyId = $window.sessionStorage.getItem("currentCustId");
  
      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_BUSINESSOP",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustBusinessListCnt"},
          initSelect : { mapCode : "KSACust.getKSACustBusinessList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
      function goBusinessOPEdit() {
        var ctrl = 'BusinessOpModalCtrl as vc';
        var paramData = {};
  
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
        }, function (cancelData) {
          // cancel버튼
        });
      }
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 


      vm.goBusinessOPEdit = goBusinessOPEdit;
  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustCompCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustCompCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 변경이력
    Client.getClientHistoryListCnt
    Client.getClientHistoryList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_CUST_COMP",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustCompCnt"},
        initSelect : { mapCode : "KSACust.getKSACustComp", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = {};
      data = vm.lists;
      for (var i = 0; i < data.length; i++) {
        if (data[i].WorkStatus == 'Y') {
          data[i].WorkStatus = '재직';
        } 
        else {
          data[i].WorkStatus = '퇴사';
        }
      }
      

    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustEnergyCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustEnergyCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 에너지 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_ECC",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustEnergyListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustEnergyList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = vm.lists;
        

      var estMonth = '';


      if (data.length > 0) {
        for(var i = 0; i < data.length; i++) {
          data[i].WorkFDT = data[i].WorkFDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          data[i].WorkLDT = data[i].WorkLDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          
        
        }
      }
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustHistoryCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustHistoryCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 변경이력
    Client.getClientHistoryListCnt
    Client.getClientHistoryList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_HIST",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustHistoryListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustHistoryList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = {};
      data = vm.lists;
      for (var i = 0; i < data.length; i++) {
        if (data[i].FieldNm == 'Memo') {
          data[i].FieldNm = '비고';
        }
        if (data[i].FieldNm == 'Working') {
          data[i].FieldNm = '재직상태';
        }
        if (data[i].FieldNm == 'Mobile') {
          data[i].FieldNm = '휴대전화';
        }
        if (data[i].FieldNm == 'Telephone') {
          data[i].FieldNm = '전화번호';
        }
        if (data[i].FieldNm == 'Email') {
          data[i].FieldNm = '이메일';
        }
        if (data[i].FieldNm == 'CustRole') {
          data[i].FieldNm = '사업정보';
        }
        if (data[i].FieldNm == 'Department') {
          data[i].FieldNm = '부서';
        }
        if (data[i].FieldNm == 'Title') {
          data[i].FieldNm = '직위';
        }
        if (data[i].FieldNm == 'ClientNm') {
          data[i].FieldNm = '고객사명';
        }
        if (data[i].FieldNm == 'CompTel') {
          data[i].FieldNm = '회사전화';
        }
        if (data[i].FieldNm == 'Fax') {
          data[i].FieldNm = '팩스';
        }
        if (data[i].FieldNm == 'ZipCode') {
          data[i].FieldNm = '우편번호';
        }
        if (data[i].FieldNm == 'Address1') {
          data[i].FieldNm = '기본주소';
        }
        if (data[i].FieldNm == 'Address2') {
          data[i].FieldNm = '상세주소';
        }
        if (data[i].FieldNm == 'AgreeSMS') {
          data[i].FieldNm = 'SMS 마케팅';
        }
        if (data[i].FieldNm == 'AgreeEmail') {
          data[i].FieldNm = '이메일 마케팅';
        }
        if (data[i].FieldNm == 'AgreeSMSDT') {
          data[i].FieldNm = 'SMS동의일시';
        }
        if (data[i].FieldNm == 'DenialSMSDT') {
          data[i].FieldNm = 'SMS거부일시';
        }
        if (data[i].FieldNm == 'AgreeEmailDT') {
          data[i].FieldNm = '이메일동의일시';
        }
        if (data[i].FieldNm == 'DenialEmailDT') {
          data[i].FieldNm = '이메일거부일시';
        }
        if (data[i].FieldNm == 'CustNm') {
          data[i].FieldNm = '고객명';
        }
        if (data[i].FieldNm == 'KeyMan') {
          data[i].FieldNm = '주요담당자 여부';
        }
        if (data[i].FieldNm == 'UserId') {
          data[i].FieldNm = '영업담당자';
        }
      }      
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustISOCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustISOCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 ISO */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_ISO",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustISOListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustISOList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        var data = vm.lists;
        

        var estMonth = '';


        if (data.length > 0) {
          for(var i = 0; i < data.length; i++) {
            data[i].CertExpDT = data[i].CertExpDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            data[i].CertFDate = data[i].CertFDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            data[i].NextDate = data[i].NextDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            //NextDate 는 월 까지만 
            estMonth = data[i].NextDate.split("-");
            estMonth = estMonth[0] + "-" + estMonth[1];
            data[i].NextDate = estMonth;
            data[i].IssueDate = data[i].IssueDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
        }


    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustKSCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustKSCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_KS",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustKSListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustKSList", param : null },
      },


      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);


  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustMembersCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustMembersCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 회원사 
    Client.getClientMembersListCnt
    Client.getClientMembersList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_MBR",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustMembersListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustMembersList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 

  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustNetworkCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustNetworkCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 회원사
    Client.getClientNetworkListCnt
    Client.getClientNetworkList */

    var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
      var KeyId = $window.sessionStorage.getItem("currentCustId");

      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_KSSN",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustNetworkListCnt"},
          initSelect : { mapCode : "KSACust.getKSACustNetworkList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 


  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustQualityCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustQualityCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 분임조
    Client.getClientQualityListCnt
    Client.getClientQualityList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_QCC",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getKSACustQualityListCnt"},
        initSelect : { mapCode : "KSACust.getKSACustQualityList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustRelateCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustRelateCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객 연관사업정보 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
    var KeyId = $window.sessionStorage.getItem("currentCustId");

    vm.listOptions = {
      addColumn : {

      },

      html : {

      },
      addColumnClass : {

      },

      addRowClass : {
        //if : "li.CustReadyYN == 'Y'",  class : "row-highlight"
      },
      ngIf: {

      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_RELATE",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "KSACust.getClientRelateListCnt"},
        initSelect : { mapCode : "KSACust.getClientRelateList", param : null },
      },


      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('KSACustSalesCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function KSACustSalesCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {

    var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentCustId");
      var KeyId = $window.sessionStorage.getItem("currentCustId");
  
      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        //printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_BUSINESSDR",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "KSACust.getKSACustSalesListCnt"},
          initSelect : { mapCode : "KSACust.getKSACustSalesList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
      function goBusinessDREdit() {
        var ctrl = 'BusinessDrModalCtrl as vc';
        var paramData = { };
  
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          var KeyId = 0;
          // 새로등록
          if (!isNullOrEmpty(okData)) {
            KeyId = okData;
          }
          // 수정하는 경우
          else {
            KeyId = okData.KeyId;
          }
          vm.busiWriteModal(KeyId);
        }, function (cancelData) {
          av.search();
        });
      }
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 
      vm.goBusinessDREdit = goBusinessDREdit;

  }]);

})();
webapp.controller('ClientEditModalCtrl', [ '$uibModalInstance', 'toModalData', '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert',
    function ClientEditModalCtrl($uibModalInstance, mdata, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      //vm.getList = getList;
      var LoginId = $window.sessionStorage['loginUserId'];
      vm.isClientValid = 0;

      (function ClientEditModalCtrl() {
        //getList();
      })();
      // 담당지역본부
      /* postApi.select({ mapCode: 'CommonCode.getCommonCodeList', CodeType: 'DEPT_CODE' }, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeDeptCodeList = result.body.docs;
        }
      }); */
      
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.Edit, // List OR Edit
        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "TB_COMPANY",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data", // ex : vc.data = {}
        apis : {
          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect : { mapCode : "Client.getCompanyDetail", param : null },
          // vieType is edit
          insert : "Client.insertClientBatch",
          update : "Client.updateCompany",        
        },
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow : [],
  
        // vc의 ng-if
        /* ngIf : {
          CustType : "false",
        }, */
        
        // 비활성화 시킬 컬럼의 조건
        disabled : {
          //Sales3Y : true,
          //SalesCredit : true,
          KeyId : true,
          RegInfo : true,
          EditInfo : true,
          DeptCodes : true,
          ManagerNms : true,
          //PrivateType : true,
          //ClientStatus : true,
          //PublicType : true,
          //ClientSize : true,
          //BranchType : true,
          ClientGRD : true,
          //OpIncome : true,
          //NetIncome : true,

        },
  
        // MataColum 외 추가 적으로 넣어야할 폼
        addForm : {
          // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
          Address : { after : "Homepage", type : mElemTx.address,  bindKey : ["ZipCode", "Address1", "Address2"], label : "주소"},
          empytyBox1 : { after : "ManagerId"},
          empytyBox2 : { after : "EditInfo"},
        },
  
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes : {
          //BusiInfoBox : "codeBusiInfo",
        },
        
        customColSize : {
          Address : "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          empytyBox1 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
          empytyBox2 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
        },
  
        // 필수 항목 컬럼 
        required : [ "Telephone"],
        
      };

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      var busiInfoEtcText = "";
      // 체크박스 기타 체크시 인풋 열어주기
      $scope.clickCheckBoxEtc = function(event) {
        var checkBox = document.getElementById("inlineCheckbox12");
        if (checkBox.checked) {
          $('#busiInfoEtc').attr('readonly', false);
        } else {
          $('#busiInfoEtc').attr('readonly', true);
        }
        
      };

      //고객사 등록 저장버튼 클릭
      function setData() {
        if (getIsValidData()) {
          /* chkClientBSN(); */
          //고객사가 중복인지 아닌지 확인
          //고객사의 사업자등록번호를 가지고 비교한다. 
          //var isValidClient = chkClientBSN();
          //chkClientBSN();
          chkClientBSN (function(result) {
          //console.log(result);
          if (result == 0) {
            busiInfoEtcText = $('#busiInfoEtc').val();
            var BusiInfo = "";
            //기타 선택했는지 확인 
            if (busiInfoEtcText != null && busiInfoEtcText != "") {
              BusiInfo = busiInfoEtcText;
            }
            // 체크박스 
            var checkboxes = document.getElementsByName('busiInfo');
            var selected = [];
            
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    selected.push(checkboxes[i].value);
                }
            }
            // 선택된 체크박스가 하나면 그대로 두개이상이면 ,로 구분
            
            for (i = 0; i < selected.length; i ++) {
              if (i == 0 && BusiInfo != "") {
                BusiInfo += ", " + selected[i];
              }
              else if (i == 0 && BusiInfo == "") {
                BusiInfo += selected[i] + ""; 
              }
              else  {
                BusiInfo += "," + selected[i];
              }
            }
            
            // 아무것도 체크가 안되어 있으면 기본값은 CRM으로 자동입력
            if (BusiInfo == null || BusiInfo == ""){
              vm.data.SVCSystem = "C";
            } else {
              vm.data.SVCSystem = BusiInfo;
            }
            
            vm.data.LoginId = LoginId;
            av.confirm("Menu.SAVECONFIRM2", function(){
              av.commit(function(result){
                
                //console.log(result);
    
                av.alert('Menu.SAVED', function(){
                  var url = "app.client.client-list";
                  var param = {};
                  param.srch = '';
                  //param.KeyId = result.body.docs[0].RelateDataId;
                  param = JSON.stringify(param);
                  cancel();
                  if (isNullOrEmpty(vm.popupYN)) { // 고객사목록페이지에서 등록 할 경우에는 해당페이지 리로딩
                    $state.go(url, JSON.parse(param) , {reload: url});
                  }
                });
              });
            });
          } 

          
        });
      }

      }
      
      //고객사 중복 여부 체크 
      function chkClientBSN( callback ) {
        vm.dataloader = true;
        var paramData = {
          ClientNm : vm.data.ClientNm,
          ClientBSN1 : vm.data.ClientBSN1,
          ClientTelNo : vm.data.Telephone,
        };
        var errMsg = '';
        //var bRtn = true;
        paramData.mapCode = 'Client.chkClientBSN';
        //console.log(paramData);
        postApi.select(paramData, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              //고객사 중복인 경우 값이 있음
              vm.dataloader = false;
              errMsg = vm.data.ClientNm + "과 같은 고객사 " + result.body.docs[0].ChkClientNm + " 가 이미 존재합니다.";
              errMsg = errMsg + "사업자등록번호 : " + result.body.docs[0].ChkClientBSN1;
              errMsg = errMsg + "전화번호 : " + result.body.docs[0].ChkTelephone;
              vm.isClientValid = 10;
              
              //console.log(vm.isClientValid);
              if (!isNullOrEmpty(errMsg)) {
                gAlert('', errMsg);
                //bRtn = false;
                
              }
              
              
            }
            else {
              //bRtn = true;
              vm.isClientValid = 0;
              //console.log(vm.isClientValid);
            }
            callback(vm.isClientValid);
          }
        }); 
        
        //return bRtn;
      }
      //#region 필수항목 체크
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        if(vm.data.ClientBSN1.length > 10) {
          errMsg = errMsg + '- 사업자등록번호를 확인해 주세요.<br/>';
        }
        if(vm.data.ClientBSN1.length < 10) {
          errMsg = errMsg + '- 사업자등록번호를 확인해 주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ClientNm)) {
          errMsg = errMsg + '- 고객사를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Telephone)) {
          errMsg = errMsg + '- 전화번호를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ClientBSN1)) {
          errMsg = errMsg + '- 사업자등록번호를 입력하세요.<br/>';
        }
        
 
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn = false;
        }
        return bRtn;
      }
      //#endregion 필수항목 체크

      function onReadyAutoView() {
        // 초기 설정
        vm.data = {};
        if (!isNullOrEmpty(mdata)) {  // 고객사목록페이지 등록이 아닌 경로로 왔을때 처리
          vm.popupYN = isNullOrEmpty(mdata.popup) ? 'N' : mdata.popup;
        }
      }


      vm.onReadyAutoView = onReadyAutoView;
      vm.setData = setData; 
      //vm.clickCheckBoxEtc = clickCheckBoxEtc;

      var av = new autoView();
      av.init(autoViewOption);
    } ]);

webapp.controller('ClientNiceDNBModalCtrl', [ '$uibModalInstance', 'toModalData', '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert', 'gConfirm', '$uibModalStack',
    function ClientNiceDNBModalCtrl($uibModalInstance, mdata, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert, gConfirm, $uibModalStack) {
      var vm = this;
      vm.dataloader = false;
      //vm.mdata = mdata;
      //vm.getList = getList;
      var LoginId = $window.sessionStorage['loginUserId'];
      var KEY_TABLE_NM = 'TB_CLS_COMP'; // 작업 테이블명
      vm.headerTitle = "나이스정보조회";
      // 변수설정
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        Key : mdata.Key,
        ClientNm : mdata.ClientNm,
        ClientBSN1 : mdata.ClientBSN1
      };
      vm.ok = ok;
      vm.cancel = cancel;
      vm.goData = goData;
      vm.getSearch = getSearch;
      vm.getList = getList;
      vm.pageChanged = pageChanged;
      vm.chgChkBox = chgChkBox;
      vm.srch.viewSize = 10;
      vm.currentPage = 1;
      vm.maxSize = 10;


      getList();

      

      





      function getList() {
        vm.dataloader = true;
        getListCnt();
        
        var data = angular.copy(vm.srch); 
        data.mapCode= 'Client.getNiceList';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            //console.log('result', result);
            vm.lists = result.body.docs;
            if (vm.lists.length > 0) {
              for(var i = 0; i < vm.lists.length; i++) {
                if (!isNullOrEmpty(vm.lists[i].SaleSetDT)) {
                  vm.lists[i].SaleSetDT = vm.lists[i].SaleSetDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
                }
                
              }
            }
          }
          vm.dataloader = false;
        });
        
      }

      function getListCnt() {
        var data = angular.copy(vm.srch); 
        data.mapCode = 'Client.getNiceListCnt';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();
      }

        // 검색
      function getSearch() {
        
        vm.srch.page = 1;
        vm.currentPage = vm.srch.page;
        var data = angular.copy(vm.srch); 
        if (!isNullOrEmpty(data.ClientNm) && isNullOrEmpty(data.ClientBSN1)) {
          vm.srch.Key = 'Name';
        }
        if (isNullOrEmpty(data.ClientNm) && !isNullOrEmpty(data.ClientBSN1)) {
          vm.srch.Key = 'BSN';
        }
        if (!isNullOrEmpty(data.ClientNm) && !isNullOrEmpty(data.ClientBSN1)) {
          vm.srch.Key = 'Both';
        }
        //console.log(vm.srch);
        getList();
      }


      function chgChkBox(KeyId) {
        $('input[type="checkbox"][id^="chk_"]').prop('checked', false);
        $('input[type="checkbox"][id="chk_' + KeyId + '"]').prop('checked', true);
      }

      



      function goData() {
        var data = {};
        data.KeyId = $('input:checkbox[name="chkbox"]:checked').val();
        if (isNullOrEmpty(data.KeyId)) {
          gAlert('', '선택된 나이스정보가 없습니다.');
          return false;
        } 
        else {
          gConfirm('', '선택된 나이스정보를 적용 하시겠습니까?', {
            btn : '',
            fn : function() {
              $uibModalStack.dismissAll();
              /* $state.go('app.client.client-detail', {
                srch : '',
                KeyId : data.KeyId
              }); */
              for(var i = 0; i < vm.lists.length; i++) {
                if ( vm.lists[i].KeyId == data.KeyId) {
                  vm.data = vm.lists[i];
                }
              }
            }
          }, {
            btn : '',
            fn : function() {
            }
          });
        }
      }




      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

    } ]);

webapp.controller('ClientscoreEditModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state',
    function ClientscoreEditModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      (function ClientscoreEditModalCtrl() {
        //getList();
      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }



    } ]);



webapp.controller('KSACustEditModalCtrl', ['$mdDialog', '$timeout', '$q','$log', '$uibModalInstance', 'toModalData', '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert', 'gConfirm',
    function KSACustEditModalCtrl( $mdDialog, $timeout, $q, $log, $uibModalInstance, mdata, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert, gConfirm) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.mdata = mdata;
      var oldParam = {};
      var newParam = {};
      vm.dataloader = false;  // Progressbar 숨김
      //$scope.SelectBox = [];
      vm.custStatus = 0;
      
      //담당지역본부 값 불러와서 셀렉트박스에 설정
      var codeval = [];
      postApi.select({ mapCode: 'KSACust.getDeptCode'}, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.CodeValue = result.body.docs;
            angular.forEach(vm.CodeValue, function(item) {
              var code = {Code : item.Code, CodeValue : item.CodeValue};
              codeval.push(code);
            });
          }
          
        }
      }); 
      
      $scope.DeptBox = codeval;
      //console.log(codeval);
      

      //담당지역본부 선택시.. 담당지역본부값 설정
      function setDeptSelect(selectedDept) {
        vm.data.DeptCode = selectedDept;
        //console.log(vm.data.DeptCode);
        //setManagerId();
      }
      //담당지역본부 선택시 해당 담당지역본부의 영업담당자 설정?
      function setManagerId() {

      }
      
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.Edit, // List OR Edit
        /* 상세페이지 */
        // 엘리먼트 퍼블리싱 타입
        formType : mElemTx.layout.inline,
        tableNm : "TB_MEMBER",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data", // ex : vc.data = {}
        apis : {
          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect : { mapCode : "KSACust.getKSACustDetail", param : null },
          // vieType is edit
          insert : "KSACust.insertKSACustBatch",
          update : "KSACust.updateKSACust",        
        },
  
        // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
        addRow : [],
  
        // vc의 ng-if
        /* ngIf : {
          CustType : "false",
        }, */
        
        // 비활성화 시킬 컬럼의 조건
        disabled : {
          RegInfo : true,
          EditInfo : true,
          KeyId : true,
          EncryptMobile : "vc.custStatus != 0 ",
          EncryptEmail : "vc.custStatus != 0",
          CustTel : "vc.custStatus == 10",
          Memo : "vc.custStatus == 10",
          AgreeSMS : "vc.custStatus == 10",
          AgreeEmail : "vc.custStatus == 10",
          SVCSystem : "vc.custStatus != 0",
          EncryptNm : "vc.custStatus != 0",
          /* KeyMan : "vc.data.custStatus == '10'", */
          AgreeEmailDT : "vc.custStatus == 10",
          DenialEmailDT : "vc.custStatus == 10",
          AgreeSMSDT : "vc.custStatus == 10",
          DenialSMSDT : "vc.custStatus == 10",
          DeptCode : "vc.custStatus == 10",
          ManagerId : "vc.custStatus == 10",
          //ClientNm : "vc.data.custStatus == '20'",
          
        },
  
        // MataColum 외 추가 적으로 넣어야할 폼
        addForm : {
          // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
          Address : { after : "Working", type : mElemTx.address,  bindKey : ["ZipCode", "Address1", "Address2"], label : "주소"},
          
          /* empytyBox1 : { after : "KeyMan"}, */
          //empytyBox2 : { after : "empytyBox1"},
        },
  
        
  
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes : {
          //BusiInfoBox : "codeBusiInfo",
        },
        
        customColSize : {
          Address : "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          /* empytyBox1 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4", */
          //empytyBox2 : "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4",
        },
  
        // 필수 항목 컬럼 
        required : ["EncryptNm", "EncryptMobile", "EncryptEmail", /* "AgreeSMS", "AgreeEmail", */ "ClientNm" ],

        autocomplete: {
          ClientNm: { keyNm: "ClientId", callback: "getSetClient", codeList: "codeClientList", addTopRow: "신규등록", addTopRowCallback: "addClient", ngChange: "onChangeClientNm" },
          CustNm: { keyNm: "CustId", callback: "getSetCust", codeList: "codeCustList", /* addTopRow: "신규등록", addTopRowCallback: "addCust", */ ngChange: "onChangeCustNm" },
          //ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", addTopRow: "", addTopRowCallback: "", ngChange: "onChangeManagerNm" },
        }  

        
      };

      /* START 고객사 자동완성 */
      vm.ACClientNm = "__undefined__";
      vm.ACClientNmTimerId = null;

      vm.onChangeClientNm = function(item) {
        if (vm.ACClientTimerId != null) {
          clearTimeout(vm.ACClientNmTimerId);
        }

        vm.ACClientNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACClientNm != item && !check.test(item)) {
            // 고객사리스트
            postApi.select({mapCode: 'AutoComplete.getClientList', ClientNm: item}, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function(item){
                  item.CodeValue = item.ClientNm;
                });
                vm.codeClientList = result.body.docs;
              }

              vm.ACClientNm = item;
            });
          }
        }, 100);
      };

      function addClient(){
        var ctrl = 'ClientEditModalCtrl as vc';
        var paramData = {popup : 'Y'};
        var modalInstance = modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
          var data = angular.copy(okData);
          getSetClient(data);
        }, function (cancelData) {
        });
      }
      /* END 고객사 자동완성 */

      /* START 고객 자동완성 */
      /* vm.ACCustNm = "__undefined__";
      vm.ACCustNmTimerId = null;

      vm.onChangeCustNm = function (item) {
        if (vm.ACCustNmTimerId != null) {
          clearTimeout(vm.ACCustNmTimerId);
        }

        vm.ACCustNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACCustNm != item && !check.test(item)) {
            // 영업담당자사리스트
            postApi.select({ mapCode: 'AutoComplete.getCustList', CustNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.CustNm;
                });
                vm.codeCustList = result.body.docs;
              }

              vm.ACCustNm = item;
            });
          }
        }, 100);
      }; */

      



      
      /* END 고객 자동완성 */
      
      /* START 영업담당자 자동완성 */
      vm.ACManagerNm = "__undefined__";
      vm.ACManagerNmTimerId = null;
      vm.onChangeManagerNm = function (item) {
        if (vm.ACManagerNmTimerId != null) {
          clearTimeout(vm.ACManagerNmTimerId);
        }

        vm.ACManagerNmTimerId = setTimeout(function () {
          var check = /[ㄱ-ㅎ]/;
          if (vm.ACManagerNm != item && !check.test(item)) {
            // 영업담당자사리스트
            postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function (item) {
                  item.CodeValue = item.UserNm;
                });
                vm.codeManagerList = result.body.docs;
              }

              vm.ACManagerNm = item;
            });
          }
        }, 100);
      };

      function setManagerCode(data) {
        vm.data.ManagerId = data.UserId;
      }

      /* END 영업담당자 자동완성 */


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

      var busiInfoEtcText = "";
      // 체크박스 기타 체크시 인풋 열어주기
      $scope.clickCheckBoxEtc = function(event) {
        var checkBox = document.getElementById("inlineCheckbox12");
        if (checkBox.checked) {
          $('#busiInfoEtc').attr('readonly', false);
        } else {
          $('#busiInfoEtc').attr('readonly', true);
        }
        
      };

      //고객사 등록 저장버튼 클릭
      function setData() {

        if (isNullOrEmpty(vm.data.AgreeEmail)) {
          vm.data.AgreeEmail = 'Y';
        }
        if (isNullOrEmpty(vm.data.AgreeSMS)) {
          vm.data.AgreeSMS = 'Y';
        }
        busiInfoEtcText = $('#busiInfoEtc').val();
        var BusiInfo = "";
        
        //기타 선택했는지 확인 
        if (busiInfoEtcText != null && busiInfoEtcText != "") {
          BusiInfo = busiInfoEtcText;
          //기타담당사업
          vm.data.ETCRole = busiInfoEtcText;
        }
        // 체크박스 
        var checkboxes = document.getElementsByName('busiInfo');
        var selected = [];
        
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                selected.push(checkboxes[i].value);
            }
        }
        // 선택된 체크박스가 하나면 그대로 두개이상이면 ,로 구분
        var svcRoleList = [];
        for (i = 0; i < selected.length; i ++) {
          var svcRoleMap = {};
          if (i == 0 && BusiInfo != "") {
            BusiInfo += ", " + selected[i];
          }
          else if (i == 0 && BusiInfo == "") {
            BusiInfo += selected[i] + ""; 
          }
          else  {
            BusiInfo += "," + selected[i];
            
          }
          svcRoleMap.SVCRole = selected[i];
          svcRoleList.push(svcRoleMap);
          
        }
        //Mainrole 관련사업(KIESLGMQB) == KEYMAN Y용으로 관련사업 수 만큼 TB_COMP_MEMBER에 INSERT한다.
        vm.data.SVCRole = svcRoleList;
        // CUSTROLE 의 경우 SVCROLE과 같으나 문자열로 들어간다. 아무것도 체크가 안되어 있으면 기본값은 없음
        if (BusiInfo == null || BusiInfo == "") {
          vm.data.CustRole = "";
        } else {
          vm.data.CustRole = BusiInfo;
        }
        
        if (getIsValidData()) {
          
          if (chkCustValue()) {

            //SVC 출처 미선택시 기본값 CRM
            if (vm.data.SVCSystem == null || vm.data.SVCSystem == "") {
              vm.data.SVCSystem = "C";
            }
            var tele = vm.data.EncryptMobile;
            vm.data.Mobile4 = tele.slice(tele.length - 4);

            if (vm.data.Working == null || vm.data.Working == "") {
              vm.data.Working = 'Y';
            }
            if (vm.data.KeyMan == null || vm.data.KeyMan == "") {
              vm.data.KeyMan = 'N';
            }
            /* vm.data.Department = $('#custDept').val();
            vm.data.Title = $('#custTitle').val(); */
            //vm.data.LoginId = LoginId;
            if (vm.data.AgreeSMS == 'Y' ) {
              vm.data.AgreeSMSDT = moment.utc(vm.data.AgreeSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS동의일시
              vm.data.DenialSMSDT = null;
            } 
            if (vm.data.AgreeEmail == 'Y') {
              vm.data.AgreeEmailDT = moment.utc(vm.data.AgreeEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일동의일시
              vm.data.DenialEmailDT = null;
            }
            if (vm.data.AgreeSMS == 'N') {
              vm.data.AgreeSMSDT = null;
              vm.data.DenialSMSDT = moment.utc(vm.data.DenialSMSDT).format('YYYY-MM-DD HH:mm') ; // SMS거부일시
            } 
            if (vm.data.AgreeEmail == 'N') {
              vm.data.AgreeEmailDT = null;
              vm.data.DenialEmailDT = moment.utc(vm.data.DenialEmailDT).format('YYYY-MM-DD HH:mm') ; // 이메일거부일시
            }

            
            if (vm.data.KeyId == null || vm.data.KeyId == '') {
              vm.data.KeyId = '';
            }
            //newParam = vm.data;
            newParam = angular.copy(vm.data);


            //신규 또는 기존 고객사에 신규 고객을 추가
            if (newParam.CustId == null || newParam.CustId == "") {
              //insertKSACustBatch
              //이함수에서 신규 고객을 추가하고 기존 고객사 인지 신규고객사인지 ClientId를 조사하여 
              //기존의 고객사이면 tb_comp_member와 tb_cust_ref 만 추가하고
              //신규 고객사이면 tb_company에도 추가한다. 
              console.log('신규 고객 추가 ====> insertKSACustBatch'); 
              insertKSACustBatch();
              //리맴버에서 추가시 리맴버 정보 수정 
              if (newParam.SVCSystem == 'R') {
                console.log('리맴버 정보 업데이트');
                updateMemberRememberData();
                var param = {};
                param.srch = '';
                param = JSON.stringify(param);
                var url = "app.client.remember-list";
                $state.go(url, JSON.parse(param) , {reload: url});
              }
            }
            
            //기존의 고객에 두번째 새로운 직장 정보를 추가! 
            if (vm.custStatus == 10) {
              if (newParam.CustId != null || newParam.CustId != "") {
                if (oldParam.ClientId != newParam.ClientId) {
                  //기존의 고객에 새로운 직장정보를 추가한다. 
                  //기존고객사이면 tb_comp_member와 tb_cust_ref 만 추가한다.
                  //고객사 미등록 고객에 관하여도 함수가 적용된다. 
                  console.log('두번째 직장추가 ====> insertKSACustNewCompBatch'); 
                  insertKSACustNewComp();
                }
              }
            }
            
            
            if (!isNullOrEmpty(newParam.CustId)) {
              if (oldParam.ClientId == null && newParam.ClientId != null) {
                //기존의 고객에 새로운 직장정보를 추가한다. 
                //쿼리에서는 ClientId를 조사하여 두번째 직장정보에 대하여 신규고객사인지 기존 고객사인지를 조사하여
                //고객사 미등록 고객에 관하여도 함수가 적용된다. 
                console.log('직장미등록고객 직장추가 ====> insertKSACustNewCompBatch'); 
                insertKSACustNewComp();
              }
            }

            /* av.confirm("Menu.SAVECONFIRM2", function(){
              //console.log(vm.data);
              av.commit(function(result){ */
                
                //console.log(result);

                 av.alert('Menu.SAVED', function(){
                  var url = "app.client.ksacust-list";
                  var param = {};
                  param.srch = '';
                  //param.KeyId = result.body.docs[0].RelateDataId;
                  param = JSON.stringify(param);
                  cancel();
                  if (isNullOrEmpty(vm.popupYN)) { // 고객목록페이지에서 등록 할 경우에는 해당페이지 리로딩
                    $state.go(url, JSON.parse(param) , {reload: url});
                  }
                }); 
            /*  });
            });  */
          }
        }
        
        

      }

      function insertKSACustBatch() {
        vm.dataloader = true;
        var newData = {};
        newData = newParam;
        //newData.LoginId = LoginId;
        newData.mapCode = "KSACust.insertKSACustBatch";

        postApi.update(newData, function(result) {
          vm.dataloader = false;

        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
      }

      //리맴버에서 고객 등록시
      function updateMemberRememberData() {
        vm.dataloader = true;
        var newData = {};
        newData = newParam;
        newData.mapCode = "Remember.updateMemberRememberData";
        ("updateMemberRememberData == > ");
        postApi.update(newData, function(result) {
          vm.dataloader = false;
          console.log("updateMemberRememberData");
          console.table(result);
        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        });  
      }

      // 두번째 직장정보추가 수정시! 
      function insertKSACustNewComp() {
        vm.dataloader = true;
        var newData = {};
        newData = newParam;
        //newData.LoginId = LoginId;
        //console.log("oldParam ====" + JSON.stringify(oldParam));
        //console.log("newParam ====" + JSON.stringify(newParam));

        newData.mapCode = "KSACust.insertKSACustNewComp";
        //console.log("insertKSACustNewCompBatch Param == > " + JSON.stringify(newData));
        postApi.update(newData, function(result) {
          vm.dataloader = false;

        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        });  
      }


      function onReadyAutoView() {
        // 초기 설정
        var KeyId = mdata;
        if (!isNullOrEmpty(KeyId)) {
          
          //console.log(KeyId);
          //직장추가 버튼으로 넘어온 경우!
          if (typeof KeyId == "string") {
            $("#CustEditTitle").text("고객 직장 정보 추가");
            $("#CustEditSubTitle").text("선택한 고객에 새로운 직장정보를 추가 합니다. 고객사 검색 혹은 신규등록으로 고객의 직장을 추가합니다.");
            getSetCust(KeyId);
          }
          //리맴버등록으로 넘어온 경우!
          if (typeof KeyId == "object" && KeyId.popup != 'Y') {
            
              $("#CustEditTitle").text("리맴버 고객 등록");
              $("#CustEditSubTitle").text("선택한 고객을 등록합니다. 해당고객의 고객사 또는 신규등록으로 고객의 직장을 추가합니다.");
              getSetRememberCust(KeyId);
          
            
          }
        }
        if (isNullOrEmpty(KeyId)) {
          $('#sec2').hide();
          //활용동의 기본값 동의 처리
          vm.data.AgreeEmail = 'Y';
          vm.data.AgreeSMS = 'Y';
        }
        
        
        if (!isNullOrEmpty(mdata)) {  // 고객목록페이지 등록이 아닌 경로로 왔을때 처리
          vm.popupYN = isNullOrEmpty(mdata.popup) ? 'N' : mdata.popup;
        }
        //vm.custStatus = 0; //0 == 등록 및 수정전 값이 없음
        /* // 고객사리스트
        postApi.select({ mapCode: 'AutoComplete.getClientList' },
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            angular.forEach(result.body.docs, function(item){
              item.CodeValue = item.CompName;
            });
            vm.codeCompList = result.body.docs;
          }
        }); */


      }
      //상세검색필드 열고 닫기

      function openCompInfo() {
        var getClassNm = $("#detailSearch").attr('class');
        if (getClassNm.indexOf('down') > 0) {
          detailOpen();
        } else {
          detailClose();
        }
      }

      function detailOpen() {
        $('#sec2').show();
        $('#detailSearch').removeClass('fa-caret-down');
        $('#detailSearch').addClass('fa-caret-up');
      }


      function detailClose() {
        //$('#detailSearchField').fadeOut(1600, complete);
        $('#detailSearch').removeClass('fa-caret-up');
        $('#detailSearch').addClass('fa-caret-down');
        $('#sec2').hide();
      }


      
      //고객사 정보입력
      function getSetClient(data) {
        vm.dataloader = true;
        var paramData = {ClientId : data.ClientId};
        paramData.mapCode = 'KSACust.setCompanyData';
        
        /* 고객명 클릭시 해당 고객사 정보 불러와서 입력 */
        postApi.select(paramData, function(result) {
          //mapCode: 'KSACust.setCompanyData'
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            var cdata = result.body.docs[0];
            vm.data.CompTel = cdata.CompTel;
            vm.data.Fax = cdata.Fax;
            vm.data.ZipCode = cdata.ZipCode;
            vm.data.Address1 = cdata.Address1;
            vm.data.Address2 = cdata.Address2;
            vm.data.ClientId = cdata.ClientId;
            
            detailOpen();
          }
        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        
      }

      //고객 정보입력
      function getSetCust(KeyId) {
        
        var paramData = {KeyId : KeyId};
        paramData.mapCode = 'KSACust.getKSACustDetail';
        
        /* 고객명 클릭시 해당 고객사 정보 불러와서 입력 */
        postApi.select(paramData, function(result) {
          //mapCode: 'KSACust.setCompanyData'
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            vm.custStatus = 10; //불러온 값이 있음
            
            var cdata = result.body.docs[0];
            
            vm.data.CustId = cdata.CustId;
            vm.data.EncryptMobile = cdata.EncryptMobile;
            vm.data.CustTel = cdata.CustTel;
            vm.data.EncryptEmail = cdata.EncryptEmail;
            vm.data.Memo = cdata.Memo;
            vm.data.KeyMan = cdata.KeyMan;
            vm.data.CustRole = cdata.CustRole;
            vm.data.Department = cdata.Department;
            vm.data.Title = cdata.Title;
            vm.data.Working = cdata.Working;
            vm.data.AgreeSMS = cdata.AgreeSMS;
            vm.data.AgreeEmail = cdata.AgreeEmail;
            vm.data.AgreeSMSDT = cdata.AgreeSMSDT;
            vm.data.DenialSMSDT = cdata.DenialSMSDT;
            vm.data.AgreeEmailDT = cdata.AgreeEmailDT;
            vm.data.DenialEmailDT = cdata.DenialEmailDT;
            vm.data.DeptCode = cdata.DeptCode;
            vm.data.ManagerId = cdata.ManagerId;
            vm.data.SVCSystem = cdata.SVCSystem;
            vm.data.RegInfo = cdata.RegInfo;
            vm.data.EditInfo = cdata.EditInfo;
            //vm.data.ClientNm = cdata.ClientNm;
            vm.data.ClientId = cdata.ClientId;
            vm.data.EncryptNm = cdata.EncryptNm;
            vm.data.KeyId = cdata.KeyId;
            //detailOpen();
            vm.custStatus = 10; //10 == 기존고객사에서 값을 가져옴
            //기존 정보 저장
            oldParam = angular.copy(vm.data);
            
          }
        }, function(error) {
          vm.dataloader = false;
          console.table(error);
        }); 
        
      }

      //리맴버에서 등록시 !
      function getSetRememberCust(KeyId) {
        var cdata = KeyId;
        vm.data.EncryptMobile = cdata.EncryptMobile;
        vm.data.CustTel = cdata.CustTel;
        vm.data.EncryptEmail = cdata.EncryptEmail;
        vm.data.EncryptNm = cdata.CustNm;
        vm.data.Address1 = cdata.Address1;
        vm.data.Address2 = cdata.Address2;
        vm.data.CompTel = cdata.Telephone;
        vm.data.Title = cdata.Title;
        vm.data.Department = cdata.Department;
        vm.data.SVCSystem = 'R';
        vm.data.ClientId = cdata.ClientId;
        vm.data.ClientNm = cdata.ClientNm;
        vm.data.Fax = cdata.Fax;
        vm.data.AgreeEmail = 'Y';
        vm.data.AgreeSMS = 'Y';
        vm.data.Working = 'Y';
        vm.data.MemberRemberId = cdata.MemberRemberId;
        vm.data.RememberId = cdata.RememberId;
        vm.custStatus = 20; //리맴버에서 넘어온 고객인 경우
        detailOpen();
        
      }
      

      //#region 필수항목 체크
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';

        if (isNullOrEmpty(vm.data.ClientNm)) {
          errMsg = errMsg + '- 고객사를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.EncryptNm)) {
          errMsg = errMsg + '- 고객 이름을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.CompTel)) {
          errMsg = errMsg + '- 직장 전화번호를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.EncryptMobile)) {
          errMsg = errMsg + '- 휴대전화를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.EncryptEmail)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }
        /* if (isNullOrEmpty(vm.data.AgreeEmail)) {
          errMsg = errMsg + '- 이메일 마케팅 수신여부를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.AgreeSMS)) {
          errMsg = errMsg + '- SMS 마케팅 수신여부를 입력하세요.<br/>';
        } */
        if (isNullOrEmpty(vm.data.SVCRole)) {
          errMsg = errMsg + '- 사업정보를 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn = false;
        }
        return bRtn;
      }
      //#endregion 필수항목 체크

      //고객 중복 여부 체크 
      function chkCustValue() {

        vm.dataloader = true;
        var paramData = {
          EncryptNm : vm.data.EncryptNm,
          EncryptMobile : vm.data.EncryptMobile,
          EncryptEmail : vm.data.EncryptEmail,
        };
        var errMsg = '';
        var bRtn = true;
        paramData.mapCode = 'KSACust.chkCustValue';
        //console.log(paramData);
        if ( vm.custStatus == 0) {
          postApi.select(paramData, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                //고객의 개인정보 중복인 경우 값이 있음
                vm.dataloader = false;
                errMsg = vm.data.EncryptNm + "과 동일한 고객 " + result.body.docs[0].EncryptNm + " 고객이 존재합니다.";
                errMsg = errMsg + "휴대폰번호 : " + result.body.docs[0].EncryptMobile;
                errMsg = errMsg + "이메일 : " + result.body.docs[0].EncryptEmail + " 고객정보를 확인해 주세요."; 
                if (!isNullOrEmpty(errMsg)) {
                  gAlert('', errMsg);
                  bRtn = false;
                }
                
              } else {
                bRtn = true;
              }
            }
          });
        }
        else {
          // null
        }
        
        return bRtn;
      }

















      vm.addClient = addClient;
      //vm.setCustCode = setCustCode;
      //vm.addCust = addCust;

      vm.setManagerCode = setManagerCode;
      
      vm.setDeptSelect = setDeptSelect;
      vm.getSetCust = getSetCust; //고객 상세 정보  
      vm.getSetClient = getSetClient; //고객사 정보입력
      //vm.setClientCode = setClientCode;
      vm.openCompInfo = openCompInfo; //고객사 정보입력 열고
      vm.detailClose = detailClose; //고객사 정보입력 닫기
      vm.onReadyAutoView = onReadyAutoView;
      vm.setData = setData; 
      //vm.clickCheckBoxEtc = clickCheckBoxEtc;

      var av = new autoView();
      av.init(autoViewOption);


    } ]);

webapp.controller('KSACustMergeModalCtrl', [ '$uibModalInstance', 'toModalData', '$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope', 'gAlert', 'gConfirm', '$uibModalStack',
    function KSACustMergeModalCtrl($uibModalInstance, mdata, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope, gAlert, gConfirm, $uibModalStack) {
      var vm = this;
      vm.dataloader = false;
      vm.mdata = mdata;
      var LoginId = $window.sessionStorage['loginUserId'];
      vm.headerTitle = "중복고객 통합";
      vm.ok = ok;
      vm.cancel = cancel;
      vm.select_AllForOne = 'N';
      vm.select_AllForTwo = 'N';
      vm.selectedValue = false;
      
      vm.selectAll = selectAll;

      //console.log(vm.mdata);
      $scope.mapData = [];

      vm.mapData = [  {key:'EncryptNm',name:'고객명', data:[]}, {key: 'EncryptMobile', name:'휴대전화', data:[]}, {key:'EncryptEmail', name:'이메일', data:[]}, 
                      {key: 'CustTel', name:'전화번호', data:[]}, {key: 'Department', name:'부서', data:[]}, {key:'Title', name:'직위', data:[]}, {key:'Fax', name:'FAX', data:[]}, {key:'SVCRole', name:'담당사업', data:[]}, 
                      {key: 'ManagerNms', name:'영업담당자', data:[]}, {key:'DeptCodes', name:'담당지역본부', data:[]}, {key: 'ClientNms', name:'고객사명', data:[]}];

      angular.forEach(vm.mapData, function(item) {
        item.selectedValue = false;
      });

      angular.forEach(vm.mdata, function(item) {
        angular.forEach(vm.mapData, function(col) {
          //console.log(col.key, item[col.key]);
          if (item[col.key] == null) {
            col.data.push('');
          } else {
            col.data.push(item[col.key]);
          }
        });
      });
      //console.log(vm.mapData);

      vm.submitClickHandler = function () {
        var element = {};

        angular.forEach(vm.mapData, function(item) {
          if (item.selectedValue !== false) {
            element[item.key] = item.data[item.selectedValue];
          }
        });

        //console.log(element);
      };

      //var checked=false;
      function selectAll(i) {
        angular.forEach(vm.mapData, function(item) {
          item.selectedValue = i;
        });
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

    } ]);

(function () {
  "use strict";
  webapp.controller('ClientAlarmCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientAlarmCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 
      조찬
      Client.getClientAlarmListCnt
      Client.getClientAlarmList
     */
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
      var KeyId = $window.sessionStorage.getItem("currentClientId");
  
      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_NICE",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientAlarmListCnt"},
          initSelect : { mapCode : "Client.getClientAlarmList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientBreakfastCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientBreakfastCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 
      조찬
      Client.getClientBreakfastListCnt
      Client.getClientBreakfastList
     */
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
      var KeyId = $window.sessionStorage.getItem("currentClientId");
  
      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_BKM",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientBreakfastListCnt"},
          initSelect : { mapCode : "Client.getClientBreakfastList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientBusinessCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientBusinessCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 사업기회
    Client.getClientBusinessListCnt
    Client.getClientBusinessList
    TB_SV_BUSINESSOP
   */
    var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
      var KeyId = $window.sessionStorage.getItem("currentClientId");
  
      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_BUSINESSOP",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientBusinessListCnt"},
          initSelect : { mapCode : "Client.getClientBusinessList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
      function goBusinessOPEdit() {
        var ctrl = 'BusinessOpModalCtrl as vc';
        var paramData = {};
  
        var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // ok버튼
        }, function (cancelData) {
          // cancel버튼
        });
      }
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 
      vm.goBusinessOPEdit = goBusinessOPEdit;
  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientCustomerCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientCustomerCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 고객 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");



    vm.listOptions = {
      addColumn : {

      },

      html : {

      },
      addColumnClass : {

      },

      addRowClass : {
        //if : "li.CustReadyYN == 'Y'",  class : "row-highlight"
      },
      ngIf: {

      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_MEMBER",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientKSACustListCnt"},
        initSelect : { mapCode : "Client.getClientKSACustList", param : null },
      },


      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      setSVCSystem();
    }

    vm.ksacustEditModal = function() {
      var ctrl = 'KSACustEditModalCtrl as vc';
      modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl);
    };

    /* 출처(사업정보/사업실적) 정의.... */
    function setSVCSystem() {
      vm.dataloader = true;
      var data = {};
      //console.log(vm.lists);
      data = vm.lists;
      //console.log(data);
      var svcValue = "";
      var svcArray = [];
      if (data.length > 0) {
        for(var o = 0; o < data.length; o++) {
          svcValue = data[o].CustRole;
          var busiCnt = "";
          
          svcArray = svcValue.split(",");
          for(var i = 0; i < svcArray.length; i++) {
            if(svcArray[i] == 'K') {
              svcArray[i] = 'KS';
              
            }
            if(svcArray[i] == 'I') {
              svcArray[i] = 'ISO';
              
            }
            if(svcArray[i] == 'E') {
              svcArray[i] = '에너지';
              
            }
            if(svcArray[i] == 'L') {
              svcArray[i] = '교육';
              
            }
            if(svcArray[i] == 'M') {
              svcArray[i] = '회원사';
              
            }
            if(svcArray[i] == 'Q') {
              svcArray[i] = '분임조';
              
            }
            if(svcArray[i] == 'B') {
              svcArray[i] = '조찬회';
              
            }
            if(svcArray[i] == 'N') {
              svcArray[i] = '표준정보망';
              
            }
          }
          
          
          busiCnt.replace(' ',',');
          // 바꾸어준 출처 정보를 기입
          data[o].CustRole = svcArray;
          //data[o].BusiInfoCnt = busiCnt;
        }
      }
      
      vm.dataloader = false;
    }




    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientDefaultinfoCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientDefaultinfoCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {

    /* 고객사 - 기본정보 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    drawSocreGauge();
    drawClientLevel();
    drawBulletGauge();
    drawAnnualSalesBar();
    drawQuarterSalesBar();
    getCompanyDetail();

    //var CompanyId = $window.sessionStorage.getItem("currentCompanyId");
    //console.log("chk param : " + CompanyId);
    function getCompanyDetail() {
      vm.dataloader = true;
      var data = angular.copy(vm.srch);
      data.KeyId = $window.sessionStorage.getItem("currentClientId");
      data.mapCode = 'Client.getCompanyDetail';
      //alert(JSON.stringify(data));
      
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            var compDetail = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.log("error");
        // console.error('Error> client-defaultinfo-ctrl> getCompanyDetail()', error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    //고객사 스코어 산정 기준에 따라 기본 스코어 표기//사용자 스코어 기준설정을 통해 가중치 설정시 기본스코어, 사용자 스코어 2가지 결과 표시
    function drawSocreGauge() {
      var data = [
        {
          domain: { x: [0, 1], y: [0, 1] },
          value: 78,
          type: "indicator",
          mode: "gauge+number",
          delta: { reference: 80 },
          gauge: { bar: {color : 'rgba(106,121,227,.8)'},
                  axis: { range: [0, 100] } }
        }
      ];
      
      var layout = { 
        title: 'Score',
        height: 372,
        width: document.getElementById('clientScore').clientWidth, 
      };
      
      Plotly.newPlot('clientScore', data, layout, {staticPlot: true});
    }
  	
    //고객사 등급 상동
    function drawClientLevel() {

      var data = [
         { type: 'category',
          x: [0], y:[0],
            marker: {size: 10, color:'rgba(15,31,40,1)'},
            showlegend: false,
            }, 
        {
        type: 'pie',
        showlegend: false,
        hole: 0.6,
        rotation: 90,
        values: [100 / 6, 100 / 6, 100 / 6, 100 / 6, 100 / 6, 100 / 6, 100],
        text: ["0", "1", "2", "3", "4", "5", ""],
        direction: "clockwise",
        textinfo: "text",
        textposition: "inside",
        textcolor : 'rgb(79,95,201)',
        marker: {
          colors: ["rgba(106,121,227, 0.8)", "rgba(106,121,227, 0.65)", "rgba(106,121,227, 0.5)", "rgba(106,121,227, 0.4)", "rgba(106,121,227, 0.25)", "rgba(106,121,227, 0.15)", "white"]
        },
        //labels: ["0-10", "10-50", "50-200", "200-500", "500-2000", ""],
        hoverinfo: "skip"
      }];

      //화살표 설정.. level 값이 등급 점수
      // 화살표 하나더 추가 할 가능성 유
      /* var level = 3.5;
      var degrees = 180-(level-1)*45;

      var radians = degrees * Math.PI / 180;
      var x = 0.5 * Math.cos(radians);
      var y = 0.5 * Math.sin(radians);
      var mainPath = 'M -.0 -0.035 L .0 0.035 L ',
      pathX = String(x),
      space = ' ',
      pathY = String(y),
      pathEnd = ' Z';
      var path = mainPath.concat(pathX,space,pathY,pathEnd);
 */
      // needle
      var degrees = 50, radius = .9
      var radians = degrees * Math.PI / 180
      var x = -1 * radius * Math.cos(radians) * 3.5;
      var y = radius * Math.sin(radians)
      var layout = {
        title: '고객사 등급',
        height: 372,
        width: document.getElementById('clientLevel').clientWidth, 
        shapes: [{
        type: 'line',
        x0: 0,
        y0: 0.04,
        x1: 0,
        y1: 0.45,
        line: {
          color:'rgba(39,59,74,1)',
          width: 3
        }
        },
        {
        type: 'line',
        x0: 0.016,
        y0: 0.04,
        x1: 0.18,
        y1: 0.18,
        line: {
          color:'rgba(198,231,255,1)',
          width: 3
        }
        },
        /* {
        type: 'line',
        x0: 0.49,
        y0: 0.50,
        x1: 0.51,
        y1: 0.50,
        line: {
          color:'rgba(39,59,74,1)',
          width: 5
        }
        } */],
          xaxis: {type:'category', zeroline:false, showticklabels:false,
            showgrid: false, range: [-1, 1]},
          yaxis: {type:'category', zeroline:false, showticklabels:false,
            showgrid: false, range: [-1, 1]}
      };

      

      Plotly.newPlot('clientLevel', data, layout, {staticPlot: true});
    }

    //고객사 순위 == db에서 조회
    function drawBulletGauge() {
      var data = [
        {
          type: "indicator",
          mode: "gauge",
          gauge: { bar: {color: 'rgba(106,121,227, 0.8)'},shape: "bullet" },
          delta: { reference: 300 },
          value: 220,
          domain: { x: [0, 1], y: [0, 0.3] },
          text: '220위 / 500'
        }
      ];
      
      var layout = { 
        title: '고객사 순위',
        height: 372,
        width: document.getElementById('clientRank').clientWidth, 
      };
      
      Plotly.newPlot('clientRank', data, layout, {staticPlot: true});

    }


    //해당연도를 제외한 최근 3년 매출액 및 년도별 미수금 그래프 (단위: 만원)
    function drawAnnualSalesBar() {
      var xData = ['2018년', '2019년', '2020년'];
                

      var yValue = [107, 115, 123];
      var yValue2 = [15, 12, 13];
      var yValue3 = [107,15,115,12,123,13];
      //var yValue3 = [2, 2, 3.1, 4.3];
      //var textList = ['107', '15', '115', '12', '123', '13'];
      //var yData = [80, 6, 80, 6, 80, 6];
      var trace1 = {
        x: xData,
        y: yValue,
        text : yValue,
        textposition: 'outside',
        type: 'bar',
        name: '매출액',
        marker: {
          color: 'rgba(106,121,227,.8)'
        }
      };
      
      var trace2 = {
        x: xData,
        y: yValue2,
        text:yValue2,
        textposition: 'outside',
        type: 'bar',
        name: '미수금',
        marker: {
          color: 'rgba(106,121,227,.4)'
        }
      };
      
      var data = [trace1, trace2];
      
      var layout = {
        title: '매출액/미수금(년) [단위: 만]',
        
        legend: {"orientation": "h", /* y: -0.3, */
        bgcolor: 'rgba(255, 255, 255, 0)',
        bordercolor: 'rgba(255, 255, 255, 0)'},
        barmode: 'group',
        bargap: 0.2,
        bargroupgap: 0.15,
        //annotations: [],
        xaxis: {zeroline: false,},
        
        yaxis: {
          zeroline: false,
          showline: false,
          showgrid: true,
          range: [-10, 150]
        },
        config: { responsive: true },
        height: 372,
        width: document.getElementById('annualSalesBar').clientWidth, 
      };
      /* for ( var i = 0 ; i < 6 ; i++ ) {
        var result = {
          x: xData[i],
          y: yValue3[i],
          text: textList[i],
          font: {
            family: 'Arial',
            size: 14,
            color: 'black'
          },
          showarrow: false
        }; 
        layout.annotations.push(result);
      }  */
      Plotly.newPlot('annualSalesBar', data, layout, {staticPlot: true});
    }
    //해당 연도를 제외한 최근 3년간 분기별 매출액 그래프 표기 (단위 만원)
    function drawQuarterSalesBar() {
      var xData = ['18년 1분기', '18년 2분기', '18년 3분기', '18년 4분기', 
                    '19년 1분기', '19년 2분기', '19년 3분기', '19년 4분기',
                    '20년 1분기', '20년 2분기', '20년 3분기', '20년 4분기'
                  ];
      var textList = ['34', '38', '42', '54', '41', '47', '59', '71', '89', '53', '42', '65'];
      var yData = [20, 20, 20, 30, 20, 20, 30, 30, 40, 30, 20, 40];
      var trace1 = {
        x: xData,
        text: textList,
        textposition: 'outside',
        y: [34, 38, 42, 54, 41, 47, 59, 71, 89, 53, 42, 65],
        type: 'bar',
        name: '매출액',
        marker: {
          color: 'rgba(106,121,227,.8)',
          //opacity: 0.7,
        }
      };
      
      
      var data = [trace1];
      
      var layout = {
        title: '매출액(분기) [단위: 만]',
        legend: {"orientation": "h", /* y: -0.3, */
          bgcolor: 'rgba(255, 255, 255, 0)',
          bordercolor: 'rgba(255, 255, 255, 0)'},
        barmode: 'group',
        bargap: 0.2,
        bargroupgap: 0.35,
        //barmode: 'group',
        showlegend: false,
        annotations: [],
        height: 372,
        width: document.getElementById('quaterSalesBar').clientWidth, 
        xaxis: {zeroline: false, tickangle: -45 },
        
        yaxis: {
          zeroline: false,
          showline: false,
          showgrid: true,
          range: [-10, 100]
        },
      };
      /* for ( var i = 0 ; i < 12 ; i++ ) {
        var result = {
          x: xData[i],
          y: yData[i],
          text: textList[i],
          font: {
            family: 'Arial',
            size: 14,
            color: 'black'
          },
          showarrow: false
        };
        layout.annotations.push(result);
      } */
      Plotly.newPlot('quaterSalesBar', data, layout, {staticPlot: true});
    }



    vm.scoreExplain = function() {
      var ctrl = 'ClientscoreEditModalCtrl as vc';
      modalFactory.open('mf-80', 'app/client/modal/clientscore-edit-modal.html', ctrl);
    };
  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientEducationCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientEducationCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 교육 */
    /* Client.getClientEducationListCnt
      Client.getClientEducationList */
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
      var KeyId = $window.sessionStorage.getItem("currentClientId");

      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_LMS",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientEducationListCnt"},
          initSelect : { mapCode : "Client.getClientEducationList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientEnergyCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientEnergyCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 에너지 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_ECC",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientEnergyListCnt"},
        initSelect : { mapCode : "Client.getClientEnergyList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = vm.lists;
        

      var estMonth = '';


      if (data.length > 0) {
        for(var i = 0; i < data.length; i++) {
          data[i].WorkFDT = data[i].WorkFDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          data[i].WorkLDT = data[i].WorkLDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          
        
        }
      }
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientHistoryCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientHistoryCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 변경이력
    Client.getClientHistoryListCnt
    Client.getClientHistoryList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_HIST",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientHistoryListCnt"},
        initSelect : { mapCode : "Client.getClientHistoryList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientISOCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientISOCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 ISO */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_ISO",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientISOListCnt"},
        initSelect : { mapCode : "Client.getClientISOList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        var data = vm.lists;

        var estMonth = '';

        if (data.length > 0) {
          for(var i = 0; i < data.length; i++) {
            if (!isNullOrEmpty(data[i].CertExpDT)) {
              data[i].CertExpDT = data[i].CertExpDT.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            }
            if (!isNullOrEmpty(data[i].CertFDate)) {
              data[i].CertFDate = data[i].CertFDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            }
            if (!isNullOrEmpty(data[i].NextDate)) {
              data[i].NextDate = data[i].NextDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
              //NextDate 는 월 까지만 
              estMonth = data[i].NextDate.split("-");
              estMonth = estMonth[0] + "-" + estMonth[1];
              data[i].NextDate = estMonth;
            }
            if (!isNullOrEmpty(data[i].IssueDate)) {
              data[i].IssueDate = data[i].IssueDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            }
            
            
          }
        }


    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientKSCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientKSCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");



    vm.listOptions = {
      
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_KS",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientKSListCnt"},
        initSelect : { mapCode : "Client.getClientKSList", param : null },
      },


      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);


  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientMembersCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientMembersCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 - 회원사 
    Client.getClientMembersListCnt
    Client.getClientMembersList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_MBR",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientMembersListCnt"},
        initSelect : { mapCode : "Client.getClientMembersList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = vm.lists;
        

      if (data.length > 0) {
        for(var i = 0; i < data.length; i++) {
          if (!isNullOrEmpty(data[i].RegDate)) {
            data[i].RegDate = data[i].RegDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          if (!isNullOrEmpty(data[i].DelDate)) {
            data[i].DelDate = data[i].DelDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          if (!isNullOrEmpty(data[i].PmntDt)) {
            data[i].PmntDt = data[i].PmntDt.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          if (!isNullOrEmpty(data[i].LastPmntDate)) {
            data[i].LastPmntDate = data[i].LastPmntDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
        }
      }

    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientNetworkCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientNetworkCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 회원사
    Client.getClientNetworkListCnt
    Client.getClientNetworkList */

    var vm = this;
      vm.dataloader = false;
      vm.srch = {};
  
      vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
      var KeyId = $window.sessionStorage.getItem("currentClientId");

      vm.listOptions = {
      
        ngIf: {
          
        },
  
      };
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,
  
        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "TB_SV_KSSN",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        srchTarget : "searchWrap",
        apis : {
          initSelectCnt : { mapCode : "Client.getClientNetworkListCnt"},
          initSelect : { mapCode : "Client.getClientNetworkList", param : null },
        },
  
        addSrchStack : false,
        // List
        listCheckboxEnable : false,
  
        src : {
          //detail : "app.client.client-detail",
        },
  
        // 값이 변경되었을 시 콜백 처리 callback 과 유사함
        ngChange: {
          
        },
  
        // ngChange, Button, Date Chage 등에 사용하는 콜백
        callback: {
  
        },
        // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
        // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
        customCodes: {
  
        },
  
        // 필수 항목 컬럼 
        required: [],
  
        autocomplete: {}
      };
  
  
  
      function onReadyAutoView() {
          
      }
  
  
  
  
  
  
  
  
      vm.onReadyAutoView = onReadyAutoView;
  
      var av = new autoView();
      av.init(autoViewOption); 


  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientQualityCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientQualityCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 분임조
    Client.getClientQualityListCnt
    Client.getClientQualityList */

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_QCC",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientQualityListCnt"},
        initSelect : { mapCode : "Client.getClientQualityList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = vm.lists;
        

      if (data.length > 0) {
        for(var i = 0; i < data.length; i++) {
          if (!isNullOrEmpty(data[i].QCCRegDate)) {
            data[i].QCCRegDate = data[i].QCCRegDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          if (!isNullOrEmpty(data[i].StartDate)) {
            data[i].StartDate = data[i].StartDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          if (!isNullOrEmpty(data[i].EndDate)) {
            data[i].EndDate = data[i].EndDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
          }
          
        }
      }
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientRelateCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientRelateCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
    /* 고객사 연관사업정보 */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
      addColumn : {

      },

      html : {

      },
      addColumnClass : {

      },

      addRowClass : {
        //if : "li.CustReadyYN == 'Y'",  class : "row-highlight"
      },
      ngIf: {

      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_RELATE",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientRelateListCnt"},
        initSelect : { mapCode : "Client.getClientRelateList", param : null },
      },


      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
      var data = vm.lists;

      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!isNullOrEmpty(data[i].PRJT_STA_DD) && !isNullOrEmpty(data[i].PRJT_END_DD)) {
            data[i].PRJT_STA_DD = data[i].PRJT_STA_DD.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            data[i].PRJT_END_DD = data[i].PRJT_END_DD.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
            data[i].Period = data[i].PRJT_STA_DD + " ~ " + data[i].PRJT_END_DD;
          }

          
        }
      }
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientSalesCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientSalesCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
  /* 
    영업일지 
    TB_SV_BUSINESSDR
    Client.getClientSalesListCnt
    Client.getClientSalesList
  */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_BUSINESSDR",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientSalesListCnt"},
        initSelect : { mapCode : "Client.getClientSalesList", param : null },
      },

      addSrchStack : false,
      
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }


    function goBusinessDREdit() {
      var ctrl = 'BusinessDrModalCtrl as vc';
      var paramData = { };

      var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        var KeyId = 0;
        // 새로등록
        if (!isNullOrEmpty(okData)) {
          KeyId = okData;
        }
        // 수정하는 경우
        else {
          KeyId = okData.KeyId;
        }
        vm.busiWriteModal(KeyId);
      }, function (cancelData) {
        av.search();
      });
    }





    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 
    vm.goBusinessDREdit = goBusinessDREdit;
  }]);

})();
(function () {
  "use strict";
  webapp.controller('ClientSupportCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function ClientSupportCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {
  /* 
    지원사업 
    Client.getClientSupportListCnt
    Client.getClientSupportList
  */
    var vm = this;
    vm.dataloader = false;
    vm.srch = {};

    vm.srch.KeyId = $window.sessionStorage.getItem("currentClientId");
    var KeyId = $window.sessionStorage.getItem("currentClientId");

    vm.listOptions = {
    
      ngIf: {
        
      },

    };

    // 회의뷰 조회 팝업창
    vm.supportBusinessModal = function (keyId) {
      var ctrl = 'SupportBusinessModalCtrl as vc';
      var paramData = { KeyId: keyId };

      var modalInstance = modalFactory.open('mf-80', 'app/system/support-business/support-business-modal.html', ctrl, paramData);
      modalInstance.result.then(function () {
        av.search();
      }, function () {
        av.search();
      });
    };

    
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "TB_SV_SPTPROJECT",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "Client.getClientSupportListCnt"},
        initSelect : { mapCode : "Client.getClientSupportList", param : null },
      },

      addSrchStack : false,
      // List
      listCheckboxEnable : false,

      src : {
        //detail : "app.client.client-detail",
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange: {
        
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback: {

      },
      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes: {

      },

      // 필수 항목 컬럼 
      required: [],

      autocomplete: {}
    };



    function onReadyAutoView() {
        
    }








    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption); 

  }]);

})();
(function () {
  webapp.controller('CounselRecordModalCtrl', [
    '$window',
    '$scope',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'postApi',
    '$http',
    'gAlert',
    function CounselRecordModalCtrl(
      $window,
      $scope,
      $stateParams,
      CONSTANT,
      postApi,
      $http,
      gAlert
    ) {
      var vm = this;
      // 접근 권한 체크
      /*if (!isPageAccess("customerarmy-list-modal", $window.sessionStorage['loginUserType'])) {
        cancel();        
        vm.cancel = cancel;
        return false;
      }*/

      vm.getCounselrecordList = getCounselrecordList;

      (function CounselRecordModalCtrl() {
        // search
        vm.searchValue = '';
        vm.selectPeriod = 'all';
        vm.startDate = '';
        vm.endDate = '';
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        // 검색 선택 옵션
        vm.searchFieldTypeList = [
          {
            optionId: 'CustNm',
            optionName: '성명',
          },
        ];
        vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.CustArmyList = [];

        vm.searchValue = $stateParams.CustArmyId;
        getCounselrecordList();
      })();
      function changeViewSize() {
        getCounselrecordList();
      }
      function getRequestParams() {
        var req = {
          page: vm.currentPageNum,
          viewSize: vm.viewSizePerPage,
          searchFieldType: vm.searchFieldType,
          CustArmyId: vm.searchValue,
          selectPeriod: vm.selectPeriod,
        };
        vm.filter = req;
        return req;
      }

      function getCounselrecordList() {
        vm.req = vm.getRequestParams();
        vm.req.mapCode = 'Customerarmy.getCounselrecordList';

        postApi.select(
          vm.req,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                vm.lists = data.body.docs;
                $scope.showListEmpty = false;
              } else {
                $scope.showListEmpty = true;
                vm.lists = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }
    },
  ]);
})();

webapp.controller('ScheduleModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  'gAlert',
  'gConfirm',
  'modalFactory',
  function ScheduleModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    gAlert,
    gConfirm,
    modalFactory
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'schedule-edit-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    // 공통코드
    vm.FromHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : new moment().format('HH')*/
    };
    vm.FromMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : '00'*/
    };

    vm.ToHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : new moment().format('HH')*/
    };
    vm.ToMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : '00'*/
    };

    // 함수 선언
    vm.showModalCustInfo = showModalCustInfo;
    vm.clearModalCustInfo = clearModalCustInfo;
    vm.showModalUser = showModalUser;
    vm.clearModalUser = clearModalUser;

    vm.getData = getData;
    vm.deleteData = deleteData;

    vm.del = del;
    vm.ok = ok;
    vm.cancel = cancel;

    // 조회 데이터
    /*      vm.data = {
        SchId: toModalData.SchId,
        CustArmyId: '',
        CustNm: '',
        SchUserId: $window.sessionStorage['loginUserIdx'],
        SchUserId_: $window.sessionStorage['loginUserName'],
        StartYMD: toModalData.BaseDate,
        StartHour: new moment().format('HH'),
        StartMin: '00',
        EndYMD: toModalData.BaseDate,
        EndHour: new moment().format('HH'),
        EndMin: '00',
        Title: ''
      };
      vm.data.oldStartYMD = "";*/

    vm.data = {
      SchId: toModalData.SchId,
      userPermList: JSON.parse($window.sessionStorage['loginGroupUId']),
    };

    if (toModalData.SchId == 0) {
      vm.data = {
        SchId: toModalData.SchId,
        CustArmyId: '',
        CustNm: '',
        SchUserId: $window.sessionStorage['loginUserIdx'],
        SchUserId_: $window.sessionStorage['loginUserName'],
        StartYMD: toModalData.BaseDate,
        /*StartHour: new moment().format('HH'),
          StartMin: '00',*/
        EndYMD: toModalData.BaseDate,
        /*EndHour: new moment().format('HH'),
          EndMin: '00',*/
        Title: '',
      };

      vm.FromHourList.Code = '00';
      vm.FromMinList.Code = '00';
      vm.ToHourList.Code = '00';
      vm.ToMinList.Code = '00';

      vm.data.StartHour = '00';
      vm.data.StartMin = '00';
      vm.data.EndHour = '00';
      vm.data.EndMin = '00';
    }

    /**
     * Constructor
     *
     * @param
     * @return
     */
    (function ScheduleModalCtrl() {
      // 시작일, 종료일 지정
      $scope.dtFromDate = moment(toModalData.BaseDate).toDate();
      $scope.dtToDate = moment(toModalData.BaseDate).toDate();

      // 데이터 조회
      if (vm.data.SchId != '') getData();
    })();

    /**
     * 고객 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalCustInfo() {
      var ctrl = 'CustarmyModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/customer/modal/customerarmy/custarmy-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.CustNm = okData.CustNm;
          vm.data.CustArmyId = okData.CustArmyId;
          vm.data.ArmyNo = okData.ArmyNo;
        },
        function (cancelData) {}
      );
    }

    /**
     * 고객 초기화
     *
     * @param
     * @return
     */
    function clearModalCustInfo() {
      vm.data.CustNm = '';
      vm.data.CustArmyId = '';
    }

    /**
     * 상담사 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/user2-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.SchUserId_ = okData.UserNm;
          vm.data.SchUserId = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 상담사 초기화
     *
     * @param
     * @return
     */
    function clearModalUser() {
      vm.data.SchUserId_ = '';
      vm.data.SchUserId = '';
    }

    /**
     * 시작일시 Callback
     *
     * @param
     * @return
     */
    vm.onSelectFromList = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.StartHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.StartMin = data.Code;
      }
    };

    /**
     * 종료일시 Callback
     *
     * @param
     * @return
     */
    vm.onSelectToList = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.EndHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.EndMin = data.Code;
      }
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     */
    function getData() {
      vm.data.mapCode = 'Schedule.getScheduleDetail';

      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            // 조회 데이터
            vm.data = data.body.docs[0];

            // 시작일시 지정
            $scope.dtFromDate = moment(vm.data.StartYMD).toDate();
            vm.FromHourList.Code = vm.data.StartHour;
            vm.FromMinList.Code = vm.data.StartMin;

            // 종료일시 지정
            $scope.dtToDate = moment(vm.data.EndYMD).toDate();
            vm.ToHourList.Code = vm.data.EndHour;
            vm.ToMinList.Code = vm.data.EndMin;

            return;
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error> Schedule-Modal-ctrl> getData()', status, error);
        }
      );
    }

    // 유효성검사
    function chkValid() {
      // 필수입력 체크
      if (
        typeof vm.data.CustArmyId == 'undefined' ||
        vm.data.CustArmyId == ''
      ) {
        gAlert('', '성명을 선택해 주십시오.');
        return false;
      }
      if (
        typeof vm.data.SchUserId_ == 'undefined' ||
        vm.data.SchUserId_ == ''
      ) {
        gAlert('', '상담사를 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartYMD == 'undefined' || vm.data.StartYMD == '') {
        gAlert('', '시작 일자를 입력해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartHour == 'undefined') {
        gAlert('', '시작 시간을 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartMin == 'undefined') {
        gAlert('', '시작 분을 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.EndYMD == 'undefined' || vm.data.EndYMD == '') {
        gAlert('', '종료 일자를 입력해 주십시오.');
        return false;
      }
      if (typeof vm.data.EndHour == 'undefined') {
        gAlert('', '종료 시간을 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.EndMin == 'undefined') {
        gAlert('', '종료 분을 선택해 주십시오.');
        return false;
      }

      /*  if (getDateToNumber(vm.data.StartYMD + vm.data.StartHour + vm.data.StartMin) > getDateToNumber(vm.data.EndYMD + vm.data.EndHour + vm.data.EndMin)) {          
          gAlert('', '시작일 종료일의 날짜범위가 잘못되었습니다.');
          return false;
        }*/

      /*if (vm.data.oldStartYMD == "") { // 신규
          if (typeof(vm.data.StartYMD) != "undefined" && vm.data.StartYMD != "") {
            if (getDateToNumber(vm.data.StartYMD) <  getDateToNumber(getTodayAddDay(3))) {
              alert('시작일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.StartYMD) != "undefined" && vm.data.StartYMD != "") {
            if (vm.data.oldStartYMD != vm.data.StartYMD && getDateToNumber(vm.data.StartYMD) <  getDateToNumber(getTodayAddDay(3))) {
              alert('시작일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      return true;
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {
      if (!chkValid()) return false;

      // 하이픈 제거
      vm.data.StartYMD = moment(vm.data.StartYMD).format('YYYYMMDD');
      vm.data.EndYMD = moment(vm.data.EndYMD).format('YYYYMMDD');

      var successCallback = function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = data.body.docs[0];

          gAlert('', '저장 되었습니다.');

          $uibModalInstance.close(vm.data);

          return true;
        }
      };

      var errorCallback = function (error) {
        gAlert('', '저장을 실패했습니다.');

        console.log("error");
        // console.error('Error> Schedule-Modal-ctrl> setData()', status, error);

        return false;
      };

      if (vm.data.SchId == '') {
        // 등록
        vm.data.mapCode = 'Schedule.insertSchedule';
        postApi.insert(vm.data, successCallback, errorCallback);
      } else {
        // 수정
        vm.data.mapCode = 'Schedule.updateScheduleBatch';
        postApi.update(vm.data, successCallback, errorCallback);
      }
    }

    /**
     * 데이터 삭제
     *
     * @param
     * @return
     */
    function deleteData() {
      vm.data.mapCode = 'Schedule.deleteSchedule';

      postApi.delete(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '삭제 되었습니다.');

            $uibModalInstance.close(vm.data);

            return true;
          }
        },
        function (error) {
          gAlert('', '삭제를 실패했습니다.');

          console.log("error");
          // console.error(
          //   'Error> Schedule-Modal-ctrl> deleteData()',
          //   status,
          //   error
          // );

          return false;
        }
      );
    }

    /**
     * 삭제
     *
     * @param
     * @return
     */
    function del() {
      // 데이터 삭제
      gConfirm(
        '',
        '삭제 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            deleteData();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    /**
     * 저장
     *
     * @param
     * @return
     */
    function ok() {
      // 데이터 저장
      gConfirm(
        '',
        '저장 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            setData();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    /**
     * 닫기
     *
     * @param
     * @return
     */
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }
  },
]);

webapp.controller('DashboardImgModalCtrl', [
  '$window',
  '$scope',
  '$state',
  '$cookies',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'ModalAPISrv',
  'gAlert',
  'postApi',
  function DashboardImgModalCtrl(
    $window,
    $scope,
    $state,
    $cookies,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    api,
    gAlert,
    postApi
  ) {
    var vm = this;
    vm.src = toModalData.src;

    // 함수 연결
    vm.close = close;

    (function DashboardImgModalCtrl() {
    })();
    
    function close() {
      $uibModalInstance.close();
    }
  },
]);

webapp.controller('MailSecGuideModalCtrl', [
  '$window',
  '$scope',
  '$state',
  '$cookies',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'ModalAPISrv',
  'gAlert',
  'postApi',
  function MailSecGuideModalCtrl(
    $window,
    $scope,
    $state,
    $cookies,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    api,
    gAlert,
    postApi
  ) {
    var vm = this;

    // 함수 연결
    vm.close = close;

    (function MailSecGuideModalCtrl() {
    })();
    
    function close() {
      $uibModalInstance.close();
    }
  },
]);

(function () {
  "use strict";
  webapp.controller('RemindAlarmListModalCtrl',
    ['$scope', '$rootScope', '$stateParams', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm','$uibModalStack',
      function RemindAlarmListModalCtrl($scope, $rootScope, $stateParams, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm, $uibModalStack) {

        var vm = this;

        vm.srch = {
          viewSize : 10
        };

        vm.currentPage = 1;
        vm.maxSize = 10;

        $rootScope.showpopup = {remindAlarm:false};

        function getList() {
          getListCnt();
          
          var data = angular.copy(vm.srch); // 검색 옵션 설정
          data.mapCode= 'RemindAlarm.getRemindAlarmList';

          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.lists = result.body.docs;
            }
          });
        }

        function getListCnt() {
          var data = angular.copy(vm.srch); // 검색 옵션 설정
          data.mapCode = 'RemindAlarm.getRemindAlarmListCnt';
  
          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
  
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.totalItems = result.body.docs;
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.log("error");
            // console.error("Error> getListCnt()");
            // console.table(error);
          });
        }

        function pageChanged() {
          vm.srch.page = vm.currentPage;
          getList();
        }

        function ok() {
          $uibModalInstance.dismiss('update data');
        }

        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        function goDetail(p1, p2) {
          if (p2 == 'TB_BUSINESSOP') {
            $uibModalStack.dismissAll();
            $state.go('app.business.business-op-detail', {
              srch : '',
              KeyId : p1
            });
          } else if (p2 == 'TB_BUSINESSDR') {
            $uibModalStack.dismissAll();
            var ctrl = 'BusinessDrModalCtrl as vc';
            var paramData = { KeyId: p1 };

            var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-dr/business-dr-modal.html', ctrl, paramData);
            modalInstance.result.then(function (okData) {
            }, function (cancelData) {
            });
          }
        }

        function delData() {
          var data = {};

          data.KeyIdList = [];

          vm.lists.forEach(function(item){
            if (item.chkRow) {
              item.KeyId = item.KeyId;
              data.KeyIdList.push(item.KeyId);
            }
          });

          if (data.KeyIdList == null || data.KeyIdList.length == 0) {
            gAlert('', 'Menu.DELETENODATA');
            return false;
          } else {
            gConfirm('', 'Menu.DELETECONFIRM', {
              btn : '',
              fn : function() {
                data.mapCode = "RemindAlarm.updateRemindAlarmReadYN";
                postApi.update(data, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    gAlert('', "삭제되었습니다.", {
                      btn : '',
                      fn : function() {
                        $uibModalInstance.close();
                      }
                    });
                  }
                });

              }
            }, {
              btn : '',
              fn : function() {
              }
            });
          }
        }

        function setData() {
          var data = {};

          data.KeyIdList = [];

          vm.lists.forEach(function(item){
            if (item.chkRow) {
              item.KeyId = item.KeyId;
              data.KeyIdList.push(item.KeyId);
            }
          });

          if (data.KeyIdList == null || data.KeyIdList.length == 0) {
            gAlert('', '완료할 항목을 선택해 주세요.');
            return false;
          } else {
            gConfirm('', '완료하시겠습니까?', {
              btn : '',
              fn : function() {
                data.mapCode = "RemindAlarm.updateRemindAlarmDoneYN";
                postApi.update(data, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    gAlert('', "완료되었습니다.", {
                      btn : '',
                      fn : function() {
                        $uibModalInstance.close();
                      }
                    });
                  }
                });

              }
            }, {
              btn : '',
              fn : function() {
              }
            });
          }
        }

        // 팝업 쿠키 생성
        function fnSetCookie(name, value, expiredays) {
          var d = new Date();
          d.setTime(d.getTime() + (expiredays*24*60*60*1000));
          var expires = "expires="+ d.toUTCString();
          document.cookie = name + "=" + value + ";" + expires  + ";path=/";
       }

        // 팝업 오늘 하루 그만보기
        vm.closePopupToday = function(id) { 
          fnSetCookie("remindAlarm", 'hide', 1);

          cancel();
        };

        function init() {
          // 목록 체크박스 로직 설정
          vm.chkHead = false;
          $scope.chkRowChg = function () {
            for (var i = 0; i < vm.lists.length; i++) {
              if (!vm.lists[i].isChecked) {
                vm.chkHead = false;
                return;
              }
            }
            vm.chkHead = true;
          };

          $scope.chkHeadChg = function () {
            for (var i = 0; i < vm.lists.length; i++) {
              vm.lists[i].chkRow = vm.chkHead;
            }
          };

          getList();
        }


        vm.ok = ok;
        vm.cancel = cancel;

        vm.goDetail = goDetail;
        vm.delData = delData;
        vm.setData = setData;

        vm.getList = getList;
        vm.pageChanged = pageChanged;
        
        vm.fnSetCookie = fnSetCookie;

        vm.init = init;

        init();

      }]);
})();


webapp.controller('UnitCounselModalCtrl', [
  '$window',
  '$scope',
  '$state',
  '$cookies',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'ModalAPISrv',
  'gAlert',
  'postApi',
  function UnitCounselModalCtrl(
    $window,
    $scope,
    $state,
    $cookies,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    modalFactory,
    api,
    gAlert,
    postApi
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'unit-counsel-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    // 함수 연결
    vm.getUnitCounselList = getUnitCounselList;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.cancel = cancel;
    vm.todayClose = todayClose;

    (function UnitCounselModalCtrl() {
      vm.CounselDateFrom = null;
      vm.CounselDateTo = null;
    })();

    // 검색 조건
    /*vm.srch = {
        TenantId : $window.sessionStorage['loginTenantId'],
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CounselDateFrom : null,
        CounselDateTo : null,
      };*/

    function getRequestParams() {
      var req = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        CounselDateFrom: vm.CounselDateFrom,
        CounselDateTo: vm.CounselDateTo,
      };
      return req;
    }

    // 부대별 상담현황 조회
    function getUnitCounselList() {
      var param = getRequestParams();
      param.mapCode = 'Unitclass.getUnitList';

      postApi.select(
        param,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.listUnit = data.body.docs;

              // 셀병합 관련
              for (var i = 0; i < vm.listUnit.length; i++) {
                vm.listUnit[i].Gubun1_rowspan = 1;
                vm.listUnit[i].Gubun1_colspan = 1;
                vm.listUnit[i].Gubun1_show = true;
                vm.listUnit[i].Gubun2_show = true;
                vm.listUnit[i].Goal_rowspan = 1;
                vm.listUnit[i].Goal_show = true;
                vm.listUnit[i].ProgressRate_rowspan = 1;
                vm.listUnit[i].ProgressRate_show = true;
              }

              for (var i = 0; i < vm.listUnit.length; i++) {
                if (i == 0) {
                  vm.listUnit[i].Gubun1_colspan = 2;
                  vm.listUnit[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listUnit.length; j++) {
                  if (vm.listUnit[i].Gubun1 == vm.listUnit[j].Gubun1) {
                    vm.listUnit[i].Gubun1_rowspan += 1;
                    vm.listUnit[j].Gubun1_show = false;

                    if (j == vm.listUnit.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listUnit = {};
            }
          } else {
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-UnitCounselList', status, data);
        }
      );

      /*  var prms = api.doUnitCounselList().post(getRequestParams()).$promise;

      prms.then(
        function (data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs.length > 0) {
              vm.listUnit = data.responseVO.body.docs;

              console.log('vm.listUnit.length : ' + vm.listUnit.length);
              // 셀병합 관련
              for (var i = 0; i < vm.listUnit.length; i++) {
                vm.listUnit[i].Gubun1_rowspan = 1;
                vm.listUnit[i].Gubun1_colspan = 1;
                vm.listUnit[i].Gubun1_show = true;
                vm.listUnit[i].Gubun2_show = true;
                vm.listUnit[i].Goal_rowspan = 1;
                vm.listUnit[i].Goal_show = true;
                vm.listUnit[i].ProgressRate_rowspan = 1;
                vm.listUnit[i].ProgressRate_show = true;
              }

              for (var i = 0; i < vm.listUnit.length; i++) {
                if (i == 0) {
                  vm.listUnit[i].Gubun1_colspan = 2;
                  vm.listUnit[i].Gubun2_show = false;
                }

                for (var j = i + 1; j < vm.listUnit.length; j++) {
                  if (vm.listUnit[i].Gubun1 == vm.listUnit[j].Gubun1) {
                    vm.listUnit[i].Gubun1_rowspan += 1;
                    vm.listUnit[j].Gubun1_show = false;

                    if (j == vm.listUnit.length - 1) {
                      i = j - 1;
                    }
                  } else {
                    i = j - 1;
                    break;
                  }
                }
              }
            } else {
              vm.listUnit = {};
            }
          } else {
          }
        },
        function (error) {
          console.error('Error-UnitCounselList', status, data);
        }
      ); */
    }

    function getSearch() {
      if (vm.CounselDateFrom == null && vm.CounselDateTo != null) {
        return false;
      } else if (vm.CounselDateFrom != null && vm.CounselDateTo == null) {
        return false;
      } else if (vm.CounselDateFrom == null && vm.CounselDateTo == null) {
        getUnitCounselList();
      } else {
        if (
          getDateToNumber(vm.CounselDateFrom) >
          getDateToNumber(vm.CounselDateTo)
        ) {
          gAlert('', '상담등록일의 날짜범위가 잘못되었습니다.');
          return false;
        } else {
          getUnitCounselList();
        }
      }
    }

    // 오늘 그만보기
    function todayClose() {
      var param = getRequestParams();
      param.mapCode = 'User.updateCloseToday';
      postApi.update(
        param,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            return;
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (error) {
          console.log("error");
          // console.error('Error-todayClose', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );

      /*  var prms = null;

      prms = api.doUpdateCloseToday().post(getRequestParams()).$promise;

      prms.then(
        function (data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            return;
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        },
        function (error) {
          console.error('Error-todayClose', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }
      ); */

      $uibModalInstance.close();
    }

    function goDetail() {
      $state.go('app.state.unitclass');
      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 데이터 조회
    getUnitCounselList();
  },
]);

(function() {
  "use strict";

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  StatesController.$inject = [];
  /** @ngInject */
  function StatesController() {}

  webapp.component("stats", {
    templateUrl: "app/dashboard/stats/stats.html",
    controller: StatesController,
    controllerAs: "states",
    bindings: {
      model: "=",
      comments: "@",
      number: "@",
      name: "@",
      colour: "@",
      details: "@",
      type: "@",
      goto: "@"
    }
  });
})();

webapp.controller('ApplyTypeModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$http',
  'gAlert',
  'toModalData',
  function ApplyTypeModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $http,
    gAlert,
    toModalData
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringapply-list-modal',$window.sessionStorage['loginUserType'])) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getMentoringApplyArmyList = getMentoringApplyArmyList;
    vm.getMentoringApplyArmyListCnt = getMentoringApplyArmyListCnt;

    (function ApplyTypeModalCtrl() {
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'MemberNm',
          optionName: '성명',
        },
        {
          optionId: 'ArmyNo',
          optionName: '군번',
        },
      ];
      vm.changeViewSize = changeViewSize;
      
      vm.MentoringApplyArmyList = [];
      vm.paramData = toModalData;
      vm.searchFieldType = vm.paramData.searchType;
      vm.searchValue = vm.paramData.searchValue;
      getMentoringApplyArmyList();
    })();
    function changeViewSize() {
      getMentoringApplyArmyList();
    }

    function getMentoringApplyArmyList() {
      vm.MentoringApplyArmyList = [];
      if (isNullOrEmpty(vm.searchFieldType) || isNullOrEmpty(vm.searchValue)) {
        gAlert('', '조회된 정보가 없습니다.');
        vm.MentoringApplyArmyList = null;
        vm.totalCount = 0;
        return false;
      }

      var srch = {
        mapCode: 'MentoringApplyArmy.getArmyInfoSearching',
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchValue: vm.searchValue,
        searchType: vm.searchFieldType,
      };

      postApi.select(
        srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              vm.MentoringApplyArmyList = null;
              gAlert('', '조회된 정보가 없습니다.');
            } else  {
              var resultData = postApi.makeResultData(data);
              vm.MentoringApplyArmyList = resultData.body.docs;
              if (data.body.docCnt === 1) {
                ok(vm.MentoringApplyArmyList[0]);
              } else {
                getMentoringApplyArmyListCnt();
              }
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );
      vm.dataloader = false;
    }

    function getMentoringApplyArmyListCnt() {
      var srch = {
        mapCode: 'MentoringApplyArmy.getArmyInfoSearchingCnt',
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchValue: vm.searchValue,
        searchType: vm.searchFieldType,
      };

      postApi.select(
        srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              vm.MentoringApplyArmyList = null;
              vm.totalCount = 0;
              gAlert('', '조회된 정보가 없습니다.');
            } else {
              var resultData = postApi.makeResultData(data);
              vm.totalCount = resultData.body.docs[0];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDataCnt' + data.body.docs[0].errMessage);
        }
      );
      vm.dataloader = false;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(ApplyArmy) {
      $uibModalInstance.close(ApplyArmy);
    }
  },
]);

webapp.controller('ClubNameModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$http',
  'gAlert',
  function ClubNameModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $http,
    gAlert
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringclub-list-modal',$window.sessionStorage['loginUserType'])) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getMentoringClubList = getMentoringClubList;
    vm.getMentoringClubListCnt = getMentoringClubListCnt;

    (function ClubNameModalCtrl() {
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      vm.changeViewSize = changeViewSize;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'ClubNm',
          optionName: '동아리팀',
        },
      ];
      
      vm.MentoringClubList = [];
      vm.paramData = toModalData;
      vm.searchValue = vm.paramData.searchValue;
      vm.searchFrom = vm.paramData.searchFrom;
      vm.searchFieldType = 'ClubNm';
      getMentoringClubList();
    })();

    function changeViewSize() {
      getMentoringClubList();
    }

    function getMentoringClubList() {
      vm.MentoringClubList = [];
      /*
      if (isNullOrEmpty(vm.searchValue)) {
        gAlert('', '조회된 정보가 없습니다.');
        vm.MentoringClubList = null;
        vm.totalCount = 0;
        return false;
      }
      */

      var srch = {
        mapCode: 'MentoringClub.getClubInfoSearching',
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchValue: vm.searchValue,
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      srch.mapCode = vm.searchFrom != 'prtcp-edit' ? 'MentoringClub.getPrtcpClubList' : srch.mapCode;

      postApi.select(
        srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              vm.MentoringClubList = null;
              gAlert('', '조회된 정보가 없습니다.');
            } else  {
              var resultData = postApi.makeResultData(data);
              vm.MentoringClubList = resultData.body.docs;
              if (data.body.docCnt === 1) {
                ok(vm.MentoringClubList[0]);
              } else {
                getMentoringClubListCnt();
              }
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getData' + data.body.docs[0].errMessage);
        }
      );
      vm.dataloader = false;
    }

    function getMentoringClubListCnt() {
      var srch = {
        mapCode: 'MentoringClub.getClubInfoSearchingCnt',
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchValue: vm.searchValue,
      };

      srch.mapCode = vm.searchFrom != 'prtcp-edit' ? 'MentoringClub.getPrtcpClubListCnt' : srch.mapCode;

      postApi.select(
        srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              vm.MentoringClubList = null;
              vm.totalCount = 0;
              gAlert('', '조회된 정보가 없습니다.');
            } else {
              var resultData = postApi.makeResultData(data);
              vm.totalCount = resultData.body.docs[0];
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDataCnt' + data.body.docs[0].errMessage);
        }
      );
      vm.dataloader = false;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(Club) {
      $uibModalInstance.close(Club);
    }
  },
]);

(function () {
  webapp.controller('MentoringrecordPrintModalCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'modalFactory',
    'postApi',
    'gAlert',
    'gConfirm',
    'modalFactory',
    function MentoringrecordPrintModalCtrl(
      $window,
      $rootScope,
      $scope,
      $location,
      $state,
      $stateParams,
      CONSTANT,
      StaticVariable,
      modalWindow,
      postApi,
      gAlert,
      gConfirm,
      modalFactory
    ) {
      var vm = this;
      vm.dataloader = false;

      vm.print = print;
      vm.cancel = cancel;

      // 조회 데이터
      vm.data = {};
      vm.uploadFileList = [];
      if (isNullOrEmpty($stateParams.RecordId)) {
        gAlert('', '잘못된 접근입니다.', {
          fn: function () {
            cancel();
          },
        });
      }

      vm.srch = {
        RecordId: $stateParams.RecordId,
        TenantId: $window.sessionStorage['loginTenantId'],
        TableNm: 'MentoringRecord',
        IdName: 'RecordId',
        uploadFileList: [],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      function init() {
        vm.srch.mapCode = 'MentoringRecord.getMentoringRecordDetail';
  
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].RecordId !== null) {
                vm.data = data.body.docs[0];
                
                var uploadFileList = [];
                angular.forEach(vm.data.uploadFileList, function (item) {
                  var obj = {
                    id: item.fileId,
                    isLoaded: true,
                    link: StaticVariable.getUrl(
                      '/attach/file/' + item.PhysicalFileNm +
                      '/download.do?path=' + item.PhysicalPath +
                      '&fileName=' + item.LogicalFileNm +
                      '&userkey=' + $rootScope.gVariable.userkey
                    ),
                    fileName: item.LogicalFileNm,
                    size: item.FileSize,
                    fileKey: item.PhysicalFileNm,
                    path: item.PhysicalPath,
                    downloadCnt: item.DownloadCnt,
                  };
                  uploadFileList.push(obj);
                });
                angular.copy(uploadFileList, vm.data.uploadFileList);
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.error('fail', status, data);
            console.log('Error> mentoringrecordDetailCtrl> getData> ', data.body.docs[0].errMessage);
          }
        );
      }

      function print() {
        window.print();
      }

      function cancel() {
        window.close();
      }
      init();
    },
  ]);
})();

webapp.controller('MentoringScheduleModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  'gAlert',
  'gConfirm',
  'modalFactory',
  function MentoringScheduleModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    gAlert,
    gConfirm,
    modalFactory
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringschedule-edit-modal',$window.sessionStorage['loginUserType'])
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    // 공통코드
    vm.FromHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : new moment().format('HH')*/
    };
    vm.FromMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      /*Value : '00'*/
    };

    /*
    vm.ToHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      // Value : new moment().format('HH')
    };
    vm.ToMinList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
      // Value : '00'
    };*/

    // 함수 선언
    vm.showModalClubInfo = showModalClubInfo;
    vm.clearModalClubInfo = clearModalClubInfo;
    vm.showModalUser = showModalUser;
    vm.clearModalUser = clearModalUser;

    vm.getData = getData;
    vm.deleteData = deleteData;

    vm.del = del;
    vm.ok = ok;
    vm.cancel = cancel;

    // 조회 데이터
    /*      vm.data = {
        SchId: toModalData.SchId,
        CustArmyId: '',
        CustNm: '',
        SchUserId: $window.sessionStorage['loginUserIdx'],
        SchUserId_: $window.sessionStorage['loginUserName'],
        StartYMD: toModalData.BaseDate,
        StartHour: new moment().format('HH'),
        StartMin: '00',
        EndYMD: toModalData.BaseDate,
        EndHour: new moment().format('HH'),
        EndMin: '00',
        Title: ''
      };
      vm.data.oldStartYMD = "";*/

    vm.data = {
      SchId: toModalData.SchId,
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    if (toModalData.SchId == 0) {
      vm.data = {
        SchId: toModalData.SchId,
        ClubId: '',
        ClubNm: '',
        MentoUser: $window.sessionStorage['loginUserIdx'],
        MentoUser_: $window.sessionStorage['loginUserName'],
        StartYMD: toModalData.BaseDate,
        /*StartHour: new moment().format('HH'),
          StartMin: '00',*/
        // EndYMD: toModalData.BaseDate,
        /*EndHour: new moment().format('HH'),
          EndMin: '00',*/
        // Title: '',
      };

      vm.FromHourList.Code = '00';
      vm.FromMinList.Code = '00';
      // vm.ToHourList.Code = '00';
      // vm.ToMinList.Code = '00';

      vm.data.StartHour = '00';
      vm.data.StartMin = '00';
      // vm.data.EndHour = '00';
      // vm.data.EndMin = '00';
    }

    /**
     * Constructor
     *
     * @param
     * @return
     */
    (function ScheduleModalCtrl() {
      // 시작일, 종료일 지정
      $scope.dtFromDate = moment(toModalData.BaseDate).toDate();
      // $scope.dtToDate = moment(toModalData.BaseDate).toDate();

      // 데이터 조회
      if (vm.data.SchId != '') getData();
    })();

    /**
     * 고객 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalClubInfo() {
      var paramData = {
        searchValue: vm.data.ClubNm,
        searchFrom: 'mentoringschedule-modal',
      };

      var modalInstance = modalFactory.open(
        'modal',
        'app/mentoring/modal/club-name-modal.html',
        'ClubNameModalCtrl as modalCtrl',
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.ClubNm = okData.ClubNm;
          vm.data.ClubId = okData.ClubId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 고객 초기화
     *
     * @param
     * @return
     */
    function clearModalClubInfo() {
      vm.data.ClubNm = '';
      vm.data.ClubId = '';
    }

    /**
     * 상담사 검색 팝업 호출
     *
     * @param
     * @return
     */
    function showModalUser() {
      var ctrl = 'User2ModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/user2-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          vm.data.MentoUser_ = okData.UserNm;
          vm.data.MentoUser = okData.UserId;
        },
        function (cancelData) {}
      );
    }

    /**
     * 상담사 초기화
     *
     * @param
     * @return
     */
    function clearModalUser() {
      vm.data.MentoUser_ = '';
      vm.data.MentoUser = '';
    }

    /**
     * 시작일시 Callback
     *
     * @param
     * @return
     */
    vm.onSelectFromList = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.StartHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.StartMin = data.Code;
      }
    };

    /**
     * 종료일시 Callback
     *
     * @param
     * @return
     */
    /*
    vm.onSelectToList = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.EndHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.EndMin = data.Code;
      }
    };
    */

    /**
     * 데이터 조회
     *
     * @param
     * @return
     */
    function getData() {
      vm.data.mapCode = 'MentoringSchedule.getScheduleDetail';

      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            // 조회 데이터
            vm.data = data.body.docs[0];

            // 시작일시 지정
            $scope.dtFromDate = moment(vm.data.StartYMD).toDate();
            vm.FromHourList.Code = vm.data.StartHour;
            vm.FromMinList.Code = vm.data.StartMin;

            // 종료일시 지정
            // $scope.dtToDate = moment(vm.data.EndYMD).toDate();
            // vm.ToHourList.Code = vm.data.EndHour;
            // vm.ToMinList.Code = vm.data.EndMin;

            return;
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error> MentoringSchedule-Modal-ctrl> getData()', status, error);
        }
      );
    }

    // 유효성검사
    function chkValid() {
      // 필수입력 체크
      if (
        typeof vm.data.ClubId == 'undefined' ||
        vm.data.ClubId == ''
      ) {
        gAlert('', '동아리팀을 선택해 주십시오.');
        return false;
      }
      if (
        typeof vm.data.MentoUser_ == 'undefined' ||
        vm.data.MentoUser_ == ''
      ) {
        gAlert('', '멘토를 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartYMD == 'undefined' || vm.data.StartYMD == '') {
        gAlert('', '시작 일자를 입력해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartHour == 'undefined') {
        gAlert('', '시작 시간을 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.StartMin == 'undefined') {
        gAlert('', '시작 분을 선택해 주십시오.');
        return false;
      }
      /*
      if (typeof vm.data.EndYMD == 'undefined' || vm.data.EndYMD == '') {
        gAlert('', '종료 일자를 입력해 주십시오.');
        return false;
      }
      if (typeof vm.data.EndHour == 'undefined') {
        gAlert('', '종료 시간을 선택해 주십시오.');
        return false;
      }
      if (typeof vm.data.EndMin == 'undefined') {
        gAlert('', '종료 분을 선택해 주십시오.');
        return false;
      }*/

      /*  if (getDateToNumber(vm.data.StartYMD + vm.data.StartHour + vm.data.StartMin) > getDateToNumber(vm.data.EndYMD + vm.data.EndHour + vm.data.EndMin)) {          
          gAlert('', '시작일 종료일의 날짜범위가 잘못되었습니다.');
          return false;
        }*/

      /*if (vm.data.oldStartYMD == "") { // 신규
          if (typeof(vm.data.StartYMD) != "undefined" && vm.data.StartYMD != "") {
            if (getDateToNumber(vm.data.StartYMD) <  getDateToNumber(getTodayAddDay(3))) {
              alert('시작일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }
        else { // 수정
          if (typeof(vm.data.StartYMD) != "undefined" && vm.data.StartYMD != "") {
            if (vm.data.oldStartYMD != vm.data.StartYMD && getDateToNumber(vm.data.StartYMD) <  getDateToNumber(getTodayAddDay(3))) {
              alert('시작일은 과거일자 또는 오늘 포함 3일 이내의 일자는 입력할 수 없습니다.');
              return false;
            }
          }
        }*/

      return true;
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {
      if (!chkValid()) return false;

      // 하이픈 제거
      vm.data.StartYMD = moment(vm.data.StartYMD).format('YYYYMMDD');
      vm.data.EndYMD = moment(vm.data.EndYMD).format('YYYYMMDD');

      var successCallback = function (data) {
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = data.body.docs[0];

          gAlert('', '저장 되었습니다.');

          $uibModalInstance.close(vm.data);

          return true;
        }
      };

      var errorCallback = function (error) {
        gAlert('', '저장을 실패했습니다.');

        console.log("error");
        // console.error('Error> MentoringSchedule-Modal-ctrl> setData()', status, error);

        return false;
      };

      if (vm.data.SchId == '') {
        // 등록
        vm.data.mapCode = 'MentoringSchedule.insertSchedule';
        postApi.insert(vm.data, successCallback, errorCallback);
      } else {
        // 수정
        vm.data.mapCode = 'MentoringSchedule.updateScheduleBatch';
        postApi.update(vm.data, successCallback, errorCallback);
      }
    }

    /**
     * 데이터 삭제
     *
     * @param
     * @return
     */
    function deleteData() {
      vm.data.mapCode = 'MentoringSchedule.deleteSchedule';

      postApi.delete(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '삭제 되었습니다.');

            $uibModalInstance.close(vm.data);

            return true;
          }
        },
        function (error) {
          gAlert('', '삭제를 실패했습니다.');
          
          console.log("error");
          // console.error(
          //   'Error> MentoringSchedule-Modal-ctrl> deleteData()',
          //   status,
          //   error
          // );

          return false;
        }
      );
    }

    /**
     * 삭제
     *
     * @param
     * @return
     */
    function del() {
      // 데이터 삭제
      gConfirm(
        '',
        '삭제 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            deleteData();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    /**
     * 저장
     *
     * @param
     * @return
     */
    function ok() {
      // 데이터 저장
      gConfirm(
        '',
        '저장 하시겠습니까?',
        {
          btn: '',
          fn: function () {
            setData();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    /**
     * 닫기
     *
     * @param
     * @return
     */
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }
  },
]);

webapp.controller('MentoringStateListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$http',
    '$timeout',
    function MentoringStateListCtrl(
      $window,
      $scope,
      $location,
      $state,
      $stateParams,
      $rootScope,
      CONSTANT,
      modalFactory,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $http,
      $timeout
    ) {
      var vm = this;
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringstate-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');
      // console.log('loginUserType === ', $window.sessionStorage['loginUserType']);
      // 버튼 권한 체크
      $scope.showBtnExcel = true;
      vm.dataloader = false;
      vm.disabledArea = false;
  
      // 함수연결
      vm.showModalMentoUser = showModalMentoUser;
      vm.clearModalMentoUser = clearModalMentoUser;
      vm.getExcel = getExcel;
      vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
  
      // 검색 조건
      vm.srch = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        TenantNm: $window.sessionStorage['loginTenantName'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };
  
      // 데이터
      vm.data = {};
  
      // 페이징
      if ($stateParams.page === undefined || $stateParams.page === '') {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }
  
      vm.listSize = [10, 25, 50, 100];
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.viewSize = vm.viewSize;

      // 공통코드 정의
      vm.ArmyClassList = { // 계급
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1000',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ArmyTypeList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1010',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
        MentoringArea: '',
      };
      vm.ItemFieldList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1390',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ProgressList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1400',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ContestList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1410',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
  
      vm.onSelectCallback = function (data) {
        if (data.Code == null) data.Code = '';
  
        if (data.CodeType == '1000') {
          vm.srch.ArmyClass = data.Code;
        } else if (data.CodeType == '1390') {
          vm.srch.ItemField = data.Code;
        } else if (data.CodeType == '1400') {
          vm.srch.Progress = data.Code;
        }
      };
  
      vm.PermStat1List = {
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      vm.onMentoringAreaListSelected = function () {
        var data = vm.srch.MentoringAreaObj;
  
        if (data == null) {
          vm.srch.MentoringArea = '';
          vm.PermStat1List.MentoringArea = '';
          vm.ArmyTypeList.MentoringArea = '';
          return;
        }
        vm.srch.MentoringArea = data.Code;
  
        vm.PermStat1List.MentoringArea = data.Code;
        vm.ArmyTypeList.MentoringArea = data.Code;
      };
  
      vm.onArmyTypeListSelected = function (data) {
        vm.PermStat1List.CodeType = '1380';
        vm.PermStat1List.ParentCommonCodeId = '';
  
        if (data == null) {
          vm.srch.ArmyType = '';
          return;
        }

        vm.srch.ArmyType = data.Code;
        vm.srch.MentoringAreaType = data.Code;
        vm.PermStat1List.ParentCommonCodeId = vm.srch.MentoringAreaType;
  
        if (data.Code == null) data.Code = '';
      };
  
      vm.onPermStat1ListSelected = function (data) {
  
        if (data == null) {
          vm.srch.PermStat1 = '';
          return;
        }
  
        vm.srch.PermStat1 = data.Code;
        vm.srch.PermStat2 = '';
      };

      // 엑셀 정보
      vm.excel = {
        downFileName: 'mentoringstatelist',
        subject: '멘토링 참여자 현황',
        /*header : [ {
            field : 'FreeBoardId',
            title : '번호',
            width : '5',
            format : 'number'
          }, {          
            field : 'ReadCnt',
            title : '조회수',
            width : '5',
            format : 'string'
          } ],*/
      };

      function getTenantAreaList() {
        vm.srch.mapCode = 'Business.getTenantArea';
        postApi.select(
          vm.srch,
          function (data) {
            var resultData = postApi.makeResultData(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (resultData.body.docs[0] != null) {
                var areaList = resultData.body.docs[0].TenantArea.split(',');
                vm.MentoringAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                if (vm.MentoringAreaList.length === 1) {
                  vm.srch.MentoringAreaObj = vm.MentoringAreaList[0];
                  vm.srch.MentoringArea = vm.srch.MentoringAreaObj.Code;
                }
              } else {
                vm.srch.MentoringAreaList = [];
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-setData' + data.body.docs[0].errMessage);
          }
        );
      }
  
      // 목록 조회
      function getList() {

        vm.dataloader = true;
        vm.srch.page = vm.currentPage;
        getTenantAreaList();
        getListCount();

        $window.sessionStorage.setItem('mentoringstate-list-ctrl', angular.toJson(vm.srch));
        vm.srch.mapCode = 'MentoringState.getMentoringStateList';

        postApi.select(
            vm.srch,
            function (data) {
              if (data.header.status === CONSTANT.HttpStatus.OK) {
                if (data.body.docCnt === 0) {
                  vm.lists = null;
                  gAlert('', '조회된 정보가 없습니다.');
                } else {
                  var resultData = postApi.makeResultData(data);
                  vm.lists = resultData.body.docs;
                }
              }
            },
            function (data) {
              console.log("error");
              // console.error('Error-getData' + data.body.docs[0].errMessage);
            }
        );
        vm.dataloader = false;
      }
  
      // 목록카운트 조회
      function getListCount() {
        vm.srch.mapCode = 'MentoringState.getMentoringStateListCnt';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.totalItems = data.body.docs[0];
              } else {
                vm.totalItems = 0;
                vm.lists = {};
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getData' + data.body.docs[0].errMessage);
          }
        );
      }

      // 모달팝업 호출 (멘토)
      function showModalMentoUser() {
        var ctrl = 'User2ModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/user2-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            vm.srch.MentoUser_ = okData.UserNm;
            vm.srch.MentoUser = okData.UserId;
          },
          function (cancelData) {}
        );
      }
  
      // 모달팝업 데이터 삭제 (멘토)
      function clearModalMentoUser() {
        vm.srch.MentoUser_ = '';
        vm.srch.MentoUser = '';
      }
  
      // 페이징 관련
      function pageChanged() {
        getList();
      }
  
      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }
  
      function setDownloadHistory(DownloadReason) {
        var log = {};
  
        log.DownloadIP = $window.sessionStorage['loginIP'];
        log.DownloadReason = DownloadReason;
        log.ScreenNm = '멘토링참여자현황';
        log.ScreenUrl = 'app/mentoring/state-list';
  
        log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
        postApi.insert(log, function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              getExcel();
            }
          }
        });
      }
  
      // 모달팝업 호출 (다운로드사유)
      function showModalDownloadReason() {
        var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            setDownloadHistory(okData);
          },
          function (cancelData) {}
        );
      }
  
      // 엑셀 다운로드 체크여부 조회
      function getExcelDownloadCheckYn() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
  
        postApi.select(
          vm.srch,
          function (data) {
            //console.log("DownloadCheckYn", data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.DownloadCheckYn = data.body.docs;
                if (vm.DownloadCheckYn == 'Y') {
                  showModalDownloadReason();
                } else {
                  setDownloadHistory('');
                }
              } else {
                console.info('else ');
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getDownloadCheckYn', status, data);
          }
        );
      }
    
      // 엑셀 다운로드
      function getExcel() {
        if (vm.lists.length == undefined) {
          gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
          return;
        }
  
        if (vm.lists.length == 0) {
          gAlert('', '데이터가 없습니다.');
          return;
        }
  
        var header = [];
        var a = document.createElement('a');
        document.body.appendChild(a);
        var strFormat = 'string';
        var strWidth = '20';
        var numFormat = 'number2';
        var numWidth = '20';
  
        //헤더 설정..공통사용 불가
        obj = {};
        obj.title = '신청일시';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ApplyDate';
        header.push(obj);

        obj = {};
        obj.title = '년도/차수';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'YearNum';
        header.push(obj);

        obj = {};
        obj.title = '동아리팀';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubNm';
        header.push(obj);

        obj = {};
        obj.title = '팀장/팀원';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ClubRole_';
        header.push(obj);

        obj = {};
        obj.title = '성명';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyNm';
        header.push(obj);

        obj = {};
        obj.title = '계급';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyClass_';
        header.push(obj);

        obj = {};
        obj.title = '소속(사·여단급)';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'PermStat';
        header.push(obj);

        obj = {};
        obj.title = '군번';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyNo';
        header.push(obj);

        obj = {};
        obj.title = '임관일';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'InArmyDate';
        header.push(obj);

        obj = {};
        obj.title = '복무기간';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ArmyTerm';
        header.push(obj);

        obj = {};
        obj.title = '전역일';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'OutArmyDate';
        header.push(obj);

        obj = {};
        obj.title = '복무구분';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'TermGubun';
        header.push(obj);

        obj = {};
        obj.title = '권역';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoringArea';
        header.push(obj);

        obj = {};
        obj.title = '멘토';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoUser_';
        header.push(obj);

        obj = {};
        obj.title = '아이템';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ItemField_';
        header.push(obj);

        obj = {};
        obj.title = '연령';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Age';
        header.push(obj);

        obj = {};
        obj.title = '성별';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Sex';
        header.push(obj);

        obj = {};
        obj.title = '연락처';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Mobile';
        header.push(obj);

        obj = {};
        obj.title = '생년월일';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'ResRegNo';
        header.push(obj);

        obj = {};
        obj.title = '병과';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Spec_';
        header.push(obj);

        obj = {};
        obj.title = '이메일';
        obj.format = strFormat;
        obj.width = 40;
        obj.field = 'Email';
        header.push(obj);

        obj = {};
        obj.title = '최종학교';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'SchNm';
        header.push(obj);

        obj = {};
        obj.title = '전공';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MajorName';
        header.push(obj);

        obj = {};
        obj.title = '주소';
        obj.format = strFormat;
        obj.width = 40;
        obj.field = 'Addr';
        header.push(obj);

        obj = {};
        obj.title = '학교소재지';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'SchLoc_';
        header.push(obj);

        obj = {};
        obj.title = '진행상태';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'Progress_';
        header.push(obj);

        obj = {};
        obj.title = '상담회차';
        obj.format = strFormat;
        obj.width = strWidth;
        obj.field = 'MentoringRound';
        header.push(obj);

        obj = {};
        obj.title = '창업경진대회';
        obj.format = strFormat;
        obj.width = 40;
        obj.field = 'Contest_';
        header.push(obj);
        // 헤더설정 End
  
        vm.srch.header = header;
        vm.srch.downFileName = '멘토링 참여자 현황';
        vm.srch.ext = 'motisystem';
  
        vm.srch.userkey = $rootScope.gVariable.userKey;
  
        $http({
          url: StaticVariable.getUrl(
            '/excel/MentoringState.getExcelMentoringStateList/action.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: vm.srch, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var fileName = vm.srch.downFileName;
            var blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
            });
            if (window.navigator && window.navigator.msSaveBlob) {
              fileName = fileName + '.xlsx';
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              a.href = objectUrl;
              a.download = fileName;
              a.click();
            }
          })
          .error(function (data, status, headers, config) {
            //download failed
          });
      }
  
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      vm.setSortColumn = function (sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;
  
        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = 'ASC';
        } else {
          vm.srch.sortDirect = vm.srch.sortDirect == 'ASC' ? 'DESC' : 'ASC';
        }
  
        vm.srch.sortColumn = sortColumn;
  
        // 조회
        getList();
      };
  
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      vm.setSortDirect = function (sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }
  
        var rtnval = '';
  
        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      };
  
      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
  
      // 데이터 조회
      getList();
    },
  ]);
  
webapp.controller('MentoringStateSummaryCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    'GLOBAL_CONSTANT',
    'modalFactory',
    'StaticVariable',
    'postApi',
    'gAlert',
    'gConfirm',
    '$http',
    '$timeout',
    function MentoringStateSummaryCtrl(
      $window,
      $scope,
      $location,
      $state,
      $stateParams,
      $rootScope,
      CONSTANT,
      modalFactory,
      StaticVariable,
      postApi,
      gAlert,
      gConfirm,
      $http,
      $timeout
    ) {
      var vm = this;
  
      // 접근 권한 체크
      if (!isPageAccess('mentoringstate-summary', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      // 버튼 권한 체크
      $scope.showBtnExcel = true;
      vm.dataloader = false;
  
      // 함수연결
      vm.getExcel = getExcel;
      vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;
  
      // 검색 조건
      vm.srch = {
        TenantId: $window.sessionStorage['loginTenantId'],
        SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
        TenantNm: $window.sessionStorage['loginTenantName'],
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };

      $scope.dtDate = setNewDate(getToday());
      vm.srch.Date = getToday();

      // 데이터
      vm.data = {};

      // 엑셀 정보
      vm.excel = {
        downFileName: 'mentoringstatesummary',
        subject: '창업멘토링 통계 현황판',
        /*header : [ {
            field : 'FreeBoardId',
            title : '번호',
            width : '5',
            format : 'number'
          }, {          
            field : 'ReadCnt',
            title : '조회수',
            width : '5',
            format : 'string'
          } ],*/
      };

      function getData() {
        getData1();
        getData2();
        getData3();
        getData4();
        getData5();
        getData6();
      }
  
      // 목록1 조회
      function getData1() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary1';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data1 = resultData.body.docs[0];
              } else {
                vm.totalItems = 0;
                vm.data1 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 목록2 조회
      function getData2() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary2';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data2 = resultData.body.docs;
              } else {
                vm.totalItems = 0;
                vm.data2 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 목록3 조회
      function getData3() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary3';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data3 = resultData.body.docs[0];

                vm.data3.EndRatioArmy = vm.data3.EndArmy > 0 ? (vm.data3.EndArmy / vm.data3.GoalArmy * 100).toFixed(2) : 0;
                vm.data3.EndRatioNavy = vm.data3.EndNavy > 0 ? (vm.data3.EndNavy / vm.data3.GoalNavy * 100).toFixed(2) : 0;
                vm.data3.EndRatioAirforce = vm.data3.EndAirforce > 0 ? (vm.data3.EndAirforce / vm.data3.GoalAirforce * 100).toFixed(2) : 0;
                vm.data3.EndRatioMarine = vm.data3.EndMarine > 0 ? (vm.data3.EndMarine / vm.data3.GoalMarine * 100).toFixed(2) : 0;

                vm.data3.PrtcpRatioArmy = vm.data3.EndArmy+vm.data3.IngArmy > 0 ? ((vm.data3.EndArmy+vm.data3.IngArmy) / vm.data3.GoalArmy * 100).toFixed(2) : 0;
                vm.data3.PrtcpRatioNavy = vm.data3.EndNavy+vm.data3.IngNavy> 0 ? ((vm.data3.EndNavy+vm.data3.IngNavy) / vm.data3.GoalNavy * 100).toFixed(2) : 0;
                vm.data3.PrtcpRatioAirforce = vm.data3.EndAirforce+vm.data3.IngAirforce> 0 ? ((vm.data3.EndAirforce+vm.data3.IngAirforce) / vm.data3.GoalAirforce * 100).toFixed(2) : 0;
                vm.data3.PrtcpRatioMarine = vm.data3.EndMarine+vm.data3.IngMarine> 0 ? ((vm.data3.EndMarine+vm.data3.IngMarine) / vm.data3.GoalMarine * 100).toFixed(2) : 0;
              } else {
                vm.totalItems = 0;
                vm.data3 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 목록4 조회
      function getData4() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary4';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data4 = resultData.body.docs;
              } else {
                vm.totalItems = 0;
                vm.data4 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 목록5 조회
      function getData5() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary5';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data5 = resultData.body.docs;
              } else {
                vm.totalItems = 0;
                vm.data5 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 목록6 조회
      function getData6() {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateSummary6';
        postApi.select(
          vm.srch,
          function (data) {
            vm.dataloader = false;
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data6 = resultData.body.docs;
              } else {
                vm.totalItems = 0;
                vm.data6 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      function setDownloadHistory(DownloadReason) {
        var log = {};
  
        log.DownloadIP = $window.sessionStorage['loginIP'];
        log.DownloadReason = DownloadReason;
        log.ScreenNm = '멘토링통계현황판';
        log.ScreenUrl = 'app/mentoring/state/summary';
  
        log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
        postApi.insert(log, function (data) {
          //console.log(data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              getExcel();
            }
          }
        });
      }
  
      // 모달팝업 호출 (다운로드사유)
      function showModalDownloadReason() {
        var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
        var paramData = {};
  
        var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            setDownloadHistory(okData);
          },
          function (cancelData) {}
        );
      }
  
      // 엑셀 다운로드 체크여부 조회
      function getExcelDownloadCheckYn() {
        vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
  
        postApi.select(
          vm.srch,
          function (data) {
            //console.log("DownloadCheckYn", data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                vm.DownloadCheckYn = data.body.docs;
                if (vm.DownloadCheckYn == 'Y') {
                  showModalDownloadReason();
                } else {
                  setDownloadHistory('');
                }
              } else {
                console.info('else ');
              }
            } else {
              console.info('else ');
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error-getDownloadCheckYn', status, data);
          }
        );
      }
    
      // 엑셀 다운로드
      function getExcel() {
        var header = [];
        var a = document.createElement('a');
        document.body.appendChild(a);
  
        vm.srch.header = header;
        vm.srch.downFileName = '창업멘토링 현황판';
        vm.srch.userkey = $rootScope.gVariable.userKey;
  
        $http({
          url: StaticVariable.getUrl(
            '/etcExcel/MentoringStateSummary/action.json?userkey=' + $rootScope.gVariable.userKey
          ),
          method: 'POST',
          data: vm.srch, //this is your json data string
          headers: {
            'Content-type': 'application/json;charset=utf-8;',
          },
          responseType: 'arraybuffer',
        })
          .success(function (data, status, headers, config) {
            var fileName = vm.srch.downFileName;
            var blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
            });
            if (window.navigator && window.navigator.msSaveBlob) {
              fileName = fileName + '.xlsx';
              window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
              var objectUrl = URL.createObjectURL(blob);
              a.href = objectUrl;
              a.download = fileName;
              a.click();
            }
          })
          .error(function (data, status, headers, config) {
            //download failed
          });
      }
  
  
      // 함수 선언
      vm.getData = getData;
  
      // 데이터 조회
      getData();
    },
  ]);
  
webapp.controller('MentoringStateTotalCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'StaticVariable',
  'postApi',
  'gAlert',
  'gConfirm',
  '$http',
  '$timeout',
  function MentoringStateTotalCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    StaticVariable,
    postApi,
    gAlert,
    gConfirm,
    $http,
    $timeout
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('mentoringstate-total', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    vm.dataloader = false;

    // 함수연결
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      TenantNm: $window.sessionStorage['loginTenantName'],
      userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
    };

    var date = new Date();
    var year = date.getFullYear();
    $scope.dtDateFrom = setNewDate(year + '-01-01');
    vm.srch.DateFrom = year + '-01-01';
    $scope.dtDateTo = setNewDate(getToday());
    vm.srch.DateTo = getToday();
    $scope.dtDate = setNewDate(getToday());
    vm.srch.Date = getToday();
    vm.AreaList = [];
    vm.GoalList = [];
    vm.RoundList = [];
    vm.ItemFieldList = [];
    vm.MentoUserList = [];
    vm.YearMonthList = [];
    vm.GoalNum = 0;
    vm.data5_Ratio = 0;

    // 데이터
    vm.data = {};

    // 엑셀 정보
    vm.excel = {
      downFileName: 'mentoringstatetotal',
      subject: '창업멘토링 통계 종합현황',
    };

    function getData() {
      vm.YearMonthList = [];
      var stYear = vm.srch.DateFrom.substr(0,4);
      var edYear = vm.srch.DateTo.substr(0,4);
      var stYearMonth = vm.srch.DateFrom.substr(0,7);
      var edYearMonth = vm.srch.DateTo.substr(0,7);

      for(var i = stYear; i <= edYear; i++) {
        for(var j = 1; j <= 9; j++) {
          var yearMonth = i + '-0' + j;
          if (stYearMonth <= yearMonth && yearMonth <= edYearMonth) {
            vm.YearMonthList.push(yearMonth);
          }
        }
        for(var j = 0; j <= 2; j++) {
          var yearMonth = i + '-1' + j;
          if (stYearMonth <= yearMonth && yearMonth <= edYearMonth) {
            vm.YearMonthList.push(yearMonth);
          }
        }
      }

      // getData7에서 data1_2가 필요하므로 getData1이 완료된 이후 호출
      getData1().then(function() {getData7()});
      getData2();
      getData3();
      getData4();
      getData5();
      getData6();
      getData8();
      getData9();
    }

    function getMentoringArea() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringAreaList';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                angular.forEach(resultData.body.docs, function(area) {
                  vm.GoalNum += area.GoalNum;
                  vm.AreaList.push(area.AreaNm);
                  vm.GoalList.push(area.GoalNum);
                });
                resolve(true);
              } else {
                vm.AreaList = {};
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    function getMentoringRound() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringRoundList';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.RoundList = resultData.body.docs;
                resolve(true);
              } else {
                vm.RoundList = {};
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    function getMentoringItemFieldList() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringItemFieldList';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.ItemFieldList = resultData.body.docs;
                resolve(true);
              } else {
                vm.ItemFieldList = {};
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    function getMentoUserList() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoUserList';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                angular.forEach(vm.AreaList, function(area, idxArea) {
                  vm.MentoUserList[idxArea] = [];
                });
                var resultData = postApi.makeResultData(data);
                angular.forEach(resultData.body.docs, function(rslt) {
                  var idxArea = vm.AreaList.indexOf(rslt.MentoringArea);
                  vm.MentoUserList[idxArea].push(rslt);
                });
                resolve(true);
              } else {
                vm.MentoUserList = [];
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    function getMentoringContestList() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringContestList';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.MentoringContestList = resultData.body.docs;
                resolve(true);
              } else {
                vm.MentoringContestList = [];
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    // 목록1 조회
    function getData1() {
      return new Promise(function (resolve, reject) {
        vm.dataloader = true;
        vm.srch.mapCode = 'MentoringState.getMentoringStateTotal1_1';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data1_1 = resultData.body.docs[0];
              } else {
                vm.data1_1 = {};
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
  
        vm.srch.mapCode = 'MentoringState.getMentoringStateTotal1_2';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt > 0) {
                var resultData = postApi.makeResultData(data);
                vm.data1_2 = resultData.body.docs;
                resolve(true);
                vm.data1_3 = {
                  SumPrtcpCntArmy: 0,
                  SumPrtcpCntNavy: 0,
                  SumPrtcpCntAirforce: 0,
                  SumPrtcpCntMarine: 0,
                  SumPrtcpCntTotal: 0,
                  SumApplyCntArmy: 0,
                  SumApplyCntNavy: 0,
                  SumApplyCntAirforce: 0,
                  SumApplyCntMarine: 0,
                  SumApplyCntTotal: 0,
                };
                angular.forEach(vm.data1_2, function(data) {
                  vm.data1_3.SumPrtcpCntArmy += data.PrtcpCntArmy;
                  vm.data1_3.SumPrtcpCntNavy += data.PrtcpCntNavy;
                  vm.data1_3.SumPrtcpCntAirforce += data.PrtcpCntAirforce;
                  vm.data1_3.SumPrtcpCntMarine += data.PrtcpCntMarine;
                  vm.data1_3.SumPrtcpCntTotal += data.PrtcpCntTotal;
                  vm.data1_3.SumApplyCntArmy += data.ApplyCntArmy;
                  vm.data1_3.SumApplyCntNavy += data.ApplyCntNavy;
                  vm.data1_3.SumApplyCntAirforce += data.ApplyCntAirforce;
                  vm.data1_3.SumApplyCntMarine += data.ApplyCntMarine;
                  vm.data1_3.SumApplyCntTotal += data.ApplyCntTotal;
                });
              } else {
                vm.data1_2 = {};
              }
            } else {
              console.info('else ');
            }
            vm.dataloader = false;
          },
          function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      });
    }

    // 목록2 조회
    function getData2() {
      vm.dataloader = true;
      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal2';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              vm.data2 = resultData.body.docs;
              vm.data2_2 = {
                SumEndCntArmy: 0,
                SumEndCntNavy: 0,
                SumEndCntAirforce: 0,
                SumEndCntMarine: 0,
                SumEndCntTotal: 0,
              };
              angular.forEach(vm.data2, function(data) {
                vm.data2_2.SumEndCntArmy += data.EndCntArmy;
                vm.data2_2.SumEndCntNavy += data.EndCntNavy;
                vm.data2_2.SumEndCntAirforce += data.EndCntAirforce;
                vm.data2_2.SumEndCntMarine += data.EndCntMarine;
                vm.data2_2.SumEndCntTotal += data.EndCntTotal;
              });
            } else {
              vm.data2 = {};
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록3 조회
    function getData3() {
      vm.dataloader = true;
      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal3';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              vm.data3 = resultData.body.docs;
              vm.data3_1 = {
                SumCntArmy: 0,
                SumCntNavy: 0,
                SumCntAirforce: 0,
                SumCntMarine: 0,
                SumCntTotal: 0,
              };
              angular.forEach(vm.data3, function(data) {
                vm.data3_1.SumCntArmy += data.CntArmy;
                vm.data3_1.SumCntNavy += data.CntNavy;
                vm.data3_1.SumCntAirforce += data.CntAirforce;
                vm.data3_1.SumCntMarine += data.CntMarine;
                vm.data3_1.SumCntTotal += data.CntTotal;
              });
            } else {
              vm.data3 = {};
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록4 조회
    function getData4() {
      vm.dataloader = true;
      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal4';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              vm.data4 = resultData.body.docs;
              vm.data4_1 = {
                SumCntTotal: 0,
                SumCntTotal2: 0,
                SumCntTotal4: 0,
                SumCntTotal5: 0,
                SumCntTotal2_1: 0,
                SumCntTotal2_2: 0,
                SumCntTotal2_3: 0,
                SumCntTotal3_1: 0,
                SumCntTotal3_2: 0,
                SumCntTotal3_3: 0,
                SumCntTotal4_1: 0,
                SumCntTotal4_2: 0,
                SumCntTotal4_3: 0,
                SumCntTotal4_4: 0,
                SumCntTotal4_5: 0,
                SumCntTotal5_1: 0,
                SumCntTotal5_2: 0,
                SumCntTotal5_3: 0,
                SumCntTotal5_4: 0,
              };

              angular.forEach(vm.data4, function(data) {
                vm.data4_1.SumCntTotal += data.CntTotal;
                vm.data4_1.SumCntTotal2 += data.CntTotal2;
                vm.data4_1.SumCntTotal4 += data.CntTotal4;
                vm.data4_1.SumCntTotal5 += data.CntTotal5;
                vm.data4_1.SumCntTotal2_1 += data.CntTotal2_1;
                vm.data4_1.SumCntTotal2_2 += data.CntTotal2_2;
                vm.data4_1.SumCntTotal2_3 += data.CntTotal2_3;
                vm.data4_1.SumCntTotal3_1 += data.CntTotal3_1;
                vm.data4_1.SumCntTotal3_2 += data.CntTotal3_2;
                vm.data4_1.SumCntTotal3_3 += data.CntTotal3_3;
                vm.data4_1.SumCntTotal4_1 += data.CntTotal4_1;
                vm.data4_1.SumCntTotal4_2 += data.CntTotal4_2;
                vm.data4_1.SumCntTotal4_3 += data.CntTotal4_3;
                vm.data4_1.SumCntTotal4_4 += data.CntTotal4_4;
                vm.data4_1.SumCntTotal4_5 += data.CntTotal4_5;
                vm.data4_1.SumCntTotal5_1 += data.CntTotal5_1;
                vm.data4_1.SumCntTotal5_2 += data.CntTotal5_2;
                vm.data4_1.SumCntTotal5_3 += data.CntTotal5_3;
                vm.data4_1.SumCntTotal5_4 += data.CntTotal5_4;
              });
            } else {
              vm.data4 = {};
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록 5 조회
    function getData5() {
      vm.dataloader = true;
      vm.data5 = []; // 멘토링 종료 회차별 팀 수, i:권역, j:회차
      vm.data5_ItemField = []; // 멘토링 종료 아이템별 팀 수, i:권역, j:아이템
      vm.data5_YearMonth = []; // 멘토링 종료 월별 현황, i:권역 * 년월, j:년월, k: 회차
      vm.data5_SumYearMonth = []; // 월별 종료팀
      vm.data5_SumCntMemberYM = []; // 월별 종료인원
      vm.data5_SumCntMemberArea = []; // 권역별 종료인원
      vm.data5_SumCntMemberTotal = 0; // 전체 종료인원

      angular.forEach(vm.AreaList, function(area, idxArea) {
        vm.data5[idxArea] = [];
        vm.data5_ItemField[idxArea] = [];
        vm.data5_YearMonth[idxArea] = [];
        vm.data5_SumYearMonth[idxArea] = [];
        vm.data5_SumCntMemberYM[idxArea] = [];
        vm.data5_SumCntMemberArea[idxArea] = {
          Sum: 0,
          Army: 0,
          Navy: 0,
          Airforce: 0,
          Marine: 0,
        };

        angular.forEach(vm.RoundList, function(round, idxRound) {
          vm.data5[idxArea][idxRound] = {
            Sum: 0,
            Army: 0,
            Navy: 0,
            Airforce: 0,
            Marine: 0,
          };
        });

        angular.forEach(vm.ItemFieldList, function(item, idxItem) {
          vm.data5_ItemField[idxArea][idxItem] = {
            Sum: 0,
            Ratio: 0,
            Army: 0,
            Navy: 0,
            Airforce: 0,
            Marine: 0,
          };
        });

        angular.forEach(vm.YearMonthList, function(yearMonth, idxMonth) {
          vm.data5_YearMonth[idxArea][idxMonth] = [];
          vm.data5_SumCntMemberYM[idxArea][idxMonth] = 0;
          vm.data5_SumYearMonth[idxArea][idxMonth] = 0;

          angular.forEach(vm.RoundList, function(round, idxRound) {
            vm.data5_YearMonth[idxArea][idxMonth][idxRound] = 0;
          });
        });
      });

      // 멘토링 종료 멘토별 팀 수, i:권역, j:멘토, k:회차
      vm.data5_MentoUser = [];
      for (var i = 0; i < vm.AreaList.length; i++) {
        vm.data5_MentoUser[i] = [];
        for (var j = 0; j < vm.MentoUserList[i].length; j++) {
        vm.data5_MentoUser[i][j] = [];
            for (var k = 0; k < vm.RoundList.length; k++) {
            vm.data5_MentoUser[i][j][k] = 0;
          }
        }
      }

      // 멘토링 종료팀 총합
      vm.data5_Sum = 0;

      // 멘토링 권역별 군별 종료팀
      vm.data5_SumArea = [];
      for (var i = 0; i < vm.AreaList.length; i++) {
        vm.data5_SumArea[i] = {
          Sum: 0,
          Ratio: 0,
          Army: 0,
          Navy: 0,
          Airforce: 0,
          Marine: 0,
        };
      }

      // 멘토링 회차별 종료팀 상단 계, %
      vm.data5_RoundTop = [];
      for (var i = 0; i < vm.RoundList.length; i++) {
        vm.data5_RoundTop[i] = { Sum: 0, Ratio: 0 };
      }

      // 멘토링 아이템별 종료팀 계
      vm.data5_SumItemField = [];
      for (var i = 0; i < vm.ItemFieldList.length; i++) {
        vm.data5_SumItemField[i] = { Sum: 0, Ratio:0 };
      }

      // 권역별 멘토별 종료팀 총계 i:권역, j:멘토
      vm.data5_SumMentoUser = [];
      for (var i = 0; i < vm.AreaList.length; i++) {
        vm.data5_SumMentoUser[i] = [];
        for (var j = 0; j < vm.MentoUserList[i].length; j++) {
          vm.data5_SumMentoUser[i][j] = 0;
        }
      }

      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal5'
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              angular.forEach(resultData.body.docs, function(rslt) {
                var idxArea = vm.AreaList.indexOf(rslt.MentoringArea);
                var idxRound = vm.RoundList.indexOf(rslt.MentoringRound);
                var idxItem = vm.ItemFieldList.indexOf(rslt.ItemField);
                var idxYM = vm.YearMonthList.indexOf(rslt.YearMonth);
                var idxMU = vm.MentoUserList[idxArea].findIndex(function (User) {return User.MentoUser == rslt.MentoUser});

                vm.data5[idxArea][idxRound].Sum++;
                vm.data5_YearMonth[idxArea][idxYM][idxRound]++;
                vm.data5_ItemField[idxArea][idxItem].Sum++;
                vm.data5_MentoUser[idxArea][idxMU][idxRound]++;
                vm.data5_Sum++;
                vm.data5_SumArea[idxArea].Sum++;
                vm.data5_RoundTop[idxRound].Sum++;
                vm.data5_SumItemField[idxItem].Sum++;
                vm.data5_SumMentoUser[idxArea][idxMU]++;
                vm.data5_SumCntMemberArea[idxArea].Sum += rslt.CntMember;
                vm.data5_SumCntMemberYM[idxArea][idxYM] += rslt.CntMember;
                vm.data5_SumYearMonth[idxArea][idxYM]++;
                vm.data5_SumCntMemberTotal += rslt.CntMember;
                
                switch (rslt.ArmyType) {
                  case '1':
                    vm.data5_SumArea[idxArea].Army++;
                    vm.data5[idxArea][idxRound].Army++;
                    vm.data5_ItemField[idxArea][idxItem].Army++;
                    vm.data5_SumCntMemberArea[idxArea].Army += rslt.CntMember;
                    break;
                    
                    case '2':
                      vm.data5_SumArea[idxArea].Navy++;
                      vm.data5[idxArea][idxRound].Navy++;
                      vm.data5_ItemField[idxArea][idxItem].Navy++;
                      vm.data5_SumCntMemberArea[idxArea].Navy += rslt.CntMember;
                      break;
                      
                      case '3':
                        vm.data5_SumArea[idxArea].Airforce++;
                        vm.data5[idxArea][idxRound].Airforce++;
                        vm.data5_ItemField[idxArea][idxItem].Airforce++;
                        vm.data5_SumCntMemberArea[idxArea].Airforce += rslt.CntMember;
                        break;
                        
                        case '4':
                          vm.data5_SumArea[idxArea].Marine++;
                          vm.data5[idxArea][idxRound].Marine++;
                          vm.data5_ItemField[idxArea][idxItem].Marine++;
                          vm.data5_SumCntMemberArea[idxArea].Marine += rslt.CntMember;
                    break;

                    default :
                    break;
                }
              });

              angular.forEach(vm.data5_ItemField, function(area) {
                angular.forEach(area, function(item) {
                  item.Ratio = (item.Sum / vm.GoalNum * 100).toFixed(2);
                });
              });

              angular.forEach(vm.data5_SumArea, function(area) {
                area.Ratio = (area.Sum / vm.GoalNum * 100).toFixed(2);
              });

              angular.forEach(vm.data5_SumItemField, function(item) {
                item.Ratio = (item.Sum / vm.GoalNum * 100).toFixed(2);
              })

              angular.forEach(vm.data5_RoundTop, function(round) {
                round.Ratio = (round.Sum / vm.GoalNum * 100).toFixed(2);
              });

              vm.data5_Ratio = (vm.data5_Sum / vm.GoalNum * 100).toFixed(2);
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록6 조회
    function getData6() {
      vm.dataloader = true;
      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal6';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              vm.data6 = resultData.body.docs;
              vm.data6_Sum = { Sum: 0, End: 0, Ing: 0, NotStart: 0, Cancel: 0, };
              vm.data6_Rownum = [];
              vm.data6_SumArea = [];
              angular.forEach(vm.AreaList, function(area, idxArea) {
                vm.data6_Rownum[idxArea] = {
                  Sum: vm.data6.length + 1,
                  Army: 0,
                  Navy: 0,
                  Airforce: 0,
                  Marine: 0,
                };
                vm.data6_SumArea[idxArea] = {
                  Sum: 0,
                  End: 0,
                  Ing: 0,
                  NotStart: 0,
                  Cancel: 0,
                };
              });

              angular.forEach(vm.data6, function(row, idx) {
                if (idx == 0) {
                  row.isFirst = true;
                } else {
                  if (row.AreaNm != vm.data6[idx-1].AreaNm || row.ArmyType != vm.data6[idx-1].ArmyType) {
                    row.isFirst = true;
                  }
                }
                var idxArea = vm.AreaList.indexOf(row.AreaNm);
                vm.data6_Sum.Sum += row.TeamCntSum;
                vm.data6_Sum.End += row.TeamCntEnd
                vm.data6_Sum.Ing += row.TeamCntIng
                vm.data6_Sum.NotStart += row.TeamCntNotStart
                vm.data6_Sum.Cancel += row.TeamCntCancel
                vm.data6_SumArea[idxArea].Sum += row.TeamCntSum;
                vm.data6_SumArea[idxArea].End += row.TeamCntEnd
                vm.data6_SumArea[idxArea].Ing += row.TeamCntIng
                vm.data6_SumArea[idxArea].NotStart += row.TeamCntNotStart
                vm.data6_SumArea[idxArea].Cancel += row.TeamCntCancel

                // Table rowspan value
                // vm.data6_Rownum[idxArea].Sum++;
                switch(row.ArmyType) {
                  case '1':
                    vm.data6_Rownum[idxArea].Army++;
                    break;

                  case '2':
                    vm.data6_Rownum[idxArea].Navy++;
                    break;

                  case '3':
                    vm.data6_Rownum[idxArea].Airforce++;
                    break;

                  case '4':
                    vm.data6_Rownum[idxArea].Marine++;
                    break;
                    
                  default:
                    break;
                  }
              });
              vm.data6_Ratio = {
                Sum: (vm.data6_Sum.Sum / vm.GoalNum * 100).toFixed(2),
                End: (vm.data6_Sum.End / vm.GoalNum * 100).toFixed(2),
                Ing: (vm.data6_Sum.Ing / vm.GoalNum * 100).toFixed(2),
                NotStart: (vm.data6_Sum.NotStart / vm.GoalNum * 100).toFixed(2),
                Cancel: (vm.data6_Sum.Cancel / vm.GoalNum * 100).toFixed(2),
              };
            } else {
              vm.data6 = {};
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록6 조회: 13. 창업경진대회
    function getData7() {
      vm.dataloader = true;
      vm.data7 = []; // 권역별 창업경진대회 참여한 팀의 수(계, %, 육군, 해군, 공군, 해병대)
      vm.data7_Ratio = []; // 창업경진대회 권역별 %
      vm.data7_Top = []; // 창업경진대회 참여한 팀 대회별 계

      angular.forEach(vm.AreaList, function(area, idxArea) {
        vm.data7[idxArea] = [];
        angular.forEach(vm.MentoringContestList, function(contest, idxMC) {
          vm.data7[idxArea][idxMC] = {
            Sum: 0,
            Ratio: 0,
            Army: 0,
            Navy: 0,
            Airforce: 0,
            Marine: 0,
          };
        });
      });

      angular.forEach(vm.AreaList, function(contest, idxArea) {
        vm.data7_Ratio[idxArea] =
          ((vm.data1_2[idxArea].PrtcpCntTotal + vm.data1_2[idxArea].EndCntTotal) / vm.GoalNum * 100).toFixed(2);
      });
      
      angular.forEach(vm.MentoringContestList, function(contest, idxMC) {
        vm.data7_Top[idxMC] = { Sum: 0, Ratio: 0 };
      });

      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal7';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              angular.forEach(resultData.body.docs, function(rslt) {
                var idxArea = vm.AreaList.indexOf(rslt.MentoringArea);
                var idxMC = vm.MentoringContestList.indexOf(rslt.Contest);

                vm.data7[idxArea][idxMC].Sum++;
                vm.data7_Top[idxMC].Sum++;
                switch (rslt.ArmyType) {
                  case '1':
                    vm.data7[idxArea][idxMC].Army++;
                    break;

                  case '2':
                    vm.data7[idxArea][idxMC].Navy++;
                    break;

                  case '3':
                    vm.data7[idxArea][idxMC].Airforce++;
                    break;

                  case '4':
                    vm.data7[idxArea][idxMC].Marine++;
                    break;

                  default:
                    break;
                };
              });

              // 비율(%) 소수점 셋째자리에서 반올림
              angular.forEach(vm.data7, function(area) {
                angular.forEach(area, function(contest) {
                  contest.Ratio = (contest.Sum / vm.GoalNum * 100).toFixed(2);
                });
              });

              angular.forEach(vm.data7_Top, function(contest) {
                contest.Ratio = (contest.Sum / vm.GoalNum * 100).toFixed(2);
              });
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록8 조회: 종료팀 현황
    function getData8() {
      vm.dataloader = true;
      vm.data8 = [];

      angular.forEach(vm.AreaList, function(area, idxArea) {
        vm.data8[idxArea] = {
          Army: [],
          Navy: [],
          Airforce: [],
          Marine: [],
          Rownum: 2,
          Sum: 0,
          Ratio: 0,
        };
      });

      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal8';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              angular.forEach(resultData.body.docs, function(rslt) {
                var idxArea = vm.AreaList.indexOf(rslt.MentoringArea);
                vm.data8[idxArea].Rownum++;
                if (rslt.ClubRole === '팀장') vm.data8[idxArea].Sum++;

                switch (rslt.ClubArmyType) {
                  case '1':
                    vm.data8[idxArea].Army.push(rslt);
                    break;

                  case '2':
                    vm.data8[idxArea].Navy.push(rslt);
                    break;

                  case '3':
                    vm.data8[idxArea].Airforce.push(rslt);
                    break;

                  case '4':
                    vm.data8[idxArea].Marine.push(rslt);
                    break;

                  default :
                    break;
                }
              });
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록9 조회
    function getData9() {
      vm.dataloader = true;
      vm.srch.mapCode = 'MentoringState.getMentoringStateTotal9';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              var resultData = postApi.makeResultData(data);
              vm.data9 = resultData.body.docs[0];
            } else {
              vm.data9 = {};
            }
          } else {
            console.info('else ');
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '멘토링통계종합현황';
      log.ScreenUrl = 'app/mentoring/state/mentoringstate-total';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        //console.log(data);
        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('modal', 'app/modal/DownloadReason-modal.html', ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }
  
    // 엑셀 다운로드
    function getExcel() {
      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);

      vm.srch.header = header;
      vm.srch.downFileName = '창업멘토링 종합현황';
      vm.srch.userkey = $rootScope.gVariable.userKey;
      vm.srch.data = {
        GoalNum: vm.GoalNum,
        AreaList: vm.AreaList,
        RoundList: vm.RoundList,
        MentoUserList: vm.MentoUserList,
        ItemFieldList: vm.ItemFieldList,
        YearMonthList: vm.YearMonthList,
        MentoringContestList: vm.MentoringContestList,
        data1_1: vm.data1_1,
        data1_2: vm.data1_2,
        data1_3: vm.data1_3,
        data2: vm.data2,
        data2_2: vm.data2_2,
        data3: vm.data3,
        data3_1: vm.data3_1,
        data4: vm.data4,
        data4_1: vm.data4_1,
        data5: vm.data5,
        data5_YearMonth: vm.data5_YearMonth,
        data5_RoundTop: vm.data5_RoundTop,
        data5_Ratio: vm.data5_Ratio,
        data5_ItemField: vm.data5_ItemField,
        data5_MentoUser: vm.data5_MentoUser,
        data5_Sum: vm.data5_Sum,
        data5_SumArea: vm.data5_SumArea,
        data5_SumYearMonth: vm.data5_SumYearMonth,
        data5_SumItemField: vm.data5_SumItemField,
        data5_SumMentoUser: vm.data5_SumMentoUser,
        data5_SumCntMemberTotal: vm.data5_SumCntMemberTotal,
        data5_SumCntMemberYM: vm.data5_SumCntMemberYM,
        data5_SumCntMemberArea: vm.data5_SumCntMemberArea,
        data6: vm.data6,
        data6_Ratio: vm.data6_Ratio,
        data6_Sum: vm.data6_Sum,
        data6_SumArea: vm.data6_SumArea,
        data7: vm.data7,
        data7_Top: vm.data7_Top,
        data7_Ratio: vm.data7_Ratio,
        data8: vm.data8,
        data9: vm.data9,
      };

      $http({
        url: StaticVariable.getUrl(
          '/etcExcel/MentoringStateTotal/action.json?userkey=' + $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }


    // 함수 선언
    vm.getData = getData;

    // 데이터 조회
    // 조회 전 권역, 멘토, 차수, 분야, 경진대회 목록 조회
    getMentoringArea().then(function() {
      getMentoUserList().then(function() {
        getMentoringRound().then(function() {
          getMentoringItemFieldList().then(function() {
            getMentoringContestList().then(function() {
              getData();
            });
          });
        });
      });
    });
  },
]);

(function () {
  'use strict';

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.mentoring.state', {
        url: '/state',
        template: '<div ui-view></div>',
      })
      .state('app.mentoring.state.mentoringstate-summary', {
        url: '/summary',
        templateUrl: 'app/mentoring/state/mentoringstate-summary.html',
      })
      .state('app.mentoring.state.mentoringstate-total', {
        url: '/mentoringstate-total',
        templateUrl: 'app/mentoring/state/mentoringstate-total.html',
      })
      .state('app.mentoring.state.mentoringstate-list', {
        url: '/mentoringstate-list',
        templateUrl: 'app/mentoring/state/mentoringstate-list.html',
      });
    }
})();
(function () {
  "use strict";
  webapp.controller('ScheduleHolidayModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', 'gConfirm',
  function ScheduleHolidayModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, gConfirm) {

    var vm = this;

    // 당당부서
    postApi.select({mapCode : 'organizationMng.getOrganizationCodes', Depth : '3'}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeDepts = result.body.docs;
      }
    });

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.Edit, // List OR Edit
      tableNm : "scholiday",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "data", // ex : vc.data = {}
      apis : {
        /** common mapper **/
        // initSelect : 기본 데이터를 가져오는 코드 
        initSelect : { mapCode : "ScCustomerReserve.getScHolidayDetail", param : {keyId : mdata.keyId} },
        // vieType is list
        // vieType is edit
        insert : "ScCustomerReserve.insertScHoliday",
        update : "ScCustomerReserve.updateScHoliday",
      },
      /* 목록페이지 */

      /* 상세페이지 */
      // 엘리먼트 퍼블리싱 타입
      formType : mElemTx.layout.inline,

      // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
      addRow : [],

      // vc의 ng-if
      ngIf : {
      },
      
      // 비활성화 시킬 컬럼의 조건
      disabled : {
      },

      // MataColum 외 추가 적으로 넣어야할 폼
      addForm : {
        //CustList : { before : 'CustNm', type : mElemTx.select, colSize: 1, label : ""}
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange : {
        HolidayStartDate: "chkDate",
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback : {
        
      },

      timeOption : {
        HolidayStartDate : {
          minuteStep : 30, initActiveCalendar : true
        },
        HolidayEndDate : {
          minuteStep : 30, initActiveCalendar : true
        }
      },

      // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
      //noLable : ["OpenType"],

      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes : {
        DeptId : "codeDepts"
      },

      // 필수 항목 컬럼 
      required : ["DeptId"],

      autocomplete : {
        
      }
      
    };

    function cancel() {
      $uibModalInstance.dismiss('update data');
    }


    // 저장 버튼 클릭 시
    function setData() {
      if (getIsValidData()) {
        av.commit(function(result){
          angular.forEach(vm.codeDepts, function (item){
            if (item.Code == result.body.docs[0].DeptId) {
              result.DeptNm = item.CodeValue;
            }
          });
          result.HolidayYN = 'Y';
          gAlert('', 'Menu.SAVED');
          $uibModalInstance.close(result);
        });
      }
    }

    // 수정 버튼 클릭 시
    function setUpdateData() {
      if (getIsValidData()) {
        gConfirm('', 'Menu.SAVECONFIRM2', {
          btn : '',
          fn : function() {
            av.commit(function(result){
              console.log('result', result);
              angular.forEach(vm.codeDepts, function (item){
                if (item.Code == result.body.docs[0].DeptId) {
                  result.DeptNm = item.CodeValue;
                }
              });
              result.HolidayYN = 'Y';
              result.res = 'E';
              gAlert('', 'Menu.SAVED');
              $uibModalInstance.close(result);
            });
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }
    }

    // 삭제 버튼 클릭 시
    function setDelData() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          var data = vm.data;
          data.HolidayYN = 'Y';
          data.mapCode = 'ScCustomerReserve.deleteScHoliday';

          postApi.update(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED', {
                btn : '',
                fn : function() {
                  data.res = 'D';
                  $uibModalInstance.close(data);
                }
              });
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.log("error");
            // console.error("Error> setDelData()");
            // console.table(error);
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function getIsValidData() {
      var bRtn = true;

      // #region 필수항목 체크
      var errMsg = '';
      if (isNullOrEmpty(vm.data.HolidayStartDate)) {
        errMsg = errMsg + '- 휴무시작일시을 확인하세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.HolidayEndDate)) {
        errMsg = errMsg + '- 휴무종료일시을 확인하세요.<br/>';
      }
      if (vm.data.HolidayStartDate >= vm.data.HolidayEndDate) {
        errMsg = errMsg + '- 휴무일시를 확인하세요.<br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        bRtn =  false;
      }

      return bRtn;
    }

    function onReadyAutoView() {
      // 초기 설정
      setCalendar();

      // 스케줄에서 상태를 클릭하고 들어온 경우
      if (!isNullOrEmpty(mdata.option)) {
        // 시간 설정
        vm.data.HolidayStartDate = moment(new Date(mdata.addDate));
        vm.data.HolidayEndDate = moment(vm.data.HolidayStartDate).add(1, 'd');
        // 부서 설정
        vm.data.DeptId = mdata.resourceId;
      }
    }

    function setCalendar() {
      /* config object */
      $scope.uiConfig = {
        calendar:{
           header:{
             left: 'today',
             center: 'prev, title, next',
             right: ''
           },
           views:{
             month: {columnFormat : 'dddd'},
             agendaWeek: {columnFormat : 'ddd M/D'},
           },
           // initalView: 'dayGridMonth',
           schedulerLicenseKey: '0663320046-fcs-1605662091',
          //  googleCalendarApiKey : 'AIzaSyDvpTo79J0vvggfeNHMZcREpJqWnFyytls',
           locale: 'ko',
           timezone: 'local',
           editable: false,
           defaultDate: moment().format("YYYY-MM-DD"),
          defaultView: 'agendaDay', // agendaDay, agendaWeek, month           
          themeSystem:'bootstrap3',
          timeFormat: 'HH:mm',
          weekends: true,
          nowIndicator: true,
          displayEventTime: false,
          displayEventEnd: false,
          viewRender: function(view, element) {
            //  getData(view);
          },
          eventDrop: $scope.alertOnDrop,
          //  eventSources: [{
          //    googleCalendarId: 'ko.south_korea#holiday@group.v.calendar.google.com',
          //    className: 'gcal-event', color: "rgb(247,250,252)", textColor: "#FF2F2F", cursor: 'default', editable: false
          //  }],
          eventResize: $scope.alertOnResize,
          //eventRender: $scope.eventRender,
          dayClick: function(date, jsEvent, view, resourceObj) {
            dayClick(date);
          },
          eventClick: function (calEvent) {
            eventClick(calEvent);
          },
        }
      };
    }

    function chkDate() {
      vm.data.HolidayEndDate = moment(vm.data.HolidayStartDate).add(1, 'd');
    }

    /** @description autoView init Callback**/
    vm.cancel = cancel;
    vm.setData = setData;
    vm.setUpdateData = setUpdateData;
    vm.setDelData = setDelData;
    vm.onReadyAutoView = onReadyAutoView;
    vm.chkDate = chkDate;
    
    var av = new autoView();
    av.init(autoViewOption);
  }]);

})();

(function () {
  "use strict";
  webapp.controller('CampaignCustomerModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function CampaignCustomerModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {

    var vm = this;
    vm.CmpgnImpChannel = mdata.CmpgnImpChannel;
    vm.title = mdata.title;

    vm.srch = {
      page: 1,
      viewSize: CONSTANT.PAGINATION.VIEWSIZE,
      ErrYN : mdata.errYN, 
      DenyYN : mdata.errYN,
      CmpgnImplCustIdList : [],
      keyId : mdata.keyId
    };
    
    vm.viewSize = vm.srch.viewSize;
    vm.currentPage = vm.srch.page;

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
     function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    function getSearch() {
      vm.srch.pag = 1;
      vm.currentPage = vm.srch.page;

      getList();
    }
    
    function ok(clickData) {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "CampaignImpl.getCareCampaignImplCustomerListCnt";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
      });
    }

    function getList() {
      getListCnt();
      var data = angular.copy(vm.srch);
      data.mapCode = "CampaignImpl.getCareCampaignImplCustomerList";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        } else {
          vm.lists = [];
        }
      });
    }

    vm.chkRowAll = function() {
      for(var i = 0 ; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.checkListCheckbox;
      }
    };

    /**
      * 목록 삭제 확인
      * @param
      * @return
      */
    function setDelList() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          setDelListAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    /**
      * 목록 삭제
      * @param
      * @return
      */
    function setDelListAction() {
      vm.srch.KeyIdList = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.srch.CmpgnImplCustIdList.push(vm.lists[i].CmpgnImplCustId);
        }
      }

      if (vm.srch.CmpgnImplCustIdList == null || vm.srch.CmpgnImplCustIdList.length == 0) {
        gAlert('', 'Menu.DELETENODATA');
        return false;
      }

      var data = angular.copy(vm.srch);
      data.mapCode = "CampaignImpl.deleteCareCampaignImplCustomerList";

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.log("error");
        // console.error("Error> setDelListAction()");
        // console.table(error);
      });
    }

    /** @description autoView init Callback**/
    vm.cancel = cancel;
    vm.pageChanged = pageChanged;
    vm.getSearch = getSearch;
    vm.setDelList = setDelList;

    getList();

  }]);

})();

(function () {
  "use strict";
  webapp.controller('EmailCertifiModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function EmailCertifiModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {

    var vm = this;
    vm.data = {};
    vm.showMsg = false;

    function dupChk() {
      var data = angular.copy(vm.data);
      data.mapCode = 'SendVerify.getSendDuplicateCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs > 0) {
            gAlert('','이미 등록된 이메일 입니다.');
            return;
          } else {
            sendVerifyEmail();
          }
        }
      });
    }

    function sendVerifyEmail() {
      var data = angular.copy(vm.data);
      data.mapCode = 'aws/verifyEmailAddress';
      postApi.api(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.showMsg = true;
        }
      });
    }

    function sendVerifyEmailChk() {
      var data = angular.copy(vm.data);
      data.Type = 'E';
      data.CertYN = 'Y';
      data.mapCode = 'aws/verifyEmailAddressChk';

      postApi.api(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '등록이 완료되었습니다.', {
            btn : '',
            fn : function () {
              $uibModalInstance.close();
            }
          });
        } else {
          gAlert('', result.body.docs[0].errMessage);
          return;
        }
      });
    }

    function ok() {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    vm.dupChk = dupChk;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.sendVerifyEmailChk = sendVerifyEmailChk;
  }]);

})();

(function () {
  "use strict";
  webapp.controller('FormListModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm',
  function FormListModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm) {

    var vm = this;

    vm.srch = {
      page: 1,
      viewSize: CONSTANT.PAGINATION.VIEWSIZE,
      FormType : mdata.FormType
    };

    vm.viewSize = vm.srch.viewSize;
    vm.currentPage = vm.srch.page;

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
     function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    function getSearch() {
      vm.srch.pag = 1;
      vm.currentPage = vm.srch.page;

      getList();
    }
    
    function ok(clickData) {
      gConfirm('', '작성된 내용이 있을 경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
        btn : '',
        fn : function() {
          $uibModalInstance.close(clickData);
        }
      },{
          btn : '',
          fn : function() {
        }
      });      
    }
    
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign2.getFormListCnt";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
      });
    }

    function getList() {
      getListCnt();
      var data = angular.copy(vm.srch);
      data.mapCode = "Campaign2.getFormList";

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        } else {
          vm.lists = [];
        }
      });
    }

    vm.pageChanged = pageChanged;
    vm.getSearch = getSearch;
    vm.ok = ok;
    vm.cancel = cancel;

    getList();

  }]);

})();

(function () {
  "use strict";
  webapp.controller('FromTelNoModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm',
  function FromTelNoModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm) {

    var vm = this;
    $stateParams.SendInfo = mdata.SendInfo;
    
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "sendverify.modal",
      keyIdNm: "SendInfo",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {
        initSelectCnt : { mapCode : "SendVerify.getSendVerifySimpleListCnt", param : {Type:mdata.Type} },
        initSelect : { mapCode : "SendVerify.getSendVerifySimpleListForModal", param : {Type:mdata.Type} },
      },

      // List
      listCheckboxEnable : false,
      
      src : {
      },
      
      addFormGroup : {
      },

      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback : ok,

      customCodes : {
      }

    };

    function ok(clickData) {
      $uibModalInstance.close(clickData);
    }
    
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function onReadyAutoView() {
      // 초기 설정
    }

    /** @description autoView init Callback**/
    vm.cancel = cancel;
    vm.onReadyAutoView = onReadyAutoView;
    
    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();

(function () {
  "use strict";
  webapp.controller('ReceiveNumberModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function ReceiveNumberModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {
    
    //#region 상수 정의
    var vm = this;
    vm.receiveNumList = [];
    //#endregion 상수 정의

    //#region 함수 선언    
    vm.cancel = cancel;
    vm.ok = ok;
    vm.addReceiveNumList = addReceiveNumList;
    vm.delReceiveNumList = delReceiveNumList;
    vm.resetReceiveNumList = resetReceiveNumList;
    //#endregion 함수 선언

    //#region cancel 취소
    /**
      * 취소
      *
      * @param
      * @return
      * @author 이기훈
      */
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
    //#endregion cancel 취소

    //#region ok 직접입력 투입 데이터 저장
    /**
      * 직접입력 투입 데이터 저장
      *
      * @param
      * @return
      * @author 이기훈
      */
    function ok() {
      if (vm.receiveNumList.length == 0) {
        gAlert('', '휴대폰 번호를 1개 이상 입력해주세요.');
        return;
      }

      var data = {keyId : mdata.keyId, orgYN : vm.orgYN, list : angular.copy(vm.receiveNumList), mapCode : 'CampaignImpl.insertCareCampaignImplCustomerDirect'};

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", "투입되었습니다.", {
            btn: "",
            fn: function () {
              $uibModalInstance.close();
            }
          });
        } else {
          gAlert('', result.body.docs[0].errMessage);
        }
      }, function (error) {
        console.log("error");
        // console.error("Error : ok");
        // console.table(error);
      });
    }
    //#endregion ok 직접입력 투입 데이터 저장

    //#region addReceiveNumList 직접입력 투입 목록 추가
    /**
      * 직접입력 투입 목록 추가
      *
      * @param
      * @return
      * @author 이기훈
      */
    function addReceiveNumList() {
      vm.receiveNumData = {
        MbErrYN : 'N',
        MbDenyYN : 'N',
        EmErrYN : 'N',
        EmDenyYN : 'N',
        DirectYN : 'Y',
        CustStatus : "PRE"
      };

      var rgEx = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

      var chkFlg = rgEx.test(vm.receiveNum);
      if (!chkFlg) {
        gAlert('', '올바른 휴대폰 번호가 아닙니다.');
        return;
      }

      vm.receiveNumData.ToInfo = vm.receiveNum;
      
      vm.receiveNumList.push(vm.receiveNumData);
      vm.receiveNum = '';
    }
    //#endregion addReceiveNumList 직접입력 투입 목록 추가

    function delReceiveNumList(index) {
      vm.receiveNumList.splice(index, 1);
      vm.receiveNum = '';
    }

    //#region getCmpgnCustomerList 직접입력 투입 고객 조회
    /**
      * 직접입력 투입 고객 조회
      *
      * @param
      * @return
      * @author 이기훈
      */
    function getCmpgnCustomerList() {
      var data = {keyId : mdata.keyId, DirectYN : 'Y', ErrYN : 'N', DenyYN : 'N', mapCode : 'CampaignImpl.getCareCampaignImplCustomerList'};
      
      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.receiveNumList = result.body.docs;
            vm.orgYN = 'Y';
          } else {
            vm.orgYN = 'N';
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error : getCmpgnCustomerList");
        // console.table(error);
      });
    }
    //#endregion getCmpgnCustomerList 직접입력 투입 고객 조회

    //#region resetReceiveNumList 직접입력 투입 고객 초기화
    /**
      * 직접입력 투입 고객 초기화
      *
      * @param
      * @return
      * @author 이기훈
      */
    function resetReceiveNumList() {
      var data = {keyId : mdata.keyId, DirectYN : 'Y', mapCode : 'CampaignImpl.deleteCareCampaignImplCustomer'};

      gConfirm('','직접 투입한 휴대폰 번호들이 초기화 됩니다. 초기화 하시겠습니까?', {
        btn : '',
        fn : function() {
          postApi.update(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              gAlert('', '초기화 되었습니다.', {
                btn : '',
                fn : function() {
                  $uibModalInstance.close();
                }
              });
            }
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }
    //#endregion resetReceiveNumList 직접입력 투입 고객 초기화

    //#region 함수 호출
    getCmpgnCustomerList();
    //#endregion 함수 호출
  }]);

})();

(function () {
  "use strict";
  webapp.controller('SmsPreviewModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function SmsPreviewModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {
    
    var vm = this;

    if (!isNullOrEmpty(mdata.SendTitle)) {
      vm.sendCn = '제목 : ' + mdata.SendTitle + '\n' + mdata.SendMessage;
    } else {
      vm.sendCn = mdata.SendMessage;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    vm.cancel = cancel;

  }]);

})();

(function () {
  "use strict";
  webapp.controller('SrchInputModalCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData','gConfirm', 'gAlert',
  function SrchInputModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gConfirm, gAlert) {

    var vm = this;
    vm.extraSearch = false;

    // 유형(상품) 코드 
    postApi.select({ mapCode: 'ScItemType.getScitemtypeCodes',ItemType:'I' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeItemType = result.body.docs;
      }
    });

    // 담당자 목록
    postApi.select({ mapCode: 'ScUser.getUserListCodes' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeManager = result.body.docs;
      }
    });

    // 캠페인 목록
    postApi.select({ mapCode: 'CampaignImpl.getCampaignImplCareSimpleList' },
    function (result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codeCampaign = result.body.docs;
      }
    });

    vm.codeStatus = [
      {Code : 'PRE', CodeValue : '임시저장'},
      {Code : 'STANDBY', CodeValue : '대기'},
      {Code : 'EXE', CodeValue : '실행중'},
      {Code : 'END', CodeValue : '종료'},
      {Code : 'NG', CodeValue : '오류'},
    ];

    
    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.Edit, // List OR Edit
      /* 상세페이지 */
      // 엘리먼트 퍼블리싱 타입
      formType : mElemTx.layout.inline,
      tableNm : "campaign.srch-input-modal",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "data", // ex : vc.data = {}
      apis : {
        /** common mapper **/
        // initSelect : 기본 데이터를 가져오는 코드 
        initSelect : { mapCode : "ScCustomer.getCustomerDetail", param : null },

        // vieType is edit
        insert : "ScCustomer.insertCustomer",
        update : "ScCustomer.updateCustomer",
        
      },
      /* 목록페이지 */


      // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
      addRow : [],

      // vc의 ng-if
      ngIf : {
        
      },
      
      // 비활성화 시킬 컬럼의 조건
      disabled : {
      },

      // MataColum 외 추가 적으로 넣어야할 폼
      addFormGroup : {
        InquiryDate : { target : "sec5", type : mElemTx.date,  bindKey : ["InquiryDateFrom", "InquiryDateTo"], label : "문의일", addDivision : true, colSize : 2},
        BirthDay : { after : "InquiryDate", type : mElemTx.date,  bindKey : ["BirthDayFrom", "BirthDayTo"], label : "생년월일", addDivision : true, colSize : 2},
        TotalSalesCost : { target : "sec6", type : mElemTx.number,  bindKey : ["TotalSalesCostFrom", "TotalSalesCostTo"], label : "총매출", addDivision : true, colSize : 2},
        TotalSalesCount : { after : "TotalSalesCost", type : mElemTx.number,  bindKey : ["TotalSalesCountFrom", "TotalSalesCountTo"], label : "판매횟수", addDivision : true, colSize : 2}
      },

      srchDateType : {
        InquiryDateFrom : "from",
        InquiryDateTo : "to",
        BirthDayFrom : "from",
        BirthDayTo : "to"
      },

      ngClick : {
      },

      // 값이 변경되었을 시 콜백 처리 callback 과 유사함
      ngChange : {
      },

      // ngChange, Button, Date Chage 등에 사용하는 콜백
      callback : {
        
      },

      timeOption : {
        StartDate : {
          minuteStep : 10, initActiveCalendar : true
        }
      },

      autocomplete : {
      },
      // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
      //noLable : ["ChartNoAutoYN"],

      // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
      // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
      customCodes : {
        ItemType : "codeItemType",
        RecommendItem : "codeItemType",
        CounselManager : "codeManager",
        VisitManager : "codeManager",
        SurgicalManager : "codeManager",
        CampaignLog : "codeCampaign",
        CampaignAction : "codeStatus"
      },

      textAreaOption : {
      },

      // 필수 항목 컬럼 
      required : []
      
    };

    function ok() {
      vm.data.list = vm.srchList;
      var data = angular.copy(vm.data);
      data.mapCode = 'CampaignImpl.insertCareCampaignImplCustomerSrchInput';

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '투입되었습니다.', {
            btn : '',
            fn : function() {
              $uibModalInstance.close();
            }
          });
        } else {
          gAlert('', '투입되지 않았습니다.');
          return;
        }
      });
    }
    
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function onReadyAutoView() {
      // 초기 설정
      vm.srchCnt = '0';
      vm.data.keyId = mdata.keyId;
      vm.data.CmpgnImpChannel = mdata.CmpgnImpChannel;
    }

    function getSearchData() {
      var data = angular.copy(vm.data);

      if (isNullOrEmpty(data)) {
        gAlert('', '하나 이상 선택 후 추출해주시기 바랍니다.');
        return;
      }

      if (!isNullOrEmpty(data.CustNm) || !isNullOrEmpty(data.CustGubun) || !isNullOrEmpty(data.CustGrade) || !isNullOrEmpty(data.Gender) || !isNullOrEmpty(data.VisitPath) || !isNullOrEmpty(data.InquiryDateFrom) || !isNullOrEmpty(data.InquiryDateTo) || !isNullOrEmpty(data.BirthDayFrom) || !isNullOrEmpty(data.BirthDayTo) || !isNullOrEmpty(data.TotalSalesCostFrom) || !isNullOrEmpty(data.TotalSalesCostTo) || !isNullOrEmpty(data.TotalSalesCountFrom) || !isNullOrEmpty(data.TotalSalesCountTo)) {
        data.srchCTYN = 'Y';
      }
      if (!isNullOrEmpty(data.ItemType) || !isNullOrEmpty(data.RecommendItem)) {
        data.srchSITYN = 'Y';
      }
      if (!isNullOrEmpty(data.CounselManager)) {
        data.srchSCTYN = 'Y';
      }
      if (!isNullOrEmpty(data.VisitManager)) {
        data.srchSVRYN = 'Y';
      }
      if (!isNullOrEmpty(data.SurgicalManager)) {
        data.srchSSRYN = 'Y';
      }
      if (!isNullOrEmpty(data.CampaignLog) || !isNullOrEmpty(data.CampaignAction)) {
        data.srchCMTYN = 'Y';
      }

      data.mapCode = 'CampaignImpl.getCampaignImplCareSrchInputList';
      data = av.setSrchDate(data);
      
      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.extraSearch = true;
          if (result.body.docs.length > 0) {
            vm.srchList = result.body.docs;
            vm.srchCnt = result.body.docs.length;
          } else {
            vm.srchCnt = 0;
          }
        }
      });
    }

    /** @description autoView init Callback**/
    vm.ok = ok;
    vm.cancel = cancel;
    vm.onReadyAutoView = onReadyAutoView;
    vm.getSearchData = getSearchData;
    
    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:additional-service-list
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('AdditionalServiceListCtrl', ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window',

    function AdditionalServiceListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $state, $window) {
      var vm = this;  
              // View Model
      vm.srch = {};
      var today = new Date();
      vm.srch.ResultDateTo = moment(today).format('YYYY-MM-DD');

      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      vm.srch.ResultDateFrom = moment(firstDay).format('YYYY-MM-DD');

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
      }

      vm.listOptions = {
        ngIf : {
          TenantNm : "vc.loginSysAdminYN", 
          ServPoint  : "vc.loginSysAdminYN"
        }
      }
      
      var autoViewOption = {
        vm: vm,
        stateParams: $stateParams,
        scope: $scope,
        printColumn: true,

        /* 공통 */
        viewType: mViewType.List, // List OR Edit
        tableNm: "scadditionalservice",
        keyIdNm: "keyId",
        alias: "vc",
        dataModelNm: "lists", // ex : vc.data = {}
        srchModelNm: "srch",
        srchTarget: "searchWrap",
        apis: {
          initSelectCnt: { mapCode: "ScPointinfo.getScPointUseListCnt" },
          initSelect: { mapCode: "ScPointinfo.getScPointUseList", param: vm.srch },
        },

        addSrchStack: true,

        // List
        listCheckboxEnable: false,

        src: {
          detail: "",
          splitDetail: ""
        },

        addFormGroup : {
          ResultDate : { after : "BranchNm", type : mElemTx.date,  bindKey : ["ResultDateFrom", "ResultDateTo"], label : "수신일", addDivision : true, colSize : 2},
        }
      
      };

      function getTenantServPoint() {
        postApi.select({ mapCode: 'ScPointinfo.getTenantServPoint'},
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.ServPoint = result.body.docs[0];
          } else {
            vm.ServPoint = 0;
          }
        });
      }

      function onReadyAutoView() {
        getTenantServPoint();
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;
      vm.getTenantServPoint = getTenantServPoint;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $stateParams - state Parameter object
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 회원사관리
   */
  webapp.controller('ScItemTypeListCtrl', 
    ['$rootScope', '$scope', '$stateParams', '$translate', 'autoPage', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$window',
    function ScItemTypeListCtrl($rootScope, $scope, $stateParams, $translate, autoPage, autoView, postApi, CONSTANT, $window) {

      var vm = this;

      var MAPPER_DETAIL = "ScItemType.getScitemtypeDetail";

      vm.isSys = false;
      vm.isBranch = false;
      vm.codeRecommendList = [];

      if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
      if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchId")) || !isNullOrEmpty($rootScope.gVariable.srchBranchId)) {
        vm.isBranch = true;  
      }

      vm.codeDuringType = [
        {Code : "W", CodeValue:"주"}
        , {Code : "M", CodeValue:"월"}
        , {Code : "Y", CodeValue:"년"}
      ];

      vm.currentType = "";
      vm.showAttend = false;

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,

        viewType : mViewType.Edit,
        tableNm : "Scitemtype",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data",

        apis : {
          // columnMap은 불러오되 업종선택을 변경하였을시에 데이터를 불러오기 위해 빈값으로 데이터 호출
          initSelect : { mapCode : MAPPER_DETAIL, param : {IndustCode : ''} }  
          //, insert : "ScCustomer.insertScitemtype" 트리에서 작업을 함으로 필요하지 않음
          , update : "ScItemType.updateScitemtype"
        },

        ngChange : {
          AttendanceType : "setChangeAttendance"
          , IsFree : "setChangeFree"
        },

        callback : {
          FrequencyTotalCount : "drawFrequencyDetail"
          , RegularTotalCount : "drawRegularDetail"
        
        },

        addRow : ["FrequencyTotalCount", "RegularTotalCount", "RecommendId"],

        disabled : {
          Cost : "vc.data.IsFree == 'Y'"
          , Taxation : "vc.data.IsFree == 'Y'"
          
        }, 

        ngIf : {
          RecommendId : "vc.data.AttendanceType != '0'"
          , Cost : "vc.data.AttendanceType != '0' && vc.data.AttendanceType != '10'"
          , Taxation : "vc.data.AttendanceType != '0' && vc.data.AttendanceType != '10'"
          , IsFree : "vc.data.AttendanceType != '0' && vc.data.AttendanceType != '10'"
          , FrequencyTotalCount : "vc.currentType == '30'"
          , RegularTotalCount : "vc.currentType == '40'"
        },

        noLable : ["PeriodDuringType"],

        customCodes : {
          PeriodDuringType : "codeDuringType"
          , RecommendId : "codeRecommendList"
        },

        required : ["ItemName", "FrequencyTotalCount", "RegularTotalCount"]
      };

      vm.datas = [];
      vm.linkData =[];

      vm.rootData = {};
      vm.subData = {};

      vm.showTabView = [];
      vm.rootTitle = "유형 등록";

      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.sbCtrl;

      vm.rootDisabled = true;
      vm.showSubView = false;

      vm.RentalYNCode = [];
      vm.daysCode = [];

      vm.IndustCode = "";
      var defineForms = {}
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      vm.getInitDataExt = function() {
       

      };

      vm.setDetailView = function (code) {

      };

      vm.setChoiceItem = function() {

      };

      /**
       * 1Depth 정보 저장
       **/
      vm.setRootData = function() {
        
        vm.rootData.mapCode = 'ScItemType.updateScitemtype';
        ap.commit(vm.rootData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      };

      /**
       * 2Depth 정보 저장
       **/
      vm.setSubData = function() {
        vm.subData.mapCode = 'ScItemType.updateScitemtype';
        ap.commit(vm.subData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      };


      /* Sortable Container Function */

      /**
       * 해당 디렉티브가 완료되었을 시 호출되는 함수
       * html 페이지에서 initCallback으로 지정할 수 있다.
      */
      vm.succSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        
        ctrl.setRootTitle(vm.rootTitle);
        vm.getSortableList();

        //* ITEM이 추가되었을시 호출되는 함수
        ctrl.addItem = function(data, callback) {

          data.mapCode = "ScItemType.insertScitemtype";
          data.Depth = data.CodeLevel;
          data.ItemName = data.ItemNm;
          data.ParentId = data.ParentCommonCodeId;

          if(!vm.isSys && !vm.isBranch) {
            data.BranchId = vm.BranchId;
          }
          
          ap.commit(data, function(result){
            callback(result);
            //ap.alert('Menu.SAVED');
          });
        };

        ctrl.setDetailView = function(data, callback) {
          if(isNullOrEmpty(data.AttendanceType)) data.AttendanceType = 0;
          postApi.select({mapCode : 'ScItemType.getScitemtypeCodes', ItemType : "I"}, 
          function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var temp = [];
              angular.forEach(result.body.docs, function(item){
                if(item.Code != data.KeyId) temp.push(item);
              });
              vm.codeRecommendList = temp;
            }
          });

          vm.currentType = data.AttendanceType;
          vm.currentTypeNm = vm._columnMaps['AttendanceType'].CodeList[i].CodeValue;


          vm.showAttend = (data.AttendanceType == "10" || data.AttendanceType == "20" || data.AttendanceType == "40" || data.AttendanceType == "0") ? false : true;

          if(data.AttendanceType == "30") {
            $("#sec3").html('');
            av.addForm({
              PeriodExpirationCount : { target : 'sec3', type : mElemTx.number, colSize: 3, label : "사용기간", required : true},
              PeriodDuringType : { after : 'PeriodExpirationCount', type : mElemTx.select, colSize: 4, required : true},
            }, function(){

            });
          }

          // if(data.AttendanceType == "40") {
          //   var param = {};
          //   param.mapCode = "ScItemType.getScitemtyperegularDetail";
          //   param.ItemTypeId = data.KeyId
          //   postApi.select(param, function(result){
          //     vm.data.Regular = result.body.docs;
          //     $("#sec4").html('');
          //     $("#sec5").html('');
              
          //     if(vm.data.Regular.length > 0) {
          //       var temp = [];
          //       for(var i = 0; i < vm.data.Regular.length; i++) {
          //         var target = (i % 2 == 0) ? "sec4" : "sec5";        
          //         var obj = {code: "Regular[" + (vm.data.Regular[i].RegularDegree-1) +"].RegularDuring", target : target, type : mElemTx.number, colSize: 2, label : vm.data.Regular[i].RegularDegree + " 관리", required : true};
          //         temp.push(obj);
          //         obj = {code: "Regular[" + (vm.data.Regular[i].RegularDegree-1) +"].DuringType", target : target, type : mElemTx.select, colSize: 4, noLable : true, required : true, customCodes : "codeDuringType"};
          //         temp.push(obj);
          //       }
          //       av.addForm(temp, function(){ })
          //     }
          //   })
          // }

          vm.data =  data;
        };

        //* 리스트 정렬을 하였을 시 데이터를 저장한다.
        ctrl.setChangedSort = function(data) {
          var param = {};
          param.mapCode = 'ScItemType.updateChagneSort';
          param.list = data;
          postApi.update(param, function() {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          });
        };

        //* 리스트 상태 변경하기 전 함수
        //* 무조건 콜백처리를 해주어야 함
        ctrl.setChangeMenuState = function(data, callback) {
          var param = {};
          param.mapCode = "ScItemType.updateEnableList";
          param.list = data;
          postApi.update(param, function(result) {            
            callback(result);
            ap.alert('Menu.SAVED');
          });
        };
         
        ctrl.setDeleteItem = function(data, callback) {
          var param = data;
          param.mapCode = "ScItemType.deleteItem";
          postApi.update(param, function(result) {    
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              vm.getSortableList(function(){
                ap.alert('Menu.DELETED');
              });              
            }
          });
        };

        // 업종코드가 변경되었을 시
        ctrl.setChangeIndustCode = function(code, callback) {

          vm.IndustCode = code;

          var param = {
            mapCode : MAPPER_DETAIL,
            IndustCode : code
          };

          ap.getData(param, function(result){
            var docs = result.body.docs;
            vm.sbCtrl.drawList(result.body.docs);
            if(callback) callback(docs);
          });
        };

        // 지점코드가 변경되었을 시
        ctrl.setChangeBranchCode = function(code, callback) {

          vm.BranchId = code;

          var param = {
            mapCode : MAPPER_DETAIL,
            BranchId : code
          };

          ap.getData(param, function(result){
            var docs = result.body.docs;
            vm.sbCtrl.drawList(result.body.docs)
            if(callback) callback(docs);
          });

        };
      };   

      //* 데이터를 바인드하기 위함
      vm.getSortableList = function(callback) {
        var param = {
          mapCode : MAPPER_DETAIL,
          IndustCode : vm.IndustCode
        };
        
        if(vm.isBranch) delete param.IndustCode;
        ap.getData(param, function(result){
          var docs = result.body.docs;
          if(isNullOrEmpty(vm.IndustCode) && !vm.isBranch) {
            docs = [];
          }           

          vm.sbCtrl.drawList(docs)
          if(callback != undefined) callback(docs);
        })
      }

      /**
       * 노드가 추가되었을 시 호출되는 함수
       * vm.sbCtrl을 오버라이드하여 사용한다.
      */
      

      /* /Sortable Container Function */


      function getInitDataExt() {

      }

      function onReadyAutoView() {

        vm.data = {};
      }

      function setChangeAttendance(code, data) {

        if(vm.data.child.length > 0 && data != 0) {
          vm.data.AttendanceType = "0";
          av.alert("하위 유형이 존재하는 경우 수정할 수 유형그룹을 변경 할 수 없습니다.");
          return;
        }
        
        // $("#sec2").html("");
        $("#sec3").html("");
        $("#sec4").html("");
        $("#sec5").html("");

        for(var i = 0; i < vm._columnMaps['AttendanceType'].CodeList.length; i++) {
          if(vm._columnMaps['AttendanceType'].CodeList[i].Code == data) {
            vm.currentType = vm._columnMaps['AttendanceType'].CodeList[i].Code;
            vm.currentTypeNm = vm._columnMaps['AttendanceType'].CodeList[i].CodeValue;
            break;
          }
        }
        vm.showAttend = (data == "10" || data == "0" || data == "20" || data == "40") ? false : true;

        if(data == "30") {
          $("#sec3").html('');
          av.addForm({
            PeriodExpirationCount : { target : 'sec3', type : mElemTx.number, colSize: 3, label : "사용기간", required : true},
            PeriodDuringType : { after : 'PeriodExpirationCount', type : mElemTx.select, colSize: 4, required : true},
          }, function(){
            
          })
        }

        // if(data == "40") {
        //   av.addForm({
        //     RegularTotalCount : { target : 'sec4', type : mElemTx.number, colSize: 3, label : "정기관리 횟수", required : true},

        //   }, function(){
            
        //   })
        // }
      }

      function drawFrequencyDetail() {
      }

      /** @description 정기관리 DetailView 그리는 함수 **/
      var lastReqularCount = 0;
      function drawRegularDetail() {

        // if(vm.data.RegularTotalCount == lastReqularCount) {
        //   return;
        // }

        // vm.data.newRegular = "Y";

        // vm.data.Regular = [];
        // var count = vm.data.RegularTotalCount;
        // lastReqularCount = vm.data.RegularTotalCount;
        // var mngCount = 2;
        // var temp = [];
        // $("#sec4").html('');
        // $("#sec5").html('');
        // for(var i = 0; i < count; i++) {
        //   var target = (i % 2 == 0) ? "sec4" : "sec5";

        //   vm.data.Regular.push({RegularDegree: (i+1)})

        //   var obj = {code: "Regular[" + i +"].RegularDuring", target : target, type : mElemTx.number, colSize: 2, label : mngCount + " 관리", required : true};
        //   temp.push(obj);

        //   obj = {code: "Regular[" + i +"].DuringType", target : target, type : mElemTx.select, colSize: 4, noLable : true, required : true, customCodes : "codeDuringType"};
        //   temp.push(obj);
        //   mngCount++;

        // }

        // av.addForm(temp, function(){

        // })
      }

      function setData() {

        vm.data.Regular = [];
        av.commit(function(result){
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
        });
      }

      function setChangeFree() {
        vm.data.Cost = "";
        vm.data.Taxation = "N";
      }

      /** @description autoView init Callback**/
      vm.getInitDataExt = getInitDataExt;
      vm.onReadyAutoView = onReadyAutoView;
      vm.setChangeAttendance = setChangeAttendance;

      vm.drawFrequencyDetail = drawFrequencyDetail;
      vm.drawRegularDetail = drawRegularDetail;
      vm.setData = setData;
      vm.setChangeFree = setChangeFree;
      
      
      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new autoPage();
      ap.setData(pageData);
      ap.init();

      var av = new autoView();
      av.init(pageData);
      

      // autoPage 종료
      
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $stateParams - state Parameter object
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 회원사관리
   */
  webapp.controller('PenchartMngListCtrl', 
    ['$rootScope', '$scope', '$stateParams', '$translate', 'autoPage', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$window', '$timeout',
    function PenchartMngListCtrl($rootScope, $scope, $stateParams, $translate, autoPage, autoView, postApi, CONSTANT, $window, $timeout) {

      var vm = this;

      var MAPPER_DETAIL = "PenchartMng.getPenchartMngDetail";

      vm.isSys = false;
      vm.isBranch = false;
      vm.codeRecommendList = [];

      if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
      if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchCode"))) {
        vm.isBranch = true;  
      }

      vm.currentType = "";
      vm.showAttend = false;

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,

        viewType : mViewType.Edit,
        tableNm : "penchartmng",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data",

        apis : {
          // columnMap은 불러오되 업종선택을 변경하였을시에 데이터를 불러오기 위해 빈값으로 데이터 호출
          initSelect : { mapCode : MAPPER_DETAIL, param : {IndustCode : ''} },  
          //, insert : "ScCustomer.insertScitemtype" 트리에서 작업을 함으로 필요하지 않음
          update : "PenchartMng.updatePenchartMng"
        },

        callback : {
          FrequencyTotalCount : "drawFrequencyDetail",
          RegularTotalCount : "drawRegularDetail"
        },

        addRow : [],

        disabled : {
          RegDate : true
        }, 

        ngIf : {
        
        },

        noLable : [],

        customCodes : {
          
        },

        required : []
      };

      vm.datas = [];
      vm.linkData =[];

      vm.rootData = {};
      vm.subData = {};

      vm.showTabView = [];
      vm.rootTitle = "1차 분류 등록";

      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.sbCtrl = null;

      vm.rootDisabled = true;
      vm.showSubView = false;

      vm.RentalYNCode = [];
      vm.daysCode = [];

      vm.IndustCode = "";
      var defineForms = {};
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      vm.getInitDataExt = function() {
       
      };

      vm.setDetailView = function (code) {

      };

      vm.setChoiceItem = function() {

      };

      /**
       * 1Depth 정보 저장
       **/
      vm.setRootData = function() {
        
        vm.rootData.mapCode = 'PenchartMng.updatePenchartMng';
        ap.commit(vm.rootData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      };

      /**
       * 2Depth 정보 저장
       **/
      vm.setSubData = function() {
        vm.subData.mapCode = 'PenchartMng.updatePenchartMng';
        ap.commit(vm.subData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      };


      /* Sortable Container Function */

      /**
       * 해당 디렉티브가 완료되었을 시 호출되는 함수
       * html 페이지에서 initCallback으로 지정할 수 있다.
      */
      vm.sbImgCtrl = null;
      vm.succImageSortable = function(ctrl) {
        vm.sbImgCtrl = ctrl;

        ctrl.delItem = function(idx, tc) {
          $(".col-key-" + tc).animate({
              opacity : 0,
              width: "0px"
            }, 500, function() {
          });

          $timeout(function(){
            ctrl.bindData[idx].DelYN = "Y";
            var index = 1;
            for(var i = 0; i < ctrl.bindData.length; i++) {
              var at = ctrl.bindData[i];
              if(at.DelYN == "N") {
                at.Sort = index;
                index++;
              }
            }
          }, 500);
        };
      };

      vm.succListSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        
        ctrl.setRootTitle(vm.rootTitle);
        vm.getSortableList();

        //* ITEM이 추가되었을시 호출되는 함수
        ctrl.addItem = function(data, callback) {
          data.mapCode = "PenchartMng.insertPenchartMng";
          data.Depth = data.CodeLevel;
          data.ChartNm = data.ItemNm;
          data.ParentId = data.ParentCommonCodeId;
          data.FormYn = "N";
          if(!vm.isSys && !vm.isBranch) {
            data.BranchCode = vm.BranchCode;
          }
          
          ap.commit(data, function(result){
            callback(result);
          });
        };

        ctrl.setDetailView = function(data, callback) {

          vm.data =  data;
          var param = {};
          param.mapCode = 'PenchartMng.getPenchartFormDetail';
          param.KeyId = data.KeyId;
          postApi.select(param, function(result) {
            if(result.body.docs.length > 0) {
              //vm.sbImgCtrl.bindData = result.body.docs;
              var count = 100;
              angular.forEach(result.body.docs, function(item, idx){
                item.tempCode = count;
                count++;
              });

              vm.datas = result.body.docs;
            } else {
              vm.datas = [];
              //vm.sbImgCtrl.bindData = [];
            }            
          });

        };

        //* 리스트 정렬을 하였을 시 데이터를 저장한다.
        ctrl.setChangedSort = function(data) {
          var param = {};
          param.mapCode = 'PenchartMng.updateChagneSort';
          param.list = data;
          postApi.update(param, function() {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          });
        };

        //* 리스트 상태 변경하기 전 함수
        //* 무조건 콜백처리를 해주어야 함
        ctrl.setChangeMenuState = function(data, callback) {
          var param = {};
          param.mapCode = "PenchartMng.updateEnableList";
          param.list = data;
          postApi.update(param, function(result) {            
            callback(result);
            ap.alert('Menu.SAVED');
          });
        };
         
        ctrl.setDeleteItem = function(data, callback) {
          var param = data;
          param.mapCode = "PenchartMng.deleteItem";
          postApi.update(param, function(result) {    
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.getSortableList(function(){
                ap.alert('Menu.DELETED');
                vm.data = [];
              });              
            }
          });
        };

        // 업종코드가 변경되었을 시
        ctrl.setChangeIndustCode = function(code, callback) {

          vm.IndustCode = code;

          var param = {
            mapCode : MAPPER_DETAIL,
            IndustCode : code
          };

          ap.getData(param, function(result){
            var docs = result.body.docs;
            vm.sbCtrl.drawList(result.body.docs)
            if(callback) callback(docs);
          });

        };

        // 지점코드가 변경되었을 시
        ctrl.setChangeBranchCode = function(code, callback) {

          vm.BranchCode = code;

          var param = {
            mapCode : MAPPER_DETAIL,
            BranchCode : code
          }

          ap.getData(param, function(result){
            var docs = result.body.docs;
            vm.sbCtrl.drawList(result.body.docs)
            if(callback) callback(docs);
          });

        };
      };   

      //* 데이터를 바인드하기 위함
      vm.getSortableList = function(callback) {
        var param = {
          mapCode : MAPPER_DETAIL,
          IndustCode : vm.IndustCode
        };
        
        if(vm.isBranch) delete param.IndustCode;
        ap.getData(param, function(result){
          var docs = result.body.docs;
          vm.sbCtrl.drawList(docs)
          if(callback != undefined) callback(docs);
        });
      };

      /**
       * 노드가 추가되었을 시 호출되는 함수
       * vm.sbCtrl을 오버라이드하여 사용한다.
      */
      

      /* /Sortable Container Function */


      function getInitDataExt() {
        
      }

      function onReadyAutoView() {
        vm.data = [];
      }

      function setData() {

        vm.data.list = vm.datas;

        if(vm.data.list) {
          var sort = 1;
          angular.forEach(vm.data.list, function(item, index, obj){
            if(item.DelYN == "Y" && !item.PenChartMngId) {
              obj.splice(index, 1);
            } else if(item.DelYN == "N"){
              item.Sort = sort;
              sort++;
            }
          });
        }

        av.commit(function(result){
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          
          var param = {};
          param.mapCode = 'PenchartMng.getPenchartFormDetail';
          param.KeyId = vm.data.KeyId;
          postApi.select(param, function(result) {
            if(result.body.docs.length > 0) {
              //vm.sbImgCtrl.bindData = result.body.docs;
              var count = 100;
              angular.forEach(result.body.docs, function(item, idx){
                item.tempCode = count;
                count++;
              });

              vm.datas = result.body.docs;
            } else {
              vm.datas = [];
              //vm.sbImgCtrl.bindData = [];
            }            
          });
        });
      }

      /** @description autoView init Callback**/
      vm.getInitDataExt = getInitDataExt;
      vm.onReadyAutoView = onReadyAutoView;

      vm.setData = setData;
      
      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new autoPage();
      ap.setData(pageData);
      ap.init();

      var av = new autoView();
      av.init(pageData);
      

      // autoPage 종료
      
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

    }]);
})();


(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.system:business-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('BusinessDetailCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'modalFactory',
    'postApi',
    'gAlert',
    'gConfirm',
    'customFieldApi',
    '$translate',

    function BusinessDetailCtrl(
      $window,
      $rootScope,
      $scope,
      $location,
      $state,
      $stateParams,
      CONSTANT,
      StaticVariable,
      modalFactory,
      postApi,
      gAlert,
      gConfirm,
      udcApi,
      $translate
    ) {
      var vm = this;

      // 접근 권한 체크
      if (!isPageAccess('business-detail', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      // 버튼 권한 체크
      $scope.showBtnEdit = isPageAccess('business-edit', $window.sessionStorage['loginUserType'], false);
      $scope.showBtnDel = true;

      // 함수 선언
      vm.deleteDetail = deleteDetail;
      $scope.showArmyInfo = true;
      $scope.objArmyZone1YN = 'N';
      $scope.objArmyZone2YN = 'N';

      // 검색 조건
      vm.srch = {
        Session_TenantId: $window.sessionStorage['loginTenantId'],
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
        TableNm: 'Tenant',
      };

      // 조회 데이터
      vm.data = {};

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        if (vm.srch.TenantId == null || vm.srch.TenantId == '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          return;
        }

        vm.srch.mapCode = 'Business.getBusinessDetail';

        postApi.select(
          vm.srch,
          function (data) {
            console.log('load', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].UserId !== null) {
                vm.data = data.body.docs[0];
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }

      function deleteDetail() {
        gConfirm(
          '',
          'Menu.DELETECONFIRM',
          {
            btn: '',
            fn: function () {
              deleteDetailAction();
            },
          },
          {
            btn: '',
            fn: function () {},
          }
        );
      }

      function deleteDetailAction() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        console.log('before delete', vm.data);

        vm.data.TenantIds = [vm.data.TenantId];

        vm.data.mapCode = 'Business.checkDeleteDetailValidation';
        postApi.select(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt < 1) {
                vm.data.mapCode = 'Business.deleteBusinessDetail';
                postApi.update(
                  vm.data,
                  function (data) {
                    if (data.header.status == CONSTANT.HttpStatus.OK) {
                      gAlert('', 'Menu.DELETED', {
                        btn: '',
                        fn: function () {
                          $state.go('app.system.business-list');
                        },
                      });
                      return;
                    }
                  },
                  function (data) {
                    console.log("error");
                    // console.error('fail', status, data);
                    gAlert('', data.body.docs[0].errMessage);
                  }
                );
              } else {
                gAlert(
                  '',
                  "사용중인 사업은 삭제할 수 없습니다.\n사업이 중단된 경우 사용여부를 '미사용'으로 설정하세요."
                );
                return;
              }
            }
          },
          function (data) {
            console.log("error");
            // console.error('validation error >>' + data.body.docs[0].errMessage);
          }
        );
      }

      // 데이터 조회
      getData();
    },
  ]);
})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.system:business-detail-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('BusinessDetailEditCtrl', [
    '$window',
    '$rootScope',
    '$stateParams',
    '$state',
    '$scope',
    'GLOBAL_CONSTANT',
    'postApi',
    'gAlert',
    'gConfirm',
    '$translate',
    '$timeout',
    function BusinessDetailEditCtrl(
      $window,
      $rootScope,
      $stateParams,
      $state,
      $scope,
      CONSTANT,
      postApi,
      gAlert,
      gConfirm,
      $translate,
      $timeout
    ) {
      var vm = this;

      // 접근 권한 체크
      if (!isPageAccess('business-detail-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.dataloader = false;
      vm.disabledArea = false;

      // 공통코드 정의
      vm.ArmyTypeList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1010',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
        SET_DETAIL: 'Y',
      };
      vm.PermStat1List = {
        SET_DETAIL: 'Y',
      };

      vm.onArmyAreaListSelected = function () {
        var data = vm.data.ArmyAreaObj;
        console.log('vm.onArmyAreaListSelected=', data);

        if (data == null) {
          vm.data.AreaId = '';
          vm.data.AreaNm = '';
          return;
        }

        vm.data.AreaId = data.Code;
        vm.data.AreaNm = data.CodeValue;
      };

      vm.onArmyTypeListSelected = function (data) {
        if (data.Code == null) data.Code = '';

        console.log('onArmyTypeListSelected=', data);

        vm.PermStat1List.CodeType = '1380';
        vm.PermStat1List.ParentCommonCodeId = '';

        if (data == null) {
          vm.data.ArmyType = '';
          vm.data.ArmyType_ = '';
          return;
        }

        vm.data.ArmyType = data.Code;
        vm.data.ArmyType_ = data.CodeValue;

        vm.PermStat1List.ParentCommonCodeId = data.Code;
      };

      vm.onPermStat1ListSelected = function (data) {
        vm.data.PermStat1 = data.Code;
        vm.data.PermStat1_ = data.CodeValue;
      };

      vm.stateParams = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
        TableNm: 'Tenant',
      };

      // 조회 데이터
      vm.data = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
        TableNm: 'Tenant',
      };

      $scope.addRowSetting = function () {
        if (!chkValid()) return false;

        var obj = {
          TenantDetailId: 0,
          TenantId: vm.srch.TenantId,
          ArmyType: vm.data.ArmyType,
          ArmyType_: vm.data.ArmyType_ === '' || vm.data.ArmyType_ === undefined ? '-' : vm.data.ArmyType_,
          PermStat1: vm.data.PermStat1,
          PermStat1_: vm.data.PermStat1_ === '' || vm.data.PermStat1_ === undefined ? '-' : vm.data.PermStat1_,
          AreaId: vm.data.AreaId,
          AreaNm: vm.data.AreaNm,
          GoalNum: vm.data.GoalNum,
          GoalNum_: vm.data.GoalNum.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        };

        vm.list.push(obj);
      };

      $scope.removeRowSetting = function (index) {
        vm.dataloader = true;
        if (vm.list[index].TenantDetailId === 0) {
          vm.dataloader = false;
          vm.list.splice(index, 1);
        } else {
          vm.list[index].mapCode = 'Business.checkDeleteSettingValidation';
          postApi.select(
            vm.list[index],
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (!result.body.docs[0].UserExist && !result.body.docs[0].CustomerExist) {
                  deleteTenantSetting(vm.list[index], index);
                } else {
                  gAlert('', '사용중인 권역은 삭제할 수 없습니다.');
                  vm.dataloader = false;
                }
              }
            },
            function (result) {
              vm.dataloader = false;
              console.log("error");
              // console.error('Error-checkDeleteValidation' + result);
            }
          );
        }
      };

      var formatGoalNum = function () {
        vm.data.GoalNum = vm.data.GoalNum.replace(/\D/g, '').replace(/^[0]+(?=[1-9])/g, '');
      };

      var deleteTenantSetting = function (json, idx) {
        json.mapCode = 'Business.deleteTenantDetailSetting';
        postApi.update(
          json,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              $timeout(function () {
                vm.dataloader = false;
                vm.list.splice(idx, 1);
              }, 500);
            }
          },
          function (data) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-deleteTenantSetting' + data);
          }
        );
      };

      // 유효성검사
      function chkValid() {
        if (vm.data.ArmyType === undefined || vm.data.ArmyType == '') {
          gAlert('', '군별을 선택해 주세요.');
          return false;
        }

        if (vm.data.PermStat1 === undefined || vm.data.PermStat1 == '') {
          gAlert('', '소속부대를 선택해 주세요.');
          return false;
        }

        if (vm.data.AreaId === undefined || vm.data.AreaId == '') {
          gAlert('', '권역을 선택해 주세요.');
          return false;
        }

        if (vm.data.GoalNum === undefined || vm.data.GoalNum == '') {
          gAlert('', '목표인원을 입력해 주세요.');
          return false;
        }
        formatGoalNum();

        var isDuple = vm.list.some(function (e) {
          return e.ArmyType == vm.data.ArmyType && e.PermStat1 == vm.data.PermStat1 && e.AreaId == vm.data.AreaId;
        });

        if (isDuple) {
          gAlert('', '동일한 군별, 소속부대가 이미 입력되어 있습니다.');
          return false;
        } else {
          return true;
        }
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 임선규
       */
      function getData() {
        vm.dataloader = true;
        vm.srch.mapCode = 'Business.getTenantAreaForDetail';

        //권역 정보 가져오기
        postApi.select(
          vm.srch,
          function (data) {
            console.log('load', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt !== 0) {
                var areaList = data.body.docs[0].TenantArea.split(',');
                vm.ArmyAreaList = areaList.reduce(function (acc, cur) {
                  var obj = { Code: cur, CodeValue: cur };
                  acc.push(obj);
                  return acc;
                }, []);
                return;
              }
            }
            gAlert('알림', data.body.docs[0].errMessage);
          },
          function (data) {
            vm.dataloader = false;
            console.log("error");
            // console.error('fail', status, data);
            gAlert('알림', data.body.docs[0].errMessage);
          }
        );

        //상세설정 가져오기
        vm.srch.mapCode = 'Business.getTenantDetailSetting';
        postApi.select(
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              vm.list = data.body.docs;
              vm.dataloader = false;
            }
          },
          function (data) {
            vm.dataloader = false;
            console.log("error");
            // console.error('Error-getData', +data);
          }
        );
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        vm.dataloader = true;
        var jsonList = {};
        jsonList.list = vm.list.reduce(function (acc, cur) {
          if (cur.GoalNum == '' || cur.GoalNum == undefined || cur.GoalNum == null) cur.GoalNum = 0;
          acc.push(cur);
          return acc;
        }, []);
        if (vm.list.length > 0) {
          jsonList.mapCode = 'Business.updateTenantDetailSettingBatch';
          postApi.update(
            jsonList,
            function (data) {
              if (data.header.status === CONSTANT.HttpStatus.OK) {
                vm.dataloader = false;
                gAlert('', 'Menu.SAVED', {
                  btn: '',
                  fn: function () {
                    $state.go('app.system.business-list');
                  },
                });
                return;
              }
            },
            function (data) {
              vm.dataloader = false;
              console.log("error");
              // console.error('Error-setData', status, data);
              gAlert('', data.body.docs[0].errMessage);
            }
          );
        } else {
          gAlert('', 'Menu.SAVED', {
            btn: '',
            fn: function () {
              $state.go('app.system.business-list');
            },
          });
          return;
        }
      }

      // 데이터 조회
      getData();
    },
  ]);
})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.system:business-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('BusinessEditCtrl', [
    '$window',
    '$rootScope',
    '$stateParams',
    '$state',
    '$scope',
    'GLOBAL_CONSTANT',
    'postApi',
    'gAlert',
    'gConfirm',
    '$translate',
    '$timeout',
    function BusinessEditCtrl(
      $window,
      $rootScope,
      $stateParams,
      $state,
      $scope,
      CONSTANT,
      postApi,
      gAlert,
      gConfirm,
      $translate,
      $timeout
    ) {
      var vm = this;

      // 접근 권한 체크
      if (!isPageAccess('business-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
      if (isPageAccess('business-edit', $window.sessionStorage['loginUserType'])) {
        var param = {
          menuId : 'business-edit',
          userKey : $rootScope.gVariable.userKey
        };
        postApi.api('checkAuth', param, function(data){
          if(data.header.status === CONSTANT.HttpStatus.OK){
            if(!data.body.docs[0].rtn) {
              gAlert('','조회권한이 없습니다.');
              $state.go('app.dashboard');
            } 
          } else {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          }
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.dataloader = false;
      vm.disabledArea = false;

      // 공통코드 정의
      vm.ConsultNumList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1110',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };

      vm.CalculNumList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1110',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };

      vm.UseYnList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '050',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };

      vm.onSelectCallback = function (data) {
        if (data.Code == null) data.Code = '';

        if (data.CodeType == '1110') {
          vm.data.ConsultNum = data.Code;
          //          $scope.showArmyInfo = vm.data.UserType != "020";
        } else if (data.CodeType == '050') {
          vm.data.UseYn = data.Code;
        }
      };

      vm.onCalculNumSelected = function (data) {
        if (data.Code == null || data.Code === undefined) data.Code = '';

        if (data.CodeType == '1110') {
          vm.data.CalculNum = data.Code;
        }
      };

      vm.onTenentCodeSelected = function () {
        if (vm.data.TenantCodeObj == null) {
          vm.data.TenantCode = '';
          vm.data.TenantCodeNm = '';
        } else {
          vm.data.TenantCode = vm.data.TenantCodeObj.CODE;
          vm.data.TenantCodeNm = vm.data.TenantCodeObj.NAME1;
        }
      };

      vm.stateParams = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
        TableNm: 'Tenant',
      };

      // 등록/수정 표시용 컬럼 목록
      vm.srch.editColumns = [];

      // 조회 데이터
      vm.data = {
        TenantId: $stateParams.TenantId === undefined ? '' : $stateParams.TenantId,
        TableNm: 'Tenant',
      };

      // 유효성검사
      function chkValid(duple) {
        if (duple === 1) {
          gAlert('', '같은 이름을 사용하는 사업이 있습니다.<br/>다른 사업명을 입력해 주세요.');
          return false;
        }

        if (vm.data.TenantYear === undefined || vm.data.TenantYear == '') {
          gAlert('', '사업년도를 입력해 주세요.');
          return false;
        } else if (!/^[1-9]{1}\d{3}$/g.test(vm.data.TenantYear)) {
          gAlert('', '사업년도는 숫자 4자리로 입력해 주세요.');
          return false;
        }

        if (vm.data.ConsultNum === undefined || vm.data.ConsultNum == '') {
          gAlert('', '상담회차를 입력해 주세요.');
          return false;
        }

        if (vm.data.CalculNum === undefined || vm.data.CalculNum == '') {
          gAlert('', '실적산정기준을 입력해 주세요.');
          return false;
        }

        if (Number(vm.data.CalculNum) > Number(vm.data.ConsultNum)) {
          gAlert('', '실적산정기준은 상담회차보다 클 수 없습니다.');
          return false;
        }

        if (vm.data.TenantArea === undefined || vm.data.TenantArea == '') {
          gAlert('', '권역을 입력해 주세요.');
          return false;
        }

        if (vm.data.SortNum === undefined || vm.data.SortNum == '') {
          gAlert('', '정렬순서를 입력해 주세요.');
          return false;
        } else if (!/\d+/.test(vm.data.SortNum)) {
          gAlert('', '정렬순서는 숫자로 입력해 주세요.');
          return false;
        }

        vm.dataloader = true;

        vm.data.TenantArea = vm.data.TenantArea.replace(/(\s+|)(?=,)/g, '')
          .replace(/[,]\s+/g, ',')
          .replace(/[,]+(?=,)/g, '')
          .replace(/[,]$/gm, '');

        vm.data.TenantAreas = vm.data.TenantArea.split(',');
        if (vm.data.OldArea !== undefined) {
          vm.data.OldAreas = vm.data.OldArea.reduce(function (acc, cur) {
            if (vm.data.TenantAreas.indexOf(cur) === -1) {
              acc.push(cur);
            }
            return acc;
          }, []);

          if (vm.data.TenantId != '' && vm.data.OldAreas.length !== 0) {
            vm.data.mapCode = 'Business.checkUpdateDetailValidation';
            postApi.select(
              vm.data,
              function (data) {
                if (data.header.status === CONSTANT.HttpStatus.OK) {
                  if (!data.body.docs[0].dataExist) {
                    setDetail();
                    return true;
                  } else {
                    gAlert('', '삭제할 권역 중 상세설정이 등록되어 있는 권역이 있습니다.', {
                      fn: function () {
                        vm.data.TenantArea = vm.data.OldArea;
                        $timeout(function () {
                          vm.dataloader = false;
                        }, 1000);
                      },
                    });
                    return false;
                  }
                }
              },
              function (data) {
                console.log("error");
                // console.error('Error-validation' + data);
                $timeout(function () {
                  vm.dataloader = false;
                }, 1000);
                return false;
              }
            );
          } else {
            setDetail();
          }
        } else {
          setDetail();
        }
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 임선규
       */
      function getData() {
        vm.dataloader = true;
        postApi.api(
          'extSelect/Business.getExtTenantCodeList/action',
          vm.srch,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              vm.tenantCodeList = data.body.docs;
            }
          },
          function (data) {
            console.log("error");
            // console.error('extSelect-error >>' + data.body.docs[0].errMessage);
          }
        );

        if (!vm.data.TenantId) {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          vm.data.TenantId = '';
          vm.dataloader = false;
          return;
        }

        vm.srch.mapCode = 'Business.getBusinessDetail';

        postApi.select(
          vm.srch,
          function (data) {
            console.log('load', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt !== 0 && data.body.docs[0].TenantId !== null) {
                vm.data = data.body.docs[0];

                vm.data.OldArea = vm.data.TenantArea.split(',');
                vm.data.TenantCodeObj = {
                  CODE: vm.data.TenantCode,
                  NAME1: vm.data.TenantCodeNm,
                };
                vm.ConsultNumList.Code = vm.data.ConsultNum;
                vm.CalculNumList.Code = vm.data.CalculNum;
                vm.UseYnList.Code = vm.data.UseYn;
                $timeout(function () {
                  vm.dataloader = false;
                }, 500);
              }
            } else {
              gAlert('', '사업정보를 불러오는 데 실패했습니다.', {
                fn: function () {
                  $timeout(function () {
                    vm.dataloader = false;
                  }, 500);
                },
              });
            }
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
          }
        );
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        if (vm.data.TenantNm === undefined || vm.data.TenantNm == '') {
          gAlert('', '사업명을 입력해 주세요.');
          return;
        }
        //중복체크(사업명)
        vm.data.mapCode = 'Business.checkDupleBusinessName';
        postApi.select(
          vm.data,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              chkValid(data.body.docs[0].Duple);
            }
          },
          function (data) {
            console.log("error");
            // console.error('Error> BusinessEditCtrl> setData()> ' + data.body.docs[0].errMessage);
          }
        );
      }

      function setDetail() {
        console.log(vm.data);

        var successCallback = function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].TenantId !== null) {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if ($stateParams.TenantId == '') {
                    $state.go('app.system.business-list');
                  } else {
                    $state.go('app.system.business-detail', {
                      TenantId: vm.srch.TenantId,
                    });
                  }
                },
              });
              return;
            }
          } else {
            gAlert('', '사업 수정에 실패했습니다.', {
              fn: function () {
                $timeout(function () {
                  vm.dataloader = false;
                }, 500);
              },
            });
          }
        };

        var errorCallback = function (error) {
          console.log("error");
          // console.error('Error-setData', status, data);
        };

        if (vm.data.TenantId == '') {
          // 등록
          vm.data.mapCode = 'Business.insertBusinessDetail';
          postApi.insert(vm.data, successCallback, errorCallback);
        } else {
          // 수정
          vm.data.mapCode = 'Business.updateBusinessDetail';
          postApi.update(vm.data, successCallback, errorCallback);
        }
      }

      // 데이터 조회
      getData();
    },
  ]);
})();

webapp.controller('BusinessListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'gAlert',
  'gConfirm',
  '$http',
  'postApi',
  'StaticVariable',
  function BusinessListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    modalFactory,
    gAlert,
    gConfirm,
    $http,
    postApi,
    StaticVariable
  ) {
    var vm = this;
    var EXCEL_SQL = 'business.getExcelBusinessList';
    var EXCEL_TITLE = '사업 목록';

    // 접근 권한 체크
    if (!isPageAccess('business-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('business-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'business-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    $scope.showBtnDel = true;
    $scope.showBtnLinkageYN = true;
    $scope.showBtnAdd = isPageAccess('business-edit', $window.sessionStorage['loginUserType'], false);

    // 함수연결
    vm.deleteList = deleteList;
    vm.goAdd = goAdd;

    // 검색 조건
    vm.srch = {
      TenantId: $window.sessionStorage['loginTenantId'],
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
    };

    // 데이터
    vm.data = {};

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;
    vm.disabledArea = false;

    // 공통코드 정의
    vm.TenantYearList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1370',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.UseYnList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '050',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1370') {
        vm.srch.TenantYear = data.Code;
      } else if (data.CodeType == '050') {
        vm.srch.UseYn = data.Code;
      }
    };

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('business-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/system/business/business-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/system/business/business-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/system/business/business-list') !== -1)
      ) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('business-list-ctrl'));

        vm.TenantYearList.Code = vm.srch.ArmyYear;
        vm.UseYnList.Code = vm.srch.Useyn;
        vm.currentPage = vm.srch.page;
      }
    }

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };

    // 유효성검사
    function chkValid() {
      return true;
    }

    // 목록 조회
    function getList() {
      if (!chkValid()) return false;

      getListCount();

      vm.srch.page = vm.currentPage;
      console.log('vm.srch', vm.srch);
      $window.sessionStorage.setItem('jobinfoarmy-list-ctrl', angular.toJson(vm.srch));

      vm.srch.mapCode = 'Business.getBusinessList';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('Business', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록카운트 조회
    function getListCount() {
      vm.srch.mapCode = 'Business.getBusinessListCount';

      postApi.select(
        vm.srch,
        function (data) {
          console.log('Business', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.TenantIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.TenantIds.push(vm.lists[i].TenantId);
        }
      }

      console.log('before delete', vm.data);

      if (vm.data.TenantIds == null || vm.data.TenantIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'Business.checkDeleteDetailValidation';
      postApi.select(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              vm.data.mapCode = 'Business.deleteBusinessDetail';
              postApi.update(
                vm.data,
                function (data) {
                  if (data.header.status == CONSTANT.HttpStatus.OK) {
                    gAlert('', 'Menu.DELETED', {
                      btn: '',
                      fn: function () {
                        $state.reload();
                      },
                    });
                    return;
                  }
                },
                function (data) {
                  console.log("error");
                  // console.error('fail', status, data);
                  gAlert('', data.body.docs[0].errMessage);
                }
              );
            } else {
              gAlert('', "사용중인 사업은 삭제할 수 없습니다.\n사업이 중단된 경우 사용여부를 '미사용'으로 설정하세요.");
              return;
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('validation error >>' + data.body.docs[0].errMessage);
        }
      );
    }

    function goAdd() {
      if ($window.sessionStorage['loginUserType'] == '030') {
        gAlert('', '사업등록 권한이 없습니다.');
        return;
      } else {
        $state.go('app.system.business-edit', { TenantId: '' });
      }
    }

    // 페이징 관련
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;

    // 데이터 조회
    getList();
  },
]);

webapp.controller('BookMarkCtrl', ['$scope', 'postApi', 'gAlert', 'gConfirm', 'GLOBAL_CONSTANT',
    function BookMarkCtrl($scope, postApi, gAlert, gConfirm, CONSTANT){

        var LIST_SQL = 'Bookmark.getBookmarkList';
        var INSERT_SQL = 'Bookmark.insertBookmark';
        var UPDATE_SQL = 'Bookmark.updateBookmark';
        var DELETE_SQL = 'Bookmark.deleteItem';

        vm = this;

        vm.list = [];
        vm.data = {};

        function onDrop(index, obj, evt) {
            var otherObj = vm.list[index];
            var otherIndex = vm.list.indexOf(obj);
            var temp = otherObj.Sort;
            otherObj.Sort = obj.Sort;
            obj.Sort = temp;
            vm.list[index] = obj;
            vm.list[otherIndex] = otherObj;
            changeSort();
        };

        function getData(){
            var data = {};
            data.mapCode = LIST_SQL;
            postApi.select(data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                    if(result.body.docs.length > 0){
                        vm.list = result.body.docs;
                    }else{
                        vm.list = {};
                    }
                }
            }, 
            function (error) {
                console.log("error");
                // console.error('Error> setBaseMenuInfo', error);
            });
        }

        function goAdd(){
            if(isNullOrEmpty(vm.data.BmNm)){
                gAlert('', '바로가기명을 입력해주세요.');
                return false;
            }else if(isNullOrEmpty(vm.data.BmRef)){
                gAlert('', '바로가기 링크를 입력해주세요.');
                return false;
            }else{
                setData();
            }
        }
        
        function setData(){
            var data = angular.copy(vm.data);
            if(!vm.data.keyId){
                data.mapCode = INSERT_SQL;
                data.Sort = vm.list.length+1;
                postApi.insert(data, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                        gAlert('', 'Menu.SAVED', {
                            fn : function(){
                                vm.data = {};
                                getData();
                            }
                        });
                    }
                }, 
                function (error) {
                    console.log("error");
                    // console.error('Error> setBaseMenuInfo', error);
                });
            }else{
                data.mapCode = UPDATE_SQL;
                postApi.update(data, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                        gAlert('', 'Menu.SAVED', {
                            fn : function(){
                                vm.data = {};
                                getData();
                            }
                        });
                    }
                }, 
                function (error) {
                    console.log("error");
                    // console.error('Error> setBaseMenuInfo', error);
                });
            }
        }

        function delAction(){
            gConfirm('', 'Menu.DELETECONFIRM', {
                btn : '',
                fn : function() {
                    deleteData();
                }
              }, {
                btn : '',
                fn : function() {
                }
              });
        }

        function deleteData(){
            var data = angular.copy(vm.data);
            data.mapCode = DELETE_SQL;
            postApi.update(data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                    gAlert('', 'Menu.SAVED', {
                        fn : function(){
                            vm.list.forEach(function(item, idx){
                                item.Sort = idx+1;
                            });
                            changeSort();
                        }
                    });
                }
            }, 
            function (error) {
                console.log("error");
                // console.error('Error> setBaseMenuInfo', error);
            });
        }

        function changeSort(){
            var data = {};
            data.lists = vm.list;
            data.mapCode = 'Bookmark.changeSort';
            postApi.update(data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                    getData();
                    vm.data = {};
                }
            }, 
            function (error) {
                console.log("error");
                // console.error('Error> setBaseMenuInfo', error);
            });
        }

        function editData(item){
            if(vm.isDragging){
                vm.isDragging = false;
                return;
            }else{
                vm.data = item;
            }
        }

        vm.getData = getData;
        vm.setData = setData;
        vm.delAction = delAction;
        vm.goAdd = goAdd;
        vm.onDrop = onDrop;
        vm.editData = editData;

        getData();
    }
]);
(function () {
  "use strict";
  webapp.controller('BusinessManagementListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
      function BusinessManagementListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

        var vm = this;  // View Model
        vm.headerTitle = "사업관리 목록";
        vm.showDetailSearch = false;

        // 사업분류
        postApi.select({ mapCode: 'CommonCode.getCommonCodeList', CodeType: 'ERPTYPE' }, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeErpTypeCodeList = result.body.docs;
          }
        });

        // 사업관리 조회 팝업창
        vm.rentalCarModal = function (keyId) {
          var ctrl = 'RentalCarModalCtrl as vc';
          var paramData = { KeyId: keyId };

          var modalInstance = modalFactory.open('md', 'app/system/rental-car/rental-car-modal.html', ctrl, paramData);
          modalInstance.result.then(function () {
            av.search();
          }, function () {
            av.search();
          });
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_BUSINESS_MANAGEMENT",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "BusinessManagement.getBusinessManagementListCnt", param: null },
            initSelect: { mapCode: "BusinessManagement.getBusinessManagementList", param: null, excelFileName: "사업관리목록"},
          },

          addSrchStack: false,

          // List
          listCheckboxEnable: false,

          src: {
            detail: "",
            splitDetail: ""
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent
        };


        //#region 목록 삭제
        function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'RentalCar.deleteRentalCar', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelList()");
              // console.table(error);
            });
          }, function () {

          });
        }
        //#endregion 목록 삭제


        function clickevent(clickData) {
          vm.rentalCarModal(clickData.KeyId);
        }

        function onReadyAutoView() {

        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.clickevent = clickevent;
        vm.setDelList = setDelList;

        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.system:common-properties-ctrl
 * @description
 * # 공통설정
 * Controller of the 공통설정
 */

webapp.controller('CommonPropertiesCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', '$translate',
/**
 * 시스템관리 - 공통설정 Control
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function CommonPropertiesCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm, $translate) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.srch = {};

    vm.lists = [];

    /**
     * 데이터 조회
     *
     * @param
     * @return
    */
    function getList() {
      //getListCount();
      vm.dataloader = true;

      var data = vm.srch;
      postApi.sendPostApi('api/CommonProperties', 'getCommonPropertiesList', data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;

            angular.forEach(vm.lists, function(item) {
              item.makeCustomYN = 'Y';
            });
          } else {
            vm.totalItems = 0;
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'CommonProperties.getCommonPropertiesList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', status, data);
      });
    }

    function saveListComment() {
      if ($rootScope.gVariable.srchTenantId == 0 || $rootScope.gVariable.SysAdminYN != 'Y') {
        saveList();
        return;
      }

      gConfirm('', 'Menu.SAVECONFIRM', {
        btn : '',
        fn : function() {
          saveList();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function saveList() {
      //getListCount();
      if(!$scope.form1.$valid) {
        return false;
      }

      vm.dataloader = true;

      var data = {lists : []};
      angular.forEach(vm.lists, function(item) {
        if (item.makeCustomYN && item.makeCustomYN == 'Y') {
          data.lists.push(item);
        }
      });

      if (data.lists.length == 0) {
        return;
      }

      data.mapCode = 'CommonProperties.insertCommoncodeDetailBatch';

      postApi.insert(data, function(result) {
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          getList();
        }
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function addNew() {
      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var commonPropertiesId = newnum.toString(36);

      var item = {
        CommonPropertiesId:commonPropertiesId,
        isNew:'Y',
        TenantId:$rootScope.gVariable.srchTenantId,
        makeCustomYN:'Y'
      };
      vm.lists.push(item);
    }

    function checkChanged(li) {
      if (li.DelYN == 'Y') {
        if (li.isNew == 'Y') {
          angular.forEach(vm.lists, function(item, key) {
            if (item.CommonPropertiesId == li.CommonPropertiesId) {
              vm.lists.splice(key, 1);
            }
          });
        }
      }
    }

    // 함수 선언
    vm.getList = getList;
    vm.saveList = saveList;
    vm.saveListComment = saveListComment;
    vm.addNew = addNew;
    vm.checkChanged = checkChanged;

    // 데이터 조회
    getList();
  }, ]);
})();

webapp.service('CommoncodeAPISrv', [ '$resource', 'StaticVariable', function CommoncodeAPISrv($resource, StaticVariable) {
  var api = {
    doList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doSaveList : function() {
      return $resource(StaticVariable.getUrl('/api/system/updateCommoncodeListBatch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doUpdateDeviceInfoStatusCd : function() {
      return $resource(StaticVariable.getUrl('/api/device/updateDeviceInfoStatusCd.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doTreeList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeTreeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return api;
} ]);

webapp.controller('CommoncodeListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
    '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', '$filter',
    function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalWindow, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate, $filter) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxcommoncodeid = 0;
      vm.lists = [];
      vm.saveYn = true;
      vm.data = {CustomCode: 0};
      vm.CodeType = $stateParams.CodeType;
      vm.Title = $translate.instant('Menu.EM660');

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');

      vm.parentCodeValue02 = '';
      vm.parentCodeValue03 = '';
      vm.parentCodeValue04 = '';
      vm.parentCodeValue05 = '';
      vm.parentCodeValue06 = '';
      vm.parentCodeValue07 = '';
      vm.parentCodeValue08 = '';
      vm.parentCodeValue09 = '';
      vm.parentCodeValue10 = '';

      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      function resetSearch() {
        vm.srch.CodeValue = '';
        vm.data = {CustomCode: 0};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChangeCodeValue = onChangeCodeValue;
      vm.onChangeCode = onChangeCode;
      vm.onChanged = onChanged;
      vm.ChangeCustomCode = ChangeCustomCode;
      vm.parentCodeValue01 = '';
      vm.selectedScope = null;

      $scope.treeFilter = $filter('uiTreeFilter');

      $scope.availableFields = ['title'];
      $scope.supportedFields = ['title'];

      // my_tree 반드시 선언하기
      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.UseYNData = {
        CallbackTarget : '0000',
        CodeType : 'USEYN',
        Code : vm.data.UseYN,
        ReloadSeq : 1
      };

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;
        if (vm.CodeType != null) {
          data.Code = vm.CodeType;
          data.CodeType = vm.CodeType;
        }
        data.mapCode = 'CommonCode.getCommonCodeTreeList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            angular.forEach(vm.lists, function(item) {
              if (vm.CodeType == item.Code) {
                vm.Title = $translate.instant('Menu.EM660') + ' ' + item.CodeValue;
                return;
              }
            });

            refreshTree();

            // 트리 펼치기
            if (vm.CodeType == '') {            
              $timeout(function() {
                return $scope.collapseAll();
              }, 1);
            }
          }
        }, function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "title" : jsonObj[i].label,
            "id" : jsonObj[i].guid,
            "items" : jsonObj[i].children,
            "classes" : jsonObj[i].classes,
            "codeType" : jsonObj[i].codeType,
            "code" : jsonObj[i].code
          };
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(scope) {
        var nodeData = scope.$modelValue;
        vm.selectedScope = scope;
        angular.forEach(vm.lists, function(item) {
          if (nodeData.id == item.CommonCodeId.toString()) {
            vm.data = item;
            vm.UseYNData = {
              CallbackTarget : '0000',
              CodeType : 'USEYN',
              Code : vm.data.UseYN,
              ReloadSeq : (new Date()).getTime()
            };

            console.log(scope.$parent);

            return;
          }
        });

        vm.parentCodeValue01 = '';
        var pBranch = scope.$parent.node;
        if (pBranch) {
          angular.forEach(vm.lists, function(pItem) {
            if (pBranch.id == pItem.CommonCodeId.toString()) {
              vm.parentCodeValue01 = pItem.CodeValue01;
              return;
            }
          });
        }

        vm.parentCodeValue02 = '';
        vm.parentCodeValue03 = '';
        vm.parentCodeValue04 = '';
        vm.parentCodeValue05 = '';
        vm.parentCodeValue06 = '';
        vm.parentCodeValue07 = '';
        vm.parentCodeValue08 = '';
        vm.parentCodeValue09 = '';
        vm.parentCodeValue10 = '';
        var pParent = scope.$parent.$parentNodeScope ? scope.$parent.$parentNodeScope.node : null;
        if (pParent) {
          console.log(pParent.id);
          if (pParent) {
            angular.forEach(vm.lists, function(pItem) {
              if (pParent.id == pItem.CommonCodeId.toString()) {
                vm.parentCodeValue02 = pItem.CodeValue02;
                vm.parentCodeValue03 = pItem.CodeValue03;
                vm.parentCodeValue04 = pItem.CodeValue04;
                vm.parentCodeValue05 = pItem.CodeValue05;
                vm.parentCodeValue06 = pItem.CodeValue06;
                vm.parentCodeValue07 = pItem.CodeValue07;
                vm.parentCodeValue08 = pItem.CodeValue08;
                vm.parentCodeValue09 = pItem.CodeValue09;
                vm.parentCodeValue10 = pItem.CodeValue10;
                return;
              }
            });
          } 
        }
      };

      $scope.treeOptions = {
        accept: function(sourceNodeScope, destNodesScope, destIndex) {
          if (sourceNodeScope.$parentNodeScope == null && destNodesScope.$parent.$modelValue == null) {
            return true;
          }

          if (sourceNodeScope.$parentNodeScope == null || destNodesScope.$parent.$modelValue == null || sourceNodeScope.$parentNodeScope.$modelValue.id != destNodesScope.$parent.$modelValue.id) {
            return false;
          }

          return true;
        },
        dropped: function(event) {
          if (event.source.index == event.dest.index) {
            return;
          }

          var data = {lists : []};
          angular.forEach(event.dest.nodesScope.$modelValue, function(item, index) {
            data.lists.push({CommonCodeId:item.id, Sort:(index + 1)});
          });

          data.mapCode = 'CommonCode.reorderCommonCodeBatch';
          postApi.update(data, function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              $rootScope.showSimpleToast('정렬순서가 저장되었습니다.');

              angular.forEach(vm.lists, function(oldItem) {
                angular.forEach(data.lists, function(newItem) {
                  if (oldItem.CommonCodeId == newItem.CommonCodeId) {
                    oldItem.Sort = newItem.Sort;
                  }
                });

                if (vm.data.CommonCodeId == oldItem.CommonCodeId) {
                  vm.data.Sort = oldItem.Sort;
                }
              });
            }
          }, function(error) {
            console.log("error");
            // console.error('fail', status, data);
          });
        },
      };      

      function delNode() {
        var commonCodeId = '';
        if (vm.selectedScope == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            } else {
              vm.data.DelYN = 'Y';
              saveData(null);
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree(scope) {
        var commonCodeId = '';
        if (scope == null) return;

        var nodeData = scope.$modelValue;
        if (nodeData == null) return;

        angular.forEach(vm.lists, function(item) {
          if (nodeData.id == item.CommonCodeId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);
            return;
          }
        });

        vm.data = {CustomCode: 0};
        
        scope.remove();
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.CodeValue);
          data.guid = item.CommonCodeId;
          data.parent = item.ParentCommonCodeId == undefined || item.ParentCommonCodeId == 0 ? null : item.ParentCommonCodeId;
          data.classes = item.TenantId == '0' ? '' : 'color-red';
          data.codeType = item.CodeType;
          data.code = item.Code;

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.CommonCodeId > vm.maxcommoncodeid) {
            vm.maxcommoncodeid = item.CommonCodeId;
          }
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;
      }

      function onChangeCodeValue() {
        onChanged();
        if (vm.selectedScope != null) {
          vm.selectedScope.$modelValue.title = '[*]' + vm.data.CodeValue;
        }        
      }

      function onChangeCode() {
        onChanged();
        if (vm.data.New == 'Y') {
        }

        if (vm.parentCodeValue01) {
          vm.data.CodeValue01 = vm.parentCodeValue01 + "." + vm.data.Code;
        } else {
          vm.data.CodeValue01 = vm.data.Code;
        }
      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function removeNode(jsonObj, commonCodeId) {
        for (var i = 0; i < jsonObj.length; i++) {
          // console.log('jsonObj[i]=', jsonObj[i]);
          // console.log('CommonCodeId=', commonCodeId);

          if (jsonObj[i].data == commonCodeId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, commonCodeId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData(scope) {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'CommonCode.insertCommoncodeDetailBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
//            scope.label = nodeData.title.replace(/^\[\*\]/,"");
            if (scope != null) {
              scope.remove();
            } else {
              if (vm.selectedScope != null) {
                vm.selectedScope.$modelValue.title = vm.data.CodeValue;
              }
            }

            angular.forEach(data.lists, function(item) {
              angular.forEach($scope.my_data, function(d) {
                console.log(d);
              });

              if (item.New == 'Y') {
                $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                vm.data.New = '';
              } else if (item.DelYN == 'Y') {
                $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
                deleteNodeTree();
              } else {
                $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                vm.data.Edit = '';
              }
            });
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        });

      }

      function ChangeCustomCode() {
        console.log($rootScope.gVariable);
        if (vm.data.CustomCode == 0) {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTART'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              data.NewCommonCodeId = newnum.toString(36).toUpperCase();
              data.mapCode = 'CommonCode.makeCustomCommonCode';
              postApi.insert(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 1;
                }
              }, function(error) {
                console.log("error");
                // console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        } else {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTOP'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              data.mapCode = 'CommonCode.removeCustomCommonCode';
              postApi.update(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 0;
                }
              }, function(error) {
                console.log("error");
                // console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }
      }

      $scope.$watch( 'currentNode', function( newObj, oldObj ) {
        if( $scope.currentNode && angular.isObject($scope.currentNode) ) {
            console.log( 'Node Selected!!' );
            console.log( $scope.currentNode );
        }
      }, false);

      $scope.removeItem = function (scope) {
        var branch = scope.$modelValue;
        var commonCodeId = '';
        if (branch == null) return;

        if (scope.$childNodesScope.$modelValue != null && scope.$childNodesScope.$modelValue.length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree(scope);
            } else {
              angular.forEach(vm.lists, function(item) {
                if (branch.id == item.CommonCodeId.toString()) {
                  vm.data = item;
                  return;
                }
              });

              vm.data.DelYN = 'Y';
              saveData(scope);
              vm.data = {CustomCode: 0};
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      };

      $scope.toggle = function (scope) {
        scope.toggle();
      };

      $scope.moveLastToTheBeginning = function () {
        var a = $scope.data.pop();
        $scope.data.splice(0, 0, a);
      };

      $scope.newSubItem = function (scope) {
        if (scope != undefined) {
          scope.expand();
        }
        
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var commonCodeId = newnum.toString(36);

        var uiTreeScope = (scope != null) ? scope : angular.element(document.getElementById("tree-root")).scope().$nodesScope;
        //console.log(uiTreeScope);
        var nodeData = (scope != null) ? scope.$modelValue : $scope.my_data;
        var commoncode = null;
        var code = {};
        if ($rootScope.gVariable.srchTenantId == 0) {
          code = {title: '[*]새로운 코드', id: commonCodeId, classes: '', items: []};
        } else {
          code = {title: '[*]새로운 코드', id: commonCodeId, classes: 'color-red', items: []};
        }

        if (scope == null) {
          var sortNum = getSortNum('0');

          commoncode = {
            'CodeValue' : '새로운 코드',
            'CommonCodeId' : commonCodeId,
            'ParentCommonCodeId' : 0,
            'CodeLevel' : 1,
            'UseYN' : 'Y',
            'New' : 'Y',
            'Sort' : sortNum,
            'CodeType' : '',
            'TenantId' : $rootScope.gVariable.srchTenantId,
            'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
          };
          vm.lists.push(commoncode);
          nodeData.push(code);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (nodeData.id == item.CommonCodeId.toString()) {
              var sortNum = getSortNum(nodeData.id);

              commoncode = {
                'CodeValue' : '새로운 코드',
                'CommonCodeId' : commonCodeId,
                'ParentCommonCodeId' : nodeData.id,
                'CodeLevel' : item.CodeLevel + 1,
                'UseYN' : 'Y',
                'New' : 'Y',
                'Sort' : sortNum,
                'CodeType' : item.Code,
                'TenantId' : $rootScope.gVariable.srchTenantId,
                'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1,
                'CodeValue01' : item.CodeValue01
              };
              vm.lists.push(commoncode);
              vm.parentCodeValue01 = item.CodeValue01;
              return;
            }
          });

          if (nodeData.items == null) {
            nodeData.items = [];
          }

          nodeData.items.push(code);
        }

        if (uiTreeScope != null) {
          var childNodes = uiTreeScope.childNodes();
          if (childNodes != null) {
            console.log(childNodes);
            var cnt = uiTreeScope.childNodes().length;
            console.log(cnt);
            $timeout(function(){
              vm.selectedScope = uiTreeScope.childNodes()[cnt - 1];
              //console.log(vm.selectedScope);
            }, 100);
          }
        }
        vm.data = commoncode;
      };

      $scope.collapseAll = function () {
        var uiTreeScope = angular.element(document.getElementById("tree-root")).scope().$nodesScope;
        console.log(uiTreeScope.childNodes());
        angular.forEach(uiTreeScope.childNodes(), function(item) {
          item.collapse();
        });
//        $scope.$broadcast('angular-ui-tree:collapse-all');
      };

      $scope.expandAll = function () {
        var uiTreeScope = angular.element(document.getElementById("tree-root")).scope().$nodesScope;
        console.log(uiTreeScope.childNodes());
        angular.forEach(uiTreeScope.childNodes(), function(item) {
          item.expand();
        });
//        $scope.$broadcast('angular-ui-tree:expand-all');
      };

      function getSortNum(ParentCommonCodeId) {
        var maxSortNum = 0;
        angular.forEach(vm.lists, function(item) {
          if (item.ParentCommonCodeId == ParentCommonCodeId) {
            if (maxSortNum < item.Sort) {
              maxSortNum = item.Sort;
            }
          }
        });

        return maxSortNum + 1;
      }
    } ]);


webapp.service('CompanyAPISrv', ['$resource', '$rootScope', 'StaticVariable',
  function CompanyAPISrv($resource, $rootScope, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantCount/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/updateTenant.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/insertTenant.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Tenant.deleteTenantDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name company-charge-listt-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('CompanyChargeDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyChargeDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'PaymentInfo.getTenantChargeDetail';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-charge-list';         // 목록 화면
      var VIEW_PAGE_URL = 'app.system.company-charge-detail';  // 목록 조회  화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Payment.tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      
      // 조회 데이터 설정
      vm.data = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.data.selectType = "Detail"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = 'N';
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getDetail();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getDetail() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        var data = vm.data;
        data.keyId = $stateParams.keyId;
        data.RegDateFrom = $stateParams.regDateFrom;
        data.RegDateTo = $stateParams.regDateTo;
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.mapCode = LIST_SQL;
        data.RegDateFrom = moment($stateParams.regDateFrom).format("YYYY-MM-DD");
        data.RegDateTo = moment($stateParams.regDateTo).format("YYYY-MM-DD");
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.docs.length > 0) {
              data.TenantNm = result.body.docs[0].TenantNm;
              data.JoinDt = moment(result.body.docs[0].JoinDt).format('YYYY-MM-DD');
              data.ExpiDt = moment(result.body.docs[0].ExpiDt).format('YYYY-MM-DD');
              data.ServFee = result.body.docs[0].ServFee;
              data.ServPoint = result.body.docs[0].ServPoint;
              data.CountSMS = result.body.docs[0].CountSMS;
              data.CountMMS = result.body.docs[0].CountMMS;
              data.CostSMS = result.body.docs[0].CostSMS;
              data.CostMMS = result.body.docs[0].CostMMS;
              data.CountMember = result.body.docs[0].CountMember;
              data.CountMemberSMS = result.body.docs[0].CountMemberSMS;
              data.CountMemberLMS = result.body.docs[0].CountMemberLMS;
              data.CountGroup = result.body.docs[0].CountGroup;
              data.CountGroupSMS = result.body.docs[0].CountGroupSMS;
              data.CountGroupLMS = result.body.docs[0].CountGroupLMS;
              data.CountAuto = result.body.docs[0].CountAuto;
              data.CountAutoSMS = result.body.docs[0].CountAutoSMS;
              data.CountAutoLMS = result.body.docs[0].CountAutoLMS;

              data.SumSMS = data.CostSMS * data.CountSMS;
              data.SumLMS = data.CostMMS * data.CountMMS;
              data.Total = data.SumSMS + data.SumLMS ;
            } else {
              console.log("error");
              // console.error('Error> getDetail()> 정보 조회 오류');
              // console.table(data);
            }

          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getDetail()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 함수 정의
      vm.getDetail = getDetail;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.goList = goList;

      // 목록 조회
      getDetail();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name company-charge-listt-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('CompanyChargeListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyChargeListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'PaymentInfo.getTenantChargeListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'PaymentInfo.getTenantChargeList';    // 목록 조회 SQL
      var EXCEL_SQL = 'PaymentInfo.getTenantChargeList'; 

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-charge-list';         // 목록 화면
      var VIEW_PAGE_URL = 'app.system.company-charge-detail';  // 목록 조회  화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Payment.tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '회원사 사용료 조회'; //User 엑셀파일 이름

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      
      var toDate = new Date();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          RegDateFrom : new Date(toDate.getFullYear(), toDate.getMonth(), 1),
          RegDateTo : new Date(toDate.getFullYear(), toDate.getMonth()+1, 0)
          //Year : toDate.getFullYear() + '',
          //Month : toDate.getMonth() + 1 < 10 ? ( '0' + (toDate.getMonth() + 1) ) : (toDate.getMonth() + 1) + ''
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = 'N';
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        if(vm.RegDateFrom == undefined && vm.RegDateTo == undefined) {
          vm.RegDateFrom = vm.srch.RegDateFrom;
          vm.RegDateTo = vm.srch.RegDateTo; 
        }
        vm.srch.RegDateFrom = moment(data.RegDateFrom).format('YYYY-MM-DD');
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        vm.srch.RegDateTo = moment(data.RegDateTo).format('YYYY-MM-DD');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      vm.getExcelFile2 = function() {
        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }
        var header = [];
        //var a = document.createElement("a");
        //document.body.appendChild(a);
        var data = angular.copy(vm.srch);
        data.selectType = "List";
        data.viewSize = 0;
        //data.mapCode = pageData.MapperId.excel.EXCEL_SQL;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];
            var obj = [];
            angular.forEach(result.body.desc, function (item) {
              if(item.ListColumnShowYN == "Y" && item.ListColumnShowLevel != 'showlevel0') {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(result.body.desc, function(item) {
                if(item.ColumnLogicalDataType == '40') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    //obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    obj.push(moment(value[item.ColumnPhysicalNm]).format('YYYY-MM-DD'));
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }

              });
              $scope.exportData.push(obj);
            });     
            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      };

      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        var RegDateFrom = vm.srch.RegDateFrom; // 검색 옵션
        var RegDateTo = vm.srch.RegDateTo; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            regDateFrom: RegDateFrom,
            regDateTo: RegDateTo
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            regDateFrom: RegDateFrom,
            regDateTo: RegDateTo
          });
        }
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.goDetail = goDetail;

      // 목록 조회
      getList();

      // 초기 데이터 설정
//      setInitData();
    }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.bbspost:company-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('CompanyDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',


    /**
     * 회원사관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          api - CompanyApiSvr Module
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function CompanyDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          TenantId : $stateParams.srch.TenantId ? $stateParams.srch.TenantId : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'tenant',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.TenantId) {
        vm.srch.TenantId = $stateParams.TenantId;
      }

      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        tableNm : 'tenant',
        TenantId : vm.srch.TenantId,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Tenant.getTenantDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {

                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === 'Y') {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {

        /* vm.srch.tableNm = 'Companys';
        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        } */

        var data = vm.srchDetail;
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                }

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        }, function(data) {
          console.log("error");
          // console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.data;
        data.mapCode = 'Tenant.deleteTenantDetail';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.system.company-list', {
                  srch:srch
                }, {reload:'app.system.company-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> company-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.system.company-list', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.system.company-edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        } else {
          $state.go('app.system.company-list.edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        }
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.deleteDetail = deleteDetail;
      vm.goList = goList;
      vm.goEdit = goEdit;

      // 데이터 조회
      getData();
      getFileList();
  } ]);
})();



  (function () {
    "use strict";
    /**
     * @ngdoc function
     * @name app.system:company-edit-ctrl
     * @param {object} $window - window object
     * @param {object} $rootScope - rootScope object
     * @param {object} $stateParams - state Parameter object
     * @description
      * # 회원사관리 등록/수정
      * Controller of the 회원사관리
     */

    webapp.controller('CompanyEditCtrl', ['$window', '$rootScope', '$stateParams', '$state',
      function CompanyEditCtrl($window, $rootScope, $stateParams, $state) {

        // #region 상수 정의

        // 관련 화면 정의
        var LIST_PAGE_URL = 'app.system.company-list';             // 목록 화면
        var LIST_VIEW_PAGE_URL = 'app.system.company-list.edit'; // 목록 수정 화면
        var VIEW_PAGE_URL = 'app.system.company-edit';           // 수정 화면

        // View Model
        var vm = this;          // View Model

        if ($window.sessionStorage['loginSysAdminYN'] == 'Y') {
          vm.title = '회원사';
        } else {
          vm.title = '자사';
        }

        vm.layout = $state.current.name.indexOf('company-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
        vm.url = $state.current.url;

        if ($stateParams.keyId == '') {
          $('#tab2').css('display', 'none');
        }

        function setChangeTab(tabId) {
          var viewPageUrl = '';

          if (vm.layout == 'N') {
            viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
            // 수정
            $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
          } else {
            viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
            // 목록.수정 화면 이동
            $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
          }
        }

        // 함수 정의
        vm.setChangeTab = setChangeTab;
      }]);

  })();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('CompanyEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter', 'fileUploadService',

    function CompanyEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter, fileUploadService) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Tenant.insertTenantBatch';     // 등록 SQL
      var UPDATE_SQL = 'Tenant.updateTenantDetail';     // 수정 SQL
      var VIEW_SQL = 'Tenant.getTenantDetail'; // 조회 SQL
      var DEL_SQL = 'Tenant.deleteTenantDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.company-list.edit.tab1'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.company-edit.tab1';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true;
        vm.title = '회원사';
      } else {
        vm.title = '자사';
      }

      vm.checkZero = false;
      if($window.sessionStorage["loginTenantId"] == "0") {
        vm.checkZero = true;
      }

      vm.TenantId = $window.sessionStorage["loginTenantId"];

      if ($state.current.name == "app.systenant.company-info.tab1") {
        $stateParams.keyId = $window.sessionStorage["loginTenantId"];
      }     

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.tableNm) vm.srch.tableNm = KEY_TABLE_NM;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.log("error");
              // console.error("Error> onFileDelete()");
              // console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출

      /**
       * 부서 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};
        var modalInstance = modalFactory.open("modal", "components/modal/department/dept-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            // 부서 선택
            vm.data.DeptNm = okData.label;
            vm.data.DeptId = okData.data;
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 부서 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseDept = function () {
        vm.data.DeptNm = "";
        vm.data.DeptId = "";
      };
      // #endregrion 부서 검색 팝업 호출

      // #region 회원사 검색 팝업 호출

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          vm.data.TenantNm = okData.TenantNm;
          vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      // #region 역할 검색 팝업 호출

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.srch.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출

      vm.setChangeTenant = function() {
        $window.sessionStorage.setItem('srchTenantId', vm.data.KeyId);
        $window.sessionStorage.setItem('srchTenantName', vm.data.TenantNm);
        $rootScope.gVariable.srchTenantId = vm.data.KeyId;
        $rootScope.gVariable.srchTenantName = vm.data.TenantNm;
        $rootScope.$broadcast('broadcastSetChangeTenantID', vm.data);
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        //vm.srchDetail.srchTenantId = vm.data.KeyId;

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              angular.element("#userPhoto").css("background-image", "url(" + vm.data.PhotoUrl + ")");
              // 역할 설정
              vm.data.UserRoles = [];
              vm.data.ServiceExpireDate = $filter("autoViewUtcToLocal")(vm.data.ServiceExpireDate, 'YYYY-MM-DD');

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });


              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });

              initRadioMenuType();
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {

        vm.data.MenuTypeList = [];
        angular.forEach(vm.radioMenuType, function(item) {
          if (item.checked) {
            vm.data.MenuTypeList.push(item);
          }
        });

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /* 사용자 사진 업로드 관련 함수 시작 */
      var fileElement = angular.element("#photoUserFile");
      vm.openAttachDilalog = function() {
        fileElement.trigger("click");
      };

      fileElement.bind('change', function(){
        var reader = new FileReader();
        reader.onload = function (e) { vm.photoSrc = e.target.result;}
        vm.photoSrc = $(fileElement).val();
        vm.onChangeHandler(fileElement[0].files);
      });

      vm.onChangeHandler = function(files) {
        vm.uploadFiles(files);
      };

      $scope.$on('cancelFileSend', function(event, args) {
        if (request) {request.about(); }
      });

      vm.uploadFiles = function(files) {
        if(files.length == 0) return;
        var tempIds = [];
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;
          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false, fileName : value.name, size : value.size, delState : '', id : 0
              };
              tempIds.push(obj);
              if (vm.fileData == null) vm.fileData = new Array();
              vm.fileData.push(angular.copy(obj));
            }
          });
          if (hasZeroByteFile) {
            alert('빈 파일이 있습니다.');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/file/imageupload.do?userkey='+$rootScope.gVariable.userKey))
            .then(function(value) {

              var fileUrl = value.data.split("&");
              for(var i = 0; i < fileUrl.length; i++ ) {
                if(fileUrl[i].indexOf("sFileURL") != -1) {
                  fileUrl = fileUrl[i].replace("sFileURL=", "");
                }
              }
              if(isNullOrEmpty(fileUrl)) {

              } else {
                vm.setUserPhoto(fileUrl);
              }             
              vm.showLoading = false;
            }, function(reason) {
              console.log(reason);
            });
          } catch (err) {
            console.log(err);
          }
        });
      };

      vm.setUserPhoto = function(fileUrl) {
        vm.data.photoUrl = StaticVariable.getUrl(fileUrl);
        angular.element("#userPhoto").css("background-image", "url(" + vm.data.photoUrl + ")");
      };

      /* 사용자 사진 업로드 관련 함수 종료 */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.TenantNm)) {
          errMsg = errMsg + '- Shop명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Ceo)) {
          errMsg = errMsg + '- 대표자명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.TenantStatus)) {
          errMsg = errMsg + '- 상태를 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.TenantStatus)) {
          errMsg = errMsg + '- 가입일을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.MenuTypeList)){
          errMsg = errMsg + '- 메뉴그룹을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.PayType)){
          errMsg = errMsg + '- 결제구분을 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getUploadFileList()");
          // console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.log("error");
          // console.error("Error> getRoleList()");
          // console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        //vm.data.srchTenantId = vm.data.KeyId;
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        if(vm.data.JoinDt != null ) vm.data.JoinDt = $filter('localToUtc')(vm.JoinDt);
        if(vm.data.LeaveDt != null ) vm.data.LeaveDt = $filter('localToUtc')(vm.LeaveDt);
        if(vm.data.ExpiDt != null ) vm.data.ExpiDt = $filter('localToUtc')(vm.ExpiDt);

        vm.data.Addr1 = $('#addr1').val();
        vm.data.ZipCode = $('#zipCode').val();

        var msg = '';

        if (!isNullOrEmpty(vm.data.ServPoint)) {
          if((vm.data.CostSMS === null || vm.data.CostSMS === undefined)) {
            msg = msg + 'SMS 단가 금액을 입력해주시기 바랍니다.<br>';
          }
          if((vm.data.CostLMS === null || vm.data.CostLMS === undefined)) {
            msg = msg + 'LMS 단가 금액을 입력해주시기 바랍니다.<br>';
          }
          if((vm.data.CostMMS === null || vm.data.CostMMS === undefined)) {
            msg = msg + 'MMS 단가 금액을 입력해주시기 바랍니다.<br>';
          }
          if((vm.data.CostKAKAO === null || vm.data.CostKAKAO === undefined)) {
            msg = msg + '알림톡 단가 금액을 입력해주시기 바랍니다.<br>';
          }
          if((vm.data.CostEMAIL === null || vm.data.CostEMAIL === undefined)) {
            msg = msg + 'Email 단가 금액을 입력해주시기 바랍니다.';
          }

          if (!isNullOrEmpty(msg)) {
            gAlert('', msg);
            return false;
          }
        }

        var data = vm.data; // 사용자 입력 데이터

        vm.dataloader = true;

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setInsertUpdateDetail(result);
          }, function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error("Error> setData()");
            // console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            vm.dataloader = false;
            setInsertUpdateDetail(result);
          }, function (error) {
            vm.dataloader = false;
            console.log("error");
            // console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.log("error");
          // console.error("Error> delDataAction()");
          // console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }

      /* 다음 주소검색 */
      function getAddressInfo(){
        new daum.Postcode({
          oncomplete: function(data) {
            vm.zipCode = data.zonecode;
            vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
            $('#zipCode').val(vm.zipCode);
            $('#addr1').val(vm.addr1);
          },
        }).open();

      }

      function kioskCnChk() {
        if (vm.data.KioskCn.length > 25) {          
          gAlert('최대 25글자까지 입력이 가능합니다.');
          vm.data.KioskCn = vm.data.KioskCn.substring(0,25);          
        }
      }

      function initRadioMenuType() {
        var data = { mapCode: 'Menu.getMenuType', code: '' };
        postApi.select(data, function (response) {
          if (response.header.status == CONSTANT.HttpStatus.OK) {
            vm.radioMenuType = [];
            
            if (vm.srchDetail.srchTenantId == '') {
              angular.forEach(response.body.docs, function(item){
                if (item.code != "ROOTMENU") {
                  if (item.code != "MEMBERMENU" && item.code != "DEFAULTMENU") {
                    item.checked = true;                    
                  }
                  vm.radioMenuType.push(item);
                }
              });
            } else {
              vm.radioMenuType = response.body.docs;
            }

            if (vm.data.MenuTypes) {
              var menuTypeList = vm.data.MenuTypes.split(',');

              angular.forEach(vm.radioMenuType, function(menu) {
                angular.forEach(menuTypeList, function(item) {
                  if (menu.code == item) {
                    menu.checked = true;
                    return;
                  }
                });
              });
            }
          }
        }, function (e) { console.log("error"); });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      vm.setChangeTab = setChangeTab;
      vm.getAddressInfo = getAddressInfo;   // 주소검색

      vm.kioskCnChk = kioskCnChk;
      // 데이터 조회
      getData();
      initRadioMenuType();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-edit-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CompanyEditTab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CompanyEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'User.getUserTenantListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getUserTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list.edit.tab2';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.system.company-list.edit.tab2';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'userstenantlist'; // 작업 테이블명
      var EXCEL_TITLE = '회원사관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      vm.loginSysAdminYN = false;
      if($window.sessionStorage["loginSysAdminYN"] == "Y") {
        vm.loginSysAdminYN = true
      }


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수



      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          //vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      vm.gotoUserDetail = function(li) {
        var p = {};
        p.srch = '';
        p.keyId = li.UserId
        if (vm.layout == 'N') {
          $state.go('app.system.user-edit.tab1', p, {reload: 'app.system.user-edit'});
        } else  {
          $state.go('app.system.user-list.edit.tab1', p, {reload: 'app.system.user-list.edit.tab1'});
        }
      }
      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }

      vm.moveTenantUser = function() {
        
        var cti =  $window.sessionStorage['srchTenantId'];
        if(cti != vm.srch.keyId) {
          gAlert('', "회원사 관리모드로 변경합니다.", {
            btn : '',
            fn : function(){

              var data = angular.copy(vm.srch);
              data.mapCode = "Tenant.getTenantDetail";
              postApi.select(data, function (result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  $window.sessionStorage.setItem('srchTenantId', result.body.docs[0].KeyId);
                  $window.sessionStorage.setItem('srchTenantName', result.body.docs[0].TenantNm);
                  $rootScope.gVariable.srchTenantId = result.body.docs[0].KeyId;
                  $rootScope.gVariable.srchTenantName = result.body.docs[0].TenantNm;
                  $rootScope.$broadcast('broadcastSetChangeTenantID', result.body.docs[0]);
                  $state.go('app.system.user-list', {srch:''} , {reload: 'app.system.user-list'});
                }
              });
              

            }
          })
        } else{
          $state.go('app.system.user-list', {srch:''} , {reload: 'app.system.user-list'});
        }
      }

      // 함수 정의
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CompanyListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Tenant.getTenantList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.company-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.company-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.company-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = '회원사관리 리스트'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      (function CompanyListCtrl() {
        // 페이징
      })();

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      /* function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'JoinDt' || item.ColumnPhysicalNm == 'LeaveDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      } */


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }

      vm.getExcelFile2 = function() {
        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }
        var header = [];
        //var a = document.createElement("a");
        //document.body.appendChild(a);
        var data = angular.copy(vm.srch);
        data.selectType = "List";
        data.viewSize = 0;
        //data.mapCode = pageData.MapperId.excel.EXCEL_SQL;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];
            var obj = [];
            angular.forEach(result.body.desc, function (item) {
              if(item.ListColumnShowYN == "Y" && item.ListColumnShowLevel != 'showlevel0') {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(result.body.desc, function(item) {
                if(item.ColumnLogicalDataType == '40') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    //obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    obj.push(moment(value[item.ColumnPhysicalNm]).format('YYYY-MM-DD'));
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }

              });
              $scope.exportData.push(obj);
            });     
            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      };

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CompanyPayDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function CompanyPayDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var VIEW_SQL = 'PaymentInfo.getPaymentInfoDetail2'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-pay-list';         // 목록 화면
      var VIEW_PAGE_URL = 'app.system.company-pay-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'PaymentInfo2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Detail"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                
                vm.uploadFileList.push(obj);
              });
            } else {

              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.log("error");
            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if(vm.formType == 'EMAIL') {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.data.Contents = $("#strHtml").val();
        }

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getUploadFileList()");
          // console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        
//        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터

        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.log("error");
          // console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              formType: vm.formType,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch,formType:vm.formType, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.log("error");
          // console.error("Error> delDataAction()");
          // console.table(error);
        });
      }
      
      
      /**
       * 인증 확인
       * @param
       * @return
       */
      function setUpdate() {
        gConfirm('', '인증승인을 하시겠습니까?', {
          btn : '',
          fn : function() {
            seUpdateAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function seUpdateAction() {
        var data = vm.srch;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '인증승인 처리가 완료 되었습니다.', {
              btn : '',
              fn : function() {
                getData();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

//      vm.setData = setData;                     // 데이터 저장
//      vm.uploadFile = uploadFile;
//      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
//      vm.setDelData = setDelData;               // 데이터 삭제
//      vm.setUpdate = setUpdate;                   // 인증승인
      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name company-charge-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('CompanyPayListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyPayListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'PaymentInfo.getPaymentInfoListCnt2'; // 목록 건수 조회 SQL
      var LIST_SQL = 'PaymentInfo.getPaymentInfoList2';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-pay-list';         // 목록 화면
      var VIEW_PAGE_URL = 'app.system.company-pay-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'PaymentInfo2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;
        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      
      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }



      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.goDetail = goDetail;
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      // 목록 조회
      getList();

      // 초기 데이터 설정
//      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('RecommenderListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Recommender.getRecommenderCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Recommender.getRecommenderList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Recommender.getRecommenderList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.sysinfo.recommender-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.sysinfo.recommender-list.detail';  // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.sysinfo.recommender-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'recommender'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = '회원사관리 리스트'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'ASC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'TenantNm'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      (function CompanyListCtrl() {
        // 페이징
      })();

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      /* function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'JoinDt' || item.ColumnPhysicalNm == 'LeaveDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      } */


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }

      vm.getExcelFile2 = function() {
        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }
        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }
        var header = [];
        //var a = document.createElement("a");
        //document.body.appendChild(a);
        var data = angular.copy(vm.srch);
        data.selectType = "List";
        data.viewSize = 0;
        //data.mapCode = pageData.MapperId.excel.EXCEL_SQL;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];
            var obj = [];
            angular.forEach(result.body.desc, function (item) {
              if(item.ListColumnShowYN == "Y" && item.ListColumnShowLevel != 'showlevel0') {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(result.body.desc, function(item) {
                if(item.ColumnLogicalDataType == '40') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    //obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    obj.push(moment(value[item.ColumnPhysicalNm]).format('YYYY-MM-DD'));
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }

              });
              $scope.exportData.push(obj);
            });     
            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getExcelFile()");
          // console.table(error);
        });
      };

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

webapp.service('DepartmentAPISrv', ['$resource', 'StaticVariable',
    function DepartmentAPISrv($resource, StaticVariable) {
		// console.log('DepartmentAPISrv');
    	var hDepartmentApi = {
    		doList : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentList/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
        doTreeList : function() {
          return $resource(StaticVariable.getUrl('/select/Department.getDepartmentTreeList/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
        doSaveList : function() {
          return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentTreeListBatch/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
    		doListCnt : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentCount/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDetail : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doUpdateDetail : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doInsertDetail : function() {
    			return $resource(StaticVariable.getUrl('/insert/Department.insertDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDelete : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.deleteDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			}
    	};
    	return hDepartmentApi;
	}
]);

webapp.controller('DepartmentDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'DepartmentAPISrv', 'gAlert', 'gConfirm',
    'fileUploadService', function DepartmentDetailCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, departmentApi, gAlert, gConfirm, fileUploadService) {
      var vm = this;

      vm.page = $stateParams.page;
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        DeptId : $stateParams.DeptId,
      };
      vm.comment = {};

      var id = 0;

      vm.getDetail = getDetail;
      vm.deleteDetail = deleteDetail;
      vm.deleteDetailAction = deleteDetailAction;

      vm.userId = $window.sessionStorage['loginUserIdx'];

      function getDetail() {

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = data.responseVO.body.docs[0];
            return;
          }

          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        },

        function(data) {
          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var prms = departmentApi.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.department-list")
              }
            });

          }
        },

        function (error) {
            console.table(error);
        });
      }

      Array.prototype.append = function(array) {
        this.push.apply(this, array)
      };

      getDetail();
    } ]);

webapp.controller('DepartmentEditCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'DepartmentAPISrv', 'gAlert', '$rootScope',
    function DepartmentEditCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, departmentApi, gAlert, $rootScope) {
      var vm = this;

      vm.page = $stateParams.page;

      vm.uploadFileList = [];
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        DeptId : $stateParams.DeptId,
      };

      vm.data = {
        DeptId : vm.srch.DeptId,
      };

      vm.getDetail = getDetail;
      vm.saveDetail = saveDetail;
      vm.listLink = listLink;

      $rootScope.$on('$locationChangeStart', function(event, current, previous) {
        // console.log("현재페이지",'current=', current, ",previous=", previous);
        vm.previous = previous;
      });

      // 부서 조회 start
      vm.srchDeptModal = function() {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        var modalInstance = modalWindow.open('modal', 'views/modal/dept-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
          vm.data.ParentDeptNm = okData.label;
          vm.data.ParentDeptId = okData.data;
        }, function(cancelData) {
        });
      };

      vm.eraseDept = function() {
        vm.data.ParentDeptNm = "";
        vm.data.ParentDeptId = "";
      };
      // 부서 조회 end

      function listLink() {

        if (vm.previous.substring(vm.previous.length - 31) == 'app/system/department-list') {
          $state.go("app.system.department-list");
        } else {
          $state.go("app.system.department-list");
        }
      }

      function getDetail() {
        if (vm.srch.DeptId == null || vm.srch.DeptId == 0) {
          return;
        }

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null) {
              vm.data = data.responseVO.body.docs[0];
              return;
            }
          }
        },
        function(data) {
          console.table(data);
        });
      }

      function saveDetail() {

        vm.data.tableNm = "department";
        vm.data.TableId = vm.data.DeptId;

        var prms = null;

        if (vm.data.DeptId == null || vm.data.DeptId == 0)
          prms = departmentApi.doInsertDetail().post(vm.data).$promise;
        else
          prms = departmentApi.doUpdateDetail().post(vm.data).$promise;

        prms.then(

        function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null || data.responseVO.body.docs[0].TableId != null) { // insert 시 TableId 만 넘어옴
              vm.data.keyId = data.responseVO.body.docs[0].DeptId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.DeptId == 0) {
                    $state.go("app.system.department-list");
                  } else {
                    vm.data.DeptId = data.responseVO.body.docs[0].DeptId != null ? data.responseVO.body.docs[0].DeptId : data.responseVO.body.docs[0].TableId;
                    $state.go("app.system.department-detail", {
                      DeptId : vm.data.DeptId
                    });
                  }
                }
              });

              return;
            }
          }

          gAlert('', data.responseVO.body.docs[0].errMessage);
        },

        function(error) {
          console.table(data);
        });
      }

      getDetail();
    } ]);

webapp.controller('DepartmentListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
    function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxdeptid = 0;
      vm.lists = [];
      vm.saveYn = true;
      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'), '#toastContainer');
      });

      function resetSearch() {
        vm.srch.DeptNm = '';
        vm.data = {DeptNm: ''};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChanged = onChanged;
      vm.onChangeDeptNm = onChangeDeptNm;
      vm.getClear = getClear;

      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function onChangeDeptNm() {
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (vm.data.New == 'Y') {
          branch.label = '[*]' + vm.data.DeptNm;
        } else {
          branch.label = vm.data.DeptNm;
          vm.data.Edit = 'Y';
        }
      }

      vm.topItem = null;

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        var data = vm.srch;
        data.mapCode = "Department.getDepartmentTreeList";
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length == 0) return;

            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error("fail", status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
          }
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            vm.data = item;
            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var DeptId = newnum.toString(36);

        var branch = tree.get_selected_branch();
        if (branch == null) {
          var dept = {
            'DeptNm' : '새로운부서',
            'DeptId' : DeptId,
            'ParentDeptId' : 0,
            'Depth' : 1,
            'New' : 'Y'
          };
          vm.lists.push(dept);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.DeptId.toString()) {
              var dept = {
                'DeptNm' : '새로운부서',
                'DeptId' : DeptId,
                'ParentDeptId' : branch.data,
                'Depth' : item.Depth + 1,
                'New' : 'Y'
              };
              vm.lists.push(dept);
              return;
            }
          });
        }

        var new_branch = tree.add_branch(branch, {
          label: '[*]새로운부서',
          data: DeptId
        });
        tree.select_branch(new_branch);
      };

      function delNode() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'), '#toastContainer');
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            }else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();
            if(parent){
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = {CustomCode: 0};
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = new Array();

        // for문으로 다시 json 구조로 변환함.
        for (var i = 0; i < vm.lists.length; i++) {
          // 객체 생성
          var data = new Object();

          data.label = vm.lists[i]['DeptNm'];
          data.guid = vm.lists[i]['DeptId'].toString();
          data.parent = vm.lists[i]['ParentDeptId'] == undefined || vm.lists[i]['ParentDeptId'] == 0 ? null : vm.lists[i]['ParentDeptId'].toString();

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (vm.lists[i]['Deptid'] > vm.maxdeptid)
            vm.maxdeptid = vm.lists[i]['Deptid'];
        }

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
        $timeout(function() {
          return tree.expand_init();
        }, 1);

      }

      function removeNode(jsonObj, DeptId) {
        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].data == DeptId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, DeptId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'Department.updateDepartmentTreeListBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.New = '';
              var branch = tree.get_selected_branch();
              branch.label = branch.label.replace(/^\[\*\]/,"");
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'), '#toastContainer');
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        });

      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function getClear() {
        vm.srch.DeptNm = '';
      }
    } ]);

(function () {
  "use strict";
  webapp.controller('InqueryEditCtrl', 
  ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', '$filter', '$window', '$state', '$rootScope',
  function InqueryEditCtrl($scope, $stateParams, autoView, postApi, CONSTANT, modalFactory, $filter, $window, $state, $rootScope) {

    var vm = this;
    vm.dataloader = true;

    vm.codeStatus = [
      {Code : '100', CodeValue : '상담대기'},
      {Code : '200', CodeValue : '상담완료'},
    ];

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,
      printColumn : true,

      /* 공통 */
      viewType : mViewType.Edit, // List OR Edit
      /* 상세페이지 */
      // 엘리먼트 퍼블리싱 타입
      formType : mElemTx.layout.inline,
      tableNm : "Inquery",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "data", // ex : vc.data = {}
      apis : {
        /** common mapper **/
        // initSelect : 기본 데이터를 가져오는 코드 
        initSelect : { mapCode : "Inquery.getInqueryDetail", param : null },
        // vieType is edit
        insert : "Inquery.insertInquery",
        update : "Inquery.updateInqueryStatus",        
      },

      // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
      addRow : [],

      // vc의 ng-if
      ngIf : {
        CustType : "false",
      },

      customCodes : {
        Status : "codeStatus",
      },

      disabled : {
        CompanyNm  : true,
        Manager  : true,
        Tel  : true,
        Email  : true,
        Contents  : true,
        RegDate  : true
      }
    };
    
   
    function onReadyAutoView() {
      vm.dataloader = false;
    }

    function setData() {
      av.commit(function(result){
        av.alert("수정되었습니다.");
      });
    }

    function goList() {
      $window.history.back();
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.setData = setData;
    vm.goList = goList;
    var av = new autoView();
    av.init(autoViewOption);

  }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객조회
   */
  webapp.controller('InqueryListCtrl', 
    ['$scope','$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$state', '$window',
    function InqueryListCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $state, $window) {

      var vm = this;
      
      vm.headerTitle = "서비스문의 관리";

  
      var autoViewOption = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        printColumn : true,

        /* 공통 */
        viewType : mViewType.List, // List OR Edit
        tableNm : "Inquery",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "lists", // ex : vc.data = {}
        srchModelNm : "srch",
        apis : {
          initSelectCnt : { mapCode : "Inquery.getInqueryListCnt"},
          initSelect : { mapCode : "Inquery.getInqueryList", param : null },
        },

        addSrchStack : true,

        // List
        listCheckboxEnable : false,
        
        src : {
          detail : "app.system.inquery-edit",
          splitDetail : "app.system.inquery-list.edit"
        },

      };

 
      function onReadyAutoView() {
        
      }

      /** @description autoView init Callback**/
      vm.onReadyAutoView = onReadyAutoView;

      var av = new autoView();
      av.init(autoViewOption);

    }]);
})();

webapp.controller('MakeQueryListCtrl', 
['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
function MakeQueryList($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {
    

  var vm = this;
  vm.tableSchema = "saleviscare";
  vm.tables = []; // 테이블리스트
  vm.cols = []; // 컬럼리스트

  vm.namespace; // Mapper ID

  vm.checkMainTb = false;
  vm.tbMain = {}; // 메인 정보
  vm.tbJoins = []; // 조인테이블 정보
  // vm.innerjoinTb = []; // InnerJoin Table
  // vm.leftjoinTb = []; // LeftJoin Table

  vm.tempColsData = {}; // 호출된 테이블 컬럼을 임시로 저장한다.
  vm.checkDrawView = false;

  vm.copyFn = function() {
    if(document.body.createTextRange) {
      var textRange = document.body.createTextRange();
      textRange.moveToElementText(document.getElementById("queryView"))
      textRange.execCommand("Copy");
      gAlert("","복사하였습니다.")
    } else {
      console.log(3)
      window.getSelection().selectAllChildren(document.getElementById("queryView"));
      document.execCommand("Copy");
      gAlert("","복사하였습니다.")
    }

  }

  vm.blurAlis = function(p) {
    var param = {};
    param = JSON.parse(JSON.stringify(p))
    param.mapCode = "makeQuery.setTbAlias";
    postApi.select(param, function(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        param.mapCode = "makeQuery.getAliasTable";
        postApi.select(param, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            p.rkey = result.body.docs[0].rkey;
          }
        });
      }
    });
  }

  vm.changeAlis = function(p) {
    
    p.aliasNm = p.aliasNm.toUpperCase();
    if(vm.checkMainTb) {
      if(p.tbNm.toLowerCase() == vm.tbMain.tableNm.toLowerCase()) {
        vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
      }
    }

    var keys = Object.keys(vm.tempColsData);
    if(keys.length > 0) {
      if(vm.tempColsData[p.tbNm] != undefined) {
        vm.tempColsData[p.tbNm].aliasNm = p.aliasNm.toUpperCase();
      }
    }

    if(vm.cols.length > 0) {
      for(var i = 0; i < vm.cols.length; i++) {
        if(p.tbNm.toLowerCase() == vm.cols[i].tbNm.toLowerCase()) {
          vm.cols[i].aliasNm = p.aliasNm.toUpperCase();
        }
      }
    }
  };

  vm.setMainTable = function(p) {
    var checkCount = 0;
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        item.mChecked = false;
      } else checkCount++;
    });

    if(checkCount > 0) vm.checkMainTb = true;

    vm.tbMain.tableNm = p.tbNm.substring(0,1).toUpperCase() + p.tbNm.substring(1,p.tbNm.length).toLowerCase();
    vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
    vm.setColData(p, "m");
  };

  vm.setJoinTable = function(p) {
    vm.tbJoins = [];
    vm.setColData(p, "ij");
  };

  vm.setColData = function(p, type){

    if( vm.tempColsData[p.tbNm] == undefined) {
      var param = {};
      param.mapCode = "makeQuery.getTableColumnList";
      param.tableSchema = vm.tableSchema;
      param.tbNm = p.tbNm;

      postApi.select(param, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.tempColsData[p.tbNm] = {};
          vm.tempColsData[p.tbNm]["aliasNm"] = p.aliasNm;
          vm.tempColsData[p.tbNm]["cols"] = result.body.docs;

          var pk = "";
          for(var i = 0; i < result.body.docs.length; i++) {
            var at = result.body.docs[i];
            if(at.column_key == "PRI") {
              pk = at.column_name;
              break;
            }
          }
          p.pk = pk;
          vm.initColData(p, type);
        }
      });
    } else {
      vm.initColData(p, type);
    }
    vm.writeQueryField();
  };

  vm.writeQueryField = function() {

  };

  vm.initColData = function(p, type){
    vm.cols = [];
    var mainCols = [], joinCols =[];
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        if(type == "m") {
          item.mChecked = false;
        }
      }
    })
    angular.forEach(vm.tables, function(item) {
      if(item.mChecked) {
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          
          var colNm = vm.tempColsData[item.tbNm].cols[i].column_name;
          var checkYn = true;
          if(colNm.indexOf("EdtUser") == 0 || colNm.indexOf("EditUser") == 0 || colNm.indexOf("EdtDate") == 0 
            || colNm.indexOf("DelUser") == 0 || colNm.indexOf("DelDate") == 0 || colNm.indexOf("DelYN") == 0
            || colNm.indexOf("TenantId") == 0
          ) checkYn = false;

          vm.cols.push( 
            {
              tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name, 
              dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
              priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
              checkedYn: checkYn,
              selectType: "m",
              checkedN : true,
              checkedE : false,
              checkedC : false,
            } 
          ) 
        }
      }

      if(item.ijChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {

          var colNm = vm.tempColsData[item.tbNm].cols[i].column_name;
          var checkYn = true;
          if(colNm.indexOf("EdtUser") == 0 || colNm.indexOf("EditUser") == 0 || colNm.indexOf("EdtDate") == 0 
            || colNm.indexOf("DelUser") == 0 || colNm.indexOf("DelDate") == 0 || colNm.indexOf("DelYN") == 0
            || colNm.indexOf("TenantId") == 0
          ) checkYn = false;

          joinCols.push( 
            {
              tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name, 
              dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
              priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
              checkedYn: checkYn, selectType: "i",
              checkedN : true,
              checkedE : false,
              checkedC : false 
            } 
          ) 
        }
      }

      if(item.ljChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {

          var colNm = vm.tempColsData[item.tbNm].cols[i].column_name;
          var checkYn = true;
          if(colNm.indexOf("EdtUser") == 0 || colNm.indexOf("EditUser") == 0 || colNm.indexOf("EdtDate") == 0 
            || colNm.indexOf("DelUser") == 0 || colNm.indexOf("DelDate") == 0 || colNm.indexOf("DelYN") == 0
            || colNm.indexOf("TenantId") == 0
          ) checkYn = false;

          joinCols.push( 
            {
              tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name,
              dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
              priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
              checkedYn: checkYn, selectType: "l",
              checkedN : true,
              checkedE : false,
              checkedC : false 
            } 
          ) 
        }
      }
    });
    angular.forEach(joinCols, function(item) {
      vm.cols.push(item);
    })
    if(vm.cols.length > 0) vm.checkDrawView = true;
    else  vm.checkDrawView = false;
  };

  vm.changeMapperId = function() {
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
  }


  function htpt(str) {
    var str = String(str).replaceAll("<", "&lt;").replaceAll(">", "&gt;");
    return  str.replaceAll("undefined", "");
  }
  vm.getTableList = function() {

    var param = {};
    param.mapCode = "makeQuery.getTableList";
    param.tableSchema = vm.tableSchema;

    postApi.select(param, function(result) {
      console.log(result)
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.tables = result.body.docs;

        for(var i = 0; i < vm.tables.length; i++) {
          var at = vm.tables[i];
          if(at.aliasNm == undefined) at.aliasNm = at.tbNm.toLowerCase();
        }
      }
    })
  }
  vm.init = function() {

    vm.getTableList();
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
    vm.mapperend = htpt('</mapper>');

  }

  vm.init();
}]);



(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:menumanage-list-ctrl
   * @description
   * # 메뉴 관리
   * 사용자 메뉴를 편집 및 관리 할 수 있는 페이지
   */

  webapp.controller('MenuManageCtrl', [
    '$window', '$scope', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$translate', '$compile', 'modalFactory',
    function MenuManageCtrl($window, $scope, $state, $stateParams, $rootScope, CONSTANT, postApi, gAlert, gConfirm, $translate, $compile, modalFactory) {
      var vm = this;
      vm.targetField = null; // Focus 엘리먼트를 구하기 위한 변수
      vm.selectMenu = null; // 선택된 메뉴가 있는지 체크하는 변수
      vm.checkShowDetailView = false; // 메뉴의 디테일 화면을 보여줄지에 여부
      vm.menuList = [];
      vm.menuInfo = [];
      vm.delMenuList = [];
      vm.fontList = [];

      vm.addInputFa = "fa-";

      vm.sendData = { menuList: vm.menuList, delMenuList: vm.delMenuList };

      vm.roleLevelList = [];
      for(var i = 0; i < 16; i++) {
        var o = {};
        o.commonCodeId = i.toString();
        o.codeNm = "Level " + i;
        vm.roleLevelList.push(o);
      }

      vm.SysAdmin = false;
      vm.viewMode = "A"; // A : 전체보기, T : 회원사보기, TV : 회원사일때
      if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
        vm.SysAdmin = true;
        vm.viewMode = "A";
      } else {
        vm.viewMode = "TV";
      }

      vm.showTabView = [];
      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.menuTitle = 'All Category';
      vm.selectTenantInfo = {};
      vm.tenantList = [];

      vm.sysAdminDisable = false;

      vm.selectedGroupOptions = "";
      vm.mobileOnlyYN = "N";
      if($state.$current.name.indexOf("menumanage-mobilelist") != -1) vm.mobileOnlyYN = "Y";

      vm.selectNewWindowYn = [
        {value : "Y", codeNm : "Y"},
        {value : "N", codeNm : "N"},
      ];

      vm.roles = [];
      vm.rolesInfo = [];
      vm.rolesInfo.sqlMapper = [];
      vm.checkEdtLabel = false;
      vm.checkEdtLabelText = "라벨편집";

      vm.choiceRolePage = "";

      vm.mSrchTenentID = '0';

      vm.toggleMenuType = function(menuType) {
      };

      vm.setDetailView = function (code) {
        if(code == undefined) {
          vm.menuInfo = [];
          vm.rolesInfo = {};
          vm.setChangeTab(0);
          return;
        }

        var data = { mapCode: 'Menu.getBaseMenuInfo', menuId: code.menuId, type: vm.viewMode, srchTenantId: '0' };
        if (vm.SysAdmin && vm.viewMode == "TV") data.tenant = vm.selectTenantInfo.id;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.rolesInfo = [];
            vm.choiceRolePage ="";
            vm.setChangeTab(0);
            if(result.body.docs.length > 0) {
              vm.menuInfo = result.body.docs[0];
              vm.menuInfo.depth = code.depth;
              vm.menuInfo.useYn = code.useYn;
              vm.menuInfo.roleLevel = vm.menuInfo.roleLevel.toString();

              vm.menuInfo.menuTenantId = code.menuTenantId;
              ( vm.menuInfo.useYn == "Y" || ( vm.menuInfo.menuTenantId != null && vm.menuInfo.menuTenantId != "" && vm.menuInfo.menuTenantId != 0))
              ?  vm.menuInfo.levelYn = true :  vm.menuInfo.levelYn = false;

              getFa();
              vm.getPages();
              vm.getMenuType();
            } else {
              var o = {};
              o.menuTenantId = code.menuTenantId;
              o.menuId = code.menuId;
              o.menuNm = code.menuNm;
              o.icon = code.icon;
              o.mobileOnlyYN = vm.mobileOnlyYN;
              o.useYn = code.useYn;
              o.menuTenantId = code.menuTenantId;
              o.roleLevel = "1";

              (o.useYn == "Y" || (o.menuTenantId != null && o.menuTenantId != "" && o.menuTenantId != 0)) ? o.levelYn = true : o.levelYn = false;
              vm.menuInfo = o;

            }

            if (vm.mobileOnlyYN == "Y") getMenuSvyList(); //모바일 메뉴관리인 경우 연관페이지 정보도 같이 가져오도록 추가
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.getMenuType = function() {
        angular.forEach(vm.radioMenuType, function(item) {
          item.checked = false;
        });

        vm.menuInfo.pages = [];
        var data = { mapCode: 'MenuType.getBaseMenuType', menuId: vm.menuInfo.menuId, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.menuTypes = result.body.docs;

            angular.forEach(vm.radioMenuType, function(item) {
              angular.forEach(vm.menuInfo.menuTypes, function(menu) {
                if (item.code == menu.MenuType) {
                  item.checked = true;
                  return;
                }
              });
            });
          } else {
            console.log("error");
            // console.error('Error> getMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> getMenuType', status, error);
        });
      };

      vm.getPages = function () {
        vm.menuInfo.pages = {};
        var data = { mapCode: 'Screen.getBaseMenuScreen', menuId: vm.menuInfo.menuId };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.pages = result.body.docs;
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.addChild = function (depth, code) {
        var $elem;
        (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
        $elem.css("display", "block");
        $elem.find("input").focus();

        $(".subTextmenu").addClass("importantHidden");
      };

      vm.delChild = function (depth, obj) {
        if (obj.child.length > 0) {
          gAlert('', '하위 메뉴가 있으면 삭제할 수 없습니다.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        var data = { mapCode: 'Menu.getUseTenantMenu', menuId: obj.menuId, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var msg = "";
            if(result.body.docs.length == 0) {
              msg = "[" + obj.menuNm + "] 삭제하시겠습니까? (삭제전에 연관페이지는 먼저 삭제해야 됩니다.)";
            } else {
              var company = "";
              for(var j = 0; j < result.body.docs.length; j++) {
                if(j != 0) company += ", ";
                company += result.body.docs[j].TenantNm;
              }
              msg = "[" + company + "] 회원사가 사용중입니다.<br>그래도 [" + obj.menuNm + "] 삭제하시겠습니까?";
            }

            gConfirm('', msg , {
              btn: '확인', fn: function () {
                var data = { mapCode: 'Menu.delMenuList', menuId: obj.menuId, srchTenantId: '0' };
                postApi.select(data, function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    $rootScope.$broadcast('broadcastSetChangeMenuList', {});
                    $rootScope.showSimpleToast($translate.instant('삭제하였습니다.'));
                    initBaseMenuList();
                  }
                });
              }
            }, {btn: '취소', fn: function () {}
            });

        } else {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
        }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.editChild = function (depth, obj) {
        //console.log("Edt :", depth, obj)
      };

      /**
      * 같은 Depth, 직속 관계가 아닐 경우 자리 이동을 하지 않기 위함
      */
      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          var result = false;
          if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
          var target = sourceItemHandleScope.itemScope.item;
          if(target.menuTenantId == "" || target.menuTenantId == 0) result = false;
          if(target.useYn == "N") result = false;
          if(destItemScope.modelValue.menuTenantId == "" || destItemScope.modelValue.menuTenantId == 0) result = false;
          if(destItemScope.modelValue.useYn == "N") result = false;
          return result;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeSort(source);
        },
      };

      vm.setChangeSort = function (obj, ps) {
        for (var i = 0; i < obj.length; i++) {
          var minusLength = $("#atMenu_" + obj[i].menuId).closest("[ng-model]").
            parent().find("div").eq(0).find( ".fa-minus").length;
          if(minusLength != 0) $("#atMenu_" + obj[i].menuId).css("display","block");
          var tempSort = makeSortPath(obj[i].sort);
          if(ps == undefined) {
            if(tempSort.length == 1) {
              obj[i].sort = (100+i);
              obj[i].tempSortPath[0] = (100+i);
            } else if(tempSort.length == 2) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          } else {
            var tempSort = makeSortPath(ps);
            if(tempSort.length == 1) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          }
          if (obj[i].child.length > 0) vm.setChangeSort(obj[i].child, obj[i].sort);
        }
      };

      /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.extendMenu = function (elementId) {
        var $o = $("#" + elementId);
        var code = elementId.split("_")[1];
        var menupath = $o.attr("menu-sort");
        var depth;
        if ($o.hasClass("depth-one")) depth = 1;
        else if ($o.hasClass("depth-two")) depth = 2;

        if (depth == 1) {
          $(".extend-btn").removeClass("fa-minus");
          $(".extend-btn").addClass("fa-plus");
          $(".depth-two").slideUp();
          $(".depth-three").slideUp();
          if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
            $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
          } else {
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
          }
        } else {
          if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
            $o.find(".extend-btn").removeClass("fa-minus");
            $o.find(".extend-btn").addClass("fa-plus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          } else {
            $(".depth-three").slideUp();
            $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-minus");
            $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-plus");
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
          }
        }
      }

      /**
       * 동일 선상의 서브 메뉴를 보여주기 위함
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

      /**
       * 동일 선상의 서브 메뉴를 숨기기 위함
       * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
      */
      vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

      /**
       * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
      */
      vm.menuTitleChange = function () {
        var val = $(vm.targetField).val();
        var $obj = $(vm.targetField);
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.cancelMenuItem = function (depth) {
        var $obj = $(vm.targetField);
        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");
        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.addMenuItem = function (depth) {
        // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
        // 해당 로직을 진행하면 안됨 (기능 추가 필요);
        var $obj = $(vm.targetField);
        if ($obj.val() == undefined || $obj.val().length == 0) return;
        var data = {};
        data.menuNm = $obj.val();
        data.menuId = getRandomKey();
        data.depth = depth;
        data.child = [];
        data.delYn = "N"; // 생성모드
        data.mobileOnlyYN = vm.mobileOnlyYN;
        data.disableClass = "disable-master";
        data.tenantId = "";
        data.useYn = "N";
        data.roleLevel = 1;

        var checkDepth;
        if (depth == 1) {

          var checkUseY = 0, checkUseN = 0;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
            if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
          }

          if(checkUseN == 0) {
            data.sort = checkUseY + 100;
          } else {
            data.sort = checkUseN + 1;
          }

          data.tempSortPath = [];
          data.tempSortPath[0] = data.sort;

          checkDepth = 1;
          vm.depth01title = "";
        } else {
          var sort = $obj.closest(".edit-layout").attr("menu-sort");
          var obj = findObject(vm.menuList, 'sort', sort);
          data.sort = sort + "" + (obj.child.length + 100);
          var sortArray = makeSortPath(data.sort);
          data.tempSortPath = sortArray;
          if (sortArray.length == 2) {
            checkDepth = 2;
            vm.depth02title = "";
          } else {
            checkDepth = 3;
            vm.depth03title = "";
          }
        }

        data.srchTenantId = '0';

        postApi.insert('Menu.setBaseMenuList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var obj = findObject(vm.menuList, 'sort', sort);

            if (checkDepth == 1) vm.menuList.push(data);
            else obj.child.push(data);

            if (depth != 1) {
              $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
              $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
              setTimeout(function () {
                $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
              }, 500);
            }

            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            vm.setDetailView(data);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuList', status, error);
        });

        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");

        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 포커스가 된 엘리먼트를 구하기 위함
       * @param {object} $event AngularJS Object
      */
      $scope.focusCallback = function ($event) {
        if ($event.target === null) return;
        vm.targetField = $event.target;
      };

      vm.addPage = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.menuInfo.pages == null ) vm.menuInfo.pages = [];
        var o = {screenId:'', mainYn: 'N', screenNm: '', pageUrl: '', pageUrlParam: '', newWindowYn:'N', delYn: 'N' };
        vm.menuInfo.pages.push(o);
      };

      vm.delPage = function(item, idx) {
        if(item.screenId != null && item.screenId != "") {
          if(item.delYn == "Y") {
            item.delYn = "N";
          } else if(item.delYn == "N") {
            item.delYn = "Y";
          }
        } else if(item.screenId == null || item.screenId == "") {
          if(item.delYn == "N") {
            vm.menuInfo.pages.splice(idx, 1);
          }
        } else if(item.delYn == "Y") {
          item.delYn = "N";
        } else if(item.delYn == "N") {
          item.delYn = "Y";
        } else {
          vm.menuInfo.pages.splice(idx, 1);
        }
      };

      /**
       * Font 를 저장한다. DELETE 예정
      */
      vm.setFa = function () {
        if ($("#viewFontIcon").width() == 0) return;
        var data = { mapCode: "fontAwesome.setFontList", name: vm.addInputFa, srchTenantId: '0' };
        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.addInputFa = "fa-";
            getFa();
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeIcon = function (name) {
        if(vm.menuInfo.length == 0) {
          return;
        }
        for (var i = 0; i < vm.fontList.length; i++) {
          if (vm.fontList[i].name == name) {
            vm.fontList[i].active = "active";
          } else {
            vm.fontList[i].active = "";
          }
        }

        var menu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
        if (name == "_초기화") {
          menu.icon = '';
          vm.menuInfo.icon = '';
        } else {
          menu.icon = name;
          vm.menuInfo.icon = name;
        }

      };

      vm.invalidBaseInfo = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if (vm.menuInfo.name == '') {
          gAlert('', '메뉴명을 입력하세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }

        if(vm.viewMode != "T") {
          if (vm.menuInfo.pages != null && vm.menuInfo.pages.length == 0) {
            if (!vm.checkPages(function (boolean) {
              if (boolean) vm.checkMainPages();
            }));
          } else {
            vm.checkMainPages();
          }
        } else {
          vm.uptMenuBaseInfo();
        }

        // srchTenantId가 0일때만 insertBaseMenuTypeBatch 호출
        if ($rootScope.gVariable.srchTenantId == 0) {
          vm.updateMenuType();
        }
      };

      vm.updateMenuType = function() {
        var map = "MenuType.insertBaseMenuTypeBatch";
        var menuType = {MenuId: vm.menuInfo.menuId, lists:[], srchTenantId: '0'};
        angular.forEach(vm.radioMenuType, function(item) {
          if (item.checked) {
            menuType.lists.push(item);
          }
        });

        postApi.insert(map, menuType, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

          } else {
            console.log("error");
            // console.error('Error> updateMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> updateMenuType', status, error);
        });
      };

      vm.uptMenuBaseInfo = function () {


        var map = "Menu.setBaseMenuInfoBatch";

        if( vm.menuInfo.roleLevel == null || vm.menuInfo.roleLevel == "") {
          vm.menuInfo.roleLevel = '1';
        }

        var setType = [];
        if(vm.menuInfo.depth == 1) {
          if(vm.menuInfo.menuType != null && vm.menuInfo.menuType != "") {

            var rootMenu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            var menuType = vm.menuInfo.menuType;

            for(var i = 0; i < rootMenu.child.length; i++) {
              rootMenu.child[i].menuType = menuType;
              setType.push(rootMenu.child[i]);
              for(var j = 0; j < rootMenu.child[i].child.length; j++) {
                rootMenu.child[i].child[j].menuType = menuType;
                setType.push(rootMenu.child[i].child[j]);
              }
            }
          }
        }

        vm.menuInfo.setType = setType;
        if($rootScope.gVariable.srchTenantId != 0) {
          vm.menuInfo.pages = [];
        }
        vm.menuInfo.srchTenantId = '0';
        postApi.update(map, vm.menuInfo, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var temp = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            temp.menuNm = vm.menuInfo.menuNm;
            vm.getPages();

            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.checkMainPages = function () {
        if (vm.menuInfo.pages != null && vm.menuInfo.pages.length != 0) {
          var st = $(":input:radio[name=pageMain]:checked").val();
          if (vm.SysAdmin) {
            if (st == undefined) {
              gAlert('', '연관페이지의 [메인]을 선택하여주세요.', {
                btn: '확인', fn: function () { }
              });
              return;
            }

            var check = 0;
            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              if (vm.menuInfo.pages[i].pageNm == "") {
                gAlert('', '연관페이지의 [페이지명]을 확인하여주세요.', { btn: '확인', fn: function () { }});
                return;
              }
              if (vm.menuInfo.pages[i].pageUrl == "") {
                gAlert('', '연관페이지의 [페이지URL]을 확인하여주세요.', {btn: '확인', fn: function () { }});
                return;
              }
            }

            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              vm.menuInfo.pages[i].mainYn = "N";
            }

            vm.menuInfo.pages[st].mainYn = "Y";
          }

          var st = $(":input:radio[name=optionMenuType]:checked").val();
          vm.menuInfo.menuType = st;
          vm.uptMenuBaseInfo();
        } else {
          vm.uptMenuBaseInfo();
        }
      }

      vm.checkPages = function (callback) {
        gConfirm("연관 페이지가 없습니다. 계속 진행하시겠습니까?",
          { btn: '확인', fn: function () { callback(true); } },
          { btn: '취소', fn: function () { callback(false); } }
        );
      };

      vm.alertSelectMenu = function () {
        gAlert('w', '메뉴를 선택하여주세요.', {
          btn: '확인', fn: function () { }
        });
      };

      vm.onChangeGroupView = function (code) {
        if (code == null || code == undefined || code == "") {
          angular.forEach(vm.menuList, function (key, value) {
            key.extendGroupClass = "";
          });
        } else {
          angular.forEach(vm.menuList, function (key, value) {
            if (key.menuType == undefined) key.menuType = "";
            if (key.menuType.toString() == code.toString()) {
              if (key.mShowYn != "Y")
                key.extendGroupClass = "visible-group";
              else
                key.extendGroupClass = "visible-use-group";

            } else {
              key.extendGroupClass = "invisible-group";
            }
            //}
          });
        }
      };

      vm.onChangeNewWindowYn = function (code) {

      };

      /************************************************************* */
      vm.setChangeTenant = function (id, name) {
        vm.viewMode = "TV";
        vm.menuTitle = 'All Category';
        vm.sysAdminDisable = true
        vm.selectTenantInfo.id = id;
        vm.selectTenantInfo.name = name;

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[0] = "in active";

        setTimeout(function () {
          $("ul.nav-tabs li").removeClass("active");
          $("ul.nav-tabs li").eq(1).addClass("active");
        }, 25);

        vm.menuList = [];
        vm.menuInfo = [];

        var data = { mapCode: 'Menu.getTenantMenuList', tenant: id, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            makeMenuList(result.body.docs, true);
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      // arrow  true : top, false : down, default up;
      var resultObj = {};
      vm.findUptTenantNode = function (obj, arrow) {
        resultObj.str = [];
        resultObj.codes = [];
        if (arrow) { // UP
          var path = makeSortPath(obj.sort);
          for (var i = 0; i < path.length-1; i++) {
            var temp = "";
            for(var j = 0; j < i+1; j++) {
              temp += path[j];
            }
            temp = findObject(vm.menuList, 'sort', temp);
            if (temp.useYn == "N") {
              resultObj.codes.push(temp);
              resultObj.str.push(temp.menuNm);
            }
          }
        } else {
          var temp = obj.child;
          var k = [];
          var count = 0;
          for (var c = 0; c < 1000; c++) {
            for (var i = 0; i < temp.length; i++) {
              var check = true;
              for (var j = 0; j < k.length; j++) {
                if (k[j].menuId == temp[i].menuId) {
                  check = false;
                  break;
                }
              }
              if (check) k.push(temp[i]);
              else count = -1;
            }

            if (count == -1) break;
            if (k.length == count) break;
            else {
              count = k.length;
              temp = [];
              for (var i = 0; i < k.length; i++) {
                if (k[i] == undefined) {
                  count = -1;
                  break;
                }
                for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
              }
            }
          }

          for (var i = 0; i < k.length; i++) {
            resultObj.str.push(k[i].menuNm);
          }
          resultObj.codes = k;
        }
        resultObj.str = resultObj.str.toString();
        return resultObj;
      };

      vm.setTenantEnable = function (depth, obj) {
        if (depth == 1) {
          if (obj.tenantId == "" || obj.useYn == "N") {
            gConfirm('', "해당 메뉴를 [활성] 하시겠습니까?", {
              btn: '확인', fn: function () {
                if (obj.child.length > 0) {
                  vm.checkDepth1OtherData(obj);
                } else {
                  var toData = [];
                  toData.push(obj);
                  vm.setChangeMenuState(toData, true);
                }
              }
            }, {btn: '취소', fn: function () {}});
          } else {
            var msg = "";
            if (obj.child.length > 0) msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            else msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            gConfirm('', msg, {
              btn: '확인', fn: function () {
                var toData = [];
                toData.push(obj);
                var result = vm.findUptTenantNode(obj, false);
                for (var i = 0; i < result.codes.length; i++) {
                  result.codes[i].useYn = "N";
                  result.codes[i].disableClass = "disable-master";
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, false);
              }
            }, {
              btn: '취소', fn: function () {}
            });
          }
          // End Depth 1;
        } else {
          // 2Depth 이상
          var str, state = false, result = [], msg = '';
          (obj.tenantId == "" || obj.useYn == "N") ?  state = true : state = false;
          if(state) {
            result = vm.findUptTenantNode(obj, true);
            if(result.codes.length == 0) {
              msg = "해당 메뉴를 [활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
            }
          } else {
            if(obj.child.length > 0) {
              result = vm.findUptTenantNode(obj, false);
              msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            }
          }

          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              setMenuState(state, obj);
              toData = setChangeDepthCode(state, obj);
              if(state) {
                if(obj.child.length > 0) {
                  gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
                    btn: '확인', fn: function () {
                      var $thisObj = findObject(toData, 'sort', obj.sort);
                      for(var i = 0; i < $thisObj.child.length; i++) {
                        $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                        var temp = findObject(vm.menuList, 'sort', $thisObj.child[i].sort);
                        temp = setMenuState(state, temp);
                      }

                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  }, {
                    btn: '취소', fn: function () {
                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  });
                } else {
                  (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
                }
              } else {
                (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
              }
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
      };

      function setMenuState(state, data) {

        // 배열로 작업 예정
        if(state) {
          data.useYn = "Y";
          data.disableClass = "";
        } else {
          data.useYn = "N";
          data.disableClass = "disable-master";
        }

        return data;
      }

      // 2Depth 이상 수행 함수
      function setChangeDepthCode(state, obj) {

        var result = [];
        var sort = makeSortPath(obj.sort);
        var size = sort.length, oneDepth, twoDepth, sortKey = -1;
        oneDepth = findObject(vm.menuList, 'sort', sort[0]);
        if(size == 3){
           twoDepth = findObject(vm.menuList, 'sort', Number(sort[0]+''+sort[1]));
           if(state) setMenuState(state, twoDepth);
        }


        if(state) { // 활성
          var index = -1, checkSort = -1, sortidx = -1;
          if(oneDepth.useYn == "Y") {
            sortKey = oneDepth.sort;
          } else {
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].menuId == oneDepth.menuId) {
                index = i;
              }
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }

            if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            oneDepth.useYn = "Y";
            oneDepth.disableClass = "";
            oneDepth.sort = sortKey;
            oneDepth.tempSortPath[0] = sortKey;

            result.push(oneDepth);
          }

          for(var i = 0; i < oneDepth.child.length; i++) {
            var o = oneDepth.child[i];
            var childSort = makeSortPath(o.sort);
            childSort[0] = sortKey;
            o.sort =  + "" + Number(childSort.toString().replaceAll(",",""));
            o.tempSortPath = childSort;
            var d3ParentCode = [];
            angular.copy(o.tempSortPath, d3ParentCode);
            d3ParentCode.push(0);

            result.push(o);
            for(var j = 0; j < o.child.length; j++) {
              var _o = o.child[j];
              d3ParentCode[2] = _o.tempSortPath[2];
              _o.sort =  Number(d3ParentCode.toString().replaceAll(",",""));
              _o.tempSortPath = d3ParentCode;
              result.push(_o);
            }
          }

          if(index != -1) {
            var temp = {};
            angular.copy(vm.menuList[index], temp);
            vm.menuList.splice(index, 1);
            if(state) {
              (sortidx != -1) ? vm.menuList.splice(sortidx+1, 0, temp) : vm.menuList.push(temp);
            } else {
              vm.menuList.push(temp);
            }
          }
        } else { // 비활성
          result.push(obj);
          if(obj.child.length > 0) {
            for(var i = 0; i < obj.child.length; i++) {
              obj.child[i] = setMenuState(state, obj.child[i]);
              result.push(obj.child[i]);
            }
          }
        }
        return result;
      }

      vm.checkDepth1OtherData = function (obj) {
        var result = vm.findUptTenantNode(obj, false);
        if (result.codes.length > 0) {
          gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
            btn: '확인', fn: function () {
              var toData = [];
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "Y";
                result.codes[i].disableClass = "";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, true);
            }
          }, {
              btn: '취소', fn: function () {
                var toData = [];
                toData.push(obj);
                for (var i = 0; i < result.codes.length; i++) {
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, true);
              }
            });
        } else {
          var toData = [];
          toData.push(obj);
          vm.setChangeMenuState(toData, true);
        }
      };

      vm.setChangeMenuState = function (data, state, checkSortEnable) {
        var sendData = {};
        sendData.menus = data;
        // 190717 배열 인덱스 조절
        var index = -1;
        var sortidx = -1;
        if(data[0].depth == 1) {
          var sortKey = -1;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].menuId == data[0].menuId) {
              index = i;
              break;
            }
          }

          if(!state) {
            var checkUseY = 0, checkUseN = 0;
            // for(var i = 0; i < vm.menuList.length; i++) {
            //   if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
            //   if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
            // }
            // (checkUseN == 0) ? sortKey = checkUseY + 100 : sortKey = checkUseN + 1;
            data[0].useYn = "N";
            data[0].disableClass = "disable-master";
          } else {
            var checkSort = -1;
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }
            // if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            data[0].useYn = "Y";
            data[0].disableClass = "";
          }

          for(var i = 0; i < data.length; i++) {
            // var orgSort = makeSortPath(data[i].sort);
            // orgSort[0] = sortKey;
            //data[i].sort = Number(orgSort.toString().replaceAll(",",""));
            //data[i].tempSortPath = orgSort;
          }
        } // END IF (data[0].depth == 1)

        for (var i = 0; i < data.length; i++) {
          if(data[i].tenantId == "") {
            (vm.SysAdmin) ? data[i].tenantId
              = $window.sessionStorage['srchTenantId'] : data[i].tenantId = $window.sessionStorage['loginTenantId'];
          }
        }


        // if(index != -1) {

        //   // index 검증
        //   for(var i = 0; i < sortidx; i++) {
        //     if(vm.menuList[i].useYn == "N") {
        //       sortidx = i - 2 ;
        //     }
        //   }

        //   var temp = {};
        //   angular.copy(vm.menuList[index], temp);
        //   vm.menuList.splice(index, 1);
        //   if(state) {

        //     if(sortidx != -1) {
        //       if(checkSortEnable == undefined)  sortidx = sortidx+1;
        //       vm.menuList.splice(sortidx, 0, temp);
        //     } else {
        //       vm.menuList.push(temp);
        //     }
        //   } else {
        //     vm.menuList.push(temp);
        //   }
        // }

        sendData.menus = data;
        sendData.srchTenantId = $window.sessionStorage['srchTenantId'];

        postApi.update('Menu.setTenantMenuList', sendData, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            var msg;
            (state) ? msg = "해당 메뉴를 [활성]하였습니다." : msg = "해당 메뉴를 [비활성]하였습니다.";
            $rootScope.showSimpleToast(msg);
            vm.setChangeMenuList(false);
            for(var k = 0; k < data.length; k++) {
              if(data[k].menuTenantId == null || data[k].menuTenantId == "" || data[k].menuTenantId == 0) {
                var request = {};
                request.menuId = data[k].menuId;
                request.srchTenantId = $window.sessionStorage['srchTenantId'];
                postApi.callbackSelect('Menu.getTenantMenuId', request, data[k], function(result, data){
                  var sData = findObject(vm.menuList, 'menuId', data.menuId);
                  sData.menuTenantId =result.body.docs[0].menuTenantId;
                });
              }
            }
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      /* START 연관설문 ********************************************* */
      vm.srch = {};
      vm.deleteMenuSvyList = deleteMenuSvyList;

      // 문제 목록 체크박스 설정
      vm.menuSvyChkHead = false;
      $scope.menuSvyChkRowChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (!vm.menuSvyLists[i].isChecked) {
            vm.menuSvyChkHead = false;
            return;
          }
        }
        vm.menuSvyChkHead = true;
      };

      $scope.menuSvyChkHeadChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          vm.menuSvyLists[i].menuSvyChkRow = vm.menuSvyChkHead;
        }
      };

      //getMenuSvyList();

      /**
       * 설문 추가 팝업 호출
       */
      vm.addMenuSvyModal = function () {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        var ctrl = 'MenusurveyModalCtrl as vc';
        var paramData = {keyId: vm.menuInfo.menuId};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/menusvy-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getMenuSvyList();
        }, function (cancelData) {
          getMenuSvyList();
        });
      };

      /**
       * 설문 목록 조회
       */
      function getMenuSvyList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {};
        data.mapCode = "Survey.getMenusurveyList";
        data.MenuId = vm.menuInfo.menuId;
        data.srchTenantId = '0';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.menuSvyLists = result.body.docs;
              vm.menuSvyTotalItems = vm.menuSvyLists.length;
            } else {
              // 데이터 조회 실패
              vm.menuSvyLists = {};
              vm.menuSvyTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getMenuSvyList()");
          // console.table(error);
        });
      }

      /**
       * 설문 목록 삭제
       */
      function deleteMenuSvyList() {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteMenuSvyListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteMenuSvyListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (vm.menuSvyLists[i].menuSvyChkRow)
          {
            vm.srch.KeyIdList.push(vm.menuSvyLists[i].MenuSvyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = "Survey.deleteMenusurveyList";
        data.srchTenantId = '0';
        //data.MenuId = vm.menuInfo.menuId;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getMenuSvyList();
              }
            });
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> deleteMenuSvyListAction()");
          // console.table(error);
        });
      }
      /* END 연관설문 ********************************************* */


      /* START 권한정보 ********************************************* */

      /**
       * 페이지를 선택하였을 시 기본 정보를 가져온다.
       * @param {int} depth 메뉴 Depth
      */
      vm.loadPageData = function(data) {
        vm.rolesInfo = data;
        vm.rolesInfo.loadPageData = [];
        vm.rolesInfo.sqlMapper = [];
        vm.rolesInfo.conditions = [];
        vm.rolesInfo.Btn01Text = '';
        vm.rolesInfo.Btn02Text = '';
        vm.rolesInfo.Btn03Text = '';
        vm.rolesInfo.Btn04Text = '';
        vm.rolesInfo.Btn05Text = '';
        vm.rolesInfo.Btn06Text = '';
        vm.choiceRolePage = data.screenId;

        var srch = { mapCode: 'Menu.getBaseRoleInfo', screenId : data.screenId, srchTenantId: '0'};
        postApi.select(srch, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            initRoleData(result);
          } else {
            console.log("error");
            // console.error('Error> getBaseRoleInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> getBaseRoleInfo', error);
        });
      };

      function initRoleData(result) {
        vm.rolesInfo.screen = result.body.docs;

        if (vm.rolesInfo.screen.length > 0) {
          vm.rolesInfo.Btn01Text = vm.rolesInfo.screen[0].Btn01Text;
          vm.rolesInfo.Btn02Text = vm.rolesInfo.screen[0].Btn02Text;
          vm.rolesInfo.Btn03Text = vm.rolesInfo.screen[0].Btn03Text;
          vm.rolesInfo.Btn04Text = vm.rolesInfo.screen[0].Btn04Text;
          vm.rolesInfo.Btn05Text = vm.rolesInfo.screen[0].Btn05Text;
          vm.rolesInfo.Btn06Text = vm.rolesInfo.screen[0].Btn06Text;
        }

        if(vm.rolesInfo.sqlId != null) {
          var sqlMap = vm.rolesInfo.sqlId.split(",");
          for(var i = 0; i < sqlMap.length; i++) {
            var o = {};
            o.sqlCode = sqlMap[i];
            o.useYn = true;
            o.delYn = "N";
            vm.rolesInfo.sqlMapper.push(o);
          }
        }

        if(vm.rolesInfo.paramPass != null) {
          var pass = vm.rolesInfo.paramPass.split(",");
          for(var i = 0; i < pass.length; i++) {
            var spliter = pass[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
            vm.rolesInfo.conditions.push(o);
          }
        }

        if(vm.rolesInfo.paramRefuse != null) {
          var paramRefuse = vm.rolesInfo.paramRefuse.split(",");
          for(var i = 0; i < paramRefuse.length; i++) {
            var spliter = paramRefuse[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
              vm.rolesInfo.conditions.push(o);
          }
        }

        vm.loadRolesData();
      }

      vm.loadRolesData = function() {
        if(vm.menuInfo.pages != null) {

        }
        //console.log(vm.menuInfo.pages);
      };

      vm.getLoadSqlMapper = function(){

        if (vm.choiceRolePage == null || vm.choiceRolePage == "") {
          gAlert('w', '연관페이지를 선택하여주세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        openTextFile();
      };

      function openTextFile() {
        var input = document.createElement("input");
        input.type = "file";
        input.accept = "js";

        input.onchange = function (event) {
            processFile(event.target.files[0]);
        };

        input.click();
      }

      function processFile(file) {
        var tx = "";
        var reader = new FileReader();
        reader.onload = function () {
          tx = reader.result.replaceAll(" ", "").replaceAll("\r\n","").replaceAll("\n","");
          if(tx.trim().length < 1) {
            gAlert('', '다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
            return;
          }
          for(var i = 0; i < 100; i++) {
            var check = false, index = -1, compareStr;
            if(tx.toLowerCase().indexOf('mapcode') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('mapcode');
              compareStr = 'mapcode';
            } else if(tx.toLowerCase().indexOf('postapi.') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('postapi.');
              compareStr = 'postapi';
            }
            if(!check) break;
            else {
              var index1 = -1, index2 = -1;
              tx = tx.substring(index, tx.length);
              if(compareStr == "mapcode") {
                index1 = tx.indexOf("\"");
                index2 = tx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                var temp;
                if(index1 < index2) {
                  tx = tx.substring(tx.indexOf('\"') + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf('\"'));
                } else {
                  tx = tx.substring(tx.indexOf("'") + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf("'"));
                }
                if(temp.indexOf("(") == -1 && temp.indexOf(")") == -1) {
                  var o = {};
                  o.sqlCode = temp.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(temp.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }

              } else {
                tx = tx.substring( tx.indexOf('(')+1, tx.length);
                var subTx = tx.substring(0, tx.indexOf(",")).trim();
                index1 = subTx.indexOf("\"");
                index2 = subTx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                if(index1 < index2) {
                  subTx = subTx.substring(subTx.indexOf('\"') + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf('\"'));
                } else if(index1 > index2){
                  subTx = subTx.substring(subTx.indexOf("'") + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf("'"));
                }
                if(subTx.indexOf(".") > -1) {
                  var o = {};
                  o.sqlCode = subTx.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(subTx.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }
              }
            }
          }

          setTimeout(function(){
            vm.rolesInfo.sqlMapper.push({sqlCode : ""});
            vm.rolesInfo.sqlMapper.splice(vm.rolesInfo.sqlMapper.length-1, 1);
            $rootScope.showSimpleToast('파일을 로드하였습니다.');
          }, 1000);

        };

        var errorEvent = function(event) {

          gAlert('', '다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
          if (event.type === 'loadstart') {
            reader.abort();
          }
        };
        reader.onerror = errorEvent;

        reader.readAsText(file, /* optional */ "utf-8");
      }

      vm.addSqlMapper = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }
        var o = {};
        o.sqlCode = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.sqlMapper.push(o);
      };

      vm.addCondition = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.rolesInfo.conditions == null) vm.rolesInfo.conditions = [];

        var o = {};
        o.condition = "";
        o.value = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.conditions.push(o);
      };

      vm.setChangeEdtLabel = function() {
        if(vm.checkEdtLabel) {
          vm.checkEdtLabel = false;
          vm.checkEdtLabelText = "라벨편집";
        } else {
          vm.checkEdtLabel = true;
          vm.checkEdtLabelText = "수정완료";
        }
      };

      vm.setRoleData = function() {
        var request = angular.copy(vm.rolesInfo);

        var sql = request.sqlMapper;
        var cd = request.conditions;

        request.sqlId = "";
        for(var i = 0; i < sql.length; i++) {
          if(sql[i].useYn && sql[i].delYn == "N") {
            if(i != 0) request.sqlId += ",";
            request.sqlId += sql[i].sqlCode;
          }
        }
        request.paramPass = "";
        request.paramRefuse = "";
        for(var i = 0; i < cd.length; i++) {
          if(cd[i].delYn == "N") {
            if(cd[i].useYn) {
              request.paramPass += (cd[i].condition + "=" + cd[i].value + ",");
            } else {
              request.paramRefuse += (cd[i].condition + "=" + cd[i].value + ",");
            }
          }
        }
        if(request.paramPass != "") request.paramPass = request.paramPass.substring(0, request.paramPass.length-1);
        if(request.paramRefuse != "") request.paramRefuse =request.paramRefuse.substring(0, request.paramRefuse.length-1);

        // RoleScreen
        var screen = request.screen;
        request.roleScreen = [];
        for(var i = 0; i < screen.length; i++) {
          var o = {};
          o.roleScrId = screen[i].RoleScrId;
          o.screenId = screen[i].ScreenId;
          o.viewYn = screen[i].ViewYN;
          o.roleId = screen[i].RoleId;
          o.btn01Yn = screen[i].Btn01YN;
          o.btn02Yn = screen[i].Btn02YN;
          o.btn03Yn = screen[i].Btn03YN;
          o.btn04Yn = screen[i].Btn04YN;
          o.btn05Yn = screen[i].Btn05YN;
          o.btn06Yn = screen[i].Btn06YN;
          request.roleScreen.push(o);
        }
        request.srchTenantId = '0';

        postApi.update('Screen.updateScreenDetailBatch2', request, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
          } else {
            console.log("error");
            // console.error('Error> setRoleData', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setRoleData', status, error);
        });

      };

      /************************************************************* */
      vm.viewChange = function (mode) {
        vm.viewMode = mode;
      };

      vm.setChangeMenuList = function (checkToast) {
        // 메뉴 리스트 1렬로 변경
        // A 모드와 TV 모드 변경
        var data = {}
        data.type = vm.viewMode;
        data.menus = [];
        var temp = vm.menuList;
        for (var i = 0; i < temp.length; i++) {
          data.menus.push(temp[i]);
          if (temp[i].child.length > 0) {
            for (var j = 0; j < temp[i].child.length; j++) {
              data.menus.push(temp[i].child[j]);
              if (temp[i].child[j].child.length > 0) {
                for (var k = 0; k < temp[i].child[j].child.length; k++) {
                  data.menus.push(temp[i].child[j].child[k]);
                }
              }
            }
          }
        }
        data.srchTenantId = '0';
        postApi.update('Menu.setAlignMenuListBatch', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if(checkToast != false) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            }
            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
          } else {
            console.log("error");
            // console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeTab = function (index) {
        if(index == 1) {
          if (vm.menuInfo.length == 0) {
            setTimeout(function(){
              $(".nav-tabs li").eq(0).addClass("active");
              $(".nav-tabs li").eq(1).removeClass("active");
            }, 500);

            vm.alertSelectMenu();
            return;
          }

          vm.loadRolesData();
        } else {
          $(".nav-tabs li").eq(0).addClass("active");
          $(".nav-tabs li").eq(1).removeClass("active");
        }

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[index] = "in active";


      };

      //>> ICON
      /**
       * Font 를 저장한다.
      */
      function getFa() {
        var data = { mapCode: "fontAwesome.getFontList", srchTenantId: '0'};
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.fontList = [];
            if (vm.menuInfo.icon != undefined) {
              for (var i = 0; i < result.body.docs.length; i++) {
                var o = {};
                o.name = result.body.docs[i].name;
                if (vm.menuInfo.icon == result.body.docs[i].name) {
                  o.active = "active";
                }
                vm.fontList.push(o);
              }
            } else {
              vm.fontList = result.body.docs;
            }
          }
        }, function (error) {
          console.log("error");
          // console.error('Error> setBaseMenuInfo', status, error);
        });
      }

      //>> SELECT
      function initBaseMenuList() {
        vm.mSrchTenentID = '0';
        vm.menuList = [];
        vm.setChangeTab(0);
        var srchTenentID = $window.sessionStorage['srchTenantId'];
        if (vm.SysAdmin && srchTenentID == "0") vm.viewMode = "A";
        else vm.viewMode = "T";
        var request = { mapCode: 'Menu.getBaseMenuList', mobileOnlyYN: vm.mobileOnlyYN};
        postApi.select(request, function (response) {
          if (checkResponse('initBaseMenuList', response)) {
            (vm.viewMode == "T") ? makeMenuList(response.body.docs, true) : makeMenuList(response.body.docs);
          }
        }, function (e) { console.log("error");});
      }

      function initRadioMenuType() {
        var data = { mapCode: 'Menu.getMenuType', code: '', mobileOnlyYN: vm.mobileOnlyYN}
        postApi.select(data, function (response) {
          if (checkResponse('initRadioMenuType', response)) {
            vm.radioMenuType = response.body.docs;
          }
        }, function (e) { console.log("error"); });
      }

      //>> #Broadcast
      $scope.$on('broadcastSetChangeTenantID', function (event, args) {
        vm.setDetailView();
        initBaseMenuList();
      });

      //>> #Init
      vm.initialize = function () {
        initBaseMenuList();
        initRadioMenuType();
        getFa();
      };
      vm.initialize();

      //>> #Other

      function makeSortPath(sort) {
        var sort = sort.toString();
        var result = Array();
        if(sort.length >= 3) {
          result.push(Number(sort.substring(0, 3)));
        }
        if(sort.length >= 6) {
          result.push(Number(sort.substring(3, 6)));
        }
        if(sort.length == 9) {
          result.push(Number(sort.substring(6, 9)));
        }
        return result;
      }

      function makeMenuList(data, check) {
        // SORT를 다시 만들어주는 작업이 필요함
        // 현재 베이스 코드와 일반 코드가 정렬하면서 문제가 발생
        var checkDepth1Code = 0;
        var checkUpdateMenuList = false;
        var lastUseYSort = 99;
        for (var i = 0; i < data.length; i++) {
          var o = {};
          o.menuId = data[i].menuId;
          o.depth = data[i].depth;
          o.menuNm = data[i].menuNm;
          o.path = data[i].path;
          o.icon = data[i].icon;
          o.menuType = data[i].menuType;
          o.sort = data[i].sort;
          o.baseSortKey = data[i].baseSortKey;

          if(o.depth == 1 && (data[i].menuTenantId == "" || data[i].menuTenantId == 0 || data[i].useYn == "N")) {

            var tempSort = o.sort;
            var checkN = false, checkPassSort = 0, checkUseNSort = 0;
            for(var j = 0; j < vm.menuList.length; j++) {
              if(vm.menuList[j].useYn == "Y") checkPassSort = vm.menuList[j].sort;
              if(vm.menuList[j].useYn == "N") checkUseNSort = vm.menuList[j].sort;
            }

            (checkUseNSort == 0) ? o.sort = checkPassSort + 100 : o.sort = checkUseNSort + 1;
            checkDepth1Code = o.sort;
            for(var j = i+1; j < data.length; j++) {
              var code1Depth = makeSortPath(data[j].sort);
              if(tempSort == code1Depth[0]) {
                data[j].sort = checkDepth1Code + "" + code1Depth[1];
                if(code1Depth.length == 3) data[j].sort += ""+code1Depth[2];
                data[j].sort = Number(data[j].sort);
              }
            }
          } else {
            if(o.depth == 1) {
              if(lastUseYSort + 1 == data[i].sort) {
                lastUseYSort = data[i].sort;
              } else {
                checkUpdateMenuList = true;
                lastUseYSort = lastUseYSort + 1;
                o.sort = lastUseYSort;
                for(var j = i+1; j < data.length; j++) {
                  var code1Depth = makeSortPath(data[j].sort);
                  if(data[i].sort == code1Depth[0]) {
                    code1Depth[0] = lastUseYSort;
                    data[j].sort = Number(code1Depth.toString().replaceAll(",",""));
                  }
                }
              }
            }
          }

          o.tempSortPath = makeSortPath(o.sort);
          o.tempBaseSortPath = makeSortPath(o.baseSortKey);
          o.tenantId = data[i].tenantId;
          o.menuTenantId = data[i].menuTenantId;
          o.useYn = data[i].useYn;

          if (data[i].tenantId == "" ) o.disableClass = "disable-master";
          else if(data[i].useYn == "N")  o.disableClass = "disable-master";
          else o.disableClass = "";
          o.extendGroupClass = "";
          o.child = [];

          if (Number(data[i].depth) == 1) {
            vm.menuList.push(o);
          } else {

            // 2019.11.06 기존 Sort가 겹치는 문제가 발생하여
            // 2Depth부터는 BaseSortKey를 기준으로 변경하도록 수정

            /* var temp;
            if(o.tempSortPath.length == 2) temp = o.tempSortPath[0];
            else temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
            var sData;
            sData = findObject(vm.menuList, 'sort', temp); */

            var temp;
            if(o.tempBaseSortPath.length == 2) temp = o.tempBaseSortPath[0];
            else temp = o.tempBaseSortPath[0] + '' + o.tempBaseSortPath[1];
            var sData;
            //sData = findObject(vm.menuList, 'sort', temp);

            /* if(temp == '209' || temp == "209102" ) {
              console.log(sData, o)
            } */


          //  if(!sData) {

            var parent = findObject(vm.menuList, 'baseSortKey', temp);
            if (parent) {
              var parentCode = parent.sort;
              var subpath = makeSortPath(parentCode);
              if(subpath.length == 1) {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = 100 + parent.child.length;
                temp = subpath[0]
              } else {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = subpath[1];
                o.tempSortPath[2] = 100 + parent.child.length;
                temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
              }

              o.sort = o.tempSortPath.toString().replaceAll(",","");

              sData = findObject(vm.menuList, 'sort', temp);
              checkUpdateMenuList = true;
              //console.log(parentCode, o, temp, sData);
           //}
              sData['child'].push(o);
            }
          }
        }

        if(checkUpdateMenuList) {
          //vm.setChangeMenuList(false);
        }
        if (vm.selectedGroupOptions != "") vm.onChangeGroupView(vm.selectedGroupOptions);
      };

      function findObject(obj, key, value) {
        for (var i = 0; i < obj.length; i++) {
          for (var objKey in obj[i]) {
            if (objKey == key) {
              if (obj[i][objKey] == value) {
                return obj[i];
              }
            }
          }
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
        return false;
      }

      function checkResponse(fNm, reponse) {
        if (reponse.header.status === CONSTANT.HttpStatus.OK) return true;
        else {
          console.log("error");
          // console.error('Error>' + fNm, reponse.header.status, reponse.body.docs[0]);
        }
      }
    },
  ])
})();

(function () {
    "use strict";
    webapp.controller('SysExcelMigrationCtrl', 
    ['$stateParams', 'autoPage', '$timeout', '$scope', '$filter', 'postApi', 'GLOBAL_CONSTANT', 'gConfirm',
    function SysExcelMigrationCtrl($stateParams, autoPage, $timeout, $scope, $filter, postApi, CONSTANT, gConfirm) {

        var vm = this;
        vm.tenantId = '';
        vm.msg = "";
        vm.tabIdx = 0;

        vm.complet = false;
        vm.errorTx ="";

        function excelExport(type) {
          var input = "";
          vm.tabIdx = 0;
          vm.complet = false;
          vm.productList = [];
          vm.product = []; 
          vm.trainerList = [];
          vm.memberList = [];
          vm.matchingList = [];
          if (type == "T") {
            input = document.getElementById("excelFile1");
          } else if (type == "S") {
            input = document.getElementById("excelFile2");
          } else if (type == 'U') {
            input = document.getElementById("excelFile3");
          } else if(type == "C") {
            input = document.getElementById("excelFile4");
          }
          var reader = new FileReader();
          vm.student = [];
          vm.tenant = [];
          var index = 0;
          reader.onload = function(){
            var fileData = reader.result;            
            var wb = XLSX.read(fileData, {type : 'binary'});
            wb.SheetNames.forEach(function(sheetName){
              var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
              if (type == 'T') {
                vm.tenant = angular.copy(rowObj);
              } else if (type == 'S') {
                if(index == 0) {
                  vm.student = angular.copy(rowObj);  
                }
              } else if (type == 'U') {
                vm.users = angular.copy(rowObj);
              } else if (type == 'C') {
                if(index == 0) {
                  vm.consult = angular.copy(rowObj);  
                }
              }
              index++;              
            });
            $timeout(function(){
              afterData(type);
            }, 500);
          };
          reader.readAsBinaryString(input.files[0]);
        }

        function afterData (type) {
          if (type == 'T') {
            vm.msg1 = "엑셀 데이터를 검증합니다. 잠시 기다려주세요.";
          }else if(type == "S") {
            vm.msg2 = "엑셀 데이터를 검증합니다. 잠시 기다려주세요.";
          } else if(type == "U") {
            vm.msg3 = "엑셀 데이터를 검증합니다. 잠시 기다려주세요.";
          } else if(type == "C") {
            vm.msg4 = "엑셀 데이터를 검증합니다. 잠시 기다려주세요.";
          }
          $timeout(function(){
            if (type == 'T') {
              vm.msg1 = "기관데이터를 추출합니다. 잠시 기다려주세요.";
              $timeout(function(){
                setTenantData();
              }, 1000);
            } else if(type == 'S') {
              vm.msg2 = "대상자데이터를 추출합니다. 잠시 기다려주세요.";
              $timeout(function(){
                setStudentData();
              }, 1000);
            } else if(type == 'U') {
              vm.msg3 = "임직원데이터를 추출합니다. 잠시 기다려주세요.";
              $timeout(function(){
                setUsersData();
              }, 1000);
            } else if(type == 'C') {
              vm.msg4 = "상담일지데이터를 추출합니다. 잠시 기다려주세요.";
              $timeout(function(){
                setConsultData();
              }, 1000);
            }
          }, 1000);
        }

        function setTenantData() {
          var data = {};
          data.list = [];
          data.mapCode = 'Migration.insertTenantExcelBatch';

          angular.forEach(vm.tenant, function(item){
            var temp = {
              tableNm : 'tenant',
              MainPage : 'app.dashboard',
              TenantNm : item["기관명"],
              TenantStatus : 'N',
              BizRegNo : item["사업자등록번호"],
              Email : item["이메일"],
              MenuTypeList : [{codeValue : '기관', code: 'TENANTMENU'}],
              LoginId : item["ID"],
              Password : item["PW"]
            };
            var temp2 = {mapCode : 'Migration.getRelateDataId'};

            postApi.select(temp2, function(result)  {              
              if(result.body.docs.length > 0) {
                temp.RelateDataId = result.body.docs[0].RelateDataId;
                data.list.push(temp);
              }
            });
          });

          $timeout(function(){
            postApi.insert(data, function(result) {
              if(result.header.status === CONSTANT.HttpStatus.OK) {
                vm.msg1 = '기관등록이 완료되었습니다.';
              }
            });
          }, 3000);
        }

        function setStudentData() {
          var data ={};
          data.list = [];
          data.mapCode = 'Migration.insertStudentExcelBatch';
          angular.forEach(vm.student, function(item, index) {
            if(!isNullOrEmpty(item["성별"])) {
              if(item["성별"] == '남자' || item["성별"] == '남') {
                item["성별"] = 'M'; 
              } else if (item["성별"] == '여자' || item["성별"] == '여') {
                item["성별"] = 'F'; 
              }
            }

            if(!isNullOrEmpty(item["입국일"])) {
              if (item["입국일"].length == 4) {
                item["입국일"] = item["입국일"] + '0101';
              } else if (item["입국일"].length == 6) {
                item["입국일"] = item["입국일"] + '01';
              }
            }

            if(!isNullOrEmpty(item["접수일"])) {
              if (item["접수일"].length == 4) {
                item["접수일"] = item["접수일"] + '0101';
              } else if (item["접수일"].length == 6) {
                item["접수일"] = item["접수일"] + '01';
              }
            }

            var sYear = '';
            var sMonth = '';
            var sDay = '';
            var tempDate = '';

            var temp = {
              TenantNm : item["소속센터"],
              StudentId : item["고유번호"],
              StudentNm : item["대상자명"],
              StdNmEn : item["여권영문명"],
              BirthDay : item["생년월일"],
              Gender : item["성별"],
              TargetType : item["대상자유형코드"],
              Education : item["학력코드"],
              CtrOfBirth : item["출생국코드"],
              Nationality : item["국적코드"],
              VisaType : item["비자유형코드"],
              Generation : item["하나원기수"],
              Religion : item["종교코드"],
              Email : item["Email"],
              RndDate : item["입국일"],
              RecDate : item["접수일"],
              Mobile : item["휴대폰"],
              GdMobile : item["보호자휴대폰"],
              ZipCode : item["우편번호"],
              Address1 : item["주소"],
              Address2 : item["주소상세"],
              FmyMem : item["가족사항"]
            };

            if(isNullOrEmpty(temp.StdNmEn)) {
              temp.StdNmEn = 'AAA';
            }
            
            if(!isNullOrEmpty(temp.BirthDay)) {
              temp.BirthDay = String(temp.BirthDay);
              sYear = temp.BirthDay.substring(0,4);
              sMonth = temp.BirthDay.substring(4,6);
              sDay = temp.BirthDay.substring(6,8);

              tempDate = new Date(Number(sYear),Number(sMonth)-1,Number(sDay));

              temp.BirthDay = moment(tempDate).format('YYYY-MM-DD');
            }
            
            if(!isNullOrEmpty(temp.RndDate)) {
              temp.RndDate = String(temp.RndDate);
              sYear = temp.RndDate.substring(0,4);
              sMonth = temp.RndDate.substring(4,6);
              sDay = temp.RndDate.substring(6,8);

              tempDate = new Date(Number(sYear),Number(sMonth)-1,Number(sDay));

              temp.RndDate = moment(tempDate).format('YYYY-MM-DD');
            }

            if(!isNullOrEmpty(temp.RecDate)) {
              temp.RecDate = String(temp.RecDate);
              sYear = temp.RecDate.substring(0,4);
              sMonth = temp.RecDate.substring(4,6);
              sDay = temp.RecDate.substring(6,8);

              tempDate = new Date(Number(sYear),Number(sMonth)-1,Number(sDay));

              temp.RecDate = moment(tempDate).format('YYYY-MM-DD');
            }
            data.list.push(temp);
          });
          $timeout(function(){
            postApi.insert(data, function(result) {
              if(result.header.status === CONSTANT.HttpStatus.OK) {
                vm.msg2 = '대상자등록이 완료되었습니다.';
              } else {
                alert('대상자 등록이 실패하였습니다.');
                vm.msg2 = '';
              }
            });
          }, 5000);
        }

        function setUsersData() {
          var data = {};
          data.list = [];
          data.mapCode = "Migration.insertExcelUsers";

          angular.forEach(vm.users, function(item){                        
            var temp = {
              UserNm : item["담당자"],
              TenantNm : item["소속센터"],
              LoginId : item["ID"],
              Password : item["PW"],
            };
            data.list.push(temp);
          });

          $timeout(function(){
            postApi.insert(data, function(result) {
              if(result.header.status === CONSTANT.HttpStatus.OK) {
                vm.msg3 = '임직원등록이 완료되었습니다.';
              }
            });
          }, 3000);
        }

        function setConsultData() {          
          var data = {};
          data.list = [];
          data.mapCode = "Migration.insertExcelConsult";
          
          angular.forEach(vm.consult, function(item) {
            if (!isNullOrEmpty(item["시작시"])) {
              item["시작시"] = item["시작시"].toString();
              if (item["시작시"].length == 1) {
                item["시작시"] = "0"  + item["시작시"];
              }
            }
            if (!isNullOrEmpty(item["시작분"])) {
              item["시작분"] = item["시작분"].toString();
              if (item["시작분"].length == 1) {
                item["시작분"] = "0"  + item["시작분"];
              }
            }
            if (!isNullOrEmpty(item["종료시"])) {
              item["종료시"] = item["종료시"].toString();
              if (item["종료시"].length == 1) {
                item["종료시"] = "0"  + item["종료시"];
              }
            }
            if (!isNullOrEmpty(item["종료분"])) {
              item["종료분"] = item["종료분"].toString();
              if (item["종료분"].length == 1) {
                item["종료분"] = "0"  + item["종료분"];
              }
            }

            var sYear = '';
            var sMonth = '';
            var sDay = '';
            var tempDate = '';
            var temp = {
              PrmId : item["서비스유형코드"],
              ConsProgStatus : item["종결여부코드"],
              ServiceWay : item["서비스방법코드"],
              ProblemType : item["문제유형코드"],
              ServiceTarget : item["서비스대상코드"],
              UserNm : item["담당자"],
              TenantNm : item["소속센터"],
              ServiceDate : item["상담일자"],
              ServiceStartTime : item["시작시"] + item["시작분"],
              ServiceEndTime : item["종료시"] + item["종료분"],
              ServiceTime : item["제공시간"],
              ServiceSubject : item["서비스주제"],
              ServiceContents : item["서비스일지"],
              StudentId : item["대상자고유번호"],
            };

            if (!isNullOrEmpty(temp.ServiceDate)) {
              temp.ServiceDate = String(temp.ServiceDate);
              sYear = temp.ServiceDate.substring(0,4);
              sMonth = temp.ServiceDate.substring(4,6);
              sDay = temp.ServiceDate.substring(6,8);

              tempDate = new Date(Number(sYear),Number(sMonth)-1,Number(sDay));

              temp.ServiceDate = moment(tempDate).format('YYYY-MM-DD');
            }

            data.list.push(temp);
          });

          $timeout(function(){
            postApi.insert(data, function(result) {
              if(result.header.status === CONSTANT.HttpStatus.OK) {
                vm.msg4 = '상담일지등록이 완료되었습니다.';
              }else {
                alert('상담일지 등록이 실패하였습니다.');
                vm.msg4 = '';
              }
            });
          }, 3000);
        }

        vm.excelExport = excelExport;
      }]);
  })();


(function () {
  "use strict";
  webapp.controller('SysNoticEditCtrl', 
    ['$scope','$stateParams', 'autoPage', '$state', '$rootScope', 'gAlert',
    function SysNoticEditCtrl($scope, $stateParams, autoPage, $state,  $rootScope, gAlert) {
      var vm = this;
      var ap = new autoPage();
      
      vm.keyId = $stateParams.keyId;
      vm.layout = $rootScope.gVariable.layoutBoard;

      // TYPE DATA
      var ctrlData = SysNoticEditCtrlData(vm);
      var mapCode = ctrlData.get('mapCode');
      var pageUrl = ctrlData.get('pageUrl');
      var form = ctrlData.get('form');
     
      var pageData = { 
        vm : vm, 
        stateParams : $stateParams, 
        scope : $scope,
        PageUrl : pageUrl,
      };

      // VIEW DATA
      vm.notice = {};         // 저장 데이터

      //1.All, 2.User, 3.Customer, 4.0-Tenant ALL, 4.0-Tenant All, 5.0-Tenant User, 6.Tenant Customer, 9.Private
      vm.publicTarget = [
        {Code : '1', CodeValue: '전체'},
        {Code : '2', CodeValue: '직원'},
        {Code : '3', CodeValue: '회원'},
      ]


      // DECLARE
      /******************************************************************************** */
   
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.notice.Title)) errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        if (isNullOrEmpty(vm.notice.PublicTarget)) errMsg = errMsg + '- 공개대상을 선택하세요.<br/>';
        if (isNullOrEmpty(vm.notice.Contents)) errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        
        if (!isNullOrEmpty(errMsg)) {
          ap.alert(errMsg);
          return false;
        }

        return true;
      }

      function setData() {
        console.log("start setData")
        //Editor
        ap.confirm('공지사항을 저장하시겠습니까?',
          function(){
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.notice.Contents = $("#strHtml").val();
          if(getIsValidData()) {
            var p = angular.copy(vm.notice);
            p.mapCode = mapCode.update;
            ap.commit(p, function () {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  goList();
                }
              });
            });
          }
        });
      }

      function setDelData() {
        ap.confirm('공지사항을 삭제하시겠습니까?',
          function(){

            var p = angular.copy(vm.notice);
            p.mapCode = mapCode.delete;
            ap.commit(p, function(){
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  if(vm.layout == "N") {
                    $state.go(pageUrl.LIST_PAGE_URL.url, {
                      srch: ''
                    } , {reload: pageUrl.LIST_PAGE_URL.url});
                  } else {
                    $state.go(pageUrl.LIST_EDIT_PAGE_URL.url, {
                      srch: '', keyId : ''
                    } , {reload: pageUrl.LIST_EDIT_PAGE_URL.url});
                  }
                }
              });
            });
        });
      }

      function goList() {
        $state.go(pageUrl.LIST_PAGE_URL.url, {srch: ''});
      }

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // Fn Callback 시작
      function getInitDataExt(){

        if(isNullOrEmpty(vm.keyId)) {
          vm.titleNm = "공지사항 등록";
          ap.setForms(form.section01);
        } else {
          vm.titleNm = "공지사항 수정";

          var p = {
            KeyId : $stateParams.keyId,
            SysNotice : 'Y',
            mapCode : mapCode.selectDetail
          };

          ap.select(p, function(result) {
            vm.notice = result[0];
            vm.notice.PublicTarget = vm.notice.PublicTarget.toString();
            ap.setForms(form.section01);
          })
        }

      };
      // Fn Callback 종료
      /******************************************************************************** */
      
      /******************************************************************************** */
      // 함수 정의 시작

      /** @description 저장 전 데이터 유효성 검사 **/
      vm.getIsValidData = getIsValidData;
      /** @description 데이터 저장 버튼 클릭 시 **/
      vm.setData = setData;
      vm.setDelData = setDelData;
      vm.getInitDataExt = getInitDataExt;
      vm.goList = goList;

      // 함수 정의 종료
      /******************************************************************************** */
      ap.setData(pageData);
      ap.init();

    }]);
})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysNoticEditCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      mapCode : {
        selectDetail : "Notice.getNoticeDetail",        
        update : {
          insert : 'Notice.insertNotice',
          update : 'Notice.updateNotice'
        },
        delete : 'Notice.delNotice'
      },
      pageUrl : {            
        LIST_PAGE_URL : {
          url : 'app.system.notice-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.notice-list.edit',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            keyId : vm.keyId
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.notice-edit',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            keyId : vm.keyId
          }
       },            
      },
      // 폼에 대한 정보를 정의
      form : {
        section01 : {
          target : "#inputWrap",
          bindKey : viewTx.vc + '.notice',
          layout : mElemTx.layout.inline,
          resetForm :true,
          field : [
            {
              label : "제목",
              key : "Title",   
              type : mElemTx.text, 
              col : 2,
            },
            {
              label : "공개",
              key : "PublicTarget",   
              type : mElemTx.select, 
              col : 3,
              bindData : viewTx.vc + '.publicTarget',
            },
          ]
        },
      }
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  webapp.controller('SysNoticListCtrl', 
    ['$scope','$stateParams', 'autoPage', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi',
    function SysNoticListCtrl($scope, $stateParams, ap, fileUploadService, StaticVariable, $rootScope, postApi) {

      var vm = this;          // View Model
      vm.pageType = $stateParams.type;
      vm.keyId = $stateParams.keyId;

      var ctrlData = SysNoticListCtrlData(vm);
      var apiOption = ctrlData.get('apiOption');
      var pageUrl = ctrlData.get('pageUrl');
      var form = ctrlData.get('form');

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        headerTitle : vm.headerTitle,
        pageType : "LIST",
        //listStack : false,
        listParam : {
          TcId : vm.keyId,
          SysNotice : 'Y'
        },
        keyTableNm : "Notice",
        keyColumnNm : "KeyId",
        //enableListCheck : true,
        MapperId : apiOption,
        PageUrl : pageUrl,
        rootScope : $rootScope
      };

      vm.goodsState = [];
      vm.YnList = [
        {Code : 'Y', CodeValue : 'Y'},
        {Code : 'N', CodeValue : 'N'},
      ];

      vm.publicTarget = [
        {Code : '1', CodeValue: '전체'},
        {Code : '2', CodeValue: '직원'},
        {Code : '3', CodeValue: '회원'},
      ]
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      function getInitDataExt() {
        vm.headerTitle = "공지리스트";
        
        // var p = {mapCode: 'CommonCode.getCommonCodeValue', ParentCommonCodeId: '2MREQT6FV6'};
        // ap.select(p, function(result){vm.goodsState = result;});

        ap.setForms(form.SEARCH);
      };

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // 함수 정의 시작


      /** @description AP init Callback**/
      vm.getInitDataExt = getInitDataExt;

      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new ap();
      ap.setData(pageData);
      ap.initView();
      // autoPage 종료
    }]);

})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysNoticListCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      apiOption : {
        init : {
          LIST_CNT_SQL : 'Notice.getNoticeListCnt', // 목록 건수 조회 SQL
          LIST_SQL : 'Notice.getNoticeList',    // 목록 조회 SQL
        },
        del : {

        },
      },
      pageUrl : {
        LIST_PAGE_URL : {
          url : 'app.system.notice-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.notice-list.edit',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            KeyId : ''
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.notice-edit',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            KeyId : ''
          }
       },
      },
      form : {
        SEARCH : {
          target : "#searchWrap",
          bindKey : viewTx.vc + '.srch',
          layout : mElemTx.layout.inner,
          resetForm :true,
          field : [
            {   
              label : "타이틀",
              type : mElemTx.text,
              col : 1,
              key : "Title",
            },
            {   
              label : "공개타입",
              type : mElemTx.select,
              col : 1,
              key : "PublicTarget",
              bindData : "vc.publicTarget"
            },
          ]
        },
      }   
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  /**
   * @ngdoc function
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $stateParams - state Parameter object
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 회원사관리
   */
  webapp.controller('SysOrganizationListCtrl', 
    ['$rootScope', '$scope', '$stateParams', '$translate', 'autoPage', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$window', 'modalFactory',
    function SysOrganizationListCtrl($rootScope, $scope, $stateParams, $translate, ap, autoView, postApi, CONSTANT, $window, modalFactory) {

      var vm = this;
      vm.ManageYn = $window.sessionStorage['loginTenantAdminYn'];
      vm.SysAdmin = $window.sessionStorage['loginSysAdminYN'];
      vm.BranchAdminYN = $window.sessionStorage['loginBranchAdminYn']; 

      // 은행코드
      postApi.select({mapCode : 'CommonCode.getCommonCodeValue', CodeType : 'BANKS'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeBankList = result.body.docs;
        }
      });

      postApi.select({mapCode : 'CommonCode.getCommonCodeValue', CodeType : 'SETTING_MIN'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeMinList = result.body.docs;
        }
      });

      vm.codeMinList = [5, 10, 15, 30];

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,

        viewType : mViewType.Edit,
        tableNm : "organization",
        keyIdNm : "KeyId",
        alias : "vc",
        dataModelNm : "data",


        apis : {
          /** common mapper **/
          // initSelect : 기본 데이터를 가져오는 코드 
          initSelect : { mapCode : "organizationMng.getOrganizationDetail", param : null },
          //insert : "ScCustomer.insertCustomer",
          update : "organizationMng.updateOrganization",
        },

        addRow : ['GroupNm', 'Address'],

        addFormGroup : {
          BankInfo : { 
            after : "BizRegNo", 
            type : mElemTx.date,  
            bind : [ 
              {bindKey : "Bank", type: mElemTx.select},
              {bindKey : "AccountNum", type: mElemTx.input}
            ], 
            label : "계좌번호", colSize : 2
          }
            
        },

        addForm : {
          // Adress 의 경우 autoView에서 자동으로 설정이 되면 bindKey를 꼭 넣어주어야함
          Address : { target : "sec1", type : mElemTx.address,  bindKey : ["ZipCode", "Addr1", "Addr2"], label : "주소", colSize: 1},
          SettingMin : { after : 'WorkEnd', type : mElemTx.select, colSize: 2, label : "예약시간단위"},
          HomeInterlockingKey : { after : 'Remark', type : mElemTx.input, colSize: 2, label : "홈페이지연동키"},
          Guide : { after : 'HomeInterlockingKey', type : mElemTx.bindWrap, colSize: 2, label : "연동가이드"},
          
        },

        ngClick : {
          Guide : "downloadGuide",
          TelNo : "srchFromTelNoModal",
          Email : "srchFromEmailModal"
        },

        timeOption : {
          LunchStart : { minuteStep : 30 },
          LunchEnd : { minuteStep : 30 },
          WorkStart : { minuteStep : 30 },
          WorkEnd : { minuteStep : 30 },
        },

        ngIf : {
          Ceo : "vc.data.Depth == 1 || !vc.data.KeyId",
          BizRegNo : "vc.data.Depth == 1 || !vc.data.KeyId",
          TelNo : "vc.data.Depth == 1 || !vc.data.KeyId",
          BankInfo : "vc.data.Depth == 1 || !vc.data.KeyId",
          Address : "vc.data.Depth == 1 || !vc.data.KeyId",

          LunchStart : "vc.data.Depth == 1 || !vc.data.KeyId",
          LunchEnd : "vc.data.Depth == 1 || !vc.data.KeyId",
          WorkStart : "vc.data.Depth == 1 || !vc.data.KeyId",
          WorkEnd : "vc.data.Depth == 1 || !vc.data.KeyId",
          Contact :  "vc.data.Depth == 1 || !vc.data.KeyId",
          HomeInterlockingKey :  "vc.data.Depth == 1 || !vc.data.KeyId",
          Guide :  "vc.data.Depth == 1 || !vc.data.KeyId",
        },

        disabled : {
          HomeInterlockingKey : true
        },

        customCodes : {
          Contact : "codeManager",
          Bank : "codeBankList",
          SettingMin : "codeMinList"

        },

        ngChange : {
          Contact : "setChangeContact"
        },
      };

      function downloadGuide () {
        window.location.href = "/assets/guide/SalevisCare_API_Guide_v1.0.pdf";
      }

      vm.datas = [];
      vm.linkData =[];

      vm.rootData = {};
      vm.subData = {};

      vm.showTabView = [];
      vm.rootTitle = "지점 등록";
      if(vm.BranchAdminYN == "Y") {
        vm.rootTitle = "지점";
      }

      var MAPPER_DETAIL = "organizationMng.getOrganizationDetail";

      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.sbCtrl;

      vm.rootDisabled = true;
      vm.showSubView = false;

      vm.RentalYNCode = [];
      vm.daysCode = [];

      var defineForms = {}
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      vm.getInitDataExt = function() {
       

      };

      vm.setDetailView = function (code) {

      }

      vm.setChoiceItem = function() {

      }

      /**
       * 1Depth 정보 저장
       **/
      vm.setRootData = function() {
        
        vm.rootData.mapCode = 'organizationMng.updateMmgadditionitem';
        ap.commit(vm.rootData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      }

      /**
       * 2Depth 정보 저장
       **/
      vm.setSubData = function() {
        vm.subData.mapCode = 'organizationMng.updateMmgadditionitem';
        ap.commit(vm.subData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      }


      /* Sortable Container Function */

      /**
       * 해당 디렉티브가 완료되었을 시 호출되는 함수
       * html 페이지에서 initCallback으로 지정할 수 있다.
      */
      vm.succSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        
        ctrl.setRootTitle(vm.rootTitle);
        vm.getSortableList();

        //* ITEM이 추가되었을시 호출되는 함수
        ctrl.addItem = function(data, callback) {
          data.mapCode = "organizationMng.insertOrganization";
          data.GroupNm = data.GroupNm;
          data.Depth = data.CodeLevel;
          data.GroupNm = data.ItemNm
          data.ParentId = data.ParentCommonCodeId;
      
          ap.commit(data, function(result){
            callback(result);
            //ap.alert('Menu.SAVED');
          });
        };

        ctrl.setDetailView = function(data, callback) {
          vm.data =  data;
          vm.data.Guide = "연동가이드";
          vm.data.HomeInterlockingKey = $window.sessionStorage['loginTenantId'] + "-" + vm.data.KeyId;
          
          // 대표번호 하이픈 처리
          if (!isNullOrEmpty(vm.data.TelNoNm)) {
            vm.data.TelNoNm = autoHypenTel(vm.data.TelNoNm);
          }

          // 담당자
          postApi.select({mapCode : 'ScUser.getUserListCodes', srchBranchId : data.KeyId}, 
          function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeManager = result.body.docs;
            }
          })

          vm.data.PointData = [
            {ItemType : 20}, // 일반
            {ItemType : 30}, // 횟수권
            {ItemType : 40}, // 정액권
          ]

          if(vm.data.Depth == 1) {
            postApi.select({mapCode : 'organizationMng.getOrganizationPoints', srchBranchId : data.KeyId}, 
            function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                
                for(var i = 0; i < result.body.docs.length; i++) {
                  var at = result.body.docs[i];
                  if(at.ItemType == "20") {
                    vm.data.PointData[0] = at;
                  }
                  if(at.ItemType == "30") {
                    vm.data.PointData[1] = at;
                  }
                  if(at.ItemType == "40") {
                    vm.data.PointData[2] = at;
                  }
                }
              }
            })
          }
        }

        //* 리스트 정렬을 하였을 시 데이터를 저장한다.
        ctrl.setChangedSort = function(data, callback) {

          var param = {};
          param.mapCode = 'organizationMng.updateChagneSort';
          param.list = data;
          postApi.update(param, function() {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            callback();
          })
        };

        //* 리스트 상태 변경하기 전 함수
        //* 무조건 콜백처리를 해주어야 함
        ctrl.setChangeMenuState = function(data, callback) {
          var param = {};
          param.mapCode = "organizationMng.updateEnableList";
          param.list = data;
          postApi.update(param, function(result) {            
            callback(result);
            ap.alert('Menu.SAVED');
          });
        };
         
        ctrl.setDeleteItem = function(data, callback) {
          var param = data;
          param.mapCode = "organizationMng.deleteItem";
          postApi.update(param, function(result) {    
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.getSortableList(function(){
                callback(result);
                ap.alert('Menu.DELETED');
              });              
            }
          });
        };
      }      

      //* 데이터를 바인드하기 위함
      vm.getSortableList = function(callback) {
        var param = {
          mapCode : MAPPER_DETAIL,
        }
        
        ap.getData(param, function(result){
          var docs = result.body.docs;
          if(docs.length > 0) {
            for(var i = 0; i < docs.length; i++) {
              docs[i].ItemNm = docs[i].GroupNm;
              docs[i].CodeLevel = docs[i].Depth;
              docs[i].ParentCommonCodeId = docs[i].ParentId
            }
          } else {
            docs = [];
          }
          vm.sbCtrl.drawList(docs)
          if(callback != undefined) callback(docs);
        })
        //vm.sbCtrl.getData(param) 
      }

      /**
       * 노드가 추가되었을 시 호출되는 함수
       * vm.sbCtrl을 오버라이드하여 사용한다.
      */
      function onReadyAutoView() {

        vm.data = {};
        vm.data.PointData = [
          {ItemType : 20}, // 일반
          {ItemType : 30}, // 횟수권
          {ItemType : 40}, // 정액권
        ];
        var temp = [];
        for(var i = 0; i < 6; i++) {
          var label = (i % 2 == 0) ? "현금" : "카드";
          var code  = (i % 2 == 0) ? "CashPoint" : "CardPoint";
          var obj = {code: "PointData[" + Math.floor(i / 2 ) +"]." + code , target : "sec" + (i+4), type : mElemTx.number, colSize: 1, label : label};

          temp.push(obj);
        }
        //temp.push({code: "Address", after : "TelNo", type : mElemTx.address,  bindKey : ["ZipCode", "Addr1", "Addr2"], label : "주소", colSize: 1})
        av.addForm(temp, function(){ })
      }


      function setData() {

        av.commit(function(result){
          vm.sbCtrl.setName(vm.data.KeyId, vm.data.GroupNm);
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
        })
      }

      function setChangeContact(key, data) {
       
      }

      //#region 발신번호목록 모달창 호출 srchFromTelNoModal
      /**
       * 발신번호목록 모달창 호출
       * @param
       * @return
       * @author 이기훈
       */
      function srchFromTelNoModal() {
        var ctrl = 'FromTelNoModalCtrl as vc';
        var paramData = {
          SendInfo: vm.data.TelNo,
          Type: 'M'
        };

        var modalInstance = modalFactory.open('md', 'app/message/modal/from-tel-no-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.TelNo = okData.SendInfo;
          vm.data.TelNoNm = autoHypenTel(okData.SendInfo);
        }, function (cancelData) {
        });
      }
      //#endregion 발신번호목록 모달창 호출 srchFromTelNoModal

      //#region 발신이메일목록 모달창 호출 srchFromEmailModal
      /**
       * 발신이메일목록 모달창 호출
       * @param
       * @return
       * @author 이기훈
       */
      function srchFromEmailModal() {
        var ctrl = 'FromTelNoModalCtrl as vc';
        var paramData = {
          SendInfo: vm.data.Email,
          Type: 'E'
        };

        var modalInstance = modalFactory.open('md', 'app/message/modal/from-tel-no-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.Email = okData.SendInfo;
          vm.data.EmailNm = okData.SendInfo;
        }, function (cancelData) {
        });
      }
      //#endregion 발신이메일목록 모달창 호출 srchFromEmailModal

      /* /Sortable Container Function */
      vm.onReadyAutoView = onReadyAutoView;
      vm.setData = setData;
      vm.setChangeContact = setChangeContact;
      vm.downloadGuide = downloadGuide;
      vm.srchFromTelNoModal = srchFromTelNoModal;
      vm.srchFromEmailModal = srchFromEmailModal;


      // 확장 기능 개발 구간 종료
      /******************************************************************************** */
      var ap = new ap();
      ap.setData(pageData);
      ap.init();
      // autoPage 종료
      
      var av = new autoView();
      av.init(pageData);

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

    }]);
})();


webapp.controller('AccountLockListCtrl', [
  '$window',
  '$scope',
  '$rootScope',
  'gAlert',
  'gConfirm',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'postApi',
  function AccountLockListCtrl($window, $scope, $rootScope, gAlert, gConfirm, $state, $stateParams, CONSTANT, postApi) {
    if (!isPageAccess('accountLock-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('accountLock-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'accountLock-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    var vm = this;
    vm.getList = getList;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.listSize = CONSTANT.PAGINATION.LISTSIZE;

    if (!$stateParams.srch) {
      vm.srch = {
        viewSize: 25,
        page: 1,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;
    vm.sendMsg = sendMsg;

    vm.changeViewSize = function () {
      vm.srch.page = 1;
      $state.go($state.current.name, { srch: encodeURIComponent(JSON.stringify(vm.srch, replacer)) });
    };

    vm.pageChanged = function () {
      vm.srch.page = vm.currentPage;
      $state.go($state.current.name, { srch: encodeURIComponent(JSON.stringify(vm.srch, replacer)) });
    };

    function init(){
      getList();
    }

    function getList() {
      getListCnt();
      vm.srch.mapCode = 'AccountLock.getAccountLockList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = data.body.docs;
          } else {
            vm.lists = [];
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getList()');
        }
      );
    }

    function getListCnt() {
      vm.srch.mapCode = 'AccountLock.getAccountLockListCount';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.totalItems = data.body.docs[0];
          } else {
            vm.totalItems = 0;
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getListCnt()');
        }
      );
    }

    function sendMsg(data) {
      gConfirm('', '임시 비밀번호를 발송하시겠습니까?', {
        btn:'',
        fn:function(){
          var param = {
            userId : data.UserId,
            lockId : data.LockId
          };
    
          postApi.api('sendNewPasswordMessage', param, function(data){
            if(data.header.status === CONSTANT.HttpStatus.OK){
              gAlert('', '발송 완료되었습니다.', {
                fn:function(){
                  getList();
                }
              });
            }else{
              gAlert(data.body.docs[0].errMessage);
            }
          })
        }
      }, {
        btn:'',
        fn:function(){}
      });
      
    }

    init();
  },
]);

webapp.controller('PermissionInfoListCtrl', [
  '$window',
  '$scope',
  '$rootScope',
  'gAlert',
  'gConfirm',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'postApi',
  function PermissionInfoListCtrl($window, $scope, $rootScope, gAlert, gConfirm, $state, $stateParams, CONSTANT, postApi) {
    if (!isPageAccess('permissionInfo-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('permissionInfo-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'permissionInfo-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    var vm = this;
    var today = new Date();
    var year = today.getFullYear().toString();
    vm.getList = getList;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.listSize = CONSTANT.PAGINATION.LISTSIZE;

    if (!$stateParams.srch) {
      vm.srch = {
        viewSize: 25,
        page: 1,
        year: year,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;
    vm.sendMsg = sendMsg;

    vm.changeViewSize = function () {
      vm.srch.page = 1;
      $state.go($state.current.name, { srch: encodeURIComponent(JSON.stringify(vm.srch, replacer)) });
    };

    vm.pageChanged = function () {
      vm.srch.page = vm.currentPage;
      $state.go($state.current.name, { srch: encodeURIComponent(JSON.stringify(vm.srch, replacer)) });
    };

    function init(){
      getList();
    }

    function getList() {
      getListCnt();
      vm.srch.mapCode = 'PersonalInfo.getPermissionInfoList';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = data.body.docs;
          } else {
            vm.lists = [];
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getList()');
        }
      );
    }

    function getListCnt() {
      vm.srch.mapCode = 'PersonalInfo.getPermissionInfoListCnt';
      postApi.select(
        vm.srch,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.totalItems = data.body.docs[0].totalItems;
          } else {
            vm.totalItems = 0;
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getListCnt()');
        }
      );
    }

    function sendMsg(data) {
      gConfirm('', '임시 비밀번호를 발송하시겠습니까?', {
        btn:'',
        fn:function(){
          var param = {
            userId : data.UserId,
            lockId : data.LockId
          };
    
          postApi.api('sendNewPasswordMessage', param, function(data){
            if(data.header.status === CONSTANT.HttpStatus.OK){
              gAlert('', '발송 완료되었습니다.', {
                fn:function(){
                  getList();
                }
              });
            }else{
              gAlert(data.body.docs[0].errMessage);
            }
          })
        }
      }, {
        btn:'',
        fn:function(){}
      });
      
    }

    init();
  },
]);

webapp.controller('PersonalInfoEditCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  function UserEditCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalWindow,
    postApi,
    gAlert,
    gConfirm
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'personalInfo-edit',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');
    
    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('personalInfo-edit', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'personalInfo-edit',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    // 함수 선언
    //vm.chkDupLoginId = chkDupLoginId;
    //vm.chkDupLoginIdClear = chkDupLoginIdClear;
    vm.getData = getData;
    vm.setData = setData;
    /*$scope.showArmyInfo = true;
      $scope.objArmyZone1YN = "N";
      $scope.objArmyZone2YN = "N";
      $scope.objArmyZone3YN = "N";
      $scope.objArmyZone4YN = "N";*/
    vm.numberOnly = numberOnly;

    // 공통코드 정의
    vm.DownloadStartHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.DownloadStartMinuteList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.DownloadEndHourList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1120',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    vm.DownloadEndMinuteList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.DownloadStartHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.DownloadStartMinute = data.Code;
      }
    };
    vm.onSelectCallback2 = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '1120') {
        vm.data.DownloadEndHour = data.Code;
      } else if (data.CodeType == '1130') {
        vm.data.DownloadEndMinute = data.Code;
      }
    };

    function numberOnly(x) {
      return x.toString().replace(/[^0-9]/g, '');
    }

    /*vm.PermStat1List = {};
      vm.PermStat2List = {};      
      
      vm.onArmyTypeListSelected = function(data) {
        console.log("onArmyTypeListSelected=", data);
        
        vm.PermStat1List.CodeType = '1140';
        vm.PermStat1List.ParentCommonCodeId = '';
        
        if (data == null) {
        	vm.data.ArmyType = '';
        	vm.data.ArmyType_ = '';
          return;
        }
        
        vm.data.ArmyType = data.Code;
        vm.data.ArmyType_ = data.CodeValue;
        vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
        
        if (data.Code == null) data.Code = "";              
      }
      
      vm.onPermStat1ListSelected = function(data) {
        console.log("onPermStat1ListSelected=", data);
        
        vm.PermStat2List.CodeType = '';
        vm.PermStat2List.ParentCommonCodeId = '';
        
        if (data == null) {
        	vm.data.PermStat1 = '';
        	vm.data.PermStat1_ = '';
          return;
        }
        
        vm.data.PermStat1 = data.Code;
        vm.data.PermStat1_ = data.CodeValue;
        vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
      }
      
      vm.onPermStat2ListSelected = function(data) {
        console.log("onPermStat2ListSelected=", data);
        
        if (data == null) {
        	vm.data.PermStat2 = '';
        	vm.data.PermStat2_ = '';
          return;
        }
        
        vm.data.PermStat2 = data.Code;
        vm.data.PermStat2_ = data.CodeValue;
      } 
      
      // 행추가 삭제 테이블 (자격증)
      $scope.ArmyInfoJSON=[];
      
      $scope.removeRowArmyInfo = function(index){
        var removeJSON = $scope.ArmyInfoJSON.splice(index, 1);
        
        if (removeJSON[0].UserArmyInfoId != "") {
            deleteArmyInfo(removeJSON[0].UserArmyInfoId);  
        }
        
        if ($scope.ArmyInfoJSON.length() === 0){
          $scope.ArmyInfoJSON = [];
        }
      };

      $scope.addRowArmyInfo = function(){
        var strArmyType = typeof(vm.data.ArmyType) == "undefined" || vm.data.ArmyType == "" ? "" : vm.data.ArmyType;
        var strArmyType_ = typeof(vm.data.ArmyType_) == "undefined" || vm.data.ArmyType_ == "" ? "" : vm.data.ArmyType_;
        var strPermStat1 = typeof(vm.data.PermStat1) == "undefined" || vm.data.PermStat1 == "" ? "" : vm.data.PermStat1;
        var strPermStat1_ = typeof(vm.data.PermStat1_) == "undefined" || vm.data.PermStat1_ == "" ? "" : vm.data.PermStat1_;
        var strPermStat2 = typeof(vm.data.PermStat2) == "undefined" || vm.data.PermStat2 == "" ? "" : vm.data.PermStat2;
        var strPermStat2_ = typeof(vm.data.PermStat2_) == "undefined" || vm.data.PermStat2_ == "" ? "" : vm.data.PermStat2_;
        var isErr = false;
        var isDel = false;
        
        if (strArmyType == "") {
          gAlert('', '군별을 선택해주세요.');
          return false;
        }
        
        // 중복체크로직 삽입
        $.each($scope.ArmyInfoJSON, function (idx, row) {
          // 중복체크
          if (row.ArmyType == strArmyType && row.PermStat1 == strPermStat1 && row.PermStat2 == strPermStat2) {
            gAlert('', '이미등록된 소속입니다.');
            isErr = true;
            return false;
          }
          
          // 상위체크(1뎁스)
          if ((row.ArmyType == strArmyType && row.PermStat1 == "" && row.PermStat2 == "")
            || (row.ArmyType == strArmyType && row.PermStat1 == strPermStat1 && row.PermStat2 == "")
          ) {
            gAlert('', '이미상위 소속이 등록되어 있습니다.');
            isErr = true;
            return false;
          }
          
          // 하위체크 (1뎁스)
          if (strArmyType != "" && strPermStat1 == "" && strPermStat2 == "") {
            if (row.ArmyType == strArmyType) {
              //if (!isDel && !gConfirm("", "하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) { // gConfirm 사용불가 우선 true가 반환되어 진행된후 나중에 confirm 창이 나오는 문제가 발생
              if (!isDel && !confirm("하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) {                
                isErr = true;
                return false;
              }
              else {
                isDel = true;
                delete $scope.ArmyInfoJSON[idx];
                $scope.ArmyInfoJSON = $scope.ArmyInfoJSON.filter(function (x) { return x !== null }); //null값 제거
              }
            }
          }
          
          // 하위체크 (2뎁스)
          if (strArmyType != "" && strPermStat1 != "" && strPermStat2 == "") {
            if (row.ArmyType == strArmyType && row.PermStat1 == strPermStat1) {
              //if (!isDel && !gConfirm("", "하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) { // gConfirm 사용불가 우선 true가 반환되어 진행된후 나중에 confirm 창이 나오는 문제가 발생
              if (!isDel && !confirm("하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) {       
                isErr = true;
                return false;
              }
              else {
                isDel = true;
                delete $scope.ArmyInfoJSON[idx];
                $scope.ArmyInfoJSON = $scope.ArmyInfoJSON.filter(function (x) { return x !== null }); //null값 제거
              }
            }
          }
        });        
        
        if (isErr) return false;
        
        $scope.ArmyInfoJSON.push({
          "UserArmyInfoId":"", 
          "ArmyType":"" + strArmyType + "", 
          "ArmyType_":"" + strArmyType_ + "", 
          "PermStat1":"" + strPermStat1 + "", 
          "PermStat1_":"" + strPermStat1_ + "",
          "PermStat2":"" + strPermStat2 + "", 
          "PermStat2_":"" + strPermStat2_ + ""
        });
      };*/

    vm.stateParams = {
      DownloadSettingId: $stateParams.UserId,
    };

    // 검색 조건
    vm.srch = {
      //UserId : $stateParams.UserId,
      TenantId: $window.sessionStorage['loginTenantId'],
      //TableNm : 'Users',
    };

    // 등록/수정 표시용 컬럼 목록
    //vm.srch.editColumns = [];

    // 조회 데이터
    vm.data = {
      //UserId : $stateParams.UserId,
      TenantId: $window.sessionStorage['loginTenantId'],
      //TableNm : 'Users',
    };

    // 유효성검사
    function chkValid() {
      /*if (
        typeof vm.data.DownloadStartHour == 'undefined' ||
        vm.data.DownloadStartHour == '' ||
        typeof vm.data.DownloadStartMinute == 'undefined' ||
        vm.data.DownloadStartMinute == '' ||
        typeof vm.data.DownloadEndHour == 'undefined' ||
        vm.data.DownloadEndHour == '' ||
        typeof vm.data.DownloadEndMinute == 'undefined' ||
        vm.data.DownloadEndMinute == ''
      ) {
        gAlert('', '업무시간을 선택해주세요');
        return false;
      }*/
      /*if (typeof(vm.data.LoginId) == "undefined" || vm.data.LoginId == "") {          
          gAlert('', '아이디를 입력해주세요');
          return false;
        }
	    
	      if (vm.data.UserId == "") {
  	      if (vm.data.isDupLoginId == "Y") {
            gAlert('', '중복확인 버튼을 클릭해주세요');
            return false;
          }
	      }
	      if ((typeof(vm.data.UserId) == "undefined" || vm.data.UserId == "") && (typeof(vm.data.Password) == "undefined" || vm.data.Password == "")) {
          gAlert('', '비밀번호를 입력해주세요');
          return false;
        }
	      if ((typeof(vm.data.UserId) == "undefined" || vm.data.UserId == "") && (typeof(vm.data.Password) == "undefined" || vm.data.Password.length < 8)) {
          gAlert('', '비밀번호는 최소 8자리 이상으로 입력해주세요');
          return false;
        }
        if ((typeof(vm.data.UserId) == "undefined" || vm.data.UserId == "") && (typeof(vm.data.Password2) == "undefined" || vm.data.Password2 == "")) {
          gAlert('', '비밀번호확인을 입력해주세요');
          return false;
        }        
        if (vm.data.Password != vm.data.Password2) {
          gAlert('', '비밀번호가 일치하지 않습니다');
          return false;
        }
        if (typeof(vm.data.Password) != "undefined" && vm.data.Password != "" && $window.sessionStorage['loginUserType'] != '020' && !checkPassword(vm.data.Password,$window.sessionStorage['loginUserId'])) {          
            //gAlert('', '비밀번호가 일치하지 않습니다.');
            return false;
        }
        if (typeof(vm.data.UserNm) == "undefined" || vm.data.UserNm == "") {          
          gAlert('', '사용자명을 입력해주세요');
          return false;
        }
        if (typeof(vm.data.UserType) == "undefined" || vm.data.UserType == "") {
          gAlert('', '사용자구분을 선택해주세요');
          return false;
        }
        if (typeof(vm.data.UseYN) == "undefined" || vm.data.UseYN == "") {
          gAlert('', '사용여부를 선택해주세요');
          return false;
        }
        if (typeof(vm.data.Email) == "undefined" || vm.data.Email == "") {
          gAlert('', '이메일을 입력해주세요');
          return false;
        }*/

        if(isNullOrEmpty(vm.data.SessionMinute)) {
          gAlert('', '세션유지시간(분)을 입력해주세요.');
          return false;
        }

      return true;
    }

    /*function checkPassword(password,id){
          
          if(!/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/.test(password)){            
              alert('숫자+영문자+특수문자 조합으로 8자리 이상 16자리 이하로 사용해야 합니다.');
              return false;
          }    
          var checkNumber = password.search(/[0-9]/g);
          var checkEnglish = password.search(/[a-z]/ig);
          if(checkNumber <0 || checkEnglish <0){
              alert("숫자와 영문자를 혼용하여야 합니다.");
              return false;
          }
          if(/(\w)\1\1/.test(password)){
              alert('같은 문자를 3번 이상 사용하실 수 없습니다.');
              return false;
          }
          return true;
      }*/

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getData() {
      /*if (vm.srch.UserId == null || vm.srch.UserId == '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          return;
        }*/

      vm.srch.mapCode = 'PersonalInfo.getDownloadSettingDetail';
      postApi.select(
        vm.srch,
        function (data) {
          // console.log('load', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0 && data.body.docs[0].UserId !== null) {
              vm.data = data.body.docs[0];

              // vm.DownloadStartHourList.Code = vm.data.DownloadStartHour;
              // vm.DownloadStartMinuteList.Code = vm.data.DownloadStartMinute;
              // vm.DownloadEndHourList.Code = vm.data.DownloadEndHour;
              // vm.DownloadEndMinuteList.Code = vm.data.DownloadEndMinute;

              /*vm.UseYNList.Code = vm.data.UseYN;              
            vm.data.OldLoginId = vm.data.LoginId;
            vm.data.isDupLoginId = "N";
            
            $scope.objArmyZone1YN = vm.data.ArmyZone1YN;
            $scope.objArmyZone2YN = vm.data.ArmyZone2YN;  
            $scope.objArmyZone3YN = vm.data.ArmyZone3YN;  
            $scope.objArmyZone4YN = vm.data.ArmyZone4YN;       
            
            getArmyInfoList(); // 소속데이터권한 목록*/

              return;
            }
          }
          gAlert('알림', data.body.docs[0].errMessage);
        },
        function (data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('알림', data.body.docs[0].errMessage);
        }
      );
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
     */
    function setData() {
      if (!chkValid()) return false;

      /*vm.data.ArmyZone1YN = $scope.objArmyZone1YN;
        vm.data.ArmyZone2YN = $scope.objArmyZone2YN;
        vm.data.ArmyZone3YN = $scope.objArmyZone3YN;
        vm.data.ArmyZone4YN = $scope.objArmyZone4YN;*/

      // console.log(vm.data);

      /*if (vm.srch.UserId == 0) {
          // 등록
          prms = userApi.doInsertDetail().post(vm.data).$promise;
        } else {*/
      // 수정
      vm.data.mapCode = 'PersonalInfo.UpdateDownloadSettingDetail';
      postApi.update(
        vm.data,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0].UserId !== null) {
              // KeyId 조회
              vm.srch.DownloadSettingId = data.body.docs[0].DownloadSettingId;

              //setArmyInfo(); // 소속데이터권한  저장

              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  if ($stateParams.UserId == 0) {
                    //$state.go("app.system.user-list");
                  } else {
                    /*$state.go("app.system.user-detail", {
                    UserId : vm.srch.UserId
                  });*/
                  }
                },
              });
              return;
            }
          }
          gAlert('', data.body.docs[0].errMessage);
        },
        function (error) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        }
      );
      //}
    }

    // 사용자 중복체크
    /*function chkDupLoginId() {                
        if (typeof(vm.data.LoginId) == "undefined" || vm.data.LoginId == "") {          
          gAlert('', '아이디를 입력해주세요');
          return false;
        }       
        
        var prms = null;                
                
        prms = userApi.doChkDupLoginId().post(vm.data).$promise;        
        prms.then(function(data) {
          //console.log(data);          
          if (data.header.status === CONSTANT.HttpStatus.OK) {            
            if (parseInt(data.body.docs[0].UsersDupCnt) == 0) {
              vm.data.isDupLoginId = "N";
              gAlert('', '등록이 가능한 아이디입니다.');
            }
            else {
              vm.data.isDupLoginId = "Y";
              gAlert('', '이미 등록된 아이디입니다.');
            }            
          
            return;
          }
          gAlert('', data.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        });
      }     
            
      // 사용자 중복체크 초기화
      function chkDupLoginIdClear() {
        vm.data.isDupLoginId = "Y";
      }

      // 소속데이터권한 목록      
      function getArmyInfoList() {
        var prms = userApi.doUserarmyinfoList().post(vm.srch).$promise;

        prms.then(function(data) {
          console.log("Userarmyinfo", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {           
            if (data.body.docs.length > 0) {
              $scope.ArmyInfoJSON = data.body.docs;
            } else {              
            }
            console.info("vm.lists -", vm.lists);
          } else {
            console.info("else ");
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }
      
      // 소속데이터권한 저장
      function setArmyInfo() {
        var prms = null;
        $scope.ArmyInfoJSON.forEach(function(data)
        {                 
          data.UserId = vm.srch.UserId;
          
          if (typeof(data.ArmyType) == "undefined" || data.ArmyType == "") return true;
          
          if (data.UserArmyInfoId == 0) {
            prms = userApi.doInsertUserarmyinfo().post(data).$promise;
          } else {
            prms = userApi.doUpdateUserarmyinfo().post(data).$promise;
          }       
                    
          prms.then(function(data) {                    
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              return true;
            }
            gAlert('', data.body.docs[0].errMessage);
            return false;
          }, function(error) {
            console.error('Error-setDataUserarmyinfo', status, data);
            gAlert('', data.body.docs[0].errMessage);
            return false;
          });
        });                                
      }    
      
      // 소속데이터권한 삭제
      function deleteArmyInfo(idx) {           
        var data = {
            UserArmyInfoId : idx,
        }
        
        var prms = userApi.doDeleteUserarmyinfo().post(data).$promise;

        prms.then(function(data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {            
            return;
          }
        },
        function(data) {
          console.error('fail', status, data);
          gAlert('', data.body.docs[0].errMessage);
        });
      }*/

    // 데이터 조회
    getData();
  },
]);

webapp.controller('PersonalInfoListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  '$translate',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  'gAlert',
  '$http',
  'StaticVariable',
  function PersonalInfoListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    $translate,
    CONSTANT,
    modalFactory,
    postApi,
    gAlert,
    $http,
    StaticVariable
  ) {
    var vm = this;
    /* var EXCEL_SQL = 'PersonalInfo.getExcelPersonalInfoList';
    var EXCEL_TITLE = '개인정보 다운로드 이력 목록'; */

    // 접근 권한 체크
    if (
      !isPageAccess(
        'personalInfo-list',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('personalInfo-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'personalInfo-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    /*$scope.showBtnAdd = false;*/

    // 함수 선언
    /*vm.getSelectListColumnList = getSelectListColumnList;
      vm.getIsShowColumn = getIsShowColumn;*/
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: vm.TenantId,
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
    };

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    /*if ($window.sessionStorage.getItem('user-list-ctrl') != null) {
        if ($rootScope.previousPage != null
            && ($rootScope.previousPage.indexOf('/app/system/user-edit') !== -1
                || $rootScope.previousPage.indexOf('/app/system/user-detail') !== -1
                || $rootScope.previousPage.indexOf('/app/system/user-list') !== -1)) {
          vm.srch = JSON.parse($window.sessionStorage.getItem('user-list-ctrl'));
          vm.currentPage = vm.srch.page;
        }
      }*/

    // 공통코드 정의
    /*vm.UserTypeList = {
	    CommonCodeId:'',
        ParentCommonCodeId:'',
        CodeType:'130',
        Code:'',
        CodeValue:'',
        TenantId:$window.sessionStorage['loginTenantId'],  
      }
      vm.UseYNList = {
	    CommonCodeId:'',
        ParentCommonCodeId:'',
        CodeType:'030',
        Code:'',
        CodeValue:'',
        TenantId:$window.sessionStorage['loginTenantId'],  
      }
      vm.ArmyTypeList = {
	    CommonCodeId:'',
        ParentCommonCodeId:'',
        CodeType:'1010',
        Code:'',
        CodeValue:'',
        TenantId:$window.sessionStorage['loginTenantId'],    
      }  

      vm.onSelectCallback = function(data) {           
        if (data.Code == null) data.Code = "";
            
        if (data.CodeType == '130') {
          vm.srch.UserType = data.Code;
        } else if (data.CodeType == '030') {              
          vm.srch.UseYN = data.Code;
        } else if (data.CodeType == '1010') {              
          vm.srch.ArmyType = data.Code;
        }
      }
      
      vm.PermStat1List = {};
      vm.PermStat2List = {};      
      
      vm.onArmyTypeListSelected = function(data) {
        console.log("onArmyTypeListSelected=", data);
        
        vm.PermStat1List.CodeType = '1140';
        vm.PermStat1List.ParentCommonCodeId = '';
        
        if (data == null) {
        	vm.srch.ArmyType = '';
          return;
        }
        
        vm.srch.ArmyType = data.Code;
        vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
        
        if (data.Code == null) data.Code = "";              
      }
      
      vm.onPermStat1ListSelected = function(data) {
        console.log("onPermStat1ListSelected=", data);
        
        vm.PermStat2List.CodeType = '';
        vm.PermStat2List.ParentCommonCodeId = '';
        
        if (data == null) {
        	vm.srch.PermStat1 = '';
          return;
        }
        
        vm.srch.PermStat1 = data.Code;
        vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
      }
      
      vm.onPermStat2ListSelected = function(data) {
        console.log("onPermStat2ListSelected=", data);
        
        if (data == null) {
        	vm.srch.PermStat2 = '';
          return;
        }
        
        vm.srch.PermStat2 = data.Code;
      }      
      */

    function getListCnt() {
      vm.srch.mapCode = 'PersonalInfo.getPersonalInfoListCnt';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("personalInfo", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      getListCnt();

      vm.srch.page = vm.currentPage;
      //console.log("vm.srch", vm.srch);
      //$window.sessionStorage.setItem("personalInfo-list-ctrl", angular.toJson(vm.srch));

      vm.srch.mapCode = 'PersonalInfo.getPersonalInfoList';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("personalInfo", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '개인정보 다운로드 이력';
      log.ScreenUrl = 'app/system/personal/personalInfo-list';

      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';
      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    /**
     * Excel 파일 다운로드
     * @param
     * @return
     */
    /*  function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', 'Menu.데이터가 없습니다.');
        return;
      }

      var a = document.createElement('a');
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      var excelHeader = [
        ['일자', 'DownloadDate'],
        ['시간', 'DownloadTime'],
        ['사용자명', 'UserNm'],
        ['아이디', 'LoginId'],
        ['접속IP', 'DownloadIP'],
        ['다운로드사유', 'DownloadReason'],
      ];

      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];
            var columnHeader = [];
            var columnData;

            angular.forEach(excelHeader, function (head) {
              columnHeader.push(head[0]);
            });
            obj.push(columnHeader);
            angular.forEach($scope.jsonToExport, function (data) {
              columnData = [];
              angular.forEach(excelHeader, function (head) {
                if (!isNullOrEmpty(data[head[1]])) {
                  columnData.push(data[head[1]]);
                } else {
                  columnData.push('');
                }
              });
              obj.push(columnData);
            });

            $scope.exportData = obj;

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        },
        function (error) {
          // 조회 중 오류 발생
          console.error('Error> getExcelFile()');
          console.table(error);
        }
      );
    } */

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number2';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '일시';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'DownloadDate';
      header.push(obj);

      // obj = {};
      // obj.title = '시간';
      // obj.format = strFormat;
      // obj.width = strWidth;
      // obj.field = 'DownloadTime';
      // header.push(obj);

      obj = {};
      obj.title = '사용자명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'UserNm';
      header.push(obj);

      obj = {};
      obj.title = '소속';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyNm';
      header.push(obj);

      obj = {};
      obj.title = '아이디';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'LoginId';
      header.push(obj);

      obj = {};
      obj.title = '접속IP';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'DownloadIP';
      header.push(obj);

      obj = {};
      obj.title = '다운로드 메뉴';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'DownloadMenu';
      header.push(obj);

      obj = {};
      obj.title = '다운로드 사유';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'DownloadReason';
      header.push(obj);

      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '개인정보 다운로드 이력 목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        //url: 'etcExcel/downloadhistory/action.json',
        url: StaticVariable.getUrl(
          '/excel/PersonalInfo.getExcelPersonalInfoList/action.json?userkey=' +
            $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /*getSelectListColumnList();*/
    // 데이터 조회
    getList();
  },
]);

webapp.controller('PersonalSmsListCtrl', [
  '$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  '$translate',
  'GLOBAL_CONSTANT',
  'modalFactory',
  'postApi',
  '$http',
  'StaticVariable',
  function PersonalSmsListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    $translate,
    CONSTANT,
    modalFactory,
    postApi,
    $http,
    StaticVariable
  ) {
    var vm = this;
    /* var EXCEL_SQL = 'PersonalInfo.getgetPersonalSmsList';
    var EXCEL_TITLE = '로그인 SMS 인증번호 발송현황 목록'; */

    // 접근 권한 체크
    if (
      !isPageAccess(
        'personalInfo-list',
        $window.sessionStorage['loginUserType']
      )
    )
      $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('personalInfo-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'personalInfo-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    // 버튼 권한 체크
    $scope.showBtnExcel = true;
    /*$scope.showBtnAdd = false;*/

    // 함수 선언
    /*vm.getSelectListColumnList = getSelectListColumnList;
      vm.getIsShowColumn = getIsShowColumn;*/
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getExcel = getExcel;
    vm.getExcelDownloadCheckYn = getExcelDownloadCheckYn;

    // 검색 조건
    vm.srch = {
      TenantId: vm.TenantId,
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
    };

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    function getListCnt() {
      vm.srch.mapCode = 'PersonalInfo.getPersonalSmsListCnt';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("personalInfo", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      getListCnt();

      vm.srch.page = vm.currentPage;

      vm.srch.mapCode = 'PersonalInfo.getPersonalSmsList';

      postApi.select(
        vm.srch,
        function (data) {
          //console.log("personalSms", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setDownloadHistory(DownloadReason) {
      var log = {};

      log.DownloadIP = $window.sessionStorage['loginIP'];
      log.DownloadReason = DownloadReason;
      log.ScreenNm = '로그인 SMS 인증번호 발송현황';
      log.ScreenUrl = 'app/system/personal/personalSms-list';
      log.mapCode = 'PersonalInfo.insertDownloadHistoryDetail';

      postApi.insert(log, function (data) {
        //console.log(data);

        if (data.header.status === CONSTANT.HttpStatus.OK) {
          if (data.body.docCnt > 0) {
            getExcel();
          }
        }
      });
    }

    // 모달팝업 호출 (다운로드사유)
    function showModalDownloadReason() {
      var ctrl = 'DownloadReasonModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open(
        'modal',
        'app/modal/DownloadReason-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          setDownloadHistory(okData);
        },
        function (cancelData) {}
      );
    }

    // 엑셀 다운로드 체크여부 조회
    function getExcelDownloadCheckYn() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      vm.srch.mapCode = 'PersonalInfo.getDownloadCheckYn';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log("DownloadCheckYn", data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.DownloadCheckYn = data.body.docs;
              if (vm.DownloadCheckYn == 'Y') {
                showModalDownloadReason();
              } else {
                setDownloadHistory('');
              }
            } else {
              console.info('else ');
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getDownloadCheckYn', status, data);
        }
      );
    }

    /**
     * Excel 파일 다운로드
     * @param
     * @return
     */
    /* function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', 'Menu.데이터가 없습니다.');
        return;
      }

      var a = document.createElement('a');
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      var excelHeader = [
        ['일자', 'SecondDate'],
        ['시간', 'SecondTime'],
        ['사용자명', 'UserNm'],
        ['아이디', 'LoginId'],
        ['접속IP', 'SecondIP'],
        ['인증번호', 'SecondNumber'],
      ];

      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];
            var columnHeader = [];
            var columnData;

            angular.forEach(excelHeader, function (head) {
              columnHeader.push(head[0]);
            });
            obj.push(columnHeader);
            angular.forEach($scope.jsonToExport, function (data) {
              columnData = [];
              angular.forEach(excelHeader, function (head) {
                if (!isNullOrEmpty(data[head[1]])) {
                  columnData.push(data[head[1]]);
                } else {
                  columnData.push('');
                }
              });
              obj.push(columnData);
            });

            $scope.exportData = obj;

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        },
        function (error) {
          // 조회 중 오류 발생
          console.error('Error> getExcelFile()');
          console.table(error);
        }
      );
    } */

    // 엑셀 다운로드
    function getExcel() {
      if (vm.lists.length == undefined) {
        gAlert('', '조회 후 엑셀을 다운로드 하십시오.');
        return;
      }

      if (vm.lists.length == 0) {
        gAlert('', '데이터가 없습니다.');
        return;
      }

      var header = [];
      var a = document.createElement('a');
      document.body.appendChild(a);
      var strFormat = 'string';
      var strWidth = '20';
      var numFormat = 'number';
      var numWidth = '20';

      //헤더 설정..공통사용 불가
      var obj = {};
      obj.title = '일자';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'SecondDate';
      header.push(obj);

      obj = {};
      obj.title = '시간';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'SecondTime';
      header.push(obj);

      obj = {};
      obj.title = '사용자명';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'UserNm';
      header.push(obj);

      obj = {};
      obj.title = '소속';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'CompanyNm';
      header.push(obj);

      obj = {};
      obj.title = '아이디';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'LoginId';
      header.push(obj);

      obj = {};
      obj.title = '접속IP';
      obj.format = strFormat;
      obj.width = strWidth;
      obj.field = 'SecondIP';
      header.push(obj);

      obj = {};
      obj.title = '인증번호';
      obj.format = numFormat;
      obj.width = strWidth;
      obj.field = 'SecondNumber';
      header.push(obj);

      // 헤더설정 End

      vm.srch.header = header;
      vm.srch.downFileName = '로그인 SMS 인증번호 발송현황 목록';
      vm.srch.userkey = $rootScope.gVariable.userKey;

      $http({
        //url: 'etcExcel/smsList/action.json',
        url: StaticVariable.getUrl(
          '/excel/PersonalInfo.getgetPersonalSmsList/action.json?userkey=' +
            $rootScope.gVariable.userKey
        ),
        method: 'POST',
        data: vm.srch, //this is your json data string
        headers: {
          'Content-type': 'application/json;charset=utf-8;',
        },
        responseType: 'arraybuffer',
      })
        .success(function (data, status, headers, config) {
          var fileName = vm.srch.downFileName;
          var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
          });
          if (window.navigator && window.navigator.msSaveBlob) {
            fileName = fileName + '.xlsx';
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = fileName;
            a.click();
          }
        })
        .error(function (data, status, headers, config) {
          //download failed
        });
    }

    /*getSelectListColumnList();*/
    // 데이터 조회
    getList();
  },
]);

webapp.controller('VisitLogListCtrl', [
  '$window',
  '$scope',
  '$rootScope',
  'gAlert',
  'gConfirm',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'postApi',
  function VisitLogListCtrl($window, $scope, $rootScope, gAlert, gConfirm, $state, $stateParams, CONSTANT, postApi) {
    if (!isPageAccess('visitLog-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('visitLog-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'visitLog-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    var vm = this;
    vm.getList = getList;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.listSize = CONSTANT.PAGINATION.LISTSIZE;

    
    var date = new Date();
    var year = date.getFullYear();
    var month = new String(date.getMonth() + 1);
    var day = new String(date.getDate());
    if (month.length == 1) month = '0' + month;
    if (day.length == 1) day = '0' + day;
    $scope.dtStartSecondDate = setNewDate(year + '-' + month + '-' + '01');
    $scope.dtEndSecondDate = setNewDate(year + '-' + month + '-' + day);

    if (!$stateParams.srch) {
      vm.srch = {
        StartRegDate: year + '-' + month + '-' + '01',
        EndRegDate: year + '-' + month + '-' + day,
        type: 'D',
        notWeekend: false,
        mapCode: 'VisitCountLog.getVisitCountList',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    function init(){
      getList();
    }

    function getList() {
      vm.lists = [];
      var srch = angular.copy(vm.srch);
      srch.fromDate = srch.StartRegDate.replaceAll('-','');
      srch.toDate = srch.EndRegDate.replaceAll('-','');
      postApi.select(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = data.body.docs;
            switch (srch.type) {
              case 'D':
                angular.forEach(vm.lists, function(item) {
                  item.date = item.date.substring(0,4) + '-' + item.date.substring(4,6) + '-' + item.date.substring(6,8);
                });
                break;
              case 'M':
                angular.forEach(vm.lists, function(item) {
                  item.date = item.date.substring(0,4) + '-' + item.date.substring(4,6);
                });
                break;
              default:
                break;
            }
          } else {
            vm.lists = [];
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getList()');
        }
      );
    }

    init();
  },
]);

webapp.controller('VisitMenuListCtrl', [
  '$window',
  '$scope',
  '$rootScope',
  'gAlert',
  'gConfirm',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'postApi',
  function VisitMenuListCtrl($window, $scope, $rootScope, gAlert, gConfirm, $state, $stateParams, CONSTANT, postApi) {
    if (!isPageAccess('visitMenu-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('visitMenu-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'visitMenu-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    var vm = this;
    vm.getList = getList;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.listSize = CONSTANT.PAGINATION.LISTSIZE;

    
    var date = new Date();
    var year = date.getFullYear();
    var month = new String(date.getMonth() + 1);
    var day = new String(date.getDate());
    if (month.length == 1) month = '0' + month;
    if (day.length == 1) day = '0' + day;
    $scope.dtStartSecondDate = setNewDate(year + '-' + month + '-' + '01');
    $scope.dtEndSecondDate = setNewDate(year + '-' + month + '-' + day);

    if (!$stateParams.srch) {
      vm.srch = {
        StartRegDate: year + '-' + month + '-' + '01',
        EndRegDate: year + '-' + month + '-' + day,
        mapCode: 'VisitCountLog.getVisitMenuList',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    function init(){
      getList();
    }

    function getList() {
      var menuList = [];
      vm.lists = [];
      
      Object.keys(CONSTANT.MENU).forEach(function(item) {
        var group = CONSTANT.MENU[item];
        var code1 = group.CODE1;
        var name1 = group.NAME;

        Object.keys(group).forEach(function(subItem) {
          if(subItem != 'CODE1' && subItem != 'NAME') {
            var sub = group[subItem];
            if(!isNullOrEmpty(sub.NAME) && !isNullOrEmpty(sub.CODE2)) {
              menuList.push({
                code1: code1,
                name1: name1,
                code2: sub.CODE2,
                name2: sub.NAME,
                cnt: 0,
              });
            } else {
              Object.keys(sub).forEach(function(subItem2) {
                var sub2 = sub[subItem2];
                if(!isNullOrEmpty(sub2.NAME) && !isNullOrEmpty(sub2.CODE2)) {
                  menuList.push({
                    code1: code1,
                    name1: name1,
                    code2: sub2.CODE2,
                    name2: sub2.NAME,
                    cnt: 0,
                  });
                }
              });
            }
          }
        });
      });
      // console.log(menuList);

      angular.forEach(menuList, function(menu) {
        var hasCode1 = false;
        for(var i=0; i<vm.lists.length; i++) {
          if(vm.lists[i][0].code1 == menu.code1) {
            hasCode1 = true;
            var hasCode2 = false;
            for(var j=0; j<vm.lists[i].length; j++) {
              if(vm.lists[i][j].code2 == menu.code2) {
                hasCode2 = true;
                break;
              }
            }
            if(!hasCode2) vm.lists[i].push(menu);
            break;
          }
        }
        if(!hasCode1) vm.lists.push([menu]);
      });
      var srch = angular.copy(vm.srch);
      srch.fromDate = srch.StartRegDate.replaceAll('-','');
      srch.toDate = srch.EndRegDate.replaceAll('-','');
      postApi.select(
        srch,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            angular.forEach(data.body.docs, function(item) {
              var isCalc = false;
              for(var i=0; i<vm.lists.length; i++) {
                for(var j=0; j<vm.lists[i].length; j++) {
                  if(vm.lists[i][j].code1 == item.MENU_GROUP_SN
                  && vm.lists[i][j].code2 == item.MENU_SN
                  ) {
                    vm.lists[i][j].cnt += item.CNT
                    isCalc = true;
                    break;
                  }
                }
                if(isCalc) break;
              }
            });
          } else {
            vm.lists = [];
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error > AccountLockListCtrl > getList()');
        }
      );
    }

    init();
  },
]);

(function () {
  "use strict";
  webapp.controller('SysRegisteredPostDetailCtrl', 
    ['$scope','$stateParams', 'autoPage', '$rootScope',
    function SysRegisteredPostDetailCtrl($scope, $stateParams, ap, $rootScope) {
      var vm = this;
      var ap = new ap();
      
      vm.keyId = $stateParams.keyId;
      $rootScope.gVariable.listKeyId = vm.keyId;
      
      // TYPE DATA
      var ctrlData = SysRegisteredPostDetailCtrlData(vm);
      var mapCode = ctrlData.get("mapCode");
      var form = ctrlData.get("form");
      var pageUrl = ctrlData.get("pageUrl");
     
      var pageData = { 
        vm : vm, 
        stateParams : $stateParams, 
        scope : $scope,
        pageType : "VIEW",
        keyTableNm : "registeredpost",
        keyColumnNm : "KeyId",
        PageUrl : pageUrl,
        rootScope : $rootScope
      };

      vm.detail = {};
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작
     

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // Fn Callback 시작

      function getInitDataExt(){
        vm.titleNm = "문의관리 상세";
        ap.setForms(form.SECTION1);
        ap.setForms(form.SECTION2);
        var p = {};
        p.RegisteredId = vm.keyId;
        p.mapCode = mapCode.Detail;
        ap.select(p, function(result){
          result[0].RegDate =  moment(ap.datePicker().moment(result[0].RegDate)).format('YYYY-MM-DD');
          vm.detail = result[0];
        });
      }

      function setComment() {
        var data = angular.copy(vm.detail);
        data.mapCode = mapCode.setComment;
        ap.commit(data, function(){})
      }

      // Fn Callback 종료
      /******************************************************************************** */
      
      /******************************************************************************** */
      // 함수 정의 시작
      vm.getInitDataExt = getInitDataExt;

      // 커멘트 저장
      vm.setComment = setComment;
     
      // 함수 정의 종료
      /******************************************************************************** */
      ap.setData(pageData);
      ap.initView();

    }]);
})();


/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysRegisteredPostDetailCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      mapCode : {
        category : "CommonCode.getCommonCodeValue",
        Detail : "Registeredpost.getRegisteredpostDetail",
        setComment : "Registeredpost.updateRegisteredpost",
      },
      pageUrl : {
        LIST_PAGE_URL : {
          url : 'app.system.registered-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.registered-list.detail',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            KeyId : ''
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.registered-detail',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            KeyId : ''
          }
       },
      },
      // 폼에 대한 정보를 정의
      form : {

        SECTION1 : {
          target : "#section1",
          bindKey : viewTx.vc + '.detail',
          layout : mElemTx.layout.inline,
          resetForm :true,
          field : [
            {   
              label : "신청아이디",
              type : mElemTx.text,
              col : 3,
              key : "KeyId",
              disabled : true
            },
            {   
              label : "등록일",
              type : mElemTx.text,
              col : 3,
              key : "RegDate",
              disabled : true,
              inputType : mElemTx.inputType.date,
            },
            {   
              label : "신청자",
              type : mElemTx.text,
              col : 3,
              key : "RegName",
              disabled : true
            },
            {   
              label : "회사",
              type : mElemTx.text,
              col : 3,
              key : "Company",
              disabled : true
            },
            {   
              label : "연락처",
              type : mElemTx.text,
              col : 3,
              key : "Mobile",
              disabled : true
            },
            {   
              label : "이메일",
              type : mElemTx.text,
              col : 3,
              key : "Email",
              disabled : true
            },
            {   
              label : "제목",
              type : mElemTx.text,
              col : 1,
              key : "Title",
              disabled : true
            },            
            {   
              label : "문의내용",
              type : mElemTx.textarea,
              col : 1,
              row : 5,
              key : "Content",
              disabled : true
            },
          ]
        },

        SECTION2 : {
          target : "#section2",
          bindKey : viewTx.vc + '.detail',
          layout : mElemTx.layout.inline,
          resetForm :true,
          field : [
            {   
              label : "메모내용",
              type : mElemTx.textarea,
              col : 1,
              row : 5,
              key : "Comment",
            },
          ]
        },

      }, // End Form
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  webapp.controller('SysRegisteredPostListCtrl', 
    ['$scope','$stateParams', 'autoPage', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi', '$state',
    function SysRegisteredPostListCtrl($scope, $stateParams, ap, fileUploadService, StaticVariable, $rootScope, postApi, $state) {

      var vm = this;          // View Model
      vm.pageType = $stateParams.type;
      vm.keyId = $stateParams.keyId;
      
      var ctrlData = SysRegisteredPostListCtrlData(vm);
      var apiOption = ctrlData.get('apiOption');
      var pageUrl = ctrlData.get('pageUrl');
      var form = ctrlData.get('form');
      var mapCode = ctrlData.get('mapCode');

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        headerTitle : vm.headerTitle,
        pageType : "LIST",
        listStack : true,
        listParam : {
          TcId : vm.keyId,
          GroupClassYN : 'N'
        },
        keyTableNm : "registeredpost",
        keyColumnNm : "RegisteredId",
        //enableListCheck : true,
        MapperId : apiOption,
        PageUrl : pageUrl,
        rootScope : $rootScope
      };

      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      function getInitDataExt() {
        vm.headerTitle = "문의관리";
        var p = {mapCode: mapCode.category, ParentCommonCodeId: '3EKCKBTXD6'};
        ap.select(p, function(result){
          vm.orderState = result;
        });

        ap.setForms(form.SEARCH);
        ap.setSrchDateForm();
        

      };

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // 함수 정의 시작

      // function goEdit(p){
      //   var srch = $stateParams.srch; // 검색 옵션
      //   //D.vm.KeyId = p.KeyId;

      //     var url = "", param = {};
      //     if (vm.layout == 'N') {
      //       // 등록/수정 화면 이동
      //       url = pageData.PageUrl.EDIT_PAGE_URL.url; 
      //       if(url == undefined) {
      //         url = pageData.PageUrl.EDIT_PAGE_URL;
      //         param = {};
      //       } else {
      //         param = pageData.PageUrl.EDIT_PAGE_URL.param;
      //       }
      //     } else {
      //       url = pageData.PageUrl.LIST_EDIT_PAGE_URL.url;
      //       if(url == undefined) {
      //         url = pageData.PageUrl.LIST_EDIT_PAGE_URL;
      //         param = {};
      //       } else {
      //         param = pageData.PageUrl.LIST_EDIT_PAGE_URL.param;
      //       }
      //     }
          
      //     if(param == undefined) param = {};
      //     if(srch != undefined) param.srch = srch
      //     else param.srch = "";
      //     if(!isNullOrEmpty(p.KeyId)) {
      //       param.KeyId = p.KeyId;
      //       param.keyId = p.KeyId;
      //     } else {
      //       param.KeyId = p.keyId;
      //       param.keyId = p.keyId;
      //     }
      //     param.viewType = vm.viewType;
      //     param = JSON.stringify(param);              
      //     $state.go(url, JSON.parse(param) , {reload: url});
       
      // }
      /** @description AP init Callback**/
      vm.getInitDataExt = getInitDataExt;

      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new ap();
      ap.setData(pageData);
      ap.initView();
      // autoPage 종료
    }]);

})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysRegisteredPostListCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      apiOption : {
        init : {
          LIST_CNT_SQL : 'Registeredpost.getRegisteredpostListCnt', // 목록 건수 조회 SQL
          LIST_SQL : 'Registeredpost.getRegisteredpostList',    // 목록 조회 SQL
        },
        del : {

        },
      },
      mapCode : {
         category : "CommonCode.getCommonCodeValue",
      },
      pageUrl : {
        LIST_PAGE_URL : {
          url : 'app.system.registered-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.registered-list.detail',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            KeyId : ''
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.registered-detail',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            KeyId : ''
          }
       },
      },
      form : {
        SEARCH : {
          target : "#searchWrap",
          bindKey : viewTx.vc + '.srch',
          layout : mElemTx.layout.inner,
          resetForm :true,
          field : [
            {   
              label : "신청자",
              type : mElemTx.text,
              col : 1,
              key : "RegName",
            },
            {   
              label : ["등록시작일","등록종료일"],
              key : ["regDate_Str", "regDate_End"],   
              type : mElemTx.dateTime, 
              col : 1,
            },
            {   
              label : "회사",
              type : mElemTx.text,
              col : 1,
              key : "Company",
            },
            {   
              label : "연락처",
              type : mElemTx.text,
              col : 1,
              key : "Mobile",
            },
            {   
              label : "이메일",
              type : mElemTx.text,
              col : 1,
              key : "Email",
            },
          ]
        },
      }
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  webapp.controller('RentalCarListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
      function RentalCarListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

        var vm = this;  // View Model
        vm.headerTitle = "영업차량관리 목록";
        vm.showDetailSearch = false;

        // 담당지역본부
        postApi.select({ mapCode: 'AutoComplete.getRegionCodeList'}, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeRegionCodeList = result.body.docs;
          }
        });

        // 사용여부
        postApi.select({ mapCode: 'CommonCode.getCommonCodeList', CodeType: 'USEYN' }, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeUseYNList = result.body.docs;
          }
        });

        // 회의뷰 조회 팝업창
        vm.rentalCarModal = function (keyId) {
          var ctrl = 'RentalCarModalCtrl as vc';
          var paramData = { KeyId: keyId };

          var modalInstance = modalFactory.open('md', 'app/system/rental-car/rental-car-modal.html', ctrl, paramData);
          modalInstance.result.then(function () {
            av.search();
          }, function () {
            av.search();
          });
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_RENTALCAR",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "RentalCar.getRentalCarListCnt", param: null },
            initSelect: { mapCode: "RentalCar.getRentalCarList", param: null },
          },

          addSrchStack: false,

          // List
          listCheckboxEnable: true,

          src: {
            detail: "",
            splitDetail: ""
          },

          customCodes: {
            UseDeptId: "codeRegionCodeList"
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent
        };


        //#region 목록 삭제
        function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'RentalCar.deleteRentalCar', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelList()");
              // console.table(error);
            });
          }, function () {

          });
        }
        //#endregion 목록 삭제


        function clickevent(clickData) {
          vm.rentalCarModal(clickData.KeyId);
        }

        function onReadyAutoView() {

        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.clickevent = clickevent;
        vm.setDelList = setDelList;

        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function () {
  "use strict";
  webapp.controller('RentalCarModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
      function RentalCarModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {

        var vm = this;
        vm.mdata = mdata;

        // 담당지역본부
        postApi.select({ mapCode: 'AutoComplete.getRegionCodeList'}, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeRegionCodeList = result.body.docs;
          }
        });

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "TB_RENTALCAR",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {
            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "RentalCar.getRentalCarDetail", param: { KeyId: mdata.KeyId }},

            // vieType is edit
            insert: "RentalCar.insertRentalCar",
            update: "RentalCar.updateRentalCar"
          },

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
          },

          // MataColum 외 추가 적으로 넣어야할 폼
          addForm: {
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            UseDeptId: "codeRegionCodeList"
          },

          // 필수 항목 컬럼 
          required: ["CarNumber", "CarType", "UseDept", "UseYN"],
        };

        function ok() {
          $uibModalInstance.close();
        }

        function cancel() {
          $uibModalInstance.dismiss();
        }

        // 저장 버튼 클릭 시
        function setData() {
          if (getIsValidData()) {
            postApi.select({ mapCode: 'RentalCar.getRentalCarDupYN', KeyId: vm.data.KeyId, CarNumber: vm.data.CarNumber }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs[0].RentalCarDupYN == 'Y') {
                  av.alert("- 등록된 차량번호가 있습니다.");
                } else {
                  av.confirm("Menu.SAVECONFIRM2", function () {
                    av.commit(function (result) {
                      av.alert('Menu.SAVED', function () {
                        vm.cancel();
                      });
                    });
                  });
                }
              } else {
                av.alert("차량번호확인에 실패하였습니다.(관리자문의)");
              }
            });
          }
        }

        function getIsValidData() {
          var bRtn = true;
          var errMsg = '';

          if (isNullOrEmpty(vm.data.CarNumber)) {
            errMsg = errMsg + '- 차량번호를 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.CarType)) {
            errMsg = errMsg + '- 차종을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.UseDept)) {
            errMsg = errMsg + '- 담당지역본부를 선택하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.UseYN)) {
            errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            bRtn = false;
          }
          return bRtn;
        }

        function onReadyAutoView() {

        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.getIsValidData = getIsValidData;
        vm.setData = setData;
        vm.ok = ok;
        vm.cancel = cancel;

        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

webapp.service('RoleAPISrv', ['$resource', 'StaticVariable',
  function RoleAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCount: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleListCnt/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Role.updateRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Role.insertRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Role.deleteRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $stateParams - state Parameter object
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 회원사관리
   */
  webapp.controller('RoleListCtrl', 
    ['$rootScope', '$scope', '$stateParams', '$translate', 'autoPage', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$window',
    function RoleListCtrl($rootScope, $scope, $stateParams, $translate, autoPage, autoView, postApi, CONSTANT, $window) {

      var vm = this;

      var MAPPER_DETAIL = "Role.getRoleCodeList";

      vm.isSys = false;
      vm.isTenantAdmin = false;
      vm.isBranchAdmin = false;
      vm.isTenantBranch = true;

      vm.codeRecommendList = [];
      vm.cpData = {}

      if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
      if($window.sessionStorage['loginTenantAdminYn'] == "Y") vm.isTenantAdmin = true;
      if($window.sessionStorage['loginBranchAdminYn'] == "Y") vm.isBranchAdmin = true;
      
      if($window.sessionStorage['loginBranchId'] != $window.sessionStorage['srchBranchId'])
        vm.isTenantBranch = false;

      
      vm.currentType = "";

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,

        viewType : mViewType.Edit,
        tableNm : "role",
        keyIdNm : "RoleId",
        alias : "vc",
        dataModelNm : "data",

        apis : {
          // columnMap은 불러오되 업종선택을 변경하였을시에 데이터를 불러오기 위해 빈값으로 데이터 호출
          initSelect : { mapCode : MAPPER_DETAIL, param : null }  
          //, insert : "ScCustomer.insertScitemtype" 트리에서 작업을 함으로 필요하지 않음
          , update : "Role.updateRoleDetail"
        },

        callback : {
          BranchMngYn : "setChangeManage",
          BranchAdminYN : "setChangeManage",
        },

        ngIf : {
          BranchMngYn : "vc.isSys || (vc.isTenantAdmin && vc.isTenantBranch)"
        },

        addRow : []
      };

      vm.rootTitle = "역할등록";

      vm.sbCtrl = null;

      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      vm.getInitDataExt = function() { };

      /**
       * 1Depth 정보 저장
       **/
      vm.setRootData = function() {
        
        vm.rootData.mapCode = 'ScItemType.updateScitemtype';
        ap.commit(vm.rootData, function(result){
          var data = { KeyId : result.body.docs[0].KeyId, name :  result.body.docs[0].GroupNm}
          vm.sbCtrl.uptAtName(data);
        });
      }

      /**
       * 해당 디렉티브가 완료되었을 시 호출되는 함수
       * html 페이지에서 initCallback으로 지정할 수 있다.
      */
      vm.succSortable = function(ctrl) {
        vm.sbCtrl = ctrl;
        
        ctrl.setRootTitle(vm.rootTitle);
        vm.getSortableList();

        //* ITEM이 추가되었을시 호출되는 함수
        ctrl.addItem = function(data, callback) {

          data.mapCode = "Role.insertRoleDetail";
          data.Depth = data.CodeLevel;
          data.RoleNm = data.ItemNm
          data.ParentId = data.ParentCommonCodeId;

          if(!vm.isSys && !vm.isTenantAdmin) {
            data.BranchCode = vm.BranchCode;
          }
          
          ap.commit(data, function(result){
            callback(result);
            //ap.alert('Menu.SAVED');
          });
        };

        ctrl.setChangedSort = function(data, callback) {

          // var param = {};
          // param.mapCode = 'organizationMng.updateChagneSort';
          // param.list = data;
          // postApi.update(param, function() {
          //   $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //   callback();
          // })
        };

        ctrl.setDetailView = function(data, callback) {

          vm.data =  data;

          vm.cpData = angular.copy(data)

          // 역할별 권한 리스트 호출

          var param = {};
          param.mapCode = 'Rolescreen.getRolescreenList';
          param.role = data.RoleId;
          // 내용
          postApi.select(param, function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              vm.lists = [];
              angular.forEach(result.body.docs, function(item) {
                if(item.PageUrl.indexOf("app.systenant") != -1) {
                  if(vm.isTenantBranch && (vm.isSys || vm.isTenantAdmin)) {
                    vm.lists.push(item)
                  }
                } else {
                  vm.lists.push(item)
                }
              });
            } else {
              av.alert(result.body.docs[0].errMessage);
            }
          }, function(error) {
            console.log("error");
            // console.error('Error-getList', error);
            vm.dataloader = false;
          });

        }
         
        ctrl.setDeleteItem = function(data, callback) {
          var param = data;
          param.mapCode = "Role.deleteRoleDetail";
          postApi.update(param, function(result) {    
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              vm.getSortableList(function(){
                $rootScope.$broadcast('broadcastSetChangeMenuList', {});
                $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              });              
            }
          });
        };
      }

      //* 데이터를 바인드하기 위함
      vm.getSortableList = function(callback) {
        
        ap.getData({mapCode : MAPPER_DETAIL}, function(result){
          var docs = result.body.docs;
        
          angular.forEach(docs, function(item,idx){
            item.Depth = 1;
          })
          
          vm.sbCtrl.drawList(docs)
          if(callback != undefined) callback(docs);
        });
      };

      function setChangeManage(key, val) {
        if(key == "BranchMngYn") {
          if(val == "Y") {
            av.confirm("기능을 활성화시 모든 지점을 제어할 수 있습니다. 적용하시겠습니까?", 
            function(){
              vm.data.BranchAdminYN = "N";
            },function(){
              vm.data.BranchMngYn = "N";
            })
          }

          vm.setChangeRoleList();
        } else if(key == "BranchAdminYN") {
          if(val == "Y") {
            vm.data.BranchMngYn = "N";
          }
          vm.setChangeRoleList();
        }
      }

      function setChangeRoleList() {

      }

      function getInitDataExt() {

      }

      function onReadyAutoView() {
        vm.data = {};
      }

      function setData() {
        av.commit(function(result){
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
        })
      }

      function setList() {
        vm.dataloader = true;
        var param = {}
        param.upList = vm.lists;
        param.mapCode = 'Rolescreen.updateRolescreen';
        // 내용
        postApi.update(param, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            $rootScope.showSimpleToast($translate.instant(result.body.docs[0].errMessage));
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }

      function checkBtn(BtnYN) {
        angular.forEach(vm.lists, function(item) {
          item[BtnYN] = vm.checkAllBtn[BtnYN];
        });
      }

      /** @description autoView init Callback**/
      vm.getInitDataExt = getInitDataExt;
      vm.onReadyAutoView = onReadyAutoView;

      vm.setData = setData;
      vm.setList = setList;
      vm.setChangeRoleList = setChangeRoleList;

      vm.checkBtn = checkBtn;

      vm.setChangeManage = setChangeManage;
      
      
      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new autoPage();
      ap.setData(pageData);
      ap.init();

      var av = new autoView();
      av.init(pageData);

    }]);
})();


webapp.service('RolescreenAPISrv', ['$resource', 'StaticVariable',
  function RolescreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateList: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.updateRolescreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/insertRolescreen.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.deleteRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - RolescreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('RolescreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          // console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          // console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            // console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : vm.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null) {
              vm.data = data.responseVO.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {
        vm.srch.tableNm = 'Companys';

        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.log("error");
          // console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Tenant";
        vm.data.TableId = vm.data.TenantId;

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.TenantId = data.responseVO.body.docs[0].TenantId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.TenantId === "0") {
                    $state.go("app.system.rolescreen-list");
                  } else {
                    vm.data.TenantId = data.responseVO.body.docs[0].TenantId !== null ? data.responseVO.body.docs[0].TenantId : "0";
                    vm.srch.TenantId = vm.data.TenantId;
                    getFileList();
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var prms = api.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.rolescreen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} api - RolescreenApiSrv Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('RolescreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.CompanyTypeData = {
        CodeType : '130',
        TenantId : vm.TenantId,
        Value : ''
      }

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          // console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : $stateParams.TenantId,
        tableNm : 'Tenant',
        IdName : 'TenantId',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantId == '0' ? '' : $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt !== 0 && data.responseVO.body.docs[0].TenantId !== null) {
              vm.data = data.responseVO.body.docs[0];

              // 첨부파일 목록 조회
              getFileList();

              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {
        vm.srch.tableNm = 'Tenant';

        if (vm.srch.TenantId === null || vm.srch.TenantId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.log("error");
          // console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.TableId = vm.data.TenantId;
        vm.data.tableNm = 'Tenant';
        vm.data.IdName = 'TenantId';

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert시 TableId 만 넘어옴
              // KeyId 조회
              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  vm.data.TenantId = data.responseVO.body.docs[0].TenantId != null ? data.responseVO.body.docs[0].TenantId : data.responseVO.body.docs[0].TableId;
                  $state.go("app.system.rolescreen-detail", {
                    TenantId : vm.data.TenantId
                  });
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  RolescreenAPISrv Module
 */
webapp.controller('RolescreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi','gAlert','LoginAPISrv','Auth',
  function RolescreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, loginApi, Auth) {
    // View Model
    var vm = this;

    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 검색 조건
    if ($stateParams.srch == '' || $stateParams.srch == undefined) {
      vm.srch = {
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        mobile : 'N'
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'rolescrean';
      vm.currentPage = vm.srch.page;
    }

    if ($stateParams.mobile) {
      vm.srch.mobile = $stateParams.mobile;
    }

    vm.data = {
      ActionId: vm.srch.ActionId,
    };

    vm.checkAllBtn = {ViewYN:'N', Btn01YN:'N', Btn02YN:'N', Btn03YN:'N', Btn04YN:'N', Btn05YN:'N', Btn06YN:'N'};

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      vm.srch.ScreenNm = '';
      vm.srch.PageUrl = '';
      vm.srch.role = '';
      getList();
      getRoleList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     */
    function getList() {
      vm.srch.page = vm.currentPage;

      getListCnt();

      var data = vm.srch;
      data.mapCode = 'Rolescreen.getRolescreenList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.lists = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
        fnCloseLayer();
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Rolescreen.getRolescreenCount';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0];
          }
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getRoleList() {
      var data = vm.srch;
      data.mapCode = 'Role.getRoleList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.roleList = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function saveList() {
      vm.dataloader = true;
      vm.data.upList = vm.lists;
      vm.data.mapCode = 'Rolescreen.updateRolescreen';
      // 내용
      postApi.update(vm.data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn: '확인',
            fn: function () {
              $state.go("app.system.rolescreen-list");
            }
          });
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function checkBtn(BtnYN) {
      angular.forEach(vm.lists, function(item) {
        item[BtnYN] = vm.checkAllBtn[BtnYN];
      });
    }

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post().$promise;

      prms.then(function (json) {
        if (json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {

          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
        }
      }, function (error) {
        console.table(error);
      });
    }

    /**
      * 데이터 조회
      * @param
      * @return
    */
    function getSearch() {
      vm.srch.mobile = null;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {mobile:$stateParams.mobile, srch:srch}, {reload:$state.current.name});
    }

    function resetSearch() {
      $state.go('app.system.rolescreen-list', {
        srch : ''
      }, {reload: 'app.system.rolescreen-list'});
    }

    // 함수 선언
    vm.getList = getList;
    vm.getRoleList = getRoleList;
    vm.saveList = saveList;
    vm.checkBtn = checkBtn;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;

    // 데이터 조회
    getList();
    getRoleList();
  }, ]);


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.sms:sms-auto-edit
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SmsAutoEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SmsAutoEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SmsSituationAuto.insertSmsSituationAuto';     // 등록 SQL
      var UPDATE_SQL = "SmsSituationAuto.updateSmsSituationAuto";   // 인증 승인
      var VIEW_SQL = 'SmsSituationAuto.getSmsSituationAutoDetail'; // 조회 SQL
      var DEL_SQL = 'SmsSituationAuto.deleteSmsSituationAuto';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-auto-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.sms-auto-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.sms-auto-edit';           // 수정 화면

      var KEY_TABLE_NM = 'campaign.smssituationauto'; // 작업 테이블명


      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.layout = $state.current.name.indexOf('sms-auto-list') == -1 ? 'N' : $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        CmpgnChannel : 'SMS', //SMS : 90byte, LMS : 2000byte
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (!isNullOrEmpty(vm.srch.keyId)) {
              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                vm.data = result.body.docs[0];
                vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
                vm.data.theTime = new Date(1970, 1, 1, vm.data.SendHour, vm.data.SendMinute, 0);
              } else {
                vm.data.TenantId = $rootScope.gVariable.srchTenantId;
                vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
              }
            }

            vm.chkSendMessage();
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.log("error");
            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }
      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

     /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;

        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 발송 내용을 확인하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn =  false;
        }

        return bRtn;
      }

     /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData()) {
          // 내용
          var data = angular.copy(vm.data); // 사용자 입력 데이터
          data.sendHour = data.theTime.getHours();
          data.sendMinute = data.theTime.getMinutes();

          if(isNullOrEmpty(data.keyId)){
            data.mapCode = INSERT_SQL;
          }else{
            data.RelateDataId = data.keyId;
            data.mapCode = UPDATE_SQL;
          }

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                goList();
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(LIST_PAGE_URL, {
            srch: srch
          }, {reload: LIST_PAGE_URL});
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: $stateParams.keyId
          }, {reload: LIST_PAGE_URL});
        }        
      }

      vm.chgCmpgnChannel = function () {
        if (vm.data.CmpgnChannel == 'SMS') {
          if (vm.messageLength > 90) {
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
          } else {
            vm.messageMaxLength = '90';
          }
        }

        if (vm.data.CmpgnChannel == 'LMS' || vm.data.CmpgnChannel == 'MMS') {
          if (vm.messageLength < 91) {
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else {
            vm.messageMaxLength = '2000';
          }
        }
      };

       /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (vm.data.CmpgnChannel == 'SMS' && bytes > 90) {
            $rootScope.showSimpleToast($translate.instant('SMS(단문)의 최대 90 bytes를 초과하여 LMS(장문)으로 전환됩니다.'));
            vm.messageMaxLength = 2000;
            vm.data.CmpgnChannel = 'LMS';
            vm.lmsYN = 'Y';
          }

          if ((vm.data.CmpgnChannel == 'LMS' || vm.data.CmpgnChannel == 'MMS') && bytes > 2000) {
            $rootScope.showSimpleToast($translate.instant('메세지는 최대 2000 bytes까지 가능합니다.'));
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }

          if (vm.lmsYN == 'Y' && bytes < 91) {
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          }

          vm.messageLength = bytes;

          //vm.data.SendMessage = fnCutMsg(msg, 90);
        } else {
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          bytes = 0;
          vm.messageLength = bytes;
        }
        vm.messageLength = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      vm.tabId = 'tab1';
      vm.setChangeTab = function(_id){
        vm.tabId = _id;
        $('.tab-pane.active').addClass('fade').removeClass('active');
        $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
      };

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.sms:sms-auto-list
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the sms자동발송
   */
  webapp.controller('SmsAutoListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsAutoListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'SmsSituationAuto.getSmsSituationAutoListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SmsSituationAuto.getSmsSituationAutoList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-auto-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.sms-auto-list.edit';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.sms-auto-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.sms-auto-edit';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.sms-auto-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.smssituationauto'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      $scope.selectedRow = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        console.log('setPageChanged');
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == "N") return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      function sortClass(sortkey) {
        if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

        var rtnval = "";

        if (vm.srch.sortDirect == "ASC") {
          rtnval = "fa fa-caret-down";
        } else {
          rtnval = "fa fa-caret-up";
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.sortClass = sortClass;      

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SmsSendNumberEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SmsSendNumberEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var UPDATE_SQL = "SendVerify.updateSendNumberVerify";   // 인증 승인
      var VIEW_SQL = 'SendVerify.getSendVerifyDetail'; // 조회 SQL
      var DEL_SQL = 'SendVerify.deleteSendVerify';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-send-number-list';             // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.system.sms-send-number-list.edit'; // 목록 수정 화면
      var EDIT_PAGE_URL = 'app.system.sms-send-number-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendVerifyAdmin.Mobile'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          KeyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType,
          Type: 'M'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.KeyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
        vm.srch.Type = 'M';
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.KeyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.RelateDataId = vm.srch.KeyId;

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.KeyId) ? vm.srch.KeyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.log("error");
              // console.error("Error> onFileDelete()");
              // console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.KeyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = angular.copy(vm.srchDetail);
        data.tableNm = 'SendVerify.Mobile';
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.KeyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };

                vm.uploadFileList.push(obj);
              });
            } else {

              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if(vm.formType == 'EMAIL') {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.data.Contents = $("#strHtml").val();
        }

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.KeyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getUploadFileList()");
          // console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });

//        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = angular.copy(vm.data); // 사용자 입력 데이터

        // 수정
        data.RelateDataId = data.KeyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.log("error");
          // console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.log("error");
        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.KeyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.KeyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(EDIT_PAGE_URL, {
              srch: srch,
              formType: vm.formType,
              keyId: vm.data.KeyId
            }, {reload:EDIT_PAGE_URL});
          }
        } else {
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch:srch, formType:vm.formType, keyId: vm.data.KeyId}, {reload:LIST_PAGE_URL});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.log("error");
          // console.error("Error> delDataAction()");
          // console.table(error);
        });
      }


      /**
       * 인증 확인
       * @param
       * @return
       */
      function setUpdate(CertYN) {
        gConfirm('', (CertYN == 'Y'? '인증승인':'인증취소') + ' 하시겠습니까?', {
          btn : '',
          fn : function() {
            seUpdateAction(CertYN);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function seUpdateAction(CertYN) {
        var data = angular.copy(vm.srch);
        data.mapCode = UPDATE_SQL;
        data.CertYN = CertYN;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', (CertYN == 'Y'? '인증승인':'인증취소') + ' 처리가 완료 되었습니다.', {
              btn : '',
              fn : function() {
                goNextPage();        
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;               // 데이터 삭제
      vm.setUpdate = setUpdate;                   // 인증승인
      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendNumberVerify.insertSendNumberVerify';     // 등록 SQL
      var LIST_CNT_SQL = 'SendVerify.getSendVerifyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SendVerify.getSendVerifyList';    // 목록 조회 SQL
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-send-number-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.sms-send-number-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.sms-send-number-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.sms-send-number-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.sms-send-number-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendVerifyAdmin.Mobile'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          Type: 'M'
          //RegDateFrom : '',
          //RegDateTo : '',
          //SendNumber : '',
          //CertType : '',
          //CertYN : ''
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }
      vm.srchList = {};
      vm.keyId = $stateParams.keyId;
      $scope.selectedRow = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

              console.log('columnMap ===== ', vm.columnMap);
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> setDelListAction()");
          // console.table(error);
        });
      }
      


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  webapp.controller('SupportBusinessListCtrl',
    ['$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
      function SupportBusinessListCtrl($rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, modalFactory) {

        var vm = this;  // View Model
        vm.headerTitle = "지원사업 목록";
        vm.showDetailSearch = false;

        // 담당지역본부
        postApi.select({ mapCode: 'AutoComplete.getRegionCodeList'}, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeRegionCodeList = result.body.docs;
          }
        });

        // 사용여부
        postApi.select({ mapCode: 'CommonCode.getCommonCodeList', CodeType: 'USEYN' }, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeUseYNList = result.body.docs;
          }
        });

        // 회의뷰 조회 팝업창
        vm.supportBusinessModal = function (keyId) {
          var ctrl = 'SupportBusinessModalCtrl as vc';
          var paramData = { KeyId: keyId };

          var modalInstance = modalFactory.open('mf-80', 'app/system/support-business/support-business-modal.html', ctrl, paramData);
          modalInstance.result.then(function () {
            av.search();
          }, function () {
            av.search();
          });
        };

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          printColumn: true,

          /* 공통 */
          viewType: mViewType.List, // List OR Edit
          tableNm: "TB_SPTBUSINESS",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "lists", // ex : vc.data = {}
          srchModelNm: "srch",
          srchTarget: "searchWrap",
          apis: {
            initSelectCnt: { mapCode: "SupportBusiness.getSupportBusinessListCnt", param: null },
            initSelect: { mapCode: "SupportBusiness.getSupportBusinessList", param: null, excelFileName: "지원사업목록"},
          },

          addSrchStack: false,

          // List
          listCheckboxEnable: true,

          src: {
            detail: "",
            splitDetail: ""
          },

          customCodes: {
            DeptId: "codeRegionCodeList"
          },

          // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
          listClickCallback: clickevent,

          addFormGroup : {
            //BusiStartDate : { after : "BusiContents", type : mElemTx.date,  bindKey : ["BusiStartDateFrom", "BusiStartDateTo"], label : "사업시작일", addDivision : true, colSize : 4},
          }
        };


        //#region 목록 삭제
        function setDelList() {
          vm.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.KeyIdList == null || vm.KeyIdList.length == 0) {
            av.alert('Menu.DELETENODATA', function(){ });
            return false;
          }

          av.confirm("Menu.DELETECONFIRM", function () {
            var data = { mapCode: 'SupportBusiness.deleteSupportBusinessBatch', KeyIdList: vm.KeyIdList };
            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert('Menu.DELETED', function(){ av.search(); });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelList()");
              // console.table(error);
            });
          }, function () {

          });
        }
        //#endregion 목록 삭제

        vm.setExcelFile = function () {
          var ctrl = 'SupportBusinessUploadModalCtrl as vc';
          var paramData = {};
    
          var modalInstance = modalFactory.open('mf-70', 'app/system/support-business/excel-upload/support-business-upload-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
          }, function (cancelData) {
            // cancel버튼
          });
        };


        function clickevent(clickData) {
          vm.supportBusinessModal(clickData.KeyId);
        }

        function onReadyAutoView() {
          //vm.setExcelFile();
        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.clickevent = clickevent;
        vm.setDelList = setDelList;

        var av = new autoView();
        av.init(autoViewOption);

      }]);
})();

(function () {
  "use strict";
  webapp.controller('SupportBusinessModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
      function SupportBusinessModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {

        var vm = this;
        vm.mdata = mdata;

        // 담당지역본부
        postApi.select({ mapCode: 'AutoComplete.getRegionCodeList'}, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeRegionCodeList = result.body.docs;
          }
        });

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "TB_SPTBUSINESS",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {
            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "SupportBusiness.getSupportBusinessDetail", param: { KeyId: mdata.KeyId }},

            // vieType is edit
            insert: "SupportBusiness.insertSupportBusinessBatch",
            update: "SupportBusiness.updateSupportBusinessBatch"
          },

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
          },

          // MataColum 외 추가 적으로 넣어야할 폼
          addForm: {
            CustNm: { after: 'ClientNm', type: mElemTx.input, colSize: 3, label: "고객" },
            ManagerNm: { after: 'DeptId', type: mElemTx.input, colSize: 3, label: "영업담당자" }
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            DeptId: "codeRegionCodeList"
          },

          // 필수 항목 컬럼 
          required: ["BusinessNm", "ClientNm", "BusiContents", "BusiStartDate", "BusiEndDate"],

          autocomplete: {
            BusinessNm: { keyNm: "BusinessId", callback: "setBusinessCode", codeList: "codeBusinessList", ngChange: "onChangeBusinessNm" },
            ClientNm: { keyNm: "ClientId", callback: "setClientCode", codeList: "codeClientList", addTopRow: "신규등록", addTopRowCallback: "addClient", ngChange: "onChangeClientNm" },
            CustNm: { keyNm: "CustId", callback: "setCustCode", codeList: "codeCustList", addTopRow: "신규등록", addTopRowCallback: "addCust", ngChange: "onChangeCustNm" },
            ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", ngChange: "onChangeManagerNm" },
          }
        };


        //#region 사업 자동완성 목록
        vm.ACBusinessNm = "__undefined__";
        vm.ACBusinessNmTimerId = null;

        vm.onChangeBusinessNm = function (item) {
          if (vm.ACBusinessNmTimerId != null) {
            clearTimeout(vm.ACBusinessNmTimerId);
          }

          vm.ACBusinessNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACBusinessNm != item && !check.test(item)) {
              // 사업리스트
              postApi.select({ mapCode: 'AutoComplete.getBusinessCodeList', BusinessNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.BusinessNm;
                  });
                  vm.codeBusinessList = result.body.docs;
                }

                vm.ACBusinessNm = item;
              });
            }
          }, 100);
        };

        function setBusinessCode(data) {
          vm.data.BusinessId = data.BusinessId;
        }
        //#endregion 사업 자동완성 목록


        //#region 고객사 자동완성 목록
        vm.ACClientNm = "__undefined__";
        vm.ACClientNmTimerId = null;

        vm.onChangeClientNm = function (item) {
          if (vm.ACClientNmTimerId != null) {
            clearTimeout(vm.ACClientNmTimerId);
          }

          vm.ACClientNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACClientNm != item && !check.test(item)) {
              // 고객사리스트
              postApi.select({ mapCode: 'AutoComplete.getClientList', ClientNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.ClientNm;
                  });
                  vm.codeClientList = result.body.docs;
                }

                vm.ACClientNm = item;
              });
            }
          }, 100);
        };

        function setClientCode(data) {
          vm.data.ClientId = data.ClientId;
        }

        function addClient() {
          var ctrl = 'ClientEditModalCtrl as vc';
          var paramData = { popup: 'Y' };
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }
        //#endregion 고객사 자동완성 목록


        //#region 고객 자동완성 목록
        vm.ACCustNm = "__undefined__";
        vm.ACCustNmTimerId = null;

        vm.onChangeCustNm = function (item) {
          if (vm.ACCustNmTimerId != null) {
            clearTimeout(vm.ACCustNmTimerId);
          }

          vm.ACCustNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACCustNm != item && !check.test(item)) {
              // 고객리스트
              postApi.select({ mapCode: 'AutoComplete.getCustList', EncryptNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.EncryptNm;
                  });
                  vm.codeCustList = result.body.docs;
                }

                vm.ACCustNm = item;
              });
            }
          }, 100);
        };

        function setCustCode(data) {
          vm.data.CustId = data.CustId;
        }

        function addCust() {
          var ctrl = 'KSACustEditModalCtrl as vc';
          var paramData = { popup: 'Y' };
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }
        //#endregion 고객 자동완성 목록


        //#region 영업담당자 자동완성 목록
        vm.ACManagerNm = "__undefined__";
        vm.ACManagerNmTimerId = null;

        vm.onChangeManagerNm = function (item) {
          if (vm.ACManagerNmTimerId != null) {
            clearTimeout(vm.ACManagerNmTimerId);
          }

          vm.ACManagerNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACManagerNm != item && !check.test(item)) {
              // 영업담당자리스트
              postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.UserNm;
                  });
                  vm.codeManagerList = result.body.docs;
                }

                vm.ACManagerNm = item;
              });
            }
          }, 100);
        };

        function setManagerCode(data) {
          var tmpCnt = 0;

          if (data) {
            if (vm.data.ManagerList.length != 0) {
              for (var i in vm.data.ManagerList) {
                if (vm.data.ManagerList[i].ManagerId == data.UserId) {
                  tmpCnt += 1;
                  $timeout(function () {
                    vm.data.ManagerNm = "";
                  }, 1);

                  av.alert("중복된 영업담당자는 선택할 수 없습니다.");
                }
              }
            }

            if (tmpCnt == 0) {
              vm.data.ManagerList.push({ 'ManagerId': data.UserId, 'ManagerNm': data.CodeValue });

              $timeout(function () {
                vm.data.ManagerNm = "";
              }, 1);
            }
          }
        }
        //#endregion 영업담당자 자동완성 목록





        function ok() {
          $uibModalInstance.close();
        }

        function cancel() {
          $uibModalInstance.dismiss();
        }

        // 저장 버튼 클릭 시
        function setData() {
          if (getIsValidData()) {
            av.confirm("Menu.SAVECONFIRM2", function () {
              av.commit(function (result) {
                av.alert('Menu.SAVED', function () {
                  vm.cancel();
                });
              });
            });
          }
        }

        function getIsValidData() {
          var bRtn = true;
          var errMsg = '';

          if (isNullOrEmpty(vm.data.BusinessId)) {
            errMsg = errMsg + '- 지원사업명을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ClientId)) {
            errMsg = errMsg + '- 고객사명을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.BusiContents)) {
            errMsg = errMsg + '- 사업내용을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.BusiStartDate)) {
            errMsg = errMsg + '- 사업시작일을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.BusiEndDate)) {
            errMsg = errMsg + '- 사업종료일을 입력하세요.<br/>';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            bRtn = false;
          }
          return bRtn;
        }


        //#region 영업담당자 초기값 세팅
        function setManager() {
          var ManagerIds = [];
          var ManagerNms = [];
          if (vm.data.ManagerIds != null) {
            ManagerIds = vm.data.ManagerIds.split(",");
          }
          if (vm.data.ManagerNms != null) {
            ManagerNms = vm.data.ManagerNms.split(",");
          }
          angular.forEach(ManagerIds, function (item, key) {
            var result = { ManagerId: item, ManagerNm: ManagerNms[key] };
            vm.data.ManagerList.push(result);
          });
        }

        function delManager(item) {
          if (item) {
            for (var i in vm.data.ManagerList) {
              if (vm.data.ManagerList[i].ManagerId == item.ManagerId) {
                vm.data.ManagerList.splice(i, 1);
              }
            }
          }
        }
        //#endregion 영업담당자 초기값 세팅


        function onReadyAutoView() {
          vm.data.WriteDate = moment(new Date());
          vm.data.CustNm = vm.data.EncryptNm;
          vm.data.ManagerList = [];
          setManager();
        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.getIsValidData = getIsValidData;
        vm.setData = setData;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.setBusinessCode = setBusinessCode;
        vm.setClientCode = setClientCode;
        vm.addClient = addClient;
        vm.setCustCode = setCustCode;
        vm.addCust = addCust;
        vm.setManagerCode = setManagerCode;
        vm.delManager = delManager;


        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

webapp.service('ScreenAPISrv', ['$resource', 'StaticVariable',
  function ScreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.updateScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Screen.insertScreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.deleteScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doCallProcRolescreen: function() {
    	  return $resource(StaticVariable.getUrl('/select/Rolescreen.callProcRolescreen/action.json'), {},
    			  StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - ScreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('ScreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'ScreenAPISrv',
    'gAlert', 'gConfirm', function ScreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].ScreenId !== null) {
              vm.data = data.responseVO.body.docs[0];
              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Screen";
        vm.data.TableId = vm.data.ScreenId;

        var prms = null;
        if (vm.data.ScreenId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.ScreenId === "0") {
                    $state.go("app.system.screen-list");
                  } else {
                    vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId !== null ? data.responseVO.body.docs[0].ScreenId : "0";
                    vm.srch.ScreenId = vm.data.ScreenId;
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        var prms = api.doDelete().post(vm.data).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.screen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.log("error");
          // console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.system:screen-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('ScreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', function ScreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {
      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'screen',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        tableNm : 'screen',
        IdName : 'ScreenId',
      };

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var data = vm.srch;
        data.mapCode = 'Screen.getScreenDetail';
        vm.dataloader = true;
        // 내용
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
            }
          } else {
            console.log(result.body);
            gAlert('', result.body.docs[0].errMessage);
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        var data = vm.data;
        data.tableNm = vm.srch.tableNm;
        data.TableId = vm.data.ScreenId;
        vm.dataloader = true;
        if (data.ScreenId == null || data.ScreenId == '') {
          // 등록
          data.mapcode = "Screen.insertScreen";
          postApi.insert(data, function(result) {
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = "Screen.updateScreenDetail";
          postApi.update(data, function(result){
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        }
      }

      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].ScreenId !== null || result.body.docs[0].TableId !== null) {
            // KeyId 조회
            vm.data.ScreenId = result.body.docs[0].ScreenId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function() {
                var srch = $stateParams.srch;

                if (vm.layout == 'N') {
                  if (vm.srch.ScreenId == null || vm.srch.ScreenId == '') {
                    $state.go("app.system.screen-list", { srch: srch });
                  } else {
                    // 조회 화면 이동
                    $state.go("app.system.screen-edit", {
                      srch: srch,
                      ScreenId: vm.data.ScreenId
                    });
                  }
                } else {
                  var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
                  srch2.ScreenId = "";
                  srch2.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(srch2, replacer));

                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:vm.data.ScreenId });
                }
              }
            });
            return;
          }
        }
        console.table(result);
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        vm.dataloader = true;
        vm.data.mapcode = "Screen.deleteScreenDetail";
        postApi.update(vm.data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                if (vm.layout == 'N') {
                  vm.srch.ScreenId = "";
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list", { srch: srch });
                } else {
                  vm.srch.ScreenId = "";
                  vm.srch.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:''});
                }
              }
            });
          }
        },function(error) {
          vm.dataloader = false;
          console.table(error);
        });
      }

      function goList() {
        vm.srch.ScreenId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go("app.system.screen-list", { srch: srch });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.goList = goList;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  ScreenAPISrv Module
 */
webapp.controller('ScreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
  function ScreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if ($stateParams.srch == '') {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'screen',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        sortDirect : '',
        sortColumn : ''
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'screen';
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.ScreenId;

    vm.listSize = [ 10, 25, 50, 100 ];

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    function resetSearch() {
      $state.go('app.system.screen-list', {
        srch : ''
      }, {reload: 'app.system.screen-list'});
    }

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.viewSize = vm.srch.viewSize;

      vm.dataloader = true;
      getListCnt();

      var data = vm.srch;
      data.mapCode = 'Screen.getScreenList';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Screen.getScreenListCnt';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0].totalItems;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.log("error");
        // console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function goDetail(ScreenId) {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      } else {
        $state.go('app.system.screen-list.detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      }
    }

    function goEdit(ScreenId) {
      var srch = $stateParams.srch;
      $scope.selectedRow = ScreenId;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      } else {
        $state.go('app.system.screen-list.edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getSearch();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.system.screen-list', {
        srch : srch
      }, {reload: 'app.system.screen-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.system:user-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('UserDetailCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    'GLOBAL_CONSTANT',
    'StaticVariable',
    'modalFactory',
    'postApi',
    'gAlert',
    'gConfirm',
    'customFieldApi',
    '$translate',

    function UserDetailCtrl(
      $window,
      $rootScope,
      $scope,
      $location,
      $state,
      $stateParams,
      CONSTANT,
      StaticVariable,
      modalFactory,
      postApi,
      gAlert,
      gConfirm,
      udcApi,
      $translate
    ) {
      var vm = this;

      // 접근 권한 체크
      if (!isPageAccess('user-detail', $window.sessionStorage['loginUserType']))
        $state.go('app.dashboard');

      // 버튼 권한 체크
      $scope.showBtnEdit = isPageAccess(
        'user-edit',
        $window.sessionStorage['loginUserType'],
        false
      );
      $scope.showBtnDel = true;

      // 함수 선언
      vm.deleteDetail = deleteDetail;
      $scope.showArmyInfo = true;
      $scope.objArmyZone1YN = 'N';
      $scope.objArmyZone2YN = 'N';

      // 검색 조건
      vm.srch = {
        UserId: $stateParams.UserId,
        TenantId: $stateParams.TenantId,
        TableNm: 'users',
      };

      // 조회 데이터
      vm.data = {};

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        if (vm.srch.UserId == null || vm.srch.UserId == '') {
          return;
        }

        vm.srch.mapCode = 'User.getUserDetail';

        postApi.select(
          vm.srch,
          function (data) {
            //console.log('load', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].UserId !== null) {
                vm.data = data.body.docs[0];

                $scope.objArmyZone1YN = vm.data.ArmyZone1YN;
                $scope.objArmyZone2YN = vm.data.ArmyZone2YN;
                $scope.objArmyZone3YN = vm.data.ArmyZone3YN;
                $scope.objArmyZone4YN = vm.data.ArmyZone4YN;
                $scope.objArmyZone5YN = vm.data.ArmyZone5YN;

                //              $scope.showArmyInfo = vm.data.UserType != "020";

                getArmyInfoList(); // 소속데이터권한 목록
                return;
              }
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }

      function deleteDetail() {
        gConfirm(
          '',
          'Menu.DELETECONFIRM',
          {
            btn: '',
            fn: function () {
              deleteDetailAction();
            },
          },
          {
            btn: '',
            fn: function () {},
          }
        );
      }

      function deleteDetailAction() {
        if (vm.srch.UserId === null || vm.srch.UserId === '') {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        //console.log('before delete', vm.data);

        vm.data.mapCode = 'User.deleteUserDetail';
        postApi.update(
          vm.data,
          function (data) {
            if (data.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  $state.go('app.system.user-list');
                },
              });
              return;
            }
          },

          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }

      // 소속데이터권한 목록
      function getArmyInfoList() {
        vm.srch.mapCode = 'User.getUserarmyinfoList';
        postApi.select(
          vm.srch,
          function (data) {
            //console.log('Userarmyinfo', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                $scope.ArmyInfoJSON = data.body.docs;
              } else {
                /*$scope.ArmyInfoJSON = [];*/
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 데이터 조회
      getData();
    },
  ]);
})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('UserEditCtrl', [
    '$window',
    '$rootScope',
    '$stateParams',
    '$state',
    '$scope',
    'GLOBAL_CONSTANT',
    'postApi',
    'gAlert',
    'gConfirm',
    '$translate',
    '$timeout',
    function UserEditCtrl($window, $rootScope, $stateParams, $state, $scope, CONSTANT, postApi, gAlert, gConfirm, $translate, $timeout) {
      var vm = this;

      vm.dataloader = false;

      // 접근 권한 체크
      if (!isPageAccess('user-edit', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

      //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
      if (isPageAccess('user-edit', $window.sessionStorage['loginUserType'])) {
        var param = {
          menuId : 'user-edit',
          userKey : $rootScope.gVariable.userKey
        };
        postApi.api('checkAuth', param, function(data){
          if(data.header.status === CONSTANT.HttpStatus.OK){
            if(!data.body.docs[0].rtn) {
              gAlert('','조회권한이 없습니다.');
              $state.go('app.dashboard');
            } 
          } else {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          }
        });
      }

      // 함수 선언
      vm.chkDupLoginId = chkDupLoginId;
      vm.chkDupLoginIdClear = chkDupLoginIdClear;
      vm.getData = getData;
      vm.setData = setData;
      vm.disabledArea = false;
      $scope.showArmyInfo = true;
      $scope.objArmyZone1YN = 'N';
      $scope.objArmyZone2YN = 'N';
      $scope.objArmyZone3YN = 'N';
      $scope.objArmyZone4YN = 'N';
      $scope.objArmyZone5YN = 'N';

      vm.TCode = {};

      // 공통코드 정의
      vm.UserTypeList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '130',
        Code: '030',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.UseYNList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '050',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.ArmyTypeList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1010',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      vm.EmpmCnsltTrgList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1450',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      /* 
      vm.ArmyAreaList = {
        CommonCodeId: '',
        ParentCommonCodeId: '',
        CodeType: '1290',
        Code: '',
        CodeValue: '',
        TenantId: $window.sessionStorage['loginTenantId'],
      }; */

      vm.onSelectCallback = function (data) {
        if (data.Code == null) data.Code = '';

        if (data.CodeType == '130') {
          vm.data.UserType = data.Code;
          //          $scope.showArmyInfo = vm.data.UserType != "020";
        } else if (data.CodeType == '050') {
          vm.data.UseYN = data.Code;
        } else if (data.CodeType == '1010') {
          vm.data.ArmyYear = data.Code;
        } else if (data.CodeType == '1450') {
          vm.data.EmpmCnsltTrg = data.Code;
        }
      };

      /* vm.onArmyAreaListSelected = function (data) {
        console.log('vm.onArmyAreaListSelected=', data);

        if (data == null) {
          vm.data.ArmyArea = '';
          return;
        }

        vm.data.ArmyArea = data.Code;
        vm.data.ArmyArea_ = data.CodeValue;
        vm.data.ArmyAreaType = '';

        if (vm.data.ArmyArea == '010') {
          vm.data.ArmyAreaType = '1' + vm.data.ArmyType;
        } else if (vm.data.ArmyArea == '020') {
          vm.data.ArmyAreaType = '2' + vm.data.ArmyType;
        } else if (vm.data.ArmyArea == '030') {
          vm.data.ArmyAreaType = '3' + vm.data.ArmyType;
        } else if (vm.data.ArmyArea == '040') {
          vm.data.ArmyAreaType = '4' + vm.data.ArmyType;
        } else if (vm.data.ArmyArea == '050') {
          vm.disabledArea = true;
          vm.data.ArmyAreaType = vm.data.ArmyArea;
        }

        vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyAreaType;
      }; */

      /*       vm.PermStat1List = {};
      vm.PermStat2List = {}; */

      /* vm.onArmyTypeListSelected = function (data) {
        console.log('onArmyTypeListSelected=', data);

        vm.PermStat1List.CodeType = '1140';
        vm.PermStat1List.ParentCommonCodeId = '';

        if (data == null) {
          vm.data.ArmyType = '';
          vm.data.ArmyType_ = '';
          return;
        }

        vm.data.ArmyType = data.Code;
        vm.data.ArmyType_ = data.CodeValue;

        vm.data.ArmyAreaType = '';

        if (vm.data.ArmyArea == '010') {
          vm.data.ArmyAreaType = '1' + data.Code;
        } else if (vm.data.ArmyArea == '020') {
          vm.data.ArmyAreaType = '2' + data.Code;
        } else if (vm.data.ArmyArea == '030') {
          vm.data.ArmyAreaType = '3' + data.Code;
        } else if (vm.data.ArmyArea == '040') {
          vm.data.ArmyAreaType = '4' + data.Code;
        } else if (vm.data.ArmyArea == '050') {
          vm.data.ArmyAreaType = vm.data.ArmyArea;
        }

        //vm.PermStat1List.ParentCommonCodeId = data.CommonCodeId;
        vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyAreaType;

        if (data.Code == null) data.Code = '';

        if (data.Code == '') {
          if (vm.data.ArmyArea == '050') {
            vm.PermStat1List.ParentCommonCodeId = vm.data.ArmyArea;
          }
        }
      };

      vm.onPermStat1ListSelected = function (data) {
        console.log('onPermStat1ListSelected=', data);

        vm.PermStat2List.CodeType = '';
        vm.PermStat2List.ParentCommonCodeId = '';

        if (data == null) {
          vm.data.PermStat1 = '';
          vm.data.PermStat1_ = '';
          return;
        }

        vm.data.PermStat1 = data.Code;
        vm.data.PermStat1_ = data.CodeValue;
        vm.PermStat2List.ParentCommonCodeId = data.CommonCodeId;
      };

      vm.onPermStat2ListSelected = function (data) {
        console.log('onPermStat2ListSelected=', data);

        if (data == null) {
          vm.data.PermStat2 = '';
          vm.data.PermStat2_ = '';
          return;
        }

        vm.data.PermStat2 = data.Code;
        vm.data.PermStat2_ = data.CodeValue;
      }; */

      function getTenantList() {
        vm.TCode.mapCode = 'User.getTenantList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0] != null) {
                vm.tenantList = data.body.docs;
              } else {
                vm.tenantList = [];
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getTenantList', status, data);
          }
        );
      }

      vm.onTenentCodeSelected = function (item) {
        if ($stateParams.UserId != 0) {
          if (confirm('데이터 조회 권한 정보가 초기화 됩니다.변경하시겠습니까?')) {
            deleteAllArmyInfo();
          } else {
            vm.TCode = item ? item : null;
            return false;
          }
        }

        vm.data.ArmyArea = '';
        vm.data.ArmyArea_ = '';
        vm.data.ArmyType = '';
        vm.data.ArmyType_ = '';
        vm.data.PermStat1 = '';
        vm.data.PermStat1_ = '';
        vm.AreaList = [];
        vm.TypeList = [];
        vm.Stat1List = [];

        if (vm.TCode == null) {
          vm.TCode.TenantId = '';
          vm.TCode.TenantNm = '';
        } else {
          vm.TCode.TenantId = vm.TCode.TenantId;
          vm.TCode.TenantNm = vm.TCode.TenantNm;
          vm.data.TenantId = vm.TCode.TenantId;
        }
        vm.TCode.mapCode = 'User.getTenantCodeList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0] != null) {
                vm.AreaList = data.body.docs[0].TenantArea.split(',');
                vm.TCode.TenantId = data.body.docs[0].TenantId;
              } else {
                vm.AreaList = [];
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      };
      vm.onTenentCodeSelected1 = function () {
        vm.data.ArmyArea = '';
        vm.data.ArmyArea_ = '';
        vm.data.ArmyType = '';
        vm.data.ArmyType_ = '';
        vm.data.PermStat1 = '';
        vm.data.PermStat1_ = '';
        vm.AreaList = [];
        vm.TypeList = [];
        vm.Stat1List = [];

        if (vm.TCode == null) {
          vm.TCode.TenantId = '';
          vm.TCode.TenantNm = '';
        } else {
          vm.TCode.TenantId = vm.TCode.TenantId;
          vm.TCode.TenantNm = vm.TCode.TenantNm;
          vm.data.TenantId = vm.TCode.TenantId;
        }

        vm.TCode.mapCode = 'User.getTenantCodeList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0] != null) {
                vm.AreaList = data.body.docs[0].TenantArea.split(',');
                //vm.TCode.TenantId = data.body.docs[0].TenantId;
              } else {
                vm.AreaList = [];
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      };

      vm.onArmyAreaListSelected = function () {
        vm.data.ArmyType = '';
        vm.data.ArmyType_ = '';
        vm.data.PermStat1 = '';
        vm.data.PermStat1_ = '';
        vm.TypeList = [];
        vm.Stat1List = [];

        if (vm.ArmyAreaList == null) {
          vm.TCode.ArmyArea2 = '';
          vm.data.ArmyArea = '';
        } else {
          vm.TCode.ArmyArea2 = vm.ArmyAreaList;
          vm.data.ArmyArea = vm.ArmyAreaList;
        }

        vm.TCode.mapCode = 'User.getArmyTypeList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs != null) {
                vm.TypeList = data.body.docs;
              } else {
                vm.TypeList = [];
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      };

      vm.onArmyTypeListSelected = function () {
        vm.data.PermStat1 = '';
        vm.data.PermStat1_ = '';

        if (vm.ArmyTypeList == null) {
          vm.TCode.ArmyType = '';
          vm.data.ArmyType = '';
          vm.data.ArmyType_ = '';
        } else {
          vm.TCode.ArmyType = vm.ArmyTypeList.ArmyType;
          vm.data.ArmyType = vm.ArmyTypeList.ArmyType;
          vm.data.ArmyType_ = vm.ArmyTypeList.ArmyType_;
        }

        vm.TCode.mapCode = 'User.getArmyAreaList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs != null) {
                vm.Stat1List = data.body.docs;
              } else {
                vm.Stat1List = [];
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      };

      vm.onPermStat1ListSelected = function () {
        if (vm.PermStat1List == null) {
          vm.TCode.PermStat1 = '';
          vm.data.PermStat1 = '';
          vm.data.PermStat1_ = '';
        } else {
          vm.TCode.PermStat1 = vm.PermStat1List.PermStat1;
          vm.data.PermStat1 = vm.PermStat1List.PermStat1;
          vm.data.PermStat1_ = vm.PermStat1List.PermStat1_;
        }
      };

      // 행추가 삭제 테이블 (자격증)
      /*$scope.ArmyInfoJSON=[
        {"UserArmyInfoId":"", "ArmyType":"", "ArmyType_":"", "PermStat1":"", "PermStat1_":"","PermStat2":"", "PermStat2_":""},        
      ];*/
      $scope.ArmyInfoJSON = [];

      $scope.removeRowArmyInfo = function (index) {
        var removeJSON = $scope.ArmyInfoJSON.splice(index, 1);

        if (removeJSON[0].UserArmyInfoId != '') {
          deleteArmyInfo(removeJSON[0].UserArmyInfoId);
        }

        if ($scope.ArmyInfoJSON.length == 0) {
          $scope.ArmyInfoJSON = [];
        }
      };

      $scope.addRowArmyInfo = function () {
        var strArmyArea = typeof vm.data.ArmyArea == 'undefined' || vm.data.ArmyArea == '' || vm.data.ArmyArea == null ? '' : vm.data.ArmyArea;
        var strArmyType = typeof vm.data.ArmyType == 'undefined' || vm.data.ArmyType == '' || vm.data.ArmyType == null ? '' : vm.data.ArmyType;
        var strArmyType_ = typeof vm.data.ArmyType_ == 'undefined' || vm.data.ArmyType_ == '' || vm.data.ArmyType_ == null ? '' : vm.data.ArmyType_;
        var strPermStat1 = typeof vm.data.PermStat1 == 'undefined' || vm.data.PermStat1 == '' || vm.data.PermStat1 == null ? '' : vm.data.PermStat1;
        var strPermStat1_ =
          typeof vm.data.PermStat1_ == 'undefined' || vm.data.PermStat1_ == '' || vm.data.PermStat1_ == null ? '' : vm.data.PermStat1_;
        var strPermStat2 = typeof vm.data.PermStat2 == 'undefined' || vm.data.PermStat2 == '' || vm.data.PermStat2 == null ? '' : vm.data.PermStat2;
        var strPermStat2_ =
          typeof vm.data.PermStat2_ == 'undefined' || vm.data.PermStat2_ == '' || vm.data.PermStat2_ == null ? '' : vm.data.PermStat2_;
        var isErr = false;
        var isDel = false;
        // console.log('addRowArmyInfo', strArmyArea, strArmyType, strPermStat1);

        if (strArmyArea == '') {
          gAlert('', '권역을 선택해주세요.');
          return false;
        }

        // 중복체크로직 삽입
        $.each($scope.ArmyInfoJSON, function (idx, row) {
          if (row.ArmyType == null) {
            row.ArmyType = '';
          }
          if (row.PermStat1 == null) {
            row.PermStat1 = '';
          }

          // 중복체크
          if (row.ArmyArea == strArmyArea && row.ArmyType == strArmyType && row.PermStat1 == strPermStat1) {
            gAlert('', '이미등록된 소속입니다.');
            isErr = true;
            return false;
          }

          // 상위체크(1뎁스)
          if (
            (row.ArmyArea == strArmyArea && row.ArmyType == '' && row.PermStat1 == '') ||
            (row.ArmyArea == strArmyArea && row.ArmyType == strArmyType && row.PermStat1 == '')
          ) {
            gAlert('', '이미상위 소속이 등록되어 있습니다.');
            isErr = true;
            return false;
          }

          // 하위체크 (1뎁스)
          if (strArmyArea != '' && strArmyType == '' && strPermStat1 == '') {
            if (row.ArmyArea == strArmyArea) {
              //if (!isDel && !gConfirm("", "하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) { // gConfirm 사용불가 우선 true가 반환되어 진행된후 나중에 confirm 창이 나오는 문제가 발생
              if (!isDel && !confirm('하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?')) {
                isErr = true;
                return false;
              } else {
                deleteArmyInfo($scope.ArmyInfoJSON[idx].UserArmyInfoId);
                isDel = true;
                delete $scope.ArmyInfoJSON[idx];
                $scope.ArmyInfoJSON = $scope.ArmyInfoJSON.filter(function (x) {
                  return x !== null;
                }); //null값 제거
              }
            }
          }

          // 하위체크 (2뎁스)
          if (strArmyArea != '' && strArmyType != '' && strPermStat1 == '') {
            if (row.ArmyArea == strArmyArea && row.ArmyType == strArmyType) {
              //if (!isDel && !gConfirm("", "하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?")) { // gConfirm 사용불가 우선 true가 반환되어 진행된후 나중에 confirm 창이 나오는 문제가 발생
              if (!isDel && !confirm('하위 소속이 존재합니다. 삭제하고 상위소속을 등록하시겠습니까?')) {
                isErr = true;
                return false;
              } else {
                deleteArmyInfo($scope.ArmyInfoJSON[idx].UserArmyInfoId);
                isDel = true;
                delete $scope.ArmyInfoJSON[idx];
                $scope.ArmyInfoJSON = $scope.ArmyInfoJSON.filter(function (x) {
                  return x !== null;
                }); //null값 제거
              }
            }
          }
        });

        if (isErr) return false;

        $scope.ArmyInfoJSON.push({
          UserArmyInfoId: '',
          ArmyArea: '' + strArmyArea + '',
          ArmyType: '' + strArmyType + '',
          ArmyType_: '' + strArmyType_ + '',
          PermStat1: '' + strPermStat1 + '',
          PermStat1_: '' + strPermStat1_ + '',
          PermStat2: '' + strPermStat2 + '',
          PermStat2_: '' + strPermStat2_ + '',
        });
      };

      vm.stateParams = {
        UserId: $stateParams.UserId,
      };

      // 검색 조건
      vm.srch = {
        UserId: $stateParams.UserId,
        TenantId: $window.sessionStorage['loginTenantId'],
        TableNm: 'Users',
      };

      // 등록/수정 표시용 컬럼 목록
      vm.srch.editColumns = [];

      // 조회 데이터
      vm.data = {
        UserId: $stateParams.UserId,
        TenantId: $window.sessionStorage['loginTenantId'],
        TableNm: 'Users',
      };

      // 유효성검사
      function chkValid() {
        if (typeof vm.data.LoginId == 'undefined' || vm.data.LoginId == '') {
          gAlert('', '아이디를 입력해주세요');
          return false;
        }

        if (vm.data.UserId == '') {
          if (vm.data.isDupLoginId == 'Y') {
            gAlert('', '중복확인 버튼을 클릭해주세요');
            return false;
          }
        }
        if ((typeof vm.data.UserId == 'undefined' || vm.data.UserId == '')
         && (typeof vm.data.Password == 'undefined' || vm.data.Password == '')) {
          gAlert('', '비밀번호를 입력해주세요');
          return false;
        }
        if (
          (typeof vm.data.UserId == 'undefined' || vm.data.UserId == '') &&
          (typeof vm.data.Password == 'undefined' || vm.data.Password.length < 8)
        ) {
          gAlert('', '비밀번호는 최소 8자리 이상으로 입력해주세요');
          return false;
        }
        if ((typeof vm.data.UserId == 'undefined' || vm.data.UserId == '')
         && (typeof vm.data.Password2 == 'undefined' || vm.data.Password2 == '')) {
          gAlert('', '비밀번호확인을 입력해주세요');
          return false;
        }
        if (vm.data.Password != vm.data.Password2) {
          gAlert('', '비밀번호가 일치하지 않습니다');
          return false;
        }
        if (
          typeof vm.data.Password != 'undefined' &&
          vm.data.Password != '' &&
          $window.sessionStorage['loginUserType'] != '020' &&
          !checkPassword(vm.data.Password, $window.sessionStorage['loginUserId'])
        ) {
          //gAlert('', '비밀번호가 일치하지 않습니다.');
          return false;
        }
        if (typeof vm.data.UserNm == 'undefined' || vm.data.UserNm == '') {
          gAlert('', '사용자명을 입력해주세요');
          return false;
        }
        if (typeof vm.data.CompanyNm == 'undefined' || vm.data.CompanyNm == '') {
          gAlert('', '소속을 입력해주세요');
          return false;
        }
        if (typeof vm.data.UserType == 'undefined' || vm.data.UserType == '') {
          gAlert('', '사용자구분을 선택해주세요');
          return false;
        }
        if (typeof vm.data.UseYN == 'undefined' || vm.data.UseYN == '') {
          gAlert('', '사용여부를 선택해주세요');
          return false;
        }
        if (typeof vm.data.Mobile == 'undefined' || vm.data.Mobile == '') {
          gAlert('', '휴대폰 번호를 입력해주세요');
          return false;
        }
        if (typeof vm.data.Email == 'undefined' || vm.data.Email == '') {
          gAlert('', '이메일을 입력해주세요');
          return false;
        }
        /*if (vm.data.isSave == 'N') {
          gAlert('', '이미 등록된 아이디입니다');
          return false;
        }*/

        return true;
      }

      function checkPassword(password, id) {
        if (!/^(?=.*[a-zA-Z])(?=.*[~!@#$%^*+=-])(?=.*[0-9]).{8,16}$/.test(password)) {
          alert('숫자+영문자+특수문자 조합으로 8자리 이상 16자리 이하로 사용해야 합니다.');
          return false;
        }
        var checkNumber = password.search(/[0-9]/g);
        var checkEnglish = password.search(/[a-z]/gi);
        if (checkNumber < 0 || checkEnglish < 0) {
          alert('숫자와 영문자를 혼용하여야 합니다.');
          return false;
        }
        if (/(\w)\1\1/.test(password)) {
          alert('같은 문자를 3번 이상 사용하실 수 없습니다.');
          return false;
        }
        /*
          if(password.search(id) > -1){
              alert("비밀번호에 아이디가 포함되었습니다.");
              //$('#password').val('').focus();
              return false;
          }*/
        return true;
      }

      /**
       * 등록/수정 화면에 표시할 컬럼 목록
       *
       * @param
       * @return
       * @author 최원영
       */
      /*function getSelectEditColumns() {

        var prms = userApi.doSelectEditColumns().post(vm.srch).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            
             * vm.allColumns = data.responseVO.body.docs;
             *  // 등록/수정화면 표시 설정 for (let k in vm.allColumns) { if
             * (vm.allColumns.hasOwnProperty(k)) {
             * vm.srch.editColumns.push(vm.allColumns[k].ColumnPhysicalNm); } }
             
            vm.allColumns = data.responseVO.body.docs;

            angular.forEach(vm.allColumns, function(item) {

              if (item.EditColumnShowYN === 'Y')
                vm.srch.editColumns.push(item);
            });
          }
        }, function(error) {
          console.error('Error-getSelectEditColumns', status, data);
        });
      }*/

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @return {boolean} true - 존재시, false - 미 존재시
       * @param {string}
       *          columnNm - 물리 컬럼명
       * @author
       */
      /*function getIsShowColumn(columnNm) {
        var result = false;

        // 등록/수정 화면 컬럼 조회
        // if (vm.srch.editColumns.length === 0) {
        // getSelectListColumnList();
        // }
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);
        result = (itemIndex > -1);
        return result;
      }*/

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 우언수
       */
      function getData() {
        if (typeof vm.data.UserId == 'undefined' || vm.data.UserId == null || vm.data.UserId == '') {
          vm.data.UserId = '';
          if ($rootScope.gVariable.userType != '000') {
            vm.TCode.TenantId = $rootScope.gVariable.TenantId;
            vm.TCode.TenantNm = $rootScope.gVariable.TenantName;
            //vm.onTenentCodeSelected();
          }
          return;
        }
        vm.srch.mapCode = 'User.getUserDetail';

        postApi.select(
          vm.srch,
          function (data) {
            //console.log('load', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docCnt !== 0 && data.body.docs[0].UserId !== null) {
                vm.data = data.body.docs[0];

                vm.UserTypeList.Code = vm.data.UserType;
                vm.UseYNList.Code = vm.data.UseYN;
                vm.data.OldLoginId = vm.data.LoginId;
                vm.TCode.TenantId = vm.data.TenantId;
                vm.TCode.TenantNm = vm.data.TenantNm;
                vm.EmpmCnsltTrgList.Code = vm.data.EmpmCnsltTrg;
                //vm.TCode.TenantCode = vm.data.TenantCode;
                //vm.TCode.TenantCodeNm = vm.data.TenantCodeNm;

                vm.onTenentCodeSelected1();

                getArmyInfoList(); // 소속데이터권한 목록

                return;
              }
            }
            gAlert('알림', data.body.docs[0].errMessage);
          },
          function (data) {
            console.log("error");
            // console.error('fail', status, data);
            gAlert('알림', data.body.docs[0].errMessage);
          }
        );
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 우언수
       */
      function setData() {
        if (!chkValid()) return false;

        /*    if (vm.srch.UserId == 0) {
          vm.data.ArmyZone1YN = typeof(vm.data.ArmyZone1YN_) == "undefined" && vm.data.ArmyZone1YN_ ? "Y" : "N";
          vm.data.ArmyZone1YN = typeof(vm.data.ArmyZone2YN_) == "undefined" && vm.data.ArmyZone2YN_ ? "Y" : "N";
        }
        else {
          alert(vm.data.ArmyZone1YN_);
          alert(vm.data.ArmyZone2YN_);
          
          if (typeof(vm.data.ArmyZone1YN_) != "undefined") {
            vm.data.ArmyZone1YN = vm.data.ArmyZone1YN_ ? "Y" : "N";
          }
          if (typeof(vm.data.ArmyZone2YN_) != "undefined") {
            vm.data.ArmyZone2YN = vm.data.ArmyZone2YN_ ? "Y" : "N";
          }
          
         
        }*/
        vm.data.ArmyZone1YN = $scope.objArmyZone1YN;
        vm.data.ArmyZone2YN = $scope.objArmyZone2YN;
        vm.data.ArmyZone3YN = $scope.objArmyZone3YN;
        vm.data.ArmyZone4YN = $scope.objArmyZone4YN;
        vm.data.ArmyZone5YN = $scope.objArmyZone5YN;

        /*alert(vm.data.ArmyZone1YN);
        alert(vm.data.ArmyZone2YN);*/
        //console.log('id',$window.sessionStorage['loginUserId']);
        if (
          $window.sessionStorage['loginUserId'] != 'admin' &&
          $window.sessionStorage['loginUserId'] != 'jjh5797' &&
          $window.sessionStorage['loginUserId'] != 'eunim01' &&
          $window.sessionStorage['loginUserId'] != 'softzion2'
        ) {
          if (vm.data.UserType == '020' && vm.data.LoginId != $window.sessionStorage['loginUserId']) {
            alert('사용자구분 "교육원" 은 운영지원팀 계정만 등록 가능합니다.');
            return;
          }
        }

        //console.log(vm.data);
        var successCallback = function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.SAVED', {
              btn: '',
              fn: function () {
                if (data.body.docs[0].UserId !== null) {
                  $state.go('app.system.user-detail', {
                    UserId: data.body.docs[0].UserId,
                  });
                } else {
                  $state.go('app.system.user-list');
                }
              },
            });
            return;
          } else {
            gAlert('', data.body.docs[0].errMessage);
          }
        };

        var errorCallback = function (error) {
          console.log("error");
          // console.error('Error-setData', status, data);
          gAlert('', data.body.docs[0].errMessage);
        };

        // 취약점 조치 2025.06.11.
        // 기존의 비밀번호 복잡도 검증을 클라이언트에서만 진행하여
        // 패킷변조시 단순 비밀번호 설정이 가능하여 서버에서도 검증을 거치도록 수정
        if (vm.data.UserId == '') {
          // 등록
          // vm.data.mapCode = 'User.insertUserDetail';
          // postApi.insert(vm.data, successCallback, errorCallback);
          vm.data.armyInfoList = $scope.ArmyInfoJSON;
          postApi.sendPostApi('user', 'insertUser/action', vm.data, successCallback, errorCallback);
        } else {
          // 수정
          // vm.data.mapCode = 'User.updateUserDetail';
          // postApi.update(vm.data, successCallback, errorCallback);
          $scope.ArmyInfoJSON.forEach(function (data) {
            data.UserId = vm.srch.UserId;
            data.TenantId = vm.TCode.TenantId;
          });
          vm.data.armyInfoList = $scope.ArmyInfoJSON;
          postApi.sendPostApi('user', 'updateUser/action', vm.data, successCallback, errorCallback);
        }
      }

      // 사용자 중복체크
      function chkDupLoginId() {
        if (typeof vm.data.LoginId == 'undefined' || vm.data.LoginId == '') {
          gAlert('', '아이디를 입력해주세요');
          return false;
        }
        vm.data.mapCode = 'User.getChkDupLoginId';

        postApi.select(
          vm.data,
          function (data) {
            //console.log(data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (parseInt(data.body.docs[0].UsersDupCnt) == 0) {
                vm.data.isDupLoginId = 'N';
                /*vm.data.isSave = "Y";*/
                gAlert('', '등록이 가능한 아이디입니다.');
              } else {
                vm.data.isDupLoginId = 'Y';
                /*vm.data.isSave = "N";*/
                gAlert('', '이미 등록된 아이디입니다.');
              }

              return;
            }
            gAlert('', data.body.docs[0].errMessage);
          },
          function (error) {
            console.log("error");
            // console.error('Error-setData', status, data);
            gAlert('', data.body.docs[0].errMessage);
          }
        );
      }

      // 사용자 중복체크 초기화
      function chkDupLoginIdClear() {
        vm.data.isDupLoginId = 'Y';
      }

      // 소속데이터권한 목록
      function getArmyInfoList() {
        vm.srch.mapCode = 'User.getUserarmyinfoList';
        postApi.select(
          vm.srch,
          function (data) {
            //console.log('Userarmyinfo', data);
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                $scope.ArmyInfoJSON = data.body.docs;
              } else {
                /*$scope.ArmyInfoJSON = [];*/
              }
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }

      // 소속데이터권한 저장
      function setArmyInfo() {
        //console.log('$scope.ArmyInfoJSON', $scope.ArmyInfoJSON);
        $scope.ArmyInfoJSON.forEach(function (data) {
          data.UserId = vm.srch.UserId;
          data.TenantId = vm.TCode.TenantId;
        });
        var infoJsonList = {};
        infoJsonList.list = $scope.ArmyInfoJSON;
        if ($scope.ArmyInfoJSON.length > 0) {
          if ($stateParams.TenantId) {
            infoJsonList.TenantId = $stateParams.TenantId;
          }
          infoJsonList.mapCode = 'User.updateinsertUserarmyinfoBatch';
          postApi.update(
            infoJsonList,
            function (data) {
              if (data.header.status === CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.SAVED', {
                  btn: '',
                  fn: function () {
                    if ($stateParams.UserId == 0) {
                      $state.go('app.system.user-list');
                    } else {
                      $state.go('app.system.user-detail', {
                        UserId: vm.srch.UserId,
                      });
                    }
                  },
                });
                return;
              }
            },
            function (data) {
              console.log("error");
              // console.error('Error-setData', status, data);
              gAlert('', data.body.docs[0].errMessage);
            }
          );
        } else {
          gAlert('', 'Menu.SAVED', {
            btn: '',
            fn: function () {
              if ($stateParams.UserId == 0) {
                $state.go('app.system.user-list');
              } else {
                $state.go('app.system.user-detail', {
                  UserId: vm.srch.UserId,
                });
              }
            },
          });
          return;
        }

        /* $scope.ArmyInfoJSON.forEach(function (data) {
          data.UserId = vm.srch.UserId;
          data.TenantId= vm.TCode.TenantId;

            
          console.log('Userarmyinfo', data);

          var successCallback = function (json) {
            if (json.header.status === CONSTANT.HttpStatus.OK) {
              return true;
            }
            gAlert('', json.body.docs[0].errMessage);
            return false;
          };

          var errorCallback = function (json) {
            console.error('Error-setDataUserarmyinfo', status, json);
            gAlert('', json.body.docs[0].errMessage);
            return false;
          };

          if (data.UserArmyInfoId == '') {
            data.mapCode = 'User.insertUserarmyinfo';
            postApi.insert(data, successCallback, errorCallback);
          } else {
            data.mapCode = 'User.updateUserarmyinfo';
            postApi.update(data, successCallback, errorCallback);
          }
        }); */
      }

      // 소속데이터권한 삭제
      function deleteArmyInfo(idx) {
        vm.dataloader = true;
        var data = {
          UserArmyInfoId: idx,
        };

        data.mapCode = 'User.deleteUserarmyinfo';
        postApi.update(
          data,
          function (json) {
            if (json.header.status == CONSTANT.HttpStatus.OK) {
              $timeout(function () {
                vm.dataloader = false;
              }, 1000);
              return;
            }
          },
          function (json) {
            console.log("error");
            // console.error('fail', status, json);
            gAlert('', json.body.docs[0].errMessage);
          }
        );
      } // 소속데이터권한 삭제
      function deleteAllArmyInfo() {
        vm.dataloader = true;
        var data = {
          UserId: $stateParams.UserId,
        };

        data.mapCode = 'User.deleteAllUserarmyinfo';
        postApi.update(
          data,
          function (json) {
            if (json.header.status == CONSTANT.HttpStatus.OK) {
              $timeout(function () {
                vm.dataloader = false;
                $scope.ArmyInfoJSON = [];
              }, 1000);
              return;
            }
          },
          function (json) {
            console.log("error");
            // console.error('fail', status, json);
            gAlert('', json.body.docs[0].errMessage);
          }
        );
      }

      // 데이터 조회
      getData();
      getTenantList();
    },
  ]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('UserEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function UserEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'User.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'User.updateUser';     // 수정 SQL
      var VIEW_SQL = 'User.getUserMgrDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'User.deleteUserDetail';  // 삭제 SQL
      var DUPEMAIL_SQL = 'User.getEmail'; // 이메일 중복 확인 SQL
      var DEL_SHOP_SQL = 'User.deleteOwnerDetail';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.sysinfo.user-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.sysinfo.user-list.edit.tab1'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.sysinfo.user-edit.tab1';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.ManageYn = $window.sessionStorage['loginTenantAdminYn'];

      //#region 역할 호출
      
      postApi.select({mapCode : 'Role.getRoleCodeList'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          var temp = [];
          angular.forEach(result.body.docs, function(item, idx){
            temp.push({Code : item.RoleId, CodeValue :  item.RoleNm})
          })

          vm.codeRoleList = temp;
        }
      })

      vm.setChangeRoleList = function(val) {
        vm.data.UserRoles = [];
        var obj = {}
        angular.forEach(vm.codeRoleList, function(item){
          if(item.Code == val) {
            obj.RoleId = item.Code;
            obj.RoleNm = item.CodeValue
          }
        })

        vm.data.UserRoles.push(obj);
      }

      ////#endregion
      
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.tableNm) vm.srch.tableNm = KEY_TABLE_NM;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      var data = {};
      data.mapCode = 'organizationMng.getOrganizationCodes';
      data.Depth = '3';
      postApi.select(data, function(result){
        if(result.body.docs.length > 0) {
          vm.DeptCodeList = result.body.docs;
        } else {
          vm.DeptCodeList = [];
        }
      });

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.log("error");
              // console.error("Error> onFileDelete()");
              // console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          if (okData != null) {
            vm.data.TenantNm = okData.TenantNm;
            vm.data.TenantId = okData.TenantId;
          }
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId && vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      // #region 역할 검색 팝업 호출

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.data.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              if(isNullOrEmpty(vm.data.keyId)){
                vm.data.TenantId = $rootScope.gVariable.srchTenantId;
                vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
                vm.data.HSmsAgreeYN = 'N';
                vm.data.HEmailAgreeYN = 'N';
                vm.data.NSmsAgreeYN = 'N';
                vm.data.NEmailAgreeYN = 'N';
                vm.data.KSmsAgreeYN = 'N';
                vm.data.KEmailAgreeYN = 'N';
              }

              vm.tmpEmail = vm.data.Email;
              vm.tmpPassword = vm.data.Password;
              vm.data.branch_code = vm.data.BranchId;

              // 역할 설정
              vm.data.UserRoles = [];
              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
              vm.data.HSmsAgreeYN = 'N';
              vm.data.HEmailAgreeYN = 'N';
              vm.data.NSmsAgreeYN = 'N';
              vm.data.NEmailAgreeYN = 'N';
              vm.data.KSmsAgreeYN = 'N';
              vm.data.KEmailAgreeYN = 'N';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getData()");
          // console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      function getIsDupEmail () {

        var data = vm.data;
        data.mapCode = DUPEMAIL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.dupEmail = result.body.docs.length;
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> setData()");
          // console.table(error);
        });

      }

      //#region getBranchCodeList 지점 목록 조회
      /**
       * 지점 /부서 코드 조회
       *
       * @param 
       * @return
       */
      function getBranchCodeList() {
        vm.branchCodeList = [];
        var data = {};
        data.mapCode = 'organizationMng.getOrganizationCodes';
        data.Depth = '1';
        postApi.select(data, function(result){
          if(result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function(item){
                vm.branchCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
              });
          } else {
            vm.branchCodeList = [];
          }
        });
      }
      //#endregion

      /**
       * 지점 목록 변경시
       *
       * @param 
       * @return
       */
      vm.setChangeBranchCoe = function(code) {
       

      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 아이디 중복체크를 해 주세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 사용자명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(vm.data.KeyId) && vm.tmpPassword != vm.data.Password) {
          if( isNullOrEmpty(vm.data.Password)) {
            errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
          }
        }
        if (vm.data.Password != vm.data.Password2) {
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
        }

        if (!isNullOrEmpty(vm.data.Password)) {
          if (!getIsValidPassword()) {
            errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>';
          }
        }
        if (isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 핸드폰번호를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }
        if (!isNullOrEmpty(vm.data.Email) && vm.data.Email != vm.tmpEmail) {
          if (vm.dupEmail > 0) {
            errMsg = errMsg + '- 이메일이 중복되었습니다.<br/>';
          }
        }
        if (isNullOrEmpty(vm.data.UseYN)) {
          errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.UserRoleIds)) {
          errMsg = errMsg + '- 역할을 선택하세요.<br/>';
        }
        
        // if (isNullOrEmpty(vm.data.branch_code)) {
        //   errMsg = errMsg + '- 지점을 입력하십시오.<br/>';     
        // } else {
        //   vm.data.BranchCode = vm.data.branch_code;
        // }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> getUploadFileList()");
          // console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.log("error");
          // console.error("Error> getRoleList()");
          // console.table(error);
        });
      }

      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       * 
       * 
       */
      function getIsValidPassword() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.length < 8) return false;

        return true;

      }
      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        if (!isNullOrEmpty(vm.data.Email) && !isValidEmail(vm.data.Email)) {
          gAlert('이메일을 확인해주세요.');
          return;
        }

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            // console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.log("error");
            // console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        // console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 사용자 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디 입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용가능한 아이디 입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.log("error");
          // console.error("Error> setData()");
          // console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        var param = {};
        param.mapCode = "remoteJfc";
        param.remoteAction = "getUserType";
        param.rTenantID = $rootScope.gVariable.srchTenantId;
        param.rUserID = vm.data.KeyId;
        param.rLoginID = vm.data.LoginId;
        param.rShopTentID = vm.data.TenantId;

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            param.rUserType = result.body.docs[0].data.UserType;

            if(param.rUserType == "Owner") {
              gConfirm('', '[원장]권한으로 탈퇴시 Shop에 대한 모든 정보가 삭제되며 관여되어있는 사용자들 역시 탈퇴처리가 됩니다. 그래도 진행하시겠습니까?', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  setDelOwnerDataAction(param);
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            } else {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  setDelDataAction();
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            }
          } else {

          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.log("error");
          // console.error("Error> delDataAction()");
          // console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }
      /**
       * 추천인 코드 생성
       *
       * @param
       * @return
       */
      function setCode() {
        var s = '';
        var start = true;
        var intSum = '';
        var stringSum = '';
        var randomchar = function() {
        var n = Math.floor(Math.random() * 35);

        if(s.length == 0) {

          n = Math.floor(Math.random() * 26);
          stringSum += String.fromCharCode(n + 55);

          return String.fromCharCode(n + 65);
        }

          if (n < 10 && intSum.length < 3) {

            intSum += n;
            return n;
          }
            //1-10
          if (n < 36 &&  stringSum.length < 3) {

            stringSum += String.fromCharCode(n + 55);
            return String.fromCharCode(n + 55); //A-Z
          }
          if( n < 10 && n > 36) {
            return;
          }

        };
        var t ='';
        while (s.length < 6) {

          t = randomchar();
          if(t != undefined) {
            s += t;
          }
        }
        getIsDupMyCd(s);

      }

      function setDelOwnerDataAction(param) {

        param.mapCode = "remoteJfc";
        param.remoteAction = "getUserType";

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          } else {
          }
        });
        var data = vm.data;
        data.mapCode = DEL_SHOP_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if(result.body.docs[0].O_Result == 0) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  // 삭제 성공
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            } else {
              gAlert('', '삭제되지 않았습니다.', {
                btn: '',
                fn: function () {
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            }
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.log("error");
          // console.error("Error> delDataAction()");
          // console.table(error);
        });
      }

      function getTenantUserCnt(callback) {
        var maxCnt = 0;
        var fullYN = 'Y';
        vm.addUserAlert = false;

        try {
          postApi.select({ mapCode: 'User.getTenantUserCnt' },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                maxCnt = result.body.docs[0].MaxCnt;
                fullYN = result.body.docs[0].FullYN;

                if (maxCnt > 0) vm.addUserAlert = (fullYN == "N" ? true : false);
                callback(vm.addUserAlert);
              }
            });
        }
        catch (ex) {
          gAlert("확인", "신청사용자 조회중 오류가 발생하였습니다.<br/>관리자에게 문의해주세요.");
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;         // 사용자 중복 체크
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.getIsDupEmail = getIsDupEmail;

      vm.setChangeTab = setChangeTab;
      vm.setCode = setCode;
      vm.setDelOwnerDataAction = setDelOwnerDataAction;

      vm.getTenantUserCnt = getTenantUserCnt;     // 사용자 제한

      getTenantUserCnt (function(result) {
        if (isNullOrEmpty(vm.srch.keyId) && !result) {
          gAlert("", "회원사의 사용자 신청인원이 초과되었습니다.</br>관리자에게 문의해주세요.");
          goList();
        } else {
          // 데이터 조회
          getBranchCodeList();
          getData();
        }
      });
    }]);
})();

'use strict';
/**
 * @ngdoc function
 * @name app.system:user-list-ctrl
 * @param {object} $window - window object
 * @param {object} $rootScope - rootScope object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} GLOBAL_CONSTANT - Global Constant
 * @param {object} StaticVariable - StaticVariable Constant
 * @param {object} modalFactory - Modal Popup object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - gAlert Module
 * @param {object} gConfirm - gConfirm Module
 * @param {object} customFieldApi - customFieldApi Module
 * @param {object} $translate - translate object
 * @description Controller of the 사용자관리 목록
 */
webapp.controller('UserListCtrl', [
  '$window',
  '$rootScope',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  'GLOBAL_CONSTANT',
  'StaticVariable',
  'modalFactory',
  'postApi',
  'gAlert',
  'gConfirm',
  'modalFactory',
  'customFieldApi',
  '$translate',
  '$filter',
  '$timeout',

  function UserListCtrl(
    $window,
    $rootScope,
    $scope,
    $location,
    $state,
    $stateParams,
    CONSTANT,
    StaticVariable,
    modalFactory,
    postApi,
    gAlert,
    gConfirm,
    modalWindow,
    udcApi,
    $translate,
    $filter,
    $timeout
  ) {
    var vm = this;

    // 접근 권한 체크
    if (!isPageAccess('user-list', $window.sessionStorage['loginUserType'])) $state.go('app.dashboard');

    //2024-08-01 파라미터 조작을 통한 권한설정 우회 취약점 변경 후
    if (isPageAccess('user-list', $window.sessionStorage['loginUserType'])) {
      var param = {
        menuId : 'user-list',
        userKey : $rootScope.gVariable.userKey
      };
      postApi.api('checkAuth', param, function(data){
        if(data.header.status === CONSTANT.HttpStatus.OK){
          if(!data.body.docs[0].rtn) {
            gAlert('','조회권한이 없습니다.');
            $state.go('app.dashboard');
          } 
        } else {
          gAlert('','조회권한이 없습니다.');
          $state.go('app.dashboard');
        }
      });
    }

    // 버튼 권한 체크
    $scope.showBtnExcel = false;
    $scope.showBtnAdd = isPageAccess('user-edit', $window.sessionStorage['loginUserType'], false);
    $scope.showBtnDel = true;
    // 함수 선언
    /*vm.getSelectListColumnList = getSelectListColumnList;
      vm.getIsShowColumn = getIsShowColumn;*/
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.excelUpload = excelUpload;
    vm.deleteList = deleteList;
    vm.onTenentCodeSelected = onTenentCodeSelected;
    vm.onArmyAreaListSelected = onArmyAreaListSelected;
    vm.onArmyTypeListSelected = onArmyTypeListSelected;
    vm.onPermStat1ListSelected = onPermStat1ListSelected;
    vm.disabledArea = false;
    vm.listBtnDisable = false;
    vm.data = {};
    vm.TCode = {};
    // 검색 조건
    vm.srch = {
      SysAdminYN: $window.sessionStorage['loginSysAdminYN'],
      UseYN: 'Y',
    };

    // 페이징
    if ($stateParams.page === undefined || $stateParams.page === '') {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = [];

    vm.listSize = [10, 25, 50, 100];
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 공통코드 정의
    vm.TCode = {
      TenantId: '',
      TenantNm: '',
    };
    vm.UserTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '130',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    /* vm.UseYNList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '050',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */
    vm.ArmyTypeList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1010',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    };
    /* vm.ArmyAreaList = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '1290',
      Code: '',
      CodeValue: '',
      TenantId: $window.sessionStorage['loginTenantId'],
    }; */

    vm.onSelectCallback = function (data) {
      if (data.Code == null) data.Code = '';

      if (data.CodeType == '130') {
        vm.srch.UserType = data.Code;
      } else if (data.CodeType == '050') {
        vm.srch.UseYN = data.Code;
      } else if (data.CodeType == '1010') {
        vm.srch.ArmyType = data.Code;
      }
    };

    vm.PermStat1List = {};
    vm.PermStat2List = {};

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        if (!vm.lists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }

      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.lists.length; i++) {
        vm.lists[i].chkRow = vm.chkHead;
      }
    };


    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    if ($window.sessionStorage.getItem('user-list-ctrl') != null) {
      if (
        $rootScope.previousPage != null &&
        ($rootScope.previousPage.indexOf('/app/system/user-edit') !== -1 ||
          $rootScope.previousPage.indexOf('/app/system/user-detail') !== -1 ||
          $rootScope.previousPage.indexOf('/app/system/user-list') !== -1)
      ) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('user-list-ctrl'));
        vm.TCode.TenantId = vm.srch.TenantId;
        vm.TCode.TenantNm = vm.srch.TenantNm;
        onTenentCodeSelected();
        vm.ArmyAreaList = vm.srch.ArmyArea;
        onArmyAreaListSelected();
        vm.ArmyTypeList.ArmyType = vm.srch.ArmyType;
        vm.ArmyTypeList.ArmyType_ = vm.srch.ArmyType_;
        onArmyTypeListSelected();
        vm.PermStat1List.PermStat1 = vm.srch.PermStat1;
        vm.PermStat1List.PermStat1_ = vm.srch.PermStat1_;
        onPermStat1ListSelected();
        vm.UserTypeList.Code = vm.srch.UserType;
        //vm.UseYNList.Code = vm.srch.UseYN;
        vm.currentPage = vm.srch.page;
      }
    }
    
    function init() {
      if($rootScope.gVariable.userType !='000') {
        vm.TCode.TenantId = $rootScope.gVariable.TenantId;
        vm.TCode.TenantNm = $rootScope.gVariable.TenantName;
        onTenentCodeSelected();
      }
    }

    function getListCnt() {
      vm.srch.mapCode = 'User.getUserListCnt';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log('user', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt > 0) {
              vm.totalItems = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {

      vm.srch.page = vm.currentPage;
      if (vm.TCode != null) {
        if (vm.TCode.TenantId != undefined) {
          vm.srch.TenantId = vm.TCode.TenantId;
          vm.srch.TenantNm = vm.TCode.TenantNm;
        }
        if (vm.TCode.ArmyArea2 != undefined) {
          vm.srch.ArmyArea = vm.TCode.ArmyArea2;
        }
        if (vm.TCode.ArmyType != undefined) {
          vm.srch.ArmyType = vm.TCode.ArmyType;
          vm.srch.ArmyType_ = vm.TCode.ArmyType_;
        }
        if (vm.TCode.PermStat1 != undefined) {
          vm.srch.PermStat1 = vm.TCode.PermStat1;
          vm.srch.PermStat1_ = vm.TCode.PermStat1_;
        }
      }
      //console.log('vm.srch', vm.srch);
      $window.sessionStorage.setItem('user-list-ctrl', angular.toJson(vm.srch));

      getListCnt();

      vm.srch.mapCode = 'User.getUserList';
      postApi.select(
        vm.srch,
        function (data) {
          //console.log('users', data);
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              vm.lists = data.body.docs;
            } else {
              vm.totalItems = 0;
              vm.lists = {};
            }
            // console.info("vm.lists -", vm.lists);
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function getTenantList() {
      vm.TCode.mapCode = 'User.getTenantList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs[0] != null) {
              vm.tenantList = data.body.docs;
            } else {
              vm.tenantList = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getTenantList', status, data);
        }
      );
    }

    function onTenentCodeSelected () {
      //vm.listBtnDisable = true;
      if (vm.TCode == null) {
        vm.TCode = {
          TenantId: '',
          TenantNm: '',
        };
        vm.listBtnDisable = false;
        vm.AreaList = [];
      } else {
        vm.AreaList = [];
        vm.TypeList = [];
        vm.Stat1List = [];
        vm.TCode.TenantId = vm.TCode.TenantId;
        vm.TCode.TenantNm = vm.TCode.TenantNm;
        vm.data.TenantId = vm.TCode.TenantId;
        vm.TCode.mapCode = 'User.getTenantCodeList';
        postApi.select(
          vm.TCode,
          function (data) {
            if (data.header.status === CONSTANT.HttpStatus.OK) {
              if (data.body.docs[0].TenantId != '0') {
                vm.AreaList = data.body.docs[0].TenantArea.split(',');
              } else {
                vm.AreaList = [];
              }
              vm.listBtnDisable = false;
            } else {
              console.info('else ');
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error-getList', status, data);
          }
        );
      }
      
    }

    function onArmyAreaListSelected() {
      if (vm.ArmyAreaList == null) {
        vm.TCode.ArmyArea2 = '';
        vm.TypeList = [];
        vm.Stat1List = [];
      } else {
        vm.TCode.ArmyArea2 = vm.ArmyAreaList;
      }

      vm.TCode.mapCode = 'User.getArmyTypeList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs != null) {
              vm.TypeList = data.body.docs;
            } else {
              vm.TypeList = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function onArmyTypeListSelected() {
      if (vm.ArmyTypeList == null) {
        vm.TCode.ArmyType = '';
        vm.TCode.ArmyType_ = '';
      } else {
        vm.TCode.ArmyType = vm.ArmyTypeList.ArmyType;
        vm.TCode.ArmyType_ = vm.ArmyTypeList.ArmyType_;
      }

      vm.TCode.mapCode = 'User.getArmyAreaList';
      postApi.select(
        vm.TCode,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docs != null) {
              vm.Stat1List = data.body.docs;
              // console.info("vm.lists -", vm.lists);
            } else {
              vm.Stat1List = [];
            }
          } else {
            console.info('else ');
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        }
      );
    }

    function onPermStat1ListSelected() {
      if (vm.PermStat1List == null) {
        vm.TCode.PermStat1 = '';
        vm.TCode.PermStat1_ = '';
      } else {
        vm.TCode.PermStat1 = vm.PermStat1List.PermStat1;
        vm.TCode.PermStat1_ = vm.PermStat1List.PermStat1_;
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      getList();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    // 엑셀업로드 팝업
    function excelUpload() {
      var ctrl = 'UserExcelUploadModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalWindow.open(
        'lg',
        'components/modal/userExcelUpload/userExcelUpload-modal.html',
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (okData) {
          $state.go('app.system.user-list', { srch: vm.srch }, { reload: 'app.system.user-list' });
        },
        function (cancelData) {}
      );
    }

    // 목록 삭제
    function deleteList() {
      gConfirm(
        '',
        'Menu.DELETECONFIRM',
        {
          btn: '',
          fn: function () {
            deleteListAction();
          },
        },
        {
          btn: '',
          fn: function () {},
        }
      );
    }

    function deleteListAction() {
      vm.data.UserIds = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.data.UserIds.push(vm.lists[i].UserId);
        }
      }

      vm.dataloader = true;

      if (vm.data.UserIds == null || vm.data.UserIds.length == 0) {
        gAlert('', '선택된 게시물이 없습니다.');
        return false;
      }

      vm.data.mapCode = 'User.deleteUserDetail';
      postApi.update(
        vm.data,
        function (data) {
          vm.dataloader = false;
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                //$state.go("app.customer.counselappli-list");
                //GetList();
                //$state.reload();
                getList();
              },
            });
            //return;
          }
        },

        function (data) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error> userListCtrl> deleteListAction>', data.body.docs[0].errMessage);
        }
      );
    }

    /*getSelectListColumnList();*/
    // 데이터 조회
    init();
    getList();
    getTenantList();
  },
]);

(function() {
  ButtonsController.$inject = [];

  function ButtonsController() {}
  var buttons = {
    bindings: {},
    controller: ButtonsController,
    controllerAs: "buttons",
    templateUrl: "components/biz-component/buttons/buttons.html"
  };
  webapp.component("buttons", buttons);
})();

webapp.controller('LoginModalCtrl',
  ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window', '$filter',
  function LoginModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window, $filter) {
    
    var vm = this;
    var pageData = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope
    };
    
    // 확장 기능 개발 구간 종료
    /******************************************************************************** */

    vm.getInitDataExt = function() {
      // console.log("init Ap")
    };

    vm.findIdPwd = function(find){
      var ctrl = 'FindIdPwdModalCtrl as modalCtrl';
      var paramData = { find : find };
      var modalInstance = modalFactory.open('modal', 'components/modal/findIdPwd/findIdPwd-modal.html', ctrl, paramData);
    }

    // 확장 기능 개발 구간 밑에서 정의해주세요.
    var ap = new ap();
    ap.setData(pageData);
    ap.init();

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel data');
    }

    vm.ok = function(item) {
      $uibModalInstance.close(item);
    }
  } 
]);

webapp.controller('SecondAuthenticationModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'LoginAPISrv',
  'gAlert',
  '$cookies',
  '$rootScope',
  '$state',
  function SecondAuthenticationModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    api,
    gAlert,
    $cookies,
    $rootScope,
    $state
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.sendSms = sendSms;

    var saveId = $cookies.get('mySavedId');

    if (saveId != undefined && saveId != '') {
      vm.user = {
        loginId: saveId,
        saveId: '1',
      };
    }

    (function DownloadReasonModalCtrl() {
      vm.SecondNumber = '';
      //console.log("toModalData", toModalData);
      //console.log("toModalData.responseVO.body.docs[0].mobile", toModalData.responseVO.body.docs[0].mobile);
      vm.user = {};
      vm.user.SecondUserId = toModalData.responseVO.body.docs[0].userId;
      vm.user.SecondIP = $window.sessionStorage['loginIP'];
      vm.user.SecondMobile = toModalData.responseVO.body.docs[0].mobile;
      vm.user.TenantId = toModalData.responseVO.body.docs[0].TenantId;
      vm.buttonDisabled = false;
    })();

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok() {
      if (
        typeof vm.SecondNumber == 'undefined' ||
        vm.SecondNumber == '' ||
        vm.SecondNumber.length != 6
      ) {
        gAlert('', '인증번호를 6자 입력하세요.');
        return false;
      }

      vm.parm = {};
      vm.parm.SecondNumber = vm.SecondNumber;
      vm.parm.SecondUserId = vm.user.SecondUserId;
      vm.parm.SecondAuthenticationId = vm.user.SecondAuthenticationId;

      var prms = api.doCheckSecondAuthenticationNumber().post(vm.parm).$promise;

      prms.then(
        function (json) {
          if (
            json.responseVO &&
            json.responseVO.body.docCnt > 0 &&
            json.responseVO.body.docs != null
          ) {
            if (json.responseVO.body.docs[0].message == '인증 되었습니다.') {
              $uibModalInstance.close(vm.SecondNumber);

              setUserSession(vm, toModalData.responseVO.body.docs[0]);

              if (
                toModalData.responseVO.body.docs[0].userType != '020' &&
                !checkPasswordUpdateDate(
                  toModalData.responseVO.body.docs[0].lastPWUpdateDate
                )
              ) {
                $state.go('updatepass');
              } else {
                $state.go('app.dashboard');
              }
            } else {
              gAlert('', '인증번호를 확인하세요.');
            }
          } else {
            gAlert('', '인증번호를 확인하세요.');
          }
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    function sendSms() {
      vm.user.SecondNumber = generateRandom(100000, 999999);
      var prms = api.doInsertSecondAuthentication().post(vm.user).$promise;

      prms.then(
        function (json) {
          if (
            json.responseVO &&
            json.responseVO.body.docCnt > 0 &&
            json.responseVO.body.docs != null
          ) {
            //console.log("json", json);
            if (
              json.responseVO.body.docs[0].errMessage ==
              '인증횟수가 초과되었습니다.'
            ) {
              //gAlert('', '해당 아이디는 인증번호5회 이상 시도되어 2시간동안 로그인이 제한되었습니다.');
              gAlert('', '해당 아이디는 인증번호가 이미 발송되었습니다.');
            } else if (
              json.responseVO.body.docs[0].errMessage ==
              '문자 발송에 실패 했습니다.'
            ) {
              gAlert('', '문자 발송에 실패 했습니다.');
            } else if (json.responseVO.body.docs[0].result == 'FAIL') {
              //countdown("countdown", 2, 59);
              gAlert('', '인증번호가 발송되었습니다.(2)');
              vm.buttonDisabled = true;
            } else if (json.responseVO.body.docs[0].result == 'SUCCESS') {
              vm.user.SecondAuthenticationId =
                json.responseVO.body.docs[0].SecondAuthenticationId;
              //countdown("countdown", 2, 59);
              gAlert('', '인증번호가 발송되었습니다.');
              vm.buttonDisabled = true;
            } else {
              gAlert('', '문자 발송에 실패 했습니다.');
            }
          } else {
            gAlert('', '문자 발송에 실패 했습니다.');
          }
        },
        function (error) {
          gAlert('', '문자 발송에 실패 했습니다.');
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    // 타이머
    function countdown(elementName, minutes, seconds) {
      var element, endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? '0' + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          element.innerHTML = 'Time over!';
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          //element.innerHTML = (hours ? hours + ':' + twoDigits(mins) : mins) + ':' + twoDigits(time.getUTCSeconds());
          //setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
      }

      element = document.getElementById(elementName);
      endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
      //updateTimer();
    }

    function setUserSession(vm, json) {
      if (vm.user.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(
          now.getFullYear() + 1,
          now.getMonth(),
          now.getDate()
        );
        $cookies.put('mySavedId', vm.user.loginId, { expires: cookieExp });
      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json);
    }

    function checkPasswordUpdateDate(lastPWUpdateDate) {
      var da1 = new Date(lastPWUpdateDate);
      var da2 = new Date();

      //alert(lastPWUpdateDate + ' | ' + da1 + " | " + da2 );

      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30; // 월 만듬
      var cYear = cMonth * 12; // 년 만듬

      //alert(dif/cMonth);

      if (dif / cMonth > 3) {
        return false;
      }

      return true;
    }

    // 시큐어코딩으로 주석 후 수정 (2023-07-06 )
    // 랜덤 숫자 생성
    // var generateRandom = function (min, max) {
    //   var ranNum = Math.floor(Math.random() * (max - min + 1)) + min;
    //   return ranNum;
    // };

    var generateRandom = function (min, max) {
      var array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      var scale = max - min + 1;
      return Math.floor((array[0] / (Math.pow(2, 32)) * scale) + min);
  };
  

  },
]);

webapp.controller('AddPhotoCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function AddPhotoCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {
      var vm = this;
      vm.data = {};
      vm.uploadFileList = [];
      vm.showUploader = true;
      var vaultExt = 'jpg, gif, png';
      vm.showUploader = enableUploadComponent();
      vm.title = toModalData.title;
      vm.id = toModalData.id;
      initVaultComponent(vm.id, toModalData.imageCallback, null, vaultExt);
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var data = {};
        data.activityNm = vm.data.activityNm;
        if(isNullOrEmpty(data.activityNm)){
          $('#activityNm').focus();
          $('#activityNm').css('border', '1px solid #f00');
          $('#activityNm').attr('placeholder', vm.title+'명을 입력해주세요.');
          return;
        }
        $uibModalInstance.close(data);
        
      }

      vm.cancel = cancel;
      vm.ok = ok;
}]);

webapp.controller('imageModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function imageModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {

        var vm = this;
        $scope.link = toModalData;

        function cancel() {
            $uibModalInstance.dismiss('cancel data');
        }

        vm.cancel = cancel;
    }
]);
webapp.controller('DownLoadApk', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', '$timeout',
  function DownLoadApk($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, $timeout) {
    var vm = this;


    function download() {
      window.location.href = "/assets/salevisCare.apk";
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 함수 정의
    vm.cancel = cancel;
    vm.download = download;

  }]);
webapp.controller('ApprovalModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', '$filter', 'gAlert', 'modalFactory',
    function ApprovalModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, $filter, gAlert, modalFactory ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.data = {};
      vm.title = toModalData.title;

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.data);
      }

    } ]);

webapp.controller('BranchModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state',
    function BranchModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10,
        Ceo :'',
      };

      vm.selectedTenantId = toModalData.TenantId;
      vm.selectedBranchId = toModalData.BranchId;
      if (toModalData.showBaseTenant == undefined || toModalData.showBaseTenant == null) {
        vm.showBaseTenant = 'Y';
      } else if(toModalData.showBaseTenant != undefined && toModalData.showBaseTenant != '') {
        if(!toModalData.showBaseTenant) vm.showBaseTenant = 'N';
        else vm.showBaseTenant = 'Y';
      } else if (!toModalData.showBaseTenant) {
        vm.showBaseTenant = 'N';
      } else {
        vm.showBaseTenant = 'Y';
      }

      (function BranchModalCtrl() {
        getList();
      })();
      function getList() {

        var data = {
          mapCode: 'organizationMng.getOrganizationList',
          userkey : '',
          Depth : 1,
          page : vm.srch.page,
        };

        if($window.sessionStorage['loginTenantId'] != null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){

          getCnt(true);
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        } 
      }

      function getCnt(checkSession) {
        var data = {
          mapCode: 'organizationMng.getOrganizationListCnt',
          Depth : 1,
        };

        if(checkSession) {
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        } 
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('ContentsModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$sce',
    function ContentsModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $sce ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      if(!isNullOrEmpty(toModalData.VideoLink)){
        vm.VideoLink = $sce.trustAsResourceUrl(toModalData.VideoLink.replace("watch?v=","embed/") + "?rel=0");
      }
      vm.Contents = toModalData.Contents;
      vm.Title = toModalData.Title;
      vm.AgreeYN = toModalData.AgreeYN;
      vm.RejectYN = toModalData.RejectYN;
      vm.AgreeCn = toModalData.AgreeCn;
      vm.TelNo = autoHypenTel(toModalData.TelNo);


      (function ContentsModalCtrl() {

      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

    } ]);

webapp.controller('CtiCallModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state', 'gConfirm', 'gAlert',
    function CtiCallModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state, gConfirm, gAlert) {
      var vm = this;
      vm.cancel = cancel;
      vm.data  = {}
      vm.ok = ok;
      vm.CtiHistId = null;
      vm.showBtnWrap = false;

      function init() {
        vm.data = toModalData.data;
        var num = vm.data.SendNum;
        if(num) {
          if(num.indexOf("010") == 0 || num.indexOf("011") == 0 || num.indexOf("016") == 0 || num.indexOf("017") == 0 || num.indexOf("018") == 0 || num.indexOf("019") == 0) {
            vm.data.SendNum = formatMobile(vm.data.SendNum);
          } else {
            vm.data.SendNum = formatPhone(vm.data.SendNum);
          }
        }

        var data = angular.copy(vm.data);
        if( !isNullOrEmpty(vm.data.KeyId) && isNullOrEmpty(vm.data.BranchId)) {
          data.newBranchCust = "Y";
          data.CustId = vm.data.KeyId;
        } else {
          data.newBranchCust = "N";
        }
        
        if(data.WebUptYn == "Y") {
          data.mapCode = "CtiHist.insertCtihist";
          postApi.insert(data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.showBtnWrap = true;
              vm.data.CtiCallHistoryId = result.body.docs[0].RelateDataId;
            }
          })
        } else {
          vm.showBtnWrap = true;
        }
      }
    
      function goToPage(mode) {

        if(mode == "VIEW_PAGE_DETAIL") {
          $window.sessionStorage.setItem("goToCustomerAtTab", "");
          $state.go('app.customer.customer-detail', {KeyId : vm.data.KeyId}, { reload: true });
          vm.cancel();
        } else if(mode == "VIEW_PAGE_COUNSEL") {
          var param = { tab : "VIEW_PAGE_COUNSEL", idx : 1 };
          $window.sessionStorage.setItem("goToCustomerAtTab", JSON.stringify(param));
          $state.go('app.customer.customer-detail', {KeyId : vm.data.KeyId}, { reload: true });
          vm.cancel();
        } else if(mode == "CTI") {
          $window.sessionStorage.setItem("goToCustomerAtTab", "");
          $state.go('app.customer.cti-list', {srch : ""}, { reload: true });
          vm.cancel();
        } else if(mode == "VIEW_PAGE_EDIT") {
          $window.sessionStorage.setItem("goToCustomerAtTab", JSON.stringify(vm.data));
          $state.go('app.customer.customer-edit', {}, { reload: true });
          vm.cancel();
        }
      }

      function setExceptYN() {
        gConfirm("", "제외한 번호는 CTI리스트에 생성되지 않습니다. 제외하시겠습니까?",{
          btn : '',
          fn : function() {
          
            var data = angular.copy(vm.data);
            data.ExceptYN = "Y"
            data.mapCode = "CtiHist.seExceptYN"
            postApi.update(data, function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.showBtnWrap = true;
                vm.data.CtiCallHistoryId = result.body.docs[0].RelateDataId;
                
                gAlert('', "CTI리스트에서 제외되었습니다.", {
                  btn : '',
                  fn : function() {
                    vm.cancel();
                  }
                });
              }
            })

          }
        }, {
          btn : '',
          fn : function() {
          
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      init();

      vm.goToPage = goToPage;
      vm.setExceptYN = setExceptYN;

    } ]);

webapp.controller('UploadExcelUserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function UploadExcelUserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function TenantModalCtrl() {
        getList();
      })();

      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          userkey : '',
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){
          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        }

      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('KakaomapConfigModalCtrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', '$timeout', '$translate',
  function KakaomapConfigModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, $timeout, $translate) {
    var vm = this;

    (function KakaomapConfigModalCtrl() {
      console.log('toModalData.address', toModalData.address);

      var geocoder = new kakao.maps.services.Geocoder();
      geocoder.addressSearch(toModalData.address, function (result, status) {
        // 정상적으로 검색이 완료됐으면
        var container = document.getElementById('map_canvas');
        var options = { //지도를 생성할 때 필요한 기본 옵션
          center: new kakao.maps.LatLng(0, 0), //지도의 중심좌표.
          level: 3 //지도의 레벨(확대, 축소 정도)
        };
        var map = new kakao.maps.Map(container, options);

        if (status === kakao.maps.services.Status.OK) {
          var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
    
          // 결과값으로 받은 위치를 마커로 표시합니다
          var marker = new kakao.maps.Marker({
            map: map,
            position: coords,
          });

          var arg = toModalData.name + ',' + result[0].y + ',' + result[0].x;
    
          // 인포윈도우로 장소에 대한 설명을 표시합니다
          var infowindow = new kakao.maps.InfoWindow({
            content: '<div style="width:150px;text-align:center;padding:6px 0;">' + toModalData.name + '<br><a href="https://map.kakao.com/link/map/' + arg + '" style="color:blue" target="_blank">큰지도보기</a> | <a href="https://map.kakao.com/link/to/' + arg + '" style="color:blue" target="_blank">길찾기</a></div>'
          });
          infowindow.open(map, marker);
    
          // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
          map.setCenter(coords);
        } else {
          console.log("[" + toModalData.address + "]\r\nKakao Map에서 찾을 수 없는 주소입니다.");
          navigator.geolocation.getCurrentPosition(locationLoadSuccess,locationLoadError);
        }

        function locationLoadSuccess(pos){
          // 현재 위치 받아오기
          var currentPos = new kakao.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      
          // 지도 이동(기존 위치와 가깝다면 부드럽게 이동)
          map.panTo(currentPos);
        }
      
        function locationLoadError(pos){
          alert('위치 정보를 가져오는데 실패했습니다.');
        }        
      });      
    })();

    // 위치 가져오기 버튼 클릭시
    function getCurrentPosBtn(){
      navigator.geolocation.getCurrentPosition(locationLoadSuccess, locationLoadError);
    }

    vm.ok = function() {
      $uibModalInstance.close();
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel data');
    };

  }]);
webapp.controller('FindIdPwdModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert',
    function FindIdPwdModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert ) {
      var vm = this;
      vm.success = false;
      vm.type = toModalData.type;
      console.warn(toModalData.type);
      vm.findType = "Phone";
      vm.disabled1 = "1";
      vm.disabled2 = "1";
      vm.LoginId = "";
      vm.dataloader = false;
      vm.data = {};

      (function FindIdPwdModalCtrl() {
      })();


      /* 인증번호 발송 버튼 */
      function auth() {
        if (!getIsValidData()) return;

        vm.dataloader = true;

        var data = {
          UserNm: vm.UserNm,                             // 이름
          LoginId: vm.type == 'IU' ? '' : vm.LoginId,    // 로그인 ID
          Type: vm.type,
          FindType: vm.findType,
          mapCode: 'findIdPwd'
        };

        if (vm.findType == "Email") {
          data.Email = vm.Email;                               // 이메일
        } else {
          data.Mobile = vm.Mobile;   
        }

        postApi.login(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              gAlert('', '인증번호를 발송했습니다.\n인증번호가 오지 않으면 입력하신 정보가 회원정보와 일치하는지 확인해 주세요.');

              if (vm.findType == "Email") {
                vm.disabled2 = "0";
              }
              else {
                vm.disabled1 = "0";
              }

              vm.dataloader = false;
            } else {
              gAlert('', 'Menu.SYSTEMALARM');
            }
          } else {
            gAlert('', result.body.docs[0].errMessage);

            vm.dataloader = false;
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> findIdPwd-modal-ctrl> auth()', status, error);

          vm.dataloader = false;
        });
      }


      /* 다음 버튼 */
      function submit() {
        if (!getIsValidData()) return;

        if (vm.findType == 'Phone') {
          if (vm.disabled1 == "1") {
            gAlert('', '휴대폰번호를 인증요청 해주세요.');
            return;
          }
        }
    
        if (vm.findType == 'Email') {
          if (vm.disabled2 == "1") {
            gAlert('', '이메일주소를 인증요청 해주세요.');
            return;
          }
        }

        if (vm.type == "IU") {
          var loginData = {
            LoginId: vm.LoginId,
            Email: vm.Email, 
            FindType: vm.findType, 
            Type: vm.type, 
            CertificationNum: vm.CertificationNum2,
            mapCode: 'selectIdPassFindCertification'
          };

          if (vm.findType == 'Email') {
            loginData.CertificationNum = vm.CertificationNum2;
            loginData.Email = vm.Email;
          } else {
            loginData.CertificationNum = vm.CertificationNum1;
            loginData.Mobile = vm.Mobile;
          }

          postApi.login(loginData, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.success = true;
                vm.data.LoginId = result.body.docs[0].LoginId;
              } else {
                gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
                return;
              }
            } else {
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function(error) {
            console.log("error");
            // console.error('Error> findIdPwd-modal-ctrl> submit()', status, error);
          });
        }
        else {
          vm.success = true;
        }
      }


      /* 확인 버튼 */
      function submit2() {
        if (!getIsValidData()) return;

        loginData = { 
          LoginId: vm.LoginId, 
          Password: vm.data.Password, 
          CertificationNum: vm.data.CertificationNum,
          Type: vm.type,
          TableType: 'users',
          mapCode: 'updatePassword'
        };

        postApi.login(loginData, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              if (vm.data.result == 0) {
                gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
                return;
              }
              else {
                gAlert('', '수정 되었습니다.');
                $uibModalInstance.dismiss('cancel data');
              }
            }
            else {
              gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
              return;
            }
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> findIdPwd-modal-ctrl> submit2()', status, error);
        });
      }


      /* 닫기 버튼 */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }


      /* 핸드폰번호 정규식 검사 */
      function getIsValidMobile() {
        var reg = /^[0-9-]{10,11}$/g;

        if (!reg.test(vm.Mobile)) return false;

        return true;
      }


      /* 이메일 정규식 검사 */
      function getIsValidEmail() {
        var reg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

        if (!reg.test(vm.Email)) return false;

        return true;
      }


      /* 비밀번호 정규식 검사 */
      function getIsValidPassword() {
        var reg = /^(?=.*[a-zA-Z0-9])(?=.*[a-zA-Z!`~@#$%^&*()_=+{}|?<>,./\-])(?=.*[a-z0-9!`~@#$%^&*()_=+{}|?<>,./\-])(?=.*[A-Z0-9!`~@#$%^&*()_=+{}|?<>,./\-]).{8,}$/g; // 대문자, 소문자, 숫자, 특수문자 중 2개조합 8자리이상

        if (!reg.test(vm.data.Password)) return false;
        if (vm.data.Password.length < 8) return false;

        return true;
      }


      /* Validation Check */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.UserNm)) {
          errMsg = errMsg + '- 이름을 입력하세요.<br/>';
        }

        /* 아이디 찾기 */
        if (vm.type == "IU") {
          /* 휴대폰번호로 찾기 */
          if (vm.findType == "Phone") {
            if (isNullOrEmpty(vm.Mobile)) {
              errMsg = errMsg + '- 휴대폰번호를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Mobile)) { 
              if (!getIsValidMobile()) {
                errMsg = errMsg + '- 휴대폰번호 형식을 확인해 주세요.<br/>ex) 01012345678<br/>';
              }
            }
          }
          /* 이메일로 찾기 */
          else {
            if (isNullOrEmpty(vm.Email)) {
              errMsg = errMsg + '- 이메일주소를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Email)) { 
              if (!getIsValidEmail()) {
                errMsg = errMsg + '- 이메일 형식을 확인해 주세요.<br/>ex) sample@sample.co.kr<br/>';
              }
            }
          }
        }
        /* 비밀번호 찾기 */
        else {
          if (isNullOrEmpty(vm.LoginId)) {
            errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
          }

          /* 휴대폰번호로 찾기 */
          if (vm.findType == "Phone") {
            if (isNullOrEmpty(vm.Mobile)) {
              errMsg = errMsg + '- 휴대폰번호를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Mobile)) { 
              if (!getIsValidMobile()) {
                errMsg = errMsg + '- 휴대폰번호 형식을 확인해 주세요.<br/>ex) 01012345678<br/>';
              }
            }
          }
          /* 이메일로 찾기 */
          else {
            if (isNullOrEmpty(vm.Email)) {
              errMsg = errMsg + '- 이메일주소를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Email)) { 
              if (!getIsValidEmail()) {
                errMsg = errMsg + '- 이메일 형식을 확인해 주세요.<br/>ex) sample@sample.co.kr<br/>';
              }
            }
          }

          /* 비밀번호 변경시 */
          if (vm.success) {
            if (isNullOrEmpty(vm.data.CertificationNum)) {
              errMsg = errMsg + '- 인증번호를 입력하세요.<br/>';
            }

            if (isNullOrEmpty(vm.data.Password)) {
              errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
            }
    
            if (vm.data.Password != vm.data.RePassword) {
              errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
            }
    
            if (!isNullOrEmpty(vm.data.Password)) { 
              if (!getIsValidPassword()) {
                errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>ex) 대문자, 소문자, 숫자, 특수문자 중 2개조합 8자리이상.<br/>';
              }
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true; 
      }

      function chkPassId(str) {
        if(str == 'PWD') {
          var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
  
          if(!reg.test(vm.data.Password)) return false;
          if(vm.data.Password.length < 8) return false;
  
          return true;
        
        }
      }


      /* 휴대폰번호로 찾기, 이메일로 찾기 Change */
      $scope.changeFindType = function(findType) {
        vm.findType = findType;
      };


      vm.submit = submit;
      vm.submit2 = submit2;
      vm.cancel = cancel;
      vm.auth = auth;
      vm.chkPassId = chkPassId;

    } ]);

webapp.controller('FormModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function FormModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getFormList = getFormList;
      vm.columnMap = {};

      (function FormModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.FormType = toModalData.formType;
        vm.FormList = [];
        getFormList();
      })();

      function changeViewSize() {
        getFormList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getFormList() {
        getFormListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'form';
        data.mapCode = 'Campaign2.getFormList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.FormList = result.body.docs;
            } else {
              vm.FormList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function getFormListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'Campaign2.getFormListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(Form) {
        $uibModalInstance.close(Form);
//        gConfirm('', '작성된 내용이 있을경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
//          btn: '',
//          fn: function () {
//            $uibModalInstance.close(Form);
//          }
//        }, {
//          btn: '',
//          fn: function () {
//            cancel();
//          }
//        });
      }

    } ]);

/**
 * 캠페인 발송용 대상자 추가/변경.
 * - 고객 추가시에 DB에 바로 추가하지 않고. List에 가지고 있다가 저장할때 일괄 적용할것.
 */
webapp.controller('GroupEditModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function GroupEditModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.data = toModalData;
    vm.originData = angular.copy(vm.data);

    // 필수항목 체크
    function getIsValidData() {
      var errMsg = '';
      if(isNullOrEmpty(vm.data.CustNm)) {
        //errMsg = errMsg + '- 이름을 입력해 주세요.<br/>';
        vm.data.CustNm = '';
      }
      
      if(vm.data.SendType == "SMS"){
        if(isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 핸드폰 정보를 입력해 주세요.<br/>';
        }
      }
      
      if(vm.data.SendType == "EMAIL"){
        if(isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일 정보를 입력해 주세요.<br/>';
        }
      }
      
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
      return true;
    }

    // 저장
    function setData() {
      if (getIsValidData() == false) {
        return;
      }

      // 신규 추가의 경우 발송대기 상태
      if(isNullOrEmpty(vm.data.RespStatus)){
        vm.data.RespStatus = "N";
        vm.data.RespStatusConv = "발송대기";
      }else{
        // 발송대기가 아니면서 휴대폰이나 이메일이 변경된 경우 발송대기로 변경하여 재발송 대상이 되게 한다.
        if(vm.data.RespStatus != "N" &&
            ((vm.data.SendType == "SMS" && vm.data.Mobile != vm.originData.Mobile) 
                || (vm.data.SendType == "EMAIL" && vm.data.Email != vm.originData.Email))
        ) {
            vm.data.RespStatus = "N";
            vm.data.RespStatusConv = "발송대기";
        }
      }

      setInsertUpdateDetail();
    }

    // 저장 후 처리
    function setInsertUpdateDetail() {
      $uibModalInstance.close(vm.data);
    }

    // 닫기
    function cancel() {
      $uibModalInstance.close();
    }

    // 함수 정의
    vm.setData = setData;    // 데이터 저장
    vm.cancel = cancel;  // 닫기
  }, ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsCustSendModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsCustSendModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '',
          //CmpgnImplId : '',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      
      (function SmsCustSendModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getCustomerDetailSms';
        
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.data.CustIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.data.CustIdList.length;
        }
      };
      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getCustomerDetailSmsCnt';
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }
      
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          item.SendTitle = data.SendTitle;
          item.SendMessage = data.SendMessage;
          item.SendMessage2 = data.SendMessage2;
        });
        
        postApi.insert(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }
        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }

      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getTenantInfo()");
          // console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationGxModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationGxModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationGxModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationGXCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;

        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationGXCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;

        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });

        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }

        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }
        
        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까??', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getTenantInfo()");
          // console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationItemModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationItemModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationItemModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationItemCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;

        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationItemCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        // console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.ItemFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.ItemFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getTenantInfo()");
          // console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationLockerModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationLockerModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationLockerModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationLockerCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationLockerCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        // console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.LockerFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.LockerFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getTenantInfo()");
          // console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationMembershipModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationMembershipModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();

      (function SmsExpirationMembershipModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationMembershipCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationMembershipCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            // console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;

        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.log("error");
          // console.error("Error> getSendNumberList()");
          // console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getTenantInfo()");
          // console.table(error);
        });
      }

    } ]);

webapp.controller('SrchCustModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'gAlert', 'gConfirm', 'postApi', '$rootScope', 'modalFactory',
    function SrchCustModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, gAlert, gConfirm, postApi, $rootScope, modalFactory) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.columnMap = {};
     
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.srchcustomer'; // 그룹고객 작업 테이블명
      var LIST_SQL = 'Campaign2.getSrchCustomerList';
      var LIST_CNT_SQL = 'Campaign2.getSrchCustomerListCnt';
      var ADD_GRPCUST_SQL = 'Campaign2.insertGroupcustomer';
      var ADD_ALL_GRPCUST_SQL = 'Campaign2.insertGroupcustomerSrchAll';

      var MEMBERSHIP_LIST_SQL = 'MembershipPayment.getMmgmembershippaymentCodeList';
      var USER_LIST_SQL = 'User.getSelectCodeUsers';
  
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };
  
      vm.currentPage = vm.srch.page;

      (function SrchCustModalCtrl() {
        vm.GrpId = toModalData.GrpId;

        vm.mcl = [];
        vm.manageList = [];

        getList();
        getMembershipList();
        getUserList();
        setInitData();
      })();


      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.GrpId = vm.GrpId;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL;
        data.GrpId = vm.GrpId;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0];
          }
        });
      }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }
    
    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    /* 사용자검색 */
    function srchUserModal() {

      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ManagerNm = res.UserNm;
        vm.srch.ManagerId = res.UserId;
      }, function(cancelData) {
        //
      });
    }
    
    /* 사용자검색- 지우기 */
    function eraseUser() {
      vm.srch.ManagerNm = '';
      vm.srch.ManagerId = '';
    }

    /**
     * 초기 데이터 설정
     * @param
     * @return
     */
    function setInitData() {
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };

    }

      /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getList();
    }
    
    
    function addGrpcust(_type) {
      var data = angular.copy(vm.srch);

      data.GrpId = vm.GrpId;
      data.srchTenantId = $rootScope.gVariable.srchTenantId; 
      // console.log('type', _type == 'ALL');
      if(_type == 'ALL'){
        data.mapCode = ADD_ALL_GRPCUST_SQL;
      }else{
        data.mapCode = ADD_GRPCUST_SQL;
        data.lists = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            data.lists.push(vm.lists[i].KeyId);
          }
        }
      }

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              ok();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.log("error");
        // console.error("Error> addGrpcust()");
        // console.table(error);
      });
    }
    /* var list = [];
    function getMembershipList() {
      var data = vm.srch;
      data.mapCode = MEMBERSHIP_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            list = result.body.docs;
            angular.forEach(list , function (item){
              row = {};
              row.CodeValue = item.CodeValue;

              vm.mcl.push(row);
            });
            console.log('vm.mcl', vm.mcl);
          } 
        } else {
          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    } */
    
    function getMembershipList() {
      vm.mcl = [];
      var data = vm.srch;
      data.mapCode = MEMBERSHIP_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            angular.forEach(result.body.docs , function (item){
              vm.mcl.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          } 
        } else {
          console.log("error");
          // console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error> getData()");
        console.table(error);
      });
    }

    function getUserList() {
      vm.manageList = [];
      var data = vm.srch;
      data.mapCode = USER_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            angular.forEach(result.body.docs , function (item){
              vm.manageList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          } 
        } else {
          console.log("error");
          // console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.log("error");
        // console.error("Error> getData()");
        // console.table(error);
      });
    }

    function setResetSearch() {
      vm.srch = '';
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };
      getList();
    }

    vm.pageChanged = pageChanged;
    vm.srchUserModal = srchUserModal;
    vm.eraseUser = eraseUser;
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
    vm.setPageChanged = setPageChanged;
    vm.setChangeViewSize = setChangeViewSize;
    vm.addGrpcust = addGrpcust;

    vm.getMembershipList = getMembershipList;
    vm.getUserList = getUserList;

    vm.setResetSearch = setResetSearch;
  } ]);

webapp.controller('SrchCustModal2Ctrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$rootScope', 'modalFactory', '$mdUtil', '$stateParams','$http', 'gAlert', 'gConfirm',
    function SrchCustModal2Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $rootScope, modalFactory, $mdUtil,$stateParams,$http, gAlert, gConfirm) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxGrpId = 0;
      vm.lists = [];
      vm.saveYn = true;
      vm.data = {
        'GrpId': (toModalData.GrpId == undefined ? '' : toModalData.GrpId)
        ,'GrpCustList' : (toModalData.GrpCustList == undefined ? [] : toModalData.GrpCustList)
      };

      vm.grpcustLists = vm.data.GrpCustList;
      vm.totalItems = vm.grpcustLists.length;

      var o = {
          breakpoints : ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]
         ,type : []
         ,style : []
       }

       var columns = [{name: "CustNm", title: "회원명"},{name: "Mobile", title: "핸드폰"},{name: "Email", title: "이메일"}];
       vm.grpcustListColumns = [{ColumnPhysicalNm: "CustNm", ColumnLogicalNm: "회원명"},{ColumnPhysicalNm: "Mobile", ColumnLogicalNm: "핸드폰"},{ColumnPhysicalNm: "Email", ColumnLogicalNm: "이메일"}];

       vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
       vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');

      // 함수 선언
      vm.resetList = resetList;
      vm.deleteGrpcust = deleteGrpcust;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.cancel = cancel;
      vm.ok = ok;

      // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
      // 관련 테이블 정의
      var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
      var EXCEL_FORM_TITLE = '일괄업로드 양식';

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 10, // 페이지당 조회건수
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustNm' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.currentPage = 1;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.anchor = "";
      angular.copy(vm.srch, vm.srchList);

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * TODO : 전제 목록을 넘겨줘야. 삭제된것을 처리할수 있다.
       */
      function ok() {
        var chkList = [];
        angular.forEach(vm.viewList, function(item){
          if (item.chkRow) {
            chkList.push(item);
          }
        });
        //if(chkList.length > 0) gAlert('', '체크한 대상자에게만 발송됩니다.');

        $uibModalInstance.close({
          'list' : vm.grpcustLists,
          //'chkList' : chkList
        });
      }


      /**
       * 고객 삭제
       *
       * @param
       * @return
       */
      function deleteGrpcust(type) {
        gConfirm('', '발송 대상에서 제외하시겠습니까?', {
          btn : '',
          fn : function() {
            deleteGrpcustAction(type);
          }
        }, {
          btn : '',
          fn : function() {
            //ignore
          }
        });
      }

      /**
       * 고객 삭제 처리
       */
      function deleteGrpcustAction(type) {
        //삭제데이터
        vm.delData = [];

        if (type == "") {
          angular.forEach(vm.viewList, function(item){
            if (item.chkRow) {
              vm.delData.push(item);
            }
          });

          angular.forEach(vm.delData, function(item){
            vm.grpcustLists.splice(vm.grpcustLists.indexOf(item),1);
          });

        } else if (type == "ALL") {
          vm.grpcustLists = [];
        }

        setChangeViewSize();
      }

      /**
       * 그룹고객 목록 화면 구성
       *
       * 전체 / 대상자
       * if(!(item.RespStatus == "R" || item.RespStatus == "D")){
       *
       * @param
       * @return
       */
      function getGrpcustList() {
        vm.totalItems = vm.grpcustLists.length;

        var startNum = ((vm.currentPage - 1) * vm.viewSize);
        var endNum = (vm.currentPage * vm.viewSize);

        vm.viewList = [];
        for(var i = 0; i < vm.grpcustLists.length; i++){
          if(i >= startNum && i < endNum){
            vm.viewList.push(vm.grpcustLists[i]);
          }
        }

      }

      /**
       * 그룹고객 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        getGrpcustList();
      }

      /**
       * 그룹고객 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.chkHead = false;
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize =  CONSTANT.PAGINATION.VIEWSIZE; // 목록 당 조회 건수

        // 데이터 조회
        getGrpcustList();
      }

      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.viewList.length; i++) {
          if (!vm.viewList[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.viewList.length; i++) {
          vm.viewList[i].chkRow = vm.chkHead;
        }
      };

      function resetList() {
        getTreeList();
      }

      /**
       * 고객추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.GroupCustEditModal = function (_idx) {
        vm.editIdx = null;
        var ctrl;
        var paramData = {};
        var modalInstance;

        if (_idx != undefined){
          vm.editIdx = _idx;
          paramData = angular.copy(vm.viewList[vm.editIdx]);
        }
        paramData.SendType = vm.data.SendType;
       
        ctrl = 'GroupEditModalCtrl as vc';
        modalInstance = modalFactory.open("md", "components/modal/message/group-edit-modal.html", ctrl, paramData);
        
        modalInstance.result.then(
          function (okData) {
            if (okData) {
              if (vm.editIdx != undefined) {
                vm.viewList[vm.editIdx] = okData;
                vm.grpcustLists[((vm.currentPage - 1) * vm.viewSize) + vm.editIdx] = okData;
              } else {
                vm.grpcustLists.unshift(okData);
                getGrpcustList();
              }
            }
          },
          function (cancelData) {
            //ignore
          }
        );
      };
      getGrpcustList();
    } ]);

webapp.controller('SrchCustModal3Ctrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$rootScope', 'modalFactory', '$mdUtil', '$stateParams','$http', 'gAlert', 'gConfirm',
    function SrchCustModal3Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $rootScope, modalFactory, $mdUtil,$stateParams,$http, gAlert, gConfirm) {
      var vm = this;
      vm.dataloader = false;

      var LIST_SQL = 'Campaign2.getCampaignCustomers';
      var LIST_CNT_SQL = 'Campaign2.getCampaignCustomersCnt';

      //var columns = [{name: "CustNm", title: "회원명"},{name: "CustCode", title: "회원코드"}, {name: "Mobile", title: "핸드폰"},{name: "Email", title: "이메일"}];
      //vm.grpcustListColumns = [{ColumnPhysicalNm: "CustNm", ColumnLogicalNm: "회원명"},{ColumnPhysicalNm: "CustCode", ColumnLogicalNm: "회원코드"}, {ColumnPhysicalNm: "Mobile", ColumnLogicalNm: "핸드폰"},{ColumnPhysicalNm: "Email", ColumnLogicalNm: "이메일"}];


      // 함수 선언
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.cancel = cancel;

      // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.customer.modal'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CmpgnCustId'; // Primary Key Column

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustNm' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.currentPage = 1;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.anchor = "";
      angular.copy(vm.srch, vm.srchList);

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 그룹고객 목록 화면 구성
       *
       * 전체 / 대상자
       * if(!(item.RespStatus == "R" || item.RespStatus == "D")){
       *
       * @param
       * @return
       */
      /* function getGrpcustList() {
        vm.totalItems = vm.grpcustLists.length;

        var startNum = ((vm.currentPage - 1) * vm.viewSize);
        var endNum = (vm.currentPage * vm.viewSize);

        vm.viewList = [];
        for(var i = 0; i < vm.grpcustLists.length; i++){
          if(i >= startNum && i < endNum){
            vm.viewList.push(vm.grpcustLists[i]);
          }
        }
      } */

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID        
        data.keyId = toModalData.keyId;
        if (toModalData.ResultCode == 'Etc') {
          data.ResultCodeEtc = toModalData.ResultCode;
        } else {
          data.ResultCode = toModalData.ResultCode;
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getListCnt()");
          // console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.keyId = toModalData.keyId;
        if (toModalData.ResultCode == 'Etc') {
          data.ResultCodeEtc = toModalData.ResultCode;
        } else {
          data.ResultCode = toModalData.ResultCode;
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.log("error");
              // console.error('Error> getList()> MetaColumn 정보 조회 오류');
              // console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.log("error");
          // console.error("Error> getList()");
          // console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }
      vm.getList = getList;
      vm.setSortColumn = setSortColumn;
      vm.setSortDirect = setSortDirect;

      getList();
    } ]);

webapp.controller('TreeModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm', '$translate', '$timeout',
    function TreeModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm, $translate, $timeout ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.columnMap = {};
      var tree;
      $scope.my_tree = tree = {};
      vm.srch = {};
      (function TreeModalCtrl() {
        vm.getRequestParams = getRequestParams;
        getTreeList();
      })();

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;

        data.mapCode = 'Campaign.getGroupList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();
            }, 1);

          }
        }, function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, data);
        });
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.GrpNm);
          data.guid = item.GrpId;
          data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
          data.classes = [];
          //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.GrpId > vm.maxGrpId)
            vm.maxGrpId = item.GrpId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
  //        $timeout(function() {
  //          return tree.expand_all();
  //        }, 1);

      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }



      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var branch = tree.get_selected_branch();

        var data = {GrpNm : branch.label, GrpId : branch.data};
        $uibModalInstance.close(data);
      }

    } ]);

webapp.controller('MetadataConfigModalCtrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', '$timeout', '$translate',
  function MetadataConfigModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, $timeout, $translate) {
    var vm = this;
    vm.COLUMN_EDIT_STATE_DELETE = 'D';
    vm.COLUMN_EDIT_STATE_ADD = 'A';
    vm.COLUMN_EDIT_STATE_MODIFY = 'M';
    vm.COLUMN_EDIT_STATE_PENDING = '';
    vm.ChangeCustomColumn = ChangeCustomColumn;
    vm.modMetaTable = modMetaTable;
    vm.delMetaTable = delMetaTable;
    vm.openAttrSetup = openAttrSetup;
    vm.openSortMetaColumn = openSortMetaColumn;
    vm.showColumnInfo = showColumnInfo;
    vm.goModifyMetaTable = goModifyMetaTable;
    vm.checkStateChange = checkStateChange;
    vm.showFieldNameRule = showFieldNameRule;
    vm.getTableColumns = getTableColumns;
    vm.makeSrch = makeSrch;

    vm.deleteColumns = [];
    vm.metaColumnYN = 'N';
    vm.dataloader = false;
    vm.changeColumn = 'N';
    vm.srchTenantId = $rootScope.gVariable.srchTenantId;

    vm.sbCtrl = null;
    vm.viewType = "D";

    (function MetadataConfigModalCtrl() {
      console.log('toModalData.tableNm', toModalData.tableNm);
      if (angular.isDefined(toModalData.tableNm) && toModalData.tableNm != '') {
        vm.currentActionView = 'modify';
        getMetaTableDetail();
      }
    })();

    vm.srch = {};
    if (!toModalData.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent(toModalData.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    //console.log(vm.layout);

    vm.onSelectCallback = function(data) {
      vm.metaTable.metaColumns.forEach(function(item, indx) {
        if (item.metaColumnId == data.CallbackTarget) {
          item.columnPhysicalNm = data.Code;
          return;
        }
      });
    };

    function makeSrch(){
      return encodeURIComponent(JSON.stringify(vm.srch, replacer));
    }
    function getMetaTableDetail(dataType) {
      vm.dataloader = true;

      var data = {};
      data.tableNm = toModalData.tableNm;
      postApi.sendPostApi('api/metadata/metatables', toModalData.tableNm, data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.metaTable = result.body.docs[0];

            vm.sbCtrl.drawList(vm.metaTable, dataType);
            vm.checkColumnSection = "Y";
            vm.checkEditColumnRowCount = "Y";
            if (vm.metaTable) {
              vm.metaTable.metaColumns.forEach(function(elm, idx) {
                if(!isNullOrEmpty(elm.columnSection)) {
                  vm.checkColumnSection = "N";
                }
    
                if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                  vm.checkEditColumnRowCount = "N";
                }
    
                if (elm.editColumnRowCount != null) {
                  elm.editColumnRowCount = elm.editColumnRowCount.toString();
                }
                if (elm.searchColumnRowCount != null) {
                  elm.searchColumnRowCount = elm.searchColumnRowCount.toString();
                }
    
                elm.columnValid = true;
                elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
                if (elm.customColumnYN == 'Y') {
                  elm.type = 'add';
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  };
                } else if (elm.customColumnYN == 'N') {
                  elm.type = 'old';
                }
              });
    
              if(vm.metaTable.metaColumns.length > 0)
                vm.metaColumnYN = 'Y';
            }
    
            vm.dataloader = false;
          } else {
            $rootScope.showSimpleToast('failed to load');
          }
        }
        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        $rootScope.showSimpleToast('failed to load');
        console.log("error");
        // console.error('Error> metadata-list> getList()', status, error);
      });
    }

    function checkStateChange(column) {
      if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
        column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
    }

    function checkTableNm(nval, oval) {
      if (angular.isUndefined(nval) || nval == '') {
        return;
      }

      var res = metadataApi.getUsingMetaTableNm().post({
        tableNm : nval
      }).$promise;
      res.then(function(json) {
        if (json.responseVO.body.docs.length > 0) {
          vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
        } else {
          vm.usingTableNm = '';
        }
      });
    }

    function modMetaTable() {
      vm.dataloader = true;

      if(!validateCheck()){
        return false;
      }

      var data = vm.metaTable;
      data.currentActionView = vm.currentActionView;
      data.deleteColumns = vm.deleteColumns;

      postApi.sendPostApi('api/metadata/mod', vm.metaTable.tableNm, data, function(result){

        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            $uibModalInstance.close();
          } else {
            $rootScope.showSimpleToast('failed to save');
          }
        }
        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        $rootScope.showSimpleToast('failed to save');
        console.log("error");
        // console.error('Error> h0102-list-ctrl> getList()', status, error);
      });
    }

    function delMetaTable() {
      vm.dataloader = true;

      if(!validateCheck()){
        return false;
      }

      var data = {};

      postApi.sendPostApi('api/metadata/del', vm.metaTable.tableNm, data, function(result){

        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            $rootScope.showSimpleToast($translate.instant('Menu.UPDATED'));
            $uibModalInstance.close();
          } else {
            $rootScope.showSimpleToast('failed to save');
          }
        }
        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        $rootScope.showSimpleToast('failed to save');
        console.log("error");
        // console.error('Error> h0102-list-ctrl> getList()', status, error);
      });
    }      

    function saveAction(promise) {
      promise.then(function(json) {
        $uibModalInstance.close();
      });
    }

    function openAttrSetup(column) {
      if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
        gAlert('', 'Menu.EM710VA04');
        return;
      }
      var modalInstance = modalFactory.open('lg', 'app/metadata/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      modalInstance.result.then(function(result) {
        if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
          result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
        }
        result.columnValid = true;
      });
    }

    function openSortMetaColumn() {
      if (isEmptyColumnNm()) {
        gAlert('', 'Menu.EM710VA05');
      } else {
        var delColumns = [];
        var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
          if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
            delColumns.push(elm);
          }
          return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
        });
        var modalInstance = modalFactory.open('md', 'app/metadata/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
        modalInstance.result.then(function(result) {
          vm.metaTable.metaColumns = [];
          angular.copy(result, vm.metaTable.metaColumns);
          delColumns.forEach(function(elm, idx) {
            vm.metaTable.metaColumns.push(elm);
          });
        });
      }
    }

    function showColumnInfo(column) {
      var modalInstance = modalFactory.open('lg', 'app/metadata/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
    }

    function showFieldNameRule() {
      var modalInstance = modalFactory.open('fn', 'app/metadata/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
    }

    function isEmptyColumnNm() {
      var res = false;
      vm.metaTable.metaColumns.forEach(function(item, indx) {
        if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
          res = true;
        }
      });
      return res;
    }

    function validateCheck(){
      if(vm.currentActionView == 'add'){
        if(vm.usingTableNm.length != 0){
          gAlert('','Menu.EM710VA03');
          vm.dataloader = false;
          return false;
        }
      }

      return true;
    }

    function getTableColumns() {
      vm.dataloader = true;
      if(vm.metaColumnYN == 'Y') {
        gConfirm('', $translate.instant('Menu.METARESET'), {
          btn : '',
          fn : function(){

            vm.deleteColumns = vm.metaTable.metaColumns;
            vm.metaColumnYN = 'N';

            var data = vm.metaTable;
            postApi.select('MetaColumn.getTableColumns', data, function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                var newnum = 0;
                result.body.docs.forEach(function(elm,indx){

                  newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                  elm.metaColumnId = newnum.toString(36);
                  if (elm.customColumnYN == "N") {
                    elm.columnSection = "";

                    if (elm.dataType == "varchar") {
                      elm.columnPhysicalDataType = "10";
                      elm.columnLogicalDataType = "10";
                    } else if (elm.dataType == "datetime" || elm.dataType == "date") {
                      elm.columnPhysicalDataType = "40";
                      elm.columnLogicalDataType = "40";
                    } else if (elm.dataType == "int") {
                      elm.columnPhysicalDataType = "20";
                      elm.columnLogicalDataType = "20";
                    } else if (elm.dataType == "bigint") {
                      elm.columnPhysicalDataType = "20";
                      elm.columnLogicalDataType = "20";
                    } else if (elm.dataType == "char") {
                      elm.columnPhysicalDataType = "10";
                      elm.columnLogicalDataType = "10";
                    } else {
                      elm.columnPhysicalDataType = "10";
                      elm.columnLogicalDataType = "10";
                    }
                    elm.columnPhysicalDataSize = "";
                    elm.listColumnWidth = "20%";
                    elm.listColumnTextAlign = "text-center";
                    elm.listColumnShowYN = "Y";
                    elm.listColumnShowLevel = "showlevel3";
                    elm.editColumnWidth = "col-lg-4 col-md-6";
                    elm.editColumnShowYN = "Y";
                    elm.editColumnHeight = "";
                    elm.columnDesc = "";
                    elm.columnCodeValue = "";
                    elm.codeType = "";
                    elm.dirty = "";
                  }

                  if (elm.customColumnYN == 'Y') {
                    elm.commoncodeDATA = {
                      CallbackTarget : elm.metaColumnId,
                      CodeType : 'METACOLUMN',
                      Code : elm.columnPhysicalNm,
                      ReloadSeq : 1
                    };
                  }
                });
                vm.metaTable.metaColumns = result.body.docs;
                vm.sbCtrl.drawList(vm.metaTable);
              }
              vm.dataloader = false;
            }, function(error) {
              vm.dataloader = false;
              console.log("error");
              // console.error('Error> h0102-list-ctrl> getList()', status, error);
            });
          }
        }, {
          btn : '',
          fn : function(){
            vm.dataloader = false;
          }
        });
      }else{
        var data = vm.metaTable;
        postApi.select('MetaColumn.getTableColumns', data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var newnum = 0;
            vm.checkColumnSection = "Y";
            vm.checkEditColumnRowCount = "Y";

            result.body.docs.forEach(function(elm,indx){
              newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              elm.metaColumnId = newnum.toString(36);

              if(!isNullOrEmpty(elm.columnSection)) {
                vm.checkColumnSection = "N";
              }

              if(!isNullOrEmpty(elm.editColumnRowCount) && elm.editColumnRowCount != "0") {
                vm.checkEditColumnRowCount = "N";
              }

              if(elm.customColumnYN == 'N'){
                elm.columnSection = '';
                elm.editColumnSort = indx;
                if(elm.dataType =="varchar"){

                  elm.columnPhysicalDataType = '10';
                  elm.columnLogicalDataType = '10';

                }else if(elm.dataType =="date"){

                  elm.columnPhysicalDataType = '40';
                  elm.columnLogicalDataType = '40';

                }else if(elm.dataType =="datetime"){

                  elm.columnPhysicalDataType = '90';
                  elm.columnLogicalDataType = '90';

                }else if(elm.dataType =="int"){

                  elm.columnPhysicalDataType = '20';
                  elm.columnLogicalDataType = '20';

                }else if(elm.dataType =="bigint"){

                  elm.columnPhysicalDataType = '20';
                  elm.columnLogicalDataType = '20';

                }else if(elm.dataType =="char"){

                  elm.columnPhysicalDataType = '110';
                  elm.columnLogicalDataType = '110';

                }else{
                  elm.columnPhysicalDataType = '10';
                  elm.columnLogicalDataType = '10';
                }
                elm.columnPhysicalDataSize = '';
                elm.listColumnWidth = 'auto';
                elm.listColumnTextAlign = 'text-center';
                elm.listColumnShowYN = 'Y';
                elm.listColumnShowLevel = 'showlevel3';
                elm.editColumnWidth = 'col-lg-4 col-md-6';
                elm.editColumnShowYN = 'Y';
                elm.editColumnHeight = '';
                elm.columnDesc = '';
                elm.columnCodeValue = '';
                elm.codeType = '';
                elm.keyColumnYN = 'Y';
              }
              if (elm.customColumnYN == 'Y') {
                elm.commoncodeDATA = {
                  CallbackTarget : elm.metaColumnId,
                  CodeType : 'METACOLUMN',
                  Code : elm.columnPhysicalNm,
                  ReloadSeq : 1
                }
              }
            });
            vm.metaTable.metaColumns = result.body.docs;
            vm.sbCtrl.drawList(vm.metaTable)
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }
    }

    function goModifyMetaTable() {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        // 삭제시 -> 목록 화면 이동
        $state.go("app.metadata.list", { srch: srch, tableNm: ''}, {reload:"app.metadata.list"});
      } else {
        // 조회 화면 이동
        $state.go("app.metadata.list.modify", {srch: srch, tableNm: vm.metaTable.tableNm}, {reload:"app.metadata.list"});
      }        
    }

    function ChangeCustomColumn() {
      vm.dataloader = true;
      if(vm.metaColumnYN == 'Y' || vm.changeColumn == 'Y') {
        gConfirm('', $translate.instant('Menu.METARESET'), {
          btn : '',
          fn : function(){
            if (vm.changeColumn =='N') vm.deleteColumns = vm.metaTable.metaColumns;
            vm.metaColumnYN = 'N';
            vm.changeColumn = 'N';
            vm.metaTable.metaColumns = [];
            vm.dataloader = false;
          }
        }, {
          btn : '',
          fn : function(){
            vm.dataloader = false;
          }
        });
      }else{
        var data = vm.metaTable;
        vm.changeColumn = 'Y';
        postApi.select('BoardMng.getChangeTableColumns', data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var newnum = 0;
            vm.metaTable.metaColumns = result.body.docs;
            vm.metaTable.metaColumns.forEach(function(elm, idx) {

              newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              elm.metaColumnId = newnum.toString(36);
              elm.tenantId = null;

              if (elm.customColumnYN == 'Y') {
                elm.commoncodeDATA = {
                  CallbackTarget : elm.metaColumnId,
                  CodeType : 'METACOLUMN',
                  Code : elm.columnPhysicalNm,
                  ReloadSeq : 1
                };
              }
            });
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          console.log("error");
          // console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }
    }

    vm.succSortable = function(ctrl) {
      vm.sbCtrl = ctrl;

      ctrl.openPop = function(data, callback) {
      };

      ctrl.deleteColumn = function(data, callback) {
      };

      ctrl.openAttrSetup = function(data, callback) {
      };

      ctrl.onSelectCallback  = function(data, callback) {
      };
    };    

    vm.ok = function() {
      $uibModalInstance.close();
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel data');
    };

  }]);
webapp.controller('MyPageModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  'gAlert',
  '$rootScope',
  function MyPageModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    gAlert,
    $rootScope
  ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.keyId = toModalData.UserId;
    vm.TenantId = toModalData.TenantId;

    //function
    vm.setData = setData;
    vm.getData = getData;
    vm.checkUserPw = checkUserPw;

    var VIEW_SQL = 'User.getUserMgrDetail'; // 조회 SQL
    var UPDATE_SQL = 'User.updateMyPage'; // 수정 SQL

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'Users'; // 작업 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = 'Edit'; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
    vm.srchDetail.keyId = vm.keyId;
    vm.srchDetail.tableNm = KEY_TABLE_NM;
    vm.srchDetail.isDescList = 'N';
    vm.srchDetail.TenantId = $window.sessionStorage['loginTenantId'];

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      KeyId: vm.keyId, // Primary Key Data
      tableNm: KEY_TABLE_NM, // 작업 테이블명
    };

    (function MyPageModalCtrl() {})();

    function ok() {
      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.srchDetail.mapCode = 'User.getUserMgrDetail';
      postApi.select(
        vm.srchDetail,
        function (data) {
          if (data.header.status == CONSTANT.HttpStatus.OK) {
            if (data.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = data.body.docs[0];
            }
          } else {
            console.log("error");
            // console.error('Error> getData()');

            /*if (!isNullOrEmpty(data.responseVO.body.docs)) {
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }*/
          }
        },
        function (error) {
          console.log("error");
          // console.error('Error> getData()');
          // console.table(error);
        }
      );
    }

    function checkUserPw() {
      if (vm.data.UserPassword.length < 8) {
        gAlert('', '비밀번호는 8자 이상입니다.');
        return;
      }
      vm.data.UserId = vm.keyId;
      vm.data.mapCode = 'User.getUserPasswordChk';

      if (
        vm.data.UserPassword != null &&
        vm.data.UserPassword != '' &&
        vm.data.UserPassword != undefined
      ) {
        postApi.select(
          vm.data,
          function (data) {
            if (data.header.status == CONSTANT.HttpStatus.OK) {
              if (data.body.docs.length > 0) {
                setData();
              } else {
                gAlert('', '현재 비밀번호가 잘못되었습니다.');
              }
            } else {
              console.log("error");
              // console.error('Error> checkUserPw()');

              /*if (!isNullOrEmpty(data.responseVO.body.docs)) {
                gAlert('', data.responseVO.body.docs[0].errMessage);
              }*/
            }
          },
          function (error) {
            console.log("error");
            // console.error('Error> getData()');
            // console.table(error);
          }
        );
      } else {
        gAlert('', '현재 비밀번호를 입력해주시기 바랍니다.');
      }
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {
      if (vm.data.Password != null && vm.data.Password != '') {
        if (vm.data.UserPassword != vm.data.Password) {
          // #region 필수항목 체크
          var errMsg = '';

          if (vm.data.Password) {
            if (vm.data.Password != vm.data.Password2) {
              errMsg = errMsg + '새로운 비밀번호가 일치하지 않습니다.';
              gAlert('', errMsg);
              return;
            }

            if (!checkPassword(vm.data.Password, vm.data.LoginId)) {
              return;
            }
          }

          postApi.api('updateMyInfo',
            vm.data,
            function (data) {
              gAlert('', '수정되었습니다.', {
                btn: '',
                fn: function () {
                  $uibModalInstance.close();
                },
              });
            },
            function (error) {
              console.log("error");
              // console.error('Error> setData()');
              // console.table(error);
            }
          );
        } else {
          gAlert('', '현재 비밀번호와 새로운 비밀번호가 일치합니다.');
        }
      } else {
        gAlert('', '수정할 비밀번호를 입력해주시기 바랍니다.');
      }
    }

    function checkPassword(password, id) {
      if (
        !/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/.test(password)
      ) {
        gAlert(
          '',
          '숫자+영문자+특수문자 조합으로 8자리 이상 16자리 이하로 사용해야 합니다.'
        );
        return false;
      }
      var checkNumber = password.search(/[0-9]/g);
      var checkEnglish = password.search(/[a-z]/gi);
      if (checkNumber < 0 || checkEnglish < 0) {
        gAlert('', '숫자와 영문자를 혼용하여야 합니다.');
        return false;
      }
      if (/(\w)\1\1/.test(password)) {
        gAlert('', '같은 문자를 3번 이상 사용하실 수 없습니다.');
        return false;
      }
      /*
      if(password.search(id) > -1){
          alert("비밀번호에 아이디가 포함되었습니다.");
          //$('#password').val('').focus();
          return false;
      }*/
      return true;
    }

    function setMallFW(param) {
      var param = {};
      param.rTenantID = $rootScope.gVariable.srchTenantId;
      param.rUserID = vm.data.KeyId;
      param.rLoginID = vm.data.LoginId;
      param.rShopTentID = vm.data.TenantId;
      param.mapCode = 'remoteJfc';
      param.remoteAction = 'setChangePw';
      param.rUserPw = vm.data.Password;

      postApi.openApi(param, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
        } else {
        }
      });
    }
    getData();
  },
]);

webapp.service('PayAPISrv', [ '$resource', '$rootScope', 'StaticVariable', function PayAPISrv($resource, $rootScope, StaticVariable) {
    var payApi = {
      doChkPay : function(obj) {        
        return $resource(StaticVariable.getUrl('/pay/chkPay.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doInsertPay : function(obj) {        
        return $resource(StaticVariable.getUrl('/pay/insertPay.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      /*
      doSetTaxInv : function(obj) {        
        return $resource(StaticVariable.getUrl('/pay/setTaxInv.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      */
    };
    return payApi;
  } ]);
  
(function () {
  "use strict";
  webapp.controller('PayChgAdmListCtrl', 
  ['$scope','$stateParams', '$state', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function PayChgAdmListCtrl($scope, $stateParams, $state, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "PayChgAdm",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {

        initSelectCnt : { mapCode : "Pay.getPayChgAdmListCnt", param : null },
        initSelect : { mapCode : "Pay.getPayChgAdmList", param : null },
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },

      addFormGroup : {
        srchRegDate : { after : "Remark", type : mElemTx.date,  bindKey : ["RegDateFrom", "RegDateTo"], label : "변경일", addDivision : true, colSize : 3}
      },

      srchDateType : {
        RegDateFrom : "from",
        RegDateTo : "to",
      },

      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
    };

    vm.payChgAdmAddModal = function () {
      var ctrl = 'PayChgAdmWriteCtrl as vc';
      var paramData = {
        
      };

      var modalInstance = modalFactory.open('md', 'components/modal/pay/pay-chg-adm-write.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        av.search();
      }, function (cancelData) {

      });
    };

    function onReadyAutoView() {
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('PayChgAdmWriteCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter', 'modalFactory', 'pay',
      function PayChgAdmWriteCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, $window, $filter, modalFactory, pay) {

        // View Model 
        var vm = this;

        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "PayChgAdm", // 관리자결제변경
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vm.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: "",

            // insert MapperId
            insert: "Pay.insertPayChgAdm",

            // update MapperId
            update: "",

          },
          /* 목록페이지 */

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
            PayMonTo: "vc.data.PayType == 'MON'",
            PayMonEnd: "vc.data.PayType == 'MON'",
            PaySmsAmt: "vc.data.PayType == 'SMS'",
            PaySmsRemAmt: "vc.data.PayType == 'SMS'",
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            PayMonEnd: "true",
            PaySmsRemAmt: "true",
            PayMonTo: "vc.PayMonToDisbled",
          },

          // MetaColum 외 추가 적으로 넣어야할 폼
          addForm: {
            PayMonEnd: { before: 'PayMonTo', type: mElemTx.input, colSize: 2, label: "만료일" },
            PaySmsRemAmt: { before: 'PaySmsAmt', type: mElemTx.input, colSize: 2, label: "SMS잔액(원)" }
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {
          },

          timeOption: {
            // PayDate: {
            //   minuteStep: 1, initActiveCalendar: true
            // }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
          },

          // 필수 항목 컬럼 
          required: [""],

          autocomplete: {
          }

        };
        //#endregion Auto View Option 설정 

        //#region 함수 구현 
        //회원사 팝업
        vm.srchTenantModal = function () {
          var ctrl = 'TenantModalCtrl as vc';
          var paramData = {}
          var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            vm.data.TenantId = okData.TenantId;
            vm.data.TenantNm = okData.TenantNm;
            getTenantInfo();
          }, function (cancelData) { });
        };
        vm.eraseTenant = function () {
          vm.data.TenantId = "";
          vm.data.TenantNm = "";
          vm.data.PayMonEnd = "";
          vm.data.PaySmsRemAmt = "";
        };

        // 회원사 정보 가져오기
        function getTenantInfo() {
          var paramData = {};
          paramData.TenantId = angular.copy(vm.data.TenantId);
          paramData.mapCode = "Pay.getPayTenant";
          postApi.select(paramData, function (result) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].PayType != "10" || result.body.docs[0].MonAmt == "0") {
                av.alert("해당회원사의 결제구분이 '매월'로 설정되어 있지 않기때문에 만료일은 수정할 수 없습니다.");
                vm.data.PayType = 'SMS';
                vm.PayMonToDisbled = true;
                vm.data.PayMonTo = "";
                vm.data.PayMonEnd = "";
                vm.data.PaySmsRemAmt = pay.setComma(result.body.docs[0].ServPoint);
              } else {
                vm.PayMonToDisbled = false;
                //vm.data.PayMonEnd = result.body.docs[0].ServiceExpireDate;
                vm.data.PayMonEnd = !isNullOrEmpty(result.body.docs[0].ServiceExpireDate) ? $filter('autoViewUtcToLocal')(result.body.docs[0].ServiceExpireDate).substr(0, 10) : "";  
                vm.data.PaySmsRemAmt = pay.setComma(result.body.docs[0].ServPoint);
              }

            }
          }, function (error) {
            av.alert("회원사 정보를 불러오는데 실패하였습니다.");
            console.table(error);
            vm.dataloader = false;
          });
        }

        /**
         * 저장 
         */
        function setData() {
          // 필수값 체크
          if (isNullOrEmpty(vm.data.TenantNm)) {
            av.alert("회원사를 선택해주세요.");
            return false;
          }

          if (isNullOrEmpty(vm.data.PayType)) {
            av.alert("변경항목을 선택해주세요.");
            return false;
          } else {
            if (vm.data.PayType == 'MON' && isNullOrEmpty(vm.data.PayMonTo)) {
              if (vm.PayMonToDisbled == true) { av.alert("변경만료일을 변경할 수 없습니다."); }
              else { av.alert("변경만료일을 입력해주세요."); }
              return false;
            }

            if (vm.data.PayType == 'SMS' && isNullOrEmpty(vm.data.PaySmsAmt)) {
              av.alert("SMS충전/차감 금액을 입력해주세요.");
              return false;
            }
          }

          if (isNullOrEmpty(vm.data.Remark)) {
            av.alert("변경사유를 입력해주세요.");
            return false;
          }

          av.commit(function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert("저장되었습니다.", function () {
                $uibModalInstance.close('');
              });
            }
            else {
              console.log("error");
              // console.error('Error - pay-chg-adm-write-ctrl> setData()');
              // console.table(result.body.docs[0]);
              av.alert('저장을 실패했습니다.');
            }
          });
        }

        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {
          // 초기 설정
          vm.data.PayType = 'MON';
        }
        //#endregion 함수 구현  

        //#region 함수 설정 
        // 저장 
        vm.setData = setData;
        // 취소 
        vm.cancel = cancel;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

(function () {
  "use strict";
  webapp.controller('PayHistDetailCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', 'gConfirm', '$window', '$filter', 'toModalData', 'PayAPISrv',
      function PayHistDetailCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, gConfirm, $window, $filter, mdata, payApi) {

        // View Model 
        var vm = this;

        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "Pay", // 관리자결제변경
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vm.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "Pay.getPayHistDetail", param: { KeyId: mdata.KeyId } },

            // insert MapperId
            insert: "",

            // update MapperId
            update: "",

          },
          /* 목록페이지 */

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            TenantNm: "true",
            merchant_uid: "true",
            status: "true",
            pay_method: "true",
            SupAmt: "true",
            TaxAmt: "true",
            paid_amount: "true",
            name: "true",
            buyer_name: "true",
            buyer_tel: "true",
            buyer_email: "true",
            vbank_name: "true",
            vbank_holder: "true",
            vbank_num: "true",
          },

          // MetaColum 외 추가 적으로 넣어야할 폼
          addForm: {
            //PayMonEnd: { before: 'PayMonTo', type: mElemTx.input, colSize: 2, label: "만료일" },
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {
          },

          timeOption: {
            // PayDate: {
            //   minuteStep: 1, initActiveCalendar: true
            // }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
          },

          // 필수 항목 컬럼 
          required: [""],

          autocomplete: {
          }

        };
        //#endregion Auto View Option 설정 

        //#region 함수 구현 
        /**
               * 목록 건수 조회
               *
               * @param
               * @return
               */
        function getListCnt() {

          var data = {}; // 검색 옵션 설정
          data.KeyId = mdata.KeyId;
          data.mapCode = "Pay.getPayHistDetailListCnt"; // 목록 건수 조회 SQL Mapper ID

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm._totalItems = result.body.docs;
              } else {
                // 조회 실패
                vm._totalItems = 0;
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.log("error");
            // console.error("Error> getListCnt()");
            // console.table(error);
          });
        }

        /**
         * 목록 조회
         *
         * @param
         * @return
         */
        function getList() {
          vm.dataloader = true; // Progressbar 표시
          vm.custMapCode = {};
          getListCnt(); // 목록 건수 조회

          var data = {}; // 검색 옵션 설정
          data.KeyId = mdata.KeyId;
          data.tableNm = "PayDetail";
          data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
          data.mapCode = "Pay.getPayHistDetailList";

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              // MetaColumn 사용
              if (result.body.desc.length > 0) {
                // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
                vm.listColumns = result.body.desc;
                angular.forEach(vm.listColumns, function (item) {
                  vm.custMapCode[item.ColumnPhysicalNm] = item;
                });
              } else {
                console.log("error");
                // console.error('Error> getPayHistDetailList()> MetaColumn 정보 조회 오류');
                // console.table(data);
              }

              if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
                // 목록 데이터 표시
                vm.lists = result.body.docs;

                var resList = [];
                var res = '';

                if (vm.lists != null) {
                  // angular.forEach(vm.lists, function (item) {
                  //   resList = [];
                  //   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                  //     res = item.Addr1;
                  //     resList = res.split(" ");
                  //     item.Addr = resList[0] + " " + resList[1];
                  //   }
                  // });
                }
              } else {
                // 데이터 조회 실패
                vm.lists = {};
              }
            }
            vm.dataloader = false; // Progressbar 숨김
          }, function (error) {
            vm.dataloader = false; // Progressbar 숨김

            // 조회 중 오류 발생
            console.log("error");
            // console.error("Error> getList()");
            // console.table(error);

          });
        }

        function setSortDirect() {

        }

        /**
         * 윈도우 팝업 호출
         */
        vm.getWinPop = function(url) {    
          var $popup = $window.open(url, "popup", "width=800,height=600");
          $popup.Name = $scope.Name;      
        };

        /**
         * 세금계산서 발행
         */
        /*
        vm.setTaxInv = function() {             
          var rtnArr;
          var param = {};

          param.PayId = vm.data.KeyId;
          param.merchant_uid = vm.merchant_uid;
          param.imp_uid = vm.imp_uid;   
          
          gConfirm('', '전자세금계산서발행시 국세청으로 자동전송됩니다.<br />전자세금계산서를 발행하시겠습니까?', {                
            btn: '', fn: function () {
              var prms = payApi.doSetTaxInv().post(param).$promise;      
              prms.then(function(data) {
                if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {          
                  if (data.responseVO.body.docCnt > 0) {    
                    rtnArr = data.responseVO.body.docs[0].message.split("_");
                    
                    if (rtnArr.length >= 2) {                      
                      switch (rtnArr[0]) {
                        case "SUCC":
                          if (rtnArr[1] == "500") {
                            gAlert("", "전자세금계산서 발행에 성공하였습니다.");
                          }
                          else {
                            gAlert("", "이전에 발행된 전자세금계산서가 존재합니다.");
                          }
                          
                          if (rtnArr[2]) vm.getWinPop(rtnArr[2]);
                          break;

                        case "RTN":
                          if (rtnArr[1] == "-32001" 
                            || rtnArr[1] == "-32002" 
                            || rtnArr[1] == "-32003" 
                            || rtnArr[1] == "-32006" 
                            || rtnArr[1] == "-11201"
                            || rtnArr[1] == "-11202" 
                            || rtnArr[1] == "-11207") {
                            gAlert("", "전자세금계산서발행에 실패하였습니다.(" + rtnArr[1] + ")<br />회원사(공급받는자)의 법인명, 사업자번호, 대표자명, 주소, 담당자명을 확인해주세요.");
                          }
                          else if (rtnArr[1] == "-26012" || rtnArr[1] == "-26013")
                          {
                            gAlert("", "전자세금계산서 발행기간이 초과되었습니다.(" + rtnArr[1] + ")<br />고객센터로 문의해주세요.");
                          }
                          else
                          {
                            gAlert("", "전자세금계산서발행에 실패하였습니다.(" + rtnArr[1] + ")<br />고객센터로 문의해주세요.");
                          }
                          break;                       

                        default:                      
                          gAlert("", "전자세금계산서 발행에 실패하였습니다.(" + rtnArr[1] + ")");           
                          break;
                      }
                    }
                    else {
                      gAlert("", "전자세금계산서 발행에 실패하였습니다.(-FE001)");           
                    }
                  }
                  else {
                    gAlert("", "전자세금계산서 발행에 실패하였습니다.(-FE002)");
                  }          
                }
                else {
                  gAlert("", "전자세금계산서 발행에 실패하였습니다.(-FE003)");
                }
              }, function (error) {        
                console.error("Error> setTaxInv()");
                console.table(error);
              });
            }
          }, {
            btn: '', fn: function () {              
            }
          });   
        };
        */


        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {
          vm.TaxInvShow = false;
          vm.SalesSlipShow = false;          

          if (vm.data.status_ == "paid" && vm.data.pay_method != "card") {
            vm.TaxInvShow = true;    
          }

          if ((vm.data.status_ == "paid" || vm.data.status_ == "cancel") 
            && !isNullOrEmpty(vm.data.receipt_url) && vm.data.pay_method == "card") {
            vm.SalesSlipShow = true;    
          }

          getList();
        }
        //#endregion 함수 구현  

        //#region 함수 설정 
        // 취소 
        vm.cancel = cancel;

        // 상세항목
        vm.getList = getList;
        vm.setSortDirect = setSortDirect;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

(function () {
  "use strict";
  webapp.controller('PayHistListCtrl', 
  ['$window','$scope','$stateParams', '$state', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function PayHistListCtrl($window, $scope, $stateParams, $state, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;
    vm.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];

    // CustCodes 정의
    vm.codePayType = [
      {Code : 'MON', CodeValue : '기간연장'},
      {Code : 'SMS', CodeValue : 'SMS충전'},
      {Code : 'REQ', CodeValue : '요청결제'},
      {Code : 'JOIN', CodeValue : '가입비'}
    ];

    vm.codePaystatus = [
      {Code : 'paid', CodeValue : '결제완료'},
      {Code : 'ready', CodeValue : '미결제'},
      {Code : 'cancel', CodeValue : '환불/취소'},
      {Code : 'pcancel', CodeValue : '부분환불/취소'}
    ];

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "Pay",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {

        initSelectCnt : { mapCode : "Pay.getPayHistListCnt", param : vm.srch },
        initSelect : { mapCode : "Pay.getPayHistList", param : vm.srch },
      },

      // List
      listCheckboxEnable : false,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },

      addForm : {
        PayType : { after : 'merchant_uid', type : mElemTx.select, colSize: 3, label : "결제항목"},
        status : { after : 'buyer_tel', type : mElemTx.select, colSize: 3, label : "결제상태"},
      },

      addFormGroup : {
        srchPaid_amount : { after : "status", type : mElemTx.number,  bindKey : ["paid_amountFrom", "paid_amountTo"], label : "총결제금액", addDivision : true, colSize : 3},
        srchRegDate : { after : "srchPaid_amount", type : mElemTx.date,  bindKey : ["RegDateFrom", "RegDateTo"], label : "결제신청일", addDivision : true, colSize : 3}
      },

      customCodes : {
        PayType : "codePayType", 
        status : "codePaystatus"
      },

      srchDateType : {
        RegDateFrom : "from",
        RegDateTo : "to",
      },

      disabled : {
        TenantNm : "vc.SysAdminYN !='Y'",
      },

      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback : clickevent
    };

    function clickevent(clickData){
      vm.payReqAddModal(clickData.KeyId);
    }

    vm.payReqAddModal = function (keyId) {
      var ctrl = 'PayHistDetailCtrl as vc';
      var paramData = {KeyId: keyId};

      var modalInstance = modalFactory.open('mf-65', 'components/modal/pay/pay-hist-detail.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        av.search();
      }, function (cancelData) {

      });
    };

    function onReadyAutoView() {
      //?????????????
      if (vm.SysAdminYN != 'Y') {
        vm.srch.TenantNm = $window.sessionStorage['loginTenantName'];
        vm.srch.TenantId = $window.sessionStorage['loginTenantId'];
        av.search();
      }
    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

(function () {
  "use strict";
  webapp.controller('PayModalCtrl',
    ['$rootScope', '$scope', '$stateParams', '$translate', '$state', '$window', '$uibModalInstance',
      function PayModalCtrl($rootScope, $scope, $stateParams, $translate, $state, $window, $uibModalInstance) {

        var vm = this;
        vm.cancel = cancel;
        vm.url = $state.current.url;
        vm.keyId = $stateParams.keyId;
        vm.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];
        vm.ExpOverCode = $window.sessionStorage['loginExpOverCode'];        

        vm.view = {
          VIEW_PAGE_PAYWIRTE: 'components/modal/pay/pay-write.html', // 결제 화면
          VIEW_PAGE_PAYHIST: 'components/modal/pay/pay-hist-list.html', // 결제 히스토리 화면
          VIEW_PAGE_PAYREQ: 'components/modal/pay/pay-req-list.html', // 결제 요청 화면
          VIEW_PAGE_PAYCHGADM: 'components/modal/pay/pay-chg-adm-list.html', // 관리자 결제 화면
        };
        vm.pages = vm.view.VIEW_PAGE_PAYWIRTE;
        vm.tabIndex = 0;

        function setChangeTab(idx, view) {
          vm.tabIndex = idx;
          vm.pages = vm.view[view];
        }

        var checkTab = $window.sessionStorage.getItem("goToPayAtTab");
        if (!isNullOrEmpty(checkTab)) {
          checkTab = JSON.parse(checkTab);
          $window.sessionStorage.setItem("goToPayAtTab", "");
          setChangeTab(checkTab.idx, checkTab.tab);
        } else {
          $window.sessionStorage.setItem("goToPayAtTab", "");
        }

        // 함수 정의
        vm.setChangeTab = setChangeTab;

        // 회원사 변경 설정
        $scope.$on('broadcastSetChangeTenantID', function (event, data) {
          vm.setResetSearch();
          $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
        });

        /**
         * 취소
         */
        function cancel() {
          $uibModalInstance.dismiss('cancel data');
        }
      }]);
})();

(function () {
  "use strict";
  webapp.controller('PayReqListCtrl', 
  ['$scope','$stateParams', '$state', 'autoView', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory',
  function PayReqListCtrl($scope, $stateParams, $state, autoView, postApi, CONSTANT, modalFactory) {

    var vm = this;

    vm.listOptions = {
      html: {
        autoViewCheckBox: {
          template: '<input type="checkbox" ng-model="li.chkRow" ng-change="vc.chkRowChg(li)" ng-disabled="li.PayYN==\'Y\'"/>'
        }
      }
    };

    var autoViewOption = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope,

      /* 공통 */
      viewType : mViewType.List, // List OR Edit
      tableNm : "PayReq",
      keyIdNm : "KeyId",
      alias : "vc",
      dataModelNm : "lists", // ex : vc.data = {}
      srchModelNm : "srch",
      srchTarget : "searchWrap",
      apis : {

        initSelectCnt : { mapCode : "Pay.getPayReqListCnt", param : null },
        initSelect : { mapCode : "Pay.getPayReqList", param : null },
      },

      // List
      listCheckboxEnable : true,

      addSrchStack : false,
      
      src : {
        detail : "",
        splitDetail : ""
      },

      addFormGroup : {
        srchReqDate : { after : "Title", type : mElemTx.date,  bindKey : ["ReqDateFrom", "ReqDateTo"], label : "요청일", addDivision : true, colSize : 3}
      },

      srchDateType : {
        ReqDateFrom : "from",
        ReqDateTo : "to",
      },

      // listClickCallback 없을 경우 KeyIdNm으로 자동 이벤트 처리
      listClickCallback : clickevent
    };

    function clickevent(clickData){
      vm.payReqAddModal(clickData.KeyId);
    }

    vm.payReqAddModal = function (keyId) {
      var ctrl = 'PayReqWriteCtrl as vc';
      var paramData = {KeyId: keyId};

      var modalInstance = modalFactory.open('md', 'components/modal/pay/pay-req-write.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        av.search();
      }, function (cancelData) {

      });
    };

    /**
       * 목록 삭제 확인
       * @param
       * @return
       */
    function setDelList() {
      vm.srch.KeyIdList = [];

      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          vm.srch.KeyIdList.push(vm.lists[i].KeyId);
        }
      }

      if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
        av.alert("Menu.DELETENODATA");
        return false;
      } else {
        av.confirm("Menu.DELETECONFIRM",
          function () {
            var data = vm.srch;
            data.mapCode = "Pay.deletePayReq";

            postApi.update(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert("삭제 되었습니다.", function () {
                  av.search();
                });
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> setDelListAction()");
              // console.table(error);
            });
          }, function () {
        });
      }
    }

    function onReadyAutoView() {

    }

    /** @description autoView init Callback**/
    vm.onReadyAutoView = onReadyAutoView;
    vm.setDelList = setDelList;

    var av = new autoView();
    av.init(autoViewOption);

  }]);
})();

webapp.controller('PayReqModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state', '$filter', 'pay',
  function PayReqModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state, $filter, pay) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getList = getList;
    vm.currentPage = 1;
    vm.maxSize = 10;

    vm.srch = {
      TenantNm : '',
      TenantId : '',
      viewSize : 10,
      Ceo :'',
    };

    (function PayReqModalCtrl() {
      getList();

      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };
    })();

    // 목록 조회
    function getList() {      
      var data = {
        mapCode: 'Pay.getPayReqList',
        TenantId : $window.sessionStorage["loginTenantId"],        
        Title : vm.srch.Title,
        PayYN : 'N',
        userkey : '',        
        page : vm.srch.page 
      };
      
      getCnt(true);

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.lists = result.body.docs;

          if (vm.lists != null) {
            angular.forEach(vm.lists, function (item) {                
              item.ReqAmt = pay.setComma(item.ReqAmt);                          
            });
          }
        }
      });
    }

    // 목록 수 조회
    function getCnt() {
      var data = {
        mapCode: 'Pay.getPayReqListCnt',
        TenantId : $window.sessionStorage["loginTenantId"],        
        Title : vm.srch.Title,
        PayYN : 'N',
        userkey : ''
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.totalItems = result.body.docs[0].totalItems;
        }
      });        
    }       

    // 취소 이벤트
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 성공 이벤트
    function ok() {      
      var param = [];      

      vm.lists.forEach(function(item) {
        if (item.chkRow) {                    
          param.push({
            payReqId: item.KeyId,
            reqAmt: pay.delComma(item.ReqAmt)         
          }); 
        }
      });

      $uibModalInstance.close(param);
    }

    // 페이지 변경시 데이터 조회     
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    vm.pageChanged = pageChanged;
  }
]);
(function () {
  "use strict";
  webapp.controller('PayReqWriteCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter', 'modalFactory',
      function PayReqWriteCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $window, $filter, modalFactory) {

        // View Model 
        var vm = this;

        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "PayReq", // 결제요청
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vm.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "Pay.getPayReqDetail", param: { KeyId: mdata.KeyId } },

            // insert MapperId
            insert: "Pay.insertPayReq",

            // update MapperId
            update: "Pay.updatePayReq",

          },
          /* 목록페이지 */

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            TenantNm : "vc.data.PayYN == 'Y'",
            ReqAmt : "vc.data.PayYN == 'Y'",
            ReqDate : "vc.data.PayYN == 'Y'",
            Title : "vc.data.PayYN == 'Y'"
          },

          // MetaColum 외 추가 적으로 넣어야할 폼
          addForm: {
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {
          },

          timeOption: {
            // PayDate: {
            //   minuteStep: 1, initActiveCalendar: true
            // }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
          },

          // 필수 항목 컬럼 
          required: [""],

          autocomplete: {
          }

        };
        //#endregion Auto View Option 설정 

        //#region 함수 구현 
        //회원사 팝업
        vm.srchTenantModal = function () {
          var ctrl = 'TenantModalCtrl as vc';
          var paramData = {};
          var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            vm.data.TenantId = okData.TenantId;
            vm.data.TenantNm = okData.TenantNm;
          }, function (cancelData) { });
        };
        vm.eraseTenant = function () {
          vm.data.TenantId = "";
          vm.data.TenantNm = "";
        };

        /**
         * 저장 
         */
        function setData() {
          // 필수값 체크

          if (isNullOrEmpty(vm.data.TenantNm)) {
            av.alert("회원사를 선택해주세요.");
            return false;
          }

          if (isNullOrEmpty(vm.data.ReqAmt)) {
            av.alert("요청금액(원)을 입력해주세요.");
            return false;
          }
          else {
            var amt = Number(vm.data.ReqAmt.toString().replaceAll(",", ""));
            if (amt <= 0) {
              av.alert("요청금액은 0원 이상이여야합니다.");
              return false;
            }
          }

          if (isNullOrEmpty(vm.data.ReqDate)) {
            av.alert("요청일을 선택해주세요.");
            return false;
          }

          if (isNullOrEmpty(vm.data.Title)) {
            av.alert("결제내용을 입력해주세요.");
            return false;
          }

          av.commit(function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert("저장되었습니다.", function(){
                $uibModalInstance.close('');
              });
            }
            else {
              console.log("error");
              // console.error('Error - pay-req-write-ctrl> setData()');
              // console.table(result.body.docs[0]);
              av.alert('저장을 실패했습니다.');
            }
          });
        }

        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {

        }
        //#endregion 함수 구현  

        //#region 함수 설정 
        // 저장 
        vm.setData = setData;
        // 취소 
        vm.cancel = cancel;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

(function () {
  "use strict";
  webapp.controller('PayWriteCtrl', 
  ['$window','$scope','$stateParams', 'postApi', 'GLOBAL_CONSTANT', 'modalFactory', 'gAlert', 'gConfirm', '$filter', 'pay', 'PayAPISrv',
  function PayWriteCtrl($window, $scope, $stateParams, postApi, CONSTANT, modalFactory, gAlert, gConfirm, $filter, pay, payApi) {

    var vm = this;
    vm.payReqInfo = [];

    // 연장개월 코드
    postApi.select({mapCode : 'CommonCode.getCommonCodeValue', CodeType : 'PG_PAYMON'}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codePayMonList = result.body.docs;
        vm.PayMon = "1";
      }
    });

    // 결제수단 코드
    postApi.select({mapCode : 'CommonCode.getCommonCodeValue', CodeType : 'PG_PAYMETHOD'}, 
    function(result){
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.codePayMethodList = result.body.docs;
        vm.PayMethod = "card";
      }
    });   

    // 회원사 정보
    function getPayTenant() {      
      postApi.select({mapCode : 'Pay.getPayTenant'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {          
          vm.data = result.body.docs[0];
          
              // 결제구분이 "매월" 인 경우에만 기간연장 항목 활성화
          if (vm.data.PayType != "10" || vm.data.PayType.MonAmt == "0") vm.PayMonEnabled = false;       
          
          //vm.data.ServiceExpireDate = $filter('autoViewUtcToLocal')(vm.data.ServiceExpireDate, 'yyyy-MM-dd');    
          vm.data.ServiceExpireDate = !isNullOrEmpty(vm.data.ServiceExpireDate) ? $filter('autoViewUtcToLocal')(vm.data.ServiceExpireDate).substr(0, 10) : "";    
          vm.data.PayMonDate = !isNullOrEmpty(vm.data.PayMonDate) ? $filter('autoViewUtcToLocal')(vm.data.PayMonDate).substr(0, 10) : "";   
          vm.data.PaySmsDate = !isNullOrEmpty(vm.data.PaySmsDate) ? $filter('autoViewUtcToLocal')(vm.data.PaySmsDate).substr(0, 10) : "";   

          vm.PayMonEnd = vm.data.ServiceExpireDate;
          vm.MonAmt = pay.setComma(vm.data.MonAmt);
          vm.PayServPoint = pay.setComma(vm.data.ServPoint);

          // 왼쪽 결제 정보에 데이터 삽입
          if (vm.data.PayType == "20")
          {
              vm.InfoPayMonEnd1 = "무제한";
          }
          else
          {
              if (!isNullOrEmpty(vm.data.ServiceExpireDate))
              {
                var week = ['일', '월', '화', '수', '목', '금', '토']; 
                vm.InfoPayMonEnd1 = vm.data.ServiceExpireDate + "(" + week[new Date(vm.data.ServiceExpireDate).getDay()] + ")";
              }
          }

          if (!isNullOrEmpty(vm.data.PayMonDate)) vm.InfoPayMonEnd2 = "최근결제일: " + vm.data.PayMonDate;
          if (!isNullOrEmpty(vm.data.ServPoint)) vm.InfoPaySmsRemAmt1 = pay.setComma(vm.data.ServPoint) + "원";
          if (!isNullOrEmpty(vm.data.PaySmsDate)) vm.InfoPaySmsRemAmt2 = "최근결제일: " + vm.data.PaySmsDate;

          if (isNullOrEmpty(vm.data.UserCnt) || vm.data.UserCnt == "0") vm.InfoPayUserCnt = "무제한";
          else vm.InfoPayUserCnt = vm.data.UserCnt + "명";

          vm.Merchant_uid = getMerchant_uid();      
        }
      }, function (error) {        
        console.log("error");
        // console.error("Error> getPayTenant()");
        // console.table(error);
      });    
    }      

    // 결제요청 건수
    function getPayReqCnt() {    
      var param = {
        mapCode: 'Pay.getPayReqListCnt',
        TenantId : $window.sessionStorage["loginTenantId"],                
        PayYN : 'N'
      };

      vm.PayReqCnt = 0;
      vm.ChkPayReqCnt = 0;
      vm.PayReqAmt = 0;

      postApi.select(param, function (data) {        
        if(data.header.status == CONSTANT.HttpStatus.OK) {                    
          if (!isNullOrEmpty(data.body.docs[0])) {
            vm.PayReqCnt = pay.setComma(data.body.docs[0]);
            vm.PayReqEnabled = true;
          }
        }
      }, function (error) {        
        console.log("error");
        // console.error("Error> getPayReqCnt()");
        // console.table(error);
      });              
    }

    // 부가세추출
    function getTax(num) {      
      return Math.round((num * 10) / 100);
    }

    // 결제추가
    vm.setPayAdd = function(type) {
      vm.TotPayMsgShow = false;

      switch (type) {
        case "mon":
          if (isNullOrEmpty(vm.PayMon)) {
            gAlert("", "연장개월을 선택해주세요.");
            return false;
          }

          if (isNullOrEmpty(vm.MonAmt) || vm.MonAmt == "0") {
            gAlert("", "월결제금액이 0원입니다.");                         
            return false;
          }

          vm.PayMonAmt = vm.MonAmt;
          vm.PayMonCnt = pay.setComma(vm.PayMon);
          vm.TotPayMonAmt = pay.setComma(parseInt(pay.delComma(vm.MonAmt) * parseInt(vm.PayMon)));

          // 기간연장 할인 적용
          setMonAmtDC();

          vm.TotPayMonAmtShow = true;

          break;

        case "sms":
          if (isNullOrEmpty(vm.PaySmsAmt) || vm.PaySmsAmt == "0") {
            gAlert("", "충전금액을 입력해주세요.");
            return false;
          }

          if (parseInt(pay.delComma(vm.PaySmsAmt)) < 1000) {
            gAlert("", "충전금액은 천원이상부터 가능합니다.");
            return false;
          }

          // 결제수단이 카드결제인 경우 가상계좌로 변경
          if (vm.PayMethod == "card") vm.PayMethod = "vbank";

          vm.TotPaySmsAmt = pay.setComma(vm.PaySmsAmt);
          vm.TotPaySmsAmtShow = true;

          break;

        case "req":
          if (isNullOrEmpty(vm.PayReqAmt) || vm.PayReqAmt == "0") {
            alert("총결제요청금액이 0원입니다.");
            return false;
          }

          vm.TotPayReqAmt = vm.PayReqAmt;
          vm.TotPayReqAmtShow = true;

          break;

        default : break;
      }

      setJoinAmt();
      setTotAmt();

      return false;
    };

    // 결제삭제 이벤트
    vm.setPayDel = function(type) {    
      switch (type) {
        case "mon":
          vm.PayMonAmt = "0";
          vm.PayMonCnt = "0";
          vm.TotPayMonAmt = "0";
          vm.TotPayMonAmtShow = false;
          vm.TotPayMonDC = "";
          break;

        case "sms":
          vm.TotPaySmsAmt = "0";
          vm.TotPaySmsAmtShow = false;
          break;

        case "req":
          vm.TotPayReqAmt = "0";
          vm.TotPayReqAmtShow = false;
          break;          
      }

      setJoinAmt();
      setTotAmt();
    };

    // 기간연장 할인 적용             
    function setMonAmtDC() {
      var amt = 0;
      var dcAmt = 0;
      var dcRate = 0;

      if (vm.PayMon == "6") dcRate = 5;
      else if (vm.PayMon == "12") dcRate = 10;
      else if (vm.PayMon == "24") dcRate = 15;
      else vm.TotPayMonDC = "";

      if (dcRate > 0 && !isNullOrEmpty(vm.TotPayMonAmt) && vm.TotPayMonAmt != "0") {
          amt = parseInt(pay.delComma(vm.TotPayMonAmt));
          dcAmt = Math.round((amt * dcRate) / 100);
          
          vm.TotPayMonAmt = pay.setComma(amt - dcAmt);
          vm.TotPayMonDC = "(할인 " + dcRate + "% 적용)";
      }
    }

    // 가입비 표시
    function setJoinAmt() {    
      if (!isNullOrEmpty(vm.data.JoinAmt) && vm.data.JoinAmt != "0") {
        if ((!isNullOrEmpty(vm.TotPayMonAmt) && vm.TotPayMonAmt != "0") 
          || (!isNullOrEmpty(vm.TotPaySmsAmt) && vm.TotPaySmsAmt != "0") 
          || (!isNullOrEmpty(vm.TotPayReqAmt) && vm.TotPayReqAmt != "0")
        ) {
            vm.TotPayJoinAmt = pay.setComma(vm.data.JoinAmt);
            vm.TotPayJoinAmtShow = true;
        }
        else {
            vm.TotPayJoinAmt = "0";
            vm.TotPayJoinAmtShow = false;
        }
      }
    }

    // 최종 결제금액 표시    
    function setTotAmt() {      
      var totPayAmt = 0;

      totPayAmt = parseInt(pay.delComma(vm.TotPayJoinAmt))
        + parseInt(pay.delComma(vm.TotPayMonAmt))
        + parseInt(pay.delComma(vm.TotPaySmsAmt))
        + parseInt(pay.delComma(vm.TotPayReqAmt));

      if (totPayAmt > 0) {        
        vm.SupAmt = totPayAmt;
        vm.TaxAmt = getTax(vm.SupAmt);        
        vm.TotPayAmt = pay.setComma(vm.SupAmt + vm.TaxAmt);
      }
      else {
        vm.SupAmt = 0;
        vm.TaxAmt = 0;
        vm.TotPayAmt = 0;
      }
    }

    // 상품명 생성
    function setPayTitle() {  
      var tit = "";

      if (!isNullOrEmpty(vm.TotPayJoinAmt) && vm.TotPayJoinAmt != "0") tit += "가입비";
      if (!isNullOrEmpty(vm.TotPayMonAmt) && vm.TotPayMonAmt != "0") tit += (tit != "" ? "," : "") + "기간연장";
      if (!isNullOrEmpty(vm.TotPaySmsAmt) && vm.TotPaySmsAmt != "0") tit += (tit != "" ? "," : "") + "SMS충전";
      if (!isNullOrEmpty(vm.TotPayReqAmt) && vm.TotPayReqAmt != "0") tit += (tit != "" ? "," : "") + "결제요청건";

      tit = "[셀비스케어] 이용료결제(" + tit + ")";

      return tit;
    }
  

    // merchant_uid 생성
    function getMerchant_uid() {  
      var rtn = "";

      // 시큐어코딩으로 주석 후 수정 (2023-07-06 )
      // var rndNum = Math.floor(10 + Math.random() * 90);

      var array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      var rndNum = Math.floor(array[0] / (Math.pow(2, 32) - 1) * 90 + 10);

      var d = new Date();      
      rtn = (d.getFullYear() + "").substring(2, 4) + "" + pay.setZero(d.getMonth() + 1) + "" + pay.setZero(d.getDate()) + "" + pay.setZero(d.getHours()) + "" + pay.setZero(d.getMinutes()) + "" + pay.setZero(d.getSeconds()) + "" + rndNum;

      return rtn;
    }        

    // 금액변경
    vm.chgPaySmsAmt = function() {
      vm.PaySmsAmt = pay.setComma(Math.floor(pay.delComma(vm.PaySmsAmt) / 1000) * 1000);
    };    

    // 결제버튼 클릭 이벤트
    vm.setPay = function() {      
      chkPay();
    };

    // 결제 검증 (외부)
    function chkPay() {
      var param = {};
      var rtn = "";

      if (isNullOrEmpty($window.sessionStorage['loginUserIdx'])) {
          return false;
      }

      if (isNullOrEmpty(vm.TotPayAmt) || vm.TotPayAmt == "0") {
          gAlert("", "결제를 추가해주세요.");
          return false;
      }

      if (isNullOrEmpty(vm.PayMethod)) {
        gAlert("", "결제수단을 선택해주세요.");
        return false;
      }

      if (!isNullOrEmpty(vm.TotPaySmsAmt) && vm.TotPaySmsAmt != "0" && vm.PayMethod == "card") {
          alert("SMS충전은 금융사의 환금성 정책으로 카드결제가 불가능합니다.\n\r실시간 계좌이체 또는 가상계좌를 이용해주세요.");
          return false;
      }

      // 결제 데이터 검증
      param.pay_method = vm.PayMethod;
      param.TaxAmt = vm.TaxAmt;
      param.SupAmt = vm.SupAmt;        
      
      if (!isNullOrEmpty(vm.TotPayMonAmt) && vm.TotPayMonAmt != "0") param.PayMon = vm.PayMon;
      if (!isNullOrEmpty(vm.TotPaySmsAmt) && vm.TotPaySmsAmt != "0") param.PaySmsSupAmt = pay.delComma(vm.TotPaySmsAmt);
      if (!isNullOrEmpty(vm.TotPayJoinAmt) && vm.TotPayJoinAmt != "0") param.PayJoinSupAmt = pay.delComma(vm.TotPayJoinAmt);
      if (!isNullOrEmpty(vm.TotPayReqAmt) && vm.TotPayReqAmt != "0") {
        param.PayReqSupAmt = pay.delComma(vm.TotPayReqAmt);      
        param.PayReqInfo = [];
        
        vm.payReqInfo.forEach(function(item) {                 
          param.PayReqInfo.push({
            PayReqId: item.payReqId         
          }); 
        });
      }

      // 결제 데이터 검증
      var prms = payApi.doChkPay().post(param).$promise;      
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {          
          if (data.responseVO.body.docCnt > 0) {    
            rtn = data.responseVO.body.docs[0].message;

            if (rtn == "SUCC_000") {
              setPayData();              
            }
            else {
              gAlert("", "결제에 실패하였습니다.");           
            }
          }          
        }
        else {
          gAlert("", "결제에 실패하였습니다.");
        }
      }, function (error) {        
        console.log("error");
        // console.error("Error> chkPay()");
        // console.table(error);
      });
    }

    // 결제 등록 (내부검증)
    function setPayData() {
      var IMP = window.IMP; 
      var param = {};
      var rtn = "";

      IMP.init(pay.PG_KEY);
      IMP.request_pay({ 
        pg: "danal",
        bypass: {
          danal: {
              ISCASHRECEIPTUI: 'N'
          }
        },
        pay_method: vm.PayMethod,
        merchant_uid: vm.Merchant_uid,
        name: setPayTitle(),
        amount: pay.delComma(vm.TotPayAmt),
        buyer_email: $window.sessionStorage['loginEmail'],
        buyer_name: vm.sessionTenantName,
        buyer_tel: $window.sessionStorage['loginMobile'],
        buyer_addr: "",
        buyer_postcode: "",
        notice_url: pay.PG_NOTIURL
      }, function (rsp) {         
        if (rsp.success) {                              
          param.merchant_uid = rsp.merchant_uid;
          param.imp_uid = rsp.imp_uid;
          param.pay_method = rsp.pay_method;
          param.paid_amount = rsp.paid_amount;
          param.status = rsp.status;
          param.name = rsp.name;
          param.buyer_name = rsp.buyer_name;
          param.buyer_email = rsp.buyer_email;
          param.buyer_tel = rsp.buyer_tel;
          param.paid_at = rsp.paid_at;
          param.receipt_url = rsp.receipt_url;
          param.apply_num = rsp.apply_num;
          param.vbank_num = (typeof (rsp.vbank_num) != "undefined" ? rsp.vbank_num : "");
          param.vbank_name = (typeof (rsp.vbank_name) != "undefined" ? rsp.vbank_name : "");
          param.vbank_holder = (typeof (rsp.vbank_holder) != "undefined" ? rsp.vbank_holder : "");
          param.vbank_date = (typeof (rsp.vbank_date) != "undefined" ? rsp.vbank_date : "");
          param.TaxAmt = vm.TaxAmt;
          param.SupAmt = vm.SupAmt;               
          
          if (!isNullOrEmpty(vm.TotPayMonAmt) && vm.TotPayMonAmt != "0") {
            param.PayMon = vm.PayMon;
            param.PayMonTaxAmt = getTax(pay.delComma(vm.TotPayMonAmt));
            param.PayMonSupAmt = pay.delComma(vm.TotPayMonAmt);   
          }
    
          if (!isNullOrEmpty(vm.TotPaySmsAmt) && vm.TotPaySmsAmt != "0") {
            param.PaySmsTaxAmt = getTax(pay.delComma(vm.TotPaySmsAmt));
            param.PaySmsSupAmt = pay.delComma(vm.TotPaySmsAmt);
          }
    
          if (!isNullOrEmpty(vm.TotPayJoinAmt) && vm.TotPayJoinAmt != "0") {
            param.PayJoinTaxAmt = getTax(pay.delComma(vm.TotPayJoinAmt));
            param.PayJoinSupAmt = pay.delComma(vm.TotPayJoinAmt);
          }

          if (!isNullOrEmpty(vm.TotPayReqAmt) && vm.TotPayReqAmt != "0") {
            param.PayReqtaxAmt = getTax(pay.delComma(vm.TotPayReqAmt));
            param.PayReqSupAmt = pay.delComma(vm.TotPayReqAmt);
            param.PayReqInfo = [];

            vm.payReqInfo.forEach(function(item) {                 
              param.PayReqInfo.push({
                PayReqId: item.payReqId,
                TaxAmt: getTax(pay.delComma(item.reqAmt)),
                SupAmt: pay.delComma(item.reqAmt)
              }); 
            });
          }

          var prms = payApi.doInsertPay().post(param).$promise;      
          prms.then(function(data) {
            if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {          
              if (data.responseVO.body.docCnt > 0) {    
                rtn = data.responseVO.body.docs[0].message;
                
                if (rtn == "SUCC_100") {                  
                  gConfirm('', '결제에 성공하였습니다.<br />이용기간이 만료된 상태인 경우 결제창을 닫고 다시 로그인해주세요.<br />결제내역 조회페이지로 이동하시겠습니까?', {                
                    btn: '', fn: function () {
                      $scope.$parent.$parent.vc.setChangeTab("1", "VIEW_PAGE_PAYHIST");
                    }
                  }, {
                    btn: '', fn: function () {
                      getPayTenant();
                    }
                  });                                     
                }
                else {
                  gAlert("", "결제에 실패하였습니다.");
                }
              }                        
            }
            else {
              gAlert("", "결제에 실패하였습니다.");
            }
          }, function (error) {        
            console.log("error");
            // console.error("Error> setPayData()");
            // console.table(error);
          });                 
        } 
        else {  
          gAlert("", "결제에 실패하였습니다.");
        }
      });
    }    

    // 결제요청 선택 팝업
    vm.payReqModal = function () {
      var ctrl = 'PayReqModalCtrl as vc';
      var paramData = {};
      var modalInstance = modalFactory.open('modal', 'components/modal/pay/pay-req-modal.html', ctrl, paramData);
      var totPayReqAmt = 0;

      modalInstance.result.then(function (okData) {                                                        
        okData.forEach(function(item) { totPayReqAmt += parseInt(item.reqAmt); });

        vm.ChkPayReqCnt = pay.setComma(okData.length);
        vm.PayReqAmt = pay.setComma(totPayReqAmt);

        angular.copy(okData, vm.payReqInfo);
      }, function (cancelData) { });
    };    

    function init() {      
      vm.sessionTenantName = $window.sessionStorage['loginTenantName'];
      vm.sessionUserName = $window.sessionStorage['loginUserName'];      

      vm.PayMonEnabled = true;
      vm.PayReqEnabled = false;
      vm.PayMonEnd = "0000-00-00";
      vm.MonAmt = "0";
      vm.PayServPoint = "0";
      vm.PayMon = "1";

      vm.InfoPayMonEnd2 = "최근 결제일:";
      vm.InfoPaySmsRemAmt1 = "0";
      vm.InfoPaySmsRemAmt2 = "최근 결제일:";
      vm.InfoPayUserCnt = "0";

      vm.TotPayMsgShow = true;
      vm.TotPayJoinAmtShow = false;
      vm.TotPayMonAmtShow = false;
      vm.TotPaySmsAmtShow = false;
      vm.TotPayReqAmtShow = false;

      getPayTenant();
      getPayReqCnt();
    }

    init();
  }]);
})();
webapp.controller('TenantModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state',
    function TenantModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10,
        Ceo :'',
      };

      vm.selectedTenantId = toModalData.TenantId;
      if (toModalData.showBaseTenant == undefined || toModalData.showBaseTenant == null) {
        vm.showBaseTenant = 'Y';
      } else if(toModalData.showBaseTenant != undefined && toModalData.showBaseTenant != '') {
        if(!toModalData.showBaseTenant) vm.showBaseTenant = 'N';
        else vm.showBaseTenant = 'Y';
      } else if (!toModalData.showBaseTenant) {
        vm.showBaseTenant = 'N';
      } else {
        vm.showBaseTenant = 'Y';
      }

      (function TenantModalCtrl() {
        getList();
      })();
      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant,
          page : vm.srch.page,
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){

          getCnt(true);

          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {

          getCnt(false);

          data.showBaseTenant = vm.showBaseTenant;
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        }


      }

      function getCnt(checkSession) {
        var data = {
          mapCode: 'Tenant.getTenantSrchCnt',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant
        };

        if(checkSession) {
          data.mapCode= 'Tenant.getTenantSrchCnt';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        } else {
          data.mapCode= 'getTenantSrchCnt';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        }
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('Tenant2ModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function Tenant2ModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;


      vm.srch = {
		    TenantNm : '',
        TenantId : toModalData.TenantId,
        viewSize : 10
		  };

      (function TenantModalCtrl() {
        getList();
      })();


      function getList() {
        var data = {
          mapCode: 'Tenant.getTenantSrch', TenantNm : vm.srch.TenantNm, TenantId : toModalData.TenantId
        };
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.tenantlists = result.body.docs;
            vm.totalItems = result.body.docCnt;

          }
        });
      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('UserExcelUploadModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'gAlert', '$timeout', 'postApi',
  function UserExcelUploadModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, gAlert, $timeout, postApi) {
    var vm = this;
    vm.excelExport = excelExport;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.data = {
      list : []
    };

    function excelExport() {
      var input = document.getElementById("excelFile");
      var reader = new FileReader();
      var index = 0;

      reader.onload = function(){
        var fileData = reader.result;
        var wb = XLSX.read(fileData, {type : 'binary'});
        wb.SheetNames.forEach(function(sheetName){
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          vm.user = angular.copy(rowObj);
          index++;
        });
        $timeout(function(){
          afterData();
        }, 500);
      };
      reader.readAsBinaryString(input.files[0]);
    }

    function afterData() {
      vm.msg = "엑셀 데이터를 추출합니다. 잠시 기다려주세요.";
      $timeout(function(){
        chkUserData();
      }, 1000);
    }

    function chkUserData() {
      var dupLoginId = [];
      var emptyCnt = 0;
      var chkValidPswd = true;
      angular.forEach(vm.user, function (item) {
        var temp = {
          LoginId: item["아이디(필수)"],
          Password:  item["비밀번호(필수)"],
          UserNm: item["사용자명(필수)"],
          CompanyNm: item["소속(필수)"],
          UserType: item["사용자구분(필수)(위탁사(PM,행정) / 교육원(사업담당자) / 상담사(멘토))"],
          TenantId: item["사업정보 - 사업명(필수)"],
          UseYN : item["사용여부(필수)(Y/N)"],
          Mobile: item["휴대폰"],
          Email: item["이메일(필수)"],
          ArmyAreaNm: item["권역"],
          EmpmCnsltTrg: item["취업컨설팅 대상(장기/중기/단기/병사)"],
        };
        if(temp.LoginId == null
        || temp.Password == null
        || temp.UserNm == null
        || temp.CompanyNm == null
        || temp.UserType == null
        || temp.TenantId == null
        || temp.UseYN == null
        || temp.Email == null) {
          emptyCnt += 1;
        }
        angular.forEach(vm.user, function (item) {
          if (item.LoginId == temp.LoginId) {
            dupLoginId.push(temp.LoginId);
            return;
          }

          if(chkValidPswd && !checkPassword(temp.Password)) {
            chkValidPswd = false;
            return;
          }
        });

        if(!chkValidPswd) return;
        
        /* if (temp.ArmyAreaNm == '1권역') {
          temp.ArmyArea = '010';
        } else if (temp.ArmyAreaNm == '2권역') {
          temp.ArmyArea = '020';
        } else if (temp.ArmyAreaNm == '3권역') {
          temp.ArmyArea = '030';
        } else if (temp.ArmyAreaNm == '4권역') {
          temp.ArmyArea = '040';
        } else {
          temp.ArmyArea = '050';
        } */
        temp.ArmyArea= temp.ArmyAreaNm;
        vm.data.list.push(temp);
      });

      if(!chkValidPswd) return;

      var data = vm.data;
      if(emptyCnt > 0) {
        gAlert('', '필수값이 누락되있는 데이터가 있습니다.');
        vm.msg = '다시 등록하시기 바랍니다.';
        $("#excelFile").val("");
        return ;
      }
      if (dupLoginId.length > 0) {
        gAlert('', '중복된 로그인ID가 있습니다.<br/>(' + dupLoginId + ')');
        vm.msg = '다시 등록하시기 바랍니다.';
        $("#excelFile").val("");
        return ;
      } else {
        data.mapCode = 'User.getUserExcelLoginIdDupChk';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var dupUserLoginId = [];
              angular.forEach(result.body.docs, function (item) {
                dupUserLoginId.push(item.LoginId);
              });
              gAlert('', '중복된 로그인ID가 있습니다.<br/>(' + dupUserLoginId + ')');
              vm.msg = '다시 등록하시기 바랍니다.';
              $("#excelFile").val("");
              return;
            } else {
              ArmyAreaChk();
            }
          } else {
            console.info("else ");
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> userExcelUpload-modal-ctrl> getUserExcelLoginIdDupChk()', status, error);
        });
      }

      /* data.mapCode = 'User.getChkTenantId';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == vm.data.list.length){
            setUserData();
          }
          else {
            gAlert('', '사업정보와 권역이 맞지 않습니다.');
            vm.msg = '다시 등록하시기 바랍니다.';
            $("#excelFile").val("");
            return ;
          }
        } else {
          console.info("else ");
        }
      }, function(error) {
        console.error('Error> userExcelUpload-modal-ctrl> getChkTenantId()', status, error);
        vm.dataloader = false;
      });
        */

    }

    function ArmyAreaChk() {
      var data = vm.data;
      data.mapCode = 'User.getChkTenantId';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == vm.data.list.length){
            setUserData();
          }
          else {
            gAlert('', '사업정보와 권역이 맞지 않습니다.');
            vm.msg = '다시 등록하시기 바랍니다.';
            $("#excelFile").val("");
            return ;
          }
        } else {
          console.info("else ");
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> userExcelUpload-modal-ctrl> getChkTenantId()', status, error);
        vm.dataloader = false;
      });
    }


    function setUserData() {
      var data = vm.data;
      data.mapCode = 'User.insertUserExcelUpload';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /* gAlert('', '정상 업로드 되었습니다.', {
            btn : '',
            fn : function() {
              ok();
            }
          }); */
          //$timeout(function(){
            setUserInfoData();
          //}, 500);
        } else {
          console.info("else ");
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> userExcelUpload-modal-ctrl> insertUserExcelUpload()', status, error);
        vm.dataloader = false;
      });
    }


    function setUserInfoData() {
      var data = vm.data;
      data.list = data.list.reduce(function(acc,cur){
        if(cur.ArmyArea)
          acc.push(cur);
          return acc;
      },[]);
      if(data.list.length){
        data.mapCode = 'User.insertUserInfoExcelUpload';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '정상 업로드 되었습니다.', {
              btn : '',
              fn : function() {
                ok();
              }
            });
          } else {
            console.info("else ");
          }
        }, function(error) {
          console.log("error");
          // console.error('Error> userExcelUpload-modal-ctrl> insertUserInfoExcelUpload()', status, error);
          vm.dataloader = false;
        });
      } else {
        gAlert('', '정상 업로드 되었습니다.', {
          btn : '',
          fn : function() {
            ok();
          }
        });
      }
    }
    
    function checkPassword(password) {
      if (!/^(?=.*[a-zA-Z])(?=.*[~!@#$%^*+=-])(?=.*[0-9]).{8,16}$/.test(password)) {
        alert('비밀번호는 숫자+영문자+특수문자 조합으로 8자리 이상 16자리 이하로 사용해야 합니다.');
        return false;
      }
      var checkNumber = password.search(/[0-9]/g);
      var checkEnglish = password.search(/[a-z]/gi);
      if (checkNumber < 0 || checkEnglish < 0) {
        alert('비밀번호는 숫자와 영문자를 혼용하여야 합니다.');
        return false;
      }
      if (/(\w)\1\1/.test(password)) {
        alert('비밀번호는 같은 문자를 3번 이상 사용하실 수 없습니다.');
        return false;
      }
      return true;
    }


    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok() {
      $uibModalInstance.close();
    }

    function sampleDownload() {

    }
  } 
]);

webapp.controller('UserroleModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserroleModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {
      var vm = this;

      vm.UserRoles = [];
      if (!isNullOrEmpty(toModalData.UserRoles))
        vm.UserRoles = toModalData.UserRoles;

      vm.data = {list:[]};

      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.IsRole = IsRole;
      vm.addRole = addRole;
      vm.querySearch = querySearch;
      vm.onRemoveChip = onRemoveChip;
      vm.filterSelected = true;

      (function UserroleModalCtrl() {
        // search
        vm.searchValue = '';
        vm.selectPeriod = 'all';
        vm.startDate = '';
        vm.endDate = '';
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        // 검색 선택 옵션
        vm.searchFieldTypeList = [ {
          optionId : 'UserNm',
          optionName : '이름'
        } ];
        vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.list = [];
        getList();
      })();
      function changeViewSize() {
        getList();
      }
      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          searchFieldType : vm.searchFieldType,
          RoleNm : vm.searchValue,
          selectPeriod : vm.selectPeriod,
          TenantId : toModalData.TenantId
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();

        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleList';

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.data.list = result.body.docs;
            } else {
              vm.totalCount = 0;
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        });
      }

      function getListCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleListCnt';

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
        }, function(error) {
          console.log("error");
          // console.error('Error-getList', status, data);
        });
      }

      function IsRole(role) {

        if(vm.UserRoles != null && vm.UserRoles != undefined && vm.UserRoles != ""){

          for (i = 0; i < vm.UserRoles.length; i++) {
            if (role.RoleId == vm.UserRoles[i].RoleId)
              return true;
          }
        }
        return false;
      }

      function addRole(RoleId) {
        for (var i = 0; i < vm.data.list.length; i++) {
          if (vm.data.list[i].RoleId == RoleId) {
            vm.UserRoles.push(vm.data.list[i]);
            break;
          }
        }
      }

      /**
       * Search for contacts.
       */
      function querySearch(query) {
        var results = query ? vm.data.list.filter(createFilterFor(query)) : [];
        return results;
      }
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        return function filterFn(role) {
          return (role.RoleNm.indexOf(query) != -1);
        };
      }

      function onRemoveChip(item) {
        // console.log('item=', item);
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.UserRoles);
      }

    } ]);

webapp.controller('UserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;
      vm.ContactsYN = toModalData.ContactsYN;
      if(toModalData.ContactsYN == undefined) vm.ContactsYN = false;

      (function UserModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
        getUserList();
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : ''
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        if (!vm.ContactsYN) {
          data.mapCode = 'User.getUserModalList';
        } else {
          data.mapCode = 'FreeChat.getUserModalList';
        }
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        if (!vm.ContactsYN) {
          data.mapCode = 'User.getUserModalListCnt';
        } else {
          data.mapCode = 'FreeChat.getUserModalListCnt';
        }
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.log("error");
          // console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

/* 'use strict'; */

/**
 * @ngdoc function
 * @name minovateApp.controller:UiGeneralCtrl
 * @description
 * # UiGeneralCtrl
 * Controller of the minovateApp
 */
webapp
  .controller('GeneralCtrl', function ($scope) {
    $scope.page = {
      title: 'General Elements',
      subtitle: 'Place subtitle here...'
    };
  })

  .controller('ProgressDemoCtrl', function ($scope) {
    $scope.max = 200;

    $scope.random = function() {
      var value = Math.floor((Math.random() * 100) + 1);
      var type;

      if (value < 25) {
        type = 'success';
      } else if (value < 50) {
        type = 'info';
      } else if (value < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      $scope.showWarning = (type === 'danger' || type === 'warning');

      $scope.dynamic = value;
      $scope.type = type;
    };

    $scope.random();

    $scope.randomStacked = function() {
      $scope.stacked = [];
      var types = ['success', 'info', 'warning', 'danger'];

      for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
          var index = Math.floor((Math.random() * 4));
          $scope.stacked.push({
            value: Math.floor((Math.random() * 30) + 1),
            type: types[index]
          });
      }
    };

    $scope.randomStacked();
  })

  .controller('RatingDemoCtrl', function ($scope) {
    $scope.rate = 7;
    $scope.max = 10;
    $scope.isReadonly = false;

    $scope.hoveringOver = function(value) {
      $scope.overStar = value;
      $scope.percent = 100 * (value / $scope.max);
    };
  })

  .controller('ButtonsCtrl', function ($scope) {
    $scope.singleModel = 1;

    $scope.radioModel = 'Middle';

    $scope.checkModel = {
      left: false,
      middle: true,
      right: false
    };
  })

  .controller('CarouselDemoCtrl', function ($scope) {
    $scope.myInterval = 5000;
    $scope.noWrapSlides = false;
    var slides = $scope.slides = [];
    $scope.addSlide = function() {
      var newWidth = 801 + slides.length + 1;
      slides.push({
        image: '//placekitten.com/' + newWidth + '/300',
        text: ['More','Extra','Lots of','Surplus'][slides.length % 4] + ' ' +
        ['Cats', 'Kittys', 'Felines', 'Cutes'][slides.length % 4]
      });
    };
    for (var i=0; i<4; i++) {
      $scope.addSlide();
    }
  })

  .controller('TooltipDemoCtrl', function ($scope, $sce) {
    $scope.dynamicTooltip = 'Hello, World!';
    $scope.dynamicTooltipText = 'dynamic';
    $scope.htmlTooltip = $sce.trustAsHtml('I\'ve been made <b>bold</b>!');
  })

  /* jshint ignore:start */
  .controller('TypeaheadCtrl', function($scope, $http) {

    $scope.selected = undefined;
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

    // Any function returning a promise object can be used to load values asynchronously
    $scope.getLocation = function(val) {
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: val,
          sensor: false
        }
      }).then(function(response){
        return response.data.results.map(function(item){
          return item.formatted_address;
        });
      });

    };

    $scope.statesWithFlags = [{'name':'Alabama','flag':'5/5c/Flag_of_Alabama.svg/45px-Flag_of_Alabama.svg.png'},{'name':'Alaska','flag':'e/e6/Flag_of_Alaska.svg/43px-Flag_of_Alaska.svg.png'},{'name':'Arizona','flag':'9/9d/Flag_of_Arizona.svg/45px-Flag_of_Arizona.svg.png'},{'name':'Arkansas','flag':'9/9d/Flag_of_Arkansas.svg/45px-Flag_of_Arkansas.svg.png'},{'name':'California','flag':'0/01/Flag_of_California.svg/45px-Flag_of_California.svg.png'},{'name':'Colorado','flag':'4/46/Flag_of_Colorado.svg/45px-Flag_of_Colorado.svg.png'},{'name':'Connecticut','flag':'9/96/Flag_of_Connecticut.svg/39px-Flag_of_Connecticut.svg.png'},{'name':'Delaware','flag':'c/c6/Flag_of_Delaware.svg/45px-Flag_of_Delaware.svg.png'},{'name':'Florida','flag':'f/f7/Flag_of_Florida.svg/45px-Flag_of_Florida.svg.png'},{'name':'Georgia','flag':'5/54/Flag_of_Georgia_%28U.S._state%29.svg/46px-Flag_of_Georgia_%28U.S._state%29.svg.png'},{'name':'Hawaii','flag':'e/ef/Flag_of_Hawaii.svg/46px-Flag_of_Hawaii.svg.png'},{'name':'Idaho','flag':'a/a4/Flag_of_Idaho.svg/38px-Flag_of_Idaho.svg.png'},{'name':'Illinois','flag':'0/01/Flag_of_Illinois.svg/46px-Flag_of_Illinois.svg.png'},{'name':'Indiana','flag':'a/ac/Flag_of_Indiana.svg/45px-Flag_of_Indiana.svg.png'},{'name':'Iowa','flag':'a/aa/Flag_of_Iowa.svg/44px-Flag_of_Iowa.svg.png'},{'name':'Kansas','flag':'d/da/Flag_of_Kansas.svg/46px-Flag_of_Kansas.svg.png'},{'name':'Kentucky','flag':'8/8d/Flag_of_Kentucky.svg/46px-Flag_of_Kentucky.svg.png'},{'name':'Louisiana','flag':'e/e0/Flag_of_Louisiana.svg/46px-Flag_of_Louisiana.svg.png'},{'name':'Maine','flag':'3/35/Flag_of_Maine.svg/45px-Flag_of_Maine.svg.png'},{'name':'Maryland','flag':'a/a0/Flag_of_Maryland.svg/45px-Flag_of_Maryland.svg.png'},{'name':'Massachusetts','flag':'f/f2/Flag_of_Massachusetts.svg/46px-Flag_of_Massachusetts.svg.png'},{'name':'Michigan','flag':'b/b5/Flag_of_Michigan.svg/45px-Flag_of_Michigan.svg.png'},{'name':'Minnesota','flag':'b/b9/Flag_of_Minnesota.svg/46px-Flag_of_Minnesota.svg.png'},{'name':'Mississippi','flag':'4/42/Flag_of_Mississippi.svg/45px-Flag_of_Mississippi.svg.png'},{'name':'Missouri','flag':'5/5a/Flag_of_Missouri.svg/46px-Flag_of_Missouri.svg.png'},{'name':'Montana','flag':'c/cb/Flag_of_Montana.svg/45px-Flag_of_Montana.svg.png'},{'name':'Nebraska','flag':'4/4d/Flag_of_Nebraska.svg/46px-Flag_of_Nebraska.svg.png'},{'name':'Nevada','flag':'f/f1/Flag_of_Nevada.svg/45px-Flag_of_Nevada.svg.png'},{'name':'New Hampshire','flag':'2/28/Flag_of_New_Hampshire.svg/45px-Flag_of_New_Hampshire.svg.png'},{'name':'New Jersey','flag':'9/92/Flag_of_New_Jersey.svg/45px-Flag_of_New_Jersey.svg.png'},{'name':'New Mexico','flag':'c/c3/Flag_of_New_Mexico.svg/45px-Flag_of_New_Mexico.svg.png'},{'name':'New York','flag':'1/1a/Flag_of_New_York.svg/46px-Flag_of_New_York.svg.png'},{'name':'North Carolina','flag':'b/bb/Flag_of_North_Carolina.svg/45px-Flag_of_North_Carolina.svg.png'},{'name':'North Dakota','flag':'e/ee/Flag_of_North_Dakota.svg/38px-Flag_of_North_Dakota.svg.png'},{'name':'Ohio','flag':'4/4c/Flag_of_Ohio.svg/46px-Flag_of_Ohio.svg.png'},{'name':'Oklahoma','flag':'6/6e/Flag_of_Oklahoma.svg/45px-Flag_of_Oklahoma.svg.png'},{'name':'Oregon','flag':'b/b9/Flag_of_Oregon.svg/46px-Flag_of_Oregon.svg.png'},{'name':'Pennsylvania','flag':'f/f7/Flag_of_Pennsylvania.svg/45px-Flag_of_Pennsylvania.svg.png'},{'name':'Rhode Island','flag':'f/f3/Flag_of_Rhode_Island.svg/32px-Flag_of_Rhode_Island.svg.png'},{'name':'South Carolina','flag':'6/69/Flag_of_South_Carolina.svg/45px-Flag_of_South_Carolina.svg.png'},{'name':'South Dakota','flag':'1/1a/Flag_of_South_Dakota.svg/46px-Flag_of_South_Dakota.svg.png'},{'name':'Tennessee','flag':'9/9e/Flag_of_Tennessee.svg/46px-Flag_of_Tennessee.svg.png'},{'name':'Texas','flag':'f/f7/Flag_of_Texas.svg/45px-Flag_of_Texas.svg.png'},{'name':'Utah','flag':'f/f6/Flag_of_Utah.svg/45px-Flag_of_Utah.svg.png'},{'name':'Vermont','flag':'4/49/Flag_of_Vermont.svg/46px-Flag_of_Vermont.svg.png'},{'name':'Virginia','flag':'4/47/Flag_of_Virginia.svg/44px-Flag_of_Virginia.svg.png'},{'name':'Washington','flag':'5/54/Flag_of_Washington.svg/46px-Flag_of_Washington.svg.png'},{'name':'West Virginia','flag':'2/22/Flag_of_West_Virginia.svg/46px-Flag_of_West_Virginia.svg.png'},{'name':'Wisconsin','flag':'2/22/Flag_of_Wisconsin.svg/45px-Flag_of_Wisconsin.svg.png'},{'name':'Wyoming','flag':'b/bc/Flag_of_Wyoming.svg/43px-Flag_of_Wyoming.svg.png'}];
  })
  /* jshint ignore:end */

  .controller('DropdownCtrl', function ($scope) {

     $scope.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];

    $scope.status = {
      isopen: false
    };

    $scope.toggled = function(open) {
      console.log('Dropdown is now: ', open);
    };

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };
  })

  .controller('DatepickerDemoCtrl', function ($scope) {

    $scope.today = function() {
      $scope.dt = new Date();
    };

    $scope.today();

    $scope.clear = function () {
      $scope.dt = null;
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.toggleMin = function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 0,
      showWeeks: false,
      'class': 'datepicker'
    };

    $scope.formats = ['yyyy-MM-dd', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];

    $scope.processDate = function (dt) {
      return $filter('date')(dt, 'yyyy-MM-dd');
    }
  })

  .controller('TimepickerDemoCtrl', function ($scope) {
    $scope.mytime = new Date();

    $scope.hstep = 1;
    $scope.mstep = 15;

    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };

    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = ! $scope.ismeridian;
    };

    $scope.update = function() {
      var d = new Date();
      d.setHours( 14 );
      d.setMinutes( 0 );
      $scope.mytime = d;
    };

    $scope.changed = function () {
      console.log('Time changed to: ' + $scope.mytime);
    };

    $scope.clear = function() {
      $scope.mytime = null;
    };
  })

  .controller('PaginationDemoCtrl', function ($scope) {
    $scope.totalItems = 64;
    $scope.currentPage = 4;

    $scope.setPage = function (pageNo) {
      $scope.currentPage = pageNo;
    };

    $scope.pageChanged = function() {
      console.log('Page changed to: ' + $scope.currentPage);
    };

    $scope.maxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;
  })

  .controller('PopoverDemoCtrl', function ($scope) {
    $scope.dynamicPopover = 'Hello, World!';
    $scope.dynamicPopoverTitle = 'Title';
  });

(function() {
  webapp
  .factory('dock', function() {
    var valids = [ 'left', 'right', 'top', 'bottom', 'fill' ];
    return {
      dockRefs: {},
      valids: valids,
      handlesByDock: {
        "top": "s",
        "left": "e",
        "right": "w",
        "bottom": "n"
      },
      Area: (function() {
        function setPosition(r, s, pos) {
            r.position = 'absolute';
            if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
            if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
            if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
            if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
        }
        function decreaseSize($element, pos, s) {
            var size = 0;
            if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
            if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
            if (pos == "bottom") s.bottom += size;
            if (pos == "left")   s.left   += size;
            if (pos == "right")  s.right  += size;
            if (pos == "top")    s.top    += size;
        }
        function removeClasses($element){
          var x = valids.length;
          while(x--)
            $element.removeClass("dock-" + valids[x]);
        }
        function update($element, pos, s) {
            var r = {};
            removeClasses($element);
            setPosition(r, s, pos);
            $element.addClass("dock-" + pos);
            $element.css(r);
            decreaseSize($element, pos, s);
        }
        var Area = function($div, $scope) {
          var s = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          };
          var childList = [];
          this.addChild = function($element, $pos) {
            var pos = $scope.$eval($pos);
            console.log('pos=', pos);

            if (valids.indexOf(pos) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            childList.push({
              element: $element,
              pos: $pos,
              order: childList.length
            });
            update($element, pos, s);
          };
          this.refresh = function() {
            s.top = 0;
            s.bottom = 0;
            s.left = 0;
            s.right= 0;
            for (var x = 0; x < childList.length; x++) {
              var pos = $scope.$eval(childList[x].pos);
              update(childList[x].element, pos, s);
            }
          };

          var _this = this;
          $(window).resize(function() {
            _this.refresh();
          });
          $scope.$watch(function() {
            _this.refresh();
          });
        };
        return Area;
      })()
    };
  })
  .directive('dockRef', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
        dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
      },
      scope: true
    };
  })
  .directive('dock', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $element.attr('dock');
        $scope.__dock_id = String(Math.random()).replace(/\./g, "");
        var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
        area.addChild($element, dp);
      },
      scope: true
    };
  })
  .directive("dockResizable", function(dock) {
    function enableResize($element, dp) {
      $element.resizable({
        handles: dock.handlesByDock[dp]
      });
    }
    return {
      require: 'dock',
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $scope.$eval($element.attr('dock'));
        if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
        $scope.$watch(function() {
          var newdp = $scope.$eval($element.attr('dock'));
          if (newdp != dp) {
            if (dock.valids.indexOf(newdp) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            dp = newdp;
            $element.resizable('destroy');
            if (newdp != 'fill') enableResize($element, dp);
          }
        });
      }
    }
  });
})();

(function() {
  "use strict";
  webapp.factory('gAlert',
    [ '$filter', '$rootScope', 'modalFactory',
    function($filter, $rootScope, modalFactory) {

      var templateUrl = 'components/ui-component/factory/galert-factory.html';

      return function(p1, p2, p3, p4) {

        /*
          if p2 ? string : p1 = "type", p2 = msg, p3 = function
          else p1 = msg, p2 = function

          Alert Type : info, error
          p1 type of String : alert type
          p1 type of Function : ok function / default Info
        */

        var ico = "", color = "", mode = true;
        if(typeof(p2) == "string") {
          if(p1.toLowerCase() == "i") {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          } else if(p1.toLowerCase() == "c") {
           ico = "alert-icon-check";
           color = "0066cc";
          } else if(p1.toLowerCase() == "w") {
            ico = "alert-icon-caution";
            color = "be1a16";
          } else {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          }
        } else {
          mode = false;
          ico = "alert-icon-exclamation";
          color = "0066cc";
        }

        var translate = $filter('translate');
        var defaultCloseBtn = translate('Menu.CONFIRM');

        if(mode) {
          if ($rootScope.gVariable.alertMessage == p2 || p2 == null) {
            return;
          }

          $rootScope.gVariable.alertMessage = p2;
        } else {
          if ($rootScope.gVariable.alertMessage == p1 || p1 == null) {
            return;
          }

          $rootScope.gVariable.alertMessage = p1;
        }

        var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {
          //$scope.title = (title == '') ? translate('Menu.ALERT') : translate(title);

          var msg = (mode) ? p2 : p1;
          $rootScope.gVariable.alertMessage = msg;
          $scope.alertColor = color;
          $scope.alertMessage = translate(msg);
          $scope.alertIco = ico;

          var okAct;
          if(mode) {
            $scope.closeBtn = p3 && p3.btn ? translate(p3.btn) : defaultCloseBtn;
            okAct = p3;
          } else {
            $scope.closeBtn = p2 && p2.btn ? translate(p2.btn) : defaultCloseBtn;
            okAct = p2;
          }

          var okFn = okAct && okAct.fn ? okAct.fn : null;
          $scope.onClose = function() {
            if (okFn) {
              okFn();
            }
            
            $uibModalInstance.dismiss('cancel');
            $rootScope.gVariable.alertMessage = '';
          };

          var EVENT_TYPES = 'keydown keypress';
          function eventHandler(event) {
            var _key = event.which; // enter, space
            if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
              event.preventDefault();
              $scope.onClose();
            }
          }
          $document.on(EVENT_TYPES, eventHandler);
          $scope.$on('$destroy', function() {
            $document.off(EVENT_TYPES, eventHandler);
          });
        }, {}, {
          keyboard : true
        });
      };
    }]);
})();

webapp.factory('gChoice', [ '$filter', 'modalFactory', function($filter, modalFactory) {
    var defaultIconClazz = 'noty';
    var templateUrl = 'components/ui-component/factory/gchoice-factory.html';

    var basicConfirm = function(p1, p2, p3, p4, p5, p6, p7) {

    var ico = "", color = "", option = true;
    if(p1.toLowerCase() == "i") {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
    } else if(p1.toLowerCase() == "w") {
      ico = "alert-icon-caution";
      color = "be1a16";
    } else {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.SELECT');

    var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(p2);
      $scope.items = p5;
      $scope.option = p6;
      var okAct, closeAct;
      okAct = p3; closeAct = p4;
      $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
      $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
      $scope.iconClazz = p7 && p7.type ? p7.type : defaultIconClazz;

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn($scope.option);
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }
      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  };

  return basicConfirm;
} ]);

webapp.factory('gConfirm', [ '$filter', 'modalFactory', function($filter, modalFactory) {
  var defaultIconClazz = 'noty';
  var templateUrl = 'components/ui-component/factory/gconfirm-factory.html';

  var basicConfirm = function(p1, p2, p3, p4, p5) {

    //title, msg, okAct, closeAct, options
    /*
      if p2 ? string : p1 = "type", p2 = msg, p3 = ok, p4 = cancel;
      else p1 = msg, p2 = ok, p3 = cancel

      Alert Type : info, error
      p1 type of String : alert type
      p1 type of Function : ok function / default Info
    */

   var ico = "", color = "", mode = true;
   if(typeof(p2) == "string") {
     if(p1.toLowerCase() == "i") {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
     } else if(p1.toLowerCase() == "w") {
       ico = "alert-icon-caution";
       color = "be1a16";
     } else {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     }
   } else {
     mode = false;
     ico = "alert-icon-exclamation";
     color = "0066cc";
   }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.OK');

    var modalInstance = modalFactory.open('md', templateUrl, function($uibModalInstance, $scope, $document) {

      var msg = (mode) ? p2 : p1;

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(msg);

      var okAct, closeAct;
      if(mode) {
        okAct = p3; closeAct = p4;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p5 && p5.type ? p5.type : defaultIconClazz;
      } else {
        okAct = p2; closeAct = p3;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p4 && p4.type ? p4.type : defaultIconClazz;
      }

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn();
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }

      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  }

  return basicConfirm;
} ]);

webapp.factory('gSelect', [ '$filter', 'modalFactory', function($filter, modalFactory) {
    var defaultIconClazz = 'noty';
    var templateUrl = 'components/ui-component/factory/gselect-factory.html';

    var basicConfirm = function(p1, p2, p3, p4, p5, p6, p7) {

      //title, msg, okAct, closeAct, options
      /*
        if p2 ? string : p1 = "type", p2 = msg, p3 = ok, p4 = cancel;
        else p1 = msg, p2 = ok, p3 = cancel

        Alert Type : info, error
        p1 type of String : alert type
        p1 type of Function : ok function / default Info
      */

    var ico = "", color = "", mode = true;
    if(p1.toLowerCase() == "i") {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
    } else if(p1.toLowerCase() == "w") {
      ico = "alert-icon-caution";
      color = "be1a16";
    } else {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.OK');

    var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(p2);
      $scope.items = p5;
      $scope.mode = p6;

      var okAct, closeAct;
      okAct = p3; closeAct = p4;
      $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
      $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
      $scope.iconClazz = p7 && p7.type ? p7.type : defaultIconClazz;

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn($scope.mode);
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }
      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  };

  return basicConfirm;
} ]);

/**
 * 자세한 옵션은 https://angular-ui.github.io/bootstrap/ 의 Modal 항목 참고
 *
 * 사용 예제
 *
 * <pre>
 * 모달을 사용하는 측 모달 열기
 * var modalInstance = modalFactory.open('lg', 'html/changemng/req-change.html',
 * 		'ReqChangeController', data: modal측에 전달할 객체);
 * 모달 외부에서 내부로 값 전달 하는 방법
 * data에 데이터를 넣고, 모달의 내부에서 사용하는 controller에서
 * gmsController.controller('ReqChangeController', [ '$scope','$uibModalInstance','toModalData',
 * 	function($scope, $uibModalInstance, toModalData) {
 * console.log(JSON.stringify(toModalData));
 * 이런식으로 하면 toModalData안에 데이터가 들어있게 된다.
 *
 * 모달에서 처리된 값 받기
 * modalInstance.result.then(function(data) {
 * 	console.log(JSON.stringify(data))
 * }, function() {
 * 	$log.info('Modal dismissed at: ' + new Date());
 * });
 *
 * 모달 내부에서 외부로 값 전달 하는 방법
 * 확인 버튼
 * $uibModalInstance.close($scope.reqChangeModel);
 * - modalInstance.result.then(function(data) 모달을 사용하는 측에서 data에 값이 들어오게 된다.
 *
 * 취소 버튼
 * $uibModalInstance.dismiss('cancel');
 * - modalInstance.result.then 이부분이 호출되지 않게 된다.
 *
 *
 * </pre>
 */

webapp.factory('modalFactory', [ '$uibModal', '$rootScope', ModalFactory ]);

function ModalFactory($uibModal, $rootScope) {
  var modalInstance = {};
  // $uibModalInstance

  modalInstance.open = function(size, templateUrl, controller, data, options) {
    var controNm = "";
    if(typeof controller != "function" && controller) {
      controNm = "ctrl-" + controller.split(" ")[0].toLowerCase() + "-wrap";
    }
    var modal = $uibModal.open({
      animation : false,
      templateUrl : templateUrl,
      controller : controller,
      // size - (Type: string, Example: lg)
      // Optional suffix of modal window class. The value used is appended
      // to the modal- class, i.e. a value of sm gives modal-sm.
      size : size,
      windowClass  : controNm,
      backdrop : 'static',
      // 키보드 esc로 모달을 닫을지 여부
      keyboard : options && options.keyboard ? options.keyboard : true,
      windowTemplate : 'ui/template/modal/window.html',
      // 모달 외부로 부터 내부로 전달 받을 값
      resolve : {
        toModalData : function() {
          return data;
        }
      }
    });
    return modal;
  };
  return modalInstance;
};

webapp.factory('modalPopup', ['$uibModal', '$rootScope', modalPopup]);

function modalPopup($uibModal, $rootScope) {
  var modalInstance = {};
  modalInstance.open = function(templateUrl, controller, data, options) {
    var as = controller.split(' ');
    as = as[as.length - 1];

    var $wrap = $("<div id='wrap'/>");
    var $popupHeader = $('<div />', { class: 'custom-popup-header' });
    var $popupHeader = $('<div />', { class: 'custom-popup-header' });
    //"ng-click" : '$uibModalInstance.dismiss("cancel data");'
    var $popupView = $('<div />', { 'ng-include': '', src: templateUrl });

    var modal = $uibModal.open({
      animation: true,
      templateUrl: templateUrl,
      //template: "<div ng-click='vc.cancel();'>닫기</div><div ng-include src=\"'" + templateUrl +"'\"></div>",
      controller: controller,
      backdrop: 'static',
      // 키보드 esc로 모달을 닫을지 여부
      keyboard: options && options.keyboard ? options.keyboard : true,
      windowTemplate: 'components/ui-component/factory/modal-mobile-popup.html',
      // 모달 외부로 부터 내부로 전달 받을 값
      windowClass: 'modal-mobile-popup',
      resolve: {
        toModalData: function() {
          return data;
        }
      }
    });
    return modal;
  };
  return modalInstance;
}

/**
 * sort-array-object.js는 object Type들로 이루어진 Array에 대한 정렬을 제공하는 기능이다. 숫자 타입의 속성 값만 비교 가능하다.
 * Params - input: 정렬할 데이터
 * Params - attr : 정렬 기준 항목
 */
webapp.factory('sortArrayFactory', ['$resource', 'GLOBAL_CONSTANT', function sortArrayFactory($resource, CONSTANT) {
    return {
        sortArrayObject: function(input, attr){
            if(!angular.isArray(input)){
                return input;
            }
            input.sort(function(pre, post){
                try{
                    a = parseInt(pre[attr]);
                    b = parseInt(post[attr]);
                    return a - b;
                }catch(ex){
                    throw new Error('NumberFormat Error.');
                    return input;
                }
            })
            return input;
        }
    }
}]);

/**
 * static-variable-factory.js는 ng-app 전역적인 변수값을 정의하여 사용할 수 있는 정적 메소드이다.
 */

webapp.factory('StaticVariable', [
  '$state',
  '$window',
  '$cookies',
  '$filter',
  '$rootScope',
  'gAlert',
  'GLOBAL_CONSTANT',
  '$timeout',
  function ($state, $window, $cookies, $filter, $rootScope, gAlert, CONSTANT, $timeout) {
    // -- ACCESS_DENIED("ACN1N00-403") 홈으로 이동
    // -- ALREADY_LOGGED_IN("ACN0N04-409") 로그인에서만 사용
    // -- ACCESS_TOKEN_IS_NULL("ACN0N01-401") 로그인으로 이동
    // -- INVALID_TOKEN("ACN1N01-401") 로그인으로 이동
    // -- TOKEN_IS_EXPIRED("ACN1N02-401") 로그인으로 이동
    // -- DOES_NOT_MATCH_TOKEN_VERSION("ACN1N03-401") 로그인으로 이동
    // -- LOGEDIN_ANOTHER_CLIENT("ACN1N04-401") 로그인으로 이동
    function getContextPath() {
      var offset = location.href.indexOf(location.host) + location.host.length;
      if (offset + 1 >= location.href.length) return '';

      var ctxPath = location.href.substring(offset + 1, location.href.indexOf('/', offset + 1));

      if (ctxPath == '#') ctxPath = '';

      return ctxPath;
    }

    CONSTANT.URL.CONTEXT = getContextPath();
    var translate = $filter('translate');

    var alreadyOccurError = false;
    var serverDead = false;

    var intercept = {
      response: function (JSON) {
        //console.info('intercept JSON=====', JSON);
        return JSON.data;
      },
      responseError: function (error) {
        console.log('intercept error=====', error);
        console.log('intercept error.status=====', error.status);

        /* 2025.06.25 정보노출 취약점 조치 */
        if (error.status == 404) {
          $state.go('error');
          return null;
        }

        if (error.data == null) {
          gAlert(translate('Menu.SERVERERROR4'), 'Unknown error.');
          return null;
        }

        if ((error.status == -1 || error.status == 400) && !serverDead) {
          serverDead = true;
          $timeout(function () {
            gAlert(translate('Menu.SERVERERROR1'), translate('Menu.INVALIDSESSION'), {
              fn: function () {
                sessionExpire();
                $state.go('login');
              },
            });
          }, 2);
        } else if (error.data && angular.isUndefined(error.data.response)) {
          console.log("error");
          // console.error('server Error', '[' + error.status + ']' + error.statusText);
          if (error.status == 401 || error.status == 400) {
            sessionExpire();
            $state.go('login');
          }

          return null;
        } else if (
          error.data.response.body.docs.errCode == 'ACN0N01-401' ||
          error.data.response.body.docs.errCode == 'ACN1N01-401' ||
          error.data.response.body.docs.errCode == 'ACN1N02-401' ||
          error.data.response.body.docs.errCode == 'ACN1N03-401' ||
          error.data.response.body.docs.errCode == 'ACN1N04-401'
        ) {
          if ($window.sessionStorage.isLoggedIn) {
            alreadyOccurError = true;
            sessionExpire();
            $state.go('login');
            return null;
          }
        } else if (error.data.response.body.docs.errCode === 'ACN1N00-403') {
          console.log(error.data);
          $timeout(function () {
            gAlert(translate('Menu.SERVERERROR3'), error.data.response.body.docs.errMessage, {
              fn: function () {
                console.log("error");
                // console.error(error.data.response.body.docs.errMessage);
                $state.go('login');
              },
            });
            return null;
          }, 2);
        } else {
          return error.data;
        }

        //gAlert(translate('Menu.SERVERERROR4'), error.data.response.body.docs.errMessage);
        console.log("error");
        // console.error(error.data.response.body.docs.errCode, error.data.response.body.docs.errMessage);
      },
    };
    function sessionExpire() {
      $window.sessionStorage.removeItem('isLoggedIn');
      $window.sessionStorage.removeItem('loginUserId');
      $window.sessionStorage.removeItem('loginUserIdx');
      $window.sessionStorage.removeItem('loginSysAdminYN');
      $window.sessionStorage.removeItem('loginUserName');
      $window.sessionStorage.removeItem('loginUserGbn');
      $window.sessionStorage.removeItem('loginUserDept');
      $window.sessionStorage.removeItem('loginUserDeptCode');
      $window.sessionStorage.removeItem('loginComGbn');
      $window.sessionStorage.removeItem('loginUserType');
      $window.sessionStorage.removeItem('loginUserEmail');
      $window.sessionStorage.removeItem('loginTenantId');
      $window.sessionStorage.removeItem('loginTenantName');
      $window.sessionStorage.removeItem('loginTenantDir');
      $window.sessionStorage.removeItem('loginEmail');
      $window.sessionStorage.removeItem('loginTelNo');
      $window.sessionStorage.removeItem('srchTenantId');
      $window.sessionStorage.removeItem('srchTenantName');
    }
    return {
      getUrl: function (uri) {
        var domainPort = CONSTANT.URL.PORT == null || CONSTANT.URL.PORT == '' ? '' : ':' + CONSTANT.URL.PORT;
        var domainContext =
          CONSTANT.URL.CONTEXT == null || CONSTANT.URL.CONTEXT == '' ? '' : '/' + CONSTANT.URL.CONTEXT;
        var domainVersion =
          CONSTANT.URL.VERSION == null || CONSTANT.URL.VERSION == '' ? '' : '/' + CONSTANT.URL.VERSION;

        var url =
          CONSTANT.URL.HTTP_PROTOCOL +
          '//' +
          CONSTANT.URL.API_SERVER_DOMAIN +
          domainPort +
          domainContext +
          domainVersion +
          uri;
        //var url = domainContext + domainVersion + uri;
        return url;
      },
      getFileDownloadUrl: function (FileKey) {
        return this.getUrl('/attach/file/' + FileKey + '/download.do?userkey=' + $rootScope.gVariable.userKey);
      },
      getDateFormat: function (langCode, useDateTime) {
        var foramt;
        switch (langCode) {
          case 'ko':
            format = 'yyyy.MM.dd';
            break;
          case 'zh':
          // break;
          case 'ja':
            format = 'yyyy.MM.dd';
            break;
          case 'en':
            format = 'MM/dd/yy';
            break;
          default:
            format = 'MM/dd/yy';
            break;
        }
        return useDateTime ? format + ' HH:mm:ss' : format;
      },
      sessionExpire: function () {
        sessionExpire();
      },
      getRequestActions: {
        defaultAction: function () {
          return {
            one: {
              method: 'GET',
              interceptor: intercept,
              transformResponse: function (data, headersGetter) {
                var contentType = headersGetter('Content-Type');
                if (contentType && contentType.indexOf('text/html') > -1) {
                  return {
                    body: data,
                  };
                }
                return angular.fromJson(data);
              },
            },
            post: {
              method: 'POST',
              interceptor: intercept,
            },
            get: {
              method: 'GET',
              interceptor: intercept,
            },
          };
        },
        getStandardAction: function () {
          return {
            getOne: {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
              interceptor: intercept,
            },
            getList: {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
              interceptor: intercept,
            },
            create: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              interceptor: intercept,
            },
            modify: {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              interceptor: intercept,
            },
            remove: {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
              },
              interceptor: intercept,
            },
          };
        },
      },
    };
  },
]);

webapp.factory("uuidFactory", function() {

	// 시큐어코딩으로 추가함 (2023-07-06 )
	// function r(r) {
	// 	return Math.random() * r
	// }

	// function r(r) {
	// 	var seed = new Date().getTime();
  	// 	seed = (seed*9301 + 49297) % 233280;
	// 	return seed/233280.0 * r
	// }

	function r(r) {
		var array = new Uint32Array(1);
		window.crypto.getRandomValues(array);
		return array[0] / Math.pow(2, 32) * r;
	}

	return {
		v4 : function() {
			var n, a = "";
			for (n = 0; 36 > n; n++)
				a += 14 === n ? "4" : 19 === n ? "89ab".charAt(r(4)) : 8 === n
						|| 13 === n || 18 === n || 23 === n ? "-"
						: "0123456789abcdef".charAt(r(16));
			return a
		}
	};
});

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    TimeLine.$inject = ['$log'];

    /** @ngInject */
    function TimeLine($log) {
        $log.info('TimeLine Controller');
    }

    angular.module('salevis4-web')
        .component('timeline', {
            templateUrl: 'components/ui-component/timeline/timeline.html',
            controller: TimeLine
        });

})();

webapp.controller('CommonCodeCustomCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate',
  function CommonCodeCustomCtrl($scope, $element, $compile, CONSTANT, $translate) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeList = {
      Code : '',
      CodeValue : ''
    };

    vm.codeModel = {};
    vm.SelectedCode = 'Y';

    vm.list = [];
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (!vm.codeModel) {
        vm.codeModel = '';
      }

      try {
        vm.initChangeData(vm.codeModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList(codeList, codeExclude) {
      angular.forEach(codeList, function (item) {
        var bEx = true;
        if(codeExclude && codeExclude.length > 0 ){
          for(var i = 0; i < codeExclude.length; i++){
            if(codeExclude[i] == item.Code){
              bEx = false;
              break;
            }
          }
        }
        
        if(bEx){
          vm.list.push(item);
        }
        
      });
    }
  }
]);

// webapp.directive('commonCodeCustom', [ '$compile', '$parse', function($compile, $parse) {
//   return {
//     transclude : true,
//     restrict : 'E',
//     replace: true,
//     scope : {
//       codeList : "=",
//       codeModel : "=",
//       callback : "=",
//       isDisabled : "=",
//       codeExclude : "=",  //표시하고 싶지 않는 코드를 Array형태로 넘겨준다. Ref) code-exclude="['RESERVE','REPEAT']">
//     },
//     templateUrl : 'scripts/directives/common-code-custom/common-code-custom.html',
//     controller : 'CommonCodeCustomCtrl as ccCtrl',
//     link : function(scope, element, attrs, ctrl) {

//       console.log(scope)
      
//       ctrl.callback = scope.callback;
//       ctrl.isDisabled = scope.isDisabled;
//       ctrl.ngDataKey = attrs.codeModel;
      
//       if(!scope.isDisabled && scope.isdisabled) {
//         ctrl.isDisabled = scope.isdisabled;
//       }
      
//       scope.$watchCollection('codeList', function(value) {
//         // 200408 HJH : Push로 인한 리스트가 쌓이는 이슈 처리
//         ctrl.list = [];
//         ctrl.codeModel = scope.codeModel;
//         ctrl.getSelectList(scope.codeList, scope.codeExclude);
//       });

//       scope.$watchCollection('codeModel', function(value) {
//         console.log(value)
//         //console.log('watchCollection paramData=', value);
//         ctrl.codeModel = value;
//         scope.codeModel = value;
//         if(ctrl.callback != undefined) {
//           ctrl.callback(value)
//         }
//       });

//       scope.$watchCollection('isDisabled', function(value) {
//         // 2004022 HJH : disabled가 안바뀌는 이슈 수정
//         ctrl.isDisabled = value;
//       });

//       /** CommonCode Controller **/
//       ctrl.initChangeData = function(val) {
//         try {
//           if(attrs.codeModel != undefined) {
//             scope.codeModel = val;
//           }
//         } catch (e) {}
//       };
//     }
//   };
// } ]);

webapp.directive('commonCodeCustom', 
  [ '$compile', '$parse', '$translate',
  function($compile, $parse, $translate) {
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      scope : true,
      template : function(scope, iAttrs){
        var choose = $translate.instant('Menu.CHOOSE')
        var $wrap = $("<div />");
        var $select = $("<select />", { class: "form-control",  style:"" });
        var $option = $("<option />", { value: "",  text:'-- ' + choose + ' --' });
        var $optionCode = $("<option />", { "ng-repeat": "opt in " + iAttrs.codeList,  text:'{{opt.CodeValue}}', value: '{{opt.Code}}', "ng-if": "opt.hidden !='Y'" });
        $select.html( $option.clone());
        $select.append( $optionCode.clone());
        if(iAttrs.codeModel != undefined) $select.attr("ng-model",iAttrs.codeModel);
        //if(iAttrs.codeList != undefined) $select.attr("ng-options", "opt.Code as opt.CodeValue for opt in " + iAttrs.codeList);
        // ngchange 를 넣었을시 초기에 두번 호출되는 이슈로 주석처리
        //if(iAttrs.callback != undefined) $select.attr("ng-change", iAttrs.callback + "(" +  iAttrs.codeModel+ ");");
        if(iAttrs.isDisabled != undefined) $select.attr("ng-disabled", iAttrs.isDisabled);        
        $wrap.html($select.clone());
        return $wrap.html();
      },
      compile: function compile(tElement, tAttrs) {
        return {
          post: function($scope, element, attr) {},
          pre: function($scope, element, attr) {
            $scope.element = element;
            $scope.codeList = $scope.$eval(attr.codeList);
            $scope.checkInit = false;
            function commonCodeCustomSetInit(val, callback) {
              var value = $scope.$eval(val);
              if(!isNullOrEmpty(value)) {
                $scope.element.value = $scope.$eval(val);
              }
            }
            $scope.$watch(attr.codeModel, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf == 'undefined') {
                // Type이 undefined 일 경우 초기 셋팅일 확률이 높아서 패스 처리
              } else if(item == null) {
                if(attr.callback) { $scope.$eval(attr.callback+"('')"); }  
              } else {
                if(attr.callback) { $scope.$eval(attr.callback+"('" + item + "')"); }
              }
            }, true);

            $scope.$watch(attr.codeList, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf != 'undefined') {
                if(attr.codeExclude) {
                  var codeExclude = $scope.$eval(attr.codeExclude);
                  angular.forEach(item, function(at){
                    var check = true;
                    for(var i = 0; i < codeExclude.length; i++) {
                      if(codeExclude[i] == at.Code) {
                        check = false;
                        break;
                      }
                    }
                    if(!check) at.hidden = "Y";
                    else at.hidden = "N";
                  })
                }
              }
            }, true);
            
            commonCodeCustomSetInit(attr.codeModel, attr.ngChange);
          }
        }
      },
    };
}]);
webapp.controller('CommonCodeSearchCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate',
  function CommonCodeSearchCtrl($scope, $element, $compile, CONSTANT, $translate) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeList = {
      Code : '',
      CodeValue : ''
    };

    vm.codeModel = {};
    vm.SelectedCode = 'Y';

    vm.list = [];
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (!vm.codeModel) {
        vm.codeModel = '';
      }

      try {
        vm.initChangeData(vm.codeModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList(codeList, codeExclude) {
      angular.forEach(codeList, function (item) {
        var bEx = true;
        if(codeExclude && codeExclude.length > 0 ){
          for(var i = 0; i < codeExclude.length; i++){
            if(codeExclude[i] == item.Code){
              bEx = false;
              break;
            }
          }
        }
        
        if(bEx){
          vm.list.push(item);
        }
        
      });
    }
  }
]);

webapp.directive('commonCodeSearch', 
  [ '$compile', '$parse', '$translate',
  function($compile, $parse, $translate) {
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      scope : true,
      template : function(scope, iAttrs){
        var choose = $translate.instant('Menu.CHOOSE');
        var $wrap = $("<div />");
        /* var $select = $("<select />", { class: "form-control",  style:"min-width:100px;" }); */
        var $select = $("<select />", { class: ""});
        var $option = $("<option />", { value: "",  text:'-- ' + choose + ' --' });
        var $optionCode = $("<option />", { "ng-repeat": "opt in " + iAttrs.codeList,  text:'{{opt.CodeValue}}', value: '{{opt.Code}}', "ng-if": "opt.hidden !='Y'" });
        $select.html( $option.clone());
        $select.append( $optionCode.clone());
        if(iAttrs.codeModel != undefined) $select.attr("ng-model",iAttrs.codeModel);
        //if(iAttrs.codeList != undefined) $select.attr("ng-options", "opt.Code as opt.CodeValue for opt in " + iAttrs.codeList);
        // ngchange 를 넣었을시 초기에 두번 호출되는 이슈로 주석처리
        //if(iAttrs.callback != undefined) $select.attr("ng-change", iAttrs.callback + "(" +  iAttrs.codeModel+ ");");
        if(iAttrs.isDisabled != undefined) $select.attr("ng-disabled", iAttrs.isDisabled);        
        $wrap.html($select.clone());
        return $wrap.html();
      },
      compile: function compile(tElement, tAttrs) {
        return {
          post: function($scope, element, attr) {},
          pre: function($scope, element, attr) {
            $scope.element = element;
            $scope.codeList = $scope.$eval(attr.codeList);
            $scope.checkInit = false;
            function commonCodeSearchSetInit(val, callback) {
              var value = $scope.$eval(val);
              if(!isNullOrEmpty(value)) {
                $scope.element.value = $scope.$eval(val);
              }
            }
            $scope.$watch(attr.codeModel, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf == 'undefined') {
                // Type이 undefined 일 경우 초기 셋팅일 확률이 높아서 패스 처리
              } else if(item == null) {
                if(attr.callback) { $scope.$eval(attr.callback+"('')"); }  
              } else {
                if(attr.callback) { $scope.$eval(attr.callback+"('" + item + "')"); }
              }
            }, true);

            $scope.$watch(attr.codeList, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf != 'undefined') {
                if(attr.codeExclude) {
                  var codeExclude = $scope.$eval(attr.codeExclude);
                  angular.forEach(item, function(at){
                    var check = true;
                    for(var i = 0; i < codeExclude.length; i++) {
                      if(codeExclude[i] == at.Code) {
                        check = false;
                        break;
                      }
                    }
                    if(!check) at.hidden = "Y";
                    else at.hidden = "N";
                  });
                }
              }
            }, true);
            
            commonCodeSearchSetInit(attr.codeModel, attr.ngChange);
          }
        };
      },
    };
}]);
webapp.controller('CommonCodeSignupCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeSignupCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.paramData = {
      CodeType : '',
      ParentCommonCodeId : '',
      CommonCodeId : '',
      Code : '',
      CodeValue : '',
      CallbackTarget : '',
      ReloadSeq : 0
    };

    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (vm.callback) {
        if (vm.data != null) {
          vm.data.CallbackTarget = vm.paramData.CallbackTarget;
          vm.callback(vm.data);
        } else {
          var data = vm.paramData;
          data.Code = '';
          vm.callback(data);
        }
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList() {
      if (vm.paramData == null || vm.paramData.CodeType == null || vm.paramData.CodeType == '') {
        vm.list = {};
        return;
      }

      angular.copy(vm.paramData, vm.data);

      vm.data.mapCode = "getCommonCodeList";

      var prms = postApi.login(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list = result.body.docs;
        }
      }, function(error) {
        console.table(error);
      });
    }

  }
]);

webapp.directive('commonCodeSignup', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      paramData : "=",
      callback : "=",
      isDisabled : "=",
      chooseMessage : "=",
      selectWidth : "="
    },
    templateUrl : 'scripts/directives/common-code-signup/common-code-signup.html',
    controller : 'CommonCodeSignupCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.callback = scope.callback;

      scope.$watchCollection('paramData', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.paramData = scope.paramData;
        ctrl.getSelectList();
      });

      scope.$watchCollection('isDisabled', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isDisabled != undefined)
          ctrl.isDisabled = scope.isDisabled;
      });

      scope.$watchCollection('chooseMessage', function(value) {
        if (scope.chooseMessage != undefined)
          ctrl.chooseMessage = scope.chooseMessage;
      });

      scope.$watchCollection('selectWidth', function(value) {
        if (scope.selectWidth != undefined)
          ctrl.selectWidth = scope.selectWidth;
      });

    }
  };
} ]);

webapp.controller('CommonCodeFoodCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'postApi',
  function CommonCodeFoodCtrl($scope, $element, $compile, CONSTANT, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeModel = {};
    vm.codeChanged = null;
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.list = [[], []];
    vm.CommonCode = [];
    vm.CommonCode1 = {};

    vm.onChangeHandler = function(index) {
      if (index == 0) {
        getSelectList(2, vm.CommonCode[0].Code);
      } else if (index == 1) {
        try {
          if (vm.CommonCode[0] != null && vm.CommonCode[1] != null) {
            vm.initChangeData(vm.CommonCode[0].Code + '.' + vm.CommonCode[1].Code, vm.CommonCode[0].CodeValue + '.' + vm.CommonCode[1].CodeValue, true);
          }
        } catch (err) {
          vm.initChangeData("", "", true);
        }        
      }
    };

    vm.setSelectList = setSelectList;
    function setSelectList(codeList) {
      vm.list = [[], []];
    }

    vm.selectChange = selectChange;
    function selectChange() {
      if (vm.codeModel) {
        var Code = vm.codeModel.split('.');
        console.log('Code=', Code);
        vm.list[1] = [];
        vm.CommonCode[0] = {Code:Code[0]};
        vm.CommonCode1 = {Code:Code[1]};

        getSelectList(2, vm.CommonCode[0].Code);
      } else {
      }
    }    

    vm.getSelectList = getSelectList;
    function getSelectList(CodeLevel, ParentCommonCodeId) {
      vm.list[CodeLevel - 1] = [];

      var data = {};
      data.CodeLevel = CodeLevel;
      data.mapCode = "FoodList.getFoodlistValue";
      if (ParentCommonCodeId) {
        data.ParentCommonCodeId = ParentCommonCodeId;
      }

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list[CodeLevel - 1] = result.body.docs;
          if (CodeLevel == 2) {
            vm.CommonCode[1] = vm.CommonCode1;
          }
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> getSelectList', error);
      });
    }

    vm.getSelectList(1, null);

  }
]);

webapp.directive('commonCodeFood', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeList : "=",
      codeModel : "=",
      reloadSeq : "=",
      codeChanged : "=",
      chooseMessage : "=",
      preventChanging : "=",
      codeIndex : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-food.html',
    controller : 'CommonCodeFoodCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      // scope.$watchCollection('codeType', function(value) {
      //   ctrl.codeModel = scope.codeModel;
      //   ctrl.getSelectList(scope.codeType);
      // });
      ctrl.codeModel = scope.codeModel;
      ctrl.codeChanged = scope.codeChanged;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = scope.codeModel;
        ctrl.setSelectList(scope.codeList);
      });

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined) {
          ctrl.CommonCode[0] = null;
          ctrl.CommonCode[1] = null;
        }
      });

      scope.$watchCollection('codeModel', function(value) {
        ctrl.codeModel = value;
        ctrl.selectChange();
      });      

      /** CommonCode Controller **/
      ctrl.initChangeData = function(code, codevalue, bLast) {
        try {
          if (attrs.codeModel != undefined) {
            scope.codeModel = code;
          }

          if (attrs.codeChanged != undefined) {
            if (!scope.preventChanging || bLast) {
              $timeout(function() {
                return ctrl.codeChanged(code, codevalue, scope.codeIndex);
              }, 1);
            }
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

webapp.controller('CommonCodeProjectCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'postApi',
  function CommonCodeProjectCtrl($scope, $element, $compile, CONSTANT, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.prmYear = null;
    vm.prmType = null;
    vm.prmId = null;
    vm.preventChanging = null;
    vm.codeChanged = null;
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.listYear = [];
    vm.listPrm = [];
    vm.data = {};

    vm.onChangeHandlerId = function() {
      console.log('onChangeHandlerId=', vm.prmId);
      vm.initChangeDataId(vm.prmId);
    };

    vm.onChangeHandlerYear = function() {
      vm.initChangeDataYear(vm.prmYear);
      getSelectList();
    };    

    vm.setSelectList = setSelectList;
    function setSelectList(prmList) {
      vm.listPrm = prmList;
    }

    vm.getSelectList = getSelectList;
    function getSelectList() {
      vm.listPrm = [];

      if (!vm.prmYear || !vm.prmType) {
        return;
      }

      var data = {};
      data.PrmYear = vm.prmYear;
      data.PrmType = vm.prmType;
      data.mapCode = "ProjectManage.getProjectManageCodeList";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.listPrm = result.body.docs;
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> getSelectList', error);
      });
    }

    vm.getYearList = getYearList;
    function getYearList() {
      vm.listYear = [];

      var data = {};
      data.CodeType = "SEARCH_YEAR";
      data.mapCode = "CommonCode.getCommonCodeList";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.listYear = result.body.docs;
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> getSelectList', error);
      });
    }

    vm.getProjectInfo = getProjectInfo;
    function getProjectInfo() {
      if (!vm.prmYear || !vm.prmId) {
        return;
      }

      var data = {};
      data.PrmYear = vm.prmYear;
      data.PrmId = vm.prmId;
      data.mapCode = "ProjectManage.getProjectInfo";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = result.body.docs[0];
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> getSelectList', error);
      });
    }

    vm.setPreventChanging = setPreventChanging;
    function setPreventChanging(preventChanging) {
      vm.preventChanging = preventChanging;
      if (vm.preventChanging === false) {
        vm.getYearList();
        vm.getSelectList();
      }

      if (vm.preventChanging === true) {
        vm.getProjectInfo();
      }      
    }
  }
]);

webapp.directive('commonCodeProject', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      prmYear : "=",
      prmType : "=",
      prmId : "=",
      reloadSeq : "=",
      chooseMessage : "=",
      preventChanging : "=",
      codeChanged : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-project.html',
    controller : 'CommonCodeProjectCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.prmYear = scope.prmYear;
      ctrl.prmType = scope.prmType;
      ctrl.prmId = scope.prmId;
      ctrl.setPreventChanging(scope.preventChanging);

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined && value !== undefined) {
          ctrl.prmYear = scope.prmYear;
          ctrl.prmType = scope.prmType;
          ctrl.prmId = scope.prmId;
          ctrl.setPreventChanging(scope.preventChanging);
        }
      });

      /** CommonCode Controller **/
      ctrl.initChangeDataYear = function(prmYear) {
        try {
          if (!scope.preventChanging) {
            scope.prmYear = prmYear;

            $timeout(function() {
              //console.log('initChangeData prmId=', prmId);
              return scope.codeChanged();
            }, 1);
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };

      ctrl.initChangeDataId = function(prmId) {
        try {
          if (!scope.preventChanging) {
            scope.prmId = prmId;

            $timeout(function() {
              //console.log('initChangeData prmId=', prmId);
              return scope.codeChanged();
            }, 1);
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

webapp.service('CommonCodeTreeAPISrv', ['$resource', 'StaticVariable',
    function CommonCodeTreeAPISrv($resource, StaticVariable) {
    	var commonApi = {
       		doComboCode : function() {
       			return $resource(StaticVariable.getUrl('/api/system/getCommonCodeList.json'), {},
       					StaticVariable.getRequestActions.defaultAction());
   			},
    	};
    	return commonApi;
	}
]);


webapp.controller('CommonCodeTreeCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeTreeCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeModel = {};
    vm.codeChanged = null;
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.allList = {};
    vm.list = [[], [], [], []];
    vm.CommonCode = [];
    vm.Code = [];
    vm.CodeValue = [];

    vm.onChangeHandler = function(index) {
      angular.forEach(vm.Code, function(item, key) {
        if (key > index) {
          vm.Code[key] = '';
          vm.CodeValue[key] = '';
        }
      });

      vm.list[index + 1] = [];

      if (vm.CommonCode[index]) {
        vm.Code[index] = vm.CommonCode[index].Code;
        vm.CodeValue[index] = vm.CommonCode[index].CodeValue;

        angular.forEach(vm.allList, function(item) {
          if (vm.CommonCode[index] && vm.CommonCode[index].CommonCodeId == item.ParentCommonCodeId) {
            vm.list[index + 1].push(item);
          }
        });
      } else {
        vm.Code[index] = '';
        vm.CodeValue[index] = '';
      }

      try {
        var bLast = vm.list[index + 1].length == 0 && vm.Code[index] ? true : false;
        vm.initChangeData(vm.Code.filter(function(el){return el != '';}).join('.'), vm.CodeValue.filter(function(el){return el != '';}).join('.'), bLast);
      } catch (err) {
        vm.initChangeData("", "", true);
      }
    };

    vm.setSelectList = setSelectList;
    function setSelectList(codeList) {
      if (codeList == null || codeList == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      vm.allList = codeList;

      vm.CodeLevel = vm.allList.reduce(function(a, b) {
        if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
        return a;
      }, []);

      var index = 0;

      angular.forEach(vm.allList, function(item) {
        if (vm.CodeLevel[0]) {
          if (vm.CodeLevel[0] == item.CodeLevel) {
            vm.list[0].push(item);

            if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
              vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
            }
          }
        }
      });

      angular.forEach(vm.CodeLevel, function(codeLevel, key) {
        if (key == 0) return;

        angular.forEach(vm.allList, function(item) {
          if (codeLevel == item.CodeLevel) {
            if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
              vm.list[key].push(item);

              if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
              }
            }
          }
        });
      });
    }

    vm.getSelectList = getSelectList;
    function getSelectList(codeType) {
      if (codeType == null || codeType == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      if (codeType == 'PROJECT') {
        vm.data.mapCode = "Routine.getRoutineCodeTreeValue";
      } else if (codeType == 'FOODLIST') {
        vm.data.mapCode = "FoodList.getFoodlistTreeValue";        
      } else {
        vm.data.CodeType = codeType;
        vm.data.mapCode = "CommonCode.getCommonCodeTreeValue";
      }      

      var prms = postApi.select(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.allList = result.body.docs;

          vm.CodeLevel = vm.allList.reduce(function(a, b) {
            if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
            return a;
          }, []);

          var index = 0;

          angular.forEach(vm.allList, function(item) {
            if (vm.CodeLevel[0]) {
              if (vm.CodeLevel[0] == item.CodeLevel) {
                vm.list[0].push(item);

                if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
                  vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
                }
              }
            }
          });

          angular.forEach(vm.CodeLevel, function(codeLevel, key) {
            if (key == 0) return;

            angular.forEach(vm.allList, function(item) {
              if (codeLevel == item.CodeLevel) {
                if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
                  vm.list[key].push(item);

                  if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                    vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
                  }
                }
              }
            });
          });
        }
      }, function(error) {
        console.log("error");
        // console.error('Error> getSelectList', error);
      });
    }

  }
]);

webapp.directive('commonCodeTree', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeType : "=",
      codeList : "=",
      codeModel : "=",
      reloadSeq : "=",
      codeChanged : "=",
      chooseMessage : "=",
      preventChanging : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-tree.html',
    controller : 'CommonCodeTreeCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      // scope.$watchCollection('codeType', function(value) {
      //   ctrl.codeModel = scope.codeModel;
      //   ctrl.getSelectList(scope.codeType);
      // });
      ctrl.codeModel = scope.codeModel;
      ctrl.codeChanged = scope.codeChanged;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = scope.codeModel;
        ctrl.setSelectList(scope.codeList);
      });

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined) {
          ctrl.getSelectList(scope.codeType);
        }
      });

      /** CommonCode Controller **/
      ctrl.initChangeData = function(code, codevalue, bLast) {
        try {
          if (attrs.codeModel != undefined) {
            scope.codeModel = code;
          }

          if (attrs.codeChanged != undefined) {
            if (!scope.preventChanging || bLast) {
              $timeout(function() {
                return scope.codeChanged(code, codevalue);
              }, 1);
            }
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

'use strict';

/**
 * Date directive (date input element)
 */
 webapp.directive('dateInput', ['$document', '$timeout', function ($document, $timeout) {
  return {
    restrict: 'E',
    scope: {
      date: '=',
      format: '=?',
      dateFormat: '=?',
      minDate:'=?',
      maxDate:'=?',
      allowClear:'=?',
      onChange: '&',
      onClose: '&?',
      placeholder: '@',
      clearText: '@',
      closeText: '@',
      cssClass:'@',
      ariaDisabled: "="
    },
    replace: true,
    templateUrl: 'scripts/directives/date-form/date-input.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element, attr) {
          //lang:ko를 등록한다. 한번 지정하면 자동적으로 사용된다.
          moment.lang('ko', {
            weekdays: ["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],
            weekdaysShort: ["일","월","화","수","목","금","토"],
          });
          
          // Get current date
          scope.current = moment();

          // Convert date object to moment.js if its not a moment object yet
          //if ( scope.date && !scope.date._isAMomentObject ) {
          //  scope.date = moment(scope.date, scope.format);
          //}


          scope.$watch("date", function(item){
            var itemTypeOf = typeof(item);
            if(itemTypeOf == 'undefined') {
            } else if(item == null) {
            } else if(isNullOrEmpty(item)) {
            } else {
              var tempdate = moment(item, scope.format);
              if(item._isValid) {
                scope.date = moment(item, scope.format);
              } else {
                if(item.dayOfMonth) {
                  var _d = item.year + '-' + (item.monthValue) + '-' + item.dayOfMonth + ' ' + item.hour + ':' + item.minute + ':' + item.second;
                  _d = moment( new Date(_d)).format("YYYY-MM-DD HH:mm:ss");
                  scope.date = moment.utc(_d).local(scope.format);
                } else {
                  scope.date = moment(item, scope.format);
                }
              }              
            }
          }, true);

          scope.monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

          // Toggle edit popover
          scope.toggleEditPopover = function () {

            if(attr.disabled) return;
            
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;

            if ( !!scope.selected ) {
              scope.selected = undefined;
            } else {
              scope.selected = scope.date || moment();
              
              if(scope.date == undefined) {
                var _d = new Date();
                scope.selected = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours(), _d.getMinutes(), 0));
                scope.date = scope.selected;
              }

              scope.selectedCopy = scope.selected.clone();

              // 기준 날짜
              scope.calendar = scope.selected.clone();
              // 년도 표시 시작
              scope.calendarYearStart = scope.selected.clone();
              // 월
              scope.currentMonth = scope.calendar.month() + 1;

              // 년도 표시 시작 끝자리 1로 만들기 위한 함수
              var yearStartLast= scope.calendarYearStart.format('YYYY').substring(3,4);
              if (yearStartLast != '1') {
                scope.calendarYearStart.subtract(yearStartLast - 1, 'year');
              }

              // 년도 표시 종료
              scope.calendarYearEnd = scope.calendarYearStart.clone();

              // 년도 Array 만들기 위한 날짜
              scope.calendarArray = scope.calendarYearStart.clone();

              scope.calendarYearEnd.add(19, 'year');
              
              scope.yearList = [];

              var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
              for(var i = 0; i <= maxSize; i++) {
                if (i != 0) {
                  scope.calendarArray.add(1, 'year');
                }                
                scope.yearList.push(scope.calendarArray.format('YYYY'));
              }
            }
          };

          scope.addYears = function() {
            scope.calendarYearStart.add(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.add(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.subtractYears = function() {
            scope.calendarYearStart.subtract(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.subtract(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.addYear = function() {
            scope.calendar.add(1, 'year');
          };

          scope.subtractYear = function() {
            scope.calendar.subtract(1, 'year');
          };

          scope.addMonth = function() {
            scope.calendar.add(1, 'months');
            scope.currentMonth = scope.calendar.month() + 1;
          };

          scope.subtractMonth = function() {
            scope.calendar.subtract(1, 'months');
            scope.currentMonth = scope.calendar.month() + 1;
          };

          scope.clcikYearShow = function () {
            scope.yearShow = true;
            scope.monthShow = false;
            scope.dateShow = false;
          };

          scope.clickYear = function (year) {
            scope.yearShow = false;
            scope.monthShow = true;
            scope.dateShow = false;
            scope.calendar = moment(new Date(year));
            scope.selected = moment(new Date(year, scope.selected.month(), scope.selected.date()));
          };

          scope.clickMonth = function (month) {
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;
            scope.calendar = moment(new Date(scope.calendar.year(), month-1));
            scope.currentMonth = scope.calendar.month() + 1;
            scope.selected = moment(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date()));
            scope.selectTempDate = moment.utc(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date()));
          };

          // Update selected date
          scope.update = function (datetime, calendar_update) {     
            if ( scope.selected.isSame(datetime) && !!scope.date ) { 
              scope.close();
              return; 
            }
            if ( !datetime ) {
              scope.selected = scope.date = undefined;
            } else if ( ( !scope.minDate || datetime > scope.minDate ) && ( !scope.maxDate || datetime < scope.maxDate ) ) {
              if(scope.selectTempDate) {
                scope.selected.year(scope.selectTempDate.year()).month(scope.selectTempDate.month()).date(datetime.date()).hours(scope.selectTempDate.hours()).minutes(scope.selectTempDate.minutes()).seconds(scope.selectTempDate.seconds());
                scope.selectTempDate = undefined;
                scope.date = scope.selected.clone();
              } else {
                scope.selected.year(datetime.year()).month(datetime.month()).date(datetime.date()).hours(datetime.hours()).minutes(datetime.minutes()).seconds(datetime.seconds());
                scope.date = scope.selected.clone();
              }
              if ( scope.selected.clone().startOf('week').month() !== scope.calendar.month() || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              scope.$$postDigest(function () {
                $timeout(function () {
                  scope.onChange();
                }, 0)                
              });
              scope.close();  
            } else {
              scope.warning = true;
              $timeout(function () {
                scope.warning = false;
              }, 250);
            }
            scope.currentMonth = scope.calendar.month() + 1;
          };

          scope.resetDate = function () {
            scope.selected = null;
            scope.date = null;
          }

          // Close edit popover
          scope.close = function () {
            scope.selected = '';

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          };

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !!scope.selected && !element[0].contains(e.target) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( !!scope.selected && e.keyCode === 27) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

/**
 * Datetime directive (date and time input element)
 */
 webapp.directive('datetimeInput', ['$document', '$timeout', function ($document, $timeout) {
  return {
    restrict: 'E',
    scope: {
      datetime: '=',
      initActiveCalendar: '=',
      format: '=?',
      dateFormat: '=?',
      timeFormat: '=?',
      minDate:'=?',
      maxDate:'=?',
      maxHour: "=?",
      minHour: "=?",
      hourStep:'=?',
      minuteStep:'=?',
      secondStep:'=?',
      allowClear:'=?',
      onChange: '&',
      onClose: '&?',
      placeholder: '@',
      clearText: '@',
      closeText: '@',
      cssClass:'@',
      disabled: "@"
    },
    replace: true,
    templateUrl: 'scripts/directives/date-form/datetime-input.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element, attr) {
          //lang:ko를 등록한다. 한번 지정하면 자동적으로 사용된다.
          moment.lang('ko', {
            weekdays: ["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],
            weekdaysShort: ["일","월","화","수","목","금","토"],
          });

          // Get current date
          scope.current = moment();
          
          //console.log(angular.copy(scope.datetime))
          // Convert datetime object to moment.js if its not a moment object yet
          // if ( scope.datetime && !scope.datetime._isAMomentObject ) {
          //   scope.datetime = moment(scope.datetime, scope.format);
          // }
          
          scope.$watch("datetime", function(item){
            var itemTypeOf = typeof(item);
            if(itemTypeOf == 'undefined') {
            } else if(item == null) {
            } else if(isNullOrEmpty(item)) {
            } else {
              if(item.dayOfMonth) {
                var _d = item.year + '-' + (item.monthValue) + '-' + item.dayOfMonth + ' ' + item.hour + ':' + item.minute + ':' + item.second;
                _d = moment( new Date(_d)).format("YYYY-MM-DD HH:mm:ss");
                scope.datetime = moment.utc(_d).local(scope.format);
              } else {
                scope.datetime = moment(item, scope.format);
              }
            }
          }, true);


          //scope.calendarActive
          scope.calendarActive = scope.initActiveCalendar;

          scope.monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

          scope.yearShow = false;
          scope.monthShow = false;
          scope.dateShow = true;

          
          // Toggle edit popover
          scope.toggleEditPopover = function () {

            if(attr.disabled) return;
            
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;

            if ( !!scope.selected ) {
              scope.selected = undefined;
            } else {
              
              if(scope.datetime == undefined) {
                var _d = new Date();
                if(scope.minuteStep) {
                  scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours()+1, 0, 0));
                } else {
                  scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours(), _d.getMinutes(), 0));
                }
                scope.selected = scope.datetime || moment();
              }  else {
                scope.selected = scope.datetime || moment();
              }
              // else {
              //   if(scope.minuteStep) {
              //     var _d = new Date(scope.datetime);
              //     console.log(_d)
              //     scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours()+1, 0, 0));
              //   } 
              // }

              angular.copy(scope.selected);
              scope.selectedCopy = scope.selected.clone();
              // 기준 날짜
              scope.calendar = scope.selected.clone();
              // 년도 표시 시작
              scope.calendarYearStart = scope.selected.clone();
              // 월
              scope.currentMonth = scope.calendar.month() + 1;

              // 년도 표시 시작 끝자리 1로 만들기 위한 함수
              var yearStartLast= scope.calendarYearStart.format('YYYY').substring(3,4);
              if (yearStartLast != '1') {
                scope.calendarYearStart.subtract(yearStartLast - 1, 'year');
              }

              // 년도 표시 종료
              scope.calendarYearEnd = scope.calendarYearStart.clone();

              // 년도 Array 만들기 위한 날짜
              scope.calendarArray = scope.calendarYearStart.clone();

              scope.calendarYearEnd.add(19, 'year');
              
              scope.yearList = [];

              var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
              for(var i = 0; i <= maxSize; i++) {
                if (i != 0) {
                  scope.calendarArray.add(1, 'year');
                }                
                scope.yearList.push(scope.calendarArray.format('YYYY'));
              }
              
            }
          };

          scope.addYears = function() {
            scope.calendarYearStart.add(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.add(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.subtractYears = function() {
            scope.calendarYearStart.subtract(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.subtract(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.addYear = function() {
            scope.calendar.add(1, 'year');
          };

          scope.subtractYear = function() {
            scope.calendar.subtract(1, 'year');
          };
          
          scope.addMonth = function() {
            scope.calendar.add(1, 'months')
            scope.currentMonth = scope.calendar.month() + 1;
          };

          scope.subtractMonth = function() {
            scope.calendar.subtract(1, 'months');
            scope.currentMonth = scope.calendar.month() + 1;
          };
          
          scope.clcikYearShow = function () {
            scope.yearShow = true;
            scope.monthShow = false;
            scope.dateShow = false;
          };

          scope.clickYear = function (year) {
            scope.yearShow = false;
            scope.monthShow = true;
            scope.dateShow = false;
            scope.calendar = moment(new Date(year));
            scope.selected = moment(new Date(year, scope.selected.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
          };

          scope.clickMonth = function (month) {
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;
            scope.calendar = moment(new Date(scope.calendar.year(), month-1, scope.selected.hours(), scope.selected.minutes(), 0));
            scope.currentMonth = scope.calendar.month() + 1;
            scope.selected = moment(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
            scope.selectTempDate = moment(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
          };


          scope.resetDate = function () {
            scope.selected = null;
            scope.datetime = null;
          };
          // Update selected date

          scope.updateAddHour = function(datetime) {
            if(scope.maxHour != undefined) {
              if(Number(scope.maxHour) <= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateSubtractHour = function(datetime) {
            if(scope.minHour != undefined) {
              if(Number(scope.minHour) >= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateAddMinutes = function(datetime) {
            if(scope.maxHour != undefined) {
              if(Number(scope.maxHour) <= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateSubtractMinutes = function(datetime) {
            if(scope.minHour != undefined) {
              if(Number(scope.minHour) >= scope.datetime.hours()) {
                if(scope.datetime.minute() == 0) {
                  return;
                }
              }
            }
            scope.update(datetime);
          };


          scope.update = function (datetime, calendar_update) {
            if ( scope.selected.isSame(datetime) && !!scope.datetime ) { 
              scope.close();
              return; 
            }

            var checkTime = angular.copy(scope.selected);
            if ( !datetime ) {
              scope.selected = scope.datetime = undefined;
            } else if ( ( !scope.minDate || datetime > scope.minDate ) && ( !scope.maxDate || datetime < scope.maxDate ) ) {
              if(scope.selectTempDate) {
                scope.selected.year(scope.selectTempDate.year()).month(scope.selectTempDate.month()).date(datetime.date()).hours(scope.selectTempDate.hours()).minutes(scope.selectTempDate.minutes()).seconds(0);
                scope.selectTempDate = undefined;
                scope.datetime = scope.selected.clone();
              } else {
                scope.selected.year(datetime.year()).month(datetime.month()).date(datetime.date()).hours(datetime.hours()).minutes(datetime.minutes()).seconds(0);
                scope.datetime = scope.selected.clone();
              }
              
              if ( (scope.selected.clone().startOf('week').month() !== scope.calendar.month() && scope.selected.clone().endOf('week').month() !== scope.calendar.month()) || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              if ( !scope.datetime ) {
                scope.datetime = scope.selected;
              }
              //scope.datetime = scope.selected.clone();

              scope.$$postDigest(function () {
                $timeout(function () {
                  scope.onChange();

                  /* if(scope.selected.hours() == checkTime.hours() && scope.selected.minute() == checkTime.minute()) {
                    scope.close();
                  } */
                }, 0);
              });

            

            } else {
              scope.warning = true;
              $timeout(function () {
                scope.warning = false;
              }, 250);
              
            }
            scope.currentMonth = scope.calendar.month() + 1;
          };


          // Close edit popover
          scope.close = function () {
            scope.selected = '';
            scope.calendarActive = scope.initActiveCalendar;

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          };

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !!scope.selected && !element[0].contains(e.target) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( !!scope.selected && e.keyCode === 27) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

/**
 * Datetime directive (date and time input element)
 */
 webapp.directive('datetimePicker', ['$document', '$timeout', function ($document, $timeout) {
  return {
    restrict: 'E',
    scope: {
      datetime: '=',
      initActiveCalendar: '=',
      format: '=?',
      dateFormat: '=?',
      timeFormat: '=?',
      minDate:'=?',
      maxDate:'=?',
      maxHour: "=?",
      minHour: "=?",
      hourStep:'=?',
      minuteStep:'=?',
      secondStep:'=?',
      allowClear:'=?',
      onChange: '&',
      onClose: '&?',
      placeholder: '@',
      clearText: '@',
      closeText: '@',
      cssClass:'@',
      disabled: "@"
    },
    replace: true,
    templateUrl: 'scripts/directives/date-form/datetime-picker.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element, attr) {
          //lang:ko를 등록한다. 한번 지정하면 자동적으로 사용된다.
          moment.lang('ko', {
            weekdays: ["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],
            weekdaysShort: ["일","월","화","수","목","금","토"],
          });

          // Get current date
          scope.current = moment();
          
          //console.log(angular.copy(scope.datetime))
          // Convert datetime object to moment.js if its not a moment object yet
          // if ( scope.datetime && !scope.datetime._isAMomentObject ) {
          //   scope.datetime = moment(scope.datetime, scope.format);
          // }
          
          scope.$watch("datetime", function(item){
            var itemTypeOf = typeof(item);
            if(itemTypeOf == 'undefined') {
            } else if(item == null) {
            } else if(isNullOrEmpty(item)) {
            } else {
              if(item.dayOfMonth) {
                var _d = item.year + '-' + (item.monthValue) + '-' + item.dayOfMonth + ' ' + item.hour + ':' + item.minute + ':' + item.second;
                _d = moment( new Date(_d)).format("YYYY-MM-DD HH:mm:ss");
                scope.datetime = moment.utc(_d).local(scope.format);
              } else {
                scope.datetime = moment(item, scope.format);
              }
            }
          }, true);

          scope.timeChanged = function(newVal) {
            var itemTypeOf = typeof(newVal);
            if(itemTypeOf == 'undefined') {
            } else if(newVal == null) {
            } else if(isNullOrEmpty(newVal)) {
            } else {
              scope.datetimeTime = newVal;
              scope.datetime.set({'hour': scope.datetimeTime.getHours(), 'minute': scope.datetimeTime.getMinutes()});
              scope.update(scope.datetime);
            }
          };

          //scope.calendarActive
          scope.calendarActive = scope.initActiveCalendar;

          scope.monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

          scope.yearShow = false;
          scope.monthShow = false;
          scope.dateShow = true;

          
          // Toggle edit popover
          scope.toggleEditPopover = function () {

            if(attr.disabled) return;
            
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;

            if ( !!scope.selected ) {
              scope.selected = undefined;
            } else {
              
              if(scope.datetime == undefined) {
                var _d = new Date();
                if(scope.minuteStep) {
                  scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours()+1, 0, 0));
                } else {
                  scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours(), _d.getMinutes(), 0));
                }
                scope.selected = scope.datetime || moment();
              }  else {
                scope.selected = scope.datetime || moment();
              }

              scope.datetimeTime = new Date(1970, 1, 1, scope.datetime.hours(), scope.datetime.minutes(), 0);
              // else {
              //   if(scope.minuteStep) {
              //     var _d = new Date(scope.datetime);
              //     console.log(_d)
              //     scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours()+1, 0, 0));
              //   } 
              // }

              angular.copy(scope.selected);
              scope.selectedCopy = scope.selected.clone();
              // 기준 날짜
              scope.calendar = scope.selected.clone();
              // 년도 표시 시작
              scope.calendarYearStart = scope.selected.clone();
              // 월
              scope.currentMonth = scope.calendar.month() + 1;

              // 년도 표시 시작 끝자리 1로 만들기 위한 함수
              var yearStartLast= scope.calendarYearStart.format('YYYY').substring(3,4);
              if (yearStartLast != '1') {
                scope.calendarYearStart.subtract(yearStartLast - 1, 'year');
              }

              // 년도 표시 종료
              scope.calendarYearEnd = scope.calendarYearStart.clone();

              // 년도 Array 만들기 위한 날짜
              scope.calendarArray = scope.calendarYearStart.clone();

              scope.calendarYearEnd.add(19, 'year');
              
              scope.yearList = [];

              var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
              for(var i = 0; i <= maxSize; i++) {
                if (i != 0) {
                  scope.calendarArray.add(1, 'year');
                }                
                scope.yearList.push(scope.calendarArray.format('YYYY'));
              }
              
            }
          };

          scope.addYears = function() {
            scope.calendarYearStart.add(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.add(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.subtractYears = function() {
            scope.calendarYearStart.subtract(20, 'year');
            scope.calendarArray = scope.calendarYearStart.clone();
            scope.calendarYearEnd.subtract(20, 'year');

            scope.yearList = [];
            var maxSize = scope.calendarYearEnd.year() - scope.calendarYearStart.year();
            for(var i = 0; i <= maxSize; i++) {
              if (i != 0) {
                scope.calendarArray.add(1, 'year');
              }                
              scope.yearList.push(scope.calendarArray.format('YYYY'));
            }
          };

          scope.addYear = function() {
            scope.calendar.add(1, 'year');
          };

          scope.subtractYear = function() {
            scope.calendar.subtract(1, 'year');
          };
          
          scope.addMonth = function() {
            scope.calendar.add(1, 'months')
            scope.currentMonth = scope.calendar.month() + 1;
          };

          scope.subtractMonth = function() {
            scope.calendar.subtract(1, 'months');
            scope.currentMonth = scope.calendar.month() + 1;
          };
          
          scope.clcikYearShow = function () {
            scope.yearShow = true;
            scope.monthShow = false;
            scope.dateShow = false;
          };

          scope.clickYear = function (year) {
            scope.yearShow = false;
            scope.monthShow = true;
            scope.dateShow = false;
            scope.calendar = moment(new Date(year));
            scope.selected = moment(new Date(year, scope.selected.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
          };

          scope.clickMonth = function (month) {
            scope.yearShow = false;
            scope.monthShow = false;
            scope.dateShow = true;
            scope.calendar = moment(new Date(scope.calendar.year(), month-1, scope.selected.hours(), scope.selected.minutes(), 0));
            scope.currentMonth = scope.calendar.month() + 1;
            scope.selected = moment(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
            scope.selectTempDate = moment(new Date(scope.calendar.year(), scope.calendar.month(), scope.selected.date(), scope.selected.hours(), scope.selected.minutes(), 0));
          };


          scope.resetDate = function () {
            scope.selected = null;
            scope.datetime = null;
          };
          // Update selected date

          scope.updateAddHour = function(datetime) {
            if(scope.maxHour != undefined) {
              if(Number(scope.maxHour) <= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateSubtractHour = function(datetime) {
            if(scope.minHour != undefined) {
              if(Number(scope.minHour) >= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateAddMinutes = function(datetime) {
            if(scope.maxHour != undefined) {
              if(Number(scope.maxHour) <= scope.datetime.hours()) {
                return;
              }
            }
            scope.update(datetime);
          };

          scope.updateSubtractMinutes = function(datetime) {
            if(scope.minHour != undefined) {
              if(Number(scope.minHour) >= scope.datetime.hours()) {
                if(scope.datetime.minute() == 0) {
                  return;
                }
              }
            }
            scope.update(datetime);
          };


          scope.update = function (datetime, calendar_update) {
            // if ( scope.selected && scope.selected.isSame(datetime) && !!scope.datetime ) { 
            //   scope.close();
            //   return; 
            // }

            var checkTime = angular.copy(scope.selected);
            if ( !datetime ) {
              scope.selected = scope.datetime = undefined;
            } else if ( ( !scope.minDate || datetime > scope.minDate ) && ( !scope.maxDate || datetime < scope.maxDate ) ) {
              if(scope.selectTempDate) {
                scope.selected.year(scope.selectTempDate.year()).month(scope.selectTempDate.month()).date(datetime.date()).hours(scope.selectTempDate.hours()).minutes(scope.selectTempDate.minutes()).seconds(0);
                scope.selectTempDate = undefined;
                scope.datetime = scope.selected.clone();
              } else {
                scope.selected.year(datetime.year()).month(datetime.month()).date(datetime.date()).hours(datetime.hours()).minutes(datetime.minutes()).seconds(0);
                scope.datetime = scope.selected.clone();
              }
              
              if ( (scope.selected.clone().startOf('week').month() !== scope.calendar.month() && scope.selected.clone().endOf('week').month() !== scope.calendar.month()) || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              if ( !scope.datetime ) {
                scope.datetime = scope.selected;
              }
              //scope.datetime = scope.selected.clone();

              scope.$$postDigest(function () {
                $timeout(function () {
                  scope.onChange();

                  /* if(scope.selected.hours() == checkTime.hours() && scope.selected.minute() == checkTime.minute()) {
                    scope.close();
                  } */
                }, 0);
              });

            

            } else {
              scope.warning = true;
              $timeout(function () {
                scope.warning = false;
              }, 250);
              
            }
            scope.currentMonth = scope.calendar.month() + 1;
          };


          // Close edit popover
          scope.close = function () {
            scope.selected = '';
            scope.calendarActive = scope.initActiveCalendar;

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          };

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !!scope.selected && !element[0].contains(e.target) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( !!scope.selected && e.keyCode === 27) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

/**
 * Time directive (time input element)
 */
 webapp.directive('timeInput', ['$document', '$timeout', function ($document, $timeout) {
  return {
    restrict: 'E',
    scope: {
      time: '=',
      format: '=?',
      timeFormat: '=?',
      minDate:'=?',
      maxDate:'=?',
      hourStep : '=?',
      minuteStep : '=?',
      secondStep : '=?',
      allowClear:'=?',
      onChange: '&',
      onClose: '&?',
      placeholder: '@',
      clearText: '@',
      closeText: '@',
      cssClass:'@',
      disabled: "@",
    },
    replace: true,
    templateUrl: 'scripts/directives/date-form/time-input.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element, attr) {

          // Convert time object to moment.js if its not a moment object yet
          // if ( scope.time && !scope.time._isAMomentObject ) {
          //   scope.time = moment(scope.time, scope.format);
          // }

          scope.$watch("time", function(item){
            var itemTypeOf = typeof(item);
            if(itemTypeOf == 'undefined') {
            } else if(itemTypeOf == 'string') {
              item = item.split(":");
              var _d = new Date();
              //scope.selected = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), item[0], item[1], 0));
              scope.time = ("0" + item[0]).slice(-2) + ":" + ("0" + item[1]).slice(-2);
              scope.datetime = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), item[0], item[1], 0));
            } else if(item == null) {
            } else if(isNullOrEmpty(item)) {
            } else {
              item = item._i.split(":");
              var _d = new Date();
              scope.time = ("0" + item[0]).slice(-2) + ":" + ("0" + item[1]).slice(-2);
              scope.datetime = scope.selected = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), item[0], item[1], 0));
            }
          }, true);

          // Toggle edit popover
          scope.toggleEditPopover = function () {
            
            if(attr.disabled) return;
            
            if ( !!scope.selected ) {
              scope.selected = undefined;
            } else {
              scope.selected = scope.time || moment();
              var itemTypeOf = typeof(scope.selected);
              if(itemTypeOf == 'string') {
                var item = scope.selected.split(":");
                var _d = new Date();
                scope.selected = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), item[0], item[1], 0));
              }

              if(scope.datetime == undefined && scope.minuteStep) {
                var _d = new Date();
                scope.selected = moment(new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), _d.getHours()+1, 0, 0));
              }

              if(scope.time == undefined) {
                scope.update(scope.selected.clone().add(scope.minuteStep || 1, 'minutes'))
              }
            }
          };

          // Update selected time
          scope.update = function (datetime, calendar_update) {
            if ( scope.selected.isSame(datetime) && !!scope.time ) { return; }
            if ( !datetime ) {
              scope.selected = scope.time = undefined;
            } else if ( ( !scope.minDate || datetime > scope.minDate ) && ( !scope.maxDate || datetime < scope.maxDate ) ) {
              scope.selected.year(datetime.year()).month(datetime.month()).date(datetime.date()).hours(datetime.hours()).minutes(datetime.minutes()).seconds(datetime.seconds());
              //if ( !scope.time ) {
                scope.time = ("0" + scope.selected.hours()).slice(-2) + ":" + ("0" + scope.selected.minutes()).slice(-2);
              //}
              scope.$$postDigest(function () {
                scope.onChange();
              });
            } else {
              scope.warning = true;
              $timeout(function () {
                scope.warning = false;
              }, 250);
            }
          };

          scope.resetDate = function () {
            scope.selected = null;
            scope.time = null;
          };

          // Close edit popover
          scope.close = function () {
            scope.selected = '';

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          };

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !!scope.selected && !element[0].contains(e.target) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( !!scope.selected && e.keyCode === 27) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

webapp.directive('dateRange', ['$document', '$timeout', function ($document, $timeout) {

  return {
    restrict: 'E',
    scope: {
      start: '=',
      end: '=',
      presets: '=?',
      minDate:'=?',
      maxDate:'=?',
      onChange: '&?',
      onChangeStart: '&?',
      onChangeEnd: '&?',
      onClose: '&?',
      closeText: '@',
    },
    replace: true,
    templateUrl: 'scripts/directives/date-range-form/date-range.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element) {

          // Get current date
          scope.current = moment();

          // Convert start datetime to moment.js if its not a moment object yet
          if ( scope.start && !scope.start._isAMomentObject ) {
            scope.start = moment(scope.start);
          }

          // Convert end datetime to moment.js if its not a moment object yet
          if ( scope.end && !scope.end._isAMomentObject ) {
            scope.end = moment(scope.end);
          }

          // Get number of weeks in month
          scope.getNumWeeks = function () {
            if ( !scope.calendar ) { return; }

            var firstDayOfWeek = scope.calendar.clone().startOf('week').weekday();

            var firstOfMonth = scope.calendar.clone().startOf('month');
            var lastOfMonth = scope.calendar.clone().endOf('month');

            var firstWeekDay = (firstOfMonth.weekday() - firstDayOfWeek + 7) % 7;

            return Math.ceil((firstWeekDay + scope.calendar.daysInMonth()) / 7);
          }

          // Set selected date
          scope.selectDate = function (date) {
            if ( scope.selected === date ) {
              scope.selected = undefined;
            } else {
              scope.selected = date;
              scope.calendar = scope.selected.clone();
              scope.presetsActive = false;
            }
          };

          // Check if date is within bounds of min and max allowed date
          scope.isWithinBounds = function (date) {
            return  ( !scope.minDate || date > scope.minDate ) && ( !scope.maxDate || date < scope.maxDate );
          };

          // Update selected date
          scope.setDate = function (date, calendar_update) {
            if ( scope.selected.isSame(date) || !scope.isWithinBounds(date) ) { return; }
            if ( ( scope.selected === scope.start && date < scope.end ) || ( scope.selected === scope.end && date > scope.start ) ) {
              scope.selected.year(date.year()).month(date.month()).date(date.date()).hours(date.hours()).minutes(date.minutes()).seconds(date.seconds());
              if ( (scope.selected.clone().startOf('week').month() !== scope.calendar.month() && scope.selected.clone().endOf('week').month() !== scope.calendar.month()) || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              if ( scope.selected === scope.start ) {
                scope.callbackStart();
              }
              if ( scope.selected === scope.end ) {
                scope.callbackEnd();
              }
              scope.callbackAll();
            } else {
              scope.warning = ( scope.selected === scope.start ) ? 'end' : 'start';
              $timeout(function () {
                scope.warning = undefined;
              }, 250);
            }
          };

          // Set start and end datetime objects to the selected preset
          scope.selectPreset = function (preset) {
            // Hide presets menu on select
            scope.close();

            // Don't do anything if nothing is changed
            if ( scope.start.isSame(preset.start) && scope.end.isSame(preset.end) ) { return; }

            // Update start datetime object if changed
            if ( !scope.start.isSame(preset.start) ) {
              scope.start = preset.start.clone();
              scope.callbackStart();
            }

            // Update end datetime object if changed
            if ( !scope.end.isSame(preset.end) ) {
              scope.end = preset.end.clone();
              scope.callbackEnd();
            }

            // Something has definitely changed, fire ambiguous callback
            scope.callbackAll();
          };

          // Callbacks fired on change of start datetime object
          scope.callbackStart = function () {
            if ( !!scope.onChangeStart ) {
              $timeout(function () {
                scope.onChangeStart();
              });
            }
          };

          // Callbacks fired on change of end datetime object
          scope.callbackEnd = function () {
            if ( !!scope.onChangeEnd ) {
              $timeout(function () {
                scope.onChangeEnd();
              });
            }
          };

          // Callbacks fired on change of start and/or end datetime objects
          scope.callbackAll = function () {
            if ( !!scope.onChange ) {
              $timeout(function () {
                scope.onChange();
              });
            }
          };

          // Close edit popover
          scope.close = function () {
            scope.selected = '';
            scope.presetsActive = false;

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          }

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !element[0].contains(e.target) && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( e.keyCode === 27 && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

webapp.directive('datetimeRange', ['$document', '$timeout', function ($document, $timeout) {

  return {
    restrict: 'E',
    scope: {
      start: '=',
      end: '=',
      presets: '=?',
      minDate:'=?',
      maxDate:'=?',
      onChange: '&?',
      onChangeStart: '&?',
      onChangeEnd: '&?',
      onClose: '&?',
      closeText: '@',
    },
    replace: true,
    templateUrl: 'scripts/directives/date-range-form/datetime-range.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element) {

          // Get current date
          scope.current = moment();

          // Convert start datetime to moment.js if its not a moment object yet
          if ( scope.start && !scope.start._isAMomentObject ) {
            scope.start = moment(scope.start);
          }

          // Convert end datetime to moment.js if its not a moment object yet
          if ( scope.end && !scope.end._isAMomentObject ) {
            scope.end = moment(scope.end);
          }

          // Get number of weeks in month
          scope.getNumWeeks = function () {
            if ( !scope.calendar ) { return; }

            var firstDayOfWeek = scope.calendar.clone().startOf('week').weekday();

            var firstOfMonth = scope.calendar.clone().startOf('month');
            var lastOfMonth = scope.calendar.clone().endOf('month');

            var firstWeekDay = (firstOfMonth.weekday() - firstDayOfWeek + 7) % 7;

            return Math.ceil((firstWeekDay + scope.calendar.daysInMonth()) / 7);
          }

          // Set selected date
          scope.selectDate = function (date) {
            if ( scope.selected === date ) {
              scope.selected = undefined;
            } else {
              scope.selected = date;
              scope.calendar = scope.selected.clone();
              scope.presetsActive = false;
            }
          };

          // Check if date is within bounds of min and max allowed date
          scope.isWithinBounds = function (date) {
            return  ( !scope.minDate || date > scope.minDate ) && ( !scope.maxDate || date < scope.maxDate );
          };

          // Update selected date
          scope.setDate = function (date, calendar_update) {
            if ( scope.selected.isSame(date) || !scope.isWithinBounds(date) ) { return; }
            if ( ( scope.selected === scope.start && date < scope.end ) || ( scope.selected === scope.end && date > scope.start ) ) {
              scope.selected.year(date.year()).month(date.month()).date(date.date()).hours(date.hours()).minutes(date.minutes()).seconds(date.seconds());
              if ( (scope.selected.clone().startOf('week').month() !== scope.calendar.month() && scope.selected.clone().endOf('week').month() !== scope.calendar.month()) || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              if ( scope.selected === scope.start ) {
                scope.callbackStart();
              }
              if ( scope.selected === scope.end ) {
                scope.callbackEnd();
              }
              scope.callbackAll();
            } else {
              scope.warning = ( scope.selected === scope.start ) ? 'end' : 'start';
              $timeout(function () {
                scope.warning = undefined;
              }, 250);
            }
          };

          // Set start and end datetime objects to the selected preset
          scope.selectPreset = function (preset) {
            // Hide presets menu on select
            scope.close();

            // Don't do anything if nothing is changed
            if ( scope.start.isSame(preset.start) && scope.end.isSame(preset.end) ) { return; }

            // Update start datetime object if changed
            if ( !scope.start.isSame(preset.start) ) {
              scope.start = preset.start.clone();
              scope.callbackStart();
            }

            // Update end datetime object if changed
            if ( !scope.end.isSame(preset.end) ) {
              scope.end = preset.end.clone();
              scope.callbackEnd();
            }

            // Something has definitely changed, fire ambiguous callback
            scope.callbackAll();
          };

          // Callbacks fired on change of start datetime object
          scope.callbackStart = function () {
            if ( !!scope.onChangeStart ) {
              $timeout(function () {
                scope.onChangeStart();
              });
            }
          };

          // Callbacks fired on change of end datetime object
          scope.callbackEnd = function () {
            if ( !!scope.onChangeEnd ) {
              $timeout(function () {
                scope.onChangeEnd();
              });
            }
          };

          // Callbacks fired on change of start and/or end datetime objects
          scope.callbackAll = function () {
            if ( !!scope.onChange ) {
              $timeout(function () {
                scope.onChange();
              });
            }
          };

          // Close edit popover
          scope.close = function () {
            scope.selected = '';
            scope.presetsActive = false;
            scope.calendarActive = false;

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          }

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !element[0].contains(e.target) && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( e.keyCode === 27 && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

'use strict';

webapp.directive('timeRange', ['$document', '$timeout', function ($document, $timeout) {

  return {
    restrict: 'E',
    scope: {
      start: '=',
      end: '=',
      presets: '=?',
      minDate:'=?',
      maxDate:'=?',
      onChange: '&?',
      onChangeStart: '&?',
      onChangeEnd: '&?',
      onClose: '&?',
      closeText: '@',
    },
    replace: true,
    templateUrl: 'scripts/directives/date-range-form/time-range.html',
    compile: function () {
      return {
        pre: function preLink() {},
        post: function postLink(scope, element) {

          // Get current date
          scope.current = moment();

          // Convert start datetime to moment.js if its not a moment object yet
          if ( scope.start && !scope.start._isAMomentObject ) {
            scope.start = moment(scope.start);
          }

          // Convert end datetime to moment.js if its not a moment object yet
          if ( scope.end && !scope.end._isAMomentObject ) {
            scope.end = moment(scope.end);
          }

          // Get number of weeks in month
          scope.getNumWeeks = function () {
            if ( !scope.calendar ) { return; }

            var firstDayOfWeek = scope.calendar.clone().startOf('week').weekday();

            var firstOfMonth = scope.calendar.clone().startOf('month');
            var lastOfMonth = scope.calendar.clone().endOf('month');

            var firstWeekDay = (firstOfMonth.weekday() - firstDayOfWeek + 7) % 7;

            return Math.ceil((firstWeekDay + scope.calendar.daysInMonth()) / 7);
          }

          // Set selected date
          scope.selectDate = function (date) {
            if ( scope.selected === date ) {
              scope.selected = undefined;
            } else {
              scope.selected = date;
              scope.calendar = scope.selected.clone();
              scope.presetsActive = false;
            }
          };

          // Check if date is within bounds of min and max allowed date
          scope.isWithinBounds = function (date) {
            return  ( !scope.minDate || date > scope.minDate ) && ( !scope.maxDate || date < scope.maxDate );
          };

          // Update selected date
          scope.setDate = function (date, calendar_update) {
            if ( scope.selected.isSame(date) || !scope.isWithinBounds(date) ) { return; }
            if ( ( scope.selected === scope.start && date < scope.end ) || ( scope.selected === scope.end && date > scope.start ) ) {
              scope.selected.year(date.year()).month(date.month()).date(date.date()).hours(date.hours()).minutes(date.minutes()).seconds(date.seconds());
              if ( (scope.selected.clone().startOf('week').month() !== scope.calendar.month() && scope.selected.clone().endOf('week').month() !== scope.calendar.month()) || calendar_update ) {
                scope.calendar = scope.selected.clone();
              }
              if ( scope.selected === scope.start ) {
                scope.callbackStart();
              }
              if ( scope.selected === scope.end ) {
                scope.callbackEnd();
              }
              scope.callbackAll();
            } else {
              scope.warning = ( scope.selected === scope.start ) ? 'end' : 'start';
              $timeout(function () {
                scope.warning = undefined;
              }, 250);
            }
          };

          // Set start and end datetime objects to the selected preset
          scope.selectPreset = function (preset) {
            // Hide presets menu on select
            scope.close();

            // Don't do anything if nothing is changed
            if ( scope.start.isSame(preset.start) && scope.end.isSame(preset.end) ) { return; }

            // Update start datetime object if changed
            if ( !scope.start.isSame(preset.start) ) {
              scope.start = preset.start.clone();
              scope.callbackStart();
            }

            // Update end datetime object if changed
            if ( !scope.end.isSame(preset.end) ) {
              scope.end = preset.end.clone();
              scope.callbackEnd();
            }

            // Something has definitely changed, fire ambiguous callback
            scope.callbackAll();
          };

          // Callbacks fired on change of start datetime object
          scope.callbackStart = function () {
            if ( !!scope.onChangeStart ) {
              $timeout(function () {
                scope.onChangeStart();
              });
            }
          };

          // Callbacks fired on change of end datetime object
          scope.callbackEnd = function () {
            if ( !!scope.onChangeEnd ) {
              $timeout(function () {
                scope.onChangeEnd();
              });
            }
          };

          // Callbacks fired on change of start and/or end datetime objects
          scope.callbackAll = function () {
            if ( !!scope.onChange ) {
              $timeout(function () {
                scope.onChange();
              });
            }
          };

          // Close edit popover
          scope.close = function () {
            scope.selected = '';
            scope.presetsActive = false;

            if ( !!scope.onClose ) {
              scope.onClose();
            }
          }

          // Bind click events outside directive to close edit popover
          $document.on('mousedown', function (e) {
            if ( !element[0].contains(e.target) && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });

          // Bind 'esc' keyup event to close edit popover
          $document.on('keyup', function (e) {
            if ( e.keyCode === 27 && (!!scope.presetsActive || !!scope.selected) ) {
              scope.$apply(function () {
                scope.close();
              });
            }
          });
        }
      };
    }
  };
}]);

webapp.controller('KakaomapConfigCtrl', [ '$scope', '$rootScope', '$element', '$compile', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
  function KakaomapConfigCtrl($scope, $rootScope, $element, $compile, $filter, CONSTANT, modalFactory, postApi) {
    var vm = this;

    vm.address = '';
    vm.name = '';
    vm.kakaomapChanged = null;
    vm.kakaomapConfigModal = kakaomapConfigModal;

    function kakaomapConfigModal() {
      var ctrl = 'KakaomapConfigModalCtrl as modalCtrl';
      var paramData = {address : vm.address, name : vm.name};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('lg', 'components/modal/kakaomap/kakaomap-config-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        console.log('ok');
        if (vm.kakaomapChanged) {
          vm.kakaomapChanged();
        }
      }, function (cancelData) {
        // 취소
      });
    }
  }
]);

webapp.directive('kakaomapConfig', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      address : "=",
      name : "=",
      kakaomapChanged : "=",
    },
    templateUrl : 'scripts/directives/kakaomap-config/kakaomap-config.html',
    controller : 'KakaomapConfigCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.kakaomapChanged = scope.kakaomapChanged;

      scope.$watchCollection('address', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.address = scope.address;
      });

      scope.$watchCollection('name', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.name = scope.name;
      });      
    }
  };
} ]);


webapp.controller('MetatableSortableCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT',
function MetatableSortableCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, systemCodeAPISrv, CONST) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];
    vm.mode = 'A';

    vm.colSizeList = [
      {Code : "1", CodeValue : "1"},
      {Code : "2", CodeValue : "2"},
      {Code : "3", CodeValue : "3"},
      {Code : "4", CodeValue : "4"}
    ];

    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);

      },
    };

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    };

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;
    };

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        if(vm.viewType == "L") obj[i].listColumnSort = (i + 1);
        else if(vm.viewType == "S") obj[i].searchIdx = (i + 1);
        else obj[i].editColumnSort = (i + 1);
      }
      //vm.bindData = obj;      
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    };

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data, dataType) {

      if(dataType != undefined) vm.codeList = dataType;

      var col = data.metaColumns;
      if(vm.viewType == "L") col.sort(function(a, b){ return a.listColumnSort - b.listColumnSort; })
      else  col.sort(function(a, b){ return a.editColumnSort - b.editColumnSort; })
      vm.bindData = data.metaColumns;
    };

    vm.onChangeSection = function(idx, item){

      if(vm.checkSection == "Y") {
        for(var i = idx+1; i < vm.bindData.length; i++) {
          vm.bindData[i].columnSection = item;
        }
      }
    };

    vm.onChangeDetailColSize = function(idx, item){
      if(vm.checkEditColSize == "Y") {
        for(var i = idx+1; i < vm.bindData.length; i++) {
          vm.bindData[i].editColumnRowCount = item;
        }
      }
    };

    /**
     * 검색박스 > 폼그룹 설정 변경 시
     * @param {int} idx 메뉴 IDX
     * @param {int} item 선택된 아이템
    */
    vm.checkSearchDuplicateFormGroup = function(idx, item){
      for (var i = 0; i < vm.bindData.length; i++) {
        var at = vm.bindData[i];
        if (isNullOrEmpty(item.groupIdTarget)) {
          if (isNullOrEmpty(item.groupIdTargetExt)) {
            break;
          } else {
            if (at.columnPhysicalNm == item.groupIdTargetExt) {
              at.checkSearchDuplicate = "N";
              item.groupIdTargetExt = "";
              break;
            }
          }
        } else {
          if (at.columnPhysicalNm == item.groupIdTarget) {
            at.checkSearchDuplicate = "Y";
            item.groupIdTargetExt = item.groupIdTarget;
            break;
          }
        }
      }
    };
    
    vm.makeListData = function() {

    };

    vm.init = function() {
      //console.log("mode=", vm.mode);
    };
    
  }]);

webapp.directive('metatableSortable', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@",
      viewType : "=",
      checkSection : "=",
      checkEditColSize : "=",
      mode : "=",
    },
    templateUrl : 'scripts/directives/meta-sortable-container/sortable-container.html',
    controller : 'MetatableSortableCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;

      ctrl.checkSection = scope.checkSection;
      ctrl.checkEditColSize = scope.checkEditColSize;

      if (ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.viewType = scope.viewType;
      if (scope.mode != undefined) ctrl.mode = scope.mode;
      ctrl.init();

      if (scope.initCallback != undefined) {
        scope.initCallback(ctrl);
      }

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      };

      scope.$watchCollection('checkSection', function(item){
        ctrl.checkSection = item;
      });

      scope.$watchCollection('checkEditColSize', function(item){
        ctrl.checkEditColSize = item;
      });


      scope.$watchCollection('viewType', function(item){
        if(ctrl.bindData) { 
          if (item == "L") ctrl.bindData.sort(function(a, b){ return a.listColumnSort - b.listColumnSort; });
          else ctrl.bindData.sort(function(a, b){ return a.editColumnSort - b.editColumnSort; });
        }
        ctrl.viewType = item;
      });
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('MetadataConfigCtrl', [ '$scope', '$rootScope', '$element', '$compile', '$filter', '$timeout', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
  function MetadataConfigCtrl($scope, $rootScope, $element, $compile, $filter, $timeout, CONSTANT, modalFactory, postApi) {
    var vm = this;

    vm.tableNm = '';
    //vm.metadataChanged = null;
    vm.metadataConfigModal = metadataConfigModal;

    function metadataConfigModal() {
      var ctrl = 'MetadataConfigModalCtrl as modalCtrl';
      var paramData = {tableNm : vm.tableNm};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('lg', 'components/modal/metadata/metadata-config-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        if (vm.metadataChanged) {
          $timeout(function() {
            vm.metadataChanged(true);            
          }, 1);
        }
      }, function (cancelData) {
        // 취소
      });
    }
  }
]);

webapp.directive('metadataConfig', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      tableNm : "=",
      metadataChanged : "=",
    },
    templateUrl : 'scripts/directives/metadata-config/metadata-config.html',
    controller : 'MetadataConfigCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.tableNm = scope.tableNm;
      $timeout(function() {
        ctrl.metadataChanged = scope.metadataChanged;
      }, 1);

      // scope.$watch(attrs.metadataChanged, function(item){
      //   console.log('$watch(attrs.metadataChanged', item);
      //   ctrl.metadataChanged = item;
      // }, true);
    }
  };
} ]);


webapp.directive('mdDateUtcToLocal', 
  [ '$compile', '$parse',
  function($compile, $parse) {
  return {
    require:'^ngModel',
    restrict:'A',
    scope : {
      mdDateFilter : "=",
      ngModel : "=",
      mdDateUtcToLocal : "="
    },
    link:function (scope, elm, attrs, ctrl) {
      scope.$watchCollection('mdDateUtcToLocal', function(value) {        
        if(value) {
          var format = moment(moment(value).toDate()).format('YYYY-MM-DD');
          scope.ngModel = format;
        }
      });
    }
  };
} ]);

webapp.controller('SearchConditionCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT',
  function SearchConditionCtrl($scope, $element, $compile, CONSTANT) {
    var vm = this;

    vm.searchCoditionStr = "";
    vm.columnMap = null;
    vm.srch = "";
    vm.count = 0;
    vm.countStr = "0";

    vm.updateSearchCoditionStr = function() {
      
      vm.countStr = vm.count? vm.count : 0;
      vm.searchConditionStr = "";

      if (vm.columnMap == null)
        return;

      var str = [];
      for (var key in vm.srch) {
        if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
          continue;

        var name = key;
        var value = vm.srch[key];

        if (vm.columnMap[key]) {
          name = vm.columnMap[key].ColumnLogicalNm;

          if (vm.columnMap[key].ColumnLogicalDataType == "50") {
            if (vm.columnMap[key].CodeList) {
              vm.columnMap[key].CodeList.forEach(function (v) {
                if (v.Code == value) {
                  value = v.CodeValue;
                  return;
                }
              });
            }
          }
        }

        str.push(name + ':' + value);
      }

      vm.searchConditionStr += str.join(',');
    };
  }
]);

webapp.directive('searchCondition', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      count : "=",
      columnMap : "=",
      srch : "="
    },
    templateUrl : 'scripts/directives/search-condition/search-condition.html',
    controller : 'SearchConditionCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('count', function(value) {
        ctrl.count = scope.count;
      });

      scope.$watchCollection('columnMap', function(value) {
        ctrl.columnMap = scope.columnMap;
      });

      scope.$watchCollection('srch', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.srch = scope.srch;
        ctrl.updateSearchCoditionStr();
      });
    }
  };
} ]);

webapp.controller('SelectDataGroupCtrl', [ '$scope', '$rootScope', '$element', '$compile', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
  function SelectDataGroupCtrl($scope, $rootScope, $element, $compile, $filter, CONSTANT, modalFactory, postApi) {
    var vm = this;

    vm.DatagroupNm = $rootScope.gVariable.dataGroupNm;
    vm.ActionNm = $rootScope.gVariable.dataActionNm;

    vm.changeDatagroup = changeDatagroup;

    function changeDatagroup() {
      var ctrl = 'DataGroupActionModalCtrl as vc';
      var paramData = {};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('modal', 'components/modal/dataanalysis/data-group-action-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        $rootScope.setGVariable('dataGroupId', okData.DatagroupId);
        $rootScope.setGVariable('dataActionId', okData.ActionId);
        $rootScope.setGVariable('dataGroupNm', okData.DatagroupNm);
        $rootScope.setGVariable('dataActionNm', okData.ActionNm);
        vm.DatagroupNm = okData.DatagroupNm;
        vm.ActionNm = okData.ActionNm;

        if (vm.codeChanged) {
          vm.codeChanged();
        }
      }, function (cancelData) {
        // 취소
      });
    }
  }
]);

webapp.directive('selectDataGroup', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeChanged : "=",
    },
    templateUrl : 'scripts/directives/select-data-group/select-data-group.html',
    controller : 'SelectDataGroupCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.codeChanged = scope.codeChanged;
    }
  };
} ]);

webapp.controller('SortableContainerCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window',
function SortableContainerCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];


    vm.menuNm = "대부서등록";
    vm.isBranch = false;

    if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchCode"))) {
      vm.menuNm = "소부서추가";
      vm.isBranch = true;
    }


    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        vm.setChangedSort(vm.changeSortArray);

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    }

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";

      var checkDepth;
      if (depth == 1) {

        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].CodeLevel == 1) data.sort = vm.bindData[i].Sort + 1;
          } 
        }
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }


      if (depth != 1) {
        $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
        $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
        setTimeout(function () {
          $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
        }, 500);
      }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;
      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RelateDataId;
          data.tempId = data.KeyId;
          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          //var $obj = findObject(vm.bindData, 'Sort', sort);

          if (depth != 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    }

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;

      if(vm.isBranch) vm.rootTitle = "조직관리";
    }

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        var minusLength = $("#atMenu_" + obj[i].tempId).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-minus").length;
        if(minusLength != 0) $("#atMenu_" + obj[i].tempId).css("display","block");
        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        //if(obj[i].child != undefined)
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    }

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      if (obj.child.length > 0) {
        gAlert('', '하위 항목이 있으면 삭제할 수 없습니다.', {
          btn: '확인', fn: function () { }
        });
        return;
      }

      var $obj = $(vm.targetField);
      var sort = obj.Sort;
      var mSort = makeSortPath(sort);
      var msg = "";
      msg = "[" + obj.ItemNm + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {              
              //if(result.body.docs[0].CodeLevel > 1) {
                // var $obj = null;
                // if (mSort.length == 2) {
                //   $obj = $("[menu-sort=" +mSort[0] + "].as-sortable-item-text");
                // } else if (mSort.length == 3) {
                //   $obj = $("[menu-sort=" +mSort[1] + "].as-sortable-item-text");
                // }



                // if(mSort.length > 1) {
                //   $obj.find("i").eq(0).removeClass("fa-plus");
                //   $obj.find("i").eq(0).addClass("fa-minus");
                //   setTimeout(function () {
                //     $obj.find(".as-sortable-item-text").css("display", "block");
                //   }, 500);
                // }
              //}
            }            
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ItemNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ItemNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ItemNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }

    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];

      if(vm.isBranch) {
        data.push({
          CodeLevel : 1,
          Depth : 1,
          GroupNm : $window.sessionStorage.getItem("loginBranchName"),
          ItemNm : $window.sessionStorage.getItem("loginBranchName"),
          KeyId :  $window.sessionStorage.getItem("loginBranchCode"),
          UseYN : "Y",
          Sort : 100,
          child : []
        })

        data.sort(function(a, b){
          return a.Depth - b.Depth;
        })
      }

      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].CodeLevel == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].CodeLevel > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentCommonCodeId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }
      vm.bindData = temp;
    };

    vm.makeListData = function() {

    }

    vm.init = function() {
      
      //vm.getData();
    };
    
  }]);

webapp.directive('sortableContainer', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@"
    },
    templateUrl : 'scripts/directives/sortable-container/sortable-container.html',
    controller : 'SortableContainerCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      }
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('AutoCompleteCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$timeout',
  function AutoCompleteCtrl($scope, $element, $compile, CONSTANT, $translate, $timeout) {
    var vm = this;
    vm.isDisabled = false;
    vm.CodeList = [];
    vm.selectIdx = -2;

    var itemWrap = null;
    var wrapMaxCount = 0;
    vm.hasAddTop = false;
    vm.itemHeight = 0;
    vm.wrapHeight = 0;

    vm.setCursor = false;

    vm.setCodeList = function(item) {
      vm.selectIdx = vm.hasAddTop? -2 : -1;
      vm.CodeList = angular.copy(item);
    };

    vm.setDisabled = function(check) {
      vm.isDisabled = (check) ? true : false;
    };

    vm.focusInput = function(e) {

      if (!vm.hasAddTop) {
        vm.wrapHeight = 185;
      }

      if (vm.wrapHeight == 0) {
        //$timeout(function(){
          var count = 5;
          var ct = $(e.currentTarget);
          var acw = ct.parent().find(".sz-autocomplete-item-list > div");
          vm.itemHeight = acw.height();  
          vm.wrapHeight = vm.itemHeight * count;
          acw = ct.parent().find(".sz-autocomplete-item-list").css("max-height", vm.wrapHeight);
          itemWrap = ct.parent().find(".sz-autocomplete-item-list");
          wrapMaxCount = count;
          if (ct.parent().find(".sz-autocomplete-item-list > div").eq(0).hasClass("add-top-row")) {
            vm.hasAddTop = true;
            vm.selectIdx= -2;
          } else {
            vm.selectIdx= -1;
          }
      } 
      
      if (isNullOrEmpty(vm.inputValue)) {
        angular.forEach(vm.copyCodeList, function(item){
          item.isSelect = false;
        });
        vm.CodeList = vm.copyCodeList;
        
        // Timeout 적용 이유
        // isSelect가 적용되어있는 아이템이 Focus 되었다가 없어지는 현상이 있어
        // timeout 을 적용 하여 Focus를 뺀 후 리스트를 호출 하기 위함
        $timeout(function(){
          if (!vm.setCursor) {
            vm.inputFocus = true;
          } else {
            vm.setCursor = false;
          }
        }, 100);
      } else {
        vm.inputFocus = true; 
      }
    };

    vm.focusoutInput = function(e) {
      $timeout(function(){
        vm.setCursor = false;
        //vm.inputFocus = false;
        if (!isNullOrEmpty(vm.inputValue)) {
          vm.setChangeCtrlData();
        }
      }, 100);
    };

    vm.onKeydownEvent = function(e) {
      if (e.keyCode == 40 || e.keyCode == 38 || e.keyCode == 13) {
        if (e.keyCode == 40) { // ArrowDown
          if (vm.selectIdx + 1 == vm.CodeList.length) return;
          vm.selectIdx++;
          if (vm.selectIdx -1 > -1) vm.CodeList[vm.selectIdx-1].isSelect = false; 
        } else if (e.keyCode == 38) { //ArrowUp
          if (vm.hasAddTop) {
            if (vm.selectIdx - 1 == -3) return; 
            vm.selectIdx--;
            if (vm.selectIdx + 1 > -1) vm.CodeList[vm.selectIdx+1].isSelect = false; 
          } else {
            if (vm.selectIdx - 1 == -2) return;
            vm.selectIdx--;
            if(vm.selectIdx + 1 > -1) vm.CodeList[vm.selectIdx+1].isSelect = false;
          }
        } 
          
        var targetIdx = 0;
        if (vm.hasAddTop) {
          if (e.keyCode == 40) {
            targetIdx = vm.selectIdx+1;
          } else if (e.keyCode == 38) {
            targetIdx = vm.selectIdx;
          }
        } else {
          targetIdx = vm.selectIdx;
        }

        if (e.keyCode == 40) {
          var cal = (targetIdx - wrapMaxCount) * vm.itemHeight; 
          itemWrap.scrollTop(cal);
          var tp = vm.itemHeight * (wrapMaxCount-1);
          var top = itemWrap.find("> div").eq(targetIdx).position().top;
          itemWrap.scrollTop(cal + (top - tp));
        } else if (e.keyCode == 38) {
          var cal = (targetIdx - wrapMaxCount) * vm.itemHeight; 
          itemWrap.scrollTop(cal);
          var tp = vm.itemHeight * (wrapMaxCount-1);
          if (targetIdx == -1) targetIdx = 0;
          var top = itemWrap.find("> div").eq(targetIdx).position().top;
          itemWrap.scrollTop(cal + (top - tp));
          var cal = targetIdx * vm.itemHeight; 
          itemWrap.scrollTop(itemWrap.scrollTop() - vm.itemHeight);
        }

        if (vm.selectIdx > -1 && vm.CodeList[vm.selectIdx]) vm.CodeList[vm.selectIdx].isSelect = true;

        if (e.keyCode == 13) { // Enter
          e.preventDefault();
          return; false;
          if (vm.selectIdx == 0 && vm.inputValue == "") {
            vm.selectData();
          } else {          
            $timeout(function () {
              e.preventDefault();
              console.log(vm.selectIdx, vm.hasAddTop);
              if (vm.selectIdx > -2) {
                if (vm.selectIdx == -1) {
                  if (vm.inputValue == "") {
                    vm.selectData();
                  } else {
                    if (vm.hasAddTop) {
                      vm.selectTopData();
                    } else {
                      vm.selectData(vm.CodeList[vm.selectIdx], vm.selectIdx, e);
                    }
                  }
                } else {
                  vm.selectData(vm.CodeList[vm.selectIdx], vm.selectIdx, e);
                }
              }
            }, 100);
          }
        }

        if (e.keyCode != 13) { // Enter
          vm.setCursor = false;
          // if(vm.selectIdx > -1) {
          //   if(!isNullOrEmpty(vm.inputValue))
          //     vm.setLastInputCusor( vm.inputValue.length);
          // }
        }
      } else {

      }
    };
    
    vm.selectData = function(item, idx, e) {
      if (item == undefined) {
        vm.setChangeItem();
      } else {
        try {
          angular.forEach(vm.CodeList, function(item){
            item.isSelect = false;
          });
          // if(vm.selectIdx > -1) {
          //   vm.CodeList[vm.selectIdx].isSelect = false;
          // }
        } catch(e) {
          console.log('Error:', e);
        }
        vm.inputValue = item.CodeValue;
        vm.selectIdx = idx;
        vm.CodeList[vm.selectIdx].isSelect = true;
        vm.setChangeItem(item);
        vm.selectIdx = 0;
        vm.setCursor = false;
      }
    };

    vm.init = function() {};
  }
]);

webapp.directive('szAutoComplete', 
  [ '$compile', '$parse', '$translate', '$timeout', '$document', '$interval',
  function($compile, $parse, $translate, $timeout, $document, $interval) {
    return {
      transclude : true,
      replace: false,
      restrict : 'E',
      scope : {
        codeList : "=",
        codeModel : "=",
        codeKey : "=",
        callback : "=",
        //addTopRow : "=",
        addTopRowCallback : "=",
        ngDisabled : "=",
        initValue : "=",
        placeholder : "@",
        changeCallback : "=",
        // isFocus : "="
        index : "="
      },
      template : function(element, iAttrs){
        var input = $("<input />", {
          "ng-focus" : "avc.focusInput($event)",
          "ng-change" : "avc.setChangeValue()",
          "ng-model" : "avc.inputValue",
          "ng-keydown" : "avc.onKeydownEvent($event)",
          "ng-disabled" : "avc.isDisabled",
          "type":"text" ,
          "ng-blur" : "avc.focusoutInput($event)",
          //"autocomplete" : 'destroy'
        });

        if (iAttrs.placeholder) input.attr("placeholder", iAttrs.placeholder);
        if (iAttrs.id) input.attr("id", iAttrs.id);
        
        var format = "<span>{{opt.CodeValue}}</span>";
        if (iAttrs.format) {
          format = "";
          var A = iAttrs.format.split("}");
          for(var i = 0; i < A.length-1; i++) {
            var item = A[i];
            var str = "";
            if(item.indexOf(":") > -1) {
              var S = item.split(":");
              str = '<span ' + S[1] + ' ng-bind="opt.' + S[0].replace("{","") + '"></span> ';
            } else {
              str = "<span>" + "{{opt." + item.replace("{","") + "}}</span> ";
            }
            format += str;
          }
        }

        var wrap = $("<div />");
        var itemWrap = $("<div />", { class : "sz-autocomplete-item-list", "ng-show" : "avc.inputFocus" });
        var autoCompleteWrap = $("<div />", {class: "auto-complet-wrap"});
        var codeTx = iAttrs.codeList.split(".");
        codeTx.splice(0,1);
        var items  = $("<div />", { "ng-repeat": "opt in avc.CodeList" , "ng-class" : "{'szac-select' : opt.isSelect}" , html : format });
        items.attr("ng-click", "avc.selectData(opt, $index, $event)");
        autoCompleteWrap.html(input.clone());
        if (iAttrs.addTopRow) {
          var addRow  = $("<div />", { 
            html : "<span>" +iAttrs.addTopRow +"</span>", 
            "ng-click" : "avc.selectTopData()", 
            "ng-class" : "{'szac-select' : avc.selectIdx == -1}",
            class : "add-top-row"
          });
          itemWrap.append(addRow.clone());
        }
        itemWrap.append(items.clone());
        autoCompleteWrap.append(itemWrap.clone())
        wrap.append(autoCompleteWrap.clone());
        return wrap.html();
      },
      controller : 'AutoCompleteCtrl as avc',
      link : function(scope, element, attr, ctrl) {
        //return {

        var interval;
        var loadCodeList = false;
        ctrl.cDisabled = false;
        scope.$on('$destroy', function() { 
          $interval.cancel(interval);
        });

        // scope.isFocus = "N";
        // scope.checkSelect = true;
        // if(attr.codeKey) {
        //   ctrl.hasCodeKey = true;
        // } else {
        //   ctrl.hasCodeKey = false;
        // }
        //"autocomplete" : 'destroy'
        $(element).find("input").attr("autocomplete", "off");

        function autoCompletSetInit(val, callback) {
          var value = scope.$eval(val);
          if (!isNullOrEmpty(value)) {
            scope.element.value = scope.$eval(val);
          }
        }

        scope.$watch("initValue", function(item) {
          ctrl.inputValue = item;
        });

        // scope.checkSelect = false;

        scope.$watch("codeList", function(item){
          if (item) {
            // copyCodeList = angular.copy(item);
            ctrl.setCodeList(item);
            ctrl.CodeList = angular.copy(item); 
            ctrl.copyCodeList = angular.copy(item);
          }
        });

        scope.$watch("ngDisabled", function(item){
          if (item != undefined) {
            ctrl.setDisabled(item);            
          }          
        });
        
        var reBindCheck = false;
        var dualCheck = false;
        var initBind = true;
        scope.$watch("codeModel", function(item){
          if (item) {
            if (item.length > 0) {
              if (initBind) {
                initBind = false;
                if (loadCodeList) {
                  ctrl.setModel(item);
                } else {
                  var count = 0;
                  interval = $interval(function(){
                    if (ctrl.CodeList != null && ctrl.CodeList.length > 0) {
                      $interval.cancel(interval);
                      loadCodeList = true;
                      ctrl.setModel(item);
                    }
                    count++;
                    if (count > 10) {
                      $interval.cancel(interval);
                      loadCodeList = true;
                    }
                  }, 500);
                }
              } else {
                ctrl.inputValue = item;
              }
            } else {
              ctrl.CodeList = angular.copy(ctrl.copyCodeList); 
            }  
          } else {
            ctrl.CodeList = angular.copy(ctrl.copyCodeList); 
          }
        });

        ctrl.setModel = function(item) {
          if (!isNullOrEmpty(scope.codeKey)) {
            ctrl.inputValue = item;

            var temp = ctrl.copyCodeList.filter(function(e){
              return e.CodeValue.indexOf(item) > -1;
            });

            ctrl.CodeList = temp;
            angular.forEach(ctrl.CodeList, function(item){
              if (item.Code == scope.codeKey) {
                item.isSelect = true;
              }
            })
          } else {
            reBindCheck = true;
            //ctrl.inputValue = item;
          }
        };

        ctrl.setChangeValue = function() {
          if (attr.changeCallback) {
            scope.changeCallback(ctrl.inputValue);
          } else {
            ctrl.selectIdx = (ctrl.hasAddTop) ? -2  : -1;
            $timeout(function(){
              angular.forEach(ctrl.copyCodeList, function(item){
                item.isSelect = false;
              });
              if (!isNullOrEmpty(ctrl.inputValue)) {
                if (ctrl.inputValue.length > 0) {
                  var temp = ctrl.copyCodeList.filter(function(e){
                    //e.isShow = (e.CodeValue.indexOf(item) > -1) ? true : false;
                    return e.CodeValue.indexOf(ctrl.inputValue) > -1;
                  });
                  ctrl.setCodeList(angular.copy(temp));
                  ctrl.setChangeCtrlData();
                } else {
                  ctrl.setCodeList(ctrl.copyCodeList);
                  ctrl.setChangeCtrlData();
                }
              } else {
                ctrl.setCodeList(ctrl.copyCodeList);
                ctrl.setChangeCtrlData();
              }
            }, 100);
          }
        };

        ctrl.selectTopData = function(){
          $(element).find("input").blur();
          ctrl.setCursor = false;
          scope.addTopRowCallback();
          ctrl.inputFocus = false;
          ctrl.inputValue = "";
          delete scope.codeModel;
          delete scope.codeKey;
          if (ctrl.selectIdx > -1) {
            ctrl.CodeList[ctrl.selectIdx].isSelect = false;
          }
          ctrl.selectIdx = -2;
        };

        ctrl.setChangeItem = function(item) {
          ctrl.inputFocus = false;
          $(element).find("input").blur();
          ctrl.setCursor = false;
          if (scope.callback) {
            // scope.checkSelect = true;
            //scope.codeModel =  item.CodeValue;
            if (item == undefined) {
              var temp = {};
              var codeModel = attr.codeModel.split(".");
              var codeKey = attr.codeKey.split(".");
              temp["CodeValue"] = ctrl.inputValue;
              temp["Code"] = "";
              scope.callback(temp);
            } else {
              scope.codeModel =  item.CodeValue;
              scope.codeKey = item.Code;
              if (scope.index != undefined) {
                item.index = scope.index;
              }
              scope.callback(item);
            }
            
          } else {
            // scope.checkSelect = true;
            scope.codeModel =  item.CodeValue;
            scope.codeKey = item.Code;
            // if(ctrl.hasCodeKey) {
            //   scope.codeKey =  item.Code;
            // }
          }
        };

        ctrl.setChangeCtrlData = function() {
          if (!isNullOrEmpty(ctrl.inputValue)) {
            scope.codeModel = ctrl.inputValue;
          } else {
            scope.codeModel = "";
            scope.codeKey = "";
          }
        };

        ctrl.setLastInputCusor = function(pos) {
          var input =  $(element).find("input");//.foucs().setCursorPosition(1);
          input.focus().setCursorPosition(pos)
        };

        element.on('mousedown', function(e) {
          if (ctrl.isDisabled !== true) {
            scope.$apply(function () {
              ctrl.setCursor = false;
              ctrl.inputFocus = true;
            });
          }
        });

        $document.on('mousedown', function (e) {
          if ( ctrl.inputFocus && !element[0].contains(e.target) ) {
            scope.$apply(function () {
              ctrl.setCursor = false;
              ctrl.inputFocus = false;
            });
          }
        });

        $document.on('keydown', function (e) {
          if ( ctrl.inputFocus && !element[0].contains(e.target) ) {
            scope.$apply(function () {
              ctrl.setCursor = false;
              ctrl.inputFocus = true;
            });
          }
        });
    
        // Bind 'esc' keyup event to close edit popover
        // $document.on('keyup', function (e) {
        //   if (ctrl.inputFocus && !element[0].contains(e.target) ) {
        //     // scope.$apply(function () {
        //     //   scope.close();
        //     // });
        //     scope.$apply(function () {
        //       ctrl.setCursor = false;
        //       ctrl.inputFocus = false;
        //     });
        //   }
          
        // });
        autoCompletSetInit(attr.codeModel, attr.ngChange);
      },
    };
}]);
'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:TileControlClose
 * @description
 * # TileControlClose
 */
webapp.directive('tileControlClose', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var tile = element.parents('.tile');

      element.on('click', function () {
        tile.addClass('closed').fadeOut();
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:tileControlFullscreen
 * @description
 * # tileControlFullscreen
 */
webapp.directive('tileControlFullscreen', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var dropdown = element.parents('.dropdown');

      element.on('click', function () {
        dropdown.trigger('click');
      });
    },
  };
});

'use strict';

webapp.directive('tileControlLightbox', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var tile = element.parents('.tile')[0];
      var dropdown = element.parents('.dropdown');

      element.on('click', function () {
        dropdown.trigger('click');
      });

      element.magnificPopup({
        items: {
          src: tile,
          type: 'inline',
        },
        closeBtnInside: false,
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:tileControlRefresh
 * @description
 * # tileControlRefresh
 */
webapp.directive('tileControlRefresh', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var tile = element.parents('.tile');
      var dropdown = element.parents('.dropdown');

      element.on('click', function () {
        tile.addClass('refreshing');
        dropdown.trigger('click');
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:tileControlToggle
 * @description
 * # tileControlToggle
 */
webapp.directive('tileControlToggle', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var tile = element.parents('.tile');

      tile.children().find('a i').removeClass();
      tile.children().find('a i').addClass('fa fa-minus fa-lg');

      element.on('click', function () {
        if (tile.children().find('a i').hasClass('fa-plus')) {
          tile.children().find('a i').removeClass();
          tile.children().find('a i').addClass('fa fa-minus fa-lg');
        } else {
          tile.children().find('a i').removeClass();
          tile.children().find('a i').addClass('fa fa-plus fa-lg');
        }

        tile.toggleClass('collapsed');
        tile.children().not('.tile-header').slideToggle(150);
      });
    },
  };
});

webapp.directive('tileControlToggleHide', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      var tile = element.parents('.tile');

      tile.children().find('a i').removeClass();
      tile.children().find('a i').addClass('fa fa-plus fa-lg');

      tile.removeClass('collapsed');
      tile.children().not('.tile-header').hide();

      element.on('click', function () {
        if (tile.children().find('a i').hasClass('fa-plus')) {
          tile.children().find('a i').removeClass();
          tile.children().find('a i').addClass('fa fa-minus fa-lg');
        } else {
          tile.children().find('a i').removeClass();
          tile.children().find('a i').addClass('fa fa-plus fa-lg');
        }

        tile.toggleClass('collapsed');
        tile.children().not('.tile-header').slideToggle(150);
      });
    },
  };
});

(function () {
  
  'use strict';
  
  webapp
    .directive('timepicker', [
      '$window', '$document', 'utils',
      'elemUtils', 'dateUtils', timepicker
    ])
    .directive('timeInput', ['$filter', 'dateUtils', timeInput])
    .directive('renderOnBlur', renderOnBlur)
    .directive('renderOnEnter', renderOnEnter);
  
  function timepicker ($window, $document, utils, elemUtils, dateUtils) {

      return {
        restrict: 'EA',
        scope: {
          'theTime': '=ngModel',
          callback: '=',
        },
        controller: ['$scope', 'utils', 'dateUtils', TimepickerController],
        replace: true,
        // Template at the bottom of the HTML section 
        templateUrl: 'scripts/directives/time-picker/time-picker.html',
        link: linker,
      };

      function TimepickerController ($scope, utils, dateUtils) {
        
        var self = this;
        
        $scope.choiceTimes = [];
        $scope.generateChoiceTimes = _generateChoiceTimes;
        $scope.selectPrevTime = _selectPrevTime;
        $scope.selectNextTime = _selectNextTime;
        $scope.isSelectedTime = _isSelectedTime;
        $scope.showingChoiceList = false;
        $scope.showChoiceList = _showChoiceList;
        $scope.hideChoiceList = _hideChoiceList;
        $scope.toggleChoiceList = _toggleChoiceList;
        $scope.setTime = _setTime;
        
        /// Event listeners

        $scope.$watch('theTime', function (newVal, oldVal) {
          if (newVal) { $scope.selectedTime = newVal; }

          if ($scope.callback) { $scope.callback(newVal); }
        });
        
        // Allow the linker to pass a reference to the
        // directive element.
        this.init = function (element, inputField, dropdown) {
          this.element = element;
          this.inputField = inputField;
          this.dropdown = dropdown;
        };
        
        /// Functions

        function _generateChoiceTimes (startTime, endTime, stepTime) {
          var newTime = new Date(1970, 1, 1, startTime.substring(0, 2), startTime.substring(2, 4), 0);
          do {
            $scope.choiceTimes.push(newTime);

            newTime = dateUtils.dateAdd(
              newTime, 'minute', stepTime
            );
          } while (newTime <= new Date(1970, 1, 1, endTime.substring(0, 2), endTime.substring(2, 4), 0));
        }

        function _selectPrevTime () {

          // TODO: choiceTimes could be managed better with
          //       something like a circular linked list
          //       with next and prev methods on each node.

          // Don't change the selection if dropdown is not showing
          if (!$scope.showingChoiceList) { return; }

          // Get the next index value, based on the current selection.
          // If this is the first item, wrap around to the last item
          var selectedIndex = _getSelectedTimeIndex();

          var nextIndex = selectedIndex === 0 ? $scope.choiceTimes.length - 1
                                              : selectedIndex - 1;
          
          // Update the selected time
          $scope.selectedTime = $scope.choiceTimes[nextIndex];
          $scope.$apply();
          
        }
        
        function _selectNextTime () {

          // TODO: choiceTimes could be managed better with
          //       something like a circular linked list
          //       with next and prev methods on each node.

          // Don't change the selection if dropdown is not showing
          if (!$scope.showingChoiceList) { return; }

          // Get the next index value, based on the current selection.
          // If this is the first item, wrap around to the last item
          var selectedIndex = _getSelectedTimeIndex();
          var nextIndex = selectedIndex === $scope.choiceTimes.length - 1
                                              ? 0 : selectedIndex + 1;

          // Update the selected time
          $scope.selectedTime = $scope.choiceTimes[nextIndex];
          $scope.$apply();

        }
        
        /** 
         * Date objects cannot be directly compared. Instead,
         * coerce to a `Number` before making the comparison.
         **/
        function _isSelectedTime (time) {
          return Number(time) === Number($scope.selectedTime);
        }
        
        /**
         * Like the Array.indexOf() method: find the index of
         * the current time selection in the array or return `-1`.
         **/
        function _getSelectedTimeIndex () {
          for (var i = 0; i < $scope.choiceTimes.length; i++) {
            if (_isSelectedTime($scope.choiceTimes[i])) {
              return i;
            }
          }
          return -1;
        }
        
        function _showChoiceList (event) {
          if ($scope.showingChoiceList === true) { return; }
          $scope.showingChoiceList = true;
          $scope.$apply();
          $document.on('click', _hideChoiceList);
        }

        function _hideChoiceList (event) {
          if ($scope.showingChoiceList === false) { return; }
          if (event && (self.inputField[0].contains(event.target)
                        || self.dropdown[0].contains(event.target))) {
            return;
          }
          $scope.showingChoiceList = false;
          $scope.$apply();
          $document.off('click', _hideChoiceList);
        }

        function _toggleChoiceList (event) {
          if ($scope.showingChoiceList) { _hideChoiceList(event); }
          else { _showChoiceList(event); }
          $scope.$apply();
        }

        function _setTime(time) {
          $scope.theTime = time;
        }

      }

      function linker (scope, element, attrs, tpCtrl) {
        
        // initialize field value
        var inputField = element.find('input'),
            dropdown = angular.element(
                element[0].querySelector('.timepicker-dropdown')
            );

        // Pass element references to controller
        tpCtrl.init(element, inputField, dropdown);

        setTimeout(function() {
          // Initialize scope variables
          scope.labelText = attrs.label || '';
          scope.startTime = attrs.startTime ? attrs.startTime : '0800';
          scope.endTime = attrs.endTime ? attrs.endTime : '2100';
          scope.stepTime = attrs.stepTime ? attrs.stepTime : 30;

          scope.generateChoiceTimes(scope.startTime, scope.endTime, scope.stepTime);
        }, 1000);

        /// Event Listeners
        inputField.on('focus + click', function (event) {
          inputField[0].select();
          scope.showChoiceList();
          _updateDropdownPosition();
          scope.$apply();
          _updateDropdownScroll();
        });

        inputField.on('keydown', function (event) {
          switch(event.keyCode) {
            case 38: // Up arrow
              scope.selectPrevTime();
              _updateDropdownScroll();
              break;
            case 40: // Down arrow
              scope.selectNextTime();
              _updateDropdownScroll();
              break; 
            case 13: // Enter key
              scope.setTime(scope.selectedTime);
              scope.hideChoiceList();
              break;
            default: // Any other key
              // Any other should close the dropdown
              scope.hideChoiceList();
              _updateDropdownScroll();
              break;
          }
        });
        
        //
        dropdown.on('click', function (event) {
          inputField[0].focus();
          scope.$apply();
          scope.hideChoiceList();
        });

        // Hide the dropdown menu while resizing. Debounce for performance.
        $window.addEventListener('resize', utils.debounce(function () {
          dropdown.css({visibility: 'hidden'});
        }, 50, true));
        $window.addEventListener('resize', utils.debounce(function () {
          _updateDropdownPosition();
          dropdown.css({visibility: 'visible'});
        }, 50));
        
        /// Functions
        
        function _updateDropdownScroll () {
          var selectedTimeDiv = _getSelectedTimeDiv();
          if (selectedTimeDiv) {
            dropdown[0].scrollTop = selectedTimeDiv.offsetTop;
          }
        }
        
        /**
         * Get div corresponding to selected time.
         * ids are in the format of 'd' + timestamp
         */
        function _getSelectedTimeDiv () {
          return dropdown[0].querySelector(
            '#d' + String(Number(scope.selectedTime))
          );
        }

        function _updateDropdownPosition () {
          // Reposition the dropdown.
          // This needs to be called after the dropdown has been revealed, in
          // order for the width of the dropdown to be read properly.
          var dropdownPosition = elemUtils.below(
            inputField[0], dropdown[0]
          );
          dropdown.css('top', dropdownPosition.top + 'px');
          // dropdown.css('left', dropdownPosition.left + 'px');
        }

      }
  }

  function timeInput ($filter, dateUtils) {

      return {
          restrict: 'A',
          require: 'ngModel',
          link: linker,
      };

      function linker (scope, element, attrs, ngModelCtrl) {

        var dateFormat = 'a h:mm';

        ngModelCtrl.$formatters = [function (modelValue) {
          return $filter('date')(modelValue, dateFormat);
        }];

        ngModelCtrl.$parsers.unshift(function (viewValue) {
          return dateUtils.parseTimeStringToDate(viewValue);
        });

      }

  }

  /**
   * Re-renders the ng-model attached to an input when the input
   * loses focus.
   **/
  function renderOnBlur () {

      return {
          restrict: 'A',
          require: 'ngModel',
          link: linker,
      };

      function linker (scope, element, attrs, ngModelCtrl) {
          element.on('blur', function () {
              if (!ngModelCtrl.$modelValue) { return; }
              var viewValue = ngModelCtrl.$modelValue;
              for (var i = 0; i < ngModelCtrl.$formatters.length; i++) {
                  viewValue = ngModelCtrl.$formatters[i](viewValue);
              }
              ngModelCtrl.$viewValue = viewValue;
              ngModelCtrl.$render();
          });
      }

  }

  /**
   * Re-renders the ng-model attached to an input when the
   * user presses the `Enter` key while inside the input.
   **/
  function renderOnEnter () {

      return {
          restrict: 'A',
          require: 'ngModel',
          link: linker,
      };

      function linker (scope, element, attrs, ngModelCtrl) {
          element.on('keydown', function (event) {
            if(event.keyCode === 13) {
              event.preventDefault();
              event.stopPropagation();
              if (!ngModelCtrl.$modelValue) { return; }
              var viewValue = ngModelCtrl.$modelValue;
              for (var i = 0; i < ngModelCtrl.$formatters.length; i++) {
                  viewValue = ngModelCtrl.$formatters[i](viewValue);
              }
              ngModelCtrl.$viewValue = viewValue;
              ngModelCtrl.$render();              
            }
          });
      }

  }
  
})();
  
/////// Utility Services
(function () {

  webapp
    .factory('utils', utils)
    .factory('elemUtils', elemUtils)
    .factory('dateUtils', dateUtils)
    .filter('dateToTimestamp', dateToTimestamp);
  
  function dateToTimestamp () {
    return function (date) {
      return date.valueOf();
    };
  }
  
  function utils () {
    
    var exports = {
      debounce: _debounce,
      objIndexFromId: _objIndexFromId,
    };
    
    return exports;

    function _objIndexFromId (source, idVal, idKey) {
      /* Retrieve index of object with key and value that match those provided */
      idKey = typeof idKey !== 'undefined' ? idKey : 'id';
      return source.map(function(x) {return x[idKey]; }).indexOf(idVal);
    }
    
    // Debounce function from David Walsh's blog
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    function _debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
    
  }
  
  /**
   * Library of useful DOM Element operations
   **/
  function elemUtils () {

    var exports = {
      // dimensions
      outerWidth: _outerWidth,
      outerHeight: _outerHeight,
      animationDuration: _animationDuration,
      // positioning
      above: _above,
      below: _below,
      centerOffset: _centerOffset,
    };

    return exports;

    /// Element dimension functions

    function _outerWidth (element) {
      /** Get the width of an element including margins */
      var elemCSS = window.getComputedStyle(element);
      return element.offsetWidth
        + (parseFloat(elemCSS.marginLeft, 10) || 0)
        + (parseFloat(elemCSS.marginRight, 10) || 0);
    }

    function _outerHeight (element) {
      /** Get the height of an element including margins */
      var elemCSS = window.getComputedStyle(element);
      return element.offsetHeight 
        + (parseFloat(elemCSS.marginTop, 10) || 0)
        + (parseFloat(elemCSS.marginBottom, 10) || 0);      
    }

    function _animationDuration (element) {
      /* Get the computed animation duration on the element */
      var elementCSS = window.getComputedStyle(element);
      return parseFloat(elementCSS['animation-duration'], 10);
    }

    /// Element positioning functions

    function _above (parent, child) {
      /* Get child position that centers it above parent */
      throw new Error('The `Position.above()` method is not yet implemented.');
    }

    function _below (parent, child) {
      /* Get child position that centers it below parent */

      var childLeft = _centerOffset(parent).left - (_outerWidth(child) / 2);
      var childTop = parent.offsetTop + parent.offsetHeight;

      // Align the child element to the left side of the screen
      // in edge cases where it would overflow the left side
      // or where the screen is skinnier than the child element.
      if (childLeft < 0 || window.innerWidth <= _outerWidth(child)) {
        childLeft = 0;
      } else if (childLeft + _outerWidth(child) > window.innerWidth) {
        // Ensure the popover doesn't overflow the right side of the screen.
        childLeft = window.innerWidth - _outerWidth(child);
      }

      return {
        top: childTop,
        left: childLeft,
      };

    }

    function _centerOffset (element) {
      /* Get the left offset (in pixels) of the center of an element */
      return {
        left: element.offsetLeft + element.offsetWidth / 2,
        top: element.offsetTop + element.offsetHeight / 2,
      };
    }

  }
  
  /**
  * This service provides some shortcut functions for
  * working with dates, especially dates in ISO format,
  * which is the date format Angular prefers when working
  * with date inputs.
  */
  function dateUtils () {

    return {
      dateAdd: _dateAdd,
      parseTimeStringToDate: _parseTimeStringToDate,
    };

    function _dateAdd(date, interval, units) {
      var ret = new Date(date); // don't change original date
      switch(interval.toLowerCase()) {
        case 'year'   :  ret.setFullYear(ret.getFullYear() + units);  break;
        case 'quarter':  ret.setMonth(ret.getMonth() + 3*units);  break;
        case 'month'  :  ret.setMonth(ret.getMonth() + units);  break;
        case 'week'   :  ret.setDate(ret.getDate() + 7*units);  break;
        case 'day'    :  ret.setDate(ret.getDate() + units);  break;
        case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  break;
        case 'minute' :  ret.setTime(ret.getTime() + units*60000);  break;
        case 'second' :  ret.setTime(ret.getTime() + units*1000);  break;
        default       :  ret = undefined;  break;
      }
      return ret;
    }

    /**
     * Parses partial and complete time strings to a date object.
     * Makes time input a lot more user-friendly.
     *
     * For example, all of the following string inputs should be
     * parsed to a date object of today's date and time of 1pm.
     *
     *    var times = ['1:00 pm','1:00 p.m.','1:00 p','1:00pm',
     *                 '1:00p.m.','1:00p','1 pm','1 p.m.','1 p',
     *                 '1pm','1p.m.', '1p','13:00','13'];
     *
     * NOTE: This version is optimized for the en-US locale in
     *       either 12-hour or 24-hour format. It may not be
     *       suitable for all locales. Instaed of re-writing this
     *       function, it would make more sense to extend our
     *       capabilities with locale-specific functions.
     **/
    function _parseTimeStringToDate (timeString) {

      if (timeString == '') return null;

      var time = timeString.match(/(\d+)(:(\d\d))?\s*(p?)/i); 
      if (time == null) return null;

      var hours = parseInt(time[1],10);

      if (hours == 12 && !time[4]) { hours = 0; }
      else { hours += (hours < 12 && time[4])? 12 : 0; }

      var d = new Date(1970, 1, 1, 0, 0, 0);
      d.setHours(hours);
      d.setMinutes(parseInt(time[3],10) || 0);
      d.setSeconds(0, 0);
      return d;

    }
    
  }
    
})();
webapp.controller('TimeSelectCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'postApi',
  function TimeSelectCtrl($scope, $element, $compile, CONSTANT, postApi) {
    var vm = this;
    vm.isDisabled = false;
    vm.selectHour = 0;
    vm.selectMinute = 0;
    vm.beginHour = 8;
    vm.endHour = 21;
    vm.intervalMinute = 10;
    //vm.listHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //vm.listMinute = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
    //                 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
    //                 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
    vm.listHour = Array.from(Array(24).keys());
    vm.listMinute = Array.from(Array(60).keys());
    vm.data = {};

    $scope.isHourRange = function(hour) {
      return hour >= vm.beginHour && hour <= vm.endHour;
    };

    $scope.isMinuteRange = function(minute) {
      if (vm.selectHour == vm.endHour) {
        return minute == 0;
      }
      return minute % vm.intervalMinute == 0;
    };    

    vm.onChangeHandlerHour = function() {
      try {
        if (vm.selectHour == vm.endHour) {
          vm.selectMinute = 0;
          vm.changeMinute(vm.selectMinute);
        }

        vm.changeHour(vm.selectHour);
      } catch (err) {
        vm.changeHour(9);
      }
    };

    vm.onChangeHandlerMinute = function() {
      try {
        vm.changeMinute(vm.selectMinute);
      } catch (err) {
        vm.changeMinute(0);
      }
    };
  }
]);

webapp.directive('timeSelect', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      isDisabled : "=",
      selectHour : "=",
      selectMinute : "=",
      beginHour : "=",
      endHour : "=",
      intervalMinute : "="
    },
    templateUrl : 'scripts/directives/time-select/time-select.html',
    controller : 'TimeSelectCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      if (attrs.isDisabled) {
        ctrl.isDisabled = scope.isDisabled;
      }
      if (attrs.beginHour) {
        ctrl.beginHour = scope.beginHour;
      }
      if (attrs.endHour) {
        ctrl.endHour = scope.endHour;
      }
      if (attrs.intervalMinute) {
        ctrl.intervalMinute = scope.intervalMinute;
      }

      scope.$watchCollection('selectHour', function(value) {
        ctrl.selectHour = scope.selectHour;
      });

      scope.$watchCollection('selectMinute', function(value) {
        ctrl.selectMinute = scope.selectMinute;
      });

      ctrl.changeHour = function(selectHour) {
        try {
          if (attrs.selectHour != undefined) {
            scope.selectHour = selectHour;
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };

      ctrl.changeMinute = function(selectMinute) {
        try {
          if (attrs.selectMinute != undefined) {
            scope.selectMinute = selectMinute;
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };      
    }
  };
} ]);

(function () {

  'use strict';

  webapp
    .directive('timetakenPicker', [
      '$window', '$document', 'utils',
      'elemUtils', timetakenpicker
    ])
    .directive('timetakenInput', ['$filter', timetakenInput]);

  function timetakenpicker($window, $document, utils, elemUtils) {

    return {
      restrict: 'EA',
      scope: {
        'theTime': '=ngModel',
        callback: '=',
      },
      controller: ['$scope', 'utils', TimetakenPickerController],
      replace: true,
      // Template at the bottom of the HTML section 
      templateUrl: 'scripts/directives/timetaken-picker/timetaken-picker.html',
      link: linker,
    };

    function TimetakenPickerController($scope, utils) {

      var self = this;

      $scope.choiceTimes = [];
      $scope.generateChoiceTimes = _generateChoiceTimes;
      $scope.selectPrevTime = _selectPrevTime;
      $scope.selectNextTime = _selectNextTime;
      $scope.isSelectedTime = _isSelectedTime;
      $scope.showingChoiceList = false;
      $scope.showChoiceList = _showChoiceList;
      $scope.hideChoiceList = _hideChoiceList;
      $scope.toggleChoiceList = _toggleChoiceList;
      $scope.setTime = _setTime;

      /// Event listeners

      $scope.$watch('theTime', function (newVal, oldVal) {
        if (newVal) { $scope.selectedTime = newVal; }

        if ($scope.callback) { $scope.callback(newVal); }
      });

      // Allow the linker to pass a reference to the
      // directive element.
      this.init = function (element, inputField, dropdown) {
        this.element = element;
        this.inputField = inputField;
        this.dropdown = dropdown;
      };

      /// Functions

      function _generateChoiceTimes(stepTime) {
        var newTime = 0;
        do {
          $scope.choiceTimes.push(newTime);

          newTime = newTime + parseInt(stepTime);
        } while (newTime <= 180);
      }

      function _selectPrevTime() {

        // TODO: choiceTimes could be managed better with
        //       something like a circular linked list
        //       with next and prev methods on each node.

        // Don't change the selection if dropdown is not showing
        if (!$scope.showingChoiceList) { return; }

        // Get the next index value, based on the current selection.
        // If this is the first item, wrap around to the last item
        var selectedIndex = _getSelectedTimeIndex();

        var nextIndex = selectedIndex === 0 ? $scope.choiceTimes.length - 1
          : selectedIndex - 1;

        // Update the selected time
        $scope.selectedTime = $scope.choiceTimes[nextIndex];
        $scope.$apply();

      }

      function _selectNextTime() {

        // TODO: choiceTimes could be managed better with
        //       something like a circular linked list
        //       with next and prev methods on each node.

        // Don't change the selection if dropdown is not showing
        if (!$scope.showingChoiceList) { return; }

        // Get the next index value, based on the current selection.
        // If this is the first item, wrap around to the last item
        var selectedIndex = _getSelectedTimeIndex();
        var nextIndex = selectedIndex === $scope.choiceTimes.length - 1
          ? 0 : selectedIndex + 1;

        // Update the selected time
        $scope.selectedTime = $scope.choiceTimes[nextIndex];
        $scope.$apply();

      }

      /** 
       * Date objects cannot be directly compared. Instead,
       * coerce to a `Number` before making the comparison.
       **/
      function _isSelectedTime(time) {
        return Number(time) === Number($scope.selectedTime);
      }

      /**
       * Like the Array.indexOf() method: find the index of
       * the current time selection in the array or return `-1`.
       **/
      function _getSelectedTimeIndex() {
        for (var i = 0; i < $scope.choiceTimes.length; i++) {
          if (_isSelectedTime($scope.choiceTimes[i])) {
            return i;
          }
        }
        return -1;
      }

      function _showChoiceList(event) {
        if ($scope.showingChoiceList === true) { return; }
        $scope.showingChoiceList = true;
        $scope.$apply();
        $document.on('click', _hideChoiceList);
      }

      function _hideChoiceList(event) {
        if ($scope.showingChoiceList === false) { return; }
        if (event && (self.inputField[0].contains(event.target)
          || self.dropdown[0].contains(event.target))) {
          return;
        }
        $scope.showingChoiceList = false;
        $scope.$apply();
        $document.off('click', _hideChoiceList);
      }

      function _toggleChoiceList(event) {
        if ($scope.showingChoiceList) { _hideChoiceList(event); }
        else { _showChoiceList(event); }
        $scope.$apply();
      }

      function _setTime(time) {
        $scope.theTime = time;
      }

    }

    function linker(scope, element, attrs, tpCtrl) {

      // initialize field value
      var inputField = element.find('input'),
        dropdown = angular.element(
          element[0].querySelector('.timetakenpicker-dropdown')
        );

      // Pass element references to controller
      tpCtrl.init(element, inputField, dropdown);

      setTimeout(function () {
        // Initialize scope variables
        scope.labelText = attrs.label || '';
        scope.stepTime = attrs.stepTime ? attrs.stepTime : 60;

        scope.generateChoiceTimes(scope.stepTime);
      }, 1000);

      /// Event Listeners
      inputField.on('focus + click', function (event) {
        inputField[0].select();
        scope.showChoiceList();
        _updateDropdownPosition();
        scope.$apply();
        _updateDropdownScroll();
      });

      inputField.on('keydown', function (event) {
        switch (event.keyCode) {
          case 38: // Up arrow
            scope.selectPrevTime();
            _updateDropdownScroll();
            break;
          case 40: // Down arrow
            scope.selectNextTime();
            _updateDropdownScroll();
            break;
          case 13: // Enter key
            scope.setTime(scope.selectedTime);
            scope.hideChoiceList();
            break;
          default: // Any other key
            // Any other should close the dropdown
            scope.hideChoiceList();
            _updateDropdownScroll();
            break;
        }
      });

      //
      dropdown.on('click', function (event) {
        inputField[0].focus();
        scope.$apply();
        scope.hideChoiceList();
      });

      // Hide the dropdown menu while resizing. Debounce for performance.
      $window.addEventListener('resize', utils.debounce(function () {
        dropdown.css({ visibility: 'hidden' });
      }, 50, true));
      $window.addEventListener('resize', utils.debounce(function () {
        _updateDropdownPosition();
        dropdown.css({ visibility: 'visible' });
      }, 50));

      /// Functions

      function _updateDropdownScroll() {
        var selectedTimeDiv = _getSelectedTimeDiv();
        if (selectedTimeDiv) {
          dropdown[0].scrollTop = selectedTimeDiv.offsetTop;
        }
      }

      /**
       * Get div corresponding to selected time.
       * ids are in the format of 'd' + timestamp
       */
      function _getSelectedTimeDiv() {
        return dropdown[0].querySelector(
          '#d' + String(Number(scope.selectedTime))
        );
      }

      function _updateDropdownPosition() {
        // Reposition the dropdown.
        // This needs to be called after the dropdown has been revealed, in
        // order for the width of the dropdown to be read properly.
        var dropdownPosition = elemUtils.below(
          inputField[0], dropdown[0]
        );
        dropdown.css('top', dropdownPosition.top + 'px');
        // dropdown.css('left', dropdownPosition.left + 'px');
      }

    }
  }

  function timetakenInput($filter) {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: linker,
    };

    function linker(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$formatters = [function (modelValue) {
        return $filter('takenTime')(modelValue);
      }];
    }

  }

  /**
   * Re-renders the ng-model attached to an input when the input
   * loses focus.
   **/
  function renderOnBlur() {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: linker,
    };

    function linker(scope, element, attrs, ngModelCtrl) {
      element.on('blur', function () {
        if (!ngModelCtrl.$modelValue) { return; }
        var viewValue = ngModelCtrl.$modelValue;
        for (var i = 0; i < ngModelCtrl.$formatters.length; i++) {
          viewValue = ngModelCtrl.$formatters[i](viewValue);
        }
        ngModelCtrl.$viewValue = viewValue;
        ngModelCtrl.$render();
      });
    }

  }

  /**
   * Re-renders the ng-model attached to an input when the
   * user presses the `Enter` key while inside the input.
   **/
  function renderOnEnter() {

    return {
      restrict: 'A',
      require: 'ngModel',
      link: linker,
    };

    function linker(scope, element, attrs, ngModelCtrl) {
      element.on('keydown', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          event.stopPropagation();
          if (!ngModelCtrl.$modelValue) { return; }
          var viewValue = ngModelCtrl.$modelValue;
          for (var i = 0; i < ngModelCtrl.$formatters.length; i++) {
            viewValue = ngModelCtrl.$formatters[i](viewValue);
          }
          ngModelCtrl.$viewValue = viewValue;
          ngModelCtrl.$render();
        }
      });
    }

  }

})();

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:todoEscape
 * @description
 * # todoEscape
 */
webapp.directive('todoEscape', function () {
  var ESCAPE_KEY = 27;

  return {
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      element.bind('keydown', function (event) {
        if (event.keyCode === ESCAPE_KEY) {
          scope.$apply(attrs.todoEscape);
        }
      });
    },
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:todoFocus
 * @description
 * # todoFocus
 */
webapp.directive('todoFocus', function ($timeout) {
  return {
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      scope.$watch(attrs.todoFocus, function (newVal) {
        if (newVal) {
          $timeout(
            function () {
              element[0].focus();
            },
            0,
            false
          );
        }
      });
    },
  };
});

webapp.controller('UdcDetailCtrl', [ '$scope', '$rootScope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcDetailCtrl($scope, $rootScope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];
    vm.initalized = false;
    vm.name = 'name';

    vm.getCodeValue = function(key) {
      return $rootScope.getCodeValue(vm.metaList[key].CodeList, vm.metaModel[key]);
    };
  }
]);

webapp.directive('udcDetail', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-detail.html',
    controller : 'UdcDetailCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

webapp.controller('UdcEditCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcEditCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcEdit', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-edit.html',
    controller : 'UdcEditCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

webapp.controller('UdcSearchCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcSearchCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcSearch', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-search.html',
    controller : 'UdcSearchCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {
          console.log('Error:', e);
        }
      };
    }
  };
} ]);

webapp.controller('FileAttachController', [
  '$scope',
  '$element',
  '$compile',
  '$timeout',
  'gAlert',
  'gConfirm',
  'StaticVariable',
  'fileUploadService',
  'uuidFactory',
  '$rootScope',
  function FileAttachController(
    $scope,
    $element,
    $compile,
    $timeout,
    gAlert,
    gConfirm,
    StaticVariable,
    fileUploadService,
    uuid,
    $rootScope
  ) {
    var vm = this;
    var addLine = '';
    var request;

    vm.showLoading = false;
    vm.onDelete = onDelete;
    vm.onDeleteCancel = onDeleteCancel;
    vm.loadingPosition = '';
    vm.fileData = new Array();
    var id = 0;

    vm.onChangeHandler = function (files) {

      // 창업멘토링 보고서 파일첨부 조건
      if ($scope.$parent.uploadLocation == 'MentoringRecordEdit') {
        var isValidFiles = true;
        if (files.length + $scope.$parent.nowFileCnt > $scope.$parent.MaxFileCnt) isValidFiles = false;

        if (isValidFiles) {
          angular.forEach(files, function (value) {
            if(isValidFiles && value.size > $scope.$parent.MaxFileSize) {
              isValidFiles = false;            
            }
          });
        }

        if (isValidFiles) {
          angular.forEach(files, function (value) {
            if(isValidFiles && !$scope.$parent.FileType.includes(value.type)) {
              isValidFiles = false;            
            }
          });
        }

        if (!isValidFiles) {
          gAlert('', '파일첨부 조건을 만족하지 않습니다.');
          return false;
        }
      }
      vm.uploadFiles(files);
    };

    $scope.$on('cancelFileSend', function (event, args) {
      if (request) {
        request.about();
      }
    });

    vm.uploadFiles = uploadFiles;

    function uploadFiles(files) {
      console.log('uploadFiles', vm.fileData);
      var tempIds = [];
      // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
      $scope.$root.safeApply(function () {
        var hasZeroByteFile = false;
        angular.forEach(files, function (value) {
          if (value.size == 0) {
            hasZeroByteFile = true;
          } else {
            var obj = {
              isLoaded: false,
              fileName: value.name,
              size: value.size,
              id: id,
              delState: '',
            };
            tempIds.push(obj);
            if (vm.fileData == null) vm.fileData = new Array();
            vm.fileData.push(angular.copy(obj));
            id++;
          }
        });
        console.log('fu', vm.fileData);
        if (hasZeroByteFile) {
          alert('빈 파일이 있습니다.');
          return;
        }

        request = fileUploadService.post(files, null, function (percent) {
          // -- 진행율 표시
          angular.forEach(tempIds, function (obj) {
            console.log('progress percent::', percent);
            $('#filectl_' + obj.id + ' .progress .progress-bar').css(
              'width',
              percent + '%'
            );
          });
          if (percent == 100) {
            vm.showLoading = true;
          }
        });

        try {
          request
            .to(
              StaticVariable.getUrl(
                '/attach/temp/upload.do?userkey=' + $rootScope.gVariable.userKey
              )
            )
            .then(
              function (value) {
                angular.forEach(
                  value.data.responseVO.body.docs,
                  function (item) {
                    angular.forEach(vm.fileData, function (obj) {
                      if (
                        item.fileName == obj.fileName &&
                        item.size == obj.size
                      ) {
                        obj.isLoaded = true;
                        obj.tmpFileKey = item.tmpFileKey;
                        obj.typeId = item.typeId;
                        obj.path = item.path;
                        obj.link = StaticVariable.getUrl(
                          '/attach/temp/' +
                            item.tmpFileKey +
                            '/download.do?fileName=' +
                            item.encFileName +
                            '&userkey=' +
                            $rootScope.gVariable.userKey
                        );
                        obj.delState = '';
                        
                        if($scope.$parent.uploadLocation == 'MentoringRecordEdit') $scope.$parent.nowFileCnt++;
                      }
                    });
                  }
                );
                // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
                angular.element(vm.fileElement).val(null);
                if (vm.callback) {
                  vm.callback.onFileUploadComplete();
                }
                vm.showLoading = false;
              },
              function (reason) {
                console.log(reason);
              }
            );
        } catch (err) {
          console.log(err);
        }
      });
    }
    function onDelete(obj) {
      gConfirm('','첨부파일을 삭제하시겠습니까?', {
        btn: '',
        fn: function () {
          if (obj.typeId != 'temp') {
            if (obj.delState != 'delete') obj.delState = 'delete';
            else obj.delState = '';
            return;
          }

          var idx = -1;
          angular.forEach(vm.fileData, function (val, key) {
            if (val == obj) {
              idx = key;
              return;
            }
          });

          if (idx != -1) {
            if (vm.fileData[idx].typeId == 'temp') {
              fileUploadService.attachFileDelete(
                vm.fileData[idx],
                function (data) {
                  vm.fileData.splice(idx, 1);
                  if($scope.$parent.uploadLocation == 'MentoringRecordEdit') $scope.$parent.nowFileCnt--;
                },
                function (error) {
                  console.log("error");
                  // console.error('fail', error);
                }
              );
            } else {
              vm.fileData[idx].delState = 'delete';
              // if (vm.callback)
              // vm.callback.onFileDelete(vm.fileData[idx]);
            }
          }
        }
      }, {
          btn : '',
          fn : function() {
        }
      });
    }

    function onDeleteCancel(obj) {
      var idx = -1;
      angular.forEach(vm.fileData, function (val, key) {
        if (val == obj) {
          idx = key;
          return;
        }
      });

      if (idx != -1) {
        vm.fileData[idx].delState = '';
        /*			if (vm.fileData[idx].typeId == "temp") {
          			var prms = fileUploadService.attachFileDelete().get({attachId:vm.fileData[idx].fileKey}).$promise;

          			prms.then(
          	                function (data) {
          	                	console.log('success', data);
          	                },
          	                function (error) {
          	                    console.error('fail', error);
          	                }
          	            )
          			} else if (vm.callback){
          				vm.callback.onFileDelete(vm.fileData[idx]);
          			}
          			vm.fileData.splice(idx, 1);\
           */
      }
    }
    vm.openDilalog = openDilalog;
    function openDilalog() {
      angular.element('#file-5').trigger('click');
    }
  },
]);

webapp.directive('fileAttach', [
  '$compile',
  '$parse',
  function ($compile, $parse) {
    return {
      transclude: true,
      restrict: 'E',
      scope: {
        fileData: '=',
        preFilesUpload: '=',
        callback: '=',
      },
      templateUrl: 'scripts/file-attach/directive/file-attach.html',
      controller: 'FileAttachController as faCtrl',
      link: function (scope, element, attrs, ctrl) {
        var fileElement = angular.element(element[0].querySelector('input'));
        fileElement.bind('change', function () {
          ctrl.onChangeHandler(fileElement[0].files);
        });

        scope.$watchCollection('fileData', function (value) {
          ctrl.fileData = scope.fileData;
        });

        if (scope.preFilesUpload && scope.preFilesUpload.length > 0) {
          ctrl.uploadFiles(scope.preFilesUpload);
        }
        ctrl.callback = scope.callback;
        ctrl.fileElement = fileElement;

        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
        processDragOverOrEnter = function (event) {
          if (event != null) {
            event.preventDefault();
          }
          event.originalEvent.dataTransfer.effectAllowed = 'copy';
          return false;
        };
        validMimeTypes = attrs.fileDropzone;
        checkSize = function (size) {
          var _ref;
          if (
            (_ref = attrs.maxFileSize) === void 0 ||
            _ref === '' ||
            size / 1024 / 1024 < attrs.maxFileSize
          ) {
            return true;
          } else {
            alert('File must be smaller than ' + attrs.maxFileSize + ' MB');
            return false;
          }
        };
        isTypeValid = function (type) {
          if (
            validMimeTypes === void 0 ||
            validMimeTypes === '' ||
            validMimeTypes.indexOf(type) > -1
          ) {
            return true;
          } else {
            alert(
              'Invalid file type.  File must be one of following types ' +
                validMimeTypes
            );
            return false;
          }
        };
        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        return element.bind('drop', function (event) {
          var file, name, reader, size, type;
          if (event != null) {
            event.preventDefault();
          }
          reader = new FileReader();
          reader.onload = function (evt) {
            if (checkSize(size) && isTypeValid(type)) {
              return scope.$apply(function () {
                scope.file = evt.target.result;
                if (angular.isString(scope.fileName)) {
                  return (scope.fileName = name);
                }
              });
            }
          };
          file = event.dataTransfer.files[0];
          name = file.name;
          type = file.type;
          size = file.size;
          reader.readAsDataURL(file);
          return false;
        });
      },
    };
  },
]);

(function() {
  'use strict';
  angular.module('reusableThings', []).directive('fileDropzone', function() {
    return {
      restrict: 'A',
      scope: {
        file: '=',
        fileName: '='
      },
      link: function(scope, element, attrs) {
        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
        processDragOverOrEnter = function(event) {
          if (event != null) {
            event.preventDefault();
          }
          event.dataTransfer.effectAllowed = 'copy';
          return false;
        };
        validMimeTypes = attrs.fileDropzone;
        checkSize = function(size) {
          var _ref;
          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
            return true;
          } else {
            alert("File must be smaller than " + attrs.maxFileSize + " MB");
            return false;
          }
        };
        isTypeValid = function(type) {
          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
            return true;
          } else {
            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
            return false;
          }
        };
        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        return element.bind('drop', function(event) {
          var file, name, reader, size, type;
          if (event != null) {
            event.preventDefault();
          }
          reader = new FileReader();
          reader.onload = function(evt) {
            if (checkSize(size) && isTypeValid(type)) {
              return scope.$apply(function() {
                scope.file = evt.target.result;
                if (angular.isString(scope.fileName)) {
                  return scope.fileName = name;
                }
              });
            }
          };
          file = event.dataTransfer.files[0];
          name = file.name;
          type = file.type;
          size = file.size;
          reader.readAsDataURL(file);
          return false;
        });
      }
    };
  });

}).call(this);

(function() {
  'use strict';
    angular.module('reusableThings').controller('TestCtrl', function($scope) {
        $scope.image = null
        $scope.imageFileName = ''
    });

}).call(this);

webapp.factory('fileAttachDataUtil', function() {
	return {
		isLoading : function(arr) {
			if (arr) {
				var ret = false;
				angular.forEach(arr, function(value) {
					if (!value.isLoaded) {
						ret = true;
						return;
					}
				});
				return ret;
			} else {
				return ret;
			}
		},
		getTempFileKeys : function(arr) {
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.tmpFileKey){
						ret.push(value.tmpFileKey);
					}
				});
			}
			return ret;
		},
		getAttachIds: function(arr){
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.attachId){
						ret.push(value.attachId);
					}
				});
			}
			return ret;
		},
		cancel: function(scope){
			scope.$broadcast('cancelFileSend', {});
		}
	}
});

webapp.factory('fileUploadListener', fileUploadListener);
function fileUploadListener() {
	this.listener = {
			setListener: function(listener){
				this.listener = listener;
			},
			getListener: function()
			{
				return this.listener;
			}
		};
	return this.listener;
};

webapp.service('fileUploadService', [ '$rootScope', '$q', '$resource', 'StaticVariable', '$window', FileUploadService ]);

function FileUploadService($rootScope, $q, $resource, StaticVariable, $window) {
	var requests = [];
	var svc = {
    makeData : function(D) {
      if($window.sessionStorage["loginTenantId"] != "" && $window.sessionStorage["loginTenantId"] != null && $window.sessionStorage["loginTenantId"] != undefined){
        D.userkey = $rootScope.gVariable.userKey;
      }
      if ($window.sessionStorage['loginSysAdminYN'] == "Y" && !D.srchTenantId) {
        D.srchTenantId = $rootScope.gVariable.srchTenantId;
      }
      return D;
    },
		post : function(files, data, progressCb) {
			var xhr = new XMLHttpRequest();
			requests.push(xhr);
			return {
				to : function(uploadUrl) {
					var deferred = $q.defer()
					if (!files || !files.length) {
						deferred.reject("No files to upload");
						return;
          }

          // CORS 문제 발생
          // xhr.withCredentials = true;
          xhr.upload.onprogress = onProgress;
          xhr.onload = onLoad;
          xhr.upload.onerror = onError;

          var formData = new FormData();

          if (data) {
            Object.keys(data).forEach(function(key) {
              formData.append(key, data[key]);
            });
          }

          for (var idx = 0; idx < files.length; idx++) {
            formData.append(files[idx].name, files[idx]);
          }

          xhr.open("POST", uploadUrl);
          xhr.send(formData);

          function onProgress(e) {
            $rootScope.safeApply(function() {
              var percentCompleted;
              if (e.lengthComputable) {
                percentCompleted = Math.round((e.loaded / e.total) * 100);
                if (progressCb) {
                  progressCb(percentCompleted);
                } else if (deferred.notify) {
                  deferred.notify(percentCompleted);
                }
              }
            });
          }

          function onLoad(e) {
            var idx = -1;
            angular.forEach(requests, function(val, key) {
              if (val == xhr) {
                idx = key;
              }
            });
            if (idx != -1) {
              requests.splice(idx, 1);
            }
            $rootScope.safeApply(function() {

              // 2020.01.28 HJH GJ
              // 스마트에디터 주소로 전달 시 JSON 타입으로 오지않아서 예외처리
              var ret = {};
              try {
                ret = {
                  files: files,
                  data: angular.fromJson(xhr.responseText)
                };
              } catch(e) {
                ret = {
                  files: files,
                  data: xhr.responseText
                };
              }
              deferred.resolve(ret);
            });
          }

          function onError(e) {
            var msg = xhr.responseText? xhr.responseText : "An unknown error occurred posting to '" + uploadUrl + "'";
            $rootScope.safeApply(function() {
              deferred.reject(msg);
            });
          }

					return deferred.promise;
				},
				about: function(){
					if(requests){
						angular.forEach(requests, function(req){
							req.abort();
						});
					}
				}
			};
		},
		attachFileDelete : function(data, callback, callback2){
			return $resource(StaticVariable.getUrl('/attach/temp/delete.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function(success){
          callback(success);
        },
        function(error){
          callback2(error);
        });
		},
	};

	return svc;
};

(function () {
  "use strict";
  webapp.controller('BusinessDrModalCtrl',
    ['StaticVariable', '$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
      function BusinessDrModalCtrl(StaticVariable, $rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {

        var vm = this;
        vm.mdata = mdata;
        vm.setType = "save";

        //#region 소요시간
        //vm.requireTime = 60;
        vm.requireTimeChanged = function (t) {
          if (!isNullOrEmpty(vm.data.StartDate)) {
            vm.data.EndDate = moment(vm.data.StartDate).add(t, 'm');
          }
        };
        //#endregion 소요시간


        //#region 렌트카
        vm.codeRentalCarList = [];
        postApi.select({ mapCode: 'RentalCar.getRentalCarCodeList' }, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeRentalCarList = result.body.docs;
          }
        });
        //#endregion 렌트카


        //#region 업로드 파일 목록
        vm.vault = null;
        vm.uploadFileList = [];
        vm.showUploader = false;
        //#endregion 업로드 파일 목록


        //#region 첨부파일 업로드 함수
        vm.uploadFile = function () {
          if (vm.vault != null && vm.vault.data.getLength() > 0) {
            uploadVaultFile(vm.vault);
          } else {
            setData();
          }
        };
        //#endregion 첨부파일 업로드 함수


        //#region 첨부파일 Callback
        vm.onFileCallback = {
          onFileUploaded: function (id, result) {
            // 첨부파일 업로드 완료
            $scope.$apply(function () {
              angular.forEach(result.body.docs, function (item) {
                var obj = item;
                obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
                vm.uploadFileList.push(obj);
              });
            });
          },
          onFileUploadComplete: function (id) {
            // 첨부파일 업로드 이후 저장을 호출해야 함
            if (id == 'vault') {
              $timeout(setData, 1);
            }
          },
          onFileDelete: function (item) {
            var param = {
              fileId: item.id
            };

            var prms = h0102Api.attachFileDelete().post(param).$promise;
            prms.then(function (data) {
              if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            });
          },
          onLoaded: function (id, vault) {
            vm[id] = vault;
          }
        };
        //#endregion 첨부파일 Callback


        //#region 첨부파일목록
        function getFileList() {
          var uploadFileList = [];

          angular.forEach(vm.data.uploadFileList, function (item) {
            var obj = {
              id: item.fileId,
              isLoaded: true,
              link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
              fileName: item.LogicalFileNm,
              size: item.FileSize,
              fileKey: item.PhysicalFileNm,
              path: item.PhysicalPath,
              downloadCnt: item.DownloadCnt,
            };
            uploadFileList.push(obj);
          });

          angular.copy(uploadFileList, vm.uploadFileList);
        }
        //#endregion 첨부파일목록


        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "TB_BUSINESSDR",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: { mapCode: "BusinessDR.getBusinessDRDetail", param: { KeyId: mdata.KeyId, uploadFileList: [], IdName: 'KeyId' } },

            // vieType is edit
            insert: "BusinessDR.insertBusinessDRBatch",
            update: "BusinessDR.updateBusinessDRBatch"
          },

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
            RentalCarId: "vc.data.DRType == '20'",
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            ApprovalStatus: "true",
            NextStartDate: "vc.data.KeyId != '' && vc.data.NextBusinessDRId != 0",
          },

          // MataColum 외 추가 적으로 넣어야할 폼
          addForm: {
            CustNm: { after: 'ClientNm', type: mElemTx.input, colSize: 3, label: "고객" }
            // RepeatType: { after: 'ReservationEndDate', type: mElemTx.select, colSize: 2, label: "반복일정" },
            // RepeatDate: { after: 'RepeatType', type: mElemTx.date, colSize: 2, label: "반복종료일" }
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
            StartDate: "chkStartDate",
            EndDate: "chkEndDate",
            DRType: "chgDRType"
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          timeOption: {
            StartDate: { minuteStep: "vc.data.settingMin", initActiveCalendar: true },
            EndDate: { minuteStep: "vc.data.settingMin", initActiveCalendar: true },
            NextStartDate: { minuteStep: "vc.data.settingMin", initActiveCalendar: true }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            RentalCarId: "codeRentalCarList",
          },

          // 필수 항목 컬럼 
          required: ["ClientNm", "BusinessOPNm", "ManagerNm", "StartDate", "EndDate", "DRType", "DRStatus", "DRTitle"],

          autocomplete: {
            ClientNm: { keyNm: "ClientId", callback: "setClientCode", codeList: "codeClientList", addTopRow: "신규등록", addTopRowCallback: "addClient", ngChange: "onChangeClientNm" },
            CustNm: { keyNm: "CustId", callback: "setCustCode", codeList: "codeCustList", addTopRow: "신규등록", addTopRowCallback: "addCust", ngChange: "onChangeCustNm" },
            BusinessOPNm: { keyNm: "BusinessOPId", callback: "setBusinessOPCode", codeList: "codeBusinessOPList", addTopRow: "신규등록", addTopRowCallback: "addBusinessOP", ngChange: "onChangeBusinessOPNm" },
            ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", addTopRow: "신규등록", addTopRowCallback: "addManager", ngChange: "onChangeManagerNm" },
            CompanionNm: { keyNm: "UserId", callback: "setCompanionCode", codeList: "codeCompanionList", addTopRow: "신규등록", addTopRowCallback: "addCompanion", ngChange: "onChangeCompanionNm" }
          }
        };


        //#region 고객사 자동완성 목록
        vm.ACClientNm = "__undefined__";
        vm.ACClientNmTimerId = null;

        vm.onChangeClientNm = function (item) {
          if (vm.ACClientNmTimerId != null) {
            clearTimeout(vm.ACClientNmTimerId);
          }

          vm.ACClientNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACClientNm != item && !check.test(item)) {
              // 고객사리스트
              postApi.select({ mapCode: 'AutoComplete.getClientList', ClientNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.ClientNm;
                  });
                  vm.codeClientList = result.body.docs;
                }

                vm.ACClientNm = item;
              });
            }
          }, 100);
        };

        function setClientCode(data) {
          vm.data.ClientId = data.ClientId;
        }

        function addClient() {
          var ctrl = 'ClientEditModalCtrl as vc';
          var paramData = { popup: 'Y' };
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }
        //#endregion 고객사 자동완성 목록


        //#region 고객 자동완성 목록
        vm.ACCustNm = "__undefined__";
        vm.ACCustNmTimerId = null;

        vm.onChangeCustNm = function (item) {
          if (vm.ACCustNmTimerId != null) {
            clearTimeout(vm.ACCustNmTimerId);
          }

          vm.ACCustNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACCustNm != item && !check.test(item)) {
              // 고객리스트
              postApi.select({ mapCode: 'AutoComplete.getCustList', EncryptNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.EncryptNm;
                  });
                  vm.codeCustList = result.body.docs;
                }

                vm.ACCustNm = item;
              });
            }
          }, 100);
        };

        function setCustCode(data) {
          var tmpCnt = 0;

          if (data) {
            if (vm.data.CustList.length != 0) {
              for (var i in vm.data.CustList) {
                if (vm.data.CustList[i].CustId == data.CustId) {
                  tmpCnt += 1;
                  $timeout(function () {
                    vm.data.CustNm = "";
                  }, 1);

                  av.alert("중복된 고객은 선택할 수 없습니다.");
                }
              }
            }

            if (tmpCnt == 0) {
              vm.data.CustList.push({ 'CustId': data.CustId, 'CustNm': data.CodeValue });

              $timeout(function () {
                vm.data.CustNm = "";
              }, 1);
            }
          }
        }

        function addCust() {
          var ctrl = 'KSACustEditModalCtrl as vc';
          var paramData = { popup: 'Y' };
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }
        //#endregion 고객 자동완성 목록


        //#region 사업기회 자동완성 목록
        vm.ACBusinessOPNm = "__undefined__";
        vm.ACBusinessOPNmTimerId = null;

        vm.onChangeBusinessOPNm = function (item) {
          if (vm.ACBusinessOPNmTimerId != null) {
            clearTimeout(vm.ACBusinessOPNmTimerId);
          }

          vm.ACBusinessOPNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACBusinessOPNm != item && !check.test(item)) {
              // 사업기회사리스트
              postApi.select({ mapCode: 'AutoComplete.getBusinessOPList', ManagerNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.BusinessOPNm;
                  });
                  vm.codeBusinessOPList = result.body.docs;
                }

                vm.ACBusinessOPNm = item;
              });
            }
          }, 100);
        };

        function setBusinessOPCode(data) {
          vm.data.BusinessOPId = data.BusinessOPId;
          chgBusiOPId();
        }
        //#endregion 사업기회 자동완성 목록


        //#region 영업담당자 자동완성 목록
        vm.ACManagerNm = "__undefined__";
        vm.ACManagerNmTimerId = null;

        vm.onChangeManagerNm = function (item) {
          if (vm.ACManagerNmTimerId != null) {
            clearTimeout(vm.ACManagerNmTimerId);
          }

          vm.ACManagerNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACManagerNm != item && !check.test(item)) {
              // 영업담당자리스트
              postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.UserNm;
                  });
                  vm.codeManagerList = result.body.docs;
                }

                vm.ACManagerNm = item;
              });
            }
          }, 100);
        };

        function setManagerCode(data) {
          vm.data.ManagerId = data.UserId;
        }
        //#endregion 영업담당자 자동완성 목록


        //#region 동행자 자동완성 목록
        vm.ACCompanionNm = "__undefined__";
        vm.ACCompanionNmTimerId = null;

        vm.onChangeCompanionNm = function (item) {
          if (vm.ACCompanionNmTimerId != null) {
            clearTimeout(vm.ACCompanionNmTimerId);
          }

          vm.ACCompanionNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACCompanionNm != item && !check.test(item)) {
              // 동행자리스트
              postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.UserNm;
                  });
                  vm.codeCompanionList = result.body.docs;
                }

                vm.ACCompanionNm = item;
              });
            }
          }, 100);
        };

        function setCompanionCode(data) {
          var tmpCnt = 0;

          if (data) {
            if (vm.data.CompanionList.length != 0) {
              for (var i in vm.data.CompanionList) {
                if (vm.data.CompanionList[i].CompanionId == data.UserId) {
                  tmpCnt += 1;
                  $timeout(function () {
                    vm.data.CompanionNm = "";
                  }, 1);

                  av.alert("중복된 동행자는 선택할 수 없습니다.");
                }
              }
            }

            if (tmpCnt == 0) {
              vm.data.CompanionList.push({ 'CompanionId': data.UserId, 'CompanionNm': data.CodeValue });

              $timeout(function () {
                vm.data.CompanionNm = "";
              }, 1);
            }
          }
        }
        //#endregion 동행자 자동완성 목록


        function ok(newData) {
          $uibModalInstance.close(newData);
        }

        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        //#region 렌트카 중복 체크
        function getBusinessRentalCarDupYN(callback) {
          vm.BusinessRentalCarDupYN = '';
          try {
            var chkStartDate = moment.utc(vm.data.StartDate).format('YYYY-MM-DD HH:mm');
            var chkEndDate = moment.utc(vm.data.EndDate).format('YYYY-MM-DD HH:mm');
            postApi.select({ mapCode: 'RentalCar.getBusinessRentalCarDupYN', KeyId: vm.data.KeyId, RentalCarId: vm.data.RentalCarId, StartDate: chkStartDate, EndDate: chkEndDate }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.BusinessRentalCarDupYN = result.body.docs[0].BusinessRentalCarDupYN;
                callback(vm.BusinessRentalCarDupYN);
              }
            });
          }
          catch (ex) {
            vm.BusinessRentalCarDupYN = '';
          }
        }
        //#endregion 렌트카 중복 체크

        // 저장 버튼 클릭 시
        function setData() {
          if (getIsValidData()) {

            // 렌트카 중복체크
            getBusinessRentalCarDupYN(function (result) {
              vm.BusinessRentalCarDupYN = result;

              if (vm.BusinessRentalCarDupYN == 'N') {
                // 리마인드 알림설정
                if (vm.data.RemindAlarmList.length > 0) {
                  angular.forEach(vm.data.RemindAlarmList, function (element, index) {
                    element.RemindStartDate = moment(element.RemindStartDate).format("YYYY-MM-DD");
                    element.RemindEndDate = moment(element.RemindEndDate).format("YYYY-MM-DD");
                    vm.data.RemindAlarmList.splice(index, 1, element);
                  });
                }

                vm.data.tableNm = "TB_BUSINESSDR";
                vm.data.IdName = "KeyId";
                vm.data.uploadFileList = vm.uploadFileList;

                if (vm.setType == "modify") // 선택수정 클릭 시
                {
                  av.commit(function (result) {
                    var tempOkData = { KeyId: vm.edtDRId, CopyYN: 'N' };
                    ok(tempOkData);
                  });
                }

                // 저장버튼 클릭 시
                else {
                  av.confirm("Menu.SAVECONFIRM2", function () {
                    av.commit(function (result) {
                      av.alert('Menu.SAVED', function () {
                        /* 캘린더 시작 */
                        if (mdata.calendar == 'calendar') {
                          var custList = [];
                          angular.forEach(vm.data.CustList, function (item){
                            custList.push(item.CustNm);
                          });
                          var companionList = [];
                          if (!isNullOrEmpty(vm.data.CompanionList)) {
                            angular.forEach(vm.data.CompanionList, function (item){
                              companionList.push(item.CompanionNm);
                            });
                          }
                          var tempOkData = { 
                            KeyId: result.body.docs[0].KeyId,
                            StartDate: result.body.docs[0].StartDate,
                            EndDate: result.body.docs[0].EndDate,
                            ClientNm: result.body.docs[0].ClientNm,
                            DRTitle: result.body.docs[0].DRTitle,
                            ManagerNm: result.body.docs[0].ManagerNm,
                            BusinessOPNm: result.body.docs[0].BusinessOPNm,
                            DRStatus: result.body.docs[0].DRStatus,
                            CustNms: custList.join(', '),
                            CompanionNms: companionList.join(', ')
                          };
                          ok(tempOkData);
                        /* 캘린더 끝 */

                        
                        } else {
                          var tempOkData = { KeyId: result.body.docs[0].KeyId, CopyYN: 'N' };
                          ok(tempOkData);
                        }
                      });
                    });
                  }, function () {
                  });
                }
              } else if (vm.BusinessRentalCarDupYN == 'Y') {
                av.alert("- 렌트카가 업무시간에 사용중입니다.");
              } else {
                av.alert("렌트카 중복조회 중 오류가 발생했습니다. 다시 시도해주세요.");
              }
            });
          }
        }


        //#region 업무일시 변경시 소요시간변경
        function chkStartDate() {
          vm.data.EndDate = moment(vm.data.StartDate).add(vm.data.settingMin, 'm');
          vm.requireTime = moment.duration(vm.data.EndDate.diff(vm.data.StartDate)).asMinutes();
        }

        function chkEndDate() {
          vm.requireTime = moment.duration(vm.data.EndDate.diff(vm.data.StartDate)).asMinutes();
        }
        //#endregion 업무일시 변경시 소요시간변경


        //#region 사업기회 변경시 영업일지이력 호출
        function chgBusiOPId() {
          vm.BusinessOPId = vm.data.BusinessOPId;
          getBusinessOpDetail();
          getBusinessDRList();
        }
        //#endregion 사업기회 변경시 영업일지이력 호출


        //#region 활동유형 변경시 제목/내용 입력
        function chgDRType(key, data) {
          if ((mdata.CopyYN != 'Y' && isNullOrEmpty(vm.data.KeyId)) || vm.firstchgDRType == 'N') {
            vm._columnMaps['DRType'].CodeList.forEach(function (item) {
              if (item.Code == data) {
                vm.data.DRTitle = item.CodeValue;
                vm.data.DRContents = item.CodeValue;
              }
            });
          }
          vm.firstchgDRType = 'N';
        }
        //#endregion 활동유형 변경시 제목/내용 입력


        //#region 사업기회에서 고객사, 고객정보 불러오기
        function getBusinessOpDetail() {
          if (isNullOrEmpty(vm.data.KeyId) && !isNullOrEmpty(vm.BusinessOPId) && vm.BusinessOPId != '' && mdata.CopyYN != 'Y') {
            postApi.select('BusinessOP.getBusinessOPDetail', { KeyId: vm.BusinessOPId },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  // 고객사 가져오기
                  if (isNullOrEmpty(vm.data.ClientId) || isNullOrEmpty(vm.data.ClientNm)) {
                    vm.data.ClientId = result.body.docs[0].ClientId;
                    vm.data.ClientNm = result.body.docs[0].ClientNm;
                  }

                  // 고객 가져오기
                  if (vm.data.CustList.length == 0) {
                    var CustIds = [];
                    var CustNms = [];
                    if (result.body.docs[0].CustIds != null) {
                      CustIds = result.body.docs[0].CustIds.split(",");
                    }
                    if (result.body.docs[0].EncryptNms != null) {
                      CustNms = result.body.docs[0].EncryptNms.split(",");
                    }
                    angular.forEach(CustIds, function (item, key) {
                      var result = { CustId: item, CustNm: CustNms[key] };
                      vm.data.CustList.push(result);
                    });
                  }
                }
              },
              function (error) {
                vm.dataloader = false;
                console.table(error);
              });
          }
        }
        //#endregion 사업기회에서 고객사, 고객정보 불러오기


        //#region 영업일지이력리스트
        function getBusinessDRList() {
          vm.edtDRId = 0;

          if (!isNullOrEmpty(vm.BusinessOPId) && vm.BusinessOPId != '') {
            postApi.select('BusinessDR.getBusinessDRHistList', { BusinessOPId: vm.BusinessOPId }, //vm.data.BusinessOPId
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.businessDRLists = result.body.docs;
                }
              },
              function (error) {
                vm.dataloader = false;
                console.table(error);
              });
          } else {
            vm.businessDRLists = [];
          }
        }
        //#endregion 영업일지이력리스트


        //#region 영업일지이력목록 체크박스 변경시 호출함수 (체크박스 한개만 선택되도록 함)
        function chgChkBox(busiDRId) {
          if (vm.edtDRId == busiDRId) {
            $('input[type="checkbox"][id="chkDR_' + busiDRId + '"]').prop('checked', false);
            vm.edtDRId = 0;
          } else {
            $('input[type="checkbox"][id^="chkDR_"]').prop('checked', false);
            $('input[type="checkbox"][id="chkDR_' + busiDRId + '"]').prop('checked', true);
            vm.edtDRId = busiDRId;
          }
        }
        //#endregion 영업일지이력목록 체크박스 변경시 호출함수 (체크박스 한개만 선택되도록 함)


        //#region 수정할 영업 조회
        function showBusinessDRDetail() {
          if (vm.edtDRId == 0 || isNullOrEmpty(vm.edtDRId)) {
            av.alert('수정할 항목을 선택해 주세요.', function () { });
          } else {
            av.confirm("입력중이던 정보는 저장됩니다. 선택한 영업으로 이동하시겠습니까?",
              function () {
                vm.setType = "modify";
                vm.uploadFile();
              }, function () {

              });
          }
        }
        //#endregion 수정할 영업 조회


        //#region 필수항목 체크
        function getIsValidData() {
          var bRtn = true;
          var errMsg = '';

          if (isNullOrEmpty(vm.data.ClientId)) {
            errMsg = errMsg + '- 고객사를 입력하세요.<br/>';
          }
          if (vm.data.CustList.length == 0) {
            errMsg = errMsg + '- 고객을 입력하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.BusinessOPId)) {
            errMsg = errMsg + '- 사업기회를 입력하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ManagerId)) {
            errMsg = errMsg + '- 영업담당자를 입력하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.StartDate)) {
            errMsg = errMsg + '- 업무시작일시를 입력하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.EndDate)) {
            errMsg = errMsg + '- 업무종료일시를 입력하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.DRType)) {
            errMsg = errMsg + '- 활동유형을 선택하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.DRStatus)) {
            errMsg = errMsg + '- 상태를 선택하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.DRTitle)) {
            errMsg = errMsg + '- 제목을 입력하세요.<br/>';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            bRtn = false;
          }
          return bRtn;
        }
        //#endregion 필수항목 체크


        //#region 리마인드 알림설정 (맞춤설정)
        vm.addRemindAlarm = function () {
          var ctrl = 'BusinessRemindAlarmModalCtrl as vc';

          var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl);
          modalInstance.result.then(function (okData) {
            // ok버튼
            var data = angular.copy(okData);
            vm.data.RemindAlarmList.push(data);
          }, function (cancelData) {
            // cancel버튼
          });
        };

        function editItem(item) {
          var ctrl = 'BusinessRemindAlarmModalCtrl as vc';
          var paramData = angular.copy(item);
          var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            vm.data.RemindAlarmList.splice(vm.data.RemindAlarmList.indexOf(item), 1, okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }

        function deleteItem(item) {
          if (item) {
            for (var i in vm.data.RemindAlarmList) {
              if (vm.data.RemindAlarmList[i].RemindId == item.RemindId) {
                vm.data.RemindAlarmList.splice(i, 1);
              }
            }
          }
        }
        //#endregion 리마인드 알림설정 (맞춤설정)


        //#region 사업기회 수정 모달 팝업
        function goBusinessORDetail() {
          if (!isNullOrEmpty(vm.BusinessOPId) && vm.BusinessOPId != '') {
            var ctrl = 'BusinessOpModalCtrl as vc';
            var paramData = {
              KeyId: vm.BusinessOPId
            };

            var modalInstance = modalFactory.open('mf-65', 'app/business/modal/business-op/business-op-modal.html', ctrl, paramData);
            modalInstance.result.then(function (okData) {
              // ok버튼
            }, function (cancelData) {
              // cancel버튼
            });
          } else {
            av.alert("사업기회를 입력하세요.");
          }
        }
        //#endregion 사업기회 수정 모달 팝업


        //#region 영업일지 복사기능
        function copyBusinessDRDetail() {

          av.confirm("기존 내용 미 저장 시 기존 영업일지 내용이 복사됩니다.</br>복사하시겠습니까?</br>(단, 결재상태/업무일시/리마인드알림설정/첨부파일은 복사되지 않습니다.)",
            function () {
              var tempOkData = { KeyId: vm.data.KeyId, CopyYN: 'Y' };
              ok(tempOkData);
            }, function () {

            });
        }
        //#endregion 영업일지 복사기능


        //#region 고객 초기값 세팅
        function setCust() {
          var CustIds = [];
          var CustNms = [];
          if (vm.data.CustIds != null) {
            CustIds = vm.data.CustIds.split(",");
          }
          if (vm.data.EncryptNms != null) {
            CustNms = vm.data.EncryptNms.split(",");
          }
          angular.forEach(CustIds, function (item, key) {
            var result = { CustId: item, CustNm: CustNms[key] };
            vm.data.CustList.push(result);
          });
        }

        function delCust(item) {
          if (item) {
            for (var i in vm.data.CustList) {
              if (vm.data.CustList[i].CustId == item.CustId) {
                vm.data.CustList.splice(i, 1);
              }
            }
          }
        }
        //#endregion 고객 초기값 세팅


        //#region 동행자 초기값 세팅
        function setCompanion() {
          var CompanionIds = [];
          var CompanionNms = [];
          if (vm.data.CompanionIds != null) {
            CompanionIds = vm.data.CompanionIds.split(",");
          }
          if (vm.data.CompanionNms != null) {
            CompanionNms = vm.data.CompanionNms.split(",");
          }
          angular.forEach(CompanionIds, function (item, key) {
            var result = { CompanionId: item, CompanionNm: CompanionNms[key] };
            vm.data.CompanionList.push(result);
          });
        }

        function delCompanion(item) {
          if (item) {
            for (var i in vm.data.CompanionList) {
              if (vm.data.CompanionList[i].CompanionId == item.CompanionId) {
                vm.data.CompanionList.splice(i, 1);
              }
            }
          }
        }
        //#endregion 동행자 초기값 세팅

        //#region 리마인드알림 초기값 세팅
        function setRemindAlarm() {
          var RemindIds = [];
          var RemindNms = [];
          var RemindStartDates = [];
          var RemindEndDates = [];
          var RemindDoneYns = [];

          if (vm.data.RemindIds != null) {
            RemindIds = vm.data.RemindIds.split(",");
          }
          if (vm.data.RemindNms != null) {
            RemindNms = vm.data.RemindNms.split(",");
          }
          if (vm.data.RemindStartDates != null) {
            RemindStartDates = vm.data.RemindStartDates.split(",");
          }
          if (vm.data.RemindEndDates != null) {
            RemindEndDates = vm.data.RemindEndDates.split(",");
          }
          if (vm.data.RemindDoneYns != null) {
            RemindDoneYns = vm.data.RemindDoneYns.split(",");
          }
          angular.forEach(RemindIds, function (item, key) {
            var result = { RemindId: item, RemindNm: RemindNms[key], RemindStartDate: RemindStartDates[key], RemindEndDate: RemindEndDates[key], DoneYn: RemindDoneYns[key] };
            vm.data.RemindAlarmList.push(result);
          });
        }
        //#endregion 리마인드알림 초기값 세팅


        function onReadyAutoView() {
          // 시간설정 (오늘날짜, 현재시간:00분으로 설정)
          var currentHour = new Date().getHours();
          var chkDate = moment();
          var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
          tempDate.set({ h: currentHour, m: '00' });

          vm.firstchgDRType = 'Y';  // 변경이벤트를 최초에 실행 안하기 위함
          vm.data.settingMin = 60; // 소요시간 셋팅
          vm.data.CustList = [];
          vm.data.CompanionList = [];
          vm.data.RemindAlarmList = [];

          setCust(); // 고객
          setCompanion(); // 동행자
          setRemindAlarm(); // 리마인드알림


          // 키값이 있는 경우
          if (!isNullOrEmpty(vm.data.KeyId) && isNullOrEmpty(mdata.calendar)) {
            // 사업기회 값으로 영업일지이력을 호출하기 위함
            vm.BusinessOPId = vm.data.BusinessOPId;
            getBusinessDRList();

            // 복사하는 경우 키값 리셋
            if (mdata.CopyYN == 'Y') {
              vm.data.KeyId = null;
              vm.data.ApprovalStatus = "10";
              vm.data.RemindUseYN = 'N';
              vm.data.NextBusinessDRId = 0;
              vm.data.NextStartDate = '';
              vm.data.RemindAlarmList = [];
              vm.data.DRTitle = '[복사] ' + vm.data.DRTitle;

              vm.data.StartDate = tempDate;
              vm.data.EndDate = moment(vm.data.StartDate).add(vm.data.settingMin, 'm');
            }
          }
          // 신규추가
          else if (isNullOrEmpty(vm.data.KeyId) && isNullOrEmpty(mdata.calendar)) {
            vm.data.KeyId = '';
            vm.data.ApprovalStatus = "10";

            // 영업담당자 로그인 한 사람 아이디로 디폴트
            vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];
            vm.data.ManagerNm = $window.sessionStorage['loginUserName'];
            vm.data.RemindUseYN = 'N';

            vm.data.StartDate = tempDate;
            vm.data.EndDate = moment(vm.data.StartDate).add(vm.data.settingMin, 'm');
          }


		      /* 캘린더 시작 */
          if (mdata.calendar == 'calendar') {
            if (!isNullOrEmpty(vm.data.KeyId)) {
              vm.BusinessOPId = vm.data.BusinessOPId;
              getBusinessDRList();
            } else {
              if (mdata.viewType == 'month') {
                var today = moment(new Date());
                var currentHour = new Date().getHours();
                var chkDate = moment(new Date(mdata.addDate));
                var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
                vm.data.StartDate = tempDate.set({h: currentHour, m: '00'});
                vm.data.EndDate = moment(vm.data.StartDate).add(1, 'h');
                if (moment.duration(today.diff(tempDate)).asDays() > 1) {
                  vm.data.DRStatus = '30';
                } else {
                  vm.data.DRStatus = '10';
                }
                vm.data.ApprovalStatus = "10";
                // 영업담당자 로그인 한 사람 아이디로 디폴트
                vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];
                vm.data.ManagerNm = $window.sessionStorage['loginUserName'];
                vm.data.RemindUseYN = 'N';
              } else {
                var today = moment(new Date());
                var currentHour = new Date().getHours();
                var chkDate = moment(new Date(mdata.addDate));
                var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
                vm.data.StartDate = tempDate;
                vm.data.EndDate = moment(vm.data.StartDate).add(1, 'h');
                if (moment.duration(today.diff(tempDate)).asDays() > 1) {
                  vm.data.DRStatus = '30';
                } else {
                  vm.data.DRStatus = '10';
                }
                vm.data.ApprovalStatus = "10";
                // 영업담당자 로그인 한 사람 아이디로 디폴트
                vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];
                vm.data.ManagerNm = $window.sessionStorage['loginUserName'];
                vm.data.RemindUseYN = 'N';
              }
            }
          }
          /* 캘린더 끝 */

          /* 싱글뷰을 통한 영업일지 등록 시작 */
          if (mdata.BusinessOP == 'BusinessOP') {
            vm.data.BusinessOPId = mdata.BusinessOPId;
            postApi.select({ mapCode: 'AutoComplete.getBusinessOPList', BusinessOPId: vm.data.BusinessOPId }, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  vm.data.BusinessOPNm = result.body.docs[0].BusinessOPNm;
                }
              }
            });
          }
          /* 싱글뷰을 통한 영업일지 등록 끝 */


          // 소요시간 계산
          var t1 = moment(vm.data.StartDate);
          var t2 = moment(vm.data.EndDate);
          vm.requireTime = moment.duration(t2.diff(t1)).asMinutes();

          // 첨부파일 컴포넌트 초기화
          vm.showUploader = enableUploadComponent();
          initVaultComponent('vault', vm.onFileCallback);

          getFileList();

          // 고객사리스트
          postApi.select({ mapCode: 'AutoComplete.getClientList' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              angular.forEach(result.body.docs, function(item){
                item.CodeValue = item.ClientNm;
              });

              vm.codeClientList = result.body.docs;
            }
          });          
        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;

        vm.setClientCode = setClientCode;
        vm.addClient = addClient;
        vm.setCustCode = setCustCode;
        vm.addCust = addCust;
        vm.setBusinessOPCode = setBusinessOPCode;
        vm.setManagerCode = setManagerCode;
        vm.setCompanionCode = setCompanionCode;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.setData = setData;
        vm.getBusinessDRList = getBusinessDRList;
        vm.chgChkBox = chgChkBox;
        vm.showBusinessDRDetail = showBusinessDRDetail;
        vm.chkStartDate = chkStartDate;
        vm.chkEndDate = chkEndDate;
        vm.chgBusiOPId = chgBusiOPId;
        vm.chgDRType = chgDRType;
        vm.editItem = editItem;
        vm.deleteItem = deleteItem;
        vm.goBusinessORDetail = goBusinessORDetail;
        vm.copyBusinessDRDetail = copyBusinessDRDetail;
        vm.delCust = delCust;
        vm.delCompanion = delCompanion;

        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();

(function () {
  "use strict";
  webapp.controller('BusinessMeetingViewModalCtrl',
    ['StaticVariable', '$rootScope', '$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
      function BusinessMeetingViewModalCtrl(StaticVariable, $rootScope, $scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {

        var vm = this;

        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "TB_MEETINGVIEW",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            //initSelect: { mapCode: "MeetingView.getMeetingViewDetail", param: { KeyId: vm.data.KeyId }},

            // vieType is edit
            insert: "MeetingView.insertMeetingViewBatch",
            update: "MeetingView.updateMeetingViewBatch"
          },

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 필수 항목 컬럼 
          required: ["MeetViewNm"],

          // vc의 ng-if
          ngIf: {
            MeetViewNm: "!vc.data.KeyId || vc.data.ProgressYN == 'N'",
          }
        };

        function ok(newData) {
          $uibModalInstance.close(newData);
        }

        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        // 저장 버튼 클릭 시
        function setData() {
          if (getIsValidData()) {
            vm.data.businessDRViewLists = [];
            
            // 최초등록시
            if (isNullOrEmpty(vm.data.KeyId)) {
              angular.forEach(vm.businessDRViewLists, function (item) {
                var temp = { BusinessDRId: item.BusinessDRId, Sort: item.Sort };
                vm.data.businessDRViewLists.push(temp);
              });
            } 
            // 수정시
            else {
              angular.forEach(vm.businessDRViewLists, function (item) {
                var temp = { MeetViewId: item.MeetViewId, MeetViewDetId: item.MeetViewDetId, Sort: item.Sort };
                vm.data.businessDRViewLists.push(temp);
              });
            }

            av.confirm("Menu.SAVECONFIRM2", function () {
              av.commit(function (result) {
                av.alert('Menu.SAVED', function () {
                  if (isNullOrEmpty(vm.data.KeyId)) {
                    cancel();
                    $state.go("app.business.business-meeting-view-list", {reload: "app.business.business-meeting-view-list"});
                  } else {
                    ok(result.body.docs[0].KeyId);
                  }
                });
              });
            }, function () {

            });
          }
        }


        //#region 필수항목 체크
        function getIsValidData() {
          var bRtn = true;
          var errMsg = '';

          if (isNullOrEmpty(vm.data.MeetViewNm)) {
            errMsg = errMsg + '- 회의뷰명을 입력하세요.<br/>';
          }

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            bRtn = false;
          }
          return bRtn;
        }
        //#endregion 필수항목 체크


        //#region 회의뷰 조회
        function getMeetingViewDetailList() {

            postApi.select('MeetingView.getMeetingViewDetail', { KeyId: vm.data.KeyId },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.MeetViewHeader = result.body.docs[0].ProgressYN == 'Y' ? result.body.docs[0].MeetViewNm : '회의View 등록';
                  vm.data.MeetViewNm = result.body.docs[0].MeetViewNm;
                  vm.data.ProgressYN = result.body.docs[0].ProgressYN;
                  vm.businessDRViewLists = result.body.docs;

                  // 고객 클릭하기위해 변경
                  var CustIds = [];
                  var CustNms = [];
                  angular.forEach(vm.businessDRViewLists, function (item) {
                    var CustList = [];
                    if (item.CustIds != null) {
                      CustIds = item.CustIds.split(",");
                    }
                    if (item.EncryptNms != null) {
                      CustNms = item.EncryptNms.split(",");
                    }
                    angular.forEach(CustIds, function (item, key) {
                      var result = { Idx: key + 1, CustId: item, CustNm: CustNms[key] };
                      CustList.push(result);
                    });
                    item.CustList = CustList;
                  });

                  // 업무일시 형식변경
                  angular.forEach(vm.businessDRViewLists, function (item) {
                    item.StartDate = $filter('autoViewUtcToLocal')(item.StartDate).substr(0, 16);
                    item.EndDate = $filter('autoViewUtcToLocal')(item.EndDate).substr(0, 16);
                    
                    if (item.StartDate.substr(0, 10) == item.EndDate.substr(0, 10)) {
                      item.BusinessDate = item.StartDate + " ~ " + item.EndDate.substr(11, 5);
                    } else {
                      item.BusinessDate = item.StartDate + " ~ " + item.EndDate;
                    }
                  });

                  // 정렬순서
                  vm.listSort = [];

                  angular.forEach(vm.businessDRViewLists, function (item) {
                    item.Idx = item.Sort - 1;
                    vm.listSort.push(item.Sort);
                  });
                }
              },
              function (error) {
                vm.dataloader = false;
                console.table(error);
              });
        }
        //#endregion 회의뷰 조회
        

        //#region 회의뷰 미리보기
        function getBusinessDRViewList() {
          if (!isNullOrEmpty(vm.BusinessDRList) && vm.BusinessDRList != '') {
            postApi.select('MeetingView.getMeetViewBusinessDRList', { BusinessDRList: vm.BusinessDRList },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.businessDRViewLists = result.body.docs;

                  // 업무일시 형식변경
                  angular.forEach(vm.businessDRViewLists, function (item) {
                    item.StartDate = $filter('autoViewUtcToLocal')(item.StartDate).substr(0, 16);
                    item.EndDate = $filter('autoViewUtcToLocal')(item.EndDate).substr(0, 16);
                    
                    if (item.StartDate.substr(0, 10) == item.EndDate.substr(0, 10)) {
                      item.BusinessDate = item.StartDate + " ~ " + item.EndDate.substr(11, 5);
                    } else {
                      item.BusinessDate = item.StartDate + " ~ " + item.EndDate;
                    }
                  });

                  // 정렬순서
                  vm.listSort = [];

                  angular.forEach(vm.businessDRViewLists, function (item) {
                    item.Sort = item.Idx + 1;
                    vm.listSort.push(item.Sort);
                  });
                }
              },
              function (error) {
                vm.dataloader = false;
                console.table(error);
              });
          } else {
            vm.businessDRViewLists = [];
          }
        }
        //#endregion 회의뷰 미리보기


        //#region 정렬순서 변경 함수
        function changeSort(idx, chgVal) {
          var oldVal = idx + 1;

          // 변경하려는 값이 큰 경우
          if (oldVal < chgVal) {
            for (var j = idx + 1; j < chgVal; j++) {
              vm.businessDRViewLists[j].Sort = vm.businessDRViewLists[j].Sort - 1;
            }

            vm.businessDRViewLists[idx].Sort = chgVal;
          }
          // 변경하려는 값이 작은 경우
          else if (oldVal > chgVal) {
            for (var i = chgVal - 1; i < idx; i++) {
              vm.businessDRViewLists[i].Sort = vm.businessDRViewLists[i].Sort + 1;
            }

            vm.businessDRViewLists[idx].Sort = chgVal;
          }

          // 정렬 순서대로 재정렬
          vm.businessDRViewLists.sort(function (a, b) {
            return a.Sort < b.Sort ? -1 : a.Sort > b.Sort ? 1 : 0;
          });

          angular.forEach(vm.businessDRViewLists, function (item) {
            item.Idx = item.Sort - 1;
          });

          //gAlert('순서가 변경되었습니다.', function () {});
        }
        //#endregion 정렬순서 변경 함수


        //#region 영업일지 삭제 함수
        function delData(idx) {
          if (vm.businessDRViewLists.length == 1) {
            gAlert('영업일지가 한개인 경우 삭제할 수 없습니다.', function () { return; });
          } else {
            vm.listSort = [];
            vm.businessDRViewLists.splice(idx, 1);

            for (var i = 0; i < vm.businessDRViewLists.length; i++) {
              if (i >= idx) {
                vm.businessDRViewLists[i].Sort = i + 1;
              }
            }

            angular.forEach(vm.businessDRViewLists, function (item) {
              item.Idx = item.Sort - 1;
              vm.listSort.push(item.Sort);
            });
          }
        }
        //#endregion 영업일지 삭제 함수


        //#region 진행상태 변경
        function changeProgress(progressYN) {
          var data = { mapCode: 'MeetingView.updateProgressMeetingView', KeyId: vm.data.KeyId, ProgressYN: progressYN };
          postApi.update(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert('진행상태가 변경되었습니다.', function () {
                ok(vm.data.KeyId);
              });
            }
          },
            function (error) {
              console.log("error");
              // console.error('Error> updateProgressMeetingView', error);
            });
        }
        //#endregion 진행상태 변경


        //#region 클릭한 조회 페이지로 이동
        function goClientDetail(keyId) {
          $uibModalInstance.dismiss('update data');
          $state.go('app.client.client-detail', {srch: '', KeyId: keyId});
        }

        function goCustDetail(keyId) {
          $uibModalInstance.dismiss('update data');
          $state.go('app.client.ksacust-detail', {srch: '', KeyId: keyId});
        }

        function goBusinessOPDetail(keyId) {
          $uibModalInstance.dismiss('update data');
          $state.go('app.business.business-op-detail', {srch: '', KeyId: keyId});
        }
        //#region 클릭한 조회 페이지로 이동


        function onReadyAutoView() {
          vm.BusinessDRList = [];
          vm.data.KeyId = mdata.KeyId;

          // 키값이 있는 경우
          if (!isNullOrEmpty(vm.data.KeyId)) {
            getMeetingViewDetailList();
          }
          // 신규추가
          else {
            vm.MeetViewHeader = '회의View 등록';
            vm.BusinessDRList = mdata.BusinessDRList;
            getBusinessDRViewList();
          }
        }

        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.setData = setData;
        vm.getBusinessDRViewList = getBusinessDRViewList;
        vm.changeSort = changeSort;
        vm.delData = delData;
        vm.changeProgress = changeProgress;
        vm.goClientDetail = goClientDetail;
        vm.goCustDetail = goCustDetail;
        vm.goBusinessOPDetail = goBusinessOPDetail;

        var av = new autoView();
        av.init(autoViewOption);
      }]);
})();
(function () {
    "use strict";
    webapp.controller('BusinessOpCheckClientModalCtrl',
      ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm','$uibModalStack',
        function BusinessOpCheckClientModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm, $uibModalStack) {
  
          var vm = this;

          vm.ok = ok;
          vm.cancel = cancel;
          vm.goData = goData;

          vm.getList = getList;
          vm.pageChanged = pageChanged;
          vm.chgChkBox = chgChkBox;

          vm.srch = {
            viewSize : 10
          };

          vm.currentPage = 1;
          vm.maxSize = 10;

          function getList() {
            getListCnt();
            
            var data = angular.copy(vm.srch); // 검색 옵션 설정
            data.ClientId = mdata.ClientId;
            data.mapCode= 'BusinessOP.getBusinessOPList';

            postApi.select(data, function (result) {
              if(result.header.status == CONSTANT.HttpStatus.OK) {
                vm.lists = result.body.docs;
              }
            });
          }

          function getListCnt() {
            var data = angular.copy(vm.srch); // 검색 옵션 설정
    
            data.ClientId = mdata.ClientId;
            data.mapCode = 'BusinessOP.getBusinessOPListCnt';
    
            postApi.select(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
    
                if (result.body.docs.length > 0) {
                  // 총 목록 건수 설정
                  vm.totalItems = result.body.docs;
                } else {
                  // 조회 실패
                  vm.totalItems = 0;
                }
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> getListCnt()");
              // console.table(error);
            });
          }

          function pageChanged() {
            vm.srch.page = vm.currentPage;
            getList();
          }

          function chgChkBox(KeyId) {
            $('input[type="checkbox"][id^="chk_"]').prop('checked', false);
            $('input[type="checkbox"][id="chk_' + KeyId + '"]').prop('checked', true);
          }

          function ok() {
            $uibModalInstance.dismiss('update data');
          }
  
          function cancel() {
            $uibModalInstance.dismiss('update data');
          }

          function goData() {
            var data = {};
            data.KeyId = $('input:checkbox[name="chkbox"]:checked').val();
            
            if (isNullOrEmpty(data.KeyId)) {
              gAlert('', '선택된 사업기회가 없습니다.');
              return false;
            } else {
              gConfirm('', '선택된 사업기회로 이동하시겠습니까?', {
                btn : '',
                fn : function() {
                  $uibModalStack.dismissAll();
                  $state.go('app.business.business-op-detail', {
                    srch : '',
                    KeyId : data.KeyId
                  });
                }
              }, {
                btn : '',
                fn : function() {
                }
              });
            }
          }

          getList();

        }]);
  })();
  
  
(function () {
    "use strict";
    webapp.controller('BusinessOpModalCtrl',
      ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
      function BusinessOpModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {

        var vm = this;
        vm.mdata = mdata;
        $scope.events = [];

        vm.BusinessProductList = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];

        // 변경이력
        var oldParam = {};
        var newParam = {};
        
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "TB_BUSINESSOP",
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vc.data = {}
          apis: {
            insert: "BusinessOP.insertBusinessOPBatch",
            update: "BusinessOP.updateBusinessOPBatch",
            initSelect: { mapCode: "BusinessOP.getBusinessOPDetail", param:  {KeyId: mdata.KeyId} },
          },

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
          },

          // MataColum 외 추가 적으로 넣어야할 폼
          addForm: {
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
          },

          // 필수 항목 컬럼 
          // required: ["FIELD", "CustNms", "BusinessOPNms", "FIELD2", "BusiStartDate", "BusiEndDate", "DRType", "DRStatus", "DRTitle"],

          autocomplete: {
            ClientNm: { keyNm: "ClientId", callback: "setClientCode", codeList: "codeClientList", addTopRow: "신규등록", addTopRowCallback: "addClient", ngChange: "onChangeClientNm" },
            CustNm: { keyNm: "CustId", callback: "setCustCode", codeList: "codeCustList", addTopRow: "신규등록", addTopRowCallback: "addCust", ngChange: "onChangeCustNm" },
            ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", addTopRow: "", addTopRowCallback: "", ngChange: "onChangeManagerNm" },
            // ManagerNm: { keyNm: "UserId", callback: "setManagerCode", codeList: "codeManagerList", ngChange: "onChangeManagerNm" },
          }
        };

        /* START 고객사 자동완성 */
        vm.ACClientNm = "__undefined__";
        vm.ACClientNmTimerId = null;

        vm.onChangeClientNm = function(item) {
          if (vm.ACClientTimerId != null) {
            clearTimeout(vm.ACClientNmTimerId);
          }

          vm.ACClientNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACClientNm != item && !check.test(item)) {
              // 고객사리스트
              postApi.select({mapCode: 'AutoComplete.getClientList', ClientNm: item}, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function(item2){
                    item2.CodeValue = item2.ClientNm;
                  });
                  vm.codeClientList = result.body.docs;
                }

                vm.ACClientNm = item;
              });
            }
          }, 100);
        };

        function setClientCode(data) {
          getClientCheckCnt(data).then(function(item) {
            if (item[0] > 0) {
              var ctrl = 'BusinessOpCheckClientModalCtrl as vc';
              var paramData = {ClientId : data.ClientId};
              var modalInstance = modalFactory.open('mf-80', 'app/business/modal/business-op/business-op-check-client-modal.html', ctrl, paramData);
              modalInstance.result.then(function (okData) {
                // ok버튼
                var data = angular.copy(okData);
              }, function (cancelData) {
                vm.data.ClientId = data.ClientId;
                // cancel버튼
              });
            } else {
              vm.data.ClientId = data.ClientId;
            }
          });
        }

        function addClient(){
          var ctrl = 'ClientEditModalCtrl as vc';
          var paramData = {popup : 'Y'};
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/client-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
          });
        }
        /* END 고객사 자동완성 */

        function getClientCheckCnt(p) {
          return new Promise(function(resolve, reject) {
            var data = {};

            data.ClientId = p.ClientId;
            data.mapCode = 'BusinessOP.getBusinessOPListCnt';
    
            postApi.select(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  // 총 목록 건수 설정
                  vm.clientCheckCnt = result.body.docs;
                } else {
                  // 조회 실패
                  vm.clientCheckCnt = 0;
                }
                resolve(vm.clientCheckCnt);
              }
            }, function (error) {
              // 조회 중 오류 발생
              console.log("error");
              // console.error("Error> getListCnt()");
              // console.table(error);
            });
          });
        }

        /* START 고객 자동완성 */
        vm.ACCustNm = "__undefined__";
        vm.ACCustNmTimerId = null;

        vm.onChangeCustNm = function (item) {
          if (vm.ACCustNmTimerId != null) {
            clearTimeout(vm.ACCustNmTimerId);
          }

          vm.ACCustNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACCustNm != item && !check.test(item)) {
              // 고객리스트
              postApi.select({ mapCode: 'AutoComplete.getCustList', EncryptNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.EncryptNm;
                  });
                  vm.codeCustList = result.body.docs;
                }

                vm.ACCustNm = item;
              });
            }
          }, 100);
        };

        function setCustCode(data) {
          var tmpCnt = 0;

          if (data) {
            if (vm.data.CustList.length != 0) {
              for (var i in vm.data.CustList) {
                if (vm.data.CustList[i].CustId == data.CustId) {
                  tmpCnt += 1;
                  $timeout(function(){
                    vm.data.CustNm = "";
                  }, 1);
                  
                  av.alert("중복된 고객은 선택할 수 없습니다.");
                }
              }
            }
            
            if (tmpCnt == 0){
              vm.data.CustList.push({ 'CustId': data.CustId, 'CustNm': data.CodeValue });
              
              $timeout(function(){
                vm.data.CustNm = "";
              }, 1);
            }
          }
        }

        function addCust(){
          var ctrl = 'KSACustEditModalCtrl as vc';
          var paramData = {popup : 'Y'};
          var modalInstance = modalFactory.open('mf-80', 'app/client/modal/ksacust-edit-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            // var data = angular.copy(okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }

        function setCust() {
          var CustIds = [];
          var CustNms = [];
          if (vm.data.CustIds != null) {
            CustIds = vm.data.CustIds.split(",");
          }
          if (vm.data.EncryptNms != null) {
            CustNms = vm.data.EncryptNms.split(",");
          }
          angular.forEach(CustIds, function (item, key) {
            var result = {CustId: item, CustNm: CustNms[key]};
            vm.data.CustList.push(result);
          });
        }

        function delCust(item) {
          if (item) {
            for (var i in vm.data.CustList) {
              if (vm.data.CustList[i].CustId == item.CustId) {
                vm.data.CustList.splice(i, 1);
              }
            }
          }
        }
        /* END 고객 자동완성 */

        /* START 영업담당자 자동완성 */
        vm.ACManagerNm = "__undefined__";
        vm.ACManagerNmTimerId = null;

        vm.onChangeManagerNm = function (item) {
          if (vm.ACManagerNmTimerId != null) {
            clearTimeout(vm.ACManagerNmTimerId);
          }

          vm.ACManagerNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACManagerNm != item && !check.test(item)) {
              // 영업담당자사리스트
              postApi.select({ mapCode: 'AutoComplete.getUserList', UserNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.UserNm;
                  });
                  vm.codeManagerList = result.body.docs;
                }

                vm.ACManagerNm = item;
              });
            }
          }, 100);
        };

        function setManagerCode(data) {
          var tmpCnt = 0;

          if (data) {
            if (vm.data.ManagerList.length != 0) {
              for (var i in vm.data.ManagerList) {
                if (vm.data.ManagerList[i].ManagerId == data.UserId) {
                  tmpCnt += 1;
                  $timeout(function(){
                    vm.data.ManagerNm = "";
                  }, 1);
                  
                  av.alert("중복된 영업담당자는 선택할 수 없습니다.");
                }
              }
            }
            
            if (tmpCnt == 0){
              vm.data.ManagerList.push({ 'ManagerId': data.UserId, 'ManagerNm': data.CodeValue });
              
              $timeout(function(){
                vm.data.ManagerNm = "";
              }, 1);
            }
          }
        }

        function setManager() {
          var ManagerIds = [];
          var ManagerNms = [];
          if (vm.data.ManagerIds != null) {
            ManagerIds = vm.data.ManagerIds.split(",");
          }
          if (vm.data.ManagerNms != null) {
            ManagerNms = vm.data.ManagerNms.split(",");
          }
          angular.forEach(ManagerIds, function (item, key) {
            var result = {ManagerId: item, ManagerNm: ManagerNms[key]};
            vm.data.ManagerList.push(result);
          });
        }

        function delManager(item) {
          if (item) {
            for (var i in vm.data.ManagerList) {
              if (vm.data.ManagerList[i].ManagerId == item.ManagerId) {
                vm.data.ManagerList.splice(i, 1);
              }
            }
          }
        }
        /* END 영업담당자 자동완성 */

        //#region 사업 자동완성 목록
        vm.ACBusinessNm = "__undefined__";
        vm.ACBusinessNmTimerId = null;

        vm.onChangeBusinessNm = function (item) {
          if (vm.ACBusinessNmTimerId != null) {
            clearTimeout(vm.ACBusinessNmTimerId);
          }

          vm.ACBusinessNmTimerId = setTimeout(function () {
            var check = /[ㄱ-ㅎ]/;
            if (vm.ACBusinessNm != item && !check.test(item)) {
              // 사업리스트
              postApi.select({ mapCode: 'AutoComplete.getBusinessCodeList', BusinessNm: item }, function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs, function (item) {
                    item.CodeValue = item.BusinessNm;
                  });
                  vm.codeBusinessList = result.body.docs;
                }

                vm.ACBusinessNm = item;
              });
            }
          }, 100);
        };

        function setBusinessCode(data) {
          vm.BusinessProductList[data.index].BusinessId = data.BusinessId;
          vm.BusinessProductList[data.index].BusinessStartDate = data.BusinessStartDate;
          vm.BusinessProductList[data.index].BusinessEndDate = data.BusinessEndDate;
          vm.BusinessProductList[data.index].BusinessExSales = data.BusinessExSales;
        }
        //#endregion 사업 자동완성 목록

        function setRemindAlarm() {
          var RemindIds = [];
          var RemindNms = [];
          var RemindStartDates = [];
          var RemindEndDates = [];
          var RemindDoneYns = [];
  
          if (vm.data.RemindIds != null) {
            RemindIds = vm.data.RemindIds.split(",");
          }
          if (vm.data.RemindNms != null) {
            RemindNms = vm.data.RemindNms.split(",");
          }
          if (vm.data.RemindStartDates != null) {
            RemindStartDates = vm.data.RemindStartDates.split(",");
          }
          if (vm.data.RemindEndDates != null) {
            RemindEndDates = vm.data.RemindEndDates.split(",");
          }
          if (vm.data.RemindDoneYns != null) {
            RemindDoneYns = vm.data.RemindDoneYns.split(",");
          }
          angular.forEach(RemindIds, function (item, key) {
            var result = {RemindId: item, RemindNm: RemindNms[key], RemindStartDate: RemindStartDates[key], RemindEndDate: RemindEndDates[key], DoneYn: RemindDoneYns[key]};
            vm.data.RemindAlarmList.push(result);
          });
        }

        function setBusinessProduct() {
          return new Promise(function(resovle, reject) {
            vm.BusinessProductList = [];

            postApi.select({ mapCode: 'BusinessOP.getBusinessProductList', KeyId: mdata.KeyId },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                angular.forEach(result.body.docs, function(item){
                  vm.BusinessProductList.push(item);
                });
                if (vm.BusinessProductList.length == 0) {
                  vm.BusinessProductList[0] = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];
                }
              }
              resovle(setTotalSales());
            });
          });
        }

        function ok(newData) {
          $uibModalInstance.close(newData);
        }

        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        // 저장 버튼 클릭 시
        function setData() {
          if (getIsValidData()) {
            // 리마인드 알림설정
            if (vm.data.RemindAlarmList.length > 0) {
              angular.forEach(vm.data.RemindAlarmList, function (element, index) {
                element.RemindStartDate = moment(element.RemindStartDate).format("YYYY-MM-DD");
                element.RemindEndDate = moment(element.RemindEndDate).format("YYYY-MM-DD");
                vm.data.RemindAlarmList.splice(index, 1, element);
              });
            }
            
            vm.data.BusinessProductList = vm.BusinessProductList;
            if (vm.data.BusinessProductList.length > 0) {
              angular.forEach(vm.data.BusinessProductList, function (element, index) {
                element.StartDate = moment(element.BusinessStartDate).format('YYYY-MM-DD');
                element.EndDate = moment(element.BusinessEndDate).format('YYYY-MM-DD');
                if (isNullOrEmpty(element.BPId)) {
                  element.BPId = (Math.floor(Math.random() * 899999999999999 + 100000000000000)).toString(36);
                }
                vm.data.BusinessProductList.splice(index, 1, element);
              });
            }

            newParam = angular.copy(vm.data);
            
            av.confirm("Menu.SAVECONFIRM2", function(){
              av.commit(function(result){
                if(vm.data.KeyId) {
                  compareMaps(oldParam, newParam);
                }
                av.alert('Menu.SAVED', function(){
                  if (!isNullOrEmpty(mdata)) {
                    ok(result.body.docs[0]);
                  } else {
                    ok(result.body.docs[0]);
                    $state.go('app.business.business-op-list', {}, {reload: 'app.business.business-op-list'});
                  }
                });
              });
            });
          }
        }

        function getIsValidData() {
          var bRtn = true;
          var errMsg = '';

          if (isNullOrEmpty(vm.data.ClientId)) {
            errMsg = errMsg + '- 고객사를 선택해 주세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.BusinessOPNm)) {
            errMsg = errMsg + '- 사업기회명를 선택해 주세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProgressStep)) {
            errMsg = errMsg + '- 진행단계를 선택해 주세요.<br/>';
          }
          
          // 계약구분(성공)일 경우 실제종료일 필수
          if (vm.data.ContractType == '20'  && isNullOrEmpty(vm.data.RealEndDate)) {
            errMsg = errMsg + '- 실제종료일을 입력해 주세요.<br/>';
          }

          for (var i = 0; i < vm.BusinessProductList.length;  i++) {
            if (isNullOrEmpty(vm.BusinessProductList[i].BusinessId)) {
              errMsg = errMsg + '- 사업을 선택해 주세요.<br/>';
              break;
            }
            if (isNullOrEmpty(vm.BusinessProductList[i].BusinessStartDate)) {
              errMsg = errMsg + '- 사업 시작일을 확인해 주세요.<br/>';
              break;
            }
            if (isNullOrEmpty(vm.BusinessProductList[i].BusinessEndDate) || vm.BusinessProductList[i].BusinessStartDate > vm.BusinessProductList[i].BusinessEndDate) {
              errMsg = errMsg + '- 사업 종료일을 확인해 주세요.<br/>';
              break;
            }
            if (isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
              errMsg = errMsg + '- 사업 예상매출을 확인해 주세요.<br/>';
              break;
            }
          }
          
          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            bRtn =  false;
          }
  
          return bRtn;
        }

        // 변경이력 저장
        function compareMaps(oldParam, newParam) {
          var histData = {};

          var keys = Object.keys(newParam);

          var list = [];

          for (var i = 0; i < keys.length; i++) {
            if (oldParam[keys[i]] != vm.data[keys[i]]) {
              var item = {};
              if (keys[i] == 'RegDate' || keys[i] == "ExEndDate" || keys[i] == "RealEndDate" || keys[i] == "ContractStartDate" || keys[i] == "ContractEndDate") {
                var beforeDate = oldParam[keys[i]];
                beforeDate = isNullOrEmpty(beforeDate) ? '추가' : moment(beforeDate).format("YYYY-MM-DD");
                var afterDate = moment(vm.data[keys[i]].format("YYYY-MM-DD"))._i;

                item.BeforeVal = beforeDate;
                item.AfterVal = afterDate;
                item.ColNm = keys[i];

                list.push(item);
              } else if (keys[i] == 'CustList') {
                var oldIdList = [];
                var oldNameList = [];
                var newIdList = [];
                var newNameList = [];
                
                angular.forEach(oldParam[keys[i]], function (item) {
                  oldIdList.push(item.CustId);
                  oldNameList.push(item.CustNm);
                });
                angular.forEach(vm.data[keys[i]], function (item) {
                  newIdList.push(item.CustId);
                  newNameList.push(item.CustNm);
                });

                var diff1 = $(oldIdList).not(newIdList).get();
                var diff2 = $(newIdList).not(oldIdList).get();
                var sum = diff1.concat(diff2)

                if (sum.length > 0) {
                  item.BeforeVal = oldNameList.join(', ');
                  item.AfterVal = newNameList.join(', ');
                  item.ColNm = keys[i];

                  list.push(item);
                }
              } else if (keys[i] == 'ManagerList') {
                var oldIdList = [];
                var oldNameList = [];
                var newIdList = [];
                var newNameList = [];

                angular.forEach(oldParam[keys[i]], function (item) {
                  oldIdList.push(item.ManagerId);
                  oldNameList.push(item.ManagerNm);
                });
                angular.forEach(vm.data[keys[i]], function (item) {
                  newIdList.push(item.ManagerId);
                  newNameList.push(item.ManagerNm);
                });

                var diff1 = $(oldIdList).not(newIdList).get();
                var diff2 = $(newIdList).not(oldIdList).get();
                var sum = diff1.concat(diff2)

                if (sum.length > 0) {
                  item.BeforeVal = oldNameList.join(', ');
                  item.AfterVal = newNameList.join(', ');
                  item.ColNm = keys[i];

                  list.push(item);
                }
              } else if (keys[i] == 'RemindAlarmList') {
              } else if (keys[i] == 'BusinessProductList') {
              } else {
                if (keys[i] != "CustNm" || keys[i] != "ManagerNm") {
                  item.BeforeVal = isNullOrEmpty(oldParam[keys[i]]) ? '추가' : oldParam[keys[i]];
                  item.AfterVal = vm.data[keys[i]];
                  item.ColNm = keys[i];

                  list.push(item);
                }
              }
            }
          }        
          
          histData.newList = list; 
          histData.KeyId = vm.data.KeyId;
          histData.mapcode = "BusinessOP.insertBusinessOPUpdateHist";
          
          if (histData.newList.length > 0) {
            postApi.insert(histData, function(result) {
            },function(error) {
              console.table(error);
            }); 
          }
        }

        function addRow() {
          var item = {};

          item.BusinessId = vm.BusinessProductList.BusinessId;
          item.BusinessNm = vm.BusinessProductList.BusinessNm;
          item.BusinessStartDate = vm.BusinessProductList.BusinessStartDate;
          item.BusinessEndDate = vm.BusinessProductList.BusinessEndDate;
          item.BusinessExSales = vm.BusinessProductList.BusinessExSales;

          vm.BusinessProductList.push(item);
        }

        function delRow(item, p2) {
          vm.totalSales = 0;
          var number = 0;
          
          if(vm.BusinessProductList.length > 1) {
            vm.BusinessProductList.splice(p2, 1);
            for (var i in vm.BusinessProductList) {
              if (!isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
                number = parseInt(vm.BusinessProductList[i].BusinessExSales);
              }
              vm.totalSales = vm.totalSales + number;
            }
          } else {
            vm.BusinessProductList[0] = [{'BusinessId':'', 'BusinessNm': '', 'BusinessStartDate': '', 'BusinessEndDate': '', 'BusinessExSales': ''}];
          }
        }

        // 리마인드 알림설정 (맞춤설정)
        vm.addRemindAlarm = function () {
          var ctrl = 'BusinessRemindAlarmModalCtrl as vc';
  
          var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl);
          modalInstance.result.then(function (okData) {
            // ok버튼
            var data = angular.copy(okData);
            vm.data.RemindAlarmList.push(data);
          }, function (cancelData) {
            // cancel버튼
          });
        };

        function editItem(item) {
          var ctrl = 'BusinessRemindAlarmModalCtrl as vc';
          var paramData = angular.copy(item);
          var modalInstance = modalFactory.open('mf-30', 'app/business/modal/remind-alerm/business-remind-alarm-modal.html', ctrl, paramData);
          modalInstance.result.then(function (okData) {
            // ok버튼
            vm.data.RemindAlarmList.splice(vm.data.RemindAlarmList.indexOf(item), 1, okData);
          }, function (cancelData) {
            // cancel버튼
          });
        }

        function deleteItem(item) {
          if (item) {
            for (var i in vm.data.RemindAlarmList) {
              if (vm.data.RemindAlarmList[i].RemindId == item.RemindId) {
                vm.data.RemindAlarmList.splice(i, 1);
              }
            }
          }
        }

        
        function setTotalSales() {
          vm.totalSales = 0;
          var number = 0;
          
          for (var i in vm.BusinessProductList) {
            if (!isNullOrEmpty(vm.BusinessProductList[i].BusinessExSales)) {
              number = parseInt(vm.BusinessProductList[i].BusinessExSales);
            }
            vm.totalSales = vm.totalSales + number;
          }
        }


        
        function onReadyAutoView() {
          // 초기 데이터 설정
          vm.data.CustList =[];
          vm.data.ManagerList =[];
          vm.data.RemindAlarmList = [];

          // 사업정보 총금액 설정
          vm.totalSales = 0;
          
          // 고객사리스트
          postApi.select({ mapCode: 'AutoComplete.getClientList' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              angular.forEach(result.body.docs, function(item){
                item.CodeValue = item.ClientNm;
              });

              vm.codeClientList = result.body.docs;
            }
          });

          var today = new Date();

          setCust(); // 고객
          setManager(); // 영업담당자

          if (isNullOrEmpty(mdata)) {
            vm.data.RemindAlarm = 'N';
            // 진행단계 초기설정
            vm.data.ProgressStep = "10";
            // 등록일 금일로 설정
            vm.data.RegDate = moment(today);

            vm.data.ManagerId = $window.sessionStorage['loginUserIdx'];
            vm.data.ManagerNm = $window.sessionStorage['loginUserName'];
          }
          
          if (!isNullOrEmpty(mdata)) {
            // 변경이력 사용함으로 인한 초기값 저장
            oldParam = angular.copy(vm.data);
            
            if (mdata.CopyYN == 'Y') {
              vm.data.KeyId = null;
              vm.data.ProgressStep = '10';
              vm.data.ContractType = '';
              vm.data.RegDate = moment(today);
              vm.data.ExEndDate = null;
              vm.data.RealEndDate = null;
              vm.data.ContractStartDate = null;
              vm.data.ContractEndDate = null;
              vm.data.RemindAlarm = 'N';
              vm.data.RemindAlarmList = [];
              vm.data.RemindIds = [];
              vm.data.RemindNms = [];
              vm.data.BusinessOPNm = vm.data.BusinessOPNm + '[복제됨]';
            } else {
              setRemindAlarm(); // 리마인드알림
              setBusinessProduct(); // 사업정보
            }
          }
          
        }
      
        /** @description autoView init Callback**/
        vm.onReadyAutoView = onReadyAutoView;
        
        vm.setData = setData;
        vm.ok = ok;
        vm.cancel = cancel;

        vm.setClientCode = setClientCode;
        vm.addClient = addClient;
        vm.setCustCode = setCustCode;
        vm.addCust = addCust;
        vm.delCust = delCust;
        vm.setManagerCode = setManagerCode;
        vm.delManager = delManager;

        vm.setBusinessCode = setBusinessCode;
        vm.setTotalSales = setTotalSales;
        vm.addRow = addRow;
        vm.delRow = delRow;

        vm.editItem = editItem;
        vm.deleteItem = deleteItem;

        var av = new autoView();
        av.init(autoViewOption);
      }]);
  })();
  
(function () {
    "use strict";
    webapp.controller('ChgContractTypeModalCtrl',
      ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
        function ChgContractTypeModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {
  
          var vm = this;
          vm.mdata = mdata;
          $scope.events = [];

          var autoViewOption = {
            vm: vm,
            stateParams: $stateParams,
            scope: $scope,
  
            /* 공통 */
            viewType: mViewType.Edit, // List OR Edit
            tableNm: "",
            keyIdNm: "",
            alias: "vc",
            dataModelNm: "data", // ex : vc.data = {}
            apis: {
  
              /** common mapper **/
              // initSelect : 기본 데이터를 가져오는 코드 
            },
  
            /* 상세페이지 */
            // 엘리먼트 퍼블리싱 타입
            formType: mElemTx.layout.inline,
  
            // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
            addRow: [],
  
            // vc의 ng-if
            ngIf: {
              //ItemType: "!vc.data.KeyId || vc.data.Status == '10' || vc.data.Status == '20'",
            },
  
            // 비활성화 시킬 컬럼의 조건
            disabled: {
              //CustNm: "vc.data.CustNm && vc.data.KeyId",
            },
  
            // MataColum 외 추가 적으로 넣어야할 폼
            addForm: {
            },

            // 값이 변경되었을 시 콜백 처리 callback 과 유사함
            ngChange: {
            },
  
            // ngChange, Button, Date Chage 등에 사용하는 콜백
            callback: {
            },
  
            // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
            // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
            customCodes: {
              //ItemType: "codeItemType",
            },
  
            // 필수 항목 컬럼 
            required: [],
  
            autocomplete: {
            }
          };


          function setData() {
            var data = {};
            data.KeyId =  mdata.KeyId;
            data.ContractType = mdata.ContractType;
            data.ContractEndDate = moment(vm.data.ContractEndDate).format("YYYY-MM-DD");
            gConfirm('', '수정하시겠습니까?', {
              btn : '',
              fn : function() {
                  data.mapCode = "BusinessOP.updateProgressStep";
                  postApi.update(data, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      gAlert('', "수정되었습니다.", {
                        btn : '',
                        fn : function() {
                          $uibModalInstance.close();
                        }
                      });
                    }
                  });

                }
            },{
                btn : '',
                fn : function() {
              }
            }); 
          }
  
          function cancel() {
            $uibModalInstance.dismiss('update data');
          }

          function onReadyAutoView() {
            vm.data = mdata;

            var today = new Date();
            vm.data.ContractEndDate = moment(today).format('YYYY-MM-DD');
          }
        
          /** @description autoView init Callback**/
          vm.onReadyAutoView = onReadyAutoView;
          vm.setData = setData;
          vm.cancel = cancel;

          var av = new autoView();
          av.init(autoViewOption);
        }]);
  })();
  
(function () {
    "use strict";
    webapp.controller('ChgProgressStepModalCtrl',
      ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
        function ChgProgressStepModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {
  
          var vm = this;
          vm.mdata = mdata;
          $scope.events = [];

          var autoViewOption = {
            vm: vm,
            stateParams: $stateParams,
            scope: $scope,
  
            /* 공통 */
            viewType: mViewType.Edit, // List OR Edit
            tableNm: "",
            keyIdNm: "",
            alias: "vc",
            dataModelNm: "data", // ex : vc.data = {}
            apis: {
  
              /** common mapper **/
              // initSelect : 기본 데이터를 가져오는 코드 
            },
  
            /* 상세페이지 */
            // 엘리먼트 퍼블리싱 타입
            formType: mElemTx.layout.inline,
  
            // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
            addRow: [],
  
            // vc의 ng-if
            ngIf: {
              //ItemType: "!vc.data.KeyId || vc.data.Status == '10' || vc.data.Status == '20'",
            },
  
            // 비활성화 시킬 컬럼의 조건
            disabled: {
              //CustNm: "vc.data.CustNm && vc.data.KeyId",
            },
  
            // MataColum 외 추가 적으로 넣어야할 폼
            addForm: {
            },

            // 값이 변경되었을 시 콜백 처리 callback 과 유사함
            ngChange: {
            },
  
            // ngChange, Button, Date Chage 등에 사용하는 콜백
            callback: {
            },
  
            // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
            // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
            customCodes: {
              //ItemType: "codeItemType",
            },
  
            // 필수 항목 컬럼 
            required: [],
  
            autocomplete: {
            }
          };

          // 진행단계
          postApi.select({mapCode : 'CommonCode.getCommonCodeValue', CodeType : 'PROGRESS_STEP'}, 
          function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.progressStep = result.body.docs;
            }
          });

      
          function setData(param) {
            var data = {};
            data.ProgressStep =  param;
            data.KeyId = mdata;

            gConfirm('', '수정하시겠습니까?', {
              btn : '',
              fn : function() {
                  data.mapCode = "BusinessOP.updateProgressStep";
                  postApi.update(data, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      gAlert('', "수정되었습니다.", {
                        btn : '',
                        fn : function() {
                          $uibModalInstance.close();
                        }
                      });
                    }
                  });

                }
            },{
                btn : '',
                fn : function() {
              }
            }); 
          }
  
          function cancel() {
            $uibModalInstance.dismiss('update data');
          }

          function onReadyAutoView() {
            vm.data = mdata;
          }
        
          /** @description autoView init Callback**/
          vm.onReadyAutoView = onReadyAutoView;
          vm.setData = setData;
          vm.cancel = cancel;

          var av = new autoView();
          av.init(autoViewOption);
        }]);
  })();
  
(function () {
    "use strict";
    webapp.controller('BusinessRemindAlarmModalCtrl',
      ['$scope', '$stateParams', 'autoView', '$uibModalInstance', 'toModalData', 'gAlert', 'gConfirm', 'postApi', 'GLOBAL_CONSTANT',
        function BusinessRemindAlarmModalCtrl($scope, $stateParams, autoView, $uibModalInstance, mdata, gAlert, gConfirm, postApi, CONSTANT) {
  
          var vm = this;
          $scope.events = [];

          var autoViewOption = {
            vm: vm,
            stateParams: $stateParams,
            scope: $scope,
  
            /* 공통 */
            viewType: mViewType.Edit, // List OR Edit
            tableNm: "TB_REMINDALARM",
            keyIdNm: "KeyId",
            alias: "vc",
            dataModelNm: "data", // ex : vc.data = {}
            apis: {
  
              /** common mapper **/
              // initSelect : 기본 데이터를 가져오는 코드 
            },
  
            /* 상세페이지 */
            // 엘리먼트 퍼블리싱 타입
            formType: mElemTx.layout.inline,

            // MataColum 외 추가 적으로 넣어야할 폼
            addForm: {
              DoneYn : { after : 'RemindEndDate', type : mElemTx.checkbox, colSize: 1, label : "완료여부"},
            },

            // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
            // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
            customCodes: {
              //ItemType: "codeItemType",
            },
  
            // 필수 항목 컬럼 
            required: ["RemindNm", "RemindStartDate", "RemindEndDate"],
  
            autocomplete: {
            }
          };

      
          function ok() {
            gConfirm('', '설정하시겠습니까?', {
              btn : '',
              fn : function() {
                if (getIsValidData()) {
                  if (isNullOrEmpty(vm.data.RemindId)) {
                    var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                    var RemindId = newnum.toString(36);
                    vm.data.RemindId = RemindId;
                  }
                  if (vm.data.DoneYn == undefined) {
                    vm.data.DoneYn = 'N';
                  }
                  $uibModalInstance.close(vm.data);
                }
              }
            },{
                btn : '',
                fn : function() {
              }
            }); 
          }
  
          function cancel() {
            $uibModalInstance.dismiss('update data');
          }

          function getIsValidData() {
            // #region 필수항목 체크
            var errMsg = '';
            
            if (isNullOrEmpty(vm.data.RemindNm)) {
              errMsg = errMsg + '- 리마인드 명칭을 입력하세요.<br/>';
            }
            if (isNullOrEmpty(vm.data.RemindStartDate)) {
              errMsg = errMsg + '- 시작일을 확인하세요.<br/>';
            }
            if (isNullOrEmpty(vm.data.RemindEndDate)) {
              errMsg = errMsg + '- 종료일를 확인하세요.<br/>';
            }
            if (vm.data.RemindStartDate > vm.data.RemindEndDate) {
              errMsg = errMsg + '- 시작일, 종료일을 확인하세요.<br/>';
            }

            if (!isNullOrEmpty(errMsg)) {
              gAlert('', errMsg);
              return false;
            }

            return true;
            // #endregion 필수항목 체크
          }

          function onReadyAutoView() {
            vm.data = mdata;            
          }
        
          /** @description autoView init Callback**/
          vm.onReadyAutoView = onReadyAutoView;
          vm.ok = ok;
          vm.cancel = cancel;

          var av = new autoView();
          av.init(autoViewOption);
        }]);
  })();
  
(function () {
    "use strict";
    webapp.controller('CustCounselModalCtrl',
      ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$timeout', '$filter', '$window', 'modalFactory', '$state', 'gSelect', 'gConfirm',
        function CustCounselModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $timeout, $filter, $window, modalFactory, $state, gSelect, gConfirm) {
  
          var vm = this;
          var resources = [];
          var row = {};
          vm.mdata = mdata;
	        vm.custInfo = {Manager: $window.sessionStorage['loginUserIdx']};
          //var updateMapCode = "";
          $scope.events = [];
          vm.simpleSignDisabled = true;
          // CustCodes 정의
          // vm.codeOpenType = [
          //   {Code : '10', CodeValue : '상담'},
          //   {Code : '20', CodeValue : '예약'}
          // ];

          vm.codeRepeatList = [
            {Code : '10', CodeValue : '반복 안함'},
            {Code : '20', CodeValue : '매일반복'},
            {Code : '30', CodeValue : '매주선택요일반복'},
            {Code : '40', CodeValue : '격주선택요일반복'}
          ];

          vm.codeRepeatMap = {'10':'반복 안함', '20':'매일반복', '30':'매주선택요일반복', '40':'격주선택요일반복'};

          vm.takenTime = 30;
          vm.takenTimeChanged = function(t) {
            vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(t, 'm');
          };

          vm.getRepeatTypeName = function () {
            angular.forEach(vm.codeRepeatList, function(item) {
              if (item.Code == vm.data.RepeatType) {
                return item.CodeValue;
              }
            });
          };
  
          // 담당자
          postApi.select({ mapCode: 'ScUser.getUserListCodes' },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.codeManager = result.body.docs;
              }
            });
  
          // 당당부서
          postApi.select({ mapCode: 'organizationMng.getOrganizationCodes', Depth: '3' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.codeDepts = result.body.docs;
                var row = {};
                angular.forEach(vm.codeDepts, function (item){
                  row = {};
                  row.id = item.Code;
                  row.title = item.CodeValue;
  
                  resources.push(row);
                });
              }
            });
  
          // 상담상태 
          postApi.select({ mapCode: 'ScCustomerReserve.getReserveStatusCode' },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.codeStatus = result.body.docs;
              }
            });

          var autoViewOption = {
            vm: vm,
            stateParams: $stateParams,
            scope: $scope,
  
            /* 공통 */
            viewType: mViewType.Edit, // List OR Edit
            tableNm: "screserve",
            keyIdNm: "KeyId",
            alias: "vc",
            dataModelNm: "data", // ex : vc.data = {}
            apis: {
  
              /** common mapper **/
              // initSelect : 기본 데이터를 가져오는 코드 
              initSelect: { mapCode: "ScCustomerReserve.getSccustReserveDetail", param: { KeyId: mdata.KeyId, ReserveViewType: mdata.ReserveViewType, VisitId: mdata.VisitId, SurgicalId: mdata.SurgicalId } },
  
              // vieType is edit
              insert: "ScCustomerReserve.insertSccustReserve",
              //update: updateMapCode, -- 하단에서 정의
  
            },
  
            /* 상세페이지 */
            // 엘리먼트 퍼블리싱 타입
            formType: mElemTx.layout.inline,
  
            // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
            addRow: [],
  
            // vc의 ng-if
            ngIf: {
              ItemType: "!vc.data.KeyId || vc.data.Status == '10' || vc.data.Status == '20'",
              Status: "!vc.data.ReserveStatus",
              ReserveStatus: "vc.data.ReserveStatus",
              ReservationStartDate: "vc.data.Status == '10' || vc.data.Status == '20'",
              ReservationEndDate: "vc.data.Status == '10' || vc.data.Status == '20'",
              VisitDeptId: "vc.data.Status == '10'",
              VisitManager: "vc.data.Status == '10'",
              SurgicalDeptId: "vc.data.Status == '20'",
              SurgicalManager: "vc.data.Status == '20'",
              RepeatDate: "vc.data.RepeatType == '20' || vc.data.RepeatType == '30' || vc.data.RepeatType == '40'"
            },
  
            // 비활성화 시킬 컬럼의 조건
            disabled: {
              CustNm: "vc.data.CustNm && vc.data.KeyId",
              Mobile: "vc.data.CustId",
              CounselManager: "vc.data.KeyId",
              Remark: "vc.data.KeyId && vc.data.Status != '10' && vc.data.Status != '20'",
              ReservationStartDate: "vc.mdata.ReserveViewType == 'V' && vc.mdata.ReserveType == '10'",
              ReservationEndDate: "vc.mdata.ReserveViewType == 'V' && vc.mdata.ReserveType == '10'",
              ItemType: "!vc.data.CustNm"
            },
  
            // MataColum 외 추가 적으로 넣어야할 폼
            addForm: {
              //CustList: { before : 'CustNm', type : mElemTx.select, colSize: 1, label : ""}
              // RepeatType: { after: 'ReservationEndDate', type: mElemTx.select, colSize: 2, label: "반복일정" },
              // RepeatDate: { after: 'RepeatType', type: mElemTx.date, colSize: 2, label: "반복종료일" }
            },
  
            // 값이 변경되었을 시 콜백 처리 callback 과 유사함
            ngChange: {
              Status: "chgStatus",
              ReservationStartDate: "chkStartDate",
              ReservationEndDate: "chkEndDate"
              // RepeatType: "selectRepeat",
            },
  
            // ngChange, Button, Date Chage 등에 사용하는 콜백
            callback: {
  
            },
  
            timeOption: {
              ReservationStartDate: {
                minuteStep: "vc.data.settingMin", initActiveCalendar: true, minHour: "vc.data.workStartHour", maxHour: "vc.data.workEndHour"
              },
              ReservationEndDate: {
                minuteStep: "vc.data.settingMin", initActiveCalendar: false, minHour: "vc.data.workStartHour", maxHour: "vc.data.workEndHour"
              }
            },
  
            // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
            //noLable : ["OpenType"],
  
            // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
            // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
            customCodes: {
              //ItemType: "codeItemType",
              VisitDeptId: "codeDepts",
              SurgicalDeptId: "codeDepts",
              Status: "codeStatus",
              ReserveStatus: "codeReserveStatus",
              CounselManager: "codeManager",
              VisitManager: "codeManager",
              SurgicalManager: "codeManager",
              RepeatType: "codeRepeatList"
            },
  
            // 필수 항목 컬럼 
            required: ["CustNm", "Mobile", "CounselManager", "Status", "ReserveStatus", "ReservationStartDate", "ReservationEndDate", "VisitDeptId", "VisitManager", "SurgicalDeptId", "SurgicalManager"],
  
            autocomplete: {
              CustNm: { keyNm: "CustId", callback: "changeCustCode", codeList: "codeCustList", format: "{CustNm}{Mobile:auto-hyphen-tel-bind}", addTopRow: "간편등록", addTopRowCallback: "addCustomer", ngChange: "onChangeCustNm" },
              ItemType: { keyNm: "Code", callback: "setItemType", codeList: "codeItemType" }
            }
          };

          vm.ACCustNm = "__undefined__";
          vm.ACCustNmTimerId = null;

          vm.onChangeCustNm = function(item) {
            if (vm.ACCustNmTimerId != null) {
              clearTimeout(vm.ACCustNmTimerId);
            }

            vm.ACCustNmTimerId = setTimeout(function () {
              var check = /[ㄱ-ㅎ]/;
              if (vm.ACCustNm != item && !check.test(item)) {
                // 고객리스트
                postApi.select({mapCode: 'ScCustomer.getCustomerCodeList', CustNm: item}, function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs, function(item){
                      item.CodeValue = item.CustNm;
                    });
                    vm.codeCustList = result.body.docs;
                  }

                  vm.ACCustNm = item;
                });
              }
            }, 1000);
          };
          
          function addCustomer(){
            setChangeTab("tab3");
            vm.custInfo.CustNm = vm.data.CustNm;
          }
  
          function changeCustCode(data) {
            vm.data.CustId = data.Code;
            // vm.data.CustNm = data.CustNm;
            vm.data.Mobile = data.Mobile;
            chgStatus();
          }
  
          function ok(newData) {
            $uibModalInstance.close(newData);
          }
  
          function cancel() {
            $uibModalInstance.dismiss('update data');
          }

          function fnOpenRepeat(width) {
            var srchBg = $("<div />", { class: "repeat-bg-wrap", onClick: "fnCloseRepeat()" });
            // var srchBg = $("<div />", { class: "list-srch-bg-wrap" });
            var position = $(".sch_repeat_pop").css('position');

            var pos = position == 'absolute' ? $(".search_layer").position() : $(".search_layer").offset();
            var h = $(".search_layer").height();

            setTimeout(function () {
              // $(".sch_repeat_pop").css("left", (pos.left) - 10);
              // $(".sch_repeat_pop").css("top", (pos.top) + 31);
              if (width) {
                $(".sch_repeat_pop").css("width", width);
              }

              if ($(".sch_repeat_pop").is(":visible")) {
                $(".sch_repeat_pop").hide();
                $(".repeat-bg-wrap").detach();
              } else {
                $(".sch_repeat_pop").show();
                $("body").append(srchBg.clone());
              }
            }, 1);

            return false;
          }

          function fnCloseRepeat() {
            $(".sch_repeat_pop").hide();
            $(".repeat-bg-wrap").detach();

            if (vm.data.RepeatType  != '10') {
              $("#repeatBtn").attr('class', 'btn sch_repeat rp_on');
            } else {
              $("#repeatBtn").attr('class', 'btn sch_repeat');
            }

            return false;
          }

          // 상태값 선택에따른 상단 타이틀 변경 / 유형변경
          function chgStatus() {
            var type = "C";
            if (vm.data.Status == '10') {
              vm.TitleNm = '방문예약';
              vm.data.Remark = "";
            } else if (vm.data.Status == '20') {
              vm.TitleNm = '시술예약';
              vm.data.Remark = "";
              type = "I";
              if(isNullOrEmpty(vm.data.KeyId)){
                vm.data.ItemTypes =[]; // 시술인경우 초기화
              }
            } else {
              vm.TitleNm = '상담';
              vm.data.Remark = vm.tmpRemark;
              if(!isNullOrEmpty(vm.data.KeyId)){
                vm.data.ItemTypes = angular.copy(vm.data.TempItemTypes);
              }
            }
  
            // 유형(상품)코드
            postApi.select({mapCode : 'ScItemType.getScitemtypeCodesByCustId', ItemType : type, CustId: vm.data.CustId}, 
            function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.codeItemType = result.body.docs;
              }
            });
          }
  
          // 예약구분에따른 상태값가져오기
          function getStatusCode() {
            if (vm.data.Status == '10') {
              vm.StatusMapCode = 'ScCustomerReserve.getVisitStatusCode';
            } else if (vm.data.Status == '20') {
              vm.StatusMapCode = 'ScCustomerReserve.getSurgicalStatusCode';
            }
  
            postApi.select({ mapCode: vm.StatusMapCode },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.codeReserveStatus = result.body.docs;
                }
              });
          }
  
          // 유형선택시 하단에 보여주는 함수
          function setItemType(data) {
            var tmpCnt = 0;
            if (data) {
              if (vm.data.ItemTypes.length != 0) {
                for (var i in vm.data.ItemTypes) {
                  if (vm.data.ItemTypes[i].ItemTypeId == data.Code) {
                    tmpCnt += 1;
                    //vm.act_ItemTypeFocus = 'N';
                    vm.data.ItemType = "";
                    $timeout(function(){
                      //angular.element(".ItemType-col-wrap .form-group > input").focus();
                      //vm.act_ItemTypeFocus = 'Y';
                    }, 300);
                    av.alert("중복된 유형은 선택할 수 없습니다.");
                  }
                }
              }
              
              if (tmpCnt == 0){
                vm.data.ItemTypes.push({ 'ItemTypeId': data.Code, 'ItemTypeNm': data.CodeValue });
                vm.data.ItemType = "";
                $timeout(function(){
                  //angular.element(".ItemType-col-wrap .form-group > input").focus();
                  //vm.act_ItemTypeFocus = 'Y';
                }, 300);
              }
            }
          }
  
          // 고객키값이 있는 경우
          function setCustInfo(mCustId) {
            postApi.select({ mapCode: 'ScCustomer.getCustomerCodeList', CustId: mCustId },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.data.CustId = result.body.docs[0].Code;
                  vm.data.CustNm = result.body.docs[0].CustNm;
                  vm.data.Mobile = result.body.docs[0].Mobile;
                }
              });
          }
  
          function setItem() {
            var ItemTypeIds = [];
            var ItemTypeNms = [];
            if (vm.data.ItemTypeIds != null) {
              ItemTypeIds = vm.data.ItemTypeIds.split(",");
            }
            if (vm.data.ItemTypeNms != null) {
              ItemTypeNms = vm.data.ItemTypeNms.split(",");
            }
            angular.forEach(ItemTypeIds, function (item, key) {
              var result = {ItemTypeId: item, ItemTypeNm: ItemTypeNms[key]};
              vm.data.ItemTypes.push(result);
            });
  
            // 상담예약에서 상태를 변경후 다시 상태값이 바뀔 경우 기존 값을 보여주기 위함
            if(!isNullOrEmpty(vm.data.KeyId)){
              vm.data.TempItemTypes = angular.copy(vm.data.ItemTypes);
            }
          }
  
          function deleteItem(item) {
            if (item) {
              for (var i in vm.data.ItemTypes) {
                if (vm.data.ItemTypes[i].ItemTypeId == item.ItemTypeId) {
                  vm.data.ItemTypes.splice(i, 1);
                }
              }
            }
          }
  
          // 지점별 영업시간, 점심시간 체크
          function getGroupTimeList() {
            postApi.select( {mapCode: 'organizationMng.getGroupTimeList'},
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    if (result.body.docs[0] == null) {
                      vm.data.workStart = '06:00';
                      vm.data.workStartHour = '06';
                      vm.data.workEnd = '24:00';
                      vm.data.workEndHour = '24';
                      vm.data.lunchStart = '12:00';
                      vm.data.lunchEnd = '13:00';
                      vm.data.settingMin = '30';
                    } else {
                      if (result.body.docs[0].WorkStart == null || result.body.docs[0].WorkStart == '') {
                        vm.data.workStart = '06:00';
                        vm.data.workStartHour = '06';
                      } else {
                        vm.data.workStart = result.body.docs[0].WorkStart;
                        vm.data.workStartHour = vm.data.workStart.substring(0,2);
                      }
                      if (result.body.docs[0].WorkEnd == null || result.body.docs[0].WorkEnd == '') {
                        vm.data.workEnd = '24:00';
                        vm.data.workEndHour = '24';
                      } else {
                        vm.data.workEnd = result.body.docs[0].WorkEnd;
                        vm.data.workEndHour = vm.data.workEnd.substring(0,2);
                      }
                      if (result.body.docs[0].LunchStart == null || result.body.docs[0].LunchStart == '') {
                        vm.data.lunchStart = '12:00';
                      } else {
                        vm.data.lunchStart = result.body.docs[0].LunchStart;
                      }
                      if (result.body.docs[0].LunchEnd == null || result.body.docs[0].LunchEnd == '') {
                        vm.data.lunchEnd = '13:00';
                      } else {
                        vm.data.lunchEnd = result.body.docs[0].LunchEnd;
                      }
                      if (result.body.docs[0].SettingMin == null || result.body.docs[0].SettingMin == '') {
                        vm.data.settingMin = '30';
                      } else {
                        vm.data.settingMin = result.body.docs[0].SettingMin;
                      }
                    }
                  }
                }
              },
              function (error) {
                console.log("error");
                // console.error("Error> getGroupTimeList()", status, error);
              }
            );
          }

          // 저장 버튼 클릭 시
          function setData(clickType) {
            if (getIsValidData()) {
              if (vm.data.Status == '10' || vm.data.Status == '20') {
                vm.data.ReserveType = vm.data.Status;
                //vm.data.VisitManager = vm.data.CounselManager;
              }
              
              var OldReservationStartDate = vm.data.ReservationStartDate;
              var ReservationStartDate = null;
              var ReservationEndDate = null;
              var tmpStartDate = null;
              var tmpEndDate = null;

              // 반복일정 일 경우 (추가)
              if ((vm.data.RepeatType == 20 || vm.data.RepeatType == 30 || vm.data.RepeatType == 40) && mdata.addYn == true) {
                var data = angular.copy(vm.data); // 사용자 입력 데이터

                // RepeatId
                var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                var RepeatId = newnum.toString(36);              
                vm.data.RepeatId = RepeatId;

                vm.data.timeList = [];      
                ReservationStartDate = data.ReservationStartDate;
                ReservationEndDate = data.ReservationEndDate;
                vm.data.RepeatDate = moment(vm.data.RepeatDate).format("YYYY-MM-DD") ; // 반복종료일
                vm.data.RepeatStartDate = moment(vm.data.ReservationStartDate).format("YYYY-MM-DD") ; // 반복시작일
                var BaseDate = moment(data.ReservationStartDate).add(1, 'weeks');
                
                var RepeatDate = moment(data.RepeatDate).add(moment(vm.data.ReservationStartDate).hours(), 'h').add(moment(vm.data.ReservationStartDate).minutes(), 'm');

                var j = 0;
                
                do {
                  if (vm.data.RepeatType == 40 && moment(ReservationStartDate) >= BaseDate) {
                    ReservationStartDate = moment(ReservationStartDate).add(7, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(7, 'days');

                    BaseDate = moment(BaseDate).add(2, 'weeks');

                    j += 7;
                  } else {
                    var item = {};
                    var day = moment(ReservationStartDate).day();
  
                    if ((day == 0 && vm.data.RepeatSun == 'Y') || (day == 1 && vm.data.RepeatMon == 'Y') || (day == 2 && vm.data.RepeatTue == 'Y') || (day == 3 && vm.data.RepeatWed == 'Y') || (day == 4 && vm.data.RepeatThu == 'Y') || (day == 5 && vm.data.RepeatFri == 'Y') || (day == 6 && vm.data.RepeatSat == 'Y')) {
                      tmpStartDate = moment(ReservationStartDate).toDate();
                      tmpEndDate = moment(ReservationEndDate).toDate();
                      item.ReservationStartDate = $filter('localToUtc')(tmpStartDate);
                      item.ReservationEndDate = $filter('localToUtc')(tmpEndDate);
  
                      // RepeatCustCounselId, RepeatNewVisitId
                      var newnum1 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var newnum2 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var RepeatId1 = newnum1.toString(36);
                      var RepeatId2 = newnum2.toString(36);              
                      item.RepeatCustCounselId = RepeatId1;
                      item.RepeatNewVisitId = RepeatId2;
  
                      vm.data.timeList.push(item);
                    }
  
                    ReservationStartDate = moment(ReservationStartDate).add(1, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(1, 'days');
                    j++;
                  }                  
                // } while (!moment(vm.data.RepeatDate).isBefore(ReservationStartDate) && j <= 365);
                } while (!moment(RepeatDate).isBefore(ReservationStartDate) && j <= 365);
              }

              // 반복일정 일 경우 (수정)
              if ((vm.data.KeyId != undefined && vm.data.RepeatId != undefined && clickType == 'save' && mdata.calendar == 'calendar') || (vm.data.KeyId != undefined && vm.data.RepeatId == undefined && clickType == 'save' && mdata.calendar == 'calendar' && (vm.data.RepeatType == 20 || vm.data.RepeatType == 30 || vm.data.RepeatType == 40))) {
                if (moment(vm.OldReservationStartDate).format('YYYY-MM-DD') < moment(vm.data.ReservationStartDate).format('YYYY-MM-DD')) {
                  var options = [{label:'이 일정만', value:0}, {label:'이 일정 및 향후 일정', value:1}];  
                } else {
                  var options = [{label:'이 일정만', value:0}, {label:'이 일정 및 향후 일정', value:1}, {label:'모든 일정', value:2}];
                }

                if (vm.data.RepeatId != undefined) {
                  gSelect('', '반복 일정 수정', {
                    btn: '',
                    fn: function (mode) {
                      setUpdateDataAction(mode);
                    }
                  }, {
                    btn: '',
                    fn: function () {
                      // 취소
                    }
                  }, options, 0);
                } else {
                  setUpdateDataAction(4); // (일반)일정 > 반복일정으로 수정할 경우 == mode 4번
                }
              } else {
                // 예약상태에 따라 업데이트 방식이 다름
                if (vm.data.Status == '10') {
                  autoViewOption.apis.update = "ScCustomerReserve.updateScVisitReserve";
                } else if (vm.data.Status == '20') {
                  autoViewOption.apis.update = "ScCustomerReserve.updateScSurgicalReserve";
                } else {
                  autoViewOption.apis.update = "ScCustomerReserve.updateScCounselReserve";
                }

                // 그냥 저장 & 방문->시술로 저장할 경우
                if (vm.data.chgStatusSaveYN != 'Y') {
                  av.commit(function (result) {
                    // 캘린더를 통해서 저장하였을 경우
                    if (!isNullOrEmpty(mdata.calendar)) {
                      result.body.docs[0].CalItemList = [];
                      angular.forEach(vm.codeDepts, function (item){
                        if (item.Code == result.body.docs[0].VisitDeptId || item.Code == result.body.docs[0].SurgicalDeptId) {
                          result.body.docs[0].CalDeptId = item.Code;
                          result.body.docs[0].CalDeptNm = item.CodeValue;
                        }
                      });
                      angular.forEach(vm.codeManager, function (item){
                        if (item.Code == result.body.docs[0].VisitManager || item.Code == result.body.docs[0].SurgicalManager) {
                          result.body.docs[0].CalManager = item.CodeValue;
                        }
                      });
                      angular.forEach(result.body.docs[0].ItemTypes, function (item){
                        result.body.docs[0].CalItem = item.ItemTypeNm;
                        result.body.docs[0].CalItemList.push(result.body.docs[0].CalItem);
                      });
                      angular.forEach(vm.codeCustList, function (item){
                        if (item.Code == result.body.docs[0].CustId) {
                          result.body.docs[0].CalSpcNote = item.SpcNote;
                        }
                      });
                      
                      if(!isNullOrEmpty(result.body.docs[0].NewVisitId)) {
                        result.body.docs[0].CalVisitId = result.body.docs[0].ReserveType == '10' ? result.body.docs[0].NewVisitId : 0;
                        result.body.docs[0].CalSurgicalId = result.body.docs[0].ReserveType == '20' ? result.body.docs[0].NewVisitId : 0;
                      }

                      vm.data.res = vm.data.res == 'A' ? 'A' : 'E';
                    }
                    
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      if(vm.data.Status == '10' || vm.data.Status == '20'){
                        vm.data.Remark = "";
                      }

                      if (clickType == 'move'){
                        getMemoList();
                      } else if (clickType == 'pay') { 
                        // 결제 버튼 클릭시
                        var ctrl = 'CustPaymentModalCtrl as vc';
                        var paramData = {
                          CustId: vm.data.CustId,
                          KeyId: '',
                          ReserveType: vm.data.ReserveType,
                          ReserveId: vm.data.ReserveType == 10 ? vm.data.VisitId : vm.data.SurgicalId
                        };
                        var modalInstance = modalFactory.open('lg', 'app/customer/modal/custPayment/custPayment-modal.html', ctrl, paramData);
                      } else {
                        av.alert("저장되었습니다.", function(){
                          ok(result.body.docs[0]);
                        });
                      }
                    }
                  });
                } 
                // 시술->방문으로 저장할 경우
                else {
                  av.confirm("결제한 내역이 있을 경우 전체 환불 처리되며, 시술 예약건은 삭제됩니다.<br />방문 예약으로 변경하시겠습니까?", 
                  function(){
                    av.commit(function (result) {
                      // 캘린더를 통해서 저장하였을 경우
                      if (!isNullOrEmpty(mdata.calendar)) {
                        result.body.docs[0].CalItemList = [];
                        angular.forEach(vm.codeDepts, function (item){
                          if (item.Code == result.body.docs[0].VisitDeptId || item.Code == result.body.docs[0].SurgicalDeptId) {
                            result.body.docs[0].CalDeptId = item.Code;
                            result.body.docs[0].CalDeptNm = item.CodeValue;
                          }
                        });
                        angular.forEach(vm.codeManager, function (item){
                          if (item.Code == result.body.docs[0].VisitManager || item.Code == result.body.docs[0].SurgicalManager) {
                            result.body.docs[0].CalManager = item.CodeValue;
                          }
                        });
                        angular.forEach(result.body.docs[0].ItemTypes, function (item){
                          result.body.docs[0].CalItem = item.ItemTypeNm;
                          result.body.docs[0].CalItemList.push(result.body.docs[0].CalItem);
                        });
                        angular.forEach(vm.codeCustList, function (item){
                          if (item.Code == result.body.docs[0].CustId) {
                            result.body.docs[0].CalSpcNote = item.SpcNote;
                          }
                        });
                        
                        if(!isNullOrEmpty(result.body.docs[0].NewVisitId)) {
                          result.body.docs[0].CalVisitId = result.body.docs[0].ReserveType == '10' ? result.body.docs[0].NewVisitId : 0;
                          result.body.docs[0].CalSurgicalId = result.body.docs[0].ReserveType == '20' ? result.body.docs[0].NewVisitId : 0;
                        }
                      }

                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        if(vm.data.Status == '10' || vm.data.Status == '20'){
                          vm.data.Remark = "";
                        }
                        av.alert("저장되었습니다.", function(){
                          ok(result.body.docs[0]);
                        });
                      }
                    });
                  },function(){

                  });
                }
              }
            }
          }

          function setUpdateDataAction(mode) {
            vm.data.OldRepeatId = vm.data.RepeatId;
            vm.data.mode = mode;
    
            if (mode == 1 || mode == 2 || mode == 4) {
              var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              var RepeatId = newnum.toString(36);              
              vm.data.RepeatId = RepeatId;

              if (mode == 1) {
                vm.data.timeList = [];      
                var ReservationStartDate = vm.data.ReservationStartDate;
                var ReservationEndDate = vm.data.ReservationEndDate;
                vm.data.RepeatDate = moment(vm.data.RepeatDate).format("YYYY-MM-DD") ; // 반복종료일
                vm.data.RepeatStartDate = moment(vm.data.ReservationStartDate).format("YYYY-MM-DD"); // 반복시작일
                var BaseDate = moment(vm.data.ReservationStartDate).add(1, 'weeks');

                var RepeatDate = moment(vm.data.RepeatDate).add(moment(vm.data.ReservationStartDate).hours(), 'h').add(moment(vm.data.ReservationStartDate).minutes(), 'm');
                
                var j = 0;
                
                do {
                  if (vm.data.RepeatType == 40 && moment(ReservationStartDate) >= BaseDate) {
                    ReservationStartDate = moment(ReservationStartDate).add(7, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(7, 'days');

                    BaseDate = moment(BaseDate).add(2, 'weeks');

                    j += 7;
                  } else {
                    var item = {};
                    var day = moment(ReservationStartDate).day();
                    if ((day == 0 && vm.data.RepeatSun == 'Y') || (day == 1 && vm.data.RepeatMon == 'Y') || (day == 2 && vm.data.RepeatTue == 'Y') || (day == 3 && vm.data.RepeatWed == 'Y') || (day == 4 && vm.data.RepeatThu == 'Y') || (day == 5 && vm.data.RepeatFri == 'Y') || (day == 6 && vm.data.RepeatSat == 'Y')) {
                      var tmpStartDate = moment(ReservationStartDate).toDate();
                      var tmpEndDate = moment(ReservationEndDate).toDate();
                      item.ReservationStartDate = $filter('localToUtc')(tmpStartDate);
                      item.ReservationEndDate = $filter('localToUtc')(tmpEndDate);

                      // RepeatCustCounselId, RepeatNewVisitId
                      var newnum1 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var newnum2 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var RepeatId1 = newnum1.toString(36);
                      var RepeatId2 = newnum2.toString(36);              
                      item.RepeatCustCounselId = RepeatId1;
                      item.RepeatNewVisitId = RepeatId2;

                      vm.data.timeList.push(item);
                    }

                    ReservationStartDate = moment(ReservationStartDate).add(1, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(1, 'days');

                    j++;
                  }                  
                } while (!moment(RepeatDate).isBefore(ReservationStartDate) && j < 365);
              } else if (mode == 2) {
                vm.data.timeList = [];      
                var ReservationStartDate = moment(vm.data.RepeatStartDate).add(moment(vm.data.ReservationStartDate).hours(), 'h').add(moment(vm.data.ReservationStartDate).minutes(), 'm');
                var ReservationEndDate = moment(vm.data.RepeatStartDate).add(moment(vm.data.ReservationEndDate).hours(), 'h').add(moment(vm.data.ReservationEndDate).minutes(), 'm');
                vm.data.RepeatDate = moment(vm.data.RepeatDate).format("YYYY-MM-DD") ; // 반복종료일
                vm.data.RepeatStartDate = moment(vm.data.RepeatStartDate).format("YYYY-MM-DD"); // 반복시작일
                var BaseDate = moment(vm.data.RepeatStartDate).add(1, 'weeks');
                
                var RepeatDate = moment(vm.data.RepeatDate).add(moment(vm.data.ReservationStartDate).hours(), 'h').add(moment(vm.data.ReservationStartDate).minutes(), 'm');

                var j = 0;
                
                do {
                  if (vm.data.RepeatType == 40 && moment(ReservationStartDate) >= BaseDate) {
                    ReservationStartDate = moment(ReservationStartDate).add(7, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(7, 'days');

                    BaseDate = moment(BaseDate).add(2, 'weeks');

                    j += 7;
                  } else {
                    var item = {};
                    var day = moment(ReservationStartDate).day();
                    if ((day == 0 && vm.data.RepeatSun == 'Y') || (day == 1 && vm.data.RepeatMon == 'Y') || (day == 2 && vm.data.RepeatTue == 'Y') || (day == 3 && vm.data.RepeatWed == 'Y') || (day == 4 && vm.data.RepeatThu == 'Y') || (day == 5 && vm.data.RepeatFri == 'Y') || (day == 6 && vm.data.RepeatSat == 'Y')) {
                      var tmpStartDate = moment(ReservationStartDate).toDate();
                      var tmpEndDate = moment(ReservationEndDate).toDate();
                      item.ReservationStartDate = $filter('localToUtc')(tmpStartDate);
                      item.ReservationEndDate = $filter('localToUtc')(tmpEndDate);

                      // RepeatCustCounselId, RepeatNewVisitId
                      var newnum1 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var newnum2 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var RepeatId1 = newnum1.toString(36);
                      var RepeatId2 = newnum2.toString(36);              
                      item.RepeatCustCounselId = RepeatId1;
                      item.RepeatNewVisitId = RepeatId2;

                      vm.data.timeList.push(item);
                    }

                    ReservationStartDate = moment(ReservationStartDate).add(1, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(1, 'days');

                    j++;
                  }                  
                } while (!moment(RepeatDate).isBefore(ReservationStartDate) && j < 365);
              } else if (mode == 4) {
                vm.data.timeList = [];      
                var ReservationStartDate = vm.data.ReservationStartDate;
                var ReservationEndDate = vm.data.ReservationEndDate;
                vm.data.RepeatDate = moment(vm.data.RepeatDate).format("YYYY-MM-DD") ; // 반복종료일
                vm.data.RepeatStartDate = moment(vm.data.ReservationStartDate).format("YYYY-MM-DD"); // 반복시작일
                var BaseDate = moment(vm.data.ReservationStartDate).add(1, 'weeks');

                var RepeatDate = moment(vm.data.RepeatDate).add(moment(vm.data.ReservationStartDate).hours(), 'h').add(moment(vm.data.ReservationStartDate).minutes(), 'm');
                
                var j = 0;
                
                do {
                  if (vm.data.RepeatType == 40 && moment(ReservationStartDate) >= BaseDate) {
                    ReservationStartDate = moment(ReservationStartDate).add(7, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(7, 'days');

                    BaseDate = moment(BaseDate).add(2, 'weeks');

                    j += 7;
                  } else {
                    var item = {};
                    var day = moment(ReservationStartDate).day();
                    if ((day == 0 && vm.data.RepeatSun == 'Y') || (day == 1 && vm.data.RepeatMon == 'Y') || (day == 2 && vm.data.RepeatTue == 'Y') || (day == 3 && vm.data.RepeatWed == 'Y') || (day == 4 && vm.data.RepeatThu == 'Y') || (day == 5 && vm.data.RepeatFri == 'Y') || (day == 6 && vm.data.RepeatSat == 'Y')) {
                      var tmpStartDate = moment(ReservationStartDate).toDate();
                      var tmpEndDate = moment(ReservationEndDate).toDate();
                      item.ReservationStartDate = $filter('localToUtc')(tmpStartDate);
                      item.ReservationEndDate = $filter('localToUtc')(tmpEndDate);

                      // RepeatCustCounselId, RepeatNewVisitId
                      var newnum1 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var newnum2 = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      var RepeatId1 = newnum1.toString(36);
                      var RepeatId2 = newnum2.toString(36);              
                      item.RepeatCustCounselId = RepeatId1;
                      item.RepeatNewVisitId = RepeatId2;

                      vm.data.timeList.push(item);
                    }

                    ReservationStartDate = moment(ReservationStartDate).add(1, 'days');
                    ReservationEndDate = moment(ReservationEndDate).add(1, 'days');

                    j++;
                  }                  
                } while (!moment(RepeatDate).isBefore(ReservationStartDate) && j < 365);
              }

              vm.data.mapCode = "ScCustomerReserve.insertSccustReserve";
              postApi.insert(vm.data, function(result) {
                gAlert('', 'Menu.SAVED', {
                  btn: '',
                  fn: function () {
                    if (!isNullOrEmpty(mdata.calendar)) {
                      result.body.docs[0].CalItemList = [];
                      angular.forEach(vm.codeDepts, function (item){
                        if (item.Code == result.body.docs[0].VisitDeptId || item.Code == result.body.docs[0].SurgicalDeptId) {
                          result.body.docs[0].CalDeptId = item.Code;
                          result.body.docs[0].CalDeptNm = item.CodeValue;
                        }
                      });
                      angular.forEach(vm.codeManager, function (item){
                        if (item.Code == result.body.docs[0].VisitManager || item.Code == result.body.docs[0].SurgicalManager) {
                          result.body.docs[0].CalManager = item.CodeValue;
                        }
                      });
                      angular.forEach(result.body.docs[0].ItemTypes, function (item){
                        result.body.docs[0].CalItem = item.ItemTypeNm;
                        result.body.docs[0].CalItemList.push(result.body.docs[0].CalItem);
                      });
                      angular.forEach(vm.codeCustList, function (item){
                        if (item.Code == result.body.docs[0].CustId) {
                          result.body.docs[0].CalSpcNote = item.SpcNote;
                        }
                      });
                      
                      if(!isNullOrEmpty(result.body.docs[0].NewVisitId)) {
                        result.body.docs[0].CalVisitId = result.body.docs[0].ReserveType == '10' ? result.body.docs[0].NewVisitId : 0;
                        result.body.docs[0].CalSurgicalId = result.body.docs[0].ReserveType == '20' ? result.body.docs[0].NewVisitId : 0;
                      }
    
                      vm.data.res = vm.data.res == 'A' ? 'A' : 'E';
                    }
                    ok(result.body.docs[0]);
                  }
                });
              }, function (error) {
                console.log("error");
                // console.error("Error> setCalMemo()");
                // console.table(error);
              });
            } else if (mode == 0) {
              // 예약상태에 따라 업데이트 방식이 다름
              if (vm.data.Status == '10') {
                autoViewOption.apis.update = "ScCustomerReserve.updateScVisitReserve";
              } else if (vm.data.Status == '20') {
                autoViewOption.apis.update = "ScCustomerReserve.updateScSurgicalReserve";
              } else {
                autoViewOption.apis.update = "ScCustomerReserve.updateScCounselReserve";
              }

              if (vm.data.chgStatusSaveYN != 'Y') {
                av.commit(function (result) {
                  // 캘린더를 통해서 저장하였을 경우
                  if (!isNullOrEmpty(mdata.calendar)) {
                    result.body.docs[0].CalItemList = [];
                    angular.forEach(vm.codeDepts, function (item){
                      if (item.Code == result.body.docs[0].VisitDeptId || item.Code == result.body.docs[0].SurgicalDeptId) {
                        result.body.docs[0].CalDeptId = item.Code;
                        result.body.docs[0].CalDeptNm = item.CodeValue;
                      }
                    });
                    angular.forEach(vm.codeManager, function (item){
                      if (item.Code == result.body.docs[0].VisitManager || item.Code == result.body.docs[0].SurgicalManager) {
                        result.body.docs[0].CalManager = item.CodeValue;
                      }
                    });
                    angular.forEach(result.body.docs[0].ItemTypes, function (item){
                      result.body.docs[0].CalItem = item.ItemTypeNm;
                      result.body.docs[0].CalItemList.push(result.body.docs[0].CalItem);
                    });
                    angular.forEach(vm.codeCustList, function (item){
                      if (item.Code == result.body.docs[0].CustId) {
                        result.body.docs[0].CalSpcNote = item.SpcNote;
                      }
                    });
                    
                    if(!isNullOrEmpty(result.body.docs[0].NewVisitId)) {
                      result.body.docs[0].CalVisitId = result.body.docs[0].ReserveType == '10' ? result.body.docs[0].NewVisitId : 0;
                      result.body.docs[0].CalSurgicalId = result.body.docs[0].ReserveType == '20' ? result.body.docs[0].NewVisitId : 0;
                    }

                    vm.data.res = vm.data.res == 'A' ? 'A' : 'E';
                  }
                  
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    if(vm.data.Status == '10' || vm.data.Status == '20'){
                      vm.data.Remark = "";
                    }

                    av.alert("저장되었습니다.", function(){
                      ok(result.body.docs[0]);
                    });
                  }
                });
              } 
            }
          }

          function setDelDataAction(mode) {
            vm.data.ReserveType = vm.data.Status;
            vm.data.OldRepeatId = vm.data.RepeatId;
            vm.data.mode = mode;
            vm.data.res = 'D';
            vm.data.mapCode = 'ScCustomerReserve.deleteSccustReserveBatch';

            postApi.update(vm.data, function (result) {
              if (result.header.status == CONSTANT.HttpStatus.OK || result.header.status != CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.DELETED', {
                  btn: '',
                  fn: function () {
                    // 삭제 성공
                    ok(result.body.docs[0]);
                  }
                });
  
              }
            }, function (error) {
              // 삭제 중 오류 발생
              console.log("error");
              // console.error("Error> setDelDataAction()");
              // console.table(error);
            });
          }
  
          // 메모리스트 
          function getMemoList() {
            postApi.select({ mapCode: 'ScCustomerReserve.getSccustReservememoList', CustId: mdata.CustId },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.memoLists = result.body.docs;
              }
            });
          }
          
          // 메모추가
          function saveMemo() {
            if (vm.data.Remark == "") {
              av.alert("메모를 입력해주세요.");
              return false;
            } else {
              vm.memoData = {};
              vm.memoData.mapCode = 'ScCustomerReserve.insertScReserveMemo';
              vm.memoData.ReserveType = vm.data.Status;
              vm.memoData.ReserveStatus = vm.data.OldReserveStatus;
              vm.memoData.CustId = vm.data.CustId;
              if (vm.data.Status == "10") { vm.memoData.ReserveId = vm.data.VisitId; }
              else if (vm.data.Status == "20") { vm.memoData.ReserveId = vm.data.SurgicalId; }
              vm.memoData.Remark = vm.data.Remark;
  
              postApi.insert(vm.memoData,
                function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    getMemoList();
                  setChangeTab("tab1");
                    vm.data.Remark = "";
                  }
                });
            }
          }
  
          // 하단예약 버튼 클릭시
          function clickBtn(statusVal) {
            // (시술->방문)
            if (statusVal == "10") {

              vm.data.Status = statusVal;
              chgStatus();
              getStatusCode();
              vm.data.ReserveStatus = "10";

              // 스케줄에서 결제버튼 분기
              if (mdata.calendar == 'calendar') {
                mdata.addYn = 'Y';
              }
              
              // 초기화
              vm.data.ItemTypes =[];
              
              // 시간설정 (오늘날짜, 현재시간:00분으로 설정)
              var currentHour = new Date().getHours();
              // var chkDate = moment(new Date());
              var chkDate = moment(vm.data.ReservationStartDate);
              var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
              tempDate.set({h: currentHour, m: '00'});
              vm.data.ReservationStartDate = tempDate;
              vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(vm.data.settingMin, 'm');
              // vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(30, 'm');
              // vm.data.ReservationStartDate = "";
              // vm.data.ReservationEndDate = "";
              vm.data.VisitDeptId = "";
              vm.data.VisitManager = "";
              vm.data.SurgicalDeptId = "";
              vm.data.SurgicalManager = "";

              vm.data.chgStatusSaveYN = 'Y';
              vm.data.chgStatusMemoYN = 'Y';
              vm.data.mDataVisitId = 0; // 버튼을 숨기기위한 처리
            }
            // (방문->시술) 
            else if(statusVal == "20") {
              av.confirm("입력중이던 정보는 저장되며 상담완료로 변경됩니다.<br />시술예약으로 변경하시겠습니까?", 
              function(){
                setData('move');

                vm.data.Status = statusVal;
                chgStatus();
                getStatusCode();
                vm.data.ReserveStatus = "10";

                // 스케줄에서 결제버튼 분기
                if (mdata.calendar == 'calendar') {
                  mdata.addYn = 'Y';
                }
                
                // 초기화
                vm.data.ItemTypes =[];

                // 시간설정 (오늘날짜, 현재시간:00분으로 설정)
                var currentHour = new Date().getHours();
                // var chkDate = moment(new Date());
                var chkDate = moment(vm.data.ReservationStartDate);
                var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
                tempDate.set({h: currentHour, m: '00'});
                vm.data.ReservationStartDate = tempDate;
                vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(vm.data.settingMin, 'm');
                // vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(30, 'm');
                // vm.data.ReservationStartDate = "";
                // vm.data.ReservationEndDate = "";
                vm.data.VisitDeptId = "";
                vm.data.VisitManager = "";
                vm.data.SurgicalDeptId = "";
                vm.data.SurgicalManager = "";

                vm.data.chgStatusMemoYN = 'Y';

                vm.data.res = 'A'; // 캘린더에서 이벤트를 추가적으로 1개를 더 보이기 위해서 사용

              },function(){

              });
            }
            // (결제)
            else if(statusVal == "30") {
              if(mdata.ReserveViewType == "V"){
                // 결제 버튼 클릭시
                var ctrl = 'CustPaymentModalCtrl as vc';
                var paramData = {
                  CustId: mdata.CustId,
                  KeyId: '',
                  ReserveType: mdata.ReserveType,
                  ReserveId: mdata.ReserveType == 10 ? mdata.VisitId : mdata.SurgicalId
                };
                var modalInstance = modalFactory.open('lg', 'app/customer/modal/custPayment/custPayment-modal.html', ctrl, paramData);
              } else {
                av.confirm("입력중이던 정보는 저장됩니다. 결제하시겠습니까?", 
                function(){
                  setData('pay');
                },function(){

                });
              }
            }
          }
  
          // 탭
          vm.tabId = 'tab1';
          function setChangeTab (_id) {
            vm.tabId = _id;
            $('.tab-pane.active').addClass('fade').removeClass('active');
            $('#modal-' + vm.tabId).removeClass('fade').addClass('active');
            if(_id == 'tab2') {
              setCalendar();
            }
          }
  
          // 캘린더
          function setCalendar() {
            /* config object */
            $scope.uiConfig = {
              calendar:{
                header:{
                  left: 'today',
                  center: 'prev, title, next',
                  right: ''
                },
                views:{
                },
                titleFormat: "YYYY-MM-DD dddd",
                // initalView: 'dayGridMonth',
                schedulerLicenseKey: '0663320046-fcs-1605662091',
                //  googleCalendarApiKey : 'AIzaSyDvpTo79J0vvggfeNHMZcREpJqWnFyytls',
                locale: 'ko',
                timezone: 'local',
                editable: false,
                defaultDate: moment(mdata.addDate).format("YYYY-MM-DD"),
                defaultView: 'agendaDay', // agendaDay, agendaWeek, month           
                themeSystem:'bootstrap3',
                timeFormat: 'HH:mm',
                weekends: true,
                nowIndicator: false,
                displayEventTime: false,
                displayEventEnd: false,
                allDaySlot: false,
                minTime: vm.data.workStart,
                maxTime: vm.data.workEnd,
                height: "auto",
                width: "auto",
                resources: resources,
                businessHours: [
                  {  // AM
                    dow: [0, 1, 2, 3, 4, 5, 6],
                    start: vm.data.workStart,
                    end: vm.data.lunchStart
                  },
                  {  // PM
                    dow: [0, 1, 2, 3, 4, 5, 6],
                    start: vm.data.lunchEnd,
                    end: vm.data.workEnd
                  }
                ],
                viewRender: function(view, element) {
                  getData(view);
                },
                eventDrop: $scope.alertOnDrop,
                //  eventSources: [{
                //    googleCalendarId: 'ko.south_korea#holiday@group.v.calendar.google.com',
                //    className: 'gcal-event', color: "rgb(247,250,252)", textColor: "#FF2F2F", cursor: 'default', editable: false
                //  }],
                eventResize: $scope.alertOnResize,
                eventRender: function (event, element, view) {
                  element.popover({
                    content: $('<div />', {
                        class: 'popoverInfoCalendar'
                      }).append('<p><strong>고객명:</strong> ' + event.custNm + '</p>')
                      .append('<p><strong>연락처:</strong> ' + event.mobile + '</p>')
                      .append('<p><strong>담당자:</strong> ' + event.manager + '</p>')
                      .append(event.deptNm == undefined ? '' : '<p><strong>담당부서:</strong> ' + event.deptNm + '</p>')
                      .append(event.itemType == undefined ? '' : '<p><strong>유형:</strong> ' + event.itemType + '</p>')
                      .append(event.remark == undefined ? '' : '<p><strong>메모:</strong> ' + event.remark + '</p>')
                      .append(event.spcNote == undefined ? '' : '<p><strong>특이사항:</strong> ' + event.spcNote + '</p>'),
                    delay: {
                      show: "800",
                      hide: "50"
                    },
                    trigger: 'hover',
                    placement: 'left',
                    html: true,
                    container: 'body'
                  });
                },
                dayClick: function(date, jsEvent, view, resourceObj) {
                  dayClick(date, resourceObj);
                },
                eventClick: function (calEvent) {
                //  eventClick(calEvent);
                },
              }
      
            };
          }
   
          // 예약조회
          function getData(view) {
            vm.lists = [];
            $scope.events.splice(0);
  
            var start = moment(view.start).format('YYYY-MM-DD');
            var end = moment(view.end).format('YYYY-MM-DD');
            
            vm.srch = {};
            vm.srch.startDate = $filter('localToUtc')(start,'from');
            vm.srch.endDate = $filter('localToUtc')(end,'to');
            var data = angular.copy(vm.srch);
            data.mapCode = 'ScCustomerReserve.getModalScheduleList';
  
            postApi.select(data, function (result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  // 조회 데이터 설정
                  vm.lists = result.body.docs;
                  angular.forEach(vm.lists, function(item){
                    row = {};
                    row.id = item.KeyId;
                    row.start = moment.utc(item.StartDate);
                    row.end = moment.utc(item.EndDate);
                    row.title = !isNullOrEmpty(item.ItemType) ? item.CustNm + ' [' + item.ItemType+ ']' : item.CustNm;
                    row.custNm = item.CustNm;
                    row.mobile = item.Mobile;
                    row.manager = item.Manager;
                    row.deptId = item.DeptId;
                    row.deptNm = item.DeptNm;
                    row.itemType = item.ItemType;
                    row.remark = item.Remark;
                    row.spcNote = item.SpcNote;
                    switch (item.Status) {
                      case '10':
                        row.color = '#ffe16b';
                        row.textColor = '#666666';
                      break;
                      case '20':
                        row.color = '#ff6384';
                      break;
                      case '30':
                        row.color = '#55dd9f';
                        row.textColor = '#666666';
                      break;
                      case '40':
                        row.color = '#749ef8';
                      break;
                      case '50':
                        row.color = '#e5e5e5';
                        row.textColor = '#666666';
                      break;
                    }
                    row.custId = item.CustId;
                    row.visitId = item.VisitId;
                    row.surgicalId = item.SurgicalId;
                    row.reserveViewType = item.ReserveViewType;
                    row.resourceId = item.DeptId;
  
                    row.dow = '';
                    $scope.events.push(row);  
                  });
                }
              } else {
                console.log("error");
                // console.error("Error> getData()");
  
                if (!isNullOrEmpty(result.body.docs)) {
                  gAlert('', result.body.docs[0].errMessage);
                }
              }
  
            }, function (error) {
              console.log("error");
              // console.error("Error> getData()");
              // console.table(error);
            });
          }
  
          function dayClick(date, resourceObj) {
            if (mdata.ReserveViewType != 'V') {
              vm.data.TimeChange = 'Y';

              vm.data.ReservationStartDate = date;
              vm.data.ReservationEndDate = moment(date).add(vm.data.settingMin, 'm');
              vm.takenTime = moment.duration(vm.data.ReservationEndDate.diff(vm.data.ReservationStartDate)).asMinutes();
              // vm.data.ReservationEndDate = moment(date).add(30, 'm');
  
              if (vm.data.Status == '10') {
                vm.data.VisitDeptId = resourceObj.id;
              } else if (vm.data.Status == '20') {
                vm.data.SurgicalDeptId = resourceObj.id;
              }
              
              if (mdata.option == "10") {
                vm.data.VisitDeptId = resourceObj.id;
              } else if (mdata.option == "20") {
                vm.data.SurgicalDeptId = resourceObj.id;
              }
  
            }
          }
  
          function chkStartDate() {
            vm.data.TimeChange = 'Y';

            vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(vm.data.settingMin, 'm');
            // vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(30, 'm');
            vm.takenTime = moment.duration(vm.data.ReservationEndDate.diff(vm.data.ReservationStartDate)).asMinutes();
  
            $('#modalCalendar').fullCalendar( 'gotoDate', vm.data.ReservationStartDate );
          }

          function chkEndDate() {
            vm.data.TimeChange = 'Y';

            vm.takenTime = moment.duration(vm.data.ReservationEndDate.diff(vm.data.ReservationStartDate)).asMinutes();
  
            // $('#modalCalendar').fullCalendar( 'gotoDate', vm.data.ReservationStartDate );
          }
          
          function setCheckSimpleSign() {

            // if(!isNullOrEmpty(vm.custInfo.CustNm) && !isNullOrEmpty(vm.custInfo.Mobile)) {
            
            //   var p = angular.copy(vm.custInfo);
            //   p.findUser = "Y";
            //   p.mapCode = "ScCustomer.getCustomerDetail";
            //   postApi.select(p, function(result){
            //     if(result.body.docs.length > 0) {
            //       if(result.body.docs[0].CheckCustBranch == "Y") {
            //         av.alert("이미 등록된 고객이 있습니다.", function(){
            //           setCustInfo(result.body.docs[0].KeyId);
            //           setChangeTab("tab1");
            //         });
            //       }
            //     }
            //   });
            // }

            if(!isNullOrEmpty(vm.custInfo.CustNm) && !isNullOrEmpty(vm.custInfo.Mobile) && !isNullOrEmpty(vm.custInfo.Manager)) {
              vm.simpleSignDisabled = false;
            }
          }

          function saveCustomer(){

            var p = angular.copy(vm.custInfo);
            p.findUser = "Y";
            p.mapCode = "ScCustomer.getCustomerDetail";
            postApi.select(p, function(result){
              if(result.body.docs.length > 0) {
                if(result.body.docs[0].CheckCustBranch == "Y") {
                  av.alert("이미 등록된 고객이 있습니다.", function(){
                    setCustInfo(result.body.docs[0].KeyId);
                    setChangeTab("tab1");
                  });
                }
              } else {
                vm.custInfo.mapcode = "ScCustomer.insertCustomer";
                postApi.insert(vm.custInfo, function(result) {
                  vm.dataloader = false;
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    setCustInfo(result.body.docs[0].RelateDataId);
                    setChangeTab("tab1");
                  }
                }, function(error) {
                  console.table(error);
                  vm.dataloader = false;
                });
              }
            });
          }
  
          function getIsValidData() {
            var bRtn = true;
            var errMsg = '';

            if (isNullOrEmpty(vm.data.CustId)) {
              errMsg = errMsg + '- 고객이 없습니다. 간편등록 후 저장해 주세요.<br/>';
            }
            if (vm.data.ItemTypes.length == 0) {
              errMsg = errMsg + '- 유형이 없습니다. 유형등록 후 저장해 주세요.<br/>';
            }
            if (isNullOrEmpty(vm.data.VisitManager)) {
              errMsg = errMsg + '- 방문상담자를 선택해 주세요.<br/>';
            }

            if (vm.data.Status == '10' || vm.data.Status == '20') {
              // #region 필수항목 체크
              if (isNullOrEmpty(vm.data.ReservationStartDate)) {
                errMsg = errMsg + '- 예약시작일시를 확인하세요.<br/>';
              }
              if (isNullOrEmpty(vm.data.ReservationEndDate)) {
                errMsg = errMsg + '- 예약종료일시를 확인하세요.<br/>';
              }
              if (vm.data.ReservationStartDate >= vm.data.ReservationEndDate) {
                errMsg = errMsg + '- 예약일시를 확인하세요.<br/>';
              }
              if (vm.data.ReservationStartDate.format('HH:mm') < vm.data.workStart) {
                errMsg = errMsg + '- 업무시작시간를 확인하세요.<br/>';
              }
              if (vm.data.ReservationEndDate.format('HH:mm') > vm.data.workEnd) {
                errMsg = errMsg + '- 업무종료시간를 확인하세요.<br/>';
              }
              if (vm.data.RepeatType != 10 && !isNullOrEmpty(vm.data.RepeatType)) {
                if ((moment(vm.data.ReservationStartDate).format('YYYY-MM-DD') > moment(vm.data.RepeatDate).format('YYYY-MM-DD')) || ((vm.data.RepeatType == 20 || vm.data.RepeatType == 30 || vm.data.RepeatType == 40) && vm.data.RepeatDate == undefined)) {
                  errMsg = errMsg + '- 반복종료일을 확인하세요.<br/>';
                }
              }
              if ((vm.data.RepeatType == 30 || vm.data.RepeatType == 40) && vm.data.RepeatMon == false && vm.data.RepeatTue == false && vm.data.RepeatWed == false && vm.data.RepeatThu == false && vm.data.RepeatFri && false && vm.data.RepeatSat == false && vm.data.RepeatSun == false) {
                errMsg = errMsg + '- 반복요일을 확인하세요.<br/>';
              }
        
              if (!isNullOrEmpty(errMsg)) {
                gAlert('', errMsg);
                bRtn =  false;
              }
            }
            return bRtn;
          }
          
          function goCustomerDetail() {
            $uibModalInstance.close();
            $state.go('app.customer.customer-detail', { KeyId: vm.data.CustId });
          }

          function selectRepeat() {
            if (vm.data.RepeatType == '20') {
              vm.data.RepeatSun = 'Y';
              vm.data.RepeatMon = 'Y';
              vm.data.RepeatTue = 'Y';
              vm.data.RepeatWed = 'Y';
              vm.data.RepeatThu = 'Y';
              vm.data.RepeatFri = 'Y';
              vm.data.RepeatSat = 'Y';
            } else {
              vm.data.RepeatSun = 'N';
              vm.data.RepeatMon = 'N';
              vm.data.RepeatTue = 'N';
              vm.data.RepeatWed = 'N';
              vm.data.RepeatThu = 'N';
              vm.data.RepeatFri = 'N';
              vm.data.RepeatSat = 'N';
            }
          }

          function setRepeat() {}
  
          function delData() {
            if (vm.data.KeyId != undefined && vm.data.RepeatId != undefined) {
              var options = [{label:'이 일정만', value:0}, {label:'이 일정 및 향후 일정', value:1}, {label:'모든 일정', value:2}];

              gSelect('', '반복 일정 삭제', {
                btn: '',
                fn: function (mode) {
                  gConfirm("", "삭제한 내역은 복구 불가능합니다. 삭제하시겠습니까?",{
                    btn : '',
                    fn : function() {
                      setDelDataAction(mode);
                    }
                  }, {
                    btn : '',
                    fn : function() {
                    
                    }
                  });
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              }, options, 0);
            } else {
              gConfirm("", "삭제한 내역은 복구 불가능합니다. 삭제하시겠습니까?",{
                btn : '',
                fn : function() {
                  setDelDataAction(0);
                }
              }, {
                btn : '',
                fn : function() {
                
                }
              });
            }
          }

          function onReadyAutoView() {
            // Key값이 있을 때만 소요시간 계산하기
            if (!isNullOrEmpty(vm.data.KeyId)) {
              var t1 = moment(vm.data.ReservationStartDate);
              var t2 = moment(vm.data.ReservationEndDate);
              vm.takenTime = moment.duration(t2.diff(t1)).asMinutes();
            } else {
              // 고객리스트
              postApi.select({ mapCode: 'ScCustomer.getCustomerCodeList' },
                function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs, function(item){
                      item.CodeValue = item.CustNm;
                    });
                    vm.codeCustList = result.body.docs;
                  }
                });
            }
            $(".ItemType-col-wrap > .form-group label").html('<span style="color:red">* </span>유형');
            // 초기 설정
            vm.data.ItemTypes = [];  // 유형 선택된 값
            vm.tmpRemark = angular.copy(vm.data.Remark);
            
            // 세션아이디에 따른 전화상담자 default처리 
            vm.sessionCodeManager = $window.sessionStorage['loginUserIdx'];
            vm.data.CounselManager = isNullOrEmpty(vm.data.CounselManager) ? vm.sessionCodeManager: vm.data.CounselManager;
            
            vm.OldReservationStartDate = vm.data.ReservationStartDate;

            // 스케줄에서 상태를 클릭하고 들어온 경우
            if (!isNullOrEmpty(mdata.option) && mdata.calendar == 'calendar') {
              vm.data.Status = mdata.option;
              vm.data.ReserveStatus = '10';
              vm.data.RepeatType = '10'; // 반복 안함 (초기설정)
  
              // 시간 설정 
              if (mdata.viewType == 'month') {
                var currentHour = new Date().getHours();
                var chkDate = moment(new Date(mdata.addDate));
                var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
                vm.data.ReservationStartDate = tempDate.set({h: currentHour, m: '00'});
                vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(mdata.settingMin, 'm');
                vm.takenTime = mdata.settingMin;
              } else {
                var currentHour = new Date().getHours();
                var chkDate = moment(new Date(mdata.addDate));
                var tempDate = moment(chkDate, 'ddd MMM D YYYY HH:mm:ss ZZ');
                // tempDate.set({h: currentHour});
                vm.data.ReservationStartDate = tempDate;
                vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(mdata.settingMin, 'm');
                vm.takenTime = mdata.settingMin;
                // vm.data.ReservationEndDate = moment(vm.data.ReservationStartDate).add(30, 'm');
              }
              
              // 부서 설정
              if (mdata.option == "10") {
                vm.data.VisitDeptId = mdata.resourceId;
              } else if (mdata.option == "20") {
                vm.data.SurgicalDeptId = mdata.resourceId;
              }
            } else if (mdata.calendar == 'calendar') {
              vm.data.RepeatType = vm.data.RepeatType === undefined ? '10' : vm.data.RepeatType;
            }

            // 최초 상태값 체크
            vm.data.oldReserveStatus = vm.data.ReserveStatus;
  
            // 스케줄에서 ReserveViewType == 'V'를 누르고 들어온 경우
            if (mdata.ReserveViewType == 'V' && mdata.ReserveType == '10') {
              $timeout(function () {
                $(".modal-dialog input").attr("disabled","disabled");
                $(".modal-dialog textarea").attr("disabled","disabled");
                $(".modal-dialog select").attr("disabled","disabled");
                $(".item-wrap span").detach();
                $("#sec4").detach();
              });
            }

            // 스케줄에서 이벤트 클릭 > 시술예약으로 전환했을 경우
            if (mdata.chkTitle == 'V') {
              vm.data.Status = '10';
            } else if (mdata.chkTitle == 'L') {
              vm.data.Status = '20';
            }

            // 하단의 버튼을 보이고 숨기기 위한 변수
            vm.data.mDataVisitId = isNullOrEmpty(mdata.VisitId) ? 0 : mdata.VisitId;
            vm.data.mDataSurgicalId = isNullOrEmpty(mdata.SurgicalId) ? 0 : mdata.SurgicalId;

            // 하단버튼으로 시술에서 방문예약으로 변경될때 저장하기전에 팝업을 띄우기 위한 값 (초기화)
            vm.data.chgStatusSaveYN = 'N';

            // 하단버튼으로 변경될때 메모추가 버튼을 숨기기 위한 값 (초기화)
            vm.data.chgStatusMemoYN = 'N';

            // 메모추가시 필요한값
            if (!isNullOrEmpty(vm.data.ReserveStatus)) {
              vm.data.OldReserveStatus = vm.data.ReserveStatus;
            }

            getStatusCode();
            setItem();
            chgStatus();
            getMemoList();
            getGroupTimeList();
            // 고객값을 가지고 들어온 경우
            if (!isNullOrEmpty(mdata.CustId) && isNullOrEmpty(mdata.KeyId)) {
              setCustInfo(mdata.CustId);
            }
          }

          $('label.btn').on('click','input', function(e){
            e.stopPropagation();
            $(this).attr('checked', !$(this).attr('checked'));
            $(e.target).closest('label').toggleClass('btn-flat');
          });
  
  

          /** @description autoView init Callback**/
          vm.addCustomer = addCustomer;
          vm.changeCustCode = changeCustCode;
          vm.ok = ok;
          vm.cancel = cancel;
          vm.fnOpenRepeat = fnOpenRepeat;
          vm.fnCloseRepeat = fnCloseRepeat;
          vm.getStatusCode = getStatusCode;
          vm.chgStatus = chgStatus;
          vm.setItemType = setItemType;
          vm.setCustInfo = setCustInfo;
          vm.setItem = setItem;
          vm.deleteItem = deleteItem;
          vm.setData = setData;
          vm.getMemoList = getMemoList;
          vm.saveMemo = saveMemo;
          vm.clickBtn = clickBtn;
          vm.chkStartDate = chkStartDate;
          vm.chkEndDate = chkEndDate;
          vm.getIsValidData = getIsValidData;
          vm.saveCustomer = saveCustomer;
          vm.setChangeTab = setChangeTab;
          vm.goCustomerDetail = goCustomerDetail;
          vm.onReadyAutoView = onReadyAutoView;
          vm.setCheckSimpleSign = setCheckSimpleSign;
          vm.selectRepeat = selectRepeat;
          vm.setRepeat = setRepeat;
          vm.delData = delData;
  
          $scope.eventSources = [$scope.events];

          var av = new autoView();
          av.init(autoViewOption);
        }]);
  })();
  
(function () {
  "use strict";
  webapp.controller('CustMigrationModalCtrl',
    [ 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$state',
      function CustMigrationModalCtrl(postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $state) {
      
      var vm = this;
      vm.downloadExcel = downloadExcel;
      vm.importExcelData = importExcelData;
      vm.cancel = cancel;
      

      (function ModelMasterExcelUploadModalCtrl() {
        vm.rawDataList = [];
        vm.failDataList = [];
        vm.insertCustList = [];
      })();

      /**
       * 담당자 아이디 체크를 위해 사용자목록 가져오기
       * @param
       * @return
       * @author 정유리
       */
      postApi.select({mapCode : 'ScUser.getUserListCodes'}, 
      function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.codeManager = result.body.docs;
        }
      });

      /**
       * 양식파일 다운로드
       * @param
       * @return
       * @author 정유리
       */
      function downloadExcel(){
        window.location.href = "/assets/excel/InsertCustomers.xlsx";
      }

      /**
       * 비교데이터 가져오기
       * @param
       * @return
       * @author 정유리
       */
       function getScCustCompareData (callback) {
        try {
          postApi.select({ mapCode: 'ScExcel.getScCustCompareData' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.CustCompareData = result.body.docs;
              } else {
                vm.CustCompareData = [];
              }
              callback(vm.CustCompareData);
            }
          });
        }
        catch (ex)
        {
          gAlert("확인", "중복데이터 조회 중 오류가 발생했습니다. 다시 시도해주세요.");
        }
      }

      /**
       * Excel Data Import
       * @param
       * @return
       * @author 정유리
       */
      function importExcelData(e)
      {
        vm.failPanel = false;
        var excelFile = document.getElementById("excelFile");

        if ($(excelFile).val() == "") {
          gAlert('확인', 'Excel 파일을 선택 하십시오.');
          return false;
        }
        else
        {
          var fileName = excelFile.value;
          var validFileExtensions = [".xls", ".xlsx"];
          var isValid = false;
          for (var j = 0; j < validFileExtensions.length; j++) {
            var curExtension = validFileExtensions[j];
            if (fileName.substr(fileName.length - curExtension.length, curExtension.length).toLowerCase() == curExtension.toLowerCase()) {
              isValid = true;
              break;
            }
          }

          if (!isValid)
          {
            gAlert('확인', 'Excel 파일만 선택이 가능합니다.');
            return false;
          }

          // Excel Data Loading
          vm.rawDataList = [];
          vm.failDataList = [];
          vm.insertCustList = [];
          var reader = new FileReader();

          reader.onload = function(){
            var fileData = reader.result;
            var wb = XLSX.read(fileData, {type : 'binary'});

            // Todo: Excel Data Loading 표시
            wb.SheetNames.forEach(function(sheetName){
              // Excel Data Loading
              var rows =XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
              // Raw Data 저장
              vm.rawDataList = angular.copy(rows);
            });

            getScCustCompareData (function(result) {
              vm.rawDataList.splice(0,1);
              vm.rawDataList.forEach(function(item) {

                if(!isNullOrEmpty(item.CustNm) && !isNullOrEmpty(item.Mobile) && !isNullOrEmpty(item.Manager)) {

                  var userData = vm.codeManager.filter(function(e){
                    return e.LoginId == item.Manager;
                  });

                  if (userData.length > 0) {
                    var custData = result.filter(function(e){
                      // console.log(e.CustNm, e.CustNm == item.CustNm && e.Mobile == item.Mobile);
                      return e.CustNm == item.CustNm && e.Mobile == item.Mobile.replaceAll('-','');
                    });
  
                    if (custData.length > 0) {
                      if (isNullOrEmpty(custData[0].CustBranchId)) {
                        // CustBranch insert
                        item.NewBranch = 'Y';
                        item.CustId = custData[0].CustId;
                        item.BranchNewId = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                        vm.insertCustList.push(item);
                      } else {
                        item.Err = '고객중복';
                        vm.failDataList.push(item);
                      }
                    } else {
                      // Customer, CustBranch insert
                      item.NewCust = 'Y';
                      item.CustId = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      item.BranchNewId = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      vm.insertCustList.push(item);
                    }
                  } else {
                    item.Err = '담당자ID오류';
                    vm.failDataList.push(item);
                  }
                } else {
                  item.Err = '필수값누락';
                  vm.failDataList.push(item);
                }

              });

              if (vm.insertCustList.length > 0) {
                vm.insertCnt = vm.insertCustList.length;
                postApi.insert({ mapCode: 'ScExcel.insertScCustomerForExcel', CustExcelLists : vm.insertCustList},
                function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    //vm.List = result.body.docs[0];
                    
                    gAlert("", String(vm.rawDataList.length) + "건의 데이터 중 " + String(vm.insertCustList.length) + "건 투입이 완료되었습니다.", {
                      btn: "",
                      fn: function() {
                        if(vm.failDataList.length > 0){
                          vm.failPanel = true;
                        } else {
                          cancel();
                          $state.go("app.customer.customer-list", {srch : ''});
                        }
                      }
                    });
                  }
                }, 
                function(error) {
                  console.log("error");
                  // console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
                  gAlert('', "투입 과정에서 오류가 발생했습니다.</br >관리자에게 문의해주세요.");
                });
              } 
              else 
              {
                gAlert("", "엑셀데이터 모두 실패하였습니다.</br >확인 후 다시 시도해주세요.", {
                  btn: "",
                  fn: function() {
                    vm.failPanel = true;
                  }
                });
              }
            });

            //console.log(vm.rawDataList);
          };
          reader.readAsBinaryString(excelFile.files[0]);
          // Excel Data Display
        }
      }

      /**
       * 취소
       */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
  }]);
})();

webapp.controller('CustarmyGunbunModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$http',
  'gAlert',
  function CustarmyGunbunModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $http,
    gAlert
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'customerarmy-list-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getCustArmyList = getCustArmyList;

    (function CustarmyGunbunModalCtrl() {
      // search
      vm.searchValue = '';
      vm.selectPeriod = 'all';
      vm.startDate = '';
      vm.endDate = '';
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'Gunbun',
          optionName: '군번',
        },
      ];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;

      vm.CustArmyList = [];

      vm.paramData = toModalData;
      vm.searchValue = vm.paramData.ArmyNo;
      getCustArmyList();
    })();
    function changeViewSize() {
      getCustArmyList();
    }
    function getRequestParams() {
      var req = {
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchFieldType: vm.searchFieldType,
        CustNm: vm.searchValue,
        BranchId: $window.sessionStorage['loginBranchId'],
        selectPeriod: vm.selectPeriod,
      };
      vm.filter = req;
      return req;
    }

    function getCustArmyList() {
      //getCustArmyListCnt();

      /*var prms = modalApi.getCustArmyApi().post(vm.getRequestParams()).$promise;
        prms.then(function(json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.CustArmyList = json.body.docs;
          }
        }, function(error) {
          console.error('fail', status, json);
        });*/

      /*if (typeof(vm.searchValue) == "undefined" || vm.searchValue == "") {
            gAlert('', '성명을 입력해주세요');
            return false;
          }*/

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiByGunbun.jsp?p_MM_ARMY_GUNBUN=' +
        vm.searchValue; */

      postApi.api(
        'extSelect/Linkage.getCustomerInfoByGunbun/action',
        vm.getRequestParams(),
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              gAlert('', '조회된 정보가 없습니다.');
            }
            vm.CustArmyList = data.body.docs;
            if (vm.CustArmyList[0].cnt == '1') {
              ok(vm.CustArmyList[0]);
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustArmyList', data.body.docs[0].errMessage);
        }
      );
    }

    /* function getCustArmyListCnt() {
      vm.req = vm.getRequestParams();
      vm.req.mapCode = 'CustArmyModal.getCustArmyListCnt';

      postApi(
        vm.req,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalCount = json.body.docs[0];
          }
        },
        function (json) {
          console.error('fail', status, json);
        }
      );
    } */

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(Cust) {
      $uibModalInstance.close(Cust);
    }
  },
]);

webapp.controller('CustarmyModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  'gAlert',
  '$http',
  function CustarmyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, $http) {
    var vm = this;

    vm.dataloader = false;

    // 접근 권한 체크
    if (!isPageAccess('customerarmy-list-modal', $window.sessionStorage['loginUserType'])) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getCustArmyList = getCustArmyList;

    (function CustarmyModalCtrl() {
      // search
      vm.searchValue = '';
      vm.selectPeriod = 'all';
      vm.startDate = '';
      vm.endDate = '';
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'CustNm',
          optionName: '성명',
        },
        {
          optionId: 'ArmyNo',
          optionName: '군번',
        },
      ];
      vm.searchFieldType = toModalData.searchFieldType
        ? toModalData.searchFieldType
        : vm.searchFieldTypeList[0].optionId;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;
      vm.getGoojikApiList = getGoojikApiList;

      vm.SubCustArmyList = [];
      vm.CustArmySubList = [];
      //getCustArmyList();
    })();

    function changeViewSize() {
      getCustArmyList();
    }

    function getGoojikApiList() {
      if (typeof vm.searchValue == 'undefined' || vm.searchValue == '') {
        gAlert('', '고객명을 입력해주세요');
        return false;
      }

      var linkObj = {
        searchFieldType: vm.searchFieldType,
        searchValue: vm.searchValue,
      };

      postApi.api(
        'extSelect/CustArmyModal.getCustArmyInfoList/action',
        linkObj,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            vm.SubCustArmyList = data.body.docs;
            vm.SubCustArmyList.cnt = data.body.docCnt;
            getRequestParams();
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getGoojikApiList' + data.body.docs[0].errMessage);
        }
      );

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiByNameOut.jsp?p_MM_KNM=' +
        escape(encodeURIComponent(vm.searchValue));
      window.GoojikApiByNameOut = function (data) {
        vm.SubCustArmyList = data;
        getRequestParams();
      };
      $http.jsonp(url, { jsonpCallbackParam: 'GoojikApiByNameOut' }); */
    }

    function getRequestParams() {
      vm.srch = {
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchFieldType: vm.searchFieldType,
        searchValue: vm.searchValue,
        selectPeriod: vm.selectPeriod,
        type: toModalData.type,
        location: toModalData.location,
        list: vm.SubCustArmyList,
        userPermList: JSON.parse(postApi.makeResultData($window.sessionStorage['loginGroupUId'])),
      };
      getCustArmyList();
    }

    function getCustArmyList() {
      getCustArmyListCnt();

      vm.dataloader = true;

      vm.srch.mapCode = 'CustArmyModal.getCustArmyList';

      postApi.select(
        vm.srch,
        function (json) {
          vm.dataloader = false;
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.CustArmyList = json.body.docs;
          }
        },
        function (json) {
          vm.dataloader = false;
          console.log("error");
          // console.error('fail', status, json);
        }
      );
    }

    function getCustArmyListCnt() {
      vm.srch.mapCode = 'CustArmyModal.getCustArmyListCnt';

      postApi.select(
        vm.srch,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalCount = json.body.docs[0];
          }
        },
        function (json) {
          console.log("error");
          // console.error('fail', status, json);
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(Cust) {
      $uibModalInstance.close(Cust);
    }
  },
]);

webapp.controller('CustarmyNameModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$http',
  'gAlert',
  'toModalData',
  function CustarmyNameModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $http,
    gAlert,
    toModalData
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'customerarmy-list-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getCustArmyList = getCustArmyList;

    (function CustarmyNameModalCtrl() {
      // search
      vm.searchValue = '';
      vm.selectPeriod = 'all';
      vm.startDate = '';
      vm.endDate = '';
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      // 검색 선택 옵션
      vm.searchFieldTypeList = [
        {
          optionId: 'CustNm',
          optionName: '성명',
        },
      ];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;

      vm.CustArmyList = [];

      vm.paramData = toModalData;
      vm.searchValue = vm.paramData.CustNm;
      getCustArmyList();
    })();
    function changeViewSize() {
      getCustArmyList();
    }
    function getRequestParams() {
      var req = {
        page: vm.currentPageNum,
        viewSize: vm.viewSizePerPage,
        searchFieldType: vm.searchFieldType,
        CustNm: vm.searchValue,
        BranchId: $window.sessionStorage['loginBranchId'],
        selectPeriod: vm.selectPeriod,
      };
      vm.filter = req;
      return req;
    }

    function getCustArmyList() {
      //getCustArmyListCnt();

      /*var prms = modalApi.getCustArmyApi().post(vm.getRequestParams()).$promise;
        prms.then(function(json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.CustArmyList = json.body.docs;
          }
        }, function(error) {
          console.error('fail', status, json);
        });*/

      /*if (typeof(vm.searchValue) == "undefined" || vm.searchValue == "") {
            gAlert('', '성명을 입력해주세요');
            return false;
          }*/

      /* var url =
        'https://moti.or.kr/system/employ/employ5/GoojikApiByName.jsp?p_MM_KNM=' +
        escape(encodeURIComponent(vm.searchValue)); */

      postApi.api(
        'extSelect/Linkage.getCustomerInfoByName/action',
        vm.getRequestParams(),
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt !== 0) {
              vm.CustArmyList = data.body.docs;
              if (data.body.docCnt === 1) {
                ok(vm.CustArmyList[0]);
              }
            } else {
              gAlert('', '조회된 정보가 없습니다.');
            }
          }
        },
        function (data) {
          console.log("error");
          // console.error('Error-getCustArmyList' + data.body.docs[0].errMessage);
        }
      );
    }

    /*  function getCustArmyListCnt() {
      vm.req = vm.getRequestParams();
      vm.req.mapCode = 'CustArmyModal.getCustArmyListCnt';

      postApi.select(
        vm.req,
        function (json) {
          if (json.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalCount = json.body.docs[0];
          }
        },
        function (json) {
          console.error('fail', status, json);
        }
      );
    } */

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(Cust) {
      $uibModalInstance.close(Cust);
    }
  },
]);

(function () {
  "use strict";
  webapp.controller('CustPaymentModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter', 'modalFactory', 'gConfirm',
      function CustPaymentModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, $window, $filter, modalFactory, gConfirm) {

        // View Model 
        var vm = this;

        //#region 상수 선언 
        //#endregion 상수 선언 

        //#region 변수 선언
        vm.parentKeyId = toModalData.CustId;

        // 신규 추가나 방문/시술 완료 이후 결제시에는 KeyId 값 없음 
        $stateParams.KeyId = toModalData.KeyId;
        //#endregion 변수 선언 

        //#region 코드 설정 
        // 고객리스트
        postApi.select({
            mapCode: 'ScCustomer.getCustomerCodeList'
          },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeCustList = result.body.docs;
            }
          });

        // 시술담당자
        postApi.select({
            mapCode: 'ScUser.getUserListCodes'
          },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeManager = result.body.docs;
            }
          });

        // 시술담당부서
        postApi.select({
            mapCode: 'organizationMng.getOrganizationCodes',
            Depth: '3'
          },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeDepts = result.body.docs;
            }
          });

        // 유형(상품) 코드 
        postApi.select({
            mapCode: 'ScCustomerPayment.getPayScitemtypeCodes',
            ItemType: 'I'
          },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeItemType = result.body.docs;
            }
          });

        // 횟수권 코드 
        postApi.select({
            mapCode: 'ScCustomerPayment.getScCustPayTicketList',
            CustId: toModalData.CustId
          },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeTicketList = result.body.docs;
            }
          });

        // 포인트 적립 여부 
        vm.codePointYN = [];
        vm.codePointYN.push({
          'Code': 'Y',
          'CodeValue': '적립'
        }, {
          'Code': 'N',
          'CodeValue': '미적립'
        });

        //#endregion 코드 설정 

        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "sccustpaymaster", // 고객결제정보 
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vm.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: {
              mapCode: "ScCustomerPayment.getScCustPaymentDetail",
              param: {
                KeyId: toModalData.KeyId,
                ReserveType: toModalData.ReserveType,
                VisitId: toModalData.ReserveId,
                SurgicalId: toModalData.ReserveId
              }
            },

            // insert MapperId
            insert: "ScCustomerPayment.insertScCustPayment",

            // update MapperId
            update: "ScCustomerPayment.insertScCustPaymentOutAmt",

          },
          /* 목록페이지 */

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {
            ItemType: "vc.data.PayStatus == '10'",
            Ticket: "vc.data.PayStatus == '10'",
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
            PayDate: "vc.data.PayStatus == '30'",
            CustNm: true,
            Mobile: true,
            SurgicalManager: "vc.data.PayStatus != '10'",
            SurgicalDeptId: "vc.data.PayStatus != '10'",
            ItemType: "vc.data.PayStatus != '10'",
            Ticket: "vc.data.PayStatus != '10'",
            PointYN: "vc.data.PayStatus == '30'",
            Remark: "vc.data.PayStatus == '30'",
          },

          // MetaColum 외 추가 적으로 넣어야할 폼
          addForm: {},

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
            ItemType: "setItemType",
            Ticket: "setTicket",
            PointYN: "setPoint",
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {

          },

          timeOption: {
            PayDate: {
              minuteStep: 1,
              initActiveCalendar: true
            }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            ItemType: "codeItemType",
            SurgicalDeptId: "codeDepts",
            SurgicalManager: "codeManager",
            Ticket: "codeTicketList",
            PointYN: "codePointYN",
          },

          // 필수 항목 컬럼 
          required: ["CustId", "PayDate", "SurgicalManager", "TotPayAmt", "FinPayAmt", "PayStatus"],

          autocomplete: {}

        };
        //#endregion Auto View Option 설정 

        //#region 함수 구현 

        /**
         * 유형 선택시 유형 목록 추가  
         * @param {*} data
         */
        function setItemType(column, data) {

          // 결제상태가 10(대기)일 경우에만 추가 가능 
          if (data) {
            for (var i in vm.codeItemType) {
              if (vm.codeItemType[i].Code == data) {

                // 중복 체크하여 존재시 수량 증가 
                var chkItem = $filter('filter')(vm.data.PayDetailList, {
                  ItemTypeId: vm.codeItemType[i].Code
                });

                // 미 존재시 추가 
                if (isNullOrEmpty(chkItem)) {
                  var itemCnt = parseInt(vm.codeItemType[i].Quantity);

                  // 횟수(회) 초기값 설정 
                  if (itemCnt == 0)
                    itemCnt = 1;

                  vm.data.PayDetailList.push({
                    'ItemTypeId': vm.codeItemType[i].Code,
                    'ItemTypeNm': vm.codeItemType[i].CodeValue,
                    'ItemUnitPrice': vm.codeItemType[i].Cost,
                    'ItemCnt': itemCnt,
                    'ItemDiscRate': 0,
                    'ItemAmt': parseInt(vm.codeItemType[i].Cost) * itemCnt,
                    'IsTicket': 0,
                    'RemCnt': 0
                  });
                }
              }
            }

            setCalcPayMethType();
          }
        }

        /**
         * 횟수권 선택시 유형 목록 추가  
         * @param {*} data
         */
        function setTicket(column, data) {

          // 방문일 경우 횟수권 선택 불가 
          if (vm.data.ReserveType == '10')
          {
            gAlert('', '방문예약 결제시 횟수권을 사용할 수 없습니다.');
            return false;
          }

          // 결제상태가 10(대기)일 경우에만 추가 가능 
          if (data) {
            for (var i in vm.codeTicketList) {
              if (vm.codeTicketList[i].Code == data) {

                // 중복 체크하여 존재시 수량 증가 
                var chkItem = $filter('filter')(vm.data.PayDetailList, {
                  ItemTypeId: vm.codeTicketList[i].Code
                });

                // 미 존재시 추가 
                if (isNullOrEmpty(chkItem)) {
                  vm.data.PayDetailList.push({
                    'ItemTypeId': vm.codeTicketList[i].Code,
                    'ItemTypeNm': vm.codeTicketList[i].CodeValue,
                    'ItemUnitPrice': 0,
                    'ItemCnt': 1,
                    'ItemDiscRate': 0,
                    'ItemAmt': 0,
                    'IsTicket': 1,
                    'RemCnt': vm.codeTicketList[i].RemCnt
                  });

                  // 결제 수단 횟수권 선택 
                  vm.data.PayMethType20 = true;
                  setCalcPayMethType();
                }
              }
            }
          }
        }

        /**
         * 선택한 유형 삭제 
         * @param {*} item 
         */
        function deleteItem(item) {
          if (item) {
            for (var i in vm.data.PayDetailList) {
              if (vm.data.PayDetailList[i].ItemTypeId == item.ItemTypeId) {

                // 횟수권 삭제시 결제 수단 횟수권 삭제 
                if (vm.data.PayDetailList[i].IsTicket == 1) {
                  vm.data.PayMethType20 = false;
                  vm.data.PayMethType20Amt = 0;
                }

                vm.data.PayDetailList.splice(i, 1);

                vm.setCalcPayMethType();
              }
            }
          }
        }

        /**
         * 선택한 유형 환불 
         * @param {*} item 
         */
        function refundItem(item) {

          gConfirm('', '선택한 유형을 환불 체크하시겠습니까?', {
            btn: '',
            fn: function () {
              if (item) {
                for (var i in vm.data.PayDetailList) {
                  if (vm.data.PayDetailList[i].ItemTypeId == item.ItemTypeId) {

                    if (vm.data.PayDetailList[i].ItemAmt > 0) {
                      setRefundAmt(vm.data.PayDetailList[i].ItemAmt);
                      vm.data.PayDetailList[i].ItemAmt = -vm.data.PayDetailList[i].ItemAmt;
                    }
                  }
                }
              }
            }
          }, {
            btn: '',
            fn: function () {
              // 취소 
            }
          });


        }

        /**
         * 전체 환불 
         *  
         */
        function refundAllData() {
          gConfirm('', '전체 유형을 모두 환불 체크하시겠습니까?', {
            btn: '',
            fn: function () {
              for (var i in vm.data.PayDetailList) {

                if (vm.data.PayDetailList[i].ItemAmt > 0) {
                  setRefundAmt(vm.data.PayDetailList[i].ItemAmt);
                  vm.data.PayDetailList[i].ItemAmt = -vm.data.PayDetailList[i].ItemAmt;
                }
              }

            }
          }, {
            btn: '',
            fn: function () {
              // 취소 
            }
          });

        }

        /**
         * 환불 금액 누적 
         * @param {number} refundAmt
         */
        function setRefundAmt(refundAmt) {
          vm.data.RefundAmt = vm.data.RefundAmt + refundAmt;
        }

        /**
         * 환불 처리 
         *  
         */
        function setRefundData() {
          gConfirm('', '최종 환불 처리하시겠습니까?', {
            btn: '',
            fn: function () {


              vm.refundData = {};
              vm.refundData = vm.data;

              // 부분환불, 전체환불 메모 표시 
              var remark = vm.refundData.Remark;
              var refundRemark = $window.sessionStorage["loginUserName"] + '> ';

              if (vm.refundData.RefundAmt == vm.refundData.TotPayAmt) {
                refundRemark = refundRemark + '전체 환불';
              } else {
                refundRemark = refundRemark + '부분 환불';
              }

              // 환불 내역 메모 추가 
              if (isNullOrEmpty(remark)) {
                remark = refundRemark;
              } else {
                remark = '\r\n' + refundRemark;
              }

              vm.refundData.Remark = remark;

              vm.refundData.mapCode = 'ScCustomerPayment.updateRefundData';

              postApi.update(vm.refundData,
                function (result) {

                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    av.alert("환불 처리되었습니다.", function () {
                      $stateParams.KeyId = vm.parentKeyId;
                      $uibModalInstance.close('');
                    });
                  } else {
                    console.log("error");
                    // console.error('Error - custPayment-modal-ctrl> setRefundData()');
                    // console.table(result.body.docs[0]);
                    av.alert('환불 처리를 실패했습니다.');
                  }

                });
            }
          }, {
            btn: '',
            fn: function () {
              // 취소 
            }
          });

        }

        /**
         * 고객정보 조회 & 표시 
         * @param {*} mCustId 
         */
        function setCustInfo() {
          postApi.select({
              mapCode: 'ScCustomerPayment.getCustomerCodeList',
              CustId: vm.data.CustId
            },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.data.CustId = result.body.docs[0].Code;
                vm.data.CustNm = result.body.docs[0].CustNm;
                vm.data.Mobile = result.body.docs[0].Mobile;
                vm.data.RemPassAmt = result.body.docs[0].RemPassAmt;
                vm.data.RemPoint = result.body.docs[0].RemPoint;
              }
            });
        }


        /**
         * 결제 수단 선택 
         */
        function setPayMethType(payMethType) {

          switch (payMethType) {
            case '10':
              // 정액권 (잔여금액이 존재할 경우)
              if (vm.data.RemPassAmt > 0)
                vm.data.PayMethType10 = !vm.data.PayMethType10;
              break;

            case '30':
              // 포인트 (잔여포인트가 존재할 경우)
              if (vm.data.RemPoint > 0)
                vm.data.PayMethType30 = !vm.data.PayMethType30;
              break;

            case '40':
              // 현금 
              vm.data.PayMethType40 = !vm.data.PayMethType40;
              break;

            case '50':
              // 계좌이체  
              vm.data.PayMethType50 = !vm.data.PayMethType50;
              break;

            case '60':
              // 카드 
              vm.data.PayMethType60 = !vm.data.PayMethType60;
              break;
          }

          setCalcPayMethType();
        }

        /**
         * 결제 수단 & 결제금액 계산 
         */
        function setCalcPayMethType() {


          // 결제 수단별 금액 
          var selPayAmt = 0;

          // 횟수권 내역 
          vm.data.UsedTicketList = [];
          // 기존 알림 Ticket Id 초기화 
          vm.data.TktId1 = '';
          vm.data.TktId2 = '';
          vm.data.TktId3 = '';
          vm.data.TktId4 = '';
          vm.data.TktId5 = '';

          // 청구금액
          // 결제상태가 10(대기)일 경우에만 계산 
          if (vm.data.PayStatus == '10') {
            vm.data.TotPayAmt = 0;
            vm.data.PayMethType20Amt = 0;
            for (var i in vm.data.PayDetailList) {
              vm.data.TotPayAmt = vm.data.TotPayAmt + vm.data.PayDetailList[i].ItemAmt;

              // 결제수단에 (단가가 0이상일 경우에만) 횟수권 금액 적용 
              if (vm.data.PayDetailList[i].IsTicket == 1) {
                vm.data.PayMethType20 = true;

                // 단가가 0이상이면 횟수권 결제 금액에 반영함 
                if (vm.data.PayDetailList[i].ItemUnitPrice > 0) 
                  vm.data.PayMethType20Amt = vm.data.PayMethType20Amt + vm.data.PayDetailList[i].ItemAmt;

                // 횟수권 내역 
                vm.data.UsedTicketList.push({
                  'CustId': vm.data.CustId,
                  'ItemTypeId': vm.data.PayDetailList[i].ItemTypeId
                });

                // 횟수권 결제 시 알림 메시지 발송용 
                if (isNullOrEmpty(vm.data.TktId1))
                  vm.data.TktId1 = vm.data.PayDetailList[i].ItemTypeId;
              
                if (!isNullOrEmpty(vm.data.TktId1))
                  vm.data.TktId2 = vm.data.PayDetailList[i].ItemTypeId;

                if (!isNullOrEmpty(vm.data.TktId2))
                  vm.data.TktId3 = vm.data.PayDetailList[i].ItemTypeId;

                if (!isNullOrEmpty(vm.data.TktId3))
                  vm.data.TktId4 = vm.data.PayDetailList[i].ItemTypeId;

                if (!isNullOrEmpty(vm.data.TktId4))
                  vm.data.TktId5 = vm.data.PayDetailList[i].ItemTypeId;

              }
            }

            // 결제 수단별 금액 자동 설정 
            // 청구 금액이 존재하며 최종 결제 금액이 없을 경우에만 설정 
            if (vm.data.TotPayAmt > 0 && vm.data.FinPayAmt == 0) {

              if (vm.data.PayMethType10 && vm.data.PayMethType10Amt == 0)
                vm.data.PayMethType10Amt = vm.data.TotPayAmt;

              /*
              if (vm.data.PayMethType20 && vm.data.PayMethType20Amt == 0)
                vm.data.PayMethType20Amt = vm.data.TotPayAmt;
               */

              if (vm.data.PayMethType30 && vm.data.PayMethType30Amt == 0)
                vm.data.PayMethType30Amt = vm.data.TotPayAmt;

              if (vm.data.PayMethType40 && vm.data.PayMethType40Amt == 0)
                vm.data.PayMethType40Amt = vm.data.TotPayAmt;

              if (vm.data.PayMethType50 && vm.data.PayMethType50Amt == 0)
                vm.data.PayMethType50Amt = vm.data.TotPayAmt;

              if (vm.data.PayMethType60 && vm.data.PayMethType60Amt == 0)
                vm.data.PayMethType60Amt = vm.data.TotPayAmt;
            }

          } else if (vm.data.PayStatus == '20') {
            // 결제상태가 20(미수)일 경우에는 미수금액을 청구금액으로 설정 
            vm.data.TotPayAmt = vm.data.FintOutAmt;
          }

          // 정액권은 잔여금액 초과시 잔여금액만 사용가능 
          if (vm.data.PayMethType10 && vm.data.PayMethType10Amt > vm.data.RemPassAmt)
            vm.data.PayMethType10Amt = vm.data.RemPassAmt;
          // 포인트는 잔여포인트 초과시 잔여포인트만 사용가능 
          if (vm.data.PayMethType30 && vm.data.PayMethType30Amt > vm.data.RemPoint)
            vm.data.PayMethType30Amt = vm.data.RemPoint;

          // 결제 수단 
          vm.data.FinPayMethType = '';
          if (vm.data.PayMethType10) {
            vm.data.FinPayMethType = "정액권,";
          } else {
            vm.data.PayMethType10Amt = 0;
          }

          if (vm.data.PayMethType20) {
            vm.data.FinPayMethType = vm.data.FinPayMethType + "횟수권,";
          } else {
            vm.data.PayMethType20Amt = 0;
          }

          if (vm.data.PayMethType30) {
            vm.data.FinPayMethType = vm.data.FinPayMethType + "포인트,";
          } else {
            vm.data.PayMethType30Amt = 0;
          }

          if (vm.data.PayMethType40) {
            vm.data.FinPayMethType = vm.data.FinPayMethType + "현금,";
          } else {
            vm.data.PayMethType40Amt = 0;
          }

          if (vm.data.PayMethType50) {
            vm.data.FinPayMethType = vm.data.FinPayMethType + "계좌이체,";
          } else {
            vm.data.PayMethType50Amt = 0;
          }

          if (vm.data.PayMethType60) {
            vm.data.FinPayMethType = vm.data.FinPayMethType + "신용카드";
          } else {
            vm.data.PayMethType60Amt = 0;
          }

          // 결제 수단별 금액 
          selPayAmt = parseInt(vm.data.PayMethType10Amt) + parseInt(vm.data.PayMethType20Amt) + parseInt(vm.data.PayMethType30Amt) + parseInt(vm.data.PayMethType40Amt) + parseInt(vm.data.PayMethType50Amt) + parseInt(vm.data.PayMethType60Amt);

          if (isNullOrEmpty(selPayAmt))
            selPayAmt = 0;

          // 미수금 
          vm.data.OutAmt = vm.data.TotPayAmt - parseInt(selPayAmt);

          // 최종 결제금액 
          vm.data.FinPayAmt = vm.data.TotPayAmt - vm.data.OutAmt;


          // 적립예정 포인트 
          setPoint();
        }

        /**
         * 유형 목록 조회
         */
        function getPayDetailList() {
          var data = {
            mapCode: 'ScCustomerPayment.getPayDetailList',
            KeyId: vm.data.KeyId
          };
          postApi.select(data,
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.data.PayDetailList = result.body.docs;
              }
            });
        }


        /**
         * 방문/시술 완료 후 결제시 유형 목록 조회
         */
        function getReservePayDetailList() {
          var data = {
            mapCode: 'ScCustomerPayment.getReservePayDetailList',
            ReserveType: vm.data.ReserveType,
            ReserveId: vm.data.ReserveId
          };
          postApi.select(data,
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                
                // 방문은 유형 목록과 횟수권을 조회/선택할 수 없음 
                // 시술만 유형 목록 조회 
                if (vm.data.ReserveType == '20')
                  vm.data.PayDetailList = result.body.docs;

                var managerId = '';
                var deptId = '';

                if (vm.data.ReserveType == "10") {
                  // 방문 
                  managerId = result.body.docs[0].VisitManager;
                  deptId = result.body.docs[0].VisitDeptId;
                } else {
                  // 시술 
                  managerId = result.body.docs[0].SurgicalManager;
                  deptId = result.body.docs[0].SurgicalDeptId;
                }

                // 시술 담당자
                if (!isNullOrEmpty(managerId))
                  vm.data.SurgicalManager = managerId;

                // 시술 부서 
                if (!isNullOrEmpty(deptId))
                  vm.data.SurgicalDeptId = deptId;

                // 시술예약시 횟수권 사용할 경우 결제수단에 횟수권 적용 
                if (vm.data.ReserveType == '20')
                  vm.setCalcPayMethType();
              }
            });
        }


        /**
         * 결제수단 조회 
         */
        function getPayMethodList() {
          postApi.select({
              mapCode: 'ScCustomerPayment.getPayMethodList',
              KeyId: vm.data.KeyId
            },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.data.PayMethodList = result.body.docs;
              }
            });
        }

        /**
         * 지점별 포인트 조회 
         */
        function getBranchPointList() {
          postApi.select({
              mapCode: 'ScCustomerPayment.getPointList',
              KeyId: vm.data.KeyId
            },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                vm.BranchPointList = result.body.docs;
              }
            });
        }

        /**
         * 포인트 적립 
         */
        function setPoint(column, data) {


          // 포인트 적립시에만 처리 
          if (isNullOrEmpty(vm.data.PointYN) || vm.data.PointYN == 'N')
          {
            vm.data.Point = 0;
            
            return false;
          }

          var cashPoint = 0;
          var cardPoint = 0;

          // 일반 유형 
          var pointList = $filter('filter')(vm.BranchPointList, {
            ItemType: '20'
          });

          if (isNullOrEmpty(pointList))
            return false;

          cashPoint = pointList[0].CashPoint;
          cardPoint = pointList[0].CardPoint;

          vm.data.Point = 0;

          if (vm.data.PayMethType60 && vm.data.PayMethType60Amt > 0) {
            // 카드(60)
            if (cardPoint > 0) {
              // 카드 결제금액 포인트 적립 
              vm.data.Point = (vm.data.PayMethType60Amt * cardPoint) / 100;
            }
          }

          if ((vm.data.PayMethType20 || vm.data.PayMethType40 || vm.data.PayMethType50) &&
            (vm.data.PayMethType20Amt > 0 || vm.data.PayMethType40Amt > 0 || vm.data.PayMethType50Amt > 0)) {
            var cashAmt = parseInt(vm.data.PayMethType20Amt) + parseInt(vm.data.PayMethType40Amt) + parseInt(vm.data.PayMethType50Amt);

            // 횟수권(20), 현금(40), 계좌이체(50)
            //
            // -- 정액권, 횟수권 충전시 포인트 적립됨 ---
            //
            // 횟수권(20)은 추가 결제된 금액만 대상 
            // 정액권(10), 포인트(30)는 적립 대상 아님 
            if (cashPoint > 0 && cashAmt > 0) {
              // 현금 결제금액 포인트 적립 
              vm.data.Point = vm.data.Point + (cashAmt * cashPoint) / 100;
            }
          }

        }

        /**
         * 초기화 
         */
        function setInit() {
          // 결제일시 - 현재일시 
          vm.data.PayDate = moment();

          // 시술 담당부서 

          // 시술 담당자 - 로그인 사용자 
          vm.data.SurgicalManager = $window.sessionStorage['loginUserIdx'];

          // 청구금액
          vm.data.TotPayAmt = 0;

          // 미수금액 
          vm.data.OutAmt = 0;

          // 최종 결제금액 
          vm.data.FinPayAmt = 0;

          // 환불 금액 
          vm.data.RefundAmt = 0;

          // 포인트 적립여부 
          vm.data.Point = 0;
          vm.data.PointYN = 'N';

          // 비고 
          vm.data.Remark = '';


          // 결제상태 
          vm.data.PayStatus = '10'; // 10(결제대기), 20(일부결제), 30(결제완료)


          // 선택 유형 목록 
          vm.data.PayDetailList = [];

          // 결제 수단 목록
          vm.data.PayMethodList = [];
          vm.data.FinPayMethType = '';
          vm.data.PayMethType10 = false; // 정액권 
          vm.data.PayMethType20 = false; // 횟수권  
          vm.data.PayMethType30 = false; // 포인트
          vm.data.PayMethType40 = false; // 현금 
          vm.data.PayMethType50 = false; // 계좌이체  
          vm.data.PayMethType60 = false; // 신용카드 

          vm.data.PayMethType10Amt = 0; // 정액권 금액 
          vm.data.PayMethType20Amt = 0; // 횟수권 금액 
          vm.data.PayMethType30Amt = 0; // 포인트 금액 
          vm.data.PayMethType40Amt = 0; // 현금 금액 
          vm.data.PayMethType50Amt = 0; // 계좌이체 금액 
          vm.data.PayMethType60Amt = 0; // 신용카드 금액 

          // 사용한 횟수권 목록 
          vm.data.UsedTicketList = [];
          
          // 횟수권 결제시 알림 메시지 발송용 
          vm.data.PassTktId1 = '';
          vm.data.PassTktId2 = '';
          vm.data.PassTktId3 = '';
          vm.data.PassTktId4 = '';
          vm.data.PassTktId5 = '';

        }

        /**
         * 조회 
         */
        function getData() {
          // 환불 금액 
          vm.data.RefundAmt = 0;

          // 고객 정보 조회 
          if (!isNullOrEmpty(vm.data.CustId))
            setCustInfo(toModalData.CustId);

          // 선택 유형 목록 조회
          vm.data.PayDetailList = [];

          // 기 결제한 유형 목록 조회 
          if (!isNullOrEmpty(vm.data.KeyId))
            getPayDetailList();

          // 시술 완료 후 결제시 유형 목록 조회 
          // 방문은 유형과 횟수권을 조회/선택할 수 없음 
          if (!isNullOrEmpty(vm.data.ReserveType) && !isNullOrEmpty(vm.data.ReserveId))
            getReservePayDetailList();

          // 결제 수단 초기화 
          if (isNullOrEmpty(vm.data.KeyId)) {
            vm.data.PayMethType10 = false; // 정액권 
            vm.data.PayMethType20 = false; // 횟수권  
            vm.data.PayMethType30 = false; // 포인트
            vm.data.PayMethType40 = false; // 현금 
            vm.data.PayMethType50 = false; // 계좌이체  
            vm.data.PayMethType60 = false; // 신용카드 

            vm.data.PayMethType10Amt = 0; // 정액권 금액 
            vm.data.PayMethType20Amt = 0; // 횟수권 금액 
            vm.data.PayMethType30Amt = 0; // 포인트 금액 
            vm.data.PayMethType40Amt = 0; // 현금 금액 
            vm.data.PayMethType50Amt = 0; // 계좌이체 금액 
            vm.data.PayMethType60Amt = 0; // 신용카드 금액 
          }

          // 미수금을 청구금액으로 설정
          vm.data.FintOutAmt = parseInt(vm.data.OutAmt);

          // 기 결제수단 목록 조회 
          if (!isNullOrEmpty(vm.data.KeyId))
            getPayMethodList();

          // 결제 수단 & 결제금액 계산 
          setCalcPayMethType();
        }

        /**
         * 저장 
         */
        function setData() {

          // 최종결제금액이 청구금액보다 클 경우 경고 
          if (vm.data.FinPayAmt > vm.data.TotPayAmt) {
            gAlert('', '최종 결제금액이 청구금액을 초과합니다.');
            return false;
          }

          // TODO: Array로 변경 필요함 
          // 결제 수단 생성 
          vm.data.PayMethodList = [];

          if (vm.data.PayMethType10) {
            vm.data.PayMethodList.push({
              'PayMethType': '10',
              'PayAmt': parseInt(vm.data.PayMethType10Amt)
            });
          }

          if (vm.data.PayMethType20) {
            vm.data.PayMethodList.push({
              'PayMethType': '20',
              'PayAmt': parseInt(vm.data.PayMethType20Amt)
            });
          }

          if (vm.data.PayMethType30) {
            vm.data.PayMethodList.push({
              'PayMethType': '30',
              'PayAmt': parseInt(vm.data.PayMethType30Amt)
            });
          }

          if (vm.data.PayMethType40) {
            vm.data.PayMethodList.push({
              'PayMethType': '40',
              'PayAmt': parseInt(vm.data.PayMethType40Amt)
            });
          }

          if (vm.data.PayMethType50) {
            vm.data.PayMethodList.push({
              'PayMethType': '50',
              'PayAmt': parseInt(vm.data.PayMethType50Amt)
            });
          }

          if (vm.data.PayMethType60) {
            vm.data.PayMethodList.push({
              'PayMethType': '60',
              'PayAmt': parseInt(vm.data.PayMethType60Amt)
            });
          }

          // 결제 수단이 없을 경우 오류 처리 
          if (vm.data.PayMethodList.length == 0)
          {
            gAlert('', '결제 수단을 선택해 주십시오.');
            return false;
          }

          // 결제상태 
          if (!isNullOrEmpty(vm.data.OutAmt)) {
            vm.data.PayStatus = "20"; // 미수 
          }

          if (vm.data.TotPayAmt == vm.data.FinPayAmt) {
            // 완납시 최종결제금액은 청구금액과 동일함 
            vm.data.FinPayAmt = vm.data.TotPayAmt;
            vm.data.PayStatus = "30"; // 완납 
          }

          // 예약구분 (10-방문, 20-시술)
          vm.data.ReserveType = toModalData.ReserveType;
          vm.data.ReserveId = toModalData.ReserveId;

          if (toModalData.ReserveType == "10")
            vm.data.VisitId = toModalData.ReserveId;

          if (toModalData.ReserveType == "20")
            vm.data.SurgicalId = toModalData.ReserveId;


          av.commit(function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert("저장되었습니다.", function () {
                $stateParams.KeyId = vm.parentKeyId;
                $uibModalInstance.close('');
              });
            } else {
              console.log("error");
              // console.error('Error - custPayment-modal-ctrl> setData()');
              // console.table(result.body.docs[0]);
              av.alert('저장을 실패했습니다.');
            }
          });

        }

        /**
         * 닫기
         */
        function cancel() {
          $stateParams.KeyId = vm.parentKeyId;
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {
          // 초기 설정

          // KeyId 
          if (isNullOrEmpty(vm.data.KeyId))
            vm.data.KeyId = toModalData.KeyId;

          // 고객ID
          if (isNullOrEmpty(vm.data.CustId))
            vm.data.CustId = toModalData.CustId;

          // 예약구분 (10-방문, 20-시술)
          vm.data.ReserveType = toModalData.ReserveType;
          vm.data.ReserveId = toModalData.ReserveId;

          // 방문ID, 시술ID
          vm.data.VisitId = "";
          vm.data.SurgicalId = "";

          if (toModalData.ReserveType == "10")
            vm.data.VisitId = toModalData.ReserveId;

          if (toModalData.ReserveType == "20")
            vm.data.SurgicalId = toModalData.ReserveId;

          // 지점별 포인트 
          vm.BranchPointList = [];
          getBranchPointList();

          if (isNullOrEmpty(vm.data.KeyId))
            // 신규등록  
            setInit();

          // 조회 
          // 등록 - 방문/시술 완료 후 결제 
          // 수정 - 미수금 납입 
          getData();

        }

        //#endregion 함수 구현  

        //#region 함수 설정 

        // 유형 선택 
        vm.setItemType = setItemType;
        // 횟수권 선택 
        vm.setTicket = setTicket;
        // 유형 삭제 
        vm.deleteItem = deleteItem;
        // 선택 유형 환불  
        vm.refundItem = refundItem;
        // 전체 유형 환불  
        vm.refundAllData = refundAllData;


        // 결제 수단 선택 
        vm.setPayMethType = setPayMethType;

        // 결제 수단 & 결제 금액 계산 
        vm.setCalcPayMethType = setCalcPayMethType;

        // 포인트 적립 
        vm.setPoint = setPoint;

        // 환불 처리 
        vm.setRefundData = setRefundData;
        // 저장 
        vm.setData = setData;
        // 취소 
        vm.cancel = cancel;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
        //#endregion 함수 설정 


      }
    ]);
})();
(function () {
  "use strict";
  webapp.controller('CustPaymentPassTicketModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter',
      function CustPaymentModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, $window, $filter) {

        // View Model 
        var vm = this;

        //#region 상수 선언 
        //#endregion 상수 선언 

        //#region 변수 선언
        //#endregion 변수 선언 

        //#region 코드 설정 
        

        // 담당자
        postApi.select({ mapCode: 'ScUser.getUserListCodes' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeManager = result.body.docs;
            }
          });

     

        // 결제수단 
        vm.codePayMethType = [];
        vm.codePayMethType.push({'Code' : '40', 'CodeValue' : '현금'},
                                {'Code' : '60', 'CodeValue' : '카드'});

        //#endregion 코드 설정 
      
        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          /* 공통 */
          viewType: mViewType.Edit, // List OR Edit
          tableNm: "sccustpaypassticket", // 고객결제정보 - 정액권/횟수권 충전 
          keyIdNm: "KeyId",
          alias: "vc",
          dataModelNm: "data", // ex : vm.data = {}
          apis: {

            /** common mapper **/
            // initSelect : 기본 데이터를 가져오는 코드 
            initSelect: "", 

            // insert MapperId
            insert: "ScCustomerPayment.insertScCustPaymentPassTicket",
            
            // update MapperId
            update: "",

          },
          /* 목록페이지 */

          /* 상세페이지 */
          // 엘리먼트 퍼블리싱 타입
          formType: mElemTx.layout.inline,

          // 레이아웃 작업시 row class가 들어가야하는 경우 배열로 처리
          addRow: [],

          // vc의 ng-if
          ngIf: {            
          },

          // 비활성화 시킬 컬럼의 조건
          disabled: {
          },

          // MetaColum 외 추가 적으로 넣어야할 폼
          addForm: {
          },

          // 값이 변경되었을 시 콜백 처리 callback 과 유사함
          ngChange: {
            ItemTypeId:"setItemType",
            FinPayAmt:"setAddAmt",
          },

          // ngChange, Button, Date Chage 등에 사용하는 콜백
          callback: {
          },

          timeOption: {
            PayDate: {
              minuteStep: 1, initActiveCalendar: true
            }
          },

          // Lable 이 없고 LeftMargin을 뺄 경우 배열 값으로 지정
          //noLable : ["OpenType"],

          // 코드타입 (select, checkbox, radio)을 시스템 코드를 사용하지 않고 커스텀 코드를 입력할 시
          // 시스템코드가 있어도 커스텀 코드가 있으면 우선 적용
          customCodes: {
            PayUser: "codeManager",
            ItemTypeId: "codeItemType",
            PayMethType: "codePayMethType",
          },

          // 필수 항목 컬럼 
          required: ["CustId", "PayDate", "PayUser", "FinPayAmt", "PayMethType"],

          autocomplete: {
          }

        };
        //#endregion Auto View Option 설정 
       
        //#region 함수 구현 

      /**
       * 유형 선택시 유형 목록 추가  
       * @param {*} data
       */
        function setItemType(column, data) {
      
          if (data) {
            for (var i in vm.codeItemType) {
              if (vm.codeItemType[i].Code == data) {
                
               var finPayAmt = parseInt(vm.codeItemType[i].Cost);

               // 결제금액
               vm.data.FinPayAmt = finPayAmt;
               // 충전금액 
               vm.data.AddAmt = finPayAmt;

               // 횟수권 - 충전횟수 
               if (vm.data.PayType == '20') {
                var remCnt = parseInt(vm.codeItemType[i].Quantity);
                vm.data.RemCnt = remCnt;
               }
              
              }
            }

          }
        }
    

         /**
         * 지점별 포인트 조회 
         */
        function getBranchPointList()
        {
              postApi.select({ mapCode: 'ScCustomerPayment.getPointList', KeyId: vm.data.KeyId },
                function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    vm.BranchPointList = result.body.docs;
                  }
                });
        }

        /**
         * 포인트 적립  
         */
       function setPoint() {
     
        var cashPoint = 0; 
        var cardPoint = 0;

        // 유형 별 포인트 적립 비율
        var pointItemType = "";

        if (vm.data.PayType == "10")
        {
           // 횟수권 
           pointItemType = "30" 
        }
        else
        {
           // 정액권
           pointItemType = "40" 
        }

        var pointList = $filter('filter')(vm.BranchPointList, {ItemType: pointItemType});

        if (isNullOrEmpty(pointList))
          return false;

        cashPoint = pointList[0].CashPoint;
        cardPoint = pointList[0].CardPoint;

        vm.data.Point = 0;
        var finPayAmt = parseInt(vm.data.FinPayAmt);

        if (vm.data.PayMethType == "40")
        {
          if (cashPoint > 0 && finPayAmt > 0)
          {
            // 현금 결제금액 포인트 적립 
            vm.data.Point = (finPayAmt * cashPoint)/100;
          }    
        }

        if (vm.data.PayMethType == "60")
        {
          // 카드(60)
          if (cardPoint > 0 && finPayAmt > 0)
          {                  
            // 카드 결제금액 포인트 적립 
            vm.data.Point = (finPayAmt * cardPoint)/100;
          }           
        }
        
       }


       /**
        * 정액권/횟수권 유형 
        * @param {*} payType 
        */
       function setPayType(payType) {

        vm.data.PayType = payType;

        if (payType === "10") {
          vm.data.PayTypeNm = "정액권";
          
          // 정액권 코드 
          // 기 구매한 정액권은 표시하지 않음 
          postApi.select({ mapCode: 'ScCustomerPayment.getScitemtypePassCodes',CustId:toModalData.CustId },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeItemType = result.body.docs;
            }
          });

      
        }
        else {
          vm.data.PayTypeNm = "횟수권";
          
          // 횟수권 코드 
          // 기 구매한 횟수권은 표시하지 않음 
          postApi.select({ mapCode: 'ScCustomerPayment.getScitemtypeTicketCodes',CustId:toModalData.CustId },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeItemType = result.body.docs;
            }
          });
        }

       }


       /**
        * 정액권 결제금액 변경시 충전금액 적용
        */
       function setAddAmt(column, data)
       {
          if (vm.data.PayType == "10")
          {
            vm.data.AddAmt = vm.data.FinPayAmt;
          }

       }

        /**
         * 저장 
         */
        function setData() {
         
          // 결제일시 없을 경우 현재일시 설정 
          if (isNullOrEmpty(vm.data.PayDate)) 
            vm.data.PayDate = moment();

          // 정액권 충전시, 충전금액 없을 경우 결제금액과 동일 
          if (vm.data.PayType == "10" && vm.data.AddAmt == 0)                
            vm.data.AddAmt = vm.data.FinPayAmt;

          // 유형 선택  
          if (isNullOrEmpty(vm.data.ItemTypeId))
          {
            gAlert('','서비스 유형을 선택해 주십시오.');
            return false;
          }

          // 횟수권 충전시, 충전금액 초기화 
          if (vm.data.PayType == "20") {

            // 정액권 충전금액 초기화 
            vm.data.AddAmt = 0;

            // 충전횟수가 없을 경우 1로 설정 
            if (isNullOrEmpty(vm.data.RemCnt))
              vm.data.RemCnt = 1;

          }
            
          // 포인트 적립  
          setPoint();

          // 비고 내용 정리, 정액권 충전, 횟수권 구매 
          if (vm.data.PayType == '10')
          {
            vm.data.Remark = '정액권 충전';
          }
          else 
          {
            vm.data.Remark = '횟수권 구매';
          }

          av.commit(function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              av.alert("저장되었습니다.", function(){
                $uibModalInstance.close('');
              });
            }
            else {
              console.log("error");
              // console.error('Error - custPaymentPassTicket-modal-ctrl> setData()');
              // console.table(result.body.docs[0]);
              av.alert('저장을 실패했습니다.');
            }
          });
        }

        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {
          // 초기 설정
        
          // KeyId 
          vm.data.KeyId = "";

          // 고객ID
          vm.data.CustId = toModalData.CustId;

          // 지점별 포인트 
          vm.BranchPointList = [];
          getBranchPointList();

          // 정액권/횟수권 유형
          vm.data.PayType = "10";// 정액권(10), 횟수권(20)
          vm.data.PayTypeNm = "정액권";

          // 결제일시 - 현재일시 
          vm.data.PayDate = moment();

          // 담당자 - 로그인 사용자 
          vm.data.PayUser = $window.sessionStorage['loginUserIdx'];

          // 결제금액
          vm.data.FinPayAmt = 0;

          // 결제수단 
          vm.data.PayMethType = "40"; //현금(40), 신용카드(60)

          // 충전금액 
          vm.data.AddAmt = 0;

          // 포인트 
          vm.data.Point = 0;
      
          // 충전횟수  
          vm.data.RemCnt = 0;
        }

        //#endregion 함수 구현  

        //#region 함수 설정 

        // 횟수권 선택 시 결제금액, 충전횟수 설정 
        vm.setItemType = setItemType;

        // 정액권/횟수권 유형 
        vm.setPayType = setPayType;

        // 정액권 결제금액 변경시 충전금액 적용
        vm.setAddAmt = setAddAmt;

        // 저장 
        vm.setData = setData;
        // 취소 
        vm.cancel = cancel;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);

        // 정액권 기본 설정 
        setPayType('10');
        //#endregion 함수 설정 


      }]);
})();

webapp.controller('EditUserInfoModalCtrl',
    ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window', '$filter',
    function EditUserInfoModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window, $filter) {
      
      var vm = this;
      var mData = angular.copy(toModalData);
      vm.alertMessage = mData.str;

      vm.cancel = function() {
        $uibModalInstance.dismiss('cancel data');
      }

      vm.ok = function(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('EmployHistoryModalCtrl', [
  '$window',
  '$scope',
  '$uibModalInstance',
  'toModalData',
  'GLOBAL_CONSTANT',
  'postApi',
  '$http',
  'gAlert',
  function EmployHistoryModalCtrl(
    $window,
    $scope,
    $uibModalInstance,
    toModalData,
    CONSTANT,
    postApi,
    $http,
    gAlert
  ) {
    var vm = this;

    // 접근 권한 체크
    if (
      !isPageAccess(
        'customerarmy-list-modal',
        $window.sessionStorage['loginUserType']
      )
    ) {
      cancel();
      vm.cancel = cancel;
      return false;
    }

    vm.CompanyWorkTypeList = [];

    postApi.api('extSelect/Linkage.getEventCodeList/action', {}, function (data) {
      if (data.header.status === CONSTANT.HttpStatus.OK) {
        if (data.body.docCnt > 0) {
          vm.CompanyWorkTypeList = data.body.docs;
        }
      }
    });

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getEmployHistoryList = getEmployHistoryList;

    (function EmployHistoryModalCtrl() {
      vm.paramData = toModalData;
      getEmployHistoryList();
    })();

    function getEmployHistoryList() {
      // postApi.api(
      // 'extSelect/Linkage.getEmployHistoryList/action',
      vm.paramData.mapCode = 'Jobinfoarmy.getEmployHistoryList';
      postApi.select(
        vm.paramData,
        function (data) {
          if (data.header.status === CONSTANT.HttpStatus.OK) {
            if (data.body.docCnt === 0) {
              gAlert('', '조회된 정보가 없습니다.');
            } else {
              angular.forEach(data.body.docs, function(item) {
                angular.forEach(vm.CompanyWorkTypeList, function(workType) {
                  if(item.EmployType == workType.Code) {
                    item.EmployType = workType.CodeValue;
                  }
                });
              });
            }
            vm.EmployHistoryList = data.body.docs;
          }
        },
        function (data) {
          console.log("error");
          // console.error(
            // 'Error-getEmployHistoryList',
            // data.body.docs[0].errMessage
          // );
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(Cust) {
      $uibModalInstance.close(Cust);
    }
  },
]);

var __slice = Array.prototype.slice;
(function($) {
	var Sketch;
	$.fn.sketch = function() {
		var args, key, sketch;
		key = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
		
		if (this.length > 1) {
			$.error('Sketch.js can only be called on one element at a time.');
		}
		
		sketch = this.data('sketch');
		
		if (typeof key === 'string' && sketch) {
			if (sketch[key]) {
				if (typeof sketch[key] === 'function') {
					return sketch[key].apply(sketch, args);
				} else if (args.length === 0) {
					return sketch[key];
				} else if (args.length === 1) {
					return sketch[key] = args[0];
				}
			} else {
				return $.error('Sketch.js did not recognize the given command.');
			}
		} else if (sketch) {
			return sketch;
		} else {
			this.data('sketch', new Sketch(this.get(0), key));
			return this;
		}
	};
	Sketch = (function() {
		function Sketch(el, opts) {
			this.el = el;
			this.canvas = $(el);
			this.context = el.getContext('2d');
			this.options = $.extend({
				toolLinks : true,
				defaultTool : 'marker',
				defaultColor : '#000000',
				defaultSize : 1
			}, opts);
			this.painting = false;
			this.color = this.options.defaultColor;
			this.size = this.options.defaultSize;
			this.tool = this.options.defaultTool;
			this.actions = [];
			this.action = [];
			this.actionPaintied = this.options.actionPaintied;
			this.canvas.bind('click mousedown mouseup mousemove mouseleave mouseout', this.onEvent);

			//touchstart touchmove touchend touchcancel
			var _self = this;
			this.canvas.bind("touchstart", function(e){
				e.preventDefault();
				if (e.originalEvent && e.originalEvent.targetTouches) {
					e.pageX = e.originalEvent.targetTouches[0].pageX;
					e.pageY = e.originalEvent.targetTouches[0].pageY;
				}
				
				$.sketch.tools[$(this).data('sketch').tool].onEvent.call($(this).data('sketch'), e);
				//e.preventDefault();
			
			});
			this.canvas.bind("touchmove", function(e){
				e.preventDefault();
				if (e.originalEvent && e.originalEvent.targetTouches) {
					e.pageX = e.originalEvent.targetTouches[0].pageX;
					e.pageY = e.originalEvent.targetTouches[0].pageY;
				}				
				$.sketch.tools[$(this).data('sketch').tool].onEvent.call($(this).data('sketch'), e);
				//return false;
			});
			
			this.canvas.bind("touchend", function(e){
				if(_self.options.actionPaintied){
					_self.options.actionPaintied();
				}
				$.sketch.tools[$(this).data('sketch').tool].onDrawEnd(e);
			});
		}
		
    Sketch.prototype.reset = function(e) {
      var sketch = this;
      this.actions.splice(0, this.actions.length);
      return this.redraw();
    }

    Sketch.prototype.backward = function(format) {
    }

    Sketch.prototype.forward = function(format) {
    }

		Sketch.prototype.download = function(format) {

			//return window.open(this.el.toDataURL(mime));
		};
		Sketch.prototype.set = function(key, value) {
			this[key] = value;
			return this.canvas.trigger("sketch.change" + key, value);
		};
		Sketch.prototype.startPainting = function() {
			this.painting = true;
			return this.action = {
				tool : this.tool,
				color : this.color,
				size : parseFloat(this.size),
				events : []
			};
		};
		Sketch.prototype.stopPainting = function() {
			if (this.action) {
				this.actions.push(this.action);
			}
			this.painting = false;
			this.action = null;
			
			return this.redraw();
		};
		Sketch.prototype.onEvent = function(e) {
			e.preventDefault();
			if (e.originalEvent && e.originalEvent.targetTouches) {
				e.pageX = e.originalEvent.targetTouches[0].pageX;
				e.pageY = e.originalEvent.targetTouches[0].pageY;
			}

			$.sketch.tools[$(this).data('sketch').tool].onEvent.call($(this).data('sketch'), e);			
			return false;
		};
		Sketch.prototype.redraw = function() {
			var sketch;
			sketch = this;
			$.each(this.actions, function() {
				if (this.tool) {
					return $.sketch.tools[this.tool].draw.call(sketch, this);
				}
			});
			if (this.painting && this.action) {
				return $.sketch.tools[this.action.tool].draw.call(sketch,this.action);
			}
		};
		return Sketch;
	})();
	
	$.sketch = {
		tools : {}
	};

	$.sketch.tools.marker = {		
		onDrawEnd : function(e) {
			this.stopPainting();
		},

		onEvent : function(e) {
		
		
			switch (e.type) {
				case 'mousedown':
				case 'touchstart':
					this.startPainting();
					break;
				case 'mouseup':
					this.stopPainting();
					if(this.options.actionPaintied){
						this.options.actionPaintied();
					}
					break;
				case 'mouseout':
				case 'mouseleave':
				case 'touchend':
				
					this.stopPainting();
				break;
				
				case 'touchcancel':
					this.stopPainting();
					$("#testTouch").text("터치종료");
					
					break;
			}
			if(!checkMobile()) {
				if (this.painting) {
					this.action.events.push({
						x : e.pageX - this.canvas.offset().left,
						y : e.pageY - this.canvas.offset().top,
						event : e.type
					});
					return this.redraw();
				}
			} else {
				if(e.type !="mousemove") {
					if (this.painting) {
						this.action.events.push({
							x : e.pageX - this.canvas.offset().left,
							y : e.pageY - this.canvas.offset().top,
							event : e.type
						});
						return this.redraw();
					}
				}
			}
		},
		draw : function(action) {
      
      if(action.events.length == 0) return;

			var event, previous, _i, _len, _ref;
			this.context.lineJoin = "round";
			this.context.lineCap = "round";
			this.context.beginPath();
			this.context.moveTo(action.events[0].x, action.events[0].y);
			
			_ref = action.events;
			for (_i = 0, _len = _ref.length; _i < _len; _i++) {
				event = _ref[_i];
				this.context.lineTo(event.x, event.y);
				previous = event;
			}
			
			this.context.strokeStyle = action.color;
			this.context.lineWidth = action.size;
			return this.context.stroke();
		}
	};
	return $.sketch.tools.eraser = {
		onEvent : function(e) {
			return $.sketch.tools.marker.onEvent.call(this, e);
		},
		draw : function(action) {
			var oldcomposite;
			oldcomposite = this.context.globalCompositeOperation;
			this.context.globalCompositeOperation = "copy";
			action.color = "rgba(0,0,0,0)";
			$.sketch.tools.marker.draw.call(this, action);
			return this.context.globalCompositeOperation = oldcomposite;
		}
	};
})(jQuery);



(function () {
  "use strict";
  webapp.controller('CustPenchartModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter', '$interval', '$state',
      function CustPenchartModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, $window, $filter, $interval, $state) {

        // View Model 
        var vm = this;
        vm.workLists = [];
        vm.workData = [];
        vm.showSelectView = true;
        vm.showDrawView = false;
        vm.currCanvasIdx  = 0;
        vm.currentFileIdx = 0; // 현재 화면에 보여지는 파일
        vm.isFullSceen = false;
        vm.dataloader = true;

        vm.title = "펜차트 추가";
        var checkAuthPer = JSON.parse($window.sessionStorage.getItem("authPer"));
        checkAuthPer = checkAuthPer["app.sysinfo.penchart-mng-list"];
        if(checkAuthPer.read == "Y") {
          vm.checkPenMng = true;
        }
        
        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,

          addForm : {
            SearchBox : { target : 'mfSec1', type : mElemTx.input, colSize: 1, label : "서식검색"},
          },

          formType : mElemTx.layout.inline,
          viewType : mViewType.List,
          tableNm : "penchartmaster",
          keyIdNm : "KeyId",
          alias : "vc",
          dataModelNm : "lists", // ex : vc.data = {}
          srchModelNm : "srch",
          addSrchStack : false,
          initListViewSize : 5,
          apis : {
            initSelectCnt : { mapCode : "PenchartMng.getPenchartMngListCnt", param : null },
            initSelect : { mapCode : "PenchartMng.getPenchartMngList", param : {viewSize : 5} },
          },
        };
        //#endregion Auto View Option 설정 

        var interval;
        $scope.$on('$destroy', function() { 
          $interval.cancel(interval);
        });
       
        function actionPaintied(){
          if(vm.currentFileIdx != vm.workData[vm.currCanvasIdx].history.length-1) {
            vm.workData[vm.currCanvasIdx].history.splice(vm.currentFileIdx+1, vm.workData[vm.currCanvasIdx].history.length);
          }
          var canvas = document.getElementById("chartCanvas"+vm.currCanvasIdx);
          vm.workData[vm.currCanvasIdx].history.push(canvas.toDataURL())
          vm.currentFileIdx = vm.workData[vm.currCanvasIdx].history.length-1;
        }

        function setChangeDrawView() {
          if(checkMobile()) {
            $(".modal-dialog").addClass("is-fullscreen");
          }
          vm.showSelectView = false;
          vm.showDrawView = true;

          var modalWidth = $(".modal-content").width() - 40;
          var keys = [];
          for(var i = 0; i < vm.workLists.length; i++) {
            keys.push( {key : vm.workLists[i].KeyId});
          }

          var p = {
            mapCode : "PenchartMng.getPenchartForms",
            PenChartKeys : keys
          };

          postApi.select(p, function(result) {
            if(result.body.docs.length > 0) {
              vm.workData = result.body.docs;

              var fileCount = 0;
              var run = true;

              interval = $interval(function(){
                if(run) {    
                  run = false;      
                  if(fileCount == result.body.docs.length) {
                    
                    if(vm.workData.length == 1) {
                      $(".btn-forward").addClass("disabled");
                    }
                    vm.title = vm.workData[0].ChartNm;

                    $interval.cancel(interval);
                    setTimeout(function() {
                      run = true;
                    }, 100);
                  } else {
                   
                    var img = new Image();
                    vm.workData[fileCount].history = [];
                    img.src = vm.workData[fileCount].ImageData;
                    img.onload = function(){
                      var canvas = document.getElementById("chartCanvas"+fileCount);
                      var ctx = canvas.getContext('2d');
                      canvas.width = modalWidth;
                      var diff = img.width - modalWidth;
                      diff = diff / img.width;
                      canvas.height = img.height - (img.height * diff);
                      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                      if(fileCount == 0) {
                        vm.workData[fileCount].showYn = true;
                      } else {
                        vm.workData[fileCount].showYn = false;
                      }

                      vm.workData[fileCount].history.push(canvas.toDataURL());
                      fileCount++;
                      run = true;
                    };
                    $("#chartCanvas"+fileCount).sketch({defaultColor: "#000", actionPaintied : actionPaintied});
                    
                  }
                }
              },50);

            } else {
              vm.workData = [];
            }
          });
        }

        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        function ok() {
          $uibModalInstance.dismiss('update data');
        }

        function setWrapBack() {
          
          vm.showDrawView = false;
          vm.showSelectView = true;
          vm.workData = [];
          vm.isFullSceen = false;
          $(".modal-dialog").removeClass("is-fullscreen");
          //console.log(vm.workData)
          // vm.workLists = [];
        }
        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {

          vm._viewSize = 5;
          vm.viewSize = 5;
          vm.srch.viewSize = 5;


          av.compileElement('[ng-model="vc.srch.SearchBox"]','ng-keyup','vc.getSrchData(event=$event)');
          vm.dataloader = false;
          // var p = {
          //   mapCode : "PenchartMng.getPenchartFormList"
          // };
          // postApi.select(p, function(result){
          //   if(result.body.docs.length > 0) {
          //     vm.lists = result.body.docs;
          //   } else {
          //     vm.lists = [];
          //   }
          // });          
        }

        
        // vm.currCanvasIdx  = 0;
        // vm.currentFileIdx = 0; // 현재 화면에 보여지는 파일

        var sketchs = {
          getVmData : function(ci, fi) {
            if(ci != undefined && fi != undefined) {
              return vm.workData[ci].history[fi];
            } else if(ci != undefined) {
              return vm.workData[ci].history;
            } else if(fi != undefined) {
              return vm.workData[vm.currCanvasIdx].history[fi];
            }
          },

          getCanvas : function() {
            return  document.getElementById("chartCanvas"+vm.currCanvasIdx);;
          },

          getSketch : function() {
            return $("#chartCanvas"+vm.currCanvasIdx).data('sketch');
          },

          resetSketch : function() {
            var sketch = $("#chartCanvas"+vm.currCanvasIdx).data('sketch');
            sketch.reset();
          },
          setReset : function() {
            // var sketch = this.getSketch();
            var canvas = this.getCanvas();
            //var histLength = vm.workData[vm.currCanvasIdx].history.length;
            var img = this.getVmData(vm.currCanvasIdx, 0);
            this.loadCanvas(canvas, img)

          },
          loadCanvas : function(canvas, img) {
            var ctx = canvas.getContext('2d');
            var tempImg = new Image();
            this.resetSketch();
            tempImg.src = img;
            tempImg.onload = function(){
              ctx.drawImage(tempImg, 0, 0);
              //vm.currentFileIdx = 0;              
            }
          },
          loadForward : function() {

            vm.currentFileIdx++;
            if(vm.currentFileIdx >= vm.workData[vm.currCanvasIdx].history.length) {
              vm.currentFileIdx--;
              return;
            }
            var canvas = this.getCanvas();
            var img = this.getVmData(vm.currCanvasIdx, vm.currentFileIdx);
            this.loadCanvas(canvas, img);
          },
          loadBackward : function() {
            //vm.currentFileIdx = 
            var canvas = this.getCanvas();
            vm.currentFileIdx--;
            if(vm.currentFileIdx < 0) vm.currentFileIdx = 0;
            var img = this.getVmData(vm.currCanvasIdx, vm.currentFileIdx);
            this.loadCanvas(canvas, img);

          },
          setModeEraser : function(){
            var sketch = this.getSketch();
            sketch.set("tool", "eraser");
          },
          setModeMarker : function() {
            var sketch = this.getSketch();
            sketch.set("tool", "marker");
          }
        }

        function addWorkList(item) {
          var check = true;
          angular.forEach(vm.workLists, function(at, idx, obj){
            if(item.KeyId == at.KeyId) {
              obj.splice(idx, 1);
              check = false;
            }
          })
          if(check) vm.workLists.push(item)
        }

        function setData() {

          av.confirm("저장하시겠습니까?", function() {

            var p = {
              master : [],
              detail : []
            };

            angular.forEach(vm.workData, function(item, idx) {
              var array = new Uint32Array(1);
              window.crypto.getRandomValues(array);
              var m = {

                // 시큐어코딩으로 주석 후 수정 (2023-07-06)
                // KeyId : Math.floor(Math.random() * 899999999999999 + 100000000000000),
                KeyId : Math.floor(array[0] / (Math.pow(2, 32) - 1) * 899999999999999 + 100000000000000),

                PenChartMngId : item.PenChartMngId,
                CustId : toModalData.CustId,
                insertYn : 'Y'
              };
              var d = {
                PenChartMngId : item.PenChartMngId,
                PenChartFormId : item.KeyId,
                ImageData : item.history[item.history.length-1],
                Sort : item.Sort,
                ItemNm : item.ItemNm
              };
              
              var check = true;
              for(var i = 0; i < p.master.length; i++) {
                if(p.master[i].PenChartMngId == item.PenChartMngId) {
                  check = false;
                  break;
                }
              }

              if(check) {
                p.master.push(m);
              }

              p.detail.push(d);

            });

            angular.forEach(p.detail, function(item, idx){

              var master = p.master.filter(function(e){
                return e.PenChartMngId == item.PenChartMngId;
              });

              if(master.length > 0) {
                item.PenChartMasterId = master[0].KeyId;
                item.insertYn = "N";
              }
            });

            p.mapCode = "PenchartMng.setCustomerPenchart";
            postApi.update(p, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                av.alert("Menu.SAVED", function(){
                  vm.ok();
                });
              } else {
                gAlert('', 'Menu.EXCEPTIONOCCURED');  
              }
            }, function (error) {
              console.table(error);
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          });
        }

        function setChangeCanvasIndex(mode) {
          if(mode == 0) {
            vm.currCanvasIdx = vm.currCanvasIdx-1;

            if(0 > vm.currCanvasIdx) {
              vm.currCanvasIdx++;
              $(".btn-backward").addClass("disabled");
              return;
            } else {
              if(vm.currCanvasIdx == 0) {
                $(".btn-backward").addClass("disabled");
              } else {
                $(".btn-backward").removeClass("disabled");
              }

              if(vm.workData.length-1 > vm.currCanvasIdx) {
                $(".btn-forward").removeClass("disabled");
              }
            }
          } else {
            vm.currCanvasIdx = vm.currCanvasIdx+1;

            if(vm.workData.length-1 < vm.currCanvasIdx) {
              vm.currCanvasIdx--;
              return;
            } else {
              if(vm.workData.length-1 == vm.currCanvasIdx) {
                $(".btn-forward").addClass("disabled");
              } else {
                $(".btn-forward").removeClass("disabled");
              }

              if(vm.currCanvasIdx == 0) {
                $(".btn-backward").addClass("disabled");
              } else {
                $(".btn-backward").removeClass("disabled");
              }
            }
          }

          vm.currentFileIdx = vm.workData[vm.currCanvasIdx].history.length-1;         

          angular.forEach(vm.workData, function(item){
            item.showYn = false;
          });
          vm.workData[vm.currCanvasIdx].showYn = true;
          vm.title = vm.workData[vm.currCanvasIdx].ChartNm;
          
        }
        
        function getSrchData(e) {
          if(e == undefined) {
            vm.srch.ChartNm = vm.srch.SearchBox;
            vm.getSearch();
          } else {
            if(e.key == "Enter") {
              vm.srch.ChartNm = vm.srch.SearchBox;
              vm.getSearch();
            }
          }

        }

        function reloadCanvas() {

        }

        function gotoManage() {

          var uri = "app.sysinfo.penchart-mng-list";
          $state.go(uri, {
            srch:''
          }, {reload:uri});

          vm.cancel();

        }

        function fullSceen () {
          if(vm.isFullSceen) {
            vm.isFullSceen = false;
            $(".modal-dialog").removeClass("is-fullscreen")
          } else {
            vm.isFullSceen = true;
            $(".modal-dialog").addClass("is-fullscreen");
          }
          reloadCanvas();
        }

        //#endregion 함수 구현  

        //#region 함수 설정 

        // 취소 
        vm.cancel = cancel;
        vm.ok = ok;
        vm.addWorkList = addWorkList;
        vm.setChangeDrawView = setChangeDrawView;
        vm.setChangeCanvasIndex = setChangeCanvasIndex;
        vm.sketchs = sketchs;
        vm.setData = setData;
        vm.getSrchData = getSrchData;
        vm.setWrapBack = setWrapBack;
        vm.fullSceen = fullSceen;
        vm.gotoManage = gotoManage;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
        //#endregion 함수 설정 


      }]);
})();

(function () {
  "use strict";
  webapp.controller('CustPenchartViewModalCtrl',
    ['$scope', '$stateParams', 'autoView', 'postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$window', '$filter', '$interval',
      function CustPenchartViewModalCtrl($scope, $stateParams, autoView, postApi, CONSTANT, $uibModalInstance, toModalData, gAlert, $window, $filter, $interval) {

        // View Model 
        var vm = this;
        vm.workLists = [];
        vm.workData = [];
        vm.showSelectView = true;
        vm.showDrawView = false;
        vm.currCanvasIdx  = 0;
        vm.currentFileIdx = 0; // 현재 화면에 보여지는 파일

        //#region  Auto View Option 설정 
        var autoViewOption = {
          vm: vm,
          stateParams: $stateParams,
          scope: $scope,
          
          formType : mElemTx.layout.inline,
          viewType : mViewType.List,
          tableNm : "penchartmaster",
          keyIdNm : "KeyId",
          alias : "vc",
          dataModelNm : "data", // ex : vc.data = {}
          apis : {
            initSelect : { mapCode : "PenchartMng.getCustomerPenchartDetail", param : {KeyId : toModalData.KeyId, CustId : toModalData.CustId} },
          },
        };
        //#endregion Auto View Option 설정 

        var interval;
        $scope.$on('$destroy', function() { 
          $interval.cancel(interval);
        });
       
        function setChangeDrawView() {
       
          var modalWidth = $(".modal-content").width() - 40;

          vm.workData = vm.data;
          vm.title = vm.workData[0].ChartNm;

          var fileCount = 0;
          var run = true;

          interval = $interval(function(){
            if(run) {    
              run = false;      
              if(fileCount == vm.workData.length) {
                
                if(vm.workData.length == 1) {
                  $(".btn-forward").addClass("disabled");
                };
                
                $interval.cancel(interval);
                setTimeout(function(){
                  run = true;
                }, 100)
              } else {
                
                var img = new Image();
                vm.workData[fileCount];
                img.src = vm.workData[fileCount].ImageData;
                img.onload = function(){
                  var canvas = document.getElementById("chartCanvas"+fileCount);
                  var ctx = canvas.getContext('2d');

                  if(modalWidth < img.width) {
                    canvas.width = modalWidth;
                    var diff = img.width - modalWidth;
                    diff = diff / img.width;
                    canvas.height = img.height - (img.height * diff);
                  } else {
                    canvas.width = img.width;
                    canvas.height = img.height;
                  }
                  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                  if(fileCount == 0) {
                    vm.workData[fileCount].showYn = true;
                  } else {
                    vm.workData[fileCount].showYn = false;
                  }

                  //vm.workData[fileCount].push(canvas.toDataURL());
                  fileCount++;
                  run = true;
                };
                                
              }
            }
          },50);
        };

        /**
         * 닫기
         */
        function cancel() {
          $uibModalInstance.dismiss('update data');
        }

        function ok() {
          $uibModalInstance.dismiss('update data');
        }

        /**
         * AutoView Callback 
         */
        function onReadyAutoView() {
          vm.setChangeDrawView();
        }
     
        function setChangeCanvasIndex(mode) {
          if(mode == 0) {
            vm.currCanvasIdx = vm.currCanvasIdx-1;

            if(0 > vm.currCanvasIdx) {
              vm.currCanvasIdx++;
              $(".btn-backward").addClass("disabled");
              return
            } else {
              if(vm.currCanvasIdx == 0) {
                $(".btn-backward").addClass("disabled");
              } else {
                $(".btn-backward").removeClass("disabled");
              }

              if(vm.workData.length-1 > vm.currCanvasIdx) {
                $(".btn-forward").removeClass("disabled");
              }
            }
          } else {
            vm.currCanvasIdx = vm.currCanvasIdx+1;

            if(vm.workData.length-1 < vm.currCanvasIdx) {
              vm.currCanvasIdx--;
              return
            } else {
              if(vm.workData.length-1 == vm.currCanvasIdx) {
                $(".btn-forward").addClass("disabled");
              } else {
                $(".btn-forward").removeClass("disabled");
              }

              if(vm.currCanvasIdx == 0) {
                $(".btn-backward").addClass("disabled");
              } else {
                $(".btn-backward").removeClass("disabled");
              }
            }
          }

          angular.forEach(vm.workData, function(item){
            item.showYn = false;
          });
          vm.workData[vm.currCanvasIdx].showYn = true;
        }
        
        //#endregion 함수 구현  

        //#region 함수 설정 

        // 취소 
        vm.cancel = cancel;
        vm.ok = ok;
        vm.setChangeDrawView = setChangeDrawView;
        vm.setChangeCanvasIndex = setChangeCanvasIndex;

        // AutoView Callback
        vm.onReadyAutoView = onReadyAutoView;

        // AutoView 초기화 
        var av = new autoView();
        av.init(autoViewOption);
        //#endregion 함수 설정 


      }]);
})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SmsCustSendDetailModalCtrlData() {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      apiOption : {
        sms : {
          mapCode : 'Campaign2.getCampaignDetail3',
        },
      },
      // 폼에 대한 정보를 정의
      form : {
        sms : [
          {
            target : "#TAB1-A",
            bindKey : viewTx.vc + '.sms',
            layout : mElemTx.layout.inline,
            field : [
              {
                label : "발송채널",
                key : "CmpgnChannel",   
                type : mElemTx.text, 
                col : 2,
                disabled : true
              },
              {
                label : "발송번호",
                key : "FromInfo",   
                type : mElemTx.FromInfo, 
                col : 2,
                disabled : true,
              },
              {
                label : "메세지 제목",
                key : "MembershipNm",
                type : mElemTx.text, 
                col : 2,
                bindData : viewTx.vc + ".SendTitle",
                disabled : true
              },
              {
                label : '메세지 내용',
                type : mElemTx.SendMessage,
                col : 2,
                bindData : viewTx.vc + ".SendMessage",
                disabled : true
              },
            ]
          },
          {
            target : "#TAB1-G",
            bindKey : viewTx.vc + '.payment',
            layout : mElemTx.layout.inline,
            field : [
              {
                label : "미수납부예정일",
                key : "ReceivablesPayDate",   
                type : mElemTx.dateTime, 
                col : 1,
                disabled : "vc.tab1Enable",
              },
              {
                label : "메모",
                key : "Memo",   
                type : mElemTx.textArea, 
                col : 1,
                row : 4,
                //disabled : "vc.tab1Enable",
              },
            ]
          },
        ], // End Membership / GX From
      }
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
webapp.controller('SmsCustSendDetailModalCtrl',
  ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window', 'gConfirm', '$filter',
  function SmsCustSendDetailModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window, gConfirm, $filter) {

    var vm = this;
    vm.data = {}; // BASE DATA;
    
    /**
     * @description 모달팝업 데이터 설정
     */
    var mData = angular.copy(toModalData);
    var ctrlData = SmsCustSendDetailModalCtrlData();
    var apiOption = ctrlData.get('apiOption');
    var forms = ctrlData.get('form');
    
    var pageData = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope
    };

    // 비활성 변수
    vm.tab1Enable = false;

    if(mData.viewTabIndex == 1) {
      vm.title = "문자조회";
      vm.tab1Enable = true;
    } 

    vm.tempPaymentData;

/**********************************/
// 공통 구간 시작
      
    vm.getInitDataExt = function() {
      vm.getInitData();
    };

    vm.getInitData = function() {
      // 결제 정보
      var param = {};
      if(mData.viewTabIndex == 1) {
        param = apiOption.sms;
        // console.log('param', param);
        param.CmpgnImplCustId = mData.CmpgnImplCustId;
        postApi.select(param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // console.log('result', result);
            vm.sms = result.body.docs[0];
            //vm.drawBaseForm();
            //param = apiOption.sms;
            //param.KeyId = vm.sms.MembershipId;
            /* postApi.select(param, function(result){
              console.log(result);
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                var temp = result.body.docs[0];
                var keys = Object.keys(temp);
                for(var i = 0; i < keys.length; i++) {
                  if(keys[i] == "KeyId") {
                    vm.payment.productId = temp[keys[i]];
                  } else {
                    if(keys[i] == "FrequencyTotalCount")  {
                      vm.payment["FrequencyAddTotalCount"] = vm.payment.FrequencyTotalCount;
                    } 
                    vm.payment[keys[i]] = angular.copy(temp[keys[i]]);   
                  }
                }

                for(var i = 0; i < forms["membership"].length; i++) {
                  ap.setForms(forms["membership"][i]);
                }
                
                vm.payment.MembershipNm = mData.MembershipNm;

                vm.tempPaymentData = angular.copy(vm.payment);
              }
            }); */

          }
        });

      
      } 
    };

// 공통 구간 종료
/**********************************/

// 확장 기능 개발 구간 종료
/******************************************************************************** */

  // 확장 기능 개발 구간 밑에서 정의해주세요.
  var ap = new ap();
  ap.setData(pageData);
  ap.init();

  function saveData(callback) {

    var param = angular.copy(vm.paymentInfo.payment);
    if(!isNullOrEmpty(param)) param.TcId = mData.KeyId;
    else {
      if(vm.choiceTabIndex == 0 || vm.choiceTabIndex == 1) {
        gAlert('', '상품을 선택하여주세요.');
      } else if(vm.choiceTabIndex == 2) {
        gAlert('', '락커를 선택하여주세요.');
      } else if(vm.choiceTabIndex == 2) {
        gAlert('', '부가상품을 선택하여주세요.');
      }
      return;
    }
    
    // 자동 바인드된 값은 데이터가 수정되지 않음
    // param.PaymentDate = vm.PaymentDate;
    // param.PeriodStartDate = vm.PeriodStartDate;
    // param.PeriodEndDate = vm.PeriodEndDate;
    // param.PeriodExpirationDate = vm.PeriodExpirationDate;
    
    if(vm.choiceTabIndex == 0) {
      
    } else if(vm.choiceTabIndex == 1) {
      
    } else if(vm.choiceTabIndex == 2) {
      if(isNullOrEmpty(vm.paymentInfo.payment.Position)) {
        gAlert('', '락커를 선택하여주세요.');
        return;
      }
      
      param.mapCode = {
        update : "LockerPayment.updateMmglockerpayment",
        insert : "LockerPayment.insertMmglockerpayment",
      };

      param.UserId = mData.KeyId
    }

    if(vm.choiceTabIndex == 0 || vm.choiceTabIndex == 1) {
      param.mapCode = {
        update : "MembershipPayment.updateMmgmembershippayment",
        insert : "MembershipPayment.insertMmgmembershippayment",
      };
      if(isNullOrEmpty(param.MembershipId)) {
        gAlert('', '상품을 선택하여주세요.');
        return;
      }
    } 

    if(isNullOrEmpty(vm.paymentInfo.payment.CashPaidCost) && isNullOrEmpty(vm.paymentInfo.payment.CardPaidCost)) {
      gAlert('', '납부금액을 입력하여주세요.');
      return;
    }
    ap.commit(param, function(result){
      gAlert("", "Menu.SAVED", {
        btn: "",
        fn: function() {
          $uibModalInstance.close(result.body.docs[0]);    
        }
      });
    });
  }

  vm.updateFrequencyAddTotalCount = function() {
    gConfirm('', '사용가능횟수를 수정하시겠습니까?<br>(사용가능횟수가 수정되었을 시 기존에 사용한 횟수도 변경된 값으로 초기화됩니다.)', {
      btn : '',
      fn : function() {
        
        var data = angular.copy(vm.payment)
        data.Item = "사용횟수 변경";
        data.Content = $window.sessionStorage["loginUserName"] + "님이 " + vm.payment.MembershipNm + "(" + vm.payment.productId + ") 상품의 사용가능횟수를 " + vm.tempPaymentData.FrequencyIfTotalCount + "에서 " + vm.payment.FrequencyIfTotalCount + "로 수정하였습니다.";
        data.PaymentId = mData.KeyId;
        data.TcId = mData.TcId;
        data.FrequencyIfTotalCount = vm.payment.FrequencyIfTotalCount;
        data.mapCode = "MembershipPayment.updateFrequencyAddTotalCount";
        ap.commit(data, function(result){
          ap.alert("수정하였습니다.");
        })
      }
    })
  };

  vm.updatePeriodIfExpirationDate = function() {
    gConfirm('', '최종만료일을 수정하시겠습니까?', {
      btn : '',
      fn : function() {
        
        var data = angular.copy(vm.payment);
        data.Item = "최종만료일 변경";
        data.Content = $window.sessionStorage["loginUserName"] + "님이 " + vm.payment.MembershipNm + "(" + vm.payment.productId + ") 상품의 최종만료일을 " + vm.tempPaymentData.PeriodIfExpirationDate + "에서 " + vm.payment.PeriodIfExpirationDate + "로 수정하였습니다.";
        data.PaymentId = mData.KeyId;
        data.TcId = mData.TcId;
        data.PeriodIfExpirationDate = $filter('localToUtc')(vm.payment.PeriodIfExpirationDate);
        data.mapCode = "MembershipPayment.updatePeriodIfExpirationDate";
        ap.commit(data, function(result){
          ap.alert("수정하였습니다.");
        });
      }
    });
  };

  vm.editPaymentManager = function() {
    gConfirm('', '결제금액을 수정하시겠습니까?', {
      btn : '',
      fn : function() {

        var data = null;
        if(vm.tab1Enable) {
          data = angular.copy(vm.payment)
          data.Content = $window.sessionStorage["loginUserName"] + "님이 " + vm.payment.MembershipNm + "(" + vm.payment.productId + ") 상품의 금액을 수정하였습니다.\r\n";
          data.mapCode = "MembershipPayment.updateViewMmgmembershippayment";
        } else if (vm.tab2Enable) {
          data = angular.copy(vm.paymentInfo.payment)
          data.Content = $window.sessionStorage["loginUserName"] + "님이 락커 결제 내역(락커유형 : " + vm.choiceLocker[0].LockerType + " | 위치 : " + vm.paymentInfo.payment.ItemNm  + ")을 수정하였습니다.\r\n";
          data.mapCode = "LockerPayment.updateViewMmglockerpayment";
        } else if (vm.tab3Enable) {
          data = angular.copy(vm.paymentInfo.payment)
          data.Content = $window.sessionStorage["loginUserName"] + "님이 부가상품 결제 내역(" + vm.paymentInfo.addition.ItemNm + ")을 수정하였습니다.\r\n";
          data.mapCode = "AddtionItemPayment.updateViewMmgadditionitempayment";
        }
        
        data.KeyId = mData.KeyId;
        data.Item = "상품결제금액 변경";
        

        data.PaymentId = mData.KeyId;
        data.TcId = mData.TcId;

        if(data.CashPaidCost != vm.tempPaymentData.CashPaidCost) data.Content += "현금납부금액 : " + vm.tempPaymentData.CashPaidCost + " => " + data.CashPaidCost + "\r\n";
        if(data.CashAdditionalCost != vm.tempPaymentData.CashAdditionalCost) data.Content += "현금추가금액 : " + vm.tempPaymentData.CashAdditionalCost + " => " + data.CashAdditionalCost + "\r\n";
        if(data.CashSaleCost != vm.tempPaymentData.CashSaleCost) data.Content += "현금할인금액 : " + vm.tempPaymentData.CashSaleCost + " => " + data.CashSaleCost + "\r\n";
        if(data.CashReceivables != vm.tempPaymentData.CashReceivables) data.Content += "현금미수금액 : " + vm.tempPaymentData.CashReceivables + " => " + data.CashReceivables + "\r\n";
        if(data.CashPaymentCost != vm.tempPaymentData.CashPaymentCost) data.Content += "현금결제금액 : " + vm.tempPaymentData.CashPaymentCost + " => " + data.CashPaymentCost + "\r\n";

        if(data.CardPaidCost != vm.tempPaymentData.CardPaidCost) data.Content += "카드납부금액 : " + vm.tempPaymentData.CardPaidCost + " => " + data.CardPaidCost + "\r\n";
        if(data.CardAdditionalCost != vm.tempPaymentData.CardAdditionalCost) data.Content += "카드추가금액 : " + vm.tempPaymentData.CardAdditionalCost + " => " + data.CardAdditionalCost + "\r\n";
        if(data.CardSaleCost != vm.tempPaymentData.CardSaleCost) data.Content += "카드할인금액 : " + vm.tempPaymentData.CardSaleCost + " => " + data.CardSaleCost + "\r\n";
        if(data.CardReceivables != vm.tempPaymentData.CardReceivables) data.Content += "카드미수금액 : " + vm.tempPaymentData.CardReceivables + " => " + data.CardReceivables + "\r\n";
        if(data.CardPaymentCost != vm.tempPaymentData.CardPaymentCost) data.Content += "카드결제금액 : " + vm.tempPaymentData.CardPaymentCost + " => " + data.CardPaymentCost + "\r\n";

        if(data.TotalCost != vm.tempPaymentData.TotalCost) data.Content += "최종결제금액 : " + vm.tempPaymentData.TotalCost + " => " + data.TotalCost + "\r\n";
        ap.commit(data, function(result){
          ap.alert("수정하였습니다.");
        })
      }
    })
  }

  vm.delPaymentManager = function() {
    gConfirm('', '결제 내역을 삭제하시겠습니까?', {
      btn : '',
      fn : function() {

        var data = null;
        if(vm.tab1Enable) {
          data = angular.copy(vm.payment)
          data.Item = "결제정보 삭제";
          data.Content = $window.sessionStorage["loginUserName"] + "님이 결제 내역인 " + vm.payment.MembershipNm + " 상품을 삭제하였습니다.";
          data.mapCode = "MembershipPayment.delViewMmgmembershippayment";
        } else if (vm.tab2Enable) {
          data = angular.copy(vm.paymentInfo.payment)
          data.Item = "락커 결제정보 삭제";
          data.Content = $window.sessionStorage["loginUserName"] + "님이 락커 결제 내역(락커유형 : " + vm.choiceLocker[0].LockerType + " | 위치 : " + vm.paymentInfo.payment.ItemNm  + ")을 삭제하였습니다.";
          data.mapCode = "LockerPayment.delViewMmglockerpayment";
        } else if (vm.tab3Enable) {
          data = angular.copy(vm.paymentInfo.payment)
          data.Item = "부가상품 결제정보 삭제";
          data.Content = $window.sessionStorage["loginUserName"] + "님이 부가상품 결제 내역(" + vm.paymentInfo.addition.ItemNm + ")을 삭제하였습니다.";
          data.mapCode = "AddtionItemPayment.delViewMmgadditionitempayment";
        }

        data.PaymentId = mData.KeyId;
        data.TcId = mData.TcId;
        
        ap.commit(data, function(result){
          ap.alert("삭제하였습니다.", function(){
            vm.ok();
          });
        })
      }
    })
  }
  vm.cancel = function() {
    $uibModalInstance.dismiss('cancel data');
  }
} ]);

webapp.controller('ScItemTypeSortableCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window',
function ScItemTypeSortableCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];

    // 업종코드
    vm.selectIndustCode = "";
    vm.industCodeList = [];

    vm.isSys = false;
    vm.isBranch = false;
    if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
    if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchId"))) {
      vm.isBranch = true;  
    }

    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        vm.setChangedSort(vm.changeSortArray);

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    }

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";
      data.IndustCode = vm.selectIndustCode;
      var checkDepth;
      if (depth == 1) {

        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].Depth == 1) data.sort = vm.bindData[i].Sort + 1;
          } 
        }
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }


      if (depth != 1) {
        $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
        $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
        setTimeout(function () {
          $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
        }, 500);
      }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;

      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RelateDataId;
          data.tempId = data.KeyId;
          data.IndustCode = vm.selectIndustCode;
          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          //var $obj = findObject(vm.bindData, 'Sort', sort);

          if (depth != 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    }

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;
    }

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        var minusLength = $("#atMenu_" + obj[i].tempId).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-minus").length;
        if(minusLength != 0) $("#atMenu_" + obj[i].tempId).css("display","block");
        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        //if(obj[i].child != undefined)
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    }

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      if (obj.child.length > 0) {
        gAlert('', '하위 항목이 있으면 삭제할 수 없습니다.', {
          btn: '확인', fn: function () { }
        });
        return;
      }

      var $obj = $(vm.targetField);
      var sort = obj.Sort;
      var mSort = makeSortPath(sort);
      var msg = "";
      msg = "[" + obj.ItemName + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){          
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ItemNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ItemNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ItemNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }


    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];
      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].Depth == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].Depth > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }
      vm.bindData = temp;
    };

    vm.makeListData = function() {

    }

    vm.init = function() {
 
      var data = {};
      data.mapCode = 'getIndustCodeList';
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.industCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.industCodeList = [];
        }
      });

      var data = {};
      data.mapCode = 'organizationMng.getOrganizationCodes';
      data.Depth = "1";
      postApi.select(data, function(result){
        if(result.body.docs.length > 0) {
          vm.branchCodeList = result.body.docs;
        } else {
          vm.industCodeList = [];
        }
      });
    };
    
    
  }]);


webapp.directive('scItemyypeSortable', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@",
      viewType : "=",
    },
    templateUrl : 'app/scsystem/itemtype/sortable-container/sortable-container.html',
    controller : 'ScItemTypeSortableCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.viewType = scope.viewType;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      };

      scope.$watchCollection('viewType', function(item){
        if(ctrl.bindData) { 
          if (item == "L") ctrl.bindData.sort(function(a, b){ return a.listColumnSort - b.listColumnSort; })
          else ctrl.bindData.sort(function(a, b){ return a.editColumnSort - b.editColumnSort; })
        }
        ctrl.viewType = item;
      });
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('PenChartImageSortableCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window', '$interval',
function PenChartImageSortableCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window, $interval) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];
    vm.bindData = [];

    vm.isSys = false;
    vm.isBranch = false;
    if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
    if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchCode"))) {
      vm.isBranch = true;  
    }


    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        //vm.setChangedSort(vm.changeSortArray);

      },
    };

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        obj[i].Sort = (i + 1);
      }
    };

    var interval;
    $scope.$on('$destroy', function() { 
      $interval.cancel(interval);
    });


    var fileElement = angular.element("#selectFiles");
    vm.addImages = function() {
      fileElement.trigger("click");
    }

    fileElement.bind('change', function(){
      var files    = document.querySelector('#selectFiles').files;
      var fileCount = 0;
      var run = true;

      var reader = new FileReader();
      reader.addEventListener("load", function (e) {

        var maxTempCount = 0;
        angular.forEach(vm.bindData, function(item){
          if(item.tempCode > maxTempCount) maxTempCount = item.tempCode;
        })
        maxTempCount++;

        var obj = {
          ItemNm : files[fileCount].name,
          ImageData : reader.result,
          Sort : vm.bindData.length + 1,
          DelYN : 'N',
          tempCode : maxTempCount
        }
        vm.bindData.push(obj)
        fileCount++;
        run = true;
      }, false);

      interval = $interval(function(){

        if(run) {    
          run = false;      
          if(fileCount == files.length) {
            
            $interval.cancel(interval);
            setTimeout(function(){
              run = true;
              vm.setCtrlData(vm.bindData)
            }, 100)
            
          } else {
            reader.readAsDataURL(files[fileCount]);  
          }
        }
      },50);

    });
  

    function init() {

    }

    vm.init = init;
    
    $scope.$watch('$viewContentLoaded', function(){
      // setTimeout(function(){
      //   var offset = $(".sortableListContainer .sortable-root-scope").offset();
      //   var height = $(window).height() - offset.top - 243;
      //   $(".sortableImageContainer .sortable-root-scope").css("min-height", height);
      //   }, 1000)
    })
  }]);

var files = null
webapp.directive('penChartImageSortable', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@",
      viewType : "=",
    },
    templateUrl : 'app/scsystem/penchart-mng/image-sortable-container/sortable-container.html',
    controller : 'PenChartImageSortableCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.viewType = scope.viewType;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      }

      scope.$watchCollection('bindData', function(item){
        ctrl.bindData = item;
      })

      ctrl.setCtrlData = function(data) {
        scope.bindData = data;
      }
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('PenchartMngSortableCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window',
function PenchartMngSortableCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];

    // 업종코드
    vm.selectIndustCode = "";
    vm.industCodeList = [];

    vm.isSys = false;
    vm.isBranch = true;
    if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
    
    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        vm.setChangedSort(vm.changeSortArray);

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    };

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";
      data.IndustCode = vm.selectIndustCode;
      var checkDepth;
      if (depth == 1) {

        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].Depth == 1) data.sort = vm.bindData[i].Sort + 1;
          } 
        }
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }


      if (depth != 1) {
        $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
        $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
        setTimeout(function () {
          $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
        }, 500);
      }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;

      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RelateDataId;
          data.tempId = data.KeyId;
          data.IndustCode = vm.selectIndustCode;
          data.RegDate = result.body.docs[0].NowRegDate;
          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          //var $obj = findObject(vm.bindData, 'Sort', sort);

          if (depth != 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    };

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;
    };

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        var minusLength = $("#atMenu_" + obj[i].tempId).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-minus").length;
        if(minusLength != 0) $("#atMenu_" + obj[i].tempId).css("display","block");
        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        //if(obj[i].child != undefined)
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    };

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      if (obj.child.length > 0) {
        gAlert('', '하위 항목이 있으면 삭제할 수 없습니다.', {
          btn: '확인', fn: function () { }
        });
        return;
      }

      var $obj = $(vm.targetField);
      var sort = obj.Sort;
      var mSort = makeSortPath(sort);
      var msg = "";
      msg = "[" + obj.ChartNm + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){    
            if (result.header.status === CONSTANT.HttpStatus.OK) {
            }        
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ChartNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ChartNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ChartNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ChartNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ChartNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ChartNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ChartNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ChartNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }


    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];
      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].Depth == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].Depth > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }
      vm.bindData = temp;
    };

    vm.makeListData = function() {

    };

    vm.init = function() {
 
      var data = {};
      data.mapCode = 'getIndustCodeList';
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.industCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.industCodeList = [];
        }
      });

      var data = {};
      data.mapCode = 'organizationMng.getOrganizationCodes';
      data.Depth = "1";
      postApi.select(data, function(result){
        if(result.body.docs.length > 0) {
          vm.branchCodeList = result.body.docs;
        } else {
          vm.industCodeList = [];
        }
      });
    };
    
    
  }]);


webapp.directive('penChartManageSortable', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@",
      viewType : "=",
    },
    templateUrl : 'app/scsystem/penchart-mng/sortable-container/sortable-container.html',
    controller : 'PenchartMngSortableCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.viewType = scope.viewType;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      };

      scope.$watchCollection('viewType', function(item){
        if(ctrl.bindData) { 
          if (item == "L") ctrl.bindData.sort(function(a, b){ return a.listColumnSort - b.listColumnSort; })
          else ctrl.bindData.sort(function(a, b){ return a.editColumnSort - b.editColumnSort; })
        }
        ctrl.viewType = item;
      });
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('OrganizationSortableContainerCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window',
function OrganizationSortableContainerCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];


    vm.menuNm = "대부서등록";
    vm.isBranch = false;
    vm.ManageYn = $window.sessionStorage['loginTenantAdminYn'];
    vm.SysAdmin = $window.sessionStorage['loginSysAdminYN'];

    if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchCode"))) {
      vm.menuNm = "소부서추가";
      vm.isBranch = true;
    }

    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        
        // console.log(vm.changeSortArray);
        // angular.forEach(vm.changeSortArray, function(item){
        //   var obj = findObject(vm.bindData, 'KeyId', item.KeyId);
        //   console.log(obj)
        //   obj.Sort = item.Sort;
        // })

        // console.log(vm.bindData)
        vm.setChangedSort(vm.changeSortArray, function(){
        });

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    }

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";

      var checkDepth;
      if (depth == 1) {

        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].CodeLevel == 1) data.sort = vm.bindData[i].Sort + 1;
          } 
        }
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;
      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RelateDataId;
          data.tempId = data.KeyId;
          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          if (depth > 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              var depthNm = "depth-two";
              if(depth == 3) depthNm = "depth-three";
              $obj.closest(".sortable-row").find(".as-sortable-item-text."+ depthNm).css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    }

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;

      if(vm.isBranch) vm.rootTitle = "조직관리";
    }

    vm.setName = function (key, name) {
      var obj = findObject(vm.bindData, 'KeyId', key);
      obj.GroupNm = name;
      obj.ItemNm = name;
    };

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {

        var depthNm = "depth-two";
        if(obj[i].Depth == 3) depthNm = "depth-three";

        var minusLength = $("#atMenu_" + obj[i].tempId+"."+depthNm).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-angle-up").length;
        
        if(minusLength != 0 ) $("#atMenu_" + obj[i].tempId +"." +depthNm).css("display","block");
        //else  $("#atMenu_" + obj[i].tempId +"." +depthNm).css("display","block");

        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    }

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      if (obj.child.length > 0) {
        gAlert('', '하위 항목이 있으면 삭제할 수 없습니다.', {
          btn: '확인', fn: function () { }
        });
        return;
      }

      var $obj = $(vm.targetField);
      var sort = obj.Sort;
      var mSort = makeSortPath(sort);
      var msg = "";
      msg = "[" + obj.ItemNm + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
            }            
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ItemNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ItemNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ItemNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }

    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];
      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].CodeLevel == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].CodeLevel > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentCommonCodeId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }
      vm.bindData = temp;
    };

    vm.makeListData = function() {

    }

    vm.init = function() {
      
      //vm.getData();
    };
    
  }]);

webapp.directive('organizationSortableContainer', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@"
    },
    templateUrl : 'app/system/organization/sortable-container/sortable-container.html',
    controller : 'OrganizationSortableContainerCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      }
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('RoleSortableCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert', '$window',
function RoleSortableCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert, $window) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];

    // 업종코드
    vm.selectIndustCode = "";
    vm.industCodeList = [];

    vm.isSys = false;
    vm.isBranch = false;
    if($window.sessionStorage['loginSysAdminYN'] == "Y") vm.isSys = true;
    if(!isNullOrEmpty($window.sessionStorage.getItem("loginBranchCode"))) {
      vm.isBranch = true;  
    }

    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        vm.setChangedSort(vm.changeSortArray);

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    }

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { 
      $("#" + elementId).css("display", "block"); 
    }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";
      var checkDepth;
      if (depth == 1) {
        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          var maxSort = 0;
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].Depth == 1 && maxSort < vm.bindData[i].Sort) {
              maxSort = vm.bindData[i].Sort;
            } 
          } 
          data.sort = maxSort + 1;
        }
      
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }

      if (depth != 1) {
        $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
        $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
        setTimeout(function () {
          $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
        }, 500);
      }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;

      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          console.log(result)
          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RoleId;
          data.RoleId = result.body.docs[0].RoleId;

          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          if (depth != 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    }

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;
    }

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        var minusLength = $("#atMenu_" + obj[i].tempId).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-minus").length;
        if(minusLength != 0) $("#atMenu_" + obj[i].tempId).css("display","block");
        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        //if(obj[i].child != undefined)
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    }

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      
      var $obj = $(vm.targetField);

      console.log($obj)
      var msg = "";
      msg = "[" + obj.RoleNm + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){          
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ItemNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ItemNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ItemNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }


    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];
      
      console.log(data) 
      
      if(data.length > 0 && !data[0].Sort) {
        var tempSort = 100;
        for(var i = 0; i < data.length; i++) {
          data[i].Sort = tempSort;
          tempSort++;
        }  
      }
      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].Depth == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].Depth > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }
      vm.bindData = temp;
    };

    vm.makeListData = function() {

    }

    vm.init = function() {
 
      var data = {};
      data.mapCode = 'getIndustCodeList';
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.industCodeList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.industCodeList = [];
        }
      });

      var data = {};
      data.mapCode = 'organizationMng.getOrganizationCodes';
      data.Depth = "1";
      postApi.select(data, function(result){
        if(result.body.docs.length > 0) {
          vm.branchCodeList = result.body.docs;
        } else {
          vm.industCodeList = [];
        }
      });
    };
    
    
  }]);


webapp.directive('roleSortable', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@",
      viewType : "=",
    },
    templateUrl : 'app/system/role/sortable-container/sortable-container.html',
    controller : 'RoleSortableCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.viewType = scope.viewType;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      }

      scope.$watchCollection('viewType', function(item){
        if(ctrl.bindData) { 
          if (item == "L") ctrl.bindData.sort(function(a, b){ return a.listColumnSort - b.listColumnSort; })
          else ctrl.bindData.sort(function(a, b){ return a.editColumnSort - b.editColumnSort; })
        }
        ctrl.viewType = item;
      })
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

(function () {
  "use strict";
  webapp.controller('SupportBusinessUploadModalCtrl',
    ['postApi', 'GLOBAL_CONSTANT', '$uibModalInstance', 'toModalData', 'gAlert', '$state',
      function SupportBusinessUploadModalCtrl(postApi, CONSTANT, $uibModalInstance, mdata, gAlert, $state) {

        var vm = this;
        vm.dataloader = false;
        vm.downloadExcel = downloadExcel;
        vm.importExcelData = importExcelData;
        vm.cancel = cancel;
        vm.setData = setData;


        (function ModelMasterExcelUploadModalCtrl() {
          vm.rawDataList = [];
          vm.resultDataList = [];
          vm.insertCustList = [];
        })();

        /**
         * 담당자 아이디 체크를 위해 사용자목록 가져오기
         * @param
         * @return
         * @author 정유리
         */
        postApi.select({ mapCode: 'ScUser.getUserListCodes' },
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.codeManager = result.body.docs;
            }
          });

        /**
         * 양식파일 다운로드
         * @param
         * @return
         * @author 정유리
         */
        function downloadExcel() {
          window.location.href = "/assets/excel/InsertSupportBusiness.xlsx";
        }


        /**
         * Excel Data Import
         * @param
         * @return
         * @author 정유리
         */
        function importExcelData(e) {
          vm.resultPanel = false;
          var excelFile = document.getElementById("excelFile");

          if ($(excelFile).val() == "") {
            gAlert('확인', 'Excel 파일을 선택 하십시오.');
            return false;
          }
          else {
            var fileName = excelFile.value;
            var validFileExtensions = [".xls", ".xlsx"];
            var isValid = false;
            for (var j = 0; j < validFileExtensions.length; j++) {
              var curExtension = validFileExtensions[j];
              if (fileName.substr(fileName.length - curExtension.length, curExtension.length).toLowerCase() == curExtension.toLowerCase()) {
                isValid = true;
                break;
              }
            }

            if (!isValid) {
              gAlert('확인', 'Excel 파일만 선택이 가능합니다.');
              return false;
            }

            postApi.select({ mapCode: 'SupportBusiness.deleteTempSptBusiExcelData' },
              function (result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  // Excel Data Loading
                  vm.rawDataList = [];
                  vm.resultDataList = [];
                  vm.insertCustList = [];
                  var reader = new FileReader();

                  reader.onload = function () {
                    vm.dataloader = true;
                    var fileData = reader.result;
                    var wb = XLSX.read(fileData, { type: 'binary', cellText: false, cellDates: true });

                    // Todo: Excel Data Loading 표시
                    wb.SheetNames.forEach(function (sheetName) {
                      // Excel Data Loading
                      //var rows =XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
                      var rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { raw: false, dateNF: 'yyyy-mm-dd' });
                      // Raw Data 저장
                      vm.rawDataList = angular.copy(rows);
                    });

                    //console.log(vm.rawDataList);

                    vm.rawDataList.splice(0, 1);

                    angular.forEach(vm.rawDataList, function (item) {
                      item.BusinessNm = isNullOrEmpty(item.BusinessNm) ? " " : item.BusinessNm;
                      item.ClientNm = isNullOrEmpty(item.ClientNm) ? " " : item.ClientNm;
                      item.BusiContents = isNullOrEmpty(item.BusiContents) ? " " : item.BusiContents;
                      item.BusiStartDate = isNullOrEmpty(item.BusiStartDate) ? " " : item.BusiStartDate;
                      item.BusiEndDate = isNullOrEmpty(item.BusiEndDate) ? " " : item.BusiEndDate;
                      item.ManagerNms = isNullOrEmpty(item.ManagerNms) ? " " : item.ManagerNms;
                      item.EncryptNm = isNullOrEmpty(item.EncryptNm) ? " " : item.EncryptNm;
                      item.EncryptMobile = isNullOrEmpty(item.EncryptMobile) ? " " : item.EncryptMobile;
                      item.DeptNm = isNullOrEmpty(item.DeptNm) ? " " : item.DeptNm;
                      item.WriteDate = isNullOrEmpty(item.WriteDate) ? " " : item.WriteDate;
                    });

                    postApi.insert({ mapCode: 'SupportBusiness.insertTempSptBusiExcelDataBatch', list: vm.rawDataList },
                      function (result) {
                        if (result.header.status === CONSTANT.HttpStatus.OK) {
                          if (result.body.docs[0].list.length > 0) {
                            postApi.select({ mapCode: 'SupportBusiness.getinsertTempSptBusiExcelData' },
                              function (result) {
                                if (result.header.status === CONSTANT.HttpStatus.OK) {
                                  if (result.body.docs.length > 0) {
                                    vm.failDataCnt = 0;
                                    vm.resultPanel = true;
                                    vm.resultDataList = result.body.docs;

                                    // 실패 건수 계산
                                    angular.forEach(vm.resultDataList, function (item) {
                                      vm.failDataCnt = vm.failDataCnt + (item.ErrYN == 'Y' ? 1 : 0);
                                    });
                                  }
                                } else {
                                  gAlert('', "투입데이터 조회 과정에서 오류가 발생했습니다.</br >관리자에게 문의해주세요.[2]");
                                }
                              },
                              function (error) {
                                gAlert('', "투입데이터 조회 과정에서 오류가 발생했습니다.</br >관리자에게 문의해주세요.[1]");
                              });
                          } else {
                            gAlert('', "투입할 데이터가 없습니다.");
                          }
                        } else {
                          gAlert('', "투입 과정에서 오류가 발생했습니다.</br >관리자에게 문의해주세요.[2]");
                        }
                      },
                      function (error) {
                        gAlert('', "투입 과정에서 오류가 발생했습니다.</br >관리자에게 문의해주세요.[1]");
                      });
                    //console.log(vm.rawDataList);
                  };
                  reader.readAsBinaryString(excelFile.files[0]);
                  // Excel Data Display
                  vm.dataloader = false;
                } else {
                  gAlert('', "오류가 발생했습니다.</br >관리자에게 문의해주세요.[2]");
                }
              },
              function (error) {
                gAlert('', "오류가 발생했습니다.</br >관리자에게 문의해주세요.[1]");
              });
          }
        }

        function setData() {
          postApi.insert({ mapCode: 'SupportBusiness.insertSptBusiExcelDataBatch' },
            function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs[0].RelateDataId !== null) {
                  gAlert("", "Menu.SAVED", {
                    btn: "",
                    fn: function () {
                      cancel();
                      $state.go("app.sysinfo.support-business-list", {}, { reload: "app.sysinfo.support-business-list" });
                    }
                  });
                  return;
                }
              } else {
                gAlert('', result.body.docs[0].errMessage);
              }
            }, function (error) {
              console.table(error);
            });
        }

        /**
         * 취소
         */
        function cancel() {
          $uibModalInstance.dismiss('cancel data');
        }
      }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} modalFactory - modalFactory
   * @description Controller of the 고객조회
   */
  webapp.controller('CustomerMonthCtrl', 
    ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', 'autoView',
    function CustomerMonthCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, autoView) {

      var vm = this;
      vm.dataloader = false;





      graph1();
      graph2();


      function graph1() {
        vm.dataloader = true;
        var xValue = [' 2021년 01월 ', ' 2021년 02월 ', ' 2021년 03월 ', ' 2021년 04월 '];
    
        var yValue = [4.5, 2.3, 3.6, 5.3];
        var yValue2 = [2.1, 4.8, 1.9, 5.7];
        var yValue3 = [2, 2, 3.1, 4.3];
    
    
        var trace1 = {
          x: xValue,
          y: yValue,
          type: 'bar',
          name: '매출',
          marker: {
            color: 'rgba(106,121,227,.8)',
            
          },
          //hovertemplate : none
        };
    
        var trace2 = {
          x: xValue,
          y: yValue2,
          type: 'bar',
          name : '계약수',
          marker: {
            color: 'rgba(106,121,227,.4)',
            
          }
        };
    
        var trace3 = {
          x: xValue,
          y: yValue3,
          //type: 'scatter',
          name : '등록수',
          mode : 'lines+markers',
          marker: {
            color: 'rgb(198,231,255,1)',
            size: 10
          },
          line: {
            color: 'rgba(198,231,255,1)',
            width: 4,
          },
          /* hovertemplate:    '%{x} <br>' + 
                            ' <i>Price</i>: $%{y:.2f}' +
                            '<br><b>X</b>: %{x}<br>' +
                            '<b>%{text}</b>',
          text: ["Text A", "Text B", "Text C", "Text D", "Text E"], */
        };
    
        var data = [trace1,trace2, trace3, ];
    
        var layout = {
          title: '고객사월별실적',
          //barmode: 'group',
          showlegend: true,
          
          hovermode: "x unified",
          
          //hoverlabel: { bgcolor: "#FFF" },
          /* hoverlable : 
            {bgcolor : "#496B85",
              font : {size : 16, color : '#ffffff', family : "SpoqaHanSansNeo"},
            }, */
          legend: {"orientation": "h", /* y: -0.3, */
          bgcolor: 'rgba(255, 255, 255, 0)',
          bordercolor: 'rgba(255, 255, 255, 0)'},
          barmode: 'group',
          bargap: 0.2,
          bargroupgap: 0.15,
          xaxis: {zeroline: false,},
          
          yaxis: {
            zeroline: false,
            showline: false,
            showgrid: true,
            range: [-0.5, 6]
          },
          config: { responsive: true },
          height: document.getElementById("1").clientHeight,
          width: document.getElementById("1").clientWidth
        };
    
      
    
        Plotly.newPlot('1', data, layout /*, {staticPlot: true} */);
        vm.dataloader = false;
      }
    
      function graph2() {
        vm.dataloader = true;
        var xValue = [' A지역본부 ', ' B지역본부 ', ' C지역본부 ', ' D지역본부 '];
    
        var yValue = [4.5, 2.3, 3.6, 4.3];
        var yValue2 = [4.1, 4.8, 1.9, 3.7];
        var yValue3 = [2, 2.2, 3.1, 5.3];
    
    
        var trace1 = {
          x: xValue,
          y: yValue,
          type: 'bar',
          name: '매출',
          marker: {
            color: 'rgba(106,121,227,.8)',
            
          }
        };
    
        var trace2 = {
          x: xValue,
          y: yValue2,
          type: 'bar',
          name : '계약수',
          marker: {
            color: 'rgba(106,121,227,.4)',
            
          }
        };
    
        var trace3 = {
          x: xValue,
          y: yValue3,
          //type: 'scatter',
          name : '영업일지 등록수',
          mode : 'lines+markers',
          marker: {
            color: 'rgb(198,231,255,1)',
            size: 10
          },
          line: {
            color: 'rgba(198,231,255,1)',
            width: 4,
          },
        };
    
        var data = [trace1,trace2, trace3];
    
        var layout = {
          title: '지역본부별 영업실적 및 영업일지 등록 현황',
          barmode: 'group',
          showlegend: true,
          
          hovermode: "x unified",
          
          //hoverlabel: { bgcolor: "#FFF" },
          /* hoverlable : 
            {bgcolor : "#496B85",
              font : {size : 16, color : '#ffffff', family : "SpoqaHanSansNeo"},
            }, */
          legend: {"orientation": "h", /* y: -0.3, */
          bgcolor: 'rgba(255, 255, 255, 0)',
          bordercolor: 'rgba(255, 255, 255, 0)'},
          //barmode: 'group',
          bargap: 0.2,
          bargroupgap: 0.15,
          xaxis: {zeroline: false,},
          
          yaxis: {
            zeroline: false,
            showline: false,
            showgrid: true,
            range: [-0.5, 6]
          },
          height: document.getElementById("2").clientHeight,
          width: document.getElementById("2").clientWidth
        };
    
        Plotly.newPlot('2', data, layout, {staticPlot: true});
        vm.dataloader = false;
      }

      window.onresize = resize;
      function resize() {
        var currentPath = String(window.location);
        if (currentPath.indexOf('customer-report') != -1) {
          //console.log('window width changed.. redrawing wordcloud');
          graph1();
          graph2();
        }
      }
    }]);
})();

(function () {
  'use strict';
  ClockController.$inject = [
    '$log',
    '$state',
    '$filter',
    '$cookies',
    '$rootScope',
    'MAIN',
    'LoginAPISrv',
    'GLOBAL_CONSTANT',
    'gAlert',
    '$window',
    'StaticVariable',
    'Auth',
    'modalFactory',
    '$scope',
    '$timeout',
  ];

  /** @ngInject */
  function ClockController(
    $log,
    $state,
    $filter,
    $cookies,
    $rootScope,
    MAIN,
    loginApi,
    CONSTANT,
    gAlert,
    $window,
    StaticVariable,
    Auth,
    modalFactory,
    $scope,
    $timeout
  ) {
    var vm = this;
    vm.title = $window.sessionStorage['loginTitle'];
    vm.url = $window.sessionStorage['loginUrl'];

    vm.stateName = $state.current.name;
    var clockId = null;
    $rootScope.$on('$stateChangeStart', function () {
      $timeout.cancel(clockId);
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.stateName = toState.name;
    });

    function printClock() {
      var dayInWeek = ['일', '월', '화', '수', '목', '금', '토'];

      var clock = document.getElementById('clock'); // 출력할 장소 선택
      var calendar = document.getElementById('calendar');

      var currentDate = new Date(); // 현재시간

      var calendar_str =
        currentDate.getFullYear() +
        '년 ' +
        (currentDate.getMonth() + 1) +
        '월 ' +
        currentDate.getDate() +
        '일(' +
        dayInWeek[currentDate.getDay()] +
        ')';

      if (calendar.innerText === '' || calendar.innerText !== calendar_str) {
        calendar.innerText = calendar_str;
      }

      var amPm = 'AM'; // 초기값 AM
      var currentHours = addZeros(currentDate.getHours(), 2);
      var currentMinute = addZeros(currentDate.getMinutes(), 2);
      var currentSeconds = addZeros(currentDate.getSeconds(), 2);

      if (currentHours >= 12) {
        // 시간이 12보다 클 때 PM으로 세팅, 12를 빼줌
        amPm = 'PM';
      }
      if (currentHours >= 13) {
        currentHours = addZeros(currentHours - 12, 2);
      }

      clock.innerHTML =
        currentHours + ':' + currentMinute + ':' + currentSeconds + amPm; //날짜를 출력해 줌

      clockId = $timeout(printClock, 1000); // 1초마다 printClock() 함수 호출
    }

    function addZeros(num, digit) {
      // 자릿수 맞춰주기
      var zero = '';
      num = num.toString();
      if (num.length < digit) {
        for (var i = 0; i < digit - num.length; i++) {
          zero += '0';
        }
      }
      return zero + num;
    }

    printClock();
  }

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  var clock = {
    transclude: true,
    controller: ClockController,
    bindings: {},
    controllerAs: 'clock',
    templateUrl: 'components/ui-component/layout/clock/clock.html',
  };

  webapp.component('clock', clock);
})();

(function () {
  'use strict';

  HeaderController.$inject = [
    '$log',
    '$state',
    '$filter',
    '$cookies',
    '$rootScope',
    'MAIN',
    'LoginAPISrv',
    'GLOBAL_CONSTANT',
    'gAlert',
    '$window',
    'StaticVariable',
    'Auth',
    'modalFactory',
    '$scope',
    '$translate',
    '$timeout',
    'postApi',
    '$mdToast',
    '$interval',
    'gConfirm',
  ];

  /** @ngInject */
  function HeaderController(
    $log,
    $state,
    $filter,
    $cookies,
    $rootScope,
    MAIN,
    loginApi,
    CONSTANT,
    gAlert,
    $window,
    StaticVariable,
    Auth,
    modalWindow,
    $scope,
    $translate,
    $timeout,
    postApi,
    $mdToast,
    $interval,
    gConfirm
  ) {
    var vm = this;

    /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
    $rootScope.$on('$locationChangeStart', function (event, current, previous) {
      // console.log('current=', current, ',previous=', previous);
      $rootScope.previousPage = current;
    });

    /* var translate = $filter('translate'); */

    vm.srch = {};
    vm.isLogin = isLogin;
    vm.doLogout = doLogout;
    vm.doCheckSession = doCheckSession;
    vm.myPage = myPage;

    /*  vm.getChatList = getChatList;
      vm.getTaskList = getTaskList;
      vm.getNotiList = getNotiList;*/
    /*vm.getList = getList;*/
    /*vm.getChatTaskCount = getChatTaskCount;*/

    /*    vm.srchChatComm = {
        remark : '',
      };

      vm.srchTaskComm = {
        remark : '',
      };

      vm.srchNotiComm = {
        remark : '',
      };*/

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    /*   vm.srchChatComm.ChatId = '1';
      vm.srchChatComm.viewSize = vm.viewSize;
      vm.srchTaskComm.ChatId = '1';
      vm.srchTaskComm.viewSize = vm.viewSize;
      vm.srchTaskComm.WorkerId = $window.sessionStorage['loginUserIdx'];
      vm.srchNotiComm.ChatId = '1';
      vm.srchNotiComm.viewSize = vm.viewSize;
      vm.srchNotiComm.TenantId = '0';*/

    vm.userNm = $window.sessionStorage['loginUserName'];
    vm.userGbn = $window.sessionStorage['loginUserGbn'];
    vm.userTerm = $window.sessionStorage['loginUserTerm'];

    doCheckSession();

    /*getList('');
      getList($rootScope.gVariable.UserId);*/

    /*  function getChatList() {
        getList('');
      }*/

    /*   function getTaskList() {
        console.log('getTaskList', $rootScope.gVariable.UserId);
        getList($rootScope.gVariable.UserId);
      }

      function getNotiList() {
        console.log('getNotiList');

        var prms = h0201Api.doChatList().post(vm.srchNotiComm).$promise;

        prms.then(

        function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.listNotiComm = getContentsData(data.responseVO.body.docs);
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }*/

    function isLogin() {
      return $window.sessionStorage['isLoggedIn'] === 'Y';
    }

    function doLogout() {
      StaticVariable.sessionExpire();

      var prms = loginApi.doLogout().post().$promise;
      prms.then(
        function (json) {
          gAlert('', 'Menu.SIGNEDOUT', {
            btn: '',
            fn: function () {
              $interval.cancel(interval);
              //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
              //$state.reload('main.login');
              $state.go('login');
            },
          });
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post({}).$promise;

      prms.then(
        function (json) {
          if (
            json.responseVO.header.status == CONSTANT.HttpStatus.OK &&
            json.responseVO.body.docs != null &&
            json.responseVO.body.docs != ''
          ) {
            $rootScope.setUserSession(json.responseVO.body.docs[0]);
            console.log('Login user');

            vm.userNm = $window.sessionStorage['loginUserName'];
            vm.userGbn = $window.sessionStorage['loginUserGbn'];
            vm.userTerm = $window.sessionStorage['loginUserTerm'];
          } else {
            $interval.cancel(interval);
            /*  $timeout(function () {
              gAlert(translate('Menu.SERVERERROR1'), translate('Menu.INVALIDSESSION'), {
                fn: function () { */
            StaticVariable.sessionExpire();
            $state.go('login');
            /*  },
              });
            }, 2); */
          }
          // gAlert("로그아웃 되었습니다.");
        },
        function (error) {
          console.log("error");
          // console.error('fail', status);
        }
      );
    }

    function myPage() {
      var ctrl = 'MyPageModalCtrl as modalCtrl';
      var paramData = {
        UserId: $rootScope.gVariable.UserId,
        TenantId: $window.sessionStorage['loginTenantId'],
      };
      var modalInstance2 = modalWindow.open('lg', 'components/modal/mypage/mypage-modal.html', ctrl, paramData);
      modalInstance2.result.then(
        function (okData) {
          //성공
        },
        function (cancelData) {
          // 취소
        }
      );
    }

    function twoDigits(n) {
      return n <= 9 ? '0' + n : n;
    }

    var modalInstance = null;

    //타이머
    function updateTimer() {
      $rootScope.gVariable.sessioncountdown--;
      if ($rootScope.gVariable.sessioncountdown < 1) {
        $interval.cancel(interval);
        vm.countdown = '만료되었습니다.';
        if (modalInstance == null) {
          //doLogout();
        }
      } else {
        vm.countdown =
          twoDigits(parseInt($rootScope.gVariable.sessioncountdown / 60)) +
          ':' +
          twoDigits($rootScope.gVariable.sessioncountdown % 60);
      }

      if ($rootScope.gVariable.sessioncountdown == 300) {
        var ctrl = 'SessionCountdownModalCtrl as vc';
        var paramData = {};

        modalInstance = modalWindow.open('modal', 'app/modal/session-countdown-modal.html', ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            if (okData !== undefined && okData === 'expired') {
              doLogout();
            } else {
              doCheckSession();
            }
            modalInstance = null;
          },
          function (cancelData) {
            doLogout();
            modalInstance = null;
          }
        );
      }
    }

    $interval.cancel(interval);
    var interval = $interval(updateTimer, 1000);

    $scope.$on('$stateChangeStart', function () {
      doCheckSession();
    });
  }

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  var header = {
    transclude: true,
    controller: HeaderController,
    bindings: {},
    controllerAs: 'header',
    templateUrl: 'components/ui-component/layout/header/header.html',
  };

  webapp.component('header', header);
})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  SidebarController.$inject = [
    'GLOBAL_CONSTANT',
    'postApi',
    '$scope',
    '$rootScope',
    '$state',
    '$filter',
    'Helper',
    '$window',
    '$timeout',
    '$location',
  ];
  function SidebarController(
    CONSTANT,
    postApi,
    $scope,
    $rootScope,
    $state,
    $filter,
    Helper,
    $window,
    $timeout,
    $location
  ) {
    var vm = this;

    $scope.oneAtATime = false;
    /*vm.totalItemComm = 0;*/

    $scope.status = {
      isFirstOpen: true,
      isSecondOpen: true,
      isThirdOpen: true,
    };

    $rootScope.changeLanguage($window.sessionStorage['currentLanguage']);
    $scope.state = $state;

    vm.srch = {};
  }

  var sidebar = {
    transclude: true,
    controller: SidebarController,
    bindings: {},
    controllerAs: 'sidebar',
    templateUrl: 'components/ui-component/layout/sidebar/sidebar.html',
  };

  webapp.component('sidebar', sidebar);
})();

webapp.controller('CommonCodeController', [
  '$window',
  '$scope',
  '$element',
  '$compile',
  'GLOBAL_CONSTANT',
  'CommonAPISrv',
  'postApi',
  function CommonCodeController($window, $scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.paramData = {
      CommonCodeId: '',
      ParentCommonCodeId: '',
      CodeType: '',
      Code: '',
      CodeValue: '',
      CodeNm: '',
      TenantId: '',
      ArmyArea: '',
    };

    vm.data = {};

    vm.controlShow = true;

    vm.onChangeHandler = function () {
      if (vm.callback) {
        if (vm.data != null) {
          vm.callback(vm.data);
        } else {
          var data = vm.paramData;
          data.Code = '';
          vm.callback(data);
        }
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList() {
      if (
        vm.paramData == null ||
        ((vm.paramData.CodeType == null || vm.paramData.CodeType == '') &&
          (vm.paramData.ParentCommonCodeId == null || vm.paramData.ParentCommonCodeId == ''))
      ) {
        vm.list = [];
        return;
      }

      vm.data = vm.paramData;
      /* vm.data.userPermList = JSON.parse(
        $window.sessionStorage['loginGroupUId']
      ); */

      //        if (vm.useCache && vm.useCache == 'Y') {
      //          if (vm.paramData.CodeType == '1290' && $window.sessionStorage['CommonCodeList_ArmyArea'] != null) {
      //            vm.list = angular.fromJson($window.sessionStorage['CommonCodeList_ArmyArea']);
      //            return;
      //          } else if (vm.paramData.CodeType == '1010' && $window.sessionStorage['CommonCodeList_ArmyType'] != null) {
      //            vm.list = angular.fromJson($window.sessionStorage['CommonCodeList_ArmyType']);
      //            return;
      //          } else if (vm.paramData.CodeType == '1140' && $window.sessionStorage['CommonCodeList_PermStat'] != null) {
      //            vm.list = angular.fromJson($window.sessionStorage['CommonCodeList_PermStat']);
      //            return;
      //          }
      //        }

      var errorCallback = function (error) {
        console.log("error");
        // console.error('Error> common-code-ctrl> getSelectList()', status, error);
      };

      if (vm.paramData.CodeType == '1290') {
        postApi.api(
          'system/getArmyAreaCommonCodeList',
          vm.data,
          function (data) {
            var resultData = postApi.makeResultData(data);
            vm.list = resultData.body.docs;

            console.log("list : ", vm.list)

            // vm.list = data.body.docs;
            $window.sessionStorage['CommonCodeList_ArmyArea'] = JSON.stringify(vm.list);
            angular.forEach(vm.list, function (item) {
              if (item.Code == vm.paramData.Code) {
                vm.paramData = item;
                return false;
              }
            });

            if (vm.callback) {
              vm.callback(vm.paramData);
            }
          },
          errorCallback
        );
      } else if (vm.paramData.CodeType == '1010') {
        postApi.api(
          'system/getArmyTypeCommonCodeList',
          vm.data,
          function (data) {
            
            var resultData = postApi.makeResultData(data);
            vm.list = resultData.body.docs;

            // vm.list = data.body.docs;

            $window.sessionStorage['CommonCodeList_ArmyType'] = JSON.stringify(vm.list);
            angular.forEach(vm.list, function (item) {
              if (item.Code == vm.paramData.Code) {
                vm.paramData = item;
                return false;
              }
            });

            if (vm.callback) {
              vm.callback(vm.paramData);
            }
          },
          errorCallback
        );
      } else if (vm.paramData.CodeType == '1380') {
        postApi.api(
          'system/getPermStatCommonCodeList',
          vm.data,
          function (data) {
            var resultData = postApi.makeResultData(data);
            vm.list = resultData.body.docs;

            // vm.list = data.body.docs;
            $window.sessionStorage['CommonCodeList_ArmyType'] = JSON.stringify(vm.list);
            angular.forEach(vm.list, function (item) {
              if (item.Code == vm.paramData.Code) {
                vm.paramData = item;
                return false;
              }
            });

            if (vm.callback) {
              vm.callback(vm.paramData);
            }
          },
          errorCallback
        );
      } else {
        postApi.api(
          'system/getCommonCodeList',
          vm.data,
          function (data) {
            var resultData = postApi.makeResultData(data);
            vm.list = resultData.body.docs;
            // vm.list = data.body.docs;
            angular.forEach(vm.list, function (item) {
              if (item.Code == vm.paramData.Code) {
                vm.paramData = item;
                return false;
              }
            });

            if (vm.callback) {
              vm.callback(vm.paramData);
            }
          },
          errorCallback
        );
      }
    }
  },
]);

webapp.directive('commonCode', [
  '$compile',
  '$parse',
  '$window',
  function ($compile, $parse, $window) {
    return {
      transclude: true,
      restrict: 'E',
      scope: {
        paramData: '=',
        callback: '=',
        controlShow: '=',
        refreshData: '=',
        isDisabled: '=',
        useCache: '=',
      },
      templateUrl: 'scripts/directives/common-code/directive/common-code.html',
      controller: 'CommonCodeController as ccCtrl',
      link: function (scope, element, attrs, ctrl) {
        ctrl.callback = scope.callback;
        ctrl.useCache = scope.useCache;

        scope.$watchCollection('refreshData', function (value) {
          if (scope.refreshData != 0) ctrl.paramData.Code = '';
        });

        scope.$watchCollection('paramData', function (value) {
          //console.log('paramData watch');
          ctrl.paramData = scope.paramData;
          ctrl.getSelectList();
        });

        scope.$watchCollection('isDisabled', function (value) {
          //console.log('isDisabled=', scope.isDisabled);
          if (ctrl.isDisabled != undefined) ctrl.isDisabled = scope.isDisabled;
        });

        scope.$watchCollection('controlShow', function (value) {
          if (scope.controlShow != null) ctrl.controlShow = scope.controlShow;
        });
      },
    };
  },
]);

webapp.service('CommonAPISrv', [
  '$resource',
  'StaticVariable',
  '$rootScope',
  function CommonAPISrv($resource, StaticVariable, $rootScope) {
    var commonApi = {
      doComboCode: function () {
        return $resource(
          StaticVariable.getUrl('/api/system/getCommonCodeList.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doArmyArea: function () {
        return $resource(
          StaticVariable.getUrl('/api/system/getArmyAreaCommonCodeList.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doArmyType: function () {
        return $resource(
          StaticVariable.getUrl('/api/system/getArmyTypeCommonCodeList.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
      doPermStat: function () {
        return $resource(
          StaticVariable.getUrl('/api/system/getPermStatCommonCodeList.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        );
      },
    };
    return commonApi;
  },
]);

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    angular.module('salevis4-web')
        .component('sidebarSearch', {
            templateUrl: 'components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html',
            controller: function ($scope) {
                $scope.selectedMenu = 'home';
            }
        });
})();

(function () {
  'use strict';

  HeaderNotificationController.$inject = ['$log', '$window', 'LoginAPISrv', 'StaticVariable', 'GLOBAL_CONSTANT', 'gAlert', '$state', 'modalFactory', '$rootScope', 'postApi', '$filter', 'pay'];
  /** @ngInject */
  function HeaderNotificationController($log, $window, loginApi, StaticVariable, CONSTANT, gAlert, $state, modalFactory, $rootScope, postApi, $filter, pay) {
    var vm = this;
    vm.srch = {};
    vm.user = { UserName: $rootScope.gVariable.UserName };
    vm.doLogout = doLogout;
    vm.myPage = myPage;
    vm.checkUse = false;
    vm.tenantId = $window.sessionStorage.loginTenantId;
    vm.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];
    vm.TenantAdminYn = $window.sessionStorage['loginTenantAdminYn'];
    vm.goDetail = goDetail;
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.getUnReadContent = getUnReadContent;
    vm.goRemoteSupport = goRemoteSupport;
    vm.goDownLoadAndroid = goDownLoadAndroid;
    vm.getPayTenant = getPayTenant;

    // 기존로직 checkDemoUser 값이 false가 데모계정
    // vm.checkDemoUser = false;
    // if($window.sessionStorage["loginUserId"] != "guest") {
    //   vm.checkDemoUser = true;
    // }

    // 데모사용자 체크
    vm.checkDemoUser = false;
    if (!(vm.user.UserName.length >= 3 && vm.user.UserName.indexOf("데모") > -1)) {
      vm.checkDemoUser = true;
    }

    // 결제버튼 표시여부
    vm.PayBtnShow = false;
    if(vm.checkDemoUser == true && (vm.SysAdminYN == 'Y' || vm.TenantAdminYn == 'Y')){
    //if (vm.SysAdminYN == 'Y') {
      vm.PayBtnShow = true;
    }


    vm.sumUnReadCnt = 0;

    function doLogout() {
      StaticVariable.sessionExpire();
      var prms = loginApi.doLogout().post().$promise;
      prms.then(function (json) {
        var temp = {};
        temp.layoutBoard = "N";
        $window.sessionStorage.clear();
        $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
        gAlert('', 'Menu.SIGNEDOUT', {
          btn: '',
          fn: function () {

            if (M.app.check()) {
              $window.localStorage['userAuthKey'] = "";
              M.data.setStorage("loginUser", "");
            }

            //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
            //$state.reload('main.login');
            // $window.location.replace('/#/home/main');
            $window.location.href = "/";
          }
        });
      }, function (error) {
        console.log("error");
        // console.error('fail', status);
      });
    }

    /**
     * 내정보 수정 팝업 호출
     *
     */
    function myPage() {
      var ctrl = 'MyPageModalCtrl as modalCtrl';
      var paramData = { UserId: $rootScope.gVariable.UserId, TenantId: $window.sessionStorage["loginTenantId"] };
      var modalInstance = modalFactory.open("md", "components/modal/mypage/mypage-modal.html", ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          //성공
        },
        function (cancelData) {
          // 취소
        }
      );
    }

    function getSumUnReadCnt() {
      var data = angular.copy(vm.srch);
      data.SESSION_USERID = $rootScope.gVariable.UserId;
      data.ChatId = "1";
      data.mapCode = 'FreeChat.getSumUnReadCnt';
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.sumUnReadCnt = result.body.docs[0];
          } else {
            vm.sumUnReadCnt = 0;
          }
        }
        vm.dataloader = false;
      }
      );
    }

    function getUnReadContent() {
      getSumUnReadCnt();
      console.log('getUnReadContent');
      var data = angular.copy(vm.srch);
      data.SESSION_USERID = $rootScope.gVariable.UserId;
      data.mapCode = 'FreeChat.getUnReadContent';
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.unReadContentList = result.body.docs;
          }
        }
      });
    }

    /* setInterval(function(){
      getSumUnReadCnt();
    }, 3000); */

    //$scope.selectedRow = $stateParams.FreeChatId;

    function goDetail(FreeChatId) {
      angular.forEach(vm.unReadContentList, function (item) {
        if (item.FreeChatId == FreeChatId) {
          vm.unReadContentList = [];
          return;
        }
      });
      //var srch = $stateParams.srch;
      //$scope.selectedRow = FreeChatId;
      if (vm.layout == "N") {
        $state.go("app.chatting.h0201-roomdetail", {
          FreeChatId: FreeChatId
        });
      } else {
        $state.go("app.chatting.h0201-roomlist.detail", {
          FreeChatId: FreeChatId
        });
      }
    }

    /**
     * 원격지원   
     */
    function goRemoteSupport() {
      var url = 'http://320.co.kr/';

      $window.open(url, 'winRemoteSupport');
    }

    function goDownLoadAndroid() {
      var ctrl = 'DownLoadApk as modalCtrl';
      var paramData = {

      };

      var modalInstance = modalFactory.open('md', 'components/modal/apk/download-apk-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {

      }, function (cancelData) {

        // 닫기 
      });

    }

    function getPayTenant() {
      var paramData = {};
      paramData.TenantId = $window.sessionStorage["loginTenantId"];
      paramData.mapCode = "Pay.getPayTenant";
      postApi.select(paramData, function (result) {
        if (result.body.docs.length > 0) {
          if (result.body.docs[0].PayType == "20") {
            vm.PayMonEnd = "무제한";
          }
          else {
            if (!isNullOrEmpty(result.body.docs[0].ServiceExpireDate)) {
              var week = ['일', '월', '화', '수', '목', '금', '토'];
              //vm.PayMonEnd = result.body.docs[0].ServiceExpireDate;
              vm.PayMonEnd = !isNullOrEmpty(result.body.docs[0].ServiceExpireDate) ? $filter('autoViewUtcToLocal')(result.body.docs[0].ServiceExpireDate).substr(0, 10) : "";  
              //vm.PayMonEndDay = "(" + week[new Date(result.body.docs[0].ServiceExpireDate).getDay()] + ")";
            }
          }
          vm.ServPoint = pay.setComma(result.body.docs[0].ServPoint);
        }
      }, function (error) {
        av.alert("회원사 정보를 불러오는데 실패하였습니다.");
        console.table(error);
        vm.dataloader = false;
      });
    }

    // 결제팝업
    vm.payModal = function () {
      var ctrl = 'PayModalCtrl as vc';
      var paramData = {};

      var modalInstance = modalFactory.open('mf-75', 'components/modal/pay/pay-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        // ok버튼
      }, function (cancelData) {
        // cancel버튼
      });
    };

    //getSumUnReadCnt();

  } // End Controller

  var header = {
    transclude: true,
    controller: HeaderNotificationController,
    bindings: {},
    controllerAs: "vc",
    templateUrl: 'components/ui-component/layout/header/header-notification/header-notification.html'
  };

  webapp.component("headerNotification", header);

})();

angular.module("salevis4-web").run(["$templateCache", function($templateCache) {$templateCache.put("common_error.html","<html><head><title>Salevis Care - 헬스케어 CRM</title><link href=https://cloud.sscrm.co.kr/Styles/CommonStyle.css rel=stylesheet><!-- 404에러 --><link href=https://cloud.sscrm.co.kr/Styles/CommonStyleNew.css rel=stylesheet><!-- 공통에러 --></head><body><div width=100%><div id=pnCommon><div class=blackout><strong>시스템 사용중 불편을 끼쳐 드려서 죄송합니다.</strong><p>요청하신 작업을 처리 중 오류가 발생하였습니다.<br>자세한 사항은 소프트자이온 고객센터로 문의하시기 바랍니다.<br>문의전화: <span>070-5001-0869</span></p><div class=submitbtn><button type=button class=\"skinbtn default btn-m2\" onclick=history.back()><b>뒤로가기</b></button></div></div></div></div></body></html>");
$templateCache.put("error.html","<meta charset=utf-8><title>:::상담 온라인시스템:::</title><link rel=stylesheet type=text/css href=/assets/css/error.css><div class=error><h1 class=logo><img src=/assets/images/error/logo_wh.png alt=로고이미지></h1><div class=error_box><p class=img><img src=/assets/images/error/img_errorpage.png alt=에러이미지></p><strong>페이지를 이용하실 수 없습니다</strong><p>페이지에 일시적인 오류가 있거나 정상적인 경로가 아닙니다.<br>입력하신 주소가 정확한지 확인 후 다시 시도해 주시기 바랍니다.<br></p><a class=btn_error href=/#/app/dashboard>메인으로 이동</a></div></div>");
$templateCache.put("index.html","<!DOCTYPE html><html ng-app=salevis4-web ng-controller=MainCtrl class=\"no-js {{containerClass}}\" lang=ko><head><meta charset=utf-8><meta name=apple-mobile-web-app-capable content=yes><title>일자리지원 상담 시스템</title><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- IE favicon focing[only for IE] --><link rel=icon type=image/ico href=\"favicon.ico?v=2\"><link rel=\"shortcut icon\" type=image/ico href=\"favicon.ico?v=2\"><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><!-- run `gulp inject` to automatically populate bower styles dependencies --><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><!-- css files will be automatically insert here --><!-- endinject --><!-- endbuild --><script>(function(j,ennifer) {\r\n          j[\'dmndata\']=[];j[\'jenniferFront\']=function(args){window.dmndata.push(args)};\r\n          j[\'dmnaid\']=ennifer;j[\'dmnatime\']=new Date();j[\'dmnanocookie\']=false;j[\'dmnajennifer\']=\'JENNIFER_FRONT@INTG\';\r\n      }(window, \'661c335d\'));</script><script async src=https://d-collect.jennifersoft.com/661c335d/demian.js></script></head><body id=minovate class=\"{{main.settings.navbarHeaderColor}} {{main.settings.activeColor}} {{containerClass}} header-fixed aside-fixed appWrapper\" [ng-class]=\"{\'header-fixed\': main.settings.headerFixed, \'header-static\': !main.settings.headerFixed, \'aside-fixed\': main.settings.asideFixed, \'aside-static\': !main.settings.asideFixed}\"><div ui-view id=wrap><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><!-- run `gulp inject` to automatically populate bower script dependencies --><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><!-- js files will be automatically insert here --><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link href=https://unpkg.com/aos@2.3.1/dist/aos.css rel=stylesheet><link rel=stylesheet href=assets/css/intro-style.css><!-- <link rel=\"stylesheet\" href=\"assets/css/common.css\" /> --><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/scheduler.min.css><link rel=stylesheet href=assets/css/timedropper.css><link rel=stylesheet href=assets/css/time-picker.css><link rel=stylesheet href=assets/css/select2.min.css><link rel=stylesheet href=assets/css/main.css><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=https://service.iamport.kr/js/iamport.payment-1.1.4.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/scheduler.min.js></script><script src=assets/app/common/contextMenu.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/select2.min.js></script><script src=assets/app/vendor/footable/js/footable.js></script><script src=assets/js/convertKoEn.js></script><script src=https://unpkg.com/aos@2.3.1/dist/aos.js></script><script src=https://cdn.plot.ly/plotly-latest.min.js></script><script src=https://cdn.plot.ly/plotly-2.4.2.min.js></script><script type=text/javascript src=https://d3js.org/d3.v2.min.js></script><!--네이버 애널리틱스--><script type=text/javascript src=//wcs.naver.net/wcslog.js></script><script type=text/javascript>if(!wcs_add) var wcs_add = {};\r\n      wcs_add[\"wa\"] = \"98e18ba1d0e5e0\";\r\n      if(window.wcs) {\r\n      wcs_do();\r\n      }</script><!--  <script\r\n      type=\"text/javascript\"\r\n      src=\"//dapi.kakao.com/v2/maps/sdk.js?appkey=2e0899dbcd8c63032cf0a188b89909c2&libraries=services,clusterer\"\r\n    ></script>\r\n    <script\r\n      type=\"text/javascript\"\r\n      src=\"//dapi.kakao.com/v2/maps/sdk.js?appkey=2e0899dbcd8c63032cf0a188b89909c2\"\r\n    ></script> --></body></html>");
$templateCache.put("app/app.html","<div id=wrapper><!-- Navigation --><!-- <div ui-view=\"header\"></div> --><section id=header class={{main.settings.navbarHeaderColor}}><header class=clearfix></header></section><!-- /.navbar-top-links --><!-- /.navbar-static-side --><sidebar></sidebar><div id=content ui-view-container class=view-container style=\"min-height: 561px\"><div ui-view></div></div><!-- /#page-wrapper --></div>");
$templateCache.put("app/pop.html","<div class=wrapper style=\"min-height: 561px\"><div ui-view></div></div>");
$templateCache.put("app/board/bbs-master-detail.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>게시판 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><!-- <div class=\"col-lg-4 col-md-6\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>마스터아이디</label>\r\n                  <div class=\"form-control txt_view\" ng-bind=\"vc.data.BbsMasterId\"></div>\r\n                </div>\r\n              </div> --><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>정렬순서</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsSort></div></div></div><!-- <div class=\"col-lg-4 col-md-6\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>메타테이블 TableNm</label>\r\n                  <div class=\"form-control txt_view\" ng-bind=\"vc.data.MetatableNm\"></div>\r\n                </div>\r\n              </div> --><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판메뉴표시권한</label><div class=form-group><label class=\"radio-inline pl-0 pr-15\" ng-repeat=\"item in vc.RoleList\"><input type=checkbox class=clr ng-model=item.checked ng-disabled=true> {{item.RoleNm}}</label></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=\"vc.data.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'\"></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-edit.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>게시판 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- <div class=\"col-lg-4 col-md-6\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>마스터아이디</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.BbsMasterId\" readonly>\r\n                  </div>\r\n                </div> --><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><input type=text class=form-control ng-model=vc.data.BbsNm></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.data.BbsSort></div></div><!-- <div class=\"col-lg-4 col-md-6\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>메타테이블 TableNm</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.MetatableNm\">\r\n                  </div>\r\n                </div> --><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판메뉴표시권한</label><div class=form-group><label class=\"radio-inline pl-0 pr-15\" ng-repeat=\"item in vc.RoleList\"><input type=checkbox class=clr ng-model=item.checked> {{item.RoleNm}}</label></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Remark></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=form-control ng-bind=\"vc.data.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'\" readonly></div></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-list.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>게시판 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.BbsNm placeholder=\"게시판명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><!-- <div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer();\">\r\n                  <span class=\"cursor\" id=\"btn_layer_detail_search_open\">상세<i class=\"fa fa-caret-down\"></i></span>\r\n                </div> --> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.BbsNm type=text><label>게시판명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>게시판관리</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><!-- <th ng-click=\"vc.tablesort(\'X.BbsMasterId\')\" data-toggle=\"true\" class=\"text-center\">마스터아이디 <span class=\"{{vc.sortClass(\'X.BbsMasterId\')}}\"></span></th> --><th ng-click=\"vc.tablesort(\'X.BbsNm\')\" data-toggle=true class=text-center>게시판명 <span class=\"{{vc.sortClass(\'X.BbsNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.BbsSort\')\" data-toggle=true class=text-center>정렬순서 <span class=\"{{vc.sortClass(\'X.BbsSort\')}}\"></span></th><!-- <th ng-click=\"vc.tablesort(\'X.MetatableNm\')\" data-toggle=\"true\" class=\"text-center\">메타테이블 TableNm <span class=\"{{vc.sortClass(\'X.MetatableNm\')}}\"></span></th> --><th ng-click=\"vc.tablesort(\'X.RegUserNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC03\' | translate }} <span class=\"{{vc.sortClass(\'X.RegUserNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegDate\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC04\' | translate }} <span class=\"{{vc.sortClass(\'X.RegDate\')}}\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsMasterId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':vc.keyId == li.BbsMasterId}\"><!-- Result Items --><!-- <td class=\"text-center\"><span ng-bind=\"li.BbsMasterId\"></span></td> --><td class=text-center><span ng-bind=li.BbsNm></span></td><td class=text-center><span ng-bind=li.BbsSort></span></td><!-- <td class=\"text-center\"><span ng-bind=\"li.MetatableNm\"></span></td> --><td class=text-center><span ng-bind=li.RegUserNm></span></td><td class=text-center><span>{{li.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span></td></tr></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0101-detail.html","<div class=\"page page-footable\" ng-controller=\"H0101DetailCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.BOARDLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a href=javascript:;>{{ \'Menu.BOARD\' | translate }}</a></li><li><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\">{{ vc.BoardNm }}</a></li></ul></div></div><!-- /page header --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong></h4><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 ml-5\" activate-button ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 ml-5\" activate-button ui-sref=\"app.bbspost.h0101-edit({BoardId:\'{{vc.srch.BoardId}}\', FreeBoardId:\'{{vc.srch.FreeBoardId}}\'})\" ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 ml-5\" activate-button ng-click=vc.deleteDetail() ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.TITLE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Title readonly></div></div></div><!-- row --><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.NUMBER\' | translate }}</label><input type=text class=form-control ng-model=vc.data.FreeBoardId readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.REGDATE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.RegDate readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.REGUSER\' | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>첨부파일</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col width=*><col width=140px><col width=140px></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.CONTENTS\' | translate }}</label><span ng-bind-html=vc.data.Contents|htmlString></span></div></div></div></div><!-- row --></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong></h4><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- tile header --><!-- tile body --><div class=tile-body><div class=\"tile-body streamline p-0\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><aside><div class=\"thumb thumb-sm\"><img class=img-circle src=users/{{gVariable.UserId}}.png alt=\"\"></div></aside><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}}<!-- {{ \'Menu.RegUserNm\' | translate }} --> <span class=text-muted><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.FreeBoardCommId == vc.comment.editid\"><button class=\"btn btn-default btn-xs\" ng-click=vc.editComment(li.FreeBoardCommId) ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-default btn-xs\" ng-click=vc.deleteComment(li) ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.FreeBoardCommId == vc.comment.editid\"><button class=\"btn btn-default btn-xs\" ng-click=vc.editCommentAction(li) ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn btn-default btn-xs\" ng-click=vc.editCommentCancel() ng-disabled=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.FreeBoardCommId == vc.comment.editid\">{{li.Contents}}<br><a href=\"/attach/file/{{li.PhysicalFileNm}}/download.do?path={{li.PhysicalFolderNm}}&fileName={{li.LogicalFileNm}}&userkey={{$root.gVariable.userkey}}\">{{li.LogicalFileNm}}</a></div><div class=panel-body ng-show=\"li.FreeBoardCommId == vc.comment.editid\"><textarea id=strReply rows=10 style=\"width: 80%; height: 40px\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><div class=\"thumb thumb-sm\"><img class=img-circle src=users/{{$root.gVariable.UserId}}.png alt=\"\"></div><form class=\"ng-pristine ng-valid\"><div class=input-group><input type=text class=form-control placeholder=\"Write your comment here...\" ng-model=vc.srchComment.Contents> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div><div><table class=\"table b-a b-solid bg-white\"><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListComment\"><td><span ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></span> <a href={{obj.link}} target=attach ng-show=obj.isLoaded><span class=file_list ng-bind=obj.fileName></span></a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\' \" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></div></form></div></div></div><div class=tile-body style=\"height: 50px\"></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/h0101-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><script src=https://cdn.jsdelivr.net/npm/dompurify@3.0.6/dist/purify.min.js></script><div class=\"page page-footable\" ng-controller=\"H0101EditCtrl as vc\" id=h0101-edit-ctrl><!-- page header --><div class=pageheader><h2>{{ \'Menu.BOARDLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a href=javascript:void(0);>{{ \'Menu.BOARD\' | translate }}</a></li><li><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\">{{ vc.BoardNm }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.saveDetail()><i class=\"fa fa-check\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.TITLE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Title id=Title></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><file-attach file-data=vc.data.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label for=name class=control-label>{{ \'Menu.CONTENTS\' | translate }}</label><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- /tile body --></div></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : false, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/h0101-list.html","<div class=\"page page-footable\" ng-controller=\"H0101ListCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.BOARDLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a href=javascript:;>{{ \'Menu.BOARD\' | translate }}</a></li><li><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\">{{ vc.BoardNm }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=dataTables_length id=DataTables_Table_0_length style=\"margin-right: 1px\"><input type=text class=form-control ng-model=vc.srch.Title placeholder=\"{{ \'Menu.ENTERTITLE\' | translate }}\"><!-- input id=filter 인 경우 table filtering 됨 --></div></div><div class=col-lg-2 style=\"padding-top: 7px\"><md-checkbox md-no-ink=\"\" aria-label=\"{{ \'Menu.INCLUDECONTENT\' | translate }}\" ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ \'Menu.INCLUDECONTENT\' | translate }}</md-checkbox></div><div class=col-lg-6><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getList()><i class=\"fa fa-search\"></i> {{ \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-darkgray btn-ef btn-ef-7b mb-10 mr-5\"><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETSEARCH\' | translate }}<!-- 입력값 초기화 후 자동 리스트 재조회 --></button><!-- <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=\"vc.getExcel()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{ \'Menu.EXCEL\' | translate }}\r\n                  </button> --> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.bbspost.h0101-edit({BoardId:\'{{vc.srch.BoardId}}\', FreeBoardId:\'\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div></div></div></div></div></div><!-- row --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>{{ \'Menu.LIST\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div id=DataTables_Table_0_wrapper class=\"dataTables_wrapper form-inline no-footer\"><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true>{{ \'Menu.NUMBER\' | translate }}</th><th data-toggle=true>{{ \'Menu.TITLE\' | translate }}</th><th data-toggle=true class=text-center>{{ \'Menu.REGDATE\' | translate }}</th><th data-toggle=true class=text-center>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><th style=\"width: 100px\" class=text-center>{{ \'Menu.VIEWS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" ui-sref=\"app.bbspost.h0101-detail({BoardId:\'{{li.BoardId}}\', FreeBoardId:\'{{li.FreeBoardId}}\'})\" style=\"cursor: pointer\" my-directive><td><span ng-bind=li.FreeBoardId></span></td><td><span ng-bind=li.Title></span></td><td class=text-center><span ng-bind=li.RegDate></span></td><td class=text-center><span ng-bind=li.RegUserNm></span></td><td class=text-center><span ng-bind=li.ReadCnt></span></td></tr></tbody><tfoot><tr><td colspan=5 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() template-url=components/template/pagination.html max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div><!-- /tile body --></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-detail.html","<div class=\"page page-footable\" ng-controller=\"H0102DetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{vc.BbsNm}}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent ng-if=vc.ShowContents><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>&nbsp;</label><label><input type=checkbox class=clr ng-model=vc.data.NoticeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-disabled=true> {{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><!-- <common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=\"vc.data.NoticeYN\"></common-code-custom> --></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>&nbsp;</label><label><input type=checkbox class=clr ng-model=vc.data.PublicYN ng-true-value=\"\'N\'\" ng-false-value=\"\'Y\'\" ng-disabled=true> {{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><!-- <common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=\"vc.data.PublicYN\"></common-code-custom> --></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.RegUserNm></span></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label></div><div class=form-control-no-border></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=form-control-border><span class=txt_view ng-bind-html=vc.data.Contents|htmlString></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-show=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label\" style=height:40px><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div class=pagecontent ng-if=vc.ShowPwd><div class=row><div class=col-lg-12><div class=\"body ng-scope\"><div class=row><div class=\"mgt50 pw_field\"><h2 class=mgb30>비밀글입니다</h2><input type=password class=\"form-control mgb30\" ng-model=vc.PostPwd maxlength=10 placeholder=\"비밀번호를 입력해주세요\"><div class=\"ng-scope btn_wrap\"><button class=\"btn btn-primary mgr05\" ng-click=vc.chkPwd()><i class=\"fa fa-edit\"></i> 확인</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"H0102EditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{vc.BbsNm}}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상세정보 추가/수정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form name=theForm><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=theForm.Title.$invalid>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 required></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>&nbsp;</label><label><input type=checkbox class=clr ng-model=vc.data.NoticeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> {{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><!-- <common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=\"vc.data.NoticeYN\"></common-code-custom> --></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>&nbsp;</label><label><input type=checkbox class=clr ng-model=vc.data.PublicYN ng-true-value=\"\'N\'\" ng-false-value=\"\'Y\'\"> {{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><!-- <common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=\"vc.data.PublicYN\"></common-code-custom> --></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.data.PublicYN == \'N\'\"><div class=\"form-group form-inline\"><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PostPwd maxlength=10 placeholder=비밀번호입력></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.ReadCnt readonly></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef: oEditors,\r\n    elPlaceHolder: \"strHtml\",\r\n    sSkinURI: \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams: {\r\n      bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer: false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload: function () {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE: sLang\r\n    }, //boolean\r\n    fOnAppLoad: function () {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator: \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/h0102-list.html","<div class=\"page page-footable\" ng-controller=\"CustomerarmyListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>고객 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>내담자관리</a></li><li><a>고객관리</a></li><li><a>고객목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>권역</label><common-code param-data=vc.ArmyAreaList callback=vc.onArmyAreaListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.srch.Mobile placeholder=휴대폰></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>1차상담희망일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstHopeDateFrom ng-change=\"vc.srch.FirstHopeDateFrom = (dtFirstHopeDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담희망 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstHopeDateTo ng-change=\"vc.srch.FirstHopeDateTo = (dtFirstHopeDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담희망 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담신청등록자</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담신청등록자 ng-value=vc.srch.CounselAppliRegUser_> <input type=hidden ng-value=vc.srch.CounselAppliRegUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselAppliRegUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselAppliRegUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>상담신청등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselAppliRegDateFrom ng-change=\"vc.srch.CounselAppliRegDateFrom = (dtCounselAppliRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담신청등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselAppliRegDateTo ng-change=\"vc.srch.CounselAppliRegDateTo = (dtCounselAppliRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담신청등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>1차상담확정일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDateFrom ng-change=\"vc.srch.FirstDecDateFrom = (dtFirstDecDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담확정 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDateTo ng-change=\"vc.srch.FirstDecDateTo = (dtFirstDecDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담확정 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.CounselUser_> <input type=hidden ng-value=vc.srch.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>추가정보메모</label><input type=text class=form-control ng-model=vc.srch.AddMemo placeholder=추가정보메모></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>등록자</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=등록자 ng-value=vc.srch.CustArmyRegUser_> <input type=hidden ng-value=vc.srch.CustArmyRegUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustArmyRegUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCustArmyRegUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담메모</label><input type=text class=form-control ng-model=vc.srch.CounselMemo placeholder=상담메모></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담분야</label><common-code param-data=vc.CounselField1List callback=vc.onCounselField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>&nbsp;</label><common-code param-data=vc.CounselField2List callback=vc.onCounselField2ListSelected></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><common-code param-data=vc.HopeDutyList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc placeholder=희망직무기타></div></div><div class=col-lg-2 ng-show=HopeLocListShow1><div class=form-group><label>희망지역</label><common-code param-data=vc.HopeLocList1 callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>희망지역(해외)</label><common-code param-data=vc.HopeLocList2 callback=vc.onSelectCallback></common-code></div></div><!-- \r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>연동여부</label>\r\n                  <common-code param-data=\"vc.LinkageYNList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n               --></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.showModalEmail() ng-show=showBtnEmail><i class=\"fa fa-search\"></i> 선택이메일발송</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.customer.customerarmy-edit({CustArmyId:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button><!-- \r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.getExcelForWork()\" ng-show=\"showBtnExcel\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> 취업엑셀(교육원업로드용)\r\n                  </button>\r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.updateLinkageYNList()\" ng-show=\"showBtnLinkageYN\">\r\n                    <i class=\"fa fa-edit\"></i> 연동완료처리\r\n                  </button>\r\n                   --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults ui-jq=footable data-filter=#filter data-page-size=100 data-pagination=true class=\"footable table table-custom\"><thead><tr><th data-sort-ignore=true class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th data-toggle=true class=text-center>번호</th><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>계급</th>\\<th data-toggle=true class=text-center>소속부대</th><th data-toggle=true class=text-center>소속(사,여단급)</th><th data-toggle=true class=text-center>상담희망분야</th><th data-toggle=true class=text-center>상담사</th><th data-toggle=true class=text-center>등록일</th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=10 class=text-center>데이터가 없습니다.</td></tr><tr></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.viewSize)}}</td><td ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustNm></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyNo></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyClass_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.HopeField_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselUser_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustArmyRegDate></span></td></tr></tbody><tfoot><tr><td colspan=9 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-mlist.html","<div class=\"page page-footable\" ng-controller=\"H0102ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ :: \'Menu.h0102\' | translate }}</h1><div class=\"pull-right dock-header-tx\"><span ng-click=\"vc.setResponsive(\'default\')\">기본</span> <span ng-click=\"vc.setResponsive(\'vertical\')\">좌우</span> <span ng-click=\"vc.setResponsive(\'horizon\')\">상하</span></div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div id=dockWrap><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">{{ :: \'Menu.SEARCH\' | translate }} {{ :: \'Menu.CONDITION\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-4 col-sm-8 col-xs-8\"><div class=\"form-group form-inner-label\" ng-show=vc.srch.searchColumns.Title><input type=text class=\"form-control form-right\" ng-model=vc.srch.Title><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ :: \'Menu.INCLUSION_OF_CONTENT\' | translate }}</md-checkbox></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATEFROM\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateTo ng-change=\"vc.srch.RegDateTo = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATETO\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><input type=text class=form-control ng-show=vc.srch.searchColumns.RegUser_ ng-model=vc.srch.RegUser_ placeholder=등록자></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}<!-- 입력값 초기화 후 자동 리스트 재조회 --></button></div></div></div></div></div></div></div><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead></thead><tbody></tbody></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /dockWrap --></div><!-- /page content --></div><ui-view></ui-view>");
$templateCache.put("app/board/notice-board-detail.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Title></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.EdtUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BoardType></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.PublicYNNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.NoticeYNNm></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Tags></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: 50%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span style=text-align:center ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td><span style=text-align:center class=file_size ng-bind=fli.size|filesize></span></td><td><span style=text-align:center class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" style=\"height:100px; overflow-y: hidden\" ng-bind-html=vc.data.Contents|htmlString></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-show=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label\" style=height:40px><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/notice-board-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"NoticeBoardEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.data.BoardType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Tags></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div style=\"margin-left: 85px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=\"margin: 0px\"><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form><div class=row><!-- 사용자정의 컬럼 등록/수정 --><div class=\"form-group form-inline\"><form class=\"ng-pristine ng-valid\" ng-submit=\"\" name=vc.udcForm novalidate><formly-form model=vc.udcModel fields=vc.udcColumns options=vc.udcOptions form=vc.udcForm></formly-form></form></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \'ko_KR\'; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef: oEditors,\r\n    elPlaceHolder: \'strHtml\',\r\n    sSkinURI: \'assets/app/.9/SmartEditor2Skin.html\',\r\n    htParams: {\r\n      bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer: false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload: function () {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE: sLang,\r\n    }, //boolean\r\n    fOnAppLoad: function () {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator: \'createSEditor2\',\r\n  });</script>");
$templateCache.put("app/board/notice-board.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>PR Center 게시판<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Contents type=text><label>{{ :: \'Menu.CONTENTS\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.tablesort(\'T.\'+liCol.ColumnPhysicalNm)\" data-toggle=true style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{liCol.ColumnLogicalNm}} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsPostId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':vc.keyId == li.BbsPostId}\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnPhysicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd h:mm a\')}}</td></tr></tbody></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/popup-list.html","<div class=\"page page-footable\" ng-controller=\"PopupListCtrl as vc\"><!-- page header --><div class=\"row rel\"><div class=col-lg-12><div class=page-header>팝업 list<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=row><!-- 사용자 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>사용자명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 사용자 검색 끝--><!-- 단품(제품)조회 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>단품 조회</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.ProductNm placeholder=품목명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalPrd()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearPrd()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!--단품(제품)조회 끝--><!-- 주소검색 (다음) --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input type=text id=zipCode class=form-control ng-model=vc.srch.ZipCode readonly> {{vc.srch.ZipCode}} <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.getAddressInfo()><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 wd85\"><div class=form-group><input type=text id=addr1 ng-model=vc.srch.Addr1 class=form-control readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input type=text id=addr2 ng-model=vc.srch.Addr2 class=form-control></div></div></div><!-- 주소검색 (다음) --><!-- 관리권 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>관리권명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CareTktNm placeholder=관리권명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCareTkt()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCareTkt()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 관리권 검색 끝--><!-- 고객 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>고객명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=고객명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCustomer()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCustomer()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 고객 검색 끝--></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/recom-detail.html","<div class=\"page page-footable\" ng-controller=\"RecomDetailCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.BOARDLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a href=javascript:;>{{ \'Menu.BOARD\' | translate }}</a></li><li><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'{{vc.srch.BoardId}}\'})\">{{ vc.BoardNm }}</a></li></ul></div></div><!-- /page header --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong></h4><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 ml-5\" activate-button ui-sref=app.bbspost.recom-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.TITLE\' | translate }}</label>&nbsp; <span ng-bind-html=vc.data.JR_SUBJECT|htmlString></span> ~<span ng-bind=vc.data.JR_CLOSE_DATE></span></div></div></div><!-- row --><div class=row><div class=col-lg-4><div class=form-group><label>작성자</label>&nbsp; <span ng-bind=vc.data.REG_ID></span></div></div><div class=col-lg-4><div class=form-group><label>조회수</label>&nbsp; <span ng-bind=vc.data.JR_CNT></span></div></div><div class=col-lg-4><div class=form-group><label>작성일</label>&nbsp; <span ng-bind=vc.data.REG_DATE></span></div></div></div><!-- row --><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>전직교육원 채용정보 URL</label><a href={{vc.data.CONTENT_URL}}><span ng-bind=vc.data.CONTENT_URL></span></a></div></div></div><!-- row --><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.CONTENTS\' | translate }}</label><span ng-bind-html=vc.data.CONTENT|htmlString></span></div></div></div><!-- row --><div class=row><div class=col-lg-12><div class=form-group><label>첨부파일</label><a href=\"\" ng-click=\"vc.fncFileDown(\'recruit_recom\', vc.data.JR_FILE_NAME)\"><span ng-bind=vc.data.JR_FILE_NAME></span></a></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 ml-5\" activate-button ui-sref=app.bbspost.recom-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div></div><!-- row --></div></div></div><!-- /row --></div><!-- /page content --></div><iframe id=ifrmDown name=ifrmDown width=0 height=0 style=visibility:hidden></iframe><form name=frm_filedown method=post target=ifrmDown><input type=hidden name=fileurl> <input type=hidden name=filename></form>");
$templateCache.put("app/board/recom-list.html","<div class=\"page page-footable\" ng-controller=\"RecomListCtrl as vc\"><!-- page header --><div class=pageheader><h2>전직교육원 제공 채용정보</h2><div class=page-bar><ul class=page-breadcrumb><!-- <li><a ui-sref=\"app.dashboard\"><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li> --><li><a href=javascript:;>{{ \'Menu.BOARD\' | translate }}</a></li><li><a ui-sref=\"app.bbspost.h0102-list({BoardCode:\'{{ht.srch.BoardCode}}\'})\">전직교육원 제공 채용정보</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-xs-4><select class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=vc.srch.Schfield><option value=\"\" selected>-선택-</option><option value=JR_SUBJECT>제목</option><option value=REG_DATE>작성일</option><option value=CONTENTS>본문</option><option value=ALL>제목+본문</option></select></div><div class=col-xs-4><input type=text class=form-control ng-model=vc.srch.Schword placeholder=\"\"></div><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ \'Menu.SEARCH\' | translate }}</button></div></div></div></div></div></div></div><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><ul class=\"nav nav-tabs mb-15\"><li id=liTab1 class=active><a href ng-click=\"setTab(\'\')\">최신정보순</a></li><li id=liTab2><a href ng-click=\"setTab(\'closeday\')\">마감일순</a></li><li id=liTab3><a href ng-click=\"setTab(\'overday\')\">마감일지난채용정보</a></li></ul><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4><div class=pull-right><!-- \r\n              <label> {{ \'Menu.LIST\' | translate }} &nbsp; <select name=\"DataTables_Table_0_length\" aria-controls=\"DataTables_Table_0\" ng-model=\"vc.srch.viewSize\" ng-change=\"vc.changeViewSize()\"\r\n                ng-options=\"c for c in vc.listSize\" class=\"input-sm\">\r\n              </select>\r\n              </label>\r\n             --></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div id=DataTables_Table_0_wrapper class=\"dataTables_wrapper form-inline no-footer\"><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true>{{ \'Menu.NUMBER\' | translate }}</th><th data-toggle=true>{{ \'Menu.TITLE\' | translate }}</th><th data-toggle=true class=text-center>첨부파일</th><th data-toggle=true class=text-center>작성일</th><th style=\"width: 100px\" class=text-center>{{ \'Menu.VIEWS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td><span ng-bind=\"vc.totalItems - li.RNUM + 1\"></span></td><td ui-sref=\"app.bbspost.recom-detail({p_seq:\'{{li.JR_AB_SEQ}}\'})\" style=\"cursor: pointer\"><span ng-bind-html=li.JR_SUBJECT></span> ~<span ng-show=\"li.JR_CLOSE_DATE.substring(4,5) != 0\" ng-bind=li.JR_CLOSE_DATE.substring(5,6)></span><span ng-bind=li.JR_CLOSE_DATE.substring(6,7)></span>.<span ng-bind=li.JR_CLOSE_DATE.substring(8,10)></span> <img src=https://moti.or.kr/html/main/i_new.gif width=12 height=11 style=\"vertical-align: middle\" ng-show=\"li.REG_DATE > vc.srch.beforeDay3\"> <img src=https://moti.or.kr/html/imgs/gun.gif width=12 height=11 style=\"vertical-align: middle\" ng-show=\"li.JR_GUN_CONSI == \'1\'\"></td><td class=text-center><span ng-show=\"li.JR_FILE_NAME != \'\'\"><a href=\"\" ng-click=\"vc.fncFileDown(\'recruit_recom\', li.JR_FILE_NAME)\">다운로드</a></span></td><td class=text-center><span ng-bind=li.REG_DATE.substring(0,4)></span>-<span ng-bind=li.REG_DATE.substring(4,6)></span>-<span ng-bind=li.REG_DATE.substring(6,8)></span></td><td class=text-center><span ng-bind=li.JR_CNT></span></td></tr></tbody><tfoot><tr><td colspan=5 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div><!-- /tile body --></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div><iframe id=ifrmDown name=ifrmDown width=0 height=0 style=\"visibility: hidden\"></iframe><form name=frm_filedown method=post target=ifrmDown><input type=hidden name=fileurl> <input type=hidden name=filename></form>");
$templateCache.put("app/boardmng/boardmng-detail.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-detail_bak.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</h1></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-edit.html","<div class=\"page page-footable\" id=toastContainer><div class=dataloader ng-show=boardMngSave.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.EDIT\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><form name=metaTable><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{boardMngSave.makeSrch()}}\'})\" ng-if=\"boardMngSave.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\" metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=\"boardMngSave.currentActionView==\'modify\'\"><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=boardMngSave.metaTable.tableNm></div></div><div class=form-group ng-if=\"boardMngSave.currentActionView==\'add\'\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><input class=\"form-control pre\" name=tableNm ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-maxlength=100 ng-minlength=3 ng-model=boardMngSave.metaTable.tableNm ng-model-options=\"{ updateOn: \'blur\' }\" ng-required=true type=text><div ng-show=metaTable.tableNm.$error.minlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA01\' | translate }}</div><div ng-show=metaTable.tableNm.$error.maxlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA02\' | translate }}</div><div ng-show=\"boardMngSave.usingTableNm.length > 0\" class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{boardMngSave.usingTableNm}} {{ \'Menu.EM710VA03\' | translate }}</div></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label><span style=\"color: red\">* </span>모듈유형</label><common-code-custom code-list=boardMngSave.moduleTypeList code-model=boardMngSave.metaTable.moduleType ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-required=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=boardMngSave.metaTable.tableDesc ng-disabled=\"$root.gVariable.srchTenantId != 0\"></textarea></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=boardMngSave.openSortMetaColumn() ng-if=\"boardMngSave.metaTable.metaColumns.length > 0\" type=button><i class=\"fa fa-edit\"></i> 컬럼 표시순서 정렬</button></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6\" ng-init=\"boardMngSave.viewType = \'D\'\"><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=boardMngSave.viewType value=L ng-click=\"boardMngSave.viewType = \'L\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 리스트</label><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=boardMngSave.viewType value=D ng-click=\"boardMngSave.viewType = \'D\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 상세</label><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=boardMngSave.viewType value=S ng-click=\"boardMngSave.viewType = \'S\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 검색박스</label><div style=\"margin-top: 14px; color: #FF0000; font-size: 20px; margin-bottom: 20px; font-weight: bold\">* 검색박스의 표시섹션, 폼그룹설정은 아직 작업 진행 중입니다. 백번, 천번 저장해도 헛수고!!! 참고하세요.</div></div><div class=pull-right style=\"height: 100%\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-if=\"$root.gVariable.srchTenantId != \'0\'\" ng-click=boardMngSave.ChangeCustomColumn() ng-checked=\"boardMngSave.metaTable.metaColumns.length == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox style=\"margin-right: 30px\">{{ \'Menu.CUSTOMCOLUMN\' | translate }}</md-checkbox><button type=button class=\"btn btn-default\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\" ng-disabled=\"metaTable.tableNm.$invalid && boardMngSave.currentActionView ==\'add\'\" ng-click=boardMngSave.getTableColumns()><i class=\"fa fa-table\"></i> 기본 컬럼 조회</button> <button type=button class=\"btn btn-default\" ng-click=\"boardMngSave.addColumn(\'base\')\"><i class=\"fa fa-table\"></i> 기본 컬럼 추가</button> <button class=\"btn btn-default\" ng-click=\"boardMngSave.addColumn(\'add\')\" type=button><i class=\"fa fa-edit\"></i> 사용자정의 컬럼 추가</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><metatable-sortable init-callback=boardMngSave.succSortable bind-data=boardMngSave.datas link-data=boardMngSave.linkData max-depth=3 view-type=boardMngSave.viewType check-section=boardMngSave.checkColumnSection check-edit-col-size=boardMngSave.checkEditColumnRowCount></metatable-sortable><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group btn-bottom\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{boardMngSave.makeSrch()}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/boardmng-list.html","<div class=\"page page-footable\" ng-controller=\"BoardMngListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM700\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"물리 테이블/컬럼명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.tabelNm type=text><label>물리 테이블명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.columnLogicalNm type=text><label>물리 컬럼명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goDetail(\'\')\" ng-if=\"$root.gVariable.srchTenantId == 0\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong>{{ \'Menu.LIST\' | translate }}</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=dataloader ng-show=boardMngSave.dataloader></div><!-- Search Result --><table id=searchTextResults data-filter=#filter data-page-size={{vc.viewSizePerPage}} class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'A.TableNm\')\">물리 테이블명<span class=\"{{vc.sortClass(\'A.TableNm\')}}\"></span></th><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'A.TableDesc\')\">테이블 설명<span class=\"{{vc.sortClass(\'A.TableDesc\')}}\"></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.boardList\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.tableNm) ng-class=\"{\'bg-lightyellow\':selectedRow == li.tableNm}\"><!-- Result Items --><td class=text-left><span ng-bind=li.tableNm></span></td><td class=text-left><span ng-bind=li.tableDesc></span></td></tr></tbody></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label>{{ \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalCount ng-model=vc.currentPage total-items=vc.totalCount previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/modal-attr-detail.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>컬럼표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리컬럼이름</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalNm></div></div></div><div class=col-lg-4><div class=form-group><label>물리컬럼데이터크기</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalDataSize></div></div></div><div class=col-lg-4><div class=form-group><label>*물리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>*논리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign disabled></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>목록화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.listColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 표시 Level</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel disabled><option value=1>1</option><option value=2>2</option><option value=3>3</option></select></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 폭</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnWidth></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnHeight></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.editColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnDesc></div></div></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> 닫기</button></div></div>");
$templateCache.put("app/boardmng/modal-attr-setup.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalNm required></div></div><div class=col-lg-4><div class=form-group><label ng-show=modalCtrl.isSizableData() style=\"color: red\">*</label><label>물리데이터크기</label><input type=number class=\"form-control pre\" ng-value=0 ng-model=modalCtrl.column.columnPhysicalDataSize ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-required=modalCtrl.isSizableData()></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리데이터유형</label><select class=form-control ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리참조이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalAsNm></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>논리데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnHeight></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>상세화면 폭</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnWidth></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록표시 방법</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel><option value=showlevel1>①항상 표시</option><option value=showlevel2>②768 이상일때 표시</option><option value=showlevel3>③992 이상일때 표시</option><option value=showlevel4>④1024 이상일때 표시</option><option value=showlevel5>⑤1400 이상일때 표시</option><option value=showlevel0>검색영역에만 표시</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign required></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록화면 폭</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnWidth required></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>공통코드용 코드타입</label><input type=text class=form-control ng-model=modalCtrl.column.codeType></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><textarea class=form-control row=3 cols=50 ng-model=modalCtrl.column.columnDesc></textarea></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=modalCtrl.onAddClick()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> {{ \'Menu.CLOSE\' | translate}}</button></div></div>");
$templateCache.put("app/boardmng/modal_attr_fieldnamerule.html","<div class=modal-header><h3 class=\"modal-title custom-font\">필드이름 규칙</h3></div><div class=modal-body><div class=tile><span ng-if=doing_async>...loading...</span><div class=\"b-a bg-default lter\"><ol><li>Varchar형 : ExtVarchar01 ~ ExtVarchar10</li><li>Integer형 : ExtInt01 ~ ExtInt10</li><li>Datetime형 : ExtDate01 ~ ExtDate10</li></ol></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div>");
$templateCache.put("app/boardmng/modal_attr_reorder.html","<style>.btn_order_box {\r\n  position: relative;\r\n  height: 17px;\r\n  width: 100%;\r\n  padding: 0 5px;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.btn_order {\r\n  height: 17px;\r\n  width: 80px;\r\n  right: 30px;\r\n  z-index: 9;\r\n}\r\n\r\n.btn_order .change_order {\r\n  width: 17px;\r\n  height: 17px;\r\n  display: block;\r\n  float: left;\r\n  background: url(\'/assets/images/icon/btn_change_order.png\') 0 0 no-repeat;\r\n  font-size: 0;\r\n  margin-right: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_first {\r\n  background-position: 0 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_pre {\r\n  background-position: 0 -17px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_next {\r\n  background-position: 0 -34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_last {\r\n  background-position: 0 -51px;\r\n  cursor: pointer;\r\n}\r\n\r\nli.selected {\r\n  background: #f5f6f7;\r\n}</style><div class=modal-content><div class=\"modal-header ng-scope\"><h1 class=\"modal-title page-header\" ng-bind=reorderCtrl.title></h1></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"card_cont list_area\"><div class=\"b-a bg-default lter\"><ul><li data-ng-repeat=\"row in reorderCtrl.objModel\" ng-class=\"{selected:(reorderCtrl.selectedIdx == $index)}\" ng-click=reorderCtrl.onSelect($index)><span ng-bind=row.columnLogicalNm ng-if=\"row.dirty!=\'D\'\"></span>(<span ng-bind=row.columnPhysicalNm ng-if=\"row.dirty!=\'D\'\"></span>)</li></ul></div></div></div></div><div class=row><div class=col-lg-12><div class=\"btn_order_box clear\"><div class=\"btn_order pull-right\"><span class=\"change_order go_first\" ng-click=reorderCtrl.moveTop() translate>BTN.PAGINATION.FIRST</span> <span class=\"change_order go_pre\" ng-click=reorderCtrl.moveUp() translate>BTN.PAGINATION.PREV</span> <span class=\"change_order go_next\" ng-click=reorderCtrl.moveDown() translate>BTN.PAGINATION.NEXT</span> <span class=\"change_order go_last\" ng-click=reorderCtrl.moveBottom() translate>BTN.PAGINATION.LAST</span></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-shield\"></i> {{ \'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=reorderCtrl.onSave()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button></div></div>");
$templateCache.put("app/business/business-dr-list.html","<style type=text/css>.drType li {\r\n    float: left;\r\n    list-style: none;\r\n    margin: 1px;\r\n  }\r\n\r\n  .drType li i {\r\n    display: block;\r\n    width: 150px;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    text-decoration: none;\r\n    float: left;\r\n  }\r\n\r\n  .drType li span {\r\n    display: block;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"BusinessDrListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>영업일지 목록</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.BusinessOPNm placeholder=\"사업기회명 검색\" type=text> <input ng-model=vc.srch.ClientNm placeholder=\"고객사명 검색\" type=text> <input ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button><!--\r\n                  --><button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>담당자</label><input class=form-control type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>동행직원</label><input class=form-control type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>제목</label><input class=form-control type=text ng-model=vc.srch.DRTitle></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>내용</label><input class=form-control type=text ng-model=vc.srch.DRContents></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>활동유형</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>상태</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>결재여부</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>업무시작일</label><div class=\"rangeInput_wrap clear\"><date-input class=\"form-control pull-left\" placeholder=시작일 date=vc.srch.StartDateFrom></date-input><date-input class=\"form-control pull-left\" placeholder=종료일 date=vc.srch.StartDateTo></date-input></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>알림설정</label><div class=bell><label for=no class=mgr30><input class=form-control type=radio name=bell id=no ng-model=vc.srch.RemindUseYN value=N> 설정안함</label><label for=yes><input class=form-control type=radio name=bell id=yes ng-model=vc.srch.RemindUseYN value=Y> 설정함</label></div></div></div></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><div class=dropdown_btn><button class=\"btn btn-default\" data-toggle=dropdown><i class=\"fa fa-bars\"></i> 부가기능</button><ul class=dropdown-menu><li><a ng-click=vc.setExcelFile()><i class=\"fa fa-upload\"></i> 엑셀업로드</a></li><li><a ng-click=vc.getExcelFile()><i class=\"fa fa-download\"></i> 엑셀다운로드</a></li><li><a ng-click=vc.meetViewWriteModal()><i class=\"fa fa-television\"></i> 회의View생성</a></li></ul><!-- <button class=\"btn btn-default\" ng-click=\"vc.getExcelFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> 엑셀\r\n                  </button></br>\r\n                  <button class=\"btn btn-default\" ng-click=\"vc.meetViewWriteModal()\">\r\n                    <i class=\"fa fa-television\"></i> 회의View생성\r\n                  </button> --></div><button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.busiWriteModal()><i class=\"fa fa-plus\"></i> 등록</button></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---><div class=\"drType row mb-10\"><ul><li ng-repeat=\"item in vc.DRTypeLists\"><i class=\"fa fa-{{item.iconNm}} fa-2x\">&nbsp;&nbsp;<span>{{item.DRTypeCnt}}</span></i></li></ul></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div><div fa-pane pane-min=750px ng-if=\"vc.layout != \'N\'\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/business-meeting-view-list.html","<div class=\"page page-footable\" ng-controller=\"BusinessMeetingViewListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><autoview-page-header alias=vc></autoview-page-header></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 sz-search\"><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/business-op-detail.html","<style>/* 자동완성 리스트 */\r\n  .auto-complete-list ul {\r\n    list-style: none;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    display: inline-block;\r\n  }\r\n  .auto-complete-list li {\r\n    display: inline-block;\r\n    background: #555;\r\n    color: white;\r\n    padding: 3px 5px 3px 10px;\r\n    border-radius: 15px;\r\n    margin-right: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .auto-complete-list a {\r\n    color: white;\r\n    text-decoration: none;\r\n    margin-left: 5px;\r\n    font-size: 10px;\r\n    background: #555;\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n    text-align: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .auto-complete-list a:hover {\r\n    color: white;\r\n  }\r\n  /* 자동완성 고객 */\r\n\r\n  /* 탭 정렬 */\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  /* 탭 정렬 */</style><div class=\"page page-footable\" ng-controller=\"BusinessOpDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사업기회 정보<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <div class=\"page-header\">사업기회 정보\r\n        <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.changeLayout(\'N\')\"><img src=\"assets/images/icon-sp-list.png\" alt=\"\"></span>\r\n          <span ng-click=\"vc.changeLayout(\'V\')\"><img src=\"assets/images/icon-sp-rl.png\" alt=\"\"></span>\r\n          <span ng-click=\"vc.changeLayout(\'H\')\"><img src=\"assets/images/icon-sp-tb.png\" alt=\"\"></span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div> --><div class=row><div class=pagecontent pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> {{\'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.copyData()><i class=\"fa fa-copy\"></i> 복제</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><ul class=\"nav nav-tabs progress-custom\"><li id=liTab{{li.Code}} ng-repeat=\"li in vc.progressStep\" class=at-progress-step style=\"width: {{vc.stepWidthRatio}}\"><a href ng-style=\"{\'background-color\' : (vc.data.exProgressStep >= li.Code) ? (li.CodeValue02) : \'#fff\'}\">{{li.CodeValue}}</a> <a href class=arrow ng-style=\"{\'border-left\' : (vc.data.exProgressStep >= li.Code) ? \'25px solid\' + (li.CodeValue02) : \'25px solid #fff\'}\"></a></li></ul></div></div><!-- page content --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=row></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.CustList.length > 0\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=auto-complete-list><ul><li ng-repeat=\"item in vc.data.CustList\"><span>{{item.CustNm}}</span><a ng-click=vc.delCust(item)>X</a></li></ul></div></div></div><div id=sec2 class=row></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.ManagerList.length > 0\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=auto-complete-list><ul><li ng-repeat=\"item in vc.data.ManagerList\"><span>{{item.ManagerNm}}</span><a ng-click=vc.delManager(item)>X</a></li></ul></div></div></div><div id=sec3 class=row></div><!-- 리마인드 --><div id=sec4 class=row></div><div id=sec5 class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 RemindRadio-col-wrap form-layout-inline wrap-col-size-3 type-date-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=\"리마인드 알림설정\">리마인드 알림설정</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio name=selector ng-model=vc.data.RemindAlarm value=N> <span class=helping-el></span> <span class=\"label-text ng-binding\">설정안함</span></label></div><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio name=selector ng-model=vc.data.RemindAlarm value=Y> <span class=helping-el></span> <span class=\"label-text ng-binding\">맞춤설정</span></label></div><div class=\"radio-inline ng-scope\"><!-- <span ng-if=\"vc.data.RemindAlarm == \'Y\'\"> --> <span ng-style=\"{\'visibility\':vc.data.RemindAlarm == \'Y\'?\'visible\':\'hidden\'}\"><button class=\"btn btn-default\" ng-click=vc.addRemindAlarm()>+</button></span></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=remind_item-wrap><ul><li ng-class=\"item.DoneYn==\'Y\' ? \'\' : \'focus\'\" ng-repeat=\"item in vc.data.RemindAlarmList track by $index\"><span class=remind_title ng-click=vc.editItem(item) ng-bind-html=item.RemindNm></span> <span ng-click=vc.deleteItem(item)>×</span></li></ul></div></div></div><div id=sec6 class=row></div></div></div><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">사업정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec6 class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><table class=BusinessProduct id=BusinessProductTable><colgroup><col style=\"width: 20%\"><col style=\"width: 50%\"><col style=\"width: 20%\"><col style=\"width: 10%\"></colgroup><thead><tr><th>사업</th><th>기간</th><th>예상매출</th><th></th></tr></thead><tbody ng-repeat=\"data in vc.BusinessProductList track by $index\"><tr><td><sz-auto-complete code-list=vc.codeBusinessList code-model=data.BusinessNm code-key=data.BusinessId callback=vc.setBusinessCode change-callback=vc.onChangeBusinessNm is-focus=vc.act_BusinessNmFocus init-value=data.BusinessNm class=ng-isolate-scope index=$index><div class=auto-complet-wrap><input ng-focus=avc.focusInput($event) ng-change=avc.setChangeValue() ng-model=avc.inputValue ng-keydown=avc.onKeydownEvent($event) ng-disabled=avc.isDisabled type=text ng-blur=avc.focusoutInput($event) class=\"ng-pristine ng-valid ng-not-empty ng-touched ManagerNameInput\" autocomplete=off aria-invalid=false></div></sz-auto-complete></td><td><div class=col-lg-6><date-input date=data.BusinessStartDate></date-input></div><div class=col-lg-6><date-input date=data.BusinessEndDate></date-input></div></td><td><input type=text class=form-control ng-model=data.BusinessExSales ng-change=vc.setTotalSales() maxlength=12 comma numbers-only></td><td style=\"text-align: center !important\"><button class=\"btn btn-delete btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.delRow(data, $index)\">X</button></td></tr></tbody></table><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.addRow()>+</button><br><span style=\"font-weight: bold\">합계</span><input type=text class=pull-right style=\"font-weight: bold\" ng-bind=vc.totalSales comma-bind></div></div></div></div></div></div></div><!-- 싱글뷰 영역 --><div fa-pane pane-min=600px style=\"min-width: 600px\"><ul class=\"nav nav-tabs\" as-sortable=vc.sortableOptions ng-model=vc.tabList><li ng-repeat=\"tab in vc.tabList\" as-sortable-item ng-class=\"vc.tabIndex == tab.Index ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(tab.Index, tab.Page);\" data-toggle=tab as-sortable-item-handle>{{tab.Text}}</a></li></ul><div ng-include=vc.pages></div></div><!-- 싱글뷰 영역 --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/business-op-flow.html","<style>.as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n\r\n  .card {\r\n    padding: 15px;\r\n    background-color: #fafafa;\r\n    border-left: 6px solid #7f7f84;\r\n    margin-bottom: 10px;\r\n    -webkit-box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);\r\n    -moz-box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);\r\n    box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);\r\n}</style><div class=\"page page-footable\" ng-controller=\"BusinessOpFlowCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><!-- <autoview-page-header alias=\"vc\"></autoview-page-header> --><div class=row><div class=col-lg-12><div class=page-header>사업관리 목록</div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form id=form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.BusinessOPNm placeholder=\"사업기회명 검색\" type=text> <input ng-model=vc.srch.ClientNm placeholder=\"고객사명 검색\" type=text> <input ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button><!--\r\n                  --><button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>담당자</label><input class=form-control type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>비접촉기간</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>사업명</label><input class=form-control type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>진행단계</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>예상매출</label><div class=\"rangeInput_wrap clear\"><input class=\"form-control pull-left\" type=text placeholder=최소> <input class=\"form-control pull-right\" type=text placeholder=최대></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>예상종료일</label><div class=\"rangeInput_wrap clear\"><input class=\"form-control pull-left\" type=text placeholder=시작일> <input class=\"form-control pull-right\" type=text placeholder=종료일></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>계약기간</label><div class=\"rangeInput_wrap clear\"><input class=\"form-control pull-left\" type=text placeholder=시작일> <input class=\"form-control pull-right\" type=text placeholder=종료일></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>계약구분</label><select class=form-control><option value=\"\">-- 선택 --</option></select></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>비고</label><input class=form-control type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><label>알림설정</label><div class=bell><label for=no class=mgr30><input class=form-control type=radio name=bell id=no> 설정안함</label><label for=yes><input class=form-control type=radio name=bell id=yes> 설정함</label></div></div></div></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.busiWriteModal()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.busiWriteModal()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=vc.busiWriteModal()><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --><div class=\"row mt-10 mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><div class=pull-left><button class=\"btn btn-default\" ng-click=\"vc.setChangeTab(\'VIEW_PAGE_LIST\');\">목록형</button> <button class=\"btn btn-default\" ng-click=\"vc.setChangeTab(\'VIEW_PAGE_FLOW\');\">플로우형</button></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.busiWriteModal()><i class=\"fa fa-plus\"></i> 등록</button></div></div></div><!-- Start ProgressStep --><div class=\"row mt-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search progress-step\" style=min-width:{{vc.stepWrapMinWidthRatio}}><ul class=\"nav nav-tabs progress-custom\" as-sortable=vc.sortableOptions ng-model=vc.progressStep><li id=liTab{{li.Code}} ng-repeat=\"li in vc.progressStep\" class=at-progress-step style=\"width: {{vc.stepWidthRatio}}; min-width:{{vc.stepWidthMinRadio}}\"><a href style=\"background-color: {{li.CodeValue02}}\" ng-click=vc.setProgressStep(li.Code)>{{li.CodeValue}}<span>{{li.Cnt}}</span></a> <a href class=arrow style=\"border-left: 25px solid {{li.CodeValue02}}\"></a></li></ul></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search progress-step-content\" style=min-width:{{vc.stepWrapMinWidthRatio}}><div ng-repeat=\"stepKey in vc.stepDataTreeKeys\" style=\"width: {{vc.stepWidthRatio}}; min-width:{{vc.stepWidthMinRadio}}\"><ul class=\"nav nav-tabs progress-step\" as-sortable=vc.sortableOptions ng-model=vc.stepDataTree[stepKey] style=min-height:{{(vc.stepDataTree[stepKey].length+1)*200}}px><li ng-repeat=\"li in vc.stepDataTree[stepKey]\" as-sortable-item><div class=card ng-click=vc.goDetail(li.KeyId) as-sortable-item-handle><strong>{{li.BusinessOPNm}}</strong><br><strong>{{li.ClientNm}}</strong><br><strong>{{li.BusinessProductNms}}</strong><br><strong>{{li.BusinessProductPrice}}</strong><br><strong>{{li.ManagerNms}}</strong><br><button class=\"btn btn-default\" ng-click=\"vc.setBtnCtrl(li, $event)\"><i class=\"fa fa-briefcase\">영업일지추가</i></button></div></li></ul></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search progress-step-bottom\" style=\"width: {{vc.contentSize}}px\"><ul class=\"nav nav-tabs progress-step\"><li as-sortable=vc.sortableOptions ng-model=\"vc.stepStateData[\'postpone\']\" style=\"width : {{vc.contentSize/3.05}}px\"><div>보류</div></li><li as-sortable=vc.sortableOptions ng-model=\"vc.stepStateData[\'success\']\" style=\"width : {{vc.contentSize/3.05}}px\"><div>성공</div></li><li as-sortable=vc.sortableOptions ng-model=\"vc.stepStateData[\'fail\']\" style=\"width : {{vc.contentSize/3.05}}px\"><div>실패</div></li></ul></div></div><!-- End ProgressStep --><!-- 검색영역 --></form><!-- / Table row --></div><!-- <div fa-pane pane-min=\"750px\" ng-if=\"vc.layout != \'N\'\" >\r\n          <ui-view>\r\n            <div class=\"boardNothing\">\r\n              <div class=\"inner\">\r\n                <img src=\"assets/images/icon-write-line.svg\" alt=\"\" style=\"width: 70px; height:70px; text-align:center;\">\r\n                <p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p>\r\n              </div>\r\n            </div>\r\n          </ui-view>\r\n        </div> --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/business-op-list.html","<div class=\"page page-footable\" ng-controller=\"BusinessOpListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><!-- <autoview-page-header alias=\"vc\"></autoview-page-header> --><div class=row><div class=col-lg-12><div class=page-header>사업관리 목록</div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 sz-search\"><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --><div class=\"row mt-10 mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><div class=pull-left><button class=\"btn btn-default\" ng-click=\"vc.setChangeTab(\'VIEW_PAGE_LIST\');\">목록형</button> <button class=\"btn btn-default\" ng-click=\"vc.setChangeTab(\'VIEW_PAGE_FLOW\');\">플로우형</button></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goAdd()>액셀대량등록</button> <button class=\"btn btn-default\" ng-click=vc.getExcelFile()>액셀다운로드</button> <button class=\"btn btn-default\" ng-click=vc.goAdd()>담당자이관</button> <button class=\"btn btn-default\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.busiWriteModal()><i class=\"fa fa-plus\"></i> 등록</button></div></div></div><div class=\"row mt-10 mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><ul class=\"nav nav-tabs progress-custom\"><li id=liTab{{li.Code}} ng-repeat=\"li in vc.progressStep\" class=at-progress-step style=\"width: {{vc.stepWidthRatio}}\"><a href style=\"background-color: {{li.CodeValue02}}\" ng-click=vc.setProgressStep(li.Code)>{{li.CodeValue}}<span>{{li.Cnt}}</span></a> <a href class=arrow style=\"border-left: 25px solid {{li.CodeValue02}}\"></a></li></ul></div></div><!-- 검색영역 --></form><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><!-- / Table row --></div><!-- <div fa-pane pane-min=\"750px\" ng-if=\"vc.layout != \'N\'\" >\r\n          <ui-view>\r\n            <div class=\"boardNothing\">\r\n              <div class=\"inner\">\r\n                <img src=\"assets/images/icon-write-line.svg\" alt=\"\" style=\"width: 70px; height:70px; text-align:center;\">\r\n                <p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p>\r\n              </div>\r\n            </div>\r\n          </ui-view>\r\n        </div> --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/calendar/mng-calendar.html","<style>/* input {width:95% !important; text-align:center; margin-right:0 !important; margin-left:6px;} */</style><div class=\"page page-footable\" ng-controller=\"MngCalendarCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>휴일관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>년도</label><select ng-model=vc.srch.TargetYear ng-options=\"data.TargetYear as data.TargetYear for data in vc.yearsList\" class=form-control ng-change=vc.getList()></select></div></div><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>월</label><div class=month_btn-group><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'01\'\">1</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'02\'\">2</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'03\'\">3</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'04\'\">4</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'05\'\">5</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'06\'\">6</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'07\'\">7</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'08\'\">8</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'09\'\">9</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'10\'\">10</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'11\'\">11</button><!--\r\n                    --><button class=\"btn btn-default\" ng-model=TargetMonth uib-btn-radio=\"\'12\'\">12</button></div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 mgb10\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.saveData()><i class=\"fa fa-list\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=mng_cal_tble><table class=\"table table-responsive table_blue\" cellspacing=0 rules=all border=1 id=mytable><colgroup><col width=*><col width=*><col width=*><col width=*><col width=*><col width=*><col width=*></colgroup><thead><tr><th class=\"active text-center th-new\">일</th><th class=\"active text-center th-new\">월</th><th class=\"active text-center th-new\">화</th><th class=\"active text-center th-new\">수</th><th class=\"active text-center th-new\">목</th><th class=\"active text-center th-new\">금</th><th class=\"active text-center th-new\">토</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists2\"><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.SunIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Sun></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.SunIndex != null\" ng-model=vc.data.lists[li.SunIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.SunIndex != null\" ng-model=vc.data.lists[li.SunIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.MonIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Mon></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.MonIndex != null\" ng-model=vc.data.lists[li.MonIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.MonIndex != null\" ng-model=vc.data.lists[li.MonIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.TueIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Tue></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.TueIndex != null\" ng-model=vc.data.lists[li.TueIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.TueIndex != null\" ng-model=vc.data.lists[li.TueIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.WedIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Wed></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.WedIndex != null\" ng-model=vc.data.lists[li.WedIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.WedIndex != null\" ng-model=vc.data.lists[li.WedIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.ThuIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Thu></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.ThuIndex != null\" ng-model=vc.data.lists[li.ThuIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.ThuIndex != null\" ng-model=vc.data.lists[li.ThuIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.FriIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Fri></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.FriIndex != null\" ng-model=vc.data.lists[li.FriIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.FriIndex != null\" ng-model=vc.data.lists[li.FriIndex].Description></span></td><td><div class=clear><span class=\"pull-left {{vc.data.lists[li.SatIndex].HolidayYn == \'Y\' ? \'text-danger\' : \'\'}}\" ng-bind=li.Sat></span> <span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.SatIndex != null\" ng-model=vc.data.lists[li.SatIndex].HolidayYn ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span></div><span><input type=text ng-show=\"li.SatIndex != null\" ng-model=vc.data.lists[li.SatIndex].Description></span></td></tr></tbody></table></div></div></div></div><!-- /tile body --></div></div><!-- /col --></div></div><!-- page content --></div>");
$templateCache.put("app/campaign/campaign-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SendTitle placeholder=\"제목 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div></div><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'EMAIL\')\"><i class=\"fa fa-edit\"></i> Email 등록</button> <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'SMS\')\"><i class=\"fa fa-edit\"></i> SMS 등록</button> <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'KAKAO\')\"><i class=\"fa fa-edit\"></i> 알림톡 등록</button></div></div></div></form><autoview-list-table alias=vc list-data=lists></autoview-list-table></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div></div>");
$templateCache.put("app/campaign/cert-email-list.html","<div class=\"page page-footable\" ng-controller=\"CertEmailListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>발신이메일인증관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.openEmailCertifiModal();><i class=\"fa fa-edit\"></i> 등록</button></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=\"text-center none\" style=\"width: 65px\">삭제</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-bind-html=\"liCol.ColumnLogicalDataType == \'90\' ?\r\n                          (li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD\') : liCol.ColumnLogicalDataType == \'70\' ?  (li[liCol.ColumnPhysicalNm] | toHyphenContact) : liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? \r\n                          (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis\"></td><td class=text-center><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.setDelData(li);>{{ \'Menu.DELETE\' | translate }}</button></td></tr></tbody></table><div class=tbnodata ng-if=\"vc.totalItems == 0\" style=\"text-align: center; padding: 15px; border-right: 1px solid rgb(204, 204, 204); border-bottom: 1px solid rgb(204, 204, 204); border-left: 1px solid rgb(204, 204, 204); border-image: initial; border-top: none\">조회할 데이터가 없습니다.</div><div class=row ng-if=\"vc.totalItems > 0\"><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign/cert-sms-list.html","<div class=\"page page-footable\" ng-controller=\"CertSmsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>발신번호인증관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent pane-wrap-anchor={{vc.anchor}}><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발송번호인증</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"form-group form-inline\"><label>발송번호</label><input type=text class=form-control ng-model=vc.data.SendInfo ng-required=true auto-hyphen-tel></div></div><div class=\"col-lg-6 col-md-6 col-sm-8 col-xs-12\"><div class=\"form-group form-inline\"><label>인증방법</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=\"휴대폰 본인인증\"><label class=custom-radio-btn title=\"휴대폰 본인인증\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio value=MOBILE ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'MOBILE\'\" ng-click=\"vc.showUploader = false\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">휴대폰 본인인증</span></label></div><div class=\"radio-inline ng-scope\" title=\"통신서비스 이용증명원\"><label class=custom-radio-btn title=\"통신서비스 이용증명원\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=DOCUMENT ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'DOCUMENT\'\" ng-click=\"vc.showUploader = true\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">통신서비스 이용증명원</span></label></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.dupChk();><i class=\"fa fa-edit\"></i> 등록</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.setDelList(); ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div class=input-group><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div></form></div></div></div></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/chatting/h0201-chatlist.html","<div class=\"page page-footable\" ng-controller=\"H0201ChatListCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.CHATCOMMLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a href=javascript:;>{{ \'Menu.JOBLIST\' | translate }}</a></li><li><a ui-sref=\"app.chatting.h0201-roomlist({ChatUserId:\'\'})\">{{ \'Menu.CHATCOMMLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=tile-body><div class=row><div class=col-lg-3><div class=dataTables_length id=DataTables_Table_0_length ng-show=false><label>Search: <input type=text class=form-control ng-model=vc.srch.Title><!-- input id=filter 인 경우 table filtering 됨 --><md-checkbox md-no-ink=\"\" aria-label=내용포함 ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ \'Menu.INCLUDECONTENT\' | translate }}</md-checkbox></label></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getList()><i class=\"fa fa-search\"></i> {{ \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.chatting.h0201-roomedit({FreeChatId:\'\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div></div></div></section></div></div><div><div class=row><div class=col-lg-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4><div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div id=DataTables_Table_0_wrapper class=\"dataTables_wrapper form-inline no-footer\"><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"footable table table-custom\"><thead><tr><th data-toggle=true class=text-center>{{ \'Menu.NUMBER\' | translate }}</th><th data-toggle=true>{{ \'Menu.TITLE\' | translate }} {{ \'Menu.TALKINGPARTNER\' | translate }}</th><th data-toggle=true class=text-center>{{ \'Menu.RECENTMESSAGE\' | translate }}</th><th style=\"width: 100px\" class=text-center>{{ \'Menu.NEW\' | translate }} {{ \'Menu.MESSAGE\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" ui-sref=\"app.chatting.h0201-roomdetail({FreeChatId:\'{{li.FreeChatId}}\'})\" style=\"cursor: pointer\" my-directive><td class=text-center><span ng-bind=li.FreeChatId></span></td><td><span class=\"badge bg-lightred unread\" ng-show=\"li.NewMsg > 0\">1</span> <span ng-bind=li.Title></span>(<span ng-bind=li.ChatUsers ng-show=\"li.ChatUsers != null\"></span><span ng-show=\"li.ChatUsers == null\">{{ \'Menu.ME\' | translate }}</span>)</td><td class=text-left><div><small ng-bind=li.RegUserNm></small> - <small ng-bind=li.RegDate></small></div><div ng-bind=li.Contents></div></td><td class=text-center><span ng-bind=li.NewMsg></span></td></tr></tbody><tfoot><tr><td colspan=4 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div><!-- /tile body --><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div></div>");
$templateCache.put("app/chatting/h0201-roomdetail.html","<style>pre {\r\n    background-color: #fefefe;\r\n    border: 1px solid #efefef;\r\n    margin: 0;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"H0201RoomDetailCtrl as vc\"><!-- FirstId={{vc.F}},LastId={{vc.L}} --><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>대화하기</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.editDetail()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><table class=\"table table-togglable table-hover\"><colgroup><col width=127><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.NUMBER\' | translate }}</th><td><span ng-bind=vc.data.FreeChatId></span></td></tr><tr><th scope=row>{{ \'Menu.TITLE\' | translate }}</th><td><span ng-if=!vc.data.Title ng-bind=\"\'Menu.CONVERSATION\' | translate\"></span> <span ng-if=vc.data.Title ng-bind=vc.data.Title></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr><th scope=row>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><td><span class=online ng-repeat=\"li in vc.data.FreeChatUser\"><i class=\"fa fa-user\"></i><span class=\"media-heading ml-5\"><strong ng-bind=li.ContactNm></strong></span><span class=\"badge badge-outline status mr-5\"></span> </span>({{vc.data.FreeChatUser.length}})</td><tr><th scope=row>{{ \'Menu.REGDATE\' | translate }}</th><td><span ng-bind=\"vc.data.RegDate | date:\'yyyy-MM-dd HH:mm\'\"></span></td></tr><tr><th scope=row>{{ \'Menu.ATTACHMENT\' | translate }}</th><td><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100% ng-if=\"vc.data.uploadFileList.length > 0\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table><table ng-if=\"vc.data.uploadFileList.length == 0\"><tbody><tr class=tbnodata><td colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody></table></td></tr></tbody></table></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.MESSAGECNT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"text-center mb-10\" ng-click=vc.getPrevComment() ng-if=\"vc.totalItems > vc.comment.lists.length\" style=cursor:pointer><i class=\"fa fa-angle-double-up\"></i> 더보기...</div></div></div><div class=row><div class=col-lg-12><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span style=\"color:{{li.RegUser == $root.gVariable.UserId ? \'brown\':\'\'}}\">{{li.RegUserNm}}</span> <span class=text-muted><i class=\"fa fa-clock-o mr-5\"></i>{{li.RegDate | utcToLocal: \'yyyy-MM-dd HH:mm\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.FreeChatCommId == vc.comment.editid || li.FreeChatType != \'M\'\"><button class=\"btn btn-default btn-xs\" style=min-height:21px ng-click=vc.deleteComment(li) ng-disabled=\"li.RegUser != $root.gVariable.UserId\" ng-if=\"li.DelYN == \'N\'\"><i class=\"glyphicon glyphicon-trash\"></i></button> </span><span class=\"text-muted pull-right\" ng-show=\"li.FreeChatCommId == vc.comment.editid\"><button class=\"btn btn-primary btn-xs\" ng-click=vc.editCommentAction(li) ng-disabled=\"li.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn btn-danger btn-xs\" ng-click=vc.editCommentCancel() ng-disabled=\"li.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.FreeChatCommId == vc.comment.editid || li.WorkerId == null\">{{ \'Menu.ASSIGNCONTACTPERSON\' | translate }} : {{li.WorkerNm}}</div><div ng-hide=\"li.FreeChatCommId == vc.comment.editid\"><pre ng-if=li.Contents>{{li.Contents | translate}}</pre><a href=\"\" ng-click=vc.openAttachment(li) ng-if=li.PhysicalFileNm><i class=\"fa fa-file-o\" style=margin:5px></i>{{li.LogicalFileNm}}</a></div><div class=panel-body ng-show=\"li.FreeChatCommId == vc.comment.editid\"><md-input-container style=\"margin:5px 0\"><label>{{ \'Menu.ASSIGNCONTACTPERSON\' | translate }}</label><md-select ng-model=vc.comment.WorkerId><md-option ng-repeat=\"li in vc.data.FreeChatUser\" value={{li.UserId}}>{{li.UserNm}}</md-option></md-select></md-input-container><textarea id=strReply rows=10 style=\"width: 90%; height: 40px\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form id=bottom><form class=\"ng-pristine ng-valid\"><div class=\"col-sm-12 input-group\"><!-- <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.openDilalog()\">{{ \'Menu.ATTACHMENT\' | translate }}</button> --><select class=\"form-control pull-right\" id=selectCombo name=selectCombo ng-model=vc.srchComment.WorkerId ng-options=\"opt.UserId as opt.UserNm for opt in vc.data.FreeChatUser\" style=max-width:200px;min-width:100px><option value=\"\">--대화상대선택--</option></select><!-- <textarea id=\"emoji\" class=\"form-control\" rows=\"3\" placeholder=\"메세지를 입력하세요. (Shift + Enter로 줄바꿈이 가능합니다.)\" ng-model=\"vc.srchComment.Contents\" enter-submit=\"vc.saveComment()\"></textarea> --><textarea id=emoji class=form-control rows=10 placeholder=\"메세지를 입력하세요. (Shift + Enter로 줄바꿈이 가능합니다.)\" ng-model=vc.srchComment.Contents enter-submit=vc.saveComment()></textarea><span class=input-group-btn style=\"vertical-align: bottom\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SEND\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> --> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListComment\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a href=\"\" ng-click=vc.onDelete(obj)><i class=\"fa fa-trash\"></i> {{ \'Menu.DELETE\' | translate }}</a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></div></form></div></div></div></div><!-- /tile body --></div></div><!-- /col --></div><!-- /row --><div id=Content bgcolor=#DDDDDD style=width:100%></div></div><!-- /page content --></div>");
$templateCache.put("app/chatting/h0201-roomedit.html","<style>.md-chips {\r\n  display: block;\r\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  font-size: 12px;\r\n  padding: 0 0 8px 1px;\r\n  vertical-align: middle;\r\n}\r\n\r\nmd-list-item, md-list-item .md-list-item-inner {\r\n  min-height:40px !important;\r\n  height:40px !important;\r\n}\r\n\r\nmd-list-item .md-avatar {\r\n  width: 30px !important;\r\n  height: 30px !important;\r\n}</style><div class=\"page page-footable\" ng-controller=\"H0201RoomEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>대화내용</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveDetail()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.saveDetail()><i class=\"fa fa-times\"></i> {{ \'Menu.CANCEL\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><table class=\"table table-togglable table-hover\"><colgroup><col width=127><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.TITLE\' | translate }}</th><td><input type=text class=form-control ng-model=vc.data.Title placeholder=\"{{ \'Menu.CONVERSATION\' | translate }}\" ng-disabled=\"vc.data.FreeChatId != null && vc.data.RegUser != $root.gVariable.UserId\"></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr><th scope=row>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><td><!-- 채팅상대 선택 --> <span class=online ng-repeat=\"li in vc.data.FreeChatUser\" ng-if=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"fa fa-user\"></i><span class=\"media-heading ml-5\"><strong ng-bind=li.ContactNm></strong></span><span class=\"badge badge-outline status mr-5\"></span></span><md-contact-chips ng-model=vc.newFreeChatUser md-contacts=vc.querySearch($query) md-contact-name=ContactNm md-contact-image=image md-contact-email=email md-require-match=true md-highlight-flags=i filter-selected=vc.filterSelected md-on-remove=vc.onRemoveChip($item) placeholder=추가></md-contact-chips><md-input-container md-no-float=\"\" class=md-block style=\"height: 10px\"><input ng-model=opponent placeholder=\"멤버 또는 소속 이름을 검색해주세요.\"></md-input-container><md-list class=fixedRows><md-list-item class=contact-item ng-repeat=\"(index, contact) in vc.listUsers | filter:opponent | limitTo:vc.contactSize()\" ng-if=!vc.IsContact(contact) ng-click=vc.addUser(contact.UserId)><i class=\"fa fa-user\"></i><div class=\"md-list-item-text compact ml-5\" draggable=true>{{contact.ContactNm}}</div></md-list-item></md-list><div class=\"row text-center\"><button class=\"btn btn-primary w100 mb-10\" ng-show=vc.totalContact() ng-click=vc.getMoreContact()><i class=\"fa fa-caret-down\"></i> 더보기</button></div></td><tr ng-if=\"vc.data.RegUser == $root.gVariable.UserId\"><th scope=row>{{ \'Menu.ATTACHMENT\' | translate }}</th><td><!-- 파일첨부 --><file-attach file-data=vc.data.uploadFileList callback=vc.onFileCallback></file-attach></td></tr></tbody></table></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/chatting/h0201-roomlist.html","<div class=\"page page-footable\" ng-controller=\"H0201RoomListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>업무공유<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr style=\"padding-right: 0px\"></span> <span class=search-condition-str ng-if=vc.WorkerNm>지정담당자:{{vc.WorkerNm}}</span> <span class=search-condition-str ng-if=vc.ChatUserNm>,대화상대:{{vc.ChatUserNm}}</span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group><input class=\"form-control form-right\" ng-model=vc.WorkerNm placeholder=지정담당자 readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchWorkerModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseWorker() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group><input class=\"form-control form-right\" ng-model=vc.ChatUserNm placeholder=대화상대 readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><!-- udc-search meta-list=\"vc.listColumns\" meta-model=\"vc.srch\"></udc-search --><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=pull-right><button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>대화목록</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th data-toggle=true class=text-center style=width:20%>{{ \'Menu.TITLE\' | translate }}</th><th data-toggle=true class=text-center style=width:20%>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><th data-toggle=true class=text-center style=width:40%>{{ \'Menu.RECENTMESSAGE\' | translate }}</th><th data-toggle=true class=text-center style=width:10%>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th data-toggle=true class=\"text-center showlevel3\" style=width:10%>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.FreeChatId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':li.FreeChatId == selectedRow}\"><td><span class=\"badge bg-lightred unread\" ng-show=\"li.UnReadCnt > 0\">{{li.UnReadCnt}}</span> <span ng-if=!li.Title ng-bind=\"\'Menu.CONVERSATION\' | translate\"></span> <span ng-if=li.Title ng-bind=li.Title></span></td><td><span ng-bind=li.ChatUsers ng-show=\"li.ChatUsers != null\"></span> <span ng-show=\"li.ChatUsers == null\">{{ \'Menu.ME\' | translate }}</span></td><td class=text-left><div><small ng-bind=li.CommRegUserNm></small> - <small ng-bind=\"li.CommRegDate | date:\'yyyy-MM-dd HH:mm\'\"></small></div><div ng-if=li.Contents ng-bind=li.Contents class=onelinetext></div><div ng-if=!li.Contents ng-bind=li.LogicalFileNm class=onelinetext></div></td><td class=text-left><div ng-bind=li.WorkerNm></div></td><td class=\"text-left showlevel3\"><div ng-bind=li.RegUserNm></div></td></tr></tbody></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/client/client-detail.html","<style>/* 탭 정렬 */\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  /* 탭 정렬 */</style><div class=\"page page-footable\" ng-controller=\"ClientDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><!-- <autoview-page-header alias=\"vc\"></autoview-page-header> --><div class=row><div class=col-lg-12><div class=page-header>고객사 정보<div class=\"pull-right dock-header-tx list-split\"><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button> <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> {{\'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{\'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientId-col-wrap form-layout-inline wrap-col-size-3 type-bindWrap-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=고객사코드><span style=color:red>* </span>고객사코드</label><span class=\"form-control form-right bind-wrap ng-binding\" ng-bind=vc.data.ClientId></span></div></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientNm-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline required-wrap\"><label uib-tooltip=고객사명><span style=color:red>* </span>고객사명&nbsp;&nbsp;<span style=\"color: blue\" ng-click=vc.getNiceName()>[나이스정보조회]</span></label><input class=\"form-control form-right ng-pristine ng-untouched ng-valid ng-empty\" type=text ng-model=vc.data.ClientNm aria-invalid=false></div></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientBSN1-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline required-wrap\"><label uib-tooltip=사업자등록번호><span style=color:red>* </span>사업자등록번호&nbsp;&nbsp;<span style=\"color: blue\" ng-click=vc.getNiceBSN()>[나이스정보조회]</span></label><input class=\"form-control form-right ng-pristine ng-untouched ng-valid ng-empty\" type=text ng-model=vc.data.ClientBSN1 aria-invalid=false></div></div></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=pull-right><kakaomap-config address=vc.data.Address1 name=vc.data.Address1></kakaomap-config></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상세정보</strong></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label for=\"\">출처</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox1 value=K><label class=form-check-label for=inlineCheckbox1>KS</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox2 value=I><label class=form-check-label for=inlineCheckbox2>ISO</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox3 value=E><label class=form-check-label for=inlineCheckbox3>에너지</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox4 value=L><label class=form-check-label for=inlineCheckbox4>교육</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox5 value=M><label class=form-check-label for=inlineCheckbox5>회원사</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox6 value=Q><label class=form-check-label for=inlineCheckbox6>분임조</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox7 value=B><label class=form-check-label for=inlineCheckbox7>조찬</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox8 value=N><label class=form-check-label for=inlineCheckbox8>표준정보망</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfoEtc type=checkbox id=inlineCheckbox12 onchange=angular.element(this).scope().clickCheckBoxEtc(event) value=기타><label for=\"\">기타</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input type=text class=\"form-control mb5\" id=busiInfoEtc readonly></div></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">관리정보</strong></div><div class=\"panel-body collapse in\"><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><!-- <div fa-pane pane-min=\"600px\" style=\"min-width: 600px\">\r\n          <ul class=\"nav nav-tabs\">\r\n            <li ng-class=\"vc.tabIndex == 0 ? \'active\' : \'\'\"><a id=\"DefaultInfo\" ng-click=\"vc.setChangeTab(0,\'VIEW_PAGE_DEFAULTINFO\');\" data-toggle=\"tab\">기본정보</a></li>\r\n            <li ng-class=\"vc.tabIndex == 1 ? \'active\' : \'\'\"><a id=\"ERPCnt\" ng-click=\"vc.setChangeTab(1,\'VIEW_PAGE_RELATEBUSINESS\');\" data-toggle=\"tab\">연관사업정보</a></li>\r\n            <li ng-class=\"vc.tabIndex == 2 ? \'active\' : \'\'\"><a id=\"KSACust\" ng-click=\"vc.setChangeTab(2,\'VIEW_PAGE_CUSTOMER\');\" data-toggle=\"tab\">고객</a></li>\r\n            <li ng-class=\"vc.tabIndex == 3 ? \'active\' : \'\'\"><a id=\"BusinessOP\" ng-click=\"vc.setChangeTab(3,\'VIEW_PAGE_BUSINESSPLAN\');\" data-toggle=\"tab\">사업기회</a></li>\r\n            <li ng-class=\"vc.tabIndex == 4 ? \'active\' : \'\'\"><a id=\"BusinessDR\" ng-click=\"vc.setChangeTab(4,\'VIEW_PAGE_SALESPLAN\');\" data-toggle=\"tab\">영업일지</a></li>\r\n            <li ng-class=\"vc.tabIndex == 5 ? \'active\' : \'\'\"><a id=\"KSCnt\" ng-click=\"vc.setChangeTab(5,\'VIEW_PAGE_KS\');\" data-toggle=\"tab\">KS</a></li>\r\n            <li ng-class=\"vc.tabIndex == 6 ? \'active\' : \'\'\"><a id=\"ISOCnt\" ng-click=\"vc.setChangeTab(6,\'VIEW_PAGE_ISO\');\" data-toggle=\"tab\">ISO</a></li>\r\n            <li ng-class=\"vc.tabIndex == 7 ? \'active\' : \'\'\"><a id=\"ECCCnt\" ng-click=\"vc.setChangeTab(7,\'VIEW_PAGE_ENERGY\');\" data-toggle=\"tab\">에너지</a></li>\r\n            <li ng-class=\"vc.tabIndex == 8 ? \'active\' : \'\'\"><a id=\"LMSCnt\" ng-click=\"vc.setChangeTab(8,\'VIEW_PAGE_EDUCATION\');\" data-toggle=\"tab\">교육</a></li>\r\n            <li ng-class=\"vc.tabIndex == 9 ? \'active\' : \'\'\"><a id=\"KSSNCnt\" ng-click=\"vc.setChangeTab(9,\'VIEW_PAGE_NETWORK\');\" data-toggle=\"tab\">표준정보망</a></li>\r\n            <li ng-class=\"vc.tabIndex == 10 ? \'active\' : \'\'\"><a id=\"MBRCnt\" ng-click=\"vc.setChangeTab(10,\'VIEW_PAGE_MEMBERS\');\" data-toggle=\"tab\">회원사</a></li>\r\n            <li ng-class=\"vc.tabIndex == 11 ? \'active\' : \'\'\"><a id=\"QCCCnt\" ng-click=\"vc.setChangeTab(11,\'VIEW_PAGE_QUALITYCONTROL\');\" data-toggle=\"tab\">분임조</a></li>\r\n            <li ng-class=\"vc.tabIndex == 12 ? \'active\' : \'\'\"><a id=\"BKMCnt\" ng-click=\"vc.setChangeTab(12,\'VIEW_PAGE_BREAKFAST\');\" data-toggle=\"tab\">조찬</a></li>\r\n            <li ng-class=\"vc.tabIndex == 13 ? \'active\' : \'\'\"><a id=\"SupportCnt\" ng-click=\"vc.setChangeTab(13,\'VIEW_PAGE_SUPPORT\');\" data-toggle=\"tab\">지원사업</a></li>\r\n            <li ng-class=\"vc.tabIndex == 14 ? \'active\' : \'\'\"><a id=\"AlertCnt\" ng-click=\"vc.setChangeTab(14,\'VIEW_PAGE_ALARM\');\" data-toggle=\"tab\">조기경보</a></li>\r\n            <li ng-class=\"vc.tabIndex == 15 ? \'active\' : \'\'\"><a id=\"HistCnt\" ng-click=\"vc.setChangeTab(15,\'VIEW_PAGE_HISTORY\');\" data-toggle=\"tab\">변경이력</a></li>\r\n            \r\n          </ul>\r\n          <div ng-include=\"vc.pages\"></div>\r\n        </div> --><!-- 싱글뷰 영역 --><div fa-pane pane-min=600px style=\"min-width: 600px\"><ul class=\"nav nav-tabs\" as-sortable=vc.sortableOptions ng-model=vc.tabList><li ng-repeat=\"tab in vc.tabList\" as-sortable-item ng-class=\"vc.tabIndex == tab.Index ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(tab.Index, tab.Page);\" data-toggle=tab as-sortable-item-handle>{{tab.Text}}</a></li></ul><div ng-include=vc.pages></div></div><!-- 싱글뷰 영역 --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/client/client-list.html","<div class=\"page page-footable\" ng-controller=\"ClientListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>고객사 목록</div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 일반검색 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.ClientNm placeholder=고객사명 type=text> <input ng-model=vc.srch.EncryptNm placeholder=고객명 type=text> <input ng-model=vc.srch.ManagerNm placeholder=영업담당자 type=text><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i>검색</button><!--\r\n                    --><button class=\"btn btn_down\" id=detailBtn ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=fa ng-class=\"vc.showDetailSearch != true ? \'fa-caret-down\' : \'fa-caret-up\'\"></i></button></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SelectBox track by v.id\" ng-model=vc.thisSelect></select></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SortBox track by v.id\" ng-model=vc.thisSort></select></div></div></div><!-- 일반검색 --><!-- 상세검색조건 --><div ng-show=vc.showDetailSearch><!-- <div class=\"row\" id=\"searchWrap\"></div> --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>고객사 코드</label><input class=form-control ng-model=vc.srch.ClientId type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>사업자등록번호</label><input class=form-control ng-model=vc.srch.ClientBSN1 type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>회사전화</label><input class=form-control ng-model=vc.srch.Telephone type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>이메일</label><input class=form-control ng-model=vc.srch.Email type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>주소</label><input class=form-control ng-model=vc.srch.Address1 type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>사업정보</label><input class=form-control ng-model=vc.srch.BusiInfo type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>고객등급</label><input class=form-control ng-model=vc.srch.ClientScore type=text></div></div><div class=\"col-xxs-12 col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 DeptCode-col-wrap form-layout-inline wrap-col-size-3 type-select-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=담당지역본부>담당지역본부</label><select id=deptCode class=form-control ng-change=vc.setDeptSelect() ng-options=\"v as v.CodeValue for v in vc.DeptBox track by v.Code\" ng-model=vc.thisDept></select></div></div></div><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.detailClose()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div><!-- 상세검색조건 --><div class=col-sm-12><div style=\"float: right\"><div class=dropdown_btn><button class=\"btn btn-default\" data-toggle=dropdown><i class=\"fa fa-bars\"></i> 부가기능</button><ul class=dropdown-menu><li><a><i class=\"fa fa-file-excel-o\"></i> 엑셀대량등록</a></li><li><a><i class=\"fa fa-file-excel-o\"></i> 엑셀다운로드</a></li><li><a><i class=\"fa fa-user\"></i> 담당자이관</a></li></ul></div><button class=\"btn btn-secondary\"><i class=\"fa fa-trash\"></i>삭제</button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.getNiceName()><i class=\"fa fa-search\"></i>나이스정보조회</button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.companyRegisterModal()><i class=\"fa fa-edit\"></i>등록</button></div></div></form><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div></div></div>");
$templateCache.put("app/client/ksacust-detail.html","<style>/*   .autocomplete { \r\n      position: relative; \r\n      display: inline-block; \r\n    } \r\n    .autocomplete-items { \r\n      position: absolute; \r\n      border: 1px solid #d4d4d4; \r\n      border-bottom: none; \r\n      border-top: none; \r\n      z-index: 99; \r\n      top: 100%; \r\n      left: 0; \r\n      right: 0; \r\n    } \r\n    .autocomplete-items div { \r\n      padding: 10px; \r\n      cursor: pointer; \r\n      background-color: #fff; \r\n      border-bottom: 1px solid #d4d4d4; \r\n    } \r\n    .autocomplete-items div:hover { \r\n      background-color: #e9e9e9; \r\n    } \r\n    .autocomplete-active { \r\n      background-color: DodgerBlue !important; \r\n      color: #ffffff;\r\n    } */</style><div class=\"page page-footable\" ng-controller=\"KSACustDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><!-- <autoview-page-header alias=\"vc\"></autoview-page-header> --><div class=row><div class=col-lg-12><div class=page-header>고객 정보<div class=\"pull-right dock-header-tx list-split\"><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button> <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> {{\'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default ng-binding\" ng-click=vc.cancel()><i class=\"fa fa-book\">개별발송</i></button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{\'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><input id=KeyId type=hidden ng-model=vc.data.KeyId><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label for=\"\">사업정보</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox1 value=K><label class=form-check-label for=inlineCheckbox1>KS</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox2 value=I><label class=form-check-label for=inlineCheckbox2>ISO</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox3 value=E><label class=form-check-label for=inlineCheckbox3>에너지</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox4 value=L><label class=form-check-label for=inlineCheckbox4>교육</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox5 value=M><label class=form-check-label for=inlineCheckbox5>회원사</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox6 value=Q><label class=form-check-label for=inlineCheckbox6>분임조</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox7 value=B><label class=form-check-label for=inlineCheckbox7>조찬</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox8 value=N><label class=form-check-label for=inlineCheckbox8>표준정보망</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfoEtc type=checkbox id=inlineCheckbox12 onchange=angular.element(this).scope().clickCheckBoxEtc(event) value=기타><label for=\"\">기타</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input type=text class=\"form-control mb5\" id=busiInfoEtc readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 Memo-col-wrap form-layout-inline wrap-col-size-1 type-input-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=비고>비고</label><input class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" type=text ng-model=vc.data.Memo aria-invalid=false></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">직장정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><input id=ClientId type=hidden ng-model=vc.data.ClientId><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-left><button class=\"btn btn-default ng-binding\" ng-show=vc.toggleY id=clientToggle ng-click=vc.toggleClientInfo()><i class=\"fa fa-building-o\"></i>직장정보전환</button></div><div class=pull-right><kakaomap-config address=vc.data.Address1 name=vc.data.Address1></kakaomap-config></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">마케팅활용동의</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">관리정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 DeptCode-col-wrap form-layout-inline wrap-col-size-3 type-select-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=담당지역본부>담당지역본부</label><select class=form-control ng-change=vc.setDeptSelect(selectedDept) ng-options=\"v.Code as v.CodeValue for v in DeptBox\" ng-model=selectedDept></select></div></div><!-- <div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\">\r\n                        <label>영업담당자</label>\r\n                        <select class=\"form-control\" ng-change=\"vc.setSortSelect()\" ng-options=\"v as v.name for v in SelectBox track by v.id\" ng-model=\"thisSelect\"></select>\r\n                      </div> --><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ManagerNm-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline required-wrap\"><label uib-tooltip=영업담당자>영업담당자</label><sz-auto-complete code-list=vc.codeManagerList code-model=vc.data.ManagerNm code-key=vc.data.UserId callback=vc.setManagerCode add-top-row=신규등록 add-top-row-callback=vc.addManager change-callback=vc.onChangeManagerNm is-focus=vc.act_ManagerNmFocus init-value=vc.data.ManagerNm class=ng-isolate-scope><div class=auto-complet-wrap><input ng-focus=vc.focusInput($event) ng-change=vc.setChangeValue() ng-model=vc.data.cManNmArr ng-keydown=vc.onKeydownEvent($event) ng-disabled=avc.isDisabled type=text ng-blur=avc.focusoutInput($event) class=\"ng-pristine ng-valid ng-not-empty ng-touched ManagerNameInput\" autocomplete=off aria-invalid=false><div class=sz-autocomplete-item-list ng-show=vc.inputFocus aria-hidden=false><div ng-click=vc.selectTopData() ng-class=\"{\'szac-select\' : ac.selectIdx == -1}\" class=add-top-row role=button tabindex=0><span>신규등록</span></div><!-- ngRepeat: opt in avc.CodeList --></div></div></sz-auto-complete></div></div></div><div id=sec8 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><!-- <div fa-pane pane-min=\"600px\" style=\"min-width: 600px\">\r\n            <ul class=\"nav nav-tabs\">\r\n              <li ng-class=\"vc.tabIndex == 13 ? \'active\' : \'\'\"><a id=\"ERPCnt\" ng-click=\"vc.setChangeTab(13,\'VIEW_PAGE_ERP\');\" data-toggle=\"tab\">연관사업정보</a></li>\r\n              <li ng-class=\"vc.tabIndex == 0 ? \'active\' : \'\'\"><a id=\"BusinessOP\" ng-click=\"vc.setChangeTab(0,\'VIEW_PAGE_BUSINESSPLAN\');\" data-toggle=\"tab\">사업기회</a></li>\r\n              <li ng-class=\"vc.tabIndex == 1 ? \'active\' : \'\'\"><a id=\"BusinessDR\" ng-click=\"vc.setChangeTab(1,\'VIEW_PAGE_SALESPLAN\');\" data-toggle=\"tab\">영업일지</a></li>\r\n              <li ng-class=\"vc.tabIndex == 2 ? \'active\' : \'\'\"><a id=\"CampaignCnt\" ng-click=\"vc.setChangeTab(2,\'VIEW_PAGE_CAMPAIGN\');\" data-toggle=\"tab\">캠패인</a></li>\r\n              <li ng-class=\"vc.tabIndex == 3 ? \'active\' : \'\'\"><a id=\"KSCnt\" ng-click=\"vc.setChangeTab(3,\'VIEW_PAGE_KS\');\" data-toggle=\"tab\">KS</a></li>\r\n              <li ng-class=\"vc.tabIndex == 4 ? \'active\' : \'\'\"><a id=\"ISOCnt\" ng-click=\"vc.setChangeTab(4,\'VIEW_PAGE_ISO\');\" data-toggle=\"tab\">ISO</a></li>\r\n              <li ng-class=\"vc.tabIndex == 5 ? \'active\' : \'\'\"><a id=\"ECCCnt\" ng-click=\"vc.setChangeTab(5,\'VIEW_PAGE_ENERGY\');\" data-toggle=\"tab\">에너지</a></li>\r\n              <li ng-class=\"vc.tabIndex == 6 ? \'active\' : \'\'\"><a id=\"LMSCnt\" ng-click=\"vc.setChangeTab(6,\'VIEW_PAGE_EDUCATION\');\" data-toggle=\"tab\">교육</a></li>\r\n              <li ng-class=\"vc.tabIndex == 7 ? \'active\' : \'\'\"><a id=\"KSSNCnt\" ng-click=\"vc.setChangeTab(7,\'VIEW_PAGE_NETWORK\');\" data-toggle=\"tab\">표준정보망</a></li>\r\n              <li ng-class=\"vc.tabIndex == 8 ? \'active\' : \'\'\"><a id=\"MBRCnt\" ng-click=\"vc.setChangeTab(8,\'VIEW_PAGE_MEMBERS\');\" data-toggle=\"tab\">회원사</a></li>\r\n              <li ng-class=\"vc.tabIndex == 9 ? \'active\' : \'\'\"><a id=\"QCCCnt\" ng-click=\"vc.setChangeTab(9,\'VIEW_PAGE_QUALITYCONTROL\');\" data-toggle=\"tab\">분임조</a></li>\r\n              <li ng-class=\"vc.tabIndex == 10 ? \'active\' : \'\'\"><a id=\"BKMCnt\" ng-click=\"vc.setChangeTab(10,\'VIEW_PAGE_BREAKFAST\');\" data-toggle=\"tab\">조찬</a></li>\r\n              <li ng-class=\"vc.tabIndex == 11 ? \'active\' : \'\'\"><a id=\"HistCnt\" ng-click=\"vc.setChangeTab(11,\'VIEW_PAGE_HISTORY\');\" data-toggle=\"tab\">변경이력</a></li>\r\n              <li ng-class=\"vc.tabIndex == 12 ? \'active\' : \'\'\"><a id=\"CompCnt\" ng-click=\"vc.setChangeTab(12,\'VIEW_PAGE_COMP\');\" data-toggle=\"tab\">직장이력</a></li>\r\n            </ul>\r\n            <div ng-include=\"vc.pages\"></div>\r\n          </div> --><!-- 싱글뷰 영역 --><div fa-pane pane-min=600px style=\"min-width: 600px\"><ul class=\"nav nav-tabs\" as-sortable=vc.sortableOptions ng-model=vc.tabList><li ng-repeat=\"tab in vc.tabList\" as-sortable-item ng-class=\"vc.tabIndex == tab.Index ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(tab.Index, tab.Page);\" data-toggle=tab as-sortable-item-handle>{{tab.Text}}</a></li></ul><div ng-include=vc.pages></div></div><!-- 싱글뷰 영역 --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/client/ksacust-list.html","<div class=\"page page-footable\" ng-controller=\"KSACustListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>고객 목록<metadata-config table-nm=\"\'TB_MEMBER\'\" metadata-changed=vc.metadataChanged></metadata-config></div><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><!-- 일반검색 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.EncryptNm placeholder=고객명 type=text> <input ng-model=vc.srch.Mobile4 ng-keypress=limitKeypress($event,vc.srch.Mobile4,4) placeholder=\"휴대전화 4자리\" type=text> <input ng-model=vc.srch.ClientNm placeholder=고객사명 type=text> <input ng-model=vc.srch.ManagerNm placeholder=영업담당자 type=text><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i>검색</button><!--\r\n                  --><button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=fa ng-class=\"vc.showDetailSearch != true ? \'fa-caret-down\' : \'fa-caret-up\'\"></i></button></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SelectBox track by v.id\" ng-model=vc.thisSelect></select></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SortBox track by v.id\" ng-model=vc.thisSort></select></div></div></div><!-- 일반검색 --><!-- 상세검색조건 --><div ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.detailClose()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div><!-- 상세검색조건 --><!-- 검색 초기화 닫기 버튼 --><div class=col-sm-12><div style=\"float: right\"><div class=dropdown_btn><button class=\"btn btn-default\" data-toggle=dropdown><i class=\"fa fa-bars\"></i> 부가기능</button><ul class=dropdown-menu><li><a><i class=\"fa fa-file-excel-o\"></i> 엑셀대량등록</a></li><li><a><i class=\"fa fa-file-excel-o\"></i> 엑셀다운로드</a></li><li><a><i class=\"fa fa-user\"></i> 담당자이관</a></li><li><a ng-click=vc.openCustMergeModal()><i class=\"fa fa-user\"></i> 중복고객통합</a></li></ul></div><button class=\"btn btn-secondary\"><i class=\"fa fa-trash\"></i>삭제</button> <button class=\"btn btn-primary ng-binding\"><i class=\"fa fa-edit\"></i>개별발송</button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.ksacustEditModal()><i class=\"fa fa-edit\"></i>등록</button></div></div></form><!-- row --> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/client/ksacust-merge-list.html","<div class=\"page page-footable\" ng-controller=\"KSACustMergeListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><autoview-page-header alias=vc></autoview-page-header></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.EncryptNm placeholder=고객명 type=text> <input ng-model=vc.srch.Mobile4 ng-keypress=limitKeypress($event,vc.srch.Mobile4,4) placeholder=\"휴대전화 4자리\" type=text> <input ng-model=vc.srch.CustTel placeholder=전화번호 type=text> <input ng-model=vc.srch.EncryptEmail placeholder=이메일 type=text><div class=search_button><button class=\"btn btn-default\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.MergeBox track by v.id\" ng-model=vc.thisMerge></select></div><div><p><span style=color:red>* </span>중복유형을 선택해 주세요</p></div></div></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary mb-10\" ng-click=vc.openMergeModal()><i class=\"fa fa-edit\"></i> 중복고객통합</button></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/client/remember-list.html","<div class=\"page page-footable\" ng-controller=\"RememberListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><autoview-page-header alias=vc metaconfig=\"\'TB_MEMBER_REMEMBER\'\"></autoview-page-header></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.CustNm placeholder=고객명 type=text> <input ng-model=vc.srch.CreatedDate placeholder=명함생성일 type=text><div class=\"search_select mgl05\"><select id=selectForRegYN ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.RegYNBox track by v.id\" ng-model=vc.thisRegYN></select></div><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i>검색</button><!--\r\n                  --><button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=fa ng-class=\"vc.showDetailSearch != true ? \'fa-caret-down\' : \'fa-caret-up\'\"></i></button></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SelectBox track by v.id\" ng-model=vc.thisSelect></select></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SortBox track by v.id\" ng-model=vc.thisSort></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>휴대전화</label><input class=\"mb5 form-control\" ng-model=vc.srch.Mobile4 ng-keypress=limitKeypress($event,vc.srch.Mobile4,4) placeholder=\"휴대전화 4자리\" type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>이메일</label><input class=form-control ng-model=vc.srch.EncryptEmail type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>고객사명</label><input class=form-control ng-model=vc.srch.ClientNm type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>등록자</label><input class=form-control ng-model=vc.srch.CreatedBy placeholder=이메일 type=text></div></div></div><!-- 버튼영역 --><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.getSynchronize()><i class=\"fa fa-refresh\"></i>동기화</button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i>엑셀다운로드</button><!-- <button class=\"btn btn-primary ng-binding\" ng-click=\"vc.companyRegisterModal()\"><i class=\"fa fa-edit\"></i>등록</button> --></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/counsel/counselrecord-detail.html","<div class=\"page page-footable\" ng-controller=\"CounselrecordDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>상담일지조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>상담관리</a></li><li><a>상담일지조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">고객정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button type=button ng-click=vc.showModalCounselRecordList()>이전상담내역보기</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.counsel.counselrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.counsel.counselrecord-edit({CounselRecordId:\'{{vc.srch.CounselRecordId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i>수정</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i>삭제</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ArmyId readonly></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.data.CustNm readonly></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo readonly></div></div><div class=col-lg-4><div class=form-group><label>계급</label><input type=text class=form-control ng-model=vc.data.ArmyClass_ readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.ArmyArea readonly></div></div><div class=col-lg-4><div class=form-group><label>군별</label><input type=text class=form-control ng-model=vc.data.ArmyType_ readonly></div></div><div class=col-lg-4><div class=form-group><label>소속부대</label><input type=text class=form-control ng-model=vc.data.PermStat_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담희망분야</label><input type=text class=form-control ng-model=vc.data.HopeField_ readonly></div></div><div class=col-lg-4><div class=form-group><label>학력</label><input type=text class=form-control ng-model=vc.data.LastEdu_ readonly></div></div><div class=col-lg-4><div class=form-group><label>병과 및 특기</label><input type=text class=form-control ng-model=vc.data.Spec_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>임관일 또는 입대일</label><input type=text class=form-control ng-model=vc.data.InArmyDate readonly></div></div><div class=col-lg-4><div class=form-group><label>전역일</label><input type=text class=form-control ng-model=vc.data.OutArmyDate readonly></div></div><div class=col-lg-4><div class=form-group><label>생년월일</label><input type=text class=form-control ng-model=vc.data.ResRegNo readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.data.Mobile readonly></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>전역후연락가능번호</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.OutArmyTel\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.data.Email readonly></div></div></div><div class=row></div><div class=row><div class=col-lg-12><div class=form-group><label>상담메모</label><textarea class=form-control ng-model=vc.data.CounselMemo rows=5 readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group text-right\" ng-show=\"vc.srch.CounselRecordId > 0\">최종수정이력: {{vc.data.EdtDate | date : \"yyyy-MM-dd HH:mm:dd\"}} ({{vc.data.EdtUser_}})</div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">상담정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=vc.data.CounselRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>상담방법</label><input type=text class=form-control ng-value=vc.data.CounselMethod_ readonly></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control ng-value=vc.data.CounselUser_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야(1순위)</label><input type=text class=form-control ng-model=vc.data.CounselField_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무(1순위)</label><input type=text class=form-control ng-model=vc.data.HopeDuty_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>희망직무기타(1순위)</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow><div class=form-group><label>취업희망지역(1순위)</label><input type=text class=form-control ng-model=vc.data.HopeLoc_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야(2순위)</label><input type=text class=form-control ng-model=vc.data.CounselField2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무(2순위)</label><input type=text class=form-control ng-model=vc.data.HopeDuty2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow2><div class=form-group><label>희망직무기타(2순위)</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc2 readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>취업희망지역(2순위)</label><input type=text class=form-control ng-model=vc.data.HopeLoc2_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-value=vc.data.CounselDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-value=vc.data.CounselDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.CounselDateHopeNextMin readonly></div></div></div></div></div><!--  <div class=\"row\">\r\n              \r\n            </div> --><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담주제</label><input type=text class=form-control ng-model=vc.data.CounselTopic_ readonly></div></div><div class=col-lg-8 ng-if=\"vc.data.Title && vc.data.CounselTopic == \'99\'\"><div class=form-group><label>‘기타’ 세부주제</label><input type=text class=form-control ng-model=vc.data.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=vc.data.Content rows=20 readonly></textarea></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/counsel/counselrecord-edit.html","<script type=text/javascript>$(function () {\r\n    $(\'.phone-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 4) {\r\n        $(this).val(str);\r\n      } else if (str.length < 7) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3);\r\n\r\n        $(this).val(tmp);\r\n      } else if (str.length < 11) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      } else {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 4);\r\n        tmp += \'-\';\r\n        tmp += str.substr(7);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n\r\n    $(\'.resreg-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 7) {\r\n        $(this).val(str);\r\n      } else if (str.length < 13) {\r\n        tmp += str.substr(0, 6);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n  });</script><div class=\"page page-footable\" ng-controller=\"CounselrecordEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>상담일지등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>상담관리</a></li><li><a>상담일지</a></li><li><a>상담일지등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">고객정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"row mt-15\"><div class=col-sm-12><div class=pull-right><!-- <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" back>\r\n                  <i class=\"fa fa-undo\"></i>취소\r\n                </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button type=button ng-click=vc.showModalCounselRecordList()>이전상담내역보기</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.counsel.counselrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData()><i class=\"fa fa-save\"></i>저장</button>&nbsp;&nbsp;</div></div></div><!-- tile body --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>아이디</label><input type=text readonly class=form-control ng-model=vc.data.ArmyId placeholder=아이디></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat placeholder=소속(사,여단급)></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>성명</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=성명 ng-value=vc.data.CustNm> <input type=hidden ng-value=vc.data.CustArmyId> <span class=input-group-btn ng-show=\"vc.srch.CounselRecordId == \'\'\"><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCustInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo placeholder=\"군번 \" readonly></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback is-disabled=vc.ArmyClassReadOnly></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly style=\"padding: 5px !important\"></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select name=selectCombo class=form-control ng-model=vc.data.ArmyAreaObj ng-change=vc.onArmyAreaListSelected() ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>학력</label><common-code param-data=vc.LastEduList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>병과</label><common-code param-data=vc.SpecList callback=vc.onSelectCallback></common-code><!-- <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.Spec\" placeholder=\"병과 및 특기 \" /> --></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>임관일 또는 입대일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtInArmyDate ng-change=\"vc.data.InArmyDate = (dtInArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"임관 또는 입대일자 \"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>전역일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtOutArmyDate ng-change=\"vc.data.OutArmyDate = (dtOutArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=전역일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>생년월일</label><input type=text class=form-control ng-model=vc.data.ResRegNo placeholder=\"생년월일 \"></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>휴대폰</label><input type=text class=\"form-control phone-number-check\" ng-model=vc.data.Mobile placeholder=\"휴대폰 \"></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>전역후연락가능번호</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.OutArmyTel\"\r\n                    placeholder=\"전역후연락가능번호 \"\r\n                  />\r\n                </div>\r\n              </div> --><div class=col-lg-4><div class=form-group><label class=txt_req>이메일</label><input type=text class=form-control ng-model=vc.data.Email placeholder=이메일></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담메모</label><textarea class=form-control ng-model=vc.data.CounselMemo rows=5 placeholder=상담메모></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 placeholder=추가정보메모></textarea></div></div></div></div><!-- /title body --></div><!-- title --></div><!-- /col --></div><!-- /row --></div><!-- /pagecontent --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">상담정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담회차</label><common-code param-data=vc.CounselRoundList callback=vc.onSelectCallback is-disabled=true></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>상담방법</label><!-- <common-code param-data=\"vc.CounselMethodList\" callback=\"vc.onSelectCallback\"></common-code> --><select class=\"form-control select-auto\" id=counsel_method name=counsel_method ng-model=vc.data.CounselMethod><option value=2>대면</option><option value=0>비대면</option></select></div></div><div class=col-lg-2><div class=form-group><label class=txt>&nbsp;</label><select class=\"form-control select-auto\" id=remote_method name=remote_method ng-model=vc.data.RemoteMethod ng-if=\"vc.data.CounselMethod == 0\"><option value=\"\">-선택-</option><option value=1>전화</option><option value=4>화상</option><option value=3>이메일</option><option value=5>온라인 메신저</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.data.CounselUser_> <input type=hidden ng-value=vc.data.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>상담분야 (1지망)</label><common-code param-data=vc.CounselField1List callback=vc.onCounselField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField2List callback=vc.onCounselField2ListSelected></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label class=txt_req>희망직무 (1지망)</label><common-code param-data=vc.HopeDutyList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc placeholder=희망직무기타></div></div><div class=col-lg-2 ng-show=HopeLocListShow1><div class=form-group><label class=txt_req>취업희망지역 (1지망)</label><!-- <common-code param-data=\"vc.HopeLocList1\" callback=\"vc.onSelectCallback\"  refresh-data=\"vc.refreshHopeLocList1\"></common-code> --><common-code param-data=vc.HopeLocList1 callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label class=txt_req>취업희망지역(해외) (1지망)</label><common-code param-data=vc.HopeLocList2 callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담분야 (2지망)</label><common-code param-data=vc.CounselField3List callback=vc.onCounselField3ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField4List callback=vc.onCounselField4ListSelected></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무 (2지망)</label><common-code param-data=vc.HopeDutyList2 callback=vc.onSelectCallback4></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc2 placeholder=희망직무기타></div></div><div class=col-lg-2 ng-show=HopeLocListShow3><div class=form-group><label>취업희망지역 (2지망)</label><!-- <common-code param-data=\"vc.HopeLocList1\" callback=\"vc.onSelectCallback\"  refresh-data=\"vc.refreshHopeLocList1\"></common-code> --><common-code param-data=vc.HopeLocList3 callback=vc.onSelectCallback4></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow4><div class=form-group><label>취업희망지역(해외) (2지망)</label><common-code param-data=vc.HopeLocList4 callback=vc.onSelectCallback4></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDate ng-change=\"vc.data.CounselDate = (dtCounselDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=상담일자> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"txt_req\">상담시간</label>\r\n                  <div class=\"input-group\">\r\n                    <div class=\"input-group\">\r\n                      <common-code\r\n                        param-data=\"vc.CounselTimeFromHourList\"\r\n                        callback=\"vc.onSelectCallback2\"\r\n                      ></common-code>\r\n                    </div>\r\n                    <div class=\"input-group-addon input_group_split\">:</div>\r\n                    <div class=\"input-group\">\r\n                      <common-code param-data=\"vc.CounselTimeFromMinList\" callback=\"vc.onSelectCallback2\"></common-code>\r\n                    </div>\r\n                    <div class=\"input-group-addon input_group_split\">~</div>\r\n                    <div class=\"input-group\">\r\n                      <common-code param-data=\"vc.CounselTimeToHourList\" callback=\"vc.onSelectCallback3\"></common-code>\r\n                    </div>\r\n                    <div class=\"input-group-addon input_group_split\">:</div>\r\n                    <div class=\"input-group\">\r\n                      <common-code param-data=\"vc.CounselTimeToMinList\" callback=\"vc.onSelectCallback3\"></common-code>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateHopeNext ng-change=\"vc.data.CounselDateHopeNext = (dtCounselDateHopeNext | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=다음상담희망일시> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=vc.CounselDateHopeNextHourList callback=vc.onSelectCallback></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=vc.CounselDateHopeNextMinList callback=vc.onSelectCallback></common-code></div></div></div></div></div><!-- <div class=\"row\">\r\n              \r\n            </div> --><div class=row><!-- <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"txt_req\">제목</label>\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.Title\" placeholder=\"제목\" maxlength=\"45\" />\r\n                </div>\r\n              </div> --><div class=col-lg-4><div class=form-group><label class=txt_req>상담주제</label><common-code param-data=vc.CounselTopicList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-8 ng-if=\"vc.data.Title && vc.data.CounselTopic == \'99\'\"><div class=form-group><label>‘기타’ 세부주제</label><input type=text class=form-control ng-model=vc.data.Title placeholder=세부주제 maxlength=45></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label class=txt_req>상담내용</label><textarea class=form-control ng-model=vc.data.Content rows=20 placeholder=상담내용 maxlength=4000></textarea></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><!-- <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" back>\r\n                  <i class=\"fa fa-undo\"></i>취소\r\n                </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button type=button ng-click=vc.showModalCounselRecordList()>이전상담내역보기</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.counsel.counselrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData()><i class=\"fa fa-save\"></i>저장</button> &nbsp;&nbsp;&nbsp;</div></div></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/counsel/counselrecord-list.html","<div class=\"page page-footable\" ng-controller=\"CounselrecordListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>상담일지목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>상담관리</a></li><li><a>상담일지목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><!-- <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>상담제목</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.srch.Title\" placeholder=\"상담제목 \" />\r\n                  </div>\r\n                </div> --><div class=col-lg-4><div class=form-group><label class=txt_req>상담주제</label><common-code param-data=vc.CounselTopicList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=\"군번 \"></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>학력</label><common-code param-data=vc.LastEduList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>상담방법</label><common-code param-data=vc.CounselMethodList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select name=selectCombo class=form-control ng-model=vc.srch.ArmyAreaObj ng-change=vc.onArmyAreaListSelected() ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.CounselUser_> <input type=hidden ng-value=vc.srch.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>상담일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담회차</label><common-code param-data=vc.CounselRoundList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2><div class=form-group><label>상담분야</label><common-code param-data=vc.CounselField1List callback=vc.onCounselField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField2List callback=vc.onCounselField2ListSelected></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><common-code param-data=vc.HopeDutyList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc placeholder=희망직무기타></div></div><div class=col-lg-2 ng-show=HopeLocListShow1><div class=form-group><label>희망지역</label><common-code param-data=vc.HopeLocList1 callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2><div class=form-group><label ng-show=HopeLocListShow2>희망지역(해외)</label><common-code param-data=vc.HopeLocList2 ng-show=HopeLocListShow2 callback=vc.onSelectCallback></common-code></div></div></div><!-- \r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>연동여부</label>\r\n                  <common-code param-data=\"vc.LinkageYNList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n            </div>\r\n             --><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ui-sref=\"app.counsel.counselrecord-edit({CounselRecordId:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button><!-- \r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.getExcelForWork()\" ng-show=\"showBtnExcel\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> 상담엑셀(교육원업로드용)\r\n                  </button>\r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.updateLinkageYNList()\" ng-show=\"showBtnLinkageYN\">\r\n                    <i class=\"fa fa-edit\"></i> 연동완료처리\r\n                  </button>\r\n                   --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}} &nbsp; <strong style=\"color: #d00\">* 정렬기준 : 등록일시 기준 정렬</strong><div class=pull-right><label>페이지당 목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-striped\"><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'CustNm\',\'Y\')\">성명<span><i class=\"{{vc.setSortDirect(\'CustNm\')}} ml-5\"></i></span></th><!-- <th class=\"text-center\" ng-click=\"vc.setSortColumn(\'Title\',\'Y\')\">\r\n                        상담제목<span><i class=\"{{vc.setSortDirect(\'Title\')}} ml-5\"></i></span>\r\n                      </th> --><th class=text-center ng-click=\"vc.setSortColumn(\'CounselTopic\',\'Y\')\">상담주제<span><i class=\"{{vc.setSortDirect(\'CounselTopic\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'HopeField1\',\'Y\')\">상담희망분야<span><i class=\"{{vc.setSortDirect(\'HopeField1\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CounselRound\',\'Y\')\">상담회차<span><i class=\"{{vc.setSortDirect(\'CounselRound\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CounselField1\',\'Y\')\">상담분야<span><i class=\"{{vc.setSortDirect(\'CounselField1\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'LastEdu\',\'Y\')\">학력<span><i class=\"{{vc.setSortDirect(\'LastEdu\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'UserNm\',\'Y\')\">상담사<span><i class=\"{{vc.setSortDirect(\'UserNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CounselDate\',\'Y\')\">상담일<span><i class=\"{{vc.setSortDirect(\'CounselDate\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.viewSize)}}</td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustNm></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><!-- <span ng-bind=\"li.Title\"></span> --> <span ng-bind=li.CounselTopic></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.HopeField_></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselRound_></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselField_></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.LastEdu_></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselUser_></span></td><td class=text-center ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselDate></span></td></tr></tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=10 class=text-center>데이터가 없습니다.</td></tr><tfoot><tr><td colspan=10 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --><div><span class=infomark><i>!</i> 전역일 3년 이상 대상자의 개인정보는 삭제됩니다. (삭제 항목 : 아이디, 소속부대, 성명, 군번, 소속부대_사단, 소속부대_여단, 임관/입대일, 전역일, 휴대폰)</span></div></div><!-- /page content --></div>");
$templateCache.put("app/counsel/schedule-list.html","<div class=\"page page-footable\" ng-controller=\"ScheduleListCtrl as vc\"><!-- page header --><div class=pageheader><h2>상담일정</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a href=javascript:;>상담관리</a></li><li><a ui-sref=app.counsel.schedule-list>일정조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><!-- 성명 --><div class=col-lg-4><div class=form-group><label>성명</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=성명 ng-value=vc.srch.CustNm> <input type=hidden ng-model=vc.srch.CustArmyId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCustInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2></div></div></div><div class=row><!-- 상담사 --><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.SchUserId_> <input type=hidden ng-model=vc.srch.SchUserId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>메모</label><input type=text class=form-control ng-model=vc.srch.Title placeholder=메모></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=tile-body><div class=row><div class=col-lg-12><!-- 달력--><div id=szCalendar ui-calendar=uiConfig.calendar ng-model=eventSources calendar=myCalendar></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/cti-list.html","<style>.btn.btn-remove {\r\n    background: #FF0000 !important;\r\n    color: #FFF !important;\r\n  }</style><!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"CtiListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=\"row mt-10 mb-10\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions disabled-click></autoview-list-table></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-campaign.html","<style>.cols-SendMessage { \r\n    white-space: nowrap; \r\n    overflow: hidden; \r\n    text-overflow: ellipsis; \r\n    text-align: left;\r\n  }</style><!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"CustomerCampaignCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><autoview-list-table alias=vc list-data=lists></autoview-list-table><!-- /page content --></div>");
$templateCache.put("app/customer/customer-counsel.html","<!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"CustomerCounselCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><div class=\"pull-center mb-5\"><button class=\"btn btn-primary\" ng-click=\"vc.custCounselAddModal(\'\',\'\',\'\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-detail.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"CustomerDetailCtrl as vc\"><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>고객상세정보</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\"><li ng-class=\"vc.tabIndex == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(0,\'VIEW_PAGE_DETAIL\');\" data-toggle=tab>상세정보</a></li><li ng-class=\"vc.tabIndex == 1 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(1,\'VIEW_PAGE_COUNSEL\');\" data-toggle=tab>히스토리</a></li><li ng-class=\"vc.tabIndex == 2 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(2,\'VIEW_PAGE_PAYMENT\');\" data-toggle=tab>결제</a></li><li ng-class=\"vc.tabIndex == 3 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(3,\'VIEW_PAGE_PENCHART\');\" data-toggle=tab>펜차트</a></li><!-- <li ng-class=\"vc.url.indexOf(\'/tab4\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab4\');\" data-toggle=\"tab\">리콜관리</a></li> --><!-- <li ng-class=\"vc.url.indexOf(\'/tab5\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab5\');\" data-toggle=\"tab\">소개자관리</a></li> --><li ng-class=\"vc.tabIndex == 5 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(5,\'VIEW_PAGE_CAMPAIN\');\" data-toggle=tab>메시지</a></li><li ng-class=\"vc.tabIndex == 4 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(4,\'VIEW_PAGE_HISTORY\');\" data-toggle=tab>이력관리</a></li></ul><div ng-include=vc.pages></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"CustomerEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>고객등록/수정</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-if=!vc.data.KeyId ng-click=vc.custMigrationModal()><i class=\"fa fa-file-excel-o\"></i> 고객대량등록</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.data.KeyId && (vc.layout == \'N\' || vc.layout == \'\')\"><i class=\"fa fa-list\"></i> {{\'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">간편등록{{vc._layout}}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><span ng-model=vc.data.MarriageYN></span><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상세등록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-history.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"CustomerHistoryCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><autoview-list-table alias=vc list-data=lists disabled-click></autoview-list-table></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-list.html","<div class=\"page page-footable\" ng-controller=\"CustomerListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=\"row mt-10 mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.CustInfo placeholder=\"고객명/연락처 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><div class=pull-right><!-- <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.sendMessage(\'all\')\">\r\n                    <i class=\"fa fa-message\"></i> {{\'전체 문자발송\' | translate}}\r\n                  </button> --><!-- <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.sendMessage()\">\r\n                    <i class=\"fa fa-message\"></i> {{\'선택 문자발송\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelCheckDataFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}(체크회원)\r\n                  </button>\r\n                  <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}(조회조건)\r\n                  </button> --> <button class=\"btn btn-primary btn-big\" ng-click=vc.goAdd()><i class=\"material-icons md-18\">person_add_alt_1</i> 고객 신규등록</button></div></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><!-- / Table row --></div><div fa-pane pane-min=750px ng-if=\"vc.layout != \'N\'\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-payment.html","<div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"CustomerPaymentCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><div class=\"pull-center mb-5\"><button class=\"btn btn-primary\" ng-click=\"vc.custPaymentAddModal(\'\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-default\" ng-click=vc.custPaymentPassTicketAddModal()><i class=\"fa fa-shopping-cart\"></i> 정액권, 횟수권 충전</button></div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"vc.data.PaymentSummaryList.length > 0\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th class=text-center>총 청구액</th><th class=text-center>총 납입금액</th><th class=text-center>총 환불액</th><th class=text-center>총 미수액</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.PaymentSummaryList\" style=\"cursor: pointer\"><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" style=\"font-weight: bold\" readonly ng-model=li.TotPayAmt></td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" style=\"font-weight: bold\" readonly ng-model=li.TotFinPayAmt></td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" style=\"font-weight: bold\" readonly ng-model=li.TotRefundAmt></td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" style=\"font-weight: bold;color:red\" readonly ng-model=li.TotOutAmt></td></tr></tbody></table></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-penchart.html","<style>.square {\r\n    position: relative;\r\n    width: 20%;\r\n    padding: 8px;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n  .square:after {\r\n    content: \"\";\r\n    display: block;\r\n    padding-bottom: 144%;\r\n  }\r\n\r\n  .square .box-area-wrap {\r\n    position: absolute;\r\n    width: calc(100% - 16px);\r\n    border: solid 1px #e3e3e3;\r\n    background: #FFF;\r\n  }\r\n\r\n  .square .content {\r\n    height: 90%;\r\n    width: calc(100% - 18px);\r\n    position: absolute;\r\n    background: #f7f7f7;\r\n    padding: 8px;\r\n    border: none;\r\n    margin: 0px 1px 0px 1px;\r\n  }\r\n\r\n  .square .content div {\r\n    height : 100%;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n  }\r\n\r\n  .square .content .title {\r\n    height: 17px;\r\n    margin-top: 11px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    margin-left:-10px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .square .content .date {\r\n    height: 16px;\r\n    margin-top: 6px;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    letter-spacing: -1px;\r\n    margin-left:-10px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }</style><!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"CustomerPenChartCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.custPenchartAddModal()><i class=\"fa fa-edit\"></i> 펜차트 {{\'Menu.ADD\' | translate}}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in right-form-wrap\" ng-if=\"vc.lists.length > 0\"><div class=row><!-- <pre>{{vc | json}}</pre> --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div ng-repeat=\"item in vc.lists\" class=\"col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 square\"><div class=box-area-wrap></div><div class=content ng-click=vc.custPenchartDetailModal(item)><div style=\"background-image : url(\'{{item.ImageData}}\')\"></div><div class=title>{{item.ChartNm}}</div><div class=date>{{item.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD\'}}</div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><autoview-list-paging alias=vc list-data=lists></autoview-list-paging></div></div></div><div class=\"panel-body collapse in right-form-wrap\" ng-if=\"vc.lists.length == 0\" style=\"text-align: center; padding : 60px 0px\">저장된 펜차트 정보가 없습니다.</div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer.html","<!-- Html Editor --><style>.sz-search .search-condition-str {height: 0px;}</style><div class=\"page page-footable\" ng-controller=\"CustomerCtrl as vc\"><!-- page content --><div class=pagecontent><div class=row><div class=\"col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3\">총 고객 수 : 000명</div><div class=\"col-xs-6 col-sm-6 col-md-9 col-lg-9 col-xl-9\"><!-- 고객목록 --><div class=\"pull-right col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\" ng-if=\"vc.url.indexOf(\'/tab1\') == 0\"><div class=\"col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><div class=\"col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 sz-search mb-0\"><button class=\"btn btn-primary ng-binding\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> 메시지</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 삭제</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 엑셀</button></div></div><!-- 고객등록 --><div class=pull-right ng-if=\"vc.url.indexOf(\'/tab2\') == 0\"><button class=\"btn btn-primary ng-binding\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> 대형고객등록</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 초기화</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 저장</button></div><!-- 고객등록 --><div class=pull-right ng-if=\"vc.url.indexOf(\'/tab3\') == 0\"><button class=\"btn btn-primary ng-binding\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> 녹취대량등록</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 검색</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> 엑셀</button></div></div></div><ul class=\"nav nav-tabs\"><li ng-class=\"vc.url.indexOf(\'/tab1\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab1\');\" data-toggle=tab>고객목록</a></li><li ng-class=\"vc.url.indexOf(\'/tab2\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab2\');\" data-toggle=tab>고객등록</a></li><li ng-class=\"vc.url.indexOf(\'/tab3\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab3\');\" data-toggle=tab>CTI</a></li><li ng-class=\"vc.url.indexOf(\'/tab4\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab4\');\" data-toggle=tab>리콜관리</a></li><li ng-class=\"vc.url.indexOf(\'/tab5\') == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab5\');\" data-toggle=tab>소개자관리</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/customer/customerarmy-detail.html","<div class=\"page page-footable\" ng-controller=\"CustomerarmyDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>회원조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>회원상세조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>필수신청정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.customer.customerarmy-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.customer.customerarmy-edit({CustArmyId:\'{{vc.srch.CustArmyId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> {{ \'Menu.EDIT\' | translate }}</button><!--  <button\r\n                    class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\"\r\n                    activate-button\r\n                    ng-click=\"vc.showModalEmail()\"\r\n                    ng-show=\"showBtnEmail\"\r\n                  >\r\n                    <i class=\"fa fa-search\"></i> 이메일발송\r\n                  </button> --> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ArmyId readonly></div></div><div class=col-lg-2><div class=form-group><label>소속 / 지역(사여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PermStatAddr_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.data.CustNm readonly></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo readonly></div></div><div class=col-lg-4><div class=form-group><label>계급</label><input type=text class=form-control ng-model=vc.data.ArmyClass_ readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=vc.data.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.ArmyArea readonly></div></div><div class=col-lg-4><div class=form-group><label>군별</label><input type=text class=form-control ng-model=vc.data.ArmyType_ readonly></div></div><div class=col-lg-4><div class=form-group><label>소속부대</label><input type=text class=form-control ng-model=vc.data.PermStat_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담희망분야</label><input type=text class=form-control ng-model=vc.data.HopeField_ readonly></div></div><div class=col-lg-4><div class=form-group><label>참여차수</label><input type=text class=form-control ng-model=vc.data.JoinCnt_ readonly></div></div><div class=col-lg-4><div class=form-group><label>학력</label><input type=text class=form-control ng-model=vc.data.LastEdu_ readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>1지망 희망지역/희망직종</label><input type=text class=form-control ng-model=vc.data.CounselLoc_ readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeJobType_ readonly></div></div><div class=col-lg-2><div class=form-group><label>2지망 희망지역/희망직종</label><input type=text class=form-control ng-model=vc.data.CounselLoc2_ readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeJobType2_ readonly></div></div><!--  <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>&nbsp;</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.HopeJobTypeEtc\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --></div><!--  <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>&nbsp;</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.HopeJobTypeEtc2\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>상담가능연락처</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.CounselAbleTel\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.data.Mobile readonly></div></div><div class=col-lg-4><div class=form-group><label>희망급여(만원)</label><input type=text class=form-control ng-model=vc.data.HopeAmt readonly></div></div><div class=col-lg-4><div class=form-group><label>1차상담 희망일</label><input type=text class=form-control ng-model=vc.data.FirstHopeDate readonly></div></div></div><!-- <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>상담신청등록자</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.CounselAppliRegUser_\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>상담신청등록일</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.CounselAppliRegDate\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><label>관련파일</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col width=*><col width=140px><col width=140px></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group text-right\" ng-show=\"vc.srch.CustArmyId > 0\">최초등록: {{vc.data.RegDate}} ({{vc.data.RegUser_}}) / 최종수정: {{vc.data.EdtDate}} ({{vc.data.EdtUser_}})</div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담정보</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-2><div class=form-group><label>1차상담확정일</label><input type=text class=form-control ng-model=vc.data.FirstDecDate readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=vc.data.FirstDecHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.FirstDecMin readonly></div></div></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>상담승인일</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.ApprDate\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>상담승인자</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.ApprUser_\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=vc.data.CounselField_ readonly></div></div><div class=col-lg-4 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=vc.data.HopeDuty_ readonly></div></div><!-- <div class=\"col-lg-2\" ng-show=\"HopeDutyEtcShow\">\r\n                <div class=\"form-group\">\r\n                  <label>희망직무기타</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.HopeDutyEtc\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --><div class=col-lg-4 ng-show=HopeLocListShow><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=vc.data.HopeLoc_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=vc.data.CounselField2_ readonly></div></div><div class=col-lg-4 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=vc.data.HopeDuty2_ readonly></div></div><!-- <div class=\"col-lg-2\" ng-show=\"HopeDutyEtcShow2\">\r\n                <div class=\"form-group\">\r\n                  <label>희망직무기타</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.HopeDutyEtc2\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --><div class=col-lg-4 ng-show=HopeLocListShow2><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=vc.data.HopeLoc2_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control ng-model=vc.data.CounselUser_ readonly></div></div><div class=col-lg-4><div class=form-group><label>전역후상담희망지역</label><input type=text class=form-control ng-model=vc.data.OutArmyCounselLoc_ readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담메모</label><textarea class=form-control ng-model=vc.data.CounselMemo rows=5 readonly></textarea></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>추가정보</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>병과</label><input type=text class=form-control ng-model=vc.data.Spec_ readonly></div></div><div class=col-lg-4><div class=form-group><label>임관일 또는 입대일</label><input type=text class=form-control ng-model=vc.data.InArmyDate readonly></div></div><div class=col-lg-4><div class=form-group><label>전역일</label><input type=text class=form-control ng-model=vc.data.OutArmyDate readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>주민번호</label><input type=text class=form-control ng-model=vc.data.ResRegNo readonly></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>전역후연락가능번호</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.OutArmyTel\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --></div><div class=row><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.data.Email readonly></div></div><!--  <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>등록자</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.CustArmyRegUser_\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>등록일</label>\r\n                  <input\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    ng-model=\"vc.data.CustArmyRegDate\"\r\n                    readonly=\"readonly\"\r\n                  />\r\n                </div>\r\n              </div> --></div><div class=row><div class=col-lg-2><div class=form-group><label>우편번호</label><input type=text class=form-control ng-model=vc.data.Zipcode readonly></div></div><div class=col-lg-5><div class=form-group><label>주소</label><input type=text class=form-control ng-model=vc.data.Addr1 readonly></div></div><div class=col-lg-5><div class=form-group><label>상세주소</label><input type=text class=form-control ng-model=vc.data.Addr2 readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 readonly></textarea></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>취업정보</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control placeholder=상담사 ng-value=vc.data.CounselUser_ readonly></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtRegDate ng-change=\"vc.jobinfo.RegDate = (dtRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=등록일 readonly></div></div><div class=col-lg-4><div class=form-group><label>회사명</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyNm placeholder=회사명 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>부서명</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyDept placeholder=부서명 readonly></div></div><div class=col-lg-4><div class=form-group><label>기업구분</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyGuBun_ placeholder=기업구분 readonly></div></div><div class=col-lg-4><div class=form-group><label>취업형태</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyWorkType_ placeholder=취업형태 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>직급</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyClass placeholder=직급 readonly></div></div><div class=col-lg-4><div><label>직책</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyJobTitle placeholder=직책 readonly></div></div><div class=col-lg-4><div class=form-group><label>취업확인일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDate ng-change=\"vc.jobinfo.CompanyRegDate = (dtCompanyRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=취업확인일 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>취업직종</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyType_ placeholder=취업직종 readonly></div></div><div class=col-lg-4><div class=form-group><label>급여/연봉(만원)</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyAmt placeholder=급여/연봉(만원) readonly></div></div><div class=col-lg-4><div class=form-group><label>입사일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDate ng-change=\"vc.jobinfo.CompanyJoinDate = (dtCompanyJoinDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=입사일 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>고용형태</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyEmploy_ placeholder=고용형태 readonly></div></div><div class=col-lg-4><div class=form-group><label>고용형태구분</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyEmployGuBun_ placeholder=고용형태구분 readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>비고</label><input type=text class=form-control ng-model=vc.jobinfo.CompanyRemark placeholder=비고 readonly></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>학력 및 경력</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><label>자격증</label><div class=addrow_pad><table class=table><tr><th>자격증</th><th>취득일자</th><th>시행처</th></tr><tr ng-repeat=\"li in LicenseJSON\"><td><span ng-bind=li.LicenseNm></span></td><td><span ng-bind=li.GetDate></span></td><td><span ng-bind=li.GetAgency></span></td></tr></table></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>학력</label><div class=addrow_pad><table class=table><tr><th>학교명</th><th>학력</th><th>전공명</th><th>졸업년월</th><th>졸업유무</th><th>학력구분</th><th>전공구분</th><th>전공계열</th><th>지역</th></tr><tr ng-repeat=\"li in EduJSON\"><td><span ng-bind=li.SchNm></span></td><td><span ng-bind=li.EduLev_></span></td><td><span ng-bind=li.MajorName></span></td><td><span ng-bind=li.OutSchDate></span></td><td><span ng-bind=li.OutSchYN_></span></td><td><span ng-bind=li.EduLevName_></span></td><td><span ng-bind=li.MajorType_ ng-show=\"li.EduLev != 4\"></span></td><td><span ng-bind=li.MajorSeries_></span></td><td><span ng-bind=li.Loc_></span></td></tr></table></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>경력</label><div class=addrow_pad><table class=table><tr><th>근무기간(시작)</th><th>근무기간(종료)</th><th>소속(회사명)</th><th>직급</th><th>담당업무</th></tr><tr ng-repeat=\"li in CareerJSON\"><td><span ng-bind=li.WorkDateFrom></span></td><td><span ng-bind=li.WorkDateTo></span></td><td><span ng-bind=li.CompNm></span></td><td><span ng-bind=li.Position></span></td><td><span ng-bind=li.Work></span></td></tr></table></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담일지</strong></h4><div class=pull-right><button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ui-sref=\"app.counsel.counselrecord-edit({CounselRecordId:\'\', CustArmyId:vc.data.CustArmyId})\"><i class=\"fa fa-edit\"></i> 상담일지추가</button>&nbsp;&nbsp;&nbsp; <a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><!--             <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <table id=\"searchTextResults\" ui-jq=\"footable\" data-filter=\"#filter\" data-page-size=\"100\" data-pagination=\"true\" class=\"footable table table-custom\">\r\n                  <thead>\r\n                    <tr>                      \r\n                      <th data-toggle=\"true\" class=\"text-center\">제목</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상담회차</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상담분야</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상담시간</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상담사</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상담일자</th>                      \r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>                    \r\n                    <tr ng-repeat=\"li in vc.lists\" ui-sref=\"app.counsel.counselrecord-detail({CounselRecordId:\'{{li.CounselRecordId}}\'})\" style=\"cursor: pointer;\" my-directive>                                            \r\n                      <td class=\"text-center\"><span ng-bind=\"li.Title\"></span></td>\r\n                      <td class=\"text-center\"><span ng-bind=\"li.CounselRound_\"></span></td>\r\n                      <td class=\"text-center\"><span ng-bind=\"li.CounselField_\"></span></td>\r\n                      <td class=\"text-center\"><span ng-bind=\"li.CounselTime_\"></span></td>                      \r\n                      <td class=\"text-center\"><span ng-bind=\"li.CounselUser_\"></span></td>\r\n                      <td class=\"text-center\"><span ng-bind=\"li.CounselDate\"></span></td>\r\n                    </tr>\r\n                  </tbody>\r\n                  <tfoot>\r\n                    <tr>\r\n                      <td colspan=\"9\" class=\"text-center\" bgcolor=\"#FFFFFF\">\r\n                        <ul class=\"pagination\" style=\"display: none;\">\r\n                        </ul>\r\n                      </td>\r\n                    </tr>\r\n                  </tfoot>\r\n                </table>\r\n                <div class=\"paging\">\r\n                  <ul uib-pagination data-ng-if=\"vc.totalItems\" total-items=\"vc.totalItems\" items-per-page=\"vc.srch.viewSize\" ng-model=\"vc.currentPage\" ng-change=\"vc.pageChanged()\"\r\n                    max-size=\"vc.maxSize\" boundary-links=\"true\" num-pages=\"vc.numPages\"></ul>\r\n                </div>\r\n              </div>\r\n            </div>    --><div ng-repeat=\"li in vc.lists\"><div class=row><div class=col-lg-2><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=li.CounselRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control ng-model=li.CounselUser_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=li.CounselField_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=li.HopeDuty_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>희망직무기타</label><input type=text class=form-control ng-model=li.HopeDutyEtc readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=li.HopeLoc_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=li.CounselField2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=li.HopeDuty2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow2><div class=form-group><label>희망직무기타</label><input type=text class=form-control ng-model=li.HopeDutyEtc2 readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=li.HopeLoc2_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-model=li.CounselDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-model=li.CounselDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.CounselDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselDateHopeNextMin readonly></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>제목</label><input type=text class=form-control ng-model=li.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=li.Content rows=5 readonly></textarea></div></div></div><div class=row><div class=col-lg-12 style=\"padding: 15px 15px 30px 15px\"><div style=\"height: 1px; background-color: #ddd\"></div></div></div></div><div ng-show=showListEmpty><div class=row><div class=col-lg-12>등록된 데이터가 없습니다.</div></div></div></div></div></div></div><!-- 이메일 발송이력 주석처리 --><!-- <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"tile\">\r\n          <div class=\"tile-header dvd dvd-btm b-l5\">\r\n            <h4 class=\"custom-font\">\r\n              <strong>이메일발송이력</strong>\r\n            </h4>\r\n            <div class=\"pull-right\">\r\n              <a href tile-control-toggle-hide>\r\n                <i class=\"fa fa-minus fa-lg\"></i>\r\n              </a>\r\n            </div>\r\n          </div>\r\n          <div class=\"tile-body\">\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <table\r\n                  id=\"searchTextResults\"\r\n                  data-filter=\"#filter\"\r\n                  data-page-size=\"100\"\r\n                  data-pagination=\"true\"\r\n                  class=\"table table-custom\"\r\n                >\r\n                  <thead>\r\n                    <tr>\r\n                      <th data-toggle=\"true\" class=\"text-center\">제목</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">내용</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">상태</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">발송일시</th>\r\n                      <th data-toggle=\"true\" class=\"text-center\">등록일시</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                    <tr ng-repeat=\"li in vc.listsEmail\">\r\n                      <td class=\"text-center\">\r\n                        <span ng-bind=\"li.Title_\"></span>\r\n                      </td>\r\n                      <td class=\"text-center\">\r\n                        <span ng-bind=\"li.SendMessage_\"></span>\r\n                      </td>\r\n                      <td class=\"text-center\">\r\n                        <span ng-bind=\"li.SendResult_\"></span>\r\n                      </td>\r\n                      <td class=\"text-center\">\r\n                        <span ng-bind=\"li.SendDate\"></span>\r\n                      </td>\r\n                      <td class=\"text-center\">\r\n                        <span ng-bind=\"li.RegDate\"></span>\r\n                      </td>\r\n                    </tr>\r\n                  </tbody>\r\n                  <tfoot>\r\n                    <tr>\r\n                      <td colspan=\"9\" class=\"text-center\" bgcolor=\"#FFFFFF\">\r\n                        <ul class=\"pagination\" style=\"display: none\"></ul>\r\n                      </td>\r\n                    </tr>\r\n                  </tfoot>\r\n                </table>\r\n                <div class=\"paging\">\r\n                  <ul\r\n                    uib-pagination\r\n                    data-ng-if=\"vc.totalItemsEmail\"\r\n                    total-items=\"vc.totalItemsEmail\"\r\n                    items-per-page=\"vc.srch.viewSizeEmail\"\r\n                    template-url=\"components/template/pagination.html\"\r\n                    ng-model=\"vc.currentPageEmail\"\r\n                    ng-change=\"vc.pageChangedEmail()\"\r\n                    max-size=\"vc.maxSizeEmail\"\r\n                    boundary-links=\"true\"\r\n                    num-pages=\"vc.numPagesEmail\"\r\n                  ></ul>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --></div><!-- /page content --></div>");
$templateCache.put("app/customer/customerarmy-edit.html","<script type=text/javascript charset=UTF-8 src=http://dmaps.daum.net/map_js_init/postcode.v2.js></script><script type=text/javascript>$(function () {\r\n    $(\'.phone-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 4) {\r\n        $(this).val(str);\r\n      } else if (str.length < 7) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3);\r\n\r\n        $(this).val(tmp);\r\n      } else if (str.length < 11) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      } else {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 4);\r\n        tmp += \'-\';\r\n        tmp += str.substr(7);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n\r\n    $(\'.resreg-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 7) {\r\n        $(this).val(str);\r\n      } else if (str.length < 13) {\r\n        tmp += str.substr(0, 6);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n  });</script><div class=\"page page-footable\" ng-controller=\"CustomerarmyEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>회원 등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>회원등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form id=form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">필수신청정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.customer.customerarmy-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>아이디</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-keyup=\"$event.keyCode === 13 && vc.serchArmyId()\" ng-model=vc.data.ArmyId placeholder=아이디 ng-readonly=\"vc.srch.CustArmyId != 0 && vc.srch.CustArmyId !== undefined\" ng-disabled=vc.disabled> <span class=input-group-btn ng-show=\"vc.srch.CustArmyId == 0 || vc.srch.CustArmyId === undefined\"><button class=\"btn btn-default\" type=button ng-click=vc.serchArmyId()>검색</button></span></div></div></div><div class=col-lg-2><div class=form-group><label>소속 / 지역(사여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat placeholder=소속></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.PermStatAddrList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>성명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.CustNm placeholder=성명 ng-keyup=\"vc.srch.CustArmyId == 0 && $event.keyCode === 13 && vc.showModalCustNameInfo()\" ng-readonly=\"vc.srch.CustArmyId != 0 && vc.srch.CustArmyId !== undefined\" ng-disabled=vc.disabled> <span class=input-group-btn ng-show=\"vc.srch.CustArmyId == 0 || vc.srch.CustArmyId === undefined\"><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustNameInfo()>검색</button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군번</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.ArmyNo placeholder=군번 ng-keyup=\"vc.srch.CustArmyId == 0 && $event.keyCode === 13 && vc.showModalCustGunbunInfo()\" ng-readonly=\"vc.srch.CustArmyId != 0 && vc.srch.CustArmyId !== undefined\" ng-disabled=vc.disabled> <span class=input-group-btn ng-show=\"vc.srch.CustArmyId == 0 || vc.srch.CustArmyId === undefined\"><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustGunbunInfo()>검색</button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback is-disabled=vc.ArmyClassReadOnly></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName placeholder=사업명 readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.data.ArmyAreaObj ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>참여차수</label><common-code param-data=vc.JoinCntList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>학력</label><common-code param-data=vc.LastEduList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>1지망 희망지역/희망직종</label><common-code param-data=vc.CounselLocList callback=vc.onSelectCallback2></common-code></div></div><div class=col-lg-2><div class=form-group><label ng-show=HopeJobTypeListShow>&nbsp;</label><common-code param-data=vc.HopeJobTypeList callback=vc.onSelectCallback7 ng-show=HopeJobTypeListShow></common-code></div></div><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>&nbsp;</label>\r\n                    <input\r\n                      type=\"text\"\r\n                      class=\"form-control\"\r\n                      ng-model=\"vc.data.HopeJobTypeEtc\"\r\n                      placeholder=\"희망직종기타\"\r\n                      ng-show=\"HopeJobTypeEtcShow\"\r\n                    />\r\n                  </div>\r\n                </div>--><div class=row><div class=col-lg-2><div class=form-group><label>2지망 희망지역/희망직종</label><common-code param-data=vc.CounselLocList2 callback=vc.onSelectCallback4></common-code></div></div><div class=col-lg-2><div class=form-group><label ng-show=HopeJobTypeListShow2>&nbsp;</label><common-code param-data=vc.HopeJobTypeList2 callback=vc.onSelectCallback4 ng-show=HopeJobTypeListShow2></common-code></div></div></div><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>&nbsp;</label>\r\n                    <input\r\n                      type=\"text\"\r\n                      class=\"form-control\"\r\n                      ng-model=\"vc.data.HopeJobTypeEtc2\"\r\n                      placeholder=\"희망직종기타\"\r\n                      ng-show=\"HopeJobTypeEtcShow2\"\r\n                    />\r\n                  </div>\r\n                </div>--></div><div class=row><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">상담가능연락처</label>\r\n                    <input\r\n                      type=\"text\"\r\n                      class=\"form-control phone-number-check\"\r\n                      ng-model=\"vc.data.CounselAbleTel\"\r\n                      placeholder=\"상담가능연락처\"\r\n                    />\r\n                  </div>\r\n                </div>--><div class=col-lg-4><div class=form-group><label class=txt_req>휴대폰</label><input type=text class=\"form-control phone-number-check\" ng-model=vc.data.Mobile placeholder=휴대폰></div></div><div class=col-lg-4><div class=form-group><label ng-show=HopeAmtShow>희망급여(만원)</label><input type=text class=form-control ng-model=vc.data.HopeAmt placeholder=희망급여 ng-show=HopeAmtShow></div></div><div class=col-lg-4><div class=form-group><label>1차상담희망일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstHopeDate ng-change=\"vc.data.FirstHopeDate = (dtFirstHopeDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=1차상담희망일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><!--<div class=\"row\">\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">상담신청등록자</label>\r\n                    <div class=\"input-group custom-search-form\">\r\n                      <input\r\n                        type=\"text\"\r\n                        readonly=\"readonly\"\r\n                        class=\"form-control\"\r\n                        placeholder=\"상담신청등록자\"\r\n                        ng-value=\"vc.data.CounselAppliRegUser_\"\r\n                      />\r\n                      <input\r\n                        type=\"hidden\"\r\n                        ng-value=\"vc.data.CounselAppliRegUser\"\r\n                      />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.showModalCounselAppliRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-search\"></i>\r\n                        </button>\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.clearModalCounselAppliRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">상담신청등록일</label>\r\n                    <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                      <input\r\n                        type=\"text\"\r\n                        class=\"form-control\"\r\n                        uib-datepicker-popup=\"{{format}}\"\r\n                        ng-model=\"dtCounselAppliRegDate\"\r\n                        ng-change=\"vc.data.CounselAppliRegDate = (dtCounselAppliRegDate | date: \'yyyy-MM-dd\')\"\r\n                        is-open=\"opened\"\r\n                        datepicker-options=\"dateOptions\"\r\n                        current-text=\"오늘\"\r\n                        clear-text=\"취소\"\r\n                        close-text=\"닫기\"\r\n                        placeholder=\"상담신청등록일\"\r\n                      />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          type=\"button\"\r\n                          class=\"btn btn-default\"\r\n                          ng-click=\"open($event)\"\r\n                        >\r\n                          <i class=\"glyphicon glyphicon-calendar\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=row><div class=col-lg-12><div class=form-group><label>관련파일</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group text-right\" ng-show=\"vc.srch.CustArmyId > 0\">최종수정이력: {{vc.data.EdtDate | date : \"yyyy-MM-dd HH:mm:dd\"}} ({{vc.data.EdtUser_}})</div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-2><div class=form-group><label>1차상담확정일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDate ng-change=\"vc.data.FirstDecDate = (dtFirstDecDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=1차상담확정일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=vc.FirstDecHourList callback=vc.onSelectCallback></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=vc.FirstDecMinList callback=vc.onSelectCallback></common-code></div></div></div></div><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">상담승인일</label>\r\n                    <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                      <input\r\n                        type=\"text\"\r\n                        class=\"form-control\"\r\n                        uib-datepicker-popup=\"{{format}}\"\r\n                        ng-model=\"dtApprDate\"\r\n                        ng-change=\"vc.data.ApprDate = (dtApprDate | date: \'yyyy-MM-dd\')\"\r\n                        is-open=\"opened\"\r\n                        datepicker-options=\"dateOptions\"\r\n                        current-text=\"오늘\"\r\n                        clear-text=\"취소\"\r\n                        close-text=\"닫기\"\r\n                        placeholder=\"상담승인일\"\r\n                      />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          type=\"button\"\r\n                          class=\"btn btn-default\"\r\n                          ng-click=\"open($event)\"\r\n                        >\r\n                          <i class=\"glyphicon glyphicon-calendar\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">상담승인자</label>\r\n                    <div class=\"input-group custom-search-form\">\r\n                      <input\r\n                        type=\"text\"\r\n                        readonly=\"readonly\"\r\n                        class=\"form-control\"\r\n                        placeholder=\"상담사\"\r\n                        ng-value=\"vc.data.ApprUser_\"\r\n                      />\r\n                      <input type=\"hidden\" ng-value=\"vc.data.ApprUser\" />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.showModalApprUser()\"\r\n                        >\r\n                          <i class=\"fa fa-search\"></i>\r\n                        </button>\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.clearModalApprUser()\"\r\n                        >\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>--></div><div class=row><div class=col-lg-2><div class=form-group><label>상담분야</label><common-code param-data=vc.CounselField1List callback=vc.onCounselField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField2List callback=vc.onCounselField2ListSelected></common-code></div></div><div class=col-lg-4 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><common-code param-data=vc.HopeDutyList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc placeholder=희망직무기타></div></div><div class=col-lg-4 ng-show=HopeLocListShow1><div class=form-group><label>취업희망지역</label><common-code param-data=vc.HopeLocList1 callback=vc.onSelectCallback3></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>취업희망지역(해외)</label><common-code param-data=vc.HopeLocList2 callback=vc.onSelectCallback3></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담분야</label><common-code param-data=vc.CounselField3List callback=vc.onCounselField3ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField4List callback=vc.onCounselField4ListSelected></common-code></div></div><div class=col-lg-4 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무</label><common-code param-data=vc.HopeDutyList2 callback=vc.onSelectCallback5></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc2 placeholder=희망직무기타></div></div><div class=col-lg-4 ng-show=HopeLocListShow3><div class=form-group><label>취업희망지역</label><common-code param-data=vc.HopeLocList3 callback=vc.onSelectCallback6></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow4><div class=form-group><label>취업희망지역(해외)</label><common-code param-data=vc.HopeLocList4 callback=vc.onSelectCallback6></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.data.CounselUser_> <input type=hidden ng-value=vc.data.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>전역후상담희망지역</label><common-code param-data=vc.OutArmyCounselLocList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담메모</label><textarea class=form-control ng-model=vc.data.CounselMemo rows=5 placeholder=상담메모></textarea></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>추가정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>병과</label><common-code param-data=vc.SpecList callback=vc.onSelectCallback></common-code><!-- <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.Spec\" placeholder=\"병과및특기\"> --></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>임관일 또는 입대일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtInArmyDate ng-change=\"vc.data.InArmyDate = (dtInArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=임관일자 id=dtInArmyDate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>전역일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtOutArmyDate ng-change=\"vc.data.OutArmyDate = (dtOutArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=전역일자 id=dtOutArmyDate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>생년월일</label><input type=text class=form-control ng-model=vc.data.ResRegNo placeholder=생년월일></div></div><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>전역후연락가능번호</label>\r\n                    <input\r\n                      type=\"text\"\r\n                      class=\"form-control\"\r\n                      ng-model=\"vc.data.OutArmyTel\"\r\n                      placeholder=\"전역후연락가능번호\"\r\n                    />\r\n                  </div>\r\n                </div>--></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>이메일</label><input type=text class=form-control ng-model=vc.data.Email placeholder=이메일></div></div><!--<div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">등록자</label>\r\n                    <div class=\"input-group custom-search-form\">\r\n                      <input\r\n                        type=\"text\"\r\n                        readonly=\"readonly\"\r\n                        class=\"form-control\"\r\n                        placeholder=\"등록자\"\r\n                        ng-value=\"vc.data.CustArmyRegUser_\"\r\n                      />\r\n                      <input type=\"hidden\" ng-value=\"vc.data.CustArmyRegUser\" />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.showModalCustArmyRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-search\"></i>\r\n                        </button>\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.clearModalCustArmyRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"txt_req\">등록일</label>\r\n                    <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                      <input\r\n                        type=\"text\"\r\n                        class=\"form-control\"\r\n                        uib-datepicker-popup=\"{{format}}\"\r\n                        ng-model=\"dtCustArmyRegDate\"\r\n                        ng-change=\"vc.data.CustArmyRegDate = (dtCustArmyRegDate | date: \'yyyy-MM-dd\')\"\r\n                        is-open=\"opened\"\r\n                        datepicker-options=\"dateOptions\"\r\n                        current-text=\"오늘\"\r\n                        clear-text=\"취소\"\r\n                        close-text=\"닫기\"\r\n                        placeholder=\"등록일\"\r\n                      />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          type=\"button\"\r\n                          class=\"btn btn-default\"\r\n                          ng-click=\"open($event)\"\r\n                        >\r\n                          <i class=\"glyphicon glyphicon-calendar\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>--></div><div class=row><div class=col-lg-2><div class=form-group><label>우편번호</label><div class=input-group><input type=text id=txtZipcode class=form-control ng-model=vc.data.Zipcode placeholder=우편번호> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"SearchZipcode(\'txtZipcode\', \'txtAddr1\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=col-lg-5><div class=form-group><label>주소</label><input type=text class=form-control id=txtAddr1 ng-model=vc.data.Addr1 placeholder=주소 readonly></div></div><div class=col-lg-5><div class=form-group><label>상세주소</label><input type=text class=form-control ng-model=vc.data.Addr2 placeholder=상세주소></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 placeholder=추가정보메모></textarea></div></div></div></div></div></div></div><!-- \r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"tile\">\r\n          <div class=\"tile-header dvd dvd-btm b-l5\">\r\n            <h4 class=\"custom-font\">\r\n              <strong>취업정보</strong>\r\n            </h4>\r\n            <label class=\"txt_req\"> 회사명 입력시 취업정보 모든 항목은 필수 입력입니다. 취업확인일은 수정 할 수 없습니다.</label>\r\n            <div class=\"pull-right\">\r\n              <a href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n              </a>\r\n            </div>\r\n          </div>          \r\n          <div class=\"tile-body\">          \r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>회사명</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyNm\" placeholder=\"회사명\">\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>부서명</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyDept\" placeholder=\"부서명\">\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>취업형태</label><common-code param-data=\"vc.CompanyWorkTypeList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n            </div>       \r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>직급</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyClass\" placeholder=\"직급\">\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>직책</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyJobTitle\" placeholder=\"직책\">\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>취업확인일</label>\r\n                  <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dtCompanyRegDate\" ng-change=\"vc.data.CompanyRegDate = (dtCompanyRegDate | date: \'yyyy-MM-dd\')\"\r\n                      is-open=\"opened\" datepicker-options=\"dateOptions\" current-text=\"오늘\" clear-text=\"취소\" close-text=\"닫기\" placeholder=\"취업확인일\" ng-readonly=\"CompanyRegDateReadOnly\" /> \r\n                    <span class=\"input-group-btn\" ng-show=\"!CompanyRegDateReadOnly\">\r\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"open($event)\">\r\n                        <i class=\"glyphicon glyphicon-calendar\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>      \r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>취업직종</label><common-code param-data=\"vc.CompanyTypeList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>급여/연봉(만원)</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyAmt\" placeholder=\"급여/연봉(만원)\">\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>입사일</label> \r\n                  <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"dtCompanyJoinDate\" ng-change=\"vc.data.CompanyJoinDate = (dtCompanyJoinDate | date: \'yyyy-MM-dd\')\"\r\n                      is-open=\"opened\" datepicker-options=\"dateOptions\" current-text=\"오늘\" clear-text=\"취소\" close-text=\"닫기\" placeholder=\"입사일\" /> \r\n                    <span class=\"input-group-btn\">\r\n                      <button type=\"button\" class=\"btn btn-default\" ng-click=\"open($event)\">\r\n                        <i class=\"glyphicon glyphicon-calendar\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </div>                         \r\n                </div>\r\n              </div>  \r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>고용형태</label><common-code param-data=\"vc.CompanyEmployList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>비고</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.CompanyRemark\" placeholder=\"비고\">\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n     --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>학력 및 경력</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><label>자격증</label>&nbsp;<input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowLicense()><div class=addrow_pad><!-- <p>JSON data: <br/>{{LicenseJSON}}</p> --><table class=table><tr><th>자격증</th><th>취득일자</th><th>시행처</th><th>삭제</th></tr><tr ng-repeat=\"li in LicenseJSON\"><td><input type=text ng-model=li.LicenseNm class=form-control> <input type=hidden ng-model=li.CustArmyLicenseId></td><td><input type=text ng-model=li.GetDate class=form-control placeholder=yyyy-mm-dd maxlength=10></td><td><input type=text ng-model=li.GetAgency class=form-control></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowLicense($index)></td></tr></table></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>학력</label>&nbsp;<input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowEdu()><div class=addrow_pad><!-- <p>JSON data: <br/>{{EduJSON}}</p>    --><table class=table><tr><th>학교명</th><th>학력</th><th>전공명</th><th>졸업년월</th><th>졸업유무</th><th>학력구분</th><th>전공구분</th><th>전공계열</th><th>지역</th><th>삭제</th></tr><tr ng-repeat=\"li in EduJSON\"><td><input type=text ng-model=li.SchNm class=form-control></td><td><select ng-model=li.EduLev class=form-control><option value=\"\">-------선택-------</option><option value=4>고등학교</option><option value=3>대학교</option><option value=2>대학교</option><option value=1>대학원</option></select><input type=hidden ng-model=li.CustArmyEduId></td><td><input type=text ng-model=li.MajorName class=form-control ng-show=\"li.EduLev != 4\"></td><td><input type=text ng-model=li.OutSchDate class=form-control placeholder=yyyy-mm maxlength=7></td><td><select ng-model=li.OutSchYN class=form-control><option value=\"\">---선택---</option><option value=1>졸업</option><option value=4>재학</option><option value=3>중퇴</option></select></td><td><select ng-model=li.EduLevName class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">---선택---</option><option value=3>전문학사</option><option value=4>학사</option><option value=1>석사</option><option value=2>박사</option></select></td><td><select ng-model=li.MajorType class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">전공</option><option value=B>복수전공</option></select></td><td><select ng-model=li.MajorSeries class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">---선택---</option><option value=160>예체능계열</option><option value=140>이공계열</option><option value=150>인문계열</option></select></td><td><select ng-model=li.Loc class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">-선택-</option><option value=1>서울</option><option value=5>부산</option><option value=7>인천</option><option value=3>대구</option><option value=4>대전</option><option value=2>광주</option><option value=6>울산</option><option value=8>경기</option><option value=9>강원</option><option value=10>경남</option><option value=11>경북</option><option value=12>전남</option><option value=13>전북</option><option value=14>충남</option><option value=15>충북</option><option value=16>제주</option><option value=20>아시아</option><option value=30>북미</option><option value=40>중남미</option><option value=50>유럽</option><option value=60>오세아니아</option><option value=70>아프리카</option></select></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowEdu($index)></td></tr></table></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>경력</label>&nbsp;<input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowCareer()><div class=addrow_pad><!-- <p>JSON data: <br/>{{CareerJSON}}</p>    --><table class=table><tr><th>근무기간(시작)</th><th>근무기간(종료)</th><th>소속(회사명)</th><th>직급</th><th>담당업무</th><th>삭제</th></tr><tr ng-repeat=\"li in CareerJSON\"><td><input type=text ng-model=li.WorkDateFrom class=form-control placeholder=yyyy-mm-dd maxlength=10> <input type=hidden ng-model=li.CustArmyCareerId></td><td><input type=text ng-model=li.WorkDateTo class=form-control placeholder=yyyy-mm-dd maxlength=10></td><td><input type=text ng-model=li.CompNm class=form-control></td><td><input type=text ng-model=li.Position class=form-control></td><td><input type=text ng-model=li.Work class=form-control></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowCareer($index)></td></tr></table></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.customer.customerarmy-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> &nbsp;&nbsp;&nbsp;</div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customerarmy-list.html","<div class=\"page page-footable\" ng-controller=\"CustomerarmyListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>회원 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>회원목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.srch.TenantNm readonly></div></div><div class=col-lg-2><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.srch.ArmyAreaObj ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.srch.Mobile placeholder=휴대폰></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>1차상담희망일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstHopeDateFrom ng-change=\"vc.srch.FirstHopeDateFrom = (dtFirstHopeDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담희망 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstHopeDateTo ng-change=\"vc.srch.FirstHopeDateTo = (dtFirstHopeDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담희망 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><!-- <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>상담신청등록자</label>\r\n                    <div class=\"input-group custom-search-form\">\r\n                      <input\r\n                        type=\"text\"\r\n                        readonly=\"readonly\"\r\n                        class=\"form-control\"\r\n                        placeholder=\"상담신청등록자\"\r\n                        ng-value=\"vc.srch.CounselAppliRegUser_\"\r\n                      />\r\n                      <input\r\n                        type=\"hidden\"\r\n                        ng-value=\"vc.srch.CounselAppliRegUser\"\r\n                      />\r\n                      <span class=\"input-group-btn\">\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.showModalCounselAppliRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-search\"></i>\r\n                        </button>\r\n                        <button\r\n                          class=\"btn btn-default\"\r\n                          type=\"button\"\r\n                          ng-click=\"vc.clearModalCounselAppliRegUser()\"\r\n                        >\r\n                          <i class=\"fa fa-eraser\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=col-lg-4><div class=form-group><label>상담신청등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselAppliRegDateFrom ng-change=\"vc.srch.CounselAppliRegDateFrom = (dtCounselAppliRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담신청등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselAppliRegDateTo ng-change=\"vc.srch.CounselAppliRegDateTo = (dtCounselAppliRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담신청등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>1차상담확정일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDateFrom ng-change=\"vc.srch.FirstDecDateFrom = (dtFirstDecDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담확정 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDateTo ng-change=\"vc.srch.FirstDecDateTo = (dtFirstDecDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"1차상담확정 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.CounselUser_> <input type=hidden ng-value=vc.srch.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>추가정보메모</label><input type=text class=form-control ng-model=vc.srch.AddMemo placeholder=추가정보메모></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>등록자</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=등록자 ng-value=vc.srch.CustArmyRegUser_> <input type=hidden ng-value=vc.srch.CustArmyRegUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustArmyRegUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCustArmyRegUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담메모</label><input type=text class=form-control ng-model=vc.srch.CounselMemo placeholder=상담메모></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담분야</label><common-code param-data=vc.CounselField1List callback=vc.onCounselField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CounselField2List callback=vc.onCounselField2ListSelected></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><common-code param-data=vc.HopeDutyList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.HopeDutyEtc placeholder=희망직무기타></div></div><div class=col-lg-2 ng-show=HopeLocListShow1><div class=form-group><label>희망지역</label><common-code param-data=vc.HopeLocList1 callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>희망지역(해외)</label><common-code param-data=vc.HopeLocList2 callback=vc.onSelectCallback></common-code></div></div><!-- \r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>연동여부</label>\r\n                  <common-code param-data=\"vc.LinkageYNList\" callback=\"vc.onSelectCallback\"></common-code>\r\n                </div>\r\n              </div>\r\n               --></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button><!-- <button\r\n                      class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\"\r\n                      activate-button\r\n                      ng-click=\"vc.showModalEmail()\"\r\n                      ng-show=\"showBtnEmail\"\r\n                    >\r\n                      <i class=\"fa fa-search\"></i> 선택이메일발송\r\n                    </button> --> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.customer.customerarmy-edit({CustArmyId:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button><!-- \r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.getExcelForWork()\" ng-show=\"showBtnExcel\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> 취업엑셀(교육원업로드용)\r\n                  </button>\r\n                  <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=\"vc.updateLinkageYNList()\" ng-show=\"showBtnLinkageYN\">\r\n                    <i class=\"fa fa-edit\"></i> 연동완료처리\r\n                  </button>\r\n                   --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}} &nbsp; <strong style=\"color: #d00\">* 정렬기준 : 등록일시 기준 정렬</strong><div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col width=20%><col width=20%><col><col><col></colgroup><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'CustNm\', \'Y\')\">성명<span><i class=\"{{vc.setSortDirect(\'CustNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNo\',\'Y\')\">군번<span><i class=\"{{vc.setSortDirect(\'ArmyNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyClass\',\'Y\')\">계급<span><i class=\"{{vc.setSortDirect(\'ArmyClass\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat1\',\'Y\')\">소속부대<span><i class=\"{{vc.setSortDirect(\'PermStat1\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속(사,여단급)<span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'HopeField1\',\'Y\')\">상담희망분야<span><i class=\"{{vc.setSortDirect(\'HopeField1\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CounselUser\',\'Y\')\">상담사<span><i class=\"{{vc.setSortDirect(\'CounselUser\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CustArmyRegDate\',\'Y\')\">등록일<span><i class=\"{{vc.setSortDirect(\'CustArmyRegDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'AplyRtrcnYmd\',\'Y\')\">취소일<span><i class=\"{{vc.setSortDirect(\'AplyRtrcnYmd\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=10 class=text-center>데이터가 없습니다.</td></tr><tr></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.viewSize)}}</td><td ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustNm></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyNo></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyClass_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.HopeField_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselUser_></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustArmyRegDate></span></td><td class=text-center ui-sref=\"app.customer.customerarmy-detail({CustArmyId:\'{{li.CustArmyId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.AplyRtrcnYmd></span></td></tr></tbody><tfoot><tr><td colspan=11 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><div><span class=infomark><i>!</i> 전역일 3년 이상 대상자의 개인정보는 삭제됩니다. (삭제 항목 : 아이디, 소속부대, 성명, 군번, 소속부대_사단, 소속부대_여단, 임관/입대일, 전역일, 휴대폰)</span></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/customer/jobinfoarmy-detail.html","<div class=\"page page-footable\" ng-controller=\"JobinfoarmyDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>고객 상세조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>취업상세조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>취업정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.customer.jobinfoarmy-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.customer.jobinfoarmy-edit({JobInfoId:\'{{vc.srch.JobInfoId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> {{ \'Menu.EDIT\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ArmyId placeholder=성명 readonly></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat placeholder=군번 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.data.CustNm placeholder=성명 ng-keyup=\"vc.srch.CustArmyId == 0 && $event.keyCode === 13 && vc.showModalCustNameInfo()\" readonly></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo placeholder=군번 ng-keyup=\"vc.srch.CustArmyId == 0 && $event.keyCode === 13 && vc.showModalCustGunbunInfo()\" readonly></div></div><div class=col-lg-4><div class=form-group><label>계급</label><input type=text class=form-control ng-model=vc.data.ArmyClass_ placeholder=군별 readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName placeholder=사업명 readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.ArmyArea_ placeholder=권역 readonly></div></div><div class=col-lg-4><div class=form-group><label>군별</label><input type=text class=form-control ng-model=vc.data.ArmyType_ placeholder=군별 readonly></div></div><div class=col-lg-4><div class=form-group><label>소속부대</label><input type=text class=form-control ng-model=vc.data.PermStat_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담희망분야</label><input type=text class=form-control ng-model=vc.data.HopeField_ placeholder=상담희망분야 readonly></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control placeholder=상담사 ng-value=vc.data.CounselUser_ readonly></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtRegDate ng-change=\"vc.data.RegDate = (dtRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=등록일 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>회사명</label><input type=text class=form-control ng-model=vc.data.CompanyNm placeholder=회사명 readonly></div></div><div class=col-lg-4><div class=form-group><label>부서명</label><input type=text class=form-control ng-model=vc.data.CompanyDept placeholder=부서명 readonly></div></div><div class=col-lg-4><div class=form-group><label>기업유형</label><input type=text class=form-control ng-model=vc.data.CompanyGuBun_ placeholder=기업유형 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>취업형태</label><input type=text class=form-control ng-model=vc.data.CompanyWorkType_ placeholder=취업형태 readonly></div></div><div class=col-lg-4><div class=form-group><label>직급</label><input type=text class=form-control ng-model=vc.data.CompanyClass placeholder=직급 readonly></div></div><div class=col-lg-4><div><label>직책</label><input type=text class=form-control ng-model=vc.data.CompanyJobTitle placeholder=직책 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>취업확인일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDate ng-change=\"vc.data.CompanyRegDate = (dtCompanyRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=취업확인일 readonly></div></div><div class=col-lg-4><div class=form-group><label>취업직종</label><input type=text class=form-control ng-model=vc.data.CompanyType_ placeholder=취업직종 readonly></div></div><div class=col-lg-4><div class=form-group><label>급여/연봉(만원)</label><input type=text class=form-control ng-model=vc.data.CompanyAmt placeholder=급여/연봉(만원) readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>입사일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDate ng-change=\"vc.data.CompanyJoinDate = (dtCompanyJoinDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=입사일 readonly></div></div><div class=col-lg-4><div class=form-group><label>고용형태</label><input type=text class=form-control ng-model=vc.data.CompanyEmploy_ placeholder=고용형태 readonly></div></div><div class=col-lg-4><div class=form-group><label>고용형태구분</label><input type=text class=form-control ng-model=vc.data.CompanyEmployGuBun_ placeholder=고용형태구분 readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>비고</label><input type=text class=form-control ng-model=vc.data.CompanyRemark placeholder=비고 readonly></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/jobinfoarmy-edit.html","<script type=text/javascript charset=UTF-8 src=http://dmaps.daum.net/map_js_init/postcode.v2.js></script><script type=text/javascript>$(function () {\r\n    $(\'.phone-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 4) {\r\n        $(this).val(str);\r\n      } else if (str.length < 7) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3);\r\n\r\n        $(this).val(tmp);\r\n      } else if (str.length < 11) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      } else {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 4);\r\n        tmp += \'-\';\r\n        tmp += str.substr(7);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n\r\n    $(\'.resreg-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 7) {\r\n        $(this).val(str);\r\n      } else if (str.length < 13) {\r\n        tmp += str.substr(0, 6);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n  });</script><div class=\"page page-footable\" ng-controller=\"JobinfoarmyEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>취업 등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>취업등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form id=form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>취업정보</strong></h4>&nbsp;<strong style=\"color: #d00\">*동일년도 동일 사업장은 취업등록 불가 (동일년도 기준: 취업확인일)</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.customer.jobinfoarmy-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>아이디</label><input type=text class=form-control ng-model=vc.data.ArmyId placeholder=아이디 readonly></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat placeholder=소속 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>성명</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.CustNm placeholder=성명 readonly><div class=\"input-group custom-search-form\" ng-if=\"vc.srch.JobInfoId == 0\"><input type=text class=form-control ng-model=vc.data.CustNm placeholder=성명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCustInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCustInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo ng-if=\"vc.srch.JobInfoId != 0\" placeholder=군번 readonly><div class=\"input-group custom-search-form\" ng-if=\"vc.srch.JobInfoId == 0\"><input type=text class=form-control ng-model=vc.data.ArmyNo placeholder=군번 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"vc.showModalCustInfo(\'ArmyNo\')\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=\"vc.clearModalCustInfo(\'ArmyNo\')\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>계급</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.ArmyClass_ placeholder=계급 readonly><common-code ng-if=\"vc.srch.JobInfoId == 0\" param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName placeholder=사업명 readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.ArmyArea_ placeholder=권역 readonly><select ng-if=\"vc.srch.JobInfoId == 0\" class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.data.ArmyArea style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option><option ng-repeat=\"li in vc.ArmyAreaList\" value={{li.Code}}>{{li.CodeValue}}</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군별</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.ArmyType_ placeholder=군별 readonly><common-code ng-if=\"vc.srch.JobInfoId == 0\" param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.PermStat1_ placeholder=소속부대1 readonly><common-code ng-if=\"vc.srch.JobInfoId == 0\" param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.PermStat2 placeholder=소속부대2 readonly> <input type=text class=form-control ng-if=\"vc.srch.JobInfoId == 0\" ng-model=vc.data.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>상담희망분야</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0\" ng-model=vc.data.HopeField1_ placeholder=상담희망분야1 readonly><common-code ng-if=\"vc.srch.JobInfoId == 0\" param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-if=\"vc.srch.JobInfoId != 0 && vc.data.HopeField1_ == 0\" ng-model=vc.data.HopeField2_ placeholder=상담희망분야2 readonly><common-code ng-if=\"vc.srch.JobInfoId == 0\" param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.data.CounselUser_> <input type=hidden ng-value=vc.data.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>등록일</label><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtRegDate ng-change=\"vc.data.RegDate = (dtRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=등록일 readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>회사명</label><input type=text class=form-control ng-model=vc.data.CompanyNm placeholder=회사명></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>부서명</label><input type=text class=form-control ng-model=vc.data.CompanyDept placeholder=부서명></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>기업유형</label><common-code param-data=vc.CompanyGuBunList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>취업형태</label><select class=form-control name=selectCombo ng-model=vc.data.CompanyWorkType style=\"padding: 5px !important\" ng-disabled=\"$root.gVariable.TenantId == 1\"><option value=\"\">-{{\'Menu.SELECT\'|translate}}-</option><option ng-repeat=\"li in vc.CompanyWorkTypeList\" value={{li.Code}}>{{li.CodeValue}}</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>직급</label><input type=text class=form-control ng-model=vc.data.CompanyClass placeholder=직급></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>직책</label><input type=text class=form-control ng-model=vc.data.CompanyJobTitle placeholder=직책></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>취업확인일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDate ng-change=\"vc.data.CompanyRegDate = (dtCompanyRegDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=취업확인일 ng-readonly=CompanyRegDateReadOnly> <span class=input-group-btn ng-show=!CompanyRegDateReadOnly><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>취업직종</label><common-code param-data=vc.CompanyTypeList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>급여/연봉(만원)</label><input type=text class=form-control ng-model=vc.data.CompanyAmt placeholder=급여/연봉(만원)></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>입사일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDate ng-change=\"vc.data.CompanyJoinDate = (dtCompanyJoinDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=입사일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>고용형태</label><common-code param-data=vc.CompanyEmployList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>고용형태구분</label><common-code param-data=vc.CompanyEmployGuBunList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>비고</label><input type=text class=form-control ng-model=vc.data.CompanyRemark placeholder=비고></div></div></div></div></div><span class=infomark><i>i</i>고용형태구분 항목 값 : ‘정규직, 단기근로, 계약직, 인턴’은 운영업무시스템>취업결과 입력 메뉴 ‘취(창)업구분’에서 ‘취업’으로 적용 / ‘창업’은 ‘창업’으로 적용<br><br><i>i</i>취업결과 등록 시, \'경력이관\'으로 강제 처리하여 운영업무시스템으로 연계(’25.10.1. 부) * 관련근거(공문) : 일자리사업팀-2502(’25.9.30.)</span></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/customer/jobinfoarmy-list.html","<div class=\"page page-footable\" ng-controller=\"JobinfoarmyListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>취업 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>회원관리</a></li><li><a>취업목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.srch.ArmyAreaObj ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담희망분야</label><common-code param-data=vc.HopeField1List callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.HopeField2List control-show=vc.HopeField2ListShow callback=vc.onHopeField2ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtRegDateFrom ng-change=\"vc.srch.RegDateFrom = (dtRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtRegDateTo ng-change=\"vc.srch.RegDateTo = (dtRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>취업확인일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDateFrom ng-change=\"vc.srch.CompanyRegDateFrom = (dtCompanyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDateTo ng-change=\"vc.srch.CompanyRegDateTo = (dtCompanyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>입사일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDateFrom ng-change=\"vc.srch.CompanyJoinDateFrom = (dtCompanyJoinDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDateTo ng-change=\"vc.srch.CompanyJoinDateTo = (dtCompanyJoinDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>고용형태</label><common-code param-data=vc.CompanyEmployList callback=vc.onHopeField1ListSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.CounselUser_> <input type=hidden ng-value=vc.srch.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.goAdd() ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}}&nbsp; <strong style=\"color: #d00\">* 정렬기준 : 등록일시 기준 정렬</strong><div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col><col width=20%><col><col><col><col><col><col></colgroup><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'CustNm\',\'Y\')\">성명<span><i class=\"{{vc.setSortDirect(\'CustNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별<span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNo\',\'Y\')\">군번<span><i class=\"{{vc.setSortDirect(\'ArmyNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyClass\',\'Y\')\">계급<span><i class=\"{{vc.setSortDirect(\'ArmyClass\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat1\',\'Y\')\">소속부대<span><i class=\"{{vc.setSortDirect(\'PermStat1\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Spec\',\'Y\')\">병과<span><i class=\"{{vc.setSortDirect(\'Spec\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CompanyNm\',\'Y\')\">취업처<span><i class=\"{{vc.setSortDirect(\'CompanyNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CompanyJoinDate\',\'Y\')\">입사일<span><i class=\"{{vc.setSortDirect(\'CompanyJoinDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'CompanyDept\',\'Y\')\">부서<span><i class=\"{{vc.setSortDirect(\'CompanyDept\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'UserNm\',\'Y\')\">상담사<span><i class=\"{{vc.setSortDirect(\'UserNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'RegDate\',\'Y\')\">등록일<span><i class=\"{{vc.setSortDirect(\'RegDate\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=13 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.viewSize)}}</td><td ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CustNm></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyType_></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyNo></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyClass_></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat_></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.Spec_></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CompanyNm></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CompanyJoinDate></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CompanyDept></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CounselUser_></span></td><td class=text-center ui-sref=\"app.customer.jobinfoarmy-detail({JobInfoId:\'{{li.JobInfoId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.RegDate></span></td></tr></tbody><tfoot><tr><td colspan=13 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --><div><span class=infomark><i>!</i> 전역일 3년 이상 대상자의 개인정보는 삭제됩니다. (삭제 항목 : 아이디, 소속부대, 성명, 군번, 소속부대_사단, 소속부대_여단, 임관/입대일, 전역일, 휴대폰)</span></div></div><!-- /page content --></div>");
$templateCache.put("app/dashboard/dashboard.html","<style>.card-container .card {\r\n    min-height: 90px;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"DashboardCtrl as vc\"><!-- page header --><div class=pageheader><h2>Dashboard</h2><!-- <div class=\"page-bar\">\r\n        <ul class=\"page-breadcrumb\">        \r\n          <li><a>Dashboard</a></li>\r\n        </ul>\r\n      </div> --></div><!-- /page header --><!-- page content--><div class=row><div class=\"card-container col-lg-4\" ui-sref=app.counsel.counselrecord-list><div class=card><div class=bg-greensea style=\"padding: 15px\"><div class=row><div class=col-xs-3><i class=\"fa fa-address-card fa-3x\"></i></div><div class=col-xs-9><p class=\"text-lg text-strong\">상담진행</p><p class=text-md>목표: {{vc.dataTopCnt.B_TargetTot}} 건</p><p class=text-md>실시: {{vc.dataTopCnt.B_RunCnt}} 건</p></div></div></div></div></div><!--  <div class=\"card-container col-lg-3\" ui-sref=\"app.counsel.counselrecord-list\">\r\n        <div class=\"card\">\r\n          <div class=\"bg-lightred\" style=\"padding: 15px;\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-3\">\r\n                <i class=\"fa fa-comments fa-3x\"></i>\r\n              </div>\r\n              <div class=\"col-xs-9\">\r\n                <p class=\"text-lg text-strong\">상담수행</p>\r\n                <p class=\"text-md\">목표: {{vc.dataTopCnt.B_TargetTot}} 회</p>\r\n                <p class=\"text-md\">실시: {{vc.dataTopCnt.B_RunCnt}} 회</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div> --><div class=\"card-container col-lg-4\" ui-sref=app.state.unitclass><div class=card><div class=bg-blue style=\"padding: 15px\"><div class=row><div class=col-xs-3><i class=\"fa fa-hourglass-2 fa-3x\"></i></div><div class=col-xs-9><p class=\"text-lg text-strong\">진도율</p><p class=text-md>상담신청: {{vc.dataTopCnt.C_AppliRate}} %</p><p class=text-md>상담수행: {{vc.dataTopCnt.C_RunRate}} %</p></div></div></div></div></div><div class=\"card-container col-lg-4\" ui-sref=app.counsel.schedule-list><div class=card><div class=bg-slategray style=\"padding: 15px\"><div class=row><div class=col-xs-3><i class=\"fa fa-calendar fa-3x\"></i></div><div class=col-xs-9><p class=\"text-lg text-strong\">금월수행현황</p><p class=text-md>상담신청: {{vc.dataTopCnt.D_AppliCnt}} 건</p><p class=text-md>상담수행: {{vc.dataTopCnt.D_RunCnt}} 건</p></div></div></div></div></div></div><!-- \r\n     <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n          <div class=\"tile\">\r\n            <div class=\"tile-body\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-12\">\r\n                  <div id=\"szCalendar\" ui-calendar=\"uiConfig.calendar\" ng-model=\"eventSources\" calendar=\"myCalendar\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n       --></div>");
$templateCache.put("app/mentoring/mentoringapply-list.html","<script>$(document).ready(function () {\r\n    var date = new Date();\r\n    var getYear = date.getFullYear();\r\n\r\n    var startYear = 2024;\r\n    var endYear = getYear;\r\n\r\n    for (var i = endYear; i >= startYear; i--) {\r\n      $(\'#p_plan_year\').append(\"<option value=\'\" + i + \"\'>\" + i + \'</option>\');\r\n    }\r\n  });</script><div class=\"page page-footable\" ng-controller=\"MentoringApplyListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>신청자조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>신청자조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><!-- <div class=\"pull-right\">\r\n                <a href tile-control-toggle-hide>\r\n                  <i class=\"fa fa-minus fa-lg\"></i>\r\n                </a>\r\n              </div> --></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=section-auto>신청년도</label><select class=\"form-control select-auto\" name=p_plan_year id=p_plan_year ng-model=vc.srch.year></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.MemberNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.srch.MemberUnit placeholder=소속(사,여단급) ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.srch.ClubNm placeholder=동아리팀></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.srch.Mobile placeholder=휴대폰></div></div><div class=col-lg-4><div class=form-group><label>신청일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtApplyDateFrom ng-change=\"vc.srch.ApplyDateFrom = (dtApplyDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"신청일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtApplyDateTo ng-change=\"vc.srch.ApplyDateTo = (dtApplyDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"신청일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=section-auto>개인정보조회</label><select class=\"form-control select-auto\" ng-model=vc.srch.isMasking><option value=Y>미표기</option><option value=N>표기</option></select></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}} &nbsp;<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults ui-jq=footable data-filter=#filter class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col><col><col><col><col><col></colgroup><thead><tr><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'MemberNm\',\'Y\')\">성명 <span><i class=\"{{vc.setSortDirect(\'MemberNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNo\',\'Y\')\">군번 <span><i class=\"{{vc.setSortDirect(\'ArmyNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별 <span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyClass\',\'Y\')\">계급 <span><i class=\"{{vc.setSortDirect(\'ArmyClass\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속(사,여단급) <span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyTerm\',\'Y\')\">복무구분 <span><i class=\"{{vc.setSortDirect(\'ArmyTerm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리팀 <span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubRole\',\'Y\')\">팀장/팀원 <span><i class=\"{{vc.setSortDirect(\'ClubRole\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Mobile\',\'Y\')\">휴대폰 <span><i class=\"{{vc.setSortDirect(\'Mobile\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Date\',\'Y\')\">신청일시 <span><i class=\"{{vc.setSortDirect(\'Date\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=11 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><!-- <td class=\"text-center\">\r\n                        <input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\" />\r\n                      </td> --><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.srch.viewSize)}}</td><td class=text-center><span ng-bind=li.MemberNm></span></td><td class=text-center><span ng-bind=li.ArmyNo></span></td><td class=text-center><span ng-bind=li.ArmyType></span></td><td class=text-center><span ng-bind=li.ArmyClass></span></td><td class=text-center><span ng-bind=li.PermStat></span></td><td class=text-center><span ng-bind=li.Term></span></td><td class=text-center><span ng-bind=li.ClubNm></span></td><td class=text-center><span ng-bind=li.ClubRole></span></td><td class=text-center><span ng-bind=li.Phone></span></td><td class=text-center><span ng-bind=li.ApplyDate></span></td></tr></tbody><tfoot><tr><td colspan=11 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringclub-detail.html","<div class=\"page page-footable\" ng-controller=\"MentoringClubDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>동아리팀 조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>동아리팀상세조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><!--목록버튼--> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringclub-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button><!--수정버튼--> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.mentoring.mentoringclub-edit({ClubId:\'{{vc.srch.ClubId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> {{ \'Menu.EDIT\' | translate }}</button><!--삭제버튼--><!-- <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=\"vc.deleteDetail()\"\r\n                    ng-show=\"showBtnDel\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button> --></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>팀명</label><input type=text class=form-control ng-model=vc.data.ClubNm readonly></div></div><div class=col-lg-4><div class=form-group><label>아이템분야</label><input type=text class=form-control ng-model=vc.data.ItemField_ readonly></div></div><div class=col-lg-4><div class=form-group><label>진행상태</label><input type=text class=form-control ng-model=vc.data.Progress_ readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=vc.data.TenantCodeNm readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.MentoringArea readonly></div></div><div class=col-lg-4><div class=form-group><label>군별</label><input type=text class=form-control ng-model=vc.data.ArmyType_ readonly></div></div><div class=col-lg-4><div class=form-group><label>소속부대</label><input type=text class=form-control ng-model=vc.data.PermStat_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>멘토</label><input type=text class=form-control ng-model=vc.data.MentoUser_ readonly></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>창업경진대회</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><div class=addrow_pad><table class=table><tr><th>대회구분</th><th>수상결과</th></tr><tr ng-repeat=\"li in ContestJSON\"><td><span ng-bind=li.ContestType></span></td><td><span ng-bind=li.ContestResult></span></td></tr></table></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>구성원</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><div class=addrow_pad><table class=table><tr><th>성명</th><th>군번</th><th>군별</th><th>소속(사,여단급)</th><th>팀정보</th></tr><tr ng-repeat=\"li in MemberJSON\"><td><span ng-bind=li.MemberNm></span></td><td><span ng-bind=li.ArmyNo></span></td><td><span ng-bind=li.ArmyType></span></td><td><span ng-bind=li.PermStat></span></td><td><span ng-bind=li.ClubRole></span></td></tr></table></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담일지</strong></h4><div class=pull-right><!-- <button\r\n                class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\"\r\n                activate-button=\"\"\r\n                ui-sref=\"app.mentoring.mentoringrecord-edit({MentoringRecordId:\'\', ClubId:vc.data.ClubId})\"\r\n              >\r\n                <i class=\"fa fa-edit\"></i> 상담일지추가</button\r\n              >&nbsp;&nbsp;&nbsp; --> <a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div ng-repeat=\"li in vc.lists\"><div class=row><div class=col-lg-2><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=li.MentoringRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><input type=text class=form-control ng-model=li.MentoUser_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-model=li.MentoringDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-model=li.MentoringDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.MentoringDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringDateHopeNextMin readonly></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>제목</label><input type=text class=form-control ng-model=li.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=li.Content rows=5 readonly></textarea></div></div></div><div class=row ng-if=\"li.uploadFileList.length > 0\"><div class=col-lg-12><div class=form-group><label>첨부파일</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col width=*><col width=140px><col width=140px></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in li.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><div class=col-lg-12 style=\"padding: 15px 15px 30px 15px\"><div style=\"height: 1px; background-color: #ddd\"></div></div></div></div><div ng-show=showListEmpty><div class=row><div class=col-lg-12>등록된 데이터가 없습니다.</div></div></div></div></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/mentoring/mentoringclub-edit.html","<script type=text/javascript charset=UTF-8 src=http://dmaps.daum.net/map_js_init/postcode.v2.js></script><div class=\"page page-footable\" ng-controller=\"MentoringClubEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>동아리팀 등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>동아리팀 등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form id=form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringclub-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>팀명</label><input type=text class=form-control ng-model=vc.data.ClubNm placeholder=팀명></div></div><div class=col-lg-4><div class=form-group><label>아이템분야</label><common-code param-data=vc.ItemFieldList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>진행상태</label><input type=text class=form-control ng-model=vc.data.Progress_ readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName placeholder=사업명 readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select class=form-control name=selectCombo ng-change=vc.onMentoringAreaListSelected() ng-model=vc.data.MentoringAreaObj ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별(팀장)</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected is-disabled=true></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대(팀장)</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.data.MentoUser_> <input type=hidden ng-value=vc.data.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div></div></div></div></div></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>창업경진대회</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><div class=addrow_pad><table class=table><tr><th class=col-lg-2>대회구분</th><th class=col-lg-9>수상결과</th><th class=col-lg-1><input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowContest()></th></tr><tr ng-repeat=\"li in ContestJSON\"><td><select ng-model=li.ContestCode class=form-control><option value=\"\">---선택---</option><option value=010>여단경진대회</option><option value=020>각군경진대회</option><option value=030>국방부경진대회</option><option value=040>범부처경진대회</option></select><input type=hidden ng-model=li.ContestId></td><td><input type=text ng-model=li.ContestResult class=form-control></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowContest($index)></td></tr></table></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringclub-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> &nbsp;&nbsp;&nbsp;</div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringclub-list.html","<div class=\"page page-footable\" ng-controller=\"MentoringClubListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>동아리팀 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>동아리팀 목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><!-- <div class=\"pull-right\">\r\n                  <a href tile-control-toggle-hide>\r\n                    <i class=\"fa fa-minus fa-lg\"></i>\r\n                  </a>\r\n                </div> --></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.srch.ClubNm placeholder=동아리팀></div></div><div class=col-lg-4><div class=form-group><label>아이템분야</label><common-code param-data=vc.ItemFieldList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.srch.MentoUser_> <input type=hidden ng-value=vc.srch.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.srch.TenantNm readonly></div></div><div class=col-lg-2><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onMentoringAreaListSelected() ng-model=vc.srch.MentoringAreaObj ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>창업경진대회</label><common-code param-data=vc.ContestList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>진행상태</label><common-code param-data=vc.ProgressList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=section-auto>개인정보조회</label><select class=\"form-control select-auto\" ng-model=vc.srch.isMasking><option value=Y>미표기</option><option value=N>표기</option></select></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button><!-- <button\r\n                        class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\"\r\n                        activate-button\r\n                        ng-click=\"vc.deleteList()\"\r\n                        ng-show=\"showBtnDel\"\r\n                      >\r\n                        <i class=\"fa fa-trash-o\"></i> 선택삭제\r\n                      </button> --><!-- <button\r\n                        class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\"\r\n                        activate-button\r\n                        ui-sref=\"app.mentoring.mentoringclub-edit({ClubId:\'\'})\"\r\n                        ng-show=\"showBtnAdd\"\r\n                      >\r\n                        <i class=\"fa fa-edit\"></i> 추가\r\n                      </button> --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}} &nbsp;<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults ui-jq=footable data-filter=#filter class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col><col><col><col><col><col></colgroup><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리팀 <span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'LeaderNm\',\'Y\')\">팀장 <span><i class=\"{{vc.setSortDirect(\'LeaderNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MemberNm\',\'Y\')\">팀원 <span><i class=\"{{vc.setSortDirect(\'MemberNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별 <span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속부대 <span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoUser\',\'Y\')\">멘토 <span><i class=\"{{vc.setSortDirect(\'MentoUser\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringArea\',\'Y\')\">권역 <span><i class=\"{{vc.setSortDirect(\'MentoringArea\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Date\',\'Y\')\">등록일 <span><i class=\"{{vc.setSortDirect(\'Date\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Progress\',\'Y\')\">진행상태 <span><i class=\"{{vc.setSortDirect(\'Progress\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=12 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.srch.viewSize)}}</td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ClubNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.LeaderNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MemberNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyType_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoUser_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringArea></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.RegDate></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringclub-detail({ClubId:\'{{li.ClubId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.Progress_></span></td></tr></tbody><tfoot><tr><td colspan=11 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringprtcp-detail.html","<div class=\"page page-footable\" ng-controller=\"MentoringPrtcpDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>참여자조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>참여자상세조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringprtcp-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.mentoring.mentoringprtcp-edit({PrtcpId:\'{{vc.srch.PrtcpId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> {{ \'Menu.EDIT\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.data.MemberNm readonly></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.data.ArmyNo readonly></div></div><div class=col-lg-4><div class=form-group><label>계급</label><input type=text class=form-control ng-model=vc.data.ArmyClass_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat readonly></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.data.Mobile readonly></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><input type=text class=form-control ng-model=vc.data.MentoUser_ readonly placeholder=멘토(예정)></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=vc.data.TenantCodeNm readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.MentoringArea readonly placeholder=권역(예정)></div></div><div class=col-lg-4><div class=form-group><label>군별</label><input type=text class=form-control ng-model=vc.data.ArmyType_ readonly></div></div><div class=col-lg-4><div class=form-group><label>소속부대</label><input type=text class=form-control ng-model=vc.data.PermStat_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.data.ClubNm readonly></div></div><div class=col-lg-4><div class=form-group><label>팀정보</label><input type=text class=form-control ng-model=vc.data.ClubRole_ readonly></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>추가정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>병과</label><input type=text class=form-control ng-model=vc.data.Spec_ readonly></div></div><div class=col-lg-4><div class=form-group><label>임관일 또는 입대일</label><input type=text class=form-control ng-model=vc.data.InArmyDate readonly></div></div><div class=col-lg-4><div class=form-group><label>전역일</label><input type=text class=form-control ng-model=vc.data.OutArmyDate readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>생년월일</label><input type=text class=form-control ng-model=vc.data.ResRegNo readonly></div></div><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.data.Email readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>우편번호</label><input type=text class=form-control ng-model=vc.data.ZipCode readonly></div></div><div class=col-lg-5><div class=form-group><label>주소</label><input type=text class=form-control ng-model=vc.data.Address readonly></div></div><div class=col-lg-5><div class=form-group><label>상세주소</label><input type=text class=form-control ng-model=vc.data.AddressDetail readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 readonly></textarea></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>학력정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>자격증</label>\r\n                  <div class=\"addrow_pad\">\r\n                    <table class=\"table\">\r\n                      <tr>\r\n                        <th>자격증</th>\r\n                        <th>취득일자</th>\r\n                        <th>시행처</th>\r\n                      </tr>\r\n                      <tr ng-repeat=\"li in LicenseJSON\">\r\n                        <td><span ng-bind=\"li.LicenseNm\"></span></td>\r\n                        <td><span ng-bind=\"li.GetDate\"></span></td>\r\n                        <td><span ng-bind=\"li.GetAgency\"></span></td>\r\n                      </tr>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><!-- <label>학력</label> --><div class=addrow_pad><table class=table><tr><th>학교명</th><th>학력</th><th>전공명</th><th>졸업년월</th><th>졸업유무</th><th>학력구분</th><th>전공구분</th><th>전공계열</th><th>지역</th></tr><tr ng-repeat=\"li in EduJSON\"><td><span ng-bind=li.SchNm></span></td><td><span ng-bind=li.EduLev_></span></td><td><span ng-bind=li.MajorName></span></td><td><span ng-bind=li.OutSchDate></span></td><td><span ng-bind=li.OutSchYn_></span></td><td><span ng-bind=li.EduLevName_></span></td><td><span ng-bind=li.MajorType_ ng-show=\"li.EduLev != 4\"></span></td><td><span ng-bind=li.MajorSeries_></span></td><td><span ng-bind=li.Loc_></span></td></tr></table></div></div></div></div><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>경력</label>\r\n                  <div class=\"addrow_pad\">\r\n                    <table class=\"table\">\r\n                      <tr>\r\n                        <th>근무기간(시작)</th>\r\n                        <th>근무기간(종료)</th>\r\n                        <th>소속(회사명)</th>\r\n                        <th>직급</th>\r\n                        <th>담당업무</th>\r\n                      </tr>\r\n                      <tr ng-repeat=\"li in CareerJSON\">\r\n                        <td><span ng-bind=\"li.WorkDateFrom\"></span></td>\r\n                        <td><span ng-bind=\"li.WorkDateTo\"></span></td>\r\n                        <td><span ng-bind=\"li.CompNm\"></span></td>\r\n                        <td><span ng-bind=\"li.Position\"></span></td>\r\n                        <td><span ng-bind=\"li.Work\"></span></td>\r\n                      </tr>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담일지</strong></h4><div class=pull-right><!-- <button\r\n                class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\"\r\n                activate-button=\"\"\r\n                ui-sref=\"app.mentoring.mentoringrecord-edit({MentoringRecordId:\'\', ClubId:vc.data.ClubId})\"\r\n              >\r\n                <i class=\"fa fa-edit\"></i> 상담일지추가</button\r\n              >&nbsp;&nbsp;&nbsp; --> <a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div ng-repeat=\"li in vc.lists\"><div class=row><div class=col-lg-2><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=li.MentoringRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><input type=text class=form-control ng-model=li.MentoUser_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-model=li.MentoringDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-model=li.MentoringDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.MentoringDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.MentoringDateHopeNextMin readonly></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>제목</label><input type=text class=form-control ng-model=li.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=li.Content rows=5 readonly></textarea></div></div></div><div class=row ng-if=\"li.uploadFileList.length > 0\"><div class=col-lg-12><div class=form-group><label>첨부파일</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col width=*><col width=140px><col width=140px></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in li.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><div class=col-lg-12 style=\"padding: 15px 15px 30px 15px\"><div style=\"height: 1px; background-color: #ddd\"></div></div></div></div><div ng-show=showListEmpty><div class=row><div class=col-lg-12>등록된 데이터가 없습니다.</div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringprtcp-edit.html","<script type=text/javascript charset=UTF-8 src=http://dmaps.daum.net/map_js_init/postcode.v2.js></script><script type=text/javascript>$(function () {\r\n    $(\'.phone-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 4) {\r\n        $(this).val(str);\r\n      } else if (str.length < 7) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3);\r\n\r\n        $(this).val(tmp);\r\n      } else if (str.length < 11) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      } else {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 4);\r\n        tmp += \'-\';\r\n        tmp += str.substr(7);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n\r\n    $(\'.resreg-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 7) {\r\n        $(this).val(str);\r\n      } else if (str.length < 13) {\r\n        tmp += str.substr(0, 6);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n  });</script><div class=\"page page-footable\" ng-controller=\"MentoringPrtcpEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>참여자 등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>참여자 등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form id=form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringprtcp-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>성명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.MemberNm placeholder=성명 ng-keyup=\"vc.srch.ApplyId == undefined && $event.keyCode === 13 && vc.showModalArmyInfo(\'MemberNm\')\" ng-readonly=\"vc.srch.ApplyId != 0 && vc.srch.ApplyId !== undefined\" ng-disabled=vc.disabled> <span class=input-group-btn ng-show=\"vc.srch.ApplyId == 0 || vc.srch.ArmyIApplyIdd === undefined\"><button class=\"btn btn-default\" type=button ng-click=\"vc.showModalArmyInfo(\'MemberNm\')\">검색</button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군번</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.ArmyNo placeholder=군번 ng-keyup=\"vc.srch.ApplyId == undefined && $event.keyCode === 13 && vc.showModalArmyInfo(\'ArmyNo\')\" ng-readonly=\"vc.srch.ApplyId != 0 && vc.srch.ApplyId !== undefined\" ng-disabled=vc.disabled> <span class=input-group-btn ng-show=\"vc.srch.ApplyId == 0 || vc.srch.ApplyId === undefined\"><button class=\"btn btn-default\" type=button ng-click=\"vc.showModalArmyInfo(\'ArmyNo\')\">검색</button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback is-disabled=true></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.data.PermStat placeholder=소속(사,여단급) ng-disabled=true></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>휴대폰</label><input type=text class=\"form-control phone-number-check\" ng-model=vc.data.Mobile placeholder=휴대폰></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\" ng-if=\"vc.data.ClubRole != \'0\'\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.data.MentoUser_> <input type=hidden ng-value=vc.data.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div><div ng-if=\"vc.data.ClubRole == \'0\'\"><input type=text class=form-control ng-model=vc.data.MentoUser_ placeholder=멘토(예정) ng-disabled=true></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName placeholder=사업명 readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select class=form-control name=selectCombo ng-change=vc.onMentoringAreaListSelected() ng-model=vc.data.MentoringAreaObj ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" ng-if=\"vc.data.ClubRole != \'0\'\" style=\"padding: 5px !important\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select><input type=text class=form-control ng-if=\"vc.data.ClubRole == \'0\'\" ng-model=vc.data.MentoringArea ng-disabled=true placeholder=권역(예정)></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected is-disabled=true></common-code></div></div><div class=col-lg-2><div class=form-group><label class=txt_req>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>동아리팀</label><input type=text class=form-control ng-model=vc.data.ClubNm placeholder=동아리팀 ng-disabled=true><!-- <div class=\"input-group custom-search-form\">\r\n                      <input\r\n                        type=\"text\"\r\n                        class=\"form-control\"\r\n                        ng-model=\"vc.data.ClubNm\"\r\n                        placeholder=\"동아리팀\"\r\n                        ng-keyup=\"vc.srch.ClubId == 0 && $event.keyCode === 13 && vc.showModalClubNameInfo()\"\r\n                        ng-readonly=\"vc.srch.ClubId != 0 && vc.srch.ClubId !== undefined\"\r\n                        ng-disabled=\"vc.disabled\"\r\n                      />\r\n                      <span\r\n                        class=\"input-group-btn\"\r\n                        ng-show=\"vc.srch.ClubId == 0 || vc.srch.ClubId === undefined\"\r\n                      >\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.showModalClubNameInfo()\">\r\n                          검색\r\n                        </button>\r\n                      </span>\r\n                    </div> --></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>팀정보</label><!-- <common-code param-data=\"vc.ClubRoleList\" callback=\"vc.onSelectCallback\" readonly=\"readonly\"></common-code> --> <input type=text class=form-control ng-model=vc.data.ClubRole_ placeholder=팀정보 ng-disabled=true></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">추가정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>병과</label><common-code param-data=vc.SpecList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>임관일 또는 입대일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtInArmyDate ng-change=\"vc.data.InArmyDate = (dtInArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=임관일자 id=dtInArmyDate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>전역일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtOutArmyDate ng-change=\"vc.data.OutArmyDate = (dtOutArmyDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=전역일자 id=dtOutArmyDate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>생년월일</label><input type=text class=form-control ng-model=vc.data.ResRegNo placeholder=생년월일></div></div><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.data.Email placeholder=이메일></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>우편번호</label><div class=input-group><input type=text id=txtZipcode class=form-control ng-model=vc.data.ZipCode placeholder=우편번호> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"SearchZipcode(\'txtZipcode\', \'txtAddr1\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=col-lg-5><div class=form-group><label>주소</label><input type=text class=form-control id=txtAddr1 ng-model=vc.data.Address placeholder=주소 readonly></div></div><div class=col-lg-5><div class=form-group><label>상세주소</label><input type=text class=form-control ng-model=vc.data.AddressDetail placeholder=상세주소></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>추가정보메모</label><textarea class=form-control ng-model=vc.data.AddMemo rows=5 placeholder=추가정보메모></textarea></div></div></div></div></div></div></div></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>학력정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>자격증</label>\r\n                  &nbsp;<input\r\n                    class=\"btn btn-default text-right;\"\r\n                    type=\"button\"\r\n                    value=\"행추가\"\r\n                    ng-click=\"addRowLicense()\"\r\n                  />\r\n                  <div class=\"addrow_pad\">\r\n                    <table class=\"table\">\r\n                      <tr>\r\n                        <th>자격증</th>\r\n                        <th>취득일자</th>\r\n                        <th>시행처</th>\r\n                        <th>삭제</th>\r\n                      </tr>\r\n                      <tr ng-repeat=\"li in LicenseJSON\">\r\n                        <td>\r\n                          <input type=\"text\" ng-model=\"li.LicenseNm\" class=\"form-control\" />\r\n                          <input type=\"hidden\" ng-model=\"li.LicenseId\" />\r\n                        </td>\r\n                        <td>\r\n                          <input\r\n                            type=\"text\"\r\n                            ng-model=\"li.GetDate\"\r\n                            class=\"form-control\"\r\n                            placeholder=\"yyyy-mm-dd\"\r\n                            maxlength=\"10\"\r\n                          />\r\n                        </td>\r\n                        <td>\r\n                          <input type=\"text\" ng-model=\"li.GetAgency\" class=\"form-control\" />\r\n                        </td>\r\n                        <td>\r\n                          <input\r\n                            class=\"btn btn-default\"\r\n                            type=\"button\"\r\n                            value=\"행삭제\"\r\n                            data-ng-click=\"removeRowLicense($index)\"\r\n                          />\r\n                        </td>\r\n                      </tr>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><!-- <label>학력</label> --> &nbsp;<input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowEdu()><div class=addrow_pad><!-- <p>JSON data: <br/>{{EduJSON}}</p>    --><table class=table><tr><th>학교명</th><th>학력</th><th>전공명</th><th>졸업년월</th><th>졸업유무</th><th>학력구분</th><th>전공구분</th><th>전공계열</th><th>지역</th><th>삭제</th></tr><tr ng-repeat=\"li in EduJSON\"><td><input type=text ng-model=li.SchNm class=form-control></td><td><select ng-model=li.EduLev class=form-control><option value=\"\">-------선택-------</option><option value=4>고등학교</option><option value=3>대학교</option><option value=2>대학교</option><option value=1>대학원</option></select><input type=hidden ng-model=li.PrtcpEduId></td><td><input type=text ng-model=li.MajorName class=form-control ng-show=\"li.EduLev != 4\"></td><td><input type=text ng-model=li.OutSchDate class=form-control placeholder=yyyy-mm maxlength=7></td><td><select ng-model=li.OutSchYn class=form-control><option value=\"\">---선택---</option><option value=1>졸업</option><option value=4>재학</option><option value=3>중퇴</option></select></td><td><select ng-model=li.EduLevName class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">---선택---</option><option value=3>전문학사</option><option value=4>학사</option><option value=1>석사</option><option value=2>박사</option></select></td><td><select ng-model=li.MajorType class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">전공</option><option value=B>복수전공</option><option value=S>부전공</option></select></td><td><select ng-model=li.MajorSeries class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">---선택---</option><option value=160>예체능계열</option><option value=140>이공계열</option><option value=150>인문계열</option></select></td><td><select ng-model=li.Loc class=form-control ng-show=\"li.EduLev != 4\"><option value=\"\">-선택-</option><option value=1>서울</option><option value=5>부산</option><option value=7>인천</option><option value=3>대구</option><option value=4>대전</option><option value=2>광주</option><option value=6>울산</option><option value=8>경기</option><option value=9>강원</option><option value=10>경남</option><option value=11>경북</option><option value=12>전남</option><option value=13>전북</option><option value=14>충남</option><option value=15>충북</option><option value=16>제주</option><option value=20>아시아</option><option value=30>북미</option><option value=40>중남미</option><option value=50>유럽</option><option value=60>오세아니아</option><option value=70>아프리카</option></select></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowEdu($index)></td></tr></table></div></div></div></div><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>경력</label>\r\n                  &nbsp;<input\r\n                    class=\"btn btn-default text-right;\"\r\n                    type=\"button\"\r\n                    value=\"행추가\"\r\n                    ng-click=\"addRowCareer()\"\r\n                  />\r\n                  <div class=\"addrow_pad\">\r\n                    <table class=\"table\">\r\n                      <tr>\r\n                        <th>근무기간(시작)</th>\r\n                        <th>근무기간(종료)</th>\r\n                        <th>소속(회사명)</th>\r\n                        <th>직급</th>\r\n                        <th>담당업무</th>\r\n                        <th>삭제</th>\r\n                      </tr>\r\n                      <tr ng-repeat=\"li in CareerJSON\">\r\n                        <td>\r\n                          <input\r\n                            type=\"text\"\r\n                            ng-model=\"li.WorkDateFrom\"\r\n                            class=\"form-control\"\r\n                            placeholder=\"yyyy-mm-dd\"\r\n                            maxlength=\"10\"\r\n                          />\r\n                          <input type=\"hidden\" ng-model=\"li.PrtcpCareerId\" />\r\n                        </td>\r\n                        <td>\r\n                          <input\r\n                            type=\"text\"\r\n                            ng-model=\"li.WorkDateTo\"\r\n                            class=\"form-control\"\r\n                            placeholder=\"yyyy-mm-dd\"\r\n                            maxlength=\"10\"\r\n                          />\r\n                        </td>\r\n                        <td>\r\n                          <input type=\"text\" ng-model=\"li.CompNm\" class=\"form-control\" />\r\n                        </td>\r\n                        <td>\r\n                          <input type=\"text\" ng-model=\"li.Position\" class=\"form-control\" />\r\n                        </td>\r\n                        <td>\r\n                          <input type=\"text\" ng-model=\"li.Work\" class=\"form-control\" />\r\n                        </td>\r\n                        <td>\r\n                          <input\r\n                            class=\"btn btn-default\"\r\n                            type=\"button\"\r\n                            value=\"행삭제\"\r\n                            data-ng-click=\"removeRowCareer($index)\"\r\n                          />\r\n                        </td>\r\n                      </tr>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --></div><div class=row><div class=col-sm-12><div class=pull-right><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringprtcp-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.setData() ng-disabled=vc.saveButtonDisable><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> &nbsp;&nbsp;&nbsp;</div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringprtcp-list.html","<div class=\"page page-footable\" ng-controller=\"MentoringPrtcpListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>참여자 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>참여자 목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><!-- <div class=\"pull-right\">\r\n                <a href tile-control-toggle-hide>\r\n                  <i class=\"fa fa-minus fa-lg\"></i>\r\n                </a>\r\n              </div> --></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.MemberNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.srch.TenantNm readonly></div></div><div class=col-lg-2><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onMentoringAreaListSelected() ng-model=vc.srch.MentoringAreaObj ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.srch.ClubNm placeholder=동아리팀></div></div><div class=col-lg-4><div class=form-group><label>등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtPrtcpDateFrom ng-change=\"vc.srch.PrtcpDateFrom = (dtPrtcpDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtPrtcpDateTo ng-change=\"vc.srch.PrtcpDateTo = (dtPrtcpDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.srch.MentoUser_> <input type=hidden ng-value=vc.srch.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=section-auto>개인정보조회</label><select class=\"form-control select-auto\" ng-model=vc.srch.isMasking><option value=Y>미표기</option><option value=N>표기</option></select></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.mentoring.mentoringprtcp-edit({ArmyNo:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}} &nbsp;<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults ui-jq=footable data-filter=#filter class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col><col><col><col><col><col><col><col></colgroup><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'MemberNm\',\'Y\')\">성명 <span><i class=\"{{vc.setSortDirect(\'MemberNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNo\',\'Y\')\">군번 <span><i class=\"{{vc.setSortDirect(\'ArmyNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별 <span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyClass\',\'Y\')\">계급 <span><i class=\"{{vc.setSortDirect(\'ArmyClass\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속부대 <span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyTerm\',\'Y\')\">복무구분 <span><i class=\"{{vc.setSortDirect(\'ArmyTerm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'SchLoc\',\'Y\')\">학교소재지 <span><i class=\"{{vc.setSortDirect(\'SchLoc\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리팀 <span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubRole\',\'Y\')\">팀정보 <span><i class=\"{{vc.setSortDirect(\'ClubRole\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoUser\',\'Y\')\">멘토 <span><i class=\"{{vc.setSortDirect(\'MentoUser\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Date\',\'Y\')\">등록일 <span><i class=\"{{vc.setSortDirect(\'Date\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=13 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.srch.viewSize)}}</td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MemberNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyNo></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyType></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyClass></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.Term></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.Loc_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ClubNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ClubRole></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoUser_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringprtcp-detail({PrtcpId:\'{{li.PrtcpId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PrtcpDate></span></td></tr></tbody><tfoot><tr><td colspan=13 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --> <span class=infomark><i>!</i> 참여자 삭제 이벤트 시, 운영업무시스템 > 신청자관리 > 멘토링참여 ‘O’에서 ‘X’ 로 변경 처리됩니다.</span></div>");
$templateCache.put("app/mentoring/mentoringrecord-detail.html","<div class=\"page page-footable\" ng-controller=\"MentoringrecordDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>멘토링보고서 조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>멘토링보고서 조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.openPrintModal()><i class=\"fa fa-list\"></i>보고서PDF</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.mentoring.mentoringrecord-edit({RecordId:\'{{vc.srch.RecordId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i>수정</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i>삭제</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.data.ClubNm readonly></div></div><div class=col-lg-4><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=vc.data.MentoringRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>상담방법</label><input type=text class=form-control ng-value=vc.data.MentoringMethod_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>멘토</label><input type=text class=form-control ng-value=vc.data.MentoUser_ readonly></div></div><div class=col-lg-4><div class=form-group><label>진행상태</label><input type=text class=form-control ng-value=vc.data.Progress_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-value=vc.data.MentoringDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-value=vc.data.MentoringDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=vc.data.MentoringDateHopeNextMin readonly></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>제목</label><input type=text class=form-control ng-model=vc.data.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=vc.data.Content rows=20 readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>첨부파일</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col width=*><col width=140px><col width=140px></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/mentoring/mentoringrecord-edit.html","<script type=text/javascript>$(function () {\r\n    $(\'.phone-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 4) {\r\n        $(this).val(str);\r\n      } else if (str.length < 7) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3);\r\n\r\n        $(this).val(tmp);\r\n      } else if (str.length < 11) {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      } else {\r\n        tmp += str.substr(0, 3);\r\n        tmp += \'-\';\r\n        tmp += str.substr(3, 4);\r\n        tmp += \'-\';\r\n        tmp += str.substr(7);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n\r\n    $(\'.resreg-number-check\').on(\'keyup\', function (e) {\r\n      var str = $(this)\r\n        .val()\r\n        .replace(/[^0-9]/g, \'\');\r\n      var tmp = \'\';\r\n\r\n      if (str.length < 7) {\r\n        $(this).val(str);\r\n      } else if (str.length < 13) {\r\n        tmp += str.substr(0, 6);\r\n        tmp += \'-\';\r\n        tmp += str.substr(6);\r\n\r\n        $(this).val(tmp);\r\n      }\r\n    });\r\n  });</script><div class=\"page page-footable\" ng-controller=\"MentoringrecordEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>멘토링보고서 등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>멘토링보고서</a></li><li><a>멘토링보고서 등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><!-- <div class=\"pull-right\">\r\n              <a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i> </a>\r\n            </div> --></div><!-- /tile header --><div class=\"row mt-15\"><div class=col-sm-12><div class=pull-right><!-- <button\r\n                  class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\"\r\n                  activate-button\r\n                  type=\"button\"\r\n                  ng-click=\"vc.showModalCounselRecordList()\"\r\n                >\r\n                  이전상담내역보기\r\n                </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.beforeSetData()><i class=\"fa fa-save\"></i>저장</button>&nbsp;&nbsp;</div></div></div><!-- tile body --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>동아리팀</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=동아리팀 ng-value=vc.data.ClubNm> <input type=hidden ng-value=vc.data.ClubId> <span class=input-group-btn ng-show=\"vc.srch.ClubId == 0 || vc.srch.ClubId === undefined\"><button class=\"btn btn-default\" type=button ng-click=vc.showModalClubInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalClubInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담회차</label><common-code param-data=vc.MentoringRoundList callback=vc.onSelectCallback is-disabled=true></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담방법</label><common-code param-data=vc.MentoringMethodList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.data.MentoUser_> <input type=hidden ng-value=vc.data.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>진행상태</label><common-code param-data=vc.ProgressList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtMentoringDate ng-change=\"vc.data.MentoringDate = (dtMentoringDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=상담일자> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담시간</label><div class=input-group><div class=input-group><common-code param-data=vc.MentoringTimeFromHourList callback=vc.onSelectCallback2></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=vc.MentoringTimeFromMinList callback=vc.onSelectCallback2></common-code></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><common-code param-data=vc.MentoringTimeToHourList callback=vc.onSelectCallback3></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=vc.MentoringTimeToMinList callback=vc.onSelectCallback3></common-code></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtMentoringDateHopeNext ng-change=\"vc.data.MentoringDateHopeNext = (dtMentoringDateHopeNext | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=다음상담희망일시> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=vc.MentoringDateHopeNextHourList callback=vc.onSelectCallback></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=vc.MentoringDateHopeNextMinList callback=vc.onSelectCallback></common-code></div></div></div></div></div><!-- <div class=\"row\">\r\n              \r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><label class=txt_req>제목</label><input type=text class=form-control ng-model=vc.data.Title placeholder=제목 maxlength=45></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label class=txt_req>상담내용</label><textarea class=form-control ng-model=vc.data.Content rows=20 placeholder=상담내용 maxlength=4000></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach><label>※ {{ \'Menu.ATTACHEDFILE\' | translate }}(최대 4개, 개별 최대용량: 3MB, 첨부가능 확장자: jpg, gif, png)</label></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><!-- <button\r\n                  class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\"\r\n                  activate-button\r\n                  type=\"button\"\r\n                  ng-click=\"vc.showModalCounselRecordList()\"\r\n                >\r\n                  이전상담내역보기\r\n                </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.mentoring.mentoringrecord-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=button ng-click=vc.beforeSetData()><i class=\"fa fa-save\"></i>저장</button> &nbsp;&nbsp;&nbsp;</div></div></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringrecord-list.html","<div class=\"page page-footable\" ng-controller=\"MentoringrecordListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>멘토링보고서 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>멘토링보고서 목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><!-- <div class=\"pull-right\">\r\n                <a href tile-control-toggle>\r\n                  <i class=\"fa fa-minus fa-lg\"></i>\r\n                </a>\r\n              </div> --></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.srch.ClubNm placeholder=동아리팀></div></div><div class=col-lg-4><div class=form-group><label>상담제목</label><input type=text class=form-control ng-model=vc.srch.Title placeholder=\"상담제목 \"></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.srch.MentoUser_> <input type=hidden ng-value=vc.srch.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select name=selectCombo class=form-control ng-model=vc.srch.MentoringAreaObj ng-change=vc.onMentoringAreaListSelected() ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담회차</label><common-code param-data=vc.MentoringRoundList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>상담일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtMentoringDateFrom ng-change=\"vc.srch.MentoringDateFrom = (dtMentoringDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtMentoringDateTo ng-change=\"vc.srch.MentoringDateTo = (dtMentoringDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ui-sref=\"app.mentoring.mentoringrecord-edit({RecordId:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}} &nbsp; <strong style=\"color: #d00\">* 정렬기준 : 등록일시 기준 정렬</strong><div class=pull-right><label>페이지당 목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-striped\"><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리팀<span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Title\',\'Y\')\">상담제목<span><i class=\"{{vc.setSortDirect(\'Title\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringRound\',\'Y\')\">상담회차<span><i class=\"{{vc.setSortDirect(\'MentoringRound\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'UserNm\',\'Y\')\">멘토<span><i class=\"{{vc.setSortDirect(\'UserNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringDate\',\'Y\')\">상담일<span><i class=\"{{vc.setSortDirect(\'MentoringDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringTime\',\'Y\')\">상담시간<span><i class=\"{{vc.setSortDirect(\'MentoringTime\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringArea\',\'Y\')\">권역<span><i class=\"{{vc.setSortDirect(\'MentoringArea\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별<span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속부대<span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.srch.viewSize)}}</td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ClubNm></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.Title></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringRound_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoUser_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringDate></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringTime></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringArea></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyType_></span></td><td class=text-center ui-sref=\"app.mentoring.mentoringrecord-detail({RecordId:\'{{li.RecordId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.PermStat></span></td></tr></tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=11 class=text-center>데이터가 없습니다.</td></tr><tfoot><tr><td colspan=11 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/mentoringschedule-list.html","<div class=\"page page-footable\" ng-controller=\"MentoringScheduleListCtrl as vc\"><!-- page header --><div class=pageheader><h2>멘토링일정</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a href=javascript:;>창업멘토링</a></li><li><a ui-sref=app.mentoring.schedule-list>멘토링일정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\" class=no-Print><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><!-- 성명 --><div class=col-lg-4><div class=form-group><label>동아리팀</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=동아리팀 ng-value=vc.srch.ClubNm> <input type=hidden ng-model=vc.srch.ClubId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalClubInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalClubInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><!-- 멘토 --><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.srch.MentoUser_> <input type=hidden ng-model=vc.srch.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>사업명/권역</label><input type=text class=form-control ng-model=$root.gVariable.TenantName readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><select name=selectCombo class=form-control ng-model=vc.srch.MentoringAreaObj ng-change=vc.onMentoringAreaListSelected() ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대2></div></div></div><div class=row ng-if=\"vc.listType == \'list\'\"><div class=col-lg-4><div class=form-group><label>기간</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDateFrom ng-change=\"vc.srch.DateFrom = (dtDateFrom | date: \'yyyyMMdd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"검색기간 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDateTo ng-change=\"vc.srch.DateTo = (dtDateTo | date: \'yyyyMMdd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"검색기간 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-if=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-if=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.listTypeChg()><i class=\"fa fa-list\"></i>{{vc.listTypeBtn}}</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.print()><i class=\"fa fa-list\"></i>출력</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div></div></div></div></div><!-- row --></form><div class=row ng-if=\"vc.listType === \'calendar\'\"><div class=col-lg-12><div class=tile><div class=tile-body><div class=row><div class=col-lg-12><!-- 달력--><div id=szCalendar ui-calendar=uiConfig.calendar ng-model=eventSources calendar=myCalendar></div></div></div></div></div></div></div><div class=row ng-if=\"vc.listType === \'list\'\"><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}} &nbsp; <strong style=\"color: #d00\">* 정렬기준 : 등록일시 기준 정렬</strong><div class=pull-right><label>페이지당 목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-striped\"><thead><tr><th class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리팀<span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoUser\',\'Y\')\">멘토<span><i class=\"{{vc.setSortDirect(\'MentoUser\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'StartYMD\',\'Y\')\">상담일<span><i class=\"{{vc.setSortDirect(\'StartYMD\')}} ml-5\"></i></span></th><th class=text-center>상담시간<span><i class=ml-5></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringArea\',\'Y\')\">권역<span><i class=\"{{vc.setSortDirect(\'MentoringArea\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyType\',\'Y\')\">군별<span><i class=\"{{vc.setSortDirect(\'ArmyType\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속부대<span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.srch.viewSize)}}</td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=li.ClubNm></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoUser_></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=\"li.StartYMD.substr(0,4)+\'-\'+li.StartYMD.substr(4,2)+\'-\'+li.StartYMD.substr(6,2)\"></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=\"li.StartHour+\':\'+li.StartMin\"></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=li.MentoringArea></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=li.ArmyType_></span></td><td class=text-center ng-click=vc.showScheduleModalPopup(li.SchId) style=\"cursor: pointer\" my-directive><span ng-bind=\"li.PermStat1+\'>\'+li.PermStat2\"></span></td></tr></tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=11 class=text-center>데이터가 없습니다.</td></tr><tfoot><tr><td colspan=11 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-auto-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignAutoListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>자동발송 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><!-- 목록 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!-- <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.CmpgnImplCustId}\"><!-- Result Items --><!-- <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\"> --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goDetail(li.CmpgnImplCustId, li.CmpgnType)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'MM-dd HH:mm\')}}</td></tr></tbody></table><!-- NO DATA --><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><!-- / NO DATA --><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-customer-detail.html","<div class=\"page page-footable\" ng-controller=\"CampaignCustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>문자발송 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><div class=form-control>{{vc.data.CmpgnChannel}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송정보</label><div class=form-control>{{vc.data.FromInfo}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신자명</label><div class=form-control>{{vc.data.ToNm}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신정보</label><div class=form-control>{{vc.data.ToInfo}}</div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송일시</label><div class=form-control>{{ vc.data.RegDate | date: \'yyyy-MM-dd HH:mm\'}}</div></div></div></div><div ng-if=\"vc.data.CmpgnChannel != \'SMS\'\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><div class=form-control>{{vc.data.SendTitle}}</div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><div class=form-control ng-bind=vc.data.SendMessage style=min-height:300px></div><div class=text-right>[{{ vc.data.CmpgnChannel }}] {{ vc.messageLength }} / {{ vc.messageMaxLength }} bytes</div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>사용자명</td><td class=text-center>{사용자명}</td></tr></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/message/campaign-customer-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignCustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>문자발송 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><!-- 검색 영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>검색 항목</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><input type=hidden class=form-control ng-model=vc.srch.GrpId><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control ng-model=vc.srch.CmpgnChannel><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송유형</label><common-code-custom code-list=\"vc.columnMap[\'SendType\'].CodeList\" code-model=vc.srch.SendType is-disabled=false></common-code-custom></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송내용</label><input type=text class=form-control ng-model=vc.srch.SendMessage></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.srch.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>등록일</label><div class=row><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><!-- <div class=\"col-lg-12\">\r\n                        <div class=\"form-group form-inline\">\r\n                          <label>발송메세지</label>\r\n                          <input type=\"text\" class=\"form-control\" ng-model=\"vc.srch.SendMessage\" />\r\n                        </div>\r\n                      </div> --><!--                       \r\n                      <div class=\"col-lg-4\">\r\n                        <div class=\"form-group form-inline\">\r\n                          <label>발송채널</label>\r\n                          <common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=\"vc.srch.CmpgnChannel\" is-disabled=\"false\"></common-code-custom>\r\n                        </div>\r\n                      </div>\r\n--></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList();><i class=\"fa fa-search\"></i> 검색</button> <button type=button class=\"btn btn-default\" activate-button ng-click=vc.setResetSearch();><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button><!-- 	                      <button type=\"button\" class=\"btn btn-primary\" activate-button ng-click=\"vc.goAdd(\'GROUP\');\"><i class=\"fa fa-edit\"></i> 문자발송  등록</button> --><!-- <button type=\"button\" class=\"btn btn-primary\" activate-button ng-click=\"vc.goAdd(\'AUTO\');\"><i class=\"fa fa-edit\"></i> 문자발송  등록</button> --><!-- <button type=\"button\" class=\"btn btn-danger\" activate-button type=\"button\" ng-click=\"vc.delNode();\" ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> --></div></div></form></div></div></div></div><!-- 목록 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr class=tbnodata><td class=text-right style=\"background-color: #eee\"><p><span><i class=\"fa fa-circle-o\"></i> 성공발송건수: <strong><span comma-bind ng-bind=vc.SuccessSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span><i class=\"fa fa-times\"></i> 실패발송건수: <strong><span comma-bind ng-bind=vc.FailSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span><i class=\"fa fa-krw\"></i> 성공합계금액: <strong><span comma-bind ng-bind=vc.SumCost></span></strong>원</span></p></td></tr></thead></table><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!-- <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.CmpgnImplCustId}\"><!-- Result Items --><!-- <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\"> --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goDetail(li.CmpgnImplCustId, li.CmpgnType)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'MM-dd HH:mm\')}}</td></tr></tbody></table><!-- NO DATA --><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><!-- / NO DATA --><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignImplListCtrl as vc\"><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- page content --><!-- page header --><!-- <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      <div class=\"page-header\">발송 목록\r\n        <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=\"assets/images/icon-sp-list.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div> --><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SendTitle placeholder=\"제목 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-result-detail.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"CampaignResultDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>개별 메세지 결과 조회</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.data.keyId && (vc.layout == \'N\' || vc.layout == \'\')\"><i class=\"fa fa-list\"></i> {{\'Menu.LIST\' | translate }}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-result-list.html","<style>.cols-SendMessage {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"CampaignResultListCtrl as vc\"><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table></div><div fa-pane pane-min=750px ng-if=\"vc.layout != \'N\'\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/email-certifi-list.html","<div class=\"page page-footable\" ng-controller=\"EmailCertifiListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>Email발신인증</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.openEmailCertifiModal();><i class=\"fa fa-edit\"></i> 등록</button></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=\"text-center none\" style=\"width: 65px\">삭제</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-bind-html=\"liCol.ColumnLogicalDataType == \'90\' ?\r\n                          (li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD\') : liCol.ColumnLogicalDataType == \'70\' ?  (li[liCol.ColumnPhysicalNm] | toHyphenContact) : liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? \r\n                          (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis\"></td><td class=text-center><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.setDelData(li);>{{ \'Menu.DELETE\' | translate }}</button></td></tr></tbody></table><div class=tbnodata ng-if=\"vc.totalItems == 0\" style=\"text-align: center; padding: 15px; border-right: 1px solid rgb(204, 204, 204); border-bottom: 1px solid rgb(204, 204, 204); border-left: 1px solid rgb(204, 204, 204); border-image: initial; border-top: none\">조회할 데이터가 없습니다.</div><div class=row ng-if=\"vc.totalItems > 0\"><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/form-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div ng-controller=\"FormEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12 style=\"top: 10px\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\" style=\"margin-top: 0\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.contentsModal() ng-if=\"vc.formType == \'EMAIL\'\"><i class=\"fa fa-image\"></i> 미리보기</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-if=vc.isMine><i class=\"fa fa-save\"></i> 저장</button></div></div></div><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서식 등록/수정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=col-lg-8><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-5><div class=\"form-group form-inline\"><label uib-tooltip=발송채널>발송채널</label><select class=form-control disabled><option ng-if=\"vc.formType == \'SMS\' || vc.formType == \'LMS\'\" value=\"\">SMS</option><option ng-if=\"vc.formType == \'EMAIL\'\" value=\"\">EMAIL</option><option ng-if=\"vc.formType == \'KAKAO\'\" value=\"\">알림톡</option></select></div></div><div class=col-lg-5 ng-if=\"vc.formType == \'KAKAO\' && vc.loginSysAdminYN\"><div class=\"form-group form-inline\"><label uib-tooltip=승인상태>승인상태</label><select class=form-control ng-model=vc.data.ApprovalYN><option value=\"\">-- 선택 --</option><option value=Y>승인</option><option value=N>승인대기</option></select></div></div></div><div class=row><div class=col-lg-10><div class=\"form-group form-inline\"><label uib-tooltip=서식명>서식명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm ng-disabled=!vc.isMine></div></div></div><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=form-group><div class=col-sm-10><script type=text/javascript>var oEditors = [];\r\n                    \r\n                      var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n                    \r\n                      // 추가 글꼴 목록\r\n                      //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n                      nhn.husky.EZCreator.createInIFrame({\r\n                        oAppRef : oEditors,\r\n                        elPlaceHolder : \"strHtml\",\r\n                        sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n                        htParams : {\r\n                          bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n                          bUseVerticalResizer : true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n                          bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n                          //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n                          //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n                          fOnBeforeUnload : function() {\r\n                            //alert(\"완료!\");\r\n                          },\r\n                          I18N_LOCALE : sLang\r\n                        }, //boolean\r\n                        fOnAppLoad : function() {\r\n                          //예제 코드\r\n                          //oEditors.getById[\"strHtml\"].exec(\"PASTE_HTML\", []);\r\n                        },\r\n                        fCreator : \"createSEditor2\"\r\n                      });</script><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><div class=row ng-if=\"vc.formType != \'EMAIL\'\"><div class=\"col-xs-10 col-sm-10 col-md-10\"><div class=\"form-group form-inline\"><label uib-tooltip=\"메세지 내용\">메세지 내용</label><textarea rows=10 class=\"form-control form-right\" style=width:100% id=Contents name=Contents ng-model=vc.data.Contents ng-change=vc.chkSendMessage() ng-disabled=!vc.isMine></textarea><div class=text-right>{{ vc.messageLength }} / {{ vc.messageMaxLength }} bytes</div></div></div></div><div class=row ng-if=\"vc.formType == \'KAKAO\'\"><div class=\"col-xs-10 col-sm-10 col-md-10\"><div class=\"form-group form-inline\"><label uib-tooltip=\"템플릿 Key\">템플릿 Key</label><input type=text class=\"form-control form-right\" ng-model=vc.data.KakaoTemplateKey ng-required=true></div></div></div><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=\"col-xs-10 col-sm-10 col-md-10\"><div class=\"form-group sm-mb0\"><label uib-tooltip=\"수신동의 및 수신거부\">수신동의 및 수신거부</label><div class=checkbox><ul><li><label class=ng-binding><input ng-checked-=\"vc.data.AgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-disabled=!vc.isMine ng-model=vc.data.AgreeYN ng-true-value=\"\'Y\'\" type=checkbox>회원수신동의 및 관련 문구를 넣습니다.</label></li></ul></div></div></div></div><div style=margin-left:90px ng-if=\"vc.formType != \'EMAIL\'\"><button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'C\')\">고객명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'T\')\">회원사명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'B\')\">지점명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'M\')\">로그인ID 핸드폰</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'A\')\">주소</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'Contents\', \'BA\')\">계좌번호</button></div><div class=row ng-if=\"vc.formType == \'SMS\' && vc.isMine\" style=margin-left:90px><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addADTxtYN == \'Y\'\" ng-change=vc.chkADTxt() ng-false-value=\"\'N\'\" ng-model=vc.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div></div></div></form></div><div class=col-lg-4><ul class=\"nav nav-tabs\" ng-if=\"vc.formType == \'SMS\'\"><li ng-class=\"vc.tabId == \'tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\" style=cursor:pointer>광고문자전송 안내</a></li><li ng-class=\"vc.tabId == \'tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\" style=cursor:pointer>통신사별 스팸차단 안내</a></li></ul><div class=\"tab-content mt20\" ng-if=\"vc.formType == \'SMS\'\"><div class=\"tab-pane active\" id=noti-tab1><img src=/assets/images/sms-noti-msg.jpg style=width:100%></div><div class=tab-pane id=noti-tab2><img src=/assets/images/sms-noti-spam.jpg style=width:100%></div></div></div></div></div></div></div></div>");
$templateCache.put("app/message/form-list.html","<div class=\"page page-footable\" ng-controller=\"FormListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>서식관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'FormType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.srch.FormType></common-code-custom><label>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'FormNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.FormNm type=text><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- <div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">\r\n                          <div class=\"form-group form-inner-label\">\r\n                            <common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\"\r\n                                                code-model=\"vc.srch.FormType\"></common-code-custom>\r\n                            <label>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label>\r\n                          </div>\r\n                        </div> --><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'KAKAO\')\" ng-if=vc.loginSysAdminYN><i class=\"fa fa-edit\"></i> 알림톡 서식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'SMS\')\"><i class=\"fa fa-edit\"></i> SMS 서식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'EMAIL\')\"><i class=\"fa fa-edit\"></i> Email 서식추가</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 5%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=text-center style=\"vertical-align:middle; width: 80px\"><span>승인여부</span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg() ng-disabled=\"li.TenantId != vc.srchTenantId\"></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.FormTypeId)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td><td class=text-center style=vertical-align:middle><span>{{li.ApprovalYN}}</span></td></tr></table><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-auto-edit-tenant.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoEditTenantCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>알림발송 상세정보</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- Action Buttons --><div class=row><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><span class=\"btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"vc.data.SmsSituationAutoTenantId != null\" title=\"지점에서 수정되었으며 삭제하면 기본내용으로 원복됩니다.\">지점에서 수정됨</span></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"vc.data.SmsSituationAutoTenantId != null\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>자동발송 상세정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=col-lg-12><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=상황명>상황명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SituationTitl ng-disabled=true></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송유형>발송유형</label><input type=text class=\"form-control form-right\" maxlength=100 value=이메일 ng-disabled=true ng-if=\"vc.data.SCmpgnChannel == \'EMAIL\'\"> <input type=text class=\"form-control form-right\" maxlength=100 value=카카오톡 ng-disabled=true ng-if=\"vc.data.CmpgnChannel == \'KAKAO\'\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList | filter:isSMSType\" code-model=vc.data.CmpgnChannel ng-if=\"vc.data.SCmpgnChannel != \'EMAIL\' && vc.data.CmpgnChannel != \'KAKAO\'\" callback=vc.setCmpgnChannel></common-code-custom></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"발송자 이름\">발송자 이름</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.FromNm></div><div class=\"form-group form-inline\"><span class=\"form-control-no-border form-right\">※ 발송자 이름을 지정하지 않으면 상담자명이 지정됩니다.</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"발송자 정보\">발송자 정보</label><div class=\"input-group custom-search-form\"><input type=text readonly class=\"form-control ng-pristine ng-untouched ng-valid ng-not-empty\" maxlength=50 ng-model=vc.data.FromTelNo ng-click=vc.srchFromTelNoModal(); aria-invalid=false> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchFromTelNoModal();><i class=\"fa fa-search\" aria-hidden=true></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseFromTelNo();><i class=\"fa fa-eraser\" aria-hidden=true></i></button></span></div></div><div class=\"form-group form-inline\"><span class=\"form-control-no-border form-right\">※ 발송자 정보를 지정하지 않으면 지점정보가 지정됩니다.</span></div></div></div><div class=row ng-if=\"vc.data.SqlQueryId == \'AUTO\'\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"vc.data.DayBeforeYN == \'Y\'\"><div class=\"form-group form-inline\"><label uib-tooltip=\"대상일 며칠전\">대상일 며칠전</label><input type=text class=\"form-control form-right\" maxlength=10 ng-model=vc.data.DayBefore></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송시각>발송시각</label><time-select select-hour=vc.data.SendHour select-minute=vc.data.SendMinute begin-hour=8 end-hour=21 interval-minute=10 is-disabled=false></time-select></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=제목>제목</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SendTitle ng-disabled=\"vc.data.CmpgnChannel == \'KAKAO\'\"></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label uib-tooltip=내용>내용</label><textarea id=sendMessage name=sendMessage rows=15 class=\"form-control form-right\" style=width:100% ng-model=vc.data.SendMessage ng-change=vc.chkSendMessage() ng-disabled=\"vc.data.CmpgnChannel == \'KAKAO\'\" kr-input></textarea><div class=text-right>[{{vc.data.CmpgnChannel}}] {{vc.messageLength}} / {{vc.messageMaxLength}} bytes</div><span style=\"margin-left:90px; font-size:15px\">※ 아래버튼을 클릭하여 내용에 삽입하면 해당항목의 값으로 대체됩니다.<br></span><div style=margin-left:90px><button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{FromTenantNm}\')\">회원사명 지점명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{FromTenantAddr}\')\">지점주소</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{FromNm}\')\">보내는 사람 이름</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{FromInfo}\')\">보내는 사람 정보</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{ToNm}\')\">고객 이름</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{ToInfo}\')\">고객 수신 정보</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{Info1}\')\" ng-if=vc.data.Info1Desc>첫번째 지정 정보</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'{Info2}\')\" ng-if=vc.data.Info2Desc>두번째 지정 정보</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'#{DayBefore}\')\" ng-if=\"vc.data.DayBeforeYN == \'Y\'\">대상일 며칠전</button></div><ul class=form-control-no-border><li ng-show=\"vc.data.CmpgnChannel == \'SMS\'\">* 치환문자 사용 시, SMS 에서는 90자 이상은 이후 문자가 잘려서 전송될 수 있으니, 주의하여 사용하시기 바랍니다.</li><li>* {FromTenantNm} 은 \'회원사명 지점명\'으로 치환됩니다.</li><li>* {FromTenantAddr} 은 \'지점주소\'로 치환됩니다.</li><li>* {FromNm} 은 \'보내는 사람 이름\'로 치환됩니다. \'보내는 사람 이름\'을 지정하지 않은 경우 \'담당자이름\'으로 치환됩니다.</li><li>* {FromInfo} 은 \'보내는 사람 정보\'로 치환됩니다. \'보내는 사람 정보\'를 지정하지 않은 경우 \'지점의 발신정보\'로 치환됩니다.</li><li>* {ToNm} 은 \'고객 이름\'로 치환됩니다.</li><li>* {ToInfo} 는 \'고객 수신 정보\'로 치환됩니다.</li><li ng-if=vc.data.Info1Desc>* {Info1} 은 \'{{vc.data.Info1Desc}}\'로 치환됩니다.</li><li ng-if=vc.data.Info2Desc>* {Info2} 은 \'{{vc.data.Info2Desc}}\'로 치환됩니다.</li><li ng-if=\"vc.data.DayBeforeYN == \'Y\'\">* #{DayBefore} 는 \'대상일 며칠전\'으로 치환됩니다.</li><li>* 알림톡은 제목과 내용을 변경할 수 없습니다.</li></ul></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.CmpgnChannel == \'MMS\'\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><img src={{fli.link}}></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=md-warn role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div><div class=\"form-group form-inline\" ng-if=\"vc.showUploader && vc.uploadFileList.length == 0\"><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div class=form-control-no-border id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=사용여부>사용여부</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div class=form-control-no-border></div></div></div></div></form></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"vc.data.SmsSituationAutoTenantId != null\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div></div></div>");
$templateCache.put("app/message/sms-auto-list-tenant.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoListTenantCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>알림발송관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.SituationTitl placeholder=\"상황명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel></common-code-custom><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input ng-model=vc.srch.SituationTitl type=text class=form-control><label>{{vc.columnMap[\'SituationTitl\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input ng-model=vc.srch.Contents type=text class=form-control><label>{{vc.columnMap[\'SendTitle\'].ColumnLogicalNm | translate}}/{{vc.columnMap[\'SendMessage\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goEdit(\'\')\"><i class=\"fa fa-edit\"></i> 추가</button><!--button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button--></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.KeyId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.KeyId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><span class=\"btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'SituationTitl\' && li.SmsSituationAutoTenantId != null\">수정됨</span> <button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.setPageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-edit.html","<!-- Html Editor --><style>.cust-cnt {\r\n    text-decoration: underline !important;\r\n    color: #005580 !important;\r\n  }</style><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"SmsSendEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12 ng-if=\"vc.layout == \'N\'\"><div class=page-header>메세지발송</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=\"vc.uploadFile(\'T\')\"><i class=\"fa fa-edit\"></i> 임시저장</button> <button class=\"btn btn-default\" ng-click=vc.showPreView()><i class=\"fa fa-clone\"></i> 미리보기</button> <button class=\"btn btn-default\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=vc.resetAll()><i class=\"fa fa-refresh\"></i> 전체초기화</button> <button class=\"btn btn-default\" ng-click=vc.setTestData()><i class=\"fa fa-check-square-o\"></i> 테스트발송</button> <button class=\"btn btn-primary\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=\"vc.uploadFile(\'S\')\"><i class=\"fa fa-save\"></i> 발송</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">대상고객</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 mt-5 pl-0 pr-0\" ng-if=\"vc.data.Status == \'TEMP\' || vc.data.keyId == null\"><button class=\"btn btn-default mr-5\" ng-click=vc.setCustAll()>전체고객투입</button> <button class=\"btn btn-default mr-5\" ng-click=vc.srchInputModal()>조건검색투입</button> <button class=\"btn btn-default mr-5\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\" ng-click=vc.ReceiveNumberModal()>직접입력</button> <button class=\"btn btn-default\" ng-click=vc.resetCmpgnCustomerList()>대상고객초기화</button></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xg-9 col-xl-6\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=투입고객수>투입고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'A\')\">{{vc.data.EnterCnt}}</a></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=대상고객수>대상고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'T\')\">{{vc.data.TargetCnt}}</a></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=제외고객수>제외고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'E\')\">{{vc.data.ExceptCnt}}</a></span></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상세등록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송메시지>발송메시지</label><textarea class=form-control id=sendMessage name=sendMessage rows=12 kr-input ng-model=vc.data.SendMessage ng-disabled=\"vc.data.CmpgnImpChannel == \'KAKAO\' || (vc.data.keyId != null && vc.data.Status != \'TEMP\')\" aria-invalid=false ng-change=vc.chkSmsByte()></textarea></div><div ng-if=\"vc.data.CmpgnImpChannel != \'KAKAO\'\" style=\"padding-left:90px; font-size:15px\"><span>{{vc.bytes}} / {{vc.messageMaxLength}} bytes</span><br><span>※ 아래버튼을 클릭하여 내용에 삽입하면 해당항목의 값으로 대체됩니다.<br></span><span>※ 치환문자 사용 시, SMS 에서는 90자 이상은 이후 문자가 잘려서 전송될 수 있으니, 주의하여 사용하시기 바랍니다.</span><div class=mt-15 ng-if=\"vc.data.keyId == null || vc.data.Status == \'TEMP\'\"><button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'C\')\">고객명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'T\')\">회원사명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'B\')\">지점명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'M\')\">로그인ID 핸드폰</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'A\')\">주소</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'BA\')\">계좌번호</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=margin-left:90px><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input class=mt-3 ng-checked-=\"vc.addADTxtYN == \'Y\'\" ng-change=\"vc.chkADTxt(\'sendMessage\')\" ng-false-value=\"\'N\'\" ng-model=vc.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox> <span>광고문구 추가(최상단 삽입)</span></label></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-4 col-xl-4 mt-5\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\"><ul class=\"nav nav-tabs\"><li ng-class=\"vc.tabId == \'tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\" style=cursor:pointer>광고문자전송 안내</a></li><li ng-class=\"vc.tabId == \'tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\" style=cursor:pointer>통신사별 스팸차단 안내</a></li></ul><div class=tab-content><div class=\"tab-pane active\" id=noti-tab1><img src=/assets/images/sms-noti-msg.jpg style=width:100%></div><div class=tab-pane id=noti-tab2><img src=/assets/images/sms-noti-spam.jpg style=width:100%></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\" ng-if=\"vc.data.CmpgnImpChannel == \'MMS\'\"><div class=\"form-group form-inline\"><label uib-tooltip=첨부>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" ng-disabled=\"vc.data.keyId != null && vc.data.Status != \'TEMP\'\" class=md-warn role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div><div class=\"form-group form-inline\" ng-if=\"vc.showUploader && vc.uploadFileList.length == 0\"><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div class=form-control-no-border id=vault class=vault-block vault-company></div></form></div></div><div ng-show=\"vc.data.CmpgnImpChannel == \'EMAIL\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group>수신동의 및 수신거부<div><label class=ng-binding><input type=checkbox ng-model=vc.data.AgreeYN ng-checked=\"vc.data.AgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>회원수신동의 및 관련 문구를 넣습니다.</label></label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">내용에 \"{CustNm}\"을 입력하면 고객명으로 치환됩니다. ex) {CustNm}님 안녕하세요.</div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><textarea id=strHtml rows=30 style=\"width: 100%\"></textarea></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-number-save.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberSaveCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS발송번호인증</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent pane-wrap-anchor={{vc.anchor}}><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발송번호인증</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"form-group form-inline\"><label>발송번호</label><input type=text class=form-control ng-model=vc.data.SendInfo ng-required=true auto-hyphen-tel></div></div><div class=\"col-lg-6 col-md-6 col-sm-8 col-xs-12\"><div class=\"form-group form-inline\"><label>인증방법</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=\"휴대폰 본인인증\"><label class=custom-radio-btn title=\"휴대폰 본인인증\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio value=MOBILE ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'MOBILE\'\" ng-click=\"vc.showUploader = false\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">휴대폰 본인인증</span></label></div><div class=\"radio-inline ng-scope\" title=\"통신서비스 이용증명원\"><label class=custom-radio-btn title=\"통신서비스 이용증명원\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=DOCUMENT ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'DOCUMENT\'\" ng-click=\"vc.showUploader = true\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">통신서비스 이용증명원</span></label></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.dupChk();><i class=\"fa fa-edit\"></i> 등록</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.setDelList(); ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div class=input-group><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div></form></div></div></div></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/metadata/metadata-detail.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/metadata/metadata-edit.html","<div class=\"page page-footable\" id=toastContainer><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사용자정의화면 {{ \'Menu.EDIT\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><form name=metaTable><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{vc.makeSrch()}}\'})\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-warning\" ng-click=\"metaTable.$valid && vc.delMetaTable()\"><i class=\"fa fa-save\"></i> 기본설정</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && vc.modMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6\" ng-init=\"vc.viewType = \'D\'\"><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=vc.viewType value=L ng-click=\"vc.viewType = \'L\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 리스트</label><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=vc.viewType value=D ng-click=\"vc.viewType = \'D\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 상세</label></div><!--div class=\"pull-right\" style=\"height: 100%\">\r\n                    <div class=\"form-group\">\r\n                      <md-checkbox md-no-ink=\"\" ng-if=\"$root.gVariable.srchTenantId != \'0\'\" ng-click=\"vc.ChangeCustomColumn()\" ng-checked=\"vc.metaTable.metaColumns.length == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=\"checkbox\" style=\"margin-right: 30px;\"> {{ \'Menu.CUSTOMCOLUMN\' | translate }}</md-checkbox>\r\n                      <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && vc.modMetaTable()\">\r\n                        <i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}\r\n                      </button>\r\n                    </div>\r\n                  </div--></div></div><metatable-sortable init-callback=vc.succSortable bind-data=vc.datas link-data=vc.linkData max-depth=3 view-type=vc.viewType check-section=vc.checkColumnSection check-edit-col-size=vc.checkEditColumnRowCount mode=\"\'U\'\"></metatable-sortable><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group btn-bottom\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{vc.makeSrch()}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && vc.modMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/metadata/metadata-list.html","<div class=\"page page-footable\" ng-controller=\"MetadataListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사용자정의화면설정<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"물리 테이블/컬럼명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.tabelNm type=text><label>물리 테이블명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.columnLogicalNm type=text><label>물리 컬럼명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goDetail(\'\')\" ng-if=\"$root.gVariable.srchTenantId == 0\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong>{{ \'Menu.LIST\' | translate }}</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=dataloader ng-show=boardMngSave.dataloader></div><!-- Search Result --><table id=searchTextResults data-filter=#filter data-page-size={{vc.viewSizePerPage}} class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'A.TableNm\')\">물리 테이블명<span class=\"{{vc.sortClass(\'A.TableNm\')}}\"></span></th><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'A.TableDesc\')\">테이블 설명<span class=\"{{vc.sortClass(\'A.TableDesc\')}}\"></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.boardList\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.tableNm) ng-class=\"{\'bg-lightyellow\':selectedRow == li.tableNm}\"><!-- Result Items --><td class=text-left><span ng-bind=li.tableNm></span></td><td class=text-left><span ng-bind=li.tableDesc></span></td></tr></tbody></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label>{{ \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalCount ng-model=vc.currentPage total-items=vc.totalCount previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/metadata/modal-attr-detail.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>컬럼표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리컬럼이름</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalNm></div></div></div><div class=col-lg-4><div class=form-group><label>물리컬럼데이터크기</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalDataSize></div></div></div><div class=col-lg-4><div class=form-group><label>*물리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>*논리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign disabled></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>목록화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.listColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 표시 Level</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel disabled><option value=1>1</option><option value=2>2</option><option value=3>3</option></select></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 폭</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnWidth></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnHeight></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.editColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnDesc></div></div></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> 닫기</button></div></div>");
$templateCache.put("app/metadata/modal-attr-setup.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalNm required></div></div><div class=col-lg-4><div class=form-group><label ng-show=modalCtrl.isSizableData() style=\"color: red\">*</label><label>물리데이터크기</label><input type=number class=\"form-control pre\" ng-value=0 ng-model=modalCtrl.column.columnPhysicalDataSize ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-required=modalCtrl.isSizableData()></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리데이터유형</label><select class=form-control ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리참조이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalAsNm></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>논리데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnHeight></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>상세화면 폭</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnWidth></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록표시 방법</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel><option value=showlevel1>①항상 표시</option><option value=showlevel2>②768 이상일때 표시</option><option value=showlevel3>③992 이상일때 표시</option><option value=showlevel4>④1024 이상일때 표시</option><option value=showlevel5>⑤1400 이상일때 표시</option><option value=showlevel0>검색영역에만 표시</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign required></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록화면 폭</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnWidth required></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>공통코드용 코드타입</label><input type=text class=form-control ng-model=modalCtrl.column.codeType></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><textarea class=form-control row=3 cols=50 ng-model=modalCtrl.column.columnDesc></textarea></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=modalCtrl.onAddClick()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> {{ \'Menu.CLOSE\' | translate}}</button></div></div>");
$templateCache.put("app/metadata/modal_attr_fieldnamerule.html","<div class=modal-header><h3 class=\"modal-title custom-font\">필드이름 규칙</h3></div><div class=modal-body><div class=tile><span ng-if=doing_async>...loading...</span><div class=\"b-a bg-default lter\"><ol><li>Varchar형 : ExtVarchar01 ~ ExtVarchar10</li><li>Integer형 : ExtInt01 ~ ExtInt10</li><li>Datetime형 : ExtDate01 ~ ExtDate10</li></ol></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div>");
$templateCache.put("app/metadata/modal_attr_reorder.html","<style>.btn_order_box {\r\n  position: relative;\r\n  height: 17px;\r\n  width: 100%;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.btn_order {\r\n  height: 17px;\r\n  width: 80px;\r\n  right: 30px;\r\n  z-index: 9;\r\n}\r\n\r\n.btn_order .change_order {\r\n  width: 17px;\r\n  height: 17px;\r\n  display: block;\r\n  float: left;\r\n  background: url(\'/assets/images/icon/btn_change_order.png\') 0 0 no-repeat;\r\n  font-size: 0;\r\n  margin-right: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_first {\r\n  background-position: 0 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_pre {\r\n  background-position: 0 -17px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_next {\r\n  background-position: 0 -34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_last {\r\n  background-position: 0 -51px;\r\n  cursor: pointer;\r\n}\r\n\r\nli.selected {\r\n  background: #f5f6f7;\r\n}</style><div class=modal-content><div class=\"modal-header ng-scope\"><h1 class=\"modal-title page-header\" ng-bind=reorderCtrl.title></h1></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"card_cont list_area\"><div class=\"b-a bg-default lter\"><ul><li data-ng-repeat=\"row in reorderCtrl.objModel\" ng-class=\"{selected:(reorderCtrl.selectedIdx == $index)}\" ng-click=reorderCtrl.onSelect($index)><span ng-bind=row.columnLogicalNm ng-if=\"row.dirty!=\'D\'\"></span>(<span ng-bind=row.columnPhysicalNm ng-if=\"row.dirty!=\'D\'\"></span>)</li></ul></div></div></div></div><div class=row><div class=col-lg-12><div class=btn_order_box><div class=btn_order><span class=\"change_order go_first\" ng-click=reorderCtrl.moveTop() translate>BTN.PAGINATION.FIRST</span> <span class=\"change_order go_pre\" ng-click=reorderCtrl.moveUp() translate>BTN.PAGINATION.PREV</span> <span class=\"change_order go_next\" ng-click=reorderCtrl.moveDown() translate>BTN.PAGINATION.NEXT</span> <span class=\"change_order go_last\" ng-click=reorderCtrl.moveBottom() translate>BTN.PAGINATION.LAST</span></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-shield\"></i> {{ \'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=reorderCtrl.onSave()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button></div></div>");
$templateCache.put("app/modal/appr-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">상담 승인</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>상담확정일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFirstDecDate ng-change=\"modalCtrl.data.FirstDecDate = (dtFirstDecDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=상담확정일시> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=modalCtrl.FirstDecHourList callback=modalCtrl.onSelectCallback></common-code></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><common-code param-data=modalCtrl.FirstDecMinList callback=modalCtrl.onSelectCallback></common-code></div></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=modalCtrl.data.CounselUser_> <input type=hidden ng-value=modalCtrl.data.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=modalCtrl.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=modalCtrl.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- //row --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.OK\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/modal/DownloadReason-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">다운로드 사유기입</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.ok()\'}\"><div class=row><div class=col-lg-12><input type=text class=form-control ng-model=modalCtrl.DownloadReason placeholder=\"다운로드 사유\"></div><div class=col-lg-12><p style=\"color: red\">* 다운로드 사유를 5자 이상 입력하세요.</p></div></div><!-- //row --></form><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>다운로드</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div></div>");
$templateCache.put("app/modal/email-modal.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">이메일 발송</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-6><div class=form-group><label class=txt_req>발신자 이메일주소</label><input type=text class=form-control ng-model=modalCtrl.data.FromEmail ng-required=true></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label class=txt_req>제목</label><input type=text class=form-control ng-model=modalCtrl.data.Title ng-required=true></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label class=txt_req>내용</label><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=modalCtrl.data.SendMessage></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>첨부파일</label><file-attach file-data=modalCtrl.uploadFileList callback=modalCtrl.onFileCallback></file-attach></div></div></div><!-- //row --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.OK\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \'ko_KR\'; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef: oEditors,\r\n    elPlaceHolder: \'strHtml\',\r\n    sSkinURI: \'assets/app/SE2.9/SmartEditor2Skin.html\',\r\n    htParams: {\r\n      bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer: false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n      fOnBeforeUnload: function () {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE: sLang,\r\n    }, //boolean\r\n    fOnAppLoad: function () {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator: \'createSEditor2\',\r\n  });</script>");
$templateCache.put("app/modal/image-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\"><!-- 사용자 {{ \'Menu.SEARCH\' | translate }} --></h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><img src={{modalCtrl.src}} style=\"max-width: 800px\"></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.close()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("app/modal/session-countdown-modal.html","<div class=modal-header><h4 class=\"modal-title custom-font\">로그인 자동종료 안내</h4></div><div class=modal-body><div class=text-center>개인정보보호를 위해 상담관리시스템을</div><div class=text-center><span style=\"color: red\">{{vc.minute}}분 이상 미사용시</span> 자동 로그아웃 됩니다.</div><div>&nbsp;</div><div class=text-center ng-show=\"gVariable.sessioncountdown > 0\"><span style=\"color: blue\">현재 입력중인 데이터를 저장해 주세요.</span></div><div class=text-center>남은시간 <strong>{{vc.countdown}}</strong></div></div><div class=modal-footer><div class=text-center><button class=\"btn btn-primary mb-10\" ng-click=vc.ok() ng-disabled=\"gVariable.sessioncountdown < 1\"><i class=\"fa fa-check\"></i>연장하기</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-sign-out\"></i>로그아웃</button></div></div>");
$templateCache.put("app/modal/user2-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">사용자 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div><!-- //row --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table-striped table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>사용자명</th><th data-toggle=true class=text-center>사용자구분</th><!-- <th data-toggle=\"true\" class=\"text-center\">휴대폰</th>\r\n                <th data-toggle=\"true\" class=\"text-center\">이메일</th> --><th data-toggle=true class=text-center>사용여부</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.UserType_></span></td><!-- <td class=\"text-center\"><span ng-bind=\"li.Mobile\"></span></td>\r\n                <td class=\"text-center\"><span ng-bind=\"li.Email\"></span></td> --><td class=text-center><span ng-bind=li.UseYN></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage template-url=components/template/pagination.html ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/schedule/schedule.html","<style>.auto-complet-wrap {\r\n    border: solid 1px #aaa; \r\n  }</style><div class=\"page page-footable schedule-ctrl\" ng-controller=\"ScheduleCtrl as vc\"><div class=page-header>{{vc.title}}</div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=row><div class=calendar_lnb><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=miniCalendarField><div id=miniCalendar class=miniCalendar calendar=salevisMiniCalendar ui-calendar=uiConfig2.calendar></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline searchField\"><sz-auto-complete code-list=vc.codeClientList code-model=vc.data.srchClientNm code-key=vc.data.srchClientId change-callback=vc.changeClientNm callback=vc.changeClientCode placeholder=\"고객사를 검색해주세요.\" ng-model=vc.data.srchClientNm></sz-auto-complete><i class=\"fa fa-search\"></i></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline lnbItemField\"><!-- <label>부서선택</label> --><select class=form-control multiple id=ksa_calendar_select ng-model=vc.data.selectedData ng-change=vc.chgSelect()><optgroup label=부서 id=ksa_calendar_opt_dept><option value=1>1</option><option value=2>2</option><option value=3>3</option><option value=4>4</option><option value=5>5</option><option value=6>6</option><option value=7>7</option><option value=8>8</option><option value=9>9</option><option value=10>10</option><option value=11>11</option><option value=12>12</option><option value=13>13</option></optgroup><option value=person id=ksa_calendar_opt_person>개인</option></select><!-- <select class=\"form-control\" ng-model=\"selectedDept\" ng-change=\"vc.setDeptType(selectedDept)\" name=\"selectDeptList\"\r\n                data-ng-options=\"dept as dept.CodeValue for dept in vc.codeDepts\">\r\n                  <option value=\"\">-- 선택 --</option>\r\n                </select> --><div id=type_filter><div class=itemwrap ng-repeat=\"item in vc.data.deptList\">{{item.deptCodeValue}} <span ng-click=vc.deleteDept(item)>×</span></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span>영업활동</span><ul class=\"stateList ul_h\"><li><span class=\"state state1\">예정</span></li><li><span class=\"state state2\">완료</span></li><li><span class=\"state state3\">취소</span></li><li><span class=\"state state4\">보류</span></li></ul></div></div></div><div class=calendarWrap><md-progress-linear md-mode=indeterminate ng-show=vc.isLoading></md-progress-linear><div id=calendar class=calendar calendar=ksaCalendar ui-calendar=uiConfig.calendar ng-model=eventSources style=\"overflow-x: hidden\"></div></div></div></div></div></div>");
$templateCache.put("app/state/areacounsel.html","<div class=\"page page-footable\" ng-controller=\"AreacounselCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>지역별/부대별 등록현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>지역별/부대별 등록현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>고객등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>지역별/부대별 등록현황</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별 등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=16%><col width=16%><col width=16%><col width=16%><col width=16%></colgroup><tr><th>구분</th><th>계</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th></tr><tr ng-repeat=\"li in vc.listArmy\"><td class=text-center><span ng-bind=li.Gubun></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>계급별 등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%></colgroup><tr><th rowspan=2>구분</th><th rowspan=2>계</th><th colspan=9>간부</th><th colspan=5>병</th></tr><tr><th>소계</th><th>장교 계</th><th>대위</th><th>중위</th><th>소위</th><th>부사관 계</th><th>상사</th><th>중사</th><th>하사</th><th>병 계</th><th>병장</th><th>상병</th><th>일병</th><th>이병</th></tr><tr ng-repeat=\"li in vc.listClass\"><td class=text-center><span ng-bind=li.Gubun></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.HighMidTotCnt></span></td><td class=text-center><span ng-bind=li.HighTotCnt></span></td><td class=text-center><span ng-bind=li.HighType1Cnt></span></td><td class=text-center><span ng-bind=li.HighType2Cnt></span></td><td class=text-center><span ng-bind=li.HighType3Cnt></span></td><td class=text-center><span ng-bind=li.MidTotCnt></span></td><td class=text-center><span ng-bind=li.MidType1Cnt></span></td><td class=text-center><span ng-bind=li.MidType2Cnt></span></td><td class=text-center><span ng-bind=li.MidType3Cnt></span></td><td class=text-center><span ng-bind=li.LowTotCnt></span></td><td class=text-center><span ng-bind=li.LowType1Cnt></span></td><td class=text-center><span ng-bind=li.LowType2Cnt></span></td><td class=text-center><span ng-bind=li.LowType3Cnt></span></td><td class=text-center><span ng-bind=li.LowType4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=table-responsive><div class=form-group><label>학력별 등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%></colgroup><tr><th rowspan=2 colspan=2>구분</th><th colspan=4>계</th><th colspan=4>육군</th><th colspan=4>해군</th><th colspan=4>공군</th><th colspan=4>해병대</th></tr><tr><th>총계</th><th>고졸</th><th>대재</th><th>대졸</th><th>계</th><th>고졸</th><th>대재</th><th>대졸</th><th>계</th><th>고졸</th><th>대재</th><th>대졸</th><th>계</th><th>고졸</th><th>대재</th><th>대졸</th><th>계</th><th>고졸</th><th>대재</th><th>대졸</th></tr><tr ng-repeat=\"li in vc.listEdu\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td></tr></table></div></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>월별 등록현황 (금년기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%><col width=6%></colgroup><tr><th rowspan=2 colspan=2>구분</th><th rowspan=2>계</th><th colspan=9>간부</th><th colspan=5>병</th></tr><tr><th>소계</th><th>장교 계</th><th>대위</th><th>중위</th><th>소위</th><th>부사관 계</th><th>상사</th><th>중사</th><th>하사</th><th>병 계</th><th>병장</th><th>상병</th><th>일병</th><th>이병</th></tr><tr ng-repeat=\"li in vc.listMonth\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.HighMidTotCnt></span></td><td class=text-center><span ng-bind=li.HighTotCnt></span></td><td class=text-center><span ng-bind=li.HighType1Cnt></span></td><td class=text-center><span ng-bind=li.HighType2Cnt></span></td><td class=text-center><span ng-bind=li.HighType3Cnt></span></td><td class=text-center><span ng-bind=li.MidTotCnt></span></td><td class=text-center><span ng-bind=li.MidType1Cnt></span></td><td class=text-center><span ng-bind=li.MidType2Cnt></span></td><td class=text-center><span ng-bind=li.MidType3Cnt></span></td><td class=text-center><span ng-bind=li.LowTotCnt></span></td><td class=text-center><span ng-bind=li.LowType1Cnt></span></td><td class=text-center><span ng-bind=li.LowType2Cnt></span></td><td class=text-center><span ng-bind=li.LowType3Cnt></span></td><td class=text-center><span ng-bind=li.LowType4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별/신분별 등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=10%><col width=10%><col width=10%><col width=10%><col width=10%><col width=10%><col width=10%><col width=10%><col width=10%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>%</th><th>장교</th><th>%</th><th>부사관</th><th>%</th><th>병</th><th>%</th></tr><tr ng-repeat=\"li in vc.listArmyClass\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.TotRate></span></td><td class=text-center><span ng-bind=li.HighCnt></span></td><td class=text-center><span ng-bind=li.HighRate></span></td><td class=text-center><span ng-bind=li.MidCnt></span></td><td class=text-center><span ng-bind=li.MidRate></span></td><td class=text-center><span ng-bind=li.LowCnt></span></td><td class=text-center><span ng-bind=li.LowRate></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>부대별/계급별 등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=10%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%><col width=7%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>대위</th><th>중위</th><th>소위</th><th>상사</th><th>중사</th><th>하사</th><th>병장</th><th>상병</th><th>일병</th><th>이병</th></tr><tr ng-repeat=\"li in vc.listUnit\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.High1Cnt></span></td><td class=text-center><span ng-bind=li.High2Cnt></span></td><td class=text-center><span ng-bind=li.High3Cnt></span></td><td class=text-center><span ng-bind=li.Mid1Cnt></span></td><td class=text-center><span ng-bind=li.Mid2Cnt></span></td><td class=text-center><span ng-bind=li.Mid3Cnt></span></td><td class=text-center><span ng-bind=li.Low1Cnt></span></td><td class=text-center><span ng-bind=li.Low2Cnt></span></td><td class=text-center><span ng-bind=li.Low3Cnt></span></td><td class=text-center><span ng-bind=li.Low4Cnt></span></td></tr></table></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/campaign-report-list.html","<style>.cols-SendMessage {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"CampaignReportListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>발송내역피로도현황 <span style=\"font-size: 14px\">({{vc.headerTitle}})</span></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FromInfo placeholder=\"발신정보 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\" ng-if=\"vc.srch.GroupType == \'From\'\"> <input class=mb5 ng-model=vc.srch.ToInfo placeholder=\"수신정보 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\" ng-if=\"vc.srch.GroupType == \'To\'\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><div class=pull-right><span class=\"pull-right mr-5\" style=\"padding-top: 14px\">목록기준 :<label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=GroupType ng-model=vc.srch.GroupType value=From ng-click=\"vc.chgRadioButton(\'From\')\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 발신정보</label><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=GroupType ng-model=vc.srch.GroupType value=To ng-click=\"vc.chgRadioButton(\'To\')\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 수신정보</label></span></div></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div><div fa-pane pane-min=750px ng-if=\"vc.layout != \'N\'\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/careeremploy.html","<div class=\"page page-footable\" ng-controller=\"CareeremployCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>진로/취업목표별 진행현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>진로/취업목표별 진행현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>고객등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담회차</label><common-code param-data=vc.CounselRoundList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>진로/취업목표별 진행현황</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>진로목표별 현황(신청 기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%></colgroup><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan=5>육군</th><th colspan=5>공군</th><th colspan=5>해군</th><th colspan=5>해병대</th></tr><tr><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listCareerAll\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt2></span></td><td class=text-center><span ng-bind=li.Type1Cnt2></span></td><td class=text-center><span ng-bind=li.Type2Cnt2></span></td><td class=text-center><span ng-bind=li.Type3Cnt2></span></td><td class=text-center><span ng-bind=li.Type4Cnt2></span></td><td class=text-center><span ng-bind=li.TypeTotCnt3></span></td><td class=text-center><span ng-bind=li.Type1Cnt3></span></td><td class=text-center><span ng-bind=li.Type2Cnt3></span></td><td class=text-center><span ng-bind=li.Type3Cnt3></span></td><td class=text-center><span ng-bind=li.Type4Cnt3></span></td><td class=text-center><span ng-bind=li.TypeTotCnt4></span></td><td class=text-center><span ng-bind=li.Type1Cnt4></span></td><td class=text-center><span ng-bind=li.Type2Cnt4></span></td><td class=text-center><span ng-bind=li.Type3Cnt4></span></td><td class=text-center><span ng-bind=li.Type4Cnt4></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>부대별/진로목표별 현황(신청 기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=14%><col width=14%><col width=14%><col width=14%><col width=14%><col width=14%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>취업</th><th>창업</th><th>귀농귀촌</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listCareer\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>상담분야별 현황(상담 기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%><col width=4.5%></colgroup><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan=5>육군</th><th colspan=5>공군</th><th colspan=5>해군</th><th colspan=5>해병대</th></tr><tr><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th><th>소계</th><th>취업</th><th>창업</th><th>귀농<br>귀촌</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listCounselAll\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt2></span></td><td class=text-center><span ng-bind=li.Type1Cnt2></span></td><td class=text-center><span ng-bind=li.Type2Cnt2></span></td><td class=text-center><span ng-bind=li.Type3Cnt2></span></td><td class=text-center><span ng-bind=li.Type4Cnt2></span></td><td class=text-center><span ng-bind=li.TypeTotCnt3></span></td><td class=text-center><span ng-bind=li.Type1Cnt3></span></td><td class=text-center><span ng-bind=li.Type2Cnt3></span></td><td class=text-center><span ng-bind=li.Type3Cnt3></span></td><td class=text-center><span ng-bind=li.Type4Cnt3></span></td><td class=text-center><span ng-bind=li.TypeTotCnt4></span></td><td class=text-center><span ng-bind=li.Type1Cnt4></span></td><td class=text-center><span ng-bind=li.Type2Cnt4></span></td><td class=text-center><span ng-bind=li.Type3Cnt4></span></td><td class=text-center><span ng-bind=li.Type4Cnt4></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>부대별/상담분야별 현황(상담 기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=14%><col width=14%><col width=14%><col width=14%><col width=14%><col width=14%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>취업</th><th>창업</th><th>귀농귀촌</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listCounsel\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>희망기업별 현황(상담 기준)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%></colgroup><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan=6>육군</th><th colspan=6>공군</th><th colspan=6>해군</th><th colspan=6>해병대</th></tr><tr><th>소계</th><th>중소<br>기업</th><th>대기업</th><th>공공<br>기관</th><th>공무원</th><th>해외<br>취업</th><th>소계</th><th>중소<br>기업</th><th>대기업</th><th>공공<br>기관</th><th>공무원</th><th>해외<br>취업</th><th>소계</th><th>중소<br>기업</th><th>대기업</th><th>공공<br>기관</th><th>공무원</th><th>해외<br>취업</th><th>소계</th><th>중소<br>기업</th><th>대기업</th><th>공공<br>기관</th><th>공무원</th><th>해외<br>취업</th></tr><tr ng-repeat=\"li in vc.listCompanyAll\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.TypeTotCnt2></span></td><td class=text-center><span ng-bind=li.Type1Cnt2></span></td><td class=text-center><span ng-bind=li.Type2Cnt2></span></td><td class=text-center><span ng-bind=li.Type3Cnt2></span></td><td class=text-center><span ng-bind=li.Type4Cnt2></span></td><td class=text-center><span ng-bind=li.Type5Cnt2></span></td><td class=text-center><span ng-bind=li.TypeTotCnt3></span></td><td class=text-center><span ng-bind=li.Type1Cnt3></span></td><td class=text-center><span ng-bind=li.Type2Cnt3></span></td><td class=text-center><span ng-bind=li.Type3Cnt3></span></td><td class=text-center><span ng-bind=li.Type4Cnt3></span></td><td class=text-center><span ng-bind=li.Type5Cnt3></span></td><td class=text-center><span ng-bind=li.TypeTotCnt4></span></td><td class=text-center><span ng-bind=li.Type1Cnt4></span></td><td class=text-center><span ng-bind=li.Type2Cnt4></span></td><td class=text-center><span ng-bind=li.Type3Cnt4></span></td><td class=text-center><span ng-bind=li.Type4Cnt4></span></td><td class=text-center><span ng-bind=li.Type5Cnt4></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>부대별/희망기업별 현황(상담 기준)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=12%><col width=12%><col width=12%><col width=12%><col width=12%><col width=12%><col width=12%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>중소기업</th><th>대기업</th><th>공공기관</th><th>공무원</th><th>해외취업</th></tr><tr ng-repeat=\"li in vc.listCompany\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>직무별/희망근무지역별 현황</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>군<br>교관<br>요원</th><th>군무원</th><th>군전임<br>교수</th><th>기타<br>군관련직</th><th>민간<br>대학<br>교수</th><th>복지<br>시설</th><th>비상<br>계획관</th><th>산하<br>기관<br>/업체</th><th>예비군<br>지휘관</th><th>행정<br>관서</th><th>교육·<br>교사·<br>교수·<br>강사</th><th>방송·<br>미디어·<br>문화</th><th>번역·<br>통역</th><th>법무·<br>특허</th><th>보험</th><th>부동산</th><th>은행·<br>증권·<br>투신</th><th>편집·<br>자료관리·<br>출판·<br>인쇄</th><th>경비·<br>경호요원</th><th>시설<br>관리</th><th>안전</th><th>창고<br>관리</th><th>폭발물<br>처리</th><th>경리·<br>회계·<br>세무·<br>재무</th><th>경영·<br>컨설팅·<br>연구</th><th>경찰<br>공무원</th><th>기능직<br>공무원</th><th>기획<br>전략</th><th>무역·<br>수출입<br>관리</th><th>물류·<br>유통·<br>구매</th><th>비서·<br>인포메이션</th><th>사무직</th><th>사회<br>복지·<br>봉사</th><th>상담</th><th>소방<br>공무원</th><th>인사·<br>노무·<br>인재<br>개발</th><th>일반<br>공무원</th><th>일반<br>사무·<br>총무</th><th>배송·<br>운전</th><th>사진</th><th>생활<br>체육</th><th>서비스</th><th>식품·<br>조리</th><th>여행·<br>숙박·<br>레저</th><th>인포<br>메이션·<br>이벤트</th><th>CAD·<br>CAM</th><th>건축·<br>토목·조경·<br>설비</th><th>금속·<br>재료·<br>요업</th><th>기계·<br>기계<br>설비</th><th>농수<br>축산</th><th>도시·<br>교통</th><th>생명<br>공학·<br>식품<br>공학</th><th>생산직·<br>기능직</th><th>섬유·<br>패션·<br>의류</th><th>연구<br>개발</th><th>의약·<br>의료·<br>제약·<br>보건</th><th>전기·<br>전자·<br>제어</th><th>품질<br>관리·<br>품질<br>보증·<br>생산<br>관리</th><th>화학·<br>화공·<br>에너지</th><th>환경·<br>안전</th><th>TM</th><th>광고·<br>홍보·<br>PR</th><th>기술<br>영업</th><th>디자인</th><th>마케팅</th><th>매장<br>관리·<br>판매</th><th>상품<br>기획·<br>개발·<br>판매</th><th>영업·영업관리</th><th>IT<br>기술<br>영업·<br>기술<br>지원</th><th>IT<br>디자인</th><th>멀티<br>미디어</th><th>모바일</th><th>서버·<br>네트<br>워크<br>관리·<br>DB<br>관리</th><th>웹기획·<br>웹마<br>케팅·<br>컨텐츠</th><th>통신<br>기술</th><th>프로<br>그래머</th><th>고정익<br>조종</th><th>관제</th><th>기상</th><th>우주<br>항공</th><th>조선</th><th>항공<br>정비</th><th>항해</th><th>해양<br>정비</th><th>회전익<br>조종</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listArea\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.Type6Cnt></span></td><td class=text-center><span ng-bind=li.Type7Cnt></span></td><td class=text-center><span ng-bind=li.Type8Cnt></span></td><td class=text-center><span ng-bind=li.Type9Cnt></span></td><td class=text-center><span ng-bind=li.Type10Cnt></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type15Cnt></span></td><td class=text-center><span ng-bind=li.Type16Cnt></span></td><td class=text-center><span ng-bind=li.Type17Cnt></span></td><td class=text-center><span ng-bind=li.Type18Cnt></span></td><td class=text-center><span ng-bind=li.Type19Cnt></span></td><td class=text-center><span ng-bind=li.Type20Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type25Cnt></span></td><td class=text-center><span ng-bind=li.Type26Cnt></span></td><td class=text-center><span ng-bind=li.Type27Cnt></span></td><td class=text-center><span ng-bind=li.Type28Cnt></span></td><td class=text-center><span ng-bind=li.Type29Cnt></span></td><td class=text-center><span ng-bind=li.Type30Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type35Cnt></span></td><td class=text-center><span ng-bind=li.Type36Cnt></span></td><td class=text-center><span ng-bind=li.Type37Cnt></span></td><td class=text-center><span ng-bind=li.Type38Cnt></span></td><td class=text-center><span ng-bind=li.Type39Cnt></span></td><td class=text-center><span ng-bind=li.Type40Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type45Cnt></span></td><td class=text-center><span ng-bind=li.Type46Cnt></span></td><td class=text-center><span ng-bind=li.Type47Cnt></span></td><td class=text-center><span ng-bind=li.Type48Cnt></span></td><td class=text-center><span ng-bind=li.Type49Cnt></span></td><td class=text-center><span ng-bind=li.Type50Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td><td class=text-center><span ng-bind=li.Type55Cnt></span></td><td class=text-center><span ng-bind=li.Type56Cnt></span></td><td class=text-center><span ng-bind=li.Type57Cnt></span></td><td class=text-center><span ng-bind=li.Type58Cnt></span></td><td class=text-center><span ng-bind=li.Type59Cnt></span></td><td class=text-center><span ng-bind=li.Type60Cnt></span></td><td class=text-center><span ng-bind=li.Type61Cnt></span></td><td class=text-center><span ng-bind=li.Type62Cnt></span></td><td class=text-center><span ng-bind=li.Type63Cnt></span></td><td class=text-center><span ng-bind=li.Type64Cnt></span></td><td class=text-center><span ng-bind=li.Type65Cnt></span></td><td class=text-center><span ng-bind=li.Type66Cnt></span></td><td class=text-center><span ng-bind=li.Type67Cnt></span></td><td class=text-center><span ng-bind=li.Type68Cnt></span></td><td class=text-center><span ng-bind=li.Type69Cnt></span></td><td class=text-center><span ng-bind=li.Type70Cnt></span></td><td class=text-center><span ng-bind=li.Type71Cnt></span></td><td class=text-center><span ng-bind=li.Type72Cnt></span></td><td class=text-center><span ng-bind=li.Type73Cnt></span></td><td class=text-center><span ng-bind=li.Type74Cnt></span></td><td class=text-center><span ng-bind=li.Type75Cnt></span></td><td class=text-center><span ng-bind=li.Type76Cnt></span></td><td class=text-center><span ng-bind=li.Type77Cnt></span></td><td class=text-center><span ng-bind=li.Type78Cnt></span></td><td class=text-center><span ng-bind=li.Type79Cnt></span></td><td class=text-center><span ng-bind=li.Type80Cnt></span></td><td class=text-center><span ng-bind=li.Type81Cnt></span></td><td class=text-center><span ng-bind=li.Type82Cnt></span></td><td class=text-center><span ng-bind=li.Type83Cnt></span></td><td class=text-center><span ng-bind=li.Type84Cnt></span></td><td class=text-center><span ng-bind=li.Type85Cnt></span></td><td class=text-center><span ng-bind=li.Type86Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별 현황(육군)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>군<br>교관<br>요원</th><th>군무원</th><th>군전임<br>교수</th><th>기타<br>군관련직</th><th>민간<br>대학<br>교수</th><th>복지<br>시설</th><th>비상<br>계획관</th><th>산하<br>기관<br>/업체</th><th>예비군<br>지휘관</th><th>행정<br>관서</th><th>교육·<br>교사·<br>교수·<br>강사</th><th>방송·<br>미디어·<br>문화</th><th>번역·<br>통역</th><th>법무·<br>특허</th><th>보험</th><th>부동산</th><th>은행·<br>증권·<br>투신</th><th>편집·<br>자료관리·<br>출판·<br>인쇄</th><th>경비·<br>경호요원</th><th>시설<br>관리</th><th>안전</th><th>창고<br>관리</th><th>폭발물<br>처리</th><th>경리·<br>회계·<br>세무·<br>재무</th><th>경영·<br>컨설팅·<br>연구</th><th>경찰<br>공무원</th><th>기능직<br>공무원</th><th>기획<br>전략</th><th>무역·<br>수출입<br>관리</th><th>물류·<br>유통·<br>구매</th><th>비서·<br>인포메이션</th><th>사무직</th><th>사회<br>복지·<br>봉사</th><th>상담</th><th>소방<br>공무원</th><th>인사·<br>노무·<br>인재<br>개발</th><th>일반<br>공무원</th><th>일반<br>사무·<br>총무</th><th>배송·<br>운전</th><th>사진</th><th>생활<br>체육</th><th>서비스</th><th>식품·<br>조리</th><th>여행·<br>숙박·<br>레저</th><th>인포<br>메이션·<br>이벤트</th><th>CAD·<br>CAM</th><th>건축·<br>토목·조경·<br>설비</th><th>금속·<br>재료·<br>요업</th><th>기계·<br>기계<br>설비</th><th>농수<br>축산</th><th>도시·<br>교통</th><th>생명<br>공학·<br>식품<br>공학</th><th>생산직·<br>기능직</th><th>섬유·<br>패션·<br>의류</th><th>연구<br>개발</th><th>의약·<br>의료·<br>제약·<br>보건</th><th>전기·<br>전자·<br>제어</th><th>품질<br>관리·<br>품질<br>보증·<br>생산<br>관리</th><th>화학·<br>화공·<br>에너지</th><th>환경·<br>안전</th><th>TM</th><th>광고·<br>홍보·<br>PR</th><th>기술<br>영업</th><th>디자인</th><th>마케팅</th><th>매장<br>관리·<br>판매</th><th>상품<br>기획·<br>개발·<br>판매</th><th>영업·영업관리</th><th>IT<br>기술<br>영업·<br>기술<br>지원</th><th>IT<br>디자인</th><th>멀티<br>미디어</th><th>모바일</th><th>서버·<br>네트<br>워크<br>관리·<br>DB<br>관리</th><th>웹기획·<br>웹마<br>케팅·<br>컨텐츠</th><th>통신<br>기술</th><th>프로<br>그래머</th><th>고정익<br>조종</th><th>관제</th><th>기상</th><th>우주<br>항공</th><th>조선</th><th>항공<br>정비</th><th>항해</th><th>해양<br>정비</th><th>회전익<br>조종</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listArmy\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.Type6Cnt></span></td><td class=text-center><span ng-bind=li.Type7Cnt></span></td><td class=text-center><span ng-bind=li.Type8Cnt></span></td><td class=text-center><span ng-bind=li.Type9Cnt></span></td><td class=text-center><span ng-bind=li.Type10Cnt></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type15Cnt></span></td><td class=text-center><span ng-bind=li.Type16Cnt></span></td><td class=text-center><span ng-bind=li.Type17Cnt></span></td><td class=text-center><span ng-bind=li.Type18Cnt></span></td><td class=text-center><span ng-bind=li.Type19Cnt></span></td><td class=text-center><span ng-bind=li.Type20Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type25Cnt></span></td><td class=text-center><span ng-bind=li.Type26Cnt></span></td><td class=text-center><span ng-bind=li.Type27Cnt></span></td><td class=text-center><span ng-bind=li.Type28Cnt></span></td><td class=text-center><span ng-bind=li.Type29Cnt></span></td><td class=text-center><span ng-bind=li.Type30Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type35Cnt></span></td><td class=text-center><span ng-bind=li.Type36Cnt></span></td><td class=text-center><span ng-bind=li.Type37Cnt></span></td><td class=text-center><span ng-bind=li.Type38Cnt></span></td><td class=text-center><span ng-bind=li.Type39Cnt></span></td><td class=text-center><span ng-bind=li.Type40Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type45Cnt></span></td><td class=text-center><span ng-bind=li.Type46Cnt></span></td><td class=text-center><span ng-bind=li.Type47Cnt></span></td><td class=text-center><span ng-bind=li.Type48Cnt></span></td><td class=text-center><span ng-bind=li.Type49Cnt></span></td><td class=text-center><span ng-bind=li.Type50Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td><td class=text-center><span ng-bind=li.Type55Cnt></span></td><td class=text-center><span ng-bind=li.Type56Cnt></span></td><td class=text-center><span ng-bind=li.Type57Cnt></span></td><td class=text-center><span ng-bind=li.Type58Cnt></span></td><td class=text-center><span ng-bind=li.Type59Cnt></span></td><td class=text-center><span ng-bind=li.Type60Cnt></span></td><td class=text-center><span ng-bind=li.Type61Cnt></span></td><td class=text-center><span ng-bind=li.Type62Cnt></span></td><td class=text-center><span ng-bind=li.Type63Cnt></span></td><td class=text-center><span ng-bind=li.Type64Cnt></span></td><td class=text-center><span ng-bind=li.Type65Cnt></span></td><td class=text-center><span ng-bind=li.Type66Cnt></span></td><td class=text-center><span ng-bind=li.Type67Cnt></span></td><td class=text-center><span ng-bind=li.Type68Cnt></span></td><td class=text-center><span ng-bind=li.Type69Cnt></span></td><td class=text-center><span ng-bind=li.Type70Cnt></span></td><td class=text-center><span ng-bind=li.Type71Cnt></span></td><td class=text-center><span ng-bind=li.Type72Cnt></span></td><td class=text-center><span ng-bind=li.Type73Cnt></span></td><td class=text-center><span ng-bind=li.Type74Cnt></span></td><td class=text-center><span ng-bind=li.Type75Cnt></span></td><td class=text-center><span ng-bind=li.Type76Cnt></span></td><td class=text-center><span ng-bind=li.Type77Cnt></span></td><td class=text-center><span ng-bind=li.Type78Cnt></span></td><td class=text-center><span ng-bind=li.Type79Cnt></span></td><td class=text-center><span ng-bind=li.Type80Cnt></span></td><td class=text-center><span ng-bind=li.Type81Cnt></span></td><td class=text-center><span ng-bind=li.Type82Cnt></span></td><td class=text-center><span ng-bind=li.Type83Cnt></span></td><td class=text-center><span ng-bind=li.Type84Cnt></span></td><td class=text-center><span ng-bind=li.Type85Cnt></span></td><td class=text-center><span ng-bind=li.Type86Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별 현황(해군)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>군<br>교관<br>요원</th><th>군무원</th><th>군전임<br>교수</th><th>기타<br>군관련직</th><th>민간<br>대학<br>교수</th><th>복지<br>시설</th><th>비상<br>계획관</th><th>산하<br>기관<br>/업체</th><th>예비군<br>지휘관</th><th>행정<br>관서</th><th>교육·<br>교사·<br>교수·<br>강사</th><th>방송·<br>미디어·<br>문화</th><th>번역·<br>통역</th><th>법무·<br>특허</th><th>보험</th><th>부동산</th><th>은행·<br>증권·<br>투신</th><th>편집·<br>자료관리·<br>출판·<br>인쇄</th><th>경비·<br>경호요원</th><th>시설<br>관리</th><th>안전</th><th>창고<br>관리</th><th>폭발물<br>처리</th><th>경리·<br>회계·<br>세무·<br>재무</th><th>경영·<br>컨설팅·<br>연구</th><th>경찰<br>공무원</th><th>기능직<br>공무원</th><th>기획<br>전략</th><th>무역·<br>수출입<br>관리</th><th>물류·<br>유통·<br>구매</th><th>비서·<br>인포메이션</th><th>사무직</th><th>사회<br>복지·<br>봉사</th><th>상담</th><th>소방<br>공무원</th><th>인사·<br>노무·<br>인재<br>개발</th><th>일반<br>공무원</th><th>일반<br>사무·<br>총무</th><th>배송·<br>운전</th><th>사진</th><th>생활<br>체육</th><th>서비스</th><th>식품·<br>조리</th><th>여행·<br>숙박·<br>레저</th><th>인포<br>메이션·<br>이벤트</th><th>CAD·<br>CAM</th><th>건축·<br>토목·조경·<br>설비</th><th>금속·<br>재료·<br>요업</th><th>기계·<br>기계<br>설비</th><th>농수<br>축산</th><th>도시·<br>교통</th><th>생명<br>공학·<br>식품<br>공학</th><th>생산직·<br>기능직</th><th>섬유·<br>패션·<br>의류</th><th>연구<br>개발</th><th>의약·<br>의료·<br>제약·<br>보건</th><th>전기·<br>전자·<br>제어</th><th>품질<br>관리·<br>품질<br>보증·<br>생산<br>관리</th><th>화학·<br>화공·<br>에너지</th><th>환경·<br>안전</th><th>TM</th><th>광고·<br>홍보·<br>PR</th><th>기술<br>영업</th><th>디자인</th><th>마케팅</th><th>매장<br>관리·<br>판매</th><th>상품<br>기획·<br>개발·<br>판매</th><th>영업·영업관리</th><th>IT<br>기술<br>영업·<br>기술<br>지원</th><th>IT<br>디자인</th><th>멀티<br>미디어</th><th>모바일</th><th>서버·<br>네트<br>워크<br>관리·<br>DB<br>관리</th><th>웹기획·<br>웹마<br>케팅·<br>컨텐츠</th><th>통신<br>기술</th><th>프로<br>그래머</th><th>고정익<br>조종</th><th>관제</th><th>기상</th><th>우주<br>항공</th><th>조선</th><th>항공<br>정비</th><th>항해</th><th>해양<br>정비</th><th>회전익<br>조종</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listNavy\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.Type6Cnt></span></td><td class=text-center><span ng-bind=li.Type7Cnt></span></td><td class=text-center><span ng-bind=li.Type8Cnt></span></td><td class=text-center><span ng-bind=li.Type9Cnt></span></td><td class=text-center><span ng-bind=li.Type10Cnt></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type15Cnt></span></td><td class=text-center><span ng-bind=li.Type16Cnt></span></td><td class=text-center><span ng-bind=li.Type17Cnt></span></td><td class=text-center><span ng-bind=li.Type18Cnt></span></td><td class=text-center><span ng-bind=li.Type19Cnt></span></td><td class=text-center><span ng-bind=li.Type20Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type25Cnt></span></td><td class=text-center><span ng-bind=li.Type26Cnt></span></td><td class=text-center><span ng-bind=li.Type27Cnt></span></td><td class=text-center><span ng-bind=li.Type28Cnt></span></td><td class=text-center><span ng-bind=li.Type29Cnt></span></td><td class=text-center><span ng-bind=li.Type30Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type35Cnt></span></td><td class=text-center><span ng-bind=li.Type36Cnt></span></td><td class=text-center><span ng-bind=li.Type37Cnt></span></td><td class=text-center><span ng-bind=li.Type38Cnt></span></td><td class=text-center><span ng-bind=li.Type39Cnt></span></td><td class=text-center><span ng-bind=li.Type40Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type45Cnt></span></td><td class=text-center><span ng-bind=li.Type46Cnt></span></td><td class=text-center><span ng-bind=li.Type47Cnt></span></td><td class=text-center><span ng-bind=li.Type48Cnt></span></td><td class=text-center><span ng-bind=li.Type49Cnt></span></td><td class=text-center><span ng-bind=li.Type50Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td><td class=text-center><span ng-bind=li.Type55Cnt></span></td><td class=text-center><span ng-bind=li.Type56Cnt></span></td><td class=text-center><span ng-bind=li.Type57Cnt></span></td><td class=text-center><span ng-bind=li.Type58Cnt></span></td><td class=text-center><span ng-bind=li.Type59Cnt></span></td><td class=text-center><span ng-bind=li.Type60Cnt></span></td><td class=text-center><span ng-bind=li.Type61Cnt></span></td><td class=text-center><span ng-bind=li.Type62Cnt></span></td><td class=text-center><span ng-bind=li.Type63Cnt></span></td><td class=text-center><span ng-bind=li.Type64Cnt></span></td><td class=text-center><span ng-bind=li.Type65Cnt></span></td><td class=text-center><span ng-bind=li.Type66Cnt></span></td><td class=text-center><span ng-bind=li.Type67Cnt></span></td><td class=text-center><span ng-bind=li.Type68Cnt></span></td><td class=text-center><span ng-bind=li.Type69Cnt></span></td><td class=text-center><span ng-bind=li.Type70Cnt></span></td><td class=text-center><span ng-bind=li.Type71Cnt></span></td><td class=text-center><span ng-bind=li.Type72Cnt></span></td><td class=text-center><span ng-bind=li.Type73Cnt></span></td><td class=text-center><span ng-bind=li.Type74Cnt></span></td><td class=text-center><span ng-bind=li.Type75Cnt></span></td><td class=text-center><span ng-bind=li.Type76Cnt></span></td><td class=text-center><span ng-bind=li.Type77Cnt></span></td><td class=text-center><span ng-bind=li.Type78Cnt></span></td><td class=text-center><span ng-bind=li.Type79Cnt></span></td><td class=text-center><span ng-bind=li.Type80Cnt></span></td><td class=text-center><span ng-bind=li.Type81Cnt></span></td><td class=text-center><span ng-bind=li.Type82Cnt></span></td><td class=text-center><span ng-bind=li.Type83Cnt></span></td><td class=text-center><span ng-bind=li.Type84Cnt></span></td><td class=text-center><span ng-bind=li.Type85Cnt></span></td><td class=text-center><span ng-bind=li.Type86Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별 현황(공군)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%><col width=4%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>군<br>교관<br>요원</th><th>군무원</th><th>군전임<br>교수</th><th>기타<br>군관련직</th><th>민간<br>대학<br>교수</th><th>복지<br>시설</th><th>비상<br>계획관</th><th>산하<br>기관<br>/업체</th><th>예비군<br>지휘관</th><th>행정<br>관서</th><th>교육·<br>교사·<br>교수·<br>강사</th><th>방송·<br>미디어·<br>문화</th><th>번역·<br>통역</th><th>법무·<br>특허</th><th>보험</th><th>부동산</th><th>은행·<br>증권·<br>투신</th><th>편집·<br>자료관리·<br>출판·<br>인쇄</th><th>경비·<br>경호요원</th><th>시설<br>관리</th><th>안전</th><th>창고<br>관리</th><th>폭발물<br>처리</th><th>경리·<br>회계·<br>세무·<br>재무</th><th>경영·<br>컨설팅·<br>연구</th><th>경찰<br>공무원</th><th>기능직<br>공무원</th><th>기획<br>전략</th><th>무역·<br>수출입<br>관리</th><th>물류·<br>유통·<br>구매</th><th>비서·<br>인포메이션</th><th>사무직</th><th>사회<br>복지·<br>봉사</th><th>상담</th><th>소방<br>공무원</th><th>인사·<br>노무·<br>인재<br>개발</th><th>일반<br>공무원</th><th>일반<br>사무·<br>총무</th><th>배송·<br>운전</th><th>사진</th><th>생활<br>체육</th><th>서비스</th><th>식품·<br>조리</th><th>여행·<br>숙박·<br>레저</th><th>인포<br>메이션·<br>이벤트</th><th>CAD·<br>CAM</th><th>건축·<br>토목·조경·<br>설비</th><th>금속·<br>재료·<br>요업</th><th>기계·<br>기계<br>설비</th><th>농수<br>축산</th><th>도시·<br>교통</th><th>생명<br>공학·<br>식품<br>공학</th><th>생산직·<br>기능직</th><th>섬유·<br>패션·<br>의류</th><th>연구<br>개발</th><th>의약·<br>의료·<br>제약·<br>보건</th><th>전기·<br>전자·<br>제어</th><th>품질<br>관리·<br>품질<br>보증·<br>생산<br>관리</th><th>화학·<br>화공·<br>에너지</th><th>환경·<br>안전</th><th>TM</th><th>광고·<br>홍보·<br>PR</th><th>기술<br>영업</th><th>디자인</th><th>마케팅</th><th>매장<br>관리·<br>판매</th><th>상품<br>기획·<br>개발·<br>판매</th><th>영업·영업관리</th><th>IT<br>기술<br>영업·<br>기술<br>지원</th><th>IT<br>디자인</th><th>멀티<br>미디어</th><th>모바일</th><th>서버·<br>네트<br>워크<br>관리·<br>DB<br>관리</th><th>웹기획·<br>웹마<br>케팅·<br>컨텐츠</th><th>통신<br>기술</th><th>프로<br>그래머</th><th>고정익<br>조종</th><th>관제</th><th>기상</th><th>우주<br>항공</th><th>조선</th><th>항공<br>정비</th><th>항해</th><th>해양<br>정비</th><th>회전익<br>조종</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listAirForce\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.Type6Cnt></span></td><td class=text-center><span ng-bind=li.Type7Cnt></span></td><td class=text-center><span ng-bind=li.Type8Cnt></span></td><td class=text-center><span ng-bind=li.Type9Cnt></span></td><td class=text-center><span ng-bind=li.Type10Cnt></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type15Cnt></span></td><td class=text-center><span ng-bind=li.Type16Cnt></span></td><td class=text-center><span ng-bind=li.Type17Cnt></span></td><td class=text-center><span ng-bind=li.Type18Cnt></span></td><td class=text-center><span ng-bind=li.Type19Cnt></span></td><td class=text-center><span ng-bind=li.Type20Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type25Cnt></span></td><td class=text-center><span ng-bind=li.Type26Cnt></span></td><td class=text-center><span ng-bind=li.Type27Cnt></span></td><td class=text-center><span ng-bind=li.Type28Cnt></span></td><td class=text-center><span ng-bind=li.Type29Cnt></span></td><td class=text-center><span ng-bind=li.Type30Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type35Cnt></span></td><td class=text-center><span ng-bind=li.Type36Cnt></span></td><td class=text-center><span ng-bind=li.Type37Cnt></span></td><td class=text-center><span ng-bind=li.Type38Cnt></span></td><td class=text-center><span ng-bind=li.Type39Cnt></span></td><td class=text-center><span ng-bind=li.Type40Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type45Cnt></span></td><td class=text-center><span ng-bind=li.Type46Cnt></span></td><td class=text-center><span ng-bind=li.Type47Cnt></span></td><td class=text-center><span ng-bind=li.Type48Cnt></span></td><td class=text-center><span ng-bind=li.Type49Cnt></span></td><td class=text-center><span ng-bind=li.Type50Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td><td class=text-center><span ng-bind=li.Type55Cnt></span></td><td class=text-center><span ng-bind=li.Type56Cnt></span></td><td class=text-center><span ng-bind=li.Type57Cnt></span></td><td class=text-center><span ng-bind=li.Type58Cnt></span></td><td class=text-center><span ng-bind=li.Type59Cnt></span></td><td class=text-center><span ng-bind=li.Type60Cnt></span></td><td class=text-center><span ng-bind=li.Type61Cnt></span></td><td class=text-center><span ng-bind=li.Type62Cnt></span></td><td class=text-center><span ng-bind=li.Type63Cnt></span></td><td class=text-center><span ng-bind=li.Type64Cnt></span></td><td class=text-center><span ng-bind=li.Type65Cnt></span></td><td class=text-center><span ng-bind=li.Type66Cnt></span></td><td class=text-center><span ng-bind=li.Type67Cnt></span></td><td class=text-center><span ng-bind=li.Type68Cnt></span></td><td class=text-center><span ng-bind=li.Type69Cnt></span></td><td class=text-center><span ng-bind=li.Type70Cnt></span></td><td class=text-center><span ng-bind=li.Type71Cnt></span></td><td class=text-center><span ng-bind=li.Type72Cnt></span></td><td class=text-center><span ng-bind=li.Type73Cnt></span></td><td class=text-center><span ng-bind=li.Type74Cnt></span></td><td class=text-center><span ng-bind=li.Type75Cnt></span></td><td class=text-center><span ng-bind=li.Type76Cnt></span></td><td class=text-center><span ng-bind=li.Type77Cnt></span></td><td class=text-center><span ng-bind=li.Type78Cnt></span></td><td class=text-center><span ng-bind=li.Type79Cnt></span></td><td class=text-center><span ng-bind=li.Type80Cnt></span></td><td class=text-center><span ng-bind=li.Type81Cnt></span></td><td class=text-center><span ng-bind=li.Type82Cnt></span></td><td class=text-center><span ng-bind=li.Type83Cnt></span></td><td class=text-center><span ng-bind=li.Type84Cnt></span></td><td class=text-center><span ng-bind=li.Type85Cnt></span></td><td class=text-center><span ng-bind=li.Type86Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>군별 현황(해병대)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%><col width=7.4%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>군<br>교관<br>요원</th><th>군무원</th><th>군전임<br>교수</th><th>기타<br>군관련직</th><th>민간<br>대학<br>교수</th><th>복지<br>시설</th><th>비상<br>계획관</th><th>산하<br>기관<br>/업체</th><th>예비군<br>지휘관</th><th>행정<br>관서</th><th>교육·<br>교사·<br>교수·<br>강사</th><th>방송·<br>미디어·<br>문화</th><th>번역·<br>통역</th><th>법무·<br>특허</th><th>보험</th><th>부동산</th><th>은행·<br>증권·<br>투신</th><th>편집·<br>자료관리·<br>출판·<br>인쇄</th><th>경비·<br>경호요원</th><th>시설<br>관리</th><th>안전</th><th>창고<br>관리</th><th>폭발물<br>처리</th><th>경리·<br>회계·<br>세무·<br>재무</th><th>경영·<br>컨설팅·<br>연구</th><th>경찰<br>공무원</th><th>기능직<br>공무원</th><th>기획<br>전략</th><th>무역·<br>수출입<br>관리</th><th>물류·<br>유통·<br>구매</th><th>비서·<br>인포메이션</th><th>사무직</th><th>사회<br>복지·<br>봉사</th><th>상담</th><th>소방<br>공무원</th><th>인사·<br>노무·<br>인재<br>개발</th><th>일반<br>공무원</th><th>일반<br>사무·<br>총무</th><th>배송·<br>운전</th><th>사진</th><th>생활<br>체육</th><th>서비스</th><th>식품·<br>조리</th><th>여행·<br>숙박·<br>레저</th><th>인포<br>메이션·<br>이벤트</th><th>CAD·<br>CAM</th><th>건축·<br>토목·조경·<br>설비</th><th>금속·<br>재료·<br>요업</th><th>기계·<br>기계<br>설비</th><th>농수<br>축산</th><th>도시·<br>교통</th><th>생명<br>공학·<br>식품<br>공학</th><th>생산직·<br>기능직</th><th>섬유·<br>패션·<br>의류</th><th>연구<br>개발</th><th>의약·<br>의료·<br>제약·<br>보건</th><th>전기·<br>전자·<br>제어</th><th>품질<br>관리·<br>품질<br>보증·<br>생산<br>관리</th><th>화학·<br>화공·<br>에너지</th><th>환경·<br>안전</th><th>TM</th><th>광고·<br>홍보·<br>PR</th><th>기술<br>영업</th><th>디자인</th><th>마케팅</th><th>매장<br>관리·<br>판매</th><th>상품<br>기획·<br>개발·<br>판매</th><th>영업·영업관리</th><th>IT<br>기술<br>영업·<br>기술<br>지원</th><th>IT<br>디자인</th><th>멀티<br>미디어</th><th>모바일</th><th>서버·<br>네트<br>워크<br>관리·<br>DB<br>관리</th><th>웹기획·<br>웹마<br>케팅·<br>컨텐츠</th><th>통신<br>기술</th><th>프로<br>그래머</th><th>고정익<br>조종</th><th>관제</th><th>기상</th><th>우주<br>항공</th><th>조선</th><th>항공<br>정비</th><th>항해</th><th>해양<br>정비</th><th>회전익<br>조종</th><th>기타</th></tr><tr ng-repeat=\"li in vc.listROKM\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td><td class=text-center><span ng-bind=li.Type5Cnt></span></td><td class=text-center><span ng-bind=li.Type6Cnt></span></td><td class=text-center><span ng-bind=li.Type7Cnt></span></td><td class=text-center><span ng-bind=li.Type8Cnt></span></td><td class=text-center><span ng-bind=li.Type9Cnt></span></td><td class=text-center><span ng-bind=li.Type10Cnt></span></td><td class=text-center><span ng-bind=li.Type11Cnt></span></td><td class=text-center><span ng-bind=li.Type12Cnt></span></td><td class=text-center><span ng-bind=li.Type13Cnt></span></td><td class=text-center><span ng-bind=li.Type14Cnt></span></td><td class=text-center><span ng-bind=li.Type15Cnt></span></td><td class=text-center><span ng-bind=li.Type16Cnt></span></td><td class=text-center><span ng-bind=li.Type17Cnt></span></td><td class=text-center><span ng-bind=li.Type18Cnt></span></td><td class=text-center><span ng-bind=li.Type19Cnt></span></td><td class=text-center><span ng-bind=li.Type20Cnt></span></td><td class=text-center><span ng-bind=li.Type21Cnt></span></td><td class=text-center><span ng-bind=li.Type22Cnt></span></td><td class=text-center><span ng-bind=li.Type23Cnt></span></td><td class=text-center><span ng-bind=li.Type24Cnt></span></td><td class=text-center><span ng-bind=li.Type25Cnt></span></td><td class=text-center><span ng-bind=li.Type26Cnt></span></td><td class=text-center><span ng-bind=li.Type27Cnt></span></td><td class=text-center><span ng-bind=li.Type28Cnt></span></td><td class=text-center><span ng-bind=li.Type29Cnt></span></td><td class=text-center><span ng-bind=li.Type30Cnt></span></td><td class=text-center><span ng-bind=li.Type31Cnt></span></td><td class=text-center><span ng-bind=li.Type32Cnt></span></td><td class=text-center><span ng-bind=li.Type33Cnt></span></td><td class=text-center><span ng-bind=li.Type34Cnt></span></td><td class=text-center><span ng-bind=li.Type35Cnt></span></td><td class=text-center><span ng-bind=li.Type36Cnt></span></td><td class=text-center><span ng-bind=li.Type37Cnt></span></td><td class=text-center><span ng-bind=li.Type38Cnt></span></td><td class=text-center><span ng-bind=li.Type39Cnt></span></td><td class=text-center><span ng-bind=li.Type40Cnt></span></td><td class=text-center><span ng-bind=li.Type41Cnt></span></td><td class=text-center><span ng-bind=li.Type42Cnt></span></td><td class=text-center><span ng-bind=li.Type43Cnt></span></td><td class=text-center><span ng-bind=li.Type44Cnt></span></td><td class=text-center><span ng-bind=li.Type45Cnt></span></td><td class=text-center><span ng-bind=li.Type46Cnt></span></td><td class=text-center><span ng-bind=li.Type47Cnt></span></td><td class=text-center><span ng-bind=li.Type48Cnt></span></td><td class=text-center><span ng-bind=li.Type49Cnt></span></td><td class=text-center><span ng-bind=li.Type50Cnt></span></td><td class=text-center><span ng-bind=li.Type51Cnt></span></td><td class=text-center><span ng-bind=li.Type52Cnt></span></td><td class=text-center><span ng-bind=li.Type53Cnt></span></td><td class=text-center><span ng-bind=li.Type54Cnt></span></td><td class=text-center><span ng-bind=li.Type55Cnt></span></td><td class=text-center><span ng-bind=li.Type56Cnt></span></td><td class=text-center><span ng-bind=li.Type57Cnt></span></td><td class=text-center><span ng-bind=li.Type58Cnt></span></td><td class=text-center><span ng-bind=li.Type59Cnt></span></td><td class=text-center><span ng-bind=li.Type60Cnt></span></td><td class=text-center><span ng-bind=li.Type61Cnt></span></td><td class=text-center><span ng-bind=li.Type62Cnt></span></td><td class=text-center><span ng-bind=li.Type63Cnt></span></td><td class=text-center><span ng-bind=li.Type64Cnt></span></td><td class=text-center><span ng-bind=li.Type65Cnt></span></td><td class=text-center><span ng-bind=li.Type66Cnt></span></td><td class=text-center><span ng-bind=li.Type67Cnt></span></td><td class=text-center><span ng-bind=li.Type68Cnt></span></td><td class=text-center><span ng-bind=li.Type69Cnt></span></td><td class=text-center><span ng-bind=li.Type70Cnt></span></td><td class=text-center><span ng-bind=li.Type71Cnt></span></td><td class=text-center><span ng-bind=li.Type72Cnt></span></td><td class=text-center><span ng-bind=li.Type73Cnt></span></td><td class=text-center><span ng-bind=li.Type74Cnt></span></td><td class=text-center><span ng-bind=li.Type75Cnt></span></td><td class=text-center><span ng-bind=li.Type76Cnt></span></td><td class=text-center><span ng-bind=li.Type77Cnt></span></td><td class=text-center><span ng-bind=li.Type78Cnt></span></td><td class=text-center><span ng-bind=li.Type79Cnt></span></td><td class=text-center><span ng-bind=li.Type80Cnt></span></td><td class=text-center><span ng-bind=li.Type81Cnt></span></td><td class=text-center><span ng-bind=li.Type82Cnt></span></td><td class=text-center><span ng-bind=li.Type83Cnt></span></td><td class=text-center><span ng-bind=li.Type84Cnt></span></td><td class=text-center><span ng-bind=li.Type85Cnt></span></td><td class=text-center><span ng-bind=li.Type86Cnt></span></td></tr></table></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/customer-report.html","<div class=\"page page-footable\" ng-controller=\"CustomerReportCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객 통계<!-- <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div> --></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 일반검색 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.data.totalItems placeholder=\"총 고객수\" type=text readonly> <input ng-model=vc.srch.StartDate placeholder=등록일 type=date style=\"margin-right: 10px\"> <input class=form-control type=text value=\" ~ \" style=\"width: 35px; text-align: center\" readonly> <input ng-model=vc.srch.EndDate placeholder=등록일 type=date style=\"margin-right: 10px\"><div class=search_button><button class=\"btn btn-default\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i>검색</button></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.SelectBox track by v.id\" ng-model=vc.thisSelect></select></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.LengthBox track by v.id\" ng-model=vc.thisLength></select></div><div class=\"search_select mgl05\"><select ng-change=vc.setSortSelect() ng-options=\"v as v.name for v in vc.GroupBox track by v.id\" ng-model=vc.thisGroup></select></div></div></div><!-- 일반검색 --></form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><ul class=\"nav nav-tabs\" as-sortable=vc.sortableOptions ng-model=vc.tabList><li ng-repeat=\"tab in vc.tabList\" as-sortable-item ng-class=\"vc.tabIndex == tab.Index ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(tab.Index, tab.Page);\" data-toggle=tab as-sortable-item-handle>{{tab.Text}}</a></li></ul><div ng-include=vc.pages></div></div></div><div class=row><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/employstartup.html","<div class=\"page page-footable\" ng-controller=\"EmploystartupCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>중소기업 희망 현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>중소기업 희망 현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>상담등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>중소기업 희망 현황</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><label>중소기업 추천 리스트</label><div class=addrow_pad style=\"overflow-x: auto\"><div class=table-responsive><table class=\"table tableborder\"><colgroup><col width=3%><col width=4%><col width=6%><col width=6%><col width=3%><col width=6%><col width=3%><col width=7%><col width=3%><col width=5%><col width=8%><col width=3%><col width=8%><col width=9%><col width=9%><col width=17%></colgroup><tr><th>상담<br>구분</th><th>취업<br>분야</th><th>희망<br>직종</th><th>희망<br>직무</th><th>희망<br>지역</th><th>희망<br>급여</th><th>군별</th><th>소속<br>부대</th><th>계급</th><th>성명</th><th>군번</th><th>병과및<br>특기</th><th>전역일</th><th>휴대폰</th><th>전역 후<br>연락가능번호</th><th>자격증</th></tr><tr ng-repeat=\"li in vc.listRecomm\"><td><span ng-bind=li.CounselField1_></span></td><td><span ng-bind=li.CounselField2_></span></td><td><span ng-bind=li.HopeJobType_></span></td><td><span ng-bind=li.HopeDuty_></span></td><td><span ng-bind=li.HopeLoc_></span></td><td><span ng-bind=li.HopeAmt></span></td><td><span ng-bind=li.ArmyType_></span></td><td><span ng-bind=li.PermStat_></span></td><td><span ng-bind=li.ArmyClass_></span></td><td><span ng-bind=li.CustNm></span></td><td><span ng-bind=li.ArmyNo></span></td><td><span ng-bind=li.Spec_></span></td><td><span ng-bind=li.OutArmyDate></span></td><td><span ng-bind=li.Mobile></span></td><td><span ng-bind=li.OutArmyTel></span></td><td><span ng-bind=li.LicenseNm_></span></td></tr></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage template-url=components/template/pagination.html ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/employstate.html","<div class=\"page page-footable\" ng-controller=\"EmploystateCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>취업자 현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>취업자 현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>고객등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>취업확인일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDateFrom ng-change=\"vc.srch.CompanyRegDateFrom = (dtCompanyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"취업확인일 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyRegDateTo ng-change=\"vc.srch.CompanyRegDateTo = (dtCompanyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"취업확인일 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>입사일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDateFrom ng-change=\"vc.srch.CompanyJoinDateFrom = (dtCompanyJoinDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"입사일 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCompanyJoinDateTo ng-change=\"vc.srch.CompanyJoinDateTo = (dtCompanyJoinDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"입사일 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사업정보</label><select class=form-control name=selectCombo ng-change=vc.onTenentCodeSelected() ng-model=vc.TCode ng-options=\"opt.TenantNm for opt in vc.tenantList track by opt.TenantId\" ng-disabled=\'$root.gVariable.userType != \"000\"\'><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.ArmyAreaList ng-options=\"opt2 for opt2 in vc.AreaList track by opt2\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select><!-- <common-code\r\n                      param-data=\"vc.ArmyAreaList\"\r\n                      callback=\"vc.onArmyAreaListSelected\"\r\n                    ></common-code> --></div></div><div class=col-lg-2><div class=form-group><label>군별</label><select class=form-control name=selectCombo ng-change=vc.onArmyTypeListSelected() ng-model=vc.ArmyTypeList ng-options=\"opt3.ArmyType_ for opt3 in vc.TypeList track by opt3.ArmyType\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><select class=form-control name=selectCombo ng-change=vc.onPermStat1ListSelected() ng-model=vc.PermStat1List ng-options=\"opt4.PermStat1_ for opt4 in vc.Stat1List track by opt4.PermStat1\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>고용형태</label><common-code param-data=vc.CompanyEmployList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=vc.srch.CounselUser_> <input type=hidden ng-value=vc.srch.CounselUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalCounselUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalCounselUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>취업자 현황</strong></h4>&nbsp;{{vc.totalItems}}</div><div class=tile-body><div class=row><div class=col-lg-12><div class=form-group><div class=addrow_pad><div class=table-responsive><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true class=text-center>구분</th><th data-toggle=true class=text-center>순번</th><th data-toggle=true class=text-center>군별</th><th data-toggle=true class=text-center>소속부대</th><th data-toggle=true class=text-center>계급</th><th data-toggle=true class=text-center>병과</th><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>생년월일</th><th data-toggle=true class=text-center>연락처</th><th data-toggle=true class=text-center>학력</th><th data-toggle=true class=text-center>기업구분</th><th data-toggle=true class=text-center>취업처</th><th data-toggle=true class=text-center>부서</th><th data-toggle=true class=text-center>직급/직책</th><th data-toggle=true class=text-center>직종</th><th data-toggle=true class=text-center>연봉</th><th data-toggle=true class=text-center>전역일</th><th data-toggle=true class=text-center>입사일</th><th data-toggle=true class=text-center>등록일</th><th data-toggle=true class=text-center>취업확인일</th><th data-toggle=true class=text-center>고용형태</th><th data-toggle=true class=text-center>고용형태구분</th><!-- <th data-toggle=\"true\" class=\"text-center\">비고</th>--><th data-toggle=true class=text-center>상담사</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listEmployState\"><td class=text-center><span ng-bind=li.Gubun1></span></td><td class=text-center><span ng-bind=li.RowNum></span></td><td class=text-center><span ng-bind=li.ArmyType></span></td><td class=text-center><span ng-bind=li.PermStat></span></td><td class=text-center><span ng-bind=li.ArmyClass></span></td><td class=text-center><span ng-bind=li.Spec></span></td><td class=text-center><span ng-bind=li.CustNm></span></td><td class=text-center><span ng-bind=li.ArmyNo></span></td><td class=text-center><span ng-bind=li.ResRegNo></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center><span ng-bind=li.LastEdu></span></td><td class=text-center><span ng-bind=li.CompanyGuBun></span></td><td class=text-center><span ng-bind=li.CompanyNm></span></td><td class=text-center><span ng-bind=li.CompanyDept></span></td><td class=text-center><span ng-bind=li.CompanyClass></span></td><td class=text-center><span ng-bind=li.CompanyType></span></td><td class=text-center><span ng-bind=li.CompanyAmt></span></td><td class=text-center><span ng-bind=li.OutArmyDate></span></td><td class=text-center><span ng-bind=li.CompanyJoinDate></span></td><td class=text-center><span ng-bind=li.RegDate></span></td><td class=text-center><span ng-bind=li.CompanyRegDate></span></td><td class=text-center><span ng-bind=li.CompanyEmploy></span></td><td class=text-center><span ng-bind=li.CompanyEmployGuBun></span></td><!-- <td class=\"text-center\"><span ng-bind=\"li.CompanyRemark\"></span></td>--><td class=text-center><span ng-bind=li.UserNm></span></td></tr></tbody><tfoot><tr><td colspan=22 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/itemtype-report.html","<div class=\"page page-footable\" ng-controller=\"ItemTypeReportCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>유형별 매출</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=검색 type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SurgicalManager\']\"><div class=\"form-group form-inner-label\"><!-- input class=\"form-control form-right\" ng-model=\"vc.srch.SurgicalManager\" type=\"text\">\r\n                          <label>{{vc.columnMap[\'SurgicalManager\'].ColumnLogicalNm | translate}}</label> --><common-code-custom code-list=vc.codeManager code-model=vc.srch.SurgicalManager></common-code-custom><label>담당자</label></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateFrom></date-input></div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateTo></date-input></div></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><!--요일별 방문 통계--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>유형별 매출 통계 ( {{vc.text.PayDateFrom}} ~ {{vc.text.PayDateTo}} )</strong></div><div class=\"panel-body collapse in\"><div class=\"row pd10\"><div class=col-lg-12><canvas id=base class=\"chart chart-pie\" chart-data=vc.itemTypeItem.data chart-labels=vc.itemTypeItem.labels chart-dataset-override=vc.itemTypeItem.datasetOverride height=58px chart-options=vc.itemTypeItem.options></canvas></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.FormTypeId)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr><tr style=\"text-align: center; background-color:#ccc\" ng-if=\"vc.lists.length > 0\"><td style=\"text-align: center\">합계</td><td style=\"text-align: center\">{{vc.totalCCount | number}}</td><td style=\"text-align: center\">{{vc.totalPCount | number}}</td><td style=\"text-align: center\">{{vc.totalPSum | number}}</td></tr></table><!-- <div class=\"row\">\r\n                  <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden  paging_pad\">\r\n                    <div class=\"form-group form-inline select-size-list\">\r\n                      <label> {{ :: \'Menu.LIST\' | translate }} </label>\r\n                      <select aria-controls=\"DataTables_Table_0\" class=\"input-sm\" name=\"DataTables_Table_0_length\"\r\n                              ng-change=\"vc.setChangeViewSize()\" ng-model=\"vc.srch.viewSize\"\r\n                              ng-options=\"c for c in vc.listSize\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\">\r\n                    <div class=\"paging dataTables_paginate pull-right\">\r\n                      <ul data-ng-if=\"vc.totalItems\" direction-links=\"true\"\r\n                          first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\"\r\n                          last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=\"pagination\"\r\n                          next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=\"vc.setPageChanged()\"\r\n                          ng-model=\"vc.currentPage\" previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\"\r\n                          total-items=\"vc.totalItems\" uib-pagination\r\n                          boundary-links=\"true\" items-per-page=\"vc.viewSize\" max-size=\"vc.maxSize\"\r\n                          num-pages=\"vc.numPages\" rotate=\"false\" template-url=\"components/template/pagination.html\"></ul>\r\n                    </div>\r\n                  </div>\r\n                </div> --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/methodcounsel.html","<div class=\"page page-footable\" ng-controller=\"MethodcounselCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>상담방법별 상담현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>상담방법별 상담현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>상담등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>상담방법별 등록현황</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>상담방법별 등록현황(총괄)</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=16%><col width=16%><col width=16%><col width=16%><col width=16%></colgroup><tr><th colspan=2>구분</th><th>계</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th></tr><tr ng-repeat=\"li in vc.listAll\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show=li.Gubun1_show><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show=li.Gubun2_show><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>계급별 상담방법현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=12.5%><col width=12.5%><col width=12.5%><col width=12.5%><col width=12.5%><col width=12.5%><col width=12.5%><col width=12.5%></colgroup><tr><th colspan=3>구분</th><th>계</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th></tr><tr ng-repeat=\"li in vc.listClass\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show=li.Gubun1_show><span ng-bind=li.Gubun1></span></td><td class=text-center rowspan={{li.Gubun2_rowspan}} ng-show=li.Gubun2_show><span ng-bind=li.Gubun2></span></td><td class=text-center ng-show=li.Gubun3_show><span ng-bind=li.Gubun3></span></td><td class=text-center><span ng-bind=li.TotCnt></span></td><td class=text-center><span ng-bind=li.Type1Cnt></span></td><td class=text-center><span ng-bind=li.Type2Cnt></span></td><td class=text-center><span ng-bind=li.Type3Cnt></span></td><td class=text-center><span ng-bind=li.Type4Cnt></span></td></tr></table></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/outamt-report.html","<div class=\"page page-footable\" ng-controller=\"OutAmtReportCtrl as vc\"><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table><!-- / Table row --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/period-report.html","<div class=\"page page-footable\" ng-controller=\"PeriodReportCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>기간별 매출</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=검색 type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SurgicalManager\']\"><div class=\"form-group form-inner-label\"><!--\r\n                          <input class=\"form-control form-right\" ng-model=\"vc.srch.SurgicalManager\" type=\"text\">\r\n                          <label>{{vc.columnMap[\'SurgicalManager\'].ColumnLogicalNm | translate}}</label>\r\n                          --><common-code-custom code-list=vc.codeManager code-model=vc.srch.SurgicalManager></common-code-custom><label>담당자</label></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateFrom></date-input></div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateTo></date-input></div></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><!--요일별 방문 통계--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>기간별 매출 통계</strong></div><div id=reservDateBaseWrap class=\"panel-body collapse in\"><div class=\"row pd10\"><div class=col-lg-12><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.daily.data chart-labels=vc.daily.labels chart-colors=vc.daily.colors chart-dataset-override=vc.daily.datasetOverride chart-options=vc.daily.options height=50px></canvas></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr><tr style=\"text-align: center; background-color:#ccc\"><td style=\"text-align: center\">합계</td><td style=\"text-align: center\">{{vc.totalPDCount | number}}</td><td style=\"text-align: center\">{{vc.totalPCount | number}}</td><td style=\"text-align: center\">{{vc.totalPSum | number}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/surgicalmanager-report.html","<div class=\"page page-footable\" ng-controller=\"SurgicalManagerReportCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>담당자별 매출</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=검색 type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SurgicalManager\']\"><div class=\"form-group form-inner-label\"><!-- input class=\"form-control form-right\" ng-model=\"vc.srch.SurgicalManager\" type=\"text\">\r\n                          <label>{{vc.columnMap[\'SurgicalManager\'].ColumnLogicalNm | translate}}</label> --><common-code-custom code-list=vc.codeManager code-model=vc.srch.SurgicalManager></common-code-custom><label>담당자</label></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateFrom></date-input></div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateTo></date-input></div></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div><!-- /버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><!--요일별 방문 통계--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>담당자별 매출 통계 ( {{vc.text.PayDateFrom}} ~ {{vc.text.PayDateTo}} )</strong></div><div class=\"panel-body collapse in\"><div class=\"row pd10\"><div class=col-lg-12><canvas id=base class=\"chart chart-pie\" chart-data=vc.surgicalManagerItem.data chart-labels=vc.surgicalManagerItem.labels chart-dataset-override=vc.surgicalManagerItem.datasetOverride height=58px chart-options=vc.surgicalManagerItem.options></canvas></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.FormTypeId)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr><tr style=\"text-align: center; background-color:#ccc\" ng-if=\"vc.lists.length > 0\"><td style=\"text-align: center\">합계</td><td style=\"text-align: center\">{{vc.totalCCount | number}}</td><td style=\"text-align: center\">{{vc.totalPCount | number}}</td><td style=\"text-align: center\">{{vc.totalPSum | number}}</td></tr></table><!-- <div class=\"row\">\r\n                  <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden  paging_pad\">\r\n                    <div class=\"form-group form-inline select-size-list\">\r\n                      <label> {{ :: \'Menu.LIST\' | translate }} </label>\r\n                      <select aria-controls=\"DataTables_Table_0\" class=\"input-sm\" name=\"DataTables_Table_0_length\"\r\n                              ng-change=\"vc.setChangeViewSize()\" ng-model=\"vc.srch.viewSize\"\r\n                              ng-options=\"c for c in vc.listSize\">\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\">\r\n                    <div class=\"paging dataTables_paginate pull-right\">\r\n                      <ul data-ng-if=\"vc.totalItems\" direction-links=\"true\"\r\n                          first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\"\r\n                          last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=\"pagination\"\r\n                          next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=\"vc.setPageChanged()\"\r\n                          ng-model=\"vc.currentPage\" previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\"\r\n                          total-items=\"vc.totalItems\" uib-pagination\r\n                          boundary-links=\"true\" items-per-page=\"vc.viewSize\" max-size=\"vc.maxSize\"\r\n                          num-pages=\"vc.numPages\" rotate=\"false\" template-url=\"components/template/pagination.html\"></ul>\r\n                    </div>\r\n                  </div>\r\n                </div> --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/totalprog.html","<div class=\"page page-footable\" ng-controller=\"TotalprogCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>총괄진행현황/진도율</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>총괄진행현황/진도율</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>고객등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateFrom ng-change=\"vc.srch.CustArmyRegDateFrom = (dtCustArmyRegDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCustArmyRegDateTo ng-change=\"vc.srch.CustArmyRegDateTo = (dtCustArmyRegDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"고객등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>상담등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>총괄진행현황/진도율</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>등록현황</label><div class=addrow_pad><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=25%><col width=25%><col width=25%></colgroup><tr><th>구분</th><th>목표</th><th>등록</th><th>등록율(%)</th></tr><tr ng-repeat=\"li in vc.listReg\"><td class=text-center><span ng-bind=li.Gubun></span></td><td class=text-center><span ng-bind=li.TargetCnt></span></td><td class=text-center><span ng-bind=li.RegCnt></span></td><td class=text-center><span ng-bind=li.RegRate></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>상담현황</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><!-- <colgroup>\r\n                        <col width=\"\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                        <col width=\"10%\" />\r\n                      </colgroup> --><tr><th rowspan=2>구분</th><th rowspan=2>목표</th><th colspan={{vc.CounselList.length}}>실시</th><th colspan={{vc.CounselList.length}}>진도율(%)</th></tr><tr><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th></tr><tr ng-repeat=\"li in vc.listCounsel\"><td class=text-center><span ng-bind=li.Gubun></span></td><td class=text-center><span ng-bind=li.TargetCnt></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm1}}></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm2}}></span></td></tr></table></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/unitclass.html","<div class=\"page page-footable\" ng-controller=\"UnitclassCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>부대별/컨설턴트별 상담현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>통계/분석</a></li><li><a>부대별/컨설턴트별 상담현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>상담등록일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"vc.srch.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"vc.srch.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>부대별/컨설턴트별 상담현황</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>상담현황(총괄)</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><!-- <colgroup>\r\n                        <col width=\"\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                        <col width=\"5.5%\" />\r\n                      </colgroup> --><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan={{vc.CounselList.length+1}}>육군</th><th colspan={{vc.CounselList.length+1}}>공군</th><th colspan={{vc.CounselList.length+1}}>해군</th><th colspan={{vc.CounselList.length+1}}>해병대</th></tr><tr><th>소계</th><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th><th>소계</th><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th><th>소계</th><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th><th>소계</th><th ng-repeat=\"cl in vc.CounselList\">{{cl.ConsultNm}}</th></tr><tr ng-repeat=\"li in vc.listAll\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center><span ng-bind=li.CompCntTot></span></td><td class=text-center><span ng-bind=li.CompCnt></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm1}}></span></td><td class=text-center><span ng-bind=li.CompCnt2></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm1}}2></span></td><td class=text-center><span ng-bind=li.CompCnt3></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm1}}3></span></td><td class=text-center><span ng-bind=li.CompCnt4></span></td><td class=text-center ng-repeat=\"cl in vc.CounselList\"><span ng-bind=li.{{cl.ConsultNm1}}4></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>부대별 상담현황</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><!-- <colgroup>\r\n                        <col width=\"\" />\r\n                        <col width=\"14%\" />\r\n                        <col width=\"12%\" />\r\n                        <col width=\"12%\" />\r\n                        <col width=\"12%\" />\r\n                        <col width=\"12%\" />\r\n                        <col width=\"12%\" />\r\n                        <col width=\"12%\" />\r\n                      </colgroup> --><tr><th colspan=2>구분</th><th>목표</th><th>진도율(%)</th><th ng-repeat=\"cl2 in vc.CounselList2\">{{cl2.ConsultNm}}</th></tr><tr ng-repeat=\"li in vc.listUnit\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show=li.Gubun1_show><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show=li.Gubun2_show><span ng-bind=li.Gubun2></span></td><td class=text-center rowspan={{li.Goal_rowspan}} ng-show=li.Goal_show><span ng-bind=li.Goal></span></td><td class=text-center rowspan={{li.ProgressRate_rowspan}} ng-show=li.ProgressRate_show><span ng-bind=li.ProgressRate></span></td><td class=text-center ng-repeat=\"cl2 in vc.CounselList2\"><span ng-bind=li.{{cl2.ConsultNm1}}Cnt></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>컨설턴트별 상담현황</label><div class=addrow_pad style=\"overflow-x: auto\"><table class=\"table tableborder\"><!-- <colgroup>\r\n                        <col width=\"\" />\r\n                        <col width=\"17%\" />\r\n                        <col width=\"17%\" />\r\n                        <col width=\"17%\" />\r\n                        <col width=\"17%\" />\r\n                        <col width=\"17%\" />\r\n                      </colgroup> --><tr><th colspan=2>구분</th><th ng-repeat=\"cl2 in vc.CounselList2\">{{cl2.ConsultNm}}</th></tr><tr ng-repeat=\"li in vc.listCounsel\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center ng-repeat=\"cl2 in vc.CounselList2\"><span ng-bind=li.{{cl2.ConsultNm1}}Cnt></span></td></tr></table></div></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/state/visitpath-report.html","<div class=\"page page-footable\" ng-controller=\"VisitPathReportCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>방문경로별 매출</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=검색 type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SurgicalManager\']\"><div class=\"form-group form-inner-label\"><!--                           <input class=\"form-control form-right\" ng-model=\"vc.srch.SurgicalManager\" type=\"text\">\r\n                          <label>{{vc.columnMap[\'SurgicalManager\'].ColumnLogicalNm | translate}}</label> --><common-code-custom code-list=vc.codeManager code-model=vc.srch.SurgicalManager></common-code-custom><label>담당자</label></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateFrom></date-input></div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" ng-if=\"vc.columnMap[\'PayDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group><date-input date=vc.srch.PayDateTo></date-input></div></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div><!-- 버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><!--요일별 방문 통계--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>방문경로별 매출 통계 ( {{vc.text.PayDateFrom}} ~ {{vc.text.PayDateTo}} )</strong></div><div class=\"panel-body collapse in\"><div class=\"row pd10\"><div class=col-lg-12><canvas id=base class=\"chart chart-pie\" chart-data=vc.visitPathItem.data chart-labels=vc.visitPathItem.labels chart-dataset-override=vc.visitPathItem.datasetOverride height=58px chart-options=vc.visitPathItem.options></canvas></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.FormTypeId)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr><tr style=\"text-align: center; background-color:#ccc\" ng-if=\"vc.lists.length > 0\"><td style=\"text-align: center\">합계</td><td style=\"text-align: center\">{{vc.totalVCount | number}}</td><td style=\"text-align: center\">{{vc.totalPCount | number}}</td><td style=\"text-align: center\">{{vc.totalPSum | number}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div><!-- /page content --></div>");
$templateCache.put("components/agreement/agreement.html","<!-- agreement --><section class=\"joinStepWrap mtb50\"><!-- section.joinStepWrap--><div class=content><h2>이용약관</h2></div><!-- // section.joinStepWrap--></section><section class=\"inputInfoWrap custInfo mb-50\"><!-- section.joinStep --><div class=content><div class=joinItem><div class=agreeContent><ul><li><dl><dt>제1조 (목적)</dt><dd>이 약관은 ㈜소프트자이온 (이하 “회사”)가 제공하는 Salevis Care(care.salevis.co.kr) 서비스 및 관련 제반 서비스(이하 “서비스”)의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</dd></dl></li><li><dl><dt>제2조 (용어의 정의)</dt><dd>이 약관에서 사용하는 용어는 아래와 같습니다.<ul><li>1. “사용자(회원)”이라 함은 회사의 “서비스”에 접속하여 이 약관에 따라 “회사”와 이용계약을 체결하고 “회사”가 제공하는 “서비스”를 이용하는 고객을 말합니다.</li><li>2. “아이디(ID)”라 함은 “회원”의 식별과 서비스 이용을 위하여 “회원”이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 의미합니다.</li><li>3. “비밀번호”라 함은 “회원”이 부여 받은 “아이디와 일치되는 “회원”임을 확인하고 비밀보호를 위해 “회원” 자신이 정한 문자 또는 숫자의 조합을 의미합니다.</li><li>4. “고객” : 사용자(회원)가 관리의 대상으로 삼아 등록한 회원의 서비스 대상을 의미합니다.</li><li>5. “유료서비스”라 함은 “서비스” 중 “회사”가 유료로 제공하는 제반 서비스를 의미합니다.</li><li>6. “유효기간”이라 함은 회사의 회원으로 이용료를 납부하고 약정한 기간을 정하여 회원의 권리를 취득한 기간을 말합니다.</li><li>7. “게시물” 혹은 “콘텐츠”이라 함은 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호ᆞ문자ᆞ음성ᆞ음향ᆞ화상ᆞ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.</li></ul></dd></dl></li><li><dl><dt>제3조 (약관의 게시와 개정)</dt><dd><ul><li>1. 본 약관은 회사의 서비스 홈페이지(salevis.kr)에 게시함으로 효력이 발생합니다.</li><li>2. “회사”는 “약관의규제에관한법률”, “정보통신망이용촉진및정보보호에관한법률(이하 “정보통신망법”)” 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li></ul></dd></dl></li><li><dl><dt>제4조 (약관의 해석)</dt><dd><ul><li>1. 회사는 개별 서비스에 대해서는 별도의 이용약관 및 정책(“기타 약관 등”이라 함)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 “기타 약관 등”이 우선하여 적용됩니다.</li><li>2. 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 “기타 약관 등” 및 관계법령 또는 상관례에 따릅니다.</li></ul></dd></dl></li><li><dl><dt>제5조 [이용계약 체결]</dt><dd><ul><li>1. 이용계약은 “회원”이 되고자 하는 자(이하 “가입신청자”)가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 “회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</li><li>2. “회사”는 “가입신청자”의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, “회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.<ul><li>- 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li><li>- 실명이 아니거나 타인의 명의를 이용한 경우</li><li>- 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li><li>- 14세 미만 아동이 정보통신망 이용촉진 및 정보보호등에 관한 법률에서 정한 “개인정보” 입력 시 법정대리인(부모 등)의 동의를 얻지 아니한 경우</li><li>- 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li><li>- 기타 회사가 정한 이용신청요건이 미비되었을 경우</li></ul></li><li>3. “회원”이 유료서비스를 이용하는 경우 이용대금을 납부한 후 서비스를 이용하는 것을 원칙으로 하며, 유료서비스 이용계약의 성립시기는 “구매완료”를 신청절차 상에서 표시한 시점으로 합니다.</li><li>4. “회사”는 만 20세 미만의 미성년회원이 유료서비스를 이용하고자 하는 경우에 부모 등 법정대리인의 동의를 얻거나, 계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에 고지하는 조치를 취합니다.</li><li>5. “회사”는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.</li><li>6. 제2항과 제3항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, “회사”는 원칙적으로 이를 가입신청자에게 알리도록 합니다.</li><li>7. 이용계약의 성립 시기는 “회사”가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.</li><li>8. “회사”는 “회원”에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.</li></ul></dd></dl></li><li><dl><dt>제6조 (회원정보의 변경)</dt><dd><ul><li>1. “회원”은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 아이디 등은 수정이 불가능합니다.</li><li>2. “회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 “회사”에 대하여 그 변경사항을 알려야 합니다.</li><li>3. 제2항의 변경사항을 “회사”에 알리지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.</li></ul></dd></dl></li><li><dl><dt>제7조 (개인정보보호 의무)</dt><dd>본 서비스를 이용하기 위해 회원이 회사에 제공(단, 회원이 회사에 제공하는 고객정보는 회사가 요구하는 정보를 포함하여야 하며 File, 회원의 직접입력, Fax 등의 형태로 제공될 수 있음)하는 회원의 고객정보에 대한 모든 권한과 관리책임은 회원에게 있습니다. 회원은 신용정보법, 개인 정보보호지침 기타 관련 법규에 따라 적법하고 공정한 수단에 의하여 고객의 정보를 수집ㆍ이용하여야 하므로, 회사는 회원이 회사에 제공한 고 객정보에 대해 적법한 절차를 거친 것으로 처리합니다. 따라서 회사는 회원의 동의를 얻고 회원은 고객의 동의를 얻어 회원의 고객을 위해 회사가 제공하는 서비스에 대해 회원 고객이 문제를 제기할 경우, 발생하는 모든 문제는 회원의 책임으로 해결해야 합니다.<br>회원의 고객정보는 회사가 임의로 이용하거나 누출해서는 안되며 회원이 서비스를 해지할 경우에 회사는 해당 회원의 고객정보를 회원의 요구사항 에 따라 처리해야 합니다. 단, 다음 각 호의 경우는 회원의 별도 동의없이 제3자에게 회원의 개인정보를 제공할 수 있습니다.<ul><li>1.수사상 목적에 따른 수사기관의 서면 요구가 있는 경우에 수사협조의 목적으로 국가 수사 기관에 성명, 주소등 신상정보를 제공하는 경우</li><li>2.신용정보의 이용 및 보호에 관한 법률, 전기통신관련법률 등 법률에 특별한 규정이 있는 경우</li><li>3.회사가 회원에게 제공하는 서비스질을 향상시킬 목적, 학술적인 연구 등을 위하여 제공하는 경우</li><li>4.이용요금 연체로 인한 신용정보조회, 채권추심 의뢰시</li></ul></dd></dl></li><li><dl><dt>제8조 (“회원”의 “아이디” 및 “비밀번호”의 관리에 대한 의무)</dt><dd>“회원”은 본 서비스에서 사용하는 비밀번호와 관련된 모든 행동을 보호/관리해야 합니다. “회사”는 귀하의 계정에 비밀번호를 강력한 암호(대문자, 소문자 및 숫자, 기호의 조합)로 설정할 것을 권장합니다. “회사”는 위 사항을 만족하지 못했을 때 일어난 어떠한 손실이나 피해에 대해 책임지지 않습니다. “회사”는 “서비스”를 안전하게 유지하기 위해 최선을 다하고 있지만 안전을 보장할 수는 없습니다.</dd></dl></li><li><dl><dt>제9조 (“회원”에 대한 통지)</dt><dd><ul><li>1.“회사”가 “회원”에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한 “회원”이 지정한 전자우편주소, 서비스 내 전자메모 및 쪽지 등으로 할 수 있습니다.</li><li>2.“회사”는 “회원” 전체에 대한 통지의 경우 7일 이상 “회사”의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</li></ul></dd></dl></li><li><dl><dt>제10조 (“회사”의 의무)</dt><dd><ul><li>1.“회사”는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 “서비스”를 제공하기 위하여 최선을 다하여 노력합니다.</li><li>2.“회사”는 “회원”이 안전하게 “서비스”를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보보호정책을 공시하고 준수합니다.</li><li>3.“회사”는 서비스이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다.</li><li>4.“회사”는 다음의 사항을 해당 ” 유료서비스”의 이용초기화면이나 그 포장, FAQ 등에 “회원”이 알기 쉽게 표시합니다.<ul><li>유료서비스의 명칭 또는 제호</li><li>유료서비스의 내용, 이용방법, 이용료, 결제방법 기타 이용조건</li><li>이용가능 기기 및 이용에 필요한 최소한의 기술사양</li></ul></li></ul></dd></dl></li><li><dl><dt>제11조 (서비스 이용의 중지 또는 계약의 해지)</dt><dd><ul><li>1.“회원”은 다음 행위를 하여서는 안 됩니다.<ul><li>신청 또는 변경 시 허위내용의 등록</li><li>타인의 정보도용</li><li>“회사”에 게시된 정보의 변경</li><li>“회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li><li>“회사”와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li><li>“회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li><li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 “회사”에 공개 또는 게시하는 행위</li><li>회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li><li>기타 불법적이거나 부당한 행위</li></ul></li><li>2.“회원”은 관계법, 본 약관의 규정, 이용안내 및 “서비스”와 관련하여 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하며, 기타 “회사”의 업무에 방해되는 행위를 하여서는 안 됩니다.</li></ul></dd></dl></li><li><dl><dt>제12조 (서비스의 제공 등)</dt><dd><ul><li>1.서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li><li>2.“회사”는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 “회사”는 제9조(“회원”에 대한 통지)에 정한 방법으로 “회원”에게 통지합니다. 다만, “회사”가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</li><li>3.“회사”는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공시한 바에 따릅니다.</li><li>4.사업종목의 전환, 사업의 포기 등의 이유로 “유료서비스”를 제공할 수 없게 되는 경우에는 “회사”는 제9조(회원에 대한 통지)에서 정한 방법으로 “회원”에게 통지하고 당초 “회사”에 서 제시한 조건에 따라 “회원”에게 보상합니다.</li></ul></dd></dl></li><li><dl><dt>제13조 (서비스의 변경)</dt><dd><ul><li>1.“회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.</li><li>2.“회사”는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상 을 하지 않습니다.</li><li>3.“유료서비스”의 변경 내용이 중대하거나 “회원”에게 불리한 경우에는 “회사”가 해당 “유료서비스”를 제공받는 “회원”에게 제9조(회원에 대한 통지)에서 정한 방법으로 “회원”에게 통지합니 다. 이때, “회사”는 동의를 거절한 “회원”에 대해서는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 계약을 중단할 수 있으며 이 경우 환불은 제19조 2항에 따라 진행됩니다.</li></ul></dd></dl></li><li><dl><dt>제14조 (정보의 제공)</dt><dd><ul><li>1.“회사”는 “회원”이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 관련법에 따른 거래관련 정보, 고객센터 답변 등을 제외하고 언제든지 전자우편 등을 통하여 수신 거절을 할 수 있습니다.</li><li>2.제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 “회원”의 사전 동의를 받아서 전송합니다.</li></ul></dd></dl></li><li><dl><dt>제15조 (게시물의 저작권)</dt><dd><ul><li>1.“회원”이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.</li><li>2.“회원”이 “서비스” 내에 게시하는 “콘텐츠”는 검색결과 내지 “서비스” 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, “회원”은 언제든지 고객센터 또는 “서비스” 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다.</li><li>3.“회사”는 제2항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.</li></ul></dd></dl></li><li><dl><dt>제16조 (게시물의 관리)</dt><dd><ul><li>1.“회원”의 게시물이 “정보통신망법” 및 “저작권법”등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, “회사”와 “회원”은 관련법에 따라 조치를 취하여야 합니다.</li><li>2.“회사”는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.</li></ul></dd></dl></li><li><dl><dt>제17조 (권리의 귀속)</dt><dd><ul><li>1.“서비스”에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</li><li>2.“회사”는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, “회원”은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</li></ul></dd></dl></li><li><dl><dt>제18조 (“회원”의 계약해제, 해지 등)</dt><dd><ul><li>1.“회원”은 언제든지 자기 정보 관리 메뉴를 통하여 서비스 탈퇴 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li><li>2.“회원”이 계약을 해지할 경우, 관련법 및 개인정보보호정책에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.</li><li>3.“회원”이 계약을 해지하는 경우, 본인 계정에 등록된 모든 데이터 일체는 삭제됩니다.</li></ul></dd></dl></li><li><dl><dt>제19조 (환불)</dt><dd><ul><li>1.“회사”는 약정된 “유료서비스”의 하자를 회사가 보완, 수정할 수 없어 서비스가 이루어지지 않거나 정상적 이용이 불가능한 경우 회원이 결제한 전액을 환불합니다.</li><li>2.“회사”는 제13조 4항, 제18조 및 제20조에 따른 계약해지가 발생하거나, “회원”이 “유료서비스” 이용계약을 해지하는 경우, 잔여 금액을 환불합니다. 단, 정상적으로 사용되었거나 무상으로 지급한 이벤트성 포인트는 환불대상에서 제외됩니다.</li><li>3.“회사”는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 하며 “회사”가 과오금에 대한 환불을 거부할 경우 “회사” 는 정당하게 이용대금이 부과되었음을 입증할 책임을 집니다. 과오금의 환불절차는 “디지털콘텐츠이용자보호지침”에 따릅니다.</li><li>4.회사는 결제와 동일한 방법으로 환불을 진행하며, 결제와 동일한 방법으로 환불이 불가능한 때는 이를 사전에 고지합니다. 다만, 수납확인이 필요한 결제 수단의 경우에는 수납확인일로부터 3영업일 이내에 이를 환불하도록 합니다.</li><li>5.본 조에 따른 환불 진행 시, 환불 수수료(10%)는 “회원”의 귀책사유로 인한 경우에는 “회원”, “회사”의 귀책사유로 인한 경우에는 “회사”가 각각 부담합니다.</li></ul></dd></dl></li><li><dl><dt>제20조 (이용제한 등)</dt><dd><ul><li>1.“회사”는 “회원”이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 서비스 이용을 경고, 일시정지, 계약해지로 단계적으로 제한할 수 있습니다.</li><li>2.“회사”는 전항에도 불구하고, “주민등록법”을 위반한 명의도용 및 결제도용, “저작권법” 및 “컴퓨터프로그램보호법”을 위반한 불법프로그램의 제공 및 운영방해, “정보통신망법”을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약해지를 할 수 있습니다. 본 항에 따른 계약해지 시 서비스 이용을 통해 획득한 혜택 등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.</li><li>3.회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 등에서 정한 바에 의합니다.</li><li>4.본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 “회사”는 제9조[“회원”에 대한 통지]에 따라 통지합니다.</li><li>5.“회원”은 본 조에 따른 이용제한 등에 대해 “회사”가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</li></ul></dd></dl></li><li><dl><dt>제21조 (콘텐츠하자 등에 의한 회원 피해보상)</dt><dd>“회사”는 “유료서비스”의 하자 등에 의한 회원피해보상의 기준, 범위, 방법 및 절차에 관한 사항을 “디지털콘텐츠이용자보호지침”에 따라 처리합니다.</dd></dl></li><li><dl><dt>제22조 (책임의 한계)</dt><dd><ul><li>1. “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제됩니다.</li><li>2. “회사”는 “회원” 의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li><li>3. “회사”는 “회원”이 “서비스”와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li><li>4. “회사”는 “회원” 간 또는 “회원”과 제3자 상호간에 “서비스”를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</li><li>5. “회사”는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.</li></ul></dd></dl></li><li><dl><dt>제23조 (준거법 및 재판관할)</dt><dd><ul><li>1.“회사”와 “회원” 간 제기된 소송은 대한민국법을 준거법으로 합니다.</li><li>2.“회사”와 “회원”간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.</li></ul></dd></dl></li><li><dl><dt>부칙</dt><dd><ul><li>1.이 약관은 2013년 12월 16일 부터 적용됩니다.</li></ul></dd></dl></li></ul></div></div></div><!-- // section.joinStepWrap --></section><!-- // agreement -->");
$templateCache.put("components/faq/faq.html","<!-- faq --><section id=faq class=\"subPageWrap mtb100\"><!-- section#faq --><div class=\"sp_header mb30\"><div class=content><h2 class=title>자주묻는질문(FAQ)</h2></div></div><div class=sp_container><div class=content><table class=tb_board><colgroup><col width=*><col width=100px></colgroup><thead><tr><th>제목</th><th>등록일</th></tr></thead><tbody><tr ng-repeat=\"item in faq.boardlist\" ng-click=faq.showDetail(item.BbsPostId)><td>{{item.Title}}</td><td class=date>{{item.RegDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div></div><div class=\"sp_footer mt30\"><div class=content><div class=searchWrap><select name=\"\"><option value=\"\">제목</option></select><input type=text placeholder=\"검색어를 입력해주세요\"> <button><i class=\"glyphicon glyphicon-search\"></i></button></div></div></div><!-- // section#faq --></section><!-- // faq -->");
$templateCache.put("components/intro/intro.html","<div class=\"wrapper intro-page\"><div class=wrapper><div id=header><div class=content><h1 class=logo></h1><div class=btn_wrap><button class=login_btn ng-click=intro.goLogin()>로그인</button></div></div></div><div id=container><section id=visual><div class=content><div class=visual_img data-aos=fade-down></div><div class=visual_text data-aos=fade-down><p>Future Value<br>Ask KSA</p><h2><b>국민의 삶을 행복하게 만드는 표준</b></h2><button class=btn1 ng-click=intro.goInqueryScroll()>셀비스 CRM 사용 문의</button></div></div></section><section id=introduction><div class=content><h2 data-aos=fade-down><b>10년간</b>의 노하우, <span class=bg_span><b>고객관리시스템</b></span> 전문 기업</h2><p data-aos=fade-down>200개 이상의 기업들이 <b>1,000만명</b> 넘는 고객들을<br><span class=bg_span>셀비스 솔루션</span>을 통해 관리하고 있습니다.<br>약 10년간의 노하우로 사용하기 편하면서 강력한 기능을 가진 시스템을 제공합니다.</p><div class=intro_icon_wrap><ul><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon1.png alt=\"노하우 아이콘\"><p>10년간 고객관리시스템을<br>운영한 노하우</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon3.png alt=\"전화기 아이콘\"><p>API 연동을 통한<br>CTI 기능</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon4.png alt=\"알림톡 아이콘\"><p>알림톡 연동으로<br>비용절감 가능</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon5.png alt=\"펜차트 아이콘\"><p>종이 차트를 대체할<br>펜차트</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon6.png alt=\"상담내역 아이콘\"><p>한눈에 확인 가능한<br>상담내역</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon7.png alt=\"자동알림 아이콘\"><p>다양한 자동알림 기능</p></li><li data-aos=fade-down><img src=./assets/images/intro/intro_icon/icon8.png alt=\"조건검색 아이콘\"><p>다양한 조건검색으로<br>정확한 타깃 마케팅 가능</p></li></ul></div></div></section><section id=function><div class=content><h2 data-aos=fade-down>사용자의 <b>편의성</b>을 고려한<br>CRM 주요 기능</h2><!-- <img src=\"./assets/images/intro/func_img.png\" alt=\"\" data-aos=\"fade-down\"> --><ul class=func_list><li data-aos=fade-down><dl><dt><h3>상담 히스토리</h3></dt><dd><img src=./assets/images/intro/function/f_img3.png alt=\"상담 히스토리 이미지\"><ul class=func_desc><li>간편한 <b>상담등록</b> 기능</li><li><b>시간대별, 담당자별 상담내역</b>을 한눈에</li><li><b>실시간 캘린더 확인</b>으로 예약 겹침 방지</li><li>간편한 <b>고객등록 및 고객/상품 검색</b> 기능</li></ul></dd></dl></li><li data-aos=fade-down><dl><dt><h3>다양한 자동 알림 기능</h3></dt><dd><img src=./assets/images/intro/function/f_img5.png alt=\"자동 알림 이미지\"><ul class=func_desc><li><b>문자, 카카오, 이메일</b> 발송 기능</li><li><b>방문/시술에 대한 예약 등록/변경/취소</b> 자동 알림</li><li><b>회수권, 정액권 충전 및 잔여</b> 자동 알림</li><li>타사 대비 <b>저렴한 비용</b> <span class=txt_desc>A사 45원 | B사 50원 | <span class=color><b>케어 문자 40원, 알림톡 10원!</b></span></span></li></ul></dd></dl></li><li data-aos=fade-down><dl><dt><h3>펜차트</h3></dt><dd><img src=./assets/images/intro/function/f_img6.png alt=\"펜차트 이미지\"><ul class=func_desc><li>매번 찾는 <b>종이 차트의 번거로움</b> 해소</li><li>각종 <b>동의서 활용</b> 가능</li><li><b>강력한 보안</b>과 완벽한 개인정보 보호</li></ul></dd></dl></li></ul></div></section><section id=charge><div class=content><h2 data-aos=fade-down>요금 안내</h2><div class=row data-aos=fade-down><div class=box2><dl><dt><h4>부가서비스</h4></dt><dd><ul><li>SMS<span class=\"txt_desc gray\">(단문)</span> 15원</li><li>LMS<span class=\"txt_desc gray\">(장문)</span> 40원</li><li>MMS<span class=\"txt_desc gray\">(이미지)</span> 130원</li><li>카카오 알림톡 10원</li><li>이메일 0.4원</li></ul></dd></dl></div></div></div></section><section id=inquiry><div class=content><h2 data-aos=fade-down>서비스 문의</h2><div class=\"row inquire_form\" data-aos=fade-down><div><label for=input1>회사명<span class=essential>*</span></label><input type=text id=input1 autocomplete=off ng-model=intro.CompanyNm></div><div><label for=input2>담당자<span class=essential>*</span></label><input type=text id=input2 autocomplete=off ng-model=intro.Manager></div><div><label for=input3>연락처<span class=essential>*</span></label><input type=text id=input3 autocomplete=off auto-hyphen-tel ng-model=intro.Tel></div><div><label for=input4>이메일<span class=essential>*</span></label><input type=text id=input4 autocomplete=off ng-model=intro.Email></div><div class=full><label for=textarea1>문의 내용<span class=essential>*</span></label><textarea id=textarea1 cols=30 rows=10 ng-model=intro.Contents></textarea></div><div class=\"full btnWrap\"><button ng-click=intro.submit()>문의하기</button></div></div></div></section><section id=tel><div class=content><p>지금 바로 Salevis CRM과 함께하세요</p><h3><b>문의전화</b></h3><h2 class=color><b>070-5001-0869</b></h2></div></section></div><footer id=footer><div class=content><p>(주)소프트자이온</p><ul class=\"ul_h info\"><li>서울시 영등포구 선유로 130(양평동3가) 에이스하이테크시티 3차 504~505호</li><li>TEL. 02-6925-0503</li><li>FAX. 02-6925-0570</li><li>support@softzion.com</li></ul><p>COPYRIGHT(c) 2021 BY SOFTZION ALL RIGHTS RESERVED</p><ul class=\"ul_h policy\"><li><a ui-sref=login.agreement>이용약관</a></li><li><a ui-sref=login.policy>개인정보처리방침</a></li></ul></div></footer></div><script>AOS.init({\r\n        duration: 800\r\n    });\r\n\r\n    $(function(){\r\n      var rollHeader = 100;\r\n      $(window).scroll(function() {\r\n        var scroll = getCurrentScroll();\r\n        if ( scroll >= rollHeader ) {\r\n          $(\'#header\').addClass(\'roll\');\r\n        } else {\r\n          $(\'#header\').removeClass(\'roll\');\r\n        }\r\n      });\r\n    \r\n      function getCurrentScroll() {\r\n        return window.pageYOffset || document.documentElement.scrollTop;\r\n      }\r\n    });</script></div>");
$templateCache.put("components/notice/notice.html","<!-- notice --><section id=notice class=\"subPageWrap mtb100\"><!-- section#notice --><div class=\"sp_header mb30\"><div class=content><h2 class=title>공지사항</h2></div></div><div class=sp_container><div class=content><table class=tb_board><colgroup><col width=*><col width=100px></colgroup><thead><tr><th>제목</th><th>등록일</th></tr></thead><tbody><tr ng-repeat=\"item in notice.boardlist\" ng-click=notice.showDetail(item.BbsPostId)><td>{{item.Title}}</td><td class=date>{{item.RegDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div></div><div class=\"sp_footer mt30\"><div class=content><div class=searchWrap><select name=\"\"><option value=\"\">제목</option><option value=\"\">첨부파일명</option></select><input type=text placeholder=\"검색어를 입력해주세요\"> <button><i class=\"glyphicon glyphicon-search\"></i></button></div></div></div><!-- // section#notice --></section><!-- // notice -->");
$templateCache.put("components/login/forgotpass.html","<style>input.ng-invalid {\r\n    border: 1px solid #FFAAAA;\r\n  }</style><!-- <section id=\"header\" class=\"scheme-light\"> --><!--   <header class=\"clearfix\" ng-controller=\"ForgotpassCtrl as vc\"> --><!-- Right-side navigation --><!--    <ul class=\"nav-right pull-right list-inline\">\r\n        <li class=\"dropdown language\" uib-dropdown>\r\n    \r\n          <a href class=\"dropdown-toggle\" uib-dropdown-toggle>\r\n            <img ng-show=\"currentLanguage == \'ko\'\" src=\"images/flags/Korea,-South.png\" alt=\"\">\r\n            <img ng-show=\"currentLanguage == \'en\'\" src=\"images/flags/United-States-of-America.png\" alt=\"\">\r\n            <img ng-show=\"currentLanguage == \'il\'\" src=\"images/flags/Israel.png\" alt=\"\">\r\n            <img ng-show=\"currentLanguage != \'ko\' && currentLanguage != \'en\' && currentLanguage != \'il\'\" src=\"images/flags/Korea,-South.png\" alt=\"\">\r\n          </a>\r\n    \r\n          <ul class=\"dropdown-menu pull-right with-arrow animated littleFadeInDown\" role=\"menu\">\r\n            <li ng-class=\"{active: currentLanguage == \'ko\'}\">\r\n              <a href=\"javascript:;\" ng-click=\"changeLanguage(\'ko\')\">\r\n                <img src=\"images/flags/Korea,-South.png\" alt=\"\"> 한국어\r\n              </a>\r\n            </li>\r\n            <li ng-class=\"{active: currentLanguage == \'en\'}\">\r\n              <a href=\"javascript:;\" ng-click=\"changeLanguage(\'en\')\">\r\n                <img src=\"images/flags/United-States-of-America.png\" alt=\"\"> English\r\n              </a>\r\n            </li>\r\n            <li ng-class=\"{active: currentLanguage == \'il\'}\">\r\n              <a href=\"javascript:;\" ng-click=\"changeLanguage(\'il\')\">\r\n                <img src=\"images/flags/Israel.png\" alt=\"\"> ישראל\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n      </ul> --><!-- Right-side navigation end --><!--   </header>\r\n  </section>\r\n   --><!-- <div class=\"page page-login\" ng-controller=\"LoginCtrl as vc\" style=\"background-color:#f5f6f7 !important;\" data-ng-init=\"init()\"> --><div class=\"page page-core page-login\" style=\"background-color: #f5f6f7 !important; padding-top: 20px\"><p style=margin-top:50px></p><div class=\"container w-450 p-15 text-center\"><div class=\"row login_logo_pad\"><div class=\"col-xs-6 text-left\"><img src=assets/images/logo_moti03.jpg style=height:45px></div><div class=\"col-xs-6 text-right\"><img src=assets/images/logo_moti02.png style=height:45px></div></div><div class=\"text-center login_tit_pad\"><h3 class=\"text-black login_tit\">일자리지원 상담 시스템</h3></div><form name=form class=\"form-validation mt-15\"><div class=form-group><input type=text class=form-control placeholder=\"{{ \'Menu.USERNAME\' | translate }}\" ng-model=login.user.UserNm required style=\"height: 45px !important; color: #000\"></div><div class=form-group><input type=text class=form-control placeholder=휴대전화번호 ng-model=login.user.Mobile required style=\"height: 45px !important; color: #000\"></div><div class=form-group><label class=txt_req>사업정보</label><select class=form-control name=selectCombo ng-change=login.onTenentCodeSelected() ng-model=login.user.TCode ng-options=\"opt.TenantNm for opt in login.tenantList track by opt.TenantId\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div><button type=button class=\"btn btn-lg btn-blue btn-block b-0 br-2 mr-5 p-15\" ng-click=login.chkUserInfo() style=\"margin: 30px 0 10px 0\">{{ \'Menu.ID/PW\' | translate }}</button><p class=\"help-block text-left text-slategray mt-20\">※ 입력한 휴대전화 번호로 아이디 및 임시비밀번호가 발송됩니다.</p></form><div class=\"lt wrap-reset mt-10 text-left\"><p class=m-0><button ui-sref=login class=\"btn btn-default btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4c mb-10\"><i class=\"fa fa-arrow-left\"></i> {{ \'Menu.BACK\' | translate }}</button></p></div><div><p style=\"color: rgba(97, 111, 119, 0.57) !important; margin-top: 35px; border-top: 1px solid #ccc; padding-top: 15px\">Copyright © Military Outplacement Training Institute. All Right Reserved.</p></div></div></div>");
$templateCache.put("components/login/login-footer.html","<!-- footer--><div class=\"login_wrap_footer text-center\"><address>Copyright &copy; Military Outplacement Training Institute. All Right Reserved.</address></div>");
$templateCache.put("components/login/login-header.html","<!-- header--><div class=\"login_header mb-10\"><img src=assets/images/logo_moti01.png width=250 height=52><!--<h1 class=\"logo\"><img src=\"../../assets/images/salevis_logo.png\" style=\"cursor:pointer;\" onclick=\"javascript:location.href=\'#/login\';\"></h1>--> <img src=assets/images/logo_moti02.png width=220 height=52 style=\"display: block; float: right\"></div><!-- // header-->");
$templateCache.put("components/login/login.html","<link rel=stylesheet href=assets/css/login.css><style>#anounceModal {\r\n    display: none;\r\n    position: fixed;\r\n    z-index: 1000;\r\n  }\r\n  body {\r\n    background-color: #fff !important;\r\n  }</style><div class=login_wrap><!-- IE 9이하 접속시 안내 --><!-- <aside id=\"browser_pop\">\r\n    <section class=\"inwrap\">\r\n      <h2>브라우저 이용 안내</h2>\r\n      <p>\r\n        본 웹사이트에 최적화된 브라우저는\r\n        <b>Internet Explorer 10 이상 / Google Chrome</b>입니다.\r\n      </p>\r\n      <p>\r\n        편리한 사이트 이용을 위하여 최신 브라우저로 업그레이드를 권장합니다.\r\n      </p>\r\n      <div>\r\n        <a\r\n          href=\"https://support.microsoft.com/ko-kr/help/17621/internet-explorer-downloads\"\r\n          target=\"_blank\"\r\n          ><i\r\n            ><img\r\n              src=\"//img.chippo.co.kr/images/chippocorp/ie_logo.png\"\r\n              alt=\"\" /></i\r\n          >Internet Explorer</a\r\n        >\r\n        <a href=\"https://www.google.co.kr/chrome/index.html\" target=\"_blank\"\r\n          ><i\r\n            ><img\r\n              src=\"//img.chippo.co.kr/images/chippocorp/chrome_logo.png\"\r\n              alt=\"\" /></i\r\n          >Google Chrome</a\r\n        >\r\n      </div>\r\n      <span class=\"close\">X</span>\r\n    </section>\r\n  </aside> --><!-- //IE 9이하 접속시 안내 --><!-- popup --><!-- <div id=\"anounceModal\" style=\"background-color: #f8f8f7\">\r\n    <div style=\"width: 700px; height: 598px; background-color: #f8f8f7\">\r\n      <div>\r\n        <img src=\"assets/images/popup.png\" alt=\"\" />\r\n      </div>\r\n      <div\r\n        style=\"font-size: 12px; text-align: right; background-color: #f8f8f7\"\r\n      >\r\n        <input\r\n          id=\"chkNoMore\"\r\n          type=\"checkbox\"\r\n          style=\"position: relative; top: 0px\"\r\n        /><img src=\"assets/images/popup_1007_03.gif\" alt=\"\" /><input\r\n          type=\"button\"\r\n          style=\"position: relative; top: 0px\"\r\n          ng-click=\"login.popupEliminate()\"\r\n          value=\" 창 닫기 \"\r\n        />&nbsp;&nbsp;&nbsp;\r\n      </div>\r\n    </div>\r\n  </div> --><!-- //popup --><!-- <div id=\"container_\"> --><!-- container --><div style=\"height: 100%\"><form name=form class=\"form-validation login-form\" ui-keypress=\"{13:\'login.doLogin()\'}\"><div class=login-container><div class=login_box><login-header></login-header><div class=login_box_container><p class=login_band></p><div class=\"form-group text-center login_title\"><p class=login_title_txt>국방전직교육원 일자리지원 상담 시스템</p><!-- <img src=\"assets/images/login_tit.png\" /> --></div><div class=login_form_container><div class=form-group><i class=\"fa fa-user fa-2x login-input-icon\"></i> <input type=text class=\"form-control login_input input_id\" placeholder=아이디 ng-model=login.user.loginId required style=\"height: 40px !important\"></div><div class=form-group><i class=\"fa fa-lock fa-2x login-input-icon\" style=\"padding-right: 12px\"></i> <input type=password class=\"form-control login_input input_pw\" placeholder=비밀번호 ng-model=login.user.loginPw required style=\"height: 40px !important\"></div><div class=\"form-group mt-20\"><button type=button class=login_btn ng-click=login.doLogin()>로그인</button><!-- <img\r\n                  src=\"assets/images/login_btn.png\"\r\n                  ng-click=\"login.doLogin()\"\r\n                /> --><!--  <label\r\n                  class=\"checkbox checkbox-custom checkbox-custom-sm inline-block\"\r\n                >\r\n                  <input\r\n                    type=\"checkbox\"\r\n                    class=\"styled\"\r\n                    ng-model=\"login.user.saveId\"\r\n                    ng-true-value=\"1\"\r\n                    ng-false-value=\"\"\r\n                  /><i></i> {{ \'Menu.SAVEID\' | translate }}\r\n                </label> --></div><div class=form-group><a ui-sref=forgotpass class=pull-right style=\"letter-spacing: -1px\">[아이디/비밀번호 찾기]</a></div></div></div></div></div></form></div></div><login-footer></login-footer><!-- // container --><!-- </div> -->");
$templateCache.put("components/login/salemeet-signup-step-one.html","<style>.teacher_schedule li {\r\n    width: 50%;\r\n    float: left;\r\n    padding: 0 0 10px;\r\n  }</style><form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\"><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li class=current><a>회원사 선택</a></li><li><a>기본정보 입력</a></li><li><a>회원가입 완료</a></li></ul></div><table class=\"table mg_auto table_1\"><!--tr>\r\n                  <th scope=\"row\" class=\"required\" style=\"height: 100px;\">회원사명 <br /></th>\r\n                  <td style=\"text-align: left; height: 100px;\">\r\n                    <div class=\"form-group\">\r\n                      <div class=\"input-group custom-search-form\">\r\n                        <input type=\"text\" readonly=\"readonly\" class=\"form-control\" ng-model=\"vc.tenantId\" ng-click=\"vc.srchTenantModal();\">\r\n                        <input type=\"hidden\" ng-model=\"vc.tenantId\">\r\n                        <span class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.srchTenantModal();\">\r\n                            <i class=\"fa fa-search\"></i>\r\n                          </button>\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.eraseTenant();\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                          </button>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr--><tr><th scope=row class=required style=\"height: 100px\">회원사코드<br></th><td style=\"text-align: left; height: 100px\"><div class=form-group><input type=text class=form-control ng-model=vc.tenantId></div></td></tr></table><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" type=submit ng-click=vc.salemeetSignupStepTwo()>다음단계</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.salemeetGoCancel()>취소</button></div></div></div></div></div></div></form><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            Signup\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"signup.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"signup.onChangeHandler()\" name=\"selectCombo\" ng-model=\"signup.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"signup.doSignup()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNUP\"></p>\r\n            <div class=\"signup_area\">\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"signup.loginInfo.LoginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.NAME\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.NAME\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"Name\" ng-model=\"signup.loginInfo.UserNm\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\" ng-model=\"signup.loginInfo.Password\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD2\" ng-model=\"signup.loginInfo.Password2\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'Menu.COMPANYCODE\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'Menu.COMPANYCODE\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"TenantId\" ng-model=\"signup.loginInfo.TenantId\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"rows btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'Menu.SIGNUP\' | translate }}</button>\r\n            <div class=\"pull-right\"><a ui-sref=\"login\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</a></div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/salemeet-signup-step-two.html","<form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\" ng-if=vc.joinVisible><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li id=tab1><a>회원사 선택</a></li><li id=tab2 class=current><a>기본정보 입력</a></li><li id=tab3><a>회원가입 완료</a></li></ul></div><div id=tab_contents ng-show=!vc.result><table class=\"table mg_auto table_1\"><tr><th scope=row class=required>회원사명 <span style=color:#f69679>*</span></th><td style=\"text-align: left\"><span ng-bind=vc.tenantNm></span></td></tr><tr><th scope=row class=required>아이디 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=userId name=id class=\"w245 signupText\" title=아이디 placeholder=\"아이디를 입력해 주세요\" ng-model=vc.UserId required maxlength=25> <button type=button ng-click=vc.chkDupLoginId() class=\"signupBtn commonBtn2 type3\" ng-disabled=\"vc.UserId == null || vc.UserId.length < 5\">중복확인</button><p class=txt2>아이디는 5~25자의 영문 소문자, 숫자, 특수문자(_), (-)만 사용해야 합니다.</p></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span></th><td style=\"text-align: left\"><input type=text class=signupText id=name name=memberName title=성명 maxlength=50 placeholder=\"이름을 입력해 주세요.\" ng-model=vc.data.UserNm required style=width:200px></td></tr><tr><th scope=row class=required>비밀번호<span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=password name=password title=비밀번호 placeholder=\"비밀번호를 입력해 주세요.\" ng-model=vc.data.Password required maxlength=16></td></tr><tr><th scope=row class=required>비밀번호 확인 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=userPwdCheck name=userPwdCheck title=\"비밀번호 확인\" placeholder=\"비밀번호를 다시 입력해 주세요.\" ng-model=vc.data.Password2 required maxlength=16><ul><li>* 비밀번호는 8~16자의 영문 대, 소문자, 숫자, 특수문자 중 3개를 조합하여 사용합니다.</li><li>* 사용 가능 특수문자: ` . ~ ! @ # $ % ^ * ( ) - _ = +</li></ul></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=email1 class=\"signupText w200\" title=이메일 maxlength=20 placeholder=\"이메일을 입력해 주세요.\" ng-model=vc.data.Email1 required> <span class=blank>@</span> <input type=text id=email2 class=\"signupText w160\" title=이메일 maxlength=25 ng-model=vc.data.Email2 required><select id=userEmail2Select class=\"w108 signupText\" title=이메일 ng-change=vc.setEmail() ng-model=vc.data.Email3><option value=\"\">직접입력</option><option value=naver.com>naver.com</option><option value=gmail.com>gmail.com</option><option value=hanmail.net>hanmail.net</option><option value=daum.net>daum.net</option><option value=nate.com>nate.com</option><option value=hotmail.com>hotmail.com</option></select></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><select id=userTelM1 name=userTelM1 title=휴대번호 class=\"signupText num_check first_select w108\" ng-model=vc.data.Mobile1><option value=010>010</option><option value=011>011</option><option value=016>016</option><option value=017>017</option><option value=018>018</option><option value=019>019</option></select><span class=blank>-</span> <input type=text id=userTelM2 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile2 maxlength=4> <span class=blank>-</span> <input type=text id=userTelM3 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile3 maxlength=4></td></tr></table><ul class=agree_area><li><p><!-- 회사의 <a href=\"/#/reserve/policy\" style=\"color: blue;\" target=\"_blank\">이용약관</a>과 <a href=\"/#/reserve/private\" style=\"color: blue;\" target=\"_blank\">개인정보보호정책</a>에 동의합니다. --> 회사의 <a style=\"cursor: pointer; color: blue\">이용약관</a>과 <a style=\"cursor: pointer; color: blue\">개인정보보호정책</a>에 동의합니다.</p><div><input type=radio id=termsY name=termsYn class=radioBtn value=Y title=약관동의><label for=termsY class=radioYbtn>동의함</label><input type=radio id=termsN name=termsYn class=radioBtn value=N title=약관동의 checked><label for=termsN class=radioNbtn>동의안함</label></div></li></ul><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" ng-click=vc.setData()>회원가입</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.salemeetGoCancel()>취소</button></div></div><div id=tab_success ng-show=vc.result><h1>회원가입을 축하드립니다.</h1><button type=button class=\"signupBtn commonBtn5 type3\" style=\"margin-top: 30px\" ng-click=vc.salemeetGoCancel()>로그인</button></div></div></div></div></div></div></form>");
$templateCache.put("components/login/salemeet.html","<div class=n-login-wrap><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>SALEMEETSALEMEETSALEMEETSALEMEETSALEMEET</p></div><div class=n-login-body><form class=login_box id=login_box ng-submit=login.doLogin()><div class=\"title mb-30\"><img src=/assets/images/login/salemeetLogo.png alt=\"\"></div><div class=idpw-box-input><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=login.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-20><ul class=n-login-ui-find><li><a ui-sref=salemeetsignup>{{ \'Menu.SIGNUP\' | translate }}</a></li><li><span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div><script>window.document.title = \'SALEMEET\';</script><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            <img src=\"assets/images/login/login_tit.png\" alt=\"Log In\">\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"login.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"login.onChangeHandler()\" name=\"selectCombo\" ng-model=\"login.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"login.doLogin()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNIN\"></p>\r\n            <div class=\"logs_area\">\r\n              <div class=\"radio-group\">\r\n                <input type=\"radio\" id=\"one\" name=\"selector\" checked=\"checked\">\r\n                <label for=\"one\" translate=\"LOGIN.LABEL.NAME\"></label>\r\n                <input type=\"radio\" id=\"two\" name=\"selector\">\r\n                <label for=\"two\" translate=\"LOGIN.LABEL.SNUMB\"></label>\r\n              </div>\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"login.loginInfo.loginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_pw\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\"\r\n                    ng-model=\"login.loginInfo.loginPw\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</button>\r\n            <div><span><a ui-sref=\"signup\">{{ \'Menu.SIGNUP\' | translate }}</a></span> | <span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span> | <span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span> </div>\r\n            <div class=\"checks\">\r\n              <input type=\"checkbox\" id=\"c1\" checked=\"checked\">\r\n              <label for=\"c1\"><span></span>Remember me.</label>\r\n            </div>\r\n            <div class=\"pwd-id\">\r\n\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/signup-first-step.html","<link rel=stylesheet href=assets/css/login.css><div class=wrapper><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb50\"><!-- section.joinStepWrap--><div class=content><h2>회원 가입</h2><span class=now>01. 약관 동의</span></div><!-- // section.joinStepWrap--></section><section class=inputInfoWrap><!-- section.joinStep --><div class=content><div class=joinItem><h3>회원 약관</h3><div class=agreeContent><textarea readonly>\r\n제1조 (목적)\r\n이 약관은 ㈜소프트자이온 (이하 “회사”)가 제공하는 Salevis Care(care.salevis.co.kr) 서비스 및 관련 제반 서비스(이하 “서비스”)의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한\r\n    사항을 규정함을 목적으로 합니다.\r\n\r\n제2조 (용어의 정의)\r\n이 약관에서 사용하는 용어는 아래와 같습니다.\r\n    1. “사용자(회원)”이라 함은 회사의 “서비스”에 접속하여 이 약관에 따라 “회사”와 이용계약을 체결하고 “회사”가 제공하는 “서비스”를 이용하는 고객을 말합니다.\r\n    2. “아이디(ID)”라 함은 “회원”의 식별과 서비스 이용을 위하여 “회원”이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 의미합니다.\r\n    3. “비밀번호”라 함은 “회원”이 부여 받은 “아이디와 일치되는 “회원”임을 확인하고 비밀보호를 위해 “회원” 자신이 정한 문자 또는 숫자의 조합을 의미합니다.\r\n    4. “고객” : 사용자(회원)가 관리의 대상으로 삼아 등록한 회원의 서비스 대상을 의미합니다.\r\n    5. “유료서비스”라 함은 “서비스” 중 “회사”가 유료로 제공하는 제반 서비스를 의미합니다.\r\n    6. “유효기간”이라 함은 회사의 회원으로 이용료를 납부하고 약정한 기간을 정하여 회원의 권리를 취득한 기간을 말합니다.\r\n    7. “게시물” 혹은 “콘텐츠”이라 함은 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호ᆞ문자ᆞ음성ᆞ음향ᆞ화상ᆞ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을\r\n    의미합니다.\r\n\r\n제3조 (약관의 게시와 개정)\r\n    1. 본 약관은 회사의 서비스 홈페이지(salevis.kr)에 게시함으로 효력이 발생합니다.\r\n    2. “회사”는 “약관의규제에관한법률”, “정보통신망이용촉진및정보보호에관한법률(이하 “정보통신망법”)” 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.\r\n    \r\n제4조 (약관의 해석)\r\n    1. 회사는 개별 서비스에 대해서는 별도의 이용약관 및 정책(“기타 약관 등”이라 함)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 “기타 약관 등”이 우선하여 적용됩니다.\r\n    2. 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 “기타 약관 등” 및 관계법령 또는 상관례에 따릅니다.\r\n\r\n제5조 [이용계약 체결]\r\n    1. 이용계약은 “회원”이 되고자 하는 자(이하 “가입신청자”)가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 “회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다.\r\n    2. “회사”는 “가입신청자”의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, “회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할\r\n    수 있습니다.\r\n        -가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우\r\n        -실명이 아니거나 타인의 명의를 이용한 경우\r\n        -허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우\r\n        -14세 미만 아동이 정보통신망 이용촉진 및 정보보호등에 관한 법률에서 정한 “개인정보” 입력 시 법정대리인(부모 등)의 동의를 얻지 아니한 경우\r\n        -이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우\r\n        -기타 회사가 정한 이용신청요건이 미비되었을 경우\r\n    3. “회원”이 유료서비스를 이용하는 경우 이용대금을 납부한 후 서비스를 이용하는 것을 원칙으로 하며, 유료서비스 이용계약의 성립시기는 “구매완료”를 신청절차 상에서 표시한 시점으로\r\n    합니다.\r\n    4. “회사”는 만 20세 미만의 미성년회원이 유료서비스를 이용하고자 하는 경우에 부모 등 법정대리인의 동의를 얻거나, 계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그\r\n    계약을 취소할 수 있다는 내용을 계약체결 전에 고지하는 조치를 취합니다.\r\n    5. “회사”는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.\r\n    6. 제2항과 제3항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, “회사”는 원칙적으로 이를 가입신청자에게 알리도록 합니다.\r\n    7. 이용계약의 성립 시기는 “회사”가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.\r\n    8. “회사”는 “회원”에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.\r\n    \r\n제6조 (회원정보의 변경)\r\n    1. “회원”은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 아이디 등은 수정이 불가능합니다.\r\n    2. “회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 “회사”에 대하여 그 변경사항을 알려야 합니다.\r\n    3. 제2항의 변경사항을 “회사”에 알리지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.\r\n\r\n제7조 (개인정보보호 의무)\r\n본 서비스를 이용하기 위해 회원이 회사에 제공(단, 회원이 회사에 제공하는 고객정보는 회사가 요구하는 정보를 포함하여야 하며 File, 회원의 직접입력, Fax 등의 형태로 제공될 수 있음)하는 회원의\r\n고객정보에 대한 모든 권한과 관리책임은 회원에게 있습니다. 회원은 신용정보법, 개인 정보보호지침 기타 관련 법규에 따라 적법하고 공정한 수단에 의하여 고객의 정보를 수집ㆍ이용하여야 하므로, 회사는 회원이\r\n회사에 제공한 고 객정보에 대해 적법한 절차를 거친 것으로 처리합니다. 따라서 회사는 회원의 동의를 얻고 회원은 고객의 동의를 얻어 회원의 고객을 위해 회사가 제공하는 서비스에 대해 회원 고객이 문제를 제기할\r\n경우, 발생하는 모든 문제는 회원의 책임으로 해결해야 합니다.  회원의 고객정보는 회사가 임의로 이용하거나 누출해서는 안되며 회원이 서비스를 해지할 경우에 회사는 해당 회원의 고객정보를 회원의 요구사항\r\n에 따라 처리해야 합니다. 단, 다음 각 호의 경우는 회원의 별도 동의없이 제3자에게 회원의 개인정보를 제공할 수 있습니다.\r\n\r\n    1. 수사상 목적에 따른 수사기관의 서면 요구가 있는 경우에 수사협조의 목적으로 국가 수사 기관에 성명, 주소등 신상정보를 제공하는 경우\r\n    2. 신용정보의 이용 및 보호에 관한 법률, 전기통신관련법률 등 법률에 특별한 규정이 있는 경우\r\n    3. 회사가 회원에게 제공하는 서비스질을 향상시킬 목적, 학술적인 연구 등을 위하여 제공하는 경우\r\n    4. 이용요금 연체로 인한 신용정보조회, 채권추심 의뢰시\r\n    \r\n제8조 (“회원”의 “아이디” 및 “비밀번호”의 관리에 대한 의무)\r\n“회원”은 본 서비스에서 사용하는 비밀번호와 관련된 모든 행동을 보호/관리해야 합니다. “회사”는 귀하의 계정에 비밀번호를 강력한 암호(대문자, 소문자 및 숫자, 기호의 조합)로 설정할 것을 권장합니다.\r\n“회사”는 위 사항을 만족하지 못했을 때 일어난 어떠한 손실이나 피해에 대해 책임지지 않습니다. “회사”는 “서비스”를 안전하게 유지하기 위해 최선을 다하고 있지만 안전을 보장할 수는 없습니다.\r\n\r\n제9조 (“회원”에 대한 통지)\r\n    1. “회사”가 “회원”에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한 “회원”이 지정한 전자우편주소, 서비스 내 전자메모 및 쪽지 등으로 할 수 있습니다.\r\n    2. “회사”는 “회원” 전체에 대한 통지의 경우 7일 이상 “회사”의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.\r\n    \r\n\r\n\r\n제10조 (“회사”의 의무)\r\n    1. “회사”는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 “서비스”를 제공하기 위하여 최선을 다하여 노력합니다.\r\n    2. “회사”는 “회원”이 안전하게 “서비스”를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보보호정책을 공시하고 준수합니다.\r\n    3. “회사”는 서비스이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다.\r\n    4. “회사”는 다음의 사항을 해당 ” 유료서비스”의 이용초기화면이나 그 포장, FAQ 등에 “회원”이 알기 쉽게 표시합니다.\r\n    유료서비스의 명칭 또는 제호\r\n    유료서비스의 내용, 이용방법, 이용료, 결제방법 기타 이용조건\r\n    이용가능 기기 및 이용에 필요한 최소한의 기술사양\r\n\r\n제11조 (서비스 이용의 중지 또는 계약의 해지)\r\n    1. “회원”은 다음 행위를 하여서는 안 됩니다.\r\n    신청 또는 변경 시 허위내용의 등록 타인의 정보도용 “회사”에 게시된 정보의 변경 “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시\r\n    “회사”와 기타 제3자의 저작권 등 지적재산권에 대한 침해 “회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위 외설 또는 폭력적인 메시지, 화상, 음성, 기타\r\n    공서양속에 반하는 정보를 “회사”에 공개 또는 게시하는 행위 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위 기타 불법적이거나 부당한 행위\r\n    2. “회원”은 관계법, 본 약관의 규정, 이용안내 및 “서비스”와 관련하여 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하며, 기타 “회사”의 업무에 방해되는 행위를\r\n    하여서는 안 됩니다.\r\n    \r\n제12조 (서비스의 제공 등)\r\n    1. 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.\r\n    2. “회사”는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 “회사”는\r\n    제9조(“회원”에 대한 통지)에 정한 방법으로 “회원”에게 통지합니다. 다만, “회사”가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.\r\n    3. “회사”는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공시한 바에 따릅니다.\r\n    4. 사업종목의 전환, 사업의 포기 등의 이유로 “유료서비스”를 제공할 수 없게 되는 경우에는 “회사”는 제9조(회원에 대한 통지)에서 정한 방법으로 “회원”에게 통지하고 당초 “회사”에\r\n    서 제시한 조건에 따라 “회원”에게 보상합니다.\r\n\r\n제13조 (서비스의 변경)\r\n    1. “회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이\r\n    있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.\r\n    2. “회사”는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상\r\n    을 하지 않습니다.\r\n    3. “유료서비스”의 변경 내용이 중대하거나 “회원”에게 불리한 경우에는 “회사”가 해당 “유료서비스”를 제공받는 “회원”에게 제9조(회원에 대한 통지)에서 정한 방법으로 “회원”에게\r\n    통지합니다. 이때, “회사”는 동의를 거절한 “회원”에 대해서는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 계약을 중단할 수 있으며\r\n    이 경우 환불은 제19조 2항에 따라 진행됩니다.\r\n    \r\n제14조 (정보의 제공)\r\n    1. “회사”는 “회원”이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 관련법에 따른 거래관련\r\n    정보, 고객센터 답변 등을 제외하고 언제든지 전자우편 등을 통하여 수신 거절을 할 수 있습니다.\r\n    2. 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 “회원”의 사전 동의를 받아서 전송합니다.\r\n    \r\n제15조 (게시물의 저작권)\r\n    1. “회원”이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.\r\n    2. “회원”이 “서비스” 내에 게시하는 “콘텐츠”는 검색결과 내지 “서비스” 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어\r\n    게시될 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, “회원”은 언제든지 고객센터 또는 “서비스” 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수\r\n    있습니다.\r\n    3. “회사”는 제2항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.\r\n    \r\n제16조 (게시물의 관리)\r\n    1. “회원”의 게시물이 “정보통신망법” 및 “저작권법”등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수\r\n    있으며, “회사”와 “회원”은 관련법에 따라 조치를 취하여야 합니다.\r\n    2. “회사”는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치\r\n    등을 취할 수 있습니다.\r\n    \r\n제17조 (권리의 귀속)\r\n    1. “서비스”에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.\r\n    2. “회사”는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, “회원”은 이를 양도, 판매, 담보제공 등의\r\n    처분행위를 할 수 없습니다.\r\n    \r\n\r\n\r\n제18조 (“회원”의 계약해제, 해지 등)\r\n    1. “회원”은 언제든지 자기 정보 관리 메뉴를 통하여 서비스 탈퇴 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.\r\n    2. “회원”이 계약을 해지할 경우, 관련법 및 개인정보보호정책에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.\r\n    3. “회원”이 계약을 해지하는 경우, 본인 계정에 등록된 모든 데이터 일체는 삭제됩니다.\r\n    \r\n제19조 (환불)\r\n    1. “회사”는 약정된 “유료서비스”의 하자를 회사가 보완, 수정할 수 없어 서비스가 이루어지지 않거나 정상적 이용이 불가능한 경우 회원이 결제한 전액을 환불합니다.\r\n    2. “회사”는 제13조 4항, 제18조 및 제20조에 따른 계약해지가 발생하거나, “회원”이 “유료서비스” 이용계약을 해지하는 경우, 잔여 금액을 환불합니다. 단, 정상적으로 사용되었거나\r\n    무상으로 지급한 이벤트성 포인트는 환불대상에서 제외됩니다.\r\n    3. “회사”는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 하며 “회사”가 과오금에 대한 환불을 거부할 경우 “회사” 는 정당하게 이용대금이\r\n    부과되었음을 입증할 책임을 집니다. 과오금의 환불절차는 “디지털콘텐츠이용자보호지침”에 따릅니다.\r\n    4. 회사는 결제와 동일한 방법으로 환불을 진행하며, 결제와 동일한 방법으로 환불이 불가능한 때는 이를 사전에 고지합니다. 다만, 수납확인이 필요한 결제 수단의 경우에는 수납확인일로부터\r\n    3영업일 이내에 이를 환불하도록 합니다.\r\n    5. 본 조에 따른 환불 진행 시, 환불 수수료(10%)는 “회원”의 귀책사유로 인한 경우에는 “회원”, “회사”의 귀책사유로 인한 경우에는 “회사”가 각각 부담합니다.\r\n    \r\n제20조 (이용제한 등)\r\n    1. “회사”는 “회원”이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 서비스 이용을 경고, 일시정지, 계약해지로 단계적으로 제한할 수 있습니다.\r\n    2. “회사”는 전항에도 불구하고, “주민등록법”을 위반한 명의도용 및 결제도용, “저작권법” 및 “컴퓨터프로그램보호법”을 위반한 불법프로그램의 제공 및 운영방해, “정보통신망법”을 위반한\r\n    불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약해지를 할 수 있습니다. 본 항에 따른 계약해지 시 서비스 이용을 통해 획득한 혜택 등도 모두\r\n    소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.\r\n    3. 회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 등에서 정한 바에 의합니다.\r\n    4. 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 “회사”는 제9조[“회원”에 대한 통지]에 따라 통지합니다.\r\n    5. “회원”은 본 조에 따른 이용제한 등에 대해 “회사”가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을\r\n    재개합니다.\r\n\r\n제21조 (콘텐츠하자 등에 의한 회원 피해보상)\r\n“회사”는 “유료서비스”의 하자 등에 의한 회원피해보상의 기준, 범위, 방법 및 절차에 관한 사항을 “디지털콘텐츠이용자보호지침”에 따라 처리합니다.\r\n\r\n제22조 (책임의 한계)\r\n    1. “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제됩니다.\r\n    2. “회사”는 “회원” 의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.\r\n    3. “회사”는 “회원”이 “서비스”와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.\r\n    4. “회사”는 “회원” 간 또는 “회원”과 제3자 상호간에 “서비스”를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.\r\n    5. “회사”는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.\r\n\r\n제23조 (준거법 및 재판관할)\r\n    1. “회사”와 “회원” 간 제기된 소송은 대한민국법을 준거법으로 합니다.\r\n    2. “회사”와 “회원”간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.\r\n    \r\n부칙\r\n    1. 이 약관은 2013년 12월 16일 부터 적용됩니다.\r\n    \r\n                \r\n              </textarea></div></div><div class=joinItem><h3>개인정보 수집 및 이용에 대한 안내</h3><div class=agreeContent><textarea readonly>\r\nSalevis Care(care.salevis.co.kr)를 운영하고 있는 ‘㈜소프트자이온’은 (이하 ‘회사’는)고객님의 개인정보를 중요시하며, [정보통신망 이용촉진 및 개인정보보호]에 관한 법률을 준수하고 있습니다.회사는 개인정보취급방침을 통하여 고객님께서 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.\r\n\r\n1. 수집하는 개인정보의 항목\r\n회사는 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.\r\n이름, 전화번호, 휴대폰, 전자메일, 회사정보(회사명, 사업자등록번호, 주소), 대표정보(이름)\r\n개인정보 수집방법 :홈페이지 (회원가입), 서면양식\r\n\r\n2. 개인정보 수집 및 이용목적\r\n회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.\r\n\r\n전자메일 : 본인확인 및 개인식별에 이용\r\n이름 : 고지사항 전달, 불만처리, 고객문의 답변 등 회원관리에 이용\r\n전화번호/휴대폰 : 고지사항 전달, 불만처리, 고객문의 답변 등 회원관리에 이용\r\n직함/부서/회사명 : 상품상담 및 고객문의 답변 등 회원관리에 이용\r\n주소 : 이벤트 상품 발송 등에 이용\r\n3. 개인정보의 보유 및 이용기간\r\n회사는 원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.\r\n\r\n4. 개인정보 파기절차 및 방법\r\n회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.\r\n\r\n파기절차 : 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져 (종이의 경우 별도의 서류함) 내부 방침 및 기타관련 법령에 의한 정보보호 사유에 따라 (보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 되어지는 이외의 다른 목적으로 이용되지 않습니다.\r\n파기방법 : 전사적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.\r\n\r\n5. 개인정보\r\n회사는 회원의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.\r\n이용자들이 사전에 동의한 경우 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우\r\n\r\n6. 수집한 개인정보의 위탁\r\n회사는 회원의 동의 없이 회원의 개인정보를 외부 업체에 위탁하지 않습니다. 향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 회원에게 통지하고 필요한 경우 사전 동의를 받겠습니다.\r\n\r\n7. 개인정보 관한 민원 서비스\r\n회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리담당자 및 개인정보관리책임자를 지정하고 있습니다.\r\n\r\n\r\n[개인정보관리담당자]\r\n성명 : 권기철\r\n소속 : 기술사업팀 CRM파트\r\n전화번호 : 070-5001-0869\r\n이메일 : kckwon@softzion.com\r\n\r\n[개인정보관리 책임자]\r\n성명 : 조영래\r\n소속 : 기술사업팀 / 부장\r\n전화번호 : 070-5001-6432\r\n이메일 : yrcho@softzion.com\r\n\r\n[부칙]\r\n(공고일) 2014년 09년03일\r\n(시행일) 2013년 12월16일\r\n\r\n귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리 담당자 혹은 책임 자에게 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.\r\n\r\n개인분쟁조정위원회(www.1336.or.kr/1336)\r\n정보보호마크인증위원회(www.eprivacy.or.kr/02-580-0533~4)\r\n대검찰청 인터넷범죄수사센터(icic.sppo.go.kr/02-3480-3600)\r\n경찰청 사이버테러대응센터(www.ctrc.go.kr/02-392-0330)\r\n                </textarea></div><div class=agreeWrap><p><label class=ng-binding><input ng-false-value=\"\'N\'\" ng-model=vc.data.agreeYN ng-true-value=\"\'Y\'\" type=checkbox> 위 약관에 동의합니다.</label></p></div><div class=\"buttonWrap mtb30\"><button class=cancel_btn ng-click=\"vc.signUp(\'C\')\">취소</button> <button class=primary_btn ng-click=\"vc.signUp(\'N\')\"><strong>다음단계</strong></button></div></div></div><!-- // section.joinStepWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/signup-second-step.html","<link rel=stylesheet href=assets/css/login.css><div class=wrapper><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb50\"><!-- section.joinStepWrap --><div class=content><h2>회원 가입</h2><span class=now>02. 정보 입력</span></div><!-- // section.joinStepWrap--></section><section class=inputInfoWrap><!-- section.inputInfoWrap --><div class=content><!-- 로그인 정보 --><div class=joinItem><h3>로그인 정보</h3><div class=itemContent><div><label>아이디</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.LoginId maxlength=20 placeholder=\"4~20자의 영문,숫자,특수문자 만 입력\" ng-blur=vc.chkLoginIdDup()><p class=\"desc not_pass\" id=loginid style=\"display: none\"><i class=\"glyphicon glyphicon-remove\"></i><span id=loginidTx>사용할 수 없는 아이디입니다.</span></p></div><div><label>비밀번호</label><span class=e>*</span> <input type=password class=txt_input ng-model=vc.data.Password maxlength=20 placeholder=\"영문, 숫자, 특수문자 포함 8~20자 입력\"></div><div><label>비밀번호 확인</label><span class=e>*</span> <input type=password class=txt_input ng-model=vc.data.Password2 maxlength=20 placeholder=\"비밀번호 확인\"><p class=\"desc not_pass\" ng-if=\"vc.data.Password2 != \'\' && vc.data.Password2 != null && vc.data.Password != vc.data.Password2\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호를 다시 확인해 주세요.</p><p class=\"desc pass\" ng-if=\"vc.data.Password2 != \'\' && vc.data.Password2 != null && vc.data.Password == vc.data.Password2\"><i class=\"glyphicon glyphicon-ok\"></i> 비밀번호가 일치합니다.</p></div><div><label>사용자명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.UserNm placeholder=\"\"></div><div><label>휴대폰 번호</label><span class=e>*</span> <input type=text ng-model=vc.data.UserMobile auto-hyphen-tel></div><div><label>이메일</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.UserEmail></div></div></div><!-- 회원사 정보 --><div class=joinItem><h3>회원사 정보</h3><h5><span style=\"color: red\">사업자등록증의 정보로 입력 부탁드립니다.</span><div class=itemContent><div><label>법인명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.TenantNm></div><div><label>사업자번호</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.BizRegNo placeholder=\"사업자번호 입력\"></div><div ng-repeat=\"(liKey, liValue) in vc.attach\"><label>{{liValue.label}}</label><span class=e>*</span> <input id={{liKey}} ng-repeat=\"(liKey, liValue) in vc.attach\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"><div class=file-input id=filectl_{{liKey}}><input class=pull-left type=text ng-model=vc.attach[liKey].fileName ng-click=vc.downloadTemp(liKey) readonly style=\"cursor: pointer\"> <span class=pull-left ng-bind=vc.attach[liKey].size|filesize></span><div class=\"progress progress-xs pull-left\" style=height:8px><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div><div class=\"pull-right buttonWrap\"><button ng-show=\"!vc.attach[liKey].isLoaded && vc.data.TenantStatus != \'R\'\" class=\"primary-btn file-btn\" ng-click=vc.openAttachDilalog(liKey)>찾기</button> <button ng-show=\"vc.attach[liKey].isLoaded && vc.data.TenantStatus != \'R\'\" class=\"default-btn file-btn\" ng-click=vc.onDelete(liKey)>{{ \'Menu.DELETE\' | translate }}</button></div></div></div><div><label>대표자명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.Ceo></div><div><label>담당자명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.Contact></div><div><label>이메일</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.TenantEmail></div><div><label>대표 전화번호</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.TelNo auto-hyphen-tel maxlength=20></div><div><label>업종</label><span class=e>*</span><common-code-search code-list=vc.industCodeList code-model=vc.data.indust_code></common-code-search></div><div><label>업태</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.BizCondCode></div><div><label>주소</label><span class=e>*</span><div class=addressWrap><div class=zipcodeWrap><input type=text class=zipcode maxlength=5 ng-model=vc.data.ZipCode readonly> <button class=default_btn ng-click=vc.srchZipCodeModal() ng-if=\"vc.data.TenantStatus != \'R\'\"><i class=\"glyphicon glyphicon-search\"></i></button></div><input type=text ng-model=vc.data.Addr1 placeholder=\"기본 주소\" readonly> <input type=text ng-model=vc.data.Addr2 placeholder=\"상세 주소 입력\" ng-readonly=\"\"></div></div><div><label>가입경로</label><common-code-search code-list=vc.recommenderCodeList code-model=vc.data.ExtVarchar10></common-code-search></div><div><label>추천인명</label><input type=text class=txt_input ng-model=vc.data.ExtVarchar01 maxlength=20></div></div></h5></div><div class=\"buttonWrap mtb30\"><button class=cancel_btn ng-click=\"vc.signUpTenant(\'C\')\">취소</button> <button class=primary_btn ng-click=\"vc.signUpTenant(\'R\')\"><strong>가입신청</strong></button></div></div><!-- // section.inputInfoWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/signup-step-one.html","<div id=container><!-- 가입 전 정보 입력 시작 (step 1) --><section id=signUpStepOne><!-- 로고 --><div class=logoWrap><img class=logo src=assets/css/images/join.png></div><!-- 정보 입력 --><div class=inputInfoWrap><div class=business-name_area><input type=text id=business-name placeholder=기관명 ng-model=vc.data.TenantNm></div><div class=business-code_area><input type=text id=business-code placeholder=\"사업자번호 (-를 제외하고 입력해주세요)\" maxlength=10 ng-model=vc.data.BizRegNo oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\"></div><!-- 버튼 --><div class=buttonWrap><button class=\"default-btn full-btn\" ng-click=\"vc.saveData(\'E\')\">조회</button> <button class=\"default-btn full-btn\" ng-click=vc.goCancel()>취소</button> <button class=\"primary-btn full-btn\" type=submit ng-click=\"vc.saveData(\'R\')\">인증</button></div></div></section><!-- 가입 전 정보 입력 끝 --></div><!-- 이하 기존 코드 --> <!-- \r\n<div id=\"container_user\" style=\"padding: 30px 0 0; margin-bottom: 70px;\">\r\n  <div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important; width: 100%;\">\r\n    <div class=\"signupbody\">\r\n      <img class=\"mb-50\" src=\"assets/css/images/join.png\">\r\n      <div class=\"row signupcontent\">\r\n        <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10 mt-20 mb-10 ml-20\">\r\n          <div class=\"form-group form-inline\">\r\n            <label class=\"mt-3\" style=\"font-size: 14px; font-weight: 700;\">센터명</label>\r\n            <input class=\"form-control\" ng-model=\"vc.data.TenantNm\" placeholder=\"센터명\" type=\"text\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10 mb-25 ml-20\">\r\n          <div class=\"form-group form-inline\">\r\n            <label class=\"mt-3\" style=\"font-size: 14px; font-weight: 700;\">사업자번호</label>\r\n            <input class=\"form-control\" type=\"text\" maxlength=\"10\" ng-model=\"vc.data.BizRegNo\" oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\');\" placeholder=\"- 를제외하고 입력해주세요\">\r\n          </div>\r\n        </div>\r\n        <div class=\"signup-btn col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mb-20\">\r\n          <button class=\"bts btn btn-primary\" type=\"submit\" ng-click=\"vc.saveData(\'R\')\">인증</button>\r\n        </div>\r\n        <div class=\"signup-btn col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mb-20\">\r\n          <button class=\"bts btn close btn-primary\" type=\"submit\" ng-click=\"vc.goCancel()\" >취소</button>\r\n        </div>\r\n        <div class=\"signup-btn col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-20\">\r\n          <button class=\"bts btn btn-primary\" style=\"background-image: linear-gradient(to right, #FF8000, #FF8000);\" type=\"submit\" ng-click=\"vc.saveData(\'E\')\">조회</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n-->");
$templateCache.put("components/login/signup-step-two.html","<link rel=stylesheet href=assets/css/login.css><div id=container ng-drop=true><!-- 가입 전 정보 입력 시작 (step 2) --><section id=signUpStepTwo><h1 class=title>회원가입</h1><section class=infoWrap ng-if=\"vc.data.TenantStatus == \'N\'\"><h3 class=subTitle>반려의견</h3><div class=infoItemWrap><div class=full-item><label for=\"\">반려 의견</label><textarea type=text ng-model=vc.data.StatusCn readonly></textarea></div></div></section><section class=infoWrap><h3 class=subTitle>기본정보</h3><div class=infoItemWrap><div class=half-item><label for=\"\">기관명</label><input type=text ng-model=vc.data.TenantNm ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=half-item><label for=\"\">대표자</label><input type=text ng-model=vc.data.Ceo ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=half-item><label for=\"\">사업자번호</label><input type=text ng-model=vc.data.BizRegNo readonly></div><div class=half-item><label for=\"\">대표번호</label><input type=text ng-model=vc.data.TelNo auto-hyphen-tel maxlength=20 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=full-item><label for=\"\">주소</label><div class=address-input><div class=address-item><div class=zipcodeWrap><input type=text class=zipcode maxlength=5 ng-model=vc.data.ZipCode readonly> <button class=zipcode-search ng-click=vc.srchZipCodeModal() ng-if=\"vc.data.TenantStatus != \'R\'\"><i class=\"glyphicon glyphicon-search\"></i></button></div><div class=\"addressWrap address1\"><input type=text ng-model=vc.data.Addr1 readonly></div><div class=\"addressWrap address2\"><input type=text ng-model=vc.data.Addr2 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div></div></div></div><div class=half-item><label for=\"\">지역</label><common-code-signup param-data=vc.LocationData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 is-disabled=true ng-if=\"vc.data.TenantStatus == \'R\'\"></common-code-signup><common-code-signup param-data=vc.LocationData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 ng-if=\"vc.data.TenantStatus != \'R\'\"></common-code-signup></div><div class=half-item><label for=\"\">팩스번호</label><input type=text ng-model=vc.data.Fax auto-hyphen-tel maxlength=20 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=full-item><label for=\"\">이메일</label><div class=email-input><div class=email-input-id><input type=text ng-model=vc.data.Email1 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=email-asp>@</div><div class=email-input-host><input type=text class=email-host ng-model=vc.data.Email2 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=email-select ng-if=\"vc.data.TenantStatus != \'R\'\"><select class=\"form-control ml-5\" ng-model=vc.data.Email2 ng-options=\"opt.TypeId as opt.TypeNm for opt in vc.EmailList\"><option selected value=\"\">--선택--</option></select></div></div></div><div class=full-item><label for=\"\">아이디</label><div class=login-id-input><input type=text ng-model=vc.data.LoginId ng-disabled=\"vc.loginIdDisYN == \'Y\'\"> <button class=\"primary-btn chk-id-btn\" ng-click=vc.chkLoginIdDup() ng-if=\"vc.data.TenantStatus != \'R\'\">중복확인</button></div></div><div class=half-item><label for=\"\">비밀번호</label><input type=password ng-model=vc.data.Password></div><div class=half-item><label for=\"\">비밀번호 확인</label><input type=password ng-model=vc.data.Password2></div></div></section><section class=infoWrap><h3 class=subTitle>상세정보</h3><div class=infoItemWrap><div class=half-item><label for=\"\">사업명</label><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 pl-0\"><common-code-signup param-data=vc.yearList callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 is-disabled=true ng-if=\"vc.data.TenantStatus == \'R\'\"></common-code-signup><common-code-signup param-data=vc.yearList callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 ng-if=\"vc.data.TenantStatus != \'R\'\"></common-code-signup></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><select class=form-control ng-model=vc.data.PrmId ng-options=\"option.PrmId as option.PrmNm for option in vc.projectList\" disabled ng-if=\"vc.data.TenantStatus == \'R\'\"><option value=\"\">-- 선택 --</option></select><select class=form-control ng-model=vc.data.PrmId ng-options=\"option.PrmId as option.PrmNm for option in vc.projectList\" ng-if=\"vc.data.TenantStatus != \'R\'\"><option value=\"\">-- 선택 --</option></select></div></div><div class=half-item><label for=\"\">운영형태</label><common-code-signup param-data=vc.OperFormData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 is-disabled=true ng-if=\"vc.data.TenantStatus == \'R\'\"></common-code-signup><common-code-signup param-data=vc.OperFormData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 ng-if=\"vc.data.TenantStatus != \'R\'\"></common-code-signup></div><div class=half-item><label for=\"\">운영규모</label><common-code-signup param-data=vc.OperScaleData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 is-disabled=true ng-if=\"vc.data.TenantStatus == \'R\'\"></common-code-signup><common-code-signup param-data=vc.OperScaleData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" select-width=160 ng-if=\"vc.data.TenantStatus != \'R\'\"></common-code-signup></div><div class=half-item><label for=\"\">위탁일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ConsignDate = (vc.ConsignDate | date: \'yyyy-MM-dd\')\" ng-model=vc.ConsignDate ng-required=false placeholder=YYYY-MM-DD type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\" style=\"height: 28px !important\" disabled ng-if=\"vc.data.TenantStatus == \'R\'\"> <input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ConsignDate = (vc.ConsignDate | date: \'yyyy-MM-dd\')\" ng-model=vc.ConsignDate ng-required=false placeholder=YYYY-MM-DD type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\" style=\"height: 28px !important\" ng-if=\"vc.data.TenantStatus != \'R\'\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=half-item><label for=\"\">담당자 전화번호</label><input type=text ng-model=vc.data.ContactTelNo auto-hyphen-tel maxlength=20 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=half-item><label for=\"\">담당자</label><input type=text ng-model=vc.data.Contact ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div><div class=half-item><label for=\"\">담당자 휴대전화</label><input type=text ng-model=vc.data.ContactMobile auto-hyphen-tel maxlength=20 ng-readonly=\"vc.data.TenantStatus == \'R\'\"></div></div></section><section class=infoWrap><h3 class=subTitle>필수서류</h3><div class=infoItemWrap><input id={{liKey}} ng-repeat=\"(liKey, liValue) in vc.attach\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"><div class=half-item ng-repeat=\"(liKey, liValue) in vc.attach\"><label for=\"\">{{liValue.label}}</label><div class=file-input id=filectl_{{liKey}}><input class=pull-left type=text ng-model=vc.attach[liKey].fileName ng-click=vc.downloadTemp(liKey) readonly style=\"cursor: pointer\"> <span class=pull-left ng-bind=vc.attach[liKey].size|filesize></span><div class=\"progress progress-xs pull-left\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div><div class=\"pull-right buttonWrap\"><button ng-show=\"!vc.attach[liKey].isLoaded && vc.data.TenantStatus != \'R\'\" class=\"primary-btn file-btn\" ng-click=vc.openAttachDilalog(liKey)>찾기</button> <button ng-show=\"vc.attach[liKey].isLoaded && vc.data.TenantStatus != \'R\'\" class=\"default-btn file-btn\" ng-click=vc.onDelete(liKey)>{{ \'Menu.DELETE\' | translate }}</button></div></div></div></div></section><div class=buttonWrap><button class=\"primary-btn submit-btn\" ng-if=\"$root.gVariable.TenantId != 0 && vc.data.TenantStatus != \'R\'\" ng-click=vc.getIsValidData()>승인요청</button> <button class=\"primary-btn submit-btn\" ng-click=vc.goBack()>뒤로가기</button></div></section></div><!-- 가입 전 정보 입력 끝 -->");
$templateCache.put("components/login/signup.html","<link rel=stylesheet href=assets/css/login.css><div class=wrapper><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb100\"><!-- section.joinStep --><div class=content><div class=joinWrap><ul class=explainWrap><li>회원가입 후, 관리자의 승인이 있어야 이용 가능합니다.</li><li>개인은 회원가입이 불가능합니다.</li><li>위기가정지원사업 협약기관만 가입이 가능합니다.</li></ul><ul class=joinTypeWrap><li ng-click=\"vc.signUpTenant(\'T\')\"><p><img src=../../assets/images/join/typeT_btn.png></p><h3>사례관리기관</h3></li><li ng-click=\"vc.signUpTenant(\'G\')\"><p><img src=../../assets/images/join/typeG_btn.png></p><h3>위기지원기관</h3></li></ul></div></div><!-- // section.joinStepWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/updatepass.html","<style>input.ng-invalid {\r\n    border: 1px solid #FFAAAA;\r\n  }</style><div class=\"page page-core page-login\" style=\"background-color: #f5f6f7 !important; padding-top: 20px\"><p style=margin-top:50px></p><div class=\"container w-450 p-15 text-center\" style=\"background-color: transparent\"><div class=\"row login_logo_pad\"><div class=\"col-xs-6 text-left\"><img src=assets/images/logo_army.png style=height:45px></div><div class=\"col-xs-6 text-right\"><img src=assets/images/logo_armyedu.png style=height:45px></div></div><div class=\"text-center login_tit_pad\"><h3 class=\"text-black login_tit\">찾아가는 1:1 진로 및 취업상담</h3></div><form name=form class=\"form-validation mt-15\"><div class=form-group><input type=password class=form-control placeholder=\"현재 비밀번호\" ng-model=updatepass.user.oldPass required style=\"height: 45px !important; color: #000\"></div><div class=form-group><input type=password class=form-control placeholder=\"변경 비밀번호\" ng-model=updatepass.user.newPass required style=\"height: 45px !important; color: #000\"></div><div class=form-group><input type=password class=form-control placeholder=\"변경 비밀번호 확인\" ng-model=updatepass.user.newPass2 required style=\"height: 45px !important; color: #000\"></div><button type=button class=\"btn btn-lg btn-blue btn-block b-0 br-2 mr-5 p-15\" ng-click=updatepass.chkUserInfo() style=\"margin: 30px 0 10px 0\">비밀번호 변경</button><p class=\"help-block text-left text-slategray mt-20\">※ 개인정보 보호를 위하여 비밀번호를 변경 후에 사용 가능 합니다.</p><p class=\"help-block text-left text-slategray mt-10\">※ 비밀번호는 8~16 자리 까지 사용 가능 합니다.</p><p class=\"help-block text-left text-slategray mt-10\">※ 영문+숫자+특수문자 형식으로 필수조합, 1글자 연속3개 이상 사용 불가</p><p class=\"help-block text-left text-slategray mt-10\">※ 사용가능 특수문자 : ! @ # $ % ^ * + = -</p></form><!-- \r\n      <div class=\"lt wrap-reset mt-10 text-left\">\r\n        <p class=\"m-0\">\r\n          <button ui-sref=\"main.login\" class=\"btn btn-default btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4c mb-10\">\r\n            <i class=\"fa fa-arrow-left\"></i> {{ \'Menu.BACK\' | translate }}\r\n          </button>\r\n        </p>\r\n      </div>\r\n      <div>\r\n        <p style=\"color: rgba(97, 111, 119, 0.57) !important; margin-top: 35px; border-top: 1px solid #ccc; padding-top: 15px;\">Copyright ⓒ SOFTZION Corp. All right reserved.</p>\r\n      </div>\r\n       --></div></div>");
$templateCache.put("components/policy/policy.html","<!-- policy --><section class=\"joinStepWrap mb-50\"><!-- section.joinStepWrap--><div class=content><h2>개인정보처리방침</h2></div><!-- // section.joinStepWrap--></section><section class=\"inputInfoWrap custInfo mb-50\"><!-- section.joinStep --><div class=content><div class=joinItem><div class=agreeContent><ul><li>Salevis Care(care.salevis.co.kr)를 운영하고 있는 ‘㈜소프트자이온’은 (이하 ‘회사’는)고객님의 개인정보를 중요시하며, [정보통신망 이용촉진 및 개인정보보호]에 관한 법률을 준수하고 있습니다.회사는 개인정보취급방침을 통하여 고객님께서 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</li><li><dl><dt>1. 수집하는 개인정보의 항목</dt><dd>회사는 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<ul><li>이름, 전화번호, 휴대폰, 전자메일, 회사정보(회사명, 사업자등록번호, 주소), 대표정보(이름)</li><li>개인정보 수집방법 :홈페이지 (회원가입), 서면양식</li></ul></dd></dl></li><li><dl><dt>2. 개인정보 수집 및 이용목적</dt><dd>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<ul><li>전자메일 : 본인확인 및 개인식별에 이용</li><li>이름 : 고지사항 전달, 불만처리, 고객문의 답변 등 회원관리에 이용</li><li>전화번호/휴대폰 : 고지사항 전달, 불만처리, 고객문의 답변 등 회원관리에 이용</li><li>직함/부서/회사명 : 상품상담 및 고객문의 답변 등 회원관리에 이용</li><li>주소 : 이벤트 상품 발송 등에 이용</li></ul></dd></dl></li><li><dl><dt>3. 개인정보의 보유 및 이용기간</dt><dd>회사는 원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.</dd></dl></li><li><dl><dt>4. 개인정보 파기절차 및 방법</dt><dd>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.<ul><li>파기절차 : 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져 (종이의 경우 별도의 서류함) 내부 방침 및 기타관련 법령에 의한 정보보호 사유에 따라 (보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 되어지는 이외의 다른 목적으로 이용되지 않습니다.</li><li>파기방법 : 전사적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li></ul></dd></dl></li><li><dl><dt>5. 개인정보</dt><dd>회사는 회원의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<ul><li>이용자들이 사전에 동의한 경우 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li></ul></dd></dl></li><li><dl><dt>6. 수집한 개인정보의 위탁</dt><dd>회사는 회원의 동의 없이 회원의 개인정보를 외부 업체에 위탁하지 않습니다. 향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 회원에게 통지하고 필요한 경우 사전 동의를 받겠습니다.</dd></dl></li><li><dl><dt>7. 개인정보 관한 민원 서비스</dt><dd>회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리담당자 및 개인정보관리책임자를 지정하고 있습니다.<br><br><dl><dt>[개인정보관리담당자]</dt><dd><ul><li>성명 : 권기철</li><li>소속 : 기술사업팀 CRM파트</li><li>전화번호 : 070-5001-0869</li><li>이메일 : kckwon@softzion.com</li></ul></dd></dl><dl><dt>[개인정보관리 책임자]</dt><dd><ul><li>성명 : 조영래</li><li>소속 : 기술사업팀 / 부장</li><li>전화번호 : 070-5001-6432</li><li>이메일 : yrcho@softzion.com</li></ul></dd></dl></dd></dl></li><li><dl><dt>[부칙]</dt><dd>(공고일) 2014년 09년03일<br>(시행일) 2013년 12월16일</dd></dl></li><li>귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리 담당자 혹은 책임 자에게 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</li><li>개인분쟁조정위원회(www.1336.or.kr/1336)<br>정보보호마크인증위원회(www.eprivacy.or.kr/02-580-0533~4)<br>대검찰청 인터넷범죄수사센터(icic.sppo.go.kr/02-3480-3600)<br>경찰청 사이버테러대응센터(www.ctrc.go.kr/02-392-0330)</li></ul></div></div></div><!-- // section.joinStepWrap --></section><!-- // policy -->");
$templateCache.put("components/popup/popup.html","<div class=view-container ui-view-container><section ui-view autoscroll=false></section></div>");
$templateCache.put("components/template/pagination.html","<ul class=pagination><li ng-if=::boundaryLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr first\" ng-click=\"selectPage(1, $event)\"><span class=hide>맨앞으로</span></a></li><li ng-if=::directionLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr prev\" ng-click=\"selectPage(page - 1, $event)\"><span class=hide>이전</span></a></li><li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=pagination-page><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li><li ng-if=::directionLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr next\" ng-click=\"selectPage(page + 1, $event)\"><span class=hide>다음</span></a></li><li ng-if=::boundaryLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr last\" ng-click=\"selectPage(totalPages, $event)\"><span class=hide>맨뒤로</span></a></li></ul>");
$templateCache.put("components/qna/qna.html","<!-- qna --><section id=qna class=\"subPageWrap mtb100\"><!-- section#qna --><div class=\"sp_header mb30\"><div class=content><h2 class=title>1:1 문의하기</h2></div></div><div class=sp_container><div class=content><p class=qnaGuide><span class=\"glyphicon glyphicon-phone-alt\"></span><br>더 자세한 문의사항은 <span class=point-color><strong>02-3142-1900</strong></span>으로<br>문의 주시면 친절하게 답변해 드리겠습니다.</p></div></div><!-- // section#qna --></section><!-- // qna -->");
$templateCache.put("app/business/tab/business-op-tab-comm.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"BusinessOpTabCommCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><!-- <autoview-list-table alias=\"vc\" list-data=\"lists\" disabled-click></autoview-list-table> --><!-- 의견등록 --><div class=row><div class=col-lg-12><div class=form-group><textarea class=form-control row=3 cols=100 ng-model=vc.data.opContents placeholder=의견등록></textarea></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.resetData()><i class=\"fa fa-list\"></i> 취소</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.setData()><i class=\"fa fa-trash-o\"></i> 등록</button></div></div></div><!-- 의견조회 --><div class=row><div class=col-lg-12><div class=op-contents-list ng-repeat=\"item in vc.lists[0].commentList track by $index\"><!-- <pre>{{item | json}}</pre> --><div class=op-contents-item><div style=\"border:1px solid; padding:10px; margin-top:5px\"><p>{{item.RegDate}} {{item.RegUser}}</p><p>{{item.Contents}}</p></div><button ng-click=\"vc.addComment(item.KeyId, $index)\" ng-if=\"item.commentList.length == 0\">댓글추가</button> <button ng-click=\"vc.addComment(item.KeyId, $index)\" ng-if=\"item.commentList.length != 0\">댓글 {{item.commentList.length}}개</button><div class=op-comment-list ng-if=item.commDisplayYN ng-repeat=\"data in item.commentList track by $index\"><pre>{{data | json}}</pre><md-divider ng-if=!$last></md-divider></div><div class=op-comment-item ng-if=item.commDisplayYN id=comment_item_{{$index}}><div><textarea class=form-control row=3 cols=100 ng-model=vc.data.Comment[$index] placeholder=댓글등록></textarea></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.resetComment()><i class=\"fa fa-list\"></i> 취소</button> <button class=\"btn btn-danger ng-binding\" ng-click=\"vc.setComment(item, vc.data.Comment[$index])\"><i class=\"fa fa-trash-o\"></i> 등록</button></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/tab/business-op-tab-customer.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"BusinessOpTabCustomerCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><autoview-list-table alias=vc list-data=lists disabled-click></autoview-list-table></div><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.busiWriteModal()><i class=\"fa fa-edit\"></i>추가</button></div><!-- /page content --></div>");
$templateCache.put("app/business/tab/business-op-tab-dr.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"BusinessOpTabDrCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><autoview-list-table alias=vc list-data=lists></autoview-list-table></div><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.busiWriteModal()><i class=\"fa fa-edit\"></i>등록</button></div><!-- /page content --></div>");
$templateCache.put("app/business/tab/business-op-tab-files.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"BusinessOpTabFilesCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><!-- 첨부파일 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><!-- <label title=\"\" uib-tooltip=\"관련파일\">관련파일</label> --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100% ng-if=\"vc.lists.length > 0\"><colgroup><col style=\"width: 25px\"><col style=\"width: 140px\"><col style=\"width: 50px\"><col style=\"width: 50px\"></colgroup><thead><tr><th class=text-center style=\"vertical-align:middle; width: 3%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center><span>파일명</span></th><th class=text-center><span>파일크기</span></th><th class=text-center><span>등록일</span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center><a href={{li.link}} target=attach>{{li.fileName}}</a></td><td class=text-center><span ng-bind=li.size|filesize></span></td><td class=text-center><span>{{li.regDate | date : \'yyyy-MM-dd\' }}</span></td></tr></tbody></table><!-- <div class=\"form-control-no-border\">\r\n          <table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important;\">\r\n            <colgroup>\r\n              <col style=\"width: *\">\r\n              <col style=\"width: 140px;\">\r\n              <col style=\"width: 50px;\">\r\n            </colgroup>\r\n            <thead>\r\n              <tr>\r\n                <th><span>{{ \'Menu.FILENAME\' | translate }}</span></th>\r\n                <th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th>\r\n                <th><span>{{ \'Menu.DELETE\' | translate }}</span></th>\r\n              </tr>\r\n            </thead>\r\n            <tbody ng-repeat=\"fli in vc.uploadFileList\">\r\n              <tr id=\"filectl_{{fli.id}}\">\r\n                <td><span class=\"file_list\"><a href=\"{{fli.link}}\" target=\"attach\">{{fli.fileName}}</a></span>\r\n                </td>\r\n                <td align=\"right\"><span class=\"file_size\" ng-bind=\"fli.size|filesize\"></span></td>\r\n                <td>\r\n                  <div class=\"form-group\">\r\n                    <md-checkbox md-no-ink=\"\" ng-model=\"fli.delState\" ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\"\r\n                      class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=\"checkbox\">\r\n                    </md-checkbox>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div> --></div><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach callback=vc.onFileCallback file-data=vc.uploadFileList></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div id=vault class=vault-block vault-company></div></form></div></div><!-- 첨부파일 --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=pull-right><button class=\"btn btn-danger mb-10\" ng-click=vc.delData()><i class=\"fa fa-edit\"></i> 삭제</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.uploadFile()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><!-- /page content --></div>");
$templateCache.put("app/business/tab/business-op-tab-hist.html","<!-- Html Editor --><style>.hist-wrap table td {\r\n    letter-spacing: 1px;\r\n    padding: 8px !important;\r\n    line-height: 1.6 !important;\r\n  }</style><div class=\"page page-footable shop-detail-view shop-view hist-wrap\" ng-controller=\"BusinessOpTabHistCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=pagecontent><autoview-list-table alias=vc list-data=lists disabled-click></autoview-list-table></div><!-- /page content --></div>");
$templateCache.put("app/campaign/modal/campaign-cust-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.title}} 고객 목록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" id=searchWrap><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>고객명</label><input class=form-control ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6 mt-5\"><button class=\"btn btn-primary mb-10\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-danger mb-10\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></form><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align: middle; width: 40px\"><input type=checkbox ng-click=vc.chkRowAll() ng-model=vc.checkListCheckbox aria-invalid=false></th><th class=text-center>상태</th><th class=text-center>이름</th><th class=text-center>발신정보</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=\"vertical-align:middle; width: 20px\"><input type=checkbox ng-model=li.chkRow aria-invalid=false></td><td class=text-center>{{li.CmpgnImplCustStatus}}</td><td class=text-center>{{li.ToNm}}</td><td class=text-center ng-if=\"vc.CmpgnImpChannel != \'EMAIL\'\"><span auto-hyphen-tel-bind ng-bind=li.ToInfo></span></td><td class=text-center ng-if=\"vc.CmpgnImpChannel == \'EMAIL\'\"><span ng-bind=li.ToInfo></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><!--		\r\n    <button class=\"btn btn-primary mb-10\" ng-click=\"vc.ok()\">\r\n      <i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}\r\n    </button>\r\n    --> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/modal/campaign-edit-modal.html","<div class=modal-content><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">캠페인 등록/수정</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong></div><div class=\"panel-body collapse in\"><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">세그먼트</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\">&nbsp;</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">대상고객</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 mt-5 pl-0 pr-0\" ng-if=\"vc.data.Status == \'TEMP\' || vc.data.keyId == null\"><button class=\"btn btn-default mr-5\" ng-click=vc.setCustAll()>전체고객투입</button> <button class=\"btn btn-default mr-5\" ng-click=vc.extCustModal()>조건검색투입</button> <button class=\"btn btn-default mr-5\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\" ng-click=vc.ReceiveNumberModal()>직접입력</button> <button class=\"btn btn-default\" ng-click=vc.resetCmpgnCustList()>대상고객초기화</button></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xg-9 col-xl-6\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=투입고객수>투입고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'A\')\">{{vc.data.EnterCnt}}</a></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=대상고객수>대상고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'T\')\">{{vc.data.TargetCnt}}</a></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label uib-tooltip=제외고객수>제외고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'E\')\">{{vc.data.ExceptCnt}}</a></span></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상세등록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송메시지>발송메시지</label><textarea class=form-control id=sendMessage name=sendMessage rows=12 kr-input ng-model=vc.data.SendMessage ng-disabled=\"vc.data.CmpgnImpChannel == \'KAKAO\' || (vc.data.keyId != null && vc.data.Status != \'TEMP\')\" aria-invalid=false ng-change=vc.chkSmsByte()></textarea></div><div ng-if=\"vc.data.CmpgnImpChannel != \'KAKAO\'\" style=\"padding-left:90px; font-size:15px\"><span>{{vc.bytes}} / {{vc.messageMaxLength}} bytes</span><br><span>※ 아래버튼을 클릭하여 내용에 삽입하면 해당항목의 값으로 대체됩니다.<br></span><span>※ 치환문자 사용 시, SMS 에서는 90자 이상은 이후 문자가 잘려서 전송될 수 있으니, 주의하여 사용하시기 바랍니다.</span><div class=mt-15 ng-if=\"vc.data.keyId == null || vc.data.Status == \'TEMP\'\"><button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'C\')\">고객명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'T\')\">회원사명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'B\')\">지점명</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'M\')\">로그인ID 핸드폰</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'A\')\">주소</button> <button class=\"btn btn-primary\" ng-click=\"vc.innerTextArea(\'sendMessage\', \'BA\')\">계좌번호</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=margin-left:90px><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input class=mt-3 ng-checked-=\"vc.addADTxtYN == \'Y\'\" ng-change=\"vc.chkADTxt(\'sendMessage\')\" ng-false-value=\"\'N\'\" ng-model=vc.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox> <span>광고문구 추가(최상단 삽입)</span></label></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-4 col-xl-4 mt-5\" ng-if=\"vc.data.CmpgnImpChannel != \'EMAIL\'\"><ul class=\"nav nav-tabs\"><li ng-class=\"vc.tabId == \'tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\" style=cursor:pointer>광고문자전송 안내</a></li><li ng-class=\"vc.tabId == \'tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\" style=cursor:pointer>통신사별 스팸차단 안내</a></li></ul><div class=tab-content><div class=\"tab-pane active\" id=noti-tab1><img src=/assets/images/sms-noti-msg.jpg style=width:100%></div><div class=tab-pane id=noti-tab2><img src=/assets/images/sms-noti-spam.jpg style=width:100%></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\" ng-if=\"vc.data.CmpgnImpChannel == \'MMS\'\"><div class=\"form-group form-inline\"><label uib-tooltip=첨부>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" ng-disabled=\"vc.data.keyId != null && vc.data.Status != \'TEMP\'\" class=md-warn role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div><div class=\"form-group form-inline\" ng-if=\"vc.showUploader && vc.uploadFileList.length == 0\"><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div class=form-control-no-border id=vault class=vault-block vault-company></div></form></div></div><div ng-show=\"vc.data.CmpgnImpChannel == \'EMAIL\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group>수신동의 및 수신거부<div><label class=ng-binding><input type=checkbox ng-model=vc.data.AgreeYN ng-checked=\"vc.data.AgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>회원수신동의 및 관련 문구를 넣습니다.</label></label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">내용에 \"{CustNm}\"을 입력하면 고객명으로 치환됩니다. ex) {CustNm}님 안녕하세요.</div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><textarea id=strHtml rows=30 style=\"width: 100%\"></textarea></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.showPreView()><i class=\"fa fa-clone\"></i> 미리보기</button><!--\r\n    <button class=\"btn btn-default mb-10\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=\"vc.resetAll()\">\r\n      <i class=\"fa fa-refresh\"></i> 전체초기화\r\n    </button>\r\n    --> <button class=\"btn btn-default mb-10\" ng-click=vc.setTestData()><i class=\"fa fa-check-square-o\"></i> 테스트발송</button> <button class=\"btn btn-default mb-10\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=\"vc.uploadFile(\'T\')\"><i class=\"fa fa-edit\"></i> 임시저장</button> <button class=\"btn btn-primary mb-10\" ng-if=\"vc.data.keyId == undefined || vc.data.Status == \'TEMP\'\" ng-click=\"vc.uploadFile(\'S\')\"><i class=\"fa fa-save\"></i> 승인요청</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/modal/cert-email-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">이메일 인증</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10 mb-15\" ng-if=!vc.showMsg><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"><div class=\"form-group form-inline\"><label>이메일</label><input class=form-control ng-model=vc.data.SendInfo placeholder=이메일 type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-4 col-xl-4 mt-5\"><button class=\"btn btn-primary\" ng-click=vc.dupChk()><i class=\"fa fa-edit\"></i> 인증하기</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10\" ng-if=vc.showMsg><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 text-center\" style=\"font-size: 17px; font-weight: bold\">인증메일이 발송되었습니다.<br>Amazon Web Services로부터 인증메일을 받아<br>메일 내용에 있는 https://email-verification 로 시작하는 URL을 클릭 후<br>아래 완료 버튼을 클릭 해주시기 바랍니다.<br>(인증 메일은 Amazon Web Services<no-reply-aws @amazon.com>에서 발송되는 영문메일이기 때문에<br>스팸함으로 분류될 수도 있으므로 주의하시기 바랍니다)</no-reply-aws></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10 mb-15 text-center\"><button class=\"btn btn-primary\" ng-click=vc.sendVerifyEmailChk()><i class=\"fa fa-save\"></i> 완료</button></div></div></div><div class=\"modal-footer ng-scope\"><!--     \r\n      <button class=\"btn btn-primary mb-10\" ng-click=\"vc.ok()\">\r\n        <i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}\r\n      </button>\r\n      --> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div>");
$templateCache.put("app/campaign/modal/direct-input-modal.html","<style>.direct-input-item {border:1px solid #ddd; background:#f4f4f4; height:500px; overflow-y:scroll; padding:7px;}\r\n	.direct-input-item p {padding-bottom:7px;}</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">직접입력</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=휴대폰번호>휴대폰번호</label><div class=input-group><form ui-keypress=\"{13:\'vc.addReceiveNumList()\'}\"><input class=form-control ng-model=vc.receiveNum auto-hyphen-tel type=text></form><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.addReceiveNumList()><i class=\"fa fa-plus\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"추가된 휴대폰번호\">추가된 휴대폰번호</label><div class=\"input-group direct-input-item\"><p ng-repeat=\"(index, li) in vc.receiveNumList\"><span auto-hyphen-tel-bind ng-bind=li.ToInfo></span><span class=ml-5 ng-click=vc.delReceiveNumList(index)><i class=\"fa fa-times\"></i></span></p></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.resetReceiveNumList()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/modal/ext-cust-detail-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">세그먼트 등록/수정</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">검색</strong><div class=pull-right><!--<a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>--></div></div><div class=\"panel-body collapse in\"><!-- text 형 --><div ng-if=\"vc.repItem.type == \'text\'\"><div class=row><div class=col-md-6><div class=\"form-group form-inline\"><label uib-tooltip={{vc.repItem.name}}>{{vc.repItem.name}}</label><input class=form-control type=text ng-model=vc.cond></div></div></div></div><!-- select, date 형 --><div ng-if=\"vc.repItem.type == \'select\' || vc.repItem.type == \'date\'\"><div class=row><div class=col-md-6><div class=\"form-group form-inline\"><label uib-tooltip={{vc.repItem.name}}>{{vc.repItem.name}}</label><select class=form-control ng-model=vc.cond ng-options=\"opt.id as opt.nm for opt in vc.selectList\"><!--ng-change=\"vc.chgSelectItem()\"--></select></div></div></div></div><!-- search 형 --><div ng-if=\"vc.repItem.type == \'search\'\"><div class=row><div class=col-md-6><div class=\"form-group form-inline\"><label uib-tooltip={{vc.repItem.name}}>{{vc.repItem.name}}</label>search박스</div></div></div></div><!-- number 형 --><div ng-if=\"vc.repItem.type == \'number\'\"><div class=row><div class=col-md-6><div class=\"form-group form-inline\"><label uib-tooltip={{vc.repItem.name}}>{{vc.repItem.name}}(시작)</label><input class=form-control type=text ng-model=vc.cond></div></div><div class=col-md-6><div class=\"form-group form-inline\"><label uib-tooltip={{vc.repItem.name}}>{{vc.repItem.name}}(종료)</label><input class=form-control type=text ng-model=vc.cond2></div></div></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/modal/ext-cust-modal.html","<style>/* 아이템 */\r\n  .ext-cust-item {width:100%;}\r\n  .ext-cust-item > li {padding:8px 0 8px 0; border:1px #ddd solid; margin-top:-1px; cursor:pointer;}\r\n  .ext-cust-item > li > a {width:100%;}\r\n  .ext-cust-item > li > a > .tit {margin-left:8px;}  \r\n  .ext-cust-item > li > a > .ext {float:right; color:#ccc; margin-top:-3px; margin-right:8px;}  \r\n  .ext-cust-item-2 {width:100%; padding-top:10px;}  \r\n  .ext-cust-item-2 > li {padding:8px 0 8px 0; border-top:1px #ddd solid; border-bottom:1px #ddd solid; background-color:#f4f4f4; margin-top:-1px; cursor:pointer;}\r\n  .ext-cust-item-2 > li > a {width:100%;}\r\n  .ext-cust-item-2 > li > a > .tit {margin-left:16px;}  \r\n  .ext-cust-item-2 > li > a > .ext {float:right; color:#ccc; margin-top:-3px; margin-right:8px;}\r\n  .ext-cust-item-3 {width:100%; padding-top:10px;}\r\n  .ext-cust-item-3 > li {padding:8px 0 8px 0; border-top:1px #ddd solid; border-bottom:1px #ddd solid; background-color:#eee; margin-top:-1px; cursor:pointer;}  \r\n  .ext-cust-item-3 > li > a {width:100%;}\r\n  .ext-cust-item-3 > li > a > .tit {margin-left:24px;}  \r\n  .ext-cust-item-3 > li > a > .ext {float:right; color:#ccc; margin-top:-3px; margin-right:8px;}  \r\n  .ext-cust-sec {height:500px; overflow-y:scroll;}\r\n\r\n  /* 세그먼트 */\r\n  .ext-cust-seg {width:100%;}\r\n  .ext-cust-seg > li {padding:8px 0 8px 0; border:1px #ddd solid; margin-top:-1px; cursor:pointer;}\r\n  .ext-cust-seg > li {width:100%;}\r\n  .ext-cust-seg > li > .tit {margin-left:8px;}  \r\n  .ext-cust-seg > li > .cont {float:right; margin-right:8px;}  \r\n  .ext-cust-seg > li > .ext {float:right; color:red; margin-top:-3px; margin-right:8px;}  \r\n  .ext-cust-seg > li > .chg {float:right; margin-top:-3px; margin-right:8px;}    \r\n  .ext-cust-import {color:blue !important; margin-right:5px; font-weight: normal; cursor:pointer;}</style><div class=modal-content><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">조건검색투입</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-md-4><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">아이템</strong><div class=pull-right><!--<a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>--></div></div><div class=\"panel-body collapse in ext-cust-sec\"><ul class=ext-cust-item><li ng-repeat=\"item in vc.itemList\"><a ng-click=\"vc.chkItem(\'1\', item)\"><span class=tit>{{item.name}}</span> <span class=\"glyphicon glyphicon-plus ext\" ng-show=\"vc.selItem.id != item.id && item.child.length > 0\"></span> <span class=\"glyphicon glyphicon-minus ext\" ng-show=\"vc.selItem.id == item.id && item.child.length > 0\"></span></a><ul class=ext-cust-item-2 ng-show=\"vc.selItem.id == item.id && item.child.length > 0\"><li ng-repeat=\"item2 in item.child\"><a ng-click=\"vc.chkItem(\'2\', item2)\"><span class=tit>{{item2.name}}</span> <span class=\"glyphicon glyphicon-plus ext\" ng-show=\"vc.selItem2.id != item2.id && item2.child.length > 0\"></span> <span class=\"glyphicon glyphicon-minus ext\" ng-show=\"vc.selItem2.id == item2.id && item2.child.length > 0\"></span></a><ul class=ext-cust-item-3 ng-show=\"vc.selItem2.id == item2.id && item2.child.length > 0\"><li ng-repeat=\"item3 in item2.child\"><a ng-click=\"vc.chkItem(\'3\', item3)\"><span class=tit>{{item3.name}}</span></a></li></ul></li></ul></li></ul></div></div></div><div class=col-md-4><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">세그먼트(AND조건)</strong><div class=pull-right><a class=ext-cust-import ng-click=vc.import()><i class=\"fa fa-edit\"></i> 추출 </a><!--<a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>--></div></div><div class=\"panel-body collapse in ext-cust-sec\"><ul class=ext-cust-seg><li ng-repeat=\"seg in vc.segList\"><span class=tit>{{seg.name}}</span> <span class=\"glyphicon glyphicon-remove ext\" ng-click=vc.delSeg(seg)></span> <span class=\"glyphicon glyphicon glyphicon-cog chg\" ng-click=\"vc.extCustDetailModal(\'modify\', seg)\"></span> <span class=cont>{{seg.cont}}</span></li></ul></div></div></div><div class=col-md-4><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">현재기준고객수</strong><div class=pull-right><!--<a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>--></div></div><div class=\"panel-body collapse in ext-cust-sec\"><div class=row><div class=col-md-12>도넛그래프 영역</div></div><div class=row><div class=col-md-12><div class=\"form-group form-inline\"><label uib-tooltip=투입고객수>투입고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'A\')\">{{vc.data.EnterCnt}}</a></span></div></div></div><div class=row><div class=col-md-12><div class=\"form-group form-inline\"><label uib-tooltip=대상고객수>대상고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'T\')\">{{vc.data.TargetCnt}}</a></span></div></div></div><div class=row><div class=col-md-12><div class=\"form-group form-inline\"><label uib-tooltip=제외고객수>제외고객수</label><span class=\"form-control form-right bind-wrap\"><a class=cust-cnt href=\"\" ng-click=\"vc.campaignCustomerModal(\'E\')\">{{vc.data.ExceptCnt}}</a></span></div></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/modal/form-inc-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">서식 목록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" id=searchWrap><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>서식명</label><input class=form-control ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6 mt-5\"><button class=\"btn btn-primary mb-10\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button></div></div></form><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center>발송타입</th><th class=text-center>서식명</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=vc.ok(li)><!-- Result Items --><td class=text-center>{{li.FormType}}</td><td class=text-center>{{li.FormNm}}</td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><!--		\r\n    <button class=\"btn btn-primary mb-10\" ng-click=\"vc.ok()\">\r\n      <i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}\r\n    </button>\r\n    --> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/client/cust-tab/ksacust-business.html","<div class=\"page page-footable\" ng-controller=\"KSACustBusinessCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>사업기회</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.goBusinessOPEdit()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/client/cust-tab/ksacust-comp.html","<div class=\"page page-footable\" ng-controller=\"KSACustCompCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>직장이력</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-energy.html","<div class=\"page page-footable\" ng-controller=\"KSACustEnergyCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>에너지</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-history.html","<div class=\"page page-footable\" ng-controller=\"KSACustHistoryCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>변경이력</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-iso.html","<div class=\"page page-footable\" ng-controller=\"KSACustISOCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>ISO</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-ks.html","<div class=\"page page-footable\" ng-controller=\"KSACustKSCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>KS</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-member.html","<div class=\"page page-footable\" ng-controller=\"KSACustMembersCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>회원사</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-network.html","<div class=\"page page-footable\" ng-controller=\"KSACustNetworkCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>표준정보망</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-quality.html","<div class=\"page page-footable\" ng-controller=\"KSACustQualityCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>분임조</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-relate.html","<div class=\"page page-footable\" ng-controller=\"KSACustRelateCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>연관사업정보</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/cust-tab/ksacust-sales.html","<div class=\"page page-footable\" ng-controller=\"KSACustSalesCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>영업일지</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.goBusinessDREdit()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/client/modal/client-edit-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">고객사 등록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientId-col-wrap form-layout-inline wrap-col-size-3 type-bindWrap-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=고객사코드><span style=color:red>* </span>고객사코드</label><span class=\"form-control form-right bind-wrap ng-binding\" ng-bind=vc.data.ClientId></span></div></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientNm-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline required-wrap\"><label uib-tooltip=고객사명><span style=color:red>* </span>고객사명</label><input class=\"form-control form-right ng-pristine ng-untouched ng-valid ng-empty\" type=text ng-model=vc.data.ClientNm aria-invalid=false></div></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ClientBSN1-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline required-wrap\"><label uib-tooltip=사업자등록번호><span style=color:red>* </span>사업자등록번호</label><input class=\"form-control form-right ng-pristine ng-untouched ng-valid ng-empty\" type=text ng-model=vc.data.ClientBSN1 aria-invalid=false></div></div></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상세정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label for=\"\">출처</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox1 value=K><label class=form-check-label for=inlineCheckbox1>KS</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox2 value=I><label class=form-check-label for=inlineCheckbox2>ISO</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox3 value=E><label class=form-check-label for=inlineCheckbox3>에너지</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox4 value=L><label class=form-check-label for=inlineCheckbox4>교육</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox5 value=M><label class=form-check-label for=inlineCheckbox5>회원사</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox6 value=Q><label class=form-check-label for=inlineCheckbox6>분임조</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox7 value=B><label class=form-check-label for=inlineCheckbox7>조찬</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox8 value=N><label class=form-check-label for=inlineCheckbox8>표준정보망</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfoEtc type=checkbox id=inlineCheckbox12 onchange=angular.element(this).scope().clickCheckBoxEtc(event) value=기타><label for=\"\">기타</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input type=text class=\"form-control mb5\" id=busiInfoEtc readonly></div></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">관리정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/client/modal/client-nicednb-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>나이스정보조회</div></div></div><!-- /page header --><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input ng-model=vc.srch.ClientNm placeholder=고객사명 type=text> <input ng-model=vc.srch.ClientBSN1 placeholder=사업자등록번호 type=text><div class=search_button><button class=\"btn btn-default\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button></div><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goData()><i class=\"fa fa-edit\"></i> 선택 정보 적용</button> <button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></form></div></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><div class=dataloader ng-show=vc.dataloader></div><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th class=text-center>고객사명</th><th class=text-center>사업자등록번호</th><th class=text-center>산업분류코드</th><th class=text-center>국가명</th><th class=text-center>전화번호</th><th class=text-center>주소</th><th class=text-center>업태</th><th class=text-center>기업형태</th><th class=text-center>기업규모</th><th class=text-center>공기업구분</th><th class=text-center>개인법인구분</th><th class=text-center>본점지점구분</th><th class=text-center>신용등급/평가일자</th><th class=text-center>영업이익</th><th class=text-center>당기순이익</th><th class=text-center>매출액</th><th class=text-center>결산일자</th></tr></thead><tbody id=allData ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=10>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tr ng-repeat=\"li in vc.lists\"><td class=text-center style=vertical-align:middle><input type=checkbox id=chk_{{li.KeyId}} name=chkbox value={{li.KeyId}} ng-click=vc.chgChkBox(li.KeyId)></td><td class=text-center><span ng-bind=li.ClientNm></span></td><td class=text-center><span ng-bind=li.ClientBSN1></span></td><td class=text-center><span ng-bind=li.KSIC></span></td><td class=text-center><span ng-bind=li.Country></span></td><td class=text-center><span ng-bind=li.Telephone></span></td><td class=text-center><span ng-bind=li.Address></span></td><td class=text-center><span ng-bind=li.BusiType1></span></td><td class=text-center><span ng-bind=li.COMPSTATUS2></span></td><td class=text-center><span ng-bind=li.COMPSIZE2></span></td><td class=text-center><span ng-bind=li.PUBLICTYPE2></span></td><td class=text-center><span ng-bind=li.PRIVATETYPE2></span></td><td class=text-center><span ng-bind=li.BRANCHTYPE2></span></td><td class=text-center><span ng-bind=li.ClientGRD></span></td><td class=text-center><span ng-bind=li.OpIncome></span></td><td class=text-center><span ng-bind=li.NetIncome></span></td><td class=text-center><span ng-bind=li.Sales></span></td><td class=text-center><span ng-bind=li.SaleSetDT></span></td></tr></table></div></div></div><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.goData()><i class=\"fa fa-edit\"></i> 선택 정보 적용</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/client/modal/clientscore-edit-modal.html","<style>.table {\r\n    font-size: 13px;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">고객사 스코어 배점 기준</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">1-1. 항목별 배점 기준</strong></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><thead><tr><th class=text-center>배점 항목</th><th class=text-center>항목</th><th class=text-center>1점</th><th class=text-center>2점</th><th class=text-center>3점</th><th class=text-center>4점</th><th class=text-center>5점</th></tr></thead><tbody><tr><td class=text-center rowspan=2>고객정보</td><td class=text-center><b>사업연관성</b></td><td class=text-center>0</td><td class=text-center>1</td><td class=text-center>2</td><td class=text-center>3</td><td class=text-center>4</td></tr><tr><td class=text-center><b>직원수</b></td><td class=text-center>5인 미만</td><td class=text-center>5인 이상</td><td class=text-center>10인 이상</td><td class=text-center>100인 이상</td><td class=text-center>200인 이상</td></tr><tr><td class=text-center rowspan=5>최근 3년간 관련 매출<br>(단위: 만원)</td><td class=text-center><b>교육사업</b></td><td class=text-center>100 미만</td><td class=text-center>100 이상</td><td class=text-center>500 이상</td><td class=text-center>1500 이상</td><td class=text-center>3000 이상</td></tr><tr><td class=text-center><b>KS인증</b></td><td class=text-center>100 미만</td><td class=text-center>100 이상</td><td class=text-center>500 이상</td><td class=text-center>1500 이상</td><td class=text-center>3000 이상</td></tr><tr><td class=text-center><b>국제인증</b></td><td class=text-center>100 미만</td><td class=text-center>100 이상</td><td class=text-center>500 이상</td><td class=text-center>1500 이상</td><td class=text-center>3000 이상</td></tr><tr><td class=text-center><b>에너지기후</b></td><td class=text-center>100 미만</td><td class=text-center>100 이상</td><td class=text-center>500 이상</td><td class=text-center>1500 이상</td><td class=text-center>3000 이상</td></tr><tr><td class=text-center><b>표준정보망</b></td><td class=text-center>100 미만</td><td class=text-center>100 이상</td><td class=text-center>500 이상</td><td class=text-center>1500 이상</td><td class=text-center>3000 이상</td></tr></tbody></table></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">1-2. 스코어 가중치</strong></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><thead><tr><th class=text-center>사업연관성</th><th class=text-center>직원수</th><th class=text-center>교육사업</th><th class=text-center>KS인증</th><th class=text-center>국제인증</th><th class=text-center>에너지기후</th><th class=text-center>표준정보망</th><th class=text-center>합계(%)</th></tr></thead><tbody><tr><td class=text-center>30</td><td class=text-center>20</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>100</td></tr></tbody></table></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">2. 스코어 산정 예시</strong></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><thead><tr><th class=text-center>항목</th><th class=text-center>사업연관성</th><th class=text-center>고객수</th><th class=text-center>교육사업</th><th class=text-center>KS인증</th><th class=text-center>에너지기후</th><th class=text-center>국제인증</th><th class=text-center>표준정보망</th><th class=text-center>MARTSCORE</th></tr></thead><tbody><tr><td class=text-center>데이터</td><td class=text-center>3</td><td class=text-center>10</td><td class=text-center>8,302</td><td class=text-center>200</td><td class=text-center>0</td><td class=text-center>13,00</td><td class=text-center>800</td><td class=text-center></td></tr><tr><td class=text-center>점수</td><td class=text-center>4</td><td class=text-center>3</td><td class=text-center>4</td><td class=text-center>2</td><td class=text-center>1</td><td class=text-center>5</td><td class=text-center>4</td><td class=text-center></td></tr><tr><td class=text-center>가중치</td><td class=text-center>0.30</td><td class=text-center>0.20</td><td class=text-center>0.10</td><td class=text-center>0.10</td><td class=text-center>0.10</td><td class=text-center>0.10</td><td class=text-center>0.05</td><td class=text-center></td></tr><tr><td class=text-center><b>최종 스코어</b></td><td class=text-center><b>1.20</b></td><td class=text-center><b>0.60</b></td><td class=text-center><b>0.40</b></td><td class=text-center><b>0.20</b></td><td class=text-center><b>0.10</b></td><td class=text-center><b>0.50</b></td><td class=text-center><b>0.20</b></td><td class=text-center><b>3.20 (4등급)</b></td></tr><tr><td class=text-center><b>고객사 순위</b></td><td class=text-center><b>121위</b></td><td class=text-center><b>23,121위</b></td><td class=text-center><b>23위</b></td><td class=text-center><b>1,232위</b></td><td class=text-center><b>5,600위</b></td><td class=text-center><b>832위</b></td><td class=text-center><b>2,232위</b></td><td class=text-center><b>252위</b></td></tr></tbody></table></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">3. 사용자 가중치 설정</strong></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><thead><tr><th class=text-center>사업연관성</th><th class=text-center>직원수</th><th class=text-center>교육사업</th><th class=text-center>KS인증</th><th class=text-center>국제인증</th><th class=text-center>에너지기후</th><th class=text-center>표준정보망</th><th class=text-center>합계(%)</th></tr></thead><tbody><tr><td class=text-center>30</td><td class=text-center>20</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>10</td><td class=text-center>100</td></tr></tbody></table></div></div></div></div></div></div><div class=row><div class=pull-right><button class=\"btn btn-default ng-binding\" ng-click=vc.cancel()><i class=\"fa fa-times\">취소</i></button> <button class=\"btn btn-primary ng-binding\" ng-click=vc.save()><i class=\"fa fa-book\">저장</i></button></div></div></div></div>");
$templateCache.put("app/client/modal/ksacust-edit-modal.html","<style>@keyframes flipdown {\r\n    0% {\r\n      opacity: 0;\r\n      transform-origin: top center;\r\n      transform: rotateX(-90deg);\r\n    }\r\n    5% {\r\n      opacity: 1;\r\n    }\r\n    80% {\r\n      transform: rotateX(8deg);\r\n    }\r\n    83% {\r\n      transform: rotateX(6deg);\r\n    }\r\n    92% {\r\n      transform: rotateX(-3deg);\r\n    }\r\n    100% {\r\n      transform-origin: top center;\r\n      transform: rotateX(0deg);\r\n    }\r\n  }\r\n  #sec2{\r\n    -webkit-animation: flipdown .6s ease both;\r\n    animation: flipdown .6s ease both;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div id=CustEditTitle class=\"page-header pull-left\">고객 등록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row id=CustEditSubTitle></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><input id=CustId type=hidden ng-model=vc.data.CustId><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><span style=color:red>* </span><label for=\"\">사업정보</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox1 value=K><label class=form-check-label for=inlineCheckbox1>KS</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox2 value=I><label class=form-check-label for=inlineCheckbox2>ISO</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox3 value=E><label class=form-check-label for=inlineCheckbox3>에너지</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox4 value=L><label class=form-check-label for=inlineCheckbox4>교육</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox5 value=M><label class=form-check-label for=inlineCheckbox5>회원사</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox6 value=Q><label class=form-check-label for=inlineCheckbox6>분임조</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox7 value=B><label class=form-check-label for=inlineCheckbox7>조찬</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfo type=checkbox id=inlineCheckbox8 value=N><label class=form-check-label for=inlineCheckbox8>표준정보망</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input class=form-check-input name=busiInfoEtc type=checkbox id=inlineCheckbox12 onchange=angular.element(this).scope().clickCheckBoxEtc(event) value=기타><label for=\"\">기타</label></div><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-1\"><input type=text class=\"form-control mb5\" id=busiInfoEtc readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 Memo-col-wrap form-layout-inline wrap-col-size-1 type-input-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=비고>비고</label><input class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" type=text ng-model=vc.data.Memo aria-invalid=false></div></div><!-- <div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 Fax-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\">\r\n              <div class=\"form-group form-inline\">\r\n                <label title=\"고객사명\" uib-tooltip=\"주소\">고객사명</label>\r\n                <div class=\"input-group srch_form autocomplete\">\r\n                  <input id=\"autoInput\" placeholder=\"Search\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" type=\"text\" ng-keyup=\"complete(ClientNm)\" name=\"ClientNm\" ng-model=\"ClientNm\">\r\n                  <input class=\"form-control\" ng-model=\"vc.ClientId\" type=\"hidden\">\r\n                  <div id=\"autoInputautocomplete-list\" class=\"autocomplete-items\">\r\n                    <div ng-repeat=\"ClientNm in filteredName\" ng-click=\"fillTextbox(ClientNm)\">\r\n                      {{ClientNm}}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                \r\n              </div>\r\n            </div> --></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">직장정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">마케팅활용동의</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">관리정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 DeptCode-col-wrap form-layout-inline wrap-col-size-3 type-select-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=담당지역본부>담당지역본부</label><select class=form-control ng-change=vc.setDeptSelect(selectedDept) ng-options=\"v.Code as v.CodeValue for v in DeptBox\" ng-model=selectedDept></select></div><!-- <label for=\"deptCode\">담당지역본부</label> --><!-- <select id=\"deptCode\" class=\"form-control\" ng-change=\"vc.setDeptSelect()\" ng-options=\"v as v.CodeValue for v in SelectBox track by v.Code\" ng-model=\"thisSelect\"></select> --></div><!-- <div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\">\r\n                <label>영업담당자</label>\r\n                <select class=\"form-control\" ng-change=\"vc.setSortSelect()\" ng-options=\"v as v.name for v in SelectBox track by v.id\" ng-model=\"thisSelect\"></select>\r\n              </div> --><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ManagerNm-col-wrap form-layout-inline wrap-col-size-3 type-input-col-wrap\"><div class=\"form-group form-inline\"><label uib-tooltip=영업담당자>영업담당자</label><sz-auto-complete code-list=vc.codeManagerList code-model=vc.data.ManagerNm code-key=vc.data.UserId callback=vc.setManagerCode add-top-row=신규등록 add-top-row-callback=vc.addManager change-callback=vc.onChangeManagerNm is-focus=vc.act_ManagerNmFocus init-value=vc.data.ManagerNm class=ng-isolate-scope><div class=auto-complet-wrap><input ng-focus=vc.focusInput($event) ng-change=vc.setChangeValue() ng-model=vc.inputValue ng-keydown=vc.onKeydownEvent($event) ng-disabled=vc.isDisabled type=text ng-blur=vc.focusoutInput($event) class=\"ng-pristine ng-valid ng-not-empty ng-touched\" autocomplete=off aria-invalid=false><div class=sz-autocomplete-item-list ng-show=vc.inputFocus aria-hidden=false><div ng-click=vc.selectTopData() ng-class=\"{\'szac-select\' : vc.selectIdx == -1}\" class=add-top-row role=button tabindex=0><span>신규등록</span></div><!-- ngRepeat: opt in avc.CodeList --></div></div></sz-auto-complete></div></div></div><div id=sec8 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/client/modal/ksacust-merge-modal.html","<div class=modal-content><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>중복고객 통합</div></div></div><!-- /page header --><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><br><p>&nbsp;&nbsp;&nbsp;※ 선택된 항목으로 데이터가 통합되고 선택되지 않는 정보는 삭제됩니다.</p><p>&nbsp;&nbsp;&nbsp;※ 고객 관련 이력은 하나의 데이터로 통합됩니다.</p><br></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><table class=\"table table-hover\" style=\"margin-left: 10px\"><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><!-- <col width=\"\"> --></colgroup><thead><tr><th>항목명</th><th><div class=switch-field><input id=selectedAll_0 type=checkbox ng-model=vc.selectedValue ng-click=vc.selectAll(0) ng-true-value=0><label for=selectedAll_0>전체선택</label></div></th><th><div class=switch-field><input id=selectedAll_1 type=checkbox ng-model=vc.selectedValue ng-click=vc.selectAll(1) ng-true-value=1><label for=selectedAll_1>전체선택</label></div></th><!-- <th>선택값</th> --></tr></thead><tbody><tr ng-repeat=\"li in vc.mapData\" ng-style=\"{\'color\': li.error?\'red\':\'\'}\"><td>{{li.name}}</td><td><div class=switch-field><input id={{li.key}}_0 type=checkbox ng-model=li.selectedValue ng-true-value=0><label for={{li.key}}_0>{{li.data[0]}}</label></div></td><td><div class=switch-field><input id={{li.key}}_1 type=checkbox ng-model=li.selectedValue ng-true-value=1><label for={{li.key}}_1>{{li.data[1]}}</label></div></td><!-- <td >{{ li.selectedValue }}</td> --></tr></tbody></table><div ng-if=hasErrors>정보를 선택하여 주세요</div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.submitClickHandler()><i class=\"fa fa-edit\"></i> 중복고객통합</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/client/tab/client-alarm.html","<div class=\"page page-footable\" ng-controller=\"ClientAlarmCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>조기경보</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-breakfast.html","<div class=\"page page-footable\" ng-controller=\"ClientBreakfastCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>조찬</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-business.html","<div class=\"page page-footable\" ng-controller=\"ClientBusinessCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>사업기회</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.goBusinessOPEdit()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/client/tab/client-customer.html","<div class=\"page page-footable\" ng-controller=\"ClientCustomerCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>고객</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.ksacustEditModal()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/client/tab/client-defaultinfo.html","<style>#power-gauge g.arc {\r\n		fill: steelblue;\r\n	}\r\n\r\n	#power-gauge g.pointer {\r\n		fill: #e85116;\r\n		stroke: #b64011;\r\n	}\r\n	\r\n	#power-gauge g.label text {\r\n		text-anchor: middle;\r\n		font-size: 14px;\r\n		font-weight: bold;\r\n		fill: #666;\r\n	}</style><div class=\"page page-footable\" ng-controller=\"ClientDefaultinfoCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>기본정보</div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">고객사 스코어</strong> <button class=\"btn btn-primary\" ng-click=vc.scoreExplain();>자세히보기</button></div><div class=\"panel-body collapse in\"><div class=row><div id=clientScoreChart class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div id=clientScore></div></div><div id=clientLevelChart class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div id=clientLevel></div></div><div id=clientRankChart class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div id=clientRank></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">매출액/미수금(년)</strong><div id=annualSalesBar></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">매출액(분기)</strong><div id=quaterSalesBar></div></div></div></div></div></div>");
$templateCache.put("app/client/tab/client-education.html","<div class=\"page page-footable\" ng-controller=\"ClientEducationCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>교육</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-energy.html","<div class=\"page page-footable\" ng-controller=\"ClientEnergyCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>에너지</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-history.html","<div class=\"page page-footable\" ng-controller=\"ClientHistoryCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>변경이력</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-iso.html","<div class=\"page page-footable\" ng-controller=\"ClientISOCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>ISO</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-ks.html","<div class=\"page page-footable\" ng-controller=\"ClientKSCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>KS</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-members.html","<div class=\"page page-footable\" ng-controller=\"ClientMembersCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>회원사</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-network.html","<div class=\"page page-footable\" ng-controller=\"ClientNetworkCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>표준정보망</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-quality.html","<div class=\"page page-footable\" ng-controller=\"ClientQualityCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>분임조</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-relate.html","<div class=\"page page-footable\" ng-controller=\"ClientRelateCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>연관사업정보</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table></div>");
$templateCache.put("app/client/tab/client-sales.html","<div class=\"page page-footable\" ng-controller=\"ClientSalesCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>영업일지</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.goBusinessDREdit()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/client/tab/client-support.html","<div class=\"page page-footable\" ng-controller=\"ClientSupportCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=page-header>지원사업</div><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><div class=pull-right><button class=\"btn btn-primary ng-binding\" ng-click=vc.supportBusinessModal()><i class=\"fa fa-edit\"></i>등록</button></div></div>");
$templateCache.put("app/counsel/modal/counsel-record-modal.html","<div class=modal-content ng-controller=\"CounselRecordModalCtrl as modalCtrl\"><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">이전상담내역</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-md-12><div class=tile><!-- \r\n          <div class=\"tile-header dvd dvd-btm b-l5\">\r\n            <h4 class=\"custom-font\">\r\n              <strong>이전상담내역</strong>\r\n            </h4>\r\n            <div class=\"pull-right\">\r\n              <a href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n              </a>\r\n            </div>\r\n          </div>\r\n          --><div class=tile-body><div ng-repeat=\"li in modalCtrl.lists\"><div class=row><div class=col-lg-2><div class=form-group><label>상담회차</label><input type=text class=form-control ng-model=li.CounselRound_ readonly></div></div><div class=col-lg-4><div class=form-group><label>상담사</label><input type=text class=form-control ng-model=li.CounselUser_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=li.CounselField_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=li.HopeDuty_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow><div class=form-group><label>희망직무기타</label><input type=text class=form-control ng-model=li.HopeDutyEtc readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=li.HopeLoc_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담분야</label><input type=text class=form-control ng-model=li.CounselField2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyListShow2><div class=form-group><label>희망직무</label><input type=text class=form-control ng-model=li.HopeDuty2_ readonly></div></div><div class=col-lg-2 ng-show=HopeDutyEtcShow2><div class=form-group><label>희망직무기타</label><input type=text class=form-control ng-model=li.HopeDutyEtc2 readonly></div></div><div class=col-lg-2 ng-show=HopeLocListShow2><div class=form-group><label>취업희망지역</label><input type=text class=form-control ng-model=li.HopeLoc2_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상담일자</label><input type=text class=form-control ng-model=li.CounselDate readonly></div></div><div class=col-lg-4><div class=form-group><label>상담시간</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeFromHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeFromMin readonly></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeToHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselTimeToMin readonly></div></div></div></div><div class=col-lg-2><div class=form-group><label>다음상담희망일시</label><input type=text class=form-control ng-model=li.CounselDateHopeNext readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><input type=text class=form-control ng-model=li.CounselDateHopeNextHour readonly></div><div class=\"input-group-addon input_group_split\">:</div><div class=input-group><input type=text class=form-control ng-model=li.CounselDateHopeNextMin readonly></div></div></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>제목</label><input type=text class=form-control ng-model=li.Title readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>상담내용</label><textarea class=form-control ng-model=li.Content rows=5 readonly></textarea></div></div></div><div class=row><div class=col-lg-12 style=\"padding: 15px 15px 30px 15px\"><div style=\"height: 1px; background-color: #ddd\"></div></div></div></div><div ng-show=showListEmpty><div class=row><div class=col-lg-12>등록된 데이터가 없습니다.</div></div></div></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-primary mb-10\" ng-click=\"modalCtrl.ok()\">\r\n      <i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}\r\n    </button>--> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" onclick=self.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div></div>");
$templateCache.put("app/counsel/modal/schedule-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">일정정보</h3></div><div class=\"modal-body ng-scope\"><div class=row><!-- 성명 --><div class=col-lg-6><div class=form-group><label class=txt_req>성명</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=성명 ng-value=modalCtrl.data.CustNm> <input type=hidden ng-value=modalCtrl.data.CustArmyId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=modalCtrl.showModalCustInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=modalCtrl.clearModalCustInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-6><div class=form-group><label>군번</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=군번 ng-value=modalCtrl.data.ArmyNo></div></div></div></div><div class=row><!-- 상담사 --><div class=col-lg-6><div class=form-group><label class=txt_req>상담사</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=상담사 ng-value=modalCtrl.data.SchUserId_> <input type=hidden ng-value=modalCtrl.data.SchUserId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=modalCtrl.showModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=modalCtrl.clearModalUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><!-- 일정 시작/종료일시 --><!-- 시작일 --><div class=col-lg-4><div class=form-group><label class=txt_req>시작일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFromDate ng-change=\"modalCtrl.data.StartYMD = (dtFromDate | date:\r\n            \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일자> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- 시작시간 --><div class=col-lg-4><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=modalCtrl.FromHourList callback=modalCtrl.onSelectFromList></common-code></div><div class=\"input-group-addon input_group_split\">&nbsp;:&nbsp;</div><div class=input-group><common-code param-data=modalCtrl.FromMinList callback=modalCtrl.onSelectFromList></common-code></div></div></div></div></div><div class=row><!-- 종료일 --><div class=col-lg-4><div class=form-group><label class=txt_req>종료일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtToDate ng-change=\"modalCtrl.data.EndYMD = (dtToDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptons current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일자> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- 종료시간 --><div class=col-lg-4><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=modalCtrl.ToHourList callback=modalCtrl.onSelectToList></common-code></div><div class=\"input-group-addon input_group_split\">&nbsp;:&nbsp;</div><div class=input-group><common-code param-data=modalCtrl.ToMinList callback=modalCtrl.onSelectToList></common-code></div></div></div></div></div><div class=row><!--메모--><div class=col-lg-12><div class=form-group><label>메모</label><input type=text class=form-control ng-model=modalCtrl.data.Title placeholder=메모></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-lightred mb-10\" ng-click=modalCtrl.del() ng-show=\"modalCtrl.data.SchId != \'\'\"><i class=\"fa fa-trash-o\"></i> 삭제</button> <button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-save\"></i> 저장</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("app/dashboard/modal/dashboard-img-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\"><!-- 사용자 {{ \'Menu.SEARCH\' | translate }} --></h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><img ng-src={{modalCtrl.src}}></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.close()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("app/dashboard/modal/mail-security-guide-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\"><!-- 사용자 {{ \'Menu.SEARCH\' | translate }} --></h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><img src=/assets/mailSecGuide.png></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.close()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("app/dashboard/modal/remind-alarm-list-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">리마인드 알림</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><colgroup><col width=5%><col width=10%><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=text-center>구분</th><th class=text-center>분류</th><th class=text-center>내용</th><th class=text-center>고객사</th><th class=text-center>고객</th></tr></thead><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center ng-click=\"vc.goDetail(li.RelateDataId, li.RelateTableNm)\"><span ng-bind=li.RemindType></span></td><td class=text-center ng-click=\"vc.goDetail(li.RelateDataId, li.RelateTableNm)\"><span ng-bind=li.RemindTitle></span></td><td class=text-center ng-click=\"vc.goDetail(li.RelateDataId, li.RelateTableNm)\"><span ng-bind=li.RemindNm></span></td><td class=text-center ng-click=\"vc.goDetail(li.RelateDataId, li.RelateTableNm)\"><span ng-bind=li.ClientNm></span></td><td class=text-center ng-click=\"vc.goDetail(li.RelateDataId, li.RelateTableNm)\"><span ng-bind=li.EncryptNms></span></td></tr></table></div></div></div><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10 pull-left\" ng-click=\"vc.closePopupToday(\'remindAlarm\')\"><span>오늘 하루 그만보기</span></button> <button class=\"btn btn-default mb-10\" ng-click=vc.delData()><span>삭제</span></button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><span>완료</span></button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><span>닫기</span></button></div></div>");
$templateCache.put("app/dashboard/modal/unit-counsel-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=col-lg-6><h3 class=\"modal-title custom-font\">부대별 상담현황</h3></div><div class=col-lg-6><div class=pull-right><label class=\"checkbox checkbox-custom checkbox-custom-sm inline-block mr-5\"><input type=checkbox class=styled ng-click=modalCtrl.todayClose()><i></i> 오늘 그만보기</label><button class=\"btn btn-primary mr-5\" ng-click=modalCtrl.goDetail()><i class=\"fa fa-search\"></i> 자세히보기</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 취소</button></div></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=col-lg-6><div class=form-group><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateFrom ng-change=\"modalCtrl.CounselDateFrom = (dtCounselDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담등록 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtCounselDateTo ng-change=\"modalCtrl.CounselDateTo = (dtCounselDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일등록 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-2><div class=form-group><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button=\"\" ng-click=modalCtrl.getSearch()><i class=\"fa fa-search\"></i> 조회</button></div></div></div></form></div><!-- //row --><div class=\"modal-body ng-scope\"><div class=\"row row_pad\"><div class=col-lg-12><label>부대별 상담현황</label><div class=\"panel panel-default\"><table class=\"table tableborder\"><colgroup><col width=\"\"><col width=20%><col width=11%><col width=11%><col width=11%><col width=11%><col width=11%><col width=11%></colgroup><thead><tr><th colspan=2>구분</th><th>목표</th><th>상담완료</th><th>진도율(%)</th><th>1회차</th><th>2회차</th><th>3회차</th></tr></thead><tbody><tr ng-repeat=\"li in modalCtrl.listUnit\"><td class=text-center rowspan={{li.Gubun1_rowspan}} colspan={{li.Gubun1_colspan}} ng-show={{li.Gubun1_show}}><span ng-bind=li.Gubun1></span></td><td class=text-center ng-show={{li.Gubun2_show}}><span ng-bind=li.Gubun2></span></td><td class=text-center rowspan={{li.Goal_rowspan}} ng-show={{li.Goal_show}}><span ng-bind=li.Goal></span></td><td class=text-center><span ng-bind=li.CompCnt></span></td><td class=text-center rowspan={{li.ProgressRate_rowspan}} ng-show={{li.ProgressRate_show}}><span ng-bind=li.ProgressRate></span></td><td class=text-center><span ng-bind=li.Round1Cnt></span></td><td class=text-center><span ng-bind=li.Round2Cnt></span></td><td class=text-center><span ng-bind=li.Round3Cnt></span></td></tr></tbody></table></div></div></div></div><!-- //modal-body --></div>");
$templateCache.put("app/dashboard/stats/stats.html","<div class=\"col-lg-3 col-md-6\"><div class=\"panel panel-{{ states.colour }}\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-{{ states.type }} fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ states.number }}</div><div>{{ states.comments }}</div></div></div></div><a ui-sref=dashboard.home><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div>");
$templateCache.put("app/mentoring/modal/apply-type-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">회원{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.searchFieldType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getMentoringApplyArmyList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div></form><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>휴대폰</th><th data-toggle=true class=text-center>군별</th><th data-toggle=true class=text-center>소속(사,여단급)</th><th data-toggle=true class=text-center>동아리팀</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.MentoringApplyArmyList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.MemberNm></span></td><td class=text-center><span ng-bind=li.ArmyNo></span></td><td class=text-center><span ng-bind=li.ArmyId></span></td><td class=text-center ng-if=\"li.Mobile.length == 12\"><span ng-bind=\"li.Mobile.substr(0,3) + \'-\' + li.Mobile.substr(4,4) + \'-\' + li.Mobile.substr(8,4)\"></span></td><td class=text-center ng-if=\"li.Mobile.length == 11\"><span ng-bind=\"li.Mobile.substr(0,3) + \'-\' + li.Mobile.substr(3,4) + \'-\' + li.Mobile.substr(7,4)\"></span></td><td class=text-center ng-if=\"li.Mobile.length != 11 && li.Mobile.length != 12\"><span ng-bind=li.Mobile></span></td><td class=text-center><span ng-bind=li.ArmyType_></span></td><td class=text-center><span ng-bind=li.PermStat></span></td><td class=text-center><span ng-bind=li.ClubNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getMentoringApplyArmyList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-primary mb-10\" ng-click=\"modalCtrl.ok()\">\r\n        <i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}\r\n      </button> --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/mentoring/modal/club-name-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">동아리팀{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.searchFieldType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getMentoringClubList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div></form><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>동아리팀</th><th data-toggle=true class=text-center>아이템분야</th><th data-toggle=true class=text-center>진행상태</th><th data-toggle=true class=text-center>멘토</th><th data-toggle=true class=text-center>팀장</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.MentoringClubList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.ClubNm></span></td><td class=text-center><span ng-bind=li.ItemField_></span></td><td class=text-center><span ng-bind=li.Progress_></span></td><td class=text-center><span ng-bind=li.MentoUser_></span></td><td class=text-center><span ng-bind=li.LeaderNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getMentoringClubList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-primary mb-10\" ng-click=\"modalCtrl.ok()\">\r\n        <i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}\r\n      </button> --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/mentoring/modal/mentoringrecord-print-modal.html","<div class=modal-content ng-controller=\"MentoringrecordPrintModalCtrl as modalCtrl\"><div class=modal-body><table class=\"table tableborder\" style=\"border-top: 1px solid #ddd\"><colgroup><!-- <col style=\"width: auto\" /> --><col width=13%><col width=12%><col width=13%><col width=12%><col width=13%><col width=12%><col width=13%><col width=12%></colgroup><thead><tr><th colspan=8>멘토링 보고서</th></tr></thead><tbody><tr><th>동아리팀</th><td colspan=7>{{modalCtrl.data.ClubNm}}</td></tr><tr><th>멘토</th><td>{{modalCtrl.data.MentoUser_}}</td><th>상담회차</th><td>{{modalCtrl.data.MentoringRound_}}</td><th>상담방법</th><td>{{modalCtrl.data.MentoringMethod_}}</td><th>진행상태</th><td>{{modalCtrl.data.Progress_}}</td></tr><tr><th>상담일시</th><td colspan=3>{{modalCtrl.data.MentoringDate}} {{modalCtrl.data.MentoringTimeFromHour}}:{{modalCtrl.data.MentoringTimeFromMin}} ~ {{modalCtrl.data.MentoringTimeToHour}}:{{modalCtrl.data.MentoringTimeToMin}}</td><th>다음상담희망일시</th><td colspan=3>{{modalCtrl.data.MentoringDateHopeNext}} {{modalCtrl.data.MentoringDateHopeNextHour}}:{{modalCtrl.data.MentoringDateHopeNextMin}}</td></tr></tbody></table><br><table class=\"table tableborder\" style=\"border-top: 1px solid #ddd\"><thead><tr><th>{{modalCtrl.data.Title}}</th></tr></thead><tbody><tr><td>{{modalCtrl.data.Content}}</td></tr><tr><td><div class=col-xs-6 ng-repeat=\"img in modalCtrl.data.uploadFileList\"><img src={{img.link}} width=100%></div></td></tr></tbody></table></div><div class=\"modal-footer ng-scope no-Print\"><button type=button class=\"btn btn-blue\" ng-click=modalCtrl.print()>출력</button> <button type=button class=\"btn btn-sec2\" ng-click=modalCtrl.cancel()>닫기</button></div></div>");
$templateCache.put("app/mentoring/modal/mentoringschedule-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">일정정보</h3></div><div class=\"modal-body ng-scope\"><div class=row><!-- 성명 --><div class=col-lg-6><div class=form-group><label class=txt_req>동아리팀</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=동아리팀 ng-value=modalCtrl.data.ClubNm> <input type=hidden ng-value=modalCtrl.data.ClubId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=modalCtrl.showModalClubInfo()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=modalCtrl.clearModalClubInfo()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><!-- 상담사 --><div class=col-lg-6><div class=form-group><label class=txt_req>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=modalCtrl.data.MentoUser_> <input type=hidden ng-value=modalCtrl.data.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=modalCtrl.showModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=modalCtrl.clearModalUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><!-- 일정 시작/종료일시 --><!-- 시작일 --><div class=col-lg-4><div class=form-group><label class=txt_req>시작일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtFromDate ng-change=\"modalCtrl.data.StartYMD = (dtFromDate | date:\r\n            \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일자> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- 시작시간 --><div class=col-lg-4><div class=form-group><label>&nbsp;</label><div class=input-group><div class=input-group><common-code param-data=modalCtrl.FromHourList callback=modalCtrl.onSelectFromList></common-code></div><div class=\"input-group-addon input_group_split\">&nbsp;:&nbsp;</div><div class=input-group><common-code param-data=modalCtrl.FromMinList callback=modalCtrl.onSelectFromList></common-code></div></div></div></div></div><!-- 종료일 --><!-- <div class=\"row\">\r\n      <div class=\"col-lg-4\">\r\n        <div class=\"form-group\">\r\n          <label class=\"txt_req\">종료일시</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              uib-datepicker-popup=\"{{format}}\"\r\n              ng-model=\"dtToDate\"\r\n              ng-change=\"modalCtrl.data.EndYMD = (dtToDate | date: \'yyyy-MM-dd\')\"\r\n              is-open=\"opened\"\r\n              datepicker-options=\"dateOptons\"\r\n              current-text=\"오늘\"\r\n              clear-text=\"취소\"\r\n              close-text=\"닫기\"\r\n              placeholder=\"종료일자\"\r\n            />\r\n            <span class=\"input-group-btn\">\r\n              <button\r\n                type=\"button\"\r\n                class=\"btn btn-default\"\r\n                ng-click=\"open($event)\"\r\n              >\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div> --><!-- 종료시간 --><!-- <div class=\"col-lg-4\">\r\n        <div class=\"form-group\">\r\n          <label>&nbsp;</label>\r\n          <div class=\"input-group\">\r\n            <div class=\"input-group\">\r\n              <common-code\r\n                param-data=\"modalCtrl.ToHourList\"\r\n                callback=\"modalCtrl.onSelectToList\"\r\n              ></common-code>\r\n            </div>\r\n            <div class=\"input-group-addon input_group_split\">&nbsp;:&nbsp;</div>\r\n            <div class=\"input-group\">\r\n              <common-code\r\n                param-data=\"modalCtrl.ToMinList\"\r\n                callback=\"modalCtrl.onSelectToList\"\r\n              ></common-code>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><!--메모--><!-- <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"form-group\">\r\n          <label>메모</label>\r\n          <input\r\n            type=\"text\"\r\n            class=\"form-control\"\r\n            ng-model=\"modalCtrl.data.Title\"\r\n            placeholder=\"메모\"\r\n          />\r\n        </div>\r\n      </div>\r\n    </div> --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-lightred mb-10\" ng-click=modalCtrl.del() ng-show=\"modalCtrl.data.SchId != \'\'\"><i class=\"fa fa-trash-o\"></i> 삭제</button> <button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-save\"></i> 저장</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("app/mentoring/state/mentoringstate-list.html","<div class=\"page page-footable\" ng-controller=\"MentoringStateListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>참여자 현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>통계</a></li><li><a>참여자 현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><!-- <div class=\"pull-right\">\r\n                  <a href tile-control-toggle-hide>\r\n                    <i class=\"fa fa-minus fa-lg\"></i>\r\n                  </a>\r\n                </div> --></div><div class=tile-body><div class=row><div class=col-lg-2><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.srch.TenantNm readonly></div></div><div class=col-lg-2><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onMentoringAreaListSelected() ng-model=vc.srch.MentoringAreaObj ng-options=\"opt.CodeValue for opt in vc.MentoringAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{\'Menu.SELECT\' | translate}}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.srch.PermStat2 placeholder=소속부대 ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>성명</label><input type=text class=form-control ng-model=vc.srch.ArmyNm placeholder=성명></div></div><div class=col-lg-4><div class=form-group><label>군번</label><input type=text class=form-control ng-model=vc.srch.ArmyNo placeholder=군번></div></div><div class=col-lg-4><div class=form-group><label>소속(사,여단급)</label><input type=text class=form-control ng-model=vc.srch.PermStat placeholder=소속(사,여단급) ng-disabled=vc.disabledArea></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>계급</label><common-code param-data=vc.ArmyClassList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>동아리팀</label><input type=text class=form-control ng-model=vc.srch.ClubNm placeholder=동아리팀></div></div><div class=col-lg-4><div class=form-group><label>아이템</label><common-code param-data=vc.ItemFieldList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>진행상태</label><common-code param-data=vc.ProgressList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>멘토</label><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control placeholder=멘토 ng-value=vc.srch.MentoUser_> <input type=hidden ng-value=vc.srch.MentoUser> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.showModalMentoUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearModalMentoUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=form-group><label>신청일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtApplyDateFrom ng-change=\"vc.srch.ApplyDateFrom = (dtApplyDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"신청일 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtApplyDateTo ng-change=\"vc.srch.ApplyDateTo = (dtApplyDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"신청일 종료\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}} &nbsp;<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div style=\"overflow-x:auto; word-break: keep-all; white-space: nowrap\"><table id=searchTextResults class=\"table table-custom table-striped\"><colgroup><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col><col></colgroup><thead><tr><th class=text-center>번호</th><th class=text-center ng-click=\"vc.setSortColumn(\'ApplyDate\',\'Y\')\">신청일시 <span><i class=\"{{vc.setSortDirect(\'ApplyDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'YearNum\',\'Y\')\">년도/차수 <span><i class=\"{{vc.setSortDirect(\'YearNum\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubNm\',\'Y\')\">동아리명 <span><i class=\"{{vc.setSortDirect(\'ClubNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ClubRole\',\'Y\')\">팀장/팀원 <span><i class=\"{{vc.setSortDirect(\'ClubRole\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNm\',\'Y\')\">성명 <span><i class=\"{{vc.setSortDirect(\'ArmyNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyClass\',\'Y\')\">계급 <span><i class=\"{{vc.setSortDirect(\'ArmyClass\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'PermStat\',\'Y\')\">소속(사·여단급) <span><i class=\"{{vc.setSortDirect(\'PermStat\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyNo\',\'Y\')\">군번 <span><i class=\"{{vc.setSortDirect(\'ArmyNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'InArmyDate\',\'Y\')\">임관일 <span><i class=\"{{vc.setSortDirect(\'InArmyDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyTerm\',\'Y\')\">복무기간 <span><i class=\"{{vc.setSortDirect(\'ArmyTerm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'OutArmyDate\',\'Y\')\">전역일 <span><i class=\"{{vc.setSortDirect(\'OutArmyDate\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ArmyTerm\',\'Y\')\">복무구분 <span><i class=\"{{vc.setSortDirect(\'ArmyTerm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringArea\',\'Y\')\">권역 <span><i class=\"{{vc.setSortDirect(\'MentoringArea\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoUser_\',\'Y\')\">멘토 <span><i class=\"{{vc.setSortDirect(\'MentoUser_\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ItemField\',\'Y\')\">아이템 <span><i class=\"{{vc.setSortDirect(\'ItemField\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Age\',\'Y\')\">연령 <span><i class=\"{{vc.setSortDirect(\'Age\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Sex\',\'Y\')\">성별 <span><i class=\"{{vc.setSortDirect(\'Sex\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Mobile\',\'Y\')\">연락처 <span><i class=\"{{vc.setSortDirect(\'Mobile\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'ResRegNo\',\'Y\')\">생년월일 <span><i class=\"{{vc.setSortDirect(\'ResRegNo\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Spec_\',\'Y\')\">병과 <span><i class=\"{{vc.setSortDirect(\'Spec_\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Email\',\'Y\')\">이메일 <span><i class=\"{{vc.setSortDirect(\'Email\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'SchNm\',\'Y\')\">최종학교 <span><i class=\"{{vc.setSortDirect(\'SchNm\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Major\',\'Y\')\">전공 <span><i class=\"{{vc.setSortDirect(\'Major\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Addr\',\'Y\')\">주소 <span><i class=\"{{vc.setSortDirect(\'Addr\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'SchLoc_\',\'Y\')\">학교소재지 <span><i class=\"{{vc.setSortDirect(\'SchLoc\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Progress\',\'Y\')\">진행상태 <span><i class=\"{{vc.setSortDirect(\'Progress\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'MentoringRound\',\'Y\')\">상담회차 <span><i class=\"{{vc.setSortDirect(\'MentoringRound\')}} ml-5\"></i></span></th><th class=text-center ng-click=\"vc.setSortColumn(\'Contest_\',\'Y\')\">창업경진대회 <span><i class=\"{{vc.setSortDirect(\'Contest_\')}} ml-5\"></i></span></th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=29 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center>{{(vc.totalItems - $index) - ((vc.currentPage - 1) * vc.viewSize)}}</td><td class=text-center my-directive><span ng-bind=li.ApplyDate></span></td><td class=text-center my-directive><span ng-bind=li.YearNum></span></td><td class=text-center my-directive><span ng-bind=li.ClubNm></span></td><td class=text-center my-directive><span ng-bind=li.ClubRole_></span></td><td class=text-center my-directive><span ng-bind=li.ArmyNm></span></td><td class=text-center my-directive><span ng-bind=li.ArmyClass_></span></td><td class=text-center my-directive><span ng-bind=li.PermStat></span></td><td class=text-center my-directive><span ng-bind=li.ArmyNo></span></td><td class=text-center my-directive><span ng-bind=li.InArmyDate></span></td><td class=text-center my-directive><span ng-bind=li.ArmyTerm></span></td><td class=text-center my-directive><span ng-bind=li.OutArmyDate></span></td><td class=text-center my-directive><span ng-bind=li.TermGubun></span></td><td class=text-center my-directive><span ng-bind=li.MentoringArea></span></td><td class=text-center my-directive><span ng-bind=li.MentoUser_></span></td><td class=text-center my-directive><span ng-bind=li.ItemField_></span></td><td class=text-center my-directive><span ng-bind=li.Age></span></td><td class=text-center my-directive><span ng-bind=li.Sex></span></td><td class=text-center my-directive><span ng-bind=li.Mobile></span></td><td class=text-center my-directive><span ng-bind=li.ResRegNo></span></td><td class=text-center my-directive><span ng-bind=li.Spec_></span></td><td class=text-center my-directive><span ng-bind=li.Email></span></td><td class=text-center my-directive><span ng-bind=li.SchNm></span></td><td class=text-center my-directive><span ng-bind=li.MajorName></span></td><td class=text-center my-directive><span ng-bind=li.Addr></span></td><td class=text-center my-directive><span ng-bind=li.SchLoc_></span></td><td class=text-center my-directive><span ng-bind=li.Progress_></span></td><td class=text-center my-directive><span ng-bind=li.MentoringRound></span></td><td class=text-center my-directive><span ng-bind=li.Contest_></span></td></tr></tbody><tfoot><tr><td colspan=29 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging ng-hide=\"vc.totalItems == 0\"><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/state/mentoringstate-summary.html","<div class=\"page page-footable\" ng-controller=\"MentoringStateSummaryCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>현황판</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>통계</a></li><li><a>현황판</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getData()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- <div class=\"tile-header dvd dvd-btm b-l5\">\r\n                <h4 class=\"custom-font\">\r\n                  <strong style=\"letter-spacing: 0.5px\"\r\n                    >{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong\r\n                  >\r\n                </h4>\r\n              </div> --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>기준일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDate ng-change=\"vc.srch.Date = (dtDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=기준일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-8><div class=pull-right><div>&nbsp;</div><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getData()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row style=\"text-align: center\"><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">종합 현황(금년 1월 1일 ~ 기준일)</p><p class=text-md>목표: {{vc.data1.TargetCnt}}팀</p><p class=text-md>참여팀: {{vc.data1.RegCnt}}팀({{vc.data1.RegRatio}}%)</p><p class=text-md>종료팀: {{vc.data1.EndCnt}}팀({{vc.data1.EndRatio}}%)</p></div></div></div></div></div><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">위탁사 현황(금년 1월 1일 ~ 기준일)</p><p class=text-md ng-repeat=\"li in vc.data2\">{{li.AreaNm}}: 참여 {{li.RegCnt}}팀({{li.RegRatio}}%) / 종료 {{li.EndCnt}}팀({{li.EndRatio}}%)</p></div></div></div></div></div><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">각군 종료팀 현황(금년 1월 1일 ~ 기준일)</p><p class=text-sm>육군: 목표 {{vc.data3.GoalArmy}}팀 / 종료 {{vc.data3.EndArmy}}팀({{vc.data3.EndRatioArmy}}%) / 참여 {{vc.data3.EndArmy+vc.data3.IngArmy}}팀({{vc.data3.PrtcpRatioArmy}}%)</p><p class=text-sm>해군: 목표 {{vc.data3.GoalNavy}}팀 / 종료 {{vc.data3.EndNavy}}팀({{vc.data3.EndRatioNavy}}%) / 참여 {{vc.data3.EndNavy+vc.data3.IngNavy}}팀({{vc.data3.PrtcpRatioNavy}}%)</p><p class=text-sm>공군: 목표 {{vc.data3.GoalAirforce}}팀 / 종료 {{vc.data3.EndAirforce}}팀({{vc.data3.EndRatioAirforce}}%) / 참여 {{vc.data3.EndAirforce+vc.data3.IngAirforce}}팀({{vc.data3.PrtcpRatioAirforce}}%)</p><p class=text-sm>해병대: 목표 {{vc.data3.GoalMarine}}팀 / 종료 {{vc.data3.EndMarine}}팀({{vc.data3.EndRatioMarine}}%) / 참여 {{vc.data3.EndMarine+vc.data3.IngMarine}}팀({{vc.data3.PrtcpRatioMarine}}%)</p></div></div></div></div></div></div><br><div class=row style=\"text-align: center\"><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">진행팀 현황(금년 1월 1일 ~ 기준일)</p><p class=text-sm ng-repeat=\"li in vc.data4\">{{li.AreaNm}} : 육군 {{li.CntArmy}}팀 / 해군 {{li.CntNavy}}팀 / 공군 {{li.CntAirforce}}팀 / 해병대 {{li.CntMarine}}팀</p></div></div></div></div></div><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">종료팀 현황(금주)</p><p class=text-sm ng-repeat=\"li in vc.data5\">{{li.AreaNm}} : 육군 {{li.CntArmy}}팀 / 해군 {{li.CntNavy}}팀 / 공군 {{li.CntAirforce}}팀 / 해병대 {{li.CntMarine}}팀</p></div></div></div></div></div><div class=col-lg-4><div class=card><div class=bg-slategray style=\"height: 165px; padding: 15px\"><div class=row><div class=col-xs-12><p class=\"text-lg text-strong\">일정 현황(차주)</p><p class=text-sm ng-repeat=\"li in vc.data6\">{{li.AreaNm}} : 육군 {{li.CntArmy}}팀 / 해군 {{li.CntNavy}}팀 / 공군 {{li.CntAirforce}}팀 / 해병대 {{li.CntMarine}}팀</p></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/mentoring/state/mentoringstate-total.html","<div class=\"page page-footable\" ng-controller=\"MentoringStateTotalCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>종합현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>창업멘토링</a></li><li><a>통계</a></li><li><a>종합현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getData()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- <div class=\"tile-header dvd dvd-btm b-l5\">\r\n              <h4 class=\"custom-font\">\r\n                <strong style=\"letter-spacing: 0.5px\"\r\n                  >{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong\r\n                >\r\n              </h4>\r\n            </div> --><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>기간</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDateFrom ng-change=\"vc.srch.DateFrom = (dtDateFrom | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"기간 시작일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDateTo ng-change=\"vc.srch.DateTo = (dtDateTo | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"기간 종료일\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>기준일</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtDate ng-change=\"vc.srch.Date = (dtDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=기준일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=pull-right><div>&nbsp;</div><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getData()><i class=\"fa fa-search\"></i> 조회</button> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-md-12><div class=tile><!-- <div class=\"tile-header dvd dvd-btm b-l5\">\r\n            <h4 class=\"custom-font\">\r\n              <strong>총괄진행현황/진도율</strong>\r\n            </h4>\r\n            <div class=\"pull-right\">\r\n              <a href tile-control-toggle>\r\n                <i class=\"fa fa-minus fa-lg\"></i>\r\n              </a>\r\n            </div>\r\n          </div> --><div class=tile-body><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>1. 진행팀 현황</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr ng-repeat=\"li in vc.data1_2 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=li.PrtcpCntArmy></span></td><td><span ng-bind=li.PrtcpCntNavy></span></td><td><span ng-bind=li.PrtcpCntAirforce></span></td><td><span ng-bind=li.PrtcpCntMarine></span></td><td><span ng-bind=li.PrtcpCntTotal></span></td></tr><tr><td>합계</td><td><span ng-bind=vc.data1_3.SumPrtcpCntArmy></span></td><td><span ng-bind=vc.data1_3.SumPrtcpCntNavy></span></td><td><span ng-bind=vc.data1_3.SumPrtcpCntAirforce></span></td><td><span ng-bind=vc.data1_3.SumPrtcpCntMarine></span></td><td><span ng-bind=vc.data1_3.SumPrtcpCntTotal></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>2. 신청팀 현황</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr ng-repeat=\"li in vc.data1_2 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=li.ApplyCntArmy></span></td><td><span ng-bind=li.ApplyCntNavy></span></td><td><span ng-bind=li.ApplyCntAirforce></span></td><td><span ng-bind=li.ApplyCntMarine></span></td><td><span ng-bind=li.ApplyCntTotal></span></td></tr><tr><td>합계</td><td><span ng-bind=vc.data1_3.SumApplyCntArmy></span></td><td><span ng-bind=vc.data1_3.SumApplyCntNavy></span></td><td><span ng-bind=vc.data1_3.SumApplyCntAirforce></span></td><td><span ng-bind=vc.data1_3.SumApplyCntMarine></span></td><td><span ng-bind=vc.data1_3.SumApplyCntTotal></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>3. 참여팀 현황 (종료팀 + 진행팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr ng-repeat=\"li in vc.data1_2 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=\"li.PrtcpCntArmy + li.EndCntArmy\"></span></td><td><span ng-bind=\"li.PrtcpCntNavy + li.EndCntNavy\"></span></td><td><span ng-bind=\"li.PrtcpCntAirforce + li.EndCntAirforce\"></span></td><td><span ng-bind=\"li.PrtcpCntMarine + li.EndCntMarine\"></span></td><td><span ng-bind=\"li.PrtcpCntTotal + li.EndCntTotal\"></span></td></tr><tr><td>합계</td><td><span ng-bind=\"vc.data1_3.SumPrtcpCntArmy + vc.data1_1.EndCntArmy\"></span></td><td><span ng-bind=\"vc.data1_3.SumPrtcpCntNavy + vc.data1_1.EndCntNavy\"></span></td><td><span ng-bind=\"vc.data1_3.SumPrtcpCntAirforce + vc.data1_1.EndCntAirforce\"></span></td><td><span ng-bind=\"vc.data1_3.SumPrtcpCntMarine + vc.data1_1.EndCntMarine\"></span></td><td><span ng-bind=\"vc.data1_3.SumPrtcpCntTotal + vc.data1_1.EndCntTotal\"></span></td></tr><tr><td>실시율</td><td><span ng-bind=\"vc.data1_1.RatioArmy + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioNavy + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioAirforce + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioMarine + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioTotal + \'%\'\"></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>4. 위탁사 현황 (종료팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr><th>목표</th><th><span ng-bind=vc.data1_1.TargetArmy></span></th><th><span ng-bind=vc.data1_1.TargetNavy><th><span ng-bind=vc.data1_1.TargetAirforce><th><span ng-bind=vc.data1_1.TargetMarine></span></th><th><span ng-bind=vc.data1_1.TargetTotal></span></th></span></th></span></th></tr><tr></tr><tr ng-repeat=\"li in vc.data1_2 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=li.EndCntArmy></span></td><td><span ng-bind=li.EndCntNavy></span></td><td><span ng-bind=li.EndCntAirforce></span></td><td><span ng-bind=li.EndCntMarine></span></td><td><span ng-bind=li.EndCntTotal></span></td></tr><tr><td>합계</td><td><span ng-bind=vc.data1_1.EndCntArmy></span></td><td><span ng-bind=vc.data1_1.EndCntNavy></span></td><td><span ng-bind=vc.data1_1.EndCntAirforce></span></td><td><span ng-bind=vc.data1_1.EndCntMarine></span></td><td><span ng-bind=vc.data1_1.EndCntTotal></span></td></tr><tr><td>실시율</td><td><span ng-bind=\"vc.data1_1.RatioEndArmy + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioEndNavy + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioEndAirforce + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioEndMarine + \'%\'\"></span></td><td><span ng-bind=\"vc.data1_1.RatioEndTotal + \'%\'\"></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>5. 종료팀 현황 (금주)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr ng-repeat=\"li in vc.data2 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=li.EndCntArmy></span></td><td><span ng-bind=li.EndCntNavy></span></td><td><span ng-bind=li.EndCntAirforce></span></td><td><span ng-bind=li.EndCntMarine></span></td><td><span ng-bind=li.EndCntTotal></span></td></tr><tr><td>합계</td><td><span ng-bind=vc.data2_2.SumEndCntArmy></span></td><td><span ng-bind=vc.data2_2.SumEndCntNavy></span></td><td><span ng-bind=vc.data2_2.SumEndCntAirforce></span></td><td><span ng-bind=vc.data2_2.SumEndCntMarine></span></td><td><span ng-bind=vc.data2_2.SumEndCntTotal></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>6. 일정 현황 (차주)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=17%><col width=17%><col width=17%><col width=17%><col width=17%></colgroup><tr><th>구분</th><th>육군</th><th>해군</th><th>공군</th><th>해병대</th><th>총계</th></tr><tr ng-repeat=\"li in vc.data3 track by $index\"><td><span ng-bind=li.AreaNm></span></td><td><span ng-bind=li.CntArmy></span></td><td><span ng-bind=li.CntNavy></span></td><td><span ng-bind=li.CntAirforce></span></td><td><span ng-bind=li.CntMarine></span></td><td><span ng-bind=li.CntTotal></span></td></tr><tr><td>합계</td><td><span ng-bind=vc.data3_1.SumCntArmy></span></td><td><span ng-bind=vc.data3_1.SumCntNavy></span></td><td><span ng-bind=vc.data3_1.SumCntAirforce></span></td><td><span ng-bind=vc.data3_1.SumCntMarine></span></td><td><span ng-bind=vc.data3_1.SumCntTotal></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>7. 계급별 종료 현황 (단위: 인원)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%></colgroup><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan=7>장교</th><th colspan=6>부사관</th><th colspan=5>병</th></tr><tr><th>계</th><th>대령</th><th>중령</th><th>소령</th><th>대위</th><th>중위</th><th>소위</th><th>계</th><th>준위</th><th>원사</th><th>상사</th><th>중사</th><th>하사</th><th>계</th><th>병장</th><th>상병</th><th>일병</th><th>이병</th></tr><tr><th colspan=2>계</th><th><span ng-bind=vc.data4_1.SumCntTotal></span></th><th><span ng-bind=vc.data4_1.SumCntTotal2></span></th><th><span ng-bind=vc.data4_1.SumCntTotal2_1></span></th><th><span ng-bind=vc.data4_1.SumCntTotal2_2></span></th><th><span ng-bind=vc.data4_1.SumCntTotal2_3></span></th><th><span ng-bind=vc.data4_1.SumCntTotal3_1></span></th><th><span ng-bind=vc.data4_1.SumCntTotal3_2></span></th><th><span ng-bind=vc.data4_1.SumCntTotal3_3></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4_1></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4_2></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4_3></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4_4></span></th><th><span ng-bind=vc.data4_1.SumCntTotal4_5></span></th><th><span ng-bind=vc.data4_1.SumCntTotal5></span></th><th><span ng-bind=vc.data4_1.SumCntTotal5_1></span></th><th><span ng-bind=vc.data4_1.SumCntTotal5_2></span></th><th><span ng-bind=vc.data4_1.SumCntTotal5_3></span></th><th><span ng-bind=vc.data4_1.SumCntTotal5_4></span></th></tr><tr ng-repeat-start=\"li in vc.data4 track by $index\"><th rowspan=5><span ng-bind=li.AreaNm></span></th><th><span>소계</span></th><td><span ng-bind=li.CntTotal></span></td><td><span ng-bind=li.CntTotal2></span></td><td><span ng-bind=li.CntTotal2_1></span></td><td><span ng-bind=li.CntTotal2_2></span></td><td><span ng-bind=li.CntTotal2_3></span></td><td><span ng-bind=li.CntTotal3_1></span></td><td><span ng-bind=li.CntTotal3_2></span></td><td><span ng-bind=li.CntTotal3_3></span></td><td><span ng-bind=li.CntTotal4></span></td><td><span ng-bind=li.CntTotal4_1></span></td><td><span ng-bind=li.CntTotal4_2></span></td><td><span ng-bind=li.CntTotal4_3></span></td><td><span ng-bind=li.CntTotal4_4></span></td><td><span ng-bind=li.CntTotal4_5></span></td><td><span ng-bind=li.CntTotal5></span></td><td><span ng-bind=li.CntTotal5_1></span></td><td><span ng-bind=li.CntTotal5_2></span></td><td><span ng-bind=li.CntTotal5_3></span></td><td><span ng-bind=li.CntTotal5_4></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=li.CntArmy></span></td><td><span ng-bind=li.CntArmy2></span></td><td><span ng-bind=li.CntArmy2_1></span></td><td><span ng-bind=li.CntArmy2_2></span></td><td><span ng-bind=li.CntArmy2_3></span></td><td><span ng-bind=li.CntArmy3_1></span></td><td><span ng-bind=li.CntArmy3_2></span></td><td><span ng-bind=li.CntArmy3_3></span></td><td><span ng-bind=li.CntArmy4></span></td><td><span ng-bind=li.CntArmy4_1></span></td><td><span ng-bind=li.CntArmy4_2></span></td><td><span ng-bind=li.CntArmy4_3></span></td><td><span ng-bind=li.CntArmy4_4></span></td><td><span ng-bind=li.CntArmy4_5></span></td><td><span ng-bind=li.CntArmy5></span></td><td><span ng-bind=li.CntArmy5_1></span></td><td><span ng-bind=li.CntArmy5_2></span></td><td><span ng-bind=li.CntArmy5_3></span></td><td><span ng-bind=li.CntArmy5_4></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=li.CntNavy></span></td><td><span ng-bind=li.CntNavy2></span></td><td><span ng-bind=li.CntNavy2_1></span></td><td><span ng-bind=li.CntNavy2_2></span></td><td><span ng-bind=li.CntNavy2_3></span></td><td><span ng-bind=li.CntNavy3_1></span></td><td><span ng-bind=li.CntNavy3_2></span></td><td><span ng-bind=li.CntNavy3_3></span></td><td><span ng-bind=li.CntNavy4></span></td><td><span ng-bind=li.CntNavy4_1></span></td><td><span ng-bind=li.CntNavy4_2></span></td><td><span ng-bind=li.CntNavy4_3></span></td><td><span ng-bind=li.CntNavy4_4></span></td><td><span ng-bind=li.CntNavy4_5></span></td><td><span ng-bind=li.CntNavy5></span></td><td><span ng-bind=li.CntNavy5_1></span></td><td><span ng-bind=li.CntNavy5_2></span></td><td><span ng-bind=li.CntNavy5_3></span></td><td><span ng-bind=li.CntNavy5_4></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=li.CntAirforce></span></td><td><span ng-bind=li.CntAirforce2></span></td><td><span ng-bind=li.CntAirforce2_1></span></td><td><span ng-bind=li.CntAirforce2_2></span></td><td><span ng-bind=li.CntAirforce2_3></span></td><td><span ng-bind=li.CntAirforce3_1></span></td><td><span ng-bind=li.CntAirforce3_2></span></td><td><span ng-bind=li.CntAirforce3_3></span></td><td><span ng-bind=li.CntAirforce4></span></td><td><span ng-bind=li.CntAirforce4_1></span></td><td><span ng-bind=li.CntAirforce4_2></span></td><td><span ng-bind=li.CntAirforce4_3></span></td><td><span ng-bind=li.CntAirforce4_4></span></td><td><span ng-bind=li.CntAirforce4_5></span></td><td><span ng-bind=li.CntAirforce5></span></td><td><span ng-bind=li.CntAirforce5_1></span></td><td><span ng-bind=li.CntAirforce5_2></span></td><td><span ng-bind=li.CntAirforce5_3></span></td><td><span ng-bind=li.CntAirforce5_4></span></td></tr><tr ng-repeat-end><th><span>해병대</span></th><td><span ng-bind=li.CntMarine></span></td><td><span ng-bind=li.CntMarine2></span></td><td><span ng-bind=li.CntMarine2_1></span></td><td><span ng-bind=li.CntMarine2_2></span></td><td><span ng-bind=li.CntMarine2_3></span></td><td><span ng-bind=li.CntMarine3_1></span></td><td><span ng-bind=li.CntMarine3_2></span></td><td><span ng-bind=li.CntMarine3_3></span></td><td><span ng-bind=li.CntMarine4></span></td><td><span ng-bind=li.CntMarine4_1></span></td><td><span ng-bind=li.CntMarine4_2></span></td><td><span ng-bind=li.CntMarine4_3></span></td><td><span ng-bind=li.CntMarine4_4></span></td><td><span ng-bind=li.CntMarine4_5></span></td><td><span ng-bind=li.CntMarine5></span></td><td><span ng-bind=li.CntMarine5_1></span></td><td><span ng-bind=li.CntMarine5_2></span></td><td><span ng-bind=li.CntMarine5_3></span></td><td><span ng-bind=li.CntMarine5_4></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>8. 멘토링 종료 회차 현황 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><tr><th colspan=2><span>구분</span></th><th><span>총계</span></th><th ng-repeat=\"round in vc.RoundList track by $index\"><span ng-bind=round></span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th ng-repeat=\"round in vc.data5_RoundTop track by $index\"><span ng-bind=round.Sum></span></th></tr><tr ng-repeat-start=\"area in vc.data5 track by $index\"><th rowspan=5><span ng-bind=vc.AreaList[$index]></span></th><th><span>소계</span></th><td><span ng-bind=vc.data5_SumArea[$index].Sum></span></td><td ng-repeat=\"round in area track by $index\"><span ng-bind=round.Sum></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Army></span></td><td ng-repeat=\"round in area track by $index\"><span ng-bind=round.Army></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Navy></span></td><td ng-repeat=\"round in area track by $index\"><span ng-bind=round.Navy></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Airforce></span></td><td ng-repeat=\"round in area track by $index\"><span ng-bind=round.Airforce></span></td></tr><tr ng-repeat-end><th><span>해병대</span></th><td><span ng-bind=vc.data5_SumArea[$index].Marine></span></td><td ng-repeat=\"round in area track by $index\"><span ng-bind=round.Marine></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>9. 멘토링 종료 아이템 현황 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=2><span>구분</span></th><th><span>총계</span></th><th ng-repeat=\"ItemField in vc.ItemFieldList track by $index\"><span ng-bind=ItemField></span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th ng-repeat=\"item in vc.data5_SumItemField track by $index\"><span ng-bind=item.Sum></span></th></tr><tr><th colspan=2><span>%</span></th><th><span ng-bind=\"vc.data5_Ratio + \'%\'\"></span></th><th ng-repeat=\"item in vc.data5_SumItemField track by $index\"><span ng-bind=\"item.Ratio + \'%\'\"></span></th></tr><tr ng-repeat-start=\"area in vc.data5_ItemField track by $index\" ng-init=\"idx = $index\"><th rowspan=6><span ng-bind=vc.AreaList[$index]></span></th><th><span>소계</span></th><td><span ng-bind=vc.data5_SumArea[$index].Sum></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=item.Sum></span></td></tr><tr><th><span>%</span></th><td><span ng-bind=\"vc.data5_SumArea[$index].Ratio + \'%\'\"></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=\"item.Ratio + \'%\'\"></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Army></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=item.Army></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Navy></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=item.Navy></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Airforce></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=item.Airforce></span></td></tr><tr ng-repeat-end><th><span>해병대</span></th><td><span ng-bind=vc.data5_SumArea[$index].Marine></span></td><td ng-repeat=\"item in area track by $index\"><span ng-bind=item.Marine></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>10. 부대별 현황 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=3><span>구분</span></th><th><span>총계</span></th><th><span>종료</span></th><th><span>진행</span></th><th><span>미진행</span></th><th><span>기타(취소)</span></th></tr><tr><th colspan=3><span>계</span></th><th><span ng-bind=vc.data6_Sum.Sum></span></th><th><span ng-bind=vc.data6_Sum.End></span></th><th><span ng-bind=vc.data6_Sum.Ing></span></th><th><span ng-bind=vc.data6_Sum.NotStart></span></th><th><span ng-bind=vc.data6_Sum.Cancel></span></th></tr><tr><th colspan=3><span>%</span></th><th><span ng-bind=\"vc.data6_Ratio.Sum + \'%\'\"></span></th><th><span ng-bind=\"vc.data6_Ratio.End + \'%\'\"></span></th><th><span ng-bind=\"vc.data6_Ratio.Ing + \'%\'\"></span></th><th><span ng-bind=\"vc.data6_Ratio.NotStart + \'%\'\"></span></th><th><span ng-bind=\"vc.data6_Ratio.Cancel + \'%\'\"></span></th></tr><tr ng-repeat-start=\"area in vc.data6_SumArea track by $index\"><th rowspan={{vc.data6_Rownum[$index].Sum}}><span ng-bind=vc.AreaList[$index]></span></th><th></th><th><span>소계</span></th><th><span ng-bind=vc.data6_SumArea[$index].Sum></span></th><th><span ng-bind=vc.data6_SumArea[$index].End></span></th><th><span ng-bind=vc.data6_SumArea[$index].Ing></span></th><th><span ng-bind=vc.data6_SumArea[$index].NotStart></span></th><th><span ng-bind=vc.data6_SumArea[$index].Cancel></span></th></tr><tr ng-repeat=\"row in vc.data6 track by $index\"><th ng-if=\"row.AreaNm == vc.AreaList[$parent.$index] && row.isFirst && row.ArmyType == \'1\'\" rowspan={{vc.data6_Rownum[$parent.$parent.$index].Army}}><span>육군</span></th><th ng-if=\"row.AreaNm == vc.AreaList[$parent.$index] && row.isFirst && row.ArmyType == \'2\'\" rowspan={{vc.data6_Rownum[$parent.$parent.$index].Navy}}><span>해군</span></th><th ng-if=\"row.AreaNm == vc.AreaList[$parent.$index] && row.isFirst && row.ArmyType == \'3\'\" rowspan={{vc.data6_Rownum[$parent.$parent.$index].Airforce}}><span>공군</span></th><th ng-if=\"row.AreaNm == vc.AreaList[$parent.$index] && row.isFirst && row.ArmyType == \'4\'\" rowspan={{vc.data6_Rownum[$parent.$parent.$index].Marine}}><span>해병대</span></th><th ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.PermStat1_></span></th><td ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.TeamCntSum></span></td><td ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.TeamCntEnd></span></td><td ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.TeamCntIng></span></td><td ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.TeamCntNotStart></span></td><td ng-if=\"row.AreaNm == vc.AreaList[$parent.$index]\"><span ng-bind=row.TeamCntCancel></span></td></tr><tr ng-repeat-end></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>11. 종료팀 월별 현황 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=2><span>구분</span></th><th><span>종료팀</span></th><th><span>종료인원</span></th><th ng-repeat=\"round in vc.RoundList track by $index\"><span ng-bind=round></span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th><span ng-bind=vc.data5_SumCntMemberTotal></span></th><th ng-repeat=\"round in vc.data5_RoundTop track by $index\"><span ng-bind=round.Sum></span></th></tr><tr><th colspan=2><span>%</span></th><th><span ng-bind=\"vc.data5_Ratio + \'%\'\"></span></th><th><span></span></th><th ng-repeat=\"round in vc.data5_RoundTop track by $index\"><span ng-bind=\"round.Ratio + \'%\'\"></span></th></tr><tr ng-repeat-start=\"area in vc.AreaList track by $index\"><th rowspan=\"{{vc.YearMonthList.length + 1}}\"><span ng-bind=area></span></th><th><span>소계</span></th><th><span ng-bind=vc.data5_SumArea[$index].Sum></span></th><th><span ng-bind=vc.data5_SumCntMemberArea[$index].Sum></span></th><th ng-repeat=\"sum in vc.data5[$index] track by $index\"><span ng-bind=sum.Sum></span></th></tr><tr ng-repeat=\"ym in vc.YearMonthList track by $index\"><th><span ng-bind=ym></span></th><td><span ng-bind=vc.data5_SumYearMonth[$parent.$index][$index]></span></td><td><span ng-bind=vc.data5_SumCntMemberYM[$parent.$index][$index]></span></td><td ng-repeat=\"data in vc.data5_YearMonth[$parent.$index][$index] track by $index\"><span ng-bind=data></span></td></tr><tr ng-repeat-end></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>12. 멘토별/보고서 현황 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=2><span>구분</span></th><th><span>총계</span></th><th ng-repeat=\"round in vc.RoundList track by $index\"><span ng-bind=round></span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th ng-repeat=\"round in vc.data5_RoundTop track by $index\"><span ng-bind=round.Sum></span></th></tr><tr><th colspan=2><span>%</span></th><th><span ng-bind=\"vc.data5_Ratio + \'%\'\"></span></th><th ng-repeat=\"round in vc.data5_RoundTop track by $index\"><span ng-bind=\"round.Ratio + \'%\'\"></span></th></tr><tr ng-repeat-start=\"area in vc.AreaList track by $index\"><th rowspan=\"{{vc.data5_MentoUser[$index].length + 1}}\"><span ng-bind=area></span></th><th><span>소계</span></th><th><span ng-bind=vc.data5_SumArea[$index].Sum></span></th><th ng-repeat=\"sum in vc.data5[$index] track by $index\"><span ng-bind=sum.Sum></span></th></tr><tr ng-repeat=\"mu in vc.MentoUserList[$index] track by $index\"><th><span ng-bind=mu.MentoUser_></span></th><td><span ng-bind=vc.data5_SumMentoUser[$parent.$index][$index]></span></td><td ng-repeat=\"data in vc.data5_MentoUser[$parent.$index][$index] track by $index\"><span ng-bind=data></span></td></tr><tr ng-repeat-end></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>13. 창업경진대회 (단위: 팀)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=2><span>구분</span></th><th><span>종료팀</span></th><th><span>종료인원</span></th><th><span>참여팀</span></th><th ng-repeat=\"contest in vc.MentoringContestList track by $index\"><span ng-bind=contest></span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th><span ng-bind=vc.data5_SumCntMemberTotal></span></th><th><span ng-bind=\"vc.data1_3.SumPrtcpCntTotal + vc.data1_1.EndCntTotal\"></span></th><th ng-repeat=\"data in vc.data7_Top track by $index\"><span ng-bind=data.Sum></span></th></tr><tr><th colspan=2><span>%</span></th><th><span ng-bind=\"vc.data5_Ratio + \'%\'\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"vc.data1_1.RatioTotal + \'%\'\"></span></th><th ng-repeat=\"data in vc.data7_Top track by $index\"><span ng-bind=\"data.Ratio + \'%\'\"></span></th></tr><tr ng-repeat-start=\"area in vc.AreaList track by $index\"><th rowspan=6><span ng-bind=area></span></th><th><span>소계</span></th><th><span ng-bind=vc.data5_SumArea[$index].Sum></span></th><th><span ng-bind=vc.data5_SumCntMemberArea[$index].Sum></span></th><td><span ng-bind=\"vc.data1_2[$index].PrtcpCntTotal + vc.data1_2[$index].EndCntTotal\"></span></td><th ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=data.Sum></span></th></tr><tr><th><span>%</span></th><th><span ng-bind=\"vc.data5_SumArea[$index].Ratio + \'%\'\"></span></th><th><span></span></th><th><span ng-bind=\"vc.data7_Ratio[$index] + \'%\'\"></span></th><th ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=\"data.Ratio + \'%\'\"></span></th></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Army></span></td><td><span ng-bind=vc.data5_SumCntMemberArea[$index].Army></span></td><td><span ng-bind=\"vc.data1_2[$index].PrtcpCntArmy + vc.data1_2[$index].EndCntArmy\"></span></td><td ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=data.Army></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Navy></span></td><td><span ng-bind=vc.data5_SumCntMemberArea[$index].Navy></span></td><td><span ng-bind=\"vc.data1_2[$index].PrtcpCntNavy + vc.data1_2[$index].EndCntNavy\"></span></td><td ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=data.Navy></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data5_SumArea[$index].Airforce></span></td><td><span ng-bind=vc.data5_SumCntMemberArea[$index].Airforce></span></td><td><span ng-bind=\"vc.data1_2[$index].PrtcpCntAirforce + vc.data1_2[$index].EndCntAirforce\"></span></td><td ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=data.Airforce></span></td></tr><tr ng-repeat-end><th><span>해병대</span></th><td><span ng-bind=vc.data5_SumArea[$index].Marine></span></td><td><span ng-bind=vc.data5_SumCntMemberArea[$index].Marine></span></td><td><span ng-bind=\"vc.data1_2[$index].PrtcpCntMarine + vc.data1_2[$index].EndCntMarine\"></span></td><td ng-repeat=\"data in vc.data7[$index] track by $index\"><span ng-bind=data.Marine></span></td></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>14. 종료팀 현황</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\" style=\"table-layout: fixed\"><tr><th colspan=2><span>구분</span></th><th><span>종료팀</span></th><th><span>동아리명</span></th><th><span>팀장팀원</span></th><th><span>성명</span></th><th><span>계급</span></th><th><span>소속부대</span></th><th><span>군번</span></th><th><span>성별</span></th><th><span>멘토</span></th><th><span>아이템분야</span></th><th><span>종료회차</span></th><th><span>경진대회</span></th></tr><tr><th colspan=2><span>계</span></th><th><span ng-bind=vc.data5_Sum></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th></tr><tr ng-repeat-start=\"area in vc.AreaList track by $index\"><th rowspan={{vc.data8[$index].Rownum}}><span ng-bind=area></span></th><th><span>소계</span></th><th><span ng-bind=vc.data5_SumArea[$index].Sum></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th></tr><tr><th><span>%</span></th><th><span ng-bind=\"vc.data5_SumArea[$index].Ratio + \'%\'\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th><th><span ng-bind=\"\"></span></th></tr><tr ng-repeat=\"army in vc.data8[$index].Army track by $index\"><th rowspan={{vc.data8[$parent.$parent.$index].Army.length}} ng-if=\"$index == 0\"><span>육군</span></th><td rowspan={{vc.data8[$parent.$parent.$index].Army.length}} ng-if=\"$index == 0\"><span ng-bind=vc.data5_SumArea[$parent.$parent.$index].Army></span></td><td><span ng-bind=army.ClubNm></span></td><td><span ng-bind=army.ClubRole></span></td><td><span ng-bind=army.ArmyNm></span></td><!-- 2024.06.21 오류신고 683번 조치(계급, 소속부대 표출 오류 수정) --><td><span ng-bind=army.ArmyClass></span></td><td><span ng-bind=army.PermStat></span></td><td><span ng-bind=army.ArmyNo></span></td><td><span ng-bind=army.Sex></span></td><td><span ng-bind=army.MentoUser_></span></td><td rowspan={{army.CntMember}} ng-if=\"army.ClubRole == \'팀장\'\"><span ng-bind=army.ItemField></span></td><td rowspan={{army.CntMember}} ng-if=\"army.ClubRole == \'팀장\'\"><span ng-bind=army.MentoringRound></span></td><td rowspan={{army.CntMember}} ng-if=\"army.ClubRole == \'팀장\'\"><span ng-bind=army.Contest></span></td></tr><tr ng-repeat=\"navy in vc.data8[$index].Navy track by $index\"><th rowspan={{vc.data8[$parent.$parent.$index].Navy.length}} ng-if=\"$index == 0\"><span>해군</span></th><td rowspan={{vc.data8[$parent.$parent.$index].Navy.length}} ng-if=\"$index == 0\"><span ng-bind=vc.data5_SumArea[$parent.$parent.$index].Navy></span></td><td><span ng-bind=navy.ClubNm></span></td><td><span ng-bind=navy.ClubRole></span></td><td><span ng-bind=navy.ArmyNm></span></td><!-- 2024.06.21 오류신고 683번 조치(계급, 소속부대 표출 오류 수정) --><td><span ng-bind=navy.ArmyClass></span></td><td><span ng-bind=navy.PermStat></span></td><td><span ng-bind=navy.ArmyNo></span></td><td><span ng-bind=navy.Sex></span></td><td><span ng-bind=navy.MentoUser_></span></td><td rowspan={{navy.CntMember}} ng-if=\"navy.ClubRole == \'팀장\'\"><span ng-bind=navy.ItemField></span></td><td rowspan={{navy.CntMember}} ng-if=\"navy.ClubRole == \'팀장\'\"><span ng-bind=navy.MentoringRound></span></td><td rowspan={{navy.CntMember}} ng-if=\"navy.ClubRole == \'팀장\'\"><span ng-bind=navy.Contest></span></td></tr><tr ng-repeat=\"airforce in vc.data8[$index].Airforce track by $index\"><th rowspan={{vc.data8[$parent.$parent.$index].Airforce.length}} ng-if=\"$index == 0\"><span>공군</span></th><td rowspan={{vc.data8[$parent.$parent.$index].Airforce.length}} ng-if=\"$index == 0\"><span ng-bind=vc.data5_SumArea[$parent.$parent.$index].Airforce></span></td><td><span ng-bind=airforce.ClubNm></span></td><td><span ng-bind=airforce.ClubRole></span></td><td><span ng-bind=airforce.ArmyNm></span></td><!-- 2024.06.21 오류신고 683번 조치(계급, 소속부대 표출 오류 수정) --><td><span ng-bind=airforce.ArmyClass></span></td><td><span ng-bind=airforce.PermStat></span></td><td><span ng-bind=airforce.ArmyNo></span></td><td><span ng-bind=airforce.Sex></span></td><td><span ng-bind=airforce.MentoUser_></span></td><td rowspan={{airforce.CntMember}} ng-if=\"airforce.ClubRole == \'팀장\'\"><span ng-bind=airforce.ItemField></span></td><td rowspan={{airforce.CntMember}} ng-if=\"airforce.ClubRole == \'팀장\'\"><span ng-bind=airforce.MentoringRound></span></td><td rowspan={{airforce.CntMember}} ng-if=\"airforce.ClubRole == \'팀장\'\"><span ng-bind=airforce.Contest></span></td></tr><tr ng-repeat=\"marine in vc.data8[$index].Marine track by $index\"><th rowspan={{vc.data8[$parent.$parent.$index].Marine.length}} ng-if=\"$index == 0\"><span>해병대</span></th><td rowspan={{vc.data8[$parent.$parent.$index].Marine.length}} ng-if=\"$index == 0\"><span ng-bind=vc.data5_SumArea[$parent.$parent.$index].Marine></span></td><td><span ng-bind=marine.ClubNm></span></td><td><span ng-bind=marine.ClubRole></span></td><td><span ng-bind=marine.ArmyNm></span></td><!-- 2024.06.21 오류신고 683번 조치(계급, 소속부대 표출 오류 수정) --><td><span ng-bind=marine.ArmyClass></span></td><td><span ng-bind=marine.PermStat></span></td><td><span ng-bind=marine.ArmyNo></span></td><td><span ng-bind=marine.Sex></span></td><td><span ng-bind=marine.MentoUser_></span></td><td rowspan={{marine.CntMember}} ng-if=\"marine.ClubRole == \'팀장\'\"><span ng-bind=marine.ItemField></span></td><td rowspan={{marine.CntMember}} ng-if=\"marine.ClubRole == \'팀장\'\"><span ng-bind=marine.MentoringRound></span></td><td rowspan={{marine.CntMember}} ng-if=\"marine.ClubRole == \'팀장\'\"><span ng-bind=marine.Contest></span></td></tr><tr ng-repeat-end></tr></table></div></div></div></div><div class=\"row row_pad\"><div class=col-lg-12><div class=form-group><label>15. 복무기간별 종료 현황 (단위: 인원)</label><div class=\"addrow_pad text-center\"><table class=\"table tableborder\"><colgroup><col width=auto><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%><col width=4.7%></colgroup><tr><th colspan=2 rowspan=2>구분</th><th rowspan=2>계</th><th colspan=7>장교</th><th colspan=6>부사관</th><th colspan=5>병</th></tr><tr><th>계</th><th>대령</th><th>중령</th><th>소령</th><th>대위</th><th>중위</th><th>소위</th><th>계</th><th>준위</th><th>원사</th><th>상사</th><th>중사</th><th>하사</th><th>계</th><th>병장</th><th>상병</th><th>일병</th><th>이병</th></tr><tr><th colspan=2>계</th><th><span ng-bind=vc.data9.SumCntTotal></span></th><th><span ng-bind=vc.data9.SumCntTotal2></span></th><th><span ng-bind=vc.data9.SumCntTotal2_1></span></th><th><span ng-bind=vc.data9.SumCntTotal2_2></span></th><th><span ng-bind=vc.data9.SumCntTotal2_3></span></th><th><span ng-bind=vc.data9.SumCntTotal3_1></span></th><th><span ng-bind=vc.data9.SumCntTotal3_2></span></th><th><span ng-bind=vc.data9.SumCntTotal3_3></span></th><th><span ng-bind=vc.data9.SumCntTotal4></span></th><th><span ng-bind=vc.data9.SumCntTotal4_1></span></th><th><span ng-bind=vc.data9.SumCntTotal4_2></span></th><th><span ng-bind=vc.data9.SumCntTotal4_3></span></th><th><span ng-bind=vc.data9.SumCntTotal4_4></span></th><th><span ng-bind=vc.data9.SumCntTotal4_5></span></th><th><span ng-bind=vc.data9.SumCntTotal5></span></th><th><span ng-bind=vc.data9.SumCntTotal5_1></span></th><th><span ng-bind=vc.data9.SumCntTotal5_2></span></th><th><span ng-bind=vc.data9.SumCntTotal5_3></span></th><th><span ng-bind=vc.data9.SumCntTotal5_4></span></th></tr><tr><th rowspan=5><span>단기</span></th><th><span>소계</span></th><td><span ng-bind=vc.data9.SumCntShort></span></td><td><span ng-bind=vc.data9.SumCntShort2></span></td><td><span ng-bind=vc.data9.SumCntShort2_1></span></td><td><span ng-bind=vc.data9.SumCntShort2_2></span></td><td><span ng-bind=vc.data9.SumCntShort2_3></span></td><td><span ng-bind=vc.data9.SumCntShort3_1></span></td><td><span ng-bind=vc.data9.SumCntShort3_2></span></td><td><span ng-bind=vc.data9.SumCntShort3_3></span></td><td><span ng-bind=vc.data9.SumCntShort4></span></td><td><span ng-bind=vc.data9.SumCntShort4_1></span></td><td><span ng-bind=vc.data9.SumCntShort4_2></span></td><td><span ng-bind=vc.data9.SumCntShort4_3></span></td><td><span ng-bind=vc.data9.SumCntShort4_4></span></td><td><span ng-bind=vc.data9.SumCntShort4_5></span></td><td><span ng-bind=vc.data9.SumCntShort5></span></td><td><span ng-bind=vc.data9.SumCntShort5_1></span></td><td><span ng-bind=vc.data9.SumCntShort5_2></span></td><td><span ng-bind=vc.data9.SumCntShort5_3></span></td><td><span ng-bind=vc.data9.SumCntShort5_4></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data9.CntShortArmy></span></td><td><span ng-bind=vc.data9.CntShortArmy2></span></td><td><span ng-bind=vc.data9.CntShortArmy2_1></span></td><td><span ng-bind=vc.data9.CntShortArmy2_2></span></td><td><span ng-bind=vc.data9.CntShortArmy2_3></span></td><td><span ng-bind=vc.data9.CntShortArmy3_1></span></td><td><span ng-bind=vc.data9.CntShortArmy3_2></span></td><td><span ng-bind=vc.data9.CntShortArmy3_3></span></td><td><span ng-bind=vc.data9.CntShortArmy4></span></td><td><span ng-bind=vc.data9.CntShortArmy4_1></span></td><td><span ng-bind=vc.data9.CntShortArmy4_2></span></td><td><span ng-bind=vc.data9.CntShortArmy4_3></span></td><td><span ng-bind=vc.data9.CntShortArmy4_4></span></td><td><span ng-bind=vc.data9.CntShortArmy4_5></span></td><td><span ng-bind=vc.data9.CntShortArmy5></span></td><td><span ng-bind=vc.data9.CntShortArmy5_1></span></td><td><span ng-bind=vc.data9.CntShortArmy5_2></span></td><td><span ng-bind=vc.data9.CntShortArmy5_3></span></td><td><span ng-bind=vc.data9.CntShortArmy5_4></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data9.CntShortNavy></span></td><td><span ng-bind=vc.data9.CntShortNavy2></span></td><td><span ng-bind=vc.data9.CntShortNavy2_1></span></td><td><span ng-bind=vc.data9.CntShortNavy2_2></span></td><td><span ng-bind=vc.data9.CntShortNavy2_3></span></td><td><span ng-bind=vc.data9.CntShortNavy3_1></span></td><td><span ng-bind=vc.data9.CntShortNavy3_2></span></td><td><span ng-bind=vc.data9.CntShortNavy3_3></span></td><td><span ng-bind=vc.data9.CntShortNavy4></span></td><td><span ng-bind=vc.data9.CntShortNavy4_1></span></td><td><span ng-bind=vc.data9.CntShortNavy4_2></span></td><td><span ng-bind=vc.data9.CntShortNavy4_3></span></td><td><span ng-bind=vc.data9.CntShortNavy4_4></span></td><td><span ng-bind=vc.data9.CntShortNavy4_5></span></td><td><span ng-bind=vc.data9.CntShortNavy5></span></td><td><span ng-bind=vc.data9.CntShortNavy5_1></span></td><td><span ng-bind=vc.data9.CntShortNavy5_2></span></td><td><span ng-bind=vc.data9.CntShortNavy5_3></span></td><td><span ng-bind=vc.data9.CntShortNavy5_4></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data9.CntShortAirforce></span></td><td><span ng-bind=vc.data9.CntShortAirforce2></span></td><td><span ng-bind=vc.data9.CntShortAirforce2_1></span></td><td><span ng-bind=vc.data9.CntShortAirforce2_2></span></td><td><span ng-bind=vc.data9.CntShortAirforce2_3></span></td><td><span ng-bind=vc.data9.CntShortAirforce3_1></span></td><td><span ng-bind=vc.data9.CntShortAirforce3_2></span></td><td><span ng-bind=vc.data9.CntShortAirforce3_3></span></td><td><span ng-bind=vc.data9.CntShortAirforce4></span></td><td><span ng-bind=vc.data9.CntShortAirforce4_1></span></td><td><span ng-bind=vc.data9.CntShortAirforce4_2></span></td><td><span ng-bind=vc.data9.CntShortAirforce4_3></span></td><td><span ng-bind=vc.data9.CntShortAirforce4_4></span></td><td><span ng-bind=vc.data9.CntShortAirforce4_5></span></td><td><span ng-bind=vc.data9.CntShortAirforce5></span></td><td><span ng-bind=vc.data9.CntShortAirforce5_1></span></td><td><span ng-bind=vc.data9.CntShortAirforce5_2></span></td><td><span ng-bind=vc.data9.CntShortAirforce5_3></span></td><td><span ng-bind=vc.data9.CntShortAirforce5_4></span></td></tr><tr><th><span>해병대</span></th><td><span ng-bind=vc.data9.CntShortMarine></span></td><td><span ng-bind=vc.data9.CntShortMarine2></span></td><td><span ng-bind=vc.data9.CntShortMarine2_1></span></td><td><span ng-bind=vc.data9.CntShortMarine2_2></span></td><td><span ng-bind=vc.data9.CntShortMarine2_3></span></td><td><span ng-bind=vc.data9.CntShortMarine3_1></span></td><td><span ng-bind=vc.data9.CntShortMarine3_2></span></td><td><span ng-bind=vc.data9.CntShortMarine3_3></span></td><td><span ng-bind=vc.data9.CntShortMarine4></span></td><td><span ng-bind=vc.data9.CntShortMarine4_1></span></td><td><span ng-bind=vc.data9.CntShortMarine4_2></span></td><td><span ng-bind=vc.data9.CntShortMarine4_3></span></td><td><span ng-bind=vc.data9.CntShortMarine4_4></span></td><td><span ng-bind=vc.data9.CntShortMarine4_5></span></td><td><span ng-bind=vc.data9.CntShortMarine5></span></td><td><span ng-bind=vc.data9.CntShortMarine5_1></span></td><td><span ng-bind=vc.data9.CntShortMarine5_2></span></td><td><span ng-bind=vc.data9.CntShortMarine5_3></span></td><td><span ng-bind=vc.data9.CntShortMarine5_4></span></td></tr><tr><th rowspan=5><span>중기</span></th><th><span>소계</span></th><td><span ng-bind=vc.data9.SumCntMid></span></td><td><span ng-bind=vc.data9.SumCntMid2></span></td><td><span ng-bind=vc.data9.SumCntMid2_1></span></td><td><span ng-bind=vc.data9.SumCntMid2_2></span></td><td><span ng-bind=vc.data9.SumCntMid2_3></span></td><td><span ng-bind=vc.data9.SumCntMid3_1></span></td><td><span ng-bind=vc.data9.SumCntMid3_2></span></td><td><span ng-bind=vc.data9.SumCntMid3_3></span></td><td><span ng-bind=vc.data9.SumCntMid4></span></td><td><span ng-bind=vc.data9.SumCntMid4_1></span></td><td><span ng-bind=vc.data9.SumCntMid4_2></span></td><td><span ng-bind=vc.data9.SumCntMid4_3></span></td><td><span ng-bind=vc.data9.SumCntMid4_4></span></td><td><span ng-bind=vc.data9.SumCntMid4_5></span></td><td><span ng-bind=vc.data9.SumCntMid5></span></td><td><span ng-bind=vc.data9.SumCntMid5_1></span></td><td><span ng-bind=vc.data9.SumCntMid5_2></span></td><td><span ng-bind=vc.data9.SumCntMid5_3></span></td><td><span ng-bind=vc.data9.SumCntMid5_4></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data9.CntMidArmy></span></td><td><span ng-bind=vc.data9.CntMidArmy2></span></td><td><span ng-bind=vc.data9.CntMidArmy2_1></span></td><td><span ng-bind=vc.data9.CntMidArmy2_2></span></td><td><span ng-bind=vc.data9.CntMidArmy2_3></span></td><td><span ng-bind=vc.data9.CntMidArmy3_1></span></td><td><span ng-bind=vc.data9.CntMidArmy3_2></span></td><td><span ng-bind=vc.data9.CntMidArmy3_3></span></td><td><span ng-bind=vc.data9.CntMidArmy4></span></td><td><span ng-bind=vc.data9.CntMidArmy4_1></span></td><td><span ng-bind=vc.data9.CntMidArmy4_2></span></td><td><span ng-bind=vc.data9.CntMidArmy4_3></span></td><td><span ng-bind=vc.data9.CntMidArmy4_4></span></td><td><span ng-bind=vc.data9.CntMidArmy4_5></span></td><td><span ng-bind=vc.data9.CntMidArmy5></span></td><td><span ng-bind=vc.data9.CntMidArmy5_1></span></td><td><span ng-bind=vc.data9.CntMidArmy5_2></span></td><td><span ng-bind=vc.data9.CntMidArmy5_3></span></td><td><span ng-bind=vc.data9.CntMidArmy5_4></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data9.CntMidNavy></span></td><td><span ng-bind=vc.data9.CntMidNavy2></span></td><td><span ng-bind=vc.data9.CntMidNavy2_1></span></td><td><span ng-bind=vc.data9.CntMidNavy2_2></span></td><td><span ng-bind=vc.data9.CntMidNavy2_3></span></td><td><span ng-bind=vc.data9.CntMidNavy3_1></span></td><td><span ng-bind=vc.data9.CntMidNavy3_2></span></td><td><span ng-bind=vc.data9.CntMidNavy3_3></span></td><td><span ng-bind=vc.data9.CntMidNavy4></span></td><td><span ng-bind=vc.data9.CntMidNavy4_1></span></td><td><span ng-bind=vc.data9.CntMidNavy4_2></span></td><td><span ng-bind=vc.data9.CntMidNavy4_3></span></td><td><span ng-bind=vc.data9.CntMidNavy4_4></span></td><td><span ng-bind=vc.data9.CntMidNavy4_5></span></td><td><span ng-bind=vc.data9.CntMidNavy5></span></td><td><span ng-bind=vc.data9.CntMidNavy5_1></span></td><td><span ng-bind=vc.data9.CntMidNavy5_2></span></td><td><span ng-bind=vc.data9.CntMidNavy5_3></span></td><td><span ng-bind=vc.data9.CntMidNavy5_4></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data9.CntMidAirforce></span></td><td><span ng-bind=vc.data9.CntMidAirforce2></span></td><td><span ng-bind=vc.data9.CntMidAirforce2_1></span></td><td><span ng-bind=vc.data9.CntMidAirforce2_2></span></td><td><span ng-bind=vc.data9.CntMidAirforce2_3></span></td><td><span ng-bind=vc.data9.CntMidAirforce3_1></span></td><td><span ng-bind=vc.data9.CntMidAirforce3_2></span></td><td><span ng-bind=vc.data9.CntMidAirforce3_3></span></td><td><span ng-bind=vc.data9.CntMidAirforce4></span></td><td><span ng-bind=vc.data9.CntMidAirforce4_1></span></td><td><span ng-bind=vc.data9.CntMidAirforce4_2></span></td><td><span ng-bind=vc.data9.CntMidAirforce4_3></span></td><td><span ng-bind=vc.data9.CntMidAirforce4_4></span></td><td><span ng-bind=vc.data9.CntMidAirforce4_5></span></td><td><span ng-bind=vc.data9.CntMidAirforce5></span></td><td><span ng-bind=vc.data9.CntMidAirforce5_1></span></td><td><span ng-bind=vc.data9.CntMidAirforce5_2></span></td><td><span ng-bind=vc.data9.CntMidAirforce5_3></span></td><td><span ng-bind=vc.data9.CntMidAirforce5_4></span></td></tr><tr><th><span>해병대</span></th><td><span ng-bind=vc.data9.CntMidMarine></span></td><td><span ng-bind=vc.data9.CntMidMarine2></span></td><td><span ng-bind=vc.data9.CntMidMarine2_1></span></td><td><span ng-bind=vc.data9.CntMidMarine2_2></span></td><td><span ng-bind=vc.data9.CntMidMarine2_3></span></td><td><span ng-bind=vc.data9.CntMidMarine3_1></span></td><td><span ng-bind=vc.data9.CntMidMarine3_2></span></td><td><span ng-bind=vc.data9.CntMidMarine3_3></span></td><td><span ng-bind=vc.data9.CntMidMarine4></span></td><td><span ng-bind=vc.data9.CntMidMarine4_1></span></td><td><span ng-bind=vc.data9.CntMidMarine4_2></span></td><td><span ng-bind=vc.data9.CntMidMarine4_3></span></td><td><span ng-bind=vc.data9.CntMidMarine4_4></span></td><td><span ng-bind=vc.data9.CntMidMarine4_5></span></td><td><span ng-bind=vc.data9.CntMidMarine5></span></td><td><span ng-bind=vc.data9.CntMidMarine5_1></span></td><td><span ng-bind=vc.data9.CntMidMarine5_2></span></td><td><span ng-bind=vc.data9.CntMidMarine5_3></span></td><td><span ng-bind=vc.data9.CntMidMarine5_4></span></td></tr><tr><th rowspan=5><span>장기</span></th><th><span>소계</span></th><td><span ng-bind=vc.data9.SumCntLong></span></td><td><span ng-bind=vc.data9.SumCntLong2></span></td><td><span ng-bind=vc.data9.SumCntLong2_1></span></td><td><span ng-bind=vc.data9.SumCntLong2_2></span></td><td><span ng-bind=vc.data9.SumCntLong2_3></span></td><td><span ng-bind=vc.data9.SumCntLong3_1></span></td><td><span ng-bind=vc.data9.SumCntLong3_2></span></td><td><span ng-bind=vc.data9.SumCntLong3_3></span></td><td><span ng-bind=vc.data9.SumCntLong4></span></td><td><span ng-bind=vc.data9.SumCntLong4_1></span></td><td><span ng-bind=vc.data9.SumCntLong4_2></span></td><td><span ng-bind=vc.data9.SumCntLong4_3></span></td><td><span ng-bind=vc.data9.SumCntLong4_4></span></td><td><span ng-bind=vc.data9.SumCntLong4_5></span></td><td><span ng-bind=vc.data9.SumCntLong5></span></td><td><span ng-bind=vc.data9.SumCntLong5_1></span></td><td><span ng-bind=vc.data9.SumCntLong5_2></span></td><td><span ng-bind=vc.data9.SumCntLong5_3></span></td><td><span ng-bind=vc.data9.SumCntLong5_4></span></td></tr><tr><th><span>육군</span></th><td><span ng-bind=vc.data9.CntLongArmy></span></td><td><span ng-bind=vc.data9.CntLongArmy2></span></td><td><span ng-bind=vc.data9.CntLongArmy2_1></span></td><td><span ng-bind=vc.data9.CntLongArmy2_2></span></td><td><span ng-bind=vc.data9.CntLongArmy2_3></span></td><td><span ng-bind=vc.data9.CntLongArmy3_1></span></td><td><span ng-bind=vc.data9.CntLongArmy3_2></span></td><td><span ng-bind=vc.data9.CntLongArmy3_3></span></td><td><span ng-bind=vc.data9.CntLongArmy4></span></td><td><span ng-bind=vc.data9.CntLongArmy4_1></span></td><td><span ng-bind=vc.data9.CntLongArmy4_2></span></td><td><span ng-bind=vc.data9.CntLongArmy4_3></span></td><td><span ng-bind=vc.data9.CntLongArmy4_4></span></td><td><span ng-bind=vc.data9.CntLongArmy4_5></span></td><td><span ng-bind=vc.data9.CntLongArmy5></span></td><td><span ng-bind=vc.data9.CntLongArmy5_1></span></td><td><span ng-bind=vc.data9.CntLongArmy5_2></span></td><td><span ng-bind=vc.data9.CntLongArmy5_3></span></td><td><span ng-bind=vc.data9.CntLongArmy5_4></span></td></tr><tr><th><span>해군</span></th><td><span ng-bind=vc.data9.CntLongNavy></span></td><td><span ng-bind=vc.data9.CntLongNavy2></span></td><td><span ng-bind=vc.data9.CntLongNavy2_1></span></td><td><span ng-bind=vc.data9.CntLongNavy2_2></span></td><td><span ng-bind=vc.data9.CntLongNavy2_3></span></td><td><span ng-bind=vc.data9.CntLongNavy3_1></span></td><td><span ng-bind=vc.data9.CntLongNavy3_2></span></td><td><span ng-bind=vc.data9.CntLongNavy3_3></span></td><td><span ng-bind=vc.data9.CntLongNavy4></span></td><td><span ng-bind=vc.data9.CntLongNavy4_1></span></td><td><span ng-bind=vc.data9.CntLongNavy4_2></span></td><td><span ng-bind=vc.data9.CntLongNavy4_3></span></td><td><span ng-bind=vc.data9.CntLongNavy4_4></span></td><td><span ng-bind=vc.data9.CntLongNavy4_5></span></td><td><span ng-bind=vc.data9.CntLongNavy5></span></td><td><span ng-bind=vc.data9.CntLongNavy5_1></span></td><td><span ng-bind=vc.data9.CntLongNavy5_2></span></td><td><span ng-bind=vc.data9.CntLongNavy5_3></span></td><td><span ng-bind=vc.data9.CntLongNavy5_4></span></td></tr><tr><th><span>공군</span></th><td><span ng-bind=vc.data9.CntLongAirforce></span></td><td><span ng-bind=vc.data9.CntLongAirforce2></span></td><td><span ng-bind=vc.data9.CntLongAirforce2_1></span></td><td><span ng-bind=vc.data9.CntLongAirforce2_2></span></td><td><span ng-bind=vc.data9.CntLongAirforce2_3></span></td><td><span ng-bind=vc.data9.CntLongAirforce3_1></span></td><td><span ng-bind=vc.data9.CntLongAirforce3_2></span></td><td><span ng-bind=vc.data9.CntLongAirforce3_3></span></td><td><span ng-bind=vc.data9.CntLongAirforce4></span></td><td><span ng-bind=vc.data9.CntLongAirforce4_1></span></td><td><span ng-bind=vc.data9.CntLongAirforce4_2></span></td><td><span ng-bind=vc.data9.CntLongAirforce4_3></span></td><td><span ng-bind=vc.data9.CntLongAirforce4_4></span></td><td><span ng-bind=vc.data9.CntLongAirforce4_5></span></td><td><span ng-bind=vc.data9.CntLongAirforce5></span></td><td><span ng-bind=vc.data9.CntLongAirforce5_1></span></td><td><span ng-bind=vc.data9.CntLongAirforce5_2></span></td><td><span ng-bind=vc.data9.CntLongAirforce5_3></span></td><td><span ng-bind=vc.data9.CntLongAirforce5_4></span></td></tr><tr><th><span>해병대</span></th><td><span ng-bind=vc.data9.CntLongMarine></span></td><td><span ng-bind=vc.data9.CntLongMarine2></span></td><td><span ng-bind=vc.data9.CntLongMarine2_1></span></td><td><span ng-bind=vc.data9.CntLongMarine2_2></span></td><td><span ng-bind=vc.data9.CntLongMarine2_3></span></td><td><span ng-bind=vc.data9.CntLongMarine3_1></span></td><td><span ng-bind=vc.data9.CntLongMarine3_2></span></td><td><span ng-bind=vc.data9.CntLongMarine3_3></span></td><td><span ng-bind=vc.data9.CntLongMarine4></span></td><td><span ng-bind=vc.data9.CntLongMarine4_1></span></td><td><span ng-bind=vc.data9.CntLongMarine4_2></span></td><td><span ng-bind=vc.data9.CntLongMarine4_3></span></td><td><span ng-bind=vc.data9.CntLongMarine4_4></span></td><td><span ng-bind=vc.data9.CntLongMarine4_5></span></td><td><span ng-bind=vc.data9.CntLongMarine5></span></td><td><span ng-bind=vc.data9.CntLongMarine5_1></span></td><td><span ng-bind=vc.data9.CntLongMarine5_2></span></td><td><span ng-bind=vc.data9.CntLongMarine5_3></span></td><td><span ng-bind=vc.data9.CntLongMarine5_4></span></td></tr></table></div></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/message/modal/campaign-customer-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.title}} 고객 목록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><!-- 검색영역 --><div class=row><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" id=searchWrap><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>고객명</label><input class=form-control ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6 mt-5\"><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></form><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align: middle; width: 40px\"><input type=checkbox ng-click=vc.chkRowAll() ng-model=vc.checkListCheckbox aria-invalid=false></th><th class=text-center>상태</th><th class=text-center>이름</th><th class=text-center>발신정보</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=\"vertical-align:middle; width: 20px\"><input type=checkbox ng-model=li.chkRow aria-invalid=false></td><td class=text-center>{{li.CmpgnImplCustStatus}}</td><td class=text-center>{{li.ToNm}}</td><td class=text-center ng-if=\"vc.CmpgnImpChannel != \'EMAIL\'\"><span auto-hyphen-tel-bind ng-bind=li.ToInfo></span></td><td class=text-center ng-if=\"vc.CmpgnImpChannel == \'EMAIL\'\"><span ng-bind=li.ToInfo></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/message/modal/email-certifi-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">이메일 인증</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10 mb-15\" ng-if=!vc.showMsg><div class=\"col-xs-12 col-sm-12 col-md-8 col-xg-8 col-xl-8\"><div class=\"form-group form-inline\"><label>이메일</label><input class=form-control ng-model=vc.data.SendInfo placeholder=이메일 type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-4 col-xl-4 mt-5\"><button class=\"btn btn-primary\" ng-click=vc.dupChk()><i class=\"fa fa-edit\"></i> 인증하기</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10\" ng-if=vc.showMsg><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 text-center\" style=\"font-size: 17px; font-weight: bold\">인증메일이 발송되었습니다.<br>Amazon Web Services로부터 인증메일을 받아<br>메일 내용에 있는 https://email-verification 로 시작하는 URL을 클릭 후<br>아래 완료 버튼을 클릭 해주시기 바랍니다.<br>(인증 메일은 Amazon Web Services<no-reply-aws @amazon.com>에서 발송되는 영문메일이기 때문에<br>스팸함으로 분류될 수도 있으므로 주의하시기 바랍니다)</no-reply-aws></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10 mb-15 text-center\"><button class=\"btn btn-primary\" ng-click=vc.sendVerifyEmailChk()><i class=\"fa fa-save\"></i> 완료</button></div></div></div></div>");
$templateCache.put("app/message/modal/form-list-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">서식 목록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><!-- 검색영역 --><div class=row><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" id=searchWrap><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>서식명</label><input class=form-control ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6 mt-5\"><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></form><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center>발송타입</th><th class=text-center>서식명</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=vc.ok(li)><!-- Result Items --><td class=text-center>{{li.FormType}}</td><td class=text-center>{{li.FormNm}}</td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/message/modal/from-tel-no-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">발신정보 목록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><!-- 검색영역 --><div class=row><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div></div></div></div>");
$templateCache.put("app/message/modal/receive-number-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">SMS 고객 직접입력</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-xg-9 col-xl-9 mt-10\"><form ui-keypress=\"{13:\'vc.addReceiveNumList()\'}\"><input class=form-control ng-model=vc.receiveNum auto-hyphen-tel placeholder=휴대폰번호 type=text></form></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3 mt-10\"><button class=\"btn btn-primary\" ng-click=vc.addReceiveNumList()><i class=\"fa fa-plus-square\"></i> 추가</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-10\"><div class=text-center style=\"background-color: #f1f3f5; padding:7px; border:1px solid #868e96; font-size: 15px; font-weight: bold\">휴대폰 번호</div><div class=text-center style=\"border:1px solid #868e96; padding: 5px; height: 400px\"><div style=font-size:15px ng-repeat=\"(index, li) in vc.receiveNumList\"><span auto-hyphen-tel-bind ng-bind=li.ToInfo></span><span class=ml-5 ng-click=vc.delReceiveNumList(index)><i class=\"fa fa-times\"></i></span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 pl-20 pr-20 mb-10\"><div class=pull-left><button class=\"btn btn-primary\" ng-click=vc.resetReceiveNumList()><i class=\"fa fa-refresh\"></i> 초기화</button></div><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.ok()><i class=\"fa fa-save\"></i> 고객투입</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/message/modal/sms-preview-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">SMS 미리보기</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div style=\"background:url(\'assets/images/smartphone2.png\') center center no-repeat; height: 310px; display: block; text-align: center; margin-left : auto; margin-right: auto; margin-top : 15px; margin-bottom:15px\"><textarea rows=10 cols=20 readonly style=\"width: 160px; position: relative; top:42px; border: 1px solid #666; border-radius: 4px; resize: none; font-size :16px\">{{vc.sendCn}}</textarea></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 pl-20 pr-20 mb-10\"><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/message/modal/srch-input-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">조건검색투입</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec6 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 pl-20 pr-20 mt-20 mb-10\"><div class=pull-right><span class=\"mr-30 extra-search-wrap\" ng-class=\"{\'extra-search\' : vc.extraSearch}\">추출고객수 : <span>{{vc.srchCnt}}</span></span> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.getSearchData()><i class=\"fa fa-edit\"></i>추출</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.ok()><i class=\"fa fa-save\"></i>투입</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/schedule/modal/schedule-holiday-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">휴무 저장</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><!-- <pre> {{vc.data | json}}</pre> --> <strong class=ng-binding style=\"letter-spacing: 0.5px\">간편등록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=!vc.data.KeyId><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setUpdateData() ng-if=vc.data.KeyId><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-danger mb-10\" ng-click=vc.setDelData() ng-if=vc.data.KeyId><i class=\"fa fa-trash\"></i> {{\'Menu.DELETE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div><!-- <div class=\"col-lg-6\">\r\n      <div class=\"pagecontent mt-15\">\r\n        <div id=\"modalCalendar\" class=\"modalcalendar\" calendar=\"salevisModalCalendar\" ui-calendar=\"uiConfig.calendar\" ng-model=\"eventSources\"></div>\r\n      </div>\r\n    </div> --></div></div>");
$templateCache.put("app/scsystem/additional-service/additional-service-list.html","<style>.cols-SendMessage {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"AdditionalServiceListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>부가서비스내역</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=pagecontent pane-wrap-anchor={{vc.anchor}}><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.BranchNm placeholder=\"지점명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><div class=pull-right ng-if=!vc.loginSysAdminYN><span class=\"pull-right mr-5\" style=\"padding-top: 14px\"><i class=\"fa fa-money\"></i> 회원사 잔여금액 : <strong><span comma-bind ng-bind=vc.ServPoint></span></strong>원</span></div></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions disabled-click></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/scsystem/itemtype/itemtype-list-view.html","<style>.section-title  {\r\n    font-weight: bold;\r\n    margin-top:6px;\r\n    padding-left: 15px;\r\n    font-size: 15px;\r\n    color: #666666;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .Taxation-col-wrap {\r\n    width: 95px;\r\n  }\r\n\r\n  .Taxation-col-wrap label {\r\n    width: 52px;\r\n  }\r\n\r\n  .Taxation-col-wrap .input-group {\r\n    margin-left: 52px;\r\n  }\r\n\r\n  .IsFree-col-wrap label {\r\n    width: 52px;\r\n  }\r\n\r\n  .IsFree-col-wrap .input-group {\r\n    margin-left: 52px;\r\n  }\r\n\r\n  .col-sm-12 .left-context .sortableContainer > div {\r\n    min-height: unset !important;\r\n  }</style><div class=\"page page-footable menuManageView\" ng-controller=\"ScItemTypeListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=page-header>유형관리</div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=panel-default style=border:none><div class=tab-content><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><div class=row style=margin-top:0px><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-3 left-context\"><sc-itemyype-sortable root-title=부가상품 init-callback=vc.succSortable bind-data=vc.datas link-data=vc.linkData max-depth=3></sc-itemyype-sortable></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-9 right-context\"><div class=boardNothing ng-show=!vc.data.KeyId style=padding-top:40px><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>유형을 선택하시면 상세 내용을 보실 수 있습니다.</p></div></div><div class=row ng-show=vc.data.KeyId><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">유형 설정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row ng-show=\"vc.showAttend && vc.data.KeyId\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">{{vc.currentTypeNm}} 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-show=\"vc.currentType == \'30\'\"></div><!-- <div id=\"sec4\" class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-show=\"vc.currentType == \'40\'\"></div>\r\n                        <div id=\"sec5\" class=\"col-xs-12 col-sm-12 col-md-6 col-xg-6 col-xl-6\" ng-show=\"vc.currentType == \'40\'\"></div> --></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\" ng-if=vc.data.KeyId><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/scsystem/penchart-mng/penchart-mng-list.html","<style>.section-title  {\r\n    font-weight: bold;\r\n    margin-top:6px;\r\n    padding-left: 15px;\r\n    font-size: 15px;\r\n    color: #666666;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .noti-wrap {\r\n    padding: 8px;\r\n    border: solid 1px #e3e3e3;\r\n    background: #ffffff;\r\n  }\r\n\r\n  .noti-wrap span {\r\n    display: block;\r\n  }\r\n\r\n  .col-sm-12 .left-context .sortableContainer > div {\r\n    min-height: unset !important;\r\n  }</style><div ng-controller=\"PenchartMngListCtrl as vc\" class=\"page menuManageView\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=page-header>펜차트관리</div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=panel-default style=border:none><div class=tab-content><!-- 기간제 멤버십 등록 --><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><div class=row style=margin-top:0px><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-3 left-context\"><pen-chart-manage-sortable root-title=부가상품 init-callback=vc.succListSortable bind-data=vc.datas link-data=vc.linkData max-depth=3></pen-chart-manage-sortable></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-9 right-context\"><div class=boardNothing ng-show=!vc.data.KeyId style=padding-top:40px><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>분류 및 서식을 선택하시면 상세 내용을 보실 수 있습니다.</p></div></div><div class=row ng-show=vc.data.KeyId><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding-top: 6px\"><div class=noti-wrap><span>※ 서식을 변경/삭제 하시면 기존 고객에게 저장되어 있는 펜차트도 함께 변경/삭제됩니다.</span> <span>※ 사용하실 차트를 변경 하시려면 신규로 생성하시고 기존 펜차트는 숨기기 처리 부탁드립니다.</span> <span>※ 기존 펜차트 내용 등을 변경 시 추가하였던 펜차트를 삭제하지 마시고 신규 등록하여 주세요.</span> <span>※ 사이즈는 700*990(px) 에 최적화 되어있습니다.</span></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-5\" ng-if=vc.data.KeyId><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-5\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=\"row mt-5\" ng-show=\"vc.data.KeyId && vc.data.FormYn == \'Y\'\"><pen-chart-image-sortable root-title=\"\" init-callback=vc.succImageSortable bind-data=vc.datas link-data=vc.linkData max-depth=3></pen-chart-image-sortable></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/bookmark/bookmark-manage.html","<style>.left_box{\r\n        border: 1px solid #aaa;\r\n        padding: 20px;\r\n        font-size: 20px;\r\n        background: #ddd;\r\n        font-weight: 600;\r\n        color: #666;\r\n        width: 50%;\r\n        border-radius: 10px;\r\n        line-height: 55px;\r\n        text-align: center;\r\n    }\r\n    .panel{\r\n        border: none;\r\n        margin-top: 100px;\r\n    }\r\n    .bookmark-list li{\r\n        cursor: pointer;\r\n    }\r\n    [ng-drag].drag-enter:not(.drag-over){\r\n        opacity: 0.7;\r\n        border: 1px solid #aaa;\r\n        border-radius: 1em;\r\n    }</style><div class=\"page page-footable\" ng-controller=\"BookMarkCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>바로가기 관리</div></div></div><div class=panel><div class=panel-body><div class=row><div class=\"col-lg-6 col-md-6\"><div style=\"display: flex; justify-content: center\"><div class=left_box><h3>바로가기</h3><ul class=bookmark-list><li ng-repeat=\"item in vc.list\" ng-drag=true ng-drop=true ng-drag-data=item ng-drop-success=\"vc.onDrop($index, $data)\" ng-click=vc.editData(item) ng-drag-start=\"vc.isDragging = true\">{{item.BmNm}}</li></ul></div></div></div><div class=\"col-lg-5 col-md-5\"><div class=\"panel panel-default tile\" style=\"border: 1px solid #eee\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-md-6\"><div class=form-group><label>바로가기명</label><input class=\"form-control form-right\" ng-model=vc.data.BmNm type=text></div></div><div class=\"col-lg-6 col-md-6\"><div class=form-group><label>링크</label><input class=\"form-control form-right\" ng-model=vc.data.BmRef type=text></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button activate-button class=\"btn btn-default\" ng-click=\"vc.data = {}\"><i class=\"fa fa-times\"></i> 취소</button> <button class=\"btn btn-danger\" ng-click=vc.delAction()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/business-management/business-management-list.html","<div class=\"page page-footable\" ng-controller=\"BusinessManagementListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사업관리 목록</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><input class=form-control type=text ng-model=vc.srch.ErpProductCode placeholder=사업코드></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><input class=form-control type=text ng-model=vc.srch.ErpProductNm placeholder=사업명></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=vc.codeErpTypeCodeList code-model=vc.srch.ERPTYPE></common-code-custom><label>사업분류</label></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3\"><div class=\"form-group form-inline\"><input class=form-control type=text ng-model=vc.srch.ErpProductDPNm placeholder=담당부서></div></div></div><!-- //상단 검색 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-left><button class=\"btn btn-primary ng-binding\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()>액셀다운로드</button></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/business/business-detail-edit.html","<div class=\"page page-footable\" ng-controller=\"BusinessDetailEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사업 상세설정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사업관리</a></li><li><a>사업 상세설정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>세부정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><!-- <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=\"\" ng-show=\"vc.stateParams.UserId != \'\'\">\r\n                    <i class=\"fa fa-shield\"></i> {{ \'Menu.TEMP_PW\' | translate }}\r\n                  </button>\r\n                  <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-10\" activate-button ng-click=\"\">\r\n                    <i class=\"fa  icon-call-in\"></i> {{ \'Menu.CALLBACK_REG\' | translate }}\r\n                  </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.business-list()><i class=\"fa fa-list\"></i>취소</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i>저장</button></div></div></div><div class=row><div class=col-lg-12><div class=form-group><div class=row><div class=col-lg-3><div class=form-group><label>군별</label><common-code param-data=vc.ArmyTypeList callback=vc.onArmyTypeListSelected></common-code></div></div><div class=col-lg-3><div class=form-group><label>소속부대</label><common-code param-data=vc.PermStat1List callback=vc.onPermStat1ListSelected></common-code></div></div><div class=col-lg-3><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.data.ArmyAreaObj ng-options=\"opt.CodeValue for opt in vc.ArmyAreaList track by opt.Code\" style=\"padding: 5px !important\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-2><div class=form-group><label>목표인원</label><input type=text class=form-control ng-model=vc.data.GoalNum placeholder=목표인원></div></div><div class=col-lg-1><div class=form-group><label>&nbsp;</label><div><input class=\"btn btn-default text-right;\" type=button value=추가 ng-click=addRowSetting()></div></div></div></div><div class=addrow_pad><!-- <p>JSON data: <br/>{{ArmyInfoJSON}}</p> --><table class=table><tr><th>군별</th><th>소속부대</th><th>권역</th><th>목표인원</th><th>삭제</th></tr><tr ng-repeat=\"li in vc.list\"><td><input type=text ng-model=li.ArmyType_ class=form-control readonly></td><td><input type=text ng-model=li.PermStat1_ class=form-control readonly></td><td><input type=text ng-model=li.AreaNm class=form-control readonly></td><td><input type=text ng-model=li.GoalNum class=form-control></td><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowSetting($index)></td></tr></table></div></div></div></div></form></div></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/system/business/business-detail.html","<div class=\"page page-footable\" ng-controller=\"BusinessDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사업 조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사업관리</a></li><li><a>사업조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>사업 조회</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.business-list()><i class=\"fa fa-list\"></i> 목록</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.system.business-edit({TenantId:\'{{vc.srch.TenantId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> 수정</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>운영업무시스템 사업정보</label><input type=text class=form-control ng-model=vc.data.TenantCodeNm readonly></div></div><div class=col-lg-4><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.data.TenantNm readonly></div></div><div class=col-lg-4><div class=form-group><label>사업년도</label><input type=text class=form-control ng-model=vc.data.TenantYear readonly></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label>상담회차/실적산정기준</label><input type=text class=form-control ng-model=vc.data.ConsultNum_ readonly></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><input type=text class=form-control ng-model=vc.data.CalculNum_ readonly></div></div><div class=col-lg-4><div class=form-group><label>권역</label><input type=text class=form-control ng-model=vc.data.TenantArea readonly></div></div><div class=col-lg-4><div class=form-group><label>사용여부</label><input type=text class=form-control ng-model=vc.data.UseYn_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>정렬순서</label><input type=text class=form-control ng-model=vc.data.SortNum readonly></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/business/business-edit.html","<div class=\"page page-footable\" ng-controller=\"BusinessEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사업등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사업관리</a></li><li><a>사업등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><!-- <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=\"\" ng-show=\"vc.stateParams.UserId != \'\'\">\r\n                      <i class=\"fa fa-shield\"></i> {{ \'Menu.TEMP_PW\' | translate }}\r\n                    </button>\r\n                    <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-10\" activate-button ng-click=\"\">\r\n                      <i class=\"fa  icon-call-in\"></i> {{ \'Menu.CALLBACK_REG\' | translate }}\r\n                    </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.business-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i>저장</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>운영업무시스템 사업정보</label><select class=form-control name=selectCombo ng-change=vc.onTenentCodeSelected() ng-model=vc.data.TenantCodeObj ng-options=\"opt.NAME1 for opt in vc.tenantCodeList track by opt.CODE\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>사업명</label><input type=text class=form-control ng-model=vc.data.TenantNm placeholder=사업명></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>사업년도</label><input type=text class=form-control ng-model=vc.data.TenantYear placeholder=사업년도></div></div></div><div class=row><div class=col-lg-2><div class=form-group><label class=txt_req>상담회차/실적산정기준</label><common-code param-data=vc.ConsultNumList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><common-code param-data=vc.CalculNumList callback=vc.onCalculNumSelected></common-code></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>권역(쉼표로 구분)</label><input type=text class=form-control ng-model=vc.data.TenantArea placeholder=\"권역(쉼표로 구분)\"></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>사용여부</label><common-code param-data=vc.UseYnList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>정렬순서</label><input type=text class=form-control ng-model=vc.data.SortNum placeholder=정렬순서></div></div></div></form></div><!-- /tile --></div><!-- /col --></div></div><!-- /page content --></div></div>");
$templateCache.put("app/system/business/business-list.html","<div class=\"page page-footable\" ng-controller=\"BusinessListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사업 목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사업관리</a></li><li><a>사업목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle-hide><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>사업코드</label><input type=text class=form-control ng-model=vc.srch.TenantCodeNm placeholder=사업코드></div></div><div class=col-lg-4><div class=form-group><label>사업명</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=사업명></div></div><div class=col-lg-4><div class=form-group><label>사업년도</label><common-code param-data=vc.TenantYearList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사용여부</label><common-code param-data=vc.UseYnList callback=vc.onSelectCallback></common-code></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button><!-- <button\r\n                      class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\"\r\n                      activate-button=\"\"\r\n                      ng-click=\"vc.getExcelDownloadCheckYn()\"\r\n                      ng-show=\"showBtnExcel\"\r\n                    >\r\n                      <i class=\"fa fa-file-excel-o\"></i> 엑셀\r\n                    </button> --> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.goAdd() ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-sort-ignore=true class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th data-toggle=true class=text-center>운영업무시스템 사업정보</th><th data-toggle=true class=text-center>사업명</th><th data-toggle=true class=text-center>사업년도</th><th data-toggle=true class=text-center>권역</th><th data-toggle=true class=text-center>상담회차</th><th data-toggle=true class=text-center>실적산정기준</th><th data-toggle=true class=text-center>정렬순서</th><th data-toggle=true class=text-center>사용여부</th><th data-toggle=true class=text-center>상세설정</th></tr></thead><tbody><tr ng-show=\"vc.totalItems == 0\"><td colspan=10 class=text-center>데이터가 없습니다.</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><!-- <td class=\"text-center\">\r\n                        {{(vc.totalItems - $index) - ((vc.currentPage - 1) *\r\n                        vc.viewSize)}}\r\n                      </td> --><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.TenantCodeNm></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.TenantNm></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.TenantYear></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.TenantArea></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.ConsultNum_></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.CalculNum_></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.SortNum></span></td><td class=text-center ui-sref=\"app.system.business-detail({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span ng-bind=li.UseYn_></span></td><td class=text-center ui-sref=\"app.system.business-detail-edit({TenantId:\'{{li.TenantId}}\'})\" style=\"cursor: pointer\" my-directive><span>[설정]</span></td></tr></tbody><tfoot><tr><td colspan=10 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/company/company-charge-detail.html","<!-- 페이지 스타일 정의 시작 --><style>#userPhoto {\r\n    width: 320px;\r\n    height: 250px;\r\n    margin: 10px auto;\r\n    border:solid 1px #EEE;\r\n    margin-bottom: 18px;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n  }</style><!-- 페이지 스타일 정의 종료 --><div ng-controller=\"CompanyChargeDetailCtrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>회원사 사용료 조회 [{{vc.data.RegDateFrom}} ~ {{vc.data.RegDateTo}}]</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>회원사명</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>가입일</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.JoinDt readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>만료일</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ExpiDt readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>한달이용료</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.ServFee readonly comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>충전포인트</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.ServPoint readonly comma></div></div></div></form></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>SMS 사용량</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CountSMS readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>SMS단가</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CostSMS readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>합계금액</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SumSMS readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>LMS 사용량</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CountMMS readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>LMS단가</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CostMMS readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>합계금액</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SumLMS readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"개별문자 사용량\">개별 사용량</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CountMember readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"개별문자 SMS\">SMS</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CountMemberSMS readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"개별문자 LMS\">LMS</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CountMemberLMS readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"그룹문자 사용량\">그룹 사용량</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CountGroup readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"그룹문자 SMS\">SMS</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CountGroupSMS readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"자동문자 LMS\">LMS</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CountGroupLMS readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"자동문자 사용량\">자동 사용량</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CountAuto readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"자동문자 SMS\">SMS</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CountAutoSMS readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"자동문자 LMS\">LMS</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CountAutoLMS readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 pull-right\"><div class=\"form-group form-inline\"><label uib-tooltip=합계>합계</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Total readonly></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n              <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                <div class=\"col-sm-12\">\r\n                  <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                    ng-model=\"vc.data.Contents\"></textarea>\r\n                </div>\r\n              </div>\r\n            </div> --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row -->");
$templateCache.put("app/system/company/company-charge-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyChargeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>회원사 사용료 조회</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"회원사명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.srch.TenantStatus></common-code-custom><label>{{vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate}}</label></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile2()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--                       <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><!--                       <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\"> --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goDetail(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/company/company-detail.html","<div class=\"page page-footable\" ng-controller=\"CompanyDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantId></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.NAME\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.CEO\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.CEO></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Contact></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.TENANTDIR\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantDir></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/company/company-edit-tab1.html","<!-- 페이지 스타일 정의 시작 --><style>#userPhoto {\r\n    width: 320px;\r\n    height: 250px;\r\n    margin: 10px auto;\r\n    border:solid 1px #EEE;\r\n    margin-bottom: 18px;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n  }</style><!-- 페이지 스타일 정의 종료 --><div ng-controller=\"CompanyEditTab1Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\' &&  vc.TenantId == 0\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setChangeTenant() ng-if=vc.loginSysAdminYN><i class=\"fa fa-save\"></i> {{ \'관리변경\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.TenantId == 0\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{vc.title}} 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm}}\">{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CorpNm\'].ColumnLogicalNm}}\">{{vc.columnMap[\'CorpNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CorpNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'Ceo\'].ColumnLogicalNm}}\">{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Ceo></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'Contact\'].ColumnLogicalNm}}\">{{vc.columnMap[\'Contact\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Contact></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'BizRegNo\'].ColumnLogicalNm}}\">{{vc.columnMap[\'BizRegNo\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.BizRegNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'IndustCode\'].ColumnLogicalNm}}\">{{vc.columnMap[\'IndustCode\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'IndustCode\'].CodeList\" code-model=vc.data.IndustCode></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'BizCondCode\'].ColumnLogicalNm}}\">{{vc.columnMap[\'BizCondCode\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.BizCondCode></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'Email\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.Email></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'TelNo\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" auto-hyphen-tel maxlength=255 ng-model=vc.data.TelNo></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-2\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'Bank\'].ColumnLogicalNm}}\">{{vc.columnMap[\'Bank\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'Bank\'].CodeList\" code-model=vc.data.Bank></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-2\"><div class=form-group><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.AccountNum></div></div></div><!-- /row --><!-- 주소검색 (다음) --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input type=text id=zipCode class=form-control ng-model=vc.data.ZipCode readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.getAddressInfo()><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 wd85\"><div class=form-group><input type=text id=addr1 ng-model=vc.data.Addr1 class=form-control readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input type=text id=addr2 ng-model=vc.data.Addr2 class=form-control></div></div></div><!-- /row --><div class=row ng-if=vc.checkZero><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'TenantStatus\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.data.TenantStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'RegDate\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | autoViewUtcToLocal\"></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>메뉴그룹</label><div class=input-group><div class=\"radio-inline pl-0 pr-20\" ng-repeat=\"mt in vc.radioMenuType\"><input type=checkbox class=clr ng-model=mt.checked ng-disabled=true> {{ mt.codeNm}}</div></div></div></div></div><!-- /row --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{vc.title}} 결제정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'PayType\'].ColumnLogicalNm}}\">{{vc.columnMap[\'PayType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayType\'].CodeList\" code-model=vc.data.PayType ng-disabled=!vc.checkZero></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'MonAmt\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'MonAmt\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MonAmt ng-disabled=!vc.checkZero comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'JoinAmt\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'JoinAmt\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.JoinAmt ng-disabled=!vc.checkZero comma></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'UserCnt\'].ColumnLogicalNm}}\">{{vc.columnMap[\'UserCnt\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.UserCnt ng-disabled=!vc.checkZero comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-1\"><div class=form-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ActUserCnt ng-disabled=!vc.checkZero comma readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'ServiceExpireDate\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'ServiceExpireDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.ServiceExpireDate></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=최근결제일>최근결제일</label><span class=form-control ng-bind=\"vc.data.PayDate | autoViewUtcToLocal\"></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=결제상태>결제상태</label><span class=form-control ng-bind=vc.data.PayStatus></span></div></div></div></form></div><!-- /tile body --></div><!-- /tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{vc.title}} 부가정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- 조직관리로 이동\r\n                <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>{{vc.columnMap[\'HomeInterlockingKey\'].ColumnLogicalNm | translate}}</label>\r\n                  <input type=\"text\" class=\"form-control form-right\" maxlength=\"200\" ng-model=\"vc.data.HomeInterlockingKey\">\r\n                </div>\r\n              </div> --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'NaverInterlockingKey\'].ColumnLogicalNm}}\">{{vc.columnMap[\'NaverInterlockingKey\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.NaverInterlockingKey></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'KakaoInterlockingKey\'].ColumnLogicalNm}}\">{{vc.columnMap[\'KakaoInterlockingKey\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.KakaoInterlockingKey></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'KakaoKey\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'KakaoKey\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" id=KakaoKey ng-model=vc.data.KakaoKey></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'ServPoint\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'ServPoint\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ServPoint ng-disabled=!vc.checkZero comma readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'SessionTime\'].ColumnLogicalNm}}\">{{vc.columnMap[\'SessionTime\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.SessionTime></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CostSMS\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'CostSMS\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CostSMS ng-disabled=!vc.checkZero comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CostLMS\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'CostLMS\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CostLMS ng-disabled=!vc.checkZero comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CostMMS\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'CostMMS\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CostMMS ng-disabled=!vc.checkZero comma></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CostKAKAO\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'CostKAKAO\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CostKAKAO ng-disabled=!vc.checkZero comma></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'CostEMAIL\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'CostEMAIL\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CostEMAIL ng-disabled=!vc.checkZero comma></div></div></div></form></div><!-- /tile body --></div><!-- /tile --><div class=\"panel panel-default tile\" ng-if=vc.checkZero><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{vc.title}} 파일정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- file upload--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=사업자등록증>사업자등록증</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div id=vault class=vault-block></div></form></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label uib-tooltip=\"{{\'Menu.ATTACHEDFILE\' | translate}}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=\"row mt-5\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\' &&  vc.TenantId == 0\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setChangeTenant() ng-if=vc.loginSysAdminYN><i class=\"fa fa-save\"></i> {{ \'관리변경\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setdelData() ng-if=vc.loginSysAdminYN><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/company/company-edit-tab2.html","<div ng-controller=\"CompanyEditTab2Ctrl as vc\"><!-- Action Buttons --><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.moveTenantUser() ng-if=vc.loginSysAdminYN><i class=\"fa fa-trash-o\"></i> {{ \'사용자관리로이동\' | translate }}</button></div></div></div><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--         <div class=\"panel-heading tile-header\">\r\n          <strong style=\"letter-spacing: 0.5px;\"\r\n            class=\"ng-binding\">사용자 목록</strong>\r\n          <div class=\"pull-right\">\r\n            <a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>\r\n          </div>\r\n        </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><!-- <td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumPnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\" class=\"\" ng-click=\"vc.gotoUserDetail(li)\">\r\n                {{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm]\r\n                | date:\'yyyy-MM-dd\')}}\r\n              </td> --><td>{{li.UserId}}</td><td ng-click=vc.gotoUserDetail(li)>{{li.UserNm}}</td><td ng-click=vc.gotoUserDetail(li)>{{li.NickNm}}</td><td ng-click=vc.gotoUserDetail(li)>{{li.LoginId}}</td><td ng-click=vc.gotoUserDetail(li)>{{li.Mobile}}</td><td ng-click=vc.gotoUserDetail(li)>{{li.UserRoleNms}}</td></tr></table><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/system/company/company-edit.html","<div class=\"page page-footable\" ng-controller=\"CompanyEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>{{vc.title}}정보 등록/수정</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\"><li ng-class=\"vc.url == \'/tab1\' || vc.url == \'/tab1/:srch/:keyId\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab1\');\" data-toggle=tab>{{vc.title}} 정보</a></li><li id=tab2 ng-class=\"vc.url == \'/tab2\' || vc.url == \'/tab2/:srch/:keyId\' ? \'active\' : \'\'\" ng-if=false><a ng-click=\"vc.setChangeTab(\'tab2\');\" data-toggle=tab>사용자 목록</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/system/company/company-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>회원사관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"회원사명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TenantNm type=text><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Ceo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Ceo type=text><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.srch.TenantStatus></common-code-custom><label>{{vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile2()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!-- <button class=\"btn btn-primary\" ng-if=\"$root.gVariable.srchTenantId == 0\" ng-click=\"vc.goAdd()\">\r\n                    <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button> --></div><!-- /버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/company/company-pay-detail.html","<div ng-controller=\"CompanyPayDetailCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>결제 내역 조회</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayReqDate\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=\"vc.data.PayReqDate | utcToLocal:\'yyyy-MM-dd\'\"></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ImpUid\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.ImpUid></span></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.CustNm></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CardApplyNum\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.CardApplyNum></span></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'MerchantUid\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.MerchantUid></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PgTid\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.PgTid></span></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayType\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.PayType></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMethod\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.PayMethod></span></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayStaus\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.PayStaus></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Amount\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.Amount></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReceiptUrl\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\"><a target=_blank href=\"{{ vc.data.ReceiptUrl }}\">{{ vc.data.ReceiptUrl }}</a></span></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ErrYN\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.ErrYN></span></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ErrCd\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.ErrCd></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ErrMsg\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.ErrMsg></span></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate }}</label><span class=\"form-control form-readonly\" ng-bind=vc.data.TenantNm></span></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/system/company/company-pay-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyPayListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>결제 내역 조회<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ImpUid placeholder=\"거래번호 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'PayType\'].CodeList\" code-model=vc.srch.PayType></common-code-custom><label>{{vc.columnMap[\'PayType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'PayMethod\'].CodeList\" code-model=vc.srch.PayMethod></common-code-custom><label>{{vc.columnMap[\'PayMethod\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'PayStaus\'].CodeList\" code-model=vc.srch.PayStaus></common-code-custom><label>{{vc.columnMap[\'PayStaus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=form-control ng-model=vc.srch.TenantNm placeholder=\"회원사명 검색\" type=text></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!--               <div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"> --><!--                 <div class=\"pull-right\"> --><!--                   <button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\"> --><!--                     <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }} --><!--                   </button> --><!--                 </div> --><!--               </div> --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--                  <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}}></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><!--                       <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\"> --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goDetail(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/company/recommender-list.html","<div class=\"page page-footable\" ng-controller=\"RecommenderListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>회원사관리<!--div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=\"assets/images/icon-sp-list.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div--></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"회원사명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TenantNm type=text><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Ceo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Ceo type=text><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.srch.TenantStatus></common-code-custom><label>{{vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile2()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!-- <button class=\"btn btn-primary\" ng-if=\"$root.gVariable.srchTenantId == 0\" ng-click=\"vc.goAdd()\">\r\n                    <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button> --></div><!-- /버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=20>{{li[liCol.ColumnPhysicalNm] | number}}</span> <span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></table><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/common-code/common-properties.html","<div class=\"page page-footable\" ng-controller=\"CommonPropertiesCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><h1 class=page-header>공통설정관리</h1></div></div><!-- page content --><div class=pagecontent><form id=form1 name=form1><!-- row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\" ng-click=vc.addNew()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveListComment()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>공통설정관리</div><div class=\"panel-body collapse in\" id=collapse1><!-- Search Result --><div class=pull-right><span>※ Background 색상이 <i class=\"fa fa-square\" style=color:#fde8e8></i>인 항목은 커스텀코드입니다.</span></div><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><colgroup><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"></colgroup><thead><tr><th class=text-center>항목명</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드타입</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드</th><th class=text-center>코드값</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">공통코드타입</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">정렬순서</th><th class=\"text-center showlevel3\">등록일</th><th class=\"text-center showlevel3\">수정일</th><th class=text-center>{{$root.gVariable.srchTenantId != \'0\' ? \'커스텀코드삭제\' : \'삭제\'}}</th><th class=text-center>커스텀코드생성</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><!-- Result Items --><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.Remark ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Code ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.CodeValue required ng-if=\"li.CodeList == null || $root.gVariable.srchTenantId == \'0\'\"><common-code-custom code-list=li.CodeList code-model=li.CodeValue ng-if=\"li.CodeList != null && $root.gVariable.srchTenantId != \'0\'\"></common-code-custom></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CommonCodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\"></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Sort required></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == $root.gVariable.srchTenantId) && (li.TenantId != \'0\' || $root.gVariable.SysAdminYN == \'Y\')\" ng-model=li.DelYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == \'0\' && $root.gVariable.srchTenantId != \'0\') || (li.TenantId != \'0\')\" ng-disabled=\"li.isNew == \'Y\' || li.TenantId != \'0\' || $root.gVariable.SysAdminYN != \'Y\'\" ng-model=li.makeCustomYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></table></div></div></div></div><!-- row --></form></div><!-- /page content --></div>");
$templateCache.put("app/system/common-code/commoncode-list.html","<style>.btn-xs {\r\n    margin-right: 2px;\r\n    min-height: 20px;\r\n    line-height: 1.0;\r\n}\r\n\r\n.angular-ui-tree-handle {\r\n    background: #f8faff;\r\n    border: 1px solid #dae2ea;\r\n    color: #7c9eb2;\r\n    padding: 2px 5px;\r\n}\r\n\r\n.angular-ui-tree-handle:hover {\r\n    color: #438eb9;\r\n    background: #f4f6f7;\r\n    border-color: #dce2e8;\r\n}\r\n\r\n.angular-ui-tree-placeholder {\r\n    background: #f0f9ff;\r\n    border: 2px dashed #6e92bb;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    padding: 0px;\r\n}\r\n\r\ntr.angular-ui-tree-empty {\r\n    height:100px\r\n}\r\n\r\n.group-title {\r\n    background-color: #687074 !important;\r\n    color: #FFF !important;\r\n}\r\n\r\n\r\n/* --- Tree --- */\r\n.tree-node {\r\n    border: 1px solid #dae2ea;\r\n    background: #f8faff;\r\n    color: #7c9eb2;\r\n    padding-left: 5px;\r\n}\r\n\r\n.nodrop {\r\n    background-color: #f2dede;\r\n}\r\n\r\n.tree-node-content {\r\n    margin: 1px;\r\n    padding: 2px;\r\n}\r\n\r\n.tree-handle {\r\n    padding: 5px;\r\n    background: #428bca;\r\n    color: #FFF;\r\n    margin-right: 5px;\r\n}\r\n\r\n.color-red {\r\n  color: #F00;\r\n}\r\n\r\n.selected-node {\r\n  background-color: #ddddff;\r\n}\r\n\r\n.mybutton {\r\n  margin: 2px;\r\n  color: #7c9eb2;\r\n}\r\n\r\n.tree-container {\r\n    min-height: 500px;\r\n}\r\n.filtered-out .angular-ui-tree-handle {\r\n    background-color: rgba(248, 250, 255, 0.3);\r\n    border: 1px solid rgba(218, 226, 234, 0.3);\r\n    color: rgba(124, 158, 178, 0.3);\r\n}\r\n.angular-ui-tree-node:not(.filtered-out) .ui-match {\r\n    background: #ffdc0f;\r\n    border-radius: 2px;\r\n    box-shadow: 1px 1px 3px rgba(0,0,0,0.3);\r\n}\r\n\r\n.input-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n[ui-tree] small {\r\n    color: #888888;\r\n    font-weight: normal;\r\n}\r\n\r\n.inlinetext{\r\n  max-width        : 220px;\r\n  text-overflow: ellipsis;\r\n  white-space  : nowrap;\r\n  overflow     : hidden;\r\n  display      : inline-block;\r\n  vertical-align : middle;\r\n}</style><div class=\"page page-footable\" ng-controller=\"CommoncodeListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{vc.Title}}</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=pattern placeholder=코드명 type=text><div class=\"search_action mb-5\" ng-click=vc.nextSearch()><span class=cursor id=btn_layer_detail_search_open><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.EM660\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=max-height:1000px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.COMMON_CODE\' | translate }}</div><div class=panel-heading ng-if=\"vc.CodeType == \'\'\"><button class=\"btn btn-success btn-xs\" ng-click=expandAll()>Expand all <span class=\"glyphicon glyphicon-chevron-down\"></span></button> <button class=\"btn btn-success btn-xs\" ng-click=collapseAll()>Collapse all <span class=\"glyphicon glyphicon-chevron-up\"></span></button> <button class=\"btn btn-primary btn-xs pull-right\" activate-button type=button ng-click=newSubItem() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><span class=\"glyphicon glyphicon-plus\"></span>{{ \'Menu.ADD\' | translate }}</button></div><!-- Nested node template --><script type=text/ng-template id=nodes_renderer.html><div ui-tree-handle class=\"tree-node tree-node-content {{node.id == vc.data.CommonCodeId ? \'selected-node\':\'\'}}\">\r\n                            <a class=\"btn btn-success btn-xs\" ng-if=\"node.items && node.items.length > 0\" data-nodrag ng-click=\"toggle(this)\"><span\r\n                                class=\"glyphicon\"\r\n                                ng-class=\"{\r\n                                  \'glyphicon-chevron-right\': collapsed,\r\n                                  \'glyphicon-chevron-down\': !collapsed\r\n                                }\"></span></a>\r\n                            <span ng-class=\"node.classes\" class=\"inlinetext\">{{node.title}}</span>\r\n                            <a class=\"pull-right\" data-nodrag ng-click=\"my_tree_handler(this)\" style=\"cursor:pointer\" ng-if=\"vc.CodeType == \'\' || vc.CodeType == node.codeType\"><span class=\"glyphicon glyphicon-edit mybutton\"></span></a>\r\n                            <a class=\"pull-right\" data-nodrag ng-click=\"removeItem(this)\" style=\"cursor:pointer\" ng-if=\"vc.CodeType == \'\' || vc.CodeType == node.codeType\"><span class=\"glyphicon glyphicon-remove mybutton\"></span></a>\r\n                            <a class=\"pull-right\" data-nodrag ng-click=\"newSubItem(this)\" style=\"cursor:pointer\" ng-if=\"vc.CodeType == \'\' || vc.CodeType != node.codeType\"><span class=\"glyphicon glyphicon-plus mybutton\"></span></a>\r\n                          </div>\r\n                          <ol ui-tree-nodes ng-model=\"node.items\" ng-class=\"{hidden: collapsed}\">\r\n                            <li ng-repeat=\"node in node.items\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"\r\n                              ng-hide=\"!treeFilter(node, pattern, supportedFields)\"\r\n                              ng-class=\"{\'filtered-out\':!treeFilter(node, pattern, supportedFields)}\">\r\n                            </li>\r\n                          </ol></script><div ui-tree=treeOptions id=tree-root><ol ui-tree-nodes ng-model=my_data id=tree-handle><li ng-repeat=\"node in my_data\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\" ng-hide=\"!treeFilter(node, pattern, supportedFields)\" ng-class=\"{\'filtered-out\':!treeFilter(node, pattern, supportedFields)}\"></li></ol></div><!--md-content layout-padding-sm ng-controller=\"mtSidenavLeftCtrl\">\r\n                          <abn-tree tree-data=\"my_data\" tree-control=\"my_tree\" on-select=\"my_tree_handler(branch)\" expand-level=\"1\" select-text=\"vc.srch.CodeValue\" icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree>\r\n                        </md-content--></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData(null)><div class=row><div class=col-lg-2 ng-if=\"vc.CodeType == \'\'\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.srchTenantId == \'0\' || vc.data.Code == \'000\' || vc.data.New == \'Y\' || vc.data.SysCodeYN == \'Y\'\" ng-click=vc.ChangeCustomCode() ng-checked=\"vc.data.CustomCode == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>커스텀코드</md-checkbox></div></div><div class=col-lg-2 ng-if=\"vc.CodeType == \'\'\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\' || $root.gVariable.srchTenantId != \'0\' || vc.data.TenantId != \'0\'\" ng-model=vc.data.SysCodeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>시스템코드</md-checkbox></div></div><div class=pull-right><button class=\"btn btn-primary\" activate-button type=submit ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT01\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CommonCodeId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT02\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue ng-change=vc.onChangeCodeValue() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Code ng-change=vc.onChangeCode() ng-required=true></div></div><div class=col-lg-4 ng-if=\"vc.CodeType == \'\'\"><div class=form-group><label>{{ \'Menu.EM660DT04\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeLevel ng-required=true></div></div><div class=col-lg-4 ng-if=\"vc.CodeType == \'\'\"><div class=form-group><label>{{ \'Menu.EM660DT05\' | translate }}</label><input type=text class=form-control ng-model=vc.data.ParentCommonCodeId ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4 ng-if=\"vc.CodeType == \'\'\"><div class=form-group><label>{{ \'Menu.CODETYPE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeType ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT07\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT10\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue01 ng-readonly=\"vc.CodeType != \'\'\" ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT11\' | translate }}</label><input type=text class=form-control colorpicker ng-model=vc.data.CodeValue02 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT12\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue03 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT13\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue04 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT14\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue05 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT15\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue06 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT16\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue07 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT17\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue08 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT18\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue09 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT19\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue10 ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.ORNOTTOUSE\' | translate }}</label><common-code param-data=vc.UseYNData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\"></common-code></div></div></div><div class=row ng-if=\"vc.CodeType == \'\'\"><div class=col-lg-12><ul><li>* 분류로 사용되는 항목 : 코드 = \'000\', 코드타입 = \'000\'</li><li>* 코드명으로 사용되는 항목 : 코드 = 코드타입, 코드타입 = \'000\'</li><li>* 코드의 각항목 사용되는 항목 : 코드 = 코드값, 코드타입 = 코드타입</li></ul></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/system/department/department-detail.html","<div class=\"page page-footable\" ng-controller=\"DepartmentDetailCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.DEPTLIST\' | translate }} {{ \'Menu.MODIFY\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.department-edit({DeptId:\'{{vc.srch.DeptId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><table class=\"table table-togglable table-hover\"><colgroup><col width=160><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }}</th><td><span ng-bind=vc.data.DeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</th><td><span ng-bind=vc.data.ParentDeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }}</th><td><span ng-bind=vc.data.Sort></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONDATE\' | translate }}</th><td><span ng-bind=vc.data.RegDate></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr></tbody></table></div></section></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department/department-edit.html","<div class=\"page page-footable\" ng-controller=\"DepartmentEditCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.REGISTRATIONUSER\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.saveDetail()><i class=\"fa fa-check\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><form class=\"form-horizontal ng-pristine ng-valid\" role=form><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }} :</label><div class=col-sm-10><input type=text class=form-control ng-model=vc.data.DeptNm></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }} :</label><div class=col-sm-10><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=vc.data.ParentDeptNm placeholder=부서> <input type=hidden ng-model=vc.data.ParentDeptId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }} :</label><div class=col-sm-10><input type=number class=form-control ng-model=vc.data.Sort></div></div></form></div><!-- /tile body --></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department/department-list.html","<div class=\"page page-footable\" ng-controller=\"DepartmentListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.DEPTLIST\' | translate }}</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-info title-header\"><div class=panel-heading>{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}<div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4\"><div class=input-group><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.DeptNm><label>{{ \'Menu.DEPARTMENTNAME\' | translate }}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" activate-button ng-click=vc.nextSearch()><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button></div></div></div><!-- panel-body --></div><!--panel panel-default --></div></div><!-- row --><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.DEPTLIST\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=2 select-text=vc.srch.DeptNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData()><div class=row><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" activate-button type=submit ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div></div><div class=row><div class=col-lg-4><div class=form-group><label>부서아이디</label><input type=text class=form-control ng-model=vc.data.DeptId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>부서명</label><input type=text class=form-control ng-change=vc.onChangeDeptNm() ng-model=vc.data.DeptNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>DEPTH</label><input type=text class=form-control ng-model=vc.data.Depth ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>SORT</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>상위부서아이디</label><input type=text class=form-control ng-model=vc.data.ParentDeptId ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>추가1</label><input type=text class=form-control ng-model=vc.data.DeptValue01></div></div><div class=col-lg-4><div class=form-group><label>추가2</label><input type=text class=form-control ng-model=vc.data.DeptValue02></div></div><div class=col-lg-4><div class=form-group><label>추가3</label><input type=text class=form-control ng-model=vc.data.DeptValue03></div></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/system/inquery/inquery-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"InqueryEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>서비스 문의 상세</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.data.KeyId && (vc.layout == \'N\' || vc.layout == \'\') \"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'저장\' | translate}}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">문의 내용</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><span ng-model=vc.data.MarriageYN></span><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/inquery/inquery-list.html","<div class=\"page page-footable\" ng-controller=\"InqueryListCtrl as vc\"><!-- page header --><autoview-page-header alias=vc></autoview-page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=\"row mt-10 mb-10\" ng-if=false><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" ng-click=vc.fnOpenLayer(550)><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none; min-width: 800px\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" ng-click=vc.fnCloseLayer()><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><div class=pull-right><!-- <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.sendMessage(\'all\')\">\r\n                    <i class=\"fa fa-message\"></i> {{\'전체 문자발송\' | translate}}\r\n                  </button> --><!-- <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.sendMessage()\">\r\n                    <i class=\"fa fa-message\"></i> {{\'선택 문자발송\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelCheckDataFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}(체크회원)\r\n                  </button>\r\n                  <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}(조회조건)\r\n                  </button> --></div></div><!-- /col --></div><!-- 검색영역 --></form><autoview-list-table alias=vc list-data=lists></autoview-list-table><!-- / Table row --></div><div fa-pane pane-min=750px ng-if=\"vc.layout != \'N\'\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/make-query/makequery-list.html","<div class=\"page page-footable\" ng-controller=\"MakeQueryListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>쿼리생성기</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Mapper ID</div><div class=\"panel-body collapse in\"><input type=text style=\"border :solid 1px #EEE; width:100%; padding: 3px\" ng-model=vc.mapperId ng-change=vc.changeMapperId()></div></div></div></div><!-- row --><div class=row><style>table th, table td {padding: 3px;}\r\n        #queryView span {display: block;}</style><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Table</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:30%><col style=width:30%></colgroup><thead><tr><th class=text-center>Table</th><th class=text-center>Alias</th><th class=text-center>M</th><th class=text-center>IJ</th><th class=text-center>LJ</th></tr></thead><tbody><tr ng-repeat=\"li in vc.tables\"><!-- Result Items --><td class=text-left><span ng-bind=li.tbNm></span></td><td class=text-center><input type=text ng-model=li.aliasNm ng-blur=vc.blurAlis(li) ng-change=vc.changeAlis(li) style=\"border :solid 1px #EEE; width:100%; padding: 3px\"></td><td class=text-center><input type=checkbox ng-model=li.mChecked ng-click=vc.setMainTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ijChecked ng-click=vc.setJoinTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ljChecked ng-click=vc.setJoinTable(li)></td></tr></tbody></table></div></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Column</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:10%><col style=width:60%><col style=width:10%><col style=width:10%><col style=width:10%></colgroup><thead><tr><th class=text-center>V</th><th class=text-center>Column</th><th class=text-center>N</th><th class=text-center>E</th><th class=text-center>C</th></tr></thead><tbody><tr ng-repeat=\"li in vc.cols\"><!-- Result Items --><td class=text-center><input type=checkbox ng-model=li.checkedYn></td><td class=text-left>{{li.aliasNm}}.{{ li.colNm}}</td><td class=text-center><input type=checkbox ng-model=li.checkedN></td><td class=text-center><input type=checkbox ng-model=li.checkedE></td><td class=text-center><input type=checkbox ng-model=li.checkedC></td></tr></tbody></table></div></div></div><div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Query <span ng-click=vc.copyFn()>(복사하기)</span></div><div class=\"panel-body collapse in\" id=queryView ng-if=vc.checkDrawView><span>&lt;?xml version=\"1.0\" encoding=\"UTF-8\" ?></span> <span>&lt;!DOCTYPE mapper PUBLIC \"-//mybatis.org//DTD Mapper 3.0//EN\" \"/usr/local/dtd/mybatis-3-mapper.dtd\"></span><br><span ng-bind-html=vc.namespace></span><br><span>&lt;sql id=\"whereSampleQuery\"&gt;</span><!-- <span>&lt;where&gt;</span> --><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn><span style=\"display: inline-block\" ng-if=\"li.colNm !=\'DelYN\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm !=\'DelYN\'\">AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm ==\'DelYN\'\">AND {{li.aliasNm}}.{{li.colNm}} = \'N\' </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'int\' || li.dataType==\'decimal\' || li.dataType==\'date\'\">AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'varchar\' || li.dataType==\'text\'\"><span ng-if=!li.checkedC>AND {{li.aliasNm}}.{{li.colNm}} LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\')</span> <span ng-if=\"li.checkedC && li.colNm !=\'Email\'\" style=\"display: inline-block\">AND CAST(AES_DECRYPT(UNHEX({{li.aliasNm}}.{{li.colNm}}), \'SALEVIS4\') AS CHAR) LIKE CONCAT(\'%\', REPLACE(#{ {{li.colNm}} }, \'-\', \'\'), \'%\')</span> <span ng-if=\"li.checkedC && li.colNm ==\'Email\'\" style=\"display: inline-block\">AND CAST(AES_DECRYPT(UNHEX({{li.aliasNm}}.{{li.colNm}}), \'SALEVIS4\') AS CHAR) LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\')</span> </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'datetime\' || li.dataType==\'timestamp\'\">AND {{li.aliasNm}}.{{li.colNm}} &lt;![CDATA[&gt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'bigint\' && li.priYn != \'Y\'\">AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10) </span><!-- <span style=\"display: block;\" ng-if=\"li.dataType==\'bigint\' && li.priYn == \'N\'\">\r\n                &lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10) &lt;/if&gt;\r\n              </span> --> <span style=\"display: inline-block\" ng-if=\"li.dataType==\'bigint\' && li.priYn == \'Y\'\">AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ KeyId }, 36, 10) </span><span style=\"display: inline-block\" ng-if=\"li.colNm !=\'DelYN\'\"><span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&lt;/if&gt;</span></span></div><!-- <span style=\"display: block;\">&lt;if test=\'SESSION_LOGINTYPE != null and SESSION_LOGINTYPE != \"\"\'></span>\r\n            <span style=\"display: block;\">&lt;if test=\'SESSION_LOGINTYPE == \"C\"\'>AND SC.RegUser = CONV(#{SESSION_USERID}, 36, 10)&lt;/if&gt;</span>\r\n            <span style=\"display: block;\">&lt;if test=\'SESSION_LOGINTYPE != \"C\"\'>AND SC.TenantId = CONV(#{ srchTenantId }, 36, 10)&lt;/if&gt;</span>\r\n            <span style=\"display: block;\">&lt;/if></span> --><!-- <span>&lt;/where&gt;</span> --> <span>&lt;/sql&gt;</span><br><span>&lt;sql id=\"where{{vc.tbMain.tableNm}}Data\"&gt;</span> <span>&lt;/sql&gt;</span><br><span>&lt;select id=\"get{{vc.tbMain.tableNm}}ListCnt\" parameterType=\"map\" resultType=\"int\"&gt;</span> <span>SELECT</span> <span>&nbsp;&nbsp;count(*) as totalItems</span> <span>FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&lt;where&gt;</span> <span>&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&lt;/where&gt;</span> <span>&lt;/select&gt;</span><br><span>&lt;select id=\"get{{vc.tbMain.tableNm}}List\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\"><span style=\"display: block\" ng-if=\"$index == 0 && li.dataType != \'bigint\'\">&nbsp;&nbsp; <span ng-if=!li.checkedC>T.{{li.colNm}}</span> <span ng-if=li.checkedC>CAST(AES_DECRYPT(UNHEX(T.{{li.colNm}}), \'SALEVIS4\') AS CHAR) AS {{li.colNm}}</span> </span><span style=\"display: block\" ng-if=\"$index == 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;CONV(T.{{li.colNm}},10,36) AS KeyId </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType != \'bigint\'\"><span ng-if=!li.checkedC>&nbsp;&nbsp;, T.{{li.colNm}}</span> <span ng-if=li.checkedC>&nbsp;&nbsp;, CAST(AES_DECRYPT(UNHEX(T.{{li.colNm}}), \'SALEVIS4\') AS CHAR) AS {{li.colNm}}</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;, CONV(T.{{li.colNm}},10,36) AS {{li.colNm}}</span></div><span>FROM (</span> <span>&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\"><span style=\"display: block\" ng-if=\"$index == 0\">&nbsp;&nbsp;&nbsp;&nbsp;{{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: block\" ng-if=\"$index != 0\">&nbsp;&nbsp;&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}}</span></div><span>&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>&nbsp;&nbsp;INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>&nbsp;&nbsp;LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&nbsp;&nbsp;&lt;where&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/where&gt;</span> <span>&nbsp;&nbsp;ORDER BY {{vc.tbMain.aliasNm}}.RegDate DESC <span>) T</span> <span>INNER JOIN (SELECT @rowNum:=0) T2</span> <span>&lt;choose></span> <span>&lt;when test=\"sortColumn != null and sortColumn != \'\'\"></span> <span>ORDER BY ${sortColumn} ${sortDirect}</span> <span>&lt;/when></span> <span>&lt;otherwise></span> <span>ORDER BY T.RegDate Desc</span> <span>&lt;/otherwise></span> <span>&lt;/choose></span> <span>&lt;if test=\'viewSize != null and viewSize != 0 and page != null\'&gt;</span> <span>LIMIT #{offSet}, #{viewSize}</span> <span>&lt;/if&gt; <span>&lt;/select&gt;</span><br><span>&lt;select id=\"get{{vc.tbMain.tableNm}}Detail\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\"><span style=\"display: block\" ng-if=\"$index == 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;CONV({{li.aliasNm}}.{{li.colNm}},10,36) AS KeyId </span><span style=\"display: block\" ng-if=\"$index == 0 && li.dataType != \'bigint\'\">&nbsp;&nbsp; <span ng-if=!li.checkedC>{{li.aliasNm}}.{{li.colNm}}</span> <span ng-if=li.checkedC>CAST(AES_DECRYPT(UNHEX({{li.aliasNm}}.{{li.colNm}}), \'SALEVIS4\') AS CHAR) AS {{li.colNm}}</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType != \'bigint\'\"><span ng-if=!li.checkedC>&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}}</span> <span ng-if=li.checkedC>&nbsp;&nbsp;, CAST(AES_DECRYPT(UNHEX({{li.aliasNm}}.{{li.colNm}}), \'SALEVIS4\') AS CHAR) AS {{li.colNm}}</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;, CONV({{li.aliasNm}}.{{li.colNm}},10,36) AS {{li.colNm}}</span></div><span>FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&lt;where&gt;</span> <span>&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&lt;/where&gt;</span> <span>&lt;/select&gt;</span><br><span>&lt;insert id=\"insert{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>&lt;selectKey keyProperty=\"RelateDataId\" resultType=\"java.lang.String\" order=\"BEFORE\"&gt;<br><span>SELECT conv(FLOOR(100000000000000 + RAND() * 899999999999999), 10, 36) AS RelateDataId<br><span>&lt;/selectKey&gt;<br><br><span>INSERT INTO {{vc.tbMain.tableNm}}</span> <span>(</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\"><span style=\"display: block\" ng-if=\"$index == 0\">&nbsp;&nbsp;&lt;if test=\'RelateDataId != null and {{li.colNm}} != \"\"\'&gt;{{li.colNm}}&lt;/if&gt; </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'regdate\' && li.colNm.toLowerCase() != \'useyn\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> , {{li.colNm}} <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&lt;/if&gt;</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> , {{li.colNm}} <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&lt;/if&gt;</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() == \'reguser\'\">&nbsp;&nbsp;, {{li.colNm}} </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() == \'regdate\'\">&nbsp;&nbsp;, {{li.colNm}} </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">&nbsp;&nbsp;, {{li.colNm}} </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">&nbsp;&nbsp;, {{li.colNm}} </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'useyn\'\">&nbsp;&nbsp;, UseYN</span></div><span>) VALUES (</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\"><span style=\"display: block\" ng-if=\"$index == 0\">&nbsp;&nbsp;&lt;if test=\'RelateDataId != null and {{li.colNm}} != \"\"\'&gt;CONV(#{RelateDataId}, 36, 10)&lt;/if&gt; </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'regdate\'  && li.colNm.toLowerCase() != \'useyn\' \"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> <span ng-if=!li.checkedC style=\"display: inline-block\">&nbsp;&nbsp;, #{ {{li.colNm}} }</span> <span ng-if=\"li.checkedC && li.colNm !=\'Email\'\" style=\"display: inline-block\">&nbsp;&nbsp;, HEX(AES_ENCRYPT(REPLACE( #{ {{li.colNm}} }, \'-\', \'\'), \'SALEVIS4\'))</span> <span ng-if=\"li.checkedC && li.colNm ==\'Email\'\" style=\"display: inline-block\">&nbsp;&nbsp;, HEX(AES_ENCRYPT(#{ {{li.colNm}} }, \'SALEVIS4\'))</span> <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;/if&gt;</span> </span><span style=\"display: block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> ,CONV(#{ {{li.colNm}} }, 36, 10) <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&nbsp;&nbsp;&lt;/if&gt;</span> </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'regdate\'\">&nbsp;&nbsp;, NOW() </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'reguser\'\">&nbsp;&nbsp;, CONV(#{ SESSION_USERID }, 36, 10) </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">&nbsp;&nbsp;, \'N\' </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'useyn\'\">&nbsp;&nbsp;, \'Y\' </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">&nbsp;&nbsp;, CONV(#{ srchTenantId }, 36, 10)</span></div><span>)</span> <span>&lt;/insert&gt;</span><br><!-- <set>\r\n              <if test=\'CustId != null\'>CustId = CONV(#{CustId}, 36, 10),</if>\r\n              <if test=\'CustNm != null\'>CustNm = #{CustNm},</if>\r\n              <if test=\'AprvStatus != null\'>AprvStatus = #{AprvStatus},</if>\r\n              <if test=\'PurchDate != null\'>PurchDate = #{PurchDate},</if>\r\n              <if test=\'SalesType != null\'>SalesType = #{SalesType},</if>\r\n              <if test=\'PurchType != null\'>PurchType = #{PurchType},</if>\r\n              <if test=\'CareTktId != null\'>CareTktId = CONV(#{CareTktId}, 36, 10),</if>\r\n              <if test=\'CareTktQty != null\'>CareTktQty = #{CareTktQty},</if>\r\n              <if test=\'CareTktUnitPrc != null\'>CareTktUnitPrc = #{CareTktUnitPrc},</if>\r\n              <if test=\'CareTktAmt != null\'>CareTktAmt = #{CareTktAmt},</if>\r\n              <if test=\'ProductId != null\'>ProductId = #{ProductId},</if>\r\n              <if test=\'ProductQty != null\'>ProductQty = #{ProductQty},</if>\r\n              <if test=\'ProductUnitPrc != null\'>ProductUnitPrc = #{ProductUnitPrc},</if>\r\n              <if test=\'ProductAmt != null\'>ProductAmt = #{ProductAmt},</if>\r\n              <if test=\'SellType != null\'>SellType = #{SellType},</if>\r\n              <if test=\'Cntct != null\'>Cntct = #{Cntct},</if>\r\n              <if test=\'InflowPath != null\'>InflowPath = #{InflowPath},</if>\r\n              <if test=\'PayMeth != null\'>PayMeth = #{PayMeth},</if>\r\n              <if test=\'SellerId != null\'>SellerId = CONV(#{SellerId}, 36, 10),</if>\r\n              <if test=\'SptUserId != null\'>SptUserId = CONV(#{SptUserId}, 36, 10),</if>\r\n              <if test=\'ProductBarCdNo != null\'>ProductBarCdNo = #{ProductBarCdNo},</if>\r\n              <if test=\'PayAprvNo != null\'>PayAprvNo = #{PayAprvNo},</if>\r\n              <if test=\'CardNo4Digits != null\'>CardNo4Digits = #{CardNo4Digits},</if>\r\n              <if test=\'SESSION_SYSADMIN == \"Y\" and TenantId != null and TenantId != \"\"\'>\r\n                  TenantId = conv(#{TenantId}, 36, 10),\r\n              </if>\r\n              EdtDate = CURRENT_TIMESTAMP,\r\n              EdtUser = CONV(#{SESSION_USERID}, 36, 10)\r\n          </set> --> <span>&lt;update id=\"update{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>UPDATE {{vc.tbMain.tableNm}}</span> <span>&lt;set></span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.priYn != \'Y\' && li.selectType == \'m\' && li.colNm.toLowerCase() != \'regdate\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'deluser\'\"><span style=\"display: block\" ng-if=\"li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'tenantid\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\' && li.priYn != \'Y\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> {{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10), <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&lt;/if&gt;</span> </span><span style=\"display: block\" ng-if=\"li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'edtuser\'\"><span ng-if=\"li.checkedN && !li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null\'&gt;</span> <span ng-if=\"li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;</span> <span ng-if=\"!li.checkedN && li.checkedE\" style=\"display: inline-block\">&lt;if test=\'{{li.colNm}} != \"\"\'&gt;</span> <span ng-if=!li.checkedC style=\"display: inline-block\">{{li.colNm}} = #{ {{li.colNm}} },</span> <span ng-if=\"li.checkedC && li.colNm !=\'Email\'\" style=\"display: inline-block\">{{li.colNm}} = HEX(AES_ENCRYPT(REPLACE( #{ {{li.colNm}} }, \'-\', \'\'), \'SALEVIS4\'))</span> <span ng-if=\"li.checkedC && li.colNm ==\'Email\'\" style=\"display: inline-block\">{{li.colNm}} = HEX(AES_ENCRYPT(#{ {{li.colNm}} }, \'SALEVIS4\'))</span> <span ng-if=\"li.checkedN || li.checkedE\" style=\"display: inline-block\">&lt;/if&gt;</span> </span><!-- <span style=\"display: block;\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">\r\n                {{li.colNm}} = CONV(#{srchTenantId}, 36, 10),\r\n              </span> --> <span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'edtdate\'\">{{li.colNm}} = NOW(), </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'edtuser\'\">{{li.colNm}} = CONV(#{ SESSION_USERID }, 36, 10), </span><span style=\"display: block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = #{ {{li.colNm}} },&lt;/if><br>&lt;if test=\'DelYN != null and {{li.colNm}} == \"Y\"\'>DelDate = NOW(), DelUser =CONV(#{ SESSION_USERID }, 36, 10), &lt;/if> </span><!-- <span style=\"display: block;\" ng-if=\"li.colNm.toLowerCase() == \'deldate\'\">\r\n                {{li.colNm}} = NOW(),&lt;/if>\r\n              </span> --></div><span>&lt;/set></span> <span>&lt;where&gt;</span> <span>&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&lt;/where&gt;</span> <span>&lt;/update&gt;</span><br><span ng-bind-html=vc.mapperend></span></span></span></span></span></span></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/system/menu/menu-manage-list.html","<style>.left-context, .right-context {\r\n  padding-top:5px;\r\n}\r\n\r\n.left-context .panel-body{\r\n  background:#e7edf3;\r\n}\r\n.left-context .panel-default {\r\n  margin-top:0px;\r\n  margin-bottom:0px;\r\n}\r\n.left-context .no-style {padding:0px; border:none;}\r\n.as-sortable-item {\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  /* to disable context menu on iOS devices */\r\n  -webkit-touch-callout: none;\r\n  /* margin-top: 2px; */\r\n  position:relative;\r\n}\r\n.as-sortable-item, .as-sortable-placeholder {\r\n    display: block;\r\n}\r\n.as-sortable-item-text {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 6px 0px 6px 6px;\r\n}\r\n.as-sortable-item-handle {\r\n    cursor: move;\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n}\r\n.subTextmenu {\r\n  position: absolute;\r\n  right: 7px;\r\n  top: 7px;\r\n  font-size: 12px;\r\n  color : #bdbdbd;\r\n  display: none;\r\n}\r\n.subTextmenu span:hover {\r\n  color: #378AD8\r\n}\r\n.as-sortable-placeholder {}\r\n.as-sortable-drag {\r\n    position: absolute;\r\n    pointer-events: none;\r\n    z-index: 9999;\r\n}\r\n.as-sortable-hidden {\r\n    display: none !important;\r\n}\r\n.as-sortable-un-selectable {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n.left-context *:focus {\r\n    outline: none;\r\n}\r\n#sortableOptions1 {\r\n  padding:5px;\r\n}\r\n.edit-layout {\r\n  display: none;\r\n  position:relative;\r\n  border: solid 1px #c5cdd7;\r\n  padding : 4px 0px 4px 15px;\r\n}\r\n.edit-layout input {\r\n  width: 100%;\r\n  padding : 4px 0px 4px 3px;\r\n  border : solid 1px #d8d8d8;\r\n}\r\n.edit-layout input:focus {\r\n  border : solid 1px #64aef8;\r\n}\r\n.edit-layout .subBtnWrap {\r\n  position:absolute;\r\n  right : 3px;\r\n  top : 9px;\r\n}\r\n.edit-layout .subBtnWrap span {\r\n  color : #999;\r\n  border: solid 1px #ccc;\r\n  padding:5px 10px 5px 10px;\r\n}\r\n.edit-layout .subBtnWrap span.okBtn {\r\n  border: solid 1px #EC5621;\r\n  background : #EC5621;\r\n  color : #FFF;\r\n}\r\n.edit-layout .subBtnWrap span.disable {\r\n  color : #ccc;\r\n  border: solid 1px #eee;\r\n  background : #EEE;\r\n}\r\n\r\n.importantHidden {display: none !important;}\r\n\r\n#iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n\r\n.disable-master {\r\n  background:#c9c9c9 !important;\r\n  color :#999;\r\n}\r\n\r\n.right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n\r\n.depth-two {display: none;}\r\n.depth-three {display: none;}\r\n\r\n\r\n.right-panel-fixed-size-top {\r\n  position:fixed;\r\n  top: 60px;\r\n  padding-right:15px !important;\r\n}\r\n\r\n.right-panel-fixed-size-bottom {\r\n  position:fixed;\r\n  bottom: 0px;\r\n  padding-right:15px !important;\r\n  bottom:0px;\r\n}\r\n\r\n.visible-use-group {\r\n  background:#FFF  !important;\r\n}\r\n.visible-group {\r\n  /* background:#c6e2ff  !important; */\r\n}\r\n\r\n.visible-group .as-sortable-item-text {\r\n  background:#c6e2ff  !important;\r\n  display: block;\r\n}\r\n\r\n.invisible-group {\r\n  display: none !important;\r\n}\r\n\r\n.visible {\r\n  display:block;\r\n}\r\n\r\n#mapperWrap input {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#roleTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#conditionsTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n.menu-name-tx {cursor:pointer;}\r\n.depth-three i {cursor:pointer;}\r\n\r\n.noti-pre {\r\n  border:solid 1px #EEE;\r\n  margin-top:8px;\r\n  background:#EEE;\r\n  padding: 8px;\r\n}\r\n\r\n.noti-pre span {\r\n  display:block;\r\n}</style><div ng-controller=\"MenuManageCtrl as vc\" class=\"menuManageView page page-footable\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=page-header>메뉴관리</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-4 col-xl-3 left-context\"><div class=panel-default><div class=panel-body id=sortableOptions style=\"padding:3px 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=false style=\"padding: 0 3px\"><select class=form-control ng-model=vc.selectedGroupOptions ng-options=\"option.commonCodeId as option.codeNm for option in vc.radioMenuType\" ng-change=vc.onChamgeGroupView(vc.selectedGroupOptions)><option value=\"\">전체메뉴</option></select></div><div id=sortableContainer><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding: 0 3px\" as-sortable=vc.sortableOptions ng-model=vc.menuList><div style=background:#FFF ng-mouseover=\"vc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"vc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ vc.menuTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-click=\"vc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in vc.menuList\" as-sortable-item=vc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=vc.setDetailView(item) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item.menuId)\" menu-sort={{item.sort}} menu-sortpath={{item.sortPath}} ng-if=\"item.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item.menuId }}\"><i class=\"extend-btn fa fa-fw fa-plus\" ng-if=\"item.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.menuNm}}</span><div class=subTextmenu id=subMenu_{{item.menuId}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item.useYn == \'\' || item.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(1, item.menuId)\">추가</span> | <span ng-click=\"vc.delChild(1, item)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성</span></div><div ng-if=\"item.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(1, item)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item.child style=margin-left:15px><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=vc.setDetailView(item2) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item2.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item2.menuId)\" menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item2.menuId }}\"><i class=\"extend-btn fa fa-fw fa-plus\" ng-if=\"item2.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item2.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.menuNm}}</span><div class=subTextmenu id=subMenu_{{item2.menuId}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item2.useYn == \'\' || item2.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(2, item2.menuId)\">추가</span> | <span ng-click=\"vc.delChild(2, item2)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item2.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성</span></div><div ng-if=\"item2.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(2, item2)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=vc.setDetailView(item3) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item3.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item3.menuId)\" menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.delYn!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.menuId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.menuNm}}</span><div class=subTextmenu id=subMenu_{{item3.menuId}} menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item3.useYn == \'\' || item3.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.delChild(3, item3)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item3.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성</span></div><div ng-if=\"item3.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(3, item3)\">Edit</span> --></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.menuId}} menu-path={{item2.path}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth03title input-enter=\"vc.addMenuItem(3, \'editor\'+item2.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(3, \'editor\'+item2.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(3, \'editor\'+item2.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item.menuId}} menu-path={{item.path}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth02title input-enter=\"vc.addMenuItem(2, \'editor\'+item.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(2, \'editor\'+item.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(2, \'editor\'+item.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth01title input-enter=\"vc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(1, \'editorDepth01\')\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(1, \'editorDepth01\')\">확인</span></div><div style=clear:both></div></div></div><!-- End Menu Tree --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding: 0px\"><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setChangeMenuList(); style=\"width:100%; margin-top:6px; height:35px\"><i class=\"fa fa-edit\"></i> 리스트 순서 변경</button></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-6 col-lg-8 col-xl-9 right-context\"><div class=\"panel panel-default\" style=border:none><div class=\"panel-body root-panel-body\" style=padding:0px><ul class=\"nav nav-tabs\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab style=\"cursor: pointer\">기본정보</a></li><li><a ng-click=vc.setChangeTab(1); data-toggle=tab style=\"cursor: pointer\">권한정보</a></li></ul><div class=tab-content><!-- Start First Tab Content --><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><!-- Start 메뉴그룹 --><div class=row ng-if=\"vc.SysAdmin \"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴그룹</div><div class=panel-body style=padding:8px><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=\"radio-inline pl-0 pr-15\" ng-repeat=\"mt in vc.radioMenuType\"><input type=checkbox class=clr ng-model=mt.checked ng-disabled=\"vc.mSrchTenentID != \'0\'\"> {{ mt.codeNm}}</label></div><!-- End Body --></div></div></div></div><!-- End 메뉴그룹 --><!-- Start 메뉴정보 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴정보</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\"><div class=form-group><label class=ng-binding>메뉴명</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.menuNm aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.SysAdmin><div class=form-group><label class=ng-binding>다국어 키</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.translateCode aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.menuInfo.levelYn><div class=form-group><label class=ng-binding>접근권한등급</label><div><select class=form-control ng-model=vc.menuInfo.roleLevel ng-options=\"option.commonCodeId as option.codeNm for option in vc.roleLevelList\"><option value=\"\">권한등급</option></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=vc.menuInfo.levelYn><div class=noti-pre><span>* 접근권한등급이 Level 0일 경우 권한정보에 영향을 받지않고 활성화 됩니다.</span> <span>* 접근권한등급이 지정되지 않을경우 사용자의 기본 등급인 1의 값으로 설정됩니다.</span></div></div><!-- End Body --></div></div></div></div><!-- End 메뉴정보 --><!-- Start 연관페이지 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관페이지</div><div class=panel-body><!-- Start Body --><table id=searchTextResults class=\"table table-custom minWidth-1200\"><thead><tr><th data-toggle=true class=tx-center style=width:50px>메인</th><th data-toggle=true class=tx-center>페이지명</th><th data-toggle=true class=tx-center>페이지URL</th><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">매개변수</th><!-- <th data-toggle=\"true\" class=\"tx-center\">새창여부</th> --><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">삭제</th></tr></thead><tbody ng-if=vc.menuInfo.pages><tr ng-repeat=\"li in vc.menuInfo.pages\" style=\"cursor: pointer\"><td class=text-center><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=margin-top:-8px><label class=radio-inline><input type=radio name=pageMain id=page ng-model=li.mainYn value={{$index}} ng-checked=\"li.mainYn == \'Y\'\"></label></div></td><td class=text-center><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.screenNm aria-invalid=false></td><td class=text-left><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrl aria-invalid=false></td><td class=text-left ng-if=\"vc.viewMode == \'A\'\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrlParam aria-invalid=false></td><!-- <td class=\"tx-center\">\r\n                                <select class=\"form-control\"\r\n                                  ng-model=\"li.newWindowYn\"\r\n                                  ng-options=\"option.value as option.codeNm for option in vc.selectNewWindowYn\"\r\n                                  ng-change=\"vc.onChangeNewWindowYn(li)\">\r\n                                </select>\r\n                              </td> --><td class=tx-center ng-if=\"vc.viewMode == \'A\'\"><span ng-if=\"li.delYn == \'N\'\" ng-click=\"vc.delPage(li, $index)\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"vc.delPage(li, $index)\">취소</span></td></tr></tbody><tbody ng-if=\"vc.menuInfo.length == 0 || vc.menuInfo.pages.length == 0\"><tr><td colspan=5 class=tx-center style=padding:8px>연관페이지가 있을 경우 등록하세요.</td></tr></tbody></table><!-- End Body --></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addPage()><i class=\"fa fa-edit\"></i> 페이지 추가</button></div></div></div></div><!-- End 연관페이지 --><!-- Start 연관설문 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\' && vc.mobileOnlyYN == \'Y\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관설문</div><div class=panel-body><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.menuSvyChkHead ng-change=menuSvyChkHeadChg()></th><th class=\"text-center none\" style=width:10%>제목</th><th class=\"text-center none\" style=width:10%>구분</th><th class=\"text-center none\" style=width:10%>통과점수</th><th class=\"text-center none\" style=width:10%>신규가입표시여부</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.menuSvyTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.menuSvyLists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.menuSvyChkRow ng-change=menuSvyChkRowChg()></td><td class=text-center style=vertical-align:middle>{{li.SvyNm}}</td><td class=text-center style=vertical-align:middle>{{li.SvyType_}}</td><td class=text-center style=vertical-align:middle>{{li.PassScore}}</td><td class=text-center style=vertical-align:middle>{{li.JoinShowYN}}</td></tr></table></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addMenuSvyModal()><i class=\"fa fa-edit\"></i> 설문 추가</button> <button class=\"btn btn-danger\" ng-click=vc.deleteMenuSvyList()><i class=\"fa fa-trash-o\"></i> 설문 삭제</button></div></div></div></div><!-- End 연관설문 --><!-- Start 아이콘 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>아이콘 <a href=http://fa2png.io/r/font-awesome/ target=_blank><i class=\"fa fa-info\"></i></a></div><div class=panel-body><!-- Start Body --><div ng-repeat=\"item in vc.fontList\" class=\"col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-3 {{item.active}}\"><span ng-click=vc.setChangeIcon(item.name);><i class=\"fa {{ item.name }}\"></i> {{item.name}}</span></div><!-- End Body --></div><div class=panel-footer ng-if=vc.SysAdmin><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-6 col-xl-5\" style=\"padding-top:3px; padding-right:0px\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.addInputFa aria-invalid=false></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1\" style=padding-top:3px><i id=viewFontIcon class=\"fa {{vc.addInputFa}}\" style=font-size:30px></i></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 tx-right\" style=\"padding-top:3px; padding-right:3px\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setFa()><i class=\"fa fa-edit\"></i> Font Awesome 추가</button></div><div style=clear:both></div></div></div></div></div><!-- End 아이콘 --><!-- Start 메모 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴 설명</div><div class=panel-body><textarea class=form-control row=3 cols=50 ng-model=vc.menuInfo.remark></textarea></div></div></div></div><!-- End 메모 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.invalidBaseInfo()><i class=\"fa fa-edit\"></i> 저장</button></div></div><!-- End First Tab Content --></div><div class=\"tab-pane fade {{ vc.showTabView[1] }}\"><!-- Start 연관페이지 선택 --><div class=row ng-if=vc.SysAdmin><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관 페이지 선택</div><div class=panel-body><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=radio-inline ng-repeat=\"pi in vc.menuInfo.pages\"><input type=radio name=optionMenuType id=tenantPageType ng-model=pi.choicePage value={{pi.menuPageId}} ng-click=vc.loadPageData(pi)> {{ pi.screenNm}}({{ pi.pageUrl}})</label></div><!-- End Body --></div></div></div></div><!-- END 연관페이지 선택 --><!-- Start SQLMapper 관리 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>SQL Mapper 관리</div><div class=panel-body><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.getLoadSqlMapper()><i class=\"fa fa-edit\"></i> File 불러오기</button> <button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addSqlMapper()><i class=\"fa fa-edit\"></i> Mapper 추가</button></div><table class=\"footable table\" id=mapperWrap><thead><tr><th class=tx-center>SQLMapper</th><th class=tx-center style=width:80px>사용여부</th><th class=tx-center style=width:80px>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.sqlMapper\"><td class=text-left style=padding-left:5px><input type=text ng-model=li.sqlCode></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre>* 페이지 추가 : 해당 페이지의 ctrl.js 파일을 로드시 postApi로 지정된 SqlMapper를 불러올 수 있습니다.</div><!-- Start Body --><!-- End Body --></div></div></div></div><!-- END SQLMapper 관리 --><!-- Start 프로그램 관리 --><div class=row ng-if=\"vc.SysAdmin && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>상세조건 관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addCondition()><i class=\"fa fa-edit\"></i> 조건 추가히기</button></div><table id=conditionsTable class=\"footable table table-custom\"><thead><tr><th data-toggle=true class=tx-center style=width:30%>조건</th><th data-toggle=true class=tx-center style=width:30%>비교값</th><th data-toggle=true class=tx-center style=width:30%>패스여부</th><th data-toggle=true class=tx-center style=width:30%>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.conditions\" style=\"cursor: pointer\"><td class=text-center><input type=text ng-model=li.condition></td><td class=text-center><input type=text ng-model=li.value></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre><span>* \'조건 = 비교값\' 혹은 \'조건 ≠ 비교값\' 의 설정은 패스여부의 체크박스를 통하여 수정할 수 있습니다.</span> <span>* SESSION, srchTenantId 혹은 기타 전달 값을 통하여 비교연산을 하실 수 있습니다.</span></div><!-- End Body --></div></div></div></div><!-- END 프로그램 관리 --><!-- Start 역할관리 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>화면권한관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setChangeEdtLabel()><i class=\"fa fa-edit\"></i> {{vc.checkEdtLabelText}}</button></div><table id=roleTable class=\"footable table table-custom\" style=\"table-layout: fixed\"><thead><tr><th class=tx-center>역할명</th><th class=tx-center>조회</th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn01Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn01Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn02Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn02Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn03Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn03Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn04Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn04Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn05Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn05Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn06Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn06Text ng-if=vc.checkEdtLabel></th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.screen\"><td class=text-left><span>{{li.RoleNm}}</span></td><td class=text-center><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table><!-- End Body --></div></div></div></div><!-- End 역할관리 --><div class=row ng-if=\"vc.choiceRolePage != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setRoleData();><i class=\"fa fa-edit\"></i> 저장</button></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/migration/migration-list-view.html","<script src=https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.14.3/xlsx.full.min.js></script><style>table th {padding:8px; text-align: center; background:#CCC; color:#FFF; font-weight: 800;}\r\n  table td {padding:8px; text-align: center; border-top:solid 1px #CCC}\r\n  .category-title { font-size: 22px; font-weight: 800; padding-top: 3px; }\r\n  .noti {margin-top: 5px; padding:8px; background:#f1f3f5; line-height: 25px;}</style><div ng-controller=\"SysExcelMigrationCtrl as vc\" class=page><div class=dataloader ng-show=vc.dataloader></div><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>기관 업로드</strong></div><div class=\"panel-body collapse in\"><!-- <div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" id=\"tenantWrap\"></div> --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><input type=file id=excelFile1 style=\"width: 50%; border: solid 1px #CCC; display:inline-block\"><div ng-click=\"vc.excelExport(\'T\')\" style=\"font-size:18px; color:#666; margin-left: 25px; display: inline-block\">엑셀업로드</div></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" ng-bind=vc.msg1></div></div></div><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>대상자 업로드</strong></div><div class=\"panel-body collapse in\"><!-- <div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" id=\"tenantWrap\"></div> --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><input type=file id=excelFile2 style=\"width: 50%; border: solid 1px #CCC; display:inline-block\"><div ng-click=\"vc.excelExport(\'S\')\" style=\"font-size:18px; color:#666; margin-left: 25px; display: inline-block\">엑셀업로드</div></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" ng-bind=vc.msg2></div></div></div><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>임직원 업로드</strong></div><div class=\"panel-body collapse in\"><!-- <div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" id=\"tenantWrap\"></div> --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><input type=file id=excelFile3 style=\"width: 50%; border: solid 1px #CCC; display:inline-block\"><div ng-click=\"vc.excelExport(\'U\')\" style=\"font-size:18px; color:#666; margin-left: 25px; display: inline-block\">엑셀업로드</div></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" ng-bind=vc.msg3></div></div></div><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>상담일지 업로드</strong></div><div class=\"panel-body collapse in\"><!-- <div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" id=\"tenantWrap\"></div> --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><input type=file id=excelFile4 style=\"width: 50%; border: solid 1px #CCC; display:inline-block\"><div ng-click=\"vc.excelExport(\'C\')\" style=\"font-size:18px; color:#666; margin-left: 25px; display: inline-block\">엑셀업로드</div></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\" ng-bind=vc.msg4></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"vc.errorTx != \'\'\" ng-bind-html=vc.errorTx style=color:#ff0000></div><!-- <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"vc.userData.length > 0 \">\r\n    <div class=\"category-title\">\r\n      고객정보\r\n      <div class=\"pull-right\" ng-if=\"vc.complet\">\r\n        <button class=\"btn btn-primary ng-scope\" ng-click = \"vc.tabIdx = 1;\">\r\n          <i class=\"fa fa-save\"></i> 고객데이터보기\r\n        </button>\r\n        <button class=\"btn btn-primary ng-scope\" ng-click = \"vc.tabIdx = 2;\">\r\n          <i class=\"fa fa-save\"></i> 상품데이터보기\r\n        </button>\r\n        <button class=\"btn btn-primary ng-scope\" ng-click=\"vc.setData();\">\r\n          <i class=\"fa fa-save\"></i> 저장\r\n        </button>\r\n        <button class=\"btn btn-primary ng-scope\" ng-click=\"vc.delData();\">\r\n          <i class=\"fa fa-trash-o\"></i> 마이그레이션초기화\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"noti\">\r\n      * 총 {{ vc.userData.length }}명의 사용자를 찾았습니다.<br>\r\n      * 총 {{ vc.itemData.length }}건의 결제 정보를 찾았습니다.<br>\r\n      * 날짜 형식일 경우 UTC 가 적용되는 값으로 저장됩니다.<br>\r\n    </div>\r\n    <table style=\"margin-top: 15px;\" ng-if=\"vc.tabIdx == 1\">\r\n      <colgroup>\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:135px\">\r\n        <col style=\"width:*\">\r\n      </colgroup>\r\n      <thead>\r\n        <tr>\r\n          <th>고객코드(CustId)</th>\r\n          <th>지점고객코드(TcId)</th>\r\n          <th>기존고객코드(OldCode)</th>\r\n          <th>고객코드</th>\r\n          <th>고객명(CustNm)</th>\r\n          <th>성별(Gender)</th>\r\n          <th>연락처(Mobile)</th>\r\n          <th>주소(Address)</th>\r\n          <th>고객메모(Memo)</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-repeat=\"cl in vc.uploadData.user\">\r\n          <td class=\"text-center\">{{cl.CustId}}</td>\r\n          <td class=\"text-center\">{{cl.TcId}}</td>\r\n          <td class=\"text-center\">{{cl.OldCode}}</td>\r\n          <td class=\"text-center\">{{cl.CustCode}}</td>\r\n          <td class=\"text-center\">{{cl.CustNm}}</td>\r\n          <td class=\"text-center\">{{cl.Gender}}</td>\r\n          <td class=\"text-center\">{{cl.Mobile}}</td>\r\n          <td class=\"text-center\">{{cl.Address}}</td>\r\n          <td class=\"text-left\">{{cl.Memo}}</td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n    <table style=\"margin-top: 15px;\" ng-if=\"vc.tabIdx == 2\">\r\n      <thead>\r\n        <tr>\r\n          <th>결제ID</th>\r\n          <th>지점고객코드</th>\r\n          <th>상품ID</th>\r\n          <th>결제일</th>\r\n          <th>담당트레이너</th>\r\n          <th>시작일</th>\r\n          <th>종료일</th>\r\n          <th>결제금액</th>\r\n          <th>카드납부</th>\r\n          <th>카드추가</th>\r\n          <th>카드할인</th>\r\n          <th>카드미수</th>\r\n          <th>카드결제</th>\r\n          <th>현금납부</th>\r\n          <th>현금추가</th>\r\n          <th>현금할인</th>\r\n          <th>현금미수</th>\r\n          <th>현금결제</th>\r\n          <th>등록일</th>\r\n          <th>결제메모</th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-repeat=\"cl in vc.uploadData.product\">\r\n          <td class=\"text-center\">{{cl.PaymentId}}</td>\r\n          <td class=\"text-center\">{{cl.TcId}}</td>\r\n          <td class=\"text-center\">{{cl.MembershipId}}</td>\r\n          <td class=\"text-center\">{{cl.PaymentDate}}</td>\r\n          <td class=\"text-center\">{{cl.Manager}}</td>\r\n          <td class=\"text-center\">{{cl.PeriodStartDate}}</td>\r\n          <td class=\"text-center\">{{cl.PeriodEndDate}}</td>\r\n          <td class=\"text-center\">{{cl.TotalCost}}</td>\r\n          <td class=\"text-center\">{{cl.CardPaidCost}}</td>\r\n          <td class=\"text-center\">{{cl.CardAdditionalCost}}</td>\r\n          <td class=\"text-center\">{{cl.CardSaleCost}}</td>\r\n          <td class=\"text-center\">{{cl.CardReceivables}}</td>\r\n          <td class=\"text-center\">{{cl.CardPaymentCost}}</td>\r\n          <td class=\"text-center\">{{cl.CashPaidCost}}</td>\r\n          <td class=\"text-center\">{{cl.CashAdditionalCost}}</td>\r\n          <td class=\"text-center\">{{cl.CashSaleCost}}</td>\r\n          <td class=\"text-center\">{{cl.CashReceivables}}</td>\r\n          <td class=\"text-center\">{{cl.CashPaymentCost}}</td>\r\n          <td class=\"text-center\">{{cl.RegDate}}</td>\r\n          <td class=\"text-left\">{{cl.Memo}}</td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div> --></div>");
$templateCache.put("app/system/notice/sys-notice-edit-view.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><!-- 페이지 스타일 정의 시작 --><style>.imageBox {\r\n    width: 275px;\r\n    height: 170px;\r\n    margin: 0 auto;\r\n    border:solid 1px #EEE;\r\n    margin-bottom: 18px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    max-width: 100%;\r\n  }\r\n  #emptyPhoto {\r\n    background-image: url(/assets/images/icon/gift-box.png);\r\n    background-size: 80% auto;\r\n  }\r\n \r\n .addShipOptionbtn {\r\n   display: inline-block;\r\n   background: #f4f4f4;\r\n   padding: 3px 5px;\r\n   border: solid 1px #CCC;\r\n }</style><!-- 페이지 스타일 정의 종료 --><!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"SysNoticEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><h3 class=page-header>{{ vc.titleNm }}</h3></div></div><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=vc.keyId><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">공지사항 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" id=inputWrap></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.notice.Contents></textarea></div></div></div></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n       \r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      //$(\"iframe\").css(\"height\", \'600px\')\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/system/notice/sys-notice-list-view.html","<div class=\"page page-footable\" ng-controller=\"SysNoticListCtrl as vc\"><!-- page header --><page-header></page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}} class=thumbnail-list><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Title placeholder=\"타이틀 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><list-table></list-table><!-- / Table row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/organization/organization-list-view.html","<style>.section-title  {\r\n    font-weight: bold;\r\n    margin-top:6px;\r\n    padding-left: 15px;\r\n    font-size: 15px;\r\n    color: #666666;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .Guide-col-wrap label {\r\n    display: none;\r\n  }\r\n\r\n  .Guide-col-wrap span {\r\n    margin-left: -120px !important;\r\n    width: 100px  !important;\r\n    text-align: center;\r\n    background: #7f8fa4;\r\n    color: #FFF;\r\n  }\r\n\r\n  .col-sm-12 .left-context .sortableContainer > div {\r\n    min-height: unset !important;\r\n  }</style><div class=\"page page-footable menuManageView\" ng-controller=\"SysOrganizationListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=page-header>조직관리</div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=panel-default style=border:none><div class=tab-content><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><div class=row style=margin-top:0px><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-3 left-context\"><organization-sortable-container init-callback=vc.succSortable bind-data=vc.datas link-data=vc.linkData max-depth=3></organization-sortable-container></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-9 right-context\"><div class=boardNothing ng-show=!vc.data.KeyId style=padding-top:40px><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>지점 및 부서(소부서)를 선택하시면 상세 내용을 보실 수 있습니다.</p></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\" ng-if=vc.data.KeyId><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row ng-show=vc.data.KeyId style=\"margin-top: 48px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=\"row mt-5\" ng-show=\"vc.data.KeyId && vc.data.Depth == \'1\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">포인트 설정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><style>#sec3 label {\r\n                            max-width: unset;\r\n                            width:140px;\r\n                          }\r\n\r\n                          #sec3 .input-group {\r\n                            margin-left:142px;\r\n                            width:30px;\r\n                          }</style><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><table style=\"width: auto\"><colgroup><col style=width:100px><col style=width:155px><col style=width:0px><col style=width:0px><col style=width:155px><col style=width:90px></colgroup><tr><td class=tx-right>일반 결제</td><td id=sec4></td><td>%</td><td></td><td id=sec5></td><td>%</td></tr><tr><td class=tx-right>정액권 충전 시</td><td id=sec6></td><td>%</td><td></td><td id=sec7></td><td>%</td></tr><tr><td class=tx-right>횟수권 충전 시</td><td id=sec8></td><td>%</td><td></td><td id=sec9></td><td>%</td></tr></table></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/personal/accountLock-list.html","<div class=\"page page-footable\" ng-controller=\"AccountLockListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>계정잠김현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>개인정보 운영설정</a></li><li><a>계정잠김현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtStartSecondDate ng-change=\"vc.srch.StartRegDate = (dtStartSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtEndSecondDate ng-change=\"vc.srch.EndRegDate = (dtEndSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><input type=text class=form-control ng-model=vc.srch.LoginId placeholder=아이디></div></div><div class=col-lg-2><md-checkbox md-no-ink=\"\" aria-label=계정잠김여부 ng-model=vc.srch.LockYN class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>계정잠김여부</md-checkbox></div><div class=col-lg-2><md-checkbox md-no-ink=\"\" aria-label=\"임시비밀번호 발송여부\" ng-model=vc.srch.SmsYN class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>임시비밀번호 발송여부</md-checkbox></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>페이지당목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true class=text-center>계정잠김일자</th><th data-toggle=true class=text-center>계정잠김시간</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>계정잠김여부</th><th data-toggle=true class=text-center>임시비밀번호 발송여부</th><th class=text-center>임시비밀번호 발송</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td class=\"text-center mid-align\"><span ng-bind=li.RegDate></span></td><td class=\"text-center mid-align\"><span ng-bind=li.RegTime></span></td><td class=\"text-center mid-align\"><span ng-bind=li.LoginId></span></td><td class=\"text-center mid-align\"><span ng-bind=li.UserNm></span></td><td class=\"text-center mid-align\"><span ng-bind=li.LockYN></span></td><td class=\"text-center mid-align\"><span ng-bind=li.SmsYN></span></td><td class=\"text-center mid-align\" ng-switch=li.SmsYN><button ng-switch-when=N class=\"btn btn-slategray btn-ef btn-ef-7b\" ng-click=vc.sendMsg(li)>발송</button> <span ng-switch-default>발송완료</span></td></tr></tbody><tfoot><tr><td colspan=7 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/personal/permissionInfo-list.html","<script>$(document).ready(function () {\r\n    var date = new Date();\r\n    var getYear = date.getFullYear();\r\n\r\n    var startYear = 2021;\r\n    var endYear = getYear;\r\n\r\n    $(\'#p_year\').append(\"<option value=\'\'>전체</option>\'\");\r\n    for (var i = endYear; i >= startYear; i--) {\r\n      $(\'#p_year\').append(\"<option value=\'\" + i + \"\'>\" + i + \'</option>\');\r\n    }\r\n  });</script><div class=\"page page-footable\" ng-controller=\"PermissionInfoListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>계정신청현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>개인정보 운영설정</a></li><li><a>계정신청현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><div class=input-group><label class=section-auto>년도별</label><select class=\"form-control select-auto\" name=p_year id=p_year ng-model=vc.srch.year></select></div></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>페이지당목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true class=text-center>번호</th><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>전화번호</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>소속(업체명)</th><th data-toggle=true class=text-center>신청일시</th><th data-toggle=true class=text-center>승인일시</th><th data-toggle=true class=text-center>말소일시</th><th data-toggle=true class=text-center>생성자</th><th data-toggle=true class=text-center>승인자</th><th data-toggle=true class=text-center>확인자</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td class=\"text-center mid-align\"><span ng-bind=li.num></span></td><td class=\"text-center mid-align\"><span ng-bind=li.name></span></td><td class=\"text-center mid-align\"><span ng-bind=li.tel></span></td><td class=\"text-center mid-align\"><span ng-bind=li.id></span></td><td class=\"text-center mid-align\"><span ng-bind=li.coName></span></td><td class=\"text-center mid-align\"><span ng-bind=li.regDt></span></td><td class=\"text-center mid-align\"><span ng-bind=li.confirmDt></span></td><td class=\"text-center mid-align\"><span ng-bind=li.delDt></span></td><td class=\"text-center mid-align\"><span ng-bind=li.regNm></span></td><td class=\"text-center mid-align\"><span ng-bind=li.confirmNm></span></td><td class=\"text-center mid-align\"><span ng-bind=li.confirmNm2></span></td></tr></tbody><tfoot><tr><td colspan=10 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/personal/personalinfo-edit.html","<div class=\"page page-footable\" ng-controller=\"PersonalInfoEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>시스템 설정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>개인정보 운영설정</a></li><li><a>시스템 설정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i>저장</button></div></div></div><div class=row><!-- <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>업무시간 설정(다운로드 사유 미입력 시간)</label>\r\n                    <div class=\"input-group\">\r\n                      <div class=\"input-group\">\r\n                        <common-code\r\n                          param-data=\"vc.DownloadStartHourList\"\r\n                          callback=\"vc.onSelectCallback\"\r\n                        ></common-code>\r\n                      </div>\r\n                      <div class=\"input-group-addon input_group_split\">:</div>\r\n                      <div class=\"input-group\">\r\n                        <common-code\r\n                          param-data=\"vc.DownloadStartMinuteList\"\r\n                          callback=\"vc.onSelectCallback\"\r\n                        ></common-code>\r\n                      </div>\r\n                      <div class=\"input-group-addon input_group_split\">~</div>\r\n                      <div class=\"input-group\">\r\n                        <common-code\r\n                          param-data=\"vc.DownloadEndHourList\"\r\n                          callback=\"vc.onSelectCallback2\"\r\n                        ></common-code>\r\n                      </div>\r\n                      <div class=\"input-group-addon input_group_split\">:</div>\r\n                      <div class=\"input-group\">\r\n                        <common-code\r\n                          param-data=\"vc.DownloadEndMinuteList\"\r\n                          callback=\"vc.onSelectCallback2\"\r\n                        ></common-code>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=col-lg-4><div class=form-group><label>세션유지시간(분)</label><input type=text class=form-control ng-model=vc.data.SessionMinute placeholder=세션유지시간(분) ng-change=\"vc.data.SessionMinute = vc.numberOnly(vc.data.SessionMinute)\"></div></div></div><!-- <div class=\"row\">\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>교육원 내부 접속 IP</label>\r\n                    <textarea\r\n                      class=\"form-control\"\r\n                      ng-model=\"vc.data.AllowIP\"\r\n                      rows=\"5\"\r\n                      placeholder=\"교육원 내부 접속  IP\"\r\n                    ></textarea>\r\n                    <label\r\n                      >※ 줄바꿈으로 IP구분 (0.0.X.X, 0.0.0.X 로 대역대\r\n                      설정가능)<br />※ 등록된 IP 대역에서 로그인시 2차 SMS 인증\r\n                      진행 없이 로그인</label\r\n                    >\r\n                  </div>\r\n                </div>\r\n              </div> --></form></div><!-- /tile --></div><!-- /col --></div></div><!-- /page content --></div></div>");
$templateCache.put("app/system/personal/personalinfo-list.html","<div class=\"page page-footable\" ng-controller=\"PersonalInfoListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>개인정보 다운로드 이력</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>개인정보 운영설정</a></li><li><a>개인정보 다운로드 이력</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>일자</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtStartDownloadDate ng-change=\"vc.srch.StartDownloadDate = (dtStartDownloadDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtEndDownloadDate ng-change=\"vc.srch.EndDownloadDate = (dtEndDownloadDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>사용자명</label><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명></div></div><div class=col-lg-4><div class=form-group><label>소속</label><input type=text class=form-control ng-model=vc.srch.CompanyNm placeholder=소속></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.srch.LoginId placeholder=아이디></div></div><div class=\"pull-right col-lg-4\"><md-checkbox md-no-ink=\"\" aria-label=\"다운로드 사유 기재건만\" ng-model=vc.srch.DownloadReasonYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"pull-right md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>다운로드 사유 기재건만</md-checkbox></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button><!-- \r\n                  <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button=\"\" ui-sref=\"app.system.user-edit({UserId:\'\'})\" ng-show=\"showBtnAdd\">\r\n                    <i class=\"fa fa-edit\"></i> 추가\r\n                  </button>\r\n                   --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>페이지당목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true class=text-center>일시</th><th data-toggle=true class=text-center>사용자명</th><th data-toggle=true class=text-center>소속</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>접속IP</th><th data-toggle=true class=text-center>다운로드메뉴</th><th data-toggle=true class=text-center>다운로드사유</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td class=text-center><span ng-bind=li.DownloadDate></span> <span ng-bind=li.DownloadTime></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.CompanyNm></span></td><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.DownloadIP></span></td><td class=text-center><span ng-bind=li.DownloadMenu></span></td><td class=text-center><span ng-bind=li.DownloadReason></span></td></tr></tbody><tfoot><tr><td colspan=6 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/personal/personalSms-list.html","<div class=\"page page-footable\" ng-controller=\"PersonalSmsListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>인증번호 발송현황(알림톡)</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>개인정보 운영설정</a></li><li><a>인증번호 발송현황(알림톡)</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>일자</label><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtStartSecondDate ng-change=\"vc.srch.StartSecondDate = (dtStartSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtEndSecondDate ng-change=\"vc.srch.EndSecondDate = (dtEndSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-4><div class=form-group><label>사용자명</label><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명></div></div><div class=col-lg-4><div class=form-group><label>소속</label><input type=text class=form-control ng-model=vc.srch.CompanyNm placeholder=소속></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.srch.LoginId placeholder=아이디></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcelDownloadCheckYn() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button><!-- \r\n                  <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button=\"\" ui-sref=\"app.system.user-edit({UserId:\'\'})\" ng-show=\"showBtnAdd\">\r\n                    <i class=\"fa fa-edit\"></i> 추가\r\n                  </button>\r\n                   --></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>페이지당목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-toggle=true class=text-center>일자</th><th data-toggle=true class=text-center>시간</th><th data-toggle=true class=text-center>사용자명</th><th data-toggle=true class=text-center>소속</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>접속IP</th><th data-toggle=true class=text-center>인증번호</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td class=text-center><span ng-bind=li.SecondDate></span></td><td class=text-center><span ng-bind=li.SecondTime></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.CompanyNm></span></td><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.SecondIP></span></td><td class=text-center><span ng-bind=li.SecondNumber></span></td></tr></tbody><tfoot><tr><td colspan=6 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/personal/visitLog-list.html","<div class=\"page page-footable\" ng-controller=\"VisitLogListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>방문자현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>방문자현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtStartSecondDate ng-change=\"vc.srch.StartRegDate = (dtStartSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtEndSecondDate ng-change=\"vc.srch.EndRegDate = (dtEndSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=col-lg-2><select class=form-control ng-model=vc.srch.type><option value=D>일별현황</option><option value=M>월별현황</option><option value=Y>년도별현황</option></select></div><div class=col-lg-2><md-checkbox md-no-ink=\"\" aria-label=\"휴일 제외\" ng-model=vc.srch.notWeekend class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>휴일 제외</md-checkbox></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter class=\"table table-custom table-striped\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th rowspan=2 class=text-center>기간</th><th rowspan=2 class=text-center>방문자수</th><th colspan=2 class=text-center>접속기기</th></tr><tr><th class=text-center>PC</th><th class=text-center>MOBILE</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><td class=\"text-center mid-align\"><span ng-bind=li.date></span></td><td class=\"text-center mid-align\"><span ng-bind=li.tot></span></td><td class=\"text-center mid-align\"><span ng-bind=li.pc></span></td><td class=\"text-center mid-align\"><span ng-bind=li.mobile></span></td></tr></tbody><tfoot><tr><td colspan=6 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table></div></div><span class=infomark><i>i</i>방문자수 : 로그인 여부 상관없이 접속 IP로 카운트</span></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/personal/visitMenu-list.html","<div class=\"page page-footable\" ng-controller=\"VisitMenuListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴별 사용(빈도) 현황</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>메뉴별 사용(빈도) 현황</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><div class=input-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtStartSecondDate ng-change=\"vc.srch.StartRegDate = (dtStartSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=시작일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group-addon input_group_split\">~</div><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup={{format}} ng-model=dtEndSecondDate ng-change=\"vc.srch.EndRegDate = (dtEndSecondDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=종료일> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter class=\"table table-custom table-striped\"><colgroup><!-- <col style=\"width: 25%;\">\r\n                    <col style=\"width: 25%;\">\r\n                    <col style=\"width: 25%;\"> --></colgroup><thead><tr><th class=text-center>구분</th><th class=text-center>메뉴명</th><th class=text-center>조회수</th></tr></thead><tbody ng-repeat=\"row in vc.lists track by $index\"><tr ng-repeat=\"item in row track by $index\" my-directive><td style=\"border: 1px solid #e0e0e0\" class=\"text-center mid-align\" ng-if=$first rowspan={{row.length}}><span ng-bind=item.name1></span></td><td style=\"border: 1px solid #e0e0e0\" class=\"text-center mid-align\"><span ng-bind=item.name2></span></td><td style=\"border: 1px solid #e0e0e0\" class=\"text-center mid-align\"><span ng-bind=item.cnt></span></td></tr></tbody><tfoot><tr><td colspan=6 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table></div></div><span class=infomark><i>i</i>조회수 : 하위 메뉴가 존재하는 경우 합산됨(ex. 통계 메뉴), 접속 IP로 카운트하지 않고 단순 클릭수의 합계로 산정 </span><span class=infomark><i>i</i>메뉴별 사용(빈도) 현황 개시일 : ’26. 9. 2.</span></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/registered/registered-detail-view.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"SysRegisteredPostDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><h3 class=page-header>{{ vc.titleNm }}<div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></h3></div></div><!-- page content --><div class=pagecontent><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">신청정보</strong></div><div class=\"panel-body collapse in\"><div id=section1></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">담당자 메모</strong></div><div class=\"panel-body collapse in\"><div id=section2></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-if=!vc.disabledForms ng-click=vc.setComment()><i class=\"fa fa-save\"></i> 메모 저장</button></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/registered/registered-list-view.html","<div class=\"page page-footable\" ng-controller=\"SysRegisteredPostListCtrl as vc\"><!-- page header --><page-header></page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.RegName placeholder=\"이름으로 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" id=searchWrap></div><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><list-table></list-table><!-- / Table row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/rental-car/rental-car-list.html","<div class=\"page page-footable\" ng-controller=\"RentalCarListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>영업차량 목록</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 sz-search\"><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.rentalCarModal()><i class=\"fa fa-plus\"></i> 등록</button></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/rental-car/rental-car-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">영업차량 등록</div><div class=pull-right><button class=\"btn btn-default btn-close\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/role-screen/rolescreen-detail.html","<div class=\"page page-footable\" ng-controller=\"RolescreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.rolescreen-edit({TenantId:\'{{vc.stateParams.TenantId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control ng-required=true readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.REMARKS\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=vc.data.Remark readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/role-screen/rolescreen-edit.html","<div class=\"page page-footable\" ng-controller=\"RolescreenEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }} : {{ \'Menu.USERIMAGE\' | translate }} 100 * 130 px [ {{ \'Menu.MAX\' | translate }} 300MB, {{ \'Menu.NO_ENROLLMENT_COUNT\' | translate }}]</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- /tile body --></form></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/role-screen/rolescreen-list.html","<div class=\"page page-footable\" ng-controller=\"RolescreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>역할별 화면권한관리</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=col-lg-12><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.role ng-options=\"opt.RoleId as opt.RoleNm for opt in vc.roleList\"><option value=\"\">---- {{ \'Menu.ALL\' | translate }} ----</option></select><label>{{ \'Menu.ROLEGROUP\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveList()><i class=\"fa fa-save\"></i> 저장</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">권한별 화면목록</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-hover\"><thead><tr><th data-toggle=true class=text-center>{{ \'Menu.ROLEGROUP\' | translate }} {{ \'Menu.NAME\' | translate }}</th><th data-toggle=true class=text-center>메뉴명</th><th data-toggle=true class=text-center>{{ \'Menu.SCREENNAME\' | translate }}</th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'ViewYN\')\" ng-model=vc.checkAllBtn.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">조회</label></th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn01YN\')\" ng-model=vc.checkAllBtn.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button01</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button02</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button03</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button04</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button05</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button06</label></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><input type=hidden ng-model=li.RoleScrId><td class=text-left><span ng-bind=li.RoleNm></span></td><td class=text-left><span ng-bind=li.MenuNm title={{li.Sort}} ng-if=\"li.MainYN == \'Y\'\" ng-class=\"\'menudepth\' + li.Depth\"></span></td><td class=text-left><span ng-bind=li.ScreenNm title={{li.PageUrl}}></span></td><td class=text-left><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-left><label><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn01Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn02Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn03Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn04Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn05Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn06Text}}</label></td></tr></tbody></table></div></div></div></div><!-- // table  --></div></div></div></div></div></div>");
$templateCache.put("app/system/role/role-list.html","<style>.section-title  {\r\n    font-weight: bold;\r\n    margin-top:6px;\r\n    padding-left: 15px;\r\n    font-size: 15px;\r\n    color: #666666;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .Taxation-col-wrap {\r\n    width: 95px;\r\n  }\r\n\r\n  .Taxation-col-wrap label {\r\n    width: 52px;\r\n  }\r\n\r\n  .Taxation-col-wrap .input-group {\r\n    margin-left: 52px;\r\n  }\r\n\r\n  .IsFree-col-wrap label {\r\n    width: 52px;\r\n  }\r\n\r\n  .IsFree-col-wrap .input-group {\r\n    margin-left: 52px;\r\n  }\r\n\r\n  .col-sm-12 .left-context .sortableContainer > div {\r\n    min-height: unset !important;\r\n  }</style><div class=\"page page-footable menuManageView\" ng-controller=\"RoleListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=page-header>역할관리</div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=panel-default style=border:none><div class=row style=margin-top:0px><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-3 left-context\"><role-sortable init-callback=vc.succSortable bind-data=vc.datas link-data=vc.linkData max-depth=3></role-sortable></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-9 right-context\"><div class=boardNothing ng-show=!vc.data.RoleId style=padding-top:40px><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>역할을 선택하시면 상세 내용을 보실 수 있습니다.</p></div></div><div class=row ng-show=vc.data.RoleId><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 역할 정보 {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">역할 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-15\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setList()><i class=\"fa fa-save\"></i> 권한정보 {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">역할 권한 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><style>#searchTextResults th > label { position: relative; }\r\n                      #searchTextResults th > label > input { margin-top: -5px;}\r\n                      #searchTextResults th > label > span { margin-left: 5px; display: inline-block; margin-top: 5px; }\r\n                      #searchTextResults td { font-size: 13px; padding: 8px 0px; color: #666; }\r\n                      .menudepth1{ font-weight: 800; }</style><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-hover\"><thead><tr><th data-toggle=true class=text-center style=width:200px>메뉴</th><th data-toggle=true class=text-center style=width:200px ng-if=vc.isSys>{{ \'Menu.SCREENNAME\' | translate }}</th><th class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'ViewYN\')\" ng-model=vc.checkAllBtn.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>조회</span></label></th><th class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn01YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼01</span></label></th><th data-toggle=true class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn01YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼02</span></label></th><th data-toggle=true class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn02YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼03</span></label></th><th data-toggle=true class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn03YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼04</span></label></th><th data-toggle=true class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn04YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼05</span></label></th><th data-toggle=true class=text-center><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn05YN\')\" ng-disabled=true ng-model=vc.checkAllBtn.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><span>버튼06</span></label></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><input type=hidden ng-model=li.RoleScrId><td class=text-left style=padding-left:8px><span ng-bind=li.MenuNm title={{li.Sort}} ng-if=\"li.MainYN == \'Y\'\" ng-class=\"\'menudepth\' + li.Depth\"></span></td><td class=text-left ng-if=vc.isSys><span ng-bind=li.ScreenNm title={{li.PageUrl}}></span></td><td class=text-center><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><label><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn01Text}}</label></td><td class=text-center><label><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn02Text}}</label></td><td class=text-center><label><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn03Text}}</label></td><td class=text-center><label><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn04Text}}</label></td><td class=text-center><label><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn05Text}}</label></td><td class=text-center><label><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\">{{li.Btn06Text}}</label></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/screen/screen-detail.html","<div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleId></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"col-lg-12 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div><div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.screen-list>메뉴관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.screen-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.system.screen-edit({ScreenId:\'{{vc.data.ScreenId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ScreenId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>구분</label><input type=text class=form-control ng-model=vc.data.ModuleType ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>이름</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageFileNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>코드</label><input type=text class=form-control ng-model=vc.data.ScreenCd ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴구분</label><input type=text class=form-control ng-model=vc.data.ScreenType ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>등록일</label><input type=text class=form-control ng-model=vc.data.RegDate ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>수정일</label><input type=text class=form-control ng-model=vc.data.EdtDate ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴번호</label><input type=text class=form-control ng-model=vc.data.MenuNo ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType ng-required=true readonly></div></div></div></div><!-- /tile-body --></div><!-- /title --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/screen/screen-edit.html","<div class=\"page page-footable\" ng-controller=\"ScreenEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form id=form ng-submit=vc.setData()><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>화면명</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageUrl ng-required=true></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>파라메터</label><input type=text class=form-control ng-model=vc.data.PageUrlParam></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>SQLMapper</label><input type=text class=form-control ng-model=vc.data.SqlId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>허용파라메터</label><input type=text class=form-control ng-model=vc.data.ParamPass></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>거부파라메터</label><input type=text class=form-control ng-model=vc.data.ParamRefuse></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button01 설명</label><input type=text class=form-control ng-model=vc.data.Btn01Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button02 설명</label><input type=text class=form-control ng-model=vc.data.Btn02Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button03 설명</label><input type=text class=form-control ng-model=vc.data.Btn03Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button04 설명</label><input type=text class=form-control ng-model=vc.data.Btn04Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button05 설명</label><input type=text class=form-control ng-model=vc.data.Btn05Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button06 설명</label><input type=text class=form-control ng-model=vc.data.Btn06Text></div></div></div><div class=row><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록일</label><input type=text class=form-control value=\"{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정일</label><input type=text class=form-control value=\"{{vc.data.EdtDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm readonly></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/screen/screen-list.html","<div class=\"page page-footable\" ng-controller=\"ScreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>화면관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SqlId type=text><label>SQLMapper</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-click=\"vc.tablesort(\'X.ScreenNm\')\" data-toggle=true class=text-center>화면명 <span class=\"{{vc.sortClass(\'X.ScreenNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrl\')\" data-toggle=true class=text-center>프로그램명 <span class=\"{{vc.sortClass(\'X.PageUrl\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrlParam\')\" data-toggle=true class=text-center>파라메터 <span class=\"{{vc.sortClass(\'X.PageUrlParam\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.SqlId\')\" data-toggle=true class=text-center>SQLMapper <span class=\"{{vc.sortClass(\'X.SqlId\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goEdit(li.ScreenId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':selectedRow == li.ScreenId}\"><!-- Result Items --><td><span ng-bind=li.ScreenNm></span></td><td><span ng-bind=li.PageUrl></span></td><td><span ng-bind=li.PageUrlParam></span></td><td><span ng-bind=li.SqlId></span></td></tr></table><div class=row><div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/support-business/support-business-list.html","<div class=\"page page-footable\" ng-controller=\"SupportBusinessListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>지원사업 목록</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 상단 검색 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 sz-search\"><div class=search_button><button class=\"btn btn-default btn_search\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn_down\" ng-click=\"vc.showDetailSearch = (vc.showDetailSearch != true ? true : false)\"><i class=\"fa fa-caret-down\"></i></button></div><div class=\"search_select mgl05\"><select><option>전체</option><option>부서</option><option>개인</option></select></div></div></div><!-- //상단 검색 --><!-- 검색영역 --><div class=ksa_busi ng-show=vc.showDetailSearch><div class=row id=searchWrap></div><!-- 버튼영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button> <button class=\"btn btn-default\" ng-click=\"vc.showDetailSearch = false\"><i class=\"fa fa-close\"></i> 닫기</button></div></div></div><!-- //버튼영역 --></div><!-- 검색영역 --></form><!-- 버튼 영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><div class=dropdown_btn><button class=\"btn btn-default\" data-toggle=dropdown><i class=\"fa fa-bars\"></i> 부가기능</button><ul class=dropdown-menu><li><a ng-click=vc.setExcelFile()><i class=\"fa fa-upload\"></i> 엑셀업로드</a></li><li><a ng-click=vc.getExcelFile()><i class=\"fa fa-download\"></i> 엑셀다운로드</a></li></ul></div><button class=\"btn btn-danger ng-binding\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.supportBusinessModal()><i class=\"fa fa-plus\"></i> 등록</button></div></div></div><!-- /버튼 영역 --><!---- 버튼아이콘 ---> <span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><autoview-list-table alias=vc list-data=lists></autoview-list-table></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/support-business/support-business-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">지원사업 등록</div><div class=pull-right><button class=\"btn btn-default btn-close\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">관리정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=item-wrap ng-repeat=\"item in vc.data.ManagerList\">영업담당자: {{item.ManagerNm}} <span ng-click=vc.delManager(item)>×</span></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/sms/sms-auto-edit.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>알림발송 상세정보</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 자동발송 상세정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=col-lg-12><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=상황명>상황명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SituationTitl></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발신자>발신자</label><common-code-custom code-list=\"vc.columnMap[\'Caller\'].CodeList\" code-model=vc.data.Caller></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=수신자>수신자</label><common-code-custom code-list=\"vc.columnMap[\'Receiver\'].CodeList\" code-model=vc.data.Receiver></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=금액차감유형>금액차감유형</label><common-code-custom code-list=\"vc.columnMap[\'CostType\'].CodeList\" code-model=vc.data.CostType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=테넌트아이디>테넌트아이디</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.TenantId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송유형>발송유형</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.data.CmpgnChannel ng-change=vc.chgCmpgnChannel()></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=알림톡템플릿키>알림톡템플릿키</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.KakaoTemplateKey></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"스케줄러 조회용쿼리\">스케줄러 조회용쿼리</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.AutoCondition></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"실행할 API키\">실행할 API키</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.SqlQueryId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"매칭조건(json string 형식)\">매칭조건</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.ActionCondition></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"OR 지정\">지정조건</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.AutoCondition></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"실행할 API키2\">실행할 API키2</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.SqlQueryId2></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"매칭조건2(json string 형식)\">매칭조건2</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.ActionCondition2></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"OR 지정\">지정조건2</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.AutoCondition2></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는사람 전화번호\">보내는사람 이름</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.FromNm></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는사람 전화번호\">보내는사람 정보</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.FromTelNo></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"며칠전 지정\">며칠전 지정</label><common-code-custom code-list=\"vc.columnMap[\'DayBeforeYN\'].CodeList\" code-model=vc.data.DayBeforeYN></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"대상일 며칠전\">대상일 며칠전</label><input type=text class=\"form-control form-right\" maxlength=10 ng-model=vc.data.DayBefore></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는사람 전화번호\">발신시각</label><timepicker id=id_time name=time start-time=8 end-time=20 step-time=10 class=form-field label=\"Enter time:\" ng-model=vc.data.theTime required></timepicker></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{Info1}의 설명\">{Info1}의 설명</label><input type=text class=\"form-control form-right\" maxlength=30 ng-model=vc.data.Info1Desc></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{Info2}의 설명\">{Info2}의 설명</label><input type=text class=\"form-control form-right\" maxlength=30 ng-model=vc.data.Info2Desc></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=정렬순서>정렬순서</label><input type=text class=\"form-control form-right\" maxlength=30 ng-model=vc.data.Sort></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"받는사람 전화번호\">받는사람 정보</label><textarea rows=15 class=\"form-control form-right\" style=width:100% ng-model=vc.data.ToTelNo></textarea><ul class=form-control-no-border><li>* 발신자명, 발신자정보, 수신자명, 수신자정보, 수신자아이디 순으로 최종값이 select 되도록 select 문 작성.</li><li>* 본문의 {필드명}은 select 한 필드명의 값으로 치환됨.</li><li>* 다음 치환필드명은 반드시 select 필드명으로 포함시켜야 됨 : FromTenantNm,FromTenantAddr,FromNm,FromInfo,ToNm,ToInfo,Info1,Info2</li><li>* 본문의 #{변수명}은 호출된 API에 전송된 변수명이 있을 때, 할당된 값으로 치환.</li></ul></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는 메시지 제목\">발송 제목</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SendTitle></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"발송 내용\">발송 내용</label><textarea id=strHtml rows=15 class=\"form-control form-right\" style=width:100% ng-model=vc.data.SendMessage ng-change=vc.chkSendMessage() kr-input></textarea><div class=text-right>{{vc.messageLength}} / {{vc.messageMaxLength}} bytes</div><ul class=form-control-no-border><li>* 받는 사람정보에 지정된 쿼리에 의해 가져온 필드명값으로 치환 : 본문의 {필드명}은 select 한 필드명의 값으로 치환됨.(치환필드명목록:FromTenantNm,FromTenantAddr,FromNm,FromInfo,ToNm,ToInfo,Info1,Info2)</li><li>* API에 요청한 정보에 있는 값으로 치환 : 본문의 #{변수명}은 API에 전송된 정보에 변수명이 있을때 변수명에 할당된 값으로 치환.</li></ul></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=사용여부>사용여부</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div class=form-control-no-border></div></div></div></div></form></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div></div></div>");
$templateCache.put("app/system/sms/sms-auto-list.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>알림발송관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SituationTitl placeholder=\"상황명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel></common-code-custom><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input ng-model=vc.srch.SituationTitl type=text class=form-control><label>{{vc.columnMap[\'SituationTitl\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input ng-model=vc.srch.Contents type=text class=form-control><label>{{vc.columnMap[\'SendMessage\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --><!-- 버튼 그룹 --><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goEdit(\'\')\"><i class=\"fa fa-edit\"></i> 추가</button><!--button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button--></div><!-- /버튼 그룹 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.KeyId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.KeyId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.setPageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span>개정된 정보통신망법 제50조 3항 영리목적의 광고성 정보 전송 제한을 준수하여 <strong style=\"color: red\">월~금(토,일 제외) 오전10시에 발송합니다.</strong></span></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/sms/sms-send-number-edit.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=\"vc.setUpdate(\'Y\')\" ng-if=\"vc.data.CertYN == \'N\'\"><i class=\"fa fa-list\"></i> 인증승인</button> <button class=\"btn btn-danger\" ng-click=\"vc.setUpdate(\'N\')\" ng-if=\"vc.data.CertYN == \'Y\'\"><i class=\"fa fa-list\"></i> 인증취소</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 발송번호 인증 관리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'SendVerifyId\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'SendVerifyId\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SendVerifyId ng-disabled=true></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ \'회원사명\' | translate }}\">{{ \'회원사명\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm disabled></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'BranchNm\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'BranchNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.BranchNm disabled></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.RegUserNm ng-disabled=true></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RegDate disabled></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'SendInfo\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'SendInfo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendInfo disabled></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'CertType\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'CertType\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertTypeNm disabled></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertYNNm disabled></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'ImpUid\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'ImpUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ImpUid disabled></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ vc.columnMap[\'MerchantUid\'].ColumnLogicalNm | translate }}\">{{ vc.columnMap[\'MerchantUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MerchantUid disabled></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div class=input-group><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/sms/sms-send-number-list.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"회원사명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertType\'].CodeList\" code-model=vc.srch.CertType></common-code-custom><label>{{vc.columnMap[\'CertType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertYN\'].CodeList\" code-model=vc.srch.CertYN></common-code-custom><label>{{vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.KeyId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.KeyId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=90>{{li[liCol.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 paging_pad\"><div class=\"form-group form-inline select-size-list pull-left col-xs-hidden\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.setPageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/user/user-detail.html","<div class=\"page page-footable\" ng-controller=\"UserDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사용자조회</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사용자관리</a></li><li><a>사용자조회</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>사용자조회</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.user-list()><i class=\"fa fa-list\"></i> 목록</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.system.user-edit({UserId:\'{{vc.srch.UserId}}\', TenantId:\'{{vc.srch.TenantId}}\'})\" ng-show=showBtnEdit><i class=\"fa fa-edit\"></i> 수정</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>로그인아이디</label><input type=text class=form-control ng-model=vc.data.LoginId readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사용자명</label><input type=text class=form-control ng-model=vc.data.UserNm readonly></div></div><div class=col-lg-4><div class=form-group><label>소속</label><input type=text class=form-control ng-model=vc.data.CompanyNm readonly></div></div><div class=col-lg-4><div class=form-group><label>사용자구분</label><input type=text class=form-control ng-model=vc.data.UserType_ readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사업정보</label><input type=text class=form-control ng-model=vc.data.TenantNm readonly></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.data.Mobile readonly></div></div><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.data.Email readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사용여부</label><input type=text class=form-control ng-model=vc.data.UseYN readonly></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div class=row ng-show=showArmyInfo><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>데이터 조회권한 정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>권역데이터 권한</label>\r\n                  <div>\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone1YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                      disabled=\"true\"\r\n                    />\r\n                    권역1 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone2YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                      disabled=\"true\"\r\n                    />\r\n                    권역2 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone3YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                      disabled=\"true\"\r\n                    />\r\n                    권역3 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone4YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                      disabled=\"true\"\r\n                    />\r\n                    권역4 전체\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone5YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                      disabled=\"true\"\r\n                    />\r\n                    기업맞춤형 취업과정\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><!-- <label>소속데이터 권한</label> --><div class=addrow_pad><table class=table><tr><th>권역</th><th>군별</th><th>소속부대</th><!-- <th>소속부대2</th> --></tr><tr ng-repeat=\"li in ArmyInfoJSON\"><td><span ng-bind=li.ArmyArea></span></td><td><span ng-bind=li.ArmyType_></span></td><td><span ng-bind=li.PermStat1_></span></td><!-- <td><span ng-bind=\"li.PermStat2_\"></span></td> --></tr></table></div></div></div></div></div></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/system/user/user-edit-tab1.html","<div ng-controller=\"UserEditTab1Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사용자정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'LoginId\'].ColumnLogicalNm}}\">{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input ng-if=\"vc.data.KeyId != null && vc.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId readonly><div class=input-group><input ng-if=\"vc.data.KeyId== null || vc.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId maxlength=20> <span class=input-group-btn ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><button class=\"btn btn-default\" ng-click=vc.getIsDupLoginId() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'UserNm\'].ColumnLogicalNm}}\">{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.UserNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'UseYN\'].ColumnLogicalNm}}\">{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=비밀번호>비밀번호</label><input type=password class=\"form-control form-right\" ng-if=\"vc.srch.keyId != null && vc.srch.keyId != \'\' && vc.srch.keyId != undefined\" maxlength=20 ng-model=vc.data.Password readonly> <input type=password class=\"form-control form-right\" ng-if=\"vc.srch.keyId == null || vc.srch.keyId == \'\' || vc.srch.keyId == undefined\" maxlength=20 ng-model=vc.data.Password required></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"비밀번호 확인\">비밀번호 확인</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password2 ng-if=\"vc.srch.keyId != null && vc.srch.keyId != \'\' && vc.srch.keyId != undefined\" readonly> <input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password2 ng-if=\"vc.srch.keyId == null || vc.srch.keyId == \'\' || vc.srch.keyId == undefined\" required></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\" style=\"padding-left: 90px\"><label></label><span style=\"color : red\">영문자, 숫자, 특수문자 중 3가지 조합(대소문자 구분함) / 최소 8자 ~ 최대 14자 (띄어쓰기 제외) / 특수문자 !@#$%^&*()-_;:&lt;&gt;,.[]{} 사용 가능<br>동일한 문자(숫자 포함) 3자 이상 연속 금지 ex) aaa, 111 / 연속적으로 증감되는 숫자, 문자 금지 Ex) abc, 123</span></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label uib-tooltip=\"{{vc.columnMap[\'Mobile\'].ColumnLogicalNm}}\">{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 auto-hyphen-tel ng-model=vc.data.Mobile></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label uib-tooltip=\"{{vc.columnMap[\'SMSSendTelNo\'].ColumnLogicalNm}}\">{{vc.columnMap[\'SMSSendTelNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 auto-hyphen-tel ng-model=vc.data.SMSSendTelNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'Email\'].ColumnLogicalNm}}\">{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-change=vc.getIsDupEmail() maxlength=255 ng-model=vc.data.Email></div></div></div><!-- /row --><div class=row><!-- <div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\">\r\n                    <div class=\"form-group form-inline\" ng-if = \"$root.gVariable.SysAdminYN == \'Y\'\">\r\n                      <label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label>\r\n                      <div class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control form-right\" ng-model=\"vc.data.TenantNm\" readonly>\r\n                        <span class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.srchTenantModal();\">\r\n                            <i class=\"fa fa-search\"></i>\r\n                          </button>\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.eraseTenant();\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                          </button>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group form-inline\" ng-if = \"$root.gVariable.SysAdminYN != \'Y\'\">\r\n                      <label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label>\r\n                      <div class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control form-right\" ng-model=\"vc.data.TenantNm\" readonly>\r\n                      </div>\r\n                    </div>\r\n                  </div> --><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{vc.columnMap[\'DeptId\'].ColumnLogicalNm}}\">{{vc.columnMap[\'DeptId\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=vc.DeptCodeList code-model=vc.data.DeptId></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label uib-tooltip=\"{{ \'Menu.ROLE\' | translate }}\">{{ \'Menu.ROLE\' | translate }}</label><!-- <div class=\"input-group\"> --><common-code-custom code-list=vc.codeRoleList code-model=vc.data.UserRoleIds callback=vc.setChangeRoleList></common-code-custom><!-- <input type=\"text\" class=\"form-control form-right\" ng-model=\"vc.data.UserRoleNms\" readonly>\r\n                        <span class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.srchUserroleModal();\">\r\n                            <i class=\"fa fa-search\"></i>\r\n                          </button>\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.eraseUserRole();\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                          </button>\r\n                        </span> --><!-- </div> --></div></div></div><!-- /row --><!--  CTI 정보\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\">\r\n                    <div class=\"form-group form-inline\">\r\n                      <label>{{vc.columnMap[\'CtiId\'].ColumnLogicalNm | translate}}</label>\r\n                      <input type=\"text\" class=\"form-control form-right\" maxlength=\"100\" ng-model=\"vc.data.CtiId\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\">\r\n                    <div class=\"form-group form-inline\">\r\n                      <label>{{vc.columnMap[\'CtiPw\'].ColumnLogicalNm | translate}}</label>\r\n                      <input type=\"text\" class=\"form-control form-right\" maxlength=\"100\" ng-model=\"vc.data.CtiPw\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\">\r\n                    <div class=\"form-group form-inline xs-mb10\">\r\n                      <label>{{vc.columnMap[\'CtiTelNo\'].ColumnLogicalNm | translate }}</label>\r\n                      <div class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control form-right\" maxlength=\"255\" numbers-hyphen ng-model=\"vc.data.CtiTelNo\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div> \r\n                --><!-- /row --><!-- <div class=\"row\">\r\n                  <div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\" ng-if=\"vc.ManageYn == \'Y\'\">\r\n                    <div class=\"form-group form-inline\">\r\n                      <label>{{vc.columnMap[\'BranchId\'].ColumnLogicalNm | translate }}</label>\r\n                      <common-code-custom code-list=\"vc.branchCodeList\" code-model=\"vc.data.branch_code\" callback=\"vc.setChangeBranchCoe(vc.data.branch_code)\"></common-code-custom>\r\n                    </div>\r\n                  </div>\r\n                </div> --><!-- /row --><!-- file upload--><div class=row ng-if=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label uib-tooltip=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label uib-tooltip=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-if=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label uib-tooltip=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label uib-tooltip=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- /row --></form></div><!-- /tile body --></div><!-- /tile --><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>부가정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><style>.add-info-wrap .form-group > label {\r\n                max-width: unset;\r\n                width:100%;\r\n                display:block;\r\n                text-align: left;\r\n              }\r\n\r\n              .add-info-wrap .form-group > div {\r\n                position:absolute;\r\n                top:25px;\r\n                left: 25px;\r\n              }\r\n\r\n              .add-info-wrap .form-group > div label label {\r\n                padding-left: 2px;\r\n                margin-right: 8px;\r\n              }</style><div class=\"panel-body collapse in add-info-wrap\" style=\"padding-bottom: 20px\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label class=checkbox-inline>알림수신여부 (홈페이지)</label><div><label class=ng-binding><input type=checkbox ng-model=vc.data.HSmsAgreeYN ng-checked=\"vc.data.HSmsAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>{{vc.columnMap[\'HSmsAgreeYN\'].ColumnLogicalNm | translate }}</label></label><label class=ng-binding><input type=checkbox ng-model=vc.data.HEmailAgreeYN ng-checked=\"vc.data.HEmailAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>{{vc.columnMap[\'HEmailAgreeYN\'].ColumnLogicalNm | translate }}</label></label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label class=checkbox-inline>알림수신여부 (네이버)</label><div><label class=ng-binding><input type=checkbox ng-model=vc.data.NSmsAgreeYN ng-checked=\"vc.data.NSmsAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>{{vc.columnMap[\'NSmsAgreeYN\'].ColumnLogicalNm | translate }}</label></label><label class=ng-binding><input type=checkbox ng-model=vc.data.NEmailAgreeYN ng-checked=\"vc.data.NEmailAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> {{vc.columnMap[\'NEmailAgreeYN\'].ColumnLogicalNm | translate }}</label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label class=checkbox-inline>알림수신여부 (카카오)</label><div><label class=ng-binding><input type=checkbox ng-model=vc.data.KSmsAgreeYN ng-checked=\"vc.data.KSmsAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>{{vc.columnMap[\'KSmsAgreeYN\'].ColumnLogicalNm | translate }}</label></label><label class=ng-binding><input type=checkbox ng-model=vc.data.KEmailAgreeYN ng-checked=\"vc.data.KEmailAgreeYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label>{{vc.columnMap[\'KEmailAgreeYN\'].ColumnLogicalNm | translate }}</label></label></div></div></div></div><!-- /row --></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=\"row mt-5\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/user/user-edit.html","<div class=\"page page-footable\" ng-controller=\"UserEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사용자등록/수정</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사용자관리</a></li><li><a>사용자등록/수정</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">기본정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><!-- <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=\"\" ng-show=\"vc.stateParams.UserId != \'\'\">\r\n                      <i class=\"fa fa-shield\"></i> {{ \'Menu.TEMP_PW\' | translate }}\r\n                    </button>\r\n                    <button class=\"btn btn-greensea  btn-ef btn-ef-7b mb-10 mr-10\" activate-button ng-click=\"\">\r\n                      <i class=\"fa  icon-call-in\"></i> {{ \'Menu.CALLBACK_REG\' | translate }}\r\n                    </button> --> <button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.user-list()><i class=\"fa fa-list\"></i>목록</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i>저장</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>아이디</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-readonly=\"vc.data.UserId != \'\'\" ng-model=vc.data.LoginId placeholder=아이디 ng-blur=vc.chkDupLoginIdClear()> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.chkDupLoginId() ng-show=\"vc.data.UserId == \'\'\">중복확인</button></span></div></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>비밀번호</label><input type=password class=form-control ng-model=vc.data.Password placeholder=비밀번호></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>비밀번호확인</label><input type=password class=form-control ng-model=vc.data.Password2 placeholder=비밀번호확인></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>사용자명</label><input type=text class=form-control ng-model=vc.data.UserNm placeholder=사용자명></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>소속</label><input type=text class=form-control ng-model=vc.data.CompanyNm placeholder=소속></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>사용자구분</label><common-code param-data=vc.UserTypeList callback=vc.onSelectCallback></common-code></div></div><!-- <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>Password</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.Password\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group\">\r\n                    <label>Confirm Password</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.Password2\">\r\n                  </div>\r\n                </div> --></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>사업정보</label><select class=form-control name=selectCombo ng-change=vc.onTenentCodeSelected({{vc.TCode}}) ng-model=vc.TCode ng-options=\"opt.TenantNm for opt in vc.tenantList track by opt.TenantId\" ng-disabled=\'$root.gVariable.userType != \"000\"\'><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>휴대폰</label><input type=text class=form-control ng-model=vc.data.Mobile placeholder=휴대폰></div></div><div class=col-lg-4><div class=form-group><label class=txt_req>이메일</label><input type=text class=form-control ng-model=vc.data.Email placeholder=이메일></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label class=txt_req>사용여부</label><common-code param-data=vc.UseYNList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>취업컨설팅 대상</label><common-code param-data=vc.EmpmCnsltTrgList callback=vc.onSelectCallback></common-code></div></div></div></form></div><!-- /tile --></div><!-- /col --></div></div><div class=row ng-show=showArmyInfo><div class=col-md-12><div class=tile><div class=dataloaderedit ng-show=vc.dataloader></div><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>데이터 조회권한 정보</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><!-- <div class=\"row\">\r\n              <div class=\"col-lg-12\">\r\n                <div class=\"form-group\">\r\n                  <label>권역데이터 권한</label>\r\n                  <div>\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone1YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                    />\r\n                    권역1 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone2YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                    />\r\n                    권역2 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone3YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                    />\r\n                    권역3 전체&nbsp;&nbsp;\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone4YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                    />\r\n                    권역4 전체\r\n                    <input\r\n                      type=\"checkbox\"\r\n                      ng-model=\"objArmyZone5YN\"\r\n                      ng-true-value=\"\'Y\'\"\r\n                      ng-false-value=\"\'N\'\"\r\n                    />\r\n                    기업맞춤형 취업과정\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=form-group><!-- <label>소속데이터 권한</label> --><div class=row><div class=col-lg-4><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.ArmyAreaList ng-options=\"opt2 for opt2 in vc.AreaList track by opt2\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>군별</label><select class=form-control name=selectCombo ng-change=vc.onArmyTypeListSelected() ng-model=vc.ArmyTypeList ng-options=\"opt3.ArmyType_ for opt3 in vc.TypeList track by opt3.ArmyType\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><select class=form-control name=selectCombo ng-change=vc.onPermStat1ListSelected() ng-model=vc.PermStat1List ng-options=\"opt4.PermStat1_ for opt4 in vc.Stat1List track by opt4.PermStat1\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><!-- <div class=\"col-lg-2\">\r\n                      <div class=\"form-group\">\r\n                        <label>&nbsp;</label>                     \r\n                        <common-code param-data=\"vc.PermStat2List\" callback=\"vc.onPermStat2ListSelected\"></common-code>\r\n                      </div>\r\n                    </div> --><div class=col-lg-4><div class=form-group><label>&nbsp;</label><div><input class=\"btn btn-default text-right;\" type=button value=행추가 ng-click=addRowArmyInfo()></div></div></div></div><div class=addrow_pad><!-- <p>JSON data: <br/>{{ArmyInfoJSON}}</p> --><table class=table><tr><th>권역</th><th>군별</th><th>소속부대</th><!-- <th>소속부대2</th> --><th>삭제</th></tr><tr ng-repeat=\"li in ArmyInfoJSON\"><td><input type=text ng-model=li.ArmyArea class=form-control readonly></td><td><input type=text ng-model=li.ArmyType_ class=form-control readonly> <input type=hidden ng-model=li.UserArmyInfoId></td><td><input type=text ng-model=li.PermStat1_ class=form-control readonly></td><!-- <td><input type=\"text\" ng-model=\"li.PermStat2_\" class=\"form-control\" readonly=\"readonly\" /></td> --><td><input class=\"btn btn-default\" type=button value=행삭제 data-ng-click=removeRowArmyInfo($index)></td></tr></table></div></div></div></div></div></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/system/user/user-list.html","<div class=\"page page-footable\" ng-controller=\"UserListCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>사용자목록</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a>시스템관리</a></li><li><a>사용자관리</a></li><li><a>사용자목록</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><!-- col --><div class=col-md-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">검색조건</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=tile-body><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.srch.LoginId placeholder=아이디></div></div><div class=col-lg-4><div class=form-group><label>사용자명</label><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명></div></div><div class=col-lg-4><div class=form-group><label>소속</label><input type=text class=form-control ng-model=vc.srch.CompanyNm placeholder=소속></div></div><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>{{ \'Menu.DEPARTMENT\' | translate }}</label>\r\n                  <div class=\"input-group custom-search-form\">\r\n                    <input type=\"text\" readonly=\"readonly\" class=\"form-control\" ng-model=\"vc.DeptNm\" placeholder=\"{{ \'Menu.DEPARTMENT\' | translate }}\"> <input type=\"hidden\" ng-model=\"vc.srch.DeptId\">\r\n                    <span class=\"input-group-btn\">\r\n                      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.srchDeptModal();\" ng-disabled=\"gVariable.TenantId == \'0\'\">\r\n                        <i class=\"fa fa-search\"></i>\r\n                      </button>\r\n                      <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.eraseDept();\" ng-disabled=\"gVariable.TenantId == \'0\'\">\r\n                        <i class=\"fa fa-eraser\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div> --></div><div class=row><div class=col-lg-4><div class=form-group><label>사업정보</label><select class=form-control name=selectCombo ng-change=vc.onTenentCodeSelected() ng-model=vc.TCode ng-options=\"opt.TenantNm for opt in vc.tenantList track by opt.TenantId\" ng-disabled=\'$root.gVariable.userType != \"000\"\'><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-4><div class=form-group><label>권역</label><select class=form-control name=selectCombo ng-change=vc.onArmyAreaListSelected() ng-model=vc.ArmyAreaList ng-options=\"opt2 for opt2 in vc.AreaList track by opt2\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select><!-- <common-code\r\n                      param-data=\"vc.ArmyAreaList\"\r\n                      callback=\"vc.onArmyAreaListSelected\"\r\n                    ></common-code> --></div></div><div class=col-lg-2><div class=form-group><label>군별</label><select class=form-control name=selectCombo ng-change=vc.onArmyTypeListSelected() ng-model=vc.ArmyTypeList ng-options=\"opt3.ArmyType_ for opt3 in vc.TypeList track by opt3.ArmyType\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><div class=col-lg-2><div class=form-group><label>소속부대</label><select class=form-control name=selectCombo ng-change=vc.onPermStat1ListSelected() ng-model=vc.PermStat1List ng-options=\"opt4.PermStat1_ for opt4 in vc.Stat1List track by opt4.PermStat1\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select></div></div><!-- <div class=\"col-lg-2\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"txt_req\">&nbsp;</label>                     \r\n                  <common-code param-data=\"vc.PermStat2List\" callback=\"vc.onPermStat2ListSelected\"></common-code>\r\n                </div>\r\n              </div> --><!-- <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>{{ \'Menu.PW_CHANGE_CLASS\' | translate }}</label>\r\n                  <div class=\"checkbox mt-0\">\r\n                    <label><input type=\"checkbox\" ng-model=\"vc.srch.PWResetYN\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" />{{ \'Menu.PW_CHANGE_CLASS\' | translate }}</label>\r\n                  </div>\r\n                </div>\r\n              </div> --></div><div class=row><div class=col-lg-4><div class=form-group><label>사용자구분</label><common-code param-data=vc.UserTypeList callback=vc.onSelectCallback></common-code></div></div><div class=col-lg-4><div class=form-group><label>휴대폰</label><input type=text class=form-control ng-model=vc.srch.Mobile placeholder=휴대폰></div></div><div class=col-lg-4><div class=form-group><label>이메일</label><input type=text class=form-control ng-model=vc.srch.Email placeholder=이메일></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>사용여부</label><!-- <common-code param-data=\"vc.UseYNList\" callback=\"vc.onSelectCallback\"></common-code> --><select class=form-control name=selectCombo ng-model=vc.srch.UseYN><option value=\"\">-선택-</option><option value=Y>사용</option><option value=N>미사용</option></select></div></div></div><!-- <div class=\"row\">\r\n              <div class=\"col-lg-4\">\r\n                <div class=\"form-group\">\r\n                  <label>{{ \'Menu.MEMBERCOMPANY\' | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"vc.srch.TenantNm\" placeholder=\"{{ \'Menu.MEMBERCOMPANY\' | translate }}\">\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList() ng-disabled=vc.listBtnDisable><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.excelUpload()><i class=\"fa fa-file-excel-o\"></i> 엑셀 업로드</button> <button class=\"btn btn-dutch btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getExcel() ng-show=showBtnExcel><i class=\"fa fa-file-excel-o\"></i> 엑셀</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.deleteList() ng-show=showBtnDel><i class=\"fa fa-trash-o\"></i> 선택삭제</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button=\"\" ui-sref=\"app.system.user-edit({UserId:\'\'})\" ng-show=showBtnAdd><i class=\"fa fa-edit\"></i> 추가</button></div></div></div></div></div></div></div><!-- row --></form><div class=row><div class=col-lg-12><div class=tile><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>목록</strong></h4>&nbsp;{{vc.totalItems}}<div class=pull-right><label>페이지당목록수 &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><div class=tile-body><div class=row><div class=col-lg-12><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom table-striped\"><thead><tr><th data-sort-ignore=true class=text-center><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>사용자명</th><th data-toggle=true class=text-center>소속</th><th data-toggle=true class=text-center>사용자구분</th><th data-toggle=true class=text-center>사업정보</th><th data-toggle=true class=text-center>휴대폰</th><th data-toggle=true class=text-center>이메일</th><th data-toggle=true class=text-center>최근로그인</th><th data-toggle=true class=text-center>사용여부</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><td class=text-center><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.LoginId></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.UserNm></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.CompanyNm></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.UserType_></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.TenantNm></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.Mobile></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.Email></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.LoginDate></span></td><td class=text-center ui-sref=\"app.system.user-detail({UserId:\'{{li.UserId}}\'})\"><span ng-bind=li.UseYN_></span></td></tr></tbody><tfoot><tr><td colspan=10 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize template-url=components/template/pagination.html ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("scripts/file-attach/directive/file-attach.html","<div class=form-right><table class=\"table b-a b-solid bg-white\"><thead><tr><th width=50%>Name</th><th>Size</th><th>Progress</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr id=filectl_{{obj.id}} ng-repeat=\"obj in faCtrl.fileData\" ng-if=!obj.delStatus><td><span ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></span> <a href={{obj.link}} target=attach ng-show=obj.isLoaded><span class=file_list ng-bind=obj.fileName></span></a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px; height: 10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a href=\"\" ng-click=faCtrl.onDelete(obj)><span ng-show=\"obj.delState == \'\'\"><i class=icon-trash></i> {{ \'Menu.DELETE\' | translate }}</span><span ng-show=\"obj.delState == \'delete\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></td></tr></tbody></table><div tabindex=500 class=\"btn btn-info btn-file pull-right\" ng-click=faCtrl.openDilalog()><i class=icon-file-plus></i>{{ \'Menu.ATTACHMENT\' | translate }}</div><input id=file-5 style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"></div>");
$templateCache.put("scripts/directives/common-code-custom/common-code-custom.html","<select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandler() ng-model=ccCtrl.codeModel ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.list\" style=min-width:100px ng-disabled=ccCtrl.isDisabled><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-search/common-code-search.html","<select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandler() ng-model=ccCtrl.codeModel ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.list\" ng-disabled=ccCtrl.isDisabled><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-signup/common-code-signup.html","<select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler() name=selectCombo ng-model=ccCtrl.data ng-options=\"opt.CodeValue for opt in ccCtrl.list track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=\"min-width:100px; width: {{ccCtrl.selectWidth}}px\"><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-tree/common-code-food.html","<div class=\"form-group form-inner-label pull-left mt-0 mr-10\"><select ng-disabled=\"ccCtrl.list[0].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler(0) name=selectCombo ng-model=ccCtrl.CommonCode[0] ng-options=\"opt.CodeValue for opt in ccCtrl.list[0] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></div><div class=\"form-group form-inner-label pull-left mt-0\"><select ng-disabled=\"ccCtrl.list[1].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler(1) name=selectCombo ng-model=ccCtrl.CommonCode[1] ng-options=\"opt.CodeValue for opt in ccCtrl.list[1] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></div>");
$templateCache.put("scripts/directives/common-code-tree/common-code-project.html","<span style=float:left ng-if=\"ccCtrl.preventChanging === false\"><select class=form-control ng-change=ccCtrl.onChangeHandlerYear() name=selectCombo ng-model=ccCtrl.prmYear ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.listYear\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span><span style=float:left ng-if=\"ccCtrl.preventChanging === false\"><select class=\"form-control ml-5\" ng-change=ccCtrl.onChangeHandlerId() name=selectCombo ng-model=ccCtrl.prmId ng-options=\"opt.PrmId as opt.PrmNm for opt in ccCtrl.listPrm\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span><span ng-if=\"ccCtrl.preventChanging === true\">{{ccCtrl.data.PrmYear}} {{ccCtrl.data.PrmNm}} </span>");
$templateCache.put("scripts/directives/common-code-tree/common-code-tree.html","<div class=\"form-group form-inner-label\"><span style=float:left ng-repeat=\"li in ccCtrl.CodeLevel\"><select ng-disabled=\"ccCtrl.list[$index].length == 0\" class=form-control ng-change=ccCtrl.onChangeHandler($index) name=selectCombo ng-model=ccCtrl.CommonCode[$index] ng-options=\"opt.CodeValue for opt in ccCtrl.list[$index] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span></div>");
$templateCache.put("scripts/directives/date-form/date-input.html","<div class=\"datetime-input date\"><div class=display-wrap><div ng-click=toggleEditPopover() class=display ng-class=\"{\'active\': !!selected, \'warning\': !!warning, \'{{cssClass}}\': !!cssClass}\"><div class=date ng-bind=\"date.format(dateFormat || \'YYYY.MM.DD\')\"></div><div ng-if=!date class=placeholder ng-bind=placeholder></div></div><i class=\"fa fa-eraser fa-fw ico-reset\" ng-click=resetDate() ng-if=date></i></div><div class=edit-popover ng-show=!!selected><div class=header><span ng-click=clcikYearShow()><span ng-bind=\"selected.format(\'YYYY\')\"></span>년 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10 ng-click=\"clickYear(selected.format(\'YYYY\'))\"><span ng-bind=\"selected.format(\'MM\')\"></span>월 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10><span ng-bind=\"selected.format(\'DD\')\"></span>일 <i class=\"fa fa-caret-down\"></i></span> <span class=\"pull-right mr-10\" ng-click=close()><i class=\"fa fa-close\"></i></span></div><div class=calendar><!-- 년도 목록, --><div class=calendar-header ng-if=yearShow><span>{{calendarYearStart.format(\'YYYY\')}} - {{calendarYearEnd.format(\'YYYY\')}}</span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYears()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYears()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=yearShow><div class=years><span class=yearList ng-repeat=\"year in yearList\" ng-click=clickYear(year)><span ng-bind=year ng-class=\"{ \'yearUnder\' : selected.year() == year}\"></span></span></div></div><!-- 월 목록, --><div class=calendar-header ng-if=monthShow><span ng-bind=\"calendar.format(\'YYYY\')\" ng-click=clcikYearShow()></span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYear()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYear()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=monthShow><div class=month><span class=monthList ng-repeat=\"month in monthList\" ng-click=clickMonth(month)>{{month}}월</span></div></div><!-- 일별 목록 --><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\" ng-if=dateShow><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MM\') : calendar.format(\'MM YYYY\')\"></span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractMonth()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addMonth()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=dateShow><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\" ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: ((calendar.clone().endOf(\'month\').week() - calendar.clone().startOf(\'month\').week()) + 1) track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"update(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\"><span class=day-point></span> <span class=day-tx ng-class=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()+1 == currentMonth ? \'\' : \'day-other\'\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></span></div></div></div><!-- <div class=\"clear-button\" ng-if=\"!!date && allowClear\">\r\n      <div ng-click=\"update()\" ng-bind=\"clearText || \'Clear\'\"></div>\r\n    </div>\r\n    <div class=\"close-button\">\r\n      <div ng-click=\"close()\" ng-bind=\"closeText || \'Close\'\"></div>\r\n    </div> --></div></div>");
$templateCache.put("scripts/directives/date-form/datetime-input.html","<div class=\"datetime-input datetime\"><div class=display-wrap><div ng-click=toggleEditPopover(); class=display ng-class=\"{\'active\': !!selected, \'warning\': !!warning, \'{{cssClass}}\': !!cssClass}\"><div class=date ng-bind=\"datetime.format(dateFormat || \'YYYY.MM.DD\')\"></div><div class=time ng-bind=\"datetime.format(timeFormat || \'HH:mm\')\"></div><div ng-if=!datetime class=placeholder ng-bind=placeholder></div></div><i class=\"fa fa-eraser fa-fw ico-reset\" ng-click=resetDate() ng-if=datetime></i></div><div class=edit-popover ng-show=!!selected><div class=header><span class=ml-25 ng-click=clcikYearShow()><span ng-bind=\"selected.format(\'YYYY\')\"></span>년 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10 ng-click=\"clickYear(selected.format(\'YYYY\'))\"><span ng-bind=\"selected.format(\'MM\')\"></span>월 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10><span ng-bind=\"selected.format(\'DD\')\"></span> 일<i class=\"fa fa-caret-down\"></i></span> <span class=\"pull-right mr-10\" ng-click=close()><i class=\"fa fa-close\"></i></span></div><div class=calendar ng-show=!!calendarActive><!-- 년도 목록, --><div class=calendar-header ng-if=yearShow><span>{{calendarYearStart.format(\'YYYY\')}} - {{calendarYearEnd.format(\'YYYY\')}}</span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYears()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYears()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=yearShow><div class=years><span class=yearList ng-repeat=\"year in yearList\" ng-click=clickYear(year)><span ng-bind=year ng-class=\"{ \'yearUnder\' : selected.year() == year}\"></span></span></div></div><!-- 월 목록, --><div class=calendar-header ng-if=monthShow><span ng-bind=\"calendar.format(\'YYYY\')\" ng-click=clcikYearShow()></span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYear()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYear()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=monthShow><div class=month><span class=monthList ng-repeat=\"month in monthList\" ng-click=clickMonth(month)>{{month}}월</span></div></div><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\" ng-if=dateShow><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MM\') : calendar.format(\'MM YYYY\')\"></span><div class=arrowWrap><span class=\"arrow arrow-left\" ng-click=subtractMonth()><i class=\"fa fa-angle-left\"></i></span> <span class=\"arrow arrow-right\" ng-click=addMonth()><i class=\"fa fa-angle-right\"></i></span></div></div><div class=calendar-body ng-if=dateShow><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\"><span class=day-point></span> <span class=day-tx ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: ((calendar.clone().endOf(\'month\').week() - calendar.clone().startOf(\'month\').week()) + 1) track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"update(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\"><span class=day-point></span> <span class=day-tx ng-class=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()+1 == currentMonth ? \'\' : \'day-other\'\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></span></div></div></div><div class=timer ng-if=dateShow><div class=timer-hours scroll-up=\"updateAddHour(selected.clone().add(hourStep || 1, \'hours\'))\" scroll-down=\"update(selected.clone().subtract(hourStep || 1, \'hours\'))\"><div class=\"arrow arrow-up\" ng-click=\"updateAddHour(selected.clone().add(hourStep || 1, \'hours\'),\'\')\"><i class=\"fa fa-angle-up\"></i></div><span ng-bind=\"selected.format(\'HH\')\"></span><div class=\"arrow arrow-down\" ng-click=\"updateSubtractHour(selected.clone().subtract(hourStep || 1, \'hours\'))\"><i class=\"fa fa-angle-down\"></i></div></div><div class=timer-divider>:</div><div class=timer-minutes scroll-up=\"update(selected.clone().add(minuteStep || 1, \'minutes\'))\" scroll-down=\"update(selected.clone().subtract(minuteStep || 1, \'minutes\'))\"><div class=\"arrow arrow-up\" ng-click=\"updateAddMinutes(selected.clone().add(minuteStep || 1, \'minutes\'))\"><i class=\"fa fa-angle-up\"></i></div><span ng-bind=\"selected.format(\'mm\')\"></span><div class=\"arrow arrow-down\" ng-click=\"updateSubtractMinutes(selected.clone().subtract(minuteStep || 1, \'minutes\'))\"><i class=\"fa fa-angle-down\"></i></div></div><div class=timer-divider style=\"display: none\">:</div><div class=timer-seconds style=\"display: none\" scroll-up=\"update(selected.clone().add(secondStep || 1, \'seconds\'))\" scroll-down=\"update(selected.clone().subtract(secondStep || 1, \'seconds\'))\"><div class=\"arrow arrow-up\" ng-click=\"update(selected.clone().add(secondStep || 1, \'seconds\'))\"><i class=\"fa fa-angle-up\"></i></div><span ng-bind=\"selected.format(\'ss\')\"></span><div class=\"arrow arrow-down\" ng-click=\"update(selected.clone().subtract(secondStep || 1, \'seconds\'))\"><i class=\"fa fa-angle-down\"></i></div></div></div><!-- <div class=\"clear-button\" ng-if=\"!!datetime && allowClear\">\r\n      <div ng-click=\"update()\" ng-bind=\"clearText || \'Clear\'\"></div>\r\n    </div>\r\n    <div class=\"close-button\">\r\n      <div ng-click=\"close()\" ng-bind=\"closeText || \'Close\'\"></div>\r\n    </div> --></div></div>");
$templateCache.put("scripts/directives/date-form/datetime-picker.html","<div class=\"datetime-input datetime\"><div class=display-wrap><div ng-click=toggleEditPopover(); class=display ng-class=\"{\'active\': !!selected, \'warning\': !!warning, \'{{cssClass}}\': !!cssClass}\"><div class=date ng-bind=\"datetime.format(dateFormat || \'YYYY.MM.DD\')\"></div><div class=time ng-bind=\"datetime.format(timeFormat || \'HH:mm\')\"></div><div ng-if=!datetime class=placeholder ng-bind=placeholder></div></div><i class=\"fa fa-eraser fa-fw ico-reset\" ng-click=resetDate() ng-if=datetime></i></div><div class=edit-popover ng-show=!!selected><div class=header><span class=ml-25 ng-click=clcikYearShow()><span ng-bind=\"selected.format(\'YYYY\')\"></span>년 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10 ng-click=\"clickYear(selected.format(\'YYYY\'))\"><span ng-bind=\"selected.format(\'MM\')\"></span>월 <i class=\"fa fa-caret-down\"></i></span> <span class=ml-10><span ng-bind=\"selected.format(\'DD\')\"></span> 일<i class=\"fa fa-caret-down\"></i></span> <span class=\"pull-right mr-10\" ng-click=close()><i class=\"fa fa-close\"></i></span></div><div class=calendar ng-show=!!calendarActive><!-- 년도 목록, --><div class=calendar-header ng-if=yearShow><span>{{calendarYearStart.format(\'YYYY\')}} - {{calendarYearEnd.format(\'YYYY\')}}</span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYears()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYears()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=yearShow><div class=years><span class=yearList ng-repeat=\"year in yearList\" ng-click=clickYear(year)><span ng-bind=year ng-class=\"{ \'yearUnder\' : selected.year() == year}\"></span></span></div></div><!-- 월 목록, --><div class=calendar-header ng-if=monthShow><span ng-bind=\"calendar.format(\'YYYY\')\" ng-click=clcikYearShow()></span><div class=arrowWrap><div class=\"arrow arrow-left\" ng-click=subtractYear()><i class=\"fa fa-angle-left\"></i></div><div class=\"arrow arrow-right\" ng-click=addYear()><i class=\"fa fa-angle-right\"></i></div></div></div><div class=calendar-body ng-if=monthShow><div class=month><span class=monthList ng-repeat=\"month in monthList\" ng-click=clickMonth(month)>{{month}}월</span></div></div><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\" ng-if=dateShow><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MM\') : calendar.format(\'MM YYYY\')\"></span><div class=arrowWrap><span class=\"arrow arrow-left\" ng-click=subtractMonth()><i class=\"fa fa-angle-left\"></i></span> <span class=\"arrow arrow-right\" ng-click=addMonth()><i class=\"fa fa-angle-right\"></i></span></div></div><div class=calendar-body ng-if=dateShow><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\"><span class=day-point></span> <span class=day-tx ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: ((calendar.clone().endOf(\'month\').week() - calendar.clone().startOf(\'month\').week()) + 1) track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"update(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\"><span class=day-point></span> <span class=day-tx ng-class=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()+1 == currentMonth ? \'\' : \'day-other\'\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></span></div></div></div><div class=timer ng-if=dateShow><timepicker id=id_time name=time start-time={{minHour}} end-time={{maxHour}} step-time={{minuteStep}} class=form-field label=\"Enter time:\" ng-model=datetimeTime callback=timeChanged required></timepicker></div><!-- <div class=\"clear-button\" ng-if=\"!!datetime && allowClear\">\r\n      <div ng-click=\"update()\" ng-bind=\"clearText || \'Clear\'\"></div>\r\n    </div>\r\n    <div class=\"close-button\">\r\n      <div ng-click=\"close()\" ng-bind=\"closeText || \'Close\'\"></div>\r\n    </div> --></div></div>");
$templateCache.put("scripts/directives/date-form/time-input.html","<div class=\"datetime-input time\"><div class=display-wrap><div ng-click=toggleEditPopover() class=display ng-class=\"{\'active\': !!selected, \'warning\': !!warning, \'{{cssClass}}\': !!cssClass}\"><!-- <div class=\"time\" ng-bind=\"time.format(timeFormat || \'HH : mm\')\"></div> --><div class=time ng-bind=time></div><div ng-if=!time class=placeholder ng-bind=placeholder></div></div><i class=\"fa fa-eraser fa-fw ico-reset\" ng-click=resetDate() ng-if=time></i></div><div class=edit-popover ng-show=!!selected><div class=header ng-bind=\"selected.format(\'DD MMMM YYYY\')\" ng-if=false></div><div class=timer><div class=timer-hours scroll-up=\"update(selected.clone().add(hourStep || 1, \'hours\'))\" scroll-down=\"update(selected.clone().subtract(hourStep || 1, \'hours\'))\"><div class=\"arrow arrow-up\" ng-click=\"update(selected.clone().add(hourStep || 1, \'hours\'))\"></div><span ng-bind=\"selected.format(\'HH\')\"></span><div class=\"arrow arrow-down\" ng-click=\"update(selected.clone().subtract(hourStep || 1, \'hours\'))\"></div></div><div class=timer-divider>:</div><div class=timer-minutes scroll-up=\"update(selected.clone().add(minuteStep || 1, \'minutes\'))\" scroll-down=\"update(selected.clone().subtract(minuteStep || 1, \'minutes\'))\"><div class=\"arrow arrow-up\" ng-click=\"update(selected.clone().add(minuteStep || 1, \'minutes\'))\"></div><span ng-bind=\"selected.format(\'mm\')\"></span><div class=\"arrow arrow-down\" ng-click=\"update(selected.clone().subtract(minuteStep || 1, \'minutes\'))\"></div></div><div class=timer-divider ng-if=false>:</div><div class=timer-seconds ng-if=false scroll-up=\"update(selected.clone().add(secondStep || 1, \'seconds\'))\" scroll-down=\"update(selected.clone().subtract(secondStep || 1, \'seconds\'))\"><div class=\"arrow arrow-up\" ng-click=\"update(selected.clone().add(secondStep || 1, \'seconds\'))\"></div><span ng-bind=\"selected.format(\'ss\')\"></span><div class=\"arrow arrow-down\" ng-click=\"update(selected.clone().subtract(secondStep || 1, \'seconds\'))\"></div></div></div><div class=clear-button ng-if=\"!!time && allowClear\"><div ng-click=update() ng-bind=\"clearText || \'Clear\'\"></div></div><div class=close-button ng-if=false><div ng-click=close() ng-bind=\"closeText || \'Close\'\"></div></div></div></div>");
$templateCache.put("scripts/directives/date-range-form/date-range.html","<div class=\"datetime-range date\"><div class=start-datetime ng-click=selectDate(start) ng-class=\"{\'active\': selected === start, \'warning\': warning === \'start\' }\"><div class=date ng-bind=\"start.format(\'DD MMM YYYY\')\"></div></div><div class=end-datetime ng-click=selectDate(end) ng-class=\"{\'active\': selected === end, \'warning\': warning === \'end\'}\"><div class=date ng-bind=\"end.format(\'DD MMM YYYY\')\"></div></div><div class=presets ng-show=!!presets><div class=dots ng-show=!presetsActive ng-click=\"presetsActive = !presetsActive\"><div class=dot ng-repeat=\"dot in \'.....\' track by $index\"></div></div><div class=list ng-class=\"{\'active\': !!presetsActive}\"><div class=preset-button ng-repeat=\"preset in presets\" ng-click=selectPreset(preset) ng-bind=preset.name></div></div></div><div class=edit-popover ng-show=!!selected><div class=header ng-class=\"{\'start\': selected === start, \'end\': selected === end}\" ng-bind=\"selected.format(\'DD MMMM YYYY\')\"></div><div class=calendar><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\"><div class=\"arrow arrow-left\" ng-click=\"calendar.subtract(1, \'months\')\"></div><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MMMM\') : calendar.format(\'MMMM YYYY\')\"></span><div class=\"arrow arrow-right\" ng-click=\"calendar.add(1, \'months\')\"></div></div><div class=calendar-body><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\" ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: getNumWeeks() track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"setDate(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></div></div></div><div class=close-button><div ng-click=close() ng-bind=\"closeText || \'Close\'\"></div></div></div></div>");
$templateCache.put("scripts/directives/date-range-form/datetime-range.html","<div class=\"datetime-range datetime\"><div class=start-datetime ng-click=selectDate(start) ng-class=\"{\'active\': selected === start, \'warning\': warning === \'start\' }\"><div class=date ng-bind=\"start.format(\'DD MMM YYYY\')\"></div><div class=time ng-bind=\"start.format(\'HH : mm : ss\')\"></div></div><div class=end-datetime ng-click=selectDate(end) ng-class=\"{\'active\': selected === end, \'warning\': warning === \'end\'}\"><div class=date ng-bind=\"end.format(\'DD MMM YYYY\')\"></div><div class=time ng-bind=\"end.format(\'HH : mm : ss\')\"></div></div><div class=presets ng-show=!!presets><div class=dots ng-show=!presetsActive ng-click=\"presetsActive = !presetsActive\"><div class=dot ng-repeat=\"dot in \'.....\' track by $index\"></div></div><div class=list ng-class=\"{\'active\': !!presetsActive}\"><div class=preset-button ng-repeat=\"preset in presets\" ng-click=selectPreset(preset) ng-bind=preset.name></div></div></div><div class=edit-popover ng-show=!!selected><div class=calendar-toggle ng-class=\"{\'start\': selected === start, \'end\': selected === end}\" ng-click=\"calendarActive = !calendarActive\" ng-bind=\"selected.format(\'DD MMMM YYYY\')\"></div><div class=calendar ng-show=!!calendarActive><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\"><div class=\"arrow arrow-left\" ng-click=\"calendar.subtract(1, \'months\')\"></div><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MMMM\') : calendar.format(\'MMMM YYYY\')\"></span><div class=\"arrow arrow-right\" ng-click=\"calendar.add(1, \'months\')\"></div></div><div class=calendar-body><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\" ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: getNumWeeks() track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"setDate(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></div></div></div><div class=timer><div class=timer-hours scroll-up=\"setDate(selected.clone().add(1, \'hours\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'hours\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'hours\'))\"></div><span ng-bind=\"selected.format(\'HH\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'hours\'))\"></div></div><div class=timer-divider>:</div><div class=timer-minutes scroll-up=\"setDate(selected.clone().add(1, \'minutes\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'minutes\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'minutes\'))\"></div><span ng-bind=\"selected.format(\'mm\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'minutes\'))\"></div></div><div class=timer-divider>:</div><div class=timer-seconds scroll-up=\"setDate(selected.clone().add(1, \'seconds\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'seconds\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'seconds\'))\"></div><span ng-bind=\"selected.format(\'ss\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'seconds\'))\"></div></div></div><div class=close-button><div ng-click=close() ng-bind=\"closeText || \'Close\'\"></div></div></div></div>");
$templateCache.put("scripts/directives/date-range-form/time-range.html","<div class=\"datetime-range time\"><div class=start-datetime ng-click=selectDate(start) ng-class=\"{\'active\': selected === start, \'warning\': warning === \'start\' }\"><div class=time ng-bind=\"start.format(\'HH : mm : ss\')\"></div></div><div class=end-datetime ng-click=selectDate(end) ng-class=\"{\'active\': selected === end, \'warning\': warning === \'end\'}\"><div class=time ng-bind=\"end.format(\'HH : mm : ss\')\"></div></div><div class=presets ng-show=!!presets><div class=dots ng-show=!presetsActive ng-click=\"presetsActive = !presetsActive\"><div class=dot ng-repeat=\"dot in \'.....\' track by $index\"></div></div><div class=list ng-class=\"{\'active\': !!presetsActive}\"><div class=preset-button ng-repeat=\"preset in presets\" ng-click=selectPreset(preset) ng-bind=preset.name></div></div></div><div class=edit-popover ng-show=!!selected><div class=header ng-class=\"{\'start\': selected === start, \'end\': selected === end}\" ng-bind=\"selected.format(\'DD MMMM YYYY\')\"></div><div class=calendar ng-show=!!calendarActive><div class=calendar-header scroll-up=\"calendar.add(1, \'months\')\" scroll-down=\"calendar.subtract(1, \'months\')\"><div class=\"arrow arrow-left\" ng-click=\"calendar.subtract(1, \'months\')\"></div><span ng-bind=\"calendar.format(\'YYYY\') === current.format(\'YYYY\') ? calendar.format(\'MMMM\') : calendar.format(\'MMMM YYYY\')\"></span><div class=\"arrow arrow-right\" ng-click=\"calendar.add(1, \'months\')\"></div></div><div class=calendar-body><div class=weekdays><span class=weekday ng-repeat=\"weekday in \'weeeeek\' track by $index\" ng-bind=\"calendar.clone().startOf(\'week\').add($index, \'days\').format(\'ddd\')\"></span></div><div class=week ng-repeat=\"week in \'months\' | limitTo: getNumWeeks() track by $index\"><span class=date ng-repeat=\"date in \'weeeeek\' track by $index\" ng-class=\"{\r\n              \'current\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(current.clone().startOf(\'day\')),\r\n              \'active\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).startOf(\'day\').isSame(selected.clone().startOf(\'day\')),\r\n              \'inactive\': calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month() !== calendar.month()\r\n            }\" ng-click=\"setDate(selected.clone().year(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).year()).month(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).month()).date(calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()), true)\" ng-bind=\"calendar.clone().startOf(\'month\').add($parent.$index, \'weeks\').weekday($index).date()\"></span></div></div></div><div class=timer><div class=timer-hours scroll-up=\"setDate(selected.clone().add(1, \'hours\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'hours\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'hours\'))\"></div><span ng-bind=\"selected.format(\'HH\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'hours\'))\"></div></div><div class=timer-divider>:</div><div class=timer-minutes scroll-up=\"setDate(selected.clone().add(1, \'minutes\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'minutes\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'minutes\'))\"></div><span ng-bind=\"selected.format(\'mm\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'minutes\'))\"></div></div><div class=timer-divider>:</div><div class=timer-seconds scroll-up=\"setDate(selected.clone().add(1, \'seconds\'))\" scroll-down=\"setDate(selected.clone().subtract(1, \'seconds\'))\"><div class=\"arrow arrow-up\" ng-click=\"setDate(selected.clone().add(1, \'seconds\'))\"></div><span ng-bind=\"selected.format(\'ss\')\"></span><div class=\"arrow arrow-down\" ng-click=\"setDate(selected.clone().subtract(1, \'seconds\'))\"></div></div></div><div class=close-button><div ng-click=close() ng-bind=\"closeText || \'Close\'\"></div></div></div></div>");
$templateCache.put("scripts/directives/kakaomap-config/kakaomap-config.html","<button class=\"btn btn-default\" type=button ng-click=ccCtrl.kakaomapConfigModal()><i class=\"fa fa-search\"></i>지도보기</button>");
$templateCache.put("scripts/directives/meta-sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 0px 0px 0px 0px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-move;\r\n      cursor: -moz-move;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }\r\n\r\n  .table > tbody > tr > td {\r\n    padding : 0px;\r\n  }\r\n\r\n  .user-column {\r\n    background-color: #fff7f7;\r\n  }\r\n\r\n  .table-custom > tbody > tr > td { height: 40px !important; padding: 4px !important; }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  //$(\".sortable-root-scope\").css(\"min-height\", height);</script><div class=MetatableSortableCtrl><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\" ng-if=\"scVc.viewType == \'S\'\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th style=\"width: 50px\" data-toggle=true class=text-center><label>순서</label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>속성명</label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label style=\"color: red\">*</label><label>필드명 <i class=\"fa fa-question-circle\" ng-click=boardMngSave.showFieldNameRule() style=color:red></i></label></th><th style=\"width: 70px\" data-toggle=true class=\"text-center showlevel5\" ng-if=\"scVc.mode == \'A\'\"><label>검색표시</label></th><th style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-if=\"scVc.mode == \'A\'\"><label>검색열사이즈(1/x)</label></th><th style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-if=\"scVc.mode == \'A\'\"><label>표시섹션</label></th><th style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-if=\"scVc.mode == \'A\'\"><label>폼그룹설정</label></th><th style=\"width: 150px\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label></label></th></tr></thead></table></div><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\" ng-if=\"scVc.viewType == \'L\'\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th style=\"width: 50px\" data-toggle=true class=text-center><label>순서</label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>속성명</label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label style=\"color: red\">*</label><label>필드명 <i class=\"fa fa-question-circle\" ng-click=boardMngSave.showFieldNameRule() style=color:red></i></label></th><th style=\"width: 10%\" data-toggle=true class=text-center><label style=\"color: red\">*</label><label>목록화면 폭</label></th><th style=\"width: 70px\" data-toggle=true class=text-center><label>목록표시</label></th><th style=\"width: 10%\" data-toggle=true class=text-center><label>표시방법</label></th><th style=\"width: 70px\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label>정렬가능</label></th><th style=\"width: 10%\" data-toggle=true class=text-center><label>텍스트정렬</label></th><th style=\"width: 150px\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label></label></th></tr></thead></table></div><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\" ng-if=\"scVc.viewType == \'D\'\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><thead><tr><th style=\"width: 50px\" data-toggle=true class=\"text-center showlevel0\"><label>순서</label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>속성명</label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label style=\"color: red\">*</label><label>필드명 <i class=\"fa fa-question-circle\" ng-click=boardMngSave.showFieldNameRule() style=color:red></i></label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label>표시섹션</label></th><th style=\"width: 65px\" data-toggle=true class=text-center><label>상세표시</label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label>공통코드</label></th><th style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-if=\"scVc.mode == \'A\'\"><label>커스텀코드</label></th><th style=\"width: 10%\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label>논리데이터유형</label></th><th style=\"width: 100px\" data-toggle=true class=\"text-center showlevel5\"><label>ColSize(1/x)</label></th><th style=\"width: 150px\" data-toggle=true class=text-center ng-if=\"scVc.mode == \'A\'\"><label></label></th></tr></thead></table></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"scVc.viewType == \'S\'\"><tbody><tr><td style=\"width: 50px\" data-toggle=true class=\"text-center showlevel0\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.searchIdx readonly style=\"text-align: center\"></td><td data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.columnLogicalNm no-drag ng-disabled=\"scVc.mode != \'A\'\"></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><common-code ng-if=\"item.customColumnYN == \'Y\'\" param-data=item.commoncodeDATA callback=scVc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" required no-drag></common-code><input ng-if=\"item.customColumnYN == \'N\'\" type=text class=form-control ng-model=item.columnPhysicalNm no-drag></td><td style=\"width: 70px\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=checkbox ng-checked=\"item.searchColumnShowYN == \'Y\'\" ng-model=item.searchColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" no-drag></td><td style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><select class=form-control ng-model=item.searchColumnRowCount no-drag><option value=1>1</option><option value=2>2</option><option value=3>3</option><option value=4>4</option></select><!-- <input type=\"text\" class=\"form-control\" ng-model=\"item.searchColumnRowCount\"> --></td><td style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=text class=form-control ng-model=item.searchTarget no-drag ng-disabled=\"scVc.mode != \'A\'\"></td><td style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><select class=form-control ng-model=item.groupIdTarget no-drag ng-change=\"scVc.checkSearchDuplicateFormGroup($index, item);\"><option value=\"\"></option><option ng-repeat=\"opt in scVc.bindData\" ng-show=\"opt.columnPhysicalNm != item.columnPhysicalNm && opt.checkSearchDuplicate!=\'Y\'\" value={{opt.columnPhysicalNm}}>{{opt.columnLogicalNm}}</option></select></td><td style=\"width: 150px\" class=tx-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><button type=button class=\"btn btn-danger btn-min\" ng-click=scVc.deleteColumn(item) no-drag><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=button class=\"btn btn-success btn-min\" ng-click=scVc.openAttrSetup(item) no-drag><i class=\"fa fa-edit\">{{ \'Menu.EICON_DETAILEDIT\' | translate }}</i></button></td></tr></tbody></table><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"scVc.viewType == \'L\'\"><tbody><tr><td style=\"width: 50px\" data-toggle=true class=\"text-center showlevel0\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.listColumnSort readonly style=\"text-align: center\"></td><td data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.columnLogicalNm no-drag ng-disabled=\"scVc.mode != \'A\'\"></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><common-code ng-if=\"item.customColumnYN == \'Y\'\" param-data=item.commoncodeDATA callback=scVc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" required no-drag></common-code><input ng-if=\"item.customColumnYN == \'N\'\" type=text class=form-control ng-model=item.columnPhysicalNm no-drag></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.listColumnWidth no-drag></td><td style=\"width: 70px\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=checkbox ng-checked=\"item.listColumnShowYN == \'Y\'\" ng-model=item.listColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" style=\"margin-left: 4px\" no-drag></td><td style=\"width: 10%\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><select class=form-control ng-model=item.listColumnShowLevel style=\"width:calc(100% - 25px); display:inline-block\" no-drag><option value=showlevel1>①항상 표시</option><option value=showlevel2>②768 이상일때 표시</option><option value=showlevel3>③992 이상일때 표시</option><option value=showlevel4>④1024 이상일때 표시</option><option value=showlevel5>⑤1400 이상일때 표시</option><!-- <option value=\"showlevel0\">검색영역에만 표시</option> --></select></td><td style=\"width: 70px\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=checkbox ng-checked=\"item.keyColumnYN == \'Y\'\" ng-model=item.keyColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" no-drag></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><select class=form-control ng-model=item.listColumnTextAlign no-drag><option value=text-left>왼쪽정렬</option><option value=text-center>중앙정렬</option><option value=text-right>오른쪽정렬</option></select><!-- <input type=\"text\" class=\"form-control\" ng-model=\"item.listColumnTextAlign\"> --></td><td style=\"width: 150px\" class=tx-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><button type=button class=\"btn btn-danger btn-min\" ng-click=scVc.deleteColumn(item) no-drag><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=button class=\"btn btn-success btn-min\" ng-click=scVc.openAttrSetup(item) no-drag><i class=\"fa fa-edit\">{{ \'Menu.EICON_DETAILEDIT\' | translate }}</i></button></td></tr></tbody></table><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"scVc.viewType == \'D\'\"><!-- Header --><tbody><tr><td style=\"width: 50px\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.editColumnSort readonly style=\"text-align: center\"></td><td data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=text class=form-control ng-model=item.columnLogicalNm no-drag ng-disabled=\"scVc.mode != \'A\'\"></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><common-code ng-if=\"item.customColumnYN == \'Y\'\" param-data=item.commoncodeDATA callback=scVc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" no-drag required></common-code><input ng-if=\"item.customColumnYN == \'N\'\" type=text class=form-control ng-model=item.columnPhysicalNm no-drag></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=text class=form-control ng-model=item.columnSection ng-blur=\"scVc.onChangeSection($index, item.columnSection)\" no-drag></td><td style=\"width: 65px\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><input type=checkbox ng-checked=\"item.editColumnShowYN == \'Y\'\" ng-model=item.editColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" no-drag></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=text class=form-control ng-model=item.codeType no-drag></td><td style=\"width: 10%\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><input type=text class=form-control ng-model=item.codeCustType no-drag></td><td style=\"width: 10%\" data-toggle=true class=text-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><select class=form-control ng-model=item.columnLogicalDataType no-drag><option ng-repeat=\"op in scVc.codeList\" value={{op.code}}>{{op.codeValue}}</option></select></td><td style=\"width: 100px\" data-toggle=true class=\"text-center showlevel5\" ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\"><select class=form-control ng-model=item.editColumnRowCount no-drag><option value=1>1</option><option value=2>2</option><option value=3>3</option><option value=4>4</option></select><!-- <input type=\"text\" class=\"form-control\" ng-model=\"item.editColumnRowCount\" ng-blur=\"scVc.onChangeDetailColSize($index, item.editColumnRowCount)\"> --></td><td style=\"width: 150px\" class=tx-center ng-class=\"{\'user-column\':item.metaColumnUserId != null && item.metaColumnUserId != 0}\" ng-if=\"scVc.mode == \'A\'\"><button type=button class=\"btn btn-danger btn-min\" ng-click=scVc.deleteColumn(item) no-drag><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=button class=\"btn btn-success btn-min\" ng-click=scVc.openAttrSetup(item) no-drag><i class=\"fa fa-edit\">{{ \'Menu.EICON_DETAILEDIT\' | translate }}</i></button></td></tr></tbody></table></div></div><!-- /1 dpeth --></div></div></div>");
$templateCache.put("scripts/directives/metadata-config/metadata-config.html","<style>.config-icon {\r\n  margin: 0px 0px 10px 10px;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  color: #547df9;\r\n}</style><a href=\"\" ng-click=ccCtrl.metadataConfigModal()><i class=\"fa fa-cog config-icon\"></i></a>");
$templateCache.put("scripts/directives/search-condition/search-condition.html","<span class=search-condition-str><b>검색결과 <font color=red>{{ccCtrl.countStr}}</font>건</b> {{ccCtrl.searchConditionStr}}</span>");
$templateCache.put("scripts/directives/select-data-group/select-data-group.html","<span class=data-group-str ng-click=ccCtrl.changeDatagroup()><b>:::: 데이터그룹 <font color=red>{{ccCtrl.DatagroupNm}}</font> &gt; 작업명 <font color=red>{{ccCtrl.ActionNm}}</font> <i class=\"fa fa-search\"></i></b></span>");
$templateCache.put("scripts/directives/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortable-root-scope\").css(\"min-height\", height);</script><div class=sortableContainer><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu ng-if=!scVc.isBranch><div><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item.tempId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div><span ng-if=\"item.UseYN == \'\' || item.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(1, item.tempId)\" ng-if=\"scVc.maxDepth > 1\" style=color:#496887>대부서등록 |</span> <span ng-click=\"scVc.delChild(1, item)\" style=color:#496887>삭제</span></div></div></div></div><!-- /1 dpeth --><!-- 2 dpeth --><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item.child style=margin-left:15px><!-- 3 dpeth --><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item2) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item2.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item2.tempId)\" menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item2.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item2.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item2.tempId}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div><span ng-if=\"item2.UseYN == \'\' || item2.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(2, item2.tempId)\" ng-if=\"scVc.maxDepth > 2\" style=color:#496887>소부서추가</span> | <span ng-click=\"scVc.delChild(2, item2)\" style=color:#496887>삭제</span></div></div></div></div><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item3) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item3.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item3.tempId)\" menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.DelYN!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.tempId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item3.tempId}} menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}}><div><span ng-if=\"item3.UseYN == \'\' || item3.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.delChild(3, item3)\" style=color:#496887>삭제</span></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.tempId}} menu-path={{item2.path}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth03title input-enter=\"scVc.addMenuItem(3, \'editor{{item2.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(3, \'editor\'+item2.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(3, \'editor\'+item2.tempId)\">취소</span></div><div style=clear:both></div></div></div></div></div><!-- /3 dpeth --><div><div class=edit-layout style=background:#FFF id=editor{{item.tempId}} menu-path={{item.path}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth02title input-enter=\"scVc.addMenuItem(2, \'editor{{item.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(2, \'editor\'+item.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(2, \'editor\'+item.tempId)\">취소</span></div><div style=clear:both></div></div></div></div><!-- /2 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("scripts/directives/time-picker/time-picker.html","<div class=timepicker><input type=text ng-model=theTime class=form-control time-input render-on-blur render-on-enter><div ng-show=showingChoiceList class=timepicker-dropdown ng-cloak><div ng-repeat=\"time in choiceTimes\" class=item id=\"d{{ time | dateToTimestamp }}\" ng-click=setTime(time) ng-class=\"{ selected: isSelectedTime(time) }\">{{ time | date:\"shortTime\" }}</div></div></div>");
$templateCache.put("scripts/directives/time-select/time-select.html","<style>.directivelabel { float:left; margin: 5px 5px 5px 3px; }</style><span style=float:left><select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandlerHour() ng-model=ccCtrl.selectHour ng-options=\"opt for opt in ccCtrl.listHour | filter:isHourRange\" ng-disabled=ccCtrl.isDisabled style=min-width:80px></select></span><span class=directivelabel>{{ \'Menu.HOUR\' | translate }}</span> <span style=float:left;top:10px><select class=\"form-control ml-5\" name=selectCombo ng-change=ccCtrl.onChangeHandlerMinute() ng-model=ccCtrl.selectMinute ng-options=\"opt for opt in ccCtrl.listMinute | filter:isMinuteRange\" ng-disabled=ccCtrl.isDisabled style=min-width:80px></select></span><span class=directivelabel>{{ \'Menu.MINUTE\' | translate }}</span>");
$templateCache.put("scripts/directives/timetaken-picker/timetaken-picker.html","<div class=timepicker><input type=text ng-model=theTime class=form-control timetaken-input render-on-blur render-on-enter value=\"{{theTime | takenTime}}\"><div ng-show=showingChoiceList class=timetakenpicker-dropdown ng-cloak><div ng-repeat=\"time in choiceTimes\" class=item id=\"d{{ time | dateToTimestamp }}\" ng-click=setTime(time) ng-class=\"{ selected: isSelectedTime(time) }\">{{ time | takenTime}}</div></div></div>");
$templateCache.put("scripts/directives/udc/udc-detail.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><div class=\"form-control txt_view\" ng-switch=li.ColumnLogicalDataType><span ng-switch-when=40>{{vc.metaModel[li.ColumnPhysicalNm] | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span> <span ng-switch-when=50>{{vc.getCodeValue(li.ColumnPhysicalNm)}}</span> <span ng-switch-when=60><i class=\"fa {{vc.metaModel[li.ColumnPhysicalNm]}}\" aria-hidden=true></i></span> <span ng-switch-default>{{vc.metaModel[li.ColumnPhysicalAsNm] ? vc.metaModel[li.ColumnPhysicalAsNm] : vc.metaModel[li.ColumnPhysicalNm]}}</span></div></div></div>");
$templateCache.put("scripts/directives/udc/udc-edit.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom></div></div>");
$templateCache.put("scripts/directives/udc/udc-search.html","<div ng-repeat=\"li in vc.metaList\" class=\"col-lg-4 col-md-4 col-sm-8 col-xs-8\" ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inner-label\"><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label></div></div>");
$templateCache.put("components/biz-component/buttons/buttons.html","<div class=row><div class=col-lg-12><h1 class=page-header>Buttons</h1></div><!-- /.col-lg-12 --></div><!-- /.row --><div class=row><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Default Buttons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Buttons</h4><p><button type=button class=\"btn btn-default\">Default</button> <button type=button class=\"btn btn-primary\">Primary</button> <button type=button class=\"btn btn-success\">Success</button> <button type=button class=\"btn btn-info\">Info</button> <button type=button class=\"btn btn-warning\">Warning</button> <button type=button class=\"btn btn-danger\">Danger</button> <button type=button class=\"btn btn-link\">Link</button></p><br><h4>Disabled Buttons</h4><p><button type=button class=\"btn btn-default disabled\">Default</button> <button type=button class=\"btn btn-primary disabled\">Primary</button> <button type=button class=\"btn btn-success disabled\">Success</button> <button type=button class=\"btn btn-info disabled\">Info</button> <button type=button class=\"btn btn-warning disabled\">Warning</button> <button type=button class=\"btn btn-danger disabled\">Danger</button> <button type=button class=\"btn btn-link disabled\">Link</button></p><br><h4>Button Sizes</h4><p><button type=button class=\"btn btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-primary\">Default button</button> <button type=button class=\"btn btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Circle Icon Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-lg\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-lg\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-lg\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-lg\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Extra Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-xl\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-xl\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-xl\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-xl\"><i class=\"fa fa-heart\"></i></button></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Outline Buttons with Smooth Transition</div><!-- /.panel-heading --><div class=panel-body><h4>Outline Buttons</h4><p><button type=button class=\"btn btn-outline btn-default\">Default</button> <button type=button class=\"btn btn-outline btn-primary\">Primary</button> <button type=button class=\"btn btn-outline btn-success\">Success</button> <button type=button class=\"btn btn-outline btn-info\">Info</button> <button type=button class=\"btn btn-outline btn-warning\">Warning</button> <button type=button class=\"btn btn-outline btn-danger\">Danger</button> <button type=button class=\"btn btn-outline btn-link\">Link</button></p><br><h4>Outline Button Sizes</h4><p><button type=button class=\"btn btn-outline btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-outline btn-primary\">Default button</button> <button type=button class=\"btn btn-outline btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-outline btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-outline btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Social Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Social Buttons</h4><a class=\"btn btn-block btn-social btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i> Sign in with Bitbucket </a><a class=\"btn btn-block btn-social btn-dropbox\"><i class=\"fa fa-dropbox\"></i> Sign in with Dropbox </a><a class=\"btn btn-block btn-social btn-facebook\"><i class=\"fa fa-facebook\"></i> Sign in with Facebook </a><a class=\"btn btn-block btn-social btn-flickr\"><i class=\"fa fa-flickr\"></i> Sign in with Flickr </a><a class=\"btn btn-block btn-social btn-github\"><i class=\"fa fa-github\"></i> Sign in with GitHub </a><a class=\"btn btn-block btn-social btn-google-plus\"><i class=\"fa fa-google-plus\"></i> Sign in with Google </a><a class=\"btn btn-block btn-social btn-instagram\"><i class=\"fa fa-instagram\"></i> Sign in with Instagram </a><a class=\"btn btn-block btn-social btn-linkedin\"><i class=\"fa fa-linkedin\"></i> Sign in with LinkedIn </a><a class=\"btn btn-block btn-social btn-pinterest\"><i class=\"fa fa-pinterest\"></i> Sign in with Pinterest </a><a class=\"btn btn-block btn-social btn-tumblr\"><i class=\"fa fa-tumblr\"></i> Sign in with Tumblr </a><a class=\"btn btn-block btn-social btn-twitter\"><i class=\"fa fa-twitter\"></i> Sign in with Twitter </a><a class=\"btn btn-block btn-social btn-vk\"><i class=\"fa fa-vk\"></i> Sign in with VK</a><hr><div class=text-center><a class=\"btn btn-social-icon btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i></a> <a class=\"btn btn-social-icon btn-dropbox\"><i class=\"fa fa-dropbox\"></i></a> <a class=\"btn btn-social-icon btn-facebook\"><i class=\"fa fa-facebook\"></i></a> <a class=\"btn btn-social-icon btn-flickr\"><i class=\"fa fa-flickr\"></i></a> <a class=\"btn btn-social-icon btn-github\"><i class=\"fa fa-github\"></i></a> <a class=\"btn btn-social-icon btn-google-plus\"><i class=\"fa fa-google-plus\"></i></a> <a class=\"btn btn-social-icon btn-instagram\"><i class=\"fa fa-instagram\"></i></a> <a class=\"btn btn-social-icon btn-linkedin\"><i class=\"fa fa-linkedin\"></i></a> <a class=\"btn btn-social-icon btn-pinterest\"><i class=\"fa fa-pinterest\"></i></a> <a class=\"btn btn-social-icon btn-tumblr\"><i class=\"fa fa-tumblr\"></i></a> <a class=\"btn btn-social-icon btn-twitter\"><i class=\"fa fa-twitter\"></i></a> <a class=\"btn btn-social-icon btn-vk\"><i class=\"fa fa-vk\"></i></a></div></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --></div>");
$templateCache.put("components/login/modal/login-view-modal.html","<div class=modal-content><div class=\"modal-body ng-scope\"><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>THEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODY</p></div><div class=n-login-body><form class=login_box id=login_box ng-submit=vm..doLogin()><div class=\"title mb-30\">THE BODY</div><div class=idpw-box-input style=\"margin-top: 45px\"><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=vm.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"vm.loginInfo.saveId === \'1\'\" ng-model=vm.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-30><ul class=n-login-ui-find><li><span ng-click=\"vm.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"vm.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div></div>");
$templateCache.put("components/login/modal/SecondAuthentication-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">2차 SMS 인증</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><p style=\"color: red\">휴대전화번호 : <span ng-bind=modalCtrl.user.SecondMobile></span></p><!--<p style=\"color:red;\">인증번호 받기 5회 이상 시도 시 2시간동안 로그인이 제한됩니니다.</p>--><p style=\"color: red\">발송된 인증번호는 당일(23:59:59)에 한해 유효 합니다.</p><p style=\"color: red\">수신한 인증번호를 삭제하지 마세요.</p></div></div><div class=row><div class=col-lg-12><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.sendSms() ng-disabled=modalCtrl.buttonDisabled>인증번호 받기</button><!-- <span id=\"countdown\"></span> --></div></div><form ui-keypress=\"{13:\'modalCtrl.ok()\'}\"><div class=row><div class=col-lg-12><input type=text class=form-control ng-model=modalCtrl.SecondNumber placeholder=인증번호></div><!-- <div class=\"col-lg-12\">\r\n        <p style=\"color:red;\">* 다운로드 사유를 5자 이상 입력하세요.</p>\r\n      </div>--></div><!-- //row --></form><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>Login</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div></div>");
$templateCache.put("components/modal/add-photo/addphoto-modal.html","<style>.vault-block{\r\n    margin: 0;\r\n    width: 100%;\r\n  }\r\n  .dhx-file-icon, .dhx-file-info{\r\n    display: none;\r\n  }\r\n  .dhx-file-title{\r\n    line-height: 30px;\r\n  }\r\n  .dxi-delete-forever:before {\r\n    color: #a8f !important;\r\n  }\r\n  \r\n  .vault.dhx_widget .dhx-file-item{\r\n    background-color: #aaaaaa;\r\n    margin: 5px;\r\n    border-radius: 5px;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header><h3>{{vc.title}}사진 첨부</h3></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-5><div><label>{{vc.title}}명</label><input type=text class=form-control id=activityNm ng-model=vc.data.activityNm></div></div></div><div class=row><div class=col-lg-12><div class=\"drop_zone pagecontent\" file-dropzone><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id={{vc.id}} class=vault-block vault-company></div></form></div></div></div></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/add-photo/image-extension-modal.html","<div class=modal-content style=\"text-align: center\"><img src={{link}} alt=\"\" style=\"width: 595px\"><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("components/modal/apk/download-apk-modal.html","<link rel=stylesheet href=../../assets/css/ksacrm.css><link rel=stylesheet href=../../assets/css/login.css><div class=wrapper><div id=container_ style=\"padding-bottom: 0\"><section class=joinStepWrap><div class=content style=\"width: 100%\"><h2>안드로이드 설치</h2></div></section><section class=inputInfoWrap><div class=content><div class=noti><div class=mt-10>1. 다운로드 버튼을 클릭하여 설치 파일을 다운로드한다.</div><div class=mt-5>2. 핸드폰에서 실행 파일을 찾아 실행시킨다.</div><img src=../../assets/images/download/setup_01.png style=\"width: 100%\"><div class=mt-10>3. 연결 프로그램에서 패키지 설치 프로그램을 선택한다.</div><img src=../../assets/images/download/setup_02.png style=\"width: 100%\"><div class=mt-10>4. 설치 버튼을 선택한다.</div><img src=../../assets/images/download/setup_03.png style=\"width: 100%\"><div class=mt-10>5. Play프로텍트에 의해 차단되어있을 경우 무시하고 설치를 선택하여 설치를 진행한다.</div><img src=../../assets/images/download/setup_04.png style=\"width: 100%\"></div><div class=\"buttonWrap mtb30\"><button class=primary_btn ng-click=modalCtrl.download()><strong>다운로드</strong></button> <button class=cancel_btn ng-click=modalCtrl.cancel()>닫기</button></div></div></section></div></div>");
$templateCache.put("components/modal/approval/approval-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>{{modalCtrl.title}} 의견</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>의견 내용</label><textarea class=form-control ng-model=modalCtrl.data.StatusCn style=\"resize: none; height: 80px\"></textarea></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>저장</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/branch/branch-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>지점 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\" style=\"width:50%; display:inline-block\"><label style=\"text-align: left; padding-left:14px; width:54px\">지점명</label><input type=text class=form-control ng-model=vc.srch.BranchNm style=\"margin-left: 50px\"></div><div class=form-group style=\"display: inline-block; margin-left: -45px\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>지점명</th><th>법인대표자</th><th>전화번호</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.KeyId == vc.selectedBranchId\" style=color:red></td><td><span ng-bind=li.GroupNm></span></td><td><span ng-bind=li.Ceo></span></td><td><span ng-bind=li.TelNo></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/cti/cti-call-modal.html","<div class=\"modal-content cti-wrap\"><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">Salevis Care</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope mb-20\"><div class=row ng-if=vc.data.KeyId><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"mt-30 mb-30\"><img src=../../../assets/images/cti-img.png></div><p class=cti-custname>{{vc.data.CustNm}}</p><p class=cti-sendnum>{{vc.data.SendNum}}</p></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cti-key-btnwrap\" ng-show=vc.showBtnWrap><p><button class=\"btn btn-primary btn-big_2\" ng-click=\"vc.goToPage(\'VIEW_PAGE_DETAIL\')\"><i class=\"fa fa-edit\"></i> {{\'상세정보\' | translate}} 보기</button></p><p class=mt-10><button class=\"btn btn-nostyle\" ng-click=\"vc.goToPage(\'VIEW_PAGE_COUNSEL\')\">{{\'히스토리\' | translate}}</button> <button class=\"btn btn-nostyle\" ng-click=\"vc.goToPage(\'CTI\')\">{{\'CTI\' | translate}}</button></p></div></div><div class=row ng-if=!vc.data.KeyId><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"mt-30 mb-30\"><img src=../../../assets/images/cti-img.png></div><p class=cti-custname>신규고객</p><p class=cti-sendnum>{{vc.data.SendNum}}</p></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cti-none-btnwrap\" ng-show=vc.showBtnWrap><p><button class=\"btn btn-primary btn-big_2\" ng-click=\"vc.goToPage(\'VIEW_PAGE_EDIT\')\"><i class=\"fa fa-edit\"></i> {{\'고객등록\' | translate}} 하기</button></p><p class=mt-10><button class=\"btn btn-nostyle\" ng-click=vc.setExceptYN()>고객 {{\'제외\' | translate}}하기</button></p></div></div></div><!-- //modal-body --></div>");
$templateCache.put("components/modal/contents/contents-modal.html","<div class=modal-content style=\"width: 100%; min-width: 320px; display: table; border-radius:6px\"><div class=\"modal-header ng-scope\" style=border-radius:6px><h3 class=page-header ng-if=modalCtrl.Title>{{modalCtrl.Title}}</h3><h3 class=page-header ng-if=!modalCtrl.Title>컨텐츠 미리보기</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12 ng-if=modalCtrl.VideoLink><div class=form-group><iframe style=\"display:block; width:100%; height:auto; min-height:500px\" ng-src={{modalCtrl.VideoLink}} frameborder=0 allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div class=col-lg-12><div class=form-group><div ng-bind-html=modalCtrl.Contents></div><div ng-if=\"modalCtrl.AgreeYN == \'Y\'\"><br><table cellpadding=0 cellspacing=0 width=100% style=border-style:solid;border-color:#cccccc><tbody><tr><td style=padding:5px;text-align:center>본 메일은 정보통신망 이용촉진 및 정보보호 등에 관한 법률 시행규칙에 의거 2017년 6월30일 기준으로<br>회원님의 광고메일 수신동의 여부를 확인한 결과 회원님께서 수신동의를 하셨기에 발송되었습니다.<br>수신을 원치 않으시면 전화({{modalCtrl.TelNo}})주시기 바랍니다</td></tr></tbody></table></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div>");
$templateCache.put("components/modal/excel/upload-excel-user-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>{{ \'Menu.EXCEL\' | translate }} {{ \'Menu.FILE_UPLOAD\' | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/findIdPwd/findIdPwd-modal.html","<div class=modal-content><div class=dataloader ng-show=modalCtrl.dataloader></div><div class=\"modal-header ng-scope\"><h3 class=page-header ng-if=\"modalCtrl.type == \'IU\'\">아이디 찾기</h3><h3 class=page-header ng-if=\"modalCtrl.type == \'PU\'\">비밀번호 찾기</h3></div><ul class=\"nav nav-tabs\" ng-if=!modalCtrl.success><li class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0\" ng-class=\"{\'active\': modalCtrl.findType == \'Phone\'}\"><a ng-click=\"changeFindType(\'Phone\')\" data-toggle=tab style=\"cursor: pointer; margin-right: 0\">휴대폰번호로 찾기</a></li><li class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0\" ng-class=\"{\'active\': modalCtrl.findType == \'Email\'}\"><a ng-click=\"changeFindType(\'Email\')\" data-toggle=tab style=\"cursor: pointer\">이메일로 찾기</a></li></ul><div class=\"modal-body ng-scope\" ng-if=!modalCtrl.success><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">이름</label><input type=text class=form-control ng-model=modalCtrl.UserNm maxlength=20 placeholder=이름></div></div></div><div class=row ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">아이디</label><input type=text class=form-control ng-model=modalCtrl.LoginId maxlength=20 placeholder=아이디></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Phone\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">휴대폰번호</label><input type=text class=form-control auto-hyphen ng-model=modalCtrl.Mobile maxlength=20 placeholder=휴대폰번호></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Email\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">이메일</label><input type=text class=form-control ng-model=modalCtrl.Email maxlength=50 placeholder=이메일></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding-top: 6px; padding-left: 0px\"><button class=\"btn btn-primary\" ng-click=modalCtrl.auth()>인증번호 발송</button></div></div><div class=row ng-if=\"modalCtrl.type == \'IU\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Phone\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">인증번호</label><input type=text class=form-control ng-model=modalCtrl.CertificationNum1 numbers-only maxlength=10 placeholder=인증번호 ng-disabled=\"modalCtrl.disabled1 == \'1\'\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Email\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">인증번호</label><input type=text class=form-control ng-model=modalCtrl.CertificationNum2 numbers-only maxlength=10 placeholder=인증번호 ng-disabled=\"modalCtrl.disabled2 == \'1\'\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\" style=\"padding-top: 3px\">* 인증번호 입력 후 다음을 선택해 주세요.</div></div></div><div class=row ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\" style=\"padding-top: 3px\">* 인증번호 발송 후 다음을 선택해 주세요.</div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.submit() ng-disabled=\"(modalCtrl.findType == \'Phone\' && modalCtrl.disabled1 == \'1\') || (modalCtrl.findType == \'Email\' && modalCtrl.disabled2 == \'1\')\"><i class=\"fa fa-check\"></i> 다음</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"modal-body ng-scope\" ng-if=modalCtrl.success><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'IU\'\"><label>회원님의 아이디는 {{modalCtrl.data.LoginId}} 입니다.</label></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><label>* 휴대폰 또는 이메일로 수신된 인증번호를 입력 후 비밀번호를 변경해 주세요.</label></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 인증번호</label><input type=text class=form-control ng-model=modalCtrl.data.CertificationNum numbers-only maxlength=10 placeholder=인증번호></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 비밀번호</label><input type=password class=form-control maxlength=40 ng-model=modalCtrl.data.Password maxlength=20 placeholder=\"영문, 숫자, 특수문자 포함 8~20자 조합해 입력\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 비밀번호 확인</label><input type=password class=form-control maxlength=40 ng-model=modalCtrl.data.RePassword maxlength=20 placeholder=\"비밀번호 확인\"><p class=\"desc not_pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password != modalCtrl.data.RePassword\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호를 다시 확인해 주세요.</p><p class=\"desc pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password == modalCtrl.data.RePassword && modalCtrl.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-ok\"></i> 비밀번호가 일치합니다.</p><p class=\"desc not_pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password == modalCtrl.data.RePassword && !modalCtrl.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호 형식을 확인해주세요.(영문, 숫자, 특수문자 포함 8~20자 조합해 입력)</p></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.submit2() ng-if=\"modalCtrl.type == \'PU\'\"><i class=\"fa fa-check\"></i> 확인</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div>");
$templateCache.put("components/modal/message/form-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">서식 {{ \'Menu.SEARCH\' | translate }}</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.FormNm placeholder=\"{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'FormType\'].CodeList\" code-model=modalCtrl.FormType is-disabled=false></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getFormList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegUser\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.FormList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.FormNm></span></td><td class=text-center><span ng-bind=\"li.RegDate | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center><span ng-bind=li.RegUser></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getFormList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/group-edit-modal.html","<div class=\"modal-content wd80p\"><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">대상자 추가/수정</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><form id=form1 name=form1><input type=hidden class=\"form-control form-right\" readonly><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CustNm maxlength=100></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>핸드폰</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile maxlength=255></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email maxlength=255></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/message/sms-cust-send-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자발송</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-gx-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자발송</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-item-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자발송</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-locker-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자발송</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-membership-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자발송</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">수신자그룹 추가</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getSearch()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>회원구분</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=A ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=신규><label class=custom-radio-btn title=신규><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=N ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">신규</span></label></div><div class=\"radio-inline ng-scope\" title=유효><label class=custom-radio-btn title=유효><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=C ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">유효</span></label></div><div class=\"radio-inline ng-scope\" title=만기><label class=custom-radio-btn title=만기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=E ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">만기</span></label></div><div class=\"radio-inline ng-scope\" title=락커만기><label class=custom-radio-btn title=락커만기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=L ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">락커만기</span></label></div><div class=\"radio-inline ng-scope\" title=미수금><label class=custom-radio-btn title=미수금><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=R ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">미수금</span></label></div><div class=\"radio-inline ng-scope\" title=홀딩/연기><label class=custom-radio-btn title=홀딩/연기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=H ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">홀딩/연기</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.CustCode placeholder=회원코드></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.CustNm placeholder=회원명></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.manageList code-model=modalCtrl.srch.RegManage is-disabled=false></common-code-custom><label title=접수담당자>접수담당자</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.manageList code-model=modalCtrl.srch.Manager is-disabled=false></common-code-custom><label title=진행담당자>진행담당자</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.mcl code-model=modalCtrl.srch.MCL is-disabled=false></common-code-custom><label title=수강권>수강권</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>회원권종류</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=기간제><label class=custom-radio-btn title=기간제><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=T ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">기간제</span></label></div><div class=\"radio-inline ng-scope\" title=횟수제><label class=custom-radio-btn title=횟수제><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=F ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">횟수제</span></label></div><div class=\"radio-inline ng-scope\" title=GX><label class=custom-radio-btn title=GX><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=G ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">GX</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>성별</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=남성><label class=custom-radio-btn title=남성><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=M ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">남성</span></label></div><div class=\"radio-inline ng-scope\" title=여성><label class=custom-radio-btn title=여성><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=F ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">여성</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>연령별</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=10대><label class=custom-radio-btn title=10대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=10 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">10대</span></label></div><div class=\"radio-inline ng-scope\" title=20대><label class=custom-radio-btn title=20대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=20 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">20대</span></label></div><div class=\"radio-inline ng-scope\" title=30대><label class=custom-radio-btn title=30대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=30 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">30대</span></label></div><div class=\"radio-inline ng-scope\" title=40대><label class=custom-radio-btn title=40대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=40 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">40대</span></label></div><div class=\"radio-inline ng-scope\" title=50대><label class=custom-radio-btn title=50대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=50 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">50대</span></label></div><div class=\"radio-inline ng-scope\" title=60대><label class=custom-radio-btn title=60대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=60 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">60대</span></label></div><div class=\"radio-inline ng-scope\" title=70대><label class=custom-radio-btn title=70대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=70 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">70대</span></label></div><div class=\"radio-inline ng-scope\" title=80대><label class=custom-radio-btn title=80대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=80 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">80대</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.ExpirdDate_Str = (modalCtrl.ExpirdDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.ExpirdDate_Str ng-required=false placeholder=회원권만료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.ExpirdDate_End = (modalCtrl.ExpirdDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.ExpirdDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.LockerDate_Str = (modalCtrl.LockerDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.LockerDate_Str ng-required=false placeholder=락커만료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.LockerDate_End = (modalCtrl.LockerDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.LockerDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.PayDate_Str = (modalCtrl.PayDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.PayDate_Str ng-required=false placeholder=결제일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.PayDate_End = (modalCtrl.PayDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.PayDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><!-- <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inner-label\">\r\n        <form-group class=\"form-inner-label\">\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.SignDate_Str = (modalCtrl.SignDate_Str | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.SignDate_Str\"\r\n                    ng-required=\"false\" placeholder=\"최근방문일\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </form-group>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inner-label\">\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.SignDate_End = (modalCtrl.SignDate_End | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.SignDate_End\"\r\n                    ng-required=\"false\" placeholder=\"\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.TermCount placeholder=잔여횟수></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=modalCtrl.srch.TermCountType><option value=\"\">-- 선택 --</option><option value=U>이상</option><option value=D>이하</option></select></div></div></div><!-- 고객구분 및 고객등급 미사용으로 주석처리 2020-06-24 이기훈\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'SalesType\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.SalesType\"></common-code-custom>\r\n          <label>고객구분</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'CustGrade\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.CustGrade\"></common-code-custom>\r\n          <label>고객등급</label>\r\n        </div>\r\n      </div>\r\n    </div>--><!-- //row --><!-- <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>생년월일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.BirthDayFrom = (modalCtrl.BirthDayFrom | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.BirthDayFrom\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label style=\"text-align:center;\">~</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.BirthDayTo = (modalCtrl.BirthDayTo | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.BirthDayTo\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'Gender\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.Gender\"></common-code-custom>\r\n          <label>성별</label>\r\n        </div>\r\n      </div>\r\n      \r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'AgeRange\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.AgeRange\"></common-code-custom>\r\n          <label>연령대</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>등록시작일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.CustRegDtFrom = (modalCtrl.CustRegDtFrom | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.CustRegDtFrom\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>등록종료일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.CustRegDtTo = (modalCtrl.CustRegDtTo | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.CustRegDtTo\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group pull-right\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{modalCtrl.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists \"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div><!-- /row --><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'\')\"><i class=\"fa fa-check\"></i> 선택회원추가</button> <button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'ALL\')\"><i class=\"fa fa-check\"></i> 전체회원추가(조회조건)</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal2.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">발송 대상자 편집</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"row pb-5\"><div class=\"col-lg-12 text-right\"><button class=\"btn btn-primary\" activate-button ng-click=modalCtrl.GroupCustEditModal()><i class=\"fa fa-user\"></i> 개별 입력 추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'\')\"><i class=\"fa fa-trash-o\"></i> 선택 제외</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'ALL\')\"><i class=\"fa fa-trash-o\"></i> 전체 제외</button></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 3%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" ng-repeat=\"liCol in modalCtrl.grpcustListColumns\">{{liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{modalCtrl.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"(liIndex, li) in modalCtrl.viewList\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center ng-repeat=\"liCol in modalCtrl.grpcustListColumns\" ng-click=\"modalCtrl.GroupCustEditModal(liIndex, li.SvyTgtId)\">{{li[liCol.ColumnPhysicalNm]}}</td></tr></table></div></div><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>확인</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal3.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">발송 대상자 조회</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=modalCtrl.srch.CustNm placeholder=\"회원명 검색\" type=text><div class=\"search_layer mb-5\" ng-click=modalCtrl.getList() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open></span><i class=\"fa fa-search\"></i></div><span class=search-condition-str ng-bind-html=modalCtrl.SearchConditionStr></span></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{modalCtrl.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in modalCtrl.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in modalCtrl.listColumns\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table></div></div><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/tree-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">수신자 {{ \'Menu.SEARCH\' | translate }}<div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><md-sidenav md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">수신자그룹 목록</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div></div>");
$templateCache.put("components/modal/kakaomap/kakaomap-config-modal.html","<div class=wrapper><div class=content style=\"padding-bottom: 0\"><!-- container --><section class=\"joinStepWrap mtb30\"><!-- section.joinStepWrap --><div class=content style=\"width: 100%\"><h2>지도</h2></div><!-- // section.joinStepWrap--></section><section class=inputInfoWrap><!-- section.inputInfoWrap --><div class=content><!-- 로그인 정보 --><div class=row><div class=col-lg-12><div id=map_canvas style=\"width: 100%; height: 500px\"></div></div></div><div class=\"buttonWrap mtb30\"><button class=primary_btn ng-click=modalCtrl.ok()>닫기</button></div></div></section></div></div>");
$templateCache.put("components/modal/metadata/metadata-config-modal.html","<div class=wrapper><div class=content style=\"padding-bottom: 0\"><!-- container --><section class=\"joinStepWrap mtb30\"><!-- section.joinStepWrap --><div class=content style=\"width: 100%\"><h2>화면설정</h2></div><!-- // section.joinStepWrap--></section><section class=inputInfoWrap><!-- section.inputInfoWrap --><div class=content><!-- 로그인 정보 --><div class=row><div class=col-lg-12><div class=\"form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6\" ng-init=\"modalCtrl.viewType = \'D\'\"><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=modalCtrl.viewType value=L ng-click=\"modalCtrl.viewType = \'L\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 리스트</label><label class=\"radio-inline ng-binding ng-scope\"><input type=radio name=viewType ng-model=modalCtrl.viewType value=D ng-click=\"modalCtrl.viewType = \'D\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false style=margin-top:2px> 상세</label></div></div></div><metatable-sortable init-callback=modalCtrl.succSortable bind-data=modalCtrl.datas link-data=modalCtrl.linkData max-depth=3 view-type=modalCtrl.viewType check-section=vc.checkColumnSection check-edit-col-size=modalCtrl.checkEditColumnRowCount mode=\"\'U\'\"></metatable-sortable><div class=\"buttonWrap mtb30\"><button class=cancel_btn ng-click=modalCtrl.cancel()>취소</button> <button class=primary_btn ng-click=modalCtrl.delMetaTable()><strong>기본설정</strong></button> <button class=primary_btn ng-click=modalCtrl.modMetaTable()><strong>저장</strong></button></div></div></section></div></div>");
$templateCache.put("components/modal/pay/pay-chg-adm-list.html","<!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"PayChgAdmListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row id=searchWrap></div><!--버튼영역--><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.payChgAdmAddModal()><i class=\"fa fa-save\"></i> 추가</button></div></div></div></form><!-- page content --><autoview-list-table alias=vc list-data=lists></autoview-list-table><!-- /page content --></div>");
$templateCache.put("components/modal/pay/pay-chg-adm-write.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">관리자결제추가</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\"><label>회원사</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN != \'Y\'\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></div></div></div><!-- 변경항목 --><div id=sec1></div><!-- 만료일변경 --><div id=sec2></div><!-- SMS충전/차감 --><div id=sec3></div><!-- 충전금액 --><div id=sec4></div></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("components/modal/pay/pay-hist-detail.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">결제내역</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><!-- 기본정보 --><div id=sec1></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">세부정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><!-- page content --><autoview-list-table alias=vc list-data=lists cust-column-map=vc.custMapCode></autoview-list-table><!-- /page content --></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.getWinPop(vc.data.receipt_url) ng-show=vc.SalesSlipShow><i class=\"fa fa-edit\"></i> 매출전표확인</button><!--\r\n        <button class=\"btn btn-primary mb-10\" ng-click=\"vc.setTaxInv()\" ng-show=\"vc.TaxInvShow\">\r\n          <i class=\"fa fa-edit\"></i> 전자세금계산서발행\r\n        </button>\r\n        --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("components/modal/pay/pay-hist-list.html","<!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"PayHistListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row id=searchWrap></div><!--버튼영역--><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch() ng-if=\"vc.SysAdminYN ==\'Y\'\"><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button></div></div></div></form><!-- page content --><autoview-list-table alias=vc list-data=lists></autoview-list-table><!-- /page content --></div>");
$templateCache.put("components/modal/pay/pay-modal.html","<style>/*\r\n  .ctrl-paymodalctrl-wrap > .modal-dialog {\r\n    opacity: 0;\r\n  }\r\n  */\r\n\r\n  .ctrl-paymodalctrl-wrap > .modal-dialog > .modal-content {\r\n    min-height: 764px;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\"></div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><ul class=\"nav nav-tabs\"><li ng-class=\"vc.tabIndex == 0 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(0,\'VIEW_PAGE_PAYWIRTE\');\" data-toggle=tab>결제신청</a></li><li ng-class=\"vc.tabIndex == 1 ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(1,\'VIEW_PAGE_PAYHIST\');\" data-toggle=tab>결제내역</a></li><li ng-class=\"vc.tabIndex == 2 ? \'active\' : \'\'\" ng-if=\"vc.SysAdminYN == \'Y\' && vc.ExpOverCode != \'OVER\'\"><a ng-click=\"vc.setChangeTab(2,\'VIEW_PAGE_PAYREQ\');\" data-toggle=tab>결제요청관리</a></li><li ng-class=\"vc.tabIndex == 3 ? \'active\' : \'\'\" ng-if=\"vc.SysAdminYN == \'Y\' && vc.ExpOverCode != \'OVER\'\"><a ng-click=\"vc.setChangeTab(3,\'VIEW_PAGE_PAYCHGADM\');\" data-toggle=tab>관리자결제변경</a></li></ul><div ng-include=vc.pages></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/pay/pay-req-list.html","<!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"PayReqListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row id=searchWrap></div><!--버튼영역--><div class=\"row mb-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button activate-button class=\"btn btn-info\" ng-click=vc.setDelList()><i class=\"glyphicon glyphicon-remove\"></i> 선택삭제</button> <button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"vc.payReqAddModal(\'\')\"><i class=\"fa fa-save\"></i> 추가</button></div></div></div></form><!-- page content --><autoview-list-table alias=vc list-data=lists list-options=vc.listOptions></autoview-list-table><!-- /page content --></div>");
$templateCache.put("components/modal/pay/pay-req-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>결제요청 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>결제내용</label><input type=text class=form-control ng-model=vc.srch.Title placeholder=결제내용></div></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2\" style=\"text-align: right\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=30px><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th class=text-center style=vertical-align:middle><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th>결제내용</th><th>요청금액(원)</th><th>요청일</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td><span ng-bind=li.Title></span></td><td><span ng-bind=li.ReqAmt></span></td><td><span ng-bind=\"li.ReqDate | autoViewUtcToLocal:\'YYYY-MM-DD\'\"></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/pay/pay-req-write.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">결제요청</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=row><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\" ng-if=\"vc.data.PayYN != \'Y\'\"><label>회원사</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"form-group form-inline\" ng-if=\"vc.data.PayYN == \'Y\'\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></div></div></div><!-- 요청금액/요청일 --><div id=sec1></div><!-- 결제내용 --><div id=sec2></div></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=\"vc.data.PayYN != \'Y\'\"><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("components/modal/pay/pay-write.html","<!-- Html Editor --><div class=\"page page-footable shop-detail-view shop-view\" ng-controller=\"PayWriteCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=\"row tab_margin pop-pay\"><div class=\"col-sm-4 pay-info\"><div class=first><div class=row><div class=col-xs-5><img src=/assets/images/pay/img_pay3.png></div><div class=col-xs-7><h1>이용 만료일</h1><p class=p-mon><span ng-bind=vc.InfoPayMonEnd1></span></p><p><span ng-bind=vc.InfoPayMonEnd2></span></p></div></div></div><div><div class=row><div class=col-xs-5><img src=/assets/images/pay/img_pay1.png></div><div class=col-xs-7><h1>부가서비스 잔액</h1><p class=p-sms><span ng-bind=vc.InfoPaySmsRemAmt1></span></p><p><span ng-bind=vc.InfoPaySmsRemAmt2></span></p></div></div></div><div><div class=row><div class=col-xs-5><img src=/assets/images/pay/img_pay2.png></div><div class=col-xs-7 style=padding-top:12px><h1>사용자 수</h1><p class=p-per><span ng-bind=vc.InfoPayUserCnt></span></p><p></p></div></div></div></div><div class=col-sm-8><div class=row><div class=col-sm-6><div class=\"panel panel-default pnl-mon\"><div class=panel-heading>기간연장<div class=pull-right><!--\r\n                <a data-toggle=\"collapse\" href=\"#collapse1\"><i class=\"fa fa-minus fa-lg\"></i></a>\r\n                --></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=col-sm-6><div class=form-group><label>만료일</label><div class=txt_view><span ng-bind=vc.PayMonEnd></span></div></div></div><div class=col-sm-6><div class=form-group><label>월결제금액(원)</label><div class=txt_view><span ng-bind=vc.MonAmt></span></div></div></div></div><div class=row><div class=col-sm-12><div class=form-group><label>연장개월</label><select ng-model=vc.PayMon class=form-control ng-options=\"li.Code as li.CodeValue for li in vc.codePayMonList\" ng-disabled=!vc.PayMonEnabled><!--<option value=\"\">--선택--</option>--></select></div></div></div><div class=\"row pnl-btn\"><div class=\"col-sm-12 text-right\"><button class=\"btn btn-default\" ng-click=\"vc.setPayAdd(\'mon\');\" ng-disabled=!vc.PayMonEnabled><i class=\"fa fa-plus\"></i> 결제추가</button></div></div></div></div></div><div class=col-sm-6><div class=\"panel panel-default pnl-req\"><div class=panel-heading>결제요청<div class=pull-right><!--\r\n                <a data-toggle=\"collapse\" href=\"#collapse3\"><i class=\"fa fa-minus fa-lg\"></i></a>\r\n                --></div></div><div class=\"panel-body collapse in\" id=collapse3><div class=row><div class=col-sm-6><div class=form-group><label>결제요청건</label><div class=txt_view><span ng-bind=vc.PayReqCnt></span></div></div></div><div class=col-sm-6><div class=form-group><label>선택건</label><div class=txt_view><span ng-bind=vc.ChkPayReqCnt></span></div></div></div></div><div class=row><div class=col-sm-12><div class=form-group><label>총결제요청금액(원)</label><div class=txt_view><span ng-bind=vc.PayReqAmt></span></div></div></div></div><div class=\"row pnl-btn\"><div class=\"col-sm-12 text-right\"><button class=\"btn btn-default\" ng-click=vc.payReqModal(); ng-disabled=!vc.PayReqEnabled><i class=\"glyphicon glyphicon-search\"></i> 결제요청선택</button> <button class=\"btn btn-default\" ng-click=\"vc.setPayAdd(\'req\');\" ng-disabled=!vc.PayReqEnabled><i class=\"fa fa-plus\"></i> 결제추가</button></div></div></div></div></div></div><div class=row><div class=col-sm-6><div class=\"panel panel-default pnl-sms\"><div class=panel-heading>부가서비스충전<div class=pull-right><!--\r\n                <a data-toggle=\"collapse\" href=\"#collapse2\"><i class=\"fa fa-minus fa-lg\"></i></a>\r\n                --></div></div><div class=\"panel-body collapse in\" id=collapse2 style=\"padding:25px 12px 25px 12px\"><div class=row><div class=col-sm-12><div class=form-group><label>부가서비스잔액(원)</label><div class=txt_view><span ng-bind=vc.PayServPoint></span></div></div></div></div><div class=row><div class=col-sm-12><div class=form-group><label>충전금액(원)</label><input type=text class=\"form-control form-right\" ng-model=vc.PaySmsAmt maxlength=10 value=0 numbers-only comma ng-blur=vc.chgPaySmsAmt()></div></div></div><div class=\"row pnl-btn\"><div class=\"col-sm-12 text-right\"><button class=\"btn btn-default\" ng-click=\"vc.setPayAdd(\'sms\');\"><i class=\"fa fa-plus\"></i> 결제추가</button></div></div></div></div></div><div class=col-sm-6><div class=\"panel panel-default pnl-pay\"><div class=panel-heading>결제정보<div class=pull-right><!--\r\n                <a data-toggle=\"collapse\" href=\"#collapse4\"><i class=\"fa fa-minus fa-lg\"></i></a>\r\n                --></div></div><div class=\"panel-body collapse in\" id=collapse4><div class=row><div class=col-sm-12><p ng-show=vc.TotPayMsgShow>결제를 추가해주세요.</p><p ng-show=vc.TotPayJoinAmtShow>가입비: <span ng-bind=vc.TotPayJoinAmt>0</span>원</p><p ng-show=vc.TotPayMonAmtShow>기간연장: <span ng-bind=vc.PayMonAmt>0</span>원 x <span ng-bind=vc.PayMonCnt>0</span>개월 = <span ng-bind=vc.TotPayMonAmt>0</span>원 <span ng-bind=vc.TotPayMonDC></span> <img src=/assets/images/pay/btn_close.png title=삭제 class=imgbtn-del ng-click=\"vc.setPayDel(\'mon\');\"></p><p ng-show=vc.TotPaySmsAmtShow>부가서비스충전: <span ng-bind=vc.TotPaySmsAmt>0</span>원 <img src=/assets/images/pay/btn_close.png title=삭제 class=imgbtn-del ng-click=\"vc.setPayDel(\'sms\');\"></p><p ng-show=vc.TotPayReqAmtShow>결제요청: <span ng-bind=vc.TotPayReqAmt>0</span>원 <img src=/assets/images/pay/btn_close.png title=삭제 class=imgbtn-del ng-click=\"vc.setPayDel(\'req\');\"></p><hr><p>총 결제금액 (VAT포함): <span ng-bind=vc.TotPayAmt>0</span>원</p></div></div><div class=row><div class=col-sm-12><div class=\"input-group custom-search-form\"><select ng-model=vc.PayMethod class=form-control ng-options=\"li.Code as li.CodeValue for li in vc.codePayMethodList\"><!--<option value=\"\">--선택--</option>--></select><span class=input-group-btn><button class=\"btn btn-primary\" ng-click=vc.setPay();><i class=\"glyphicon glyphicon-ok\"></i> 결제</button></span></div></div></div></div></div></div></div></div></div><div class=\"row btm_margin\"><div class=col-sm-3><div class=text-left><strong>{{vc.sessionTenantName}} </strong>{{vc.sessionUserName}}</div></div><div class=\"col-sm-9 text-right\"><span style=\"font-size:12px; color:#999\">이미 결제된 월사용료에 대해서는 인원 추가/감소에 따른 금액을 소급하지 않습니다.</span></div></div><!-- /page content --></div>");
$templateCache.put("components/modal/mypage/mypage-modal.html","<div class=modal-header><h3 class=\"modal-title custom-font\">내정보 수정</h3></div><div class=modal-body><div class=tile><span ng-if=doing_async>...loading...</span><div class=row><div class=col-lg-6><div class=form-group><label>사용자명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.UserNm></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label>휴대전화</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.Mobile></div></div><div class=col-lg-6><div class=form-group><label>이메일</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.Email></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label>현재 비밀번호</label><input type=password class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.UserPassword></div></div></div><div class=row><div class=col-lg-6><div class=form-group><label>새로운 비밀번호</label><input type=password class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.Password></div></div><div class=col-lg-6><div class=form-group><label>새로운 비밀번호확인</label><input type=password class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.Password2></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.checkUserPw()><i class=\"fa fa-check\"></i> 수정</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div>");
$templateCache.put("components/modal/tenant/tenant-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>회원사 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>회원사명</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>법인대표자</label><input type=text class=form-control ng-model=vc.srch.Ceo placeholder=법인대표자></div></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2\" style=\"text-align: right\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>회원사명</th><th>지역구분</th><th>법인대표자</th><th>전화번호</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Addr1></span></td><td><span ng-bind=li.Ceo></span></td><td><span ng-bind=li.TelNo></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/tenant/tenant2-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>{{ \'Menu.MEMBERCOMPANY\' | translate }}{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/userExcelUpload/userExcelUpload-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">사용자 등록 엑셀 업로드</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-6 ng-click=vc.sampleDownload()><a href=assets/excel/userExcel_sample.xlsx>※ 엑셀 업로드 샘플 다운로드</a></div></div><div class=\"row mt-15\"><div class=col-lg-6><input type=file id=excelFile style=\"width: 100%; border: solid 1px #CCC\"></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-6\" ng-bind=modalCtrl.msg></div></div><!-- //row --></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.excelExport()><i class=\"fa fa-check\"></i>엑셀 업로드</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/users/user-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">담당자 {{ \'Menu.SEARCH\' | translate }}</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.LoginId placeholder=\"{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'WorkStatus\'].CodeList\" code-model=modalCtrl.WorkStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'EntryDt\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</th><!-- <th data-toggle=\"true\" class=\"text-center\" ng-if=\"!modalCtrl.MobileYn\">{{modalCtrl.columnMap[\'UserGrade\'].ColumnLogicalNm | translate }}</th> --></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=\"li.EntryDt | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=li.WorkStyle></span></td><td class=text-center><span ng-bind=li.WorkStatus></span></td><!-- <td class=\"text-center\" ng-if=\"!modalCtrl.MobileYn\"><span ng-bind=\"li.UserGrade\" ></span></td> --></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/userRole/userrole-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>{{\'Menu.ROLE\' | translate}} {{\'Menu.SEARCH\' | translate}}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=vc.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in vc.searchFieldTypeList\" ng-init=vc.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=vc.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSizePerPage ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><md-contact-chips ng-model=vc.UserRoles md-contacts=vc.querySearch($query) md-contact-name=RoleNm md-contact-image=image md-contact-email=email md-require-match=true md-highlight-flags=i filter-selected=vc.filterSelected md-on-remove=vc.onRemoveChip($item) placeholder=역할></md-contact-chips><md-list class=fixedRows><md-subheader class=md-no-sticky>**추가할 역할을 선택하세요**</md-subheader><md-list-item class=contact-item ng-repeat=\"(index, role) in vc.data.list\" ng-if=!vc.IsRole(role) ng-click=vc.addRole(role.RoleId)><div class=\"md-list-item-text compact\" draggable=true>{{role.RoleNm}}</div></md-list-item></md-list></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/ui-component/factory/galert-factory.html","<md-dialog md-theme=default ng-class=dialog.css class=\"md-default-theme md-transition-in\" role=alertdialog tabindex=-1 aria-describedby=dialogContent_8 style=\"min-width: 300px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_8 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple md-autofocus\" type=button ng-click=onClose() md-autofocus=true aria-label=\"Got it!\" style=\"margin: 0 auto; width:100%\"><span ng-bind=closeBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gchoice-factory.html","<style>md-radio-button {\r\n    margin-bottom: 5px !important;\r\n  }</style><md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 300px\"><md-dialog-content role=document tabindex=-1 id=dialogContent_9><div class=modal-header><div class=page-header style=\"text-align: left\">Salevis Care</div></div><div class=\"md-dialog-content-body ng-scope\"><p class=\"ng-binding modal-content--text\" ng-bind-html=alertMessage></p></div><div class=modal-content--item><md-radio-group ng-model=option class=modal-content--><md-radio-button ng-repeat=\"item in items\" ng-value=item.value aria-label={{item.label}} class=text-left><label>{{ item.label }}</label></md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions class=\"modal-footer modal-footer-custom\"><button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true><span class=\"ng-binding ng-scope ok_btn\" ng-bind=okBtn style=color:#{{alertColor}}></span></button> <button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose()><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=color:#333></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gconfirm-factory.html","<md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 300px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=okBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button> <button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose() style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=\"color:#333; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gselect-factory.html","<style>md-radio-button {\r\n    margin-bottom: 5px !important;\r\n  }</style><md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 300px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left; margin-top:25px; margin-bottom: 10px\"><p class=ng-binding ng-bind-html=alertMessage></p></div><md-radio-group ng-model=mode><md-radio-button ng-repeat=\"item in items\" ng-value=item.value aria-label={{item.label}} class=text-left><label>{{ item.label }}</label></md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=okBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button> <button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose() style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=\"color:#333; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/timeline/timeline.html","<div class=panel-body><ul class=timeline><li><div class=timeline-badge><i class=\"fa fa-check\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4><p><small class=text-muted><i class=\"fa fa-clock-o\"></i> 11 hours ago via Twitter</small></p></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge warning\"><i class=\"fa fa-credit-card\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem dolorem quibusdam, tenetur commodi provident cumque magni voluptatem libero, quis rerum. Fugiat esse debitis optio, tempore. Animi officiis alias, officia repellendus.</p><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium maiores odit qui est tempora eos, nostrum provident explicabo dignissimos debitis vel! Adipisci eius voluptates, ad aut recusandae minus eaque facere.</p></div></div></li><li><div class=\"timeline-badge danger\"><i class=\"fa fa-bomb\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellendus numquam facilis enim eaque, tenetur nam id qui vel velit similique nihil iure molestias aliquam, voluptatem totam quaerat, magni commodi quisquam.</p></div></div></li><li class=timeline-inverted><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates est quaerat asperiores sapiente, eligendi, nihil. Itaque quos, alias sapiente rerum quas odit! Aperiam officiis quidem delectus libero, omnis ut debitis!</p></div></div></li><li><div class=\"timeline-badge info\"><i class=\"fa fa-save\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nobis minus modi quam ipsum alias at est molestiae excepturi delectus nesciunt, quibusdam debitis amet, beatae consequuntur impedit nulla qui! Laborum, atque.</p><hr><div class=btn-group><button type=button class=\"btn btn-primary btn-sm dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-gear\"></i> <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li class=divider></li><li><a href=#>Separated link</a></li></ul></div></div></div></li><li><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi fuga odio quibusdam. Iure expedita, incidunt unde quis nam! Quod, quisquam. Officia quam qui adipisci quas consequuntur nostrum sequi. Consequuntur, commodi.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge success\"><i class=\"fa fa-graduation-cap\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt obcaecati, quaerat tempore officia voluptas debitis consectetur culpa amet, accusamus dolorum fugiat, animi dicta aperiam, enim incidunt quisquam maxime neque eaque.</p></div></div></li></ul></div>");
$templateCache.put("app/business/modal/business-dr/business-dr-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">영업일지 등록</div><div class=pull-right><button class=\"btn btn-default btn-close\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=\"col-lg-8 pd00\"><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=row></div><div id=sec2 class=row></div><div class=item-wrap ng-repeat=\"item in vc.data.CustList\">고객: {{item.CustNm}} <span ng-click=vc.delCust(item)>×</span></div><div class=item-wrap ng-repeat=\"item in vc.data.CompanionList\">동행자: {{item.CompanionNm}} <span ng-click=vc.delCompanion(item)>×</span></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">영업일지</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec3 class=row><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 requiredTime-col-wrap pull-right\"><div class=\"form-group form-inline\"><label uib-tooltip=소요시간>소요시간</label><div class=timer><timetaken-picker id=id_time name=time step-time={{vc.data.settingMin}} class=form-field label=\"Enter time:\" ng-model=vc.requireTime callback=vc.requireTimeChanged required></timetaken-picker></div></div></div></div><div id=sec4 class=row></div><div id=sec5 class=row></div><div id=sec6 class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 RemindRadio-col-wrap form-layout-inline wrap-col-size-3 type-date-col-wrap pull-right\"><div class=\"form-group form-inline\"><label uib-tooltip=\"리마인드 알림설정\">리마인드 알림설정</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio id=one name=selector ng-model=vc.data.RemindUseYN value=N> <span class=helping-el></span> <span class=\"label-text ng-binding\">설정안함</span></label></div><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio id=two name=selector ng-model=vc.data.RemindUseYN value=Y> <span class=helping-el></span> <span class=\"label-text ng-binding\">맞춤설정</span></label></div><div class=\"radio-inline ng-scope\"><span ng-if=\"vc.data.RemindUseYN == \'Y\'\"><button class=\"btn btn-default\" ng-click=vc.addRemindAlarm()>+</button></span></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 pull-right\"><!-- <div class=\"item-wrap\" ng-repeat=\"item in vc.remindAlarmList\" ng-style=\"{\'background\':item.DoneYn==\'Y\'?\'#7f8fa4\':\'#34495e\'}\"> --><div class=remind_item-wrap><ul><li ng-class=\"item.DoneYn==\'Y\' ? \'\' : \'focus\'\" ng-repeat=\"item in vc.data.RemindAlarmList track by $index\"><span class=remind_title ng-click=vc.editItem(item) ng-bind-html=item.RemindNm></span> <span ng-click=vc.deleteItem(item)>×</span></li></ul></div></div></div><div id=sec7 class=row></div><div id=sec8 class=row></div><!-- 첨부파일 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label uib-tooltip=첨부>첨부</label><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer\" style=\"width: 100% !important\"><colgroup><col style=\"width: auto\"><col style=\"width: 70px\"><col style=\"width: 80px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><div id=vault class=vault-block></div></form></div></div></div><!-- 첨부파일 --></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.goBusinessORDetail()>사업기회 수정</button> <button class=\"btn btn-default mb-10\" ng-click=vc.copyBusinessDRDetail() ng-if=vc.data.KeyId><i class=\"fa fa-copy\"></i> 복사</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.uploadFile()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button><!-- <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.cancel()\">\r\n          <i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}\r\n        </button> --></div></div><div class=\"col-lg-4 pd00\"><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">영업일지이력</strong><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.showBusinessDRDetail()><i class=\"fa fa-edit\"></i>선택수정</button></div></div><div class=\"panel-body collapse in bus_log_wrap\"><div class=modal-memo><div class=memo-item ng-repeat=\"item in vc.businessDRLists\" ng-class=\"item.KeyId == vc.data.KeyId ? \'memo-item-present\' : \'\'\"><div class=item-header><input type=checkbox id=chkDR_{{item.KeyId}} ng-click=vc.chgChkBox(item.KeyId) style=\"margin: -2px 0 0\" ng-disabled=\"item.KeyId == vc.data.KeyId\"> <span class=item_regUser>{{item.DRTypeNm}} / {{item.DRStatusNm}}</span> <span class=item_status>{{item.ApprovalStatusNm}}</span></div><div class=item-body><p class=mb-10><strong>{{item.DRTitle}}</strong></p><span>{{item.DRContents}}</span></div><div class=item-footer><span class=item_regDate>{{item.RegUserNm}} / {{item.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/business/modal/business-meeting-view/business-meeting-view-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.MeetViewHeader}}</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div id=sec1 class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default mb-10\" ng-click=\"vc.changeProgress(\'N\')\" ng-if=\"vc.data.KeyId && vc.data.ProgressYN == \'Y\'\"><i class=\"fa fa-edit\"></i> 진행전으로 수정</button> <button class=\"btn btn-default mb-10\" ng-click=\"vc.changeProgress(\'Y\')\" ng-if=\"vc.data.KeyId && vc.data.ProgressYN == \'N\'\"><i class=\"fa fa-edit\"></i> 진행완료</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=\"!vc.data.KeyId || (vc.data.KeyId && vc.data.ProgressYN == \'N\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button></div></div></div><div class=\"row mgt20\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile bus_meet_log\"><div class=\"panel-body collapse in modal-memo\"><div class=memo-item ng-repeat=\"item in vc.businessDRViewLists\"><div class=item-header><span class=item_regUser><strong>{{item.DRTitle}}</strong></span> <span class=item_status>순서&nbsp; <span ng-if=\"vc.data.KeyId && vc.data.ProgressYN == \'Y\'\">{{item.Sort}}</span><select id=select_sort_{{item.Idx}} ng-model=item.Sort ng-change=\"vc.changeSort(item.Idx, item.Sort)\" ng-options=\"c for c in vc.listSort\" ng-if=\"vc.data.ProgressYN != \'Y\'\" class=input-sm></select><button class=\"btn btn-danger ng-binding ml-10\" ng-click=vc.delData(item.Idx) ng-if=\"vc.data.ProgressYN != \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{\'Menu.DELETE\' | translate }}</button></span></div><div class=item-body><!-- {{item.DRContents}} --><table><colgroup><col style=\"width: 20%\"><col style=\"width: 80%\"></colgroup><tr><th>영업담당자/동행직원</th><td>{{item.ManagerNm}} / {{item.CompanionNms}}</td></tr><tr><th>업무일시</th><td>{{item.BusinessDate}}</td></tr><tr><th>고객사/고객</th><td ng-if=!item.MeetViewDetId><span ng-bind=item.ClientNm></span> / <span ng-bind=item.CustNms></span></td><td ng-if=item.MeetViewDetId><span ng-click=vc.goClientDetail(item.ClientId) style=\"cursor: pointer\" ng-bind=item.ClientNm></span> / <span ng-click=vc.goCustDetail(li.CustId) style=\"cursor: pointer\" ng-repeat=\"li in item.CustList\">{{li.CustNm}}<span ng-if=\"li.Idx != item.CustList.length\">,</span></span></td></tr><tr><th>사업기회/활동유형</th><td ng-if=!item.MeetViewDetId><span ng-bind=item.BusinessOPNm></span> / <span ng-bind=item.DRTypeNm></span></td><td ng-if=item.MeetViewDetId><span ng-click=vc.goBusinessOPDetail(item.BusinessOPId) style=\"cursor: pointer\" ng-bind=item.BusinessOPNm></span> / {{item.DRTypeNm}}</td></tr><tr><th>활동내용/기업동향</th><td><div><b>활동내용</b><br><span ng-bind-html=item.DRContents></span></div><div ng-if=item.BusinessTrend><b>기업동향</b><br><span ng-bind-html=item.BusinessTrend></span></div></td></tr></table></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/business/modal/business-op/business-op-check-client-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\"></div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=op-check-client-modal><span>선택하신 고객사에 등록된 사업기회를 먼저 확인해보세요.</span><br><span>총 {{vc.totalItems}}개의 사업기회가 있습니다.</span></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th class=text-center>사업기회명</th><th class=text-center>고객사</th><th class=text-center>고객</th><th class=text-center>진행단계</th><th class=text-center>사업</th><th class=text-center>비용</th><th class=text-center>등록일</th><th class=text-center>영업담당자</th><th class=text-center>부서명</th></tr></thead><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=10>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tr ng-repeat=\"li in vc.lists\"><td class=text-center style=vertical-align:middle><input type=checkbox id=chk_{{li.KeyId}} name=chkbox value={{li.KeyId}} ng-click=vc.chgChkBox(li.KeyId)></td><td class=text-center><span ng-bind=li.BusinessOPNm></span></td><td class=text-center><span ng-bind=li.ClientNm></span></td><td class=text-center><span ng-bind=\"\"></span></td><td class=text-center><span ng-bind=li.ProgressStep></span></td><td class=text-center><span ng-bind=\"\"></span></td><td class=text-center><span ng-bind=\"\"></span></td><td class=text-center><span ng-bind=li.RegDate></span></td><td class=text-center><span ng-bind=\"\"></span></td><td class=text-center><span ng-bind=\"\"></span></td></tr></table></div></div></div><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><span>중복되지 않습니다.</span></button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.goData()><span>선택 사업기회 이동</span></button></div></div>");
$templateCache.put("app/business/modal/business-op/business-op-modal.html","<style>/* 자동완성 리스트 */\r\n  .auto-complete-list ul {\r\n    list-style: none;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    display: inline-block;\r\n  }\r\n  .auto-complete-list li {\r\n    display: inline-block;\r\n    background: #555;\r\n    color: white;\r\n    padding: 3px 5px 3px 10px;\r\n    border-radius: 15px;\r\n    margin-right: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .auto-complete-list a {\r\n    color: white;\r\n    text-decoration: none;\r\n    margin-left: 5px;\r\n    font-size: 10px;\r\n    background: #555;\r\n    width: 15px;\r\n    height: 15px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n    text-align: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .auto-complete-list a:hover {\r\n    color: white;\r\n  }\r\n  /* 자동완성 고객 */</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">사업기회 등록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.CustList.length > 0\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=auto-complete-list><ul><li ng-repeat=\"item in vc.data.CustList\"><span>{{item.CustNm}}</span><a ng-click=vc.delCust(item)>X</a></li></ul></div></div></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.ManagerList.length > 0\"><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"></div><div class=\"col-xxs-12 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=auto-complete-list><ul><li ng-repeat=\"item in vc.data.ManagerList\"><span>{{item.ManagerNm}}</span><a ng-click=vc.delManager(item)>X</a></li></ul></div></div></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 RemindRadio-col-wrap form-layout-inline wrap-col-size-3 type-date-col-wrap pull-right\"><div class=\"form-group form-inline\"><label uib-tooltip=\"리마인드 알림설정\">리마인드 알림설정</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio name=selector ng-model=vc.data.RemindAlarm value=N> <span class=helping-el></span> <span class=\"label-text ng-binding\">설정안함</span></label></div><div class=\"radio-inline ng-scope\"><label class=custom-radio-btn><input type=radio name=selector ng-model=vc.data.RemindAlarm value=Y> <span class=helping-el></span> <span class=\"label-text ng-binding\">맞춤설정</span></label></div><div class=\"radio-inline ng-scope\"><span ng-if=\"vc.data.RemindAlarm == \'Y\'\"><button class=\"btn btn-default\" ng-click=vc.addRemindAlarm()>+</button></span></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8\"></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=remind_item-wrap><ul><li ng-class=\"item.DoneYn==\'Y\' ? \'\' : \'focus\'\" ng-repeat=\"item in vc.data.RemindAlarmList track by $index\"><span class=remind_title ng-click=vc.editItem(item) ng-bind-html=item.RemindNm></span> <span ng-click=vc.deleteItem(item)>×</span></li></ul></div></div></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">사업정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><table class=BusinessProduct id=BusinessProductTable><colgroup><col style=\"width: 20%\"><col style=\"width: 50%\"><col style=\"width: 20%\"><col style=\"width: 10%\"></colgroup><thead><tr><th>사업</th><th>기간</th><th>예상매출</th><th></th></tr></thead><tbody ng-repeat=\"data in vc.BusinessProductList track by $index\"><tr><td><sz-auto-complete code-list=vc.codeBusinessList code-model=data.BusinessNm code-key=data.BusinessId callback=vc.setBusinessCode change-callback=vc.onChangeBusinessNm is-focus=vc.act_BusinessNmFocus init-value=data.BusinessNm class=ng-isolate-scope index=$index><div class=auto-complet-wrap><input ng-focus=avc.focusInput($event) ng-change=avc.setChangeValue() ng-model=avc.inputValue ng-keydown=avc.onKeydownEvent($event) ng-disabled=avc.isDisabled type=text ng-blur=avc.focusoutInput($event) class=\"ng-pristine ng-valid ng-not-empty ng-touched ManagerNameInput\" autocomplete=off aria-invalid=false></div></sz-auto-complete></td><td><div class=col-lg-6><date-input date=data.BusinessStartDate></date-input></div><div class=col-lg-6><date-input date=data.BusinessEndDate></date-input></div></td><td><input type=text class=form-control ng-model=data.BusinessExSales ng-change=vc.setTotalSales() maxlength=12 comma numbers-only></td><td style=\"text-align: center !important\"><button class=\"btn btn-delete btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.delRow(data, $index)\">X</button></td></tr></tbody></table><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.addRow()>+</button><br><span style=\"font-weight: bold\">합계</span><input type=text class=pull-right style=\"font-weight: bold\" ng-model=vc.totalSales comma numbers-only></div><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec8 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/business/modal/business-op/chg-contract-type-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>계약구분 변경 <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a pull-right\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=chg-contract-type><span>실제종료일을 입력해주세요.</span></div><div class=chg-contract-type><date-input date=vc.data.ContractEndDate></date-input></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-close\"></i> {{ \'Menu.CLOSE\' | translate}}</button></div></div>");
$templateCache.put("app/business/modal/business-op/chg-progress-step-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>진행단계 변경 <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a pull-right\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=chg-progress-step ng-repeat=\"li in vc.progressStep\"><span ng-style=\"{\'background\':li.CodeValue02}\" ng-click=vc.setData(li.Code)>{{li.CodeValue}}<span></span></span></div></div></div></div></div>");
$templateCache.put("app/business/modal/remind-alerm/business-remind-alarm-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">맞춤설정</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div></div>");
$templateCache.put("app/customer/modal/custCounsel/custCounsel-modal.html","<style>.custCounsel-modal-row #sec2 {\r\n      padding-left: 110px;\r\n      margin-top: -5px;\r\n    }\r\n    .custCounsel-modal-row #sec2 .item-wrap {\r\n      display: inline-block;\r\n      border: solid 1px #e3e3e3;\r\n      padding: 0px 8px;\r\n      border-radius: 6%;\r\n      line-height: 21px;\r\n      margin-right: 3px;\r\n      text-align: center;\r\n      background: #7f8fa4;\r\n      color: #ffffff;\r\n      font-size: 11px;\r\n      font-weight: 600;\r\n      margin-top: 4px;\r\n    }\r\n  \r\n    .custCounsel-modal-row #sec2 .item-wrap span {\r\n      font-weight: bold;\r\n      display: inline-block;\r\n      margin-left: 2px;\r\n    }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.TitleNm}} 저장</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custCounsel-modal-row\"><div class=col-lg-6><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">간편등록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=item-wrap ng-repeat=\"item in vc.data.ItemTypes\">{{item.ItemTypeNm}} <span ng-click=vc.deleteItem(item) ng-if=\"!vc.data.KeyId || vc.data.Status == \'10\' || vc.data.Status == \'20\'\">×</span></div></div><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.mdata.calendar == \'calendar\'\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7 col-xl-7\"><div class=\"form-group form-inline\"><label uib-tooltip=소요시간>소요시간</label><div class=timer><timetaken-picker id=id_time name=time step-time={{vc.data.settingMin}} class=form-field label=\"Enter time:\" ng-model=vc.takenTime callback=vc.takenTimeChanged required style=\"padding-left: 0px; padding-right: 0px; min-width:130px\"></timetaken-picker></div></div></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a sch_repeat_btn\" ng-click=vc.fnOpenRepeat(270)><span>{{vc.codeRepeatMap[vc.data.RepeatType]}}</span><!-- &nbsp;<span>{{vc.codeRepeatMap[vc.data.RepeatType]}}</span> <i class=\"fa fa-repeat\" style=\"color:{{vc.data.RepeatType == 10 ? \'\' : \'blue\'}}\"></i>&nbsp; --></button><!-- [반복] 레이어팝업 --><div class=sch_repeat_pop style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-body><!-- 반복 일정 --><div class=row><div class=\"form-group form-inline\"><label uib-tooltip=반복일정>반복일정</label><select class=form-control ng-model=vc.data.RepeatType code-list=vc.codeRepeatList code-model=vc.data.RepeatType ng-change=vc.selectRepeat() aria-invalid=false><option ng-repeat=\"op in vc.codeRepeatList\" value={{op.Code}}>{{op.CodeValue}}</option></select></div></div><!-- 반복 종료일 --><div><div class=row ng-if=\"vc.data.RepeatType == 20 || vc.data.RepeatType == 30 || vc.data.RepeatType == 40\"><div class=\"form-group form-inline\"><label uib-tooltip=반복종료일>반복종료일</label><div class=input-group><date-input date=vc.data.RepeatDate></date-input></div></div></div></div><!-- 반복 요일 선택 --><div class=row ng-if=\"vc.data.RepeatType == 30 || vc.data.RepeatType == 40\"><table class=tb_dayPick><tr><td><input type=checkbox id=dp1 ng-model=vc.data.RepeatMon ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp1>월</label></td><td><input type=checkbox id=dp2 ng-model=vc.data.RepeatTue ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp2>화</label></td><td><input type=checkbox id=dp3 ng-model=vc.data.RepeatWed ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp3>수</label></td><td><input type=checkbox id=dp4 ng-model=vc.data.RepeatThu ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp4>목</label></td><td><input type=checkbox id=dp5 ng-model=vc.data.RepeatFri ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp5>금</label></td><td><input type=checkbox id=dp6 ng-model=vc.data.RepeatSat ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp6>토</label></td><td><input type=checkbox id=dp7 ng-model=vc.data.RepeatSun ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label for=dp7>일</label></td></tr></table></div><div class=btnWrap><!-- <button class=\"btn btn-primary btn-big\" ng-click=\"vc.setRepeat()\">설정</button> --> <button class=\"btn btn-primary btn-big\" ng-click=vc.fnCloseRepeat()>설정</button><!-- <button class=\"btn btn-default btn-big\" ng-click=\"vc.fnCloseRepeat()\">닫기</button> --></div></div></div></div><!-- [반복] 레이어팝업 --></div></div></div><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec6 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec7 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><div id=sec8 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.KeyId && (vc.data.Status == \'10\' || vc.data.Status == \'20\') && vc.data.chgStatusMemoYN == \'N\'\"><button class=\"btn btn-primary mr-10 pull-right\" ng-click=vc.saveMemo()>메모추가</button></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.clickBtn(\'10\')\" ng-if=\"(vc.data.mDataSurgicalId != \'0\' && vc.data.Status == \'20\') && vc.mdata.ReserveViewType == \'L\'\"> --> <button class=\"btn btn-delete btn-ef btn-ef-6 btn-ef-6a mb-10 pull-left\" ng-click=vc.delData() ng-if=\"vc.data.KeyId != undefined\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.goCustomerDetail() ng-if=\"vc.mdata.CustId != undefined\"><i class=\"fa fa-user\"></i> 고객정보확인</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.clickBtn(\'10\')\" ng-if=\"(vc.data.mDataSurgicalId != \'0\' && vc.data.Status == \'20\') && vc.mdata.VisitId == 0\"><i class=\"fa fa-angle-double-right\"></i> 방문예약</button><!-- <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.clickBtn(\'20\')\" ng-if=\"(vc.data.mDataVisitId != \'0\' && vc.data.Status == \'10\') && vc.mdata.ReserveViewType == \'L\'\"> --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.clickBtn(\'20\')\" ng-if=\"(vc.data.mDataVisitId != \'0\' && vc.data.Status == \'10\') && vc.mdata.SurgicalId == 0\"><i class=\"fa fa-angle-double-right\"></i> 시술예약</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=\"vc.clickBtn(\'30\')\" ng-if=\"vc.data.ReserveStatus == \'40\' && !vc.mdata.addYn && vc.data.oldReserveStatus == \'40\'\"><i class=\"fa fa-shopping-cart\"></i> 결제</button> <button class=\"btn btn-primary mb-10\" ng-click=\"vc.setData(\'save\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div><div class=col-lg-6><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><ul class=\"nav nav-tabs\"><li ng-class=\"vc.tabId == \'tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\">히스토리</a></li><li ng-class=\"vc.tabId == \'tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\">예약</a></li></ul><div class=tab-content><div class=\"tab-pane active\" id=modal-tab1><div class=\"panel panel-default tile modal-memo\"><div class=\"panel-body collapse in\"><div class=memo-item ng-repeat=\"item in vc.memoLists\"><div class=item-header><span class=item_regUser><strong>{{item.Status}}</strong></span> <span class=item_status>{{item.RegUser}}</span></div><div class=item-body>{{item.Remark}}</div><div class=item-footer><span class=item_regDate>{{item.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD HH:mm\'}}</span></div></div></div></div></div><div class=tab-pane id=modal-tab2><div class=\"panel panel-default tile modal-memo\"><div class=\"panel-body collapse in\"><div id=modalCalendar class=modalcalendar calendar=salevisModalCalendar ui-calendar=uiConfig.calendar ng-model=eventSources></div></div></div></div><div class=tab-pane id=modal-tab3><div class=\"panel panel-default tile modal-memo\"><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label><span style=color:red>*</span>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.custInfo.CustNm ng-change=vc.setCheckSimpleSign()></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label><span style=color:red>*</span>연락처</label><input type=text auto-hyphen-tel class=\"form-control form-right\" ng-model=vc.custInfo.Mobile ng-change=vc.setCheckSimpleSign()></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label><span style=color:red>*</span>담당자</label><common-code-custom code-list=vc.codeManager code-model=vc.custInfo.Manager callback=vc.setCheckSimpleSign()></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveCustomer() ng-disabled=vc.simpleSignDisabled><i class=\"fa fa-edit\"></i>간편등록</button></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/customer/modal/custMigration/custMigration-modal.html","<script src=https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.14.3/xlsx.full.min.js></script><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">고객대량등록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Excel 다운로드</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><!-- <pre>{{vc.data | json}}</pre> --><p>유의사항</p><p>- 생성한 양식의 첫 행을 변경하시면 안되며 필수항목은 반드시 입력 바랍니다.</p><p>- 괄호 선택값이 존재할 경우 괄호에 없는 값을 입력하면 해당 값은 저장되지 않습니다.</p><p>- [고객명 + 휴대폰]이 기존에 존재하는 고객은 투입되지 않습니다.</p><p style=\"color: red\">- \'YYYY-MM-DD\'형식으로 입력하는 데이터 셀 서식은 \'텍스트\'로 되어있어야 합니다.</p><div class=pull-right><button class=\"btn btn-primary mt-10\" ng-click=vc.downloadExcel()><i class=\"fa fa-file-excel-o\"></i> 양식다운로드</button></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Excel 업로드</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=col-lg-12><div class=form-group><input type=file id=excelFile style=\"width: 70%; border: solid 1px #CCC; display:inline-block\"> <button class=\"btn btn-primary\" ng-click=vc.importExcelData()><i class=\"fa fa-file-excel-o\"></i> Excel 양식 업로드</button></div></div><div class=col-lg-12 ng-if=vc.failPanel><p class=mr-5 style=\"text-align: right\">실패건수 {{vc.failDataList.length}}건</p></div><div class=\"col-lg-12 failPanel\" ng-if=vc.failPanel><div class=\"panel panel-default tile\"><table class=\"footable table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=\"text-center active th-new\">고객명</th><th data-toggle=true class=\"text-center active th-new\">연락처</th><th data-toggle=true class=\"text-center active th-new\">담당자ID</th><th data-toggle=true class=\"text-center active th-new\">실패사유</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.failDataList\"><td class=text-center><span ng-bind=li.CustNm></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center><span ng-bind=li.Manager></span></td><td class=text-center><span ng-bind=li.Err></span></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/customer/modal/customerarmy/custarmy-gunbun-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">회원{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getCustArmyList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div></form><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>휴대폰</th><th data-toggle=true class=text-center>군별</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.CustArmyList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.MM_KNM></span></td><td class=text-center><span ng-bind=li.MM_ARMY_GUNBUN></span></td><td class=text-center><span ng-bind=li.MM_ID></span></td><td class=text-center><span ng-bind=\"li.MM_TEL_HP.substr(0,3) + \'-\' + li.MM_TEL_HP.substr(4,4) + \'-\' + li.MM_TEL_HP.substr(8,4)\"></span></td><td class=text-center><span ng-bind=li.MM_ARMY_GUNBUL_NAME></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustArmyList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-primary mb-10\" ng-click=\"modalCtrl.ok()\">\r\n      <i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}\r\n    </button> --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/customer/modal/customerarmy/custarmy-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">회원{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><div class=dataloader ng-show=modalCtrl.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getGoojikApiList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div></form><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>계급</th><th data-toggle=true class=text-center>휴대폰</th><th data-toggle=true class=text-center>소속(사, 여단급)</th><th data-toggle=true class=text-center>사업명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.CustArmyList track by $index\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.CustNm></span></td><td class=text-center><span ng-bind=li.ArmyNo></span></td><td class=text-center><span ng-bind=li.ArmyClass_></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center><span ng-bind=li.PermStat_></span></td><td class=text-center><span ng-bind=li.TenantNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount template-url=components/template/pagination.html total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getGoojikApiList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/customer/modal/customerarmy/custarmy-name-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">회원{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getList()\'}\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getCustArmyList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div></form><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=text-center>성명</th><th data-toggle=true class=text-center>군번</th><th data-toggle=true class=text-center>아이디</th><th data-toggle=true class=text-center>휴대폰</th><th data-toggle=true class=text-center>군별</th><th data-toggle=true class=text-center>소속(사,여단급)</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.CustArmyList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.MM_KNM></span></td><td class=text-center><span ng-bind=li.MM_ARMY_GUNBUN></span></td><td class=text-center><span ng-bind=li.MM_ID></span></td><td class=text-center><span ng-bind=\"li.MM_TEL_HP.substr(0,3) + \'-\' + li.MM_TEL_HP.substr(4,4) + \'-\' + li.MM_TEL_HP.substr(8,4)\"></span></td><td class=text-center><span ng-bind=li.MM_ARMY_GUNBUL_NAME></span></td><td class=text-center><span ng-bind=li.MM_UNIT></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustArmyList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><!-- <button class=\"btn btn-primary mb-10\" ng-click=\"modalCtrl.ok()\">\r\n      <i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}\r\n    </button> --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/customer/modal/custPayment/custPayment-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">결제</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custPayment-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">고객결제</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><!-- <pre>vc.data {{vc.data | json}}</pre> --><!-- 결제 기본 정보 --><div id=sec1></div><!-- 담당자 --><div id=sec2></div><!-- 유형 --><div id=sec3 ng-if=\"vc.data.PayStatus != \'20\' && vc.data.PayStatus != \'30\'\"></div><!-- 선택 유형 --><div id=sec3ItemType class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 mt-5\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"vc.data.PayDetailList.length > 0\"><colgroup><col style=\"width: 45%\"><col style=\"width: 15%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 15%\"><col style=\"width: 5%\"></colgroup><thead><tr><th class=text-center>유형명</th><th class=text-center>단가(원)</th><th class=text-center>횟수(회)</th><th class=text-center>할인율(%)</th><th class=text-center>금액(원)</th><th class=text-center ng-if=\"vc.data.PayStatus == \'10\'\">삭제</th><th class=text-center ng-if=\"vc.data.PayStatus == \'30\'\" ng-click=vc.refundAllData()>환불</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.PayDetailList\" style=\"cursor: pointer\"><td class=text-left>{{li.ItemTypeNm}}</td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" ng-disabled=\"vc.data.PayStatus != \'10\'\" ng-model=li.ItemUnitPrice ng-change=\"li.ItemAmt=(li.ItemCnt * li.ItemUnitPrice) - (((li.ItemCnt * li.ItemUnitPrice)/100) * li.ItemDiscRate); vc.setCalcPayMethType();\"></td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" ng-disabled=\"vc.data.PayStatus != \'10\'\" ng-model=li.ItemCnt ng-change=\"li.ItemAmt=(li.ItemCnt * li.ItemUnitPrice) - (((li.ItemCnt * li.ItemUnitPrice)/100) * li.ItemDiscRate); vc.setCalcPayMethType();\"></td><td class=text-center><input type=text comma numbers-only class=\"text-right form-control form-right\" ng-disabled=\"vc.data.PayStatus != \'10\'\" ng-model=li.ItemDiscRate ng-change=\"li.ItemAmt=(li.ItemCnt * li.ItemUnitPrice) - (((li.ItemCnt * li.ItemUnitPrice)/100) * li.ItemDiscRate); vc.setCalcPayMethType();\" ng-disabled=li.isTicket></td><td class=text-right><span comma-bind ng-bind=li.ItemAmt></span></td><td class=text-center ng-if=\"vc.data.PayStatus == \'10\'\"><span ng-if=\"vc.data.PayStatus == \'10\'\" ng-click=vc.deleteItem(li)>X</span></td><td class=text-center ng-if=\"vc.data.PayStatus == \'30\'\"><span ng-if=\"vc.data.PayStatus == \'30\'\" ng-click=vc.refundItem(li) style=color:red>환불</span></td></tr></tbody></table></div><!-- 결제 수단 --><div id=sec3PayMethType class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.PayDetailList.length > 0\"><!-- 결제수단 목록  --><div id=sec3PayMethTypeList class=mt-10 ng-if=\"vc.data.PayMethodList.length > 0\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"vc.data.PayMethodList.length > 0\"><colgroup><col style=\"width: 70%\"><col style=\"width: 30%\"></colgroup><thead><tr><th class=text-center>최종 결제수단</th><th class=text-center>최종 납입금액(원)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.PayMethodList\" style=\"cursor: pointer\"><td class=text-left>{{li.PayMethTypeNm}}</td><td class=text-right><span comma-bind ng-bind=li.PayAmt></span></td></tr></tbody></table></div><!-- 결제 수단 --><div id=secPayMethType1 class=\"row mt-10 mb-10\" ng-if=\"vc.data.PayStatus != \'30\'\"><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType10 ng-true-value=true ng-disabled=\"vc.data.RemPassAmt == 0\" ng-false-value=false ng-change=vc.setCalcPayMethType() role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false id=payMethItem1></md-checkbox><label for=payMethItem1 ng-click=\"vc.setPayMethType(\'10\')\"></label><p>정액권</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType10Amt ng-change=vc.setCalcPayMethType() ng-disabled=!vc.data.PayMethType10 class=form-control><span class=addInputTxt>원</span></div><div>잔여: <span comma-bind ng-bind=vc.data.RemPassAmt></span> 원</div></div><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType30 ng-true-value=true ng-disabled=\"vc.data.RemPoint == 0\" ng-false-value=false ng-change=vc.setCalcPayMethType() role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false id=payMethItem3></md-checkbox><label for=payMethItem3 ng-click=\"vc.setPayMethType(\'30\')\"></label><p>포인트</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType30Amt ng-change=vc.setCalcPayMethType() ng-disabled=!vc.data.PayMethType30 class=form-control><span class=addInputTxt>원</span></div><div>잔여: <span comma-bind ng-bind=vc.data.RemPoint></span> 원</div></div><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType20 ng-true-value=true ng-disabled=\"vc.data.UsedTicketList.length == 0\" ng-false-value=false role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false aria-disabled=true id=payMethItem2></md-checkbox><label for=payMethItem2></label><p>횟수권</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType20Amt ng-disabled=true class=form-control><span class=addInputTxt>원</span></div></div><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType40 ng-true-value=true ng-false-value=false ng-change=vc.setCalcPayMethType() role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false id=payMethItem4></md-checkbox><label for=payMethItem4 ng-click=\"vc.setPayMethType(\'40\')\"></label><p>현금</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType40Amt ng-change=vc.setCalcPayMethType() ng-disabled=!vc.data.PayMethType40 class=form-control><span class=addInputTxt>원</span></div></div><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType50 ng-true-value=true ng-false-value=false ng-change=vc.setCalcPayMethType() role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false id=payMethItem5></md-checkbox><label for=payMethItem5 ng-click=\"vc.setPayMethType(\'50\')\"></label><p>계좌이체</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType50Amt ng-change=vc.setCalcPayMethType() ng-disabled=!vc.data.PayMethType50 class=form-control><span class=addInputTxt>원</span></div></div><div class=\"payMethItem col-xs-12 col-sm-6 col-md-2 col-xg-2 col-xl-2\"><div class=payMethIconWrap><md-checkbox ng-model=vc.data.PayMethType60 ng-true-value=true ng-false-value=false ng-change=vc.setCalcPayMethType() role=checkbox aria-label=\"\'\'\" tabindex=0 type=checkbox class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-checked=false aria-invalid=false id=payMethItem6></md-checkbox><label for=payMethItem6 ng-click=\"vc.setPayMethType(\'60\')\"></label><p>카드</p></div><div class=\"form-group form-inline\"><input type=text comma numbers-only ng-model=vc.data.PayMethType60Amt ng-change=vc.setCalcPayMethType() ng-disabled=!vc.data.PayMethType60 class=form-control><span class=addInputTxt>원</span></div></div></div><!-- 최종 결제금액 --><div id=secPayMethType3 class=row ng-if=\"vc.data.PayStatus != \'30\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div style=\"display: flex; padding: 20px 30px; font-size: 14px; line-height: 1; background: #f5f6f9\"><div style=\"display: flex; flex-direction: column; width: 100%\"><p class=xlabel><strong>결제수단</strong></p><p class=xprice><span ng-bind=vc.data.FinPayMethType></span></p></div><div style=\"display: flex; flex-direction: column; width: 100%\"><p class=xlabel><strong>청구금액</strong></p><p class=xprice>₩ <span comma-bind ng-bind=vc.data.TotPayAmt></span></p></div><div style=\"display: flex; flex-direction: column; width: 100%\"><p class=xlabel><strong>미수금액</strong></p><p class=xprice>₩ <span comma-bind ng-bind=vc.data.OutAmt style=color:red></span></p></div><div style=\"display: flex; flex-direction: column; width: 100%\"><p class=xlabel><strong>최종 결제금액</strong></p><p class=xprice>₩ <span comma-bind ng-bind=vc.data.FinPayAmt></span></p></div></div></div></div></div><!-- 적립예정포인트 --><div id=sec4 ng-if=\"vc.data.PayStatus != \'30\'\"></div><!-- 메모 --><div id=sec5></div></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" ng-click=vc.setRefundData() ng-if=\"vc.data.PayStatus == \'30\' && vc.data.RefundAmt > 0\"><i class=\"fa fa-undo\"></i> 환불처리</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=\"vc.data.PayStatus != \'30\'\"><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/customer/modal/custPayment/custPaymentPassTicket-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">정액권/횟수권 충전</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custPayment-modal-row\"><div class=col-lg-12><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><!-- Header --><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">{{vc.data.PayTypeNm}} 충전</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- Body --><div class=\"panel-body collapse in\"><!-- 정액권/횟수권 유형--><div id=secPayType class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12 modal-btn-wrap\"><button class=\"btn btn-default mb-10\" ng-class=\"{active : vc.data.PayType == \'10\'}\" ng-click=\"vc.setPayType(\'10\')\"><i class=\"fa fa-shopping-cart\"></i> 정액권</button> <button class=\"btn btn-default mb-10\" ng-class=\"{active : vc.data.PayType == \'20\'}\" ng-click=\"vc.setPayType(\'20\')\"><i class=\"fa fa-ticket\"></i> 횟수권</button></div><!-- 결제일시 --><div id=sec0 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><!-- 담당자 --><div id=sec1 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><!-- 정액권/횟수권 --><div id=sec2 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><!-- 결제금액, 결제수단 --><div id=sec3 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"></div><!-- 충전금액 --><div id=sec4 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.PayType != \'20\'\"></div><!-- 충전횟수 --><div id=sec5 class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.data.PayType != \'10\'\"></div></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=\"vc.data.FinPayAmt > 0\"><i class=\"fa fa-edit\"></i> {{\'Menu.SAVE\' | translate}}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/customer/modal/editconfirm/user-edit-confirm-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\" style=\"padding :0px\"><md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 550px; max-width: 100%;\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/alert-icon-exclamation.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=vc.alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=vc.ok(1) style=width:33.3%><span class=\"ng-binding ng-scope\" style=\"color:#333; font-size:15px; font-weight:800\">A -> B</span></button> <button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=vc.ok(2) md-autofocus=true style=width:33.3%><span class=\"ng-binding ng-scope\" style=\"color:#333; font-size:15px; font-weight:800\">B -> A</span></button> <button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=vc.cancel() md-autofocus=true style=width:33.3%><span class=\"ng-binding ng-scope\" style=\"color:#333; font-size:15px; font-weight:800\">취소</span></button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/customer/modal/jobinfoarmy/employhistory-modal.html","<style>.ctrl-employhistorymodalctrl-wrap .modal-dialog {\r\n    width: 1080px;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">취업결과현황</h3></div><div class=\"modal-body ng-scope\"><div class=dataloader ng-show=modalCtrl.dataloader></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table class=\"table table-custom table-striped\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=text-center>번호</th><th data-toggle=true class=text-center>회사명</th><th data-toggle=true class=text-center>부서</th><th data-toggle=true class=text-center>직급</th><th data-toggle=true class=text-center>직책</th><th data-toggle=true class=text-center>취업직종</th><th data-toggle=true class=text-center>입사일</th><th data-toggle=true class=text-center>취업형태</th><th data-toggle=true class=text-center>등록자</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.EmployHistoryList track by $index\"><td class=text-center><span ng-bind=li.RowNumber></span></td><td class=text-center><span ng-bind=li.CompanyName></span></td><td class=text-center><span ng-bind=li.DepartName></span></td><td class=text-center><span ng-bind=li.WorkRank></span></td><td class=text-center><span ng-bind=li.WorkName></span></td><td class=text-center><span ng-bind=li.WorkClass></span></td><td class=text-center><span ng-bind=li.EntryDate></span></td><td class=text-center><span ng-bind=li.EmployType></span></td><td class=text-center><span ng-bind=li.RegUser></span></td></tr></tbody></table></div><!-- /row --></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/customer/modal/penchart/cust-penchart-modal.html","<style>.cust-pench-modal-wrap img {\r\n    width: 100%;\r\n  }\r\n\r\n  .square {\r\n    position: relative;\r\n    /* width: 20%; */\r\n    padding: 8px;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n  .square:after {\r\n    content: \"\";\r\n    display: block;\r\n    padding-bottom: 144%;\r\n  }\r\n\r\n  .square .box-area-wrap {\r\n    position: absolute;\r\n    width: calc(100% - 16px);\r\n    border: solid 1px #e3e3e3;\r\n    background: #FFF;\r\n  }\r\n\r\n  .square .content {\r\n    height: 90%;\r\n    width: calc(100% - 18px);\r\n    position: absolute;\r\n    background: #f7f7f7;\r\n    padding: 8px;\r\n    border: none;\r\n    margin: 0px 1px 0px 1px;\r\n  }\r\n\r\n  .square .content div {\r\n    height: 100%;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n  }\r\n\r\n  .cust-pench-modal-wrap .square .title {\r\n    height: 16px;\r\n    margin-top: 11px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  .cust-pench-modal-wrap .square .date {\r\n    height: 16px;\r\n    margin-top: 6px;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    letter-spacing: -1px;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  .penchart-list .av-page-size-wrap {\r\n    display: none;\r\n    \r\n  }\r\n\r\n  .penchart-list .av-paging-wrap {\r\n    width: 100% !important;\r\n    margin: 18px 0 5px;\r\n  }\r\n\r\n  .penchart-list .paging_pad:nth-child(2) .paging {\r\n    width: 100% !important;\r\n  }\r\n\r\n  canvas {\r\n    cursor: crosshair;\r\n    border: solid 1px #e4e8eb;\r\n    width: 100%;\r\n  }\r\n\r\n  .is-fullscreen {\r\n    width: 100%;\r\n    margin: 0;\r\n  }\r\n\r\n  .is-fullscreen .page-header{\r\n    font-size: 14px;\r\n  }\r\n\r\n  .modal-body {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .empty-wrap {\r\n    border: none !important;\r\n    padding-bottom: 30px;\r\n    font-size: 18px;\r\n  }</style><div class=\"modal-content cust-pench-modal-wrap\"><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.title}}</div><div class=pull-right><!-- <button class=\"btn btn-default\" ng-click=\"vc.fullSceen()\" ng-show=\"vc.showDrawView\">\r\n        <i class=\"fa fa-tablet\"></i>\r\n      </button> --> <button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custPayment-modal-row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-show=vc.showSelectView><div class=\"modal-body ng-scope\"><div class=row><div id=mfSec1 style=width:35%></div><button class=\"btn btn-default\" ng-click=vc.getSrchData() style=\"margin-top:6px; margin-left:-6px\"><i class=\"fa fa-search\"></i> 검색</button></div><div class=\"row mt-5\" ng-if=\"vc.lists.length > 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><!-- 내용이 없을 때 --><p class=emptyTxt ng-if=\"vc.workLists.length == 0\">서식을 선택해 주세요.</p><div ng-repeat=\"item in vc.workLists\" class=\"col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 square\"><div class=box-area-wrap></div><div class=content ng-click=vc.addWorkList(item)><div style=\"background-image : url(\'{{item.ImageData}}\')\"></div><div class=title>{{item.ChartNm}}</div><div class=date>{{item.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD\'}}</div></div></div></div></div></div></div><div class=\"row penchart-list\" ng-if=\"vc.lists.length > 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in right-form-wrap\"><div ng-repeat=\"item in vc.lists\" class=\"col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 square\"><div class=box-area-wrap></div><div class=content ng-click=vc.addWorkList(item)><div style=\"background-image : url(\'{{item.ImageData}}\')\"></div><div class=title>{{item.ChartNm}}</div><div class=date>{{item.RegDate | autoViewUtcToLocal:\'YYYY-MM-DD\'}}</div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><autoview-list-paging alias=vc list-data=lists></autoview-list-paging></div></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\" ng-if=\"vc.lists.length > 0\"><button class=\"btn btn-primary\" ng-click=vc.setChangeDrawView()><i class=\"fa fa-edit\"></i> 선택완료</button></div><div class=mt-5 ng-if=\"vc.lists.length == 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile empty-wrap\"><div class=\"panel-body collapse in\"><!-- 내용이 없을 때 --><p class=emptyTxt ng-if=\"vc.workLists.length == 0\">등록된 서식이 없습니다.</p><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-center mt-15\" ng-if=vc.checkPenMng><button class=\"btn btn-primary\" ng-click=vc.gotoManage()><i class=\"fa fa-edit\"></i> 서식 등록하기</button></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-show=vc.showDrawView><div class=modal-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- <button class=\"btn btn-default mb-10\" ng-click=\"vc.sketchs.setModeMarker()\">\r\n              <i class=\"fa fa-times\"></i>{{ \'선긋기\' | translate }}\r\n            </button>\r\n    \r\n            <button class=\"btn btn-default mb-10\" ng-click=\"vc.sketchs.setModeEraser()\">\r\n              <i class=\"fa fa-times\"></i>{{ \'지우개\' | translate }}\r\n            </button> --><!-- <button class=\"btn btn-default mb-10\" ng-click=\"vc.cancel()\">\r\n              <i class=\"fa fa-times\"></i>{{ \'선 굵기\' | translate }}\r\n            </button>\r\n            <button class=\"btn btn-default mb-10\" ng-click=\"vc.cancel()\">\r\n              <i class=\"fa fa-times\"></i>{{ \'색상\' | translate }}\r\n            </button> --> <button class=\"btn btn-default\" ng-click=vc.sketchs.setReset()><i class=\"fa fa-refresh\"></i>{{ \'초기화\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.sketchs.loadBackward()><i class=\"fa fa-backward\"></i>{{ \'되돌리기\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.sketchs.loadForward()><i class=\"fa fa-forward\"></i>{{ \'다시실행\' | translate }}</button></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-10\"><div class=slider><div ng-repeat=\"photo in vc.workData\" ng-show=photo.showYn><canvas id=chartCanvas{{$index}}></canvas></div><div class=\"btnWrap mt-10\"><button class=\"btn btn-default disabled btn-backward\" ng-click=vc.setChangeCanvasIndex(0)><i class=\"fa fa-chevron-left\"></i> 이전</button> <button class=\"btn btn-primary btn-forward\" ng-click=vc.setChangeCanvasIndex(1)>다음 <i class=\"fa fa-chevron-right\"></i></button></div></div></div></div></div><!-- Action Buttons  --><div class=\"modal-footer ng-scope\"><div class=pull-left><button class=\"btn btn-default\" ng-click=vc.setWrapBack()><i class=\"fa fa-chevron-left\"></i> 뒤로</button></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!-- <button class=\"btn btn-default\" ng-click=\"vc.cancel()\">\r\n            <i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}\r\n          </button> --></div></div></div></div></div>");
$templateCache.put("app/customer/modal/penchart/cust-penchart-view-modal.html","<style>.cust-pench-modal-wrap img {\r\n    width: 100%;\r\n  }\r\n\r\n  .square {\r\n    position: relative;\r\n    /* width: 20%; */\r\n    padding: 8px;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n  .square:after {\r\n    content: \"\";\r\n    display: block;\r\n    padding-bottom: 144%;\r\n  }\r\n\r\n  .square .box-area-wrap {\r\n    position: absolute;\r\n    width: calc(100% - 16px);\r\n    border: solid 1px #e3e3e3;\r\n    background: #FFF;\r\n  }\r\n\r\n  .square .content {\r\n    height: 90%;\r\n    width: calc(100% - 18px);\r\n    position: absolute;\r\n    background: #f7f7f7;\r\n    padding: 8px;\r\n    border: none;\r\n    margin: 0px 1px 0px 1px;\r\n  }\r\n\r\n  .square .content div {\r\n    height : 100%;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n  }\r\n\r\n  .cust-pench-modal-wrap .square .title {\r\n    height: 16px;\r\n    margin-top: 11px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  .cust-pench-modal-wrap .square .date {\r\n    height: 16px;\r\n    margin-top: 6px;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    letter-spacing: -1px;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  .penchart-list .paging_pad:nth-child(1){ \r\n    display: none;;\r\n  }\r\n\r\n  .penchart-list .paging_pad:nth-child(2){ \r\n    width : 100% !important;\r\n  }\r\n\r\n  .penchart-list .paging_pad:nth-child(2) .paging{ \r\n    width : 100% !important;\r\n  }\r\n\r\n  canvas {\r\n    cursor : crosshair;\r\n  }</style><div class=\"modal-content cust-pench-modal-wrap\"><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">{{vc.title}}</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"row custPayment-modal-row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=modal-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-10\"><div class=slider><div ng-repeat=\"photo in vc.workData\" ng-show=photo.showYn><canvas id=chartCanvas{{$index}}></canvas></div><div class=\"btnWrap mt-10\"><button class=\"btn btn-default disabled btn-backward\" ng-click=vc.setChangeCanvasIndex(0)><i class=\"fa fa-chevron-left\"></i> 이전</button> <button class=\"btn btn-primary btn-forward\" ng-click=vc.setChangeCanvasIndex(1)>다음 <i class=\"fa fa-chevron-right\"></i></button></div></div></div></div></div><!-- Action Buttons  --><!-- <div class=\"modal-footer ng-scope\">\r\n        <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=\"vc.cancel()\">\r\n          <i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}\r\n        </button>\r\n      </div> --></div></div></div>");
$templateCache.put("app/customer/modal/sms/sms-view-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">문자조회</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getFormList()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=vc.sms.CmpgnChannel disabled><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><input type=text class=\"form-control form-right\" ng-model=vc.sms.FromInfo ng-required=true disabled></div></div></div><div ng-switch on=vc.sms.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=vc.sms.SendTitle ng-required=true disabled></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=vc.sms.SendMessage ng-required=true ng-change=vc.chkSendMessage() disabled></textarea><div class=text-right></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("app/scsystem/itemtype/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortableContainer .sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortableContainer .sortable-root-scope\").css(\"min-height\", height);</script><div class=sortableContainer><div class=dataloader ng-show=vc.dataloader></div><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || (!scVc.isSys && !scVc.isBranch && scVc.selectBranchCode) || scVc.isBranch\"><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.ItemName}}</span><div class=subTextmenu id=subMenu_{{item.tempId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item.UseYN == \'\' || item.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(1, item.tempId)\" ng-if=\"scVc.maxDepth > 1 && item.AttendanceType == 0\" style=color:#496887>추가 |</span> <span ng-click=\"scVc.delChild(1, item)\" style=color:#496887>삭제</span></div></div></div></div><!-- /1 dpeth --><!-- 2 dpeth --><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item.child style=margin-left:15px><!-- 3 dpeth --><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item2) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item2.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item2.tempId)\" menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item2.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item2.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.ItemName}}</span><div class=subTextmenu id=subMenu_{{item2.tempId}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item2.UseYN == \'\' || item2.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(2, item2.tempId)\" ng-if=\"scVc.maxDepth > 2 && item2.AttendanceType == 0\" style=color:#496887>추가 |</span> <span ng-click=\"scVc.delChild(2, item2)\" style=color:#496887>삭제</span></div></div></div></div><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item3) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item3.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item3.tempId)\" menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.DelYN!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.tempId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.ItemName}}</span><div class=subTextmenu id=subMenu_{{item3.tempId}} menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item3.UseYN == \'\' || item3.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.delChild(3, item3)\" style=color:#496887>삭제</span></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.tempId}} menu-path={{item2.path}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth03title input-enter=\"scVc.addMenuItem(3, \'editor{{item2.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(3, \'editor\'+item2.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(3, \'editor\'+item2.tempId)\">취소</span></div><div style=clear:both></div></div></div></div></div><!-- /3 dpeth --><div><div class=edit-layout style=background:#FFF id=editor{{item.tempId}} menu-path={{item.path}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth02title input-enter=\"scVc.addMenuItem(2, \'editor{{item.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(2, \'editor\'+item.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(2, \'editor\'+item.tempId)\">취소</span></div><div style=clear:both></div></div></div></div><!-- /2 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("app/scsystem/penchart-mng/image-sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .sortableImageContainer .as-sortable-placeholder {border:none !important; height: 100% !important;}\r\n  .sortableImageContainer .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n      min-height: 500px !important;\r\n      min-width: 260px !important\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }\r\n\r\n  .square {\r\n    position: relative;\r\n    width: 20%;\r\n    padding: 8px;\r\n    margin-bottom: 18px;\r\n    margin-top: 21px;\r\n  }\r\n\r\n  .square:after {\r\n    content: \"\";\r\n    display: block;\r\n    padding-bottom: 150%;\r\n  }\r\n\r\n  .square .box-area-wrap {\r\n    position: absolute;\r\n    width: calc(100% - 16px);\r\n    height: 107%;\r\n    border: solid 1px #e3e3e3;\r\n    background: #FFF;\r\n  }\r\n\r\n  .empty-view .box-area-wrap {\r\n    background: #f7f7f7\r\n  }\r\n\r\n  .empty-view .content {\r\n   text-align: center;\r\n   padding-top: 43% !important;\r\n  }\r\n\r\n  .empty-view .content > div {\r\n    height: auto;\r\n    margin-top: 8px;\r\n    font-weight: 600;\r\n    color: #c2c2c2;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .square .content {\r\n    height: 90%;\r\n    width: calc(100% - 18px);\r\n    position: absolute;\r\n    background: #f7f7f7;\r\n    padding-bottom: 26px;\r\n    padding: 8px;\r\n    border: none;\r\n    margin: 0px 1px 0px 1px;\r\n    top:10px;\r\n  }\r\n\r\n  .square .content div {\r\n    height: 100%;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    margin-top: 32px;\r\n  }\r\n\r\n  .sortable-image-row.as-sortable-dragging .square{\r\n    height:100% !important;\r\n    width:100% !important;\r\n    margin: 0px !important;\r\n  }\r\n\r\n  .sortableImageContainer .as-sortable-item-handle {\r\n    width: 100%;\r\n  }\r\n  \r\n  .sortableImageContainer .sort-wrap {\r\n    display: inline-block;\r\n    position: absolute;\r\n    z-index: 10;\r\n    top: -10px;\r\n    border: solid 1px #CCC;\r\n    width: 25px;\r\n    height: 25px;\r\n    line-height: 25px;\r\n    text-align: center;\r\n    right: -21px;\r\n    background: #FFF;\r\n  }\r\n\r\n  .sortableImageContainer .name-wrap {\r\n    position: absolute;\r\n    bottom: -25px;\r\n    left: 16px;\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 84%;\r\n  }\r\n\r\n  .sortableImageContainer .header, .sortableImageContainer .del-btn-wrap {\r\n    margin: 0px;\r\n    width: calc(100% - 18px);\r\n    border: none;\r\n    position: absolute;\r\n    z-index: 2;\r\n    background: #FFF;\r\n    top: 10px;\r\n    left: 9px;\r\n    line-height: 30px;\r\n    border-bottom: solid 1px #e3e3e3;\r\n    padding-left: 6px;\r\n  }\r\n\r\n  .sortableImageContainer .del-btn-wrap {\r\n    left: unset;\r\n    width: 10px;\r\n    right: 25px;\r\n  }</style><div class=\"sortableContainer sortableImageContainer\" style=\"margin-left: 12px; margin-right: 12px\"><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --> <input type=file name=\"\" id=selectFiles multiple accept=\"image/gif, image/jpeg, image/png\" style=\"display: none\"><div class=\"sortable-row sortable-image-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding: 8px 8px 35px 1.5%; background:#fff; border:solid 1px #e3e3e3; margin-top:4px; padding-left:1.5%\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions ng-if=\"item.DelYN==\'N\'\" style=border:none class=\"{{item.extendGroupClass}} col-key-{{item.tempCode}} col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 square item-square\"><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=box-area-wrap></div><div class=header>{{item.Sort}}</div><div class=del-btn-wrap><i class=\"fa fa-trash fa-fw\" ng-click=\"scVc.delItem($index, item.tempCode);\"></i></div><div class=\"content as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><div style=\"background-image : url(\'{{item.ImageData}}\')\"></div><span class=menu-name-tx>{{item.ChartNm}}</span></div><div class=name-wrap>{{item.ItemNm}}</div></div><div style=\"clear: both\"></div><!-- /1 dpeth --></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 square empty-view\"><div class=\"ng-scope as-sortable-item-handle\"><div class=box-area-wrap></div><div class=content ng-click=scVc.addImages()><img src=../../../../assets/images/btn_add_plus.png><div>추가</div></div></div></div></div></div>");
$templateCache.put("app/scsystem/penchart-mng/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortableListContainer .sortable-root-scope\").css(\"min-height\", height);</script><div class=\"sortableListContainer sortableContainer\"><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || (!scVc.isSys && !scVc.isBranch && scVc.selectBranchCode) || scVc.isBranch\"><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.ChartNm}}</span><div class=subTextmenu id=subMenu_{{item.tempId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item.UseYN == \'\' || item.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>숨기기 | </span><span ng-click=\"scVc.addChild(1, item.tempId)\" ng-if=\"scVc.maxDepth > 1 && item.FormYn == \'N\'\" style=color:#496887>2차분류 및 서식 추가 |</span> <span ng-click=\"scVc.delChild(1, item)\" style=color:#496887>삭제</span></div></div></div></div><!-- /1 dpeth --><!-- 2 dpeth --><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item.child style=margin-left:15px><!-- 3 dpeth --><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item2) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item2.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item2.tempId)\" menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item2.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item2.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.ChartNm}}</span><div class=subTextmenu id=subMenu_{{item2.tempId}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item2.UseYN == \'\' || item2.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>숨기기 | </span><span ng-click=\"scVc.addChild(2, item2.tempId)\" ng-if=\"scVc.maxDepth > 2 && item2.FormYn == \'N\'\" style=color:#496887>서식 추가</span> | <span ng-click=\"scVc.delChild(2, item2)\" style=color:#496887>삭제</span></div></div></div></div><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item3) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item3.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item3.tempId)\" menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.DelYN!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.tempId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.ChartNm}}</span><div class=subTextmenu id=subMenu_{{item3.tempId}} menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}}><div ng-if=\"(scVc.selectIndustCode != \'\'  && scVc.isSys) || !scVc.isSys\"><span ng-if=\"item3.UseYN == \'\' || item3.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>숨기기 | </span><span ng-click=\"scVc.delChild(3, item3)\" style=color:#496887>삭제</span></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.tempId}} menu-path={{item2.path}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth03title input-enter=\"scVc.addMenuItem(3, \'editor{{item2.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(3, \'editor\'+item2.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(3, \'editor\'+item2.tempId)\">취소</span></div><div style=clear:both></div></div></div></div></div><!-- /3 dpeth --><div><div class=edit-layout style=background:#FFF id=editor{{item.tempId}} menu-path={{item.path}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth02title input-enter=\"scVc.addMenuItem(2, \'editor{{item.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(2, \'editor\'+item.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(2, \'editor\'+item.tempId)\">취소</span></div><div style=clear:both></div></div></div></div><!-- /2 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("app/state/tab/customer-tab/customer-month.html","<style>.chart{\r\n    padding: 5px;\r\n    border-radius: 15px;\r\n    /* border-style: solid; */\r\n    \r\n    /* text-align: center; */\r\n    box-shadow: 1px 1px 15px 7px rgba(33,33,33,.2);\r\n  }</style><div class=\"page page-footable\" ng-controller=\"CustomerMonthCtrl as vc\"><!-- page content --><div class=pagecontent><div class=row><div class=dataloader ng-show=vc.dataloader></div></div><div class=row style=\"margin-bottom: 50px\"><div class=\"col-sm-12 col-md-1 col-lg-1\"></div><div class=\"col-sm-12 col-md-4 col-lg-4 chart\"><div id=1></div></div><div class=\"col-sm-12 col-md-2 col-lg-1\"></div><div class=\"col-sm-12 col-md-4 col-lg-4 chart\"><div id=2></div></div><div class=\"col-sm-12 col-md-1 col-lg-1\"></div></div></div></div>");
$templateCache.put("app/system/organization/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n    width: 119px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding: 5px 9px 5px 9px;\r\n    display: inline-block;\r\n    margin-top: -6px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortable-root-scope\").css(\"min-height\", height);</script><div class=sortableContainer><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu ng-if=\"scVc.ManageYn ==\'Y\'\"><div><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item.tempId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div><span ng-if=\"item.UseYN == \'\' || item.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>활성 </span><span ng-if=\"item.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>비활성 </span><span ng-click=\"scVc.addChild(1, item.tempId)\" ng-if=\"scVc.maxDepth > 1\" style=color:#496887>| 대부서등록 </span><span ng-click=\"scVc.delChild(1, item)\" ng-if=\"item.MasterBranchYn ==\'N\'\" style=color:#496887>| 삭제</span></div></div></div></div><!-- /1 dpeth --><!-- 2 dpeth --><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item.child style=margin-left:15px><!-- 3 dpeth --><div ng-repeat=\"item2 in item.child \" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item2) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item2.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item2.tempId)\" menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item2.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item2.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item2.tempId}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div><span ng-if=\"item2.UseYN == \'\' || item2.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(2, item2.tempId)\" ng-if=\"scVc.maxDepth > 2\" style=color:#496887>소부서추가</span> | <span ng-click=\"scVc.delChild(2, item2)\" style=color:#496887>삭제</span></div></div></div></div><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item3) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item3.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item3.tempId)\" menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.DelYN!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.tempId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item3.tempId}} menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}}><div><span ng-if=\"item3.UseYN == \'\' || item3.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.delChild(3, item3)\" style=color:#496887>삭제</span></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.tempId}} menu-path={{item2.path}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth03title input-enter=\"scVc.addMenuItem(3, \'editor{{item2.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(3, \'editor\'+item2.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(3, \'editor\'+item2.tempId)\">취소</span></div><div style=clear:both></div></div></div></div></div><!-- /3 dpeth --><div><div class=edit-layout style=background:#FFF id=editor{{item.tempId}} menu-path={{item.path}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth02title input-enter=\"scVc.addMenuItem(2, \'editor{{item.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(2, \'editor\'+item.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(2, \'editor\'+item.tempId)\">취소</span></div><div style=clear:both></div></div></div></div><!-- /2 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("app/system/role/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortable-root-scope\").css(\"min-height\", height);</script><div class=sortableContainer><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><select class=form-control ng-model=scVc.selectIndustCode ng-change=scVc.setChangeIndustCode(scVc.selectIndustCode) ng-if=false><option value=\"\">회원사 선택</option><option ng-repeat=\"op in scVc.industCodeList\" value={{op.Code}}>{{op.CodeValue}}</option></select><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.RoleId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.RoleId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.RoleId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.RoleId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.RoleNm}}</span><div class=subTextmenu id=subMenu_{{item.RoleId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div><span ng-click=\"scVc.delChild(1, item)\" style=color:#496887>삭제</span></div></div></div></div><!-- /1 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("app/system/support-business/excel-upload/support-business-upload-modal.html","<script src=https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.14.3/xlsx.full.min.js></script><div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"page-header pull-left\">지원사업대량등록</div><div class=pull-right><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i></button></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Excel 다운로드</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><!-- <pre>{{vc.data | json}}</pre> --><p>유의사항</p><p>- 생성한 양식의 첫 행을 변경하시면 안되며 필수항목은 반드시 입력 바랍니다.</p><p>- 작성한 값이 올바르지 않은 경우 투입되지 않습니다.</p><p>- 작성한 값의 오류체크는 앞에서부터 순차적으로 잔행되며 실패사유는 최초 오류로 보여집니다.</p><p>- 괄호 선택값이 존재할 경우 괄호에 없는 값을 입력하면 해당 값은 저장되지 않습니다.</p><div class=pull-right><button class=\"btn btn-primary mt-10\" ng-click=vc.downloadExcel()><i class=\"fa fa-file-excel-o\"></i> 양식다운로드</button></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Excel 업로드</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=col-lg-12><div class=form-group><input type=file id=excelFile style=\"width: 70%; border: solid 1px #CCC; display:inline-block\"> <button class=\"btn btn-primary\" ng-click=vc.importExcelData()><i class=\"fa fa-file-excel-o\"></i> Excel 양식 업로드</button></div></div><div class=col-lg-12 ng-if=vc.resultPanel><p class=\"mr-5 mb-5\" style=\"text-align: right\">총건수: {{vc.resultDataList.length}}건 / 실패건수: {{vc.failDataCnt}}건</p></div><div class=\"col-lg-12 failPanel\" ng-if=vc.resultPanel style=\"overflow-y: auto; height: 310px\"><div class=\"panel panel-default tile\"><table class=\"footable table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th data-toggle=true class=\"text-center active th-new\">지원사업명</th><th data-toggle=true class=\"text-center active th-new\">고객사명</th><th data-toggle=true class=\"text-center active th-new\">사업내용</th><th data-toggle=true class=\"text-center active th-new\">사업시작일</th><th data-toggle=true class=\"text-center active th-new\">사업종료일</th><th data-toggle=true class=\"text-center active th-new\">담당자ID</th><th data-toggle=true class=\"text-center active th-new\">고객명</th><th data-toggle=true class=\"text-center active th-new\">휴대폰번호</th><th data-toggle=true class=\"text-center active th-new\">담당지역본부</th><th data-toggle=true class=\"text-center active th-new\">일자</th><th data-toggle=true class=\"text-center active th-new\">실패사유</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.resultDataList\" ng-style=\"{\'background-color\' : (li.ErrYN == \'Y\') ? \'lightgray\' : \'#fff\'}\"><td class=text-center><span ng-bind=li.BusinessNm></span></td><td class=text-center><span ng-bind=li.ClientNm></span></td><td class=text-center><span ng-bind=li.BusiContents></span></td><td class=text-center><span ng-bind=li.BusiStartDate></span></td><td class=text-center><span ng-bind=li.BusiEndDate></span></td><td class=text-center><span ng-bind=li.ManagerNms></span></td><td class=text-center><span ng-bind=li.EncryptNm></span></td><td class=text-center><span ng-bind=li.EncryptMobile auto-hyphen-tel-bind></span></td><td class=text-center><span ng-bind=li.DeptNm></span></td><td class=text-center><span ng-bind=li.WriteDate></span></td><td class=text-center><span ng-bind=li.ErrReason></span></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData() ng-if=\"vc.failDataCnt == 0\"><i class=\"fa fa-edit\"></i> 업로드</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("scripts/directives/common-code/directive/common-code.html","<select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler() name=selectCombo ng-model=ccCtrl.data ng-show=ccCtrl.controlShow ng-options=\"opt.CodeValue for opt in ccCtrl.list track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=\"padding: 5px !important\"><option value=\"\">-{{ \'Menu.SELECT\' | translate }}-</option></select>");
$templateCache.put("components/ui-component/layout/header/header.html","<!-- Branding --><div class=\"branding {{main.settings.brandingColor}}\"><a ui-sref=app.dashboard><img src=assets/images/logo_armyedu_w.png style=\"height: 45px; margin-left: -7px\"></a><!-- <a class=\"brand\" ui-sref=\"app.dashboard\"> --><!-- <span><strong>{{gVariable.TenantName}}</strong></span> --><!-- <span><strong>SALE</strong>VIS</span> --><!-- </a> --> <a href=javascript:; class=\"offcanvas-toggle visible-xs-inline\" offcanvas-sidebar><i class=\"fa fa-bars\"></i></a></div><!-- Branding end --><!-- Left-side navigation --><ul class=\"nav-left pull-left list-unstyled list-inline\"><li class=\"sidebar-collapse divided-right\"><a href=javascript:; collapse-sidebar><fa name=outdent></fa></a></li></ul><!-- Left-side navigation end --><!-- Right-side navigation --><ul class=\"nav-right pull-right list-inline\"><li><a style=\"text-decoration: none; color: rgba(255, 255, 255, 0.7)\">남은 시간 <span ng-bind=header.countdown></span></a></li><li class=\"dropdown nav-profile\" uib-dropdown ng-if=header.isLogin()><a href class=dropdown-toggle uib-dropdown-toggle><span>{{header.userNm}}<fa name=angle-down></fa></span></a><ul class=\"dropdown-menu animated littleFadeInDown\" role=menu><li><a href=\"\" ng-click=header.myPage()><fa name=user></fa>Profile</a></li><li class=divider></li><li><a href=# ng-click=header.doLogout()><fa name=sign-out></fa>Logout</a></li></ul></li></ul><!-- Right-side navigation end -->");
$templateCache.put("components/ui-component/layout/clock/clock.html","<span id=calendar></span> <span id=clock class=cred></span>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar.html","<div id=controls><aside id=sidebar class={{main.settings.sidebarColor}} ng-class=\"{\'aside-fixed\':main.settings.asideFixed}\"><style>.answer {\r\n        display: none;\r\n      }\r\n\r\n      .your-class.collapsing {\r\n        transition-duration: 0.0125s;\r\n      }\r\n\r\n      .naviTop2 ul {\r\n        list-style: none;\r\n      }</style><div id=sidebar-wrap><div uib-accordion close-others=oneAtTime slimscroll=\"{height: \'100%\'}\" style=\"transition: all 0 ease 0\"><div uib-accordion-group is-open=status.isFirstOpen><div uib-accordion-heading>Navigation <i class=\"pull-right fa\" ng-class=\"{\'fa-angle-up\': status.isFirstOpen, \'fa-angle-down\': !status.isFirstOpen}\"></i></div><ul class=\"navigation naviTop2\" nav-collapse ripple><!-- Dashboard --><li md-ink-ripple ui-sref-active=active><a ui-sref=app.dashboard><fa name=dashboard></fa><span>Dashboard</span></a></li><!-- 내담자관리 --><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.customer\')}\" class=\"dropdown open\"><a ui-sref=app.customer.counselappli-list><fa name=address-card></fa><span>회원관리</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: block\"><!-- <li ui-sref-active=\"active\"><a ui-sref=\"app.customer.counselappli-list\" ui-sref-opts=\"{reload:\'app.customer.counselappli-list\'}\"><span>상담신청관리 > 상담신청목록</span></a></li>\r\n              <li ui-sref-active=\"active\"><a ui-sref=\"app.customer.counselappli-edit\" ui-sref-opts=\"{reload:\'app.customer.counselappli-edit\'}\"><span>상담신청관리 > 상담신청등록</span></a></li> --><li ui-sref-active=active><a ui-sref=app.customer.customerarmy-edit ui-sref-opts=\"{reload:\'app.customer.customerarmy-edit\'}\"><span>회원등록</span></a></li><li ui-sref-active=active><a ui-sref=app.customer.customerarmy-list ui-sref-opts=\"{reload:\'app.customer.customerarmy-list\'}\"><span>회원목록</span></a></li><!-- <li ui-sref-active=\"active\"><a ui-sref=\"app.customer.customerarmy-large\" ui-sref-opts=\"{reload:\'app.customer.customerarmy-large\'}\"><span>고객관리 > 고객대량등록</span></a></li> --><li ui-sref-active=active><a ui-sref=app.customer.jobinfoarmy-edit ui-sref-opts=\"{reload:\'app.customer.jobinfoarmy-edit\'}\"><span>취업등록</span></a></li><li ui-sref-active=active><a ui-sref=app.customer.jobinfoarmy-list ui-sref-opts=\"{reload:\'app.customer.jobinfoarmy-list\'}\"><span>취업목록</span></a></li></ul></li><!-- 상담관리 --><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.counsel\')}\" class=\"dropdown open\"><a ui-sref=app.counsel.counselrecord-list><fa name=list-alt></fa><span>상담관리</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: block\"><li ui-sref-active=active><a ui-sref=app.counsel.counselrecord-edit ui-sref-opts=\"{reload:\'app.counsel.counselrecord-edit\'}\"><span>상담일지등록</span></a></li><li ui-sref-active=active><a ui-sref=app.counsel.counselrecord-list ui-sref-opts=\"{reload:\'app.counsel.counselrecord-list\'}\"><span>상담일지목록</span></a></li><li ui-sref-active=active><a ui-sref=app.counsel.schedule-list ui-sref-opts=\"{reload:\'app.counsel.schedule-list\'}\"><span>상담일정조회</span></a></li></ul></li><!-- 창업멘토링 --><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.mentoring\')}\" class=\"dropdown open\"><a ui-sref=app.mentoring.mentoringapply-list><fa name=list-alt></fa><span>창업멘토링</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: block\"><li ui-sref-active=active><a ui-sref=app.mentoring.mentoringapply-list ui-sref-opts=\"{reload:\'app.mentoring.mentoringapply-list\'}\"><span>신청자조회</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.mentoringclub-list ui-sref-opts=\"{reload:\'app.mentoring.mentoringclub-list\'}\"><span>동아리팀</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.mentoringprtcp-list ui-sref-opts=\"{reload:\'app.mentoring.mentoringprtcp-list\'}\"><span>참여자</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.mentoringrecord-list ui-sref-opts=\"{reload:\'app.mentoring.mentoringrecord-list\'}\"><span>멘토링보고서</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.mentoringschedule-list ui-sref-opts=\"{reload:\'app.mentoring.mentoringschedule-list\'}\"><span>멘토링일정</span></a></li><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.mentoring\')}\" class=\"dropdown open\"><a ui-sref=app.mentoring.state.mentoringstate-summary><fa name=bar-chart></fa><span>통계</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: block\"><li ui-sref-active=active><a ui-sref=app.mentoring.state.mentoringstate-summary ui-sref-opts=\"{reload:\'app.mentoring.state.mentoringstate-summary\'}\"><span>현황판</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.state.mentoringstate-total ui-sref-opts=\"{reload:\'app.mentoring.state.mentoringstate-total\'}\"><span>종합현황</span></a></li><li ui-sref-active=active><a ui-sref=app.mentoring.state.mentoringstate-list ui-sref-opts=\"{reload:\'app.mentoring.state.mentoringstate-list\'}\"><span>참여자현황</span></a></li></ul></li></ul></li><!-- 설문조사 --><!-- 설문조사 숨김처리\r\n         <li ui-sref-active=\"active\" ng-class=\"{\'open\':$state.includes(\'app.survey\')}\"><a ui-sref=\"app.survey.beforesurvey-list\"><fa name=\"pencil\"></fa><span>설문조사</span><i class=\"fa fa-plus\"></i></a>\r\n          <ul style=\"display: hidden;\">            \r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.beforesurvey-list\" ui-sref-opts=\"{reload:\'app.survey.beforesurvey-list\'}\"><span> 사후설문조사 >  -- >진로지도설문목록</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.beforesurvey-edit\" ui-sref-opts=\"{reload:\'app.survey.beforesurvey-edit\'}\"><span> 사후설문조사 >  -- >진로지도설문등록</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.aftersurvey-list\" ui-sref-opts=\"{reload:\'app.survey.aftersurvey-list\'}\"><span>사후설문조사 >  -- >취업역량강화설문목록</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.aftersurvey-edit\" ui-sref-opts=\"{reload:\'app.survey.aftersurvey-edit\'}\"><span>사후설문조사 >  -- >취업역량강화설문등록</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.aftersurvey2-list\" ui-sref-opts=\"{reload:\'app.survey.aftersurvey2-list\'}\"><span> 사후설문조사 >  -- >사후설문목록</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.survey.aftersurvey2-edit\" ui-sref-opts=\"{reload:\'app.survey.aftersurvey2-edit\'}\"><span> 사후설문조사 >  -- >사후설문등록</span></a></li>\r\n           </ul>\r\n         </li>\r\n          --><!-- 게시판 --><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.bbspost\')}\" class=dropdown><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'60Y9C18S4M\'})\"><fa name=table></fa><span>게시판</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: hidden\"><li ui-sref-active=active><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'60Y9C18S4M\'})\" ui-sref-opts=\"{reload:\'app.bbspost.h0101-list\'}\"><span>공지사항</span></a></li><li ui-sref-active=active><a ui-sref=\"app.bbspost.h0101-list({BoardId:\'7GLIAQRSY0\'})\" ui-sref-opts=\"{reload:\'app.bbspost.h0101-list\'}\"><span>자료실</span></a></li><li ui-sref-active=active><a ui-sref=app.bbspost.recom-list ui-sref-opts=\"{reload:\'app.bbspost.recom-list\'}\"><span>전직교육원 제공 채용정보</span></a></li></ul></li><!-- 통계/분석 --><li ui-sref-active=active ng-class=\"{\'open\':$state.includes(\'app.state\')}\" class=dropdown><a ui-sref=app.state.totalprog><fa name=bar-chart></fa><span>통계/분석</span><i class=\"fa fa-plus\"></i></a><ul style=\"display: hidden\"><li ui-sref-active=active><a ui-sref=app.state.totalprog ui-sref-opts=\"{reload:\'app.state.totalprog\'}\"><span>총괄진행현황/진도율</span></a></li><li ui-sref-active=active><a ui-sref=app.state.areacounsel ui-sref-opts=\"{reload:\'app.state.areacounsel\'}\"><span>지역별/부대별 등록현황</span></a></li><li ui-sref-active=active><a ui-sref=app.state.unitclass ui-sref-opts=\"{reload:\'app.state.unitclass\'}\"><span>부대별/컨설턴트별 상담현황</span></a></li><li ui-sref-active=active><a ui-sref=app.state.methodcounsel ui-sref-opts=\"{reload:\'app.state.methodcounsel\'}\"><span>상담방법별 상담현황</span></a></li><li ui-sref-active=active><a ui-sref=app.state.careeremploy ui-sref-opts=\"{reload:\'app.state.careeremploy\'}\"><span>진로/취업목표별 진행현황</span></a></li><li ui-sref-active=active><a ui-sref=app.state.employstartup ui-sref-opts=\"{reload:\'app.state.employstartup\'}\"><span>중소기업 희망 현황</span></a></li><!-- <li ui-sref-active=\"active\"><a ui-sref=\"app.state.survey\" ui-sref-opts=\"{reload:\'app.state.survey\'}\"><span>설문서종합결과</span></a></li>\r\n            <li ui-sref-active=\"active\"><a ui-sref=\"app.state.survey2\" ui-sref-opts=\"{reload:\'app.state.survey2\'}\"><span>교육후 설문서조사결과</span></a></li> --><li ui-sref-active=active><a ui-sref=app.state.employstate ui-sref-opts=\"{reload:\'app.state.employstate\'}\"><span>취업자 현황</span></a></li></ul></li><!-- 시스템관리 --><li ui-sref-active=active ng-class=\"{\'active\':$state.includes(\'app.system\')}\" class=dropdown><a ui-sref=app.system.user-list><fa name=cogs></fa><span>시스템관리</span><i class=\"fa fa-plus\"></i></a><ul><li ui-sref-active=active class=\"dropdown open\"><a href=javascript:;><fa name=caret-down></fa><span>사업관리</span></a><ul style=\"display: block\"><li ui-sref-active=active><a ui-sref=app.system.business-list ui-sref-opts=\"{reload:\'app.system.business-list\'}\"><span>사업목록</span></a></li><li ui-sref-active=active><a ui-sref=app.system.business-edit ui-sref-opts=\"{reload:\'app.system.business-edit\'}\"><span>사업등록</span></a></li></ul></li><li ui-sref-active=active class=\"dropdown open\"><a href=javascript:;><fa name=caret-down></fa><span>시용자관리</span></a><ul><li ui-sref-active=active><a ui-sref=app.system.user-list ui-sref-opts=\"{reload:\'app.system.user-list\'}\"><span>사용자목록</span></a></li><li ui-sref-active=active><a ui-sref=app.system.user-edit ui-sref-opts=\"{reload:\'app.system.user-edit\'}\"><span>사용자등록</span></a></li></ul></li><li class=\"dropdown open\"><a href=javascript:;><fa name=caret-down></fa><span>개인정보 운영설정</span></a><ul><li ui-sref-active=active><a ui-sref=app.system.personalInfo-list ui-sref-opts=\"{reload:\'app.system.personalInfo-list\'}\"><span>개인정보 다운로드 이력</span></a></li><li ui-sref-active=active><a ui-sref=app.system.personalInfo-edit ui-sref-opts=\"{reload:\'app.system.personalInfo-edit\'}\"><span>시스템 설정</span></a></li><li ui-sref-active=active><a ui-sref=app.system.personalSms-list ui-sref-opts=\"{reload:\'app.system.personalSms-list\'}\"><span>인증번호 발송현황(알림톡)</span></a></li><li ui-sref-active=active><a ui-sref=app.system.accountLock-list ui-sref-opts=\"{reload:\'app.system.accountLock-list\'}\"><span>계정잠김 현황</span></a></li><li ui-sref-active=active><a ui-sref=app.system.permissionInfo-list ui-sref-opts=\"{reload:\'app.system.permissionInfo-list\'}\"><span>계정신청 현황</span></a></li></ul></li><li ui-sref-active=active><a ui-sref=app.system.visitLog-list ui-sref-opts=\"{reload:\'app.system.visitLog-list\'}\"><span>방문자현황</span></a></li><li ui-sref-active=active><a ui-sref=app.system.visitMenu-list ui-sref-opts=\"{reload:\'app.system.visitMenu-list\'}\"><span>메뉴별 사용(빈도) 현황</span></a></li></ul></li></ul></div><!-- <div class=\"customercenter\">\r\n        <label>고객센터</label>\r\n        <p>(주)소프트자이온</p>\r\n        <p>Tel: 070-5001-0869</p>\r\n      </div> --></div></div><script>/* function setNaviStyle() {\r\n      setTimeout(function() {\r\n        $(\".naviTop2 > li > a\").click(function() {\r\n          $(this).next().css(\"max-height\", (($(this).next().find(\"li\").length * 33) + 10));\r\n          $(this).next().find(\"li\").css(\"display\", \"inline-block\");\r\n          $(this).next().find(\"li\").css(\"height\", \"33px\");\r\n          $(this).next().find(\"li\").css(\"width\", \"99%\");\r\n          $(this).css(\"height\", \"auto\");\r\n        });\r\n      }, 1000);\r\n    }\r\n    \r\n    setNaviStyle(); */</script></aside></div>");
$templateCache.put("components/ui-component/layout/header/header-notification/header-notification.html","<style>.badge.badge-danger {background-color: red;}\r\n  .alarmH3\r\n    {\r\n      display:block;\r\n      color:#333;\r\n      background:#FFF;\r\n      font-weight:bold;\r\n      font-size:13px;\r\n      padding:8px;\r\n      margin:0;\r\n      border-bottom:solid 1px rgba(100, 100, 100, .30);\r\n    }\r\n  .alarmAHref\r\n    {\r\n      display:block;\r\n      width:430px;\r\n      height:auto;\r\n      border-bottom:solid 1px rgba(100, 100, 100, .30);\r\n      overflow:hidden;        /* wdith:430px를 넘으면 보이지 않게 처리함 */\r\n      text-overflow:ellipsis; /* 글자가 width:430px를 넘으면 생략부호를 표시함 */\r\n      white-space:nowrap;     /* 공백문자가 있으면 줄바꿈하지 않고 한줄로 나오게 처리함 (\\A로 줄바꿈가능) */\r\n    }\r\n  .seeAll\r\n    {\r\n      background:#F6F7F8;\r\n      padding:8px;\r\n      font-size:12px;\r\n      font-weight:bold;\r\n      border-top:solid 1px rgba(100, 100, 100, .30);\r\n      text-align:center;\r\n    }\r\n  .seeAll a\r\n    {\r\n      color:#3b5998;\r\n    }\r\n  ::-webkit-scrollbar { width: 5px; }\r\n  ::-webkit-scrollbar-thumb { background: #a9a9a9; }</style><ul class=\"nav navbar-top-links navbar-right pull-right\"><!-- <li class=\"dropdown\">\r\n    <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\r\n      <i class=\"fa fa-bell\"><span class=\"badge badge-danger\">{{vc.sumUnReadCnt > 0 ? vc.sumUnReadCnt : \'\'}}</span></i>\r\n    </a>\r\n    <ul class=\"dropdown-menu dropdown-alarm\" style=\"width: 440px; max-height: 440px; overflow-x: hidden; overflow-y: auto;\" ng-if=\"vc.sumUnReadCnt > 0\">\r\n      <h3 class=\"alarmH3\">알림 <span class=\"badge badge-danger\">{{vc.sumUnReadCnt > 0 ? vc.sumUnReadCnt : \'\'}}</span></h3>\r\n      <li ng-repeat=\"li in vc.unReadContentList\">\r\n        <a href=\"\" class=\"alarmAHref\" ng-click=\"vc.goDetail(li.FreeChatId)\"><b>{{li.UserNm}}</b><small class=\"pull-right\">{{li.RegDate|utcToLocal:\'MM-dd HH:mm\'}}</small><br>\r\n          {{li.LogicalFileNm == null ? li.Contents : li.LogicalFileNm}}\r\n        </a>\r\n      </li>\r\n      <div class=\"seeAll\" ng-if=\"vc.sumUnReadCnt > 0\"><a href=\"\">모두 보기</a></div>\r\n    </ul>\r\n    <ul class=\"dropdown-menu dropdown-alarm\" style=\"width: 440px; max-height: 440px; overflow-x: hidden; overflow-y: auto;\" ng-if=\"vc.sumUnReadCnt == 0\">\r\n      <h3 class=\"alarmH3\">알림 <span class=\"badge badge-danger\">{{vc.sumUnReadCnt > 0 ? vc.sumUnReadCnt : \'\'}}</span></h3>\r\n      <li>\r\n        <a href=\"\" class=\"alarmAHref\">새로운 알림이 없습니다.\r\n        </a>\r\n      </li>\r\n    </ul>\r\n  </li> --><li class=dropdown><a class=\"droptown-toggle popModalText\" data-toggle=dropdown ng-click=vc.getPayTenant();><i class=\"glyphicon glyphicon-credit-card\"></i></a><div class=\"dropdown-menu dropdown-pay\"><p><i class=\"glyphicon glyphicon-credit-card\"></i> <span>잔액:</span>&nbsp;<span ng-bind=vc.ServPoint></span> 원<br><i class=\"glyphicon glyphicon-calendar\"></i> <span>만료일:</span>&nbsp;<span ng-bind=vc.PayMonEnd></span></p><button class=\"btn btn-primary btn-big\" ng-if=vc.PayBtnShow ng-click=vc.payModal()>이용료 및 SMS 결제</button></div></li><li><a href=\"\" ng-click=vc.goDownLoadAndroid() title=앱다운로드><i class=\"fa fa-android\"></i></a></li><li><a ui-sref=\"app.message.sms-send-edit({keyId:\'\'})\" ui-sref-opts=\"{reload:\'app.message.sms-send-edit\'}\" href=#/app/message/sms-send-edit/ title=메세지발송 permission=\"\'app.message.sms-send-edit\'\"><i class=\"fa fa-comments\"></i></a></li><li><a href=\"\" ng-click=vc.goRemoteSupport() title=원격지원><i class=\"fa fa-laptop\"></i></a></li><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown><i class=\"fa fa-user fa-fw\"></i> {{vc.user.UserName}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-user\"><li ng-if=vc.checkDemoUser><a href=\"\" ng-click=vc.myPage()><i class=\"fa fa-user fa-fw\"></i> 내 정보</a></li><li ng-if=vc.checkDemoUser class=divider></li><li><a href=\"\" ng-click=vc.doLogout()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul><!-- /.dropdown-user --></li><!-- /.dropdown --></ul>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html","<li class=sidebar-search><div class=\"input-group custom-search-form\"><input type=text class=form-control placeholder=Search...> <span class=input-group-btn><button class=\"btn btn-default\" type=button><i class=\"fa fa-search\"></i></button></span></div></li>");}]);